import * as ht from "react";
import _t, { useContext as Zn, isValidElement as Hce, forwardRef as Gu, useRef as er, useImperativeHandle as lv, useEffect as Pn, useLayoutEffect as Bce, useState as tn, createContext as zce, memo as Pd, useMemo as Wy, useCallback as Uy, useDebugValue as Fce, createElement as rg, PureComponent as tz } from "react";
import jl, { unstable_batchedUpdates as nz } from "react-dom";
var rn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gl(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function KN(t) {
  if (t.__esModule) return t;
  var r = t.default;
  if (typeof r == "function") {
    var a = function u() {
      return this instanceof u ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    a.prototype = r.prototype;
  } else a = {};
  return Object.defineProperty(a, "__esModule", { value: !0 }), Object.keys(t).forEach(function(u) {
    var h = Object.getOwnPropertyDescriptor(t, u);
    Object.defineProperty(a, u, h.get ? h : {
      enumerable: !0,
      get: function() {
        return t[u];
      }
    });
  }), a;
}
var S2 = { exports: {} }, yy = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U9;
function Gce() {
  if (U9) return yy;
  U9 = 1;
  var t = _t, r = Symbol.for("react.element"), a = Symbol.for("react.fragment"), u = Object.prototype.hasOwnProperty, h = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, b = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(v, s, c) {
    var d, p = {}, m = null, E = null;
    c !== void 0 && (m = "" + c), s.key !== void 0 && (m = "" + s.key), s.ref !== void 0 && (E = s.ref);
    for (d in s) u.call(s, d) && !b.hasOwnProperty(d) && (p[d] = s[d]);
    if (v && v.defaultProps) for (d in s = v.defaultProps, s) p[d] === void 0 && (p[d] = s[d]);
    return { $$typeof: r, type: v, key: m, ref: E, props: p, _owner: h.current };
  }
  return yy.Fragment = a, yy.jsx = l, yy.jsxs = l, yy;
}
var vy = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H9;
function Vce() {
  return H9 || (H9 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = _t, r = Symbol.for("react.element"), a = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), v = Symbol.for("react.context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), y = Symbol.iterator, g = "@@iterator";
    function C(ie) {
      if (ie === null || typeof ie != "object")
        return null;
      var ye = y && ie[y] || ie[g];
      return typeof ye == "function" ? ye : null;
    }
    var O = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function N(ie) {
      {
        for (var ye = arguments.length, Ye = new Array(ye > 1 ? ye - 1 : 0), ne = 1; ne < ye; ne++)
          Ye[ne - 1] = arguments[ne];
        w("error", ie, Ye);
      }
    }
    function w(ie, ye, Ye) {
      {
        var ne = O.ReactDebugCurrentFrame, Qe = ne.getStackAddendum();
        Qe !== "" && (ye += "%s", Ye = Ye.concat([Qe]));
        var W = Ye.map(function(ce) {
          return String(ce);
        });
        W.unshift("Warning: " + ye), Function.prototype.apply.call(console[ie], console, W);
      }
    }
    var _ = !1, I = !1, k = !1, H = !1, S = !1, B;
    B = Symbol.for("react.module.reference");
    function D(ie) {
      return !!(typeof ie == "string" || typeof ie == "function" || ie === u || ie === b || S || ie === h || ie === c || ie === d || H || ie === E || _ || I || k || typeof ie == "object" && ie !== null && (ie.$$typeof === m || ie.$$typeof === p || ie.$$typeof === l || ie.$$typeof === v || ie.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ie.$$typeof === B || ie.getModuleId !== void 0));
    }
    function F(ie, ye, Ye) {
      var ne = ie.displayName;
      if (ne)
        return ne;
      var Qe = ye.displayName || ye.name || "";
      return Qe !== "" ? Ye + "(" + Qe + ")" : Ye;
    }
    function j(ie) {
      return ie.displayName || "Context";
    }
    function G(ie) {
      if (ie == null)
        return null;
      if (typeof ie.tag == "number" && N("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ie == "function")
        return ie.displayName || ie.name || null;
      if (typeof ie == "string")
        return ie;
      switch (ie) {
        case u:
          return "Fragment";
        case a:
          return "Portal";
        case b:
          return "Profiler";
        case h:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof ie == "object")
        switch (ie.$$typeof) {
          case v:
            var ye = ie;
            return j(ye) + ".Consumer";
          case l:
            var Ye = ie;
            return j(Ye._context) + ".Provider";
          case s:
            return F(ie, ie.render, "ForwardRef");
          case p:
            var ne = ie.displayName || null;
            return ne !== null ? ne : G(ie.type) || "Memo";
          case m: {
            var Qe = ie, W = Qe._payload, ce = Qe._init;
            try {
              return G(ce(W));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, M = 0, V, J, ue, se, ee, de, he;
    function pe() {
    }
    pe.__reactDisabledLog = !0;
    function Ce() {
      {
        if (M === 0) {
          V = console.log, J = console.info, ue = console.warn, se = console.error, ee = console.group, de = console.groupCollapsed, he = console.groupEnd;
          var ie = {
            configurable: !0,
            enumerable: !0,
            value: pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ie,
            log: ie,
            warn: ie,
            error: ie,
            group: ie,
            groupCollapsed: ie,
            groupEnd: ie
          });
        }
        M++;
      }
    }
    function _e() {
      {
        if (M--, M === 0) {
          var ie = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, ie, {
              value: V
            }),
            info: U({}, ie, {
              value: J
            }),
            warn: U({}, ie, {
              value: ue
            }),
            error: U({}, ie, {
              value: se
            }),
            group: U({}, ie, {
              value: ee
            }),
            groupCollapsed: U({}, ie, {
              value: de
            }),
            groupEnd: U({}, ie, {
              value: he
            })
          });
        }
        M < 0 && N("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = O.ReactCurrentDispatcher, Te;
    function K(ie, ye, Ye) {
      {
        if (Te === void 0)
          try {
            throw Error();
          } catch (Qe) {
            var ne = Qe.stack.trim().match(/\n( *(at )?)/);
            Te = ne && ne[1] || "";
          }
        return `
` + Te + ie;
      }
    }
    var Oe = !1, Pe;
    {
      var xe = typeof WeakMap == "function" ? WeakMap : Map;
      Pe = new xe();
    }
    function be(ie, ye) {
      if (!ie || Oe)
        return "";
      {
        var Ye = Pe.get(ie);
        if (Ye !== void 0)
          return Ye;
      }
      var ne;
      Oe = !0;
      var Qe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var W;
      W = Le.current, Le.current = null, Ce();
      try {
        if (ye) {
          var ce = function() {
            throw Error();
          };
          if (Object.defineProperty(ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ce, []);
            } catch (ot) {
              ne = ot;
            }
            Reflect.construct(ie, [], ce);
          } else {
            try {
              ce.call();
            } catch (ot) {
              ne = ot;
            }
            ie.call(ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ot) {
            ne = ot;
          }
          ie();
        }
      } catch (ot) {
        if (ot && ne && typeof ot.stack == "string") {
          for (var fe = ot.stack.split(`
`), we = ne.stack.split(`
`), Fe = fe.length - 1, je = we.length - 1; Fe >= 1 && je >= 0 && fe[Fe] !== we[je]; )
            je--;
          for (; Fe >= 1 && je >= 0; Fe--, je--)
            if (fe[Fe] !== we[je]) {
              if (Fe !== 1 || je !== 1)
                do
                  if (Fe--, je--, je < 0 || fe[Fe] !== we[je]) {
                    var qe = `
` + fe[Fe].replace(" at new ", " at ");
                    return ie.displayName && qe.includes("<anonymous>") && (qe = qe.replace("<anonymous>", ie.displayName)), typeof ie == "function" && Pe.set(ie, qe), qe;
                  }
                while (Fe >= 1 && je >= 0);
              break;
            }
        }
      } finally {
        Oe = !1, Le.current = W, _e(), Error.prepareStackTrace = Qe;
      }
      var et = ie ? ie.displayName || ie.name : "", bt = et ? K(et) : "";
      return typeof ie == "function" && Pe.set(ie, bt), bt;
    }
    function $e(ie, ye, Ye) {
      return be(ie, !1);
    }
    function Be(ie) {
      var ye = ie.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function Ke(ie, ye, Ye) {
      if (ie == null)
        return "";
      if (typeof ie == "function")
        return be(ie, Be(ie));
      if (typeof ie == "string")
        return K(ie);
      switch (ie) {
        case c:
          return K("Suspense");
        case d:
          return K("SuspenseList");
      }
      if (typeof ie == "object")
        switch (ie.$$typeof) {
          case s:
            return $e(ie.render);
          case p:
            return Ke(ie.type, ye, Ye);
          case m: {
            var ne = ie, Qe = ne._payload, W = ne._init;
            try {
              return Ke(W(Qe), ye, Ye);
            } catch {
            }
          }
        }
      return "";
    }
    var Ze = Object.prototype.hasOwnProperty, at = {}, pt = O.ReactDebugCurrentFrame;
    function It(ie) {
      if (ie) {
        var ye = ie._owner, Ye = Ke(ie.type, ie._source, ye ? ye.type : null);
        pt.setExtraStackFrame(Ye);
      } else
        pt.setExtraStackFrame(null);
    }
    function Rt(ie, ye, Ye, ne, Qe) {
      {
        var W = Function.call.bind(Ze);
        for (var ce in ie)
          if (W(ie, ce)) {
            var fe = void 0;
            try {
              if (typeof ie[ce] != "function") {
                var we = Error((ne || "React class") + ": " + Ye + " type `" + ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ie[ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw we.name = "Invariant Violation", we;
              }
              fe = ie[ce](ye, ce, ne, Ye, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Fe) {
              fe = Fe;
            }
            fe && !(fe instanceof Error) && (It(Qe), N("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ne || "React class", Ye, ce, typeof fe), It(null)), fe instanceof Error && !(fe.message in at) && (at[fe.message] = !0, It(Qe), N("Failed %s type: %s", Ye, fe.message), It(null));
          }
      }
    }
    var gt = Array.isArray;
    function it(ie) {
      return gt(ie);
    }
    function Tt(ie) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, Ye = ye && ie[Symbol.toStringTag] || ie.constructor.name || "Object";
        return Ye;
      }
    }
    function Ut(ie) {
      try {
        return st(ie), !1;
      } catch {
        return !0;
      }
    }
    function st(ie) {
      return "" + ie;
    }
    function Ot(ie) {
      if (Ut(ie))
        return N("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Tt(ie)), st(ie);
    }
    var kt = O.ReactCurrentOwner, wt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Et, ut;
    function St(ie) {
      if (Ze.call(ie, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(ie, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return ie.ref !== void 0;
    }
    function Ft(ie) {
      if (Ze.call(ie, "key")) {
        var ye = Object.getOwnPropertyDescriptor(ie, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return ie.key !== void 0;
    }
    function Ht(ie, ye) {
      typeof ie.ref == "string" && kt.current;
    }
    function zt(ie, ye) {
      {
        var Ye = function() {
          Et || (Et = !0, N("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Ye.isReactWarning = !0, Object.defineProperty(ie, "key", {
          get: Ye,
          configurable: !0
        });
      }
    }
    function ze(ie, ye) {
      {
        var Ye = function() {
          ut || (ut = !0, N("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Ye.isReactWarning = !0, Object.defineProperty(ie, "ref", {
          get: Ye,
          configurable: !0
        });
      }
    }
    var Ne = function(ie, ye, Ye, ne, Qe, W, ce) {
      var fe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: ie,
        key: ye,
        ref: Ye,
        props: ce,
        // Record the component responsible for creating this element.
        _owner: W
      };
      return fe._store = {}, Object.defineProperty(fe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(fe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ne
      }), Object.defineProperty(fe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qe
      }), Object.freeze && (Object.freeze(fe.props), Object.freeze(fe)), fe;
    };
    function le(ie, ye, Ye, ne, Qe) {
      {
        var W, ce = {}, fe = null, we = null;
        Ye !== void 0 && (Ot(Ye), fe = "" + Ye), Ft(ye) && (Ot(ye.key), fe = "" + ye.key), St(ye) && (we = ye.ref, Ht(ye, Qe));
        for (W in ye)
          Ze.call(ye, W) && !wt.hasOwnProperty(W) && (ce[W] = ye[W]);
        if (ie && ie.defaultProps) {
          var Fe = ie.defaultProps;
          for (W in Fe)
            ce[W] === void 0 && (ce[W] = Fe[W]);
        }
        if (fe || we) {
          var je = typeof ie == "function" ? ie.displayName || ie.name || "Unknown" : ie;
          fe && zt(ce, je), we && ze(ce, je);
        }
        return Ne(ie, fe, we, Qe, ne, kt.current, ce);
      }
    }
    var X = O.ReactCurrentOwner, re = O.ReactDebugCurrentFrame;
    function Me(ie) {
      if (ie) {
        var ye = ie._owner, Ye = Ke(ie.type, ie._source, ye ? ye.type : null);
        re.setExtraStackFrame(Ye);
      } else
        re.setExtraStackFrame(null);
    }
    var Se;
    Se = !1;
    function ke(ie) {
      return typeof ie == "object" && ie !== null && ie.$$typeof === r;
    }
    function Ge() {
      {
        if (X.current) {
          var ie = G(X.current.type);
          if (ie)
            return `

Check the render method of \`` + ie + "`.";
        }
        return "";
      }
    }
    function nt(ie) {
      return "";
    }
    var rt = {};
    function dt(ie) {
      {
        var ye = Ge();
        if (!ye) {
          var Ye = typeof ie == "string" ? ie : ie.displayName || ie.name;
          Ye && (ye = `

Check the top-level render call using <` + Ye + ">.");
        }
        return ye;
      }
    }
    function lt(ie, ye) {
      {
        if (!ie._store || ie._store.validated || ie.key != null)
          return;
        ie._store.validated = !0;
        var Ye = dt(ye);
        if (rt[Ye])
          return;
        rt[Ye] = !0;
        var ne = "";
        ie && ie._owner && ie._owner !== X.current && (ne = " It was passed a child from " + G(ie._owner.type) + "."), Me(ie), N('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ye, ne), Me(null);
      }
    }
    function Ct(ie, ye) {
      {
        if (typeof ie != "object")
          return;
        if (it(ie))
          for (var Ye = 0; Ye < ie.length; Ye++) {
            var ne = ie[Ye];
            ke(ne) && lt(ne, ye);
          }
        else if (ke(ie))
          ie._store && (ie._store.validated = !0);
        else if (ie) {
          var Qe = C(ie);
          if (typeof Qe == "function" && Qe !== ie.entries)
            for (var W = Qe.call(ie), ce; !(ce = W.next()).done; )
              ke(ce.value) && lt(ce.value, ye);
        }
      }
    }
    function Ie(ie) {
      {
        var ye = ie.type;
        if (ye == null || typeof ye == "string")
          return;
        var Ye;
        if (typeof ye == "function")
          Ye = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === s || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === p))
          Ye = ye.propTypes;
        else
          return;
        if (Ye) {
          var ne = G(ye);
          Rt(Ye, ie.props, "prop", ne, ie);
        } else if (ye.PropTypes !== void 0 && !Se) {
          Se = !0;
          var Qe = G(ye);
          N("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Qe || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && N("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function x(ie) {
      {
        for (var ye = Object.keys(ie.props), Ye = 0; Ye < ye.length; Ye++) {
          var ne = ye[Ye];
          if (ne !== "children" && ne !== "key") {
            Me(ie), N("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ne), Me(null);
            break;
          }
        }
        ie.ref !== null && (Me(ie), N("Invalid attribute `ref` supplied to `React.Fragment`."), Me(null));
      }
    }
    var ae = {};
    function Q(ie, ye, Ye, ne, Qe, W) {
      {
        var ce = D(ie);
        if (!ce) {
          var fe = "";
          (ie === void 0 || typeof ie == "object" && ie !== null && Object.keys(ie).length === 0) && (fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var we = nt();
          we ? fe += we : fe += Ge();
          var Fe;
          ie === null ? Fe = "null" : it(ie) ? Fe = "array" : ie !== void 0 && ie.$$typeof === r ? (Fe = "<" + (G(ie.type) || "Unknown") + " />", fe = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof ie, N("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, fe);
        }
        var je = le(ie, ye, Ye, Qe, W);
        if (je == null)
          return je;
        if (ce) {
          var qe = ye.children;
          if (qe !== void 0)
            if (ne)
              if (it(qe)) {
                for (var et = 0; et < qe.length; et++)
                  Ct(qe[et], ie);
                Object.freeze && Object.freeze(qe);
              } else
                N("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ct(qe, ie);
        }
        if (Ze.call(ye, "key")) {
          var bt = G(ie), ot = Object.keys(ye).filter(function($t) {
            return $t !== "key";
          }), Lt = ot.length > 0 ? "{key: someKey, " + ot.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ae[bt + Lt]) {
            var Kt = ot.length > 0 ? "{" + ot.join(": ..., ") + ": ...}" : "{}";
            N(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Lt, bt, Kt, bt), ae[bt + Lt] = !0;
          }
        }
        return ie === u ? x(je) : Ie(je), je;
      }
    }
    function Z(ie, ye, Ye) {
      return Q(ie, ye, Ye, !0);
    }
    function ge(ie, ye, Ye) {
      return Q(ie, ye, Ye, !1);
    }
    var me = ge, ve = Z;
    vy.Fragment = u, vy.jsx = me, vy.jsxs = ve;
  }()), vy;
}
process.env.NODE_ENV === "production" ? S2.exports = Gce() : S2.exports = Vce();
var q = S2.exports, rz = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var r = {}.hasOwnProperty;
    function a() {
      for (var b = "", l = 0; l < arguments.length; l++) {
        var v = arguments[l];
        v && (b = h(b, u(v)));
      }
      return b;
    }
    function u(b) {
      if (typeof b == "string" || typeof b == "number")
        return b;
      if (typeof b != "object")
        return "";
      if (Array.isArray(b))
        return a.apply(null, b);
      if (b.toString !== Object.prototype.toString && !b.toString.toString().includes("[native code]"))
        return b.toString();
      var l = "";
      for (var v in b)
        r.call(b, v) && b[v] && (l = h(l, v));
      return l;
    }
    function h(b, l) {
      return l ? b ? b + " " + l : b + l : b;
    }
    t.exports ? (a.default = a, t.exports = a) : window.classNames = a;
  })();
})(rz);
var Yce = rz.exports;
const En = /* @__PURE__ */ Gl(Yce), Xce = (t, r) => r || (t ? `cui-${t}` : "cui"), Hn = _t.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: Xce
});
Hn.Consumer;
Hn.Provider;
const Wce = "data:image/png;base64,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", { isValidElement: JN } = ht;
function qce(t) {
  return t && JN(t) && t.type === ht.Fragment;
}
function Kce(t, r, a) {
  return JN(t) ? ht.cloneElement(
    t,
    typeof a == "function" ? a(t.props || {}) : a
  ) : r;
}
function Vl(t, r) {
  return Kce(t, t, r);
}
const Vn = _t.createContext({
  rootStore: {},
  initConfig: {},
  client: {},
  reactionConfig: { map: {} },
  theme: {},
  presenceMap: {}
}), L3e = Vn.Consumer, Jce = Vn.Provider, Zce = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M11.9999 3.16309L15.174 7.79439L20.5594 9.38193L17.1356 13.8318L17.29 19.4442L11.9999 17.5631L6.70987 19.4442L6.86423 13.8318L3.44043 9.38193L8.8259 7.79439L11.9999 3.16309Z" })), Qce = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.48231 11.3914C3.78202 11.1055 4.25676 11.1167 4.54267 11.4164L7.89528 14.9307L7.92492 14.9015C8.21995 14.6108 8.69481 14.6143 8.98555 14.9093C9.2763 15.2043 9.27282 15.6792 8.9778 15.9699L8.40522 16.5342C8.26204 16.6753 8.06821 16.753 7.86721 16.7499C7.66621 16.7468 7.47487 16.6631 7.33611 16.5177L3.45733 12.4517C3.17141 12.152 3.1826 11.6773 3.48231 11.3914ZM10.7724 13.0278C10.4747 12.7398 10.4668 12.265 10.7548 11.9673L15.0973 7.47854C15.3853 7.18084 15.8601 7.17297 16.1578 7.46097C16.4555 7.74897 16.4634 8.22378 16.1754 8.52149L11.8329 13.0103C11.5449 13.308 11.0701 13.3158 10.7724 13.0278Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.10282 11.4073C7.39373 11.1125 7.86859 11.1092 8.16346 11.4002L11.7622 14.9507L19.478 7.46183C19.7752 7.17334 20.25 7.18043 20.5385 7.47766C20.827 7.77489 20.8199 8.24971 20.5227 8.5382L12.2803 16.5382C11.9876 16.8223 11.5215 16.8204 11.2312 16.5339L7.10998 12.468C6.81512 12.177 6.81191 11.7022 7.10282 11.4073Z" })), $ce = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.59088 4.46967C5.29798 4.17678 4.82311 4.17678 4.53022 4.46967C4.23732 4.76256 4.23732 5.23744 4.53022 5.53033L10.9999 12L4.53022 18.4697C4.23732 18.7626 4.23732 19.2375 4.53022 19.5303C4.82311 19.8232 5.29798 19.8232 5.59088 19.5303L12.0606 13.0607L18.4696 19.4697C18.7624 19.7626 19.2373 19.7626 19.5302 19.4697C19.8231 19.1768 19.8231 18.7019 19.5302 18.409L13.1212 12L19.5302 5.59101C19.8231 5.29811 19.8231 4.82324 19.5302 4.53035C19.2373 4.23745 18.7625 4.23745 18.4696 4.53035L12.0606 10.9393L5.59088 4.46967Z" })), eue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 4C5.89543 4 5 4.89543 5 6V18C5 19.1046 5.89543 20 7 20H17C18.1046 20 19 19.1046 19 18V8.82843C19 8.29799 18.7893 7.78929 18.4142 7.41421L15.5858 4.58579C15.2107 4.21071 14.702 4 14.1716 4H7ZM8.75 7.5C8.33579 7.5 8 7.83579 8 8.25C8 8.66421 8.33579 9 8.75 9H13.25C13.6642 9 14 8.66421 14 8.25C14 7.83579 13.6642 7.5 13.25 7.5H8.75ZM8 11.25C8 10.8358 8.33579 10.5 8.75 10.5H15.25C15.6642 10.5 16 10.8358 16 11.25C16 11.6642 15.6642 12 15.25 12H8.75C8.33579 12 8 11.6642 8 11.25ZM8.75 13.5C8.33579 13.5 8 13.8358 8 14.25C8 14.6642 8.33579 15 8.75 15H15.25C15.6642 15 16 14.6642 16 14.25C16 13.8358 15.6642 13.5 15.25 13.5H8.75Z" })), tue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M12 5C11.5028 5 11.0452 5.1342 10.6271 5.40261C10.209 5.65882 9.87571 6.01264 9.62712 6.46405C9.38983 6.91547 9.27119 7.40959 9.27119 7.94641V9.72157C9.27119 10.2462 9.38983 10.7342 9.62712 11.1856C9.87571 11.637 10.209 11.997 10.6271 12.2654C11.0452 12.5338 11.5028 12.668 12 12.668C12.4972 12.668 12.9548 12.5338 13.3729 12.2654C13.791 11.997 14.1186 11.637 14.3559 11.1856C14.6045 10.7342 14.7288 10.2462 14.7288 9.72157V7.94641C14.7288 7.40959 14.6045 6.91547 14.3559 6.46405C14.1186 6.01264 13.791 5.65882 13.3729 5.40261C12.9548 5.1342 12.4972 5 12 5ZM12 19H7.42373C7.02825 19 6.68927 18.8475 6.40678 18.5425C6.13559 18.2375 6 17.8776 6 17.4627C6 17.0479 6.0678 16.7124 6.20339 16.4562C6.44068 16.0414 6.77966 15.6571 7.22034 15.3033C7.75141 14.8641 8.37853 14.5224 9.10169 14.2784C9.96045 13.9856 10.9266 13.8392 12 13.8392C13.0734 13.8392 14.0395 13.9856 14.8983 14.2784C15.6215 14.5224 16.2486 14.8641 16.7797 15.3033C17.2203 15.6571 17.5593 16.0414 17.7966 16.4562C17.9322 16.7124 18 17.0479 18 17.4627C18 17.8776 17.8588 18.2375 17.5763 18.5425C17.3051 18.8475 16.9718 19 16.5763 19H12Z" })), nue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M9.5 15.0184V8.98159C9.5 8.61236 9.8833 8.38088 10.1914 8.56407L15.2672 11.5825C15.5776 11.7671 15.5776 12.2329 15.2672 12.4175L10.1914 15.4359C9.8833 15.6191 9.5 15.3876 9.5 15.0184Z", fill: "#464E53" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z" })), rue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 5.5C13.5 6.32843 12.8284 7 12 7C11.1716 7 10.5 6.32843 10.5 5.5C10.5 4.67157 11.1716 4 12 4C12.8284 4 13.5 4.67157 13.5 5.5ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12ZM12 20.001C12.8284 20.001 13.5 19.3295 13.5 18.501C13.5 17.6726 12.8284 17.001 12 17.001C11.1716 17.001 10.5 17.6726 10.5 18.501C10.5 19.3295 11.1716 20.001 12 20.001Z" })), iue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 9.5C15.9919 9.5 9.5 15.9919 9.5 24C9.5 24.8284 8.82843 25.5 8 25.5C7.17157 25.5 6.5 24.8284 6.5 24C6.5 14.335 14.335 6.5 24 6.5C33.665 6.5 41.5 14.335 41.5 24C41.5 33.665 33.665 41.5 24 41.5C23.1716 41.5 22.5 40.8284 22.5 40C22.5 39.1716 23.1716 38.5 24 38.5C32.0081 38.5 38.5 32.0081 38.5 24C38.5 15.9919 32.0081 9.5 24 9.5Z", fill: "#ACB4B9" })), sue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.28571 2.00001C5.02335 2.00001 4 3.00737 4 4.25001V19.75C4 20.9926 5.02335 22 6.28571 22H17.7143C18.9767 22 20 20.9926 20 19.75V7.43199C20 6.83525 19.7592 6.26296 19.3305 5.841L16.098 2.65902C15.6694 2.23706 15.088 2.00001 14.4818 2.00001H6.28571ZM7.75 6.00001C7.33579 6.00001 7 6.33579 7 6.75001C7 7.16422 7.33579 7.50001 7.75 7.50001H12.25C12.6642 7.50001 13 7.16422 13 6.75001C13 6.33579 12.6642 6.00001 12.25 6.00001H7.75ZM7 11.25C7 10.8358 7.33579 10.5 7.75 10.5H16.25C16.6642 10.5 17 10.8358 17 11.25C17 11.6642 16.6642 12 16.25 12H7.75C7.33579 12 7 11.6642 7 11.25ZM7.75 15C7.33579 15 7 15.3358 7 15.75C7 16.1642 7.33579 16.5 7.75 16.5H16.25C16.6642 16.5 17 16.1642 17 15.75C17 15.3358 16.6642 15 16.25 15H7.75Z" })), aue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M6.0437 15.0053C7.72465 13.3455 7.72465 10.6546 6.0437 8.99487", stroke: "#464E53", strokeWidth: 1.5, strokeLinecap: "round" })), oue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M9.36279 17.5096C12.4446 14.4667 12.4446 9.53332 9.36279 6.49048", stroke: "#464E53", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ ht.createElement("path", { d: "M6.0437 15.0053C7.72465 13.3455 7.72465 10.6546 6.0437 8.99487", stroke: "#464E53", strokeWidth: 1.5, strokeLinecap: "round" })), cue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M12.3909 20.5C17.1453 15.8056 17.1453 8.19442 12.3909 3.5", stroke: "#464E53", strokeWidth: 1.5, strokeLinecap: "round", fillRule: "evenodd", fill: "none" }), /* @__PURE__ */ ht.createElement("path", { d: "M9.36279 17.5095C12.4446 14.4666 12.4446 9.5332 9.36279 6.49036", stroke: "#464E53", strokeWidth: 1.5, strokeLinecap: "round", fill: "none" }), /* @__PURE__ */ ht.createElement("path", { d: "M6.0437 15.0051C7.72465 13.3454 7.72465 10.6545 6.0437 8.99475", stroke: "#464E53", strokeWidth: 1.5, strokeLinecap: "round", fill: "none" })), uue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.1995 5.80628C13.9047 5.51525 13.4268 5.51525 13.1321 5.80628C12.8373 6.0973 12.8373 6.56915 13.1321 6.86018C15.9138 9.60672 15.9138 14.0597 13.1321 16.8063C12.8373 17.0973 12.8373 17.5691 13.1321 17.8602C13.4268 18.1512 13.9047 18.1512 14.1995 17.8602C17.5706 14.5316 17.5706 9.13487 14.1995 5.80628ZM10.3848 7.74118C10.6795 7.45016 11.1574 7.45016 11.4521 7.74118C13.741 10.0011 13.741 13.6652 11.4521 15.9251C11.1574 16.2161 10.6795 16.2161 10.3848 15.9251C10.09 15.6341 10.09 15.1622 10.3848 14.8712C12.0841 13.1933 12.0841 10.473 10.3848 8.79508C10.09 8.50406 10.09 8.03221 10.3848 7.74118ZM8.62915 9.36173C8.3344 9.0707 7.85652 9.0707 7.56177 9.36173C7.26702 9.65275 7.26702 10.1246 7.56177 10.4156C8.3547 11.1985 8.3547 12.4679 7.56177 13.2508C7.26702 13.5418 7.26702 14.0137 7.56177 14.3047C7.85652 14.5957 8.3344 14.5957 8.62915 14.3047C10.0116 12.9397 10.0116 10.7267 8.62915 9.36173Z" })), due = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M9.1875 15.3957V8.60429C9.1875 8.18891 9.61871 7.92849 9.96527 8.13458L15.6756 11.5303C16.0248 11.738 16.0248 12.262 15.6756 12.4697L9.96527 15.8654C9.61871 16.0715 9.1875 15.8111 9.1875 15.3957Z", fill: "#464E53" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z", fill: "#464E53" })), lue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.8456 8.87143C15.8456 8.44539 15.5002 8.10001 15.0742 8.10001C14.6481 8.10001 14.3027 8.44539 14.3027 8.87143V10.3951C14.3027 10.8212 14.6481 11.1665 15.0742 11.1665C15.5002 11.1665 15.8456 10.8212 15.8456 10.3951V8.87143ZM9.69813 8.87144C9.69813 8.44539 9.35275 8.10001 8.9267 8.10001C8.50065 8.10001 8.15527 8.44539 8.15527 8.87144V10.3951C8.15527 10.8212 8.50065 11.1665 8.9267 11.1665C9.35275 11.1665 9.69813 10.8212 9.69813 10.3951V8.87144ZM16.132 13.7847C16.5149 13.9427 16.6972 14.3812 16.5391 14.7641C15.8047 16.5436 14.0513 17.8009 12.0003 17.8009C9.95007 17.8009 8.19724 16.5444 7.46232 14.7659C7.30413 14.3831 7.48622 13.9445 7.86904 13.7864C8.25186 13.6282 8.69043 13.8103 8.84862 14.1931C9.35998 15.4305 10.5787 16.3009 12.0003 16.3009C13.4225 16.3009 14.6416 15.4299 15.1526 14.1918C15.3106 13.8089 15.7491 13.6266 16.132 13.7847Z" })), fue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.56383 3.44264C4.97805 2.85686 4.0283 2.85686 3.44251 3.44264C2.85673 4.02843 2.85673 4.97818 3.44251 5.56396L9.87856 12L3.44253 18.436C2.85674 19.0218 2.85674 19.9716 3.44253 20.5574C4.02832 21.1432 4.97807 21.1432 5.56385 20.5574L11.9999 14.1213L18.4359 20.5574C19.0217 21.1431 19.9714 21.1431 20.5572 20.5574C21.143 19.9716 21.143 19.0218 20.5572 18.436L14.1212 12L20.5573 5.56397C21.143 4.97818 21.143 4.02843 20.5573 3.44265C19.9715 2.85686 19.0217 2.85686 18.4359 3.44265L11.9999 9.87869L5.56383 3.44264Z" })), hue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.22266 19.7016C2.92564 19.9987 2.92564 20.4802 3.22266 20.7772C3.51968 21.0743 4.00124 21.0743 4.29826 20.7772L11.9998 13.0756L19.7015 20.7772C19.9985 21.0742 20.4801 21.0742 20.7771 20.7772C21.0741 20.4802 21.0741 19.9986 20.7771 19.7016L13.0754 12L20.777 4.29838C21.074 4.00136 21.074 3.5198 20.777 3.22278C20.48 2.92576 19.9984 2.92576 19.7014 3.22278L11.9998 10.9244L4.29825 3.22283C4.00123 2.92581 3.51967 2.92581 3.22265 3.22283C2.92563 3.51985 2.92563 4.00142 3.22265 4.29844L10.9242 12L3.22266 19.7016Z" })), pue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M21.3897 11.0127L5.59933 3.11925C4.76206 2.70071 3.8164 3.44838 4.03081 4.3594L5.49881 10.597C5.61616 11.0957 6.0612 11.4481 6.57356 11.4481H12.8758C13.1807 11.4481 13.4278 11.6952 13.4278 12C13.4278 12.3048 13.1807 12.5519 12.8758 12.5519H6.57356C6.0612 12.5519 5.61616 12.9043 5.49881 13.403L4.03081 19.6406C3.8164 20.5516 4.76205 21.2993 5.59933 20.8808L21.3897 12.9873C22.2034 12.5805 22.2034 11.4195 21.3897 11.0127Z" })), gue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4736 19.7841C11.1807 19.491 11.1807 19.0159 11.4736 18.7228L18.1893 12.0029L11.4755 5.28502C11.1826 4.99195 11.1826 4.51678 11.4755 4.22371C11.7684 3.93064 12.2433 3.93064 12.5362 4.22371L19.7803 11.4723C20.0732 11.7653 20.0732 12.2405 19.7803 12.5336L12.5342 19.7841C12.2413 20.0772 11.7665 20.0772 11.4736 19.7841Z" })), mue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.2803 4.46967C13.5732 4.76256 13.5732 5.23744 13.2803 5.53033L6.81066 12L13.2803 18.4697C13.5732 18.7626 13.5732 19.2374 13.2803 19.5303C12.9874 19.8232 12.5126 19.8232 12.2197 19.5303L5.21967 12.5303C4.92678 12.2374 4.92678 11.7626 5.21967 11.4697L12.2197 4.46967C12.5126 4.17678 12.9874 4.17678 13.2803 4.46967Z" })), Eue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.2803 16.2803C18.9874 16.5732 18.5126 16.5732 18.2197 16.2803L11.75 9.81066L5.28033 16.2803C4.98744 16.5732 4.51256 16.5732 4.21967 16.2803C3.92678 15.9874 3.92678 15.5126 4.21967 15.2197L11.2197 8.21967C11.5126 7.92678 11.9874 7.92678 12.2803 8.21967L19.2803 15.2197C19.5732 15.5126 19.5732 15.9874 19.2803 16.2803Z" })), yue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.03271 10.9504L10.4091 4.57415C11.2878 3.69547 12.7124 3.69547 13.5911 4.57415L19.9674 10.9504C20.4555 11.4386 20.4555 12.23 19.9674 12.7182C19.4792 13.2063 18.6878 13.2063 18.1996 12.7182L13.2501 7.76868L13.2501 18.8509C13.2501 19.5425 12.6803 20.0849 12.0001 20.0849C11.32 20.0849 10.7501 19.5425 10.7501 18.8509L10.7501 7.76866L5.80048 12.7182C5.31232 13.2063 4.52087 13.2063 4.03271 12.7182C3.54455 12.23 3.54456 11.4386 4.03271 10.9504Z" })), vue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.21967 8.71967C4.51256 8.42678 4.98744 8.42678 5.28033 8.71967L11.75 15.1893L18.2197 8.71967C18.5126 8.42678 18.9874 8.42678 19.2803 8.71967C19.5732 9.01256 19.5732 9.48744 19.2803 9.78033L12.2803 16.7803C11.9874 17.0732 11.5126 17.0732 11.2197 16.7803L4.21967 9.78033C3.92678 9.48744 3.92678 9.01256 4.21967 8.71967Z" })), Tue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.9673 13.0496L13.5909 19.4258C12.7122 20.3045 11.2876 20.3045 10.4089 19.4259L4.03262 13.0496C3.54446 12.5614 3.54447 11.77 4.03262 11.2818C4.52078 10.7937 5.31223 10.7937 5.80039 11.2818L10.7499 16.2313L10.7499 5.14914C10.7499 4.45751 11.3197 3.91513 11.9999 3.91513C12.68 3.91513 13.2499 4.45751 13.2499 5.14914L13.2499 16.2313L18.1995 11.2818C18.6877 10.7937 19.4791 10.7937 19.9673 11.2818C20.4554 11.77 20.4554 12.5614 19.9673 13.0496Z" })), bue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.54907 11.3995C4.54907 7.61613 7.61613 4.54907 11.3995 4.54907C15.1829 4.54907 18.25 7.61613 18.25 11.3995C18.25 15.1829 15.1829 18.25 11.3995 18.25C7.61613 18.25 4.54907 15.1829 4.54907 11.3995ZM11.3995 3.04907C6.7877 3.04907 3.04907 6.7877 3.04907 11.3995C3.04907 16.0114 6.7877 19.75 11.3995 19.75C13.4354 19.75 15.3011 19.0214 16.7502 17.8108L19.9697 21.0303C20.2626 21.3232 20.7374 21.3232 21.0303 21.0303C21.3232 20.7374 21.3232 20.2626 21.0303 19.9697L17.8108 16.7502C19.0214 15.3011 19.75 13.4354 19.75 11.3995C19.75 6.7877 16.0114 3.04907 11.3995 3.04907Z" })), Aue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.58333 2.5C8.66286 2.5 7.91667 3.24619 7.91667 4.16667H12.0833C12.0833 3.24619 11.3371 2.5 10.4167 2.5H9.58333ZM2.5 5.83333C2.5 5.3731 2.8731 5 3.33333 5H16.6667C17.1269 5 17.5 5.3731 17.5 5.83333C17.5 6.29357 17.1269 6.66667 16.6667 6.66667H15.387L15.0689 15.5714C15.0305 16.6475 14.1469 17.5 13.0702 17.5H6.92388C5.84949 17.5 4.96705 16.6511 4.92539 15.5776L4.57953 6.66667H3.33333C2.8731 6.66667 2.5 6.29357 2.5 5.83333ZM7.59546 14.8799L7.40576 8.83986C7.39492 8.49485 7.66575 8.20431 8.01067 8.19092C8.35559 8.17752 8.64398 8.44635 8.65482 8.79136L8.84452 14.8314C8.85536 15.1764 8.58453 15.4669 8.23961 15.4803C7.89469 15.4937 7.6063 15.2249 7.59546 14.8799ZM11.3454 8.79136L11.1557 14.8314C11.1449 15.1764 11.4157 15.4669 11.7606 15.4803C12.1055 15.4937 12.3939 15.2249 12.4048 14.8799L12.5945 8.83986C12.6053 8.49485 12.3345 8.20431 11.9895 8.19092C11.6446 8.17752 11.3562 8.44635 11.3454 8.79136Z" })), Oue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM7.46967 7.46967C7.76256 7.17678 8.23744 7.17678 8.53033 7.46967L12 10.9393L15.4697 7.46967C15.7626 7.17678 16.2374 7.17678 16.5303 7.46967C16.8232 7.76256 16.8232 8.23744 16.5303 8.53033L13.0607 12L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L12 13.0607L8.53033 16.5303C8.23744 16.8232 7.76256 16.8232 7.46967 16.5303C7.17678 16.2374 7.17678 15.7626 7.46967 15.4697L10.9393 12L7.46967 8.53033C7.17678 8.23744 7.17678 7.76256 7.46967 7.46967Z" })), Cue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 5.5H4C3.72386 5.5 3.5 5.72386 3.5 6V18C3.5 18.2761 3.72386 18.5 4 18.5H20C20.2761 18.5 20.5 18.2761 20.5 18V6C20.5 5.72386 20.2761 5.5 20 5.5ZM4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H4Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M13.2094 11.7165L6 19H21V16.3129L16.6303 11.7467C15.6889 10.763 14.1666 10.7495 13.2094 11.7165Z" }), /* @__PURE__ */ ht.createElement("circle", { cx: 7.75, cy: 9.75, r: 1.75 })), Sue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M10.4273 4.55741L3.32463 11.2482C2.89179 11.656 2.89179 12.3441 3.32463 12.7518L10.4273 19.4426C10.7568 19.753 11.2978 19.5194 11.2978 19.0667V15.0882C14.8772 14.9222 17.7904 16.2148 20.0175 18.8097C20.3571 19.2054 21.0534 18.9781 20.9967 18.4597C20.2691 11.797 15.5719 8.89651 11.2978 8.89651V4.9333C11.2978 4.48062 10.7568 4.24701 10.4273 4.55741Z" })), Iue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M13.5727 4.55834L20.6754 11.2483C21.1082 11.656 21.1082 12.344 20.6754 12.7517L13.5727 19.4417C13.2432 19.7521 12.7022 19.5185 12.7022 19.0659V15.0878C9.12279 14.9219 6.20956 16.2143 3.98251 18.8088C3.64287 19.2045 2.94664 18.9772 3.00325 18.4589C3.73088 11.7971 8.42807 8.8969 12.7022 8.8969V4.93418C12.7022 4.48156 13.2432 4.24798 13.5727 4.55834Z" })), Rue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C12.3112 3.5 12.6183 3.51669 12.9203 3.54918C13.3322 3.59348 13.702 3.29553 13.7462 2.88369C13.7905 2.47185 13.4926 2.10208 13.0808 2.05779C12.7255 2.01958 12.3649 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 11.6324 21.9801 11.2692 21.9414 10.9113C21.8967 10.4995 21.5267 10.2019 21.1149 10.2465C20.7031 10.2911 20.4055 10.6611 20.4501 11.0729C20.4831 11.3772 20.5 11.6865 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12ZM18.5 2C18.9134 2 19.2485 2.33513 19.2485 2.74854V4.75146H21.2515C21.6649 4.75146 22 5.0866 22 5.5C22 5.91341 21.6649 6.24854 21.2515 6.24854H19.2485V8.25146C19.2485 8.66487 18.9134 9 18.5 9C18.0866 9 17.7515 8.66487 17.7515 8.25146V6.24854H15.7485C15.3351 6.24854 15 5.91341 15 5.5C15 5.0866 15.3351 4.75146 15.7485 4.75146H17.7515V2.74854C17.7515 2.33513 18.0866 2 18.5 2ZM16.5391 14.7641C16.6972 14.3812 16.5149 13.9427 16.132 13.7847C15.7491 13.6266 15.3106 13.8089 15.1526 14.1918C14.6416 15.4299 13.4225 16.3009 12.0003 16.3009C10.5787 16.3009 9.35998 15.4305 8.84862 14.1931C8.69043 13.8103 8.25186 13.6282 7.86904 13.7864C7.48622 13.9445 7.30413 14.3831 7.46232 14.7659C8.19724 16.5444 9.95007 17.8009 12.0003 17.8009C14.0513 17.8009 15.8047 16.5436 16.5391 14.7641ZM15.8456 8.87143C15.8456 8.44539 15.5002 8.10001 15.0742 8.10001C14.6481 8.10001 14.3027 8.44539 14.3027 8.87143V10.3951C14.3027 10.8212 14.6481 11.1665 15.0742 11.1665C15.5002 11.1665 15.8456 10.8212 15.8456 10.3951V8.87143ZM9.69813 8.87144C9.69813 8.44539 9.35275 8.10001 8.9267 8.10001C8.50065 8.10001 8.15527 8.44539 8.15527 8.87144V10.3951C8.15527 10.8212 8.50065 11.1665 8.9267 11.1665C9.35275 11.1665 9.69813 10.8212 9.69813 10.3951V8.87144Z" })), Nue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7803 5.28033C14.0732 4.98744 14.0732 4.51256 13.7803 4.21967C13.4874 3.92678 13.0126 3.92678 12.7197 4.21967L8.71967 8.21967C8.42678 8.51256 8.42678 8.98744 8.71967 9.28033L12.7197 13.2803C13.0126 13.5732 13.4874 13.5732 13.7803 13.2803C14.0732 12.9874 14.0732 12.5126 13.7803 12.2197L11.0607 9.5H14.25C16.5972 9.5 18.5 11.4028 18.5 13.75C18.5 16.0972 16.5972 18 14.25 18H4.75C4.33579 18 4 18.3358 4 18.75C4 19.1642 4.33579 19.5 4.75 19.5H14.25C17.4256 19.5 20 16.9256 20 13.75C20 10.5744 17.4256 8 14.25 8H11.0607L13.7803 5.28033Z" })), wue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.17471 10.0045C3.10176 5.43748 7.13908 2 11.9798 2C16.4062 2 20.1606 4.87418 21.4797 8.85736C21.6447 9.35551 21.3547 9.86602 20.8786 10.0278C20.3323 10.2134 19.7702 9.88486 19.5913 9.36855C18.4993 6.2156 15.5035 3.95224 11.9798 3.95224C8.46338 3.95224 5.47284 6.20627 4.37521 9.34869L5.60804 8.77631C6.06623 8.56359 6.60979 8.76833 6.81378 9.23047C7.01427 9.68471 6.81021 10.2156 6.35709 10.4186L3.00579 11.9199C2.52855 12.1337 1.9615 11.7869 2.00206 11.2345C2.0449 10.651 2.12739 10.2376 2.17471 10.0045ZM21.8253 14.006C20.8982 18.573 16.8609 22.0105 12.0202 22.0105C7.59384 22.0105 3.83944 19.1363 2.52025 15.1531C2.35527 14.655 2.64533 14.1445 3.12142 13.9827C3.66769 13.7971 4.22985 14.1256 4.40868 14.6419C5.50072 17.7949 8.49645 20.0582 12.0202 20.0582C15.5366 20.0582 18.5272 17.8042 19.6248 14.6618L18.392 15.2342C17.9338 15.4469 17.3902 15.2422 17.1862 14.78C16.9857 14.3258 17.1898 13.7949 17.6429 13.5919L20.9942 12.0906C21.4715 11.8768 22.0385 12.2236 21.9979 12.776C21.9551 13.3595 21.8726 13.7729 21.8253 14.006ZM10.8573 6.52918C11.2799 5.50219 12.7202 5.5022 13.1428 6.52918L16.9201 15.7085C17.1405 16.244 16.8893 16.8585 16.3592 17.0811C15.829 17.3037 15.2206 17.05 15.0002 16.5145L14.1918 14.55H9.80817L8.99975 16.5145C8.77939 17.05 8.17098 17.3037 7.64083 17.0811C7.11067 16.8585 6.85953 16.244 7.07989 15.7085L10.8573 6.52918ZM12 9.22358L13.3277 12.45H10.6723L12 9.22358Z" })), _ue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "icons/slash_in_box" }, /* @__PURE__ */ ht.createElement("path", { id: "Rectangle 78 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M5.0625 4.125C4.54473 4.125 4.125 4.54473 4.125 5.0625V12.9375C4.125 13.4553 4.54473 13.875 5.0625 13.875H12.9375C13.4553 13.875 13.875 13.4553 13.875 12.9375V9C13.875 8.68934 14.1268 8.4375 14.4375 8.4375C14.7482 8.4375 15 8.68934 15 9V12.9375C15 14.0766 14.0766 15 12.9375 15H5.0625C3.92341 15 3 14.0766 3 12.9375V5.0625C3 3.92341 3.92341 3 5.0625 3H9C9.31066 3 9.5625 3.25184 9.5625 3.5625C9.5625 3.87316 9.31066 4.125 9 4.125H5.0625Z", strokeWidth: 0.8, strokeLinecap: "round" }), /* @__PURE__ */ ht.createElement("path", { id: "Line 45 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M14.4538 3.53975C14.6735 3.75942 14.6735 4.11558 14.4538 4.33525L7.53518 11.2539C7.31551 11.4736 6.95936 11.4736 6.73969 11.2539C6.52002 11.0342 6.52002 10.6781 6.73969 10.4584L13.6583 3.53975C13.878 3.32008 14.2341 3.32008 14.4538 3.53975Z", strokeLinecap: "round" }))), Pue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("rect", { x: 3, y: 5, width: 10, height: 2, rx: 1 }), /* @__PURE__ */ ht.createElement("rect", { x: 3, y: 11, width: 6, height: 2, rx: 1 }), /* @__PURE__ */ ht.createElement("rect", { x: 3, y: 17, width: 17, height: 2, rx: 1 }), /* @__PURE__ */ ht.createElement("path", { d: "M17.0485 5.09435L21.7836 9.55434C22.0721 9.82613 22.0721 10.2848 21.7836 10.5566L17.0485 15.0166C16.8288 15.2235 16.4681 15.0678 16.4681 14.766V12.114C14.0819 12.0034 12.4847 12.865 11 14.5947C10.7736 14.8585 10.3094 14.7069 10.3472 14.3614C10.8322 9.92017 13.6187 7.98672 16.4681 7.98672V5.34492C16.4681 5.04317 16.8288 4.88744 17.0485 5.09435Z" })), xue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 3.78571C6.56795 3.78571 3.78571 6.56795 3.78571 10C3.78571 13.4321 6.56795 16.2143 10 16.2143C13.4321 16.2143 16.2143 13.4321 16.2143 10C16.2143 6.56795 13.4321 3.78571 10 3.78571ZM2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10ZM10.5172 10V6.17343C10.5172 5.80048 10.2149 5.49815 9.84194 5.49815C9.469 5.49815 9.16667 5.80048 9.16667 6.17343V10.6724C9.16667 10.8734 9.25455 11.054 9.394 11.1777C9.51359 11.2852 9.67176 11.3506 9.8452 11.3506H13.8267C14.1996 11.3506 14.5019 11.0482 14.5019 10.6753C14.5019 10.3023 14.1996 10 13.8267 10L10.5172 10Z" })), Due = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.7426 10.2838C18.0959 9.93417 18.0989 9.36433 17.7493 9.01102C17.3997 8.65772 16.8298 8.65473 16.4765 9.00436L10.601 14.8338L7.54722 11.8041C7.19391 11.4545 6.62407 11.4575 6.27444 11.8108C5.92481 12.1641 5.9278 12.734 6.2811 13.0836L9.96794 16.7397C10.3186 17.0868 10.8834 17.0868 11.2341 16.7397L17.7426 10.2838Z" })), Mue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "icons/bubble_fill" }, /* @__PURE__ */ ht.createElement("path", { id: "Subtract", fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.06 19.2214 15.9381 17.9425 17.3561L18.7257 19.3143C18.8571 19.6427 18.6152 20 18.2615 20H12C7.58172 20 4 16.4183 4 12ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12ZM16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" }))), Lue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2203 19H18.0976C18.0361 18.7179 17.9436 18.4457 17.812 18.1907L17.803 18.1734L17.7936 18.1564C17.4139 17.4763 16.8876 16.8742 16.2438 16.3433C15.4579 15.6787 14.5436 15.1733 13.5169 14.8181C13.1322 14.6837 12.7352 14.5716 12.3265 14.4809C12.7747 14.0846 13.1429 13.6102 13.4286 13.0655C13.5447 12.8521 13.6446 12.6336 13.7284 12.4104C13.9805 12.3961 14.2376 12.3889 14.4999 12.3889C15.8417 12.3889 17.0494 12.5764 18.1228 12.9515C19.0268 13.2641 19.8107 13.7017 20.4745 14.2644C21.0253 14.7176 21.4491 15.2099 21.7457 15.7413C21.9152 16.0695 21.9999 16.4993 21.9999 17.0307C21.9999 17.5621 21.8234 18.0232 21.4703 18.4139C21.1313 18.8046 20.7146 19 20.2203 19ZM14.3027 11.4444C14.1966 11.4444 14.0918 11.4397 13.9884 11.4302C14.0332 11.1522 14.0556 10.8685 14.0556 10.5799V8.86451C14.0556 7.97224 13.8492 7.12843 13.4286 6.35483C13.0266 5.58852 12.4593 4.96568 11.7313 4.51361C11.525 4.38094 11.3121 4.26655 11.0934 4.17062C11.1304 4.08608 11.1704 4.00263 11.2133 3.92026C11.537 3.32818 11.971 2.86412 12.5153 2.52807C13.0596 2.17602 13.6554 2 14.3027 2C14.95 2 15.5458 2.17602 16.0901 2.52807C16.6345 2.86412 17.0611 3.32818 17.37 3.92026C17.6937 4.51234 17.8555 5.16042 17.8555 5.86452V7.57993C17.8555 8.26802 17.6937 8.9081 17.37 9.50018C17.0611 10.0923 16.6345 10.5643 16.0901 10.9164C15.5458 11.2684 14.95 11.4444 14.3027 11.4444ZM6.21341 12.5002C5.90447 11.9081 5.75 11.268 5.75 10.5799V8.86452C5.75 8.16042 5.90447 7.51234 6.21341 6.92026C6.53706 6.32818 6.97104 5.86412 7.51536 5.52807C8.05968 5.17602 8.65549 5 9.30279 5C9.95009 5 10.5459 5.17602 11.0902 5.52807C11.6345 5.86412 12.0612 6.32818 12.3701 6.92026C12.6938 7.51234 12.8556 8.16042 12.8556 8.86452V10.5799C12.8556 11.268 12.6938 11.9081 12.3701 12.5002C12.0612 13.0923 11.6345 13.5643 11.0902 13.9164C10.5459 14.2684 9.95009 14.4444 9.30279 14.4444C8.65549 14.4444 8.05968 14.2684 7.51536 13.9164C6.97104 13.5643 6.53706 13.0923 6.21341 12.5002ZM13.1229 15.9515C12.0494 15.5764 10.8418 15.3889 9.5 15.3889C8.15819 15.3889 6.95057 15.5764 5.87712 15.9515C4.97316 16.2641 4.18927 16.7017 3.52542 17.2644C2.97458 17.7176 2.55085 18.2099 2.25424 18.7413C2.08475 19.0695 2 19.4993 2 20.0307C2 20.5621 2.16949 21.0232 2.50847 21.4139C2.86158 21.8046 3.28531 22 3.77966 22H15.2203C15.7147 22 16.1314 21.8046 16.4703 21.4139C16.8234 21.0232 17 20.5621 17 20.0307C17 19.4993 16.9153 19.0695 16.7458 18.7413C16.4492 18.2099 16.0254 17.7176 15.4746 17.2644C14.8107 16.7017 14.0268 16.2641 13.1229 15.9515Z" })), kue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 8.90816C8 9.63672 8.16477 10.3145 8.4943 10.9414C8.83953 11.5683 9.30245 12.0681 9.88305 12.4409C10.4637 12.8136 11.0992 13 11.7896 13C12.4801 13 13.1156 12.8136 13.6962 12.4409C14.2768 12.0681 14.7319 11.5683 15.0615 10.9414C15.4067 10.3145 15.5793 9.63672 15.5793 8.90816V7.09184C15.5793 6.34633 15.4067 5.66012 15.0615 5.03321C14.7319 4.40631 14.2768 3.91495 13.6962 3.55913C13.1156 3.18638 12.4801 3 11.7896 3C11.0992 3 10.4637 3.18638 9.88305 3.55913C9.30245 3.91495 8.83953 4.40631 8.4943 5.03321C8.16477 5.66012 8 6.34633 8 7.09184V8.90816ZM12 14C13.4313 14 14.7194 14.1986 15.8644 14.5957C16.8286 14.9267 17.6648 15.3901 18.3729 15.9858C18.9605 16.4657 19.4124 16.987 19.7288 17.5496C19.9096 17.8972 20 18.3522 20 18.9149C20 19.4775 19.8117 19.9657 19.435 20.3794C19.0734 20.7931 18.629 21 18.1017 21H5.89831C5.371 21 4.91902 20.7931 4.54237 20.3794C4.18079 19.9657 4 19.4775 4 18.9149C4 18.3522 4.0904 17.8972 4.27119 17.5496C4.58757 16.987 5.03955 16.4657 5.62712 15.9858C6.33522 15.3901 7.17137 14.9267 8.13559 14.5957C9.2806 14.1986 10.5687 14 12 14Z" })), jue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6883 18.3845L18.3142 17.6906C19.674 16.1828 20.5 14.1896 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5H18.5345L17.6883 18.3845ZM19.0144 21.7C19.0143 21.6996 19.0142 21.6993 19.014 21.6989L19.0144 21.7ZM22 12C22 14.575 21.0268 16.9226 19.4281 18.6952L20.4072 21.1429C20.5714 21.5534 20.269 22 19.8269 22H12C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.00195 14.256C7.00195 13.834 7.33964 13.4919 7.7562 13.4919L15.6027 13.4919C16.0192 13.4919 16.3569 13.834 16.3569 14.256C16.3569 14.678 16.0192 15.0201 15.6027 15.0201H7.7562C7.33964 15.0201 7.00195 14.678 7.00195 14.256Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.64331 9.96243C7.64331 9.54041 7.981 9.1983 8.39756 9.1983L16.244 9.1983C16.6606 9.1983 16.9983 9.54041 16.9983 9.96243C16.9983 10.3844 16.6606 10.7266 16.244 10.7266H8.39756C7.981 10.7266 7.64331 10.3844 7.64331 9.96243Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6159 17.5535C12.2079 17.4684 11.9454 17.0643 12.0294 16.651L14.0041 7.04095C14.0882 6.62761 14.487 6.36155 14.895 6.44669C15.3029 6.53182 15.5655 6.93591 15.4815 7.34925L13.5068 16.9593C13.4227 17.3726 13.0239 17.6387 12.6159 17.5535Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.94526 17.5535C8.5373 17.4684 8.27471 17.0643 8.35875 16.651L10.3335 7.04095C10.4175 6.62761 10.8164 6.36155 11.2243 6.44669C11.6323 6.53182 11.8949 6.93591 11.8108 7.34925L9.83611 16.9593C9.75206 17.3726 9.35322 17.6387 8.94526 17.5535Z" })), Uue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "icons/hashtag_in_bubble_fill" }, /* @__PURE__ */ ht.createElement("path", { id: "Subtract", fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.5749 21.0268 16.9226 19.4281 18.6951L20.4758 21.3143C20.6072 21.6427 20.3653 22 20.0115 22H12.0001L12 22C6.47715 22 2 17.5228 2 12ZM12.0322 17.1029C11.94 17.5564 12.2281 17.9997 12.6757 18.0931C13.1233 18.1865 13.5609 17.8946 13.6531 17.4411L14.0903 15.3135H15.9526C16.4097 15.3135 16.7802 14.9382 16.7802 14.4751C16.7802 14.0121 16.4097 13.6368 15.9526 13.6368H14.4349L15.0583 10.6028H16.6563C17.1134 10.6028 17.4839 10.2275 17.4839 9.76443C17.4839 9.30141 17.1134 8.92606 16.6563 8.92606H15.4028L15.8197 6.89735C15.9119 6.44385 15.6238 6.0005 15.1762 5.90709C14.7286 5.81368 14.291 6.1056 14.1988 6.5591L13.7124 8.92606H11.3755L11.7924 6.89735C11.8846 6.44385 11.5965 6.0005 11.1489 5.90709C10.7013 5.81368 10.2637 6.1056 10.1715 6.5591L9.68513 8.92606H8.0475C7.59046 8.92606 7.21996 9.30141 7.21996 9.76443C7.21996 10.2275 7.59046 10.6028 8.0475 10.6028H9.34058L8.71715 13.6368H7.34382C6.88679 13.6368 6.51629 14.0121 6.51629 14.4751C6.51629 14.9382 6.88679 15.3135 7.34382 15.3135H8.3726L8.00492 17.1029C7.91271 17.5564 8.20081 17.9997 8.64841 18.0931C9.09601 18.1865 9.53361 17.8946 9.62582 17.4411L10.063 15.3135H12.3999L12.0322 17.1029ZM10.4075 13.6368L11.031 10.6028H13.3679L12.7444 13.6368H10.4075Z" }))), Hue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.3335 4C3.22893 4 2.3335 4.89543 2.3335 6V18C2.3335 19.1046 3.22893 20 4.3335 20H20.3335C21.4381 20 22.3335 19.1046 22.3335 18V6C22.3335 4.89543 21.4381 4 20.3335 4H4.3335ZM6.32126 7.36589C5.97105 7.0965 5.46878 7.16202 5.19939 7.51222C4.93 7.86243 4.99552 8.3647 5.34572 8.63409L11.236 13.1651C11.883 13.6628 12.784 13.6628 13.431 13.1651L19.3213 8.63409C19.6715 8.3647 19.737 7.86243 19.4676 7.51222C19.1982 7.16202 18.6959 7.0965 18.3457 7.36589L12.4554 11.8969C12.3835 11.9522 12.2834 11.9522 12.2115 11.8969L6.32126 7.36589Z" })), Bue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "Group 612" }, /* @__PURE__ */ ht.createElement("path", { id: "Subtract", fillRule: "evenodd", clipRule: "evenodd", d: "M8.84336 0.859477C9.22079 0.619826 9.63393 0.5 10.0828 0.5C10.5316 0.5 10.9447 0.619826 11.3222 0.859477C11.6996 1.08824 11.9954 1.40414 12.2096 1.80719C12.4341 2.21024 12.5463 2.65142 12.5463 3.13072V4.71569C12.5463 5.1841 12.4341 5.61983 12.2096 6.02288C11.9954 6.42593 11.6996 6.74728 11.3222 6.98693C10.9447 7.22658 10.5316 7.34641 10.0828 7.34641C9.83773 7.34641 9.60333 7.31069 9.37958 7.23926C9.37963 7.23141 9.37965 7.22354 9.37965 7.21568V5.63071C9.37965 4.99131 9.22881 4.38463 8.92144 3.82921C8.62773 3.28005 8.21314 2.83351 7.68359 2.5102C7.73656 2.26422 7.82222 2.02989 7.94058 1.80719C8.165 1.40414 8.46593 1.08824 8.84336 0.859477ZM12.1427 13H14.2141C14.5712 13 14.8721 12.8638 15.1169 12.5915C15.3719 12.3192 15.4994 11.9978 15.4994 11.6275C15.4994 11.2571 15.4382 10.9575 15.3158 10.7288C15.1016 10.3584 14.7956 10.0153 14.3977 9.69935C13.9183 9.30719 13.3521 9.00218 12.6993 8.78431C11.924 8.52288 11.0518 8.39216 10.0828 8.39216C9.7705 8.39216 9.46829 8.40573 9.17614 8.43288C9.10823 8.62721 9.02333 8.81674 8.92144 9.00084C8.6901 9.43342 8.38478 9.80398 8.00912 10.1045C8.29757 10.1673 8.57824 10.2444 8.85081 10.3363C9.60308 10.5875 10.2769 10.9461 10.8586 11.4207C11.3342 11.7993 11.7283 12.2328 12.0148 12.7281L12.0231 12.7424L12.0309 12.7569C12.0733 12.8361 12.1104 12.9173 12.1427 13Z", fill: "#F9FAFA" }), /* @__PURE__ */ ht.createElement("path", { id: "I", d: "M5.91667 3C5.46783 3 5.05469 3.11983 4.67726 3.35948C4.29983 3.58824 3.9989 3.90414 3.77448 4.30719C3.56026 4.71024 3.45315 5.15142 3.45315 5.63072V7.21569C3.45315 7.6841 3.56026 8.11983 3.77448 8.52288C3.9989 8.92593 4.29983 9.24728 4.67726 9.48693C5.05469 9.72658 5.46783 9.84641 5.91667 9.84641C6.36551 9.84641 6.77864 9.72658 7.15607 9.48693C7.53351 9.24728 7.82933 8.92593 8.04355 8.52288C8.26797 8.11983 8.38018 7.6841 8.38018 7.21569V5.63072C8.38018 5.15142 8.26797 4.71024 8.04355 4.30719C7.82933 3.90414 7.53351 3.58824 7.15607 3.35948C6.77864 3.11983 6.36551 3 5.91667 3ZM5.91667 15.5H1.78531C1.42828 15.5 1.12225 15.3638 0.867232 15.0915C0.622411 14.8192 0.5 14.4978 0.5 14.1275C0.5 13.7571 0.561205 13.4575 0.683616 13.2288C0.897834 12.8584 1.20386 12.5153 1.60169 12.1993C2.08114 11.8072 2.64728 11.5022 3.30014 11.2843C4.07541 11.0229 4.94758 10.8922 5.91667 10.8922C6.88575 10.8922 7.75793 11.0229 8.53319 11.2843C9.18605 11.5022 9.7522 11.8072 10.2316 12.1993C10.6295 12.5153 10.9355 12.8584 11.1497 13.2288C11.2721 13.4575 11.3333 13.7571 11.3333 14.1275C11.3333 14.4978 11.2058 14.8192 10.9508 15.0915C10.706 15.3638 10.4051 15.5 10.048 15.5H5.91667Z", fill: "#F9FAFA" }))), B9 = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M2.9087 6.11383C4.13881 3.52085 6.94734 1.90564 9.94409 2.32066C13.2369 2.77668 15.6433 5.52972 15.7689 8.73497C15.7803 9.02647 15.6289 9.30023 15.3758 9.44572C15.1226 9.59122 14.8095 9.58443 14.563 9.4281L12.3426 8.07353C11.9763 7.84131 11.8678 7.35646 12.1004 6.9906C12.3329 6.62474 12.8183 6.51641 13.1846 6.74864L13.8453 7.11441C13.1817 5.42921 11.6512 4.14135 9.7283 3.87505C7.44902 3.55939 5.30943 4.77485 4.35311 6.73473C4.18026 7.08896 3.78194 7.29701 3.4071 7.17515C2.95683 7.02877 2.70577 6.5416 2.9087 6.11383Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M2.63508 8.72148C2.87747 8.56831 3.18417 8.55925 3.4352 8.69785L5.56889 9.84201C5.9486 10.0517 6.08625 10.5291 5.87634 10.9083C5.66643 11.2876 5.18845 11.425 4.80874 11.2154L4.19109 10.9083C4.85697 12.5882 6.38507 13.871 8.30372 14.1367C10.5409 14.4465 12.6437 13.2812 13.6249 11.3845C13.806 11.0344 14.209 10.8357 14.5809 10.9663C15.0277 11.1231 15.2673 11.616 15.0544 12.0389C13.7906 14.5491 11.0301 16.0985 8.08793 15.6911C4.84878 15.2425 2.46757 12.5712 2.27107 9.43353C2.25316 9.1476 2.3927 8.87466 2.63508 8.72148Z" })), zue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.30881 5C4.26561 5 3.41992 5.84568 3.41992 6.88889L3.49991 17.1111C3.49991 18.1543 4.34559 19 5.3888 19H14.361C15.4042 19 16.2499 18.1543 16.2499 17.1111V15.3089L19.5177 17.1244C19.9584 17.3692 20.4999 17.0505 20.4999 16.5464V7.46025C20.4999 6.95616 19.9584 6.63753 19.5177 6.88233L16.2499 8.69779L16.1699 6.88889C16.1699 5.84568 15.3242 5 14.281 5H5.30881ZM9.41339 8.46878C9.70628 8.17589 10.1812 8.17589 10.474 8.46878L13.4042 11.399C13.7362 11.7309 13.7362 12.2691 13.4042 12.6011L10.474 15.5312C10.1811 15.8241 9.70621 15.8241 9.41332 15.5312C9.12043 15.2383 9.12043 14.7635 9.41332 14.4706L11.1266 12.7573H6.78253C6.3503 12.7573 5.99991 12.4216 5.99991 12.0073C5.99991 11.5931 6.3503 11.2573 6.78253 11.2573H11.1413L9.41339 9.52944C9.12049 9.23655 9.12049 8.76168 9.41339 8.46878Z", fill: "#464E53" })), Fue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V7ZM6 10.25C6.41421 10.25 6.75 10.5858 6.75 11V12C6.75 14.8995 9.10051 17.25 12 17.25C14.8995 17.25 17.25 14.8995 17.25 12V11C17.25 10.5858 17.5858 10.25 18 10.25C18.4142 10.25 18.75 10.5858 18.75 11V12C18.75 15.4744 16.125 18.3357 12.75 18.7088V20.25C12.75 20.6642 12.4142 21 12 21C11.5858 21 11.25 20.6642 11.25 20.25V18.7088C7.87504 18.3357 5.25 15.4744 5.25 12V11C5.25 10.5858 5.58579 10.25 6 10.25Z", fill: "#464E53" })), Gue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 18, viewBox: "0 0 24 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "æ°äººæç¤¼" }, /* @__PURE__ */ ht.createElement("g", { id: "åå¹¶å½¢ç¶ Clipped" }, /* @__PURE__ */ ht.createElement("path", { id: "åå¹¶å½¢ç¶", d: "M18.7635 0.910224L19.791 4.60795H7.91895L17.4102 0.0837687C17.9582 -0.17743 18.5641 0.192587 18.7635 0.910224Z", fill: "url(#paint0_linear_971_81107)" })), /* @__PURE__ */ ht.createElement("g", { id: "åå¹¶å½¢ç¶ Clipped_2" }, /* @__PURE__ */ ht.createElement("path", { id: "åå¹¶å½¢ç¶_2", d: "M5.31679 0.910224L4.26172 4.60795L16.1904 4.6079L6.70632 0.0837687C6.14369 -0.17743 5.52157 0.192587 5.31679 0.910224Z", fill: "url(#paint1_linear_971_81107)" })), /* @__PURE__ */ ht.createElement("g", { id: "Mask Clipped" }, /* @__PURE__ */ ht.createElement("path", { id: "Mask", d: "M5.31093 4.7417L18.6891 4.7417C19.4131 4.7417 20 5.29725 20 5.98255V15.0001C20 16.6569 18.6569 18.0001 17 18.0001H7C5.34314 18.0001 4 16.6569 4 15.0001L4 5.98255C4 5.29725 4.58692 4.7417 5.31093 4.7417Z", fill: "url(#paint2_linear_971_81107)" })), /* @__PURE__ */ ht.createElement("g", { id: "Rectangle Clipped" }, /* @__PURE__ */ ht.createElement("g", { id: "Rectangle", filter: "url(#filter0_d_971_81107)" }, /* @__PURE__ */ ht.createElement("rect", { x: 2, y: 4.60791, width: 20, height: 4.60795, rx: 2.30398, fill: "url(#paint3_linear_971_81107)" }))), /* @__PURE__ */ ht.createElement("g", { id: "ç©å½¢ Clipped" }, /* @__PURE__ */ ht.createElement("path", { id: "ç©å½¢", d: "M11.1428 4.60791H12.8571V9.21586H11.1428V4.60791Z", fill: "white" }))), /* @__PURE__ */ ht.createElement("defs", null, /* @__PURE__ */ ht.createElement("filter", { id: "filter0_d_971_81107", x: -1, y: 2.60791, width: 26, height: 10.6079, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ ht.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ ht.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ ht.createElement("feOffset", { dy: 1 }), /* @__PURE__ */ ht.createElement("feGaussianBlur", { stdDeviation: 1.5 }), /* @__PURE__ */ ht.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.64238 0 0 0 0 0.0618266 0 0 0 0 0.366989 0 0 0 0.25 0" }), /* @__PURE__ */ ht.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_971_81107" }), /* @__PURE__ */ ht.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_971_81107", result: "shape" })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint0_linear_971_81107", x1: 10.4642, y1: 0.0640693, x2: 10.4642, y2: 5.8582, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#FFE6C7" }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#FF4B85" })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint1_linear_971_81107", x1: 14.0101, y1: 0.0640693, x2: 14.0101, y2: 5.8582, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#FFE6C7" }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#FF4B85" })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint2_linear_971_81107", x1: 0.489142, y1: 9.07792, x2: 5.26645, y2: 21.3258, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#FFDB5F" }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#FF4B9C" })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint3_linear_971_81107", x1: -11.0037, y1: 6.28886, x2: -10.0085, y2: 14.0311, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { offset: 633446e-9, stopColor: "#FFF37D" }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#FF6F92" })))), Vue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M9.5 20H14.5C14.5 21.1046 13.6046 22 12.5 22H11.5C10.3954 22 9.5 21.1046 9.5 20Z" }), /* @__PURE__ */ ht.createElement("rect", { x: 11, y: 2, width: 2, height: 4, rx: 1 }), /* @__PURE__ */ ht.createElement("path", { d: "M5.5 10.4872C5.5 6.99626 8.01418 4 12 4C15.9858 4 18.5 6.99058 18.5 10.4872V13.8158C18.5 14.8247 18.9869 15.7716 19.8074 16.3585L20.1667 16.6155C20.6897 16.9897 21 17.5932 21 18.2362V18.4149C21 18.7381 20.7381 19 20.4149 19H3.58506C3.26194 19 3 18.7381 3 18.4149V18.2362C3 17.5932 3.31032 16.9897 3.83333 16.6155L4.1926 16.3585C5.01314 15.7716 5.5 14.8247 5.5 13.8158V10.4872Z" })), Yue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.21661 21.7835C1.92372 21.4906 1.92372 21.0157 2.21661 20.7228L20.7229 2.21652C21.0158 1.92363 21.4907 1.92363 21.7836 2.21652C22.0765 2.50942 22.0765 2.98429 21.7836 3.27718L3.27727 21.7835C2.98438 22.0764 2.5095 22.0764 2.21661 21.7835Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C11.4477 2 11 2.44772 11 3V4.06556C7.59829 4.52172 5.5 7.29803 5.5 10.4872V13.8158C5.5 14.8247 5.01314 15.7716 4.1926 16.3585L3.83333 16.6155C3.31032 16.9897 3 17.5932 3 18.2362V18.4149C3 18.5469 3.04367 18.6686 3.11735 18.7665C3.14027 18.7401 3.16426 18.7144 3.18932 18.6893L16.3368 5.54184C15.454 4.77249 14.326 4.24295 13 4.06544V3C13 2.44772 12.5523 2 12 2ZM18.0664 8.05492L7.1213 19H20.4149C20.7381 19 21 18.7381 21 18.4149V18.2362C21 17.5932 20.6897 16.9897 20.1667 16.6155L19.8074 16.3585C18.9869 15.7716 18.5 14.8247 18.5 13.8158V10.4872C18.5 9.63429 18.3504 8.81153 18.0664 8.05492ZM12.5 22C13.6046 22 14.5 21.1046 14.5 20H9.5C9.5 21.1046 10.3954 22 11.5 22H12.5Z" })), Xue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 91, height: 93, viewBox: "0 0 91 93", fill: "none", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 34.9995L0.5 44.9995H10.5V34.9995ZM73 44.9995V36.9362L73.5373 36.5574H74.5579L83 44.9995H73Z", fill: "url(#paint0_linear_1930_138773)" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M83 44.9995H0.5V84.5828C0.5 88.9551 4.01776 92.4995 8.35714 92.4995H75.1429C79.4822 92.4995 83 88.9551 83 84.5828V44.9995ZM31.64 79.1283C30.7717 78.2587 30.7717 76.8489 31.64 75.9794L38.8595 68.7494L31.6378 61.5172C30.7696 60.6477 30.7696 59.2379 31.6378 58.3684C32.5061 57.4988 33.9138 57.4988 34.7821 58.3684L42.0038 65.6006L49.2258 58.368C50.0941 57.4984 51.5018 57.4984 52.3701 58.368C53.2384 59.2375 53.2384 60.6473 52.3701 61.5168L45.148 68.7494L52.3679 75.9798C53.2362 76.8493 53.2362 78.2591 52.3679 79.1286C51.4997 79.9982 50.0919 79.9982 49.2237 79.1286L42.0038 71.8982L34.7843 79.1282C33.916 79.9978 32.5083 79.9978 31.64 79.1283Z", fill: "url(#paint1_linear_1930_138773)" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M58 12.3606C58 9.6759 60.2047 7.49951 62.9242 7.49951H85.5758C88.2953 7.49951 90.5 9.67591 90.5 12.3606V31.696C90.5 34.3808 88.2953 36.5572 85.5758 36.5572H73.5373L65.1094 42.4995V36.5572H62.9242C60.2047 36.5572 58 34.3808 58 31.696V12.3606ZM84.5915 22.0829C84.5915 27.4524 80.1822 31.8051 74.743 31.8051C69.3038 31.8051 64.8945 27.4524 64.8945 22.0829C64.8945 16.7135 69.3038 12.3607 74.743 12.3607C80.1822 12.3607 84.5915 16.7135 84.5915 22.0829ZM75.5734 28.2685C72.4161 28.2685 69.8041 25.9637 69.3696 22.9656H81.7771C81.3426 25.9637 78.7306 28.2685 75.5734 28.2685ZM73.8445 19.4309C73.8445 20.4072 73.0428 21.1986 72.0538 21.1986C71.0649 21.1986 70.2632 20.4072 70.2632 19.4309C70.2632 18.4547 71.0649 17.6633 72.0538 17.6633C73.0428 17.6633 73.8445 18.4547 73.8445 19.4309ZM77.4166 18.5472C76.9284 18.5472 76.5327 18.9429 76.5327 19.4311C76.5327 19.9192 76.9284 20.3149 77.4165 20.3149H80.1255C80.6136 20.3149 81.0093 19.9192 81.0093 19.4311C81.0093 18.9429 80.6136 18.5472 80.1255 18.5472H77.4166Z", fill: "url(#paint2_linear_1930_138773)" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5 7.82609C10.5 3.50386 14.1106 0 18.5645 0H64.9355C69.2766 0 72.8166 3.32867 72.9931 7.49939H62.9242C60.2047 7.49939 58 9.67578 58 12.3605V31.6959C58 34.3806 60.2047 36.557 62.9242 36.557H65.1094V42.4994L73 36.9359V45H10.5V7.82609ZM19.4746 14.8224C19.4746 13.7309 20.3594 12.8461 21.4509 12.8461H50.1071C51.1986 12.8461 52.0834 13.7309 52.0834 14.8224C52.0834 15.9138 51.1986 16.7986 50.1071 16.7986H21.4509C20.3594 16.7986 19.4746 15.9138 19.4746 14.8224ZM21.4509 23.7157C20.3594 23.7157 19.4746 24.6005 19.4746 25.692C19.4746 26.7835 20.3594 27.6683 21.4509 27.6683H49.7513C50.8428 27.6683 51.7276 26.7835 51.7276 25.692C51.7276 24.6005 50.8428 23.7157 49.7513 23.7157H21.4509ZM19.4746 36.5616C19.4746 35.4701 20.3594 34.5853 21.4509 34.5853H40.2652C41.3566 34.5853 42.2415 35.4701 42.2415 36.5616C42.2415 37.6531 41.3566 38.5379 40.2652 38.5379H21.4509C20.3594 38.5379 19.4746 37.6531 19.4746 36.5616Z", fill: "url(#paint3_linear_1930_138773)" }), /* @__PURE__ */ ht.createElement("defs", null, /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint0_linear_1930_138773", x1: 5.93509, y1: 27.2912, x2: 5.93509, y2: 44.9995, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#4D4D4D", stopOpacity: 0.25 }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#808080", stopOpacity: 0.2 })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint1_linear_1930_138773", x1: 42.0021, y1: 44.9995, x2: 42.0021, y2: 92.4995, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#7F7F7F", stopOpacity: 0.12 }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#999999", stopOpacity: 0.1 })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint2_linear_1930_138773", x1: 74.25, y1: 7.49951, x2: 74.6515, y2: 48.8191, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#7F7F7F", stopOpacity: 0.25 }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#ADADAD", stopOpacity: 0.2 })), /* @__PURE__ */ ht.createElement("linearGradient", { id: "paint3_linear_1930_138773", x1: 41.1325, y1: 0, x2: 41.1325, y2: 45.4546, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ ht.createElement("stop", { stopColor: "#7F7F7F", stopOpacity: 0.08 }), /* @__PURE__ */ ht.createElement("stop", { offset: 1, stopColor: "#ADADAD", stopOpacity: 0.06 })))), Wue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6865 14.0776C18.7864 13.7558 18.4389 13.494 18.1239 13.6133C17.4636 13.8632 16.7478 14 16 14C12.6863 14 10 11.3137 10 8.00002C10 7.25222 10.1368 6.53637 10.3867 5.87614C10.506 5.56107 10.2442 5.21362 9.92243 5.31348C7.07088 6.19851 5 8.85742 5 12C5 15.866 8.13401 19 12 19C15.1426 19 17.8015 16.9291 18.6865 14.0776Z" })), que = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("circle", { cx: 12, cy: 12, r: 4 }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 17.5C12.4142 17.5 12.75 17.835 12.75 18.2483L12.75 20.2517C12.75 20.665 12.4142 21 12 21C11.5858 21 11.25 20.665 11.25 20.2517L11.25 18.2483C11.25 17.835 11.5858 17.5 12 17.5Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C12.4142 3 12.75 3.33504 12.75 3.74833L12.75 5.75167C12.75 6.16496 12.4142 6.5 12 6.5C11.5858 6.5 11.25 6.16496 11.25 5.75167L11.25 3.74833C11.25 3.33504 11.5858 3 12 3Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.11091 15.8891C8.4038 16.182 8.40433 16.6563 8.11209 16.9486L6.69551 18.3651C6.40327 18.6574 5.92892 18.6568 5.63603 18.3639C5.34314 18.0711 5.34261 17.5967 5.63485 17.3045L7.05143 15.8879C7.34367 15.5957 7.81801 15.5962 8.11091 15.8891Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.364 5.63605C18.6569 5.92894 18.6574 6.40329 18.3651 6.69553L16.9486 8.11211C16.6563 8.40435 16.182 8.40382 15.8891 8.11093C15.5962 7.81803 15.5957 7.34369 15.8879 7.05145L17.3045 5.63487C17.5967 5.34263 18.0711 5.34316 18.364 5.63605Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.8891 15.889C16.182 15.5961 16.6563 15.5956 16.9486 15.8878L18.3652 17.3044C18.6574 17.5966 18.6569 18.071 18.364 18.3638C18.0711 18.6567 17.5967 18.6573 17.3045 18.365L15.8879 16.9485C15.5957 16.6562 15.5962 16.1819 15.8891 15.889Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.63605 5.63604C5.92894 5.34315 6.40329 5.34262 6.69553 5.63486L8.11211 7.05144C8.40435 7.34368 8.40382 7.81802 8.11093 8.11092C7.81803 8.40381 7.34369 8.40434 7.05145 8.1121L5.63487 6.69552C5.34263 6.40328 5.34316 5.92894 5.63605 5.63604Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5 12C17.5 11.5858 17.835 11.25 18.2483 11.25L20.2517 11.25C20.665 11.25 21 11.5858 21 12C21 12.4142 20.665 12.75 20.2517 12.75L18.2483 12.75C17.835 12.75 17.5 12.4142 17.5 12Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 12C3 11.5858 3.33504 11.25 3.74833 11.25L5.75167 11.25C6.16496 11.25 6.5 11.5858 6.5 12C6.5 12.4142 6.16496 12.75 5.75167 12.75L3.74833 12.75C3.33504 12.75 3 12.4142 3 12Z" })), Kue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.81112 6.55318C8.08522 6.86373 8.05567 7.33768 7.74512 7.61178C6.4084 8.79159 5.56714 10.5154 5.56714 12.4365C5.56714 15.9893 8.44718 18.8693 11.9999 18.8693C15.5526 18.8693 18.4326 15.9893 18.4326 12.4365C18.4326 10.5154 17.5914 8.79159 16.2547 7.61178C15.9441 7.33768 15.9146 6.86373 16.1887 6.55318C16.4628 6.24263 16.9367 6.21307 17.2473 6.48717C18.8929 7.93964 19.9326 10.0671 19.9326 12.4365C19.9326 16.8177 16.381 20.3693 11.9999 20.3693C7.61875 20.3693 4.06714 16.8177 4.06714 12.4365C4.06714 10.0671 5.10688 7.93964 6.75252 6.48717C7.06307 6.21307 7.53702 6.24263 7.81112 6.55318Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0581 3.58075C12.4999 3.58075 12.8581 3.93892 12.8581 4.38075V12.761C12.8581 13.2029 12.4999 13.561 12.0581 13.561C11.6162 13.561 11.2581 13.2029 11.2581 12.761V4.38075C11.2581 3.93892 11.6162 3.58075 12.0581 3.58075Z" })), Jue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...t }, /* @__PURE__ */ ht.createElement("path", { clipRule: "evenodd", d: "M10.0001 2.91797C6.08806 2.91797 2.91675 6.08928 2.91675 10.0013C2.91675 10.3465 2.63693 10.6263 2.29175 10.6263C1.94657 10.6263 1.66675 10.3465 1.66675 10.0013C1.66675 5.39893 5.39771 1.66797 10.0001 1.66797C14.6025 1.66797 18.3334 5.39893 18.3334 10.0013C18.3334 14.6037 14.6025 18.3346 10.0001 18.3346C9.6549 18.3346 9.37508 18.0548 9.37508 17.7096C9.37508 17.3645 9.6549 17.0846 10.0001 17.0846C13.9121 17.0846 17.0834 13.9133 17.0834 10.0013C17.0834 6.08928 13.9121 2.91797 10.0001 2.91797Z" })), Zue = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.252 20C19.8377 20 19.502 19.6645 19.502 19.2505L19.502 4.74945C19.502 4.33554 19.8377 4 20.252 4C20.6662 4 21.002 4.33554 21.002 4.74945L21.002 19.2505C21.002 19.6645 20.6662 20 20.252 20Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0551 19.7917C11.348 20.0846 11.8229 20.0846 12.1158 19.7917C12.4087 19.4988 12.4087 19.0239 12.1158 18.731L6.14646 12.7617L16.2694 12.7614C16.6748 12.7614 17.0034 12.4256 17.0034 12.0114C17.0034 11.5972 16.6748 11.2614 16.2694 11.2614L6.14649 11.2617L12.1158 5.29235C12.4087 4.99946 12.4087 4.52459 12.1158 4.23169C11.8229 3.9388 11.348 3.9388 11.0551 4.23169L4.5126 10.7742C3.82918 11.4577 3.82918 12.5657 4.5126 13.2491L11.0551 19.7917Z" })), Que = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6.88892C2 5.84571 2.84568 5.00003 3.88889 5.00003H15.8611C16.9043 5.00003 17.75 5.84571 17.75 6.88892V8.69782L21.0178 6.88236C21.4585 6.63756 22 6.95619 22 7.46028V16.5465C22 17.0506 21.4585 17.3692 21.0178 17.1244L17.75 15.3089V17.1111C17.75 18.1543 16.9043 19 15.8611 19H3.88889C2.84568 19 2 18.1543 2 17.1111V6.88892ZM10.0103 7.96206C10.4244 7.96196 10.76 8.29759 10.7599 8.7117L10.7593 11.4966L13.5442 11.4959C13.9583 11.4958 14.2939 11.8315 14.2938 12.2456C14.2937 12.6597 13.9579 12.9955 13.5438 12.9956L10.7589 12.9962L10.7583 15.7811C10.7582 16.1952 10.4224 16.531 10.0083 16.5311C9.59416 16.5312 9.25853 16.1956 9.25862 15.7815L9.25928 12.9966L6.47441 12.9972C6.06029 12.9973 5.72466 12.6617 5.72476 12.2476C5.72485 11.8335 6.06064 11.4977 6.47476 11.4976L9.25963 11.4969L9.26028 8.71206C9.26038 8.29794 9.59616 7.96215 10.0103 7.96206Z" })), $ue = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.88144C3.5 5.83873 4.34568 4.99344 5.38889 4.99344H14.3611C15.4043 4.99344 16.25 5.83873 16.25 6.88144V8.69605L19.5178 6.88144C19.9585 6.63675 20.5 6.95524 20.5 7.45909V16.541C20.5 17.0449 19.9585 17.3634 19.5178 17.1187L16.25 15.3041V17.1054C16.25 18.1482 15.4043 18.9934 14.3611 18.9934H5.38889C4.34568 18.9934 3.5 18.1482 3.5 17.1054V6.88144ZM13.0396 9.21769C13.3325 9.51045 13.3325 9.9851 13.0396 10.2779L11.0699 12.2466L13.0396 14.2154C13.3325 14.5081 13.3325 14.9828 13.0396 15.2755C12.7467 15.5683 12.2718 15.5683 11.9789 15.2755L10.0093 13.3068L8.03961 15.2755C7.74671 15.5683 7.27184 15.5683 6.97895 15.2755C6.68605 14.9828 6.68605 14.5081 6.97895 14.2153L8.94861 12.2466L6.97895 10.2779C6.68605 9.98511 6.68605 9.51046 6.97895 9.21771C7.27184 8.92495 7.74671 8.92495 8.03961 9.21771L10.0093 11.1864L11.9789 9.21769C12.2718 8.92493 12.7467 8.92493 13.0396 9.21769Z", fill: "#464E53" })), ede = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.06 19.2214 15.9381 17.9425 17.3561L18.7257 19.3143C18.8571 19.6427 18.6152 20 18.2615 20H12C7.58172 20 4 16.4183 4 12ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12ZM16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" })), tde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.5 16.7996C13.5 17.628 12.8284 18.2996 12 18.2996C11.1716 18.2996 10.5 17.628 10.5 16.7996C10.5 15.9712 11.1716 15.2996 12 15.2996C12.8284 15.2996 13.5 15.9712 13.5 16.7996ZM12 14.2004C11.4477 14.2004 11 13.7534 11 13.2019V6.69881C11 6.14739 11.4477 5.70038 12 5.70038C12.5523 5.70038 13 6.14739 13 6.69881V13.2019C13 13.7534 12.5523 14.2004 12 14.2004Z" })), nde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 3.75C4 3.33579 4.33579 3 4.75 3L19.25 3C19.6642 3 20 3.33579 20 3.75C20 4.16421 19.6642 4.5 19.25 4.5L4.75 4.5C4.33579 4.5 4 4.16421 4 3.75Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M5.48482 20.7852C4.60435 21.0303 3.84223 20.0556 4.3026 19.266L11.1702 7.48779C11.5569 6.82468 12.5156 6.82642 12.8998 7.49094L19.7727 19.3774C20.2213 20.1532 19.5015 21.082 18.6383 20.8412L12.5647 19.147C12.2197 19.0508 11.8575 19.0483 11.5117 19.1414C10.3749 19.4473 7.61904 20.1911 5.48482 20.7852Z" })), rde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.99854 19.7694C3.99854 19.3552 4.33432 19.0194 4.74854 19.0194L20.2485 19.0194C20.6627 19.0194 20.9985 19.3552 20.9985 19.7694C20.9985 20.1837 20.6627 20.5194 20.2485 20.5194L4.74854 20.5194C4.33432 20.5194 3.99854 20.1837 3.99854 19.7694Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M11.463 4.85131C11.8132 4.9486 12.1834 4.9486 12.5336 4.85131L18.6334 3.15692C19.4972 2.91697 20.216 3.84728 19.7658 4.62257L12.8631 16.5106C12.4776 17.1745 11.519 17.1745 11.1335 16.5106L4.23076 4.62257C3.78059 3.84728 4.49939 2.91697 5.3632 3.15692L11.463 4.85131Z" })), ide = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5833 7.27517V17.2292C19.5833 17.4376 19.4196 17.5833 19.246 17.5833H16L16 9.95377C16 9.66541 15.8755 9.39108 15.6585 9.20119L12.2828 6.24742C12.1005 6.08792 11.8665 6 11.6243 6H9.41667V4.77083C9.41667 4.56242 9.58043 4.41667 9.75397 4.41667H16.7655C16.8506 4.41667 16.9349 4.45065 16.9993 4.5156L19.4798 7.01993C19.5445 7.08533 19.5833 7.17689 19.5833 7.27517ZM16 19L16 21C16 21.5523 15.5523 22 15 22H4C3.44772 22 3 21.5523 3 21V7C3 6.44772 3.44772 6 4 6H8V4.77083C8 3.79283 8.78528 3 9.75397 3H16.7655C17.2307 3 17.6769 3.18657 18.0058 3.51867L20.4863 6.023C20.8152 6.3551 21 6.80552 21 7.27517V17.2292C21 18.2072 20.2147 19 19.246 19H16Z" })), sde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.4943 10.9414C8.16477 10.3145 8 9.63672 8 8.90816V7.09184C8 6.34633 8.16477 5.66012 8.4943 5.03321C8.83953 4.40631 9.30245 3.91495 9.88305 3.55913C10.4637 3.18638 11.0992 3 11.7896 3C12.4801 3 13.1156 3.18638 13.6962 3.55913C14.2768 3.91495 14.7319 4.40631 15.0615 5.03321C15.4067 5.66012 15.5793 6.34633 15.5793 7.09184V8.90816C15.5793 9.63672 15.4067 10.3145 15.0615 10.9414C14.7319 11.5683 14.2768 12.0681 13.6962 12.4409C13.1156 12.8136 12.4801 13 11.7896 13C11.0992 13 10.4637 12.8136 9.88305 12.4409C9.30245 12.0681 8.83953 11.5683 8.4943 10.9414ZM15.8644 14.5957C14.7194 14.1986 13.4313 14 12 14C10.5687 14 9.2806 14.1986 8.13559 14.5957C7.17137 14.9267 6.33522 15.3901 5.62712 15.9858C5.03955 16.4657 4.58757 16.987 4.27119 17.5496C4.0904 17.8972 4 18.3522 4 18.9149C4 19.4775 4.18079 19.9657 4.54237 20.3794C4.91902 20.7931 5.371 21 5.89831 21H11.628C11.5451 20.7654 11.5 20.513 11.5 20.25C11.5 19.6737 11.7166 19.1481 12.0729 18.75C11.7166 18.3519 11.5 17.8263 11.5 17.25C11.5 16.0074 12.5074 15 13.75 15H16.8464C16.5353 14.8484 16.208 14.7137 15.8644 14.5957Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 17.25C13 16.8358 13.3358 16.5 13.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H13.75C13.3358 18 13 17.6642 13 17.25Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 20.25C13 19.8358 13.3358 19.5 13.75 19.5H20.25C20.6642 19.5 21 19.8358 21 20.25C21 20.6642 20.6642 21 20.25 21H13.75C13.3358 21 13 20.6642 13 20.25Z" })), ade = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.75 5.5C6.05964 5.5 5.5 6.05964 5.5 6.75V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H17.25C17.9404 18.5 18.5 17.9404 18.5 17.25V12C18.5 11.5858 18.8358 11.25 19.25 11.25C19.6642 11.25 20 11.5858 20 12V17.25C20 18.7688 18.7688 20 17.25 20H6.75C5.23122 20 4 18.7688 4 17.25V6.75C4 5.23122 5.23122 4 6.75 4H12C12.4142 4 12.75 4.33579 12.75 4.75C12.75 5.16421 12.4142 5.5 12 5.5H6.75Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.7689 3.22022C21.0618 3.51311 21.0618 3.98799 20.7689 4.28088L10.0448 15.0052C9.75187 15.2981 9.27699 15.2981 8.9841 15.0052C8.6912 14.7123 8.6912 14.2374 8.9841 13.9445L19.7083 3.22022C20.0012 2.92733 20.476 2.92733 20.7689 3.22022Z" })), ode = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 20, viewBox: "0 0 21 20", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.21426 10.9508C1.43321 11.7319 1.43322 12.9982 2.21426 13.7793L5.40469 16.9697C6.96679 18.5318 9.49945 18.5318 11.0615 16.9697L11.9497 16.0816L4.51658 8.64852L2.21426 10.9508ZM11.5492 1.61607L5.53031 7.63492L12.9634 15.068L18.9822 9.04914C19.7633 8.26809 19.7633 7.00176 18.9822 6.22071L14.3776 1.61607C13.5965 0.835019 12.3302 0.835021 11.5492 1.61607Z" }), /* @__PURE__ */ ht.createElement("rect", { x: 15, y: 15, width: 5, height: 1.5, rx: 0.75 }), /* @__PURE__ */ ht.createElement("rect", { x: 12, y: 17.5, width: 5, height: 1.5, rx: 0.75 })), cde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 7C4 5.34315 5.34315 4 7 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM11.6258 6.96235C11.9187 6.66945 12.3936 6.66945 12.6865 6.96235L16.4867 10.7626C17.1701 11.446 17.1701 12.554 16.4867 13.2374L12.6865 17.0377C12.3936 17.3305 11.9187 17.3305 11.6258 17.0377C11.3329 16.7448 11.3329 16.2699 11.6258 15.977L14.8528 12.75L7.40979 12.75C6.99558 12.75 6.65979 12.4142 6.65979 12C6.65979 11.5858 6.99558 11.25 7.40979 11.25L14.8528 11.25L11.6258 8.02301C11.3329 7.73011 11.3329 7.25524 11.6258 6.96235Z" })), ude = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.22 10.22C18.22 10.6508 18.5692 11 19 11C19.4308 11 19.78 10.6508 19.78 10.22L19.78 8.78003L21.22 8.78002C21.6508 8.78002 22 8.43079 22 7.99999C22 7.5692 21.6508 7.21997 21.22 7.21997L19.78 7.21998L19.78 5.78002C19.78 5.34923 19.4308 5 19 5C18.5692 5 18.22 5.34923 18.22 5.78002L18.22 7.21999L16.78 7.22C16.3492 7.22 16 7.56922 16 8.00002C16 8.43081 16.3492 8.78004 16.78 8.78004L18.22 8.78003L18.22 10.22Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4818 12.5687C12.5541 12.5288 12.6256 12.4862 12.6962 12.4409C13.2768 12.0681 13.7319 11.5683 14.0615 10.9414C14.4067 10.3145 14.5793 9.63672 14.5793 8.90816V7.09184C14.5793 6.34633 14.4067 5.66012 14.0615 5.03321C13.7319 4.40631 13.2768 3.91495 12.6962 3.55913C12.1156 3.18638 11.4801 3 10.7896 3C10.0992 3 9.46366 3.18638 8.88305 3.55913C8.30245 3.91495 7.83953 4.40631 7.4943 5.03321C7.16477 5.66012 7 6.34633 7 7.09184V8.90816C7 9.63672 7.16477 10.3145 7.4943 10.9414C7.83953 11.5683 8.30245 12.0681 8.88305 12.4409C8.97661 12.5009 9.0716 12.5562 9.16802 12.6065C9.66991 12.8688 10.2105 13 10.7896 13C10.8603 13 10.9305 12.998 11 12.9941C11.527 12.9645 12.0209 12.8227 12.4818 12.5687ZM12.744 14.1072C12.1884 14.0357 11.6071 14 11 14C10.9295 14 10.8594 14.0005 10.7896 14.0014C10.1446 14.0103 9.52913 14.0604 8.94335 14.1516C8.30561 14.2509 7.70303 14.3989 7.13559 14.5957C6.17137 14.9267 5.33522 15.3901 4.62712 15.9858C4.03955 16.4657 3.58757 16.987 3.27119 17.5496C3.0904 17.8972 3 18.3522 3 18.9149C3 19.4775 3.18079 19.9657 3.54237 20.3794C3.91902 20.7931 4.371 21 4.89831 21H17.1017C17.629 21 18.0734 20.7931 18.435 20.3794C18.8117 19.9657 19 19.4775 19 18.9149C19 18.3522 18.9096 17.8972 18.7288 17.5496C18.4124 16.987 17.9605 16.4657 17.3729 15.9858C16.6648 15.3901 15.8286 14.9267 14.8644 14.5957C14.2051 14.367 13.4983 14.2042 12.744 14.1072ZM17.4053 18.2566C17.1952 17.8922 16.8797 17.5197 16.424 17.1476L16.4156 17.1407L16.4072 17.1336C15.8543 16.6685 15.1845 16.2915 14.3774 16.0145L14.3728 16.0129C13.4116 15.6795 12.2935 15.5 11 15.5C9.70653 15.5 8.5884 15.6795 7.62716 16.0129L7.62258 16.0145L7.62258 16.0145C6.81549 16.2915 6.1457 16.6685 5.5928 17.1336L5.58444 17.1407L5.57599 17.1476C5.12032 17.5197 4.8048 17.8922 4.59471 18.2567C4.56071 18.3309 4.5 18.5244 4.5 18.9149C4.5 19.1181 4.55224 19.2513 4.66199 19.3809C4.76716 19.493 4.82385 19.5 4.89831 19.5H17.1017C17.1635 19.5 17.1883 19.4893 17.1976 19.4849C17.2084 19.4799 17.2458 19.4607 17.3056 19.3923L17.3156 19.3809L17.3258 19.3696C17.4495 19.2338 17.5 19.1064 17.5 18.9149C17.5 18.5244 17.4393 18.3308 17.4053 18.2566ZM8.81534 10.2306C9.04375 10.6409 9.3346 10.9482 9.69343 11.1786L8.88305 12.4409L9.69343 11.1786C10.0321 11.396 10.3863 11.5 10.7896 11.5C11.193 11.5 11.5472 11.396 11.8859 11.1786C12.2421 10.9499 12.5216 10.647 12.7337 10.2434L12.7405 10.2306L12.7475 10.2178C12.9684 9.81667 13.0793 9.38847 13.0793 8.90816V7.09184C13.0793 6.5884 12.9655 6.15265 12.7475 5.75678L12.7405 5.74403L12.7337 5.73114C12.5246 5.33334 12.2533 5.04694 11.9125 4.83808L11.8991 4.82987L11.8859 4.82139C11.5472 4.60397 11.193 4.5 10.7896 4.5C10.3863 4.5 10.0321 4.60397 9.69343 4.82139L9.68022 4.82987L9.66683 4.83808C9.32322 5.04865 9.04053 5.33964 8.81535 5.74396C8.60927 6.14091 8.5 6.58179 8.5 7.09184V8.90816C8.5 9.39561 8.60669 9.82887 8.81534 10.2306Z" })), z9 = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.4943 10.9414C7.16477 10.3145 7 9.63672 7 8.90816V7.09184C7 6.34633 7.16477 5.66012 7.4943 5.03321C7.83953 4.40631 8.30245 3.91495 8.88305 3.55913C9.46366 3.18638 10.0992 3 10.7896 3C11.4801 3 12.1156 3.18638 12.6962 3.55913C13.2768 3.91495 13.7319 4.40631 14.0615 5.03321C14.4067 5.66012 14.5793 6.34633 14.5793 7.09184V8.90816C14.5793 9.63672 14.4067 10.3145 14.0615 10.9414C13.7319 11.5683 13.2768 12.0681 12.6962 12.4409C12.1156 12.8136 11.4801 13 10.7896 13C10.0992 13 9.46366 12.8136 8.88305 12.4409C8.30245 12.0681 7.83953 11.5683 7.4943 10.9414ZM14.8644 14.5957C13.7194 14.1986 12.4313 14 11 14C9.56874 14 8.2806 14.1986 7.13559 14.5957C6.17137 14.9267 5.33522 15.3901 4.62712 15.9858C4.03955 16.4657 3.58757 16.987 3.27119 17.5496C3.0904 17.8972 3 18.3522 3 18.9149C3 19.4775 3.18079 19.9657 3.54237 20.3794C3.91902 20.7931 4.371 21 4.89831 21H17.1017C17.629 21 18.0734 20.7931 18.435 20.3794C18.8117 19.9657 19 19.4775 19 18.9149C19 18.3522 18.9096 17.8972 18.7288 17.5496C18.4124 16.987 17.9605 16.4657 17.3729 15.9858C16.6648 15.3901 15.8286 14.9267 14.8644 14.5957ZM18.9833 11.2402C18.5525 11.2402 18.2032 10.891 18.2032 10.4602V8.90011H16.6432C16.2124 8.90011 15.8632 8.55088 15.8632 8.12009C15.8632 7.68929 16.2124 7.34006 16.6432 7.34006H18.2032V5.78003C18.2032 5.34923 18.5525 5.00001 18.9833 5.00001C19.4141 5.00001 19.7633 5.34923 19.7633 5.78003V7.34006L21.3234 7.34006C21.7542 7.34006 22.1034 7.68929 22.1034 8.12009C22.1034 8.55088 21.7542 8.90011 21.3234 8.90011H19.7633V10.4602C19.7633 10.891 19.4141 11.2402 18.9833 11.2402Z" })), dde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4804 12.5687C11.5526 12.5288 11.6241 12.4862 11.6948 12.4409C12.2754 12.0681 12.7305 11.5683 13.06 10.9414C13.4052 10.3145 13.5778 9.63672 13.5778 8.90816V7.09184C13.5778 6.34633 13.4052 5.66012 13.06 5.03321C12.7305 4.40631 12.2754 3.91495 11.6948 3.55913C11.1142 3.18638 10.4786 3 9.78818 3C9.09773 3 8.4622 3.18638 7.88159 3.55913C7.30098 3.91495 6.83806 4.40631 6.49284 5.03321C6.1633 5.66012 5.99854 6.34633 5.99854 7.09184V8.90816C5.99854 9.63672 6.1633 10.3145 6.49284 10.9414C6.83806 11.5683 7.30098 12.0681 7.88159 12.4409C7.97515 12.5009 8.07014 12.5562 8.16655 12.6065C8.66845 12.8688 9.20899 13 9.78818 13C9.85888 13 9.92899 12.998 9.99854 12.9941C10.5255 12.9645 11.0195 12.8227 11.4804 12.5687ZM11.7425 14.1072C11.187 14.0357 10.6056 14 9.99854 14C9.92807 14 9.85795 14.0005 9.78818 14.0014C9.14309 14.0103 8.52766 14.0604 7.94188 14.1516C7.30415 14.2509 6.70156 14.3989 6.13413 14.5957C5.16991 14.9267 4.33375 15.3901 3.62565 15.9858C3.03808 16.4657 2.58611 16.987 2.26972 17.5496C2.08893 17.8972 1.99854 18.3522 1.99854 18.9149C1.99854 19.4775 2.17933 19.9657 2.54091 20.3794C2.91756 20.7931 3.36953 21 3.89684 21H16.1002C16.6275 21 17.072 20.7931 17.4336 20.3794C17.8102 19.9657 17.9985 19.4775 17.9985 18.9149C17.9985 18.3522 17.9081 17.8972 17.7273 17.5496C17.411 16.987 16.959 16.4657 16.3714 15.9858C15.6633 15.3901 14.8272 14.9267 13.8629 14.5957C13.2036 14.367 12.4968 14.2042 11.7425 14.1072ZM16.4038 18.2566C16.1937 17.8922 15.8782 17.5197 15.4226 17.1476L15.4141 17.1407L15.4057 17.1336C14.8528 16.6685 14.1831 16.2915 13.376 16.0145L13.3714 16.0129C12.4101 15.6795 11.292 15.5 9.99854 15.5C8.70507 15.5 7.58694 15.6795 6.62569 16.0129L6.62112 16.0145L6.62111 16.0145C5.81402 16.2915 5.14423 16.6685 4.59134 17.1336L4.58298 17.1407L4.57452 17.1476C4.11886 17.5197 3.80334 17.8922 3.59324 18.2567C3.55924 18.3309 3.49854 18.5244 3.49854 18.9149C3.49854 19.1181 3.55078 19.2513 3.66052 19.3809C3.7657 19.493 3.82238 19.5 3.89684 19.5H16.1002C16.162 19.5 16.1868 19.4893 16.1961 19.4849C16.2069 19.4799 16.2444 19.4607 16.3041 19.3923L16.3141 19.3809L16.3244 19.3696C16.448 19.2338 16.4985 19.1064 16.4985 18.9149C16.4985 18.5244 16.4378 18.3308 16.4038 18.2566ZM7.81388 10.2306C8.04228 10.6409 8.33313 10.9482 8.69197 11.1786L7.88159 12.4409L8.69197 11.1786C9.03061 11.396 9.38484 11.5 9.78818 11.5C10.1915 11.5 10.5457 11.396 10.8844 11.1786C11.2407 10.9499 11.5201 10.647 11.7323 10.2434L11.739 10.2306L11.746 10.2178C11.9669 9.81667 12.0778 9.38847 12.0778 8.90816V7.09184C12.0778 6.5884 11.964 6.15265 11.746 5.75678L11.739 5.74403L11.7323 5.73114C11.5231 5.33334 11.2518 5.04694 10.911 4.83808L10.8976 4.82987L10.8844 4.82139C10.5458 4.60397 10.1915 4.5 9.78818 4.5C9.38483 4.5 9.03061 4.60397 8.69197 4.82139L8.67875 4.82987L8.66536 4.83808C8.32175 5.04865 8.03906 5.33964 7.81388 5.74396C7.6078 6.14091 7.49854 6.58179 7.49854 7.09184V8.90816C7.49854 9.39561 7.60522 9.82887 7.81388 10.2306Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9985 8.00002C15.9985 7.56922 16.3478 7.22 16.7786 7.22L21.2185 7.21997C21.6493 7.21997 21.9985 7.5692 21.9985 7.99999C21.9985 8.43079 21.6493 8.78002 21.2185 8.78002L16.7786 8.78004C16.3478 8.78004 15.9985 8.43081 15.9985 8.00002Z" })), lde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.04199 6.21875C2.04199 5.11418 2.93742 4.21875 4.04199 4.21875H20.042C21.1466 4.21875 22.042 5.11418 22.042 6.21875V18.2188C22.042 19.3233 21.1466 20.2188 20.042 20.2188H4.04199C2.93742 20.2188 2.04199 19.3233 2.04199 18.2188V6.21875ZM9 8.73948V15.6387C9 16.0607 9.43805 16.3252 9.79012 16.1159L15.5911 12.6663C15.9458 12.4553 15.9458 11.9229 15.5911 11.7119L9.79012 8.26231C9.43805 8.05295 9 8.3175 9 8.73948Z" })), fde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M3.33325 13.1702V7.15817C3.33325 6.60589 3.78096 6.15818 4.33324 6.15817L7.49992 6.15813L12.1724 2.85242C12.8347 2.38384 13.75 2.85746 13.75 3.66877V16.6156C13.75 17.424 12.8405 17.8983 12.1776 17.4356L7.49992 14.1702H4.33325C3.78097 14.1702 3.33325 13.7224 3.33325 13.1702Z" }), /* @__PURE__ */ ht.createElement("rect", { x: 15, y: 5.8335, width: 1.66667, height: 8.33333, rx: 0.833333 })), hde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M16.8797 10.0065C16.8797 6.21124 13.803 3.13457 10.0077 3.13457C6.21246 3.13457 3.13579 6.21124 3.13579 10.0065C3.13579 13.5976 5.89029 16.5453 9.40173 16.8521C9.73533 16.8812 10.0077 17.1499 10.0077 17.4848C10.0077 17.8197 9.73531 18.0935 9.40135 18.0687C5.21955 17.7587 1.9231 14.2675 1.9231 10.0065C1.9231 5.54149 5.54271 1.92188 10.0077 1.92188C14.4727 1.92188 18.0924 5.54149 18.0924 10.0065C18.0924 10.5247 18.0436 11.0315 17.9504 11.5226C17.8584 12.0079 17.3229 12.2378 16.8786 12.0218L13.9437 10.5951C13.6375 10.4463 13.5227 10.0682 13.6944 9.77418C13.8478 9.51158 14.1769 9.41036 14.4513 9.54136L16.8418 10.6823C16.8728 10.4172 16.8797 10.28 16.8797 10.0065Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0077 2.12298C5.6543 2.12298 2.12518 5.6521 2.12518 10.0055C2.12518 14.1599 5.33921 17.5639 9.41626 17.8662C9.62331 17.8815 9.80558 17.7111 9.80558 17.4838C9.80558 17.2647 9.62465 17.0734 9.3841 17.0524C5.76917 16.7366 2.93364 13.7023 2.93364 10.0055C2.93364 6.09861 6.1008 2.93144 10.0077 2.93144C13.9146 2.93144 17.0817 6.09861 17.0817 10.0055C17.0817 10.2859 17.0746 10.431 17.0425 10.7048L17.0096 10.9854L14.3642 9.72276C14.1846 9.63703 13.9693 9.70326 13.8689 9.87511C13.7565 10.0675 13.8316 10.3149 14.0321 10.4123L16.9669 11.839C17.3075 12.0046 17.6878 11.8214 17.7518 11.4839C17.8427 11.0052 17.8902 10.511 17.8902 10.0055C17.8902 5.6521 14.3611 2.12298 10.0077 2.12298ZM1.72095 10.0055C1.72095 5.42885 5.43105 1.71875 10.0077 1.71875C14.5843 1.71875 18.2944 5.42885 18.2944 10.0055C18.2944 10.5364 18.2445 11.0558 18.149 11.5592C18.0289 12.1924 17.3382 12.469 16.7902 12.2025L13.8553 10.7759C13.4432 10.5756 13.2887 10.0669 13.5199 9.67123C13.7263 9.31787 14.169 9.18168 14.5384 9.35795L16.6682 10.3745C16.6754 10.2635 16.6775 10.1566 16.6775 10.0055C16.6775 6.32186 13.6913 3.33568 10.0077 3.33568C6.32405 3.33568 3.33787 6.32186 3.33787 10.0055C3.33787 13.4908 6.01134 16.352 9.41929 16.6497C9.84595 16.687 10.2098 17.0331 10.2098 17.4838C10.2098 17.9262 9.84725 18.3035 9.38637 18.2693C5.09982 17.9514 1.72095 14.3732 1.72095 10.0055Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M14.425 4.74321C11.5177 2.30366 7.18315 2.68288 4.7436 5.59023C2.30405 8.49757 2.68327 12.8321 5.59061 15.2716C8.34152 17.5799 12.3702 17.3646 14.8623 14.8719C15.0991 14.6351 15.48 14.5991 15.7365 14.8144C15.993 15.0296 16.0277 15.4143 15.7941 15.6542C12.8685 18.6584 8.07525 18.9395 4.81111 16.2006C1.3907 13.3305 0.944561 8.23112 3.81462 4.81072C6.68468 1.39032 11.7841 0.944177 15.2045 3.81424L14.425 4.74321Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.96953 4.93916C1.17122 8.27406 1.60621 13.246 4.9411 16.0443C8.12357 18.7147 12.7971 18.4406 15.6493 15.5117C15.7942 15.363 15.7808 15.1139 15.6067 14.9677C15.4389 14.8269 15.176 14.8426 15.0053 15.0133C12.4397 17.5795 8.29268 17.8012 5.46077 15.425C2.46792 12.9137 2.07755 8.45169 4.58885 5.45883C7.0567 2.51776 11.4083 2.0899 14.3983 4.45916L14.9182 3.83962C11.5859 1.18349 6.7244 1.65604 3.96953 4.93916ZM4.68127 16.354C1.17535 13.4122 0.718059 8.18524 3.65987 4.67933C6.60168 1.17342 11.8286 0.716122 15.3345 3.65793L15.4893 3.78785L14.45 5.02649L14.2952 4.89657C11.4733 2.52877 7.2663 2.89684 4.89851 5.71867C2.53071 8.5405 2.89878 12.7475 5.72061 15.1153C8.39053 17.3557 12.3008 17.1468 14.7194 14.7275C15.0223 14.4246 15.5212 14.3684 15.8665 14.6581C16.2054 14.9424 16.2614 15.4627 15.9389 15.7938C12.9401 18.8731 8.02709 19.1614 4.68127 16.354Z" })), pde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.9985 5.5H3.99854C3.72239 5.5 3.49854 5.72386 3.49854 6V18C3.49854 18.2761 3.72239 18.5 3.99854 18.5H19.9985C20.2747 18.5 20.4985 18.2761 20.4985 18V6C20.4985 5.72386 20.2747 5.5 19.9985 5.5ZM3.99854 4C2.89397 4 1.99854 4.89543 1.99854 6V18C1.99854 19.1046 2.89397 20 3.99854 20H19.9985C21.1031 20 21.9985 19.1046 21.9985 18V6C21.9985 4.89543 21.1031 4 19.9985 4H3.99854Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M10.2032 15.8734C9.66982 16.1806 9.00391 15.7956 9.00391 15.1802V8.91601C9.00391 8.30777 9.6558 7.92202 10.189 8.21476L15.7571 11.2722C16.3039 11.5724 16.3119 12.3553 15.7713 12.6667L10.2032 15.8734Z" })), gde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 4C3.44772 4 3 4.44772 3 5V18.5C3 19.3284 3.67157 20 4.5 20L19.5 20C20.3284 20 21 19.3284 21 18.5V7.5C21 6.67157 20.3284 6 19.5 6L10.394 6.00001C10.0104 6.00001 9.6606 5.78056 9.49366 5.43517L9.073 4.56483C8.90607 4.21945 8.55626 4 8.17265 4H4ZM5.58 9C5.25967 9 5 9.25968 5 9.58C5 9.90033 5.25967 10.16 5.58 10.16H18.42C18.7403 10.16 19 9.90033 19 9.58C19 9.25968 18.7403 9 18.42 9H5.58Z" })), mde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.8739 20.2928C13.271 20.4284 12.6439 20.5 12 20.5C9.23258 20.5 6.77405 19.1775 5.22197 17.1299C6.00575 17.2505 6.78612 17.2111 7.15971 16.7558C7.5594 16.2686 7.66327 15.4954 7.75984 14.7764C7.86966 13.9587 7.97006 13.2112 8.48535 13.0344C8.86945 12.9027 9.4269 13.2273 10.0752 13.605C11.0615 14.1794 12.2581 14.8763 13.3745 14.2749C14.3726 13.7372 14.2246 12.7546 14.0809 11.8002C13.9582 10.9855 13.8386 10.1913 14.4377 9.71183C14.9722 9.28414 15.5124 9.24689 15.9941 9.21368C16.685 9.16604 17.2556 9.12669 17.5167 7.95575C17.7793 6.77759 17.2655 6.49017 16.7562 6.20524C16.4064 6.00953 16.0587 5.81499 15.9661 5.33378C15.8921 4.94921 15.8071 4.62236 15.7255 4.35779C18.5526 5.73855 20.5 8.64186 20.5 12C20.5 13.4139 20.1548 14.7471 19.5441 15.9201C18.5037 15.1003 16.3045 14.028 15.3731 14.6057C14.5109 15.1405 14.4807 15.7966 14.4566 16.3194C14.4504 16.455 14.4446 16.5816 14.4248 16.6948C14.3833 16.9316 14.2858 17.0103 14.1486 17.1209C13.9673 17.2671 13.7169 17.4691 13.4352 18.1653C13.0611 19.0902 13.5415 19.9324 13.8739 20.2928ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" })), Ede = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM11.9999 10.2617C12.4475 10.2617 12.8103 10.6245 12.8103 11.072L12.8103 16.1959C12.8103 16.6434 12.4475 17.0062 12 17.0062C11.5525 17.0062 11.1897 16.6434 11.1897 16.1959L11.1896 11.072C11.1896 10.6245 11.5524 10.2617 11.9999 10.2617ZM10.8049 8.19507C10.8049 7.53505 11.34 7 12 7C12.66 7 13.1951 7.53505 13.1951 8.19507C13.1951 8.85509 12.66 9.39014 12 9.39014C11.34 9.39014 10.8049 8.85509 10.8049 8.19507Z" })), yde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM13.5 16.7996C13.5 17.628 12.8284 18.2996 12 18.2996C11.1716 18.2996 10.5 17.628 10.5 16.7996C10.5 15.9712 11.1716 15.2996 12 15.2996C12.8284 15.2996 13.5 15.9712 13.5 16.7996ZM12 14.2004C11.4477 14.2004 11 13.7534 11 13.2019V6.69881C11 6.14739 11.4477 5.70038 12 5.70038C12.5523 5.70038 13 6.14739 13 6.69881V13.2019C13 13.7534 12.5523 14.2004 12 14.2004Z" })), vde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM8.27674 11.3584C7.98188 11.0674 7.50701 11.0707 7.2161 11.3655C6.92519 11.6604 6.9284 12.1352 7.22326 12.4262L10.6364 15.7839C10.9267 16.0704 11.3928 16.0723 11.6854 15.7882L17.2158 10.5C17.513 10.2115 17.5201 9.73669 17.2316 9.43946C16.9431 9.14223 16.4683 9.13514 16.1711 9.42363L11.1674 14.2007L8.27674 11.3584Z" })), Tde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("rect", { x: 3, y: 5, width: 18, height: 1.5, rx: 0.75 }), /* @__PURE__ */ ht.createElement("rect", { x: 3, y: 11.25, width: 18, height: 1.5, rx: 0.75 }), /* @__PURE__ */ ht.createElement("rect", { x: 3, y: 17.5, width: 18, height: 1.5, rx: 0.75 })), bde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.4943 10.9414C6.16477 10.3145 6 9.63672 6 8.90816V7.09184C6 6.34633 6.16477 5.66012 6.4943 5.03321C6.83953 4.40631 7.30245 3.91495 7.88305 3.55913C8.46366 3.18638 9.09919 3 9.78965 3C10.4801 3 11.1156 3.18638 11.6962 3.55913C12.2768 3.91495 12.7319 4.40631 13.0615 5.03321C13.4067 5.66012 13.5793 6.34633 13.5793 7.09184V8.90816C13.5793 9.63672 13.4067 10.3145 13.0615 10.9414C12.7319 11.5683 12.2768 12.0681 11.6962 12.4409C11.1156 12.8136 10.4801 13 9.78965 13C9.09919 13 8.46366 12.8136 7.88305 12.4409C7.30245 12.0681 6.83953 11.5683 6.4943 10.9414ZM13.8644 14.5957C12.7194 14.1986 11.4313 14 10 14C8.56874 14 7.2806 14.1986 6.13559 14.5957C5.17137 14.9267 4.33522 15.3901 3.62712 15.9858C3.03955 16.4657 2.58757 16.987 2.27119 17.5496C2.0904 17.8972 2 18.3522 2 18.9149C2 19.4775 2.18079 19.9657 2.54237 20.3794C2.91902 20.7931 3.371 21 3.89831 21H16.1017C16.629 21 17.0734 20.7931 17.435 20.3794C17.8117 19.9657 18 19.4775 18 18.9149C18 18.3522 17.9096 17.8972 17.7288 17.5496C17.4124 16.987 16.9605 16.4657 16.3729 15.9858C15.6648 15.3901 14.8286 14.9267 13.8644 14.5957ZM16.6432 7.65462C16.2124 7.65462 15.8632 8.00384 15.8632 8.43464C15.8632 8.86543 16.2124 9.21466 16.6432 9.21466L21.2238 9.21466C21.6546 9.21466 22.0038 8.86543 22.0038 8.43464C22.0038 8.00384 21.6546 7.65462 21.2238 7.65462L16.6432 7.65462Z" })), Ade = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.53496 3.16182H15.4824C16.5526 3.16182 17.5417 3.7319 18.0782 4.6579L21.5659 10.6777C22.1052 11.6085 22.1048 12.7569 21.5648 13.6874L18.0785 19.6949C17.5417 20.6198 16.5532 21.1891 15.4837 21.1891H8.53639C7.46359 21.1891 6.47245 20.6162 5.93691 19.6867L2.46888 13.6669C1.93447 12.7392 1.93488 11.5971 2.46994 10.6699L5.93654 4.66241C6.47235 3.73387 7.46292 3.16182 8.53496 3.16182ZM12 17.1891C14.7614 17.1891 17 14.9505 17 12.1891C17 9.42768 14.7614 7.1891 12 7.1891C9.23858 7.1891 7 9.42768 7 12.1891C7 14.9505 9.23858 17.1891 12 17.1891Z" })), Ode = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { d: "M13.8237 15.5557C13.8754 15.5557 14.1849 15.2833 14.2881 15.2288C14.4945 15.1198 14.6493 15.0109 14.8041 14.9564C15.8876 14.466 16.8163 14.7929 18.0547 16.3731C18.8286 17.3538 19.035 18.1712 18.777 18.934C18.5706 19.4789 18.1063 19.9148 17.3839 20.3507C17.3323 20.4052 16.9195 20.6776 16.7647 20.7321C15.0105 21.8764 10.9343 19.2609 7.99333 14.6839C5.05231 10.1614 4.27837 5.31201 6.08425 4.11328L6.34223 3.94982L6.60022 3.78635C7.52896 3.18698 8.09651 2.91454 8.76727 3.02351C9.43803 3.13249 10.0572 3.67737 10.5216 4.65816C11.5535 6.72869 11.3471 7.70948 10.0056 8.63578C9.9024 8.69027 9.54123 8.90822 9.54123 8.96271C9.23164 9.18066 9.74761 10.6518 11.0891 12.6134C12.379 14.6839 13.4626 15.8282 13.8237 15.5557Z" })), Cde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.88889 5C2.84568 5 2 5.84568 2 6.88889V17.1111C2 18.1543 2.84568 19 3.88889 19H15.8611C16.9043 19 17.75 18.1543 17.75 17.1111V15.3089L21.0178 17.1244C21.4585 17.3692 22 17.0505 22 16.5464V7.46025C22 6.95616 21.4585 6.63753 21.0178 6.88233L17.75 8.69779V6.88889C17.75 5.84568 16.9043 5 15.8611 5H3.88889ZM5.5 10C6.32843 10 7 9.32843 7 8.5C7 7.67157 6.32843 7 5.5 7C4.67157 7 4 7.67157 4 8.5C4 9.32843 4.67157 10 5.5 10Z" })), F9 = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H12.75V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V12.75H7C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H11.25V7C11.25 6.58579 11.5858 6.25 12 6.25Z" })), Sde = (t) => /* @__PURE__ */ ht.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H12.75V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V12.75H7C6.58579 12.75 6.25 12.4142 6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H11.25V7C11.25 6.58579 11.5858 6.25 12 6.25Z" })), Ide = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.28446 11.4073C5.57537 11.1125 6.05023 11.1092 6.3451 11.4002L9.94385 14.9507L17.6596 7.46183C17.9568 7.17334 18.4317 7.18043 18.7202 7.47766C19.0086 7.77489 19.0016 8.24971 18.7043 8.5382L10.4619 16.5382C10.1692 16.8223 9.70318 16.8204 9.41283 16.5339L5.29162 12.468C4.99676 12.177 4.99355 11.7022 5.28446 11.4073Z" })), Rde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.48231 11.3913C3.78202 11.1054 4.25676 11.1166 4.54267 11.4163L7.89528 14.9307L7.92492 14.9015C8.21995 14.6108 8.69481 14.6142 8.98555 14.9093C9.2763 15.2043 9.27282 15.6792 8.9778 15.9699L8.40522 16.5342C8.26204 16.6753 8.06821 16.753 7.86721 16.7499C7.66621 16.7468 7.47487 16.6631 7.33611 16.5177L3.45733 12.4517C3.17141 12.152 3.1826 11.6773 3.48231 11.3913ZM10.7724 13.0278C10.4747 12.7398 10.4668 12.265 10.7548 11.9673L15.0973 7.47851C15.3853 7.18081 15.8601 7.17294 16.1578 7.46094C16.4555 7.74894 16.4634 8.22375 16.1754 8.52146L11.8329 13.0102C11.5449 13.3079 11.0701 13.3158 10.7724 13.0278Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.10282 11.4073C7.39373 11.1124 7.86859 11.1092 8.16346 11.4001L11.7622 14.9506L19.478 7.4618C19.7752 7.17331 20.25 7.1804 20.5385 7.47763C20.827 7.77486 20.8199 8.24968 20.5227 8.53817L12.2803 16.5382C11.9876 16.8222 11.5215 16.8203 11.2312 16.5339L7.10998 12.4679C6.81512 12.177 6.81191 11.7021 7.10282 11.4073Z" })), Nde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5.37143C8.33914 5.37143 5.37143 8.33914 5.37143 12C5.37143 15.6609 8.33914 18.6286 12 18.6286C15.6609 18.6286 18.6286 15.6609 18.6286 12C18.6286 8.33914 15.6609 5.37143 12 5.37143ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z" }), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8103 11.072C12.8103 10.6245 12.4475 10.2617 11.9999 10.2617C11.5524 10.2617 11.1896 10.6245 11.1896 11.072L11.1897 16.1959C11.1897 16.6434 11.5525 17.0062 12 17.0062C12.4475 17.0062 12.8103 16.6434 12.8103 16.1959L12.8103 11.072ZM12 7C11.34 7 10.8049 7.53505 10.8049 8.19507C10.8049 8.85509 11.34 9.39014 12 9.39014C12.66 9.39014 13.1951 8.85509 13.1951 8.19507C13.1951 7.53505 12.66 7 12 7Z" })), wde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "icons/pin" }, /* @__PURE__ */ ht.createElement("g", { id: "Union" }, /* @__PURE__ */ ht.createElement("mask", { id: "path-1-inside-1_241_2072" }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.56252 13.48C12.5938 13.1755 14.9602 10.6167 14.9602 7.50517C14.9602 4.18861 12.2716 1.5 8.95506 1.5C5.6385 1.5 2.94989 4.18861 2.94989 7.50517C2.94989 10.6474 5.36325 13.2259 8.43752 13.4884V15.9375C8.43752 16.2482 8.68935 16.5 9.00002 16.5C9.31068 16.5 9.56252 16.2482 9.56252 15.9375V13.48ZM11.8055 5.30327C11.8055 6.07713 11.1782 6.70447 10.4043 6.70447C9.63042 6.70447 9.00308 6.07713 9.00308 5.30327C9.00308 4.5294 9.63042 3.90206 10.4043 3.90206C11.1782 3.90206 11.8055 4.5294 11.8055 5.30327Z" })), /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.56252 13.48C12.5938 13.1755 14.9602 10.6167 14.9602 7.50517C14.9602 4.18861 12.2716 1.5 8.95506 1.5C5.6385 1.5 2.94989 4.18861 2.94989 7.50517C2.94989 10.6474 5.36325 13.2259 8.43752 13.4884V15.9375C8.43752 16.2482 8.68935 16.5 9.00002 16.5C9.31068 16.5 9.56252 16.2482 9.56252 15.9375V13.48ZM11.8055 5.30327C11.8055 6.07713 11.1782 6.70447 10.4043 6.70447C9.63042 6.70447 9.00308 6.07713 9.00308 5.30327C9.00308 4.5294 9.63042 3.90206 10.4043 3.90206C11.1782 3.90206 11.8055 4.5294 11.8055 5.30327Z" }), /* @__PURE__ */ ht.createElement("path", { d: "M9.56252 13.48L9.46256 12.485L8.56252 12.5754V13.48H9.56252ZM8.43752 13.4884H9.43752V12.5701L8.52257 12.492L8.43752 13.4884ZM9.66247 14.475C13.1996 14.1197 15.9602 11.1354 15.9602 7.50517H13.9602C13.9602 10.0979 11.988 12.2313 9.46256 12.485L9.66247 14.475ZM15.9602 7.50517C15.9602 3.63632 12.8239 0.5 8.95506 0.5V2.5C11.7193 2.5 13.9602 4.74089 13.9602 7.50517H15.9602ZM8.95506 0.5C5.08621 0.5 1.94989 3.63632 1.94989 7.50517H3.94989C3.94989 4.74089 6.19078 2.5 8.95506 2.5V0.5ZM1.94989 7.50517C1.94989 11.1712 4.76521 14.1785 8.35246 14.4847L8.52257 12.492C5.96129 12.2733 3.94989 10.1236 3.94989 7.50517H1.94989ZM9.43752 15.9375V13.4884H7.43752V15.9375H9.43752ZM9.00002 15.5C9.24164 15.5 9.43752 15.6959 9.43752 15.9375H7.43752C7.43752 16.8004 8.13707 17.5 9.00002 17.5V15.5ZM8.56252 15.9375C8.56252 15.6959 8.75839 15.5 9.00002 15.5V17.5C9.86296 17.5 10.5625 16.8004 10.5625 15.9375H8.56252ZM8.56252 13.48V15.9375H10.5625V13.48H8.56252ZM10.4043 7.70447C11.7304 7.70447 12.8055 6.62942 12.8055 5.30327H10.8055C10.8055 5.52485 10.6259 5.70447 10.4043 5.70447V7.70447ZM8.00308 5.30327C8.00308 6.62942 9.07814 7.70447 10.4043 7.70447V5.70447C10.1827 5.70447 10.0031 5.52485 10.0031 5.30327H8.00308ZM10.4043 2.90206C9.07814 2.90206 8.00308 3.97712 8.00308 5.30327H10.0031C10.0031 5.08169 10.1827 4.90206 10.4043 4.90206V2.90206ZM12.8055 5.30327C12.8055 3.97712 11.7304 2.90206 10.4043 2.90206V4.90206C10.6259 4.90206 10.8055 5.08169 10.8055 5.30327H12.8055Z", mask: "url(#path-1-inside-1_241_2072)" })))), _de = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 16, height: 18, viewBox: "0 0 16 18", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "Group 237777" }, /* @__PURE__ */ ht.createElement("path", { id: "Subtract", fillRule: "evenodd", clipRule: "evenodd", d: "M13.0677 4.11225C13.0678 4.11227 13.0678 4.1123 13.0678 4.11232L3.79471 13.3831C3.79469 13.3831 3.79466 13.383 3.79464 13.383L13.0677 4.11225ZM11.6397 2.59418C10.5105 1.71783 9.09231 1.19611 7.5523 1.19611C3.86722 1.19611 0.879883 4.18345 0.879883 7.86852C0.879883 9.40793 1.4012 10.8256 2.27693 11.9546L11.6397 2.59418ZM4.53499 13.8213C5.44112 14.2815 6.46642 14.5409 7.5523 14.5409C11.2374 14.5409 14.2247 11.5536 14.2247 7.86852C14.2247 6.78324 13.9656 5.75847 13.5059 4.85271L4.53499 13.8213Z" }), /* @__PURE__ */ ht.createElement("path", { id: "Line 20 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M1.14122 15.1289C0.89714 14.8848 0.89714 14.489 1.14122 14.245L13.9753 1.41408C14.2193 1.17001 14.6151 1.17001 14.8591 1.41408C15.1032 1.65816 15.1032 2.05389 14.8591 2.29797L2.0251 15.1289C1.78102 15.3729 1.3853 15.3729 1.14122 15.1289Z" }), /* @__PURE__ */ ht.createElement("path", { id: "Rectangle 81", d: "M6.97754 11.9858C6.97754 11.6406 7.25736 11.3608 7.60254 11.3608V11.3608C7.94772 11.3608 8.22754 11.6406 8.22754 11.9858V16.4044C8.22754 16.7496 7.94772 17.0294 7.60254 17.0294V17.0294C7.25736 17.0294 6.97754 16.7496 6.97754 16.4044V11.9858Z" }))), Pde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("g", { id: "icons/arrowshape_left" }, /* @__PURE__ */ ht.createElement("path", { id: "Vector 680", d: "M8.68944 3.79782L2.77053 9.37351C2.40982 9.71329 2.40982 10.2867 2.77053 10.6265L8.68944 16.2022C8.96402 16.4608 9.41487 16.2662 9.41487 15.8889V12.5735C12.3977 12.4352 14.8254 13.5123 16.6812 15.6747C16.9643 16.0045 17.5445 15.8151 17.4973 15.3831C16.8909 9.83085 12.9766 7.41374 9.41487 7.41374V4.11107C9.41487 3.73384 8.96402 3.53916 8.68944 3.79782Z" }))), xde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C9.1005 3 6.75 5.35051 6.75 8.25V8.59451C5.45608 8.92755 4.5 10.1021 4.5 11.5V17.5C4.5 19.1569 5.84315 20.5 7.5 20.5H16.5C18.1569 20.5 19.5 19.1569 19.5 17.5V11.5C19.5 10.1021 18.5439 8.92755 17.25 8.59451V8.25C17.25 5.35051 14.8995 3 12 3ZM15.75 8.5V8.25C15.75 6.17893 14.0711 4.5 12 4.5C9.92893 4.5 8.25 6.17893 8.25 8.25V8.5H15.75ZM12.75 14.2993C13.1984 14.04 13.5 13.5552 13.5 13C13.5 12.1716 12.8284 11.5 12 11.5C11.1716 11.5 10.5 12.1716 10.5 13C10.5 13.5552 10.8016 14.04 11.25 14.2993V16.75C11.25 17.1642 11.5858 17.5 12 17.5C12.4142 17.5 12.75 17.1642 12.75 16.75V14.2993Z" })), Dde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 12.734 19.9012 13.4448 19.7161 14.1201C19.0505 13.6258 18.2261 13.3333 17.3335 13.3333C15.1243 13.3333 13.3335 15.1242 13.3335 17.3333C13.3335 18.2261 13.6259 19.0505 14.1202 19.716C13.445 19.9011 12.734 20 12 20C7.58172 20 4 16.4183 4 12ZM17.3333 20C18.8061 20 20 18.8061 20 17.3333C20 15.8606 18.8061 14.6667 17.3333 14.6667C15.8606 14.6667 14.6667 15.8606 14.6667 17.3333C14.6667 18.8061 15.8606 20 17.3333 20Z" })), Mde = (t) => /* @__PURE__ */ ht.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ ht.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.08459 4.46013C9.54401 4.15338 10.0469 4 10.5932 4C11.1395 4 11.6424 4.15338 12.1018 4.46013C12.5612 4.75294 12.9213 5.1573 13.1821 5.6732C13.4552 6.18911 13.5918 6.75381 13.5918 7.36732V9.39608C13.5918 9.99564 13.4552 10.5534 13.1821 11.0693C12.9213 11.5852 12.5612 11.9965 12.1018 12.3033C11.6424 12.61 11.1395 12.7634 10.5932 12.7634C10.0469 12.7634 9.54401 12.61 9.08459 12.3033C8.62518 11.9965 8.25889 11.5852 7.98572 11.0693C7.72498 10.5534 7.5946 9.99564 7.5946 9.39608V7.36732C7.5946 6.75381 7.72498 6.18911 7.98572 5.6732C8.25889 5.1573 8.62518 4.75294 9.08459 4.46013ZM5.56449 20H10.5932H15.6219C16.0565 20 16.4228 19.8257 16.7208 19.4771C17.0312 19.1285 17.1864 18.7172 17.1864 18.2431C17.1864 17.7691 17.1119 17.3856 16.9629 17.0928C16.7022 16.6187 16.3297 16.1795 15.8454 15.7752C15.2618 15.2732 14.5727 14.8828 13.7781 14.6039C12.8344 14.2693 11.7728 14.102 10.5932 14.102C9.41363 14.102 8.35201 14.2693 7.40835 14.6039C6.61369 14.8828 5.92457 15.2732 5.34099 15.7752C4.85674 16.1795 4.48425 16.6187 4.2235 17.0928C4.0745 17.3856 4 17.7691 4 18.2431C4 18.7172 4.149 19.1285 4.447 19.4771C4.75741 19.8257 5.12991 20 5.56449 20ZM18.5 10.635C19.7081 10.635 20.6875 9.61638 20.6875 8.35989C20.6875 7.97505 20.5956 7.61253 20.4334 7.29476L17.4759 10.3707C17.7814 10.5394 18.13 10.635 18.5 10.635ZM18.5 6.08482C18.8601 6.08482 19.1999 6.17532 19.4995 6.33565L16.5537 9.39939C16.3995 9.08781 16.3125 8.73442 16.3125 8.35989C16.3125 7.10341 17.2919 6.08482 18.5 6.08482ZM22 8.35989C22 10.3703 20.433 12 18.5 12C16.567 12 15 10.3703 15 8.35989C15 6.34951 16.567 4.71978 18.5 4.71978C20.433 4.71978 22 6.34951 22 8.35989Z" })), G9 = (t) => {
  switch (t) {
    case "SHUT_DOWN":
      break;
    case "STAR":
      return /* @__PURE__ */ q.jsx(Zce, {});
    case "DONE_ALL":
      return /* @__PURE__ */ q.jsx(Qce, {});
    case "CLOSE":
      return /* @__PURE__ */ q.jsx($ce, {});
    case "FILE":
      return /* @__PURE__ */ q.jsx(eue, {});
    case "USER":
      return /* @__PURE__ */ q.jsx(tue, {});
    case "PLAY":
      return /* @__PURE__ */ q.jsx(nue, {});
    case "ELLIPSIS":
      return /* @__PURE__ */ q.jsx(rue, {});
    case "LOADING":
      return /* @__PURE__ */ q.jsx(iue, {});
    case "DOC":
      return /* @__PURE__ */ q.jsx(sue, {});
    case "WAVE1":
      return /* @__PURE__ */ q.jsx(aue, {});
    case "WAVE2":
      return /* @__PURE__ */ q.jsx(oue, {});
    case "WAVE3":
      return /* @__PURE__ */ q.jsx(cue, {});
    case "CIRCLE_WAVE":
      return /* @__PURE__ */ q.jsx(uue, {});
    case "PLAY_VIDEO":
      return /* @__PURE__ */ q.jsx(due, {});
    case "FACE":
      return /* @__PURE__ */ q.jsx(lue, {});
    case "CROSS":
      return /* @__PURE__ */ q.jsx(fue, {});
    case "AIR_PLANE":
      return /* @__PURE__ */ q.jsx(pue, {});
    case "ARROW_RIGHT":
      return /* @__PURE__ */ q.jsx(gue, {});
    case "ARROW_LEFT":
      return /* @__PURE__ */ q.jsx(mue, {});
    case "ARROW_UP":
      return /* @__PURE__ */ q.jsx(Eue, {});
    case "ARROW_DOWN":
      return /* @__PURE__ */ q.jsx(vue, {});
    case "PLUS_CIRCLE":
      return /* @__PURE__ */ q.jsx(F9, {});
    case "SEARCH":
      return /* @__PURE__ */ q.jsx(bue, {});
    case "DELETE":
      return /* @__PURE__ */ q.jsx(Aue, {});
    case "CLOSE_CIRCLE":
      return /* @__PURE__ */ q.jsx(Oue, {});
    case "CLOSE_THIN":
      return /* @__PURE__ */ q.jsx(hue, {});
    case "IMG":
      return /* @__PURE__ */ q.jsx(Cue, {});
    case "ARROW_TURN_LEFT":
      return /* @__PURE__ */ q.jsx(Sue, {});
    case "ARROW_TURN_RIGHT":
      return /* @__PURE__ */ q.jsx(Iue, {});
    case "ARROW_UP_THICK":
      return /* @__PURE__ */ q.jsx(yue, {});
    case "ARROW_DOWN_THICK":
      return /* @__PURE__ */ q.jsx(Tue, {});
    case "ARROW_BACK":
      return /* @__PURE__ */ q.jsx(Nue, {});
    case "FACE_PLUS":
      return /* @__PURE__ */ q.jsx(Rue, {});
    case "TRANSLATION":
      return /* @__PURE__ */ q.jsx(wue, {});
    case "MODIFY_MESSAGE":
      return /* @__PURE__ */ q.jsx(_ue, {});
    case "FORWARD_LIST":
      return /* @__PURE__ */ q.jsx(Pue, {});
    case "TIME":
      return /* @__PURE__ */ q.jsx(xue, {});
    case "SELECT":
      return /* @__PURE__ */ q.jsx(Due, {});
    case "GO_TO_CHAT":
      return /* @__PURE__ */ q.jsx(Mue, {});
    case "ADD_FRIEND":
      return /* @__PURE__ */ q.jsx(z9, {});
    case "PERSON_DOUBLE_FILL":
      return /* @__PURE__ */ q.jsx(Lue, {});
    case "PERSON_SINGLE_FILL":
      return /* @__PURE__ */ q.jsx(kue, {});
    case "THREAD":
      return /* @__PURE__ */ q.jsx(jue, {});
    case "HASHTAG_IN_BUBBLE_FILL":
      return /* @__PURE__ */ q.jsx(Uue, {});
    case "ENVELOPE":
      return /* @__PURE__ */ q.jsx(Hue, {});
    case "MEMBER_GROUP":
      return /* @__PURE__ */ q.jsx(Bue, {});
    case "LOOP":
      return /* @__PURE__ */ q.jsx(B9, {});
    case "CAMERA_ARROW":
      return /* @__PURE__ */ q.jsx(zue, {});
    case "MIC":
      return /* @__PURE__ */ q.jsx(Fue, {});
    case "GIFT":
      return /* @__PURE__ */ q.jsx(Gue, {});
    case "BELL":
      return /* @__PURE__ */ q.jsx(Vue, {});
    case "BELL_SLASH":
      return /* @__PURE__ */ q.jsx(Yue, {});
    case "EMPTY":
      return /* @__PURE__ */ q.jsx(Xue, {});
    case "MOON":
      return /* @__PURE__ */ q.jsx(Wue, {});
    case "SUN":
      return /* @__PURE__ */ q.jsx(que, {});
    case "VIDEO_CAMERA_PLUS":
      return /* @__PURE__ */ q.jsx(Que, {});
    case "VIDEO_CAMERA_XMARK":
      return /* @__PURE__ */ q.jsx($ue, {});
    case "POWER":
      return /* @__PURE__ */ q.jsx(Kue, {});
    case "SPINNER":
      return /* @__PURE__ */ q.jsx(Jue, {});
    case "VERTICAL_ARROW":
      return /* @__PURE__ */ q.jsx(Zue, {});
    case "BUBBLE_FILL":
      return /* @__PURE__ */ q.jsx(ede, {});
    case "EXCLAMATION_MARK_IN_CIRCLE":
      return /* @__PURE__ */ q.jsx(tde, {});
    case "LINE_ARROW":
      return /* @__PURE__ */ q.jsx(nde, {});
    case "ARROW_LINE":
      return /* @__PURE__ */ q.jsx(rde, {});
    case "DOC_ON_DOC":
      return /* @__PURE__ */ q.jsx(ide, {});
    case "PERSON_SINGLE_LINE_FILL":
      return /* @__PURE__ */ q.jsx(sde, {});
    case "SLASH_IN_BOX":
      return /* @__PURE__ */ q.jsx(ade, {});
    case "ERASER":
      return /* @__PURE__ */ q.jsx(ode, {});
    case "ARROW_RIGHT_SQUARE_FILL":
      return /* @__PURE__ */ q.jsx(cde, {});
    case "ARROWS_ROUND":
      return /* @__PURE__ */ q.jsx(B9, {});
    case "PERSON_ADD":
      return /* @__PURE__ */ q.jsx(ude, {});
    case "PERSON_MINUS":
      return /* @__PURE__ */ q.jsx(dde, {});
    case "TRIANGLE_IN_RECTANGLE_FILL":
      return /* @__PURE__ */ q.jsx(lde, {});
    case "SPEAKER_N_VERTICAL_BAR":
      return /* @__PURE__ */ q.jsx(fde, {});
    case "ROUND_ARROW_THICK":
      return /* @__PURE__ */ q.jsx(hde, {});
    case "TRIANGLE_IN_RECTANGLE":
      return /* @__PURE__ */ q.jsx(pde, {});
    case "FOLDER":
      return /* @__PURE__ */ q.jsx(gde, {});
    case "GLOBE":
      return /* @__PURE__ */ q.jsx(mde, {});
    case "CANDLE_IN_CIRCLE_FILL":
      return /* @__PURE__ */ q.jsx(Ede, {});
    case "EXCLAMATION_MARK_IN_CIRCLE_FILL":
      return /* @__PURE__ */ q.jsx(yde, {});
    case "CHECK_IN_CIRCLE_FILL":
      return /* @__PURE__ */ q.jsx(vde, {});
    case "HAMBURGER":
      return /* @__PURE__ */ q.jsx(Tde, {});
    case "PERSON_MINUS_FILL":
      return /* @__PURE__ */ q.jsx(bde, {});
    case "GEAR":
      return /* @__PURE__ */ q.jsx(Ade, {});
    case "PHONE_PICK":
      return /* @__PURE__ */ q.jsx(Ode, {});
    case "VIDEO_CAMERA":
      return /* @__PURE__ */ q.jsx(Cde, {});
    case "PLUS_IN_CIRCLE":
      return /* @__PURE__ */ q.jsx(F9, {});
    case "PLUS_IN_CIRCLE_FILL":
      return /* @__PURE__ */ q.jsx(Sde, {});
    case "CHECK":
      return /* @__PURE__ */ q.jsx(Ide, {});
    case "CHECK2":
      return /* @__PURE__ */ q.jsx(Rde, {});
    case "CANDLE_IN_CIRCLE":
      return /* @__PURE__ */ q.jsx(Nde, {});
    case "PERSON_ADD_FILL":
      return /* @__PURE__ */ q.jsx(z9, {});
    case "PIN":
      return /* @__PURE__ */ q.jsx(wde, {});
    case "UNPIN":
      return /* @__PURE__ */ q.jsx(_de, {});
    case "ARROW_TO":
      return /* @__PURE__ */ q.jsx(Pde, {});
    case "LOCK":
      return /* @__PURE__ */ q.jsx(xde, {});
    case "CIRCLE_N_DOT":
      return /* @__PURE__ */ q.jsx(Dde, {});
    case "PERSON_SLASH_FILL":
      return /* @__PURE__ */ q.jsx(Mde, {});
  }
}, pn = ({
  className: t = "",
  type: r,
  children: a,
  width: u,
  height: h,
  color: b,
  onClick: l,
  style: v,
  ...s
}) => {
  const { getPrefixCls: c } = _t.useContext(Hn), d = c("icon"), { theme: p } = _t.useContext(Vn), m = p == null ? void 0 : p.mode, E = {
    width: typeof u == "string" ? u : `${u}px`,
    minWidth: typeof u == "string" ? u : `${u}px`,
    height: typeof h == "string" ? h : `${h}px`,
    minHeight: typeof h == "string" ? h : `${h}px`,
    lineHeight: typeof h == "string" ? h : `${h}px`,
    fill: b
  };
  Vl(G9(r), (g) => ({
    style: {
      ...E,
      ...g.style
    }
  }));
  const y = (g) => {
    l && l(g);
  };
  return /* @__PURE__ */ q.jsx(
    "div",
    {
      className: En(
        d,
        {
          [`${d}-${m}`]: !!m
        },
        t
      ),
      onClick: y,
      style: {
        ...E,
        ...v
      },
      ...s,
      children: a || G9(r)
    }
  );
}, Lde = (t) => {
  const { getPrefixCls: r } = _t.useContext(Hn), a = Zn(Vn), { theme: u } = a, h = (u == null ? void 0 : u.mode) || "light";
  let b;
  const {
    status: l = "default",
    type: v = "icon",
    prefixCls: s,
    className: c,
    style: d
  } = t, p = r("message-status", s), m = En(
    p,
    {
      [`${p}-icon`]: v == "icon",
      [`${p}-text`]: v == "text"
    },
    c
  );
  switch (l) {
    case "sending":
      b = v == "icon" ? /* @__PURE__ */ q.jsx("img", { alt: "sending", src: Wce }) : "发送中";
      break;
    case "sent":
      b = v == "icon" ? /* @__PURE__ */ q.jsx(pn, { type: "CHECK", width: 20, height: 20 }) : "已发送";
      break;
    case "received":
      b = v == "icon" ? /* @__PURE__ */ q.jsx(pn, { type: "CHECK2", width: 20, height: 20 }) : "已送达";
      break;
    case "read":
      b = v == "icon" ? /* @__PURE__ */ q.jsx(
        pn,
        {
          type: "CHECK2",
          width: 20,
          height: 20,
          color: h == "light" ? "#00CC77" : "#00FF95"
        }
      ) : "已读";
      break;
    case "unread":
      b = v == "icon" ? /* @__PURE__ */ q.jsx("span", {}) : "未读";
      break;
    case "failed":
      b = v == "icon" ? /* @__PURE__ */ q.jsx(pn, { type: "CANDLE_IN_CIRCLE", width: 20, height: 20, color: "#FF002B" }) : "发送失败";
      break;
    default:
      b = null;
      break;
  }
  return /* @__PURE__ */ q.jsx("span", { className: m, style: d, children: b });
}, lg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR6SURBVHgB7ZfLbxtVFMa/mfHM+JE0bkMSJTjpREhxVIL6YEHYWSCxQYgi2gUryF9QWKYb3EXXTXchG7LoggUSZQcrglhXYgECREWsRkogTkLTxsaTsedyzszcGY9dEttxkRD9JHvuvH8+5zvnXgPP9B+Tgn9B65aVTcMoKFAsFTgvIC7QOCsAi8+PlH4JORJ4SmKIARjX6DcXaLcgjwvvWwm27eo70JY1W0hAfNwM0azDTBJm+i8oIwHaKRcoPQWgCEQUWgGSMxVoOXpxTsAw7fabP+sjEIFYBPJpDMQUcPIm0gRi5OyunncioF0rf40MWqTgZyWIdtGFerFBkTiMXaskVOhnhqAOJKEaOrRMyj+e1NGcs56Bylb+FiXhQ7nvWAbSrx2QJ0QMwhh/DomhDDT6dKKugbh6MjDWaHjeO0BRcV/XkZl5HF6jmjrMqTHoo9m2+6t1gbLt4kHF9X9Yze0diP2iQ3wj+wdXSuIth6Lip4cjYk6OwZgYjt33034dPz9q0Nb/HKWOgVph6nkDKU6R6aeI05KanSIoLbzn3q6Dr7ecYyF6AtLg3hVQLG98jkz7RpQiPH8WaWsw3OWIrNyvYacWb3+V2mk8qo6hYmdxUMui0TBgO+ytb7sDYgMj8AxHRsJwipLTE+QVH4b98cWGja82nfDeuqtja3cW2/vTwcuP1rFA29bsB9Rj/GqiCuI0SZjM3DTUoHx3yJw3f6yGUZEgW3t5b9ysQag4Ax0GTSE8/q1TIPaNSt1XBDD6FSf0DEdGwnDF3Pyh6kWIxWn5dfOVWETGCcAihLMwPYhmfd4pENmzKE2cmG+EPcacHA1LuhVmY2cOG+WXYiAvI+1tO9E/Av1hzVymOfl9HqtkYv6wDAIxp0a9sZemJpj7m/OeVzxoisIlpDCHVOuj14QQXyoqvqfXlxaX3yl1BKRBuSVrRJv3YbyGN+nDMAR75kkwg3T3mzjlbT0JPIQqbtvJg6Xi0sJDHKEnApVp5qY5ykIQnTBV1H2VpOGN76zboYE5TRJmmB7JMKb0icBdO/144TiQI4EUaWTEoyN9ww3vu22/tPcOcqFnZGQkDKXmo+srV5fQhdqAuLJEsJRojY7UnZK/pOAqWv/9kn+eIGKRUZSF659cWUWXUlsPkHcuhyfPtUeHIyNT1dzs5qmSIs+IG4vL766iB6ntB9y3vQFFRs1F85SUTBWDyFSxb2aQlJesLq5cLaJHxYD+pKWFCNbCai5aFuijp70tl7mcKLn5Sb2KAJirSXFu4ASKAdWRvBCeeMEH4nTJxdW9vXp47YPynLflNEVNT6wuLr9XQr+A3KZ/Cs646V8wEDU2CcSztfTOi1Gq6OL6bZxQLR4SfoSIhf+qsLR09MIwXZUoXRPRlLB20ui0AVGNDPFWGYn8ow1EE6jUftXv1jxbDwedg6cD9EGtVWZ532Z0QNH8Syr1CKje8Lv1cFMbU1yem/oMJGd2JxMRqab/8rIdrf4OA/8MIFqu2olECf0GCh+up9Ctii2z9jP9b/Q34bGwu6GsY/0AAAAASUVORK5CYII=", fg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANgSURBVHgB7VhPTxNBFP/NlkpTBDlAYkKiJUahUUONGr3ZXj3pF9D6BYwejCaGdEvjyYMxxjN69gDfwJJ4kRipB6XAoSumCQqRiqGxpZ3xzfbfsuxuS3fhor9k0n0zs9tf3nvz/gzwH85gcAGRUwdR6olDERMkhlCt3mFhVYML9KALiBU1CuFLoIwomKAJmmTKBRae1OAS+yKka2RHSYCze7sWOJIs/DgDD9CxycSiGoKivKVXQqYljY1NjsIjdKQhsfwkAsGJDAb3LHKRhIdQ2m3QNSOqM00y5e9AabWxXECAz8JDOBLSfcZsJr4FVDZrzwyzbFQtwEM4m0w6sJGMROB067kq5uAxbDVUM5XpNJnBuScnqyNCUHwq2oCdVQ+HkK4d4LZxbmt7BzNzq5j/stGY8tR3GrD2IZ8S1aNvHfkfRcST75BfL+ryo/h53Lp+6kAIWZtMsKhRnCXNNMhIvHyTlT8hkZ1y9jHPCDFMGMX+Pv+u5YFgXWbsmVhOTddNfICEBGVuA8g8+miQe/HginEvZXvfglfassxlYikl0A04YpTx03AB+8BYylOaoKH0AsFzRN2Hw4BNHKoUdDISvETiOtqgQAfhvlvtSFhriPVoYL2U4UuO2+rI4Eg15lVOs/4nzucQHI+gQkHQN0Cj3+kbIXgIa5MpLKP7zpGRdmRkBB+c//jTs3hkfcpk2VH25WAqyO4+fY/Fr78wMhxsBkoZxfV3GItlMx/ScAlLDen+IPhr8/xDShmXx/uRX9vUiTTI6O8IMT0euRqCS9jW1LUa2rcAo5bkiSt+psUKst92kN+oYKtIIStwEgN9AVwKD2nHgkrMTSvkWOSLpaRKSkw0J2TpWl7buzFwAvAfb0gaeLVrUo4lLBtLqES5VfM0w4AJvGyUpGZz3aaStkU+daM3iYlW2x20+YrFvEy8S6mcWJ6KYx/oqC9r9mSCh1Ck0oNvtxb9w2QyQ1vGydGrNPxDxk9odAyfQ6mk2RnnKrO7RrH6u+bgMlaZ49SfFWoOqCs5etEu/xXqbqCR9pNmX9v3ZYNYTKlk6ITtBklUlJ0DKkPa7mKiq9uPekhQ6emaRWvdhoi8B7BPwq6uYyTIcW9QkRYlrU3QbwStuEXJVpB5WJouJz6ht/LK66by38Rf9zxEcH6x0zwAAAAASUVORK5CYII=", hg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANrSURBVHgB7VdNTttQEP7GTummUs0NnEWrdlMM2XQZDlARJEDqiuQEKetKYNoLkBMQVpUKUkIvUA5QIK0qof5I5AZYoos2if067zmJHeLYCU7YtN8ict4bz3yemTczD/iPeFCSgPhuW3Dh0FO7OVLmfa4BDQ9x7S5SqeFEylzaBjqw6JF9ghhoiCXzpgihn0PTL8W3t5vRZJaKrGWBH0080F5Fyvzkd1v6FTz9o9J5W0LwYIT+7amvDBt699yERjv9BaKy2LcGZS5skz28FywIE7cmJLw6//ZCYKBFgx6Ya0mvmaEVY8hLmm6rdR8OPFHFbQmpvPHEVki83POS8o6g4RBJL8m9ACv9J9YVl4uJhHxS21VWVILvKQO/dUttZNo2MBDSHgzca6swih92visjPVNSupLsYUyoXND1fT4pFXz90ITmnce/QMt4tmKwhTJct5TkmYkJ9e0cWnmQXkO0d8JwOIF3af1sDxMguQ7VLBNt5AEOlX+885gMnIc4BokmJ1EDv4wGlU6csQkpDwi90DUu8yXJE5NDoMGW5YE5po2zajyho5zAXeLanQ9X9+FTJmgXdwW2dbPVROaQOMxVeWcTs4SHCm2cDtWxkUk9U1ICB7R+Wozaij1lMyJVp7XT1VGb8ZU640qXNjAtePjMSVyKExmnDhlw9UtM4/i33Sy9bDTjRDJRi90GqghQ1m6Kw6UKN80dpENVkmHdZk9vlBANkOhoZXZrkZfNkMQJvtQr/FRDGsgGba2WOaGt0KoskA3udbu9Xhd4qKWdDxDxwULaFoTLTVJHemicP24tZMdSBHVd/l9WEoEwDeaI4K4+xzPy49f8FXr6/CEYSpfnScMHN2yZvcfAQ567yOOonKEd3O9UOcZBBSUhhzGkgkYLSpUfmiKPMzYoUwBJ72fqAe8xII6WeISgMtJA4JiLYSFJLHFi9OF/XYy1Jvx65YxWgQQdkxGKyiFHNWLZrdfOssi9WOYKPN8dd5sR8ubNG0kKQsKKIJKl9U+27NbqrtXiuxuXDjnfMLFsJDED0yLEtSiCSMBXKyhzf7Rib6lPDFhV78uhzIkJae89TAF8q71ShARPgE+2ExM3DuN6aDSZC9UK/FAQjZW4mCUhrmRm6J+JlEhPqDOQuE2kRGpCqvLKNuPfTu9uHv9n8Rfyg1bKV8UEgwAAAABJRU5ErkJggg==", pg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJqSURBVHgB7ZdNi9NAGMefJy/tLlKo4kFBIT0UtnhovHppF9R6VFDwuH6Deiwe7J48Fu9C3bPC6k1EaPwEm5Pi9pCABRcPNlh1X5rmcdJuX7aZZGrZdj3kd0gn+c9MfukMmQlAzCmwq9/SLf2OBnNi6cV0U79ZnKWuJKrQzJe2gaSdLlGDiW3AP/JFv323SwmLSG7s5ksNUX2MCvsCJNWnLr9U8fBxxjScvjB7cgLUBp2RnTU/GH7Z/1dcL/mUEMonboi4njXfGTCXUL5ksR+NE9mA8j2gXo2Vi1OZSUibSFgLa8se6PrwgaYJHbKmXiqHdAj969Tb4cj46ExmO6rtESTKIVm4kOdRERYEEy6EZpMn9PmZ5rExR8C82+mmj77+1sMadoxv0Pm4x81ShUuQKl4OawqJq+dMJaU6bH7ZkseGN1exA0IDGYkNA6VhBn68sqD92uZm5+9rcOFBBmYDnV7PXU9ce2L6Z6MhI8T6rDKnC6UVWa4Nz8ZC/Am6FCbvPTGp0YGzwx4WxkLkPYczgoDeDssjITlXqbJg6VJEtKWsVUbvJWUy9AP3/UMTJLku7KnzJyL7DtT6BUIZdXVTLbyonnAI1HL2BAvKMfsyt/kg+wnQboMIpPHcCRfK3gBUVBDyqcUOLX52UQNcuwIiyPXY0YBooZWUvySDEEmJztRVEKJQsCn8Z8RCImIhEbGQiFhIRCwkIiDkeZ4JS4IguNoHhPzdP04vwQuAfVK/UXMVA0RC/crJA/aZTFuwQBlM7D/iZdw9BGaq/oZ/g6xqGQ6S3E8jt4eghmxT/Ewi4mawcugc9x8zF38BZLrKa/Er98sAAAAASUVORK5CYII=", gg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAYMSURBVHgB7VhfTFtVGP/de1taqECnK4NtuLJsIM4NFsec8YGaGZcsxjETNcwsQHwwe1jkZQ9LTMAX59vmErPERCtZJvtjtvlofABidO4/aHABFQr7Ay1QLi39c3v/HM+5Xe9a2tJLxLf9kpN7zznf+b7f+b7vfKe3wFOsEuRLu7rki019xNvoXNm6pr74+Vc6zcrzZoTk3j0eQrhuAniUkqIumIR8afdJQuDhee0k02FmjSlCRFC9xjtHOs0oj/XucRNCnnjGopraSEFCTDF9uNPHVI40pvcTF5u8yvdN3gzFvNae3meeIkldy8JSSMBuj4uybBXpq5E7ZM7h9Ld2tnAcnKXNgx4g0qZplPzpfQj/Vj/A8fCp80NOy7OLmcricbGQPQ4moFx4uQWO9V4CzSndK0P0jksf50sklO27Y8gR2YLQjzv1J0Pxdh/sO1RokTg4LtRR9N7NbwvZKhiywKHO9uDV105qGz9xWt74GtLkFmNOKI9kyHJWBRZX2OgnphrA1nAvfAbxyqtdgUNH2wvZyxuy8ZZOp6NYvQKiefLJpDyRDlUsySfupifCG2g92qYSoaPq/ClfLiE+PxntLt2zB8tAmaXhu70FfHmN3mK/u6FFbVgenEfgtD5mA2YJUTKnsORk5UNi0gWh+bTepH+qYBLukhKt0zQhenoO4H8GR/BxrvGchGjNyHKnFpUynquAnCHLmdS0FgzSayKj+EV6f0L0h59BonGYhTq7gOCxL/NtwpdrMKeHpPngUC7lyqQfKwVbl2sTcnC+P5d8Tg/FH02BKCpsLhfMQJstWIAzIAVm6AkNwDQhobQUCbqIJGQUVbjAW61YDsGub2AGRFN1MvJcELb1lcBQtkxWyG4MjzcKre80s3dZFBEb9yERDEKT5fyGaEiWyy2dyMwMIiN/6WQYtLf2eW4MjzYulbUsJcND6xPqtjo5dzUSvvs6EWlqWm+CwwFr6TPgiu0Q7HZwvJCXgBqjJONxyOFFqJHMK8ZSWQFqw81zwt2b98Zfb6qv6U/NGZfrtXvjbivR+uiru+phAOViGNLI35D9fsSu34YWz/YAx/PghExSRFUpIS1LlpEo3vESOLoRe91WhCrXYmpDBZsShWK+ZmdNjZjhIauqdoPn3LqhaEwfs9Vt0Zt13TqIFy8bynlnGXiqWJkO5DSePs8g0L7z3YP0Wf5EZnYOSBJyKlG9andnEKJkmg1ytwYBupsUGKmyt/cjMTGJ4obtKNpUrY8zg+Kly/RCDRmyTK64Ibk2MXEfsaE/4Ni9K4OMbvjPUaChXn+nN0NbNqG0u0uZ9mcQYmBGUoYMpTQMaw63InrjFg2ppBtmYykw4inySyH7JpHLtkFIpnXHaknmwyJN5BK6a+bqQmA7L31zL1YC5tFw2qmNxZ9UcuPYT9H6kMLi+wcwf7Y3IxSrBaaT6Y4caTPGxIVQNqGH0zP9zEv6ok0bsfDhIcydu4Do9VtYDRDqhcjAL5j77gJCrQehuZ7Tx2VFge/Bo8GUnBGyxXCkZ3RswrOtdnNSsKkRIq1F8pkemiO39Vyw76AJ7a5eERGW2NLIKOJDw0hs3oRI9zGDDMPo2CQWY7EvUv2MH/mff9XbV1Wx1lNLF6bySWdNT4Rt4BqKBn7Vj7NlnUvPHZ41m02vLUkvxKFJEjRxgdavAH2GoAo8lPpaxPfvhfJiraGTeYaReeQPDB3/6IPGLA/pClV0TPln+uYXQu46Ssr13Bp9nClijcWdkbPSJvgegJuZBT8zl+ER4iimIa+G0rhNDz1rxJH5O5vqx/DIGOKS5IPGt6TPZX0GdXu9TlvCdopOtK0pL8PzGyoNYv8VjMjYxEP9STT0SHaps7ujQ1yWUAonzpxr53iOff667XYbGLkKSsxZXkrDWfD7UgcLi7gQRpASmPLPQqF9WgX7iap8evzI4f5cawp+KJ44c9YDXminx/EAefyz00IJldIwWGieMXLC43xTH5/S8GIEMSmRJJA0IhKOu0qJ9OQjYprQUnI8z9EE5JupAScIq7DEvUSlj/4hIXLgBjmiDmkaGSxE4ilWgn8B4bSsEcRjdAcAAAAASUVORK5CYII=", mg = "data:image/png;base64,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", Eg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMQSURBVHgB7Vi9btNQFP6uY6dpSqWkQyU60BRUEBMZ2BjoK/AAiDAhWOgjJE/AI1AxslAmYCISAwNItBNQBLhIdEBAA2mTNHF8OeemVHFiO9fJrbr0kyzH915ffz7nOz8OcIp4iCSL5ddSAR3/Jd1VoMsN2NYNsbTmwiCsRKs9v3RIhlGk63eK5IkRGkaOLLYKg5iUEDv9FgxickJkJfnenNuSERLkomNGMkJSXgkbFpfNRVpCl4ni0JCk8DcIbULyU2kFCHGZxDYMQt9C0itF7GDUQrb2Ssu6TtYYhpCLh9bj3dyB2Rpl8hoSQKt0yK2blKHFQ4wPJuXSTi691FM4qWpUyRlJSG6VihBUv6AX8tKTkB0/dM6aTvVflsXyowp0CVGNylGtuk8/V3XJHHxroPl5P5JQ9tIsphaz/UMVIlWOJdSzSPcBTa0gAfxmF39e/URq1kbmXDZ0jT2XHrRSjTqGpX6dBUStrNL1n0CKAhKivdNU5zPF3OBD45BD21uh8/r/gWDYe9RSyKP2IhGE09uKLaWD9k4Lf1//IgZ2IAqDYS+7BYomjIP0wjRa2w3U3+4q18SBNdate1SJsCmW16rRhCaAsIU6FOiBwol+MZ5LX5hB+mx2fXDOGCHvd1u9dUgkxYGjuNw/YKIfUvBbPe1YGb0t+QVIbzkVSH0wZiFnPkOu2ENjaw+ZA3JZKtpl3Zavcpb0/OrcvRcxop4ArJ+phYwSduNDXWf9phDi9uC4MUKM9o8DlYNYR0cCDwGvoWORsrSL4yLE+YcPJuPMT+nconrxwW7TmKg5MfLBVopLjlx89zdqqL/ZBTIYak2Mamj6/AwaH+uqpo2ChKiE9UpBQpasUR3DuFCuIkKsEWfOCV0jbAt23tlIX3tcDpsPEurY9L0e3jrogEOZMXs1P6rAFrmrEBfXhtrfgIYOBVbBmOAapUqIEy3NDmmMU0MUQv3Ta8648qs/F7Q/lTn7cnHtuSy8wLLoSUBu/s6zJegSCpDr9dNcc4rQQPt7E80v+9GRJlDlhJi/+9zFKcbAPwuqHEMyNyteAAAAAElFTkSuQmCC", yg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMxSURBVHgB7ZdLTxNRFMfPnUcfWKT4SoyJVAwaExMh0YULY13pTtwbZOsK/QTAN5CNLi26csfSnd250BhITBQRKSZKgkEmVDrTznSu5wyg7fROuUNvd/ySybS9t3P+Pa97CnBIe9h+G/ji/VHQ2ARuzYME1e8VcFYr4Nt1sUEGcw5jj08/fF0SrRtCESvjWfBgGF/dxesRSFIve1D5XAa914DkmVTrc10OtfXqaAp4Ft/eEj2jxUN8aWwSbyQiCzGxF8uBd/punAAtrQv3uOvVwHvJs5kRdqEwH15v8hB6JgeePwUdwAwGzNQi181TyV1j4vXmkHmQgw4wTyYDD2293QDzWEK8CQUnjics8/qredFy80/h9Rx0gLfpBncKSfWHLb5QcPmDld14eluYmwYoxF7+AwkMSc/lviB0Ikhs5eMW1Kv+JKZIgZ0rWF0RtFfmRn8iUgxByZ651k8vs+AEhdMdQWSIktnBPkRl3w5maLSnxC4VSuE1pSFLnz8S9KHy+02p/WvP7uTCDVJpyOzl7cBT6cEjbfdyj4P9bTuXZvAcQg1SmSDq0tz1IXOlH4yokm+AwoohztOp0JjYGihiL5GpE8tAolGU1bUqIwMmVhgltbtZa9utCT2lQ2owM9PyHFAE5VDdqQdCyFcs6mzYpfrThtqafRPaCtK4BXzfiUSIh14hUb1X5XKIOrb7y8nzpfE8GyoUxYJ0o4iHK8U09km/1xj1o6bU/uRAT3CB7zXZagp0kGCeNoKFWYSYUIcmyu9+Qw3PLNElHNoS6IRGDVEG+CccRXQcRRg8AEkcPMuoF0XRc7F3xyv/mWZDL6akBP0T9mV8GJj/BiTDSE2P+pGIhqEN04KjmJdPwnukMhinyCm8TcLBobwsAePzWHwLYOgtp3w8QcGM7a+AyEuMzWFlzqAhC0wIG7GiDEch1Yfoofzr2CwanWhZ5HyBDc0WQRHyRwfX5oSfMzYACpEWxHaal8D9PA8KiXm48tbBnHf2xyBMPEGcrQo/pp6liHiCGJZul1ExD1mi2figdC6I+pBC4iZ1c5VxDKHLpkEhMZNaLwYidt4U8ev3VIbrEBn+As+WTiiRxrNoAAAAAElFTkSuQmCC", vg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASrSURBVHgB7ZdBbxtFFMffjNeJkzipHUNUKiGcSiAQh7rQAweabEQD3PCFCwfkHtMeYkjgWueKUtmRSnKM+QRNb0gNqtVy4EBFcuAABbIqooeWYFOnibPe3eG9cXe76+7aceyIHvo/JDu765nfvnnvzXsAz/UMqD6vqsaXavog7yrQocTvn86CaY1DWCmw8aJ2oN8IsSosUcHLNfCATlxinG8qX5XWOgLavnIuKxirJKaPA1hQAMYBoT4SW5mpdlDG3Nm0xUQSBCy57+tfTK4iaEaY1pIblEMblZffzytDSj7EYHXvt2reeSAgiVA3ECrZ6vcWMLWxEi+6YYBgAL7pu3wz636fQRuZm59s8UElae2Z8GizDINvxiA0rLhn0CDEPZYSdzIqCCNN22pe0VIGM5ORxVuFZpj+xZuZ5vV8gcgqOK2qJPq16FujjjO2gtq5/U/R2N5X+14eWhp8feTq4ycVEAj7WnFDgmbVWF2xthDmmh+ML9Dfy++lQ8DlhEzhMPzOC8AHQtAOiu7v3N4GHglB9EzCPeVTUKxQqkCAngIqr5xDc7Mb9phgom8nOoKKnByGvhMDgVAkSgX4i0kMlgwT7Hx4sVSS6zUDxWfWS7jHC30nBmHk7JicnBanxdyQQ6fisPtzBcyqAc3wtT+qoN/bc08bA4YB8GsmRQOKPAE4BsjhWjEm8LmfhcoratKyFHQ4piU+eOmSjCSUWa3j4v9KiF5YqrasVUIhK8sYX7Mt4w+0PL2F/5J0PfLumGfxXkO5t88tZ8vKeRXNJhzT0SLCEM6LoeEwLnqs4+3T7+223L5AoPhn0vMX3Bap/vDAs3g7KPIdz+QDjYhjYeb5OAnFrauYVGOBQBLqwnqBHJquldE+OSGZvRMoP4VfjGAKaQpomenNfPO7volRv/VxIXx8YFZeo7npy5tDP8inOpbC45jlnbzkeCFFGH4LpnVQEdN5wXZIspQbyrbU3i8PYSgVh0PLMDP4t2APnS2zhJKWMKj9P3c9e0tQFC1+29cVDInxU+6hA8QZOGFolHV4tOGNsiCormWKuC+QnaHtcf1BDXZ+3D56KC6O+QJJqIvrOfSf8/aYHDcIqmdiXAsEklAz14vAxBTGZaUVVFeR5Zawku5hYIFW/no6hWB46jPp4OTAMskpbWu6QwiPkleLJXnV/IjKAn1uohC7U6/g6qcRSKP7fpbqnSzVQbMvjDk1rc9PlKksQLvN6iFIxWe+1XCPp44USmAJbDypt70Wws4Cl1pgaML+y43W5EihCMbE7XrjST3e0iHc5WZ55UNsZUwqbeUp3bVP+cCQAtsg6g5kQZ5TpVNLS+3X0VKNBGpb6lD5KAAmEMjVqlxjuYaF0NFno3+hX124ftoSsrlrQGGSpJqnFzC+QH59k55VMQVAQQhLtkSJi99lGwmUaWQhOvUffn9fHrT1+zV59BwGhuRppbHXzgufJk5Q/Qvk89xpeWUCBSg+zleqUTOT1t2dV/bvMglNiTNyMgrULBwUhuTxSP1zNSO4lUSYnOf+/MRPOGEM295xaCNyfkuYOQ5skjoKZTS8FD0zVsJP33DXPV2JclSjj3qu/1//AfjKx66hsB7kAAAAAElFTkSuQmCC", Tg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPSSURBVHgB7ZfPS9xAFMffzJquuP2xhW6hFuoKVdRClVKPRUvxXL1IPal/gSu2h566ngr9pf4F6knwov9BlR71YA+64sXYgz1YMEWyVWNmOi9uksmPzWZX0IsfGDLJ/PrmZfLeG4BroiF2ZfHbzhhwlhdVzTzlL4fet6thA2bzu+n6W8f9CtAeRqALOM+Kx+lSswaEqMBhA4Ct6kf1y6P5Zi1snoWPhWwiSZdwPAOYfDPRNu0V9HWbS/1Vk/HRoXftK54JFJITI4YlAXHeec48ZZPyCy58LvQmKFmSX2Rwou1ulCBnMjDPZoiiDHPGcnABONDp4pEyefOO8SFsLiHI0lInPVNFyfqmGYFEYkRMABeFAMulbp3kOAtt3LCr1Fma81W4IhiHPbsuCSIbcEVQ4MtuvUSyLjkH+JdcNgRUndYHBQ2MN2uc8Rm4ZLjJ50fHXddA5UZ2BnNwyfjX9AiiCuTDBum6bpVaiRpv+TYJxw8tTe2mDXZy6B+g7v2CtbV1q55tegQdHe2QSqUgDgcHB7C5VRDXP9Z9Z+dTaG157O+m6TTZbH82xw8Z7Lhf0ucKUlWPOCyVhPmF2Ozv74cJSqcMXPv80zmCOIdeEtQDDxsbAxOXE6brRVhbXw/0t7mfyYQ+hwTtCQgilHaiKj8t4o2UGzdga7MAelEPCMPF+/pegaIosLr6I9AHyWTuwRMhPFNOEOFddtUNHedROxS0BBYU4BemF4vW1TCMgJiKQpy13ZAl/2UVIziK6u5+5nmGC6J1sPj3RywxvrUpVIle/Oe5RyvYNDY+8PbVi1AtsqDLDxsha7uCMNOLQfrObc99Q0OD25ZOW5/ORrZeJMRKfSzc356xn4SQrkpjcdHu7udQFJ4XF5R9EYrp7Xkh/M3vQFskUqbh/vYEVsRlOM543NxRgrFUB3NyMeeTKecpwJXso7Lph/AH81ADFwu+ZE5OP+ScGswEn04wMgYxsOOVpv21nKIN7p1stkl81qY404BJ2aRHnr/D4pftafE0UhQK2RIlCoxx6Bgj4TAz+LbNk37U+fsoiWTe4CevZXcuo2maIwatcVf61dFSh6Id4xv2uS/ay8cvUMXRJxd8HMLClDgUcvI9TBQuhAt3lEJGGOihtwoFy0eFWkmIMYk4HY8HT8ehgpDFTztdUMeWylmqZtAJEjowON66Ed4cQZSlahVTzjJulxjE2egVERtYF/tT/sVrFoSgtagJeRFeYnnz0uwaMJhHdxJlFe+QKpkVh4GUyL+tlBdElklFYsdL+YwlgKhUnNUNEQ6OhQeuZJFrquU/BR6tByZB9mUAAAAASUVORK5CYII=", bg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALZSURBVHgB7VdNVttADJZks88N6jRNd+SFExAKB4ATEE4APQHJCUhPQHKDsG1pX3qCGlgWXtIbuOt6pGpMEkKY2M4fC16+je2xZuazRvokA2ywwRsDwgrRr9YKwP6pCFT1sWDHWOTG87FbDK97edZYCSFLxBivhYjHs61kQIBtoLhTDHsDWBehfvWgxiyXulSQe5JImzzsuLyWi5D1AMPWIRneZaTxcejKhaf7BSHQIi9uqtci++hn2fcr+8fM2LKbM2KywkqBcMbGsx91Yh8pzfahcnDO9tyX9UImKayPbmcSut/eP9RLA14BKNAd3TuPTGMmYIYLWC8iJRIK8hV63IY0QprCDU3hAJbcUFWoqYdQIJF3BuEvAkZAqOn/L9QgDu2Hv5+SgBdZ9rD9qQ5Il7AkGaJ4z246/UJJVE3s1ZESzSpYfTJERx/Db4ktTRkHGmDnsASsMiuZHReZJEnY/6VkTmGcKBhsCZ+ObJ4dmRj/Qn0WQDoidetAk786Oajx0BPgTvnuR9s1qV85uGCAM8iAP8leNzlMM7abohcfjUQs8eiQ5GjMhUf5yCbzjJD6p54i3JEu2CzfXbcmB9Nq0iQZyJAPFrxxEEKX+EUC0vHINEopHnBhWPlzeYYIxvE2dsl9Zb+laTkMLgwZ5MqneOQRJesHAHFYzCCW1D2mOiRrYQCZkEHp9nvxBSGL31q5fYhtPIQ2/RHoWBBq0wtoOetpQGk2UfJlRrUGOQ5QaHdoP0+p+Vy6fQoFZ9DkOffVQHskMnuTseisZZpNNXgNiDSnE8NJSGX+J6wZ2sl0Sw7NchIq3143rObA2iADxPjE9WZm+2EFMAngFeOxtCRxE81FyE7QiTtWh2BFEMCO75na0k3+Ywdgiy4GsBBkwIQn5Ry/Qrn/OpKmzVBtHmI2DtmjLx/Cr13IiYV+g6yAEnPVCiE8F8GIUf6gCqY2Yd3inOVmgw3eJP4Dtzc6Dop+WT8AAAAASUVORK5CYII=", Ag = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVbSURBVHgB7ZbtT1tVHMe/57a9vdAWbnlaYcAuGzMbc7NbYtBsbE22RV/MZNMYY2IyfKPvFKcvNJrAPyDhjYnEF1MTjb4amCyyqRluRpYMTdkGmj1RVh5LoQ/0Edp7ds4tdGNtoRuwZMm+hNz2nod+zvf3O79zgGd6ykSwDnK02BQqiK0qMHCp/W4H1iA91qgUjOECBVXY6lzsVRro4Me1H4LSNgp8dKnd/W0+8wlYg5ZgNplE5eybu/HF/tp028FT1a0MhsPJ7EcO5TvnmhxSiaGNPZR399hgNuhwdEuJov79yplvzv/j/CFI2vAYWhXI8/YHw9oHgo65of8CAqirzvl7L3dHJThpFnWwV5jT/YkoHm9uKD++6cYUOv2FCKuPlqYrhszX3CKzh6L9U3SY6utPQ5Qu3N5zeHj3jNzK+zRVF8NmEpeNM9QqOCqreKcoqn2nlAawHkDh8LyyrLPBANO2rTDIVuW9warmwoSAAwzoYRG9HoaqGhwxz8MkUO6uH+sBpNOJcrb30uYqWIwW7B8vRr21IOtYfVU1eDjNDIj9rQ/QSuJQ3KFc4i4Ro4RQKofWDciVcyALn6+IoOfObK4u+CO+zkld+VOHi+SIf8CUxIgtgdPXJtEznAl1yxfF93fjeFTpVmp0tMhyTNDZ6xesO0SqWwbT3eRDeUkp9t4x4y93AKMWgphYiGkWxn+jenx+fghzCar1Zx4NjPQFe5GH9LlAVKGInU20pdt0E33SGF6MVaFuoRjDhgCuVHixxVKPY/2l2BWyaWO8v4SguzsFT2kSA6+bUFltg9s1mpqQQkae0mfCpI6DvRUmxWYWMReJ4zWdFxV0QkvQ0bAIzxxLVucQ3go0pceVUTNoVQGk8XG88VUQXScrMKGfRCKR4B4peBygJRhWeZWOI/UPtGyHGg4hMTaK7UEfXiqYw6ceVqdCEdZWmO5FdDoU1NSAjI3jwPkQrh9edInkf5YtS2p+NrGoKzf90cyOJjPE53ZAen4v9m2WcVixopJYsk5qtG1C+YwAGwubUTLyV7LjE8WBRwViwfYTSp3h+aTrxmw06+4ikgTjzt1orC1FsjD7nuBOUZsVelaLapTq1GJV1YE8lLNI0CvH2kBIa67237wJGC5uxq7hwqzt16sDONcU0T4PsnwL+oP+i+1uK1ZRzjr0fs8NJ1ZQX1iPwa3RrG28LPTtu1+D6nds427JTadqmrGKsnrOL1feWOJrCzuLGspMGe28GJ7pvwWPLoKJnTpURI0oZoAxA8XV7RGc3e9DRFLT/XnoqKpylxx1jUKn63IshnyBHGwVFES7hg7NRFAqGdIHaGghiU7nBH4c8mjfI2yXjYa8GKgJYbBJwJWGEFyVcSSzLLNILoLP65PmF4jEiuQ55FBGDh06VTNMU3egZeJ3nsnwfK55tN3EE7jcVp6zD1/AQP9VCAQner90d+UFlHLoft3QLleL55kA4uLPpEpkIqgyr8BEIC9QCjt7rVVjDsTBFrd7hkZZXWK1yS+oc3W9HX7/qkCPK0eLYldJsoUdxoe4w9UMamnLP6yr/deYW+GuP9vdJ7BRQMvgUi63ipJR2WVvyHArHotrUGoykRE6HTZArr6gs66xpDuRWLBOjE3ycKKYJfWS+K4TWCL5ZgOvPrzrNgRIg7rs949cDnbVvVw8wra73TM5LZeUlWgwXJYiCy8DUixO4iN9gd4NB0qDPeDW9NS0XRAEDYarpMwK37RPvn1ppvOJAWlQi25tabSM+GcD9lgsLpvMJoiiiIVEsufar+7uJwqUBku59V0oHJ4K+gOSXm/o3mor+az35/9jeKanVfcAgI4UrkwIE6oAAAAASUVORK5CYII=", Og = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMWSURBVHgB7VdNWtswEJ2RfYAcwXxAdwQ4QdOSfckJgBPADXBO0HKChhOQdQmQnqAmXfLR+AbNvpGmIztynMRWpNAu+pW3iax4xk/Smx8BvOIfA9r+HB+0GkqJU0G4T4CRnlNEjxAGw53kS99mBxC0QMIHY8eYEKqvQqj+VjJMwYdQ5lCFlwrgAmpBKRB1t7/f9xZsm0fnCjDmYaPelHoikN0qYlhBJlIqeOC/IlgLSoWQh+x4kpNpf7QvYsX23TIpsTkZPj7AK0Pmee/9qTsZDcy+lR9vDSEpg9iVjF7h7mjwSY/0QgDxEryBEcnwM1QR0k4R8QRcwfoxQ7+FLLlBOB4ftFsrhHKnjkDqGTF7L6QCUuHxCiGBuO9oz+/KYndIhTfwQiDQ28J34RjgwNG+CFctZA87GyJYJuQKIXCeEAP4UygirUxoAg5QUp2b8XZy3yNBHVdbCyYrhJAgcTJFPP2x174x+WMnuesLMT3MMveGKH97riHkGuUIHaqc1L5l+YehNaWz7qakFOLjCiFV1oYTikwblUlxLXLb6RICQcW3F2rZc7P9E2xFsRKUSiE6b5LbjEjeIYRjdz+Ubo/utszTQpRxLboCb2AUKPWCXITX5acFQqGY6trkHTG5fmbgtgU8docDorfgq/ygK7fvLlFe8VM9zroFv4p/bW0/NPJdco0WSgPxKzZPeeviCq2dQbw8u0Io2yWBZ+Dkk7pFP9RsX/pUfD7mTuV81eRuMhjy1nfBhqWKzz8xuEMvJHEmlJHi7eQMWpebJuWK73NUiNCvOqq1hDLjYHpWl+hKQuaIQueoQpxa5WAlpPWBYtqpEHmDNXNh3uE9sh/vjMysqbemFeu9zKCm+Z9wDtmai/poXCdqfZcLA3lsu48ZOPVDszp1yJoalqYbSoZFY18XmdqGybRcyGTvgyeemu2YV1EQEQL4GAZDPea25IE7gZb5TyfNndGtR6LcoGPU0ceN9JnRFck5OR0EkJUeShUT9SWT+YANoXUlVRAj4AlxtTd3/Se+0oQwTdaJ969BE+OIi+EV/yt+A1fifChe27BUAAAAAElFTkSuQmCC", Cg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJUSURBVHgB7ZdBdtowEIZ/CWfvI0CbdlceR4AH+6YnKDlBuEHgBIUTlJyg6TqkdW/Ag2XSB0dg3Yc1nTHBUcEY5Mivm3wbhGSZj5E8GgOv5KNQAotGMwTOqtKuTe+mp46VIrSot68MVJ+b4aaHliAavJ3/GC/qnWsD9OyxWOtP7y0xr0K/+Qf5o581pggRKTQzhlaxVq2tlIYnNktB3UPjB2SEMIjpy/aLN6E1ggbHoYoCsGwDvoUCrFcoTrhteBNiliiI7K9t25tQbRqt7Bu7QDA38C0kxBUM4AwtdcVEKEPo3XQSEWjkNIlzFEd3iTKEhIqO+0kyPI0kYdodmYlRcorB2QUMVZMOMklY7X+SdR1pPa3gT8TN0JjKz7w0QFA357O77m7/ntB+6n+Gw9mvzSaD/OskOmqk9fqWTPCN8JxjLJkRy/SQwT9CeanfutuQZ62OXbeVf6h3+ty+fupeEdHl+fz+9tC8VIjDXzUmWMAjWqNV442+ube+0NqMJT3kzUmFHj+0x0qpz/CI5KU380nLZU76lLHMR3jGPqNOxX7sQ/jH+Z620EsOR2+kQrz7f8EzRc42aw9RBM/wHvoOR1IheSThedkkOcKRVEjyAxfgbgdjHorGu0eNk5AQ6PXQ4WDMgUsKFRcoRXaEkihpdYmXslNSFBYSpKbhpSv0757YKylcOPhe9lhvDxXUFRw4VFJ4EXKV8iEj5FaM57P73onLN/AhI5z0Kv3Q6DS1oa8ZFeDR+qYUIUFqmrUJuhzSZAklZ0maOFbflI6Ibd7jX/k//AXQA/4p7sVaawAAAABJRU5ErkJggg==", Sg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARZSURBVHgB7VhfbFNlFP99t3V/3DpaBKEhY51/ZjAxm8WQmBi7+mIQEyssQRKjxAhhYLIZX3xy852E7kExMVE0JL7oVlTQJ9s9mBijEyVo6ESmqFVGoGxzW5f2fp7zsd719t7e3bYEXvglvbf3nHPv+d3z/b7zfS1wG84QqAPJwZgfOc+YpuFY5K1PPsANgIY6IHMiTsdeXZfHkgd3DuEGoOYKJV+J9aKgJcvMU/TEFJ3Hoeup6DuJKVSJ2iuUFzEbawgSe+nzPoR2oZaq1UxIapR81SAMK51VAa/bwOsC1vbSKD9DmXoombtEi+ihYwou4UpDyQOxEA3BD/S1qrdlSCFHhC7jbvXkbsg0z1gtZBhCigGlp/6dR9zEuyMkZQ/qx6AbUm5FnS29aFy7Hndu6nC8gf0NFGchdYDahQPciVpghEQ85GluQddLr8F334PKPP3tOP5IfIjCwn9GKJO4d0+/EfPP+BcUU9LENdUuUpVSOVaIxZzs35VkMny96ck+lSiTyeDzk6eQb+/Cxsh20z0cM9cSUH6OY//GyFMl7ybWOOX0OpEhMVInlqGiLfDQIyrJ/v5D6hwMBpH46Dj++vJj5ecKMslS/2eJUWx4fDtV6pSKkZDX4IDKFVJkVpof64Y/59KTKhmDz+cv/qnsDNZNuT+dThv+64zEAIl7sCpCap2CuRPnF+bV2edrNcX6fD7Dt3Rl2tZfWPaX4EglUvYVKmiWac7Cnfn1Z2wNh7Hnud3Ktn/fy1ij5wxR54hQz5YHTH4etpnzZ+2yDNktK7adepm9pWewoLccesNkm3zvMK6e+c64ZgFvjr1gXOeJ7NnDryuysGZ/M/r26HCpyV7UUj9NGrKYZ6lCaSLASbkqPKXZVgoWL5NYty2iYljwtmRUHknrIoZXJ1S4IwtvgZuhpaRZqka2pCJ2uEz9iT+rQ4TKLZYyJA/uGiAyNS2kNcDvSEhtqKSM4+ZhqtxgiHq5EV6odOc3l+aQnsmhHjx6dwvub2sqN8ejR0dfLV4YGpJCDDttjuYLuiJVD3a0264avOCeoP1SykRICK2bhqviw54ItuHKYh5fZWYNW7ijE093b0XXhiBaG5uVLXPtKib//Rupc79g4vffjNi+zgDuaqywUgkPr5UpEyE3e56+zrVo9mqYmNVw9Pl9CPoDlhi2hTvuwe5tj+HkT9/j+NdJhNt09UKVsZLb9Z66iB3tfvS1rkMrFugq4BgbaQ9ic3cQS4uzqz3WbyUkxGm3O8OFuctIT3yKhiYf/OtDaGxqg8fboHyF/BLmyZ+dnqLvridB1koI8gQdqtqq8ptfungGdUNKo4uu9KEGnftPFrcEK73PIBSNJ7K0hj2Lmw0pR4pT3kSIoRx5/WHYdFAHZOm3zojSYE1kxkz7IvvtB+9TFrUYJXlxeUoWZwH9mSBoWCVNAPxI5FPRdxMGEdXtofVC41+21NcE3Scl3xsyvQBECrJgqsxtuMX/a8qxOYm4YqQAAAAASUVORK5CYII=", Ig = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPxSURBVHgB7VhBTBNBFP3bUgI1aBUS0UBcMCkJJFKDmjSYWKxeTMFy8WaqBw96AYPx4gG8eDAS8eSBC1y90KSeFAIeoAmBUIya2CjUtBFMLFbQQizbdf60Xbfdnd0tlHjhJdvdzvyZffvnz583A7APbXBQJMQFrw1SghfMpgsgCg7SBU+KbdnqBLGIAMeFQIA3YDH7udP+BBQBw4TEoJcHy3YvaeKTETDyhhH4Y37IOf0RY+Z6RNAj6XQ/iGIv7AYcDHFtgbv6ZlpkqFeESfLIQynAQYR4q0PLWyZWhTjrdZSUDO2U9FUuTIqzVxwsE1UPldwzyrcyPaXuob0kg8h5asFl0yUkznc93VMyclLpqv7C4rwhyw7VslY/8R9JqD5sBSNIbqXAWmHRNkqZG+RDV5ZXaREGtNq+ePkOJqaXKaG+W04mMSQ9OBykd3d7I1zztLA7pbkNpJQiDRnNNwA+VrvwUpySyb0w96yGwESY2iAmppdoWzY4nzyW/sUQLgcaKOw09GGVaRtdWddsWwCyFFV5lYRM4IIioBUbW5spKAq4Lko0JHCtWm3sjdV5/+uOH2TatjbXarZVgC7SCkIiDzqEMEARGMydbjvT1t3eIAU8ttElBBwvPUl05jpFMABDUzmLYlIEdyZAuZigSBglgzBKRg45IaaQin5dp9dOgZ7SmWnSu2WJkYuQgVOswrlkiEDvYDDjl9fYrGCtLIPKinJQI/A9kaTTf20tSYcZgXHnudQEShCVqSQkLpIfBaHoyga920+5IPY5lP1Sza/Ng/WADeoaeYgtheAjaetRM0LJqyCUhikygIpMjV5AVB/loe/JJCR/JyD2KdM+/i2SvX/J2pyg90pCoqaWhyPkQkLP+7spIWslI/5QfysIEUEOgoArfZ4kaOKrIfR+FYKvRyBKOr0zMAb2VhcYARIevNdBPYtwtNSqG1o2/LnH/NV+rmuI/PbIy5Ik6z54PE7iYFsqc16+AY72q1B/0kE9V0givDgFM69GIfx2SirHuHt0363ggpsAorVvqhNiyA+Mm8HhGWAhR2rzV4IOqRpuXz8LjmYVDxXIj7w8lKkQnxW2wUzb6VabHRmgV/BikcHZpUqGvKtQxio0NZUhgrAAKqoxOB/NkxZ6wDSBWsjZVq+sJLqaDFWDsliNt4bIRzKB8TCEl+NMYkgE17CL5xvUM7uGyGfuy+g2yCSMgYa+xtiKrfwkgZ8JeEwRdccO0eTJXGKQjGDu5s75Q+rVGvgfG0VDe3txzkPSAdcDuwKZLOayAb3DhyIPG+gmwAfGgacho5AqGyrZYYOCWO44hkpeVJlU2MmOY7jscUx6R8cx+9DDX6sJonaKDA9YAAAAAElFTkSuQmCC", Rg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAP+SURBVHgB7VhNaBNBFP6macRExWgLilRIqkRQsKmK0Cpaf05SJYJ6bT14FBWLB0FaLx6kxfaihx6s6EU9GGiPLW0PtlBbmgoKRqmBFq3Qn9hqIsbNOm/ys7vZ3WRj03rpB9lsZt7M+/Lem3lvBlhDbjAUCHnc70Jc8sNWchyy5ONTuHmzK9Ud4RJhMBaEhEHYbQFWHYigAFgmJA/73bD/uc6HNKgIWNHQhd+2u6wmELYmno8IWSSRaIYsX8dywNDODnbfyC+Wi4ywitTPX90oBhjC3FonclmrxKxDHvH7ikpGTMrnWif1yyNnfGYihhYqumX0Wk0tZWyhlSRDSFtqvM6Vl5A8du7BipJRk0psas5u1rgs5arPWE3EbR6167QWskstWG2IvU1BxkJiv5GkBaw+IrAteVj1gNjRFQtROvg/4KloU0a3QqgEdVZGzy1ErYgh+ituWVbkxRRKlVZWRaFvhr7Xk+jpDQlFhJqDO3Gpfh+c6+06Ij29HzA8Ni3ey7Y4cfa0FzUHdprOnUzSOkKy20y+uy8klKgxPDYlLHDzSq2mva1zGNNfvmd+k0zXyyBisThOHqk00cDcBoSMMzhNSGTon3o9ZXA67IjGyB0xhCZnRV/96T1ClqxIZLyeci7vELJz81FMzSziec87VO3dLuYxgMuIkCnICt7KMkOy9M/TIGX3bp0yVEoWtQJl2Y+eXUAhdU5xEWGHurfQi2pjZGEjSQpMCtDQ5FwmoAsBjaGxwfczOaR4lZmCOqgn+ENXFrzgvlebu2LHZr6ySoVbyl2G8YDZSNKVU18XNUv/FA9qWpk6UMmrI5TAALdXQ7YsBS/BV+tH9EcEobcD6R7kg3ODCxWVXpRvdyM4FMCUavVpQPW3jhAvyHnqoEyviaNylwMh/j37LYybrf1CSfRnBNOfggpp3kdw8D7nxuTHwT9l29xCtq3pRJKgw25MyL4USL9qs/3ouXb+vKZuI98/evpGvJOCxqbH8FbVwQpCEwPoar2cIdx40affIPkhgNfal5WfakIm5cft+32aWPDur0M1d2HFripU7PYJqxHIGnMzYXycGMQ4d5HiXmVL0CGr/NCVsPJoPbcS01iJVklb5xCWgztXj4kFkaWtgx3q0ZQf+hLWVtrCn2F1E22KjRdM6/K8oLE6MlRXJ3VlNRvArMintPDw2ajlLE5uIjK6XT5HkW96LhPHoBLpFQzqa9qXKOGaESMitTx4Tx716KoBQUaynWeHA0Gjscs6KJLFZiMxzKeIOdav49bYapZALR0ULZ3tjQK9cMgdFDP5Lh8KvGwQh4AGWAfdhjxBvLS9aJcNOmLp6xhR8ooq0w3NdQxLXcck/uk6Zg358BfBubEDtr95gAAAAABJRU5ErkJggg==", Ng = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUQSURBVHgB7VhfTBxFGP/t7S0cCwfbuwsKUnKUBIsmQgukgVZLYx9sQvFQ06daIaYPbdKAqYmJiZHGxAeTxjbxTZNe9cUYzWEh8QVaiAVeoBymkVoTOECKpFw5/t2dd7e7zuxxx663txwC6Ut/ycfOzvxm5jff7HzzccAzGIPZitDqmXdC5KpFRnIur4WcXHSx4JRjyHlE+FMotSwI+eagQGjCBj2wEuMDT6JW3x1/FW4tHgtInGO6IC/bx8omHyTJ5z5T6N2WoNYbUwJyrS6RxZvktZFOFv4niuzoHJrtt/GGYwRWcwiZ4pfHtfh2/hTC3Auw8tmKaGL9gPTzd28Xug0FnfP422VJ7kysWJLkABd5dPP9wu+PH9t3vxo7wNhK+cBn8x968ywWulDnRrWPzHJFLSwp6NxP/k9lKGIS8F2yfdVSZx31qAbYGRj4up40t3lW3/pSlmXVAqUPiKhrtGRSkV3qvgXsqndXxVDIcLpst24Uc3MBbYOpPVEyb3JlDWlZtLo+X/gIr+YOotLyAA7zInaCxZgDE+GD+HX9qHMuUuzUtjL9KYJYJtomytwdqDzygAxAjYI3BVGaNaM8c4k5zH4YC7Arz+lIqSImKPHpqD7WFLmSlKZuafUsCTViv2eSqWhcxHPYS/BYR6181zvINpxwt5QFdAXJwy4n1gNTWAtiNHYE99CACeYV7JY4h7yASvyGg8RqTMPg80llrlDG1Hf5EhyzpgcndkKwglpNcIIYiWGRKIKRLEyjHDPEgshTBD5WiUwI5rGmrDyXWLy8BgcWFKvEOHhzmJByiJF4lJVHvmXqj1gH+dOR4iF5zCVAFJd0lybJRFiE9BU3LBavkyRdOkym+GRmsl4zSybn4mWT7sUQALtaxhzqD2g9FBVdqiDwnwnIQJZs7BEERK005Li1gkzKNbElvL//jb8ercBuy0H94f26nOHRWfiXQoYcDVjT8VRBYKpoNDLCDz330Tc4lXzvJeVPLr2m4Vz9eggPJzdDwiwRf6bpZcNxIYvJqK3aJNlp1IeumoopKS7AhXfrUHHATjy1jJ7eP5Kc7r6Hihjadvl8A+Hmkz6TuE3MGIxTR1AyhdAFnYzi4tlaVL/0PC6crQNvMSsig+FoUrR9H4/Wd6oVURc3OL0qr6aBoCfIEHSi148eUJ4UfA6HppMvwkbeeQuHYCiKHPJsOFyS5MT7lMMu8JlOozr2I6eXsIWX9hABprZ7Hy2oPMT48NQg+xIl9Uc9jqcFhkmmtZuCJJpW6oPGHnqc/UtBbBe0D+07TsZICxEDqYI4tgvxfDcF9FTRz+3jL/rg/tGriTPpQDmUS/sEwzFUKWOkAbfalShqb/uRZpJGyu16fegpuvrNkBKlKegJoke7tCifnK4spS4UjmBmfkURk/AmjVuXz9crJ1EXDNxMTXebviCafnBi2qBBRfWQeNS3ZaCLg4aJppMV6cVQRFlN+pFy/cojTcRLTDsMMDu/jL67Uxi+N5vSRicvKSrAaSKEetAY8nWmtqdDXZMqKJ6GjCHD5J5uD43UoVAM+4ussNl4Y49szuwjW1WWWq2nO751mvx6V0HEIMKeUG9VArpXh0KU2BYo/8jtgRiRbdETE282wK57ysAzm5QMkMmHnsEo18GaO5lDXQEjVkaClOHi3uokxfeQOcjk8k1EzdeMvPK/BCWF0VMYz78bN7JMJ1Q/xyiXNL2bRGmARv+tPPIM28W/WLX19nXBEloAAAAASUVORK5CYII=", wg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPtSURBVHgB7VhNSFRRFD5vnhM6kD8oZKIwY6D0A84UBGb0o61CRRfhUoPaliK0CjSCdqLSooWLlFbVwgFd+lekA6Y5LQxsoUMj6SJzVHCi8c3rnOt7M29m7vsZZ6IWfjDMve/ed+/3vnvOPedegGMYQ4A0IS+1FEJEagHRdh1kyY1DOPFxodIcwh4BEAQ/SPAO7KJX8HhDkAYsE5J9LU6wH3TiK+0aAlZmGIbf4hOh1huw1t2MCCkSjfaALHdCJhBgQLg01mXezYgMU0WaxqITsgEBAqjWTSO1bHoN8nyLO6tk2KA41glpWp6/7YZ0CDFlbNIoj8zW9j58Xd2CjEiJ4iibgwPukskLTWtaMvu/IjA5uwpTH9ZYmdDWeAHq61xwZNDy2fY8gmcmwQtzUsgsNvejATvVOqnx4tVHRsSRawf32VKoKCuAmnOnICOQUtGTPVjqSuSp7XNoxGtqnVR5M77Myk0N1VB/1cVIGWEK3/m2sQuOPDuUFOZB+ekCqKos1n8hIrq0Rp6okF3qVYukDJEhAt33a6EcVTFDcGMHXisfoEVxkQOablVB7cWK1JfY3gaxLSWmENtvJGlbrfsWg4yQVTLaD1FBy+xf3gTfpyCrNyIpUjoJIRD3XKotxQnNN3Wgz70Ek8m2QvtoP6WmS6cFeWbfkI/9tzWeR2eoTOwQhbvC5bFhKsbd3gY3jAYlxfqG5mD4rZ8ZuRlIHSJAoCUjpemfC4qLCjQ2JNSQ6ethYi5m60wp+vGMlYiMT6zgB6yzstZ+nj1q4A/OgvQhNBtj3NV5WP++k1hHT+KBlmZyNr5fkUqkKnmfPgSnWtJ6mWEEd+Tm4CQHsXpxUV5KH9omiHiVq4S1l6A6QawHN3eZ95Ht6SxbIY+QIRrqzsDY5IpCxoH7S35KH3pOy8Kb1P9lE6xASygEBipRmPiB8ofDEWYTvEndqIAejNqUuZMJCQG0I90oTDtvxx3d5gyBWaYCrVF/hn8FSnkVxAlFYQayCNXLLIHybwXxJcOEHENHP1jIl58+f88CZzXuQxQ8tSR+op0toQGHwwfw+ME1sAT7njeFEJ0O5IXmEVy6h2bvezAFIY8z8hzL9oaHAG1OlJgxRmwDYAEUJMvL8nXbKRhzIzsPeCLRVhMIHeYl8iBYQPe9K9xJyb0pblmDPJic8KeksEoasgQWk3sKDUEljFBss5wFsBRW9CQfJPk5dbaPPzwyOsch7qmDdYyKrVgMwN8gI4mtemez/+6gaOlsLy80ovcJptuBySiDIOb0ml0+pHnZwA4B7WAddBsyApGcgaxdNqQQU69jWMrLskwnJFzHCMp1TPRI1zHHMMMfGOObGjAsJZsAAAAASUVORK5CYII=", _g = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAP0SURBVHgB7VjLaxRJGP+qunsyibp5rutKEmb2kBWFzUxWdok5qLsr7GEl4yKCpwjizYMH75qrIEbwIiKYf0AneBQxHkQUIe1BEQ9m9CCKeQwoGTMz3WV91U6lpme6pno86MEfzHR11ff4dX2P6hmA79CDmAouZvalvKp1ilA6yW+LHWnqbj3hZJxtJMXvez6LFf0PrPD2crlQesJSYob5LrW86bQ7XzDxY0QIyfi+vaA4FrAHCAye7QDaFZipLjF4fW5dXEMoepTsH3Fvua18kSbOe3yfHqOMjPqEvOz4M5Fff7B+g4ummhnoPmBD/1FHjN9drcD7e1WIgNv3v31o5Xo5F9hmjyn18+GdqyO0+NvfUz6QGQjthA64O6lLSTEunPwI/hrTyobWi5SyU2n39qyUkWQwLDHJINBBdZmJq45MTTYEHg0yg1FpIMTDlItLpt4ZtAtOyj5Wu7FrAwYkY1xyIdj9gWaTkBiBEjYqxwqhArSB5A5pAhJD7T2Sz8hLCBOyafUatIFNWUuOO3dY0A6o4lsSwvLbPG7NQUxsGtsg0X0gPqHkTmtOLf2NkC3keraeSExiXzHF5glL5o8wxnNoy4S5PspuP53YyxaaVBlUPKwy0eR6J52WxtB5X65RrnfSlp1bB/Tz43Gh3wOVLblGQhT2qUaHzyW1T4sy6u7UgMcJrkUBi2BwOgl1kbDoXqm/MUtGsdZUw/gEaHx1rgqlZ55ogAEZB3ShxTXsS6tzFWkLkx8/alVKMC8jWci5RwdXoUVjFF15iZf3sFl5l18xTgZMQlgku2/2CvLKZMsujYYTw2AMU+KqbwrfGFRCRfh6kL4VQvqjY3l1DZ6/WBZXU6Cs+/SNgQ4r1EZKDrHH/CsTpXL+yn1puCvpwOD2H8S1s7O+F5VKFVgqlmBlZQ3WPlak/IUz/0IkCHEbCfkwz/drKkpHfUp0hLtlihqxSHhwtzbcCJlj5UGTRyO/DEC7GEn36wWc9/kGQiSb52TIbJTOnrFBaBd7dg9FLxK4RrLzzZKao0JnovTGfx+CzM5tEBeoNz6mIVS2ptXbOkJkPF/gyX0xSnfqcCYWqZH0ABz5b5dGgl0MfCocGkT4awh4Hv4GS0WZuX3vBf8sRpYzVtXBf36FvybSEAkCBaBWNkgVdboZ7/u5FDjeHR0pBPYY0ZtWAmL9fV0w9HM3jO76SZDSkilb+8O7EyxFgD3MZYB6N1qRig0k41mHyB95t/myBqY7FYtMxM7UoD1chaJlZXWJbg5uA3NGQ0b4BFNzwW6d5cMpMAdPWDYLFXumFZHYhCQxrEJ8/xavvOItMwXK3zHikMazyfPvYvcPV9F3fCk+AdDEYaKuc8ynAAAAAElFTkSuQmCC", Pg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAO3SURBVHgB7VjNTxNBFP9NlyJUy4eQYMCS4kE+YgIVJEEOfhA9GMR6MHIhoFdM4KhekMSY4An1DwDOmtgEDsZIQC8kBKUcJMJBGhHCQUKlSVXKdp23tLDtfnSXluiBX9LtZPe9N795783MmwEOYQwGi5BmvQWIiF4ItguQxDpuws1fF8Q+B7lEAIz5IeI97IKPeXxBWIBpQtKU1w37di9X6VQQMNPDMLaEftbkC5gTT0WEPBKN9kGSepEOGAZhC/Uzz2TQWMyIjOwVcYI33cgEGALcW5eMvGXT+yBNe+sySkY2ym1lixPS9LU6PRFND2XcM+pedT2lIiTnjCjOHhgZJSlbyJOcU+qQUQIfNBkChS/q7Et+neChmtr6oUqXvSsUjmJlXVTZKCsS4HTYkOdgqCrPRmmxjb/L4u92zITCEtfbxsK3CFZ+iPKPYGRrYTkyPD/38Y4eoQ3JyhqTAXACwTATKwJ+vxy63ZBR7rwdKCkg5lZAo+y4cgzdN5ywqltWLODNQAmWhvZ8sJdDfDsgATJsBST/oD0P3W1OdFw9ak2X67iKBb4VOb1qQjZcpL9zlUdgBVWuLEXbDiuoLI/J076oIgRWS0/yEoXBPKHs3XY1J2RWl+Sq4wOQN2kVIckdb7V4cmAG3maHPOOUnTRWZpvSTZRjbg1Ce7PL25wLM9DKt/vt+aa8RIPR6ltTs5HnkVFyU4cv7h3XnFUU8id38w1nHNnWi8Kuv6WZ6xtIWoM2+UL3ZXlL1SEthmaQrJ/HB1LKdZVhjiHIGkYLqaGwzAKcVsIuTIqNFmfd/vR5lRmDMqnn8K9AJW8Me4SimNSTD/+OIB2k1Kf6W0WIF+SQi3Q15j6v4eHTcSx+XYdVkM7j5x8wN7+mL2QP+eLNhOySZtoG+bNHS2f4pR9Tn5Zx+lQRzte70HTWBT2QR76vbmJ0fEEmRLJdt3SKRH4IYPWj2rt9rFJc0uzkVwQjr/zwx0bqyLHjZGkeXKX5cBzZWXHDfyJYXv0pk4mHqa7mBDo5GZLXRESoUFaO6opxppV7ifVAB2PvFuWRm8Ht1jO43FxhICE9Yw1jCaeZfZWw6xthjHJii0vrclsJ8kQTD2kLJ1JU6IAu5BJW8CQfJNMu8uP54sjJQm6u3ZiEkozZIn+XFB2DbOJrZLq+JjKicJM1+vzanw3wXx0UZX1SFAQPJR/SBrdBOZPijG/xskF8xJudMA+6DRlBJGswY5cNKmLx6xi55KUqUy7sFNcxLHYdE93XdcwhUuEvE8VZbbgSdyYAAAAASUVORK5CYII=", xg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL/SURBVHgB7ZhNTxNBGMf/w7aENsHUYKImmrSYQMKFol4QE3nxZJCUg2e8eAbjBwAT7xY/ARw1HpqINxU0ahNSbD3owQM21shFQpGkNZbtODN92+3uzmy1Lxz4Hdp9eWbnP8+8PM8McIwcggahyUgABT0CresaqB5mnwiyx4Hy6yyzSIOQFHS8hleLkZFYFg3gWhCNR4LwHi6wInMGAW5qWMEf7T4ZjaXdmauEcI8Ui4ugdAH/A0GUXHp2V20mEyO8oq+zyyCaAUGaeWtC5q0upxd0MxJuqhjxUfatbn2dbt4IO5nYeqjpnrHW6ugpew+1Ugyn4qnkeEApiG7NPGypGKOoYu9i/WNTl5W76ivaSUELGbvO7CGvvoR2I9a2GlUPifVG1/fQfrLQDkJkZEOs6DUP8XCg4Mv2LuIfMsj9LqhMhc2rd9uijAIWinqrdXuqj7swLisV38pg5WlKXA/09+HenSsyczx49Aa7ezlxfftWGKMXzzsb87gIFmJgGkNkGBJevK+Ndd5qWcv5u4oYzsu3inkignQJgyAalJX5/mPffL/zy7VtZmcfckgQVkHyCO7v8Zju+076HG19vu46Wz8UBOwESZkau2Cq4NzZE462w0OnTQ0ID52BW4zN5tPO0UuTYyH8ZOMiny/g5vUBaav9Pq8Y9I/XPmOQTYDJqyEoqCZxtXUoMZNkv2F0BJoil9dG+JVxUH9Ep+Apb5maoCI20Cl4/l2mNoZYQs5CB4/0juPoyfNPyOXVq7SRU2w2Tk8Nyo28BzGLIL47YONolXXdvF0ZLiSe+MZCwiEawd/jZROiX/zbwjYBlThWujWgSj94fMo36CEfm3GOYjh16YclhaWJ6Sh7PI+2QJfZ7DKlH9aFUfMssd80Wg3Pq0t1mbAIEjvNgjbRUlGVJN9mV2sbOkSfFrXZlojiYnRt1mlvduQ2iq729s0Z6HSZjxnV4UODhw1iEzAH9/DTkFUUPNGmHTZYhFWOY0TKy7NMkdgZjmNI+Tim+E/HMceo+Atjqh5UO9HFxgAAAABJRU5ErkJggg==", Dg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATBSURBVHgB7VhLbBtFGP52166IhZuUcGiqGDkVcqA94GCEZHoowXCLUZCgXJAKB860QgKJS4oUOFSKmsCBQ0FK4YB4SA1KxKU1uJWCJUipi2jVGqmxSJRWatI4D/zIer3MP+td79rrzdpJb/2kxOPZ2ZnP3/yvGeAhnCGgRahXh7sgK8OQxKNQlTCbIsi6u6qPc2xEFoKQhoJL8EpTwsBUDi3ANSE1NRyEt3yCvXLcRMDNCpPYkj4WolNZd8O3I0KKVCojUNUT2AkEjAuR6ZPbD3Miw1VRfmXNIHYDArJMrUEntZoSUn8fDkNUzpvJLCyt45/5ZeQLZUQjveje50NbpBTlNeH5n9N2jz22ZEgZE5nM7RVMJ27xTx2BA3vbI6SyOSXpPFvDVilbhdS5+LxO5vuZv5GYnef9ob7H8UIkgECPH70HOrEjkFLixoAwkLR4YYNC6pVXzzADDlJ78sc0UlcWuBJvvx5G6GA33GBlNY+ODi98j3ibDyKlKv4R1jpp5Wkeoxkxl4OIECFS4v13o86Tm4iMfnYZ+aJs9NGPIFWjzwbsX5KlPvPWWRXyKqf0JqkSfno/jsUPuyJD6GDjens62XgPI1XmxMjuuA1ezPAf1mB3PLbBCCmGQjzeKMqq04KkwMKddYQP7Ydb0DtEJvWntvU2pHKQNvp0WxKNbkoHDkjfuIuPTifwxTd/YOzsb3ALbn9vhBGP9WvkEpn6ISwV+Y21a1sm4kWnic0T6dvgZOS0XYWCbKgx9HKItTvs36G8yHzISgjCM2T6zbC4tGb9zrbObnIiMnPxFnOKRd4mQnFGhow6Gmli2DxJazAR0ly9GXRD1UG/1g5jZ1MW8rRNkz+kuVovHTnYZHYhqLdEU69jBo9GnrB87+3Z2zAmMXubk6EASorEGAHyVFLpu5nrnFwTGGt74BJDsZDhZfFYyDZtUN+nH8Rsn1Fcc4Oa28/FV9FKnbO7yAnPTe+jhtmos4xWGA8AlbyKtQtlyMsqOp6S4D8i1Y1gVWYVZqO+xv61TCjPjHXsyxQ3+n6ynfqyJLeBxVEJ5fvaZmzOKoygF52vmLUQjFKkZtQVJNEGfCyJUvSlwLfMbIyCJ5UqHPfXsHmpZJDRsfpTGSvfylg6XcIGI8jr7ypqNFlBzlLHGbRhR5TrKCbRX4HHoQxPqN35IuRcYx7Ut5BQvLmFe1/V1jQU0k4HwjnsABQIyQuJICValBW3r47oDavby+I4y/jvoUX8wuLPv4zItet3ebZ/861DWoUgivB2VVzMoBpFmjkwQqtL1Am0ADJqqrELeVmrgwSVF2ccezzw9csuZqntTEMJWy1DrqKNkwYFTkodlCY++TAG31aJGfY6lr72o5i1j8EqhIkn/7pg1ENi/QBuS7I0yJpZtAhydyr+eaYntR718W177GihYSwTMlkRMWgmw/ubTW53DHIClSPpG3f4gYBy2LGhw9qD9U2uUv6mF6V7Xio1sv9lhHcCM8mk3Tw7PiiSDY1+fpl7VT9ze6omG8qSYokrBY/IzmR72jsoWojNDY2zoS17X90sE5A8p7a7fGjxsoEfAo7DPeg25Bxkz/iuXTY0ENOvY3jJy6vMICzXMUL1OqbS1nXMQ2yH/wGNQAckzWD5dgAAAABJRU5ErkJggg==", Mg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOVSURBVHgB7VjNTxNBFH/TbQ00AQrlgKRNCoeayIHyEZPiQQycTMGaqNd68SzGPwD8A4zl7AWOfiQ2Kd4k4EFJCEg9YAIH2wRCNAGpknQJZbu+Gbrtzn4XC3rgd+l29s3Mb3/z5r03A3ABaxCoEfJa3AdFKQ6C6wbIUgSHCGGzr/w6jxY5ICQDEnwAj5Aifak81ADHhOSleAg8xxPYJaEi4GSGGTgSnpJoKufM3I4IVaRUmgRZnoC/AYEkGUg/tjezIsNUkRbwMQT1AIEcqnXTSi2X2Qt5OR6pKxk2KI51SVqQl29FzEwMFaq7MvpZTZUyVugsyVAoSq0N+2wJyavjz8+UjJpUqWlS28wtWXmpsnCeKApd6qXjFfJIU3DeYLGtiopCLN5I0j6cP/IgHHSRvkUW0asK0XTwb4CpqKkyt7vS7IJhreX2zi/IfP0B3kY3tLV6IdztB2+DB2pB4bAIm9/24Od+AQriMfRe7YBgZzNvRPMiYIrhCAHppa6vxvzHLHz6vMW1UVJDA0GI9gfBCpREen6D/WoJBjt7eGOWpMssKm0rY9R/fEYDK1+5kd1jqlH4UbEnD6PsV409VGLmTaZCJNzVzhQJXm5B20YI4LOBynkymG6lD+pdZpjBqSIRlPl+rAcHbeYmfvZiiZHVtnGqEJn1jQ4ErJa8MrdpLtOiIBZhaZVfvkYcXBSL3H8tFIWdQk3IspASDQYdHw1zS+Zt9MDYyBVHfTXIGxAiOasedGJvg5tra/N5dXaBziZdP7+BHQ+sMvWE5C82vSA2Wv36KO403fZFUOcNd7dX/g/1B8AWtOQto/rJJVhEegmrfiPXu9kXixhPqJOage4+6m/+cuyyBa2/FW7KQzl10MTqvF6uF4SDVl3qODkdkFmoAXT3bO38RjW2MaJ/r3lHnUwMMwoZCt5Li64kZvxHdmPQ4Pjy3bouCitQ4pY2aBoCTyQ8Pw3klVgSm01J0VQy+zoDTpC4F0Gntkox8jQZnOPKD7fORnBPoS/dBoOqkUZihYw6JSgQD49gd19ky7iZ3WW2wY4Ww93I6moXzqVrNuJtUuS/mltnpGIY/Awn0ZBPv99kMzy4G9GTMSnyTc9l7Bjkkt6qSVGHPU35wfWhZCThDrmWMlz3/+6g6Ohsb+foziBPU/+0u3yo8bKBHQIS4Bz0NmQWiu5k3S4bdMSU6xhW8rIqMwTcdQwpX8eUTnUdcwE7/AEeXHlSU+k4XAAAAABJRU5ErkJggg==", Lg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN3SURBVHgB7VgxbNNAFH2XNk1FkQhLWOMOlSIh6g02ChUqQkKUkakDZW6ZGWgHZkJnhjLRDcQEQi3tRrcAlZCKRLLC0iAItE3j4/+Lk9hn+xzTJCx9kpPz+d/953f3/50POIEZAglRtqeydaRnIVOX6dYGZJ66yTafyiqVK1QoQThbadRfWqXNaoLuuydUtq/n645chJBzHQJdYTUtxLJVel3pxjiWECty5GQeSoFFHAcSxYmPb+7HmQkzGVJFyndUzKM3qJBaV0xqpaIe7NrX7B6TYagX3LVv2FEGoQr1QRkdkUqFKtRnMgz1wjw/EUfoy4WZx30m0yFFwaJX+obMHaoyBggaOss7dD6FDh1nCQNGHdKXTtoKqQwsM3sYPKppcWC1MnpbIbUc/B9kvb6HWwXpiCmhJYEyjvAehxgj3udIzPNIq3IS1OBgh173G6VqLl/CCKyOWxdqXVz1EUoJTErN7BX2sUGXF0zqKkYxjQxMYBLP8Vv96wTncdpvLNFOlB2FQkJ9gRqy4xo95Y4/0bXjXmtU+whnkMOQr813NPAEv9pE+AXGyY1FdmxrafYu8gFCUSs4d8i4SFKvkCMexqZjBw/wA0Vk28PIZLiOn3lxlyxi0Pbd9YRglda14WMiXO+918FK1TSCJnh6kFUzoWCnd3DKN2RjNPG5Ltg2FtUAIQqwiqkFO9YVyIUookcQ2+TiB6ISIOQIfIhr5X17jrRg+DYJteYdY5rsYiFoy+tiuFMnN+l3ztTuJnWeU/PGUYSiwNG3gQNl6yVnYLTV4eGiuXSMlBPul3sCWjrOBpYOVSHEMyQAK8VpgJPnNimSNKIUBFa9Xya+SdCAKA5BLsT1wSSekms9C7fAOWueQiAXngSh+Vz23vumf4H3JYISrQHrpMQiRWkUGcY2rX/3sKdsjSBfBW0bGwiTNA6W6sjcQshSwpl4BT9V2bsktFBzbb6SgkyYbcfVcjEcRqfCvoIcQ/CZdo5DIftqHiZ2yOEf4cRHfg1/VB5f0BdTItOgTX4hZJMf+V3Gn0H0ufzCS4on7L9sP7Q2NC2c2xOlt6Uwe+OHYpRSx0CkMl0RamHXnimS9rHRZwRNYJ4zcYcPXR82sFopOEtCmrO5H1LlNk4nhV4dNuhoHseMzko4U0JiEmo4vccxvFAKOo4RdByzn/g45gRx+AtcmlHNs8N6mwAAAABJRU5ErkJggg==", kg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATVSURBVHgB7VhLbxtVFD7jsUMcqaUhkVqCg+IKEkGEYjeA6nZBC1kg1BQj8VihthskNhDED6CV2KKabliwCWJFC6olB7Fp1IJUXEqDE4mAYlBjcEipFDduItlt3PH0fDee6Z2Hx49W7aafNB7P49773e887rlD9BDeUKhF6Jn4NqpocVJ9L5GuRbiLAb69rfa4yG/kSFFmSaMfKaAmlWiySC2gaUJ6Oj5AgVsT3OSQRKCZESZpQz2mxJK55l5vRASKVKufkK5P0N1AoQT51o8p0XOeivm8HgpVNC1jJ1O6UaHZP/4XZzekZ5acz3SaoOqWjOizHUL6xXiEAtpZ/jtgf3Zyap6++PpX+utywdEORCe/zdDUmaxLp9xXh3ZWv/hahFohJGbh0067kVlavs4K5Kmnu4tGnt3haBvhe6G+rTR9/jKlphfcSanq6XpKOXxI+AzMZCOTZTUWFlfMmb//7gticDcUVkv02Zdpce5//FF6+8AwDe7ssY+cY5+K2n3KSWjm4HHDZzDL6fOLVC5XTJ+AMoffjDgHcCGVYvLp3/LmPbQd2xuml/fuNEZPKKOpj+oS2gxtbdG4NggBg+EeepJNsXu0n7o6A9QsoOzPbOLCapkKxZKVEFBRw3JK8FtaB7Sj8mWMB4fkPd1BMbt2ACVxQLFS+Rb186SsYyK3kRnFpkI131mV30U0QSUAqsBZ9zBJqNWIIEx8gZXJcNQtLa+ZJsckYXIJRVLXw4Yv3VEIy4Et5vbsColz4VqJVoplIT8OkImNhmj8lSFXMpgEnF/2O0RkVzBg9imBl6ItcT5PWgn5aJ/9zVAfRwgfBhDy33w/L0hhQMwc0SYD+Qm5CICpoEZDc2NddBAiZQRJwg3CMTla5uat2RkD55mU4Rf5K9dNMka7T0/8RCPDO1iZ/vqRKRbpGgvz3qVx+I9l0ZQVAeBHsqN3dfqFinbyoi2T+5fJZhcLwqEBD8WKyvOpbjshizyYKeQXHYV7aXxssGHuqQeQRE7KcmIFDr8VoRgrJoMJCS7+ep0gGYZYiXfcsmyLQPuP34uJJecM57WgRx7zNNl9hGkyKdCVHD0wcJVZg2QyfY5/Is00R6TNzV8Vi23+ypowL2Bk9CE2kd1HPIGS10GoSudYr0ON2spJr++p3fTY02O0PbgZ9jfLa/TPf39S+tQF4cQIhKaIof52EOKCnJeO4+ThRyenfheL7XP7jtCuVz+gR4JbXd9bv7ZEMz+coMlT34k8hfLDE4H1pPHXutpfOpjg3w/d2qSms6zMAnUwid4nnqFmsPz3L+J8gJWqt8xgE8AlyBHj0hr2FV+CV3wHISQ2kAE22CzGQM0CJh7iXOaaPnhHIl9altPNukT/3N4G6twtXMtZHsu+PXImRtV/lH3pdaqVsFAHCU2GKEU4aWIN6+XICnZ2mM/w/gofKMiMzAwgWyMQzOJOlLA8lg0OQthpcuW439hxIKwNAtHh7aKMaKVYMypGrGmoDoTZQGZD3c/qOPZodTeKYhtU23lYZtYmzD5ARlPfUF5Mzrq957lzrdXYrnuztnBHmVy9Vzx3rqKhqkbdHL11cB8+Ndpoj9/ixwaxCWiYzSXga8hXVPEn7tnHBgcx43OMKHlFlTlAls8xSu1zTLWtzzEP0Qi3AbjqRlMSP0WkAAAAAElFTkSuQmCC", jg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQ0SURBVHgB7ZhLTBNRFIb/aalRfNVg4iNi6qsLTaREY0QWotWNqaa4YKWpLkx0pUb34FoNsNGFC2l0pQuawEpsxAVtYkCmxphIAKslPhKr9UWJdTrec9sZpp3OdFpL3PAvYKb39d1zz5x77gUWZS4BFUoe9zuRkfyw2w5CljysCxf72ZkvTrEacQiCCAlP4bCHhOZQChXIMpAc9bvg+HOJNQloAKyM0Iff9mtCSyhurXo5ELJINtsJWb6Ef5GAHmHPwOXy1cxguFWkJ+zRhVpIQJxZ65CZtWxGBfIzv6emMLxT1tcS6Yn87JjHqEpJC9XcMvpRDS1V2kILCUNSLDXe5iwLJI+d6F5QGC1UdmVn8c8FS5Zfqjdm/SS/zqJhTT2saHYug/qlDvNKGfsW7dLVFRQ6pC6ztg8GXyI88oYDXTnXYghG0DfvRPl/b+tWdPh2GXfKYxvUkKIuGY83QMCo3cR0ksMoAyrPpTQQnuB1SOGRad7WWEJA60vzPkTbgYmKOxVffTSsm/jw3bRtkdhWtNKvB7KhDRXIzDfm0hlUJNoXVQxVQpNZG/fWhoL3TRtXGdZt2rnetK1OfJPWAckulAEiByWRMx/3ug3relu3qA5PbcoCQXCpTyrO6HEZFmTpU86rkhAh7B3gLDZUKKswJKswWmnjECVShnkOWSb5JY30XIUOi5y/lZlIqgSQEGcL5ykFMvj4NaJjM/y5WpEv+Y64DcBYlqkHkmPsjw4o+FDkMad+uRPek2cgjoTgafXz988f40hMi2g+kAsj46yscbsHa9e5MPszBTGSq0ttKEAmPnxjEf6AnodSXh1QFsPMowoidXQswWHcu9tw4Vo/h0hMivC2X0QDG3QiNozIEOA7ndsjk5/iaDkagLupjT8npkR0nO+G71Qnbne1Y+LFMA+Suq+O8m8dEEvIIUm006t+pERcmuXMZG4SNPPEZAxJss5UDGn2TmCknMViKpy2jCAJKPI8oQdy/AjpgOh0II+eCLKlu6j8ls5HXOqUZkv6wgaKDvVh2Qonh6KBI0NBFUKpSzCzv1LzZaxuSbFDgNA8XMqpmTK2Hrbjq0DKZ9u4zaMuy03WcceFbs2SBXHm6l1eFrxxtmDJ+q6fVcvC/b3cQps3rC4EYicS7WsBEOUl8qivlz1xqMMs4oZHpjBwrwv1zCI7dh8smC0tH1mCBlfek5/e8neqo5RFHgUxyPqgCTbtXKcZUe4tTmN1OTVPQyRpHPmsceb9N9y6P6qmE9WKPnfKoTZtXK2MHIfN3lx8kLSU5BNMjH1t795/RzXazALj/j2N8zHIJMk3PJfxY5BN6ket82uCkeztwr6QWLrYRP/joGjpbM8cvUdx9Ool98Je11Xu8qHCywZ+CAjAuug2JIhMXU/NLht0YMp1DE95KcvkiZ3mOkbIX8dkq7qOWVQ5/QXvcAIcbUPGQAAAAABJRU5ErkJggg==", Ug = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATCSURBVHgB7VhdTFxFFP7m7m6F1RYEorRCuzQVI5qwm1ZSbESw+mKKLrFqNGmERB58UIlGnzRto/HJmlYffCBGTExqqskSy5MGwdp2lbZ2Ma0iibANWBuEspTKUpZ7xzOzf3d/7t172+1bv4e983Nm5ptvzsycWeAWzMFgE/ysvxwx1Q+H8ii46qUuPFRcnqiOkEUYjIWg4ke4HP3M1x+BDVgmxIN+D1yrPdTkJR0BKyP0YcWxnzX3h62ZFyIiFNG0veC8BzcChoNQFvcz33DE3MyMjFRFHaKkB8UAQ5jUajNTSzGq4CN+b1HJyE6przXqEB950mtkklehoiuTO6qhUjmEpM+o6tmbRkZPSln0ZftU7pIJBzYhMze/hPc+OYbxiTkjE1knbKYuXjG0kcunrd2bXZxBSC6VyW4SZA70BjF9cUH2aAZh8+mXp2QbE1I9ckwjQuQ3+4zailm///ExOUD7znrUb64yMqW6SrK5LzWB4K9Thrbxsy2NlA8lfGc+235pOYYjA+cRPBPv9PldD+KxHXWwgsETE7KtQPPWWjmRyjvd2WYROBbrkr6UJjTS3kl6fZ7Mi9kNnpxE8PSUJFWzoQxdzzTKrx0kVUouXV5iGrpY09E+kUwvmYJWfUfBM9MYPD4h00KVd19tsU1GQAz8wds70bnbK9NCadF3BsS9mEBaodNP0VbnqQNrKRrDZZpVRYWbHPQKpv9ZwGwkCvdtLrhLnbi3rgq1G9blJSHUGJ+4LL9L12KyTQ3ZehuqEfr9kvQxd4lL14KH2LYBn0g5dYUefafuUhfGJ6NSbrFk+SAUe7O7OdW5IND3TcjwSBAKPU7+5y6pzqphnmRKRyj3Bk+u+5rGPbha0QS+diPuLxlDi3YYofOXiPAcoqRkklApfefmo6gn9XwP3I1TTj/+0JpknePPw8DMt1L5PEiNrVuydsOD5Y2/P8TsaqVMP3LHcXRXfgYr6J17GT9d3SHTVc5ZfHTPW4a2bNtRyUV/DtkKpIqM1Ng6QiyM64TwGbOrpDAoykxA79Sj9OOFTRzoPZkiI3bPK3seytpBFiBC3gTSCmkYhk0cGTiXoYxI/5A4u2xBxN85hCgghw0/kif5icmcclFmdEwYwrXYn0Mo/jpgX8Aiksq03b4dL5S1o6t8N3wlDZLMKB0JlkGPAH1M5MyojCkH6cZ/HRYgzhtBptW9PVXmcdWgzLGO6uZhGfQi0Wczwo94SMkPwSI4bhT8UHYYmxsxOpz76DeMAhA7avi/nxFY/A7h2DTGrv2FIcqLssaGahSECGHjY8GUkPSlmKOtEClB6J3XWlC5dRljm39BeEsIDt8M3W0PG166GWREkJ/nVevMa08y0jOoA4oagEl8Xbu+DLW7bIYkgozq6DB6mzkN2zX1hwLf93Y1un8LRLXS1OV3YWUjAgt+WMGFldqM/LloQ2RseUvXs090hwzHTSY6v/63dZUxP2PYxMC8PCscKTZojDBnPMw1jDo1ra/vubskyZRCRKaTyDxNyXJehP1TCHLC9BSiMb2qojRSUVucaBZeDMx4FVUhQ83DufhiEzWUS8YY8yQ6E3nTf0CY/rLmiFCbiPAfzrFAfZMfKZGYKzb8Vcf6MG7BBv4HSrf1apwjw8QAAAAASUVORK5CYII=", Hg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMFSURBVHgB7ZhBaxNBFMf/s5tIG6hUexFRSHqIoEITFLH2YCWeJIV40WNO3gt+gLYfQEjPXtqrCAbqNbQeSqAoiSAeemgDEeulGBuIxbhZZybJstnJzM7YVDz0B0k2M/Nm/sy8ffNmgDPUEBjiVnKTaDs52NZ9uE6KdhGnxZO96gZtUQMhVTh4h6hdJOliAwZoC3LLuTiivxepSd4nQGeENfyyV8hssabXPEwIm5FOZwmuu4iTQFCA1Vwh6a2GuplKDJ8VZ5M+xjEKCGp0th6oZsuSVbg7udRIxfBOaV/nnE1351FK1mToDI18ZsRRpTMlCOI+4ziVUxPjF2U100GfEpeMOfBpi2Gw5etMLAWLB2aot1T7qn4Ov7cwdSEGHVrHbcTGoupGbTvhX7rIQGXUWVbZvnr7CaXtfS7o+bNZqTAm+sXLMv/NzE3jSfaGvFMe2+CFFG/JuO8AeZnd7t4hF9MfsP88jI3SLm/DKG3vcVs5JO9W5icFQXw7UBDstPr5m7Rt/eBIaRuAbkUTOVGQhXkYoPKN459tGMH2RU+GB5lR2SSnpwb+X7l8Xtp25volpa0A36QFQW4cIYKYgzKYMy9kktK2mbmE5/DMJlQQSNx78uS8X3Chgdar3MMkRJDbG1yLBUN0xTB0xfjxCzJKpPzUvx7xzwnwxvYFRlKjC5eCAWxJ1l5Xvdc6LGDKoVlmD79Tf4QhLBr7Y0xfoDEs5RUEdbAFA5iQfjQOlocEQhGWfwuCaEIOAz9SDWosKNosCoK6pwOyjn8NPQT4c6LB175tFaBJbCwirZu6OA5t6InE/3dAUDcvcVehwd1bV6WikomwyNzHXQ2msWJgtCPL9LuGEGLjUWQfXhPKn2Zv6r32LIXtjhUoHoJJkl8/+IHyhy9o0R3+Hp218H0LZkm+J4odgyznDUadXzMxjv2Y3ClWh1cr+K8OityeGdp2WtfR1dA+LDsddsY3vGzgh4A89GG3IetoRwoju2wQhPWvY3jKy7JMntj5rmNI7zqm81fXMWeE8QdAwDNNTbUDyQAAAABJRU5ErkJggg==", Bg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAT/SURBVHgB7VdPTBxVGP+92Vn+l+5KQKmQLm3EQKNsG9ukNpFFGi+WhBrFeJH17AWPnoB4M2mCB2NvrdXEWC/bQGOiMbskRqM1djmAKWncIW7aSgNsYf/A7s68vjfLLjPz3rDQcuwv2ezM9773fb/v35sZ4Bl2B8E+EU1QH4yNYUPx9BODBikQYGLf9nKKGdQoSBygs4rSGBnoIinsA3smFE3kArqujxGCUQuBvbi4qijK5EBXvbYn7WoKZkaQGTcMjOHpMDV4vOmTakpkdzK5gGEYUZb+AA4ERGPZGtgtWwpcyaSDB0uGg5oB/rSYDrppEDmZg86M4NY1U0KG6O1hnxuZ5hoFHYc85q/W415tVSF4oamky/eIKGUqmlgThkN1CmK+b8dhiGRMIs2eyn1ro4KFh0Vs6dSmx4n2tqo2wsl1HckNXULKO84ubI1uC7NUKj2BKmTKWM1RLK4WbLLjfhWtDWJWllI67md0Qa4oni5r6Ww72Tkz4dzAI5WR4ThcS1BnPIS/uGD+mnQN/nr5nHAbvJROUL1oO04qGryeLIVrzg08Wh61G+r/+RBEz5SMexqR67nmquuSpZSiFFiW/OaJXgmHkRmWGXmuXp6dMspknNcyHKqVZs9n9V3RoBQhp2bn1o9MewluUDYTEpnmqu+nGtrzsxJDpF8gpCjoK1+rNINXMpfwUvYa1OKyqwN1LSrIPOt/uOvTLHoyl9GTvWz6qIA9pAVCLEMB/s+b9NTGZ2jN/1VSkGSBgxSWmfNbotOVm1AK8iDKZNu3ZnFm/VMrqYBACNtP8FfTl9i0LO3qgBgZ1C19bpISiLI+quVrjn5yBlAO3Orb1Ctf/HoneeXF1Z8nu85+pNE/h8KM6niZOfW2Id/xMWhNG0h+GTXJL00Hi/+uYPqXO0jeW0d2s4DuYy0IvxtEi7/B3FNoG4HRdMK2ZxspVpKLUNX43fTbwfstb4Xf6D0athFK33if1uX/B3vf0ZQCBhBgpL36bbi8+8QXHuCrb27JljD6XhCvn+qEC1IoeE5CS0FXcYXdh4qeplTdOzN+vlgpGSdjZoP1kuFFlG9gN1/ILGZzBVyfmXdziB+m582MSUGNSW7b9IHSZKt6uhJ0hRDPTGUPI2WyV9UpMyIHFhMrWFnLwg2czNz8A3GB+SCnb04x2xPlITLFFHGBkEEx59geKt5NBWVZ4j1TDbnNoiik9Eb+eoiP+KhNTHaCViwsNed+JuMnaAxPAF5WAYZ6lT3OxFdhSzKsYx8XFNkLPTk9E4OkbE+AFDkTibPW6JcQigmEDBkhNmH0u1AA8rX9Is7LZe2dim9L/1YIeb1iyTh0D58EMoenBp1jj6eAbKVmJCY2NbkYS1knzQLe2DL5PvkQjeqQvdzb2kFBFRAFh1mNbZv4SVwNnUea7QJqftUGBPuOYbIRopJJM3T4nbK+3udRDR3tzaJQwVGnyDryJZUqMDPkQEO9FyMXTrjuGRrs3lMWZbC9mxI+VTItRRz7wXPHkMsV8dvf/1VO7YY6L4bOv4w3z3WJNohHk5lmfRtwJUQlNaYGHpHXpiP09+Eu9rCdgOWUvXC+2/wl7z0y7zuOCMnkD8SvUVCnyNmIVvw+FHbWhLWJT0po+0j3SSLQzH9mkP2F2YfkGAr6MDMcYtI+/n3FiPh2CBCNbYpDN2bh9UTIychOdon0gDXPOvJBTMMz7AGPAVdoEEhpYE41AAAAAElFTkSuQmCC", zg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUuSURBVHgB7VhdTBxVFP5mZpeWpbQQCgpCXIhgKg8uPzZBH2pj34QGE21fTMCYaqpNStNXY2n1xcRG+mBMak2oJorEpBuBRhMbfhIlqUC3sdgAsWzaCk2x2ZXt7gKzs+M9d3dmZ9jZ2aXw4EO/ZDIz9557zne/e+fOuRd4DHsI2CDUa+1FkJV2SOI+qIqHuXCz4qJkdZBZ+CEIPigYhVPyCg3eIDaAnAmp4+1uOGNdrEmHgUAuEXqxJp0WWrz+3MyzESFF4vFTUNUubAYCeoSmgRPZzezIcFWUYfboxlZAgJ+ptd9OrYyE1KvtHojKJSOZOwvLmJv/B5FoDC1NlSgpdlm2fRCIYHzyLlz5DtRW70ZVxU4zKUV5Tdh72WfV1mFJhpQxkJm99QADV2b4XQMFyUTo+vQ9bq+hsmIXDrxUjZbGKuac+ZSkSyyGpVKWCqkTbfMamf7BG7jy6zwvr2O9fbGpClXlhTyIHYg8KeVj5Hw37/Gy1gN1aHvlWS2yH2KoQWgYCdoSUicPfqZN4N4ffEz6O1yJztc9qKspwaOAiJ39cpzfW1iHyFcyetpENxFKTmIuBxEhQqTEySMtcG13YjOIRGWcvfAb7rJ52PmGJzF8BFmqNg6daGrlVLq1R1LFs+dJvPdms05GdZYhXlAPVSxANpCNut3NL4Ir38l8vcCHPd/YOb62paArxNcbRQlYOY+VtEJ+4pCJiCMwDOf97yHIS2lE5MpjiO3cmwoi32e2/byNBYKQQtXaXEopRL8DC8hlh7BW/laaKrHi/VipOQNVSpWrzlKs1n5qIpMoL8PaU8eYr8NWIdivqFCPnSIk4uX1lhTA6OS7vn6cv/AVFhcX9UCkXor8YcRZGWF2bo7bDgxeNnWOhjwN9F9MwrAOCc/TImGEvDsV7PRHHzPnQ0liffj2m69RXl7OCL3Kh46gJJUhwu8efR+hUIi/T01N4dSHH/BnUi8vPG0mxH/Smi6pUjfWwzBMGhlCKPQQI6NjiVZsyEgpfiWHb2RsTCfD2w4NWfo0iOG2IGTxB4+H9cemxkZTVV1drdnOYFtXW2uyJSWtfFrFFq1qEc4HJurh+GlVL+pmkhMpcn7yRJdOUGLyC0qYX1L4hk7+nSNvc2L0fP6Lz3U/0ii4bx7DAqnPfqItwJmS4WgTW8kSDVY7D0JxVyAT8meO8s+ad55N2JXqMxltJf8CtvX+mHhxRYF9k0BBlN6CQvNAMcwKCX5+I/aRFPu8vp/h8M2kOReY9Ntuf6KT4c6YWlQmGsqMZMiXjkhiFBJgWWYShq9Mvc7U8WCp2Bx4ZRV53mFOiitV9BBi6R8Q//2dk0oLvHwVYtSP+I56xJdYwGAhJyOyKw0Ui0ZkR9SXTiiOEca6Axkgak7d7Gqehh1INSnALh9bxf3ltraIbGfjHh3V4+gVLCHHrlD2hNwZQ85wytltitjy4Ax50wjx3UFe7CJKA/YOnrmNnPH0gn09qZ0X6zXmRObPXhZ7+HC4otYOnvtL+ypyA/We2liBYuy5BdqRGIvTE7SJ1h6EXcdxs4ZPSKyxVKFoGahlyhjUo2TLDqb0lvz8Sf6SubX774Q/p3xOaB60Tj90Qok05Bpsdhpa8mYHUxJmBZ7CSg3rN5LWOXWW7Q+pM/DLLOzQxvLnTJsAu+3QhrZBWwK+DZLYNsjrs662wf9qo2giRhMdwnFsCuo5SI7ubIcPGzxs4JuADuQOOg25CNnRs2WHDWnEtOMYnvLyLNMN03GMkDyOiT/SccxjZMN/tfwgpKxS8LAAAAAASUVORK5CYII=", Fg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQmSURBVHgB7ZjBbxtFFMa/2fG6dkKDjRtTWoLsHsKhBxwBB7g0UZGQUFO5CIUbhTtVy4kLooV/gFQcOJKKEwhVkZreQA4XKqWNYiQCUg61q6Rp1CS1m8qxE3t3Om/i3eza69iOnZz6SfZ6Z9+8+c2b8eybAV5obzG0KTGXDKFsJMG1MxBGQrqIyeJQ9XFeWmTBWBoG/oLOJ9nQZB5tqGUgcScZg165IqtcdAC00sIEtvl37L3JbGvmzUAoIqZ5FUJcQSdiGGdv3/qqudleMCoqRkr+jKEbYsjKaI3sFS2t0QMxk0x0FUY5lb78RkrMfJRoZOIZoa5Hpr7VhpHyjtBBwpCsSM0Nh5oCidnzPxwojBPKPHq1ttg1ZNWhyuAwVeZx59C5I6Qb15rV3yyVsbi8gYX76w1t6Dl9yLap1Nq2KztCar0xjJxXHWo8/f8K0vMrWM9t2uXfXDqDgRN9Ltv0fyv46Ze79v3rJ17GwGt9OPv+qTrbqvLgz+JsaFqt6D67mF4HNTOKGp/4PW1HoyegYzB+DJFwEMfCPYi8EqzzPhiPYPTsm1iTdddzRSw9eoql5ae4M7uIwVMRfP5JQtbvcVaRr6KjSXmdcANpGK51PvXHgoIhiNEPBmVv+xTUXuoJ6jgnbZ0imL9nl6SvNdz6c0FBuUTvxSrQ7pDdOz8nvxO1EaJeUs+6Ieqcd6dEmr0zNeQC2lqeyumrN0OsvIrDlNB6Uen/OO8fGAu7gAqlbUFXXy4F/fGvqAWrhEZQeXUMbcsoKH98466r2Ow9veMzPKLuewN+xWLPoUDmW9uAPrwwrxxp8qqAJIypR9G25Ohsn7yE4MZnNkg5+ikMeSXxwr+ynd9scxtINpz3F+ZD9LAcHVNQRvx7GanHqsK+YKoSvBcGdVR2mECYWYBvbQr6+m3lHyqx21HDSS0kQCU8rBx1AuOUBeJbu61+O5DtSe1zFP4jv2wgKzL0Iaitk1+iE/lXfgZ/kqoBsRqTKW9Vu0uhielGznguhU5FkfGEIVH+XQckE3I4xvJQpT+bRC0Q7Q7KkdEbRt+7EIEYDlo0R6ktI/LhhPUeUxxOo2KxGDMZV+kHhVcryh1NMQOtsort41+gE9EcMn39MF86DeGPqgWRpAkjHgwGs55ApNLizXF2JHrZ9MvKgTgOQlopozormP964PiId/phqZqGyCVgJ2sUEorgtt74Gp3oyMMfJcQDsFLGajkLjQ/VbiTrUlhlUOa0nmfVvXTAN2bQqXhu2g1DSb7HrtYzyVcppckvWFDKoVzi9yut5MiKCcbgFxrtzVreKNK/giakqfejHTFzc3dBbGGj2NLeXtw7Ny5NL6MjievgvmvNDh/aPGxQm4CLaF10GnIDZd941w4b6sCs4xiV8rK3ZEkMruMYVj2OMfd1HPNCzfQcvG/Is/9lM9UAAAAASUVORK5CYII=", Gg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANpSURBVHgB7VhNTBNBFH7TpYQ24U9MFEKTlkNNwKStcKkYBeFkCimJ0SN64KqoVxMw8WoELx68YLwRDyTFmwQ0ISSIARJiQg+liQQ9iKAkQKjbdd70b/9mdquteOA7NDu77818/WbmvTcDcAIxCBQJZTlaByk5CpLjCihykHbhpa/rsp93qUUSCFkBGd6BU5oioaldKAK2CSkLUS84fw1Tl0EVATsjTMCR9IiEp5L2zK2IoCLp9AgoyjD8DQiMkfbYPWszERmmijxLH71QChBIUrW6RWo5eB+UxWiwpGRYp7SvSnlWWbwW5JmYKlRyZYyjcpUyV6icZBA5pZa76iwJKR/7n5aVjJpUunpE/1ozZdmp2oB/iZTkU0+dViGnPCry3T9Mweetn2AXaLu9sy82YrGtgLxCLN7I8g7PDzt+/Ow9I9XT2QI3Im0gwuT0GszMb4C7ygn3hy6Cp6mGZ7oL0p6PhOZYRC8ohOlAgInXq4wMYmY+AfHENtcWvyEZBPpMvlkTdU1TUXV+7AIhB3SJvOKJb5r25hf+1G1u/QA9QSEwLxoIAQmIfNxVFZq2S9fWfHNV6nydIARL0gZCilfk09ykDRn+lgaubaD1jLbddhbEIF4wEhJn8FvXA9BQ72b/9mbkPHvmwe1yQl/POWbr952mz36wQH7swi5b6lPgGEE6YoyLWqGiCqkSIz+2elEn4dhAq8wsVFtFWaU/QSgCGCzjie9wcHjE2qfouvI01gjXlymw5DUQSsMc1WvQjj/GldjMOje+NDfVQm+nD8IXPGALWH/nuOUesqkDwyt3t2HUff7qg3WgyyLc7mE7zFIxaa8+lzq02X6pf4z+3jXzwel58mIhnyxxO2N+8jTW0gFdecKbNKGuU8LxjUxkRzIPhsJ8UvQQQGvt24WmmhCn/MCBMLEeHGQS69VLPsvoi8Rjb+OUWEbNh3cum/voyg9DCassRahKRKMSTtHKp68Q6fVbpwEOsRCN1oFWfcRWxknHtHn5kTfJrKVlKHfViHW1QwrpD5KGEpYZpKRu+piEcpLBIt/kVGta5LM5TUsDZSGFZGRpgHc2++8OirbO9mYLvXgo4yBVjFpdPhR52cAOAbaieRZ4G/ISUhVjJbtsMBDLXcewkherTFbYqa5jSPY6Jv1H1zEnsMJvWXtXCbpufXIAAAAASUVORK5CYII=", Vg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQmSURBVHgB7ZhfaBRHHMe/c3t7uUtqPZOagrXtHZSWWksTahNqH5oUCtK0clKo7VPe+zd96VOlBkofaqERfBJBfVBQUAKngvgn8UECMRLFf6CgRxSNFy45lcQze7vjbyaXy+7t30tO9MEvHLf7m9n5fea3szO/GeClvMVQpfhoKg5NT0EJfQ6ut1ATCTLHS8V5qpEBYxeg4wxUpZ+19udRhQID8aFUAmqxhx7pNgEE8bAHs0ov+7Q/E6y6H4iIiGH8Bc57sBQx9LGP07/7V/OCkVHRB+gygVqIIUPR6vSKVsitgA+nWmoKIxultiL6AB/+qsWtimOEah4Zu1fXSDlH6FnCCM1HarTD9nEotrrnN/5PfxvMttzUE6QHxnH4xANMhtqRXP+LtIcKGSd3uH7zEXYfGsPZy2G83vojGlZ9BqVwC8yYMVcjmLpo787rx81GyysrvapbFls0gf923cCNa5fKth9+3Ya2L76FmjuKyPhuC8x9vh5b/txRvo81vIp/9l1ASMuibuxfeyc0JWl+ddZXpupbLTDqShTe+gO53JSl2mT2zlxbTV0oNnaV7cV4B65m37bUfTz9UP4MtRmFRC+40gCrz6JlOikDyfkG6DYX6g0fyIY+oWiY1Wa6n31tAUhr/g4ftn+JxubVZdsbyTUyStIHwejLO2AV6zaPpfBCa7QcVAxxo36t/N/w/W/SiYjMO2vbLQ45Ac/3WsDHVOCnv/dj+PQhCdJW0Rk9mjQ5laKlaFmK/vdYgULogIcqG/aSABadCCyxLpaATDFhH1XWCz3JwE9isDJ9Wv7Eta/vmct2o1ykS+2ZrAnbw/kBXydq9uDCNX11XhJtKdNXHEpYwgHIvoKLXteNbXOFEjDh/GD5PkxA6qQzFDOmEaXPnmkTTsVl3+V5iI98w+Ei8flrzZtpQCYobPVgsxNQJw669Hbu8y/GO8EjK+W98vAcRe+IG8wcyLo0qwSaQjV5Tm2VJ6AV4sI8qDN4bqIssyTzoL6I5yWR8pa0MA8ZGCS8bixSt+/O4Pb4Y3ldH1XQFI/gzVX1wR4W+bcNiBJy6LpY6QOPI5EFnByawND5HGYKuq28aUUEW35+XwJ6Sn3UbwMSuwM+snEvvbpAU+yps1kcOHanAqDOch8jEAHqCUSbANY6mLcBSWmhPlrxfYHSp+4hffoe3k0uQ+ua5Xgv+QoaCcY3Ek6iHYmVr0J85Os+MrtCieRLRGZz12oJtDTx7WzdkR5vIJGG6PooXFLY3NQsYjFlcdGwes7QtihZabbl1HKnqSmddJlxakcM1FrAiCTfqcgxyZcppaFscoNaMoyubHLbm71wG8VAe3u/gR5MfDuU8Fa/w4cqDxvkJqCa2VychuyFFu6r2WGDDWz+OEamvCLLlImd6TiGlY5jjEUdx7yUn54CPueG6V+mkecAAAAASUVORK5CYII=", Yg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQdSURBVHgB7VfdbhtFFP5mZtdOUkQNIqCKizoq3CGRPgH2E9QBKoEUp+4TODxB4ydI+wQ1IRJItMJ5grpvkEpcUEiouQBUoNSkqE68njmcWTv2rnfXXlcmF1U/Kdn1zPn5zsw5Z2aBlxGVr3/P2z/MAU4aofU7j0tCqqo68a7XP7/QGp832cx3RJTj15XxOUtUZ9xtIdDY+fitL6f5kkgBSXIVhILOurdjBQi5JF2dyW7zowSiFaTxlUZo5+ryFgSallT57pNtpMTG3Sc3eP1K/Nra+YRtzIuQhRLedWuYl2Nz/c5fpWnylW//LBBoy+oo6RWREqkJ1dcutMiQJQXOh/DWCbQ5h9rBIaOkv5JE+guri5RIldSn2L263OTVWRPChHJGiqOiVGFZY6hm5XY/faeBGSAmTdKjyiq0vse5U4OjGvBQgIumWKm3kAKsn2OdktWBoSrIbPKSFcX7u80kHSfWiDFMgvbh6fu8qTmmfQXa5LncqtDiFottIg202fJ1DOocVL7vQOTpoHyP9z0HKYscXGiroznUA5c4rfJbJTRuBqUt6DzSwiS2g4LvwxuQDGC4QnS4UR0Q2cNZQfRydFjmAhH74tLOrRAhJnOz/zS/TM6seULalarYzsrwCaUu+7PC7IRI/DN8/bFc4SLID39zVdqxgPU2ZsQLEOo78R1LbpC2LZzCmNt2jB6ul4Ky8yMk/SS3+ZWL0bw2cPpgRHbQrZWoIhzESF9QHhMQ7dSCPgr86BsWYpXHV4f2+w2zMHDWCDje44Kw4wX6ab0QsDo6+4S4MRq2B2+4guJWqBAzBuoRur92cPzzEeD1Ro3RVc3hu+3mI8fXrKz3xzFMRyMWQnwYGRo6PCgTEtB5+AzkGbhvZ+G8mWkLR/a3gLs5HwOXQ8QPNh7x/3w/CNPWR71c97cO5KLCwqXXklxAvPeVz2VqUh8f/gt3OYulD84zoQUMyfQj3I9RGTZWK8sB+LrOGxl0fniGaZhIyI9sQdlViRfQFO3qhuJI+jbkovRtpiQkWuOTvb+7yLy7OEk7Wtau2k8Sz148B+/xSdxUa2TyFAb3x6XIS0wr30jcNYJPb0sosf8IN/ZcakYJCVMfl8peXEIiiJK/IMi/osTCFkYEStUihPxoiWpBucTcIXrA8ltIgiNvJiS8XxhjtmrBC18oqa0T3TXTrh9NOE5hkoB/6ZJyDYGtiAN19d54YJFOrZ+ftM1zCbXo2LKFUMJGAdIE3dF77uVvpn5xDEi1+FH0vv+soRx1xbfDXwf8ocBEDExXW7NPx/UihDKvL7GShmYFWCXdT2xh7bnyKWaE8TjBvd7IDgdp90UtOdYephI6VXKcmBb1Ahe3zLmMPaRTy78EF7T/Ga8ITUPMBU3WYXQzVlqoFmbFvO2dNf4DPvueszUWgPIAAAAASUVORK5CYII=", Xg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMfSURBVHgB7ZdNTBNBFMf/0235UAyjJiYmIAsRiRdTzzaRBky8WWI8qEEwxnjEePNgbA+e4exBG+sHhAM1JOpNjMHEmCAHE442FKERjUUtCezOjrMrDW0p3ZkJ4cTv0pmd9978983szCuwR20INPk7fSkcCuGtaOaNAIk7DqEcTtztEwt9dWfGZ6FBEJrUhTDMASqalDl8BOB0Y4g6BuLiNwYNtAUFm4Rr0IBjMbCC7YkxGoMI1BvgltMGTbSWjH8dpGDsV7Fvr6x5oYLNdZtGhtFO2pMZKBKADjbC5VHI1lezQKGBniBiS0zGwtBATxAn5pZnRkWKyK5miJg7YlMFzQxx09eG8GZooJkh+E/m8F3cQ4D/ZLu1ZN4ZBKkNS4WtCUXUM2Qx+SvBZsrXh7qgAAakbQkuQBGdPdStYBveWGJplASJ4KpfDhVXiKnioJYhZptQhav5qAkSRRhUIWo+0uWH9wkz5laIZuWY/Wfdu/GD+0PVXDOiFInKliLbCoqlst0gRhgWSU9E7pogbALbnD8+glzycFi0b/pBBqH6QQTsTPrKsbSUIE9IwHhs25bJbBuXOz7m+1tf10y7hCCPJ9nz+fH5CCWi9jVCoYzYA33pqy1ltXfZHoo9yw0JMd6yrCzn0Gs8gp8YFa61vqFR/hD5Hzm3a4rpP8eeL96uKij2Yum+UDxS7J9uc3AnMg8pRHaIIbcd3Zhnu6zNBxzD/+euECRu53ip4092BKusATKIpcoYDcG8jO1SoQlffneUPyyZe9vPvsAaMbkUgRQOEuJNEzKmc6tdNcdrnkOTuYh/ljhPkBOpJOlMjbht+DD27Ry0BflkaUoIiJLOp/HiA6/t4Lo3VoXRhV58XzsIbUEubpZKgxTsBoxmexPkeMoVM1Vp72VLjLk2pX5u2y87UoLcLN2bu+UFzK7U4+b7fowt9vgeBWMLPXTow0XPx/V1Y8gg9Ve6GHDm0wyajjaB7jP8a2pxhy2vH8KNV1G0nwz7LpWSoKKollM9Gz32zt+DzB6ghwdAo8IX0qgXaART4rhP+tpZa0mx6V9ijx3mH6HiGh9bRFHLAAAAAElFTkSuQmCC", Wg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAROSURBVHgB7VhRTFtVGP5Ou3Yr2I0FHWkdpvVBEx0OpDFBHqQhblHYgi/oYoxiMp0PZuCTb5PE+CrzafqgmGjcFhMxQxNnCNUEMAiBKQ/aZPQiWAKzo67CoOXe6/kPvbe9tPe2lU5e9iXQ89//P//5+p3T+//3AndhDYYSoU51VCEld8BuewqqXM9T+PjlqrQ7ziMkMDYNGT/AYR9gDQNxlICiCaljHT44Nrv5lJezCBSzQj+S9l7WNCAVF16ICCmiKOegqt3YCRj6WOOVnsJhVmSEKvIwH/pQDjBIXK2glVo2M4c63lFfVjIiKc/llIfV8WfrzULyKlR2ZXJXNVUqv0J3kgxBU2qqpaogIXXy5Pt3lEw2KcV9bvtlw5altyqC/xMpuz9764wKOeR3rOauracQno2hWMxHbyG2smYdJO5tGegKifuNLK+YzaPE737woyDV2vwgOtsfhRUuD85gaCSCin0OvHX6SdR695uFxmFP+FlDSNzRMwpRObBA/5fXBBnC0MispVJEnsgQaM7lb2asUvNS5NbXzhCyocVq1kLUWJIWFm+ZxoZnb26zC2wz1cUcQmBHsVsQRXoLWYRUn9WcpsYHDPbRR2pMY7f7mhprYQ3mQy4h6wre2uzHYc8BcUifbz+C6oMVprEVLoc49BRLc060PoQC0NfO/MomTqjYRbDAFcElW6GSGqkyQ187+1BL2DXwLjON7EN9DbsFannTyBBSELKak1ScmFwJQFr1Czt62yvsRMotbBr/nnjY4PtroxpFgfrvNPboF3lDzksHVfq8v7bQz8uQ7gsAN0bhnOc9vOcw/wtgcmQYzvXrSD5+Bpsrv2Esckn3hSMxeGofQ7UzhsV1L3wVEXj2ReF2JIzJHYkBbWis9hMn+/j/s/kIvfneOOpe+BjJxBI2/lnG3nsOwemuwe3YLDaTq3B76iDzzzVuaz6y7c7KnFzuPQl4XFFOUMIh13J/5RMXuzSfsdqnbH0wASWZufgqlma+FovH534StvBxm8bzox/pvvDg23nJEBKbboT59l5dOo7PpJde+fDSt1/lVWhLpXZOip01Iyat+jB2sxlH9v+CugO/InQjKLbjVO3niG3ci6vLx4XPVymJcxROnysNpMyxmu8wx/NM/90wHU9WUdmQXu9s8+cntNWGTKEMXSMp8cUfLxquEXFxhnhffeH6mV6+RZ9wEl2vdbb1kz+nhRVPmil7kFhjh6Btbjw4odukjkaGmnwbGLWwkkYmLyFBilpKxf5cOUgRoabqUTFe5LeDoaWn4wtr93ddmD/dQgWdq9NrWNsqWTkfh+je9D0/xBvKXjKlraVVaGdHg80qCSnFix6foJ7HDuF1/Xne65prSJcoH6mjyLbg9jhbMclYYLCbng748FOUhrj4MvRkwXMca+uZVmQWZIyFoKg9b5x6RspZCyVCfx0jWl7qMkVjl/U6hqVfxyj/6XXMXRTCv304tQBFcW+zAAAAAElFTkSuQmCC", qg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUOSURBVHgB7VhdTFtlGH5OTymUWVZ+s6ndYBoSRyJlkCXMC/kxRreBnYugiRvbxcwuTMTs3s17E9mF7tIueuVPxgK6RbcBE8FhscWMGYsysIQfB6NAaMfa0+P7faU/pz09LYxkN3sues75fp++7/O93/t9wBNoQ8AGITttZgQkG0Tdy5AlKw1RSsXm9WovtZiAILggoQ9ZYqdQ1enFBpAxIXnQVoqsYDt1aYsjkMkMdjwUPxZqOycya56OCLNIKHQWstyOR4GADqG668P0zbTIcKtIPfRaiq2AgAmyVr2WtXSpKuQhm3VLyfBBaSyD1CMPHbRiI4S4ZXTSpVRkFhZ9sH/rgu9BIGUde6YkJYqX+ByZEkpnma7rbgwOezA1vaxCyM/rPv/KgZSIWMpZZ05LSB5u/jQTMoX5uSjfU5hUz8pq91mI7BIufPmbtqVCprOJxQpRr4v4bnwZG9DnD2Ls7jycd2bhHl/gZM6cquVPNfj8AVwgC7nH56PEDxDJwnxjcp+AWBYvciUhR5OdHm2R76+7R3H9l3FF//KyIpx4qzIlmXh0X3Nj4HePwkqNL+1By+GK+FnPCzXd7UmEeLyRpMX4AV1kEdfoLH/f9XQeKvfuyIhIPJjwR2gMz8wyt5y1YgesNE4cvBBXyoSqXq+S0FDTCVLUF+kmYC5b8Pq4TrQwODwFo1GfOLk6Qjgp7O+ys1d9tFCHunT9mKC7r/3F3wdI2GdOHVBtx5Y9Ez5DK7mngdykCbYvUrcwjSiESqRBZBIGZimPyrL3zCwp2nWRjtQwk/Uabhs/gjvnfawJxdFAGUdILoUGmDATl/AUTZ7czq/4ZhpiLo7Wr2bjtu49TBOhNaEAK7rnMW54t1SFkPYObszJSipTE3iuSrtIXzb5lf9a0Duyqqj36SxmNUKayDVmUTwpUpBJFRjjidZWWzjJn2dr8N0/jXihoho7dyqFXrLwQ/Q9tsocTWzJa1qJLVsWm/z0bGmqSBkC+H72zQgPhK/U78Pc9uMIzuXhhmcSrzbWJ5Gx3LvoFd505CcQanbSrxVbCOai/sVDGPj+JlpvDkN+x4aHrzfwOlFaxXNTn8C0Okp7p94lvHGripXHlj3kEfrZMkLMRX9M7kJj/2Vkz8wiOxBEqO9XTuip1Tsom/4MhsA9wED6Kja7Iv1ihELoJUW14RHBVpEbR2F6kA/J9ROCY+OwEBlpbzn8p4+FXTRnJ/WSfAu2A3nb2Nx9kf6JWwfbWDPPlxPAXDQSaMXV7h68faWfW4Vh7eghBI/UxVyUYwCKSDJ6MdxRXMlP2jo4KUdzB/1+gE1g6H4tbjhNsLnc3CrcRcWFZJXjMO4OhF0k3yci9H9zsmMd6RBAufbJyKdeMWpA10HpR8aEWNCbWTJC2n0ahmVKcJyXEfz7X04m4qIi3S1YJu1kdxO5p4RclZDG04kk/jMpyZcdh8lKQlpSLC0Z/FOE5cVmCPMLkK/+iOxQFkqCJpQ0H4u5SBpTukc5myL1UCcU1hKFAO2skW2yLOAZKWAWmsPxiFmMbSemgmdxsOYZNFRvC4tWDXQCIVeVJRbrk9rRSZMyx3qtvFqQwXd6tUjNwDZenkcxF6Ugw45D6lUpwI9BGiePTYORkcQjwv5Ol3q1Bh7HQTGjs32mQk8zynmI+nPpLh82eNkgnQM2FM3ZbchFBPQdW3bZkEQsch3DU16WZfLELu46Rli/jglt6jrmCdLhfyalLwB2sDlGAAAAAElFTkSuQmCC", Kg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVcSURBVHgB7VhfTFtVGP9dyp+1S5EBbjIEizEUjGEUNhzw4GZDXMzALjPqwwzTxBc3w/RJ4wMs2YMzS2Sy+aDJRJc4E50r4IORsWkioGyudTFbQR1MYLitHR3dWkq5vZ7v9N/tn9sWh+Flv6TNufd+53y/8/055zsHuI/kELBESBZTHnyiCaqMpyCJ1WwIHXudF/zsZBITEAQrRPyILJVZMJidWALSJiQNm3TIWtzHurTKCKSjoRsLqv1CvXkiPfFURMgifn87JGkf7gUCOoXavjdTiyUjw60inmVNHZYDAiaYtbYms1aG0gdpxFS9rGT4oGysbPGsNPJstZJIQgstu2XitSpaKrGF/k8yhJClLFvikiMzTvbXlg9YAOtGRr2wTfow+rcP03aR/4oLVdBqMmA0rMKmimwUF2Qm1Dfn9sM85E7Yt6I0C5v02ajT5+jg17Yz8ahAj3JZRXVNx96W3PZzNi9GRheQCntatHi6ZhVyNZFhzD958Pnpu3AxUslABE2NGhzpndtvs17oSEjo8Q21s1JwjaEOrzOFdTJLuOcXcekvN24vZOG9E3OYdoiKyt5+KRerMxfxWEk2CvNy+Huy+LR9EUd77vB2kIDTLYhlE1YrX0DDMUTrzfcH1+WROwjEfgf7hcg4Zr04cMSGj7/4E+5bTnzT8WCYALmCfiF8uDefyxz78g8c6LLB7vTy9xUlWczdahhrAjpI11BXEcY/jYRSZBS2HdDM9jyn5Y/kdzmsl27DPhtw48DQDbZzSGEy/QfX4Zeuh8KkaBLDFkfQqiIGBm8iEV5uWo0HNALbirSmeEIZ2MIVqAOvYmNgcsYTbpOS67cCJq8szQzHUMi6Lo8/TJ7gmY+eHAV7aDIctC/GEYKwgc8umA2xQV1SpI56vukKkNCzGAmhojTgXhtTqFmlCr9Xy9qEy0FClcyFHHyTjiMk6UKtJ1lakoUo9UOory1A4ZqA8mZjEXoGAxar08sIBRUc77/DZQgFrI+xcW1YhoKakoGSRWYMXaglX0jCkbWL+fa0ZR7vHnPy1NaztYNm0/aqHoMX7+LnK8CpQTe3ZshNAXI5nCBZt7hQg21Nj2LbZi231rRjESO2BXzU4+KypgYNEukOp710vlmSSxztdbH0dEEJZI2uN/JZAEe7g5Jh9/t2xSWBQIlDE5VD2NgnxBKaRUydQ4MPWD04x2ZMLqTYWs8yyGjI4dZIBnL3gMWL0clALBJxPV+lcyKxE4GTEVoTQ6jFwv6rsSKQrMLGbw3Ukgf1b1gpUMkbRISQHz8oydOWcS9I2Z/q7zhCrCAHL9LjQav0O4d+x9gV5SBXAvWhLcd6OUmtn+Uyh5pRmyuLo07235aoT/fJqxi64EB5mRYNNfnsVwAlkEWmrnnQe+YfjI27uOzunY8kFmaHAFZrvxJ5lBMKVIrjiZWI6P76animtLY8XKRByXo1NDmB1Hd7RUwyIlMzbi5PMFTmovX5sqiVOwo+VZm8cowrYaXz25mVhDYooO/MDPoGZtC86y0Y6p+B/foUrMPf8W/lVQ3QV23GUP9X6Dt+CC9uL4WxYS2UIR1m2RV1moknRMceUWRLgHIJ62Abp0O9E+WNr/FnIkB1aUPTC/x5bPAT5M+fZHVQNhTB6mrmqrLY13E1NT9p+lRbWXNCaSzan8qL3Uqf+bdUZKjIT/xJAfwYlCGeQrJiv8DIaognMHpxmA9UXlUPLNwArp1AUjKiaodQZ7Ym/pwEK3FQTOtsnyrQ04N0GKrMjlSXD0u8bBA7WLMV6YNuQz6DL7Nz2S4b4oiFrmN4yUtVJi/sZNcxQvA6xv+frmPuIxX+BXXBJKRAd2J/AAAAAElFTkSuQmCC", Jg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPjSURBVHgB7ZfBb9tUHMe/z3ZcJ6TF6eDCkAgCiSOt2IZ2Ij1wAARkHBHdxhFx6PgLmv4FYwfOzZnLgnpAYkjpxGGCTVo6cZpWYiZt2qZpddJkcRzbb79nJ2mdZLOdVuqlX+nFeX5+7/d5v9/vvWcDxzrWEYrfLuqi4BAlYUr5IK5bh+fe5v98vhBq2z6/yu8t1/ndbxeSjjs1EHrI068OTldJrvJbXxZ9mPr5C+C8RH/zYEoRCTU1EDtTqdHF6FdF2K7yO99chcvLw4c8r4aEmgjE6xd1URAlWV4L1e1eEc0m0O1SsWpotkx+o5gfG5/u8ZtflSa1sbGH731HbmbrCGZdFkbZu2VjFJhmv0KhuQTL0qkgQpsU2t/ImgHGPvT7BeNvslMbSxFAy3XAz4+BTCoVePJ1MFenHl9TvRDqJICioSaLy0vsdGVzIpBYHf2ETCoDDfMKeWEF4cnEUchLwxyiMOSnhKHO2GIfbfzc3rYrXpcjoQr8ZrEwBoSeU8K0YviEbxUvZ/Lqpc59B4mhmLu6NxSJ312+SGjrOIg8D2i1/Kv1IIBK5SQosxJtRyy6fz+XAg9JWMVBJdFQc3OApkE7qfiFu/DhuBvDY30vKf3q4Z1HBARVhUTeUmfIM2/IcXsWxE/gIc6v4DA18FYmE/yPpYBhGFx/lbluFcmX7VBexw140vu8InLL37m7kzuJzdLFGjuzUQ6qo5xBgl/GlGG0tlv+VXsvG24QYGLztO19xvgWFKXAFivmHt8EHdRbwlPP/21APZmG+lY63Li7Cxo78IxNK+tsxdjf/NL1mARKADg79phx+0FneF+ZV/3npF5beMuko2ip/8aAWEBJoUSohEERqlAOkbr/t+E8I7B5IKUzyhn53CSYSCChzu/Fgvp2pjpqZJIEULtmQsmpmHknMwaGjlWB0/t+f86MKnJNajoM53HDEDOcJPthZ28wApg9ewLyrOLn0MBrA7mOzF4FEwsIMnRVl/K82fJdPyre88YMi2TOnp6HpMlDsN4TC9Z/7UqUuRiHDHnhjy+qYLxAx4ApZxVd+0APhUPACKPinkjgkVCZzb+ernmWY+Z+uFaOshULSGjnl08XXj81s85ktmA/df0jQjmhjYENQjgAE/eafz7M5X7aNOPYif2Sn/vxWo0Oy+v+LIiha7RM22iM5ZBYZQKmfcfcEgneuvVsLS6MkIIEav7dKslvarrbcIy5RU2XVLbidS3s3mjTqnptuA8JsPT72Urq418Tf5fFDtmoxBeD3bSr3UeO7j73ztHcDDnLSvJs6oKip0wK1WL6s/AufCTaWS/oouBYxzoivQAG+tRJU/Xt+gAAAABJRU5ErkJggg==", Zg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQPSURBVHgB7VhLbxtVFP7ujF+xXScpCYqlGhyBmqZU1N4VhMRjh0CoLQJ1h8SCLWGBitgQdlQsMP+g3SAeiwQkxLJUYoEEogZSaKtWdZVIdh+Jp2mdxh7PTM+5iSczzrzSJlUX/STLM+eee+6Z87rnXuAxgiGwRUzPHB5qqfHDCvAyLJRIQpHIQ+vDGtFqUFE1TZzJGPrs9JFZDVtAZIU+mTlWtBRjima851AgHApOClX//IvXZ2tR2EMVYovcVROfAdYUHgiicuKt7z8K5QoalFZRjdP0WMT2oCbi+qtB1lL8Bj7++Z3SNivDKFp6/PSnJNuPwdNCO2CZfvhaytNCO6wMQ1qK4xNhCh3/6d2vdlgZW6m1ZHHD5bJ1V13BQwS5btzpOpeFTKU7jYcMq6O6yoltoSnyZ1KNN4Mm66smbtXbWG506L+D/GQaY5MZF0/j/xXMn13GE+MDyI0lMJhPIp5SgsRqA4Y+3qvosR41TtuB34y5XxZpoRZWml0XfZAW7MdKU0edlOKfzZdPkHJJlI+OeomXWxH9n+QXW3VhWa/AB2yVfmUYuXzCg5b0mN/BXU2HHxSF9sXe8wZVHPSbUD76JNLDcRftmRcGMUJu6cfIeApPlXe5aOmhGEokwxcG7EJpu0xY/qnOAl98P4/5v25jRet6xo4TJXINx9CtRlvOLZCCgXEkNtaOOciBOzgLnnhtGFFRKGdRQDYqu722gkcMTgtx2gVa6UbjBi6dv4zRsVEUinuQTCU9+brdLhZqC6gvNFB89mnk9+QRAruJsy1kCer0QqDGVKkEK3au+p9cuB/t1Tb++fNfqUwsFvNV2gVrY+0Nl5nW32Hzdo/sxnOl/cgN5eTCtUtXN/GwZXgsnU2jfKgk54SCWt7eo+0yyxS/ClW2p4HgL544sBdnf6+ieXMJf3yToWzqyCySv71NsoyKfQcmpIWiQFD/3Xu2LaRDn4XDl0HouaLbNXDtym1ZNLn4Nest6cZMNhPNVetIGXJtt0IV3kss81REGXb85EZTss6MUW1K7Vqr3K07LUQGHQKcJxOXTYUZr1D78WGYjPn1OBmkWNr/QcE1dq7awrK2LHk4E8PAJxLnu+p8+e27Oe2lY5PDEOKQ12RW4sLcRZll7LbJ5/dtipMsuWvx+iK0JU3ys/t8Y8kyvz7x5sy3TtKmwtg2jWn6q3nNZ0X46zk+ONu84oSzqzfG/PWFOnxQG1hby4UtNfn8xRwfnPZRMmiJstCH17fJ9z2X8TFIMTCD7e+va6aKI1++8UPVa/CROyhGOtsf//HtCoQSmn2BoADmmAm7fNjSZQMfAoQQodXcAb4NOSUSemXbLhv6wYe7VeqBTdnyioOi7zrGoo2SaFUSfCZ1H9cxjxGGe7BNml7UIltrAAAAAElFTkSuQmCC", Qg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPOSURBVHgB7VhNTBNREJ7dpbGtUcGSIIQmbQ8lQRNaRSOQqIAHD9WUA94InjRchKvGRDiZmBjxqhe44sEmVBMTiHhQjIFQDpjQAzRCDBek2oQS2+365u1uu9vt/oGVC18C3Z/38+28b97MPIAjGIMBmxCWorWQ46PAsVdB4ENkCB95XCu9TpMWKWCYBPDwERxcjAnH0mADlgkJ81EfOPIjpMuggoCVGSbgDzfGdMRS1pqbEUGLFAqPQRBG4CBgYBzYzBgTnksbNzMiQ63CfyCXPrCJjR+/IbuXg+amk+B2OuTZUsRa3UbW0iUkfI2GgOXf2CWT+LYFk68TsEvIyOi44IWbvUHw1LlFUjzfx1x6l7BMaL+WmZ5NQnxmtXiPllESi1wPEmIthpbSEKKa4fklu2S2d3bh4dNZeh1qPQOD/SFKaH5xgxLF94jergDcjpwVSbGZcLmmuPKBR+8Gn5CfG2ATbpcDjhMC51oa6ISOGnFob9MpSiK7l4f1jR36h1YIBuqJpx5zjr1MvleOo7KQtFTrUCXEZ5LEWqvEgo0wNNAuPsxxfuXS1ah6OPjR8kHQ5Kvr25Bc2y4+89S5xC/v9ItCtQjUUDDgoZ5XmhP3NihuKUULSdrZKR/k3oNp+ot6cLlE95X1IE9Chbp/pIHL+GUtlSyE4YDVtn50/wolo7QEes7yypYk1mzFWdCi+C4YOG1mRRKKTkTJ74SaEAvXKrX2Np4qXs9+WqMToaVQuLi/6JF59uozvUYy8kfpAuOihhAwbWThdPvghjcVXyne4wTUfSsALScDl/fL4ib0dPlBFzRIi1AskuADA2ySUFBOUA8/FRpD7GZzYAzGB1pCxhHc7VQ7pKfWpdvW6VIvj9tlsFxlc7NgEZeJXnAHpmSILu70h3Tbdp5vVt23tTaAVSg/G91O10r4lUMDF6mHGQoUxPCQzeZJxP8FHe1eK3tVugIhJkV0FDLraUZGBu5P1kGyTAlKUS/DYQFTXgklQgWYg8MC5t8SSktGEnISOp6DgY6m3q5YcGE16knci5iFFkcmpiGE1YGwcGuSLN1wpT5IZH7hOxF1HuwANddDRK6rPVIEKHMiW+kHeljWpoUwzBg6Qln6oc0YFyLj5PEw/BcIL5j2uKqa0W6MXM0o+Z+CagNTWHEuFTSEaKWZ47qrSkpO8itUtRVDB13TAtdXFVK0DOL69GqzqhWKumRMCkXD4Eo7clwYxQcHBhmD5cJmNb7NwwZaBAyCdeBpyCTkasb/2WGDhph8HENTXppl+kB1HMNIxzGFfR3HHMEMfwHyDmsgtglQLAAAAABJRU5ErkJggg==", $g = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVmSURBVHgB7VjdTxxVFP/NzM52ly2UWkAbaQs0tlWSFjQlwZdSjDVRaogm1LSNNKkfidZI1agPKuAf0GKsxo8arTGp8NASW4zRNrR9gKRNhDZSEmgKpsgSlLKwsMvu7Ox47l12dudjv5TH/pKbuXPn3Ht+c+45Z84d4B7SQ0CO0AYaC6GEGyFKu6BpVTRURq1w+bGP2jgEYRBRXIYsdQvV3T7kgKwJaf2NZZAjLdDQnEQgCw3Cd1CkdqG2ezwr8UwC3CIRtZV6Lfh/aBN2nm/PJJSWELeKpPTSW5YhC2iiB5GiBkRdZdAkD8TgGBz+qxAXh5a1aeNQ5N3prCWsFJnIugaE72/ipMxwzPbCOd0JQfk7IylhJcgoJU0Il+xLKyMujcE11gpBXUxLSrSdncs2ycUGMl6vF6c7u3C+52eDXNRVzq0Ym0Rry0qvNlBnCQ6HRcG1BnJgHspZQSlqMNy/8+77GBkd5f1JIvfKS4cTsuuegUxbp5OK5DNdR5PnGyzEt4qiATmAOXAyvFNeve/3LxieMUfX5JLkkZZlnfaEIKltSAM7hzXj5cMxi+Tnr8b+F5oyykOKGNKJ7tSxfBOZNcszHwmVvgHVUxmbTyG8auLTWMQQQhvfQ6SgxjDH7/cToXzYIW/4xZhjJ+CDY6FcqL7EM3rCQoraaLfAUsXHOhkG1mdjzPycIOUZM1KRYS9jIsNAn6J8XXfyltWZJaOkPLq851+f/AbHjnfwKGJjamFMnOUYUZlGNlg1ccL+gYhd8W4iygRth1ku6izm19M/duIrIsTAIuiLzz+DSmEcn+y63UpWa9fJ20Ge7qJtTkFci1YluCVQZpYTwjE/mfROJeYuX6XAUEKOFDFSMlnLDGnxD0qIH/FMnRpCWbyXnIcKrYsN8QVZtCws+HleeftoC98iac7oO4yU868TvMV9TgxSJRKN+UxgSUWeS0IK6LoTUXatQUslHaZPg8oiiRyZEZFnelKb34SRsQVc6JvmV7dbwoevb7MlRpUA55JsIR9S1DlO2n+wliVmfGH0/T6DgeE5THiDfCzPU4CZ2XlOrOrhNeYpehGXTGicWhX+A+6Q0jtT1LwBDBKJmdmw/mzL9lo8e/At/PTDMYzc6EcgGLFZgT62FkKacJ0irSqVwot9iS1i/sAas0SycgZmiS3bH0N17VOo3dPE7y+ePcnJ8Oduh1WBIA5aCUG9RG7YDBt8e+ZP3fRm5aUVD2Hj5kewoaISGzZXcosko++3LnR+2abfl653WxWw+ttCSHZ206fjONLUy/V7DuDJA0d43716DSeUCoHFeZyjbWLWiWNL+WoUFTqtwrK/O97V8xA/HWg4Zbd49bIT3u79FfLZKyiYCdmS0QJBKDdvwf/9GZx79aCBDMOh5zdZF6dDQPw7xmDcUNXRAUfkTfOcJx4vQf/AXYCqieCVq7wJeW7Imx6EGghAXQxAondT/7mrz4kGjVu8t369vXXoRJJ8ayg/eEkp4BPzHJY3XttfYcgfzBrh4VsIXR9G6MawgYwZjMze+gfsHlmOR9YSVnK00QFw3DzMnPHQcxuRC9gL7Hu61J4M1dWUDNvMwxZC3JdUebcdKY9dyKbA1vJ8fHBkG213sS0ZVuTbzbMt8rkZbUiJBQqyRWWN095nMhyDxBTr2ZKSCiIQVkUNcpInD/J9ay3zHSUh5EomLaE4KaGmp5y6eiR4Hp0zysgyRJfLMOau9HPyRkEKFkmuznTGz+1nAzsECFrz/C/FCN5MUaYSkbVNk3FCPtJwCoqjY8V+NliI8d8xauP8haK60GjejuiSVBUn4tq64PPsnBsX3FH6HaNeZtk/198x95AJ/wIY5DN24mHfIwAAAABJRU5ErkJggg==", em = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAShSURBVHgB7VhNbFRVFP7ulLEtODgLA7FuZlxAmyi8aJWFi87QoIbYcbaN0WpEbSQi+JMYTWQgaWKiEYjBFC3JuHLbFBe66N9KsajjTyLWxA4LStINTadAy7Tvcs5t75v77rzOD7Ss+JKZd8+7953z3e/ce94PcA+VIVAnppxEtIhwGjLUQaYDyBi5ia70yllq56mRg3DHwygOxnNjs3W4r53QlPNcrOjKwxCyp0SgJmTDQhyL537I1zK4KiFWZMltPCoFDuNOIHFyx58/Hqk2TFQmQ6pIOUrNGNYHeVIrWUmt0Fodk84+Z53JMNQEJ539zloDAhXaAGVsrKlUoEIbTIahJszrE9UI/bfr2RMbTKZEijaLfdKXstVUTeEuglIXN1PnU+im62Zwl1GE9JUTTyFVgWXjVbPzGlz8TZdsId5xNKjj7YD9zNBvCkt4FGFsI18GZsNiMa4r+qYSU7odWBjAdYxgwbPjNPwxctiFJttpIIkhupavZzIae+nad3C/OTS6GjvrIyRdkRBWEehGMwUOES2J/2l2rBbPcgg3iFQzDpBmQUS+o/5z9GNsoSSwKo9QqM3U7kQjyqHui1kfoZDAbmkNYxW6yY3GAIXTgfjIBPuw1ZfKjzGnSGswcdNHICS8Qhkqnau+1Uew6LM58DVIn22S0cRrQKyMULU7+AyWVTpMHELEt5Z4jVnrQxGesa4LQDSAUGVwWuxdtj3g8nhpFXjYVsfuNEbK2cqEBO2QRl8QXqxBhEwCvKtqgBfbmw5tsLwEnEpX8eJkYrzruioE6sMDtHYW1Niu2gjlywi5An8IWZkQB6i6Y7CyO18LKAlrQtAjr01IQI7Rf4+2uaidt3bVemEP7kOKyoHBaFy3vGTzA7leRz/jJs5iXtUZ/i3tjKvj5vZd3jlub08+7fVfbXlQtS9FmrzzelxH76teP//O0t7jYyn2wmAZIXUvEeJbbtu15MMP3kPrzh14+cVuZT/c8hD6jh/FS2Q/1f4EvjzxOZ1rUX1tNI5tPY7bhUIB2YEziEQins+/NCGBrPlm4tuPyxAnTZsd9B3PKMcHe99ACwVNp7owV5hX/Vupn+2JC7/hlwu/wgaPmyMyl6evKJuJ2aCYx0zbR6iNn0sETmmbHYyMjtFxXjkdpvawsgt45cCb+OiTDJ5sfxyn+88gCDwRJsUqvX3kfWWbKnGsNusxtqyKhbGYmYf7AjVjnckEpetd5SSdel71T5ASrAYTTKfalTqsIqvVQyRXFJlWYzURnVYGT4QnRDHyHMuOX1ZCOZ/nxA21lliNTz/7Al/1f42L/05i3/6ULzUHe19XYxhMYg8F5mCn+79R53giTIav1crodHOMoLfawJoujMrJM2eHrIy5BniRD4+OK0LTq4qcXyXbmexQx0Okzl5S+S1af9weHPpekbZjWLHL4ThOdFE2/I4NfA2SYjl5MZfLoxZCjFbHiQk0OFQwo8+gOdEqN/XgDjAhiqd+woKqyNfhDuZzudoVCsI/9EYSgpsRUtRBTKraxuWkbb0+NthY+RzTlJZwE3Tv2w2VVvNzDN8oBX2OEeNcgev9HHMP1XALfOfttqTP7fAAAAAASUVORK5CYII=", tm = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATaSURBVHgB7ZjLTxtXFMa/8YyxxxDKIylRAsimgog0qHYTpDqtSCoapapK6/QfiLLIqhsQ3dN2000j00UWbRUVVlmWKiy6CIKoD6IUGmjUIpCKrYAojaA4PGyD7bm999oeZjyDZwwkq3ySNeO5Z+787jnnPoEXKi4BJYo8DFUhlQlBdFwAyfhpFV76uCpXHKMWUQjCFDK4B6c4JASGYihBtoHIeMgLZ7qbvnJVA2DnCwPYET8TgkNRe+ZWIMwjitIHQrpxEAnoF87e6bE2KwbDvZIZpbdeHIYERKm33i7mLcdeBeRByH+oMLxSWldZZpQ8eM+/l4mph8w8E0+msLi0jrn5VdWu/kQl/KeP695l5VY2xTxlDjTRFdHCjPwyj+G7cxyqUF9/0aXexxMp9Hz+o8GmttqD4Nl6dHWe0kM5NgJCYCxWFIhMfhDWJvCNb39VW9ziO4rAq3WQ3WVIJHcgy04EX2/QvT8+uUDLUqrN7N+rmJpZzr7fVIve6+e1Xzckug4oF6pIYYtZC3uvB/l1P1pdi9OGjfNruO9deNzO3cKU6NOGTg800TVAL1cLK2Oe0FWyT7G6jI0iXwnnhrsNQHy8yWTW8PwVg7jhy+eSpD5m04GjpIp4bs1GVnjvY6qt8aDzvK/U0NKp6EiIXgf0QA5chE2x3jZ8d5b2voihbOTneXS+2YT332mxH2Y2L+aAND4RXoNNsQQ1g1Gh6DDBbGyLT9JZaYCIFzZ0Z2SOhuippR2zYV60J8ELI5D1DM56SeFH3E4BodMuVHuMYyzzotlgaqIqM6A9lX6yzH8L/6zrnjOIj9+Q0eFz4kqry/Aeg5n+cxmlSNLcx2DiJbK1ie25GX7/+L+XDDA1sgNrcYKhv7Y52MlKEbenk6oda0QQllKnD21SR80skzOPsoZuN9a2HaYwN+/H0V7v5KFrr5cgO3fDZy9kdJVpBCLThWbppUUoyWxrnY3Z8UULs/RU4TCXm1243FLG7W7/kUQiRdQ6jlbZGJPYktcApGBMa0MoyM7jbNcWJAliZRXavOX45C2PCnPr9wSHaW+QkKQQN36Ko8btQC+1yXuJTaiWYuvvnHZziC7I6dQRRi6PUhSGpNO8SKw5BrKdxLGVeRD6od8W0/ie5gzz1MlKB4e5eT+BM3WS6qlqWYCnQrYH5NwYMngouzsQBrMwUaSe7PYOZX0NiUcPOSD7+L3IjgrDcuhL6pkOb5kubEvrCrroaG0pugnQrokMyw+S2YrEJ+yNsgzm1mQCFyhMPmzMU6sJgksdzXT6OGVdSbHlB1P8m7pRJb51ERZiefXdVBqXGhVd2F6pFXlvczU1QzpRb1GLfunBJBWaUBg/bIiF75pf4lc2JKzUNuCj4L/wSeuwJb6ElT4tfKwbqRNhtxclbALzMO4zATSVp1UYZ6O3uHfyi3yTXa2EA0pwuZFaWqC/Rf7f1dIK6eXjKAqTEa/stTcz5NBmfwVbNdrfKucrojlVxvLGCqbkjSIRfsA+YOS2QHEYmsBwiAGrPb5JyJT+3IGCLfEcam2DUF5hVsxOQwaRkvoPdNiwGS7vpvNLGFYvS1JM9p+D4JY1xzFC7jhGOdzjmBxUH/bOpzGRpK/JPckoDlFFTz/YMJCBGKJgH+aXuAIcYwohg0d6NsfwDPQ/3JsQeP3K3BsAAAAASUVORK5CYII=", nm = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAZ+SURBVHgB7VhLbBtFGP7Gu+tH4rjr2E1bIMHhkQKlbVJaIFDRBMoBqaWOeLUHRCrUGwgiEM8DqYQQICEiDnAAqRE3FEStBoQEFNIDRIi0cZE4EJXWbdo0BSd2nIc3XnuHf9bxK14nTdtjP2k8s/+8vvnmn39nDVzH0mC5wrn2Z0L6xOTNjPM4A48YjJ3lNltYonJj+McwrhLPHI69ZGR4NxXjuj7fHtq3LmLVTs4VJJdzM/e4A+nENPgCT2YYMCj/Z9NO8RQmshHOcDJHNPBZdRwSVGquUqc4FERYSyhuNRGR6VkoqrJs76S8e0lCfD4Fx9q1yMzOgWcyFk15M5FppkIwRzTSNQt7A0Pd83bIPloEdeNDu8JgLDzxaUNASyhdN/X15NQVebO5UFoYKsCWX4E+D5uiQKmtxeXCmONIR/kiK2smtTqNOanNLhu/zHzybKewSjrr4JwfhGHs73va31tpzLxCmVnNzO2+WuiTkxVUKod/r5JVpwj6qMvMJU9aZQyH+PHdO5Daf5C1hrqXG69IId3MmSRdtkrePQqqtkhldubMwP/CWdQeGEVVK7kUKQZ75hc+GAwUt3u1/8m2ioTEvuZICZUEseXIePfIlnXy6hSYwyg1cgQWk7KBffz6kafOvPF9sa0IRjKZJbeMSkuRWRI5UsNtqjkPN508wNP2j8sIGeBThp7O962k0hWTKSaVqTn0xuG9gQVLxJVO7S8jRLEkbmha4dFCpasmU0Dw0drUc5THmaK3d3cUYlfJ6BktWdKr+MStplhT86CEawU7N7o5Yx0fPBaKFNvzhOjgxnnRlpk2UqmqyQfv3gTs9QzXEhtcBrZXI/7hInuRQiwulBAnTQRIs5JOiyeYpHiyMjJzmo6R0xNIJtPweV1ousVX1sYriYCaDtLPgCUh5yZbQPvTQGZmFjavCteWKbjbJ7ESTMTm0Pt12CRTjCqngoe3N2L3I+sX9WB76OdlS0JV66XNgpBy4yzUXUko9ZrlpGL1yWQ2Xvm8VSV1H30+aJJqavSjZcMa03ZuLIGRMxMYPH7eghAdeQoBrGWg3Knd26SAs9EG5x0pSyJi1f1H/y5ZvSD03muP5J8f2FKPKhep8WCj5UIsoakiJpUTkv1MpWTZp//oCL796W+zLFYv/EKotP5Wf0m7XTubUAli2ywhU1yiWFR4XAZHfz1tkhFqdD7ZbOmg1xLFhCKUAlaNBJlXDrSW+cxSyFAImbgURbXHbaYcpnUH+ka34vuxu+FW5pHMKPT6CA3k6vN7xIceHxaXMFwjTI5HoSU11N20FrIi58m8eGIfTk3XlbQ1DKNr8K0d5o2y+OV6DFcI4bDFTivUmU3MYJVPzZOJ6rXo+e9lGKs2wuV0lPS3SbZ38uW8lRshkWl/1VhOOh1LYHQkgknahkxRRD8/NoW3PzhqplE64gLphfoqd2GLv7a9i1T1nfDWOLCzdTPq164uDM6h5oqFV8e2bwdS3zwdn/tNVZ0bpssIuWhwWgmmJuLQ5//FmoYbTPsXv9fi+H1HYMhuHBiZx+0XL6HROQa3Nop7Yik0eaIwFA+mUIcffjqC6MQk7tnSjE0bN2I8GoOeFuRZbxkhgcR3/mPGnLxHH3WWBUYhvay44XA5MX52DDOkmNvrgextgJHOOu1M2oHhWAOG0UBP9+PLGFC/zo/778gGScVuN/PjJ8LYuOEurPGrOD8ejShcP5ibp+SCxpPyDpHPDnpRCYKY3WlHKpUNoG21J+Ab7UN1bBg3yhfK2rscDmiozrZ9aDuabr8NPl/2WkOvs5OKlm4ZeLM9UqbQpX0vBPnCXgqFuEYXTKdhTUqW836yfZMXde4hKg3lY9RFzYPx5CpTsQt6A2rYXbRlqzHvrkYNkcqung2MnR3vGOhuL/mOyxMyuCwq2ilF6g5EOonMO6gAOqawsYK4i4PlOmfCTFmcovRzoZLzk++n+4JvtroiVmNXvFfwod29lD1nVZcgx1YcdtPRVwQiQ/K2Vfq6FShx6ie+igaZjTWnZ2w9bKu3k/+xK0JfoWVKeXwqrgADRKZjKTICed2Dh2MqHevDjAjIbqNT2CgUdNPtX1zAI7hyxCnGdbGt/e3LkSkhFOrwxnMTi39AcnZ2b38vJKmFglcXVkaMiNCnsyQ1sm3f9VxupzIfCh6KqaH93ooroW1so1509WSbkf3zQM0TABNbHEbGOAZFCl2OItexUvwPi5yHkVQqClcAAAAASUVORK5CYII=", rm = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAS/SURBVHgB7VhfSFtXGP9dr3FV5nBGhhkKibAU18LiNgbqw7rZh9HZYmHQvXWDuafB3Nq9DMaUjT61zI5BYUxQyvYgHQ3EPgyWtiuoYNVk3ao1grGLM24zNdYRrfHm7nwnuclN7p/cVMte+oOQc8+/73e+7zvfOd8BHsMcAkqEHOiqQVLqglj2KmTJw6ZwsuqaTHOc9ViEIAQh4RfYRK/Q4o2jBFgmJI93OWHb6WFDTqoIWJEwiG2xT2j1LlrrXowIaSSV+hyy3IPdQEC/8JLvo+LdzMhwrUjXWNGJvYCARaat18y0VWbUIE90efTIJLZ24PNHsRp/gJIhs7kqpGvyxBEPSiHENVMmXYaOZoYu/QHf1SiWopt4KBApUbzMZVglpKeZ2NoDnP1uHoHZONyuaniazf06sSXh07O/8zEabSqaChzSTCIWVshTx75if28o36GFDYxN38Pgj3exsrqFFkak+20XbOWG1k6vibXPhf/F7fn78I/9w+v2N1WruzAyT+zr+zb0k7oyz6kzThym8th0jJNQULVPxNEOBzrankEpCDKNDl9ZwuraNo6+7uBz5CEputROXp7XaJN6lWLd0xXcNOn/J+F5voaTIqeO3duGvbaCfZejGMi0jfVVODcQ4r5Hc3S0qxbFYxuyISWrIR5vJGnNbHLyo3MD83y1dkb0sw+auQA1+C68uoLI8ibaXqxlP3tm7Da++GaWl898clA9Lg5xwyW0XOcRPecIdBwUgUJGERCc0Z4Kw1f+hH/0b4TCG9zkFCIItAAyNzn7+FRMPYQdRdVZ2TlCZTgEE5BzK2SMQMLI99QgM0UyIYJMRS5QWVmwl+hczEDlBMILtB+NsBrXkqHJrSASTaDRUcnNdOb0QW0Hfkinodq7stNs0kLh9ozTq0ECC32K11dq6/IhOHUImZ/gJFzZsiT0xJsNuv30wkKDowpFkJVdfN+qQHFEEainCU6I+Ulgdp0dLQn+TbusrsaaaQsJxWHhnmNERN1++r3ncjHHWiCN6xASFpkfebAH4CY9km/SxFaS1dsMRrBbZgZqp/4VjxBffn0DFy7e1G+kK6+GUArX8YgQia6zQJow7kD3bw0hdiGHypZqkLr1JqR6n38Og5eCGJ+OwAihhXSw9Byo1+9g2/AqxawPUXYgTx4bYqb7sLD/hYuTWFpex8fdbWh89qmsEDIBkSKMT0Xg+zmEU92tLEbltjktxD8a5nVul11LhiUByjlGyNsyve8234GovczTCXzz1jJuTNxFLL7JzqkYvvfeQnInxWLTfpzoPMDLVB+c+YvdDOpZMLRxsj94f0M4sobD7S6mIYeWUFI83jdwJ66WlQd5srOfVWu0FJxZwfDI7azpaMXvvOWBuym36hGmITIhtZF55pgWSbNuVx1Ovd+qJQP5vPDySE/h4vO7pK8hARhkGmQqugfV1lbpbmP/6AIjNsevIYSO9iZ0HnZr+7IMhKVFrsLxumnQbtMfMtXS8n00MH/TjT0m6ZBhXsbTIIPMY1cgMpJ4XHjFG9RvNsH/kShayu2NHL00yOchlvcWe3wo8bGBJwEnYR30GjKEZHn/nj02aIgpzzH8ystvmU7kPccImeeY1EM9xzxGMfwHBO71o6WHNCAAAAAASUVORK5CYII=", im = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASdSURBVHgB7VhdaBxVFP7uzm5+TRvz0xBj4taGoGJrlkirgiZ9EKTGkFJFWoW0oAhGdNW3iDSC+CK2CVTwQaQFpagIoYmCSNP6YKMlNWulxkSbXdm2aWs3TbrtrvszO557d3d2Zmd2d9Js0Id+cGfO3J9zvvs359wL3EJ+MCwTylRvNWJyLyRbJxS5nVQ4Kbs6VbxINXxgzAMZ38MhjTDXyCKWAcuElIleJxxxNzXp0xCwYuEgotI77OERn7XqhYjwEUkk9kJR3FgJGIZYx+jrhavlIyNGRT5GohPFAIOPRmtrvtGy5SpQTva2F5WMUEq6SuRjyslt7bmqmI5Q0UfGaDXnSJkTmnzKm4tM4GoEM97rqCiTcOcd5airLtWVh/6Jw/PbUs5yHSlb0MVcx3W70G4gc6pnPy1gZ3b+7FwQR8YvYtYbVPNqby/B26/cK4yn8e6B33HlalT9bltfhd1PtxiJ8elLVO0lSbfQdWtITJXJbvr863OYWujEQki/2wNkeOJUQP0+8XMANc0deOTxZzIdoQ4MvH8Go0fnYYACt7CZixCtm0Fd/XgcHx6aRUBx4dmXBtH9/BsGnf6LYVX2TC9h95v7KO031Bsdn8eBT84InXqbcbcpIfG/Afq0hZE/5rA2uoDZ0xMY/XQfxihlQzs9obCMLz4axMEPzH83pZEgItO/ZuWyPmWqq9pASLgDLRp3wrauC53OCJTokiB05ZLfYKTcoahyBcmeiW9x4rsvTes90RoBa3pS6NaAXFFVr5GQDV2qLFUCDT1wPDSAuoZm9G++gZryhMHIhloZuzaF1O+dG0NorYmbkuE6uK6SLQNCt7Ch2iO/mIJml7EH+CpLarhbNGBrKlG24xs0f7UN/Q4//lyw4/y15I7a2BATxu2Nj6kabmtxoX/LuKjHUzjGREc2N0VRWdsidLE1LcnKVfeTK/4pKQsnbSCk2eql9RmapKBs1w9oPDuG+unPoFz7Kzmg9Ztgb38ZUnkM8A2JPEfHq2CtL+Ieqtf292m1va3pUThc/WCla2EO5jQhpPHgaebp6qTIft9zIhng/zgjh72wb3iBUjcKIuSFmW1zXybf0BvKhehlIv9j5jtwlPIuFW43fzjZ1gRaQvpA6vIRmoph6smcaUMEafvODOgV847MvJW/zdn3gAuHs0tU26ovUyZ7puhp7oVL1tG6aki+Oa6T4oh5D3VtKpKbQxDlZPjbFIqHPTjm4pJ2Uf9CD3NCfBSiBQispA0PeVPITFkCx/FfgcffKWQIUUCO7HVkATzc8F8IicTlm4IjOJIWdfEQrSP6oSivwQI804sUBZwX8ZEWPCTZs+MuEXZYAh0CKNbek/7Ux0Mx2xB5fEuEuCMNh+PCcB2R4OCO9tx8SLzb1sMa6ESi55cFZbKbRolZIrVyKMO0u9z5CfEwRJbpF7BK8XTGso+myjCOhj+1OGnGpK0k+rCKZHiQb1Zk6jrEaSAhbV8VUpyMLG3PdTb73x0ULZ3ti7PQlWFI9sFClw/LvGwQh4A+WAe/DTmEmH2oaJcNBmLp6xgR8ooo0wnddQxLXcckbuo65hYK4V/OHsxm/2NFMQAAAABJRU5ErkJggg==", sm = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMWSURBVHgB7VddTttAEP7WTqoKCTVHcE9ASlqpb5gbULWl4glygtATQE5QOEHSJ1SgKpyA8FapLTUnYI+Qij7Vtbeza2fjEP9ssilPfNI6jnd29vPM7MwYeEA5GCwhPrU24KJHt0NEeM/e/TiDBRzYwkWHrg0aHmnbgSXsCWXB8ASWWCyhBaBWNCF6fgNLQx/x44BtfeUoFBTnYMxP7tklSmCiszCoxWnrBjIuAI6wvl5GSpw895Wyt98HhTJHLz3Uwwut8zZ6xtrB0IiQOH7RhBP/zDyqJFWGO2QSxERoMwjuyua6jG1+C8hCPKPAw6Nwj37bepOTpg/HWSM3+fQvlWMcMa4R1Q8myNf/7NKcl9mC55EpJKQQRuuou+O3isW1IiLjYPlW5p0NCP0K0MQdENGwQy/UJ6t2FTFBFh77givdBShNjOKo6aHm7EiFbPOqn2v6cmhXi+PVHdqtgd9xPy92jAhNkpuZzJhUQQDnwTwP1cL9OchArVl2e6bCRhZKrXMDGwi2XpYWRjCzkDoltoh9Eyl9ytKqvY2kUJLtxIC9vuoms2wFtmBsTe/1pdWhzmBDz0U4HHUJ42Pv4gOyMUL5hTLwZWpmD/bwlFqZvyIcTMy4aNJVEcq6rIF7QW7qG+bNyizc0f8EO88EIYe9lbi8SJ1k+S6FxJomE+HjFCH2Rvkwv9sT4lJX9HmRZvqU1H6RmGEecgawRRQfmIgZEUpdZ9Mr99lWwE0EzTO1G8kY45gdsph2TYWNCbFXVIuSKs1hDlXZTa2j9qkSUGVD9kICAQX+YdIBuPu0crti6RkV1bYsqioRhng61SfNSmiqwseiLduQZI6Iue4u2XhlokFL+urBKGWotsNho+Ja2XnWjMkk9PV96obqGudSwtWNHJRO0WsWtiPFMVQPm5hMhhx/436eqCwHqiTk7qDW8MwTD0tuvmwpITcaZBQVBqf4vLoHRq0uDXGyOmWxnMNAfXcUYF6oL5Cy+dPWBQ2RjosqXeSu0ppZQwXkFwgWBBNd9p/SAr+wQNgTYugjiQ9ZtQ/xgP+Mf7fqWmkWJoegAAAAAElFTkSuQmCC", am = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARVSURBVHgB7VhNaBNBFP62yUoTqW2sFa1NTS1U1IPVViEoVLEnqRJBPSl68eDBPwQPoqgXD4JYPXjxUsGTCgZa8GJRD1qRVOOhClXbSDT+tk0tJuJ2s86b/HQ3+xuNeOkHye7OvH3z7TdvZt4MMAtrCCgRyvNQDSQ5BFdFBxS5lbkIsOKaXHWSWcQgCFHIeAjRFRbWhJMoAY4JKQOhAMTpo+yVfSoCTlrowS/XOSEYjjkztyNCimQyZ6AoR/E3ENAttPUeszezIsNVke+z2wDKAQExptZmK7UqzCqUp6HWspLhTpmvOfJ95enWVjMTQ4XKroy+VVOljBX6l2QIeaWeb6qxJaQMbr/0T8moSWWqzhQXa7os11WjZj5SPyWMjaeRZldCQ/08eCvFkm00kFxN6q5zaypF+azROwODcTx+FsfwyJiu7tShDvhZo4SxiRROXujX2TTUV6NzQxOCa/1653xuQ2FKKSjE5xtZnlDbUgNXb0TwPjHJn1uaFqDW58ECn5crkUpL2L9rZsDQc1//ML8nVcgmnviO4dFvvKyWvXf8QJBfVUjCNdUkrHnAZ/QZhWg5KIqovnvDnEywzY/dXauspScSHpHbFYM+rJf5GmAq9zLC+3dqRj1biqpC7NqjJVSBTcWOujpb0NJcayx1CSBFSMnly2rRwn460LqoIwRhNYV+saOgVt6/AiltCL5IZ6EipARgAYqH/kcjiL78jPHxFH+mLqQvPrh3Hbe5eO0x6+LvvI5gGcwaCAEDQqoVXGLFr5cCsfpczRQuDl4pBHfD4mo0MDJjyRTiH3MEFIqVNDwsjqieysi+51YU9x6N4nTbYRa+VcAcifvDihFgblrXtruYK354gIdtTBKPSp5KeKcWIti8BLv3NJoG9/kTWzTPFMz9LB0i0kjUFXxxYl98QMegmlRWq/yNEtk2wZlGVs0oY4TOJ9kvdAL6uLsbzevrWJMdEbpLCu29PrpRDXQhxrvKigzhnU29Gm8areu/+rLhQVlmDipCygsk58EWkhuOIYn2NtR9lPLqCGXwAN60vQNxGo4hSvY23p/g+beOEEvIWYAleb9aYWmCLwd2oIBG/RdrI2qLglqcCueLCvrT7kCJbL+O9qEjulGWx8q3PKBv3hoCjXM/m2f8i6o1JvFPk4zwJNLpaZw67M2+87JZ74t6o32IbwLy6xjnobYppB80Ol4tAz7UZeOAvoQpg0CC29Hq33M7CivQUlGYEGkgvG7Mxgt145KvM/NQUfqhS2GVSFc3Kz4CG9CER4ulEYiIOgswh3JZaO/T7Gb0KazLfZb9x2ADanDbluWaMpowqcwRGcqrs20VFRug1CSfEjdvpRvz53ttU5QCGZMk33RfxrdBFfIdlDu/JjKya4ewPhw1rrbA/9goOtrbOw10Gy+XKWbsDh9KPGzgm4B9cA46DbnOlpvush026Ijlj2N4ysuzzAA0xzFC7jgm80fHMbOww2+FesP2R7jyAQAAAABJRU5ErkJggg==", om = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI+SURBVHgB7ZdRftJAEMa/2eQAPQIV+1hoTyAqPltuQE9gPQFwg/YEhRPIu6h4AqF99IdwAzkA2XEGmjRAEpNYiO2v/6fJbnb3y2R3ZwZ45pFBSZ3Tk9qBtaZpmKoMKmmbZR4T8ah8+7WbNA5wavDw3h8nzJnsd2Ns/3A0nCGLoOWE1m1Z4AKx8AzMnU1h08rbDxbUFvMgfih3jeN1ooRRhJiStc436SohDYzL8u3go5qT6rtrWayZapx8kDHe601R9E9iQqKMzJTs0VhRpyJq7re44W7Pc9pEGcUohAuLPFCJPfdajMb9VHesvONOUQDGQH7dYLi0/Ub1DgrCs3Tm24EgQ1RFQRD4lW8Hghg4QXGUfMPg/yC4s8KC5iiOYO1AEDFGKIjw2vd7iHiMgrBEwdqBIGuoj4JwDAdrr4WOSaX+G0lBcSfwrHzz5dB/Wjtlcv1fYe9QL/y0Jsg1i0vs9bRpcF10ESdIo+5+vUS9xPRDWWWJzo/MKUhm1veOz9ZNvfSSoXPsGMmDGpHtUY1HkgrIr+tgd2j6GnkRJyb5v47rn5hwhgeECP0X40Ejrj8xuJKzOBfFDxZSVhXLInE7JHpIyZ1nbxGd1G/y1/RDJ9CJlmVPTtQzacSkEhQSdSpReYiM6BjX8WppxCzfR0Z+Vupt+YpWmnelar16efM5U2mUWZAyOX7TlOPSit9XPNO77OiukshCrhRWy2fdEwzubUkRr+jvzSNGyeWhMHoKPeu0RchMgnM37V555snwB4zC7oASTv6bAAAAAElFTkSuQmCC", cm = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJDSURBVHgB7VZNTttAFP6ebVbtIkcwNwhRK3VHOAFYopG6qjlB2xOUnoDeAHZIRBW5QbPnz0cwJ8ASO4j9GA9xArE9M8wksOGTotieNzOf3xt/7wPe8QrgYe8nn/RiLAEeHMH/egcgOoBHh4LYPhzhTAhMO7Nroh9whBMhHnb74i988qjDw099OMAxQ35ce8TFDhzgRoiwWV+RtuEAa0IN5aoQupTNPkPkKUpT9GEJh5IpSkO0CdtVYQE++dyFV1wpg/x8naIkxQsR1DY77Ya6SSh4G6yJmQSxWOtIE4VF0rMM8fGXEGv3/9F8UFeJFLf5Bu0lWXkzP0PBXfwGZCD3/OjF1c2cEFGCtwIjqy5nhGj3YiT60h+8NsSeNLg8qm5rX5kUNeJDrL58qSCzR1/Px08f1nRIBtznW+JyhNVhLA/yAhm5v2qWyNa+yNZvLBNMvwSRv23DWmHkY6FLa/4y5CBFkUc0SJQfj7Z10DchXH6+gTLN9hjJEmnIGBGSpCIhWoxr2IKQVcK3FELTRe19DsPYtBkRmnqfDuxhbG3NMqT0PoYwtLaGJfOs/c18CTNrqyUkXQC4qwlLpz8VQhNro8+Qf9fXREjVNVL3ib70gS5ApPp769hz1S0/60ip7iTL1qrSMkQ1KFLcQe7fNAw1NsbZvEeLe4q6umcim+sqTVKXbIKms9PaGCvQ4CxpKWEHH9QtSE0oQCn187cpS7R7sWWiumXLEbHRgsfKkEM516y5BqXF9MaqrBitwcXIpJ+9Q4UHBTvKUfoytx8AAAAASUVORK5CYII=";
var kde = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(r, a) {
    return "Cannot apply '" + r + "' to '" + a.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(r, a) {
    return "[mobx.array] Index out of bounds, " + r + " is larger than " + a;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(r) {
    return "Cannot initialize from classes that inherit from Map: " + r.constructor.name;
  },
  20: function(r) {
    return "Cannot initialize map from " + r;
  },
  21: function(r) {
    return "Cannot convert to map from '" + r + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(r) {
    return "Cannot obtain administration from " + r;
  },
  25: function(r, a) {
    return "the entry '" + r + "' does not exist in the observable map '" + a + "'";
  },
  26: "please specify a property",
  27: function(r, a) {
    return "no observable property '" + r.toString() + "' found on the observable object '" + a + "'";
  },
  28: function(r) {
    return "Cannot obtain atom from " + r;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(r, a) {
    return "Cycle detected in computation " + r + ": " + a;
  },
  33: function(r) {
    return "The setter of computed value '" + r + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(r) {
    return "[ComputedValue '" + r + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(r) {
    return "[mobx] `observableArray." + r + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + r + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, jde = process.env.NODE_ENV !== "production" ? kde : {};
function Gn(t) {
  for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), u = 1; u < r; u++)
    a[u - 1] = arguments[u];
  if (process.env.NODE_ENV !== "production") {
    var h = typeof t == "string" ? t : jde[t];
    throw typeof h == "function" && (h = h.apply(null, a)), new Error("[MobX] " + h);
  }
  throw new Error(typeof t == "number" ? "[MobX] minified error nr: " + t + (a.length ? " " + a.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + t);
}
var Ude = {};
function ZN() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : Ude;
}
var iz = Object.assign, nb = Object.getOwnPropertyDescriptor, ju = Object.defineProperty, Fb = Object.prototype, rb = [];
Object.freeze(rb);
var QN = {};
Object.freeze(QN);
var Hde = typeof Proxy < "u", Bde = /* @__PURE__ */ Object.toString();
function sz() {
  Hde || Gn(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Ty(t) {
  process.env.NODE_ENV !== "production" && Rn.verifyProxies && Gn("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + t);
}
function Ic() {
  return ++Rn.mobxGuid;
}
function $N(t) {
  var r = !1;
  return function() {
    if (!r)
      return r = !0, t.apply(this, arguments);
  };
}
var Xp = function() {
};
function ks(t) {
  return typeof t == "function";
}
function ih(t) {
  var r = typeof t;
  switch (r) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Gb(t) {
  return t !== null && typeof t == "object";
}
function nu(t) {
  if (!Gb(t))
    return !1;
  var r = Object.getPrototypeOf(t);
  if (r == null)
    return !0;
  var a = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
  return typeof a == "function" && a.toString() === Bde;
}
function az(t) {
  var r = t == null ? void 0 : t.constructor;
  return r ? r.name === "GeneratorFunction" || r.displayName === "GeneratorFunction" : !1;
}
function Vb(t, r, a) {
  ju(t, r, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: a
  });
}
function oz(t, r, a) {
  ju(t, r, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: a
  });
}
function hh(t, r) {
  var a = "isMobX" + t;
  return r.prototype[a] = !0, function(u) {
    return Gb(u) && u[a] === !0;
  };
}
function Lm(t) {
  return t instanceof Map;
}
function fv(t) {
  return t instanceof Set;
}
var cz = typeof Object.getOwnPropertySymbols < "u";
function zde(t) {
  var r = Object.keys(t);
  if (!cz)
    return r;
  var a = Object.getOwnPropertySymbols(t);
  return a.length ? [].concat(r, a.filter(function(u) {
    return Fb.propertyIsEnumerable.call(t, u);
  })) : r;
}
var Yb = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : cz ? function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function I2(t) {
  return typeof t == "string" ? t : typeof t == "symbol" ? t.toString() : new String(t).toString();
}
function uz(t) {
  return t === null ? null : typeof t == "object" ? "" + t : t;
}
function Ac(t, r) {
  return Fb.hasOwnProperty.call(t, r);
}
var Fde = Object.getOwnPropertyDescriptors || function(r) {
  var a = {};
  return Yb(r).forEach(function(u) {
    a[u] = nb(r, u);
  }), a;
};
function Gde(t, r) {
  for (var a = 0; a < r.length; a++) {
    var u = r[a];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(t, Xde(u.key), u);
  }
}
function ew(t, r, a) {
  return r && Gde(t.prototype, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Ul() {
  return Ul = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a)
        Object.prototype.hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, Ul.apply(this, arguments);
}
function dz(t, r) {
  t.prototype = Object.create(r.prototype), t.prototype.constructor = t, R2(t, r);
}
function R2(t, r) {
  return R2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, h) {
    return u.__proto__ = h, u;
  }, R2(t, r);
}
function Y0(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Vde(t, r) {
  if (t) {
    if (typeof t == "string") return V9(t, r);
    var a = Object.prototype.toString.call(t).slice(8, -1);
    if (a === "Object" && t.constructor && (a = t.constructor.name), a === "Map" || a === "Set") return Array.from(t);
    if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return V9(t, r);
  }
}
function V9(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var a = 0, u = new Array(r); a < r; a++) u[a] = t[a];
  return u;
}
function Wp(t, r) {
  var a = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (a) return (a = a.call(t)).next.bind(a);
  if (Array.isArray(t) || (a = Vde(t)) || r) {
    a && (t = a);
    var u = 0;
    return function() {
      return u >= t.length ? {
        done: !0
      } : {
        done: !1,
        value: t[u++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yde(t, r) {
  if (typeof t != "object" || t === null) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var u = a.call(t, r);
    if (typeof u != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function Xde(t) {
  var r = Yde(t, "string");
  return typeof r == "symbol" ? r : String(r);
}
var qa = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Uu(t) {
  function r(a, u) {
    hv(a, u, t);
  }
  return Object.assign(r, t);
}
function hv(t, r, a) {
  if (Ac(t, qa) || Vb(t, qa, Ul({}, t[qa])), process.env.NODE_ENV !== "production" && ib(a) && !Ac(t[qa], r)) {
    var u = t.constructor.name + ".prototype." + r.toString();
    Gn("'" + u + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  Wde(t, a, r), ib(a) || (t[qa][r] = a);
}
function Wde(t, r, a) {
  if (process.env.NODE_ENV !== "production" && !ib(r) && Ac(t[qa], a)) {
    var u = t.constructor.name + ".prototype." + a.toString(), h = t[qa][a].annotationType_, b = r.annotationType_;
    Gn("Cannot apply '@" + b + "' to '" + u + "':" + (`
The field is already decorated with '@` + h + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function qde(t) {
  return Ac(t, qa) || (process.env.NODE_ENV !== "production" && !t[qa] && Gn("No annotations were passed to makeObservable, but no decorated members have been found either"), Vb(t, qa, Ul({}, t[qa]))), t[qa];
}
var Ur = /* @__PURE__ */ Symbol("mobx administration"), pv = /* @__PURE__ */ function() {
  function t(a) {
    a === void 0 && (a = process.env.NODE_ENV !== "production" ? "Atom@" + Ic() : "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = pi.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = a;
  }
  var r = t.prototype;
  return r.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(u) {
      return u();
    });
  }, r.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(u) {
      return u();
    });
  }, r.reportObserved = function() {
    return xz(this);
  }, r.reportChanged = function() {
    jo(), Dz(this), Uo();
  }, r.toString = function() {
    return this.name_;
  }, t;
}(), tw = /* @__PURE__ */ hh("Atom", pv);
function lz(t, r, a) {
  r === void 0 && (r = Xp), a === void 0 && (a = Xp);
  var u = new pv(t);
  return r !== Xp && efe(u, r), a !== Xp && Vz(u, a), u;
}
function Kde(t, r) {
  return t === r;
}
function Jde(t, r) {
  return ow(t, r);
}
function Zde(t, r) {
  return ow(t, r, 1);
}
function Qde(t, r) {
  return Object.is ? Object.is(t, r) : t === r ? t !== 0 || 1 / t === 1 / r : t !== t && r !== r;
}
var um = {
  identity: Kde,
  structural: Jde,
  default: Qde,
  shallow: Zde
};
function dm(t, r, a) {
  return Jy(t) ? t : Array.isArray(t) ? Ar.array(t, {
    name: a
  }) : nu(t) ? Ar.object(t, void 0, {
    name: a
  }) : Lm(t) ? Ar.map(t, {
    name: a
  }) : fv(t) ? Ar.set(t, {
    name: a
  }) : typeof t == "function" && !Kb(t) && !cb(t) ? az(t) ? Ky(t) : qy(a, t) : t;
}
function $de(t, r, a) {
  if (t == null || bv(t) || Jb(t) || Xl(t) || jm(t))
    return t;
  if (Array.isArray(t))
    return Ar.array(t, {
      name: a,
      deep: !1
    });
  if (nu(t))
    return Ar.object(t, void 0, {
      name: a,
      deep: !1
    });
  if (Lm(t))
    return Ar.map(t, {
      name: a,
      deep: !1
    });
  if (fv(t))
    return Ar.set(t, {
      name: a,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && Gn("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Xb(t) {
  return t;
}
function ele(t, r) {
  return process.env.NODE_ENV !== "production" && Jy(t) && Gn("observable.struct should not be used with observable values"), ow(t, r) ? r : t;
}
var tle = "override";
function ib(t) {
  return t.annotationType_ === tle;
}
function gv(t, r) {
  return {
    annotationType_: t,
    options_: r,
    make_: nle,
    extend_: rle
  };
}
function nle(t, r, a, u) {
  var h;
  if ((h = this.options_) != null && h.bound)
    return this.extend_(t, r, a, !1) === null ? 0 : 1;
  if (u === t.target_)
    return this.extend_(t, r, a, !1) === null ? 0 : 2;
  if (Kb(a.value))
    return 1;
  var b = fz(t, this, r, a, !1);
  return ju(u, r, b), 2;
}
function rle(t, r, a, u) {
  var h = fz(t, this, r, a);
  return t.defineProperty_(r, h, u);
}
function ile(t, r, a, u) {
  var h = r.annotationType_, b = u.value;
  process.env.NODE_ENV !== "production" && !ks(b) && Gn("Cannot apply '" + h + "' to '" + t.name_ + "." + a.toString() + "':" + (`
'` + h + "' can only be used on properties with a function value."));
}
function fz(t, r, a, u, h) {
  var b, l, v, s, c, d, p;
  h === void 0 && (h = Rn.safeDescriptors), ile(t, r, a, u);
  var m = u.value;
  if ((b = r.options_) != null && b.bound) {
    var E;
    m = m.bind((E = t.proxy_) != null ? E : t.target_);
  }
  return {
    value: lm(
      (l = (v = r.options_) == null ? void 0 : v.name) != null ? l : a.toString(),
      m,
      (s = (c = r.options_) == null ? void 0 : c.autoAction) != null ? s : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (d = r.options_) != null && d.bound ? (p = t.proxy_) != null ? p : t.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: h ? t.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !h
  };
}
function hz(t, r) {
  return {
    annotationType_: t,
    options_: r,
    make_: sle,
    extend_: ale
  };
}
function sle(t, r, a, u) {
  var h;
  if (u === t.target_)
    return this.extend_(t, r, a, !1) === null ? 0 : 2;
  if ((h = this.options_) != null && h.bound && (!Ac(t.target_, r) || !cb(t.target_[r])) && this.extend_(t, r, a, !1) === null)
    return 0;
  if (cb(a.value))
    return 1;
  var b = pz(t, this, r, a, !1, !1);
  return ju(u, r, b), 2;
}
function ale(t, r, a, u) {
  var h, b = pz(t, this, r, a, (h = this.options_) == null ? void 0 : h.bound);
  return t.defineProperty_(r, b, u);
}
function ole(t, r, a, u) {
  var h = r.annotationType_, b = u.value;
  process.env.NODE_ENV !== "production" && !ks(b) && Gn("Cannot apply '" + h + "' to '" + t.name_ + "." + a.toString() + "':" + (`
'` + h + "' can only be used on properties with a generator function value."));
}
function pz(t, r, a, u, h, b) {
  b === void 0 && (b = Rn.safeDescriptors), ole(t, r, a, u);
  var l = u.value;
  if (cb(l) || (l = Ky(l)), h) {
    var v;
    l = l.bind((v = t.proxy_) != null ? v : t.target_), l.isMobXFlow = !0;
  }
  return {
    value: l,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: b ? t.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !b
  };
}
function nw(t, r) {
  return {
    annotationType_: t,
    options_: r,
    make_: cle,
    extend_: ule
  };
}
function cle(t, r, a) {
  return this.extend_(t, r, a, !1) === null ? 0 : 1;
}
function ule(t, r, a, u) {
  return dle(t, this, r, a), t.defineComputedProperty_(r, Ul({}, this.options_, {
    get: a.get,
    set: a.set
  }), u);
}
function dle(t, r, a, u) {
  var h = r.annotationType_, b = u.get;
  process.env.NODE_ENV !== "production" && !b && Gn("Cannot apply '" + h + "' to '" + t.name_ + "." + a.toString() + "':" + (`
'` + h + "' can only be used on getter(+setter) properties."));
}
function Wb(t, r) {
  return {
    annotationType_: t,
    options_: r,
    make_: lle,
    extend_: fle
  };
}
function lle(t, r, a) {
  return this.extend_(t, r, a, !1) === null ? 0 : 1;
}
function fle(t, r, a, u) {
  var h, b;
  return hle(t, this, r, a), t.defineObservableProperty_(r, a.value, (h = (b = this.options_) == null ? void 0 : b.enhancer) != null ? h : dm, u);
}
function hle(t, r, a, u) {
  var h = r.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in u) && Gn("Cannot apply '" + h + "' to '" + t.name_ + "." + a.toString() + "':" + (`
'` + h + "' cannot be used on getter/setter properties"));
}
var ple = "true", gle = /* @__PURE__ */ gz();
function gz(t) {
  return {
    annotationType_: ple,
    options_: t,
    make_: mle,
    extend_: Ele
  };
}
function mle(t, r, a, u) {
  var h, b;
  if (a.get)
    return mv.make_(t, r, a, u);
  if (a.set) {
    var l = lm(r.toString(), a.set);
    return u === t.target_ ? t.defineProperty_(r, {
      configurable: Rn.safeDescriptors ? t.isPlainObject_ : !0,
      set: l
    }) === null ? 0 : 2 : (ju(u, r, {
      configurable: !0,
      set: l
    }), 2);
  }
  if (u !== t.target_ && typeof a.value == "function") {
    var v;
    if (az(a.value)) {
      var s, c = (s = this.options_) != null && s.autoBind ? Ky.bound : Ky;
      return c.make_(t, r, a, u);
    }
    var d = (v = this.options_) != null && v.autoBind ? qy.bound : qy;
    return d.make_(t, r, a, u);
  }
  var p = ((h = this.options_) == null ? void 0 : h.deep) === !1 ? Ar.ref : Ar;
  if (typeof a.value == "function" && (b = this.options_) != null && b.autoBind) {
    var m;
    a.value = a.value.bind((m = t.proxy_) != null ? m : t.target_);
  }
  return p.make_(t, r, a, u);
}
function Ele(t, r, a, u) {
  var h, b;
  if (a.get)
    return mv.extend_(t, r, a, u);
  if (a.set)
    return t.defineProperty_(r, {
      configurable: Rn.safeDescriptors ? t.isPlainObject_ : !0,
      set: lm(r.toString(), a.set)
    }, u);
  if (typeof a.value == "function" && (h = this.options_) != null && h.autoBind) {
    var l;
    a.value = a.value.bind((l = t.proxy_) != null ? l : t.target_);
  }
  var v = ((b = this.options_) == null ? void 0 : b.deep) === !1 ? Ar.ref : Ar;
  return v.extend_(t, r, a, u);
}
var yle = "observable", vle = "observable.ref", Tle = "observable.shallow", ble = "observable.struct", mz = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(mz);
function A0(t) {
  return t || mz;
}
var Ez = /* @__PURE__ */ Wb(yle), Ale = /* @__PURE__ */ Wb(vle, {
  enhancer: Xb
}), Ole = /* @__PURE__ */ Wb(Tle, {
  enhancer: $de
}), Cle = /* @__PURE__ */ Wb(ble, {
  enhancer: ele
}), yz = /* @__PURE__ */ Uu(Ez);
function O0(t) {
  return t.deep === !0 ? dm : t.deep === !1 ? Xb : Ile(t.defaultDecorator);
}
function Sle(t) {
  var r;
  return t ? (r = t.defaultDecorator) != null ? r : gz(t) : void 0;
}
function Ile(t) {
  var r, a;
  return t && (r = (a = t.options_) == null ? void 0 : a.enhancer) != null ? r : dm;
}
function vz(t, r, a) {
  if (ih(r)) {
    hv(t, r, Ez);
    return;
  }
  return Jy(t) ? t : nu(t) ? Ar.object(t, r, a) : Array.isArray(t) ? Ar.array(t, r) : Lm(t) ? Ar.map(t, r) : fv(t) ? Ar.set(t, r) : typeof t == "object" && t !== null ? t : Ar.box(t, r);
}
iz(vz, yz);
var Rle = {
  box: function(r, a) {
    var u = A0(a);
    return new ig(r, O0(u), u.name, !0, u.equals);
  },
  array: function(r, a) {
    var u = A0(a);
    return (Rn.useProxies === !1 || u.proxy === !1 ? Cfe : gfe)(r, O0(u), u.name);
  },
  map: function(r, a) {
    var u = A0(a);
    return new Qz(r, O0(u), u.name);
  },
  set: function(r, a) {
    var u = A0(a);
    return new tF(r, O0(u), u.name);
  },
  object: function(r, a, u) {
    return ife(Rn.useProxies === !1 || (u == null ? void 0 : u.proxy) === !1 ? Zb({}, u) : ffe({}, u), r, a);
  },
  ref: /* @__PURE__ */ Uu(Ale),
  shallow: /* @__PURE__ */ Uu(Ole),
  deep: yz,
  struct: /* @__PURE__ */ Uu(Cle)
}, Ar = /* @__PURE__ */ iz(vz, Rle), Tz = "computed", Nle = "computed.struct", bz = /* @__PURE__ */ nw(Tz), wle = /* @__PURE__ */ nw(Nle, {
  equals: um.structural
}), mv = function(r, a) {
  if (ih(a))
    return hv(r, a, bz);
  if (nu(r))
    return Uu(nw(Tz, r));
  process.env.NODE_ENV !== "production" && (ks(r) || Gn("First argument to `computed` should be an expression."), ks(a) && Gn("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var u = nu(a) ? a : {};
  return u.get = r, u.name || (u.name = r.name || ""), new fm(u);
};
Object.assign(mv, bz);
mv.struct = /* @__PURE__ */ Uu(wle);
var Y9, X9, sb = 0, _le = 1, Ple = (Y9 = (X9 = /* @__PURE__ */ nb(function() {
}, "name")) == null ? void 0 : X9.configurable) != null ? Y9 : !1, W9 = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function lm(t, r, a, u) {
  a === void 0 && (a = !1), process.env.NODE_ENV !== "production" && (ks(r) || Gn("`action` can only be invoked on functions"), (typeof t != "string" || !t) && Gn("actions should have valid names, got: '" + t + "'"));
  function h() {
    return Az(t, a, r, u || this, arguments);
  }
  return h.isMobxAction = !0, Ple && (W9.value = t, ju(h, "name", W9)), h;
}
function Az(t, r, a, u, h) {
  var b = xle(t, r, u, h);
  try {
    return a.apply(u, h);
  } catch (l) {
    throw b.error_ = l, l;
  } finally {
    Dle(b);
  }
}
function xle(t, r, a, u) {
  var h = process.env.NODE_ENV !== "production" && ya() && !!t, b = 0;
  if (process.env.NODE_ENV !== "production" && h) {
    b = Date.now();
    var l = u ? Array.from(u) : rb;
    Bo({
      type: iw,
      name: t,
      object: a,
      arguments: l
    });
  }
  var v = Rn.trackingDerivation, s = !r || !v;
  jo();
  var c = Rn.allowStateChanges;
  s && (km(), c = Ev(!0));
  var d = rw(!0), p = {
    runAsAction_: s,
    prevDerivation_: v,
    prevAllowStateChanges_: c,
    prevAllowStateReads_: d,
    notifySpy_: h,
    startTime_: b,
    actionId_: _le++,
    parentActionId_: sb
  };
  return sb = p.actionId_, p;
}
function Dle(t) {
  sb !== t.actionId_ && Gn(30), sb = t.parentActionId_, t.error_ !== void 0 && (Rn.suppressReactionErrors = !0), yv(t.prevAllowStateChanges_), Hy(t.prevAllowStateReads_), Uo(), t.runAsAction_ && xl(t.prevDerivation_), process.env.NODE_ENV !== "production" && t.notifySpy_ && zo({
    time: Date.now() - t.startTime_
  }), Rn.suppressReactionErrors = !1;
}
function Oz(t, r) {
  var a = Ev(t);
  try {
    return r();
  } finally {
    yv(a);
  }
}
function Ev(t) {
  var r = Rn.allowStateChanges;
  return Rn.allowStateChanges = t, r;
}
function yv(t) {
  Rn.allowStateChanges = t;
}
var Cz, Mle = "create";
Cz = Symbol.toPrimitive;
var ig = /* @__PURE__ */ function(t) {
  dz(r, t);
  function r(u, h, b, l, v) {
    var s;
    return b === void 0 && (b = process.env.NODE_ENV !== "production" ? "ObservableValue@" + Ic() : "ObservableValue"), l === void 0 && (l = !0), v === void 0 && (v = um.default), s = t.call(this, b) || this, s.enhancer = void 0, s.name_ = void 0, s.equals = void 0, s.hasUnreportedChange_ = !1, s.interceptors_ = void 0, s.changeListeners_ = void 0, s.value_ = void 0, s.dehancer = void 0, s.enhancer = h, s.name_ = b, s.equals = v, s.value_ = h(u, void 0, b), process.env.NODE_ENV !== "production" && l && ya() && sh({
      type: Mle,
      object: Y0(s),
      observableKind: "value",
      debugObjectName: s.name_,
      newValue: "" + s.value_
    }), s;
  }
  var a = r.prototype;
  return a.dehanceValue = function(h) {
    return this.dehancer !== void 0 ? this.dehancer(h) : h;
  }, a.set = function(h) {
    var b = this.value_;
    if (h = this.prepareNewValue_(h), h !== Rn.UNCHANGED) {
      var l = ya();
      process.env.NODE_ENV !== "production" && l && Bo({
        type: Zc,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: h,
        oldValue: b
      }), this.setNewValue_(h), process.env.NODE_ENV !== "production" && l && zo();
    }
  }, a.prepareNewValue_ = function(h) {
    if (hm(this), Tc(this)) {
      var b = bc(this, {
        object: this,
        type: Zc,
        newValue: h
      });
      if (!b)
        return Rn.UNCHANGED;
      h = b.newValue;
    }
    return h = this.enhancer(h, this.value_, this.name_), this.equals(this.value_, h) ? Rn.UNCHANGED : h;
  }, a.setNewValue_ = function(h) {
    var b = this.value_;
    this.value_ = h, this.reportChanged(), $c(this) && eu(this, {
      type: Zc,
      object: this,
      newValue: h,
      oldValue: b
    });
  }, a.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, a.intercept_ = function(h) {
    return vv(this, h);
  }, a.observe_ = function(h, b) {
    return b && h({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Zc,
      newValue: this.value_,
      oldValue: void 0
    }), Tv(this, h);
  }, a.raw = function() {
    return this.value_;
  }, a.toJSON = function() {
    return this.get();
  }, a.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, a.valueOf = function() {
    return uz(this.get());
  }, a[Cz] = function() {
    return this.valueOf();
  }, r;
}(pv), Sz;
Sz = Symbol.toPrimitive;
var fm = /* @__PURE__ */ function() {
  function t(a) {
    this.dependenciesState_ = pi.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = pi.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new ab(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Oc.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, a.get || Gn(31), this.derivation = a.get, this.name_ = a.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + Ic() : "ComputedValue"), a.set && (this.setter_ = lm(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", a.set)), this.equals_ = a.equals || (a.compareStructural || a.struct ? um.structural : um.default), this.scope_ = a.context, this.requiresReaction_ = a.requiresReaction, this.keepAlive_ = !!a.keepAlive;
  }
  var r = t.prototype;
  return r.onBecomeStale_ = function() {
    zle(this);
  }, r.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(u) {
      return u();
    });
  }, r.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(u) {
      return u();
    });
  }, r.get = function() {
    if (this.isComputing_ && Gn(32, this.name_, this.derivation), Rn.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      N2(this) && (this.warnAboutUntrackedRead_(), jo(), this.value_ = this.computeValue_(!1), Uo());
    else if (xz(this), N2(this)) {
      var u = Rn.trackingContext;
      this.keepAlive_ && !u && (Rn.trackingContext = this), this.trackAndCompute() && Ble(this), Rn.trackingContext = u;
    }
    var h = this.value_;
    if (X0(h))
      throw h.cause;
    return h;
  }, r.set = function(u) {
    if (this.setter_) {
      this.isRunningSetter_ && Gn(33, this.name_), this.isRunningSetter_ = !0;
      try {
        this.setter_.call(this.scope_, u);
      } finally {
        this.isRunningSetter_ = !1;
      }
    } else
      Gn(34, this.name_);
  }, r.trackAndCompute = function() {
    var u = this.value_, h = (
      /* see #1208 */
      this.dependenciesState_ === pi.NOT_TRACKING_
    ), b = this.computeValue_(!0), l = h || X0(u) || X0(b) || !this.equals_(u, b);
    return l && (this.value_ = b, process.env.NODE_ENV !== "production" && ya() && sh({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: u,
      newValue: b
    })), l;
  }, r.computeValue_ = function(u) {
    this.isComputing_ = !0;
    var h = Ev(!1), b;
    if (u)
      b = Iz(this, this.derivation, this.scope_);
    else if (Rn.disableErrorBoundaries === !0)
      b = this.derivation.call(this.scope_);
    else
      try {
        b = this.derivation.call(this.scope_);
      } catch (l) {
        b = new ab(l);
      }
    return yv(h), this.isComputing_ = !1, b;
  }, r.suspend_ = function() {
    this.keepAlive_ || (w2(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== Oc.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, r.observe_ = function(u, h) {
    var b = this, l = !0, v = void 0;
    return Fz(function() {
      var s = b.get();
      if (!l || h) {
        var c = km();
        u({
          observableKind: "computed",
          debugObjectName: b.name_,
          type: Zc,
          object: b,
          newValue: s,
          oldValue: v
        }), xl(c);
      }
      l = !1, v = s;
    });
  }, r.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== Oc.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : Rn.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, r.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, r.valueOf = function() {
    return uz(this.get());
  }, r[Sz] = function() {
    return this.valueOf();
  }, t;
}(), qb = /* @__PURE__ */ hh("ComputedValue", fm), pi;
(function(t) {
  t[t.NOT_TRACKING_ = -1] = "NOT_TRACKING_", t[t.UP_TO_DATE_ = 0] = "UP_TO_DATE_", t[t.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", t[t.STALE_ = 2] = "STALE_";
})(pi || (pi = {}));
var Oc;
(function(t) {
  t[t.NONE = 0] = "NONE", t[t.LOG = 1] = "LOG", t[t.BREAK = 2] = "BREAK";
})(Oc || (Oc = {}));
var ab = function(r) {
  this.cause = void 0, this.cause = r;
};
function X0(t) {
  return t instanceof ab;
}
function N2(t) {
  switch (t.dependenciesState_) {
    case pi.UP_TO_DATE_:
      return !1;
    case pi.NOT_TRACKING_:
    case pi.STALE_:
      return !0;
    case pi.POSSIBLY_STALE_: {
      for (var r = rw(!0), a = km(), u = t.observing_, h = u.length, b = 0; b < h; b++) {
        var l = u[b];
        if (qb(l)) {
          if (Rn.disableErrorBoundaries)
            l.get();
          else
            try {
              l.get();
            } catch {
              return xl(a), Hy(r), !0;
            }
          if (t.dependenciesState_ === pi.STALE_)
            return xl(a), Hy(r), !0;
        }
      }
      return Nz(t), xl(a), Hy(r), !1;
    }
  }
}
function hm(t) {
  if (process.env.NODE_ENV !== "production") {
    var r = t.observers_.size > 0;
    !Rn.allowStateChanges && (r || Rn.enforceActions === "always") && console.warn("[MobX] " + (Rn.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + t.name_);
  }
}
function Lle(t) {
  process.env.NODE_ENV !== "production" && !Rn.allowStateReads && Rn.observableRequiresReaction && console.warn("[mobx] Observable '" + t.name_ + "' being read outside a reactive context.");
}
function Iz(t, r, a) {
  var u = rw(!0);
  Nz(t), t.newObserving_ = new Array(t.observing_.length + 100), t.unboundDepsCount_ = 0, t.runId_ = ++Rn.runId;
  var h = Rn.trackingDerivation;
  Rn.trackingDerivation = t, Rn.inBatch++;
  var b;
  if (Rn.disableErrorBoundaries === !0)
    b = r.call(a);
  else
    try {
      b = r.call(a);
    } catch (l) {
      b = new ab(l);
    }
  return Rn.inBatch--, Rn.trackingDerivation = h, jle(t), kle(t), Hy(u), b;
}
function kle(t) {
  process.env.NODE_ENV !== "production" && t.observing_.length === 0 && (typeof t.requiresObservable_ == "boolean" ? t.requiresObservable_ : Rn.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + t.name_ + "' is created/updated without reading any observable value.");
}
function jle(t) {
  for (var r = t.observing_, a = t.observing_ = t.newObserving_, u = pi.UP_TO_DATE_, h = 0, b = t.unboundDepsCount_, l = 0; l < b; l++) {
    var v = a[l];
    v.diffValue_ === 0 && (v.diffValue_ = 1, h !== l && (a[h] = v), h++), v.dependenciesState_ > u && (u = v.dependenciesState_);
  }
  for (a.length = h, t.newObserving_ = null, b = r.length; b--; ) {
    var s = r[b];
    s.diffValue_ === 0 && _z(s, t), s.diffValue_ = 0;
  }
  for (; h--; ) {
    var c = a[h];
    c.diffValue_ === 1 && (c.diffValue_ = 0, Hle(c, t));
  }
  u !== pi.UP_TO_DATE_ && (t.dependenciesState_ = u, t.onBecomeStale_());
}
function w2(t) {
  var r = t.observing_;
  t.observing_ = [];
  for (var a = r.length; a--; )
    _z(r[a], t);
  t.dependenciesState_ = pi.NOT_TRACKING_;
}
function Rz(t) {
  var r = km();
  try {
    return t();
  } finally {
    xl(r);
  }
}
function km() {
  var t = Rn.trackingDerivation;
  return Rn.trackingDerivation = null, t;
}
function xl(t) {
  Rn.trackingDerivation = t;
}
function rw(t) {
  var r = Rn.allowStateReads;
  return Rn.allowStateReads = t, r;
}
function Hy(t) {
  Rn.allowStateReads = t;
}
function Nz(t) {
  if (t.dependenciesState_ !== pi.UP_TO_DATE_) {
    t.dependenciesState_ = pi.UP_TO_DATE_;
    for (var r = t.observing_, a = r.length; a--; )
      r[a].lowestObserverState_ = pi.UP_TO_DATE_;
  }
}
var W0 = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, q0 = !0, wz = !1, Rn = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ ZN();
  return t.__mobxInstanceCount > 0 && !t.__mobxGlobals && (q0 = !1), t.__mobxGlobals && t.__mobxGlobals.version !== new W0().version && (q0 = !1), q0 ? t.__mobxGlobals ? (t.__mobxInstanceCount += 1, t.__mobxGlobals.UNCHANGED || (t.__mobxGlobals.UNCHANGED = {}), t.__mobxGlobals) : (t.__mobxInstanceCount = 1, t.__mobxGlobals = /* @__PURE__ */ new W0()) : (setTimeout(function() {
    wz || Gn(35);
  }, 1), new W0());
}();
function Ule() {
  if ((Rn.pendingReactions.length || Rn.inBatch || Rn.isRunningReactions) && Gn(36), wz = !0, q0) {
    var t = ZN();
    --t.__mobxInstanceCount === 0 && (t.__mobxGlobals = void 0), Rn = new W0();
  }
}
function Hle(t, r) {
  t.observers_.add(r), t.lowestObserverState_ > r.dependenciesState_ && (t.lowestObserverState_ = r.dependenciesState_);
}
function _z(t, r) {
  t.observers_.delete(r), t.observers_.size === 0 && Pz(t);
}
function Pz(t) {
  t.isPendingUnobservation_ === !1 && (t.isPendingUnobservation_ = !0, Rn.pendingUnobservations.push(t));
}
function jo() {
  Rn.inBatch++;
}
function Uo() {
  if (--Rn.inBatch === 0) {
    kz();
    for (var t = Rn.pendingUnobservations, r = 0; r < t.length; r++) {
      var a = t[r];
      a.isPendingUnobservation_ = !1, a.observers_.size === 0 && (a.isBeingObserved_ && (a.isBeingObserved_ = !1, a.onBUO()), a instanceof fm && a.suspend_());
    }
    Rn.pendingUnobservations = [];
  }
}
function xz(t) {
  Lle(t);
  var r = Rn.trackingDerivation;
  return r !== null ? (r.runId_ !== t.lastAccessedBy_ && (t.lastAccessedBy_ = r.runId_, r.newObserving_[r.unboundDepsCount_++] = t, !t.isBeingObserved_ && Rn.trackingContext && (t.isBeingObserved_ = !0, t.onBO())), t.isBeingObserved_) : (t.observers_.size === 0 && Rn.inBatch > 0 && Pz(t), !1);
}
function Dz(t) {
  t.lowestObserverState_ !== pi.STALE_ && (t.lowestObserverState_ = pi.STALE_, t.observers_.forEach(function(r) {
    r.dependenciesState_ === pi.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && r.isTracing_ !== Oc.NONE && Mz(r, t), r.onBecomeStale_()), r.dependenciesState_ = pi.STALE_;
  }));
}
function Ble(t) {
  t.lowestObserverState_ !== pi.STALE_ && (t.lowestObserverState_ = pi.STALE_, t.observers_.forEach(function(r) {
    r.dependenciesState_ === pi.POSSIBLY_STALE_ ? (r.dependenciesState_ = pi.STALE_, process.env.NODE_ENV !== "production" && r.isTracing_ !== Oc.NONE && Mz(r, t)) : r.dependenciesState_ === pi.UP_TO_DATE_ && (t.lowestObserverState_ = pi.UP_TO_DATE_);
  }));
}
function zle(t) {
  t.lowestObserverState_ === pi.UP_TO_DATE_ && (t.lowestObserverState_ = pi.POSSIBLY_STALE_, t.observers_.forEach(function(r) {
    r.dependenciesState_ === pi.UP_TO_DATE_ && (r.dependenciesState_ = pi.POSSIBLY_STALE_, r.onBecomeStale_());
  }));
}
function Mz(t, r) {
  if (console.log("[mobx.trace] '" + t.name_ + "' is invalidated due to a change in: '" + r.name_ + "'"), t.isTracing_ === Oc.BREAK) {
    var a = [];
    Lz(Xz(t), a, 1), new Function(`debugger;
/*
Tracing '` + t.name_ + `'

You are entering this break point because derivation '` + t.name_ + "' is being traced and '" + r.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (t instanceof fm ? t.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + a.join(`
`) + `
*/
    `)();
  }
}
function Lz(t, r, a) {
  if (r.length >= 1e3) {
    r.push("(and many more)");
    return;
  }
  r.push("" + "	".repeat(a - 1) + t.name), t.dependencies && t.dependencies.forEach(function(u) {
    return Lz(u, r, a + 1);
  });
}
var pm = /* @__PURE__ */ function() {
  function t(a, u, h, b) {
    a === void 0 && (a = process.env.NODE_ENV !== "production" ? "Reaction@" + Ic() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = pi.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = Oc.NONE, this.name_ = a, this.onInvalidate_ = u, this.errorHandler_ = h, this.requiresObservable_ = b;
  }
  var r = t.prototype;
  return r.onBecomeStale_ = function() {
    this.schedule_();
  }, r.schedule_ = function() {
    this.isScheduled_ || (this.isScheduled_ = !0, Rn.pendingReactions.push(this), kz());
  }, r.isScheduled = function() {
    return this.isScheduled_;
  }, r.runReaction_ = function() {
    if (!this.isDisposed_) {
      jo(), this.isScheduled_ = !1;
      var u = Rn.trackingContext;
      if (Rn.trackingContext = this, N2(this)) {
        this.isTrackPending_ = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending_ && ya() && sh({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (h) {
          this.reportExceptionInDerivation_(h);
        }
      }
      Rn.trackingContext = u, Uo();
    }
  }, r.track = function(u) {
    if (!this.isDisposed_) {
      jo();
      var h = ya(), b;
      process.env.NODE_ENV !== "production" && h && (b = Date.now(), Bo({
        name: this.name_,
        type: "reaction"
      })), this.isRunning_ = !0;
      var l = Rn.trackingContext;
      Rn.trackingContext = this;
      var v = Iz(this, u, void 0);
      Rn.trackingContext = l, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && w2(this), X0(v) && this.reportExceptionInDerivation_(v.cause), process.env.NODE_ENV !== "production" && h && zo({
        time: Date.now() - b
      }), Uo();
    }
  }, r.reportExceptionInDerivation_ = function(u) {
    var h = this;
    if (this.errorHandler_) {
      this.errorHandler_(u, this);
      return;
    }
    if (Rn.disableErrorBoundaries)
      throw u;
    var b = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    Rn.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(b, u), process.env.NODE_ENV !== "production" && ya() && sh({
      type: "error",
      name: this.name_,
      message: b,
      error: "" + u
    }), Rn.globalReactionErrorHandlers.forEach(function(l) {
      return l(u, h);
    });
  }, r.dispose = function() {
    this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (jo(), w2(this), Uo()));
  }, r.getDisposer_ = function() {
    var u = this.dispose.bind(this);
    return u[Ur] = this, u;
  }, r.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, r.trace = function(u) {
    u === void 0 && (u = !1), ufe(this, u);
  }, t;
}(), q9 = 100, _2 = function(r) {
  return r();
};
function kz() {
  Rn.inBatch > 0 || Rn.isRunningReactions || _2(Fle);
}
function Fle() {
  Rn.isRunningReactions = !0;
  for (var t = Rn.pendingReactions, r = 0; t.length > 0; ) {
    ++r === q9 && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + q9 + " iterations." + (" Probably there is a cycle in the reactive function: " + t[0]) : "[mobx] cycle in reaction: " + t[0]), t.splice(0));
    for (var a = t.splice(0), u = 0, h = a.length; u < h; u++)
      a[u].runReaction_();
  }
  Rn.isRunningReactions = !1;
}
var ob = /* @__PURE__ */ hh("Reaction", pm);
function Gle(t) {
  var r = _2;
  _2 = function(u) {
    return t(function() {
      return r(u);
    });
  };
}
function ya() {
  return process.env.NODE_ENV !== "production" && !!Rn.spyListeners.length;
}
function sh(t) {
  if (process.env.NODE_ENV !== "production" && Rn.spyListeners.length)
    for (var r = Rn.spyListeners, a = 0, u = r.length; a < u; a++)
      r[a](t);
}
function Bo(t) {
  if (process.env.NODE_ENV !== "production") {
    var r = Ul({}, t, {
      spyReportStart: !0
    });
    sh(r);
  }
}
var Vle = {
  type: "report-end",
  spyReportEnd: !0
};
function zo(t) {
  process.env.NODE_ENV !== "production" && sh(t ? Ul({}, t, {
    type: "report-end",
    spyReportEnd: !0
  }) : Vle);
}
function Yle(t) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (Rn.spyListeners.push(t), $N(function() {
    Rn.spyListeners = Rn.spyListeners.filter(function(r) {
      return r !== t;
    });
  }));
}
var iw = "action", Xle = "action.bound", jz = "autoAction", Wle = "autoAction.bound", Uz = "<unnamed action>", Hz = /* @__PURE__ */ gv(iw), qle = /* @__PURE__ */ gv(Xle, {
  bound: !0
}), Bz = /* @__PURE__ */ gv(jz, {
  autoAction: !0
}), Kle = /* @__PURE__ */ gv(Wle, {
  autoAction: !0,
  bound: !0
});
function zz(t) {
  var r = function(u, h) {
    if (ks(u))
      return lm(u.name || Uz, u, t);
    if (ks(h))
      return lm(u, h, t);
    if (ih(h))
      return hv(u, h, t ? Bz : Hz);
    if (ih(u))
      return Uu(gv(t ? jz : iw, {
        name: u,
        autoAction: t
      }));
    process.env.NODE_ENV !== "production" && Gn("Invalid arguments for `action`");
  };
  return r;
}
var Sn = /* @__PURE__ */ zz(!1);
Object.assign(Sn, Hz);
var qy = /* @__PURE__ */ zz(!0);
Object.assign(qy, Bz);
Sn.bound = /* @__PURE__ */ Uu(qle);
qy.bound = /* @__PURE__ */ Uu(Kle);
function qi(t) {
  return Az(t.name || Uz, !1, t, this, void 0);
}
function Kb(t) {
  return ks(t) && t.isMobxAction === !0;
}
function Fz(t, r) {
  var a, u;
  r === void 0 && (r = QN), process.env.NODE_ENV !== "production" && (ks(t) || Gn("Autorun expects a function as first argument"), Kb(t) && Gn("Autorun does not accept actions since actions are untrackable"));
  var h = (a = (u = r) == null ? void 0 : u.name) != null ? a : process.env.NODE_ENV !== "production" ? t.name || "Autorun@" + Ic() : "Autorun", b = !r.scheduler && !r.delay, l;
  if (b)
    l = new pm(h, function() {
      this.track(c);
    }, r.onError, r.requiresObservable);
  else {
    var v = Gz(r), s = !1;
    l = new pm(h, function() {
      s || (s = !0, v(function() {
        s = !1, l.isDisposed_ || l.track(c);
      }));
    }, r.onError, r.requiresObservable);
  }
  function c() {
    t(l);
  }
  return l.schedule_(), l.getDisposer_();
}
var Jle = function(r) {
  return r();
};
function Gz(t) {
  return t.scheduler ? t.scheduler : t.delay ? function(r) {
    return setTimeout(r, t.delay);
  } : Jle;
}
function Qc(t, r, a) {
  var u;
  a === void 0 && (a = QN), process.env.NODE_ENV !== "production" && ((!ks(t) || !ks(r)) && Gn("First and second argument to reaction should be functions"), nu(a) || Gn("Third argument of reactions should be an object"));
  var h = (u = a.name) != null ? u : process.env.NODE_ENV !== "production" ? "Reaction@" + Ic() : "Reaction", b = Sn(h, a.onError ? Zle(a.onError, r) : r), l = !a.scheduler && !a.delay, v = Gz(a), s = !0, c = !1, d, p, m = a.compareStructural ? um.structural : a.equals || um.default, E = new pm(h, function() {
    s || l ? y() : c || (c = !0, v(y));
  }, a.onError, a.requiresObservable);
  function y() {
    if (c = !1, !E.isDisposed_) {
      var g = !1;
      E.track(function() {
        var C = Oz(!1, function() {
          return t(E);
        });
        g = s || !m(d, C), p = d, d = C;
      }), (s && a.fireImmediately || !s && g) && b(d, p, E), s = !1;
    }
  }
  return E.schedule_(), E.getDisposer_();
}
function Zle(t, r) {
  return function() {
    try {
      return r.apply(this, arguments);
    } catch (a) {
      t.call(this, a);
    }
  };
}
var Qle = "onBO", $le = "onBUO";
function efe(t, r, a) {
  return Yz(Qle, t, r, a);
}
function Vz(t, r, a) {
  return Yz($le, t, r, a);
}
function Yz(t, r, a, u) {
  var h = gm(r), b = ks(u) ? u : a, l = t + "L";
  return h[l] ? h[l].add(b) : h[l] = /* @__PURE__ */ new Set([b]), function() {
    var v = h[l];
    v && (v.delete(b), v.size === 0 && delete h[l]);
  };
}
var tfe = "never", C0 = "always", nfe = "observed";
function rfe(t) {
  t.isolateGlobalState === !0 && Ule();
  var r = t.useProxies, a = t.enforceActions;
  if (r !== void 0 && (Rn.useProxies = r === C0 ? !0 : r === tfe ? !1 : typeof Proxy < "u"), r === "ifavailable" && (Rn.verifyProxies = !0), a !== void 0) {
    var u = a === C0 ? C0 : a === nfe;
    Rn.enforceActions = u, Rn.allowStateChanges = !(u === !0 || u === C0);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(h) {
    h in t && (Rn[h] = !!t[h]);
  }), Rn.allowStateReads = !Rn.observableRequiresReaction, process.env.NODE_ENV !== "production" && Rn.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), t.reactionScheduler && Gle(t.reactionScheduler);
}
function ife(t, r, a, u) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && Gn("'extendObservable' expected 2-4 arguments"), typeof t != "object" && Gn("'extendObservable' expects an object as first argument"), Xl(t) && Gn("'extendObservable' should not be used on maps, use map.merge instead"), nu(r) || Gn("'extendObservable' only accepts plain objects as second argument"), (Jy(r) || Jy(a)) && Gn("Extending an object with another observable (object) is not supported"));
  var h = Fde(r), b = Zb(t, u)[Ur];
  jo();
  try {
    Yb(h).forEach(function(l) {
      b.extend_(
        l,
        h[l],
        // must pass "undefined" for { key: undefined }
        a && l in a ? a[l] : !0
      );
    });
  } finally {
    Uo();
  }
  return t;
}
function Xz(t, r) {
  return Wz(gm(t, r));
}
function Wz(t) {
  var r = {
    name: t.name_
  };
  return t.observing_ && t.observing_.length > 0 && (r.dependencies = sfe(t.observing_).map(Wz)), r;
}
function sfe(t) {
  return Array.from(new Set(t));
}
var afe = 0;
function qz() {
  this.message = "FLOW_CANCELLED";
}
qz.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var K9 = /* @__PURE__ */ hz("flow"), ofe = /* @__PURE__ */ hz("flow.bound", {
  bound: !0
}), Ky = /* @__PURE__ */ Object.assign(function(r, a) {
  if (ih(a))
    return hv(r, a, K9);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && Gn("Flow expects single argument with generator function");
  var u = r, h = u.name || "<unnamed flow>", b = function() {
    var v = this, s = arguments, c = ++afe, d = Sn(h + " - runid: " + c + " - init", u).apply(v, s), p, m = void 0, E = new Promise(function(y, g) {
      var C = 0;
      p = g;
      function O(_) {
        m = void 0;
        var I;
        try {
          I = Sn(h + " - runid: " + c + " - yield " + C++, d.next).call(d, _);
        } catch (k) {
          return g(k);
        }
        w(I);
      }
      function N(_) {
        m = void 0;
        var I;
        try {
          I = Sn(h + " - runid: " + c + " - yield " + C++, d.throw).call(d, _);
        } catch (k) {
          return g(k);
        }
        w(I);
      }
      function w(_) {
        if (ks(_ == null ? void 0 : _.then)) {
          _.then(w, g);
          return;
        }
        return _.done ? y(_.value) : (m = Promise.resolve(_.value), m.then(O, N));
      }
      O(void 0);
    });
    return E.cancel = Sn(h + " - runid: " + c + " - cancel", function() {
      try {
        m && J9(m);
        var y = d.return(void 0), g = Promise.resolve(y.value);
        g.then(Xp, Xp), J9(g), p(new qz());
      } catch (C) {
        p(C);
      }
    }), E;
  };
  return b.isMobXFlow = !0, b;
}, K9);
Ky.bound = /* @__PURE__ */ Uu(ofe);
function J9(t) {
  ks(t.cancel) && t.cancel();
}
function cb(t) {
  return (t == null ? void 0 : t.isMobXFlow) === !0;
}
function cfe(t, r) {
  return t ? bv(t) || !!t[Ur] || tw(t) || ob(t) || qb(t) : !1;
}
function Jy(t) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && Gn("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), cfe(t);
}
function ufe() {
  process.env.NODE_ENV === "production" && Gn("trace() is not available in production builds");
  for (var t = !1, r = arguments.length, a = new Array(r), u = 0; u < r; u++)
    a[u] = arguments[u];
  typeof a[a.length - 1] == "boolean" && (t = a.pop());
  var h = dfe(a);
  if (!h)
    return Gn("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
  h.isTracing_ === Oc.NONE && console.log("[mobx.trace] '" + h.name_ + "' tracing enabled"), h.isTracing_ = t ? Oc.BREAK : Oc.LOG;
}
function dfe(t) {
  switch (t.length) {
    case 0:
      return Rn.trackingDerivation;
    case 1:
      return gm(t[0]);
    case 2:
      return gm(t[0], t[1]);
  }
}
function Rd(t, r) {
  r === void 0 && (r = void 0), jo();
  try {
    return t.apply(r);
  } finally {
    Uo();
  }
}
function Yf(t) {
  return t[Ur];
}
var lfe = {
  has: function(r, a) {
    return process.env.NODE_ENV !== "production" && Rn.trackingDerivation && Ty("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Yf(r).has_(a);
  },
  get: function(r, a) {
    return Yf(r).get_(a);
  },
  set: function(r, a, u) {
    var h;
    return ih(a) ? (process.env.NODE_ENV !== "production" && !Yf(r).values_.has(a) && Ty("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (h = Yf(r).set_(a, u, !0)) != null ? h : !0) : !1;
  },
  deleteProperty: function(r, a) {
    var u;
    return process.env.NODE_ENV !== "production" && Ty("delete properties from an observable object. Use 'remove' from 'mobx' instead."), ih(a) ? (u = Yf(r).delete_(a, !0)) != null ? u : !0 : !1;
  },
  defineProperty: function(r, a, u) {
    var h;
    return process.env.NODE_ENV !== "production" && Ty("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (h = Yf(r).defineProperty_(a, u)) != null ? h : !0;
  },
  ownKeys: function(r) {
    return process.env.NODE_ENV !== "production" && Rn.trackingDerivation && Ty("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Yf(r).ownKeys_();
  },
  preventExtensions: function(r) {
    Gn(13);
  }
};
function ffe(t, r) {
  var a, u;
  return sz(), t = Zb(t, r), (u = (a = t[Ur]).proxy_) != null ? u : a.proxy_ = new Proxy(t, lfe);
}
function Tc(t) {
  return t.interceptors_ !== void 0 && t.interceptors_.length > 0;
}
function vv(t, r) {
  var a = t.interceptors_ || (t.interceptors_ = []);
  return a.push(r), $N(function() {
    var u = a.indexOf(r);
    u !== -1 && a.splice(u, 1);
  });
}
function bc(t, r) {
  var a = km();
  try {
    for (var u = [].concat(t.interceptors_ || []), h = 0, b = u.length; h < b && (r = u[h](r), r && !r.type && Gn(14), !!r); h++)
      ;
    return r;
  } finally {
    xl(a);
  }
}
function $c(t) {
  return t.changeListeners_ !== void 0 && t.changeListeners_.length > 0;
}
function Tv(t, r) {
  var a = t.changeListeners_ || (t.changeListeners_ = []);
  return a.push(r), $N(function() {
    var u = a.indexOf(r);
    u !== -1 && a.splice(u, 1);
  });
}
function eu(t, r) {
  var a = km(), u = t.changeListeners_;
  if (u) {
    u = u.slice();
    for (var h = 0, b = u.length; h < b; h++)
      u[h](r);
    xl(a);
  }
}
function ph(t, r, a) {
  var u = Zb(t, a)[Ur];
  jo();
  try {
    var h;
    process.env.NODE_ENV !== "production" && r && t[qa] && Gn("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (h = r) != null || (r = qde(t)), Yb(r).forEach(function(b) {
      return u.make_(b, r[b]);
    });
  } finally {
    Uo();
  }
  return t;
}
var Z9 = "splice", Zc = "update", hfe = 1e4, pfe = {
  get: function(r, a) {
    var u = r[Ur];
    return a === Ur ? u : a === "length" ? u.getArrayLength_() : typeof a == "string" && !isNaN(a) ? u.get_(parseInt(a)) : Ac(ub, a) ? ub[a] : r[a];
  },
  set: function(r, a, u) {
    var h = r[Ur];
    return a === "length" && h.setArrayLength_(u), typeof a == "symbol" || isNaN(a) ? r[a] = u : h.set_(parseInt(a), u), !0;
  },
  preventExtensions: function() {
    Gn(15);
  }
}, sw = /* @__PURE__ */ function() {
  function t(a, u, h, b) {
    a === void 0 && (a = process.env.NODE_ENV !== "production" ? "ObservableArray@" + Ic() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = h, this.legacyMode_ = b, this.atom_ = new pv(a), this.enhancer_ = function(l, v) {
      return u(l, v, process.env.NODE_ENV !== "production" ? a + "[..]" : "ObservableArray[..]");
    };
  }
  var r = t.prototype;
  return r.dehanceValue_ = function(u) {
    return this.dehancer !== void 0 ? this.dehancer(u) : u;
  }, r.dehanceValues_ = function(u) {
    return this.dehancer !== void 0 && u.length > 0 ? u.map(this.dehancer) : u;
  }, r.intercept_ = function(u) {
    return vv(this, u);
  }, r.observe_ = function(u, h) {
    return h === void 0 && (h = !1), h && u({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), Tv(this, u);
  }, r.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, r.setArrayLength_ = function(u) {
    (typeof u != "number" || isNaN(u) || u < 0) && Gn("Out of range: " + u);
    var h = this.values_.length;
    if (u !== h)
      if (u > h) {
        for (var b = new Array(u - h), l = 0; l < u - h; l++)
          b[l] = void 0;
        this.spliceWithArray_(h, 0, b);
      } else
        this.spliceWithArray_(u, h - u);
  }, r.updateArrayLength_ = function(u, h) {
    u !== this.lastKnownLength_ && Gn(16), this.lastKnownLength_ += h, this.legacyMode_ && h > 0 && iF(u + h + 1);
  }, r.spliceWithArray_ = function(u, h, b) {
    var l = this;
    hm(this.atom_);
    var v = this.values_.length;
    if (u === void 0 ? u = 0 : u > v ? u = v : u < 0 && (u = Math.max(0, v + u)), arguments.length === 1 ? h = v - u : h == null ? h = 0 : h = Math.max(0, Math.min(h, v - u)), b === void 0 && (b = rb), Tc(this)) {
      var s = bc(this, {
        object: this.proxy_,
        type: Z9,
        index: u,
        removedCount: h,
        added: b
      });
      if (!s)
        return rb;
      h = s.removedCount, b = s.added;
    }
    if (b = b.length === 0 ? b : b.map(function(p) {
      return l.enhancer_(p, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var c = b.length - h;
      this.updateArrayLength_(v, c);
    }
    var d = this.spliceItemsIntoValues_(u, h, b);
    return (h !== 0 || b.length !== 0) && this.notifyArraySplice_(u, b, d), this.dehanceValues_(d);
  }, r.spliceItemsIntoValues_ = function(u, h, b) {
    if (b.length < hfe) {
      var l;
      return (l = this.values_).splice.apply(l, [u, h].concat(b));
    } else {
      var v = this.values_.slice(u, u + h), s = this.values_.slice(u + h);
      this.values_.length += b.length - h;
      for (var c = 0; c < b.length; c++)
        this.values_[u + c] = b[c];
      for (var d = 0; d < s.length; d++)
        this.values_[u + b.length + d] = s[d];
      return v;
    }
  }, r.notifyArrayChildUpdate_ = function(u, h, b) {
    var l = !this.owned_ && ya(), v = $c(this), s = v || l ? {
      observableKind: "array",
      object: this.proxy_,
      type: Zc,
      debugObjectName: this.atom_.name_,
      index: u,
      newValue: h,
      oldValue: b
    } : null;
    process.env.NODE_ENV !== "production" && l && Bo(s), this.atom_.reportChanged(), v && eu(this, s), process.env.NODE_ENV !== "production" && l && zo();
  }, r.notifyArraySplice_ = function(u, h, b) {
    var l = !this.owned_ && ya(), v = $c(this), s = v || l ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: Z9,
      index: u,
      removed: b,
      added: h,
      removedCount: b.length,
      addedCount: h.length
    } : null;
    process.env.NODE_ENV !== "production" && l && Bo(s), this.atom_.reportChanged(), v && eu(this, s), process.env.NODE_ENV !== "production" && l && zo();
  }, r.get_ = function(u) {
    if (this.legacyMode_ && u >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + u + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + u);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[u]);
  }, r.set_ = function(u, h) {
    var b = this.values_;
    if (this.legacyMode_ && u > b.length && Gn(17, u, b.length), u < b.length) {
      hm(this.atom_);
      var l = b[u];
      if (Tc(this)) {
        var v = bc(this, {
          type: Zc,
          object: this.proxy_,
          index: u,
          newValue: h
        });
        if (!v)
          return;
        h = v.newValue;
      }
      h = this.enhancer_(h, l);
      var s = h !== l;
      s && (b[u] = h, this.notifyArrayChildUpdate_(u, h, l));
    } else {
      for (var c = new Array(u + 1 - b.length), d = 0; d < c.length - 1; d++)
        c[d] = void 0;
      c[c.length - 1] = h, this.spliceWithArray_(b.length, 0, c);
    }
  }, t;
}();
function gfe(t, r, a, u) {
  a === void 0 && (a = process.env.NODE_ENV !== "production" ? "ObservableArray@" + Ic() : "ObservableArray"), u === void 0 && (u = !1), sz();
  var h = new sw(a, r, u, !1);
  oz(h.values_, Ur, h);
  var b = new Proxy(h.values_, pfe);
  if (h.proxy_ = b, t && t.length) {
    var l = Ev(!0);
    h.spliceWithArray_(0, 0, t), yv(l);
  }
  return b;
}
var ub = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(r) {
    var a = this[Ur];
    return a.spliceWithArray_(0, a.values_.length, r);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(r, a) {
    for (var u = arguments.length, h = new Array(u > 2 ? u - 2 : 0), b = 2; b < u; b++)
      h[b - 2] = arguments[b];
    var l = this[Ur];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return l.spliceWithArray_(r);
      case 2:
        return l.spliceWithArray_(r, a);
    }
    return l.spliceWithArray_(r, a, h);
  },
  spliceWithArray: function(r, a, u) {
    return this[Ur].spliceWithArray_(r, a, u);
  },
  push: function() {
    for (var r = this[Ur], a = arguments.length, u = new Array(a), h = 0; h < a; h++)
      u[h] = arguments[h];
    return r.spliceWithArray_(r.values_.length, 0, u), r.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[Ur].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var r = this[Ur], a = arguments.length, u = new Array(a), h = 0; h < a; h++)
      u[h] = arguments[h];
    return r.spliceWithArray_(0, 0, u), r.values_.length;
  },
  reverse: function() {
    return Rn.trackingDerivation && Gn(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    Rn.trackingDerivation && Gn(37, "sort");
    var r = this.slice();
    return r.sort.apply(r, arguments), this.replace(r), this;
  },
  remove: function(r) {
    var a = this[Ur], u = a.dehanceValues_(a.values_).indexOf(r);
    return u > -1 ? (this.splice(u, 1), !0) : !1;
  }
};
$s("concat", kd);
$s("flat", kd);
$s("includes", kd);
$s("indexOf", kd);
$s("join", kd);
$s("lastIndexOf", kd);
$s("slice", kd);
$s("toString", kd);
$s("toLocaleString", kd);
$s("every", Yl);
$s("filter", Yl);
$s("find", Yl);
$s("findIndex", Yl);
$s("flatMap", Yl);
$s("forEach", Yl);
$s("map", Yl);
$s("some", Yl);
$s("reduce", Kz);
$s("reduceRight", Kz);
function $s(t, r) {
  typeof Array.prototype[t] == "function" && (ub[t] = r(t));
}
function kd(t) {
  return function() {
    var r = this[Ur];
    r.atom_.reportObserved();
    var a = r.dehanceValues_(r.values_);
    return a[t].apply(a, arguments);
  };
}
function Yl(t) {
  return function(r, a) {
    var u = this, h = this[Ur];
    h.atom_.reportObserved();
    var b = h.dehanceValues_(h.values_);
    return b[t](function(l, v) {
      return r.call(a, l, v, u);
    });
  };
}
function Kz(t) {
  return function() {
    var r = this, a = this[Ur];
    a.atom_.reportObserved();
    var u = a.dehanceValues_(a.values_), h = arguments[0];
    return arguments[0] = function(b, l, v) {
      return h(b, l, v, r);
    }, u[t].apply(u, arguments);
  };
}
var mfe = /* @__PURE__ */ hh("ObservableArrayAdministration", sw);
function Jb(t) {
  return Gb(t) && mfe(t[Ur]);
}
var Jz, Zz, Efe = {}, wl = "add", db = "delete";
Jz = Symbol.iterator;
Zz = Symbol.toStringTag;
var Qz = /* @__PURE__ */ function() {
  function t(a, u, h) {
    var b = this;
    u === void 0 && (u = dm), h === void 0 && (h = process.env.NODE_ENV !== "production" ? "ObservableMap@" + Ic() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Ur] = Efe, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = u, this.name_ = h, ks(Map) || Gn(18), this.keysAtom_ = lz(process.env.NODE_ENV !== "production" ? this.name_ + ".keys()" : "ObservableMap.keys()"), this.data_ = /* @__PURE__ */ new Map(), this.hasMap_ = /* @__PURE__ */ new Map(), Oz(!0, function() {
      b.merge(a);
    });
  }
  var r = t.prototype;
  return r.has_ = function(u) {
    return this.data_.has(u);
  }, r.has = function(u) {
    var h = this;
    if (!Rn.trackingDerivation)
      return this.has_(u);
    var b = this.hasMap_.get(u);
    if (!b) {
      var l = b = new ig(this.has_(u), Xb, process.env.NODE_ENV !== "production" ? this.name_ + "." + I2(u) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(u, l), Vz(l, function() {
        return h.hasMap_.delete(u);
      });
    }
    return b.get();
  }, r.set = function(u, h) {
    var b = this.has_(u);
    if (Tc(this)) {
      var l = bc(this, {
        type: b ? Zc : wl,
        object: this,
        newValue: h,
        name: u
      });
      if (!l)
        return this;
      h = l.newValue;
    }
    return b ? this.updateValue_(u, h) : this.addValue_(u, h), this;
  }, r.delete = function(u) {
    var h = this;
    if (hm(this.keysAtom_), Tc(this)) {
      var b = bc(this, {
        type: db,
        object: this,
        name: u
      });
      if (!b)
        return !1;
    }
    if (this.has_(u)) {
      var l = ya(), v = $c(this), s = v || l ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: db,
        object: this,
        oldValue: this.data_.get(u).value_,
        name: u
      } : null;
      return process.env.NODE_ENV !== "production" && l && Bo(s), Rd(function() {
        var c;
        h.keysAtom_.reportChanged(), (c = h.hasMap_.get(u)) == null || c.setNewValue_(!1);
        var d = h.data_.get(u);
        d.setNewValue_(void 0), h.data_.delete(u);
      }), v && eu(this, s), process.env.NODE_ENV !== "production" && l && zo(), !0;
    }
    return !1;
  }, r.updateValue_ = function(u, h) {
    var b = this.data_.get(u);
    if (h = b.prepareNewValue_(h), h !== Rn.UNCHANGED) {
      var l = ya(), v = $c(this), s = v || l ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Zc,
        object: this,
        oldValue: b.value_,
        name: u,
        newValue: h
      } : null;
      process.env.NODE_ENV !== "production" && l && Bo(s), b.setNewValue_(h), v && eu(this, s), process.env.NODE_ENV !== "production" && l && zo();
    }
  }, r.addValue_ = function(u, h) {
    var b = this;
    hm(this.keysAtom_), Rd(function() {
      var c, d = new ig(h, b.enhancer_, process.env.NODE_ENV !== "production" ? b.name_ + "." + I2(u) : "ObservableMap.key", !1);
      b.data_.set(u, d), h = d.value_, (c = b.hasMap_.get(u)) == null || c.setNewValue_(!0), b.keysAtom_.reportChanged();
    });
    var l = ya(), v = $c(this), s = v || l ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: wl,
      object: this,
      name: u,
      newValue: h
    } : null;
    process.env.NODE_ENV !== "production" && l && Bo(s), v && eu(this, s), process.env.NODE_ENV !== "production" && l && zo();
  }, r.get = function(u) {
    return this.has(u) ? this.dehanceValue_(this.data_.get(u).get()) : this.dehanceValue_(void 0);
  }, r.dehanceValue_ = function(u) {
    return this.dehancer !== void 0 ? this.dehancer(u) : u;
  }, r.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, r.values = function() {
    var u = this, h = this.keys();
    return Zy({
      next: function() {
        var l = h.next(), v = l.done, s = l.value;
        return {
          done: v,
          value: v ? void 0 : u.get(s)
        };
      }
    });
  }, r.entries = function() {
    var u = this, h = this.keys();
    return Zy({
      next: function() {
        var l = h.next(), v = l.done, s = l.value;
        return {
          done: v,
          value: v ? void 0 : [s, u.get(s)]
        };
      }
    });
  }, r[Jz] = function() {
    return this.entries();
  }, r.forEach = function(u, h) {
    for (var b = Wp(this), l; !(l = b()).done; ) {
      var v = l.value, s = v[0], c = v[1];
      u.call(h, c, s, this);
    }
  }, r.merge = function(u) {
    var h = this;
    return Xl(u) && (u = new Map(u)), Rd(function() {
      nu(u) ? zde(u).forEach(function(b) {
        return h.set(b, u[b]);
      }) : Array.isArray(u) ? u.forEach(function(b) {
        var l = b[0], v = b[1];
        return h.set(l, v);
      }) : Lm(u) ? (u.constructor !== Map && Gn(19, u), u.forEach(function(b, l) {
        return h.set(l, b);
      })) : u != null && Gn(20, u);
    }), this;
  }, r.clear = function() {
    var u = this;
    Rd(function() {
      Rz(function() {
        for (var h = Wp(u.keys()), b; !(b = h()).done; ) {
          var l = b.value;
          u.delete(l);
        }
      });
    });
  }, r.replace = function(u) {
    var h = this;
    return Rd(function() {
      for (var b = yfe(u), l = /* @__PURE__ */ new Map(), v = !1, s = Wp(h.data_.keys()), c; !(c = s()).done; ) {
        var d = c.value;
        if (!b.has(d)) {
          var p = h.delete(d);
          if (p)
            v = !0;
          else {
            var m = h.data_.get(d);
            l.set(d, m);
          }
        }
      }
      for (var E = Wp(b.entries()), y; !(y = E()).done; ) {
        var g = y.value, C = g[0], O = g[1], N = h.data_.has(C);
        if (h.set(C, O), h.data_.has(C)) {
          var w = h.data_.get(C);
          l.set(C, w), N || (v = !0);
        }
      }
      if (!v)
        if (h.data_.size !== l.size)
          h.keysAtom_.reportChanged();
        else
          for (var _ = h.data_.keys(), I = l.keys(), k = _.next(), H = I.next(); !k.done; ) {
            if (k.value !== H.value) {
              h.keysAtom_.reportChanged();
              break;
            }
            k = _.next(), H = I.next();
          }
      h.data_ = l;
    }), this;
  }, r.toString = function() {
    return "[object ObservableMap]";
  }, r.toJSON = function() {
    return Array.from(this);
  }, r.observe_ = function(u, h) {
    return process.env.NODE_ENV !== "production" && h === !0 && Gn("`observe` doesn't support fireImmediately=true in combination with maps."), Tv(this, u);
  }, r.intercept_ = function(u) {
    return vv(this, u);
  }, ew(t, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Zz,
    get: function() {
      return "Map";
    }
  }]), t;
}(), Xl = /* @__PURE__ */ hh("ObservableMap", Qz);
function yfe(t) {
  if (Lm(t) || Xl(t))
    return t;
  if (Array.isArray(t))
    return new Map(t);
  if (nu(t)) {
    var r = /* @__PURE__ */ new Map();
    for (var a in t)
      r.set(a, t[a]);
    return r;
  } else
    return Gn(21, t);
}
var $z, eF, vfe = {};
$z = Symbol.iterator;
eF = Symbol.toStringTag;
var tF = /* @__PURE__ */ function() {
  function t(a, u, h) {
    u === void 0 && (u = dm), h === void 0 && (h = process.env.NODE_ENV !== "production" ? "ObservableSet@" + Ic() : "ObservableSet"), this.name_ = void 0, this[Ur] = vfe, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = h, ks(Set) || Gn(22), this.atom_ = lz(this.name_), this.enhancer_ = function(b, l) {
      return u(b, l, h);
    }, a && this.replace(a);
  }
  var r = t.prototype;
  return r.dehanceValue_ = function(u) {
    return this.dehancer !== void 0 ? this.dehancer(u) : u;
  }, r.clear = function() {
    var u = this;
    Rd(function() {
      Rz(function() {
        for (var h = Wp(u.data_.values()), b; !(b = h()).done; ) {
          var l = b.value;
          u.delete(l);
        }
      });
    });
  }, r.forEach = function(u, h) {
    for (var b = Wp(this), l; !(l = b()).done; ) {
      var v = l.value;
      u.call(h, v, v, this);
    }
  }, r.add = function(u) {
    var h = this;
    if (hm(this.atom_), Tc(this)) {
      var b = bc(this, {
        type: wl,
        object: this,
        newValue: u
      });
      if (!b)
        return this;
    }
    if (!this.has(u)) {
      Rd(function() {
        h.data_.add(h.enhancer_(u, void 0)), h.atom_.reportChanged();
      });
      var l = process.env.NODE_ENV !== "production" && ya(), v = $c(this), s = v || l ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: wl,
        object: this,
        newValue: u
      } : null;
      l && process.env.NODE_ENV !== "production" && Bo(s), v && eu(this, s), l && process.env.NODE_ENV !== "production" && zo();
    }
    return this;
  }, r.delete = function(u) {
    var h = this;
    if (Tc(this)) {
      var b = bc(this, {
        type: db,
        object: this,
        oldValue: u
      });
      if (!b)
        return !1;
    }
    if (this.has(u)) {
      var l = process.env.NODE_ENV !== "production" && ya(), v = $c(this), s = v || l ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: db,
        object: this,
        oldValue: u
      } : null;
      return l && process.env.NODE_ENV !== "production" && Bo(s), Rd(function() {
        h.atom_.reportChanged(), h.data_.delete(u);
      }), v && eu(this, s), l && process.env.NODE_ENV !== "production" && zo(), !0;
    }
    return !1;
  }, r.has = function(u) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(u));
  }, r.entries = function() {
    var u = 0, h = Array.from(this.keys()), b = Array.from(this.values());
    return Zy({
      next: function() {
        var v = u;
        return u += 1, v < b.length ? {
          value: [h[v], b[v]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, r.keys = function() {
    return this.values();
  }, r.values = function() {
    this.atom_.reportObserved();
    var u = this, h = 0, b = Array.from(this.data_.values());
    return Zy({
      next: function() {
        return h < b.length ? {
          value: u.dehanceValue_(b[h++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, r.replace = function(u) {
    var h = this;
    return jm(u) && (u = new Set(u)), Rd(function() {
      Array.isArray(u) ? (h.clear(), u.forEach(function(b) {
        return h.add(b);
      })) : fv(u) ? (h.clear(), u.forEach(function(b) {
        return h.add(b);
      })) : u != null && Gn("Cannot initialize set from " + u);
    }), this;
  }, r.observe_ = function(u, h) {
    return process.env.NODE_ENV !== "production" && h === !0 && Gn("`observe` doesn't support fireImmediately=true in combination with sets."), Tv(this, u);
  }, r.intercept_ = function(u) {
    return vv(this, u);
  }, r.toJSON = function() {
    return Array.from(this);
  }, r.toString = function() {
    return "[object ObservableSet]";
  }, r[$z] = function() {
    return this.values();
  }, ew(t, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: eF,
    get: function() {
      return "Set";
    }
  }]), t;
}(), jm = /* @__PURE__ */ hh("ObservableSet", tF), Q9 = /* @__PURE__ */ Object.create(null), $9 = "remove", P2 = /* @__PURE__ */ function() {
  function t(a, u, h, b) {
    u === void 0 && (u = /* @__PURE__ */ new Map()), b === void 0 && (b = gle), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = a, this.values_ = u, this.name_ = h, this.defaultAnnotation_ = b, this.keysAtom_ = new pv(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = nu(this.target_), process.env.NODE_ENV !== "production" && !aF(this.defaultAnnotation_) && Gn("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var r = t.prototype;
  return r.getObservablePropValue_ = function(u) {
    return this.values_.get(u).get();
  }, r.setObservablePropValue_ = function(u, h) {
    var b = this.values_.get(u);
    if (b instanceof fm)
      return b.set(h), !0;
    if (Tc(this)) {
      var l = bc(this, {
        type: Zc,
        object: this.proxy_ || this.target_,
        name: u,
        newValue: h
      });
      if (!l)
        return null;
      h = l.newValue;
    }
    if (h = b.prepareNewValue_(h), h !== Rn.UNCHANGED) {
      var v = $c(this), s = process.env.NODE_ENV !== "production" && ya(), c = v || s ? {
        type: Zc,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: b.value_,
        name: u,
        newValue: h
      } : null;
      process.env.NODE_ENV !== "production" && s && Bo(c), b.setNewValue_(h), v && eu(this, c), process.env.NODE_ENV !== "production" && s && zo();
    }
    return !0;
  }, r.get_ = function(u) {
    return Rn.trackingDerivation && !Ac(this.target_, u) && this.has_(u), this.target_[u];
  }, r.set_ = function(u, h, b) {
    return b === void 0 && (b = !1), Ac(this.target_, u) ? this.values_.has(u) ? this.setObservablePropValue_(u, h) : b ? Reflect.set(this.target_, u, h) : (this.target_[u] = h, !0) : this.extend_(u, {
      value: h,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, b);
  }, r.has_ = function(u) {
    if (!Rn.trackingDerivation)
      return u in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var h = this.pendingKeys_.get(u);
    return h || (h = new ig(u in this.target_, Xb, process.env.NODE_ENV !== "production" ? this.name_ + "." + I2(u) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(u, h)), h.get();
  }, r.make_ = function(u, h) {
    if (h === !0 && (h = this.defaultAnnotation_), h !== !1) {
      if (nj(this, h, u), !(u in this.target_)) {
        var b;
        if ((b = this.target_[qa]) != null && b[u])
          return;
        Gn(1, h.annotationType_, this.name_ + "." + u.toString());
      }
      for (var l = this.target_; l && l !== Fb; ) {
        var v = nb(l, u);
        if (v) {
          var s = h.make_(this, u, v, l);
          if (s === 0)
            return;
          if (s === 1)
            break;
        }
        l = Object.getPrototypeOf(l);
      }
      tj(this, h, u);
    }
  }, r.extend_ = function(u, h, b, l) {
    if (l === void 0 && (l = !1), b === !0 && (b = this.defaultAnnotation_), b === !1)
      return this.defineProperty_(u, h, l);
    nj(this, b, u);
    var v = b.extend_(this, u, h, l);
    return v && tj(this, b, u), v;
  }, r.defineProperty_ = function(u, h, b) {
    b === void 0 && (b = !1);
    try {
      jo();
      var l = this.delete_(u);
      if (!l)
        return l;
      if (Tc(this)) {
        var v = bc(this, {
          object: this.proxy_ || this.target_,
          name: u,
          type: wl,
          newValue: h.value
        });
        if (!v)
          return null;
        var s = v.newValue;
        h.value !== s && (h = Ul({}, h, {
          value: s
        }));
      }
      if (b) {
        if (!Reflect.defineProperty(this.target_, u, h))
          return !1;
      } else
        ju(this.target_, u, h);
      this.notifyPropertyAddition_(u, h.value);
    } finally {
      Uo();
    }
    return !0;
  }, r.defineObservableProperty_ = function(u, h, b, l) {
    l === void 0 && (l = !1);
    try {
      jo();
      var v = this.delete_(u);
      if (!v)
        return v;
      if (Tc(this)) {
        var s = bc(this, {
          object: this.proxy_ || this.target_,
          name: u,
          type: wl,
          newValue: h
        });
        if (!s)
          return null;
        h = s.newValue;
      }
      var c = ej(u), d = {
        configurable: Rn.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: c.get,
        set: c.set
      };
      if (l) {
        if (!Reflect.defineProperty(this.target_, u, d))
          return !1;
      } else
        ju(this.target_, u, d);
      var p = new ig(h, b, process.env.NODE_ENV !== "production" ? this.name_ + "." + u.toString() : "ObservableObject.key", !1);
      this.values_.set(u, p), this.notifyPropertyAddition_(u, p.value_);
    } finally {
      Uo();
    }
    return !0;
  }, r.defineComputedProperty_ = function(u, h, b) {
    b === void 0 && (b = !1);
    try {
      jo();
      var l = this.delete_(u);
      if (!l)
        return l;
      if (Tc(this)) {
        var v = bc(this, {
          object: this.proxy_ || this.target_,
          name: u,
          type: wl,
          newValue: void 0
        });
        if (!v)
          return null;
      }
      h.name || (h.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + u.toString() : "ObservableObject.key"), h.context = this.proxy_ || this.target_;
      var s = ej(u), c = {
        configurable: Rn.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: s.get,
        set: s.set
      };
      if (b) {
        if (!Reflect.defineProperty(this.target_, u, c))
          return !1;
      } else
        ju(this.target_, u, c);
      this.values_.set(u, new fm(h)), this.notifyPropertyAddition_(u, void 0);
    } finally {
      Uo();
    }
    return !0;
  }, r.delete_ = function(u, h) {
    if (h === void 0 && (h = !1), !Ac(this.target_, u))
      return !0;
    if (Tc(this)) {
      var b = bc(this, {
        object: this.proxy_ || this.target_,
        name: u,
        type: $9
      });
      if (!b)
        return null;
    }
    try {
      var l, v;
      jo();
      var s = $c(this), c = process.env.NODE_ENV !== "production" && ya(), d = this.values_.get(u), p = void 0;
      if (!d && (s || c)) {
        var m;
        p = (m = nb(this.target_, u)) == null ? void 0 : m.value;
      }
      if (h) {
        if (!Reflect.deleteProperty(this.target_, u))
          return !1;
      } else
        delete this.target_[u];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[u], d && (this.values_.delete(u), d instanceof ig && (p = d.value_), Dz(d)), this.keysAtom_.reportChanged(), (l = this.pendingKeys_) == null || (v = l.get(u)) == null || v.set(u in this.target_), s || c) {
        var E = {
          type: $9,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: p,
          name: u
        };
        process.env.NODE_ENV !== "production" && c && Bo(E), s && eu(this, E), process.env.NODE_ENV !== "production" && c && zo();
      }
    } finally {
      Uo();
    }
    return !0;
  }, r.observe_ = function(u, h) {
    return process.env.NODE_ENV !== "production" && h === !0 && Gn("`observe` doesn't support the fire immediately property for observable objects."), Tv(this, u);
  }, r.intercept_ = function(u) {
    return vv(this, u);
  }, r.notifyPropertyAddition_ = function(u, h) {
    var b, l, v = $c(this), s = process.env.NODE_ENV !== "production" && ya();
    if (v || s) {
      var c = v || s ? {
        type: wl,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: u,
        newValue: h
      } : null;
      process.env.NODE_ENV !== "production" && s && Bo(c), v && eu(this, c), process.env.NODE_ENV !== "production" && s && zo();
    }
    (b = this.pendingKeys_) == null || (l = b.get(u)) == null || l.set(!0), this.keysAtom_.reportChanged();
  }, r.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), Yb(this.target_);
  }, r.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, t;
}();
function Zb(t, r) {
  var a;
  if (process.env.NODE_ENV !== "production" && r && bv(t) && Gn("Options can't be provided for already observable objects."), Ac(t, Ur))
    return process.env.NODE_ENV !== "production" && !(sF(t) instanceof P2) && Gn("Cannot convert '" + lb(t) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), t;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(t) && Gn("Cannot make the designated object observable; it is not extensible");
  var u = (a = r == null ? void 0 : r.name) != null ? a : process.env.NODE_ENV !== "production" ? (nu(t) ? "ObservableObject" : t.constructor.name) + "@" + Ic() : "ObservableObject", h = new P2(t, /* @__PURE__ */ new Map(), String(u), Sle(r));
  return Vb(t, Ur, h), t;
}
var Tfe = /* @__PURE__ */ hh("ObservableObjectAdministration", P2);
function ej(t) {
  return Q9[t] || (Q9[t] = {
    get: function() {
      return this[Ur].getObservablePropValue_(t);
    },
    set: function(a) {
      return this[Ur].setObservablePropValue_(t, a);
    }
  });
}
function bv(t) {
  return Gb(t) ? Tfe(t[Ur]) : !1;
}
function tj(t, r, a) {
  var u;
  process.env.NODE_ENV !== "production" && (t.appliedAnnotations_[a] = r), (u = t.target_[qa]) == null || delete u[a];
}
function nj(t, r, a) {
  if (process.env.NODE_ENV !== "production" && !aF(r) && Gn("Cannot annotate '" + t.name_ + "." + a.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !ib(r) && Ac(t.appliedAnnotations_, a)) {
    var u = t.name_ + "." + a.toString(), h = t.appliedAnnotations_[a].annotationType_, b = r.annotationType_;
    Gn("Cannot apply '" + b + "' to '" + u + "':" + (`
The field is already annotated with '` + h + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var bfe = /* @__PURE__ */ rF(0), OR = 0, nF = function() {
};
function Afe(t, r) {
  Object.setPrototypeOf ? Object.setPrototypeOf(t.prototype, r) : t.prototype.__proto__ !== void 0 ? t.prototype.__proto__ = r : t.prototype = r;
}
Afe(nF, Array.prototype);
var aw = /* @__PURE__ */ function(t, r, a) {
  dz(u, t);
  function u(b, l, v, s) {
    var c;
    v === void 0 && (v = process.env.NODE_ENV !== "production" ? "ObservableArray@" + Ic() : "ObservableArray"), s === void 0 && (s = !1), c = t.call(this) || this;
    var d = new sw(v, l, s, !0);
    if (d.proxy_ = Y0(c), oz(Y0(c), Ur, d), b && b.length) {
      var p = Ev(!0);
      c.spliceWithArray(0, 0, b), yv(p);
    }
    return Object.defineProperty(Y0(c), "0", bfe), c;
  }
  var h = u.prototype;
  return h.concat = function() {
    this[Ur].atom_.reportObserved();
    for (var l = arguments.length, v = new Array(l), s = 0; s < l; s++)
      v[s] = arguments[s];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      v.map(function(c) {
        return Jb(c) ? c.slice() : c;
      })
    );
  }, h[a] = function() {
    var b = this, l = 0;
    return Zy({
      next: function() {
        return l < b.length ? {
          value: b[l++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, ew(u, [{
    key: "length",
    get: function() {
      return this[Ur].getArrayLength_();
    },
    set: function(l) {
      this[Ur].setArrayLength_(l);
    }
  }, {
    key: r,
    get: function() {
      return "Array";
    }
  }]), u;
}(nF, Symbol.toStringTag, Symbol.iterator);
Object.entries(ub).forEach(function(t) {
  var r = t[0], a = t[1];
  r !== "concat" && Vb(aw.prototype, r, a);
});
function rF(t) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[Ur].get_(t);
    },
    set: function(a) {
      this[Ur].set_(t, a);
    }
  };
}
function Ofe(t) {
  ju(aw.prototype, "" + t, rF(t));
}
function iF(t) {
  if (t > OR) {
    for (var r = OR; r < t + 100; r++)
      Ofe(r);
    OR = t;
  }
}
iF(1e3);
function Cfe(t, r, a) {
  return new aw(t, r, a);
}
function gm(t, r) {
  if (typeof t == "object" && t !== null) {
    if (Jb(t))
      return r !== void 0 && Gn(23), t[Ur].atom_;
    if (jm(t))
      return t.atom_;
    if (Xl(t)) {
      if (r === void 0)
        return t.keysAtom_;
      var a = t.data_.get(r) || t.hasMap_.get(r);
      return a || Gn(25, r, lb(t)), a;
    }
    if (bv(t)) {
      if (!r)
        return Gn(26);
      var u = t[Ur].values_.get(r);
      return u || Gn(27, r, lb(t)), u;
    }
    if (tw(t) || qb(t) || ob(t))
      return t;
  } else if (ks(t) && ob(t[Ur]))
    return t[Ur];
  Gn(28);
}
function sF(t, r) {
  if (t || Gn(29), tw(t) || qb(t) || ob(t) || Xl(t) || jm(t))
    return t;
  if (t[Ur])
    return t[Ur];
  Gn(24, t);
}
function lb(t, r) {
  var a;
  if (r !== void 0)
    a = gm(t, r);
  else {
    if (Kb(t))
      return t.name;
    bv(t) || Xl(t) || jm(t) ? a = sF(t) : a = gm(t);
  }
  return a.name_;
}
var rj = Fb.toString;
function ow(t, r, a) {
  return a === void 0 && (a = -1), x2(t, r, a);
}
function x2(t, r, a, u, h) {
  if (t === r)
    return t !== 0 || 1 / t === 1 / r;
  if (t == null || r == null)
    return !1;
  if (t !== t)
    return r !== r;
  var b = typeof t;
  if (b !== "function" && b !== "object" && typeof r != "object")
    return !1;
  var l = rj.call(t);
  if (l !== rj.call(r))
    return !1;
  switch (l) {
    case "[object RegExp]":
    case "[object String]":
      return "" + t == "" + r;
    case "[object Number]":
      return +t != +t ? +r != +r : +t == 0 ? 1 / +t === 1 / r : +t == +r;
    case "[object Date]":
    case "[object Boolean]":
      return +t == +r;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(t) === Symbol.valueOf.call(r);
    case "[object Map]":
    case "[object Set]":
      a >= 0 && a++;
      break;
  }
  t = ij(t), r = ij(r);
  var v = l === "[object Array]";
  if (!v) {
    if (typeof t != "object" || typeof r != "object")
      return !1;
    var s = t.constructor, c = r.constructor;
    if (s !== c && !(ks(s) && s instanceof s && ks(c) && c instanceof c) && "constructor" in t && "constructor" in r)
      return !1;
  }
  if (a === 0)
    return !1;
  a < 0 && (a = -1), u = u || [], h = h || [];
  for (var d = u.length; d--; )
    if (u[d] === t)
      return h[d] === r;
  if (u.push(t), h.push(r), v) {
    if (d = t.length, d !== r.length)
      return !1;
    for (; d--; )
      if (!x2(t[d], r[d], a - 1, u, h))
        return !1;
  } else {
    var p = Object.keys(t), m;
    if (d = p.length, Object.keys(r).length !== d)
      return !1;
    for (; d--; )
      if (m = p[d], !(Ac(r, m) && x2(t[m], r[m], a - 1, u, h)))
        return !1;
  }
  return u.pop(), h.pop(), !0;
}
function ij(t) {
  return Jb(t) ? t.slice() : Lm(t) || Xl(t) || fv(t) || jm(t) ? Array.from(t.entries()) : t;
}
function Zy(t) {
  return t[Symbol.iterator] = Sfe, t;
}
function Sfe() {
  return this;
}
function aF(t) {
  return (
    // Can be function
    t instanceof Object && typeof t.annotationType_ == "string" && ks(t.make_) && ks(t.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(t) {
  var r = ZN();
  typeof r[t] > "u" && Gn("MobX requires global '" + t + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: Yle,
  extras: {
    getDebugName: lb
  },
  $mobx: Ur
});
var oF = { exports: {} };
(function(t, r) {
  (function(a, u) {
    t.exports = u();
  })(rn, function() {
    return function() {
      var a = { 4537: function(l) {
        l.exports = function(v, s) {
          for (var c = new Array(arguments.length - 1), d = 0, p = 2, m = !0; p < arguments.length; ) c[d++] = arguments[p++];
          return new Promise(function(E, y) {
            c[d] = function(g) {
              if (m) if (m = !1, g) y(g);
              else {
                for (var C = new Array(arguments.length - 1), O = 0; O < C.length; ) C[O++] = arguments[O];
                E.apply(null, C);
              }
            };
            try {
              v.apply(s || null, c);
            } catch (g) {
              m && (m = !1, y(g));
            }
          });
        };
      }, 7419: function(l, v) {
        var s = v;
        s.length = function(E) {
          var y = E.length;
          if (!y) return 0;
          for (var g = 0; --y % 4 > 1 && E.charAt(y) === "="; ) ++g;
          return Math.ceil(3 * E.length) / 4 - g;
        };
        for (var c = new Array(64), d = new Array(123), p = 0; p < 64; ) d[c[p] = p < 26 ? p + 65 : p < 52 ? p + 71 : p < 62 ? p - 4 : p - 59 | 43] = p++;
        s.encode = function(E, y, g) {
          for (var C, O = null, N = [], w = 0, _ = 0; y < g; ) {
            var I = E[y++];
            switch (_) {
              case 0:
                N[w++] = c[I >> 2], C = (3 & I) << 4, _ = 1;
                break;
              case 1:
                N[w++] = c[C | I >> 4], C = (15 & I) << 2, _ = 2;
                break;
              case 2:
                N[w++] = c[C | I >> 6], N[w++] = c[63 & I], _ = 0;
            }
            w > 8191 && ((O || (O = [])).push(String.fromCharCode.apply(String, N)), w = 0);
          }
          return _ && (N[w++] = c[C], N[w++] = 61, _ === 1 && (N[w++] = 61)), O ? (w && O.push(String.fromCharCode.apply(String, N.slice(0, w))), O.join("")) : String.fromCharCode.apply(String, N.slice(0, w));
        };
        var m = "invalid encoding";
        s.decode = function(E, y, g) {
          for (var C, O = g, N = 0, w = 0; w < E.length; ) {
            var _ = E.charCodeAt(w++);
            if (_ === 61 && N > 1) break;
            if ((_ = d[_]) === void 0) throw Error(m);
            switch (N) {
              case 0:
                C = _, N = 1;
                break;
              case 1:
                y[g++] = C << 2 | (48 & _) >> 4, C = _, N = 2;
                break;
              case 2:
                y[g++] = (15 & C) << 4 | (60 & _) >> 2, C = _, N = 3;
                break;
              case 3:
                y[g++] = (3 & C) << 6 | _, N = 0;
            }
          }
          if (N === 1) throw Error(m);
          return g - O;
        }, s.test = function(E) {
          return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(E);
        };
      }, 5124: function(l) {
        function v(s, c) {
          typeof s == "string" && (c = s, s = void 0);
          var d = [];
          function p(E) {
            if (typeof E != "string") {
              var y = m();
              if (v.verbose && console.log("codegen: " + y), y = "return " + y, E) {
                for (var g = Object.keys(E), C = new Array(g.length + 1), O = new Array(g.length), N = 0; N < g.length; ) C[N] = g[N], O[N] = E[g[N++]];
                return C[N] = y, Function.apply(null, C).apply(null, O);
              }
              return Function(y)();
            }
            for (var w = new Array(arguments.length - 1), _ = 0; _ < w.length; ) w[_] = arguments[++_];
            if (_ = 0, E = E.replace(/%([%dfijs])/g, function(I, k) {
              var H = w[_++];
              switch (k) {
                case "d":
                case "f":
                  return String(Number(H));
                case "i":
                  return String(Math.floor(H));
                case "j":
                  return JSON.stringify(H);
                case "s":
                  return String(H);
              }
              return "%";
            }), _ !== w.length) throw Error("parameter count mismatch");
            return d.push(E), p;
          }
          function m(E) {
            return "function " + (E || c || "") + "(" + (s && s.join(",") || "") + `){
  ` + d.join(`
  `) + `
}`;
          }
          return p.toString = m, p;
        }
        l.exports = v, v.verbose = !1;
      }, 9211: function(l) {
        function v() {
          this._listeners = {};
        }
        l.exports = v, v.prototype.on = function(s, c, d) {
          return (this._listeners[s] || (this._listeners[s] = [])).push({ fn: c, ctx: d || this }), this;
        }, v.prototype.off = function(s, c) {
          if (s === void 0) this._listeners = {};
          else if (c === void 0) this._listeners[s] = [];
          else for (var d = this._listeners[s], p = 0; p < d.length; ) d[p].fn === c ? d.splice(p, 1) : ++p;
          return this;
        }, v.prototype.emit = function(s) {
          var c = this._listeners[s];
          if (c) {
            for (var d = [], p = 1; p < arguments.length; ) d.push(arguments[p++]);
            for (p = 0; p < c.length; ) c[p].fn.apply(c[p++].ctx, d);
          }
          return this;
        };
      }, 9054: function(l, v, s) {
        l.exports = p;
        var c = s(4537), d = s(7199)("fs");
        function p(m, E, y) {
          return typeof E == "function" ? (y = E, E = {}) : E || (E = {}), y ? !E.xhr && d && d.readFile ? d.readFile(m, function(g, C) {
            return g && typeof XMLHttpRequest < "u" ? p.xhr(m, E, y) : g ? y(g) : y(null, E.binary ? C : C.toString("utf8"));
          }) : p.xhr(m, E, y) : c(p, this, m, E);
        }
        p.xhr = function(m, E, y) {
          var g = new XMLHttpRequest();
          g.onreadystatechange = function() {
            if (g.readyState === 4) {
              if (g.status !== 0 && g.status !== 200) return y(Error("status " + g.status));
              if (E.binary) {
                var C = g.response;
                if (!C) {
                  C = [];
                  for (var O = 0; O < g.responseText.length; ++O) C.push(255 & g.responseText.charCodeAt(O));
                }
                return y(null, typeof Uint8Array < "u" ? new Uint8Array(C) : C);
              }
              return y(null, g.responseText);
            }
          }, E.binary && ("overrideMimeType" in g && g.overrideMimeType("text/plain; charset=x-user-defined"), g.responseType = "arraybuffer"), g.open("GET", m), g.send();
        };
      }, 945: function(l) {
        function v(m) {
          return typeof Float32Array < "u" ? function() {
            var E = new Float32Array([-0]), y = new Uint8Array(E.buffer), g = y[3] === 128;
            function C(_, I, k) {
              E[0] = _, I[k] = y[0], I[k + 1] = y[1], I[k + 2] = y[2], I[k + 3] = y[3];
            }
            function O(_, I, k) {
              E[0] = _, I[k] = y[3], I[k + 1] = y[2], I[k + 2] = y[1], I[k + 3] = y[0];
            }
            function N(_, I) {
              return y[0] = _[I], y[1] = _[I + 1], y[2] = _[I + 2], y[3] = _[I + 3], E[0];
            }
            function w(_, I) {
              return y[3] = _[I], y[2] = _[I + 1], y[1] = _[I + 2], y[0] = _[I + 3], E[0];
            }
            m.writeFloatLE = g ? C : O, m.writeFloatBE = g ? O : C, m.readFloatLE = g ? N : w, m.readFloatBE = g ? w : N;
          }() : function() {
            function E(g, C, O, N) {
              var w = C < 0 ? 1 : 0;
              if (w && (C = -C), C === 0) g(1 / C > 0 ? 0 : 2147483648, O, N);
              else if (isNaN(C)) g(2143289344, O, N);
              else if (C > 34028234663852886e22) g((w << 31 | 2139095040) >>> 0, O, N);
              else if (C < 11754943508222875e-54) g((w << 31 | Math.round(C / 1401298464324817e-60)) >>> 0, O, N);
              else {
                var _ = Math.floor(Math.log(C) / Math.LN2);
                g((w << 31 | _ + 127 << 23 | 8388607 & Math.round(C * Math.pow(2, -_) * 8388608)) >>> 0, O, N);
              }
            }
            function y(g, C, O) {
              var N = g(C, O), w = 2 * (N >> 31) + 1, _ = N >>> 23 & 255, I = 8388607 & N;
              return _ === 255 ? I ? NaN : w * (1 / 0) : _ === 0 ? 1401298464324817e-60 * w * I : w * Math.pow(2, _ - 150) * (I + 8388608);
            }
            m.writeFloatLE = E.bind(null, s), m.writeFloatBE = E.bind(null, c), m.readFloatLE = y.bind(null, d), m.readFloatBE = y.bind(null, p);
          }(), typeof Float64Array < "u" ? function() {
            var E = new Float64Array([-0]), y = new Uint8Array(E.buffer), g = y[7] === 128;
            function C(_, I, k) {
              E[0] = _, I[k] = y[0], I[k + 1] = y[1], I[k + 2] = y[2], I[k + 3] = y[3], I[k + 4] = y[4], I[k + 5] = y[5], I[k + 6] = y[6], I[k + 7] = y[7];
            }
            function O(_, I, k) {
              E[0] = _, I[k] = y[7], I[k + 1] = y[6], I[k + 2] = y[5], I[k + 3] = y[4], I[k + 4] = y[3], I[k + 5] = y[2], I[k + 6] = y[1], I[k + 7] = y[0];
            }
            function N(_, I) {
              return y[0] = _[I], y[1] = _[I + 1], y[2] = _[I + 2], y[3] = _[I + 3], y[4] = _[I + 4], y[5] = _[I + 5], y[6] = _[I + 6], y[7] = _[I + 7], E[0];
            }
            function w(_, I) {
              return y[7] = _[I], y[6] = _[I + 1], y[5] = _[I + 2], y[4] = _[I + 3], y[3] = _[I + 4], y[2] = _[I + 5], y[1] = _[I + 6], y[0] = _[I + 7], E[0];
            }
            m.writeDoubleLE = g ? C : O, m.writeDoubleBE = g ? O : C, m.readDoubleLE = g ? N : w, m.readDoubleBE = g ? w : N;
          }() : function() {
            function E(g, C, O, N, w, _) {
              var I = N < 0 ? 1 : 0;
              if (I && (N = -N), N === 0) g(0, w, _ + C), g(1 / N > 0 ? 0 : 2147483648, w, _ + O);
              else if (isNaN(N)) g(0, w, _ + C), g(2146959360, w, _ + O);
              else if (N > 17976931348623157e292) g(0, w, _ + C), g((I << 31 | 2146435072) >>> 0, w, _ + O);
              else {
                var k;
                if (N < 22250738585072014e-324) g((k = N / 5e-324) >>> 0, w, _ + C), g((I << 31 | k / 4294967296) >>> 0, w, _ + O);
                else {
                  var H = Math.floor(Math.log(N) / Math.LN2);
                  H === 1024 && (H = 1023), g(4503599627370496 * (k = N * Math.pow(2, -H)) >>> 0, w, _ + C), g((I << 31 | H + 1023 << 20 | 1048576 * k & 1048575) >>> 0, w, _ + O);
                }
              }
            }
            function y(g, C, O, N, w) {
              var _ = g(N, w + C), I = g(N, w + O), k = 2 * (I >> 31) + 1, H = I >>> 20 & 2047, S = 4294967296 * (1048575 & I) + _;
              return H === 2047 ? S ? NaN : k * (1 / 0) : H === 0 ? 5e-324 * k * S : k * Math.pow(2, H - 1075) * (S + 4503599627370496);
            }
            m.writeDoubleLE = E.bind(null, s, 0, 4), m.writeDoubleBE = E.bind(null, c, 4, 0), m.readDoubleLE = y.bind(null, d, 0, 4), m.readDoubleBE = y.bind(null, p, 4, 0);
          }(), m;
        }
        function s(m, E, y) {
          E[y] = 255 & m, E[y + 1] = m >>> 8 & 255, E[y + 2] = m >>> 16 & 255, E[y + 3] = m >>> 24;
        }
        function c(m, E, y) {
          E[y] = m >>> 24, E[y + 1] = m >>> 16 & 255, E[y + 2] = m >>> 8 & 255, E[y + 3] = 255 & m;
        }
        function d(m, E) {
          return (m[E] | m[E + 1] << 8 | m[E + 2] << 16 | m[E + 3] << 24) >>> 0;
        }
        function p(m, E) {
          return (m[E] << 24 | m[E + 1] << 16 | m[E + 2] << 8 | m[E + 3]) >>> 0;
        }
        l.exports = v(v);
      }, 7199: function(l, v, s) {
        l.exports = function(c) {
          try {
            var d = s(822)(c);
            if (d && (d.length || Object.keys(d).length)) return d;
          } catch {
          }
          return null;
        };
      }, 822: function(l) {
        function v(s) {
          var c = new Error("Cannot find module '" + s + "'");
          throw c.code = "MODULE_NOT_FOUND", c;
        }
        v.keys = function() {
          return [];
        }, v.resolve = v, v.id = 822, l.exports = v;
      }, 8626: function(l, v) {
        var s = v, c = s.isAbsolute = function(p) {
          return /^(?:\/|\w+:)/.test(p);
        }, d = s.normalize = function(p) {
          var m = (p = p.replace(/\\/g, "/").replace(/\/{2,}/g, "/")).split("/"), E = c(p), y = "";
          E && (y = m.shift() + "/");
          for (var g = 0; g < m.length; ) m[g] === ".." ? g > 0 && m[g - 1] !== ".." ? m.splice(--g, 2) : E ? m.splice(g, 1) : ++g : m[g] === "." ? m.splice(g, 1) : ++g;
          return y + m.join("/");
        };
        s.resolve = function(p, m, E) {
          return E || (m = d(m)), c(m) ? m : (E || (p = d(p)), (p = p.replace(/(?:\/|^)[^/]+$/, "")).length ? d(p + "/" + m) : m);
        };
      }, 6662: function(l) {
        l.exports = function(v, s, c) {
          var d = c || 8192, p = d >>> 1, m = null, E = d;
          return function(y) {
            if (y < 1 || y > p) return v(y);
            E + y > d && (m = v(d), E = 0);
            var g = s.call(m, E, E += y);
            return 7 & E && (E = 1 + (7 | E)), g;
          };
        };
      }, 4997: function(l, v) {
        var s = v;
        s.length = function(c) {
          for (var d = 0, p = 0, m = 0; m < c.length; ++m) (p = c.charCodeAt(m)) < 128 ? d += 1 : p < 2048 ? d += 2 : (64512 & p) == 55296 && (64512 & c.charCodeAt(m + 1)) == 56320 ? (++m, d += 4) : d += 3;
          return d;
        }, s.read = function(c, d, p) {
          if (p - d < 1) return "";
          for (var m, E = null, y = [], g = 0; d < p; ) (m = c[d++]) < 128 ? y[g++] = m : m > 191 && m < 224 ? y[g++] = (31 & m) << 6 | 63 & c[d++] : m > 239 && m < 365 ? (m = ((7 & m) << 18 | (63 & c[d++]) << 12 | (63 & c[d++]) << 6 | 63 & c[d++]) - 65536, y[g++] = 55296 + (m >> 10), y[g++] = 56320 + (1023 & m)) : y[g++] = (15 & m) << 12 | (63 & c[d++]) << 6 | 63 & c[d++], g > 8191 && ((E || (E = [])).push(String.fromCharCode.apply(String, y)), g = 0);
          return E ? (g && E.push(String.fromCharCode.apply(String, y.slice(0, g))), E.join("")) : String.fromCharCode.apply(String, y.slice(0, g));
        }, s.write = function(c, d, p) {
          for (var m, E, y = p, g = 0; g < c.length; ++g) (m = c.charCodeAt(g)) < 128 ? d[p++] = m : m < 2048 ? (d[p++] = m >> 6 | 192, d[p++] = 63 & m | 128) : (64512 & m) == 55296 && (64512 & (E = c.charCodeAt(g + 1))) == 56320 ? (m = 65536 + ((1023 & m) << 10) + (1023 & E), ++g, d[p++] = m >> 18 | 240, d[p++] = m >> 12 & 63 | 128, d[p++] = m >> 6 & 63 | 128, d[p++] = 63 & m | 128) : (d[p++] = m >> 12 | 224, d[p++] = m >> 6 & 63 | 128, d[p++] = 63 & m | 128);
          return p - y;
        };
      }, 4188: function(l, v, s) {
        var c, d, p;
        (function(m) {
          if (v != null && typeof v.nodeType != "number") l.exports = m();
          else if (s.amdO != null) d = [], (p = typeof (c = m) == "function" ? c.apply(v, d) : c) === void 0 || (l.exports = p);
          else {
            var E = m(), y = typeof self < "u" ? self : $.global;
            typeof y.btoa != "function" && (y.btoa = E.btoa), typeof y.atob != "function" && (y.atob = E.atob);
          }
        })(function() {
          var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          function E(y) {
            this.message = y;
          }
          return E.prototype = new Error(), E.prototype.name = "InvalidCharacterError", { btoa: function(y) {
            for (var g, C, O = String(y), N = 0, w = m, _ = ""; O.charAt(0 | N) || (w = "=", N % 1); _ += w.charAt(63 & g >> 8 - N % 1 * 8)) {
              if ((C = O.charCodeAt(N += 0.75)) > 255) throw new E("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
              g = g << 8 | C;
            }
            return _;
          }, atob: function(y) {
            var g = String(y).replace(/[=]+$/, "");
            if (g.length % 4 == 1) throw new E("'atob' failed: The string to be decoded is not correctly encoded.");
            for (var C, O, N = 0, w = 0, _ = ""; O = g.charAt(w++); ~O && (C = N % 4 ? 64 * C + O : O, N++ % 4) ? _ += String.fromCharCode(255 & C >> (-2 * N & 6)) : 0) O = m.indexOf(O);
            return _;
          } };
        });
      }, 9667: function(l, v, s) {
        s.r(v), s.d(v, { addUsersToChatRoom: function() {
          return S;
        }, addUsersToChatRoomAllowlist: function() {
          return at;
        }, addUsersToChatRoomWhitelist: function() {
          return Ze;
        }, blockChatRoomMember: function() {
          return Ce;
        }, blockChatRoomMembers: function() {
          return Le;
        }, chatRoomBlockMulti: function() {
          return _e;
        }, chatRoomBlockSingle: function() {
          return pe;
        }, createChatRoom: function() {
          return C;
        }, deleteChatRoomSharedFile: function() {
          return Et;
        }, destroyChatRoom: function() {
          return O;
        }, disableSendChatRoomMsg: function() {
          return Be;
        }, enableSendChatRoomMsg: function() {
          return Ke;
        }, fetchChatRoomAnnouncement: function() {
          return Ot;
        }, fetchChatRoomSharedFileList: function() {
          return ut;
        }, getChatRoomAdmin: function() {
          return U;
        }, getChatRoomAllowlist: function() {
          return it;
        }, getChatRoomAttributes: function() {
          return Ft;
        }, getChatRoomBlacklist: function() {
          return be;
        }, getChatRoomBlacklistNew: function() {
          return xe;
        }, getChatRoomBlocklist: function() {
          return $e;
        }, getChatRoomDetails: function() {
          return N;
        }, getChatRoomMuteList: function() {
          return de;
        }, getChatRoomMuted: function() {
          return ee;
        }, getChatRoomMutelist: function() {
          return he;
        }, getChatRoomSharedFilelist: function() {
          return St;
        }, getChatRoomWhitelist: function() {
          return gt;
        }, getChatRooms: function() {
          return g;
        }, getJoinedChatRooms: function() {
          return le;
        }, isChatRoomWhiteUser: function() {
          return Tt;
        }, isInChatRoomAllowlist: function() {
          return Ut;
        }, isInChatRoomMutelist: function() {
          return st;
        }, joinChatRoom: function() {
          return B;
        }, leaveChatRoom: function() {
          return F;
        }, listChatRoomMember: function() {
          return j;
        }, listChatRoomMembers: function() {
          return G;
        }, modifyChatRoom: function() {
          return w;
        }, muteChatRoomMember: function() {
          return J;
        }, quitChatRoom: function() {
          return D;
        }, removeChatRoomAdmin: function() {
          return V;
        }, removeChatRoomAllowlistMember: function() {
          return Rt;
        }, removeChatRoomAttribute: function() {
          return Ne;
        }, removeChatRoomAttributes: function() {
          return ze;
        }, removeChatRoomBlockMulti: function() {
          return Oe;
        }, removeChatRoomBlockSingle: function() {
          return Te;
        }, removeChatRoomMember: function() {
          return I;
        }, removeChatRoomMembers: function() {
          return H;
        }, removeChatRoomWhitelistMember: function() {
          return It;
        }, removeMultiChatRoomMember: function() {
          return k;
        }, removeMuteChatRoomMember: function() {
          return ue;
        }, removeSingleChatRoomMember: function() {
          return _;
        }, rmUsersFromChatRoomWhitelist: function() {
          return pt;
        }, setChatRoomAdmin: function() {
          return M;
        }, setChatRoomAttribute: function() {
          return zt;
        }, setChatRoomAttributes: function() {
          return Ht;
        }, unblockChatRoomMember: function() {
          return K;
        }, unblockChatRoomMembers: function() {
          return Pe;
        }, unmuteChatRoomMember: function() {
          return se;
        }, updateChatRoomAnnouncement: function() {
          return kt;
        }, uploadChatRoomSharedFile: function() {
          return wt;
        } }), s(1539), s(8674), s(8309), s(2526), s(1817), s(2222), s(9753), s(9600), s(1249), s(4916), s(3123), s(2165), s(6992), s(8783), s(3948);
        var c = s(5531), d = s(4024), p = s(3246), m = s(7360), E = s(1595);
        function y(X) {
          return y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(re) {
            return typeof re;
          } : function(re) {
            return re && typeof Symbol == "function" && re.constructor === Symbol && re !== Symbol.prototype ? "symbol" : typeof re;
          }, y(X);
        }
        function g(X) {
          var re = this;
          if (typeof X.pagenum != "number" || typeof X.pagesize != "number") throw Error("Invalid parameter");
          var Me = p.XZ.call(this).error;
          if (Me) return Promise.reject(Me);
          var Se = { pagenum: X.pagenum || 1, pagesize: X.pagesize || 20 }, ke = this.context, Ge = ke.orgName, nt = ke.appName, rt = ke.accessToken, dt = { url: this.apiUrl + "/" + Ge + "/" + nt + "/chatrooms", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + rt }, data: Se, success: function(lt) {
            typeof X.success == "function" && X.success(lt);
          }, error: function(lt) {
            lt.error && lt.error_description && re.onError && re.onError({ type: c.E.WEBIM_CONNCTION_LOAD_CHATROOM_ERROR, message: lt.error_description, data: lt }), typeof X.error == "function" && X.error(lt);
          } };
          return m.kg.debug("Call getChatRooms", X), d.hj.call(this, dt, E.fI.GET_CHATROOM_LIST);
        }
        function C(X) {
          if (typeof X.name != "string") throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = { name: X.name, description: X.description, maxusers: X.maxusers, owner: this.user, members: X.members }, Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms?resource=").concat(rt.clientResource), dataType: "json", type: "POST", data: JSON.stringify(Me), headers: { Authorization: "Bearer " + (X.token || nt), "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call createChatRoom", X), d.hj.call(this, dt, E.fI.CREATE_CHATROOM);
        }
        function O(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(X.chatRoomId, "?resource=").concat(nt.clientResource, "&version=v3"), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + (X.token || Ge) }, success: X.success, error: X.error };
          return m.kg.debug("Call destroyChatRoom", X), d.hj.call(this, rt, E.fI.DESTROY_CHATROOM);
        }
        function N(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = { url: this.apiUrl + "/" + Se + "/" + ke + "/chatrooms/" + X.chatRoomId, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call getChatRoomDetails", X), d.hj.call(this, nt, E.fI.GET_CHATROOM_DETAIL);
        }
        function w(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { groupname: X.chatRoomName, description: X.description, maxusers: X.maxusers }, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "?resource=").concat(nt.clientResource), type: "PUT", data: JSON.stringify(dt), dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call modifyChatRoom", X), d.hj.call(this, lt, E.fI.MODIFY_CHATROOM);
        }
        function _(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "" || typeof X.username != "string") throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = X.username, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/users/").concat(dt, "?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call removeChatRoomMember", X), d.hj.call(this, lt, E.fI.REMOVE_CHATROOM_MEMBER);
        }
        var I = _;
        function k(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "" || !Array.isArray(X.users)) throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = X.chatRoomId, Se = X.users.join(","), ke = this.context, Ge = ke.orgName, nt = ke.appName, rt = ke.accessToken, dt = ke.jid, lt = { url: "".concat(this.apiUrl, "/").concat(Ge, "/").concat(nt, "/chatrooms/").concat(Me, "/users/").concat(Se, "?resource=").concat(dt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + rt, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call removeChatRoomMembers", X), d.hj.call(this, lt, E.fI.MULTI_REMOVE_CHATROOM_MEMBER);
        }
        var H = k;
        function S(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "" || !Array.isArray(X.users)) throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = X.chatRoomId, Se = { usernames: X.users }, ke = this.context, Ge = ke.orgName, nt = ke.appName, rt = ke.accessToken, dt = ke.jid, lt = { url: "".concat(this.apiUrl, "/").concat(Ge, "/").concat(nt, "/chatrooms/").concat(Me, "/users?resource=").concat(dt.clientResource), type: "POST", data: JSON.stringify(Se), dataType: "json", headers: { Authorization: "Bearer " + rt, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call addUsersToChatRoom", X), d.hj.call(this, lt, E.fI.ADD_USERS_TO_CHATROOM);
        }
        function B(X) {
          var re = X.roomId, Me = X.message, Se = Me === void 0 ? "" : Me, ke = X.ext, Ge = ke === void 0 ? "" : ke, nt = X.leaveOtherRooms, rt = nt !== void 0 && nt, dt = X.success, lt = X.error;
          if (typeof re != "string" || re === "") throw Error("Invalid parameter roomId");
          if (typeof Ge != "string") throw Error("Invalid parameter ext");
          if (typeof rt != "boolean") throw Error("Invalid parameter leaveOtherRooms");
          var Ct = p.XZ.call(this).error;
          return Ct ? Promise.reject(Ct) : (m.kg.debug("Call joinChatRoom", X), this.logOut ? Promise.reject({ type: c.E.WEBIM_CONNECTION_CLOSED, message: "not login" }) : this.mSync.handleChatRoom({ roomId: re, ext: Ge, leaveOtherRooms: rt, message: Se, success: dt, errorCb: lt }, "join"));
        }
        function D(X) {
          if (typeof X.roomId != "string" || X.roomId === "") throw Error("Invalid parameter");
          var re = p.XZ.call(this).error;
          return re ? Promise.reject(re) : (m.kg.debug("Call leaveChatRoom", X), this.logOut ? Promise.reject({ type: c.E.WEBIM_CONNECTION_CLOSED, message: "not login" }) : this.mSync.handleChatRoom(X, "leave"));
        }
        var F = D;
        function j(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (isNaN(X.pageNum) || X.pageNum <= 0) throw Error('The parameter "pageNum" should be a positive number');
          if (isNaN(X.pageSize) || X.pageSize <= 0) throw Error('The parameter "pageSize" should be a positive number');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = { pagenum: X.pageNum, pagesize: X.pageSize }, Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + X.chatRoomId + "/users", dataType: "json", type: "GET", data: Me, headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call listChatRoomMembers", X), d.hj.call(this, rt, E.fI.LIST_CHATROOM_MEMBERS);
        }
        var G = j;
        function U(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.chatRoomId, rt = { url: this.apiUrl + "/" + Se + "/" + ke + "/chatrooms/" + nt + "/admin", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call getChatRoomAdmin", X), d.hj.call(this, rt, E.fI.GET_CHATROOM_ADMIN);
        }
        function M(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.username != "string" || X.username === "") throw Error('Invalid parameter: "username"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { newadmin: X.username }, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/admin?resource=").concat(nt.clientResource), type: "POST", dataType: "json", data: JSON.stringify(dt), headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call setChatRoomAdmin", X), d.hj.call(this, lt, E.fI.SET_CHATROOM_ADMIN);
        }
        function V(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.username != "string" || X.username === "") throw Error('Invalid parameter: "username"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = X.username, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/admin/").concat(dt, "?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call removeChatRoomAdmin", X), d.hj.call(this, lt, E.fI.REMOVE_CHATROOM_ADMIN);
        }
        function J(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof X.username != "string" || X.username === "") throw Error('Invalid parameter: "username"');
          if (typeof X.muteDuration != "number") throw Error('Invalid parameter: "muteDuration"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { usernames: [X.username], mute_duration: X.muteDuration }, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/mute?resource=").concat(nt.clientResource), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, data: JSON.stringify(dt), success: X.success, error: X.error };
          return m.kg.debug("Call muteChatRoomMember", X), d.hj.call(this, lt, E.fI.MUTE_CHATROOM_MEMBER);
        }
        function ue(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.username != "string" || X.username === "") throw Error('Invalid parameter: "username"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = X.username, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/mute/").concat(dt, "?resource=").concat(nt.clientResource), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call unmuteChatRoomMember", X), d.hj.call(this, lt, E.fI.REMOVE_MUTE_CHATROOM_MEMBER);
        }
        var se = ue;
        function ee(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.chatRoomId, rt = { url: this.apiUrl + "/" + Se + "/" + ke + "/chatrooms/" + nt + "/mute", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call getChatRoomMutelist", X), d.hj.call(this, rt, E.fI.GET_MUTE_CHATROOM_MEMBERS);
        }
        var de = ee, he = ee;
        function pe(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.username != "string" || X.username === "") throw Error('Invalid parameter: "username"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = X.username, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/blocks/users/").concat(dt, "?resource=").concat(nt.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call blockChatRoomMember", X), d.hj.call(this, lt, E.fI.SET_CHATROOM_MEMBER_TO_BLACK);
        }
        var Ce = pe;
        function _e(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!Array.isArray(X.usernames)) throw Error('Invalid parameter: "usernames"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { usernames: X.usernames }, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/blocks/users?resource=").concat(nt.clientResource), data: JSON.stringify(dt), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Chat blockChatRoomMembers:", lt), d.hj.call(this, lt, E.fI.MULTI_SET_CHATROOM_MEMBER_TO_BLACK);
        }
        var Le = _e;
        function Te(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.username != "string" || X.username === "") throw Error('Invalid parameter: "username"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = X.username, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/blocks/users/").concat(dt, "?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call unblockChatRoomMember", X), d.hj.call(this, lt, E.fI.REMOVE_CHATROOM_MEMBER_BLACK);
        }
        var K = Te;
        function Oe(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!Array.isArray(X.usernames)) throw Error('Invalid parameter: "usernames"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = X.usernames.join(","), lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/blocks/users/").concat(dt, "?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call unblockChatRoomMembers", X), d.hj.call(this, lt, E.fI.MULTI_REMOVE_CHATROOM_MEMBER_BLACK);
        }
        var Pe = Oe;
        function xe(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.chatRoomId, rt = { url: this.apiUrl + "/" + Se + "/" + ke + "/chatrooms/" + nt + "/blocks/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call getChatRoomBlocklist", X), d.hj.call(this, rt, E.fI.GET_CHATROOM_BLOCK_MEMBERS);
        }
        var be = xe, $e = xe;
        function Be(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/ban?resource=").concat(nt.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call disableSendChatRoomMsg", X), d.hj.call(this, dt, E.fI.DISABLED_CHATROOM_SEND_MSG);
        }
        function Ke(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/ban?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call enableSendChatRoomMsg", X), d.hj.call(this, dt, E.fI.ENABLE_CHATROOM_SEND_MSG);
        }
        function Ze(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!Array.isArray(X.users)) throw Error('Invalid parameter: "users"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { usernames: X.users }, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/white/users?resource=").concat(nt.clientResource), type: "POST", data: JSON.stringify(dt), dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call addUsersToChatRoomWhitelist", X), d.hj.call(this, lt, E.fI.ADD_USERS_TO_CHATROOM);
        }
        var at = Ze;
        function pt(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.userName != "string" || X.userName === "") throw Error('Invalid parameter: "userName"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.chatRoomId, dt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/white/users/").concat(X.userName, "?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call removeChatRoomAllowlistMember", X), d.hj.call(this, dt, E.fI.REMOVE_CHATROOM_WHITE_USERS);
        }
        var It = pt, Rt = pt;
        function gt(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.chatRoomId, rt = { url: this.apiUrl + "/" + Se + "/" + ke + "/chatrooms/" + nt + "/white/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call getChatRoomAllowlist", X), d.hj.call(this, rt, E.fI.GET_CHATROOM_WHITE_USERS);
        }
        var it = gt;
        function Tt(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof X.userName != "string" || X.userName === "") throw Error('Invalid parameter: "userName"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.chatRoomId, rt = { url: this.apiUrl + "/" + Se + "/" + ke + "/chatrooms/" + nt + "/white/users/" + X.userName, type: "GET", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call isInChatRoomAllowlist", X), d.hj.call(this, rt, E.fI.CHECK_CHATROOM_WHITE_USER);
        }
        var Ut = Tt;
        function st(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.userId, rt = { url: this.apiUrl + "/" + Se + "/" + ke + "/sdk/chatrooms/" + X.chatRoomId + "/mute/" + nt, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + Ge } };
          return m.kg.debug("Call isInChatRoomMutelist", X), d.hj.call(this, rt).then(function(dt) {
            return { type: dt.type, data: dt.data };
          });
        }
        function Ot(X) {
          if (typeof X.roomId != "string" || X.roomId === "") throw Error('Invalid parameter: "roomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.roomId, rt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(nt, "/announcement"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call fetchChatRoomAnnouncement", X), d.hj.call(this, rt, E.fI.GET_CHATROOM_ANN);
        }
        function kt(X) {
          if (typeof X.roomId != "string" || X.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (typeof X.announcement != "string") throw Error('Invalid parameter: "announcement"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.roomId, dt = { announcement: X.announcement }, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/announcement?resource=").concat(nt.clientResource), type: "POST", dataType: "json", data: JSON.stringify(dt), headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call updateChatRoomAnnouncement:", X), d.hj.call(this, lt, E.fI.UPDATE_CHATROOM_ANN);
        }
        function wt(X) {
          var re;
          if (typeof X.roomId != "string" || X.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (y(X.file) !== "object") throw Error('Invalid parameter: "file"');
          var Me = p.XZ.call(this).error;
          if (Me) return (re = X.onFileUploadError) === null || re === void 0 ? void 0 : re.call(X, Me);
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = X.roomId;
          d.cT.call(this, { uploadUrl: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/share_files?resource=").concat(rt.clientResource), onFileUploadProgress: X.onFileUploadProgress, onFileUploadComplete: X.onFileUploadComplete, onFileUploadError: X.onFileUploadError, onFileUploadCanceled: X.onFileUploadCanceled, accessToken: nt, apiUrl: this.apiUrl, file: X.file, appKey: this.context.appKey }, E.fI.UPLOAD_CHATROOM_FILE), m.kg.debug("Call uploadChatRoomSharedFile", X);
        }
        function Et(X) {
          if (typeof X.roomId != "string" || X.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (typeof X.fileId != "string" || X.fileId === "") throw Error('Invalid parameter: "fileId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = X.roomId, dt = X.fileId, lt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/share_files/").concat(dt, "?resource=").concat(nt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call deleteChatRoomSharedFile", X), d.hj.call(this, lt, E.fI.DELETE_CHATROOM_FILE);
        }
        function ut(X) {
          if (typeof X.roomId != "string" || X.roomId === "") throw Error('Invalid parameter: "roomId"');
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = X.roomId, rt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(nt, "/share_files"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json", accept: "application/json" }, success: X.success, error: X.error };
          return m.kg.debug("Call fetchChatRoomSharedFileList", X), d.hj.call(this, rt, E.fI.GET_CHATROOM_FILES);
        }
        var St = ut;
        function Ft(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + X.chatRoomId);
          if (X.attributeKeys && !Array.isArray(X.attributeKeys)) throw Error('"Invalid parameter attributeKeys": ' + X.attributeKeys);
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = (Me.jid, X.chatRoomId), rt = { keys: X.attributeKeys }, dt = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/metadata/chatroom/").concat(nt), type: "POST", dataType: "json", data: JSON.stringify(rt), headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" } };
          return m.kg.debug("Call getChatRoomAttributes:", X), d.hj.call(this, dt, E.fI.GET_CHATROOM_ATTR).then(function(lt) {
            return { data: lt.data, type: lt.type };
          });
        }
        function Ht(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + X.chatRoomId);
          if (y(X.attributes) !== "object") throw Error("Invalid parameter attributes: " + X.attributes);
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.userId, rt = X.chatRoomId, dt = X.attributes, lt = X.autoDelete, Ct = lt === void 0 || lt, Ie = X.isForced ? "/forced" : "", x = { metaData: dt, autoDelete: Ct ? "DELETE" : "NO_DELETE" }, ae = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/metadata/chatroom/").concat(rt, "/user/").concat(nt) + Ie, type: "PUT", dataType: "json", data: JSON.stringify(x), headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" } };
          return m.kg.debug("Call setChatRoomAttributes:", X), d.hj.call(this, ae, E.fI.SET_CHATROOM_ATTR).then(function(Q) {
            return (0, p._W)(Q);
          });
        }
        function zt(X) {
          var re;
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + X.chatRoomId);
          if (typeof X.attributeKey != "string" || X.attributeKey === "") throw Error("Invalid parameter attributeKey: " + X.attributeKey);
          if (typeof X.attributeValue != "string" || X.attributeValue === "") throw Error("Invalid parameter attributeValue: " + X.attributeValue);
          var Me = p.XZ.call(this).error;
          if (Me) return Promise.reject(Me);
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.userId, dt = X.chatRoomId, lt = X.attributeKey, Ct = X.attributeValue, Ie = X.autoDelete, x = Ie === void 0 || Ie, ae = X.isForced ? "/forced" : "", Q = { metaData: (re = {}, re[lt] = Ct, re), autoDelete: x ? "DELETE" : "NO_DELETE" }, Z = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/metadata/chatroom/").concat(dt, "/user/").concat(rt) + ae, type: "PUT", dataType: "json", data: JSON.stringify(Q), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" } };
          return m.kg.debug("Call setChatRoomAttribute:", X), d.hj.call(this, Z, E.fI.SET_CHATROOM_ATTR).then(function(ge) {
            var me = (0, p.H7)(ge);
            if (me) throw me;
          });
        }
        function ze(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + X.chatRoomId);
          if (!Array.isArray(X.attributeKeys)) throw Error('"Invalid parameter attributes": ' + X.attributeKeys);
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.userId, rt = X.chatRoomId, dt = X.attributeKeys, lt = X.isForced ? "/forced" : "", Ct = { keys: dt }, Ie = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/metadata/chatroom/").concat(rt, "/user/").concat(nt) + lt, type: "DELETE", dataType: "json", data: JSON.stringify(Ct), headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" } };
          return m.kg.debug("Call removeChatRoomAttributes:", X), d.hj.call(this, Ie, E.fI.DELETE_CHATROOM_ATTR).then(function(x) {
            return (0, p._W)(x);
          });
        }
        function Ne(X) {
          if (typeof X.chatRoomId != "string" || X.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + X.chatRoomId);
          if (typeof X.attributeKey != "string" || X.attributeKey === "") throw Error('"Invalid parameter attributeKey": ' + X.attributeKey);
          var re = p.XZ.call(this).error;
          if (re) return Promise.reject(re);
          var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.userId, rt = X.chatRoomId, dt = X.attributeKey, lt = X.isForced ? "/forced" : "", Ct = { keys: [dt] }, Ie = { url: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/metadata/chatroom/").concat(rt, "/user/").concat(nt) + lt, type: "DELETE", dataType: "json", data: JSON.stringify(Ct), headers: { Authorization: "Bearer " + Ge, "Content-Type": "application/json" } };
          return m.kg.debug("Call removeChatRoomAttribute:", X), d.hj.call(this, Ie, E.fI.DELETE_CHATROOM_ATTR).then(function(x) {
            var ae = (0, p.H7)(x);
            if (ae) throw ae;
          });
        }
        function le(X) {
          var re = this, Me = X || {}, Se = Me.pageNum, ke = Me.pageSize;
          if (isNaN(Se) || Se <= 0) throw Error("Invalid parameter pageNum:".concat(Se));
          if (isNaN(ke) || ke <= 0) throw Error("Invalid parameter pageSize:".concat(ke));
          var Ge = p.XZ.call(this).error;
          if (Ge) return Promise.reject(Ge);
          var nt = { pagenum: Se, pagesize: ke, detail: !0 }, rt = this.context, dt = rt.orgName, lt = rt.appName, Ct = rt.accessToken, Ie = { url: "".concat(this.apiUrl, "/").concat(dt, "/").concat(lt, "/users/").concat(this.user, "/joined_chatrooms"), dataType: "json", type: "GET", data: nt, headers: { Authorization: "Bearer " + Ct, "Content-Type": "application/json" } };
          return m.kg.debug("Call getJoinedChatRooms", X), d.hj.call(this, Ie, E.fI.GET_USER_JOINED_CHATROOM).then(function(x) {
            var ae = (x.data || []).map(function(Q) {
              var Z = Q.id, ge = Q.title, me = Q.owner, ve = Q.created, ie = Q.description, ye = Q.max_users;
              return { id: Z, name: ge, owner: me.split("".concat(re.appKey, "_"))[1], created: ve, description: ie, maxusers: ye };
            });
            return { type: x.type, data: ae };
          });
        }
      }, 4363: function(l, v, s) {
        s.d(v, { U: function() {
          return E;
        }, w: function() {
          return y;
        } }), s(9601), s(2772), s(1249);
        var c = s(7360), d = s(8161), p = s(4024), m = function() {
          return m = Object.assign || function(g) {
            for (var C, O = 1, N = arguments.length; O < N; O++) for (var w in C = arguments[O]) Object.prototype.hasOwnProperty.call(C, w) && (g[w] = C[w]);
            return g;
          }, m.apply(this, arguments);
        }, E = { chat: "singleChat", chatroom: "chatRoom", groupchat: "groupChat", singleChat: "singleChat", chatRoom: "chatRoom", groupChat: "groupChat" };
        function y(g, C) {
          var O, N, w, _ = C || {}, I = _.formatCustomExts, k = I === void 0 || I, H = _.formatChatType, S = H !== void 0 && H, B = g.id, D = g.payload, F = g.timestamp, j = g.to, G = D.bodies && D.bodies.length > 0 ? D.bodies[0] : {}, U = {}, M = {}, V = D.type ? D.type : j.indexOf("@conference.easemob.com") > -1 ? "groupChat" : "singleChat";
          V = V === "chat" ? "singleChat" : V, S && D.type && (V = E[D.type]);
          var J = "";
          switch (G.type) {
            case "txt":
              if (Object.prototype.hasOwnProperty.call(G, "subType") && G.subType === "sub_combine") J = d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "combine", chatType: V, to: D.to, from: D.from, ext: D.ext, time: F, title: G.title || "", summary: G.summary || "", url: J || "", secret: G.secret || "", file_length: G.file_length || 0, filename: G.filename || "", compatibleText: G.msg, combineLevel: G.combineLevel || 0 };
              else {
                var ue = (O = D == null ? void 0 : D.meta) === null || O === void 0 ? void 0 : O.edit_msg;
                if (U = { id: B, type: "txt", chatType: V, msg: G.msg || "", to: D.to || "", from: D.from, time: F, ext: D.ext }, ue) {
                  var se = ue.edit_time, ee = ue.operator, de = ue.count;
                  U.modifiedInfo = { operationTime: se, operatorId: ee, operationCount: de };
                }
              }
              break;
            case "img":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "img", chatType: V, to: D.to, from: D.from, time: F, ext: D.ext, width: ((N = G.size) === null || N === void 0 ? void 0 : N.width) || 0, height: ((w = G.size) === null || w === void 0 ? void 0 : w.height) || 0, thumb: this.useOwnUploadFun ? "" : "".concat(J, "&thumbnail=true"), thumb_secret: G.secret, secret: G.secret || "", url: J || "", file_length: G.file_length || 0, file: {} };
              break;
            case "video":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "video", chatType: V, from: D.from, to: D.to, thumb: p.P6.formatAttachUrl.call(this, G.thumb), thumb_secret: G.thumb_secret || "", url: J || "", secret: G.secret || "", filename: G.filename, length: G.length || 0, file: {}, file_length: G.file_length || 0, filetype: D.ext.file_type || "", ext: D.ext, time: F };
              break;
            case "loc":
              U = { id: B, type: "loc", chatType: V, from: D.from, to: D.to, buildingName: G.buildingName || "", addr: G.addr, lat: G.lat, lng: G.lng, ext: D.ext, time: F };
              break;
            case "audio":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "audio", chatType: V, from: D.from, to: D.to, secret: G.secret || "", ext: D.ext, time: F, url: J || "", file: {}, filename: G.filename, length: G.length || 0, file_length: G.file_length || 0, filetype: D.ext.file_type || "" };
              break;
            case "file":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "file", chatType: V, from: D.from, to: D.to, ext: D.ext, time: F, url: J || "", secret: G.secret || "", file: {}, filename: G.filename || "", file_length: G.file_length || 0, filetype: D.ext.file_type || "" };
              break;
            case "cmd":
              U = { id: B, type: "cmd", chatType: V, from: D.from, to: D.to, ext: D.ext, time: F, action: G.action || "" };
              break;
            case "custom":
              var he = G.customExts || {};
              k && G.customExts && (he = {}, G.customExts.map(function(Ce) {
                he = m(m({}, he), Ce);
              })), U = { id: B, type: "custom", chatType: V, from: D.from, to: D.to, ext: D.ext, time: F, customEvent: G.customEvent || "", customExts: he };
              break;
            case "combine":
              J = d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "combine", chatType: V, msg: G.msg || "", to: D.to || "", from: D.from, time: F, ext: D.ext, title: G.title || "", summary: G.summary || "", url: J || "", compatibleText: G.text, combineLevel: G.combineLevel || 0, secret: G.secret || "", filename: G.filename || "", file_length: G.file_length || 0 };
              break;
            default:
              c.kg.error("unexpected message: ".concat(g));
          }
          if (D.msgConfig && (M.msgConfig = D.msgConfig), D == null ? void 0 : D.meta) {
            var pe = D.meta;
            pe.thread && (M.chatThread = { messageId: pe.thread.msg_parent_id, parentId: pe.thread.muc_parent_id, chatThreadName: pe.thread.thread_name }), pe.reaction && (M.reactions = pe.reaction), pe.translations && (M.translations = pe.translations);
          }
          return m(m({}, U), M);
        }
      }, 2856: function(l, v, s) {
        s.r(v), s.d(v, { acceptGroupInvite: function() {
          return xe;
        }, acceptGroupJoinRequest: function() {
          return Te;
        }, addUsersToGroupAllowlist: function() {
          return re;
        }, addUsersToGroupWhitelist: function() {
          return X;
        }, agreeInviteIntoGroup: function() {
          return Pe;
        }, agreeJoinGroup: function() {
          return Le;
        }, blockGroup: function() {
          return N;
        }, blockGroupMember: function() {
          return Ot;
        }, blockGroupMembers: function() {
          return wt;
        }, blockGroupMessages: function() {
          return w;
        }, changeGroupOwner: function() {
          return B;
        }, changeOwner: function() {
          return S;
        }, createGroup: function() {
          return O;
        }, createGroupNew: function() {
          return C;
        }, deleteGroupSharedFile: function() {
          return Z;
        }, destroyGroup: function() {
          return ee;
        }, disableSendGroupMsg: function() {
          return Ne;
        }, dissolveGroup: function() {
          return se;
        }, downloadGroupSharedFile: function() {
          return ve;
        }, enableSendGroupMsg: function() {
          return le;
        }, fetchGroupAnnouncement: function() {
          return x;
        }, fetchGroupSharedFileList: function() {
          return ge;
        }, getGroup: function() {
          return k;
        }, getGroupAdmin: function() {
          return U;
        }, getGroupAllowlist: function() {
          return nt;
        }, getGroupBlacklist: function() {
          return zt;
        }, getGroupBlacklistNew: function() {
          return Ht;
        }, getGroupBlocklist: function() {
          return ze;
        }, getGroupInfo: function() {
          return D;
        }, getGroupMemberAttributes: function() {
          return ye;
        }, getGroupMembersAttributes: function() {
          return Ye;
        }, getGroupMsgReadUser: function() {
          return Ie;
        }, getGroupMuteList: function() {
          return Tt;
        }, getGroupMutelist: function() {
          return Ut;
        }, getGroupSharedFilelist: function() {
          return me;
        }, getGroupWhitelist: function() {
          return Ge;
        }, getJoinedGroups: function() {
          return H;
        }, getMuted: function() {
          return it;
        }, getPublicGroups: function() {
          return I;
        }, groupBlockMulti: function() {
          return kt;
        }, groupBlockSingle: function() {
          return st;
        }, inviteToGroup: function() {
          return pe;
        }, inviteUsersToGroup: function() {
          return Ce;
        }, isGroupWhiteUser: function() {
          return rt;
        }, isInGroupAllowlist: function() {
          return lt;
        }, isInGroupMutelist: function() {
          return Ct;
        }, isInGroupWhiteList: function() {
          return dt;
        }, joinGroup: function() {
          return _e;
        }, leaveGroup: function() {
          return he;
        }, listGroupMember: function() {
          return j;
        }, listGroupMembers: function() {
          return G;
        }, listGroups: function() {
          return _;
        }, modifyGroup: function() {
          return F;
        }, mute: function() {
          return pt;
        }, muteGroupMember: function() {
          return It;
        }, quitGroup: function() {
          return de;
        }, rejectGroupInvite: function() {
          return $e;
        }, rejectGroupJoinRequest: function() {
          return Oe;
        }, rejectInviteIntoGroup: function() {
          return be;
        }, rejectJoinGroup: function() {
          return K;
        }, removeAdmin: function() {
          return J;
        }, removeGroupAdmin: function() {
          return ue;
        }, removeGroupAllowlistMember: function() {
          return ke;
        }, removeGroupBlockMulti: function() {
          return St;
        }, removeGroupBlockSingle: function() {
          return Et;
        }, removeGroupMember: function() {
          return Ke;
        }, removeGroupMembers: function() {
          return at;
        }, removeGroupWhitelistMember: function() {
          return Se;
        }, removeMultiGroupMember: function() {
          return Ze;
        }, removeMute: function() {
          return Rt;
        }, removeSingleGroupMember: function() {
          return Be;
        }, rmUsersFromGroupWhitelist: function() {
          return Me;
        }, setAdmin: function() {
          return M;
        }, setGroupAdmin: function() {
          return V;
        }, setGroupMemberAttributes: function() {
          return ie;
        }, unblockGroupMember: function() {
          return ut;
        }, unblockGroupMembers: function() {
          return Ft;
        }, unmuteGroupMember: function() {
          return gt;
        }, updateGroupAnnouncement: function() {
          return ae;
        }, uploadGroupSharedFile: function() {
          return Q;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(2222), s(6699), s(2023), s(9554), s(4747), s(8309), s(9753), s(9600);
        var c = s(4024), d = s(3246), p = s(7360), m = s(1595);
        function E(ne) {
          return E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Qe) {
            return typeof Qe;
          } : function(Qe) {
            return Qe && typeof Symbol == "function" && Qe.constructor === Symbol && Qe !== Symbol.prototype ? "symbol" : typeof Qe;
          }, E(ne);
        }
        var y = function(ne, Qe, W, ce) {
          return new (W || (W = Promise))(function(fe, we) {
            function Fe(et) {
              try {
                qe(ce.next(et));
              } catch (bt) {
                we(bt);
              }
            }
            function je(et) {
              try {
                qe(ce.throw(et));
              } catch (bt) {
                we(bt);
              }
            }
            function qe(et) {
              var bt;
              et.done ? fe(et.value) : (bt = et.value, bt instanceof W ? bt : new W(function(ot) {
                ot(bt);
              })).then(Fe, je);
            }
            qe((ce = ce.apply(ne, [])).next());
          });
        }, g = function(ne, Qe) {
          var W, ce, fe, we, Fe = { label: 0, sent: function() {
            if (1 & fe[0]) throw fe[1];
            return fe[1];
          }, trys: [], ops: [] };
          return we = { next: je(0), throw: je(1), return: je(2) }, typeof Symbol == "function" && (we[Symbol.iterator] = function() {
            return this;
          }), we;
          function je(qe) {
            return function(et) {
              return function(bt) {
                if (W) throw new TypeError("Generator is already executing.");
                for (; Fe; ) try {
                  if (W = 1, ce && (fe = 2 & bt[0] ? ce.return : bt[0] ? ce.throw || ((fe = ce.return) && fe.call(ce), 0) : ce.next) && !(fe = fe.call(ce, bt[1])).done) return fe;
                  switch (ce = 0, fe && (bt = [2 & bt[0], fe.value]), bt[0]) {
                    case 0:
                    case 1:
                      fe = bt;
                      break;
                    case 4:
                      return Fe.label++, { value: bt[1], done: !1 };
                    case 5:
                      Fe.label++, ce = bt[1], bt = [0];
                      continue;
                    case 7:
                      bt = Fe.ops.pop(), Fe.trys.pop();
                      continue;
                    default:
                      if (!((fe = (fe = Fe.trys).length > 0 && fe[fe.length - 1]) || bt[0] !== 6 && bt[0] !== 2)) {
                        Fe = 0;
                        continue;
                      }
                      if (bt[0] === 3 && (!fe || bt[1] > fe[0] && bt[1] < fe[3])) {
                        Fe.label = bt[1];
                        break;
                      }
                      if (bt[0] === 6 && Fe.label < fe[1]) {
                        Fe.label = fe[1], fe = bt;
                        break;
                      }
                      if (fe && Fe.label < fe[2]) {
                        Fe.label = fe[2], Fe.ops.push(bt);
                        break;
                      }
                      fe[2] && Fe.ops.pop(), Fe.trys.pop();
                      continue;
                  }
                  bt = Qe.call(ne, Fe);
                } catch (ot) {
                  bt = [6, ot], ce = 0;
                } finally {
                  W = fe = 0;
                }
                if (5 & bt[0]) throw bt[1];
                return { value: bt[0] ? bt[1] : void 0, done: !0 };
              }([qe, et]);
            };
          }
        };
        function C(ne) {
          if (!ne || !ne.data) throw Error("Invalid parameter");
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups?resource=").concat(Fe.clientResource), dataType: "json", type: "POST", data: JSON.stringify({ owner: this.user, groupname: ne.data.groupname, desc: ne.data.desc, members: ne.data.members, public: ne.data.public, approval: ne.data.approval, allowinvites: ne.data.allowinvites, invite_need_confirm: ne.data.inviteNeedConfirm, maxusers: ne.data.maxusers, custom: ne.data.ext }), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: function(qe) {
            ne.success && ne.success(qe);
          }, error: ne.error };
          return p.kg.debug("Call createGroup:", ne), c.hj.call(this, je, m.fI.CREATE_GROUP);
        }
        var O = C;
        function N(ne) {
          var Qe;
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error("Invalid parameter");
          var W = d.XZ.call(this).error;
          if (W) return Promise.reject(W);
          var ce = this.context, fe = ce.orgName, we = ce.appName, Fe = ce.accessToken, je = ce.jid, qe = { entities: [(Qe = {}, Qe["notification_ignore_" + ne.groupId] = !0, Qe)] }, et = { type: "PUT", url: "".concat(this.apiUrl, "/").concat(fe, "/").concat(we, "/users/").concat(this.user, "?resource=").concat(je.clientResource), data: JSON.stringify(qe), dataType: "json", headers: { Authorization: "Bearer " + Fe, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call blockGroupMessages", ne), c.hj.call(this, et, m.fI.BLOCK_GROUP);
        }
        var w = N;
        function _(ne) {
          if (typeof ne.limit != "number") throw Error("Invalid parameter");
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = { limit: ne.limit, cursor: ne.cursor };
          ne.cursor || delete Fe.cursor;
          var je = { url: this.apiUrl + "/" + ce + "/" + fe + "/publicchatgroups", type: "GET", dataType: "json", data: Fe, headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call listGroups", ne), c.hj.call(this, je, m.fI.LIST_GROUP);
        }
        var I = _;
        function k(ne) {
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = { url: this.apiUrl + "/" + ce + "/" + fe + "/users/" + this.user + "/joined_chatgroups", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne && (ne == null ? void 0 : ne.success), error: ne && (ne == null ? void 0 : ne.error) };
          return p.kg.debug("Call getJoinedGroups", ne), c.hj.call(this, Fe, m.fI.GET_USER_GROUP);
        }
        function H(ne) {
          if (typeof ne.pageNum != "number" || typeof ne.pageSize != "number") throw Error('Invalid parameter: "pageNum or pageSize"');
          if (ne.pageNum < 0 || ne.pageSize < 0) throw Error('"pageNum" should >= 0 and "pageSize" should >= 0');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.needAffiliations || ne.needRole ? "/chatgroups/user/".concat(this.user, "?pagenum=").concat(ne.pageNum, "&pagesize=").concat(ne.pageSize, "&needAffiliations=").concat(ne.needAffiliations, "&needRole=").concat(ne.needRole) : "/users/".concat(this.user, "/joined_chatgroups?pagenum=").concat(ne.pageNum, "&pagesize=").concat(ne.pageSize), je = { url: this.apiUrl + "/" + ce + "/" + fe + Fe, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne && (ne == null ? void 0 : ne.success), error: ne && (ne == null ? void 0 : ne.error) };
          return p.kg.debug("Call getGroup", ne), c.hj.call(this, je, m.fI.GET_USER_GROUP).then(function(qe) {
            var et = qe.uri, bt = qe.entities, ot = [];
            return et.includes("joined_chatgroups") || (bt.forEach(function(Lt) {
              var Kt = { affiliationsCount: Lt.affiliations_count, groupName: Lt.name, groupId: Lt.groupId, role: Lt.permission, disabled: Lt.disabled, approval: Lt.membersonly, allowInvites: Lt.allowinvites, description: Lt.description, maxUsers: Lt.maxusers, public: Lt.public };
              ot.push(Kt);
            }), qe.entities = ot), qe;
          });
        }
        function S(ne) {
          if (typeof ne.groupId != "string" || typeof ne.newOwner != "string") throw Error("Invalid parameter");
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = { newowner: ne.newOwner }, ce = this.context, fe = ce.orgName, we = ce.appName, Fe = ce.accessToken, je = ce.jid, qe = { url: "".concat(this.apiUrl, "/").concat(fe, "/").concat(we, "/chatgroups/").concat(ne.groupId, "?resource=").concat(je.clientResource), type: "PUT", dataType: "json", headers: { Authorization: "Bearer " + Fe, "Content-Type": "application/json" }, data: JSON.stringify(W), success: ne.success, error: ne.error };
          return p.kg.debug("Call changeOwner", ne), c.hj.call(this, qe, m.fI.CHANGE_OWNER);
        }
        var B = S;
        function D(ne) {
          if (typeof ne.groupId != "string" && !Array.isArray(ne.groupId)) throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + ne.groupId + "?joined_time=true", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupInfo", ne), c.hj.call(this, Fe, m.fI.GET_GROUP_INFO);
        }
        function F(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error("Invalid parameter");
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { groupname: ne.groupName, description: ne.description, custom: ne.ext }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "?resource=").concat(Fe.clientResource), type: "PUT", data: JSON.stringify(qe), dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call modifyGroup", ne), c.hj.call(this, et, m.fI.MODIFY_GROUP);
        }
        function j(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (isNaN(ne.pageNum) || ne.pageNum <= 0) throw Error('The parameter "pageNum" should be a positive number');
          if (isNaN(ne.pageSize) || ne.pageSize <= 0) throw Error('The parameter "pageSize" should be a positive number');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = { pagenum: ne.pageNum, pagesize: ne.pageSize }, ce = this.context, fe = ce.orgName, we = ce.appName, Fe = ce.accessToken, je = { url: this.apiUrl + "/" + fe + "/" + we + "/chatgroups/" + ne.groupId + "/users", dataType: "json", type: "GET", data: W, headers: { Authorization: "Bearer " + Fe, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call listGroupMember", ne), c.hj.call(this, je, m.fI.LIST_GROUP_MEMBER);
        }
        var G = j;
        function U(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.groupId, je = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + Fe + "/admin", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupAdmin", ne), c.hj.call(this, je, m.fI.GET_GROUP_ADMIN);
        }
        function M(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.username != "string" || ne.username === "") throw Error('Invalid parameter: "username"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { newadmin: ne.username }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/admin?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(qe), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call setGroupAdmin", ne), c.hj.call(this, et, m.fI.SET_GROUP_ADMIN);
        }
        var V = M;
        function J(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.username != "string" || ne.username === "") throw Error('Invalid parameter: "username"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.username, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/admin/").concat(qe, "?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call removeAdmin", ne), c.hj.call(this, et, m.fI.REMOVE_GROUP_ADMIN);
        }
        var ue = J;
        function se(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "?version=v3&resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call destroyGroup", ne), c.hj.call(this, qe, m.fI.DISSOLVE_GROUP);
        }
        var ee = se;
        function de(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/quit?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call quitGroup", ne), c.hj.call(this, qe, m.fI.QUIT_GROUP);
        }
        var he = de;
        function pe(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(ne.users)) throw Error('Invalid parameter: "users"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = ne.groupId, ce = { usernames: ne.users }, fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(W, "/invite?resource=").concat(qe.clientResource), type: "POST", data: JSON.stringify(ce), dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call inviteUsersToGroup", ne), c.hj.call(this, et, m.fI.INVITE_TO_GROUP);
        }
        var Ce = pe;
        function _e(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(ne.groupId, "/apply?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify({ message: ne.message || "" }), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call joinGroup", ne), c.hj.call(this, je, m.fI.JOIN_GROUP);
        }
        function Le(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.applicant != "string" || ne.applicant === "") throw Error('Invalid parameter: "applicant"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { applicant: ne.applicant, verifyResult: !0, reason: "no clue" }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/apply_verify?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(qe), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call agreeJoinGroup", ne), c.hj.call(this, et, m.fI.AGREE_JOIN_GROUP);
        }
        var Te = Le;
        function K(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.applicant != "string" || ne.applicant === "") throw Error('Invalid parameter: "applicant"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { applicant: ne.applicant, verifyResult: !1, reason: ne.reason || "" }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/apply_verify?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(qe), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call rejectGroupJoinRequest", ne), c.hj.call(this, et, m.fI.REJECT_JOIN_GROUP);
        }
        var Oe = K;
        function Pe(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.invitee != "string" || ne.invitee === "") throw Error('Invalid parameter: "invitee"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { invitee: ne.invitee, verifyResult: !0 }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/invite_verify?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(qe), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call acceptGroupInvite", ne), c.hj.call(this, et, m.fI.AGREE_INVITE_GROUP);
        }
        var xe = Pe;
        function be(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.invitee != "string" || ne.invitee === "") throw Error('Invalid parameter: "invitee"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { invitee: ne.invitee, verifyResult: !1 }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/invite_verify?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(qe), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call rejectGroupInvite", ne), c.hj.call(this, et, m.fI.REJECT_INVITE_GROUP);
        }
        var $e = be;
        function Be(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.username != "string" || ne.username === "") throw Error('Invalid parameter: "username"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = ne.groupId, ce = ne.username, fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(W, "/users/").concat(ce, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call removeGroupMember", ne), c.hj.call(this, et, m.fI.REMOVE_GROUP_MEMBER);
        }
        var Ke = Be;
        function Ze(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(ne.users)) throw Error('Invalid parameter: "users"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.users.join(","), et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/users/").concat(qe, "?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call removeGroupMembers", ne), c.hj.call(this, et, m.fI.MULTI_REMOVE_GROUP_MEMBER);
        }
        var at = Ze;
        function pt(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!(Array.isArray(ne.username) || typeof ne.username == "string" && ne.username !== "")) throw Error('Invalid parameter: "username"');
          if (typeof ne.muteDuration != "number") throw Error('Invalid parameter: "muteDuration"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { usernames: typeof ne.username == "string" ? [ne.username] : ne.username, mute_duration: ne.muteDuration }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/mute?resource=").concat(Fe.clientResource), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, data: JSON.stringify(qe), success: ne.success, error: ne.error };
          return p.kg.debug("Call muteGroupMember", ne), c.hj.call(this, et, m.fI.MUTE_GROUP_MEMBER);
        }
        var It = pt;
        function Rt(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!(Array.isArray(ne.username) || typeof ne.username == "string" && ne.username !== "")) throw Error('Invalid parameter: "username"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.username, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/mute/").concat(qe, "?resource=").concat(Fe.clientResource), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call unmuteGroupMember", ne), c.hj.call(this, et, m.fI.UNMUTE_GROUP_MEMBER);
        }
        var gt = Rt;
        function it(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.groupId, je = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + Fe + "/mute", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupMuteList", ne), c.hj.call(this, je, m.fI.GET_GROUP_MUTE_LIST);
        }
        var Tt = it, Ut = it;
        function st(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.username != "string" || ne.username === "") throw Error('Invalid parameter: "username"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.username, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/blocks/users/").concat(qe, "?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call blockGroupMember", ne), c.hj.call(this, et, m.fI.BLOCK_GROUP_MEMBER);
        }
        var Ot = st;
        function kt(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(ne.usernames)) throw Error('Invalid parameter: "usernames"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { usernames: ne.usernames }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/blocks/users?resource=").concat(Fe.clientResource), data: JSON.stringify(qe), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call blockGroupMembers", ne), c.hj.call(this, et, m.fI.BLOCK_GROUP_MEMBERS);
        }
        var wt = kt;
        function Et(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.username != "string" || ne.username === "") throw Error('Invalid parameter: "username"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.username, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/blocks/users/").concat(qe, "?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call unblockGroupMember", ne), c.hj.call(this, et, m.fI.UNBLOCK_GROUP_MEMBER);
        }
        var ut = Et;
        function St(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(ne.usernames)) throw Error('Invalid parameter: "usernames"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.usernames.join(","), et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/blocks/users/").concat(qe, "?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call unblockGroupMembers", ne), c.hj.call(this, et, m.fI.UNBLOCK_GROUP_MEMBERS);
        }
        var Ft = St;
        function Ht(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.groupId, je = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + Fe + "/blocks/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupBlacklist", ne), c.hj.call(this, je, m.fI.GET_GROUP_BLACK_LIST);
        }
        var zt = Ht, ze = Ht;
        function Ne(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/ban?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call disableSendGroupMsg", ne), c.hj.call(this, qe, m.fI.DISABLED_SEND_GROUP_MSG);
        }
        function le(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/ban?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call enableSendGroupMsg", ne), c.hj.call(this, qe, m.fI.ENABLE_SEND_GROUP_MSG);
        }
        function X(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(ne.users)) throw Error('Invalid parameter: "users"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { usernames: ne.users }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/white/users?resource=").concat(Fe.clientResource), type: "POST", data: JSON.stringify(qe), dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call addUsersToGroupWhitelist", ne), c.hj.call(this, et, m.fI.ADD_USERS_TO_GROUP_WHITE);
        }
        var re = X;
        function Me(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.userName != "string" || ne.userName === "") throw Error('Invalid parameter: "userName"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/white/users/").concat(ne.userName, "?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call removeGroupAllowlistMember", ne), c.hj.call(this, qe, m.fI.REMOVE_GROUP_WHITE_MEMBER);
        }
        var Se = Me, ke = Me;
        function Ge(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.groupId, je = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + Fe + "/white/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupAllowlist", ne), c.hj.call(this, je, m.fI.GET_GROUP_WHITE_LIST);
        }
        var nt = Ge;
        function rt(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.userName != "string" || ne.userName === "") throw Error('Invalid parameter: "userName"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.groupId, je = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + Fe + "/white/users/" + ne.userName, type: "GET", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call isInGroupAllowlist", ne), c.hj.call(this, je, m.fI.IS_IN_GROUP_WHITE_LIST);
        }
        var dt = rt, lt = rt;
        function Ct(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.userId, je = { url: this.apiUrl + "/" + ce + "/" + fe + "/sdk/chatgroups/" + ne.groupId + "/mute/" + Fe, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + we } };
          return p.kg.debug("Call isInGroupMutelist", ne), c.hj.call(this, je).then(function(qe) {
            return { type: qe.type, data: qe.data };
          });
        }
        function Ie(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.msgId != "string" || ne.msgId === "") throw Error('Invalid parameter: "msgId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = { url: this.apiUrl + "/" + ce + "/" + fe + "/chatgroups/" + ne.groupId + "/acks/" + ne.msgId, dataType: "json", type: "GET", data: { limit: 500, key: void 0 }, headers: { Authorization: "Bearer " + we }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupMsgReadUser", ne), c.hj.call(this, Fe, m.fI.GET_GROUP_MSG_READ_USER);
        }
        function x(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.groupId, je = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(Fe, "/announcement"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call fetchGroupAnnouncement", ne), c.hj.call(this, je, m.fI.GET_GROUP_ANN);
        }
        function ae(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.announcement != "string") throw Error('Invalid parameter: "announcement"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = { announcement: ne.announcement }, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/announcement?resource=").concat(Fe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(qe), headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call updateGroupAnnouncement", ne), c.hj.call(this, et, m.fI.UPDATE_GROUP_ANN);
        }
        function Q(ne) {
          var Qe;
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (E(ne.file) !== "object") throw Error('Invalid parameter: "file"');
          var W = d.XZ.call(this).error;
          if (W) return (Qe = ne.onFileUploadError) === null || Qe === void 0 ? void 0 : Qe.call(ne, W);
          var ce = this.context, fe = ce.orgName, we = ce.appName, Fe = ce.accessToken, je = ce.jid, qe = ne.groupId;
          c.cT.call(this, { uploadUrl: "".concat(this.apiUrl, "/").concat(fe, "/").concat(we, "/chatgroups/").concat(qe, "/share_files?resource=").concat(je.clientResource), onFileUploadProgress: ne.onFileUploadProgress, onFileUploadComplete: ne.onFileUploadComplete, onFileUploadError: ne.onFileUploadError, onFileUploadCanceled: ne.onFileUploadCanceled, accessToken: Fe, apiUrl: this.apiUrl, file: ne.file, appKey: this.context.appKey }, m.fI.UPLOAD_GROUP_FILE), p.kg.debug("Call uploadGroupSharedFile", ne);
        }
        function Z(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof ne.fileId != "string" || ne.fileId === "") throw Error('Invalid parameter: "file"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = W.jid, je = ne.groupId, qe = ne.fileId, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(je, "/share_files/").concat(qe, "?resource=").concat(Fe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call deleteGroupSharedFile", ne), c.hj.call(this, et, m.fI.DELETE_GROUP_FILE);
        }
        function ge(ne) {
          if (typeof ne.groupId != "string" || ne.groupId === "") throw Error('Invalid parameter: "groupId"');
          var Qe = d.XZ.call(this).error;
          if (Qe) return Promise.reject(Qe);
          var W = this.context, ce = W.orgName, fe = W.appName, we = W.accessToken, Fe = ne.pageNum || 1, je = ne.pageSize || 10, qe = ne.groupId, et = { url: "".concat(this.apiUrl, "/").concat(ce, "/").concat(fe, "/chatgroups/").concat(qe, "/share_files?pagenum=").concat(Fe, "&pagesize=").concat(je), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + we, "Content-Type": "application/json" }, success: ne.success, error: ne.error };
          return p.kg.debug("Call getGroupSharedFilelist", ne), c.hj.call(this, et, m.fI.GET_GROUP_FILE_LIST);
        }
        var me = ge;
        function ve(ne) {
          var Qe = this.context, W = Qe.orgName, ce = Qe.appName, fe = Qe.accessToken, we = this.apiUrl, Fe = ne.groupId, je = ne.fileId;
          c.LR.call(this, { url: "".concat(we, "/").concat(W, "/").concat(ce, "/chatgroups/").concat(Fe, "/share_files/").concat(je), onFileDownloadComplete: ne.onFileDownloadComplete, onFileDownloadError: ne.onFileDownloadError, accessToken: fe, id: je, secret: ne.secret }, m.fI.DOWN_GROUP_FILE), p.kg.debug("Call downloadGroupSharedFile", ne);
        }
        function ie(ne) {
          return y(this, void 0, void 0, function() {
            var Qe, W, ce, fe, we, Fe, je, qe, et, bt, ot;
            return g(this, function(Lt) {
              switch (Lt.label) {
                case 0:
                  if (Qe = ne.groupId, W = ne.userId, ce = ne.memberAttributes, typeof Qe != "string" || Qe === "") throw Error('Invalid parameter: "groupId"');
                  if (typeof W != "string" || W === "") throw Error('Invalid parameter: "userId"');
                  if (E(ce) !== "object") throw Error('Invalid parameter: "memberAttributes"');
                  return (fe = d.XZ.call(this).error) ? [2, Promise.reject(fe)] : (we = this.context, Fe = we.orgName, je = we.appName, qe = we.accessToken, et = we.jid, bt = { metaData: ce }, ot = { url: "".concat(this.apiUrl, "/").concat(Fe, "/").concat(je, "/sdk/metadata/chatgroup/").concat(Qe, "/user/").concat(W, "?resource=").concat(et.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + qe, "Content-Type": "application/json" } }, p.kg.debug("Call setGroupMemberAttributes", ne), [4, c.hj.call(this, ot, m.fI.SET_GROUP_MEMBER_ATTRS)]);
                case 1:
                  return Lt.sent(), [2];
              }
            });
          });
        }
        function ye(ne) {
          var Qe = ne.groupId, W = ne.userId;
          return Ye.call(this, { groupId: Qe, userIds: [W] }).then(function(ce) {
            var fe;
            return { type: ce.type, data: (fe = ce.data) === null || fe === void 0 ? void 0 : fe[W] };
          });
        }
        function Ye(ne) {
          var Qe = ne.groupId, W = ne.userIds, ce = ne.keys, fe = ce === void 0 ? [] : ce;
          if (typeof Qe != "string" || Qe === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(W) || (W == null ? void 0 : W.length) <= 0) throw Error('Invalid parameter: "userIds"');
          if (!Array.isArray(fe)) throw Error('Invalid parameter: "keys"');
          var we = d.XZ.call(this).error;
          if (we) return Promise.reject(we);
          var Fe = this.context, je = Fe.orgName, qe = Fe.appName, et = Fe.accessToken, bt = { targets: W, properties: fe }, ot = { url: "".concat(this.apiUrl, "/").concat(je, "/").concat(qe, "/sdk/metadata/chatgroup/").concat(Qe, "/get"), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + et, "Content-Type": "application/json" } };
          return p.kg.debug("Call getGroupMembersAttributes", ne), c.hj.call(this, ot, m.fI.GET_GROUP_MEMBER_ATTR).then(function(Lt) {
            return { type: Lt.type, data: (Lt == null ? void 0 : Lt.data) || {} };
          });
        }
      }, 7479: function(l, v, s) {
        s.r(v), s.d(v, { acceptContactInvite: function() {
          return Be;
        }, acceptInvitation: function() {
          return $e;
        }, addContact: function() {
          return Pe;
        }, addConversationMark: function() {
          return Me;
        }, addReaction: function() {
          return st;
        }, addToBlackList: function() {
          return at;
        }, addUsersToBlacklist: function() {
          return pt;
        }, addUsersToBlocklist: function() {
          return It;
        }, declineContactInvite: function() {
          return Ze;
        }, declineInvitation: function() {
          return Ke;
        }, deleteAllMessagesAndConversations: function() {
          return nt;
        }, deleteContact: function() {
          return be;
        }, deleteConversation: function() {
          return de;
        }, deleteReaction: function() {
          return Ot;
        }, deleteSession: function() {
          return ee;
        }, fetchHistoryMessages: function() {
          return Te;
        }, fetchUserInfoById: function() {
          return Ce;
        }, getAllContacts: function() {
          return le;
        }, getBlacklist: function() {
          return F;
        }, getBlocklist: function() {
          return j;
        }, getContacts: function() {
          return U;
        }, getContactsWithCursor: function() {
          return X;
        }, getConversationlist: function() {
          return ue;
        }, getHistoryMessages: function() {
          return Oe;
        }, getReactionDetail: function() {
          return Et;
        }, getReactionList: function() {
          return kt;
        }, getReactionlist: function() {
          return wt;
        }, getRoster: function() {
          return G;
        }, getSelfIdsOnOtherPlatform: function() {
          return Ge;
        }, getServerConversations: function() {
          return Ft;
        }, getServerConversationsByFilter: function() {
          return ke;
        }, getServerPinnedConversations: function() {
          return zt;
        }, getServerPinnedMessages: function() {
          return Ct;
        }, getSessionList: function() {
          return J;
        }, getTokenExpireTimestamp: function() {
          return Le;
        }, modifyMessage: function() {
          return Ut;
        }, pinConversation: function() {
          return ze;
        }, pinMessage: function() {
          return dt;
        }, recallMessage: function() {
          return Tt;
        }, removeConversationMark: function() {
          return Se;
        }, removeFromBlackList: function() {
          return Rt;
        }, removeHistoryMessages: function() {
          return St;
        }, removeRoster: function() {
          return xe;
        }, removeUserFromBlackList: function() {
          return gt;
        }, removeUserFromBlocklist: function() {
          return it;
        }, reportMessage: function() {
          return ut;
        }, setContactRemark: function() {
          return Ne;
        }, unbindPushToken: function() {
          return Ie;
        }, unpinMessage: function() {
          return lt;
        }, updateCurrentUserNick: function() {
          return _e;
        }, updateOwnUserInfo: function() {
          return he;
        }, updateUserInfo: function() {
          return pe;
        }, uploadPushToken: function() {
          return V;
        }, uploadToken: function() {
          return M;
        } }), s(9601), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(9554), s(4747), s(2222), s(7941), s(6699), s(3710), s(9714), s(9600), s(5069), s(561), s(9753), s(8309), s(1249), s(7327);
        var c = s(3246), d = s(5531), p = s(7252), m = s(4024), E = s(9937), y = s(8161), g = s(4188), C = s.n(g), O = s(7360), N = s(1595), w = s(4363), _ = s(7288), I = s(9743), k = s(6801), H = function() {
          return H = Object.assign || function(x) {
            for (var ae, Q = 1, Z = arguments.length; Q < Z; Q++) for (var ge in ae = arguments[Q]) Object.prototype.hasOwnProperty.call(ae, ge) && (x[ge] = ae[ge]);
            return x;
          }, H.apply(this, arguments);
        }, S = function(x, ae, Q, Z) {
          return new (Q || (Q = Promise))(function(ge, me) {
            function ve(Ye) {
              try {
                ye(Z.next(Ye));
              } catch (ne) {
                me(ne);
              }
            }
            function ie(Ye) {
              try {
                ye(Z.throw(Ye));
              } catch (ne) {
                me(ne);
              }
            }
            function ye(Ye) {
              var ne;
              Ye.done ? ge(Ye.value) : (ne = Ye.value, ne instanceof Q ? ne : new Q(function(Qe) {
                Qe(ne);
              })).then(ve, ie);
            }
            ye((Z = Z.apply(x, [])).next());
          });
        }, B = function(x, ae) {
          var Q, Z, ge, me, ve = { label: 0, sent: function() {
            if (1 & ge[0]) throw ge[1];
            return ge[1];
          }, trys: [], ops: [] };
          return me = { next: ie(0), throw: ie(1), return: ie(2) }, typeof Symbol == "function" && (me[Symbol.iterator] = function() {
            return this;
          }), me;
          function ie(ye) {
            return function(Ye) {
              return function(ne) {
                if (Q) throw new TypeError("Generator is already executing.");
                for (; ve; ) try {
                  if (Q = 1, Z && (ge = 2 & ne[0] ? Z.return : ne[0] ? Z.throw || ((ge = Z.return) && ge.call(Z), 0) : Z.next) && !(ge = ge.call(Z, ne[1])).done) return ge;
                  switch (Z = 0, ge && (ne = [2 & ne[0], ge.value]), ne[0]) {
                    case 0:
                    case 1:
                      ge = ne;
                      break;
                    case 4:
                      return ve.label++, { value: ne[1], done: !1 };
                    case 5:
                      ve.label++, Z = ne[1], ne = [0];
                      continue;
                    case 7:
                      ne = ve.ops.pop(), ve.trys.pop();
                      continue;
                    default:
                      if (!((ge = (ge = ve.trys).length > 0 && ge[ge.length - 1]) || ne[0] !== 6 && ne[0] !== 2)) {
                        ve = 0;
                        continue;
                      }
                      if (ne[0] === 3 && (!ge || ne[1] > ge[0] && ne[1] < ge[3])) {
                        ve.label = ne[1];
                        break;
                      }
                      if (ne[0] === 6 && ve.label < ge[1]) {
                        ve.label = ge[1], ge = ne;
                        break;
                      }
                      if (ge && ve.label < ge[2]) {
                        ve.label = ge[2], ve.ops.push(ne);
                        break;
                      }
                      ge[2] && ve.ops.pop(), ve.trys.pop();
                      continue;
                  }
                  ne = ae.call(x, ve);
                } catch (Qe) {
                  ne = [6, Qe], Z = 0;
                } finally {
                  Q = ge = 0;
                }
                if (5 & ne[0]) throw ne[1];
                return { value: ne[0] ? ne[1] : void 0, done: !0 };
              }([ye, Ye]);
            };
          }
        }, D = { singleChat: "chat", chatRoom: "chatroom", groupChat: "groupchat" };
        function F(x) {
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = { url: this.apiUrl + "/" + Z + "/" + ge + "/users/" + this.user + "/blocks/users", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + me }, success: function(ie) {
            ie.data.forEach(function(ye) {
            }), typeof (x == null ? void 0 : x.success) == "function" && x.success(ie);
          }, error: function(ie) {
            typeof (x == null ? void 0 : x.error) == "function" && x.error(ie);
          } };
          return O.kg.debug("Call getBlocklist"), m.hj.call(this, ve, N.fI.GET_BLACK_LIST);
        }
        var j = F, G = U;
        function U(x) {
          var ae = this, Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = { url: this.apiUrl + "/" + ge + "/" + me + "/users/" + this.user + "/contacts/users", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + ve }, success: function(ye) {
            var Ye = [];
            ye.data.forEach(function(ne) {
              Ye.push({ name: ne, subscription: "both", jid: ae.context.jid });
            }), typeof (x == null ? void 0 : x.success) == "function" && x.success(Ye);
          }, error: function(ye) {
            typeof (x == null ? void 0 : x.error) == "function" && x.error(ye);
          } };
          return O.kg.debug("Call getContacts"), m.hj.call(this, ie, N.fI.GET_CONTACTS);
        }
        function M(x) {
          return O.kg.debug("Call uploadPushToken"), k.r.call(this, x);
        }
        var V = M;
        function J(x) {
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/user_channels"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" }, success: x && (x == null ? void 0 : x.success), error: x && (x == null ? void 0 : x.error) };
          return O.kg.debug("Call getSessionList"), m.hj.call(this, ve, N.fI.GET_SESSION_LIST);
        }
        function ue(x) {
          var ae = this, Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = !!(x && typeof x.pageNum == "number" && typeof x.pageSize == "number" && x.pageNum > 0 && x.pageSize > 0), ye = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/users/").concat(this.user, "/user_channels").concat(ie ? "/page" : ""), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" }, success: x && (x == null ? void 0 : x.success), error: x && (x == null ? void 0 : x.error) };
          return ie && (ye.data = { pageNum: x.pageNum, pageSize: x.pageSize }), O.kg.debug("Call getConversationlist"), m.hj.call(this, ye, N.fI.GET_SESSION_LIST).then(function(Ye) {
            return se.call(ae, Ye);
          });
        }
        function se(x) {
          var ae = this, Q = x.data.channel_infos;
          return Q == null || Q.forEach(function(Z) {
            Z.meta && JSON.stringify(Z.meta) !== "{}" ? (Z.meta.payload = JSON.parse(Z.meta.payload), Z.lastMessage = w.w.call(ae, Z.meta, { formatCustomExts: !1 })) : Z.lastMessage = Z.meta, delete Z.meta;
          }), x;
        }
        function ee(x) {
          if (x && typeof x.channel != "string") throw Error("Invalid parameter channel: ".concat(x.channel));
          if (x && x.chatType !== "singleChat" && x.chatType !== "groupChat") throw Error("Invalid parameter chatType: ".concat(x.chatType));
          if (x && typeof x.deleteRoam != "boolean") throw Error("Invalid parameter deleteRoam: ".concat(x.deleteRoam));
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          var Q, Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = Z.jid;
          Q = x.chatType === "singleChat" ? "chat" : "groupChat";
          var ye = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/user/").concat(this.user, "/user_channel?resource=").concat(ie.clientResource), dataType: "json", type: "DELETE", data: JSON.stringify({ channel: x.channel, type: Q, delete_roam: x.deleteRoam }), headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" }, success: x.success, error: x.error };
          return O.kg.debug("Call deleteSession", x), m.hj.call(this, ye, N.fI.DELETE_SESSION);
        }
        var de = ee;
        function he(x, ae) {
          var Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = ["nickname", "avatarurl", "mail", "phone", "gender", "sign", "birth", "ext"], ye = {}, Ye = m.P6.getEnvInfo();
          if (Ye.platform === "wx" || Ye.platform === "qq") if (typeof x == "string" && ae !== void 0) {
            if (!ie.includes(x)) throw new Error("illegal key, only these keys: nickname, avatarurl, mail, phone, gender, sign, birth, ext are allowed");
            ye[x] = ae;
          } else {
            if (Object.prototype.toString.call(x) !== "[object Object]") throw new Error("illegal params");
            ie.forEach(function(W) {
              ie.includes(W) && x[W] !== void 0 && (ye[W] = x[W]);
            });
          }
          else if (typeof x == "string") {
            if (!ie.includes(x)) throw new Error("illegal key, only these keys: nickname, avatarurl, mail, phone, gender, sign, birth, ext are allowed");
            ye = x + "=" + ae;
          } else {
            if (Object.prototype.toString.call(x) !== "[object Object]") throw new Error("illegal params");
            var ne = [];
            ie.forEach(function(W) {
              if (ie.includes(W) && x[W] !== void 0) {
                var ce = encodeURIComponent(W), fe = encodeURIComponent(x[W]);
                ne.push(ce + "=" + fe);
              }
            }), ye = ne.join("&");
          }
          var Qe = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/metadata/user/").concat(this.user), type: "PUT", data: ye, dataType: "json", headers: { Authorization: "Bearer " + ve, "Content-Type": "application/x-www-form-urlencoded" } };
          return O.kg.debug("Call updateOwnUserInfo", x), m.hj.call(this, Qe, N.fI.UPDATE_USER_INFO);
        }
        var pe = he;
        function Ce(x, ae) {
          var Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          var Z, ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = [];
          if (typeof x == "string") ye = [x];
          else {
            if (Object.prototype.toString.call(x) !== "[object Array]") throw new Error("illegal params");
            ye = x;
          }
          Z = typeof ae == "string" ? [ae] : ae && Object.prototype.toString.call(ae) === "[object Array]" ? ae : ["nickname", "avatarurl", "mail", "phone", "gender", "sign", "birth", "ext"];
          var Ye = { url: "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/metadata/user/get"), type: "POST", data: JSON.stringify({ targets: ye, properties: Z }), dataType: "json", headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } };
          return O.kg.debug("Call fetchUserInfoById", x), m.hj.call(this, Ye, N.fI.GET_USER_INFO);
        }
        function _e(x) {
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user), type: "PUT", dataType: "json", data: JSON.stringify({ nickname: x }), headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } };
          return O.kg.debug("Call updateCurrentUserNick", x), m.hj.call(this, ve);
        }
        function Le(x) {
          if (typeof x != "string" || x === "") throw Error('Invalid parameter: "token"');
          var ae = this.context, Q = ae.orgName, Z = ae.appName, ge = { url: "".concat(this.apiUrl, "/").concat(Q, "/").concat(Z, "/sdk/users/").concat(this.user, "/token/expires"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + x, "Content-Type": "application/json" } };
          return O.kg.debug("Call getTokenExpireTimestamp", x), m.hj.call(this, ge, N.fI.SDK_INTERNAL);
        }
        function Te(x) {
          var ae = this;
          return new Promise(function(Q, Z) {
            if (!x.queue) throw Error('Invalid parameter: "specified"');
            var ge = c.XZ.call(ae).error;
            if (ge) return Promise.reject(ge);
            (function me(ve) {
              var ie = this, ye = ve.count || 20;
              K.call(this, { count: ye, isGroup: !!ve.isGroup, queue: ve.queue, start: ve.start, format: ve.format, success: function(Ye) {
                if (Ye.msgs.length >= ye || Ye.is_last) {
                  var ne = Ye.msgs.splice(0, ye).reverse();
                  ve.success && ve.success(ne), Q(ne);
                } else me.call(ie, H(H({}, ve), { start: null }));
              }, fail: function(Ye) {
                Z(Ye), ve.fail && ve.fail(Ye);
              } });
            }).call(ae, x), O.kg.debug("Call fetchHistoryMessages", x);
          });
        }
        function K(x) {
          var ae = this, Q = x.queue, Z = this.mr_cache[Q] || (this.mr_cache[Q] = { msgs: [] }), ge = this.context.userId, me = x.start || -1, ve = x.count || 20;
          if (Z.msgs.length >= ve || Z.is_last) typeof x.success == "function" && x.success(Z);
          else {
            Z && Z.next_key && (me = Z.next_key), x.start && (me = x.start);
            var ie = { queue: Q + (x.isGroup ? "@conference.easemob.com" : "@easemob.com"), start: me, end: -1 }, ye = this.context, Ye = ye.orgName, ne = ye.appName, Qe = { url: "".concat(this.apiUrl, "/").concat(Ye, "/").concat(ne, "/users/").concat(ge, "/messageroaming"), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + this.token, "Content-Type": "application/json" }, data: JSON.stringify(ie), success: function(W) {
              return S(ae, void 0, void 0, function() {
                var ce, fe, we, Fe, je, qe, et = this;
                return B(this, function(bt) {
                  switch (bt.label) {
                    case 0:
                      if (ce = W == null ? void 0 : W.data, !W.data.msgs) return typeof x.success == "function" && x.success(Z), Z.is_last = !0, Z.next_key = "", [2];
                      fe = ce.msgs, we = fe.length, Z.is_last = ce.is_last, Z.next_key = ce.next_key, Fe = function(ot) {
                        return S(et, void 0, void 0, function() {
                          var Lt, Kt, $t, yt, Wt;
                          return B(this, function(In) {
                            switch (In.label) {
                              case 0:
                                for (Lt = [], ot = C().atob(ot), Kt = 0, $t = ot.length; Kt < $t; ++Kt) Lt.push(ot.charCodeAt(Kt));
                                return yt = (yt = this.context.root.lookup("easemob.pb.Meta")).decode(Lt), Wt = { errorCode: 0, reason: "" }, yt.ns !== 1 ? [3, 2] : [4, y.Z.call(this, yt, Wt, !0, x.format)];
                              case 1:
                                return [2, In.sent()];
                              case 2:
                                return [2];
                            }
                          });
                        });
                      }, je = 0, bt.label = 1;
                    case 1:
                      return je < we ? [4, Fe(fe[je].msg)] : [3, 4];
                    case 2:
                      (qe = bt.sent()) && Z.msgs.push(qe), bt.label = 3;
                    case 3:
                      return je++, [3, 1];
                    case 4:
                      return typeof x.success == "function" && x.success(Z), [2];
                  }
                });
              });
            }, error: function(W) {
              if (W.error && W.error_description) {
                var ce = p.Z.create({ type: d.E.WEBIM_CONNCTION_AJAX_ERROR, message: "fetch history messages error", data: W });
                ae.onError && ae.onError(ce);
              }
            } };
            m.hj.call(this, Qe, N.fI.GET_HISTORY_MSG).catch(function(W) {
              typeof x.fail == "function" && x.fail(W);
            });
          }
        }
        function Oe(x) {
          var ae = this;
          return new Promise(function(Q, Z) {
            var ge = x.targetId, me = x.cursor, ve = me === void 0 ? -1 : me, ie = x.pageSize, ye = ie === void 0 ? 20 : ie, Ye = x.chatType, ne = x.searchDirection, Qe = x.searchOptions, W = Qe === void 0 ? {} : Qe, ce = W.msgTypes, fe = ce === void 0 ? [] : ce, we = W.startTime, Fe = we === void 0 ? null : we, je = W.endTime, qe = je === void 0 ? null : je, et = W.from, bt = et === void 0 ? null : et;
            if (typeof ge != "string" || ge === "") throw Error('"Invalid parameter": "targetId"');
            if (bt && typeof bt != "string") throw Error('"Invalid parameter": "searchOptions.from"');
            if (fe && !Array.isArray(fe)) throw Error('"Invalid parameter": "searchOptions.msgTypes"');
            if (Fe && typeof Fe != "number") throw Error('"Invalid parameter": "searchOptions.startTime"');
            if (qe && typeof Fe != "number") throw Error('"Invalid parameter": "searchOptions.endTime"');
            var ot = c.XZ.call(ae).error;
            if (ot) return Promise.reject(ot);
            var Lt = ae.context, Kt = Lt.orgName, $t = Lt.appName, yt = Lt.userId, Wt = x.chatType === "singleChat" ? "@easemob.com" : "@conference.easemob.com", In = { queue: "".concat(ge).concat(Wt), start: ve, pull_number: ye, is_positive: ne === "down", msgType: fe.join(",") || "", end: -1, startTime: Fe, endTime: qe, userId: Ye === "singleChat" ? null : bt }, gn = { url: "".concat(ae.apiUrl, "/").concat(Kt, "/").concat($t, "/users/").concat(yt, "/messageroaming"), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + ae.token, "Content-Type": "application/json" }, data: JSON.stringify(In), success: function(zn) {
              return S(ae, void 0, void 0, function() {
                var Xn, yr, ur, Yn, xi, gs, Or, da, Za = this;
                return B(this, function(js) {
                  switch (js.label) {
                    case 0:
                      Xn = zn == null ? void 0 : zn.data, yr = Xn.msgs || [], ur = function(Fs) {
                        return S(Za, void 0, void 0, function() {
                          var la, Gs, ka, Vs, ja;
                          return B(this, function(Xt) {
                            switch (Xt.label) {
                              case 0:
                                for (la = [], Fs = C().atob(Fs), Gs = 0, ka = Fs.length; Gs < ka; ++Gs) la.push(Fs.charCodeAt(Gs));
                                return Vs = (Vs = this.context.root.lookup("easemob.pb.Meta")).decode(la), ja = { errorCode: 0, reason: "" }, Vs.ns !== 1 ? [3, 2] : [4, y.Z.call(this, Vs, ja, !0, !0)];
                              case 1:
                                return [2, Xt.sent()];
                              case 2:
                                return [2];
                            }
                          });
                        });
                      }, Yn = [], xi = 0, js.label = 1;
                    case 1:
                      return xi < yr.length ? [4, ur(yr[xi].msg)] : [3, 4];
                    case 2:
                      (gs = js.sent()) && Yn.push(gs), js.label = 3;
                    case 3:
                      return xi++, [3, 1];
                    case 4:
                      return Xn.msgs = Yn, Or = { cursor: Xn.next_key, messages: Yn, isLast: Xn.is_last }, (da = x.success) === null || da === void 0 || da.call(x, Or), Q(Or), [2];
                  }
                });
              });
            }, error: x.fail };
            m.hj.call(ae, gn).catch(function(zn) {
              Z(zn);
            }), O.kg.debug("Call getHistoryMessages", x);
          });
        }
        function Pe(x, ae) {
          return S(this, void 0, void 0, function() {
            var Q, Z, ge, me, ve, ie, ye;
            return B(this, function(Ye) {
              switch (Ye.label) {
                case 0:
                  if (Q = c.XZ.call(this).error) return [2, Promise.reject(Q)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call addContact", x, ae), Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = Z.jid, ye = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/users/").concat(this.user, "/contacts/apply?resource=").concat(ie.clientResource), type: "POST", dataType: "json", data: JSON.stringify({ usernames: [x], reason: ae }), headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" } }, [4, m.hj.call(this, ye, N.fI.ROSTER_ADD)];
                case 1:
                  return Ye.sent(), [2];
              }
            });
          });
        }
        var xe = be;
        function be(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie;
            return B(this, function(ye) {
              switch (ye.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call deleteContact", x), Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = Q.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/contacts/users/").concat(x, "?resource=").concat(ve.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ie, N.fI.ROSTER_REMOVE)];
                case 1:
                  return ye.sent(), [2];
              }
            });
          });
        }
        function $e(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie;
            return B(this, function(ye) {
              switch (ye.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call acceptInvitation", x), Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = Q.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/contacts/accept/users/").concat(x, "?resource=").concat(ve.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ie, N.fI.ROSTER_ACCEPT)];
                case 1:
                  return ye.sent(), [2];
              }
            });
          });
        }
        var Be = $e;
        function Ke(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie;
            return B(this, function(ye) {
              switch (ye.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call declineInvitation", x), Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = Q.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/contacts/decline/users/").concat(x, "?resource=").concat(ve.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ie, N.fI.ROSTER_DECLINE)];
                case 1:
                  return ye.sent(), [2];
              }
            });
          });
        }
        var Ze = Ke;
        function at(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye;
            return B(this, function(ne) {
              switch (ne.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (Q = x.name, Z = [], typeof Q == "string") {
                    if (Q === "") throw Error('"Invalid parameter": "name"');
                    Z = [Q];
                  } else {
                    if (!Array.isArray(Q)) throw Error('"Invalid parameter": "name"');
                    Z = Q;
                  }
                  return O.kg.debug("Call addToBlockList", x), ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = ge.jid, Ye = { url: "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/sdk/user/").concat(this.user, "/blocks?resource=").concat(ye.clientResource), type: "POST", dataType: "json", data: JSON.stringify({ usernames: Z }), headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } }, [4, m.hj.call(this, Ye, N.fI.ROSTER_BAN).then(function(Qe) {
                    return { type: Qe.type, data: { userIds: (Qe == null ? void 0 : Qe.data) || [] } };
                  })];
                case 1:
                  return [2, ne.sent()];
              }
            });
          });
        }
        var pt = at, It = at;
        function Rt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye;
            return B(this, function(ne) {
              switch (ne.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (Q = x.name, Z = [], typeof Q == "string") {
                    if (Q === "") throw Error('"Invalid parameter": "name"');
                    Z = [Q];
                  } else {
                    if (!Array.isArray(Q)) throw Error('"Invalid parameter": "name"');
                    Z = Q;
                  }
                  return O.kg.debug("Call removeFromBlockList", x), ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = ge.jid, Ye = { url: "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/sdk/user/").concat(this.user, "/blocks?resource=").concat(ye.clientResource), type: "DELETE", dataType: "json", data: JSON.stringify({ usernames: Z }), headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } }, [4, m.hj.call(this, Ye, N.fI.ROSTER_ALLOW)];
                case 1:
                  return ne.sent(), [2];
              }
            });
          });
        }
        var gt = Rt, it = Rt;
        function Tt(x) {
          var ae = this, Q = (x == null ? void 0 : x.ext) || "";
          if (typeof Q != "string") throw Error('"Invalid parameter": "ext"', Q);
          var Z = this.getUniqueId(), ge = { id: Z, to: x.to };
          this._msgHash[Z] = H({}, ge);
          var me = "";
          x.chatType !== void 0 ? me = x.chatType : x.type !== void 0 && (me = x.type === "chat" ? "singleChat" : x.type);
          var ve = { id: Z, type: "recall", chatType: me, ackId: x.mid, to: x.to, isChatThread: x.isChatThread || !1, metaExt: Q, success: function(ie) {
            return S(ae, void 0, void 0, function() {
              var ye, Ye, ne, Qe, W, ce, fe, we, Fe;
              return B(this, function(je) {
                switch (je.label) {
                  case 0:
                    return je.trys.push([0, 5, , 6]), me !== "singleChat" && me !== "groupChat" ? [3, 4] : [4, (ne = (Ye = this._localCache) === null || Ye === void 0 ? void 0 : Ye.getInstance()) === null || ne === void 0 ? void 0 : ne.removeMsgByServerMsgId(x.mid)];
                  case 1:
                    return je.sent(), [4, (W = (Qe = this._localCache) === null || Qe === void 0 ? void 0 : Qe.getInstance()) === null || W === void 0 ? void 0 : W.getConversationLastMessage(x.to, me)];
                  case 2:
                    return ye = je.sent(), [4, (fe = (ce = this._localCache) === null || ce === void 0 ? void 0 : ce.getInstance()) === null || fe === void 0 ? void 0 : fe.updateLocalConversation((0, I.MQ)({ conversationId: x.to, conversationType: me }), { lastMessageId: ye == null ? void 0 : ye.serverMsgId })];
                  case 3:
                    je.sent(), je.label = 4;
                  case 4:
                    return (we = x == null ? void 0 : x.success) === null || we === void 0 || we.call(x, ie), [3, 6];
                  case 5:
                    return je.sent(), (Fe = x == null ? void 0 : x.success) === null || Fe === void 0 || Fe.call(x, ie), [3, 6];
                  case 6:
                    return [2];
                }
              });
            });
          }, fail: x.fail };
          return O.kg.debug("Call recallMessage", x), this.mSync.send(ve, this);
        }
        function Ut(x) {
          var ae = x || {}, Q = ae.messageId, Z = ae.modifiedMessage;
          if (O.kg.debug("Call modifyMessage", Q, Z), Q === "") throw Error('Invalid parameter: "messageId"');
          if (Z.type !== "txt") throw Error('Invalid parameter: "modifiedMessage.type"');
          return this.mSync.send(H({ editMessageId: Q }, Z));
        }
        function st(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye;
            return B(this, function(ne) {
              switch (ne.label) {
                case 0:
                  if (typeof x.messageId != "string" || !x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
                  if (typeof x.reaction != "string" || !x.reaction) throw Error("Invalid parameter reaction: ".concat(x.reaction));
                  return (ae = c.XZ.call(this).error) ? [2, Promise.reject(ae)] : (Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.reaction, ie = x.messageId, ye = { msgId: ie, message: ve }, Ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user), type: "POST", data: JSON.stringify(ye), dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, Ye)]);
                case 1:
                  return ne.sent(), [2];
              }
            });
          });
        }
        function Ot(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye;
            return B(this, function(Ye) {
              switch (Ye.label) {
                case 0:
                  if (typeof x.reaction != "string" || !x.reaction) throw Error("Invalid parameter reactionId: ".concat(x.reaction));
                  return (ae = c.XZ.call(this).error) ? [2, Promise.reject(ae)] : (Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.messageId, ie = x.reaction, ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user, "?msgId=").concat(ve, "&message=").concat(ie), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ye)]);
                case 1:
                  return Ye.sent(), [2];
              }
            });
          });
        }
        function kt(x) {
          if (typeof x.chatType != "string" || !x.chatType) throw Error("Invalid parameter chatType: ".concat(x.chatType));
          if (!x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.chatType, ie = x.messageId, ye = { msgIdList: typeof ie == "string" ? [ie] : ie, msgType: ve === "singleChat" ? "chat" : "groupchat", groupId: x.groupId || null }, Ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user), type: "GET", data: ye, dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } };
          return m.hj.call(this, Ye).then(function(ne) {
            var Qe = ne.data;
            return Qe == null || Qe.forEach(function(W) {
              W == null || W.reactionList.forEach(function(ce) {
                ce.isAddedBySelf = ce.state, delete ce.state, delete ce.reactionId;
              });
            }), ne;
          });
        }
        var wt = kt;
        function Et(x) {
          if (typeof x.reaction != "string" || !x.reaction) throw Error("Invalid parameter reaction: ".concat(x.reaction));
          if (typeof x.messageId != "string" || !x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.cursor, ie = x.pageSize, ye = { msgId: x.messageId, message: x.reaction, currentPage: ve || null, pageSize: ie || 20 }, Ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user, "/detail"), type: "GET", data: ye, dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } };
          return m.hj.call(this, Ye).then(function(ne) {
            return ne.data.isAddedBySelf = ne.data.state, delete ne.data.state, delete ne.data.reactionId, ne;
          });
        }
        function ut(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe;
            return B(this, function(W) {
              switch (W.label) {
                case 0:
                  if (typeof x.reportType != "string" || !x.reportType) throw Error("Invalid parameter reportType: ".concat(x.reportType));
                  if (typeof x.messageId != "string" || !x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
                  if (typeof x.reportReason != "string" || !x.reportReason) throw Error("Invalid parameter messageId: ".concat(x.reportReason));
                  return (ae = c.XZ.call(this).error) ? [2, Promise.reject(ae)] : (Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.reportType, ie = x.reportReason, ye = x.messageId, Ye = { username: this.user, reportType: ve, reportReason: ie }, ne = "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/user/").concat(this.user, "/moderation/report/message/").concat(ye), Qe = { url: ne, type: "POST", data: JSON.stringify(Ye), dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, Qe)]);
                case 1:
                  return W.sent(), [2];
              }
            });
          });
        }
        function St(x) {
          var ae;
          return S(this, void 0, void 0, function() {
            var Q, Z, ge, me, ve, ie, ye, Ye, ne;
            return B(this, function(Qe) {
              switch (Qe.label) {
                case 0:
                  if (typeof x.targetId != "string" || x.targetId === "") throw Error('"Invalid parameter targetId": ' + x.targetId);
                  if (!["singleChat", "groupChat", "chatRoom"].includes(x.chatType)) throw Error('"Invalid parameter chatType": ' + x.chatType);
                  if (x.beforeTimeStamp && (typeof x.beforeTimeStamp != "number" || x.beforeTimeStamp < 0 || ((ae = x.beforeTimeStamp) === null || ae === void 0 ? void 0 : ae.toString().length) > 18)) throw Error('"Invalid parameter beforeTimeStamp": ' + x.beforeTimeStamp);
                  if (x.messageIds && !(Array.isArray(x.messageIds) && x.messageIds.length > 0 && x.messageIds.length <= 20)) throw Error('"Invalid parameter messageIds": ' + x.messageIds);
                  if (!x.messageIds && !x.beforeTimeStamp) throw Error("messageIds or beforeTimeStamp field is required.");
                  return (Q = c.XZ.call(this).error) ? [2, Promise.reject(Q)] : (Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.userId, ie = x.chatType === "singleChat" ? "userId" : "groupId", ye = x.chatType === "singleChat" ? "chat" : "group", Ye = x.messageIds ? "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/message/roaming/").concat(ye, "/user/").concat(ve, "?").concat(ie, "=").concat(x.targetId, "&msgIdList=").concat(x.messageIds, "&resource=").concat(this.clientResource) : "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/message/roaming/").concat(ye, "/user/").concat(ve, "/time?").concat(ie, "=").concat(x.targetId, "&delTime=").concat(x.beforeTimeStamp, "&&resource=").concat(this.clientResource), ne = { url: Ye, dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + this.token, "Content-Type": "application/json" } }, O.kg.debug("Call removeHistoryMessages", x), [4, m.hj.call(this, ne)]);
                case 1:
                  return Qe.sent(), [2];
              }
            });
          });
        }
        function Ft(x) {
          var ae = this, Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          if (x != null && x.pageSize && typeof x.pageSize != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          if (x != null && x.cursor && typeof x.cursor != "string") throw Error("Invalid parameter cursor: ".concat(x.cursor));
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/user/").concat(this.user, "/user_channels/list?"), type: "GET", dataType: "json", data: { limit: (x == null ? void 0 : x.pageSize) || 20, cursor: (x == null ? void 0 : x.cursor) || "", need_mark: !0 }, headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" } };
          return O.kg.debug("Call getServerConversations", x), new Promise(function(ye, Ye) {
            m.hj.call(ae, ie, N.fI.GET_SESSION_LIST).then(function(ne) {
              return S(ae, void 0, void 0, function() {
                var Qe, W, ce = this;
                return B(this, function(fe) {
                  switch (fe.label) {
                    case 0:
                      return Qe = Ht.call(this, ne), this._localCache ? (W = Qe.data.conversations.map(function(we) {
                        return S(ce, void 0, void 0, function() {
                          var Fe, je, qe, et;
                          return B(this, function(bt) {
                            switch (bt.label) {
                              case 0:
                                return [4, (je = (Fe = this._localCache) === null || Fe === void 0 ? void 0 : Fe.getInstance()) === null || je === void 0 ? void 0 : je.storeMessage(we.lastMessage, _.r.SUCCESS, !0)];
                              case 1:
                                return bt.sent(), [4, (et = (qe = this._localCache) === null || qe === void 0 ? void 0 : qe.getInstance()) === null || et === void 0 ? void 0 : et.updateLocalConversation((0, I.MQ)({ conversationId: we.conversationId, conversationType: we.conversationType }), { unReadCount: we.unReadCount })];
                              case 2:
                                return bt.sent(), [2];
                            }
                          });
                        });
                      }), [4, Promise.all(W)]) : [3, 2];
                    case 1:
                      fe.sent(), fe.label = 2;
                    case 2:
                      return ye(Qe), [2];
                  }
                });
              });
            }).catch(function(ne) {
              Ye(ne);
            });
          });
        }
        function Ht(x) {
          var ae = this, Q = x.data, Z = Q.cursor, ge = Q.channel_infos, me = [];
          ge == null || ge.forEach(function(ie) {
            var ye = null;
            ie != null && ie.meta && JSON.stringify(ie.meta) !== "{}" && (ie.meta.payload = JSON.parse(ie.meta.payload), (ye = w.w.call(ae, ie.meta)).type !== "delivery" && ye.type !== "read" && ye.type !== "channel" && (ye.chatType = w.U[ye.chatType]));
            var Ye = { conversationId: ie.session_to, conversationType: ie.session_type === "chat" ? "singleChat" : "groupChat", isPinned: ie.is_top, pinnedTime: ie.is_top ? ie.update_top_status_time : 0, unReadCount: ie.unread_num, lastMessage: ye };
            ie.marks && (Ye.marks = ie.marks.map(function(ne) {
              return E.Z[ne];
            })), me.push(Ye);
          });
          var ve = { conversations: me, cursor: Z || "" };
          return { type: x.type, data: ve };
        }
        function zt(x) {
          var ae = this, Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          if (x != null && x.pageSize && typeof x.pageSize != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          if (x != null && x.cursor && typeof x.cursor != "string") throw Error("Invalid parameter cursor: ".concat(x.cursor));
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/user/").concat(this.user, "/user_channels/list?"), type: "GET", dataType: "json", data: { limit: (x == null ? void 0 : x.pageSize) || 20, cursor: (x == null ? void 0 : x.cursor) || "", is_top: !0, need_mark: !0 }, headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" } };
          return O.kg.debug("Call getServerPinnedConversations", x), m.hj.call(this, ie, N.fI.GET_SESSION_LIST).then(function(ye) {
            return Ht.call(ae, ye);
          });
        }
        function ze(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe;
            return B(this, function(we) {
              if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
              if (Q = x.conversationId, Z = x.conversationType, ge = x.isPinned, me = Z === "singleChat" ? "chat" : "groupChat", typeof Q != "string" || Q === "") throw Error("Invalid parameter conversationId: ".concat(Q));
              if (!["singleChat", "groupChat"].includes(Z)) throw Error("Invalid parameter conversationType: ".concat(Z));
              if (typeof ge != "boolean") throw Error("Invalid parameter isPinned: ".concat(ge));
              return ve = this.context, ie = ve.orgName, ye = ve.appName, Ye = ve.accessToken, ne = ve.jid, Qe = { type: me, to: Q }, W = ge ? "" : "type=".concat(me, "&to=").concat(Q, "&"), ce = "".concat(this.apiUrl, "/").concat(ie, "/").concat(ye, "/sdk/user/").concat(this.user, "/user_channel/top?").concat(W, "resource=").concat(ne.clientResource), fe = { url: ce, type: ge ? "POST" : "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ye, "Content-Type": "application/json" } }, ge && (fe.data = JSON.stringify(Qe)), O.kg.debug("Call pinConversation", x), [2, m.hj.call(this, fe, N.fI.PIN_CONVERSATION).then(function(Fe) {
                var je = Fe.type, qe = Fe.data;
                return { type: je, data: { isPinned: qe.is_top || !1, pinnedTime: qe.is_top ? qe.update_top_status_time : 0 } };
              })];
            });
          });
        }
        function Ne(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne;
            return B(this, function(Qe) {
              switch (Qe.label) {
                case 0:
                  if (ae = x.userId, Q = x.remark, Z = c.XZ.call(this).error) return [2, Promise.reject(Z)];
                  if (typeof ae != "string" || ae === "") throw Error('Invalid parameter: "userId"');
                  if (typeof Q != "string") throw Error('Invalid parameter: "remark"');
                  return O.kg.debug("Call setContactRemark", x), ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = ge.jid, Ye = "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/users/").concat(this.context.userId, "/contacts/users/").concat(ae, "?resource=").concat(ye.clientResource), ne = { url: Ye, type: "PUT", data: JSON.stringify({ remark: Q }), dataType: "json", headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } }, [4, m.hj.call(this, ne, N.fI.ROSTER_SET_CONTACT_REMARK)];
                case 1:
                  return Qe.sent(), [2];
              }
            });
          });
        }
        function le() {
          var x = c.XZ.call(this).error;
          if (x) return Promise.reject(x);
          var ae = this.context, Q = ae.orgName, Z = ae.appName, ge = ae.accessToken, me = { url: "".concat(this.apiUrl, "/").concat(Q, "/").concat(Z, "/users/").concat(this.user, "/contacts/users?needReturnRemark=true"), dataType: "json", type: "GET", headers: { Authorization: "Bearer " + ge } };
          return O.kg.debug("Call getAllContacts"), m.hj.call(this, me, N.fI.ROSTER_GET_ALL_CONTACTS_REMARKS).then(function(ve) {
            var ie = ((ve == null ? void 0 : ve.entities) || []).map(function(ye) {
              return { userId: ye.username, remark: ye.remark };
            });
            return { type: ve.type, data: ie };
          });
        }
        function X(x) {
          var ae = c.XZ.call(this).error;
          if (ae) return Promise.reject(ae);
          O.kg.debug("Call getContactsWithCursor", x);
          var Q = x || {}, Z = Q.pageSize, ge = Z === void 0 ? 20 : Z, me = Q.cursor, ve = me === void 0 ? "" : me;
          if (ge && typeof ge != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          var ie = this.context, ye = ie.orgName, Ye = ie.appName, ne = ie.accessToken, Qe = { url: "".concat(this.apiUrl, "/").concat(ye, "/").concat(Ye, "/users/").concat(this.user, "/contacts?needReturnRemark=true&limit=").concat(ge, "&cursor=").concat(ve), dataType: "json", type: "GET", headers: { Authorization: "Bearer " + ne } };
          return m.hj.call(this, Qe, N.fI.ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE).then(function(W) {
            var ce, fe, we = ((ce = W == null ? void 0 : W.data) === null || ce === void 0 ? void 0 : ce.contacts) || [], Fe = ((fe = W == null ? void 0 : W.data) === null || fe === void 0 ? void 0 : fe.cursor) || "", je = we.map(function(qe) {
              return { userId: qe.username, remark: qe.remark };
            });
            return { type: W.type, data: { cursor: Fe, contacts: je } };
          });
        }
        function re(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we;
            return B(this, function(Fe) {
              switch (Fe.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (O.kg.debug("Call markConversation", x), Z = (Q = x || {}).conversations, ge = Z === void 0 ? [] : Z, me = Q.mark, ve = Q.isMarked, !Array.isArray(ge)) throw Error("Invalid parameter conversations");
                  if (ie = ge.map(function(je) {
                    if (!je.conversationId || !["singleChat", "groupChat"].includes(je.conversationType)) throw Error("Invalid parameter conversations");
                    return { to: je.conversationId, type: D[je.conversationType] };
                  }), typeof ve != "boolean") throw Error("Invalid parameter isMarked: ".concat(ve));
                  if (typeof me != "number") throw Error("Invalid parameter mark: ".concat(me));
                  return ye = this.context, Ye = ye.orgName, ne = ye.appName, Qe = ye.accessToken, W = ye.userId, ce = ye.jid, fe = { mark: E.Z[me], targets: ie }, we = { url: "".concat(this.apiUrl, "/").concat(Ye, "/").concat(ne, "/sdk/user/").concat(W, "/user_channels/mark?resource=").concat(ce.clientResource), dataType: "json", data: JSON.stringify(fe), type: ve ? "Post" : "Delete", headers: { Authorization: "Bearer " + Qe } }, [4, m.hj.call(this, we, N.fI.MARK_CONVERSATION).then(function(je) {
                    var qe, et = ((qe = je.data) === null || qe === void 0 ? void 0 : qe.ignore) || [];
                    Array.isArray(et) && et.length > 0 && O.kg.debug("markConversation has ignored conversations", et.map(function(bt) {
                      return { conversationId: bt.to, conversationType: w.U[bt.type] };
                    }));
                  })];
                case 1:
                  return Fe.sent(), [2];
              }
            });
          });
        }
        function Me(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q;
            return B(this, function(Z) {
              return O.kg.debug("Call addConversationMark", x), ae = x.conversations, Q = x.mark, [2, re.call(this, { conversations: ae, mark: Q, isMarked: !0 })];
            });
          });
        }
        function Se(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q;
            return B(this, function(Z) {
              return O.kg.debug("Call removeConversationMark", x), ae = x.conversations, Q = x.mark, [2, re.call(this, { conversations: ae, mark: Q, isMarked: !1 })];
            });
          });
        }
        function ke(x) {
          var ae, Q, Z = this, ge = c.XZ.call(this).error;
          if (ge) return Promise.reject(ge);
          if (O.kg.debug("Call getServerConversationsByFilter", x), (x == null ? void 0 : x.pageSize) && typeof x.pageSize != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          if (x != null && x.cursor && typeof x.cursor != "string") throw Error("Invalid parameter cursor: ".concat(x.cursor));
          if (typeof ((ae = x == null ? void 0 : x.filter) === null || ae === void 0 ? void 0 : ae.mark) != "number") throw Error("Invalid parameter mark: ".concat((Q = x == null ? void 0 : x.filter) === null || Q === void 0 ? void 0 : Q.mark));
          var me = this.context, ve = me.orgName, ie = me.appName, ye = me.accessToken, Ye = "".concat(this.apiUrl, "/").concat(ve, "/").concat(ie, "/sdk/user/").concat(this.user, "/user_channels/mark/search?"), ne = x.pageSize, Qe = x.cursor, W = ((x == null ? void 0 : x.filter) || {}).mark, ce = { url: Ye, type: "GET", dataType: "json", data: { limit: ne || 10, cursor: Qe || "", need_mark: !0, mark: E.Z[W] }, headers: { Authorization: "Bearer " + ye, "Content-Type": "application/json" } };
          return m.hj.call(this, ce, N.fI.GET_SESSION_LIST).then(function(fe) {
            return Ht.call(Z, fe);
          });
        }
        function Ge() {
          var x = c.XZ.call(this).error;
          if (x) return Promise.reject(x);
          O.kg.debug("Call getSelfIdsOnOtherPlatform");
          var ae = this.context, Q = ae.orgName, Z = ae.appName, ge = ae.accessToken, me = ae.userId, ve = ae.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Q, "/").concat(Z, "/users/").concat(me, "/resources"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + ge, "Content-Type": "application/json" } };
          return m.hj.call(this, ie, N.fI.USER_LOGGEDIN_OTHER_PLATFORM).then(function(ye) {
            var Ye, ne = (Ye = ye.data) === null || Ye === void 0 ? void 0 : Ye.filter(function(W) {
              return W.res !== ve.clientResource;
            }), Qe = ne == null ? void 0 : ne.map(function(W) {
              return "".concat(me, "/").concat(W.res);
            });
            return { type: ye.type, data: Qe };
          });
        }
        function nt() {
          var x, ae, Q, Z, ge, me;
          return S(this, void 0, void 0, function() {
            var ve, ie, ye, Ye, ne, Qe, W, ce, fe;
            return B(this, function(we) {
              switch (we.label) {
                case 0:
                  return (ve = c.XZ.call(this).error) ? [2, Promise.reject(ve)] : (O.kg.debug("Call deleteAllMessagesAndConversations"), ie = this.context, ye = ie.orgName, Ye = ie.appName, ne = ie.accessToken, Qe = ie.userId, W = ie.jid, ce = "".concat(this.apiUrl, "/").concat(ye, "/").concat(Ye, "/sdk/message/roaming/user/").concat(Qe, "/delete/all?resource=").concat(W.clientResource), fe = { url: ce, type: "POST", dataType: "json", headers: { Authorization: "Bearer " + ne, "Content-Type": "application/json" } }, [4, m.hj.call(this, fe, N.fI.REST_DELETE_MESSAGES_CONVERSATIONS)]);
                case 1:
                  return we.sent(), (ae = (x = this._localCache) === null || x === void 0 ? void 0 : x.getInstance()) === null || ae === void 0 || ae.clearConversationMap(), [4, (Z = (Q = this._localCache) === null || Q === void 0 ? void 0 : Q.getInstance()) === null || Z === void 0 ? void 0 : Z.clearStoreData("conversationList")];
                case 2:
                  return we.sent(), [4, (me = (ge = this._localCache) === null || ge === void 0 ? void 0 : ge.getInstance()) === null || me === void 0 ? void 0 : me.clearStoreData("message")];
                case 3:
                  return we.sent(), [2];
              }
            });
          });
        }
        function rt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we;
            return B(this, function(Fe) {
              switch (Fe.label) {
                case 0:
                  if (ae = c.XZ.call(this).error) return [2, Promise.reject(ae)];
                  if (O.kg.debug("Call setMessagePinStatus", x), Z = (Q = x || {}).conversationId, ge = Z === void 0 ? "" : Z, me = Q.conversationType, ve = Q.messageId, ie = Q.isPinned, typeof ge != "string" || ge === "") throw Error("Invalid parameter conversationId");
                  if (typeof ve != "string" || ve === "") throw Error("Invalid parameter messageId");
                  if (typeof ie != "boolean") throw Error("Invalid parameter isPinned");
                  return ye = this.context, Ye = ye.orgName, ne = ye.appName, Qe = ye.accessToken, W = ye.userId, ce = ye.jid, fe = { to: ge, type: D[me], pin_msg_id: ve }, we = { url: "".concat(this.apiUrl, "/").concat(Ye, "/").concat(ne, "/sdk/user/").concat(W, "/user_channel/pin?resource=").concat(ce.clientResource), dataType: "json", data: JSON.stringify(fe), type: ie ? "Post" : "Delete", headers: { Authorization: "Bearer " + Qe } }, [4, m.hj.call(this, we, N.fI.REST_PIN_MESSAGE)];
                case 1:
                  return Fe.sent(), [2];
              }
            });
          });
        }
        function dt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge;
            return B(this, function(me) {
              return O.kg.debug("Call pinMessage", x), Q = (ae = x || {}).conversationType, Z = ae.conversationId, ge = ae.messageId, [2, rt.call(this, { conversationId: Z, conversationType: Q, messageId: ge, isPinned: !0 })];
            });
          });
        }
        function lt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge;
            return B(this, function(me) {
              return O.kg.debug("Call unpinMessage", x), Q = (ae = x || {}).conversationType, Z = ae.conversationId, ge = ae.messageId, [2, rt.call(this, { conversationId: Z, conversationType: Q, messageId: ge, isPinned: !1 })];
            });
          });
        }
        function Ct(x) {
          var ae = this, Q = c.XZ.call(this).error;
          if (Q) return Promise.reject(Q);
          O.kg.debug("Call getServerPinnedMessages", x);
          var Z = x.conversationId, ge = x.conversationType, me = x.pageSize, ve = x.cursor;
          if (typeof Z != "string" || Z === "") throw Error("Invalid parameter conversationId");
          if (me && typeof me != "number") throw Error("Invalid parameter pageSize: ".concat(me));
          if (ve && typeof ve != "string") throw Error("Invalid parameter cursor: ".concat(ve));
          var ie = this.context, ye = ie.orgName, Ye = ie.appName, ne = ie.accessToken, Qe = { url: "".concat(this.apiUrl, "/").concat(ye, "/").concat(Ye, "/sdk/user/").concat(this.user, "/user_channel/pin"), type: "GET", dataType: "json", data: { to: Z, type: D[ge], limit: me || 10, cursor: ve || "" }, headers: { Authorization: "Bearer " + ne, "Content-Type": "application/json" } };
          return m.hj.call(this, Qe, N.fI.GET_SESSION_LIST).then(function(W) {
            return { type: 0, data: { list: W.data.msg_infos.map(function(ce) {
              ce.message.payload = JSON.parse(ce.message.payload);
              var fe = ce.message, we = ce.pin_opt_at, Fe = ce.pin_operator;
              return { message: w.w.call(ae, fe, { formatChatType: !0 }), pinTime: we, operatorId: Fe };
            }), cursor: W.data.cursor || "" } };
          });
        }
        function Ie() {
          var x = this;
          O.kg.debug("Call unbindPushToken");
          var ae = { deviceId: this.clientResource, deviceToken: "", notifierName: this.pushCertificateName };
          return k.r.call(this, ae).then(function(Q) {
            return x.isRegisterPush = !1, Q;
          });
        }
      }, 3770: function(l, v, s) {
        s.r(v), s.d(v, { getPresenceStatus: function() {
          return w;
        }, getSubscribedPresenceList: function() {
          return O;
        }, getSubscribedPresencelist: function() {
          return N;
        }, publishPresence: function() {
          return y;
        }, subscribePresence: function() {
          return g;
        }, unsubscribePresence: function() {
          return C;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(2222), s(9753);
        var c = s(4024), d = s(3246), p = s(7360), m = function(_, I, k, H) {
          return new (k || (k = Promise))(function(S, B) {
            function D(G) {
              try {
                j(H.next(G));
              } catch (U) {
                B(U);
              }
            }
            function F(G) {
              try {
                j(H.throw(G));
              } catch (U) {
                B(U);
              }
            }
            function j(G) {
              var U;
              G.done ? S(G.value) : (U = G.value, U instanceof k ? U : new k(function(M) {
                M(U);
              })).then(D, F);
            }
            j((H = H.apply(_, [])).next());
          });
        }, E = function(_, I) {
          var k, H, S, B, D = { label: 0, sent: function() {
            if (1 & S[0]) throw S[1];
            return S[1];
          }, trys: [], ops: [] };
          return B = { next: F(0), throw: F(1), return: F(2) }, typeof Symbol == "function" && (B[Symbol.iterator] = function() {
            return this;
          }), B;
          function F(j) {
            return function(G) {
              return function(U) {
                if (k) throw new TypeError("Generator is already executing.");
                for (; D; ) try {
                  if (k = 1, H && (S = 2 & U[0] ? H.return : U[0] ? H.throw || ((S = H.return) && S.call(H), 0) : H.next) && !(S = S.call(H, U[1])).done) return S;
                  switch (H = 0, S && (U = [2 & U[0], S.value]), U[0]) {
                    case 0:
                    case 1:
                      S = U;
                      break;
                    case 4:
                      return D.label++, { value: U[1], done: !1 };
                    case 5:
                      D.label++, H = U[1], U = [0];
                      continue;
                    case 7:
                      U = D.ops.pop(), D.trys.pop();
                      continue;
                    default:
                      if (!((S = (S = D.trys).length > 0 && S[S.length - 1]) || U[0] !== 6 && U[0] !== 2)) {
                        D = 0;
                        continue;
                      }
                      if (U[0] === 3 && (!S || U[1] > S[0] && U[1] < S[3])) {
                        D.label = U[1];
                        break;
                      }
                      if (U[0] === 6 && D.label < S[1]) {
                        D.label = S[1], S = U;
                        break;
                      }
                      if (S && D.label < S[2]) {
                        D.label = S[2], D.ops.push(U);
                        break;
                      }
                      S[2] && D.ops.pop(), D.trys.pop();
                      continue;
                  }
                  U = I.call(_, D);
                } catch (M) {
                  U = [6, M], H = 0;
                } finally {
                  k = S = 0;
                }
                if (5 & U[0]) throw U[1];
                return { value: U[0] ? U[1] : void 0, done: !0 };
              }([j, G]);
            };
          }
        };
        function y(_) {
          return m(this, void 0, void 0, function() {
            var I, k, H, S, B, D, F, j, G;
            return E(this, function(U) {
              switch (U.label) {
                case 0:
                  if (typeof _.description != "string") throw Error('Invalid parameter: "description"');
                  return (I = d.XZ.call(this).error) ? [2, Promise.reject(I)] : (k = this.context, H = k.accessToken, S = k.orgName, B = k.appName, D = k.userId, F = this.context.jid.clientResource, j = { ext: _.description }, G = { url: "".concat(this.apiUrl, "/").concat(S, "/").concat(B, "/users/").concat(D, "/presence/").concat(F, "/1"), type: "POST", dataType: "json", data: JSON.stringify(j), headers: { Authorization: "Bearer " + H, "Content-Type": "application/json" }, success: _.success, error: _.error }, p.kg.debug("Call publishPresence:", _), [4, c.hj.call(this, G)]);
                case 1:
                  return U.sent(), [2];
              }
            });
          });
        }
        function g(_) {
          if (!Array.isArray(_.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!_.usernames.length) throw Error('"usernames" can not be empty');
          if (typeof _.expiry != "number") throw Error('Invalid parameter: "expiry"');
          var I = d.XZ.call(this).error;
          if (I) return Promise.reject(I);
          var k = this.context, H = k.orgName, S = k.appName, B = k.userId, D = k.accessToken, F = { usernames: _.usernames }, j = { url: "".concat(this.apiUrl, "/").concat(H, "/").concat(S, "/users/").concat(B, "/presence/").concat(_.expiry), type: "POST", dataType: "json", data: JSON.stringify(F), headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: _.success, error: _.error };
          return p.kg.debug("Call subscribePresence:", _), c.hj.call(this, j).then(function(G) {
            return G.data = { result: G == null ? void 0 : G.result }, G;
          });
        }
        function C(_) {
          return m(this, void 0, void 0, function() {
            var I, k, H, S, B, D, F;
            return E(this, function(j) {
              switch (j.label) {
                case 0:
                  if (!Array.isArray(_.usernames)) throw Error('Invalid parameter: "usernames"');
                  if (!_.usernames.length) throw Error('"usernames" can not be empty');
                  return (I = d.XZ.call(this).error) ? [2, Promise.reject(I)] : (k = this.context, H = k.orgName, S = k.appName, B = k.userId, D = k.accessToken, F = { url: "".concat(this.apiUrl, "/").concat(H, "/").concat(S, "/users/").concat(B, "/presence"), type: "DELETE", dataType: "json", data: JSON.stringify(_.usernames), headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: _.success, error: _.error }, p.kg.debug("Call unsubscribePresence:", _), [4, c.hj.call(this, F)]);
                case 1:
                  return j.sent(), [2];
              }
            });
          });
        }
        function O(_) {
          if (typeof _.pageNum != "number" || typeof _.pageSize != "number") throw Error('Invalid parameter: "pageNum or pageSize"');
          if (_.pageNum < 0 || _.pageSize < 0) throw Error('"pageNum" should >= 0 and "pageSize" should >= 0');
          var I = d.XZ.call(this).error;
          if (I) return Promise.reject(I);
          var k = this.context, H = k.orgName, S = k.appName, B = k.userId, D = k.accessToken, F = { url: "".concat(this.apiUrl, "/").concat(H, "/").concat(S, "/users/").concat(B, "/presence/sublist?pageNum=").concat(_.pageNum, "&pageSize=").concat(_.pageSize), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: _.success, error: _.error };
          return p.kg.debug("Call getSubscribedPresenceList:", _), c.hj.call(this, F).then(function(j) {
            return j.data = { result: j == null ? void 0 : j.result }, j;
          });
        }
        var N = O;
        function w(_) {
          if (!Array.isArray(_.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!_.usernames.length) throw Error('"usernames" can not be empty');
          var I = d.XZ.call(this).error;
          if (I) return Promise.reject(I);
          var k = { usernames: _.usernames }, H = this.context, S = H.orgName, B = H.appName, D = H.userId, F = H.accessToken, j = { url: "".concat(this.apiUrl, "/").concat(S, "/").concat(B, "/users/").concat(D, "/presence"), type: "POST", dataType: "json", data: JSON.stringify(k), headers: { Authorization: "Bearer " + F, "Content-Type": "application/json" }, success: _.success, error: _.error };
          return p.kg.debug("Call getPresenceStatus:", _), c.hj.call(this, j).then(function(G) {
            return G.data = { result: G == null ? void 0 : G.result }, G;
          });
        }
      }, 6801: function(l, v, s) {
        s.d(v, { r: function() {
          return E;
        } }), s(1539), s(8674), s(2222), s(4812);
        var c = s(3246), d = s(4024), p = s(7360), m = s(1595);
        function E(y) {
          if (typeof y.deviceId != "string" || y.deviceId === "") throw Error('Invalid parameter: "deviceId"');
          var g = c.XZ.call(this).error;
          if (g) return Promise.reject(g);
          var C = this.context, O = C.orgName, N = C.appName, w = C.accessToken, _ = { url: "".concat(this.apiUrl, "/").concat(O, "/").concat(N, "/users/").concat(this.user), type: "PUT", data: JSON.stringify({ device_id: y.deviceId, device_token: y.deviceToken, notifier_name: y.notifierName }), dataType: "json", headers: { Authorization: "Bearer " + w, "Content-Type": "application/json" }, success: y.success, error: y.error };
          p.kg.debug("Call uploadPushTokenToServer", y);
          var I = d.hj.bind(this, _, m.fI.UPLOAD_PUSH_TOKEN);
          return d.P6.retryPromise(I).then(function(k) {
            var H = k.entities[0] || {};
            return { type: k.type, data: H };
          });
        }
      }, 1735: function(l, v, s) {
        s.r(v), s.d(v, { clearRemindTypeForConversation: function() {
          return g;
        }, getPushPerformLanguage: function() {
          return w;
        }, getSilentModeForAll: function() {
          return E;
        }, getSilentModeForConversation: function() {
          return C;
        }, getSilentModeForConversations: function() {
          return O;
        }, getSilentModeRemindTypeConversations: function() {
          return _;
        }, setPushPerformLanguage: function() {
          return N;
        }, setSilentModeForAll: function() {
          return m;
        }, setSilentModeForConversation: function() {
          return y;
        } }), s(7941), s(1539), s(8674), s(2222), s(9753), s(9554), s(4747), s(9600), s(1249);
        var c = s(4024), d = s(3246), p = s(7360);
        function m(I) {
          if (!(I.options instanceof Object)) throw Error('Invalid parameter: "options"');
          var k = I.options.paramType;
          if (typeof k != "number" || k < 0 || k > 2) throw Error('Invalid parameter: "options of paramType"');
          if (k === 0) {
            if (typeof I.options.remindType != "string") throw Error('Invalid parameter: "options of remindType"');
          } else if (k === 1) {
            if (typeof I.options.duration != "number") throw Error('Invalid parameter: "options of duration"');
          } else if (k === 2) {
            var H = I.options, S = H.startTime, B = H.endTime;
            if (!(S instanceof Object && Object.keys(S).length)) throw Error('Invalid parameter: "options of startTime"');
            if (!S.hours || typeof S.hours != "number" || !S.minutes || typeof S.minutes != "number") throw Error('Invalid parameter: "options of startTime of hours or minutes"');
            if (!(B instanceof Object && Object.keys(B).length)) throw Error('Invalid parameter: "options of endTime"');
            if (!B.hours || typeof B.hours != "number" || !B.minutes || typeof B.minutes != "number") throw Error('Invalid parameter: "options of endTime of hours or minutes"');
          }
          var D = d.XZ.call(this).error;
          if (D) return Promise.reject(D);
          var F = this.context, j = F.accessToken, G = F.orgName, U = F.appName, M = F.userId, V = F.jid, J = {};
          switch (k) {
            case 0:
              J = { type: I.options.remindType };
              break;
            case 1:
              J = { ignoreDuration: I.options.duration };
              break;
            case 2:
              var ue = I.options;
              S = ue.startTime, B = ue.endTime, J = { ignoreInterval: "".concat(S.hours, ":").concat(S.minutes, "-").concat(B.hours, ":").concat(B.minutes) };
          }
          var se = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/users/").concat(M, "/notification/user/").concat(M, "?resource=").concat(V.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(J), headers: { Authorization: "Bearer " + j, "Content-Type": "application/json" }, success: I.success, error: I.error };
          return p.kg.debug("Call setSilentModeForAll:", I), c.hj.call(this, se);
        }
        function E(I) {
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          var H = this.context, S = H.accessToken, B = H.orgName, D = H.appName, F = H.userId, j = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/notification/user/").concat(F), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + S, "Content-Type": "application/json" }, success: I == null ? void 0 : I.success, error: I == null ? void 0 : I.error };
          return p.kg.debug("Call getSilentModeForAll:", I), c.hj.call(this, j);
        }
        function y(I) {
          if (typeof I.conversationId != "string" || !I.conversationId) throw Error('Invalid parameter: "conversationId"');
          if (typeof I.type != "string" || !I.type) throw Error('Invalid parameter: "type"');
          if (!(I.options instanceof Object)) throw Error('Invalid parameter: "options"');
          var k = I.options.paramType;
          if (typeof k != "number" || k < 0 || k > 2) throw Error('Invalid parameter: "options of paramType"');
          if (k === 0) {
            if (typeof I.options.remindType != "string") throw Error('Invalid parameter: "options of remindType"');
          } else if (k === 1) {
            if (typeof I.options.duration != "number") throw Error('Invalid parameter: "options of duration"');
          } else if (k === 2) {
            var H = I.options, S = H.startTime, B = H.endTime;
            if (!(S instanceof Object && Object.keys(S).length)) throw Error('Invalid parameter: "options of startTime"');
            if (!S.hours || typeof S.hours != "number" || !S.minutes || typeof S.minutes != "number") throw Error('Invalid parameter: "options of startTime of hours or minutes"');
            if (!(B instanceof Object && Object.keys(B).length)) throw Error('Invalid parameter: "options of endTime"');
            if (!B.hours || typeof B.hours != "number" || !B.minutes || typeof B.minutes != "number") throw Error('Invalid parameter: "options of endTime of hours or minutes"');
          }
          var D = d.XZ.call(this).error;
          if (D) return Promise.reject(D);
          var F = this.context, j = F.accessToken, G = F.orgName, U = F.appName, M = F.userId, V = F.jid, J = "chatgroup", ue = {};
          switch (k) {
            case 0:
              ue = { type: I.options.remindType };
              break;
            case 1:
              ue = { ignoreDuration: I.options.duration };
              break;
            case 2:
              var se = I.options;
              S = se.startTime, B = se.endTime, ue = { ignoreInterval: "".concat(S.hours, ":").concat(S.minutes, "-").concat(B.hours, ":").concat(B.minutes) };
          }
          I.type === "singleChat" && (J = "user");
          var ee = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/users/").concat(M, "/notification/").concat(J, "/").concat(I.conversationId, "?resource=").concat(V.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(ue), headers: { Authorization: "Bearer " + j, "Content-Type": "application/json" }, success: I.success, error: I.error };
          return p.kg.debug("Call setSilentModeForConversation:", I), c.hj.call(this, ee);
        }
        function g(I) {
          if (typeof I.conversationId != "string" || !I.conversationId) throw Error('Invalid parameter: "conversationId"');
          if (typeof I.type != "string" || !I.type) throw Error('Invalid parameter: "type"');
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          var H = this.context, S = H.accessToken, B = H.orgName, D = H.appName, F = H.userId, j = H.jid, G = "chatgroup";
          I.type === "singleChat" && (G = "user");
          var U = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/notification/").concat(G, "/").concat(I.conversationId, "?resource=").concat(j.clientResource), type: "PUT", dataType: "json", data: JSON.stringify({ type: "DEFAULT" }), headers: { Authorization: "Bearer " + S, "Content-Type": "application/json" }, success: I.success, error: I.error };
          return p.kg.debug("Call clearRemindTypeForConversation:", I), c.hj.call(this, U);
        }
        function C(I) {
          if (typeof I.conversationId != "string" || !I.conversationId) throw Error('Invalid parameter: "conversationId"');
          if (typeof I.type != "string" || !I.type) throw Error('Invalid parameter: "type"');
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          var H = this.context, S = H.accessToken, B = H.orgName, D = H.appName, F = H.userId, j = "chatgroup";
          I.type === "singleChat" && (j = "user");
          var G = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/notification/").concat(j, "/").concat(I.conversationId), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + S, "Content-Type": "application/json" }, success: I.success, error: I.error };
          return p.kg.debug("Call getSilentModeForConversation:", I), c.hj.call(this, G);
        }
        function O(I) {
          if (!Array.isArray(I.conversationList)) throw Error('Invalid parameter: "conversationList"');
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          var H = this.context, S = H.accessToken, B = H.orgName, D = H.appName, F = H.userId, j = [], G = [];
          I.conversationList.forEach(function(J) {
            J.type === "singleChat" ? j.push(J.id) : G.push(J.id);
          });
          var U = j.length ? j.join(",") : "", M = G.length ? G.join(",") : "", V = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/notification?user=").concat(U, "&group=").concat(M), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + S, "Content-Type": "application/json" }, success: I.success, error: I.error };
          return p.kg.debug("Call getSilentModeForConversations:", I), c.hj.call(this, V);
        }
        function N(I) {
          if (typeof I.language != "string" || !I.language) throw Error('Invalid parameter: "language"');
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          var H = { translationLanguage: I.language }, S = this.context, B = S.accessToken, D = S.orgName, F = S.appName, j = S.userId, G = { url: "".concat(this.apiUrl, "/").concat(D, "/").concat(F, "/users/").concat(j, "/notification/language"), type: "PUT", dataType: "json", data: JSON.stringify(H), headers: { Authorization: "Bearer " + B, "Content-Type": "application/json" }, success: I.success, error: I.error };
          return p.kg.debug("Call setPushPerformLanguage:", I), c.hj.call(this, G);
        }
        function w(I) {
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          var H = this.context, S = H.accessToken, B = H.orgName, D = H.appName, F = H.userId, j = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/notification/language"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + S, "Content-Type": "application/json" }, success: I == null ? void 0 : I.success, error: I == null ? void 0 : I.error };
          return p.kg.debug("Call getPushPerformLanguage:", I), c.hj.call(this, j);
        }
        function _(I) {
          var k = d.XZ.call(this).error;
          if (k) return Promise.reject(k);
          if (typeof I.pageSize != "number") throw Error('Invalid parameter: "pageSize"');
          var H = this.context, S = H.accessToken, B = H.orgName, D = H.appName, F = H.userId, j = { limit: I.pageSize || 10, cursor: I.cursor };
          I.cursor || delete j.cursor;
          var G = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/notification/mute/type"), type: "GET", dataType: "json", data: j, headers: { Authorization: "Bearer " + S, "Content-Type": "application/json" } };
          return p.kg.debug("Call getSilentModeRemindTypeConversations:", I), c.hj.call(this, G).then(function(U) {
            return U.data ? { data: { conversations: U.data.map(function(M) {
              return "user" in M ? { conversationId: M.user, type: "singleChat", remindType: M.value } : { conversationId: M.group, type: "groupChat", remindType: M.value };
            }), cursor: U.cursor }, type: U.type } : U;
          });
        }
      }, 7384: function(l, v, s) {
        s.r(v), s.d(v, { changeChatThreadName: function() {
          return N;
        }, createChatThread: function() {
          return y;
        }, destroyChatThread: function() {
          return O;
        }, getChatThreadDetail: function() {
          return B;
        }, getChatThreadLastMessage: function() {
          return H;
        }, getChatThreadMembers: function() {
          return w;
        }, getChatThreads: function() {
          return k;
        }, getJoinedChatThreads: function() {
          return I;
        }, joinChatThread: function() {
          return g;
        }, leaveChatThread: function() {
          return C;
        }, removeChatThreadMember: function() {
          return _;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(8309), s(2222), s(9554), s(4747), s(9753);
        var c = s(4024), d = s(3246), p = s(4363), m = function(D, F, j, G) {
          return new (j || (j = Promise))(function(U, M) {
            function V(se) {
              try {
                ue(G.next(se));
              } catch (ee) {
                M(ee);
              }
            }
            function J(se) {
              try {
                ue(G.throw(se));
              } catch (ee) {
                M(ee);
              }
            }
            function ue(se) {
              var ee;
              se.done ? U(se.value) : (ee = se.value, ee instanceof j ? ee : new j(function(de) {
                de(ee);
              })).then(V, J);
            }
            ue((G = G.apply(D, [])).next());
          });
        }, E = function(D, F) {
          var j, G, U, M, V = { label: 0, sent: function() {
            if (1 & U[0]) throw U[1];
            return U[1];
          }, trys: [], ops: [] };
          return M = { next: J(0), throw: J(1), return: J(2) }, typeof Symbol == "function" && (M[Symbol.iterator] = function() {
            return this;
          }), M;
          function J(ue) {
            return function(se) {
              return function(ee) {
                if (j) throw new TypeError("Generator is already executing.");
                for (; V; ) try {
                  if (j = 1, G && (U = 2 & ee[0] ? G.return : ee[0] ? G.throw || ((U = G.return) && U.call(G), 0) : G.next) && !(U = U.call(G, ee[1])).done) return U;
                  switch (G = 0, U && (ee = [2 & ee[0], U.value]), ee[0]) {
                    case 0:
                    case 1:
                      U = ee;
                      break;
                    case 4:
                      return V.label++, { value: ee[1], done: !1 };
                    case 5:
                      V.label++, G = ee[1], ee = [0];
                      continue;
                    case 7:
                      ee = V.ops.pop(), V.trys.pop();
                      continue;
                    default:
                      if (!((U = (U = V.trys).length > 0 && U[U.length - 1]) || ee[0] !== 6 && ee[0] !== 2)) {
                        V = 0;
                        continue;
                      }
                      if (ee[0] === 3 && (!U || ee[1] > U[0] && ee[1] < U[3])) {
                        V.label = ee[1];
                        break;
                      }
                      if (ee[0] === 6 && V.label < U[1]) {
                        V.label = U[1], U = ee;
                        break;
                      }
                      if (U && V.label < U[2]) {
                        V.label = U[2], V.ops.push(ee);
                        break;
                      }
                      U[2] && V.ops.pop(), V.trys.pop();
                      continue;
                  }
                  ee = F.call(D, V);
                } catch (de) {
                  ee = [6, de], G = 0;
                } finally {
                  j = U = 0;
                }
                if (5 & ee[0]) throw ee[1];
                return { value: ee[0] ? ee[1] : void 0, done: !0 };
              }([ue, se]);
            };
          }
        };
        function y(D) {
          if (typeof D.name != "string" || D.name === "") throw Error("Invalid parameter name: ".concat(D.name));
          if (typeof D.messageId != "string" || D.messageId === "") throw Error("Invalid parameter messageId: ".concat(D.messageId));
          if (typeof D.parentId != "string" || D.parentId === "") throw Error("Invalid parameter parentId: ".concat(D.parentId));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = j.jid, J = { name: D.name, msg_id: D.messageId, group_id: D.parentId, owner: this.user }, ue = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread?resource=").concat(V.clientResource), type: "POST", dataType: "json", data: JSON.stringify(J), headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, ue).then(function(se) {
            var ee = se.data.thread_id;
            return se.data = { chatThreadId: ee }, se;
          });
        }
        function g(D) {
          if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = j.jid, J = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId, "/user/").concat(this.user, "/join?resource=").concat(V.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, J).then(function(ue) {
            var se = ue.data.detail;
            return se.messageId = se.msgId, se.parentId = se.groupId, delete se.msgId, delete se.groupId, ue;
          });
        }
        function C(D) {
          return m(this, void 0, void 0, function() {
            var F, j, G, U, M, V, J;
            return E(this, function(ue) {
              switch (ue.label) {
                case 0:
                  if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
                  return (F = d.XZ.call(this).error) ? [2, Promise.reject(F)] : (j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = j.jid, J = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId, "/user/").concat(this.user, "/quit?resource=").concat(V.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } }, [4, c.hj.call(this, J)]);
                case 1:
                  return ue.sent(), [2];
              }
            });
          });
        }
        function O(D) {
          return m(this, void 0, void 0, function() {
            var F, j, G, U, M, V, J;
            return E(this, function(ue) {
              switch (ue.label) {
                case 0:
                  if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
                  return (F = d.XZ.call(this).error) ? [2, Promise.reject(F)] : (j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = j.jid, J = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId, "?resource=").concat(V.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } }, [4, c.hj.call(this, J)]);
                case 1:
                  return ue.sent(), [2];
              }
            });
          });
        }
        function N(D) {
          if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
          if (typeof D.name != "string" || D.name === "") throw Error("Invalid parameter name: ".concat(D.name));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = j.jid, J = { name: D.name }, ue = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId, "?resource=").concat(V.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(J), headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, ue);
        }
        function w(D) {
          if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = { limit: D.pageSize || 20, cursor: D.cursor || "" }, J = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId, "/users"), type: "GET", dataType: "json", data: V, headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, J);
        }
        function _(D) {
          if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
          if (typeof D.username != "string" || D.username === "") throw Error("Invalid parameter username: ".concat(D.username));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = j.jid, J = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId, "/users/").concat(D.username, "?resource=").concat(V.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, J);
        }
        function I(D) {
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = { limit: D.pageSize || 20, cursor: D.cursor || "" }, J = { url: D.parentId ? "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/threads/chatgroups/").concat(D.parentId, "/user/").concat(this.user) : "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/threads/user/").concat(this.user), type: "GET", dataType: "json", data: V, headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, J).then(function(ue) {
            var se = ue.entities;
            return se == null || se.forEach(function(ee) {
              ee.parentId = ee.groupId, ee.messageId = ee.msgId, delete ee.groupId, delete ee.msgId;
            }), ue;
          });
        }
        function k(D) {
          if (typeof D.parentId != "string" || D.parentId === "") throw Error("Invalid parameter parentId: ".concat(D.parentId));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = { cursor: D.cursor || "", limit: D.pageSize || 20 }, J = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/threads/chatgroups/").concat(D.parentId), type: "GET", dataType: "json", data: V, headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, J).then(function(ue) {
            var se = ue.entities;
            return se == null || se.forEach(function(ee) {
              ee.parentId = ee.groupId, ee.messageId = ee.msgId, delete ee.groupId, delete ee.msgId;
            }), ue;
          });
        }
        function H(D) {
          var F = this;
          if (!Array.isArray(D.chatThreadIds)) throw Error("Invalid parameter chatThreadIds: ".concat(D.chatThreadIds));
          var j = d.XZ.call(this).error;
          if (j) return Promise.reject(j);
          var G = this.context, U = G.orgName, M = G.appName, V = G.accessToken, J = { threadIds: D.chatThreadIds }, ue = { url: "".concat(this.apiUrl, "/").concat(U, "/").concat(M, "/thread/message"), type: "POST", dataType: "json", data: JSON.stringify(J), headers: { Authorization: "Bearer " + V, "Content-Type": "application/json" } };
          return c.hj.call(this, ue).then(function(se) {
            return S.call(F, se);
          });
        }
        function S(D) {
          var F = this, j = D.entities;
          return j == null || j.forEach(function(G) {
            G.chatThreadId = G.thread_id, G.last_message && JSON.stringify(G.last_message) !== "{}" ? G.lastMessage = p.w.call(F, G.last_message) : G.lastMessage = G.last_message, delete G.thread_id, delete G.last_message;
          }), D;
        }
        function B(D) {
          if (typeof D.chatThreadId != "string" || D.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(D.chatThreadId));
          var F = d.XZ.call(this).error;
          if (F) return Promise.reject(F);
          var j = this.context, G = j.orgName, U = j.appName, M = j.accessToken, V = { url: "".concat(this.apiUrl, "/").concat(G, "/").concat(U, "/thread/").concat(D.chatThreadId), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + M, "Content-Type": "application/json" } };
          return c.hj.call(this, V).then(function(J) {
            return J.data.affiliationsCount = J.data.affiliations_count, J.data.messageId = J.data.msgId, J.data.parentId = J.data.groupId, delete J.data.affiliations_count, delete J.data.msgId, delete J.data.groupId, J;
          });
        }
      }, 70: function(l, v, s) {
        s.r(v), s.d(v, { getSupportedLanguages: function() {
          return m;
        }, translateMessage: function() {
          return E;
        } }), s(1539), s(8674), s(2222), s(9753);
        var c = s(3246), d = s(7360), p = s(4024);
        function m() {
          var y = c.XZ.call(this).error;
          if (y) return Promise.reject(y);
          var g = this.context, C = g.orgName, O = g.appName, N = g.accessToken, w = { url: "".concat(this.apiUrl, "/").concat(C, "/").concat(O, "/users/").concat(this.user, "/translate/support/language"), dataType: "json", type: "GET", headers: { Authorization: "Bearer " + N } };
          return d.kg.debug("Call getSupportedLanguages"), p.hj.call(this, w);
        }
        function E(y) {
          if (typeof y.text != "string" || y.text === "") throw Error('Invalid parameter: "text"');
          if (!Array.isArray(y.languages)) throw Error('Invalid parameter: "language"');
          var g = c.XZ.call(this).error;
          if (g) return Promise.reject(g);
          var C = this.context, O = C.orgName, N = C.appName, w = C.accessToken, _ = "".concat(this.apiUrl, "/").concat(O, "/").concat(N, "/users/").concat(this.user, "/translate"), I = { text: y.text, to: y.languages }, k = { url: _, dataType: "json", type: "POST", data: JSON.stringify(I), headers: { Authorization: "Bearer " + w } };
          return d.kg.debug("Call translateMessage"), p.hj.call(this, k);
        }
      }, 3246: function(l, v, s) {
        s.d(v, { H7: function() {
          return C;
        }, XZ: function() {
          return y;
        }, _W: function() {
          return g;
        } }), s(7941), s(9554), s(1539), s(4747), s(6699), s(2023);
        var c = s(5531), d = s(7252), p = s(7360);
        function m() {
          var O = this.context.appName, N = this.context.orgName;
          return !(!O || !N) || (this.onError && this.onError({ type: c.E.WEBIM_CONNCTION_AUTH_ERROR, message: "appName or orgName is illegal" }), !1);
        }
        function E() {
          var O, N = this.context.accessToken;
          if (!N) {
            var w = d.Z.create({ type: c.E.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR, message: "token not assign error" });
            return p.kg.debug("token not assign error", N), this.onError && this.onError(w), (O = this.eventHandler) === null || O === void 0 || O.dispatch("onError", w), !1;
          }
          return !0;
        }
        function y() {
          if (this._initWithAppId) {
            if (!m.call(this)) return { error: d.Z.create({ type: c.E.WEBIM_CONNECTION_CLOSED, message: "not login" }) };
            if (!E.call(this)) return { error: d.Z.create({ type: c.E.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR, message: "token not assign error" }) };
          } else if (!m.call(this)) return { error: d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" }) };
          return {};
        }
        function g(O) {
          var N = O.data, w = O.type;
          return { data: { status: Object.keys(N.errorKeys).length > 0 ? "fail" : "success", errorKeys: N.errorKeys, successKeys: N.successKeys }, type: w };
        }
        function C(O) {
          var N = O.data, w = void 0;
          return Object.keys(N.errorKeys).length > 0 && Object.keys(N.errorKeys).forEach(function(_) {
            var I = N.errorKeys[_];
            w = I.includes("is not part of you") ? d.Z.create({ type: c.E.NO_PERMISSION, message: I }) : I.includes("size of metadata for this single chatroom exceeds the user defined limit") || I.includes("total size of chatroom metadata for this app exceeds the user defined limit") || I.includes("is exceeding maximum limit") ? d.Z.create({ type: c.E.MAX_LIMIT, message: I }) : I.includes("is not Legal") ? d.Z.create({ type: c.E.REQUEST_PARAMETER_ERROR, message: I }) : I.includes("Failed to update userMetadata. Concurrent updates not allowed") ? d.Z.create({ type: c.E.OPERATION_NOT_ALLOWED, message: I }) : d.Z.create({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: I });
          }), w;
        }
      }, 4319: function(l, v, s) {
        s.d(v, { Ge: function() {
          return w;
        }, Gf: function() {
          return p;
        }, Nt: function() {
          return y;
        }, XV: function() {
          return C;
        }, al: function() {
          return O;
        }, bh: function() {
          return _;
        }, ke: function() {
          return N;
        }, th: function() {
          return E;
        }, xd: function() {
          return g;
        }, xz: function() {
          return d;
        }, zj: function() {
          return m;
        } });
        var c = s(5531), d = 15e3, p = 15e3, m = 3e5, E = 1e4, y = 1e4, g = 8e3, C = 3e5, O = 3e4, N = 5, w = 3, _ = [c.E.MAX_LIMIT, c.E.WEBIM_TOKEN_EXPIRED, c.E.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR, c.E.USER_NOT_FOUND, c.E.WEBIM_CONNCTION_AUTH_ERROR, c.E.REQUEST_PARAMETER_ERROR, c.E.WEBIM_CONNCTION_AUTH_ERROR, c.E.WEBIM_SERVER_SERVING_DISABLED];
      }, 2071: function(l, v, s) {
        s.d(v, { $x: function() {
          return E;
        }, F3: function() {
          return y;
        }, TJ: function() {
          return d;
        }, Tp: function() {
          return O;
        }, Wc: function() {
          return c;
        }, el: function() {
          return p;
        }, iB: function() {
          return g;
        }, iO: function() {
          return m;
        }, yK: function() {
          return C;
        } }), s(6992), s(1532), s(1539), s(8783), s(3948);
        var c = 7, d = /* @__PURE__ */ new Map(), p = "im", m = /* @__PURE__ */ new Map(), E = "32f24ab2ddb74f508aa9286c356cec84", y = 1e3, g = { INIT: 9674, API: 9675 }, C = "direct", O = -1;
      }, 1595: function(l, v, s) {
        var c, d, p, m, E, y;
        s.d(v, { C8: function() {
          return c;
        }, aC: function() {
          return y;
        }, c: function() {
          return p;
        }, dd: function() {
          return E;
        }, fI: function() {
          return d;
        }, td: function() {
          return m;
        } }), function(g) {
          g[g.UNKNOWOPERATION = -1] = "UNKNOWOPERATION", g[g.REST_GET_SESSION_LIST = 1] = "REST_GET_SESSION_LIST", g[g.REST_DEL_SESSION = 2] = "REST_DEL_SESSION", g[g.REST_GET_HISTORY_MESSAGE = 3] = "REST_GET_HISTORY_MESSAGE", g[g.REST_PIN_CONVERSATION = 4] = "REST_PIN_CONVERSATION", g[g.REST_MARK_CONVERSATION = 5] = "REST_MARK_CONVERSATION", g[g.REST_UPLOAD_FILE_IN_PARTS = 6] = "REST_UPLOAD_FILE_IN_PARTS", g[g.REST_DELETE_MESSAGES_CONVERSATIONS = 7] = "REST_DELETE_MESSAGES_CONVERSATIONS", g[g.REST_PIN_MESSAGE = 8] = "REST_PIN_MESSAGE", g[g.REST_FETCH_PINMESSAGES = 9] = "REST_FETCH_PINMESSAGES", g[g.REST_OPERATE = 100] = "REST_OPERATE", g[g.MSYNC_SENDMESSAGE = 101] = "MSYNC_SENDMESSAGE", g[g.MSYNC_RECALLMESSAGE = 102] = "MSYNC_RECALLMESSAGE", g[g.MSYNC_MODIFYMESSAGE = 103] = "MSYNC_MODIFYMESSAGE", g[g.MSYNC_OPERATE = 200] = "MSYNC_OPERATE", g[g.ROSTER_ADD = 201] = "ROSTER_ADD", g[g.ROSTER_REMOVE = 202] = "ROSTER_REMOVE", g[g.ROSTER_ACCEPT = 203] = "ROSTER_ACCEPT", g[g.ROSTER_DECLINE = 204] = "ROSTER_DECLINE", g[g.ROSTER_BAN = 205] = "ROSTER_BAN", g[g.ROSTER_ALLOW = 206] = "ROSTER_ALLOW", g[g.ROSTER_BLACKLIST = 207] = "ROSTER_BLACKLIST", g[g.ROSTER_CONTACTS = 208] = "ROSTER_CONTACTS", g[g.ROSTER_GET_ALL_CONTACTS_REMARKS = 209] = "ROSTER_GET_ALL_CONTACTS_REMARKS", g[g.ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE = 210] = "ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE", g[g.ROSTER_SET_CONTACT_REMARK = 211] = "ROSTER_SET_CONTACT_REMARK", g[g.ROSTER_OPERATE = 300] = "ROSTER_OPERATE", g[g.USER_LOGIN = 301] = "USER_LOGIN", g[g.USER_CREATE = 302] = "USER_CREATE", g[g.USER_UPDATE_USERINFO = 303] = "USER_UPDATE_USERINFO", g[g.USER_FETCH_USERINFO = 304] = "USER_FETCH_USERINFO", g[g.USER_UPDATE_NICK = 305] = "USER_UPDATE_NICK", g[g.USER_UPLOAD_PUSH_TOKEN = 306] = "USER_UPLOAD_PUSH_TOKEN", g[g.USER_LOGGEDIN_OTHER_PLATFORM = 307] = "USER_LOGGEDIN_OTHER_PLATFORM", g[g.USER_OPERATE = 400] = "USER_OPERATE", g[g.GROUP_CREATEGROUP = 401] = "GROUP_CREATEGROUP", g[g.GROUP_BLOCK_MESSAGE = 402] = "GROUP_BLOCK_MESSAGE", g[g.GROUP_FETCH_PUBLICGROUPS_WITHCURSOR = 403] = "GROUP_FETCH_PUBLICGROUPS_WITHCURSOR", g[g.GROUP_FETCH_USERS_GROUP = 404] = "GROUP_FETCH_USERS_GROUP", g[g.GROUP_CHANGE_OWNER = 405] = "GROUP_CHANGE_OWNER", g[g.GROUP_FETCH_SPECIFICATION = 406] = "GROUP_FETCH_SPECIFICATION", g[g.GROUP_CHANGE_GROUPATTRIBUTE = 407] = "GROUP_CHANGE_GROUPATTRIBUTE", g[g.GROUP_FETCH_MEMEBERS = 408] = "GROUP_FETCH_MEMEBERS", g[g.GROUP_GET_ADMIN = 409] = "GROUP_GET_ADMIN", g[g.GROUP_SET_ADMIN = 410] = "GROUP_SET_ADMIN", g[g.GROUP_REMOVE_ADMIN = 411] = "GROUP_REMOVE_ADMIN", g[g.GROUP_DESTOTYGROUP = 412] = "GROUP_DESTOTYGROUP", g[g.GROUP_LEAVEGROUP = 413] = "GROUP_LEAVEGROUP", g[g.GROUP_INVITE_TO_GROUP = 414] = "GROUP_INVITE_TO_GROUP", g[g.GROUP_JOIN_PUBLICGROUP = 415] = "GROUP_JOIN_PUBLICGROUP", g[g.GROUP_ACCEPT_JOINPUBLICGROUPAPPL = 416] = "GROUP_ACCEPT_JOINPUBLICGROUPAPPL", g[g.GROUP_DECLINE_JOINPUBLICGROUPAPPL = 417] = "GROUP_DECLINE_JOINPUBLICGROUPAPPL", g[g.GROUP_ACCEPT_INVITATION = 418] = "GROUP_ACCEPT_INVITATION", g[g.GROUP_DECLINE_INVITATION = 419] = "GROUP_DECLINE_INVITATION", g[g.GROUP_REMOVE_MEMBER = 420] = "GROUP_REMOVE_MEMBER", g[g.GROUP_REMOVE_MEMBERS = 421] = "GROUP_REMOVE_MEMBERS", g[g.GROUP_MUTE_MEMBERS = 422] = "GROUP_MUTE_MEMBERS", g[g.GROUP_UNMUTE_MEMBERS = 423] = "GROUP_UNMUTE_MEMBERS", g[g.GROUP_FETCH_MUTES = 424] = "GROUP_FETCH_MUTES", g[g.GROUP_BLOCK_MEMBER = 425] = "GROUP_BLOCK_MEMBER", g[g.GROUP_BLOCK_MEMBERS = 426] = "GROUP_BLOCK_MEMBERS", g[g.GROUP_UNBLOCK_MEMBER = 427] = "GROUP_UNBLOCK_MEMBER", g[g.GROUP_UNBLOCK_MEMBERS = 428] = "GROUP_UNBLOCK_MEMBERS", g[g.GROUP_GET_BLOCK_LIST = 429] = "GROUP_GET_BLOCK_LIST", g[g.GROUP_MUTE_ALLMEMBERS = 430] = "GROUP_MUTE_ALLMEMBERS", g[g.GROUP_UNMUTE_ALLMEMBERS = 431] = "GROUP_UNMUTE_ALLMEMBERS", g[g.GROUP_ADD_WHITELIST = 432] = "GROUP_ADD_WHITELIST", g[g.GROUP_REMOVE_WHITELIST = 433] = "GROUP_REMOVE_WHITELIST", g[g.GROUP_FETCH_WHITELIST = 434] = "GROUP_FETCH_WHITELIST", g[g.GROUP_IS_IN_WHITELIST = 435] = "GROUP_IS_IN_WHITELIST", g[g.GROUP_GET_READ_USERS = 436] = "GROUP_GET_READ_USERS", g[g.GROUP_FETCH_ANNOUNCEMENT = 437] = "GROUP_FETCH_ANNOUNCEMENT", g[g.GROUP_UPDATE_ANNOUNCEMENT = 438] = "GROUP_UPDATE_ANNOUNCEMENT", g[g.GROUP_UPLOAD_SHAREDFILE = 439] = "GROUP_UPLOAD_SHAREDFILE", g[g.GROUP_DELETE_SHAREDFILE = 440] = "GROUP_DELETE_SHAREDFILE", g[g.GROUP_FETCH_SHAREDFILE = 441] = "GROUP_FETCH_SHAREDFILE", g[g.GROUP_DOWNLOAD_SHAREDFILE = 442] = "GROUP_DOWNLOAD_SHAREDFILE", g[g.GROUP_MEMBER_SET_META_DATA = 443] = "GROUP_MEMBER_SET_META_DATA", g[g.GROUP_MEMBER_FETCH_META_DATA = 444] = "GROUP_MEMBER_FETCH_META_DATA", g[g.GROUP_OPERATE = 500] = "GROUP_OPERATE", g[g.CHATROOM_FETCH_CHATROOMSWITHPAGE = 501] = "CHATROOM_FETCH_CHATROOMSWITHPAGE", g[g.CHATROOM_CREATECHATROOM = 502] = "CHATROOM_CREATECHATROOM", g[g.CHATROOM_DESTORYCHATROOM = 503] = "CHATROOM_DESTORYCHATROOM", g[g.CHATROOM_FETCH_SPECIFICATION = 504] = "CHATROOM_FETCH_SPECIFICATION", g[g.CHATROOM_CHANGE_ATTRIBUTE = 505] = "CHATROOM_CHANGE_ATTRIBUTE", g[g.CHATROOM_REMOVE_MEMBER = 506] = "CHATROOM_REMOVE_MEMBER", g[g.CHATROOM_REMOVE_MEMBERS = 507] = "CHATROOM_REMOVE_MEMBERS", g[g.CHATROOM_ADD_MEMBERS = 508] = "CHATROOM_ADD_MEMBERS", g[g.CHATROOM_JOINCAHTROOM = 509] = "CHATROOM_JOINCAHTROOM", g[g.CHATROOM_LEAVECAHTROOM = 510] = "CHATROOM_LEAVECAHTROOM", g[g.CHATROOM_FETCH_MEMBERS = 511] = "CHATROOM_FETCH_MEMBERS", g[g.CHATROOM_GET_ADMIN = 512] = "CHATROOM_GET_ADMIN", g[g.CHATROOM_SET_ADMIN = 513] = "CHATROOM_SET_ADMIN", g[g.CHATROOM_REMOVE_ADMIN = 514] = "CHATROOM_REMOVE_ADMIN", g[g.CHATROOM_MUTE_USER = 515] = "CHATROOM_MUTE_USER", g[g.CHATROOM_UNMUTE_USER = 516] = "CHATROOM_UNMUTE_USER", g[g.CHATROOM_FETCH_MUTES = 517] = "CHATROOM_FETCH_MUTES", g[g.CHATROOM_BLOCK_USER = 518] = "CHATROOM_BLOCK_USER", g[g.CHATROOM_BLOCK_USERS = 519] = "CHATROOM_BLOCK_USERS", g[g.CHATROOM_UNBLOCK_USER = 520] = "CHATROOM_UNBLOCK_USER", g[g.CHATROOM_UNBLOCK_USERS = 521] = "CHATROOM_UNBLOCK_USERS", g[g.CHATROOM_FETCH_BANS = 522] = "CHATROOM_FETCH_BANS", g[g.CHATROOM_MUTE_ALLMEMEBERS = 523] = "CHATROOM_MUTE_ALLMEMEBERS", g[g.CHATROOM_UNMUTE_ALLMEMEBERS = 524] = "CHATROOM_UNMUTE_ALLMEMEBERS", g[g.CHATROOM_ADD_WHITELIST = 525] = "CHATROOM_ADD_WHITELIST", g[g.CHATROOM_REMOVE_WHITELIST = 526] = "CHATROOM_REMOVE_WHITELIST", g[g.CHATROOM_FETCH_WHITELIST = 527] = "CHATROOM_FETCH_WHITELIST", g[g.CHATROOM_FETCH_MEMBERIN_WHITELIST = 528] = "CHATROOM_FETCH_MEMBERIN_WHITELIST", g[g.CHATROOM_FETCH_ANNOUNCEMENT = 529] = "CHATROOM_FETCH_ANNOUNCEMENT", g[g.CHATROOM_UPDATE_ANNOUNCEMENT = 530] = "CHATROOM_UPDATE_ANNOUNCEMENT", g[g.CHATROOM_REMOVE_SHARE_FILE = 531] = "CHATROOM_REMOVE_SHARE_FILE", g[g.CHATROOM_GET_SHARE_FILE_LIST = 532] = "CHATROOM_GET_SHARE_FILE_LIST", g[g.CHATROOM_UPLOAD_FILE = 533] = "CHATROOM_UPLOAD_FILE", g[g.CHATROOM_SET_META_DATA = 534] = "CHATROOM_SET_META_DATA", g[g.CHATROOM_DELETE_META_DATA = 535] = "CHATROOM_DELETE_META_DATA", g[g.CHATROOM_FETCH_META_DATA = 536] = "CHATROOM_FETCH_META_DATA", g[g.CHATROOM_FETCH_USER_JOINED_CHATROOM = 537] = "CHATROOM_FETCH_USER_JOINED_CHATROOM", g[g.CHATROOM_OPERATE = 600] = "CHATROOM_OPERATE";
        }(c || (c = {})), function(g) {
          g.SDK_INTERNAL = "SDK_INTERNAL", g.LOGIN = "USER_LOGIN", g.REGISTER = "USER_CREATE", g.GET_CHATROOM_LIST = "CHATROOM_FETCH_CHATROOMSWITHPAGE", g.CREATE_CHATROOM = "CHATROOM_CREATECHATROOM", g.DESTROY_CHATROOM = "CHATROOM_DESTORYCHATROOM", g.GET_CHATROOM_DETAIL = "CHATROOM_FETCH_SPECIFICATION", g.MODIFY_CHATROOM = "CHATROOM_CHANGE_ATTRIBUTE", g.REMOVE_CHATROOM_MEMBER = "CHATROOM_REMOVE_MEMBER", g.MULTI_REMOVE_CHATROOM_MEMBER = "CHATROOM_REMOVE_MEMBERS", g.ADD_USERS_TO_CHATROOM = "CHATROOM_ADD_MEMBERS", g.JOIN_CHATROOM = "CHATROOM_JOINCAHTROOM", g.QUIT_CHATROOM = "CHATROOM_LEAVECAHTROOM", g.LIST_CHATROOM_MEMBERS = "CHATROOM_FETCH_MEMBERS", g.GET_CHATROOM_ADMIN = "CHATROOM_GET_ADMIN", g.SET_CHATROOM_ADMIN = "CHATROOM_SET_ADMIN", g.REMOVE_CHATROOM_ADMIN = "CHATROOM_REMOVE_ADMIN", g.MUTE_CHATROOM_MEMBER = "CHATROOM_MUTE_USER", g.REMOVE_MUTE_CHATROOM_MEMBER = "CHATROOM_UNMUTE_USER", g.GET_MUTE_CHATROOM_MEMBERS = "CHATROOM_FETCH_MUTES", g.SET_CHATROOM_MEMBER_TO_BLACK = "CHATROOM_BLOCK_USER", g.MULTI_SET_CHATROOM_MEMBER_TO_BLACK = "CHATROOM_BLOCK_USERS", g.REMOVE_CHATROOM_MEMBER_BLACK = "CHATROOM_UNBLOCK_USER", g.MULTI_REMOVE_CHATROOM_MEMBER_BLACK = "CHATROOM_UNBLOCK_USERS", g.GET_CHATROOM_BLOCK_MEMBERS = "CHATROOM_FETCH_BANS", g.DISABLED_CHATROOM_SEND_MSG = "CHATROOM_MUTE_ALLMEMEBERS", g.ENABLE_CHATROOM_SEND_MSG = "CHATROOM_UNMUTE_ALLMEMEBERS", g.ADD_CHATROOM_WHITE_USERS = "CHATROOM_ADD_WHITELIST", g.REMOVE_CHATROOM_WHITE_USERS = "CHATROOM_REMOVE_WHITELIST", g.GET_CHATROOM_WHITE_USERS = "CHATROOM_FETCH_WHITELIST", g.CHECK_CHATROOM_WHITE_USER = "CHATROOM_FETCH_MEMBERIN_WHITELIST", g.GET_CHATROOM_ANN = "CHATROOM_FETCH_ANNOUNCEMENT", g.UPDATE_CHATROOM_ANN = "CHATROOM_UPDATE_ANNOUNCEMENT", g.DELETE_CHATROOM_FILE = "CHATROOM_REMOVE_SHARE_FILE", g.GET_CHATROOM_FILES = "CHATROOM_GET_SHARE_FILE_LIST", g.UPLOAD_CHATROOM_FILE = "CHATROOM_UPLOAD_FILE", g.SET_CHATROOM_ATTR = "CHATROOM_SET_META_DATA", g.DELETE_CHATROOM_ATTR = "CHATROOM_DELETE_META_DATA", g.GET_CHATROOM_ATTR = "CHATROOM_FETCH_META_DATA", g.GET_USER_JOINED_CHATROOM = "CHATROOM_FETCH_USER_JOINED_CHATROOM", g.CREATE_GROUP = "GROUP_CREATEGROUP", g.BLOCK_GROUP = "GROUP_BLOCK_MESSAGE", g.LIST_GROUP = "GROUP_FETCH_PUBLICGROUPS_WITHCURSOR", g.GET_USER_GROUP = "GROUP_FETCH_USERS_GROUP", g.CHANGE_OWNER = "GROUP_CHANGE_OWNER", g.GET_GROUP_INFO = "GROUP_FETCH_SPECIFICATION", g.MODIFY_GROUP = "GROUP_CHANGE_GROUPATTRIBUTE", g.LIST_GROUP_MEMBER = "GROUP_FETCH_MEMEBERS", g.GET_GROUP_ADMIN = "GROUP_GET_ADMIN", g.SET_GROUP_ADMIN = "GROUP_SET_ADMIN", g.REMOVE_GROUP_ADMIN = "GROUP_REMOVE_ADMIN", g.DISSOLVE_GROUP = "GROUP_DESTOTYGROUP", g.QUIT_GROUP = "GROUP_LEAVEGROUP", g.INVITE_TO_GROUP = "GROUP_INVITE_TO_GROUP", g.JOIN_GROUP = "GROUP_JOIN_PUBLICGROUP", g.AGREE_JOIN_GROUP = "GROUP_ACCEPT_JOINPUBLICGROUPAPPL", g.REJECT_JOIN_GROUP = "GROUP_DECLINE_JOINPUBLICGROUPAPPL", g.AGREE_INVITE_GROUP = "GROUP_ACCEPT_INVITATION", g.REJECT_INVITE_GROUP = "GROUP_DECLINE_INVITATION", g.REMOVE_GROUP_MEMBER = "GROUP_REMOVE_MEMBER", g.MULTI_REMOVE_GROUP_MEMBER = "GROUP_REMOVE_MEMBERS", g.MUTE_GROUP_MEMBER = "GROUP_MUTE_MEMBERS", g.UNMUTE_GROUP_MEMBER = "GROUP_UNMUTE_MEMBERS", g.GET_GROUP_MUTE_LIST = "GROUP_FETCH_MUTES", g.BLOCK_GROUP_MEMBER = "GROUP_BLOCK_MEMBER", g.BLOCK_GROUP_MEMBERS = "GROUP_BLOCK_MEMBERS", g.UNBLOCK_GROUP_MEMBER = "GROUP_UNBLOCK_MEMBER", g.UNBLOCK_GROUP_MEMBERS = "GROUP_UNBLOCK_MEMBERS", g.GET_GROUP_BLACK_LIST = "GROUP_GET_BLOCK_LIST", g.DISABLED_SEND_GROUP_MSG = "GROUP_MUTE_ALLMEMBERS", g.ENABLE_SEND_GROUP_MSG = "GROUP_UNMUTE_ALLMEMBERS", g.ADD_USERS_TO_GROUP_WHITE = "GROUP_ADD_WHITELIST", g.REMOVE_GROUP_WHITE_MEMBER = "GROUP_REMOVE_WHITELIST", g.GET_GROUP_WHITE_LIST = "GROUP_FETCH_WHITELIST", g.IS_IN_GROUP_WHITE_LIST = "GROUP_IS_IN_WHITELIST", g.GET_GROUP_MSG_READ_USER = "GROUP_GET_READ_USERS", g.GET_GROUP_ANN = "GROUP_FETCH_ANNOUNCEMENT", g.UPDATE_GROUP_ANN = "GROUP_UPDATE_ANNOUNCEMENT", g.UPLOAD_GROUP_FILE = "GROUP_UPLOAD_SHAREDFILE", g.DELETE_GROUP_FILE = "GROUP_DELETE_SHAREDFILE", g.GET_GROUP_FILE_LIST = "GROUP_FETCH_SHAREDFILE", g.DOWN_GROUP_FILE = "GROUP_DOWNLOAD_SHAREDFILE", g.SET_GROUP_MEMBER_ATTRS = "GROUP_MEMBER_SET_META_DATA", g.GET_GROUP_MEMBER_ATTR = "GROUP_MEMBER_FETCH_META_DATA", g.GET_SESSION_LIST = "REST_GET_SESSION_LIST", g.DELETE_SESSION = "REST_DEL_SESSION", g.GET_HISTORY_MSG = "REST_GET_HISTORY_MESSAGE", g.PIN_CONVERSATION = "REST_PIN_CONVERSATION", g.REST_UPLOAD_FILE_IN_PARTS = "REST_UPLOAD_FILE_IN_PARTS", g.REST_DELETE_MESSAGES_CONVERSATIONS = "REST_DELETE_MESSAGES_CONVERSATIONS", g.MARK_CONVERSATION = "REST_MARK_CONVERSATION", g.REST_FETCH_PINMESSAGES = "REST_FETCH_PINMESSAGES", g.REST_PIN_MESSAGE = "REST_PIN_MESSAGE", g.UPDATE_USER_INFO = "USER_UPDATE_USERINFO", g.GET_USER_INFO = "USER_FETCH_USERINFO", g.UPDATE_USER_NICK = "USER_UPDATE_NICK", g.UPLOAD_PUSH_TOKEN = "USER_UPLOAD_PUSH_TOKEN", g.USER_LOGGEDIN_OTHER_PLATFORM = "USER_LOGGEDIN_OTHER_PLATFORM", g.GET_BLACK_LIST = "ROSTER_BLACKLIST", g.GET_CONTACTS = "ROSTER_CONTACTS", g.ROSTER_GET_ALL_CONTACTS_REMARKS = "ROSTER_GET_ALL_CONTACTS_REMARKS", g.ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE = "ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE", g.ROSTER_SET_CONTACT_REMARK = "ROSTER_SET_CONTACT_REMARK", g.ROSTER_ADD = "ROSTER_ADD", g.ROSTER_REMOVE = "ROSTER_REMOVE", g.ROSTER_ACCEPT = "ROSTER_ACCEPT", g.ROSTER_DECLINE = "ROSTER_DECLINE", g.ROSTER_BAN = "ROSTER_BAN", g.ROSTER_ALLOW = "ROSTER_ALLOW", g.SEND_MSG = "MSYNC_SENDMESSAGE", g.UPLOAD_MSG_ATTACH = "UPLOAD_MSG_ATTACH", g.SEND_RECALL_MSG = "MSYNC_RECALLMESSAGE", g.MODIFY_MESSAGE = "MSYNC_MODIFYMESSAGE";
        }(d || (d = {})), function(g) {
          g.GET_DNS = "REST_DNSLIST", g.LOGIN_BY_AGORA_TOKEN = "LOGIN_BY_AGORA_TOKEN", g.LOGIN_BY_PWD = "LOGIN_BY_PWD", g.RESISTER = "REGISTER", g.REST_INIT_UPLOAD_TASK_IN_PARTS = "REST_INIT_UPLOAD_TASK_IN_PARTS", g.REST_UPLOAD_PART = "REST_UPLOAD_PART", g.REST_COMPLETE_UPLOAD_PART = "REST_COMPLETE_UPLOAD_PART", g.REST_ABORT_UPLOAD_PART = "REST_ABORT_UPLOAD_PART", g.CONNECT_WEBSOCKET = "CONNECT_WEBSOCKET";
        }(p || (p = {})), function(g) {
          g[g["5G"] = 7] = "5G", g[g["4G"] = 7] = "4G", g[g["3G"] = 7] = "3G", g[g["2G"] = 7] = "2G", g[g["SLOW-2G"] = 7] = "SLOW-2G", g[g.WIFI = 2] = "WIFI", g[g.LAN = 1] = "LAN", g[g.DISCONNECTED = 0] = "DISCONNECTED", g[g.NONE = 0] = "NONE", g[g.UNKNOWN = -1] = "UNKNOWN", g[g["WEBIM UNABLE TO GET"] = -2] = "WEBIM UNABLE TO GET";
        }(m || (m = {})), function(g) {
          g[g.success = 200] = "success", g[g.failed = 500] = "failed", g[g.disconnect = -1] = "disconnect", g[g.closed = 401] = "closed", g[g.notFound = 404] = "notFound", g[g.reachLimit = 429] = "reachLimit";
        }(E || (E = {})), function(g) {
          g[g.web = 0] = "web", g[g.native = 1] = "native";
        }(y || (y = {}));
      }, 6424: function(l, v, s) {
        s.d(v, { gA: function() {
          return _e;
        }, ZP: function() {
          return Ct;
        } }), s(9601), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(7042), s(2222), s(3710), s(7941), s(9714), s(3843), s(8309), s(2772), s(5212), s(7327), s(5827), s(9826), s(4553), s(561), s(9653), s(1038), s(2564), s(9575), s(2472), s(2990), s(8927), s(3105), s(5035), s(4345), s(7174), s(2846), s(4731), s(7209), s(6319), s(8867), s(7789), s(3739), s(9368), s(4483), s(2056), s(3462), s(678), s(7462), s(3824), s(5021), s(2974), s(5016), s(6699), s(2023), s(3161), s(4048), s(9753), s(9554), s(4747), s(285), s(1637), s(8145), s(1249), s(4812);
        var c = s(4188), d = s.n(c), p = s(3720), m = s.n(p), E = s(5531), y = s(8161), g = s(7360), C = ["public", "members_only", "allow_user_invites", "invite_need_confirm"], O = { name: "name", title: "name", description: "description", public: "public", members_only: "approval", allow_user_invites: "allowInvites", max_users: "maxUsers", invite_need_confirm: "inviteNeedConfirm", custom: "ext", last_modified: "lastModified" };
        function N(Ie, x) {
          var ae, Q, Z, ge, me, ve, ie = this, ye = this.context, Ye = ye.userId, ne = ye.jid, Qe = x.from.name === Ye && ne.clientResource !== x.from.clientResource;
          return x.isThread ? (Z = { id: x.mucId.name, name: x.mucName, operation: "", parentId: x.mucParentId.name, operator: x.from.name, userName: x.to.length ? x.to[0].name : "" }, ge = { chatThreadId: x.mucId.name, chatThreadName: x.mucName, operation: "", parentId: x.mucParentId.name }) : (Q = { type: "", owner: x.from.name, gid: x.mucId.name, from: x.from.name, fromJid: x.from, to: x.to.length ? x.to[0].name : "", toJid: x.to, chatroom: x.isChatroom, status: x.status }, me = { operation: "", id: x.mucId.name, from: x.from.name }, x.isChatroom && (!((ae = x == null ? void 0 : x.eventInfo) === null || ae === void 0) && ae.ext) && (ve = JSON.parse(x.eventInfo.ext))), ({ 45: function() {
            var W, ce, fe;
            me.operation = "memberAttributesUpdate";
            var we = JSON.parse((W = x == null ? void 0 : x.eventInfo) === null || W === void 0 ? void 0 : W.ext) || {};
            me.attributes = we.properties || {}, me.userId = we.username || "", Qe ? (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onMultiDeviceEvent", me) : (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupEvent", me);
          }, 44: function() {
            var W;
            me.operation = "removeChatRoomAttributes", me.attributes = ve.result.successKeys, ve.result.successKeys.length > 0 && ((W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomEvent", me));
          }, 43: function() {
            var W;
            me.operation = "updateChatRoomAttributes";
            var ce = {};
            ve.result.successKeys.forEach(function(fe) {
              ce[fe] = ve.properties[fe];
            }), me.attributes = ce, ve.result.successKeys.length > 0 && ((W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomEvent", me));
          }, 42: function() {
          }, 41: function() {
          }, 40: function() {
          }, 39: function() {
          }, 38: function() {
            var W;
            ge.operation = "chatThreadNameUpdate", (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onMultiDeviceEvent", ge);
          }, 37: function() {
            var W;
            Z.operation = "userRemove", (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatThreadChange", Z);
          }, 36: function() {
            var W;
            ge.operation = "chatThreadLeave", (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onMultiDeviceEvent", ge);
          }, 35: function() {
            var W;
            ge.operation = "chatThreadJoin", (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onMultiDeviceEvent", ge);
          }, 34: function() {
            var W;
            ge.operation = "chatThreadDestroy", (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onMultiDeviceEvent", ge);
          }, 33: function() {
            var W;
            ge.operation = "chatThreadCreate", (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onMultiDeviceEvent", ge);
          }, 32: function() {
            var W, ce, fe, we;
            Q.type = x.isChatroom ? "rmChatRoomMute" : "rmGroupMute", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "unmuteAllMembers", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 31: function() {
            var W, ce, fe, we;
            Q.type = x.isChatroom ? "muteChatRoom" : "muteGroup", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "muteAllMembers", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 30: function() {
            var W, ce, fe, we;
            Q.type = x.isChatroom ? "rmUserFromChatRoomWhiteList" : "rmUserFromGroupWhiteList", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "removeAllowlistMember", me.userId = Q.to, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 29: function() {
            var W, ce, fe, we;
            Q.type = x.isChatroom ? "addUserToChatRoomWhiteList" : "addUserToGroupWhiteList", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "addUserToAllowlist", me.userId = Q.to, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 28: function() {
            var W, ce, fe, we;
            Q.type = "deleteFile", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "deleteFile", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 27: function() {
            var W, ce, fe, we;
            Q.type = "uploadFile", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "uploadFile", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 26: function() {
            var W, ce, fe, we;
            Q.type = "deleteAnnouncement", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "deleteAnnouncement", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 25: function() {
            var W, ce, fe, we;
            Q.type = "updateAnnouncement", Q.announcement = x.reason, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "updateAnnouncement", me.announcement = x.reason, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 24: function() {
            var W, ce, fe, we;
            Q.type = "removeMute", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "unmuteMember", me.userId = Q.to, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 23: function() {
            var W, ce, fe, we;
            if (Q.type = "addMute", ie.onPresence && ie.onPresence(Q), x.ext && typeof x.ext == "string") {
              var Fe = JSON.parse(x.ext);
              Fe.user_mute_time && (Q.muteTimestamp = Fe.user_mute_time, me.muteTimestamp = Fe.user_mute_time);
            }
            x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "muteMember", me.userId = Q.to, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 22: function() {
            var W, ce, fe, we;
            Q.type = "removeAdmin", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "removeAdmin", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 21: function() {
            var W, ce, fe, we;
            Q.type = "addAdmin", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "setAdmin", me.userId = Q.to, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 20: function() {
            var W, ce, fe, we;
            Q.type = "changeOwner", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "changeOwner", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 19: function() {
            var W, ce, fe, we;
            Q.type = "direct_joined", Q.groupName = x.mucName, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "directJoined", me.name = x.mucName, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 18: function() {
            var W, ce, fe, we;
            Q.type = x.isChatroom ? "leaveChatRoom" : "leaveGroup", ie.onPresence && ie.onPresence(Q);
            var Fe = x.mucMemberCount;
            Fe && (me.memberCount = Fe), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "memberAbsence", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 17: function() {
            var W, ce, fe, we;
            x.isChatroom && x.ext && (me.ext = x.ext, Q.ext = x.ext), Q.type = x.isChatroom ? "memberJoinChatRoomSuccess" : "memberJoinPublicGroupSuccess", ie.onPresence && ie.onPresence(Q);
            var Fe = x.mucMemberCount;
            x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "memberPresence", Fe && (me.memberCount = Fe), x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 16: function() {
            var W, ce;
            Q.type = "unblock", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q);
          }, 15: function() {
            var W, ce;
            Q.type = "block", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q);
          }, 14: function() {
            var W, ce, fe, we, Fe, je = x.isChatroom;
            if (!je) {
              var qe = JSON.parse(((W = x == null ? void 0 : x.eventInfo) === null || W === void 0 ? void 0 : W.ext) || "{}", function(et, bt) {
                return et === "last_modified" ? Number(bt) : C.includes(et) ? bt === "true" || bt === !0 : bt;
              });
              me.detail = Q.detail = {}, Object.keys(qe).forEach(function(et) {
                var bt = O[et];
                if (bt) {
                  var ot = qe[et];
                  me.detail && (me.detail[bt] = ot), Q.detail && (Q.detail[bt] = ot);
                }
              });
            }
            Q.type = "update", ie.onPresence && ie.onPresence(Q), je ? (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Q) : (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Q), me.operation = "updateInfo", je ? (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", me) : (Fe = ie.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", me);
          }, 13: function() {
            var W, ce, fe, we;
            Q.type = "allow", Q.reason = x.reason, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), x.reason && (me.reason = x.reason), me.operation = "unblockMember", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 12: function() {
            var W, ce;
            Q.type = "ban", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q);
          }, 11: function() {
            var W, ce;
            Q.type = "getBlackList", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q);
          }, 10: function() {
            var W, ce, fe, we;
            Q.type = "removedFromGroup", Q.kicked = Q.to, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "removeMember", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 9: function() {
            var W, ce, fe, we;
            Q.type = "invite_decline", Q.kicked = Q.to, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "rejectInvite", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 8: function() {
            var W, ce, fe, we;
            Q.type = "invite_accept", Q.kicked = Q.to, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "acceptInvite", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 7: function() {
            var W, ce, fe, we;
            Q.type = "invite", Q.kicked = Q.to, Q.groupName = x.mucName, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "inviteToJoin", me.name = x.mucName, x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 6: function() {
            var W, ce, fe, we;
            Q.type = "joinPublicGroupDeclined", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "joinPublicGroupDeclined", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (me.userId = x.to.length ? x.to[0].name : "", (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me));
          }, 5: function() {
            var W, ce, fe, we;
            Q.type = "joinPublicGroupSuccess", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "acceptRequest", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 4: function() {
            var W, ce, fe, we;
            Q.type = "joinGroupNotifications", Q.reason = x.reason, ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), x.reason && (me.reason = x.reason), me.operation = "requestToJoin", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 3: function() {
            var W, ce;
            Q.type = "leave", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q);
          }, 2: function() {
            var W, ce;
            Q.type = "join", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q);
          }, 1: function() {
            var W, ce, fe, we;
            Q.type = "deleteGroupChat", ie.onPresence && ie.onPresence(Q), x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomChange", Q) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupChange", Q), me.operation = "destroy", x.isChatroom ? (fe = ie.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomEvent", me) : (we = ie.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", me);
          }, 0: function() {
            var W, ce;
            me.operation = "create", x.isChatroom ? (W = ie.eventHandler) === null || W === void 0 || W.dispatch("onChatroomEvent", me) : (ce = ie.eventHandler) === null || ce === void 0 || ce.dispatch("onGroupEvent", me);
          } }[Ie] || function() {
            console.error("No match operation ".concat(Ie));
          })();
        }
        var w = function(Ie) {
          var x = this.root.lookup("easemob.pb.MUCBody").decode(Ie.payload), ae = x.operation;
          g.kg.debug("onMucMessage", x), N.call(this, ae, x);
        }, _ = { handleRosterMsg: function(Ie) {
          var x, ae, Q, Z, ge, me, ve = this.root.lookup("easemob.pb.RosterBody").decode(Ie.payload), ie = { type: "", to: ve.to[0].name, from: ve.from.name, status: ve.reason };
          switch (ve.operation) {
            case 2:
              ie.type = "subscribe", this.onContactInvited && this.onContactInvited(ie), (x = this.eventHandler) === null || x === void 0 || x.dispatch("onContactInvited", ie);
              break;
            case 3:
              ie.type = "unsubscribed", this.onContactDeleted && this.onContactDeleted(ie), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onContactDeleted", ie);
              break;
            case 4:
              ie.type = "subscribed", this.onContactAdded && this.onContactAdded(ie), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onContactAdded", ie);
              break;
            case 5:
              ie.type = "unsubscribed", this.onContactRefuse && this.onContactRefuse(ie), (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onContactRefuse", ie);
              break;
            case 6:
            case 7:
              break;
            case 8:
              ie.type = "subscribed", this.onContactAgreed && this.onContactAgreed(ie), (ge = this.eventHandler) === null || ge === void 0 || ge.dispatch("onContactAgreed", ie);
              break;
            case 9:
              ie.type = "unsubscribed", this.onContactRefuse && this.onContactRefuse(ie), (me = this.eventHandler) === null || me === void 0 || me.dispatch("onContactRefuse", ie);
              break;
            default:
              g.kg.error("handleRosterMsg:", ve);
          }
          this.onPresence && ie.type && this.onPresence(ie);
        } }, I = s(7252), k = function(Ie) {
          var x, ae, Q, Z, ge, me, ve = this.root.lookup("easemob.pb.StatisticsBody").decode(Ie.payload), ie = ve.operation, ye = ve.reason;
          switch (ie) {
            case 0:
              this.onStatisticMessage && this.onStatisticMessage(ve), (x = this.eventHandler) === null || x === void 0 || x.dispatch("onStatisticMessage", ve);
              break;
            case 1:
              me = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_REMOVED, message: "user has been removed" }), this.disconnectedReason = me, this.logOut = !0, this.onError && this.onError(me), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onError", me);
              break;
            case 2:
              me = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE, message: "the user is already logged on another device" }), ye && (me.data = { loginInfoCustomExt: ve.reason }), this.disconnectedReason = me, this.logOut = !0, this.onError && this.onError(me), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onError", me);
              break;
            case 3:
              me = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_KICKED_BY_CHANGE_PASSWORD, message: "the user was kicked by changing password" }), this.disconnectedReason = me, this.logOut = !0, this.onError && this.onError(me), (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onError", me);
              break;
            case 4:
              me = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_KICKED_BY_OTHER_DEVICE, message: "the user was kicked by other device" }), this.disconnectedReason = me, this.logOut = !0, this.onError && this.onError(me), (ge = this.eventHandler) === null || ge === void 0 || ge.dispatch("onError", me);
              break;
            default:
              g.kg.error("handleStatisticsMsg:", ve);
          }
        }, H = (s(9720), s(4024)), S = s(4363), B = s(9937);
        function D(Ie) {
          var x, ae = [], Q = [], Z = Ie.data;
          Z && Z.values && Z.values.forEach(function(ge) {
            Object.entries(ge.status).forEach(function(me) {
              Q.push({ device: me[0], status: Number(me[1]) });
            }), ae.push({ userId: ge.uid, lastTime: Number(ge.last_time), expire: Number(ge.expiry), ext: ge.ext, statusDetails: Q });
          }), this.onPresenceStatusChange && this.onPresenceStatusChange(ae), (x = this.eventHandler) === null || x === void 0 || x.dispatch("onPresenceStatusChange", ae);
        }
        function F(Ie) {
          var x = this;
          Ie.data.forEach(function(ae) {
            var Q, Z = { from: ae.from, to: ae.to, chatType: ae.channel_type === "chat" ? "singleChat" : "groupChat", messageId: ae.messageId, reactions: ae.reactions, ts: ae.ts };
            (Q = x.eventHandler) === null || Q === void 0 || Q.dispatch("onReactionChange", Z);
          });
        }
        function j(Ie) {
          var x, ae, Q, Z;
          if (Ie.data) {
            var ge = Ie.data, me = { id: ge.id || "", name: ge.name || "", parentId: ge.muc_parent_id || "", messageId: ge.msg_parent_id || "", timestamp: ge.timestamp || 0, operator: ge.from || "", operation: "" };
            switch (ge.operation) {
              case "create":
                me.operation = "create", me.createTimestamp = me.timestamp, me.messageCount = 0, (x = this.eventHandler) === null || x === void 0 || x.dispatch("onChatThreadChange", me);
                break;
              case "update_msg":
                me.operation = "update", me.messageCount = ge.message_count, ge.last_message && JSON.stringify(ge.last_message) !== "{}" ? me.lastMessage = S.w.call(this, ge.last_message) : JSON.stringify(ge.last_message) === "{}" && (me.lastMessage = {}), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onChatThreadChange", me);
                break;
              case "update":
                me.operation = "update", me.messageCount = ge.message_count, (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onChatThreadChange", me);
                break;
              case "delete":
                me.operation = "destroy", (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onChatThreadChange", me);
            }
          }
        }
        function G(Ie) {
          var x, ae = Ie.data;
          if (ae.resource !== this.clientResource) {
            var Q = { operation: "deleteRoaming", conversationId: ae.to, chatType: ae.chatType === "chat" ? "singleChat" : "groupChat", resource: ae.resource };
            (x = this.eventHandler) === null || x === void 0 || x.dispatch("onMultiDeviceEvent", Q);
          }
        }
        function U(Ie) {
          var x, ae, Q = Ie.data, Z = "";
          if (this.clientResource !== Q.res || Q.from !== this.user) {
            switch (Q.op) {
              case "del":
                Z = "deleteConversation";
                break;
              case "top":
                Z = "pinnedConversation";
                break;
              case "not_top":
                Z = "unpinnedConversation";
                break;
              case "mark":
                Z = "markConversation";
                break;
              case "mark_delete":
                Z = "unMarkConversation";
                break;
              case "pin":
                Z = "pin";
                break;
              case "pin_delete":
                Z = "unpin";
                break;
              default:
                return void g.kg.error("unexpected conversation op:", Q.op);
            }
            if (Z !== "pin" && Z !== "unpin") {
              var ge = { operation: Z, conversationId: Q.id, conversationType: Q.type === "chat" ? "singleChat" : "groupChat", timestamp: Q.ts };
              ge.operation !== "markConversation" && ge.operation !== "unMarkConversation" || Q.ext && (ge.conversationMark = B.Z[Q.ext]), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onMultiDeviceEvent", ge);
            } else {
              var me = Q.ext, ve = Q.from, ie = Q.id, ye = Q.type, Ye = Q.ts, ne = { messageId: me || "", conversationId: ye === "chat" ? ve : ie, conversationType: S.U[ye], operation: Z, operatorId: ve, time: Ye };
              (x = this.eventHandler) === null || x === void 0 || x.dispatch("onMessagePinEvent", ne);
            }
          }
        }
        function M(Ie) {
          var x, ae = this;
          (x = Ie.values) === null || x === void 0 || x.forEach(function(Q) {
            var Z, ge, me, ve, ie;
            if (Q.operator_resource !== ae.clientResource) if ("ignoreInterval" in Q.data) {
              var ye = { operation: "setSilentModeForUser", resource: Q.operator_resource, data: Q.data };
              (Z = ae.eventHandler) === null || Z === void 0 || Z.dispatch("onMultiDeviceEvent", ye);
            } else "group" in Q ? (ye = { operation: Object.keys((ge = Q.data) !== null && ge !== void 0 ? ge : {}).length === 0 ? "removeSilentModeForConversation" : "setSilentModeForConversation", resource: Q.operator_resource, conversationId: Q.group, type: "groupChat", data: Q.data }, (me = ae.eventHandler) === null || me === void 0 || me.dispatch("onMultiDeviceEvent", ye)) : (ye = { operation: Object.keys((ve = Q.data) !== null && ve !== void 0 ? ve : {}).length === 0 ? "removeSilentModeForConversation" : "setSilentModeForConversation", resource: Q.operator_resource, conversationId: Q.user, type: "singleChat", data: Q.data }, (ie = ae.eventHandler) === null || ie === void 0 || ie.dispatch("onMultiDeviceEvent", ye));
          });
        }
        var V = function(Ie) {
          var x = H.P6.parseNotify(Ie.payload);
          switch (x.type) {
            case "presence":
              D.call(this, x);
              break;
            case "reaction":
              F.call(this, x);
              break;
            case "thread":
              j.call(this, x);
              break;
            case "roaming_delete":
              G.call(this, x);
              break;
            case "conv":
              U.call(this, x);
              break;
            case "user_notification_mute":
              M.call(this, x);
              break;
            default:
              g.kg.error("unexpected notify type: ".concat(x.type));
          }
        }, J = s(7288), ue = s(9743), se = s(4998), ee = s(6801), de = s(2071), he = s(1595), pe = s(4319);
        function Ce(Ie) {
          return Ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(x) {
            return typeof x;
          } : function(x) {
            return x && typeof Symbol == "function" && x.constructor === Symbol && x !== Symbol.prototype ? "symbol" : typeof x;
          }, Ce(Ie);
        }
        var _e, Le, Te, K = function() {
          return K = Object.assign || function(Ie) {
            for (var x, ae = 1, Q = arguments.length; ae < Q; ae++) for (var Z in x = arguments[ae]) Object.prototype.hasOwnProperty.call(x, Z) && (Ie[Z] = x[Z]);
            return Ie;
          }, K.apply(this, arguments);
        }, Oe = function(Ie, x, ae, Q) {
          return new (ae || (ae = Promise))(function(Z, ge) {
            function me(ye) {
              try {
                ie(Q.next(ye));
              } catch (Ye) {
                ge(Ye);
              }
            }
            function ve(ye) {
              try {
                ie(Q.throw(ye));
              } catch (Ye) {
                ge(Ye);
              }
            }
            function ie(ye) {
              var Ye;
              ye.done ? Z(ye.value) : (Ye = ye.value, Ye instanceof ae ? Ye : new ae(function(ne) {
                ne(Ye);
              })).then(me, ve);
            }
            ie((Q = Q.apply(Ie, [])).next());
          });
        }, Pe = function(Ie, x) {
          var ae, Q, Z, ge, me = { label: 0, sent: function() {
            if (1 & Z[0]) throw Z[1];
            return Z[1];
          }, trys: [], ops: [] };
          return ge = { next: ve(0), throw: ve(1), return: ve(2) }, typeof Symbol == "function" && (ge[Symbol.iterator] = function() {
            return this;
          }), ge;
          function ve(ie) {
            return function(ye) {
              return function(Ye) {
                if (ae) throw new TypeError("Generator is already executing.");
                for (; me; ) try {
                  if (ae = 1, Q && (Z = 2 & Ye[0] ? Q.return : Ye[0] ? Q.throw || ((Z = Q.return) && Z.call(Q), 0) : Q.next) && !(Z = Z.call(Q, Ye[1])).done) return Z;
                  switch (Q = 0, Z && (Ye = [2 & Ye[0], Z.value]), Ye[0]) {
                    case 0:
                    case 1:
                      Z = Ye;
                      break;
                    case 4:
                      return me.label++, { value: Ye[1], done: !1 };
                    case 5:
                      me.label++, Q = Ye[1], Ye = [0];
                      continue;
                    case 7:
                      Ye = me.ops.pop(), me.trys.pop();
                      continue;
                    default:
                      if (!((Z = (Z = me.trys).length > 0 && Z[Z.length - 1]) || Ye[0] !== 6 && Ye[0] !== 2)) {
                        me = 0;
                        continue;
                      }
                      if (Ye[0] === 3 && (!Z || Ye[1] > Z[0] && Ye[1] < Z[3])) {
                        me.label = Ye[1];
                        break;
                      }
                      if (Ye[0] === 6 && me.label < Z[1]) {
                        me.label = Z[1], Z = Ye;
                        break;
                      }
                      if (Z && me.label < Z[2]) {
                        me.label = Z[2], me.ops.push(Ye);
                        break;
                      }
                      Z[2] && me.ops.pop(), me.trys.pop();
                      continue;
                  }
                  Ye = x.call(Ie, me);
                } catch (ne) {
                  Ye = [6, ne], Q = 0;
                } finally {
                  ae = Z = 0;
                }
                if (5 & Ye[0]) throw Ye[1];
                return { value: Ye[0] ? Ye[1] : void 0, done: !0 };
              }([ie, ye]);
            };
          }
        };
        (function(Ie) {
          Ie[Ie.NORMAL = 0] = "NORMAL", Ie[Ie.SINGLECHAT = 1] = "SINGLECHAT", Ie[Ie.GROUPCHAT = 2] = "GROUPCHAT", Ie[Ie.CHATROOM = 3] = "CHATROOM", Ie[Ie.READ_ACK = 4] = "READ_ACK", Ie[Ie.DELIVER_ACK = 5] = "DELIVER_ACK", Ie[Ie.RECALL = 6] = "RECALL", Ie[Ie.CHANNEL_ACK = 7] = "CHANNEL_ACK", Ie[Ie.EDIT = 8] = "EDIT";
        })(_e || (_e = {})), function(Ie) {
          Ie[Ie.APNs = 0] = "APNs", Ie[Ie.FCM = 1] = "FCM", Ie[Ie.HMSPUSH = 2] = "HMSPUSH", Ie[Ie.MIPUSH = 3] = "MIPUSH", Ie[Ie.MEIZUPUSH = 4] = "MEIZUPUSH", Ie[Ie.VIVOPUSH = 5] = "VIVOPUSH", Ie[Ie.OPPOPUSH = 6] = "OPPOPUSH", Ie[Ie.HONORPUSH = 7] = "HONORPUSH";
        }(Le || (Le = {})), function(Ie) {
          Ie[Ie.OK = 0] = "OK", Ie[Ie.FAIL = 1] = "FAIL", Ie[Ie.UNAUTHORIZED = 2] = "UNAUTHORIZED", Ie[Ie.MISSING_PARAMETER = 3] = "MISSING_PARAMETER", Ie[Ie.WRONG_PARAMETER = 4] = "WRONG_PARAMETER", Ie[Ie.REDIRECT = 5] = "REDIRECT", Ie[Ie.TOKEN_EXPIRED = 6] = "TOKEN_EXPIRED", Ie[Ie.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", Ie[Ie.NO_ROUTE = 8] = "NO_ROUTE", Ie[Ie.UNKNOWN_COMMAND = 9] = "UNKNOWN_COMMAND", Ie[Ie.PB_PARSER_ERROR = 10] = "PB_PARSER_ERROR", Ie[Ie.BIND_ANOTHER_DEVICE = 11] = "BIND_ANOTHER_DEVICE", Ie[Ie.IM_FORBIDDEN = 12] = "IM_FORBIDDEN", Ie[Ie.TOO_MANY_DEVICES = 13] = "TOO_MANY_DEVICES", Ie[Ie.PLATFORM_LIMIT = 14] = "PLATFORM_LIMIT", Ie[Ie.USER_MUTED = 15] = "USER_MUTED", Ie[Ie.ENCRYPT_DISABLE = 16] = "ENCRYPT_DISABLE", Ie[Ie.ENCRYPT_ENABLE = 17] = "ENCRYPT_ENABLE", Ie[Ie.DECRYPT_FAILURE = 18] = "DECRYPT_FAILURE", Ie[Ie.PERMISSION_DENIED_EXTERNAL = 19] = "PERMISSION_DENIED_EXTERNAL";
        }(Te || (Te = {}));
        var xe = ["txt", "img", "video", "audio", "file", "loc", "custom", "cmd", "combine"], be = H.P6.getEnvInfo();
        function $e() {
          var Ie, x, ae, Q, Z = "webim", ge = "", me = "", ve = [], ie = (/* @__PURE__ */ new Date()).valueOf(), ye = H.P6.getDevicePlatform(be);
          if (this.isFixedDeviceId) {
            var Ye = H.P6.getLocalDeviceInfo();
            if (Ye) {
              var ne = JSON.parse(Ye);
              Z = ne.deviceId, ge = ne.deviceName, me = ne.deviceUuid;
            } else this.deviceId === "webim" ? (me = "".concat(ye, "_").concat(ie.toString()), Z = "".concat(this.deviceId, "_").concat(me), ge = this.deviceId) : Z = ge = me = "webim_".concat(ye, "_").concat(this.deviceId), H.P6.setLocalDeviceInfo(JSON.stringify({ deviceId: Z, deviceName: ge, deviceUuid: me }));
          } else this.deviceId === "webim" ? (me = "random_".concat(ye, "_").concat(ie.toString()), Z = "".concat(this.deviceId, "_").concat(me), ge = this.deviceId) : Z = ge = me = "webim_".concat(ye, "_").concat(this.deviceId);
          this.context.jid && (this.context.jid.clientResource = Z);
          var Qe = this.root.lookup("easemob.pb.Provision"), W = Qe.decode(ve);
          W.compressType = this.compressType, W.encryptType = this.encryptType, W.osType = this.osType, W.version = this.version, W.deviceName = ge, W.resource = Z, W.deviceUuid = me, W.authToken = '{"token":"$t$' + this.token + '"}', W.sessionId = Date.now().toString() + ":", this.loginInfoCustomExt && (W.reason = this.loginInfoCustomExt), g.kg.debug("provision info", { version: this.version, resource: Z, isFixedDeviceId: this.isFixedDeviceId, loginInfoCustomExt: !!this.loginInfoCustomExt, token: ((x = (Ie = this.token) === null || Ie === void 0 ? void 0 : Ie.slice) === null || x === void 0 ? void 0 : x.call(Ie, 0, 10)) + "...", userId: (Q = (ae = this.context) === null || ae === void 0 ? void 0 : ae.jid) === null || Q === void 0 ? void 0 : Q.name }), W.actionVersion = "v5.0", W = Qe.encode(W).finish();
          var ce = this.root.lookup("easemob.pb.MSync"), fe = ce.decode(ve);
          return fe.version = this.version, fe.guid = this.context.jid, fe.auth = "$t$" + this.token, fe.command = 3, fe.deviceId = ge, fe.serviceId = this.dataReport.getServiceId(), fe.encryptType = this.encryptType, fe.payload = W, ce.encode(fe).finish();
        }
        function Be(Ie, x) {
          var ae = this, Q = H.P6.getEnvInfo();
          if (Q.platform === "zfb" || Q.platform === "dd") {
            for (var Z = "", ge = 0; ge < Ie.length; ge++) Z += String.fromCharCode(Ie[ge]);
            return { data: Z = d().btoa(Z), isBuffer: !1, complete: function() {
            }, fail: function(ve) {
              ve.errMsg !== "sendSocketMessage:fail taskID not exist" && ve.errMsg !== "SocketTast.send:fail SocketTask.readyState is not OPEN" || (g.kg.debug("send message fail and reconnect"), ae.reconnecting || ae.reconnect()), x && ae._msgHash && ae._msgHash[x] && ae._msgHash[x].fail({ id: x });
            } };
          }
          var me = Ie;
          return { data: me.buffer.slice(me.byteOffset, me.byteOffset + me.byteLength), fail: function(ve) {
            ve.errMsg !== "sendSocketMessage:fail taskID not exist" && ve.errMsg !== "SocketTast.send:fail SocketTask.readyState is not OPEN" || ae.reconnecting || ae.reconnect(), x && ae._msgHash && ae._msgHash[x] && ae._msgHash[x].fail({ id: x });
          } };
        }
        function Ke(Ie, x) {
          var ae;
          return Oe(this, void 0, void 0, function() {
            var Q, Z, ge, me, ve, ie;
            return Pe(this, function(ye) {
              switch (ye.label) {
                case 0:
                  for (g.kg.debug("distributeMeta, metas length: ", Ie.length), Q = [], Z = function(Ye) {
                    var ne = Ie[Ye], Qe = new (m())(ne.id.low, ne.id.high, ne.id.unsigned).toString(), W = ne.from.name, ce = ne.to ? ne.to.name : "", fe = !!ne.to && ne.to.domain.indexOf("conference") !== -1;
                    if (ge._load_msg_cache.some(function(we) {
                      return we.msgId === Qe;
                    })) return "continue";
                    switch (ge._load_msg_cache.length <= ge.max_cache_length || ge._load_msg_cache.shift(), ge._load_msg_cache.push({ msgId: Qe, from: W, to: ce, isGroup: fe }), ne.ns) {
                      case 0:
                        k.call(ge, ne);
                        break;
                      case 1:
                        Q.push(y.Z.call(ge, ne, x, !1, !0, !0));
                        break;
                      case 2:
                        w.call(ge, ne);
                        break;
                      case 3:
                        _.handleRosterMsg.call(ge, ne);
                        break;
                      case 4:
                        ge.registerConfrIQHandler && ge.registerConfrIQHandler(ne, x, ge);
                        break;
                      case 5:
                        V.call(ge, ne);
                        break;
                      default:
                        g.kg.error("distributeMeta", ne);
                    }
                  }, ge = this, me = 0; me < Ie.length; me++) Z(me);
                  return [4, Promise.all(Q)];
                case 1:
                  return ve = ye.sent(), (ie = ve.filter(function(Ye) {
                    return Ye && Ye.type !== "cmd";
                  })).length > 0 && ((ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onMessage", ie)), [2];
              }
            });
          });
        }
        function Ze(Ie, x) {
          Ke.call(this, Ie, x);
        }
        function at(Ie) {
          var x;
          this._offlineMessagePullState === se.a.SYNC_INIT && (this._offlineMessagePullState = se.a.SYNC_START, this._offlineMessagePullQueue = Ie.unread.reduce(function(ae, Q) {
            return ae.find(function(Z) {
              return Z.name === Q.queue.name;
            }) || ae.push(Q.queue), ae;
          }, []), (x = this.eventHandler) === null || x === void 0 || x.dispatch("onOfflineMessageSyncStart"));
        }
        function pt(Ie) {
          var x;
          if (this._offlineMessagePullState === se.a.SYNC_START) {
            var ae = this._offlineMessagePullQueue.findIndex(function(Q) {
              return Q.name === Ie.queue.name;
            });
            ae > -1 && this._offlineMessagePullQueue.splice(ae, 1), this._offlineMessagePullQueue.length === 0 && (this._offlineMessagePullState = se.a.SYNC_FINISH, (x = this.eventHandler) === null || x === void 0 || x.dispatch("onOfflineMessageSyncFinish"));
          }
        }
        function It(Ie) {
          var x = this.root.lookup("easemob.pb.CommUnreadDL");
          x = x.decode(Ie.payload);
          var ae = new (m())(x.timestamp.low, x.timestamp.high, x.timestamp.unsigned).toString();
          if (this.expirationTime && this.compareTokenExpireTime(Number(ae), this.expirationTime), x.unread.length === 0) Et.call(this);
          else {
            at.call(this, x), g.kg.debug("pull unread message", x.unread);
            for (var Q = 0; Q < x.unread.length; Q++) it.call(this, x.unread[Q].queue);
          }
          Et.call(this);
        }
        function Rt() {
          var Ie = [], x = this.root.lookup("easemob.pb.StatisticsBody"), ae = x.decode(Ie);
          ae.operation = 0, ae = x.encode(ae).finish();
          var Q = this.root.lookup("easemob.pb.Meta").decode(Ie);
          Q.id = (/* @__PURE__ */ new Date()).valueOf(), Q.ns = 0, Q.payload = ae;
          var Z = this.root.lookup("easemob.pb.CommSyncUL"), ge = Z.decode(Ie);
          ge.meta = Q, ge = Z.encode(ge).finish();
          var me = this.root.lookup("easemob.pb.MSync"), ve = me.decode(Ie);
          return ve.version = this.version, ve.encryptType = [0], ve.command = 0, ve.payload = ge, me.encode(ve).finish();
        }
        function gt(Ie) {
          var x = [], ae = this.root.lookup("easemob.pb.CommSyncUL"), Q = ae.decode(x);
          Q.queue = Ie, Q = ae.encode(Q).finish();
          var Z = this.root.lookup("easemob.pb.MSync"), ge = Z.decode(x);
          return ge.version = this.version, ge.encryptType = this.encryptType, ge.command = 0, ge.payload = Q, Z.encode(ge).finish();
        }
        function it(Ie) {
          g.kg.debug("sendBackqueue", Ie);
          var x = gt.call(this, Ie);
          lt.call(this, x);
        }
        function Tt(Ie, x) {
          var ae = [], Q = this.root.lookup("easemob.pb.CommSyncUL"), Z = Q.decode(ae);
          Z.queue = x, Z.key = new (m())(Ie.low, Ie.high, Ie.unsigned).toString(), Z = Q.encode(Z).finish();
          var ge = this.root.lookup("easemob.pb.MSync"), me = ge.decode(ae);
          return me.version = this.version, me.encryptType = this.encryptType, me.command = 0, me.payload = Z, ge.encode(me).finish();
        }
        function Ut() {
          var Ie = this;
          this.uniPush && this.isRegisterPush === !1 && (this.isRegisterPush = !0, this.uniPush.onRegister(function(x) {
            g.kg.debug("push token onRegister", x);
            var ae = Ie.uniPushConfig || {}, Q = ae.APNsCertificateName, Z = Q === void 0 ? "" : Q, ge = ae.HMSCertificateName, me = ge === void 0 ? "" : ge, ve = ae.HONORCertificateName, ie = ve === void 0 ? "" : ve, ye = ae.MEIZUCertificateName, Ye = ye === void 0 ? "" : ye, ne = ae.MICertificateName, Qe = ne === void 0 ? "" : ne, W = ae.OPPOCertificateName, ce = W === void 0 ? "" : W, fe = ae.VIVOCertificateName, we = fe === void 0 ? "" : fe;
            switch (x.push_type) {
              case Le.APNs:
                Ie.pushCertificateName = Z;
                break;
              case Le.HMSPUSH:
                Ie.pushCertificateName = me;
                break;
              case Le.HONORPUSH:
                Ie.pushCertificateName = ie;
                break;
              case Le.MEIZUPUSH:
                Ie.pushCertificateName = Ye;
                break;
              case Le.MIPUSH:
                Ie.pushCertificateName = Qe;
                break;
              case Le.OPPOPUSH:
                Ie.pushCertificateName = ce;
                break;
              case Le.VIVOPUSH:
                Ie.pushCertificateName = we;
                break;
              default:
                g.kg.error("unexpected push type", x.push_type);
            }
            Ie.pushCertificateName && x.push_token && ee.r.call(Ie, { deviceId: Ie.clientResource, deviceToken: x.push_token, notifierName: Ie.pushCertificateName }).then(function() {
              g.kg.debug("uploadPushToken success");
            }).catch(function(Fe) {
              g.kg.debug("uploadPushToken failed", Fe);
            });
          }));
        }
        function st() {
          var Ie;
          this._offlineMessagePullState = se.a.SYNC_INIT, this._offlineMessagePullQueue = [], this.times = 1, this.autoReconnectNumTotal = 0, this.onOpened && this.onOpened(), Ut.call(this), (Ie = this.eventHandler) === null || Ie === void 0 || Ie.dispatch("onConnected"), wt.call(this), St.call(this), ut.call(this), Et.call(this);
        }
        function Ot(Ie, x) {
          g.kg.debug("sendLastSession", Ie);
          var ae = Tt.call(this, Ie, x);
          lt.call(this, ae);
        }
        function kt(Ie) {
          var x, ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe = this, we = this.root.lookup("easemob.pb.Provision").decode(Ie.payload);
          if (this.context.jid && (this.context.jid.clientResource = we.resource), this.clientResource = we.resource, this.provisionTimer && clearTimeout(this.provisionTimer), g.kg.debug("receiveProvisionResult", we.status), this._isLogging = !1, we.status.errorCode === Te.OK) {
            if (this.disconnectedReason = void 0, we.authToken) {
              var Fe = JSON.parse(we.authToken).expires_in;
              if (!this.tokenExpiredTimer && !this.tokenWillExpireTimer) {
                var je = Date.now();
                this.expirationTime = Fe;
                var qe = this.expirationTime - je;
                this.expiresIn = qe < 0 ? 0 : qe, this.tokenExpireTimeCountDown(this.expiresIn);
              }
            }
            this.reconnecting = !1, this.logOut = !1, this.needSetReadyState && (this.sock = K(K({}, this.sock), { close: this.sock.close, send: this.sock.send, readyState: 1 })), this._localCache ? !((x = this._localCache) === null || x === void 0) && x.getInstance() ? st.call(this) : this._localCache && new this._localCache({ user: this.user, dbName: "cache_".concat(Math.abs((0, ue.un)(this.appKey || this.appId)), "_").concat(this.user), version: 2, onInit: function() {
              return Oe(fe, void 0, void 0, function() {
                return Pe(this, function(Kt) {
                  return g.kg.debug("localCache init success"), st.call(this), [2];
                });
              });
            } }) : st.call(this), (ae = this.connectionResolve) === null || ae === void 0 || ae.call(this);
          } else {
            var et = void 0, bt = we.status, ot = bt.reason, Lt = bt.errorCode;
            switch (g.kg.debug("provision errorCode: ", Lt), g.kg.debug("provision reason: ", ot), Lt) {
              case Te.FAIL:
                et = ot === "Sorry, user register limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the number of user registrations limit has been reached" }) : ot === "Sorry, user register rate limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, user register rate limit" }) : ot === "Sorry, token expired" ? I.Z.create({ type: E.E.WEBIM_TOKEN_EXPIRED, message: "Sorry, token expired" }) : ot === "Sorry, token or password does not match login info" ? I.Z.create({ type: E.E.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR, message: "INVALID_TOKEN" }) : ot === "Sorry, user not found" ? I.Z.create({ type: E.E.USER_NOT_FOUND, message: "User not found" }) : I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: "Auth failed" }), (Q = this.connectionReject) === null || Q === void 0 || Q.call(this, et), (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onError", et);
                break;
              case Te.WRONG_PARAMETER:
                et = I.Z.create({ type: E.E.REQUEST_PARAMETER_ERROR, message: "Invalid parameter" }), (ge = this.connectionReject) === null || ge === void 0 || ge.call(this, et), (me = this.eventHandler) === null || me === void 0 || me.dispatch("onError", et);
                break;
              case Te.UNAUTHORIZED:
                et = I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: "Auth failed" }), (ve = this.connectionReject) === null || ve === void 0 || ve.call(this, et), (ie = this.eventHandler) === null || ie === void 0 || ie.dispatch("onError", et);
                break;
              case Te.IM_FORBIDDEN:
                et = I.Z.create({ type: E.E.WEBIM_SERVER_SERVING_DISABLED, message: "Server serving disabled." }), (ye = this.connectionReject) === null || ye === void 0 || ye.call(this, et), (Ye = this.eventHandler) === null || Ye === void 0 || Ye.dispatch("onError", et);
                break;
              case Te.PERMISSION_DENIED:
                et = ot === "Sorry, the app month live count limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the monthly active user limit for this app has been reached" }) : ot === "Sorry, the app day live count limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the daily active user limit for this app has been reached" }) : ot === "Sorry, the app online count limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the maximum number limit of online users for this app has been reached" }) : I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: "Auth failed" }), (ne = this.connectionReject) === null || ne === void 0 || ne.call(this, et), (Qe = this.eventHandler) === null || Qe === void 0 || Qe.dispatch("onError", et);
                break;
              default:
                et = I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: ot }), (W = this.connectionReject) === null || W === void 0 || W.call(this, et), (ce = this.eventHandler) === null || ce === void 0 || ce.dispatch("onError", et);
            }
            this.disconnectedReason = et;
          }
        }
        function wt() {
          var Ie, x;
          if (((Ie = this.unMSyncSendMsgMap) === null || Ie === void 0 ? void 0 : Ie.size) > 0) {
            for (var ae = Array.from(this.unMSyncSendMsgMap.keys()), Q = 0; Q < ae.length; Q++) {
              var Z = this.unMSyncSendMsgMap.get(ae[Q]);
              lt.call(this, Z, ae[Q]);
            }
            (x = this.unMSyncSendMsgMap) === null || x === void 0 || x.clear();
          }
        }
        function Et() {
          var Ie = Rt.call(this);
          lt.call(this, Ie);
        }
        function ut() {
          g.kg.debug("sendUnreadDeal");
          var Ie = Ht.call(this);
          lt.call(this, Ie);
        }
        function St() {
          var Ie = this;
          Ft.call(this), this.heartBeatID = setInterval(function() {
            (Date.now() - Ie.lastHeartbeat) / 1e3 >= 30 && (g.kg.debug("send heart beat"), ut.call(Ie), Ie.lastHeartbeat = Date.now());
          }, this.heartBeatWait);
        }
        function Ft() {
          clearInterval(this.heartBeatID);
        }
        function Ht() {
          var Ie = this.root.lookup("easemob.pb.MSync"), x = Ie.decode([]);
          return x.version = this.version, x.encryptType = this.encryptType, x.command = 1, Ie.encode(x).finish();
        }
        function zt(Ie, x) {
          return Ie.some(function(ae) {
            return ae.name === x.name;
          });
        }
        function ze(Ie) {
          var x = this.root.lookup("easemob.pb.CommNotice").decode(Ie.payload), ae = zt(this._queues, x.queue);
          g.kg.debug("receive notice", x.queue, this._queues), ae || this.clientResource === x.queue.clientResource && x.queue.name === this.context.userId || (this._queues.push(x.queue), this._queues.length === 1 && it.call(this, x.queue));
        }
        function Ne(Ie) {
          return Oe(this, void 0, void 0, function() {
            var x, ae, Q, Z, ge, me, ve, ie;
            return Pe(this, function(ye) {
              if (x = H.P6.getEnvInfo(), ae = this.root.lookup("easemob.pb.MSync"), this.name === "miniCore" || x.platform === "web") {
                try {
                  Z = new Uint8Array(Ie.data), Q = ae.decode(Z);
                } catch {
                  throw new Error("decode message fail.");
                }
                return [2, Q];
              }
              if (x.platform === "zfb" || x.platform === "dd") {
                for (ge = d().atob(Ie.data), me = [], ve = 0, ie = ge.length; ve < ie; ++ve) me.push(ge.charCodeAt(ve));
                return [2, ae.decode(me)];
              }
              try {
                Q = ae.decode(Ie.data);
              } catch {
                throw new Error("decode message fail.");
              }
              return [2, Q];
            });
          });
        }
        function le(Ie) {
          var x = this;
          this.lastHeartbeat = Date.now(), this.probingTimer && clearTimeout(this.probingTimer), Ie.then(function(ae) {
            if (ae) switch (ae.command) {
              case 0:
                X.call(x, ae);
                break;
              case 1:
                It.call(x, ae);
                break;
              case 2:
                ze.call(x, ae);
                break;
              case 3:
                kt.call(x, ae);
                break;
              default:
                g.kg.error("unexpected msync command: ".concat(ae.command));
            }
            else g.kg.error("unexpected msync result: ".concat(ae));
          });
        }
        function X(Ie) {
          var x, ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we, Fe, je, qe, et, bt, ot, Lt, Kt, $t, yt, Wt, In, gn, zn, Xn, yr, ur, Yn, xi, gs, Or, da, Za, js, Fs, la, Gs, ka, Vs, ja;
          return Oe(this, void 0, void 0, function() {
            var Xt, Wn, Mt, Nc, To, ou, Ku, cu, bo, Ju, Yo, Xo, Bd, zd, wc, Qa, Ql, $l, ef, Ua, tf, nf, Zu, Wo, Qu, rf, $u, qo, ba, Ts, Fd, Kr, uu, Ko, Zi, Hr, Di, os, Aa, Ao, Hi, Qi, Ha, ed, Ei, cs = this;
            return Pe(this, function(ci) {
              switch (ci.label) {
                case 0:
                  if (Xt = (Xt = this.root.lookup("easemob.pb.CommSyncDL")).decode(Ie.payload), Wn = new (m())(Xt.serverId.low, Xt.serverId.high, Xt.serverId.unsigned).toString(), Mt = new (m())(Xt.metaId.low, Xt.metaId.high, Xt.metaId.unsigned).toString(), !(Number(Mt) > 0)) return [3, 23];
                  if (clearTimeout((x = this._msgHash[Mt]) === null || x === void 0 ? void 0 : x.messageTimer), !Xt.status) return [3, 22];
                  if (Xt.status.errorCode !== 0) return [3, 21];
                  if ((Nc = this._msgHash[Mt]) != null && Nc.isHandleChatroom) {
                    try {
                      if (To = ((ae = this._msgHash[Mt]) === null || ae === void 0 ? void 0 : ae.operation) === "join") {
                        ou = {};
                        try {
                          Xt.metas.length > 0 && (Ku = this.root.lookup("easemob.pb.MUCBody"), cu = Ku.decode(Xt.metas[0].payload), (bo = JSON.parse(cu.status.chatroomInfo || "{}")[this.user]) && (ou = { isAllMembersMuted: bo.is_all_mute, createTimestamp: bo.create_timestamp, isInAllowlist: bo.is_in_white_list, memberCount: bo.member_count, muteExpireTimestamp: bo.mute_duration ? bo.mute_duration : -1 }));
                        } catch (bs) {
                          g.kg.error("decode chat room info error", bs);
                        }
                        ((Q = this._msgHash[Mt]) === null || Q === void 0 ? void 0 : Q.resolve) instanceof Function && this._msgHash[Mt].resolve({ type: 0, data: { action: "apply", id: this._msgHash[Mt].roomId, result: !0, user: this.context.userId, info: ou } }), ((Z = this._msgHash[Mt]) === null || Z === void 0 ? void 0 : Z.success) instanceof Function && this._msgHash[Mt].success({ type: 0, data: { action: "apply", id: this._msgHash[Mt].roomId, result: !0, user: this.context.userId, info: ou } });
                      }
                      ((ge = this._msgHash[Mt]) === null || ge === void 0 ? void 0 : ge.resolve) instanceof Function && !To && this._msgHash[Mt].resolve({ type: 0, data: { result: !0 } }), ((me = this._msgHash[Mt]) === null || me === void 0 ? void 0 : me.success) instanceof Function && !To && this._msgHash[Mt].success({ type: 0, data: { result: !0 } }), de.iO.has(Mt) && (Ju = de.iO.get(Mt), Aa = Ju.rpt, Ao = Ju.requestName, Aa({ isEndApi: !0, data: { isSuccess: 1, requestName: Ao, requestMethod: "WEBSOCKET", requestUrl: this.url, code: he.dd.success } }), de.iO.delete(Mt));
                    } catch (bs) {
                      de.iO.has(Mt) && (Yo = de.iO.get(Mt), Aa = Yo.rpt, Ao = Yo.requestName, Aa({ isEndApi: !0, data: { isSuccess: 0, requestName: Ao, requestMethod: "WEBSOCKET", requestUrl: this.url, code: he.dd.failed, codeDesc: "when executing success function error" } }), de.iO.delete(Mt)), Qi = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "when executing success function error", data: bs }), this.onError && this.onError(Qi), (ve = this.eventHandler) === null || ve === void 0 || ve.dispatch("onError", Qi);
                    }
                    delete this._msgHash[Mt];
                  }
                  return !Nc || Nc.isHandleChatroom ? [3, 20] : (Xo = null, Bd = "", zd = 0, wc = null, this._msgHash[Mt].thirdMessage ? (this._msgHash[Mt].thirdMessage.id = Xt.serverId, this._msgHash[Mt].thirdMessage.timestamp = Xt.timestamp, [4, y.Z.call(this, this._msgHash[Mt].thirdMessage, Xt.status, !0, !0)]) : [3, 2]);
                case 1:
                  wc = ci.sent(), ci.label = 2;
                case 2:
                  if (Xt.metas.length === 0) return [3, 13];
                  ci.label = 3;
                case 3:
                  switch (ci.trys.push([3, 12, , 13]), Qa = Xt.metas[0], Ql = Xt.status, Qa.ns) {
                    case 1:
                      return [3, 4];
                    case 5:
                      return [3, 9];
                  }
                  return [3, 10];
                case 4:
                  return this.useReplacedMessageContents ? [4, y.Z.call(this, Qa, Ql, !0, !0)] : [3, 8];
                case 5:
                  return wc = ci.sent(), [4, (ye = (ie = this._localCache) === null || ie === void 0 ? void 0 : ie.getInstance()) === null || ye === void 0 ? void 0 : ye.getMessageByServerMsgId(Mt)];
                case 6:
                  return ($l = ci.sent()) ? [4, (ne = (Ye = this._localCache) === null || Ye === void 0 ? void 0 : Ye.getInstance()) === null || ne === void 0 ? void 0 : ne.putMessageToDB(K(K(K({}, $l), wc), { id: Mt }))] : [3, 8];
                case 7:
                  ci.sent(), ci.label = 8;
                case 8:
                  return [3, 11];
                case 9:
                  return (ef = H.P6.parseNotify(Xt.metas[0].payload)).edit_msg && (Ua = ef.edit_msg, tf = Ua.count, nf = Ua.operator, Zu = Ua.edit_time, Wo = Ua.sender, Qu = Ua.send_time, Xo = { operationTime: Zu, operatorId: nf, operationCount: tf }, Bd = Wo, zd = Number(Qu)), [3, 11];
                case 10:
                  return g.kg.error("decode local meta error", Qa), [3, 11];
                case 11:
                  return [3, 13];
                case 12:
                  return rf = ci.sent(), Qi = I.Z.create({ type: E.E.WEBIM_LOAD_MSG_ERROR, message: "decode local meta message error", data: rf }), this.onError && this.onError(Qi), (Qe = this.eventHandler) === null || Qe === void 0 || Qe.dispatch("onError", Qi), [3, 13];
                case 13:
                  de.TJ.has(Mt) && (de.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 1, requestMethod: "WEBSOCKET", requestUrl: this.url, code: he.dd.success, msgId: Wn } }), de.TJ.delete(Mt)), ci.label = 14;
                case 14:
                  return ci.trys.push([14, 18, , 19]), $u = { localMsgId: Mt, serverMsgId: Wn }, Xo && (this._msgHash[Mt].modifiedInfo = Xo, qo = this._msgHash[Mt], ba = qo.editMessageId, Hr = qo.type, Ts = qo.chatType, Fd = qo.msg, Kr = qo.to, uu = qo.translations, Ko = { id: ba, type: Hr, chatType: Ts, msg: Fd, modifiedInfo: Xo, to: Kr, from: Bd, time: Number(zd) }, uu && (Ko.translations = uu), $u.message = Ko, (fe = (ce = (W = this._localCache) === null || W === void 0 ? void 0 : W.getInstance()) === null || ce === void 0 ? void 0 : ce.getMessageByServerMsgId(ba)) === null || fe === void 0 || fe.then(function(bs) {
                    var Oa, Gd;
                    bs && bs.type === "txt" && ((Gd = (Oa = cs._localCache) === null || Oa === void 0 ? void 0 : Oa.getInstance()) === null || Gd === void 0 || Gd.putMessageToDB(K(K({}, bs), { msg: Ko.msg, modifiedInfo: Ko.modifiedInfo, translations: Ko.translations })));
                  })), wc && ($u.message = wc), [4, (Fe = (we = this._localCache) === null || we === void 0 ? void 0 : we.getInstance()) === null || Fe === void 0 ? void 0 : Fe.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.SUCCESS })];
                case 15:
                  return ci.sent(), ((je = this._msgHash[Mt]) === null || je === void 0 ? void 0 : je.success) instanceof Function ? [4, this._msgHash[Mt].success(Mt, Wn)] : [3, 17];
                case 16:
                  ci.sent(), ci.label = 17;
                case 17:
                  return ((qe = this._msgHash[Mt]) === null || qe === void 0 ? void 0 : qe.resolve) instanceof Function && this._msgHash[Mt].resolve($u), [3, 19];
                case 18:
                  return Zi = ci.sent(), Qi = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "when executing success function error", data: Zi }), this.onError && this.onError(Qi), (et = this.eventHandler) === null || et === void 0 || et.dispatch("onError", Qi), [3, 19];
                case 19:
                  this.onReceivedMessage && this.onReceivedMessage({ id: Mt, mid: Wn, to: this._msgHash[Mt].to, time: 0 }), (bt = this.eventHandler) === null || bt === void 0 || bt.dispatch("onReceivedMessage", { id: Mt, mid: Wn, to: this._msgHash[Mt].to }), delete this._msgHash[Mt], ci.label = 20;
                case 20:
                  return [3, 22];
                case 21:
                  if (Xt.status.errorCode === 15) ((ot = this._msgHash[Mt]) === null || ot === void 0 ? void 0 : ot.fail) instanceof Function && this._msgHash[Mt].fail({ type: E.E.SERVICE_NOT_ALLOW_MESSAGING_MUTE, reason: "you were muted" }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject({ type: E.E.SERVICE_NOT_ALLOW_MESSAGING_MUTE, reason: "you were muted" }), (Kt = (Lt = this._localCache) === null || Lt === void 0 ? void 0 : Lt.getInstance()) === null || Kt === void 0 || Kt.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL });
                  else if (Xt.status.errorCode === 1) {
                    switch (Hr = void 0, Xt.status.reason) {
                      case "blocked":
                        Hr = E.E.PERMISSION_DENIED;
                        break;
                      case "group not found":
                        Hr = E.E.GROUP_NOT_EXIST;
                        break;
                      case "not in group or chatroom":
                        Hr = E.E.GROUP_NOT_JOINED;
                        break;
                      case "exceed recall time limit":
                        Hr = E.E.MESSAGE_RECALL_TIME_LIMIT;
                        break;
                      case "message recall disabled":
                        Hr = E.E.SERVICE_NOT_ENABLED;
                        break;
                      case "not in group or chatroom white list":
                        Hr = E.E.SERVICE_NOT_ALLOW_MESSAGING;
                        break;
                      case "nonroster":
                        Hr = E.E.USER_NOT_FRIEND, Xt.status.reason = "not contact";
                        break;
                      case "group is disabled":
                        Hr = E.E.GROUP_IS_DISABLED, Xt.status.reason = "group is disabled";
                        break;
                      case "limit directed users":
                        Hr = E.E.MAX_LIMIT;
                        break;
                      case "Sorry, edit limit reached":
                        Hr = E.E.MAX_LIMIT, Xt.status.reason = "Modify message limit reached";
                        break;
                      case "Sorry, message does not exist":
                        Hr = E.E.MODIFY_MESSAGE_NOT_EXIST, Xt.status.reason = "The message does not exist.";
                        break;
                      case "Sorry, You do not have permission":
                        Hr = E.E.PERMISSION_DENIED, Xt.status.reason = "You do not have the modified permission.";
                        break;
                      case "Sorry, format is incorrect":
                        Hr = E.E.MODIFY_MESSAGE_FORMAT_ERROR, Xt.status.reason = "The modify messaged format error.";
                        break;
                      case "Sorry, edit is not available":
                        Hr = E.E.SERVICE_NOT_ENABLED, Xt.status.reason = "The message modify function is not activated.";
                        break;
                      case "Sorry, edit fail":
                        Hr = E.E.MODIFY_MESSAGE_FAILED, Xt.status.reason = "Modify message failed.";
                        break;
                      default:
                        Xt.status.reason.includes("grpID") && Xt.status.reason.includes("does not exist!") ? (Hr = E.E.CHATROOM_NOT_EXIST, Xt.status.reason = "The chat room dose not exist.") : Xt.status.reason.includes("username") && Xt.status.reason.includes("doesn't exist!") ? Hr = E.E.USER_NOT_FOUND : Xt.status.reason === "group member list is full!" ? Hr = E.E.CHATROOM_MEMBERS_FULL : Xt.status.reason.includes("can not join this group") && Xt.status.reason.includes("is in the blacklist") ? (Hr = E.E.PERMISSION_DENIED, Xt.status.reason = "permission denied") : Xt.status.reason === "can not operate this group, reason: group is disabled" ? Hr = E.E.GROUP_IS_DISABLED : Xt.status.reason.includes("moderation") ? Hr = E.E.MESSAGE_MODERATION_BLOCKED : Xt.status.reason.includes("group ID illegal, please check it") ? (Hr = E.E.REQUEST_PARAMETER_ERROR, Xt.status.reason = "Invalid parameter") : Hr = Xt.status.reason.includes("has create too many chatrooms") || Xt.status.reason.includes("has joined too many chatrooms") ? E.E.MAX_LIMIT : Xt.status.reason.includes("auto create failed") ? E.E.SERVER_BUSY : E.E.SERVER_UNKNOWN_ERROR;
                    }
                    this._msgHash[Mt] && (!(($t = this._msgHash[Mt]) === null || $t === void 0) && $t.isHandleChatroom ? (Hi = I.Z.create({ type: Hr, message: Xt.status.reason || "", data: "" }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].error instanceof Function && this._msgHash[Mt].error(Hi), de.iO.has(Mt) && (Di = he.dd.failed, Hr === E.E.CHATROOM_NOT_EXIST ? Di = he.dd.notFound : Hr === E.E.CHATROOM_MEMBERS_FULL && (Di = he.dd.reachLimit), os = de.iO.get(Mt), Aa = os.rpt, Ao = os.requestName, Aa({ isEndApi: !0, data: { isSuccess: 0, requestName: Ao, requestMethod: "WEBSOCKET", requestUrl: this.url, code: Di, codeDesc: Xt.status.reason } }), de.iO.delete(Mt))) : (Hi = I.Z.create({ type: Hr, message: Xt.status.reason || "", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: Hr, reason: Xt.status.reason ? Xt.status.reason : "", data: { id: Mt, mid: Wn } }), (Wt = (yt = this._localCache) === null || yt === void 0 ? void 0 : yt.getInstance()) === null || Wt === void 0 || Wt.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })), delete this._msgHash[Mt]);
                  } else if (Xt.status.errorCode === 7) Xt.status.reason === "sensitive words" && this._msgHash[Mt] ? (Hi = I.Z.create({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, message: "sensitive words", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, data: { id: Mt, mid: Wn, reason: "sensitive words" } }), (gn = (In = this._localCache) === null || In === void 0 ? void 0 : In.getInstance()) === null || gn === void 0 || gn.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "blocked by mod_antispam" && this._msgHash[Mt] ? (Hi = I.Z.create({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, message: "blocked by mod_antispam", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, data: { id: Mt, mid: Wn, reason: "blocked by mod_antispam" } }), (Xn = (zn = this._localCache) === null || zn === void 0 ? void 0 : zn.getInstance()) === null || Xn === void 0 || Xn.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "user is mute" && this._msgHash[Mt] ? (Hi = I.Z.create({ type: E.E.USER_MUTED_BY_ADMIN, message: "user is mute", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail(Hi), (ur = (yr = this._localCache) === null || yr === void 0 ? void 0 : yr.getInstance()) === null || ur === void 0 || ur.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "traffic limit" && this._msgHash[Mt] ? (Hi = I.Z.create({ type: E.E.MESSAGE_CURRENT_LIMITING, message: "traffic limit", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail(Hi), (xi = (Yn = this._localCache) === null || Yn === void 0 ? void 0 : Yn.getInstance()) === null || xi === void 0 || xi.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "Sorry, data is too large" && this._msgHash[Mt] && (Hi = I.Z.create({ type: E.E.MESSAGE_SIZE_LIMIT, message: "Sorry, data is too large", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail(Hi), (Or = (gs = this._localCache) === null || gs === void 0 ? void 0 : gs.getInstance()) === null || Or === void 0 || Or.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL }));
                  else if (Xt.status.errorCode === 19) this._msgHash[Mt] && (de.TJ.has(Mt) && (de.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "WEBSOCKET", requestUrl: this.url, code: E.E.MESSAGE_EXTERNAL_LOGIC_BLOCKED, codeDesc: Xt.status.reason || "", msgId: Wn } }), de.TJ.delete(Mt)), Hi = I.Z.create({ type: E.E.MESSAGE_EXTERNAL_LOGIC_BLOCKED, message: Xt.status.reason || "", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.MESSAGE_EXTERNAL_LOGIC_BLOCKED, data: { id: Mt, mid: Wn, reason: Xt.status.reason } }), (Za = (da = this._localCache) === null || da === void 0 ? void 0 : da.getInstance()) === null || Za === void 0 || Za.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL }));
                  else if (this._msgHash[Mt]) {
                    de.TJ.has(Mt) && (de.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "WEBSOCKET", requestUrl: this.url, code: E.E.WEBIM_LOAD_MSG_ERROR, codeDesc: ((js = Xt.status) === null || js === void 0 ? void 0 : js.reason) || "", msgId: Wn } }), de.TJ.delete(Mt));
                    try {
                      Hi = I.Z.create({ type: E.E.WEBIM_LOAD_MSG_ERROR, message: ((Fs = Xt.status) === null || Fs === void 0 ? void 0 : Fs.reason) || "", data: { id: Mt, mid: Wn, reason: Xt.status && Xt.status.reason } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Hi), (Gs = (la = this._localCache) === null || la === void 0 ? void 0 : la.getInstance()) === null || Gs === void 0 || Gs.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL }), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.WEBIM_LOAD_MSG_ERROR, data: { errorCode: Xt.status && Xt.status.errorCode, reason: Xt.status && Xt.status.reason } });
                    } catch (bs) {
                      Qi = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "when executing fail function error", data: bs }), this.onError && this.onError(Qi), (ka = this.eventHandler) === null || ka === void 0 || ka.dispatch("onError", Qi);
                    }
                    delete this._msgHash[Mt];
                  } else de.TJ.has(Mt) && (de.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "WEBSOCKET", requestUrl: this.url, code: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, codeDesc: "on message error", msgId: Wn } }), de.TJ.delete(Mt)), Qi = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "on message error" }), this.onError && this.onError(Qi), (Vs = this.eventHandler) === null || Vs === void 0 || Vs.dispatch("onError", Qi);
                  ci.label = 22;
                case 22:
                  return [2];
                case 23:
                  if (Xt.metas && Xt.metas.length !== 0) try {
                    Ze.call(this, Xt.metas, Xt.status);
                  } catch (bs) {
                    Qi = I.Z.create({ type: E.E.WEBIM_LOAD_MSG_ERROR, message: "decode message error", data: bs }), g.kg.error("decode message error", bs), this.onError && this.onError(Qi), (ja = this.eventHandler) === null || ja === void 0 || ja.dispatch("onError", Qi);
                  } finally {
                    Xt.isLast ? (g.kg.debug("metas & CommSyncDLMessage.isLast", Xt.isLast), Ha = -1, this._queues.some(function(bs, Oa) {
                      return bs.name === Xt.name && (Ha = Oa, !0);
                    }) && Ha > 0 && this._queues.splice(Ha, 1), this._queues.length > 0 && it.call(this, this._queues[0]), pt.call(this, Xt)) : Xt.nextKey && (Ei = new (m())(Xt.nextKey.low, Xt.nextKey.high, Xt.nextKey.unsigned).toString(), g.kg.debug("nexKey:", Ei, "this.nextKey:", this.nexKey), Ei !== this.nexKey && (this.nexKey = Ei, Ot.call(this, Xt.nextKey, Xt.queue)));
                  }
                  else Xt.isLast ? (g.kg.debug("CommSyncDLMessage.isLast", Xt.isLast), ed = -1, this._queues.some(function(bs, Oa) {
                    return bs.name === Xt.queue.name && (ed = Oa, !0);
                  }) && this._queues.splice(ed, 1), this._queues.length > 0 && it.call(this, this._queues[0]), pt.call(this, Xt)) : Xt.nextKey && (Ei = new (m())(Xt.nextKey.low, Xt.nextKey.high, Xt.nextKey.unsigned).toString(), g.kg.debug("nexKey:", Ei, "this.nextKey:", this.nexKey), Ei !== this.nexKey && (this.nexKey = Ei, Ot.call(this, Xt.nextKey, Xt.queue)));
                  return [2];
              }
            });
          });
        }
        function re(Ie) {
          var x = [], ae = this.root.lookup("easemob.pb.KeyValue"), Q = [];
          for (var Z in Ie) {
            var ge = ae.decode(x);
            if (ge.key = Z, Ie[Z] !== void 0) {
              if (Ce(Ie[Z]) === "object") ge.type = 8, ge.stringValue = JSON.stringify(Ie[Z]);
              else if (typeof Ie[Z] == "string") ge.type = 7, ge.stringValue = Ie[Z];
              else if (typeof Ie[Z] == "boolean") ge.type = 1, ge.varintValue = Ie[Z] === !0 ? 1 : 0;
              else if (Number.isInteger(Ie[Z])) ge.type = 2, ge.varintValue = Ie[Z];
              else if (typeof Ie[Z] == "bigint" || Ce(Ie[Z]) === "symbol" || typeof Ie[Z] == "function" || Number.isNaN(Ie[Z])) ge.type = 7, ge.stringValue = Ie[Z].toString();
              else {
                if (typeof Ie[Z] != "number" || Number.isInteger(Ie[Z])) continue;
                ge.type = 6, ge.doubleValue = Ie[Z];
              }
              Q.push(ge);
            }
          }
          return Q;
        }
        function Me(Ie) {
          var x, ae, Q, Z = [];
          if (this.root) {
            var ge, me = this.root.lookup("easemob.pb.MessageBody.Content").decode(Z);
            switch (ge = !Ie.group && ((x = Ie == null ? void 0 : Ie.chatType) === null || x === void 0 ? void 0 : x.toLowerCase()) !== "groupchat" || Ie.roomType ? Ie.group && Ie.roomType || ((ae = Ie == null ? void 0 : Ie.chatType) === null || ae === void 0 ? void 0 : ae.toLowerCase()) === "chatroom" ? "chatRoom" : "singleChat" : "groupChat", Ie.type) {
              case "txt":
                me.type = 0, me.text = Ie.msg;
                break;
              case "img":
                me.type = 1, Ie.body ? (me.displayName = Ie.body.filename, me.remotePath = Ie.body.url, me.secretKey = Ie.body.secret, me.fileLength = Ie.body.file_length, me.size = Ie.body.size, me.thumbnailDisplayName = Ie.body.filename) : Ie.file ? (me.displayName = Ie.file.filename, me.remotePath = Ie.file.url, me.secretKey = Ie.file.secret, me.fileLength = Ie.file.file_length, me.size = Ie.file.size, me.thumbnailDisplayName = Ie.file.filename) : (me.displayName = Ie.filename, me.remotePath = Ie.url, me.secretKey = Ie.secret, me.fileLength = Ie.file_length, me.size = Ie.size, me.thumbnailDisplayName = Ie.filename), Ie.isBuildCombinedMsg && (me.remotePath = Ie.url, me.secretKey = Ie.secret, me.size = { height: Ie.height, width: Ie.width });
                break;
              case "video":
                me.type = 2, Ie.body ? (me.displayName = Ie.body.filename, me.remotePath = Ie.body.url, me.secretKey = Ie.body.secret, me.fileLength = Ie.body.file_length, me.duration = Ie.body.length, me.thumbnailDisplayName = Ie.body.filename, me.thumbnailRemotePath = this.useOwnUploadFun ? "" : "".concat(Ie.body.url, "?vframe=true"), me.thumbnailSecretKey = this.useOwnUploadFun ? "" : Ie.body.secret) : Ie.isBuildCombinedMsg && (me.displayName = Ie.filename, me.remotePath = Ie.url, me.secretKey = Ie.secret, me.fileLength = Ie.file_length, me.duration = Ie.length, me.thumbnailDisplayName = Ie.filename, me.thumbnailRemotePath = Ie.thumb, me.thumbnailSecretKey = Ie.thumb_secret);
                break;
              case "loc":
                me.type = 3, me.latitude = Ie.lat, me.longitude = Ie.lng, me.address = Ie.addr, me.buildingName = Ie.buildingName, me.latitude = Ie.lat;
                break;
              case "audio":
                me.type = 4, Ie.body ? (me.displayName = Ie.body.filename, me.remotePath = Ie.body.url, me.secretKey = Ie.body.secret, me.fileLength = Ie.body.file_length, me.duration = Ie.body.length, me.thumbnailDisplayName = Ie.body.filename) : Ie.isBuildCombinedMsg && (me.displayName = Ie.filename, me.remotePath = Ie.url, me.secretKey = Ie.secret, me.fileLength = Ie.file_length, me.duration = Ie.length, me.thumbnailDisplayName = Ie.filename);
                break;
              case "file":
                me.type = 5, Ie.body ? (me.displayName = Ie.body.filename, me.remotePath = Ie.body.url, me.secretKey = Ie.body.secret, me.fileLength = Ie.body.file_length, me.thumbnailDisplayName = Ie.body.filename) : Ie.isBuildCombinedMsg && (me.displayName = Ie.filename, me.remotePath = Ie.url, me.secretKey = Ie.secret, me.fileLength = Ie.file_length, me.thumbnailDisplayName = Ie.filename);
                break;
              case "cmd":
                me.type = 6, me.action = Ie.action;
                break;
              case "custom":
                me.type = 7, me.customEvent = Ie.customEvent, me.customExts = re.call(this, Ie.customExts);
                break;
              case "combine":
                me.type = 0, me.subType = 0, me.text = Ie.compatibleText, me.displayName = Ie.filename, me.remotePath = Ie.url, me.secretKey = Ie.secret, me.fileLength = Ie.file_length, me.title = Ie.title, me.summary = Ie.summary, me.combineLevel = Ie.combineLevel;
            }
            var ve = [];
            Ie.ext && (ve = re.call(this, Ie.ext));
            var ie = this.root.lookup("easemob.pb.MessageBody"), ye = ie.decode(Z), Ye = Ie.from || this.context.jid.name;
            ye.from = { name: Ie.isBuildCombinedMsg ? Ye : this.context.jid.name };
            var ne = Ie.to.indexOf("/"), Qe = ne > -1 ? Ie.to.substring(0, ne) : Ie.to;
            if (ye.to = { name: Qe }, Ie.type === "channel") ye.type = _e.CHANNEL_ACK;
            else if (Ie.type === "recall") ye.type = _e.RECALL, ye.ackMessageId = Ie.ackId;
            else if (Ie.type === "delivery") ye.type = _e.DELIVER_ACK, ye.ackMessageId = Ie.ackId;
            else if (Ie.type === "read") ye.type = _e.READ_ACK, ye.ackMessageId = Ie.ackId, ge === "groupChat" && (ye.msgConfig = { allowGroupAck: !0 }, ye.ackContent = Ie.ackContent);
            else if (ge === "chatRoom") ye.type = _e.CHATROOM;
            else if (ge === "groupChat") {
              if (ye.type = _e.GROUPCHAT, Ie.msgConfig) {
                var W = Ie.msgConfig.allowGroupAck;
                ye.msgConfig = { allowGroupAck: !!W };
              }
            } else ge === "singleChat" && (ye.type = _e.SINGLECHAT);
            Ie.editMessageId && (ye.type = _e.EDIT, ye.editMessageId = Ie.editMessageId), ye.contents = [me], ye.ext = ve;
            var ce = function(ot) {
              var Lt = {};
              return "translations" in ot && (Lt.translations = ot.translations), "isChatThread" in ot && ot.isChatThread && (Lt.thread = {}), Object.keys(Lt).length > 0 ? JSON.stringify(Lt) : "";
            }(Ie);
            ce && (ye.meta = ce), ye = ie.encode(ye).finish();
            var fe = this.root.lookup("easemob.pb.Meta"), we = fe.decode(Z);
            we.id = Ie.id;
            var Fe = "easemob.com";
            if (ge !== "chatRoom" && ge !== "groupChat" || (Fe = "conference.easemob.com"), we.to = { appKey: this.appKey, name: Qe, domain: Fe }, ne > -1 && (we.to.clientResource = Ie.to.substring(ne + 1, Ie.to.length)), ge === "chatRoom" && (we.ext = re.call(this, function(ot) {
              return { chatroom_msg_tag: ot.priority === "high" ? 0 : ot.priority === "low" ? 2 : 1 };
            }(Ie))), Ie.type === "recall" && Ie.metaExt && (we.ext = re.call(this, { recallMessageExtensionInfo: Ie.metaExt })), we.ns = 1, we.payload = ye, we.routetype = Ie.deliverOnlineOnly ? 1 : 0, ge !== "singleChat" && Array.isArray(Ie.receiverList) && ((Q = Ie.receiverList) === null || Q === void 0 ? void 0 : Q.length) > 0 && (we.directedUsers = Ie.receiverList, we.routetype = 2), Ie.isBuildCombinedMsg) return we.timestamp = m().fromValue(Ie.time), fe.encode(we).finish();
            var je = this.root.lookup("easemob.pb.CommSyncUL"), qe = je.decode(Z);
            qe.meta = we, !Ie.isPing && ke.call(this, Ie, we), qe = je.encode(qe).finish();
            var et = this.root.lookup("easemob.pb.MSync"), bt = et.decode(Z);
            return bt.version = this.version, bt.encryptType = this.encryptType, bt.command = 0, bt.payload = qe, et.encode(bt).finish();
          }
          Ie.fail && Ie.fail({ type: E.E.WEBIM_CONNCTION_CLIENT_OFFLINE, message: "Not logged in" });
        }
        function Se(Ie) {
          var x, ae, Q = this, Z = K({}, Ie);
          if (Ie.file) return Z.accessToken = this.token, Z.appKey = this.appKey, Z.apiUrl = this.apiUrl, Z.body && Z.body.url ? Me.call(this, Z) : new Promise(function(ie, ye) {
            var Ye = Z.onFileUploadComplete;
            Z.onFileUploadComplete = function(ne) {
              var Qe, W, ce, fe, we, Fe;
              if (ne.entities[0]["file-metadata"]) {
                var je = ne.entities[0]["file-metadata"]["content-length"];
                Z.file_length = je, Z.filetype = ne.entities[0]["file-metadata"]["content-type"], je > 204800 && (Z.thumbnail = !0);
              }
              var qe = "".concat(Q.apiUrl, "/").concat(Q.orgName, "/").concat(Q.appName, "/chatfiles/").concat(ne.entities[0].uuid);
              Z.body = { type: Z.type || "file", secret: ne.entities[0]["share-secret"], filename: Z.file.filename || Z.filename, url: qe, length: Z.length || 0, filetype: Z.filetype || Z.file.filetype, file_length: ((W = (Qe = Z.file) === null || Qe === void 0 ? void 0 : Qe.data) === null || W === void 0 ? void 0 : W.size) || 0, size: { width: Z.width || 0, height: Z.height || 0 } }, Z.file.url = ne.uri, Ie.secret = ne.entities[0]["share-secret"], ne.url = Ie.url = "".concat(qe, "?em-redirect=true&share-secret=").concat(ne.entities[0]["share-secret"]), Ie.file_length = Z.file_length = ((fe = (ce = Z.file) === null || ce === void 0 ? void 0 : ce.data) === null || fe === void 0 ? void 0 : fe.size) || 0, Z.type === "img" && (Ie.thumb = "".concat(Ie.url, "&thumbnail=true"), ne.thumb = "".concat(ne.url, "&thumbnail=true")), Z.type === "video" && (Ie.thumb = "".concat(Ie.url, "&vframe=true"), Ie.thumb_secret = ne.entities[0]["share-secret"], ne.thumb = "".concat(ne.url, "&vframe=true")), Ye instanceof Function && Ye(ne, Z.id);
              var et = Me.call(Q, Z);
              de.TJ.size <= de.F3 && de.TJ.set(Z.id, { rpt: Q.dataReport.geOperateFun({ operationName: he.fI.SEND_MSG }) }), (Fe = (we = Q._localCache) === null || we === void 0 ? void 0 : we.getInstance()) === null || Fe === void 0 || Fe.storeMessage(Ie, J.r.INPROGRESS), lt.call(Q, et);
            }, H.P6.uploadFile.call(Q, Z, he.fI.UPLOAD_MSG_ATTACH);
          });
          if (Ie.type === "combine") {
            Z.accessToken = this.token, Z.appKey = this.appKey, Z.apiUrl = this.apiUrl;
            var ge = Z.onFileUploadComplete, me = Z.onFileUploadError;
            return new Promise(function(ie, ye) {
              var Ye, ne, Qe, W;
              if (((Ye = Ie.messageList) === null || Ye === void 0 ? void 0 : Ye.length) > 300 || ((ne = Ie.messageList) === null || ne === void 0 ? void 0 : ne.length) === 0) return Q._msgHash[Z.id].reject({ type: E.E.MAX_LIMIT, message: "The number of combined messages exceeded the limit." });
              var ce = function(Lt, Kt, $t) {
                for (var yt, Wt = 0, In = Kt.length; Wt < In; Wt++) !yt && Wt in Kt || (yt || (yt = Array.prototype.slice.call(Kt, 0, Wt)), yt[Wt] = Kt[Wt]);
                return Lt.concat(yt || Array.prototype.slice.call(Kt));
              }([], Ie.messageList), fe = 0;
              if (ce.forEach(function(Lt) {
                (Lt == null ? void 0 : Lt.combineLevel) > fe && (fe = Lt == null ? void 0 : Lt.combineLevel);
              }), Z.combineLevel = fe + 1, Z.combineLevel > 10) return Q._msgHash[Z.id].reject({ type: E.E.MAX_LIMIT, message: "The level of the merged message exceeded the limit." });
              var we = Ge.call(Q, ce), Fe = function(Lt, Kt) {
                var $t, yt, Wt, In, gn, zn, Xn = "".concat(Q.apiUrl, "/").concat(Q.orgName, "/").concat(Q.appName, "/chatfiles/").concat(Lt.entities[0].uuid), yr = ($t = Lt.entities[0]) === null || $t === void 0 ? void 0 : $t["share-secret"], ur = Xn + "?em-redirect=true";
                yr && (ur = "".concat(ur, "&share-secret=").concat(yr)), ge instanceof Function && ge({ url: ur, secret: yr }), Ie.url = ur, Ie.secret = yr, Z.url = ur, Z.secret = Lt.entities[0]["share-secret"], Z.filename = ((yt = Z.file) === null || yt === void 0 ? void 0 : yt.filename) || (Kt == null ? void 0 : Kt.fileName), Z.file_length = ((In = (Wt = Z.file) === null || Wt === void 0 ? void 0 : Wt.data) === null || In === void 0 ? void 0 : In.size) || (Kt == null ? void 0 : Kt.fileLength) || 0, (zn = (gn = Q._localCache) === null || gn === void 0 ? void 0 : gn.getInstance()) === null || zn === void 0 || zn.storeMessage(Ie, J.r.INPROGRESS);
                var Yn = Me.call(Q, Z);
                lt.call(Q, Yn);
              }, je = H.P6.getEnvInfo();
              if (je.platform !== "web" && je.platform !== "node" && je.platform !== "quick_app" && (!((W = (Qe = je.global) === null || Qe === void 0 ? void 0 : Qe.canIUse) === null || W === void 0) && W.call(Qe, "getFileSystemManager"))) {
                var qe = je.global.getFileSystemManager(), et = "".concat(Q.apiUrl, "/").concat(Q.orgName, "/").concat(Q.appName, "/chatfiles");
                qe.writeFile({ filePath: "".concat(je.global.env.USER_DATA_PATH, "/combine"), data: we.buffer, encoding: "binary", success: function(Lt) {
                  je.global.uploadFile({ url: et, filePath: "".concat(je.global.env.USER_DATA_PATH, "/combine"), name: "file", header: { "Content-Type": "multipart/form-data", Authorization: "Bearer " + Z.accessToken }, success: function(Kt) {
                    if (Kt.statusCode === 200) {
                      g.kg.debug("upload success", Kt);
                      var $t = JSON.parse(Kt.data);
                      Fe($t, { fileName: "combine", fileLength: we.length });
                    } else g.kg.debug("upload fail"), Z.onFileUploadError instanceof Function && Z.onFileUploadError(Kt), this._msgHash[Z.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: Kt });
                  }, fail: function(Kt) {
                    g.kg.debug("upload fail"), Z.onFileUploadError instanceof Function && Z.onFileUploadError(Lt), this._msgHash[Z.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: Kt });
                  } });
                }, fail: function(Lt) {
                  g.kg.debug("write file fail", Lt), this._msgHash[Z.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: Lt });
                } });
              } else {
                var bt = new File([we], "combine", { type: "application/octet-stream" }), ot = { url: URL.createObjectURL(bt), filename: Z.id, data: bt };
                Z.file = ot, Z.onFileUploadComplete = function(Lt) {
                  Fe(Lt);
                }, Z.onFileUploadError = function(Lt) {
                  me instanceof Function && me(Lt), Q._msgHash[Z.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: Lt });
                }, H.P6.uploadFile.call(Q, Z, he.fI.UPLOAD_MSG_ATTACH);
              }
            });
          }
          Ie.type === "img" && (Z.body || (Z.body = K(K({}, Z), { size: { width: Z.width || 0, height: Z.height || 0 } }))), (ae = (x = this._localCache) === null || x === void 0 ? void 0 : x.getInstance()) === null || ae === void 0 || ae.storeMessage(Ie, J.r.INPROGRESS);
          var ve = Me.call(this, Z);
          lt.call(this, ve);
        }
        function ke(Ie, x) {
          Ie.editMessageId || xe.includes(Ie.type) && (this._msgHash[Ie.id].thirdMessage = x);
        }
        function Ge(Ie) {
          for (var x = Uint8Array.from("cm", function(Qe) {
            return Qe.charCodeAt(0);
          }), ae = 0; ae < Ie.length; ae++) {
            for (var Q = Ie[ae], Z = K(K({}, Q), { isBuildCombinedMsg: !0 }), ge = this.mSync.encodeChatMsg.call(this, Z), me = ge.length, ve = new Uint8Array(4), ie = 0; ie < 4; ie++) ve[ie] = me >> 8 * (3 - ie) & 255;
            g.kg.debug("message length:", ve);
            var ye = new Uint8Array(x.length + ve.length + ge.length);
            ye.set(x), ye.set(ve, x.length), ye.set(ge, x.length + ve.length), x = ye;
          }
          var Ye = new Uint8Array(x.length + 1), ne = 0;
          for (ae = 2; ae < x.length; ae++) ae % 2 == 1 && (ne ^= x[ae]);
          return Ye.set(x), g.kg.debug("checkResult:", ne), Ye[x.length] = ne, Ye;
        }
        function nt(Ie, x, ae) {
          var Q = [], Z = this.root.lookup("easemob.pb.MUCBody"), ge = Ie.roomId, me = Ie.ext, ve = me === void 0 ? "" : me, ie = Ie.leaveOtherRooms, ye = ie !== void 0 && ie, Ye = Z.decode(Q);
          Ye.mucId = { appKey: this.appKey, name: ge, domain: "conference.easemob.com" }, Ye.operation = ae === "join" ? 2 : 3, Ye.from = { name: this.context.userId }, Ye.isChatroom = !0, ae === "join" && (Ye.ext = ve, Ye.leaveOtherRooms = ye), Ye = Z.encode(Ye).finish();
          var ne = this.root.lookup("easemob.pb.Meta").decode(Q);
          ne.id = x, ne.from = { appKey: this.appKey, name: this.context.userId, domain: "easemob.com", client_resource: this.context.jid.clientResource }, ne.to = { domain: "easemob.com" }, ne.ns = 2, ne.payload = Ye;
          var Qe = this.root.lookup("easemob.pb.CommSyncUL"), W = Qe.decode(Q);
          W.meta = ne, W = Qe.encode(W).finish();
          var ce = this.root.lookup("easemob.pb.MSync"), fe = ce.decode(Q);
          return fe.version = this.version, fe.encryptType = this.encryptType, fe.command = 0, fe.payload = W, ce.encode(fe).finish();
        }
        function rt(Ie, x) {
          var ae = H.P6.getUniqueId(), Q = nt.call(this, Ie, ae, x), Z = x === "join" ? he.fI.JOIN_CHATROOM : he.fI.QUIT_CHATROOM, ge = this.dataReport.geOperateFun({ operationName: Z });
          return de.iO.size <= de.F3 && de.iO.set(ae, { rpt: ge, requestName: Z }), lt.call(this, K(K({}, Ie), { isHandleChatroom: !0, joinMsg: Q, id: ae, operation: x }), ae);
        }
        function dt(Ie) {
          var x = this;
          return new Promise(function(ae, Q) {
            var Z, ge, me, ve, ie, ye;
            if (g.kg.debug("call send"), x.logOut) return g.kg.debug("send message failed", E.E.WEBIM_CONNECTION_CLOSED), Q({ type: E.E.WEBIM_CONNECTION_CLOSED, message: "not login" });
            if (!Ie.id || typeof Ie.id != "string" || Ie.id === "") return Q({ type: E.E.MESSAGE_PARAMETER_ERROR, message: 'Missing required parameter: "id"' });
            if (!Ie.to || typeof Ie.to != "string" || Ie.to === "") return Q({ type: E.E.MESSAGE_PARAMETER_ERROR, message: 'Missing required parameter: "to"' });
            var Ye = Ie.type === "file" || Ie.type === "img" || Ie.type === "audio" || Ie.type === "video", ne = Ie.type === "delivery" || Ie.type === "read" || Ie.type === "channel", Qe = Ie.type === "cmd", W = Ie.type === "recall", ce = Ie == null ? void 0 : Ie.editMessageId, fe = !(ne || W || Qe || ce);
            if (Ie.id) {
              if (!Ye && !ne || Ye && x.useOwnUploadFun) {
                var we = Ie.type === "recall" ? he.fI.SEND_RECALL_MSG : he.fI.SEND_MSG;
                ce && (we = he.fI.MODIFY_MESSAGE), de.TJ.size <= de.F3 && de.TJ.set(Ie.id, { rpt: x.dataReport.geOperateFun({ operationName: we }) });
              }
              fe && ((ge = (Z = x._localCache) === null || Z === void 0 ? void 0 : Z.getInstance()) === null || ge === void 0 || ge.storeMessage(Ie, J.r.CREATE)), x._msgHash[Ie.id] = K(K({}, Ie), { resolve: ae, reject: Q });
            }
            if (Ye || Ie.type === "combine") return Se.call(x, Ie);
            if (Ie.type === "txt" && (!((me = Ie.msgConfig) === null || me === void 0) && me.languages) && Array.isArray((ve = Ie.msgConfig) === null || ve === void 0 ? void 0 : ve.languages) && Ie.msgConfig.languages.length > 0) {
              var Fe = x.translateMessage || x.translation.translateMessage;
              if (!Fe) throw new Error("there is no method to translate message");
              Fe.call(x, { text: Ie.msg, languages: Ie.msgConfig.languages }).then(function(qe) {
                var et, bt, ot, Lt = (et = qe.data[0]) === null || et === void 0 ? void 0 : et.translations;
                Lt = Lt.map(function($t) {
                  return { code: $t.to, text: $t.text };
                }), Ie.translations = Lt, x._msgHash[Ie.id].translations = Lt, (ot = (bt = x._localCache) === null || bt === void 0 ? void 0 : bt.getInstance()) === null || ot === void 0 || ot.storeMessage(Ie, J.r.INPROGRESS);
                var Kt = Me.call(x, Ie);
                lt.call(x, Kt, Ie.id);
              }).catch(function(qe) {
                Q(qe);
              });
            } else {
              fe && ((ye = (ie = x._localCache) === null || ie === void 0 ? void 0 : ie.getInstance()) === null || ye === void 0 || ye.storeMessage(Ie, J.r.INPROGRESS));
              var je = Me.call(x, Ie);
              lt.call(x, je, Ie.id);
            }
          });
        }
        function lt(Ie, x) {
          var ae, Q = this;
          if (Ie.isHandleChatroom) {
            if (!this.isOpened()) {
              var Z = { data: "", type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" };
              if (de.iO.has(Ie.id)) {
                var ge = de.iO.get(Ie.id);
                (0, ge.rpt)({ isEndApi: !0, data: { isSuccess: 0, requestName: ge.requestName, requestMethod: "WEBSOCKET", requestUrl: this.url, code: he.dd.disconnect, codeDesc: "websocket has been disconnected" } }), de.iO.delete(Ie.id);
              }
              return Promise.reject(Z);
            }
            return new Promise(function(ye, Ye) {
              var ne;
              Q._msgHash[Ie.id] = K(K({}, Ie), { resolve: ye, reject: Ye });
              var Qe = H.P6.getEnvInfo();
              ne = Q.name === "miniCore" || Qe.platform === "web" ? Ie.joinMsg : Be.call(Q, Ie.joinMsg, x);
              var W = x && setTimeout(function() {
                var ce, fe, we;
                if (Q._msgHash[Ie.id]) {
                  var Fe = { type: E.E.REQUEST_TIMEOUT, message: "request timeout" };
                  (fe = (ce = Q._msgHash[Ie.id]).reject) === null || fe === void 0 || fe.call(ce, Fe), clearTimeout((we = Q._msgHash[Ie.id]) === null || we === void 0 ? void 0 : we.messageTimer), delete Q._msgHash[Ie.id], Q.reconnecting || Q.reconnect(!0);
                }
              }, pe.xz);
              Q._msgHash[Ie.id].messageTimer = W, Q.sock.send(ne);
            });
          }
          if (!this.isOpened()) return (ae = this.unMSyncSendMsgMap) === null || ae === void 0 || ae.set(x, Ie), !this.logOut && this.autoReconnectNumTotal < this.autoReconnectNumMax && (g.kg.debug("need to reconnect", this.autoReconnectNumTotal, this.autoReconnectNumMax), this.offLineSendConnecting = !0, this.reconnecting || this.reconnect()), void (this.onError && this.onError({ type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" }));
          var me, ve = x && setTimeout(function() {
            var ye, Ye, ne;
            if (Q._msgHash[x ?? ""]) {
              var Qe = { type: E.E.MESSAGE_SEND_TIMEOUT, message: "send message timeout" };
              (Ye = (ye = Q._msgHash[x ?? ""]).reject) === null || Ye === void 0 || Ye.call(ye, Qe), clearTimeout((ne = Q._msgHash[x ?? ""]) === null || ne === void 0 ? void 0 : ne.messageTimer), delete Q._msgHash[x ?? ""], Q.reconnecting || Q.reconnect(!0);
            }
          }, pe.xz);
          this._msgHash[x ?? ""] && (this._msgHash[x ?? ""].messageTimer = ve);
          var ie = H.P6.getEnvInfo();
          me = this.name === "miniCore" || ie.platform === "web" ? Ie : Be.call(this, Ie, x), this.sock.send(me);
        }
        var Ct = function(Ie, x) {
          return Ie.send = dt, Ie.sendMsg = dt, g.kg.debug("init Msync by ".concat(Ie.name)), { generateProvision: $e.bind(Ie), base64transform: Be.bind(Ie), distributeMeta: Ke.bind(Ie), decodeMeta: Ze.bind(Ie), decodeUnreadDL: It.bind(Ie), _rebuild: Rt.bind(Ie), _lastsession: Tt.bind(Ie), receiveProvision: kt.bind(Ie), isInQueue: zt.bind(Ie), decodeNotice: ze.bind(Ie), decodeMSync: Ne.bind(Ie), distributeMSync: le.bind(Ie), encodeChatMsg: Me.bind(Ie), upLoadFile: Se.bind(Ie), send: dt.bind(Ie), stopHeartBeat: Ft.bind(Ie), handleChatRoom: rt.bind(Ie), sendUnreadDeal: ut.bind(Ie) };
        };
      }, 7252: function(l, v) {
        var s = function() {
          function c(d) {
            this.type = d.type, this.message = d.message, this.data = d.data;
          }
          return c.create = function(d) {
            return new c(d);
          }, c;
        }();
        v.Z = s;
      }, 8161: function(l, v, s) {
        s.d(v, { t: function() {
          return H;
        } }), s(9601), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(7941), s(3710), s(9714), s(9653), s(6699), s(2023), s(2222), s(8309), s(9554), s(4747), s(2772);
        var c = s(3720), d = s.n(c), p = s(4363), m = s(4024), E = s(6424), y = s(9743), g = s(7360), C = s(2449), O = s(7288), N = function() {
          return N = Object.assign || function(j) {
            for (var G, U = 1, M = arguments.length; U < M; U++) for (var V in G = arguments[U]) Object.prototype.hasOwnProperty.call(G, V) && (j[V] = G[V]);
            return j;
          }, N.apply(this, arguments);
        }, w = function(j, G, U, M) {
          return new (U || (U = Promise))(function(V, J) {
            function ue(de) {
              try {
                ee(M.next(de));
              } catch (he) {
                J(he);
              }
            }
            function se(de) {
              try {
                ee(M.throw(de));
              } catch (he) {
                J(he);
              }
            }
            function ee(de) {
              var he;
              de.done ? V(de.value) : (he = de.value, he instanceof U ? he : new U(function(pe) {
                pe(he);
              })).then(ue, se);
            }
            ee((M = M.apply(j, [])).next());
          });
        }, _ = function(j, G) {
          var U, M, V, J, ue = { label: 0, sent: function() {
            if (1 & V[0]) throw V[1];
            return V[1];
          }, trys: [], ops: [] };
          return J = { next: se(0), throw: se(1), return: se(2) }, typeof Symbol == "function" && (J[Symbol.iterator] = function() {
            return this;
          }), J;
          function se(ee) {
            return function(de) {
              return function(he) {
                if (U) throw new TypeError("Generator is already executing.");
                for (; ue; ) try {
                  if (U = 1, M && (V = 2 & he[0] ? M.return : he[0] ? M.throw || ((V = M.return) && V.call(M), 0) : M.next) && !(V = V.call(M, he[1])).done) return V;
                  switch (M = 0, V && (he = [2 & he[0], V.value]), he[0]) {
                    case 0:
                    case 1:
                      V = he;
                      break;
                    case 4:
                      return ue.label++, { value: he[1], done: !1 };
                    case 5:
                      ue.label++, M = he[1], he = [0];
                      continue;
                    case 7:
                      he = ue.ops.pop(), ue.trys.pop();
                      continue;
                    default:
                      if (!((V = (V = ue.trys).length > 0 && V[V.length - 1]) || he[0] !== 6 && he[0] !== 2)) {
                        ue = 0;
                        continue;
                      }
                      if (he[0] === 3 && (!V || he[1] > V[0] && he[1] < V[3])) {
                        ue.label = he[1];
                        break;
                      }
                      if (he[0] === 6 && ue.label < V[1]) {
                        ue.label = V[1], V = he;
                        break;
                      }
                      if (V && ue.label < V[2]) {
                        ue.label = V[2], ue.ops.push(he);
                        break;
                      }
                      V[2] && ue.ops.pop(), ue.trys.pop();
                      continue;
                  }
                  he = G.call(j, ue);
                } catch (pe) {
                  he = [6, pe], M = 0;
                } finally {
                  U = V = 0;
                }
                if (5 & he[0]) throw he[1];
                return { value: he[0] ? he[1] : void 0, done: !0 };
              }([ee, de]);
            };
          }
        }, I = { 0: "TEXT", 1: "IMAGE", 2: "VIDEO", 3: "LOCATION", 4: "VOICE", 5: "FILE", 6: "COMMAND", 7: "CUSTOM", 8: "COMBINE" };
        function k(j) {
          for (var G = {}, U = 0; U < j.length; U++) if (j[U].type === 8) G[j[U].key] = JSON.parse(j[U].stringValue);
          else if (j[U].type === 7) G[j[U].key] = j[U].stringValue;
          else if (j[U].type === 6) G[j[U].key] = j[U].doubleValue;
          else if (j[U].type === 5) G[j[U].key] = j[U].floatValue;
          else if (j[U].type === 1) {
            var M = j[U].varintValue, V = new (d())(M.low, M.high, M.unsigned).toString();
            G[j[U].key] = Number(V) !== 0;
          } else j[U].type !== 2 && j[U].type !== 3 && j[U].type !== 4 || (M = j[U].varintValue, V = new (d())(M.low, M.high, M.unsigned).toString(), G[j[U].key] = Number(V));
          return G;
        }
        function H(j) {
          var G = "";
          return j.remotePath && (G = m.P6.formatAttachUrl.call(this, j.remotePath), j.remotePath.includes("?em-redirect") || (G = "".concat(G, "?em-redirect=true"), j.secretKey && (G = "".concat(G, "&share-secret=").concat(j.secretKey)))), G;
        }
        function S(j, G) {
          var U, M, V = G.from && G.from.name;
          if (V === this.context.userId) {
            var J = (U = j == null ? void 0 : j.from) === null || U === void 0 ? void 0 : U.clientResource;
            V === ((M = G == null ? void 0 : G.to) === null || M === void 0 ? void 0 : M.name) && J && J !== this.clientResource && (V = "".concat(V, "/").concat(J));
          }
          return V;
        }
        function B(j, G) {
          var U, M = G.to && G.to.name;
          return !((U = j == null ? void 0 : j.to) === null || U === void 0) && U.clientResource && (M = "".concat(M, "/").concat(j.to.clientResource)), M;
        }
        function D(j) {
          var G, U, M, V, J, ue, se, ee, de, he, pe, Ce, _e, Le, Te, K, Oe, Pe, xe, be, $e, Be, Ke, Ze, at, pt, It;
          return w(this, void 0, void 0, function() {
            var Rt, gt, it, Tt, Ut, st, Ot, kt, wt, Et, ut, St, Ft, Ht, zt, ze, Ne, le, X, re, Me, Se, ke, Ge, nt, rt, dt, lt, Ct, Ie, x, ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we, Fe, je, qe, et, bt, ot, Lt, Kt;
            return _(this, function($t) {
              switch ($t.label) {
                case 0:
                  switch (Rt = j.status, gt = j.thirdMessage, it = j.msgBody, Tt = j.msgId, Ut = j.type, st = j.from, Ot = j.to, kt = j.time, wt = j.onlineState, Et = j.chatType, ut = j.ignoreCallback, St = j.priority, Ft = j.format, Ht = j.broadcast, zt = Ht !== void 0 && Ht, ze = j.isContentReplaced, Ne = ze !== void 0 && ze, le = {}, X = {}, re = Rt.errorCode > 0, Me = Rt.errorCode, Se = Rt.reason, ke = {}, Ge = [], nt = [], rt = {}, dt = "", lt = 0, Ct = null, Ie = null, ae = !1, Q = !1, gt.ext && (ke = k(gt.ext)), gt.meta && typeof gt.meta == "string" && ((Z = JSON.parse(gt.meta)).reaction && (Ge = Z.reaction).forEach(function(yt) {
                    yt.isAddedBySelf = yt.state, delete yt.state;
                  }), Z.translations && (nt = Z.translations), Z.edit_msg && (ge = Z.edit_msg, me = ge.count, ve = ge.operator, ie = ge.edit_time, ye = ge.sender, Ye = ge.send_time, rt = { operationTime: ie, operatorId: ve, operationCount: me }, dt = ye, lt = Ye), Z.thread && JSON.stringify(Z.thread) !== "{}" && (Ct = { messageId: Z.thread.msg_parent_id, parentId: Z.thread.muc_parent_id, chatThreadName: Z.thread.thread_name }), Z.thread_overview && JSON.stringify(Z.thread_overview) !== "{}" && (Ie = { id: Z.thread_overview.id, parentId: Z.thread_overview.muc_parent_id, name: Z.thread_overview.name, lastMessage: Z.thread_overview.last_message && JSON.stringify(Z.thread_overview.last_message) !== "{}" ? p.w.call(this, Z.thread_overview.last_message) : null, createTimestamp: Z.thread_overview.create_timestamp, updateTimestamp: Z.thread_overview.update_timestamp, messageCount: Z.thread_overview.message_count || 0 }), Z.isDelivered && (ae = !0), Z.isRead && (Q = !0)), it.type) {
                    case 0:
                      return [3, 1];
                    case 1:
                      return [3, 7];
                    case 2:
                      return [3, 10];
                    case 3:
                      return [3, 13];
                    case 4:
                      return [3, 16];
                    case 5:
                      return [3, 19];
                    case 6:
                      return [3, 22];
                    case 7:
                      return [3, 23];
                    case 8:
                      return [3, 26];
                  }
                  return [3, 27];
                case 1:
                  return Object.prototype.hasOwnProperty.call(it, "subType") && it.subType === 0 ? (x = H.call(this, it), ne = { id: Tt, type: "combine", chatType: Et, to: Ot, from: st, ext: ke, time: Number(kt), onlineState: wt, title: it.title || "", summary: it.summary || "", url: x || "", secret: it.secretKey || "", file_length: it.fileLength || 0, filename: it.displayName || "", compatibleText: it.text, combineLevel: it.combineLevel || 0 }, le.msgConfig && (ne.msgConfig = le.msgConfig), Ge.length > 0 && (ne.reactions = Ge), Ct && (ne.chatThread = Ct), Ie && (ne.chatThreadOverview = Ie), Et === "chatRoom" && (ne.priority = St, ne.broadcast = zt), Ne && (ne.isContentReplaced = Ne), Q && (ne.isRead = !0), ae && (ne.isDelivered = !0), X = ne, ut ? [3, 3] : [4, (U = (G = this._localCache) === null || G === void 0 ? void 0 : G.getInstance()) === null || U === void 0 ? void 0 : U.storeMessage(ne, O.r.SUCCESS)]) : [3, 4];
                case 2:
                  $t.sent(), (M = this.eventHandler) === null || M === void 0 || M.dispatch("onCombineMessage", ne), $t.label = 3;
                case 3:
                  return [3, 28];
                case 4:
                  return !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, data: it.text, ext: ke, sourceMsg: it.text, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onTextMessage && this.onTextMessage(le), Qe = { id: Tt, type: "txt", chatType: Et, msg: it.text, to: Ot, from: st, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (Qe.msgConfig = le.msgConfig), Ge.length > 0 && (Qe.reactions = Ge), Ct && (Qe.chatThread = Ct), Ie && (Qe.chatThreadOverview = Ie), nt.length > 0 && (Qe.translations = nt), rt.operationCount > 0 && (Qe.modifiedInfo = rt, gt.type === E.gA.EDIT && (Qe.from = dt, Qe.time = lt)), Et === "chatRoom" && (Qe.priority = St, Qe.broadcast = zt), Ne && (Qe.isContentReplaced = Ne), Q && (Qe.isRead = !0), ae && (Qe.isDelivered = !0), X = Qe, ut ? [3, 6] : [4, (J = (V = this._localCache) === null || V === void 0 ? void 0 : V.getInstance()) === null || J === void 0 ? void 0 : J.storeMessage(Qe, O.r.SUCCESS)];
                case 5:
                  $t.sent(), (ue = this.eventHandler) === null || ue === void 0 || ue.dispatch("onTextMessage", Qe), $t.label = 6;
                case 6:
                  return [3, 28];
                case 7:
                  return W = ((se = it == null ? void 0 : it.size) === null || se === void 0 ? void 0 : se.width) || 0, ce = ((ee = it == null ? void 0 : it.size) === null || ee === void 0 ? void 0 : ee.height) || 0, x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, thumb: this.useOwnUploadFun ? "" : "".concat(x, "&thumbnail=true"), thumb_secret: it.secretKey, file_length: it.fileLength || "", width: W, height: ce, filetype: it.filetype || "", accessToken: this.token, ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onPictureMessage && this.onPictureMessage(le), fe = { id: Tt, type: "img", chatType: Et, from: st, to: Ot, url: x || "", width: W, height: ce, secret: it.secretKey || "", thumb: this.useOwnUploadFun ? "" : "".concat(x, "&thumbnail=true"), thumb_secret: it.secretKey, file_length: it.fileLength || 0, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (fe.msgConfig = le.msgConfig), Ge.length > 0 && (fe.reactions = Ge), Ct && (fe.chatThread = Ct), Ie && (fe.chatThreadOverview = Ie), Et === "chatRoom" && (fe.priority = St, fe.broadcast = zt), Ne && (fe.isContentReplaced = Ne), Q && (fe.isRead = !0), ae && (fe.isDelivered = !0), X = fe, ut ? [3, 9] : [4, (he = (de = this._localCache) === null || de === void 0 ? void 0 : de.getInstance()) === null || he === void 0 ? void 0 : he.storeMessage(fe, O.r.SUCCESS)];
                case 8:
                  $t.sent(), (pe = this.eventHandler) === null || pe === void 0 || pe.dispatch("onImageMessage", fe), $t.label = 9;
                case 9:
                  return [3, 28];
                case 10:
                  return x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, length: it.duration || "", file_length: it.fileLength || "", filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onVideoMessage && this.onVideoMessage(le), we = { id: Tt, type: "video", chatType: Et, from: st, to: Ot, url: x, secret: it.secretKey, thumb: m.P6.formatAttachUrl.call(this, it.thumbnailRemotePath), thumb_secret: it.thumbnailSecretKey, filename: it.displayName, length: it.duration || 0, file: {}, file_length: it.fileLength || 0, filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (we.msgConfig = le.msgConfig), Ge.length > 0 && (we.reactions = Ge), Ct && (we.chatThread = Ct), Ie && (we.chatThreadOverview = Ie), Et === "chatRoom" && (we.priority = St, we.broadcast = zt), Ne && (we.isContentReplaced = Ne), Q && (we.isRead = !0), ae && (we.isDelivered = !0), X = we, ut ? [3, 12] : [4, (_e = (Ce = this._localCache) === null || Ce === void 0 ? void 0 : Ce.getInstance()) === null || _e === void 0 ? void 0 : _e.storeMessage(we, O.r.SUCCESS)];
                case 11:
                  $t.sent(), (Le = this.eventHandler) === null || Le === void 0 || Le.dispatch("onVideoMessage", we), $t.label = 12;
                case 12:
                  return [3, 28];
                case 13:
                  return !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, addr: it.address, buildingName: it.buildingName, lat: it.latitude, lng: it.longitude, ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onLocationMessage && this.onLocationMessage(le), Fe = { id: Tt, type: "loc", chatType: Et, from: st, to: Ot, buildingName: it.buildingName, addr: it.address, lat: it.latitude, lng: it.longitude, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (Fe.msgConfig = le.msgConfig), Ge.length > 0 && (Fe.reactions = Ge), Ct && (Fe.chatThread = Ct), Ie && (Fe.chatThreadOverview = Ie), Et === "chatRoom" && (Fe.priority = St, Fe.broadcast = zt), Ne && (Fe.isContentReplaced = Ne), Q && (Fe.isRead = !0), ae && (Fe.isDelivered = !0), X = Fe, ut ? [3, 15] : [4, (K = (Te = this._localCache) === null || Te === void 0 ? void 0 : Te.getInstance()) === null || K === void 0 ? void 0 : K.storeMessage(Fe, O.r.SUCCESS)];
                case 14:
                  $t.sent(), (Oe = this.eventHandler) === null || Oe === void 0 || Oe.dispatch("onLocationMessage", Fe), $t.label = 15;
                case 15:
                  return [3, 28];
                case 16:
                  return x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, file_length: it.fileLength || "", accessToken: this.token || "", ext: ke, length: it.duration, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onAudioMessage && this.onAudioMessage(le), je = { id: Tt, type: "audio", chatType: Et, from: st, to: Ot, url: x, secret: it.secretKey, file: {}, filename: it.displayName, length: it.duration || 0, file_length: it.fileLength || 0, filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (je.msgConfig = le.msgConfig), Ge.length > 0 && (je.reactions = Ge), Ct && (je.chatThread = Ct), Ie && (je.chatThreadOverview = Ie), Et === "chatRoom" && (je.priority = St, je.broadcast = zt), Ne && (je.isContentReplaced = Ne), Q && (je.isRead = !0), ae && (je.isDelivered = !0), X = je, ut ? [3, 18] : [4, (xe = (Pe = this._localCache) === null || Pe === void 0 ? void 0 : Pe.getInstance()) === null || xe === void 0 ? void 0 : xe.storeMessage(je, O.r.SUCCESS)];
                case 17:
                  $t.sent(), (be = this.eventHandler) === null || be === void 0 || be.dispatch("onAudioMessage", je), $t.label = 18;
                case 18:
                  return [3, 28];
                case 19:
                  return x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, file_length: it.fileLength, accessToken: this.token || "", ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onFileMessage && this.onFileMessage(le), qe = { id: Tt, type: "file", chatType: Et, from: st, to: Ot, url: x, secret: it.secretKey, file: {}, filename: it.displayName, length: it.duration || 0, file_length: it.fileLength || 0, filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (qe.msgConfig = le.msgConfig), Ge.length > 0 && (qe.reactions = Ge), Ct && (qe.chatThread = Ct), Ie && (qe.chatThreadOverview = Ie), Et === "chatRoom" && (qe.priority = St, qe.broadcast = zt), Ne && (qe.isContentReplaced = Ne), Q && (qe.isRead = !0), ae && (qe.isDelivered = !0), X = qe, ut ? [3, 21] : [4, (Be = ($e = this._localCache) === null || $e === void 0 ? void 0 : $e.getInstance()) === null || Be === void 0 ? void 0 : Be.storeMessage(qe, O.r.SUCCESS)];
                case 20:
                  $t.sent(), (Ke = this.eventHandler) === null || Ke === void 0 || Ke.dispatch("onFileMessage", qe), $t.label = 21;
                case 21:
                  return [3, 28];
                case 22:
                  return !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, action: it.action, ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onCmdMessage && this.onCmdMessage(le), et = { id: Tt, type: "cmd", chatType: Et, from: st, to: Ot, action: it.action, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (et.msgConfig = le.msgConfig), Ge.length > 0 && (et.reactions = Ge), Ct && (et.chatThread = Ct), Ie && (et.chatThreadOverview = Ie), Et === "chatRoom" && (et.priority = St, et.broadcast = zt), Ne && (et.isContentReplaced = Ne), Q && (et.isRead = !0), ae && (et.isDelivered = !0), X = et, ut || (Ze = this.eventHandler) === null || Ze === void 0 || Ze.dispatch("onCmdMessage", et), [3, 28];
                case 23:
                  return bt = {}, ot = {}, gt.contents[0].customExts && (bt = k(gt.contents[0].customExts)), gt.contents[0].params && (ot = k(gt.contents[0].params)), le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, customEvent: it.customEvent, params: ot, customExts: bt, ext: ke, time: kt, onlineState: wt }, !ut && this.onCustomMessage && this.onCustomMessage(le), Lt = { id: Tt, type: "custom", chatType: Et, from: st, to: Ot, customEvent: it.customEvent, params: ot, customExts: bt, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (Lt.msgConfig = le.msgConfig), Ge.length > 0 && (Lt.reactions = Ge), Ct && (Lt.chatThread = Ct), Ie && (Lt.chatThreadOverview = Ie), rt.operationCount > 0 && (Lt.modifiedInfo = rt, gt.type === E.gA.EDIT && (Lt.from = dt, Lt.time = lt)), Et === "chatRoom" && (Lt.priority = St, Lt.broadcast = zt), Ne && (Lt.isContentReplaced = Ne), Q && (Lt.isRead = !0), ae && (Lt.isDelivered = !0), X = Lt, ut ? [3, 25] : [4, (pt = (at = this._localCache) === null || at === void 0 ? void 0 : at.getInstance()) === null || pt === void 0 ? void 0 : pt.storeMessage(Lt, O.r.SUCCESS)];
                case 24:
                  $t.sent(), (It = this.eventHandler) === null || It === void 0 || It.dispatch("onCustomMessage", Lt), $t.label = 25;
                case 25:
                  return [3, 28];
                case 26:
                  return x = H.call(this, it), Kt = { id: Tt, type: "combine", chatType: Et, to: Ot, from: st, ext: ke, time: Number(kt), onlineState: wt, title: it.title || "", summary: it.summary || "", url: x || "", secret: it.secretKey || "", file_length: it.fileLength || 0, filename: it.displayName || "", compatibleText: it.text, combineLevel: it.combineLevel || 0 }, le.msgConfig && (Kt.msgConfig = le.msgConfig), Ge.length > 0 && (Kt.reactions = Ge), Ct && (Kt.chatThread = Ct), Ie && (Kt.chatThreadOverview = Ie), Et === "chatRoom" && (Kt.priority = St, Kt.broadcast = zt), Ne && (Kt.isContentReplaced = Ne), Q && (Kt.isRead = !0), ae && (Kt.isDelivered = !0), X = Kt, !ut && this.eventHandler && this.eventHandler.dispatch("onCombineMessage", Kt), [3, 28];
                case 27:
                  return g.kg.error("Unknow message type, message:", it), [3, 28];
                case 28:
                  return Ft ? [2, X] : [2, le];
              }
            });
          });
        }
        function F(j, G, U) {
          if (this.delivery && j !== G) {
            var M = this.getUniqueId(), V = new C.Message("delivery", M);
            V.set({ ackId: U, to: j }), g.kg.debug("send delivery ack"), this.send(V.body);
          }
        }
        v.Z = function(j, G, U, M, V) {
          var J, ue, se, ee, de, he, pe, Ce, _e, Le, Te, K, Oe, Pe, xe, be, $e, Be, Ke, Ze, at, pt, It, Rt, gt, it;
          return w(this, void 0, void 0, function() {
            var Tt, Ut, st, Ot, kt, wt, Et, ut, St, Ft, Ht, zt, ze, Ne, le, X, re, Me, Se, ke, Ge, nt, rt, dt, lt, Ct, Ie, x, ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce;
            return _(this, function(fe) {
              switch (fe.label) {
                case 0:
                  if (Tt = new (d())(j.timestamp.low, j.timestamp.high, j.timestamp.unsigned).toString(), Ut = this.root.lookup("easemob.pb.MessageBody"), st = Ut.decode(j.payload), Ot = 3, kt = !1, wt = new (d())(j.id.low, j.id.high, j.id.unsigned).toString(), V && j.from && j.from.name === this.context.userId && j.from.clientResource === this.clientResource && st.type === E.gA.CHATROOM) return [2, g.kg.debug("Discard your own chat room message:", wt)];
                  if (j.meta && j.meta.length) {
                    if (Et = m.P6.parseNotify(j.meta), ut = Et.is_online, St = Et.callback_replace, this.useReplacedMessageContents && St && (kt = !0), ut || ut === 0) switch (ut) {
                      case 0:
                        Ot = 0;
                        break;
                      case 1:
                        Ot = 1;
                        break;
                      default:
                        Ot = 2;
                    }
                  } else Ot = 3;
                  switch (Ft = st.ackMessageId ? new (d())(st.ackMessageId.low, st.ackMessageId.high, st.ackMessageId.unsigned).toString() : "", Ht = "", zt = S.call(this, j, st), ze = B.call(this, j, st), g.kg.debug("meta thirdMessage:", { metaId: wt, metaNs: j.ns, type: st.type, from: zt, to: ze, contentType: (ue = (J = st.contents) === null || J === void 0 ? void 0 : J[0]) === null || ue === void 0 ? void 0 : ue.type, contentLen: (se = st.contents) === null || se === void 0 ? void 0 : se.length }), st.type) {
                    case E.gA.SINGLECHAT:
                      return [3, 1];
                    case E.gA.GROUPCHAT:
                      return [3, 2];
                    case E.gA.CHATROOM:
                      return [3, 3];
                    case E.gA.READ_ACK:
                      return [3, 4];
                    case E.gA.DELIVER_ACK:
                      return [3, 5];
                    case E.gA.RECALL:
                      return [3, 6];
                    case E.gA.CHANNEL_ACK:
                      return [3, 15];
                    case E.gA.EDIT:
                      return [3, 16];
                  }
                  return [3, 20];
                case 1:
                  return Ht = "chat", this.grantType === "agoraToken" && (Ht = "singleChat"), this.delivery && !U && zt !== this.context.userId && F.call(this, zt, ze, wt), [3, 21];
                case 2:
                  return Ht = "groupchat", this.grantType === "agoraToken" && (Ht = "groupChat"), [3, 21];
                case 3:
                  return Ht = "chatroom", this.grantType === "agoraToken" && (Ht = "chatRoom"), Ot = 1, [3, 21];
                case 4:
                  return Ht = "read_ack", Ne = void 0, st.ext[0] && JSON.parse(st.ext[0].stringValue) ? (Ne = { id: wt, type: "read", from: zt, to: ze, mid: Ft, groupReadCount: st.ext[0] && JSON.parse(st.ext[0].stringValue), ackContent: st.ackContent, onlineState: Ot }, this.onReadMessage && this.onReadMessage(Ne), (ee = this.eventHandler) === null || ee === void 0 || ee.dispatch("onReadMessage", Ne), [2]) : (Ne = { id: wt, type: "read", from: zt, to: ze, mid: Ft, onlineState: Ot }, this.onReadMessage && this.onReadMessage(Ne), (de = this.eventHandler) === null || de === void 0 || de.dispatch("onReadMessage", Ne), [2]);
                case 5:
                  return Ht = "deliver_ack", this.onDeliveredMessage && this.onDeliveredMessage({ id: wt, type: "delivery", from: zt, to: ze, mid: Ft, onlineState: Ot }), le = { id: wt, type: "delivery", from: zt, to: ze, mid: Ft, onlineState: Ot }, (he = this.eventHandler) === null || he === void 0 || he.dispatch("onDeliveredMessage", le), [2];
                case 6:
                  return Ht = "recall", X = "", j.ext && (X = ((pe = k(j.ext)) === null || pe === void 0 ? void 0 : pe.recallMessageExtensionInfo) || ""), re = { id: wt, from: zt || "admin", to: ze, mid: Ft, ext: X, onlineState: Ot }, Me = ze === this.user ? zt : ze, [4, (_e = (Ce = this._localCache) === null || Ce === void 0 ? void 0 : Ce.getInstance()) === null || _e === void 0 ? void 0 : _e.getMessageByServerMsgId(re.mid)];
                case 7:
                  return (Se = fe.sent()) ? [4, (Te = (Le = this._localCache) === null || Le === void 0 ? void 0 : Le.getInstance()) === null || Te === void 0 ? void 0 : Te.removeMsgByServerMsgId(re.mid)] : [3, 9];
                case 8:
                  fe.sent(), fe.label = 9;
                case 9:
                  return (Se == null ? void 0 : Se.chatType) !== "singleChat" && (Se == null ? void 0 : Se.chatType) !== "groupChat" ? [3, 14] : (ke = (Se == null ? void 0 : Se.from) === this.user || (Se == null ? void 0 : Se.from) === "", [4, (Oe = (K = this._localCache) === null || K === void 0 ? void 0 : K.getInstance()) === null || Oe === void 0 ? void 0 : Oe.getConversationLastMessage(Me, Se.chatType)]);
                case 10:
                  return Ge = fe.sent(), [4, (xe = (Pe = this._localCache) === null || Pe === void 0 ? void 0 : Pe.getInstance()) === null || xe === void 0 ? void 0 : xe.getConversationBySessionId((0, y.MQ)({ conversationId: Me, conversationType: Se.chatType }))];
                case 11:
                  return (nt = fe.sent()) ? [4, ($e = (be = this._localCache) === null || be === void 0 ? void 0 : be.getInstance()) === null || $e === void 0 ? void 0 : $e.updateLocalConversation((0, y.MQ)({ conversationId: Me, conversationType: Se.chatType }), { lastMessageId: Ge == null ? void 0 : Ge.serverMsgId, unReadCount: (0, y.E7)({ conversation: nt, isRecallSelfMsg: ke, recalledMsgTime: Se.time }) })] : [3, 13];
                case 12:
                  fe.sent(), fe.label = 13;
                case 13:
                  fe.label = 14;
                case 14:
                  return this.onRecallMessage && this.onRecallMessage(re), (Be = this.eventHandler) === null || Be === void 0 || Be.dispatch("onRecallMessage", re), [2];
                case 15:
                  return this.onChannelMessage && this.onChannelMessage({ id: wt, type: "channel", chatType: "singleChat", from: zt, to: ze, time: Number(Tt), onlineState: Ot }), rt = { id: wt, type: "channel", chatType: "singleChat", from: zt, to: ze, time: Number(Tt), onlineState: Ot }, (Ke = this.eventHandler) === null || Ke === void 0 || Ke.dispatch("onChannelMessage", rt), [2];
                case 16:
                  return dt = { errorCode: 0, reason: "" }, [4, D.call(this, { status: dt, thirdMessage: st, msgBody: st.contents[0], msgId: wt, type: Ht, from: zt, to: ze, time: Tt, onlineState: Ot, ignoreCallback: !0, format: !0, isContentReplaced: kt })];
                case 17:
                  return lt = fe.sent(), Ct = !!j.to && j.to.domain.indexOf("conference") !== -1, lt.chatType = Ct ? "groupChat" : "singleChat", Ie = st.editMessageId && new (d())(st.editMessageId.low, st.editMessageId.high, st.editMessageId.unsigned).toString(), x = {}, ae = lt.ext && Object.keys(lt.ext).length > 0, lt.type === "txt" ? (Q = lt.type, Z = lt.chatType, ge = lt.to, me = lt.from, ve = lt.time, ie = lt.modifiedInfo, x = { id: Ie, type: Q, chatType: Z, to: ge, from: me, time: ve, modifiedInfo: ie, msg: lt.msg }, lt.translations && (x.translations = lt.translations)) : lt.type === "custom" && ((x = lt).id = Ie, delete x.onlineState), ae && (x.ext = lt.ext), x ? [4, (at = (Ze = this._localCache) === null || Ze === void 0 ? void 0 : Ze.getInstance()) === null || at === void 0 ? void 0 : at.getMessageByServerMsgId(Ie)] : [3, 19];
                case 18:
                  ((ye = fe.sent()) == null ? void 0 : ye.type) === "txt" && x.type === "txt" ? (It = (pt = this._localCache) === null || pt === void 0 ? void 0 : pt.getInstance()) === null || It === void 0 || It.putMessageToDB(N(N({}, ye), { msg: x.msg, ext: x.ext || ye.ext, modifiedInfo: x.modifiedInfo, translations: x.translations })) : (ye == null ? void 0 : ye.type) === "custom" && x.type === "custom" && ((gt = (Rt = this._localCache) === null || Rt === void 0 ? void 0 : Rt.getInstance()) === null || gt === void 0 || gt.putMessageToDB(N(N({}, ye), { modifiedInfo: x.modifiedInfo, customEvent: x.customEvent, customExts: x.customExts, ext: x.ext || ye.ext }))), fe.label = 19;
                case 19:
                  return lt.type !== "txt" && lt.type !== "custom" || (it = this.eventHandler) === null || it === void 0 || it.dispatch("onModifiedMessage", x), [2];
                case 20:
                  return g.kg.error("unexpected message type: ".concat(st.type)), [2];
                case 21:
                  Ye = "normal", Qe = !1, Ht.toLowerCase() === "chat" || Ht === "singleChat" ? ne = "singleChat" : Ht.toLowerCase() === "groupchat" || Ht === "groupChat" ? ne = "groupChat" : (ne = "chatRoom", Ot = 1, j.ext && (W = k(j.ext), Qe = !!(W != null && W.is_broadcast), Ye = W.chatroom_msg_tag === 0 ? "high" : W.chatroom_msg_tag === 2 ? "low" : "normal")), ce = 0, fe.label = 22;
                case 22:
                  return ce < st.contents.length ? [4, D.call(this, { status: G, thirdMessage: st, msgBody: st.contents[ce], msgId: wt, type: Ht, from: zt, to: ze, time: Tt, onlineState: Ot, chatType: ne, ignoreCallback: U, priority: Ye, format: M, broadcast: Qe, isContentReplaced: kt })] : [3, 25];
                case 23:
                  return [2, fe.sent()];
                case 24:
                  return ce++, [3, 22];
                case 25:
                  return [2];
              }
            });
          });
        };
      }, 7288: function(l, v, s) {
        var c;
        s.d(v, { r: function() {
          return c;
        } }), function(d) {
          d[d.CREATE = 0] = "CREATE", d[d.FAIL = 1] = "FAIL", d[d.INPROGRESS = 2] = "INPROGRESS", d[d.SUCCESS = 3] = "SUCCESS";
        }(c || (c = {}));
      }, 9743: function(l, v, s) {
        s.d(v, { E7: function() {
          return d;
        }, MQ: function() {
          return c;
        }, un: function() {
          return p;
        } }), s(2222);
        var c = function(m) {
          return "".concat(m.conversationType, "-").concat(m.conversationId);
        }, d = function(m) {
          var E = m.isRecallSelfMsg, y = m.conversation, g = m.recalledMsgTime, C = y.unReadCount, O = C === void 0 ? 0 : C, N = y.unreadCountClearTimestamp;
          return E || (N === void 0 ? 0 : N) > g ? O : O && O > 0 ? O - 1 : 0;
        }, p = function(m) {
          var E, y = 0;
          if (m.length === 0) return y;
          for (E = 0; E < m.length; E++) y = (y << 5) - y + m.charCodeAt(E), y |= 0;
          return y;
        };
      }, 7360: function(l, v, s) {
        function c() {
          console.log && (console.log.apply ? console.log.apply(console, Array.prototype.slice.call(arguments)) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
        }
        s.d(v, { kg: function() {
          return I;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(7042), s(2222), s(8309), s(9600), s(3843), s(3710), s(2564), s(285), s(1637), s(4812), s(9554), s(2772), s(4916);
        var d = typeof window < "u" && window.navigator !== void 0 && /Trident\/|MSIE /.test(window.navigator.userAgent), p = s(4024);
        function m(k) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
            return typeof H;
          } : function(H) {
            return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
          }, m(k);
        }
        var E, y = function(k, H, S, B) {
          return new (S || (S = Promise))(function(D, F) {
            function j(M) {
              try {
                U(B.next(M));
              } catch (V) {
                F(V);
              }
            }
            function G(M) {
              try {
                U(B.throw(M));
              } catch (V) {
                F(V);
              }
            }
            function U(M) {
              var V;
              M.done ? D(M.value) : (V = M.value, V instanceof S ? V : new S(function(J) {
                J(V);
              })).then(j, G);
            }
            U((B = B.apply(k, [])).next());
          });
        }, g = function(k, H) {
          var S, B, D, F, j = { label: 0, sent: function() {
            if (1 & D[0]) throw D[1];
            return D[1];
          }, trys: [], ops: [] };
          return F = { next: G(0), throw: G(1), return: G(2) }, typeof Symbol == "function" && (F[Symbol.iterator] = function() {
            return this;
          }), F;
          function G(U) {
            return function(M) {
              return function(V) {
                if (S) throw new TypeError("Generator is already executing.");
                for (; j; ) try {
                  if (S = 1, B && (D = 2 & V[0] ? B.return : V[0] ? B.throw || ((D = B.return) && D.call(B), 0) : B.next) && !(D = D.call(B, V[1])).done) return D;
                  switch (B = 0, D && (V = [2 & V[0], D.value]), V[0]) {
                    case 0:
                    case 1:
                      D = V;
                      break;
                    case 4:
                      return j.label++, { value: V[1], done: !1 };
                    case 5:
                      j.label++, B = V[1], V = [0];
                      continue;
                    case 7:
                      V = j.ops.pop(), j.trys.pop();
                      continue;
                    default:
                      if (!((D = (D = j.trys).length > 0 && D[D.length - 1]) || V[0] !== 6 && V[0] !== 2)) {
                        j = 0;
                        continue;
                      }
                      if (V[0] === 3 && (!D || V[1] > D[0] && V[1] < D[3])) {
                        j.label = V[1];
                        break;
                      }
                      if (V[0] === 6 && j.label < D[1]) {
                        j.label = D[1], D = V;
                        break;
                      }
                      if (D && j.label < D[2]) {
                        j.label = D[2], j.ops.push(V);
                        break;
                      }
                      D[2] && j.ops.pop(), j.trys.pop();
                      continue;
                  }
                  V = H.call(k, j);
                } catch (J) {
                  V = [6, J], B = 0;
                } finally {
                  S = D = 0;
                }
                if (5 & V[0]) throw V[1];
                return { value: V[0] ? V[1] : void 0, done: !0 };
              }([U, M]);
            };
          }
        }, C = function() {
        }, O = {};
        (function(k) {
          k[k.TRACE = 0] = "TRACE", k[k.DEBUG = 1] = "DEBUG", k[k.INFO = 2] = "INFO", k[k.WARN = 3] = "WARN", k[k.ERROR = 4] = "ERROR", k[k.SILENT = 5] = "SILENT";
        })(E || (E = {}));
        var N = function() {
          function k(H, S, B) {
            this.name = H || "defaultLogger", this.currentLevel = 0, this.useCookiePersist = !1, this.storageLogLevelKey = "loglevel", this.levels = E, this.consoleLogVisibility = !0, this.logMethods = ["trace", "debug", "info", "warn", "error"], this.methodFactory = B || this.defaultMethodFactory, this.report = !1;
            var D = this._getPersistedLevel();
            D == null && (D = S === null ? "WARN" : S), this.logs = [], this.reportLogs = [], this.reportInterval = 3e5, this.timer = null, this.config = { useCache: !1, maxCache: 3145728, color: "", background: "" }, this.logBytes = 0, this.setLevel(D, !1, "");
          }
          return k.prototype.reportLog = function() {
            var H, S, B;
            return y(this, void 0, void 0, function() {
              var D, F, j, G, U, M, V, J;
              return g(this, function(ue) {
                switch (ue.label) {
                  case 0:
                    if (((H = this.reportLogs) === null || H === void 0 ? void 0 : H.length) === 0) return [2];
                    for (D = 2097152, F = this.reportLogs.join(`
`) + `
`, j = F.length, G = []; j > D; ) G.push(F.substring(0, D)), j -= D, F = F.substring(D);
                    G.push(F), U = 0, M = G, ue.label = 1;
                  case 1:
                    if (!(U < M.length)) return [3, 8];
                    if (V = M[U], this.reportLogs = [], !(!((B = (S = this.connection) === null || S === void 0 ? void 0 : S.context) === null || B === void 0) && B.accessToken)) return [2];
                    ue.label = 2;
                  case 2:
                    return ue.trys.push([2, 4, , 5]), [4, this.reportData(V)];
                  case 3:
                    return ((J = ue.sent()) == null ? void 0 : J.status) !== "ok" && this.reportLogs.unshift(V), [3, 5];
                  case 4:
                    return ue.sent(), this.reportLogs.unshift(V), [3, 5];
                  case 5:
                    return [4, p.P6.delay(3e3)];
                  case 6:
                    ue.sent(), ue.label = 7;
                  case 7:
                    return U++, [3, 1];
                  case 8:
                    return [2];
                }
              });
            });
          }, k.prototype.reportData = function(H) {
            var S, B = this;
            if (this.connection) {
              var D = this.connection.context || {}, F = D.orgName, j = D.appName, G = D.accessToken, U = D.userId;
              if (F && j) {
                var M = { url: "".concat((S = this.connection) === null || S === void 0 ? void 0 : S.apiUrl, "/").concat(F, "/").concat(j, "/sdk/users/").concat(U, "/client/logs"), type: "POST", data: JSON.stringify({ resource: this.connection.clientResource || "random_".concat(Date.now()), logContent: H }), dataType: "json", headers: { Authorization: "Bearer " + G, "Content-Type": "application/json" } };
                return p.hj.call(this.connection, M).then(function(V) {
                  return B.log("report log success", V), V;
                }).catch(function(V) {
                  B.error("report log error", V);
                });
              }
            } else this.error("report log error", "connection is null");
          }, k.prototype._regularlyReportLogs = function() {
            var H, S = this;
            this.timer && clearInterval(this.timer), ((H = this.reportInterval) !== null && H !== void 0 ? H : 0) < 6e4 && (this.reportInterval = 6e4), this.timer = setInterval(function() {
              S.reportLog();
            }, this.reportInterval || 3e5);
          }, k.prototype._stopReportLogs = function() {
            return y(this, void 0, void 0, function() {
              return g(this, function(H) {
                switch (H.label) {
                  case 0:
                    return H.trys.push([0, 2, , 3]), [4, this.reportLog()];
                  case 1:
                    return H.sent(), [3, 3];
                  case 2:
                    return H.sent(), this.error("report log error when stopping upload"), [3, 3];
                  case 3:
                    return this.reportLogs = [], clearInterval(this.timer), [2];
                }
              });
            });
          }, k.prototype.setConfig = function(H) {
            this.config = H;
          }, k.prototype.getLevel = function() {
            return this.currentLevel;
          }, k.prototype.setLevel = function(H, S, B) {
            if (typeof H == "string" && (H = E[H]), H === void 0 && (H = 0), !(typeof H == "number" && H >= 0 && H <= this.levels.SILENT)) throw Error("log.setLevel() called with invalid level: " + H);
            if (this.currentLevel = H, S !== !1 && this._persistLevel(H), this.replaceLoggingMethods(H, B || ""), typeof console > "u" && H < E.SILENT) throw Error("No console available for logging");
          }, k.prototype.setDefaultLevel = function(H) {
            this._getPersistedLevel() || this.setLevel(H, !1, "");
          }, k.prototype.enableAll = function(H) {
            this.setLevel(this.levels.TRACE, !0, "");
          }, k.prototype.disableAll = function(H) {
            this.setLevel(this.levels.SILENT, !0, "");
          }, k.prototype.getLogs = function() {
            return this.logs;
          }, k.prototype.download = function() {
            if (typeof window < "u" && typeof document < "u") {
              var H = this.getLogs().join(`
`), S = new Blob([H], { type: "text/plain;charset=UTF-8" }), B = window.URL.createObjectURL(S), D = document.createElement("a");
              D.style.display = "none", D.href = B, D.setAttribute("download", "sdklog"), document.body.appendChild(D), D.click();
            }
          }, k.prototype.setConsoleLogVisibility = function(H) {
            this.consoleLogVisibility = H;
          }, k.prototype._bindMethod = function(H, S, B) {
            var D = this, F = H[S], j = this.getTime();
            if (B) return this._cacheLog;
            if (typeof F.bind == "function") return function() {
              for (var G = [], U = 0; U < arguments.length; U++) G[U] = arguments[U];
              var M = D.getTime();
              D.consoleLogVisibility && F.call.apply(F, function(V, J, ue) {
                if (arguments.length === 2) for (var se, ee = 0, de = J.length; ee < de; ee++) !se && ee in J || (se || (se = Array.prototype.slice.call(J, 0, ee)), se[ee] = J[ee]);
                return V.concat(se || Array.prototype.slice.call(J));
              }([H, "".concat(M, " IM SDK [").concat(S === "log" ? "debug" : S, "]: ")], G, !1)), D.onLog && D.onLog({ time: M, level: S === "log" ? "debug" : S, logs: G }), D._cacheReportLogs.apply(D, G);
            };
            try {
              return Function.prototype.bind.call(F, H, "".concat(j, " IM SDK [").concat(S === "log" ? "debug" : S, "]: "));
            } catch {
              return function() {
                return Function.prototype.apply.apply(F, [H, arguments]);
              };
            }
          }, k.prototype.getTime = function() {
            var H = /* @__PURE__ */ new Date();
            return H.toTimeString().split(" ")[0] + ":" + H.getMilliseconds();
          }, k.prototype._cacheLog = function() {
            for (var H = [], S = 0; S < arguments.length; S++) H[S] = arguments[S];
            var B = (/* @__PURE__ */ new Date()).toLocaleString() + ": ", D = "";
            H.forEach(function(F) {
              m(F) === "object" ? D += JSON.stringify(F) + " " : D += F + " ";
            }), this._cacheLogCall(B + D), this._cacheReportLogs.apply(this, H);
          }, k.prototype._cacheLogCall = function(H) {
            var S = H.length, B = this.logBytes + S, D = this.config.maxCache;
            if (!(S >= D)) {
              if (B < D) this.logBytes += S;
              else for (var F = B - D, j = 0; j < F; ) {
                var G = this.logs.shift();
                G !== void 0 && (j += G.length);
              }
              this.logs.push(H);
            }
          }, k.prototype._cacheReportLogs = function() {
            for (var H = [], S = 0; S < arguments.length; S++) H[S] = arguments[S];
            if (this.report) {
              var B = (/* @__PURE__ */ new Date()).toLocaleString() + ": ", D = "";
              H.forEach(function(F) {
                m(F) === "object" ? D += JSON.stringify(F) + " " : D += F + " ";
              }), this.reportLogs.push(B + D);
            }
          }, k.prototype._getPersistedLevel = function() {
            var H;
            if (typeof window > "u") return 5;
            if ((H = window && window.localStorage && window.localStorage[this.storageLogLevelKey]) === "undefined") {
              var S = window.document.cookie, B = S.indexOf(encodeURIComponent(this.storageLogLevelKey));
              B !== -1 && (H = /^([^;]+)/.exec(S.slice(B))[1]);
            }
            return H || 5;
          }, k.prototype._persistLevel = function(H) {
            var S = this.logMethods[H] || "SILENT";
            if (typeof window < "u") {
              if (window.localStorage) try {
                window.localStorage[this.storageLogLevelKey] = S;
              } catch (B) {
                console.log(B);
              }
              this.useCookiePersist && (window.document.cookie = encodeURIComponent(this.storageLogLevelKey) + "=" + S + ";");
            }
          }, k.prototype.replaceLoggingMethods = function(H, S) {
            for (var B = this, D = 0; D < this.logMethods.length; D++) {
              var F = this.logMethods[D];
              this[F] = D < H ? function() {
                for (var j = [], G = 0; G < arguments.length; G++) j[G] = arguments[G];
                B.report && B._cacheReportLogs.apply(B, j);
              } : this.methodFactory(F, H, S);
            }
            this.log = this.debug;
          }, k.prototype.defaultMethodFactory = function(H, S, B) {
            return this.realMethod(H) || this.enableLoggingWhenConsoleArrives.apply(this, [H, S, B]);
          }, k.prototype.realMethod = function(H) {
            return H === "debug" && (H = "log"), typeof console < "u" && (H === "trace" && d ? c : console[H] !== void 0 ? this._bindMethod(console, H, this.config.useCache) : console.log !== void 0 ? this._bindMethod(console, "log", this.config.useCache) : C);
          }, k.prototype.enableLoggingWhenConsoleArrives = function(H, S, B) {
            return (function() {
              typeof console < "u" && (this.replaceLoggingMethods.call(this, S, B), this[H].apply(this, arguments));
            }).bind(this);
          }, k;
        }(), w = new N();
        w.getLogger = function(k) {
          if (typeof k != "string" || k === "") throw new TypeError("You must supply a name when creating a logger.");
          return this;
        };
        var _ = typeof window < "u" ? window.log : void 0;
        w.noConflict = function() {
          return typeof window < "u" && window.log === w && (window.log = _), w;
        }, w.getLoggers = function() {
          return O;
        }, w.initReport = function(k) {
          var H = k.report, S = k.reportInterval, B = k.connection;
          w.report = H, w.reportInterval = S, w.connection = B, H && w._regularlyReportLogs();
        };
        var I = w;
      }, 2449: function(l, v, s) {
        s.d(v, { Message: function() {
          return k;
        } });
        var c = s(4024), d = function() {
          function H(S) {
            var B = S.id;
            this.id = B, this.type = S.type;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, ackId: S.id, type: "read", to: S.to, from: S.from || "", chatType: S.chatType };
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType, ackId: S.id, type: "read", to: S.to, from: S.from || "", ackContent: S.ackContent, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly };
          }, H;
        }(), p = function() {
          function H(S) {
            this.id = S.id, this.type = S.type;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, ackId: S.ackId, type: "delivery", to: S.to, from: S.from || "" };
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), ackId: S.ackId, type: "delivery", to: S.to, from: S.from || "", isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly };
          }, H;
        }(), m = (s(3843), s(3710), function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "channel", to: S.to, from: S.from || "", time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), type: "channel", chatType: S.chatType || "singleChat", to: S.to, from: S.from || "", time: Date.now(), isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly };
          }, H;
        }()), E = (s(9753), function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B, this.value = "";
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "txt", to: S.to, msg: S.msg, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), isChatThread: S.isChatThread }, this.value = S.msg;
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            var B, D;
            return !((B = S.msgConfig) === null || B === void 0) && B.languages && Array.isArray((D = S.msgConfig) === null || D === void 0 ? void 0 : D.languages), { type: "txt", id: c.P6.getUniqueId(), msg: S.msg, to: S.to, from: S.from || "", chatType: S.chatType, ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }()), y = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D || c.P6.getUniqueId(), this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "cmd", to: S.to, action: S.action, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), type: "cmd", to: S.to, from: S.from || "", chatType: S.chatType || "singleChat", action: S.action, time: Date.now(), ext: S.ext, msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), g = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "custom", to: S.to, customEvent: S.customEvent, customExts: S.customExts, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "custom", to: S.to, customEvent: S.customEvent, customExts: S.customExts, from: S.from || "", ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), C = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D || c.P6.getUniqueId(), this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "loc", to: S.to, addr: S.addr, buildingName: S.buildingName, lat: S.lat, lng: S.lng, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "loc", to: S.to, addr: S.addr, buildingName: S.buildingName, lat: S.lat, lng: S.lng, from: S.from || "", ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), O = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "img", file: S.file, width: S.width, height: S.height, to: S.to, from: S.from || "", roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType, type: "img", url: S.url, width: S.width, height: S.height, file: S.file, to: S.to, from: S.from || "", ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, file_length: S.file_length, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList, thumbnailWidth: S.thumbnailWidth, thumbnailHeight: S.thumbnailHeight };
          }, H;
        }(), N = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "audio", file: S.file, filename: S.filename, length: S.length, file_length: S.file_length, fileInputId: S.fileInputId, to: S.to, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType, type: "audio", filename: S.filename, length: S.length, file: S.file, to: S.to, from: S.from || "", ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, file_length: S.file_length, msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), w = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "video", file: S.file, filename: S.filename, length: S.length, file_length: S.file_length, fileInputId: S.fileInputId, to: S.to, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), apiUrl: S.apiUrl, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "video", file: S.file, filename: S.filename, length: S.length, file_length: S.file_length, fileInputId: S.fileInputId, to: S.to, from: S.from || "", ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), _ = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "file", file: S.file, filename: S.filename, fileInputId: S.fileInputId, to: S.to, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "file", file: S.file, filename: S.filename, fileInputId: S.fileInputId, file_length: S.file_length, to: S.to, from: S.from || "", ext: S.ext, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), I = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B, this.value = "";
          }
          return H.create = function(S) {
            return { type: "combine", id: c.P6.getUniqueId(), to: S.to, from: S.from || "", chatType: S.chatType, ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList, compatibleText: S.compatibleText, title: S.title, summary: S.summary, messageList: S.messageList, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete };
          }, H;
        }(), k = function() {
          function H(S, B) {
            return this.type = S, this.id = B || c.P6.getUniqueId(), H.createOldMsg({ type: S, id: this.id });
          }
          return H.createOldMsg = function(S) {
            switch (S.type) {
              case "read":
                return new d({ type: "read", id: S.id });
              case "delivery":
                return new p({ type: "delivery", id: S.id });
              case "channel":
                return new m({ type: "channel", id: S.id });
              case "txt":
                return new E({ type: "txt", id: S.id });
              case "cmd":
                return new y({ type: "cmd", id: S.id });
              case "custom":
                return new g({ type: "custom", id: S.id });
              case "loc":
                return new C({ type: "loc", id: S.id });
              case "img":
                return new O({ type: "img", id: S.id });
              case "audio":
                return new N({ type: "audio", id: S.id });
              case "video":
                return new w({ type: "video", id: S.id });
              case "file":
                return new _({ type: "file", id: S.id });
            }
          }, H.create = function(S) {
            return (B = S).type !== "txt" || "version" in B ? function(D) {
              return D.type === "img" && !("version" in D);
            }(S) ? O.create(S) : function(D) {
              return D.type === "cmd" && !("version" in D);
            }(S) ? y.create(S) : function(D) {
              return D.type === "file" && !("version" in D);
            }(S) ? _.create(S) : function(D) {
              return D.type === "audio" && !("version" in D);
            }(S) ? N.create(S) : function(D) {
              return D.type === "video" && !("version" in D);
            }(S) ? w.create(S) : function(D) {
              return D.type === "custom" && !("version" in D);
            }(S) ? g.create(S) : function(D) {
              return D.type === "loc" && !("version" in D);
            }(S) ? C.create(S) : function(D) {
              return D.type === "channel" && !("version" in D);
            }(S) ? m.create(S) : function(D) {
              return D.type === "delivery" && !("version" in D);
            }(S) ? p.create(S) : function(D) {
              return D.type === "read" && !("version" in D);
            }(S) ? d.create(S) : function(D) {
              return D.type === "combine" && !("version" in D);
            }(S) ? I.create(S) : {} : E.create(S);
            var B;
          }, H.prototype.set = function(S) {
          }, H.getFileUrl = c.P6.getFileUrl, H.download = c.P6.download, H.parseDownloadResponse = c.P6.parseDownloadResponse, H;
        }();
      }, 5531: function(l, v, s) {
        var c;
        s.d(v, { E: function() {
          return c;
        } }), function(d) {
          d[d.REQUEST_SUCCESS = 0] = "REQUEST_SUCCESS", d[d.REQUEST_TIMEOUT = -1] = "REQUEST_TIMEOUT", d[d.REQUEST_UNKNOWN = -2] = "REQUEST_UNKNOWN", d[d.REQUEST_PARAMETER_ERROR = -3] = "REQUEST_PARAMETER_ERROR", d[d.REQUEST_ABORT = -4] = "REQUEST_ABORT", d[d.WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR = 0] = "WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_OPEN_ERROR = 1] = "WEBIM_CONNCTION_OPEN_ERROR", d[d.WEBIM_CONNCTION_AUTH_ERROR = 2] = "WEBIM_CONNCTION_AUTH_ERROR", d[d.WEBIM_CONNCTION_OPEN_USERGRID_ERROR = 3] = "WEBIM_CONNCTION_OPEN_USERGRID_ERROR", d[d.WEBIM_CONNCTION_ATTACH_ERROR = 4] = "WEBIM_CONNCTION_ATTACH_ERROR", d[d.WEBIM_CONNCTION_ATTACH_USERGRID_ERROR = 5] = "WEBIM_CONNCTION_ATTACH_USERGRID_ERROR", d[d.WEBIM_CONNCTION_REOPEN_ERROR = 6] = "WEBIM_CONNCTION_REOPEN_ERROR", d[d.WEBIM_CONNCTION_SERVER_CLOSE_ERROR = 7] = "WEBIM_CONNCTION_SERVER_CLOSE_ERROR", d[d.WEBIM_CONNCTION_SERVER_ERROR = 8] = "WEBIM_CONNCTION_SERVER_ERROR", d[d.WEBIM_CONNCTION_IQ_ERROR = 9] = "WEBIM_CONNCTION_IQ_ERROR", d[d.WEBIM_CONNCTION_PING_ERROR = 10] = "WEBIM_CONNCTION_PING_ERROR", d[d.WEBIM_CONNCTION_NOTIFYVERSION_ERROR = 11] = "WEBIM_CONNCTION_NOTIFYVERSION_ERROR", d[d.WEBIM_CONNCTION_GETROSTER_ERROR = 12] = "WEBIM_CONNCTION_GETROSTER_ERROR", d[d.WEBIM_CONNCTION_CROSSDOMAIN_ERROR = 13] = "WEBIM_CONNCTION_CROSSDOMAIN_ERROR", d[d.WEBIM_CONNCTION_LISTENING_OUTOF_MAXRETRIES = 14] = "WEBIM_CONNCTION_LISTENING_OUTOF_MAXRETRIES", d[d.WEBIM_CONNCTION_RECEIVEMSG_CONTENTERROR = 15] = "WEBIM_CONNCTION_RECEIVEMSG_CONTENTERROR", d[d.WEBIM_CONNCTION_DISCONNECTED = 16] = "WEBIM_CONNCTION_DISCONNECTED", d[d.WEBIM_CONNCTION_AJAX_ERROR = 17] = "WEBIM_CONNCTION_AJAX_ERROR", d[d.WEBIM_CONNCTION_JOINROOM_ERROR = 18] = "WEBIM_CONNCTION_JOINROOM_ERROR", d[d.WEBIM_CONNCTION_GETROOM_ERROR = 19] = "WEBIM_CONNCTION_GETROOM_ERROR", d[d.WEBIM_CONNCTION_GETROOMINFO_ERROR = 20] = "WEBIM_CONNCTION_GETROOMINFO_ERROR", d[d.WEBIM_CONNCTION_GETROOMMEMBER_ERROR = 21] = "WEBIM_CONNCTION_GETROOMMEMBER_ERROR", d[d.WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR = 22] = "WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR", d[d.WEBIM_CONNCTION_LOAD_CHATROOM_ERROR = 23] = "WEBIM_CONNCTION_LOAD_CHATROOM_ERROR", d[d.WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR = 24] = "WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR", d[d.WEBIM_CONNCTION_JOINCHATROOM_ERROR = 25] = "WEBIM_CONNCTION_JOINCHATROOM_ERROR", d[d.WEBIM_CONNCTION_QUITCHATROOM_ERROR = 26] = "WEBIM_CONNCTION_QUITCHATROOM_ERROR", d[d.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR = 27] = "WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR = 28] = "WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR = 29] = "WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR = 30] = "WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_CALLBACK_INNER_ERROR = 31] = "WEBIM_CONNCTION_CALLBACK_INNER_ERROR", d[d.WEBIM_CONNCTION_CLIENT_OFFLINE = 32] = "WEBIM_CONNCTION_CLIENT_OFFLINE", d[d.WEBIM_CONNCTION_CLIENT_LOGOUT = 33] = "WEBIM_CONNCTION_CLIENT_LOGOUT", d[d.WEBIM_CONNCTION_CLIENT_TOO_MUCH_ERROR = 34] = "WEBIM_CONNCTION_CLIENT_TOO_MUCH_ERROR", d[d.WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP = 35] = "WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP", d[d.WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP = 36] = "WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP", d[d.WEBIM_CONNECTION_ACCEPT_JOIN_GROUP = 37] = "WEBIM_CONNECTION_ACCEPT_JOIN_GROUP", d[d.WEBIM_CONNECTION_DECLINE_JOIN_GROUP = 38] = "WEBIM_CONNECTION_DECLINE_JOIN_GROUP", d[d.WEBIM_CONNECTION_CLOSED = 39] = "WEBIM_CONNECTION_CLOSED", d[d.WEBIM_CONNECTION_ERROR = 40] = "WEBIM_CONNECTION_ERROR", d[d.MAX_LIMIT = 50] = "MAX_LIMIT", d[d.MESSAGE_NOT_FOUND = 51] = "MESSAGE_NOT_FOUND", d[d.NO_PERMISSION = 52] = "NO_PERMISSION", d[d.OPERATION_UNSUPPORTED = 53] = "OPERATION_UNSUPPORTED", d[d.OPERATION_NOT_ALLOWED = 54] = "OPERATION_NOT_ALLOWED", d[d.WEBIM_TOKEN_EXPIRED = 56] = "WEBIM_TOKEN_EXPIRED", d[d.WEBIM_SERVER_SERVING_DISABLED = 57] = "WEBIM_SERVER_SERVING_DISABLED", d[d.WEBIM_UPLOADFILE_BROWSER_ERROR = 100] = "WEBIM_UPLOADFILE_BROWSER_ERROR", d[d.WEBIM_UPLOADFILE_ERROR = 101] = "WEBIM_UPLOADFILE_ERROR", d[d.WEBIM_UPLOADFILE_NO_LOGIN = 102] = "WEBIM_UPLOADFILE_NO_LOGIN", d[d.WEBIM_UPLOADFILE_NO_FILE = 103] = "WEBIM_UPLOADFILE_NO_FILE", d[d.WEBIM_DOWNLOADFILE_ERROR = 200] = "WEBIM_DOWNLOADFILE_ERROR", d[d.WEBIM_DOWNLOADFILE_NO_LOGIN = 201] = "WEBIM_DOWNLOADFILE_NO_LOGIN", d[d.WEBIM_DOWNLOADFILE_BROWSER_ERROR = 202] = "WEBIM_DOWNLOADFILE_BROWSER_ERROR", d[d.PARSE_FILE_ERROR = 203] = "PARSE_FILE_ERROR", d[d.USER_NOT_FOUND = 204] = "USER_NOT_FOUND", d[d.MESSAGE_PARAMETER_ERROR = 205] = "MESSAGE_PARAMETER_ERROR", d[d.WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE = 206] = "WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE", d[d.WEBIM_CONNCTION_USER_REMOVED = 207] = "WEBIM_CONNCTION_USER_REMOVED", d[d.WEBIM_USER_ALREADY_LOGIN = 208] = "WEBIM_USER_ALREADY_LOGIN", d[d.WEBIM_CONNCTION_USER_KICKED_BY_CHANGE_PASSWORD = 216] = "WEBIM_CONNCTION_USER_KICKED_BY_CHANGE_PASSWORD", d[d.WEBIM_CONNCTION_USER_KICKED_BY_OTHER_DEVICE = 217] = "WEBIM_CONNCTION_USER_KICKED_BY_OTHER_DEVICE", d[d.USER_MUTED_BY_ADMIN = 219] = "USER_MUTED_BY_ADMIN", d[d.USER_NOT_FRIEND = 221] = "USER_NOT_FRIEND", d[d.WEBIM_MESSAGE_REC_TEXT = 300] = "WEBIM_MESSAGE_REC_TEXT", d[d.WEBIM_MESSAGE_REC_TEXT_ERROR = 301] = "WEBIM_MESSAGE_REC_TEXT_ERROR", d[d.WEBIM_MESSAGE_REC_EMOTION = 302] = "WEBIM_MESSAGE_REC_EMOTION", d[d.WEBIM_MESSAGE_REC_PHOTO = 303] = "WEBIM_MESSAGE_REC_PHOTO", d[d.SERVER_GET_DNSLIST_FAILED = 304] = "SERVER_GET_DNSLIST_FAILED", d[d.WEBIM_MESSAGE_REC_AUDIO_FILE = 305] = "WEBIM_MESSAGE_REC_AUDIO_FILE", d[d.WEBIM_MESSAGE_REC_VEDIO = 306] = "WEBIM_MESSAGE_REC_VEDIO", d[d.WEBIM_MESSAGE_REC_VEDIO_FILE = 307] = "WEBIM_MESSAGE_REC_VEDIO_FILE", d[d.WEBIM_MESSAGE_REC_FILE = 308] = "WEBIM_MESSAGE_REC_FILE", d[d.WEBIM_MESSAGE_SED_TEXT = 309] = "WEBIM_MESSAGE_SED_TEXT", d[d.WEBIM_MESSAGE_SED_EMOTION = 310] = "WEBIM_MESSAGE_SED_EMOTION", d[d.WEBIM_MESSAGE_SED_PHOTO = 311] = "WEBIM_MESSAGE_SED_PHOTO", d[d.WEBIM_MESSAGE_SED_AUDIO = 312] = "WEBIM_MESSAGE_SED_AUDIO", d[d.WEBIM_MESSAGE_SED_AUDIO_FILE = 313] = "WEBIM_MESSAGE_SED_AUDIO_FILE", d[d.WEBIM_MESSAGE_SED_VEDIO = 314] = "WEBIM_MESSAGE_SED_VEDIO", d[d.WEBIM_MESSAGE_SED_VEDIO_FILE = 315] = "WEBIM_MESSAGE_SED_VEDIO_FILE", d[d.WEBIM_MESSAGE_SED_FILE = 316] = "WEBIM_MESSAGE_SED_FILE", d[d.WEBIM_MESSAGE_SED_ERROR = 317] = "WEBIM_MESSAGE_SED_ERROR", d[d.STATUS_INIT = 400] = "STATUS_INIT", d[d.STATUS_DOLOGIN_USERGRID = 401] = "STATUS_DOLOGIN_USERGRID", d[d.STATUS_DOLOGIN_IM = 402] = "STATUS_DOLOGIN_IM", d[d.STATUS_OPENED = 403] = "STATUS_OPENED", d[d.STATUS_CLOSING = 404] = "STATUS_CLOSING", d[d.STATUS_CLOSED = 405] = "STATUS_CLOSED", d[d.STATUS_ERROR = 406] = "STATUS_ERROR", d[d.SERVER_BUSY = 500] = "SERVER_BUSY", d[d.MESSAGE_INCLUDE_ILLEGAL_CONTENT = 501] = "MESSAGE_INCLUDE_ILLEGAL_CONTENT", d[d.MESSAGE_EXTERNAL_LOGIC_BLOCKED = 502] = "MESSAGE_EXTERNAL_LOGIC_BLOCKED", d[d.SERVER_UNKNOWN_ERROR = 503] = "SERVER_UNKNOWN_ERROR", d[d.MESSAGE_RECALL_TIME_LIMIT = 504] = "MESSAGE_RECALL_TIME_LIMIT", d[d.SERVICE_NOT_ENABLED = 505] = "SERVICE_NOT_ENABLED", d[d.SERVICE_NOT_ALLOW_MESSAGING = 506] = "SERVICE_NOT_ALLOW_MESSAGING", d[d.SERVICE_NOT_ALLOW_MESSAGING_MUTE = 507] = "SERVICE_NOT_ALLOW_MESSAGING_MUTE", d[d.MESSAGE_MODERATION_BLOCKED = 508] = "MESSAGE_MODERATION_BLOCKED", d[d.MESSAGE_CURRENT_LIMITING = 509] = "MESSAGE_CURRENT_LIMITING", d[d.MESSAGE_WEBSOCKET_DISCONNECTED = 510] = "MESSAGE_WEBSOCKET_DISCONNECTED", d[d.MESSAGE_SIZE_LIMIT = 511] = "MESSAGE_SIZE_LIMIT", d[d.MESSAGE_SEND_TIMEOUT = 512] = "MESSAGE_SEND_TIMEOUT", d[d.GROUP_NOT_EXIST = 605] = "GROUP_NOT_EXIST", d[d.GROUP_NOT_JOINED = 602] = "GROUP_NOT_JOINED", d[d.GROUP_MEMBERS_FULL = 606] = "GROUP_MEMBERS_FULL", d[d.PERMISSION_DENIED = 603] = "PERMISSION_DENIED", d[d.WEBIM_LOAD_MSG_ERROR = 604] = "WEBIM_LOAD_MSG_ERROR", d[d.GROUP_ALREADY_JOINED = 601] = "GROUP_ALREADY_JOINED", d[d.GROUP_MEMBERS_LIMIT = 607] = "GROUP_MEMBERS_LIMIT", d[d.GROUP_IS_DISABLED = 608] = "GROUP_IS_DISABLED", d[d.GROUP_MEMBER_ATTRIBUTES_SET_FAILED = 609] = "GROUP_MEMBER_ATTRIBUTES_SET_FAILED", d[d.REST_PARAMS_STATUS = 700] = "REST_PARAMS_STATUS", d[d.CHATROOM_NOT_JOINED = 702] = "CHATROOM_NOT_JOINED", d[d.CHATROOM_MEMBERS_FULL = 704] = "CHATROOM_MEMBERS_FULL", d[d.CHATROOM_NOT_EXIST = 705] = "CHATROOM_NOT_EXIST", d[d.LOCAL_DB_OPERATION_FAILED = 800] = "LOCAL_DB_OPERATION_FAILED", d[d.SDK_RUNTIME_ERROR = 999] = "SDK_RUNTIME_ERROR", d[d.PRESENCE_PARAM_EXCEED = 1100] = "PRESENCE_PARAM_EXCEED", d[d.REACTION_ALREADY_ADDED = 1101] = "REACTION_ALREADY_ADDED", d[d.REACTION_CREATING = 1102] = "REACTION_CREATING", d[d.REACTION_OPERATION_IS_ILLEGAL = 1103] = "REACTION_OPERATION_IS_ILLEGAL", d[d.TRANSLATION_NOT_VALID = 1200] = "TRANSLATION_NOT_VALID", d[d.TRANSLATION_TEXT_TOO_LONG = 1201] = "TRANSLATION_TEXT_TOO_LONG", d[d.TRANSLATION_FAILED = 1204] = "TRANSLATION_FAILED", d[d.THREAD_NOT_EXIST = 1300] = "THREAD_NOT_EXIST", d[d.THREAD_ALREADY_EXIST = 1301] = "THREAD_ALREADY_EXIST", d[d.MODIFY_MESSAGE_NOT_EXIST = 1302] = "MODIFY_MESSAGE_NOT_EXIST", d[d.MODIFY_MESSAGE_FORMAT_ERROR = 1303] = "MODIFY_MESSAGE_FORMAT_ERROR", d[d.MODIFY_MESSAGE_FAILED = 1304] = "MODIFY_MESSAGE_FAILED", d[d.CONVERSATION_NOT_EXIST = 1400] = "CONVERSATION_NOT_EXIST";
        }(c || (c = {}));
      }, 4998: function(l, v, s) {
        var c;
        s.d(v, { a: function() {
          return c;
        } }), s(7252), function(d) {
          d[d.SYNC_INIT = 0] = "SYNC_INIT", d[d.SYNC_START = 1] = "SYNC_START", d[d.SYNC_FINISH = 2] = "SYNC_FINISH";
        }(c || (c = {}));
      }, 9937: function(l, v, s) {
        var c;
        s.d(v, { Z: function() {
          return c;
        } }), function(d) {
          d[d.mark_0 = 0] = "mark_0", d[d.mark_1 = 1] = "mark_1", d[d.mark_2 = 2] = "mark_2", d[d.mark_3 = 3] = "mark_3", d[d.mark_4 = 4] = "mark_4", d[d.mark_5 = 5] = "mark_5", d[d.mark_6 = 6] = "mark_6", d[d.mark_7 = 7] = "mark_7", d[d.mark_8 = 8] = "mark_8", d[d.mark_9 = 9] = "mark_9", d[d.mark_10 = 10] = "mark_10", d[d.mark_11 = 11] = "mark_11", d[d.mark_12 = 12] = "mark_12", d[d.mark_13 = 13] = "mark_13", d[d.mark_14 = 14] = "mark_14", d[d.mark_15 = 15] = "mark_15", d[d.mark_16 = 16] = "mark_16", d[d.mark_17 = 17] = "mark_17", d[d.mark_18 = 18] = "mark_18", d[d.mark_19 = 19] = "mark_19";
        }(c || (c = {}));
      }, 4024: function(l, v, s) {
        s.d(v, { PU: function() {
          return G;
        }, iw: function() {
          return ue;
        }, hj: function() {
          return U;
        }, LR: function() {
          return Ce;
        }, cT: function() {
          return pe;
        }, P6: function() {
          return Te;
        } }), s(9601), s(1539), s(8674), s(3710), s(7941), s(2564), s(6699), s(7042), s(2772), s(9714), s(9653), s(6992), s(8783), s(3948), s(285), s(1637), s(8309), s(4986), s(2222), s(4916), s(6977);
        var c = s(5531), d = (s(2023), function() {
          return d = Object.assign || function(K) {
            for (var Oe, Pe = 1, xe = arguments.length; Pe < xe; Pe++) for (var be in Oe = arguments[Pe]) Object.prototype.hasOwnProperty.call(Oe, be) && (K[be] = Oe[be]);
            return K;
          }, d.apply(this, arguments);
        }), p = function(K, Oe, Pe, xe) {
          var be, $e, Be, Ke, Ze, at, pt, It, Rt, gt, it, Tt, Ut, st, Ot, kt, wt, Et, ut, St, Ft, Ht, zt, ze, Ne = K.response;
          Ne && typeof Ne == "string" && (Ne = JSON.parse(Ne));
          var le = K.status, X = { elapse: xe, httpCode: le, errDesc: Ne == null ? void 0 : Ne.error_description };
          if (le === 400) {
            if (Ne.error_code === 40002) return void Oe({ type: c.E.THREAD_ALREADY_EXIST, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
            if (Ne.error_code === 40009) return void Oe({ type: c.E.OPERATION_UNSUPPORTED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
            if (Ne.error_code === 60005) return void Oe({ type: c.E.GROUP_MEMBER_ATTRIBUTES_SET_FAILED, message: (Ne == null ? void 0 : Ne.desc) || (Ne == null ? void 0 : Ne.error_description), extraInfo: X });
            if (Ne.error_code === 60010) return void (Ne != null && Ne.error_description.includes("exceeds chatgroup user metadata single value limit") ? Oe({ type: c.E.MAX_LIMIT, message: (Ne == null ? void 0 : Ne.desc) || Ne.error_description, extraInfo: X }) : Oe({ type: c.E.NO_PERMISSION, message: (Ne == null ? void 0 : Ne.desc) || Ne.error_description, extraInfo: X }));
            if (Ne.error_code === 60011) return void Oe({ type: c.E.CHATROOM_NOT_JOINED, message: Ne == null ? void 0 : Ne.desc, extraInfo: X });
            if (Ne.error_code === 14403) return void Oe({ type: c.E.WEBIM_UPLOADFILE_ERROR, message: Ne == null ? void 0 : Ne.error_description, data: Ne, extraInfo: X });
            if (Ne.error_code === 60006 || Ne.error_code === 60007 || Ne.error_code === 60009 || Ne.error_code === 60012) return void Oe({ type: c.E.MAX_LIMIT, message: (Ne == null ? void 0 : Ne.desc) || (Ne == null ? void 0 : Ne.error_description), extraInfo: X });
            if (Ne.error_code === 91104) return void Oe({ type: c.E.NO_PERMISSION, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
            if (!((be = Ne.error_description) === null || be === void 0) && be.includes("are not members of this group")) return !(($e = K.responseURL) === null || $e === void 0) && $e.includes("chatgroups") ? Oe({ type: c.E.GROUP_NOT_JOINED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : Oe({ type: c.E.CHATROOM_NOT_JOINED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }), void Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: Ne == null ? void 0 : Ne.error_description, data: K.responseText, extraInfo: X });
            if ((Ne == null ? void 0 : Ne.result) === "the app not open presence") return void Oe({ type: c.E.SERVICE_NOT_ENABLED, message: Ne == null ? void 0 : Ne.result, extraInfo: X });
            if (Ne != null && Ne.error_description.includes("remark length must less")) return void Oe({ type: c.E.MAX_LIMIT, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
            switch (Ne == null ? void 0 : Ne.error_description) {
              case "the user is already operation this message":
                Oe({ type: c.E.REACTION_ALREADY_ADDED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "The quantity has exceeded the limit!":
                Oe({ type: c.E.MAX_LIMIT, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "The user not in this group!":
                Oe({ type: c.E.GROUP_NOT_JOINED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "the user operation is illegal!":
                Oe({ type: c.E.REACTION_OPERATION_IS_ILLEGAL, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "this appKey is not open reaction service!":
              case "this appKey not open message roaming":
                Oe({ type: c.E.SERVICE_NOT_ENABLED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "this message is creating reaction, please try again.":
                Oe({ type: c.E.REACTION_CREATING, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "groupId can not be null!":
                Oe({ type: c.E.GROUP_NOT_EXIST, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "The input text is too long.":
                Oe({ type: c.E.TRANSLATION_TEXT_TOO_LONG, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "The target language is not valid.":
                Oe({ type: c.E.TRANSLATION_NOT_VALID, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "report failed, get message by id failed":
                Oe({ type: c.E.MESSAGE_NOT_FOUND, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "ext is too big ":
                Oe({ type: c.E.PRESENCE_PARAM_EXCEED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "Request body not readable.Please check content type is correct!":
              case "param mark must be not empty, please check!":
              case "param mark illegal, please check it!":
              case "param pin_msg_id illegal, please check it!":
                Oe({ type: c.E.REQUEST_PARAMETER_ERROR, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              case "updateRemark | they are not friends, please add as a friend first.":
                Oe({ type: c.E.USER_NOT_FRIEND, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
                break;
              default:
                Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: Ne == null ? void 0 : Ne.error_description, data: K.responseText, extraInfo: X }), Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: Ne == null ? void 0 : Ne.error_description, data: K.responseText, extraInfo: X });
            }
          } else if (le === 401) Ne.error_code === 40001 || Ne.error_code === 60001 || Ne.error_description === "Unable to authenticate (OAuth)" ? Oe({ type: c.E.NO_PERMISSION, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : (Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: K.responseText, extraInfo: X }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: K.responseText, extraInfo: X }));
          else if (le === 403) Ne.error_code === 4e4 || Ne.error_code === 60004 || Ne.error_code === 15002 ? Oe({ type: c.E.SERVICE_NOT_ENABLED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 40003 || Ne.error_code === 40004 ? Oe({ type: c.E.THREAD_ALREADY_EXIST, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 40005 || Ne.error_code === 40007 || Ne.error_code === 91002 ? Oe({ type: c.E.MAX_LIMIT, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 60002 ? Oe({ type: c.E.PERMISSION_DENIED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 91101 ? Oe({ type: c.E.MAX_LIMIT, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 91102 && Oe({ type: c.E.REQUEST_PARAMETER_ERROR, message: Ne.error_description, extraInfo: X }), Ne.error_description === "group member list is full!" ? !((Be = K.responseURL) === null || Be === void 0) && Be.includes("chatgroups") ? Oe({ type: c.E.GROUP_MEMBERS_FULL, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : Oe({ type: c.E.CHATROOM_MEMBERS_FULL, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : !((Ke = Ne.error_description) === null || Ke === void 0) && Ke.includes(Ne.error_description.includes("already in group")) ? !((Ze = K.responseURL) === null || Ze === void 0) && Ze.includes("chatgroups") && Oe({ type: c.E.GROUP_ALREADY_JOINED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : !((at = Ne.error_description) === null || at === void 0) && at.includes("are not members of this group") ? !((pt = K.responseURL) === null || pt === void 0) && pt.includes("chatgroups") ? Oe({ type: c.E.GROUP_NOT_JOINED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : Oe({ type: c.E.CHATROOM_NOT_JOINED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : !((It = Ne.error_description) === null || It === void 0) && It.includes("service not open!") || !((Rt = Ne.error_description) === null || Rt === void 0) && Rt.includes("message report not open") || !((gt = Ne.error_description) === null || gt === void 0) && gt.includes("messageroaming function not open") ? Oe({ type: c.E.SERVICE_NOT_ENABLED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : !((it = Ne.error_description) === null || it === void 0) && it.includes("members size is greater than max user size !") ? Oe({ type: c.E.GROUP_MEMBERS_LIMIT, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : !((Tt = Ne.error_description) === null || Tt === void 0) && Tt.includes("can not operate this group, reason: group is disabled") ? Oe({ type: c.E.GROUP_IS_DISABLED, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : !((Ut = Ne.error_description) === null || Ut === void 0) && Ut.includes("Invitee's contact max count") || !((st = Ne.error_description) === null || st === void 0) && st.includes("Inviter's contact max count") ? Oe({ type: c.E.MAX_LIMIT, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : Oe({ type: c.E.PERMISSION_DENIED, data: K.response || K.responseText, message: "permission denied", extraInfo: d(d({}, X), { errDesc: "permission denied" }) }), Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: K.responseText, extraInfo: X });
          else if (le === 404) Ne.error_code === 40011 ? Oe({ type: c.E.THREAD_NOT_EXIST, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 40012 ? Oe({ type: c.E.NO_PERMISSION, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 60003 || Ne.error_code === 20004 ? Oe({ type: c.E.GROUP_NOT_JOINED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }) : Ne.error_code === 91001 && Oe({ type: c.E.CONVERSATION_NOT_EXIST, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X }), !((Ot = Ne.error_description) === null || Ot === void 0) && Ot.includes("do not find this group") || !((kt = Ne.error_description) === null || kt === void 0) && kt.includes("does not exist") ? !((wt = K.responseURL) === null || wt === void 0) && wt.includes("chatgroups") ? Oe({ type: c.E.GROUP_NOT_EXIST, data: K.response || K.responseText, message: "The chat room dose not exist.", extraInfo: d(d({}, X), { errDesc: "The chat room dose not exist." }) }) : Oe({ type: c.E.CHATROOM_NOT_EXIST, data: K.response || K.responseText, message: "The chat room dose not exist.", extraInfo: d(d({}, X), { errDesc: "The chat room dose not exist." }) }) : !((Et = Ne.error_description) === null || Et === void 0) && Et.includes("username") && (!((ut = Ne.error_description) === null || ut === void 0) && ut.includes("doesn't exist!'")) || !((St = Ne.error_description) === null || St === void 0) && St.includes("user not found") || !((Ft = Ne.error_description) === null || Ft === void 0) && Ft.includes("Service resource not found") && (Ne == null ? void 0 : Ne.exception) === "UserNotFoundException" ? Oe({ type: c.E.USER_NOT_FOUND, data: K.response || K.responseText, message: Ne.error_description, extraInfo: X }) : Ne.error_description.includes("user session pin message not exist") ? Oe({ type: c.E.MESSAGE_NOT_FOUND, message: Ne.error_description, extraInfo: X }) : Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.response || K.responseText, message: K.responseText, extraInfo: X }), Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.response || K.responseText, message: K.responseText, extraInfo: X });
          else if (le === 406) Ne.error_code === 90004 && Oe({ type: c.E.OPERATION_NOT_ALLOWED, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
          else if (le === 429 || le === 503) {
            if (!((Ht = Ne.error_description) === null || Ht === void 0) && Ht.includes("The request has reached the maximum limit")) return void Oe({ type: c.E.MAX_LIMIT, message: K.responseText, extraInfo: X });
            if (!((zt = Ne.error_description) === null || zt === void 0) && zt.includes("upload client logs reached limit")) return void Oe({ type: c.E.MAX_LIMIT, message: K.responseText });
            Oe({ type: c.E.SERVER_BUSY, data: K.response || K.responseText, message: "Server is busy.", extraInfo: d(d({}, X), { errDesc: "Server is busy." }) }), Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: "Server is busy.", extraInfo: d(d({}, X), { errDesc: "Server is busy." }) });
          } else if (le === 500) {
            if (Ne.error_code === 40006 || Ne.error_code === 40008 || Ne.error_code === 40010) return void Oe({ type: c.E.SERVER_UNKNOWN_ERROR, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
            if (Ne.error_code === 90005 || Ne.error_code === 99999) return void Oe({ type: c.E.REQUEST_UNKNOWN, message: Ne == null ? void 0 : Ne.error_description, extraInfo: X });
            if (!((ze = Ne.error_description) === null || ze === void 0) && ze.includes("translte failed!")) return void Oe({ type: c.E.TRANSLATION_FAILED, message: K.responseText, extraInfo: X });
            Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: "", extraInfo: X }), Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: "", extraInfo: X });
          } else Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: K.responseText, extraInfo: d(d({}, X), { errDesc: "ajax error" }) }), Pe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: K.responseText, message: K.responseText, extraInfo: d(d({}, X), { errDesc: "ajax error" }) });
        }, m = s(1595), E = s(2071), y = s(7360), g = 5242880, C = 5242880, O = { size: 0 }, N = (s(2526), s(1817), s(2165), s(5827), s(4553), s(561), s(4319)), w = function() {
          return w = Object.assign || function(K) {
            for (var Oe, Pe = 1, xe = arguments.length; Pe < xe; Pe++) for (var be in Oe = arguments[Pe]) Object.prototype.hasOwnProperty.call(Oe, be) && (K[be] = Oe[be]);
            return K;
          }, w.apply(this, arguments);
        };
        function _() {
          var K = this.context, Oe = K.orgName, Pe = K.appName, xe = K.accessToken, be = { url: "".concat(this.apiUrl, "/").concat(Oe, "/").concat(Pe, "/sdk/chatfiles/part-upload"), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + xe } };
          return y.kg.debug("Call multipartInit"), U.call(this, be, m.fI.SDK_INTERNAL).then(function($e) {
            var Be = $e.entities[0];
            return { data: { fileMaxSize: Be.file_upper_limit, partMinSize: Be.part_lower_limit, uuid: Be.uuid }, extraInfo: $e.extraInfo, type: $e.type };
          });
        }
        function I(K) {
          var Oe = this;
          return new Promise(function(Pe, xe) {
            var be, $e, Be = (/* @__PURE__ */ new Date()).getTime(), Ke = Oe.context, Ze = Ke.orgName, at = Ke.appName, pt = Ke.accessToken, It = K.uuid, Rt = K.partNumber, gt = K.part, it = K.onProgress, Tt = "".concat(Oe.apiUrl, "/").concat(Ze, "/").concat(at, "/sdk/chatfiles/part-upload/").concat(It), Ut = new XMLHttpRequest();
            y.kg.debug("Call multipartUpload"), Ut.upload && (($e = (be = Ut.upload).addEventListener) === null || $e === void 0 || $e.call(be, "progress", function(Ot) {
              it == null || it(Ot);
            }, !1)), Ut.addEventListener("abort", function() {
              xe({ type: c.E.REQUEST_ABORT, message: "Request Abort", errorType: "onabort", xhr: Ut, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, errDesc: "Request Abort", url: Tt } });
            }, !1), Ut.addEventListener("error", function() {
              xe({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: Ut, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, errDesc: "request error", url: Tt } });
            }, !1), Ut.addEventListener("load", function() {
              try {
                var Ot = JSON.parse(Ut.responseText);
                if (Ut.status !== 200) return xe({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: Ot, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, errDesc: "part upload failed", url: Tt } }), !1;
                try {
                  Pe(w(w({}, Ot), { extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, url: Tt } }));
                } catch (kt) {
                  xe({ type: c.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, data: kt, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, errDesc: "part upload failed", url: Tt } });
                }
              } catch {
                xe({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: Ut.responseText, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, errDesc: "part upload failed", url: Tt } });
              }
            }, !1), Ut.addEventListener("timeout", function() {
              xe({ type: c.E.REQUEST_TIMEOUT, message: "request timeout", extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - Be, httpCode: Ut.status || -1, errDesc: "request timeout", url: Tt } });
            }, !1);
            var st = new FormData();
            st.append("part_file", gt), st.append("part_number", Rt), Ut.timeout = N.zj, Ut.open("PUT", Tt), Ut.setRequestHeader("restrict-access", "true"), Ut.setRequestHeader("Accept", "*/*"), Ut.setRequestHeader("Authorization", "Bearer " + pt), Ut.send(st);
          });
        }
        function k(K) {
          var Oe = K.uuid, Pe = K.thumbnailHeight, xe = K.thumbnailWidth, be = this.context, $e = be.orgName, Be = be.appName, Ke = be.accessToken, Ze = "".concat(this.apiUrl, "/").concat($e, "/").concat(Be, "/sdk/chatfiles/part-upload/").concat(Oe, "?restrict-access=true");
          xe && (Ze += "&thumbnail-width=".concat(xe)), Pe && (Ze += "&thumbnail-height=".concat(Pe));
          var at = { url: Ze, dataType: "json", type: "POST", headers: { Authorization: "Bearer " + Ke } };
          return y.kg.debug("Call multipartComplete"), U.call(this, at, m.fI.SDK_INTERNAL);
        }
        function H(K) {
          var Oe = K.uuid, Pe = this.context, xe = Pe.orgName, be = Pe.appName, $e = Pe.accessToken, Be = { url: "".concat(this.apiUrl, "/").concat(xe, "/").concat(be, "/sdk/chatfiles/part-upload/").concat(Oe), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + $e } };
          return y.kg.debug("Call multipartAbort"), U.call(this, Be, m.fI.SDK_INTERNAL);
        }
        var S = function(K, Oe, Pe, xe) {
          return new (Pe || (Pe = Promise))(function(be, $e) {
            function Be(at) {
              try {
                Ze(xe.next(at));
              } catch (pt) {
                $e(pt);
              }
            }
            function Ke(at) {
              try {
                Ze(xe.throw(at));
              } catch (pt) {
                $e(pt);
              }
            }
            function Ze(at) {
              var pt;
              at.done ? be(at.value) : (pt = at.value, pt instanceof Pe ? pt : new Pe(function(It) {
                It(pt);
              })).then(Be, Ke);
            }
            Ze((xe = xe.apply(K, [])).next());
          });
        }, B = function(K, Oe) {
          var Pe, xe, be, $e, Be = { label: 0, sent: function() {
            if (1 & be[0]) throw be[1];
            return be[1];
          }, trys: [], ops: [] };
          return $e = { next: Ke(0), throw: Ke(1), return: Ke(2) }, typeof Symbol == "function" && ($e[Symbol.iterator] = function() {
            return this;
          }), $e;
          function Ke(Ze) {
            return function(at) {
              return function(pt) {
                if (Pe) throw new TypeError("Generator is already executing.");
                for (; Be; ) try {
                  if (Pe = 1, xe && (be = 2 & pt[0] ? xe.return : pt[0] ? xe.throw || ((be = xe.return) && be.call(xe), 0) : xe.next) && !(be = be.call(xe, pt[1])).done) return be;
                  switch (xe = 0, be && (pt = [2 & pt[0], be.value]), pt[0]) {
                    case 0:
                    case 1:
                      be = pt;
                      break;
                    case 4:
                      return Be.label++, { value: pt[1], done: !1 };
                    case 5:
                      Be.label++, xe = pt[1], pt = [0];
                      continue;
                    case 7:
                      pt = Be.ops.pop(), Be.trys.pop();
                      continue;
                    default:
                      if (!((be = (be = Be.trys).length > 0 && be[be.length - 1]) || pt[0] !== 6 && pt[0] !== 2)) {
                        Be = 0;
                        continue;
                      }
                      if (pt[0] === 3 && (!be || pt[1] > be[0] && pt[1] < be[3])) {
                        Be.label = pt[1];
                        break;
                      }
                      if (pt[0] === 6 && Be.label < be[1]) {
                        Be.label = be[1], be = pt;
                        break;
                      }
                      if (be && Be.label < be[2]) {
                        Be.label = be[2], Be.ops.push(pt);
                        break;
                      }
                      be[2] && Be.ops.pop(), Be.trys.pop();
                      continue;
                  }
                  pt = Oe.call(K, Be);
                } catch (It) {
                  pt = [6, It], xe = 0;
                } finally {
                  Pe = be = 0;
                }
                if (5 & pt[0]) throw pt[1];
                return { value: pt[0] ? pt[1] : void 0, done: !0 };
              }([Ze, at]);
            };
          }
        }, D = function() {
          function K(Oe, Pe) {
            var xe = this;
            this.handleUploadProgress = function(be, $e) {
              var Be, Ke;
              if (be.total) {
                xe.progressArr[$e] = be.loaded;
                var Ze = xe.progressArr.reduce(function(at, pt) {
                  return at + pt;
                }, 0);
                (Ke = (Be = xe.options).onFileUploadProgress) === null || Ke === void 0 || Ke.call(Be, { isTrusted: be.isTrusted, type: be.type, loaded: Ze > xe.file.size ? xe.file.size : Ze, total: xe.file.size, lengthComputable: be.lengthComputable });
              }
            }, this.uuid = "", this.pool = [], this.progressArr = [], this.connection = Oe, this.options = Pe, this.partSize = g, this.file = Pe.file, this.init(), this.rpt = this.connection.dataReport.geOperateFun({ operationName: m.fI.REST_UPLOAD_FILE_IN_PARTS });
          }
          return K.prototype.init = function() {
            var Oe, Pe, xe, be;
            return S(this, void 0, void 0, function() {
              var $e, Be, Ke, Ze, at, pt, It, Rt, gt, it, Tt, Ut, st, Ot, kt;
              return B(this, function(wt) {
                switch (wt.label) {
                  case 0:
                    return wt.trys.push([0, 4, , 6]), [4, _.call(this.connection)];
                  case 1:
                    return $e = wt.sent(), Be = $e.data || {}, Ke = Be.fileMaxSize, Ze = Ke === void 0 ? 0 : Ke, at = Be.partMinSize, pt = at === void 0 ? g : at, It = Be.uuid, Rt = It === void 0 ? "" : It, gt = $e.extraInfo, Ut = gt.elapse, st = gt.httpCode, kt = gt.url, this.partSize = pt, this.uuid = Rt, O.size = pt, y.kg.debug("multipartInit success", "uuid: ".concat(Rt), "fileMaxSize: ".concat(Ze), "partMinSize: ".concat(pt)), this.file.size > Ze ? [4, this.multipartAbort()] : [3, 3];
                  case 2:
                    return wt.sent(), (Pe = (Oe = this.options).onFileUploadError) === null || Pe === void 0 || Pe.call(Oe, { code: c.E.WEBIM_UPLOADFILE_ERROR, message: "The file size exceeds the maximum limit" }), [2];
                  case 3:
                    return this.rpt({ data: { requestUrl: kt, requestName: m.c.REST_INIT_UPLOAD_TASK_IN_PARTS, requestElapse: Ut, requestMethod: "POST", isSuccess: 1, code: st } }), this.upload(), [3, 6];
                  case 4:
                    return it = wt.sent(), Tt = (it == null ? void 0 : it.extraInfo) || {}, Ut = Tt.elapse, st = Tt.httpCode, Ot = Tt.errDesc, kt = Tt.url, this.rpt({ data: { requestUrl: kt, requestName: m.c.REST_INIT_UPLOAD_TASK_IN_PARTS, requestElapse: Ut, requestMethod: "POST", isSuccess: 0, codeDesc: Ot, code: st } }), [4, this.multipartAbort()];
                  case 5:
                    return wt.sent(), (be = (xe = this.options) === null || xe === void 0 ? void 0 : xe.onInitFail) === null || be === void 0 || be.call(xe), [3, 6];
                  case 6:
                    return [2];
                }
              });
            });
          }, K.prototype.upload = function() {
            var Oe, Pe, xe;
            return S(this, void 0, void 0, function() {
              var be, $e, Be, Ke, Ze, at, pt = this;
              return B(this, function(It) {
                switch (It.label) {
                  case 0:
                    new FileReader().readAsArrayBuffer(this.file), be = this.file.size, $e = Math.ceil(be / this.partSize), It.label = 1;
                  case 1:
                    It.trys.push([1, 7, , 9]), Be = function(Rt) {
                      var gt, it, Tt, Ut;
                      return B(this, function(st) {
                        switch (st.label) {
                          case 0:
                            return gt = Rt * Ke.partSize, it = Math.min(be, gt + Ke.partSize), Tt = (Oe = Ke.file) === null || Oe === void 0 ? void 0 : Oe.slice(gt, it), (Ut = I.call(Ke.connection, { uuid: Ke.uuid, partNumber: "".concat(Rt + 1), part: Tt, onProgress: function(Ot) {
                              pt.handleUploadProgress(Ot, Rt);
                            } })).then(function(Ot) {
                              var kt = (Ot == null ? void 0 : Ot.extraInfo) || {}, wt = kt.elapse, Et = kt.httpCode, ut = kt.url;
                              pt.rpt({ data: { requestUrl: ut, requestName: m.c.REST_UPLOAD_PART, requestElapse: wt, isSuccess: 1, requestMethod: "PUT", code: Et } }), pt.handleTask(Ut);
                            }), Ut.catch(function(Ot) {
                              var kt = (Ot == null ? void 0 : Ot.extraInfo) || {}, wt = kt.elapse, Et = kt.httpCode, ut = kt.url, St = kt.errDesc;
                              pt.rpt({ data: { requestUrl: ut, requestName: m.c.REST_UPLOAD_PART, requestElapse: wt, isSuccess: 0, requestMethod: "PUT", code: Et, codeDesc: St } }), delete Ot.extraInfo;
                            }), Ke.pool.push(Ut), Ke.pool.length !== 4 ? [3, 2] : [4, Promise.race(Ke.pool)];
                          case 1:
                            st.sent(), st.label = 2;
                          case 2:
                            return [2];
                        }
                      });
                    }, Ke = this, Ze = 0, It.label = 2;
                  case 2:
                    return Ze < $e ? [5, Be(Ze)] : [3, 5];
                  case 3:
                    It.sent(), It.label = 4;
                  case 4:
                    return Ze++, [3, 2];
                  case 5:
                    return [4, Promise.all(this.pool)];
                  case 6:
                    return It.sent(), this.multipartComplete(), [3, 9];
                  case 7:
                    return at = It.sent(), [4, this.multipartAbort()];
                  case 8:
                    return It.sent(), this.rpt({ data: { isLastApi: 1, isSuccess: 0 } }), (xe = (Pe = this.options).onFileUploadError) === null || xe === void 0 || xe.call(Pe, at), [3, 9];
                  case 9:
                    return [2];
                }
              });
            });
          }, K.prototype.multipartComplete = function() {
            var Oe, Pe, xe, be;
            return S(this, void 0, void 0, function() {
              var $e, Be, Ke, Ze, at, pt, It, Rt, gt, it, Tt;
              return B(this, function(Ut) {
                switch (Ut.label) {
                  case 0:
                    return Ut.trys.push([0, 2, , 3]), $e = this.options.thumbnailInfo || {}, Be = $e.width, Ke = $e.height, [4, k.call(this.connection, { uuid: this.uuid, thumbnailHeight: Ke, thumbnailWidth: Be })];
                  case 1:
                    return Ze = Ut.sent(), at = (Ze == null ? void 0 : Ze.extraInfo) || {}, Rt = at.elapse, gt = at.httpCode, Tt = at.url, this.rpt({ data: { requestUrl: Tt, requestName: m.c.REST_COMPLETE_UPLOAD_PART, requestElapse: Rt, requestMethod: "POST", isSuccess: 1, code: gt } }), this.rpt({ data: { isLastApi: 1, isSuccess: 1 } }), (Pe = (Oe = this.options).onFileUploadComplete) === null || Pe === void 0 || Pe.call(Oe, Ze), [3, 3];
                  case 2:
                    return pt = Ut.sent(), It = (pt == null ? void 0 : pt.extraInfo) || {}, Rt = It.elapse, gt = It.httpCode, it = It.errDesc, Tt = It.url, this.rpt({ data: { requestUrl: Tt, requestName: m.c.REST_COMPLETE_UPLOAD_PART, requestElapse: Rt, requestMethod: "POST", isSuccess: 0, codeDesc: it, code: gt } }), this.rpt({ data: { isLastApi: 1, isSuccess: 0 } }), (be = (xe = this.options).onFileUploadError) === null || be === void 0 || be.call(xe, pt), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, K.prototype.multipartAbort = function() {
            return S(this, void 0, void 0, function() {
              var Oe, Pe, xe, be, $e, Be, Ke, Ze;
              return B(this, function(at) {
                switch (at.label) {
                  case 0:
                    if (!this.uuid) return [2];
                    at.label = 1;
                  case 1:
                    return at.trys.push([1, 3, , 4]), [4, H.call(this.connection, { uuid: this.uuid })];
                  case 2:
                    return Oe = at.sent(), Pe = (Oe == null ? void 0 : Oe.extraInfo) || {}, $e = Pe.elapse, Be = Pe.httpCode, Ze = Pe.url, this.rpt({ data: { requestUrl: Ze, requestName: m.c.REST_ABORT_UPLOAD_PART, requestElapse: $e, requestMethod: "DELETE", isSuccess: 1, code: Be } }), [3, 4];
                  case 3:
                    return xe = at.sent(), be = (xe == null ? void 0 : xe.extraInfo) || {}, $e = be.elapse, Be = be.httpCode, Ke = be.errDesc, Ze = be.url, this.rpt({ data: { requestUrl: Ze, requestName: m.c.REST_ABORT_UPLOAD_PART, requestElapse: $e, requestMethod: "DELETE", isSuccess: 0, codeDesc: Ke, code: Be } }), [3, 4];
                  case 4:
                    return [2];
                }
              });
            });
          }, K.prototype.handleTask = function(Oe) {
            var Pe = this.pool.findIndex(function(xe) {
              return xe === Oe;
            });
            this.pool.splice(Pe, 1);
          }, K;
        }(), F = function(K) {
          var Oe, Pe, xe = this, be = (/* @__PURE__ */ new Date()).getTime(), $e = K.apiUrl, Be = K.orgName, Ke = K.appName, Ze = K.operateName, at = K.accessToken, pt = K.uploadUrl || "".concat($e, "/").concat(Be, "/").concat(Ke, "/chatfiles"), It = function(Tt) {
            var Ut = (/* @__PURE__ */ new Date()).getTime() - be;
            xe.dataReport && Ze && [m.fI.UPLOAD_MSG_ATTACH, m.fI.UPLOAD_CHATROOM_FILE, m.fI.UPLOAD_GROUP_FILE].includes(Ze) && xe.dataReport.geOperateFun({ operationName: Ze })({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "POST", requestName: Ze, requestElapse: Ut, requestUrl: pt, code: (gt == null ? void 0 : gt.status) || 0, codeDesc: "upload file error" } }), K.onFileUploadError && K.onFileUploadError(Tt);
          };
          function Rt(Tt) {
            It({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: gt });
          }
          var gt = new XMLHttpRequest();
          gt.upload && ((Pe = (Oe = gt.upload).addEventListener) === null || Pe === void 0 || Pe.call(Oe, "progress", K.onFileUploadProgress || G, !1)), gt.addEventListener("abort", K.onFileUploadCanceled || G, !1), gt.addEventListener("error", Rt, !1), gt.addEventListener("load", function(Tt) {
            try {
              var Ut = JSON.parse(gt.responseText);
              if (gt.status === 400) return It({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: Ut }), !1;
              try {
                (function(st) {
                  var Ot = (/* @__PURE__ */ new Date()).getTime() - be;
                  xe.dataReport && Ze && [m.fI.UPLOAD_MSG_ATTACH, m.fI.UPLOAD_CHATROOM_FILE, m.fI.UPLOAD_GROUP_FILE].includes(Ze) && xe.dataReport.geOperateFun({ operationName: Ze })({ isEndApi: !0, data: { isSuccess: st != null && st.error ? 0 : 1, requestMethod: "POST", requestName: Ze, requestElapse: Ot, requestUrl: pt, code: gt.status, codeDesc: (st == null ? void 0 : st.error_description) || "" } }), K.onFileUploadComplete && K.onFileUploadComplete(st);
                })(Ut);
              } catch (st) {
                It({ type: c.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, data: st });
              }
            } catch {
              It({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: gt.responseText });
            }
          }, !1), gt.addEventListener("timeout", Rt, !1), gt.timeout = N.zj, gt.open("POST", pt), gt.setRequestHeader("restrict-access", "true"), gt.setRequestHeader("Accept", "*/*"), gt.setRequestHeader("Authorization", "Bearer " + at);
          var it = new FormData();
          it.append("file", K.file.data), K.thumbnailWidth && it.append("thumbnail-width", K.thumbnailWidth + ""), K.thumbnailHeight && it.append("thumbnail-height", K.thumbnailHeight + ""), gt.send(it);
        }, j = function() {
          return j = Object.assign || function(K) {
            for (var Oe, Pe = 1, xe = arguments.length; Pe < xe; Pe++) for (var be in Oe = arguments[Pe]) Object.prototype.hasOwnProperty.call(Oe, be) && (K[be] = Oe[be]);
            return K;
          }, j.apply(this, arguments);
        }, G = function() {
        };
        function U(K, Oe) {
          var Pe, xe = this;
          return de().platform === ue.WEB ? new Promise(function(be, $e) {
            var Be = K.dataType || "text", Ke = K.success || G, Ze = K.error || G, at = new XMLHttpRequest();
            at.timeout = N.Gf;
            var pt = !1;
            at.ontimeout = function() {
              y.kg.warn("request timeout"), pt = !0;
              var st = { type: c.E.REQUEST_TIMEOUT, message: "Request Timeout", errorType: "timeout_error", xhr: at };
              Ze(st), $e(st);
            }, at.onerror = function() {
              $e({ type: c.E.REQUEST_UNKNOWN, message: "Request Unknow Error", errorType: "onerror", xhr: at });
            }, at.onabort = function() {
              $e({ type: c.E.REQUEST_ABORT, message: "Request Abort", errorType: "onabort", xhr: at });
            }, at.onreadystatechange = function() {
              if (at.readyState === 4) {
                var st = (/* @__PURE__ */ new Date()).getTime() - Pe, Ot = at.status || 0, kt = { elapse: st, httpCode: Ot };
                if (Ot === 200) {
                  Te.ajaxUnconventionalErrorTimes = 0;
                  try {
                    switch (Be) {
                      case "text":
                        return Ke(at.responseText), void be(at.responseText);
                      case "json":
                        var wt = JSON.parse(at.responseText);
                        return wt.extraInfo = kt, Ke(wt), void be(wt);
                      case "xml":
                        return at.responseXML && at.responseXML.documentElement ? (Ke(at.responseXML.documentElement), void be(at.responseXML.documentElement)) : (Ze({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: at.responseText, message: "XHR.responseXML is null or XHR.responseXML.documentElement is null" }), void $e({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: at.responseText, message: "XHR.responseXML is null or XHR.responseXML.documentElement is null" }));
                      default:
                        Ze({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: at.responseText, message: "Invalid dataType" }), $e({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: at.responseText, message: "Invalid dataType" });
                    }
                    return be(at.response || at.responseText), void Ke(at.response || at.responseText, at);
                  } catch (Et) {
                    $e(Et);
                  }
                  return;
                }
                Ot === 0 ? setTimeout(function() {
                  y.kg.debug("request timeout:", pt), !pt && p(at, $e, Ze, st);
                }, 0) : ([400, 401, 403, 404, 429, 500, 503].includes(Ot) || (y.kg.debug("rest api request fail status:", Ot), Te.ajaxUnconventionalErrorTimes++), p(at, $e, Ze, st));
              }
              at.readyState === 0 && (Ze({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: at.responseText, message: "Request not initialized" }), $e({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: at.responseText, message: "Request not initialized" }));
            }, K.responseType && at.responseType && (at.responseType = K.responseType), K.mimeType && at.overrideMimeType(K.mimeType);
            var It = K.type || "POST", Rt = K.data || null, gt = "";
            if (It.toLowerCase() === "get" && Rt) {
              for (var it in Rt) Rt.hasOwnProperty(it) && (gt += it + "=" + Rt[it] + "&");
              gt = gt && gt.slice(0, -1), K.url += (K.url.indexOf("?") > 0 ? "&" : "?") + (gt && gt + "&") + "_v=" + (/* @__PURE__ */ new Date()).getTime(), Rt = null, gt = "";
            }
            Pe = (/* @__PURE__ */ new Date()).getTime(), at.open(It, K.url);
            var Tt = K.headers || {};
            for (var Ut in Tt["Content-Type"] || (Tt["Content-Type"] = "application/json"), Tt) Tt.hasOwnProperty(Ut) && at.setRequestHeader(Ut, Tt[Ut]);
            at.send(Rt);
          }).then(function(be) {
            return xe.dataReport && Oe && Oe !== m.fI.SDK_INTERNAL && xe.dataReport.geOperateFun({ operationName: Oe })({ isEndApi: !0, data: j({ isSuccess: 1, requestUrl: K.url, requestName: Oe, requestMethod: K.type }, _e(be.extraInfo)) }), Oe === m.fI.SDK_INTERNAL && (be.extraInfo.url = K.url), Oe !== m.fI.SDK_INTERNAL && delete be.extraInfo, M(be) === "Object" ? j(j({}, be), { type: c.E.REQUEST_SUCCESS }) : { data: be, type: c.E.REQUEST_SUCCESS };
          }).catch(function(be) {
            var $e, Be;
            if (xe.dataReport && Oe && Oe !== m.fI.SDK_INTERNAL && xe.dataReport.geOperateFun({ operationName: Oe })({ isEndApi: !0, data: j({ isSuccess: 0, requestUrl: K.url, requestName: Oe, requestMethod: K.type }, _e(be.extraInfo)) }), Oe === m.fI.SDK_INTERNAL) if (be.extraInfo) be.extraInfo.url = K.url;
            else {
              var Ke = { elapse: (/* @__PURE__ */ new Date()).getTime() - Pe, httpCode: (Be = ($e = be.xhr) === null || $e === void 0 ? void 0 : $e.status) !== null && Be !== void 0 ? Be : 0, url: K.url };
              be.extraInfo = Ke;
            }
            throw Oe !== m.fI.SDK_INTERNAL && delete be.extraInfo, be;
          }) : V.call(this, K, Oe);
        }
        function M(K) {
          return Object.prototype.toString.call(K).slice(8, -1);
        }
        function V(K, Oe) {
          var Pe = this;
          return new Promise(function(xe, be) {
            var $e = K.success || G, Be = K.error || G, Ke = K.type || "POST", Ze = K.data || null, at = "", pt = (/* @__PURE__ */ new Date()).getTime(), It = Te.getEnvInfo();
            if (Ke.toLowerCase() === "get" && Ze) {
              for (var Rt in Ze) Ze.hasOwnProperty(Rt) && (at += Rt + "=" + Ze[Rt] + "&");
              at = at && at.slice(0, -1), K.url += (K.url.indexOf("?") > 0 ? "&" : "?") + (at && at + "&") + "_v=" + (/* @__PURE__ */ new Date()).getTime(), Ze = null, at = "";
            }
            var gt = { url: K.url, data: K.data, method: Ke, headers: {}, timeout: N.Gf, success: function(it) {
              var Tt, Ut, st, Ot, kt, wt = { elapse: (/* @__PURE__ */ new Date()).getTime() - pt, httpCode: Number(((Tt = it.statusCode) === null || Tt === void 0 ? void 0 : Tt.toString()) || ((Ut = it.status) === null || Ut === void 0 ? void 0 : Ut.toString())), errDesc: ((st = it == null ? void 0 : it.data) === null || st === void 0 ? void 0 : st.error_description) || "" };
              if (((Ot = it.statusCode) === null || Ot === void 0 ? void 0 : Ot.toString()) === "200" || ((kt = it.status) === null || kt === void 0 ? void 0 : kt.toString()) === "200") {
                it.data.extraInfo = wt;
                var Et = it.data;
                $e(Et), xe(Et);
              } else it.extraInfo = wt, Be(Et = it), be(Et), y.kg.debug(Oe, "reject reason: ", Et);
            }, complete: function() {
            }, fail: function(it) {
              var Tt = { elapse: (/* @__PURE__ */ new Date()).getTime() - pt, httpCode: E.Tp, errDesc: "request:fail" };
              if (it.extraInfo = Tt, it.data = { error: "request:fail", error_description: "request:fail" }, it.errMsg === "request:fail timeout") return be({ type: c.E.REQUEST_TIMEOUT, message: "Request Timeout", extraInfo: Tt }), void Be({ type: c.E.REQUEST_TIMEOUT, message: "Request Timeout", extraInfo: Tt });
              Be(it), be(it), y.kg.error(Oe, "fail reason:", it);
            } };
            if (It.platform === "zfb" || It.platform === "dd" ? gt.headers = K.headers : gt.header = K.headers, It.platform === "dd") return dd.httpRequest(gt);
            It.global.request(gt);
          }).then(function(xe) {
            return Pe.dataReport && Oe && Oe !== m.fI.SDK_INTERNAL && Pe.dataReport.geOperateFun({ operationName: Oe })({ isEndApi: !0, data: j({ isSuccess: 1, requestUrl: K.url, requestName: Oe, requestMethod: K.type }, _e(xe.extraInfo)) }), Oe !== m.fI.SDK_INTERNAL && delete xe.extraInfo, M(xe) === "Object" ? j(j({}, xe), { type: c.E.REQUEST_SUCCESS }) : { data: xe, type: c.E.REQUEST_SUCCESS };
          }).catch(function(xe) {
            Pe.dataReport && Oe && Oe !== m.fI.SDK_INTERNAL && Pe.dataReport.geOperateFun({ operationName: Oe })({ isEndApi: !0, data: j({ isSuccess: 0, requestUrl: K.url, requestName: Oe, requestMethod: K.type }, _e(xe.extraInfo)) }), Oe !== m.fI.SDK_INTERNAL && delete xe.extraInfo;
            var be = JSON.stringify(xe.data || {}), $e = j(j({}, xe), { status: xe.statusCode || xe.status || 0, response: be, responseText: be });
            p($e, function(Be) {
              throw j(j({}, xe), { message: Be.message, type: Be.type });
            }, G, 0);
          });
        }
        function J(K, Oe) {
          var Pe;
          return function() {
            for (var xe = [], be = 0; be < arguments.length; be++) xe[be] = arguments[be];
            if (!K) return Pe;
            Pe = K.apply(void 0, xe), K = null;
          };
        }
        var ue, se = J(function(K, Oe) {
          var Pe = de();
          if (Pe.platform !== ue.WEB) {
            var xe = Pe.global, be = function($e) {
              $e.isConnected ? K() : Oe();
            };
            xe.offNetworkStatusChange && xe.offNetworkStatusChange(be), xe.onNetworkStatusChange && xe.onNetworkStatusChange(be);
          } else typeof addEventListener < "u" && (window.addEventListener("online", K), window.addEventListener("offline", Oe));
        }), ee = J(function(K, Oe) {
          var Pe, xe, be = de();
          if (be.platform === ue.WEB) document && document.addEventListener("visibilitychange", function() {
            document.hidden ? Oe == null || Oe() : K == null || K();
          }, !1);
          else {
            var $e = be.global;
            $e.onAppShow && ((Pe = $e.onAppShow) === null || Pe === void 0 || Pe.call($e, K)), $e.onAppHide && ((xe = $e.onAppHide) === null || xe === void 0 || xe.call($e, Oe));
          }
        });
        function de() {
          return typeof swan < "u" && he(swan) ? { platform: ue.BAIDU, global: swan } : typeof tt < "u" && he(tt) ? { platform: ue.TT, global: tt } : typeof dd < "u" && he(dd) ? { platform: ue.DD, global: dd } : typeof my < "u" && he(my) ? { platform: ue.ZFB, global: my } : typeof wx < "u" && he(wx) ? { platform: ue.WX, global: wx } : typeof qq < "u" && he(qq) ? { platform: ue.QQ, global: qq } : typeof uni < "u" && he(uni) ? { platform: ue.UNI, global: uni } : typeof window < "u" && window.WebSocket ? { platform: ue.WEB, global: window } : { platform: ue.NODE, global: s.g || {} };
        }
        function he(K) {
          for (var Oe = ["canIUse", "getSystemInfo"], Pe = 0, xe = Oe.length; Pe < xe; Pe++) if (!K[Oe[Pe]]) return !1;
          return !0;
        }
        function pe(K, Oe) {
          var Pe, xe, be, $e = this, Be = K.accessToken, Ke = K.appKey, Ze = (xe = (Pe = K == null ? void 0 : K.file) === null || Pe === void 0 ? void 0 : Pe.data) === null || xe === void 0 ? void 0 : xe.size, at = [], pt = "", It = "";
          if (Be) if (Ke && (at = Ke.split("#"), pt = at[0], It = at[1]), pt || It) if (Ze <= 0) K.onFileUploadError && K.onFileUploadError({ type: c.E.WEBIM_UPLOADFILE_ERROR, message: "fileSize must be greater than 0" });
          else if (K.uploadUrl) F.call(this, j(j({}, K), { orgName: pt, appName: It, operateName: Oe }));
          else {
            var Rt = O.size || C;
            this.uploadPartEnable && Ze > 1.5 * Rt ? new D(this, { file: (be = K == null ? void 0 : K.file) === null || be === void 0 ? void 0 : be.data, onFileUploadProgress: K.onFileUploadProgress || G, onFileUploadComplete: K.onFileUploadComplete || G, onFileUploadError: K.onFileUploadError || G, onFileUploadCanceled: K.onFileUploadCanceled || G, onInitFail: function() {
              F.call($e, j(j({}, K), { orgName: pt, appName: It, operateName: Oe }));
            }, thumbnailInfo: { width: K.thumbnailWidth, height: K.thumbnailHeight } }) : F.call(this, j(j({}, K), { orgName: pt, appName: It, operateName: Oe }));
          }
          else K.onFileUploadError && K.onFileUploadError({ type: c.E.WEBIM_UPLOADFILE_ERROR, message: this._initWithAppId ? "appId illegal" : "AppKey illegal" });
          else K.onFileUploadError && K.onFileUploadError({ type: c.E.WEBIM_UPLOADFILE_NO_LOGIN, message: "AccessToken cannot be empty" });
        }
        function Ce(K, Oe) {
          var Pe;
          K.onFileDownloadComplete = K.onFileDownloadComplete || G, K.onFileDownloadError = K.onFileDownloadError || G;
          var xe = (/* @__PURE__ */ new Date()).getTime(), be = new XMLHttpRequest(), $e = this;
          be.addEventListener("load", function(Rt) {
            var gt = (/* @__PURE__ */ new Date()).getTime() - xe;
            $e.dataReport && Oe && Oe === m.fI.DOWN_GROUP_FILE && $e.dataReport.geOperateFun({ operationName: Oe })({ isEndApi: !0, data: { isSuccess: be.status === 200 ? 1 : 0, requestMethod: "POST", requestName: Oe, requestElapse: gt, requestUrl: K == null ? void 0 : K.url, code: be.status, codeDesc: be.status === 200 ? "" : "download file error" } }), K.onFileDownloadComplete && K.onFileDownloadComplete(be.response);
          }, !1), be.addEventListener("error", function(Rt) {
            var gt = (/* @__PURE__ */ new Date()).getTime() - xe;
            $e.dataReport && Oe && Oe === m.fI.DOWN_GROUP_FILE && $e.dataReport.geOperateFun({ operationName: Oe })({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "POST", requestName: Oe, requestElapse: gt, requestUrl: K == null ? void 0 : K.url, code: (be == null ? void 0 : be.status) || 0, codeDesc: "download file error" } }), K.onFileDownloadError && K.onFileDownloadError({ type: c.E.WEBIM_DOWNLOADFILE_ERROR, id: K.id, xhr: be });
          }, !1);
          var Be = K.method || "GET", Ke = K.responseType || "blob", Ze = K.mimeType || "text/plain; charset=x-user-defined";
          be.open(Be, K.url), typeof Blob < "u" ? be.responseType = Ke : be.overrideMimeType(Ze);
          var at = { "X-Requested-With": "XMLHttpRequest", Accept: "application/octet-stream", "share-secret": K.secret, Authorization: "Bearer " + ((Pe = this == null ? void 0 : this.context) === null || Pe === void 0 ? void 0 : Pe.accessToken) }, pt = K.headers || {};
          for (var It in pt) at[It] = pt[It];
          for (var It in at) at[It] && be.setRequestHeader(It, at[It]);
          be.send(null);
        }
        function _e(K) {
          K === void 0 && (K = {});
          var Oe = K.elapse, Pe = Oe === void 0 ? 0 : Oe, xe = K.httpCode, be = xe === void 0 ? 0 : xe, $e = K.errDesc;
          return { requestElapse: Pe, code: be, codeDesc: $e === void 0 ? "" : $e };
        }
        (function(K) {
          K.WEB = "web", K.WX = "wx", K.QQ = "qq", K.ZFB = "zfb", K.DD = "dd", K.TT = "tt", K.BAIDU = "baidu", K.QUICK_APP = "quick_app", K.UNI = "uni", K.NODE = "node";
        })(ue || (ue = {}));
        var Le = "localDeviceInfo", Te = { autoIncrement: 0, ajaxUnconventionalErrorTimes: 0, isUseHttps: function(K) {
          var Oe;
          return typeof K == "boolean" ? K : !(typeof window < "u") || ((Oe = window.location) === null || Oe === void 0 ? void 0 : Oe.protocol) === "https:";
        }, getRetryDelay: function(K) {
          return K <= 5 ? Number((Math.random() + 1).toFixed(2)) : K > 5 && K < 20 ? Math.floor(4 * Math.random()) + 3 : Math.floor(6 * Math.random()) + 5;
        }, ajax: U, getUniqueId: function() {
          this.autoIncrement ? this.autoIncrement++ : this.autoIncrement = 1;
          var K = /* @__PURE__ */ new Date(), Oe = new Date(2010, 1, 1);
          return (K.getTime() - Oe.getTime() + this.autoIncrement).toString();
        }, getFileUrl: function(K) {
          var Oe = { url: "", filename: "", filetype: "", data: {} }, Pe = typeof K == "string" ? document.getElementById(K) : K;
          if (window.URL.createObjectURL) {
            if (!Pe.files) throw Error("this is not HTMLInputElement");
            var xe = Pe.files;
            if (xe.length > 0) {
              var be = xe.item(0);
              Oe.data = be, Oe.url = window.URL.createObjectURL(be), Oe.filename = (be == null ? void 0 : be.name) || "";
            }
          } else {
            if (typeof K != "string") throw Error("in IE fileInputId must be string");
            be = document.getElementById(K).value, Oe.url = be;
            var $e = be.lastIndexOf("/"), Be = be.lastIndexOf("\\"), Ke = Math.max($e, Be);
            Oe.filename = Ke < 0 ? be : be.substring(Ke + 1);
          }
          var Ze = Oe.filename.lastIndexOf(".");
          return Ze !== -1 && (Oe.filetype = Oe.filename.substring(Ze + 1).toLowerCase()), Oe;
        }, uploadFile: pe, flow: function(K) {
          for (var Oe = K.length, Pe = Oe; Pe--; ) if (typeof K[Pe] != "function") throw new TypeError("Expected a function");
          return function() {
            for (var xe = [], be = 0; be < arguments.length; be++) xe[be] = arguments[be];
            for (var $e = 0, Be = Oe ? K[$e].apply(this, xe) : xe[0]; ++$e < Oe; ) Be = K[$e].call(this, Be);
            return Be;
          };
        }, listenNetwork: se, listenBrowserVisibility: ee, getEnvInfo: de, wxRequest: V, parseDownloadResponse: function(K) {
          if (!window || !window.URL) throw Error("parseDownloadResponse can be used in broswer only");
          return K && K.type && K.type === "application/json" || 0 > Object.prototype.toString.call(K).indexOf("Blob") ? this.url + "?token=" : window.URL.createObjectURL(K);
        }, download: Ce, parseNotify: function(K) {
          for (var Oe = "", Pe = 0; Pe < K.length; Pe++) Oe += "%" + K[Pe].toString(16);
          return JSON.parse(decodeURIComponent(Oe));
        }, getExtraData: _e, retryPromise: function(K, Oe, Pe) {
          return new Promise(function(xe, be) {
            (function $e(Be) {
              K().then(xe).catch(function(Ke) {
                Be > 0 ? setTimeout(function() {
                  $e(Be - 1);
                }, Pe || 1e3) : be(Ke);
              });
            })(Oe || 3);
          });
        }, formatAttachUrl: function(K) {
          return K && typeof K == "string" ? "".concat(this.apiUrl).concat(K.substr(K.indexOf("/", 9))) : "";
        }, Uint8ArrayToString: function(K) {
          for (var Oe = "", Pe = 0; Pe < K.length; Pe++) Oe += String.fromCharCode(K[Pe]);
          return Oe;
        }, getLocalDeviceInfo: function() {
          return function(K) {
            var Oe, Pe = Te.getEnvInfo(), xe = Pe.platform, be = "";
            xe !== ue.NODE && xe !== ue.QUICK_APP || (be = "");
            try {
              xe === ue.WEB ? be = localStorage.getItem(K) || "" : xe === ue.WX || xe === ue.QQ || xe === ue.TT || xe === ue.BAIDU || xe === ue.UNI ? be = Pe.global.getStorageSync(K) || "" : xe !== ue.ZFB && xe !== ue.DD || (be = ((Oe = Pe.global.getStorageSync({ key: K })) === null || Oe === void 0 ? void 0 : Oe.data) || "");
            } catch ($e) {
              y.kg.debug("get local ".concat(K, " failed: "), $e);
            }
            return y.kg.debug("".concat(K, " "), be), be;
          }(Le);
        }, setLocalDeviceInfo: function(K) {
          (function(Oe, Pe) {
            var xe = Te.getEnvInfo(), be = xe.platform;
            if (be !== ue.NODE && be !== ue.QUICK_APP) if (be === ue.WEB) try {
              localStorage.setItem(Oe, Pe);
            } catch ($e) {
              y.kg.error("set local ".concat(Oe, " failed: "), $e);
            }
            else xe.global.setStorage({ key: Oe, data: Pe, success: function($e) {
              y.kg.debug("set local ".concat(Oe, " success: "), $e);
            }, fail: function($e) {
              y.kg.error("set local ".concat(Oe, " failed: "), $e);
            } });
          })(Le, K);
        }, detectBrowser: function() {
          if (typeof navigator > "u") return "unknown";
          var K = navigator.userAgent;
          return /MicroMessenger/i.test(K) ? "WeChat" : /QQBrowser/i.test(K) ? "QQ" : !/Chrome/i.test(K) || /Edg/i.test(K) || /OPR/i.test(K) ? !/Safari/i.test(K) || /Chrome/i.test(K) || /CriOS/i.test(K) ? /Firefox/i.test(K) ? "Firefox" : /MSIE/i.test(K) || /Trident/i.test(K) ? "IE" : /Edg/i.test(K) ? "Edge" : "unknown" : "Safari" : "Chrome";
        }, getDevicePlatform: function(K) {
          return K.platform === ue.WX && typeof uni < "u" && he(uni) ? ue.UNI : K.platform;
        }, delay: function(K) {
          return new Promise(function(Oe) {
            return setTimeout(Oe, K);
          });
        } };
      }, 9662: function(l, v, s) {
        var c = s(614), d = s(6330), p = TypeError;
        l.exports = function(m) {
          if (c(m)) return m;
          throw p(d(m) + " is not a function");
        };
      }, 9483: function(l, v, s) {
        var c = s(4411), d = s(6330), p = TypeError;
        l.exports = function(m) {
          if (c(m)) return m;
          throw p(d(m) + " is not a constructor");
        };
      }, 6077: function(l, v, s) {
        var c = s(614), d = String, p = TypeError;
        l.exports = function(m) {
          if (typeof m == "object" || c(m)) return m;
          throw p("Can't set " + d(m) + " as a prototype");
        };
      }, 1223: function(l, v, s) {
        var c = s(5112), d = s(30), p = s(3070).f, m = c("unscopables"), E = Array.prototype;
        E[m] == null && p(E, m, { configurable: !0, value: d(null) }), l.exports = function(y) {
          E[m][y] = !0;
        };
      }, 1530: function(l, v, s) {
        var c = s(8710).charAt;
        l.exports = function(d, p, m) {
          return p + (m ? c(d, p).length : 1);
        };
      }, 5787: function(l, v, s) {
        var c = s(7976), d = TypeError;
        l.exports = function(p, m) {
          if (c(m, p)) return p;
          throw d("Incorrect invocation");
        };
      }, 9670: function(l, v, s) {
        var c = s(111), d = String, p = TypeError;
        l.exports = function(m) {
          if (c(m)) return m;
          throw p(d(m) + " is not an object");
        };
      }, 3013: function(l) {
        l.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
      }, 7556: function(l, v, s) {
        var c = s(7293);
        l.exports = c(function() {
          if (typeof ArrayBuffer == "function") {
            var d = new ArrayBuffer(8);
            Object.isExtensible(d) && Object.defineProperty(d, "a", { value: 8 });
          }
        });
      }, 260: function(l, v, s) {
        var c, d, p, m = s(3013), E = s(9781), y = s(7854), g = s(614), C = s(111), O = s(2597), N = s(648), w = s(6330), _ = s(8880), I = s(8052), k = s(7045), H = s(7976), S = s(9518), B = s(7674), D = s(5112), F = s(9711), j = s(9909), G = j.enforce, U = j.get, M = y.Int8Array, V = M && M.prototype, J = y.Uint8ClampedArray, ue = J && J.prototype, se = M && S(M), ee = V && S(V), de = Object.prototype, he = y.TypeError, pe = D("toStringTag"), Ce = F("TYPED_ARRAY_TAG"), _e = "TypedArrayConstructor", Le = m && !!B && N(y.opera) !== "Opera", Te = !1, K = { Int8Array: 1, Uint8Array: 1, Uint8ClampedArray: 1, Int16Array: 2, Uint16Array: 2, Int32Array: 4, Uint32Array: 4, Float32Array: 4, Float64Array: 8 }, Oe = { BigInt64Array: 8, BigUint64Array: 8 }, Pe = function(be) {
          var $e = S(be);
          if (C($e)) {
            var Be = U($e);
            return Be && O(Be, _e) ? Be[_e] : Pe($e);
          }
        }, xe = function(be) {
          if (!C(be)) return !1;
          var $e = N(be);
          return O(K, $e) || O(Oe, $e);
        };
        for (c in K) (p = (d = y[c]) && d.prototype) ? G(p)[_e] = d : Le = !1;
        for (c in Oe) (p = (d = y[c]) && d.prototype) && (G(p)[_e] = d);
        if ((!Le || !g(se) || se === Function.prototype) && (se = function() {
          throw he("Incorrect invocation");
        }, Le)) for (c in K) y[c] && B(y[c], se);
        if ((!Le || !ee || ee === de) && (ee = se.prototype, Le)) for (c in K) y[c] && B(y[c].prototype, ee);
        if (Le && S(ue) !== ee && B(ue, ee), E && !O(ee, pe)) for (c in Te = !0, k(ee, pe, { configurable: !0, get: function() {
          return C(this) ? this[Ce] : void 0;
        } }), K) y[c] && _(y[c], Ce, c);
        l.exports = { NATIVE_ARRAY_BUFFER_VIEWS: Le, TYPED_ARRAY_TAG: Te && Ce, aTypedArray: function(be) {
          if (xe(be)) return be;
          throw he("Target is not a typed array");
        }, aTypedArrayConstructor: function(be) {
          if (g(be) && (!B || H(se, be))) return be;
          throw he(w(be) + " is not a typed array constructor");
        }, exportTypedArrayMethod: function(be, $e, Be, Ke) {
          if (E) {
            if (Be) for (var Ze in K) {
              var at = y[Ze];
              if (at && O(at.prototype, be)) try {
                delete at.prototype[be];
              } catch {
                try {
                  at.prototype[be] = $e;
                } catch {
                }
              }
            }
            ee[be] && !Be || I(ee, be, Be ? $e : Le && V[be] || $e, Ke);
          }
        }, exportTypedArrayStaticMethod: function(be, $e, Be) {
          var Ke, Ze;
          if (E) {
            if (B) {
              if (Be) {
                for (Ke in K) if ((Ze = y[Ke]) && O(Ze, be)) try {
                  delete Ze[be];
                } catch {
                }
              }
              if (se[be] && !Be) return;
              try {
                return I(se, be, Be ? $e : Le && se[be] || $e);
              } catch {
              }
            }
            for (Ke in K) !(Ze = y[Ke]) || Ze[be] && !Be || I(Ze, be, $e);
          }
        }, getTypedArrayConstructor: Pe, isView: function(be) {
          if (!C(be)) return !1;
          var $e = N(be);
          return $e === "DataView" || O(K, $e) || O(Oe, $e);
        }, isTypedArray: xe, TypedArray: se, TypedArrayPrototype: ee };
      }, 3331: function(l, v, s) {
        var c = s(7854), d = s(1702), p = s(9781), m = s(3013), E = s(6530), y = s(8880), g = s(7045), C = s(9190), O = s(7293), N = s(5787), w = s(9303), _ = s(7466), I = s(7067), k = s(1179), H = s(9518), S = s(7674), B = s(8006).f, D = s(1285), F = s(1589), j = s(8003), G = s(9909), U = E.PROPER, M = E.CONFIGURABLE, V = "ArrayBuffer", J = "DataView", ue = "prototype", se = "Wrong index", ee = G.getterFor(V), de = G.getterFor(J), he = G.set, pe = c[V], Ce = pe, _e = Ce && Ce[ue], Le = c[J], Te = Le && Le[ue], K = Object.prototype, Oe = c.Array, Pe = c.RangeError, xe = d(D), be = d([].reverse), $e = k.pack, Be = k.unpack, Ke = function(ut) {
          return [255 & ut];
        }, Ze = function(ut) {
          return [255 & ut, ut >> 8 & 255];
        }, at = function(ut) {
          return [255 & ut, ut >> 8 & 255, ut >> 16 & 255, ut >> 24 & 255];
        }, pt = function(ut) {
          return ut[3] << 24 | ut[2] << 16 | ut[1] << 8 | ut[0];
        }, It = function(ut) {
          return $e(ut, 23, 4);
        }, Rt = function(ut) {
          return $e(ut, 52, 8);
        }, gt = function(ut, St, Ft) {
          g(ut[ue], St, { configurable: !0, get: function() {
            return Ft(this)[St];
          } });
        }, it = function(ut, St, Ft, Ht) {
          var zt = I(Ft), ze = de(ut);
          if (zt + St > ze.byteLength) throw Pe(se);
          var Ne = ze.bytes, le = zt + ze.byteOffset, X = F(Ne, le, le + St);
          return Ht ? X : be(X);
        }, Tt = function(ut, St, Ft, Ht, zt, ze) {
          var Ne = I(Ft), le = de(ut);
          if (Ne + St > le.byteLength) throw Pe(se);
          for (var X = le.bytes, re = Ne + le.byteOffset, Me = Ht(+zt), Se = 0; Se < St; Se++) X[re + Se] = Me[ze ? Se : St - Se - 1];
        };
        if (m) {
          var Ut = U && pe.name !== V;
          if (O(function() {
            pe(1);
          }) && O(function() {
            new pe(-1);
          }) && !O(function() {
            return new pe(), new pe(1.5), new pe(NaN), pe.length != 1 || Ut && !M;
          })) Ut && M && y(pe, "name", V);
          else {
            (Ce = function(ut) {
              return N(this, _e), new pe(I(ut));
            })[ue] = _e;
            for (var st, Ot = B(pe), kt = 0; Ot.length > kt; ) (st = Ot[kt++]) in Ce || y(Ce, st, pe[st]);
            _e.constructor = Ce;
          }
          S && H(Te) !== K && S(Te, K);
          var wt = new Le(new Ce(2)), Et = d(Te.setInt8);
          wt.setInt8(0, 2147483648), wt.setInt8(1, 2147483649), !wt.getInt8(0) && wt.getInt8(1) || C(Te, { setInt8: function(ut, St) {
            Et(this, ut, St << 24 >> 24);
          }, setUint8: function(ut, St) {
            Et(this, ut, St << 24 >> 24);
          } }, { unsafe: !0 });
        } else _e = (Ce = function(ut) {
          N(this, _e);
          var St = I(ut);
          he(this, { type: V, bytes: xe(Oe(St), 0), byteLength: St }), p || (this.byteLength = St, this.detached = !1);
        })[ue], Te = (Le = function(ut, St, Ft) {
          N(this, Te), N(ut, _e);
          var Ht = ee(ut), zt = Ht.byteLength, ze = w(St);
          if (ze < 0 || ze > zt) throw Pe("Wrong offset");
          if (ze + (Ft = Ft === void 0 ? zt - ze : _(Ft)) > zt) throw Pe("Wrong length");
          he(this, { type: J, buffer: ut, byteLength: Ft, byteOffset: ze, bytes: Ht.bytes }), p || (this.buffer = ut, this.byteLength = Ft, this.byteOffset = ze);
        })[ue], p && (gt(Ce, "byteLength", ee), gt(Le, "buffer", de), gt(Le, "byteLength", de), gt(Le, "byteOffset", de)), C(Te, { getInt8: function(ut) {
          return it(this, 1, ut)[0] << 24 >> 24;
        }, getUint8: function(ut) {
          return it(this, 1, ut)[0];
        }, getInt16: function(ut) {
          var St = it(this, 2, ut, arguments.length > 1 ? arguments[1] : void 0);
          return (St[1] << 8 | St[0]) << 16 >> 16;
        }, getUint16: function(ut) {
          var St = it(this, 2, ut, arguments.length > 1 ? arguments[1] : void 0);
          return St[1] << 8 | St[0];
        }, getInt32: function(ut) {
          return pt(it(this, 4, ut, arguments.length > 1 ? arguments[1] : void 0));
        }, getUint32: function(ut) {
          return pt(it(this, 4, ut, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
        }, getFloat32: function(ut) {
          return Be(it(this, 4, ut, arguments.length > 1 ? arguments[1] : void 0), 23);
        }, getFloat64: function(ut) {
          return Be(it(this, 8, ut, arguments.length > 1 ? arguments[1] : void 0), 52);
        }, setInt8: function(ut, St) {
          Tt(this, 1, ut, Ke, St);
        }, setUint8: function(ut, St) {
          Tt(this, 1, ut, Ke, St);
        }, setInt16: function(ut, St) {
          Tt(this, 2, ut, Ze, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setUint16: function(ut, St) {
          Tt(this, 2, ut, Ze, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setInt32: function(ut, St) {
          Tt(this, 4, ut, at, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setUint32: function(ut, St) {
          Tt(this, 4, ut, at, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setFloat32: function(ut, St) {
          Tt(this, 4, ut, It, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setFloat64: function(ut, St) {
          Tt(this, 8, ut, Rt, St, arguments.length > 2 ? arguments[2] : void 0);
        } });
        j(Ce, V), j(Le, J), l.exports = { ArrayBuffer: Ce, DataView: Le };
      }, 1048: function(l, v, s) {
        var c = s(7908), d = s(1400), p = s(6244), m = s(5117), E = Math.min;
        l.exports = [].copyWithin || function(y, g) {
          var C = c(this), O = p(C), N = d(y, O), w = d(g, O), _ = arguments.length > 2 ? arguments[2] : void 0, I = E((_ === void 0 ? O : d(_, O)) - w, O - N), k = 1;
          for (w < N && N < w + I && (k = -1, w += I - 1, N += I - 1); I-- > 0; ) w in C ? C[N] = C[w] : m(C, N), N += k, w += k;
          return C;
        };
      }, 1285: function(l, v, s) {
        var c = s(7908), d = s(1400), p = s(6244);
        l.exports = function(m) {
          for (var E = c(this), y = p(E), g = arguments.length, C = d(g > 1 ? arguments[1] : void 0, y), O = g > 2 ? arguments[2] : void 0, N = O === void 0 ? y : d(O, y); N > C; ) E[C++] = m;
          return E;
        };
      }, 8533: function(l, v, s) {
        var c = s(2092).forEach, d = s(9341)("forEach");
        l.exports = d ? [].forEach : function(p) {
          return c(this, p, arguments.length > 1 ? arguments[1] : void 0);
        };
      }, 7745: function(l, v, s) {
        var c = s(6244);
        l.exports = function(d, p) {
          for (var m = 0, E = c(p), y = new d(E); E > m; ) y[m] = p[m++];
          return y;
        };
      }, 8457: function(l, v, s) {
        var c = s(9974), d = s(6916), p = s(7908), m = s(3411), E = s(7659), y = s(4411), g = s(6244), C = s(6135), O = s(4121), N = s(1246), w = Array;
        l.exports = function(_) {
          var I = p(_), k = y(this), H = arguments.length, S = H > 1 ? arguments[1] : void 0, B = S !== void 0;
          B && (S = c(S, H > 2 ? arguments[2] : void 0));
          var D, F, j, G, U, M, V = N(I), J = 0;
          if (!V || this === w && E(V)) for (D = g(I), F = k ? new this(D) : w(D); D > J; J++) M = B ? S(I[J], J) : I[J], C(F, J, M);
          else for (U = (G = O(I, V)).next, F = k ? new this() : []; !(j = d(U, G)).done; J++) M = B ? m(G, S, [j.value, J], !0) : j.value, C(F, J, M);
          return F.length = J, F;
        };
      }, 1318: function(l, v, s) {
        var c = s(5656), d = s(1400), p = s(6244), m = function(E) {
          return function(y, g, C) {
            var O, N = c(y), w = p(N), _ = d(C, w);
            if (E && g != g) {
              for (; w > _; ) if ((O = N[_++]) != O) return !0;
            } else for (; w > _; _++) if ((E || _ in N) && N[_] === g) return E || _ || 0;
            return !E && -1;
          };
        };
        l.exports = { includes: m(!0), indexOf: m(!1) };
      }, 2092: function(l, v, s) {
        var c = s(9974), d = s(1702), p = s(8361), m = s(7908), E = s(6244), y = s(5417), g = d([].push), C = function(O) {
          var N = O == 1, w = O == 2, _ = O == 3, I = O == 4, k = O == 6, H = O == 7, S = O == 5 || k;
          return function(B, D, F, j) {
            for (var G, U, M = m(B), V = p(M), J = c(D, F), ue = E(V), se = 0, ee = j || y, de = N ? ee(B, ue) : w || H ? ee(B, 0) : void 0; ue > se; se++) if ((S || se in V) && (U = J(G = V[se], se, M), O)) if (N) de[se] = U;
            else if (U) switch (O) {
              case 3:
                return !0;
              case 5:
                return G;
              case 6:
                return se;
              case 2:
                g(de, G);
            }
            else switch (O) {
              case 4:
                return !1;
              case 7:
                g(de, G);
            }
            return k ? -1 : _ || I ? I : de;
          };
        };
        l.exports = { forEach: C(0), map: C(1), filter: C(2), some: C(3), every: C(4), find: C(5), findIndex: C(6), filterReject: C(7) };
      }, 6583: function(l, v, s) {
        var c = s(2104), d = s(5656), p = s(9303), m = s(6244), E = s(9341), y = Math.min, g = [].lastIndexOf, C = !!g && 1 / [1].lastIndexOf(1, -0) < 0, O = E("lastIndexOf"), N = C || !O;
        l.exports = N ? function(w) {
          if (C) return c(g, this, arguments) || 0;
          var _ = d(this), I = m(_), k = I - 1;
          for (arguments.length > 1 && (k = y(k, p(arguments[1]))), k < 0 && (k = I + k); k >= 0; k--) if (k in _ && _[k] === w) return k || 0;
          return -1;
        } : g;
      }, 1194: function(l, v, s) {
        var c = s(7293), d = s(5112), p = s(7392), m = d("species");
        l.exports = function(E) {
          return p >= 51 || !c(function() {
            var y = [];
            return (y.constructor = {})[m] = function() {
              return { foo: 1 };
            }, y[E](Boolean).foo !== 1;
          });
        };
      }, 9341: function(l, v, s) {
        var c = s(7293);
        l.exports = function(d, p) {
          var m = [][d];
          return !!m && c(function() {
            m.call(null, p || function() {
              return 1;
            }, 1);
          });
        };
      }, 3671: function(l, v, s) {
        var c = s(9662), d = s(7908), p = s(8361), m = s(6244), E = TypeError, y = function(g) {
          return function(C, O, N, w) {
            c(O);
            var _ = d(C), I = p(_), k = m(_), H = g ? k - 1 : 0, S = g ? -1 : 1;
            if (N < 2) for (; ; ) {
              if (H in I) {
                w = I[H], H += S;
                break;
              }
              if (H += S, g ? H < 0 : k <= H) throw E("Reduce of empty array with no initial value");
            }
            for (; g ? H >= 0 : k > H; H += S) H in I && (w = O(w, I[H], H, _));
            return w;
          };
        };
        l.exports = { left: y(!1), right: y(!0) };
      }, 3658: function(l, v, s) {
        var c = s(9781), d = s(3157), p = TypeError, m = Object.getOwnPropertyDescriptor, E = c && !function() {
          if (this !== void 0) return !0;
          try {
            Object.defineProperty([], "length", { writable: !1 }).length = 1;
          } catch (y) {
            return y instanceof TypeError;
          }
        }();
        l.exports = E ? function(y, g) {
          if (d(y) && !m(y, "length").writable) throw p("Cannot set read only .length");
          return y.length = g;
        } : function(y, g) {
          return y.length = g;
        };
      }, 1589: function(l, v, s) {
        var c = s(1400), d = s(6244), p = s(6135), m = Array, E = Math.max;
        l.exports = function(y, g, C) {
          for (var O = d(y), N = c(g, O), w = c(C === void 0 ? O : C, O), _ = m(E(w - N, 0)), I = 0; N < w; N++, I++) p(_, I, y[N]);
          return _.length = I, _;
        };
      }, 206: function(l, v, s) {
        var c = s(1702);
        l.exports = c([].slice);
      }, 4362: function(l, v, s) {
        var c = s(1589), d = Math.floor, p = function(y, g) {
          var C = y.length, O = d(C / 2);
          return C < 8 ? m(y, g) : E(y, p(c(y, 0, O), g), p(c(y, O), g), g);
        }, m = function(y, g) {
          for (var C, O, N = y.length, w = 1; w < N; ) {
            for (O = w, C = y[w]; O && g(y[O - 1], C) > 0; ) y[O] = y[--O];
            O !== w++ && (y[O] = C);
          }
          return y;
        }, E = function(y, g, C, O) {
          for (var N = g.length, w = C.length, _ = 0, I = 0; _ < N || I < w; ) y[_ + I] = _ < N && I < w ? O(g[_], C[I]) <= 0 ? g[_++] : C[I++] : _ < N ? g[_++] : C[I++];
          return y;
        };
        l.exports = p;
      }, 7475: function(l, v, s) {
        var c = s(3157), d = s(4411), p = s(111), m = s(5112)("species"), E = Array;
        l.exports = function(y) {
          var g;
          return c(y) && (g = y.constructor, (d(g) && (g === E || c(g.prototype)) || p(g) && (g = g[m]) === null) && (g = void 0)), g === void 0 ? E : g;
        };
      }, 5417: function(l, v, s) {
        var c = s(7475);
        l.exports = function(d, p) {
          return new (c(d))(p === 0 ? 0 : p);
        };
      }, 3411: function(l, v, s) {
        var c = s(9670), d = s(9212);
        l.exports = function(p, m, E, y) {
          try {
            return y ? m(c(E)[0], E[1]) : m(E);
          } catch (g) {
            d(p, "throw", g);
          }
        };
      }, 7072: function(l, v, s) {
        var c = s(5112)("iterator"), d = !1;
        try {
          var p = 0, m = { next: function() {
            return { done: !!p++ };
          }, return: function() {
            d = !0;
          } };
          m[c] = function() {
            return this;
          }, Array.from(m, function() {
            throw 2;
          });
        } catch {
        }
        l.exports = function(E, y) {
          if (!y && !d) return !1;
          var g = !1;
          try {
            var C = {};
            C[c] = function() {
              return { next: function() {
                return { done: g = !0 };
              } };
            }, E(C);
          } catch {
          }
          return g;
        };
      }, 4326: function(l, v, s) {
        var c = s(1702), d = c({}.toString), p = c("".slice);
        l.exports = function(m) {
          return p(d(m), 8, -1);
        };
      }, 648: function(l, v, s) {
        var c = s(1694), d = s(614), p = s(4326), m = s(5112)("toStringTag"), E = Object, y = p(/* @__PURE__ */ function() {
          return arguments;
        }()) == "Arguments";
        l.exports = c ? p : function(g) {
          var C, O, N;
          return g === void 0 ? "Undefined" : g === null ? "Null" : typeof (O = function(w, _) {
            try {
              return w[_];
            } catch {
            }
          }(C = E(g), m)) == "string" ? O : y ? p(C) : (N = p(C)) == "Object" && d(C.callee) ? "Arguments" : N;
        };
      }, 5631: function(l, v, s) {
        var c = s(30), d = s(7045), p = s(9190), m = s(9974), E = s(5787), y = s(8554), g = s(408), C = s(1656), O = s(6178), N = s(6340), w = s(9781), _ = s(2423).fastKey, I = s(9909), k = I.set, H = I.getterFor;
        l.exports = { getConstructor: function(S, B, D, F) {
          var j = S(function(J, ue) {
            E(J, G), k(J, { type: B, index: c(null), first: void 0, last: void 0, size: 0 }), w || (J.size = 0), y(ue) || g(ue, J[F], { that: J, AS_ENTRIES: D });
          }), G = j.prototype, U = H(B), M = function(J, ue, se) {
            var ee, de, he = U(J), pe = V(J, ue);
            return pe ? pe.value = se : (he.last = pe = { index: de = _(ue, !0), key: ue, value: se, previous: ee = he.last, next: void 0, removed: !1 }, he.first || (he.first = pe), ee && (ee.next = pe), w ? he.size++ : J.size++, de !== "F" && (he.index[de] = pe)), J;
          }, V = function(J, ue) {
            var se, ee = U(J), de = _(ue);
            if (de !== "F") return ee.index[de];
            for (se = ee.first; se; se = se.next) if (se.key == ue) return se;
          };
          return p(G, { clear: function() {
            for (var J = U(this), ue = J.index, se = J.first; se; ) se.removed = !0, se.previous && (se.previous = se.previous.next = void 0), delete ue[se.index], se = se.next;
            J.first = J.last = void 0, w ? J.size = 0 : this.size = 0;
          }, delete: function(J) {
            var ue = this, se = U(ue), ee = V(ue, J);
            if (ee) {
              var de = ee.next, he = ee.previous;
              delete se.index[ee.index], ee.removed = !0, he && (he.next = de), de && (de.previous = he), se.first == ee && (se.first = de), se.last == ee && (se.last = he), w ? se.size-- : ue.size--;
            }
            return !!ee;
          }, forEach: function(J) {
            for (var ue, se = U(this), ee = m(J, arguments.length > 1 ? arguments[1] : void 0); ue = ue ? ue.next : se.first; ) for (ee(ue.value, ue.key, this); ue && ue.removed; ) ue = ue.previous;
          }, has: function(J) {
            return !!V(this, J);
          } }), p(G, D ? { get: function(J) {
            var ue = V(this, J);
            return ue && ue.value;
          }, set: function(J, ue) {
            return M(this, J === 0 ? 0 : J, ue);
          } } : { add: function(J) {
            return M(this, J = J === 0 ? 0 : J, J);
          } }), w && d(G, "size", { configurable: !0, get: function() {
            return U(this).size;
          } }), j;
        }, setStrong: function(S, B, D) {
          var F = B + " Iterator", j = H(B), G = H(F);
          C(S, B, function(U, M) {
            k(this, { type: F, target: U, state: j(U), kind: M, last: void 0 });
          }, function() {
            for (var U = G(this), M = U.kind, V = U.last; V && V.removed; ) V = V.previous;
            return U.target && (U.last = V = V ? V.next : U.state.first) ? O(M == "keys" ? V.key : M == "values" ? V.value : [V.key, V.value], !1) : (U.target = void 0, O(void 0, !0));
          }, D ? "entries" : "values", !D, !0), N(B);
        } };
      }, 7710: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(1702), m = s(4705), E = s(8052), y = s(2423), g = s(408), C = s(5787), O = s(614), N = s(8554), w = s(111), _ = s(7293), I = s(7072), k = s(8003), H = s(9587);
        l.exports = function(S, B, D) {
          var F = S.indexOf("Map") !== -1, j = S.indexOf("Weak") !== -1, G = F ? "set" : "add", U = d[S], M = U && U.prototype, V = U, J = {}, ue = function(Ce) {
            var _e = p(M[Ce]);
            E(M, Ce, Ce == "add" ? function(Le) {
              return _e(this, Le === 0 ? 0 : Le), this;
            } : Ce == "delete" ? function(Le) {
              return !(j && !w(Le)) && _e(this, Le === 0 ? 0 : Le);
            } : Ce == "get" ? function(Le) {
              return j && !w(Le) ? void 0 : _e(this, Le === 0 ? 0 : Le);
            } : Ce == "has" ? function(Le) {
              return !(j && !w(Le)) && _e(this, Le === 0 ? 0 : Le);
            } : function(Le, Te) {
              return _e(this, Le === 0 ? 0 : Le, Te), this;
            });
          };
          if (m(S, !O(U) || !(j || M.forEach && !_(function() {
            new U().entries().next();
          })))) V = D.getConstructor(B, S, F, G), y.enable();
          else if (m(S, !0)) {
            var se = new V(), ee = se[G](j ? {} : -0, 1) != se, de = _(function() {
              se.has(1);
            }), he = I(function(Ce) {
              new U(Ce);
            }), pe = !j && _(function() {
              for (var Ce = new U(), _e = 5; _e--; ) Ce[G](_e, _e);
              return !Ce.has(-0);
            });
            he || ((V = B(function(Ce, _e) {
              C(Ce, M);
              var Le = H(new U(), Ce, V);
              return N(_e) || g(_e, Le[G], { that: Le, AS_ENTRIES: F }), Le;
            })).prototype = M, M.constructor = V), (de || pe) && (ue("delete"), ue("has"), F && ue("get")), (pe || ee) && ue(G), j && M.clear && delete M.clear;
          }
          return J[S] = V, c({ global: !0, constructor: !0, forced: V != U }, J), k(V, S), j || D.setStrong(V, S, F), V;
        };
      }, 9920: function(l, v, s) {
        var c = s(2597), d = s(3887), p = s(1236), m = s(3070);
        l.exports = function(E, y, g) {
          for (var C = d(y), O = m.f, N = p.f, w = 0; w < C.length; w++) {
            var _ = C[w];
            c(E, _) || g && c(g, _) || O(E, _, N(y, _));
          }
        };
      }, 4964: function(l, v, s) {
        var c = s(5112)("match");
        l.exports = function(d) {
          var p = /./;
          try {
            "/./"[d](p);
          } catch {
            try {
              return p[c] = !1, "/./"[d](p);
            } catch {
            }
          }
          return !1;
        };
      }, 8544: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          function d() {
          }
          return d.prototype.constructor = null, Object.getPrototypeOf(new d()) !== d.prototype;
        });
      }, 6178: function(l) {
        l.exports = function(v, s) {
          return { value: v, done: s };
        };
      }, 8880: function(l, v, s) {
        var c = s(9781), d = s(3070), p = s(9114);
        l.exports = c ? function(m, E, y) {
          return d.f(m, E, p(1, y));
        } : function(m, E, y) {
          return m[E] = y, m;
        };
      }, 9114: function(l) {
        l.exports = function(v, s) {
          return { enumerable: !(1 & v), configurable: !(2 & v), writable: !(4 & v), value: s };
        };
      }, 6135: function(l, v, s) {
        var c = s(4948), d = s(3070), p = s(9114);
        l.exports = function(m, E, y) {
          var g = c(E);
          g in m ? d.f(m, g, p(0, y)) : m[g] = y;
        };
      }, 7045: function(l, v, s) {
        var c = s(6339), d = s(3070);
        l.exports = function(p, m, E) {
          return E.get && c(E.get, m, { getter: !0 }), E.set && c(E.set, m, { setter: !0 }), d.f(p, m, E);
        };
      }, 8052: function(l, v, s) {
        var c = s(614), d = s(3070), p = s(6339), m = s(3072);
        l.exports = function(E, y, g, C) {
          C || (C = {});
          var O = C.enumerable, N = C.name !== void 0 ? C.name : y;
          if (c(g) && p(g, N, C), C.global) O ? E[y] = g : m(y, g);
          else {
            try {
              C.unsafe ? E[y] && (O = !0) : delete E[y];
            } catch {
            }
            O ? E[y] = g : d.f(E, y, { value: g, enumerable: !1, configurable: !C.nonConfigurable, writable: !C.nonWritable });
          }
          return E;
        };
      }, 9190: function(l, v, s) {
        var c = s(8052);
        l.exports = function(d, p, m) {
          for (var E in p) c(d, E, p[E], m);
          return d;
        };
      }, 3072: function(l, v, s) {
        var c = s(7854), d = Object.defineProperty;
        l.exports = function(p, m) {
          try {
            d(c, p, { value: m, configurable: !0, writable: !0 });
          } catch {
            c[p] = m;
          }
          return m;
        };
      }, 5117: function(l, v, s) {
        var c = s(6330), d = TypeError;
        l.exports = function(p, m) {
          if (!delete p[m]) throw d("Cannot delete property " + c(m) + " of " + c(p));
        };
      }, 9781: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          return Object.defineProperty({}, 1, { get: function() {
            return 7;
          } })[1] != 7;
        });
      }, 4154: function(l) {
        var v = typeof document == "object" && document.all, s = v === void 0 && v !== void 0;
        l.exports = { all: v, IS_HTMLDDA: s };
      }, 317: function(l, v, s) {
        var c = s(7854), d = s(111), p = c.document, m = d(p) && d(p.createElement);
        l.exports = function(E) {
          return m ? p.createElement(E) : {};
        };
      }, 7207: function(l) {
        var v = TypeError;
        l.exports = function(s) {
          if (s > 9007199254740991) throw v("Maximum allowed index exceeded");
          return s;
        };
      }, 8324: function(l) {
        l.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
      }, 8509: function(l, v, s) {
        var c = s(317)("span").classList, d = c && c.constructor && c.constructor.prototype;
        l.exports = d === Object.prototype ? void 0 : d;
      }, 8886: function(l, v, s) {
        var c = s(8113).match(/firefox\/(\d+)/i);
        l.exports = !!c && +c[1];
      }, 7871: function(l, v, s) {
        var c = s(3823), d = s(5268);
        l.exports = !c && !d && typeof window == "object" && typeof document == "object";
      }, 9363: function(l) {
        l.exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";
      }, 3823: function(l) {
        l.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";
      }, 256: function(l, v, s) {
        var c = s(8113);
        l.exports = /MSIE|Trident/.test(c);
      }, 1528: function(l, v, s) {
        var c = s(8113);
        l.exports = /ipad|iphone|ipod/i.test(c) && typeof Pebble < "u";
      }, 6833: function(l, v, s) {
        var c = s(8113);
        l.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(c);
      }, 5268: function(l, v, s) {
        var c = s(4326);
        l.exports = typeof process < "u" && c(process) == "process";
      }, 1036: function(l, v, s) {
        var c = s(8113);
        l.exports = /web0s(?!.*chrome)/i.test(c);
      }, 8113: function(l) {
        l.exports = typeof navigator < "u" && String(navigator.userAgent) || "";
      }, 7392: function(l, v, s) {
        var c, d, p = s(7854), m = s(8113), E = p.process, y = p.Deno, g = E && E.versions || y && y.version, C = g && g.v8;
        C && (d = (c = C.split("."))[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !d && m && (!(c = m.match(/Edge\/(\d+)/)) || c[1] >= 74) && (c = m.match(/Chrome\/(\d+)/)) && (d = +c[1]), l.exports = d;
      }, 8008: function(l, v, s) {
        var c = s(8113).match(/AppleWebKit\/(\d+)\./);
        l.exports = !!c && +c[1];
      }, 748: function(l) {
        l.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
      }, 2109: function(l, v, s) {
        var c = s(7854), d = s(1236).f, p = s(8880), m = s(8052), E = s(3072), y = s(9920), g = s(4705);
        l.exports = function(C, O) {
          var N, w, _, I, k, H = C.target, S = C.global, B = C.stat;
          if (N = S ? c : B ? c[H] || E(H, {}) : (c[H] || {}).prototype) for (w in O) {
            if (I = O[w], _ = C.dontCallGetSet ? (k = d(N, w)) && k.value : N[w], !g(S ? w : H + (B ? "." : "#") + w, C.forced) && _ !== void 0) {
              if (typeof I == typeof _) continue;
              y(I, _);
            }
            (C.sham || _ && _.sham) && p(I, "sham", !0), m(N, w, I, C);
          }
        };
      }, 7293: function(l) {
        l.exports = function(v) {
          try {
            return !!v();
          } catch {
            return !0;
          }
        };
      }, 7007: function(l, v, s) {
        s(4916);
        var c = s(1470), d = s(8052), p = s(2261), m = s(7293), E = s(5112), y = s(8880), g = E("species"), C = RegExp.prototype;
        l.exports = function(O, N, w, _) {
          var I = E(O), k = !m(function() {
            var D = {};
            return D[I] = function() {
              return 7;
            }, ""[O](D) != 7;
          }), H = k && !m(function() {
            var D = !1, F = /a/;
            return O === "split" && ((F = {}).constructor = {}, F.constructor[g] = function() {
              return F;
            }, F.flags = "", F[I] = /./[I]), F.exec = function() {
              return D = !0, null;
            }, F[I](""), !D;
          });
          if (!k || !H || w) {
            var S = c(/./[I]), B = N(I, ""[O], function(D, F, j, G, U) {
              var M = c(D), V = F.exec;
              return V === p || V === C.exec ? k && !U ? { done: !0, value: S(F, j, G) } : { done: !0, value: M(j, F, G) } : { done: !1 };
            });
            d(String.prototype, O, B[0]), d(C, I, B[1]);
          }
          _ && y(C[I], "sham", !0);
        };
      }, 6677: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          return Object.isExtensible(Object.preventExtensions({}));
        });
      }, 2104: function(l, v, s) {
        var c = s(4374), d = Function.prototype, p = d.apply, m = d.call;
        l.exports = typeof Reflect == "object" && Reflect.apply || (c ? m.bind(p) : function() {
          return m.apply(p, arguments);
        });
      }, 9974: function(l, v, s) {
        var c = s(1470), d = s(9662), p = s(4374), m = c(c.bind);
        l.exports = function(E, y) {
          return d(E), y === void 0 ? E : p ? m(E, y) : function() {
            return E.apply(y, arguments);
          };
        };
      }, 4374: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          var d = (function() {
          }).bind();
          return typeof d != "function" || d.hasOwnProperty("prototype");
        });
      }, 7065: function(l, v, s) {
        var c = s(1702), d = s(9662), p = s(111), m = s(2597), E = s(206), y = s(4374), g = Function, C = c([].concat), O = c([].join), N = {};
        l.exports = y ? g.bind : function(w) {
          var _ = d(this), I = _.prototype, k = E(arguments, 1), H = function() {
            var S = C(k, E(arguments));
            return this instanceof H ? function(B, D, F) {
              if (!m(N, D)) {
                for (var j = [], G = 0; G < D; G++) j[G] = "a[" + G + "]";
                N[D] = g("C,a", "return new C(" + O(j, ",") + ")");
              }
              return N[D](B, F);
            }(_, S.length, S) : _.apply(w, S);
          };
          return p(I) && (H.prototype = I), H;
        };
      }, 6916: function(l, v, s) {
        var c = s(4374), d = Function.prototype.call;
        l.exports = c ? d.bind(d) : function() {
          return d.apply(d, arguments);
        };
      }, 6530: function(l, v, s) {
        var c = s(9781), d = s(2597), p = Function.prototype, m = c && Object.getOwnPropertyDescriptor, E = d(p, "name"), y = E && (function() {
        }).name === "something", g = E && (!c || c && m(p, "name").configurable);
        l.exports = { EXISTS: E, PROPER: y, CONFIGURABLE: g };
      }, 5668: function(l, v, s) {
        var c = s(1702), d = s(9662);
        l.exports = function(p, m, E) {
          try {
            return c(d(Object.getOwnPropertyDescriptor(p, m)[E]));
          } catch {
          }
        };
      }, 1470: function(l, v, s) {
        var c = s(4326), d = s(1702);
        l.exports = function(p) {
          if (c(p) === "Function") return d(p);
        };
      }, 1702: function(l, v, s) {
        var c = s(4374), d = Function.prototype, p = d.call, m = c && d.bind.bind(p, p);
        l.exports = c ? m : function(E) {
          return function() {
            return p.apply(E, arguments);
          };
        };
      }, 5005: function(l, v, s) {
        var c = s(7854), d = s(614);
        l.exports = function(p, m) {
          return arguments.length < 2 ? (E = c[p], d(E) ? E : void 0) : c[p] && c[p][m];
          var E;
        };
      }, 1246: function(l, v, s) {
        var c = s(648), d = s(8173), p = s(8554), m = s(7497), E = s(5112)("iterator");
        l.exports = function(y) {
          if (!p(y)) return d(y, E) || d(y, "@@iterator") || m[c(y)];
        };
      }, 4121: function(l, v, s) {
        var c = s(6916), d = s(9662), p = s(9670), m = s(6330), E = s(1246), y = TypeError;
        l.exports = function(g, C) {
          var O = arguments.length < 2 ? E(g) : C;
          if (d(O)) return p(c(O, g));
          throw y(m(g) + " is not iterable");
        };
      }, 8044: function(l, v, s) {
        var c = s(1702), d = s(3157), p = s(614), m = s(4326), E = s(1340), y = c([].push);
        l.exports = function(g) {
          if (p(g)) return g;
          if (d(g)) {
            for (var C = g.length, O = [], N = 0; N < C; N++) {
              var w = g[N];
              typeof w == "string" ? y(O, w) : typeof w != "number" && m(w) != "Number" && m(w) != "String" || y(O, E(w));
            }
            var _ = O.length, I = !0;
            return function(k, H) {
              if (I) return I = !1, H;
              if (d(this)) return H;
              for (var S = 0; S < _; S++) if (O[S] === k) return H;
            };
          }
        };
      }, 8173: function(l, v, s) {
        var c = s(9662), d = s(8554);
        l.exports = function(p, m) {
          var E = p[m];
          return d(E) ? void 0 : c(E);
        };
      }, 7854: function(l, v, s) {
        var c = function(d) {
          return d && d.Math == Math && d;
        };
        l.exports = c(typeof globalThis == "object" && globalThis) || c(typeof window == "object" && window) || c(typeof self == "object" && self) || c(typeof s.g == "object" && s.g) || /* @__PURE__ */ function() {
          return this;
        }() || this || Function("return this")();
      }, 2597: function(l, v, s) {
        var c = s(1702), d = s(7908), p = c({}.hasOwnProperty);
        l.exports = Object.hasOwn || function(m, E) {
          return p(d(m), E);
        };
      }, 3501: function(l) {
        l.exports = {};
      }, 842: function(l) {
        l.exports = function(v, s) {
          try {
            arguments.length == 1 ? console.error(v) : console.error(v, s);
          } catch {
          }
        };
      }, 490: function(l, v, s) {
        var c = s(5005);
        l.exports = c("document", "documentElement");
      }, 4664: function(l, v, s) {
        var c = s(9781), d = s(7293), p = s(317);
        l.exports = !c && !d(function() {
          return Object.defineProperty(p("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      }, 1179: function(l) {
        var v = Array, s = Math.abs, c = Math.pow, d = Math.floor, p = Math.log, m = Math.LN2;
        l.exports = { pack: function(E, y, g) {
          var C, O, N, w = v(g), _ = 8 * g - y - 1, I = (1 << _) - 1, k = I >> 1, H = y === 23 ? c(2, -24) - c(2, -77) : 0, S = E < 0 || E === 0 && 1 / E < 0 ? 1 : 0, B = 0;
          for ((E = s(E)) != E || E === 1 / 0 ? (O = E != E ? 1 : 0, C = I) : (C = d(p(E) / m), E * (N = c(2, -C)) < 1 && (C--, N *= 2), (E += C + k >= 1 ? H / N : H * c(2, 1 - k)) * N >= 2 && (C++, N /= 2), C + k >= I ? (O = 0, C = I) : C + k >= 1 ? (O = (E * N - 1) * c(2, y), C += k) : (O = E * c(2, k - 1) * c(2, y), C = 0)); y >= 8; ) w[B++] = 255 & O, O /= 256, y -= 8;
          for (C = C << y | O, _ += y; _ > 0; ) w[B++] = 255 & C, C /= 256, _ -= 8;
          return w[--B] |= 128 * S, w;
        }, unpack: function(E, y) {
          var g, C = E.length, O = 8 * C - y - 1, N = (1 << O) - 1, w = N >> 1, _ = O - 7, I = C - 1, k = E[I--], H = 127 & k;
          for (k >>= 7; _ > 0; ) H = 256 * H + E[I--], _ -= 8;
          for (g = H & (1 << -_) - 1, H >>= -_, _ += y; _ > 0; ) g = 256 * g + E[I--], _ -= 8;
          if (H === 0) H = 1 - w;
          else {
            if (H === N) return g ? NaN : k ? -1 / 0 : 1 / 0;
            g += c(2, y), H -= w;
          }
          return (k ? -1 : 1) * g * c(2, H - y);
        } };
      }, 8361: function(l, v, s) {
        var c = s(1702), d = s(7293), p = s(4326), m = Object, E = c("".split);
        l.exports = d(function() {
          return !m("z").propertyIsEnumerable(0);
        }) ? function(y) {
          return p(y) == "String" ? E(y, "") : m(y);
        } : m;
      }, 9587: function(l, v, s) {
        var c = s(614), d = s(111), p = s(7674);
        l.exports = function(m, E, y) {
          var g, C;
          return p && c(g = E.constructor) && g !== y && d(C = g.prototype) && C !== y.prototype && p(m, C), m;
        };
      }, 2788: function(l, v, s) {
        var c = s(1702), d = s(614), p = s(5465), m = c(Function.toString);
        d(p.inspectSource) || (p.inspectSource = function(E) {
          return m(E);
        }), l.exports = p.inspectSource;
      }, 2423: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(3501), m = s(111), E = s(2597), y = s(3070).f, g = s(8006), C = s(1156), O = s(2050), N = s(9711), w = s(6677), _ = !1, I = N("meta"), k = 0, H = function(B) {
          y(B, I, { value: { objectID: "O" + k++, weakData: {} } });
        }, S = l.exports = { enable: function() {
          S.enable = function() {
          }, _ = !0;
          var B = g.f, D = d([].splice), F = {};
          F[I] = 1, B(F).length && (g.f = function(j) {
            for (var G = B(j), U = 0, M = G.length; U < M; U++) if (G[U] === I) {
              D(G, U, 1);
              break;
            }
            return G;
          }, c({ target: "Object", stat: !0, forced: !0 }, { getOwnPropertyNames: C.f }));
        }, fastKey: function(B, D) {
          if (!m(B)) return typeof B == "symbol" ? B : (typeof B == "string" ? "S" : "P") + B;
          if (!E(B, I)) {
            if (!O(B)) return "F";
            if (!D) return "E";
            H(B);
          }
          return B[I].objectID;
        }, getWeakData: function(B, D) {
          if (!E(B, I)) {
            if (!O(B)) return !0;
            if (!D) return !1;
            H(B);
          }
          return B[I].weakData;
        }, onFreeze: function(B) {
          return w && _ && O(B) && !E(B, I) && H(B), B;
        } };
        p[I] = !0;
      }, 9909: function(l, v, s) {
        var c, d, p, m = s(4811), E = s(7854), y = s(111), g = s(8880), C = s(2597), O = s(5465), N = s(6200), w = s(3501), _ = "Object already initialized", I = E.TypeError, k = E.WeakMap;
        if (m || O.state) {
          var H = O.state || (O.state = new k());
          H.get = H.get, H.has = H.has, H.set = H.set, c = function(B, D) {
            if (H.has(B)) throw I(_);
            return D.facade = B, H.set(B, D), D;
          }, d = function(B) {
            return H.get(B) || {};
          }, p = function(B) {
            return H.has(B);
          };
        } else {
          var S = N("state");
          w[S] = !0, c = function(B, D) {
            if (C(B, S)) throw I(_);
            return D.facade = B, g(B, S, D), D;
          }, d = function(B) {
            return C(B, S) ? B[S] : {};
          }, p = function(B) {
            return C(B, S);
          };
        }
        l.exports = { set: c, get: d, has: p, enforce: function(B) {
          return p(B) ? d(B) : c(B, {});
        }, getterFor: function(B) {
          return function(D) {
            var F;
            if (!y(D) || (F = d(D)).type !== B) throw I("Incompatible receiver, " + B + " required");
            return F;
          };
        } };
      }, 7659: function(l, v, s) {
        var c = s(5112), d = s(7497), p = c("iterator"), m = Array.prototype;
        l.exports = function(E) {
          return E !== void 0 && (d.Array === E || m[p] === E);
        };
      }, 3157: function(l, v, s) {
        var c = s(4326);
        l.exports = Array.isArray || function(d) {
          return c(d) == "Array";
        };
      }, 4067: function(l, v, s) {
        var c = s(648);
        l.exports = function(d) {
          var p = c(d);
          return p == "BigInt64Array" || p == "BigUint64Array";
        };
      }, 614: function(l, v, s) {
        var c = s(4154), d = c.all;
        l.exports = c.IS_HTMLDDA ? function(p) {
          return typeof p == "function" || p === d;
        } : function(p) {
          return typeof p == "function";
        };
      }, 4411: function(l, v, s) {
        var c = s(1702), d = s(7293), p = s(614), m = s(648), E = s(5005), y = s(2788), g = function() {
        }, C = [], O = E("Reflect", "construct"), N = /^\s*(?:class|function)\b/, w = c(N.exec), _ = !N.exec(g), I = function(H) {
          if (!p(H)) return !1;
          try {
            return O(g, C, H), !0;
          } catch {
            return !1;
          }
        }, k = function(H) {
          if (!p(H)) return !1;
          switch (m(H)) {
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
              return !1;
          }
          try {
            return _ || !!w(N, y(H));
          } catch {
            return !0;
          }
        };
        k.sham = !0, l.exports = !O || d(function() {
          var H;
          return I(I.call) || !I(Object) || !I(function() {
            H = !0;
          }) || H;
        }) ? k : I;
      }, 4705: function(l, v, s) {
        var c = s(7293), d = s(614), p = /#|\.prototype\./, m = function(O, N) {
          var w = y[E(O)];
          return w == C || w != g && (d(N) ? c(N) : !!N);
        }, E = m.normalize = function(O) {
          return String(O).replace(p, ".").toLowerCase();
        }, y = m.data = {}, g = m.NATIVE = "N", C = m.POLYFILL = "P";
        l.exports = m;
      }, 5988: function(l, v, s) {
        var c = s(111), d = Math.floor;
        l.exports = Number.isInteger || function(p) {
          return !c(p) && isFinite(p) && d(p) === p;
        };
      }, 8554: function(l) {
        l.exports = function(v) {
          return v == null;
        };
      }, 111: function(l, v, s) {
        var c = s(614), d = s(4154), p = d.all;
        l.exports = d.IS_HTMLDDA ? function(m) {
          return typeof m == "object" ? m !== null : c(m) || m === p;
        } : function(m) {
          return typeof m == "object" ? m !== null : c(m);
        };
      }, 1913: function(l) {
        l.exports = !1;
      }, 7850: function(l, v, s) {
        var c = s(111), d = s(4326), p = s(5112)("match");
        l.exports = function(m) {
          var E;
          return c(m) && ((E = m[p]) !== void 0 ? !!E : d(m) == "RegExp");
        };
      }, 2190: function(l, v, s) {
        var c = s(5005), d = s(614), p = s(7976), m = s(3307), E = Object;
        l.exports = m ? function(y) {
          return typeof y == "symbol";
        } : function(y) {
          var g = c("Symbol");
          return d(g) && p(g.prototype, E(y));
        };
      }, 408: function(l, v, s) {
        var c = s(9974), d = s(6916), p = s(9670), m = s(6330), E = s(7659), y = s(6244), g = s(7976), C = s(4121), O = s(1246), N = s(9212), w = TypeError, _ = function(k, H) {
          this.stopped = k, this.result = H;
        }, I = _.prototype;
        l.exports = function(k, H, S) {
          var B, D, F, j, G, U, M, V = S && S.that, J = !(!S || !S.AS_ENTRIES), ue = !(!S || !S.IS_RECORD), se = !(!S || !S.IS_ITERATOR), ee = !(!S || !S.INTERRUPTED), de = c(H, V), he = function(Ce) {
            return B && N(B, "normal", Ce), new _(!0, Ce);
          }, pe = function(Ce) {
            return J ? (p(Ce), ee ? de(Ce[0], Ce[1], he) : de(Ce[0], Ce[1])) : ee ? de(Ce, he) : de(Ce);
          };
          if (ue) B = k.iterator;
          else if (se) B = k;
          else {
            if (!(D = O(k))) throw w(m(k) + " is not iterable");
            if (E(D)) {
              for (F = 0, j = y(k); j > F; F++) if ((G = pe(k[F])) && g(I, G)) return G;
              return new _(!1);
            }
            B = C(k, D);
          }
          for (U = ue ? k.next : B.next; !(M = d(U, B)).done; ) {
            try {
              G = pe(M.value);
            } catch (Ce) {
              N(B, "throw", Ce);
            }
            if (typeof G == "object" && G && g(I, G)) return G;
          }
          return new _(!1);
        };
      }, 9212: function(l, v, s) {
        var c = s(6916), d = s(9670), p = s(8173);
        l.exports = function(m, E, y) {
          var g, C;
          d(m);
          try {
            if (!(g = p(m, "return"))) {
              if (E === "throw") throw y;
              return y;
            }
            g = c(g, m);
          } catch (O) {
            C = !0, g = O;
          }
          if (E === "throw") throw y;
          if (C) throw g;
          return d(g), y;
        };
      }, 3061: function(l, v, s) {
        var c = s(3383).IteratorPrototype, d = s(30), p = s(9114), m = s(8003), E = s(7497), y = function() {
          return this;
        };
        l.exports = function(g, C, O, N) {
          var w = C + " Iterator";
          return g.prototype = d(c, { next: p(+!N, O) }), m(g, w, !1, !0), E[w] = y, g;
        };
      }, 1656: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(1913), m = s(6530), E = s(614), y = s(3061), g = s(9518), C = s(7674), O = s(8003), N = s(8880), w = s(8052), _ = s(5112), I = s(7497), k = s(3383), H = m.PROPER, S = m.CONFIGURABLE, B = k.IteratorPrototype, D = k.BUGGY_SAFARI_ITERATORS, F = _("iterator"), j = "keys", G = "values", U = "entries", M = function() {
          return this;
        };
        l.exports = function(V, J, ue, se, ee, de, he) {
          y(ue, J, se);
          var pe, Ce, _e, Le = function($e) {
            if ($e === ee && xe) return xe;
            if (!D && $e in Oe) return Oe[$e];
            switch ($e) {
              case j:
              case G:
              case U:
                return function() {
                  return new ue(this, $e);
                };
            }
            return function() {
              return new ue(this);
            };
          }, Te = J + " Iterator", K = !1, Oe = V.prototype, Pe = Oe[F] || Oe["@@iterator"] || ee && Oe[ee], xe = !D && Pe || Le(ee), be = J == "Array" && Oe.entries || Pe;
          if (be && (pe = g(be.call(new V()))) !== Object.prototype && pe.next && (p || g(pe) === B || (C ? C(pe, B) : E(pe[F]) || w(pe, F, M)), O(pe, Te, !0, !0), p && (I[Te] = M)), H && ee == G && Pe && Pe.name !== G && (!p && S ? N(Oe, "name", G) : (K = !0, xe = function() {
            return d(Pe, this);
          })), ee) if (Ce = { values: Le(G), keys: de ? xe : Le(j), entries: Le(U) }, he) for (_e in Ce) (D || K || !(_e in Oe)) && w(Oe, _e, Ce[_e]);
          else c({ target: J, proto: !0, forced: D || K }, Ce);
          return p && !he || Oe[F] === xe || w(Oe, F, xe, { name: ee }), I[J] = xe, Ce;
        };
      }, 3383: function(l, v, s) {
        var c, d, p, m = s(7293), E = s(614), y = s(111), g = s(30), C = s(9518), O = s(8052), N = s(5112), w = s(1913), _ = N("iterator"), I = !1;
        [].keys && ("next" in (p = [].keys()) ? (d = C(C(p))) !== Object.prototype && (c = d) : I = !0), !y(c) || m(function() {
          var k = {};
          return c[_].call(k) !== k;
        }) ? c = {} : w && (c = g(c)), E(c[_]) || O(c, _, function() {
          return this;
        }), l.exports = { IteratorPrototype: c, BUGGY_SAFARI_ITERATORS: I };
      }, 7497: function(l) {
        l.exports = {};
      }, 6244: function(l, v, s) {
        var c = s(7466);
        l.exports = function(d) {
          return c(d.length);
        };
      }, 6339: function(l, v, s) {
        var c = s(1702), d = s(7293), p = s(614), m = s(2597), E = s(9781), y = s(6530).CONFIGURABLE, g = s(2788), C = s(9909), O = C.enforce, N = C.get, w = String, _ = Object.defineProperty, I = c("".slice), k = c("".replace), H = c([].join), S = E && !d(function() {
          return _(function() {
          }, "length", { value: 8 }).length !== 8;
        }), B = String(String).split("String"), D = l.exports = function(F, j, G) {
          I(w(j), 0, 7) === "Symbol(" && (j = "[" + k(w(j), /^Symbol\(([^)]*)\)/, "$1") + "]"), G && G.getter && (j = "get " + j), G && G.setter && (j = "set " + j), (!m(F, "name") || y && F.name !== j) && (E ? _(F, "name", { value: j, configurable: !0 }) : F.name = j), S && G && m(G, "arity") && F.length !== G.arity && _(F, "length", { value: G.arity });
          try {
            G && m(G, "constructor") && G.constructor ? E && _(F, "prototype", { writable: !1 }) : F.prototype && (F.prototype = void 0);
          } catch {
          }
          var U = O(F);
          return m(U, "source") || (U.source = H(B, typeof j == "string" ? j : "")), F;
        };
        Function.prototype.toString = D(function() {
          return p(this) && N(this).source || g(this);
        }, "toString");
      }, 4758: function(l) {
        var v = Math.ceil, s = Math.floor;
        l.exports = Math.trunc || function(c) {
          var d = +c;
          return (d > 0 ? s : v)(d);
        };
      }, 5948: function(l, v, s) {
        var c, d, p, m, E, y = s(7854), g = s(9974), C = s(1236).f, O = s(261).set, N = s(8572), w = s(6833), _ = s(1528), I = s(1036), k = s(5268), H = y.MutationObserver || y.WebKitMutationObserver, S = y.document, B = y.process, D = y.Promise, F = C(y, "queueMicrotask"), j = F && F.value;
        if (!j) {
          var G = new N(), U = function() {
            var M, V;
            for (k && (M = B.domain) && M.exit(); V = G.get(); ) try {
              V();
            } catch (J) {
              throw G.head && c(), J;
            }
            M && M.enter();
          };
          w || k || I || !H || !S ? !_ && D && D.resolve ? ((m = D.resolve(void 0)).constructor = D, E = g(m.then, m), c = function() {
            E(U);
          }) : k ? c = function() {
            B.nextTick(U);
          } : (O = g(O, y), c = function() {
            O(U);
          }) : (d = !0, p = S.createTextNode(""), new H(U).observe(p, { characterData: !0 }), c = function() {
            p.data = d = !d;
          }), j = function(M) {
            G.head || c(), G.add(M);
          };
        }
        l.exports = j;
      }, 8523: function(l, v, s) {
        var c = s(9662), d = TypeError, p = function(m) {
          var E, y;
          this.promise = new m(function(g, C) {
            if (E !== void 0 || y !== void 0) throw d("Bad Promise constructor");
            E = g, y = C;
          }), this.resolve = c(E), this.reject = c(y);
        };
        l.exports.f = function(m) {
          return new p(m);
        };
      }, 3929: function(l, v, s) {
        var c = s(7850), d = TypeError;
        l.exports = function(p) {
          if (c(p)) throw d("The method doesn't accept regular expressions");
          return p;
        };
      }, 1574: function(l, v, s) {
        var c = s(9781), d = s(1702), p = s(6916), m = s(7293), E = s(1956), y = s(5181), g = s(5296), C = s(7908), O = s(8361), N = Object.assign, w = Object.defineProperty, _ = d([].concat);
        l.exports = !N || m(function() {
          if (c && N({ b: 1 }, N(w({}, "a", { enumerable: !0, get: function() {
            w(this, "b", { value: 3, enumerable: !1 });
          } }), { b: 2 })).b !== 1) return !0;
          var I = {}, k = {}, H = Symbol(), S = "abcdefghijklmnopqrst";
          return I[H] = 7, S.split("").forEach(function(B) {
            k[B] = B;
          }), N({}, I)[H] != 7 || E(N({}, k)).join("") != S;
        }) ? function(I, k) {
          for (var H = C(I), S = arguments.length, B = 1, D = y.f, F = g.f; S > B; ) for (var j, G = O(arguments[B++]), U = D ? _(E(G), D(G)) : E(G), M = U.length, V = 0; M > V; ) j = U[V++], c && !p(F, G, j) || (H[j] = G[j]);
          return H;
        } : N;
      }, 30: function(l, v, s) {
        var c, d = s(9670), p = s(6048), m = s(748), E = s(3501), y = s(490), g = s(317), C = s(6200), O = "prototype", N = "script", w = C("IE_PROTO"), _ = function() {
        }, I = function(S) {
          return "<" + N + ">" + S + "</" + N + ">";
        }, k = function(S) {
          S.write(I("")), S.close();
          var B = S.parentWindow.Object;
          return S = null, B;
        }, H = function() {
          try {
            c = new ActiveXObject("htmlfile");
          } catch {
          }
          var S, B, D;
          H = typeof document < "u" ? document.domain && c ? k(c) : (B = g("iframe"), D = "java" + N + ":", B.style.display = "none", y.appendChild(B), B.src = String(D), (S = B.contentWindow.document).open(), S.write(I("document.F=Object")), S.close(), S.F) : k(c);
          for (var F = m.length; F--; ) delete H[O][m[F]];
          return H();
        };
        E[w] = !0, l.exports = Object.create || function(S, B) {
          var D;
          return S !== null ? (_[O] = d(S), D = new _(), _[O] = null, D[w] = S) : D = H(), B === void 0 ? D : p.f(D, B);
        };
      }, 6048: function(l, v, s) {
        var c = s(9781), d = s(3353), p = s(3070), m = s(9670), E = s(5656), y = s(1956);
        v.f = c && !d ? Object.defineProperties : function(g, C) {
          m(g);
          for (var O, N = E(C), w = y(C), _ = w.length, I = 0; _ > I; ) p.f(g, O = w[I++], N[O]);
          return g;
        };
      }, 3070: function(l, v, s) {
        var c = s(9781), d = s(4664), p = s(3353), m = s(9670), E = s(4948), y = TypeError, g = Object.defineProperty, C = Object.getOwnPropertyDescriptor, O = "enumerable", N = "configurable", w = "writable";
        v.f = c ? p ? function(_, I, k) {
          if (m(_), I = E(I), m(k), typeof _ == "function" && I === "prototype" && "value" in k && w in k && !k[w]) {
            var H = C(_, I);
            H && H[w] && (_[I] = k.value, k = { configurable: N in k ? k[N] : H[N], enumerable: O in k ? k[O] : H[O], writable: !1 });
          }
          return g(_, I, k);
        } : g : function(_, I, k) {
          if (m(_), I = E(I), m(k), d) try {
            return g(_, I, k);
          } catch {
          }
          if ("get" in k || "set" in k) throw y("Accessors not supported");
          return "value" in k && (_[I] = k.value), _;
        };
      }, 1236: function(l, v, s) {
        var c = s(9781), d = s(6916), p = s(5296), m = s(9114), E = s(5656), y = s(4948), g = s(2597), C = s(4664), O = Object.getOwnPropertyDescriptor;
        v.f = c ? O : function(N, w) {
          if (N = E(N), w = y(w), C) try {
            return O(N, w);
          } catch {
          }
          if (g(N, w)) return m(!d(p.f, N, w), N[w]);
        };
      }, 1156: function(l, v, s) {
        var c = s(4326), d = s(5656), p = s(8006).f, m = s(1589), E = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        l.exports.f = function(y) {
          return E && c(y) == "Window" ? function(g) {
            try {
              return p(g);
            } catch {
              return m(E);
            }
          }(y) : p(d(y));
        };
      }, 8006: function(l, v, s) {
        var c = s(6324), d = s(748).concat("length", "prototype");
        v.f = Object.getOwnPropertyNames || function(p) {
          return c(p, d);
        };
      }, 5181: function(l, v) {
        v.f = Object.getOwnPropertySymbols;
      }, 9518: function(l, v, s) {
        var c = s(2597), d = s(614), p = s(7908), m = s(6200), E = s(8544), y = m("IE_PROTO"), g = Object, C = g.prototype;
        l.exports = E ? g.getPrototypeOf : function(O) {
          var N = p(O);
          if (c(N, y)) return N[y];
          var w = N.constructor;
          return d(w) && N instanceof w ? w.prototype : N instanceof g ? C : null;
        };
      }, 2050: function(l, v, s) {
        var c = s(7293), d = s(111), p = s(4326), m = s(7556), E = Object.isExtensible, y = c(function() {
        });
        l.exports = y || m ? function(g) {
          return !!d(g) && (!m || p(g) != "ArrayBuffer") && (!E || E(g));
        } : E;
      }, 7976: function(l, v, s) {
        var c = s(1702);
        l.exports = c({}.isPrototypeOf);
      }, 6324: function(l, v, s) {
        var c = s(1702), d = s(2597), p = s(5656), m = s(1318).indexOf, E = s(3501), y = c([].push);
        l.exports = function(g, C) {
          var O, N = p(g), w = 0, _ = [];
          for (O in N) !d(E, O) && d(N, O) && y(_, O);
          for (; C.length > w; ) d(N, O = C[w++]) && (~m(_, O) || y(_, O));
          return _;
        };
      }, 1956: function(l, v, s) {
        var c = s(6324), d = s(748);
        l.exports = Object.keys || function(p) {
          return c(p, d);
        };
      }, 5296: function(l, v) {
        var s = {}.propertyIsEnumerable, c = Object.getOwnPropertyDescriptor, d = c && !s.call({ 1: 2 }, 1);
        v.f = d ? function(p) {
          var m = c(this, p);
          return !!m && m.enumerable;
        } : s;
      }, 7674: function(l, v, s) {
        var c = s(5668), d = s(9670), p = s(6077);
        l.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
          var m, E = !1, y = {};
          try {
            (m = c(Object.prototype, "__proto__", "set"))(y, []), E = y instanceof Array;
          } catch {
          }
          return function(g, C) {
            return d(g), p(C), E ? m(g, C) : g.__proto__ = C, g;
          };
        }() : void 0);
      }, 4699: function(l, v, s) {
        var c = s(9781), d = s(1702), p = s(1956), m = s(5656), E = d(s(5296).f), y = d([].push), g = function(C) {
          return function(O) {
            for (var N, w = m(O), _ = p(w), I = _.length, k = 0, H = []; I > k; ) N = _[k++], c && !E(w, N) || y(H, C ? [N, w[N]] : w[N]);
            return H;
          };
        };
        l.exports = { entries: g(!0), values: g(!1) };
      }, 288: function(l, v, s) {
        var c = s(1694), d = s(648);
        l.exports = c ? {}.toString : function() {
          return "[object " + d(this) + "]";
        };
      }, 2140: function(l, v, s) {
        var c = s(6916), d = s(614), p = s(111), m = TypeError;
        l.exports = function(E, y) {
          var g, C;
          if (y === "string" && d(g = E.toString) && !p(C = c(g, E)) || d(g = E.valueOf) && !p(C = c(g, E)) || y !== "string" && d(g = E.toString) && !p(C = c(g, E))) return C;
          throw m("Can't convert object to primitive value");
        };
      }, 3887: function(l, v, s) {
        var c = s(5005), d = s(1702), p = s(8006), m = s(5181), E = s(9670), y = d([].concat);
        l.exports = c("Reflect", "ownKeys") || function(g) {
          var C = p.f(E(g)), O = m.f;
          return O ? y(C, O(g)) : C;
        };
      }, 857: function(l, v, s) {
        var c = s(7854);
        l.exports = c;
      }, 2534: function(l) {
        l.exports = function(v) {
          try {
            return { error: !1, value: v() };
          } catch (s) {
            return { error: !0, value: s };
          }
        };
      }, 3702: function(l, v, s) {
        var c = s(7854), d = s(2492), p = s(614), m = s(4705), E = s(2788), y = s(5112), g = s(7871), C = s(3823), O = s(1913), N = s(7392), w = d && d.prototype, _ = y("species"), I = !1, k = p(c.PromiseRejectionEvent), H = m("Promise", function() {
          var S = E(d), B = S !== String(d);
          if (!B && N === 66 || O && (!w.catch || !w.finally)) return !0;
          if (!N || N < 51 || !/native code/.test(S)) {
            var D = new d(function(j) {
              j(1);
            }), F = function(j) {
              j(function() {
              }, function() {
              });
            };
            if ((D.constructor = {})[_] = F, !(I = D.then(function() {
            }) instanceof F)) return !0;
          }
          return !B && (g || C) && !k;
        });
        l.exports = { CONSTRUCTOR: H, REJECTION_EVENT: k, SUBCLASSING: I };
      }, 2492: function(l, v, s) {
        var c = s(7854);
        l.exports = c.Promise;
      }, 9478: function(l, v, s) {
        var c = s(9670), d = s(111), p = s(8523);
        l.exports = function(m, E) {
          if (c(m), d(E) && E.constructor === m) return E;
          var y = p.f(m);
          return (0, y.resolve)(E), y.promise;
        };
      }, 612: function(l, v, s) {
        var c = s(2492), d = s(7072), p = s(3702).CONSTRUCTOR;
        l.exports = p || !d(function(m) {
          c.all(m).then(void 0, function() {
          });
        });
      }, 8572: function(l) {
        var v = function() {
          this.head = null, this.tail = null;
        };
        v.prototype = { add: function(s) {
          var c = { item: s, next: null }, d = this.tail;
          d ? d.next = c : this.head = c, this.tail = c;
        }, get: function() {
          var s = this.head;
          if (s) return (this.head = s.next) === null && (this.tail = null), s.item;
        } }, l.exports = v;
      }, 7651: function(l, v, s) {
        var c = s(6916), d = s(9670), p = s(614), m = s(4326), E = s(2261), y = TypeError;
        l.exports = function(g, C) {
          var O = g.exec;
          if (p(O)) {
            var N = c(O, g, C);
            return N !== null && d(N), N;
          }
          if (m(g) === "RegExp") return c(E, g, C);
          throw y("RegExp#exec called on incompatible receiver");
        };
      }, 2261: function(l, v, s) {
        var c, d, p = s(6916), m = s(1702), E = s(1340), y = s(7066), g = s(2999), C = s(2309), O = s(30), N = s(9909).get, w = s(9441), _ = s(7168), I = C("native-string-replace", String.prototype.replace), k = RegExp.prototype.exec, H = k, S = m("".charAt), B = m("".indexOf), D = m("".replace), F = m("".slice), j = (d = /b*/g, p(k, c = /a/, "a"), p(k, d, "a"), c.lastIndex !== 0 || d.lastIndex !== 0), G = g.BROKEN_CARET, U = /()??/.exec("")[1] !== void 0;
        (j || U || G || w || _) && (H = function(M) {
          var V, J, ue, se, ee, de, he, pe = this, Ce = N(pe), _e = E(M), Le = Ce.raw;
          if (Le) return Le.lastIndex = pe.lastIndex, V = p(H, Le, _e), pe.lastIndex = Le.lastIndex, V;
          var Te = Ce.groups, K = G && pe.sticky, Oe = p(y, pe), Pe = pe.source, xe = 0, be = _e;
          if (K && (Oe = D(Oe, "y", ""), B(Oe, "g") === -1 && (Oe += "g"), be = F(_e, pe.lastIndex), pe.lastIndex > 0 && (!pe.multiline || pe.multiline && S(_e, pe.lastIndex - 1) !== `
`) && (Pe = "(?: " + Pe + ")", be = " " + be, xe++), J = new RegExp("^(?:" + Pe + ")", Oe)), U && (J = new RegExp("^" + Pe + "$(?!\\s)", Oe)), j && (ue = pe.lastIndex), se = p(k, K ? J : pe, be), K ? se ? (se.input = F(se.input, xe), se[0] = F(se[0], xe), se.index = pe.lastIndex, pe.lastIndex += se[0].length) : pe.lastIndex = 0 : j && se && (pe.lastIndex = pe.global ? se.index + se[0].length : ue), U && se && se.length > 1 && p(I, se[0], J, function() {
            for (ee = 1; ee < arguments.length - 2; ee++) arguments[ee] === void 0 && (se[ee] = void 0);
          }), se && Te) for (se.groups = de = O(null), ee = 0; ee < Te.length; ee++) de[(he = Te[ee])[0]] = se[he[1]];
          return se;
        }), l.exports = H;
      }, 7066: function(l, v, s) {
        var c = s(9670);
        l.exports = function() {
          var d = c(this), p = "";
          return d.hasIndices && (p += "d"), d.global && (p += "g"), d.ignoreCase && (p += "i"), d.multiline && (p += "m"), d.dotAll && (p += "s"), d.unicode && (p += "u"), d.unicodeSets && (p += "v"), d.sticky && (p += "y"), p;
        };
      }, 4706: function(l, v, s) {
        var c = s(6916), d = s(2597), p = s(7976), m = s(7066), E = RegExp.prototype;
        l.exports = function(y) {
          var g = y.flags;
          return g !== void 0 || "flags" in E || d(y, "flags") || !p(E, y) ? g : c(m, y);
        };
      }, 2999: function(l, v, s) {
        var c = s(7293), d = s(7854).RegExp, p = c(function() {
          var y = d("a", "y");
          return y.lastIndex = 2, y.exec("abcd") != null;
        }), m = p || c(function() {
          return !d("a", "y").sticky;
        }), E = p || c(function() {
          var y = d("^r", "gy");
          return y.lastIndex = 2, y.exec("str") != null;
        });
        l.exports = { BROKEN_CARET: E, MISSED_STICKY: m, UNSUPPORTED_Y: p };
      }, 9441: function(l, v, s) {
        var c = s(7293), d = s(7854).RegExp;
        l.exports = c(function() {
          var p = d(".", "s");
          return !(p.dotAll && p.exec(`
`) && p.flags === "s");
        });
      }, 7168: function(l, v, s) {
        var c = s(7293), d = s(7854).RegExp;
        l.exports = c(function() {
          var p = d("(?<a>b)", "g");
          return p.exec("b").groups.a !== "b" || "b".replace(p, "$<a>c") !== "bc";
        });
      }, 4488: function(l, v, s) {
        var c = s(8554), d = TypeError;
        l.exports = function(p) {
          if (c(p)) throw d("Can't call method on " + p);
          return p;
        };
      }, 7152: function(l, v, s) {
        var c, d = s(7854), p = s(2104), m = s(614), E = s(9363), y = s(8113), g = s(206), C = s(8053), O = d.Function, N = /MSIE .\./.test(y) || E && ((c = d.Bun.version.split(".")).length < 3 || c[0] == 0 && (c[1] < 3 || c[1] == 3 && c[2] == 0));
        l.exports = function(w, _) {
          var I = _ ? 2 : 1;
          return N ? function(k, H) {
            var S = C(arguments.length, 1) > I, B = m(k) ? k : O(k), D = S ? g(arguments, I) : [], F = S ? function() {
              p(B, this, D);
            } : B;
            return _ ? w(F, H) : w(F);
          } : w;
        };
      }, 6340: function(l, v, s) {
        var c = s(5005), d = s(7045), p = s(5112), m = s(9781), E = p("species");
        l.exports = function(y) {
          var g = c(y);
          m && g && !g[E] && d(g, E, { configurable: !0, get: function() {
            return this;
          } });
        };
      }, 8003: function(l, v, s) {
        var c = s(3070).f, d = s(2597), p = s(5112)("toStringTag");
        l.exports = function(m, E, y) {
          m && !y && (m = m.prototype), m && !d(m, p) && c(m, p, { configurable: !0, value: E });
        };
      }, 6200: function(l, v, s) {
        var c = s(2309), d = s(9711), p = c("keys");
        l.exports = function(m) {
          return p[m] || (p[m] = d(m));
        };
      }, 5465: function(l, v, s) {
        var c = s(7854), d = s(3072), p = "__core-js_shared__", m = c[p] || d(p, {});
        l.exports = m;
      }, 2309: function(l, v, s) {
        var c = s(1913), d = s(5465);
        (l.exports = function(p, m) {
          return d[p] || (d[p] = m !== void 0 ? m : {});
        })("versions", []).push({ version: "3.30.2", mode: c ? "pure" : "global", copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE", source: "https://github.com/zloirock/core-js" });
      }, 6707: function(l, v, s) {
        var c = s(9670), d = s(9483), p = s(8554), m = s(5112)("species");
        l.exports = function(E, y) {
          var g, C = c(E).constructor;
          return C === void 0 || p(g = c(C)[m]) ? y : d(g);
        };
      }, 8710: function(l, v, s) {
        var c = s(1702), d = s(9303), p = s(1340), m = s(4488), E = c("".charAt), y = c("".charCodeAt), g = c("".slice), C = function(O) {
          return function(N, w) {
            var _, I, k = p(m(N)), H = d(w), S = k.length;
            return H < 0 || H >= S ? O ? "" : void 0 : (_ = y(k, H)) < 55296 || _ > 56319 || H + 1 === S || (I = y(k, H + 1)) < 56320 || I > 57343 ? O ? E(k, H) : _ : O ? g(k, H, H + 2) : I - 56320 + (_ - 55296 << 10) + 65536;
          };
        };
        l.exports = { codeAt: C(!1), charAt: C(!0) };
      }, 3197: function(l, v, s) {
        var c = s(1702), d = 2147483647, p = /[^\0-\u007E]/, m = /[.\u3002\uFF0E\uFF61]/g, E = "Overflow: input needs wider integers to process", y = RangeError, g = c(m.exec), C = Math.floor, O = String.fromCharCode, N = c("".charCodeAt), w = c([].join), _ = c([].push), I = c("".replace), k = c("".split), H = c("".toLowerCase), S = function(F) {
          return F + 22 + 75 * (F < 26);
        }, B = function(F, j, G) {
          var U = 0;
          for (F = G ? C(F / 700) : F >> 1, F += C(F / j); F > 455; ) F = C(F / 35), U += 36;
          return C(U + 36 * F / (F + 38));
        }, D = function(F) {
          var j = [];
          F = function(K) {
            for (var Oe = [], Pe = 0, xe = K.length; Pe < xe; ) {
              var be = N(K, Pe++);
              if (be >= 55296 && be <= 56319 && Pe < xe) {
                var $e = N(K, Pe++);
                (64512 & $e) == 56320 ? _(Oe, ((1023 & be) << 10) + (1023 & $e) + 65536) : (_(Oe, be), Pe--);
              } else _(Oe, be);
            }
            return Oe;
          }(F);
          var G, U, M = F.length, V = 128, J = 0, ue = 72;
          for (G = 0; G < F.length; G++) (U = F[G]) < 128 && _(j, O(U));
          var se = j.length, ee = se;
          for (se && _(j, "-"); ee < M; ) {
            var de = d;
            for (G = 0; G < F.length; G++) (U = F[G]) >= V && U < de && (de = U);
            var he = ee + 1;
            if (de - V > C((d - J) / he)) throw y(E);
            for (J += (de - V) * he, V = de, G = 0; G < F.length; G++) {
              if ((U = F[G]) < V && ++J > d) throw y(E);
              if (U == V) {
                for (var pe = J, Ce = 36; ; ) {
                  var _e = Ce <= ue ? 1 : Ce >= ue + 26 ? 26 : Ce - ue;
                  if (pe < _e) break;
                  var Le = pe - _e, Te = 36 - _e;
                  _(j, O(S(_e + Le % Te))), pe = C(Le / Te), Ce += 36;
                }
                _(j, O(S(pe))), ue = B(J, he, ee == se), J = 0, ee++;
              }
            }
            J++, V++;
          }
          return w(j, "");
        };
        l.exports = function(F) {
          var j, G, U = [], M = k(I(H(F), m, "."), ".");
          for (j = 0; j < M.length; j++) G = M[j], _(U, g(p, G) ? "xn--" + D(G) : G);
          return w(U, ".");
        };
      }, 8415: function(l, v, s) {
        var c = s(9303), d = s(1340), p = s(4488), m = RangeError;
        l.exports = function(E) {
          var y = d(p(this)), g = "", C = c(E);
          if (C < 0 || C == 1 / 0) throw m("Wrong number of repetitions");
          for (; C > 0; (C >>>= 1) && (y += y)) 1 & C && (g += y);
          return g;
        };
      }, 3111: function(l, v, s) {
        var c = s(1702), d = s(4488), p = s(1340), m = s(1361), E = c("".replace), y = RegExp("^[" + m + "]+"), g = RegExp("(^|[^" + m + "])[" + m + "]+$"), C = function(O) {
          return function(N) {
            var w = p(d(N));
            return 1 & O && (w = E(w, y, "")), 2 & O && (w = E(w, g, "$1")), w;
          };
        };
        l.exports = { start: C(1), end: C(2), trim: C(3) };
      }, 6293: function(l, v, s) {
        var c = s(7392), d = s(7293), p = s(7854).String;
        l.exports = !!Object.getOwnPropertySymbols && !d(function() {
          var m = Symbol();
          return !p(m) || !(Object(m) instanceof Symbol) || !Symbol.sham && c && c < 41;
        });
      }, 6532: function(l, v, s) {
        var c = s(6916), d = s(5005), p = s(5112), m = s(8052);
        l.exports = function() {
          var E = d("Symbol"), y = E && E.prototype, g = y && y.valueOf, C = p("toPrimitive");
          y && !y[C] && m(y, C, function(O) {
            return c(g, this);
          }, { arity: 1 });
        };
      }, 2015: function(l, v, s) {
        var c = s(6293);
        l.exports = c && !!Symbol.for && !!Symbol.keyFor;
      }, 261: function(l, v, s) {
        var c, d, p, m, E = s(7854), y = s(2104), g = s(9974), C = s(614), O = s(2597), N = s(7293), w = s(490), _ = s(206), I = s(317), k = s(8053), H = s(6833), S = s(5268), B = E.setImmediate, D = E.clearImmediate, F = E.process, j = E.Dispatch, G = E.Function, U = E.MessageChannel, M = E.String, V = 0, J = {}, ue = "onreadystatechange";
        N(function() {
          c = E.location;
        });
        var se = function(pe) {
          if (O(J, pe)) {
            var Ce = J[pe];
            delete J[pe], Ce();
          }
        }, ee = function(pe) {
          return function() {
            se(pe);
          };
        }, de = function(pe) {
          se(pe.data);
        }, he = function(pe) {
          E.postMessage(M(pe), c.protocol + "//" + c.host);
        };
        B && D || (B = function(pe) {
          k(arguments.length, 1);
          var Ce = C(pe) ? pe : G(pe), _e = _(arguments, 1);
          return J[++V] = function() {
            y(Ce, void 0, _e);
          }, d(V), V;
        }, D = function(pe) {
          delete J[pe];
        }, S ? d = function(pe) {
          F.nextTick(ee(pe));
        } : j && j.now ? d = function(pe) {
          j.now(ee(pe));
        } : U && !H ? (m = (p = new U()).port2, p.port1.onmessage = de, d = g(m.postMessage, m)) : E.addEventListener && C(E.postMessage) && !E.importScripts && c && c.protocol !== "file:" && !N(he) ? (d = he, E.addEventListener("message", de, !1)) : d = ue in I("script") ? function(pe) {
          w.appendChild(I("script"))[ue] = function() {
            w.removeChild(this), se(pe);
          };
        } : function(pe) {
          setTimeout(ee(pe), 0);
        }), l.exports = { set: B, clear: D };
      }, 863: function(l, v, s) {
        var c = s(1702);
        l.exports = c(1 .valueOf);
      }, 1400: function(l, v, s) {
        var c = s(9303), d = Math.max, p = Math.min;
        l.exports = function(m, E) {
          var y = c(m);
          return y < 0 ? d(y + E, 0) : p(y, E);
        };
      }, 4599: function(l, v, s) {
        var c = s(7593), d = TypeError;
        l.exports = function(p) {
          var m = c(p, "number");
          if (typeof m == "number") throw d("Can't convert number to bigint");
          return BigInt(m);
        };
      }, 7067: function(l, v, s) {
        var c = s(9303), d = s(7466), p = RangeError;
        l.exports = function(m) {
          if (m === void 0) return 0;
          var E = c(m), y = d(E);
          if (E !== y) throw p("Wrong length or index");
          return y;
        };
      }, 5656: function(l, v, s) {
        var c = s(8361), d = s(4488);
        l.exports = function(p) {
          return c(d(p));
        };
      }, 9303: function(l, v, s) {
        var c = s(4758);
        l.exports = function(d) {
          var p = +d;
          return p != p || p === 0 ? 0 : c(p);
        };
      }, 7466: function(l, v, s) {
        var c = s(9303), d = Math.min;
        l.exports = function(p) {
          return p > 0 ? d(c(p), 9007199254740991) : 0;
        };
      }, 7908: function(l, v, s) {
        var c = s(4488), d = Object;
        l.exports = function(p) {
          return d(c(p));
        };
      }, 4590: function(l, v, s) {
        var c = s(3002), d = RangeError;
        l.exports = function(p, m) {
          var E = c(p);
          if (E % m) throw d("Wrong offset");
          return E;
        };
      }, 3002: function(l, v, s) {
        var c = s(9303), d = RangeError;
        l.exports = function(p) {
          var m = c(p);
          if (m < 0) throw d("The argument can't be less than 0");
          return m;
        };
      }, 7593: function(l, v, s) {
        var c = s(6916), d = s(111), p = s(2190), m = s(8173), E = s(2140), y = s(5112), g = TypeError, C = y("toPrimitive");
        l.exports = function(O, N) {
          if (!d(O) || p(O)) return O;
          var w, _ = m(O, C);
          if (_) {
            if (N === void 0 && (N = "default"), w = c(_, O, N), !d(w) || p(w)) return w;
            throw g("Can't convert object to primitive value");
          }
          return N === void 0 && (N = "number"), E(O, N);
        };
      }, 4948: function(l, v, s) {
        var c = s(7593), d = s(2190);
        l.exports = function(p) {
          var m = c(p, "string");
          return d(m) ? m : m + "";
        };
      }, 1694: function(l, v, s) {
        var c = {};
        c[s(5112)("toStringTag")] = "z", l.exports = String(c) === "[object z]";
      }, 1340: function(l, v, s) {
        var c = s(648), d = String;
        l.exports = function(p) {
          if (c(p) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
          return d(p);
        };
      }, 6330: function(l) {
        var v = String;
        l.exports = function(s) {
          try {
            return v(s);
          } catch {
            return "Object";
          }
        };
      }, 9843: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(6916), m = s(9781), E = s(3832), y = s(260), g = s(3331), C = s(5787), O = s(9114), N = s(8880), w = s(5988), _ = s(7466), I = s(7067), k = s(4590), H = s(4948), S = s(2597), B = s(648), D = s(111), F = s(2190), j = s(30), G = s(7976), U = s(7674), M = s(8006).f, V = s(7321), J = s(2092).forEach, ue = s(6340), se = s(7045), ee = s(3070), de = s(1236), he = s(9909), pe = s(9587), Ce = he.get, _e = he.set, Le = he.enforce, Te = ee.f, K = de.f, Oe = Math.round, Pe = d.RangeError, xe = g.ArrayBuffer, be = xe.prototype, $e = g.DataView, Be = y.NATIVE_ARRAY_BUFFER_VIEWS, Ke = y.TYPED_ARRAY_TAG, Ze = y.TypedArray, at = y.TypedArrayPrototype, pt = y.aTypedArrayConstructor, It = y.isTypedArray, Rt = "BYTES_PER_ELEMENT", gt = "Wrong length", it = function(wt, Et) {
          pt(wt);
          for (var ut = 0, St = Et.length, Ft = new wt(St); St > ut; ) Ft[ut] = Et[ut++];
          return Ft;
        }, Tt = function(wt, Et) {
          se(wt, Et, { configurable: !0, get: function() {
            return Ce(this)[Et];
          } });
        }, Ut = function(wt) {
          var Et;
          return G(be, wt) || (Et = B(wt)) == "ArrayBuffer" || Et == "SharedArrayBuffer";
        }, st = function(wt, Et) {
          return It(wt) && !F(Et) && Et in wt && w(+Et) && Et >= 0;
        }, Ot = function(wt, Et) {
          return Et = H(Et), st(wt, Et) ? O(2, wt[Et]) : K(wt, Et);
        }, kt = function(wt, Et, ut) {
          return Et = H(Et), !(st(wt, Et) && D(ut) && S(ut, "value")) || S(ut, "get") || S(ut, "set") || ut.configurable || S(ut, "writable") && !ut.writable || S(ut, "enumerable") && !ut.enumerable ? Te(wt, Et, ut) : (wt[Et] = ut.value, wt);
        };
        m ? (Be || (de.f = Ot, ee.f = kt, Tt(at, "buffer"), Tt(at, "byteOffset"), Tt(at, "byteLength"), Tt(at, "length")), c({ target: "Object", stat: !0, forced: !Be }, { getOwnPropertyDescriptor: Ot, defineProperty: kt }), l.exports = function(wt, Et, ut) {
          var St = wt.match(/\d+/)[0] / 8, Ft = wt + (ut ? "Clamped" : "") + "Array", Ht = "get" + wt, zt = "set" + wt, ze = d[Ft], Ne = ze, le = Ne && Ne.prototype, X = {}, re = function(Se, ke) {
            Te(Se, ke, { get: function() {
              return function(Ge, nt) {
                var rt = Ce(Ge);
                return rt.view[Ht](nt * St + rt.byteOffset, !0);
              }(this, ke);
            }, set: function(Ge) {
              return function(nt, rt, dt) {
                var lt = Ce(nt);
                ut && (dt = (dt = Oe(dt)) < 0 ? 0 : dt > 255 ? 255 : 255 & dt), lt.view[zt](rt * St + lt.byteOffset, dt, !0);
              }(this, ke, Ge);
            }, enumerable: !0 });
          };
          Be ? E && (Ne = Et(function(Se, ke, Ge, nt) {
            return C(Se, le), pe(D(ke) ? Ut(ke) ? nt !== void 0 ? new ze(ke, k(Ge, St), nt) : Ge !== void 0 ? new ze(ke, k(Ge, St)) : new ze(ke) : It(ke) ? it(Ne, ke) : p(V, Ne, ke) : new ze(I(ke)), Se, Ne);
          }), U && U(Ne, Ze), J(M(ze), function(Se) {
            Se in Ne || N(Ne, Se, ze[Se]);
          }), Ne.prototype = le) : (Ne = Et(function(Se, ke, Ge, nt) {
            C(Se, le);
            var rt, dt, lt, Ct = 0, Ie = 0;
            if (D(ke)) {
              if (!Ut(ke)) return It(ke) ? it(Ne, ke) : p(V, Ne, ke);
              rt = ke, Ie = k(Ge, St);
              var x = ke.byteLength;
              if (nt === void 0) {
                if (x % St || (dt = x - Ie) < 0) throw Pe(gt);
              } else if ((dt = _(nt) * St) + Ie > x) throw Pe(gt);
              lt = dt / St;
            } else lt = I(ke), rt = new xe(dt = lt * St);
            for (_e(Se, { buffer: rt, byteOffset: Ie, byteLength: dt, length: lt, view: new $e(rt) }); Ct < lt; ) re(Se, Ct++);
          }), U && U(Ne, Ze), le = Ne.prototype = j(at)), le.constructor !== Ne && N(le, "constructor", Ne), Le(le).TypedArrayConstructor = Ne, Ke && N(le, Ke, Ft);
          var Me = Ne != ze;
          X[Ft] = Ne, c({ global: !0, constructor: !0, forced: Me, sham: !Be }, X), Rt in Ne || N(Ne, Rt, St), Rt in le || N(le, Rt, St), ue(Ft);
        }) : l.exports = function() {
        };
      }, 3832: function(l, v, s) {
        var c = s(7854), d = s(7293), p = s(7072), m = s(260).NATIVE_ARRAY_BUFFER_VIEWS, E = c.ArrayBuffer, y = c.Int8Array;
        l.exports = !m || !d(function() {
          y(1);
        }) || !d(function() {
          new y(-1);
        }) || !p(function(g) {
          new y(), new y(null), new y(1.5), new y(g);
        }, !0) || d(function() {
          return new y(new E(2), 1, void 0).length !== 1;
        });
      }, 3074: function(l, v, s) {
        var c = s(7745), d = s(6304);
        l.exports = function(p, m) {
          return c(d(p), m);
        };
      }, 7321: function(l, v, s) {
        var c = s(9974), d = s(6916), p = s(9483), m = s(7908), E = s(6244), y = s(4121), g = s(1246), C = s(7659), O = s(4067), N = s(260).aTypedArrayConstructor, w = s(4599);
        l.exports = function(_) {
          var I, k, H, S, B, D, F, j, G = p(this), U = m(_), M = arguments.length, V = M > 1 ? arguments[1] : void 0, J = V !== void 0, ue = g(U);
          if (ue && !C(ue)) for (j = (F = y(U, ue)).next, U = []; !(D = d(j, F)).done; ) U.push(D.value);
          for (J && M > 2 && (V = c(V, arguments[2])), k = E(U), H = new (N(G))(k), S = O(H), I = 0; k > I; I++) B = J ? V(U[I], I) : U[I], H[I] = S ? w(B) : +B;
          return H;
        };
      }, 6304: function(l, v, s) {
        var c = s(260), d = s(6707), p = c.aTypedArrayConstructor, m = c.getTypedArrayConstructor;
        l.exports = function(E) {
          return p(d(E, m(E)));
        };
      }, 9711: function(l, v, s) {
        var c = s(1702), d = 0, p = Math.random(), m = c(1 .toString);
        l.exports = function(E) {
          return "Symbol(" + (E === void 0 ? "" : E) + ")_" + m(++d + p, 36);
        };
      }, 5143: function(l, v, s) {
        var c = s(7293), d = s(5112), p = s(9781), m = s(1913), E = d("iterator");
        l.exports = !c(function() {
          var y = new URL("b?a=1&b=2&c=3", "http://a"), g = y.searchParams, C = "";
          return y.pathname = "c%20d", g.forEach(function(O, N) {
            g.delete("b"), C += N + O;
          }), m && !y.toJSON || !g.size && (m || !p) || !g.sort || y.href !== "http://a/c%20d?a=1&c=3" || g.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !g[E] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || C !== "a1c3" || new URL("http://x", void 0).host !== "x";
        });
      }, 3307: function(l, v, s) {
        var c = s(6293);
        l.exports = c && !Symbol.sham && typeof Symbol.iterator == "symbol";
      }, 3353: function(l, v, s) {
        var c = s(9781), d = s(7293);
        l.exports = c && d(function() {
          return Object.defineProperty(function() {
          }, "prototype", { value: 42, writable: !1 }).prototype != 42;
        });
      }, 8053: function(l) {
        var v = TypeError;
        l.exports = function(s, c) {
          if (s < c) throw v("Not enough arguments");
          return s;
        };
      }, 4811: function(l, v, s) {
        var c = s(7854), d = s(614), p = c.WeakMap;
        l.exports = d(p) && /native code/.test(String(p));
      }, 6800: function(l, v, s) {
        var c = s(857), d = s(2597), p = s(6061), m = s(3070).f;
        l.exports = function(E) {
          var y = c.Symbol || (c.Symbol = {});
          d(y, E) || m(y, E, { value: p.f(E) });
        };
      }, 6061: function(l, v, s) {
        var c = s(5112);
        v.f = c;
      }, 5112: function(l, v, s) {
        var c = s(7854), d = s(2309), p = s(2597), m = s(9711), E = s(6293), y = s(3307), g = c.Symbol, C = d("wks"), O = y ? g.for || g : g && g.withoutSetter || m;
        l.exports = function(N) {
          return p(C, N) || (C[N] = E && p(g, N) ? g[N] : O("Symbol." + N)), C[N];
        };
      }, 1361: function(l) {
        l.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
      }, 9575: function(l, v, s) {
        var c = s(2109), d = s(1470), p = s(7293), m = s(3331), E = s(9670), y = s(1400), g = s(7466), C = s(6707), O = m.ArrayBuffer, N = m.DataView, w = N.prototype, _ = d(O.prototype.slice), I = d(w.getUint8), k = d(w.setUint8);
        c({ target: "ArrayBuffer", proto: !0, unsafe: !0, forced: p(function() {
          return !new O(2).slice(1, void 0).byteLength;
        }) }, { slice: function(H, S) {
          if (_ && S === void 0) return _(E(this), H);
          for (var B = E(this).byteLength, D = y(H, B), F = y(S === void 0 ? B : S, B), j = new (C(this, O))(g(F - D)), G = new N(this), U = new N(j), M = 0; D < F; ) k(U, M++, I(G, D++));
          return j;
        } });
      }, 2222: function(l, v, s) {
        var c = s(2109), d = s(7293), p = s(3157), m = s(111), E = s(7908), y = s(6244), g = s(7207), C = s(6135), O = s(5417), N = s(1194), w = s(5112), _ = s(7392), I = w("isConcatSpreadable"), k = _ >= 51 || !d(function() {
          var S = [];
          return S[I] = !1, S.concat()[0] !== S;
        }), H = function(S) {
          if (!m(S)) return !1;
          var B = S[I];
          return B !== void 0 ? !!B : p(S);
        };
        c({ target: "Array", proto: !0, arity: 1, forced: !k || !N("concat") }, { concat: function(S) {
          var B, D, F, j, G, U = E(this), M = O(U, 0), V = 0;
          for (B = -1, F = arguments.length; B < F; B++) if (H(G = B === -1 ? U : arguments[B])) for (j = y(G), g(V + j), D = 0; D < j; D++, V++) D in G && C(M, V, G[D]);
          else g(V + 1), C(M, V++, G);
          return M.length = V, M;
        } });
      }, 7327: function(l, v, s) {
        var c = s(2109), d = s(2092).filter;
        c({ target: "Array", proto: !0, forced: !s(1194)("filter") }, { filter: function(p) {
          return d(this, p, arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 4553: function(l, v, s) {
        var c = s(2109), d = s(2092).findIndex, p = s(1223), m = "findIndex", E = !0;
        m in [] && Array(1)[m](function() {
          E = !1;
        }), c({ target: "Array", proto: !0, forced: E }, { findIndex: function(y) {
          return d(this, y, arguments.length > 1 ? arguments[1] : void 0);
        } }), p(m);
      }, 9826: function(l, v, s) {
        var c = s(2109), d = s(2092).find, p = s(1223), m = "find", E = !0;
        m in [] && Array(1)[m](function() {
          E = !1;
        }), c({ target: "Array", proto: !0, forced: E }, { find: function(y) {
          return d(this, y, arguments.length > 1 ? arguments[1] : void 0);
        } }), p(m);
      }, 9554: function(l, v, s) {
        var c = s(2109), d = s(8533);
        c({ target: "Array", proto: !0, forced: [].forEach != d }, { forEach: d });
      }, 1038: function(l, v, s) {
        var c = s(2109), d = s(8457);
        c({ target: "Array", stat: !0, forced: !s(7072)(function(p) {
          Array.from(p);
        }) }, { from: d });
      }, 6699: function(l, v, s) {
        var c = s(2109), d = s(1318).includes, p = s(7293), m = s(1223);
        c({ target: "Array", proto: !0, forced: p(function() {
          return !Array(1).includes();
        }) }, { includes: function(E) {
          return d(this, E, arguments.length > 1 ? arguments[1] : void 0);
        } }), m("includes");
      }, 2772: function(l, v, s) {
        var c = s(2109), d = s(1470), p = s(1318).indexOf, m = s(9341), E = d([].indexOf), y = !!E && 1 / E([1], 1, -0) < 0;
        c({ target: "Array", proto: !0, forced: y || !m("indexOf") }, { indexOf: function(g) {
          var C = arguments.length > 1 ? arguments[1] : void 0;
          return y ? E(this, g, C) || 0 : p(this, g, C);
        } });
      }, 9753: function(l, v, s) {
        s(2109)({ target: "Array", stat: !0 }, { isArray: s(3157) });
      }, 6992: function(l, v, s) {
        var c = s(5656), d = s(1223), p = s(7497), m = s(9909), E = s(3070).f, y = s(1656), g = s(6178), C = s(1913), O = s(9781), N = "Array Iterator", w = m.set, _ = m.getterFor(N);
        l.exports = y(Array, "Array", function(k, H) {
          w(this, { type: N, target: c(k), index: 0, kind: H });
        }, function() {
          var k = _(this), H = k.target, S = k.kind, B = k.index++;
          return !H || B >= H.length ? (k.target = void 0, g(void 0, !0)) : g(S == "keys" ? B : S == "values" ? H[B] : [B, H[B]], !1);
        }, "values");
        var I = p.Arguments = p.Array;
        if (d("keys"), d("values"), d("entries"), !C && O && I.name !== "values") try {
          E(I, "name", { value: "values" });
        } catch {
        }
      }, 9600: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(8361), m = s(5656), E = s(9341), y = d([].join);
        c({ target: "Array", proto: !0, forced: p != Object || !E("join", ",") }, { join: function(g) {
          return y(m(this), g === void 0 ? "," : g);
        } });
      }, 4986: function(l, v, s) {
        var c = s(2109), d = s(6583);
        c({ target: "Array", proto: !0, forced: d !== [].lastIndexOf }, { lastIndexOf: d });
      }, 1249: function(l, v, s) {
        var c = s(2109), d = s(2092).map;
        c({ target: "Array", proto: !0, forced: !s(1194)("map") }, { map: function(p) {
          return d(this, p, arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 5827: function(l, v, s) {
        var c = s(2109), d = s(3671).left, p = s(9341), m = s(7392);
        c({ target: "Array", proto: !0, forced: !s(5268) && m > 79 && m < 83 || !p("reduce") }, { reduce: function(E) {
          var y = arguments.length;
          return d(this, E, y, y > 1 ? arguments[1] : void 0);
        } });
      }, 5069: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(3157), m = d([].reverse), E = [1, 2];
        c({ target: "Array", proto: !0, forced: String(E) === String(E.reverse()) }, { reverse: function() {
          return p(this) && (this.length = this.length), m(this);
        } });
      }, 7042: function(l, v, s) {
        var c = s(2109), d = s(3157), p = s(4411), m = s(111), E = s(1400), y = s(6244), g = s(5656), C = s(6135), O = s(5112), N = s(1194), w = s(206), _ = N("slice"), I = O("species"), k = Array, H = Math.max;
        c({ target: "Array", proto: !0, forced: !_ }, { slice: function(S, B) {
          var D, F, j, G = g(this), U = y(G), M = E(S, U), V = E(B === void 0 ? U : B, U);
          if (d(G) && (D = G.constructor, (p(D) && (D === k || d(D.prototype)) || m(D) && (D = D[I]) === null) && (D = void 0), D === k || D === void 0)) return w(G, M, V);
          for (F = new (D === void 0 ? k : D)(H(V - M, 0)), j = 0; M < V; M++, j++) M in G && C(F, j, G[M]);
          return F.length = j, F;
        } });
      }, 5212: function(l, v, s) {
        var c = s(2109), d = s(2092).some;
        c({ target: "Array", proto: !0, forced: !s(9341)("some") }, { some: function(p) {
          return d(this, p, arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 561: function(l, v, s) {
        var c = s(2109), d = s(7908), p = s(1400), m = s(9303), E = s(6244), y = s(3658), g = s(7207), C = s(5417), O = s(6135), N = s(5117), w = s(1194)("splice"), _ = Math.max, I = Math.min;
        c({ target: "Array", proto: !0, forced: !w }, { splice: function(k, H) {
          var S, B, D, F, j, G, U = d(this), M = E(U), V = p(k, M), J = arguments.length;
          for (J === 0 ? S = B = 0 : J === 1 ? (S = 0, B = M - V) : (S = J - 2, B = I(_(m(H), 0), M - V)), g(M + S - B), D = C(U, B), F = 0; F < B; F++) (j = V + F) in U && O(D, F, U[j]);
          if (D.length = B, S < B) {
            for (F = V; F < M - B; F++) G = F + S, (j = F + B) in U ? U[G] = U[j] : N(U, G);
            for (F = M; F > M - B + S; F--) N(U, F - 1);
          } else if (S > B) for (F = M - B; F > V; F--) G = F + S - 1, (j = F + B - 1) in U ? U[G] = U[j] : N(U, G);
          for (F = 0; F < S; F++) U[F + V] = arguments[F + 2];
          return y(U, M - B + S), D;
        } });
      }, 3843: function(l, v, s) {
        var c = s(2109), d = s(1702), p = Date, m = d(p.prototype.getTime);
        c({ target: "Date", stat: !0 }, { now: function() {
          return m(new p());
        } });
      }, 3710: function(l, v, s) {
        var c = s(1702), d = s(8052), p = Date.prototype, m = "Invalid Date", E = "toString", y = c(p[E]), g = c(p.getTime);
        String(/* @__PURE__ */ new Date(NaN)) != m && d(p, E, function() {
          var C = g(this);
          return C == C ? y(this) : m;
        });
      }, 4812: function(l, v, s) {
        var c = s(2109), d = s(7065);
        c({ target: "Function", proto: !0, forced: Function.bind !== d }, { bind: d });
      }, 8309: function(l, v, s) {
        var c = s(9781), d = s(6530).EXISTS, p = s(1702), m = s(7045), E = Function.prototype, y = p(E.toString), g = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, C = p(g.exec);
        c && !d && m(E, "name", { configurable: !0, get: function() {
          try {
            return C(g, y(this))[1];
          } catch {
            return "";
          }
        } });
      }, 8862: function(l, v, s) {
        var c = s(2109), d = s(5005), p = s(2104), m = s(6916), E = s(1702), y = s(7293), g = s(614), C = s(2190), O = s(206), N = s(8044), w = s(6293), _ = String, I = d("JSON", "stringify"), k = E(/./.exec), H = E("".charAt), S = E("".charCodeAt), B = E("".replace), D = E(1 .toString), F = /[\uD800-\uDFFF]/g, j = /^[\uD800-\uDBFF]$/, G = /^[\uDC00-\uDFFF]$/, U = !w || y(function() {
          var ue = d("Symbol")();
          return I([ue]) != "[null]" || I({ a: ue }) != "{}" || I(Object(ue)) != "{}";
        }), M = y(function() {
          return I("\uDF06\uD834") !== '"\\udf06\\ud834"' || I("\uDEAD") !== '"\\udead"';
        }), V = function(ue, se) {
          var ee = O(arguments), de = N(se);
          if (g(de) || ue !== void 0 && !C(ue)) return ee[1] = function(he, pe) {
            if (g(de) && (pe = m(de, this, _(he), pe)), !C(pe)) return pe;
          }, p(I, null, ee);
        }, J = function(ue, se, ee) {
          var de = H(ee, se - 1), he = H(ee, se + 1);
          return k(j, ue) && !k(G, he) || k(G, ue) && !k(j, de) ? "\\u" + D(S(ue, 0), 16) : ue;
        };
        I && c({ target: "JSON", stat: !0, arity: 3, forced: U || M }, { stringify: function(ue, se, ee) {
          var de = O(arguments), he = p(U ? V : I, null, de);
          return M && typeof he == "string" ? B(he, F, J) : he;
        } });
      }, 9098: function(l, v, s) {
        s(7710)("Map", function(c) {
          return function() {
            return c(this, arguments.length ? arguments[0] : void 0);
          };
        }, s(5631));
      }, 1532: function(l, v, s) {
        s(9098);
      }, 9653: function(l, v, s) {
        var c = s(2109), d = s(1913), p = s(9781), m = s(7854), E = s(857), y = s(1702), g = s(4705), C = s(2597), O = s(9587), N = s(7976), w = s(2190), _ = s(7593), I = s(7293), k = s(8006).f, H = s(1236).f, S = s(3070).f, B = s(863), D = s(3111).trim, F = "Number", j = m[F], G = E[F], U = j.prototype, M = m.TypeError, V = y("".slice), J = y("".charCodeAt), ue = g(F, !j(" 0o1") || !j("0b1") || j("+0x1")), se = function(de) {
          var he, pe = arguments.length < 1 ? 0 : j(function(Ce) {
            var _e = _(Ce, "number");
            return typeof _e == "bigint" ? _e : function(Le) {
              var Te, K, Oe, Pe, xe, be, $e, Be, Ke = _(Le, "number");
              if (w(Ke)) throw M("Cannot convert a Symbol value to a number");
              if (typeof Ke == "string" && Ke.length > 2) {
                if (Ke = D(Ke), (Te = J(Ke, 0)) === 43 || Te === 45) {
                  if ((K = J(Ke, 2)) === 88 || K === 120) return NaN;
                } else if (Te === 48) {
                  switch (J(Ke, 1)) {
                    case 66:
                    case 98:
                      Oe = 2, Pe = 49;
                      break;
                    case 79:
                    case 111:
                      Oe = 8, Pe = 55;
                      break;
                    default:
                      return +Ke;
                  }
                  for (be = (xe = V(Ke, 2)).length, $e = 0; $e < be; $e++) if ((Be = J(xe, $e)) < 48 || Be > Pe) return NaN;
                  return parseInt(xe, Oe);
                }
              }
              return +Ke;
            }(_e);
          }(de));
          return N(U, he = this) && I(function() {
            B(he);
          }) ? O(Object(pe), this, se) : pe;
        };
        se.prototype = U, ue && !d && (U.constructor = se), c({ global: !0, constructor: !0, wrap: !0, forced: ue }, { Number: se });
        var ee = function(de, he) {
          for (var pe, Ce = p ? k(he) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), _e = 0; Ce.length > _e; _e++) C(he, pe = Ce[_e]) && !C(de, pe) && S(de, pe, H(he, pe));
        };
        d && G && ee(E[F], G), (ue || d) && ee(E[F], j);
      }, 3161: function(l, v, s) {
        s(2109)({ target: "Number", stat: !0 }, { isInteger: s(5988) });
      }, 4048: function(l, v, s) {
        s(2109)({ target: "Number", stat: !0 }, { isNaN: function(c) {
          return c != c;
        } });
      }, 6977: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(9303), m = s(863), E = s(8415), y = s(7293), g = RangeError, C = String, O = Math.floor, N = d(E), w = d("".slice), _ = d(1 .toFixed), I = function(B, D, F) {
          return D === 0 ? F : D % 2 == 1 ? I(B, D - 1, F * B) : I(B * B, D / 2, F);
        }, k = function(B, D, F) {
          for (var j = -1, G = F; ++j < 6; ) G += D * B[j], B[j] = G % 1e7, G = O(G / 1e7);
        }, H = function(B, D) {
          for (var F = 6, j = 0; --F >= 0; ) j += B[F], B[F] = O(j / D), j = j % D * 1e7;
        }, S = function(B) {
          for (var D = 6, F = ""; --D >= 0; ) if (F !== "" || D === 0 || B[D] !== 0) {
            var j = C(B[D]);
            F = F === "" ? j : F + N("0", 7 - j.length) + j;
          }
          return F;
        };
        c({ target: "Number", proto: !0, forced: y(function() {
          return _(8e-5, 3) !== "0.000" || _(0.9, 0) !== "1" || _(1.255, 2) !== "1.25" || _(1000000000000000100, 0) !== "1000000000000000128";
        }) || !y(function() {
          _({});
        }) }, { toFixed: function(B) {
          var D, F, j, G, U = m(this), M = p(B), V = [0, 0, 0, 0, 0, 0], J = "", ue = "0";
          if (M < 0 || M > 20) throw g("Incorrect fraction digits");
          if (U != U) return "NaN";
          if (U <= -1e21 || U >= 1e21) return C(U);
          if (U < 0 && (J = "-", U = -U), U > 1e-21) if (F = (D = function(se) {
            for (var ee = 0, de = se; de >= 4096; ) ee += 12, de /= 4096;
            for (; de >= 2; ) ee += 1, de /= 2;
            return ee;
          }(U * I(2, 69, 1)) - 69) < 0 ? U * I(2, -D, 1) : U / I(2, D, 1), F *= 4503599627370496, (D = 52 - D) > 0) {
            for (k(V, 0, F), j = M; j >= 7; ) k(V, 1e7, 0), j -= 7;
            for (k(V, I(10, j, 1), 0), j = D - 1; j >= 23; ) H(V, 8388608), j -= 23;
            H(V, 1 << j), k(V, 1, 1), H(V, 2), ue = S(V);
          } else k(V, 0, F), k(V, 1 << -D, 0), ue = S(V) + N("0", M);
          return M > 0 ? J + ((G = ue.length) <= M ? "0." + N("0", M - G) + ue : w(ue, 0, G - M) + "." + w(ue, G - M)) : J + ue;
        } });
      }, 9601: function(l, v, s) {
        var c = s(2109), d = s(1574);
        c({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== d }, { assign: d });
      }, 9070: function(l, v, s) {
        var c = s(2109), d = s(9781), p = s(3070).f;
        c({ target: "Object", stat: !0, forced: Object.defineProperty !== p, sham: !d }, { defineProperty: p });
      }, 9720: function(l, v, s) {
        var c = s(2109), d = s(4699).entries;
        c({ target: "Object", stat: !0 }, { entries: function(p) {
          return d(p);
        } });
      }, 9660: function(l, v, s) {
        var c = s(2109), d = s(6293), p = s(7293), m = s(5181), E = s(7908);
        c({ target: "Object", stat: !0, forced: !d || p(function() {
          m.f(1);
        }) }, { getOwnPropertySymbols: function(y) {
          var g = m.f;
          return g ? g(E(y)) : [];
        } });
      }, 7941: function(l, v, s) {
        var c = s(2109), d = s(7908), p = s(1956);
        c({ target: "Object", stat: !0, forced: s(7293)(function() {
          p(1);
        }) }, { keys: function(m) {
          return p(d(m));
        } });
      }, 1539: function(l, v, s) {
        var c = s(1694), d = s(8052), p = s(288);
        c || d(Object.prototype, "toString", p, { unsafe: !0 });
      }, 821: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(9662), m = s(8523), E = s(2534), y = s(408);
        c({ target: "Promise", stat: !0, forced: s(612) }, { all: function(g) {
          var C = this, O = m.f(C), N = O.resolve, w = O.reject, _ = E(function() {
            var I = p(C.resolve), k = [], H = 0, S = 1;
            y(g, function(B) {
              var D = H++, F = !1;
              S++, d(I, C, B).then(function(j) {
                F || (F = !0, k[D] = j, --S || N(k));
              }, w);
            }), --S || N(k);
          });
          return _.error && w(_.value), O.promise;
        } });
      }, 4164: function(l, v, s) {
        var c = s(2109), d = s(1913), p = s(3702).CONSTRUCTOR, m = s(2492), E = s(5005), y = s(614), g = s(8052), C = m && m.prototype;
        if (c({ target: "Promise", proto: !0, forced: p, real: !0 }, { catch: function(N) {
          return this.then(void 0, N);
        } }), !d && y(m)) {
          var O = E("Promise").prototype.catch;
          C.catch !== O && g(C, "catch", O, { unsafe: !0 });
        }
      }, 3401: function(l, v, s) {
        var c, d, p, m = s(2109), E = s(1913), y = s(5268), g = s(7854), C = s(6916), O = s(8052), N = s(7674), w = s(8003), _ = s(6340), I = s(9662), k = s(614), H = s(111), S = s(5787), B = s(6707), D = s(261).set, F = s(5948), j = s(842), G = s(2534), U = s(8572), M = s(9909), V = s(2492), J = s(3702), ue = s(8523), se = "Promise", ee = J.CONSTRUCTOR, de = J.REJECTION_EVENT, he = J.SUBCLASSING, pe = M.getterFor(se), Ce = M.set, _e = V && V.prototype, Le = V, Te = _e, K = g.TypeError, Oe = g.document, Pe = g.process, xe = ue.f, be = xe, $e = !!(Oe && Oe.createEvent && g.dispatchEvent), Be = "unhandledrejection", Ke = function(st) {
          var Ot;
          return !(!H(st) || !k(Ot = st.then)) && Ot;
        }, Ze = function(st, Ot) {
          var kt, wt, Et, ut = Ot.value, St = Ot.state == 1, Ft = St ? st.ok : st.fail, Ht = st.resolve, zt = st.reject, ze = st.domain;
          try {
            Ft ? (St || (Ot.rejection === 2 && gt(Ot), Ot.rejection = 1), Ft === !0 ? kt = ut : (ze && ze.enter(), kt = Ft(ut), ze && (ze.exit(), Et = !0)), kt === st.promise ? zt(K("Promise-chain cycle")) : (wt = Ke(kt)) ? C(wt, kt, Ht, zt) : Ht(kt)) : zt(ut);
          } catch (Ne) {
            ze && !Et && ze.exit(), zt(Ne);
          }
        }, at = function(st, Ot) {
          st.notified || (st.notified = !0, F(function() {
            for (var kt, wt = st.reactions; kt = wt.get(); ) Ze(kt, st);
            st.notified = !1, Ot && !st.rejection && It(st);
          }));
        }, pt = function(st, Ot, kt) {
          var wt, Et;
          $e ? ((wt = Oe.createEvent("Event")).promise = Ot, wt.reason = kt, wt.initEvent(st, !1, !0), g.dispatchEvent(wt)) : wt = { promise: Ot, reason: kt }, !de && (Et = g["on" + st]) ? Et(wt) : st === Be && j("Unhandled promise rejection", kt);
        }, It = function(st) {
          C(D, g, function() {
            var Ot, kt = st.facade, wt = st.value;
            if (Rt(st) && (Ot = G(function() {
              y ? Pe.emit("unhandledRejection", wt, kt) : pt(Be, kt, wt);
            }), st.rejection = y || Rt(st) ? 2 : 1, Ot.error)) throw Ot.value;
          });
        }, Rt = function(st) {
          return st.rejection !== 1 && !st.parent;
        }, gt = function(st) {
          C(D, g, function() {
            var Ot = st.facade;
            y ? Pe.emit("rejectionHandled", Ot) : pt("rejectionhandled", Ot, st.value);
          });
        }, it = function(st, Ot, kt) {
          return function(wt) {
            st(Ot, wt, kt);
          };
        }, Tt = function(st, Ot, kt) {
          st.done || (st.done = !0, kt && (st = kt), st.value = Ot, st.state = 2, at(st, !0));
        }, Ut = function(st, Ot, kt) {
          if (!st.done) {
            st.done = !0, kt && (st = kt);
            try {
              if (st.facade === Ot) throw K("Promise can't be resolved itself");
              var wt = Ke(Ot);
              wt ? F(function() {
                var Et = { done: !1 };
                try {
                  C(wt, Ot, it(Ut, Et, st), it(Tt, Et, st));
                } catch (ut) {
                  Tt(Et, ut, st);
                }
              }) : (st.value = Ot, st.state = 1, at(st, !1));
            } catch (Et) {
              Tt({ done: !1 }, Et, st);
            }
          }
        };
        if (ee && (Te = (Le = function(st) {
          S(this, Te), I(st), C(c, this);
          var Ot = pe(this);
          try {
            st(it(Ut, Ot), it(Tt, Ot));
          } catch (kt) {
            Tt(Ot, kt);
          }
        }).prototype, (c = function(st) {
          Ce(this, { type: se, done: !1, notified: !1, parent: !1, reactions: new U(), rejection: !1, state: 0, value: void 0 });
        }).prototype = O(Te, "then", function(st, Ot) {
          var kt = pe(this), wt = xe(B(this, Le));
          return kt.parent = !0, wt.ok = !k(st) || st, wt.fail = k(Ot) && Ot, wt.domain = y ? Pe.domain : void 0, kt.state == 0 ? kt.reactions.add(wt) : F(function() {
            Ze(wt, kt);
          }), wt.promise;
        }), d = function() {
          var st = new c(), Ot = pe(st);
          this.promise = st, this.resolve = it(Ut, Ot), this.reject = it(Tt, Ot);
        }, ue.f = xe = function(st) {
          return st === Le || st === void 0 ? new d(st) : be(st);
        }, !E && k(V) && _e !== Object.prototype)) {
          p = _e.then, he || O(_e, "then", function(st, Ot) {
            var kt = this;
            return new Le(function(wt, Et) {
              C(p, kt, wt, Et);
            }).then(st, Ot);
          }, { unsafe: !0 });
          try {
            delete _e.constructor;
          } catch {
          }
          N && N(_e, Te);
        }
        m({ global: !0, constructor: !0, wrap: !0, forced: ee }, { Promise: Le }), w(Le, se, !1, !0), _(se);
      }, 8674: function(l, v, s) {
        s(3401), s(821), s(4164), s(6027), s(683), s(6294);
      }, 6027: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(9662), m = s(8523), E = s(2534), y = s(408);
        c({ target: "Promise", stat: !0, forced: s(612) }, { race: function(g) {
          var C = this, O = m.f(C), N = O.reject, w = E(function() {
            var _ = p(C.resolve);
            y(g, function(I) {
              d(_, C, I).then(O.resolve, N);
            });
          });
          return w.error && N(w.value), O.promise;
        } });
      }, 683: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(8523);
        c({ target: "Promise", stat: !0, forced: s(3702).CONSTRUCTOR }, { reject: function(m) {
          var E = p.f(this);
          return d(E.reject, void 0, m), E.promise;
        } });
      }, 6294: function(l, v, s) {
        var c = s(2109), d = s(5005), p = s(1913), m = s(2492), E = s(3702).CONSTRUCTOR, y = s(9478), g = d("Promise"), C = p && !E;
        c({ target: "Promise", stat: !0, forced: p || E }, { resolve: function(O) {
          return y(C && this === g ? m : this, O);
        } });
      }, 4916: function(l, v, s) {
        var c = s(2109), d = s(2261);
        c({ target: "RegExp", proto: !0, forced: /./.exec !== d }, { exec: d });
      }, 9714: function(l, v, s) {
        var c = s(6530).PROPER, d = s(8052), p = s(9670), m = s(1340), E = s(7293), y = s(4706), g = "toString", C = RegExp.prototype[g], O = E(function() {
          return C.call({ source: "a", flags: "b" }) != "/a/b";
        }), N = c && C.name != g;
        (O || N) && d(RegExp.prototype, g, function() {
          var w = p(this);
          return "/" + m(w.source) + "/" + m(y(w));
        }, { unsafe: !0 });
      }, 2023: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(3929), m = s(4488), E = s(1340), y = s(4964), g = d("".indexOf);
        c({ target: "String", proto: !0, forced: !y("includes") }, { includes: function(C) {
          return !!~g(E(m(this)), E(p(C)), arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 8783: function(l, v, s) {
        var c = s(8710).charAt, d = s(1340), p = s(9909), m = s(1656), E = s(6178), y = "String Iterator", g = p.set, C = p.getterFor(y);
        m(String, "String", function(O) {
          g(this, { type: y, string: d(O), index: 0 });
        }, function() {
          var O, N = C(this), w = N.string, _ = N.index;
          return _ >= w.length ? E(void 0, !0) : (O = c(w, _), N.index += O.length, E(O, !1));
        });
      }, 3123: function(l, v, s) {
        var c = s(2104), d = s(6916), p = s(1702), m = s(7007), E = s(9670), y = s(8554), g = s(7850), C = s(4488), O = s(6707), N = s(1530), w = s(7466), _ = s(1340), I = s(8173), k = s(1589), H = s(7651), S = s(2261), B = s(2999), D = s(7293), F = B.UNSUPPORTED_Y, j = 4294967295, G = Math.min, U = [].push, M = p(/./.exec), V = p(U), J = p("".slice), ue = !D(function() {
          var se = /(?:)/, ee = se.exec;
          se.exec = function() {
            return ee.apply(this, arguments);
          };
          var de = "ab".split(se);
          return de.length !== 2 || de[0] !== "a" || de[1] !== "b";
        });
        m("split", function(se, ee, de) {
          var he;
          return he = "abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(pe, Ce) {
            var _e = _(C(this)), Le = Ce === void 0 ? j : Ce >>> 0;
            if (Le === 0) return [];
            if (pe === void 0) return [_e];
            if (!g(pe)) return d(ee, _e, pe, Le);
            for (var Te, K, Oe, Pe = [], xe = (pe.ignoreCase ? "i" : "") + (pe.multiline ? "m" : "") + (pe.unicode ? "u" : "") + (pe.sticky ? "y" : ""), be = 0, $e = new RegExp(pe.source, xe + "g"); (Te = d(S, $e, _e)) && !((K = $e.lastIndex) > be && (V(Pe, J(_e, be, Te.index)), Te.length > 1 && Te.index < _e.length && c(U, Pe, k(Te, 1)), Oe = Te[0].length, be = K, Pe.length >= Le)); ) $e.lastIndex === Te.index && $e.lastIndex++;
            return be === _e.length ? !Oe && M($e, "") || V(Pe, "") : V(Pe, J(_e, be)), Pe.length > Le ? k(Pe, 0, Le) : Pe;
          } : "0".split(void 0, 0).length ? function(pe, Ce) {
            return pe === void 0 && Ce === 0 ? [] : d(ee, this, pe, Ce);
          } : ee, [function(pe, Ce) {
            var _e = C(this), Le = y(pe) ? void 0 : I(pe, se);
            return Le ? d(Le, pe, _e, Ce) : d(he, _(_e), pe, Ce);
          }, function(pe, Ce) {
            var _e = E(this), Le = _(pe), Te = de(he, _e, Le, Ce, he !== ee);
            if (Te.done) return Te.value;
            var K = O(_e, RegExp), Oe = _e.unicode, Pe = (_e.ignoreCase ? "i" : "") + (_e.multiline ? "m" : "") + (_e.unicode ? "u" : "") + (F ? "g" : "y"), xe = new K(F ? "^(?:" + _e.source + ")" : _e, Pe), be = Ce === void 0 ? j : Ce >>> 0;
            if (be === 0) return [];
            if (Le.length === 0) return H(xe, Le) === null ? [Le] : [];
            for (var $e = 0, Be = 0, Ke = []; Be < Le.length; ) {
              xe.lastIndex = F ? 0 : Be;
              var Ze, at = H(xe, F ? J(Le, Be) : Le);
              if (at === null || (Ze = G(w(xe.lastIndex + (F ? Be : 0)), Le.length)) === $e) Be = N(Le, Be, Oe);
              else {
                if (V(Ke, J(Le, $e, Be)), Ke.length === be) return Ke;
                for (var pt = 1; pt <= at.length - 1; pt++) if (V(Ke, at[pt]), Ke.length === be) return Ke;
                Be = $e = Ze;
              }
            }
            return V(Ke, J(Le, $e)), Ke;
          }];
        }, !ue, F);
      }, 6755: function(l, v, s) {
        var c, d = s(2109), p = s(1470), m = s(1236).f, E = s(7466), y = s(1340), g = s(3929), C = s(4488), O = s(4964), N = s(1913), w = p("".startsWith), _ = p("".slice), I = Math.min, k = O("startsWith");
        d({ target: "String", proto: !0, forced: !(!N && !k && (c = m(String.prototype, "startsWith"), c && !c.writable) || k) }, { startsWith: function(H) {
          var S = y(C(this));
          g(H);
          var B = E(I(arguments.length > 1 ? arguments[1] : void 0, S.length)), D = y(H);
          return w ? w(S, D, B) : _(S, B, B + D.length) === D;
        } });
      }, 4032: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(6916), m = s(1702), E = s(1913), y = s(9781), g = s(6293), C = s(7293), O = s(2597), N = s(7976), w = s(9670), _ = s(5656), I = s(4948), k = s(1340), H = s(9114), S = s(30), B = s(1956), D = s(8006), F = s(1156), j = s(5181), G = s(1236), U = s(3070), M = s(6048), V = s(5296), J = s(8052), ue = s(7045), se = s(2309), ee = s(6200), de = s(3501), he = s(9711), pe = s(5112), Ce = s(6061), _e = s(6800), Le = s(6532), Te = s(8003), K = s(9909), Oe = s(2092).forEach, Pe = ee("hidden"), xe = "Symbol", be = "prototype", $e = K.set, Be = K.getterFor(xe), Ke = Object[be], Ze = d.Symbol, at = Ze && Ze[be], pt = d.TypeError, It = d.QObject, Rt = G.f, gt = U.f, it = F.f, Tt = V.f, Ut = m([].push), st = se("symbols"), Ot = se("op-symbols"), kt = se("wks"), wt = !It || !It[be] || !It[be].findChild, Et = y && C(function() {
          return S(gt({}, "a", { get: function() {
            return gt(this, "a", { value: 7 }).a;
          } })).a != 7;
        }) ? function(le, X, re) {
          var Me = Rt(Ke, X);
          Me && delete Ke[X], gt(le, X, re), Me && le !== Ke && gt(Ke, X, Me);
        } : gt, ut = function(le, X) {
          var re = st[le] = S(at);
          return $e(re, { type: xe, tag: le, description: X }), y || (re.description = X), re;
        }, St = function(le, X, re) {
          le === Ke && St(Ot, X, re), w(le);
          var Me = I(X);
          return w(re), O(st, Me) ? (re.enumerable ? (O(le, Pe) && le[Pe][Me] && (le[Pe][Me] = !1), re = S(re, { enumerable: H(0, !1) })) : (O(le, Pe) || gt(le, Pe, H(1, {})), le[Pe][Me] = !0), Et(le, Me, re)) : gt(le, Me, re);
        }, Ft = function(le, X) {
          w(le);
          var re = _(X), Me = B(re).concat(Ne(re));
          return Oe(Me, function(Se) {
            y && !p(Ht, re, Se) || St(le, Se, re[Se]);
          }), le;
        }, Ht = function(le) {
          var X = I(le), re = p(Tt, this, X);
          return !(this === Ke && O(st, X) && !O(Ot, X)) && (!(re || !O(this, X) || !O(st, X) || O(this, Pe) && this[Pe][X]) || re);
        }, zt = function(le, X) {
          var re = _(le), Me = I(X);
          if (re !== Ke || !O(st, Me) || O(Ot, Me)) {
            var Se = Rt(re, Me);
            return !Se || !O(st, Me) || O(re, Pe) && re[Pe][Me] || (Se.enumerable = !0), Se;
          }
        }, ze = function(le) {
          var X = it(_(le)), re = [];
          return Oe(X, function(Me) {
            O(st, Me) || O(de, Me) || Ut(re, Me);
          }), re;
        }, Ne = function(le) {
          var X = le === Ke, re = it(X ? Ot : _(le)), Me = [];
          return Oe(re, function(Se) {
            !O(st, Se) || X && !O(Ke, Se) || Ut(Me, st[Se]);
          }), Me;
        };
        g || (Ze = function() {
          if (N(at, this)) throw pt("Symbol is not a constructor");
          var le = arguments.length && arguments[0] !== void 0 ? k(arguments[0]) : void 0, X = he(le), re = function(Me) {
            this === Ke && p(re, Ot, Me), O(this, Pe) && O(this[Pe], X) && (this[Pe][X] = !1), Et(this, X, H(1, Me));
          };
          return y && wt && Et(Ke, X, { configurable: !0, set: re }), ut(X, le);
        }, J(at = Ze[be], "toString", function() {
          return Be(this).tag;
        }), J(Ze, "withoutSetter", function(le) {
          return ut(he(le), le);
        }), V.f = Ht, U.f = St, M.f = Ft, G.f = zt, D.f = F.f = ze, j.f = Ne, Ce.f = function(le) {
          return ut(pe(le), le);
        }, y && (ue(at, "description", { configurable: !0, get: function() {
          return Be(this).description;
        } }), E || J(Ke, "propertyIsEnumerable", Ht, { unsafe: !0 }))), c({ global: !0, constructor: !0, wrap: !0, forced: !g, sham: !g }, { Symbol: Ze }), Oe(B(kt), function(le) {
          _e(le);
        }), c({ target: xe, stat: !0, forced: !g }, { useSetter: function() {
          wt = !0;
        }, useSimple: function() {
          wt = !1;
        } }), c({ target: "Object", stat: !0, forced: !g, sham: !y }, { create: function(le, X) {
          return X === void 0 ? S(le) : Ft(S(le), X);
        }, defineProperty: St, defineProperties: Ft, getOwnPropertyDescriptor: zt }), c({ target: "Object", stat: !0, forced: !g }, { getOwnPropertyNames: ze }), Le(), Te(Ze, xe), de[Pe] = !0;
      }, 1817: function(l, v, s) {
        var c = s(2109), d = s(9781), p = s(7854), m = s(1702), E = s(2597), y = s(614), g = s(7976), C = s(1340), O = s(7045), N = s(9920), w = p.Symbol, _ = w && w.prototype;
        if (d && y(w) && (!("description" in _) || w().description !== void 0)) {
          var I = {}, k = function() {
            var G = arguments.length < 1 || arguments[0] === void 0 ? void 0 : C(arguments[0]), U = g(_, this) ? new w(G) : G === void 0 ? w() : w(G);
            return G === "" && (I[U] = !0), U;
          };
          N(k, w), k.prototype = _, _.constructor = k;
          var H = String(w("test")) == "Symbol(test)", S = m(_.valueOf), B = m(_.toString), D = /^Symbol\((.*)\)[^)]+$/, F = m("".replace), j = m("".slice);
          O(_, "description", { configurable: !0, get: function() {
            var G = S(this);
            if (E(I, G)) return "";
            var U = B(G), M = H ? j(U, 7, -1) : F(U, D, "$1");
            return M === "" ? void 0 : M;
          } }), c({ global: !0, constructor: !0, forced: !0 }, { Symbol: k });
        }
      }, 763: function(l, v, s) {
        var c = s(2109), d = s(5005), p = s(2597), m = s(1340), E = s(2309), y = s(2015), g = E("string-to-symbol-registry"), C = E("symbol-to-string-registry");
        c({ target: "Symbol", stat: !0, forced: !y }, { for: function(O) {
          var N = m(O);
          if (p(g, N)) return g[N];
          var w = d("Symbol")(N);
          return g[N] = w, C[w] = N, w;
        } });
      }, 2165: function(l, v, s) {
        s(6800)("iterator");
      }, 2526: function(l, v, s) {
        s(4032), s(763), s(6620), s(8862), s(9660);
      }, 6620: function(l, v, s) {
        var c = s(2109), d = s(2597), p = s(2190), m = s(6330), E = s(2309), y = s(2015), g = E("symbol-to-string-registry");
        c({ target: "Symbol", stat: !0, forced: !y }, { keyFor: function(C) {
          if (!p(C)) throw TypeError(m(C) + " is not a symbol");
          if (d(g, C)) return g[C];
        } });
      }, 2990: function(l, v, s) {
        var c = s(1702), d = s(260), p = c(s(1048)), m = d.aTypedArray;
        (0, d.exportTypedArrayMethod)("copyWithin", function(E, y) {
          return p(m(this), E, y, arguments.length > 2 ? arguments[2] : void 0);
        });
      }, 8927: function(l, v, s) {
        var c = s(260), d = s(2092).every, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("every", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 3105: function(l, v, s) {
        var c = s(260), d = s(1285), p = s(4599), m = s(648), E = s(6916), y = s(1702), g = s(7293), C = c.aTypedArray, O = c.exportTypedArrayMethod, N = y("".slice);
        O("fill", function(w) {
          var _ = arguments.length;
          C(this);
          var I = N(m(this), 0, 3) === "Big" ? p(w) : +w;
          return E(d, this, I, _ > 1 ? arguments[1] : void 0, _ > 2 ? arguments[2] : void 0);
        }, g(function() {
          var w = 0;
          return new Int8Array(2).fill({ valueOf: function() {
            return w++;
          } }), w !== 1;
        }));
      }, 5035: function(l, v, s) {
        var c = s(260), d = s(2092).filter, p = s(3074), m = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("filter", function(E) {
          var y = d(m(this), E, arguments.length > 1 ? arguments[1] : void 0);
          return p(this, y);
        });
      }, 7174: function(l, v, s) {
        var c = s(260), d = s(2092).findIndex, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("findIndex", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 4345: function(l, v, s) {
        var c = s(260), d = s(2092).find, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("find", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 2846: function(l, v, s) {
        var c = s(260), d = s(2092).forEach, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("forEach", function(m) {
          d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 8145: function(l, v, s) {
        var c = s(3832);
        (0, s(260).exportTypedArrayStaticMethod)("from", s(7321), c);
      }, 4731: function(l, v, s) {
        var c = s(260), d = s(1318).includes, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("includes", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 7209: function(l, v, s) {
        var c = s(260), d = s(1318).indexOf, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("indexOf", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 6319: function(l, v, s) {
        var c = s(7854), d = s(7293), p = s(1702), m = s(260), E = s(6992), y = s(5112)("iterator"), g = c.Uint8Array, C = p(E.values), O = p(E.keys), N = p(E.entries), w = m.aTypedArray, _ = m.exportTypedArrayMethod, I = g && g.prototype, k = !d(function() {
          I[y].call([1]);
        }), H = !!I && I.values && I[y] === I.values && I.values.name === "values", S = function() {
          return C(w(this));
        };
        _("entries", function() {
          return N(w(this));
        }, k), _("keys", function() {
          return O(w(this));
        }, k), _("values", S, k || !H, { name: "values" }), _(y, S, k || !H, { name: "values" });
      }, 8867: function(l, v, s) {
        var c = s(260), d = s(1702), p = c.aTypedArray, m = c.exportTypedArrayMethod, E = d([].join);
        m("join", function(y) {
          return E(p(this), y);
        });
      }, 7789: function(l, v, s) {
        var c = s(260), d = s(2104), p = s(6583), m = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("lastIndexOf", function(E) {
          var y = arguments.length;
          return d(p, m(this), y > 1 ? [E, arguments[1]] : [E]);
        });
      }, 3739: function(l, v, s) {
        var c = s(260), d = s(2092).map, p = s(6304), m = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("map", function(E) {
          return d(m(this), E, arguments.length > 1 ? arguments[1] : void 0, function(y, g) {
            return new (p(y))(g);
          });
        });
      }, 4483: function(l, v, s) {
        var c = s(260), d = s(3671).right, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("reduceRight", function(m) {
          var E = arguments.length;
          return d(p(this), m, E, E > 1 ? arguments[1] : void 0);
        });
      }, 9368: function(l, v, s) {
        var c = s(260), d = s(3671).left, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("reduce", function(m) {
          var E = arguments.length;
          return d(p(this), m, E, E > 1 ? arguments[1] : void 0);
        });
      }, 2056: function(l, v, s) {
        var c = s(260), d = c.aTypedArray, p = c.exportTypedArrayMethod, m = Math.floor;
        p("reverse", function() {
          for (var E, y = this, g = d(y).length, C = m(g / 2), O = 0; O < C; ) E = y[O], y[O++] = y[--g], y[g] = E;
          return y;
        });
      }, 3462: function(l, v, s) {
        var c = s(7854), d = s(6916), p = s(260), m = s(6244), E = s(4590), y = s(7908), g = s(7293), C = c.RangeError, O = c.Int8Array, N = O && O.prototype, w = N && N.set, _ = p.aTypedArray, I = p.exportTypedArrayMethod, k = !g(function() {
          var S = new Uint8ClampedArray(2);
          return d(w, S, { length: 1, 0: 3 }, 1), S[1] !== 3;
        }), H = k && p.NATIVE_ARRAY_BUFFER_VIEWS && g(function() {
          var S = new O(2);
          return S.set(1), S.set("2", 1), S[0] !== 0 || S[1] !== 2;
        });
        I("set", function(S) {
          _(this);
          var B = E(arguments.length > 1 ? arguments[1] : void 0, 1), D = y(S);
          if (k) return d(w, this, D, B);
          var F = this.length, j = m(D), G = 0;
          if (j + B > F) throw C("Wrong length");
          for (; G < j; ) this[B + G] = D[G++];
        }, !k || H);
      }, 678: function(l, v, s) {
        var c = s(260), d = s(6304), p = s(7293), m = s(206), E = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("slice", function(y, g) {
          for (var C = m(E(this), y, g), O = d(this), N = 0, w = C.length, _ = new O(w); w > N; ) _[N] = C[N++];
          return _;
        }, p(function() {
          new Int8Array(1).slice();
        }));
      }, 7462: function(l, v, s) {
        var c = s(260), d = s(2092).some, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("some", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 3824: function(l, v, s) {
        var c = s(7854), d = s(1470), p = s(7293), m = s(9662), E = s(4362), y = s(260), g = s(8886), C = s(256), O = s(7392), N = s(8008), w = y.aTypedArray, _ = y.exportTypedArrayMethod, I = c.Uint16Array, k = I && d(I.prototype.sort), H = !(!k || p(function() {
          k(new I(2), null);
        }) && p(function() {
          k(new I(2), {});
        })), S = !!k && !p(function() {
          if (O) return O < 74;
          if (g) return g < 67;
          if (C) return !0;
          if (N) return N < 602;
          var B, D, F = new I(516), j = Array(516);
          for (B = 0; B < 516; B++) D = B % 4, F[B] = 515 - B, j[B] = B - 2 * D + 3;
          for (k(F, function(G, U) {
            return (G / 4 | 0) - (U / 4 | 0);
          }), B = 0; B < 516; B++) if (F[B] !== j[B]) return !0;
        });
        _("sort", function(B) {
          return B !== void 0 && m(B), S ? k(this, B) : E(w(this), /* @__PURE__ */ function(D) {
            return function(F, j) {
              return D !== void 0 ? +D(F, j) || 0 : j != j ? -1 : F != F ? 1 : F === 0 && j === 0 ? 1 / F > 0 && 1 / j < 0 ? 1 : -1 : F > j;
            };
          }(B));
        }, !S || H);
      }, 5021: function(l, v, s) {
        var c = s(260), d = s(7466), p = s(1400), m = s(6304), E = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("subarray", function(y, g) {
          var C = E(this), O = C.length, N = p(y, O);
          return new (m(C))(C.buffer, C.byteOffset + N * C.BYTES_PER_ELEMENT, d((g === void 0 ? O : p(g, O)) - N));
        });
      }, 2974: function(l, v, s) {
        var c = s(7854), d = s(2104), p = s(260), m = s(7293), E = s(206), y = c.Int8Array, g = p.aTypedArray, C = p.exportTypedArrayMethod, O = [].toLocaleString, N = !!y && m(function() {
          O.call(new y(1));
        });
        C("toLocaleString", function() {
          return d(O, N ? E(g(this)) : g(this), E(arguments));
        }, m(function() {
          return [1, 2].toLocaleString() != new y([1, 2]).toLocaleString();
        }) || !m(function() {
          y.prototype.toLocaleString.call([1, 2]);
        }));
      }, 5016: function(l, v, s) {
        var c = s(260).exportTypedArrayMethod, d = s(7293), p = s(7854), m = s(1702), E = p.Uint8Array, y = E && E.prototype || {}, g = [].toString, C = m([].join);
        d(function() {
          g.call({});
        }) && (g = function() {
          return C(this);
        });
        var O = y.toString != g;
        c("toString", g, O);
      }, 2472: function(l, v, s) {
        s(9843)("Uint8", function(c) {
          return function(d, p, m) {
            return c(this, d, p, m);
          };
        });
      }, 4747: function(l, v, s) {
        var c = s(7854), d = s(8324), p = s(8509), m = s(8533), E = s(8880), y = function(C) {
          if (C && C.forEach !== m) try {
            E(C, "forEach", m);
          } catch {
            C.forEach = m;
          }
        };
        for (var g in d) d[g] && y(c[g] && c[g].prototype);
        y(p);
      }, 3948: function(l, v, s) {
        var c = s(7854), d = s(8324), p = s(8509), m = s(6992), E = s(8880), y = s(5112), g = y("iterator"), C = y("toStringTag"), O = m.values, N = function(_, I) {
          if (_) {
            if (_[g] !== O) try {
              E(_, g, O);
            } catch {
              _[g] = O;
            }
            if (_[C] || E(_, C, I), d[I]) {
              for (var k in m) if (_[k] !== m[k]) try {
                E(_, k, m[k]);
              } catch {
                _[k] = m[k];
              }
            }
          }
        };
        for (var w in d) N(c[w] && c[w].prototype, w);
        N(p, "DOMTokenList");
      }, 6815: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(7152)(d.setInterval, !0);
        c({ global: !0, bind: !0, forced: d.setInterval !== p }, { setInterval: p });
      }, 8417: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(7152)(d.setTimeout, !0);
        c({ global: !0, bind: !0, forced: d.setTimeout !== p }, { setTimeout: p });
      }, 2564: function(l, v, s) {
        s(6815), s(8417);
      }, 5556: function(l, v, s) {
        s(6992);
        var c = s(2109), d = s(7854), p = s(6916), m = s(1702), E = s(9781), y = s(5143), g = s(8052), C = s(7045), O = s(9190), N = s(8003), w = s(3061), _ = s(9909), I = s(5787), k = s(614), H = s(2597), S = s(9974), B = s(648), D = s(9670), F = s(111), j = s(1340), G = s(30), U = s(9114), M = s(4121), V = s(1246), J = s(8053), ue = s(5112), se = s(4362), ee = ue("iterator"), de = "URLSearchParams", he = de + "Iterator", pe = _.set, Ce = _.getterFor(de), _e = _.getterFor(he), Le = Object.getOwnPropertyDescriptor, Te = function(ke) {
          if (!E) return d[ke];
          var Ge = Le(d, ke);
          return Ge && Ge.value;
        }, K = Te("fetch"), Oe = Te("Request"), Pe = Te("Headers"), xe = Oe && Oe.prototype, be = Pe && Pe.prototype, $e = d.RegExp, Be = d.TypeError, Ke = d.decodeURIComponent, Ze = d.encodeURIComponent, at = m("".charAt), pt = m([].join), It = m([].push), Rt = m("".replace), gt = m([].shift), it = m([].splice), Tt = m("".split), Ut = m("".slice), st = /\+/g, Ot = Array(4), kt = function(ke) {
          return Ot[ke - 1] || (Ot[ke - 1] = $e("((?:%[\\da-f]{2}){" + ke + "})", "gi"));
        }, wt = function(ke) {
          try {
            return Ke(ke);
          } catch {
            return ke;
          }
        }, Et = function(ke) {
          var Ge = Rt(ke, st, " "), nt = 4;
          try {
            return Ke(Ge);
          } catch {
            for (; nt; ) Ge = Rt(Ge, kt(nt--), wt);
            return Ge;
          }
        }, ut = /[!'()~]|%20/g, St = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+" }, Ft = function(ke) {
          return St[ke];
        }, Ht = function(ke) {
          return Rt(Ze(ke), ut, Ft);
        }, zt = w(function(ke, Ge) {
          pe(this, { type: he, iterator: M(Ce(ke).entries), kind: Ge });
        }, "Iterator", function() {
          var ke = _e(this), Ge = ke.kind, nt = ke.iterator.next(), rt = nt.value;
          return nt.done || (nt.value = Ge === "keys" ? rt.key : Ge === "values" ? rt.value : [rt.key, rt.value]), nt;
        }, !0), ze = function(ke) {
          this.entries = [], this.url = null, ke !== void 0 && (F(ke) ? this.parseObject(ke) : this.parseQuery(typeof ke == "string" ? at(ke, 0) === "?" ? Ut(ke, 1) : ke : j(ke)));
        };
        ze.prototype = { type: de, bindURL: function(ke) {
          this.url = ke, this.update();
        }, parseObject: function(ke) {
          var Ge, nt, rt, dt, lt, Ct, Ie, x = V(ke);
          if (x) for (nt = (Ge = M(ke, x)).next; !(rt = p(nt, Ge)).done; ) {
            if (lt = (dt = M(D(rt.value))).next, (Ct = p(lt, dt)).done || (Ie = p(lt, dt)).done || !p(lt, dt).done) throw Be("Expected sequence with length 2");
            It(this.entries, { key: j(Ct.value), value: j(Ie.value) });
          }
          else for (var ae in ke) H(ke, ae) && It(this.entries, { key: ae, value: j(ke[ae]) });
        }, parseQuery: function(ke) {
          if (ke) for (var Ge, nt, rt = Tt(ke, "&"), dt = 0; dt < rt.length; ) (Ge = rt[dt++]).length && (nt = Tt(Ge, "="), It(this.entries, { key: Et(gt(nt)), value: Et(pt(nt, "=")) }));
        }, serialize: function() {
          for (var ke, Ge = this.entries, nt = [], rt = 0; rt < Ge.length; ) ke = Ge[rt++], It(nt, Ht(ke.key) + "=" + Ht(ke.value));
          return pt(nt, "&");
        }, update: function() {
          this.entries.length = 0, this.parseQuery(this.url.query);
        }, updateURL: function() {
          this.url && this.url.update();
        } };
        var Ne = function() {
          I(this, le);
          var ke = pe(this, new ze(arguments.length > 0 ? arguments[0] : void 0));
          E || (this.length = ke.entries.length);
        }, le = Ne.prototype;
        if (O(le, { append: function(ke, Ge) {
          J(arguments.length, 2);
          var nt = Ce(this);
          It(nt.entries, { key: j(ke), value: j(Ge) }), E || this.length++, nt.updateURL();
        }, delete: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this), nt = Ge.entries, rt = j(ke), dt = 0; dt < nt.length; ) nt[dt].key === rt ? it(nt, dt, 1) : dt++;
          E || (this.length = nt.length), Ge.updateURL();
        }, get: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this).entries, nt = j(ke), rt = 0; rt < Ge.length; rt++) if (Ge[rt].key === nt) return Ge[rt].value;
          return null;
        }, getAll: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this).entries, nt = j(ke), rt = [], dt = 0; dt < Ge.length; dt++) Ge[dt].key === nt && It(rt, Ge[dt].value);
          return rt;
        }, has: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this).entries, nt = j(ke), rt = 0; rt < Ge.length; ) if (Ge[rt++].key === nt) return !0;
          return !1;
        }, set: function(ke, Ge) {
          J(arguments.length, 1);
          for (var nt, rt = Ce(this), dt = rt.entries, lt = !1, Ct = j(ke), Ie = j(Ge), x = 0; x < dt.length; x++) (nt = dt[x]).key === Ct && (lt ? it(dt, x--, 1) : (lt = !0, nt.value = Ie));
          lt || It(dt, { key: Ct, value: Ie }), E || (this.length = dt.length), rt.updateURL();
        }, sort: function() {
          var ke = Ce(this);
          se(ke.entries, function(Ge, nt) {
            return Ge.key > nt.key ? 1 : -1;
          }), ke.updateURL();
        }, forEach: function(ke) {
          for (var Ge, nt = Ce(this).entries, rt = S(ke, arguments.length > 1 ? arguments[1] : void 0), dt = 0; dt < nt.length; ) rt((Ge = nt[dt++]).value, Ge.key, this);
        }, keys: function() {
          return new zt(this, "keys");
        }, values: function() {
          return new zt(this, "values");
        }, entries: function() {
          return new zt(this, "entries");
        } }, { enumerable: !0 }), g(le, ee, le.entries, { name: "entries" }), g(le, "toString", function() {
          return Ce(this).serialize();
        }, { enumerable: !0 }), E && C(le, "size", { get: function() {
          return Ce(this).entries.length;
        }, configurable: !0, enumerable: !0 }), N(Ne, de), c({ global: !0, constructor: !0, forced: !y }, { URLSearchParams: Ne }), !y && k(Pe)) {
          var X = m(be.has), re = m(be.set), Me = function(ke) {
            if (F(ke)) {
              var Ge, nt = ke.body;
              if (B(nt) === de) return Ge = ke.headers ? new Pe(ke.headers) : new Pe(), X(Ge, "content-type") || re(Ge, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), G(ke, { body: U(0, j(nt)), headers: U(0, Ge) });
            }
            return ke;
          };
          if (k(K) && c({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, { fetch: function(ke) {
            return K(ke, arguments.length > 1 ? Me(arguments[1]) : {});
          } }), k(Oe)) {
            var Se = function(ke) {
              return I(this, xe), new Oe(ke, arguments.length > 1 ? Me(arguments[1]) : {});
            };
            xe.constructor = Se, Se.prototype = xe, c({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, { Request: Se });
          }
        }
        l.exports = { URLSearchParams: Ne, getState: Ce };
      }, 1637: function(l, v, s) {
        s(5556);
      }, 8789: function(l, v, s) {
        s(8783);
        var c, d = s(2109), p = s(9781), m = s(5143), E = s(7854), y = s(9974), g = s(1702), C = s(8052), O = s(7045), N = s(5787), w = s(2597), _ = s(1574), I = s(8457), k = s(1589), H = s(8710).codeAt, S = s(3197), B = s(1340), D = s(8003), F = s(8053), j = s(5556), G = s(9909), U = G.set, M = G.getterFor("URL"), V = j.URLSearchParams, J = j.getState, ue = E.URL, se = E.TypeError, ee = E.parseInt, de = Math.floor, he = Math.pow, pe = g("".charAt), Ce = g(/./.exec), _e = g([].join), Le = g(1 .toString), Te = g([].pop), K = g([].push), Oe = g("".replace), Pe = g([].shift), xe = g("".split), be = g("".slice), $e = g("".toLowerCase), Be = g([].unshift), Ke = "Invalid scheme", Ze = "Invalid host", at = "Invalid port", pt = /[a-z]/i, It = /[\d+-.a-z]/i, Rt = /\d/, gt = /^0x/i, it = /^[0-7]+$/, Tt = /^\d+$/, Ut = /^[\da-f]+$/i, st = /[\0\t\n\r #%/:<>?@[\\\]^|]/, Ot = /[\0\t\n\r #/:<>?@[\\\]^|]/, kt = /^[\u0000-\u0020]+/, wt = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, Et = /[\t\n\r]/g, ut = function(je) {
          var qe, et, bt, ot;
          if (typeof je == "number") {
            for (qe = [], et = 0; et < 4; et++) Be(qe, je % 256), je = de(je / 256);
            return _e(qe, ".");
          }
          if (typeof je == "object") {
            for (qe = "", bt = function(Lt) {
              for (var Kt = null, $t = 1, yt = null, Wt = 0, In = 0; In < 8; In++) Lt[In] !== 0 ? (Wt > $t && (Kt = yt, $t = Wt), yt = null, Wt = 0) : (yt === null && (yt = In), ++Wt);
              return Wt > $t && (Kt = yt, $t = Wt), Kt;
            }(je), et = 0; et < 8; et++) ot && je[et] === 0 || (ot && (ot = !1), bt === et ? (qe += et ? ":" : "::", ot = !0) : (qe += Le(je[et], 16), et < 7 && (qe += ":")));
            return "[" + qe + "]";
          }
          return je;
        }, St = {}, Ft = _({}, St, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }), Ht = _({}, Ft, { "#": 1, "?": 1, "{": 1, "}": 1 }), zt = _({}, Ht, { "/": 1, ":": 1, ";": 1, "=": 1, "@": 1, "[": 1, "\\": 1, "]": 1, "^": 1, "|": 1 }), ze = function(je, qe) {
          var et = H(je, 0);
          return et > 32 && et < 127 && !w(qe, je) ? je : encodeURIComponent(je);
        }, Ne = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 }, le = function(je, qe) {
          var et;
          return je.length == 2 && Ce(pt, pe(je, 0)) && ((et = pe(je, 1)) == ":" || !qe && et == "|");
        }, X = function(je) {
          var qe;
          return je.length > 1 && le(be(je, 0, 2)) && (je.length == 2 || (qe = pe(je, 2)) === "/" || qe === "\\" || qe === "?" || qe === "#");
        }, re = function(je) {
          return je === "." || $e(je) === "%2e";
        }, Me = {}, Se = {}, ke = {}, Ge = {}, nt = {}, rt = {}, dt = {}, lt = {}, Ct = {}, Ie = {}, x = {}, ae = {}, Q = {}, Z = {}, ge = {}, me = {}, ve = {}, ie = {}, ye = {}, Ye = {}, ne = {}, Qe = function(je, qe, et) {
          var bt, ot, Lt, Kt = B(je);
          if (qe) {
            if (ot = this.parse(Kt)) throw se(ot);
            this.searchParams = null;
          } else {
            if (et !== void 0 && (bt = new Qe(et, !0)), ot = this.parse(Kt, null, bt)) throw se(ot);
            (Lt = J(new V())).bindURL(this), this.searchParams = Lt;
          }
        };
        Qe.prototype = { type: "URL", parse: function(je, qe, et) {
          var bt, ot, Lt, Kt, $t, yt = this, Wt = qe || Me, In = 0, gn = "", zn = !1, Xn = !1, yr = !1;
          for (je = B(je), qe || (yt.scheme = "", yt.username = "", yt.password = "", yt.host = null, yt.port = null, yt.path = [], yt.query = null, yt.fragment = null, yt.cannotBeABaseURL = !1, je = Oe(je, kt, ""), je = Oe(je, wt, "$1")), je = Oe(je, Et, ""), bt = I(je); In <= bt.length; ) {
            switch (ot = bt[In], Wt) {
              case Me:
                if (!ot || !Ce(pt, ot)) {
                  if (qe) return Ke;
                  Wt = ke;
                  continue;
                }
                gn += $e(ot), Wt = Se;
                break;
              case Se:
                if (ot && (Ce(It, ot) || ot == "+" || ot == "-" || ot == ".")) gn += $e(ot);
                else {
                  if (ot != ":") {
                    if (qe) return Ke;
                    gn = "", Wt = ke, In = 0;
                    continue;
                  }
                  if (qe && (yt.isSpecial() != w(Ne, gn) || gn == "file" && (yt.includesCredentials() || yt.port !== null) || yt.scheme == "file" && !yt.host)) return;
                  if (yt.scheme = gn, qe) return void (yt.isSpecial() && Ne[yt.scheme] == yt.port && (yt.port = null));
                  gn = "", yt.scheme == "file" ? Wt = Z : yt.isSpecial() && et && et.scheme == yt.scheme ? Wt = Ge : yt.isSpecial() ? Wt = lt : bt[In + 1] == "/" ? (Wt = nt, In++) : (yt.cannotBeABaseURL = !0, K(yt.path, ""), Wt = ye);
                }
                break;
              case ke:
                if (!et || et.cannotBeABaseURL && ot != "#") return Ke;
                if (et.cannotBeABaseURL && ot == "#") {
                  yt.scheme = et.scheme, yt.path = k(et.path), yt.query = et.query, yt.fragment = "", yt.cannotBeABaseURL = !0, Wt = ne;
                  break;
                }
                Wt = et.scheme == "file" ? Z : rt;
                continue;
              case Ge:
                if (ot != "/" || bt[In + 1] != "/") {
                  Wt = rt;
                  continue;
                }
                Wt = Ct, In++;
                break;
              case nt:
                if (ot == "/") {
                  Wt = Ie;
                  break;
                }
                Wt = ie;
                continue;
              case rt:
                if (yt.scheme = et.scheme, ot == c) yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.query = et.query;
                else if (ot == "/" || ot == "\\" && yt.isSpecial()) Wt = dt;
                else if (ot == "?") yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.query = "", Wt = Ye;
                else {
                  if (ot != "#") {
                    yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.path.length--, Wt = ie;
                    continue;
                  }
                  yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.query = et.query, yt.fragment = "", Wt = ne;
                }
                break;
              case dt:
                if (!yt.isSpecial() || ot != "/" && ot != "\\") {
                  if (ot != "/") {
                    yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, Wt = ie;
                    continue;
                  }
                  Wt = Ie;
                } else Wt = Ct;
                break;
              case lt:
                if (Wt = Ct, ot != "/" || pe(gn, In + 1) != "/") continue;
                In++;
                break;
              case Ct:
                if (ot != "/" && ot != "\\") {
                  Wt = Ie;
                  continue;
                }
                break;
              case Ie:
                if (ot == "@") {
                  zn && (gn = "%40" + gn), zn = !0, Lt = I(gn);
                  for (var ur = 0; ur < Lt.length; ur++) {
                    var Yn = Lt[ur];
                    if (Yn != ":" || yr) {
                      var xi = ze(Yn, zt);
                      yr ? yt.password += xi : yt.username += xi;
                    } else yr = !0;
                  }
                  gn = "";
                } else if (ot == c || ot == "/" || ot == "?" || ot == "#" || ot == "\\" && yt.isSpecial()) {
                  if (zn && gn == "") return "Invalid authority";
                  In -= I(gn).length + 1, gn = "", Wt = x;
                } else gn += ot;
                break;
              case x:
              case ae:
                if (qe && yt.scheme == "file") {
                  Wt = me;
                  continue;
                }
                if (ot != ":" || Xn) {
                  if (ot == c || ot == "/" || ot == "?" || ot == "#" || ot == "\\" && yt.isSpecial()) {
                    if (yt.isSpecial() && gn == "") return Ze;
                    if (qe && gn == "" && (yt.includesCredentials() || yt.port !== null)) return;
                    if (Kt = yt.parseHost(gn)) return Kt;
                    if (gn = "", Wt = ve, qe) return;
                    continue;
                  }
                  ot == "[" ? Xn = !0 : ot == "]" && (Xn = !1), gn += ot;
                } else {
                  if (gn == "") return Ze;
                  if (Kt = yt.parseHost(gn)) return Kt;
                  if (gn = "", Wt = Q, qe == ae) return;
                }
                break;
              case Q:
                if (!Ce(Rt, ot)) {
                  if (ot == c || ot == "/" || ot == "?" || ot == "#" || ot == "\\" && yt.isSpecial() || qe) {
                    if (gn != "") {
                      var gs = ee(gn, 10);
                      if (gs > 65535) return at;
                      yt.port = yt.isSpecial() && gs === Ne[yt.scheme] ? null : gs, gn = "";
                    }
                    if (qe) return;
                    Wt = ve;
                    continue;
                  }
                  return at;
                }
                gn += ot;
                break;
              case Z:
                if (yt.scheme = "file", ot == "/" || ot == "\\") Wt = ge;
                else {
                  if (!et || et.scheme != "file") {
                    Wt = ie;
                    continue;
                  }
                  if (ot == c) yt.host = et.host, yt.path = k(et.path), yt.query = et.query;
                  else if (ot == "?") yt.host = et.host, yt.path = k(et.path), yt.query = "", Wt = Ye;
                  else {
                    if (ot != "#") {
                      X(_e(k(bt, In), "")) || (yt.host = et.host, yt.path = k(et.path), yt.shortenPath()), Wt = ie;
                      continue;
                    }
                    yt.host = et.host, yt.path = k(et.path), yt.query = et.query, yt.fragment = "", Wt = ne;
                  }
                }
                break;
              case ge:
                if (ot == "/" || ot == "\\") {
                  Wt = me;
                  break;
                }
                et && et.scheme == "file" && !X(_e(k(bt, In), "")) && (le(et.path[0], !0) ? K(yt.path, et.path[0]) : yt.host = et.host), Wt = ie;
                continue;
              case me:
                if (ot == c || ot == "/" || ot == "\\" || ot == "?" || ot == "#") {
                  if (!qe && le(gn)) Wt = ie;
                  else if (gn == "") {
                    if (yt.host = "", qe) return;
                    Wt = ve;
                  } else {
                    if (Kt = yt.parseHost(gn)) return Kt;
                    if (yt.host == "localhost" && (yt.host = ""), qe) return;
                    gn = "", Wt = ve;
                  }
                  continue;
                }
                gn += ot;
                break;
              case ve:
                if (yt.isSpecial()) {
                  if (Wt = ie, ot != "/" && ot != "\\") continue;
                } else if (qe || ot != "?") if (qe || ot != "#") {
                  if (ot != c && (Wt = ie, ot != "/")) continue;
                } else yt.fragment = "", Wt = ne;
                else yt.query = "", Wt = Ye;
                break;
              case ie:
                if (ot == c || ot == "/" || ot == "\\" && yt.isSpecial() || !qe && (ot == "?" || ot == "#")) {
                  if (($t = $e($t = gn)) === ".." || $t === "%2e." || $t === ".%2e" || $t === "%2e%2e" ? (yt.shortenPath(), ot == "/" || ot == "\\" && yt.isSpecial() || K(yt.path, "")) : re(gn) ? ot == "/" || ot == "\\" && yt.isSpecial() || K(yt.path, "") : (yt.scheme == "file" && !yt.path.length && le(gn) && (yt.host && (yt.host = ""), gn = pe(gn, 0) + ":"), K(yt.path, gn)), gn = "", yt.scheme == "file" && (ot == c || ot == "?" || ot == "#")) for (; yt.path.length > 1 && yt.path[0] === ""; ) Pe(yt.path);
                  ot == "?" ? (yt.query = "", Wt = Ye) : ot == "#" && (yt.fragment = "", Wt = ne);
                } else gn += ze(ot, Ht);
                break;
              case ye:
                ot == "?" ? (yt.query = "", Wt = Ye) : ot == "#" ? (yt.fragment = "", Wt = ne) : ot != c && (yt.path[0] += ze(ot, St));
                break;
              case Ye:
                qe || ot != "#" ? ot != c && (ot == "'" && yt.isSpecial() ? yt.query += "%27" : yt.query += ot == "#" ? "%23" : ze(ot, St)) : (yt.fragment = "", Wt = ne);
                break;
              case ne:
                ot != c && (yt.fragment += ze(ot, Ft));
            }
            In++;
          }
        }, parseHost: function(je) {
          var qe, et, bt;
          if (pe(je, 0) == "[") {
            if (pe(je, je.length - 1) != "]" || (qe = function(ot) {
              var Lt, Kt, $t, yt, Wt, In, gn, zn = [0, 0, 0, 0, 0, 0, 0, 0], Xn = 0, yr = null, ur = 0, Yn = function() {
                return pe(ot, ur);
              };
              if (Yn() == ":") {
                if (pe(ot, 1) != ":") return;
                ur += 2, yr = ++Xn;
              }
              for (; Yn(); ) {
                if (Xn == 8) return;
                if (Yn() != ":") {
                  for (Lt = Kt = 0; Kt < 4 && Ce(Ut, Yn()); ) Lt = 16 * Lt + ee(Yn(), 16), ur++, Kt++;
                  if (Yn() == ".") {
                    if (Kt == 0 || (ur -= Kt, Xn > 6)) return;
                    for ($t = 0; Yn(); ) {
                      if (yt = null, $t > 0) {
                        if (!(Yn() == "." && $t < 4)) return;
                        ur++;
                      }
                      if (!Ce(Rt, Yn())) return;
                      for (; Ce(Rt, Yn()); ) {
                        if (Wt = ee(Yn(), 10), yt === null) yt = Wt;
                        else {
                          if (yt == 0) return;
                          yt = 10 * yt + Wt;
                        }
                        if (yt > 255) return;
                        ur++;
                      }
                      zn[Xn] = 256 * zn[Xn] + yt, ++$t != 2 && $t != 4 || Xn++;
                    }
                    if ($t != 4) return;
                    break;
                  }
                  if (Yn() == ":") {
                    if (ur++, !Yn()) return;
                  } else if (Yn()) return;
                  zn[Xn++] = Lt;
                } else {
                  if (yr !== null) return;
                  ur++, yr = ++Xn;
                }
              }
              if (yr !== null) for (In = Xn - yr, Xn = 7; Xn != 0 && In > 0; ) gn = zn[Xn], zn[Xn--] = zn[yr + In - 1], zn[yr + --In] = gn;
              else if (Xn != 8) return;
              return zn;
            }(be(je, 1, -1)), !qe)) return Ze;
            this.host = qe;
          } else if (this.isSpecial()) {
            if (je = S(je), Ce(st, je) || (qe = function(ot) {
              var Lt, Kt, $t, yt, Wt, In, gn, zn = xe(ot, ".");
              if (zn.length && zn[zn.length - 1] == "" && zn.length--, (Lt = zn.length) > 4) return ot;
              for (Kt = [], $t = 0; $t < Lt; $t++) {
                if ((yt = zn[$t]) == "") return ot;
                if (Wt = 10, yt.length > 1 && pe(yt, 0) == "0" && (Wt = Ce(gt, yt) ? 16 : 8, yt = be(yt, Wt == 8 ? 1 : 2)), yt === "") In = 0;
                else {
                  if (!Ce(Wt == 10 ? Tt : Wt == 8 ? it : Ut, yt)) return ot;
                  In = ee(yt, Wt);
                }
                K(Kt, In);
              }
              for ($t = 0; $t < Lt; $t++) if (In = Kt[$t], $t == Lt - 1) {
                if (In >= he(256, 5 - Lt)) return null;
              } else if (In > 255) return null;
              for (gn = Te(Kt), $t = 0; $t < Kt.length; $t++) gn += Kt[$t] * he(256, 3 - $t);
              return gn;
            }(je), qe === null)) return Ze;
            this.host = qe;
          } else {
            if (Ce(Ot, je)) return Ze;
            for (qe = "", et = I(je), bt = 0; bt < et.length; bt++) qe += ze(et[bt], St);
            this.host = qe;
          }
        }, cannotHaveUsernamePasswordPort: function() {
          return !this.host || this.cannotBeABaseURL || this.scheme == "file";
        }, includesCredentials: function() {
          return this.username != "" || this.password != "";
        }, isSpecial: function() {
          return w(Ne, this.scheme);
        }, shortenPath: function() {
          var je = this.path, qe = je.length;
          !qe || this.scheme == "file" && qe == 1 && le(je[0], !0) || je.length--;
        }, serialize: function() {
          var je = this, qe = je.scheme, et = je.username, bt = je.password, ot = je.host, Lt = je.port, Kt = je.path, $t = je.query, yt = je.fragment, Wt = qe + ":";
          return ot !== null ? (Wt += "//", je.includesCredentials() && (Wt += et + (bt ? ":" + bt : "") + "@"), Wt += ut(ot), Lt !== null && (Wt += ":" + Lt)) : qe == "file" && (Wt += "//"), Wt += je.cannotBeABaseURL ? Kt[0] : Kt.length ? "/" + _e(Kt, "/") : "", $t !== null && (Wt += "?" + $t), yt !== null && (Wt += "#" + yt), Wt;
        }, setHref: function(je) {
          var qe = this.parse(je);
          if (qe) throw se(qe);
          this.searchParams.update();
        }, getOrigin: function() {
          var je = this.scheme, qe = this.port;
          if (je == "blob") try {
            return new W(je.path[0]).origin;
          } catch {
            return "null";
          }
          return je != "file" && this.isSpecial() ? je + "://" + ut(this.host) + (qe !== null ? ":" + qe : "") : "null";
        }, getProtocol: function() {
          return this.scheme + ":";
        }, setProtocol: function(je) {
          this.parse(B(je) + ":", Me);
        }, getUsername: function() {
          return this.username;
        }, setUsername: function(je) {
          var qe = I(B(je));
          if (!this.cannotHaveUsernamePasswordPort()) {
            this.username = "";
            for (var et = 0; et < qe.length; et++) this.username += ze(qe[et], zt);
          }
        }, getPassword: function() {
          return this.password;
        }, setPassword: function(je) {
          var qe = I(B(je));
          if (!this.cannotHaveUsernamePasswordPort()) {
            this.password = "";
            for (var et = 0; et < qe.length; et++) this.password += ze(qe[et], zt);
          }
        }, getHost: function() {
          var je = this.host, qe = this.port;
          return je === null ? "" : qe === null ? ut(je) : ut(je) + ":" + qe;
        }, setHost: function(je) {
          this.cannotBeABaseURL || this.parse(je, x);
        }, getHostname: function() {
          var je = this.host;
          return je === null ? "" : ut(je);
        }, setHostname: function(je) {
          this.cannotBeABaseURL || this.parse(je, ae);
        }, getPort: function() {
          var je = this.port;
          return je === null ? "" : B(je);
        }, setPort: function(je) {
          this.cannotHaveUsernamePasswordPort() || ((je = B(je)) == "" ? this.port = null : this.parse(je, Q));
        }, getPathname: function() {
          var je = this.path;
          return this.cannotBeABaseURL ? je[0] : je.length ? "/" + _e(je, "/") : "";
        }, setPathname: function(je) {
          this.cannotBeABaseURL || (this.path = [], this.parse(je, ve));
        }, getSearch: function() {
          var je = this.query;
          return je ? "?" + je : "";
        }, setSearch: function(je) {
          (je = B(je)) == "" ? this.query = null : (pe(je, 0) == "?" && (je = be(je, 1)), this.query = "", this.parse(je, Ye)), this.searchParams.update();
        }, getSearchParams: function() {
          return this.searchParams.facade;
        }, getHash: function() {
          var je = this.fragment;
          return je ? "#" + je : "";
        }, setHash: function(je) {
          (je = B(je)) != "" ? (pe(je, 0) == "#" && (je = be(je, 1)), this.fragment = "", this.parse(je, ne)) : this.fragment = null;
        }, update: function() {
          this.query = this.searchParams.serialize() || null;
        } };
        var W = function(je) {
          var qe = N(this, ce), et = F(arguments.length, 1) > 1 ? arguments[1] : void 0, bt = U(qe, new Qe(je, !1, et));
          p || (qe.href = bt.serialize(), qe.origin = bt.getOrigin(), qe.protocol = bt.getProtocol(), qe.username = bt.getUsername(), qe.password = bt.getPassword(), qe.host = bt.getHost(), qe.hostname = bt.getHostname(), qe.port = bt.getPort(), qe.pathname = bt.getPathname(), qe.search = bt.getSearch(), qe.searchParams = bt.getSearchParams(), qe.hash = bt.getHash());
        }, ce = W.prototype, fe = function(je, qe) {
          return { get: function() {
            return M(this)[je]();
          }, set: qe && function(et) {
            return M(this)[qe](et);
          }, configurable: !0, enumerable: !0 };
        };
        if (p && (O(ce, "href", fe("serialize", "setHref")), O(ce, "origin", fe("getOrigin")), O(ce, "protocol", fe("getProtocol", "setProtocol")), O(ce, "username", fe("getUsername", "setUsername")), O(ce, "password", fe("getPassword", "setPassword")), O(ce, "host", fe("getHost", "setHost")), O(ce, "hostname", fe("getHostname", "setHostname")), O(ce, "port", fe("getPort", "setPort")), O(ce, "pathname", fe("getPathname", "setPathname")), O(ce, "search", fe("getSearch", "setSearch")), O(ce, "searchParams", fe("getSearchParams")), O(ce, "hash", fe("getHash", "setHash"))), C(ce, "toJSON", function() {
          return M(this).serialize();
        }, { enumerable: !0 }), C(ce, "toString", function() {
          return M(this).serialize();
        }, { enumerable: !0 }), ue) {
          var we = ue.createObjectURL, Fe = ue.revokeObjectURL;
          we && C(W, "createObjectURL", y(we, ue)), Fe && C(W, "revokeObjectURL", y(Fe, ue));
        }
        D(W, "URL"), d({ global: !0, constructor: !0, forced: !m, sham: !p }, { URL: W });
      }, 285: function(l, v, s) {
        s(8789);
      }, 3720: function(l) {
        l.exports = s;
        var v = null;
        try {
          v = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
        } catch {
        }
        function s(M, V, J) {
          this.low = 0 | M, this.high = 0 | V, this.unsigned = !!J;
        }
        function c(M) {
          return (M && M.__isLong__) === !0;
        }
        s.prototype.__isLong__, Object.defineProperty(s.prototype, "__isLong__", { value: !0 }), s.isLong = c;
        var d = {}, p = {};
        function m(M, V) {
          var J, ue, se;
          return V ? (se = 0 <= (M >>>= 0) && M < 256) && (ue = p[M]) ? ue : (J = y(M, (0 | M) < 0 ? -1 : 0, !0), se && (p[M] = J), J) : (se = -128 <= (M |= 0) && M < 128) && (ue = d[M]) ? ue : (J = y(M, M < 0 ? -1 : 0, !1), se && (d[M] = J), J);
        }
        function E(M, V) {
          if (isNaN(M)) return V ? H : k;
          if (V) {
            if (M < 0) return H;
            if (M >= w) return j;
          } else {
            if (M <= -9223372036854776e3) return G;
            if (M + 1 >= _) return F;
          }
          return M < 0 ? E(-M, V).neg() : y(M % N | 0, M / N | 0, V);
        }
        function y(M, V, J) {
          return new s(M, V, J);
        }
        s.fromInt = m, s.fromNumber = E, s.fromBits = y;
        var g = Math.pow;
        function C(M, V, J) {
          if (M.length === 0) throw Error("empty string");
          if (M === "NaN" || M === "Infinity" || M === "+Infinity" || M === "-Infinity") return k;
          if (typeof V == "number" ? (J = V, V = !1) : V = !!V, (J = J || 10) < 2 || 36 < J) throw RangeError("radix");
          var ue;
          if ((ue = M.indexOf("-")) > 0) throw Error("interior hyphen");
          if (ue === 0) return C(M.substring(1), V, J).neg();
          for (var se = E(g(J, 8)), ee = k, de = 0; de < M.length; de += 8) {
            var he = Math.min(8, M.length - de), pe = parseInt(M.substring(de, de + he), J);
            if (he < 8) {
              var Ce = E(g(J, he));
              ee = ee.mul(Ce).add(E(pe));
            } else ee = (ee = ee.mul(se)).add(E(pe));
          }
          return ee.unsigned = V, ee;
        }
        function O(M, V) {
          return typeof M == "number" ? E(M, V) : typeof M == "string" ? C(M, V) : y(M.low, M.high, typeof V == "boolean" ? V : M.unsigned);
        }
        s.fromString = C, s.fromValue = O;
        var N = 4294967296, w = N * N, _ = w / 2, I = m(1 << 24), k = m(0);
        s.ZERO = k;
        var H = m(0, !0);
        s.UZERO = H;
        var S = m(1);
        s.ONE = S;
        var B = m(1, !0);
        s.UONE = B;
        var D = m(-1);
        s.NEG_ONE = D;
        var F = y(-1, 2147483647, !1);
        s.MAX_VALUE = F;
        var j = y(-1, -1, !0);
        s.MAX_UNSIGNED_VALUE = j;
        var G = y(0, -2147483648, !1);
        s.MIN_VALUE = G;
        var U = s.prototype;
        U.toInt = function() {
          return this.unsigned ? this.low >>> 0 : this.low;
        }, U.toNumber = function() {
          return this.unsigned ? (this.high >>> 0) * N + (this.low >>> 0) : this.high * N + (this.low >>> 0);
        }, U.toString = function(M) {
          if ((M = M || 10) < 2 || 36 < M) throw RangeError("radix");
          if (this.isZero()) return "0";
          if (this.isNegative()) {
            if (this.eq(G)) {
              var V = E(M), J = this.div(V), ue = J.mul(V).sub(this);
              return J.toString(M) + ue.toInt().toString(M);
            }
            return "-" + this.neg().toString(M);
          }
          for (var se = E(g(M, 6), this.unsigned), ee = this, de = ""; ; ) {
            var he = ee.div(se), pe = (ee.sub(he.mul(se)).toInt() >>> 0).toString(M);
            if ((ee = he).isZero()) return pe + de;
            for (; pe.length < 6; ) pe = "0" + pe;
            de = "" + pe + de;
          }
        }, U.getHighBits = function() {
          return this.high;
        }, U.getHighBitsUnsigned = function() {
          return this.high >>> 0;
        }, U.getLowBits = function() {
          return this.low;
        }, U.getLowBitsUnsigned = function() {
          return this.low >>> 0;
        }, U.getNumBitsAbs = function() {
          if (this.isNegative()) return this.eq(G) ? 64 : this.neg().getNumBitsAbs();
          for (var M = this.high != 0 ? this.high : this.low, V = 31; V > 0 && !(M & 1 << V); V--) ;
          return this.high != 0 ? V + 33 : V + 1;
        }, U.isZero = function() {
          return this.high === 0 && this.low === 0;
        }, U.eqz = U.isZero, U.isNegative = function() {
          return !this.unsigned && this.high < 0;
        }, U.isPositive = function() {
          return this.unsigned || this.high >= 0;
        }, U.isOdd = function() {
          return !(1 & ~this.low);
        }, U.isEven = function() {
          return !(1 & this.low);
        }, U.equals = function(M) {
          return c(M) || (M = O(M)), (this.unsigned === M.unsigned || this.high >>> 31 != 1 || M.high >>> 31 != 1) && this.high === M.high && this.low === M.low;
        }, U.eq = U.equals, U.notEquals = function(M) {
          return !this.eq(M);
        }, U.neq = U.notEquals, U.ne = U.notEquals, U.lessThan = function(M) {
          return this.comp(M) < 0;
        }, U.lt = U.lessThan, U.lessThanOrEqual = function(M) {
          return this.comp(M) <= 0;
        }, U.lte = U.lessThanOrEqual, U.le = U.lessThanOrEqual, U.greaterThan = function(M) {
          return this.comp(M) > 0;
        }, U.gt = U.greaterThan, U.greaterThanOrEqual = function(M) {
          return this.comp(M) >= 0;
        }, U.gte = U.greaterThanOrEqual, U.ge = U.greaterThanOrEqual, U.compare = function(M) {
          if (c(M) || (M = O(M)), this.eq(M)) return 0;
          var V = this.isNegative(), J = M.isNegative();
          return V && !J ? -1 : !V && J ? 1 : this.unsigned ? M.high >>> 0 > this.high >>> 0 || M.high === this.high && M.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(M).isNegative() ? -1 : 1;
        }, U.comp = U.compare, U.negate = function() {
          return !this.unsigned && this.eq(G) ? G : this.not().add(S);
        }, U.neg = U.negate, U.add = function(M) {
          c(M) || (M = O(M));
          var V = this.high >>> 16, J = 65535 & this.high, ue = this.low >>> 16, se = 65535 & this.low, ee = M.high >>> 16, de = 65535 & M.high, he = M.low >>> 16, pe = 0, Ce = 0, _e = 0, Le = 0;
          return _e += (Le += se + (65535 & M.low)) >>> 16, Ce += (_e += ue + he) >>> 16, pe += (Ce += J + de) >>> 16, pe += V + ee, y((_e &= 65535) << 16 | (Le &= 65535), (pe &= 65535) << 16 | (Ce &= 65535), this.unsigned);
        }, U.subtract = function(M) {
          return c(M) || (M = O(M)), this.add(M.neg());
        }, U.sub = U.subtract, U.multiply = function(M) {
          if (this.isZero()) return k;
          if (c(M) || (M = O(M)), v) return y(v.mul(this.low, this.high, M.low, M.high), v.get_high(), this.unsigned);
          if (M.isZero()) return k;
          if (this.eq(G)) return M.isOdd() ? G : k;
          if (M.eq(G)) return this.isOdd() ? G : k;
          if (this.isNegative()) return M.isNegative() ? this.neg().mul(M.neg()) : this.neg().mul(M).neg();
          if (M.isNegative()) return this.mul(M.neg()).neg();
          if (this.lt(I) && M.lt(I)) return E(this.toNumber() * M.toNumber(), this.unsigned);
          var V = this.high >>> 16, J = 65535 & this.high, ue = this.low >>> 16, se = 65535 & this.low, ee = M.high >>> 16, de = 65535 & M.high, he = M.low >>> 16, pe = 65535 & M.low, Ce = 0, _e = 0, Le = 0, Te = 0;
          return Le += (Te += se * pe) >>> 16, _e += (Le += ue * pe) >>> 16, Le &= 65535, _e += (Le += se * he) >>> 16, Ce += (_e += J * pe) >>> 16, _e &= 65535, Ce += (_e += ue * he) >>> 16, _e &= 65535, Ce += (_e += se * de) >>> 16, Ce += V * pe + J * he + ue * de + se * ee, y((Le &= 65535) << 16 | (Te &= 65535), (Ce &= 65535) << 16 | (_e &= 65535), this.unsigned);
        }, U.mul = U.multiply, U.divide = function(M) {
          if (c(M) || (M = O(M)), M.isZero()) throw Error("division by zero");
          var V, J, ue;
          if (v) return this.unsigned || this.high !== -2147483648 || M.low !== -1 || M.high !== -1 ? y((this.unsigned ? v.div_u : v.div_s)(this.low, this.high, M.low, M.high), v.get_high(), this.unsigned) : this;
          if (this.isZero()) return this.unsigned ? H : k;
          if (this.unsigned) {
            if (M.unsigned || (M = M.toUnsigned()), M.gt(this)) return H;
            if (M.gt(this.shru(1))) return B;
            ue = H;
          } else {
            if (this.eq(G)) return M.eq(S) || M.eq(D) ? G : M.eq(G) ? S : (V = this.shr(1).div(M).shl(1)).eq(k) ? M.isNegative() ? S : D : (J = this.sub(M.mul(V)), ue = V.add(J.div(M)));
            if (M.eq(G)) return this.unsigned ? H : k;
            if (this.isNegative()) return M.isNegative() ? this.neg().div(M.neg()) : this.neg().div(M).neg();
            if (M.isNegative()) return this.div(M.neg()).neg();
            ue = k;
          }
          for (J = this; J.gte(M); ) {
            V = Math.max(1, Math.floor(J.toNumber() / M.toNumber()));
            for (var se = Math.ceil(Math.log(V) / Math.LN2), ee = se <= 48 ? 1 : g(2, se - 48), de = E(V), he = de.mul(M); he.isNegative() || he.gt(J); ) he = (de = E(V -= ee, this.unsigned)).mul(M);
            de.isZero() && (de = S), ue = ue.add(de), J = J.sub(he);
          }
          return ue;
        }, U.div = U.divide, U.modulo = function(M) {
          return c(M) || (M = O(M)), v ? y((this.unsigned ? v.rem_u : v.rem_s)(this.low, this.high, M.low, M.high), v.get_high(), this.unsigned) : this.sub(this.div(M).mul(M));
        }, U.mod = U.modulo, U.rem = U.modulo, U.not = function() {
          return y(~this.low, ~this.high, this.unsigned);
        }, U.and = function(M) {
          return c(M) || (M = O(M)), y(this.low & M.low, this.high & M.high, this.unsigned);
        }, U.or = function(M) {
          return c(M) || (M = O(M)), y(this.low | M.low, this.high | M.high, this.unsigned);
        }, U.xor = function(M) {
          return c(M) || (M = O(M)), y(this.low ^ M.low, this.high ^ M.high, this.unsigned);
        }, U.shiftLeft = function(M) {
          return c(M) && (M = M.toInt()), (M &= 63) == 0 ? this : M < 32 ? y(this.low << M, this.high << M | this.low >>> 32 - M, this.unsigned) : y(0, this.low << M - 32, this.unsigned);
        }, U.shl = U.shiftLeft, U.shiftRight = function(M) {
          return c(M) && (M = M.toInt()), (M &= 63) == 0 ? this : M < 32 ? y(this.low >>> M | this.high << 32 - M, this.high >> M, this.unsigned) : y(this.high >> M - 32, this.high >= 0 ? 0 : -1, this.unsigned);
        }, U.shr = U.shiftRight, U.shiftRightUnsigned = function(M) {
          if (c(M) && (M = M.toInt()), (M &= 63) == 0) return this;
          var V = this.high;
          return M < 32 ? y(this.low >>> M | V << 32 - M, V >>> M, this.unsigned) : y(M === 32 ? V : V >>> M - 32, 0, this.unsigned);
        }, U.shru = U.shiftRightUnsigned, U.shr_u = U.shiftRightUnsigned, U.toSigned = function() {
          return this.unsigned ? y(this.low, this.high, !1) : this;
        }, U.toUnsigned = function() {
          return this.unsigned ? this : y(this.low, this.high, !0);
        }, U.toBytes = function(M) {
          return M ? this.toBytesLE() : this.toBytesBE();
        }, U.toBytesLE = function() {
          var M = this.high, V = this.low;
          return [255 & V, V >>> 8 & 255, V >>> 16 & 255, V >>> 24, 255 & M, M >>> 8 & 255, M >>> 16 & 255, M >>> 24];
        }, U.toBytesBE = function() {
          var M = this.high, V = this.low;
          return [M >>> 24, M >>> 16 & 255, M >>> 8 & 255, 255 & M, V >>> 24, V >>> 16 & 255, V >>> 8 & 255, 255 & V];
        }, s.fromBytes = function(M, V, J) {
          return J ? s.fromBytesLE(M, V) : s.fromBytesBE(M, V);
        }, s.fromBytesLE = function(M, V) {
          return new s(M[0] | M[1] << 8 | M[2] << 16 | M[3] << 24, M[4] | M[5] << 8 | M[6] << 16 | M[7] << 24, V);
        }, s.fromBytesBE = function(M, V) {
          return new s(M[4] << 24 | M[5] << 16 | M[6] << 8 | M[7], M[0] << 24 | M[1] << 16 | M[2] << 8 | M[3], V);
        };
      }, 3281: function(l, v, s) {
        l.exports = s(9050);
      }, 2967: function(l) {
        l.exports = c;
        var v, s = /\/|\./;
        function c(d, p) {
          s.test(d) || (d = "google/protobuf/" + d + ".proto", p = { nested: { google: { nested: { protobuf: { nested: p } } } } }), c[d] = p;
        }
        c("any", { Any: { fields: { type_url: { type: "string", id: 1 }, value: { type: "bytes", id: 2 } } } }), c("duration", { Duration: v = { fields: { seconds: { type: "int64", id: 1 }, nanos: { type: "int32", id: 2 } } } }), c("timestamp", { Timestamp: v }), c("empty", { Empty: { fields: {} } }), c("struct", { Struct: { fields: { fields: { keyType: "string", type: "Value", id: 1 } } }, Value: { oneofs: { kind: { oneof: ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"] } }, fields: { nullValue: { type: "NullValue", id: 1 }, numberValue: { type: "double", id: 2 }, stringValue: { type: "string", id: 3 }, boolValue: { type: "bool", id: 4 }, structValue: { type: "Struct", id: 5 }, listValue: { type: "ListValue", id: 6 } } }, NullValue: { values: { NULL_VALUE: 0 } }, ListValue: { fields: { values: { rule: "repeated", type: "Value", id: 1 } } } }), c("wrappers", { DoubleValue: { fields: { value: { type: "double", id: 1 } } }, FloatValue: { fields: { value: { type: "float", id: 1 } } }, Int64Value: { fields: { value: { type: "int64", id: 1 } } }, UInt64Value: { fields: { value: { type: "uint64", id: 1 } } }, Int32Value: { fields: { value: { type: "int32", id: 1 } } }, UInt32Value: { fields: { value: { type: "uint32", id: 1 } } }, BoolValue: { fields: { value: { type: "bool", id: 1 } } }, StringValue: { fields: { value: { type: "string", id: 1 } } }, BytesValue: { fields: { value: { type: "bytes", id: 1 } } } }), c("field_mask", { FieldMask: { fields: { paths: { rule: "repeated", type: "string", id: 1 } } } }), c.get = function(d) {
          return c[d] || null;
        };
      }, 3996: function(l, v, s) {
        var c = v, d = s(7025), p = s(9935);
        function m(y, g, C, O) {
          if (g.resolvedType) if (g.resolvedType instanceof d) {
            y("switch(d%s){", O);
            for (var N = g.resolvedType.values, w = Object.keys(N), _ = 0; _ < w.length; ++_) g.repeated && N[w[_]] === g.typeDefault && y("default:"), y("case%j:", w[_])("case %i:", N[w[_]])("m%s=%j", O, N[w[_]])("break");
            y("}");
          } else y('if(typeof d%s!=="object")', O)("throw TypeError(%j)", g.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", O, C, O);
          else {
            var I = !1;
            switch (g.type) {
              case "double":
              case "float":
                y("m%s=Number(d%s)", O, O);
                break;
              case "uint32":
              case "fixed32":
                y("m%s=d%s>>>0", O, O);
                break;
              case "int32":
              case "sint32":
              case "sfixed32":
                y("m%s=d%s|0", O, O);
                break;
              case "uint64":
                I = !0;
              case "int64":
              case "sint64":
              case "fixed64":
              case "sfixed64":
                y("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", O, O, I)('else if(typeof d%s==="string")', O)("m%s=parseInt(d%s,10)", O, O)('else if(typeof d%s==="number")', O)("m%s=d%s", O, O)('else if(typeof d%s==="object")', O)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", O, O, O, I ? "true" : "");
                break;
              case "bytes":
                y('if(typeof d%s==="string")', O)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", O, O, O)("else if(d%s.length)", O)("m%s=d%s", O, O);
                break;
              case "string":
                y("m%s=String(d%s)", O, O);
                break;
              case "bool":
                y("m%s=Boolean(d%s)", O, O);
            }
          }
          return y;
        }
        function E(y, g, C, O) {
          if (g.resolvedType) g.resolvedType instanceof d ? y("d%s=o.enums===String?types[%i].values[m%s]:m%s", O, C, O, O) : y("d%s=types[%i].toObject(m%s,o)", O, C, O);
          else {
            var N = !1;
            switch (g.type) {
              case "double":
              case "float":
                y("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", O, O, O, O);
                break;
              case "uint64":
                N = !0;
              case "int64":
              case "sint64":
              case "fixed64":
              case "sfixed64":
                y('if(typeof m%s==="number")', O)("d%s=o.longs===String?String(m%s):m%s", O, O, O)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", O, O, O, O, N ? "true" : "", O);
                break;
              case "bytes":
                y("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", O, O, O, O, O);
                break;
              default:
                y("d%s=m%s", O, O);
            }
          }
          return y;
        }
        c.fromObject = function(y) {
          var g = y.fieldsArray, C = p.codegen(["d"], y.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
          if (!g.length) return C("return new this.ctor");
          C("var m=new this.ctor");
          for (var O = 0; O < g.length; ++O) {
            var N = g[O].resolve(), w = p.safeProp(N.name);
            N.map ? (C("if(d%s){", w)('if(typeof d%s!=="object")', w)("throw TypeError(%j)", N.fullName + ": object expected")("m%s={}", w)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", w), m(C, N, O, w + "[ks[i]]")("}")("}")) : N.repeated ? (C("if(d%s){", w)("if(!Array.isArray(d%s))", w)("throw TypeError(%j)", N.fullName + ": array expected")("m%s=[]", w)("for(var i=0;i<d%s.length;++i){", w), m(C, N, O, w + "[i]")("}")("}")) : (N.resolvedType instanceof d || C("if(d%s!=null){", w), m(C, N, O, w), N.resolvedType instanceof d || C("}"));
          }
          return C("return m");
        }, c.toObject = function(y) {
          var g = y.fieldsArray.slice().sort(p.compareFieldsById);
          if (!g.length) return p.codegen()("return {}");
          for (var C = p.codegen(["m", "o"], y.name + "$toObject")("if(!o)")("o={}")("var d={}"), O = [], N = [], w = [], _ = 0; _ < g.length; ++_) g[_].partOf || (g[_].resolve().repeated ? O : g[_].map ? N : w).push(g[_]);
          if (O.length) {
            for (C("if(o.arrays||o.defaults){"), _ = 0; _ < O.length; ++_) C("d%s=[]", p.safeProp(O[_].name));
            C("}");
          }
          if (N.length) {
            for (C("if(o.objects||o.defaults){"), _ = 0; _ < N.length; ++_) C("d%s={}", p.safeProp(N[_].name));
            C("}");
          }
          if (w.length) {
            for (C("if(o.defaults){"), _ = 0; _ < w.length; ++_) {
              var I = w[_], k = p.safeProp(I.name);
              if (I.resolvedType instanceof d) C("d%s=o.enums===String?%j:%j", k, I.resolvedType.valuesById[I.typeDefault], I.typeDefault);
              else if (I.long) C("if(util.Long){")("var n=new util.Long(%i,%i,%j)", I.typeDefault.low, I.typeDefault.high, I.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", k)("}else")("d%s=o.longs===String?%j:%i", k, I.typeDefault.toString(), I.typeDefault.toNumber());
              else if (I.bytes) {
                var H = "[" + Array.prototype.slice.call(I.typeDefault).join(",") + "]";
                C("if(o.bytes===String)d%s=%j", k, String.fromCharCode.apply(String, I.typeDefault))("else{")("d%s=%s", k, H)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", k, k)("}");
              } else C("d%s=%j", k, I.typeDefault);
            }
            C("}");
          }
          var S = !1;
          for (_ = 0; _ < g.length; ++_) {
            I = g[_];
            var B = y._fieldsArray.indexOf(I);
            k = p.safeProp(I.name), I.map ? (S || (S = !0, C("var ks2")), C("if(m%s&&(ks2=Object.keys(m%s)).length){", k, k)("d%s={}", k)("for(var j=0;j<ks2.length;++j){"), E(C, I, B, k + "[ks2[j]]")("}")) : I.repeated ? (C("if(m%s&&m%s.length){", k, k)("d%s=[]", k)("for(var j=0;j<m%s.length;++j){", k), E(C, I, B, k + "[j]")("}")) : (C("if(m%s!=null&&m.hasOwnProperty(%j)){", k, I.name), E(C, I, B, k), I.partOf && C("if(o.oneofs)")("d%s=%j", p.safeProp(I.partOf.name), I.name)), C("}");
          }
          return C("return d");
        };
      }, 5305: function(l, v, s) {
        l.exports = function(E) {
          var y = p.codegen(["r", "l"], E.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (E.fieldsArray.filter(function(_) {
            return _.map;
          }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()");
          E.group && y("if((t&7)===4)")("break"), y("switch(t>>>3){");
          for (var g = 0; g < E.fieldsArray.length; ++g) {
            var C = E._fieldsArray[g].resolve(), O = C.resolvedType instanceof c ? "int32" : C.type, N = "m" + p.safeProp(C.name);
            y("case %i:", C.id), C.map ? (y("if(%s===util.emptyObject)", N)("%s={}", N)("var c2 = r.uint32()+r.pos"), d.defaults[C.keyType] !== void 0 ? y("k=%j", d.defaults[C.keyType]) : y("k=null"), d.defaults[O] !== void 0 ? y("value=%j", d.defaults[O]) : y("value=null"), y("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", C.keyType)("case 2:"), d.basic[O] === void 0 ? y("value=types[%i].decode(r,r.uint32())", g) : y("value=r.%s()", O), y("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), d.long[C.keyType] !== void 0 ? y('%s[typeof k==="object"?util.longToHash(k):k]=value', N) : y("%s[k]=value", N)) : C.repeated ? (y("if(!(%s&&%s.length))", N, N)("%s=[]", N), d.packed[O] !== void 0 && y("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", N, O)("}else"), d.basic[O] === void 0 ? y(C.resolvedType.group ? "%s.push(types[%i].decode(r))" : "%s.push(types[%i].decode(r,r.uint32()))", N, g) : y("%s.push(r.%s())", N, O)) : d.basic[O] === void 0 ? y(C.resolvedType.group ? "%s=types[%i].decode(r)" : "%s=types[%i].decode(r,r.uint32())", N, g) : y("%s=r.%s()", N, O), y("break");
          }
          for (y("default:")("r.skipType(t&7)")("break")("}")("}"), g = 0; g < E._fieldsArray.length; ++g) {
            var w = E._fieldsArray[g];
            w.required && y("if(!m.hasOwnProperty(%j))", w.name)("throw util.ProtocolError(%j,{instance:m})", m(w));
          }
          return y("return m");
        };
        var c = s(7025), d = s(7063), p = s(9935);
        function m(E) {
          return "missing required '" + E.name + "'";
        }
      }, 4928: function(l, v, s) {
        l.exports = function(E) {
          for (var y, g = p.codegen(["m", "w"], E.name + "$encode")("if(!w)")("w=Writer.create()"), C = E.fieldsArray.slice().sort(p.compareFieldsById), O = 0; O < C.length; ++O) {
            var N = C[O].resolve(), w = E._fieldsArray.indexOf(N), _ = N.resolvedType instanceof c ? "int32" : N.type, I = d.basic[_];
            y = "m" + p.safeProp(N.name), N.map ? (g("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", y, N.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", y)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (N.id << 3 | 2) >>> 0, 8 | d.mapKey[N.keyType], N.keyType), I === void 0 ? g("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", w, y) : g(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | I, _, y), g("}")("}")) : N.repeated ? (g("if(%s!=null&&%s.length){", y, y), N.packed && d.packed[_] !== void 0 ? g("w.uint32(%i).fork()", (N.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", y)("w.%s(%s[i])", _, y)("w.ldelim()") : (g("for(var i=0;i<%s.length;++i)", y), I === void 0 ? m(g, N, w, y + "[i]") : g("w.uint32(%i).%s(%s[i])", (N.id << 3 | I) >>> 0, _, y)), g("}")) : (N.optional && g("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", y, N.name), I === void 0 ? m(g, N, w, y) : g("w.uint32(%i).%s(%s)", (N.id << 3 | I) >>> 0, _, y));
          }
          return g("return w");
        };
        var c = s(7025), d = s(7063), p = s(9935);
        function m(E, y, g, C) {
          return y.resolvedType.group ? E("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", g, C, (y.id << 3 | 3) >>> 0, (y.id << 3 | 4) >>> 0) : E("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", g, C, (y.id << 3 | 2) >>> 0);
        }
      }, 7025: function(l, v, s) {
        l.exports = m;
        var c = s(3243);
        ((m.prototype = Object.create(c.prototype)).constructor = m).className = "Enum";
        var d = s(9313), p = s(9935);
        function m(E, y, g, C, O) {
          if (c.call(this, E, g), y && typeof y != "object") throw TypeError("values must be an object");
          if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = C, this.comments = O || {}, this.reserved = void 0, y) for (var N = Object.keys(y), w = 0; w < N.length; ++w) typeof y[N[w]] == "number" && (this.valuesById[this.values[N[w]] = y[N[w]]] = N[w]);
        }
        m.fromJSON = function(E, y) {
          var g = new m(E, y.values, y.options, y.comment, y.comments);
          return g.reserved = y.reserved, g;
        }, m.prototype.toJSON = function(E) {
          var y = !!E && !!E.keepComments;
          return p.toObject(["options", this.options, "values", this.values, "reserved", this.reserved && this.reserved.length ? this.reserved : void 0, "comment", y ? this.comment : void 0, "comments", y ? this.comments : void 0]);
        }, m.prototype.add = function(E, y, g) {
          if (!p.isString(E)) throw TypeError("name must be a string");
          if (!p.isInteger(y)) throw TypeError("id must be an integer");
          if (this.values[E] !== void 0) throw Error("duplicate name '" + E + "' in " + this);
          if (this.isReservedId(y)) throw Error("id " + y + " is reserved in " + this);
          if (this.isReservedName(E)) throw Error("name '" + E + "' is reserved in " + this);
          if (this.valuesById[y] !== void 0) {
            if (!this.options || !this.options.allow_alias) throw Error("duplicate id " + y + " in " + this);
            this.values[E] = y;
          } else this.valuesById[this.values[E] = y] = E;
          return this.comments[E] = g || null, this;
        }, m.prototype.remove = function(E) {
          if (!p.isString(E)) throw TypeError("name must be a string");
          var y = this.values[E];
          if (y == null) throw Error("name '" + E + "' does not exist in " + this);
          return delete this.valuesById[y], delete this.values[E], delete this.comments[E], this;
        }, m.prototype.isReservedId = function(E) {
          return d.isReservedId(this.reserved, E);
        }, m.prototype.isReservedName = function(E) {
          return d.isReservedName(this.reserved, E);
        };
      }, 3548: function(l, v, s) {
        l.exports = g;
        var c = s(3243);
        ((g.prototype = Object.create(c.prototype)).constructor = g).className = "Field";
        var d, p = s(7025), m = s(7063), E = s(9935), y = /^required|optional|repeated$/;
        function g(C, O, N, w, _, I, k) {
          if (E.isObject(w) ? (k = _, I = w, w = _ = void 0) : E.isObject(_) && (k = I, I = _, _ = void 0), c.call(this, C, I), !E.isInteger(O) || O < 0) throw TypeError("id must be a non-negative integer");
          if (!E.isString(N)) throw TypeError("type must be a string");
          if (w !== void 0 && !y.test(w = w.toString().toLowerCase())) throw TypeError("rule must be a string rule");
          if (_ !== void 0 && !E.isString(_)) throw TypeError("extend must be a string");
          w === "proto3_optional" && (w = "optional"), this.rule = w && w !== "optional" ? w : void 0, this.type = N, this.id = O, this.extend = _ || void 0, this.required = w === "required", this.optional = !this.required, this.repeated = w === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = !!E.Long && m.long[N] !== void 0, this.bytes = N === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this._packed = null, this.comment = k;
        }
        g.fromJSON = function(C, O) {
          return new g(C, O.id, O.type, O.rule, O.extend, O.options, O.comment);
        }, Object.defineProperty(g.prototype, "packed", { get: function() {
          return this._packed === null && (this._packed = this.getOption("packed") !== !1), this._packed;
        } }), g.prototype.setOption = function(C, O, N) {
          return C === "packed" && (this._packed = null), c.prototype.setOption.call(this, C, O, N);
        }, g.prototype.toJSON = function(C) {
          var O = !!C && !!C.keepComments;
          return E.toObject(["rule", this.rule !== "optional" && this.rule || void 0, "type", this.type, "id", this.id, "extend", this.extend, "options", this.options, "comment", O ? this.comment : void 0]);
        }, g.prototype.resolve = function() {
          if (this.resolved) return this;
          if ((this.typeDefault = m.defaults[this.type]) === void 0 && (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof d ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof p && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (this.options.packed !== !0 && (this.options.packed === void 0 || !this.resolvedType || this.resolvedType instanceof p) || delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long) this.typeDefault = E.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
          else if (this.bytes && typeof this.typeDefault == "string") {
            var C;
            E.base64.test(this.typeDefault) ? E.base64.decode(this.typeDefault, C = E.newBuffer(E.base64.length(this.typeDefault)), 0) : E.utf8.write(this.typeDefault, C = E.newBuffer(E.utf8.length(this.typeDefault)), 0), this.typeDefault = C;
          }
          return this.map ? this.defaultValue = E.emptyObject : this.repeated ? this.defaultValue = E.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof d && (this.parent.ctor.prototype[this.name] = this.defaultValue), c.prototype.resolve.call(this);
        }, g.d = function(C, O, N, w) {
          return typeof O == "function" ? O = E.decorateType(O).name : O && typeof O == "object" && (O = E.decorateEnum(O).name), function(_, I) {
            E.decorateType(_.constructor).add(new g(I, C, O, N, { default: w }));
          };
        }, g._configure = function(C) {
          d = C;
        };
      }, 8836: function(l, v, s) {
        var c = l.exports = s(9482);
        c.build = "light", c.load = function(d, p, m) {
          return typeof p == "function" ? (m = p, p = new c.Root()) : p || (p = new c.Root()), p.load(d, m);
        }, c.loadSync = function(d, p) {
          return p || (p = new c.Root()), p.loadSync(d);
        }, c.encoder = s(4928), c.decoder = s(5305), c.verifier = s(4497), c.converter = s(3996), c.ReflectionObject = s(3243), c.Namespace = s(9313), c.Root = s(9424), c.Enum = s(7025), c.Type = s(7645), c.Field = s(3548), c.OneOf = s(7598), c.MapField = s(6039), c.Service = s(7513), c.Method = s(4429), c.Message = s(8368), c.wrappers = s(1667), c.types = s(7063), c.util = s(9935), c.ReflectionObject._configure(c.Root), c.Namespace._configure(c.Type, c.Service, c.Enum), c.Root._configure(c.Type), c.Field._configure(c.Type);
      }, 9482: function(l, v, s) {
        var c = v;
        function d() {
          c.util._configure(), c.Writer._configure(c.BufferWriter), c.Reader._configure(c.BufferReader);
        }
        c.build = "minimal", c.Writer = s(1173), c.BufferWriter = s(3155), c.Reader = s(1408), c.BufferReader = s(593), c.util = s(9693), c.rpc = s(5994), c.roots = s(5054), c.configure = d, d();
      }, 9050: function(l, v, s) {
        var c = l.exports = s(8836);
        c.build = "full", c.tokenize = s(626), c.parse = s(2228), c.common = s(2967), c.Root._configure(c.Type, c.parse, c.common);
      }, 6039: function(l, v, s) {
        l.exports = m;
        var c = s(3548);
        ((m.prototype = Object.create(c.prototype)).constructor = m).className = "MapField";
        var d = s(7063), p = s(9935);
        function m(E, y, g, C, O, N) {
          if (c.call(this, E, y, C, void 0, void 0, O, N), !p.isString(g)) throw TypeError("keyType must be a string");
          this.keyType = g, this.resolvedKeyType = null, this.map = !0;
        }
        m.fromJSON = function(E, y) {
          return new m(E, y.id, y.keyType, y.type, y.options, y.comment);
        }, m.prototype.toJSON = function(E) {
          var y = !!E && !!E.keepComments;
          return p.toObject(["keyType", this.keyType, "type", this.type, "id", this.id, "extend", this.extend, "options", this.options, "comment", y ? this.comment : void 0]);
        }, m.prototype.resolve = function() {
          if (this.resolved) return this;
          if (d.mapKey[this.keyType] === void 0) throw Error("invalid key type: " + this.keyType);
          return c.prototype.resolve.call(this);
        }, m.d = function(E, y, g) {
          return typeof g == "function" ? g = p.decorateType(g).name : g && typeof g == "object" && (g = p.decorateEnum(g).name), function(C, O) {
            p.decorateType(C.constructor).add(new m(O, E, y, g));
          };
        };
      }, 8368: function(l, v, s) {
        l.exports = d;
        var c = s(9693);
        function d(p) {
          if (p) for (var m = Object.keys(p), E = 0; E < m.length; ++E) this[m[E]] = p[m[E]];
        }
        d.create = function(p) {
          return this.$type.create(p);
        }, d.encode = function(p, m) {
          return this.$type.encode(p, m);
        }, d.encodeDelimited = function(p, m) {
          return this.$type.encodeDelimited(p, m);
        }, d.decode = function(p) {
          return this.$type.decode(p);
        }, d.decodeDelimited = function(p) {
          return this.$type.decodeDelimited(p);
        }, d.verify = function(p) {
          return this.$type.verify(p);
        }, d.fromObject = function(p) {
          return this.$type.fromObject(p);
        }, d.toObject = function(p, m) {
          return this.$type.toObject(p, m);
        }, d.prototype.toJSON = function() {
          return this.$type.toObject(this, c.toJSONOptions);
        };
      }, 4429: function(l, v, s) {
        l.exports = p;
        var c = s(3243);
        ((p.prototype = Object.create(c.prototype)).constructor = p).className = "Method";
        var d = s(9935);
        function p(m, E, y, g, C, O, N, w, _) {
          if (d.isObject(C) ? (N = C, C = O = void 0) : d.isObject(O) && (N = O, O = void 0), E !== void 0 && !d.isString(E)) throw TypeError("type must be a string");
          if (!d.isString(y)) throw TypeError("requestType must be a string");
          if (!d.isString(g)) throw TypeError("responseType must be a string");
          c.call(this, m, N), this.type = E || "rpc", this.requestType = y, this.requestStream = !!C || void 0, this.responseType = g, this.responseStream = !!O || void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = w, this.parsedOptions = _;
        }
        p.fromJSON = function(m, E) {
          return new p(m, E.type, E.requestType, E.responseType, E.requestStream, E.responseStream, E.options, E.comment, E.parsedOptions);
        }, p.prototype.toJSON = function(m) {
          var E = !!m && !!m.keepComments;
          return d.toObject(["type", this.type !== "rpc" && this.type || void 0, "requestType", this.requestType, "requestStream", this.requestStream, "responseType", this.responseType, "responseStream", this.responseStream, "options", this.options, "comment", E ? this.comment : void 0, "parsedOptions", this.parsedOptions]);
        }, p.prototype.resolve = function() {
          return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), c.prototype.resolve.call(this));
        };
      }, 9313: function(l, v, s) {
        l.exports = O;
        var c = s(3243);
        ((O.prototype = Object.create(c.prototype)).constructor = O).className = "Namespace";
        var d, p, m, E = s(3548), y = s(7598), g = s(9935);
        function C(w, _) {
          if (w && w.length) {
            for (var I = {}, k = 0; k < w.length; ++k) I[w[k].name] = w[k].toJSON(_);
            return I;
          }
        }
        function O(w, _) {
          c.call(this, w, _), this.nested = void 0, this._nestedArray = null;
        }
        function N(w) {
          return w._nestedArray = null, w;
        }
        O.fromJSON = function(w, _) {
          return new O(w, _.options).addJSON(_.nested);
        }, O.arrayToJSON = C, O.isReservedId = function(w, _) {
          if (w) {
            for (var I = 0; I < w.length; ++I) if (typeof w[I] != "string" && w[I][0] <= _ && w[I][1] > _) return !0;
          }
          return !1;
        }, O.isReservedName = function(w, _) {
          if (w) {
            for (var I = 0; I < w.length; ++I) if (w[I] === _) return !0;
          }
          return !1;
        }, Object.defineProperty(O.prototype, "nestedArray", { get: function() {
          return this._nestedArray || (this._nestedArray = g.toArray(this.nested));
        } }), O.prototype.toJSON = function(w) {
          return g.toObject(["options", this.options, "nested", C(this.nestedArray, w)]);
        }, O.prototype.addJSON = function(w) {
          if (w) for (var _, I = Object.keys(w), k = 0; k < I.length; ++k) _ = w[I[k]], this.add((_.fields !== void 0 ? d.fromJSON : _.values !== void 0 ? m.fromJSON : _.methods !== void 0 ? p.fromJSON : _.id !== void 0 ? E.fromJSON : O.fromJSON)(I[k], _));
          return this;
        }, O.prototype.get = function(w) {
          return this.nested && this.nested[w] || null;
        }, O.prototype.getEnum = function(w) {
          if (this.nested && this.nested[w] instanceof m) return this.nested[w].values;
          throw Error("no such enum: " + w);
        }, O.prototype.add = function(w) {
          if (!(w instanceof E && w.extend !== void 0 || w instanceof d || w instanceof m || w instanceof p || w instanceof O || w instanceof y)) throw TypeError("object must be a valid nested object");
          if (this.nested) {
            var _ = this.get(w.name);
            if (_) {
              if (!(_ instanceof O && w instanceof O) || _ instanceof d || _ instanceof p) throw Error("duplicate name '" + w.name + "' in " + this);
              for (var I = _.nestedArray, k = 0; k < I.length; ++k) w.add(I[k]);
              this.remove(_), this.nested || (this.nested = {}), w.setOptions(_.options, !0);
            }
          } else this.nested = {};
          return this.nested[w.name] = w, w.onAdd(this), N(this);
        }, O.prototype.remove = function(w) {
          if (!(w instanceof c)) throw TypeError("object must be a ReflectionObject");
          if (w.parent !== this) throw Error(w + " is not a member of " + this);
          return delete this.nested[w.name], Object.keys(this.nested).length || (this.nested = void 0), w.onRemove(this), N(this);
        }, O.prototype.define = function(w, _) {
          if (g.isString(w)) w = w.split(".");
          else if (!Array.isArray(w)) throw TypeError("illegal path");
          if (w && w.length && w[0] === "") throw Error("path must be relative");
          for (var I = this; w.length > 0; ) {
            var k = w.shift();
            if (I.nested && I.nested[k]) {
              if (!((I = I.nested[k]) instanceof O)) throw Error("path conflicts with non-namespace objects");
            } else I.add(I = new O(k));
          }
          return _ && I.addJSON(_), I;
        }, O.prototype.resolveAll = function() {
          for (var w = this.nestedArray, _ = 0; _ < w.length; ) w[_] instanceof O ? w[_++].resolveAll() : w[_++].resolve();
          return this.resolve();
        }, O.prototype.lookup = function(w, _, I) {
          if (typeof _ == "boolean" ? (I = _, _ = void 0) : _ && !Array.isArray(_) && (_ = [_]), g.isString(w) && w.length) {
            if (w === ".") return this.root;
            w = w.split(".");
          } else if (!w.length) return this;
          if (w[0] === "") return this.root.lookup(w.slice(1), _);
          var k = this.get(w[0]);
          if (k) {
            if (w.length === 1) {
              if (!_ || _.indexOf(k.constructor) > -1) return k;
            } else if (k instanceof O && (k = k.lookup(w.slice(1), _, !0))) return k;
          } else for (var H = 0; H < this.nestedArray.length; ++H) if (this._nestedArray[H] instanceof O && (k = this._nestedArray[H].lookup(w, _, !0))) return k;
          return this.parent === null || I ? null : this.parent.lookup(w, _);
        }, O.prototype.lookupType = function(w) {
          var _ = this.lookup(w, [d]);
          if (!_) throw Error("no such type: " + w);
          return _;
        }, O.prototype.lookupEnum = function(w) {
          var _ = this.lookup(w, [m]);
          if (!_) throw Error("no such Enum '" + w + "' in " + this);
          return _;
        }, O.prototype.lookupTypeOrEnum = function(w) {
          var _ = this.lookup(w, [d, m]);
          if (!_) throw Error("no such Type or Enum '" + w + "' in " + this);
          return _;
        }, O.prototype.lookupService = function(w) {
          var _ = this.lookup(w, [p]);
          if (!_) throw Error("no such Service '" + w + "' in " + this);
          return _;
        }, O._configure = function(w, _, I) {
          d = w, p = _, m = I;
        };
      }, 3243: function(l, v, s) {
        l.exports = p, p.className = "ReflectionObject";
        var c, d = s(9935);
        function p(m, E) {
          if (!d.isString(m)) throw TypeError("name must be a string");
          if (E && !d.isObject(E)) throw TypeError("options must be an object");
          this.options = E, this.parsedOptions = null, this.name = m, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
        }
        Object.defineProperties(p.prototype, { root: { get: function() {
          for (var m = this; m.parent !== null; ) m = m.parent;
          return m;
        } }, fullName: { get: function() {
          for (var m = [this.name], E = this.parent; E; ) m.unshift(E.name), E = E.parent;
          return m.join(".");
        } } }), p.prototype.toJSON = function() {
          throw Error();
        }, p.prototype.onAdd = function(m) {
          this.parent && this.parent !== m && this.parent.remove(this), this.parent = m, this.resolved = !1;
          var E = m.root;
          E instanceof c && E._handleAdd(this);
        }, p.prototype.onRemove = function(m) {
          var E = m.root;
          E instanceof c && E._handleRemove(this), this.parent = null, this.resolved = !1;
        }, p.prototype.resolve = function() {
          return this.resolved || this.root instanceof c && (this.resolved = !0), this;
        }, p.prototype.getOption = function(m) {
          if (this.options) return this.options[m];
        }, p.prototype.setOption = function(m, E, y) {
          return y && this.options && this.options[m] !== void 0 || ((this.options || (this.options = {}))[m] = E), this;
        }, p.prototype.setParsedOption = function(m, E, y) {
          this.parsedOptions || (this.parsedOptions = []);
          var g = this.parsedOptions;
          if (y) {
            var C = g.find(function(w) {
              return Object.prototype.hasOwnProperty.call(w, m);
            });
            if (C) {
              var O = C[m];
              d.setProperty(O, y, E);
            } else (C = {})[m] = d.setProperty({}, y, E), g.push(C);
          } else {
            var N = {};
            N[m] = E, g.push(N);
          }
          return this;
        }, p.prototype.setOptions = function(m, E) {
          if (m) for (var y = Object.keys(m), g = 0; g < y.length; ++g) this.setOption(y[g], m[y[g]], E);
          return this;
        }, p.prototype.toString = function() {
          var m = this.constructor.className, E = this.fullName;
          return E.length ? m + " " + E : m;
        }, p._configure = function(m) {
          c = m;
        };
      }, 7598: function(l, v, s) {
        l.exports = m;
        var c = s(3243);
        ((m.prototype = Object.create(c.prototype)).constructor = m).className = "OneOf";
        var d = s(3548), p = s(9935);
        function m(y, g, C, O) {
          if (Array.isArray(g) || (C = g, g = void 0), c.call(this, y, C), g !== void 0 && !Array.isArray(g)) throw TypeError("fieldNames must be an Array");
          this.oneof = g || [], this.fieldsArray = [], this.comment = O;
        }
        function E(y) {
          if (y.parent) for (var g = 0; g < y.fieldsArray.length; ++g) y.fieldsArray[g].parent || y.parent.add(y.fieldsArray[g]);
        }
        m.fromJSON = function(y, g) {
          return new m(y, g.oneof, g.options, g.comment);
        }, m.prototype.toJSON = function(y) {
          var g = !!y && !!y.keepComments;
          return p.toObject(["options", this.options, "oneof", this.oneof, "comment", g ? this.comment : void 0]);
        }, m.prototype.add = function(y) {
          if (!(y instanceof d)) throw TypeError("field must be a Field");
          return y.parent && y.parent !== this.parent && y.parent.remove(y), this.oneof.push(y.name), this.fieldsArray.push(y), y.partOf = this, E(this), this;
        }, m.prototype.remove = function(y) {
          if (!(y instanceof d)) throw TypeError("field must be a Field");
          var g = this.fieldsArray.indexOf(y);
          if (g < 0) throw Error(y + " is not a member of " + this);
          return this.fieldsArray.splice(g, 1), (g = this.oneof.indexOf(y.name)) > -1 && this.oneof.splice(g, 1), y.partOf = null, this;
        }, m.prototype.onAdd = function(y) {
          c.prototype.onAdd.call(this, y);
          for (var g = 0; g < this.oneof.length; ++g) {
            var C = y.get(this.oneof[g]);
            C && !C.partOf && (C.partOf = this, this.fieldsArray.push(C));
          }
          E(this);
        }, m.prototype.onRemove = function(y) {
          for (var g, C = 0; C < this.fieldsArray.length; ++C) (g = this.fieldsArray[C]).parent && g.parent.remove(g);
          c.prototype.onRemove.call(this, y);
        }, m.d = function() {
          for (var y = new Array(arguments.length), g = 0; g < arguments.length; ) y[g] = arguments[g++];
          return function(C, O) {
            p.decorateType(C.constructor).add(new m(O, y)), Object.defineProperty(C, O, { get: p.oneOfGetter(y), set: p.oneOfSetter(y) });
          };
        };
      }, 2228: function(l, v, s) {
        l.exports = U, U.filename = null, U.defaults = { keepCase: !1 };
        var c = s(626), d = s(9424), p = s(7645), m = s(3548), E = s(6039), y = s(7598), g = s(7025), C = s(7513), O = s(4429), N = s(7063), w = s(9935), _ = /^[1-9][0-9]*$/, I = /^-?[1-9][0-9]*$/, k = /^0[x][0-9a-fA-F]+$/, H = /^-?0[x][0-9a-fA-F]+$/, S = /^0[0-7]+$/, B = /^-?0[0-7]+$/, D = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, F = /^[a-zA-Z_][a-zA-Z_0-9]*$/, j = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/, G = /^(?:\.[a-zA-Z_][a-zA-Z_0-9]*)+$/;
        function U(M, V, J) {
          V instanceof d || (J = V, V = new d()), J || (J = U.defaults);
          var ue, se, ee, de, he, pe = J.preferTrailingComment || !1, Ce = c(M, J.alternateCommentMode || !1), _e = Ce.next, Le = Ce.push, Te = Ce.peek, K = Ce.skip, Oe = Ce.cmnt, Pe = !0, xe = !1, be = V, $e = J.keepCase ? function(Et) {
            return Et;
          } : w.camelCase;
          function Be(Et, ut, St) {
            var Ft = U.filename;
            return St || (U.filename = null), Error("illegal " + (ut || "token") + " '" + Et + "' (" + (Ft ? Ft + ", " : "") + "line " + Ce.line + ")");
          }
          function Ke() {
            var Et, ut = [];
            do {
              if ((Et = _e()) !== '"' && Et !== "'") throw Be(Et);
              ut.push(_e()), K(Et), Et = Te();
            } while (Et === '"' || Et === "'");
            return ut.join("");
          }
          function Ze(Et) {
            var ut = _e();
            switch (ut) {
              case "'":
              case '"':
                return Le(ut), Ke();
              case "true":
              case "TRUE":
                return !0;
              case "false":
              case "FALSE":
                return !1;
            }
            try {
              return function(St) {
                var Ft = 1;
                switch (St.charAt(0) === "-" && (Ft = -1, St = St.substring(1)), St) {
                  case "inf":
                  case "INF":
                  case "Inf":
                    return Ft * (1 / 0);
                  case "nan":
                  case "NAN":
                  case "Nan":
                  case "NaN":
                    return NaN;
                  case "0":
                    return 0;
                }
                if (_.test(St)) return Ft * parseInt(St, 10);
                if (k.test(St)) return Ft * parseInt(St, 16);
                if (S.test(St)) return Ft * parseInt(St, 8);
                if (D.test(St)) return Ft * parseFloat(St);
                throw Be(St, "number", !0);
              }(ut);
            } catch {
              if (j.test(ut)) return ut;
              throw Be(ut, "value");
            }
          }
          function at(Et, ut) {
            var St, Ft;
            do
              !ut || (St = Te()) !== '"' && St !== "'" ? Et.push([Ft = pt(_e()), K("to", !0) ? pt(_e()) : Ft]) : Et.push(Ke());
            while (K(",", !0));
            K(";");
          }
          function pt(Et, ut) {
            switch (Et) {
              case "max":
              case "MAX":
              case "Max":
                return 536870911;
              case "0":
                return 0;
            }
            if (!ut && Et.charAt(0) === "-") throw Be(Et, "id");
            if (I.test(Et)) return parseInt(Et, 10);
            if (H.test(Et)) return parseInt(Et, 16);
            if (B.test(Et)) return parseInt(Et, 8);
            throw Be(Et, "id");
          }
          function It() {
            if (ue !== void 0) throw Be("package");
            if (ue = _e(), !j.test(ue)) throw Be(ue, "name");
            be = be.define(ue), K(";");
          }
          function Rt() {
            var Et, ut = Te();
            switch (ut) {
              case "weak":
                Et = ee || (ee = []), _e();
                break;
              case "public":
                _e();
              default:
                Et = se || (se = []);
            }
            ut = Ke(), K(";"), Et.push(ut);
          }
          function gt() {
            if (K("="), de = Ke(), !(xe = de === "proto3") && de !== "proto2") throw Be(de, "syntax");
            K(";");
          }
          function it(Et, ut) {
            switch (ut) {
              case "option":
                return st(Et, ut), K(";"), !0;
              case "message":
                return function(St, Ft) {
                  if (!F.test(Ft = _e())) throw Be(Ft, "type name");
                  var Ht = new p(Ft);
                  Tt(Ht, function(zt) {
                    if (!it(Ht, zt)) switch (zt) {
                      case "map":
                        (function(ze) {
                          K("<");
                          var Ne = _e();
                          if (N.mapKey[Ne] === void 0) throw Be(Ne, "type");
                          K(",");
                          var le = _e();
                          if (!j.test(le)) throw Be(le, "type");
                          K(">");
                          var X = _e();
                          if (!F.test(X)) throw Be(X, "name");
                          K("=");
                          var re = new E($e(X), pt(_e()), Ne, le);
                          Tt(re, function(Me) {
                            if (Me !== "option") throw Be(Me);
                            st(re, Me), K(";");
                          }, function() {
                            wt(re);
                          }), ze.add(re);
                        })(Ht);
                        break;
                      case "required":
                      case "repeated":
                        Ut(Ht, zt);
                        break;
                      case "optional":
                        Ut(Ht, xe ? "proto3_optional" : "optional");
                        break;
                      case "oneof":
                        (function(ze, Ne) {
                          if (!F.test(Ne = _e())) throw Be(Ne, "name");
                          var le = new y($e(Ne));
                          Tt(le, function(X) {
                            X === "option" ? (st(le, X), K(";")) : (Le(X), Ut(le, "optional"));
                          }), ze.add(le);
                        })(Ht, zt);
                        break;
                      case "extensions":
                        at(Ht.extensions || (Ht.extensions = []));
                        break;
                      case "reserved":
                        at(Ht.reserved || (Ht.reserved = []), !0);
                        break;
                      default:
                        if (!xe || !j.test(zt)) throw Be(zt);
                        Le(zt), Ut(Ht, "optional");
                    }
                  }), St.add(Ht);
                }(Et, ut), !0;
              case "enum":
                return function(St, Ft) {
                  if (!F.test(Ft = _e())) throw Be(Ft, "name");
                  var Ht = new g(Ft);
                  Tt(Ht, function(zt) {
                    switch (zt) {
                      case "option":
                        st(Ht, zt), K(";");
                        break;
                      case "reserved":
                        at(Ht.reserved || (Ht.reserved = []), !0);
                        break;
                      default:
                        (function(ze, Ne) {
                          if (!F.test(Ne)) throw Be(Ne, "name");
                          K("=");
                          var le = pt(_e(), !0), X = {};
                          Tt(X, function(re) {
                            if (re !== "option") throw Be(re);
                            st(X, re), K(";");
                          }, function() {
                            wt(X);
                          }), ze.add(Ne, le, X.comment);
                        })(Ht, zt);
                    }
                  }), St.add(Ht);
                }(Et, ut), !0;
              case "service":
                return function(St, Ft) {
                  if (!F.test(Ft = _e())) throw Be(Ft, "service name");
                  var Ht = new C(Ft);
                  Tt(Ht, function(zt) {
                    if (!it(Ht, zt)) {
                      if (zt !== "rpc") throw Be(zt);
                      (function(ze, Ne) {
                        var le = Oe(), X = Ne;
                        if (!F.test(Ne = _e())) throw Be(Ne, "name");
                        var re, Me, Se, ke, Ge = Ne;
                        if (K("("), K("stream", !0) && (Me = !0), !j.test(Ne = _e()) || (re = Ne, K(")"), K("returns"), K("("), K("stream", !0) && (ke = !0), !j.test(Ne = _e()))) throw Be(Ne);
                        Se = Ne, K(")");
                        var nt = new O(Ge, X, re, Se, Me, ke);
                        nt.comment = le, Tt(nt, function(rt) {
                          if (rt !== "option") throw Be(rt);
                          st(nt, rt), K(";");
                        }), ze.add(nt);
                      })(Ht, zt);
                    }
                  }), St.add(Ht);
                }(Et, ut), !0;
              case "extend":
                return function(St, Ft) {
                  if (!j.test(Ft = _e())) throw Be(Ft, "reference");
                  var Ht = Ft;
                  Tt(null, function(zt) {
                    switch (zt) {
                      case "required":
                      case "repeated":
                        Ut(St, zt, Ht);
                        break;
                      case "optional":
                        Ut(St, xe ? "proto3_optional" : "optional", Ht);
                        break;
                      default:
                        if (!xe || !j.test(zt)) throw Be(zt);
                        Le(zt), Ut(St, "optional", Ht);
                    }
                  });
                }(Et, ut), !0;
            }
            return !1;
          }
          function Tt(Et, ut, St) {
            var Ft = Ce.line;
            if (Et && (typeof Et.comment != "string" && (Et.comment = Oe()), Et.filename = U.filename), K("{", !0)) {
              for (var Ht; (Ht = _e()) !== "}"; ) ut(Ht);
              K(";", !0);
            } else St && St(), K(";"), Et && (typeof Et.comment != "string" || pe) && (Et.comment = Oe(Ft) || Et.comment);
          }
          function Ut(Et, ut, St) {
            var Ft = _e();
            if (Ft !== "group") {
              if (!j.test(Ft)) throw Be(Ft, "type");
              var Ht = _e();
              if (!F.test(Ht)) throw Be(Ht, "name");
              Ht = $e(Ht), K("=");
              var zt = new m(Ht, pt(_e()), Ft, ut, St);
              if (Tt(zt, function(Ne) {
                if (Ne !== "option") throw Be(Ne);
                st(zt, Ne), K(";");
              }, function() {
                wt(zt);
              }), ut === "proto3_optional") {
                var ze = new y("_" + Ht);
                zt.setOption("proto3_optional", !0), ze.add(zt), Et.add(ze);
              } else Et.add(zt);
              xe || !zt.repeated || N.packed[Ft] === void 0 && N.basic[Ft] !== void 0 || zt.setOption("packed", !1, !0);
            } else (function(Ne, le) {
              var X = _e();
              if (!F.test(X)) throw Be(X, "name");
              var re = w.lcFirst(X);
              X === re && (X = w.ucFirst(X)), K("=");
              var Me = pt(_e()), Se = new p(X);
              Se.group = !0;
              var ke = new m(re, Me, X, le);
              ke.filename = U.filename, Tt(Se, function(Ge) {
                switch (Ge) {
                  case "option":
                    st(Se, Ge), K(";");
                    break;
                  case "required":
                  case "repeated":
                    Ut(Se, Ge);
                    break;
                  case "optional":
                    Ut(Se, xe ? "proto3_optional" : "optional");
                    break;
                  default:
                    throw Be(Ge);
                }
              }), Ne.add(Se).add(ke);
            })(Et, ut);
          }
          function st(Et, ut) {
            var St = K("(", !0);
            if (!j.test(ut = _e())) throw Be(ut, "name");
            var Ft, Ht = ut, zt = Ht;
            St && (K(")"), zt = Ht = "(" + Ht + ")", ut = Te(), G.test(ut) && (Ft = ut.substr(1), Ht += ut, _e())), K("="), function(ze, Ne, le, X) {
              ze.setParsedOption && ze.setParsedOption(Ne, le, X);
            }(Et, zt, Ot(Et, Ht), Ft);
          }
          function Ot(Et, ut) {
            if (K("{", !0)) {
              for (var St = {}; !K("}", !0); ) {
                if (!F.test(he = _e())) throw Be(he, "name");
                var Ft, Ht = he;
                Te() === "{" ? Ft = Ot(Et, ut + "." + he) : (K(":"), Te() === "{" ? Ft = Ot(Et, ut + "." + he) : (Ft = Ze(), kt(Et, ut + "." + he, Ft)));
                var zt = St[Ht];
                zt && (Ft = [].concat(zt).concat(Ft)), St[Ht] = Ft, K(",", !0);
              }
              return St;
            }
            var ze = Ze();
            return kt(Et, ut, ze), ze;
          }
          function kt(Et, ut, St) {
            Et.setOption && Et.setOption(ut, St);
          }
          function wt(Et) {
            if (K("[", !0)) {
              do
                st(Et, "option");
              while (K(",", !0));
              K("]");
            }
            return Et;
          }
          for (; (he = _e()) !== null; ) switch (he) {
            case "package":
              if (!Pe) throw Be(he);
              It();
              break;
            case "import":
              if (!Pe) throw Be(he);
              Rt();
              break;
            case "syntax":
              if (!Pe) throw Be(he);
              gt();
              break;
            case "option":
              st(be, he), K(";");
              break;
            default:
              if (it(be, he)) {
                Pe = !1;
                continue;
              }
              throw Be(he);
          }
          return U.filename = null, { package: ue, imports: se, weakImports: ee, syntax: de, root: V };
        }
      }, 1408: function(l, v, s) {
        l.exports = y;
        var c, d = s(9693), p = d.LongBits, m = d.utf8;
        function E(I, k) {
          return RangeError("index out of range: " + I.pos + " + " + (k || 1) + " > " + I.len);
        }
        function y(I) {
          this.buf = I, this.pos = 0, this.len = I.length;
        }
        var g, C = typeof Uint8Array < "u" ? function(I) {
          if (I instanceof Uint8Array || Array.isArray(I)) return new y(I);
          throw Error("illegal buffer");
        } : function(I) {
          if (Array.isArray(I)) return new y(I);
          throw Error("illegal buffer");
        }, O = function() {
          return d.Buffer ? function(I) {
            return (y.create = function(k) {
              return d.Buffer.isBuffer(k) ? new c(k) : C(k);
            })(I);
          } : C;
        };
        function N() {
          var I = new p(0, 0), k = 0;
          if (!(this.len - this.pos > 4)) {
            for (; k < 3; ++k) {
              if (this.pos >= this.len) throw E(this);
              if (I.lo = (I.lo | (127 & this.buf[this.pos]) << 7 * k) >>> 0, this.buf[this.pos++] < 128) return I;
            }
            return I.lo = (I.lo | (127 & this.buf[this.pos++]) << 7 * k) >>> 0, I;
          }
          for (; k < 4; ++k) if (I.lo = (I.lo | (127 & this.buf[this.pos]) << 7 * k) >>> 0, this.buf[this.pos++] < 128) return I;
          if (I.lo = (I.lo | (127 & this.buf[this.pos]) << 28) >>> 0, I.hi = (I.hi | (127 & this.buf[this.pos]) >> 4) >>> 0, this.buf[this.pos++] < 128) return I;
          if (k = 0, this.len - this.pos > 4) {
            for (; k < 5; ++k) if (I.hi = (I.hi | (127 & this.buf[this.pos]) << 7 * k + 3) >>> 0, this.buf[this.pos++] < 128) return I;
          } else for (; k < 5; ++k) {
            if (this.pos >= this.len) throw E(this);
            if (I.hi = (I.hi | (127 & this.buf[this.pos]) << 7 * k + 3) >>> 0, this.buf[this.pos++] < 128) return I;
          }
          throw Error("invalid varint encoding");
        }
        function w(I, k) {
          return (I[k - 4] | I[k - 3] << 8 | I[k - 2] << 16 | I[k - 1] << 24) >>> 0;
        }
        function _() {
          if (this.pos + 8 > this.len) throw E(this, 8);
          return new p(w(this.buf, this.pos += 4), w(this.buf, this.pos += 4));
        }
        y.create = O(), y.prototype._slice = d.Array.prototype.subarray || d.Array.prototype.slice, y.prototype.uint32 = (g = 4294967295, function() {
          if (g = (127 & this.buf[this.pos]) >>> 0, this.buf[this.pos++] < 128 || (g = (g | (127 & this.buf[this.pos]) << 7) >>> 0, this.buf[this.pos++] < 128) || (g = (g | (127 & this.buf[this.pos]) << 14) >>> 0, this.buf[this.pos++] < 128) || (g = (g | (127 & this.buf[this.pos]) << 21) >>> 0, this.buf[this.pos++] < 128) || (g = (g | (15 & this.buf[this.pos]) << 28) >>> 0, this.buf[this.pos++] < 128)) return g;
          if ((this.pos += 5) > this.len) throw this.pos = this.len, E(this, 10);
          return g;
        }), y.prototype.int32 = function() {
          return 0 | this.uint32();
        }, y.prototype.sint32 = function() {
          var I = this.uint32();
          return I >>> 1 ^ -(1 & I);
        }, y.prototype.bool = function() {
          return this.uint32() !== 0;
        }, y.prototype.fixed32 = function() {
          if (this.pos + 4 > this.len) throw E(this, 4);
          return w(this.buf, this.pos += 4);
        }, y.prototype.sfixed32 = function() {
          if (this.pos + 4 > this.len) throw E(this, 4);
          return 0 | w(this.buf, this.pos += 4);
        }, y.prototype.float = function() {
          if (this.pos + 4 > this.len) throw E(this, 4);
          var I = d.float.readFloatLE(this.buf, this.pos);
          return this.pos += 4, I;
        }, y.prototype.double = function() {
          if (this.pos + 8 > this.len) throw E(this, 4);
          var I = d.float.readDoubleLE(this.buf, this.pos);
          return this.pos += 8, I;
        }, y.prototype.bytes = function() {
          var I = this.uint32(), k = this.pos, H = this.pos + I;
          if (H > this.len) throw E(this, I);
          return this.pos += I, Array.isArray(this.buf) ? this.buf.slice(k, H) : k === H ? new this.buf.constructor(0) : this._slice.call(this.buf, k, H);
        }, y.prototype.string = function() {
          var I = this.bytes();
          return m.read(I, 0, I.length);
        }, y.prototype.skip = function(I) {
          if (typeof I == "number") {
            if (this.pos + I > this.len) throw E(this, I);
            this.pos += I;
          } else do
            if (this.pos >= this.len) throw E(this);
          while (128 & this.buf[this.pos++]);
          return this;
        }, y.prototype.skipType = function(I) {
          switch (I) {
            case 0:
              this.skip();
              break;
            case 1:
              this.skip(8);
              break;
            case 2:
              this.skip(this.uint32());
              break;
            case 3:
              for (; (I = 7 & this.uint32()) != 4; ) this.skipType(I);
              break;
            case 5:
              this.skip(4);
              break;
            default:
              throw Error("invalid wire type " + I + " at offset " + this.pos);
          }
          return this;
        }, y._configure = function(I) {
          c = I, y.create = O(), c._configure();
          var k = d.Long ? "toLong" : "toNumber";
          d.merge(y.prototype, { int64: function() {
            return N.call(this)[k](!1);
          }, uint64: function() {
            return N.call(this)[k](!0);
          }, sint64: function() {
            return N.call(this).zzDecode()[k](!1);
          }, fixed64: function() {
            return _.call(this)[k](!0);
          }, sfixed64: function() {
            return _.call(this)[k](!1);
          } });
        };
      }, 593: function(l, v, s) {
        l.exports = p;
        var c = s(1408);
        (p.prototype = Object.create(c.prototype)).constructor = p;
        var d = s(9693);
        function p(m) {
          c.call(this, m);
        }
        p._configure = function() {
          d.Buffer && (p.prototype._slice = d.Buffer.prototype.slice);
        }, p.prototype.string = function() {
          var m = this.uint32();
          return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + m, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + m, this.len));
        }, p._configure();
      }, 9424: function(l, v, s) {
        l.exports = O;
        var c = s(9313);
        ((O.prototype = Object.create(c.prototype)).constructor = O).className = "Root";
        var d, p, m, E = s(3548), y = s(7025), g = s(7598), C = s(9935);
        function O(I) {
          c.call(this, "", I), this.deferred = [], this.files = [];
        }
        function N() {
        }
        O.fromJSON = function(I, k) {
          return k || (k = new O()), I.options && k.setOptions(I.options), k.addJSON(I.nested);
        }, O.prototype.resolvePath = C.path.resolve, O.prototype.fetch = C.fetch, O.prototype.load = function I(k, H, S) {
          typeof H == "function" && (S = H, H = void 0);
          var B = this;
          if (!S) return C.asPromise(I, B, k, H);
          var D = S === N;
          function F(ue, se) {
            if (S) {
              var ee = S;
              if (S = null, D) throw ue;
              ee(ue, se);
            }
          }
          function j(ue) {
            var se = ue.lastIndexOf("google/protobuf/");
            if (se > -1) {
              var ee = ue.substring(se);
              if (ee in m) return ee;
            }
            return null;
          }
          function G(ue, se) {
            try {
              if (C.isString(se) && se.charAt(0) === "{" && (se = JSON.parse(se)), C.isString(se)) {
                p.filename = ue;
                var ee, de = p(se, B, H), he = 0;
                if (de.imports) for (; he < de.imports.length; ++he) (ee = j(de.imports[he]) || B.resolvePath(ue, de.imports[he])) && U(ee);
                if (de.weakImports) for (he = 0; he < de.weakImports.length; ++he) (ee = j(de.weakImports[he]) || B.resolvePath(ue, de.weakImports[he])) && U(ee, !0);
              } else B.setOptions(se.options).addJSON(se.nested);
            } catch (pe) {
              F(pe);
            }
            D || M || F(null, B);
          }
          function U(ue, se) {
            if (!(B.files.indexOf(ue) > -1)) if (B.files.push(ue), ue in m) D ? G(ue, m[ue]) : (++M, setTimeout(function() {
              --M, G(ue, m[ue]);
            }));
            else if (D) {
              var ee;
              try {
                ee = C.fs.readFileSync(ue).toString("utf8");
              } catch (de) {
                return void (se || F(de));
              }
              G(ue, ee);
            } else ++M, B.fetch(ue, function(de, he) {
              --M, S && (de ? se ? M || F(null, B) : F(de) : G(ue, he));
            });
          }
          var M = 0;
          C.isString(k) && (k = [k]);
          for (var V, J = 0; J < k.length; ++J) (V = B.resolvePath("", k[J])) && U(V);
          if (D) return B;
          M || F(null, B);
        }, O.prototype.loadSync = function(I, k) {
          if (!C.isNode) throw Error("not supported");
          return this.load(I, k, N);
        }, O.prototype.resolveAll = function() {
          if (this.deferred.length) throw Error("unresolvable extensions: " + this.deferred.map(function(I) {
            return "'extend " + I.extend + "' in " + I.parent.fullName;
          }).join(", "));
          return c.prototype.resolveAll.call(this);
        };
        var w = /^[A-Z]/;
        function _(I, k) {
          var H = k.parent.lookup(k.extend);
          if (H) {
            var S = new E(k.fullName, k.id, k.type, k.rule, void 0, k.options);
            return S.declaringField = k, k.extensionField = S, H.add(S), !0;
          }
          return !1;
        }
        O.prototype._handleAdd = function(I) {
          if (I instanceof E) I.extend === void 0 || I.extensionField || _(0, I) || this.deferred.push(I);
          else if (I instanceof y) w.test(I.name) && (I.parent[I.name] = I.values);
          else if (!(I instanceof g)) {
            if (I instanceof d) for (var k = 0; k < this.deferred.length; ) _(0, this.deferred[k]) ? this.deferred.splice(k, 1) : ++k;
            for (var H = 0; H < I.nestedArray.length; ++H) this._handleAdd(I._nestedArray[H]);
            w.test(I.name) && (I.parent[I.name] = I);
          }
        }, O.prototype._handleRemove = function(I) {
          if (I instanceof E) {
            if (I.extend !== void 0) if (I.extensionField) I.extensionField.parent.remove(I.extensionField), I.extensionField = null;
            else {
              var k = this.deferred.indexOf(I);
              k > -1 && this.deferred.splice(k, 1);
            }
          } else if (I instanceof y) w.test(I.name) && delete I.parent[I.name];
          else if (I instanceof c) {
            for (var H = 0; H < I.nestedArray.length; ++H) this._handleRemove(I._nestedArray[H]);
            w.test(I.name) && delete I.parent[I.name];
          }
        }, O._configure = function(I, k, H) {
          d = I, p = k, m = H;
        };
      }, 5054: function(l) {
        l.exports = {};
      }, 5994: function(l, v, s) {
        v.Service = s(7948);
      }, 7948: function(l, v, s) {
        l.exports = d;
        var c = s(9693);
        function d(p, m, E) {
          if (typeof p != "function") throw TypeError("rpcImpl must be a function");
          c.EventEmitter.call(this), this.rpcImpl = p, this.requestDelimited = !!m, this.responseDelimited = !!E;
        }
        (d.prototype = Object.create(c.EventEmitter.prototype)).constructor = d, d.prototype.rpcCall = function p(m, E, y, g, C) {
          if (!g) throw TypeError("request must be specified");
          var O = this;
          if (!C) return c.asPromise(p, O, m, E, y, g);
          if (O.rpcImpl) try {
            return O.rpcImpl(m, E[O.requestDelimited ? "encodeDelimited" : "encode"](g).finish(), function(N, w) {
              if (N) return O.emit("error", N, m), C(N);
              if (w !== null) {
                if (!(w instanceof y)) try {
                  w = y[O.responseDelimited ? "decodeDelimited" : "decode"](w);
                } catch (_) {
                  return O.emit("error", _, m), C(_);
                }
                return O.emit("data", w, m), C(null, w);
              }
              O.end(!0);
            });
          } catch (N) {
            return O.emit("error", N, m), void setTimeout(function() {
              C(N);
            }, 0);
          }
          else setTimeout(function() {
            C(Error("already ended"));
          }, 0);
        }, d.prototype.end = function(p) {
          return this.rpcImpl && (p || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
        };
      }, 7513: function(l, v, s) {
        l.exports = E;
        var c = s(9313);
        ((E.prototype = Object.create(c.prototype)).constructor = E).className = "Service";
        var d = s(4429), p = s(9935), m = s(5994);
        function E(g, C) {
          c.call(this, g, C), this.methods = {}, this._methodsArray = null;
        }
        function y(g) {
          return g._methodsArray = null, g;
        }
        E.fromJSON = function(g, C) {
          var O = new E(g, C.options);
          if (C.methods) for (var N = Object.keys(C.methods), w = 0; w < N.length; ++w) O.add(d.fromJSON(N[w], C.methods[N[w]]));
          return C.nested && O.addJSON(C.nested), O.comment = C.comment, O;
        }, E.prototype.toJSON = function(g) {
          var C = c.prototype.toJSON.call(this, g), O = !!g && !!g.keepComments;
          return p.toObject(["options", C && C.options || void 0, "methods", c.arrayToJSON(this.methodsArray, g) || {}, "nested", C && C.nested || void 0, "comment", O ? this.comment : void 0]);
        }, Object.defineProperty(E.prototype, "methodsArray", { get: function() {
          return this._methodsArray || (this._methodsArray = p.toArray(this.methods));
        } }), E.prototype.get = function(g) {
          return this.methods[g] || c.prototype.get.call(this, g);
        }, E.prototype.resolveAll = function() {
          for (var g = this.methodsArray, C = 0; C < g.length; ++C) g[C].resolve();
          return c.prototype.resolve.call(this);
        }, E.prototype.add = function(g) {
          if (this.get(g.name)) throw Error("duplicate name '" + g.name + "' in " + this);
          return g instanceof d ? (this.methods[g.name] = g, g.parent = this, y(this)) : c.prototype.add.call(this, g);
        }, E.prototype.remove = function(g) {
          if (g instanceof d) {
            if (this.methods[g.name] !== g) throw Error(g + " is not a member of " + this);
            return delete this.methods[g.name], g.parent = null, y(this);
          }
          return c.prototype.remove.call(this, g);
        }, E.prototype.create = function(g, C, O) {
          for (var N, w = new m.Service(g, C, O), _ = 0; _ < this.methodsArray.length; ++_) {
            var I = p.lcFirst((N = this._methodsArray[_]).resolve().name).replace(/[^$\w_]/g, "");
            w[I] = p.codegen(["r", "c"], p.isReserved(I) ? I + "_" : I)("return this.rpcCall(m,q,s,r,c)")({ m: N, q: N.resolvedRequestType.ctor, s: N.resolvedResponseType.ctor });
          }
          return w;
        };
      }, 626: function(l) {
        l.exports = O;
        var v = /[\s{}=;:[\],'"()<>]/g, s = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, c = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, d = /^ *[*/]+ */, p = /^\s*\*?\/*/, m = /\n/g, E = /\s/, y = /\\(.?)/g, g = { 0: "\0", r: "\r", n: `
`, t: "	" };
        function C(N) {
          return N.replace(y, function(w, _) {
            switch (_) {
              case "\\":
              case "":
                return _;
              default:
                return g[_] || "";
            }
          });
        }
        function O(N, w) {
          N = N.toString();
          var _ = 0, I = N.length, k = 1, H = null, S = null, B = 0, D = !1, F = !1, j = [], G = null;
          function U(he) {
            return Error("illegal " + he + " (line " + k + ")");
          }
          function M(he) {
            return N.charAt(he);
          }
          function V(he, pe, Ce) {
            H = N.charAt(he++), B = k, D = !1, F = Ce;
            var _e, Le = he - (w ? 2 : 3);
            do
              if (--Le < 0 || (_e = N.charAt(Le)) === `
`) {
                D = !0;
                break;
              }
            while (_e === " " || _e === "	");
            for (var Te = N.substring(he, pe).split(m), K = 0; K < Te.length; ++K) Te[K] = Te[K].replace(w ? p : d, "").trim();
            S = Te.join(`
`).trim();
          }
          function J(he) {
            var pe = ue(he), Ce = N.substring(he, pe);
            return /^\s*\/{1,2}/.test(Ce);
          }
          function ue(he) {
            for (var pe = he; pe < I && M(pe) !== `
`; ) pe++;
            return pe;
          }
          function se() {
            if (j.length > 0) return j.shift();
            if (G) return function() {
              var Pe = G === "'" ? c : s;
              Pe.lastIndex = _ - 1;
              var xe = Pe.exec(N);
              if (!xe) throw U("string");
              return _ = Pe.lastIndex, ee(G), G = null, C(xe[1]);
            }();
            var he, pe, Ce, _e, Le, Te = _ === 0;
            do {
              if (_ === I) return null;
              for (he = !1; E.test(Ce = M(_)); ) if (Ce === `
` && (Te = !0, ++k), ++_ === I) return null;
              if (M(_) === "/") {
                if (++_ === I) throw U("comment");
                if (M(_) === "/") if (w) {
                  if (_e = _, Le = !1, J(_)) {
                    Le = !0;
                    do {
                      if ((_ = ue(_)) === I) break;
                      _++;
                    } while (J(_));
                  } else _ = Math.min(I, ue(_) + 1);
                  Le && V(_e, _, Te), k++, he = !0;
                } else {
                  for (Le = M(_e = _ + 1) === "/"; M(++_) !== `
`; ) if (_ === I) return null;
                  ++_, Le && V(_e, _ - 1, Te), ++k, he = !0;
                }
                else {
                  if ((Ce = M(_)) !== "*") return "/";
                  _e = _ + 1, Le = w || M(_e) === "*";
                  do {
                    if (Ce === `
` && ++k, ++_ === I) throw U("comment");
                    pe = Ce, Ce = M(_);
                  } while (pe !== "*" || Ce !== "/");
                  ++_, Le && V(_e, _ - 2, Te), he = !0;
                }
              }
            } while (he);
            var K = _;
            if (v.lastIndex = 0, !v.test(M(K++))) for (; K < I && !v.test(M(K)); ) ++K;
            var Oe = N.substring(_, _ = K);
            return Oe !== '"' && Oe !== "'" || (G = Oe), Oe;
          }
          function ee(he) {
            j.push(he);
          }
          function de() {
            if (!j.length) {
              var he = se();
              if (he === null) return null;
              ee(he);
            }
            return j[0];
          }
          return Object.defineProperty({ next: se, peek: de, push: ee, skip: function(he, pe) {
            var Ce = de();
            if (Ce === he) return se(), !0;
            if (!pe) throw U("token '" + Ce + "', '" + he + "' expected");
            return !1;
          }, cmnt: function(he) {
            var pe = null;
            return he === void 0 ? B === k - 1 && (w || H === "*" || D) && (pe = F ? S : null) : (B < he && de(), B !== he || D || !w && H !== "/" || (pe = F ? null : S)), pe;
          } }, "line", { get: function() {
            return k;
          } });
        }
        O.unescape = C;
      }, 7645: function(l, v, s) {
        l.exports = S;
        var c = s(9313);
        ((S.prototype = Object.create(c.prototype)).constructor = S).className = "Type";
        var d = s(7025), p = s(7598), m = s(3548), E = s(6039), y = s(7513), g = s(8368), C = s(1408), O = s(1173), N = s(9935), w = s(4928), _ = s(5305), I = s(4497), k = s(3996), H = s(1667);
        function S(D, F) {
          c.call(this, D, F), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
        }
        function B(D) {
          return D._fieldsById = D._fieldsArray = D._oneofsArray = null, delete D.encode, delete D.decode, delete D.verify, D;
        }
        Object.defineProperties(S.prototype, { fieldsById: { get: function() {
          if (this._fieldsById) return this._fieldsById;
          this._fieldsById = {};
          for (var D = Object.keys(this.fields), F = 0; F < D.length; ++F) {
            var j = this.fields[D[F]], G = j.id;
            if (this._fieldsById[G]) throw Error("duplicate id " + G + " in " + this);
            this._fieldsById[G] = j;
          }
          return this._fieldsById;
        } }, fieldsArray: { get: function() {
          return this._fieldsArray || (this._fieldsArray = N.toArray(this.fields));
        } }, oneofsArray: { get: function() {
          return this._oneofsArray || (this._oneofsArray = N.toArray(this.oneofs));
        } }, ctor: { get: function() {
          return this._ctor || (this.ctor = S.generateConstructor(this)());
        }, set: function(D) {
          var F = D.prototype;
          F instanceof g || ((D.prototype = new g()).constructor = D, N.merge(D.prototype, F)), D.$type = D.prototype.$type = this, N.merge(D, g, !0), this._ctor = D;
          for (var j = 0; j < this.fieldsArray.length; ++j) this._fieldsArray[j].resolve();
          var G = {};
          for (j = 0; j < this.oneofsArray.length; ++j) G[this._oneofsArray[j].resolve().name] = { get: N.oneOfGetter(this._oneofsArray[j].oneof), set: N.oneOfSetter(this._oneofsArray[j].oneof) };
          j && Object.defineProperties(D.prototype, G);
        } } }), S.generateConstructor = function(D) {
          for (var F, j = N.codegen(["p"], D.name), G = 0; G < D.fieldsArray.length; ++G) (F = D._fieldsArray[G]).map ? j("this%s={}", N.safeProp(F.name)) : F.repeated && j("this%s=[]", N.safeProp(F.name));
          return j("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
        }, S.fromJSON = function(D, F) {
          var j = new S(D, F.options);
          j.extensions = F.extensions, j.reserved = F.reserved;
          for (var G = Object.keys(F.fields), U = 0; U < G.length; ++U) j.add((F.fields[G[U]].keyType !== void 0 ? E.fromJSON : m.fromJSON)(G[U], F.fields[G[U]]));
          if (F.oneofs) for (G = Object.keys(F.oneofs), U = 0; U < G.length; ++U) j.add(p.fromJSON(G[U], F.oneofs[G[U]]));
          if (F.nested) for (G = Object.keys(F.nested), U = 0; U < G.length; ++U) {
            var M = F.nested[G[U]];
            j.add((M.id !== void 0 ? m.fromJSON : M.fields !== void 0 ? S.fromJSON : M.values !== void 0 ? d.fromJSON : M.methods !== void 0 ? y.fromJSON : c.fromJSON)(G[U], M));
          }
          return F.extensions && F.extensions.length && (j.extensions = F.extensions), F.reserved && F.reserved.length && (j.reserved = F.reserved), F.group && (j.group = !0), F.comment && (j.comment = F.comment), j;
        }, S.prototype.toJSON = function(D) {
          var F = c.prototype.toJSON.call(this, D), j = !!D && !!D.keepComments;
          return N.toObject(["options", F && F.options || void 0, "oneofs", c.arrayToJSON(this.oneofsArray, D), "fields", c.arrayToJSON(this.fieldsArray.filter(function(G) {
            return !G.declaringField;
          }), D) || {}, "extensions", this.extensions && this.extensions.length ? this.extensions : void 0, "reserved", this.reserved && this.reserved.length ? this.reserved : void 0, "group", this.group || void 0, "nested", F && F.nested || void 0, "comment", j ? this.comment : void 0]);
        }, S.prototype.resolveAll = function() {
          for (var D = this.fieldsArray, F = 0; F < D.length; ) D[F++].resolve();
          var j = this.oneofsArray;
          for (F = 0; F < j.length; ) j[F++].resolve();
          return c.prototype.resolveAll.call(this);
        }, S.prototype.get = function(D) {
          return this.fields[D] || this.oneofs && this.oneofs[D] || this.nested && this.nested[D] || null;
        }, S.prototype.add = function(D) {
          if (this.get(D.name)) throw Error("duplicate name '" + D.name + "' in " + this);
          if (D instanceof m && D.extend === void 0) {
            if (this._fieldsById ? this._fieldsById[D.id] : this.fieldsById[D.id]) throw Error("duplicate id " + D.id + " in " + this);
            if (this.isReservedId(D.id)) throw Error("id " + D.id + " is reserved in " + this);
            if (this.isReservedName(D.name)) throw Error("name '" + D.name + "' is reserved in " + this);
            return D.parent && D.parent.remove(D), this.fields[D.name] = D, D.message = this, D.onAdd(this), B(this);
          }
          return D instanceof p ? (this.oneofs || (this.oneofs = {}), this.oneofs[D.name] = D, D.onAdd(this), B(this)) : c.prototype.add.call(this, D);
        }, S.prototype.remove = function(D) {
          if (D instanceof m && D.extend === void 0) {
            if (!this.fields || this.fields[D.name] !== D) throw Error(D + " is not a member of " + this);
            return delete this.fields[D.name], D.parent = null, D.onRemove(this), B(this);
          }
          if (D instanceof p) {
            if (!this.oneofs || this.oneofs[D.name] !== D) throw Error(D + " is not a member of " + this);
            return delete this.oneofs[D.name], D.parent = null, D.onRemove(this), B(this);
          }
          return c.prototype.remove.call(this, D);
        }, S.prototype.isReservedId = function(D) {
          return c.isReservedId(this.reserved, D);
        }, S.prototype.isReservedName = function(D) {
          return c.isReservedName(this.reserved, D);
        }, S.prototype.create = function(D) {
          return new this.ctor(D);
        }, S.prototype.setup = function() {
          for (var D = this.fullName, F = [], j = 0; j < this.fieldsArray.length; ++j) F.push(this._fieldsArray[j].resolve().resolvedType);
          this.encode = w(this)({ Writer: O, types: F, util: N }), this.decode = _(this)({ Reader: C, types: F, util: N }), this.verify = I(this)({ types: F, util: N }), this.fromObject = k.fromObject(this)({ types: F, util: N }), this.toObject = k.toObject(this)({ types: F, util: N });
          var G = H[D];
          if (G) {
            var U = Object.create(this);
            U.fromObject = this.fromObject, this.fromObject = G.fromObject.bind(U), U.toObject = this.toObject, this.toObject = G.toObject.bind(U);
          }
          return this;
        }, S.prototype.encode = function(D, F) {
          return this.setup().encode(D, F);
        }, S.prototype.encodeDelimited = function(D, F) {
          return this.encode(D, F && F.len ? F.fork() : F).ldelim();
        }, S.prototype.decode = function(D, F) {
          return this.setup().decode(D, F);
        }, S.prototype.decodeDelimited = function(D) {
          return D instanceof C || (D = C.create(D)), this.decode(D, D.uint32());
        }, S.prototype.verify = function(D) {
          return this.setup().verify(D);
        }, S.prototype.fromObject = function(D) {
          return this.setup().fromObject(D);
        }, S.prototype.toObject = function(D, F) {
          return this.setup().toObject(D, F);
        }, S.d = function(D) {
          return function(F) {
            N.decorateType(F, D);
          };
        };
      }, 7063: function(l, v, s) {
        var c = v, d = s(9935), p = ["double", "float", "int32", "uint32", "sint32", "fixed32", "sfixed32", "int64", "uint64", "sint64", "fixed64", "sfixed64", "bool", "string", "bytes"];
        function m(E, y) {
          var g = 0, C = {};
          for (y |= 0; g < E.length; ) C[p[g + y]] = E[g++];
          return C;
        }
        c.basic = m([1, 5, 0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0, 2, 2]), c.defaults = m([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, !1, "", d.emptyArray, null]), c.long = m([0, 0, 0, 1, 1], 7), c.mapKey = m([0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0, 2], 2), c.packed = m([1, 5, 0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0]);
      }, 9935: function(l, v, s) {
        var c, d, p = l.exports = s(9693), m = s(5054);
        p.codegen = s(5124), p.fetch = s(9054), p.path = s(8626), p.fs = p.inquire("fs"), p.toArray = function(O) {
          if (O) {
            for (var N = Object.keys(O), w = new Array(N.length), _ = 0; _ < N.length; ) w[_] = O[N[_++]];
            return w;
          }
          return [];
        }, p.toObject = function(O) {
          for (var N = {}, w = 0; w < O.length; ) {
            var _ = O[w++], I = O[w++];
            I !== void 0 && (N[_] = I);
          }
          return N;
        };
        var E = /\\/g, y = /"/g;
        p.isReserved = function(O) {
          return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(O);
        }, p.safeProp = function(O) {
          return !/^[$\w_]+$/.test(O) || p.isReserved(O) ? '["' + O.replace(E, "\\\\").replace(y, '\\"') + '"]' : "." + O;
        }, p.ucFirst = function(O) {
          return O.charAt(0).toUpperCase() + O.substring(1);
        };
        var g = /_([a-z])/g;
        p.camelCase = function(O) {
          return O.substring(0, 1) + O.substring(1).replace(g, function(N, w) {
            return w.toUpperCase();
          });
        }, p.compareFieldsById = function(O, N) {
          return O.id - N.id;
        }, p.decorateType = function(O, N) {
          if (O.$type) return N && O.$type.name !== N && (p.decorateRoot.remove(O.$type), O.$type.name = N, p.decorateRoot.add(O.$type)), O.$type;
          c || (c = s(7645));
          var w = new c(N || O.name);
          return p.decorateRoot.add(w), w.ctor = O, Object.defineProperty(O, "$type", { value: w, enumerable: !1 }), Object.defineProperty(O.prototype, "$type", { value: w, enumerable: !1 }), w;
        };
        var C = 0;
        p.decorateEnum = function(O) {
          if (O.$type) return O.$type;
          d || (d = s(7025));
          var N = new d("Enum" + C++, O);
          return p.decorateRoot.add(N), Object.defineProperty(O, "$type", { value: N, enumerable: !1 }), N;
        }, p.setProperty = function(O, N, w) {
          if (typeof O != "object") throw TypeError("dst must be an object");
          if (!N) throw TypeError("path must be specified");
          return function _(I, k, H) {
            var S = k.shift();
            if (S === "__proto__") return I;
            if (k.length > 0) I[S] = _(I[S] || {}, k, H);
            else {
              var B = I[S];
              B && (H = [].concat(B).concat(H)), I[S] = H;
            }
            return I;
          }(O, N = N.split("."), w);
        }, Object.defineProperty(p, "decorateRoot", { get: function() {
          return m.decorated || (m.decorated = new (s(9424))());
        } });
      }, 1945: function(l, v, s) {
        l.exports = d;
        var c = s(9693);
        function d(y, g) {
          this.lo = y >>> 0, this.hi = g >>> 0;
        }
        var p = d.zero = new d(0, 0);
        p.toNumber = function() {
          return 0;
        }, p.zzEncode = p.zzDecode = function() {
          return this;
        }, p.length = function() {
          return 1;
        };
        var m = d.zeroHash = "\0\0\0\0\0\0\0\0";
        d.fromNumber = function(y) {
          if (y === 0) return p;
          var g = y < 0;
          g && (y = -y);
          var C = y >>> 0, O = (y - C) / 4294967296 >>> 0;
          return g && (O = ~O >>> 0, C = ~C >>> 0, ++C > 4294967295 && (C = 0, ++O > 4294967295 && (O = 0))), new d(C, O);
        }, d.from = function(y) {
          if (typeof y == "number") return d.fromNumber(y);
          if (c.isString(y)) {
            if (!c.Long) return d.fromNumber(parseInt(y, 10));
            y = c.Long.fromString(y);
          }
          return y.low || y.high ? new d(y.low >>> 0, y.high >>> 0) : p;
        }, d.prototype.toNumber = function(y) {
          if (!y && this.hi >>> 31) {
            var g = 1 + ~this.lo >>> 0, C = ~this.hi >>> 0;
            return g || (C = C + 1 >>> 0), -(g + 4294967296 * C);
          }
          return this.lo + 4294967296 * this.hi;
        }, d.prototype.toLong = function(y) {
          return c.Long ? new c.Long(0 | this.lo, 0 | this.hi, !!y) : { low: 0 | this.lo, high: 0 | this.hi, unsigned: !!y };
        };
        var E = String.prototype.charCodeAt;
        d.fromHash = function(y) {
          return y === m ? p : new d((E.call(y, 0) | E.call(y, 1) << 8 | E.call(y, 2) << 16 | E.call(y, 3) << 24) >>> 0, (E.call(y, 4) | E.call(y, 5) << 8 | E.call(y, 6) << 16 | E.call(y, 7) << 24) >>> 0);
        }, d.prototype.toHash = function() {
          return String.fromCharCode(255 & this.lo, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, 255 & this.hi, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
        }, d.prototype.zzEncode = function() {
          var y = this.hi >> 31;
          return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ y) >>> 0, this.lo = (this.lo << 1 ^ y) >>> 0, this;
        }, d.prototype.zzDecode = function() {
          var y = -(1 & this.lo);
          return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ y) >>> 0, this.hi = (this.hi >>> 1 ^ y) >>> 0, this;
        }, d.prototype.length = function() {
          var y = this.lo, g = (this.lo >>> 28 | this.hi << 4) >>> 0, C = this.hi >>> 24;
          return C === 0 ? g === 0 ? y < 16384 ? y < 128 ? 1 : 2 : y < 2097152 ? 3 : 4 : g < 16384 ? g < 128 ? 5 : 6 : g < 2097152 ? 7 : 8 : C < 128 ? 9 : 10;
        };
      }, 9693: function(l, v, s) {
        var c = v;
        function d(m, E, y) {
          for (var g = Object.keys(E), C = 0; C < g.length; ++C) m[g[C]] !== void 0 && y || (m[g[C]] = E[g[C]]);
          return m;
        }
        function p(m) {
          function E(y, g) {
            if (!(this instanceof E)) return new E(y, g);
            Object.defineProperty(this, "message", { get: function() {
              return y;
            } }), Error.captureStackTrace ? Error.captureStackTrace(this, E) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), g && d(this, g);
          }
          return (E.prototype = Object.create(Error.prototype)).constructor = E, Object.defineProperty(E.prototype, "name", { get: function() {
            return m;
          } }), E.prototype.toString = function() {
            return this.name + ": " + this.message;
          }, E;
        }
        c.asPromise = s(4537), c.base64 = s(7419), c.EventEmitter = s(9211), c.float = s(945), c.inquire = s(7199), c.utf8 = s(4997), c.pool = s(6662), c.LongBits = s(1945), c.isNode = !!(s.g !== void 0 && s.g && s.g.process && s.g.process.versions && s.g.process.versions.node), c.global = c.isNode && s.g || typeof window < "u" && window || typeof self < "u" && self || this, c.emptyArray = Object.freeze ? Object.freeze([]) : [], c.emptyObject = Object.freeze ? Object.freeze({}) : {}, c.isInteger = Number.isInteger || function(m) {
          return typeof m == "number" && isFinite(m) && Math.floor(m) === m;
        }, c.isString = function(m) {
          return typeof m == "string" || m instanceof String;
        }, c.isObject = function(m) {
          return m && typeof m == "object";
        }, c.isset = c.isSet = function(m, E) {
          var y = m[E];
          return !(y == null || !m.hasOwnProperty(E)) && (typeof y != "object" || (Array.isArray(y) ? y.length : Object.keys(y).length) > 0);
        }, c.Buffer = function() {
          try {
            var m = c.inquire("buffer").Buffer;
            return m.prototype.utf8Write ? m : null;
          } catch {
            return null;
          }
        }(), c._Buffer_from = null, c._Buffer_allocUnsafe = null, c.newBuffer = function(m) {
          return typeof m == "number" ? c.Buffer ? c._Buffer_allocUnsafe(m) : new c.Array(m) : c.Buffer ? c._Buffer_from(m) : typeof Uint8Array > "u" ? m : new Uint8Array(m);
        }, c.Array = typeof Uint8Array < "u" ? Uint8Array : Array, c.Long = c.global.dcodeIO && c.global.dcodeIO.Long || c.global.Long || c.inquire("long"), c.key2Re = /^true|false|0|1$/, c.key32Re = /^-?(?:0|[1-9][0-9]*)$/, c.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, c.longToHash = function(m) {
          return m ? c.LongBits.from(m).toHash() : c.LongBits.zeroHash;
        }, c.longFromHash = function(m, E) {
          var y = c.LongBits.fromHash(m);
          return c.Long ? c.Long.fromBits(y.lo, y.hi, E) : y.toNumber(!!E);
        }, c.merge = d, c.lcFirst = function(m) {
          return m.charAt(0).toLowerCase() + m.substring(1);
        }, c.newError = p, c.ProtocolError = p("ProtocolError"), c.oneOfGetter = function(m) {
          for (var E = {}, y = 0; y < m.length; ++y) E[m[y]] = 1;
          return function() {
            for (var g = Object.keys(this), C = g.length - 1; C > -1; --C) if (E[g[C]] === 1 && this[g[C]] !== void 0 && this[g[C]] !== null) return g[C];
          };
        }, c.oneOfSetter = function(m) {
          return function(E) {
            for (var y = 0; y < m.length; ++y) m[y] !== E && delete this[m[y]];
          };
        }, c.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, c._configure = function() {
          var m = c.Buffer;
          m ? (c._Buffer_from = m.from !== Uint8Array.from && m.from || function(E, y) {
            return new m(E, y);
          }, c._Buffer_allocUnsafe = m.allocUnsafe || function(E) {
            return new m(E);
          }) : c._Buffer_from = c._Buffer_allocUnsafe = null;
        };
      }, 4497: function(l, v, s) {
        l.exports = function(y) {
          var g = d.codegen(["m"], y.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), C = {};
          y.oneofsArray.length && g("var p={}");
          for (var O = 0; O < y.fieldsArray.length; ++O) {
            var N = y._fieldsArray[O].resolve(), w = "m" + d.safeProp(N.name);
            if (N.optional && g("if(%s!=null&&m.hasOwnProperty(%j)){", w, N.name), N.map) g("if(!util.isObject(%s))", w)("return%j", p(N, "object"))("var k=Object.keys(%s)", w)("for(var i=0;i<k.length;++i){"), E(g, N, "k[i]"), m(g, N, O, w + "[k[i]]")("}");
            else if (N.repeated) g("if(!Array.isArray(%s))", w)("return%j", p(N, "array"))("for(var i=0;i<%s.length;++i){", w), m(g, N, O, w + "[i]")("}");
            else {
              if (N.partOf) {
                var _ = d.safeProp(N.partOf.name);
                C[N.partOf.name] === 1 && g("if(p%s===1)", _)("return%j", N.partOf.name + ": multiple values"), C[N.partOf.name] = 1, g("p%s=1", _);
              }
              m(g, N, O, w);
            }
            N.optional && g("}");
          }
          return g("return null");
        };
        var c = s(7025), d = s(9935);
        function p(y, g) {
          return y.name + ": " + g + (y.repeated && g !== "array" ? "[]" : y.map && g !== "object" ? "{k:" + y.keyType + "}" : "") + " expected";
        }
        function m(y, g, C, O) {
          if (g.resolvedType) if (g.resolvedType instanceof c) {
            y("switch(%s){", O)("default:")("return%j", p(g, "enum value"));
            for (var N = Object.keys(g.resolvedType.values), w = 0; w < N.length; ++w) y("case %i:", g.resolvedType.values[N[w]]);
            y("break")("}");
          } else y("{")("var e=types[%i].verify(%s);", C, O)("if(e)")("return%j+e", g.name + ".")("}");
          else switch (g.type) {
            case "int32":
            case "uint32":
            case "sint32":
            case "fixed32":
            case "sfixed32":
              y("if(!util.isInteger(%s))", O)("return%j", p(g, "integer"));
              break;
            case "int64":
            case "uint64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
              y("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", O, O, O, O)("return%j", p(g, "integer|Long"));
              break;
            case "float":
            case "double":
              y('if(typeof %s!=="number")', O)("return%j", p(g, "number"));
              break;
            case "bool":
              y('if(typeof %s!=="boolean")', O)("return%j", p(g, "boolean"));
              break;
            case "string":
              y("if(!util.isString(%s))", O)("return%j", p(g, "string"));
              break;
            case "bytes":
              y('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', O, O, O)("return%j", p(g, "buffer"));
          }
          return y;
        }
        function E(y, g, C) {
          switch (g.keyType) {
            case "int32":
            case "uint32":
            case "sint32":
            case "fixed32":
            case "sfixed32":
              y("if(!util.key32Re.test(%s))", C)("return%j", p(g, "integer key"));
              break;
            case "int64":
            case "uint64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
              y("if(!util.key64Re.test(%s))", C)("return%j", p(g, "integer|Long key"));
              break;
            case "bool":
              y("if(!util.key2Re.test(%s))", C)("return%j", p(g, "boolean key"));
          }
          return y;
        }
      }, 1667: function(l, v, s) {
        var c = v, d = s(8368);
        c[".google.protobuf.Any"] = { fromObject: function(p) {
          if (p && p["@type"]) {
            var m = p["@type"].substring(p["@type"].lastIndexOf("/") + 1), E = this.lookup(m);
            if (E) {
              var y = p["@type"].charAt(0) === "." ? p["@type"].substr(1) : p["@type"];
              return y.indexOf("/") === -1 && (y = "/" + y), this.create({ type_url: y, value: E.encode(E.fromObject(p)).finish() });
            }
          }
          return this.fromObject(p);
        }, toObject: function(p, m) {
          var E = "", y = "";
          if (m && m.json && p.type_url && p.value) {
            y = p.type_url.substring(p.type_url.lastIndexOf("/") + 1), E = p.type_url.substring(0, p.type_url.lastIndexOf("/") + 1);
            var g = this.lookup(y);
            g && (p = g.decode(p.value));
          }
          if (!(p instanceof this.ctor) && p instanceof d) {
            var C = p.$type.toObject(p, m);
            return E === "" && (E = "type.googleapis.com/"), y = E + (p.$type.fullName[0] === "." ? p.$type.fullName.substr(1) : p.$type.fullName), C["@type"] = y, C;
          }
          return this.toObject(p, m);
        } };
      }, 1173: function(l, v, s) {
        l.exports = O;
        var c, d = s(9693), p = d.LongBits, m = d.base64, E = d.utf8;
        function y(S, B, D) {
          this.fn = S, this.len = B, this.next = void 0, this.val = D;
        }
        function g() {
        }
        function C(S) {
          this.head = S.head, this.tail = S.tail, this.len = S.len, this.next = S.states;
        }
        function O() {
          this.len = 0, this.head = new y(g, 0, 0), this.tail = this.head, this.states = null;
        }
        var N = function() {
          return d.Buffer ? function() {
            return (O.create = function() {
              return new c();
            })();
          } : function() {
            return new O();
          };
        };
        function w(S, B, D) {
          B[D] = 255 & S;
        }
        function _(S, B) {
          this.len = S, this.next = void 0, this.val = B;
        }
        function I(S, B, D) {
          for (; S.hi; ) B[D++] = 127 & S.lo | 128, S.lo = (S.lo >>> 7 | S.hi << 25) >>> 0, S.hi >>>= 7;
          for (; S.lo > 127; ) B[D++] = 127 & S.lo | 128, S.lo = S.lo >>> 7;
          B[D++] = S.lo;
        }
        function k(S, B, D) {
          B[D] = 255 & S, B[D + 1] = S >>> 8 & 255, B[D + 2] = S >>> 16 & 255, B[D + 3] = S >>> 24;
        }
        O.create = N(), O.alloc = function(S) {
          return new d.Array(S);
        }, d.Array !== Array && (O.alloc = d.pool(O.alloc, d.Array.prototype.subarray)), O.prototype._push = function(S, B, D) {
          return this.tail = this.tail.next = new y(S, B, D), this.len += B, this;
        }, _.prototype = Object.create(y.prototype), _.prototype.fn = function(S, B, D) {
          for (; S > 127; ) B[D++] = 127 & S | 128, S >>>= 7;
          B[D] = S;
        }, O.prototype.uint32 = function(S) {
          return this.len += (this.tail = this.tail.next = new _((S >>>= 0) < 128 ? 1 : S < 16384 ? 2 : S < 2097152 ? 3 : S < 268435456 ? 4 : 5, S)).len, this;
        }, O.prototype.int32 = function(S) {
          return S < 0 ? this._push(I, 10, p.fromNumber(S)) : this.uint32(S);
        }, O.prototype.sint32 = function(S) {
          return this.uint32((S << 1 ^ S >> 31) >>> 0);
        }, O.prototype.uint64 = function(S) {
          var B = p.from(S);
          return this._push(I, B.length(), B);
        }, O.prototype.int64 = O.prototype.uint64, O.prototype.sint64 = function(S) {
          var B = p.from(S).zzEncode();
          return this._push(I, B.length(), B);
        }, O.prototype.bool = function(S) {
          return this._push(w, 1, S ? 1 : 0);
        }, O.prototype.fixed32 = function(S) {
          return this._push(k, 4, S >>> 0);
        }, O.prototype.sfixed32 = O.prototype.fixed32, O.prototype.fixed64 = function(S) {
          var B = p.from(S);
          return this._push(k, 4, B.lo)._push(k, 4, B.hi);
        }, O.prototype.sfixed64 = O.prototype.fixed64, O.prototype.float = function(S) {
          return this._push(d.float.writeFloatLE, 4, S);
        }, O.prototype.double = function(S) {
          return this._push(d.float.writeDoubleLE, 8, S);
        };
        var H = d.Array.prototype.set ? function(S, B, D) {
          B.set(S, D);
        } : function(S, B, D) {
          for (var F = 0; F < S.length; ++F) B[D + F] = S[F];
        };
        O.prototype.bytes = function(S) {
          var B = S.length >>> 0;
          if (!B) return this._push(w, 1, 0);
          if (d.isString(S)) {
            var D = O.alloc(B = m.length(S));
            m.decode(S, D, 0), S = D;
          }
          return this.uint32(B)._push(H, B, S);
        }, O.prototype.string = function(S) {
          var B = E.length(S);
          return B ? this.uint32(B)._push(E.write, B, S) : this._push(w, 1, 0);
        }, O.prototype.fork = function() {
          return this.states = new C(this), this.head = this.tail = new y(g, 0, 0), this.len = 0, this;
        }, O.prototype.reset = function() {
          return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new y(g, 0, 0), this.len = 0), this;
        }, O.prototype.ldelim = function() {
          var S = this.head, B = this.tail, D = this.len;
          return this.reset().uint32(D), D && (this.tail.next = S.next, this.tail = B, this.len += D), this;
        }, O.prototype.finish = function() {
          for (var S = this.head.next, B = this.constructor.alloc(this.len), D = 0; S; ) S.fn(S.val, B, D), D += S.len, S = S.next;
          return B;
        }, O._configure = function(S) {
          c = S, O.create = N(), c._configure();
        };
      }, 3155: function(l, v, s) {
        l.exports = p;
        var c = s(1173);
        (p.prototype = Object.create(c.prototype)).constructor = p;
        var d = s(9693);
        function p() {
          c.call(this);
        }
        function m(E, y, g) {
          E.length < 40 ? d.utf8.write(E, y, g) : y.utf8Write ? y.utf8Write(E, g) : y.write(E, g);
        }
        p._configure = function() {
          p.alloc = d._Buffer_allocUnsafe, p.writeBytesBuffer = d.Buffer && d.Buffer.prototype instanceof Uint8Array && d.Buffer.prototype.set.name === "set" ? function(E, y, g) {
            y.set(E, g);
          } : function(E, y, g) {
            if (E.copy) E.copy(y, g, 0, E.length);
            else for (var C = 0; C < E.length; ) y[g++] = E[C++];
          };
        }, p.prototype.bytes = function(E) {
          d.isString(E) && (E = d._Buffer_from(E, "base64"));
          var y = E.length >>> 0;
          return this.uint32(y), y && this._push(p.writeBytesBuffer, y, E), this;
        }, p.prototype.string = function(E) {
          var y = d.Buffer.byteLength(E);
          return this.uint32(y), y && this._push(m, y, E), this;
        }, p._configure();
      } }, u = {};
      function h(l) {
        var v = u[l];
        if (v !== void 0) return v.exports;
        var s = u[l] = { exports: {} };
        return a[l].call(s.exports, s, s.exports, h), s.exports;
      }
      h.amdO = {}, h.n = function(l) {
        var v = l && l.__esModule ? function() {
          return l.default;
        } : function() {
          return l;
        };
        return h.d(v, { a: v }), v;
      }, h.d = function(l, v) {
        for (var s in v) h.o(v, s) && !h.o(l, s) && Object.defineProperty(l, s, { enumerable: !0, get: v[s] });
      }, h.g = function() {
        if (typeof globalThis == "object") return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object") return window;
        }
      }(), h.o = function(l, v) {
        return Object.prototype.hasOwnProperty.call(l, v);
      }, h.r = function(l) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(l, "__esModule", { value: !0 });
      };
      var b = {};
      return function() {
        h.r(b), h.d(b, { default: function() {
          return Ne;
        } });
        var l = h(3281), v = h.n(l), s = h(3720), c = h.n(s), d = (h(9601), h(1539), h(8674), h(2526), h(1817), h(2165), h(6992), h(8783), h(3948), h(8309), h(3843), h(3710), h(7327), h(6755), h(1532), h(4812), h(9070), h(7941), h(2222), h(9575), h(2472), h(2990), h(8927), h(3105), h(5035), h(4345), h(7174), h(2846), h(4731), h(7209), h(6319), h(8867), h(7789), h(3739), h(9368), h(4483), h(2056), h(3462), h(678), h(7462), h(3824), h(5021), h(2974), h(5016), h(5827), h(2564), h(9653), h(9554), h(4747), h(6699), h(2023), h(7252)), p = h(4024), m = h(4998), E = h(5531), y = h(6424), g = h(7360), C = ["onTextMessage", "onFileMessage", "onAudioMessage", "onVideoMessage", "onImageMessage", "onLocationMessage", "onCustomMessage", "onCMDMessage"], O = function() {
          function le(X, re, Me) {
            this.handlerData = {}, this.handlerData = {}, X.addEventHandler = this.addEventHandler.bind(this), X.removeEventHandler = this.removeEventHandler.bind(this);
          }
          return le.prototype.addEventHandler = function(X, re) {
            this.handlerData[X] = re;
          }, le.prototype.removeEventHandler = function(X) {
            delete this.handlerData[X];
          }, le.prototype.dispatch = function(X, re) {
            for (var Me in C.includes(X) && re ? g.kg.debug("dispatch event: " + X, { id: re.id, type: re.type, time: re.time, from: re.from, to: re.to, chatType: re.chatType }) : X === "onMessage" ? g.kg.debug("dispatch event: " + X, re == null ? void 0 : re.length) : g.kg.debug("dispatch event: " + X, re || ""), this.handlerData) {
              var Se = this.handlerData[Me][X];
              Se && Se(re);
            }
          }, le;
        }(), N = function() {
        };
        function w(le) {
          this.onOpened = le.onOpened || N, this.onPresence = le.onPresence || N, this.onTextMessage = le.onTextMessage || N, this.onPictureMessage = le.onPictureMessage || N, this.onAudioMessage = le.onAudioMessage || N, this.onVideoMessage = le.onVideoMessage || N, this.onFileMessage = le.onFileMessage || N, this.onLocationMessage = le.onLocationMessage || N, this.onCmdMessage = le.onCmdMessage || N, this.onCustomMessage = le.onCustomMessage || N, this.onReceivedMessage = le.onReceivedMessage || N, this.onDeliveredMessage = le.onDeliveredMessage || N, this.onReadMessage = le.onReadMessage || N, this.onRecallMessage = le.onRecallMessage || N, this.onChannelMessage = le.onChannelMessage || N, this.onError = le.onError || N, this.onOffline = le.onOffline || N, this.onOnline = le.onOnline || N, this.onStatisticMessage = le.onStatisticMessage || N, this.onContactInvited = le.onContactInvited || N, this.onContactAgreed = le.onContactAgreed || N, this.onContactRefuse = le.onContactRefuse || N, this.onContactDeleted = le.onContactDeleted || N, this.onContactAdded = le.onContactAdded || N, this.onTokenWillExpire = le.onTokenWillExpire || N, this.onTokenExpired = le.onTokenExpired || N, this.onClosed = le.onClosed || N, this.onPresenceStatusChange = le.onPresenceStatusChange || N;
        }
        h(2772);
        var _ = { biz: "", debug: !1, token: "" }, I = "https://data-reporting.rtnsvc.com/report", k = "https://data-reporting.realtimemesh.com/report", H = h(2071), S = h(1595), B = function(le) {
          var X = Number(S.C8[le]);
          return X === S.C8.USER_LOGIN ? "MANUALLOGIN" : X === S.C8.MSYNC_SENDMESSAGE ? "SENDMESSAGE" : X > S.C8.UNKNOWOPERATION && X < S.C8.REST_OPERATE ? "REST" : X > S.C8.REST_OPERATE && X < S.C8.MSYNC_OPERATE ? "MESSAGE" : X > S.C8.MSYNC_OPERATE && X < S.C8.ROSTER_OPERATE ? "ROSTER" : X > S.C8.ROSTER_OPERATE && X < S.C8.USER_OPERATE ? "USER" : X > S.C8.USER_OPERATE && X < S.C8.GROUP_OPERATE ? "GROUP" : X > S.C8.GROUP_OPERATE && X < S.C8.CHATROOM_OPERATE ? "CHATROOM" : "OPERATION";
        }, D = function() {
          return (/* @__PURE__ */ new Date()).getTime();
        }, F = function(le) {
          return [p.iw.BAIDU, p.iw.WX, p.iw.DD, p.iw.ZFB, p.iw.TT, p.iw.QUICK_APP, p.iw.UNI].includes(le.platform);
        }, j = function() {
          return le = 1, X = 99999, le = Math.ceil(le), X = Math.floor(X), Math.floor(Math.random() * (X - le)) + le;
          var le, X;
        }, G = h(4319), U = {}, M = (h(561), h(1249), function(le, X) {
          var re = {};
          for (var Me in le) Object.prototype.hasOwnProperty.call(le, Me) && X.indexOf(Me) < 0 && (re[Me] = le[Me]);
          if (le != null && typeof Object.getOwnPropertySymbols == "function") {
            var Se = 0;
            for (Me = Object.getOwnPropertySymbols(le); Se < Me.length; Se++) X.indexOf(Me[Se]) < 0 && Object.prototype.propertyIsEnumerable.call(le, Me[Se]) && (re[Me[Se]] = le[Me[Se]]);
          }
          return re;
        }), V = 1e3, J = function() {
          function le(X) {
            this.eventQueue = [], this.stock = V, this.config = X, this.governor();
          }
          return le.prototype.add = function(X) {
            this.stock <= 0 ? console.warn("Event Report limit ".concat(V, " per minute")) : (this.eventQueue.push(X), this.consume(), this.stock -= 1);
          }, le.prototype.consume = function() {
            var X = this;
            this.eventQueue.length !== 0 && (this.timer && this.eventQueue.length <= 10 && clearTimeout(this.timer), this.timer = setTimeout(function() {
              var re, Me = X.eventQueue.splice(0, 10), Se = Me.filter(function(Ge) {
                return Ge.appId === Me[0].appId;
              }), ke = Me.filter(function(Ge) {
                return Ge.appId !== Me[0].appId;
              });
              (re = X.eventQueue).unshift.apply(re, ke), X.batchSend(Se);
            }, 1e3));
          }, le.prototype.governor = function() {
            var X = this, re = setInterval(function() {
              X.stock = V;
            }, 6e4);
            typeof addEventListener < "u" && addEventListener("beforeunload", function() {
              clearInterval(re);
            });
          }, le.prototype.batchSend = function(X) {
            var re, Me;
            if (X === void 0 && (X = []), X.length !== 0) try {
              var Se = X.map(function(ke) {
                ke.biz, ke.appId;
                var Ge = ke.eventId, nt = M(ke, ["biz", "appId", "eventId"]);
                return { eventId: Number(Ge), body: nt };
              });
              (function(ke, Ge) {
                try {
                  var nt = Ge.biz, rt = Ge.appId, dt = Ge.data, lt = Ge.debug, Ct = Ge.onSuccess;
                  if (!nt) throw new Error("biz is not defined");
                  U.global || (U = p.P6.getEnvInfo());
                  var Ie = U;
                  if (F(Ie)) {
                    var x = { url: lt ? k : I, data: dt, method: "POST", timeout: G.zj, success: function() {
                      Ct == null || Ct();
                    }, fail: function() {
                    }, complete: function() {
                    } }, ae = { token: ke, appid: rt ?? "", sendts: "".concat(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3)), biz: nt, debug: "".concat(lt) };
                    if (Ie.platform === "zfb" || Ie.platform === "dd" ? x.headers = ae : x.header = ae, Ie.platform === "dd") return Ie.global.httpRequest(x);
                    Ie.global.request(x);
                  } else {
                    var Q = new XMLHttpRequest();
                    Q.onreadystatechange = function() {
                      Q.readyState === 2 && (Ct == null || Ct());
                    }, Q.open("POST", lt ? k : I), Q.setRequestHeader("Content-Type", "application/json"), Q.setRequestHeader("token", ke), Q.setRequestHeader("appid", rt ?? ""), Q.setRequestHeader("sendts", "".concat(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3))), Q.setRequestHeader("biz", nt), Q.setRequestHeader("debug", "".concat(lt)), Q.send(JSON.stringify(dt));
                  }
                } catch (Z) {
                  console.error(Z);
                }
              })(this.config.token, { biz: (re = X[0]) === null || re === void 0 ? void 0 : re.biz, appId: (Me = X[0]) === null || Me === void 0 ? void 0 : Me.appId, data: Se, debug: this.config.debug, onSuccess: this.consume.bind(this) });
            } catch (ke) {
              console.error(ke);
            }
          }, le;
        }(), ue = function() {
          return ue = Object.assign || function(le) {
            for (var X, re = 1, Me = arguments.length; re < Me; re++) for (var Se in X = arguments[re]) Object.prototype.hasOwnProperty.call(X, Se) && (le[Se] = X[Se]);
            return le;
          }, ue.apply(this, arguments);
        }, se = new (function() {
          function le(X) {
            this.inited = !1, this.appId = "", this.biz = "", this.eventQueue = {}, this.config = _, X && this.init(X);
          }
          return le.prototype.init = function(X) {
            var re;
            if (X === void 0 && (X = {}), !X.biz || !X.token) throw new Error("Event Report: biz or token is not defined");
            try {
              this.appId = (re = X.appId) !== null && re !== void 0 ? re : "", this.biz = X.biz, this.config = ue(ue({}, _), X), this.eventQueue = new J(this.config), this.log(X), this.inited = !0;
            } catch (Me) {
              console.error(Me);
            }
          }, le.prototype.updateAppId = function(X) {
            this.appId = X;
          }, le.prototype.send = function(X, re, Me) {
            var Se;
            if (re === void 0 && (re = {}), this.inited) {
              var ke = ue(ue({}, re), { eventId: Number(X), biz: this.biz, appId: (Se = Me == null ? void 0 : Me.appId) !== null && Se !== void 0 ? Se : this.appId });
              this.eventQueue.add(ke), this.log(ke);
            } else console.error("Event Report: init is not called");
          }, le.prototype.log = function(X) {
            try {
              if (this.config.debug) {
                var re = X.payload, Me = function(Se, ke) {
                  var Ge = {};
                  for (var nt in Se) Object.prototype.hasOwnProperty.call(Se, nt) && ke.indexOf(nt) < 0 && (Ge[nt] = Se[nt]);
                  if (Se != null && typeof Object.getOwnPropertySymbols == "function") {
                    var rt = 0;
                    for (nt = Object.getOwnPropertySymbols(Se); rt < nt.length; rt++) ke.indexOf(nt[rt]) < 0 && Object.prototype.propertyIsEnumerable.call(Se, nt[rt]) && (Ge[nt[rt]] = Se[nt[rt]]);
                  }
                  return Ge;
                }(X, ["payload"]);
                console.log("%c Event Report: ".concat(this.config.biz, " "), "background: #8A97FC; color: #fff"), console.table(Me), re && (console.info("payload:"), console.table(re));
              }
            } catch (Se) {
              console.error(Se);
            }
          }, le;
        }())(), ee = function() {
          return ee = Object.assign || function(le) {
            for (var X, re = 1, Me = arguments.length; re < Me; re++) for (var Se in X = arguments[re]) Object.prototype.hasOwnProperty.call(X, Se) && (le[Se] = X[Se]);
            return le;
          }, ee.apply(this, arguments);
        }, de = { requestName: "", subrequestid: "1", requestMethod: "GET", requestUrl: "", requestElapse: 0, code: 0, codeDesc: "", isLastApi: 0, isSuccess: 1 }, he = function() {
          function le(X) {
            this.platform = p.P6.getEnvInfo(), this.isReportDt = X.isReport || !1, this.isCollectDt = !0, F(this.platform) && !this.isReportDt && (this.isCollectDt = !1), this.eventQueue = [], this.accessChannel = H.yK, this.options = function(re, Me) {
              Me.platform || (Me = p.P6.getEnvInfo());
              var Se = re.org, ke = re.appkey, Ge = re.deviceId, nt = re.sdkVersion, rt = typeof navigator < "u" ? navigator == null ? void 0 : navigator.userAgent : "".concat(Me.platform, "_mini_program");
              return { org: Se, appkey: ke, deviceId: Ge, sdkServiceId: "sid_".concat(p.P6.getUniqueId(), "_").concat(j()), did: rt, sdkVersion: nt, os: H.Wc, sdkProduct: S.aC.web };
            }(X, this.platform), this.sid = this.options.sdkServiceId, this.init(X);
          }
          return le.getInstance = function(X) {
            return le.instance || (le.instance = new le(X)), le.instance;
          }, le.prototype.getServiceId = function() {
            return this.sid || "sid_0";
          }, le.prototype.setIsReportDt = function(X) {
            this.isReportDt = X, X && this.rptEventQueue();
          }, le.prototype.setIsCollectDt = function(X) {
            this.isCollectDt = X, X || (this.eventQueue = []);
          }, le.prototype.rptEventQueue = function() {
            var X = this;
            this.eventQueue.length && this.eventQueue.forEach(function(re, Me) {
              se.send(re.eventId, re.dt), Me >= X.eventQueue.length - 1 && (X.eventQueue = []);
            });
          }, le.prototype.init = function(X) {
            le.instance || (le.instance = this, se.init({ biz: H.el, token: H.$x, appId: X.appkey, debug: !1 }), this.reportInit());
          }, le.prototype.updateAppKey = function(X) {
            this.options.appkey = X, this.eventQueue.forEach(function(re) {
              re.dt.appkey === "default#appkey" && (re.dt.appkey = X);
            });
          }, le.prototype.reportInit = function() {
            if (this.isCollectDt) {
              var X = this.options, re = X.did, Me = X.os, Se = X.sdkVersion, ke = X.deviceId;
              this.reportData(H.iB.INIT, { did: re, os: Me, sdkVersion: Se, deviceId: ke });
            }
          }, le.prototype.geOperateFun = function(X) {
            var re = this;
            if (!this.isCollectDt) return function() {
            };
            var Me = 1, Se = 0, ke = "", Ge = D(), nt = X.uid, rt = X.operationName;
            nt && (this.uid = nt);
            var dt = { uid: this.uid, operationId: "opr_".concat(p.P6.getUniqueId(), "_").concat(j()), requestid: "req_".concat(p.P6.getUniqueId(), "_").concat(j()), operationName: rt };
            return function(lt) {
              var Ct, Ie, x, ae;
              if (lt.data.isSuccess ? (Se = 0, ke = "") : (lt.data.code === 0 && (lt.data.code = H.Tp), Se = (Ct = lt.data.code) !== null && Ct !== void 0 ? Ct : Se, ke = (Ie = lt.data.codeDesc) !== null && Ie !== void 0 ? Ie : ke), !((x = lt.data) === null || x === void 0) && x.accessChannel && (re.accessChannel = (ae = lt.data) === null || ae === void 0 ? void 0 : ae.accessChannel), lt.isRetry ? (Me++, lt.data.subrequestid = "".concat(Me)) : (dt.requestid = "req_".concat(p.P6.getUniqueId(), "_").concat(j()), Me = 1), lt.data.isLastApi) {
                var Q = D();
                lt.data.requestElapse = Q - Ge, lt.data.requestMethod = "", lt.data.subrequestid = "0", lt.data.code = Se === 200 ? 0 : Se, lt.data.codeDesc = ke;
              } else lt.data.requestName || (lt.data.requestName = rt);
              lt.data.requestElapse || (lt.data.requestElapse = D() - Ge), re.reportData.call(re, H.iB.API, ee(ee(ee(ee({}, de), dt), lt.data), { accessChannel: re.accessChannel, operationType: B(rt) })), lt.isEndApi && re.reportData.call(re, H.iB.API, ee(ee(ee({}, dt), de), { isSuccess: lt.data.isSuccess, isLastApi: 1, subrequestid: "0", requestMethod: "", code: Se === 200 ? 0 : Se, codeDesc: ke, requestElapse: lt.data.requestElapse, accessChannel: re.accessChannel, operationType: B(rt) }));
            };
          }, le.prototype.reportData = function(X, re) {
            return Me = this, Se = void 0, Ge = function() {
              var nt, rt, dt, lt, Ct, Ie, x, ae;
              return function(Q, Z) {
                var ge, me, ve, ie, ye = { label: 0, sent: function() {
                  if (1 & ve[0]) throw ve[1];
                  return ve[1];
                }, trys: [], ops: [] };
                return ie = { next: Ye(0), throw: Ye(1), return: Ye(2) }, typeof Symbol == "function" && (ie[Symbol.iterator] = function() {
                  return this;
                }), ie;
                function Ye(ne) {
                  return function(Qe) {
                    return function(W) {
                      if (ge) throw new TypeError("Generator is already executing.");
                      for (; ye; ) try {
                        if (ge = 1, me && (ve = 2 & W[0] ? me.return : W[0] ? me.throw || ((ve = me.return) && ve.call(me), 0) : me.next) && !(ve = ve.call(me, W[1])).done) return ve;
                        switch (me = 0, ve && (W = [2 & W[0], ve.value]), W[0]) {
                          case 0:
                          case 1:
                            ve = W;
                            break;
                          case 4:
                            return ye.label++, { value: W[1], done: !1 };
                          case 5:
                            ye.label++, me = W[1], W = [0];
                            continue;
                          case 7:
                            W = ye.ops.pop(), ye.trys.pop();
                            continue;
                          default:
                            if (!((ve = (ve = ye.trys).length > 0 && ve[ve.length - 1]) || W[0] !== 6 && W[0] !== 2)) {
                              ye = 0;
                              continue;
                            }
                            if (W[0] === 3 && (!ve || W[1] > ve[0] && W[1] < ve[3])) {
                              ye.label = W[1];
                              break;
                            }
                            if (W[0] === 6 && ye.label < ve[1]) {
                              ye.label = ve[1], ve = W;
                              break;
                            }
                            if (ve && ye.label < ve[2]) {
                              ye.label = ve[2], ye.ops.push(W);
                              break;
                            }
                            ve[2] && ye.ops.pop(), ye.trys.pop();
                            continue;
                        }
                        W = Z.call(Q, ye);
                      } catch (ce) {
                        W = [6, ce], me = 0;
                      } finally {
                        ge = ve = 0;
                      }
                      if (5 & W[0]) throw W[1];
                      return { value: W[0] ? W[1] : void 0, done: !0 };
                    }([ne, Qe]);
                  };
                }
              }(this, function(Q) {
                switch (Q.label) {
                  case 0:
                    return Q.trys.push([0, 3, , 4]), nt = D(), rt = 0, X !== H.iB.API ? [3, 2] : [4, (Z = this.platform, new Promise(function(ge) {
                      var me;
                      Z.platform || (Z = p.P6.getEnvInfo());
                      var ve = "";
                      if (Z.platform === p.iw.WEB) {
                        var ie = navigator.connection;
                        ie != null && ie.type ? (ie == null || ie.type, ve = S.td.WIFI) : ie != null && ie.effectiveType && (ve = S.td[ie.effectiveType.toLocaleUpperCase()]), ge(ve);
                      } else Z.platform === p.iw.NODE ? (ve = S.td.UNKNOWN, ge(ve)) : (me = Z.global) === null || me === void 0 || me.getNetworkType({ success: function(ye) {
                        ve = S.td[ye.networkType.toLocaleUpperCase()], ge(ve);
                      } });
                    }))];
                  case 1:
                    rt = Q.sent(), Q.label = 2;
                  case 2:
                    return dt = this.options, lt = dt.appkey, Ct = dt.sdkServiceId, Ie = dt.sdkProduct, x = ee({ lts: nt, net: rt, appkey: lt, sdkServiceId: Ct, sdkProduct: Ie }, re), this.isReportDt ? se.send(X, x) : this.isCollectDt && this.eventQueue.push({ eventId: X, dt: x }), [3, 4];
                  case 3:
                    return ae = Q.sent(), console.warn(ae), [3, 4];
                  case 4:
                    return [2];
                }
                var Z;
              });
            }, new ((ke = void 0) || (ke = Promise))(function(nt, rt) {
              function dt(Ie) {
                try {
                  Ct(Ge.next(Ie));
                } catch (x) {
                  rt(x);
                }
              }
              function lt(Ie) {
                try {
                  Ct(Ge.throw(Ie));
                } catch (x) {
                  rt(x);
                }
              }
              function Ct(Ie) {
                var x;
                Ie.done ? nt(Ie.value) : (x = Ie.value, x instanceof ke ? x : new ke(function(ae) {
                  ae(x);
                })).then(dt, lt);
              }
              Ct((Ge = Ge.apply(Me, Se || [])).next());
            });
            var Me, Se, ke, Ge;
          }, le;
        }(), pe = h(7288), Ce = h(7479), _e = h(2856), Le = h(9667), Te = h(3770), K = h(1735), Oe = h(7384), Pe = h(70), xe = h(8161);
        function be(le) {
          return be = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(X) {
            return typeof X;
          } : function(X) {
            return X && typeof Symbol == "function" && X.constructor === Symbol && X !== Symbol.prototype ? "symbol" : typeof X;
          }, be(le);
        }
        var $e = function() {
          return $e = Object.assign || function(le) {
            for (var X, re = 1, Me = arguments.length; re < Me; re++) for (var Se in X = arguments[re]) Object.prototype.hasOwnProperty.call(X, Se) && (le[Se] = X[Se]);
            return le;
          }, $e.apply(this, arguments);
        }, Be = function(le, X, re, Me) {
          return new (re || (re = Promise))(function(Se, ke) {
            function Ge(dt) {
              try {
                rt(Me.next(dt));
              } catch (lt) {
                ke(lt);
              }
            }
            function nt(dt) {
              try {
                rt(Me.throw(dt));
              } catch (lt) {
                ke(lt);
              }
            }
            function rt(dt) {
              var lt;
              dt.done ? Se(dt.value) : (lt = dt.value, lt instanceof re ? lt : new re(function(Ct) {
                Ct(lt);
              })).then(Ge, nt);
            }
            rt((Me = Me.apply(le, [])).next());
          });
        }, Ke = function(le, X) {
          var re, Me, Se, ke, Ge = { label: 0, sent: function() {
            if (1 & Se[0]) throw Se[1];
            return Se[1];
          }, trys: [], ops: [] };
          return ke = { next: nt(0), throw: nt(1), return: nt(2) }, typeof Symbol == "function" && (ke[Symbol.iterator] = function() {
            return this;
          }), ke;
          function nt(rt) {
            return function(dt) {
              return function(lt) {
                if (re) throw new TypeError("Generator is already executing.");
                for (; Ge; ) try {
                  if (re = 1, Me && (Se = 2 & lt[0] ? Me.return : lt[0] ? Me.throw || ((Se = Me.return) && Se.call(Me), 0) : Me.next) && !(Se = Se.call(Me, lt[1])).done) return Se;
                  switch (Me = 0, Se && (lt = [2 & lt[0], Se.value]), lt[0]) {
                    case 0:
                    case 1:
                      Se = lt;
                      break;
                    case 4:
                      return Ge.label++, { value: lt[1], done: !1 };
                    case 5:
                      Ge.label++, Me = lt[1], lt = [0];
                      continue;
                    case 7:
                      lt = Ge.ops.pop(), Ge.trys.pop();
                      continue;
                    default:
                      if (!((Se = (Se = Ge.trys).length > 0 && Se[Se.length - 1]) || lt[0] !== 6 && lt[0] !== 2)) {
                        Ge = 0;
                        continue;
                      }
                      if (lt[0] === 3 && (!Se || lt[1] > Se[0] && lt[1] < Se[3])) {
                        Ge.label = lt[1];
                        break;
                      }
                      if (lt[0] === 6 && Ge.label < Se[1]) {
                        Ge.label = Se[1], Se = lt;
                        break;
                      }
                      if (Se && Ge.label < Se[2]) {
                        Ge.label = Se[2], Ge.ops.push(lt);
                        break;
                      }
                      Se[2] && Ge.ops.pop(), Ge.trys.pop();
                      continue;
                  }
                  lt = X.call(le, Ge);
                } catch (Ct) {
                  lt = [6, Ct], Me = 0;
                } finally {
                  re = Se = 0;
                }
                if (5 & lt[0]) throw lt[1];
                return { value: lt[0] ? lt[1] : void 0, done: !0 };
              }([rt, dt]);
            };
          }
        }, Ze = p.P6.getEnvInfo(), at = function() {
          function le(X) {
            var re, Me = this;
            if (this.name = "connection", this.appKey = "", this.dnsTotal = 0, this.max_cache_length = 100, this._reportLogs = !1, this._reportInterval = G.XV, this._isLogging = !1, this._initWithAppId = !1, this.lastHeartbeat = Date.now(), this.isDebug = X.isDebug || !1, this.isReport = !1, this.uploadPartEnable = !0, this.isHttpDNS = X.isHttpDNS === void 0 || X.isHttpDNS, this.heartBeatWait = X.heartBeatWait || G.al, this.autoReconnectNumMax = X.autoReconnectNumMax || G.ke, this.refreshDNSIntervals = this.autoReconnectNumMax < 5 ? this.autoReconnectNumMax : 5, this.delivery = X.delivery || !1, this.disconnectedReason = void 0, this.loginInfoCustomExt = void 0, this.https = p.P6.isUseHttps(X.https), this.dnsArr = ["https://rs.chat.rtnsvc.com", "https://rs.chat.realtimemesh.com"].filter(function(nt) {
              return nt.startsWith(Me.https ? "https" : "");
            }), this.dnsIndex = 0, this.restHosts = [], this.restTotal = 0, this.restIndex = 0, this.hostIndex = 0, this.socketHost = [], this.hostTotal = 0, this.times = 1, this.autoReconnectNumTotal = 0, this.domain = "easemob.com", this.dnsTotal = this.dnsArr.length, "appKey" in X && (this.appKey = X.appKey), "appId" in X && (this.appId = X.appId, this._initWithAppId = !0), this.appName = "", this.orgName = "", this.token = "", this.grantType = "", this.apiUrl = X.apiUrl || "", this.url = X.url || "", this.version = "1.3.2", this.deviceId = X.deviceId || "webim", this.isFixedDeviceId = (re = X.isFixedDeviceId) === null || re === void 0 || re, this.osType = 16, this.useOwnUploadFun = X.useOwnUploadFun || !1, this.compressType = [0], this.encryptType = [0], this.clientResource = "", this.expiresIn = 0, this.expirationTime = 0, this.useReplacedMessageContents = X.useReplacedMessageContents || !1, this.logOut = !0, this.context = { jid: { appKey: "", clientResource: "", domain: "easemob.com", name: "" }, userId: "", appKey: "", appId: "", status: 0, restTokenData: "", appName: "", orgName: "", root: {}, accessToken: "" }, this._msgHash = {}, this._msgPromiseHash = {}, this._queues = [], this._load_msg_cache = [], this.unMSyncSendMsgMap = /* @__PURE__ */ new Map(), this.mr_cache = {}, this.reconnecting = !1, this._offlineMessagePullState = m.a.SYNC_INIT, this._offlineMessagePullQueue = [], this.uniPushConfig = {}, this.uniPush = null, this.isRegisterPush = !1, this.pushCertificateName = "", this._initWithAppId) {
              if (this.appKey = "", typeof this.appId != "string" || !this.appId) throw Error("Invalid appId: ".concat(this.appId));
            } else {
              if (typeof this.appKey != "string" || this.appKey.split("#").length !== 2) throw Error("Invalid appKey: ".concat(this.appKey));
              this.devInfos = this.appKey.split("#"), this.orgName = this.devInfos[0], this.appName = this.devInfos[1];
            }
            this.listen = w.bind(this), this.mSync = this.usePlugin(y.ZP), this.eventHandler = this.usePlugin(O), Object.assign(le.prototype, Ce), Object.assign(le.prototype, _e), Object.assign(le.prototype, Le), Object.assign(le.prototype, Te), Object.assign(le.prototype, K), Object.assign(le.prototype, Oe), Object.assign(le.prototype, Pe), this.dataReport = new he({ appkey: this.appKey || "default#appkey", org: this.orgName, sdkVersion: this.version, deviceId: this.deviceId, isReport: this.isReport });
            var Se = 0, ke = this;
            if (Object.defineProperty(p.P6, "ajaxUnconventionalErrorTimes", { set: function(nt) {
              nt !== 0 && (g.kg.debug("rest api request fail times: ".concat(nt)), (Se = nt) % 5 == 0 && ke.isHttpDNS && (g.kg.debug("refresh dns config when rest request fail."), Et.call(ke, function() {
              })));
            }, get: function() {
              return Se;
            } }), this.isFixedDeviceId) {
              var Ge = p.P6.getLocalDeviceInfo();
              Ge && (this.clientResource = JSON.parse(Ge).deviceId);
            }
            g.kg.debug("init SDK: Conn ".concat(this.version, " ").concat(Ze.platform));
          }
          return le.prototype.usePlugin = function(X, re) {
            if (re !== "push") return re ? void (this[re] = new X(this)) : new X(this);
            X.config && X.emPush ? (this.uniPushConfig = X.config, this.uniPush = X.emPush) : g.kg.error("use push plugin failed", "emPush", this.uniPush, "config", this.uniPushConfig);
          }, le.prototype.listen = function(X) {
          }, le.prototype.addEventHandler = function(X, re) {
          }, le.prototype.removeEventHandler = function(X) {
          }, le.prototype.registerUser = function(X) {
            return Be(this, void 0, void 0, function() {
              var re, Me;
              return Ke(this, function(Se) {
                switch (Se.label) {
                  case 0:
                    if (!X.username || !X.password) throw Error("Invalid parameter");
                    Se.label = 1;
                  case 1:
                    return Se.trys.push([1, 5, , 6]), re = this.dataReport.geOperateFun({ uid: X.username, operationName: S.fI.REGISTER }), this.isHttpDNS ? (this.dnsIndex = 0, [4, Et.call(this, re)]) : [3, 3];
                  case 2:
                    Se.sent(), Se.label = 3;
                  case 3:
                    return [4, It.call(this, X, { rpt: re })];
                  case 4:
                    return [2, Se.sent()];
                  case 5:
                    throw Me = Se.sent(), X.error && X.error(Me), Me;
                  case 6:
                    return [2];
                }
              });
            });
          }, le.prototype.open = function(X) {
            var re;
            return Be(this, void 0, void 0, function() {
              var Me, Se, ke, Ge, nt, rt;
              return Ke(this, function(dt) {
                switch (dt.label) {
                  case 0:
                    if (g.kg.debug("open", X.user, "isLogout:", this.logOut), this._isLogging) throw Se = d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_ERROR, message: "Currently logging in, please wait." });
                    if (!this.logOut) throw Se = d.Z.create({ type: E.E.WEBIM_USER_ALREADY_LOGIN, message: "The user has logged in." });
                    this.retryConnectTimes = 0, this._isLogging = !0, dt.label = 1;
                  case 1:
                    if (dt.trys.push([1, 6, 7, 8]), Ze.platform === "web" && (Me = p.P6.detectBrowser(), g.kg.debug("browser", Me)), Se = Ot.call(this, X)) throw (re = this.onError) === null || re === void 0 || re.call(this, Se), Se;
                    return X.accessToken && (this.token = X.accessToken), ke = $e({}, X), Ge = this.dataReport.geOperateFun({ uid: X.user, operationName: S.fI.LOGIN }), this.dnsIndex = 0, this.isHttpDNS ? [4, Et.call(this, Ge)] : [3, 3];
                  case 2:
                    dt.sent(), dt.label = 3;
                  case 3:
                    return g.kg.initReport({ report: this._reportLogs, reportInterval: this._reportInterval, connection: this }), [4, gt.call(this, ke, { rpt: Ge })];
                  case 4:
                    return nt = dt.sent(), [4, Ut.call(this, Ge)];
                  case 5:
                    return dt.sent(), g.kg.debug("grantType", this.grantType), p.P6.listenNetwork(it.bind(this), Tt.bind(this)), p.P6.listenBrowserVisibility(function() {
                      g.kg.debug("visibility: true");
                    }, function() {
                      g.kg.debug("visibility: false");
                    }), [2, nt];
                  case 6:
                    throw rt = dt.sent(), this._isLogging = !1, X.error && X.error(rt), g.kg.error("login failed", rt), rt;
                  case 7:
                    return g.kg.reportLog(), [7];
                  case 8:
                    return [2];
                }
              });
            });
          }, le.prototype.isOpened = function() {
            return this.sock && this.sock.readyState === 1 || !1;
          }, le.prototype.close = function() {
            var X, re, Me;
            g.kg.debug("call close"), g.kg._stopReportLogs(), this.logOut = !0, this.disconnectedReason = void 0, this.reconnecting = !1, this.context.status = E.E.STATUS_CLOSING, this.sock && this.sock.close(), (X = this.unMSyncSendMsgMap) === null || X === void 0 || X.clear(), this.stopHeartBeat(), this.rejectMessage(), this.context.status = E.E.STATUS_CLOSED, this._load_msg_cache = [], this._queues = [], this._msgHash = {}, this.mr_cache = {}, this.token = "", this.context.accessToken = "", this.isRegisterPush = !1, this.clearTokenTimeout(), (Me = (re = this == null ? void 0 : this._localCache) === null || re === void 0 ? void 0 : re.getInstance()) === null || Me === void 0 || Me.close(), this.connectionTimer && clearTimeout(this.connectionTimer), this.provisionTimer && clearTimeout(this.provisionTimer), this.probingTimer && clearTimeout(this.probingTimer);
          }, le.prototype.downloadAndParseCombineMessage = function(X) {
            var re = this, Me = X.url, Se = X.secret;
            return new Promise(function(ke, Ge) {
              var nt, rt, dt = p.P6.getEnvInfo(), lt = dt.platform !== "web" && dt.platform !== "node" && dt.platform !== "quick_app" && ((rt = (nt = dt.global) === null || nt === void 0 ? void 0 : nt.canIUse) === null || rt === void 0 ? void 0 : rt.call(nt, "getFileSystemManager")), Ct = function(x) {
                var ae = function(ve) {
                  Ge({ type: E.E.PARSE_FILE_ERROR, message: "Read file failed", data: ve });
                }, Q = function(ve) {
                  return Be(re, void 0, void 0, function() {
                    var ie, ye, Ye, ne, Qe, W, ce, fe, we, Fe, je, qe, et;
                    return Ke(this, function(bt) {
                      switch (bt.label) {
                        case 0:
                          for (ie = lt ? new Uint8Array(ve.data) : new Uint8Array(ve.target.result), ye = 0, Ye = 0, ne = 2, Qe = ie.subarray(ye, ye + ne), W = p.P6.Uint8ArrayToString(Qe), g.kg.debug("file header:", W), Ye += ne, ce = 0, fe = 2; fe < ie.length - 1; fe++) fe % 2 == 1 && (ce ^= ie[fe]);
                          if (we = ie.subarray(ie.length - 1, ie.length), g.kg.debug("checkResult:", ce, we[0] === ce), we[0] !== ce) return [2, Ge({ type: E.E.PARSE_FILE_ERROR, message: "File verification failed" })];
                          if (W !== "cm") return [3, 7];
                          bt.label = 1;
                        case 1:
                          bt.trys.push([1, 5, , 6]), Fe = [], je = function() {
                            var ot, Lt, Kt, $t;
                            return Ke(this, function(yt) {
                              switch (yt.label) {
                                case 0:
                                  return ye += ne, Ye += ne = 4, ot = ie.subarray(ye, ye + ne), ye += ne, ne = ot.reduce(function(Wt, In, gn) {
                                    return Wt + (In << 8 * (ot.length - gn - 1));
                                  }, 0), Ye += ne, Lt = ie.subarray(ye, ye + ne), Kt = (Kt = qe.root.lookup("easemob.pb.Meta")).decode(Lt), [4, xe.Z.call(qe, Kt, 0, !0, !0)];
                                case 1:
                                  return $t = yt.sent(), Fe.push($t), [2];
                              }
                            });
                          }, qe = this, bt.label = 2;
                        case 2:
                          return Ye < ie.length - 1 ? [5, je()] : [3, 4];
                        case 3:
                          return bt.sent(), [3, 2];
                        case 4:
                          return [2, ke(Fe)];
                        case 5:
                          return et = bt.sent(), Ge({ type: E.E.PARSE_FILE_ERROR, message: "Parse file failed", data: et }), [3, 6];
                        case 6:
                          return [3, 8];
                        case 7:
                          return [2, Ge({ type: E.E.PARSE_FILE_ERROR, message: "File verification failed" })];
                        case 8:
                          return [2];
                      }
                    });
                  });
                };
                if (lt) {
                  var Z = dt.global.getFileSystemManager(), ge = x.tempFilePath;
                  Z.readFile({ filePath: ge, success: Q, fail: ae });
                } else if (x instanceof Blob) {
                  var me = new FileReader();
                  me.readAsArrayBuffer(x), me.onerror = ae, me.onload = Q;
                }
              }, Ie = function(x) {
                Ge({ type: E.E.WEBIM_DOWNLOADFILE_ERROR, message: "Download failed, please try again", data: x });
              };
              lt ? dt.global.downloadFile({ url: Me, success: Ct, fail: Ie }) : p.P6.download.call(re, { url: Me, headers: { Accept: "application/json" }, onFileDownloadComplete: Ct, onFileDownloadError: Ie, secret: Se, accessToken: re.context.accessToken });
            });
          }, le.prototype.stopHeartBeat = function() {
            clearInterval(this.heartBeatID);
          }, le.prototype.clear = function() {
            this.restTotal = 0, this.restIndex = 0, this.hostIndex = 0, this.hostTotal = 0;
          }, le.prototype.heartBeat = function() {
          }, le.prototype.renewToken = function(X) {
            var re = this;
            return this.isOpened() ? this.getTokenExpireTimestamp(X).then(function(Me) {
              var Se = Me.expire_timestamp, ke = Date.now();
              return re.expirationTime = Se, re.expiresIn = Se - ke, re.token = X, re.context.accessToken = X, re.clearTokenTimeout(), re.tokenExpireTimeCountDown(re.expiresIn), { status: !0, token: X, expire: Se };
            }) : Promise.reject({ status: !1 });
          }, le.prototype.clearTokenTimeout = function() {
            g.kg.info("clearTokenTimeout"), this.tokenWillExpireTimer && clearTimeout(this.tokenWillExpireTimer), this.tokenExpiredTimer && clearTimeout(this.tokenExpiredTimer), this.tokenWillExpireTimer = null, this.tokenExpiredTimer = null;
          }, le.prototype.tokenExpireTimeCountDown = function(X) {
            var re = this;
            g.kg.info("tokenExpireTimeCountDown", X), X > Math.pow(2, 31) - 1 && (X = Math.pow(2, 31) - 1), this.tokenWillExpireTimer = setTimeout(function() {
              var Me;
              re.onTokenWillExpire && re.onTokenWillExpire(), (Me = re.eventHandler) === null || Me === void 0 || Me.dispatch("onTokenWillExpire"), g.kg.info("onTokenWillExpire", Math.floor(X / 2));
            }, X / 2), this.tokenExpiredTimer = setTimeout(function() {
              var Me;
              g.kg.info("onTokenExpired", 0), re.onTokenExpired && re.onTokenExpired(), (Me = re.eventHandler) === null || Me === void 0 || Me.dispatch("onTokenExpired"), re.close();
            }, X);
          }, le.prototype.compareTokenExpireTime = function(X, re) {
            var Me, Se = Number(re) - Number(X);
            g.kg.debug("compareTokenExpireTime", Se), Se <= this.expiresIn / 2 && Se > 0 ? (this.onTokenWillExpire && this.onTokenWillExpire(), (Me = this.eventHandler) === null || Me === void 0 || Me.dispatch("onTokenWillExpire"), g.kg.info("onTokenWillExpire", Se)) : Se <= 0 && (this.closeByTokenExpired(), g.kg.info("closeByTokenExpired", Se));
          }, le.prototype.closeByTokenExpired = function() {
            var X;
            g.kg.info("closed By TokenExpired"), this.onTokenExpired && this.onTokenExpired(), (X = this.eventHandler) === null || X === void 0 || X.dispatch("onTokenExpired"), this.close();
          }, le.prototype.rejectMessage = function() {
            var X = this, re = Object.keys(this._msgHash);
            if (re.length > 0) {
              var Me = d.Z.create({ type: E.E.MESSAGE_WEBSOCKET_DISCONNECTED, message: "websocket disconnected" });
              re.forEach(function(Se) {
                var ke, Ge, nt;
                !((ke = X.unMSyncSendMsgMap) === null || ke === void 0) && ke.has(Se) || (X._msgHash[Se].reject instanceof Function && X._msgHash[Se].reject(Me), (nt = (Ge = X._localCache) === null || Ge === void 0 ? void 0 : Ge.getInstance()) === null || nt === void 0 || nt.updateLocalMessage(Se, { serverMsgId: Se, status: pe.r.FAIL }), X._msgHash[Se].fail instanceof Function && X._msgHash[Se].fail(Me), X._msgHash[Se].messageTimer && clearTimeout(X._msgHash[Se].messageTimer), delete X._msgHash[Se]);
              });
            }
          }, le.prototype.resetConnState = function() {
            this.mSync.stopHeartBeat(), this.times = 1, this.autoReconnectNumTotal = 0, this.hostIndex = 0;
          }, le.prototype.reconnect = function(X) {
            var re, Me = this;
            if (this.logout) return g.kg.warn("The user has already logged out when reconnecting");
            if (g.kg.debug("socket reconnect readyState", this.sock.readyState), (this.sock.readyState !== 0 || X) && (this.sock.readyState !== 1 || X)) {
              g.kg.info("reconnect: time", this.times), g.kg.info("reconnect sock.readyState: ", this.sock.readyState), this.reconnecting === !1 && (this.reconnecting = !0), (re = this.eventHandler) === null || re === void 0 || re.dispatch("onReconnecting"), this.rejectMessage(), this.isHttpDNS && (this.hostIndex < this.socketHost.length - 1 ? this.hostIndex++ : this.hostIndex = this.socketHost.length - 1);
              var Se = 1e3 * p.P6.getRetryDelay(this.times);
              g.kg.info("reconnect delay: ", Se), setTimeout(function() {
                (Me.sock.readyState !== 1 || X) && (g.kg.info("login sock.readyState: ", Me.sock.readyState), Me.sock.close(), st.call(Me).catch(function(ke) {
                  g.kg.error("reconnect websocket failed", ke);
                }), Me.times++);
              }, Se), this.autoReconnectNumTotal++;
            }
          }, le.prototype.send = function(X) {
            return Promise.resolve(null);
          }, le.prototype.setLoginInfoCustomExt = function(X) {
            if (g.kg.debug("setLoginInfoCustomExt", "params:", X), X) {
              if (typeof X != "string") throw new Error("ext must be a string");
              if (X.length > 1024) throw new Error("ext length must be less than 1024");
            }
            this.loginInfoCustomExt = X;
          }, le.prototype.onShow = function() {
            var X = this;
            g.kg.debug("execute onshow callback", this.lastHeartbeat), !this.logOut && !this.reconnecting && Date.now() - this.lastHeartbeat > 2e3 && (g.kg.debug("send ping"), this.mSync.sendUnreadDeal(), this.probingTimer && clearTimeout(this.probingTimer), this.probingTimer = setTimeout(function() {
              g.kg.error("Websocket connection timeout"), X.logOut || X.reconnecting || X.reconnect(!0);
            }, G.xd));
          }, le._getSock = function() {
          }, le;
        }();
        function pt(le, X) {
          var re = X.rpt, Me = X.isRetry, Se = this.apiUrl + "/" + this.orgName + "/" + this.appName + "/users", ke = { requestName: S.c.RESISTER, requestUrl: Se }, Ge = { headers: { "Content-Type": "application/json" }, url: Se, dataType: "json", data: JSON.stringify({ username: le.username, password: le.password, nickname: le.nickname || "" }) };
          return p.P6.ajax(Ge, S.fI.SDK_INTERNAL).then(function(nt) {
            var rt = $e($e({}, nt), { type: E.E.REQUEST_SUCCESS }), dt = nt.extraInfo, lt = dt.httpCode, Ct = dt.elapse;
            return re({ isEndApi: !0, isRetry: Me, data: $e($e({}, { requestElapse: Ct, isSuccess: 1, code: lt }), ke) }), rt;
          }).catch(function(nt) {
            var rt = nt.extraInfo, dt = rt.elapse, lt = rt.httpCode, Ct = rt.errDesc;
            throw re({ isRetry: Me, data: $e($e({}, { requestElapse: dt, isSuccess: 0, code: lt, codeDesc: Ct }), ke) }), nt;
          });
        }
        function It(le, X) {
          return Be(this, void 0, void 0, function() {
            var re, Me;
            return Ke(this, function(Se) {
              switch (Se.label) {
                case 0:
                  re = X.rpt, Se.label = 1;
                case 1:
                  return Se.trys.push([1, 3, , 7]), [4, pt.call(this, le, X)];
                case 2:
                  return [2, Se.sent()];
                case 3:
                  return !((Me = Se.sent()).message.includes("Open registration doesn't allow") || Me.message.includes("username be unique") || Me.message.includes("is not legal")) && this.isHttpDNS && this.restIndex + 1 < this.restTotal ? (this.restIndex++, St.call(this), [4, It.call(this, le, { rpt: re })]) : [3, 5];
                case 4:
                  return [2, Se.sent()];
                case 5:
                  throw g.kg.error("retry signup failed", Me), re({ data: { isLastApi: 1, isSuccess: 0 } }), Me;
                case 6:
                  return [3, 7];
                case 7:
                  return [2];
              }
            });
          });
        }
        function Rt(le, X) {
          var re;
          return Be(this, void 0, void 0, function() {
            var Me, Se, ke, Ge, nt, rt, dt, lt, Ct, Ie = this;
            return Ke(this, function(x) {
              switch (x.label) {
                case 0:
                  if (Me = Ot.call(this, le)) throw Me;
                  return g.kg.debug("socket readyState", (re = this.sock) === null || re === void 0 ? void 0 : re.readyState), Se = X.rpt, ke = X.isRetry, kt.call(this, le), this.user = le.user, Ge = this.context.appName, nt = this.context.orgName, rt = this.apiUrl + "/" + nt + "/" + Ge + "/token", le.accessToken ? (g.kg.debug("login with accessToken"), this.grantType = "accessToken", this.token = le.accessToken, this.context.accessToken = le.accessToken, this.context.restTokenData = le.accessToken, [2, { accessToken: le.accessToken }]) : [3, 1];
                case 1:
                  return le.agoraToken ? (g.kg.debug("login with agoraToken"), this.grantType = "agoraToken", this.token = le.agoraToken, this.context.accessToken = le.agoraToken, this.context.restTokenData = le.agoraToken, [2, { accessToken: le.agoraToken }]) : [3, 2];
                case 2:
                  return g.kg.debug("login with password"), this.grantType = "password", dt = { grant_type: "password", username: le.user, password: le.pwd, timestamp: +/* @__PURE__ */ new Date() }, lt = JSON.stringify(dt), Ct = { headers: { "Content-Type": "application/json" }, url: rt, dataType: "json", data: lt, version: this.version }, g.kg.debug("start get token"), [4, p.P6.ajax(Ct, S.fI.SDK_INTERNAL).then(function(ae) {
                    g.kg.debug("get token success", ae), Ie.token = ae.access_token, Ie.context.restTokenData = ae.access_token, Ie.context.accessToken = ae.access_token, Ie.expiresIn = ae.expires_in;
                    var Q = ae.extraInfo, Z = Q.httpCode, ge = Q.elapse, me = { requestName: S.c.LOGIN_BY_PWD, requestElapse: ge, requestUrl: rt, isSuccess: 1, code: Z };
                    return Se({ isRetry: ke, data: me }), { accessToken: ae.access_token, duration: ae.expires_in };
                  }).catch(function(ae) {
                    var Q = ae.extraInfo, Z = Q.elapse, ge = Q.httpCode, me = Q.errDesc, ve = { requestName: S.c.LOGIN_BY_PWD, requestElapse: Z, requestUrl: rt, isSuccess: 0, code: ge, codeDesc: me };
                    throw Se({ isRetry: ke, data: ve }), ae;
                  })];
                case 3:
                  return [2, x.sent()];
              }
            });
          });
        }
        function gt(le, X) {
          var re;
          return Be(this, void 0, void 0, function() {
            var Me, Se, ke;
            return Ke(this, function(Ge) {
              switch (Ge.label) {
                case 0:
                  Me = X.rpt, Ge.label = 1;
                case 1:
                  return Ge.trys.push([1, 3, , 7]), [4, Rt.call(this, le, X)];
                case 2:
                  return [2, Ge.sent()];
                case 3:
                  return (Se = Ge.sent()).message !== "invalid password" && Se.message !== "user not found" && this.isHttpDNS && this.restIndex + 1 < this.restTotal ? (this.restIndex++, St.call(this), [4, gt.call(this, le, { rpt: Me, isRetry: !0 })]) : [3, 5];
                case 4:
                  return [2, Ge.sent()];
                case 5:
                  throw g.kg.error("retry login failed", Se), Me({ data: { isLastApi: 1, isSuccess: 0 } }), this.clear(), ke = void 0, Se.error && Se.error_description ? (ke = d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_USERGRID_ERROR, message: Se.error_description, data: Se }), this.onError && this.onError(ke), ke) : (ke = d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_ERROR, message: (re = Se.message) !== null && re !== void 0 ? re : "login failed", data: Se }), this.onError && this.onError(ke), ke);
                case 6:
                  return [3, 7];
                case 7:
                  return [2];
              }
            });
          });
        }
        function it() {
          var le;
          g.kg.debug("online"), this.onOnline && this.onOnline(), (le = this.eventHandler) === null || le === void 0 || le.dispatch("onOnline"), this.sock && this.sock.readyState !== 1 && (g.kg.debug("sock.readyState:", this.sock.readyState), this.logOut || this.reconnecting || this.reconnect());
        }
        function Tt() {
          var le, X;
          g.kg.debug("offline"), (le = this.sock) === null || le === void 0 || le.close(), this.onOffline && this.onOffline(), (X = this.eventHandler) === null || X === void 0 || X.dispatch("onOffline");
        }
        function Ut(le) {
          var X, re, Me;
          return Be(this, void 0, void 0, function() {
            var Se, ke, Ge, nt;
            return Ke(this, function(rt) {
              switch (rt.label) {
                case 0:
                  Se = (/* @__PURE__ */ new Date()).getTime(), rt.label = 1;
                case 1:
                  return rt.trys.push([1, 3, , 7]), [4, st.call(this, le)];
                case 2:
                  return ke = rt.sent(), le && le({ data: { isLastApi: 1, isSuccess: 1, accessChannel: (X = this.socketHost[this.hostIndex]) === null || X === void 0 ? void 0 : X.channel } }), [2, ke];
                case 3:
                  if (Ge = rt.sent(), g.kg.error("connect to msync failed times:", this.retryConnectTimes, Ge), G.bh.includes(Ge.type)) throw le && le({ data: { isLastApi: 1, isSuccess: 0, accessChannel: (re = this.socketHost[this.hostIndex]) === null || re === void 0 ? void 0 : re.channel, codeDesc: this.disconnectedReason && JSON.stringify(this.disconnectedReason) || Ge.message } }), Ge;
                  return this.retryConnectTimes++, this.retryConnectTimes < G.Ge ? (this.isHttpDNS && (this.hostIndex < this.socketHost.length - 1 ? this.hostIndex++ : this.hostIndex = this.socketHost.length - 1, ut.call(this)), Ge.type === E.E.REQUEST_TIMEOUT && Ge.message === "provision timeout" || (nt = (/* @__PURE__ */ new Date()).getTime() - Se, le == null || le({ isRetry: this.retryConnectTimes !== 1, data: { requestUrl: this.url, requestName: S.c.CONNECT_WEBSOCKET, isSuccess: 0, code: S.dd.closed, requestElapse: nt, codeDesc: this.disconnectedReason && JSON.stringify(this.disconnectedReason) || "websocket close" } })), [4, Ut.call(this, le)]) : [3, 5];
                case 4:
                  return rt.sent(), [3, 6];
                case 5:
                  throw g.kg.error("connect failed three times", Ge), le && le({ data: { isLastApi: 1, isSuccess: 0, accessChannel: (Me = this.socketHost[this.hostIndex]) === null || Me === void 0 ? void 0 : Me.channel, codeDesc: this.disconnectedReason && JSON.stringify(this.disconnectedReason) || Ge.message } }), Ge;
                case 6:
                  return [3, 7];
                case 7:
                  return [2];
              }
            });
          });
        }
        function st(le) {
          var X = this, re = (/* @__PURE__ */ new Date()).getTime(), Me = "pending";
          return new Promise(function(Se, ke) {
            var Ge;
            X._getSock ? (Ge = X._getSock()).readyState === void 0 && (X.needSetReadyState = !0) : (Ge = new WebSocket(X.url)).binaryType = "arraybuffer", X.sock = Ge, X.connectionTimer && clearTimeout(X.connectionTimer), X.connectionTimer = setTimeout(function() {
              X.disconnectedReason = { type: E.E.REQUEST_TIMEOUT, message: "connection timeout" }, Ge.close(), ke == null || ke(X.disconnectedReason);
            }, G.th), g.kg.debug("start connect ws"), X.connectionResolve = Se, X.connectionReject = ke;
            var nt = function() {
              if (X.connectionTimer && clearTimeout(X.connectionTimer), g.kg.debug("websocket onOpen"), le) {
                var lt = (/* @__PURE__ */ new Date()).getTime() - re;
                le({ isRetry: X.retryConnectTimes !== 0, data: { requestUrl: X.url, requestName: S.c.CONNECT_WEBSOCKET, isSuccess: 1, code: S.dd.success, requestElapse: lt } });
              }
              var Ct;
              Ct = X._getSock ? p.P6.flow([X.mSync.generateProvision, X.mSync.base64transform])() : X.mSync.generateProvision();
              try {
                X.provisionTimer && clearTimeout(X.provisionTimer), X.provisionTimer = setTimeout(function() {
                  g.kg.debug("provision timeout"), X.disconnectedReason = d.Z.create({ type: E.E.REQUEST_TIMEOUT, message: "provision timeout" }), Ge.close(), ke == null || ke(X.disconnectedReason);
                }, G.Nt), Ge.send(Ct);
              } catch (x) {
                var Ie = d.Z.create({ type: E.E.SDK_RUNTIME_ERROR, message: "send message error", data: x });
                X.onError && X.onError(Ie);
              }
            }, rt = function(lt) {
              X.connectionTimer && clearTimeout(X.connectionTimer), setTimeout(function() {
                var Ct, Ie, x, ae, Q, Z, ge;
                if (g.kg.debug("websocket onClose, isLogging:", X._isLogging, lt), X.needSetReadyState && (X.sock = $e($e({}, X.sock), { close: X.sock.close, send: X.sock.send, readyState: 3 })), X._isLogging) return ke == null || ke({ type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" }), void (Me = "rejected");
                if (Me !== "rejected") if (Me = "rejected", X.logOut) X.clear(), X.resetConnState(), (Ie = (Ct = X == null ? void 0 : X._localCache) === null || Ct === void 0 ? void 0 : Ct.getInstance()) === null || Ie === void 0 || Ie.close(), X.onClosed && X.onClosed(), (x = X.eventHandler) === null || x === void 0 || x.dispatch("onDisconnected", X.disconnectedReason), ke == null || ke(X.disconnectedReason || { type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" });
                else if (X.autoReconnectNumTotal < X.autoReconnectNumMax) {
                  X.reconnect();
                  var me = { type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" };
                  X.onError && X.onError(me), X.autoReconnectNumTotal % X.refreshDNSIntervals == 0 && X.isHttpDNS && (g.kg.debug("refresh dns config when websocket close"), Et.call(X, function() {
                  }));
                } else (ae = X.unMSyncSendMsgMap) === null || ae === void 0 || ae.clear(), X.rejectMessage(), me = { type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" }, X.disconnectedReason = d.Z.create({ type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "reconnection failed" }), X.onError && X.onError(me), (Z = (Q = X == null ? void 0 : X._localCache) === null || Q === void 0 ? void 0 : Q.getInstance()) === null || Z === void 0 || Z.close(), X.onClosed && X.onClosed(), (ge = X.eventHandler) === null || ge === void 0 || ge.dispatch("onDisconnected", X.disconnectedReason), X.resetConnState(), X.reconnecting = !1, ke == null || ke(me), g.kg.debug("reconnect fail");
                else g.kg.debug("reject is null");
              }, 0);
            }, dt = function(lt) {
              var Ct = X.mSync, Ie = Ct.decodeMSync, x = Ct.distributeMSync;
              p.P6.flow([Ie, x])(lt);
            };
            Ze.platform === "web" ? (Ge.onopen = nt, Ge.onclose = rt, Ge.onmessage = dt) : (Ge.onOpen(nt), Ge.onMessage(dt), Ge.onClose(rt), typeof window < "u" && window.WebSocket || Ge.onError(function(lt) {
              var Ct, Ie, x, ae;
              if (X.connectionTimer && clearTimeout(X.connectionTimer), g.kg.debug("websocket onerror, isLogging:", X._isLogging, lt), X.sock.readyState !== 3 && (X.sock = $e($e({}, X.sock), { close: X.sock.close, send: X.sock.send, readyState: 3 })), X.onError && X.onError({ type: E.E.WEBIM_CONNECTION_ERROR, message: "on socket error", data: lt }), X._isLogging) return ke == null || ke({ type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" }), void (Me = "rejected");
              if (Me !== "rejected") {
                if (Me = "rejected", !X.logOut) if (X.autoReconnectNumTotal < X.autoReconnectNumMax) g.kg.debug("sock.onError reconnect", X.autoReconnectNumTotal, X.autoReconnectNumMax), X.reconnect(), X.autoReconnectNumTotal % X.refreshDNSIntervals == 0 && X.isHttpDNS && (g.kg.debug("refresh dns config when websocket error"), Et.call(X, function() {
                }));
                else {
                  var Q = { type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" };
                  X.disconnectedReason = d.Z.create({ type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "reconnection failed" }), (Ct = X.unMSyncSendMsgMap) === null || Ct === void 0 || Ct.clear(), X.rejectMessage(), X.onError && X.onError(Q), (x = (Ie = X == null ? void 0 : X._localCache) === null || Ie === void 0 ? void 0 : Ie.getInstance()) === null || x === void 0 || x.close(), X.onClosed && X.onClosed(), (ae = X.eventHandler) === null || ae === void 0 || ae.dispatch("onDisconnected", X.disconnectedReason), X.resetConnState(), X.reconnecting = !1, ke == null || ke(Q), g.kg.debug("reconnect fail");
                }
              } else g.kg.debug("reject is null");
            }));
          });
        }
        function Ot(le) {
          if (be(le) !== "object" || le === null) return d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the param is illegal" });
          if (!le.user || typeof le.user != "string") {
            var X = d.Z.create({ type: E.E.WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR, message: "the user is empty or type is not string" });
            return g.kg.debug("open params error", X), X;
          }
          return !("agoraToken" in le) || le.agoraToken && typeof le.agoraToken == "string" ? !("accessToken" in le) || le.accessToken && typeof le.accessToken == "string" ? "accessToken" in le || "agoraToken" in le || le.pwd ? void 0 : (X = d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the accessToken or pwd is illegal" }), g.kg.debug("open params error", X), X) : (X = d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the accessToken is illegal" }), g.kg.debug("open params error", X), X) : (X = d.Z.create({ type: E.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the agoraToken is illegal" }), g.kg.debug("open params error", X), console.warn("agoraToken is deprecated, please use accessToken instead"), X);
        }
        function kt(le) {
          this.context.jid = { appKey: this.appKey, name: le.user, domain: this.domain, clientResource: this.clientResource }, this.context.root = this.root, this.context.userId = le.user, this.context.appKey = this.appKey, this.context.appName = this.appName, this.context.orgName = this.orgName;
        }
        function wt(le) {
          var X = this, re = le.rpt, Me = le.isRetry, Se = this.dnsIndex < this.dnsTotal ? this.dnsIndex : 0, ke = "".concat(this.dnsArr[Se], "/easemob/server.json");
          g.kg.debug("call getHttpDNS: " + this.dnsIndex);
          var Ge = { url: ke, dataType: "json", type: "GET", data: {} };
          return this._initWithAppId ? Ge.data = { app_id: this.appId, sdk_version: "4.10.0", file_version: "1" } : Ge.data = { app_key: Ze.platform === p.iw.WEB ? encodeURIComponent(this.appKey) : this.appKey }, p.P6.ajax(Ge, S.fI.SDK_INTERNAL).then(function(nt) {
            if (!nt) throw d.Z.create({ type: E.E.SERVER_GET_DNSLIST_FAILED, message: "get DNS failed" });
            g.kg.debug("getHttpDNS success");
            var rt = nt.rest.hosts, dt = X.https ? "https" : "http";
            if (g.kg.info("httpType: " + dt), X._initWithAppId) {
              if (!nt.app_key) throw (Ct = d.Z.create({ type: E.E.SERVER_GET_DNSLIST_FAILED, message: "get DNS failed" })).extraInfo = nt.extraInfo, Ct;
              X.appKey = nt.app_key, X.context.appKey = X.appKey, X.devInfos = X.appKey.split("#"), X.orgName = X.devInfos[0], X.appName = X.devInfos[1], X.dataReport.updateAppKey(X.appKey);
            }
            if (!rt) throw (Ct = d.Z.create({ type: E.E.SERVER_GET_DNSLIST_FAILED, message: "DNS hosts resolution failed", data: nt.rest })).extraInfo = nt.extraInfo, Ct;
            var lt = rt.filter(function(me) {
              if (me.protocol === dt) return me;
            });
            X.restHosts = lt, X.restTotal = lt.length;
            var Ct, Ie = nt["msync-wx"].hosts;
            if (!Ie) throw (Ct = d.Z.create({ type: E.E.SERVER_GET_DNSLIST_FAILED, message: "DNS msync-wx resolution failed", data: nt["msync-wx"] })).extraInfo = nt.extraInfo, Ct;
            var x = Ie.filter(function(me) {
              if (me.protocol === dt) return me;
            });
            if (X.socketHost = x, X.hostTotal = x.length, X.isHttpDNS && St.call(X), X.isHttpDNS && ut.call(X), X._reportLogs = nt.enableReportLogs === "true", X._reportInterval = Number(nt.reportInterval || G.XV), (nt == null ? void 0 : nt.enableDataReport) === "true" ? (X.dataReport.setIsCollectDt(!0), X.dataReport.setIsReportDt(!0)) : (X.dataReport.setIsReportDt(!1), X.dataReport.setIsCollectDt(!1)), (nt == null ? void 0 : nt.uploadinparts_enable) === "false" && (X.uploadPartEnable = !1), nt.extraInfo) {
              var ae = nt.extraInfo, Q = ae.elapse, Z = ae.httpCode, ge = { requestUrl: ke, requestName: S.c.GET_DNS, requestElapse: Q, isSuccess: 1, code: Z };
              re && re({ isRetry: Me, data: ge });
            }
          }).catch(function(nt) {
            var rt = nt.extraInfo || {}, dt = rt.elapse, lt = rt.httpCode, Ct = rt.errDesc, Ie = { requestUrl: ke, requestName: S.c.GET_DNS, isSuccess: 0, code: lt, codeDesc: Ct, requestElapse: dt };
            throw re && re({ isRetry: Me, data: Ie }), d.Z.create({ type: E.E.SERVER_GET_DNSLIST_FAILED, message: nt.message, data: nt });
          });
        }
        function Et(le, X) {
          return Be(this, void 0, void 0, function() {
            var re;
            return Ke(this, function(Me) {
              switch (Me.label) {
                case 0:
                  return Me.trys.push([0, 2, , 6]), [4, wt.call(this, { rpt: le, isRetry: X })];
                case 1:
                case 3:
                  return [2, Me.sent()];
                case 2:
                  return re = Me.sent(), g.kg.error("get DNS failed", re, "times:", this.dnsIndex), this.dnsIndex++, this.dnsIndex < this.dnsTotal ? [4, Et.call(this, le, !0)] : [3, 4];
                case 4:
                  throw g.kg.error("retryRequestDNS failed"), d.Z.create({ type: E.E.SERVER_GET_DNSLIST_FAILED, message: "get DNS failed", data: re });
                case 5:
                  return [3, 6];
                case 6:
                  return [2];
              }
            });
          });
        }
        function ut() {
          var le = this.socketHost[this.hostIndex], X = le.domain, re = le.ip, Me = le.port, Se = "";
          Se = X || re, Me && Me !== "80" && Me !== "443" && (Se += ":" + Me), Se && (this.url = "//" + Se + "/websocket");
          var ke = this.https ? "wss:" : "ws:";
          this.url = ke + this.url;
        }
        function St() {
          var le, X;
          if (this.restIndex > this.restTotal) return g.kg.debug("restIndex > restTotal"), "";
          var re = "", Me = this.restHosts[this.restIndex], Se = Me.domain, ke = Me.ip, Ge = Me.port, nt = this.https ? "https:" : "http:";
          return ke && typeof window < "u" && ((le = window == null ? void 0 : window.location) === null || le === void 0 ? void 0 : le.protocol) === "http:" ? re = nt + "//" + ke + ":" + Ge : (re = nt + "//" + Se, Ge && Ge !== "80" && Ge !== "443" && (re += ":".concat(Ge)), typeof window > "u" || window.location || (re = "https://" + Se), typeof window < "u" && window.location && ((X = window.location) === null || X === void 0 ? void 0 : X.protocol) === "file:" && (re = "https://" + Se)), typeof window > "u" && (re = nt + "//" + Se), this.apiUrl = re, re;
        }
        var Ft = h(2449);
        v().util.Long = c(), v().configure();
        var Ht = v().Root.fromJSON({ nested: { easemob: { nested: { pb: { nested: { MessageBody: { fields: { type: { type: "Type", id: 1 }, from: { type: "JID", id: 2 }, to: { type: "JID", id: 3 }, contents: { rule: "repeated", type: "Content", id: 4 }, ext: { rule: "repeated", type: "KeyValue", id: 5 }, ackMessageId: { type: "uint64", id: 6 }, msgConfig: { type: "MessageConfig", id: 7 }, ackContent: { type: "string", id: 8 }, meta: { type: "string", id: 9 }, editMessageId: { type: "uint64", id: 11 } }, nested: { Content: { fields: { type: { type: "Type", id: 1 }, text: { type: "string", id: 2 }, latitude: { type: "double", id: 3 }, longitude: { type: "double", id: 4 }, address: { type: "string", id: 5 }, displayName: { type: "string", id: 6 }, remotePath: { type: "string", id: 7 }, secretKey: { type: "string", id: 8 }, fileLength: { type: "int32", id: 9 }, action: { type: "string", id: 10 }, params: { rule: "repeated", type: "KeyValue", id: 11 }, duration: { type: "int32", id: 12 }, size: { type: "Size", id: 13 }, thumbnailRemotePath: { type: "string", id: 14 }, thumbnailSecretKey: { type: "string", id: 15 }, thumbnailDisplayName: { type: "string", id: 16 }, thumbnailFileLength: { type: "int32", id: 17 }, thumbnailSize: { type: "Size", id: 18 }, customEvent: { type: "string", id: 19 }, customExts: { rule: "repeated", type: "KeyValue", id: 20 }, buildingName: { type: "string", id: 21 }, subType: { type: "SubType", id: 22 }, title: { type: "string", id: 23 }, summary: { type: "string", id: 24 }, combineLevel: { type: "int32", id: 25 } }, nested: { Type: { values: { TEXT: 0, IMAGE: 1, VIDEO: 2, LOCATION: 3, VOICE: 4, FILE: 5, COMMAND: 6, CUSTOM: 7, COMBINE: 8 } }, Size: { fields: { width: { type: "double", id: 1 }, height: { type: "double", id: 2 } } }, SubType: { values: { COMBINE: 0 } } } }, Type: { values: { NORMAL: 0, CHAT: 1, GROUPCHAT: 2, CHATROOM: 3, READ_ACK: 4, DELIVER_ACK: 5, RECALL: 6, CHANNEL_ACK: 7, EDIT: 8 } }, MessageConfig: { fields: { allowGroupAck: { type: "bool", id: 1 } } } } }, KeyValue: { oneofs: { value: { oneof: ["varintValue", "floatValue", "doubleValue", "stringValue"] } }, fields: { key: { type: "string", id: 1 }, type: { type: "ValueType", id: 2 }, varintValue: { type: "int64", id: 3 }, floatValue: { type: "float", id: 4 }, doubleValue: { type: "double", id: 5 }, stringValue: { type: "string", id: 6 } }, nested: { ValueType: { values: { BOOL: 1, INT: 2, UINT: 3, LLINT: 4, FLOAT: 5, DOUBLE: 6, STRING: 7, JSON_STRING: 8 } } } }, JID: { fields: { appKey: { type: "string", id: 1 }, name: { type: "string", id: 2 }, domain: { type: "string", id: 3 }, clientResource: { type: "string", id: 4 } } }, ConferenceBody: { fields: { sessionId: { type: "string", id: 1 }, operation: { type: "Operation", id: 2 }, conferenceId: { type: "string", id: 3 }, type: { type: "Type", id: 4 }, content: { type: "string", id: 5 }, network: { type: "string", id: 6 }, version: { type: "string", id: 7 }, identity: { type: "Identity", id: 8 }, duration: { type: "string", id: 9 }, peerName: { type: "string", id: 10 }, endReason: { type: "EndReason", id: 11 }, status: { type: "Status", id: 12 }, isDirect: { type: "bool", id: 13 }, controlType: { type: "StreamControlType", id: 14 }, routeFlag: { type: "int32", id: 15 }, routeKey: { type: "string", id: 16 } }, nested: { Status: { fields: { errorCode: { type: "int32", id: 1 } } }, Operation: { values: { JOIN: 0, INITIATE: 1, ACCEPT_INITIATE: 2, ANSWER: 3, TERMINATE: 4, REMOVE: 5, STREAM_CONTROL: 6, MEDIA_REQUEST: 7 } }, Type: { values: { VOICE: 0, VIDEO: 1 } }, Identity: { values: { CALLER: 0, CALLEE: 1 } }, EndReason: { values: { HANGUP: 0, NORESPONSE: 1, REJECT: 2, BUSY: 3, FAIL: 4, UNSUPPORTED: 5, OFFLINE: 6 } }, StreamControlType: { values: { PAUSE_VOICE: 0, RESUME_VOICE: 1, PAUSE_VIDEO: 2, RESUME_VIDEO: 3 } } } }, MSync: { fields: { version: { type: "Version", id: 1, options: { default: "MSYNC_V1" } }, guid: { type: "JID", id: 2 }, auth: { type: "string", id: 3 }, compressAlgorimth: { type: "uint32", id: 4 }, crypto: { type: "uint32", id: 5 }, userAgent: { type: "string", id: 6 }, pov: { type: "uint64", id: 7 }, command: { type: "Command", id: 8 }, deviceId: { type: "uint32", id: 10 }, encryptType: { rule: "repeated", type: "EncryptType", id: 11, options: { packed: !1 } }, encryptKey: { type: "string", id: 12 }, payload: { type: "bytes", id: 9 } }, nested: { Version: { values: { MSYNC_V1: 0, MSYNC_V2: 1 } }, Command: { values: { SYNC: 0, UNREAD: 1, NOTICE: 2, PROVISION: 3 } } } }, EncryptType: { values: { ENCRYPT_NONE: 0, ENCRYPT_AES_128_CBC: 1, ENCRYPT_AES_256_CBC: 2 } }, CommSyncUL: { fields: { meta: { type: "Meta", id: 1 }, key: { type: "uint64", id: 2 }, queue: { type: "JID", id: 3 }, isRoam: { type: "bool", id: 4 }, lastFullRoamKey: { type: "uint64", id: 5 } } }, CommSyncDL: { fields: { status: { type: "Status", id: 1 }, metaId: { type: "uint64", id: 2 }, serverId: { type: "uint64", id: 3 }, metas: { rule: "repeated", type: "Meta", id: 4 }, nextKey: { type: "uint64", id: 5 }, queue: { type: "JID", id: 6 }, isLast: { type: "bool", id: 7 }, timestamp: { type: "uint64", id: 8 }, isRoam: { type: "bool", id: 9 } } }, CommNotice: { fields: { queue: { type: "JID", id: 1 } } }, CommUnreadUL: { fields: {} }, CommUnreadDL: { fields: { status: { type: "Status", id: 1 }, unread: { rule: "repeated", type: "MetaQueue", id: 2 }, timestamp: { type: "uint64", id: 3 } } }, MetaQueue: { fields: { queue: { type: "JID", id: 1 }, n: { type: "uint32", id: 2 } } }, Meta: { fields: { id: { type: "uint64", id: 1 }, from: { type: "JID", id: 2 }, to: { type: "JID", id: 3 }, timestamp: { type: "uint64", id: 4 }, ns: { type: "NameSpace", id: 5 }, payload: { type: "bytes", id: 6 }, routetype: { type: "RouteType", id: 7 }, ext: { rule: "repeated", type: "KeyValue", id: 8 }, meta: { type: "bytes", id: 9 }, directedUsers: { rule: "repeated", type: "string", id: 10 } }, nested: { NameSpace: { values: { STATISTIC: 0, CHAT: 1, MUC: 2, ROSTER: 3, CONFERENCE: 4, NOTIFY: 5, QUERY: 6 } }, RouteType: { values: { ROUTE_ALL: 0, ROUTE_ONLINE: 1, ROUTE_DIRECT: 2 } } } }, Status: { fields: { errorCode: { type: "ErrorCode", id: 1 }, reason: { type: "string", id: 2 }, redirectInfo: { rule: "repeated", type: "RedirectInfo", id: 3 } }, nested: { ErrorCode: { values: { OK: 0, FAIL: 1, UNAUTHORIZED: 2, MISSING_PARAMETER: 3, WRONG_PARAMETER: 4, REDIRECT: 5, TOKEN_EXPIRED: 6, PERMISSION_DENIED: 7, NO_ROUTE: 8, UNKNOWN_COMMAND: 9, PB_PARSER_ERROR: 10, BIND_ANOTHER_DEVICE: 11, IM_FORBIDDEN: 12, TOO_MANY_DEVICES: 13, PLATFORM_LIMIT: 14, USER_MUTED: 15, ENCRYPT_DISABLE: 16, ENCRYPT_ENABLE: 17, DECRYPT_FAILURE: 18, PERMISSION_DENIED_EXTERNAL: 19 } } } }, RedirectInfo: { fields: { host: { type: "string", id: 1 }, port: { type: "uint32", id: 2 } } }, Provision: { fields: { osType: { type: "OsType", id: 1 }, version: { type: "string", id: 2 }, networkType: { type: "NetworkType", id: 3 }, appSign: { type: "string", id: 4 }, compressType: { rule: "repeated", type: "CompressType", id: 5, options: { packed: !1 } }, encryptType: { rule: "repeated", type: "EncryptType", id: 6, options: { packed: !1 } }, encryptKey: { type: "string", id: 7 }, status: { type: "Status", id: 8 }, deviceUuid: { type: "string", id: 9 }, isManualLogin: { type: "bool", id: 10 }, password: { type: "string", id: 11 }, deviceName: { type: "string", id: 12 }, resource: { type: "string", id: 13 }, auth: { type: "string", id: 14 }, serviceId: { type: "string", id: 16 }, actionVersion: { type: "string", id: 17 }, authToken: { type: "string", id: 18 }, sessionId: { type: "string", id: 20 }, reason: { type: "string", id: 21 } }, nested: { OsType: { values: { OS_IOS: 0, OS_ANDROID: 1, OS_LINUX: 2, OS_OSX: 3, OS_WIN: 4, OS_OTHER: 16 } }, NetworkType: { values: { NETWORK_NONE: 0, NETWORK_WIFI: 1, NETWORK_4G: 2, NETWORK_3G: 3, NETWORK_2G: 4, NETWORK_WIRE: 5 } }, CompressType: { values: { COMPRESS_NONE: 0, COMPRESS_ZLIB: 1 } } } }, MUCBody: { fields: { mucId: { type: "JID", id: 1 }, operation: { type: "Operation", id: 2 }, from: { type: "JID", id: 3 }, to: { rule: "repeated", type: "JID", id: 4 }, setting: { type: "Setting", id: 5 }, reason: { type: "string", id: 6 }, isChatroom: { type: "bool", id: 7 }, status: { type: "Status", id: 8 }, isThread: { type: "bool", id: 9 }, mucParentId: { type: "JID", id: 10 }, mucName: { type: "string", id: 11 }, eventInfo: { type: "EventInfo", id: 12 }, mucMemberCount: { type: "int32", id: 13 }, ext: { type: "string", id: 14 }, leaveOtherRooms: { type: "bool", id: 15 } }, nested: { Operation: { values: { CREATE: 0, DESTROY: 1, JOIN: 2, LEAVE: 3, APPLY: 4, APPLY_ACCEPT: 5, APPLY_DECLINE: 6, INVITE: 7, INVITE_ACCEPT: 8, INVITE_DECLINE: 9, KICK: 10, GET_BLACKLIST: 11, BAN: 12, ALLOW: 13, UPDATE: 14, BLOCK: 15, UNBLOCK: 16, PRESENCE: 17, ABSENCE: 18, DIRECT_JOINED: 19, ASSIGN_OWNER: 20, ADD_ADMIN: 21, REMOVE_ADMIN: 22, ADD_MUTE: 23, REMOVE_MUTE: 24, UPDATE_ANNOUNCEMENT: 25, DELETE_ANNOUNCEMENT: 26, UPLOAD_FILE: 27, DELETE_FILE: 28, ADD_USER_WHITE_LIST: 29, REMOVE_USER_WHITE_LIST: 30, BAN_GROUP: 31, REMOVE_BAN_GROUP: 32, THREAD_CREATE: 33, THREAD_DESTROY: 34, THREAD_JOIN: 35, THREAD_LEAVE: 36, THREAD_KICK: 37, THREAD_UPDATE: 38, THREAD_PRESENCE: 39, THREAD_ABSENCE: 40, DISABLE_GROUP: 41, ABLE_GROUP: 42, SET_METADATA: 43, DELETE_METADATA: 44, GROUP_MEMBER_METADATA_UPDATE: 45 } }, Setting: { fields: { name: { type: "string", id: 1 }, desc: { type: "string", id: 2 }, type: { type: "Type", id: 3 }, maxUsers: { type: "int32", id: 4 }, owner: { type: "string", id: 5 } }, nested: { Type: { values: { PRIVATE_OWNER_INVITE: 0, PRIVATE_MEMBER_INVITE: 1, PUBLIC_JOIN_APPROVAL: 2, PUBLIC_JOIN_OPEN: 3, PUBLIC_ANONYMOUS: 4 } } } }, Status: { fields: { errorCode: { type: "ErrorCode", id: 1 }, description: { type: "string", id: 2 }, chatroomInfo: { type: "string", id: 3 } }, nested: { ErrorCode: { values: { OK: 0, PERMISSION_DENIED: 1, WRONG_PARAMETER: 2, MUC_NOT_EXIST: 3, USER_NOT_EXIST: 4, UNKNOWN: 5 } } } }, EventInfo: { fields: { eventType: { type: "EventType", id: 1, options: { default: "EVENT_NONE" } }, ext: { type: "string", id: 2 } }, nested: { EventType: { values: { EVENT_NONE: 0, CIRCLE_CHANNEL: 1 } } } } } }, RosterBody: { fields: { operation: { type: "Operation", id: 1 }, status: { type: "Status", id: 2 }, from: { type: "JID", id: 3 }, to: { rule: "repeated", type: "JID", id: 4 }, reason: { type: "string", id: 5 }, rosterVer: { type: "string", id: 6 }, biDirection: { type: "bool", id: 7 } }, nested: { Operation: { values: { GET_ROSTER: 0, GET_BLACKLIST: 1, ADD: 2, REMOVE: 3, ACCEPT: 4, DECLINE: 5, BAN: 6, ALLOW: 7, REMOTE_ACCEPT: 8, REMOTE_DECLINE: 9 } }, Status: { fields: { errorCode: { type: "ErrorCode", id: 1 }, description: { type: "string", id: 2 } }, nested: { ErrorCode: { values: { OK: 0, USER_NOT_EXIST: 1, USER_ALREADY_FRIEND: 2, USER_ALREADY_BLACKLIST: 3 } } } } } }, StatisticsBody: { fields: { operation: { type: "Operation", id: 1 }, os: { type: "OsType", id: 2 }, version: { type: "string", id: 3 }, network: { type: "NetworkType", id: 4 }, imTime: { type: "uint32", id: 5 }, chatTime: { type: "uint32", id: 6 }, location: { type: "string", id: 7 }, reason: { type: "string", id: 10 } }, nested: { Operation: { values: { INFORMATION: 0, USER_REMOVED: 1, USER_LOGIN_ANOTHER_DEVICE: 2, USER_KICKED_BY_CHANGE_PASSWORD: 3, USER_KICKED_BY_OTHER_DEVICE: 4 } }, OsType: { values: { OS_IOS: 0, OS_ANDROID: 1, OS_LINUX: 2, OS_OSX: 3, OS_WIN: 4, OS_OTHER: 16 } }, NetworkType: { values: { NETWORK_NONE: 0, NETWORK_WIFI: 1, NETWORK_4G: 2, NETWORK_3G: 3, NETWORK_2G: 4, NETWORK_WIRE: 5 } } } } } } } } } });
        at.prototype.root = Ht;
        var zt = g.kg.getLogger("defaultLogger");
        zt.setConfig({ useCache: !1, maxCache: 3145728, color: "", background: "" }), zt.enableAll(), at.prototype.getUniqueId = p.P6.getUniqueId;
        var ze = { connection: at, message: Ft.Message, utils: p.P6, logger: zt, statusCode: E.E };
        typeof window < "u" && (window.WebIM = ze);
        var Ne = ze;
      }(), b;
    }();
  });
})(oF);
var Ife = oF.exports;
const Zs = /* @__PURE__ */ Gl(Ife);
function Rfe(t, r) {
  typeof t == "function" ? t(r) : typeof t == "object" && t && "current" in t && (t.current = r);
}
function Nfe(...t) {
  const r = t.filter((a) => a);
  return r.length <= 1 ? r[0] : (a) => {
    t.forEach((u) => {
      Rfe(u, a);
    });
  };
}
function ru() {
  return ru = Object.assign ? Object.assign.bind() : function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a) ({}).hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, ru.apply(null, arguments);
}
function as(t) {
  "@babel/helpers - typeof";
  return as = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, as(t);
}
function wfe(t, r) {
  if (as(t) != "object" || !t) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var u = a.call(t, r || "default");
    if (as(u) != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function cF(t) {
  var r = wfe(t, "string");
  return as(r) == "symbol" ? r : r + "";
}
function Jn(t, r, a) {
  return (r = cF(r)) in t ? Object.defineProperty(t, r, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = a, t;
}
function sj(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function jr(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? sj(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : sj(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function _fe(t, r) {
  if (t == null) return {};
  var a = {};
  for (var u in t) if ({}.hasOwnProperty.call(t, u)) {
    if (r.includes(u)) continue;
    a[u] = t[u];
  }
  return a;
}
function fb(t, r) {
  if (t == null) return {};
  var a, u, h = _fe(t, r);
  if (Object.getOwnPropertySymbols) {
    var b = Object.getOwnPropertySymbols(t);
    for (u = 0; u < b.length; u++) a = b[u], r.includes(a) || {}.propertyIsEnumerable.call(t, a) && (h[a] = t[a]);
  }
  return h;
}
function yo(t, r) {
  if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function aj(t, r) {
  for (var a = 0; a < r.length; a++) {
    var u = r[a];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(t, cF(u.key), u);
  }
}
function vo(t, r, a) {
  return r && aj(t.prototype, r), a && aj(t, a), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function Er(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function hb(t, r) {
  return hb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, u) {
    return a.__proto__ = u, a;
  }, hb(t, r);
}
function gh(t, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), r && hb(t, r);
}
function Sc(t) {
  return Sc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Sc(t);
}
function uF() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (uF = function() {
    return !!t;
  })();
}
function Um(t, r) {
  if (r && (as(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Er(t);
}
function cw(t) {
  var r = uF();
  return function() {
    var a, u = Sc(t);
    if (r) {
      var h = Sc(this).constructor;
      a = Reflect.construct(u, arguments, h);
    } else a = u.apply(this, arguments);
    return Um(this, a);
  };
}
var dF = function(r) {
  return +setTimeout(r, 16);
}, lF = function(r) {
  return clearTimeout(r);
};
typeof window < "u" && "requestAnimationFrame" in window && (dF = function(r) {
  return window.requestAnimationFrame(r);
}, lF = function(r) {
  return window.cancelAnimationFrame(r);
});
var oj = 0, Qb = /* @__PURE__ */ new Map();
function fF(t) {
  Qb.delete(t);
}
var Hu = function(r) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  oj += 1;
  var u = oj;
  function h(b) {
    if (b === 0)
      fF(u), r();
    else {
      var l = dF(function() {
        h(b - 1);
      });
      Qb.set(u, l);
    }
  }
  return h(a), u;
};
Hu.cancel = function(t) {
  var r = Qb.get(t);
  return fF(t), lF(r);
};
process.env.NODE_ENV !== "production" && (Hu.ids = function() {
  return Qb;
});
function K0(t, r) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(r);
  for (var a = r; a; ) {
    if (a === t)
      return !0;
    a = a.parentNode;
  }
  return !1;
}
function cj(t) {
  return t instanceof HTMLElement || t instanceof SVGElement;
}
function Pfe(t) {
  return t && as(t) === "object" && cj(t.nativeElement) ? t.nativeElement : cj(t) ? t : null;
}
function hF(t) {
  var r = Pfe(t);
  if (r)
    return r;
  if (t instanceof _t.Component) {
    var a;
    return (a = jl.findDOMNode) === null || a === void 0 ? void 0 : a.call(jl, t);
  }
  return null;
}
var D2 = { exports: {} }, Ci = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uj;
function xfe() {
  if (uj) return Ci;
  uj = 1;
  var t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), l = Symbol.for("react.context"), v = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function g(C) {
    if (typeof C == "object" && C !== null) {
      var O = C.$$typeof;
      switch (O) {
        case t:
          switch (C = C.type, C) {
            case a:
            case h:
            case u:
            case c:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case v:
                case l:
                case s:
                case m:
                case p:
                case b:
                  return C;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  return Ci.ContextConsumer = l, Ci.ContextProvider = b, Ci.Element = t, Ci.ForwardRef = s, Ci.Fragment = a, Ci.Lazy = m, Ci.Memo = p, Ci.Portal = r, Ci.Profiler = h, Ci.StrictMode = u, Ci.Suspense = c, Ci.SuspenseList = d, Ci.isAsyncMode = function() {
    return !1;
  }, Ci.isConcurrentMode = function() {
    return !1;
  }, Ci.isContextConsumer = function(C) {
    return g(C) === l;
  }, Ci.isContextProvider = function(C) {
    return g(C) === b;
  }, Ci.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Ci.isForwardRef = function(C) {
    return g(C) === s;
  }, Ci.isFragment = function(C) {
    return g(C) === a;
  }, Ci.isLazy = function(C) {
    return g(C) === m;
  }, Ci.isMemo = function(C) {
    return g(C) === p;
  }, Ci.isPortal = function(C) {
    return g(C) === r;
  }, Ci.isProfiler = function(C) {
    return g(C) === h;
  }, Ci.isStrictMode = function(C) {
    return g(C) === u;
  }, Ci.isSuspense = function(C) {
    return g(C) === c;
  }, Ci.isSuspenseList = function(C) {
    return g(C) === d;
  }, Ci.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === a || C === h || C === u || C === c || C === d || C === E || typeof C == "object" && C !== null && (C.$$typeof === m || C.$$typeof === p || C.$$typeof === b || C.$$typeof === l || C.$$typeof === s || C.$$typeof === y || C.getModuleId !== void 0);
  }, Ci.typeOf = g, Ci;
}
var Si = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dj;
function Dfe() {
  return dj || (dj = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), l = Symbol.for("react.context"), v = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), y = !1, g = !1, C = !1, O = !1, N = !1, w;
    w = Symbol.for("react.module.reference");
    function _(Be) {
      return !!(typeof Be == "string" || typeof Be == "function" || Be === a || Be === h || N || Be === u || Be === c || Be === d || O || Be === E || y || g || C || typeof Be == "object" && Be !== null && (Be.$$typeof === m || Be.$$typeof === p || Be.$$typeof === b || Be.$$typeof === l || Be.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Be.$$typeof === w || Be.getModuleId !== void 0));
    }
    function I(Be) {
      if (typeof Be == "object" && Be !== null) {
        var Ke = Be.$$typeof;
        switch (Ke) {
          case t:
            var Ze = Be.type;
            switch (Ze) {
              case a:
              case h:
              case u:
              case c:
              case d:
                return Ze;
              default:
                var at = Ze && Ze.$$typeof;
                switch (at) {
                  case v:
                  case l:
                  case s:
                  case m:
                  case p:
                  case b:
                    return at;
                  default:
                    return Ke;
                }
            }
          case r:
            return Ke;
        }
      }
    }
    var k = l, H = b, S = t, B = s, D = a, F = m, j = p, G = r, U = h, M = u, V = c, J = d, ue = !1, se = !1;
    function ee(Be) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function de(Be) {
      return se || (se = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function he(Be) {
      return I(Be) === l;
    }
    function pe(Be) {
      return I(Be) === b;
    }
    function Ce(Be) {
      return typeof Be == "object" && Be !== null && Be.$$typeof === t;
    }
    function _e(Be) {
      return I(Be) === s;
    }
    function Le(Be) {
      return I(Be) === a;
    }
    function Te(Be) {
      return I(Be) === m;
    }
    function K(Be) {
      return I(Be) === p;
    }
    function Oe(Be) {
      return I(Be) === r;
    }
    function Pe(Be) {
      return I(Be) === h;
    }
    function xe(Be) {
      return I(Be) === u;
    }
    function be(Be) {
      return I(Be) === c;
    }
    function $e(Be) {
      return I(Be) === d;
    }
    Si.ContextConsumer = k, Si.ContextProvider = H, Si.Element = S, Si.ForwardRef = B, Si.Fragment = D, Si.Lazy = F, Si.Memo = j, Si.Portal = G, Si.Profiler = U, Si.StrictMode = M, Si.Suspense = V, Si.SuspenseList = J, Si.isAsyncMode = ee, Si.isConcurrentMode = de, Si.isContextConsumer = he, Si.isContextProvider = pe, Si.isElement = Ce, Si.isForwardRef = _e, Si.isFragment = Le, Si.isLazy = Te, Si.isMemo = K, Si.isPortal = Oe, Si.isProfiler = Pe, Si.isStrictMode = xe, Si.isSuspense = be, Si.isSuspenseList = $e, Si.isValidElementType = _, Si.typeOf = I;
  }()), Si;
}
process.env.NODE_ENV === "production" ? D2.exports = xfe() : D2.exports = Dfe();
var CR = D2.exports, Mfe = Symbol.for("react.element"), Lfe = Symbol.for("react.transitional.element"), kfe = Symbol.for("react.fragment");
function jfe(t) {
  return (
    // Base object type
    t && as(t) === "object" && // React Element type
    (t.$$typeof === Mfe || t.$$typeof === Lfe) && // React Fragment type
    t.type === kfe
  );
}
var pF = function(r, a) {
  typeof r == "function" ? r(a) : as(r) === "object" && r && "current" in r && (r.current = a);
}, gF = function() {
  for (var r = arguments.length, a = new Array(r), u = 0; u < r; u++)
    a[u] = arguments[u];
  var h = a.filter(Boolean);
  return h.length <= 1 ? h[0] : function(b) {
    a.forEach(function(l) {
      pF(l, b);
    });
  };
}, mF = function(r) {
  var a, u;
  if (!r)
    return !1;
  if (EF(r) && r.props.propertyIsEnumerable("ref"))
    return !0;
  var h = CR.isMemo(r) ? r.type.type : r.type;
  return !(typeof h == "function" && !((a = h.prototype) !== null && a !== void 0 && a.render) && h.$$typeof !== CR.ForwardRef || typeof r == "function" && !((u = r.prototype) !== null && u !== void 0 && u.render) && r.$$typeof !== CR.ForwardRef);
};
function EF(t) {
  return /* @__PURE__ */ Hce(t) && !jfe(t);
}
var Ufe = function(r) {
  if (r && EF(r)) {
    var a = r;
    return a.props.propertyIsEnumerable("ref") ? a.props.ref : a.ref;
  }
  return null;
};
function Py(t, r, a, u) {
  var h = jl.unstable_batchedUpdates ? function(l) {
    jl.unstable_batchedUpdates(a, l);
  } : a;
  return t != null && t.addEventListener && t.addEventListener(r, h, u), {
    remove: function() {
      t != null && t.removeEventListener && t.removeEventListener(r, h, u);
    }
  };
}
function Av() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Hfe = /* @__PURE__ */ Gu(function(t, r) {
  var a = t.didUpdate, u = t.getContainer, h = t.children, b = er(), l = er();
  lv(r, function() {
    return {};
  });
  var v = er(!1);
  return !v.current && Av() && (l.current = u(), b.current = l.current.parentNode, v.current = !0), Pn(function() {
    a == null || a(t);
  }), Pn(function() {
    return l.current.parentNode === null && b.current !== null && b.current.appendChild(l.current), function() {
      var s;
      (s = l.current) === null || s === void 0 || (s = s.parentNode) === null || s === void 0 || s.removeChild(l.current);
    };
  }, []), l.current ? /* @__PURE__ */ jl.createPortal(h, l.current) : null;
});
function Bfe(t, r, a) {
  return a ? t[0] === r[0] : t[0] === r[0] && t[1] === r[1];
}
function zfe(t, r, a) {
  var u = t[r] || {};
  return jr(jr({}, u), a);
}
function Ffe(t, r, a, u) {
  for (var h = a.points, b = Object.keys(t), l = 0; l < b.length; l += 1) {
    var v = b[l];
    if (Bfe(t[v].points, h, u))
      return "".concat(r, "-placement-").concat(v);
  }
  return "";
}
function yF(t) {
  if (Array.isArray(t)) return t;
}
function Gfe(t, r) {
  var a = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (a != null) {
    var u, h, b, l, v = [], s = !0, c = !1;
    try {
      if (b = (a = a.call(t)).next, r === 0) {
        if (Object(a) !== a) return;
        s = !1;
      } else for (; !(s = (u = b.call(a)).done) && (v.push(u.value), v.length !== r); s = !0) ;
    } catch (d) {
      c = !0, h = d;
    } finally {
      try {
        if (!s && a.return != null && (l = a.return(), Object(l) !== l)) return;
      } finally {
        if (c) throw h;
      }
    }
    return v;
  }
}
function lj(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var a = 0, u = Array(r); a < r; a++) u[a] = t[a];
  return u;
}
function vF(t, r) {
  if (t) {
    if (typeof t == "string") return lj(t, r);
    var a = {}.toString.call(t).slice(8, -1);
    return a === "Object" && t.constructor && (a = t.constructor.name), a === "Map" || a === "Set" ? Array.from(t) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? lj(t, r) : void 0;
  }
}
function TF() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ps(t, r) {
  return yF(t) || Gfe(t, r) || vF(t, r) || TF();
}
const Vfe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ps
}, Symbol.toStringTag, { value: "Module" })), Yfe = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var t = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t == null ? void 0 : t.substr(0, 4));
};
var Xfe = /* @__PURE__ */ ht.createContext({}), Wfe = /* @__PURE__ */ function(t) {
  gh(a, t);
  var r = cw(a);
  function a() {
    return yo(this, a), r.apply(this, arguments);
  }
  return vo(a, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), a;
}(ht.Component);
function M2(t) {
  var r = ht.useRef();
  r.current = t;
  var a = ht.useCallback(function() {
    for (var u, h = arguments.length, b = new Array(h), l = 0; l < h; l++)
      b[l] = arguments[l];
    return (u = r.current) === null || u === void 0 ? void 0 : u.call.apply(u, [r].concat(b));
  }, []);
  return a;
}
var fj = process.env.NODE_ENV !== "test" && Av() ? ht.useLayoutEffect : ht.useEffect, L2 = function(r, a) {
  var u = ht.useRef(!0);
  fj(function() {
    return r(u.current);
  }, a), fj(function() {
    return u.current = !1, function() {
      u.current = !0;
    };
  }, []);
};
function pb(t) {
  var r = ht.useRef(!1), a = ht.useState(t), u = ps(a, 2), h = u[0], b = u[1];
  ht.useEffect(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
  function l(v, s) {
    s && r.current || b(v);
  }
  return [h, l];
}
function qfe(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Kfe(t) {
  return yF(t) || qfe(t) || vF(t) || TF();
}
var k2 = {}, uw = [], Jfe = function(r) {
  uw.push(r);
};
function Zfe(t, r) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var a = uw.reduce(function(u, h) {
      return h(u ?? "", "warning");
    }, r);
    a && console.error("Warning: ".concat(a));
  }
}
function Qfe(t, r) {
  if (process.env.NODE_ENV !== "production" && !t && console !== void 0) {
    var a = uw.reduce(function(u, h) {
      return h(u ?? "", "note");
    }, r);
    a && console.warn("Note: ".concat(a));
  }
}
function $fe() {
  k2 = {};
}
function bF(t, r, a) {
  !r && !k2[a] && (t(!1, a), k2[a] = !0);
}
function $b(t, r) {
  bF(Zfe, t, r);
}
function ehe(t, r) {
  bF(Qfe, t, r);
}
$b.preMessage = Jfe;
$b.resetWarned = $fe;
$b.noteOnce = ehe;
function the(t) {
  var r = ht.useReducer(function(v) {
    return v + 1;
  }, 0), a = ps(r, 2), u = a[1], h = ht.useRef(t), b = M2(function() {
    return h.current;
  }), l = M2(function(v) {
    h.current = typeof v == "function" ? v(h.current) : v, u();
  });
  return [b, l];
}
var Cl = "none", S0 = "appear", I0 = "enter", R0 = "leave", hj = "none", Wc = "prepare", qp = "start", Kp = "active", dw = "end", AF = "prepared";
function pj(t, r) {
  var a = {};
  return a[t.toLowerCase()] = r.toLowerCase(), a["Webkit".concat(t)] = "webkit".concat(r), a["Moz".concat(t)] = "moz".concat(r), a["ms".concat(t)] = "MS".concat(r), a["O".concat(t)] = "o".concat(r.toLowerCase()), a;
}
function nhe(t, r) {
  var a = {
    animationend: pj("Animation", "AnimationEnd"),
    transitionend: pj("Transition", "TransitionEnd")
  };
  return t && ("AnimationEvent" in r || delete a.animationend.animation, "TransitionEvent" in r || delete a.transitionend.transition), a;
}
var rhe = nhe(Av(), typeof window < "u" ? window : {}), OF = {};
if (Av()) {
  var ihe = document.createElement("div");
  OF = ihe.style;
}
var N0 = {};
function CF(t) {
  if (N0[t])
    return N0[t];
  var r = rhe[t];
  if (r)
    for (var a = Object.keys(r), u = a.length, h = 0; h < u; h += 1) {
      var b = a[h];
      if (Object.prototype.hasOwnProperty.call(r, b) && b in OF)
        return N0[t] = r[b], N0[t];
    }
  return "";
}
var SF = CF("animationend"), IF = CF("transitionend"), RF = !!(SF && IF), gj = SF || "animationend", mj = IF || "transitionend";
function Ej(t, r) {
  if (!t) return null;
  if (as(t) === "object") {
    var a = r.replace(/-\w/g, function(u) {
      return u[1].toUpperCase();
    });
    return t[a];
  }
  return "".concat(t, "-").concat(r);
}
const she = function(t) {
  var r = er();
  function a(h) {
    h && (h.removeEventListener(mj, t), h.removeEventListener(gj, t));
  }
  function u(h) {
    r.current && r.current !== h && a(r.current), h && h !== r.current && (h.addEventListener(mj, t), h.addEventListener(gj, t), r.current = h);
  }
  return ht.useEffect(function() {
    return function() {
      a(r.current);
    };
  }, []), [u, a];
};
var NF = Av() ? Bce : Pn;
const ahe = function() {
  var t = ht.useRef(null);
  function r() {
    Hu.cancel(t.current);
  }
  function a(u) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    r();
    var b = Hu(function() {
      h <= 1 ? u({
        isCanceled: function() {
          return b !== t.current;
        }
      }) : a(u, h - 1);
    });
    t.current = b;
  }
  return ht.useEffect(function() {
    return function() {
      r();
    };
  }, []), [a, r];
};
var ohe = [Wc, qp, Kp, dw], che = [Wc, AF], wF = !1, uhe = !0;
function _F(t) {
  return t === Kp || t === dw;
}
const dhe = function(t, r, a) {
  var u = pb(hj), h = ps(u, 2), b = h[0], l = h[1], v = ahe(), s = ps(v, 2), c = s[0], d = s[1];
  function p() {
    l(Wc, !0);
  }
  var m = r ? che : ohe;
  return NF(function() {
    if (b !== hj && b !== dw) {
      var E = m.indexOf(b), y = m[E + 1], g = a(b);
      g === wF ? l(y, !0) : y && c(function(C) {
        function O() {
          C.isCanceled() || l(y, !0);
        }
        g === !0 ? O() : Promise.resolve(g).then(O);
      });
    }
  }, [t, b]), ht.useEffect(function() {
    return function() {
      d();
    };
  }, []), [p, b];
};
function lhe(t, r, a, u) {
  var h = u.motionEnter, b = h === void 0 ? !0 : h, l = u.motionAppear, v = l === void 0 ? !0 : l, s = u.motionLeave, c = s === void 0 ? !0 : s, d = u.motionDeadline, p = u.motionLeaveImmediately, m = u.onAppearPrepare, E = u.onEnterPrepare, y = u.onLeavePrepare, g = u.onAppearStart, C = u.onEnterStart, O = u.onLeaveStart, N = u.onAppearActive, w = u.onEnterActive, _ = u.onLeaveActive, I = u.onAppearEnd, k = u.onEnterEnd, H = u.onLeaveEnd, S = u.onVisibleChanged, B = pb(), D = ps(B, 2), F = D[0], j = D[1], G = the(Cl), U = ps(G, 2), M = U[0], V = U[1], J = pb(null), ue = ps(J, 2), se = ue[0], ee = ue[1], de = M(), he = er(!1), pe = er(null);
  function Ce() {
    return a();
  }
  var _e = er(!1);
  function Le() {
    V(Cl), ee(null, !0);
  }
  var Te = M2(function(gt) {
    var it = M();
    if (it !== Cl) {
      var Tt = Ce();
      if (!(gt && !gt.deadline && gt.target !== Tt)) {
        var Ut = _e.current, st;
        it === S0 && Ut ? st = I == null ? void 0 : I(Tt, gt) : it === I0 && Ut ? st = k == null ? void 0 : k(Tt, gt) : it === R0 && Ut && (st = H == null ? void 0 : H(Tt, gt)), Ut && st !== !1 && Le();
      }
    }
  }), K = she(Te), Oe = ps(K, 1), Pe = Oe[0], xe = function(it) {
    switch (it) {
      case S0:
        return Jn(Jn(Jn({}, Wc, m), qp, g), Kp, N);
      case I0:
        return Jn(Jn(Jn({}, Wc, E), qp, C), Kp, w);
      case R0:
        return Jn(Jn(Jn({}, Wc, y), qp, O), Kp, _);
      default:
        return {};
    }
  }, be = ht.useMemo(function() {
    return xe(de);
  }, [de]), $e = dhe(de, !t, function(gt) {
    if (gt === Wc) {
      var it = be[Wc];
      return it ? it(Ce()) : wF;
    }
    if (Ze in be) {
      var Tt;
      ee(((Tt = be[Ze]) === null || Tt === void 0 ? void 0 : Tt.call(be, Ce(), null)) || null);
    }
    return Ze === Kp && de !== Cl && (Pe(Ce()), d > 0 && (clearTimeout(pe.current), pe.current = setTimeout(function() {
      Te({
        deadline: !0
      });
    }, d))), Ze === AF && Le(), uhe;
  }), Be = ps($e, 2), Ke = Be[0], Ze = Be[1], at = _F(Ze);
  _e.current = at;
  var pt = er(null);
  NF(function() {
    if (!(he.current && pt.current === r)) {
      j(r);
      var gt = he.current;
      he.current = !0;
      var it;
      !gt && r && v && (it = S0), gt && r && b && (it = I0), (gt && !r && c || !gt && p && !r && c) && (it = R0);
      var Tt = xe(it);
      it && (t || Tt[Wc]) ? (V(it), Ke()) : V(Cl), pt.current = r;
    }
  }, [r]), Pn(function() {
    // Cancel appear
    (de === S0 && !v || // Cancel enter
    de === I0 && !b || // Cancel leave
    de === R0 && !c) && V(Cl);
  }, [v, b, c]), Pn(function() {
    return function() {
      he.current = !1, clearTimeout(pe.current);
    };
  }, []);
  var It = ht.useRef(!1);
  Pn(function() {
    F && (It.current = !0), F !== void 0 && de === Cl && ((It.current || F) && (S == null || S(F)), It.current = !0);
  }, [F, de]);
  var Rt = se;
  return be[Wc] && Ze === qp && (Rt = jr({
    transition: "none"
  }, Rt)), [de, Ze, Rt, F ?? r];
}
function fhe(t) {
  var r = t;
  as(t) === "object" && (r = t.transitionSupport);
  function a(h, b) {
    return !!(h.motionName && r && b !== !1);
  }
  var u = /* @__PURE__ */ ht.forwardRef(function(h, b) {
    var l = h.visible, v = l === void 0 ? !0 : l, s = h.removeOnLeave, c = s === void 0 ? !0 : s, d = h.forceRender, p = h.children, m = h.motionName, E = h.leavedClassName, y = h.eventProps, g = ht.useContext(Xfe), C = g.motion, O = a(h, C), N = er(), w = er();
    function _() {
      try {
        return N.current instanceof HTMLElement ? N.current : hF(w.current);
      } catch {
        return null;
      }
    }
    var I = lhe(O, v, _, h), k = ps(I, 4), H = k[0], S = k[1], B = k[2], D = k[3], F = ht.useRef(D);
    D && (F.current = !0);
    var j = ht.useCallback(function(ue) {
      N.current = ue, pF(b, ue);
    }, [b]), G, U = jr(jr({}, y), {}, {
      visible: v
    });
    if (!p)
      G = null;
    else if (H === Cl)
      D ? G = p(jr({}, U), j) : !c && F.current && E ? G = p(jr(jr({}, U), {}, {
        className: E
      }), j) : d || !c && !E ? G = p(jr(jr({}, U), {}, {
        style: {
          display: "none"
        }
      }), j) : G = null;
    else {
      var M;
      S === Wc ? M = "prepare" : _F(S) ? M = "active" : S === qp && (M = "start");
      var V = Ej(m, "".concat(H, "-").concat(M));
      G = p(jr(jr({}, U), {}, {
        className: En(Ej(m, H), Jn(Jn({}, V, V && M), m, typeof m == "string")),
        style: B
      }), j);
    }
    if (/* @__PURE__ */ ht.isValidElement(G) && mF(G)) {
      var J = Ufe(G);
      J || (G = /* @__PURE__ */ ht.cloneElement(G, {
        ref: j
      }));
    }
    return /* @__PURE__ */ ht.createElement(Wfe, {
      ref: w
    }, G);
  });
  return u.displayName = "CSSMotion", u;
}
const mh = fhe(RF);
var j2 = "add", U2 = "keep", H2 = "remove", SR = "removed";
function hhe(t) {
  var r;
  return t && as(t) === "object" && "key" in t ? r = t : r = {
    key: t
  }, jr(jr({}, r), {}, {
    key: String(r.key)
  });
}
function B2() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return t.map(hhe);
}
function phe() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = [], u = 0, h = r.length, b = B2(t), l = B2(r);
  b.forEach(function(c) {
    for (var d = !1, p = u; p < h; p += 1) {
      var m = l[p];
      if (m.key === c.key) {
        u < p && (a = a.concat(l.slice(u, p).map(function(E) {
          return jr(jr({}, E), {}, {
            status: j2
          });
        })), u = p), a.push(jr(jr({}, m), {}, {
          status: U2
        })), u += 1, d = !0;
        break;
      }
    }
    d || a.push(jr(jr({}, c), {}, {
      status: H2
    }));
  }), u < h && (a = a.concat(l.slice(u).map(function(c) {
    return jr(jr({}, c), {}, {
      status: j2
    });
  })));
  var v = {};
  a.forEach(function(c) {
    var d = c.key;
    v[d] = (v[d] || 0) + 1;
  });
  var s = Object.keys(v).filter(function(c) {
    return v[c] > 1;
  });
  return s.forEach(function(c) {
    a = a.filter(function(d) {
      var p = d.key, m = d.status;
      return p !== c || m !== H2;
    }), a.forEach(function(d) {
      d.key === c && (d.status = U2);
    });
  }), a;
}
var ghe = ["component", "children", "onVisibleChanged", "onAllRemoved"], mhe = ["status"], Ehe = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function yhe(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : mh, a = /* @__PURE__ */ function(u) {
    gh(b, u);
    var h = cw(b);
    function b() {
      var l;
      yo(this, b);
      for (var v = arguments.length, s = new Array(v), c = 0; c < v; c++)
        s[c] = arguments[c];
      return l = h.call.apply(h, [this].concat(s)), Jn(Er(l), "state", {
        keyEntities: []
      }), Jn(Er(l), "removeKey", function(d) {
        l.setState(function(p) {
          var m = p.keyEntities.map(function(E) {
            return E.key !== d ? E : jr(jr({}, E), {}, {
              status: SR
            });
          });
          return {
            keyEntities: m
          };
        }, function() {
          var p = l.state.keyEntities, m = p.filter(function(E) {
            var y = E.status;
            return y !== SR;
          }).length;
          m === 0 && l.props.onAllRemoved && l.props.onAllRemoved();
        });
      }), l;
    }
    return vo(b, [{
      key: "render",
      value: function() {
        var v = this, s = this.state.keyEntities, c = this.props, d = c.component, p = c.children, m = c.onVisibleChanged;
        c.onAllRemoved;
        var E = fb(c, ghe), y = d || ht.Fragment, g = {};
        return Ehe.forEach(function(C) {
          g[C] = E[C], delete E[C];
        }), delete E.keys, /* @__PURE__ */ ht.createElement(y, E, s.map(function(C, O) {
          var N = C.status, w = fb(C, mhe), _ = N === j2 || N === U2;
          return /* @__PURE__ */ ht.createElement(r, ru({}, g, {
            key: w.key,
            visible: _,
            eventProps: w,
            onVisibleChanged: function(k) {
              m == null || m(k, {
                key: w.key
              }), k || v.removeKey(w.key);
            }
          }), function(I, k) {
            return p(jr(jr({}, I), {}, {
              index: O
            }), k);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(v, s) {
        var c = v.keys, d = s.keyEntities, p = B2(c), m = phe(d, p);
        return {
          keyEntities: m.filter(function(E) {
            var y = d.find(function(g) {
              var C = g.key;
              return E.key === C;
            });
            return !(y && y.status === SR && E.status === H2);
          })
        };
      }
    }]), b;
  }(ht.Component);
  return Jn(a, "defaultProps", {
    component: "div"
  }), a;
}
yhe(RF);
function PF(t) {
  var r = t.prefixCls, a = t.motion, u = t.animation, h = t.transitionName;
  return a || (u ? {
    motionName: "".concat(r, "-").concat(u)
  } : h ? {
    motionName: h
  } : null);
}
function vhe(t) {
  var r = t.prefixCls, a = t.visible, u = t.zIndex, h = t.mask, b = t.maskMotion, l = t.maskAnimation, v = t.maskTransitionName;
  if (!h)
    return null;
  var s = {};
  return (b || v || l) && (s = jr({
    motionAppear: !0
  }, PF({
    motion: b,
    prefixCls: r,
    transitionName: v,
    animation: l
  }))), /* @__PURE__ */ ht.createElement(mh, ru({}, s, {
    visible: a,
    removeOnLeave: !0
  }), function(c) {
    var d = c.className;
    return /* @__PURE__ */ ht.createElement("div", {
      style: {
        zIndex: u
      },
      className: En("".concat(r, "-mask"), d)
    });
  });
}
function yj(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function vj(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? yj(Object(a), !0).forEach(function(u) {
      The(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : yj(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function z2(t) {
  "@babel/helpers - typeof";
  return z2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, z2(t);
}
function The(t, r, a) {
  return r in t ? Object.defineProperty(t, r, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[r] = a, t;
}
var by, bhe = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function gb() {
  if (by !== void 0)
    return by;
  by = "";
  var t = document.createElement("p").style, r = "Transform";
  for (var a in bhe)
    a + r in t && (by = a);
  return by;
}
function xF() {
  return gb() ? "".concat(gb(), "TransitionProperty") : "transitionProperty";
}
function eA() {
  return gb() ? "".concat(gb(), "Transform") : "transform";
}
function Tj(t, r) {
  var a = xF();
  a && (t.style[a] = r, a !== "transitionProperty" && (t.style.transitionProperty = r));
}
function IR(t, r) {
  var a = eA();
  a && (t.style[a] = r, a !== "transform" && (t.style.transform = r));
}
function Ahe(t) {
  return t.style.transitionProperty || t.style[xF()];
}
function Ohe(t) {
  var r = window.getComputedStyle(t, null), a = r.getPropertyValue("transform") || r.getPropertyValue(eA());
  if (a && a !== "none") {
    var u = a.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(u[12] || u[4], 0),
      y: parseFloat(u[13] || u[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var Che = /matrix\((.*)\)/, She = /matrix3d\((.*)\)/;
function Ihe(t, r) {
  var a = window.getComputedStyle(t, null), u = a.getPropertyValue("transform") || a.getPropertyValue(eA());
  if (u && u !== "none") {
    var h, b = u.match(Che);
    if (b)
      b = b[1], h = b.split(",").map(function(v) {
        return parseFloat(v, 10);
      }), h[4] = r.x, h[5] = r.y, IR(t, "matrix(".concat(h.join(","), ")"));
    else {
      var l = u.match(She)[1];
      h = l.split(",").map(function(v) {
        return parseFloat(v, 10);
      }), h[12] = r.x, h[13] = r.y, IR(t, "matrix3d(".concat(h.join(","), ")"));
    }
  } else
    IR(t, "translateX(".concat(r.x, "px) translateY(").concat(r.y, "px) translateZ(0)"));
}
var Rhe = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, Ov;
function bj(t) {
  var r = t.style.display;
  t.style.display = "none", t.offsetHeight, t.style.display = r;
}
function sg(t, r, a) {
  var u = a;
  if (z2(r) === "object") {
    for (var h in r)
      r.hasOwnProperty(h) && sg(t, h, r[h]);
    return;
  }
  if (typeof u < "u") {
    typeof u == "number" && (u = "".concat(u, "px")), t.style[r] = u;
    return;
  }
  return Ov(t, r);
}
function Nhe(t) {
  var r, a, u, h = t.ownerDocument, b = h.body, l = h && h.documentElement;
  return r = t.getBoundingClientRect(), a = Math.floor(r.left), u = Math.floor(r.top), a -= l.clientLeft || b.clientLeft || 0, u -= l.clientTop || b.clientTop || 0, {
    left: a,
    top: u
  };
}
function DF(t, r) {
  var a = t["page".concat(r ? "Y" : "X", "Offset")], u = "scroll".concat(r ? "Top" : "Left");
  if (typeof a != "number") {
    var h = t.document;
    a = h.documentElement[u], typeof a != "number" && (a = h.body[u]);
  }
  return a;
}
function MF(t) {
  return DF(t);
}
function LF(t) {
  return DF(t, !0);
}
function Qy(t) {
  var r = Nhe(t), a = t.ownerDocument, u = a.defaultView || a.parentWindow;
  return r.left += MF(u), r.top += LF(u), r;
}
function lw(t) {
  return t != null && t == t.window;
}
function kF(t) {
  return lw(t) ? t.document : t.nodeType === 9 ? t : t.ownerDocument;
}
function whe(t, r, a) {
  var u = a, h = "", b = kF(t);
  return u = u || b.defaultView.getComputedStyle(t, null), u && (h = u.getPropertyValue(r) || u[r]), h;
}
var _he = new RegExp("^(".concat(Rhe, ")(?!px)[a-z%]+$"), "i"), Phe = /^(top|right|bottom|left)$/, RR = "currentStyle", NR = "runtimeStyle", Xf = "left", xhe = "px";
function Dhe(t, r) {
  var a = t[RR] && t[RR][r];
  if (_he.test(a) && !Phe.test(r)) {
    var u = t.style, h = u[Xf], b = t[NR][Xf];
    t[NR][Xf] = t[RR][Xf], u[Xf] = r === "fontSize" ? "1em" : a || 0, a = u.pixelLeft + xhe, u[Xf] = h, t[NR][Xf] = b;
  }
  return a === "" ? "auto" : a;
}
typeof window < "u" && (Ov = window.getComputedStyle ? whe : Dhe);
function w0(t, r) {
  return t === "left" ? r.useCssRight ? "right" : t : r.useCssBottom ? "bottom" : t;
}
function Aj(t) {
  if (t === "left")
    return "right";
  if (t === "right")
    return "left";
  if (t === "top")
    return "bottom";
  if (t === "bottom")
    return "top";
}
function Oj(t, r, a) {
  sg(t, "position") === "static" && (t.style.position = "relative");
  var u = -999, h = -999, b = w0("left", a), l = w0("top", a), v = Aj(b), s = Aj(l);
  b !== "left" && (u = 999), l !== "top" && (h = 999);
  var c = "", d = Qy(t);
  ("left" in r || "top" in r) && (c = Ahe(t) || "", Tj(t, "none")), "left" in r && (t.style[v] = "", t.style[b] = "".concat(u, "px")), "top" in r && (t.style[s] = "", t.style[l] = "".concat(h, "px")), bj(t);
  var p = Qy(t), m = {};
  for (var E in r)
    if (r.hasOwnProperty(E)) {
      var y = w0(E, a), g = E === "left" ? u : h, C = d[E] - p[E];
      y === E ? m[y] = g + C : m[y] = g - C;
    }
  sg(t, m), bj(t), ("left" in r || "top" in r) && Tj(t, c);
  var O = {};
  for (var N in r)
    if (r.hasOwnProperty(N)) {
      var w = w0(N, a), _ = r[N] - d[N];
      N === w ? O[w] = m[w] + _ : O[w] = m[w] - _;
    }
  sg(t, O);
}
function Mhe(t, r) {
  var a = Qy(t), u = Ohe(t), h = {
    x: u.x,
    y: u.y
  };
  "left" in r && (h.x = u.x + r.left - a.left), "top" in r && (h.y = u.y + r.top - a.top), Ihe(t, h);
}
function Lhe(t, r, a) {
  if (a.ignoreShake) {
    var u = Qy(t), h = u.left.toFixed(0), b = u.top.toFixed(0), l = r.left.toFixed(0), v = r.top.toFixed(0);
    if (h === l && b === v)
      return;
  }
  a.useCssRight || a.useCssBottom ? Oj(t, r, a) : a.useCssTransform && eA() in document.body.style ? Mhe(t, r) : Oj(t, r, a);
}
function fw(t, r) {
  for (var a = 0; a < t.length; a++)
    r(t[a]);
}
function jF(t) {
  return Ov(t, "boxSizing") === "border-box";
}
var khe = ["margin", "border", "padding"], F2 = -1, jhe = 2, G2 = 1, Uhe = 0;
function Hhe(t, r, a) {
  var u = {}, h = t.style, b;
  for (b in r)
    r.hasOwnProperty(b) && (u[b] = h[b], h[b] = r[b]);
  a.call(t);
  for (b in r)
    r.hasOwnProperty(b) && (h[b] = u[b]);
}
function xy(t, r, a) {
  var u = 0, h, b, l;
  for (b = 0; b < r.length; b++)
    if (h = r[b], h)
      for (l = 0; l < a.length; l++) {
        var v = void 0;
        h === "border" ? v = "".concat(h).concat(a[l], "Width") : v = h + a[l], u += parseFloat(Ov(t, v)) || 0;
      }
  return u;
}
var Lu = {
  getParent: function(r) {
    var a = r;
    do
      a.nodeType === 11 && a.host ? a = a.host : a = a.parentNode;
    while (a && a.nodeType !== 1 && a.nodeType !== 9);
    return a;
  }
};
fw(["Width", "Height"], function(t) {
  Lu["doc".concat(t)] = function(r) {
    var a = r.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      a.documentElement["scroll".concat(t)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      a.body["scroll".concat(t)],
      Lu["viewport".concat(t)](a)
    );
  }, Lu["viewport".concat(t)] = function(r) {
    var a = "client".concat(t), u = r.document, h = u.body, b = u.documentElement, l = b[a];
    return u.compatMode === "CSS1Compat" && l || h && h[a] || l;
  };
});
function Cj(t, r, a) {
  var u = a;
  if (lw(t))
    return r === "width" ? Lu.viewportWidth(t) : Lu.viewportHeight(t);
  if (t.nodeType === 9)
    return r === "width" ? Lu.docWidth(t) : Lu.docHeight(t);
  var h = r === "width" ? ["Left", "Right"] : ["Top", "Bottom"], b = Math.floor(r === "width" ? t.getBoundingClientRect().width : t.getBoundingClientRect().height), l = jF(t), v = 0;
  (b == null || b <= 0) && (b = void 0, v = Ov(t, r), (v == null || Number(v) < 0) && (v = t.style[r] || 0), v = Math.floor(parseFloat(v)) || 0), u === void 0 && (u = l ? G2 : F2);
  var s = b !== void 0 || l, c = b || v;
  return u === F2 ? s ? c - xy(t, ["border", "padding"], h) : v : s ? u === G2 ? c : c + (u === jhe ? -xy(t, ["border"], h) : xy(t, ["margin"], h)) : v + xy(t, khe.slice(u), h);
}
var Bhe = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function Sj() {
  for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  var u, h = r[0];
  return h.offsetWidth !== 0 ? u = Cj.apply(void 0, r) : Hhe(h, Bhe, function() {
    u = Cj.apply(void 0, r);
  }), u;
}
fw(["width", "height"], function(t) {
  var r = t.charAt(0).toUpperCase() + t.slice(1);
  Lu["outer".concat(r)] = function(u, h) {
    return u && Sj(u, t, h ? Uhe : G2);
  };
  var a = t === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  Lu[t] = function(u, h) {
    var b = h;
    if (b !== void 0) {
      if (u) {
        var l = jF(u);
        return l && (b += xy(u, ["padding", "border"], a)), sg(u, t, b);
      }
      return;
    }
    return u && Sj(u, t, F2);
  };
});
function UF(t, r) {
  for (var a in r)
    r.hasOwnProperty(a) && (t[a] = r[a]);
  return t;
}
var Nr = {
  getWindow: function(r) {
    if (r && r.document && r.setTimeout)
      return r;
    var a = r.ownerDocument || r;
    return a.defaultView || a.parentWindow;
  },
  getDocument: kF,
  offset: function(r, a, u) {
    if (typeof a < "u")
      Lhe(r, a, u || {});
    else
      return Qy(r);
  },
  isWindow: lw,
  each: fw,
  css: sg,
  clone: function(r) {
    var a, u = {};
    for (a in r)
      r.hasOwnProperty(a) && (u[a] = r[a]);
    var h = r.overflow;
    if (h)
      for (a in r)
        r.hasOwnProperty(a) && (u.overflow[a] = r.overflow[a]);
    return u;
  },
  mix: UF,
  getWindowScrollLeft: function(r) {
    return MF(r);
  },
  getWindowScrollTop: function(r) {
    return LF(r);
  },
  merge: function() {
    for (var r = {}, a = 0; a < arguments.length; a++)
      Nr.mix(r, a < 0 || arguments.length <= a ? void 0 : arguments[a]);
    return r;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
UF(Nr, Lu);
var wR = Nr.getParent;
function V2(t) {
  if (Nr.isWindow(t) || t.nodeType === 9)
    return null;
  var r = Nr.getDocument(t), a = r.body, u, h = Nr.css(t, "position"), b = h === "fixed" || h === "absolute";
  if (!b)
    return t.nodeName.toLowerCase() === "html" ? null : wR(t);
  for (u = wR(t); u && u !== a && u.nodeType !== 9; u = wR(u))
    if (h = Nr.css(u, "position"), h !== "static")
      return u;
  return null;
}
var Ij = Nr.getParent;
function zhe(t) {
  if (Nr.isWindow(t) || t.nodeType === 9)
    return !1;
  var r = Nr.getDocument(t), a = r.body, u = null;
  for (
    u = Ij(t);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    u && u !== a && u !== r;
    u = Ij(u)
  ) {
    var h = Nr.css(u, "position");
    if (h === "fixed")
      return !0;
  }
  return !1;
}
function hw(t, r) {
  for (var a = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, u = V2(t), h = Nr.getDocument(t), b = h.defaultView || h.parentWindow, l = h.body, v = h.documentElement; u; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || u.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    u !== l && u !== v && Nr.css(u, "overflow") !== "visible") {
      var s = Nr.offset(u);
      s.left += u.clientLeft, s.top += u.clientTop, a.top = Math.max(a.top, s.top), a.right = Math.min(
        a.right,
        // consider area without scrollBar
        s.left + u.clientWidth
      ), a.bottom = Math.min(a.bottom, s.top + u.clientHeight), a.left = Math.max(a.left, s.left);
    } else if (u === l || u === v)
      break;
    u = V2(u);
  }
  var c = null;
  if (!Nr.isWindow(t) && t.nodeType !== 9) {
    c = t.style.position;
    var d = Nr.css(t, "position");
    d === "absolute" && (t.style.position = "fixed");
  }
  var p = Nr.getWindowScrollLeft(b), m = Nr.getWindowScrollTop(b), E = Nr.viewportWidth(b), y = Nr.viewportHeight(b), g = v.scrollWidth, C = v.scrollHeight, O = window.getComputedStyle(l);
  if (O.overflowX === "hidden" && (g = b.innerWidth), O.overflowY === "hidden" && (C = b.innerHeight), t.style && (t.style.position = c), r || zhe(t))
    a.left = Math.max(a.left, p), a.top = Math.max(a.top, m), a.right = Math.min(a.right, p + E), a.bottom = Math.min(a.bottom, m + y);
  else {
    var N = Math.max(g, p + E);
    a.right = Math.min(a.right, N);
    var w = Math.max(C, m + y);
    a.bottom = Math.min(a.bottom, w);
  }
  return a.top >= 0 && a.left >= 0 && a.bottom > a.top && a.right > a.left ? a : null;
}
function Fhe(t, r, a, u) {
  var h = Nr.clone(t), b = {
    width: r.width,
    height: r.height
  };
  return u.adjustX && h.left < a.left && (h.left = a.left), u.resizeWidth && h.left >= a.left && h.left + b.width > a.right && (b.width -= h.left + b.width - a.right), u.adjustX && h.left + b.width > a.right && (h.left = Math.max(a.right - b.width, a.left)), u.adjustY && h.top < a.top && (h.top = a.top), u.resizeHeight && h.top >= a.top && h.top + b.height > a.bottom && (b.height -= h.top + b.height - a.bottom), u.adjustY && h.top + b.height > a.bottom && (h.top = Math.max(a.bottom - b.height, a.top)), Nr.mix(h, b);
}
function pw(t) {
  var r, a, u;
  if (!Nr.isWindow(t) && t.nodeType !== 9)
    r = Nr.offset(t), a = Nr.outerWidth(t), u = Nr.outerHeight(t);
  else {
    var h = Nr.getWindow(t);
    r = {
      left: Nr.getWindowScrollLeft(h),
      top: Nr.getWindowScrollTop(h)
    }, a = Nr.viewportWidth(h), u = Nr.viewportHeight(h);
  }
  return r.width = a, r.height = u, r;
}
function Rj(t, r) {
  var a = r.charAt(0), u = r.charAt(1), h = t.width, b = t.height, l = t.left, v = t.top;
  return a === "c" ? v += b / 2 : a === "b" && (v += b), u === "c" ? l += h / 2 : u === "r" && (l += h), {
    left: l,
    top: v
  };
}
function _0(t, r, a, u, h) {
  var b = Rj(r, a[1]), l = Rj(t, a[0]), v = [l.left - b.left, l.top - b.top];
  return {
    left: Math.round(t.left - v[0] + u[0] - h[0]),
    top: Math.round(t.top - v[1] + u[1] - h[1])
  };
}
function Nj(t, r, a) {
  return t.left < a.left || t.left + r.width > a.right;
}
function wj(t, r, a) {
  return t.top < a.top || t.top + r.height > a.bottom;
}
function Ghe(t, r, a) {
  return t.left > a.right || t.left + r.width < a.left;
}
function Vhe(t, r, a) {
  return t.top > a.bottom || t.top + r.height < a.top;
}
function P0(t, r, a) {
  var u = [];
  return Nr.each(t, function(h) {
    u.push(h.replace(r, function(b) {
      return a[b];
    }));
  }), u;
}
function x0(t, r) {
  return t[r] = -t[r], t;
}
function _j(t, r) {
  var a;
  return /%$/.test(t) ? a = parseInt(t.substring(0, t.length - 1), 10) / 100 * r : a = parseInt(t, 10), a || 0;
}
function Pj(t, r) {
  t[0] = _j(t[0], r.width), t[1] = _j(t[1], r.height);
}
function HF(t, r, a, u) {
  var h = a.points, b = a.offset || [0, 0], l = a.targetOffset || [0, 0], v = a.overflow, s = a.source || t;
  b = [].concat(b), l = [].concat(l), v = v || {};
  var c = {}, d = 0, p = !!(v && v.alwaysByViewport), m = hw(s, p), E = pw(s);
  Pj(b, E), Pj(l, r);
  var y = _0(E, r, h, b, l), g = Nr.merge(E, y);
  if (m && (v.adjustX || v.adjustY) && u) {
    if (v.adjustX && Nj(y, E, m)) {
      var C = P0(h, /[lr]/gi, {
        l: "r",
        r: "l"
      }), O = x0(b, 0), N = x0(l, 0), w = _0(E, r, C, O, N);
      Ghe(w, E, m) || (d = 1, h = C, b = O, l = N);
    }
    if (v.adjustY && wj(y, E, m)) {
      var _ = P0(h, /[tb]/gi, {
        t: "b",
        b: "t"
      }), I = x0(b, 1), k = x0(l, 1), H = _0(E, r, _, I, k);
      Vhe(H, E, m) || (d = 1, h = _, b = I, l = k);
    }
    d && (y = _0(E, r, h, b, l), Nr.mix(g, y));
    var S = Nj(y, E, m), B = wj(y, E, m);
    if (S || B) {
      var D = h;
      S && (D = P0(h, /[lr]/gi, {
        l: "r",
        r: "l"
      })), B && (D = P0(h, /[tb]/gi, {
        t: "b",
        b: "t"
      })), h = D, b = a.offset || [0, 0], l = a.targetOffset || [0, 0];
    }
    c.adjustX = v.adjustX && S, c.adjustY = v.adjustY && B, (c.adjustX || c.adjustY) && (g = Fhe(y, E, m, c));
  }
  return g.width !== E.width && Nr.css(s, "width", Nr.width(s) + g.width - E.width), g.height !== E.height && Nr.css(s, "height", Nr.height(s) + g.height - E.height), Nr.offset(s, {
    left: g.left,
    top: g.top
  }, {
    useCssRight: a.useCssRight,
    useCssBottom: a.useCssBottom,
    useCssTransform: a.useCssTransform,
    ignoreShake: a.ignoreShake
  }), {
    points: h,
    offset: b,
    targetOffset: l,
    overflow: c
  };
}
function Yhe(t, r) {
  var a = hw(t, r), u = pw(t);
  return !a || u.left + u.width <= a.left || u.top + u.height <= a.top || u.left >= a.right || u.top >= a.bottom;
}
function gw(t, r, a) {
  var u = a.target || r, h = pw(u), b = !Yhe(u, a.overflow && a.overflow.alwaysByViewport);
  return HF(t, h, a, b);
}
gw.__getOffsetParent = V2;
gw.__getVisibleRectForElement = hw;
function Xhe(t, r, a) {
  var u, h, b = Nr.getDocument(t), l = b.defaultView || b.parentWindow, v = Nr.getWindowScrollLeft(l), s = Nr.getWindowScrollTop(l), c = Nr.viewportWidth(l), d = Nr.viewportHeight(l);
  "pageX" in r ? u = r.pageX : u = v + r.clientX, "pageY" in r ? h = r.pageY : h = s + r.clientY;
  var p = {
    left: u,
    top: h,
    width: 0,
    height: 0
  }, m = u >= 0 && u <= v + c && h >= 0 && h <= s + d, E = [a.points[0], "cc"];
  return HF(t, p, vj(vj({}, a), {}, {
    points: E
  }), m);
}
function Whe(t, r) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, u = /* @__PURE__ */ new Set();
  function h(b, l) {
    var v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, s = u.has(b);
    if ($b(!s, "Warning: There may be circular references"), s)
      return !1;
    if (b === l)
      return !0;
    if (a && v > 1)
      return !1;
    u.add(b);
    var c = v + 1;
    if (Array.isArray(b)) {
      if (!Array.isArray(l) || b.length !== l.length)
        return !1;
      for (var d = 0; d < b.length; d++)
        if (!h(b[d], l[d], c))
          return !1;
      return !0;
    }
    if (b && l && as(b) === "object" && as(l) === "object") {
      var p = Object.keys(b);
      return p.length !== Object.keys(l).length ? !1 : p.every(function(m) {
        return h(b[m], l[m], c);
      });
    }
    return !1;
  }
  return h(t, r);
}
const qhe = function(t) {
  if (!t)
    return !1;
  if (t instanceof Element) {
    if (t.offsetParent)
      return !0;
    if (t.getBBox) {
      var r = t.getBBox(), a = r.width, u = r.height;
      if (a || u)
        return !0;
    }
    if (t.getBoundingClientRect) {
      var h = t.getBoundingClientRect(), b = h.width, l = h.height;
      if (b || l)
        return !0;
    }
  }
  return !1;
}, Khe = function(t, r) {
  var a = _t.useRef(!1), u = _t.useRef(null);
  function h() {
    window.clearTimeout(u.current);
  }
  function b(l) {
    if (h(), !a.current || l === !0) {
      if (t(l) === !1)
        return;
      a.current = !0, u.current = window.setTimeout(function() {
        a.current = !1;
      }, r);
    } else
      u.current = window.setTimeout(function() {
        a.current = !1, b();
      }, r);
  }
  return [b, function() {
    a.current = !1, h();
  }];
};
var BF = function() {
  if (typeof Map < "u")
    return Map;
  function t(r, a) {
    var u = -1;
    return r.some(function(h, b) {
      return h[0] === a ? (u = b, !0) : !1;
    }), u;
  }
  return (
    /** @class */
    function() {
      function r() {
        this.__entries__ = [];
      }
      return Object.defineProperty(r.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), r.prototype.get = function(a) {
        var u = t(this.__entries__, a), h = this.__entries__[u];
        return h && h[1];
      }, r.prototype.set = function(a, u) {
        var h = t(this.__entries__, a);
        ~h ? this.__entries__[h][1] = u : this.__entries__.push([a, u]);
      }, r.prototype.delete = function(a) {
        var u = this.__entries__, h = t(u, a);
        ~h && u.splice(h, 1);
      }, r.prototype.has = function(a) {
        return !!~t(this.__entries__, a);
      }, r.prototype.clear = function() {
        this.__entries__.splice(0);
      }, r.prototype.forEach = function(a, u) {
        u === void 0 && (u = null);
        for (var h = 0, b = this.__entries__; h < b.length; h++) {
          var l = b[h];
          a.call(u, l[1], l[0]);
        }
      }, r;
    }()
  );
}(), Y2 = typeof window < "u" && typeof document < "u" && window.document === document, mb = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Jhe = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(mb) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), Zhe = 2;
function Qhe(t, r) {
  var a = !1, u = !1, h = 0;
  function b() {
    a && (a = !1, t()), u && v();
  }
  function l() {
    Jhe(b);
  }
  function v() {
    var s = Date.now();
    if (a) {
      if (s - h < Zhe)
        return;
      u = !0;
    } else
      a = !0, u = !1, setTimeout(l, r);
    h = s;
  }
  return v;
}
var $he = 20, epe = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], tpe = typeof MutationObserver < "u", npe = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Qhe(this.refresh.bind(this), $he);
    }
    return t.prototype.addObserver = function(r) {
      ~this.observers_.indexOf(r) || this.observers_.push(r), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(r) {
      var a = this.observers_, u = a.indexOf(r);
      ~u && a.splice(u, 1), !a.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var r = this.updateObservers_();
      r && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var r = this.observers_.filter(function(a) {
        return a.gatherActive(), a.hasActive();
      });
      return r.forEach(function(a) {
        return a.broadcastActive();
      }), r.length > 0;
    }, t.prototype.connect_ = function() {
      !Y2 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), tpe ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !Y2 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(r) {
      var a = r.propertyName, u = a === void 0 ? "" : a, h = epe.some(function(b) {
        return !!~u.indexOf(b);
      });
      h && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), zF = function(t, r) {
  for (var a = 0, u = Object.keys(r); a < u.length; a++) {
    var h = u[a];
    Object.defineProperty(t, h, {
      value: r[h],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, mm = function(t) {
  var r = t && t.ownerDocument && t.ownerDocument.defaultView;
  return r || mb;
}, FF = tA(0, 0, 0, 0);
function Eb(t) {
  return parseFloat(t) || 0;
}
function xj(t) {
  for (var r = [], a = 1; a < arguments.length; a++)
    r[a - 1] = arguments[a];
  return r.reduce(function(u, h) {
    var b = t["border-" + h + "-width"];
    return u + Eb(b);
  }, 0);
}
function rpe(t) {
  for (var r = ["top", "right", "bottom", "left"], a = {}, u = 0, h = r; u < h.length; u++) {
    var b = h[u], l = t["padding-" + b];
    a[b] = Eb(l);
  }
  return a;
}
function ipe(t) {
  var r = t.getBBox();
  return tA(0, 0, r.width, r.height);
}
function spe(t) {
  var r = t.clientWidth, a = t.clientHeight;
  if (!r && !a)
    return FF;
  var u = mm(t).getComputedStyle(t), h = rpe(u), b = h.left + h.right, l = h.top + h.bottom, v = Eb(u.width), s = Eb(u.height);
  if (u.boxSizing === "border-box" && (Math.round(v + b) !== r && (v -= xj(u, "left", "right") + b), Math.round(s + l) !== a && (s -= xj(u, "top", "bottom") + l)), !ope(t)) {
    var c = Math.round(v + b) - r, d = Math.round(s + l) - a;
    Math.abs(c) !== 1 && (v -= c), Math.abs(d) !== 1 && (s -= d);
  }
  return tA(h.left, h.top, v, s);
}
var ape = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof mm(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof mm(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function ope(t) {
  return t === mm(t).document.documentElement;
}
function cpe(t) {
  return Y2 ? ape(t) ? ipe(t) : spe(t) : FF;
}
function upe(t) {
  var r = t.x, a = t.y, u = t.width, h = t.height, b = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, l = Object.create(b.prototype);
  return zF(l, {
    x: r,
    y: a,
    width: u,
    height: h,
    top: a,
    right: r + u,
    bottom: h + a,
    left: r
  }), l;
}
function tA(t, r, a, u) {
  return { x: t, y: r, width: a, height: u };
}
var dpe = (
  /** @class */
  function() {
    function t(r) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = tA(0, 0, 0, 0), this.target = r;
    }
    return t.prototype.isActive = function() {
      var r = cpe(this.target);
      return this.contentRect_ = r, r.width !== this.broadcastWidth || r.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var r = this.contentRect_;
      return this.broadcastWidth = r.width, this.broadcastHeight = r.height, r;
    }, t;
  }()
), lpe = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r, a) {
      var u = upe(a);
      zF(this, { target: r, contentRect: u });
    }
    return t;
  }()
), fpe = (
  /** @class */
  function() {
    function t(r, a, u) {
      if (this.activeObservations_ = [], this.observations_ = new BF(), typeof r != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = r, this.controller_ = a, this.callbackCtx_ = u;
    }
    return t.prototype.observe = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(r instanceof mm(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var a = this.observations_;
        a.has(r) || (a.set(r, new dpe(r)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(r) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(r instanceof mm(r).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var a = this.observations_;
        a.has(r) && (a.delete(r), a.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var r = this;
      this.clearActive(), this.observations_.forEach(function(a) {
        a.isActive() && r.activeObservations_.push(a);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var r = this.callbackCtx_, a = this.activeObservations_.map(function(u) {
          return new lpe(u.target, u.broadcastRect());
        });
        this.callback_.call(r, a, r), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), GF = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new BF(), VF = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var a = npe.getInstance(), u = new fpe(r, a, this);
      GF.set(this, u);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  VF.prototype[t] = function() {
    var r;
    return (r = GF.get(this))[t].apply(r, arguments);
  };
});
var hpe = function() {
  return typeof mb.ResizeObserver < "u" ? mb.ResizeObserver : VF;
}();
function ppe(t, r) {
  return t === r ? !0 : !t || !r ? !1 : "pageX" in r && "pageY" in r ? t.pageX === r.pageX && t.pageY === r.pageY : "clientX" in r && "clientY" in r ? t.clientX === r.clientX && t.clientY === r.clientY : !1;
}
function gpe(t, r) {
  t !== document.activeElement && K0(r, t) && typeof t.focus == "function" && t.focus();
}
function Dj(t, r) {
  var a = null, u = null;
  function h(l) {
    var v = ps(l, 1), s = v[0].target;
    if (document.documentElement.contains(s)) {
      var c = s.getBoundingClientRect(), d = c.width, p = c.height, m = Math.floor(d), E = Math.floor(p);
      (a !== m || u !== E) && Promise.resolve().then(function() {
        r({
          width: m,
          height: E
        });
      }), a = m, u = E;
    }
  }
  var b = new hpe(h);
  return t && b.observe(t), function() {
    b.disconnect();
  };
}
function Mj(t) {
  return typeof t != "function" ? null : t();
}
function Lj(t) {
  return as(t) !== "object" || !t ? null : t;
}
var mpe = function(r, a) {
  var u = r.children, h = r.disabled, b = r.target, l = r.align, v = r.onAlign, s = r.monitorWindowResize, c = r.monitorBufferTime, d = c === void 0 ? 0 : c, p = _t.useRef({}), m = _t.useRef(), E = _t.Children.only(u), y = _t.useRef({});
  y.current.disabled = h, y.current.target = b, y.current.align = l, y.current.onAlign = v;
  var g = Khe(function() {
    var F = y.current, j = F.disabled, G = F.target, U = F.align, M = F.onAlign, V = m.current;
    if (!j && G && V) {
      var J, ue = Mj(G), se = Lj(G);
      p.current.element = ue, p.current.point = se, p.current.align = U;
      var ee = document, de = ee.activeElement;
      return ue && qhe(ue) ? J = gw(V, ue, U) : se && (J = Xhe(V, se, U)), gpe(de, V), M && J && M(V, J), !0;
    }
    return !1;
  }, d), C = ps(g, 2), O = C[0], N = C[1], w = _t.useState(), _ = ps(w, 2), I = _[0], k = _[1], H = _t.useState(), S = ps(H, 2), B = S[0], D = S[1];
  return L2(function() {
    k(Mj(b)), D(Lj(b));
  }), _t.useEffect(function() {
    (p.current.element !== I || !ppe(p.current.point, B) || !Whe(p.current.align, l)) && O();
  }), _t.useEffect(function() {
    var F = Dj(m.current, O);
    return F;
  }, [m.current]), _t.useEffect(function() {
    var F = Dj(I, O);
    return F;
  }, [I]), _t.useEffect(function() {
    h ? N() : O();
  }, [h]), _t.useEffect(function() {
    if (s) {
      var F = Py(window, "resize", O);
      return F.remove;
    }
  }, [s]), _t.useEffect(function() {
    return function() {
      N();
    };
  }, []), _t.useImperativeHandle(a, function() {
    return {
      forceAlign: function() {
        return O(!0);
      }
    };
  }), /* @__PURE__ */ _t.isValidElement(E) && (E = /* @__PURE__ */ _t.cloneElement(E, {
    ref: gF(E.ref, m)
  })), E;
}, YF = /* @__PURE__ */ _t.forwardRef(mpe);
YF.displayName = "Align";
function X2() {
  X2 = function() {
    return r;
  };
  var t, r = {}, a = Object.prototype, u = a.hasOwnProperty, h = Object.defineProperty || function(V, J, ue) {
    V[J] = ue.value;
  }, b = typeof Symbol == "function" ? Symbol : {}, l = b.iterator || "@@iterator", v = b.asyncIterator || "@@asyncIterator", s = b.toStringTag || "@@toStringTag";
  function c(V, J, ue) {
    return Object.defineProperty(V, J, {
      value: ue,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), V[J];
  }
  try {
    c({}, "");
  } catch {
    c = function(ue, se, ee) {
      return ue[se] = ee;
    };
  }
  function d(V, J, ue, se) {
    var ee = J && J.prototype instanceof O ? J : O, de = Object.create(ee.prototype), he = new U(se || []);
    return h(de, "_invoke", {
      value: D(V, ue, he)
    }), de;
  }
  function p(V, J, ue) {
    try {
      return {
        type: "normal",
        arg: V.call(J, ue)
      };
    } catch (se) {
      return {
        type: "throw",
        arg: se
      };
    }
  }
  r.wrap = d;
  var m = "suspendedStart", E = "suspendedYield", y = "executing", g = "completed", C = {};
  function O() {
  }
  function N() {
  }
  function w() {
  }
  var _ = {};
  c(_, l, function() {
    return this;
  });
  var I = Object.getPrototypeOf, k = I && I(I(M([])));
  k && k !== a && u.call(k, l) && (_ = k);
  var H = w.prototype = O.prototype = Object.create(_);
  function S(V) {
    ["next", "throw", "return"].forEach(function(J) {
      c(V, J, function(ue) {
        return this._invoke(J, ue);
      });
    });
  }
  function B(V, J) {
    function ue(ee, de, he, pe) {
      var Ce = p(V[ee], V, de);
      if (Ce.type !== "throw") {
        var _e = Ce.arg, Le = _e.value;
        return Le && as(Le) == "object" && u.call(Le, "__await") ? J.resolve(Le.__await).then(function(Te) {
          ue("next", Te, he, pe);
        }, function(Te) {
          ue("throw", Te, he, pe);
        }) : J.resolve(Le).then(function(Te) {
          _e.value = Te, he(_e);
        }, function(Te) {
          return ue("throw", Te, he, pe);
        });
      }
      pe(Ce.arg);
    }
    var se;
    h(this, "_invoke", {
      value: function(de, he) {
        function pe() {
          return new J(function(Ce, _e) {
            ue(de, he, Ce, _e);
          });
        }
        return se = se ? se.then(pe, pe) : pe();
      }
    });
  }
  function D(V, J, ue) {
    var se = m;
    return function(ee, de) {
      if (se === y) throw Error("Generator is already running");
      if (se === g) {
        if (ee === "throw") throw de;
        return {
          value: t,
          done: !0
        };
      }
      for (ue.method = ee, ue.arg = de; ; ) {
        var he = ue.delegate;
        if (he) {
          var pe = F(he, ue);
          if (pe) {
            if (pe === C) continue;
            return pe;
          }
        }
        if (ue.method === "next") ue.sent = ue._sent = ue.arg;
        else if (ue.method === "throw") {
          if (se === m) throw se = g, ue.arg;
          ue.dispatchException(ue.arg);
        } else ue.method === "return" && ue.abrupt("return", ue.arg);
        se = y;
        var Ce = p(V, J, ue);
        if (Ce.type === "normal") {
          if (se = ue.done ? g : E, Ce.arg === C) continue;
          return {
            value: Ce.arg,
            done: ue.done
          };
        }
        Ce.type === "throw" && (se = g, ue.method = "throw", ue.arg = Ce.arg);
      }
    };
  }
  function F(V, J) {
    var ue = J.method, se = V.iterator[ue];
    if (se === t) return J.delegate = null, ue === "throw" && V.iterator.return && (J.method = "return", J.arg = t, F(V, J), J.method === "throw") || ue !== "return" && (J.method = "throw", J.arg = new TypeError("The iterator does not provide a '" + ue + "' method")), C;
    var ee = p(se, V.iterator, J.arg);
    if (ee.type === "throw") return J.method = "throw", J.arg = ee.arg, J.delegate = null, C;
    var de = ee.arg;
    return de ? de.done ? (J[V.resultName] = de.value, J.next = V.nextLoc, J.method !== "return" && (J.method = "next", J.arg = t), J.delegate = null, C) : de : (J.method = "throw", J.arg = new TypeError("iterator result is not an object"), J.delegate = null, C);
  }
  function j(V) {
    var J = {
      tryLoc: V[0]
    };
    1 in V && (J.catchLoc = V[1]), 2 in V && (J.finallyLoc = V[2], J.afterLoc = V[3]), this.tryEntries.push(J);
  }
  function G(V) {
    var J = V.completion || {};
    J.type = "normal", delete J.arg, V.completion = J;
  }
  function U(V) {
    this.tryEntries = [{
      tryLoc: "root"
    }], V.forEach(j, this), this.reset(!0);
  }
  function M(V) {
    if (V || V === "") {
      var J = V[l];
      if (J) return J.call(V);
      if (typeof V.next == "function") return V;
      if (!isNaN(V.length)) {
        var ue = -1, se = function ee() {
          for (; ++ue < V.length; ) if (u.call(V, ue)) return ee.value = V[ue], ee.done = !1, ee;
          return ee.value = t, ee.done = !0, ee;
        };
        return se.next = se;
      }
    }
    throw new TypeError(as(V) + " is not iterable");
  }
  return N.prototype = w, h(H, "constructor", {
    value: w,
    configurable: !0
  }), h(w, "constructor", {
    value: N,
    configurable: !0
  }), N.displayName = c(w, s, "GeneratorFunction"), r.isGeneratorFunction = function(V) {
    var J = typeof V == "function" && V.constructor;
    return !!J && (J === N || (J.displayName || J.name) === "GeneratorFunction");
  }, r.mark = function(V) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(V, w) : (V.__proto__ = w, c(V, s, "GeneratorFunction")), V.prototype = Object.create(H), V;
  }, r.awrap = function(V) {
    return {
      __await: V
    };
  }, S(B.prototype), c(B.prototype, v, function() {
    return this;
  }), r.AsyncIterator = B, r.async = function(V, J, ue, se, ee) {
    ee === void 0 && (ee = Promise);
    var de = new B(d(V, J, ue, se), ee);
    return r.isGeneratorFunction(J) ? de : de.next().then(function(he) {
      return he.done ? he.value : de.next();
    });
  }, S(H), c(H, s, "Generator"), c(H, l, function() {
    return this;
  }), c(H, "toString", function() {
    return "[object Generator]";
  }), r.keys = function(V) {
    var J = Object(V), ue = [];
    for (var se in J) ue.push(se);
    return ue.reverse(), function ee() {
      for (; ue.length; ) {
        var de = ue.pop();
        if (de in J) return ee.value = de, ee.done = !1, ee;
      }
      return ee.done = !0, ee;
    };
  }, r.values = M, U.prototype = {
    constructor: U,
    reset: function(J) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(G), !J) for (var ue in this) ue.charAt(0) === "t" && u.call(this, ue) && !isNaN(+ue.slice(1)) && (this[ue] = t);
    },
    stop: function() {
      this.done = !0;
      var J = this.tryEntries[0].completion;
      if (J.type === "throw") throw J.arg;
      return this.rval;
    },
    dispatchException: function(J) {
      if (this.done) throw J;
      var ue = this;
      function se(_e, Le) {
        return he.type = "throw", he.arg = J, ue.next = _e, Le && (ue.method = "next", ue.arg = t), !!Le;
      }
      for (var ee = this.tryEntries.length - 1; ee >= 0; --ee) {
        var de = this.tryEntries[ee], he = de.completion;
        if (de.tryLoc === "root") return se("end");
        if (de.tryLoc <= this.prev) {
          var pe = u.call(de, "catchLoc"), Ce = u.call(de, "finallyLoc");
          if (pe && Ce) {
            if (this.prev < de.catchLoc) return se(de.catchLoc, !0);
            if (this.prev < de.finallyLoc) return se(de.finallyLoc);
          } else if (pe) {
            if (this.prev < de.catchLoc) return se(de.catchLoc, !0);
          } else {
            if (!Ce) throw Error("try statement without catch or finally");
            if (this.prev < de.finallyLoc) return se(de.finallyLoc);
          }
        }
      }
    },
    abrupt: function(J, ue) {
      for (var se = this.tryEntries.length - 1; se >= 0; --se) {
        var ee = this.tryEntries[se];
        if (ee.tryLoc <= this.prev && u.call(ee, "finallyLoc") && this.prev < ee.finallyLoc) {
          var de = ee;
          break;
        }
      }
      de && (J === "break" || J === "continue") && de.tryLoc <= ue && ue <= de.finallyLoc && (de = null);
      var he = de ? de.completion : {};
      return he.type = J, he.arg = ue, de ? (this.method = "next", this.next = de.finallyLoc, C) : this.complete(he);
    },
    complete: function(J, ue) {
      if (J.type === "throw") throw J.arg;
      return J.type === "break" || J.type === "continue" ? this.next = J.arg : J.type === "return" ? (this.rval = this.arg = J.arg, this.method = "return", this.next = "end") : J.type === "normal" && ue && (this.next = ue), C;
    },
    finish: function(J) {
      for (var ue = this.tryEntries.length - 1; ue >= 0; --ue) {
        var se = this.tryEntries[ue];
        if (se.finallyLoc === J) return this.complete(se.completion, se.afterLoc), G(se), C;
      }
    },
    catch: function(J) {
      for (var ue = this.tryEntries.length - 1; ue >= 0; --ue) {
        var se = this.tryEntries[ue];
        if (se.tryLoc === J) {
          var ee = se.completion;
          if (ee.type === "throw") {
            var de = ee.arg;
            G(se);
          }
          return de;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(J, ue, se) {
      return this.delegate = {
        iterator: M(J),
        resultName: ue,
        nextLoc: se
      }, this.method === "next" && (this.arg = t), C;
    }
  }, r;
}
function kj(t, r, a, u, h, b, l) {
  try {
    var v = t[b](l), s = v.value;
  } catch (c) {
    return void a(c);
  }
  v.done ? r(s) : Promise.resolve(s).then(u, h);
}
function Epe(t) {
  return function() {
    var r = this, a = arguments;
    return new Promise(function(u, h) {
      var b = t.apply(r, a);
      function l(s) {
        kj(b, u, h, l, v, "next", s);
      }
      function v(s) {
        kj(b, u, h, l, v, "throw", s);
      }
      l(void 0);
    });
  };
}
var jj = ["measure", "alignPre", "align", null, "motion"];
const ype = function(t, r) {
  var a = pb(null), u = ps(a, 2), h = u[0], b = u[1], l = er();
  function v(d) {
    b(d, !0);
  }
  function s() {
    Hu.cancel(l.current);
  }
  function c(d) {
    s(), l.current = Hu(function() {
      v(function(p) {
        switch (h) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return p;
      }), d == null || d();
    });
  }
  return Pn(function() {
    v("measure");
  }, [t]), Pn(function() {
    switch (h) {
      case "measure":
        r();
        break;
    }
    h && (l.current = Hu(/* @__PURE__ */ Epe(/* @__PURE__ */ X2().mark(function d() {
      var p, m;
      return X2().wrap(function(y) {
        for (; ; )
          switch (y.prev = y.next) {
            case 0:
              p = jj.indexOf(h), m = jj[p + 1], m && p !== -1 && v(m);
            case 3:
            case "end":
              return y.stop();
          }
      }, d);
    }))));
  }, [h]), Pn(function() {
    return function() {
      s();
    };
  }, []), [h, c];
}, vpe = function(t) {
  var r = ht.useState({
    width: 0,
    height: 0
  }), a = ps(r, 2), u = a[0], h = a[1];
  function b(v) {
    var s = v.offsetWidth, c = v.offsetHeight, d = v.getBoundingClientRect(), p = d.width, m = d.height;
    Math.abs(s - p) < 1 && Math.abs(c - m) < 1 && (s = p, c = m), h({
      width: s,
      height: c
    });
  }
  var l = ht.useMemo(function() {
    var v = {};
    if (t) {
      var s = u.width, c = u.height;
      t.indexOf("height") !== -1 && c ? v.height = c : t.indexOf("minHeight") !== -1 && c && (v.minHeight = c), t.indexOf("width") !== -1 && s ? v.width = s : t.indexOf("minWidth") !== -1 && s && (v.minWidth = s);
    }
    return v;
  }, [t, u]);
  return [l, b];
};
var XF = /* @__PURE__ */ ht.forwardRef(function(t, r) {
  var a = t.visible, u = t.prefixCls, h = t.className, b = t.style, l = t.children, v = t.zIndex, s = t.stretch, c = t.destroyPopupOnHide, d = t.forceRender, p = t.align, m = t.point, E = t.getRootDomNode, y = t.getClassNameFromAlign, g = t.onAlign, C = t.onMouseEnter, O = t.onMouseLeave, N = t.onMouseDown, w = t.onTouchStart, _ = t.onClick, I = er(), k = er(), H = tn(), S = ps(H, 2), B = S[0], D = S[1], F = vpe(s), j = ps(F, 2), G = j[0], U = j[1];
  function M() {
    s && U(E());
  }
  var V = ype(a, M), J = ps(V, 2), ue = J[0], se = J[1], ee = tn(0), de = ps(ee, 2), he = de[0], pe = de[1], Ce = er();
  L2(function() {
    ue === "alignPre" && pe(0);
  }, [ue]);
  function _e() {
    return m || E;
  }
  function Le() {
    var $e;
    ($e = I.current) === null || $e === void 0 || $e.forceAlign();
  }
  function Te($e, Be) {
    var Ke = y(Be);
    B !== Ke && D(Ke), pe(function(Ze) {
      return Ze + 1;
    }), ue === "align" && (g == null || g($e, Be));
  }
  L2(function() {
    ue === "align" && (he < 3 ? Le() : se(function() {
      var $e;
      ($e = Ce.current) === null || $e === void 0 || $e.call(Ce);
    }));
  }, [he]);
  var K = jr({}, PF(t));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function($e) {
    var Be = K[$e];
    K[$e] = function(Ke, Ze) {
      return se(), Be == null ? void 0 : Be(Ke, Ze);
    };
  });
  function Oe() {
    return new Promise(function($e) {
      Ce.current = $e;
    });
  }
  ht.useEffect(function() {
    !K.motionName && ue === "motion" && se();
  }, [K.motionName, ue]), ht.useImperativeHandle(r, function() {
    return {
      forceAlign: Le,
      getElement: function() {
        return k.current;
      }
    };
  });
  var Pe = jr(jr({}, G), {}, {
    zIndex: v,
    opacity: ue === "motion" || ue === "stable" || !a ? void 0 : 0,
    // Cannot interact with disappearing elements
    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
    pointerEvents: !a && ue !== "stable" ? "none" : void 0
  }, b), xe = !0;
  p != null && p.points && (ue === "align" || ue === "stable") && (xe = !1);
  var be = l;
  return ht.Children.count(l) > 1 && (be = /* @__PURE__ */ ht.createElement("div", {
    className: "".concat(u, "-content")
  }, l)), /* @__PURE__ */ ht.createElement(mh, ru({
    visible: a,
    ref: k,
    leavedClassName: "".concat(u, "-hidden")
  }, K, {
    onAppearPrepare: Oe,
    onEnterPrepare: Oe,
    removeOnLeave: c,
    forceRender: d
  }), function($e, Be) {
    var Ke = $e.className, Ze = $e.style, at = En(u, h, B, Ke);
    return /* @__PURE__ */ ht.createElement(YF, {
      target: _e(),
      key: "popup",
      ref: I,
      monitorWindowResize: !0,
      disabled: xe,
      align: p,
      onAlign: Te
    }, /* @__PURE__ */ ht.createElement("div", {
      ref: Be,
      className: at,
      onMouseEnter: C,
      onMouseLeave: O,
      onMouseDownCapture: N,
      onTouchStartCapture: w,
      onClick: _,
      style: jr(jr({}, Ze), Pe)
    }, be));
  });
});
XF.displayName = "PopupInner";
var WF = /* @__PURE__ */ ht.forwardRef(function(t, r) {
  var a = t.prefixCls, u = t.visible, h = t.zIndex, b = t.children, l = t.mobile;
  l = l === void 0 ? {} : l;
  var v = l.popupClassName, s = l.popupStyle, c = l.popupMotion, d = c === void 0 ? {} : c, p = l.popupRender, m = t.onClick, E = ht.useRef();
  ht.useImperativeHandle(r, function() {
    return {
      forceAlign: function() {
      },
      getElement: function() {
        return E.current;
      }
    };
  });
  var y = jr({
    zIndex: h
  }, s), g = b;
  return ht.Children.count(b) > 1 && (g = /* @__PURE__ */ ht.createElement("div", {
    className: "".concat(a, "-content")
  }, b)), p && (g = p(g)), /* @__PURE__ */ ht.createElement(mh, ru({
    visible: u,
    ref: E,
    removeOnLeave: !0
  }, d), function(C, O) {
    var N = C.className, w = C.style, _ = En(a, v, N);
    return /* @__PURE__ */ ht.createElement("div", {
      ref: O,
      className: _,
      onClick: m,
      style: jr(jr({}, w), y)
    }, g);
  });
});
WF.displayName = "MobilePopupInner";
var Tpe = ["visible", "mobile"], qF = /* @__PURE__ */ ht.forwardRef(function(t, r) {
  var a = t.visible, u = t.mobile, h = fb(t, Tpe), b = tn(a), l = ps(b, 2), v = l[0], s = l[1], c = tn(!1), d = ps(c, 2), p = d[0], m = d[1], E = jr(jr({}, h), {}, {
    visible: v
  });
  Pn(function() {
    s(a), a && u && m(Yfe());
  }, [a, u]);
  var y = p ? /* @__PURE__ */ ht.createElement(WF, ru({}, E, {
    mobile: u,
    ref: r
  })) : /* @__PURE__ */ ht.createElement(XF, ru({}, E, {
    ref: r
  }));
  return /* @__PURE__ */ ht.createElement("div", null, /* @__PURE__ */ ht.createElement(vhe, E), y);
});
qF.displayName = "Popup";
var Uj = /* @__PURE__ */ ht.createContext(null);
function _R() {
}
function bpe() {
  return "";
}
function Ape(t) {
  return t ? t.ownerDocument : window.document;
}
var Ope = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function Cpe(t) {
  var r = /* @__PURE__ */ function(a) {
    gh(h, a);
    var u = cw(h);
    function h(b) {
      var l;
      yo(this, h), l = u.call(this, b), Jn(Er(l), "popupRef", /* @__PURE__ */ ht.createRef()), Jn(Er(l), "triggerRef", /* @__PURE__ */ ht.createRef()), Jn(Er(l), "portalContainer", void 0), Jn(Er(l), "attachId", void 0), Jn(Er(l), "clickOutsideHandler", void 0), Jn(Er(l), "touchOutsideHandler", void 0), Jn(Er(l), "contextMenuOutsideHandler1", void 0), Jn(Er(l), "contextMenuOutsideHandler2", void 0), Jn(Er(l), "mouseDownTimeout", void 0), Jn(Er(l), "focusTime", void 0), Jn(Er(l), "preClickTime", void 0), Jn(Er(l), "preTouchTime", void 0), Jn(Er(l), "delayTimer", void 0), Jn(Er(l), "hasPopupMouseDown", void 0), Jn(Er(l), "onMouseEnter", function(s) {
        var c = l.props.mouseEnterDelay;
        l.fireEvents("onMouseEnter", s), l.delaySetPopupVisible(!0, c, c ? null : s);
      }), Jn(Er(l), "onMouseMove", function(s) {
        l.fireEvents("onMouseMove", s), l.setPoint(s);
      }), Jn(Er(l), "onMouseLeave", function(s) {
        l.fireEvents("onMouseLeave", s), l.delaySetPopupVisible(!1, l.props.mouseLeaveDelay);
      }), Jn(Er(l), "onPopupMouseEnter", function() {
        l.clearDelayTimer();
      }), Jn(Er(l), "onPopupMouseLeave", function(s) {
        var c;
        s.relatedTarget && !s.relatedTarget.setTimeout && K0((c = l.popupRef.current) === null || c === void 0 ? void 0 : c.getElement(), s.relatedTarget) || l.delaySetPopupVisible(!1, l.props.mouseLeaveDelay);
      }), Jn(Er(l), "onFocus", function(s) {
        l.fireEvents("onFocus", s), l.clearDelayTimer(), l.isFocusToShow() && (l.focusTime = Date.now(), l.delaySetPopupVisible(!0, l.props.focusDelay));
      }), Jn(Er(l), "onMouseDown", function(s) {
        l.fireEvents("onMouseDown", s), l.preClickTime = Date.now();
      }), Jn(Er(l), "onTouchStart", function(s) {
        l.fireEvents("onTouchStart", s), l.preTouchTime = Date.now();
      }), Jn(Er(l), "onBlur", function(s) {
        l.fireEvents("onBlur", s), l.clearDelayTimer(), l.isBlurToHide() && l.delaySetPopupVisible(!1, l.props.blurDelay);
      }), Jn(Er(l), "onContextMenu", function(s) {
        s.preventDefault(), l.fireEvents("onContextMenu", s), l.setPopupVisible(!0, s);
      }), Jn(Er(l), "onContextMenuClose", function() {
        l.isContextMenuToShow() && l.close();
      }), Jn(Er(l), "onClick", function(s) {
        if (l.fireEvents("onClick", s), l.focusTime) {
          var c;
          if (l.preClickTime && l.preTouchTime ? c = Math.min(l.preClickTime, l.preTouchTime) : l.preClickTime ? c = l.preClickTime : l.preTouchTime && (c = l.preTouchTime), Math.abs(c - l.focusTime) < 20)
            return;
          l.focusTime = 0;
        }
        l.preClickTime = 0, l.preTouchTime = 0, l.isClickToShow() && (l.isClickToHide() || l.isBlurToHide()) && s && s.preventDefault && s.preventDefault();
        var d = !l.state.popupVisible;
        (l.isClickToHide() && !d || d && l.isClickToShow()) && l.setPopupVisible(!l.state.popupVisible, s);
      }), Jn(Er(l), "onPopupMouseDown", function() {
        if (l.hasPopupMouseDown = !0, clearTimeout(l.mouseDownTimeout), l.mouseDownTimeout = window.setTimeout(function() {
          l.hasPopupMouseDown = !1;
        }, 0), l.context) {
          var s;
          (s = l.context).onPopupMouseDown.apply(s, arguments);
        }
      }), Jn(Er(l), "onDocumentClick", function(s) {
        if (!(l.props.mask && !l.props.maskClosable)) {
          var c = s.target, d = l.getRootDomNode(), p = l.getPopupDomNode();
          // mousedown on the target should also close popup when action is contextMenu.
          // https://github.com/ant-design/ant-design/issues/29853
          (!K0(d, c) || l.isContextMenuOnly()) && !K0(p, c) && !l.hasPopupMouseDown && l.close();
        }
      }), Jn(Er(l), "getRootDomNode", function() {
        var s = l.props.getTriggerDOMNode;
        if (s)
          return s(l.triggerRef.current);
        try {
          var c = hF(l.triggerRef.current);
          if (c)
            return c;
        } catch {
        }
        return jl.findDOMNode(Er(l));
      }), Jn(Er(l), "getPopupClassNameFromAlign", function(s) {
        var c = [], d = l.props, p = d.popupPlacement, m = d.builtinPlacements, E = d.prefixCls, y = d.alignPoint, g = d.getPopupClassNameFromAlign;
        return p && m && c.push(Ffe(m, E, s, y)), g && c.push(g(s)), c.join(" ");
      }), Jn(Er(l), "getComponent", function() {
        var s = l.props, c = s.prefixCls, d = s.destroyPopupOnHide, p = s.popupClassName, m = s.onPopupAlign, E = s.popupMotion, y = s.popupAnimation, g = s.popupTransitionName, C = s.popupStyle, O = s.mask, N = s.maskAnimation, w = s.maskTransitionName, _ = s.maskMotion, I = s.zIndex, k = s.popup, H = s.stretch, S = s.alignPoint, B = s.mobile, D = s.forceRender, F = s.onPopupClick, j = l.state, G = j.popupVisible, U = j.point, M = l.getPopupAlign(), V = {};
        return l.isMouseEnterToShow() && (V.onMouseEnter = l.onPopupMouseEnter), l.isMouseLeaveToHide() && (V.onMouseLeave = l.onPopupMouseLeave), V.onMouseDown = l.onPopupMouseDown, V.onTouchStart = l.onPopupMouseDown, /* @__PURE__ */ ht.createElement(qF, ru({
          prefixCls: c,
          destroyPopupOnHide: d,
          visible: G,
          point: S && U,
          className: p,
          align: M,
          onAlign: m,
          animation: y,
          getClassNameFromAlign: l.getPopupClassNameFromAlign
        }, V, {
          stretch: H,
          getRootDomNode: l.getRootDomNode,
          style: C,
          mask: O,
          zIndex: I,
          transitionName: g,
          maskAnimation: N,
          maskTransitionName: w,
          maskMotion: _,
          ref: l.popupRef,
          motion: E,
          mobile: B,
          forceRender: D,
          onClick: F
        }), typeof k == "function" ? k() : k);
      }), Jn(Er(l), "attachParent", function(s) {
        Hu.cancel(l.attachId);
        var c = l.props, d = c.getPopupContainer, p = c.getDocument, m = l.getRootDomNode(), E;
        d ? (m || d.length === 0) && (E = d(m)) : E = p(l.getRootDomNode()).body, E ? E.appendChild(s) : l.attachId = Hu(function() {
          l.attachParent(s);
        });
      }), Jn(Er(l), "getContainer", function() {
        if (!l.portalContainer) {
          var s = l.props.getDocument, c = s(l.getRootDomNode()).createElement("div");
          c.style.position = "absolute", c.style.top = "0", c.style.left = "0", c.style.width = "100%", l.portalContainer = c;
        }
        return l.attachParent(l.portalContainer), l.portalContainer;
      }), Jn(Er(l), "setPoint", function(s) {
        var c = l.props.alignPoint;
        !c || !s || l.setState({
          point: {
            pageX: s.pageX,
            pageY: s.pageY
          }
        });
      }), Jn(Er(l), "handlePortalUpdate", function() {
        l.state.prevPopupVisible !== l.state.popupVisible && l.props.afterPopupVisibleChange(l.state.popupVisible);
      }), Jn(Er(l), "triggerContextValue", {
        onPopupMouseDown: l.onPopupMouseDown
      });
      var v;
      return "popupVisible" in b ? v = !!b.popupVisible : v = !!b.defaultPopupVisible, l.state = {
        prevPopupVisible: v,
        popupVisible: v
      }, Ope.forEach(function(s) {
        l["fire".concat(s)] = function(c) {
          l.fireEvents(s, c);
        };
      }), l;
    }
    return vo(h, [{
      key: "componentDidMount",
      value: function() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var l = this.props, v = this.state;
        if (v.popupVisible) {
          var s;
          !this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow()) && (s = l.getDocument(this.getRootDomNode()), this.clickOutsideHandler = Py(s, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (s = s || l.getDocument(this.getRootDomNode()), this.touchOutsideHandler = Py(s, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (s = s || l.getDocument(this.getRootDomNode()), this.contextMenuOutsideHandler1 = Py(s, "scroll", this.onContextMenuClose)), !this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = Py(window, "blur", this.onContextMenuClose));
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout), Hu.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function() {
        var l;
        return ((l = this.popupRef.current) === null || l === void 0 ? void 0 : l.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function() {
        var l = this.props, v = l.popupPlacement, s = l.popupAlign, c = l.builtinPlacements;
        return v && c ? zfe(c, v, s) : s;
      }
    }, {
      key: "setPopupVisible",
      value: (
        /**
         * @param popupVisible    Show or not the popup element
         * @param event           SyntheticEvent, used for `pointAlign`
         */
        function(l, v) {
          var s = this.props.alignPoint, c = this.state.popupVisible;
          this.clearDelayTimer(), c !== l && ("popupVisible" in this.props || this.setState({
            popupVisible: l,
            prevPopupVisible: c
          }), this.props.onPopupVisibleChange(l)), s && v && l && this.setPoint(v);
        }
      )
    }, {
      key: "delaySetPopupVisible",
      value: function(l, v, s) {
        var c = this, d = v * 1e3;
        if (this.clearDelayTimer(), d) {
          var p = s ? {
            pageX: s.pageX,
            pageY: s.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            c.setPopupVisible(l, p), c.clearDelayTimer();
          }, d);
        } else
          this.setPopupVisible(l, s);
      }
    }, {
      key: "clearDelayTimer",
      value: function() {
        this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
      }
    }, {
      key: "clearOutsideHandler",
      value: function() {
        this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
      }
    }, {
      key: "createTwoChains",
      value: function(l) {
        var v = this.props.children.props, s = this.props;
        return v[l] && s[l] ? this["fire".concat(l)] : v[l] || s[l];
      }
    }, {
      key: "isClickToShow",
      value: function() {
        var l = this.props, v = l.action, s = l.showAction;
        return v.indexOf("click") !== -1 || s.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function() {
        var l = this.props.action;
        return l === "contextMenu" || l.length === 1 && l[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function() {
        var l = this.props, v = l.action, s = l.showAction;
        return v.indexOf("contextMenu") !== -1 || s.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function() {
        var l = this.props, v = l.action, s = l.hideAction;
        return v.indexOf("click") !== -1 || s.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function() {
        var l = this.props, v = l.action, s = l.showAction;
        return v.indexOf("hover") !== -1 || s.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function() {
        var l = this.props, v = l.action, s = l.hideAction;
        return v.indexOf("hover") !== -1 || s.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function() {
        var l = this.props, v = l.action, s = l.showAction;
        return v.indexOf("focus") !== -1 || s.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function() {
        var l = this.props, v = l.action, s = l.hideAction;
        return v.indexOf("focus") !== -1 || s.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function() {
        if (this.state.popupVisible) {
          var l;
          (l = this.popupRef.current) === null || l === void 0 || l.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function(l, v) {
        var s = this.props.children.props[l];
        s && s(v);
        var c = this.props[l];
        c && c(v);
      }
    }, {
      key: "close",
      value: function() {
        this.setPopupVisible(!1);
      }
    }, {
      key: "render",
      value: function() {
        var l = this.state.popupVisible, v = this.props, s = v.children, c = v.forceRender, d = v.alignPoint, p = v.className, m = v.autoDestroy, E = ht.Children.only(s), y = {
          key: "trigger"
        };
        this.isContextMenuToShow() ? y.onContextMenu = this.onContextMenu : y.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (y.onClick = this.onClick, y.onMouseDown = this.onMouseDown, y.onTouchStart = this.onTouchStart) : (y.onClick = this.createTwoChains("onClick"), y.onMouseDown = this.createTwoChains("onMouseDown"), y.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (y.onMouseEnter = this.onMouseEnter, d && (y.onMouseMove = this.onMouseMove)) : y.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? y.onMouseLeave = this.onMouseLeave : y.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (y.onFocus = this.onFocus, y.onBlur = this.onBlur) : (y.onFocus = this.createTwoChains("onFocus"), y.onBlur = this.createTwoChains("onBlur"));
        var g = En(E && E.props && E.props.className, p);
        g && (y.className = g);
        var C = jr({}, y);
        mF(E) && (C.ref = gF(this.triggerRef, E.ref));
        var O = /* @__PURE__ */ ht.cloneElement(E, C), N;
        return (l || this.popupRef.current || c) && (N = /* @__PURE__ */ ht.createElement(t, {
          key: "portal",
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        }, this.getComponent())), !l && m && (N = null), /* @__PURE__ */ ht.createElement(Uj.Provider, {
          value: this.triggerContextValue
        }, O, N);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(l, v) {
        var s = l.popupVisible, c = {};
        return s !== void 0 && v.popupVisible !== s && (c.popupVisible = s, c.prevPopupVisible = v.popupVisible), c;
      }
    }]), h;
  }(ht.Component);
  return Jn(r, "contextType", Uj), Jn(r, "defaultProps", {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: bpe,
    getDocument: Ape,
    onPopupVisibleChange: _R,
    afterPopupVisibleChange: _R,
    onPopupAlign: _R,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: !1,
    popupAlign: {},
    defaultPopupVisible: !1,
    mask: !1,
    maskClosable: !0,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: !1
  }), r;
}
const Spe = Cpe(Hfe);
var gc = {
  adjustX: 1,
  adjustY: 1
}, mc = [0, 0], Ipe = {
  left: {
    points: ["cr", "cl"],
    overflow: gc,
    offset: [-4, 0],
    targetOffset: mc
  },
  right: {
    points: ["cl", "cr"],
    overflow: gc,
    offset: [4, 0],
    targetOffset: mc
  },
  top: {
    points: ["bc", "tc"],
    overflow: gc,
    offset: [0, -4],
    targetOffset: mc
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: gc,
    offset: [0, 4],
    targetOffset: mc
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: gc,
    offset: [0, -4],
    targetOffset: mc
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: gc,
    offset: [-4, 0],
    targetOffset: mc
  },
  topRight: {
    points: ["br", "tr"],
    overflow: gc,
    offset: [0, -4],
    targetOffset: mc
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: gc,
    offset: [4, 0],
    targetOffset: mc
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: gc,
    offset: [0, 4],
    targetOffset: mc
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: gc,
    offset: [4, 0],
    targetOffset: mc
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: gc,
    offset: [0, 4],
    targetOffset: mc
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: gc,
    offset: [-4, 0],
    targetOffset: mc
  }
}, Rpe = function(r) {
  var a = r.overlay, u = r.prefixCls, h = r.id, b = r.overlayInnerStyle;
  return /* @__PURE__ */ ht.createElement("div", {
    className: "".concat(u, "-inner"),
    id: h,
    role: "tooltip",
    style: b
  }, typeof a == "function" ? a() : a);
}, Npe = function(r, a) {
  var u = r.overlayClassName, h = r.trigger, b = h === void 0 ? ["hover"] : h, l = r.mouseEnterDelay, v = l === void 0 ? 0 : l, s = r.mouseLeaveDelay, c = s === void 0 ? 0.1 : s, d = r.overlayStyle, p = r.prefixCls, m = p === void 0 ? "rc-tooltip" : p, E = r.children, y = r.onVisibleChange, g = r.afterVisibleChange, C = r.transitionName, O = r.animation, N = r.motion, w = r.placement, _ = w === void 0 ? "right" : w, I = r.align, k = I === void 0 ? {} : I, H = r.destroyTooltipOnHide, S = H === void 0 ? !1 : H, B = r.defaultVisible, D = r.getTooltipContainer, F = r.overlayInnerStyle, j = fb(r, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]), G = er(null);
  lv(a, function() {
    return G.current;
  });
  var U = jr({}, j);
  "visible" in r && (U.popupVisible = r.visible);
  var M = function() {
    var ee = r.arrowContent, de = ee === void 0 ? null : ee, he = r.overlay, pe = r.id;
    return [/* @__PURE__ */ ht.createElement("div", {
      className: "".concat(m, "-arrow"),
      key: "arrow"
    }, de), /* @__PURE__ */ ht.createElement(Rpe, {
      key: "content",
      prefixCls: m,
      id: pe,
      overlay: he,
      overlayInnerStyle: F
    })];
  }, V = !1, J = !1;
  if (typeof S == "boolean")
    V = S;
  else if (S && as(S) === "object") {
    var ue = S.keepParent;
    V = ue === !0, J = ue === !1;
  }
  return /* @__PURE__ */ ht.createElement(Spe, ru({
    popupClassName: u,
    prefixCls: m,
    popup: M,
    action: b,
    builtinPlacements: Ipe,
    popupPlacement: _,
    ref: G,
    popupAlign: k,
    getPopupContainer: D,
    onPopupVisibleChange: y,
    afterPopupVisibleChange: g,
    popupTransitionName: C,
    popupAnimation: O,
    popupMotion: N,
    defaultPopupVisible: B,
    destroyPopupOnHide: V,
    autoDestroy: J,
    mouseLeaveDelay: c,
    popupStyle: d,
    mouseEnterDelay: v
  }, U), E);
};
const wpe = /* @__PURE__ */ Gu(Npe);
var KF = {}, JF = { exports: {} };
(function(t) {
  function r(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(JF);
var Cv = JF.exports;
const mw = /* @__PURE__ */ KN(Vfe);
var Ew = {}, ZF = { exports: {} }, QF = { exports: {} };
(function(t) {
  function r(a) {
    "@babel/helpers - typeof";
    return t.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, r(a);
  }
  t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})(QF);
var nA = QF.exports;
(function(t) {
  var r = nA.default;
  function a(h) {
    if (typeof WeakMap != "function") return null;
    var b = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (a = function(s) {
      return s ? l : b;
    })(h);
  }
  function u(h, b) {
    if (!b && h && h.__esModule) return h;
    if (h === null || r(h) != "object" && typeof h != "function") return {
      default: h
    };
    var l = a(b);
    if (l && l.has(h)) return l.get(h);
    var v = {
      __proto__: null
    }, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var c in h) if (c !== "default" && {}.hasOwnProperty.call(h, c)) {
      var d = s ? Object.getOwnPropertyDescriptor(h, c) : null;
      d && (d.get || d.set) ? Object.defineProperty(v, c, d) : v[c] = h[c];
    }
    return v.default = h, l && l.set(h, v), v;
  }
  t.exports = u, t.exports.__esModule = !0, t.exports.default = t.exports;
})(ZF);
var rA = ZF.exports, _pe = rA.default;
Object.defineProperty(Ew, "__esModule", {
  value: !0
});
Ew.default = Ppe;
var Hj = _pe(_t);
function Ppe(t) {
  var r = Hj.useRef();
  r.current = t;
  var a = Hj.useCallback(function() {
    for (var u, h = arguments.length, b = new Array(h), l = 0; l < h; l++)
      b[l] = arguments[l];
    return (u = r.current) === null || u === void 0 ? void 0 : u.call.apply(u, [r].concat(b));
  }, []);
  return a;
}
var Em = {}, yw = {};
Object.defineProperty(yw, "__esModule", {
  value: !0
});
yw.default = xpe;
function xpe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Dpe = Cv.default, Mpe = rA.default;
Object.defineProperty(Em, "__esModule", {
  value: !0
});
Em.useLayoutUpdateEffect = Em.default = void 0;
var W2 = Mpe(_t), Lpe = Dpe(yw), Bj = process.env.NODE_ENV !== "test" && (0, Lpe.default)() ? W2.useLayoutEffect : W2.useEffect, $F = function(r, a) {
  var u = W2.useRef(!0);
  Bj(function() {
    return r(u.current);
  }, a), Bj(function() {
    return u.current = !1, function() {
      u.current = !0;
    };
  }, []);
};
Em.useLayoutUpdateEffect = function(r, a) {
  $F(function(u) {
    if (!u)
      return r();
  }, a);
};
Em.default = $F;
var vw = {}, kpe = rA.default, jpe = Cv.default;
Object.defineProperty(vw, "__esModule", {
  value: !0
});
vw.default = Hpe;
var Upe = jpe(mw), PR = kpe(_t);
function Hpe(t) {
  var r = PR.useRef(!1), a = PR.useState(t), u = (0, Upe.default)(a, 2), h = u[0], b = u[1];
  PR.useEffect(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
  function l(v, s) {
    s && r.current || b(v);
  }
  return [h, l];
}
var Tw = Cv.default;
Object.defineProperty(KF, "__esModule", {
  value: !0
});
var Bpe = KF.default = zpe, zj = Tw(mw), Fj = Tw(Ew), Gj = Em, Vj = Tw(vw);
function xR(t) {
  return t !== void 0;
}
function zpe(t, r) {
  var a = r || {}, u = a.defaultValue, h = a.value, b = a.onChange, l = a.postState, v = (0, Vj.default)(function() {
    return xR(h) ? h : xR(u) ? typeof u == "function" ? u() : u : typeof t == "function" ? t() : t;
  }), s = (0, zj.default)(v, 2), c = s[0], d = s[1], p = h !== void 0 ? h : c, m = l ? l(p) : p, E = (0, Fj.default)(b), y = (0, Vj.default)([p]), g = (0, zj.default)(y, 2), C = g[0], O = g[1];
  (0, Gj.useLayoutUpdateEffect)(function() {
    var w = C[0];
    c !== w && E(c, w);
  }, [C]), (0, Gj.useLayoutUpdateEffect)(function() {
    xR(h) || d(h);
  }, [h]);
  var N = (0, Fj.default)(function(w, _) {
    d(w, _), O([p], _);
  });
  return [m, N];
}
const q2 = (t, r, a) => a !== void 0 ? a : `${t}-${r}`;
var $y = {};
Object.defineProperty($y, "__esModule", {
  value: !0
});
$y.default = tG = $y.placements = void 0;
var Ec = {
  adjustX: 1,
  adjustY: 1
}, yc = [0, 0], eG = {
  left: {
    points: ["cr", "cl"],
    overflow: Ec,
    offset: [-4, 0],
    targetOffset: yc
  },
  right: {
    points: ["cl", "cr"],
    overflow: Ec,
    offset: [4, 0],
    targetOffset: yc
  },
  top: {
    points: ["bc", "tc"],
    overflow: Ec,
    offset: [0, -4],
    targetOffset: yc
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: Ec,
    offset: [0, 4],
    targetOffset: yc
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: Ec,
    offset: [0, -4],
    targetOffset: yc
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: Ec,
    offset: [-4, 0],
    targetOffset: yc
  },
  topRight: {
    points: ["br", "tr"],
    overflow: Ec,
    offset: [0, -4],
    targetOffset: yc
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: Ec,
    offset: [4, 0],
    targetOffset: yc
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: Ec,
    offset: [0, 4],
    targetOffset: yc
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: Ec,
    offset: [4, 0],
    targetOffset: yc
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: Ec,
    offset: [0, 4],
    targetOffset: yc
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: Ec,
    offset: [-4, 0],
    targetOffset: yc
  }
}, tG = $y.placements = eG, Fpe = eG;
$y.default = Fpe;
const Gpe = {
  adjustX: 1,
  adjustY: 1
}, Yj = {
  adjustX: 0,
  adjustY: 0
}, Vpe = [0, 0];
function Xj(t) {
  return typeof t == "boolean" ? t ? Gpe : Yj : {
    ...Yj,
    ...t
  };
}
function Ype(t) {
  const {
    arrowWidth: r = 4,
    horizontalArrowShift: a = 16,
    verticalArrowShift: u = 8,
    autoAdjustOverflow: h,
    arrowPointAtCenter: b
  } = t, l = {
    left: {
      points: ["cr", "cl"],
      offset: [-4, 0]
    },
    right: {
      points: ["cl", "cr"],
      offset: [4, 0]
    },
    top: {
      points: ["bc", "tc"],
      offset: [0, -4]
    },
    bottom: {
      points: ["tc", "bc"],
      offset: [0, 4]
    },
    topLeft: {
      points: ["bl", "tc"],
      offset: [-(a + r), -4]
    },
    leftTop: {
      points: ["tr", "cl"],
      offset: [-4, -(u + r)]
    },
    topRight: {
      points: ["br", "tc"],
      offset: [a + r, -4]
    },
    rightTop: {
      points: ["tl", "cr"],
      offset: [4, -(u + r)]
    },
    bottomRight: {
      points: ["tr", "bc"],
      offset: [a + r, 4]
    },
    rightBottom: {
      points: ["bl", "cr"],
      offset: [4, u + r]
    },
    bottomLeft: {
      points: ["tl", "bc"],
      offset: [-(a + r), 4]
    },
    leftBottom: {
      points: ["br", "cl"],
      offset: [-4, u + r]
    }
  };
  return Object.keys(l).forEach((v) => {
    l[v] = b ? {
      ...l[v],
      overflow: Xj(h),
      targetOffset: Vpe
    } : {
      ...tG[v],
      overflow: Xj(h)
    }, l[v].ignoreShake = !0;
  }), l;
}
const Xpe = (t, r) => {
  const a = {}, u = { ...t };
  return r.forEach((h) => {
    t && h in t && (a[h] = t[h], delete u[h]);
  }), { picked: a, omitted: u };
};
function Wpe(t, r) {
  const a = t.type;
  if ((a.__ANT_BUTTON === !0 || t.type === "button") && t.props.disabled || a.__ANT_SWITCH === !0 && (t.props.disabled || t.props.loading) || a.__ANT_RADIO === !0 && t.props.disabled) {
    const { picked: u, omitted: h } = Xpe(t.props.style, [
      "position",
      "left",
      "right",
      "top",
      "bottom",
      "float",
      "display",
      "zIndex"
    ]), b = {
      display: "inline-block",
      // default inline-block is important
      ...u,
      cursor: "not-allowed",
      width: t.props.block ? "100%" : void 0
    }, l = {
      ...h,
      pointerEvents: "none"
    }, v = Vl(t, {
      style: l,
      className: null
    });
    return /* @__PURE__ */ q.jsx(
      "span",
      {
        style: b,
        className: En(t.props.className, `${r}-disabled-compatible-wrapper`),
        children: v
      }
    );
  }
  return t;
}
const va = ht.forwardRef((t, r) => {
  const {
    getPopupContainer: a,
    getPrefixCls: u
    // direction,
  } = ht.useContext(Hn), { theme: h } = ht.useContext(Vn), b = h == null ? void 0 : h.mode, l = h == null ? void 0 : h.componentsShape, [v, s] = Bpe(!1, {
    value: t.open,
    defaultValue: t.defaultOpen
  }), c = () => {
    const { title: se, overlay: ee } = t;
    return !se && !ee && se !== 0;
  }, d = (se) => {
    var ee;
    s(c() ? !1 : se), c() || (ee = t.onOpenChange) == null || ee.call(t, se);
  }, p = () => {
    const {
      builtinPlacements: se,
      arrowPointAtCenter: ee = !1,
      autoAdjustOverflow: de = !0,
      arrow: he = !0
    } = t;
    return se || Ype({
      arrowPointAtCenter: !1,
      autoAdjustOverflow: de,
      arrowWidth: 20
    });
  }, m = (se, ee) => {
    const de = p(), he = Object.keys(de).find(
      (pe) => {
        var Ce, _e;
        return de[pe].points[0] === ((Ce = ee.points) == null ? void 0 : Ce[0]) && de[pe].points[1] === ((_e = ee.points) == null ? void 0 : _e[1]);
      }
    );
    if (he) {
      const pe = se.getBoundingClientRect(), Ce = {
        top: "50%",
        left: "50%"
      };
      /top|Bottom/.test(he) ? Ce.top = `${pe.height - ee.offset[1]}px` : /Top|bottom/.test(he) && (Ce.top = `${-ee.offset[1]}px`), /left|Right/.test(he) ? Ce.left = `${Math.floor(pe.width - ee.offset[0])}px` : /right|Left/.test(he) && (Ce.left = `${Math.floor(-ee.offset[0])}px`), se.style.transformOrigin = `${Ce.left} ${Ce.top}`;
    }
  }, E = () => {
    const { title: se, overlay: ee } = t;
    return se === 0 ? se : ee || se || "";
  }, {
    getPopupContainer: y,
    placement: g = "top",
    mouseEnterDelay: C = 0.1,
    mouseLeaveDelay: O = 0.1,
    ...N
  } = t, {
    prefixCls: w,
    openClassName: _,
    getTooltipContainer: I,
    overlayClassName: k,
    overlayInnerStyle: H,
    children: S
  } = t;
  let { color: B } = t;
  b == "dark" && (B = "dark");
  const D = u("tooltip", w), F = u();
  let j = v;
  !("open" in t) && c() && (j = !1);
  const G = Wpe(
    JN(S) && !qce(S) ? S : /* @__PURE__ */ q.jsx("span", { children: S }),
    D
  ), U = G.props, M = !U.className || typeof U.className == "string" ? En(U.className, {
    [_ || `${D}-open`]: !0
  }) : U.className, V = En(k, {
    [`${D}-${B}`]: B,
    [`${D}-${l}`]: !!l
  }), J = H, ue = {};
  return /* @__PURE__ */ q.jsx(
    wpe,
    {
      ...N,
      placement: g,
      mouseEnterDelay: C,
      mouseLeaveDelay: O,
      prefixCls: D,
      overlayClassName: V,
      getTooltipContainer: y || I || a,
      ref: r,
      builtinPlacements: p(),
      overlay: E(),
      visible: j,
      onVisibleChange: d,
      onPopupAlign: m,
      overlayInnerStyle: J,
      arrowContent: t.arrow ? /* @__PURE__ */ q.jsx("span", { className: `${D}-arrow-content`, style: ue }) : null,
      motion: {
        motionName: q2(F, "zoom-big-fast", t.transitionName),
        motionDeadline: 1e3
      },
      children: j ? Vl(G, { className: M }) : G
    }
  );
});
va.displayName = "Tooltip";
const nG = (t, r) => {
  const [a, u] = _t.useState(!0), h = _t.useRef(null), b = _t.useRef(null), l = Nfe(r, h), { getPrefixCls: v } = _t.useContext(Hn);
  _t.useEffect(() => {
    t.src !== "" && u(!0);
  }, [t.src]);
  const s = () => {
    const { onError: se } = t;
    (se ? se() : void 0) !== !1 && u(!1);
  }, {
    prefixCls: c,
    shape: d = "circle",
    size: p = "default",
    src: m,
    icon: E,
    className: y,
    alt: g,
    children: C,
    draggable: O,
    crossOrigin: N,
    srcSet: w,
    isOnline: _,
    presence: I,
    ...k
  } = t, H = v("avatar", c);
  v("avatar-wrap", c);
  const S = v("presence-tag", c), { theme: B } = Zn(Vn), D = B == null ? void 0 : B.mode, F = En({
    [`${H}-lg`]: p === "large",
    [`${H}-sm`]: p === "small"
  }), j = _t.isValidElement(m), G = En(
    H,
    F,
    {
      [`${H}-${d}`]: !!d,
      [`${H}-hasImage`]: typeof m == "string" && a && m !== "",
      [`${H}-icon`]: !!E,
      [`${H}-${D}`]: !!D
    },
    y
  ), U = typeof p == "number" ? {
    width: p,
    height: p,
    lineHeight: `${p}px`,
    fontSize: p / 2 - 4
  } : {};
  let M;
  typeof m == "string" && a && m !== "" ? M = /* @__PURE__ */ q.jsx("div", { className: `${H}-image`, children: /* @__PURE__ */ q.jsx(
    "img",
    {
      src: m,
      draggable: O,
      srcSet: w,
      onError: s,
      alt: g,
      crossOrigin: N
    }
  ) }) : j ? M = m : E ? M = E : typeof C == "string" ? M = /* @__PURE__ */ q.jsx("span", { className: `${H}-string`, ref: b, children: p < 20 ? C.slice(0, 1) : C.slice(0, 2) }) : M = /* @__PURE__ */ q.jsx("span", { className: `${H}-string`, ref: b, children: C });
  let V = "default";
  typeof p == "number" ? p >= 100 ? V = "large" : p <= 40 ? V = "small" : V = "default" : p === "large" ? V = "large" : p === "small" && (V = "small");
  const J = {
    large: 28,
    default: 16,
    small: 12
  }, ue = d === "circle" ? {
    width: J[V],
    height: J[V],
    padding: V === "large" ? 4 : 2,
    right: `calc(14.65% - ${J[V] / 2}px)`,
    bottom: `calc(14.65% - ${J[V] / 2}px)`
  } : {
    width: J[V],
    height: J[V],
    padding: V === "large" ? 4 : 2,
    right: V === "large" ? -4 : -2,
    bottom: V === "large" ? -4 : -2
  };
  return /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: G,
      ref: l,
      ...k,
      style: { ...U, ...k.style },
      children: [
        M,
        _ && /* @__PURE__ */ q.jsx("div", { className: `${S}-wrap`, children: /* @__PURE__ */ q.jsx("div", { className: S }) }),
        (I == null ? void 0 : I.visible) && /* @__PURE__ */ q.jsx(
          va,
          {
            title: I.text ? /* @__PURE__ */ q.jsx("div", { className: `${H}-presence-text`, children: I.text }) : null,
            placement: "bottom",
            children: /* @__PURE__ */ q.jsx("div", { className: `${H}-presence-wrap`, style: ue, children: _t.isValidElement(I.icon) ? I.icon : /* @__PURE__ */ q.jsx("img", { alt: I.text, src: I.icon }) })
          }
        )
      ]
    }
  );
}, qpe = _t.forwardRef(nG);
qpe.displayName = "Avatar";
const Kpe = (t) => {
  const { getPrefixCls: r } = _t.useContext(Hn), {
    children: a,
    className: u,
    prefixCls: h,
    shape: b = "circle",
    size: l = "default"
  } = t, v = r("avatar-group", h), s = En({
    [`${v}-lg`]: l === "large",
    [`${v}-sm`]: l === "small"
  }), c = typeof l == "number" ? {
    width: l,
    height: l,
    lineHeight: `${l}px`
  } : {};
  let d = _t.Children.map(
    a,
    (y, g) => Vl(y, {
      key: `avatar-key-${g}`,
      size: l,
      shape: b
    })
  );
  (d == null || typeof d > "u") && (d = []), d.length;
  const m = d.slice(0, 2), E = En(v, s, { [`${v}-${b}`]: !!b }, u);
  return /* @__PURE__ */ q.jsx("div", { className: E, style: { ...c, ...t.style }, children: m });
}, zs = nG;
zs.Group = Kpe;
zs.displayName = "Avatar";
function Jpe() {
  if (console && console.warn) {
    for (var t, r = arguments.length, a = new Array(r), u = 0; u < r; u++)
      a[u] = arguments[u];
    typeof a[0] == "string" && (a[0] = "react-i18next:: ".concat(a[0])), (t = console).warn.apply(t, a);
  }
}
var Wj = {};
function K2() {
  for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  typeof r[0] == "string" && Wj[r[0]] || (typeof r[0] == "string" && (Wj[r[0]] = /* @__PURE__ */ new Date()), Jpe.apply(void 0, r));
}
var rG = function(r, a) {
  return function() {
    if (r.isInitialized)
      a();
    else {
      var u = function h() {
        setTimeout(function() {
          r.off("initialized", h);
        }, 0), a();
      };
      r.on("initialized", u);
    }
  };
};
function qj(t, r, a) {
  t.loadNamespaces(r, rG(t, a));
}
function Kj(t, r, a, u) {
  typeof a == "string" && (a = [a]), a.forEach(function(h) {
    t.options.ns.indexOf(h) < 0 && t.options.ns.push(h);
  }), t.loadLanguages(r, rG(t, u));
}
function Zpe(t, r) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, u = r.languages[0], h = r.options ? r.options.fallbackLng : !1, b = r.languages[r.languages.length - 1];
  if (u.toLowerCase() === "cimode") return !0;
  var l = function(s, c) {
    var d = r.services.backendConnector.state["".concat(s, "|").concat(c)];
    return d === -1 || d === 2;
  };
  return a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !l(r.isLanguageChangingTo, t) ? !1 : !!(r.hasResourceBundle(u, t) || !r.services.backendConnector.backend || r.options.resources && !r.options.partialBundledLanguages || l(u, t) && (!h || l(b, t)));
}
function Qpe(t, r) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!r.languages || !r.languages.length)
    return K2("i18n.languages were undefined or empty", r.languages), !0;
  var u = r.options.ignoreJSONStructure !== void 0;
  return u ? r.hasLoadedNamespace(t, {
    lng: a.lng,
    precheck: function(b, l) {
      if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && b.services.backendConnector.backend && b.isLanguageChangingTo && !l(b.isLanguageChangingTo, t)) return !1;
    }
  }) : Zpe(t, r, a);
}
var $pe = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, ege = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, tge = function(r) {
  return ege[r];
}, nge = function(r) {
  return r.replace($pe, tge);
};
function Jj(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function Zj(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Jj(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : Jj(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
var J2 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: nge
};
function rge() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  J2 = Zj(Zj({}, J2), t);
}
function ige() {
  return J2;
}
var iG;
function sge(t) {
  iG = t;
}
function age() {
  return iG;
}
var oge = {
  type: "3rdParty",
  init: function(r) {
    rge(r.options.react), sge(r);
  }
}, cge = zce(), uge = function() {
  function t() {
    yo(this, t), this.usedNamespaces = {};
  }
  return vo(t, [{
    key: "addUsedNamespaces",
    value: function(a) {
      var u = this;
      a.forEach(function(h) {
        u.usedNamespaces[h] || (u.usedNamespaces[h] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), t;
}();
function Qj(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function DR(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Qj(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : Qj(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
var dge = function(r, a) {
  var u = er();
  return Pn(function() {
    u.current = r;
  }, [r, a]), u.current;
};
function Yr(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.i18n, u = Zn(cge) || {}, h = u.i18n, b = u.defaultNS, l = a || h || age();
  if (l && !l.reportNamespaces && (l.reportNamespaces = new uge()), !l) {
    K2("You will need to pass in an i18next instance by using initReactI18next");
    var v = function(B, D) {
      return typeof D == "string" ? D : D && as(D) === "object" && typeof D.defaultValue == "string" ? D.defaultValue : Array.isArray(B) ? B[B.length - 1] : B;
    }, s = [v, {}, !1];
    return s.t = v, s.i18n = {}, s.ready = !1, s;
  }
  l.options.react && l.options.react.wait !== void 0 && K2("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = DR(DR(DR({}, ige()), l.options.react), r), d = c.useSuspense, p = c.keyPrefix, m = b || l.options && l.options.defaultNS;
  m = typeof m == "string" ? [m] : m || ["translation"], l.reportNamespaces.addUsedNamespaces && l.reportNamespaces.addUsedNamespaces(m);
  var E = (l.isInitialized || l.initializedStoreOnce) && m.every(function(S) {
    return Qpe(S, l, c);
  });
  function y() {
    return l.getFixedT(r.lng || null, c.nsMode === "fallback" ? m : m[0], p);
  }
  var g = tn(y), C = ps(g, 2), O = C[0], N = C[1], w = m.join();
  r.lng && (w = "".concat(r.lng).concat(w));
  var _ = dge(w), I = er(!0);
  Pn(function() {
    var S = c.bindI18n, B = c.bindI18nStore;
    I.current = !0, !E && !d && (r.lng ? Kj(l, r.lng, m, function() {
      I.current && N(y);
    }) : qj(l, m, function() {
      I.current && N(y);
    })), E && _ && _ !== w && I.current && N(y);
    function D() {
      I.current && N(y);
    }
    return S && l && l.on(S, D), B && l && l.store.on(B, D), function() {
      I.current = !1, S && l && S.split(" ").forEach(function(F) {
        return l.off(F, D);
      }), B && l && B.split(" ").forEach(function(F) {
        return l.store.off(F, D);
      });
    };
  }, [l, w]);
  var k = er(!0);
  Pn(function() {
    I.current && !k.current && N(y), k.current = !1;
  }, [l, p]);
  var H = [O, l, E];
  if (H.t = O, H.i18n = l, H.ready = E, E || !E && !d) return H;
  throw new Promise(function(S) {
    r.lng ? Kj(l, r.lng, m, function() {
      return S();
    }) : qj(l, m, function() {
      return S();
    });
  });
}
if (!tn)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!ph)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function lge(t) {
  t();
}
function fge(t) {
  t || (t = lge, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), rfe({ reactionScheduler: t });
}
function hge(t) {
  return Xz(t);
}
var pge = 1e4, gge = 1e4, mge = (
  /** @class */
  function() {
    function t(r) {
      var a = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(u) {
          u === void 0 && (u = pge), clearTimeout(a.sweepTimeout), a.sweepTimeout = void 0;
          var h = Date.now();
          a.registrations.forEach(function(b, l) {
            h - b.registeredAt >= u && (a.finalize(b.value), a.registrations.delete(l));
          }), a.registrations.size > 0 && a.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          a.sweep(0);
        }
      });
    }
    return Object.defineProperty(t.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(r, a, u) {
        this.registrations.set(u, {
          value: a,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(t.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(r) {
        this.registrations.delete(r);
      }
    }), Object.defineProperty(t.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, gge));
      }
    }), t;
  }()
), Ege = typeof FinalizationRegistry < "u" ? FinalizationRegistry : mge, Z2 = new Ege(function(t) {
  var r;
  (r = t.reaction) === null || r === void 0 || r.dispose(), t.reaction = null;
}), $j = function(t, r) {
  var a = typeof Symbol == "function" && t[Symbol.iterator];
  if (!a) return t;
  var u = a.call(t), h, b = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(h = u.next()).done; ) b.push(h.value);
  } catch (v) {
    l = { error: v };
  } finally {
    try {
      h && !h.done && (a = u.return) && a.call(u);
    } finally {
      if (l) throw l.error;
    }
  }
  return b;
};
function eU(t) {
  return "observer".concat(t);
}
var yge = (
  /** @class */
  /* @__PURE__ */ function() {
    function t() {
    }
    return t;
  }()
);
function vge() {
  return new yge();
}
function Tge(t, r) {
  r === void 0 && (r = "observed");
  var a = $j(_t.useState(vge), 1), u = a[0], h = $j(_t.useState(), 2), b = h[1], l = function() {
    return b([]);
  }, v = _t.useRef(null);
  v.current || (v.current = {
    reaction: null,
    mounted: !1,
    changedBeforeMount: !1
  });
  var s = v.current;
  s.reaction || (s.reaction = new pm(eU(r), function() {
    s.mounted ? l() : s.changedBeforeMount = !0;
  }), Z2.register(u, s, s)), _t.useDebugValue(s.reaction, hge), _t.useEffect(function() {
    return Z2.unregister(s), s.mounted = !0, s.reaction ? s.changedBeforeMount && (s.changedBeforeMount = !1, l()) : (s.reaction = new pm(eU(r), function() {
      l();
    }), l()), function() {
      s.reaction.dispose(), s.reaction = null, s.mounted = !1, s.changedBeforeMount = !1;
    };
  }, []);
  var c, d;
  if (s.reaction.track(function() {
    try {
      c = t();
    } catch (p) {
      d = p;
    }
  }), d)
    throw d;
  return c;
}
var bge = !0, sG = typeof Symbol == "function" && Symbol.for, tU = sG ? Symbol.for("react.forward_ref") : typeof Gu == "function" && Gu(function(t) {
  return null;
}).$$typeof, nU = sG ? Symbol.for("react.memo") : typeof Pd == "function" && Pd(function(t) {
  return null;
}).$$typeof;
function mi(t, r) {
  var a;
  if (process.env.NODE_ENV, nU && t.$$typeof === nU)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var u = (a = void 0) !== null && a !== void 0 ? a : !1, h = t, b = t.displayName || t.name;
  if (tU && t.$$typeof === tU && (u = !0, h = t.render, typeof h != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var l = function(v, s) {
    return Tge(function() {
      return h(v, s);
    }, b);
  };
  return b !== "" && (l.displayName = b), t.contextTypes && (l.contextTypes = t.contextTypes), u && (l = Gu(l)), l = Pd(l), Oge(t, l), process.env.NODE_ENV !== "production" && Object.defineProperty(l, "contextTypes", {
    set: function() {
      var v;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((v = this.type) === null || v === void 0 ? void 0 : v.displayName) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), l;
}
var Age = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function Oge(t, r) {
  Object.keys(t).forEach(function(a) {
    Age[a] || Object.defineProperty(r, a, Object.getOwnPropertyDescriptor(t, a));
  });
}
process.env.NODE_ENV;
var MR;
fge(nz);
MR = Z2.finalizeAllImmediately;
const Q2 = "@", bw = new RegExp(`${Q2}([^${Q2}\\s]*)$`), Aw = () => {
  const t = window.getSelection();
  return t == null ? void 0 : t.focusOffset;
}, Ow = () => {
  const t = window.getSelection();
  return t == null ? void 0 : t.focusNode;
}, Cge = () => {
  var h;
  const t = window.getSelection(), a = ((h = t == null ? void 0 : t.getRangeAt) == null ? void 0 : h.call(t, 0)).getClientRects()[0];
  return {
    x: a.x,
    y: a.y + 0
  };
}, Sge = () => {
  const t = Ow();
  if (!t || t.nodeType !== Node.TEXT_NODE) return !1;
  const r = t.textContent || "", u = bw.exec(r.slice(0, Aw()));
  return u && u.length === 2;
}, Ige = () => {
  var u;
  const t = ((u = Ow()) == null ? void 0 : u.textContent) || "", a = bw.exec(t.slice(0, Aw()));
  if (a && a.length === 2)
    return a[1];
}, Rge = (t) => {
  const r = document.createElement("span");
  r.style.display = "inline-block", r.dataset.user = t.userId, r.className = "at-button", r.contentEditable = "false", r.textContent = `${Q2}${ah(t)}`;
  const a = document.createElement("span");
  a.style.display = "inline-block", a.contentEditable = "false";
  const u = document.createElement("span");
  u.style.whiteSpace = "pre", u.textContent = "​", u.contentEditable = "false";
  const h = u.cloneNode(!0);
  return a.appendChild(u), a.appendChild(r), a.appendChild(h), a;
}, Nge = (t, r) => t.replace(bw, r), wge = (t) => {
  const r = Ow();
  if (r) {
    const a = (r == null ? void 0 : r.textContent) || "", u = Aw(), h = Nge(a.slice(0, u), ""), b = a.slice(u), l = r == null ? void 0 : r.parentNode, v = r == null ? void 0 : r.nextSibling, s = new Text(h), c = new Text("​" + b), d = Rge(t);
    l.removeChild(r), v ? (l.insertBefore(s, v), l.insertBefore(d, v), l.append(" "), l.insertBefore(c, v)) : (l.appendChild(s), l.appendChild(d), l.append(" "), l.appendChild(c)), setTimeout(() => {
      const p = new Range();
      p.setStart(c, 0), p.setEnd(c, 0);
      const m = window.getSelection();
      m == null || m.removeAllRanges(), m == null || m.addRange(p);
    }, 10);
  }
}, rU = () => {
  const t = navigator.userAgent;
  if (/^((?!chrome|android).)*safari/i.test(t)) {
    const a = t.match(/Version\/(\d+(\.\d+)?)/);
    if (a && a[1])
      return parseFloat(a[1]) > 17;
  }
  return !1;
}, ym = "ALL", _ge = (t, r) => r ? t.filter((a) => ah(a).startsWith(r)) : t.slice(0), Pge = (t) => {
  var H;
  const { t: r } = Yr(), { getPrefixCls: a } = _t.useContext(Hn), u = _t.useContext(Vn), { theme: h } = u, b = (h == null ? void 0 : h.mode) || "light", l = a("suggest"), v = a("suggest-list"), s = En(
    l,
    {
      [`${l}-${b}`]: !!b
    },
    t.className
  ), [c, d] = tn(-1), p = er(), m = er(null), E = er();
  E.current = c;
  const y = er();
  y.current = t.visible;
  const { style: g = {} } = t, C = gr().messageStore.currentCVS, O = gr().client, N = ((H = jd(C.conversationId)) == null ? void 0 : H.members) || [], w = (S) => {
    d(Number(S.target.dataset.idx));
  }, _ = (S) => {
    var B, D;
    E.current !== void 0 && ((B = p.current) != null && B[E.current]) && (t.onPickUser((D = p.current) == null ? void 0 : D[E.current]), d(-1));
  }, I = {
    userId: ym,
    role: null,
    attributes: {
      nickName: r("atAll")
    }
  }, k = Wy(() => _ge(
    [I, ...N].filter((S) => S.userId !== O.user),
    t.queryString
  ), [N, t.queryString]);
  return p.current = k, Pn(() => {
    d(0), k.length || t.onHide();
  }, [k]), Pn(() => {
    var S, B, D;
    (D = (B = (S = m == null ? void 0 : m.current) == null ? void 0 : S.getElementsByClassName("active")) == null ? void 0 : B[0]) == null || D.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [c]), Pn(() => {
    const S = (B) => {
      var D, F;
      if (y.current) {
        if (B.code === "Escape") {
          t.onHide();
          return;
        }
        if (B.code === "ArrowDown") {
          d((j) => {
            var G;
            return Math.min(j + 1, (((G = p.current) == null ? void 0 : G.length) || 0) - 1);
          });
          return;
        }
        if (B.code === "ArrowUp") {
          d((j) => Math.max(0, j - 1));
          return;
        }
        if (B.code === "Enter") {
          E.current !== void 0 && ((D = p.current) != null && D[E.current]) && (t.onPickUser((F = p.current) == null ? void 0 : F[E.current]), d(-1));
          return;
        }
      }
    };
    return document.addEventListener("keyup", S), () => {
      document.removeEventListener("keyup", S);
    };
  }, []), /* @__PURE__ */ q.jsx("div", { children: t.visible && k.length ? /* @__PURE__ */ q.jsx(
    "div",
    {
      className: s,
      ref: m,
      style: {
        bottom: `calc(100% - ${t.position.y}px)`,
        left: t.position.x,
        ...g
      },
      children: /* @__PURE__ */ q.jsx("div", { className: v, children: k.map((S, B) => /* @__PURE__ */ q.jsxs(
        "div",
        {
          style: { userSelect: "none" },
          "data-idx": B,
          className: B === c ? `active ${l}-item` : `${l}-item`,
          onMouseEnter: w,
          onMouseDown: rU() ? _ : () => {
          },
          onClick: rU() ? () => {
          } : _,
          children: [
            /* @__PURE__ */ q.jsx("div", { className: "avatar", style: { userSelect: "none" }, children: /* @__PURE__ */ q.jsx(zs, { src: Lme(S.userId).avatarurl, size: "small", children: S.role === null && S.userId === ym ? /* @__PURE__ */ q.jsx(
              pn,
              {
                type: "MEMBER_GROUP",
                style: { verticalAlign: "sub", width: "15px", height: "15px" }
              }
            ) : ah(S) }) }),
            /* @__PURE__ */ q.jsx("div", { className: "name", children: ah(S) })
          ]
        },
        S.userId
      )) })
    }
  ) : null });
}, xge = mi(Pge);
class Jp {
  constructor() {
    this.handlerData = {}, this.handlerData = {};
  }
  static getInstance() {
    return Jp.instance || (Jp.instance = new Jp()), Jp.instance;
  }
  addEventHandler(r, a) {
    this.handlerData[r] = a;
  }
  removeEventHandler(r) {
    delete this.handlerData[r];
  }
  dispatchSuccess(r) {
    Object.keys(this.handlerData).forEach((a) => {
      var u, h, b, l;
      (u = this.handlerData[a]) != null && u[r] && ((h = this.handlerData[a][r]) != null && h.success) && ((l = (b = this.handlerData[a][r]) == null ? void 0 : b.success) == null || l.call(b));
    });
  }
  dispatchError(r, a) {
    Object.keys(this.handlerData).forEach((u) => {
      var h, b, l, v, s, c;
      (h = this.handlerData[u]) != null && h[r] && ((b = this.handlerData[u][r]) != null && b.error) && ((v = (l = this.handlerData[u][r]) == null ? void 0 : l.error) == null || v.call(l, a)), (c = (s = this.handlerData[u]) == null ? void 0 : s.onError) == null || c.call(s, a), console.error(a);
    });
  }
}
const mn = Jp.getInstance();
class $2 {
  constructor(r) {
    const { message: a, time: u, noticeType: h, ext: b, type: l = "notice" } = r;
    this.id = Date.now().toString(), this.time = u, this.type = l, this.message = a, this.noticeType = h, this.ext = b || {};
  }
}
const Dge = (t) => {
  var m, E, y, g, C, O, N;
  const { t: r } = Yr(), { prefix: a, className: u } = t, { getPrefixCls: h } = _t.useContext(Hn), b = h("message-notice", a), { noticeMessage: l, style: v = {} } = t;
  let { message: s, time: c } = l;
  const d = En(b, u), p = Zt.client.user;
  switch (l.noticeType) {
    case "recall":
      p == ((m = l.ext) == null ? void 0 : m.from) ? s = r("you") + " " + r("unsentAMessage") : s = Bu(l.ext) + " " + r("unsentAMessage");
      break;
    case "pin":
      s = `${Bu({
        from: (E = l.ext) == null ? void 0 : E.operatorId,
        chatType: (y = l.ext) == null ? void 0 : y.conversationType,
        to: (g = l.ext) == null ? void 0 : g.conversationId
      })} ${r("pinned a message")}`;
      break;
    case "unpin":
      s = `${Bu({
        from: (C = l.ext) == null ? void 0 : C.operatorId,
        chatType: (O = l.ext) == null ? void 0 : O.conversationType,
        to: (N = l.ext) == null ? void 0 : N.conversationId
      })} ${r("removed a pin message")}`;
      break;
  }
  return /* @__PURE__ */ q.jsxs("div", { className: d, style: { ...v }, children: [
    /* @__PURE__ */ q.jsx("span", { children: s }),
    /* @__PURE__ */ q.jsx("span", { children: Tm(c) })
  ] });
}, eN = {};
function Mge(t, r) {
  eN[`${t}${r}`] = !1;
}
const Lge = (t) => {
  const r = Zn(Vn).rootStore, { client: a, messageStore: u } = r, [h, b] = tn([]), [l, v] = tn(-1), [s, c] = tn(!1), d = 25;
  return Pn(() => {
    var O, N;
    if (!t.conversationId) {
      console.warn("Invalid conversationId:", t);
      return;
    }
    const m = u.message[t.chatType][t.conversationId] || [];
    if (m.length > 0 && (l === -1 || l != m[0].id) && eN[`${t.chatType}${t.conversationId}`])
      return b(m);
    const E = (N = (O = r.client) == null ? void 0 : O.context) == null ? void 0 : N.userId;
    if (!E) return;
    const y = h[0] || {}, g = y.chatType == "groupChat" || y.from == E ? y.to : y.from;
    let C = l;
    if (t.conversationId != g && (C = -1), m.length > 0) {
      const w = m.find((_) => _.type !== "notice" && _.type !== "recall");
      w && (C = w.mid || w.id);
    }
    c(!0), r.loginState && a.getHistoryMessages({
      targetId: t.conversationId,
      cursor: C,
      pageSize: d,
      chatType: t.chatType,
      searchDirection: "up"
    }).then((w) => {
      eN[`${t.chatType}${t.conversationId}`] = !0;
      let _ = w.messages.reverse();
      if (_.length > 0) {
        let I = !1;
        const k = u.message[t.chatType][t.conversationId] || [];
        if (k.forEach((H) => {
          H.id == _[0].id && (I = !0);
        }), I) return;
        b(_), _ = _.filter((H) => {
          var S;
          return !((S = k == null ? void 0 : k.find) != null && S.call(k, (B) => B.id === H.id || B.mid === H.id));
        }), u.addHistoryMsgs(t, _);
      }
      c(!1);
    }).catch((w) => {
      console.warn("get history messages failed", w), c(!1);
    });
  }, [t.conversationId, l]), { historyMsgs: h, loadMore: () => {
    var O, N;
    const m = u.message[t.chatType][t.conversationId] || [];
    let E = ((O = m[0]) == null ? void 0 : O.mid) || ((N = m[0]) == null ? void 0 : N.id) || -1;
    const y = m[0] || {}, g = r.client.context.userId, C = y.chatType == "groupChat" || y.from == g ? y.to : y.from;
    t.conversationId != C && (E = -1), v(E);
  }, isLoading: s };
};
let LR = null;
class kge {
  constructor(r) {
    this.rootStore = r, this.message = {
      singleChat: {},
      groupChat: {},
      chatRoom: {},
      byId: /* @__PURE__ */ new Map(),
      broadcast: []
    }, this.selectedMessage = {
      singleChat: {},
      groupChat: {}
      // chatRoom: {},
    }, this.currentCVS = {}, this.repliedMessage = null, this.typing = {}, this.holding = !1, this.unreadMessageCount = 0, ph(this, {
      currentCVS: Ar,
      message: Ar,
      selectedMessage: Ar,
      repliedMessage: Ar,
      typing: Ar,
      unreadMessageCount: Ar,
      setCurrentCVS: Sn,
      currentCvsMsgs: mv,
      sendMessage: Sn,
      receiveMessage: Sn,
      modifyMessage: Sn,
      sendChannelAck: Sn,
      updateMessageStatus: Sn,
      clearMessage: Sn,
      setRepliedMessage: Sn,
      addReaction: Sn,
      updateReactions: Sn,
      recallMessage: Sn,
      modifyLocalMessage: Sn,
      modifyServerMessage: Sn,
      translateMessage: Sn,
      setSelectedMessage: Sn,
      setTyping: Sn,
      sendTypingCmd: Sn,
      clear: Sn,
      deleteMessage: Sn,
      setHoldingStatus: Sn,
      setUnreadMessageCount: Sn,
      shiftBroadcastMessage: Sn,
      setKeyValue: Sn
    }), Fz(() => {
    });
  }
  get currentCvsMsgs() {
    const { conversationId: r, chatType: a } = this.currentCVS;
    return !r || !a ? (console.warn("No specified conversation."), []) : this.message[a][r] || [];
  }
  setKeyValue(r, a) {
    const u = this.rootStore.initConfig.maxMessages || 200;
    if (this.message.byId.size >= u) {
      const h = this.message.byId.keys().next().value || "";
      this.message.byId.delete(h);
    }
    this.message.byId.set(r, a);
  }
  setCurrentCVS(r) {
    this.currentCVS = r;
  }
  sendMessage(r) {
    var l, v, s, c, d, p, m, E;
    if (!r)
      throw new Error("no message");
    const { to: a, chatType: u } = r;
    if (r.bySelf = !0, r.mid = "", r.from = (v = (l = this.rootStore.client) == null ? void 0 : l.context) == null ? void 0 : v.userId, ((s = this.message.byId.get(r.id)) == null ? void 0 : s.status) !== "failed" && (r.status = "sending"), this.repliedMessage != null && r.type != "read" && r.type != "delivery" && r.type != "channel") {
      const y = r.ext || {};
      let g = "";
      switch (this.repliedMessage.type) {
        case "txt":
          g = this.repliedMessage.msg;
          break;
        case "img":
          g = "[Image]";
          break;
        case "audio":
          g = "[Voice]";
          break;
        case "video":
          g = "[Video]";
          break;
        case "file":
          g = "[File]";
          break;
        case "custom":
          g = "[Custom]";
          break;
        default:
          g = "[unknown]";
          break;
      }
      y.msgQuote = {
        // @ts-ignore
        msgID: this.repliedMessage.mid || this.repliedMessage.id,
        msgPreview: g,
        msgSender: Bu(this.repliedMessage) || ((d = (c = this.rootStore) == null ? void 0 : c.client) == null ? void 0 : d.user),
        msgType: this.repliedMessage.type
      }, r.ext = y;
    }
    if (r.isChatThread) {
      const { currentThread: y } = this.rootStore.threadStore;
      r.chatThread = {
        parentId: ((p = y.info) == null ? void 0 : p.parentId) || y.originalMessage.to
      };
    }
    const h = this.rootStore.addressStore.appUsersInfo[this.rootStore.client.user] || {};
    if (u === "chatRoom")
      r.ext = {
        ...r.ext,
        chatroom_uikit_userInfo: {
          userId: h == null ? void 0 : h.userId,
          nickname: h == null ? void 0 : h.nickname,
          avatarURL: h == null ? void 0 : h.avatarurl,
          gender: Number(h == null ? void 0 : h.gender),
          identify: (m = h == null ? void 0 : h.ext) == null ? void 0 : m.identify
        }
      };
    else {
      if (u == "groupChat") {
        const y = jd(a);
        if (y) {
          const g = aA(y, this.rootStore.client.user) ?? -1;
          if (g > -1) {
            const C = ((E = y == null ? void 0 : y.members) == null ? void 0 : E[g]) || { userId: "", role: "member" };
            h.nickname = ah(C);
          }
        }
      }
      r.ext = {
        ...r.ext,
        ease_chat_uikit_user_info: {
          nickname: h == null ? void 0 : h.nickname,
          avatarURL: h == null ? void 0 : h.avatarurl
        }
      };
    }
    let b = this.message.byId.get(r.id);
    return r.type != "read" && r.type != "delivery" && r.type != "channel" && (b || (this.setKeyValue(r.id, r), b = r)), u !== "chatRoom" && (this.message[u][a] ? b.status !== "failed" && this.message[u][a].push(b) : this.message[u][a] = [b]), this.repliedMessage != null && this.setRepliedMessage(null), this.rootStore.client.send(r).then((y) => {
      const g = this.message.byId.get(r.id);
      u == "chatRoom" && (this.message[u][a] ? this.message.byId.get(r.id).status !== "failed" && qi(() => {
        this.message[u][a].push(g);
      }) : qi(() => {
        this.message[u][a] = [g];
      }));
      const C = g || {};
      if (C.status = "sent", C.mid = y.serverMsgId, r.type == "combine") {
        let N = 0;
        r.messageList.forEach((w) => {
          w.combineLevel > N && (N = w.combineLevel);
        }), C.combineLevel = N + 1;
      }
      r.url && (r.type === "video" && (C.thumb = r.thumb), C.url = r.url, C.file && (C.file.url = r.url || "")), qi(() => {
        var I;
        const N = this.message.byId.get(r.id);
        this.setKeyValue(y.serverMsgId, N);
        const w = this.message.byId.get(r.id);
        w.status = "sent", w.mid = y.serverMsgId;
        const _ = (I = this.message[u][a]) == null ? void 0 : I.findIndex((k) => {
          if (k.id === y.serverMsgId || r.id === k.id)
            return !0;
        });
        this.message[u][a].splice(_, 1, C);
      });
      let O = this.rootStore.conversationStore.getConversation(
        // @ts-ignore
        r.chatType,
        a
      );
      if (!r.isChatThread) {
        if (!O) {
          O = {
            // @ts-ignore
            chatType: r.chatType,
            conversationId: r.to,
            lastMessage: r,
            unreadCount: 0
          }, this.rootStore.conversationStore.addConversation(O);
          return;
        }
        O.lastMessage = r, this.rootStore.conversationStore.modifyConversation({ ...O }), mn.dispatchSuccess("sendMessage");
      }
    }).catch((y) => {
      this.updateMessageStatus(r.id, "failed"), mn.dispatchError("sendMessage", y);
    });
  }
  receiveMessage(r) {
    var s, c, d;
    const a = this.rootStore.conversationStore.currentCvs, u = ar(r);
    if (a && a.chatType === r.chatType && a.conversationId === u && r.chatType != "chatRoom" && (LR && clearTimeout(LR), LR = setTimeout(() => {
      this.sendChannelAck(a);
    }, 1e3)), ((c = (s = r.from) == null ? void 0 : s.includes) == null ? void 0 : c.call(s, "chatbot_")) && (r.printed = !1), this.setKeyValue(r.id, r), r.from !== this.rootStore.client.user ? r.bySelf = !1 : r.bySelf = !0, r.broadcast) {
      this.message.broadcast.push(r);
      return;
    }
    if (!this.message[r.chatType][u])
      this.message[r.chatType][u] = [r];
    else {
      const p = this.rootStore.initConfig.maxMessages || 200;
      this.message[r.chatType][u].length > p && (this.message[r.chatType][u].splice(
        0,
        this.message[r.chatType][u].length - p
      ), Mge(r.chatType, u)), this.message[r.chatType][u].push(r);
    }
    if (this.holding && this.currentCVS.conversationId == u && (this.unreadMessageCount += 1), r.isChatThread || r.chatThread || r.type === "cmd")
      return;
    if (r.chatType == "chatRoom") {
      const p = r.ext || {}, m = typeof p.chatroom_uikit_userInfo == "string" ? JSON.parse(p.chatroom_uikit_userInfo) : p.chatroom_uikit_userInfo || {}, E = this.rootStore.addressStore.appUsersInfo;
      this.rootStore.addressStore.setAppUserInfo({
        ...E,
        [m.userId]: {
          nickname: m.nickname,
          userId: m.userId,
          avatarurl: m.avatarURL,
          gender: m.gender
        }
      });
      return;
    }
    if (r.ext && r.ext.ease_chat_uikit_user_info) {
      const p = this.rootStore.addressStore.appUsersInfo;
      r.from && p[r.from] == null && this.rootStore.addressStore.setAppUserInfo({
        ...p,
        [r.from]: {
          nickname: r.ext.ease_chat_uikit_user_info.nickname,
          userId: r.from,
          avatarurl: r.ext.ease_chat_uikit_user_info.avatarURL
        }
      });
    }
    const b = (
      // @ts-ignore
      this.currentCVS.chatType == r.chatType && this.currentCVS.conversationId == u
    );
    let l = this.rootStore.conversationStore.getConversation(
      // @ts-ignore
      r.chatType,
      u
    );
    if (!l) {
      let p = "";
      this.rootStore.addressStore.groups.forEach((E) => {
        u == E.groupid && (p = E.groupname);
      }), l = {
        // @ts-ignore
        chatType: r.chatType,
        conversationId: u,
        lastMessage: r,
        unreadCount: b ? 0 : 1,
        name: p
      }, this.rootStore.conversationStore.addConversation(l);
      return;
    }
    if (l.lastMessage.time < r.time && !b && (l.unreadCount = l.unreadCount + 1), l.lastMessage = r, this.rootStore.conversationStore.topConversation({ ...l }), !b && r.type === "txt") {
      const p = (d = r == null ? void 0 : r.ext) == null ? void 0 : d.em_at_list;
      p && r.from !== this.rootStore.client.user && (p === ym || p.includes(this.rootStore.client.user)) && this.rootStore.conversationStore.setAtType(
        l.chatType,
        l.conversationId,
        p === ym ? "ALL" : "ME"
      );
    }
  }
  modifyMessage(r, a) {
    this.setKeyValue(r, a);
  }
  sendChannelAck(r) {
    const a = Zs.message.create({
      type: "channel",
      chatType: r.chatType,
      to: r.conversationId
    });
    return this.rootStore.client.send(a);
  }
  updateMessageStatus(r, a) {
    setTimeout(() => {
      qi(() => {
        var l;
        const u = this.message.byId.get(r);
        if (!u)
          return;
        const h = ar(u);
        u.status = a;
        const b = (l = this.message[u.chatType][h]) == null ? void 0 : l.indexOf(u);
        typeof b > "u" || b == -1 || this.message[u.chatType][h].splice(b, 1, u);
      });
    }, 10);
  }
  addHistoryMsgs(r, a) {
    var u, h;
    !r || !a.length || ((u = this.message[r.chatType]) != null && u[r.conversationId] ? this.message[r.chatType][r.conversationId] = a.concat(
      ((h = this.message[r.chatType]) == null ? void 0 : h[r.conversationId]) || []
    ) : this.message[r.chatType][r.conversationId] = a);
  }
  clearMessage(r) {
    r && (this.rootStore.client.removeHistoryMessages({
      targetId: r.conversationId,
      chatType: r.chatType,
      beforeTimeStamp: Date.now()
    }), this.message[r.chatType][r.conversationId] = []);
  }
  setRepliedMessage(r) {
    typeof r > "u" || (this.repliedMessage = r);
  }
  deleteMessage(r, a) {
    if (!r || !a)
      throw new Error("deleteMessage params error");
    let u = [];
    Array.isArray(a) ? u = a : u = [a];
    const h = [];
    u = u.filter((l) => (l.length < 13 && h.push(l), l.length > 13));
    const b = (l) => {
      const s = this.message[r.chatType][r.conversationId].filter((c) => !l.includes(c.id) && !l.includes(c.mid));
      qi(() => {
        this.message[r.chatType][r.conversationId] = s;
      });
    };
    return h.length > 0 ? b(h) : this.rootStore.client.removeHistoryMessages({
      targetId: r.conversationId,
      chatType: r.chatType,
      messageIds: u
    }).then(() => {
      b(u);
      const l = this.rootStore.conversationStore.getConversation(
        // @ts-ignore
        r.chatType,
        r.conversationId
      );
      l.lastMessage = {}, this.rootStore.conversationStore.modifyConversation(l), mn.dispatchSuccess("removeHistoryMessages");
    }).catch((l) => {
      mn.dispatchError("removeHistoryMessages", l);
    });
  }
  recallMessage(r, a, u = !1, h = !1) {
    if (!r || !a)
      throw new Error("recallMessage params error");
    let b = this.rootStore.conversationStore.getConversation(
      // @ts-ignore
      r.chatType,
      r.conversationId
    );
    !b && r.chatType == "groupChat" && (b = this.rootStore.conversationStore.getConversation(
      // @ts-ignore
      "chatRoom",
      r.conversationId
    ));
    const l = qf(b);
    if (!l) return;
    const v = Kf(l, a);
    if (!h) {
      if (v > -1) {
        const s = Date.now(), c = new $2({
          time: s,
          type: "recall",
          noticeType: "recall",
          ext: { ...l[v] }
        });
        l[v] = c;
      }
      if (!b) return;
      b.lastMessage = l[v], b.unreadCount > 0 && (b.unreadCount -= 1), this.rootStore.pinnedMessagesStore.deletePinnedMessage(
        b.chatType,
        b.conversationId,
        a
      ), this.rootStore.conversationStore.modifyConversation(b);
      return;
    }
    return this.rootStore.client.recallMessage({
      chatType: r.chatType,
      to: r.conversationId,
      mid: a,
      isChatThread: u
    }).then(() => {
      const s = qf(r), c = Kf(s, a);
      if (c > -1) {
        const d = Date.now(), p = new $2({
          time: d,
          type: "recall",
          noticeType: "recall",
          ext: { ...s[c] }
        });
        if (s[c] = p, !b) return;
        b.lastMessage = s[c], this.rootStore.conversationStore.modifyConversation(b), this.rootStore.pinnedMessagesStore.deletePinnedMessage(
          b.chatType,
          b.conversationId,
          a
        ), mn.dispatchSuccess("recallMessage");
      }
    }).catch((s) => {
      mn.dispatchError("recallMessage", s);
    });
  }
  addReaction(r, a, u) {
    if (!(!r || !a || !u))
      return this.rootStore.client.addReaction({
        messageId: a,
        reaction: u
      }).then(() => {
        const h = qf(r), b = Kf(h, a);
        b > -1 && qi(() => {
          const l = h[b], v = UR(l, u);
          if (v)
            v.count += 1, v.isAddedBySelf = !0, v.userList.unshift(this.rootStore.client.user);
          else {
            const s = {
              count: 1,
              isAddedBySelf: !0,
              reaction: u,
              userList: [this.rootStore.client.user]
            };
            Array.isArray(l.reactions) ? h[b].reactions.push(s) : h[b].reactions = [s];
          }
        }), mn.dispatchSuccess("addReaction");
      }).catch((h) => {
        mn.dispatchError("addReaction", h);
      });
  }
  deleteReaction(r, a, u) {
    if (!r || !a || !u)
      throw new Error("deleteReaction params error");
    return this.rootStore.client.deleteReaction({
      messageId: a,
      reaction: encodeURIComponent(u)
    }).then(() => {
      var l, v, s;
      const h = qf(r), b = Kf(h, a);
      if (b > -1) {
        const c = h[b], d = UR(c, u);
        if (d) {
          d.count -= 1, d.count <= 0 && ((v = c.reactions) == null || v.splice(
            // @ts-ignore
            (l = c.reactions) == null ? void 0 : l.indexOf(d),
            1
          ));
          const p = (s = d.userList) == null ? void 0 : s.indexOf(this.rootStore.client.user);
          p > -1 && d.userList.splice(p, 1);
        }
      }
      mn.dispatchSuccess("deleteReaction");
    }).catch((h) => {
      mn.dispatchError("deleteReaction", h);
    });
  }
  updateReactions(r, a, u) {
    var v;
    if (!r || !a) return;
    const h = qf(r), b = Kf(h, a), l = u.filter((s) => {
      var c, d;
      return ((c = s.op) == null ? void 0 : c.length) && ((d = s.op) == null ? void 0 : d.length) > 0;
    });
    if (b > -1) {
      const s = h[b];
      !s.reactions || ((v = s.reactions) == null ? void 0 : v.length) === 0 ? (u.forEach((c) => {
        var d;
        c.op && (c.isAddedBySelf = !!((d = c == null ? void 0 : c.op) != null && d.find(
          (p) => p.operator === this.rootStore.client.user && p.reactionType === "create"
        )));
      }), s.reactions = u) : l.forEach((c) => {
        var p, m;
        const d = UR(s, c.reaction);
        d ? (d.count = c.count, d.userList = c.userList, d.op = c.op, (p = c == null ? void 0 : c.op) == null || p.forEach((E) => {
          E.operator === this.rootStore.client.user && (E.reactionType === "create" ? d.isAddedBySelf = !0 : d.isAddedBySelf = !1);
        }), s.reactions = [...s.reactions]) : (c.isAddedBySelf = !!((m = c == null ? void 0 : c.op) != null && m.find(
          (E) => E.operator === this.rootStore.client.user && E.reactionType === "create"
        )), s.reactions.push(c));
      });
    }
  }
  getReactionUserList(r, a, u) {
    if (!(!r || !a))
      return this.rootStore.client.getReactionDetail({
        messageId: a,
        reaction: u,
        pageSize: 100
      }).then((h) => {
        const b = h.data, l = qf(r), v = Kf(l, a);
        if (b) {
          if (v > -1) {
            const s = l[v];
            s.reactions.userList = b.userList;
          }
          mn.dispatchSuccess("getReactionDetail");
        }
      }).catch((h) => {
        mn.dispatchError("getReactionDetail", h);
      });
  }
  translateMessage(r, a, u) {
    if (!r || !a)
      throw new Error("translateMessage params error");
    const h = qf(r), b = Kf(h, a);
    return new Promise((l, v) => {
      if (b > -1) {
        const s = h[b];
        if (s.type !== "txt")
          return v(!1), console.warn("message type is not txt");
        this.rootStore.client.translateMessage({
          text: s.msg,
          languages: [u]
        }).then((c) => {
          var d;
          if (c.type == 0) {
            const p = (d = c.data[0]) == null ? void 0 : d.translations;
            s.translations = p;
          }
          l(!0), mn.dispatchSuccess("translateMessage");
        }).catch((c) => {
          v(!1), mn.dispatchError("translateMessage", c);
        });
      }
    });
  }
  modifyLocalMessage(r, a, u) {
    if (a.chatType !== "chatRoom") {
      let h = "";
      u ? h = a.chatType === "groupChat" ? a.to : a.from || "" : h = a.to, this.rootStore.pinnedMessagesStore.modifyPinnedMessage(a.chatType, h, a);
      const b = this.message[a.chatType][h].findIndex(
        //@ts-ignore
        (l) => l.id === r || l.mid === r
      );
      if (b > -1) {
        const l = this.message[a.chatType][h][b];
        a.type === "txt" && l.type === "txt" && (l.msg = a.msg, l.modifiedInfo = a.modifiedInfo, l.translations = void 0), a.type === "custom" && l.type === "custom" && (l.customEvent = a.customEvent, l.modifiedInfo = a.modifiedInfo, l.customExts = a.customExts, l.ext = a.ext);
      }
    }
  }
  modifyServerMessage(r, a) {
    if (!r || !a)
      throw new Error("modifyServerMessage params error");
    const { client: u } = this.rootStore;
    return u.modifyMessage({
      messageId: r,
      modifiedMessage: a
    }).then((h) => {
      this.modifyLocalMessage(r, h.message), mn.dispatchSuccess("modifyMessage");
    }).catch((h) => {
      mn.dispatchError("modifyMessage", h);
    });
  }
  setSelectedMessage(r, a) {
    this.selectedMessage[r.chatType][r.conversationId] = a;
  }
  setTyping(r, a) {
    if (r.chatType !== "singleChat") return console.warn("typing is only for singleChat");
    this.typing[r.conversationId] = a;
  }
  sendTypingCmd(r) {
    const a = {
      chatType: r.chatType,
      to: r.conversationId,
      type: "cmd",
      isChatThread: !1,
      action: "TypingBegin"
    }, u = Zs.message.create(a);
    this.rootStore.client.send(u).then(() => {
    }).catch((h) => {
      mn.dispatchError("sendMessage", h);
    });
  }
  setHoldingStatus(r) {
    this.holding = r;
  }
  setUnreadMessageCount(r) {
    this.unreadMessageCount = r;
  }
  shiftBroadcastMessage() {
    this.message.broadcast.shift();
  }
  sendReadAck(r, a) {
    if (!r || !a)
      return console.error(`Invalid parameter, messageId: ${r}, to: ${a}`);
    const u = Zs.message.create({
      type: "read",
      chatType: "singleChat",
      to: a,
      id: r
    });
    this.rootStore.client.send(u);
  }
  clear() {
    this.message = {
      singleChat: {},
      groupChat: {},
      byId: /* @__PURE__ */ new Map(),
      chatRoom: {},
      broadcast: []
    }, this.selectedMessage = {
      singleChat: {},
      groupChat: {}
    }, this.currentCVS = {}, this.repliedMessage = null, this.typing = {};
  }
}
class jge {
  constructor(r) {
    this.setCurrentCvs = (a) => {
      this.currentCvs = a, this.rootStore.messageStore.setCurrentCVS(a), this.conversationList.forEach((u, h) => {
        u.chatType == a.chatType && u.conversationId == a.conversationId && this.conversationList[h].unreadCount > 0 && (this.conversationList[h].unreadCount = 0, this.rootStore.messageStore.sendChannelAck(a)), this.conversationList = [...this.conversationList];
      });
    }, this.rootStore = r, this.currentCvs = {
      conversationId: "",
      chatType: ""
    }, this.conversationList = [], this.searchList = [], this.hasConversationNext = !0, this.byId = {}, ph(this, {
      currentCvs: Ar,
      conversationList: Ar,
      searchList: Ar,
      hasConversationNext: Ar,
      byId: Ar,
      setCurrentCvs: Sn,
      setConversation: Sn,
      setSearchList: Sn,
      deleteConversation: Sn,
      getConversation: Sn,
      addConversation: Sn,
      modifyConversation: Sn,
      topConversation: Sn,
      setAtType: Sn,
      updateConversationName: Sn,
      pinConversation: Sn,
      getServerPinnedConversations: Sn,
      setSilentModeForConversation: Sn,
      setSilentModeForConversationSync: Sn,
      clearRemindTypeForConversation: Sn,
      getSilentModeForConversations: Sn,
      setOnlineStatus: Sn,
      setHasConversationNext: Sn,
      clear: Sn
    });
  }
  setConversation(r) {
    if (!Array.isArray(r))
      return console.error("Invalid parameter: conversations");
    const a = this.conversationList.map((h) => h.conversationId), u = r.filter(
      ({ conversationId: h }) => !a.find((b) => b === h)
    );
    u.forEach((h) => {
      this.byId[`${h.chatType}_${h.conversationId}`] = h;
    }), this.conversationList = [...this.conversationList, ...u];
  }
  addConversation(r) {
    if (typeof r != "object")
      return console.error("Invalid parameter: conversation");
    this.conversationList.find((u) => u.conversationId === r.conversationId) || (this.conversationList = [r, ...this.conversationList].sort(Ay), this.byId[`${r.chatType}_${r.conversationId}`] = r, this.getSilentModeForConversations([r]));
  }
  setSearchList(r) {
    if (!Array.isArray(r))
      return console.error("Invalid parameter: conversations");
    this.searchList = r;
  }
  deleteConversation(r) {
    var a, u;
    if (typeof r != "object")
      return console.error("Invalid parameter: conversation");
    this.conversationList = (a = this.conversationList) == null ? void 0 : a.filter((h) => !(h.chatType == r.chatType && h.conversationId == r.conversationId)), this.searchList = (u = this.searchList) == null ? void 0 : u.filter((h) => !(h.chatType == r.chatType && h.conversationId == r.conversationId)), this.setCurrentCvs({});
  }
  modifyConversation(r) {
    var a;
    (a = this.conversationList) == null || a.forEach((u, h) => {
      u.chatType == r.chatType && u.conversationId == r.conversationId && (this.conversationList[h] = r);
    }), this.conversationList = [...this.conversationList].sort(Ay);
  }
  topConversation(r) {
    this.conversationList = [...this.conversationList.sort(Ay)];
  }
  getConversation(r, a) {
    var h;
    let u;
    return (h = this.conversationList) == null || h.forEach((b) => {
      b.chatType == r && b.conversationId == a && (u = b);
    }), u;
  }
  setAtType(r, a, u) {
    const h = this.conversationList.findIndex((b) => b.chatType === r && b.conversationId === a);
    h > -1 && this.conversationList[h].atType !== u && (this.conversationList[h].atType = u);
  }
  setHasConversationNext(r) {
    this.hasConversationNext = r;
  }
  updateConversationName(r, a) {
    this.rootStore.client.getGroupInfo({ groupId: a }).then((u) => {
      var h;
      (h = this.conversationList) == null || h.forEach((b) => {
        var l, v;
        b.conversationId === a && (b.name = (v = (l = u == null ? void 0 : u.data) == null ? void 0 : l[0]) == null ? void 0 : v.name);
      }), qi(() => {
        this.conversationList = [...this.conversationList];
      }), mn.dispatchSuccess("getGroupInfo");
    }).catch((u) => {
      mn.dispatchError("getGroupInfo", u);
    });
  }
  sortConversationList(r) {
    this.conversationList = r(this.conversationList);
  }
  pinConversation(r, a, u) {
    this.rootStore.client.pinConversation({ conversationType: r, conversationId: a, isPinned: u }).then((h) => {
      var b;
      (b = this.conversationList) == null || b.forEach((l) => {
        l.conversationId === a && (l.isPinned = u);
      }), qi(() => {
        this.conversationList = [...this.conversationList.sort(Ay)];
      }), mn.dispatchSuccess("pinConversation");
    }).catch((h) => {
      mn.dispatchError("pinConversation", h);
    });
  }
  getServerPinnedConversations() {
    this.rootStore.client.getServerPinnedConversations({ pageSize: 50 }).then((r) => {
      var h;
      const a = ((h = r.data) == null ? void 0 : h.conversations) || [], u = [...this.conversationList];
      a.forEach((b) => {
        const l = this.conversationList.findIndex(
          (v) => v.conversationId === b.conversationId
        );
        if (l === -1) {
          const v = {
            ...b,
            chatType: b.conversationType,
            unreadCount: 0
          };
          delete v.conversationType, delete v.unReadCount, delete v.pinnedTime, u.push(v);
        } else
          this.conversationList[l].isPinned = !0;
      }), qi(() => {
        this.conversationList = [...u.sort(Ay)];
      }), mn.dispatchSuccess("getServerPinnedConversations");
    }).catch((r) => {
      mn.dispatchError("getServerPinnedConversations", r);
    });
  }
  setSilentModeForConversationSync(r, a) {
    var u;
    (u = this.conversationList) == null || u.forEach((h) => {
      h.conversationId === r.conversationId && (h.silent = a);
    }), this.conversationList = [...this.conversationList];
  }
  setSilentModeForConversation(r) {
    this.rootStore.client.setSilentModeForConversation({
      conversationId: r.conversationId,
      type: r.chatType,
      options: {
        paramType: 0,
        remindType: r.chatType == "groupChat" ? "AT" : "NONE"
      }
    }).then((a) => {
      this.setSilentModeForConversationSync(r, !0), this.rootStore.addressStore.setSilentModeForConversationSync(r, !0), mn.dispatchSuccess("setSilentModeForConversation");
    }).catch((a) => {
      mn.dispatchError("setSilentModeForConversation", a);
    });
  }
  clearRemindTypeForConversation(r) {
    this.rootStore.client.clearRemindTypeForConversation({
      conversationId: r.conversationId,
      type: r.chatType
    }).then((a) => {
      this.setSilentModeForConversationSync(r, !1), this.rootStore.addressStore.setSilentModeForConversationSync(r, !1), mn.dispatchSuccess("clearRemindTypeForConversation");
    }).catch((a) => {
      mn.dispatchError("clearRemindTypeForConversation", a);
    });
  }
  getSilentModeForConversations(r) {
    if (!r || r.length == 0)
      return;
    const a = r.map((u) => ({
      id: u.conversationId,
      type: u.chatType
    }));
    this.rootStore.client.getSilentModeForConversations({
      conversationList: a
    }).then((u) => {
      var l;
      const h = u.data.user, b = u.data.group;
      (l = this.conversationList) == null || l.forEach((v) => {
        var s, c;
        v.chatType === "singleChat" ? h[v.conversationId] && ((s = h[v.conversationId]) == null ? void 0 : s.type) == "NONE" && (v.silent = !0) : v.chatType === "groupChat" && ((c = b[v.conversationId]) == null ? void 0 : c.type) == "AT" && b[v.conversationId] && (v.silent = !0);
      }), mn.dispatchSuccess("getSilentModeForConversations");
    }).catch((u) => {
      mn.dispatchError("getSilentModeForConversations", u);
    });
  }
  setOnlineStatus(r) {
    r.forEach((a) => {
      var u, h;
      Object.prototype.toString.call(a.status) === "[object Object]" && Object.values(a.status).indexOf("1") > -1 ? (u = this.conversationList) == null || u.forEach((b) => {
        b.conversationId === a.uid && (b.isOnline = !0);
      }) : (h = this.conversationList) == null || h.forEach((b) => {
        b.conversationId === a.uid && (b.isOnline = !1);
      });
    }), this.conversationList = [...this.conversationList];
  }
  clear() {
    this.currentCvs = {
      conversationId: "",
      chatType: ""
    }, this.conversationList = [], this.searchList = [], this.hasConversationNext = !0, this.byId = {};
  }
}
const Uge = /^[\uD800-\uDBFF]$/, Hge = /^[\uDC00-\uDFFF]$/, Bge = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
var iU;
(function(t) {
  t[t.Unknown = 1e-13] = "Unknown", t[t.Rule = 1e-12] = "Rule", t[t.DICT = 2e-8] = "DICT", t[t.Surname = 1] = "Surname", t[t.Custom = 1] = "Custom";
})(iU || (iU = {}));
const Go = {
  Normal: 1,
  Surname: 10,
  Custom: 100
};
function Jc(t) {
  var r;
  return t.length - (((r = t.match(Bge)) === null || r === void 0 ? void 0 : r.length) || 0);
}
function yb(t) {
  const r = [];
  let a = 0;
  for (; a < t.length; ) {
    const u = t[a];
    Uge.test(u) && Hge.test(t[a + 1]) ? (r.push(t.substring(a, a + 2)), a += 2) : (r.push(u), a += 1);
  }
  return r;
}
class aG {
  constructor() {
    this.NumberDICT = [], this.StringDICT = /* @__PURE__ */ new Map();
  }
  get(r) {
    if (r.length > 1)
      return this.StringDICT.get(r);
    {
      const a = r.charCodeAt(0);
      return this.NumberDICT[a];
    }
  }
  set(r, a) {
    if (r.length > 1)
      this.StringDICT.set(r, a);
    else {
      const u = r.charCodeAt(0);
      this.NumberDICT[u] = a;
    }
  }
  clear() {
    this.NumberDICT = [], this.StringDICT.clear();
  }
}
const sU = {
  "bǎng páng pāng": ["膀"],
  líng: [
    "〇",
    "伶",
    "凌",
    "刢",
    "囹",
    "坽",
    "夌",
    "姈",
    "婈",
    "孁",
    "岺",
    "彾",
    "掕",
    "昤",
    "朎",
    "柃",
    "棂",
    "櫺",
    "欞",
    "泠",
    "淩",
    "澪",
    "灵",
    "燯",
    "爧",
    "狑",
    "玲",
    "琌",
    "瓴",
    "皊",
    "砱",
    "祾",
    "秢",
    "竛",
    "笭",
    "紷",
    "綾",
    "绫",
    "羐",
    "羚",
    "翎",
    "聆",
    "舲",
    "苓",
    "菱",
    "蓤",
    "蔆",
    "蕶",
    "蛉",
    "衑",
    "裬",
    "詅",
    "跉",
    "軨",
    "輘",
    "酃",
    "醽",
    "鈴",
    "錂",
    "铃",
    "閝",
    "陵",
    "零",
    "霊",
    "霗",
    "霛",
    "霝",
    "靈",
    "駖",
    "魿",
    "鯪",
    "鲮",
    "鴒",
    "鸰",
    "鹷",
    "麢",
    "齡",
    "齢",
    "龄",
    "龗",
    "㥄"
  ],
  yī: [
    "一",
    "乊",
    "伊",
    "依",
    "医",
    "吚",
    "咿",
    "噫",
    "壱",
    "壹",
    "夁",
    "嫛",
    "嬄",
    "弌",
    "揖",
    "撎",
    "檹",
    "毉",
    "洢",
    "渏",
    "漪",
    "瑿",
    "畩",
    "祎",
    "禕",
    "稦",
    "繄",
    "蛜",
    "衤",
    "譩",
    "辷",
    "郼",
    "醫",
    "銥",
    "铱",
    "鷖",
    "鹥",
    "黟",
    "黳"
  ],
  "dīng zhēng": ["丁"],
  "kǎo qiǎo yú": ["丂"],
  qī: [
    "七",
    "倛",
    "僛",
    "凄",
    "嘁",
    "墄",
    "娸",
    "悽",
    "慼",
    "慽",
    "戚",
    "捿",
    "柒",
    "桤",
    "桼",
    "棲",
    "榿",
    "欺",
    "沏",
    "淒",
    "漆",
    "紪",
    "緀",
    "萋",
    "褄",
    "諆",
    "迉",
    "郪",
    "鏚",
    "霋",
    "魌",
    "鶈"
  ],
  shàng: ["丄", "尙", "尚", "恦", "緔", "绱"],
  xià: [
    "丅",
    "下",
    "乤",
    "圷",
    "夏",
    "夓",
    "懗",
    "梺",
    "疜",
    "睱",
    "罅",
    "鎼",
    "鏬"
  ],
  hǎn: ["丆", "喊", "浫", "罕", "豃", "㘎"],
  "wàn mò": ["万"],
  zhàng: [
    "丈",
    "仗",
    "墇",
    "嶂",
    "帐",
    "帳",
    "幛",
    "扙",
    "杖",
    "涱",
    "痮",
    "瘬",
    "瘴",
    "瞕",
    "粀",
    "胀",
    "脹",
    "賬",
    "账",
    "障"
  ],
  sān: ["三", "厁", "叁", "弎", "毵", "毶", "毿", "犙", "鬖"],
  "shàng shǎng shang": ["上"],
  "qí jī": ["丌", "其", "奇"],
  "bù fǒu": ["不"],
  "yǔ yù yú": ["与"],
  miǎn: [
    "丏",
    "偭",
    "免",
    "冕",
    "勉",
    "勔",
    "喕",
    "娩",
    "愐",
    "汅",
    "沔",
    "湎",
    "睌",
    "緬",
    "缅",
    "腼",
    "葂",
    "靦",
    "鮸",
    "𩾃"
  ],
  gài: [
    "丐",
    "乢",
    "匃",
    "匄",
    "戤",
    "概",
    "槩",
    "槪",
    "溉",
    "漑",
    "瓂",
    "葢",
    "鈣",
    "钙",
    "𬮿"
  ],
  chǒu: ["丑", "丒", "侴", "吜", "杽", "瞅", "矁", "醜", "魗"],
  zhuān: [
    "专",
    "叀",
    "嫥",
    "専",
    "專",
    "瑼",
    "甎",
    "砖",
    "磗",
    "磚",
    "蟤",
    "諯",
    "鄟",
    "顓",
    "颛",
    "鱄",
    "䏝"
  ],
  "qiě jū": ["且"],
  pī: [
    "丕",
    "伓",
    "伾",
    "噼",
    "坯",
    "岯",
    "憵",
    "批",
    "披",
    "炋",
    "狉",
    "狓",
    "砒",
    "磇",
    "礔",
    "礕",
    "秛",
    "秠",
    "耚",
    "豾",
    "邳",
    "鈚",
    "鉟",
    "銔",
    "錃",
    "錍",
    "霹",
    "駓",
    "髬",
    "魾",
    "𬳵"
  ],
  shì: [
    "世",
    "丗",
    "亊",
    "事",
    "仕",
    "侍",
    "冟",
    "势",
    "勢",
    "卋",
    "呩",
    "嗜",
    "噬",
    "士",
    "奭",
    "嬕",
    "室",
    "市",
    "式",
    "弑",
    "弒",
    "恀",
    "恃",
    "戺",
    "拭",
    "揓",
    "是",
    "昰",
    "枾",
    "柿",
    "栻",
    "澨",
    "烒",
    "煶",
    "眂",
    "眎",
    "眡",
    "睗",
    "示",
    "礻",
    "筮",
    "簭",
    "舐",
    "舓",
    "襫",
    "視",
    "视",
    "觢",
    "試",
    "誓",
    "諡",
    "謚",
    "试",
    "谥",
    "貰",
    "贳",
    "軾",
    "轼",
    "逝",
    "遾",
    "釈",
    "释",
    "釋",
    "鈰",
    "鉃",
    "鉽",
    "铈",
    "飾",
    "餙",
    "餝",
    "饰",
    "鰘",
    "䏡",
    "𬤊"
  ],
  qiū: [
    "丘",
    "丠",
    "坵",
    "媝",
    "恘",
    "恷",
    "楸",
    "秋",
    "秌",
    "穐",
    "篍",
    "緧",
    "萩",
    "蘒",
    "蚯",
    "蝵",
    "蟗",
    "蠤",
    "趥",
    "邱",
    "鞦",
    "鞧",
    "鰌",
    "鰍",
    "鳅",
    "鶖",
    "鹙",
    "龝"
  ],
  bǐng: [
    "丙",
    "屛",
    "怲",
    "抦",
    "昞",
    "昺",
    "柄",
    "棅",
    "炳",
    "禀",
    "秉",
    "稟",
    "苪",
    "蛃",
    "邴",
    "鈵",
    "陃",
    "鞆",
    "餅",
    "餠",
    "饼"
  ],
  yè: [
    "业",
    "亱",
    "僷",
    "墷",
    "夜",
    "嶪",
    "嶫",
    "抴",
    "捙",
    "擛",
    "擪",
    "擫",
    "晔",
    "曄",
    "曅",
    "曗",
    "曳",
    "曵",
    "枼",
    "枽",
    "業",
    "洂",
    "液",
    "澲",
    "烨",
    "燁",
    "爗",
    "璍",
    "皣",
    "瞱",
    "瞸",
    "礏",
    "腋",
    "葉",
    "謁",
    "谒",
    "邺",
    "鄴",
    "鍱",
    "鐷",
    "靥",
    "靨",
    "頁",
    "页",
    "餣",
    "饁",
    "馌",
    "驜",
    "鵺",
    "鸈"
  ],
  cóng: [
    "丛",
    "从",
    "叢",
    "婃",
    "孮",
    "従",
    "徔",
    "徖",
    "悰",
    "樷",
    "欉",
    "淙",
    "灇",
    "爜",
    "琮",
    "藂",
    "誴",
    "賨",
    "賩",
    "錝"
  ],
  dōng: [
    "东",
    "倲",
    "冬",
    "咚",
    "埬",
    "岽",
    "崬",
    "徚",
    "昸",
    "東",
    "氡",
    "氭",
    "涷",
    "笗",
    "苳",
    "菄",
    "蝀",
    "鮗",
    "鯟",
    "鶇",
    "鶫",
    "鸫",
    "鼕",
    "𬟽"
  ],
  sī: [
    "丝",
    "俬",
    "凘",
    "厮",
    "司",
    "咝",
    "嘶",
    "噝",
    "媤",
    "廝",
    "恖",
    "撕",
    "斯",
    "楒",
    "泀",
    "澌",
    "燍",
    "禗",
    "禠",
    "私",
    "糹",
    "絲",
    "緦",
    "纟",
    "缌",
    "罳",
    "蕬",
    "虒",
    "蛳",
    "蜤",
    "螄",
    "蟖",
    "蟴",
    "鉰",
    "銯",
    "鍶",
    "鐁",
    "锶",
    "颸",
    "飔",
    "騦",
    "鷥",
    "鸶",
    "鼶",
    "㟃"
  ],
  chéng: [
    "丞",
    "呈",
    "城",
    "埕",
    "堘",
    "塍",
    "塖",
    "宬",
    "峸",
    "惩",
    "懲",
    "成",
    "承",
    "挰",
    "掁",
    "揨",
    "枨",
    "棖",
    "橙",
    "檙",
    "洆",
    "溗",
    "澂",
    "珵",
    "珹",
    "畻",
    "程",
    "窚",
    "筬",
    "絾",
    "脭",
    "荿",
    "誠",
    "诚",
    "郕",
    "酲",
    "鋮",
    "铖",
    "騬",
    "鯎"
  ],
  diū: ["丟", "丢", "銩", "铥"],
  liǎng: [
    "両",
    "两",
    "兩",
    "唡",
    "啢",
    "掚",
    "緉",
    "脼",
    "蜽",
    "裲",
    "魉",
    "魎",
    "𬜯"
  ],
  yǒu: [
    "丣",
    "卣",
    "友",
    "梄",
    "湵",
    "牖",
    "禉",
    "羑",
    "聈",
    "苃",
    "莠",
    "蜏",
    "酉",
    "銪",
    "铕",
    "黝"
  ],
  yán: [
    "严",
    "厳",
    "啱",
    "喦",
    "嚴",
    "塩",
    "壛",
    "壧",
    "妍",
    "姸",
    "娫",
    "娮",
    "岩",
    "嵒",
    "嵓",
    "巌",
    "巖",
    "巗",
    "延",
    "揅",
    "昖",
    "楌",
    "檐",
    "櫩",
    "欕",
    "沿",
    "炎",
    "炏",
    "狿",
    "琂",
    "盐",
    "碞",
    "筵",
    "簷",
    "莚",
    "蔅",
    "虤",
    "蜒",
    "言",
    "訁",
    "訮",
    "詽",
    "讠",
    "郔",
    "閆",
    "閻",
    "闫",
    "阎",
    "顏",
    "顔",
    "颜",
    "鹽",
    "麣",
    "𫄧"
  ],
  bìng: [
    "並",
    "併",
    "倂",
    "傡",
    "垪",
    "摒",
    "栤",
    "病",
    "窉",
    "竝",
    "誁",
    "靐",
    "鮩"
  ],
  "sàng sāng": ["丧"],
  gǔn: [
    "丨",
    "惃",
    "滚",
    "滾",
    "磙",
    "緄",
    "绲",
    "蓘",
    "蔉",
    "衮",
    "袞",
    "輥",
    "辊",
    "鮌",
    "鯀",
    "鲧"
  ],
  jiū: [
    "丩",
    "勼",
    "啾",
    "揪",
    "揫",
    "朻",
    "究",
    "糾",
    "纠",
    "萛",
    "赳",
    "阄",
    "鬏",
    "鬮",
    "鳩",
    "鸠"
  ],
  "gè gě": ["个", "個", "各"],
  yā: [
    "丫",
    "圧",
    "孲",
    "庘",
    "押",
    "枒",
    "桠",
    "椏",
    "錏",
    "鐚",
    "鴉",
    "鴨",
    "鵶",
    "鸦",
    "鸭"
  ],
  pán: [
    "丬",
    "媻",
    "幋",
    "槃",
    "洀",
    "瀊",
    "爿",
    "盘",
    "盤",
    "磐",
    "縏",
    "蒰",
    "蟠",
    "蹒",
    "蹣",
    "鎜",
    "鞶"
  ],
  "zhōng zhòng": ["中"],
  jǐ: [
    "丮",
    "妀",
    "己",
    "戟",
    "挤",
    "掎",
    "撠",
    "擠",
    "橶",
    "泲",
    "犱",
    "脊",
    "虮",
    "蟣",
    "魢",
    "鱾",
    "麂"
  ],
  jiè: [
    "丯",
    "介",
    "借",
    "唶",
    "堺",
    "屆",
    "届",
    "岕",
    "庎",
    "徣",
    "戒",
    "楐",
    "犗",
    "玠",
    "琾",
    "界",
    "畍",
    "疥",
    "砎",
    "蚧",
    "蛶",
    "衸",
    "褯",
    "誡",
    "诫",
    "鎅",
    "骱",
    "魪"
  ],
  fēng: [
    "丰",
    "仹",
    "偑",
    "僼",
    "凨",
    "凬",
    "凮",
    "妦",
    "寷",
    "封",
    "峯",
    "峰",
    "崶",
    "枫",
    "楓",
    "檒",
    "沣",
    "沨",
    "渢",
    "灃",
    "烽",
    "犎",
    "猦",
    "琒",
    "疯",
    "瘋",
    "盽",
    "砜",
    "碸",
    "篈",
    "蘴",
    "蜂",
    "蠭",
    "豐",
    "鄷",
    "酆",
    "鋒",
    "鎽",
    "鏠",
    "锋",
    "霻",
    "靊",
    "飌",
    "麷"
  ],
  "guàn kuàng": ["丱"],
  chuàn: ["串", "汌", "玔", "賗", "釧", "钏"],
  chǎn: [
    "丳",
    "产",
    "冁",
    "剷",
    "囅",
    "嵼",
    "旵",
    "浐",
    "滻",
    "灛",
    "產",
    "産",
    "簅",
    "蒇",
    "蕆",
    "諂",
    "譂",
    "讇",
    "谄",
    "鏟",
    "铲",
    "閳",
    "闡",
    "阐",
    "骣",
    "𬊤"
  ],
  lín: [
    "临",
    "冧",
    "壣",
    "崊",
    "嶙",
    "斴",
    "晽",
    "暽",
    "林",
    "潾",
    "瀶",
    "燐",
    "琳",
    "璘",
    "瞵",
    "碄",
    "磷",
    "粦",
    "粼",
    "繗",
    "翷",
    "臨",
    "轔",
    "辚",
    "遴",
    "邻",
    "鄰",
    "鏻",
    "阾",
    "隣",
    "霖",
    "驎",
    "鱗",
    "鳞",
    "麐",
    "麟",
    "𬴊",
    "𬭸"
  ],
  zhuó: [
    "丵",
    "劅",
    "卓",
    "啄",
    "圴",
    "妰",
    "娺",
    "撯",
    "擆",
    "擢",
    "斫",
    "斮",
    "斱",
    "斲",
    "斵",
    "晫",
    "椓",
    "浊",
    "浞",
    "濁",
    "灼",
    "烵",
    "琸",
    "硺",
    "禚",
    "窡",
    "籗",
    "籱",
    "罬",
    "茁",
    "蠗",
    "蠿",
    "諁",
    "諑",
    "謶",
    "诼",
    "酌",
    "鐲",
    "镯",
    "鵫",
    "鷟",
    "䓬",
    "𬸦"
  ],
  zhǔ: [
    "丶",
    "主",
    "劯",
    "嘱",
    "囑",
    "宔",
    "帾",
    "拄",
    "渚",
    "濐",
    "煑",
    "煮",
    "燝",
    "瞩",
    "矚",
    "罜",
    "詝",
    "陼",
    "鸀",
    "麈",
    "𬣞"
  ],
  bā: [
    "丷",
    "仈",
    "八",
    "叭",
    "哵",
    "夿",
    "岜",
    "巴",
    "捌",
    "朳",
    "玐",
    "疤",
    "笆",
    "粑",
    "羓",
    "芭",
    "蚆",
    "豝",
    "釟"
  ],
  wán: [
    "丸",
    "刓",
    "完",
    "岏",
    "抏",
    "捖",
    "汍",
    "烷",
    "玩",
    "琓",
    "笂",
    "紈",
    "纨",
    "翫",
    "芄",
    "貦",
    "頑",
    "顽"
  ],
  dān: [
    "丹",
    "勯",
    "匰",
    "単",
    "妉",
    "媅",
    "殚",
    "殫",
    "甔",
    "眈",
    "砃",
    "箪",
    "簞",
    "耼",
    "耽",
    "聃",
    "聸",
    "褝",
    "襌",
    "躭",
    "郸",
    "鄲",
    "酖",
    "頕"
  ],
  "wèi wéi": ["为"],
  "jǐng dǎn": ["丼"],
  "lì lí": ["丽"],
  jǔ: [
    "举",
    "弆",
    "挙",
    "擧",
    "椇",
    "榉",
    "榘",
    "櫸",
    "欅",
    "矩",
    "筥",
    "聥",
    "舉",
    "莒",
    "蒟",
    "襷",
    "踽",
    "齟",
    "龃"
  ],
  piě: ["丿", "苤", "鐅", "𬭯"],
  fú: [
    "乀",
    "伏",
    "俘",
    "凫",
    "刜",
    "匐",
    "咈",
    "哹",
    "垘",
    "孚",
    "岪",
    "巿",
    "帗",
    "幅",
    "幞",
    "弗",
    "彿",
    "怫",
    "扶",
    "柫",
    "栿",
    "桴",
    "氟",
    "泭",
    "浮",
    "涪",
    "澓",
    "炥",
    "玸",
    "甶",
    "畉",
    "癁",
    "祓",
    "福",
    "稪",
    "符",
    "箙",
    "紱",
    "紼",
    "絥",
    "綍",
    "绂",
    "绋",
    "罘",
    "罦",
    "翇",
    "艀",
    "芙",
    "芣",
    "苻",
    "茀",
    "茯",
    "菔",
    "葍",
    "虙",
    "蚨",
    "蜉",
    "蝠",
    "袚",
    "袱",
    "襆",
    "襥",
    "諨",
    "豧",
    "踾",
    "輻",
    "辐",
    "郛",
    "鉘",
    "鉜",
    "韍",
    "韨",
    "颫",
    "髴",
    "鮄",
    "鮲",
    "鳧",
    "鳬",
    "鴔",
    "鵩",
    "黻"
  ],
  "yí jí": ["乁"],
  yì: [
    "乂",
    "义",
    "亄",
    "亦",
    "亿",
    "伇",
    "伿",
    "佾",
    "俋",
    "億",
    "兿",
    "刈",
    "劓",
    "劮",
    "勚",
    "勩",
    "匇",
    "呓",
    "呭",
    "呹",
    "唈",
    "囈",
    "圛",
    "坄",
    "垼",
    "埸",
    "奕",
    "嫕",
    "嬑",
    "寱",
    "屹",
    "峄",
    "嶧",
    "帟",
    "帠",
    "幆",
    "廙",
    "异",
    "弈",
    "弋",
    "役",
    "忆",
    "怈",
    "怿",
    "悒",
    "意",
    "憶",
    "懌",
    "懿",
    "抑",
    "挹",
    "敡",
    "易",
    "晹",
    "曀",
    "曎",
    "杙",
    "枍",
    "棭",
    "榏",
    "槸",
    "檍",
    "歝",
    "殔",
    "殪",
    "殹",
    "毅",
    "浂",
    "浥",
    "浳",
    "湙",
    "溢",
    "潩",
    "澺",
    "瀷",
    "炈",
    "焲",
    "熠",
    "熤",
    "熼",
    "燚",
    "燡",
    "燱",
    "獈",
    "玴",
    "異",
    "疫",
    "痬",
    "瘗",
    "瘞",
    "瘱",
    "癔",
    "益",
    "瞖",
    "穓",
    "竩",
    "篒",
    "縊",
    "繶",
    "繹",
    "绎",
    "缢",
    "義",
    "羿",
    "翊",
    "翌",
    "翳",
    "翼",
    "耴",
    "肄",
    "肊",
    "膉",
    "臆",
    "艗",
    "艺",
    "芅",
    "苅",
    "萟",
    "蓺",
    "薏",
    "藙",
    "藝",
    "蘙",
    "虉",
    "蜴",
    "螠",
    "衪",
    "袣",
    "裔",
    "裛",
    "褹",
    "襼",
    "訲",
    "訳",
    "詍",
    "詣",
    "誼",
    "譯",
    "議",
    "讛",
    "议",
    "译",
    "诣",
    "谊",
    "豙",
    "豛",
    "豷",
    "貖",
    "贀",
    "跇",
    "轶",
    "逸",
    "邑",
    "鄓",
    "醷",
    "釴",
    "鈠",
    "鎰",
    "鐿",
    "镒",
    "镱",
    "阣",
    "隿",
    "霬",
    "饐",
    "駅",
    "驛",
    "驿",
    "骮",
    "鮨",
    "鶂",
    "鶃",
    "鶍",
    "鷁",
    "鷊",
    "鷧",
    "鷾",
    "鸃",
    "鹝",
    "鹢",
    "黓",
    "齸",
    "𬬩",
    "㑊",
    "𫄷",
    "𬟁"
  ],
  nǎi: ["乃", "倷", "奶", "嬭", "廼", "氖", "疓", "艿", "迺", "釢"],
  wǔ: [
    "乄",
    "五",
    "仵",
    "伍",
    "侮",
    "倵",
    "儛",
    "午",
    "啎",
    "妩",
    "娬",
    "嫵",
    "庑",
    "廡",
    "忤",
    "怃",
    "憮",
    "摀",
    "武",
    "潕",
    "熓",
    "牾",
    "玝",
    "珷",
    "瑦",
    "甒",
    "碔",
    "舞",
    "躌",
    "迕",
    "逜",
    "陚",
    "鵡",
    "鹉",
    "𣲘"
  ],
  jiǔ: [
    "久",
    "乆",
    "九",
    "乣",
    "奺",
    "杦",
    "汣",
    "灸",
    "玖",
    "紤",
    "舏",
    "酒",
    "镹",
    "韭",
    "韮"
  ],
  "tuō zhé": ["乇", "杔", "馲"],
  "me mó ma yāo": ["么"],
  zhī: [
    "之",
    "倁",
    "卮",
    "巵",
    "搘",
    "支",
    "栀",
    "梔",
    "椥",
    "榰",
    "汁",
    "泜",
    "疷",
    "祗",
    "祬",
    "秓",
    "稙",
    "綕",
    "肢",
    "胑",
    "胝",
    "脂",
    "芝",
    "蘵",
    "蜘",
    "衼",
    "隻",
    "鳷",
    "鴲",
    "鼅",
    "𦭜"
  ],
  "wū wù": ["乌"],
  zhà: [
    "乍",
    "咤",
    "宱",
    "搾",
    "榨",
    "溠",
    "痄",
    "蚱",
    "詐",
    "诈",
    "醡",
    "霅",
    "䃎"
  ],
  hū: [
    "乎",
    "乯",
    "匢",
    "匫",
    "呼",
    "唿",
    "嘑",
    "垀",
    "寣",
    "幠",
    "忽",
    "惚",
    "昒",
    "歑",
    "泘",
    "淴",
    "滹",
    "烀",
    "苸",
    "虍",
    "虖",
    "謼",
    "軤",
    "轷",
    "雐"
  ],
  fá: [
    "乏",
    "伐",
    "傠",
    "坺",
    "垡",
    "墢",
    "姂",
    "栰",
    "浌",
    "瞂",
    "笩",
    "筏",
    "罚",
    "罰",
    "罸",
    "藅",
    "閥",
    "阀"
  ],
  "lè yuè yào lào": ["乐", "樂"],
  yín: [
    "乑",
    "吟",
    "噖",
    "嚚",
    "圁",
    "垠",
    "夤",
    "婬",
    "寅",
    "峾",
    "崟",
    "崯",
    "檭",
    "殥",
    "泿",
    "淫",
    "滛",
    "烎",
    "犾",
    "狺",
    "璌",
    "硍",
    "碒",
    "荶",
    "蔩",
    "訔",
    "訚",
    "訡",
    "誾",
    "鄞",
    "鈝",
    "銀",
    "银",
    "霪",
    "鷣",
    "齦"
  ],
  pīng: ["乒", "俜", "娉", "涄", "甹", "砯", "聠", "艵", "頩"],
  pāng: ["乓", "滂", "胮", "膖", "雱", "霶"],
  qiáo: [
    "乔",
    "侨",
    "僑",
    "嫶",
    "憔",
    "桥",
    "槗",
    "樵",
    "橋",
    "櫵",
    "犞",
    "瞧",
    "硚",
    "礄",
    "荍",
    "荞",
    "蕎",
    "藮",
    "譙",
    "趫",
    "鐈",
    "鞒",
    "鞽",
    "顦"
  ],
  hǔ: ["乕", "琥", "萀", "虎", "虝", "錿", "鯱"],
  guāi: ["乖"],
  "chéng shèng": ["乗", "乘", "娍"],
  yǐ: [
    "乙",
    "乛",
    "以",
    "倚",
    "偯",
    "嬟",
    "崺",
    "已",
    "庡",
    "扆",
    "攺",
    "敼",
    "旑",
    "旖",
    "檥",
    "矣",
    "礒",
    "笖",
    "舣",
    "艤",
    "苡",
    "苢",
    "蚁",
    "螘",
    "蟻",
    "裿",
    "踦",
    "輢",
    "轙",
    "逘",
    "酏",
    "釔",
    "鈘",
    "鉯",
    "钇",
    "顗",
    "鳦",
    "齮",
    "𫖮",
    "𬺈"
  ],
  "háo yǐ": ["乚"],
  "niè miē": ["乜"],
  qǐ: [
    "乞",
    "企",
    "启",
    "唘",
    "啓",
    "啔",
    "啟",
    "婍",
    "屺",
    "杞",
    "棨",
    "玘",
    "盀",
    "綺",
    "绮",
    "芑",
    "諬",
    "起",
    "邔",
    "闙"
  ],
  yě: ["也", "冶", "嘢", "埜", "壄", "漜", "野"],
  xí: [
    "习",
    "喺",
    "媳",
    "嶍",
    "席",
    "椺",
    "檄",
    "漝",
    "習",
    "蓆",
    "袭",
    "襲",
    "覡",
    "觋",
    "謵",
    "趘",
    "郋",
    "鎴",
    "隰",
    "霫",
    "飁",
    "騱",
    "騽",
    "驨",
    "鰼",
    "鳛",
    "𠅤",
    "𫘬"
  ],
  xiāng: [
    "乡",
    "厢",
    "廂",
    "忀",
    "楿",
    "欀",
    "湘",
    "瓖",
    "稥",
    "箱",
    "緗",
    "缃",
    "膷",
    "芗",
    "萫",
    "葙",
    "薌",
    "襄",
    "郷",
    "鄉",
    "鄊",
    "鄕",
    "鑲",
    "镶",
    "香",
    "驤",
    "骧",
    "鱜",
    "麘",
    "𬙋"
  ],
  shū: [
    "书",
    "倏",
    "倐",
    "儵",
    "叔",
    "姝",
    "尗",
    "抒",
    "掓",
    "摅",
    "攄",
    "書",
    "枢",
    "梳",
    "樞",
    "殊",
    "殳",
    "毹",
    "毺",
    "淑",
    "瀭",
    "焂",
    "疎",
    "疏",
    "紓",
    "綀",
    "纾",
    "舒",
    "菽",
    "蔬",
    "踈",
    "軗",
    "輸",
    "输",
    "鄃",
    "陎",
    "鮛",
    "鵨"
  ],
  dǒu: ["乧", "抖", "枓", "蚪", "鈄", "阧", "陡"],
  shǐ: [
    "乨",
    "使",
    "兘",
    "史",
    "始",
    "宩",
    "屎",
    "榁",
    "矢",
    "笶",
    "豕",
    "鉂",
    "駛",
    "驶"
  ],
  jī: [
    "乩",
    "僟",
    "击",
    "刉",
    "刏",
    "剞",
    "叽",
    "唧",
    "喞",
    "嗘",
    "嘰",
    "圾",
    "基",
    "墼",
    "姬",
    "屐",
    "嵆",
    "嵇",
    "撃",
    "擊",
    "朞",
    "机",
    "枅",
    "樭",
    "機",
    "毄",
    "激",
    "犄",
    "玑",
    "璣",
    "畸",
    "畿",
    "癪",
    "矶",
    "磯",
    "积",
    "積",
    "笄",
    "筓",
    "箕",
    "簊",
    "緁",
    "羁",
    "羇",
    "羈",
    "耭",
    "肌",
    "芨",
    "虀",
    "覉",
    "覊",
    "譏",
    "譤",
    "讥",
    "賫",
    "賷",
    "赍",
    "跻",
    "踑",
    "躋",
    "躸",
    "銈",
    "錤",
    "鐖",
    "鑇",
    "鑙",
    "隮",
    "雞",
    "鞿",
    "韲",
    "飢",
    "饑",
    "饥",
    "魕",
    "鳮",
    "鶏",
    "鶺",
    "鷄",
    "鸄",
    "鸡",
    "齎",
    "齏",
    "齑",
    "𬯀",
    "𫓯",
    "𫓹",
    "𫌀"
  ],
  náng: ["乪", "嚢", "欜", "蠰", "饢"],
  jiā: [
    "乫",
    "佳",
    "傢",
    "加",
    "嘉",
    "抸",
    "枷",
    "梜",
    "毠",
    "泇",
    "浃",
    "浹",
    "犌",
    "猳",
    "珈",
    "痂",
    "笳",
    "糘",
    "耞",
    "腵",
    "葭",
    "袈",
    "豭",
    "貑",
    "跏",
    "迦",
    "鉫",
    "鎵",
    "镓",
    "鴐",
    "麚",
    "𬂩"
  ],
  jù: [
    "乬",
    "倨",
    "倶",
    "具",
    "剧",
    "劇",
    "勮",
    "埧",
    "埾",
    "壉",
    "姖",
    "屦",
    "屨",
    "岠",
    "巨",
    "巪",
    "怇",
    "惧",
    "愳",
    "懅",
    "懼",
    "拒",
    "拠",
    "昛",
    "歫",
    "洰",
    "澽",
    "炬",
    "烥",
    "犋",
    "秬",
    "窭",
    "窶",
    "簴",
    "粔",
    "耟",
    "聚",
    "虡",
    "蚷",
    "詎",
    "讵",
    "豦",
    "距",
    "踞",
    "躆",
    "遽",
    "邭",
    "醵",
    "鉅",
    "鐻",
    "钜",
    "颶",
    "飓",
    "駏",
    "鮔"
  ],
  shí: [
    "乭",
    "十",
    "埘",
    "塒",
    "姼",
    "实",
    "実",
    "寔",
    "實",
    "峕",
    "嵵",
    "时",
    "旹",
    "時",
    "榯",
    "湜",
    "溡",
    "炻",
    "祏",
    "竍",
    "蚀",
    "蝕",
    "辻",
    "遈",
    "鉐",
    "飠",
    "饣",
    "鮖",
    "鰣",
    "鲥",
    "鼫",
    "鼭"
  ],
  mǎo: ["乮", "冇", "卯", "峁", "戼", "昴", "泖", "笷", "蓩", "鉚", "铆"],
  mǎi: ["买", "嘪", "荬", "蕒", "買", "鷶"],
  luàn: ["乱", "亂", "釠"],
  rǔ: ["乳", "擩", "汝", "肗", "辱", "鄏"],
  xué: [
    "乴",
    "学",
    "學",
    "峃",
    "嶨",
    "斈",
    "泶",
    "澩",
    "燢",
    "穴",
    "茓",
    "袕",
    "踅",
    "鷽",
    "鸴"
  ],
  yǎn: [
    "䶮",
    "乵",
    "俨",
    "偃",
    "儼",
    "兖",
    "兗",
    "厣",
    "厴",
    "噞",
    "孍",
    "嵃",
    "巘",
    "巚",
    "弇",
    "愝",
    "戭",
    "扊",
    "抁",
    "掩",
    "揜",
    "曮",
    "椼",
    "檿",
    "沇",
    "渷",
    "演",
    "琰",
    "甗",
    "眼",
    "罨",
    "萒",
    "蝘",
    "衍",
    "褗",
    "躽",
    "遃",
    "郾",
    "隒",
    "顩",
    "魇",
    "魘",
    "鰋",
    "鶠",
    "黡",
    "黤",
    "黬",
    "黭",
    "黶",
    "鼴",
    "鼹",
    "齴",
    "龑",
    "𬸘",
    "𬙂",
    "𪩘"
  ],
  fǔ: [
    "乶",
    "俌",
    "俛",
    "俯",
    "府",
    "弣",
    "抚",
    "拊",
    "撫",
    "斧",
    "椨",
    "滏",
    "焤",
    "甫",
    "盙",
    "簠",
    "腐",
    "腑",
    "蜅",
    "輔",
    "辅",
    "郙",
    "釜",
    "釡",
    "阝",
    "頫",
    "鬴",
    "黼",
    "㕮",
    "𫖯"
  ],
  shā: [
    "乷",
    "唦",
    "杀",
    "桬",
    "殺",
    "毮",
    "猀",
    "痧",
    "砂",
    "硰",
    "紗",
    "繺",
    "纱",
    "蔱",
    "裟",
    "鎩",
    "铩",
    "閷",
    "髿",
    "魦",
    "鯊",
    "鯋",
    "鲨"
  ],
  nǎ: ["乸", "雫"],
  qián: [
    "乹",
    "亁",
    "仱",
    "偂",
    "前",
    "墘",
    "媊",
    "岒",
    "拑",
    "掮",
    "榩",
    "橬",
    "歬",
    "潛",
    "潜",
    "濳",
    "灊",
    "箝",
    "葥",
    "虔",
    "軡",
    "鈐",
    "鉗",
    "銭",
    "錢",
    "鎆",
    "钤",
    "钱",
    "钳",
    "靬",
    "騚",
    "騝",
    "鰬",
    "黔",
    "黚"
  ],
  suǒ: [
    "乺",
    "唢",
    "嗩",
    "所",
    "暛",
    "溑",
    "溹",
    "琐",
    "琑",
    "瑣",
    "索",
    "褨",
    "鎖",
    "鎻",
    "鏁",
    "锁"
  ],
  yú: [
    "乻",
    "于",
    "亐",
    "伃",
    "余",
    "堣",
    "堬",
    "妤",
    "娛",
    "娯",
    "娱",
    "嬩",
    "崳",
    "嵎",
    "嵛",
    "愚",
    "扵",
    "揄",
    "旟",
    "楡",
    "楰",
    "榆",
    "欤",
    "歈",
    "歟",
    "歶",
    "渔",
    "渝",
    "湡",
    "漁",
    "澞",
    "牏",
    "狳",
    "玗",
    "玙",
    "瑜",
    "璵",
    "盂",
    "睮",
    "窬",
    "竽",
    "籅",
    "羭",
    "腴",
    "臾",
    "舁",
    "舆",
    "艅",
    "茰",
    "萮",
    "萸",
    "蕍",
    "蘛",
    "虞",
    "虶",
    "蝓",
    "螸",
    "衧",
    "褕",
    "覦",
    "觎",
    "諛",
    "謣",
    "谀",
    "踰",
    "輿",
    "轝",
    "逾",
    "邘",
    "酑",
    "鍝",
    "隅",
    "雓",
    "雩",
    "餘",
    "馀",
    "騟",
    "骬",
    "髃",
    "魚",
    "魣",
    "鮽",
    "鯲",
    "鰅",
    "鱼",
    "鷠",
    "鸆",
    "齵"
  ],
  zhù: [
    "乼",
    "伫",
    "佇",
    "住",
    "坾",
    "墸",
    "壴",
    "嵀",
    "拀",
    "杼",
    "柱",
    "樦",
    "殶",
    "注",
    "炷",
    "疰",
    "眝",
    "祝",
    "祩",
    "竚",
    "筯",
    "箸",
    "篫",
    "簗",
    "紵",
    "紸",
    "纻",
    "羜",
    "翥",
    "苎",
    "莇",
    "蛀",
    "註",
    "貯",
    "贮",
    "跓",
    "軴",
    "鉒",
    "鋳",
    "鑄",
    "铸",
    "馵",
    "駐",
    "驻"
  ],
  zhě: ["乽", "者", "褶", "襵", "赭", "踷", "鍺", "锗"],
  "qián gān": ["乾"],
  "zhì luàn": ["乿"],
  guī: [
    "亀",
    "圭",
    "妫",
    "媯",
    "嫢",
    "嬀",
    "帰",
    "归",
    "摫",
    "椝",
    "槻",
    "槼",
    "櫷",
    "歸",
    "珪",
    "瑰",
    "璝",
    "瓌",
    "皈",
    "瞡",
    "硅",
    "茥",
    "蘬",
    "規",
    "规",
    "邽",
    "郌",
    "閨",
    "闺",
    "騩",
    "鬶",
    "鬹"
  ],
  "lǐn lìn": ["亃"],
  jué: [
    "亅",
    "决",
    "刔",
    "劂",
    "匷",
    "厥",
    "噊",
    "孒",
    "孓",
    "崛",
    "崫",
    "嶥",
    "彏",
    "憠",
    "憰",
    "戄",
    "抉",
    "挗",
    "掘",
    "攫",
    "桷",
    "橛",
    "橜",
    "欮",
    "氒",
    "決",
    "灍",
    "焳",
    "熦",
    "爑",
    "爴",
    "爵",
    "獗",
    "玃",
    "玦",
    "玨",
    "珏",
    "瑴",
    "瘚",
    "矍",
    "矡",
    "砄",
    "絕",
    "絶",
    "绝",
    "臄",
    "芵",
    "蕝",
    "蕨",
    "虳",
    "蟨",
    "蟩",
    "觖",
    "觮",
    "觼",
    "訣",
    "譎",
    "诀",
    "谲",
    "貜",
    "赽",
    "趉",
    "蹷",
    "躩",
    "鈌",
    "鐍",
    "鐝",
    "钁",
    "镢",
    "鴂",
    "鴃",
    "鷢",
    "𫘝",
    "㵐",
    "𫔎"
  ],
  "le liǎo": ["了"],
  "gè mā": ["亇"],
  "yǔ yú": ["予", "懙"],
  zhēng: [
    "争",
    "佂",
    "凧",
    "姃",
    "媜",
    "峥",
    "崝",
    "崢",
    "征",
    "徰",
    "炡",
    "烝",
    "爭",
    "狰",
    "猙",
    "癥",
    "眐",
    "睁",
    "睜",
    "筝",
    "箏",
    "篜",
    "聇",
    "脀",
    "蒸",
    "踭",
    "鉦",
    "錚",
    "鏳",
    "鬇"
  ],
  èr: ["二", "刵", "咡", "弍", "弐", "樲", "誀", "貮", "貳", "贰", "髶"],
  chù: [
    "亍",
    "傗",
    "儊",
    "怵",
    "憷",
    "搐",
    "斶",
    "歜",
    "珿",
    "琡",
    "矗",
    "竌",
    "絀",
    "绌",
    "臅",
    "触",
    "觸",
    "豖",
    "鄐",
    "閦",
    "黜"
  ],
  kuī: ["亏", "刲", "岿", "巋", "盔", "窥", "窺", "聧", "虧", "闚", "顝"],
  yún: [
    "云",
    "伝",
    "勻",
    "匀",
    "囩",
    "妘",
    "愪",
    "抣",
    "昀",
    "橒",
    "沄",
    "涢",
    "溳",
    "澐",
    "熉",
    "畇",
    "秐",
    "筼",
    "篔",
    "紜",
    "縜",
    "纭",
    "耘",
    "芸",
    "蒷",
    "蕓",
    "郧",
    "鄖",
    "鋆",
    "雲"
  ],
  hù: [
    "互",
    "冱",
    "嗀",
    "嚛",
    "婟",
    "嫭",
    "嫮",
    "岵",
    "帍",
    "弖",
    "怙",
    "戶",
    "户",
    "戸",
    "戽",
    "扈",
    "护",
    "昈",
    "槴",
    "沍",
    "沪",
    "滬",
    "熩",
    "瓠",
    "祜",
    "笏",
    "簄",
    "粐",
    "綔",
    "蔰",
    "護",
    "豰",
    "鄠",
    "鍙",
    "頀",
    "鱯",
    "鳠",
    "鳸",
    "鸌",
    "鹱"
  ],
  qí: [
    "亓",
    "剘",
    "埼",
    "岐",
    "岓",
    "崎",
    "嵜",
    "愭",
    "掑",
    "斉",
    "斊",
    "旂",
    "旗",
    "棊",
    "棋",
    "檱",
    "櫀",
    "歧",
    "淇",
    "濝",
    "猉",
    "玂",
    "琦",
    "琪",
    "璂",
    "畦",
    "疧",
    "碁",
    "碕",
    "祁",
    "祈",
    "祺",
    "禥",
    "竒",
    "簯",
    "簱",
    "籏",
    "粸",
    "綥",
    "綦",
    "肵",
    "脐",
    "臍",
    "艩",
    "芪",
    "萁",
    "萕",
    "蕲",
    "藄",
    "蘄",
    "蚑",
    "蚚",
    "蛴",
    "蜝",
    "蜞",
    "螧",
    "蠐",
    "褀",
    "軝",
    "鄿",
    "釮",
    "錡",
    "锜",
    "陭",
    "頎",
    "颀",
    "騎",
    "騏",
    "騹",
    "骐",
    "骑",
    "鬐",
    "鬿",
    "鯕",
    "鰭",
    "鲯",
    "鳍",
    "鵸",
    "鶀",
    "麒",
    "麡",
    "𨙸",
    "𬨂",
    "䓫"
  ],
  jǐng: [
    "井",
    "儆",
    "刭",
    "剄",
    "坓",
    "宑",
    "幜",
    "憬",
    "暻",
    "殌",
    "汫",
    "汬",
    "澋",
    "璄",
    "璟",
    "璥",
    "穽",
    "肼",
    "蟼",
    "警",
    "阱",
    "頚",
    "頸"
  ],
  sì: [
    "亖",
    "佀",
    "価",
    "儩",
    "兕",
    "嗣",
    "四",
    "姒",
    "娰",
    "孠",
    "寺",
    "巳",
    "柶",
    "榹",
    "汜",
    "泗",
    "泤",
    "洍",
    "洠",
    "涘",
    "瀃",
    "牭",
    "祀",
    "禩",
    "竢",
    "笥",
    "耜",
    "肂",
    "肆",
    "蕼",
    "覗",
    "貄",
    "釲",
    "鈶",
    "鈻",
    "飤",
    "飼",
    "饲",
    "駟",
    "騃",
    "驷"
  ],
  suì: [
    "亗",
    "嬘",
    "岁",
    "嵗",
    "旞",
    "檖",
    "歲",
    "歳",
    "澻",
    "煫",
    "燧",
    "璲",
    "砕",
    "碎",
    "祟",
    "禭",
    "穂",
    "穗",
    "穟",
    "繀",
    "繐",
    "繸",
    "襚",
    "誶",
    "譢",
    "谇",
    "賥",
    "邃",
    "鐆",
    "鐩",
    "隧",
    "韢",
    "𫟦",
    "𬭼"
  ],
  gèn: ["亘", "亙", "揯", "搄", "茛"],
  yà: [
    "亚",
    "亜",
    "俹",
    "冴",
    "劜",
    "圔",
    "圠",
    "埡",
    "娅",
    "婭",
    "揠",
    "氩",
    "氬",
    "犽",
    "砑",
    "稏",
    "聐",
    "襾",
    "覀",
    "訝",
    "讶",
    "迓",
    "齾"
  ],
  "xiē suò": ["些"],
  "qí zhāi": ["亝", "齊"],
  "yā yà": ["亞", "压", "垭", "壓", "铔"],
  "jí qì": ["亟", "焏"],
  tóu: ["亠", "投", "頭", "骰"],
  "wáng wú": ["亡"],
  "kàng háng gāng": ["亢"],
  dà: ["亣", "眔"],
  jiāo: [
    "交",
    "僬",
    "娇",
    "嬌",
    "峧",
    "嶕",
    "嶣",
    "憍",
    "椒",
    "浇",
    "澆",
    "焦",
    "礁",
    "穚",
    "簥",
    "胶",
    "膠",
    "膲",
    "茭",
    "茮",
    "蕉",
    "虠",
    "蛟",
    "蟭",
    "跤",
    "轇",
    "郊",
    "鐎",
    "驕",
    "骄",
    "鮫",
    "鲛",
    "鵁",
    "鷦",
    "鷮",
    "鹪",
    "䴔"
  ],
  hài: ["亥", "嗐", "害", "氦", "餀", "饚", "駭", "駴", "骇"],
  "hēng pēng": ["亨"],
  mǔ: [
    "亩",
    "姆",
    "峔",
    "拇",
    "母",
    "牡",
    "牳",
    "畂",
    "畆",
    "畒",
    "畝",
    "畞",
    "畮",
    "砪",
    "胟",
    "踇",
    "鉧",
    "𬭁",
    "𧿹"
  ],
  ye: ["亪"],
  xiǎng: [
    "享",
    "亯",
    "响",
    "想",
    "晑",
    "蚃",
    "蠁",
    "響",
    "飨",
    "餉",
    "饗",
    "饷",
    "鮝",
    "鯗",
    "鱶",
    "鲞"
  ],
  jīng: [
    "京",
    "亰",
    "兢",
    "坕",
    "坙",
    "婛",
    "惊",
    "旌",
    "旍",
    "晶",
    "橸",
    "泾",
    "涇",
    "猄",
    "睛",
    "秔",
    "稉",
    "粳",
    "精",
    "経",
    "經",
    "綡",
    "聙",
    "腈",
    "茎",
    "荆",
    "荊",
    "菁",
    "葏",
    "驚",
    "鯨",
    "鲸",
    "鶁",
    "鶄",
    "麖",
    "麠",
    "鼱",
    "䴖"
  ],
  tíng: [
    "亭",
    "停",
    "婷",
    "嵉",
    "庭",
    "廷",
    "楟",
    "榳",
    "筳",
    "聤",
    "莛",
    "葶",
    "蜓",
    "蝏",
    "諪",
    "邒",
    "霆",
    "鼮",
    "䗴"
  ],
  liàng: ["亮", "喨", "悢", "晾", "湸", "諒", "谅", "輌", "輛", "辆", "鍄"],
  "qīn qìng": ["亲", "親"],
  bó: [
    "亳",
    "仢",
    "侼",
    "僰",
    "博",
    "帛",
    "愽",
    "懪",
    "挬",
    "搏",
    "欂",
    "浡",
    "淿",
    "渤",
    "煿",
    "牔",
    "狛",
    "瓝",
    "礴",
    "秡",
    "箔",
    "簙",
    "糪",
    "胉",
    "脖",
    "膊",
    "舶",
    "艊",
    "萡",
    "葧",
    "袯",
    "襏",
    "襮",
    "謈",
    "踣",
    "郣",
    "鈸",
    "鉑",
    "鋍",
    "鎛",
    "鑮",
    "钹",
    "铂",
    "镈",
    "餺",
    "馎",
    "馛",
    "馞",
    "駁",
    "駮",
    "驳",
    "髆",
    "鵓",
    "鹁"
  ],
  yòu: [
    "亴",
    "佑",
    "佦",
    "侑",
    "又",
    "右",
    "哊",
    "唀",
    "囿",
    "姷",
    "宥",
    "峟",
    "幼",
    "狖",
    "祐",
    "蚴",
    "誘",
    "诱",
    "貁",
    "迶",
    "酭",
    "釉",
    "鼬"
  ],
  xiè: [
    "亵",
    "伳",
    "偞",
    "偰",
    "僁",
    "卨",
    "卸",
    "噧",
    "塮",
    "夑",
    "媟",
    "屑",
    "屧",
    "廨",
    "徢",
    "懈",
    "暬",
    "械",
    "榍",
    "榭",
    "泻",
    "洩",
    "渫",
    "澥",
    "瀉",
    "瀣",
    "灺",
    "炧",
    "炨",
    "燮",
    "爕",
    "獬",
    "祄",
    "禼",
    "糏",
    "紲",
    "絏",
    "絬",
    "繲",
    "纈",
    "绁",
    "缷",
    "薢",
    "薤",
    "蟹",
    "蠏",
    "褉",
    "褻",
    "謝",
    "谢",
    "躞",
    "邂",
    "靾",
    "韰",
    "齂",
    "齘",
    "齛",
    "齥",
    "𬹼",
    "𤫉"
  ],
  "dǎn dàn": ["亶", "馾"],
  lián: [
    "亷",
    "劆",
    "匲",
    "匳",
    "嗹",
    "噒",
    "奁",
    "奩",
    "嫾",
    "帘",
    "廉",
    "怜",
    "憐",
    "涟",
    "漣",
    "濂",
    "濓",
    "瀮",
    "熑",
    "燫",
    "簾",
    "籢",
    "籨",
    "縺",
    "翴",
    "联",
    "聨",
    "聫",
    "聮",
    "聯",
    "臁",
    "莲",
    "蓮",
    "薕",
    "螊",
    "蠊",
    "裢",
    "褳",
    "覝",
    "謰",
    "蹥",
    "连",
    "連",
    "鎌",
    "鐮",
    "镰",
    "鬑",
    "鰱",
    "鲢"
  ],
  duǒ: [
    "亸",
    "哚",
    "嚲",
    "埵",
    "崜",
    "朵",
    "朶",
    "綞",
    "缍",
    "趓",
    "躱",
    "躲",
    "軃"
  ],
  "wěi mén": ["亹", "斖"],
  rén: ["人", "亻", "仁", "壬", "忈", "忎", "朲", "秂", "芢", "魜", "鵀"],
  jí: [
    "亼",
    "亽",
    "伋",
    "佶",
    "偮",
    "卙",
    "即",
    "卽",
    "及",
    "叝",
    "吉",
    "堲",
    "塉",
    "姞",
    "嫉",
    "岌",
    "嵴",
    "嶯",
    "彶",
    "忣",
    "急",
    "愱",
    "戢",
    "揤",
    "极",
    "棘",
    "楫",
    "極",
    "槉",
    "檝",
    "殛",
    "汲",
    "湒",
    "潗",
    "疾",
    "瘠",
    "皍",
    "笈",
    "箿",
    "籍",
    "級",
    "级",
    "膌",
    "艥",
    "蒺",
    "蕀",
    "蕺",
    "蝍",
    "螏",
    "襋",
    "觙",
    "谻",
    "踖",
    "蹐",
    "躤",
    "輯",
    "轚",
    "辑",
    "郆",
    "銡",
    "鍓",
    "鏶",
    "集",
    "雧",
    "霵",
    "鹡",
    "㴔"
  ],
  wáng: ["亾", "仼", "兦", "莣", "蚟"],
  "shén shí": ["什"],
  lè: [
    "仂",
    "叻",
    "忇",
    "氻",
    "泐",
    "玏",
    "砳",
    "簕",
    "艻",
    "阞",
    "韷",
    "餎",
    "鰳",
    "鱳",
    "鳓"
  ],
  dīng: ["仃", "叮", "帄", "玎", "疔", "盯", "耵", "虰", "靪"],
  zè: ["仄", "崱", "庂", "捑", "昃", "昗", "汄"],
  "jǐn jìn": ["仅", "僅", "嫤"],
  "pú pū": ["仆"],
  "chóu qiú": ["仇"],
  zhǎng: ["仉", "幥", "掌", "礃"],
  jīn: [
    "今",
    "堻",
    "巾",
    "惍",
    "斤",
    "津",
    "珒",
    "琻",
    "璡",
    "砛",
    "筋",
    "荕",
    "衿",
    "襟",
    "觔",
    "金",
    "釒",
    "釿",
    "钅",
    "鹶",
    "黅",
    "𬬱"
  ],
  bīng: ["仌", "仒", "兵", "冫", "冰", "掤", "氷", "鋲"],
  réng: ["仍", "礽", "芿", "辸", "陾"],
  fó: ["仏", "坲", "梻"],
  "jīn sǎn": ["仐"],
  lún: [
    "仑",
    "伦",
    "侖",
    "倫",
    "囵",
    "圇",
    "婨",
    "崘",
    "崙",
    "棆",
    "沦",
    "淪",
    "磮",
    "腀",
    "菕",
    "蜦",
    "踚",
    "輪",
    "轮",
    "錀",
    "陯",
    "鯩",
    "𬬭"
  ],
  cāng: [
    "仓",
    "仺",
    "倉",
    "凔",
    "嵢",
    "沧",
    "滄",
    "濸",
    "獊",
    "舱",
    "艙",
    "苍",
    "蒼",
    "螥",
    "鸧"
  ],
  "zǎi zǐ zī": ["仔"],
  tā: ["他", "塌", "它", "榙", "溻", "牠", "祂", "褟", "趿", "遢", "闧"],
  fù: [
    "付",
    "偩",
    "傅",
    "冨",
    "副",
    "咐",
    "坿",
    "复",
    "妇",
    "婦",
    "媍",
    "嬔",
    "富",
    "復",
    "椱",
    "祔",
    "禣",
    "竎",
    "緮",
    "縛",
    "缚",
    "腹",
    "萯",
    "蕧",
    "蚹",
    "蛗",
    "蝜",
    "蝮",
    "袝",
    "複",
    "覄",
    "覆",
    "訃",
    "詂",
    "讣",
    "負",
    "賦",
    "賻",
    "负",
    "赋",
    "赙",
    "赴",
    "輹",
    "鍑",
    "鍢",
    "阜",
    "附",
    "馥",
    "駙",
    "驸",
    "鮒",
    "鰒",
    "鲋",
    "鳆",
    "㳇"
  ],
  xiān: [
    "仙",
    "仚",
    "佡",
    "僊",
    "僲",
    "先",
    "嘕",
    "奾",
    "屳",
    "廯",
    "忺",
    "憸",
    "掀",
    "暹",
    "杴",
    "氙",
    "珗",
    "祆",
    "秈",
    "籼",
    "繊",
    "纎",
    "纖",
    "苮",
    "褼",
    "襳",
    "跹",
    "蹮",
    "躚",
    "酰",
    "鍁",
    "锨",
    "韯",
    "韱",
    "馦",
    "鱻",
    "鶱",
    "𬸣"
  ],
  "tuō chà duó": ["仛"],
  hóng: [
    "仜",
    "吰",
    "垬",
    "妅",
    "娂",
    "宏",
    "宖",
    "弘",
    "彋",
    "汯",
    "泓",
    "洪",
    "浤",
    "渱",
    "潂",
    "玒",
    "玜",
    "竑",
    "竤",
    "篊",
    "粠",
    "紘",
    "紭",
    "綋",
    "纮",
    "翃",
    "翝",
    "耾",
    "苰",
    "荭",
    "葒",
    "葓",
    "谹",
    "谼",
    "鈜",
    "鉷",
    "鋐",
    "閎",
    "闳",
    "霐",
    "霟",
    "鞃",
    "魟",
    "鴻",
    "鸿",
    "黉",
    "黌",
    "𫟹",
    "𬭎"
  ],
  tóng: [
    "仝",
    "佟",
    "哃",
    "峂",
    "峝",
    "庝",
    "彤",
    "晍",
    "曈",
    "桐",
    "氃",
    "浵",
    "潼",
    "犝",
    "獞",
    "眮",
    "瞳",
    "砼",
    "秱",
    "童",
    "粡",
    "膧",
    "茼",
    "蚒",
    "詷",
    "赨",
    "酮",
    "鉖",
    "鉵",
    "銅",
    "铜",
    "餇",
    "鮦",
    "鲖",
    "𫍣",
    "𦒍"
  ],
  rèn: [
    "仞",
    "仭",
    "刃",
    "刄",
    "妊",
    "姙",
    "屻",
    "岃",
    "扨",
    "牣",
    "祍",
    "紉",
    "紝",
    "絍",
    "纫",
    "纴",
    "肕",
    "腍",
    "衽",
    "袵",
    "訒",
    "認",
    "认",
    "讱",
    "軔",
    "轫",
    "鈓",
    "靭",
    "靱",
    "韌",
    "韧",
    "飪",
    "餁",
    "饪"
  ],
  qiān: [
    "仟",
    "佥",
    "僉",
    "千",
    "圲",
    "奷",
    "孯",
    "岍",
    "悭",
    "愆",
    "慳",
    "扦",
    "拪",
    "搴",
    "撁",
    "攐",
    "攑",
    "攓",
    "杄",
    "櫏",
    "汘",
    "汧",
    "牵",
    "牽",
    "竏",
    "签",
    "簽",
    "籖",
    "籤",
    "粁",
    "芊",
    "茾",
    "蚈",
    "褰",
    "諐",
    "謙",
    "谦",
    "谸",
    "迁",
    "遷",
    "釺",
    "鈆",
    "鉛",
    "鏲",
    "钎",
    "阡",
    "韆",
    "顅",
    "騫",
    "骞",
    "鬜",
    "鬝",
    "鵮",
    "鹐"
  ],
  "gǎn hàn": ["仠"],
  "yì gē": ["仡"],
  dài: [
    "代",
    "侢",
    "叇",
    "垈",
    "埭",
    "岱",
    "帒",
    "带",
    "帯",
    "帶",
    "廗",
    "怠",
    "戴",
    "曃",
    "柋",
    "殆",
    "瀻",
    "玳",
    "瑇",
    "甙",
    "簤",
    "紿",
    "緿",
    "绐",
    "艜",
    "蝳",
    "袋",
    "襶",
    "貣",
    "贷",
    "蹛",
    "軑",
    "軚",
    "軩",
    "轪",
    "迨",
    "霴",
    "靆",
    "鴏",
    "黛",
    "黱"
  ],
  "lìng líng lǐng": ["令"],
  chào: ["仦", "耖", "觘"],
  "cháng zhǎng": ["仧", "兏", "長", "长"],
  sā: ["仨"],
  cháng: [
    "仩",
    "偿",
    "償",
    "嘗",
    "嚐",
    "嫦",
    "尝",
    "常",
    "徜",
    "瑺",
    "瓺",
    "甞",
    "肠",
    "腸",
    "膓",
    "苌",
    "萇",
    "镸",
    "鱨",
    "鲿"
  ],
  yí: [
    "仪",
    "侇",
    "儀",
    "冝",
    "匜",
    "咦",
    "圯",
    "夷",
    "姨",
    "宐",
    "宜",
    "宧",
    "寲",
    "峓",
    "嶬",
    "嶷",
    "巸",
    "彛",
    "彜",
    "彝",
    "彞",
    "怡",
    "恞",
    "扅",
    "暆",
    "栘",
    "椬",
    "椸",
    "沂",
    "洟",
    "熪",
    "瓵",
    "痍",
    "移",
    "簃",
    "籎",
    "羠",
    "胰",
    "萓",
    "蛦",
    "螔",
    "觺",
    "謻",
    "貽",
    "贻",
    "跠",
    "迻",
    "遺",
    "鏔",
    "頉",
    "頤",
    "頥",
    "顊",
    "颐",
    "饴",
    "鮧",
    "鴺"
  ],
  mù: [
    "仫",
    "凩",
    "募",
    "墓",
    "幕",
    "幙",
    "慔",
    "慕",
    "暮",
    "暯",
    "木",
    "楘",
    "毣",
    "沐",
    "炑",
    "牧",
    "狇",
    "目",
    "睦",
    "穆",
    "艒",
    "苜",
    "莯",
    "蚞",
    "鉬",
    "钼",
    "雮",
    "霂"
  ],
  "men mén": ["们"],
  fǎn: ["仮", "反", "橎", "返"],
  "chào miǎo": ["仯"],
  "yǎng áng": ["仰"],
  zhòng: [
    "仲",
    "众",
    "堹",
    "妕",
    "媑",
    "狆",
    "眾",
    "祌",
    "筗",
    "茽",
    "蚛",
    "衆",
    "衶",
    "諥"
  ],
  "pǐ pí": ["仳"],
  wò: [
    "仴",
    "偓",
    "卧",
    "媉",
    "幄",
    "握",
    "楃",
    "沃",
    "渥",
    "濣",
    "瓁",
    "瞃",
    "硪",
    "肟",
    "腛",
    "臥",
    "齷",
    "龌"
  ],
  jiàn: [
    "件",
    "俴",
    "健",
    "僭",
    "剑",
    "剣",
    "剱",
    "劍",
    "劎",
    "劒",
    "劔",
    "墹",
    "寋",
    "建",
    "徤",
    "擶",
    "旔",
    "楗",
    "毽",
    "洊",
    "涧",
    "澗",
    "牮",
    "珔",
    "瞷",
    "磵",
    "礀",
    "箭",
    "糋",
    "繝",
    "腱",
    "臶",
    "舰",
    "艦",
    "荐",
    "薦",
    "覸",
    "諓",
    "諫",
    "譛",
    "谏",
    "賎",
    "賤",
    "贱",
    "趝",
    "践",
    "踐",
    "踺",
    "轞",
    "鉴",
    "鍳",
    "鍵",
    "鐱",
    "鑑",
    "鑒",
    "鑬",
    "鑳",
    "键",
    "間",
    "餞",
    "饯",
    "𬣡"
  ],
  "jià jiè jie": ["价"],
  "yǎo fó": ["仸"],
  "rèn rén": ["任"],
  "fèn bīn": ["份"],
  dī: [
    "仾",
    "低",
    "啲",
    "埞",
    "堤",
    "岻",
    "彽",
    "樀",
    "滴",
    "磾",
    "秪",
    "羝",
    "袛",
    "趆",
    "隄",
    "鞮",
    "䃅"
  ],
  fǎng: [
    "仿",
    "倣",
    "旊",
    "昉",
    "昘",
    "瓬",
    "眆",
    "紡",
    "纺",
    "舫",
    "訪",
    "访",
    "髣",
    "鶭"
  ],
  zhōng: [
    "伀",
    "刣",
    "妐",
    "幒",
    "彸",
    "忠",
    "柊",
    "汷",
    "泈",
    "炂",
    "盅",
    "籦",
    "終",
    "终",
    "舯",
    "蔠",
    "蜙",
    "螤",
    "螽",
    "衳",
    "衷",
    "蹱",
    "鈡",
    "鍾",
    "鐘",
    "钟",
    "锺",
    "鴤",
    "鼨"
  ],
  pèi: [
    "伂",
    "佩",
    "姵",
    "帔",
    "斾",
    "旆",
    "沛",
    "浿",
    "珮",
    "蓜",
    "轡",
    "辔",
    "配",
    "霈",
    "馷"
  ],
  diào: [
    "伄",
    "吊",
    "弔",
    "掉",
    "瘹",
    "盄",
    "窎",
    "窵",
    "竨",
    "訋",
    "釣",
    "鈟",
    "銱",
    "鋽",
    "鑃",
    "钓",
    "铞",
    "雿",
    "魡"
  ],
  dùn: [
    "伅",
    "潡",
    "炖",
    "燉",
    "盾",
    "砘",
    "碷",
    "踲",
    "逇",
    "遁",
    "遯",
    "鈍",
    "钝"
  ],
  wěn: ["伆", "刎", "吻", "呅", "抆", "桽", "稳", "穏", "穩", "紊", "肳", "脗"],
  xǐn: ["伈"],
  kàng: ["伉", "匟", "囥", "抗", "炕", "鈧", "钪"],
  ài: [
    "伌",
    "僾",
    "塧",
    "壒",
    "嫒",
    "嬡",
    "愛",
    "懓",
    "暧",
    "曖",
    "爱",
    "瑷",
    "璦",
    "皧",
    "瞹",
    "砹",
    "硋",
    "碍",
    "礙",
    "薆",
    "譺",
    "賹",
    "鑀",
    "隘",
    "靉",
    "餲",
    "馤",
    "鱫",
    "鴱"
  ],
  "jì qí": ["伎", "薺"],
  "xiū xǔ": ["休"],
  "jìn yín": ["伒"],
  dǎn: [
    "伔",
    "刐",
    "撢",
    "玬",
    "瓭",
    "紞",
    "胆",
    "膽",
    "衴",
    "賧",
    "赕",
    "黕",
    "𬘘"
  ],
  fū: [
    "伕",
    "呋",
    "娐",
    "孵",
    "尃",
    "怤",
    "懯",
    "敷",
    "旉",
    "玞",
    "砆",
    "稃",
    "筟",
    "糐",
    "綒",
    "肤",
    "膚",
    "荂",
    "荴",
    "衭",
    "趺",
    "跗",
    "邞",
    "鄜",
    "酜",
    "鈇",
    "麩",
    "麬",
    "麱",
    "麸",
    "𫓧"
  ],
  tǎng: [
    "伖",
    "傥",
    "儻",
    "埫",
    "戃",
    "曭",
    "爣",
    "矘",
    "躺",
    "鎲",
    "钂",
    "镋"
  ],
  yōu: [
    "优",
    "優",
    "呦",
    "嚘",
    "峳",
    "幽",
    "忧",
    "悠",
    "憂",
    "攸",
    "櫌",
    "滺",
    "瀀",
    "纋",
    "羪",
    "耰",
    "逌",
    "鄾",
    "麀"
  ],
  huǒ: ["伙", "夥", "火", "煷", "邩", "鈥", "钬"],
  "huì kuài": ["会", "會", "浍", "璯"],
  yǔ: [
    "伛",
    "俁",
    "俣",
    "偊",
    "傴",
    "匬",
    "噳",
    "圄",
    "圉",
    "宇",
    "寙",
    "屿",
    "嶼",
    "庾",
    "挧",
    "敔",
    "斞",
    "楀",
    "瑀",
    "瘐",
    "祤",
    "禹",
    "穥",
    "窳",
    "羽",
    "與",
    "萭",
    "貐",
    "鄅",
    "頨",
    "麌",
    "齬",
    "龉",
    "㺄"
  ],
  cuì: [
    "伜",
    "啛",
    "忰",
    "悴",
    "毳",
    "淬",
    "焠",
    "疩",
    "瘁",
    "竁",
    "粋",
    "粹",
    "紣",
    "綷",
    "翆",
    "翠",
    "脃",
    "脆",
    "脺",
    "膬",
    "膵",
    "臎",
    "萃",
    "襊",
    "顇"
  ],
  sǎn: ["伞", "傘", "糤", "繖", "饊", "馓"],
  wěi: [
    "伟",
    "伪",
    "偉",
    "偽",
    "僞",
    "儰",
    "娓",
    "寪",
    "屗",
    "崣",
    "嶉",
    "徫",
    "愇",
    "捤",
    "暐",
    "梶",
    "洧",
    "浘",
    "渨",
    "炜",
    "煒",
    "猥",
    "玮",
    "瑋",
    "痿",
    "緯",
    "纬",
    "腲",
    "艉",
    "芛",
    "苇",
    "荱",
    "萎",
    "葦",
    "蒍",
    "蔿",
    "蜼",
    "諉",
    "诿",
    "踓",
    "鍡",
    "韑",
    "韙",
    "韡",
    "韪",
    "頠",
    "颹",
    "骩",
    "骪",
    "骫",
    "鮪",
    "鲔",
    "𫇭",
    "𬀩",
    "𬱟"
  ],
  "chuán zhuàn": ["传", "傳"],
  "chē jū": ["伡", "俥", "车"],
  "jū chē": ["車"],
  yá: [
    "伢",
    "厑",
    "厓",
    "堐",
    "岈",
    "崕",
    "崖",
    "涯",
    "漄",
    "牙",
    "玡",
    "琊",
    "睚",
    "笌",
    "芽",
    "蚜",
    "衙",
    "齖"
  ],
  qiàn: [
    "伣",
    "俔",
    "倩",
    "儙",
    "刋",
    "壍",
    "嬱",
    "悓",
    "棈",
    "椠",
    "槧",
    "欠",
    "歉",
    "皘",
    "篏",
    "篟",
    "縴",
    "芡",
    "蒨",
    "蔳",
    "輤",
    "𬘬"
  ],
  shāng: [
    "伤",
    "傷",
    "商",
    "墒",
    "慯",
    "殇",
    "殤",
    "滳",
    "漡",
    "熵",
    "蔏",
    "螪",
    "觞",
    "觴",
    "謪",
    "鬺"
  ],
  chāng: [
    "伥",
    "倀",
    "娼",
    "昌",
    "椙",
    "淐",
    "猖",
    "琩",
    "菖",
    "裮",
    "錩",
    "锠",
    "閶",
    "阊",
    "鯧",
    "鲳",
    "鼚"
  ],
  "chen cāng": ["伧"],
  xùn: [
    "伨",
    "侚",
    "卂",
    "噀",
    "巺",
    "巽",
    "徇",
    "愻",
    "殉",
    "殾",
    "汛",
    "潠",
    "狥",
    "蕈",
    "訊",
    "訓",
    "訙",
    "训",
    "讯",
    "迅",
    "迿",
    "逊",
    "遜",
    "鑂",
    "顨",
    "馴",
    "驯"
  ],
  xìn: ["伩", "囟", "孞", "脪", "舋", "衅", "訫", "釁", "阠", "顖"],
  chǐ: [
    "伬",
    "侈",
    "卶",
    "叺",
    "呎",
    "垑",
    "恥",
    "歯",
    "耻",
    "肔",
    "胣",
    "蚇",
    "裭",
    "褫",
    "豉",
    "鉹",
    "齒",
    "齿"
  ],
  "xián xuán": ["伭"],
  "nú nǔ": ["伮"],
  "bó bǎi": ["伯"],
  "gū gù": ["估"],
  nǐ: ["伱", "你", "儞", "孴", "拟", "擬", "旎", "晲", "狔", "苨", "薿", "隬"],
  "nì ní": ["伲"],
  bàn: [
    "伴",
    "办",
    "半",
    "姅",
    "怑",
    "扮",
    "瓣",
    "秚",
    "絆",
    "绊",
    "辦",
    "鉡",
    "靽"
  ],
  xù: [
    "伵",
    "侐",
    "勖",
    "勗",
    "卹",
    "叙",
    "垿",
    "壻",
    "婿",
    "序",
    "恤",
    "敍",
    "敘",
    "旭",
    "昫",
    "朂",
    "槒",
    "欰",
    "殈",
    "汿",
    "沀",
    "洫",
    "溆",
    "漵",
    "潊",
    "烅",
    "烼",
    "煦",
    "獝",
    "珬",
    "盢",
    "瞁",
    "稸",
    "絮",
    "続",
    "緒",
    "緖",
    "續",
    "绪",
    "续",
    "聓",
    "聟",
    "蓄",
    "藚",
    "訹",
    "賉",
    "酗",
    "頊",
    "鱮",
    "㳚"
  ],
  zhòu: [
    "伷",
    "僽",
    "冑",
    "呪",
    "咒",
    "咮",
    "宙",
    "昼",
    "晝",
    "甃",
    "皱",
    "皺",
    "籀",
    "籒",
    "籕",
    "粙",
    "紂",
    "縐",
    "纣",
    "绉",
    "胄",
    "荮",
    "葤",
    "詋",
    "酎",
    "駎",
    "驟",
    "骤",
    "㤘",
    "㑇"
  ],
  shēn: [
    "伸",
    "侁",
    "兟",
    "呻",
    "堔",
    "妽",
    "娠",
    "屾",
    "峷",
    "扟",
    "敒",
    "曑",
    "柛",
    "氠",
    "深",
    "燊",
    "珅",
    "甡",
    "甧",
    "申",
    "眒",
    "砷",
    "穼",
    "籶",
    "籸",
    "糂",
    "紳",
    "绅",
    "罙",
    "罧",
    "葠",
    "蓡",
    "蔘",
    "薓",
    "裑",
    "訷",
    "詵",
    "诜",
    "身",
    "駪",
    "鯓",
    "鯵",
    "鰺",
    "鲹",
    "鵢",
    "𬳽"
  ],
  qū: [
    "伹",
    "佉",
    "匤",
    "呿",
    "坥",
    "屈",
    "岖",
    "岴",
    "嶇",
    "憈",
    "抾",
    "敺",
    "浀",
    "煀",
    "祛",
    "筁",
    "粬",
    "胠",
    "蛆",
    "蛐",
    "袪",
    "覻",
    "詘",
    "诎",
    "趍",
    "躯",
    "軀",
    "阹",
    "駆",
    "駈",
    "驅",
    "驱",
    "髷",
    "魼",
    "鰸",
    "鱋",
    "鶌",
    "麯",
    "麴",
    "麹",
    "黢",
    "㭕",
    "𪨰",
    "䓛"
  ],
  "sì cì": ["伺"],
  bēng: ["伻", "嘣", "奟", "崩", "嵭", "閍"],
  "sì shì": ["似"],
  "jiā qié gā": ["伽"],
  "yǐ chì": ["佁"],
  "diàn tián": ["佃", "钿"],
  "hān gàn": ["佄"],
  mài: [
    "佅",
    "劢",
    "勱",
    "卖",
    "唛",
    "売",
    "脈",
    "衇",
    "賣",
    "迈",
    "邁",
    "霡",
    "霢",
    "麥",
    "麦",
    "鿏"
  ],
  dàn: [
    "但",
    "僤",
    "啖",
    "啗",
    "啿",
    "噉",
    "嚪",
    "帎",
    "憺",
    "旦",
    "柦",
    "氮",
    "沊",
    "泹",
    "淡",
    "狚",
    "疍",
    "癚",
    "禫",
    "窞",
    "腅",
    "萏",
    "蓞",
    "蛋",
    "蜑",
    "觛",
    "訑",
    "誕",
    "诞",
    "贉",
    "霮",
    "餤",
    "饏",
    "駳",
    "髧",
    "鴠",
    "𫢸"
  ],
  bù: [
    "佈",
    "勏",
    "吥",
    "咘",
    "埗",
    "埠",
    "布",
    "廍",
    "怖",
    "悑",
    "步",
    "歨",
    "歩",
    "瓿",
    "篰",
    "荹",
    "蔀",
    "踄",
    "部",
    "郶",
    "鈈",
    "钚",
    "餢"
  ],
  bǐ: [
    "佊",
    "俾",
    "匕",
    "夶",
    "妣",
    "彼",
    "朼",
    "柀",
    "比",
    "毞",
    "沘",
    "疕",
    "秕",
    "笔",
    "筆",
    "粃",
    "聛",
    "舭",
    "貏",
    "鄙"
  ],
  "zhāo shào": ["佋"],
  cǐ: ["佌", "此", "泚", "皉", "𫚖"],
  wèi: [
    "位",
    "卫",
    "味",
    "喂",
    "墛",
    "媦",
    "慰",
    "懀",
    "未",
    "渭",
    "煟",
    "熭",
    "犚",
    "猬",
    "畏",
    "緭",
    "罻",
    "胃",
    "苿",
    "菋",
    "藯",
    "蘶",
    "蝟",
    "螱",
    "衛",
    "衞",
    "褽",
    "謂",
    "讆",
    "讏",
    "谓",
    "躗",
    "躛",
    "軎",
    "轊",
    "鏏",
    "霨",
    "餧",
    "餵",
    "饖",
    "魏",
    "鮇",
    "鳚"
  ],
  zuǒ: ["佐", "左", "繓"],
  yǎng: [
    "佒",
    "傟",
    "养",
    "坱",
    "岟",
    "慃",
    "懩",
    "攁",
    "氧",
    "氱",
    "炴",
    "痒",
    "癢",
    "礢",
    "紻",
    "蝆",
    "軮",
    "養",
    "駚"
  ],
  "tǐ tī": ["体", "體"],
  zhàn: [
    "佔",
    "偡",
    "嶘",
    "战",
    "戦",
    "戰",
    "栈",
    "桟",
    "棧",
    "湛",
    "站",
    "綻",
    "绽",
    "菚",
    "蘸",
    "虥",
    "虦",
    "譧",
    "轏",
    "驏"
  ],
  "hé hē hè": ["何"],
  bì: [
    "佖",
    "咇",
    "哔",
    "嗶",
    "坒",
    "堛",
    "壁",
    "奰",
    "妼",
    "婢",
    "嬖",
    "币",
    "幣",
    "幤",
    "庇",
    "庳",
    "廦",
    "弊",
    "弻",
    "弼",
    "彃",
    "必",
    "怭",
    "愊",
    "愎",
    "敝",
    "斃",
    "梐",
    "毕",
    "毖",
    "毙",
    "湢",
    "滗",
    "滭",
    "潷",
    "煏",
    "熚",
    "狴",
    "獘",
    "獙",
    "珌",
    "璧",
    "畀",
    "畢",
    "疪",
    "痹",
    "痺",
    "皕",
    "睤",
    "碧",
    "筚",
    "箅",
    "箆",
    "篦",
    "篳",
    "粊",
    "綼",
    "縪",
    "繴",
    "罼",
    "腷",
    "苾",
    "荜",
    "萆",
    "萞",
    "蓖",
    "蓽",
    "蔽",
    "薜",
    "蜌",
    "袐",
    "襅",
    "襞",
    "襣",
    "觱",
    "詖",
    "诐",
    "貱",
    "贔",
    "赑",
    "跸",
    "蹕",
    "躃",
    "躄",
    "避",
    "邲",
    "鄨",
    "鄪",
    "鉍",
    "鏎",
    "鐴",
    "铋",
    "閇",
    "閉",
    "閟",
    "闭",
    "陛",
    "韠",
    "飶",
    "饆",
    "馝",
    "駜",
    "驆",
    "髀",
    "魓",
    "鮅",
    "鷝",
    "鷩",
    "鼊"
  ],
  tuó: [
    "佗",
    "坨",
    "堶",
    "岮",
    "槖",
    "橐",
    "沱",
    "砣",
    "砤",
    "碢",
    "紽",
    "詑",
    "跎",
    "酡",
    "阤",
    "陀",
    "陁",
    "駝",
    "駞",
    "騨",
    "驒",
    "驝",
    "驼",
    "鮀",
    "鴕",
    "鸵",
    "鼉",
    "鼍",
    "鼧",
    "𬶍"
  ],
  shé: ["佘", "舌", "虵", "蛥"],
  "yì dié": ["佚", "昳", "泆", "軼"],
  "fó fú bì bó": ["佛"],
  "zuò zuō": ["作"],
  gōu: [
    "佝",
    "沟",
    "溝",
    "痀",
    "篝",
    "簼",
    "緱",
    "缑",
    "袧",
    "褠",
    "鈎",
    "鉤",
    "钩",
    "鞲",
    "韝"
  ],
  nìng: ["佞", "侫", "倿", "寕", "泞", "澝", "濘"],
  qú: [
    "佢",
    "劬",
    "戵",
    "斪",
    "欋",
    "欔",
    "氍",
    "淭",
    "灈",
    "爠",
    "璖",
    "璩",
    "癯",
    "磲",
    "籧",
    "絇",
    "胊",
    "臞",
    "菃",
    "葋",
    "蕖",
    "蘧",
    "蟝",
    "蠷",
    "蠼",
    "衐",
    "衢",
    "躣",
    "軥",
    "鑺",
    "鴝",
    "鸜",
    "鸲",
    "鼩"
  ],
  "yōng yòng": ["佣"],
  wǎ: ["佤", "咓", "砙", "邷"],
  kǎ: ["佧", "垰", "胩", "裃", "鉲"],
  bāo: [
    "佨",
    "勹",
    "包",
    "孢",
    "煲",
    "笣",
    "胞",
    "苞",
    "蕔",
    "裦",
    "褒",
    "襃",
    "闁",
    "齙",
    "龅"
  ],
  "huái huí": ["佪"],
  "gé hè": ["佫"],
  lǎo: [
    "佬",
    "咾",
    "恅",
    "栳",
    "狫",
    "珯",
    "硓",
    "老",
    "耂",
    "荖",
    "蛯",
    "轑",
    "銠",
    "铑",
    "鮱"
  ],
  xiáng: ["佭", "庠", "栙", "祥", "絴", "翔", "詳", "跭"],
  gé: [
    "佮",
    "匌",
    "呄",
    "嗝",
    "塥",
    "愅",
    "挌",
    "搿",
    "槅",
    "櫊",
    "滆",
    "膈",
    "臵",
    "茖",
    "觡",
    "諽",
    "輵",
    "轕",
    "閣",
    "阁",
    "隔",
    "鞷",
    "韐",
    "韚",
    "騔",
    "骼",
    "鮯"
  ],
  yáng: [
    "佯",
    "劷",
    "垟",
    "崸",
    "徉",
    "扬",
    "揚",
    "敭",
    "旸",
    "昜",
    "暘",
    "杨",
    "楊",
    "洋",
    "炀",
    "珜",
    "疡",
    "瘍",
    "眻",
    "蛘",
    "諹",
    "輰",
    "鍚",
    "钖",
    "阦",
    "阳",
    "陽",
    "霷",
    "颺",
    "飏",
    "鰑",
    "鴹",
    "鸉"
  ],
  bǎi: ["佰", "捭", "摆", "擺", "栢", "百", "竡", "粨", "襬"],
  fǎ: ["佱", "峜", "法", "灋", "砝", "鍅"],
  mǐng: ["佲", "凕", "姳", "慏", "酩"],
  "èr nài": ["佴"],
  hěn: ["佷", "很", "狠", "詪", "𬣳"],
  huó: ["佸", "活"],
  guǐ: [
    "佹",
    "匦",
    "匭",
    "厬",
    "垝",
    "姽",
    "宄",
    "庋",
    "庪",
    "恑",
    "晷",
    "湀",
    "癸",
    "祪",
    "簋",
    "蛫",
    "蟡",
    "觤",
    "詭",
    "诡",
    "軌",
    "轨",
    "陒",
    "鬼"
  ],
  quán: [
    "佺",
    "全",
    "啳",
    "埢",
    "姾",
    "峑",
    "巏",
    "拳",
    "搼",
    "权",
    "楾",
    "権",
    "權",
    "泉",
    "洤",
    "湶",
    "牷",
    "犈",
    "瑔",
    "痊",
    "硂",
    "筌",
    "縓",
    "荃",
    "葲",
    "蜷",
    "蠸",
    "觠",
    "詮",
    "诠",
    "跧",
    "踡",
    "輇",
    "辁",
    "醛",
    "銓",
    "铨",
    "闎",
    "顴",
    "颧",
    "駩",
    "騡",
    "鬈",
    "鰁",
    "鳈",
    "齤"
  ],
  tiāo: ["佻", "庣", "旫", "祧", "聎"],
  jiǎo: [
    "佼",
    "儌",
    "孂",
    "挢",
    "搅",
    "撟",
    "撹",
    "攪",
    "敫",
    "敽",
    "敿",
    "晈",
    "暞",
    "曒",
    "灚",
    "燞",
    "狡",
    "璬",
    "皎",
    "皦",
    "絞",
    "纐",
    "绞",
    "腳",
    "臫",
    "蟜",
    "譑",
    "賋",
    "踋",
    "鉸",
    "铰",
    "餃",
    "饺",
    "鱎",
    "龣"
  ],
  cì: [
    "佽",
    "刾",
    "庛",
    "朿",
    "栨",
    "次",
    "絘",
    "茦",
    "莿",
    "蛓",
    "螆",
    "賜",
    "赐"
  ],
  xíng: [
    "侀",
    "刑",
    "哘",
    "型",
    "娙",
    "形",
    "洐",
    "硎",
    "蛵",
    "邢",
    "郉",
    "鈃",
    "鉶",
    "銒",
    "钘",
    "铏",
    "陉",
    "陘",
    "餳",
    "𫰛"
  ],
  tuō: [
    "侂",
    "咃",
    "咜",
    "圫",
    "托",
    "拕",
    "拖",
    "汑",
    "脫",
    "脱",
    "莌",
    "袥",
    "託",
    "讬",
    "飥",
    "饦",
    "魠",
    "鮵"
  ],
  kǎn: ["侃", "偘", "冚", "坎", "惂", "砍", "莰", "輡", "轗", "顑"],
  zhí: [
    "侄",
    "値",
    "值",
    "埴",
    "執",
    "姪",
    "嬂",
    "戠",
    "执",
    "摭",
    "植",
    "樴",
    "淔",
    "漐",
    "直",
    "禃",
    "絷",
    "縶",
    "聀",
    "职",
    "職",
    "膱",
    "蟙",
    "跖",
    "踯",
    "蹠",
    "躑",
    "軄",
    "釞",
    "馽"
  ],
  gāi: [
    "侅",
    "垓",
    "姟",
    "峐",
    "晐",
    "畡",
    "祴",
    "荄",
    "該",
    "该",
    "豥",
    "賅",
    "賌",
    "赅",
    "陔"
  ],
  lái: [
    "來",
    "俫",
    "倈",
    "崃",
    "崍",
    "庲",
    "来",
    "梾",
    "棶",
    "涞",
    "淶",
    "猍",
    "琜",
    "筙",
    "箂",
    "莱",
    "萊",
    "逨",
    "郲",
    "錸",
    "铼",
    "騋",
    "鯠",
    "鶆",
    "麳"
  ],
  kuǎ: ["侉", "咵", "垮", "銙"],
  gōng: [
    "侊",
    "公",
    "功",
    "匑",
    "匔",
    "塨",
    "宫",
    "宮",
    "工",
    "幊",
    "弓",
    "恭",
    "攻",
    "杛",
    "碽",
    "糼",
    "糿",
    "肱",
    "觥",
    "觵",
    "躬",
    "躳",
    "髸",
    "龔",
    "龚",
    "䢼"
  ],
  lì: [
    "例",
    "俐",
    "俪",
    "傈",
    "儮",
    "儷",
    "凓",
    "利",
    "力",
    "励",
    "勵",
    "历",
    "厉",
    "厤",
    "厯",
    "厲",
    "叓",
    "吏",
    "呖",
    "唎",
    "唳",
    "嚦",
    "囇",
    "坜",
    "塛",
    "壢",
    "娳",
    "婯",
    "屴",
    "岦",
    "悧",
    "悷",
    "慄",
    "戾",
    "搮",
    "暦",
    "曆",
    "曞",
    "朸",
    "枥",
    "栃",
    "栗",
    "栛",
    "檪",
    "櫔",
    "櫪",
    "欐",
    "歴",
    "歷",
    "沥",
    "沴",
    "涖",
    "溧",
    "濿",
    "瀝",
    "爏",
    "犡",
    "猁",
    "珕",
    "瑮",
    "瓅",
    "瓑",
    "瓥",
    "疬",
    "痢",
    "癧",
    "盭",
    "睙",
    "砅",
    "砺",
    "砾",
    "磿",
    "礪",
    "礫",
    "礰",
    "禲",
    "秝",
    "立",
    "笠",
    "篥",
    "粒",
    "粝",
    "糲",
    "脷",
    "苈",
    "茘",
    "荔",
    "莅",
    "莉",
    "蒚",
    "蒞",
    "藶",
    "蚸",
    "蛎",
    "蛠",
    "蜧",
    "蝷",
    "蠇",
    "蠣",
    "詈",
    "讈",
    "赲",
    "轢",
    "轣",
    "轹",
    "酈",
    "鉝",
    "隶",
    "隷",
    "雳",
    "靂",
    "靋",
    "鬁",
    "鳨",
    "鴗",
    "鷅",
    "麜",
    "𫵷",
    "𬍛"
  ],
  yīn: [
    "侌",
    "凐",
    "喑",
    "噾",
    "囙",
    "因",
    "垔",
    "堙",
    "姻",
    "婣",
    "愔",
    "慇",
    "栶",
    "氤",
    "洇",
    "溵",
    "濦",
    "瘖",
    "禋",
    "秵",
    "筃",
    "絪",
    "緸",
    "茵",
    "蒑",
    "蔭",
    "裀",
    "諲",
    "銦",
    "铟",
    "闉",
    "阥",
    "阴",
    "陰",
    "陻",
    "隂",
    "霒",
    "霠",
    "鞇",
    "音",
    "韾",
    "駰",
    "骃",
    "齗",
    "𬘡",
    "𬤇",
    "𬮱"
  ],
  mǐ: [
    "侎",
    "孊",
    "弭",
    "敉",
    "洣",
    "渳",
    "灖",
    "米",
    "粎",
    "羋",
    "脒",
    "芈",
    "葞",
    "蔝",
    "銤"
  ],
  zhū: [
    "侏",
    "株",
    "槠",
    "橥",
    "櫧",
    "櫫",
    "洙",
    "潴",
    "瀦",
    "猪",
    "珠",
    "硃",
    "秼",
    "絑",
    "茱",
    "蕏",
    "蛛",
    "蝫",
    "蠩",
    "袾",
    "誅",
    "諸",
    "诛",
    "诸",
    "豬",
    "跦",
    "邾",
    "銖",
    "铢",
    "駯",
    "鮢",
    "鯺",
    "鴸",
    "鼄"
  ],
  ān: [
    "侒",
    "偣",
    "媕",
    "安",
    "峖",
    "庵",
    "桉",
    "氨",
    "盦",
    "盫",
    "腤",
    "菴",
    "萻",
    "葊",
    "蓭",
    "誝",
    "諳",
    "谙",
    "鞌",
    "鞍",
    "韽",
    "馣",
    "鮟",
    "鵪",
    "鶕",
    "鹌",
    "𩽾"
  ],
  lù: [
    "侓",
    "僇",
    "勎",
    "勠",
    "圥",
    "坴",
    "塶",
    "娽",
    "峍",
    "廘",
    "彔",
    "录",
    "戮",
    "摝",
    "椂",
    "樚",
    "淕",
    "淥",
    "渌",
    "漉",
    "潞",
    "琭",
    "璐",
    "甪",
    "盝",
    "睩",
    "硉",
    "祿",
    "禄",
    "稑",
    "穋",
    "箓",
    "簏",
    "簬",
    "簵",
    "簶",
    "籙",
    "粶",
    "蔍",
    "蕗",
    "虂",
    "螰",
    "賂",
    "赂",
    "趢",
    "路",
    "踛",
    "蹗",
    "輅",
    "轆",
    "辂",
    "辘",
    "逯",
    "醁",
    "錄",
    "録",
    "錴",
    "鏴",
    "陸",
    "騄",
    "騼",
    "鯥",
    "鴼",
    "鵦",
    "鵱",
    "鷺",
    "鹭",
    "鹿",
    "麓",
    "𫘧"
  ],
  móu: ["侔", "劺", "恈", "眸", "蛑", "謀", "谋", "踎", "鍪", "鴾", "麰"],
  ér: [
    "侕",
    "儿",
    "児",
    "兒",
    "峏",
    "栭",
    "洏",
    "粫",
    "而",
    "胹",
    "荋",
    "袻",
    "輀",
    "轜",
    "陑",
    "隭",
    "髵",
    "鮞",
    "鲕",
    "鴯",
    "鸸"
  ],
  "dòng tǒng tóng": ["侗"],
  chà: ["侘", "奼", "姹", "岔", "汊", "詫", "诧"],
  chì: [
    "侙",
    "傺",
    "勅",
    "勑",
    "叱",
    "啻",
    "彳",
    "恜",
    "慗",
    "憏",
    "懘",
    "抶",
    "敕",
    "斥",
    "杘",
    "湁",
    "灻",
    "炽",
    "烾",
    "熾",
    "痓",
    "痸",
    "瘛",
    "翄",
    "翅",
    "翤",
    "翨",
    "腟",
    "赤",
    "趩",
    "遫",
    "鉓",
    "雴",
    "飭",
    "饬",
    "鶒",
    "鷘"
  ],
  "gòng gōng": ["供", "共"],
  zhōu: [
    "侜",
    "周",
    "喌",
    "州",
    "徟",
    "洲",
    "淍",
    "炿",
    "烐",
    "珘",
    "矪",
    "舟",
    "謅",
    "譸",
    "诌",
    "賙",
    "赒",
    "輈",
    "輖",
    "辀",
    "週",
    "郮",
    "銂",
    "霌",
    "駲",
    "騆",
    "鵃",
    "鸼"
  ],
  rú: [
    "侞",
    "儒",
    "嚅",
    "如",
    "嬬",
    "孺",
    "帤",
    "曘",
    "桇",
    "渪",
    "濡",
    "筎",
    "茹",
    "蕠",
    "薷",
    "蝡",
    "蠕",
    "袽",
    "襦",
    "邚",
    "醹",
    "銣",
    "铷",
    "顬",
    "颥",
    "鱬",
    "鴑",
    "鴽"
  ],
  "jiàn cún": ["侟"],
  xiá: [
    "侠",
    "俠",
    "匣",
    "峡",
    "峽",
    "敮",
    "暇",
    "柙",
    "炠",
    "烚",
    "狎",
    "狭",
    "狹",
    "珨",
    "瑕",
    "硖",
    "硤",
    "碬",
    "祫",
    "筪",
    "縖",
    "翈",
    "舝",
    "舺",
    "蕸",
    "赮",
    "轄",
    "辖",
    "遐",
    "鍜",
    "鎋",
    "陜",
    "陿",
    "霞",
    "騢",
    "魻",
    "鶷",
    "黠"
  ],
  lǚ: [
    "侣",
    "侶",
    "儢",
    "吕",
    "呂",
    "屡",
    "屢",
    "履",
    "挔",
    "捛",
    "旅",
    "梠",
    "焒",
    "祣",
    "稆",
    "穭",
    "絽",
    "縷",
    "缕",
    "膂",
    "膐",
    "褛",
    "褸",
    "郘",
    "鋁",
    "铝"
  ],
  ta: ["侤"],
  "jiǎo yáo": ["侥", "僥", "徺"],
  zhēn: [
    "侦",
    "偵",
    "寊",
    "帧",
    "帪",
    "幀",
    "搸",
    "斟",
    "桢",
    "楨",
    "榛",
    "樼",
    "殝",
    "浈",
    "湞",
    "潧",
    "澵",
    "獉",
    "珍",
    "珎",
    "瑧",
    "甄",
    "眞",
    "真",
    "砧",
    "碪",
    "祯",
    "禎",
    "禛",
    "箴",
    "胗",
    "臻",
    "葴",
    "蒖",
    "蓁",
    "薽",
    "貞",
    "贞",
    "轃",
    "遉",
    "酙",
    "針",
    "鉁",
    "錱",
    "鍼",
    "针",
    "鱵"
  ],
  "cè zè zhāi": ["侧", "側"],
  kuài: [
    "侩",
    "儈",
    "凷",
    "哙",
    "噲",
    "圦",
    "块",
    "塊",
    "巜",
    "廥",
    "快",
    "旝",
    "欳",
    "狯",
    "獪",
    "筷",
    "糩",
    "脍",
    "膾",
    "郐",
    "鄶",
    "鱠",
    "鲙"
  ],
  chái: ["侪", "儕", "喍", "柴", "犲", "祡", "豺"],
  nóng: [
    "侬",
    "儂",
    "农",
    "哝",
    "噥",
    "檂",
    "欁",
    "浓",
    "濃",
    "燶",
    "禯",
    "秾",
    "穠",
    "脓",
    "膿",
    "蕽",
    "襛",
    "譨",
    "農",
    "辳",
    "醲",
    "鬞",
    "𬪩"
  ],
  jǐn: [
    "侭",
    "儘",
    "卺",
    "厪",
    "巹",
    "槿",
    "漌",
    "瑾",
    "紧",
    "緊",
    "菫",
    "蓳",
    "謹",
    "谨",
    "錦",
    "锦",
    "饉",
    "馑"
  ],
  "hóu hòu": ["侯", "矦"],
  jiǒng: [
    "侰",
    "僒",
    "冏",
    "囧",
    "泂",
    "澃",
    "炯",
    "烱",
    "煚",
    "煛",
    "熲",
    "燛",
    "窘",
    "綗",
    "褧",
    "迥",
    "逈",
    "顈",
    "颎",
    "䌹"
  ],
  "chěng tǐng": ["侱"],
  "zhèn zhēn": ["侲", "揕"],
  zuò: [
    "侳",
    "做",
    "唑",
    "坐",
    "岝",
    "岞",
    "座",
    "祚",
    "糳",
    "胙",
    "葃",
    "葄",
    "蓙",
    "袏",
    "阼"
  ],
  qīn: [
    "侵",
    "兓",
    "媇",
    "嵚",
    "嶔",
    "欽",
    "衾",
    "誛",
    "钦",
    "顉",
    "駸",
    "骎",
    "鮼"
  ],
  jú: [
    "侷",
    "啹",
    "婅",
    "局",
    "巈",
    "椈",
    "橘",
    "泦",
    "淗",
    "湨",
    "焗",
    "犑",
    "狊",
    "粷",
    "菊",
    "蘜",
    "趜",
    "跼",
    "蹫",
    "輂",
    "郹",
    "閰",
    "駶",
    "驧",
    "鵙",
    "鵴",
    "鶪",
    "鼰",
    "鼳",
    "䴗"
  ],
  "shù dōu": ["侸"],
  tǐng: [
    "侹",
    "圢",
    "娗",
    "挺",
    "涏",
    "烶",
    "珽",
    "脡",
    "艇",
    "誔",
    "頲",
    "颋"
  ],
  shèn: [
    "侺",
    "愼",
    "慎",
    "昚",
    "涁",
    "渗",
    "滲",
    "瘆",
    "瘮",
    "眘",
    "祳",
    "肾",
    "胂",
    "脤",
    "腎",
    "蜃",
    "蜄",
    "鋠"
  ],
  "tuì tuó": ["侻"],
  nán: [
    "侽",
    "喃",
    "娚",
    "抩",
    "暔",
    "枏",
    "柟",
    "楠",
    "男",
    "畘",
    "莮",
    "萳",
    "遖"
  ],
  xiāo: [
    "侾",
    "哓",
    "嘵",
    "嚻",
    "囂",
    "婋",
    "宯",
    "宵",
    "庨",
    "彇",
    "揱",
    "枭",
    "枵",
    "梟",
    "櫹",
    "歊",
    "毊",
    "消",
    "潇",
    "瀟",
    "灱",
    "灲",
    "烋",
    "焇",
    "猇",
    "獢",
    "痚",
    "痟",
    "硝",
    "硣",
    "窙",
    "箫",
    "簘",
    "簫",
    "綃",
    "绡",
    "翛",
    "膮",
    "萧",
    "蕭",
    "虈",
    "虓",
    "蟂",
    "蟏",
    "蟰",
    "蠨",
    "踃",
    "逍",
    "銷",
    "销",
    "霄",
    "颵",
    "驍",
    "骁",
    "髇",
    "髐",
    "魈",
    "鴞",
    "鴵",
    "鷍",
    "鸮"
  ],
  "biàn pián": ["便", "緶", "缏"],
  tuǐ: ["俀", "腿", "蹆", "骽"],
  xì: [
    "係",
    "匸",
    "卌",
    "呬",
    "墍",
    "屃",
    "屓",
    "屭",
    "忥",
    "怬",
    "恄",
    "椞",
    "潝",
    "潟",
    "澙",
    "熂",
    "犔",
    "磶",
    "禊",
    "細",
    "綌",
    "縘",
    "细",
    "绤",
    "舃",
    "舄",
    "蕮",
    "虩",
    "衋",
    "覤",
    "赩",
    "趇",
    "郤",
    "釳",
    "阋",
    "隙",
    "隟",
    "霼",
    "餼",
    "饩",
    "鬩",
    "黖"
  ],
  cù: [
    "促",
    "媨",
    "憱",
    "猝",
    "瘄",
    "瘯",
    "簇",
    "縬",
    "脨",
    "蔟",
    "誎",
    "趗",
    "踧",
    "踿",
    "蹙",
    "蹴",
    "蹵",
    "醋",
    "顣",
    "鼀"
  ],
  é: [
    "俄",
    "囮",
    "娥",
    "峉",
    "峨",
    "峩",
    "涐",
    "珴",
    "皒",
    "睋",
    "磀",
    "莪",
    "訛",
    "誐",
    "譌",
    "讹",
    "迗",
    "鈋",
    "鋨",
    "锇",
    "頟",
    "額",
    "额",
    "魤",
    "鵝",
    "鵞",
    "鹅"
  ],
  qiú: [
    "俅",
    "叴",
    "唒",
    "囚",
    "崷",
    "巯",
    "巰",
    "扏",
    "梂",
    "殏",
    "毬",
    "求",
    "汓",
    "泅",
    "浗",
    "湭",
    "煪",
    "犰",
    "玌",
    "球",
    "璆",
    "皳",
    "盚",
    "紌",
    "絿",
    "肍",
    "芁",
    "莍",
    "虬",
    "虯",
    "蛷",
    "裘",
    "觓",
    "觩",
    "訄",
    "訅",
    "賕",
    "赇",
    "逎",
    "逑",
    "遒",
    "酋",
    "釚",
    "釻",
    "銶",
    "頄",
    "鮂",
    "鯄",
    "鰽",
    "鼽",
    "𨱇"
  ],
  xú: ["俆", "徐", "禑"],
  "guàng kuāng": ["俇"],
  kù: [
    "俈",
    "喾",
    "嚳",
    "库",
    "庫",
    "廤",
    "瘔",
    "絝",
    "绔",
    "袴",
    "裤",
    "褲",
    "酷"
  ],
  wù: [
    "俉",
    "务",
    "務",
    "勿",
    "卼",
    "坞",
    "塢",
    "奦",
    "婺",
    "寤",
    "屼",
    "岉",
    "嵨",
    "忢",
    "悞",
    "悟",
    "悮",
    "戊",
    "扤",
    "晤",
    "杌",
    "溩",
    "焐",
    "熃",
    "物",
    "痦",
    "矹",
    "窹",
    "粅",
    "蘁",
    "誤",
    "误",
    "鋈",
    "阢",
    "隖",
    "雾",
    "霚",
    "霧",
    "靰",
    "騖",
    "骛",
    "鶩",
    "鹜",
    "鼿",
    "齀"
  ],
  jùn: [
    "俊",
    "儁",
    "呁",
    "埈",
    "寯",
    "峻",
    "懏",
    "捃",
    "攟",
    "晙",
    "棞",
    "燇",
    "珺",
    "畯",
    "竣",
    "箟",
    "蜠",
    "賐",
    "郡",
    "陖",
    "餕",
    "馂",
    "駿",
    "骏",
    "鵔",
    "鵕",
    "鵘",
    "䐃"
  ],
  liáng: [
    "俍",
    "墚",
    "梁",
    "椋",
    "樑",
    "粮",
    "粱",
    "糧",
    "良",
    "輬",
    "辌",
    "𫟅"
  ],
  zǔ: ["俎", "唨", "爼", "祖", "組", "组", "詛", "诅", "鎺", "阻", "靻"],
  "qiào xiào": ["俏"],
  yǒng: [
    "俑",
    "勇",
    "勈",
    "咏",
    "埇",
    "塎",
    "嵱",
    "彮",
    "怺",
    "恿",
    "悀",
    "惥",
    "愑",
    "愹",
    "慂",
    "柡",
    "栐",
    "永",
    "泳",
    "湧",
    "甬",
    "蛹",
    "詠",
    "踊",
    "踴",
    "鯒",
    "鲬"
  ],
  hùn: ["俒", "倱", "圂", "尡", "慁", "掍", "溷", "焝", "睴", "觨", "諢", "诨"],
  jìng: [
    "俓",
    "傹",
    "境",
    "妌",
    "婙",
    "婧",
    "弪",
    "弳",
    "径",
    "徑",
    "敬",
    "曔",
    "桱",
    "梷",
    "浄",
    "瀞",
    "獍",
    "痉",
    "痙",
    "竞",
    "竟",
    "竫",
    "競",
    "竸",
    "胫",
    "脛",
    "莖",
    "誩",
    "踁",
    "迳",
    "逕",
    "鏡",
    "镜",
    "靖",
    "静",
    "靜",
    "鵛"
  ],
  sàn: ["俕", "閐"],
  pěi: ["俖"],
  sú: ["俗"],
  xī: [
    "俙",
    "僖",
    "兮",
    "凞",
    "卥",
    "厀",
    "吸",
    "唏",
    "唽",
    "嘻",
    "噏",
    "嚱",
    "夕",
    "奚",
    "嬆",
    "嬉",
    "屖",
    "嵠",
    "巇",
    "希",
    "徆",
    "徯",
    "息",
    "悉",
    "悕",
    "惁",
    "惜",
    "昔",
    "晞",
    "晰",
    "晳",
    "曦",
    "析",
    "桸",
    "榽",
    "樨",
    "橀",
    "欷",
    "氥",
    "汐",
    "浠",
    "淅",
    "渓",
    "溪",
    "烯",
    "焁",
    "焈",
    "焟",
    "熄",
    "熈",
    "熙",
    "熹",
    "熺",
    "熻",
    "燨",
    "爔",
    "牺",
    "犀",
    "犠",
    "犧",
    "琋",
    "瘜",
    "皙",
    "睎",
    "瞦",
    "矽",
    "硒",
    "磎",
    "礂",
    "稀",
    "穸",
    "窸",
    "粞",
    "糦",
    "緆",
    "繥",
    "羲",
    "翕",
    "翖",
    "肸",
    "肹",
    "膝",
    "舾",
    "莃",
    "菥",
    "蒠",
    "蜥",
    "螅",
    "蟋",
    "蠵",
    "西",
    "觹",
    "觽",
    "觿",
    "譆",
    "谿",
    "豀",
    "豨",
    "豯",
    "貕",
    "赥",
    "邜",
    "鄎",
    "酅",
    "醯",
    "釸",
    "錫",
    "鏭",
    "鐊",
    "鑴",
    "锡",
    "隵",
    "餏",
    "饎",
    "饻",
    "鯑",
    "鵗",
    "鸂",
    "鼷"
  ],
  lǐ: [
    "俚",
    "娌",
    "峢",
    "峲",
    "李",
    "欚",
    "浬",
    "澧",
    "理",
    "礼",
    "禮",
    "粴",
    "裏",
    "裡",
    "豊",
    "逦",
    "邐",
    "醴",
    "鋰",
    "锂",
    "鯉",
    "鱧",
    "鱱",
    "鲤",
    "鳢"
  ],
  bǎo: [
    "保",
    "堢",
    "媬",
    "宝",
    "寚",
    "寳",
    "寶",
    "珤",
    "緥",
    "葆",
    "藵",
    "褓",
    "賲",
    "靌",
    "飹",
    "飽",
    "饱",
    "駂",
    "鳵",
    "鴇",
    "鸨"
  ],
  "yú shù yù": ["俞"],
  "sì qí": ["俟"],
  "xìn shēn": ["信"],
  xiū: [
    "俢",
    "修",
    "咻",
    "庥",
    "樇",
    "烌",
    "羞",
    "脙",
    "脩",
    "臹",
    "貅",
    "銝",
    "鎀",
    "飍",
    "饈",
    "馐",
    "髤",
    "髹",
    "鮴",
    "鱃",
    "鵂",
    "鸺",
    "䗛"
  ],
  dì: [
    "俤",
    "偙",
    "僀",
    "埊",
    "墑",
    "墬",
    "娣",
    "帝",
    "怟",
    "旳",
    "梊",
    "焍",
    "玓",
    "甋",
    "眱",
    "睇",
    "碲",
    "祶",
    "禘",
    "第",
    "締",
    "缔",
    "腣",
    "菂",
    "蒂",
    "蔕",
    "蝃",
    "蝭",
    "螮",
    "諦",
    "谛",
    "踶",
    "递",
    "逓",
    "遞",
    "遰",
    "鉪",
    "𤧛",
    "䗖"
  ],
  chóu: [
    "俦",
    "儔",
    "嬦",
    "惆",
    "愁",
    "懤",
    "栦",
    "燽",
    "畴",
    "疇",
    "皗",
    "稠",
    "筹",
    "籌",
    "絒",
    "綢",
    "绸",
    "菗",
    "詶",
    "讎",
    "讐",
    "踌",
    "躊",
    "酧",
    "酬",
    "醻",
    "雔",
    "雠",
    "雦"
  ],
  zhì: [
    "俧",
    "偫",
    "儨",
    "制",
    "劕",
    "垁",
    "娡",
    "寘",
    "帙",
    "帜",
    "幟",
    "庢",
    "庤",
    "廌",
    "彘",
    "徏",
    "徝",
    "志",
    "忮",
    "懥",
    "懫",
    "挃",
    "挚",
    "掷",
    "摯",
    "擲",
    "旘",
    "晊",
    "智",
    "栉",
    "桎",
    "梽",
    "櫍",
    "櫛",
    "治",
    "洷",
    "滍",
    "滞",
    "滯",
    "潌",
    "瀄",
    "炙",
    "熫",
    "狾",
    "猘",
    "璏",
    "瓆",
    "痔",
    "痣",
    "礩",
    "祑",
    "秩",
    "秷",
    "稚",
    "稺",
    "穉",
    "窒",
    "紩",
    "緻",
    "置",
    "翐",
    "膣",
    "至",
    "致",
    "芖",
    "蛭",
    "袟",
    "袠",
    "製",
    "覟",
    "觗",
    "觯",
    "觶",
    "誌",
    "豑",
    "豒",
    "貭",
    "質",
    "贄",
    "质",
    "贽",
    "跱",
    "踬",
    "躓",
    "輊",
    "轾",
    "郅",
    "銍",
    "鋕",
    "鑕",
    "铚",
    "锧",
    "陟",
    "隲",
    "雉",
    "駤",
    "騭",
    "騺",
    "驇",
    "骘",
    "鯯",
    "鴙",
    "鷙",
    "鸷",
    "𬃊"
  ],
  "liǎ liǎng": ["俩"],
  jiǎn: [
    "俭",
    "倹",
    "儉",
    "减",
    "剪",
    "堿",
    "弿",
    "彅",
    "戩",
    "戬",
    "拣",
    "挸",
    "捡",
    "揀",
    "撿",
    "枧",
    "柬",
    "梘",
    "检",
    "検",
    "檢",
    "減",
    "湕",
    "瀽",
    "瑐",
    "睑",
    "瞼",
    "硷",
    "碱",
    "礆",
    "笕",
    "筧",
    "简",
    "簡",
    "絸",
    "繭",
    "翦",
    "茧",
    "藆",
    "蠒",
    "裥",
    "襇",
    "襉",
    "襺",
    "詃",
    "謇",
    "謭",
    "譾",
    "谫",
    "趼",
    "蹇",
    "鐗",
    "鬋",
    "鰎",
    "鹸",
    "鹻",
    "鹼"
  ],
  huò: [
    "俰",
    "咟",
    "嚯",
    "嚿",
    "奯",
    "彠",
    "惑",
    "或",
    "擭",
    "旤",
    "曤",
    "檴",
    "沎",
    "湱",
    "瀖",
    "獲",
    "癨",
    "眓",
    "矐",
    "祸",
    "禍",
    "穫",
    "窢",
    "耯",
    "臛",
    "艧",
    "获",
    "蒦",
    "藿",
    "蠖",
    "謋",
    "貨",
    "货",
    "鍃",
    "鑊",
    "镬",
    "雘",
    "霍",
    "靃",
    "韄",
    "㸌"
  ],
  "jù jū": ["俱", "据", "鋸", "锯"],
  xiào: [
    "俲",
    "傚",
    "効",
    "咲",
    "哮",
    "啸",
    "嘋",
    "嘨",
    "嘯",
    "孝",
    "效",
    "斅",
    "斆",
    "歗",
    "涍",
    "熽",
    "笑",
    "詨",
    "誟"
  ],
  pái: ["俳", "徘", "牌", "犤", "猅", "簰", "簲", "輫"],
  biào: ["俵", "鰾", "鳔"],
  "chù tì": ["俶"],
  fèi: [
    "俷",
    "剕",
    "厞",
    "吠",
    "屝",
    "废",
    "廃",
    "廢",
    "昲",
    "曊",
    "櫠",
    "沸",
    "濷",
    "狒",
    "癈",
    "肺",
    "萉",
    "費",
    "费",
    "鐨",
    "镄",
    "陫",
    "靅",
    "鼣"
  ],
  fèng: ["俸", "凤", "奉", "湗", "焨", "煈", "賵", "赗", "鳯", "鳳", "鴌"],
  ǎn: ["俺", "唵", "埯", "揞", "罯", "銨", "铵"],
  bèi: [
    "俻",
    "倍",
    "偝",
    "偹",
    "備",
    "僃",
    "备",
    "悖",
    "惫",
    "愂",
    "憊",
    "昁",
    "梖",
    "焙",
    "牬",
    "犕",
    "狈",
    "狽",
    "珼",
    "琲",
    "碚",
    "禙",
    "糒",
    "苝",
    "蓓",
    "蛽",
    "褙",
    "貝",
    "贝",
    "軰",
    "輩",
    "辈",
    "邶",
    "郥",
    "鄁",
    "鋇",
    "鐾",
    "钡",
    "鞁",
    "鞴",
    "𬇙"
  ],
  yù: [
    "俼",
    "儥",
    "喅",
    "喩",
    "喻",
    "域",
    "堉",
    "妪",
    "嫗",
    "寓",
    "峪",
    "嶎",
    "庽",
    "彧",
    "御",
    "愈",
    "慾",
    "戫",
    "昱",
    "棛",
    "棜",
    "棫",
    "櫲",
    "欎",
    "欝",
    "欲",
    "毓",
    "浴",
    "淯",
    "滪",
    "潏",
    "澦",
    "灪",
    "焴",
    "煜",
    "燏",
    "燠",
    "爩",
    "狱",
    "獄",
    "玉",
    "琙",
    "瘉",
    "癒",
    "砡",
    "硢",
    "硲",
    "礇",
    "礖",
    "礜",
    "禦",
    "秗",
    "稢",
    "稶",
    "篽",
    "籞",
    "籲",
    "粖",
    "緎",
    "罭",
    "聿",
    "肀",
    "艈",
    "芋",
    "芌",
    "茟",
    "蒮",
    "蓣",
    "蓹",
    "蕷",
    "蘌",
    "蜟",
    "蜮",
    "袬",
    "裕",
    "誉",
    "諭",
    "譽",
    "谕",
    "豫",
    "軉",
    "輍",
    "逳",
    "遇",
    "遹",
    "郁",
    "醧",
    "鈺",
    "鋊",
    "錥",
    "鐭",
    "钰",
    "閾",
    "阈",
    "雤",
    "霱",
    "預",
    "预",
    "飫",
    "饇",
    "饫",
    "馭",
    "驈",
    "驭",
    "鬰",
    "鬱",
    "鬻",
    "魊",
    "鱊",
    "鳿",
    "鴥",
    "鴧",
    "鴪",
    "鵒",
    "鷸",
    "鸒",
    "鹆",
    "鹬"
  ],
  xīn: [
    "俽",
    "噺",
    "妡",
    "嬜",
    "廞",
    "心",
    "忄",
    "忻",
    "惞",
    "新",
    "昕",
    "杺",
    "欣",
    "歆",
    "炘",
    "盺",
    "薪",
    "訢",
    "辛",
    "邤",
    "鈊",
    "鋅",
    "鑫",
    "锌",
    "馨",
    "馫",
    "䜣",
    "𫷷"
  ],
  "hǔ chí": ["俿"],
  jiù: [
    "倃",
    "僦",
    "匓",
    "匛",
    "匶",
    "厩",
    "咎",
    "就",
    "廄",
    "廏",
    "廐",
    "慦",
    "捄",
    "救",
    "旧",
    "柩",
    "柾",
    "桕",
    "欍",
    "殧",
    "疚",
    "臼",
    "舅",
    "舊",
    "鯦",
    "鷲",
    "鹫",
    "麔",
    "齨",
    "㠇"
  ],
  yáo: [
    "倄",
    "傜",
    "嗂",
    "垚",
    "堯",
    "姚",
    "媱",
    "尧",
    "尭",
    "峣",
    "嶢",
    "嶤",
    "徭",
    "揺",
    "搖",
    "摇",
    "摿",
    "暚",
    "榣",
    "烑",
    "爻",
    "猺",
    "珧",
    "瑤",
    "瑶",
    "磘",
    "窑",
    "窯",
    "窰",
    "肴",
    "蘨",
    "謠",
    "謡",
    "谣",
    "軺",
    "轺",
    "遙",
    "遥",
    "邎",
    "顤",
    "颻",
    "飖",
    "餆",
    "餚",
    "鰩",
    "鱙",
    "鳐"
  ],
  "cuì zú": ["倅"],
  "liǎng liǎ": ["倆"],
  wǎn: [
    "倇",
    "唍",
    "婉",
    "惋",
    "挽",
    "晚",
    "晥",
    "晩",
    "晼",
    "梚",
    "椀",
    "琬",
    "畹",
    "皖",
    "盌",
    "碗",
    "綩",
    "綰",
    "绾",
    "脘",
    "萖",
    "踠",
    "輓",
    "鋔"
  ],
  zǒng: [
    "倊",
    "偬",
    "傯",
    "嵸",
    "总",
    "惣",
    "捴",
    "搃",
    "摠",
    "燪",
    "総",
    "緫",
    "縂",
    "總",
    "蓗"
  ],
  guān: [
    "倌",
    "关",
    "官",
    "棺",
    "瘝",
    "癏",
    "窤",
    "蒄",
    "関",
    "闗",
    "關",
    "鰥",
    "鱞",
    "鳏"
  ],
  tiǎn: [
    "倎",
    "唺",
    "忝",
    "悿",
    "晪",
    "殄",
    "淟",
    "睓",
    "腆",
    "舔",
    "覥",
    "觍",
    "賟",
    "錪",
    "餂"
  ],
  mén: ["們", "扪", "捫", "璊", "菛", "虋", "鍆", "钔", "門", "閅", "门", "𫞩"],
  "dǎo dào": ["倒"],
  "tán tàn": ["倓", "埮"],
  "juè jué": ["倔"],
  chuí: [
    "倕",
    "垂",
    "埀",
    "捶",
    "搥",
    "桘",
    "棰",
    "槌",
    "箠",
    "腄",
    "菙",
    "錘",
    "鎚",
    "锤",
    "陲",
    "顀"
  ],
  xìng: [
    "倖",
    "姓",
    "婞",
    "嬹",
    "幸",
    "性",
    "悻",
    "杏",
    "涬",
    "緈",
    "臖",
    "荇",
    "莕",
    "葕"
  ],
  péng: [
    "倗",
    "傰",
    "塜",
    "塳",
    "弸",
    "憉",
    "捀",
    "朋",
    "棚",
    "椖",
    "樥",
    "硼",
    "稝",
    "竼",
    "篷",
    "纄",
    "膨",
    "芃",
    "蓬",
    "蘕",
    "蟚",
    "蟛",
    "袶",
    "輣",
    "錋",
    "鑝",
    "韸",
    "韼",
    "騯",
    "髼",
    "鬅",
    "鬔",
    "鵬",
    "鹏"
  ],
  "tǎng cháng": ["倘"],
  hòu: [
    "候",
    "厚",
    "后",
    "垕",
    "堠",
    "後",
    "洉",
    "茩",
    "豞",
    "逅",
    "郈",
    "鮜",
    "鱟",
    "鲎",
    "鲘"
  ],
  tì: [
    "倜",
    "剃",
    "嚏",
    "嚔",
    "屉",
    "屜",
    "悌",
    "悐",
    "惕",
    "惖",
    "戻",
    "掦",
    "替",
    "朑",
    "歒",
    "殢",
    "涕",
    "瓋",
    "笹",
    "籊",
    "薙",
    "褅",
    "逖",
    "逷",
    "髰",
    "鬀",
    "鬄"
  ],
  gàn: [
    "倝",
    "凎",
    "幹",
    "榦",
    "檊",
    "淦",
    "灨",
    "盰",
    "紺",
    "绀",
    "詌",
    "贑",
    "赣",
    "骭",
    "㽏"
  ],
  "liàng jìng": ["倞", "靓"],
  suī: [
    "倠",
    "哸",
    "夊",
    "滖",
    "濉",
    "眭",
    "睢",
    "芕",
    "荽",
    "荾",
    "虽",
    "雖",
    "鞖"
  ],
  "chàng chāng": ["倡"],
  jié: [
    "倢",
    "偼",
    "傑",
    "刦",
    "刧",
    "刼",
    "劫",
    "劼",
    "卩",
    "卪",
    "婕",
    "媫",
    "孑",
    "岊",
    "崨",
    "嵥",
    "嶻",
    "巀",
    "幯",
    "截",
    "捷",
    "掶",
    "擮",
    "昅",
    "杢",
    "杰",
    "桀",
    "桝",
    "楬",
    "楶",
    "榤",
    "洁",
    "滐",
    "潔",
    "狤",
    "睫",
    "礍",
    "竭",
    "節",
    "羯",
    "莭",
    "蓵",
    "蛣",
    "蜐",
    "蠘",
    "蠞",
    "蠽",
    "衱",
    "袺",
    "訐",
    "詰",
    "誱",
    "讦",
    "踕",
    "迼",
    "鉣",
    "鍻",
    "镼",
    "頡",
    "鮚",
    "鲒",
    "㛃"
  ],
  "kǒng kōng": ["倥"],
  juàn: [
    "倦",
    "劵",
    "奆",
    "慻",
    "桊",
    "淃",
    "狷",
    "獧",
    "眷",
    "睊",
    "睠",
    "絭",
    "絹",
    "绢",
    "罥",
    "羂",
    "腃",
    "蔨",
    "鄄",
    "餋"
  ],
  zōng: [
    "倧",
    "堫",
    "宗",
    "嵏",
    "嵕",
    "惾",
    "朡",
    "棕",
    "椶",
    "熧",
    "猣",
    "磫",
    "緃",
    "翪",
    "腙",
    "葼",
    "蝬",
    "豵",
    "踨",
    "踪",
    "蹤",
    "鍐",
    "鑁",
    "騌",
    "騣",
    "骔",
    "鬃",
    "鬉",
    "鬷",
    "鯮",
    "鯼"
  ],
  ní: [
    "倪",
    "坭",
    "埿",
    "尼",
    "屔",
    "怩",
    "淣",
    "猊",
    "籾",
    "聣",
    "蚭",
    "蜺",
    "觬",
    "貎",
    "跜",
    "輗",
    "郳",
    "鈮",
    "铌",
    "霓",
    "馜",
    "鯢",
    "鲵",
    "麑",
    "齯",
    "𫐐",
    "𫠜"
  ],
  zhuō: [
    "倬",
    "拙",
    "捉",
    "桌",
    "梲",
    "棁",
    "棳",
    "槕",
    "涿",
    "窧",
    "鐯",
    "䦃"
  ],
  "wō wēi": ["倭"],
  luǒ: ["倮", "剆", "曪", "瘰", "癳", "臝", "蓏", "蠃", "裸", "躶"],
  sōng: [
    "倯",
    "凇",
    "娀",
    "崧",
    "嵩",
    "庺",
    "憽",
    "松",
    "枀",
    "枩",
    "柗",
    "梥",
    "檧",
    "淞",
    "濍",
    "硹",
    "菘",
    "鬆"
  ],
  lèng: ["倰", "堎", "愣", "睖", "踜"],
  zì: [
    "倳",
    "剚",
    "字",
    "恣",
    "渍",
    "漬",
    "牸",
    "眥",
    "眦",
    "胔",
    "胾",
    "自",
    "茡",
    "荢"
  ],
  bèn: ["倴", "坌", "捹", "撪", "渀", "笨", "逩"],
  cǎi: ["倸", "啋", "婇", "彩", "採", "棌", "毝", "睬", "綵", "跴", "踩"],
  zhài: ["债", "債", "寨", "瘵", "砦"],
  yē: ["倻", "吔", "噎", "擨", "暍", "椰", "歋", "潱", "蠮"],
  shà: ["倽", "唼", "喢", "歃", "箑", "翜", "翣", "萐", "閯", "霎"],
  qīng: [
    "倾",
    "傾",
    "卿",
    "圊",
    "寈",
    "氢",
    "氫",
    "淸",
    "清",
    "蜻",
    "軽",
    "輕",
    "轻",
    "郬",
    "錆",
    "鑋",
    "靑",
    "青",
    "鯖"
  ],
  yīng: [
    "偀",
    "嘤",
    "噟",
    "嚶",
    "婴",
    "媖",
    "嫈",
    "嬰",
    "孆",
    "孾",
    "愥",
    "撄",
    "攖",
    "朠",
    "桜",
    "樱",
    "櫻",
    "渶",
    "煐",
    "珱",
    "瑛",
    "璎",
    "瓔",
    "甇",
    "甖",
    "碤",
    "礯",
    "緓",
    "纓",
    "绬",
    "缨",
    "罂",
    "罃",
    "罌",
    "膺",
    "英",
    "莺",
    "蘡",
    "蝧",
    "蠳",
    "褮",
    "譻",
    "賏",
    "軈",
    "鑍",
    "锳",
    "霙",
    "韺",
    "鴬",
    "鶑",
    "鶧",
    "鶯",
    "鷪",
    "鷹",
    "鸎",
    "鸚",
    "鹦",
    "鹰",
    "䓨"
  ],
  "chēng chèn": ["偁", "爯"],
  ruǎn: ["偄", "朊", "瑌", "瓀", "碝", "礝", "腝", "軟", "輭", "软", "阮"],
  "zhòng tóng": ["偅"],
  chǔn: ["偆", "惷", "睶", "萶", "蠢", "賰"],
  "jiǎ jià": ["假"],
  "jì jié": ["偈"],
  "bǐng bìng": ["偋"],
  ruò: [
    "偌",
    "叒",
    "嵶",
    "弱",
    "楉",
    "焫",
    "爇",
    "箬",
    "篛",
    "蒻",
    "鄀",
    "鰙",
    "鰯",
    "鶸"
  ],
  tí: [
    "偍",
    "厗",
    "啼",
    "嗁",
    "崹",
    "漽",
    "瑅",
    "睼",
    "禵",
    "稊",
    "緹",
    "缇",
    "罤",
    "蕛",
    "褆",
    "謕",
    "趧",
    "蹄",
    "蹏",
    "醍",
    "鍗",
    "題",
    "题",
    "騠",
    "鮷",
    "鯷",
    "鳀",
    "鵜",
    "鷤",
    "鹈",
    "𫘨"
  ],
  wēi: [
    "偎",
    "危",
    "喴",
    "威",
    "媙",
    "嶶",
    "巍",
    "微",
    "愄",
    "揋",
    "揻",
    "椳",
    "楲",
    "溦",
    "烓",
    "煨",
    "燰",
    "癓",
    "縅",
    "葨",
    "葳",
    "薇",
    "蜲",
    "蝛",
    "覣",
    "詴",
    "逶",
    "隇",
    "隈",
    "霺",
    "鰃",
    "鰄",
    "鳂"
  ],
  piān: ["偏", "囨", "媥", "楄", "犏", "篇", "翩", "鍂"],
  yàn: [
    "偐",
    "厌",
    "厭",
    "唁",
    "喭",
    "嚈",
    "嚥",
    "堰",
    "妟",
    "姲",
    "嬊",
    "嬿",
    "宴",
    "彥",
    "彦",
    "敥",
    "晏",
    "暥",
    "曕",
    "曣",
    "滟",
    "灎",
    "灔",
    "灧",
    "灩",
    "焔",
    "焰",
    "焱",
    "熖",
    "燄",
    "牪",
    "猒",
    "砚",
    "硯",
    "艳",
    "艶",
    "艷",
    "覎",
    "觃",
    "觾",
    "諺",
    "讌",
    "讞",
    "谚",
    "谳",
    "豓",
    "豔",
    "贋",
    "贗",
    "赝",
    "軅",
    "酀",
    "酽",
    "醼",
    "釅",
    "雁",
    "餍",
    "饜",
    "騐",
    "験",
    "騴",
    "驗",
    "驠",
    "验",
    "鬳",
    "鳫",
    "鴈",
    "鴳",
    "鷃",
    "鷰",
    "齞"
  ],
  "tǎng dàng": ["偒"],
  è: [
    "偔",
    "匎",
    "卾",
    "厄",
    "呝",
    "咢",
    "噩",
    "垩",
    "堊",
    "堮",
    "岋",
    "崿",
    "廅",
    "悪",
    "愕",
    "戹",
    "扼",
    "搤",
    "搹",
    "擜",
    "櫮",
    "歞",
    "歺",
    "湂",
    "琧",
    "砈",
    "砐",
    "硆",
    "腭",
    "苊",
    "萼",
    "蕚",
    "蚅",
    "蝁",
    "覨",
    "諤",
    "讍",
    "谔",
    "豟",
    "軛",
    "軶",
    "轭",
    "遌",
    "遏",
    "遻",
    "鄂",
    "鈪",
    "鍔",
    "鑩",
    "锷",
    "阨",
    "阸",
    "頞",
    "顎",
    "颚",
    "餓",
    "餩",
    "饿",
    "鰐",
    "鰪",
    "鱷",
    "鳄",
    "鶚",
    "鹗",
    "齃",
    "齶",
    "𫫇",
    "𥔲"
  ],
  xié: [
    "偕",
    "勰",
    "协",
    "協",
    "嗋",
    "垥",
    "奊",
    "恊",
    "愶",
    "拹",
    "携",
    "撷",
    "擕",
    "擷",
    "攜",
    "斜",
    "旪",
    "熁",
    "燲",
    "綊",
    "緳",
    "縀",
    "缬",
    "翓",
    "胁",
    "脅",
    "脇",
    "脋",
    "膎",
    "蝢",
    "衺",
    "襭",
    "諧",
    "讗",
    "谐",
    "鞋",
    "鞵",
    "龤",
    "㙦"
  ],
  chě: ["偖", "扯", "撦"],
  shěng: ["偗", "渻", "眚"],
  chā: [
    "偛",
    "嗏",
    "扠",
    "挿",
    "插",
    "揷",
    "疀",
    "臿",
    "艖",
    "銟",
    "鍤",
    "锸",
    "餷"
  ],
  huáng: [
    "偟",
    "凰",
    "喤",
    "堭",
    "墴",
    "媓",
    "崲",
    "徨",
    "惶",
    "楻",
    "湟",
    "煌",
    "獚",
    "瑝",
    "璜",
    "癀",
    "皇",
    "磺",
    "穔",
    "篁",
    "簧",
    "艎",
    "葟",
    "蝗",
    "蟥",
    "諻",
    "趪",
    "遑",
    "鍠",
    "鐄",
    "锽",
    "隍",
    "韹",
    "餭",
    "騜",
    "鰉",
    "鱑",
    "鳇",
    "鷬",
    "黃",
    "黄",
    "𨱑"
  ],
  yǎo: [
    "偠",
    "咬",
    "婹",
    "宎",
    "岆",
    "杳",
    "柼",
    "榚",
    "溔",
    "狕",
    "窅",
    "窈",
    "舀",
    "苭",
    "闄",
    "騕",
    "鷕",
    "齩"
  ],
  "chǒu qiào": ["偢"],
  yóu: [
    "偤",
    "尤",
    "庮",
    "怣",
    "沋",
    "油",
    "浟",
    "游",
    "犹",
    "猶",
    "猷",
    "由",
    "疣",
    "秞",
    "肬",
    "莜",
    "莸",
    "蕕",
    "蚰",
    "蝣",
    "訧",
    "輏",
    "輶",
    "逰",
    "遊",
    "邮",
    "郵",
    "鈾",
    "铀",
    "駀",
    "魷",
    "鮋",
    "鱿",
    "鲉",
    "𬨎"
  ],
  xū: [
    "偦",
    "墟",
    "媭",
    "嬃",
    "楈",
    "欨",
    "歔",
    "燸",
    "疞",
    "盱",
    "綇",
    "縃",
    "繻",
    "胥",
    "蕦",
    "虗",
    "虚",
    "虛",
    "蝑",
    "裇",
    "訏",
    "許",
    "諝",
    "譃",
    "谞",
    "鑐",
    "需",
    "須",
    "须",
    "顼",
    "驉",
    "鬚",
    "魆",
    "魖",
    "𬣙",
    "𦈡"
  ],
  zhā: [
    "偧",
    "哳",
    "抯",
    "挓",
    "揸",
    "摣",
    "樝",
    "渣",
    "皶",
    "觰",
    "譇",
    "齄",
    "齇"
  ],
  cī: ["偨", "疵", "蠀", "趀", "骴", "髊", "齹"],
  bī: ["偪", "屄", "楅", "毴", "豍", "逼", "鰏", "鲾", "鵖"],
  xún: [
    "偱",
    "噚",
    "寻",
    "尋",
    "峋",
    "巡",
    "廵",
    "循",
    "恂",
    "揗",
    "攳",
    "旬",
    "杊",
    "栒",
    "桪",
    "樳",
    "洵",
    "浔",
    "潯",
    "燅",
    "燖",
    "珣",
    "璕",
    "畃",
    "紃",
    "荀",
    "蟳",
    "詢",
    "询",
    "鄩",
    "鱏",
    "鱘",
    "鲟",
    "𬘓",
    "𬩽",
    "𬍤",
    "𬊈"
  ],
  "cāi sī": ["偲"],
  duān: ["偳", "媏", "端", "褍", "鍴"],
  ǒu: ["偶", "吘", "嘔", "耦", "腢", "蕅", "藕", "𬉼", "𠙶"],
  tōu: ["偷", "偸", "鍮"],
  "zán zá zǎ": ["偺"],
  "lǚ lóu": ["偻", "僂"],
  fèn: [
    "偾",
    "僨",
    "奋",
    "奮",
    "弅",
    "忿",
    "愤",
    "憤",
    "瀵",
    "瞓",
    "秎",
    "粪",
    "糞",
    "膹",
    "鱝",
    "鲼"
  ],
  "kuǐ guī": ["傀"],
  sǒu: ["傁", "叜", "叟", "嗾", "櫢", "瞍", "薮", "藪"],
  "zhì sī tí": ["傂"],
  sù: [
    "傃",
    "僳",
    "嗉",
    "塐",
    "塑",
    "夙",
    "嫊",
    "愫",
    "憟",
    "榡",
    "樎",
    "樕",
    "殐",
    "泝",
    "涑",
    "溯",
    "溸",
    "潚",
    "潥",
    "玊",
    "珟",
    "璛",
    "簌",
    "粛",
    "粟",
    "素",
    "縤",
    "肃",
    "肅",
    "膆",
    "蔌",
    "藗",
    "觫",
    "訴",
    "謖",
    "诉",
    "谡",
    "趚",
    "蹜",
    "速",
    "遡",
    "遬",
    "鋉",
    "餗",
    "驌",
    "骕",
    "鱐",
    "鷫",
    "鹔",
    "𫗧"
  ],
  xiā: ["傄", "煆", "瞎", "虲", "谺", "颬", "鰕"],
  "yuàn yuán": ["傆", "媛"],
  rǒng: ["傇", "冗", "宂", "氄", "軵"],
  nù: ["傉", "怒"],
  yùn: [
    "傊",
    "孕",
    "恽",
    "惲",
    "愠",
    "慍",
    "枟",
    "腪",
    "蕴",
    "薀",
    "藴",
    "蘊",
    "褞",
    "貟",
    "运",
    "運",
    "郓",
    "鄆",
    "酝",
    "醖",
    "醞",
    "韗",
    "韞",
    "韵",
    "韻",
    "餫"
  ],
  "gòu jiǎng": ["傋"],
  mà: ["傌", "嘜", "榪", "睰", "祃", "禡", "罵", "閁", "駡", "骂", "鬕"],
  bàng: [
    "傍",
    "塝",
    "棒",
    "玤",
    "稖",
    "艕",
    "蒡",
    "蜯",
    "謗",
    "谤",
    "鎊",
    "镑"
  ],
  diān: [
    "傎",
    "厧",
    "嵮",
    "巅",
    "巓",
    "巔",
    "掂",
    "攧",
    "敁",
    "槇",
    "滇",
    "癫",
    "癲",
    "蹎",
    "顚",
    "顛",
    "颠",
    "齻"
  ],
  táng: [
    "傏",
    "唐",
    "啺",
    "坣",
    "堂",
    "塘",
    "搪",
    "棠",
    "榶",
    "溏",
    "漟",
    "煻",
    "瑭",
    "磄",
    "禟",
    "篖",
    "糃",
    "糖",
    "糛",
    "膅",
    "膛",
    "蓎",
    "螗",
    "螳",
    "赯",
    "踼",
    "鄌",
    "醣",
    "鎕",
    "隚",
    "餹",
    "饄",
    "鶶",
    "䣘"
  ],
  hào: [
    "傐",
    "哠",
    "恏",
    "昊",
    "昦",
    "晧",
    "暠",
    "暤",
    "暭",
    "曍",
    "浩",
    "淏",
    "澔",
    "灏",
    "灝",
    "皓",
    "皜",
    "皞",
    "皡",
    "皥",
    "耗",
    "聕",
    "薃",
    "號",
    "鄗",
    "顥",
    "颢",
    "鰝"
  ],
  "xī xì": ["傒"],
  shān: [
    "傓",
    "删",
    "刪",
    "剼",
    "圸",
    "山",
    "挻",
    "搧",
    "柵",
    "檆",
    "潸",
    "澘",
    "煽",
    "狦",
    "珊",
    "笘",
    "縿",
    "羴",
    "羶",
    "脠",
    "舢",
    "芟",
    "衫",
    "跚",
    "軕",
    "邖",
    "閊",
    "鯅"
  ],
  "qiàn jiān": ["傔"],
  "què jué": ["傕", "埆"],
  "cāng chen": ["傖"],
  róng: [
    "傛",
    "媶",
    "嫆",
    "嬫",
    "容",
    "峵",
    "嵘",
    "嶸",
    "戎",
    "搈",
    "曧",
    "栄",
    "榕",
    "榮",
    "榵",
    "毧",
    "溶",
    "瀜",
    "烿",
    "熔",
    "狨",
    "瑢",
    "穁",
    "絨",
    "绒",
    "羢",
    "肜",
    "茙",
    "茸",
    "荣",
    "蓉",
    "蝾",
    "融",
    "螎",
    "蠑",
    "褣",
    "鎔",
    "镕",
    "駥"
  ],
  "tà tàn": ["傝"],
  suō: [
    "傞",
    "唆",
    "嗍",
    "嗦",
    "娑",
    "摍",
    "桫",
    "梭",
    "睃",
    "簑",
    "簔",
    "羧",
    "莏",
    "蓑",
    "趖",
    "鮻"
  ],
  dǎi: ["傣", "歹"],
  zài: ["傤", "儎", "再", "在", "扗", "洅", "載", "酨"],
  gǔ: [
    "傦",
    "古",
    "啒",
    "尳",
    "愲",
    "榖",
    "榾",
    "汩",
    "淈",
    "濲",
    "瀔",
    "牯",
    "皷",
    "皼",
    "盬",
    "瞽",
    "穀",
    "罟",
    "羖",
    "股",
    "脵",
    "臌",
    "薣",
    "蛊",
    "蠱",
    "詁",
    "诂",
    "轂",
    "逧",
    "鈷",
    "钴",
    "餶",
    "馉",
    "鼓",
    "鼔",
    "𦙶"
  ],
  bīn: [
    "傧",
    "宾",
    "彬",
    "斌",
    "椕",
    "滨",
    "濒",
    "濱",
    "濵",
    "瀕",
    "繽",
    "缤",
    "虨",
    "豩",
    "豳",
    "賓",
    "賔",
    "邠",
    "鑌",
    "镔",
    "霦",
    "顮"
  ],
  chǔ: [
    "储",
    "儲",
    "杵",
    "椘",
    "楚",
    "楮",
    "檚",
    "濋",
    "璴",
    "础",
    "礎",
    "禇",
    "處",
    "齭",
    "齼",
    "𬺓"
  ],
  nuó: ["傩", "儺", "挪", "梛", "橠"],
  "cān càn": ["傪"],
  lěi: [
    "傫",
    "儡",
    "厽",
    "垒",
    "塁",
    "壘",
    "壨",
    "櫐",
    "灅",
    "癗",
    "矋",
    "磊",
    "礨",
    "耒",
    "蕌",
    "蕾",
    "藟",
    "蘽",
    "蠝",
    "誄",
    "讄",
    "诔",
    "鑸",
    "鸓"
  ],
  cuī: ["催", "凗", "墔", "崔", "嵟", "慛", "摧", "榱", "獕", "磪", "鏙"],
  yōng: [
    "傭",
    "嗈",
    "墉",
    "壅",
    "嫞",
    "庸",
    "廱",
    "慵",
    "拥",
    "擁",
    "滽",
    "灉",
    "牅",
    "痈",
    "癕",
    "癰",
    "臃",
    "邕",
    "郺",
    "鄘",
    "鏞",
    "镛",
    "雍",
    "雝",
    "饔",
    "鱅",
    "鳙",
    "鷛"
  ],
  "zāo cáo": ["傮"],
  sǒng: ["傱", "嵷", "怂", "悚", "愯", "慫", "竦", "耸", "聳", "駷", "㧐"],
  ào: [
    "傲",
    "坳",
    "垇",
    "墺",
    "奡",
    "嫯",
    "岙",
    "岰",
    "嶴",
    "懊",
    "擙",
    "澳",
    "鏊",
    "驁",
    "骜"
  ],
  "qī còu": ["傶"],
  chuǎng: ["傸", "磢", "闖", "闯"],
  shǎ: ["傻", "儍"],
  hàn: [
    "傼",
    "垾",
    "悍",
    "憾",
    "扞",
    "捍",
    "撖",
    "撼",
    "旱",
    "晘",
    "暵",
    "汉",
    "涆",
    "漢",
    "瀚",
    "焊",
    "猂",
    "皔",
    "睅",
    "翰",
    "莟",
    "菡",
    "蛿",
    "蜭",
    "螒",
    "譀",
    "輚",
    "釬",
    "銲",
    "鋎",
    "雗",
    "頷",
    "顄",
    "颔",
    "駻",
    "鶾"
  ],
  zhāng: [
    "傽",
    "嫜",
    "张",
    "張",
    "彰",
    "慞",
    "暲",
    "樟",
    "漳",
    "獐",
    "璋",
    "章",
    "粻",
    "蔁",
    "蟑",
    "遧",
    "鄣",
    "鏱",
    "餦",
    "騿",
    "鱆",
    "麞"
  ],
  "yān yàn": ["傿", "墕", "嬮"],
  "piào biāo": ["僄", "骠"],
  liàn: [
    "僆",
    "堜",
    "媡",
    "恋",
    "戀",
    "楝",
    "殓",
    "殮",
    "湅",
    "潋",
    "澰",
    "瀲",
    "炼",
    "煉",
    "瑓",
    "練",
    "纞",
    "练",
    "萰",
    "錬",
    "鍊",
    "鏈",
    "链",
    "鰊",
    "𬶠"
  ],
  màn: [
    "㵘",
    "僈",
    "墁",
    "幔",
    "慢",
    "曼",
    "漫",
    "澷",
    "熳",
    "獌",
    "縵",
    "缦",
    "蔄",
    "蘰",
    "鄤",
    "鏝",
    "镘",
    "𬜬"
  ],
  "tàn tǎn": ["僋"],
  yíng: [
    "僌",
    "営",
    "塋",
    "嬴",
    "攍",
    "楹",
    "櫿",
    "溁",
    "溋",
    "滢",
    "潆",
    "濙",
    "濚",
    "濴",
    "瀅",
    "瀛",
    "瀠",
    "瀯",
    "灐",
    "灜",
    "熒",
    "營",
    "瑩",
    "盁",
    "盈",
    "禜",
    "籝",
    "籯",
    "縈",
    "茔",
    "荧",
    "莹",
    "萤",
    "营",
    "萦",
    "萾",
    "蓥",
    "藀",
    "蛍",
    "蝇",
    "蝿",
    "螢",
    "蠅",
    "謍",
    "贏",
    "赢",
    "迎",
    "鎣"
  ],
  dòng: [
    "働",
    "冻",
    "凍",
    "动",
    "動",
    "姛",
    "戙",
    "挏",
    "栋",
    "棟",
    "湩",
    "硐",
    "胨",
    "胴",
    "腖",
    "迵",
    "霘",
    "駧"
  ],
  zhuàn: [
    "僎",
    "啭",
    "囀",
    "堟",
    "撰",
    "灷",
    "瑑",
    "篆",
    "腞",
    "蒃",
    "襈",
    "譔",
    "饌",
    "馔"
  ],
  xiàng: [
    "像",
    "勨",
    "向",
    "嚮",
    "姠",
    "嶑",
    "曏",
    "橡",
    "珦",
    "缿",
    "蟓",
    "衖",
    "襐",
    "象",
    "鐌",
    "項",
    "项",
    "鱌"
  ],
  shàn: [
    "僐",
    "善",
    "墠",
    "墡",
    "嬗",
    "擅",
    "敾",
    "椫",
    "樿",
    "歚",
    "汕",
    "灗",
    "疝",
    "磰",
    "繕",
    "缮",
    "膳",
    "蟮",
    "蟺",
    "訕",
    "謆",
    "譱",
    "讪",
    "贍",
    "赡",
    "赸",
    "鄯",
    "鐥",
    "饍",
    "騸",
    "骟",
    "鱓",
    "鱔",
    "鳝",
    "𫮃"
  ],
  "tuí tuǐ": ["僓"],
  zǔn: ["僔", "噂", "撙", "譐"],
  pú: [
    "僕",
    "匍",
    "圤",
    "墣",
    "濮",
    "獛",
    "璞",
    "瞨",
    "穙",
    "莆",
    "菐",
    "菩",
    "葡",
    "蒱",
    "蒲",
    "贌",
    "酺",
    "鏷",
    "镤"
  ],
  láo: [
    "僗",
    "劳",
    "労",
    "勞",
    "哰",
    "崂",
    "嶗",
    "憥",
    "朥",
    "浶",
    "牢",
    "痨",
    "癆",
    "窂",
    "簩",
    "醪",
    "鐒",
    "铹",
    "顟",
    "髝",
    "𫭼"
  ],
  chǎng: ["僘", "厰", "廠", "敞", "昶", "氅", "鋹", "𬬮"],
  guāng: [
    "僙",
    "光",
    "咣",
    "垙",
    "姯",
    "洸",
    "灮",
    "炗",
    "炚",
    "炛",
    "烡",
    "珖",
    "胱",
    "茪",
    "輄",
    "銧",
    "黆",
    "𨐈"
  ],
  liáo: [
    "僚",
    "嘹",
    "嫽",
    "寥",
    "寮",
    "尞",
    "屪",
    "嵺",
    "嶚",
    "嶛",
    "廫",
    "憀",
    "敹",
    "暸",
    "橑",
    "獠",
    "璙",
    "疗",
    "療",
    "竂",
    "簝",
    "繚",
    "缭",
    "聊",
    "膋",
    "膫",
    "藔",
    "蟟",
    "豂",
    "賿",
    "蹘",
    "辽",
    "遼",
    "飉",
    "髎",
    "鷯",
    "鹩"
  ],
  dèng: ["僜", "凳", "墱", "嶝", "櫈", "瞪", "磴", "覴", "邓", "鄧", "隥"],
  "chán zhàn zhuàn": ["僝"],
  bō: [
    "僠",
    "嶓",
    "拨",
    "撥",
    "播",
    "波",
    "溊",
    "玻",
    "癶",
    "盋",
    "砵",
    "碆",
    "礡",
    "缽",
    "菠",
    "袰",
    "蹳",
    "鉢",
    "钵",
    "餑",
    "饽",
    "驋",
    "鱍",
    "𬭛"
  ],
  huì: [
    "僡",
    "匯",
    "卉",
    "喙",
    "嘒",
    "嚖",
    "圚",
    "嬒",
    "寭",
    "屶",
    "屷",
    "彗",
    "彙",
    "彚",
    "徻",
    "恚",
    "恵",
    "惠",
    "慧",
    "憓",
    "懳",
    "晦",
    "暳",
    "槥",
    "橞",
    "檅",
    "櫘",
    "汇",
    "泋",
    "滙",
    "潓",
    "烩",
    "燴",
    "獩",
    "璤",
    "瞺",
    "硊",
    "秽",
    "穢",
    "篲",
    "絵",
    "繪",
    "绘",
    "翙",
    "翽",
    "荟",
    "蔧",
    "蕙",
    "薈",
    "薉",
    "蟪",
    "詯",
    "誨",
    "諱",
    "譓",
    "譿",
    "讳",
    "诲",
    "賄",
    "贿",
    "鐬",
    "闠",
    "阓",
    "靧",
    "頮",
    "顪",
    "颒",
    "餯",
    "𬤝",
    "𬭬"
  ],
  chuǎn: ["僢", "喘", "舛", "荈", "踳"],
  "tiě jiàn": ["僣"],
  sēng: ["僧", "鬙"],
  xiàn: [
    "僩",
    "僴",
    "哯",
    "垷",
    "塪",
    "姭",
    "娊",
    "宪",
    "岘",
    "峴",
    "憲",
    "撊",
    "晛",
    "橌",
    "橺",
    "涀",
    "瀗",
    "献",
    "獻",
    "现",
    "現",
    "県",
    "睍",
    "粯",
    "糮",
    "絤",
    "綫",
    "線",
    "线",
    "缐",
    "羡",
    "羨",
    "腺",
    "臔",
    "臽",
    "苋",
    "莧",
    "誢",
    "豏",
    "鋧",
    "錎",
    "限",
    "陥",
    "陷",
    "霰",
    "餡",
    "馅",
    "麲",
    "鼸",
    "𬀪",
    "𪾢"
  ],
  "yù jú": ["僪"],
  "è wū": ["僫"],
  "tóng zhuàng": ["僮"],
  lǐn: [
    "僯",
    "凛",
    "凜",
    "廩",
    "廪",
    "懍",
    "懔",
    "撛",
    "檁",
    "檩",
    "澟",
    "癛",
    "癝"
  ],
  gù: [
    "僱",
    "凅",
    "固",
    "堌",
    "崓",
    "崮",
    "故",
    "梏",
    "棝",
    "牿",
    "痼",
    "祻",
    "錮",
    "锢",
    "雇",
    "顧",
    "顾",
    "鯝",
    "鲴"
  ],
  jiāng: [
    "僵",
    "壃",
    "姜",
    "橿",
    "殭",
    "江",
    "畕",
    "疅",
    "礓",
    "繮",
    "缰",
    "翞",
    "茳",
    "葁",
    "薑",
    "螀",
    "螿",
    "豇",
    "韁",
    "鱂",
    "鳉"
  ],
  mǐn: [
    "僶",
    "冺",
    "刡",
    "勄",
    "悯",
    "惽",
    "愍",
    "慜",
    "憫",
    "抿",
    "敃",
    "敏",
    "敯",
    "泯",
    "潣",
    "皿",
    "笢",
    "笽",
    "簢",
    "蠠",
    "閔",
    "閩",
    "闵",
    "闽",
    "鰵",
    "鳘",
    "黽"
  ],
  jìn: [
    "僸",
    "凚",
    "噤",
    "嚍",
    "墐",
    "壗",
    "妗",
    "嬧",
    "搢",
    "晉",
    "晋",
    "枃",
    "殣",
    "浕",
    "浸",
    "溍",
    "濅",
    "濜",
    "烬",
    "煡",
    "燼",
    "琎",
    "瑨",
    "璶",
    "盡",
    "祲",
    "縉",
    "缙",
    "荩",
    "藎",
    "覲",
    "觐",
    "賮",
    "贐",
    "赆",
    "近",
    "进",
    "進",
    "靳",
    "齽"
  ],
  "jià jie": ["價"],
  qiào: [
    "僺",
    "峭",
    "帩",
    "撬",
    "殻",
    "窍",
    "竅",
    "誚",
    "诮",
    "躈",
    "陗",
    "鞩",
    "韒",
    "髚"
  ],
  pì: ["僻", "媲", "嫓", "屁", "澼", "甓", "疈", "譬", "闢", "鷿", "鸊", "䴙"],
  sài: ["僿", "簺", "賽", "赛"],
  "chán tǎn shàn": ["儃"],
  "dāng dàng": ["儅", "当", "闣"],
  xuān: [
    "儇",
    "喧",
    "塇",
    "媗",
    "宣",
    "愃",
    "愋",
    "揎",
    "昍",
    "暄",
    "煊",
    "煖",
    "瑄",
    "睻",
    "矎",
    "禤",
    "箮",
    "翧",
    "翾",
    "萱",
    "萲",
    "蓒",
    "蕿",
    "藼",
    "蘐",
    "蝖",
    "蠉",
    "諠",
    "諼",
    "譞",
    "谖",
    "軒",
    "轩",
    "鍹",
    "駽",
    "鰚",
    "𫓶",
    "𫍽"
  ],
  "dān dàn": ["儋", "擔", "瘅"],
  càn: ["儏", "澯", "灿", "燦", "璨", "粲", "薒", "謲"],
  "bīn bìn": ["儐"],
  "án àn": ["儑"],
  tái: [
    "儓",
    "坮",
    "嬯",
    "抬",
    "擡",
    "檯",
    "炱",
    "炲",
    "籉",
    "臺",
    "薹",
    "跆",
    "邰",
    "颱",
    "鮐",
    "鲐"
  ],
  lán: [
    "儖",
    "兰",
    "囒",
    "婪",
    "岚",
    "嵐",
    "幱",
    "拦",
    "攔",
    "斓",
    "斕",
    "栏",
    "欄",
    "欗",
    "澜",
    "瀾",
    "灆",
    "灡",
    "燣",
    "燷",
    "璼",
    "篮",
    "籃",
    "籣",
    "繿",
    "葻",
    "蓝",
    "藍",
    "蘫",
    "蘭",
    "褴",
    "襕",
    "襤",
    "襴",
    "襽",
    "譋",
    "讕",
    "谰",
    "躝",
    "鑭",
    "镧",
    "闌",
    "阑",
    "韊",
    "𬒗"
  ],
  "nǐ yì ài yí": ["儗"],
  méng: [
    "儚",
    "幪",
    "曚",
    "朦",
    "橗",
    "檬",
    "氋",
    "溕",
    "濛",
    "甍",
    "甿",
    "盟",
    "礞",
    "艨",
    "莔",
    "萌",
    "蕄",
    "虻",
    "蝱",
    "鄳",
    "鄸",
    "霿",
    "靀",
    "顭",
    "饛",
    "鯍",
    "鸏",
    "鹲",
    "𫑡",
    "㠓"
  ],
  níng: [
    "儜",
    "凝",
    "咛",
    "嚀",
    "嬣",
    "柠",
    "橣",
    "檸",
    "狞",
    "獰",
    "聍",
    "聹",
    "薴",
    "鑏",
    "鬡",
    "鸋"
  ],
  qióng: [
    "儝",
    "卭",
    "宆",
    "惸",
    "憌",
    "桏",
    "橩",
    "焪",
    "焭",
    "煢",
    "熍",
    "琼",
    "瓊",
    "睘",
    "穷",
    "穹",
    "窮",
    "竆",
    "笻",
    "筇",
    "舼",
    "茕",
    "藑",
    "藭",
    "蛩",
    "蛬",
    "赹",
    "跫",
    "邛",
    "銎",
    "䓖"
  ],
  liè: [
    "儠",
    "冽",
    "列",
    "劣",
    "劽",
    "埒",
    "埓",
    "姴",
    "峛",
    "巤",
    "挒",
    "捩",
    "栵",
    "洌",
    "浖",
    "烈",
    "烮",
    "煭",
    "犣",
    "猎",
    "猟",
    "獵",
    "聗",
    "脟",
    "茢",
    "蛚",
    "趔",
    "躐",
    "迾",
    "颲",
    "鬛",
    "鬣",
    "鮤",
    "鱲",
    "鴷",
    "䴕",
    "𫚭"
  ],
  kuǎng: ["儣", "夼", "懭"],
  bào: [
    "儤",
    "勽",
    "報",
    "忁",
    "报",
    "抱",
    "曓",
    "爆",
    "犦",
    "菢",
    "虣",
    "蚫",
    "豹",
    "鉋",
    "鑤",
    "铇",
    "骲",
    "髱",
    "鮑",
    "鲍"
  ],
  biāo: [
    "儦",
    "墂",
    "幖",
    "彪",
    "标",
    "標",
    "滮",
    "瀌",
    "熛",
    "爂",
    "猋",
    "瘭",
    "磦",
    "膘",
    "臕",
    "謤",
    "贆",
    "鏢",
    "鑣",
    "镖",
    "镳",
    "颮",
    "颷",
    "飆",
    "飇",
    "飈",
    "飊",
    "飑",
    "飙",
    "飚",
    "驫",
    "骉",
    "髟"
  ],
  zǎn: ["儧", "儹", "噆", "攅", "昝", "趱", "趲"],
  háo: [
    "儫",
    "嗥",
    "嘷",
    "噑",
    "嚎",
    "壕",
    "椃",
    "毜",
    "毫",
    "濠",
    "獆",
    "獔",
    "竓",
    "籇",
    "蚝",
    "蠔",
    "譹",
    "豪"
  ],
  qìng: ["儬", "凊", "庆", "慶", "櫦", "濪", "碃", "磬", "罄", "靘"],
  chèn: [
    "儭",
    "嚫",
    "榇",
    "櫬",
    "疢",
    "衬",
    "襯",
    "讖",
    "谶",
    "趁",
    "趂",
    "齓",
    "齔",
    "龀"
  ],
  téng: [
    "儯",
    "幐",
    "滕",
    "漛",
    "疼",
    "籐",
    "籘",
    "縢",
    "腾",
    "藤",
    "虅",
    "螣",
    "誊",
    "謄",
    "邆",
    "駦",
    "騰",
    "驣",
    "鰧",
    "䲢"
  ],
  "lǒng lóng lòng": ["儱"],
  "chán chàn": ["儳"],
  "ráng xiāng": ["儴", "勷"],
  "huì xié": ["儶"],
  luó: [
    "儸",
    "攞",
    "椤",
    "欏",
    "猡",
    "玀",
    "箩",
    "籮",
    "罗",
    "羅",
    "脶",
    "腡",
    "萝",
    "蘿",
    "螺",
    "覼",
    "逻",
    "邏",
    "鏍",
    "鑼",
    "锣",
    "镙",
    "饠",
    "騾",
    "驘",
    "骡",
    "鸁"
  ],
  léi: [
    "儽",
    "嫘",
    "檑",
    "欙",
    "瓃",
    "畾",
    "縲",
    "纍",
    "纝",
    "缧",
    "罍",
    "羸",
    "蔂",
    "蘲",
    "虆",
    "轠",
    "鐳",
    "鑘",
    "镭",
    "雷",
    "靁",
    "鱩",
    "鼺"
  ],
  "nàng nāng": ["儾"],
  "wù wū": ["兀"],
  yǔn: [
    "允",
    "喗",
    "夽",
    "抎",
    "殒",
    "殞",
    "狁",
    "磒",
    "荺",
    "賱",
    "鈗",
    "阭",
    "陨",
    "隕",
    "霣",
    "馻",
    "齫",
    "齳"
  ],
  zān: ["兂", "橵", "簪", "簮", "糌", "鐕", "鐟", "鵤"],
  yuán: [
    "元",
    "円",
    "原",
    "厡",
    "厵",
    "园",
    "圆",
    "圎",
    "園",
    "圓",
    "垣",
    "塬",
    "媴",
    "嫄",
    "援",
    "榞",
    "榬",
    "橼",
    "櫞",
    "沅",
    "湲",
    "源",
    "溒",
    "爰",
    "猨",
    "猿",
    "笎",
    "緣",
    "縁",
    "缘",
    "羱",
    "茒",
    "薗",
    "蝝",
    "蝯",
    "螈",
    "袁",
    "褤",
    "謜",
    "轅",
    "辕",
    "邍",
    "邧",
    "酛",
    "鈨",
    "鎱",
    "騵",
    "魭",
    "鶢",
    "鶰",
    "黿",
    "鼋",
    "𫘪"
  ],
  xiōng: [
    "兄",
    "兇",
    "凶",
    "匂",
    "匈",
    "哅",
    "忷",
    "恟",
    "汹",
    "洶",
    "胷",
    "胸",
    "芎",
    "訩",
    "詾",
    "讻"
  ],
  chōng: [
    "充",
    "嘃",
    "忡",
    "憃",
    "憧",
    "摏",
    "沖",
    "浺",
    "珫",
    "罿",
    "翀",
    "舂",
    "艟",
    "茺",
    "衝",
    "蹖",
    "㳘"
  ],
  zhào: [
    "兆",
    "垗",
    "旐",
    "曌",
    "枛",
    "櫂",
    "照",
    "燳",
    "狣",
    "瞾",
    "笊",
    "罀",
    "罩",
    "羄",
    "肁",
    "肇",
    "肈",
    "詔",
    "诏",
    "赵",
    "趙",
    "鮡",
    "𬶐"
  ],
  "duì ruì yuè": ["兊", "兌", "兑"],
  kè: [
    "克",
    "刻",
    "勀",
    "勊",
    "堁",
    "娔",
    "客",
    "恪",
    "愙",
    "氪",
    "溘",
    "碦",
    "緙",
    "缂",
    "艐",
    "衉",
    "課",
    "课",
    "錁",
    "锞",
    "騍",
    "骒"
  ],
  tù: ["兎", "兔", "堍", "迌", "鵵"],
  dǎng: ["党", "攩", "欓", "譡", "讜", "谠", "黨", "𣗋"],
  dōu: ["兜", "兠", "唗", "橷", "篼", "蔸"],
  huǎng: [
    "兤",
    "奛",
    "幌",
    "怳",
    "恍",
    "晄",
    "炾",
    "熀",
    "縨",
    "詤",
    "謊",
    "谎"
  ],
  rù: ["入", "嗕", "媷", "扖", "杁", "洳", "溽", "縟", "缛", "蓐", "褥", "鳰"],
  nèi: ["內", "氝", "氞", "錗"],
  "yú shù": ["兪"],
  "liù lù": ["六"],
  han: ["兯", "爳"],
  tiān: ["兲", "天", "婖", "添", "酟", "靔", "靝", "黇"],
  "xīng xìng": ["兴"],
  diǎn: [
    "典",
    "嚸",
    "奌",
    "婰",
    "敟",
    "椣",
    "点",
    "碘",
    "蒧",
    "蕇",
    "踮",
    "點"
  ],
  "zī cí": ["兹"],
  jiān: [
    "兼",
    "冿",
    "囏",
    "坚",
    "堅",
    "奸",
    "姦",
    "姧",
    "尖",
    "幵",
    "惤",
    "戋",
    "戔",
    "搛",
    "椾",
    "樫",
    "櫼",
    "歼",
    "殱",
    "殲",
    "湔",
    "瀐",
    "瀸",
    "煎",
    "熞",
    "熸",
    "牋",
    "瑊",
    "睷",
    "礛",
    "礷",
    "笺",
    "箋",
    "緘",
    "縑",
    "缄",
    "缣",
    "肩",
    "艰",
    "艱",
    "菅",
    "菺",
    "葌",
    "蒹",
    "蔪",
    "蕑",
    "蕳",
    "虃",
    "譼",
    "豜",
    "鑯",
    "雃",
    "鞯",
    "韀",
    "韉",
    "餰",
    "馢",
    "鰔",
    "鰜",
    "鰹",
    "鲣",
    "鳒",
    "鵑",
    "鵳",
    "鶼",
    "鹣",
    "麉"
  ],
  shòu: [
    "兽",
    "受",
    "售",
    "壽",
    "夀",
    "寿",
    "授",
    "狩",
    "獣",
    "獸",
    "痩",
    "瘦",
    "綬",
    "绶",
    "膄"
  ],
  jì: [
    "兾",
    "冀",
    "剂",
    "剤",
    "劑",
    "勣",
    "坖",
    "垍",
    "塈",
    "妓",
    "季",
    "寂",
    "寄",
    "廭",
    "彑",
    "徛",
    "忌",
    "悸",
    "惎",
    "懻",
    "技",
    "旡",
    "既",
    "旣",
    "暨",
    "暩",
    "曁",
    "梞",
    "檕",
    "檵",
    "洎",
    "漃",
    "漈",
    "瀱",
    "痵",
    "癠",
    "禝",
    "稩",
    "稷",
    "穄",
    "穊",
    "穧",
    "紀",
    "継",
    "績",
    "繋",
    "繼",
    "继",
    "绩",
    "罽",
    "臮",
    "芰",
    "茍",
    "茤",
    "葪",
    "蓟",
    "蔇",
    "薊",
    "蘎",
    "蘮",
    "蘻",
    "裚",
    "襀",
    "覬",
    "觊",
    "計",
    "記",
    "誋",
    "计",
    "记",
    "跡",
    "跽",
    "蹟",
    "迹",
    "际",
    "際",
    "霁",
    "霽",
    "驥",
    "骥",
    "髻",
    "鬾",
    "魝",
    "魥",
    "鯚",
    "鯽",
    "鰶",
    "鰿",
    "鱀",
    "鱭",
    "鲚",
    "鲫",
    "鵋",
    "鷑",
    "齌",
    "𪟝",
    "𬶨",
    "𬶭"
  ],
  jiōng: ["冂", "冋", "坰", "埛", "扃", "蘏", "蘔", "駉", "駫", "𬳶"],
  mào: [
    "冃",
    "冐",
    "媢",
    "帽",
    "愗",
    "懋",
    "暓",
    "柕",
    "楙",
    "毷",
    "瑁",
    "皃",
    "眊",
    "瞀",
    "耄",
    "茂",
    "萺",
    "蝐",
    "袤",
    "覒",
    "貌",
    "貿",
    "贸",
    "鄚",
    "鄮"
  ],
  rǎn: ["冄", "冉", "姌", "媣", "染", "珃", "苒", "蒅", "䎃"],
  "nèi nà": ["内"],
  gāng: [
    "冈",
    "冮",
    "刚",
    "剛",
    "堈",
    "堽",
    "岡",
    "掆",
    "摃",
    "棡",
    "牨",
    "犅",
    "疘",
    "綱",
    "纲",
    "缸",
    "罁",
    "罡",
    "肛",
    "釭",
    "鎠",
    "㭎"
  ],
  cè: [
    "冊",
    "册",
    "厕",
    "厠",
    "夨",
    "廁",
    "恻",
    "惻",
    "憡",
    "敇",
    "测",
    "測",
    "笧",
    "策",
    "筞",
    "筴",
    "箣",
    "荝",
    "萗",
    "萴",
    "蓛"
  ],
  guǎ: ["冎", "剐", "剮", "叧", "寡"],
  "mào mò": ["冒"],
  gòu: [
    "冓",
    "啂",
    "坸",
    "垢",
    "够",
    "夠",
    "媾",
    "彀",
    "搆",
    "撀",
    "构",
    "構",
    "煹",
    "覯",
    "觏",
    "訽",
    "詬",
    "诟",
    "購",
    "购",
    "遘",
    "雊"
  ],
  xǔ: ["冔", "喣", "暊", "栩", "珝", "盨", "糈", "詡", "諿", "诩", "鄦", "醑"],
  mì: [
    "冖",
    "冪",
    "嘧",
    "塓",
    "宻",
    "密",
    "峚",
    "幂",
    "幎",
    "幦",
    "怽",
    "榓",
    "樒",
    "櫁",
    "汨",
    "淧",
    "滵",
    "漞",
    "濗",
    "熐",
    "羃",
    "蔤",
    "蜜",
    "覓",
    "覔",
    "覛",
    "觅",
    "謐",
    "谧",
    "鼏"
  ],
  "yóu yín": ["冘"],
  xiě: ["写", "冩", "藛"],
  jūn: [
    "军",
    "君",
    "均",
    "桾",
    "汮",
    "皲",
    "皸",
    "皹",
    "碅",
    "莙",
    "蚐",
    "袀",
    "覠",
    "軍",
    "鈞",
    "銁",
    "銞",
    "鍕",
    "钧",
    "頵",
    "鮶",
    "鲪",
    "麏"
  ],
  mí: [
    "冞",
    "擟",
    "瀰",
    "爢",
    "猕",
    "獼",
    "祢",
    "禰",
    "縻",
    "蒾",
    "藌",
    "蘪",
    "蘼",
    "袮",
    "詸",
    "謎",
    "迷",
    "醚",
    "醾",
    "醿",
    "釄",
    "镾",
    "鸍",
    "麊",
    "麋",
    "麛"
  ],
  "guān guàn": ["冠", "覌", "観", "觀", "观"],
  měng: [
    "冡",
    "勐",
    "懵",
    "掹",
    "猛",
    "獴",
    "艋",
    "蜢",
    "蠓",
    "錳",
    "锰",
    "鯭",
    "鼆"
  ],
  zhǒng: ["冢", "塚", "尰", "歱", "煄", "瘇", "肿", "腫", "踵"],
  zuì: [
    "冣",
    "嶵",
    "晬",
    "最",
    "栬",
    "槜",
    "檇",
    "檌",
    "祽",
    "絊",
    "罪",
    "蕞",
    "辠",
    "酔",
    "酻",
    "醉",
    "錊"
  ],
  yuān: [
    "冤",
    "剈",
    "囦",
    "嬽",
    "寃",
    "棩",
    "淵",
    "渁",
    "渆",
    "渊",
    "渕",
    "灁",
    "眢",
    "肙",
    "葾",
    "蒬",
    "蜎",
    "蜵",
    "駌",
    "鳶",
    "鴛",
    "鵷",
    "鸢",
    "鸳",
    "鹓",
    "鼘",
    "鼝"
  ],
  míng: [
    "冥",
    "名",
    "明",
    "暝",
    "朙",
    "榠",
    "洺",
    "溟",
    "猽",
    "眀",
    "眳",
    "瞑",
    "茗",
    "螟",
    "覭",
    "詺",
    "鄍",
    "銘",
    "铭",
    "鳴",
    "鸣"
  ],
  kòu: [
    "冦",
    "叩",
    "宼",
    "寇",
    "扣",
    "敂",
    "滱",
    "窛",
    "筘",
    "簆",
    "蔲",
    "蔻",
    "釦",
    "鷇"
  ],
  tài: [
    "冭",
    "太",
    "夳",
    "忲",
    "态",
    "態",
    "汰",
    "汱",
    "泰",
    "溙",
    "肽",
    "舦",
    "酞",
    "鈦",
    "钛"
  ],
  "féng píng": ["冯", "馮"],
  "chōng chòng": ["冲"],
  kuàng: [
    "况",
    "圹",
    "壙",
    "岲",
    "懬",
    "旷",
    "昿",
    "曠",
    "框",
    "況",
    "爌",
    "眖",
    "眶",
    "矿",
    "砿",
    "礦",
    "穬",
    "絋",
    "絖",
    "纊",
    "纩",
    "貺",
    "贶",
    "軦",
    "邝",
    "鄺",
    "鉱",
    "鋛",
    "鑛",
    "黋"
  ],
  lěng: ["冷"],
  pàn: [
    "冸",
    "判",
    "叛",
    "沜",
    "泮",
    "溿",
    "炍",
    "牉",
    "畔",
    "盼",
    "聁",
    "袢",
    "襻",
    "詊",
    "鋬",
    "鑻",
    "頖",
    "鵥"
  ],
  fā: ["冹", "彂", "沷", "発", "發"],
  xiǎn: [
    "冼",
    "尟",
    "尠",
    "崄",
    "嶮",
    "幰",
    "攇",
    "显",
    "櫶",
    "毨",
    "灦",
    "烍",
    "燹",
    "狝",
    "猃",
    "獫",
    "獮",
    "玁",
    "禒",
    "筅",
    "箲",
    "藓",
    "蘚",
    "蚬",
    "蜆",
    "譣",
    "赻",
    "跣",
    "鍌",
    "险",
    "険",
    "險",
    "韅",
    "顕",
    "顯",
    "㬎"
  ],
  qià: ["冾", "圶", "帢", "恰", "殎", "洽", "硈", "胢", "髂"],
  "jìng chēng": ["净", "凈", "淨"],
  sōu: [
    "凁",
    "嗖",
    "廀",
    "廋",
    "捜",
    "搜",
    "摉",
    "溲",
    "獀",
    "艘",
    "蒐",
    "螋",
    "鄋",
    "醙",
    "鎪",
    "锼",
    "颼",
    "飕",
    "餿",
    "馊",
    "騪"
  ],
  měi: [
    "凂",
    "媄",
    "媺",
    "嬍",
    "嵄",
    "挴",
    "毎",
    "每",
    "浼",
    "渼",
    "燘",
    "美",
    "躾",
    "鎂",
    "镁",
    "黣"
  ],
  tú: [
    "凃",
    "図",
    "图",
    "圖",
    "圗",
    "塗",
    "屠",
    "峹",
    "嵞",
    "庩",
    "廜",
    "徒",
    "悇",
    "揬",
    "涂",
    "瘏",
    "筡",
    "腯",
    "荼",
    "蒤",
    "跿",
    "途",
    "酴",
    "鈯",
    "鍎",
    "馟",
    "駼",
    "鵌",
    "鶟",
    "鷋",
    "鷵",
    "𬳿"
  ],
  zhǔn: ["准", "凖", "埻", "準", "𬘯"],
  "liáng liàng": ["凉", "涼", "量"],
  diāo: [
    "凋",
    "刁",
    "刟",
    "叼",
    "奝",
    "弴",
    "彫",
    "汈",
    "琱",
    "碉",
    "簓",
    "虭",
    "蛁",
    "貂",
    "錭",
    "雕",
    "鮉",
    "鯛",
    "鲷",
    "鵰",
    "鼦"
  ],
  còu: ["凑", "湊", "腠", "輳", "辏"],
  ái: ["凒", "啀", "嘊", "捱", "溰", "癌", "皑", "皚"],
  duó: ["凙", "剫", "夺", "奪", "痥", "踱", "鈬", "鐸", "铎"],
  dú: [
    "凟",
    "匵",
    "嬻",
    "椟",
    "櫝",
    "殰",
    "涜",
    "牍",
    "牘",
    "犊",
    "犢",
    "独",
    "獨",
    "瓄",
    "皾",
    "裻",
    "読",
    "讀",
    "讟",
    "豄",
    "贕",
    "錖",
    "鑟",
    "韇",
    "韣",
    "韥",
    "騳",
    "髑",
    "黩",
    "黷"
  ],
  "jǐ jī": ["几"],
  fán: [
    "凡",
    "凢",
    "凣",
    "匥",
    "墦",
    "杋",
    "柉",
    "棥",
    "樊",
    "瀿",
    "烦",
    "煩",
    "燔",
    "璠",
    "矾",
    "礬",
    "笲",
    "籵",
    "緐",
    "羳",
    "舤",
    "舧",
    "薠",
    "蘩",
    "蠜",
    "襎",
    "蹯",
    "釩",
    "鐇",
    "鐢",
    "钒",
    "鷭",
    "𫔍",
    "𬸪"
  ],
  jū: [
    "凥",
    "匊",
    "娵",
    "婮",
    "居",
    "崌",
    "抅",
    "挶",
    "掬",
    "梮",
    "椐",
    "檋",
    "毩",
    "毱",
    "泃",
    "涺",
    "狙",
    "琚",
    "疽",
    "砠",
    "罝",
    "腒",
    "艍",
    "蜛",
    "裾",
    "諊",
    "跔",
    "踘",
    "躹",
    "陱",
    "雎",
    "鞠",
    "鞫",
    "駒",
    "驹",
    "鮈",
    "鴡",
    "鶋",
    "𬶋"
  ],
  "chù chǔ": ["処", "处"],
  zhǐ: [
    "凪",
    "劧",
    "咫",
    "址",
    "坧",
    "帋",
    "恉",
    "扺",
    "指",
    "旨",
    "枳",
    "止",
    "汦",
    "沚",
    "洔",
    "淽",
    "疻",
    "砋",
    "祉",
    "秖",
    "紙",
    "纸",
    "芷",
    "藢",
    "衹",
    "襧",
    "訨",
    "趾",
    "軹",
    "轵",
    "酯",
    "阯",
    "黹"
  ],
  píng: [
    "凭",
    "凴",
    "呯",
    "坪",
    "塀",
    "岼",
    "帡",
    "帲",
    "幈",
    "平",
    "慿",
    "憑",
    "枰",
    "洴",
    "焩",
    "玶",
    "瓶",
    "甁",
    "竮",
    "箳",
    "簈",
    "缾",
    "荓",
    "萍",
    "蓱",
    "蚲",
    "蛢",
    "評",
    "评",
    "軿",
    "輧",
    "郱",
    "鮃",
    "鲆"
  ],
  kǎi: [
    "凯",
    "凱",
    "剀",
    "剴",
    "垲",
    "塏",
    "恺",
    "愷",
    "慨",
    "暟",
    "蒈",
    "輆",
    "鍇",
    "鎧",
    "铠",
    "锴",
    "闓",
    "闿",
    "颽"
  ],
  gān: [
    "凲",
    "坩",
    "尲",
    "尴",
    "尶",
    "尷",
    "柑",
    "泔",
    "漧",
    "玕",
    "甘",
    "疳",
    "矸",
    "竿",
    "筸",
    "粓",
    "肝",
    "苷",
    "迀",
    "酐",
    "魐"
  ],
  "kǎn qiǎn": ["凵"],
  tū: [
    "凸",
    "堗",
    "嶀",
    "捸",
    "涋",
    "湥",
    "痜",
    "禿",
    "秃",
    "突",
    "葖",
    "鋵",
    "鵚",
    "鼵",
    "㻬"
  ],
  "āo wā": ["凹"],
  chū: ["出", "初", "岀", "摴", "榋", "樗", "貙", "齣", "䢺", "䝙"],
  dàng: [
    "凼",
    "圵",
    "垱",
    "壋",
    "档",
    "檔",
    "氹",
    "璗",
    "瓽",
    "盪",
    "瞊",
    "砀",
    "碭",
    "礑",
    "簜",
    "荡",
    "菪",
    "蕩",
    "蘯",
    "趤",
    "逿",
    "雼",
    "𬍡"
  ],
  hán: [
    "函",
    "凾",
    "含",
    "圅",
    "娢",
    "寒",
    "崡",
    "晗",
    "梒",
    "浛",
    "涵",
    "澏",
    "焓",
    "琀",
    "甝",
    "筨",
    "蜬",
    "邗",
    "邯",
    "鋡",
    "韓",
    "韩"
  ],
  záo: ["凿", "鑿"],
  dāo: ["刀", "刂", "忉", "氘", "舠", "螩", "釖", "魛", "鱽"],
  chuāng: ["刅", "摐", "牎", "牕", "疮", "瘡", "窓", "窗", "窻"],
  "fēn fèn": ["分"],
  "qiè qiē": ["切"],
  kān: ["刊", "勘", "堪", "戡", "栞", "龕", "龛"],
  cǔn: ["刌", "忖"],
  chú: [
    "刍",
    "厨",
    "幮",
    "廚",
    "橱",
    "櫉",
    "櫥",
    "滁",
    "犓",
    "篨",
    "耡",
    "芻",
    "蒢",
    "蒭",
    "蜍",
    "蟵",
    "豠",
    "趎",
    "蹰",
    "躇",
    "躕",
    "鉏",
    "鋤",
    "锄",
    "除",
    "雏",
    "雛",
    "鶵"
  ],
  "huà huá": ["划"],
  lí: [
    "刕",
    "剓",
    "剺",
    "劙",
    "厘",
    "喱",
    "嚟",
    "囄",
    "嫠",
    "孷",
    "廲",
    "悡",
    "梨",
    "梸",
    "棃",
    "漓",
    "灕",
    "犁",
    "犂",
    "狸",
    "琍",
    "璃",
    "瓈",
    "盠",
    "睝",
    "离",
    "穲",
    "竰",
    "筣",
    "篱",
    "籬",
    "糎",
    "縭",
    "缡",
    "罹",
    "艃",
    "荲",
    "菞",
    "蓠",
    "蔾",
    "藜",
    "蘺",
    "蜊",
    "蟍",
    "蟸",
    "蠫",
    "褵",
    "謧",
    "貍",
    "醨",
    "鋫",
    "錅",
    "鏫",
    "鑗",
    "離",
    "驪",
    "骊",
    "鯏",
    "鯬",
    "鱺",
    "鲡",
    "鵹",
    "鸝",
    "鹂",
    "黎",
    "黧",
    "㰀"
  ],
  yuè: [
    "刖",
    "嬳",
    "岄",
    "岳",
    "嶽",
    "恱",
    "悅",
    "悦",
    "戉",
    "抈",
    "捳",
    "月",
    "樾",
    "瀹",
    "爚",
    "玥",
    "礿",
    "禴",
    "篗",
    "籆",
    "籥",
    "籰",
    "粤",
    "粵",
    "蘥",
    "蚎",
    "蚏",
    "説",
    "越",
    "跀",
    "跃",
    "躍",
    "軏",
    "鈅",
    "鉞",
    "鑰",
    "钺",
    "閱",
    "閲",
    "阅",
    "鸑",
    "鸙",
    "黦",
    "龠",
    "𫐄",
    "𬸚"
  ],
  liú: [
    "刘",
    "劉",
    "嚠",
    "媹",
    "嵧",
    "旈",
    "旒",
    "榴",
    "橊",
    "流",
    "浏",
    "瀏",
    "琉",
    "瑠",
    "瑬",
    "璢",
    "畄",
    "留",
    "畱",
    "疁",
    "瘤",
    "癅",
    "硫",
    "蒥",
    "蓅",
    "蟉",
    "裗",
    "鎏",
    "鏐",
    "鐂",
    "镠",
    "飀",
    "飅",
    "飗",
    "駠",
    "駵",
    "騮",
    "驑",
    "骝",
    "鰡",
    "鶹",
    "鹠",
    "麍"
  ],
  zé: [
    "则",
    "則",
    "啧",
    "嘖",
    "嫧",
    "帻",
    "幘",
    "択",
    "樍",
    "歵",
    "沢",
    "泎",
    "溭",
    "皟",
    "瞔",
    "矠",
    "礋",
    "箦",
    "簀",
    "舴",
    "蔶",
    "蠌",
    "襗",
    "謮",
    "賾",
    "赜",
    "迮",
    "鸅",
    "齚",
    "齰"
  ],
  "chuàng chuāng": ["创", "創"],
  qù: ["刞", "厺", "去", "閴", "闃", "阒", "麮", "鼁"],
  "bié biè": ["別", "别"],
  "páo bào": ["刨"],
  "chǎn chàn": ["刬", "剗", "幝"],
  guā: [
    "刮",
    "劀",
    "桰",
    "歄",
    "煱",
    "瓜",
    "胍",
    "踻",
    "颪",
    "颳",
    "騧",
    "鴰",
    "鸹"
  ],
  gēng: [
    "刯",
    "庚",
    "椩",
    "浭",
    "焿",
    "畊",
    "絚",
    "羮",
    "羹",
    "耕",
    "菮",
    "賡",
    "赓",
    "鶊",
    "鹒"
  ],
  dào: [
    "到",
    "噵",
    "悼",
    "椡",
    "檤",
    "燾",
    "瓙",
    "盗",
    "盜",
    "稲",
    "稻",
    "纛",
    "翿",
    "艔",
    "菿",
    "衜",
    "衟",
    "軇",
    "道"
  ],
  chuàng: ["刱", "剏", "剙", "怆", "愴"],
  kū: ["刳", "哭", "圐", "堀", "枯", "桍", "矻", "窟", "跍", "郀", "骷", "鮬"],
  duò: [
    "刴",
    "剁",
    "墯",
    "尮",
    "惰",
    "憜",
    "挅",
    "桗",
    "舵",
    "跥",
    "跺",
    "陊",
    "陏",
    "飿",
    "饳",
    "鵽"
  ],
  "shuā shuà": ["刷"],
  "quàn xuàn": ["券"],
  "chà shā": ["刹", "剎"],
  "cì cī": ["刺"],
  guì: [
    "刽",
    "刿",
    "劊",
    "劌",
    "撌",
    "攰",
    "昋",
    "桂",
    "椢",
    "槶",
    "樻",
    "櫃",
    "猤",
    "禬",
    "筀",
    "蓕",
    "襘",
    "貴",
    "贵",
    "跪",
    "鐀",
    "鑎",
    "鞼",
    "鱖",
    "鱥"
  ],
  lóu: [
    "剅",
    "娄",
    "婁",
    "廔",
    "楼",
    "樓",
    "溇",
    "漊",
    "熡",
    "耧",
    "耬",
    "艛",
    "蒌",
    "蔞",
    "蝼",
    "螻",
    "謱",
    "軁",
    "遱",
    "鞻",
    "髅",
    "髏",
    "𪣻"
  ],
  cuò: [
    "剉",
    "剒",
    "厝",
    "夎",
    "挫",
    "措",
    "棤",
    "莝",
    "莡",
    "蓌",
    "逪",
    "銼",
    "錯",
    "锉",
    "错"
  ],
  "xiāo xuē": ["削"],
  "kēi kè": ["剋", "尅"],
  "là lá": ["剌"],
  tī: ["剔", "梯", "踢", "銻", "锑", "鷈", "鷉", "䏲", "䴘"],
  pōu: ["剖"],
  wān: ["剜", "塆", "壪", "帵", "弯", "彎", "湾", "潫", "灣", "睕", "蜿", "豌"],
  "bāo bō": ["剝", "剥"],
  duō: ["剟", "咄", "哆", "嚉", "多", "夛", "掇", "毲", "畓", "裰", "㙍"],
  qíng: [
    "剠",
    "勍",
    "夝",
    "情",
    "擎",
    "晴",
    "暒",
    "棾",
    "樈",
    "檠",
    "氰",
    "甠",
    "硘",
    "葝",
    "黥"
  ],
  "yǎn shàn": ["剡"],
  "dū zhuó": ["剢"],
  yān: [
    "剦",
    "嫣",
    "崦",
    "嶖",
    "恹",
    "懕",
    "懨",
    "樮",
    "淊",
    "淹",
    "漹",
    "烟",
    "焉",
    "焑",
    "煙",
    "珚",
    "篶",
    "胭",
    "臙",
    "菸",
    "鄢",
    "醃",
    "閹",
    "阉",
    "黫"
  ],
  huō: ["剨", "劐", "吙", "攉", "秴", "耠", "锪", "騞", "𬴃"],
  shèng: [
    "剩",
    "剰",
    "勝",
    "圣",
    "墭",
    "嵊",
    "晠",
    "榺",
    "橳",
    "琞",
    "聖",
    "蕂",
    "貹",
    "賸"
  ],
  "duān zhì": ["剬"],
  wū: [
    "剭",
    "呜",
    "嗚",
    "圬",
    "屋",
    "巫",
    "弙",
    "杇",
    "歍",
    "汙",
    "汚",
    "污",
    "洿",
    "烏",
    "窏",
    "箼",
    "螐",
    "誈",
    "誣",
    "诬",
    "邬",
    "鄔",
    "鎢",
    "钨",
    "鰞",
    "鴮"
  ],
  gē: [
    "割",
    "哥",
    "圪",
    "彁",
    "戈",
    "戓",
    "戨",
    "歌",
    "滒",
    "犵",
    "肐",
    "袼",
    "謌",
    "鎶",
    "鴚",
    "鴿",
    "鸽"
  ],
  "dá zhá": ["剳"],
  chuán: ["剶", "暷", "椽", "篅", "舡", "舩", "船", "輲", "遄"],
  "tuán zhuān": ["剸", "漙", "篿"],
  "lù jiū": ["剹"],
  pēng: ["剻", "匉", "嘭", "怦", "恲", "抨", "梈", "烹", "砰", "軯", "駍"],
  piāo: ["剽", "勡", "慓", "旚", "犥", "翲", "螵", "飃", "飄", "飘", "魒"],
  kōu: ["剾", "彄", "抠", "摳", "眍", "瞘", "芤", "𫸩"],
  "jiǎo chāo": ["剿", "劋", "勦", "摷"],
  qiāo: [
    "劁",
    "勪",
    "墝",
    "幧",
    "敲",
    "橇",
    "毃",
    "燆",
    "硗",
    "磽",
    "繑",
    "趬",
    "跷",
    "踍",
    "蹺",
    "蹻",
    "郻",
    "鄡",
    "鄥",
    "鍫",
    "鍬",
    "鐰",
    "锹",
    "頝"
  ],
  "huá huà": ["劃"],
  "zhā zhá": ["劄"],
  "pī pǐ": ["劈", "悂"],
  tāng: ["劏", "嘡", "羰", "薚", "蝪", "蹚", "鞺", "鼞"],
  chán: [
    "劖",
    "嚵",
    "壥",
    "婵",
    "嬋",
    "巉",
    "廛",
    "棎",
    "毚",
    "湹",
    "潹",
    "潺",
    "澶",
    "瀍",
    "瀺",
    "煘",
    "獑",
    "磛",
    "緾",
    "纏",
    "纒",
    "缠",
    "艬",
    "蝉",
    "蟐",
    "蟬",
    "蟾",
    "誗",
    "讒",
    "谗",
    "躔",
    "鄽",
    "酁",
    "鋋",
    "鑱",
    "镵",
    "饞",
    "馋"
  ],
  zuān: ["劗", "躜", "躦", "鉆", "鑚"],
  mó: [
    "劘",
    "嫫",
    "嬤",
    "嬷",
    "尛",
    "摹",
    "擵",
    "橅",
    "糢",
    "膜",
    "藦",
    "蘑",
    "謨",
    "謩",
    "谟",
    "饃",
    "饝",
    "馍",
    "髍",
    "魔",
    "魹"
  ],
  zhú: [
    "劚",
    "斸",
    "曯",
    "欘",
    "灟",
    "炢",
    "烛",
    "燭",
    "爥",
    "瘃",
    "竹",
    "笁",
    "笜",
    "舳",
    "茿",
    "蓫",
    "蠋",
    "蠾",
    "躅",
    "逐",
    "逫",
    "钃",
    "鱁"
  ],
  quàn: ["劝", "勧", "勸", "牶", "韏"],
  "jìn jìng": ["劤", "劲", "勁"],
  kēng: ["劥", "坑", "牼", "硁", "硜", "誙", "銵", "鍞", "鏗", "铿", "阬"],
  "xié liè": ["劦"],
  "zhù chú": ["助"],
  nǔ: ["努", "弩", "砮", "胬"],
  shào: ["劭", "卲", "哨", "潲", "紹", "綤", "绍", "袑", "邵"],
  miǎo: ["劰", "杪", "淼", "渺", "眇", "秒", "篎", "緲", "缈", "藐", "邈"],
  kǒu: ["劶", "口"],
  wā: [
    "劸",
    "娲",
    "媧",
    "屲",
    "挖",
    "攨",
    "洼",
    "溛",
    "漥",
    "瓾",
    "畖",
    "穵",
    "窊",
    "窪",
    "蛙",
    "韈",
    "鼃"
  ],
  kuāng: [
    "劻",
    "匡",
    "匩",
    "哐",
    "恇",
    "洭",
    "筐",
    "筺",
    "誆",
    "诓",
    "軭",
    "邼"
  ],
  hé: [
    "劾",
    "咊",
    "啝",
    "姀",
    "峆",
    "敆",
    "曷",
    "柇",
    "楁",
    "毼",
    "河",
    "涸",
    "渮",
    "澕",
    "熆",
    "皬",
    "盇",
    "盉",
    "盍",
    "盒",
    "禾",
    "篕",
    "籺",
    "粭",
    "翮",
    "菏",
    "萂",
    "覈",
    "訸",
    "詥",
    "郃",
    "釛",
    "鉌",
    "鑉",
    "閡",
    "闔",
    "阂",
    "阖",
    "鞨",
    "頜",
    "餄",
    "饸",
    "魺",
    "鹖",
    "麧",
    "齕",
    "龁",
    "龢",
    "𬌗"
  ],
  gào: [
    "勂",
    "吿",
    "告",
    "峼",
    "祮",
    "祰",
    "禞",
    "筶",
    "誥",
    "诰",
    "郜",
    "鋯",
    "锆"
  ],
  "bó bèi": ["勃"],
  láng: [
    "勆",
    "嫏",
    "廊",
    "斏",
    "桹",
    "榔",
    "樃",
    "欴",
    "狼",
    "琅",
    "瑯",
    "硠",
    "稂",
    "艆",
    "蓈",
    "蜋",
    "螂",
    "躴",
    "郒",
    "郞",
    "鋃",
    "鎯",
    "锒"
  ],
  xūn: [
    "勋",
    "勛",
    "勲",
    "勳",
    "嚑",
    "坃",
    "埙",
    "塤",
    "壎",
    "壦",
    "曛",
    "燻",
    "獯",
    "矄",
    "纁",
    "臐",
    "薫",
    "薰",
    "蘍",
    "醺",
    "𫄸"
  ],
  "juàn juān": ["勌", "瓹"],
  "lè lēi": ["勒"],
  kài: ["勓", "炌", "烗", "鎎"],
  "wěng yǎng": ["勜"],
  qín: [
    "勤",
    "嗪",
    "噙",
    "嶜",
    "庈",
    "懃",
    "懄",
    "捦",
    "擒",
    "斳",
    "檎",
    "澿",
    "珡",
    "琴",
    "琹",
    "瘽",
    "禽",
    "秦",
    "耹",
    "芩",
    "芹",
    "菦",
    "螓",
    "蠄",
    "鈙",
    "鈫",
    "雂",
    "靲",
    "鳹",
    "鵭"
  ],
  jiàng: [
    "勥",
    "匞",
    "匠",
    "嵹",
    "弜",
    "弶",
    "摾",
    "櫤",
    "洚",
    "滰",
    "犟",
    "糡",
    "糨",
    "絳",
    "绛",
    "謽",
    "酱",
    "醤",
    "醬"
  ],
  fān: [
    "勫",
    "嬏",
    "帆",
    "幡",
    "忛",
    "憣",
    "旙",
    "旛",
    "繙",
    "翻",
    "藩",
    "轓",
    "颿",
    "飜",
    "鱕"
  ],
  juān: ["勬", "姢", "娟", "捐", "涓", "蠲", "裐", "鎸", "鐫", "镌", "鹃"],
  "tóng dòng": ["勭", "烔", "燑", "狪"],
  lǜ: [
    "勴",
    "垏",
    "嵂",
    "律",
    "慮",
    "氯",
    "滤",
    "濾",
    "爈",
    "箻",
    "綠",
    "繂",
    "膟",
    "葎",
    "虑",
    "鑢"
  ],
  chè: [
    "勶",
    "坼",
    "彻",
    "徹",
    "掣",
    "撤",
    "澈",
    "烢",
    "爡",
    "瞮",
    "硩",
    "聅",
    "迠",
    "頙",
    "㬚"
  ],
  sháo: ["勺", "玿", "韶"],
  "gōu gòu": ["勾"],
  cōng: [
    "匆",
    "囪",
    "囱",
    "忩",
    "怱",
    "悤",
    "暰",
    "樬",
    "漗",
    "瑽",
    "璁",
    "瞛",
    "篵",
    "繱",
    "聡",
    "聦",
    "聪",
    "聰",
    "苁",
    "茐",
    "葱",
    "蓯",
    "蔥",
    "蟌",
    "鍯",
    "鏓",
    "鏦",
    "騘",
    "驄",
    "骢"
  ],
  "táo yáo": ["匋", "陶"],
  páo: ["匏", "咆", "垉", "庖", "爮", "狍", "袍", "褜", "軳", "鞄", "麅"],
  dá: [
    "匒",
    "妲",
    "怛",
    "炟",
    "燵",
    "畣",
    "笪",
    "羍",
    "荙",
    "薘",
    "蟽",
    "詚",
    "达",
    "迏",
    "迖",
    "迚",
    "逹",
    "達",
    "鐽",
    "靼",
    "鞑",
    "韃",
    "龖",
    "龘",
    "𫟼"
  ],
  "huà huā": ["化"],
  "běi bèi": ["北"],
  nǎo: ["匘", "垴", "堖", "嫐", "恼", "悩", "惱", "瑙", "碯", "脑", "脳", "腦"],
  "chí shi": ["匙"],
  fāng: ["匚", "堏", "方", "淓", "牥", "芳", "邡", "鈁", "錺", "钫", "鴋"],
  zā: ["匝", "咂", "帀", "沞", "臜", "臢", "迊", "鉔", "魳"],
  qiè: [
    "匧",
    "厒",
    "妾",
    "怯",
    "悏",
    "惬",
    "愜",
    "挈",
    "穕",
    "窃",
    "竊",
    "笡",
    "箧",
    "篋",
    "籡",
    "踥",
    "鍥",
    "锲",
    "鯜"
  ],
  "zāng cáng": ["匨"],
  fěi: ["匪", "奜", "悱", "棐", "榧", "篚", "翡", "蕜", "誹", "诽"],
  "kuì guì": ["匮", "匱"],
  suǎn: ["匴"],
  pǐ: ["匹", "噽", "嚭", "圮", "庀", "痞", "癖", "脴", "苉", "銢", "鴄"],
  "qū ōu": ["区", "區"],
  "kē qià": ["匼"],
  "yǎn yàn": ["匽", "棪"],
  biǎn: ["匾", "惼", "揙", "碥", "稨", "窆", "藊", "褊", "貶", "贬", "鴘"],
  nì: [
    "匿",
    "堄",
    "嫟",
    "嬺",
    "惄",
    "愵",
    "昵",
    "暱",
    "氼",
    "眤",
    "睨",
    "縌",
    "胒",
    "腻",
    "膩",
    "逆",
    "𨺙"
  ],
  niàn: ["卄", "唸", "埝", "廿", "念", "惗", "艌"],
  sà: ["卅", "櫒", "脎", "萨", "蕯", "薩", "鈒", "隡", "颯", "飒", "馺"],
  zú: ["卆", "哫", "崪", "族", "箤", "足", "踤", "镞"],
  shēng: [
    "升",
    "呏",
    "声",
    "斘",
    "昇",
    "曻",
    "枡",
    "殅",
    "泩",
    "湦",
    "焺",
    "牲",
    "珄",
    "生",
    "甥",
    "竔",
    "笙",
    "聲",
    "鉎",
    "鍟",
    "阩",
    "陞",
    "陹",
    "鵿",
    "鼪"
  ],
  wàn: [
    "卍",
    "卐",
    "忨",
    "杤",
    "瞣",
    "脕",
    "腕",
    "萬",
    "蟃",
    "贎",
    "輐",
    "錽",
    "𬇕"
  ],
  "huá huà huā": ["华", "華"],
  bēi: ["卑", "悲", "揹", "杯", "桮", "盃", "碑", "藣", "鵯", "鹎"],
  "zú cù": ["卒"],
  "dān shàn chán": ["单", "單"],
  "nán nā": ["南"],
  "shuài lǜ": ["卛"],
  "bǔ bo pú": ["卜"],
  "kuàng guàn": ["卝"],
  biàn: [
    "卞",
    "变",
    "変",
    "峅",
    "弁",
    "徧",
    "忭",
    "抃",
    "昪",
    "汳",
    "汴",
    "玣",
    "艑",
    "苄",
    "覍",
    "諚",
    "變",
    "辡",
    "辧",
    "辨",
    "辩",
    "辫",
    "辮",
    "辯",
    "遍",
    "釆",
    "𨚕"
  ],
  bǔ: ["卟", "哺", "捕", "补", "補", "鸔", "𬷕"],
  "zhàn zhān": ["占", "覱"],
  "kǎ qiǎ": ["卡"],
  lú: [
    "卢",
    "嚧",
    "垆",
    "壚",
    "庐",
    "廬",
    "曥",
    "枦",
    "栌",
    "櫨",
    "泸",
    "瀘",
    "炉",
    "爐",
    "獹",
    "玈",
    "瓐",
    "盧",
    "矑",
    "籚",
    "纑",
    "罏",
    "胪",
    "臚",
    "舮",
    "舻",
    "艫",
    "芦",
    "蘆",
    "蠦",
    "轤",
    "轳",
    "鈩",
    "鑪",
    "顱",
    "颅",
    "馿",
    "髗",
    "魲",
    "鱸",
    "鲈",
    "鸕",
    "鸬",
    "黸",
    "𬬻"
  ],
  lǔ: [
    "卤",
    "塷",
    "掳",
    "擄",
    "樐",
    "橹",
    "櫓",
    "氌",
    "滷",
    "澛",
    "瀂",
    "硵",
    "磠",
    "穞",
    "艣",
    "艪",
    "蓾",
    "虏",
    "虜",
    "鏀",
    "鐪",
    "鑥",
    "镥",
    "魯",
    "鲁",
    "鹵"
  ],
  guà: ["卦", "啩", "挂", "掛", "罣", "褂", "詿", "诖"],
  "áng yǎng": ["卬"],
  yìn: [
    "印",
    "垽",
    "堷",
    "廕",
    "慭",
    "憖",
    "憗",
    "懚",
    "洕",
    "湚",
    "猌",
    "癊",
    "胤",
    "茚",
    "酳",
    "鮣",
    "䲟"
  ],
  què: [
    "却",
    "卻",
    "塙",
    "崅",
    "悫",
    "愨",
    "慤",
    "搉",
    "榷",
    "燩",
    "琷",
    "皵",
    "确",
    "確",
    "礭",
    "闋",
    "阕",
    "鵲",
    "鹊",
    "𬒈"
  ],
  luǎn: ["卵"],
  "juàn juǎn": ["卷", "巻"],
  "chǎng ān hàn": ["厂"],
  "wěi yán": ["厃"],
  tīng: [
    "厅",
    "厛",
    "听",
    "庁",
    "廰",
    "廳",
    "汀",
    "烃",
    "烴",
    "綎",
    "耓",
    "聴",
    "聼",
    "聽",
    "鞓",
    "𬘩"
  ],
  "zhé zhái": ["厇"],
  "hàn àn": ["厈", "屽"],
  yǎ: ["厊", "唖", "庌", "痖", "瘂", "蕥"],
  shè: [
    "厍",
    "厙",
    "弽",
    "慑",
    "慴",
    "懾",
    "摂",
    "欇",
    "涉",
    "涻",
    "渉",
    "滠",
    "灄",
    "社",
    "舎",
    "蔎",
    "蠂",
    "設",
    "设",
    "赦",
    "騇",
    "麝"
  ],
  dǐ: [
    "厎",
    "呧",
    "坘",
    "弤",
    "抵",
    "拞",
    "掋",
    "牴",
    "砥",
    "菧",
    "觝",
    "詆",
    "诋",
    "軧",
    "邸",
    "阺",
    "骶",
    "鯳"
  ],
  "zhǎ zhǎi": ["厏"],
  páng: ["厐", "嫎", "庞", "徬", "舽", "螃", "逄", "鰟", "鳑", "龎", "龐"],
  "zhì shī": ["厔"],
  máng: [
    "厖",
    "吂",
    "哤",
    "娏",
    "忙",
    "恾",
    "杗",
    "杧",
    "汒",
    "浝",
    "牻",
    "痝",
    "盲",
    "硭",
    "笀",
    "芒",
    "茫",
    "蘉",
    "邙",
    "釯",
    "鋩",
    "铓",
    "駹"
  ],
  zuī: ["厜", "樶", "纗", "蟕"],
  "shà xià": ["厦", "廈"],
  áo: [
    "厫",
    "嗷",
    "嗸",
    "廒",
    "敖",
    "滶",
    "獒",
    "獓",
    "璈",
    "翱",
    "翶",
    "翺",
    "聱",
    "蔜",
    "螯",
    "謷",
    "謸",
    "遨",
    "鏖",
    "隞",
    "鰲",
    "鳌",
    "鷔",
    "鼇"
  ],
  "lán qiān": ["厱"],
  "sī mǒu": ["厶"],
  "gōng hóng": ["厷"],
  "lín miǎo": ["厸"],
  "qiú róu": ["厹"],
  dū: ["厾", "嘟", "督", "醏"],
  "xiàn xuán": ["县", "縣"],
  "cān shēn cēn sān": ["参", "參", "叄", "叅"],
  "ài yǐ": ["叆"],
  "chā chà chǎ chá": ["叉"],
  shuāng: [
    "双",
    "孀",
    "孇",
    "欆",
    "礵",
    "艭",
    "雙",
    "霜",
    "騻",
    "驦",
    "骦",
    "鷞",
    "鸘",
    "鹴"
  ],
  shōu: ["収", "收"],
  guái: ["叏"],
  bá: [
    "叐",
    "妭",
    "抜",
    "拔",
    "炦",
    "癹",
    "胈",
    "茇",
    "菝",
    "詙",
    "跋",
    "軷",
    "魃",
    "鼥"
  ],
  "fā fà": ["发"],
  "zhuó yǐ lì jué": ["叕"],
  qǔ: ["取", "娶", "竬", "蝺", "詓", "齲", "龋"],
  "jiǎ xiá": ["叚", "徦"],
  "wèi yù": ["叞", "尉", "蔚"],
  dié: [
    "叠",
    "垤",
    "堞",
    "峌",
    "幉",
    "恎",
    "惵",
    "戜",
    "曡",
    "殜",
    "氎",
    "牃",
    "牒",
    "瓞",
    "畳",
    "疂",
    "疉",
    "疊",
    "碟",
    "絰",
    "绖",
    "耊",
    "耋",
    "胅",
    "艓",
    "苵",
    "蜨",
    "蝶",
    "褋",
    "詄",
    "諜",
    "谍",
    "跮",
    "蹀",
    "迭",
    "镻",
    "鰈",
    "鲽",
    "鴩",
    "𫶇"
  ],
  ruì: ["叡", "枘", "汭", "瑞", "睿", "芮", "蚋", "蜹", "銳", "鋭", "锐"],
  "jù gōu": ["句"],
  lìng: ["另", "呤", "炩", "蘦"],
  "dāo dáo tāo": ["叨"],
  "zhī zhǐ": ["只"],
  jiào: [
    "叫",
    "呌",
    "嘂",
    "嘦",
    "噍",
    "嬓",
    "斍",
    "斠",
    "滘",
    "漖",
    "獥",
    "珓",
    "皭",
    "窖",
    "藠",
    "訆",
    "譥",
    "趭",
    "較",
    "轎",
    "轿",
    "较",
    "酵",
    "醮",
    "釂"
  ],
  "zhào shào": ["召"],
  "kě kè": ["可"],
  "tái tāi": ["台", "苔"],
  pǒ: ["叵", "尀", "笸", "箥", "鉕", "钷", "駊"],
  "yè xié": ["叶"],
  "hào háo": ["号"],
  tàn: ["叹", "嘆", "探", "歎", "湠", "炭", "碳", "舕"],
  "hōng hóng": ["叿"],
  miē: ["吀", "咩", "哶", "孭"],
  "xū yū yù": ["吁"],
  chī: [
    "吃",
    "哧",
    "喫",
    "嗤",
    "噄",
    "妛",
    "媸",
    "彨",
    "彲",
    "摛",
    "攡",
    "殦",
    "瓻",
    "痴",
    "癡",
    "眵",
    "瞝",
    "笞",
    "粚",
    "胵",
    "蚩",
    "螭",
    "訵",
    "魑",
    "鴟",
    "鵄",
    "鸱",
    "黐",
    "齝",
    "𫄨"
  ],
  "xuān sòng": ["吅"],
  yāo: [
    "吆",
    "喓",
    "夭",
    "妖",
    "幺",
    "楆",
    "殀",
    "祅",
    "腰",
    "葽",
    "訞",
    "邀",
    "鴁",
    "鴢",
    "㙘"
  ],
  zǐ: [
    "吇",
    "姉",
    "姊",
    "子",
    "杍",
    "梓",
    "榟",
    "橴",
    "滓",
    "矷",
    "秭",
    "笫",
    "籽",
    "紫",
    "耔",
    "虸",
    "訿",
    "釨"
  ],
  "hé gě": ["合", "鲄"],
  "cùn dòu": ["吋"],
  "tóng tòng": ["同"],
  "tǔ tù": ["吐", "唋"],
  "zhà zhā": ["吒", "奓"],
  "xià hè": ["吓"],
  "ā yā": ["吖"],
  "ma má mǎ": ["吗"],
  lìn: [
    "吝",
    "恡",
    "悋",
    "橉",
    "焛",
    "甐",
    "膦",
    "蔺",
    "藺",
    "賃",
    "赁",
    "蹸",
    "躏",
    "躙",
    "躪",
    "轥",
    "閵"
  ],
  tūn: ["吞", "暾", "朜", "焞"],
  "bǐ pǐ": ["吡"],
  qìn: ["吢", "吣", "唚", "抋", "揿", "搇", "撳", "沁", "瀙", "菣", "藽"],
  "jiè gè": ["吤"],
  "fǒu pǐ": ["否"],
  "ba bā": ["吧"],
  dūn: [
    "吨",
    "噸",
    "墩",
    "墪",
    "惇",
    "撉",
    "撴",
    "犜",
    "獤",
    "礅",
    "蜳",
    "蹾",
    "驐"
  ],
  fēn: [
    "吩",
    "帉",
    "昐",
    "朆",
    "梤",
    "棻",
    "氛",
    "竕",
    "紛",
    "纷",
    "翂",
    "芬",
    "衯",
    "訜",
    "躮",
    "酚",
    "鈖",
    "雰",
    "餴",
    "饙",
    "馚"
  ],
  "é huā": ["吪"],
  "kēng háng": ["吭", "妔"],
  shǔn: ["吮"],
  "zhī zī": ["吱"],
  "yǐn shěn": ["吲"],
  wú: [
    "吳",
    "吴",
    "呉",
    "墲",
    "峿",
    "梧",
    "橆",
    "毋",
    "洖",
    "浯",
    "無",
    "珸",
    "璑",
    "祦",
    "芜",
    "茣",
    "莁",
    "蕪",
    "蜈",
    "蟱",
    "譕",
    "郚",
    "鋙",
    "铻",
    "鯃",
    "鵐",
    "鷡",
    "鹀",
    "鼯"
  ],
  "chǎo chāo": ["吵"],
  "nà nè": ["吶"],
  "xuè chuò jué": ["吷"],
  chuī: ["吹", "炊", "龡"],
  "dōu rú": ["吺"],
  hǒu: ["吼", "犼"],
  "hōng hǒu ōu": ["吽"],
  "wú yù": ["吾"],
  "ya yā": ["呀"],
  "è e": ["呃"],
  dāi: ["呆", "懛", "獃"],
  "mèn qǐ": ["呇"],
  hōng: [
    "呍",
    "嚝",
    "揈",
    "灴",
    "烘",
    "焢",
    "硡",
    "薨",
    "訇",
    "谾",
    "軣",
    "輷",
    "轟",
    "轰",
    "鍧"
  ],
  nà: [
    "呐",
    "捺",
    "笝",
    "納",
    "纳",
    "肭",
    "蒳",
    "衲",
    "豽",
    "貀",
    "軜",
    "郍",
    "鈉",
    "钠",
    "靹",
    "魶"
  ],
  "tūn tiān": ["呑"],
  "fǔ ḿ": ["呒", "嘸"],
  "dāi tǎi": ["呔"],
  "ǒu ōu òu": ["呕"],
  "bài bei": ["呗"],
  "yuán yún yùn": ["员", "員"],
  guō: [
    "呙",
    "啯",
    "嘓",
    "埚",
    "堝",
    "墎",
    "崞",
    "彉",
    "彍",
    "懖",
    "猓",
    "瘑",
    "聒",
    "蝈",
    "蟈",
    "郭",
    "鈛",
    "鍋",
    "锅"
  ],
  "huá qì": ["呚"],
  "qiàng qiāng": ["呛", "跄"],
  shī: [
    "呞",
    "失",
    "尸",
    "屍",
    "师",
    "師",
    "施",
    "浉",
    "湤",
    "湿",
    "溮",
    "溼",
    "濕",
    "狮",
    "獅",
    "瑡",
    "絁",
    "葹",
    "蒒",
    "蓍",
    "虱",
    "蝨",
    "褷",
    "襹",
    "詩",
    "诗",
    "邿",
    "釃",
    "鉇",
    "鍦",
    "鯴",
    "鰤",
    "鲺",
    "鳲",
    "鳾",
    "鶳",
    "鸤",
    "䴓",
    "𫚕"
  ],
  juǎn: ["呟", "埍", "臇", "菤", "錈", "锩"],
  pěn: ["呠", "翸"],
  "wěn mǐn": ["呡"],
  "ne ní": ["呢"],
  "ḿ m̀ móu": ["呣"],
  rán: [
    "呥",
    "嘫",
    "然",
    "燃",
    "繎",
    "肰",
    "蚦",
    "蚺",
    "衻",
    "袇",
    "袡",
    "髥",
    "髯"
  ],
  "tiè chè": ["呫"],
  "qì zhī": ["呮"],
  "zǐ cī": ["呰"],
  "guā gū guǎ": ["呱"],
  "cī zī": ["呲"],
  "hǒu xǔ gòu": ["呴"],
  "hē ā á ǎ à a": ["呵"],
  náo: [
    "呶",
    "夒",
    "峱",
    "嶩",
    "巎",
    "挠",
    "撓",
    "猱",
    "硇",
    "蛲",
    "蟯",
    "詉",
    "譊",
    "鐃",
    "铙"
  ],
  "xiā gā": ["呷"],
  pēi: ["呸", "怌", "肧", "胚", "衃", "醅"],
  "háo xiāo": ["呺"],
  mìng: ["命", "掵"],
  "dá dàn": ["呾"],
  "zuǐ jǔ": ["咀"],
  "xián gān": ["咁"],
  pǒu: ["咅", "哣", "犃"],
  "yǎng yāng": ["咉"],
  "zǎ zé zhā": ["咋"],
  "hé hè huó huò hú": ["和"],
  hāi: ["咍"],
  dā: ["咑", "哒", "噠", "墶", "搭", "撘", "耷", "褡", "鎝", "𨱏"],
  "kǎ kā": ["咔"],
  gū: [
    "咕",
    "唂",
    "唃",
    "姑",
    "嫴",
    "孤",
    "巬",
    "巭",
    "柧",
    "橭",
    "沽",
    "泒",
    "稒",
    "笟",
    "箍",
    "箛",
    "篐",
    "罛",
    "苽",
    "菇",
    "菰",
    "蓇",
    "觚",
    "軱",
    "軲",
    "轱",
    "辜",
    "酤",
    "鈲",
    "鮕",
    "鴣",
    "鸪"
  ],
  "kā gā": ["咖"],
  zuo: ["咗"],
  lóng: [
    "咙",
    "嚨",
    "嶐",
    "巃",
    "巄",
    "昽",
    "曨",
    "朧",
    "栊",
    "槞",
    "櫳",
    "湰",
    "滝",
    "漋",
    "爖",
    "珑",
    "瓏",
    "癃",
    "眬",
    "矓",
    "砻",
    "礱",
    "礲",
    "窿",
    "竜",
    "聋",
    "聾",
    "胧",
    "茏",
    "蘢",
    "蠪",
    "蠬",
    "襱",
    "豅",
    "鏧",
    "鑨",
    "霳",
    "靇",
    "驡",
    "鸗",
    "龍",
    "龒",
    "龙"
  ],
  "xiàn xián": ["咞"],
  qì: [
    "咠",
    "唭",
    "噐",
    "器",
    "夡",
    "弃",
    "憇",
    "憩",
    "暣",
    "棄",
    "欫",
    "气",
    "気",
    "氣",
    "汔",
    "汽",
    "泣",
    "湆",
    "湇",
    "炁",
    "甈",
    "盵",
    "矵",
    "碛",
    "碶",
    "磜",
    "磧",
    "罊",
    "芞",
    "葺",
    "藒",
    "蟿",
    "訖",
    "讫",
    "迄",
    "鐑"
  ],
  "xì dié": ["咥"],
  "liē liě lié lie": ["咧"],
  zī: [
    "咨",
    "嗞",
    "姕",
    "姿",
    "孜",
    "孳",
    "孶",
    "崰",
    "嵫",
    "栥",
    "椔",
    "淄",
    "湽",
    "滋",
    "澬",
    "玆",
    "禌",
    "秶",
    "粢",
    "紎",
    "緇",
    "緕",
    "纃",
    "缁",
    "茊",
    "茲",
    "葘",
    "諮",
    "谘",
    "貲",
    "資",
    "赀",
    "资",
    "赼",
    "趑",
    "趦",
    "輜",
    "輺",
    "辎",
    "鄑",
    "鈭",
    "錙",
    "鍿",
    "鎡",
    "锱",
    "镃",
    "頾",
    "頿",
    "髭",
    "鯔",
    "鰦",
    "鲻",
    "鶅",
    "鼒",
    "齍",
    "齜",
    "龇"
  ],
  mī: ["咪"],
  "jī xī qià": ["咭"],
  "gē luò kǎ lo": ["咯"],
  "shù xún": ["咰"],
  "zán zá zǎ zan": ["咱"],
  "hāi ké": ["咳"],
  huī: [
    "咴",
    "噅",
    "噕",
    "婎",
    "媈",
    "幑",
    "徽",
    "恢",
    "拻",
    "挥",
    "揮",
    "晖",
    "暉",
    "楎",
    "洃",
    "瀈",
    "灰",
    "灳",
    "烣",
    "睳",
    "禈",
    "翚",
    "翬",
    "蘳",
    "袆",
    "褘",
    "詼",
    "诙",
    "豗",
    "輝",
    "辉",
    "鰴",
    "麾",
    "㧑"
  ],
  "huài shì": ["咶"],
  táo: [
    "咷",
    "啕",
    "桃",
    "檮",
    "洮",
    "淘",
    "祹",
    "綯",
    "绹",
    "萄",
    "蜪",
    "裪",
    "迯",
    "逃",
    "醄",
    "鋾",
    "鞀",
    "鞉",
    "饀",
    "駣",
    "騊",
    "鼗",
    "𫘦"
  ],
  xián: [
    "咸",
    "啣",
    "娴",
    "娹",
    "婱",
    "嫌",
    "嫺",
    "嫻",
    "弦",
    "挦",
    "撏",
    "涎",
    "湺",
    "澖",
    "甉",
    "痫",
    "癇",
    "癎",
    "絃",
    "胘",
    "舷",
    "藖",
    "蚿",
    "蛝",
    "衔",
    "衘",
    "誸",
    "諴",
    "賢",
    "贒",
    "贤",
    "輱",
    "醎",
    "銜",
    "鑦",
    "閑",
    "闲",
    "鷳",
    "鷴",
    "鷼",
    "鹇",
    "鹹",
    "麙",
    "𫍯"
  ],
  "è àn": ["咹"],
  "xuān xuǎn": ["咺", "烜"],
  "wāi hé wǒ guǎ guō": ["咼"],
  "yàn yè yān": ["咽"],
  āi: ["哀", "哎", "埃", "溾", "銰", "鎄", "锿"],
  pǐn: ["品", "榀"],
  shěn: [
    "哂",
    "婶",
    "嬸",
    "审",
    "宷",
    "審",
    "弞",
    "曋",
    "渖",
    "瀋",
    "瞫",
    "矤",
    "矧",
    "覾",
    "訠",
    "諗",
    "讅",
    "谂",
    "谉",
    "邥",
    "頣",
    "魫"
  ],
  "hǒng hōng hòng": ["哄"],
  "wā wa": ["哇"],
  "hā hǎ hà": ["哈"],
  zāi: ["哉", "栽", "渽", "溨", "災", "灾", "烖", "睵", "賳"],
  "dì diè": ["哋"],
  pài: ["哌", "沠", "派", "渒", "湃", "蒎", "鎃"],
  "gén hěn": ["哏"],
  "yǎ yā": ["哑", "雅"],
  "yuě huì": ["哕", "噦"],
  nián: ["哖", "年", "秊", "秥", "鮎", "鯰", "鲇", "鲶", "鵇", "黏"],
  "huá huā": ["哗", "嘩"],
  "jì jiē zhāi": ["哜", "嚌"],
  mōu: ["哞"],
  "yō yo": ["哟", "喲"],
  lòng: ["哢", "梇", "贚"],
  "ò ó é": ["哦"],
  "lī lǐ li": ["哩"],
  "nǎ na nǎi né něi": ["哪"],
  hè: [
    "哬",
    "垎",
    "壑",
    "寉",
    "惒",
    "焃",
    "煂",
    "燺",
    "爀",
    "癋",
    "碋",
    "翯",
    "褐",
    "謞",
    "賀",
    "贺",
    "赫",
    "靍",
    "靎",
    "靏",
    "鶴",
    "鸖",
    "鹤"
  ],
  "bō pò bā": ["哱"],
  zhé: [
    "哲",
    "啠",
    "喆",
    "嚞",
    "埑",
    "悊",
    "摺",
    "晢",
    "晣",
    "歽",
    "矺",
    "砓",
    "磔",
    "籷",
    "粍",
    "虴",
    "蛰",
    "蟄",
    "袩",
    "詟",
    "謫",
    "謺",
    "讁",
    "讋",
    "谪",
    "輒",
    "輙",
    "轍",
    "辄",
    "辙",
    "鮿"
  ],
  "liàng láng": ["哴"],
  "liè lǜ": ["哷"],
  hān: ["哻", "憨", "蚶", "谽", "酣", "頇", "顸", "馠", "魽", "鼾"],
  "hēng hng": ["哼"],
  gěng: [
    "哽",
    "埂",
    "峺",
    "挭",
    "梗",
    "綆",
    "绠",
    "耿",
    "莄",
    "郠",
    "骾",
    "鯁",
    "鲠",
    "𬒔"
  ],
  "chuò yuè": ["哾"],
  "gě jiā": ["哿"],
  "bei bài": ["唄"],
  "hán hàn": ["唅"],
  chún: [
    "唇",
    "浱",
    "湻",
    "滣",
    "漘",
    "犉",
    "純",
    "纯",
    "脣",
    "莼",
    "蒓",
    "蓴",
    "醇",
    "醕",
    "錞",
    "陙",
    "鯙",
    "鶉",
    "鹑",
    "𬭚"
  ],
  "ài āi": ["唉"],
  "jiá qiǎn": ["唊"],
  "yán dàn xián": ["唌"],
  chē: ["唓", "砗", "硨", "莗", "蛼"],
  "wú ńg ń": ["唔"],
  zào: [
    "唕",
    "唣",
    "噪",
    "慥",
    "梍",
    "灶",
    "煰",
    "燥",
    "皁",
    "皂",
    "竃",
    "竈",
    "簉",
    "艁",
    "譟",
    "趮",
    "躁",
    "造",
    "𥖨"
  ],
  dí: [
    "唙",
    "啇",
    "嘀",
    "嚁",
    "嫡",
    "廸",
    "敌",
    "敵",
    "梑",
    "涤",
    "滌",
    "狄",
    "笛",
    "籴",
    "糴",
    "苖",
    "荻",
    "蔋",
    "蔐",
    "藡",
    "覿",
    "觌",
    "豴",
    "迪",
    "靮",
    "頔",
    "馰",
    "髢",
    "鸐",
    "𬱖"
  ],
  "gòng hǒng gǒng": ["唝", "嗊"],
  dóu: ["唞"],
  "lào láo": ["唠", "嘮", "憦"],
  huàn: [
    "唤",
    "喚",
    "奂",
    "奐",
    "宦",
    "嵈",
    "幻",
    "患",
    "愌",
    "换",
    "換",
    "擐",
    "攌",
    "梙",
    "槵",
    "浣",
    "涣",
    "渙",
    "漶",
    "澣",
    "烉",
    "焕",
    "煥",
    "瑍",
    "痪",
    "瘓",
    "睆",
    "肒",
    "藧",
    "豢",
    "轘",
    "逭",
    "鯇",
    "鯶",
    "鰀",
    "鲩"
  ],
  léng: ["唥", "塄", "楞", "碐", "薐"],
  "wō wěi": ["唩"],
  fěng: ["唪", "覂", "諷", "讽"],
  "yín jìn": ["唫"],
  "hǔ xià": ["唬"],
  wéi: [
    "唯",
    "围",
    "圍",
    "壝",
    "峗",
    "峞",
    "嵬",
    "帏",
    "帷",
    "幃",
    "惟",
    "桅",
    "沩",
    "洈",
    "涠",
    "湋",
    "溈",
    "潍",
    "潙",
    "潿",
    "濰",
    "犩",
    "矀",
    "維",
    "维",
    "蓶",
    "覹",
    "违",
    "違",
    "鄬",
    "醀",
    "鍏",
    "闈",
    "闱",
    "韋",
    "韦",
    "鮠",
    "𣲗",
    "𬶏"
  ],
  shuā: ["唰"],
  chàng: ["唱", "怅", "悵", "暢", "焻", "畅", "畼", "誯", "韔", "鬯"],
  "ér wā": ["唲"],
  qiàng: ["唴", "炝", "熗", "羻"],
  yō: ["唷"],
  yū: ["唹", "淤", "瘀", "盓", "箊", "紆", "纡", "込", "迂", "迃", "陓"],
  lài: [
    "唻",
    "濑",
    "瀨",
    "瀬",
    "癞",
    "癩",
    "睐",
    "睞",
    "籁",
    "籟",
    "藾",
    "賚",
    "賴",
    "赉",
    "赖",
    "頼",
    "顂",
    "鵣"
  ],
  tuò: ["唾", "嶞", "柝", "毤", "毻", "箨", "籜", "萚", "蘀", "跅"],
  "zhōu zhāo tiào": ["啁"],
  kěn: ["啃", "垦", "墾", "恳", "懇", "肎", "肯", "肻", "豤", "錹"],
  "zhuó zhào": ["啅", "濯"],
  "hēng hèng": ["啈", "悙"],
  "lín lán": ["啉"],
  "a ā á ǎ à": ["啊"],
  qiāng: [
    "啌",
    "嗴",
    "嶈",
    "戕",
    "摤",
    "斨",
    "枪",
    "槍",
    "溬",
    "牄",
    "猐",
    "獇",
    "羌",
    "羗",
    "腔",
    "蜣",
    "謒",
    "鏘",
    "锖",
    "锵"
  ],
  "tūn zhūn xiāng duǐ": ["啍"],
  wèn: ["問", "妏", "揾", "搵", "璺", "问", "顐"],
  "cuì qi": ["啐"],
  "dié shà jié tì": ["啑"],
  "yuē wā": ["啘"],
  "zǐ cǐ": ["啙"],
  "bǐ tú": ["啚"],
  "chuò chuài": ["啜"],
  "yǎ yā è": ["啞"],
  fēi: [
    "啡",
    "婓",
    "婔",
    "扉",
    "暃",
    "渄",
    "猆",
    "緋",
    "绯",
    "裶",
    "霏",
    "非",
    "靟",
    "飛",
    "飝",
    "飞",
    "餥",
    "馡",
    "騑",
    "騛",
    "鯡",
    "鲱",
    "𬴂"
  ],
  pí: [
    "啤",
    "壀",
    "枇",
    "毗",
    "毘",
    "焷",
    "琵",
    "疲",
    "皮",
    "篺",
    "罴",
    "羆",
    "脾",
    "腗",
    "膍",
    "蚍",
    "蚽",
    "蜱",
    "螷",
    "蠯",
    "豼",
    "貔",
    "郫",
    "鈹",
    "阰",
    "陴",
    "隦",
    "魮",
    "鮍",
    "鲏",
    "鵧",
    "鼙"
  ],
  shá: ["啥"],
  "lā la": ["啦"],
  "yīng qíng": ["啨"],
  pā: ["啪", "妑", "舥", "葩", "趴"],
  "zhě shì": ["啫"],
  sè: [
    "啬",
    "嗇",
    "懎",
    "擌",
    "栜",
    "歮",
    "涩",
    "渋",
    "澀",
    "澁",
    "濇",
    "濏",
    "瀒",
    "瑟",
    "璱",
    "瘷",
    "穑",
    "穡",
    "穯",
    "繬",
    "譅",
    "轖",
    "銫",
    "鏼",
    "铯",
    "飋"
  ],
  niè: [
    "啮",
    "嗫",
    "噛",
    "嚙",
    "囁",
    "囓",
    "圼",
    "孼",
    "孽",
    "嵲",
    "嶭",
    "巕",
    "帇",
    "敜",
    "枿",
    "槷",
    "櫱",
    "涅",
    "湼",
    "痆",
    "篞",
    "籋",
    "糱",
    "糵",
    "聂",
    "聶",
    "臬",
    "臲",
    "蘖",
    "蠥",
    "讘",
    "踂",
    "踗",
    "踙",
    "蹑",
    "躡",
    "錜",
    "鎳",
    "鑈",
    "鑷",
    "钀",
    "镊",
    "镍",
    "闑",
    "陧",
    "隉",
    "顳",
    "颞",
    "齧",
    "𫔶"
  ],
  "luō luó luo": ["啰", "囉"],
  "tān chǎn tuō": ["啴"],
  bo: ["啵", "蔔"],
  dìng: [
    "啶",
    "定",
    "椗",
    "矴",
    "碇",
    "碠",
    "磸",
    "聢",
    "腚",
    "萣",
    "蝊",
    "訂",
    "订",
    "錠",
    "锭",
    "顁",
    "飣",
    "饤"
  ],
  lāng: ["啷"],
  "án ān": ["啽"],
  kā: ["喀", "擖"],
  "yóng yú": ["喁"],
  "lā lá lǎ": ["喇"],
  jiē: [
    "喈",
    "喼",
    "嗟",
    "堦",
    "媘",
    "接",
    "掲",
    "擑",
    "湝",
    "煯",
    "疖",
    "痎",
    "癤",
    "皆",
    "秸",
    "稭",
    "脻",
    "蝔",
    "街",
    "謯",
    "阶",
    "階",
    "鞂",
    "鶛"
  ],
  hóu: [
    "喉",
    "帿",
    "猴",
    "瘊",
    "睺",
    "篌",
    "糇",
    "翭",
    "葔",
    "鄇",
    "鍭",
    "餱",
    "骺",
    "鯸",
    "𬭤"
  ],
  "dié zhá": ["喋"],
  wāi: ["喎", "歪", "竵"],
  "nuò rě": ["喏"],
  "xù huò guó": ["喐"],
  zán: ["喒"],
  "wō ō": ["喔"],
  hú: [
    "喖",
    "嘝",
    "囫",
    "壶",
    "壷",
    "壺",
    "媩",
    "弧",
    "搰",
    "斛",
    "楜",
    "槲",
    "湖",
    "瀫",
    "焀",
    "煳",
    "狐",
    "猢",
    "瑚",
    "瓳",
    "箶",
    "絗",
    "縠",
    "胡",
    "葫",
    "蔛",
    "蝴",
    "螜",
    "衚",
    "觳",
    "醐",
    "鍸",
    "頶",
    "餬",
    "鬍",
    "魱",
    "鰗",
    "鵠",
    "鶘",
    "鶦",
    "鹕"
  ],
  "huàn yuán xuǎn hé": ["喛"],
  xǐ: [
    "喜",
    "囍",
    "壐",
    "屣",
    "徙",
    "憙",
    "枲",
    "橲",
    "歖",
    "漇",
    "玺",
    "璽",
    "矖",
    "禧",
    "縰",
    "葈",
    "葸",
    "蓰",
    "蟢",
    "謑",
    "蹝",
    "躧",
    "鈢",
    "鉨",
    "鉩",
    "鱚",
    "𬭳",
    "𬶮"
  ],
  "hē hè yè": ["喝"],
  kuì: [
    "喟",
    "嘳",
    "媿",
    "嬇",
    "愦",
    "愧",
    "憒",
    "篑",
    "簣",
    "籄",
    "聩",
    "聭",
    "聵",
    "膭",
    "蕢",
    "謉",
    "餽",
    "饋",
    "馈"
  ],
  "zhǒng chuáng": ["喠"],
  "wéi wèi": ["喡", "為", "爲"],
  "duó zhà": ["喥"],
  "sāng sàng": ["喪"],
  "qiáo jiāo": ["喬"],
  "pèn bēn": ["喯"],
  "cān sūn qī": ["喰"],
  "zhā chā": ["喳"],
  miāo: ["喵"],
  "pēn pèn": ["喷"],
  kuí: [
    "喹",
    "夔",
    "奎",
    "巙",
    "戣",
    "揆",
    "晆",
    "暌",
    "楏",
    "楑",
    "櫆",
    "犪",
    "睽",
    "葵",
    "藈",
    "蘷",
    "虁",
    "蝰",
    "躨",
    "逵",
    "鄈",
    "鍨",
    "鍷",
    "頯",
    "馗",
    "騤",
    "骙",
    "魁"
  ],
  "lou lóu": ["喽"],
  "zào qiāo": ["喿"],
  "hè xiāo xiào hù": ["嗃"],
  "á shà": ["嗄"],
  xiù: [
    "嗅",
    "岫",
    "峀",
    "溴",
    "珛",
    "琇",
    "璓",
    "秀",
    "綉",
    "繍",
    "繡",
    "绣",
    "螑",
    "袖",
    "褎",
    "褏",
    "銹",
    "鏥",
    "鏽",
    "锈",
    "齅"
  ],
  "qiāng qiàng": ["嗆", "戗", "戧", "蹌", "蹡"],
  "ài yì": ["嗌", "艾"],
  "má mǎ ma": ["嗎"],
  "kè kē": ["嗑"],
  "dā tà": ["嗒", "鎉"],
  sǎng: ["嗓", "搡", "磉", "褬", "鎟", "顙", "颡"],
  chēn: ["嗔", "抻", "琛", "瞋", "諃", "謓", "賝", "郴", "𬘭"],
  "wā gǔ": ["嗗"],
  "pǎng bēng": ["嗙"],
  "xián qiǎn qiān": ["嗛"],
  lào: ["嗠", "嫪", "橯", "涝", "澇", "耢", "耮", "躼", "軂", "酪"],
  wēng: ["嗡", "翁", "聬", "螉", "鎓", "鶲", "鹟", "𬭩"],
  wà: ["嗢", "腽", "膃", "袜", "襪", "韤"],
  "hēi hāi": ["嗨"],
  hē: ["嗬", "欱", "蠚", "訶", "诃"],
  zi: ["嗭"],
  sǎi: ["嗮"],
  "ǹg ńg ňg": ["嗯"],
  gě: ["嗰", "舸"],
  ná: ["嗱", "拏", "拿", "鎿", "镎"],
  diǎ: ["嗲"],
  "ài ǎi āi": ["嗳"],
  tōng: ["嗵", "樋", "炵", "蓪"],
  "zuī suī": ["嗺"],
  "zhē zhè zhù zhe": ["嗻"],
  mò: [
    "嗼",
    "圽",
    "塻",
    "墨",
    "妺",
    "嫼",
    "寞",
    "帞",
    "昩",
    "末",
    "枺",
    "歿",
    "殁",
    "沫",
    "漠",
    "爅",
    "獏",
    "瘼",
    "皌",
    "眽",
    "眿",
    "瞐",
    "瞙",
    "砞",
    "礳",
    "秣",
    "絈",
    "纆",
    "耱",
    "茉",
    "莈",
    "蓦",
    "蛨",
    "蟔",
    "貃",
    "貊",
    "貘",
    "銆",
    "鏌",
    "镆",
    "陌",
    "靺",
    "驀",
    "魩",
    "默",
    "黙",
    "𬙊"
  ],
  sòu: ["嗽", "瘶"],
  tǎn: [
    "嗿",
    "坦",
    "忐",
    "憳",
    "憻",
    "暺",
    "毯",
    "璮",
    "菼",
    "袒",
    "襢",
    "醓",
    "鉭",
    "钽"
  ],
  "jiào dǎo": ["嘄"],
  "kǎi gě": ["嘅"],
  "shān càn": ["嘇"],
  cáo: ["嘈", "嶆", "曹", "曺", "槽", "漕", "艚", "蓸", "螬", "褿", "鏪", "𥕢"],
  piào: ["嘌", "徱", "蔈", "驃"],
  "lóu lou": ["嘍"],
  gǎ: ["尕", "玍"],
  "gǔ jiǎ": ["嘏"],
  "jiāo xiāo": ["嘐"],
  "xū shī": ["嘘", "噓"],
  pó: ["嘙", "嚩", "婆", "櫇", "皤", "鄱"],
  "dē dēi": ["嘚"],
  "ma má": ["嘛"],
  "lē lei": ["嘞"],
  "gā gá gǎ": ["嘠"],
  sāi: ["嘥", "噻", "毢", "腮", "顋", "鰓"],
  "zuō chuài": ["嘬"],
  "cháo zhāo": ["嘲", "朝", "鼂"],
  zuǐ: ["嘴", "噿", "嶊", "璻"],
  "qiáo qiào": ["嘺", "翹", "谯"],
  "chù xù shòu": ["嘼"],
  "tān chǎn": ["嘽"],
  "dàn tán": ["嘾", "弾", "彈", "惔", "澹"],
  "hēi mò": ["嘿"],
  ě: ["噁", "砨", "頋", "騀", "鵈"],
  "fān bo": ["噃"],
  chuáng: ["噇", "床", "牀"],
  "cù zā hé": ["噈"],
  "tūn kuò": ["噋"],
  "cēng chēng": ["噌"],
  dēng: ["噔", "嬁", "灯", "燈", "璒", "登", "竳", "簦", "艠", "豋"],
  pū: ["噗", "扑", "撲", "攴", "攵", "潽", "炇", "陠"],
  juē: ["噘", "屩", "屫", "撧"],
  lū: ["噜", "嚕", "撸", "擼", "謢"],
  zhān: [
    "噡",
    "岾",
    "惉",
    "旃",
    "旜",
    "枬",
    "栴",
    "毡",
    "氈",
    "氊",
    "沾",
    "瞻",
    "薝",
    "蛅",
    "詀",
    "詹",
    "譫",
    "谵",
    "趈",
    "邅",
    "閚",
    "霑",
    "飦",
    "饘",
    "驙",
    "魙",
    "鱣",
    "鸇",
    "鹯",
    "𫗴"
  ],
  ō: ["噢"],
  "zhòu zhuó": ["噣"],
  "jiào qiào chī": ["噭"],
  yuàn: [
    "噮",
    "妴",
    "怨",
    "愿",
    "掾",
    "瑗",
    "禐",
    "苑",
    "衏",
    "裫",
    "褑",
    "院",
    "願"
  ],
  "ǎi ài āi": ["噯"],
  "yōng yǒng": ["噰", "澭"],
  "jué xué": ["噱"],
  "pēn pèn fèn": ["噴"],
  gá: ["噶", "尜", "釓", "錷", "钆"],
  "xīn hěn hèn": ["噷"],
  dāng: ["噹", "澢", "珰", "璫", "筜", "簹", "艡", "蟷", "裆", "襠"],
  làn: ["嚂", "滥", "濫", "烂", "燗", "爁", "爛", "爤", "瓓", "糷", "钄"],
  tà: [
    "嚃",
    "嚺",
    "崉",
    "挞",
    "搨",
    "撻",
    "榻",
    "橽",
    "毾",
    "涾",
    "澾",
    "濌",
    "禢",
    "粏",
    "誻",
    "譶",
    "蹋",
    "蹹",
    "躂",
    "躢",
    "遝",
    "錔",
    "闒",
    "闥",
    "闼",
    "阘",
    "鞜",
    "鞳"
  ],
  "huō huò ǒ": ["嚄"],
  hāo: ["嚆", "茠", "蒿", "薅"],
  "hè xià": ["嚇"],
  "xiù pì": ["嚊"],
  "zhōu chóu": ["嚋", "盩", "诪"],
  mē: ["嚒"],
  "chā cā": ["嚓"],
  "bó pào bào": ["嚗"],
  "me mèi mò": ["嚜"],
  "xié hái": ["嚡"],
  "áo xiāo": ["嚣"],
  mō: ["嚤", "摸"],
  pín: [
    "嚬",
    "娦",
    "嫔",
    "嬪",
    "玭",
    "矉",
    "薲",
    "蠙",
    "貧",
    "贫",
    "顰",
    "颦",
    "𬞟"
  ],
  mè: ["嚰", "濹"],
  "rǎng rāng": ["嚷"],
  lá: ["嚹", "旯"],
  "jiáo jué jiào": ["嚼"],
  chuò: [
    "嚽",
    "娖",
    "擉",
    "歠",
    "涰",
    "磭",
    "踀",
    "輟",
    "辍",
    "辵",
    "辶",
    "酫",
    "鑡",
    "餟",
    "齪",
    "龊"
  ],
  "huān huàn": ["嚾"],
  "zá cà": ["囃"],
  chài: ["囆", "虿", "蠆", "袃", "訍"],
  "náng nāng": ["囊"],
  "zá zàn cān": ["囋"],
  sū: ["囌", "櫯", "甦", "稣", "穌", "窣", "蘇", "蘓", "酥", "鯂"],
  zèng: ["囎", "熷", "甑", "贈", "赠", "鋥", "锃"],
  "zá niè yàn": ["囐"],
  nāng: ["囔"],
  "luó luō luo": ["囖"],
  "wéi guó": ["囗"],
  huí: [
    "囘",
    "回",
    "囬",
    "廻",
    "廽",
    "恛",
    "洄",
    "痐",
    "茴",
    "蚘",
    "蛔",
    "蛕",
    "蜖",
    "迴",
    "逥",
    "鮰"
  ],
  nín: ["囜", "您", "脌"],
  "jiǎn nān": ["囝"],
  nān: ["囡"],
  tuán: ["团", "団", "團", "慱", "抟", "摶", "檲", "糰", "鏄", "鷒", "鷻"],
  "tún dùn": ["囤", "坉"],
  guó: [
    "囯",
    "囶",
    "囻",
    "国",
    "圀",
    "國",
    "帼",
    "幗",
    "慖",
    "摑",
    "漍",
    "聝",
    "腘",
    "膕",
    "蔮",
    "虢",
    "馘",
    "𬇹"
  ],
  kùn: ["困", "涃", "睏"],
  "wéi tōng": ["囲"],
  qūn: ["囷", "夋", "逡"],
  rì: ["囸", "日", "衵", "鈤", "馹", "驲"],
  tāi: ["囼", "孡", "胎"],
  pǔ: [
    "圃",
    "圑",
    "擈",
    "普",
    "暜",
    "樸",
    "檏",
    "氆",
    "浦",
    "溥",
    "烳",
    "諩",
    "譜",
    "谱",
    "蹼",
    "鐠",
    "镨"
  ],
  "quān juàn juān": ["圈", "圏"],
  "chuí chuán": ["圌"],
  tuǎn: ["圕", "畽", "疃"],
  lüè: ["圙", "掠", "略", "畧", "稤", "鋝", "鋢", "锊", "䂮"],
  "huán yuán": ["圜"],
  luán: [
    "圝",
    "圞",
    "奱",
    "娈",
    "孌",
    "孪",
    "孿",
    "峦",
    "巒",
    "挛",
    "攣",
    "曫",
    "栾",
    "欒",
    "滦",
    "灤",
    "癴",
    "癵",
    "羉",
    "脔",
    "臠",
    "虊",
    "銮",
    "鑾",
    "鵉",
    "鸞",
    "鸾"
  ],
  tǔ: ["土", "圡", "釷", "钍"],
  "xū wéi": ["圩"],
  "dì de": ["地", "嶳"],
  "qiān sú": ["圱"],
  zhèn: [
    "圳",
    "塦",
    "挋",
    "振",
    "朕",
    "栚",
    "甽",
    "眹",
    "紖",
    "絼",
    "纼",
    "誫",
    "賑",
    "赈",
    "鋴",
    "鎭",
    "鎮",
    "镇",
    "阵",
    "陣",
    "震",
    "鴆",
    "鸩"
  ],
  "chǎng cháng": ["场", "場", "塲"],
  "qí yín": ["圻"],
  jiá: [
    "圿",
    "忦",
    "恝",
    "戞",
    "扴",
    "脥",
    "荚",
    "莢",
    "蛱",
    "蛺",
    "裌",
    "跲",
    "郏",
    "郟",
    "鋏",
    "铗",
    "頬",
    "頰",
    "颊",
    "鴶",
    "鵊"
  ],
  "zhǐ zhì": ["坁"],
  bǎn: [
    "坂",
    "岅",
    "昄",
    "板",
    "版",
    "瓪",
    "粄",
    "舨",
    "蝂",
    "鈑",
    "钣",
    "阪",
    "魬"
  ],
  qǐn: ["坅", "寑", "寝", "寢", "昑", "梫", "笉", "螼", "赾", "鋟", "锓"],
  "méi fén": ["坆"],
  "rǒng kēng": ["坈"],
  "fāng fáng": ["坊"],
  "fèn bèn": ["坋"],
  tān: ["坍", "怹", "摊", "擹", "攤", "滩", "灘", "瘫", "癱", "舑", "貪", "贪"],
  "huài pēi pī péi": ["坏"],
  "dì làn": ["坔"],
  tán: [
    "坛",
    "墰",
    "墵",
    "壇",
    "壜",
    "婒",
    "憛",
    "昙",
    "曇",
    "榃",
    "檀",
    "潭",
    "燂",
    "痰",
    "磹",
    "罈",
    "罎",
    "藫",
    "談",
    "譚",
    "譠",
    "谈",
    "谭",
    "貚",
    "郯",
    "醰",
    "錟",
    "顃"
  ],
  bà: ["坝", "垻", "壩", "弝", "欛", "灞", "爸", "矲", "覇", "霸", "鮁", "鲅"],
  fén: [
    "坟",
    "墳",
    "妢",
    "岎",
    "幩",
    "枌",
    "棼",
    "汾",
    "焚",
    "燌",
    "燓",
    "羒",
    "羵",
    "蒶",
    "蕡",
    "蚠",
    "蚡",
    "豮",
    "豶",
    "轒",
    "鐼",
    "隫",
    "馩",
    "魵",
    "黂",
    "鼖",
    "鼢",
    "𣸣"
  ],
  zhuì: [
    "坠",
    "墜",
    "惴",
    "甀",
    "畷",
    "礈",
    "綴",
    "縋",
    "缀",
    "缒",
    "腏",
    "膇",
    "諈",
    "贅",
    "赘",
    "醊",
    "錣",
    "鑆"
  ],
  pō: ["坡", "岥", "泼", "溌", "潑", "釙", "鏺", "钋", "頗", "颇", "䥽"],
  "pǎn bàn": ["坢"],
  kūn: [
    "坤",
    "堃",
    "堒",
    "崐",
    "崑",
    "昆",
    "晜",
    "潉",
    "焜",
    "熴",
    "猑",
    "琨",
    "瑻",
    "菎",
    "蜫",
    "裈",
    "裩",
    "褌",
    "醌",
    "錕",
    "锟",
    "騉",
    "髠",
    "髡",
    "髨",
    "鯤",
    "鲲",
    "鵾",
    "鶤",
    "鹍"
  ],
  diàn: [
    "坫",
    "垫",
    "墊",
    "壂",
    "奠",
    "婝",
    "店",
    "惦",
    "扂",
    "橂",
    "殿",
    "淀",
    "澱",
    "玷",
    "琔",
    "电",
    "癜",
    "簟",
    "蜔",
    "鈿",
    "電",
    "靛",
    "驔"
  ],
  "mù mǔ": ["坶"],
  "kē kě": ["坷", "軻"],
  xuè: ["坹", "岤", "桖", "瀥", "狘", "瞲", "謔", "谑", "趐"],
  "dǐ chí": ["坻", "柢"],
  lā: ["垃", "柆", "菈", "邋"],
  lǒng: ["垄", "垅", "壟", "壠", "拢", "攏", "竉", "陇", "隴", "𬕂"],
  mín: [
    "垊",
    "姄",
    "岷",
    "崏",
    "捪",
    "旻",
    "旼",
    "民",
    "珉",
    "琘",
    "琝",
    "瑉",
    "痻",
    "盿",
    "砇",
    "緍",
    "緡",
    "缗",
    "罠",
    "苠",
    "鈱",
    "錉",
    "鍲",
    "鴖"
  ],
  "dòng tóng": ["垌", "峒", "洞"],
  cí: [
    "垐",
    "嬨",
    "慈",
    "柌",
    "濨",
    "珁",
    "瓷",
    "甆",
    "磁",
    "礠",
    "祠",
    "糍",
    "茨",
    "詞",
    "词",
    "辝",
    "辞",
    "辤",
    "辭",
    "雌",
    "飺",
    "餈",
    "鴜",
    "鶿",
    "鷀",
    "鹚"
  ],
  duī: ["垖", "堆", "塠", "痽", "磓", "鐓", "鐜", "鴭"],
  "duò duǒ": ["垛"],
  "duǒ duò": ["垜", "挆"],
  chá: ["垞", "察", "嵖", "搽", "槎", "檫", "猹", "茬", "茶", "詧", "靫", "𥻗"],
  shǎng: ["垧", "晌", "樉", "賞", "贘", "赏", "鋿", "鏛", "鑜"],
  shǒu: ["垨", "守", "手", "扌", "艏", "首"],
  da: ["垯", "繨", "跶"],
  háng: [
    "垳",
    "斻",
    "杭",
    "筕",
    "絎",
    "绗",
    "航",
    "苀",
    "蚢",
    "裄",
    "貥",
    "迒",
    "頏",
    "颃",
    "魧"
  ],
  "ān ǎn": ["垵"],
  xīng: [
    "垶",
    "惺",
    "星",
    "曐",
    "煋",
    "猩",
    "瑆",
    "皨",
    "篂",
    "腥",
    "興",
    "觪",
    "觲",
    "謃",
    "騂",
    "骍",
    "鮏",
    "鯹"
  ],
  "yuàn huán": ["垸"],
  bāng: [
    "垹",
    "帮",
    "幇",
    "幚",
    "幫",
    "捠",
    "梆",
    "浜",
    "邦",
    "邫",
    "鞤",
    "𠳐"
  ],
  "póu fú": ["垺"],
  cén: ["埁", "岑", "涔"],
  "běng fēng": ["埄"],
  "dì fáng": ["埅"],
  "xiá jiā": ["埉"],
  "mái mán": ["埋"],
  làng: ["埌", "崀", "浪", "蒗", "閬", "㫰"],
  "shān yán": ["埏"],
  "qín jīn": ["埐"],
  "pǔ bù": ["埔"],
  huā: ["埖", "婲", "椛", "硴", "糀", "花", "蒊", "蘤", "誮", "錵"],
  "suì sù": ["埣"],
  "pí pì": ["埤"],
  "qīng zhēng": ["埥", "鲭"],
  "wǎn wān": ["埦"],
  lǔn: ["埨", "稐", "𫭢"],
  "zhēng chéng": ["埩"],
  kōng: ["埪", "崆", "箜", "躻", "錓", "鵼"],
  "cǎi cài": ["埰", "寀", "采"],
  "chù tòu": ["埱"],
  běng: ["埲", "琫", "菶", "鞛"],
  "kǎn xiàn": ["埳"],
  "yì shì": ["埶", "醳"],
  péi: ["培", "毰", "裴", "裵", "賠", "赔", "錇", "锫", "阫", "陪"],
  "sào sǎo": ["埽"],
  "jǐn qīn jìn": ["堇"],
  "péng bèng": ["堋"],
  "qiàn zàn jiàn": ["堑"],
  àn: [
    "堓",
    "屵",
    "岸",
    "按",
    "暗",
    "案",
    "胺",
    "荌",
    "豻",
    "貋",
    "錌",
    "闇",
    "隌",
    "黯"
  ],
  "duò huī": ["堕", "墮"],
  huán: [
    "堚",
    "寏",
    "寰",
    "峘",
    "桓",
    "洹",
    "澴",
    "獂",
    "环",
    "環",
    "糫",
    "繯",
    "缳",
    "羦",
    "荁",
    "萈",
    "萑",
    "豲",
    "鍰",
    "鐶",
    "锾",
    "镮",
    "闤",
    "阛",
    "雈",
    "鬟",
    "鹮",
    "𬘫",
    "𤩽"
  ],
  "bǎo bǔ pù": ["堡"],
  "máo móu wǔ": ["堥"],
  ruán: ["堧", "壖", "撋"],
  "ài è yè": ["堨"],
  gèng: ["堩", "暅"],
  méi: [
    "堳",
    "塺",
    "媒",
    "嵋",
    "徾",
    "攗",
    "枚",
    "栂",
    "梅",
    "楣",
    "楳",
    "槑",
    "湄",
    "湈",
    "煤",
    "猸",
    "玫",
    "珻",
    "瑂",
    "眉",
    "睂",
    "禖",
    "脄",
    "脢",
    "腜",
    "苺",
    "莓",
    "葿",
    "郿",
    "酶",
    "鎇",
    "镅",
    "霉",
    "鶥",
    "鹛",
    "黴"
  ],
  dǔ: ["堵", "琽", "睹", "笃", "篤", "覩", "賭", "赌"],
  féng: ["堸", "綘", "艂", "逢"],
  hèng: ["堼"],
  chūn: [
    "堾",
    "媋",
    "旾",
    "春",
    "暙",
    "杶",
    "椿",
    "槆",
    "橁",
    "櫄",
    "瑃",
    "箺",
    "萅",
    "蝽",
    "輴",
    "鰆",
    "鶞",
    "䲠"
  ],
  jiǎng: [
    "塂",
    "奖",
    "奨",
    "奬",
    "桨",
    "槳",
    "獎",
    "耩",
    "膙",
    "蒋",
    "蔣",
    "講",
    "讲",
    "顜"
  ],
  huāng: ["塃", "巟", "慌", "肓", "荒", "衁"],
  duàn: [
    "塅",
    "断",
    "斷",
    "椴",
    "段",
    "毈",
    "煅",
    "瑖",
    "碫",
    "簖",
    "籪",
    "緞",
    "缎",
    "腶",
    "葮",
    "躖",
    "鍛",
    "锻"
  ],
  tǎ: ["塔", "墖", "獭", "獺", "鮙", "鰨", "鳎"],
  wěng: ["塕", "奣", "嵡", "攚", "暡", "瞈", "蓊"],
  "sāi sài sè": ["塞"],
  zàng: ["塟", "弉", "臓", "臟", "葬", "蔵", "銺"],
  tián: [
    "塡",
    "屇",
    "恬",
    "沺",
    "湉",
    "璳",
    "甛",
    "甜",
    "田",
    "畋",
    "畑",
    "碵",
    "磌",
    "胋",
    "闐",
    "阗",
    "鴫",
    "鷆",
    "鷏"
  ],
  zhèng: [
    "塣",
    "幁",
    "政",
    "証",
    "諍",
    "證",
    "证",
    "诤",
    "郑",
    "鄭",
    "靕",
    "鴊"
  ],
  "tián zhèn": ["填"],
  wēn: [
    "塭",
    "昷",
    "榲",
    "殟",
    "温",
    "溫",
    "瑥",
    "瘟",
    "蕰",
    "豱",
    "輼",
    "轀",
    "辒",
    "鎾",
    "饂",
    "鰛",
    "鰮",
    "鳁"
  ],
  liù: ["塯", "廇", "磟", "翏", "雡", "霤", "餾", "鬸", "鷚", "鹨"],
  hǎi: ["塰", "海", "烸", "酼", "醢"],
  lǎng: ["塱", "朖", "朗", "朤", "烺", "蓢", "㮾"],
  bèng: ["塴", "揼", "泵", "甏", "綳", "蹦", "迸", "逬", "鏰", "镚"],
  chén: [
    "塵",
    "宸",
    "尘",
    "忱",
    "敐",
    "敶",
    "晨",
    "曟",
    "栕",
    "樄",
    "沉",
    "煁",
    "瘎",
    "臣",
    "茞",
    "莀",
    "莐",
    "蔯",
    "薼",
    "螴",
    "訦",
    "諶",
    "軙",
    "辰",
    "迧",
    "鈂",
    "陈",
    "陳",
    "霃",
    "鷐",
    "麎"
  ],
  "ōu qiū": ["塸"],
  "qiàn jiàn": ["塹"],
  "zhuān tuán": ["塼"],
  shuǎng: ["塽", "慡", "漺", "爽", "縔", "鏯"],
  shú: ["塾", "婌", "孰", "璹", "秫", "贖", "赎"],
  lǒu: ["塿", "嵝", "嶁", "甊", "篓", "簍"],
  chí: [
    "墀",
    "弛",
    "持",
    "池",
    "漦",
    "竾",
    "筂",
    "箎",
    "篪",
    "茌",
    "荎",
    "蚳",
    "謘",
    "貾",
    "赿",
    "踟",
    "迟",
    "迡",
    "遅",
    "遟",
    "遲",
    "鍉",
    "馳",
    "驰"
  ],
  shù: [
    "墅",
    "庶",
    "庻",
    "怷",
    "恕",
    "戍",
    "束",
    "树",
    "樹",
    "沭",
    "漱",
    "潄",
    "濖",
    "竖",
    "竪",
    "絉",
    "腧",
    "荗",
    "蒁",
    "虪",
    "術",
    "裋",
    "豎",
    "述",
    "鉥",
    "錰",
    "鏣",
    "霔",
    "鶐",
    "𬬸"
  ],
  "dì zhì": ["墆", "疐"],
  kàn: ["墈", "崁", "瞰", "矙", "磡", "衎", "鬫"],
  chěn: ["墋", "夦", "硶", "碜", "磣", "贂", "趻", "踸", "鍖"],
  "zhǐ zhuó": ["墌"],
  qiǎng: ["墏", "繈", "繦", "羥", "襁"],
  zēng: ["増", "增", "憎", "璔", "矰", "磳", "罾", "譄", "鄫", "鱛", "䎖"],
  qiáng: [
    "墙",
    "墻",
    "嫱",
    "嬙",
    "樯",
    "檣",
    "漒",
    "牆",
    "艢",
    "蔃",
    "蔷",
    "蘠"
  ],
  "kuài tuí": ["墤"],
  "tuǎn dǒng": ["墥"],
  "qiáo què": ["墧"],
  "zūn dūn": ["墫"],
  "qiāo áo": ["墽"],
  "yì tú": ["墿"],
  "xué bó jué": ["壆"],
  lǎn: [
    "壈",
    "嬾",
    "孄",
    "孏",
    "懒",
    "懶",
    "揽",
    "擥",
    "攬",
    "榄",
    "欖",
    "浨",
    "漤",
    "灠",
    "纜",
    "缆",
    "罱",
    "覧",
    "覽",
    "览",
    "醂",
    "顲"
  ],
  huài: ["壊", "壞", "蘾"],
  rǎng: ["壌", "壤", "攘", "爙"],
  "làn xiàn": ["壏"],
  dǎo: [
    "壔",
    "导",
    "導",
    "岛",
    "島",
    "嶋",
    "嶌",
    "嶹",
    "捣",
    "搗",
    "擣",
    "槝",
    "祷",
    "禂",
    "禱",
    "蹈",
    "陦",
    "隝",
    "隯"
  ],
  ruǐ: ["壡", "桵", "橤", "繠", "蕊", "蕋", "蘂", "蘃"],
  san: ["壭"],
  zhuàng: ["壮", "壯", "壵", "撞", "焋", "状", "狀"],
  "ké qiào": ["壳", "殼"],
  kǔn: [
    "壸",
    "壼",
    "悃",
    "捆",
    "梱",
    "硱",
    "祵",
    "稇",
    "稛",
    "綑",
    "裍",
    "閫",
    "閸",
    "阃"
  ],
  mǎng: ["壾", "漭", "茻", "莽", "莾", "蠎"],
  cún: ["壿", "存"],
  "zhǐ zhōng": ["夂"],
  "gǔ yíng": ["夃"],
  "jiàng xiáng": ["夅", "降"],
  "páng féng fēng": ["夆"],
  zhāi: ["夈", "捚", "摘", "斋", "斎", "榸", "粂", "齋"],
  "xuàn xiòng": ["夐"],
  wài: ["外", "顡"],
  "wǎn yuàn wān yuān": ["夗"],
  "mǎo wǎn": ["夘"],
  mèng: ["夢", "夣", "孟", "梦", "癦", "霥"],
  "dà dài": ["大"],
  "fū fú": ["夫", "姇", "枎", "粰"],
  guài: ["夬", "怪", "恠"],
  yāng: [
    "央",
    "姎",
    "抰",
    "殃",
    "泱",
    "秧",
    "胦",
    "鉠",
    "鍈",
    "雵",
    "鴦",
    "鸯"
  ],
  "hāng bèn": ["夯"],
  gǎo: [
    "夰",
    "搞",
    "杲",
    "槀",
    "槁",
    "檺",
    "稁",
    "稾",
    "稿",
    "縞",
    "缟",
    "菒",
    "藁",
    "藳"
  ],
  "tāo běn": ["夲"],
  "tóu tou": ["头"],
  "yǎn tāo": ["夵"],
  "kuā kuà": ["夸", "誇"],
  "jiá jiā gā xiá": ["夹"],
  huà: [
    "夻",
    "婳",
    "嫿",
    "嬅",
    "崋",
    "摦",
    "杹",
    "枠",
    "桦",
    "槬",
    "樺",
    "澅",
    "画",
    "畫",
    "畵",
    "繣",
    "舙",
    "話",
    "諙",
    "譮",
    "话",
    "黊"
  ],
  "jiā jiá gā xiá": ["夾"],
  ēn: ["奀", "恩", "蒽"],
  "dī tì": ["奃"],
  "yǎn yān": ["奄", "渰"],
  pào: ["奅", "疱", "皰", "砲", "礟", "礮", "靤", "麭"],
  nài: ["奈", "柰", "渿", "耐", "萘", "褦", "錼", "鼐"],
  "quān juàn": ["奍", "弮", "棬"],
  zòu: ["奏", "揍"],
  "qì qiè xiè": ["契"],
  kāi: ["奒", "开", "揩", "鐦", "锎", "開"],
  "bēn bèn": ["奔", "泍"],
  tào: ["套"],
  "zàng zhuǎng": ["奘"],
  běn: ["奙", "本", "楍", "畚", "翉", "苯"],
  "xùn zhuì": ["奞"],
  shē: ["奢", "檨", "猞", "畭", "畲", "賒", "賖", "赊", "輋", "𪨶"],
  "hǎ pò tǎi": ["奤"],
  "ào yù": ["奥", "奧", "澚"],
  yūn: ["奫", "氲", "氳", "蒀", "蒕", "蝹", "贇", "赟", "𫖳"],
  "duǒ chě": ["奲"],
  "nǚ rǔ": ["女"],
  nú: ["奴", "孥", "笯", "駑", "驽"],
  "dīng dǐng tiǎn": ["奵"],
  "tā jiě": ["她"],
  nuán: ["奻"],
  "hǎo hào": ["好"],
  fàn: [
    "奿",
    "嬎",
    "梵",
    "汎",
    "泛",
    "滼",
    "瀪",
    "犯",
    "畈",
    "盕",
    "笵",
    "範",
    "范",
    "訉",
    "販",
    "贩",
    "軬",
    "輽",
    "飯",
    "飰",
    "饭"
  ],
  shuò: ["妁", "搠", "朔", "槊", "烁", "爍", "矟", "蒴", "鎙", "鑠", "铄"],
  "fēi pèi": ["妃"],
  wàng: ["妄", "忘", "旺", "望", "朢"],
  zhuāng: [
    "妆",
    "妝",
    "娤",
    "庄",
    "庒",
    "桩",
    "梉",
    "樁",
    "粧",
    "糚",
    "荘",
    "莊",
    "装",
    "裝"
  ],
  mā: ["妈", "媽"],
  "fū yōu": ["妋"],
  "hài jiè": ["妎"],
  dù: [
    "妒",
    "妬",
    "杜",
    "殬",
    "渡",
    "秺",
    "芏",
    "荰",
    "螙",
    "蠧",
    "蠹",
    "鍍",
    "镀",
    "靯",
    "𬭊"
  ],
  miào: ["妙", "庙", "庿", "廟", "玅", "竗"],
  "fǒu pēi pī": ["妚"],
  "yuè jué": ["妜"],
  niū: ["妞"],
  "nà nàn": ["妠"],
  tuǒ: ["妥", "嫷", "庹", "椭", "楕", "橢", "鬌", "鰖", "鵎"],
  "wàn yuán": ["妧"],
  fáng: ["妨", "房", "肪", "防", "魴", "鲂"],
  nī: ["妮"],
  zhóu: ["妯", "碡"],
  zhāo: ["妱", "巶", "招", "昭", "釗", "鉊", "鍣", "钊", "駋", "𬬿"],
  "nǎi nǐ": ["妳"],
  tǒu: ["妵", "敨", "紏", "蘣", "黈"],
  "xián xuán xù": ["妶"],
  "zhí yì": ["妷", "秇"],
  ē: ["妸", "妿", "婀", "屙"],
  mèi: [
    "妹",
    "媚",
    "寐",
    "抺",
    "旀",
    "昧",
    "沬",
    "煝",
    "痗",
    "眛",
    "睸",
    "祙",
    "篃",
    "蝞",
    "袂",
    "跊",
    "鬽",
    "魅"
  ],
  "qī qì": ["妻"],
  "xū xǔ": ["姁", "稰"],
  "shān shàn": ["姍", "姗", "苫", "釤", "钐"],
  mán: ["姏", "慲", "樠", "蛮", "蠻", "謾", "饅", "馒", "鬗", "鬘", "鰻", "鳗"],
  jiě: ["姐", "媎", "檞", "毑", "飷"],
  "wěi wēi": ["委"],
  pīn: ["姘", "拼", "礗", "穦", "馪", "驞"],
  "huá huó": ["姡"],
  "jiāo xiáo": ["姣"],
  "gòu dù": ["姤"],
  "lǎo mǔ": ["姥"],
  "nián niàn": ["姩"],
  zhěn: [
    "姫",
    "屒",
    "弫",
    "抮",
    "昣",
    "枕",
    "畛",
    "疹",
    "眕",
    "稹",
    "縝",
    "縥",
    "缜",
    "聄",
    "萙",
    "袗",
    "裖",
    "覙",
    "診",
    "诊",
    "軫",
    "轸",
    "辴",
    "駗",
    "鬒"
  ],
  héng: [
    "姮",
    "恆",
    "恒",
    "烆",
    "珩",
    "胻",
    "蘅",
    "衡",
    "鑅",
    "鴴",
    "鵆",
    "鸻"
  ],
  "jūn xún": ["姰"],
  "kuā hù": ["姱"],
  "è yà": ["姶"],
  "xiān shēn": ["姺"],
  wá: ["娃"],
  "ráo rǎo": ["娆", "嬈"],
  "shào shāo": ["娋"],
  xiē: ["娎", "揳", "楔", "歇", "蝎", "蠍"],
  "wǔ méi mǔ": ["娒"],
  "chuò lài": ["娕"],
  niáng: ["娘", "嬢", "孃"],
  "nà nuó": ["娜", "𦰡"],
  "pōu bǐ": ["娝"],
  "něi suī": ["娞"],
  tuì: ["娧", "煺", "蛻", "蜕", "退", "駾"],
  mǎn: ["娨", "屘", "満", "满", "滿", "螨", "蟎", "襔", "鏋"],
  "wú wù yú": ["娪"],
  "xī āi": ["娭"],
  "zhuì shuì": ["娷"],
  "dōng dòng": ["娻"],
  "ǎi ái è": ["娾"],
  "ē ě": ["娿"],
  mián: [
    "婂",
    "嬵",
    "宀",
    "杣",
    "棉",
    "檰",
    "櫋",
    "眠",
    "矈",
    "矊",
    "矏",
    "綿",
    "緜",
    "绵",
    "芇",
    "蝒"
  ],
  "pǒu péi bù": ["婄"],
  biǎo: ["婊", "脿", "表", "裱", "褾", "諘", "錶"],
  "fù fàn": ["婏"],
  wǒ: ["婐", "婑", "我"],
  "ní nǐ": ["婗", "棿"],
  "quán juàn": ["婘", "惓"],
  hūn: [
    "婚",
    "昏",
    "昬",
    "棔",
    "涽",
    "睧",
    "睯",
    "碈",
    "荤",
    "葷",
    "蔒",
    "轋",
    "閽",
    "阍"
  ],
  "qiān jǐn": ["婜"],
  "wān wà": ["婠"],
  "lái lài": ["婡", "徕", "徠"],
  "zhōu chōu": ["婤"],
  "chuò nào": ["婥"],
  "nüè àn": ["婩"],
  "hùn kūn": ["婫"],
  "dàng yáng": ["婸"],
  nàn: ["婻"],
  "ruò chuò": ["婼"],
  jiǎ: ["婽", "岬", "斚", "斝", "榎", "槚", "檟", "玾", "甲", "胛", "鉀", "钾"],
  "tōu yú": ["婾", "媮"],
  "yù yú": ["媀"],
  "wéi wěi": ["媁"],
  "dì tí": ["媂", "珶", "苐"],
  róu: [
    "媃",
    "揉",
    "柔",
    "渘",
    "煣",
    "瑈",
    "瓇",
    "禸",
    "粈",
    "糅",
    "脜",
    "腬",
    "葇",
    "蝚",
    "蹂",
    "輮",
    "鍒",
    "鞣",
    "騥",
    "鰇",
    "鶔",
    "𫐓"
  ],
  "ruǎn nèn": ["媆"],
  miáo: ["媌", "嫹", "描", "瞄", "苗", "鶓", "鹋"],
  "yí pèi": ["媐"],
  "mián miǎn": ["媔"],
  "tí shì": ["媞", "惿"],
  "duò tuó": ["媠", "沲"],
  ǎo: ["媪", "媼", "艹", "芺", "袄", "襖", "镺"],
  "chú zòu": ["媰"],
  yìng: ["媵", "映", "暎", "硬", "膡", "鱦"],
  "qín shēn": ["嫀"],
  jià: ["嫁", "幏", "架", "榢", "稼", "駕", "驾"],
  sǎo: ["嫂"],
  "zhēn zhěn": ["嫃"],
  "jiē suǒ": ["嫅"],
  "míng mǐng": ["嫇"],
  niǎo: ["嫋", "嬝", "嬲", "茑", "蔦", "袅", "裊", "褭", "鸟"],
  tāo: [
    "嫍",
    "幍",
    "弢",
    "慆",
    "掏",
    "搯",
    "槄",
    "涛",
    "滔",
    "濤",
    "瑫",
    "絛",
    "縚",
    "縧",
    "绦",
    "詜",
    "謟",
    "轁",
    "鞱",
    "韜",
    "韬",
    "飸",
    "饕"
  ],
  biáo: ["嫑"],
  "piáo piāo": ["嫖", "薸"],
  xuán: [
    "嫙",
    "悬",
    "懸",
    "暶",
    "檈",
    "漩",
    "玄",
    "璇",
    "璿",
    "痃",
    "蜁",
    "𫠊"
  ],
  "màn mān": ["嫚"],
  kāng: [
    "嫝",
    "嵻",
    "康",
    "慷",
    "槺",
    "漮",
    "砊",
    "穅",
    "糠",
    "躿",
    "鏮",
    "鱇",
    "𡐓",
    "𩾌"
  ],
  "hān nǎn": ["嫨"],
  nèn: ["嫩", "嫰"],
  zhē: ["嫬", "遮"],
  "mā má": ["嫲"],
  piè: ["嫳"],
  zhǎn: [
    "嫸",
    "展",
    "搌",
    "斩",
    "斬",
    "琖",
    "盏",
    "盞",
    "輾",
    "醆",
    "颭",
    "飐"
  ],
  "xiān yǎn jìn": ["嬐"],
  liǎn: [
    "嬚",
    "敛",
    "斂",
    "琏",
    "璉",
    "羷",
    "脸",
    "臉",
    "蔹",
    "蘝",
    "蘞",
    "裣",
    "襝",
    "鄻"
  ],
  "qióng huán xuān": ["嬛"],
  dǒng: ["嬞", "懂", "箽", "董", "蕫", "諌"],
  cān: ["嬠", "湌", "爘", "飡", "餐", "驂", "骖"],
  tiǎo: ["嬥", "宨", "晀", "朓", "窱", "脁"],
  bí: ["嬶", "荸", "鼻"],
  liǔ: [
    "嬼",
    "柳",
    "栁",
    "桞",
    "桺",
    "橮",
    "熮",
    "珋",
    "綹",
    "绺",
    "罶",
    "羀",
    "鋶",
    "锍"
  ],
  "qiān xiān": ["孅", "欦"],
  "xié huī": ["孈"],
  "huān quán": ["孉"],
  "lí lì": ["孋", "麗"],
  "zhú chuò": ["孎"],
  kǒng: ["孔", "恐"],
  "mā zī": ["孖"],
  "sūn xùn": ["孙", "孫"],
  "bèi bó": ["孛", "誖"],
  "yòu niū": ["孧"],
  zhuǎn: ["孨", "竱", "轉"],
  hái: ["孩", "骸"],
  nāo: ["孬"],
  "chán càn": ["孱"],
  bò: ["孹", "檗", "蘗", "譒"],
  nái: ["孻", "腉"],
  "níng nìng": ["宁", "寍", "寗", "寜", "寧", "甯"],
  zhái: ["宅"],
  "tū jiā": ["宊"],
  sòng: ["宋", "訟", "誦", "讼", "诵", "送", "鎹", "頌", "颂", "餸"],
  ròu: ["宍", "肉", "譳"],
  zhūn: ["宒", "窀", "衠", "諄", "谆", "迍"],
  "mì fú": ["宓"],
  "dàng tàn": ["宕"],
  "wǎn yuān": ["宛"],
  chǒng: ["宠", "寵"],
  qún: ["宭", "峮", "帬", "羣", "群", "裙", "裠"],
  zǎi: ["宰", "崽"],
  "bǎo shí": ["宲"],
  "jiā jia jie": ["家"],
  "huāng huǎng": ["宺"],
  kuān: ["宽", "寛", "寬", "臗", "鑧", "髋", "髖"],
  "sù xiǔ xiù": ["宿"],
  "jié zǎn": ["寁"],
  "bìng bǐng": ["寎"],
  "jìn qǐn": ["寖"],
  "lóu jù": ["寠"],
  "xiě xiè": ["寫"],
  "qīn qìn": ["寴"],
  cùn: ["寸", "籿"],
  duì: [
    "对",
    "対",
    "對",
    "怼",
    "憝",
    "懟",
    "濧",
    "瀩",
    "碓",
    "祋",
    "綐",
    "薱",
    "譈",
    "譵",
    "轛",
    "队",
    "陮"
  ],
  "lüè luó": ["寽"],
  "shè yè yì": ["射"],
  "jiāng jiàng qiāng": ["将"],
  "jiāng jiàng": ["將", "浆", "漿", "畺"],
  zūn: ["尊", "嶟", "樽", "罇", "遵", "鐏", "鱒", "鳟", "鶎", "鷷", "𨱔"],
  "shù zhù": ["尌", "澍"],
  xiǎo: ["小", "晓", "暁", "曉", "皛", "皢", "筱", "筿", "篠", "謏", "𫍲"],
  "jié jí": ["尐", "诘", "鞊"],
  "shǎo shào": ["少"],
  ěr: [
    "尒",
    "尓",
    "尔",
    "栮",
    "毦",
    "洱",
    "爾",
    "珥",
    "耳",
    "薾",
    "衈",
    "趰",
    "迩",
    "邇",
    "鉺",
    "铒",
    "餌",
    "饵",
    "駬"
  ],
  "wāng yóu": ["尢"],
  wāng: ["尣", "尩", "尪", "尫", "汪"],
  liào: ["尥", "尦", "廖", "撂", "料", "炓", "窷", "鐐", "镣", "𪤗"],
  "méng máng lóng páng": ["尨"],
  gà: ["尬", "魀"],
  "kuì kuǐ": ["尯"],
  tuí: ["尵", "弚", "穨", "蘈", "蹪", "隤", "頹", "頺", "頽", "颓", "魋", "𬯎"],
  yǐn: [
    "尹",
    "嶾",
    "引",
    "朄",
    "檃",
    "檼",
    "櫽",
    "淾",
    "濥",
    "瘾",
    "癮",
    "粌",
    "蘟",
    "蚓",
    "螾",
    "讔",
    "赺",
    "趛",
    "輑",
    "鈏",
    "靷"
  ],
  "chǐ chě": ["尺"],
  kāo: ["尻", "髛"],
  "jìn jǐn": ["尽"],
  "wěi yǐ": ["尾"],
  "niào suī": ["尿"],
  céng: ["层", "層", "嶒", "驓"],
  diǎo: ["屌"],
  "píng bǐng bīng": ["屏"],
  lòu: ["屚", "漏", "瘘", "瘺", "瘻", "鏤", "镂", "陋"],
  "shǔ zhǔ": ["属", "屬"],
  "xiè tì": ["屟"],
  "chè cǎo": ["屮"],
  "tún zhūn": ["屯"],
  "nì jǐ": ["屰"],
  "hóng lóng": ["屸"],
  "qǐ kǎi": ["岂", "豈"],
  áng: ["岇", "昂", "昻"],
  "gǎng gāng": ["岗", "崗"],
  kě: ["岢", "敤", "渇", "渴", "炣"],
  gǒu: ["岣", "狗", "玽", "笱", "耇", "耈", "耉", "苟", "豿"],
  tiáo: [
    "岧",
    "岹",
    "樤",
    "祒",
    "笤",
    "芀",
    "萔",
    "蓚",
    "蓨",
    "蜩",
    "迢",
    "鋚",
    "鎥",
    "鞗",
    "髫",
    "鯈",
    "鰷",
    "鲦",
    "齠",
    "龆"
  ],
  "qū jū": ["岨"],
  lǐng: ["岭", "嶺", "領", "领"],
  pò: ["岶", "敀", "洦", "湐", "烞", "珀", "破", "砶", "粕", "蒪", "魄"],
  "bā kè": ["峇"],
  luò: [
    "峈",
    "摞",
    "洛",
    "洜",
    "犖",
    "珞",
    "笿",
    "纙",
    "荦",
    "詻",
    "雒",
    "駱",
    "骆",
    "鵅"
  ],
  "fù niè": ["峊"],
  ěn: ["峎"],
  "zhì shì": ["峙", "崻"],
  qiǎ: ["峠", "跒", "酠", "鞐"],
  "qiáo jiào": ["峤", "癄"],
  "xié yé": ["峫"],
  bū: ["峬", "庯", "晡", "誧", "逋", "鈽", "錻", "钸", "餔", "鵏"],
  chóng: ["崇", "崈", "爞", "虫", "蝩", "蟲", "褈", "隀"],
  "zú cuì": ["崒", "椊"],
  "líng léng": ["崚"],
  "dòng dōng": ["崠"],
  xiáo: ["崤", "洨", "淆", "訤", "誵"],
  "pí bǐ": ["崥", "芘"],
  "zhǎn chán": ["崭", "嶃", "嶄"],
  "wǎi wēi": ["崴"],
  "yáng dàng": ["崵"],
  "shì dié": ["崼"],
  yào: [
    "崾",
    "曜",
    "熎",
    "燿",
    "矅",
    "穾",
    "窔",
    "筄",
    "耀",
    "艞",
    "药",
    "葯",
    "薬",
    "藥",
    "袎",
    "覞",
    "詏",
    "讑",
    "靿",
    "鷂",
    "鹞",
    "鼼"
  ],
  "kān zhàn": ["嵁"],
  "hán dǎng": ["嵅"],
  "qiàn kàn": ["嵌"],
  "wù máo": ["嵍"],
  "kě jié": ["嵑", "嶱"],
  "wēi wěi": ["嵔"],
  kē: [
    "嵙",
    "柯",
    "棵",
    "榼",
    "樖",
    "牁",
    "牱",
    "犐",
    "珂",
    "疴",
    "瞌",
    "磕",
    "礚",
    "科",
    "稞",
    "窠",
    "萪",
    "薖",
    "蚵",
    "蝌",
    "趷",
    "轲",
    "醘",
    "鈳",
    "钶",
    "頦",
    "顆",
    "颗",
    "髁"
  ],
  "dàng táng": ["嵣"],
  "róng yíng": ["嵤", "爃"],
  "ái kǎi": ["嵦"],
  "kāo qiāo": ["嵪"],
  cuó: ["嵯", "嵳", "痤", "矬", "蒫", "蔖", "虘", "鹺", "鹾"],
  "qiǎn qīn": ["嵰"],
  "dì dié": ["嵽"],
  cēn: ["嵾"],
  dǐng: ["嵿", "艼", "薡", "鐤", "頂", "顶", "鼎", "鼑"],
  "áo ào": ["嶅"],
  "pǐ pèi": ["嶏"],
  "jiào qiáo": ["嶠", "潐"],
  "jué guì": ["嶡", "鳜"],
  "zhān shàn": ["嶦", "鳣"],
  "xiè jiè": ["嶰"],
  "guī xī juàn": ["嶲"],
  rū: ["嶿"],
  "lì liè": ["巁", "棙", "爄", "綟"],
  "xī guī juàn": ["巂"],
  "yíng hōng": ["巆"],
  yǐng: [
    "巊",
    "廮",
    "影",
    "摬",
    "梬",
    "潁",
    "瘿",
    "癭",
    "矨",
    "穎",
    "郢",
    "鐛",
    "頴",
    "颍",
    "颕",
    "颖"
  ],
  chǎo: ["巐", "炒", "煼", "眧", "麨"],
  cuán: ["巑", "櫕", "欑"],
  chuān: ["巛", "川", "氚", "瑏", "穿"],
  "jīng xíng": ["巠"],
  cháo: [
    "巢",
    "巣",
    "晁",
    "漅",
    "潮",
    "牊",
    "窲",
    "罺",
    "謿",
    "轈",
    "鄛",
    "鼌"
  ],
  qiǎo: ["巧", "愀", "髜"],
  gǒng: ["巩", "廾", "拱", "拲", "栱", "汞", "珙", "輁", "鞏"],
  "chà chā chāi cī": ["差"],
  "xiàng hàng": ["巷"],
  shuài: ["帅", "帥", "蟀"],
  pà: ["帊", "帕", "怕", "袙"],
  "tǎng nú": ["帑"],
  "mò wà": ["帓"],
  "tiē tiě tiè": ["帖"],
  zhǒu: ["帚", "晭", "疛", "睭", "箒", "肘", "菷", "鯞"],
  "juǎn juàn": ["帣"],
  shuì: ["帨", "涗", "涚", "睡", "稅", "税", "裞"],
  "chóu dào": ["帱", "幬"],
  "jiǎn jiān sàn": ["帴"],
  "shà qiè": ["帹"],
  "qí jì": ["帺", "荠"],
  "shān qiāo shēn": ["幓"],
  "zhuàng chuáng": ["幢"],
  "chān chàn": ["幨"],
  miè: [
    "幭",
    "懱",
    "搣",
    "滅",
    "灭",
    "烕",
    "礣",
    "篾",
    "蔑",
    "薎",
    "蠛",
    "衊",
    "鑖",
    "鱴",
    "鴓"
  ],
  "gān gàn": ["干"],
  "bìng bīng": ["并", "幷"],
  "jī jǐ": ["幾"],
  "guǎng ān": ["广"],
  guǎng: ["広", "廣", "犷", "獷"],
  me: ["庅"],
  "dùn tún": ["庉"],
  "bài tīng": ["庍"],
  "yìng yīng": ["应"],
  "dǐ de": ["底"],
  "dù duó": ["度"],
  "máng méng páng": ["庬"],
  "bìng píng": ["庰"],
  chěng: ["庱", "悜", "睈", "逞", "騁", "骋"],
  "jī cuò": ["庴"],
  qǐng: ["庼", "廎", "檾", "漀", "苘", "請", "謦", "请", "頃", "顷"],
  "guī wěi huì": ["廆"],
  "jǐn qín": ["廑"],
  kuò: [
    "廓",
    "扩",
    "拡",
    "擴",
    "濶",
    "筈",
    "萿",
    "葀",
    "蛞",
    "闊",
    "阔",
    "霩",
    "鞟",
    "鞹",
    "韕",
    "頢",
    "鬠"
  ],
  "qiáng sè": ["廧", "薔"],
  "yǐn yìn": ["廴", "隐", "隠", "隱", "飮", "飲", "饮"],
  "pò pǎi": ["廹", "迫"],
  "nòng lòng": ["弄"],
  "dì tì tuí": ["弟"],
  "jué zhāng": ["弡"],
  "mí mǐ": ["弥", "彌", "靡"],
  chāo: ["弨", "怊", "抄", "欩", "訬", "超", "鈔", "钞"],
  yi: ["弬"],
  shāo: [
    "弰",
    "旓",
    "烧",
    "焼",
    "燒",
    "筲",
    "艄",
    "萷",
    "蕱",
    "輎",
    "髾",
    "鮹"
  ],
  "xuān yuān": ["弲"],
  "qiáng qiǎng jiàng": ["強", "强"],
  "tán dàn": ["弹", "醈"],
  biè: ["彆"],
  "qiáng jiàng qiǎng": ["彊"],
  "jì xuě": ["彐"],
  tuàn: ["彖", "褖"],
  yuē: ["彟", "曰", "曱", "矱"],
  "shān xiǎn": ["彡"],
  wén: [
    "彣",
    "文",
    "炆",
    "珳",
    "瘒",
    "繧",
    "聞",
    "芠",
    "蚉",
    "蚊",
    "螡",
    "蟁",
    "閺",
    "閿",
    "闅",
    "闦",
    "闻",
    "阌",
    "雯",
    "馼",
    "駇",
    "魰",
    "鳼",
    "鴍",
    "鼤",
    "𫘜"
  ],
  "péng bāng": ["彭"],
  "piāo piào": ["彯"],
  "zhuó bó": ["彴"],
  "tuǒ yí": ["彵"],
  "páng fǎng": ["彷"],
  wǎng: [
    "彺",
    "往",
    "徃",
    "惘",
    "枉",
    "棢",
    "網",
    "网",
    "罒",
    "罓",
    "罔",
    "罖",
    "菵",
    "蛧",
    "蝄",
    "誷",
    "輞",
    "辋",
    "魍"
  ],
  cú: ["徂", "殂"],
  "dài dāi": ["待"],
  huái: ["徊", "怀", "懐", "懷", "槐", "淮", "耲", "蘹", "褢", "褱", "踝"],
  "wā wàng jiā": ["徍"],
  "chěng zhèng": ["徎"],
  "dé děi de": ["得"],
  "cóng zòng": ["從"],
  "shì tǐ": ["徥"],
  "tí chí": ["徲", "鶗", "鶙"],
  dé: ["徳", "德", "恴", "悳", "惪", "淂", "鍀", "锝"],
  "zhǐ zhēng": ["徴", "徵"],
  bié: ["徶", "癿", "莂", "蛂", "襒", "蹩"],
  "chōng zhǒng": ["徸"],
  "jiǎo jiào": ["徼", "笅", "筊"],
  "lòng lǒng": ["徿"],
  "qú jù": ["忂", "渠", "瞿", "螶"],
  "dìng tìng": ["忊"],
  gǎi: ["忋", "改"],
  rěn: ["忍", "栠", "栣", "秹", "稔", "綛", "荏", "荵", "躵"],
  chàn: ["忏", "懴", "懺", "硟", "羼", "韂", "顫"],
  tè: ["忑", "慝", "特", "蟘", "鋱", "铽"],
  "tè tēi tuī": ["忒"],
  "gān hàn": ["忓", "攼"],
  "yì qì": ["忔"],
  "tài shì": ["忕"],
  "xī liě": ["忚"],
  "yīng yìng": ["応", "應", "譍"],
  "mǐn wěn mín": ["忞", "忟"],
  "sōng zhōng": ["忪"],
  "yù shū": ["忬", "悆"],
  "qí shì": ["忯", "耆"],
  "tún zhūn dùn": ["忳"],
  "qián qín": ["忴", "扲"],
  hún: ["忶", "浑", "渾", "餛", "馄", "魂", "鼲"],
  niǔ: ["忸", "扭", "炄", "狃", "紐", "纽", "莥", "鈕", "钮", "靵"],
  "kuáng wǎng": ["忹"],
  "kāng hàng": ["忼"],
  "kài xì": ["忾", "愾"],
  òu: ["怄", "慪"],
  "bǎo bào": ["怉"],
  "mín mén": ["怋"],
  "zuò zhà": ["怍"],
  zěn: ["怎"],
  yàng: ["怏", "恙", "样", "様", "樣", "漾", "羕", "詇"],
  "kòu jù": ["怐"],
  "náo niú": ["怓"],
  "zhēng zhèng": ["怔", "掙", "钲", "铮"],
  "tiē zhān": ["怗"],
  "hù gù": ["怘"],
  "cū jù zū": ["怚"],
  "sī sāi": ["思"],
  "yóu chóu": ["怞"],
  "tū dié": ["怢"],
  "yōu yào": ["怮"],
  xuàn: [
    "怰",
    "昡",
    "楦",
    "泫",
    "渲",
    "炫",
    "琄",
    "眩",
    "碹",
    "絢",
    "縼",
    "繏",
    "绚",
    "蔙",
    "衒",
    "袨",
    "贙",
    "鉉",
    "鏇",
    "铉",
    "镟",
    "颴"
  ],
  "xù xuè": ["怴"],
  "bì pī": ["怶"],
  "xī shù": ["怸"],
  "nèn nín": ["恁"],
  "tiāo yáo": ["恌"],
  "xī qī xù": ["恓"],
  "xiào jiǎo": ["恔"],
  "hū kuā": ["恗"],
  nǜ: ["恧", "朒", "衂", "衄"],
  hèn: ["恨"],
  "dòng tōng": ["恫"],
  "quán zhuān": ["恮"],
  "è wù ě wū": ["恶", "惡"],
  tòng: ["恸", "慟", "憅", "痛", "衕"],
  "yuān juàn": ["悁"],
  "qiāo qiǎo": ["悄"],
  "jiè kè": ["悈"],
  "hào jiào": ["悎"],
  huǐ: ["悔", "檓", "毀", "毁", "毇", "燬", "譭"],
  "mán mèn": ["悗", "鞔"],
  "yī yì": ["悘", "衣"],
  quān: ["悛", "箞", "鐉", "𨟠"],
  "kuī lǐ": ["悝"],
  "yì niàn": ["悥"],
  "mèn mēn": ["悶"],
  guàn: [
    "悹",
    "悺",
    "惯",
    "慣",
    "掼",
    "摜",
    "樌",
    "欟",
    "泴",
    "涫",
    "潅",
    "灌",
    "爟",
    "瓘",
    "盥",
    "礶",
    "祼",
    "罆",
    "罐",
    "貫",
    "贯",
    "躀",
    "遦",
    "鏆",
    "鑵",
    "鱹",
    "鸛",
    "鹳"
  ],
  "kōng kǒng": ["悾"],
  "lǔn lùn": ["惀"],
  guǒ: [
    "惈",
    "果",
    "椁",
    "槨",
    "粿",
    "綶",
    "菓",
    "蜾",
    "裹",
    "褁",
    "輠",
    "餜",
    "馃"
  ],
  "yuān wǎn": ["惌", "箢"],
  "lán lín": ["惏"],
  "yù xù": ["惐", "淢"],
  "chuò chuì": ["惙"],
  "hūn mèn": ["惛"],
  "chǎng tǎng": ["惝"],
  "suǒ ruǐ": ["惢"],
  cǎn: ["惨", "慘", "憯", "黪", "黲", "䅟"],
  cán: ["惭", "慙", "慚", "残", "殘", "蚕", "蝅", "蠶", "蠺"],
  "dàn dá": ["惮", "憚"],
  rě: ["惹"],
  "yú tōu": ["愉"],
  "kài qì": ["愒"],
  "dàng táng shāng yáng": ["愓"],
  "chén xìn dān": ["愖"],
  "kè qià": ["愘"],
  nuò: [
    "愞",
    "懦",
    "懧",
    "掿",
    "搦",
    "榒",
    "稬",
    "穤",
    "糑",
    "糥",
    "糯",
    "諾",
    "诺",
    "蹃",
    "逽",
    "鍩",
    "锘"
  ],
  gǎn: [
    "感",
    "擀",
    "敢",
    "桿",
    "橄",
    "澉",
    "澸",
    "皯",
    "秆",
    "稈",
    "笴",
    "芉",
    "衦",
    "赶",
    "趕",
    "鱤",
    "鳡"
  ],
  "còng sōng": ["愡"],
  "sāi sī sǐ": ["愢"],
  "gōng gòng hǒng": ["愩", "慐"],
  "shuò sù": ["愬", "洬"],
  "yáo yào": ["愮"],
  huàng: ["愰", "曂", "榥", "滉", "皝", "皩", "鎤", "㿠"],
  zhěng: ["愸", "抍", "拯", "整", "晸"],
  cǎo: ["愺", "艸", "草", "騲"],
  "xì xié": ["慀"],
  "cǎo sāo": ["慅"],
  "xù chù": ["慉"],
  "qiè qiàn": ["慊"],
  "cáo cóng": ["慒"],
  "ào áo": ["慠"],
  "lián liǎn": ["慩", "梿", "槤", "櫣"],
  "jìn qín jǐn": ["慬"],
  "dì chì": ["慸"],
  "zhí zhé": ["慹"],
  "lóu lǚ": ["慺", "鷜"],
  còng: ["憁", "謥"],
  "zhī zhì": ["憄", "知", "織", "织"],
  chēng: [
    "憆",
    "摚",
    "撐",
    "撑",
    "晿",
    "柽",
    "棦",
    "橕",
    "檉",
    "泟",
    "浾",
    "琤",
    "瞠",
    "碀",
    "緽",
    "罉",
    "蛏",
    "蟶",
    "赪",
    "赬",
    "鏿",
    "鐣",
    "阷",
    "靗",
    "頳",
    "饓"
  ],
  biē: ["憋", "虌", "鱉", "鳖", "鼈", "龞"],
  "chéng dèng zhèng": ["憕"],
  "xǐ xī": ["憘"],
  "duì dùn tūn": ["憞"],
  "xiāo jiāo": ["憢"],
  "xián xiàn": ["憪"],
  "liáo liǎo": ["憭", "燎", "爎", "爒"],
  shéng: ["憴", "縄", "繉", "繩", "绳", "譝"],
  "náo nǎo náng": ["憹"],
  "jǐng jìng": ["憼"],
  "jǐ jiǎo": ["憿"],
  "xuān huān": ["懁"],
  "cǎo sāo sào": ["懆"],
  mèn: ["懑", "懣", "暪", "焖", "燜"],
  "mèng méng měng": ["懜"],
  "ài yì nǐ": ["懝"],
  "méng měng": ["懞", "瞢", "矒"],
  "qí jī jì": ["懠"],
  mǒ: ["懡"],
  "lán xiàn": ["懢"],
  "yōu yǒu": ["懮"],
  "liú liǔ": ["懰", "藰"],
  ràng: ["懹", "譲", "讓", "让"],
  huān: ["懽", "欢", "歓", "歡", "獾", "讙", "貛", "酄", "驩", "鴅", "鵍"],
  nǎn: ["戁", "揇", "湳", "煵", "腩", "蝻", "赧"],
  "mí mó": ["戂"],
  "gàng zhuàng": ["戅", "戆"],
  "zhuàng gàng": ["戇"],
  "xū qu": ["戌"],
  "xì hū": ["戏", "戯", "戲"],
  "jiá gā": ["戛"],
  zéi: ["戝", "蠈", "賊", "贼", "鰂", "鱡", "鲗"],
  děng: ["戥", "等"],
  "hū xì": ["戱"],
  chuō: ["戳", "踔", "逴"],
  "biǎn piān": ["扁"],
  "shǎng jiōng": ["扄"],
  "shàn shān": ["扇"],
  cái: ["才", "材", "纔", "裁", "財", "财"],
  "zhā zā zhá": ["扎"],
  "lè lì cái": ["扐"],
  "bā pá": ["扒"],
  "dǎ dá": ["打"],
  rēng: ["扔"],
  "fǎn fú": ["払"],
  "diǎo dí yuē lì": ["扚"],
  "káng gāng": ["扛"],
  "yū wū": ["扜"],
  "yū wū kū": ["扝"],
  "tuō chǐ yǐ": ["扡"],
  "gǔ jié xì gē": ["扢"],
  dèn: ["扥", "扽"],
  "sǎo sào": ["扫", "掃"],
  rǎo: ["扰", "擾", "隢"],
  "xī chā qì": ["扱"],
  "bān pān": ["扳"],
  "bā ào": ["扷"],
  "xī zhé": ["扸"],
  "zhì sǔn kǎn": ["扻"],
  zhǎo: ["找", "沼", "瑵"],
  "kuáng wǎng zài": ["抂"],
  "hú gǔ": ["抇", "鹄", "鹘"],
  "bǎ bà": ["把"],
  "dǎn shěn": ["抌"],
  "nè nì ruì nà": ["抐"],
  zhuā: ["抓", "檛", "簻", "膼", "髽"],
  póu: ["抔", "裒"],
  "zhé shé zhē": ["折"],
  "póu pōu fū": ["抙", "捊"],
  pāo: ["抛", "拋", "脬", "萢"],
  "ǎo ào niù": ["抝"],
  "lūn lún": ["抡", "掄"],
  "qiǎng qiāng chēng": ["抢"],
  "zhǐ zhǎi": ["抧"],
  "bù pū": ["抪", "柨"],
  "yǎo tāo": ["抭"],
  "hē hè qiā": ["抲"],
  "nǐ ní": ["抳"],
  "pī pēi": ["抷"],
  "mǒ mò mā": ["抹"],
  chōu: ["抽", "犨", "犫", "瘳", "篘"],
  "jiā yá": ["拁"],
  "fú bì": ["拂", "畐", "鶝"],
  zhǎ: ["拃", "眨", "砟", "鮺", "鲝"],
  "dān dàn dǎn": ["担"],
  "chāi cā": ["拆"],
  niān: ["拈", "蔫"],
  "lā lá lǎ là": ["拉"],
  "bàn pàn": ["拌"],
  pāi: ["拍"],
  līn: ["拎"],
  guǎi: ["拐", "枴", "柺"],
  "tuò tà zhí": ["拓"],
  "ào ǎo niù": ["拗"],
  "jū gōu": ["拘"],
  "pīn pàn fān": ["拚"],
  "bài bái": ["拜"],
  bài: ["拝", "敗", "稗", "粺", "薭", "贁", "败", "韛"],
  qiá: ["拤"],
  "nǐng níng nìng": ["拧"],
  "zé zhái": ["择", "擇"],
  hén: ["拫", "痕", "鞎"],
  "kuò guā": ["括"],
  "jié jiá": ["拮"],
  nǐn: ["拰"],
  shuān: ["拴", "栓", "閂", "闩"],
  "cún zùn": ["拵"],
  "zā zǎn": ["拶", "桚"],
  kǎo: ["拷", "攷", "栲", "烤", "考"],
  "yí chǐ hài": ["拸"],
  "cè sè chuò": ["拺"],
  "zhuài zhuāi yè": ["拽"],
  "shí shè": ["拾"],
  bāi: ["挀", "掰"],
  "kuò guāng": ["挄"],
  nòng: ["挊", "挵", "齈"],
  "jiào jiāo": ["挍", "敎", "教"],
  "kuà kū": ["挎"],
  "ná rú": ["挐"],
  "tiāo tiǎo": ["挑"],
  "dié shè": ["挕"],
  liě: ["挘", "毟"],
  "yà yǎ": ["挜", "掗"],
  "wō zhuā": ["挝"],
  "xié jiā": ["挟", "挾"],
  "dǎng dàng": ["挡", "擋"],
  "zhèng zhēng": ["挣", "正", "症"],
  "āi ái": ["挨"],
  "tuō shuì": ["挩", "捝"],
  "tǐ tì": ["挮"],
  "suō shā": ["挱"],
  "sā shā suō": ["挲"],
  "kēng qiān": ["挳", "摼"],
  "bàng péng": ["挷"],
  "ruó ruá": ["挼"],
  "jiǎo kù": ["捁"],
  "wǔ wú": ["捂"],
  tǒng: ["捅", "桶", "筒", "筩", "統", "綂", "统", "㛚"],
  "huò chì": ["捇"],
  "tú shū chá": ["捈"],
  "lǚ luō": ["捋"],
  "shāo shào": ["捎", "稍"],
  niē: ["捏", "揑"],
  "shù sǒng sōu": ["捒"],
  "yé yú": ["捓"],
  "jué zhuó": ["捔"],
  "bù pú zhì": ["捗"],
  zùn: ["捘", "銌"],
  lāo: ["捞", "撈", "粩"],
  sǔn: ["损", "損", "榫", "笋", "筍", "箰", "鎨", "隼"],
  "wàn wǎn wān yù": ["捥"],
  pěng: ["捧", "淎", "皏"],
  shě: ["捨"],
  "fǔ fù bǔ": ["捬"],
  dáo: ["捯"],
  "luò luǒ wǒ": ["捰"],
  "juǎn quán": ["捲"],
  "chēn tiǎn": ["捵"],
  "niǎn niē": ["捻"],
  "ruó wěi ré": ["捼"],
  zuó: ["捽", "昨", "秨", "稓", "筰", "莋", "鈼"],
  "wò xiá": ["捾"],
  "qìng qiàn": ["掅"],
  "póu pǒu": ["掊"],
  qiā: ["掐", "葜"],
  "pái pǎi": ["排"],
  "qiān wàn": ["掔"],
  "yè yē": ["掖"],
  "niè nǐ yì": ["掜"],
  "huò xù": ["掝"],
  "yàn shàn yǎn": ["掞"],
  "zhěng dìng": ["掟"],
  kòng: ["控", "鞚"],
  tuī: ["推", "蓷", "藬"],
  "zōu zhōu chōu": ["掫"],
  tiàn: ["掭", "舚"],
  kèn: ["掯", "裉", "褃"],
  pá: ["掱", "杷", "潖", "爬", "琶", "筢"],
  "guó guāi": ["掴"],
  "dǎn shàn": ["掸", "撣"],
  "chān xiān càn shǎn": ["掺"],
  sāo: ["掻", "搔", "溞", "繅", "缫", "螦", "騒", "騷", "鰠", "鱢", "鳋"],
  pèng: ["掽", "椪", "槰", "碰", "踫"],
  "zhēng kēng": ["揁"],
  "jiū yóu": ["揂"],
  "jiān jiǎn": ["揃", "籛"],
  "pì chè": ["揊"],
  "sāi zǒng cāi": ["揌"],
  "tí dī dǐ": ["提"],
  "zǒng sōng": ["揔"],
  "huáng yóng": ["揘"],
  "zǎn zuàn": ["揝"],
  "xū jū": ["揟"],
  "ké qiā": ["揢"],
  "chuāi chuǎi chuài tuán zhuī": ["揣"],
  "dì tì": ["揥"],
  "lá là": ["揦"],
  là: [
    "揧",
    "楋",
    "溂",
    "瓎",
    "瘌",
    "翋",
    "臘",
    "蝋",
    "蝲",
    "蠟",
    "辢",
    "辣",
    "鑞",
    "镴",
    "鬎",
    "鯻",
    "𬶟"
  ],
  "jiē qì": ["揭"],
  "chòng dǒng": ["揰"],
  "dié shé yè": ["揲"],
  "jiàn qián jiǎn": ["揵"],
  yé: ["揶", "爷", "爺", "瑘", "鋣", "鎁", "铘"],
  chān: ["搀", "摻", "攙", "裧", "襜", "覘", "觇", "辿", "鋓"],
  "gē gé": ["搁", "擱"],
  "lǒu lōu": ["搂", "摟"],
  "chōu zǒu": ["搊"],
  chuāi: ["搋"],
  sūn: ["搎", "槂", "狲", "猻", "荪", "蓀", "蕵", "薞", "飧", "飱"],
  "róng náng nǎng": ["搑"],
  "péng bàng": ["搒"],
  cuō: ["搓", "瑳", "磋", "蹉", "遳", "醝"],
  "kē è": ["搕"],
  "nù nuò nòu": ["搙"],
  "lā xié xiàn": ["搚"],
  qiǔ: ["搝", "糗"],
  "xiǎn xiān": ["搟"],
  "jié zhé": ["搩"],
  "pán bān pó": ["搫"],
  bān: [
    "搬",
    "攽",
    "斑",
    "斒",
    "班",
    "瘢",
    "癍",
    "肦",
    "螁",
    "螌",
    "褩",
    "辬",
    "頒",
    "颁",
    "𨭉"
  ],
  "zhì nái": ["搱"],
  "wā wǎ wà": ["搲"],
  huá: ["搳", "撶", "滑", "猾", "蕐", "螖", "譁", "鏵", "铧", "驊", "骅", "鷨"],
  "qiāng qiǎng chēng": ["搶"],
  "tián shēn": ["搷"],
  "ná nuò": ["搻"],
  èn: ["摁"],
  "shè niè": ["摄", "攝"],
  bìn: ["摈", "擯", "殡", "殯", "膑", "臏", "髌", "髕", "髩", "鬂", "鬓", "鬢"],
  "shā sà shǎi": ["摋"],
  "chǎn sùn": ["摌"],
  "jiū liú liáo jiǎo náo": ["摎"],
  "féng pěng": ["摓"],
  shuāi: ["摔"],
  "dì tú zhí": ["摕"],
  "qì jì chá": ["摖"],
  "sōu sǒng": ["摗"],
  "liǎn liàn": ["摙"],
  "gài xì": ["摡"],
  "hù chū": ["摢"],
  tàng: ["摥", "烫", "燙", "鐋"],
  "nái zhì": ["摨"],
  "mó mā": ["摩"],
  "jiāng qiàng": ["摪"],
  "áo qiáo": ["摮"],
  "niè chè": ["摰"],
  "mán màn": ["摱"],
  "chàn cán": ["摲"],
  "sè mí sù": ["摵"],
  "biāo biào": ["摽"],
  "juē jué": ["撅"],
  piē: ["撆", "暼", "氕", "瞥"],
  "piě piē": ["撇"],
  "zǎn zān zēn qián": ["撍"],
  "sā sǎ": ["撒"],
  hòng: ["撔", "訌", "讧", "闀", "鬨"],
  "héng guàng": ["撗"],
  niǎn: [
    "撚",
    "撵",
    "攆",
    "涊",
    "焾",
    "碾",
    "簐",
    "蹍",
    "蹨",
    "躎",
    "輦",
    "辇"
  ],
  "chéng zhěng": ["撜"],
  "huī wéi": ["撝"],
  cāo: ["撡", "操", "糙"],
  "xiāo sōu": ["撨"],
  "liáo liāo": ["撩"],
  "cuō zuǒ": ["撮"],
  "wěi tuǒ": ["撱"],
  cuān: ["撺", "攛", "汆", "蹿", "躥", "鑹", "镩"],
  "qiào yāo jī": ["撽"],
  "zhuā wō": ["撾"],
  "lèi léi": ["擂"],
  nǎng: ["擃", "攮", "曩", "灢"],
  "qíng jǐng": ["擏"],
  kuǎi: ["擓", "蒯", "㧟"],
  "pǐ bò": ["擗"],
  "bò bāi": ["擘"],
  "jù jǐ": ["據"],
  mēng: ["擝"],
  "sǒu sòu": ["擞"],
  xǐng: ["擤", "箵", "醒"],
  cā: ["擦"],
  "níng nǐng nìng": ["擰"],
  "zhì jié": ["擳"],
  "là liè": ["擸", "爉"],
  "sòu sǒu": ["擻"],
  "lì luò yuè": ["擽"],
  "tī zhāi zhì": ["擿"],
  pān: ["攀", "潘", "眅", "萠"],
  lèi: [
    "攂",
    "泪",
    "涙",
    "淚",
    "禷",
    "类",
    "纇",
    "蘱",
    "酹",
    "銇",
    "錑",
    "頛",
    "頪",
    "類",
    "颣"
  ],
  "cā sǎ": ["攃"],
  "jùn pèi": ["攈"],
  "lì luò": ["攊", "躒"],
  "là lài": ["攋", "櫴"],
  "lú luó": ["攎"],
  "zǎn cuán": ["攒"],
  "xiān jiān": ["攕"],
  "mí mǐ mó": ["攠"],
  "zǎn cuán zàn zuān": ["攢"],
  zuàn: ["攥"],
  "lì shài": ["攦"],
  "lì luǒ": ["攭"],
  "guǐ guì": ["攱"],
  "jī qī yǐ": ["攲"],
  fàng: ["放"],
  "wù móu": ["敄"],
  "chù shōu": ["敊"],
  "gé guó è": ["敋"],
  "duó duì": ["敓", "敚"],
  "duō què": ["敠", "敪"],
  "sàn sǎn": ["散"],
  "dūn duì": ["敦", "镦"],
  "qī yǐ jī": ["敧"],
  "xiào xué": ["敩"],
  "shù shǔ shuò": ["数", "數"],
  "ái zhú": ["敱", "敳"],
  "xiòng xuàn": ["敻"],
  "zhuó zhú": ["斀"],
  "yì dù": ["斁"],
  "lí tái": ["斄"],
  "fěi fēi": ["斐"],
  "yǔ zhōng": ["斔"],
  "dòu dǒu": ["斗"],
  "wò guǎn": ["斡"],
  "tǒu tiǎo": ["斢"],
  dòu: [
    "斣",
    "梪",
    "浢",
    "痘",
    "窦",
    "竇",
    "脰",
    "荳",
    "豆",
    "逗",
    "郖",
    "酘",
    "閗",
    "闘",
    "餖",
    "饾",
    "鬥",
    "鬦",
    "鬪",
    "鬬",
    "鬭"
  ],
  "yín zhì": ["斦"],
  "chǎn jiè": ["斺"],
  "wū yū yú": ["於"],
  "yóu liú": ["斿"],
  "páng bàng": ["旁"],
  "máo mào": ["旄"],
  "pī bì": ["旇"],
  "xuán xuàn": ["旋"],
  "wú mó": ["无"],
  zǎo: ["早", "枣", "栆", "棗", "澡", "璪", "薻", "藻", "蚤"],
  gā: ["旮"],
  "gàn hàn": ["旰"],
  "tái yīng": ["旲"],
  "xū xù": ["旴"],
  "tūn zhùn": ["旽"],
  "wù wǔ": ["旿"],
  "pò pèi": ["昢"],
  zòng: ["昮", "猔", "疭", "瘲", "粽", "糉", "糭", "縦"],
  ǎi: ["昹", "毐", "矮", "蔼", "藹", "譪", "躷", "霭", "靄"],
  "huàng huǎng": ["晃"],
  xuǎn: ["晅", "癣", "癬", "选", "選"],
  "xù kuā": ["晇"],
  hǒng: ["晎"],
  shài: ["晒", "曬"],
  "yūn yùn": ["晕", "煴"],
  "shèng chéng": ["晟", "椉", "盛"],
  "jǐng yǐng": ["景"],
  shǎn: ["晱", "熌", "睒", "覢", "閃", "闪", "陕", "陝"],
  "qǐ dù": ["晵"],
  "ǎn àn yǎn": ["晻"],
  "wǎng wàng": ["暀"],
  zàn: [
    "暂",
    "暫",
    "瓉",
    "瓒",
    "瓚",
    "禶",
    "襸",
    "讃",
    "讚",
    "賛",
    "贊",
    "赞",
    "蹔",
    "鄼",
    "錾",
    "鏨",
    "饡"
  ],
  "yùn yūn": ["暈"],
  "mín mǐn": ["暋"],
  "dǔ shǔ": ["暏"],
  shǔ: [
    "暑",
    "曙",
    "潻",
    "癙",
    "糬",
    "署",
    "薥",
    "薯",
    "藷",
    "蜀",
    "蠴",
    "襡",
    "襩",
    "鱪",
    "鱰",
    "黍",
    "鼠",
    "鼡"
  ],
  "jiǎn lán": ["暕"],
  nuǎn: ["暖", "煗", "餪"],
  "bào pù": ["暴"],
  "xī xǐ": ["暿"],
  "pù bào": ["曝", "瀑"],
  "qū qǔ": ["紶"],
  "qǔ qū": ["曲"],
  "gèng gēng": ["更"],
  "hū hù": ["曶", "雽"],
  "zēng céng": ["曽", "橧"],
  "céng zēng": ["曾", "竲"],
  "cǎn qián jiàn": ["朁"],
  "qiè hé": ["朅"],
  "bì pí": ["朇", "禆", "笓", "裨"],
  "yǒu yòu": ["有"],
  "bān fén": ["朌", "鳻"],
  "fú fù": ["服", "洑"],
  "fěi kū": ["朏", "胐"],
  "qú xù chǔn": ["朐"],
  "juān zuī": ["朘"],
  "huāng máng wáng": ["朚"],
  "qī jī": ["期"],
  "tóng chuáng": ["朣", "橦"],
  zhá: ["札", "牐", "箚", "蚻", "譗", "鍘", "铡", "閘", "闸"],
  "zhú shù shú": ["朮"],
  "shù shú zhú": ["术"],
  "zhū shú": ["朱"],
  "pǔ pò pō piáo": ["朴"],
  "dāo tiáo mù": ["朷"],
  "guǐ qiú": ["朹"],
  xiǔ: ["朽", "滫", "潃", "糔"],
  "chéng chēng": ["朾"],
  zá: ["杂", "沯", "砸", "襍", "雑", "雜", "雥", "韴"],
  "yú wū": ["杅"],
  "gān gǎn": ["杆"],
  "chā chà": ["杈"],
  "shān shā": ["杉"],
  cūn: ["村", "皴", "竴", "膥", "踆", "邨"],
  "rèn ér": ["杒", "梕"],
  "sháo biāo": ["杓"],
  "dì duò": ["杕", "枤"],
  "gū gài": ["杚"],
  "yí zhì lí duò": ["杝"],
  "gàng gāng": ["杠"],
  "tiáo tiāo": ["条", "條"],
  "mà mǎ": ["杩"],
  "sì zhǐ xǐ": ["杫"],
  "yuán wán": ["杬", "蚖"],
  "bèi fèi": ["杮"],
  "shū duì": ["杸"],
  "niǔ chǒu": ["杻"],
  "wò yuè": ["枂", "臒"],
  máo: [
    "枆",
    "毛",
    "氂",
    "渵",
    "牦",
    "矛",
    "罞",
    "茅",
    "茆",
    "蝥",
    "蟊",
    "軞",
    "酕",
    "鉾",
    "錨",
    "锚",
    "髦",
    "鶜"
  ],
  "pī mì": ["枈"],
  àng: ["枊", "盎", "醠"],
  "fāng bìng": ["枋"],
  "hù dǐ": ["枑"],
  xín: ["枔", "襑", "鐔", "鬵"],
  "yāo yǎo": ["枖"],
  "ě è": ["枙"],
  "zhī qí": ["枝"],
  "cōng zōng": ["枞", "樅"],
  "xiān zhēn": ["枮"],
  "tái sì": ["枱"],
  "gǒu jǔ gōu": ["枸"],
  "bāo fú": ["枹"],
  "yì xiè": ["枻", "栧"],
  "tuó duò": ["柁", "馱", "駄", "驮"],
  "yí duò lí": ["柂"],
  "nǐ chì": ["柅"],
  "pán bàn": ["柈", "跘"],
  "yǎng yàng yāng yīng": ["柍"],
  "fù fū fǔ": ["柎"],
  "bǎi bó bò": ["柏"],
  mǒu: ["某"],
  "sháo shào": ["柖"],
  zhè: ["柘", "樜", "浙", "淛", "蔗", "蟅", "這", "鷓", "鹧", "䗪"],
  "yòu yóu": ["柚", "櫾"],
  "guì jǔ": ["柜"],
  "zhà zuò": ["柞"],
  "dié zhì": ["柣", "眰"],
  "zhā zǔ zū": ["柤"],
  "chá zhā": ["查", "査"],
  "āo ào": ["柪", "軪"],
  "bā fú pèi bó biē": ["柭"],
  "duò zuó wù": ["柮"],
  "bì bié": ["柲"],
  "zhù chù": ["柷"],
  "bēi pēi": ["柸"],
  "shì fèi": ["柹"],
  "shān zhà shi cè": ["栅"],
  "lì yuè": ["栎", "櫟"],
  "qì qiè": ["栔", "砌"],
  "qī xī": ["栖", "蹊"],
  "guā kuò": ["栝"],
  "bīng bēn": ["栟"],
  "xiào jiào": ["校"],
  "jiàn zùn": ["栫", "袸"],
  "yǒu yù": ["栯"],
  "hé hú": ["核"],
  gēn: ["根", "跟"],
  "zhī yì": ["栺"],
  "gé gē": ["格"],
  "héng háng": ["桁"],
  "guàng guāng": ["桄"],
  "yí tí": ["桋", "荑"],
  sāng: ["桑", "桒", "槡"],
  "jú jié": ["桔"],
  "yú móu": ["桙"],
  "ráo náo": ["桡", "橈"],
  "guì huì": ["桧", "檜"],
  "chén zhèn": ["桭"],
  "tīng yíng": ["桯"],
  "bó po": ["桲"],
  "bèn fàn": ["桳"],
  "fēng fèng": ["桻", "葑"],
  "sù yìn": ["梀"],
  "tǐng tìng": ["梃"],
  "xuān juān xié": ["梋"],
  "tú chá": ["梌"],
  "āo yòu": ["梎"],
  kuǎn: ["梡", "欵", "款", "歀"],
  "shāo sào": ["梢"],
  "qín chén cén": ["梣"],
  "lí sì qǐ": ["梩"],
  "chān yán": ["梴"],
  "bīn bīng": ["梹", "槟", "檳"],
  "táo chóu dào": ["梼"],
  "cōng sōng": ["棇"],
  "gùn hùn": ["棍"],
  "dé zhé": ["棏"],
  "pái bèi pèi": ["棑"],
  "bàng pǒu bèi bēi": ["棓"],
  "dì dài tì": ["棣"],
  sēn: ["森", "椮", "槮", "襂"],
  "rěn shěn": ["棯"],
  "léng lēng líng": ["棱"],
  "fú sù": ["棴"],
  "zōu sǒu": ["棷"],
  zōu: [
    "棸",
    "箃",
    "緅",
    "諏",
    "诹",
    "邹",
    "郰",
    "鄒",
    "鄹",
    "陬",
    "騶",
    "驺",
    "鯫",
    "鲰",
    "黀",
    "齱",
    "齺"
  ],
  "zhào zhuō": ["棹"],
  "chēn shēn": ["棽"],
  "jiē qiè": ["椄"],
  "yǐ yī": ["椅"],
  "chóu zhòu diāo": ["椆"],
  "qiāng kōng": ["椌"],
  "zhuī chuí": ["椎"],
  "bēi pí": ["椑"],
  mēn: ["椚"],
  "quān juàn quán": ["椦"],
  "duǒ chuán": ["椯"],
  "wěi huī": ["椲"],
  "jiǎ jiā": ["椵"],
  "hán jiān": ["椷"],
  "shèn zhēn": ["椹"],
  "yàn yà": ["椻"],
  "zhā chá": ["楂"],
  "guō kuǎ": ["楇"],
  "jí zhì": ["楖"],
  "kǔ hù": ["楛"],
  "yóu yǒu": ["楢"],
  "sǒng cōng": ["楤"],
  "yuán xuàn": ["楥"],
  "yǎng yàng yīng": ["楧"],
  pián: ["楩", "胼", "腁", "賆", "蹁", "駢", "騈", "骈", "骿", "㛹"],
  "dié yè": ["楪"],
  "dùn shǔn": ["楯"],
  "còu zòu": ["楱"],
  "dì dǐ shì": ["楴"],
  "kǎi jiē": ["楷"],
  "róu ròu": ["楺"],
  "lè yuè": ["楽"],
  "wēn yùn": ["榅", "鞰"],
  lǘ: ["榈", "櫚", "氀", "膢", "藘", "閭", "闾", "驢", "驴"],
  shén: ["榊", "神", "鉮", "鰰", "𬬹"],
  "bī pi": ["榌"],
  "zhǎn niǎn zhèn": ["榐"],
  "fú fù bó": ["榑"],
  "jiàn jìn": ["榗"],
  "bǎng bàng": ["榜"],
  "shā xiè": ["榝", "樧"],
  nòu: ["槈", "耨", "鎒", "鐞"],
  "qiǎn lián xiàn": ["槏"],
  gàng: ["槓", "焵", "焹", "筻", "鿍"],
  gāo: [
    "槔",
    "槹",
    "橰",
    "櫜",
    "睾",
    "篙",
    "糕",
    "羔",
    "臯",
    "韟",
    "餻",
    "高",
    "髙",
    "鷎",
    "鷱",
    "鼛"
  ],
  "diān zhěn zhēn": ["槙"],
  "kǎn jiàn": ["槛"],
  "xí dié": ["槢"],
  "jī guī": ["槣"],
  "róng yōng": ["槦"],
  "tuán shuàn quán": ["槫"],
  "qì sè": ["槭"],
  "cuī zhǐ": ["槯"],
  "yǒu chǎo": ["槱"],
  "màn wàn": ["槾"],
  "lí chī": ["樆"],
  "léi lěi": ["樏", "櫑", "礌"],
  "cháo jiǎo chāo": ["樔"],
  "chēng táng": ["樘"],
  "jiū liáo": ["樛"],
  "mó mú": ["模"],
  "niǎo mù": ["樢"],
  "héng hèng": ["横", "橫"],
  xuě: ["樰", "膤", "艝", "轌", "雪", "鱈", "鳕"],
  "fá fèi": ["橃"],
  rùn: ["橍", "润", "潤", "膶", "閏", "閠", "闰"],
  "zhǎn jiǎn": ["橏"],
  shùn: ["橓", "瞚", "瞬", "舜", "蕣", "順", "顺", "鬊"],
  "tuí dūn": ["橔"],
  "táng chēng": ["橖"],
  "sù qiū": ["橚"],
  "tán diàn": ["橝"],
  "fén fèn fèi": ["橨"],
  "rǎn yān": ["橪"],
  "cū chu": ["橻"],
  "shū qiāo": ["橾"],
  "píng bò": ["檘"],
  "zhái shì tú": ["檡"],
  "biǎo biāo": ["檦"],
  "qiān lián": ["檶"],
  "nǐ mí": ["檷"],
  "jiàn kǎn": ["檻"],
  "nòu ruǎn rú": ["檽"],
  "jī jì": ["櫅", "禨"],
  "huǎng guǒ gǔ": ["櫎"],
  "lǜ chū": ["櫖"],
  "miè mèi": ["櫗"],
  ōu: [
    "櫙",
    "欧",
    "歐",
    "殴",
    "毆",
    "瓯",
    "甌",
    "膒",
    "藲",
    "謳",
    "讴",
    "鏂",
    "鴎",
    "鷗",
    "鸥"
  ],
  "zhù zhuó": ["櫡"],
  "jué jì": ["櫭"],
  "huái guī": ["櫰"],
  "chán zhàn": ["欃"],
  "wéi zuì": ["欈"],
  cáng: ["欌", "鑶"],
  "yù yì": ["欥"],
  "chù qù xì": ["欪"],
  "kài ài": ["欬"],
  "yì yīn": ["欭"],
  "xì kài": ["欯"],
  "shuò sòu": ["欶"],
  "ǎi ēi éi ěi èi ê̄ ế ê̌ ề": ["欸"],
  "qī yī": ["欹"],
  "chuā xū": ["欻"],
  "chǐ chuài": ["欼"],
  "kǎn qiàn": ["欿"],
  "kǎn kè": ["歁"],
  "chuǎn chuán": ["歂"],
  "yīn yān": ["歅"],
  "jìn qūn": ["歏"],
  pēn: ["歕"],
  "xū chuā": ["歘"],
  "xī shè": ["歙"],
  "liǎn hān": ["歛"],
  "zhì chí": ["歭"],
  "sè shà": ["歰"],
  sǐ: ["死"],
  "wěn mò": ["歾"],
  piǎo: ["殍", "皫", "瞟", "醥", "顠"],
  "qíng jìng": ["殑"],
  "fǒu bó": ["殕"],
  "zhí shi": ["殖"],
  "yè yān yàn": ["殗"],
  "hūn mèi": ["殙"],
  chòu: ["殠", "臰", "遚"],
  "kuì huì": ["殨", "溃", "潰"],
  cuàn: ["殩", "熶", "爨", "窜", "竄", "篡", "簒"],
  "yīn yān yǐn": ["殷"],
  "qìng kēng shēng": ["殸"],
  "yáo xiáo xiào": ["殽"],
  "gū gǔ": ["毂", "蛄"],
  "guàn wān": ["毌"],
  "dú dài": ["毒"],
  "xún xùn": ["毥"],
  mú: ["毪", "氁"],
  "dòu nuò": ["毭"],
  "sāi suī": ["毸"],
  lu: ["氇"],
  sào: ["氉", "瘙", "矂", "髞"],
  "shì zhī": ["氏"],
  "dī dǐ": ["氐"],
  "máng méng": ["氓"],
  "yáng rì": ["氜"],
  shuǐ: ["水", "氵", "氺", "閖"],
  "zhěng chéng zhèng": ["氶"],
  tǔn: ["氽"],
  "fán fàn": ["氾"],
  "guǐ jiǔ": ["氿"],
  "bīn pà pā": ["汃"],
  "zhuó què": ["汋"],
  "dà tài": ["汏"],
  pìn: ["汖", "牝", "聘"],
  "hàn hán": ["汗", "馯"],
  tu: ["汢"],
  "tāng shāng": ["汤", "湯"],
  "zhī jì": ["汥"],
  "gàn hán cén": ["汵"],
  "wèn mén": ["汶"],
  "fāng pāng": ["汸"],
  "hǔ huǎng": ["汻"],
  "niú yóu": ["汼"],
  hàng: ["沆"],
  "shěn chén": ["沈"],
  "dùn zhuàn": ["沌"],
  "nǜ niǔ": ["沑"],
  "méi mò": ["沒", "没"],
  "tà dá": ["沓"],
  "mì wù": ["沕"],
  "hóng pāng": ["沗"],
  "shā shà": ["沙"],
  "zhuǐ zǐ": ["沝"],
  "ōu òu": ["沤", "漚"],
  "jǔ jù": ["沮"],
  "tuō duó": ["沰"],
  "mǐ lì": ["沵"],
  "yí chí": ["沶"],
  "xiè yì": ["泄"],
  "bó pō": ["泊"],
  "mì bì": ["泌", "秘"],
  "chù shè": ["泏"],
  "yōu yòu āo": ["泑"],
  "pēng píng": ["泙", "硑"],
  "pào pāo": ["泡"],
  "ní nì": ["泥", "秜"],
  "yuè sà": ["泧"],
  "jué xuè": ["泬", "疦"],
  "lóng shuāng": ["泷", "瀧"],
  "luò pō": ["泺", "濼"],
  "zé shì": ["泽", "澤"],
  "sǎ xǐ": ["洒"],
  "sè qì zì": ["洓"],
  "xǐ xiǎn": ["洗"],
  "kǎo kào": ["洘"],
  "àn yàn è": ["洝"],
  "lěi lèi": ["洡"],
  "qiè jié": ["洯"],
  "qiǎn jiān": ["浅"],
  "jì jǐ": ["济", "済", "濟", "纪"],
  "hǔ xǔ": ["浒", "滸"],
  "jùn xùn": ["浚", "濬"],
  "yǐng chéng yíng": ["浧"],
  "liàn lì": ["浰"],
  "féng hóng": ["浲", "溄"],
  "jiǒng jiōng": ["浻"],
  "suī něi": ["浽"],
  "yǒng chōng": ["涌"],
  "tūn yūn": ["涒"],
  "wō guō": ["涡", "渦"],
  hēng: ["涥", "脝"],
  "zhǎng zhàng": ["涨", "漲"],
  "shòu tāo": ["涭"],
  shuàn: ["涮", "腨"],
  "kōng náng": ["涳"],
  "wò wǎn yuān": ["涴"],
  "tuō tuò": ["涶"],
  wō: ["涹", "猧", "窝", "窩", "莴", "萵", "蜗", "蝸", "踒"],
  "qiè jí": ["淁"],
  "guǒ guàn": ["淉"],
  "lín lìn": ["淋", "獜", "疄"],
  "tǎng chǎng": ["淌"],
  "nào chuò zhuō": ["淖"],
  "péng píng": ["淜"],
  féi: ["淝", "肥", "腓", "蜰"],
  "pì pèi": ["淠"],
  "niǎn shěn": ["淰"],
  "biāo hǔ": ["淲"],
  "chún zhūn": ["淳"],
  "hùn hún": ["混"],
  qiǎn: ["淺", "繾", "缱", "肷", "膁", "蜸", "譴", "谴", "遣", "鑓"],
  "wèn mín": ["渂"],
  "rè ruò luò": ["渃"],
  "dú dòu": ["渎", "瀆", "读"],
  "jiàn jiān": ["渐", "溅", "漸", "濺"],
  "miǎn shéng": ["渑", "澠"],
  "nuǎn nuán": ["渜"],
  "qiú wù": ["渞"],
  "tíng tīng": ["渟"],
  "dì tí dī": ["渧"],
  "gǎng jiǎng": ["港"],
  "hōng qìng": ["渹"],
  tuān: ["湍", "煓"],
  "huì mǐn xū": ["湏"],
  "xǔ xù": ["湑"],
  pén: ["湓", "瓫", "盆", "葐"],
  "mǐn hūn": ["湣"],
  "tuàn nuǎn": ["湪"],
  "qiū jiǎo": ["湫", "湬"],
  "yān yīn": ["湮"],
  "bàn pán": ["湴"],
  "zhuāng hún": ["湷"],
  "yàn guì": ["溎"],
  "lián liǎn nián xián xiàn": ["溓"],
  "dá tǎ": ["溚", "鿎"],
  "liū liù": ["溜", "澑", "蹓"],
  lùn: ["溣"],
  mǎ: [
    "溤",
    "犸",
    "獁",
    "玛",
    "瑪",
    "码",
    "碼",
    "遤",
    "鎷",
    "馬",
    "马",
    "鰢",
    "鷌"
  ],
  "zhēn qín": ["溱"],
  "nì niào": ["溺"],
  "chù xù": ["滀", "畜"],
  "wěng wēng": ["滃"],
  "hào xuè": ["滈"],
  "qì xì xiē": ["滊"],
  "xíng yíng": ["滎"],
  "zé hào": ["滜"],
  "piāo piào piǎo": ["漂"],
  "cóng sǒng": ["漎"],
  "féng péng": ["漨"],
  "luò tà": ["漯"],
  "pēng bēn": ["漰"],
  "chóng shuāng": ["漴"],
  "huǒ kuò huò": ["漷"],
  "liáo liú": ["漻"],
  "cuǐ cuī": ["漼"],
  "cóng zǒng": ["潀"],
  "cóng zōng": ["潈"],
  "pì piē": ["潎"],
  "dàng xiàng": ["潒"],
  "huáng guāng": ["潢"],
  "liáo lào lǎo": ["潦"],
  "cōng zòng": ["潨"],
  "zhí zhì": ["潪"],
  "tān shàn": ["潬"],
  "tú zhā": ["潳"],
  "sàn sǎ": ["潵"],
  hēi: ["潶", "黑", "黒", "𬭶"],
  "chéng dèng": ["澄", "瀓"],
  "cūn cún": ["澊"],
  "péng pēng": ["澎"],
  "hòng gǒng": ["澒", "銾"],
  "wàn màn": ["澫"],
  "kuài huì": ["澮"],
  "guō wō": ["濄"],
  "pēn fén": ["濆"],
  "jí shà": ["濈"],
  "huì huò": ["濊"],
  "dǐng tìng": ["濎"],
  "mǐ nǐ": ["濔"],
  "bì pì": ["濞"],
  "cuì zuǐ": ["濢"],
  "hù huò": ["濩"],
  "ǎi kài kè": ["濭"],
  "wěi duì": ["濻", "瀢"],
  "zàn cuán": ["濽", "灒"],
  "yǎng yàng": ["瀁"],
  "wǎng wāng": ["瀇"],
  "mò miè": ["瀎", "眜"],
  suǐ: ["瀡", "膸", "髓"],
  "huái wāi": ["瀤"],
  "zùn jiàn": ["瀳"],
  "yīng yǐng yìng": ["瀴"],
  "ráng ràng": ["瀼"],
  shuàng: ["灀"],
  "zhuó jiào zé": ["灂"],
  sǎ: ["灑", "訯", "靸"],
  "luán luàn": ["灓"],
  "dǎng tǎng": ["灙"],
  "xún quán quàn": ["灥"],
  "huǒ biāo": ["灬"],
  "zhà yù": ["灹"],
  "fén bèn": ["炃"],
  "jiǒng guì": ["炅"],
  "pàng fēng": ["炐"],
  quē: ["炔", "缺", "缼", "蒛"],
  biān: [
    "炞",
    "煸",
    "甂",
    "砭",
    "笾",
    "箯",
    "籩",
    "編",
    "编",
    "蝙",
    "邉",
    "邊",
    "鍽",
    "鞭",
    "鯾",
    "鯿",
    "鳊"
  ],
  "zhāo zhào": ["炤"],
  "zhuō chù": ["炪"],
  "pào páo bāo": ["炮"],
  "páo fǒu": ["炰"],
  "shǎn qián shān": ["炶"],
  "zhà zhá": ["炸"],
  "jiǎo yào": ["烄"],
  quǎn: ["烇", "犬", "犭", "畎", "綣", "绻", "虇"],
  "yàng yáng": ["烊"],
  "lào luò": ["烙"],
  "huí huǐ": ["烠"],
  rè: ["热", "熱"],
  "fú páo": ["烰"],
  "xiè chè": ["烲", "焎"],
  "yàn shān": ["烻"],
  "hūn xūn": ["焄"],
  kào: ["焅", "犒", "銬", "铐", "靠", "鮳", "鯌", "鲓", "㸆"],
  "juān yè": ["焆"],
  "jùn qū": ["焌"],
  "tāo dào": ["焘"],
  "chǎo jù": ["焣"],
  "wò ài": ["焥"],
  "zǒng cōng": ["焧"],
  "xī yì": ["焬"],
  "xìn xīn": ["焮"],
  "chāo zhuō": ["焯"],
  "xiǒng yīng": ["焸", "焽"],
  kuǐ: ["煃", "跬", "蹞", "頍", "𫠆"],
  "huī yùn xūn": ["煇"],
  "jiǎo qiāo": ["煍"],
  "qián shǎn shān": ["煔"],
  "xī yí": ["煕"],
  "shà shā": ["煞"],
  "yè zhá": ["煠"],
  "yáng yàng": ["煬"],
  "ēn yūn": ["煾"],
  "yūn yǔn": ["熅"],
  "hè xiāo": ["熇"],
  xióng: ["熊", "熋", "雄"],
  "xūn xùn": ["熏", "爋"],
  gòng: ["熕", "貢", "贡"],
  liū: ["熘"],
  "cōng zǒng": ["熜"],
  "lù āo": ["熝"],
  "shú shóu": ["熟"],
  "fēng péng": ["熢"],
  "cuǐ suī": ["熣"],
  tēng: ["熥", "膯", "鼟"],
  "yùn yù": ["熨"],
  "áo āo": ["熬"],
  "hàn rǎn": ["熯"],
  "ōu ǒu": ["熰"],
  "huáng huǎng": ["熿"],
  "chǎn dǎn chàn": ["燀"],
  "jiāo zhuó qiáo jué": ["燋"],
  "yàn yān": ["燕"],
  "tài liè": ["燤"],
  āo: ["爊"],
  "yàn xún": ["爓"],
  "jué jiào": ["爝", "覐", "覚", "覺", "觉"],
  "lǎn làn": ["爦"],
  "zhuǎ zhǎo": ["爪"],
  "zhǎo zhuǎ": ["爫"],
  "fù fǔ": ["父"],
  diē: ["爹", "褺", "跌"],
  zāng: ["牂", "羘", "臧", "賍", "賘", "贓", "贜", "赃", "髒"],
  "piàn piān": ["片"],
  "biān miàn": ["牑"],
  bǎng: ["牓", "綁", "绑"],
  "yǒu yōng": ["牗"],
  "chēng chèng": ["牚", "竀"],
  niú: ["牛", "牜"],
  "jiū lè": ["牞"],
  "mù móu": ["牟"],
  māng: ["牤"],
  "gē qiú": ["牫"],
  "yòu chōu": ["牰"],
  "tè zhí": ["犆"],
  bēn: ["犇", "錛", "锛"],
  "jiān qián": ["犍", "玪"],
  má: ["犘", "痲", "蔴", "蟇", "麻"],
  "máo lí": ["犛"],
  "bá quǎn": ["犮"],
  "zhuó bào": ["犳"],
  "àn hān": ["犴"],
  "kàng gǎng": ["犺"],
  "pèi fèi": ["犻"],
  "fān huān": ["犿"],
  kuáng: ["狂", "狅", "誑", "诳", "軖", "軠", "鵟", "𫛭"],
  "yí quán chí": ["狋"],
  "xīng shēng": ["狌"],
  "tuó yí": ["狏"],
  kǔ: ["狜", "苦"],
  "huán huān": ["狟"],
  "hé mò": ["狢"],
  "tà shì": ["狧"],
  "máng dòu": ["狵"],
  "xī shǐ": ["狶"],
  suān: ["狻", "痠", "酸"],
  "bài pí": ["猈"],
  "jiān yàn": ["猏", "豣"],
  "yī yǐ": ["猗"],
  "yá wèi": ["猚"],
  cāi: ["猜"],
  "māo máo": ["猫", "貓"],
  "chuàn chuān": ["猭"],
  "tuān tuàn": ["猯", "貒"],
  "yà jiá qiè": ["猰"],
  "hè xiē gé hài": ["猲"],
  "biān piàn": ["猵", "獱"],
  "bó pò": ["猼"],
  "háo gāo": ["獋"],
  "fén fèn": ["獖"],
  "yào xiāo": ["獟"],
  "shuò xī": ["獡"],
  "gé liè xiē": ["獦"],
  "nòu rú": ["獳"],
  "náo nǎo yōu": ["獶"],
  ráng: ["獽", "瓤", "禳", "穣", "穰", "蘘", "躟", "鬤"],
  "náo yōu": ["獿"],
  "lǜ shuài": ["率"],
  "wáng wàng": ["王"],
  "yáng chàng": ["玚"],
  "mín wén": ["玟"],
  "bīn fēn": ["玢"],
  "mén yǔn": ["玧"],
  "qiāng cāng": ["玱", "瑲", "篬"],
  "án gān": ["玵"],
  "xuán xián": ["玹"],
  "cī cǐ": ["玼", "跐"],
  "yí tāi": ["珆"],
  "zǔ jù": ["珇"],
  fà: ["珐", "琺", "蕟", "髪", "髮"],
  "yín kèn": ["珢"],
  "huī hún": ["珲"],
  "xuán qióng": ["琁"],
  "fú fū": ["琈"],
  "bǐng pín": ["琕"],
  "cuì sè": ["琗"],
  "yù wéi": ["琟"],
  "tiǎn tiàn": ["琠"],
  "zhuó zuó": ["琢"],
  "běng pěi": ["琣"],
  guǎn: ["琯", "璭", "痯", "筦", "管", "舘", "輨", "錧", "館", "馆", "鳤"],
  "hún huī": ["琿"],
  "xié jiē": ["瑎"],
  "chàng dàng yáng": ["瑒"],
  "tiàn zhèn": ["瑱"],
  "bīn pián": ["瑸", "璸"],
  "tú shū": ["瑹"],
  cuǐ: ["璀", "皠", "趡"],
  "zǎo suǒ": ["璅"],
  "jué qióng": ["璚"],
  "lú fū": ["璷"],
  "jì zī": ["璾"],
  suí: ["瓍", "綏", "绥", "遀", "随", "隨", "髄"],
  "mí xǐ": ["瓕"],
  "qióng wěi wèi": ["瓗"],
  "huán yè yà": ["瓛"],
  "bó páo": ["瓟"],
  "zhí hú": ["瓡"],
  piáo: ["瓢", "闝"],
  "wǎ wà": ["瓦"],
  "xiáng hóng": ["瓨"],
  wèng: ["瓮", "甕", "罋", "蕹", "齆"],
  "shèn shén": ["甚"],
  ruí: ["甤", "緌", "蕤"],
  yòng: ["用", "砽", "苚", "蒏", "醟", "㶲"],
  shuǎi: ["甩"],
  béng: ["甭", "甮"],
  "yóu zhá": ["甴"],
  "diàn tián shèng": ["甸"],
  "tǐng dīng": ["町", "甼"],
  "zāi zī": ["甾"],
  "bì qí": ["畁"],
  "dá fú": ["畗"],
  "cè jì": ["畟"],
  "zāi zī tián": ["畠"],
  "zhì chóu shì": ["畤"],
  "fān pān": ["畨", "番"],
  "shē yú": ["畬"],
  "dāng dàng dǎng": ["當"],
  "jiāng qiáng": ["疆"],
  "pǐ yǎ shū": ["疋"],
  "jié qiè": ["疌"],
  "yí nǐ": ["疑"],
  nè: ["疒", "眲", "訥", "讷"],
  "gē yì": ["疙"],
  "nüè yào": ["疟", "瘧"],
  "lì lài": ["疠", "癘"],
  "yǎ xiā": ["疨"],
  xuē: ["疶", "蒆", "薛", "辥", "辪", "靴", "鞾"],
  "dǎn da": ["疸"],
  "fá biǎn": ["疺"],
  "fèi féi": ["疿", "痱"],
  "shān diàn": ["痁"],
  "téng chóng": ["痋"],
  "tōng tóng": ["痌"],
  "wěi yòu yù": ["痏"],
  "tān shǐ": ["痑"],
  "pū pù": ["痡", "鋪"],
  "bēng péng": ["痭"],
  "má lìn": ["痳"],
  "tiǎn diàn": ["痶"],
  "ān yè è": ["痷"],
  "kē ē": ["痾"],
  "zhì chì": ["瘈"],
  "jiǎ xiá xiā": ["瘕"],
  "lěi huì": ["瘣"],
  "chài cuó": ["瘥"],
  "diān chēn": ["瘨"],
  "da dá": ["瘩"],
  "biě biē": ["瘪"],
  qué: ["瘸"],
  "dàn dān": ["癉"],
  "guì wēi": ["癐"],
  "nòng nóng": ["癑"],
  "biē biě": ["癟"],
  "bō bǒ": ["癷"],
  bái: ["白"],
  "jí bī": ["皀"],
  "de dì dí dī": ["的"],
  "pā bà": ["皅"],
  "gāo háo": ["皋"],
  "gāo yáo": ["皐"],
  "lì luò bō": ["皪"],
  "zhā cǔ": ["皻"],
  "zhāo zhǎn dǎn": ["皽"],
  "jiān jiàn": ["监", "監", "鋻", "间", "鞬"],
  "gài gě hé": ["盖"],
  "máng wàng": ["盳"],
  yuǎn: ["盶", "逺", "遠"],
  "tián xián": ["盷"],
  "xiāng xiàng": ["相"],
  dǔn: ["盹", "趸", "躉"],
  "xì pǎn": ["盻"],
  "shěng xǐng": ["省"],
  "yún hùn": ["眃"],
  "miǎn miàn": ["眄"],
  "kàn kān": ["看"],
  "yìng yāng yǎng": ["眏"],
  "yǎo āo ǎo": ["眑"],
  "jū xū kōu": ["眗"],
  "yí chì": ["眙"],
  "dié tì": ["眣"],
  "bǐng fǎng": ["眪"],
  "pàng pán": ["眫"],
  "mī mí": ["眯", "瞇"],
  "xuàn shùn xún": ["眴"],
  tiào: ["眺", "粜", "糶", "覜", "趒"],
  "zhe zhuó zháo zhāo": ["着"],
  "qiáo shào xiāo": ["睄"],
  "cuó zhuài": ["睉"],
  gùn: ["睔", "謴"],
  "suì zuì": ["睟"],
  "pì bì": ["睥", "稫", "辟"],
  "yì zé gāo": ["睪"],
  "xǐng xìng": ["睲"],
  "guì wèi kuì": ["瞆"],
  "kòu jì": ["瞉"],
  "qióng huán": ["瞏"],
  "mán mén": ["瞒", "瞞"],
  "diāo dōu": ["瞗"],
  "lou lóu lǘ": ["瞜"],
  "shùn rún": ["瞤"],
  "liào liǎo": ["瞭", "钌"],
  "jiàn xián": ["瞯"],
  "wǔ mí": ["瞴"],
  "guì kuì": ["瞶"],
  "nǐng chēng": ["矃"],
  "huò yuè": ["矆"],
  "mēng méng": ["矇"],
  "kuàng guō": ["矌"],
  "guàn quán": ["矔"],
  "mǎn mán": ["矕"],
  "jīn guān qín": ["矜"],
  "jīn qín guān": ["矝"],
  "yù xù jué": ["矞"],
  "jiǎo jiáo": ["矫", "矯"],
  duǎn: ["短"],
  "shí dàn": ["石"],
  "gāng qiāng kòng": ["矼"],
  "huā xū": ["砉"],
  "pīn bīn fēn": ["砏"],
  "yán yàn": ["研", "硏"],
  "luǒ kē": ["砢"],
  "fú fèi": ["砩", "笰"],
  "zhǔ zhù": ["砫"],
  "lá lì lā": ["砬"],
  "kuāng guāng": ["硄"],
  "gè luò": ["硌"],
  "shuò shí": ["硕", "碩"],
  "wèi wéi ái": ["硙"],
  "què kè kù": ["硞"],
  "mǎng bàng": ["硥"],
  "luò lòng": ["硦"],
  "yǒng tóng": ["硧"],
  nüè: ["硸", "虐"],
  "kēng kěng": ["硻"],
  "yān yǎn": ["硽"],
  "zhuì chuí duǒ": ["硾"],
  "kōng kòng": ["硿"],
  "zòng cóng": ["碂"],
  "jiān zhàn": ["碊"],
  "lù liù": ["碌", "陆"],
  "què xī": ["碏"],
  "lún lǔn lùn": ["碖"],
  "náo gāng": ["碙"],
  "jié yà": ["碣"],
  "wèi wěi": ["碨"],
  "tí dī": ["碮"],
  "chá chā": ["碴"],
  "qiāo què": ["碻"],
  "sù xiè": ["碿"],
  "liú liù": ["磂", "遛", "鎦", "馏"],
  "sī tí": ["磃"],
  "bàng páng": ["磅"],
  "huá kě gū": ["磆"],
  "wěi kuǐ": ["磈"],
  "xiá qià yà": ["磍"],
  "lián qiān": ["磏"],
  "wèi ái gài": ["磑"],
  "lá lā": ["磖"],
  "áo qiāo": ["磝"],
  "pēng pèng": ["磞", "閛"],
  "yīn yǐn": ["磤"],
  "lěi léi": ["磥"],
  "mó mò": ["磨"],
  "qì zhú": ["磩"],
  "láo luò": ["磱"],
  "pán bō": ["磻"],
  "jí shé": ["磼"],
  "hé qiāo qiào": ["礉"],
  "kè huò": ["礊"],
  "què hú": ["礐"],
  "è qì": ["礘"],
  cǎ: ["礤", "礸"],
  "xián xín": ["礥"],
  "léi lěi lèi": ["礧"],
  "yán yǎn": ["礹"],
  "qí zhǐ": ["祇", "蚔"],
  "bēng fāng": ["祊"],
  "bì mì": ["祕"],
  suàn: ["祘", "笇", "筭", "算", "蒜"],
  "piào piāo": ["票"],
  "jì zhài": ["祭"],
  "shuì lèi": ["祱"],
  "jìn jīn": ["禁"],
  "chán shàn": ["禅"],
  "yáng shāng": ["禓"],
  "zhī zhǐ tí": ["禔"],
  "shàn chán": ["禪"],
  "yú yù ǒu": ["禺"],
  "zǐ zì": ["秄"],
  "chá ná": ["秅"],
  "zhǒng zhòng chóng": ["种"],
  "hào mào": ["秏"],
  "kù kū": ["秙"],
  zū: ["租", "葅"],
  chèng: ["秤", "穪"],
  "huó kuò": ["秮", "秳"],
  "chēng chèn chèng": ["称", "稱"],
  "shì zhì": ["秲", "銴"],
  "fù pū": ["秿"],
  "xùn zè": ["稄"],
  "tú shǔ": ["稌"],
  "zhùn zhǔn": ["稕"],
  "jī qí": ["稘", "綨", "觭"],
  "léng líng": ["稜"],
  "zuì zú sū": ["稡"],
  "xì qiè": ["稧", "郄"],
  "zhǒng zhòng": ["種"],
  "zōng zǒng": ["稯"],
  "xián jiān liàn": ["稴"],
  "zī jiū": ["稵"],
  "jī qǐ": ["稽"],
  ròng: ["穃"],
  "shān cǎn cēn": ["穇"],
  "mén méi": ["穈"],
  "jǐ jì": ["穖"],
  "xiāo rào": ["穘"],
  "zhuō bó": ["穛"],
  "tóng zhǒng zhòng": ["穜"],
  zuō: ["穝"],
  "biāo pāo": ["穮", "藨"],
  "zhuō jué": ["穱"],
  "cuán zàn": ["穳"],
  "kōng kòng kǒng": ["空"],
  "yū yǔ": ["穻"],
  zhǎi: ["窄", "鉙"],
  báo: ["窇", "雹"],
  "kū zhú": ["窋"],
  "jiào liáo liù": ["窌"],
  "wā guī": ["窐"],
  "tiǎo yáo": ["窕"],
  "xūn yìn": ["窨"],
  "yà yē": ["窫"],
  "tián diān yǎn": ["窴"],
  "chāo kē": ["窼"],
  "kuǎn cuàn": ["窽", "窾"],
  "chù qì": ["竐"],
  "qǔ kǒu": ["竘"],
  "jìng zhěn": ["竧"],
  "kǎn kàn": ["竷"],
  "zhú dǔ": ["竺"],
  "lè jīn": ["竻"],
  "zhuì ruì": ["笍"],
  "háng hàng": ["笐"],
  "cén jìn hán": ["笒"],
  "dā xiá nà": ["笚"],
  "zé zuó": ["笮"],
  "lóng lǒng": ["笼", "篭", "籠", "躘", "龓"],
  "zhù zhú": ["筑", "築"],
  "dá dā": ["答", "荅"],
  shāi: ["筛", "篩", "簁", "籭"],
  "yún jūn": ["筠"],
  "láng làng": ["筤", "郎", "阆"],
  "zhì zhǐ": ["筫"],
  o: ["筽"],
  "póu bù fú pú": ["箁"],
  "pái bēi": ["箄"],
  gè: ["箇", "虼", "鉻", "铬"],
  "tái chí": ["箈"],
  "guǎi dài": ["箉"],
  "zhào dào": ["箌"],
  "jīng qìng": ["箐"],
  "lín lǐn": ["箖"],
  "jùn qūn": ["箘"],
  "shī yí": ["箷", "釶"],
  "yuē yào chuò": ["箹"],
  "xiāo shuò qiào": ["箾"],
  "gōng gǎn lǒng": ["篢"],
  "páng péng": ["篣"],
  "zhuó huò": ["篧"],
  "jiǎn jiān": ["篯"],
  "dí zhú": ["篴"],
  "zān cēn cǎn": ["篸"],
  "zhuàn suǎn zuàn": ["篹"],
  "piǎo biāo": ["篻"],
  "guó guì": ["簂"],
  "cè jí": ["簎"],
  "mì miè": ["簚"],
  "shāi sī": ["簛"],
  "sǔn zhuàn": ["簨"],
  "gàn gǎn": ["簳"],
  "bò bǒ": ["簸"],
  "bó bù": ["簿"],
  shi: ["籂"],
  "zhēn jiān": ["籈"],
  "zhuàn zuǎn": ["籑"],
  "fān pān biān": ["籓"],
  "sǒu shǔ": ["籔"],
  zuǎn: ["籫", "繤", "纂", "纉", "纘", "缵"],
  nǚ: ["籹", "釹", "钕"],
  "shā chǎo": ["粆"],
  "kāng jīng": ["粇"],
  fěn: ["粉", "黺"],
  cū: ["粗", "觕", "麁", "麄", "麤"],
  "nián zhān": ["粘"],
  "cè sè": ["粣"],
  "zhōu yù": ["粥"],
  "shēn sǎn": ["糁"],
  "biān biǎn": ["糄", "萹"],
  miàn: ["糆", "面", "靣", "麪", "麫", "麵", "麺"],
  "hú hū hù": ["糊"],
  "gǔ gòu": ["糓"],
  "mí méi": ["糜"],
  "sǎn shēn": ["糝", "糣"],
  zāo: ["糟", "蹧", "遭", "醩"],
  "mì sī": ["糸"],
  "jiū jiǔ": ["糺"],
  "xì jì": ["系", "繫"],
  "zhēng zhěng": ["糽"],
  "chà chǎ": ["紁", "衩"],
  "yuē yāo": ["約", "约"],
  "hóng gōng": ["紅", "红"],
  "hé gē": ["紇", "纥"],
  "wén wèn": ["紋", "纹"],
  fóu: ["紑"],
  "jì jié jiè": ["紒"],
  "pī pí bǐ": ["紕", "纰"],
  "jīn jìn": ["紟"],
  "zhā zā": ["紥", "紮"],
  hā: ["紦"],
  "fū fù": ["紨"],
  "chōu chóu": ["紬"],
  "lèi léi lěi": ["累"],
  "bō bì": ["紴"],
  "tiǎn zhěn": ["紾"],
  "jiōng jiǒng": ["絅"],
  "jié jiē": ["結", "结", "节"],
  "guà kuā": ["絓"],
  "bǎi mò": ["絔"],
  "gēng huán": ["絙"],
  "jié xié": ["絜"],
  "quán shuān": ["絟"],
  "gǎi ǎi": ["絠"],
  "luò lào": ["絡", "络"],
  "bīng bēng pēng": ["絣"],
  "gěi jǐ": ["給", "给"],
  "tóng tōng dòng": ["絧"],
  "tiào diào dào": ["絩"],
  "lěi lèi léi": ["絫"],
  "gāi hài": ["絯"],
  "chī zhǐ": ["絺"],
  "wèn miǎn mán wàn": ["絻"],
  "huán huàn wàn": ["綄"],
  "qīn xiān": ["綅"],
  "tì tí": ["綈"],
  "yán xiàn": ["綖"],
  "zōng zèng zòng": ["綜"],
  "chēn lín": ["綝"],
  "zhǔn zhùn": ["綧"],
  "qiàn qīng zhēng": ["綪"],
  "qìng qǐ": ["綮"],
  "lún guān": ["綸", "纶"],
  "chuò chāo": ["綽", "绰"],
  "tián tǎn chān": ["緂"],
  "lǜ lù": ["緑", "绿"],
  "ruǎn ruàn": ["緛"],
  "jí qī": ["緝"],
  "zhòng chóng": ["緟", "重"],
  "miáo máo": ["緢"],
  "xiè yè": ["緤"],
  huǎn: ["緩", "缓", "㬊"],
  "gēng gèng": ["緪", "縆"],
  "tōu xū shū": ["緰"],
  "zōng zòng": ["緵", "繌"],
  "yùn gǔn": ["緷"],
  "guā wō": ["緺"],
  "yùn yūn wēn": ["緼", "縕"],
  "bāng bàng": ["縍"],
  "gǔ hú": ["縎", "鶻"],
  "cī cuò suǒ": ["縒"],
  "cuī shuāi": ["縗"],
  "róng rǒng ròng": ["縙"],
  "zài zēng": ["縡"],
  cài: ["縩", "菜", "蔡"],
  "féng fèng": ["縫"],
  "suō sù": ["縮", "缩"],
  "yǎn yǐn": ["縯", "酓"],
  "zòng zǒng": ["縱", "纵"],
  "zhuàn juàn": ["縳"],
  "mò mù": ["縸", "莫"],
  "piǎo piāo": ["縹", "缥"],
  "fán pó": ["繁"],
  "bēng bèng": ["繃"],
  "móu miù miào liǎo": ["繆"],
  "yáo yóu zhòu": ["繇"],
  "zēng zèng": ["繒", "缯"],
  "jú jué": ["繘"],
  "chuō chuò": ["繛"],
  "zūn zǔn": ["繜"],
  rào: ["繞", "绕", "遶"],
  "chǎn chán": ["繟"],
  "huì huí": ["繢", "缋", "藱"],
  "qiāo sāo zǎo": ["繰"],
  "jiǎo zhuó": ["繳", "缴"],
  "dàn tán chán": ["繵"],
  nǒng: ["繷"],
  "pú fú": ["纀"],
  "yào lì": ["纅"],
  "rǎng xiāng": ["纕"],
  "lí sǎ xǐ lǐ": ["纚"],
  "xiān qiàn": ["纤"],
  "jīng jìng": ["经"],
  "tí tì": ["绨"],
  "bēng běng bèng": ["绷"],
  "zōng zèng": ["综"],
  "jī qī": ["缉"],
  "wēn yùn yūn": ["缊"],
  "fèng féng": ["缝"],
  "shuāi cuī suī": ["缞"],
  "miù móu liáo miào mù": ["缪"],
  "qiāo sāo": ["缲"],
  fǒu: ["缶", "缹", "缻", "雬", "鴀"],
  "bà ba pí": ["罢", "罷"],
  "guà guǎi": ["罫"],
  "yáng xiáng": ["羊", "羏"],
  "měi gāo": ["羙"],
  "yì xī": ["羛"],
  "qiǎng qiān": ["羟"],
  "qiāng kòng": ["羫"],
  "qián xián yán": ["羬"],
  nóu: ["羺"],
  "hóng gòng": ["羾"],
  "pī bì pō": ["翍"],
  "qú yù": ["翑"],
  ké: ["翗"],
  "qiào qiáo": ["翘"],
  "zhái dí": ["翟"],
  "dào zhōu": ["翢"],
  "hóu qú": ["翵"],
  shuǎ: ["耍"],
  "ruǎn nuò": ["耎"],
  "ér nài": ["耏"],
  "zhuān duān": ["耑"],
  "pá bà": ["耙"],
  "chí sì": ["耛"],
  "qù chú": ["耝"],
  "lún lǔn": ["耣"],
  "jí jiè": ["耤"],
  "tāng tǎng": ["耥"],
  pǎng: ["耪", "覫"],
  "zhá zé": ["耫"],
  "yē yé": ["耶"],
  "yún yíng": ["耺"],
  "wà tuǐ zhuó": ["聉"],
  "ér nǜ": ["聏"],
  "tiē zhé": ["聑"],
  "dǐ zhì": ["聜"],
  qié: ["聺"],
  "nǐ jiàn": ["聻"],
  "lèi lē": ["肋"],
  cào: ["肏", "襙", "鄵", "鼜"],
  "bó dí": ["肑"],
  "xiào xiāo": ["肖"],
  "dù dǔ": ["肚"],
  chāi: ["肞", "釵", "钗"],
  "hán qín hàn": ["肣"],
  "pàng pán pàn": ["肨", "胖"],
  "zhūn chún": ["肫"],
  āng: ["肮", "骯"],
  "yù yō": ["育"],
  "pí bǐ bì": ["肶"],
  "fèi bì": ["胇"],
  "bèi bēi": ["背"],
  "fèi zǐ": ["胏"],
  "píng pēng": ["胓", "苹"],
  "fū fú zhǒu": ["胕"],
  "shèng shēng": ["胜"],
  kuà: ["胯", "跨", "骻"],
  "gǎi hǎi": ["胲"],
  "gē gé gā": ["胳"],
  "néng nài": ["能"],
  "guī kuì": ["胿"],
  "mài mò": ["脉"],
  "zāng zàng": ["脏"],
  "jiǎo jué": ["脚", "角"],
  cuǒ: ["脞"],
  "de te": ["脦"],
  "zuī juān": ["脧"],
  něi: ["脮", "腇", "餒", "馁", "鮾", "鯘"],
  "pú fǔ": ["脯"],
  niào: ["脲"],
  shuí: ["脽"],
  guò: ["腂", "過", "鐹"],
  "là xī": ["腊"],
  "yān ā": ["腌"],
  "gāo gào": ["膏"],
  "lù biāo": ["膔"],
  chuái: ["膗"],
  "zhuān chuán chún zhuǎn": ["膞"],
  chuài: ["膪", "踹"],
  "fán pán": ["膰"],
  "wǔ hū": ["膴"],
  "shān dàn": ["膻"],
  tún: ["臀", "臋", "蛌", "豘", "豚", "軘", "霕", "飩", "饨", "魨", "鲀", "黗"],
  "bì bei": ["臂"],
  "là gé": ["臈"],
  "sào sāo": ["臊"],
  nào: ["臑", "閙", "闹", "鬧"],
  "ní luán": ["臡"],
  "qiān xián": ["臤"],
  "guàng jiǒng": ["臦"],
  "guǎng jiǒng": ["臩"],
  "chòu xiù": ["臭"],
  "mián biān": ["臱"],
  "dié zhí": ["臷"],
  "zhī jìn": ["臸"],
  "shè shě": ["舍"],
  pù: ["舖", "舗"],
  "bān bō pán": ["般"],
  kuā: ["舿"],
  "gèn gěn": ["艮"],
  "sè shǎi": ["色"],
  "fú bó": ["艴"],
  "jiāo qiú": ["艽"],
  "chāi chā": ["芆"],
  "sháo què": ["芍"],
  "hù xià": ["芐"],
  "zì zǐ": ["芓"],
  "huì hū": ["芔"],
  "tún chūn": ["芚"],
  "jiè gài": ["芥"],
  "xù zhù": ["芧"],
  "yuán yán": ["芫"],
  "xīn xìn": ["芯"],
  "lún huā": ["芲"],
  "wù hū": ["芴"],
  "gōu gǒu": ["芶"],
  "mào máo": ["芼"],
  "fèi fú": ["芾"],
  "chán yín": ["苂"],
  qiē: ["苆"],
  "sū sù": ["苏"],
  "tiáo sháo": ["苕"],
  "lì jī": ["苙"],
  "kē hē": ["苛"],
  "jù qǔ": ["苣"],
  "ruò rě": ["若"],
  "zhù níng": ["苧"],
  "pā bó": ["苩"],
  xiú: ["苬"],
  "zhǎ zuó": ["苲"],
  "jū chá": ["苴"],
  nié: ["苶"],
  "shēng ruí": ["苼"],
  "qié jiā": ["茄"],
  "zǐ cí": ["茈"],
  "qiàn xī": ["茜"],
  chǎi: ["茝"],
  "fá pèi": ["茷"],
  ráo: ["荛", "蕘", "襓", "饒", "饶"],
  "yíng xíng": ["荥"],
  "qián xún": ["荨", "蕁"],
  "yìn yīn": ["荫"],
  "hé hè": ["荷"],
  "shā suō": ["莎"],
  "péng fēng": ["莑"],
  "shēn xīn": ["莘"],
  "wǎn guān guǎn": ["莞"],
  "yóu sù": ["莤"],
  "shāo xiāo": ["莦", "蛸"],
  "làng liáng": ["莨"],
  "piǎo fú": ["莩"],
  "wèn wǎn miǎn": ["莬"],
  "shì shí": ["莳", "蒔"],
  "tù tú": ["莵"],
  "xiān liǎn": ["莶", "薟"],
  "wǎn yù": ["菀"],
  "zōu chù": ["菆"],
  "lù lǜ": ["菉"],
  "jūn jùn": ["菌"],
  "niè rěn": ["菍"],
  "zī zì zāi": ["菑"],
  "tú tù": ["菟"],
  "jiē shà": ["菨"],
  "qiáo zhǎo": ["菬"],
  "tái zhī chí": ["菭"],
  "fēi fěi": ["菲", "蜚"],
  "qín qīn jīn": ["菳"],
  "zū jù": ["菹", "蒩"],
  "lǐn má": ["菻"],
  "tián tiàn": ["菾"],
  tiē: ["萜", "貼", "贴"],
  "luò là lào luō": ["落"],
  "zhù zhuó zhe": ["著"],
  "shèn rèn": ["葚"],
  "gě gé": ["葛"],
  "jùn suǒ": ["葰"],
  "kuì kuài": ["蒉"],
  "rú ná": ["蒘"],
  "méng mēng měng": ["蒙"],
  "yuán huán": ["蒝"],
  "xú shú": ["蒣"],
  "xí xì": ["蒵"],
  "mì míng": ["蓂"],
  "sōu sǒu": ["蓃"],
  "gài gě hé hài": ["蓋"],
  "yǎo zhuó": ["蓔"],
  "diào tiáo dí": ["蓧"],
  "xū qiū fū": ["蓲"],
  "zí jú": ["蓻"],
  "liǎo lù": ["蓼"],
  xu: ["蓿"],
  "hàn hǎn": ["蔊"],
  "màn wàn mán": ["蔓"],
  "pó bò": ["蔢"],
  "fān fán bō": ["蕃"],
  "hóng hòng": ["蕻"],
  "yù ào": ["薁", "隩"],
  "xí xiào": ["薂"],
  "báo bó bò": ["薄"],
  "cí zī": ["薋"],
  "wàn luàn": ["薍"],
  "kǎo hāo": ["薧"],
  "yuǎn wěi": ["薳"],
  "zhòu chóu": ["薵"],
  "wō mái": ["薶"],
  "xiāo hào": ["藃"],
  "yù xù xū": ["藇"],
  "jiè jí": ["藉"],
  "diào zhuó": ["藋"],
  "cáng zàng": ["藏"],
  lǎ: ["藞"],
  "chú zhū": ["藸"],
  "pín píng": ["蘋"],
  "gān hán": ["虷"],
  "hóng jiàng": ["虹"],
  "huī huǐ": ["虺"],
  "xiā há": ["虾"],
  "mǎ mà mā": ["蚂"],
  "fāng bàng": ["蚄"],
  "bàng bèng": ["蚌"],
  "jué quē": ["蚗"],
  "qín qián": ["蚙"],
  "gōng zhōng": ["蚣"],
  "fǔ fù": ["蚥"],
  "dài dé": ["蚮"],
  "gǒu qú xù": ["蚼"],
  "bǒ pí": ["蚾"],
  "shé yí": ["蛇"],
  tiě: ["蛈", "鉄", "銕", "鐡", "鐵", "铁", "驖"],
  "gé luò": ["蛒"],
  "máng bàng": ["蛖"],
  "yì xǔ": ["蛡"],
  "há gé": ["蛤"],
  "qiè ní": ["蛪"],
  "é yǐ": ["蛾"],
  "zhē zhé": ["蜇"],
  "là zhà": ["蜡"],
  suò: ["蜶", "逤"],
  "yóu qiú": ["蝤"],
  "xiā hā": ["蝦"],
  "xī qī": ["螇"],
  "bī pí": ["螕"],
  "nài něng": ["螚"],
  "hé xiá": ["螛"],
  "guì huǐ": ["螝"],
  "mǎ mā mà": ["螞"],
  "shì zhē": ["螫"],
  "zhì dié": ["螲"],
  "jiàn chán": ["螹"],
  "ma má mò": ["蟆"],
  "mǎng měng": ["蟒"],
  "biē bié": ["蟞"],
  "bēn fèi": ["蟦"],
  "láo liáo": ["蟧"],
  "yín xún": ["蟫"],
  "lí lǐ": ["蠡"],
  "xuè xiě": ["血"],
  "xíng háng hàng héng": ["行"],
  "shuāi cuī": ["衰"],
  "tuó tuō": ["袉"],
  "lǐng líng": ["袊"],
  "bào páo pào": ["袌"],
  "jù jiē": ["袓"],
  "hè kè": ["袔"],
  "yí yì": ["袘", "貤"],
  "nà jué": ["袦"],
  "bèi pī": ["被"],
  "chǐ nuǒ": ["袲"],
  "chǐ qǐ duǒ nuǒ": ["袳"],
  "jiá qiā jié": ["袷"],
  "bó mò": ["袹"],
  "guī guà": ["袿"],
  "liè liě": ["裂"],
  "chéng chěng": ["裎"],
  "jiē gé": ["裓"],
  "dāo chóu": ["裯"],
  "shang cháng": ["裳"],
  "yuān gǔn": ["裷"],
  "yǎn ān": ["裺"],
  "tì xī": ["裼"],
  "fù fú": ["褔"],
  "chǔ zhǔ": ["褚"],
  "tuì tùn": ["褪"],
  lǎi: ["襰"],
  "yào yāo": ["要"],
  "qín tán": ["覃"],
  "jiàn xiàn": ["見", "见"],
  piǎn: ["覑", "諞", "谝", "貵", "𡎚"],
  "piē miè": ["覕"],
  "yíng yǐng": ["覮"],
  "qù qū": ["覰", "覷", "觑"],
  "jiàn biǎn": ["覵"],
  "luó luǎn": ["覶"],
  "zī zuǐ": ["觜"],
  "huà xiè": ["觟"],
  "jiě jiè xiè": ["解", "觧"],
  "xué hù": ["觷"],
  "lì lù": ["觻"],
  tǎo: ["討", "讨"],
  zhùn: ["訰"],
  "zī zǐ": ["訾"],
  "yí dài": ["詒", "诒"],
  xiòng: ["詗", "诇"],
  "diào tiǎo": ["誂"],
  "yí chǐ chì": ["誃"],
  "lǎng làng": ["誏"],
  "ēi éi ěi èi xī": ["誒", "诶"],
  shuà: ["誜"],
  "yǔ yù": ["語", "语", "雨"],
  "shuō shuì yuè": ["說", "说"],
  "shuí shéi": ["誰", "谁"],
  "qū juè": ["誳"],
  "chī lài": ["誺"],
  "nì ná": ["誽"],
  "diào tiáo": ["調"],
  "pǐ bēi": ["諀"],
  "jì jī": ["諅"],
  "zé zuò zhǎ cuò": ["諎"],
  "chù jí": ["諔"],
  "háo xià": ["諕"],
  "lùn lún": ["論", "论"],
  "shì dì": ["諟"],
  "huà guā": ["諣"],
  "xǐ shāi āi": ["諰"],
  "nán nàn": ["諵", "難"],
  miù: ["謬", "谬"],
  zèn: ["譖", "谮"],
  "shí zhì": ["識", "识"],
  "juàn xuān": ["讂"],
  "yí tuī": ["讉"],
  zhán: ["讝"],
  "xǔ hǔ": ["许"],
  "xiáng yáng": ["详"],
  "tiáo diào zhōu": ["调"],
  "chén shèn": ["谌"],
  "mí mèi": ["谜"],
  "màn mán": ["谩"],
  "gǔ yù": ["谷"],
  "huō huò huá": ["豁"],
  "zhì zhài": ["豸"],
  "huān huán": ["貆"],
  "kěn kūn": ["貇"],
  "mò hé": ["貈"],
  "mò hé háo": ["貉"],
  "jù lóu": ["貗"],
  "zé zhài": ["責", "责"],
  "dài tè": ["貸"],
  "bì bēn": ["賁"],
  "jiǎ gǔ jià": ["賈"],
  "xiōng mín": ["賯"],
  càng: ["賶"],
  "zhuàn zuàn": ["賺", "赚"],
  "wàn zhuàn": ["贃"],
  "gàn gòng zhuàng": ["贛"],
  "yuán yùn": ["贠"],
  "bēn bì": ["贲"],
  "jiǎ gǔ": ["贾"],
  zǒu: ["走", "赱", "鯐"],
  "dié tú": ["趃"],
  "jū qiè": ["趄"],
  "qū cù": ["趋", "趨"],
  "jí jié": ["趌"],
  "guā huó": ["趏"],
  "què qì jí": ["趞"],
  "tàng tāng": ["趟"],
  "chuō zhuó": ["趠"],
  "qù cù": ["趣"],
  "yuè tì": ["趯"],
  "bō bào": ["趵"],
  "kuà wù": ["趶"],
  "guì jué": ["趹"],
  "fāng fàng páng": ["趽"],
  "páo bà": ["跁"],
  "qí qǐ": ["跂"],
  "jiàn chén": ["跈"],
  "pǎo páo": ["跑"],
  "diǎn diē tiē": ["跕"],
  "jū jù qiè": ["跙"],
  bǒ: ["跛"],
  "luò lì": ["跞"],
  "dài duò duō chí": ["跢"],
  zhuǎi: ["跩"],
  "bèng pián": ["跰"],
  "tiào táo": ["跳"],
  "shū chōu": ["跾"],
  "liàng liáng": ["踉"],
  "tà tā": ["踏"],
  chǎ: ["蹅", "鑔", "镲"],
  "dí zhí": ["蹢"],
  "dēng dèng": ["蹬", "鐙", "镫"],
  cèng: ["蹭"],
  "dūn cún": ["蹲"],
  "juě jué": ["蹶"],
  liāo: ["蹽"],
  "xiè sǎ": ["躠"],
  tǐ: ["躰", "軆", "骵"],
  "yà zhá gá": ["轧", "軋"],
  "xìn xiàn": ["軐"],
  "fàn guǐ": ["軓"],
  "zhuàn zhuǎn": ["転"],
  "zhóu zhòu": ["軸", "轴"],
  bú: ["轐", "醭", "鳪"],
  "zhuǎn zhuàn zhuǎi": ["转"],
  "zǎi zài": ["载"],
  "niǎn zhǎn": ["辗"],
  "biān bian": ["边"],
  "dào biān": ["辺"],
  "yǐ yí": ["迆", "迤", "迱"],
  "guò guo guō": ["过"],
  "wàng kuāng": ["迋"],
  "hái huán": ["还"],
  "zhè zhèi": ["这"],
  "yuǎn yuàn": ["远"],
  "zhì lì": ["迣"],
  "zhù wǎng": ["迬"],
  "zhuī duī": ["追"],
  "shì kuò": ["适"],
  tòu: ["透"],
  "tōng tòng": ["通"],
  guàng: ["逛"],
  "dǎi dài": ["逮"],
  "suì suí": ["遂"],
  "tí dì": ["遆"],
  "yí wèi": ["遗"],
  "shì dí zhé": ["適"],
  cà: ["遪"],
  "huán hái": ["還"],
  "lí chí": ["邌"],
  "kàng háng": ["邟"],
  "nà nèi nā": ["那"],
  "xié yá yé yú xú": ["邪"],
  "gāi hái": ["郂"],
  "huán xún": ["郇"],
  "chī xī": ["郗"],
  hǎo: ["郝"],
  "lì zhí": ["郦"],
  "xiáo ǎo": ["郩"],
  "dōu dū": ["都"],
  liǎo: ["曢", "鄝", "镽"],
  "zàn cuán cuó": ["酂", "酇"],
  "dīng dǐng": ["酊"],
  "cù zuò": ["酢"],
  "fā pō": ["酦"],
  "shāi shī": ["酾"],
  niàng: ["酿", "醸"],
  "qiú chōu": ["醔"],
  "pō fā": ["醗", "醱"],
  "chǎn chěn": ["醦"],
  "yàn liǎn xiān": ["醶"],
  "niàng niáng": ["釀"],
  "lǐ li": ["里"],
  "lí xǐ xī": ["釐"],
  "liǎo liào": ["釕"],
  "dīng dìng": ["釘", "钉"],
  "qiǎo jiǎo": ["釥"],
  "yú huá": ["釪"],
  "huá wū": ["釫"],
  "rì rèn jiàn": ["釰", "釼"],
  "dì dài": ["釱"],
  "pī zhāo": ["釽"],
  "yá yé": ["釾"],
  "bǎ pá": ["鈀", "钯"],
  "tā tuó": ["鉈", "铊"],
  běi: ["鉳"],
  "bǐng píng": ["鉼"],
  "hā kē": ["鉿", "铪"],
  chòng: ["銃", "铳"],
  "xiǎng jiōng": ["銄"],
  "yù sì": ["銉"],
  "xù huì": ["銊"],
  "rén rěn": ["銋"],
  "shàn shuò": ["銏"],
  "chì lì": ["銐"],
  "xiǎn xǐ": ["銑", "铣"],
  "hóu xiàng": ["銗"],
  "diào tiáo yáo": ["銚"],
  "xiān kuò tiǎn guā": ["銛", "銽", "铦"],
  "zhé niè": ["銸"],
  "zhōng yōng": ["銿"],
  "tōu tù dòu": ["鋀"],
  "méi méng": ["鋂"],
  "wàn jiǎn": ["鋄", "鎫"],
  "tǐng dìng": ["鋌", "铤"],
  "juān jiān cuān": ["鋑"],
  "sī tuó": ["鋖"],
  "juān xuān juàn": ["鋗"],
  "wú huá wū": ["鋘"],
  "zhuó chuò": ["鋜"],
  "xíng xìng jīng": ["鋞"],
  "jū jú": ["鋦", "锔"],
  "zuì niè": ["鋷"],
  "yuān yuǎn wǎn wān": ["鋺"],
  "gāng gàng": ["鋼", "钢"],
  zhuī: ["錐", "锥", "騅", "骓", "鵻"],
  ā: ["錒", "锕"],
  "cuō chā": ["鎈"],
  "suǒ sè": ["鎍"],
  "yáo zú": ["鎐"],
  "yè tà gé": ["鎑"],
  "qiāng chēng": ["鎗"],
  "gé lì": ["鎘", "镉", "鬲"],
  "bī pī bì": ["鎞"],
  "gǎo hào": ["鎬"],
  "zú chuò": ["鏃"],
  "xiū xiù": ["鏅"],
  "shòu sōu": ["鏉"],
  "dí dī": ["鏑", "镝"],
  "qiāo sǎn càn": ["鏒"],
  "lù áo": ["鏕"],
  "tāng táng": ["鏜"],
  "jiàn zàn": ["鏩"],
  "huì suì ruì": ["鏸"],
  "qiǎng qiāng": ["鏹", "镪"],
  "sǎn xiàn sà": ["鏾"],
  "jiǎn jiàn": ["鐧", "锏"],
  "dāng chēng": ["鐺", "铛"],
  "zuān zuàn": ["鑽"],
  "sà xì": ["钑"],
  "yào yuè": ["钥"],
  "tǒu dǒu": ["钭"],
  "zuàn zuān": ["钻"],
  "qiān yán": ["铅"],
  "pí pī": ["铍"],
  "yáo diào tiáo": ["铫"],
  "tāng tàng": ["铴"],
  "pù pū": ["铺"],
  "tán xiān": ["锬"],
  "liù liú": ["镏"],
  "hào gǎo": ["镐"],
  "táng tāng": ["镗"],
  "tán chán xín": ["镡"],
  "huò shǎn": ["閄"],
  "hàn bì": ["閈", "闬"],
  "kāng kàng": ["閌", "闶"],
  "xián jiàn jiān jiǎn": ["閒"],
  "xiā xiǎ": ["閕"],
  "xiǎ kě": ["閜"],
  "biàn guān": ["閞"],
  "hé gé": ["閤", "颌"],
  "hòng xiàng": ["閧"],
  "sē xī": ["閪"],
  "tíng tǐng": ["閮"],
  "è yān": ["閼", "阏"],
  "hòng juǎn xiàng": ["闂"],
  "bǎn pàn": ["闆"],
  "dū shé": ["闍", "阇"],
  "què quē": ["闕"],
  "tāng táng chāng": ["闛"],
  "kàn hǎn": ["闞", "阚"],
  "xì sè tà": ["闟"],
  "mēn mèn": ["闷"],
  "quē què": ["阙"],
  "yán diàn": ["阽"],
  "ā ē": ["阿"],
  "bēi pō pí": ["陂"],
  "yàn yǎn": ["隁"],
  "yú yáo shù": ["隃"],
  "lóng lōng": ["隆"],
  "duì zhuì": ["隊"],
  "suí duò": ["隋"],
  "gāi qí ái": ["隑"],
  "huī duò": ["隓", "隳"],
  "wěi kuí": ["隗"],
  "lì dài": ["隸"],
  "zhuī cuī wéi": ["隹"],
  "hè hú": ["隺", "鶮"],
  "jùn juàn": ["隽", "雋"],
  "nán nàn nuó": ["难"],
  "què qiāo qiǎo": ["雀"],
  "guàn huán": ["雚"],
  "guī xī": ["雟"],
  "sè xí": ["雭"],
  án: ["雸"],
  "wù méng": ["雺"],
  tèng: ["霯"],
  "lù lòu": ["露"],
  mái: ["霾"],
  "jìng liàng": ["靚"],
  "gé jí": ["革"],
  bǎ: ["靶"],
  "yāng yàng": ["鞅"],
  "gé tà sǎ": ["鞈"],
  "biān yìng": ["鞕"],
  "qiào shāo": ["鞘"],
  "juān xuān": ["鞙"],
  "shàng zhǎng": ["鞝"],
  "pí bǐng bì bēi": ["鞞"],
  la: ["鞡"],
  "xiè dié": ["鞢"],
  ēng: ["鞥"],
  "móu mù": ["鞪"],
  "bì bǐng": ["鞸"],
  "mèi wà": ["韎"],
  rǒu: ["韖"],
  "shè xiè": ["韘"],
  "yùn wēn": ["韫"],
  "dùn dú": ["頓", "顿"],
  duǐ: ["頧"],
  luō: ["頱"],
  "bīn pín": ["頻"],
  yóng: ["顒", "颙", "鰫"],
  mān: ["顢", "颟"],
  "jǐng gěng": ["颈"],
  "jié xié jiá": ["颉"],
  "kē ké": ["颏"],
  "pín bīn": ["频"],
  "chàn zhàn": ["颤"],
  "fēng fěng": ["風", "风"],
  "biāo diū": ["颩"],
  "bá fú": ["颰"],
  "sāo sōu": ["颾"],
  "liù liáo": ["飂"],
  "shí sì yì": ["食"],
  "yǎng juàn": ["飬"],
  "zhù tǒu": ["飳"],
  "yí sì": ["飴"],
  "zuò zé zhā": ["飵"],
  tiè: ["飻", "餮"],
  "xiǎng náng": ["饟"],
  "táng xíng": ["饧"],
  "gē le": ["饹"],
  "chā zha": ["馇"],
  "náng nǎng": ["馕"],
  "yūn wò": ["馧"],
  "zhī shì": ["馶"],
  "xìn jìn": ["馸"],
  "kuài jué": ["駃"],
  zǎng: ["駔", "驵"],
  "tái dài": ["駘"],
  "xún xuān": ["駨"],
  "liáng láng": ["駺"],
  piàn: ["騗", "騙", "骗", "魸"],
  "dài tái": ["骀"],
  "sāo sǎo": ["骚"],
  "gǔ gū": ["骨"],
  "bèi mó": ["骳"],
  "xiāo qiāo": ["骹"],
  "bǎng pǎng": ["髈"],
  "bó jué": ["髉"],
  "bì pǒ": ["髲"],
  "máo méng": ["髳"],
  "kuò yuè": ["髺"],
  "bā bà": ["魞", "鲃"],
  "jì cǐ": ["鮆"],
  "bó bà": ["鮊"],
  "zhǎ zhà": ["鮓", "鲊"],
  "chóu dài": ["鮘"],
  "luò gé": ["鮥"],
  "guī xié wā kuí": ["鮭"],
  "xiān xiǎn": ["鮮", "鲜"],
  "pū bū": ["鯆"],
  "yì sī": ["鯣"],
  "bà bó": ["鲌"],
  "guī xié": ["鲑"],
  "sāi xǐ": ["鳃"],
  "niǎo diǎo": ["鳥"],
  "diāo zhāo": ["鳭"],
  "gān hàn yàn": ["鳱"],
  "fū guī": ["鳺"],
  "jiān qiān zhān": ["鳽"],
  "hé jiè": ["鶡"],
  "piān biǎn": ["鶣"],
  "chuàn zhì": ["鶨"],
  "cāng qiāng": ["鶬"],
  "sǔn xùn": ["鶽"],
  "biāo páo": ["麃"],
  "zhù cū": ["麆"],
  "jūn qún": ["麇", "麕"],
  chi: ["麶"],
  "mó me": ["麼"],
  "mó me ma": ["麽"],
  "mí mǒ": ["麿"],
  "dàn shèn": ["黮"],
  "zhěn yān": ["黰"],
  "dǎn zhǎn": ["黵"],
  "miǎn mǐn měng": ["黾"],
  hōu: ["齁"],
  nàng: ["齉"],
  "qí jì zī zhāi": ["齐"],
  "yín kěn yǎn": ["龂"],
  "yín kěn": ["龈"],
  "gōng wò": ["龏"],
  "guī jūn qiū": ["龜", "龟"],
  "kuí wā": ["䖯"],
  lōu: ["䁖"],
  "ōu qū": ["𫭟"],
  "lóu lǘ": ["𦝼"],
  "gǎ gā gá": ["嘎"],
  "wā guà": ["坬"],
  "zhǐ dǐ": ["茋"],
  "gǒng hóng": ["硔"],
  "yáo xiào": ["滧"]
}, Hl = new aG();
Object.keys(sU).forEach((t) => {
  const r = sU[t];
  for (let a of r)
    Hl.set(a, t);
});
const zge = [
  "zh",
  "ch",
  "sh",
  "z",
  "c",
  "s",
  "b",
  "p",
  "m",
  "f",
  "d",
  "t",
  "n",
  "l",
  "g",
  "k",
  "h",
  "j",
  "q",
  "x",
  "r",
  "y",
  "w",
  ""
], Fge = ["j", "q", "x"], Gge = [
  "uān",
  "uán",
  "uǎn",
  "uàn",
  "uan",
  "uē",
  "ué",
  "uě",
  "uè",
  "ue",
  "ūn",
  "ún",
  "ǔn",
  "ùn",
  "un",
  "ū",
  "ú",
  "ǔ",
  "ù",
  "u"
], Vge = {
  uān: "üān",
  uán: "üán",
  uǎn: "üǎn",
  uàn: "üàn",
  uan: "üan",
  uē: "üē",
  ué: "üé",
  uě: "üě",
  uè: "üè",
  ue: "üe",
  ūn: "ǖn",
  ún: "ǘn",
  ǔn: "ǚn",
  ùn: "ǜn",
  un: "ün",
  ū: "ǖ",
  ú: "ǘ",
  ǔ: "ǚ",
  ù: "ǜ",
  u: "ü"
}, Yge = [
  "ia",
  "ian",
  "iang",
  "iao",
  "ie",
  "iu",
  "iong",
  "ua",
  "uai",
  "uan",
  "uang",
  "ue",
  "ui",
  "uo",
  "üan",
  "üe",
  "van",
  "ve"
], aU = {
  一: "yì",
  二: "èr",
  三: "sān",
  四: "sì",
  五: "wǔ",
  六: "liù",
  七: "qī",
  八: "bā",
  九: "jiǔ",
  十: "shí",
  百: "bǎi",
  千: "qiān",
  万: "wàn",
  亿: "yì",
  单: "dān",
  两: "liǎng",
  双: "shuāng",
  多: "duō",
  几: "jǐ",
  十一: "shí yī",
  零一: "líng yī",
  第一: "dì yī",
  一十: "yī shí",
  一十一: "yī shí yī"
}, oU = {
  重: "chóng",
  行: "háng",
  斗: "dǒu",
  更: "gēng"
};
function Xge() {
  const t = {
    零一: "líng yī",
    "〇一": "líng yī",
    十一: "shí yī",
    一十: "yī shí",
    第一: "dì yī",
    一十一: "yī shí yī"
  };
  for (let r in aU)
    for (let a in oU) {
      const u = `${r}${a}`, h = `${aU[r]} ${oU[a]}`;
      t[u] = h;
    }
  return t;
}
const cU = Xge(), Wge = Object.keys(cU).map((t) => ({
  zh: t,
  pinyin: cU[t],
  probability: 1e-12,
  length: Jc(t),
  priority: Go.Normal,
  dict: Symbol("rule")
})), oG = {
  // 说不说，说一说，叠词之间发音为轻声
  不: {
    bú: [4]
    // "不" 后面跟 4 声时，变调为 2 声
  },
  一: {
    yí: [4],
    yì: [1, 2, 3]
  }
}, qge = {
  不: ["的", "而", "之", "后", "也", "还", "地"],
  一: ["的", "而", "之", "后", "也", "还", "是"]
}, Kge = Object.keys(oG);
function Jge(t, r, a) {
  if (Kge.indexOf(t) === -1)
    return Dy(t);
  if (r === a && r && Dy(r) !== r)
    return iA(Dy(t));
  if (a && !qge[t].includes(a)) {
    const u = Dy(a);
    if (u !== a) {
      const h = sA(u), b = oG[t];
      for (let l in b)
        if (b[l].indexOf(Number(h)) !== -1)
          return l;
    }
  }
}
function Zge(t, r) {
  if (t === "了" && (!r || !Hl.get(r)))
    return "liǎo";
}
function Qge(t, r) {
  if (t === "々")
    return !r || !Hl.get(r) ? "tóng" : Hl.get(r).split(" ")[0];
}
function uU(t, r, a) {
  return Qge(t, r) || Zge(t, r) || Jge(t, r, a) || Dy(t);
}
const tN = {
  南宫: "nán gōng",
  第五: "dì wǔ",
  万俟: "mò qí",
  司马: "sī mǎ",
  上官: "shàng guān",
  欧阳: "ōu yáng",
  夏侯: "xià hóu",
  诸葛: "zhū gě",
  闻人: "wén rén",
  东方: "dōng fāng",
  赫连: "hè lián",
  皇甫: "huáng fǔ",
  尉迟: "yù chí",
  公羊: "gōng yáng",
  澹台: "tán tái",
  公冶: "gōng yě",
  宗政: "zōng zhèng",
  濮阳: "pú yáng",
  淳于: "chún yú",
  太叔: "tài shū",
  申屠: "shēn tú",
  公孙: "gōng sūn",
  仲孙: "zhòng sūn",
  轩辕: "xuān yuán",
  令狐: "líng hú",
  钟离: "zhōng lí",
  宇文: "yǔ wén",
  长孙: "zhǎng sūn",
  慕容: "mù róng",
  鲜于: "xiān yú",
  闾丘: "lǘ qiū",
  司徒: "sī tú",
  司空: "sī kōng",
  亓官: "qí guān",
  司寇: "sī kòu",
  仉督: "zhǎng dū",
  子车: "zǐ jū",
  颛孙: "zhuān sūn",
  端木: "duān mù",
  巫马: "wū mǎ",
  公西: "gōng xī",
  漆雕: "qī diāo",
  乐正: "yuè zhèng",
  壤驷: "rǎng sì",
  公良: "gōng liáng",
  拓跋: "tuò bá",
  夹谷: "jiá gǔ",
  宰父: "zǎi fǔ",
  榖梁: "gǔ liáng",
  段干: "duàn gān",
  百里: "bǎi lǐ",
  东郭: "dōng guō",
  南门: "nán mén",
  呼延: "hū yán",
  羊舌: "yáng shé",
  梁丘: "liáng qiū",
  左丘: "zuǒ qiū",
  东门: "dōng mén",
  西门: "xī mén",
  句龙: "gōu lóng",
  毌丘: "guàn qiū",
  赵: "zhào",
  钱: "qián",
  孙: "sūn",
  李: "lǐ",
  周: "zhōu",
  吴: "wú",
  郑: "zhèng",
  王: "wáng",
  冯: "féng",
  陈: "chén",
  褚: "chǔ",
  卫: "wèi",
  蒋: "jiǎng",
  沈: "shěn",
  韩: "hán",
  杨: "yáng",
  朱: "zhū",
  秦: "qín",
  尤: "yóu",
  许: "xǔ",
  何: "hé",
  吕: "lǚ",
  施: "shī",
  张: "zhāng",
  孔: "kǒng",
  曹: "cáo",
  严: "yán",
  华: "huà",
  金: "jīn",
  魏: "wèi",
  陶: "táo",
  姜: "jiāng",
  戚: "qī",
  谢: "xiè",
  邹: "zōu",
  喻: "yù",
  柏: "bǎi",
  水: "shuǐ",
  窦: "dòu",
  章: "zhāng",
  云: "yún",
  苏: "sū",
  潘: "pān",
  葛: "gě",
  奚: "xī",
  范: "fàn",
  彭: "péng",
  郎: "láng",
  鲁: "lǔ",
  韦: "wéi",
  昌: "chāng",
  马: "mǎ",
  苗: "miáo",
  凤: "fèng",
  花: "huā",
  方: "fāng",
  俞: "yú",
  任: "rén",
  袁: "yuán",
  柳: "liǔ",
  酆: "fēng",
  鲍: "bào",
  史: "shǐ",
  唐: "táng",
  费: "fèi",
  廉: "lián",
  岑: "cén",
  薛: "xuē",
  雷: "léi",
  贺: "hè",
  倪: "ní",
  汤: "tāng",
  滕: "téng",
  殷: "yīn",
  罗: "luó",
  毕: "bì",
  郝: "hǎo",
  邬: "wū",
  安: "ān",
  常: "cháng",
  乐: "yuè",
  于: "yú",
  时: "shí",
  傅: "fù",
  皮: "pí",
  卞: "biàn",
  齐: "qí",
  康: "kāng",
  伍: "wǔ",
  余: "yú",
  元: "yuán",
  卜: "bǔ",
  顾: "gù",
  孟: "mèng",
  平: "píng",
  黄: "huáng",
  和: "hé",
  穆: "mù",
  萧: "xiāo",
  尹: "yǐn",
  姚: "yáo",
  邵: "shào",
  湛: "zhàn",
  汪: "wāng",
  祁: "qí",
  毛: "máo",
  禹: "yǔ",
  狄: "dí",
  米: "mǐ",
  贝: "bèi",
  明: "míng",
  臧: "zāng",
  计: "jì",
  伏: "fú",
  成: "chéng",
  戴: "dài",
  谈: "tán",
  宋: "sòng",
  茅: "máo",
  庞: "páng",
  熊: "xióng",
  纪: "jǐ",
  舒: "shū",
  屈: "qū",
  项: "xiàng",
  祝: "zhù",
  董: "dǒng",
  梁: "liáng",
  杜: "dù",
  阮: "ruǎn",
  蓝: "lán",
  闵: "mǐn",
  席: "xí",
  季: "jì",
  麻: "má",
  强: "qiáng",
  贾: "jiǎ",
  路: "lù",
  娄: "lóu",
  危: "wēi",
  江: "jiāng",
  童: "tóng",
  颜: "yán",
  郭: "guō",
  梅: "méi",
  盛: "shèng",
  林: "lín",
  刁: "diāo",
  钟: "zhōng",
  徐: "xú",
  邱: "qiū",
  骆: "luò",
  高: "gāo",
  夏: "xià",
  蔡: "cài",
  田: "tián",
  樊: "fán",
  胡: "hú",
  凌: "líng",
  霍: "huò",
  虞: "yú",
  万: "wàn",
  支: "zhī",
  柯: "kē",
  昝: "zǎn",
  管: "guǎn",
  卢: "lú",
  莫: "mò",
  经: "jīng",
  房: "fáng",
  裘: "qiú",
  缪: "miào",
  干: "gān",
  解: "xiè",
  应: "yīng",
  宗: "zōng",
  丁: "dīng",
  宣: "xuān",
  贲: "bēn",
  邓: "dèng",
  郁: "yù",
  单: "shàn",
  杭: "háng",
  洪: "hóng",
  包: "bāo",
  诸: "zhū",
  左: "zuǒ",
  石: "shí",
  崔: "cuī",
  吉: "jí",
  钮: "niǔ",
  龚: "gōng",
  程: "chéng",
  嵇: "jī",
  邢: "xíng",
  滑: "huá",
  裴: "péi",
  陆: "lù",
  荣: "róng",
  翁: "wēng",
  荀: "xún",
  羊: "yáng",
  於: "yū",
  惠: "huì",
  甄: "zhēn",
  曲: "qū",
  家: "jiā",
  封: "fēng",
  芮: "ruì",
  羿: "yì",
  储: "chǔ",
  靳: "jìn",
  汲: "jí",
  邴: "bǐng",
  糜: "mí",
  松: "sōng",
  井: "jǐng",
  段: "duàn",
  富: "fù",
  巫: "wū",
  乌: "wū",
  焦: "jiāo",
  巴: "bā",
  弓: "gōng",
  牧: "mù",
  隗: "wěi",
  山: "shān",
  谷: "gǔ",
  车: "chē",
  侯: "hóu",
  宓: "mì",
  蓬: "péng",
  全: "quán",
  郗: "xī",
  班: "bān",
  仰: "yǎng",
  秋: "qiū",
  仲: "zhòng",
  伊: "yī",
  宫: "gōng",
  宁: "nìng",
  仇: "qiú",
  栾: "luán",
  暴: "bào",
  甘: "gān",
  钭: "tǒu",
  厉: "lì",
  戎: "róng",
  祖: "zǔ",
  武: "wǔ",
  符: "fú",
  刘: "liú",
  景: "jǐng",
  詹: "zhān",
  束: "shù",
  龙: "lóng",
  叶: "yè",
  幸: "xìng",
  司: "sī",
  韶: "sháo",
  郜: "gào",
  黎: "lí",
  蓟: "jì",
  薄: "bó",
  印: "yìn",
  宿: "sù",
  白: "bái",
  怀: "huái",
  蒲: "pú",
  邰: "tái",
  从: "cóng",
  鄂: "è",
  索: "suǒ",
  咸: "xián",
  籍: "jí",
  赖: "lài",
  卓: "zhuó",
  蔺: "lìn",
  屠: "tú",
  蒙: "méng",
  池: "chí",
  乔: "qiáo",
  阴: "yīn",
  鬱: "yù",
  胥: "xū",
  能: "nài",
  苍: "cāng",
  双: "shuāng",
  闻: "wén",
  莘: "shēn",
  党: "dǎng",
  翟: "zhái",
  谭: "tán",
  贡: "gòng",
  劳: "láo",
  逄: "páng",
  姬: "jī",
  申: "shēn",
  扶: "fú",
  堵: "dǔ",
  冉: "rǎn",
  宰: "zǎi",
  郦: "lì",
  雍: "yōng",
  郤: "xì",
  璩: "qú",
  桑: "sāng",
  桂: "guì",
  濮: "pú",
  牛: "niú",
  寿: "shòu",
  通: "tōng",
  边: "biān",
  扈: "hù",
  燕: "yān",
  冀: "jì",
  郏: "jiá",
  浦: "pǔ",
  尚: "shàng",
  农: "nóng",
  温: "wēn",
  别: "bié",
  庄: "zhuāng",
  晏: "yàn",
  柴: "chái",
  瞿: "qú",
  阎: "yán",
  充: "chōng",
  慕: "mù",
  连: "lián",
  茹: "rú",
  习: "xí",
  宦: "huàn",
  艾: "ài",
  鱼: "yú",
  容: "róng",
  向: "xiàng",
  古: "gǔ",
  易: "yì",
  慎: "shèn",
  戈: "gē",
  廖: "liào",
  庾: "yǔ",
  终: "zhōng",
  暨: "jì",
  居: "jū",
  衡: "héng",
  步: "bù",
  都: "dū",
  耿: "gěng",
  满: "mǎn",
  弘: "hóng",
  匡: "kuāng",
  国: "guó",
  文: "wén",
  寇: "kòu",
  广: "guǎng",
  禄: "lù",
  阙: "quē",
  东: "dōng",
  欧: "ōu",
  殳: "shū",
  沃: "wò",
  利: "lì",
  蔚: "wèi",
  越: "yuè",
  夔: "kuí",
  隆: "lóng",
  师: "shī",
  巩: "gǒng",
  厍: "shè",
  聂: "niè",
  晁: "cháo",
  勾: "gōu",
  敖: "áo",
  融: "róng",
  冷: "lěng",
  訾: "zī",
  辛: "xīn",
  阚: "kàn",
  那: "nā",
  简: "jiǎn",
  饶: "ráo",
  空: "kōng",
  曾: "zēng",
  母: "mǔ",
  沙: "shā",
  乜: "niè",
  养: "yǎng",
  鞠: "jū",
  须: "xū",
  丰: "fēng",
  巢: "cháo",
  关: "guān",
  蒯: "kuǎi",
  相: "xiàng",
  查: "zhā",
  后: "hòu",
  荆: "jīng",
  红: "hóng",
  游: "yóu",
  竺: "zhú",
  权: "quán",
  逯: "lù",
  盖: "gě",
  益: "yì",
  桓: "huán",
  公: "gōng",
  牟: "móu",
  哈: "hǎ",
  言: "yán",
  福: "fú",
  肖: "xiāo",
  区: "ōu",
  覃: "qín",
  朴: "piáo",
  繁: "pó",
  员: "yùn",
  句: "gōu",
  要: "yāo",
  过: "guō",
  钻: "zuān",
  谌: "chén",
  折: "shé",
  召: "shào",
  郄: "qiè",
  撒: "sǎ",
  甯: "nìng",
  六: "lù",
  啜: "chuài",
  行: "xíng"
}, $ge = Object.keys(tN).map((t) => ({
  zh: t,
  pinyin: tN[t],
  probability: 1 + Jc(t),
  length: Jc(t),
  priority: Go.Surname,
  dict: Symbol("surname")
})), dU = {
  这个: "zhè ge",
  成为: "chéng wéi",
  认为: "rèn wéi",
  作为: "zuò wéi",
  部分: "bù fen",
  要求: "yāo qiú",
  应该: "yīng gāi",
  增长: "zēng zhǎng",
  提供: "tí gōng",
  觉得: "jué de",
  任务: "rèn wu",
  那个: "nà ge",
  称为: "chēng wéi",
  为主: "wéi zhǔ",
  了解: "liǎo jiě",
  处理: "chǔ lǐ",
  皇上: "huáng shang",
  只要: "zhǐ yào",
  大量: "dà liàng",
  力量: "lì liàng",
  几乎: "jī hū",
  干部: "gàn bù",
  目的: "mù dì",
  行为: "xíng wéi",
  只见: "zhǐ jiàn",
  认识: "rèn shi",
  市长: "shì zhǎng",
  师父: "shī fu",
  调查: "diào chá",
  重新: "chóng xīn",
  分为: "fēn wéi",
  知识: "zhī shi",
  导弹: "dǎo dàn",
  质量: "zhì liàng",
  行款: "háng kuǎn",
  行列: "háng liè",
  行话: "háng huà",
  行业: "háng yè",
  隔行: "gé háng",
  在行: "zài háng",
  行家: "háng jia",
  内行: "nèi háng",
  外行: "wài háng",
  同行: "tóng háng",
  本行: "běn háng",
  行伍: "háng wǔ",
  洋行: "yáng háng",
  银行: "yín háng",
  商行: "shāng háng",
  支行: "zhī háng",
  总行: "zǒng háng",
  行情: "háng qíng",
  懂行: "dǒng háng",
  行规: "háng guī",
  行当: "háng dang",
  行货: "háng huò",
  太行: "tài háng",
  入行: "rù háng",
  中行: "zhōng háng",
  农行: "nóng háng",
  工行: "gōng háng",
  建行: "jiàn háng",
  各行: "gè háng",
  行号: "háng hào",
  行高: "háng gāo",
  行首: "háng shǒu",
  行尾: "háng wěi",
  行末: "háng mò",
  行长: "háng cháng",
  行距: "háng jù",
  换行: "huàn háng",
  行会: "háng huì",
  行辈: "háng bèi",
  行道: "háng dào",
  道行: "dào heng",
  参与: "cān yù",
  充分: "chōng fèn",
  尽管: "jǐn guǎn",
  生长: "shēng zhǎng",
  数量: "shù liàng",
  应当: "yīng dāng",
  院长: "yuàn zhǎng",
  强调: "qiáng diào",
  只能: "zhǐ néng",
  音乐: "yīn yuè",
  以为: "yǐ wéi",
  处于: "chǔ yú",
  部长: "bù zhǎng",
  蒙古: "měng gǔ",
  只有: "zhǐ yǒu",
  适当: "shì dàng",
  只好: "zhǐ hǎo",
  成长: "chéng zhǎng",
  高兴: "gāo xìng",
  不了: "bù liǎo",
  产量: "chǎn liàng",
  胖子: "pàng zi",
  显得: "xiǎn de",
  只是: "zhǐ shì",
  似的: "shì de",
  率领: "shuài lǐng",
  改为: "gǎi wéi",
  不禁: "bù jīn",
  成分: "chéng fèn",
  答应: "dā ying",
  少年: "shào nián",
  兴趣: "xìng qù",
  太监: "tài jian",
  休息: "xiū xi",
  校长: "xiào zhǎng",
  更新: "gēng xīn",
  合同: "hé tong",
  喝道: "hè dào",
  重庆: "chóng qìng",
  重建: "chóng jiàn",
  使得: "shǐ de",
  审查: "shěn chá",
  累计: "lěi jì",
  给予: "jǐ yǔ",
  极为: "jí wéi",
  冠军: "guàn jūn",
  仿佛: "fǎng fú",
  头发: "tóu fa",
  投降: "tóu xiáng",
  家长: "jiā zhǎng",
  仔细: "zǐ xì",
  要是: "yào shi",
  将领: "jiàng lǐng",
  含量: "hán liàng",
  更为: "gèng wéi",
  积累: "jī lěi",
  地处: "dì chǔ",
  县长: "xiàn zhǎng",
  少女: "shào nǚ",
  路上: "lù shang",
  只怕: "zhǐ pà",
  能量: "néng liàng",
  储量: "chǔ liàng",
  供应: "gōng yìng",
  挑战: "tiǎo zhàn",
  西藏: "xī zàng",
  记得: "jì de",
  总量: "zǒng liàng",
  当真: "dàng zhēn",
  将士: "jiàng shì",
  差别: "chā bié",
  较为: "jiào wéi",
  长老: "zhǎng lǎo",
  大夫: "dài fu",
  差异: "chā yì",
  懂得: "dǒng de",
  尽量: "jǐn liàng",
  模样: "mú yàng",
  的确: "dí què",
  为首: "wéi shǒu",
  便宜: "pián yi",
  更名: "gēng míng",
  石头: "shí tou",
  州长: "zhōu zhǎng",
  为止: "wéi zhǐ",
  漂亮: "piào liang",
  炮弹: "pào dàn",
  藏族: "zàng zú",
  角色: "jué sè",
  当作: "dàng zuò",
  尽快: "jǐn kuài",
  人为: "rén wéi",
  重复: "chóng fù",
  胡同: "hú tòng",
  差距: "chā jù",
  弟兄: "dì xiong",
  大将: "dà jiàng",
  睡觉: "shuì jiào",
  一觉: "yí jiào",
  团长: "tuán zhǎng",
  队长: "duì zhǎng",
  区长: "qū zhǎng",
  难得: "nán dé",
  丫头: "yā tou",
  会长: "huì zhǎng",
  弟弟: "dì di",
  王爷: "wáng ye",
  重量: "zhòng liàng",
  誉为: "yù wéi",
  家伙: "jiā huo",
  华山: "huà shān",
  椅子: "yǐ zi",
  流量: "liú liàng",
  长大: "zhǎng dà",
  勉强: "miǎn qiǎng",
  会计: "kuài jì",
  过分: "guò fèn",
  济南: "jǐ nán",
  调动: "diào dòng",
  燕京: "yān jīng",
  少将: "shào jiàng",
  中毒: "zhòng dú",
  晓得: "xiǎo de",
  变更: "biàn gēng",
  打更: "dǎ gēng",
  认得: "rèn de",
  苹果: "píng guǒ",
  念头: "niàn tou",
  挣扎: "zhēng zhá",
  三藏: "sān zàng",
  剥削: "bō xuē",
  丞相: "chéng xiàng",
  少量: "shǎo liàng",
  寻思: "xún si",
  夺得: "duó dé",
  干线: "gàn xiàn",
  呼吁: "hū yù",
  处罚: "chǔ fá",
  长官: "zhǎng guān",
  柏林: "bó lín",
  亲戚: "qīn qi",
  身分: "shēn fèn",
  胳膊: "gē bo",
  着手: "zhuó shǒu",
  炸弹: "zhà dàn",
  咳嗽: "ké sou",
  叶子: "yè zi",
  外长: "wài zhǎng",
  供给: "gōng jǐ",
  师长: "shī zhǎng",
  变量: "biàn liàng",
  应有: "yīng yǒu",
  下载: "xià zài",
  乐器: "yuè qì",
  间接: "jiàn jiē",
  底下: "dǐ xià",
  打扮: "dǎ bàn",
  子弹: "zǐ dàn",
  弹药: "dàn yào",
  热量: "rè liàng",
  削弱: "xuē ruò",
  骨干: "gǔ gàn",
  容量: "róng liàng",
  模糊: "mó hu",
  转动: "zhuàn dòng",
  称呼: "chēng hu",
  科长: "kē zhǎng",
  处置: "chǔ zhì",
  着重: "zhuó zhòng",
  着急: "zháo jí",
  强迫: "qiǎng pò",
  庭长: "tíng zhǎng",
  首相: "shǒu xiàng",
  喇嘛: "lǎ ma",
  镇长: "zhèn zhǎng",
  只管: "zhǐ guǎn",
  重重: "chóng chóng",
  免得: "miǎn de",
  着实: "zhuó shí",
  度假: "dù jià",
  真相: "zhēn xiàng",
  相貌: "xiàng mào",
  处分: "chǔ fèn",
  委屈: "wěi qu",
  为期: "wéi qī",
  伯伯: "bó bo",
  伯子: "bǎi zi",
  圈子: "quān zi",
  见识: "jiàn shi",
  笼罩: "lǒng zhào",
  与会: "yù huì",
  都督: "dū du",
  都市: "dū shì",
  成都: "chéng dū",
  首都: "shǒu dū",
  帝都: "dì dū",
  王都: "wáng dū",
  东都: "dōng dū",
  都护: "dū hù",
  都城: "dū chéng",
  建都: "jiàn dū",
  迁都: "qiān dū",
  故都: "gù dū",
  定都: "dìng dū",
  中都: "zhōng dū",
  六安: "lù ān",
  宰相: "zǎi xiàng",
  较量: "jiào liàng",
  对称: "duì chèn",
  总长: "zǒng zhǎng",
  相公: "xiàng gong",
  空白: "kòng bái",
  打量: "dǎ liang",
  水分: "shuǐ fèn",
  舌头: "shé tou",
  没收: "mò shōu",
  行李: "xíng li",
  判处: "pàn chǔ",
  散文: "sǎn wén",
  处境: "chǔ jìng",
  孙子: "sūn zi",
  拳头: "quán tou",
  打发: "dǎ fā",
  组长: "zǔ zhǎng",
  骨头: "gǔ tou",
  宁可: "nìng kě",
  更换: "gēng huàn",
  薄弱: "bó ruò",
  还原: "huán yuán",
  重修: "chóng xiū",
  重来: "chóng lái",
  只顾: "zhǐ gù",
  爱好: "ài hào",
  馒头: "mán tou",
  军长: "jūn zhǎng",
  首长: "shǒu zhǎng",
  厂长: "chǎng zhǎng",
  司长: "sī zhǎng",
  长子: "zhǎng zǐ",
  强劲: "qiáng jìng",
  恰当: "qià dàng",
  头儿: "tóu er",
  站长: "zhàn zhǎng",
  折腾: "zhē teng",
  相处: "xiāng chǔ",
  统率: "tǒng shuài",
  中将: "zhōng jiàng",
  命中: "mìng zhòng",
  名将: "míng jiàng",
  木头: "mù tou",
  动弹: "dòng tan",
  地壳: "dì qiào",
  干活: "gàn huó",
  少爷: "shào ye",
  水量: "shuǐ liàng",
  补给: "bǔ jǐ",
  尾巴: "wěi ba",
  来得: "lái de",
  好奇: "hào qí",
  钥匙: "yào shi",
  当做: "dàng zuò",
  沉着: "chén zhuó",
  哑巴: "yǎ ba",
  车子: "chē zi",
  上将: "shàng jiàng",
  恶心: "ě xīn",
  担子: "dàn zi",
  应届: "yīng jiè",
  主角: "zhǔ jué",
  运转: "yùn zhuǎn",
  兄长: "xiōng zhǎng",
  格式: "gé shì",
  正月: "zhēng yuè",
  营长: "yíng zhǎng",
  当成: "dàng chéng",
  女婿: "nǚ xu",
  咽喉: "yān hóu",
  重阳: "chóng yáng",
  化为: "huà wéi",
  吐蕃: "tǔ bō",
  钻进: "zuān jìn",
  乐队: "yuè duì",
  亮相: "liàng xiàng",
  被子: "bèi zi",
  舍得: "shě de",
  杉木: "shā mù",
  击中: "jī zhòng",
  排长: "pái zhǎng",
  假期: "jià qī",
  分量: "fèn liàng",
  数次: "shù cì",
  提防: "dī fáng",
  吆喝: "yāo he",
  查处: "chá chǔ",
  量子: "liàng zǐ",
  里头: "lǐ tou",
  调研: "diào yán",
  伺候: "cì hou",
  重申: "chóng shēn",
  枕头: "zhěn tou",
  拚命: "pīn mìng",
  社长: "shè zhǎng",
  归还: "guī huán",
  批量: "pī liàng",
  畜牧: "xù mù",
  点着: "diǎn zháo",
  甚为: "shèn wéi",
  小将: "xiǎo jiàng",
  着眼: "zhuó yǎn",
  处死: "chǔ sǐ",
  厌恶: "yàn wù",
  鼓乐: "gǔ yuè",
  树干: "shù gàn",
  秘鲁: "bì lǔ",
  大方: "dà fāng",
  外头: "wài tou",
  班长: "bān zhǎng",
  星宿: "xīng xiù",
  宁愿: "nìng yuàn",
  钦差: "qīn chāi",
  为数: "wéi shù",
  勾当: "gòu dàng",
  削减: "xuē jiǎn",
  间谍: "jiàn dié",
  埋怨: "mán yuàn",
  结实: "jiē shi",
  计量: "jì liáng",
  淹没: "yān mò",
  村长: "cūn zhǎng",
  连长: "lián zhǎng",
  自给: "zì jǐ",
  武将: "wǔ jiàng",
  温差: "wēn chā",
  直奔: "zhí bèn",
  供求: "gōng qiú",
  剂量: "jì liàng",
  道长: "dào zhǎng",
  泄露: "xiè lòu",
  王八: "wáng ba",
  切割: "qiē gē",
  间隔: "jiàn gé",
  一晃: "yì huǎng",
  长假: "cháng jià",
  令狐: "líng hú",
  为害: "wéi hài",
  句子: "jù zi",
  偿还: "cháng huán",
  疙瘩: "gē da",
  燕山: "yān shān",
  堵塞: "dǔ sè",
  夺冠: "duó guàn",
  扎实: "zhā shi",
  电荷: "diàn hè",
  看守: "kān shǒu",
  复辟: "fù bì",
  郁闷: "yù mèn",
  尽早: "jǐn zǎo",
  切断: "qiē duàn",
  指头: "zhǐ tou",
  为生: "wéi shēng",
  畜生: "chù sheng",
  切除: "qiē chú",
  着力: "zhuó lì",
  着想: "zhuó xiǎng",
  级差: "jí chā",
  投奔: "tóu bèn",
  棍子: "gùn zi",
  含糊: "hán hu",
  少妇: "shào fù",
  兴致: "xìng zhì",
  纳闷: "nà mèn",
  干流: "gàn liú",
  卷起: "juǎn qǐ",
  扇子: "shàn zi",
  更改: "gēng gǎi",
  笼络: "lǒng luò",
  喇叭: "lǎ ba",
  载荷: "zài hè",
  妥当: "tuǒ dàng",
  为难: "wéi nán",
  着陆: "zhuó lù",
  燕子: "yàn zi",
  干吗: "gàn má",
  白发: "bái fà",
  总得: "zǒng děi",
  夹击: "jiā jī",
  曝光: "bào guāng",
  曲调: "qǔ diào",
  相机: "xiàng jī",
  叫化: "jiào huà",
  角逐: "jué zhú",
  啊哟: "ā yō",
  载重: "zài zhòng",
  长辈: "zhǎng bèi",
  出差: "chū chāi",
  垛口: "duǒ kǒu",
  撇开: "piē kāi",
  厅长: "tīng zhǎng",
  组分: "zǔ fèn",
  误差: "wù chā",
  家当: "jiā dàng",
  传记: "zhuàn jì",
  个子: "gè zi",
  铺设: "pū shè",
  干事: "gàn shì",
  杆菌: "gǎn jūn",
  定量: "dìng liàng",
  运载: "yùn zài",
  会儿: "huì er",
  酋长: "qiú zhǎng",
  重返: "chóng fǎn",
  差额: "chā é",
  露面: "lòu miàn",
  钻研: "zuān yán",
  大城: "dài chéng",
  上当: "shàng dàng",
  销量: "xiāo liàng",
  作坊: "zuō fang",
  照相: "zhào xiàng",
  哎呀: "āi yā",
  调集: "diào jí",
  看中: "kàn zhòng",
  议长: "yì zhǎng",
  风筝: "fēng zheng",
  辟邪: "bì xié",
  空隙: "kòng xì",
  更迭: "gēng dié",
  偏差: "piān chā",
  声调: "shēng diào",
  适量: "shì liàng",
  屯子: "tún zi",
  无量: "wú liàng",
  空地: "kòng dì",
  调度: "diào dù",
  散射: "sǎn shè",
  创伤: "chuāng shāng",
  海参: "hǎi shēn",
  满载: "mǎn zài",
  重叠: "chóng dié",
  落差: "luò chā",
  单调: "dān diào",
  老将: "lǎo jiàng",
  人参: "rén shēn",
  间断: "jiàn duàn",
  重现: "chóng xiàn",
  夹杂: "jiā zá",
  调用: "diào yòng",
  萝卜: "luó bo",
  附着: "fù zhuó",
  应声: "yìng shēng",
  主将: "zhǔ jiàng",
  罪过: "zuì guo",
  咀嚼: "jǔ jué",
  为政: "wéi zhèng",
  过量: "guò liàng",
  乐曲: "yuè qǔ",
  负荷: "fù hè",
  枪弹: "qiāng dàn",
  悄然: "qiǎo rán",
  处方: "chǔ fāng",
  悄声: "qiǎo shēng",
  曲子: "qǔ zi",
  情调: "qíng diào",
  挑衅: "tiǎo xìn",
  代为: "dài wéi",
  了结: "liǎo jié",
  打中: "dǎ zhòng",
  酒吧: "jiǔ bā",
  懒得: "lǎn de",
  增量: "zēng liàng",
  衣着: "yī zhuó",
  部将: "bù jiàng",
  要塞: "yào sài",
  茶几: "chá jī",
  杠杆: "gàng gǎn",
  出没: "chū mò",
  鲜有: "xiǎn yǒu",
  间隙: "jiàn xì",
  重担: "zhòng dàn",
  重演: "chóng yǎn",
  重试: "chóng shì",
  应酬: "yìng chou",
  只当: "zhǐ dāng",
  毋宁: "wú nìng",
  包扎: "bāo zā",
  前头: "qián tou",
  卷烟: "juǎn yān",
  非得: "fēi děi",
  弹道: "dàn dào",
  杆子: "gān zi",
  门将: "mén jiàng",
  后头: "hòu tou",
  喝彩: "hè cǎi",
  暖和: "nuǎn huo",
  累积: "lěi jī",
  调遣: "diào qiǎn",
  倔强: "jué jiàng",
  宝藏: "bǎo zàng",
  丧事: "sāng shì",
  约莫: "yuē mo",
  纤夫: "qiàn fū",
  更替: "gēng tì",
  装载: "zhuāng zài",
  背包: "bēi bāo",
  帖子: "tiě zi",
  松散: "sōng sǎn",
  呼喝: "hū hè",
  可恶: "kě wù",
  自转: "zì zhuàn",
  供电: "gōng diàn",
  反省: "fǎn xǐng",
  坦率: "tǎn shuài",
  苏打: "sū dá",
  本分: "běn fèn",
  落得: "luò de",
  鄙薄: "bǐ bó",
  相间: "xiāng jiàn",
  单薄: "dān bó",
  混蛋: "hún dàn",
  贞观: "zhēn guān",
  附和: "fù hè",
  能耐: "néng nài",
  吓唬: "xià hu",
  未了: "wèi liǎo",
  引着: "yǐn zháo",
  抽调: "chōu diào",
  沙子: "shā zi",
  席卷: "xí juǎn",
  标的: "biāo dì",
  别扭: "biè niu",
  思量: "sī liang",
  喝采: "hè cǎi",
  论语: "lún yǔ",
  盖子: "gài zi",
  分外: "fèn wài",
  弄堂: "lòng táng",
  乐舞: "yuè wǔ",
  雨量: "yǔ liàng",
  毛发: "máo fà",
  差遣: "chāi qiǎn",
  背负: "bēi fù",
  转速: "zhuàn sù",
  声乐: "shēng yuè",
  夹攻: "jiā gōng",
  供水: "gōng shuǐ",
  主干: "zhǔ gàn",
  惩处: "chéng chǔ",
  长相: "zhǎng xiàng",
  公差: "gōng chāi",
  榴弹: "liú dàn",
  省得: "shěng de",
  条子: "tiáo zi",
  重围: "chóng wéi",
  阻塞: "zǔ sè",
  劲风: "jìng fēng",
  纠葛: "jiū gé",
  颠簸: "diān bǒ",
  点中: "diǎn zhòng",
  重创: "zhòng chuāng",
  姥姥: "lǎo lao",
  迷糊: "mí hu",
  公家: "gōng jia",
  几率: "jī lǜ",
  苦闷: "kǔ mèn",
  度量: "dù liàng",
  差错: "chā cuò",
  暑假: "shǔ jià",
  参差: "cēn cī",
  搭载: "dā zài",
  助长: "zhù zhǎng",
  相称: "xiāng chèn",
  红晕: "hóng yùn",
  舍命: "shě mìng",
  喜好: "xǐ hào",
  列传: "liè zhuàn",
  劲敌: "jìng dí",
  蛤蟆: "há ma",
  请假: "qǐng jià",
  钉子: "dīng zi",
  沉没: "chén mò",
  高丽: "gāo lí",
  休假: "xiū jià",
  无为: "wú wéi",
  巴结: "bā jie",
  了得: "liǎo dé",
  变相: "biàn xiàng",
  核弹: "hé dàn",
  亲家: "qìng jia",
  承载: "chéng zài",
  喝问: "hè wèn",
  还击: "huán jī",
  交还: "jiāo huán",
  将令: "jiàng lìng",
  单于: "chán yú",
  空缺: "kòng quē",
  绿林: "lù lín",
  胆量: "dǎn liàng",
  执着: "zhí zhuó",
  低调: "dī diào",
  闭塞: "bì sè",
  轻薄: "qīng bó",
  得当: "dé dàng",
  占卜: "zhān bǔ",
  扫帚: "sào zhou",
  龟兹: "qiū cí",
  年长: "nián zhǎng",
  外传: "wài zhuàn",
  头子: "tóu zi",
  裁缝: "cái feng",
  礼乐: "lǐ yuè",
  血泊: "xuè pō",
  散乱: "sǎn luàn",
  动量: "dòng liàng",
  倒腾: "dǎo teng",
  取舍: "qǔ shě",
  咱家: "zán jiā",
  长发: "cháng fà",
  爪哇: "zhǎo wā",
  弹壳: "dàn ké",
  省悟: "xǐng wù",
  嚷嚷: "rāng rang",
  连累: "lián lèi",
  应得: "yīng dé",
  族长: "zú zhǎng",
  柜子: "guì zi",
  擂鼓: "léi gǔ",
  眩晕: "xuàn yùn",
  调配: "tiáo pèi",
  躯干: "qū gàn",
  差役: "chāi yì",
  坎坷: "kǎn kě",
  少儿: "shào ér",
  乐团: "yuè tuán",
  养分: "yǎng fèn",
  退还: "tuì huán",
  格调: "gé diào",
  语调: "yǔ diào",
  音调: "yīn diào",
  乐府: "yuè fǔ",
  古朴: "gǔ pǔ",
  打点: "dǎ diǎn",
  差使: "chāi shǐ",
  匀称: "yún chèn",
  瘦削: "shòu xuē",
  膏药: "gāo yao",
  吞没: "tūn mò",
  调任: "diào rèn",
  散居: "sǎn jū",
  上头: "shàng tóu",
  风靡: "fēng mǐ",
  放假: "fàng jià",
  估量: "gū liang",
  失当: "shī dàng",
  中弹: "zhòng dàn",
  妄为: "wàng wéi",
  长者: "zhǎng zhě",
  起哄: "qǐ hòng",
  末了: "mò liǎo",
  相声: "xiàng sheng",
  校正: "jiào zhèng",
  劝降: "quàn xiáng",
  矢量: "shǐ liàng",
  沉闷: "chén mèn",
  给与: "jǐ yǔ",
  解法: "jiě fǎ",
  塞外: "sài wài",
  将校: "jiàng xiào",
  嗜好: "shì hào",
  没落: "mò luò",
  朴刀: "pō dāo",
  片子: "piān zi",
  切削: "qiē xiāo",
  弹丸: "dàn wán",
  稀薄: "xī bó",
  亏得: "kuī dé",
  间歇: "jiàn xiē",
  翘首: "qiáo shǒu",
  色调: "sè diào",
  处决: "chǔ jué",
  表率: "biǎo shuài",
  尺子: "chǐ zi",
  招降: "zhāo xiáng",
  称职: "chèn zhí",
  斗篷: "dǒu peng",
  铺子: "pù zi",
  底子: "dǐ zi",
  负载: "fù zài",
  干警: "gàn jǐng",
  倒数: "dào shǔ",
  将官: "jiàng guān",
  锄头: "chú tou",
  归降: "guī xiáng",
  疟疾: "nüè ji",
  唠叨: "láo dao",
  限量: "xiàn liàng",
  屏息: "bǐng xī",
  重逢: "chóng féng",
  器乐: "qì yuè",
  氢弹: "qīng dàn",
  脖颈: "bó gěng",
  妃子: "fēi zi",
  处事: "chǔ shì",
  参量: "cān liàng",
  轻率: "qīng shuài",
  缥缈: "piāo miǎo",
  中奖: "zhòng jiǎng",
  才干: "cái gàn",
  施舍: "shī shě",
  卷子: "juàn zi",
  游说: "yóu shuì",
  巷子: "xiàng zi",
  膀胱: "páng guāng",
  切勿: "qiè wù",
  看管: "kān guǎn",
  风头: "fēng tou",
  精干: "jīng gàn",
  高差: "gāo chā",
  恐吓: "kǒng hè",
  扁担: "biǎn dàn",
  给养: "jǐ yǎng",
  格子: "gé zi",
  供需: "gōng xū",
  反差: "fǎn chā",
  飞弹: "fēi dàn",
  微薄: "wēi bó",
  发型: "fà xíng",
  即兴: "jí xìng",
  攒动: "cuán dòng",
  间或: "jiàn huò",
  浅薄: "qiǎn bó",
  乐章: "yuè zhāng",
  顺差: "shùn chā",
  调子: "diào zi",
  相位: "xiàng wèi",
  转子: "zhuàn zǐ",
  劲旅: "jìng lǚ",
  咔嚓: "kā chā",
  了事: "liǎo shì",
  转悠: "zhuàn you",
  当铺: "dàng pù",
  爪子: "zhuǎ zi",
  单子: "dān zi",
  好战: "hào zhàn",
  燕麦: "yàn mài",
  只许: "zhǐ xǔ",
  干练: "gàn liàn",
  女将: "nǚ jiàng",
  酒量: "jiǔ liàng",
  划船: "huá chuán",
  伎俩: "jì liǎng",
  挑拨: "tiǎo bō",
  少校: "shào xiào",
  着落: "zhuó luò",
  憎恶: "zēng wù",
  刻薄: "kè bó",
  要挟: "yāo xié",
  用处: "yòng chu",
  还手: "huán shǒu",
  模具: "mú jù",
  执著: "zhí zhuó",
  喝令: "hè lìng",
  保长: "bǎo zhǎng",
  吸着: "xī zhe",
  症结: "zhēng jié",
  公转: "gōng zhuàn",
  校勘: "jiào kān",
  重提: "chóng tí",
  扫兴: "sǎo xìng",
  铺盖: "pū gài",
  长史: "zhǎng shǐ",
  差价: "chā jià",
  压根: "yà gēn",
  怔住: "zhèng zhù",
  应允: "yīng yǔn",
  切入: "qiē rù",
  战将: "zhàn jiàng",
  年少: "nián shào",
  舍身: "shě shēn",
  执拗: "zhí niù",
  处世: "chǔ shì",
  中风: "zhòng fēng",
  等量: "děng liàng",
  放量: "fàng liàng",
  腔调: "qiāng diào",
  老少: "lǎo shào",
  没入: "mò rù",
  瓜葛: "guā gé",
  将帅: "jiàng shuài",
  车载: "chē zài",
  窝囊: "wō nang",
  长进: "zhǎng jìn",
  可汗: "kè hán",
  并州: "bīng zhōu",
  供销: "gōng xiāo",
  切片: "qiē piàn",
  差事: "chāi shì",
  知会: "zhī hui",
  鹰爪: "yīng zhǎo",
  处女: "chǔ nǚ",
  切磋: "qiē cuō",
  日头: "rì tou",
  押解: "yā jiè",
  滋长: "zī zhǎng",
  道观: "dào guàn",
  脚色: "jué sè",
  当量: "dāng liàng",
  婆家: "pó jia",
  缘分: "yuán fèn",
  空闲: "kòng xián",
  好色: "hào sè",
  怒喝: "nù hè",
  笼统: "lǒng tǒng",
  边塞: "biān sài",
  何曾: "hé céng",
  重合: "chóng hé",
  零散: "líng sǎn",
  轰隆: "hōng lōng",
  化子: "huà zi",
  内蒙: "nèi měng",
  数落: "shǔ luò",
  逆差: "nì chā",
  牟利: "móu lì",
  栅栏: "zhà lan",
  中标: "zhòng biāo",
  调档: "diào dàng",
  佝偻: "gōu lóu",
  场子: "chǎng zi",
  甲壳: "jiǎ qiào",
  重温: "chóng wēn",
  炮制: "páo zhì",
  返还: "fǎn huán",
  自传: "zì zhuàn",
  高调: "gāo diào",
  殷红: "yān hóng",
  固着: "gù zhuó",
  强求: "qiǎng qiú",
  本相: "běn xiàng",
  骄横: "jiāo hèng",
  草率: "cǎo shuài",
  气闷: "qì mèn",
  着色: "zhuó sè",
  宁肯: "nìng kěn",
  兴头: "xìng tou",
  拘泥: "jū nì",
  夹角: "jiā jiǎo",
  发髻: "fà jì",
  猛将: "měng jiàng",
  约摸: "yuē mo",
  拖累: "tuō lěi",
  呢绒: "ní róng",
  钻探: "zuān tàn",
  夹层: "jiā céng",
  落魄: "luò pò",
  巷道: "hàng dào",
  运量: "yùn liàng",
  解闷: "jiě mèn",
  空儿: "kòng er",
  估摸: "gū mo",
  好客: "hào kè",
  钻孔: "zuān kǒng",
  糊弄: "hù nòng",
  荥阳: "xíng yáng",
  烦闷: "fán mèn",
  仓卒: "cāng cù",
  分叉: "fēn chà",
  厂子: "chǎng zi",
  小调: "xiǎo diào",
  少阳: "shào yáng",
  受降: "shòu xiáng",
  染坊: "rǎn fáng",
  胳臂: "gē bei",
  将门: "jiàng mén",
  模板: "mú bǎn",
  配给: "pèi jǐ",
  为伍: "wéi wǔ",
  跟头: "gēn tou",
  划算: "huá suàn",
  累赘: "léi zhui",
  哄笑: "hōng xiào",
  晕眩: "yūn xuàn",
  干掉: "gàn diào",
  缝制: "féng zhì",
  难处: "nán chù",
  着意: "zhuó yì",
  蛮横: "mán hèng",
  奇数: "jī shù",
  短发: "duǎn fà",
  生还: "shēng huán",
  还清: "huán qīng",
  看护: "kān hù",
  直率: "zhí shuài",
  奏乐: "zòu yuè",
  载客: "zài kè",
  专横: "zhuān hèng",
  湮没: "yān mò",
  空格: "kòng gé",
  铺垫: "pū diàn",
  良将: "liáng jiàng",
  哗啦: "huā lā",
  散漫: "sǎn màn",
  脱发: "tuō fà",
  送还: "sòng huán",
  埋没: "mái mò",
  累及: "lěi jí",
  薄雾: "bó wù",
  调离: "diào lí",
  舌苔: "shé tāi",
  机长: "jī zhǎng",
  栓塞: "shuān sè",
  配角: "pèi jué",
  切口: "qiē kǒu",
  创口: "chuāng kǒu",
  哈欠: "hā qian",
  实弹: "shí dàn",
  铺平: "pū píng",
  哈达: "hǎ dá",
  懒散: "lǎn sǎn",
  实干: "shí gàn",
  填空: "tián kòng",
  刁钻: "diāo zuān",
  乐师: "yuè shī",
  量变: "liàng biàn",
  诱降: "yòu xiáng",
  搪塞: "táng sè",
  征调: "zhēng diào",
  夹道: "jiā dào",
  干咳: "gān ké",
  止咳: "zhǐ ké",
  乐工: "yuè gōng",
  划过: "huá guò",
  着火: "zháo huǒ",
  更正: "gēng zhèng",
  给付: "jǐ fù",
  空子: "kòng zi",
  哪吒: "né zhā",
  正着: "zhèng zháo",
  刷子: "shuā zi",
  丧葬: "sāng zàng",
  夹带: "jiā dài",
  安分: "ān fèn",
  中意: "zhòng yì",
  长孙: "zhǎng sūn",
  校订: "jiào dìng",
  卷曲: "juǎn qū",
  载运: "zài yùn",
  投弹: "tóu dàn",
  柞蚕: "zuò cán",
  份量: "fèn liàng",
  调换: "diào huàn",
  了然: "liǎo rán",
  咧嘴: "liě zuǐ",
  典当: "diǎn dàng",
  寒假: "hán jià",
  长兄: "zhǎng xiōng",
  给水: "jǐ shuǐ",
  须发: "xū fà",
  枝干: "zhī gàn",
  属相: "shǔ xiàng",
  哄抢: "hōng qiǎng",
  刻划: "kè huà",
  塞子: "sāi zi",
  单干: "dān gàn",
  还乡: "huán xiāng",
  兆头: "zhào tou",
  寺观: "sì guàn",
  督率: "dū shuài",
  啊哈: "ā ha",
  割舍: "gē shě",
  抹布: "mā bù",
  好恶: "hào wù",
  下处: "xià chǔ",
  消长: "xiāo zhǎng",
  离间: "lí jiàn",
  准头: "zhǔn tou",
  校对: "jiào duì",
  什物: "shí wù",
  番禺: "pān yú",
  佛爷: "fó ye",
  吗啡: "mǎ fēi",
  盐分: "yán fèn",
  虎将: "hǔ jiàng",
  薄荷: "bò he",
  独处: "dú chǔ",
  空位: "kòng wèi",
  铺路: "pū lù",
  乌拉: "wū lā",
  调回: "diào huí",
  来头: "lái tou",
  闲散: "xián sǎn",
  胶卷: "jiāo juǎn",
  冒失: "mào shi",
  干劲: "gàn jìn",
  弦乐: "xián yuè",
  相国: "xiàng guó",
  丹参: "dān shēn",
  助兴: "zhù xìng",
  铺开: "pū kāi",
  次长: "cì zhǎng",
  发卡: "fà qiǎ",
  拮据: "jié jū",
  刹车: "shā chē",
  生发: "shēng fà",
  重播: "chóng bō",
  缝合: "féng hé",
  音量: "yīn liàng",
  少尉: "shào wèi",
  冲压: "chòng yā",
  苍劲: "cāng jìng",
  厚薄: "hòu báo",
  威吓: "wēi hè",
  外相: "wài xiàng",
  呼号: "hū háo",
  着迷: "zháo mí",
  挑担: "tiāo dàn",
  纹路: "wén lù",
  还俗: "huán sú",
  强横: "qiáng hèng",
  着数: "zhāo shù",
  降顺: "xiáng shùn",
  挑明: "tiǎo míng",
  眯缝: "mī feng",
  分内: "fèn nèi",
  更衣: "gēng yī",
  软和: "ruǎn huo",
  尽兴: "jìn xìng",
  号子: "hào zi",
  爪牙: "zhǎo yá",
  败将: "bài jiàng",
  猜中: "cāi zhòng",
  结扎: "jié zā",
  没空: "méi kòng",
  夹缝: "jiā fèng",
  拾掇: "shí duo",
  掺和: "chān huo",
  簸箕: "bò ji",
  电量: "diàn liàng",
  荷载: "hè zǎi",
  调式: "diào shì",
  处身: "chǔ shēn",
  打手: "dǎ shǒu",
  弹弓: "dàn gōng",
  横蛮: "hèng mán",
  能干: "néng gàn",
  校点: "jiào diǎn",
  加载: "jiā zài",
  干校: "gàn xiào",
  哄传: "hōng chuán",
  校注: "jiào zhù",
  淤塞: "yū sè",
  马扎: "mǎ zhá",
  月氏: "yuè zhī",
  高干: "gāo gàn",
  经传: "jīng zhuàn",
  曾孙: "zēng sūn",
  好斗: "hào dòu",
  关卡: "guān qiǎ",
  逃奔: "táo bèn",
  磨蹭: "mó ceng",
  牟取: "móu qǔ",
  颤栗: "zhàn lì",
  蚂蚱: "mà zha",
  撮合: "cuō he",
  趔趄: "liè qie",
  摔打: "shuāi dǎ",
  台子: "tái zi",
  分得: "fēn de",
  粘着: "nián zhuó",
  采邑: "cài yì",
  散装: "sǎn zhuāng",
  婀娜: "ē nuó",
  兴味: "xìng wèi",
  行头: "xíng tou",
  气量: "qì liàng",
  调运: "diào yùn",
  处治: "chǔ zhì",
  乐音: "yuè yīn",
  充塞: "chōng sè",
  恫吓: "dòng hè",
  论调: "lùn diào",
  相中: "xiāng zhòng",
  民乐: "mín yuè",
  炮仗: "pào zhang",
  丧服: "sāng fú",
  骁将: "xiāo jiàng",
  量刑: "liàng xíng",
  缝补: "féng bǔ",
  财会: "cái kuài",
  大干: "dà gàn",
  历数: "lì shǔ",
  校场: "jiào chǎng",
  塞北: "sài běi",
  识相: "shí xiàng",
  辱没: "rǔ mò",
  鲜亮: "xiān liàng",
  语塞: "yǔ sè",
  露脸: "lòu liǎn",
  凉快: "liáng kuai",
  腰杆: "yāo gǎn",
  溜达: "liū da",
  嘎嘎: "gā gā",
  公干: "gōng gàn",
  桔梗: "jié gěng",
  挑逗: "tiǎo dòu",
  看门: "kān mén",
  乐歌: "yuè gē",
  拓片: "tà piàn",
  挑动: "tiǎo dòng",
  准将: "zhǔn jiàng",
  遒劲: "qiú jìng",
  磨坊: "mò fáng",
  逶迤: "wēi yí",
  搅和: "jiǎo huo",
  摩挲: "mó suō",
  作弄: "zuò nòng",
  苗头: "miáo tou",
  打颤: "dǎ zhàn",
  大藏: "dà zàng",
  畜牲: "chù shēng",
  勾搭: "gōu da",
  树荫: "shù yīn",
  树杈: "shù chà",
  铁杆: "tiě gǎn",
  将相: "jiàng xiàng",
  份子: "fèn zi",
  视差: "shì chā",
  绿荫: "lǜ yīn",
  枪杆: "qiāng gǎn",
  缝纫: "féng rèn",
  愁闷: "chóu mèn",
  点将: "diǎn jiàng",
  华佗: "huà tuó",
  劲射: "jìng shè",
  箱笼: "xiāng lǒng",
  终了: "zhōng liǎo",
  鬓发: "bìn fà",
  结巴: "jiē ba",
  苦干: "kǔ gàn",
  看家: "kān jiā",
  正旦: "zhēng dàn",
  中肯: "zhòng kěn",
  厦门: "xià mén",
  东莞: "dōng guǎn",
  食量: "shí liàng",
  宫调: "gōng diào",
  间作: "jiàn zuò",
  弹片: "dàn piàn",
  差池: "chā chí",
  漂白: "piǎo bái",
  杠子: "gàng zi",
  调处: "tiáo chǔ",
  好动: "hào dòng",
  转炉: "zhuàn lú",
  屏气: "bǐng qì",
  夹板: "jiā bǎn",
  哀乐: "āi yuè",
  干道: "gàn dào",
  苦处: "kǔ chù",
  劈柴: "pǐ chái",
  长势: "zhǎng shì",
  天华: "tiān huá",
  共处: "gòng chǔ",
  校验: "jiào yàn",
  出塞: "chū sài",
  磨盘: "mò pán",
  萎靡: "wěi mǐ",
  奔丧: "bēn sāng",
  唱和: "chàng hè",
  大调: "dà diào",
  非分: "fēi fèn",
  钻营: "zuān yíng",
  夹子: "jiā zi",
  超载: "chāo zài",
  更始: "gēng shǐ",
  铃铛: "líng dang",
  披散: "pī sàn",
  发还: "fā huán",
  转轮: "zhuàn lún",
  横财: "hèng cái",
  泡桐: "pāo tóng",
  抛撒: "pāo sǎ",
  天呀: "tiān yā",
  糊糊: "hū hu",
  躯壳: "qū qiào",
  通量: "tōng liàng",
  奉还: "fèng huán",
  午觉: "wǔ jiào",
  闷棍: "mèn gùn",
  浪头: "làng tou",
  砚台: "yàn tái",
  油坊: "yóu fáng",
  学长: "xué zhǎng",
  过载: "guò zài",
  笔调: "bǐ diào",
  衣被: "yī bèi",
  畜产: "xù chǎn",
  调阅: "diào yuè",
  蛮干: "mán gàn",
  曾祖: "zēng zǔ",
  提干: "tí gàn",
  变调: "biàn diào",
  覆没: "fù mò",
  模子: "mú zi",
  乐律: "yuè lǜ",
  称心: "chèn xīn",
  木杆: "mù gān",
  重印: "chóng yìn",
  自省: "zì xǐng",
  提调: "tí diào",
  看相: "kàn xiàng",
  芋头: "yù tou",
  下切: "xià qiē",
  塞上: "sài shàng",
  铺张: "pū zhāng",
  藤蔓: "téng wàn",
  薄幸: "bó xìng",
  解数: "xiè shù",
  褪去: "tuì qù",
  霰弹: "xiàn dàn",
  柚木: "yóu mù",
  痕量: "hén liàng",
  雅乐: "yǎ yuè",
  号哭: "háo kū",
  诈降: "zhà xiáng",
  猪圈: "zhū juàn",
  咋舌: "zé shé",
  铣床: "xǐ chuáng",
  防弹: "fáng dàn",
  健将: "jiàn jiàng",
  丽水: "lí shuǐ",
  削发: "xuē fà",
  空当: "kòng dāng",
  多相: "duō xiàng",
  鲜见: "xiǎn jiàn",
  划桨: "huá jiǎng",
  载波: "zài bō",
  跳蚤: "tiào zao",
  俏皮: "qiào pí",
  吧嗒: "bā dā",
  结发: "jié fà",
  了断: "liǎo duàn",
  同调: "tóng diào",
  石磨: "shí mò",
  时差: "shí chā",
  鼻塞: "bí sè",
  挑子: "tiāo zi",
  推磨: "tuī mò",
  武侯: "wǔ hóu",
  抹煞: "mǒ shā",
  调转: "diào zhuǎn",
  籍没: "jí mò",
  还债: "huán zhài",
  调演: "diào yǎn",
  分划: "fēn huá",
  奇偶: "jī ǒu",
  断喝: "duàn hè",
  闷雷: "mèn léi",
  狼藉: "láng jí",
  饭量: "fàn liàng",
  还礼: "huán lǐ",
  转调: "zhuǎn diào",
  星相: "xīng xiàng",
  手相: "shǒu xiàng",
  配乐: "pèi yuè",
  盖头: "gài tou",
  连杆: "lián gǎn",
  簿记: "bù jì",
  刀把: "dāo bà",
  量词: "liàng cí",
  名角: "míng jué",
  步调: "bù diào",
  校本: "jiào běn",
  账簿: "zhàng bù",
  隽永: "juàn yǒng",
  稍为: "shāo wéi",
  易传: "yì zhuàn",
  乐谱: "yuè pǔ",
  牵累: "qiān lěi",
  答理: "dā li",
  喝斥: "hè chì",
  吟哦: "yín é",
  干渠: "gàn qú",
  海量: "hǎi liàng",
  精当: "jīng dàng",
  着床: "zhuó chuáng",
  月相: "yuè xiàng",
  庶几: "shù jī",
  宫观: "gōng guàn",
  论处: "lùn chǔ",
  征辟: "zhēng bì",
  厚朴: "hòu pò",
  介壳: "jiè qiào",
  吭哧: "kēng chī",
  咯血: "kǎ xiě",
  铺陈: "pū chén",
  重生: "chóng shēng",
  乐理: "yuè lǐ",
  哀号: "āi háo",
  藏历: "zàng lì",
  刚劲: "gāng jìng",
  削平: "xuē píng",
  浓荫: "nóng yīn",
  城垛: "chéng duǒ",
  当差: "dāng chāi",
  正传: "zhèng zhuàn",
  并处: "bìng chǔ",
  创面: "chuāng miàn",
  旦角: "dàn jué",
  薄礼: "bó lǐ",
  晃荡: "huàng dang",
  臊子: "sào zi",
  家什: "jiā shí",
  闷头: "mēn tóu",
  美发: "měi fà",
  度数: "dù shu",
  着凉: "zháo liáng",
  闯将: "chuǎng jiàng",
  几案: "jī àn",
  姘头: "pīn tou",
  差数: "chā shù",
  散碎: "sǎn suì",
  壅塞: "yōng sè",
  寒颤: "hán zhàn",
  牵强: "qiān qiǎng",
  无间: "wú jiàn",
  轮转: "lún zhuàn",
  号叫: "háo jiào",
  铺排: "pū pái",
  降伏: "xiáng fú",
  轧钢: "zhá gāng",
  东阿: "dōng ē",
  病假: "bìng jià",
  累加: "lěi jiā",
  梗塞: "gěng sè",
  弹夹: "dàn jiā",
  钻心: "zuān xīn",
  晃眼: "huǎng yǎn",
  魔爪: "mó zhǎo",
  标量: "biāo liàng",
  憋闷: "biē mèn",
  猜度: "cāi duó",
  处士: "chǔ shì",
  官差: "guān chāi",
  讨还: "tǎo huán",
  长门: "cháng mén",
  馏分: "liú fēn",
  里弄: "lǐ lòng",
  色相: "sè xiàng",
  雅兴: "yǎ xìng",
  角力: "jué lì",
  弹坑: "dàn kēng",
  枝杈: "zhī chà",
  夹具: "jiā jù",
  处刑: "chǔ xíng",
  悍将: "hàn jiàng",
  好学: "hào xué",
  好好: "hǎo hǎo",
  银发: "yín fà",
  扫把: "sào bǎ",
  法相: "fǎ xiàng",
  贵干: "guì gàn",
  供气: "gōng qì",
  空余: "kòng yú",
  捆扎: "kǔn zā",
  瘠薄: "jí bó",
  浆糊: "jiàng hu",
  嘎吱: "gā zhī",
  调令: "diào lìng",
  法帖: "fǎ tiè",
  淋病: "lìn bìng",
  调派: "diào pài",
  转盘: "zhuàn pán",
  供稿: "gōng gǎo",
  差官: "chāi guān",
  忧闷: "yōu mèn",
  教长: "jiào zhǎng",
  重唱: "chóng chàng",
  酒兴: "jiǔ xìng",
  乐坛: "yuè tán",
  花呢: "huā ní",
  叱喝: "chì hè",
  膀臂: "bǎng bì",
  得空: "dé kòng",
  转圈: "zhuàn quān",
  横暴: "hèng bào",
  哄抬: "hōng tái",
  引吭: "yǐn háng",
  载货: "zài huò",
  中计: "zhòng jì",
  官长: "guān zhǎng",
  相面: "xiàng miàn",
  看头: "kàn tou",
  盼头: "pàn tou",
  意兴: "yì xìng",
  军乐: "jūn yuè",
  累次: "lěi cì",
  骨嘟: "gǔ dū",
  燕赵: "yān zhào",
  报丧: "bào sāng",
  弥撒: "mí sa",
  挨斗: "ái dòu",
  扁舟: "piān zhōu",
  丑角: "chǒu jué",
  吊丧: "diào sāng",
  强将: "qiáng jiàng",
  重奏: "chóng zòu",
  发辫: "fà biàn",
  着魔: "zháo mó",
  着法: "zhāo fǎ",
  盛放: "shèng fàng",
  填塞: "tián sè",
  凶横: "xiōng hèng",
  稽首: "qǐ shǒu",
  碑帖: "bēi tiè",
  冲量: "chōng liàng",
  发菜: "fà cài",
  假发: "jiǎ fà",
  翻卷: "fān juǎn",
  小量: "xiǎo liàng",
  胶着: "jiāo zhuó",
  里子: "lǐ zi",
  调调: "diào diao",
  散兵: "sǎn bīng",
  高挑: "gāo tiǎo",
  播撒: "bō sǎ",
  夹心: "jiā xīn",
  扇动: "shān dòng",
  叨扰: "tāo rǎo",
  霓裳: "ní cháng",
  捻子: "niǎn zi",
  弥缝: "mí féng",
  撒布: "sǎ bù",
  场院: "cháng yuàn",
  省亲: "xǐng qīn",
  提拉: "tí lā",
  惯量: "guàn liàng",
  强逼: "qiáng bī",
  强征: "qiáng zhēng",
  晕车: "yùn chē",
  数道: "shù dào",
  带累: "dài lèi",
  拓本: "tà běn",
  嫌恶: "xián wù",
  宿将: "sù jiàng",
  龟裂: "jūn liè",
  缠夹: "chán jiā",
  发式: "fà shì",
  隔扇: "gé shàn",
  天分: "tiān fèn",
  癖好: "pǐ hào",
  四通: "sì tōng",
  白术: "bái zhú",
  划伤: "huá shāng",
  角斗: "jué dòu",
  听差: "tīng chāi",
  岁差: "suì chā",
  丧礼: "sāng lǐ",
  脉脉: "mò mò",
  削瘦: "xuē shòu",
  撒播: "sǎ bō",
  莎草: "suō cǎo",
  犍为: "qián wéi",
  调头: "diào tóu",
  龙卷: "lóng juǎn",
  外调: "wài diào",
  字帖: "zì tiè",
  卷发: "juǎn fà",
  揣度: "chuǎi duó",
  洋相: "yáng xiàng",
  散光: "sǎn guāng",
  骨碌: "gū lu",
  薄命: "bó mìng",
  笼头: "lóng tóu",
  咽炎: "yān yán",
  碌碡: "liù zhou",
  片儿: "piàn er",
  纤手: "qiàn shǒu",
  散体: "sǎn tǐ",
  内省: "nèi xǐng",
  强留: "qiáng liú",
  解送: "jiè sòng",
  反间: "fǎn jiàn",
  少壮: "shào zhuàng",
  留空: "liú kōng",
  告假: "gào jià",
  咳血: "ké xuè",
  薄暮: "bó mù",
  铺轨: "pū guǐ",
  磨削: "mó xuē",
  治丧: "zhì sāng",
  叉子: "chā zi",
  哄动: "hōng dòng",
  蛾子: "é zi",
  出落: "chū luò",
  股长: "gǔ zhǎng",
  贵处: "guì chù",
  还魂: "huán hún",
  例假: "lì jià",
  刹住: "shā zhù",
  身量: "shēn liàng",
  同好: "tóng hào",
  模量: "mó liàng",
  更生: "gēng shēng",
  服丧: "fú sāng",
  率直: "shuài zhí",
  字模: "zì mú",
  散架: "sǎn jià",
  答腔: "dā qiāng",
  交恶: "jiāo wù",
  薄情: "bó qíng",
  眼泡: "yǎn pāo",
  袅娜: "niǎo nuó",
  草垛: "cǎo duò",
  冲劲: "chòng jìn",
  呢喃: "ní nán",
  切中: "qiè zhòng",
  挑灯: "tiǎo dēng",
  还愿: "huán yuàn",
  激将: "jī jiàng",
  更鼓: "gēng gǔ",
  没药: "mò yào",
  败兴: "bài xìng",
  切面: "qiē miàn",
  散户: "sǎn hù",
  累进: "lěi jìn",
  背带: "bēi dài",
  秤杆: "chèng gǎn",
  碾坊: "niǎn fáng",
  簿子: "bù zi",
  扳手: "bān shǒu",
  铅山: "yán shān",
  儒将: "rú jiàng",
  重光: "chóng guāng",
  剪发: "jiǎn fà",
  长上: "zhǎng shàng",
  小传: "xiǎo zhuàn",
  压轴: "yā zhòu",
  弱冠: "ruò guàn",
  花卷: "huā juǎn",
  横祸: "hèng huò",
  夹克: "jiā kè",
  光晕: "guāng yùn",
  披靡: "pī mǐ",
  对调: "duì diào",
  夹持: "jiā chí",
  空额: "kòng é",
  平调: "píng diào",
  铺床: "pū chuáng",
  丧钟: "sāng zhōng",
  作乐: "zuò lè",
  少府: "shào fǔ",
  数数: "shuò shuò",
  奔头: "bèn tou",
  进给: "jìn jǐ",
  率性: "shuài xìng",
  乐子: "lè zi",
  绑扎: "bǎng zā",
  挑唆: "tiǎo suō",
  漂洗: "piǎo xǐ",
  夹墙: "jiā qiáng",
  咳喘: "ké chuǎn",
  乜斜: "miē xie",
  错处: "cuò chù",
  闷酒: "mèn jiǔ",
  时调: "shí diào",
  重孙: "chóng sūn",
  经幢: "jīng chuáng",
  圩场: "xū chǎng",
  调门: "diào mén",
  花头: "huā tóu",
  划拉: "huá la",
  套色: "tào shǎi",
  粗率: "cū shuài",
  相率: "xiāng shuài",
  款识: "kuǎn zhì",
  吁请: "yù qǐng",
  荫蔽: "yīn bì",
  文蛤: "wén gé",
  嘀嗒: "dī dā",
  调取: "diào qǔ",
  交差: "jiāo chāi",
  落子: "luò zǐ",
  相册: "xiàng cè",
  絮叨: "xù dao",
  落发: "luò fà",
  异相: "yì xiàng",
  浸没: "jìn mò",
  角抵: "jué dǐ",
  卸载: "xiè zài",
  春卷: "chūn juǎn",
  扎挣: "zhá zheng",
  畜养: "xù yǎng",
  吡咯: "bǐ luò",
  垛子: "duò zi",
  恶少: "è shào",
  发际: "fà jì",
  红苕: "hóng sháo",
  糨糊: "jiàng hu",
  哭丧: "kū sāng",
  稍息: "shào xī",
  晕船: "yùn chuán",
  校样: "jiào yàng",
  外差: "wài chā",
  脚爪: "jiǎo zhǎo",
  铺展: "pū zhǎn",
  芫荽: "yán sui",
  夹紧: "jiā jǐn",
  尿泡: "suī pào",
  丧乱: "sāng luàn",
  凶相: "xiōng xiàng",
  华发: "huá fà",
  打场: "dǎ cháng",
  云量: "yún liàng",
  正切: "zhèng qiē",
  划拳: "huá quán",
  划艇: "huá tǐng",
  评传: "píng zhuàn",
  拉纤: "lā qiàn",
  句读: "jù dòu",
  散剂: "sǎn jì",
  骨殖: "gǔ shi",
  塞音: "sè yīn",
  铺叙: "pū xù",
  阏氏: "yān zhī",
  冷颤: "lěng zhàn",
  煞住: "shā zhù",
  少男: "shào nán",
  管乐: "guǎn yuè",
  号啕: "háo táo",
  纳降: "nà xiáng",
  拥塞: "yōng sè",
  万乘: "wàn shèng",
  杆儿: "gǎn ér",
  葛藤: "gé téng",
  簿籍: "bù jí",
  皮夹: "pí jiā",
  校准: "jiào zhǔn",
  允当: "yǔn dàng",
  器量: "qì liàng",
  选调: "xuǎn diào",
  扮相: "bàn xiàng",
  干才: "gàn cái",
  基干: "jī gàn",
  割切: "gē qiē",
  国乐: "guó yuè",
  卡壳: "qiǎ ké",
  辟谷: "bì gǔ",
  磨房: "mò fáng",
  咿呀: "yī yā",
  芥末: "jiè mo",
  薄技: "bó jì",
  产假: "chǎn jià",
  诗兴: "shī xìng",
  重出: "chóng chū",
  转椅: "zhuàn yǐ",
  酌量: "zhuó liang",
  簿册: "bù cè",
  藏青: "zàng qīng",
  的士: "dī shì",
  调人: "diào rén",
  解元: "jiè yuán",
  茎干: "jīng gàn",
  巨量: "jù liàng",
  榔头: "láng tou",
  率真: "shuài zhēn",
  喷香: "pèn xiāng",
  锁钥: "suǒ yuè",
  虾蟆: "há má",
  相图: "xiàng tú",
  兴会: "xìng huì",
  灶头: "zào tóu",
  重婚: "chóng hūn",
  钻洞: "zuān dòng",
  忖度: "cǔn duó",
  党参: "dǎng shēn",
  调温: "diào wēn",
  杆塔: "gān tǎ",
  葛布: "gé bù",
  拱券: "gǒng xuàn",
  夹生: "jiā shēng",
  露馅: "lòu xiàn",
  恰切: "qià qiè",
  散见: "sǎn jiàn",
  哨卡: "shào qiǎ",
  烫发: "tàng fà",
  体量: "tǐ liàng",
  挺括: "tǐng kuò",
  系带: "jì dài",
  相士: "xiàng shì",
  羊圈: "yáng juàn",
  转矩: "zhuàn jǔ",
  吧台: "bā tái",
  苍术: "cāng zhú",
  菲薄: "fěi bó",
  蛤蚧: "gé jiè",
  蛤蜊: "gé lí",
  瓜蔓: "guā wàn",
  怪相: "guài xiàng",
  临帖: "lín tiè",
  女红: "nǚ gōng",
  刨床: "bào chuáng",
  翘楚: "qiáo chǔ",
  数九: "shǔ jiǔ",
  谈兴: "tán xìng",
  雄劲: "xióng jìng",
  扎染: "zā rǎn",
  遮荫: "zhē yīn",
  周正: "zhōu zhèng",
  赚头: "zhuàn tou",
  扒手: "pá shǒu",
  搀和: "chān huo",
  诚朴: "chéng pǔ",
  肚量: "dù liàng",
  干结: "gān jié",
  工尺: "gōng chě",
  家累: "jiā lěi",
  曲水: "qū shuǐ",
  沙参: "shā shēn",
  挑花: "tiǎo huā",
  阿门: "ā mén",
  背篓: "bēi lǒu",
  瘪三: "biē sān",
  裁处: "cái chǔ",
  创痛: "chuāng tòng",
  福相: "fú xiàng",
  更动: "gēng dòng",
  豪兴: "háo xìng",
  还阳: "huán yáng",
  还嘴: "huán zuǐ",
  借调: "jiè diào",
  卷云: "juǎn yún",
  流弹: "liú dàn",
  想头: "xiǎng tou",
  削价: "xuē jià",
  校阅: "jiào yuè",
  雅量: "yǎ liàng",
  别传: "bié zhuàn",
  薄酒: "bó jiǔ",
  春假: "chūn jià",
  发妻: "fà qī",
  哗哗: "huā huā",
  宽绰: "kuān chuo",
  了悟: "liǎo wù",
  切花: "qiē huā",
  审度: "shěn duó",
  应许: "yīng xǔ",
  转台: "zhuàn tái",
  仔猪: "zǐ zhū",
  裁量: "cái liáng",
  藏戏: "zàng xì",
  乘兴: "chéng xìng",
  绸缪: "chóu móu",
  摧折: "cuī zhé",
  调经: "tiáo jīng",
  调职: "diào zhí",
  缝缀: "féng zhuì",
  骨朵: "gū duǒ",
  核儿: "hú er",
  恒量: "héng liàng",
  还价: "huán jià",
  浑朴: "hún pǔ",
  苦差: "kǔ chāi",
  面糊: "miàn hù",
  煞车: "shā chē",
  省视: "xǐng shì",
  什锦: "shí jǐn",
  信差: "xìn chāi",
  余切: "yú qiē",
  攒眉: "cuán méi",
  炸糕: "zhá gāo",
  钻杆: "zuàn gǎn",
  扒灰: "pá huī",
  拌和: "bàn huò",
  长调: "cháng diào",
  大溜: "dà liù",
  抖搂: "dǒu lōu",
  飞转: "fēi zhuàn",
  干仗: "gàn zhàng",
  好胜: "hào shèng",
  画片: "huà piàn",
  搅混: "jiǎo hún",
  螺杆: "luó gǎn",
  木模: "mù mú",
  怒号: "nù háo",
  频数: "pín shù",
  无宁: "wú níng",
  遗少: "yí shào",
  邮差: "yóu chāi",
  占卦: "zhān guà",
  占星: "zhān xīng",
  重审: "chóng shěn",
  自量: "zì liàng",
  调防: "diào fáng",
  发廊: "fà láng",
  反调: "fǎn diào",
  缝子: "fèng zi",
  更夫: "gēng fū",
  骨子: "gǔ zi",
  光杆: "guāng gǎn",
  夹棍: "jiā gùn",
  居丧: "jū sāng",
  巨贾: "jù gǔ",
  看押: "kān yā",
  空转: "kōng zhuàn",
  量力: "liàng lì",
  炮烙: "páo luò",
  赔还: "péi huán",
  扑扇: "pū shān",
  散记: "sǎn jì",
  散件: "sǎn jiàn",
  删削: "shān xuē",
  射干: "shè gàn",
  条几: "tiáo jī",
  偷空: "tōu kòng",
  削壁: "xuē bì",
  校核: "jiào hé",
  阴干: "yīn gān",
  择菜: "zhái cài",
  重九: "chóng jiǔ",
  主调: "zhǔ diào",
  自禁: "zì jīn",
  吧唧: "bā jī",
  便溺: "biàn niào",
  词调: "cí diào",
  叨咕: "dáo gu",
  落枕: "lào zhěn",
  铺砌: "pū qì",
  刷白: "shuà bái",
  委靡: "wěi mǐ",
  系泊: "xì bó",
  相马: "xiàng mǎ",
  熨帖: "yù tiē",
  转筋: "zhuàn jīn",
  棒喝: "bàng hè",
  傧相: "bīn xiàng",
  镐头: "gǎo tóu",
  间苗: "jiàn miáo",
  乐池: "yuè chí",
  卖相: "mài xiàng",
  屏弃: "bǐng qì",
  铅弹: "qiān dàn",
  切变: "qiē biàn",
  请调: "qǐng diào",
  群氓: "qún méng",
  散板: "sǎn bǎn",
  省察: "xǐng chá",
  事假: "shì jià",
  纤绳: "qiàn shéng",
  重影: "chóng yǐng",
  耕种: "gēng zhòng",
  种地: "zhòng dì",
  种菜: "zhòng cài",
  栽种: "zāi zhòng",
  接种: "jiē zhòng",
  垦种: "kěn zhòng",
  种殖: "zhòng zhí",
  种瓜: "zhòng guā",
  种豆: "zhòng dòu",
  种树: "zhòng shù",
  睡着: "shuì zháo",
  笼子: "lóng zi",
  重启: "chóng qǐ",
  重整: "chóng zhěng",
  重弹: "chóng tán",
  重足: "chóng zú",
  重山: "chóng shān",
  重游: "chóng yóu",
  重峦: "chóng luán",
  爷爷: "yé ye",
  奶奶: "nǎi nai",
  姥爷: "lǎo ye",
  爸爸: "bà ba",
  妈妈: "mā ma",
  婶婶: "shěn shen",
  舅舅: "jiù jiu",
  姑姑: "gū gu",
  叔叔: "shū shu",
  姨夫: "yí fu",
  舅母: "jiù mu",
  姑父: "gū fu",
  姐夫: "jiě fu",
  婆婆: "pó po",
  公公: "gōng gong",
  舅子: "jiù zi",
  姐姐: "jiě jie",
  哥哥: "gē ge",
  妹妹: "mèi mei",
  妹夫: "mèi fu",
  姨子: "yí zi",
  宝宝: "bǎo bao",
  娃娃: "wá wa",
  孩子: "hái zi",
  日子: "rì zi",
  样子: "yàng zi",
  狮子: "shī zi",
  身子: "shēn zi",
  架子: "jià zi",
  嫂子: "sǎo zi",
  鼻子: "bí zi",
  亭子: "tíng zi",
  折子: "zhé zi",
  面子: "miàn zi",
  脖子: "bó zi",
  辈子: "bèi zi",
  帽子: "mào zi",
  拍子: "pāi zi",
  柱子: "zhù zi",
  辫子: "biàn zi",
  鸽子: "gē zi",
  房子: "fáng zi",
  丸子: "wán zi",
  摊子: "tān zi",
  牌子: "pái zi",
  胡子: "hú zi",
  鬼子: "guǐ zi",
  矮子: "ǎi zi",
  鸭子: "yā zi",
  小子: "xiǎo zi",
  影子: "yǐng zi",
  屋子: "wū zi",
  对子: "duì zi",
  点子: "diǎn zi",
  本子: "běn zi",
  种子: "zhǒng zi",
  儿子: "ér zi",
  兔子: "tù zi",
  骗子: "piàn zi",
  院子: "yuàn zi",
  猴子: "hóu zi",
  嗓子: "sǎng zi",
  侄子: "zhí zi",
  柿子: "shì zi",
  钳子: "qián zi",
  虱子: "shī zi",
  瓶子: "píng zi",
  豹子: "bào zi",
  筷子: "kuài zi",
  篮子: "lán zi",
  绳子: "shéng zi",
  嘴巴: "zuǐ ba",
  耳朵: "ěr duo",
  茄子: "qié zi",
  蚌埠: "bèng bù",
  崆峒: "kōng tóng",
  琵琶: "pí pa",
  蘑菇: "mó gu",
  葫芦: "hú lu",
  狐狸: "hú li",
  桔子: "jú zi",
  盒子: "hé zi",
  桌子: "zhuō zi",
  竹子: "zhú zi",
  师傅: "shī fu",
  衣服: "yī fu",
  袜子: "wà zi",
  杯子: "bēi zi",
  刺猬: "cì wei",
  麦子: "mài zi",
  队伍: "duì wu",
  知了: "zhī liǎo",
  鱼儿: "yú er",
  馄饨: "hún tun",
  灯笼: "dēng long",
  庄稼: "zhuāng jia",
  聪明: "cōng ming",
  镜子: "jìng zi",
  银子: "yín zi",
  盘子: "pán zi",
  了却: "liǎo què",
  力气: "lì qi",
  席子: "xí zi",
  林子: "lín zi",
  朝霞: "zhāo xiá",
  朝夕: "zhāo xī",
  朝气: "zhāo qì",
  翅膀: "chì bǎng",
  省长: "shěng zhǎng",
  臧否: "zāng pǐ",
  否泰: "pǐ tài",
  变得: "biàn de",
  丈夫: "zhàng fu",
  豆腐: "dòu fu",
  笔杆: "bǐ gǎn",
  枞阳: "zōng yáng",
  行人: "xíng rén",
  打着: "dǎ zhe",
  // 一字不变调的词语（需要增补更多）
  // 有歧义的词：一楼、一栋、一层、一排、一连
  // “一楼”这个词，上下文语意是“一整栋楼”时，需要变调成四声；我住一楼时，则是一声
  第一: "dì yī",
  万一: "wàn yī",
  之一: "zhī yī",
  得之: "dé zhī",
  统一: "tǒng yī",
  唯一: "wéi yī",
  专一: "zhuān yī",
  单一: "dān yī",
  如一: "rú yī",
  其一: "qí yī",
  合一: "hé yī",
  逐一: "zhú yī",
  周一: "zhōu yī",
  初一: "chū yī",
  研一: "yán yī",
  归一: "guī yī",
  假一: "jiǎ yī",
  闻一: "wén yī",
  了了: "liǎo liǎo",
  公了: "gōng liǎo",
  私了: "sī liǎo",
  // 一 发音
  一月: "yī yuè",
  一号: "yī hào",
  一级: "yī jí",
  一等: "yī děng",
  一哥: "yī gē",
  月一: "yuè yī",
  一一: "yī yī",
  二一: "èr yī",
  三一: "sān yī",
  四一: "sì yī",
  五一: "wǔ yī",
  六一: "liù yī",
  七一: "qī yī",
  八一: "bā yī",
  九一: "jiǔ yī",
  "一〇": "yī líng",
  一零: "yī líng",
  一二: "yī èr",
  一三: "yī sān",
  一四: "yī sì",
  一五: "yī wǔ",
  一六: "yī liù",
  一七: "yī qī",
  一八: "yī bā",
  一九: "yī jiǔ",
  一又: "yī yòu",
  一饼: "yī bǐng",
  一楼: "yī lóu",
  为例: "wéi lì",
  为准: "wéi zhǔn",
  沧海: "cāng hǎi",
  难为: "nán wéi",
  责难: "zé nàn",
  患难: "huàn nàn",
  磨难: "mó nàn",
  大难: "dà nàn",
  刁难: "diāo nàn",
  殉难: "xùn nàn",
  落难: "luò nàn",
  罹难: "lí nàn",
  灾难: "zāi nàn",
  难民: "nàn mín",
  苦难: "kǔ nàn",
  危难: "wēi nàn",
  发难: "fā nàn",
  逃难: "táo nàn",
  避难: "bì nàn",
  遇难: "yù nàn",
  阻难: "zǔ nàn",
  厄难: "è nàn",
  徇难: "xùn nàn",
  空难: "kōng nàn",
  喜欢: "xǐ huan",
  朝朝: "zhāo zhāo",
  不行: "bù xíng",
  轧轧: "yà yà",
  弯曲: "wān qū",
  扭曲: "niǔ qū",
  曲直: "qū zhí",
  委曲: "wěi qū",
  酒曲: "jiǔ qū",
  曲径: "qū jìng",
  曲解: "qū jiě",
  歪曲: "wāi qū",
  曲线: "qū xiàn",
  曲阜: "qū fù",
  九曲: "jiǔ qū",
  曲折: "qū zhé",
  曲肱: "qū gōng",
  曲意: "qū yì",
  仡佬: "gē lǎo"
}, eme = Object.keys(dU).map((t) => ({
  zh: t,
  pinyin: dU[t],
  probability: 2e-8,
  length: 2,
  priority: Go.Normal,
  dict: Symbol("dict2")
})), lU = {
  为什么: "wèi shén me",
  实际上: "shí jì shang",
  检察长: "jiǎn chá zhǎng",
  干什么: "gàn shén me",
  这会儿: "zhè huì er",
  尽可能: "jǐn kě néng",
  董事长: "dǒng shì zhǎng",
  了不起: "liǎo bù qǐ",
  参谋长: "cān móu zhǎng",
  朝鲜族: "cháo xiǎn zú",
  海内外: "hǎi nèi wài",
  禁不住: "jīn bú zhù",
  柏拉图: "bó lā tú",
  不在乎: "bú zài hu",
  洛杉矶: "luò shān jī",
  有点儿: "yǒu diǎn er",
  迫击炮: "pǎi jī pào",
  不得了: "bù dé liǎo",
  马尾松: "mǎ wěi sōng",
  运输量: "yùn shū liàng",
  发脾气: "fā pí qi",
  士大夫: "shì dà fū",
  鸭绿江: "yā lù jiāng",
  压根儿: "yà gēn er",
  对得起: "duì de qǐ",
  那会儿: "nà huì er",
  自个儿: "zì gě er",
  物理量: "wù lǐ liàng",
  怎么着: "zěn me zhāo",
  明晃晃: "míng huǎng huǎng",
  节假日: "jié jià rì",
  心里话: "xīn lǐ huà",
  发行量: "fā xíng liàng",
  兴冲冲: "xìng chōng chōng",
  分子量: "fēn zǐ liàng",
  国子监: "guó zǐ jiàn",
  老大难: "lǎo dà nán",
  党内外: "dǎng nèi wài",
  这么着: "zhè me zhāo",
  少奶奶: "shào nǎi nai",
  暗地里: "àn dì lǐ",
  更年期: "gēng nián qī",
  工作量: "gōng zuò liàng",
  背地里: "bèi dì lǐ",
  山里红: "shān li hóng",
  好好儿: "hǎo hāo er",
  交响乐: "jiāo xiǎng yuè",
  好意思: "hǎo yì si",
  吐谷浑: "tǔ yù hún",
  没意思: "méi yì si",
  理发师: "lǐ fà shī",
  塔什干: "tǎ shí gān",
  充其量: "chōng qí liàng",
  靠得住: "kào de zhù",
  车行道: "chē xíng dào",
  人行道: "rén xíng dào",
  中郎将: "zhōng láng jiàng",
  照明弹: "zhào míng dàn",
  烟幕弹: "yān mù dàn",
  没奈何: "mò nài hé",
  乱哄哄: "luàn hōng hōng",
  惠更斯: "huì gēng sī",
  载重量: "zài zhòng liàng",
  瞧得起: "qiáo de qǐ",
  纪传体: "jì zhuàn tǐ",
  阿房宫: "ē páng gōng",
  卷心菜: "juǎn xīn cài",
  戏班子: "xì bān zi",
  过得去: "guò de qù",
  花岗石: "huā gāng shí",
  外甥女: "wài sheng nǚ",
  团团转: "tuán tuán zhuàn",
  大堡礁: "dà bǎo jiāo",
  燃烧弹: "rán shāo dàn",
  劳什子: "láo shí zi",
  摇滚乐: "yáo gǔn yuè",
  夹竹桃: "jiā zhú táo",
  闹哄哄: "nào hōng hōng",
  三连冠: "sān lián guàn",
  重头戏: "zhòng tóu xì",
  二人转: "èr rén zhuàn",
  节骨眼: "jiē gǔ yǎn",
  知识面: "zhī shi miàn",
  护士长: "hù shi zhǎng",
  信号弹: "xìn hào dàn",
  干电池: "gān diàn chí",
  枪杆子: "qiāng gǎn zi",
  哭丧棒: "kū sāng bàng",
  鼻咽癌: "bí yān ái",
  瓦岗军: "wǎ gāng jūn",
  买得起: "mǎi de qǐ",
  癞蛤蟆: "lài há ma",
  脊梁骨: "jǐ liang gǔ",
  子母弹: "zǐ mǔ dàn",
  开小差: "kāi xiǎo chāi",
  女强人: "nǚ qiáng rén",
  英雄传: "yīng xióng zhuàn",
  爵士乐: "jué shì yuè",
  说笑话: "shuō xiào hua",
  碰头会: "pèng tóu huì",
  玻璃钢: "bō li gāng",
  曳光弹: "yè guāng dàn",
  少林拳: "shào lín quán",
  咏叹调: "yǒng tàn diào",
  少先队: "shào xiān duì",
  灵长目: "líng zhǎng mù",
  对着干: "duì zhe gàn",
  蒙蒙亮: "méng méng liàng",
  软骨头: "ruǎn gǔ tou",
  铺盖卷: "pū gài juǎn",
  和稀泥: "huò xī ní",
  背黑锅: "bēi hēi guō",
  红彤彤: "hóng tōng tōng",
  武侯祠: "wǔ hóu cí",
  打哆嗦: "dǎ duō suo",
  户口簿: "hù kǒu bù",
  马尾藻: "mǎ wěi zǎo",
  夜猫子: "yè māo zi",
  打手势: "dǎ shǒu shì",
  龙王爷: "lóng wáng yé",
  气头上: "qì tóu shang",
  糊涂虫: "hú tu chóng",
  笔杆子: "bǐ gǎn zi",
  占便宜: "zhàn pián yi",
  打主意: "dǎ zhǔ yì",
  多弹头: "duō dàn tóu",
  露一手: "lòu yì shǒu",
  堰塞湖: "yàn sè hú",
  保得住: "bǎo de zhù",
  趵突泉: "bào tū quán",
  奥得河: "ào de hé",
  司务长: "sī wù zhǎng",
  禁不起: "jīn bù qǐ",
  什刹海: "shí chà hǎi",
  莲花落: "lián huā lào",
  见世面: "jiàn shì miàn",
  豁出去: "huō chū qù",
  电位差: "diàn wèi chā",
  挨个儿: "āi gè er",
  那阵儿: "nà zhèn er",
  肺活量: "fèi huó liàng",
  大师傅: "dà shī fu",
  掷弹筒: "zhì dàn tǒng",
  打呼噜: "dǎ hū lu",
  广渠门: "ān qú mén",
  未见得: "wèi jiàn dé",
  大婶儿: "dà shěn er",
  谈得来: "tán de lái",
  脚丫子: "jiǎo yā zi",
  空包弹: "kōng bāo dàn",
  窝里斗: "wō li dòu",
  弹着点: "dàn zhuó diǎn",
  个头儿: "gè tóu er",
  看得起: "kàn de qǐ",
  糊涂账: "hú tu zhàng",
  大猩猩: "dà xīng xing",
  禁得起: "jīn de qǐ",
  法相宗: "fǎ xiàng zōng",
  可怜相: "kě lián xiàng",
  吃得下: "chī de xià",
  汉堡包: "hàn bǎo bāo",
  闹嚷嚷: "nào rāng rāng",
  数来宝: "shǔ lái bǎo",
  合得来: "hé de lái",
  干性油: "gān xìng yóu",
  闷葫芦: "mèn hú lu",
  呱呱叫: "guā guā jiào",
  西洋参: "xī yáng shēn",
  林荫道: "lín yīn dào",
  拉家常: "lā jiā cháng",
  卷铺盖: "juǎn pū gài",
  过得硬: "guò de yìng",
  飞将军: "fēi jiāng jūn",
  挑大梁: "tiǎo dà liáng",
  哈巴狗: "hǎ ba gǒu",
  过家家: "guò jiā jiā",
  催泪弹: "cuī lèi dàn",
  雨夹雪: "yǔ jiā xuě",
  敲竹杠: "qiāo zhú gàng",
  列车长: "liè chē zhǎng",
  华达呢: "huá dá ní",
  犯得着: "fàn de zháo",
  土疙瘩: "tǔ gē da",
  煞风景: "shā fēng jǐng",
  轻量级: "qīng liàng jí",
  羞答答: "xiū dā dā",
  石子儿: "shí zǐ er",
  达姆弹: "dá mǔ dàn",
  科教片: "kē jiào piān",
  侃大山: "kǎn dà shān",
  丁点儿: "dīng diǎn er",
  吃得消: "chī de xiāo",
  捋虎须: "luō hǔ xū",
  高丽参: "gāo lí shēn",
  众生相: "zhòng shēng xiàng",
  咽峡炎: "yān xiá yán",
  禁得住: "jīn de zhù",
  吃得开: "chī de kāi",
  柞丝绸: "zuò sī chóu",
  应声虫: "yìng shēng chóng",
  数得着: "shǔ de zháo",
  傻劲儿: "shǎ jìn er",
  铅玻璃: "qiān bō li",
  可的松: "kě dì sōng",
  划得来: "huá de lái",
  晕乎乎: "yūn hū hū",
  屎壳郎: "shǐ ke làng",
  尥蹶子: "liào juě zi",
  藏红花: "zàng hóng huā",
  闷罐车: "mèn guàn chē",
  卡脖子: "qiǎ bó zi",
  红澄澄: "hóng deng deng",
  赶得及: "gǎn de jí",
  当间儿: "dāng jiàn er",
  露马脚: "lòu mǎ jiǎo",
  鸡内金: "jī nèi jīn",
  犯得上: "fàn de shàng",
  钉齿耙: "dīng chǐ bà",
  饱和点: "bǎo hé diǎn",
  龙爪槐: "lóng zhǎo huái",
  喝倒彩: "hè dào cǎi",
  定冠词: "dìng guàn cí",
  担担面: "dàn dan miàn",
  吃得住: "chī de zhù",
  爪尖儿: "zhuǎ jiān er",
  支着儿: "zhī zhāo er",
  折跟头: "zhē gēn tou",
  阴着儿: "yīn zhāo er",
  烟卷儿: "yān juǎn er",
  宣传弹: "xuān chuán dàn",
  信皮儿: "xìn pí er",
  弦切角: "xián qiē jiǎo",
  缩砂密: "sù shā mì",
  说得来: "shuō de lái",
  水漂儿: "shuǐ piāo er",
  耍笔杆: "shuǎ bǐ gǎn",
  数得上: "shǔ de shàng",
  数不着: "shǔ bù zháo",
  数不清: "shǔ bù qīng",
  什件儿: "shí jiàn er",
  生死簿: "shēng sǐ bù",
  扇风机: "shān fēng jī",
  撒呓挣: "sā yì zheng",
  日记簿: "rì jì bù",
  热得快: "rè de kuài",
  亲家公: "qìng jia gōng",
  奇函数: "jī hán shù",
  拍纸簿: "pāi zhǐ bù",
  努劲儿: "nǔ jìn er",
  泥娃娃: "ní wá wa",
  内切圆: "nèi qiē yuán",
  哪会儿: "nǎ huì er",
  闷头儿: "mēn tóu er",
  没谱儿: "méi pǔ er",
  铆劲儿: "mǎo jìn er",
  溜肩膀: "liū jiān bǎng",
  了望台: "liào wàng tái",
  老来少: "lǎo lái shào",
  坤角儿: "kūn jué er",
  考勤簿: "kǎo qín bù",
  卷笔刀: "juǎn bǐ dāo",
  进给量: "jìn jǐ liàng",
  划不来: "huá bù lái",
  汗褂儿: "hàn guà er",
  鼓囊囊: "gǔ nāng nāng",
  够劲儿: "gòu jìn er",
  公切线: "gōng qiē xiàn",
  搁得住: "gé de zhù",
  赶浪头: "gǎn làng tóu",
  赶得上: "gǎn de shàng",
  干酵母: "gān jiào mǔ",
  嘎渣儿: "gā zhā er",
  嘎嘣脆: "gā bēng cuì",
  对得住: "duì de zhù",
  逗闷子: "dòu mèn zi",
  顶呱呱: "dǐng guā guā",
  滴溜儿: "dī liù er",
  大轴子: "dà zhòu zi",
  打板子: "dǎ bǎn zi",
  寸劲儿: "cùn jìn er",
  醋劲儿: "cù jìn er",
  揣手儿: "chuāi shǒu er",
  冲劲儿: "chòng jìn er",
  吃得来: "chī de lái",
  不更事: "bù gēng shì",
  奔头儿: "bèn tou er",
  百夫长: "bǎi fū zhǎng",
  娃娃亲: "wá wa qīn",
  死劲儿: "sǐ jìn er",
  骨朵儿: "gū duǒ er",
  功劳簿: "gōng láo bù",
  都江堰: "dū jiāng yàn",
  一担水: "yí dàn shuǐ",
  否极泰: "pǐ jí tài",
  泰来否: "tài lái pǐ",
  咳特灵: "ké tè líng",
  开户行: "kāi hù háng",
  郦食其: "lì yì jī",
  花事了: "huā shì liǎo",
  // 一字变调的词语（与两个字的字典冲突，故需要重新定义）
  一更更: "yì gēng gēng",
  一重山: "yì chóng shān",
  风一更: "fēng yì gēng",
  雪一更: "xuě yì gēng",
  归一码: "guī yì mǎ",
  // 一字不变调的词语（需要增补更多）
  星期一: "xīng qī yī",
  礼拜一: "lǐ bài yī",
  一季度: "yī jì dù",
  一月一: "yī yuè yī",
  一字马: "yī zì mǎ",
  一是一: "yī shì yī",
  一次方: "yī cì fāng",
  一阳指: "yī yáng zhǐ",
  一字决: "yī zì jué",
  一年级: "yī nián jí",
  一不做: "yī bú zuò",
  屈戌儿: "qū qu ér",
  难为水: "nán wéi shuǐ",
  难为情: "nán wéi qíng",
  行一行: "xíng yì háng",
  别别的: "biè bié de",
  干哪行: "gàn nǎ háng",
  干一行: "gàn yì háng",
  曲别针: "qū bié zhēn"
}, tme = Object.keys(lU).map((t) => ({
  zh: t,
  pinyin: lU[t],
  probability: 2e-8,
  length: 3,
  priority: Go.Normal,
  dict: Symbol("dict3")
})), fU = {
  成吉思汗: "chéng jí sī hán",
  四通八达: "sì tōng bā dá",
  一模一样: "yì mú yí yàng",
  青藏高原: "qīng zàng gāo yuán",
  阿弥陀佛: "ē mí tuó fó",
  解放思想: "jiè fàng sī xiǎng",
  所作所为: "suǒ zuò suǒ wéi",
  迷迷糊糊: "mí mí hu hū",
  荷枪实弹: "hè qiāng shí dàn",
  兴高采烈: "xìng gāo cǎi liè",
  无能为力: "wú néng wéi lì",
  布鲁塞尔: "bù lǔ sài ěr",
  为所欲为: "wéi suǒ yù wéi",
  克什米尔: "kè shí mǐ ěr",
  没完没了: "méi wán méi liǎo",
  不为人知: "bù wéi rén zhī",
  结结巴巴: "jiē jiē bā bā",
  前仆后继: "qián pū hòu jì",
  铺天盖地: "pū tiān gài dì",
  直截了当: "zhí jié liǎo dàng",
  供不应求: "gōng bú yìng qiú",
  御史大夫: "yù shǐ dà fū",
  不为瓦全: "bù wéi wǎ quán",
  不可收拾: "bù kě shōu shi",
  胡作非为: "hú zuò fēi wéi",
  分毫不差: "fēn háo bú chà",
  模模糊糊: "mó mó hu hū",
  不足为奇: "bù zú wéi qí",
  悄无声息: "qiǎo wú shēng xī",
  了如指掌: "liǎo rú zhǐ zhǎng",
  深恶痛绝: "shēn wù tòng jué",
  高高兴兴: "gāo gāo xìng xìng",
  唉声叹气: "āi shēng tàn qì",
  汉藏语系: "hàn zàng yǔ xì",
  处心积虑: "chǔ xīn jī lǜ",
  泣不成声: "qì bù chéng shēng",
  半夜三更: "bàn yè sān gēng",
  失魂落魄: "shī hún luò pò",
  二十八宿: "èr shí bā xiù",
  转来转去: "zhuàn lái zhuàn qù",
  数以万计: "shǔ yǐ wàn jì",
  相依为命: "xiāng yī wéi mìng",
  恋恋不舍: "liàn liàn bù shě",
  屈指可数: "qū zhǐ kě shǔ",
  神出鬼没: "shén chū guǐ mò",
  结结实实: "jiē jiē shí shí",
  有的放矢: "yǒu dì fàng shǐ",
  叽哩咕噜: "jī lǐ gū lū",
  调兵遣将: "diào bīng qiǎn jiàng",
  载歌载舞: "zài gē zài wǔ",
  转危为安: "zhuǎn wēi wéi ān",
  踏踏实实: "tā tā shi shí",
  桑给巴尔: "sāng jǐ bā ěr",
  装模作样: "zhuāng mú zuò yàng",
  见义勇为: "jiàn yì yǒng wéi",
  相差无几: "xiāng chā wú jǐ",
  叹为观止: "tàn wéi guān zhǐ",
  闷闷不乐: "mèn mèn bú lè",
  喜怒哀乐: "xǐ nù āi lè",
  鲜为人知: "xiǎn wéi rén zhī",
  张牙舞爪: "zhāng yá wǔ zhǎo",
  为非作歹: "wéi fēi zuò dǎi",
  含糊其辞: "hán hú qí cí",
  疲于奔命: "pí yú bēn mìng",
  勉为其难: "miǎn wéi qí nán",
  依依不舍: "yī yī bù shě",
  顶头上司: "dǐng tóu shàng si",
  不着边际: "bù zhuó biān jì",
  大模大样: "dà mú dà yàng",
  寻欢作乐: "xún huān zuò lè",
  一走了之: "yì zǒu liǎo zhī",
  字里行间: "zì lǐ háng jiān",
  含含糊糊: "hán hán hu hū",
  恰如其分: "qià rú qí fèn",
  破涕为笑: "pò tì wéi xiào",
  深更半夜: "shēn gēng bàn yè",
  千差万别: "qiān chā wàn bié",
  数不胜数: "shǔ bú shèng shǔ",
  据为己有: "jù wéi jǐ yǒu",
  天旋地转: "tiān xuán dì zhuàn",
  养尊处优: "yǎng zūn chǔ yōu",
  玻璃纤维: "bō li xiān wéi",
  吵吵闹闹: "chāo chao nào nào",
  晕头转向: "yūn tóu zhuàn xiàng",
  土生土长: "tǔ shēng tǔ zhǎng",
  宁死不屈: "nìng sǐ bù qū",
  不省人事: "bù xǐng rén shì",
  尽力而为: "jìn lì ér wéi",
  精明强干: "jīng míng qiáng gàn",
  唠唠叨叨: "láo lao dāo dāo",
  叽叽喳喳: "jī ji zhā zhā",
  功不可没: "gōng bù kě mò",
  锲而不舍: "qiè ér bù shě",
  排忧解难: "pái yōu jiě nàn",
  稀里糊涂: "xī li hú tú",
  各有所长: "gè yǒu suǒ cháng",
  的的确确: "dí dí què què",
  哄堂大笑: "hōng táng dà xiào",
  听而不闻: "tīng ér bù wén",
  刀耕火种: "dāo gēng huǒ zhòng",
  内分泌腺: "nèi fèn mì xiàn",
  化险为夷: "huà xiǎn wéi yí",
  百发百中: "bǎi fā bǎi zhòng",
  重见天日: "chóng jiàn tiān rì",
  反败为胜: "fǎn bài wéi shèng",
  一了百了: "yì liǎo bǎi liǎo",
  大大咧咧: "dà da liē liē",
  心急火燎: "xīn jí huǒ liǎo",
  粗心大意: "cū xīn dà yi",
  鸡皮疙瘩: "jī pí gē da",
  夷为平地: "yí wéi píng dì",
  日积月累: "rì jī yuè lěi",
  设身处地: "shè shēn chǔ dì",
  投其所好: "tóu qí suǒ hào",
  间不容发: "jiān bù róng fà",
  人满为患: "rén mǎn wéi huàn",
  穷追不舍: "qióng zhuī bù shě",
  为时已晚: "wéi shí yǐ wǎn",
  如数家珍: "rú shǔ jiā zhēn",
  心里有数: "xīn lǐ yǒu shù",
  以牙还牙: "yǐ yá huán yá",
  神不守舍: "shén bù shǒu shě",
  孟什维克: "mèng shí wéi kè",
  各自为战: "gè zì wéi zhàn",
  怨声载道: "yuàn shēng zài dào",
  救苦救难: "jiù kǔ jiù nàn",
  好好先生: "hǎo hǎo xiān sheng",
  怪模怪样: "guài mú guài yàng",
  抛头露面: "pāo tóu lù miàn",
  游手好闲: "yóu shǒu hào xián",
  无所不为: "wú suǒ bù wéi",
  调虎离山: "diào hǔ lí shān",
  步步为营: "bù bù wéi yíng",
  好大喜功: "hào dà xǐ gōng",
  众矢之的: "zhòng shǐ zhī dì",
  长生不死: "cháng shēng bù sǐ",
  蔚为壮观: "wèi wéi zhuàng guān",
  不可胜数: "bù kě shèng shǔ",
  鬼使神差: "guǐ shǐ shén chāi",
  洁身自好: "jié shēn zì hào",
  敢作敢为: "gǎn zuò gǎn wéi",
  茅塞顿开: "máo sè dùn kāi",
  走马换将: "zǒu mǎ huàn jiàng",
  为时过早: "wéi shí guò zǎo",
  为人师表: "wéi rén shī biǎo",
  阴差阳错: "yīn chā yáng cuò",
  油腔滑调: "yóu qiāng huá diào",
  重蹈覆辙: "chóng dǎo fù zhé",
  骂骂咧咧: "mà ma liē liē",
  絮絮叨叨: "xù xù dāo dāo",
  如履薄冰: "rú lǚ bó bīng",
  损兵折将: "sǔn bīng zhé jiàng",
  拐弯抹角: "guǎi wān mò jiǎo",
  像模像样: "xiàng mú xiàng yàng",
  供过于求: "gōng guò yú qiú",
  开花结果: "kāi huā jiē guǒ",
  仔仔细细: "zǐ zǐ xì xì",
  川藏公路: "chuān zàng gōng lù",
  河北梆子: "hé běi bāng zi",
  长年累月: "cháng nián lěi yuè",
  正儿八经: "zhèng er bā jīng",
  不识抬举: "bù shí tái ju",
  重振旗鼓: "chóng zhèn qí gǔ",
  气息奄奄: "qì xī yān yān",
  紧追不舍: "jǐn zhuī bù shě",
  服服帖帖: "fú fu tiē tiē",
  强词夺理: "qiǎng cí duó lǐ",
  噼里啪啦: "pī li pā lā",
  人才济济: "rén cái jǐ jǐ",
  发人深省: "fā rén shēn xǐng",
  不足为凭: "bù zú wéi píng",
  为富不仁: "wéi fù bù rén",
  连篇累牍: "lián piān lěi dú",
  呼天抢地: "hū tiān qiāng dì",
  落落大方: "luò luò dà fāng",
  自吹自擂: "zì chuī zì léi",
  乐善好施: "lè shàn hào shī",
  以攻为守: "yǐ gōng wéi shǒu",
  磨磨蹭蹭: "mó mó cèng cèng",
  削铁如泥: "xuē tiě rú ní",
  助纣为虐: "zhù zhòu wéi nüè",
  以退为进: "yǐ tuì wéi jìn",
  嘁嘁喳喳: "qī qī chā chā",
  枪林弹雨: "qiāng lín dàn yǔ",
  令人发指: "lìng rén fà zhǐ",
  转败为胜: "zhuǎn bài wéi shèng",
  转弯抹角: "zhuǎn wān mò jiǎo",
  在劫难逃: "zài jié nán táo",
  正当防卫: "zhèng dàng fáng wèi",
  不足为怪: "bù zú wéi guài",
  难兄难弟: "nàn xiōng nàn dì",
  咿咿呀呀: "yī yī yā yā",
  弹尽粮绝: "dàn jìn liáng jué",
  阿谀奉承: "ē yú fèng chéng",
  稀里哗啦: "xī li huā lā",
  返老还童: "fǎn lǎo huán tóng",
  好高骛远: "hào gāo wù yuǎn",
  鹿死谁手: "lù sǐ shéi shǒu",
  差强人意: "chā qiáng rén yì",
  大吹大擂: "dà chuī dà léi",
  成家立业: "chéng jiā lì yè",
  自怨自艾: "zì yuàn zì yì",
  负债累累: "fù zhài lěi lěi",
  古为今用: "gǔ wéi jīn yòng",
  入土为安: "rù tǔ wéi ān",
  下不为例: "xià bù wéi lì",
  一哄而上: "yì hōng ér shàng",
  没头苍蝇: "méi tóu cāng ying",
  天差地远: "tiān chā dì yuǎn",
  风卷残云: "fēng juǎn cán yún",
  多灾多难: "duō zāi duō nàn",
  乳臭未干: "rǔ xiù wèi gān",
  行家里手: "háng jiā lǐ shǒu",
  狼狈为奸: "láng bèi wéi jiān",
  处变不惊: "chǔ biàn bù jīng",
  一唱一和: "yí chàng yí hè",
  一念之差: "yí niàn zhī chā",
  金蝉脱壳: "jīn chán tuō qiào",
  滴滴答答: "dī dī dā dā",
  硕果累累: "shuò guǒ léi léi",
  好整以暇: "hào zhěng yǐ xiá",
  红得发紫: "hóng de fā zǐ",
  传为美谈: "chuán wéi měi tán",
  富商大贾: "fù shāng dà gǔ",
  四海为家: "sì hǎi wéi jiā",
  了若指掌: "liǎo ruò zhǐ zhǎng",
  大有可为: "dà yǒu kě wéi",
  出头露面: "chū tóu lù miàn",
  鼓鼓囊囊: "gǔ gu nāng nāng",
  窗明几净: "chuāng míng jī jìng",
  泰然处之: "tài rán chǔ zhī",
  怒发冲冠: "nù fà chōng guān",
  有机玻璃: "yǒu jī bō li",
  骨头架子: "gǔ tou jià zi",
  义薄云天: "yì bó yún tiān",
  一丁点儿: "yī dīng diǎn er",
  时来运转: "shí lái yùn zhuǎn",
  陈词滥调: "chén cí làn diào",
  化整为零: "huà zhěng wéi líng",
  火烧火燎: "huǒ shāo huǒ liǎo",
  干脆利索: "gàn cuì lì suǒ",
  吊儿郎当: "diào er láng dāng",
  广种薄收: "guǎng zhòng bó shōu",
  种瓜得瓜: "zhòng guā dé guā",
  种豆得豆: "zhòng dòu dé dòu",
  难舍难分: "nán shě nán fēn",
  歃血为盟: "shà xuè wéi méng",
  奋发有为: "fèn fā yǒu wéi",
  阴错阳差: "yīn cuò yáng chā",
  东躲西藏: "dōng duǒ xī cáng",
  烟熏火燎: "yān xūn huǒ liǎo",
  钻牛角尖: "zuān niú jiǎo jiān",
  乔装打扮: "qiáo zhuāng dǎ bàn",
  改弦更张: "gǎi xián gēng zhāng",
  河南梆子: "hé nán bāng zi",
  好吃懒做: "hào chī lǎn zuò",
  何乐不为: "hé lè bù wéi",
  大出风头: "dà chū fēng tóu",
  攻城掠地: "gōng chéng lüè dì",
  漂漂亮亮: "piào piào liang liang",
  折衷主义: "zhé zhōng zhǔ yì",
  大马哈鱼: "dà mǎ hǎ yú",
  绿树成荫: "lǜ shù chéng yīn",
  率先垂范: "shuài xiān chuí fàn",
  家长里短: "jiā cháng lǐ duǎn",
  宽大为怀: "kuān dà wéi huái",
  左膀右臂: "zuǒ bǎng yòu bì",
  一笑了之: "yí xiào liǎo zhī",
  天下为公: "tiān xià wéi gōng",
  还我河山: "huán wǒ hé shān",
  何足为奇: "hé zú wéi qí",
  好自为之: "hǎo zì wéi zhī",
  风姿绰约: "fēng zī chuò yuē",
  大雨滂沱: "dà yǔ pāng tuó",
  传为佳话: "chuán wéi jiā huà",
  吃里扒外: "chī lǐ pá wài",
  重操旧业: "chóng cāo jiù yè",
  小家子气: "xiǎo jiā zi qì",
  少不更事: "shào bù gēng shì",
  难分难舍: "nán fēn nán shě",
  添砖加瓦: "tiān zhuān jiā wǎ",
  是非分明: "shì fēi fēn míng",
  舍我其谁: "shě wǒ qí shuí",
  偏听偏信: "piān tīng piān xìn",
  量入为出: "liàng rù wéi chū",
  降龙伏虎: "xiáng lóng fú hǔ",
  钢化玻璃: "gāng huà bō li",
  正中下怀: "zhèng zhòng xià huái",
  以身许国: "yǐ shēn xǔ guó",
  一语中的: "yì yǔ zhòng dì",
  丧魂落魄: "sàng hún luò pò",
  三座大山: "sān zuò dà shān",
  济济一堂: "jǐ jǐ yì táng",
  好事之徒: "hào shì zhī tú",
  干净利索: "gàn jìng lì suǒ",
  出将入相: "chū jiàng rù xiàng",
  袅袅娜娜: "niǎo niǎo nuó nuó",
  狐狸尾巴: "hú li wěi ba",
  好逸恶劳: "hào yì wù láo",
  大而无当: "dà ér wú dàng",
  打马虎眼: "dǎ mǎ hu yǎn",
  板上钉钉: "bǎn shàng dìng dīng",
  吆五喝六: "yāo wǔ hè liù",
  虾兵蟹将: "xiā bīng xiè jiàng",
  水调歌头: "shuǐ diào gē tóu",
  数典忘祖: "shǔ diǎn wàng zǔ",
  人事不省: "rén shì bù xǐng",
  曲高和寡: "qǔ gāo hè guǎ",
  屡教不改: "lǚ jiào bù gǎi",
  互为因果: "hù wéi yīn guǒ",
  互为表里: "hù wéi biǎo lǐ",
  厚此薄彼: "hòu cǐ bó bǐ",
  过关斩将: "guò guān zhǎn jiàng",
  疙疙瘩瘩: "gē ge dā dā",
  大腹便便: "dà fù pián pián",
  走为上策: "zǒu wéi shàng cè",
  冤家对头: "yuān jia duì tóu",
  有隙可乘: "yǒu xì kě chèng",
  一鳞半爪: "yì lín bàn zhǎo",
  片言只语: "piàn yán zhǐ yǔ",
  开花结实: "kāi huā jié shí",
  经年累月: "jīng nián lěi yuè",
  含糊其词: "hán hú qí cí",
  寡廉鲜耻: "guǎ lián xiǎn chǐ",
  成年累月: "chéng nián lěi yuè",
  不徇私情: "bú xùn sī qíng",
  不当人子: "bù dāng rén zǐ",
  膀大腰圆: "bǎng dà yāo yuán",
  指腹为婚: "zhǐ fù wéi hūn",
  这么点儿: "zhè me diǎn er",
  意兴索然: "yì xīng suǒ rán",
  绣花枕头: "xiù huā zhěn tou",
  无的放矢: "wú dì fàng shǐ",
  望闻问切: "wàng wén wèn qiè",
  舍己为人: "shě jǐ wèi rén",
  穷年累月: "qióng nián lěi yuè",
  排难解纷: "pái nàn jiě fēn",
  处之泰然: "chǔ zhī tài rán",
  指鹿为马: "zhǐ lù wéi mǎ",
  危如累卵: "wēi rú lěi luǎn",
  天兵天将: "tiān bīng tiān jiàng",
  舍近求远: "shě jìn qiú yuǎn",
  南腔北调: "nán qiāng běi diào",
  苦中作乐: "kǔ zhōng zuò lè",
  厚积薄发: "hòu jī bó fā",
  臭味相投: "xiù wèi xiāng tóu",
  长幼有序: "zhǎng yòu yǒu xù",
  逼良为娼: "bī liáng wéi chāng",
  悲悲切切: "bēi bēi qiè qiē",
  败军之将: "bài jūn zhī jiàng",
  欺行霸市: "qī háng bà shì",
  削足适履: "xuē zú shì lǚ",
  先睹为快: "xiān dǔ wéi kuài",
  啼饥号寒: "tí jī háo hán",
  疏不间亲: "shū bú jiàn qīn",
  神差鬼使: "shén chāi guǐ shǐ",
  敲敲打打: "qiāo qiāo dǎ dǎ",
  平铺直叙: "píng pū zhí xù",
  没头没尾: "méi tóu mò wěi",
  寥寥可数: "liáo liáo kě shǔ",
  哼哈二将: "hēng hā èr jiàng",
  鹤发童颜: "hè fà tóng yán",
  各奔前程: "gè bèn qián chéng",
  弹无虚发: "dàn wú xū fā",
  大人先生: "dà rén xiān sheng",
  与民更始: "yǔ mín gēng shǐ",
  树碑立传: "shù bēi lì zhuàn",
  是非得失: "shì fēi dé shī",
  实逼处此: "shí bī chǔ cǐ",
  塞翁失马: "sài wēng shī mǎ",
  日薄西山: "rì bó xī shān",
  切身体会: "qiè shēn tǐ huì",
  片言只字: "piàn yán zhǐ zì",
  跑马卖解: "pǎo mǎ mài xiè",
  宁折不弯: "nìng zhé bù wān",
  零零散散: "líng líng sǎn sǎn",
  量体裁衣: "liàng tǐ cái yī",
  连中三元: "lián zhòng sān yuán",
  礼崩乐坏: "lǐ bēng yuè huài",
  不为已甚: "bù wéi yǐ shèn",
  转悲为喜: "zhuǎn bēi wéi xǐ",
  以眼还眼: "yǐ yǎn huán yǎn",
  蔚为大观: "wèi wéi dà guān",
  未为不可: "wèi wéi bù kě",
  童颜鹤发: "tóng yán hè fà",
  朋比为奸: "péng bǐ wéi jiān",
  莫此为甚: "mò cǐ wéi shèn",
  夹枪带棒: "jiā qiāng dài bàng",
  富商巨贾: "fù shāng jù jiǎ",
  淡然处之: "dàn rán chǔ zhī",
  箪食壶浆: "dān shí hú jiāng",
  创巨痛深: "chuāng jù tòng shēn",
  草长莺飞: "cǎo zhǎng yīng fēi",
  坐视不救: "zuò shī bú jiù",
  以己度人: "yǐ jǐ duó rén",
  随行就市: "suí háng jiù shì",
  文以载道: "wén yǐ zài dào",
  文不对题: "wén bú duì tí",
  铁板钉钉: "tiě bǎn dìng dīng",
  身体发肤: "shēn tǐ fà fū",
  缺吃少穿: "quē chī shǎo chuān",
  目无尊长: "mù wú zūn zhǎng",
  吉人天相: "jí rén tiān xiàng",
  毁家纾难: "huǐ jiā shū nàn",
  钢筋铁骨: "gāng jīn tiě gǔ",
  丢卒保车: "diū zú bǎo jū",
  丢三落四: "diū sān là sì",
  闭目塞听: "bì mù sè tīng",
  削尖脑袋: "xuē jiān nǎo dài",
  为非作恶: "wéi fēi zuò è",
  人才难得: "rén cái nán dé",
  情非得已: "qíng fēi dé yǐ",
  切中要害: "qiè zhòng yào hài",
  火急火燎: "huǒ jí huǒ liǎo",
  画地为牢: "huà dì wéi láo",
  好酒贪杯: "hào jiǔ tān bēi",
  长歌当哭: "cháng gē dàng kū",
  载沉载浮: "zài chén zài fú",
  遇难呈祥: "yù nàn chéng xiáng",
  榆木疙瘩: "yú mù gē da",
  以邻为壑: "yǐ lín wéi hè",
  洋为中用: "yáng wéi zhōng yòng",
  言为心声: "yán wéi xīn shēng",
  言必有中: "yán bì yǒu zhòng",
  图穷匕见: "tú qióng bǐ xiàn",
  滂沱大雨: "páng tuó dà yǔ",
  目不暇给: "mù bù xiá jǐ",
  量才录用: "liàng cái lù yòng",
  教学相长: "jiào xué xiāng zhǎng",
  悔不当初: "huǐ bù dāng chū",
  呼幺喝六: "hū yāo hè liù",
  不足为训: "bù zú wéi xùn",
  不拘形迹: "bù jū xíng jī",
  傍若无人: "páng ruò wú rén",
  罪责难逃: "zuì zé nán táo",
  自我吹嘘: "zì wǒ chuī xū",
  转祸为福: "zhuǎn huò wéi fú",
  勇冠三军: "yǒng guàn sān jūn",
  易地而处: "yì dì ér chǔ",
  卸磨杀驴: "xiè mò shā lǘ",
  玩儿不转: "wán ér bú zhuàn",
  天道好还: "tiān dào hǎo huán",
  身单力薄: "shēn dān lì bó",
  撒豆成兵: "sǎ dòu chéng bīng",
  片纸只字: "piàn zhǐ zhī zì",
  宁缺毋滥: "nìng quē wú làn",
  没没无闻: "mò mò wú wén",
  量力而为: "liàng lì ér wéi",
  历历可数: "lì lì kě shǔ",
  口碑载道: "kǒu bēi zài dào",
  君子好逑: "jūn zǐ hǎo qiú",
  好为人师: "hào wéi rén shī",
  豪商巨贾: "háo shāng jù jiǎ",
  各有所好: "gè yǒu suǒ hào",
  度德量力: "duó dé liàng lì",
  指天为誓: "zhǐ tiān wéi shì",
  逸兴遄飞: "yì xìng chuán fēi",
  心宽体胖: "xīn kuān tǐ pán",
  为德不卒: "wéi dé bù zú",
  天下为家: "tiān xià wéi jiā",
  视为畏途: "shì wéi wèi tú",
  三灾八难: "sān zāi bā nàn",
  沐猴而冠: "mù hóu ér guàn",
  哩哩啦啦: "lī li lā lā",
  见缝就钻: "jiàn fèng jiù zuān",
  夹层玻璃: "jiā céng bō li",
  急公好义: "jí gōng hào yì",
  积年累月: "jī nián lěi yuè",
  划地为牢: "huá dì wéi láo",
  更名改姓: "gēng míng gǎi xìng",
  奉为圭臬: "fèng wéi guī niè",
  多难兴邦: "duō nàn xīng bāng",
  不破不立: "bú pò bú lì",
  坐地自划: "zuò dì zì huá",
  坐不重席: "zuò bù chóng xí",
  坐不窥堂: "zuò bù kuī táng",
  作嫁衣裳: "zuò jià yī shang",
  左枝右梧: "zuǒ zhī yòu wú",
  左宜右有: "zuǒ yí yòu yǒu",
  钻头觅缝: "zuān tóu mì fèng",
  钻天打洞: "zuān tiān dǎ dòng",
  钻皮出羽: "zuān pí chū yǔ",
  钻火得冰: "zuān huǒ dé bīng",
  钻洞觅缝: "zuàn dòng mì féng",
  钻冰求火: "zuān bīng qiú huǒ",
  子为父隐: "zǐ wéi fù yǐn",
  擢发难数: "zhuó fà nán shǔ",
  着人先鞭: "zhuó rén xiān biān",
  斫雕为朴: "zhuó diāo wéi pǔ",
  锥处囊中: "zhuī chǔ náng zhōng",
  椎心饮泣: "chuí xīn yǐn qì",
  椎心泣血: "chuí xīn qì xuè",
  椎牛飨士: "chuí niú xiǎng shì",
  椎牛歃血: "chuí niú shà xuè",
  椎牛发冢: "chuí niú fà zhǒng",
  椎埋屠狗: "chuí mái tú gǒu",
  椎埋狗窃: "chuí mái gǒu qiè",
  壮发冲冠: "zhuàng fā chōng guàn",
  庄严宝相: "zhuāng yán bǎo xiàng",
  转愁为喜: "zhuǎn chóu wéi xǐ",
  转嗔为喜: "zhuǎn chēn wéi xǐ",
  拽巷啰街: "zhuài xiàng luó jiē",
  拽耙扶犁: "zhuāi pá fú lí",
  拽布拖麻: "zhuài bù tuō má",
  箸长碗短: "zhù cháng wǎn duǎn",
  铸剑为犁: "zhù jiàn wéi lí",
  杼柚其空: "zhù yòu qí kōng",
  杼柚空虚: "zhù yòu kōng xū",
  助天为虐: "zhù tiān wéi nüè",
  属垣有耳: "zhǔ yuán yǒu ěr",
  属毛离里: "zhǔ máo lí lǐ",
  属辞比事: "zhǔ cí bǐ shì",
  逐物不还: "zhú wù bù huán",
  铢量寸度: "zhū liáng cùn duó",
  铢两悉称: "zhū liǎng xī chèn",
  侏儒观戏: "zhū rú guān xì",
  朱轓皁盖: "zhū fān zào gài",
  昼度夜思: "zhòu duó yè sī",
  诪张为幻: "zhōu zhāng wéi huàn",
  重明继焰: "chóng míng jì yàn",
  众啄同音: "zhòng zhuó tóng yīn",
  众毛攒裘: "zhòng máo cuán qiú",
  众好众恶: "zhòng hào zhòng wù",
  擿埴索涂: "zhāi zhí suǒ tú",
  稚齿婑媠: "zhì chǐ wǒ tuó",
  至当不易: "zhì dàng bú yì",
  指皂为白: "zhǐ zào wéi bái",
  指雁为羹: "zhǐ yàn wéi gēng",
  指树为姓: "zhǐ shù wéi xìng",
  指山说磨: "zhǐ shān shuō mò",
  止戈为武: "zhǐ gē wéi wǔ",
  枝干相持: "zhī gàn xiāng chí",
  枝大于本: "zh dà yú běn",
  支吾其词: "zhī wú qí cí",
  正身率下: "zhèng shēn shuài xià",
  正冠李下: "zhèng guàn lǐ xià",
  整冠纳履: "zhěng guān nà lǚ",
  整躬率物: "zhěng gōng shuài wù",
  整顿干坤: "zhěng dùn gàn kūn",
  针头削铁: "zhēn tóu xuē tiě",
  贞松劲柏: "zhēn sōng jìng bǎi",
  赭衣塞路: "zhě yī sè lù",
  折箭为誓: "shé jiàn wéi shì",
  折而族之: "zhé ér zú zhī",
  昭德塞违: "zhāo dé sè wéi",
  章句小儒: "zhāng jù xiǎo rú",
  湛恩汪濊: "zhàn ēn wāng huì",
  占风望气: "zhān fēng wàng qì",
  斩将搴旗: "zhǎn jiàng qiān qí",
  曾母投杼: "zēng mǔ tóu zhù",
  曾参杀人: "zēng shēn shā rén",
  造谣中伤: "zào yáo zhòng shāng",
  早占勿药: "zǎo zhān wù yào",
  凿龟数策: "záo guī shǔ cè",
  攒三聚五: "cuán sān jù wǔ",
  攒眉蹙额: "cuán mei cù é",
  攒零合整: "cuán líng hé zhěng",
  攒锋聚镝: "cuán fēng jù dí",
  载笑载言: "zài xiào zài yán",
  载酒问字: "zài jiǔ wèn zì",
  殒身不恤: "yǔn shēn bú xù",
  云舒霞卷: "yún shū xiá juǎn",
  月中折桂: "yuè zhōng shé guì",
  月落参横: "yuè luò shēn héng",
  鬻驽窃价: "yù nú qiè jià",
  鬻鸡为凤: "yù jī wéi fèng",
  遇难成祥: "yù nàn chéng xiáng",
  郁郁累累: "yù yù lěi lěi",
  玉卮无当: "yù zhī wú dàng",
  语笑喧阗: "yǔ xiào xuān tián",
  与世沉浮: "yǔ shì chén fú",
  与时消息: "yǔ shí xiāo xi",
  逾墙钻隙: "yú qiáng zuān xì",
  渔夺侵牟: "yú duó qīn móu",
  杅穿皮蠹: "yú chuān pí dù",
  余勇可贾: "yú yǒng kě gǔ",
  予智予雄: "yú zhì yú xióng",
  予取予求: "yú qǔ yú qiú",
  于家为国: "yú jiā wéi guó",
  有借无还: "yǒu jiè wú huán",
  有加无已: "yǒu jiā wú yǐ",
  有国难投: "yǒu guó nán tóu",
  游必有方: "yóu bì yǒu fāng",
  油干灯尽: "yóu gàn dēng jìn",
  尤云殢雨: "yóu yún tì yǔ",
  庸中皦皦: "yōng zhōng jiǎo jiǎo",
  郢书燕说: "yǐng shū yān shuō",
  营蝇斐锦: "yíng yíng fēi jǐn",
  鹰心雁爪: "yīng xīn yàn zhǎo",
  莺吟燕儛: "yīng yín yàn wǔ",
  应天顺时: "yīng tiān shùn shí",
  印累绶若: "yìn léi shòu ruò",
  隐占身体: "yǐn zhàn shēn tǐ",
  饮犊上流: "yìn dú shàng liú",
  引绳切墨: "yǐn shéng qiē mò",
  龈齿弹舌: "yín chǐ dàn shé",
  因缘为市: "yīn yuán wéi shì",
  因树为屋: "yīn shù wéi wū",
  溢美溢恶: "yì měi yì wù",
  抑塞磊落: "yì sè lěi luò",
  倚闾望切: "yǐ lǘ wàng qiē",
  以意为之: "yǐ yì wéi zhī",
  以言为讳: "yǐ yán wéi huì",
  以疏间亲: "yǐ shū jiàn qīn",
  以水济水: "yǐ shuǐ jǐ shuǐ",
  以书为御: "yǐ shū wéi yù",
  以守为攻: "yǐ shǒu wéi gōng",
  以升量石: "yǐ shēng liáng dàn",
  以慎为键: "yǐ shèn wéi jiàn",
  以筌为鱼: "yǐ quán wéi yú",
  以利累形: "yǐ lì lěi xíng",
  以毁为罚: "yǐ huǐ wéi fá",
  以黑为白: "yǐ hēi wéi bái",
  以规为瑱: "yǐ guī wéi tiàn",
  以古为鉴: "yǐ gǔ wéi jiàn",
  以宫笑角: "yǐ gōng xiào jué",
  以法为教: "yǐ fǎ wéi jiào",
  以大恶细: "yǐ dà wù xì",
  遗世忘累: "yí shì wàng lěi",
  遗寝载怀: "yí qǐn zài huái",
  移的就箭: "yí dì jiù jiàn",
  依头缕当: "yī tóu lǚ dàng",
  衣租食税: "yì zū shí shuì",
  衣轻乘肥: "yì qīng chéng féi",
  衣裳之会: "yī shang zhī huì",
  衣单食薄: "yī dān shí bó",
  一还一报: "yì huán yí bào",
  叶公好龙: "yè gōng hào lóng",
  野调无腔: "yě diào wú qiāng",
  瑶池女使: "yáo chí nǚ shǐ",
  幺麽小丑: "yāo mó xiǎo chǒu",
  养精畜锐: "yǎng jīng xù ruì",
  卬首信眉: "áng shǒu shēn méi",
  洋洋纚纚: "yáng yáng sǎ sǎ",
  羊羔美酒: "yáng gāo měi jiǔ",
  扬风扢雅: "yáng fēng jié yǎ",
  燕昭市骏: "yān zhāo shì jùn",
  燕昭好马: "yān zhāo hǎo mǎ",
  燕石妄珍: "yān shí wàng zhēn",
  燕骏千金: "yān jùn qiān jīn",
  燕金募秀: "yān jīn mù xiù",
  燕驾越毂: "yān jià yuè gǔ",
  燕歌赵舞: "yān gē zhào wǔ",
  燕岱之石: "yān dài zhī shí",
  燕处危巢: "yàn chǔ wēi cháo",
  掞藻飞声: "shàn zǎo fēi shēng",
  偃革为轩: "yǎn gé wéi xuān",
  妍蚩好恶: "yán chī hǎo è",
  压良为贱: "yā liáng wéi jiàn",
  搀行夺市: "chān háng duó shì",
  泣数行下: "qì shù háng xià",
  当行出色: "dāng háng chū sè",
  秀出班行: "xiù chū bān háng",
  儿女成行: "ér nǚ chéng háng",
  大行大市: "dà háng dà shì",
  寻行数墨: "xún háng shǔ mò",
  埙篪相和: "xūn chí xiāng hè",
  血债累累: "xuè zhài lěi lěi",
  炫玉贾石: "xuàn yù gǔ shí",
  炫石为玉: "xuàn shí wéi yù",
  悬石程书: "xuán dàn chéng shū",
  悬狟素飡: "xuán huán sù cān",
  悬龟系鱼: "xuán guī xì yú",
  揎拳捋袖: "xuān quán luō xiù",
  轩鹤冠猴: "xuān hè guàn hóu",
  畜妻养子: "xù qī yǎng zǐ",
  羞人答答: "xiū rén dā dā",
  修鳞养爪: "xiū lín yǎng zhǎo",
  熊据虎跱: "xióng jù hǔ zhì",
  兄死弟及: "xiōng sǐ dì jí",
  腥闻在上: "xīng wén zài shàng",
  兴文匽武: "xīng wén yǎn wǔ",
  兴观群怨: "xìng guān qún yuàn",
  兴高彩烈: "xìng gāo cǎi liè",
  心手相应: "xīn shǒu xiāng yìng",
  心口相应: "xīn kǒu xiāng yīng",
  挟势弄权: "xié shì nòng quán",
  胁肩累足: "xié jiān lěi zú",
  校短量长: "jiào duǎn liáng cháng",
  小眼薄皮: "xiǎo yǎn bó pí",
  硝云弹雨: "xiāo yún dàn yǔ",
  鸮鸣鼠暴: "xiāo míng shǔ bào",
  削株掘根: "xuē zhū jué gēn",
  削铁无声: "xuē tiě wú shēng",
  削职为民: "xuē zhí wéi mín",
  削木为吏: "xuē mù wéi lì",
  想望风褱: "xiǎng wàng fēng huái",
  香培玉琢: "xiang pei yu zhuó",
  相鼠有皮: "xiàng shǔ yǒu pí",
  相时而动: "xiàng shí ér dòng",
  相切相磋: "xiāng qiē xiāng cuō",
  相女配夫: "xiàng nǚ pèi fū",
  相门有相: "xiàng mén yǒu xiàng",
  挦章撦句: "xián zhāng chě jù",
  先我着鞭: "xiān wǒ zhuó biān",
  习焉不察: "xí yān bù chá",
  歙漆阿胶: "shè qī ē jiāo",
  晰毛辨发: "xī máo biàn fà",
  悉索薄赋: "xī suǒ bó fù",
  雾鳞云爪: "wù lín yún zhǎo",
  物稀为贵: "wù xī wéi guì",
  碔砆混玉: "wǔ fū hùn yù",
  武断专横: "wǔ duàn zhuān héng",
  五石六鹢: "wǔ shí liù yì",
  五色相宣: "wǔ sè xiāng xuān",
  五侯七贵: "wǔ hóu qī guì",
  五侯蜡烛: "wǔ hòu là zhú",
  五羖大夫: "wǔ gǔ dà fū",
  吾自有处: "wú zì yǒu chǔ",
  无下箸处: "wú xià zhù chǔ",
  无伤无臭: "wú shāng wú xiù",
  无能为役: "wú néng wéi yì",
  无寇暴死: "wú kòu bào sǐ",
  无孔不钻: "wú kǒng bú zuàn",
  无间可乘: "wú jiān kě chéng",
  无间冬夏: "wú jiān dōng xià",
  无恶不为: "wú è bù wéi",
  无动为大: "wú dòng wéi dà",
  诬良为盗: "wū liáng wéi dào",
  握拳透爪: "wò quán tòu zhǎo",
  文武差事: "wén wǔ chāi shì",
  委委佗佗: "wēi wēi tuó tuó",
  惟日为岁: "wéi rì wéi suì",
  帷薄不修: "wéi bó bù xiū",
  为善最乐: "wéi shàn zuì lè",
  为山止篑: "wéi shān zhǐ kuì",
  为仁不富: "wéi rén bú fù",
  为裘为箕: "wéi qiú wéi jī",
  为民父母: "wéi mín fù mǔ",
  为虺弗摧: "wéi huǐ fú cuī",
  为好成歉: "wéi hǎo chéng qiàn",
  为鬼为蜮: "wéi guǐ wéi yù",
  望风响应: "wàng fēng xiǎng yīng",
  望尘僄声: "wàng chén piào shēng",
  往渚还汀: "wǎng zhǔ huán tīng",
  王贡弹冠: "wáng gòng dàn guàn",
  亡国大夫: "wáng guó dà fū",
  万贯家私: "wàn guàn jiā sī",
  晚食当肉: "wǎn shí dàng ròu",
  晚节不保: "wǎn jié bù bǎo",
  玩岁愒时: "wán suì kài shí",
  蛙蟆胜负: "wā má shèng fù",
  吞言咽理: "tūn yán yàn lǐ",
  颓垣断堑: "tuí yuán duàn qiàn",
  推干就湿: "tuī gàn jiù shī",
  剸繁决剧: "tuán fán jué jù",
  团头聚面: "tuán tóu jù miàn",
  兔丝燕麦: "tù sī yàn mài",
  兔头麞脑: "tù tóu zhāng nǎo",
  兔葵燕麦: "tù kuí yàn mài",
  吐哺握发: "tǔ bǔ wò fà",
  投传而去: "tóu zhuàn ér qù",
  头没杯案: "tóu mò bēi àn",
  头昏脑闷: "tóu hūn nǎo mèn",
  头会箕敛: "tóu kuài jī liǎn",
  头出头没: "tóu chū tóu mò",
  痛自创艾: "tòng zì chuāng yì",
  同恶相助: "tóng wù xiāng zhù",
  同恶相恤: "tóng wù xiāng xù",
  痌瘝在抱: "tōng guān zài bào",
  通文调武: "tōng wén diào wǔ",
  停留长智: "tíng liú zhǎng zhì",
  铁树开华: "tiě shù kāi huā",
  条贯部分: "tiáo guàn bù fēn",
  挑牙料唇: "tiǎo yá liào chún",
  挑么挑六: "tiāo yāo tiāo liù",
  挑唇料嘴: "tiǎo chún liào zuǐ",
  恬不为意: "tián bù wéi yì",
  恬不为怪: "tián bù wéi guài",
  天下为笼: "tiān xià wéi lóng",
  天台路迷: "tiān tái lù mí",
  天年不遂: "tiān nián bú suì",
  探囊胠箧: "tàn náng qū qiè",
  谭言微中: "tán yán wēi zhòng",
  谈言微中: "tán yán wēi zhòng",
  狧穅及米: "shì kāng jí mǐ",
  随物应机: "suí wù yīng jī",
  搜岩采干: "sōu yán cǎi gàn",
  宋斤鲁削: "sòng jīn lǔ xuē",
  松筠之节: "sōng yún zhī jié",
  四亭八当: "sì tíng bā dàng",
  四马攒蹄: "sì mǎ cuán tí",
  四不拗六: "sì bú niù liù",
  思所逐之: "sī suǒ zhú zhī",
  丝恩发怨: "sī ēn fà yuàn",
  硕望宿德: "shuò wàng xiǔ dé",
  铄古切今: "shuò gǔ qiē jīn",
  顺风而呼: "shùn fēng ér hū",
  顺风吹火: "shùn fēng chuī huǒ",
  水中著盐: "shuǐ zhōng zhuó yán",
  双柑斗酒: "shuāng gān dǒu jiǔ",
  数米而炊: "shǔ mǐ ér chuī",
  数米量柴: "shǔ mǐ liáng chái",
  数理逻辑: "shù lǐ luó ji",
  数黑论黄: "shǔ hēi lùn huáng",
  数白论黄: "shǔ bái lùn huáng",
  束缊还妇: "shù yūn huán fù",
  束蒲为脯: "shù pú wéi pú",
  束椽为柱: "shù chuán wéi zhù",
  书缺有间: "shū quē yǒu jiàn",
  手足重茧: "shǒu zú chóng jiǎn",
  手足异处: "shǒu zú yì chǔ",
  手脚干净: "shǒu jiǎo gàn jìng",
  手不应心: "shǒu bù yīng xīn",
  螫手解腕: "shì shǒu jiě wàn",
  释知遗形: "shì zhī yí xíng",
  适时应务: "shì shí yīng wù",
  适情率意: "shì qíng shuài yì",
  适当其冲: "shì dāng qí chōng",
  视为知己: "shì wéi zhī jǐ",
  使羊将狼: "shǐ yáng jiàng láng",
  食为民天: "shí wéi mín tiān",
  拾掇无遗: "shí duō wú yí",
  实与有力: "shí yù yǒu lì",
  石英玻璃: "shí yīng bō li",
  石室金匮: "shí shì jīn guì",
  什袭珍藏: "shí xí zhēn cáng",
  什伍东西: "shí wǔ dōng xī",
  什围伍攻: "shí wéi wǔ gōng",
  十魔九难: "shí mó jiǔ nàn",
  诗书发冢: "shī shū fà zhǒng",
  虱处裈中: "shī chǔ kūn zhōng",
  师直为壮: "shī zhí wéi zhuàng",
  尸居龙见: "shī jū lóng xiàn",
  圣经贤传: "shèng jīng xián zhuàn",
  圣君贤相: "shèng jūn xián xiàng",
  生拖死拽: "shēng tuō sǐ zhuài",
  审己度人: "shěn jǐ duó rén",
  神武挂冠: "shén wǔ guà guàn",
  神龙失埶: "shén lóng shī shì",
  深文曲折: "shēn wén qǔ shé",
  深厉浅揭: "shēn lì qiǎn qì",
  深谷为陵: "shēn gǔ wéi líng",
  深恶痛疾: "shēn wù tòng jí",
  深仇宿怨: "shēn chóu xiǔ yuàn",
  舍己为公: "shě jǐ wèi gōng",
  舍短取长: "shě duǎn qǔ cháng",
  舍策追羊: "shě cè zhuī yáng",
  蛇蝎为心: "shé xiē wéi xīn",
  少成若性: "shào chéng ruò xìng",
  上当学乖: "shàng dàng xué guāi",
  赏不当功: "shǎng bù dāng gōng",
  善自为谋: "shàn zì wéi móu",
  善为说辞: "shàn wéi shuō cí",
  善善恶恶: "shàn shàn wù è",
  善财难舍: "shàn cái nán shě",
  苫眼铺眉: "shān yǎn pū méi",
  讪牙闲嗑: "shàn yá xián kē",
  山阴乘兴: "shān yīn chéng xīng",
  山殽野湋: "shān yáo yě wéi",
  山溜穿石: "shān liù chuān shí",
  山节藻棁: "shān jié zǎo zhuō",
  杀鸡为黍: "shā jī wéi shǔ",
  色厉胆薄: "sè lì dǎn bó",
  桑荫未移: "sāng yīn wèi yí",
  桑荫不徙: "sāng yīn bù xǐ",
  桑土绸缪: "sāng tǔ chóu miù",
  桑户棬枢: "sāng hù juàn shū",
  三战三北: "sān zhàn sān běi",
  三瓦两舍: "sān wǎ liǎng shě",
  三人为众: "sān rén wèi zhòng",
  三差两错: "sān chā liǎng cuò",
  塞井焚舍: "sāi jǐng fén shě",
  洒心更始: "sǎ xīn gèng shǐ",
  洒扫应对: "sǎ sǎo yìng duì",
  软红香土: "ruǎn hóng xiāng tǔ",
  入吾彀中: "rù wú gòu zhōng",
  入铁主簿: "rù tiě zhǔ bù",
  入理切情: "rù lǐ qiē qíng",
  汝成人耶: "rǔ chéng rén yé",
  如水投石: "rú shuǐ tóu shí",
  如切如磋: "rú qiē rú cuō",
  如登春台: "rú dēng chūn tái",
  肉薄骨并: "ròu bó gǔ bìng",
  柔情绰态: "róu qíng chuò tài",
  戎马劻勷: "róng mǎ kuāng ráng",
  日中为市: "rì zhōng wéi shì",
  日月参辰: "rì yuè shēn chén",
  日省月修: "rì xǐng yuè xiū",
  日削月割: "rì xuē yuè gē",
  日省月试: "rì xǐng yuè shì",
  任达不拘: "rèn dá bù jū",
  人言藉藉: "rén yán jí jí",
  人模狗样: "rén mú gǒu yàng",
  人莫予毒: "rén mò yú dú",
  热熬翻饼: "rè áo fān bǐng",
  圈牢养物: "juàn láo yǎng wù",
  取予有节: "qǔ yǔ yǒu jié",
  诎要桡腘: "qū yāo ráo guó",
  穷形尽相: "qióng xíng jìn xiàng",
  情凄意切: "qíng qī yì qiè",
  情见势屈: "qíng xiàn shì qū",
  情见乎辞: "qíng xiàn hū cí",
  清都绛阙: "qīng dōu jiàng què",
  倾肠倒肚: "qīng cháng dào dǔ",
  青紫被体: "qīng zǐ pī tǐ",
  青林黑塞: "qīng lín hēi sài",
  螓首蛾眉: "qín shǒu é méi",
  琴瑟之好: "qín sè zhī hào",
  且住为佳: "qiě zhù wéi jiā",
  切树倒根: "qiē shù dǎo gēn",
  切理餍心: "qiē lǐ yàn xīn",
  切近的当: "qiē jìn de dāng",
  翘足引领: "qiáo zú yǐn lǐng",
  巧发奇中: "qiǎo fā qí zhòng",
  强嘴拗舌: "jiàng zuǐ niù shé",
  强直自遂: "qiáng zhí zì suí",
  强死强活: "qiǎng sǐ qiǎng huó",
  强食自爱: "qiǎng shí zì ài",
  强食靡角: "qiǎng shí mí jiǎo",
  强弓劲弩: "qiáng gōng jìng nǔ",
  强聒不舍: "qiǎng guō bù shě",
  强凫变鹤: "qiáng fú biàn hè",
  强而后可: "qiǎng ér hòu kě",
  强得易贫: "qiǎng dé yì pín",
  遣兴陶情: "qiǎn xìng táo qíng",
  牵羊担酒: "qiān yáng dān jiǔ",
  千了百当: "qiān liǎo bǎi dàng",
  泣下如雨: "qì xià rú yǔ",
  起偃为竖: "qǐ yǎn wéi shù",
  岂弟君子: "kǎi tì jūn zǐ",
  綦溪利跂: "qí xī lì qí",
  棋输先著: "qí shū xiān zhuó",
  齐王舍牛: "qí wáng shě niú",
  欺天诳地: "qī tiān kuáng dì",
  普天率土: "pǔ tiān shuài tǔ",
  铺胸纳地: "pū xiōng nà dì",
  铺锦列绣: "pū jǐn liè xiù",
  破家为国: "pò jiā wèi guó",
  破觚为圜: "pò gū wéi yuán",
  萍飘蓬转: "píng piāo péng zhuàn",
  帡天极地: "píng tiān jí dì",
  屏声息气: "bǐng shēng xī qì",
  凭几据杖: "píng jī jù zhàng",
  贫嘴薄舌: "pín zuǐ bó shé",
  片语只辞: "piàn yǔ zhī cí",
  披发文身: "pī fà wén shēn",
  烹龙炮凤: "pēng lóng páo fèng",
  炰鳖脍鲤: "fǒu biē kuài lǐ",
  庞眉皓发: "páng méi hào fà",
  攀花折柳: "pān huā zhé liǔ",
  攀蟾折桂: "pān chán shé guì",
  女大难留: "nǚ dà nán liú",
  弄玉吹箫: "nòng yù chuī xiāo",
  弄管调弦: "nòng guǎn tiáo xián",
  弄粉调朱: "nòng fěn diào zhū",
  浓抹淡妆: "nóng mò dàn zhuāng",
  捻土为香: "niǎn tǔ wéi xiāng",
  年谊世好: "nián yì shì hǎo",
  年华垂暮: "nián huá chuí mù",
  儗不于伦: "nǐ bù yú lún",
  泥而不滓: "ní ér bù zǐ",
  能者为师: "néng zhě wéi shī",
  能不称官: "néng bú chèn guān",
  挠直为曲: "náo zhí wéi qū",
  难进易退: "nán jìn yì tuì",
  难得糊涂: "nán dé hú tú",
  南蛮鴂舌: "nán mán jué shé",
  南贩北贾: "nán fàn běi gǔ",
  牧猪奴戏: "mù zhū nú xì",
  目眢心忳: "mù yuān xīn tún",
  目挑心招: "mù tiǎo xīn zhāo",
  目量意营: "mù liàng yì yíng",
  木头木脑: "mù tóu mù nǎo",
  木干鸟栖: "mù gàn niǎo qī",
  侔色揣称: "móu sè chuǎi chèn",
  莫予毒也: "mò yú dú yě",
  抹粉施脂: "mò fěn shī zhī",
  磨砻镌切: "mó lóng juān qiē",
  磨棱刓角: "mó léng wán jiǎo",
  摸门不着: "mō mén bù zháo",
  摸不着边: "mō bù zhuó biān",
  命中注定: "mìng zhōng zhù dìng",
  鸣鹤之应: "míng hè zhī yìng",
  明效大验: "míng xiào dà yàn",
  名我固当: "míng wǒ gù dāng",
  邈处欿视: "miǎo chǔ kǎn shì",
  黾穴鸲巢: "měng xué qú cháo",
  绵里薄材: "mián lǐ bó cái",
  靡有孑遗: "mǐ yǒu jié yí",
  靡衣偷食: "mǐ yī tōu shí",
  迷恋骸骨: "mí liàn hái gǔ",
  扪参历井: "mén shēn lì jǐng",
  门单户薄: "mén dān hù bó",
  昧旦晨兴: "mèi dàn chén xīng",
  冒名接脚: "mào míng jiē jiǎo",
  毛遂堕井: "máo suí duò jǐng",
  毛发倒竖: "máo fā dǎo shù",
  卖文为生: "mài wén wéi shēng",
  卖李钻核: "mài lǐ zuān hé",
  买椟还珠: "mǎi dú huán zhū",
  埋三怨四: "mán sān yuàn sì",
  马入华山: "mǎ rù huá shān",
  落魄江湖: "luò pò jiāng hú",
  落落难合: "luò luò nán hé",
  落草为寇: "luò cǎo wéi kòu",
  罗织构陷: "luó zhī gòu xiàn",
  鸾凤和鸣: "luán fèng hè míng",
  率由旧章: "shuài yóu jiù zhāng",
  率土同庆: "shuài tǔ tóng qìng",
  率兽食人: "shuài shòu shí rén",
  率土归心: "shuài tǔ guī xīn",
  率马以骥: "shuài mǎ yǐ jì",
  率尔成章: "shuài ěr chéng zhāng",
  鲁斤燕削: "lǔ jīn yàn xuē",
  漏尽更阑: "lòu jìn gēng lán",
  笼鸟槛猿: "lóng niǎo jiàn yuán",
  笼鸟池鱼: "lóng niǎo chí yú",
  龙游曲沼: "lóng yóu qū zhǎo",
  龙血玄黄: "lóng xuè xuán huáng",
  龙雕凤咀: "lóng diāo fèng jǔ",
  六尺之讬: "liù chǐ zhī tuō",
  令原之戚: "líng yuán zhī qī",
  令人捧腹: "lìng rén pěng fù",
  陵劲淬砺: "líng jìng cuì lì",
  临敌易将: "lín dí yì jiàng",
  裂裳衣疮: "liè shang yī chuāng",
  裂冠毁冕: "liè guàn huǐ miǎn",
  了无惧色: "liǎo wú jù sè",
  了身达命: "liǎo shēn dá mìng",
  了然无闻: "liǎo rán wú wén",
  了不可见: "liǎo bù kě jiàn",
  了不长进: "liǎo bù zhǎng jìn",
  燎发摧枯: "liǎo fà cuī kū",
  审时度势: "shěn shí duó shì",
  量小力微: "liàng xiǎo lì wēi",
  相时度力: "xiāng shí duó lì",
  量枘制凿: "liàng ruì zhì záo",
  量如江海: "liàng rú jiāng hǎi",
  量金买赋: "liàng jīn mǎi fù",
  量己审分: "liàng jǐ shěn fēn",
  敛骨吹魂: "liǎn gǔ chuī hún",
  詈夷为跖: "lì yí wéi zhí",
  利令志惛: "lì lìng zhì hūn",
  李广不侯: "lǐ guǎng bú hòu",
  礼为情貌: "lǐ wéi qíng mào",
  礼让为国: "lǐ ràng wéi guó",
  犁生骍角: "lí shēng xīng jiǎo",
  离本徼末: "lí běn jiǎo mò",
  楞眉横眼: "léng méi hèng yǎn",
  擂天倒地: "léi tiān dǎo dì",
  累足成步: "lěi zú chéng bù",
  累瓦结绳: "lěi wǎ jié shéng",
  累土至山: "lěi tǔ zhì shān",
  累土聚沙: "lěi tǔ jù shā",
  累卵之危: "lěi luǎn zhī wēi",
  累累如珠: "lěi lěi rú zhū",
  累块积苏: "lěi kuài jī sū",
  乐山乐水: "lè shān lè shuǐ",
  潦原浸天: "lǎo yuán jìn tiān",
  老师宿儒: "lǎo shī xiǔ rú",
  牢什古子: "láo shí gǔ zi",
  琅嬛福地: "láng huán fú dì",
  揆情度理: "kuí qíng duó lǐ",
  旷日累时: "kuàng rì lěi shí",
  匡救弥缝: "kuāng jiù mí fèng",
  枯树生华: "kū shù shēng huā",
  口轻舌薄: "kǒu qīng shé bó",
  口角生风: "kǒu jiǎo shēng fēng",
  口角春风: "kǒu jiǎo chūn fēng",
  口角风情: "kǒu jiǎo fēng qíng",
  口干舌焦: "kǒu gān shé jiāo",
  口腹之累: "kǒu fù zhī lěi",
  空腹便便: "kōng fù pián pián",
  嗑牙料嘴: "kē yá liào zuǐ",
  刻木为鹄: "kè mù wéi hú",
  咳珠唾玉: "ké zhū tuò yù",
  咳唾成珠: "ké tuò chéng zhū",
  抗颜为师: "kàng yán wéi shī",
  开华结果: "kāi huā jié guǒ",
  峻阪盐车: "jùn bǎn yán chē",
  嚼铁咀金: "jiáo tiě jǔ jīn",
  嚼墨喷纸: "jué mò pēn zhǐ",
  倔头强脑: "juè tóu jiàng nǎo",
  倔头倔脑: "juè tóu juè nǎo",
  倦鸟知还: "juàn niǎo zhī huán",
  卷席而葬: "juǎn xí ér zàng",
  卷甲倍道: "juǎn jiǎ bèi dào",
  聚米为山: "jù mǐ wéi shān",
  举手相庆: "jǔ shǒu xiāng qìng",
  举世混浊: "jǔ shì hún zhuó",
  鞠为茂草: "jū wéi mào cǎo",
  拘神遣将: "jū shén qiǎn jiàng",
  居下讪上: "jū xià shàn shàng",
  久要不忘: "jiǔ yāo bú wàng",
  九转功成: "jiǔ zhuǎn gōng chéng",
  九蒸三熯: "jiǔ zhēng sān hàn",
  敬业乐群: "jìng yè lè qún",
  井底虾蟆: "jǐng dǐ xiā má",
  旌旗卷舒: "jīng qí juǎn shū",
  荆棘载途: "jīng jí zài tú",
  禁舍开塞: "jìn shě kāi sāi",
  祲威盛容: "jìn wēi shèng róng",
  进退消长: "jìn tuì xiāo cháng",
  进退应矩: "jìn tuì yīng jǔ",
  进退触籓: "jìn tuì chù fān",
  进退跋疐: "jìn tuì bá zhì",
  尽多尽少: "jǐn duō jǐn shǎo",
  锦囊还矢: "jǐn náng huán shǐ",
  矜己自饰: "jīn jǐ zì shì",
  矜功负气: "jīn gōng fù qì",
  津关险塞: "jīn guān xiǎn sài",
  金吾不禁: "jīn wú bú jìn",
  金翅擘海: "jīn chì bāi hǎi",
  解衣衣人: "jiě yī yī rén",
  解人难得: "jiě rén nán dé",
  解铃系铃: "jiě líng xì líng",
  解发佯狂: "jiě fà yáng kuáng",
  诘屈磝碻: "jié qū áo qiāo",
  教猱升木: "jiāo náo shēng mù",
  较瘦量肥: "jiào shòu liàng féi",
  角立杰出: "jiǎo lì jié chū",
  焦沙烂石: "jiāo shā làn shí",
  骄儿騃女: "jiāo ér sì nǚ",
  浇风薄俗: "jiāo fēng bó sú",
  降妖捉怪: "xiáng yāo zhuō guài",
  将取固予: "jiāng qǔ gù yǔ",
  将门有将: "jiàng mén yǒu jiàng",
  将夺固与: "jiāng duó gù yǔ",
  槛花笼鹤: "jiàn huā lóng hè",
  鉴影度形: "jiàn yǐng duó xíng",
  渐不可长: "jiàn bù kě zhǎng",
  见素抱朴: "xiàn sù bào pǔ",
  见弃于人: "jiàn qì yú rén",
  简丝数米: "jiǎn sī shǔ mǐ",
  俭不中礼: "jiǎn bú zhòng lǐ",
  间见层出: "jiàn xiàn céng chū",
  尖嘴薄舌: "jiān zuǐ bó shé",
  甲冠天下: "jiǎ guàn tiān xià",
  葭莩之亲: "jiā fú zhī qīn",
  家累千金: "jiā lèi qiān jīn",
  家给人足: "jiā jǐ rén zú",
  家道从容: "jiā dào cóng róng",
  夹袋人物: "jiā dài rén wù",
  霁风朗月: "jì fēng lǎng yuè",
  寄兴寓情: "jì xìng yù qíng",
  计深虑远: "jì shēn lǜ yuǎn",
  计功量罪: "jì gōng liàng zuì",
  掎裳连襼: "jǐ shang lián yì",
  虮虱相吊: "jǐ shī xiāng diào",
  疾不可为: "jí bù kě wéi",
  极深研几: "jí shēn yán jī",
  及宾有鱼: "jí bīn yǒu yú",
  激薄停浇: "jī bó tíng jiāo",
  积素累旧: "jī sù lěi jiù",
  积时累日: "jī shí lěi rì",
  积露为波: "jī lù wéi bō",
  积德累功: "jī dé lěi gōng",
  积谗糜骨: "jī chán méi gǔ",
  击排冒没: "jī pái mào mò",
  祸为福先: "huò wéi fú xiān",
  祸福相依: "huò fú xiāng yī",
  获隽公车: "huò jùn gōng chē",
  混应滥应: "hùn yīng làn yīng",
  毁舟为杕: "huǐ zhōu wéi duò",
  毁钟为铎: "huǐ zhōng wéi duó",
  毁冠裂裳: "huǐ guān liè cháng",
  晦盲否塞: "huì máng pǐ sè",
  回船转舵: "huí chuán zhuàn duò",
  潢池盗弄: "huáng chí dào nòng",
  黄冠草履: "huáng guàn cǎo lǚ",
  黄发儿齿: "huáng fà ér chǐ",
  黄发垂髫: "huáng fà chuí tiáo",
  还珠返璧: "huán zhū fǎn bì",
  还年驻色: "huán nián zhù sè",
  还年却老: "huán nián què lǎo",
  坏裳为裤: "huài shang wéi kù",
  画荻和丸: "huà dí huò wán",
  化枭为鸠: "huà xiāo wéi jiū",
  化腐为奇: "huà fǔ wéi qí",
  化鸱为凤: "huà chī wéi fèng",
  花不棱登: "huā bu lēng dēng",
  户限为穿: "hù xiàn wéi chuān",
  呼卢喝雉: "hū lú hè zhì",
  呼来喝去: "hū lái hè qù",
  呼不给吸: "hū bù jǐ xī",
  厚味腊毒: "hòu wèi xī dú",
  厚德载物: "hòu dé zài wù",
  鸿渐于干: "hóng jiàn yú gàn",
  洪炉燎发: "hóng lú liáo fà",
  红绳系足: "hóng shéng jì zú",
  红不棱登: "hóng bu lēng dēng",
  横抢硬夺: "hèng qiǎng yìng duó",
  横恩滥赏: "hèng ēn làn shǎng",
  恨海难填: "hèn hǎi nán tián",
  鹤发鸡皮: "hè fà jī pí",
  涸思干虑: "hé sī gān lǜ",
  河涸海干: "hé hé hǎi gān",
  和颜说色: "hé yán yuè sè",
  合从连衡: "hé zòng lián héng",
  浩浩汤汤: "hào hào shāng shāng",
  好勇斗狠: "hào yǒng dòu hěn",
  好问则裕: "hào wèn zé yù",
  好为事端: "hào wéi shì duān",
  好问决疑: "hào wèn jué yí",
  好生之德: "hào shēng zhī dé",
  好奇尚异: "hǎo qí shàng yì",
  好恶不同: "hǎo è bù tóng",
  好丹非素: "hào dān fēi sù",
  豪干暴取: "háo gàn bào qǔ",
  毫发不爽: "háo fà bù shuǎng",
  寒酸落魄: "hán suān luò pò",
  含英咀华: "hán yīng jǔ huá",
  含糊不明: "hán hú bù míng",
  过为已甚: "guò wéi yǐ shèn",
  桂折兰摧: "guì shé lán cuī",
  规旋矩折: "guī xuán jǔ shé",
  广文先生: "guǎng wén xiān sheng",
  广陵散绝: "guǎng líng sǎn jué",
  冠山戴粒: "guàn shān dài lì",
  冠屦倒施: "guàn jù dǎo shī",
  挂席为门: "guà xí wéi mén",
  寡见鲜闻: "guǎ jiàn xiǎn wén",
  瓜葛相连: "guā gé xiāng lián",
  鼓吻奋爪: "gǔ wěn fèn zhǎo",
  古调单弹: "gǔ diào dān tán",
  古调不弹: "gǔ diào bù tán",
  姑射神人: "gū yè shén rén",
  苟合取容: "gǒu hé qǔ róng",
  狗续侯冠: "gǒu xù hòu guàn",
  钩爪锯牙: "gōu zhǎo jù yá",
  共枝别干: "gòng zhī bié gàn",
  共为唇齿: "gòng wéi chún chǐ",
  拱手而降: "gǒng shǒu ér xiáng",
  拱肩缩背: "gǒng jiān suō bèi",
  功薄蝉翼: "gōng bó chán yì",
  弓调马服: "gōng diào mǎ fú",
  更姓改物: "gēng xìng gǎi wù",
  更仆难数: "gēng pú nán shǔ",
  更令明号: "gēng lìng míng hào",
  更待干罢: "gèng dài gàn bà",
  更唱迭和: "gēng chàng dié hé",
  更长梦短: "gēng cháng mèng duǎn",
  各色名样: "gè sè míng yàng",
  格格不纳: "gé gé bú nà",
  格格不吐: "gé gé bù tǔ",
  告朔饩羊: "gù shuò xì yáng",
  膏车秣马: "gào chē mò mǎ",
  高义薄云: "gāo yì bó yún",
  岗头泽底: "gāng tóu zé dǐ",
  敢为敢做: "gǎn wéi gǎn zuò",
  甘分随时: "gān fèn suí shí",
  甘处下流: "gān chǔ xià liú",
  干啼湿哭: "gàn tí shī kū",
  干名犯义: "gàn míng fàn yì",
  干将莫邪: "gān jiāng mò yé",
  干城之将: "gān chéng zhī jiàng",
  腹载五车: "fù zài wǔ chē",
  父债子还: "fù zhài zǐ huán",
  父为子隐: "fù wéi zǐ yǐn",
  辅世长民: "fǔ shì zhǎng mín",
  福为祸始: "fú wéi huò shǐ",
  符号逻辑: "fú hào luó jí",
  浮收勒折: "fú shōu lè shé",
  肤受之愬: "fū shòu zhī sù",
  否终则泰: "pǐ zhōng zé tài",
  佛头著粪: "fó tóu zhuó fèn",
  奉为楷模: "fèng wéi kǎi mó",
  凤靡鸾吪: "fèng mǐ luán é",
  封豨修蛇: "fēng xī xiū shé",
  风影敷衍: "fēng yǐng fū yǎn",
  丰屋蔀家: "fēng wū bù jiā",
  粪土不如: "fèn tǔ bù rú",
  分风劈流: "fēn fēng pǐ liú",
  沸沸汤汤: "fèi fèi shāng shāng",
  菲食薄衣: "fěi shí bó yī",
  飞将数奇: "fēi jiàng shù qí",
  放辟邪侈: "fàng pì xié chǐ",
  方领圆冠: "fāng lǐng yuán guàn",
  犯而不校: "fàn ér bú jiào",
  返本还源: "fǎn běn huán yuán",
  反劳为逸: "fǎn láo wéi yì",
  法轮常转: "fǎ lún cháng zhuàn",
  罚不当罪: "fá bù dāng zuì",
  发引千钧: "fà yǐn qiān jūn",
  发奸擿伏: "fā jiān tī fú",
  发短心长: "fà duǎn xīn cháng",
  二竖为虐: "èr shù wéi nüè",
  儿女心肠: "ér nǚ xīn cháng",
  儿女亲家: "ér nǚ qìng jiā",
  遏恶扬善: "è wù yáng shàn",
  饿殍枕藉: "è piǎo zhěn jí",
  饿殍载道: "è piǎo zài dào",
  恶醉强酒: "wù zuì qiǎng jiǔ",
  恶意中伤: "è yì zhòng shāng",
  恶湿居下: "wù shī jū xià",
  恶居下流: "wù jū xià liú",
  恶不去善: "wù bú qù shàn",
  扼吭夺食: "è háng duó shí",
  扼襟控咽: "è jīn kòng yān",
  峨峨汤汤: "é é shāng shāng",
  屙金溺银: "ē jīn niào yín",
  朵颐大嚼: "duǒ yí dà jiáo",
  夺人所好: "duó rén suǒ hào",
  多言数穷: "duō yán shuò qióng",
  多文为富: "duō wén wéi fù",
  多端寡要: "duō duān guǎ yào",
  多财善贾: "duō cái shàn gǔ",
  遁世无闷: "dùn shì wú mèn",
  遁迹黄冠: "dùn jì huáng guàn",
  堆案盈几: "duī àn yíng jī",
  断还归宗: "duàn huán guī zōng",
  短见薄识: "duǎn jiàn bó shí",
  蠹居棊处: "dù jū qí chǔ",
  度己以绳: "duó jǐ yǐ shéng",
  杜默为诗: "dù mò wéi shī",
  杜鹃啼血: "dù juān tí xuè",
  笃近举远: "dǔ jìn jǔ yuǎn",
  独有千秋: "dú yǒu qiān qiū",
  读书得间: "dú shū dé jiàn",
  斗转参横: "dǒu zhuǎn shēn héng",
  兜肚连肠: "dōu dǔ lián cháng",
  洞见症结: "dòng jiàn zhèng jié",
  恫疑虚喝: "dòng yí xū hè",
  动中窾要: "dòng zhōng kuǎn yào",
  东鸣西应: "dōng míng xī yīng",
  东鳞西爪: "dōng lín xī zhǎo",
  东量西折: "dōng liàng xī shé",
  东家西舍: "dōng jiā xī shè",
  东扯西拽: "dōng chě xī zhuāi",
  鼎铛有耳: "dǐng chēng yǒu ěr",
  鼎铛玉石: "dǐng chēng yù shí",
  钉头磷磷: "dīng tóu lín lín",
  跌宕不羁: "diē dàng bù jī",
  跌弹斑鸠: "diē dàn bān jiū",
  雕心雁爪: "diāo xīn yàn zhǎo",
  颠倒衣裳: "diān dǎo yī cháng",
  德薄能鲜: "dé bó néng xiǎn",
  得马折足: "dé mǎ shé zú",
  蹈其覆辙: "dǎo qí fù zhé",
  捣虚撇抗: "dǎo xū piē kàng",
  倒载干戈: "dào zài gān gē",
  倒裳索领: "dào cháng suǒ lǐng",
  倒果为因: "dào guǒ wéi yīn",
  叨在知己: "tāo zài zhī jǐ",
  叨陪末座: "tāo péi mò zuò",
  党豺为虐: "dǎng chái wéi nüè",
  当轴处中: "dāng zhóu chǔ zhōng",
  当着不着: "dāng zhuó bù zhuó",
  当务始终: "dāng wù shǐ zhōng",
  淡汝浓抹: "dàn rǔ nóng mǒ",
  弹丸脱手: "tán wán tuō shǒu",
  弹铗无鱼: "dàn jiá wú yú",
  箪食瓢饮: "dān sì piáo yǐn",
  大璞不完: "dà pú bù wán",
  大明法度: "dà míng fǎ dù",
  大车以载: "dà chē yǐ zài",
  打闷葫芦: "dǎ mèn hú lu",
  沓来踵至: "tà lái zhǒng zhì",
  厝火燎原: "cuò huǒ liǎo yuán",
  撮科打哄: "cuō kē dǎ hòng",
  寸积铢累: "cùn jī zhū lěi",
  啛啛喳喳: "cuì cuì chā chā",
  摧折豪强: "cuī zhé háo qiáng",
  摧刚为柔: "cuī gāng wéi róu",
  从俗就简: "cóng sú jiù jiǎn",
  此发彼应: "cǐ fā bǐ yīng",
  此唱彼和: "cǐ chàng bǐ hè",
  慈悲为本: "cí bēi wéi běn",
  纯属骗局: "chún shǔ piàn jú",
  春笋怒发: "chūn sǔn nù fā",
  垂头搨翼: "chuí tóu tà yì",
  传为笑谈: "chuán wéi xiào tán",
  传风扇火: "chuán fēng shān huǒ",
  穿红着绿: "chuān hóng zhuó lǜ",
  触处机来: "chù chǔ jī lái",
  处尊居显: "chǔ zūn jū xiǎn",
  处堂燕雀: "chǔ táng yàn què",
  处实效功: "chǔ shí xiào gōng",
  处高临深: "chǔ gāo lín shēn",
  出入无间: "chū rù wú jiān",
  出门应辙: "chū mén yīng zhé",
  出处语默: "chū chǔ yǔ mò",
  出处殊途: "chū chǔ shū tú",
  出处进退: "chū chǔ jìn tuì",
  愁山闷海: "chóu shān mèn hǎi",
  冲冠眦裂: "chōng guàn zì liè",
  齿牙为祸: "chǐ yá wéi huò",
  尺二冤家: "chǐ èr yuān jia",
  尺短寸长: "chǐ duǎn cùn cháng",
  尺寸之功: "chǐ cùn zhī gōng",
  城北徐公: "chéng běi xú gōng",
  成败兴废: "chéng bài xīng fèi",
  趁水和泥: "chèn shuǐ huò ní",
  称雨道晴: "chēng yǔ dào qíng",
  称体载衣: "chēng tǐ zài yī",
  称体裁衣: "chèn tǐ cái yī",
  称家有无: "chèn jiā yǒu wú",
  称德度功: "chēng dé duó gōng",
  沉吟章句: "chén yín zhāng jù",
  沉吟不决: "chén yín bù jué",
  沉疴宿疾: "chén kē sù jí",
  扯纤拉烟: "chě qiàn lā yān",
  扯顺风旗: "chě shùn fēng qí",
  车载船装: "chē zǎi chuán zhuāng",
  朝升暮合: "zhāo shēng mù gě",
  朝攀暮折: "zhāo pān mù shé",
  超今冠古: "chāo jīn guàn gǔ",
  倡而不和: "chàng ér bú hè",
  畅所欲为: "chàng suǒ yù wéi",
  苌弘碧血: "cháng hóng bì xiě",
  长幼尊卑: "zhǎng yòu zūn bēi",
  长绳系日: "cháng shéng jì rì",
  长年三老: "zhǎng nián sān lǎo",
  长春不老: "cháng chūn bù lǎo",
  长傲饰非: "zhǎng ào shì fēi",
  昌亭旅食: "chāng tíng lǚ shí",
  禅絮沾泥: "chán xù zhān ní",
  差三错四: "chā sān cuò sì",
  层台累榭: "céng tái lěi xiè",
  层见迭出: "céng xiàn dié chū",
  藏踪蹑迹: "cáng zōng niè jì",
  苍蝇见血: "cāng yíng jiàn xiě",
  餐松啖柏: "cān sōng dàn bó",
  骖风驷霞: "cān fēng sì xiá",
  参伍错综: "cēn wǔ cuò zōng",
  参辰卯酉: "shēn chén mǎo yǒu",
  材优干济: "cái yōu gān jǐ",
  材薄质衰: "cái bó zhì shuāi",
  才大难用: "cái dà nán yòng",
  才薄智浅: "cái bó zhì qiǎn",
  不足为意: "bù zú wéi yì",
  不足为据: "bù zú wéi jù",
  不足为法: "bù zú wéi fǎ",
  不足齿数: "bù zú chǐ shǔ",
  不着疼热: "bù zhuó téng rè",
  不知薡蕫: "bù zhī dǐng dǒng",
  不越雷池: "bú yuè léi chí",
  不相为谋: "bù xiāng wéi móu",
  不贪为宝: "bù tān wéi bǎo",
  不了而了: "bù liǎo ér liǎo",
  不可揆度: "bù kě kuí duó",
  不遑启处: "bù huáng qǐ chǔ",
  不当不正: "bù dāng bú zhèng",
  不差什么: "bú chà shén me",
  不差累黍: "bù chā lěi shǔ",
  擘两分星: "bò liǎng fēn xīng",
  簸土扬沙: "bǒ tǔ yáng shā",
  薄物细故: "bó wù xì gù",
  薄寒中人: "bó hán zhòng rén",
  博文约礼: "bó wén yuē lǐ",
  播糠眯目: "bō kāng mí mù",
  剥皮抽筋: "bō pí chōu jīn",
  剥肤椎髓: "bō fū chuí suǐ",
  波属云委: "bō zhǔ yún wěi",
  波骇云属: "bō hài yún zhǔ",
  兵微将寡: "bīng wēi jiàng guǎ",
  兵强将勇: "bīng qiáng jiàng yǒng",
  兵多将广: "bīng duō jiàng guǎng",
  兵不由将: "bīng bù yóu jiàng",
  冰解的破: "bīng jiě dì pò",
  彬彬济济: "bīn bīn jǐ jǐ",
  摽梅之年: "biào méi zhī nián",
  表里为奸: "biǎo lǐ wéi jiān",
  飙发电举: "biāo fā diàn jǔ",
  变贪厉薄: "biàn tān lì bó",
  敝盖不弃: "bì gài bú qì",
  秕言谬说: "bǐ yán miù shuō",
  比物属事: "bǐ wù zhǔ shì",
  被山带河: "pī shān dài hé",
  被甲枕戈: "pī jiǎ zhěn gē",
  被甲据鞍: "pī jiǎ jù ān",
  被褐怀玉: "pī hè huái yù",
  被发缨冠: "pī fà yīng guàn",
  背曲腰躬: "bèi qǔ yāo gōng",
  北窗高卧: "běi chuāng gāo wò",
  北辰星拱: "běi chén xīng gǒng",
  北鄙之音: "běi bǐ zhī yīn",
  卑宫菲食: "bēi gōng fěi shí",
  暴衣露冠: "pù yī lù guàn",
  暴腮龙门: "pù sāi lóng mén",
  暴露文学: "bào lù wén xué",
  暴虎冯河: "bào hǔ píng hé",
  抱蔓摘瓜: "bào wàn zhāi guā",
  抱法处势: "bào fǎ chǔ shì",
  褒贬与夺: "bāo biǎn yǔ duó",
  帮闲钻懒: "bāng xián zuān lǎn",
  拜将封侯: "bài jiàng fēng hóu",
  百兽率舞: "bǎi shòu shuài wǔ",
  百孔千创: "bǎi kǒng qiān chuāng",
  白衣卿相: "bái yī qīng xiàng",
  白首为郎: "bái shǒu wéi láng",
  白首相知: "bái shǒu xiāng zhī",
  把玩无厌: "bǎ wán wú yàn",
  拔锅卷席: "bá guō juǎn xí",
  拔本塞源: "bá běn sè yuán",
  傲不可长: "ào bù kě zhǎng",
  熬更守夜: "áo gēng shǒu yè",
  安时处顺: "ān shí chǔ shùn",
  安身为乐: "ān shēn wéi lè",
  安老怀少: "ān lǎo huái shào",
  安步当车: "ān bù dàng chē",
  爱人好士: "ài rén hào shì",
  矮人观场: "ǎi rén guān chǎng",
  捱风缉缝: "ái fēng jī fèng",
  挨山塞海: "āi shān sè hǎi",
  阿家阿翁: "ā jiā ā wēng",
  阿党相为: "ē dǎng xiāng wéi",
  追亡逐北: "zhuī wáng zhú běi",
  竹篮打水: "zhú lán dá shuǐ",
  知疼着热: "zhī téng zháo rè",
  语不惊人: "yǔ bù jīng rén",
  于今为烈: "yú jīn wéi liè",
  一日三省: "yí rì sān xǐng",
  穴居野处: "xué jū yě chǔ",
  五脊六兽: "wǔ jǐ liù shòu",
  无声无臭: "wú shēng wú xiù",
  谓予不信: "wèi yú bú xìn",
  舍身为国: "shě shēn wéi guó",
  杀妻求将: "shā qī qiú jiàng",
  强作解人: "qiǎng zuò jiě rén",
  气冲斗牛: "qì chōng dǒu niú",
  临深履薄: "lín shēn lǚ bó",
  钧天广乐: "jūn tiān guǎng yuè",
  艰难竭蹶: "jiān nán jié jué",
  夹七夹八: "jiā qī jiā bā",
  混混噩噩: "hún hún è è",
  厚古薄今: "hòu gǔ bó jīn",
  鬼怕恶人: "guǐ pà è rén",
  伽马射线: "gā mǎ shè xiàn",
  佛头着粪: "fó tóu zhuó fèn",
  奉为至宝: "fèng wéi zhì bǎo",
  登坛拜将: "dēng tán bài jiàng",
  晨昏定省: "chén hūn dìng xǐng",
  察察为明: "chá chá wéi míng",
  博闻强识: "bó wén qiáng zhì",
  避难就易: "bì nán jiù yì",
  了无生机: "liǎo wú shēng jī",
  // 一字不变调的词语，如果词语仅有单个一且一字在结尾的无需添加（需要增补更多）
  有一说一: "yǒu yī shuō yī",
  独一无二: "dú yī wú èr",
  说一不二: "shuō yī bù èr",
  举一反三: "jǔ yī fǎn sān",
  数一数二: "shǔ yī shǔ èr",
  杀一儆百: "shā yī jǐng bǎi",
  丁一卯二: "dīng yī mǎo èr",
  丁一确二: "dīng yī què èr",
  不一而止: "bù yī ér zhǐ",
  无一幸免: "wú yī xìng miǎn",
  // 来源：https://m.gushici.com/cyxy_4e00_4
  表里不一: "biǎo lǐ bù yī",
  良莠不一: "liáng yǒu bù yī",
  心口不一: "xīn kǒu bù yī",
  言行不一: "yán xíng bù yī",
  政令不一: "zhèng lìng bù yī",
  参差不一: "cēn cī bù yī",
  纷纷不一: "fēn fēn bù yī",
  毁誉不一: "huǐ yù bù yī",
  不一而三: "bù yī ér sān",
  百不一遇: "bǎi bù yī yù",
  言行抱一: "yán xíng bào yī",
  瑜百瑕一: "yú bǎi xiá yī",
  背城借一: "bèi chéng jiè yī",
  凭城借一: "píng chéng jiè yī",
  劝百讽一: "quàn bǎi fěng yī",
  群居和一: "qún jū hé yī",
  百不获一: "bǎi bù huò yī",
  百不失一: "bǎi bù shī yī",
  百无失一: "bǎi wú shī yī",
  万不失一: "wàn bù shī yī",
  万无失一: "wàn wú shī yī",
  合而为一: "hé ér wéi yī",
  合两为一: "hé liǎng wéi yī",
  合二为一: "hé èr wéi yī",
  天下为一: "tiān xià wéi yī",
  相与为一: "xiāng yǔ wéi yī",
  较若画一: "jiào ruò huà yī",
  较如画一: "jiào rú huà yī",
  斠若画一: "jiào ruò huà yī",
  言行若一: "yán xíng ruò yī",
  始终若一: "shǐ zhōng ruò yī",
  终始若一: "zhōng shǐ ruò yī",
  惟精惟一: "wéi jīng wéi yī",
  众多非一: "zhòng duō fēi yī",
  不能赞一: "bù néng zàn yī",
  问一答十: "wèn yī dá shí",
  一不扭众: "yī bù niǔ zhòng",
  一以贯之: "yī yǐ guàn zhī",
  一以当百: "yī yǐ dāng bǎi",
  百不当一: "bǎi bù dāng yī",
  十不当一: "shí bù dāng yī",
  以一警百: "yǐ yī jǐng bǎi",
  以一奉百: "yǐ yī fèng bǎi",
  以一持万: "yǐ yī chí wàn",
  以一知万: "yǐ yī zhī wàn",
  百里挑一: "bǎi lǐ tiāo yī",
  整齐划一: "zhěng qí huà yī",
  一来二去: "yī lái èr qù",
  一路公交: "yī lù gōng jiāo",
  一路汽车: "yī lù qì chē",
  一路巴士: "yī lù bā shì",
  朝朝朝落: "zhāo cháo zhāo luò",
  曲意逢迎: "qū yì féng yíng",
  一行不行: "yì háng bù xíng",
  行行不行: "háng háng bù xíng"
}, nme = Object.keys(fU).map((t) => ({
  zh: t,
  pinyin: fU[t],
  probability: 2e-8,
  length: 4,
  priority: Go.Normal,
  dict: Symbol("dict4")
})), hU = {
  巴尔干半岛: "bā ěr gàn bàn dǎo",
  巴尔喀什湖: "bā ěr kā shí hú",
  不幸而言中: "bú xìng ér yán zhòng",
  布尔什维克: "bù ěr shí wéi kè",
  何乐而不为: "hé lè ér bù wéi",
  苛政猛于虎: "kē zhèng měng yú hǔ",
  蒙得维的亚: "méng dé wéi dì yà",
  民以食为天: "mín yǐ shí wéi tiān",
  事后诸葛亮: "shì hòu zhū gě liàng",
  物以稀为贵: "wù yǐ xī wéi guì",
  先下手为强: "xiān xià shǒu wéi qiáng",
  行行出状元: "háng háng chū zhuàng yuan",
  亚得里亚海: "yà dé lǐ yà hǎi",
  眼不见为净: "yǎn bú jiàn wéi jìng",
  竹筒倒豆子: "zhú tǒng dào dòu zi"
}, rme = Object.keys(hU).map((t) => ({
  zh: t,
  pinyin: hU[t],
  probability: 2e-8,
  length: 5,
  priority: Go.Normal,
  dict: Symbol("dict5")
}));
function pU(t, r) {
  return t && (t.decimal < r.decimal || t.decimal === r.decimal && t.probability > r.probability) ? t : r;
}
function gU(t) {
  t.probability < 1e-300 && (t.probability *= 1e300, t.decimal += 1);
}
function ime(t) {
  return t.priority === Go.Custom ? -(t.length * t.length * 100) : t.priority === Go.Surname ? -(t.length * t.length * 10) : 0;
}
function sme(t, r) {
  const a = [];
  let u = t.length - 1, h = t[u];
  for (let b = r - 1; b >= 0; b--) {
    const l = b + 1 >= r ? { probability: 1, decimal: 0, patterns: [] } : a[b + 1];
    for (; h && h.index + h.length - 1 === b; ) {
      const s = h.index, c = {
        probability: h.probability * l.probability,
        decimal: l.decimal + ime(h),
        patterns: l.patterns,
        concatPattern: h
      };
      gU(c), a[s] = pU(a[s], c), h = t[--u];
    }
    const v = {
      probability: 1e-13 * l.probability,
      decimal: 0,
      patterns: l.patterns
    };
    gU(v), a[b] = pU(a[b], v), a[b].concatPattern && (a[b].patterns = a[b].patterns.concat(a[b].concatPattern), a[b].concatPattern = void 0, delete a[b + 1]);
  }
  return a[0].patterns.reverse();
}
function mU(t, r) {
  return t && t.count <= r.count ? t : r;
}
function ame(t) {
  return t.priority === Go.Custom ? -(t.length * t.length * 1e5) : t.priority === Go.Surname ? -(t.length * t.length * 100) : 1;
}
function ome(t, r) {
  const a = [];
  let u = t.length - 1, h = t[u];
  for (let b = r - 1; b >= 0; b--) {
    const l = b + 1 >= r ? { count: 0, patterns: [] } : a[b + 1];
    for (; h && h.index + h.length - 1 === b; ) {
      const s = h.index, c = {
        count: ame(h) + l.count,
        patterns: l.patterns,
        concatPattern: h
      };
      a[s] = mU(a[s], c), h = t[--u];
    }
    const v = {
      count: 1 + l.count,
      patterns: l.patterns
    };
    a[b] = mU(a[b], v), a[b].concatPattern && (a[b].patterns = a[b].patterns.concat(a[b].concatPattern), a[b].concatPattern = void 0, delete a[b + 1]);
  }
  return a[0].patterns.reverse();
}
function cme(t, r) {
  return !(r.index + r.length <= t.index || r.priority > t.priority || r.priority === t.priority && r.length > t.length);
}
function ume(t) {
  const r = [];
  for (let a = t.length - 1; a >= 0; ) {
    const { index: u } = t[a];
    let h = a - 1;
    for (; h >= 0 && cme(t[a], t[h]); )
      h--;
    (h < 0 || t[h].index + t[h].length <= u) && r.push(t[a]), a = h;
  }
  return r.reverse();
}
var EU;
(function(t) {
  t[t.ReverseMaxMatch = 1] = "ReverseMaxMatch", t[t.MaxProbability = 2] = "MaxProbability", t[t.MinTokenization = 3] = "MinTokenization";
})(EU || (EU = {}));
class yU {
  constructor(r, a = "", u = "") {
    this.children = /* @__PURE__ */ new Map(), this.fail = null, this.patterns = [], this.parent = r, this.prefix = a, this.key = u;
  }
}
class dme {
  constructor() {
    this.dictMap = /* @__PURE__ */ new Map(), this.queues = [], this.root = new yU(null);
  }
  build(r) {
    this.buildTrie(r), this.buildFailPointer();
  }
  // 构建 trie 树
  buildTrie(r) {
    for (let a of r) {
      const u = yb(a.zh);
      let h = this.root;
      for (let b = 0; b < u.length; b++) {
        let l = u[b];
        if (!h.children.has(l)) {
          const v = new yU(h, u.slice(0, b).join(""), l);
          h.children.set(l, v), this.addNodeToQueues(v);
        }
        h = h.children.get(l);
      }
      this.insertPattern(h.patterns, a), a.node = h, this.addPatternToDictMap(a);
    }
  }
  // 构建失败指针
  buildFailPointer() {
    let r = [], a = 0;
    for (this.queues.forEach((u) => {
      r = r.concat(u);
    }), this.queues = []; r.length > a; ) {
      let u = r[a++], h = u.parent && u.parent.fail, b = u.key;
      for (; h && !h.children.has(b); )
        h = h.fail;
      h ? u.fail = h.children.get(b) : u.fail = this.root;
    }
  }
  // 将 pattern 添加到 dictMap 中
  addPatternToDictMap(r) {
    this.dictMap.has(r.dict) || this.dictMap.set(r.dict, /* @__PURE__ */ new Set()), this.dictMap.get(r.dict).add(r);
  }
  addNodeToQueues(r) {
    this.queues[Jc(r.prefix)] || (this.queues[Jc(r.prefix)] = []), this.queues[Jc(r.prefix)].push(r);
  }
  // 按照优先级插入 pattern
  insertPattern(r, a) {
    for (let u = r.length - 1; u >= 0; u--) {
      const h = r[u];
      if (a.priority === h.priority && a.probability >= h.probability)
        r[u + 1] = h;
      else if (a.priority > h.priority)
        r[u + 1] = h;
      else {
        r[u + 1] = a;
        return;
      }
    }
    r[0] = a;
  }
  removeDict(r) {
    this.dictMap.has(r) && (this.dictMap.get(r).forEach((u) => {
      u.node.patterns = u.node.patterns.filter((h) => h !== u);
    }), this.dictMap.delete(r));
  }
  // 搜索字符串返回匹配的模式串
  match(r, a) {
    let u = this.root, h = [];
    const b = yb(r);
    for (let l = 0; l < b.length; l++) {
      let v = b[l];
      for (; u !== null && !u.children.has(v); )
        u = u.fail;
      if (u === null)
        u = this.root;
      else {
        u = u.children.get(v);
        const s = u.patterns.find((d) => a === "off" ? d.priority !== Go.Surname : a === "head" ? d.length - 1 - l === 0 : !0);
        s && h.push(Object.assign(Object.assign({}, s), { index: l - s.length + 1 }));
        let c = u.fail;
        for (; c !== null; ) {
          const d = c.patterns.find((p) => a === "off" ? p.priority !== Go.Surname : a === "head" ? p.length - 1 - l === 0 : !0);
          d && h.push(Object.assign(Object.assign({}, d), { index: l - d.length + 1 })), c = c.fail;
        }
      }
    }
    return h;
  }
  search(r, a, u = 2) {
    const h = this.match(r, a);
    return u === 1 ? ume(h) : u === 3 ? ome(h, Jc(r)) : sme(h, Jc(r));
  }
}
const lme = [
  ...rme,
  ...nme,
  ...tme,
  ...eme,
  ...Wge,
  ...$ge
], cG = new dme();
cG.build(lme);
const fme = new aG(), hme = () => fme, Dy = (t) => {
  const r = Hl.get(t);
  return r ? r.split(" ")[0] : t;
}, pme = (t, r, a, u) => {
  const h = cG.search(t, a, u);
  let b = 0;
  const l = yb(t);
  for (let v = 0; v < l.length; ) {
    const s = h[b];
    if (s && v === s.index) {
      if (s.length === 1 && s.priority <= Go.Normal) {
        const p = l[v];
        let m = "";
        m = uU(p, l[v - 1], l[v + 1]), r[v] = {
          origin: p,
          result: m,
          isZh: m !== p,
          originPinyin: m
        }, v++, b++;
        continue;
      }
      const c = s.pinyin.split(" ");
      let d = 0;
      for (let p = 0; p < s.length; p++) {
        const m = yb(s.zh);
        r[v + p] = {
          origin: m[p],
          result: c[d],
          isZh: !0,
          originPinyin: c[d]
        }, d++;
      }
      v += s.length, b++;
    } else {
      const c = l[v];
      let d = "";
      d = uU(c, l[v - 1], l[v + 1]), r[v] = {
        origin: c,
        result: d,
        isZh: d !== c,
        originPinyin: d
      }, v++;
    }
  }
  return { list: r, matches: h };
}, iA = (t) => t.replace(/(ā|á|ǎ|à)/g, "a").replace(/(ō|ó|ǒ|ò)/g, "o").replace(/(ē|é|ě|è)/g, "e").replace(/(ī|í|ǐ|ì)/g, "i").replace(/(ū|ú|ǔ|ù)/g, "u").replace(/(ǖ|ǘ|ǚ|ǜ)/g, "ü").replace(/(n̄|ń|ň|ǹ)/g, "n").replace(/(m̄|ḿ|m̌|m̀)/g, "m").replace(/(ê̄|ế|ê̌|ề)/g, "ê"), uG = (t, r = "off") => {
  const a = hme();
  let u = Hl.get(t) ? Hl.get(t).split(" ") : [];
  if (a.get(t))
    u = a.get(t).split(" ");
  else if (r !== "off") {
    const h = tN[t];
    h && (u = [h].concat(u.filter((b) => b !== h)));
  }
  return u;
}, gme = (t, r = "off") => {
  let a = uG(t, r);
  return a.length > 0 ? a.map((u) => ({
    origin: t,
    result: u,
    isZh: !0,
    originPinyin: u
  })) : [
    {
      origin: t,
      result: t,
      isZh: !1,
      originPinyin: t
    }
  ];
}, vb = (t) => {
  const r = t.split(" "), a = [], u = [];
  for (let h of r)
    for (let b of zge)
      if (h.startsWith(b)) {
        let l = h.slice(b.length);
        Fge.indexOf(b) !== -1 && Gge.indexOf(l) !== -1 && (l = Vge[l]), a.push(b), u.push(l);
        break;
      }
  return {
    final: u.join(" "),
    initial: a.join(" ")
    // 声母
  };
}, J0 = (t) => {
  const { final: r } = vb(t);
  let a = "", u = "", h = "";
  return Yge.indexOf(iA(r)) !== -1 ? (a = r[0], u = r[1], h = r.slice(2)) : (u = r[0] || "", h = r.slice(1) || ""), { head: a, body: u, tail: h };
}, sA = (t) => {
  const r = /(ā|ō|ē|ī|ū|ǖ|n̄|m̄|ê̄)/, a = /(á|ó|é|í|ú|ǘ|ń|ḿ|ế)/, u = /(ǎ|ǒ|ě|ǐ|ǔ|ǚ|ň|m̌|ê̌)/, h = /(à|ò|è|ì|ù|ǜ|ǹ|m̀|ề)/, b = /(a|o|e|i|u|ü|ê)/, l = /(n|m)$/, v = [];
  return t.split(" ").forEach((c) => {
    r.test(c) ? v.push("1") : a.test(c) ? v.push("2") : u.test(c) ? v.push("3") : h.test(c) ? v.push("4") : b.test(c) || l.test(c) ? v.push("0") : v.push("");
  }), v.join(" ");
}, mme = (t, r) => {
  const a = iA(t).split(" "), u = sA(r).split(" "), h = [];
  return a.forEach((b, l) => {
    h.push(`${b}${u[l]}`);
  }), h.join(" ");
}, dG = (t, r) => {
  const a = [];
  return t.split(" ").forEach((h) => {
    a.push(r ? h[0] : h);
  }), a.join(" ");
}, Eme = (t) => typeof t != "string" ? (console.error("The first param of pinyin is error: " + t + ' is not assignable to type "string".'), !1) : !0;
function kR(t, r) {
  return r instanceof RegExp ? r.test(t) : !0;
}
const yme = (t, r) => {
  let a = r.nonZh;
  if (a === "removed")
    return t.filter((u) => u.isZh || !kR(u.origin, r.nonZhScope));
  if (a === "consecutive") {
    for (let u = t.length - 2; u >= 0; u--) {
      const h = t[u], b = t[u + 1];
      !h.isZh && !b.isZh && kR(h.origin, r.nonZhScope) && kR(b.origin, r.nonZhScope) && (h.origin += b.origin, h.result += b.result, b.delete = !0);
    }
    return t.filter((u) => !u.delete);
  } else
    return t;
}, vU = (t, r) => Jc(t) === 1 && r.multiple ? gme(t, r.surname) : !1, vme = (t, r) => {
  switch (r.pattern) {
    case "pinyin":
      break;
    case "num":
      t.forEach((a) => {
        a.result = a.isZh ? sA(a.result) : "";
      });
      break;
    case "initial":
      t.forEach((a) => {
        a.result = a.isZh ? vb(a.result).initial : "";
      });
      break;
    case "final":
      t.forEach((a) => {
        a.result = a.isZh ? vb(a.result).final : "";
      });
      break;
    case "first":
      t.forEach((a) => {
        a.result = dG(a.result, a.isZh);
      });
      break;
    case "finalHead":
      t.forEach((a) => {
        a.result = a.isZh ? J0(a.result).head : "";
      });
      break;
    case "finalBody":
      t.forEach((a) => {
        a.result = a.isZh ? J0(a.result).body : "";
      });
      break;
    case "finalTail":
      t.forEach((a) => {
        a.result = a.isZh ? J0(a.result).tail : "";
      });
      break;
  }
}, Tme = (t, r) => {
  switch (r.toneType) {
    case "symbol":
      break;
    case "none":
      t.forEach((a) => {
        a.isZh && (a.result = iA(a.result));
      });
      break;
    case "num": {
      t.forEach((a) => {
        a.isZh && (a.result = mme(a.result, a.originPinyin));
      });
      break;
    }
  }
}, bme = (t, r) => {
  r.v && t.forEach((a) => {
    a.isZh && (a.result = a.result.replace(/ü/g, "v"));
  });
}, Ame = (t, r, a) => {
  if (r.multiple && Jc(a) === 1) {
    let u = "";
    t = t.filter((h) => {
      const b = h.result !== u;
      return u = h.result, b;
    });
  }
  return r.type === "array" ? t.map((u) => u.result) : r.type === "all" ? t.map((u) => {
    const h = u.isZh ? u.result : "", { initial: b, final: l } = vb(h), { head: v, body: s, tail: c } = J0(h);
    let d = [];
    return h !== "" && (d = [h].concat(uG(u.origin, r.surname).filter((p) => p !== h))), {
      origin: u.origin,
      pinyin: h,
      initial: b,
      final: l,
      first: dG(u.result, u.isZh),
      finalHead: v,
      finalBody: s,
      finalTail: c,
      num: Number(sA(u.originPinyin)),
      isZh: u.isZh,
      polyphonic: d,
      inZhRange: !!Hl.get(u.origin),
      result: u.result
    };
  }) : t.map((u) => u.result).join(r.separator);
}, Ome = (t, r) => (r === !1 && t.forEach((a) => {
  a.origin === "一" ? a.result = a.originPinyin = "yī" : a.origin === "不" && (a.result = a.originPinyin = "bù");
}), t), Cme = {
  pattern: "pinyin",
  toneType: "symbol",
  type: "string",
  multiple: !1,
  mode: "normal",
  removeNonZh: !1,
  nonZh: "spaced",
  v: !1,
  separator: " ",
  toneSandhi: !0,
  segmentit: 2
};
function nN(t, r) {
  if (r = Object.assign(Object.assign({}, Cme), r || {}), !Eme(t))
    return t;
  if (t === "")
    return r.type === "array" || r.type === "all" ? [] : "";
  r.surname === void 0 && (r.mode === "surname" ? r.surname = "all" : r.surname = "off"), r.type === "all" && (r.pattern = "pinyin"), r.pattern === "num" && (r.toneType = "none"), r.removeNonZh && (r.nonZh = "removed");
  let u = Array(Jc(t)), { list: h } = pme(t, u, r.surname, r.segmentit);
  return h = Ome(h, r.toneSandhi), h = yme(h, r), vU(t, r) && (h = vU(t, r)), vme(h, r), Tme(h, r), bme(h, r), Ame(h, r, t);
}
var rN;
(function(t) {
  t[t.AllSegment = 1] = "AllSegment", t[t.AllArray = 2] = "AllArray", t[t.AllString = 3] = "AllString", t[t.PinyinSegment = 4] = "PinyinSegment", t[t.PinyinArray = 5] = "PinyinArray", t[t.PinyinString = 6] = "PinyinString", t[t.ZhSegment = 7] = "ZhSegment", t[t.ZhArray = 8] = "ZhArray", t[t.ZhString = 9] = "ZhString";
})(rN || (rN = {}));
rN.AllSegment;
class Sme {
  constructor() {
    this.setAppUserInfo = (r) => {
      this.appUsersInfo = r;
    }, this.setGroupMemberAttributesAsync = (r, a, u) => {
      gr().client.setGroupMemberAttributes({
        groupId: r,
        userId: a,
        memberAttributes: u
      }).then((b) => {
        this.setGroupMemberAttributes(r, a, u), mn.dispatchSuccess("setGroupMemberAttributes");
      }).catch((b) => {
        mn.dispatchError("setGroupMemberAttributes", b);
      });
    }, this.setGroupAdmins = (r, a) => {
      const u = Wf(r);
      u > -1 && (this.groups[u].admins = [...a]);
    }, this.getUserInfo = (r, a = !1, u = !1) => {
      var b;
      let h = (b = this.appUsersInfo) == null ? void 0 : b[r];
      return !h || u ? xd({ userIdList: [r], withPresence: a }).then(() => {
        var l;
        return h = (l = this.appUsersInfo) == null ? void 0 : l[r], qi(() => {
          this.appUsersInfo[r] = h;
        }), h;
      }).catch((l) => {
        console.warn("get getUsersInfo failed", l);
      }) : Promise.resolve(h);
    }, this.getUserInfoWithPresence = (r) => {
      xd({ userIdList: r }).catch((a) => {
        console.warn("get getUsersInfo failed", a);
      });
    }, this.setChatroomAdmins = (r, a) => {
      const u = this.chatroom.findIndex((h) => h.id === r);
      u > -1 && (this.chatroom[u].admins = [...a]);
    }, this.addUserToMuteList = (r, a) => {
      const u = this.chatroom.findIndex((h) => h.id === r);
      if (u > -1) {
        const h = this.chatroom[u].muteList || [];
        this.chatroom[u].muteList = [...h, a];
      }
    }, this.setChatroomMuteList = (r, a) => {
      const u = this.chatroom.findIndex((h) => h.id === r);
      u > -1 && (this.chatroom[u].muteList = [...a]);
    }, this.muteChatRoomMember = (r, a, u) => {
      if (!r || !a) throw "chatroomId or userId is empty";
      const h = gr(), b = this.chatroom.findIndex((l) => l.id === r);
      return b > -1 && (this.chatroom[b].muteList || []).includes(a) ? Promise.resolve() : h.client.muteChatRoomMember({
        chatRoomId: r,
        username: a,
        //message.from as string,
        muteDuration: u || 60 * 60 * 24 * 30
      }).then((l) => {
        this.addUserToMuteList(r, a), mn.dispatchSuccess("muteChatRoomMember");
      }).catch((l) => {
        mn.dispatchError("muteChatRoomMember", l);
      });
    }, this.getChatroomMuteList = (r) => {
      if (!r) throw "chatroomId is empty";
      return gr().client.getChatRoomMutelist({ chatRoomId: r }).then((u) => {
        var b;
        const h = ((b = u.data) == null ? void 0 : b.map((l) => l.user)) || [];
        this.setChatroomMuteList(r, h), mn.dispatchSuccess("getChatRoomMutelist");
      }).catch((u) => {
        mn.dispatchError("getChatRoomMutelist", u);
      });
    }, this.unmuteChatRoomMember = (r, a) => {
      if (!r || !a) throw "chatroomId or userId is empty";
      return gr().client.unmuteChatRoomMember({
        chatRoomId: r,
        username: a
        //message.from as string,
      }).then((h) => {
        this.removeUserFromMuteList(r, a), mn.dispatchSuccess("unmuteChatRoomMember");
      }).catch((h) => {
        mn.dispatchError("unmuteChatRoomMember", h);
      });
    }, this.removeUserFromMuteList = (r, a) => {
      const u = this.chatroom.findIndex((h) => h.id === r);
      if (u > -1) {
        const h = this.chatroom[u].muteList || [];
        this.chatroom[u].muteList = h.filter((b) => b !== a);
      }
    }, this.setChatroomMemberIds = (r, a) => {
      const u = this.chatroom.findIndex((h) => h.id === r);
      u > -1 && qi(() => {
        this.chatroom[u].membersId = [
          .../* @__PURE__ */ new Set([...this.chatroom[u].membersId || [], ...a])
        ];
      });
    }, this.removerChatroomMember = (r, a) => {
      gr().client.removeChatRoomMember({
        chatRoomId: r,
        username: a
      }).then(() => {
        var b;
        const h = this.chatroom.findIndex((l) => l.id === r);
        h > -1 && (this.chatroom[h].membersId = (b = this.chatroom[h].membersId) == null ? void 0 : b.filter(
          (l) => l !== a
        )), mn.dispatchSuccess("removeChatRoomMember");
      }).catch((h) => {
        mn.dispatchError("removeChatRoomMember", h);
      });
    }, this.appUsersInfo = {}, this.contacts = [], this.groups = [], this.chatroom = [], this.hasGroupsNext = !0, this.searchList = [], this.thread = {}, this.requests = [], this.blockList = [], ph(this, {
      appUsersInfo: Ar,
      contacts: Ar,
      groups: Ar,
      chatroom: Ar,
      searchList: Ar,
      hasGroupsNext: Ar,
      thread: Ar,
      requests: Ar,
      blockList: Ar,
      setHasGroupsNext: Sn,
      setContacts: Sn,
      deleteContactFromContactList: Sn,
      deleteContact: Sn,
      setGroups: Sn,
      setGroupMembers: Sn,
      setGroupMemberAttributes: Sn,
      setAppUserInfo: Sn,
      setChatroom: Sn,
      updateGroupName: Sn,
      removeGroupMember: Sn,
      setChatroomAdmins: Sn,
      setChatroomMuteList: Sn,
      getChatroomMuteList: Sn,
      removeUserFromMuteList: Sn,
      unmuteChatRoomMember: Sn,
      removerChatroomMember: Sn,
      getSilentModeForConversations: Sn,
      setSilentModeForConversationSync: Sn,
      getGroupInfo: Sn,
      modifyGroup: Sn,
      destroyGroup: Sn,
      leaveGroup: Sn,
      addContactRequest: Sn,
      readContactInvite: Sn,
      createGroup: Sn,
      inviteToGroup: Sn,
      setGroupOwner: Sn,
      addContactToContactList: Sn,
      removeGroupFromContactList: Sn,
      clear: Sn,
      setContactRemark: Sn,
      updateGroupAvatar: Sn,
      getBlockList: Sn,
      addUsersToBlocklist: Sn,
      removeUserFromBlocklist: Sn,
      updateChatroomMemberCount: Sn
    });
  }
  setContacts(r) {
    this.contacts = r;
  }
  setContactRemark(r, a) {
    const u = gr();
    u.client.setContactRemark({
      userId: r,
      remark: a
    }).then(() => {
      qi(() => {
        this.contacts = this.contacts.map((h) => (h.userId === r && (h.remark = a), h)), u.conversationStore.currentCvs.conversationId === r && (u.conversationStore.currentCvs.name = a);
      }), mn.dispatchSuccess("setContactRemark");
    }).catch((h) => {
      mn.dispatchError("setContactRemark", h);
    });
  }
  deleteContact(r) {
    gr().client.deleteContact(r).then(() => {
      this.deleteContactFromContactList(r), mn.dispatchSuccess("deleteContact");
    }).catch((u) => {
      mn.dispatchError("deleteContact", u);
    });
  }
  deleteContactFromContactList(r) {
    this.contacts = this.contacts.filter((a) => a.userId !== r), delete this.appUsersInfo[r];
  }
  async addContactToContactList(r, a = !1) {
    if (this.contacts.find((v) => v.userId === r))
      return;
    let h = this.appUsersInfo[r];
    if (!h)
      try {
        h = await this.getUserInfo(r, a, !0) || { userId: r };
      } catch {
        console.log("addContactToContactList error");
      }
    const b = h.nickname || r;
    let l = "#";
    Zp(b.substring(0, 1)) == "en" ? l = b.substring(0, 1).toUpperCase() : Zp(b.substring(0, 1)) == "zh" ? l = nN(b.substring(0, 1), { toneType: "none" })[0][0].toUpperCase() : l = "#", qi(() => {
      this.contacts.find((s) => s.userId === r) || (this.contacts.push({
        userId: r,
        nickname: h.nickname,
        // @ts-ignore
        name: h.nickname,
        remark: "",
        avatar: h.avatarurl,
        initial: l
      }), this.contacts = [...this.contacts]);
    });
  }
  setGroups(r) {
    const a = this.groups.map((h) => h.groupid), u = r.filter(
      ({ groupid: h }) => !a.find((b) => b === h)
    );
    this.groups = [...this.groups, ...u];
  }
  updateGroupAvatar(r, a) {
    const u = Wf(r);
    u > -1 && (this.groups[u].avatarUrl = a, this.groups = [...this.groups]);
    const h = gr(), b = h.conversationStore.conversationList.find(
      (l) => l.conversationId === r
    );
    b && (b.avatarUrl = a, h.conversationStore.modifyConversation(b));
  }
  updateGroupName(r, a) {
    const u = Wf(r);
    u > -1 && (this.groups[u].groupname = a, this.groups = [...this.groups]);
  }
  setHasGroupsNext(r) {
    this.hasGroupsNext = r;
  }
  setGroupMembers(r, a) {
    var h, b;
    const u = Wf(r);
    if (u > -1) {
      const l = (b = (h = this.groups[u]) == null ? void 0 : h.members) == null ? void 0 : b.map((s) => s.userId), v = a.filter(
        //@ts-ignore
        (s) => !(l != null && l.find((c) => c === (s.owner || s.member)))
      ).map((s) => {
        var c;
        return {
          //@ts-ignore
          userId: s.owner || s.member,
          //@ts-ignore
          role: (c = this.groups[u].admins) != null && c.includes(s.owner || s.member) ? "admin" : (
            //@ts-ignore
            s != null && s.owner ? "owner" : "member"
          )
        };
      });
      qi(() => {
        this.groups[u].members = [...this.groups[u].members || [], ...v];
      });
    }
  }
  removeGroupMember(r, a) {
    var h;
    const u = Wf(r);
    u > -1 && this.groups[u].members && (this.groups[u].members = (h = this.groups[u].members) == null ? void 0 : h.filter((b) => b.userId !== a));
  }
  setGroupItemHasMembersNext(r, a) {
    const u = Wf(r);
    u > -1 && (this.groups[u].hasMembersNext = a);
  }
  setGroupMemberAttributes(r, a, u) {
    const h = Wf(r), b = aA(this.groups[h], a) ?? -1;
    if (b > -1) {
      const l = this.groups[h].members || [];
      l[b].attributes = u;
    }
  }
  setChatroom(r) {
    this.chatroom = r;
  }
  updateChatroomMemberCount(r, a) {
    const u = this.chatroom.findIndex((h) => h.id === r);
    u > -1 && (this.chatroom[u].affiliations_count = a);
  }
  setSearchList(r) {
    this.searchList = r;
  }
  getSilentModeForConversations(r) {
    if (!r || r.length == 0)
      return;
    const a = r.map((h) => ({
      id: h.conversationId,
      type: h.chatType
    }));
    gr().client.getSilentModeForConversations({
      conversationList: a
    }).then((h) => {
      const b = h.data.user, l = h.data.group;
      qi(() => {
        this.contacts.forEach((v) => {
          var s;
          b[v.userId] && ((s = b[v.userId]) == null ? void 0 : s.type) == "NONE" ? v.silent = !0 : b[v.userId] && (v.silent = !1);
        }), this.groups.forEach((v) => {
          var s;
          l[v.groupid] && ((s = l[v.groupid]) == null ? void 0 : s.type) == "AT" ? v.silent = !0 : l[v.groupid] && (v.silent = !1);
        });
      }), mn.dispatchSuccess("getSilentModeForConversations");
    }).catch((h) => {
      mn.dispatchError("getSilentModeForConversations", h);
    });
  }
  setSilentModeForConversationSync(r, a) {
    r.chatType === "singleChat" ? this.contacts.forEach((u) => {
      u.userId === r.conversationId && (u.silent = a);
    }) : r.chatType === "groupChat" && this.groups.forEach((u) => {
      u.groupid === r.conversationId && (u.silent = a);
    });
  }
  setSilentModeForConversation(r, a) {
    const u = gr();
    a ? u.client.setSilentModeForConversation({
      conversationId: r.conversationId,
      type: r.chatType,
      options: {
        paramType: 0,
        remindType: r.chatType == "groupChat" ? "AT" : "NONE"
      }
    }).then((h) => {
      u.conversationStore.setSilentModeForConversationSync(r, !0), this.setSilentModeForConversationSync(r, !0), mn.dispatchSuccess("setSilentModeForConversation");
    }).catch((h) => {
      mn.dispatchError("setSilentModeForConversation", h);
    }) : u.client.clearRemindTypeForConversation({
      conversationId: r.conversationId,
      type: r.chatType
    }).then((h) => {
      u.conversationStore.setSilentModeForConversationSync(r, !1), this.setSilentModeForConversationSync(r, !1), mn.dispatchSuccess("clearRemindTypeForConversation");
    }).catch((h) => {
      mn.dispatchError("clearRemindTypeForConversation", h);
    });
  }
  getGroupInfo(r) {
    gr().client.getGroupInfo({
      groupId: r
    }).then((u) => {
      qi(() => {
        var b, l, v;
        const h = this.groups.filter((s) => s.groupid === r);
        h.length === 0 ? this.groups.push({
          info: (b = u.data) == null ? void 0 : b[0],
          groupid: r,
          groupname: ((l = u.data) == null ? void 0 : l[0].name) || ""
        }) : h[0].info = (v = u.data) == null ? void 0 : v[0];
      }), mn.dispatchSuccess("getGroupInfo");
    }).catch((u) => {
      mn.dispatchError("getGroupInfo", u);
    });
  }
  modifyGroup(r, a, u) {
    const h = gr();
    h.client.modifyGroup({
      groupId: r,
      groupName: a,
      description: u
    }).then(() => {
      this.groups.forEach((l) => {
        l.groupid === r && qi(() => {
          l.groupname = a, l.info && (l.info.description = u, l.info.name = a), h.conversationStore.currentCvs.conversationId === r && (h.conversationStore.currentCvs.name = a), h.messageStore.currentCVS.conversationId === r && (h.messageStore.currentCVS.name = a);
        });
      });
      const b = h.conversationStore.conversationList.find((l) => l.conversationId === r);
      b && (b.name = a), b && h.conversationStore.modifyConversation(b), mn.dispatchSuccess("modifyGroup");
    }).catch((b) => {
      mn.dispatchError("modifyGroup", b);
    });
  }
  destroyGroup(r) {
    const a = gr();
    a.client.destroyGroup({
      groupId: r
    }).then(() => {
      qi(() => {
        this.groups = this.groups.filter((u) => u.groupid !== r);
      }), a.conversationStore.deleteConversation({
        chatType: "groupChat",
        conversationId: r
      }), mn.dispatchSuccess("destroyGroup");
    }).catch((u) => {
      mn.dispatchError("destroyGroup", u);
    });
  }
  leaveGroup(r) {
    const a = gr();
    a.client.leaveGroup({
      groupId: r
    }).then(() => {
      qi(() => {
        this.groups = this.groups.filter((u) => u.groupid !== r), a.messageStore.message.groupChat[r] = [];
      }), a.conversationStore.deleteConversation({
        chatType: "groupChat",
        conversationId: r
      }), mn.dispatchSuccess("leaveGroup");
    }).catch((u) => {
      mn.dispatchError("leaveGroup", u);
    });
  }
  addContact(r) {
    gr().client.addContact(r, "").then(() => {
      mn.dispatchSuccess("addContact");
    }).catch((u) => {
      mn.dispatchError("addContact", u);
    });
  }
  addContactRequest(r) {
    const a = this.requests.findIndex(
      (u) => u.from === r.from && u.to === r.to
    );
    a >= 0 ? this.requests[a] = r : this.requests.push(r), this.requests = [...this.requests];
  }
  acceptContactInvite(r) {
    gr().client.acceptContactInvite(r), this.requests.forEach((u) => {
      u.from === r && (u.requestStatus = "accepted");
    }), this.requests = [...this.requests];
  }
  readContactInvite(r) {
    this.requests.forEach((a) => {
      a.from === r && a.requestStatus === "pending" && (a.requestStatus = "read");
    }), this.requests = [...this.requests];
  }
  // TODO: 增加群名称，群头像等参数，传头像的话，创建会话时增加avatarUrl字段
  createGroup(r) {
    var b, l;
    const a = gr(), u = r.slice(0, 2).map((v) => {
      var s, c;
      return ((c = (s = a.addressStore.appUsersInfo) == null ? void 0 : s[v]) == null ? void 0 : c.nickname) || v;
    });
    u.unshift(
      ((l = (b = a.addressStore.appUsersInfo) == null ? void 0 : b[a.client.user]) == null ? void 0 : l.nickname) || a.client.user
    );
    const h = u.join("、");
    a.client.createGroup({
      data: {
        groupname: h,
        members: r,
        desc: h,
        public: !1,
        approval: !1,
        allowinvites: !0,
        inviteNeedConfirm: !1,
        maxusers: 1e3
      }
    }).then((v) => {
      var s, c;
      qi(() => {
        var m;
        const d = r.map((E) => ({
          userId: E,
          role: "member"
        }));
        d.push({
          userId: a.client.user,
          role: "owner"
        });
        let p = "#";
        Zp(h.substring(0, 1)) == "en" ? p = h.substring(0, 1).toUpperCase() : Zp(h.substring(0, 1)) == "zh" && (p = nN(h.substring(0, 1), { toneType: "none" })[0][0].toUpperCase()), this.groups.push({
          disabled: !1,
          groupid: ((m = v.data) == null ? void 0 : m.groupid) || "",
          initial: p,
          name: h,
          groupname: h,
          members: d
        });
      }), a.conversationStore.addConversation({
        chatType: "groupChat",
        conversationId: ((s = v.data) == null ? void 0 : s.groupid) || "",
        name: h,
        lastMessage: {},
        unreadCount: 0
        // avatarUrl: group?.avatarUrl,
      }), a.conversationStore.setCurrentCvs({
        chatType: "groupChat",
        conversationId: ((c = v.data) == null ? void 0 : c.groupid) || "",
        name: h
      }), mn.dispatchSuccess("createGroup");
    }).catch((v) => {
      mn.dispatchError("createGroup", v);
    });
  }
  inviteToGroup(r, a) {
    gr().client.inviteUsersToGroup({
      groupId: r,
      users: a
    }).then((h) => {
      this.groups.forEach((b) => {
        if (b.groupid === r) {
          const l = a.map((v) => ({
            userId: v,
            role: "member"
          }));
          b.members = [...b.members || [], ...l];
        }
      }), mn.dispatchSuccess("inviteToGroup");
    }).catch((h) => {
      mn.dispatchError("inviteToGroup", h);
    });
  }
  removeGroupMembers(r, a) {
    gr().client.removeGroupMembers({
      groupId: r,
      users: a
    }).then((h) => {
      a.forEach((b) => {
        this.removeGroupMember(r, b);
      }), mn.dispatchSuccess("removeGroupMembers");
    }).catch((h) => {
      mn.dispatchError("removeGroupMembers", h);
    });
  }
  setGroupOwner(r, a) {
    this.groups.forEach((u) => {
      var h;
      u.groupid === r && ((h = u.members) == null || h.forEach((b) => {
        b.userId === a ? b.role = "owner" : b.role === "owner" && (b.role = "member");
      }), u.info && (u.info.owner = a));
    }), this.groups = [...this.groups];
  }
  changeGroupOwner(r, a) {
    gr().client.changeGroupOwner({
      groupId: r,
      newOwner: a
    }).then((h) => {
      this.setGroupOwner(r, a), mn.dispatchSuccess("changeGroupOwner");
    }).catch((h) => {
      mn.dispatchError("changeGroupOwner", h);
    });
  }
  removeGroupFromContactList(r) {
    this.groups = this.groups.filter((a) => a.groupid !== r);
  }
  getBlockList() {
    gr().client.getBlocklist().then((a) => {
      qi(() => {
        a.data && (this.blockList = a.data);
      }), mn.dispatchSuccess("getBlockList");
    }).catch((a) => {
      mn.dispatchError("getBlockList", a);
    });
  }
  addUsersToBlocklist(r) {
    gr().client.addUsersToBlocklist({
      name: r
    }).then((u) => {
      qi(() => {
        this.blockList = [...this.blockList, ...r];
      }), mn.dispatchSuccess("addUsersToBlocklist");
    }).catch((u) => {
      mn.dispatchError("addUsersToBlocklist", u);
    });
  }
  removeUserFromBlocklist(r) {
    gr().client.removeUserFromBlocklist({
      name: r
    }).then((u) => {
      qi(() => {
        this.blockList = this.blockList.filter((h) => !r.includes(h));
      }), mn.dispatchSuccess("removeUserFromBlocklist");
    }).catch((u) => {
      mn.dispatchError("removeUserFromBlocklist", u);
    });
  }
  publishPresence(r) {
    const a = gr();
    a.client.publishPresence({
      description: r
    }).then((u) => {
      qi(() => {
        this.appUsersInfo[a.client.user] = {
          ...this.appUsersInfo[a.client.user],
          presenceExt: r
        };
      }), mn.dispatchSuccess("publishPresence");
    }).catch((u) => {
      mn.dispatchError("publishPresence", u);
    });
  }
  clear() {
    this.appUsersInfo = {}, this.contacts = [], this.groups = [], this.chatroom = [], this.hasGroupsNext = !0, this.searchList = [], this.thread = {}, this.blockList = [];
  }
}
class Ime {
  constructor(r) {
    this.rootStore = r, this.thread = {}, this.currentThread = {}, this.showThreadPanel = !1, this.threadList = {}, ph(this, {
      thread: Ar,
      currentThread: Ar,
      showThreadPanel: Ar,
      threadList: Ar,
      setThread: Sn,
      setCurrentThread: Sn,
      setThreadVisible: Sn,
      updateThreadInfo: Sn,
      updateMultiDeviceEvent: Sn,
      getChatThreadDetail: Sn,
      getGroupChatThreads: Sn,
      clear: Sn
    });
  }
  setThread(r) {
    this.thread = { ...this.thread, ...r };
  }
  setCurrentThread(r) {
    if (!r)
      throw new Error("no thread");
    this.currentThread = r;
  }
  setThreadVisible(r) {
    if (typeof r != "boolean")
      throw new Error("visible must be boolean");
    this.showThreadPanel = r;
  }
  updateThreadInfo(r) {
    var E, y, g, C, O, N, w;
    let a;
    const { operation: u, messageId: h, parentId: b, id: l, operator: v } = r, s = this.currentThread.info, c = this.currentThread.originalMessage, d = (c == null ? void 0 : c.mid) || (c == null ? void 0 : c.id);
    let p = {};
    switch (u != "create" && ((E = this.threadList[b]) == null || E.forEach((_) => {
      _.id === l && (p = _);
    })), u) {
      case "create":
        a = r, (h === (s == null ? void 0 : s.messageId) || d === h) && this.rootStore.client.context.userId !== v && this.setCurrentThread({
          visible: !1,
          creating: !1,
          info: void 0,
          originalMessage: {}
        });
        break;
      case "update":
        if ((h === (s == null ? void 0 : s.messageId) || d === h) && this.setCurrentThread({
          ...this.currentThread,
          // owner: threadInfo.operator,
          creating: !1,
          info: { ...r, owner: r.operator }
        }), a = r, a.lastMessage = r.lastMessage ? r.lastMessage : (
          //@ts-ignore
          (g = (y = this.currentThread.originalMessage) == null ? void 0 : y.chatThreadOverview) == null ? void 0 : g.lastMessage
        ), !p) return;
        (O = this.threadList[b]) == null || O.splice(
          (C = this.threadList[b]) == null ? void 0 : C.indexOf(p),
          1,
          {
            ...p,
            ...r,
            name: r.name
          }
        );
        break;
      case "destroy":
      case "userRemove":
        a = void 0, l === (s == null ? void 0 : s.id) && (this.setCurrentThread({
          visible: !1,
          creating: !1,
          info: void 0,
          originalMessage: {}
        }), this.setThreadVisible(!1), (w = this.threadList[b]) == null || w.splice(
          (N = this.threadList[b]) == null ? void 0 : N.indexOf(p),
          1
        ));
        break;
    }
    (this.rootStore.messageStore.message.groupChat[b] || []).forEach((_) => {
      (_.mid === h || _.id === h) && (_.chatThreadOverview = a);
    });
  }
  //thread member received changed
  updateMultiDeviceEvent(r) {
    const a = this.currentThread.info;
    r.operation === "chatThreadLeave" && (a == null ? void 0 : a.id) === r.chatThreadId && (this.setCurrentThread({
      ...this.currentThread,
      visible: !1
    }), this.setThreadVisible(!1));
  }
  getChatThreadDetail(r) {
    if (!r)
      throw new Error("no threadId");
    return this.currentThread.info, this.rootStore.client.getChatThreadDetail({ chatThreadId: r }).then((a) => {
      const h = (this.rootStore.messageStore.message.groupChat[a.data.parentId] || []).find(
        (b) => b.mid === a.data.messageId || b.id === a.data.messageId
      );
      this.setCurrentThread({
        ...this.currentThread,
        originalMessage: h || {},
        info: {
          // ...currentThreadInfo,
          // // @ts-ignore
          // owner: res.data.owner,
          ...a.data
        }
      });
    });
  }
  getThreadMembers(r, a, u) {
    if (!r || !a)
      throw new Error("no parentId or threadId");
    return this.rootStore.client.getChatThreadMembers({
      chatThreadId: a,
      pageSize: 50,
      cursor: u
    }).then((h) => {
      const b = h.data.affiliations;
      return qi(() => {
        var l, v;
        this.threadList[r] || (this.threadList[r] = [
          {
            id: a,
            parentId: r,
            members: b,
            name: "",
            owner: "",
            created: 0,
            messageId: ""
          }
        ]), (l = this.threadList[r]) == null || l.forEach((s) => {
          s.id === a && (s.members = b);
        }), ((v = this.currentThread.info) == null ? void 0 : v.id) === a && (this.currentThread.info.members = b);
      }), b;
    });
  }
  removeChatThreadMember(r, a, u) {
    if (!r || !a || !u)
      throw new Error("no parentId or threadId or userId");
    return this.rootStore.client.removeChatThreadMember({
      chatThreadId: a,
      username: u
    }).then((h) => {
      this.getThreadMembers(r, a);
    });
  }
  joinChatThread(r) {
    if (!r)
      throw new Error("no chatThreadId");
    return this.rootStore.client.joinChatThread({ chatThreadId: r }).then((a) => {
      mn.dispatchSuccess("joinChatThread");
    }).catch((a) => {
      mn.dispatchError("joinChatThread", a);
    });
  }
  getGroupChatThreads(r, a) {
    if (!r)
      throw new Error("no parentId");
    return this.rootStore.client.getChatThreads({
      parentId: r,
      pageSize: 20,
      cursor: a
    }).then((u) => {
      const h = u.entities || [];
      let b = this.threadList[r] || [];
      a || (b = []);
      const l = h == null ? void 0 : h.map((v) => v.id);
      return mn.dispatchSuccess("getChatThreads"), this.rootStore.client.getChatThreadLastMessage({
        chatThreadIds: l
      }).then((v) => {
        var s;
        return (s = v.entities) == null || s.forEach((c) => {
          const d = h == null ? void 0 : h.findIndex((p) => c.chatThreadId === p.id);
          c.lastMessage.chatType = "groupChat", h[d].lastMessage = c.lastMessage;
        }), qi(() => {
          this.threadList[r] = [...b, ...h];
        }), h.length < 20 ? null : (mn.dispatchSuccess("getChatThreadLastMessage"), u.properties.cursor);
      }).catch((v) => {
        mn.dispatchError("getChatThreadLastMessage", v);
      });
    }).catch((u) => {
      mn.dispatchError("getChatThreads", u);
    });
  }
  clear() {
    this.thread = {}, this.currentThread = {}, this.showThreadPanel = !1, this.threadList = {};
  }
}
class Rme {
  constructor() {
    this.messages = {
      groupChat: {},
      chatRoom: {},
      singleChat: {}
    }, this.visible = !1, ph(this, {
      messages: Ar,
      visible: Ar,
      unshiftPinnedMessage: Sn,
      deletePinnedMessage: Sn,
      pushPinnedMessage: Sn,
      clearPinnedMessages: Sn,
      changeVisible: Sn,
      pushPinNoticeMessage: Sn,
      modifyPinnedMessage: Sn,
      clear: Sn
    });
  }
  unshiftPinnedMessage(r, a, u) {
    const h = this.messages[r][a] || {
      list: [],
      cursor: ""
    };
    h.list.unshift(u), this.messages[r][a] = {
      list: [...h.list],
      cursor: h.cursor
    };
  }
  pushPinnedMessage(r, a, u) {
    const h = this.messages[r][a] || {
      list: [],
      cursor: ""
    };
    h.list.push(u), this.messages[r][a] = {
      list: [...h.list],
      cursor: h.cursor
    };
  }
  clearPinnedMessages(r, a) {
    this.messages[r][a] = {
      list: [],
      cursor: ""
    };
  }
  deletePinnedMessage(r, a, u) {
    const h = this.messages[r][a] || {
      list: [],
      cursor: ""
    };
    if (r === "chatRoom") {
      this.messages[r][a] = {
        list: [],
        cursor: ""
      };
      return;
    }
    const b = h.list.findIndex(
      // @ts-ignore
      (l) => l.message.id === u || l.message.mid === u
    );
    b > -1 && (h.list.splice(b, 1), this.messages[r][a] = {
      list: [...h.list],
      cursor: h.cursor
    });
  }
  setPinnedMessageCursor(r, a, u) {
    const h = this.messages[r][a] || {
      list: [],
      cursor: ""
    };
    this.messages[r][a] = {
      list: [...h.list],
      cursor: u
    };
  }
  updatePinnedMessage(r, a, u, h, b) {
    var d, p;
    const { messageStore: l, client: v } = gr(), s = (d = l.message[r][a]) == null ? void 0 : d.find((m) => (m.mid || m.id) === u), c = ((p = this.messages[r][a]) == null ? void 0 : p.list) || [];
    s && c.length > 0 ? (this.deletePinnedMessage(r, a, u), this.unshiftPinnedMessage(r, a, {
      //@ts-ignore
      message: { ...s, id: s.mid || s.id },
      operatorId: b || v.user,
      pinTime: h
    })) : this.clearPinnedMessages(r, a);
  }
  modifyPinnedMessage(r, a, u) {
    const h = this.messages[r][a] || {
      list: [],
      cursor: ""
    }, b = h.list.findIndex((v) => v.message.id === u.id), l = h.list;
    b > -1 && l.length > 0 && (l[b].message = {
      ...l[b].message,
      ...u
    });
  }
  changeVisible(r) {
    this.visible = r;
  }
  pushPinNoticeMessage(r) {
    const { messageStore: a } = gr(), { conversationType: u, conversationId: h, noticeType: b, operatorId: l, time: v } = r, s = new $2({
      time: v,
      noticeType: b,
      ext: {
        operatorId: l,
        conversationId: h,
        conversationType: u
      }
    });
    a.message[u][h] = [
      ...a.message[u][h] || [],
      s
    ];
  }
  clear() {
    this.messages = {
      groupChat: {},
      chatRoom: {},
      singleChat: {}
    }, this.visible = !1;
  }
}
const TU = 20;
let iN = 1;
const Nme = () => {
  const t = Zn(Vn).rootStore, { client: r, conversationStore: a } = t, { hasConversationNext: u } = a;
  return { getConversationList: () => r.getConversationlist({
    pageSize: TU,
    pageNum: iN
  }).then((b) => {
    var v, s, c, d, p;
    (((s = (v = b.data) == null ? void 0 : v.channel_infos) == null ? void 0 : s.length) || 0) < TU ? a.setHasConversationNext(!1) : (a.setHasConversationNext(!0), iN++);
    const l = (p = (d = (c = b.data) == null ? void 0 : c.channel_infos) == null ? void 0 : d.filter((m) => {
      const { lastMessage: E } = m;
      return !E.chatThread;
    })) == null ? void 0 : p.map((m) => {
      const { chatType: E, conversationId: y } = Dme(m.channel_id);
      return {
        chatType: E,
        conversationId: y,
        unreadCount: m.unread_num,
        lastMessage: m.lastMessage
      };
    });
    a.getSilentModeForConversations(l || []), a.setConversation(l);
  }).catch((b) => {
    console.warn("get conversation list failed", b);
  }), hasConversationNext: u };
}, wme = () => {
  iN = 1;
}, bU = 20;
let sN = 1;
const _me = (t) => {
  const r = Zn(Vn).rootStore, { client: a } = r;
  let u = !0;
  return { getChatroomMembers: () => {
    a.listChatRoomMembers({
      chatRoomId: t,
      pageSize: bU,
      pageNum: sN
    }).then((b) => {
      var c, d;
      (((c = b.data) == null ? void 0 : c.length) || 0) < bU ? u = !1 : (u = !0, sN++);
      const l = ((d = b.data) == null ? void 0 : d.map((p) => p.member || p.owner)) || [], v = r.addressStore.appUsersInfo, s = l.filter((p) => !(p in v));
      r.addressStore.setChatroomMemberIds(t, l), r.addressStore.updateChatroomMemberCount(t, b.count), s.length > 0 && xd({ userIdList: s, withPresence: !1 }).catch((p) => {
        console.warn("get getUsersInfo failed", p);
      });
    }).catch((b) => {
      console.warn("get member list failed", b);
    });
  }, next: u };
}, Pme = () => {
  sN = 1;
};
class xme {
  constructor() {
    this.loginState = !1, this.initConfig = { appKey: "" }, this.client = {}, this.messageStore = new kge(this), this.conversationStore = new jge(this), this.addressStore = new Sme(), this.threadStore = new Ime(this), this.pinnedMessagesStore = new Rme(), ph(this, {
      client: Ar,
      loginState: Ar,
      setLoginState: Sn,
      setClient: Sn,
      initConfig: Ar,
      setInitConfig: Sn,
      clear: Sn
    });
  }
  setClient(r) {
    this.client = r;
  }
  setLoginState(r) {
    this.loginState = r;
  }
  setInitConfig(r) {
    this.initConfig = r;
  }
  clear() {
    this.messageStore.clear(), this.addressStore.clear(), this.conversationStore.clear(), this.threadStore.clear(), this.pinnedMessagesStore.clear(), wme(), Pme();
  }
}
let jR;
function gr() {
  return jR || (jR = new xme()), jR;
}
const Zt = gr(), vm = {
  path: "/module/assets/reactions/",
  map: {
    // 'U+1F600': 'U+1F600.png',
    // 'U+1F604': 'U+1F604.png',
    // 'U+1F609': 'U+1F609.png',
    // 'U+1F62E': 'U+1F62E.png',
    // 'U+1F92A': 'U+1F92A.png',
    // 'U+1F60E': 'U+1F60E.png',
    // 'U+1F971': 'U+1F971.png',
    // 'U+1F974': 'U+1F974.png',
    // 'U+263A': 'U+263A.png',
    // 'U+1F641': 'U+1F641.png',
    // 'U+1F62D': 'U+1F62D.png',
    // 'U+1F610': 'U+1F610.png',
    // 'U+1F607': 'U+1F607.png',
    // 'U+1F62C': 'U+1F62C.png',
    // 'U+1F913': 'U+1F913.png',
    // 'U+1F633': 'U+1F633.png',
    // 'U+1F973': 'U+1F973.png',
    // 'U+1F620': 'U+1F620.png',
    // 'U+1F644': 'U+1F644.png',
    // 'U+1F910': 'U+1F910.png',
    // 'U+1F97A': 'U+1F97A.png',
    // 'U+1F928': 'U+1F928.png',
    // 'U+1F62B': 'U+1F62B.png',
    // 'U+1F637': 'U+1F637.png',
    // 'U+1F912': 'U+1F912.png',
    // 'U+1F631': 'U+1F631.png',
    // 'U+1F618': 'U+1F618.png',
    // 'U+1F60D': 'U+1F60D.png',
    // 'U+1F922': 'U+1F922.png',
    // 'U+1F47F': 'U+1F47F.png',
    // 'U+1F92C': 'U+1F92C.png',
    // 'U+1F621': 'U+1F621.png',
    // 'U+1F44D': 'U+1F44D.png',
    // 'U+1F44E': 'U+1F44E.png',
    // 'U+1F44F': 'U+1F44F.png',
    // 'U+1F64C': 'U+1F64C.png',
    // 'U+1F91D': 'U+1F91D.png',
    // 'U+1F64F': 'U+1F64F.png',
    // 'U+2764': 'U+2764.png',
    // 'U+1F494': 'U+1F494.png',
    // 'U+1F495': 'U+1F495.png',
    // 'U+1F4A9': 'U+1F4A9.png',
    // 'U+1F48B': 'U+1F48B.png',
    // 'U+2600': 'U+2600.png',
    // 'U+1F31C': 'U+1F31C.png',
    // 'U+1F308': 'U+1F308.png',
    // 'U+2B50': 'U+2B50.png',
    // 'U+1F31F': 'U+1F31F.png',
    // 'U+1F389': 'U+1F389.png',
    // 'U+1F490': 'U+1F490.png',
    // 'U+1F382': 'U+1F382.png',
    // 'U+1F381': 'U+1F381.png',
    "😀": "U+1F600.png",
    "😄": "U+1F604.png",
    "😉": "U+1F609.png",
    "😮": "U+1F62E.png",
    "🤪": "U+1F92A.png",
    "😎": "U+1F60E.png",
    "🥱": "U+1F971.png",
    "🥴": "U+1F974.png",
    // '☺': 'U+263A.png',
    "☺️": "U+263A.png",
    "🙁": "U+1F641.png",
    "😭": "U+1F62D.png",
    "😐": "U+1F610.png",
    "😇": "U+1F607.png",
    "😬": "U+1F62C.png",
    "🤓": "U+1F913.png",
    "😳": "U+1F633.png",
    "🥳": "U+1F973.png",
    "😠": "U+1F620.png",
    "🙄": "U+1F644.png",
    "🤐": "U+1F910.png",
    "🥺": "U+1F97A.png",
    "🤨": "U+1F928.png",
    "😫": "U+1F62B.png",
    "😷": "U+1F637.png",
    "🤒": "U+1F912.png",
    "😱": "U+1F631.png",
    "😘": "U+1F618.png",
    "😍": "U+1F60D.png",
    "🤢": "U+1F922.png",
    "👿": "U+1F47F.png",
    "🤬": "U+1F92C.png",
    "😡": "U+1F621.png",
    "👍": "U+1F44D.png",
    "👎": "U+1F44E.png",
    "👏": "U+1F44F.png",
    "🙌": "U+1F64C.png",
    "🤝": "U+1F91D.png",
    "🙏": "U+1F64F.png",
    "❤️": "U+2764.png",
    "💔": "U+1F494.png",
    "💕": "U+1F495.png",
    "💩": "U+1F4A9.png",
    "💋": "U+1F48B.png",
    "☀️": "U+2600.png",
    "🌜": "U+1F31C.png",
    "🌈": "U+1F308.png",
    "⭐": "U+2B50.png",
    "🌟": "U+1F31F.png",
    "🎉": "U+1F389.png",
    "💐": "U+1F490.png",
    "🎂": "U+1F382.png",
    "🎁": "U+1F381.png"
  },
  oldMap: {
    "U+1F600": "U+1F600.png",
    "U+1F604": "U+1F604.png",
    "U+1F609": "U+1F609.png",
    "U+1F62E": "U+1F62E.png",
    "U+1F92A": "U+1F92A.png",
    "U+1F60E": "U+1F60E.png",
    "U+1F971": "U+1F971.png",
    "U+1F974": "U+1F974.png",
    "U+263A": "U+263A.png",
    "U+1F641": "U+1F641.png",
    "U+1F62D": "U+1F62D.png",
    "U+1F610": "U+1F610.png",
    "U+1F607": "U+1F607.png",
    "U+1F62C": "U+1F62C.png",
    "U+1F913": "U+1F913.png",
    "U+1F633": "U+1F633.png",
    "U+1F973": "U+1F973.png",
    "U+1F620": "U+1F620.png",
    "U+1F644": "U+1F644.png",
    "U+1F910": "U+1F910.png",
    "U+1F97A": "U+1F97A.png",
    "U+1F928": "U+1F928.png",
    "U+1F62B": "U+1F62B.png",
    "U+1F637": "U+1F637.png",
    "U+1F912": "U+1F912.png",
    "U+1F631": "U+1F631.png",
    "U+1F618": "U+1F618.png",
    "U+1F60D": "U+1F60D.png",
    "U+1F922": "U+1F922.png",
    "U+1F47F": "U+1F47F.png",
    "U+1F92C": "U+1F92C.png",
    "U+1F621": "U+1F621.png",
    "U+1F44D": "U+1F44D.png",
    "U+1F44E": "U+1F44E.png",
    "U+1F44F": "U+1F44F.png",
    "U+1F64C": "U+1F64C.png",
    "U+1F91D": "U+1F91D.png",
    "U+1F64F": "U+1F64F.png",
    "U+2764": "U+2764.png",
    "U+1F494": "U+1F494.png",
    "U+1F495": "U+1F495.png",
    "U+1F4A9": "U+1F4A9.png",
    "U+1F48B": "U+1F48B.png",
    "U+2600": "U+2600.png",
    "U+1F31C": "U+1F31C.png",
    "U+1F308": "U+1F308.png",
    "U+2B50": "U+2B50.png",
    "U+1F31F": "U+1F31F.png",
    "U+1F389": "U+1F389.png",
    "U+1F490": "U+1F490.png",
    "U+1F382": "U+1F382.png",
    "U+1F381": "U+1F381.png",
    "😀": "U+1F600.png",
    "😄": "U+1F604.png",
    "😉": "U+1F609.png",
    "😮": "U+1F62E.png",
    "🤪": "U+1F92A.png",
    "😎": "U+1F60E.png",
    "🥱": "U+1F971.png",
    "🥴": "U+1F974.png",
    "☺": "U+263A.png",
    "🙁": "U+1F641.png",
    "😭": "U+1F62D.png",
    "😐": "U+1F610.png",
    "😇": "U+1F607.png",
    "😬": "U+1F62C.png",
    "🤓": "U+1F913.png",
    "😳": "U+1F633.png",
    "🥳": "U+1F973.png",
    "😠": "U+1F620.png",
    "🙄": "U+1F644.png",
    "🤐": "U+1F910.png",
    "🥺": "U+1F97A.png",
    "🤨": "U+1F928.png",
    "😫": "U+1F62B.png",
    "😷": "U+1F637.png",
    "🤒": "U+1F912.png",
    "😱": "U+1F631.png",
    "😘": "U+1F618.png",
    "😍": "U+1F60D.png",
    "🤢": "U+1F922.png",
    "👿": "U+1F47F.png",
    "🤬": "U+1F92C.png",
    "😡": "U+1F621.png",
    "👍": "U+1F44D.png",
    "👎": "U+1F44E.png",
    "👏": "U+1F44F.png",
    "🙌": "U+1F64C.png",
    "🤝": "U+1F91D.png",
    "🙏": "U+1F64F.png",
    "❤️": "U+2764.png",
    "💔": "U+1F494.png",
    "💕": "U+1F495.png",
    "💩": "U+1F4A9.png",
    "💋": "U+1F48B.png",
    "☀️": "U+2600.png",
    "🌜": "U+1F31C.png",
    "🌈": "U+1F308.png",
    "⭐": "U+2B50.png",
    "🌟": "U+1F31F.png",
    "🎉": "U+1F389.png",
    "💐": "U+1F490.png",
    "🎂": "U+1F382.png",
    "🎁": "U+1F381.png"
  }
};
function Tm(t) {
  if (!t) return "";
  const r = (/* @__PURE__ */ new Date()).toString().split(" "), a = new Date(t).toString().split(" ");
  if (r[3] === a[3])
    if (r[1] === a[1])
      if (r[0] === a[0]) {
        if (r[2] === a[2])
          return a[4].substr(0, 5);
      } else
        return Number(r[0]) - Number(a[0]) === 1 ? "Yday" : a[0];
    else
      return a[1];
  else
    return a[1];
}
function Dme(t) {
  var h;
  const r = /_(\S*)@/, a = t.includes("@conference") ? "groupChat" : "singleChat", u = ((h = t.match(r)) == null ? void 0 : h[1]) || "";
  return {
    chatType: a,
    conversationId: u
  };
}
function ar(t) {
  let r = "";
  return (t == null ? void 0 : t.type) !== "notice" && (t == null ? void 0 : t.type) !== "recall" && (t = t, t.chatType == "groupChat" || t.chatType == "chatRoom" || t.from == Zt.client.user ? r = t.to : r = t.from || ""), r;
}
function Mme({ src: t = "", dataKey: r = "", alt: a = "" }) {
  return `<span><img  src=${t} data-key=${r} alt=${a} width="20" height="20" style="vertical-align: middle" /></span>`;
}
const lG = (t) => {
  if (t === void 0)
    return "";
  let r = "", a = null;
  const u = /(\[.*?\])/g;
  let h = 0, b = 0;
  for (; a = u.exec(t); ) {
    if (b = a.index, b > h && (r += t.substring(h, b)), a[1] in vm.map) {
      const l = vm.map[a[1]];
      r += Mme({
        src: new URL((/* @__PURE__ */ Object.assign({ "/module/assets/reactions/U+1F308.png": lg, "/module/assets/reactions/U+1F31C.png": fg, "/module/assets/reactions/U+1F31F.png": hg, "/module/assets/reactions/U+1F381.png": pg, "/module/assets/reactions/U+1F382.png": gg, "/module/assets/reactions/U+1F389.png": mg, "/module/assets/reactions/U+1F44D.png": Eg, "/module/assets/reactions/U+1F44E.png": yg, "/module/assets/reactions/U+1F44F.png": vg, "/module/assets/reactions/U+1F47F.png": Tg, "/module/assets/reactions/U+1F48B.png": bg, "/module/assets/reactions/U+1F490.png": Ag, "/module/assets/reactions/U+1F494.png": Og, "/module/assets/reactions/U+1F495.png": Cg, "/module/assets/reactions/U+1F4A9.png": Sg, "/module/assets/reactions/U+1F600.png": Ig, "/module/assets/reactions/U+1F604.png": Rg, "/module/assets/reactions/U+1F607.png": Ng, "/module/assets/reactions/U+1F609.png": wg, "/module/assets/reactions/U+1F60D.png": _g, "/module/assets/reactions/U+1F60E.png": Pg, "/module/assets/reactions/U+1F610.png": xg, "/module/assets/reactions/U+1F618.png": Dg, "/module/assets/reactions/U+1F620.png": Mg, "/module/assets/reactions/U+1F621.png": Lg, "/module/assets/reactions/U+1F62B.png": kg, "/module/assets/reactions/U+1F62C.png": jg, "/module/assets/reactions/U+1F62D.png": Ug, "/module/assets/reactions/U+1F62E.png": Hg, "/module/assets/reactions/U+1F631.png": Bg, "/module/assets/reactions/U+1F633.png": zg, "/module/assets/reactions/U+1F637.png": Fg, "/module/assets/reactions/U+1F641.png": Gg, "/module/assets/reactions/U+1F644.png": Vg, "/module/assets/reactions/U+1F64C.png": Yg, "/module/assets/reactions/U+1F64F.png": Xg, "/module/assets/reactions/U+1F910.png": Wg, "/module/assets/reactions/U+1F912.png": qg, "/module/assets/reactions/U+1F913.png": Kg, "/module/assets/reactions/U+1F91D.png": Jg, "/module/assets/reactions/U+1F922.png": Zg, "/module/assets/reactions/U+1F928.png": Qg, "/module/assets/reactions/U+1F92A.png": $g, "/module/assets/reactions/U+1F92C.png": em, "/module/assets/reactions/U+1F971.png": tm, "/module/assets/reactions/U+1F973.png": nm, "/module/assets/reactions/U+1F974.png": rm, "/module/assets/reactions/U+1F97A.png": im, "/module/assets/reactions/U+2600.png": sm, "/module/assets/reactions/U+263A.png": am, "/module/assets/reactions/U+2764.png": om, "/module/assets/reactions/U+2B50.png": cm }))[`/module/assets/reactions/${l}`], import.meta.url).href,
        dataKey: a[1],
        alt: a[1]
      });
    } else
      r += a[1];
    h = b + a[1].length;
  }
  return r += t.substring(h, t.length), r;
};
function xd(t) {
  const { userIdList: r, withPresence: a = !0 } = t, { client: u, addressStore: h, conversationStore: b } = gr();
  if (!u.context) return Promise.reject("client is not initialized");
  const l = r.indexOf(u.user), v = [...r], s = {};
  return l > -1 && v.splice(l, 1), v.length > 0 && a && u.subscribePresence({ usernames: v, expiry: 2592e3 }).catch((c) => {
    console.warn("subscribePresence failed", c);
  }), new Promise((c, d) => {
    const p = [
      "nickname",
      "avatarurl",
      "mail",
      "phone",
      "gender",
      "sign",
      "birth",
      "ext"
    ], m = {};
    r.forEach((E) => {
      m[E] = {
        userId: E,
        isOnline: !1
      };
    }), r.length === 0 ? c(Object.assign({}, m)) : u.fetchUserInfoById(r, p).then((E) => {
      if (E.data && Object.keys(E.data).forEach((y) => {
        p.forEach((g) => {
          var C;
          m[y][g] = (C = E == null ? void 0 : E.data) != null && C[y][g] ? E.data[y][g] : "";
        });
      }), a)
        u.getPresenceStatus({ usernames: r }).then((y) => {
          var C, O;
          (C = y == null ? void 0 : y.data) == null || C.result.forEach((N) => {
            m[N.uid] && (m[N.uid].presenceExt = N.ext, Object.prototype.toString.call(N.status) === "[object Object]" && Object.values(N.status).indexOf("1") > -1 && (m[N.uid].isOnline = !0));
          }), b.setOnlineStatus((O = y.data) == null ? void 0 : O.result);
          const g = h.appUsersInfo;
          h.setAppUserInfo(Object.assign({}, m, g)), c(Object.assign({}, s, m));
        }).catch((y) => {
          d(y);
        });
      else {
        const y = h.appUsersInfo;
        h.setAppUserInfo(Object.assign({}, m, y)), c(Object.assign({}, s, m));
      }
    }).catch((E) => {
      d(E);
    });
  });
}
const fG = (t) => (
  //@ts-ignore
  t == null ? void 0 : t.replace(/[\u00A0-\u9999<>]/gim, (r) => "".concat("&#", r.charCodeAt(0), ";"))
);
function jd(t) {
  const { addressStore: r } = Zt;
  return r.groups.find((a) => t === a.groupid);
}
function Wf(t) {
  const { addressStore: r } = Zt;
  return r.groups.findIndex((a) => t === a.groupid);
}
function aA(t, r) {
  var a;
  return (a = t == null ? void 0 : t.members) == null ? void 0 : a.findIndex((u) => r === u.userId);
}
function ah(t) {
  var a, u;
  const { appUsersInfo: r } = Zt.addressStore;
  return ((a = t.attributes) == null ? void 0 : a.nickName) || ((u = r == null ? void 0 : r[t.userId]) == null ? void 0 : u.nickname) || t.userId;
}
function Lme(t) {
  const { appUsersInfo: r } = Zt.addressStore;
  return (r == null ? void 0 : r[t]) || {};
}
function qf(t) {
  const { message: r } = Zt.messageStore;
  return r[t.chatType][t.conversationId];
}
function Kf(t, r) {
  return t ? t.findIndex((a) => a.id === r || a.mid === r) : -1;
}
function UR(t, r) {
  var a;
  return (a = t.reactions) == null ? void 0 : a.find((u) => u.reaction === r);
}
const Bu = (t, r) => {
  var c, d, p, m, E;
  let { chatType: a, from: u = "", to: h, chatThread: b } = t;
  const l = r || (b == null ? void 0 : b.parentId);
  l && (h = l);
  const { appUsersInfo: v, contacts: s } = gr().addressStore;
  if (a === "groupChat") {
    const y = jd(h), g = s.find((O) => O.userId === u);
    if (g && g.remark)
      return g.remark;
    const C = (y && aA(y, u)) ?? -1;
    if (C > -1) {
      const O = (c = y == null ? void 0 : y.members) == null ? void 0 : c[C];
      return O ? ah(O) || ((d = v == null ? void 0 : v[u]) == null ? void 0 : d.nickname) || u : ((p = v == null ? void 0 : v[u]) == null ? void 0 : p.nickname) || u;
    }
    return ((m = v == null ? void 0 : v[u]) == null ? void 0 : m.nickname) || u;
  } else
    return ((E = v == null ? void 0 : v[u]) == null ? void 0 : E.nickname) || u;
};
function Ay(t, r) {
  var a, u, h;
  return t.isPinned && !r.isPinned ? -1 : !t.isPinned && r.isPinned ? 1 : (!t.isPinned && !r.isPinned || t.isPinned && r.isPinned) && (a = t.lastMessage) != null && a.time ? ((u = t.lastMessage) == null ? void 0 : u.time) > ((h = r.lastMessage) == null ? void 0 : h.time) ? -1 : 1 : 0;
}
function Zp(t) {
  const a = /[\u4E00-\u9FA5]/.test(t), u = /^[a-zA-Z]$/.test(t);
  return a ? "zh" : u ? "en" : "unknown";
}
var ev = {}, hG = {}, pG = {};
Object.defineProperty(pG, "__esModule", { value: !0 });
var oA = {}, Hm = {}, Tb = rn && rn.__assign || function() {
  return Tb = Object.assign || function(t) {
    for (var r, a = 1, u = arguments.length; a < u; a++) {
      r = arguments[a];
      for (var h in r) Object.prototype.hasOwnProperty.call(r, h) && (t[h] = r[h]);
    }
    return t;
  }, Tb.apply(this, arguments);
};
Object.defineProperty(Hm, "__esModule", { value: !0 });
Hm.flatten = void 0;
var kme = {
  xml: !1,
  decodeEntities: !0
};
Hm.default = kme;
var AU = {
  _useHtmlParser2: !0,
  xmlMode: !0
};
function jme(t) {
  return t != null && t.xml ? typeof t.xml == "boolean" ? AU : Tb(Tb({}, AU), t.xml) : t ?? void 0;
}
Hm.flatten = jme;
var Ls = {}, tu = {}, Wl = {}, Ma = {}, Bm = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0;
  var r;
  (function(u) {
    u.Root = "root", u.Text = "text", u.Directive = "directive", u.Comment = "comment", u.Script = "script", u.Style = "style", u.Tag = "tag", u.CDATA = "cdata", u.Doctype = "doctype";
  })(r = t.ElementType || (t.ElementType = {}));
  function a(u) {
    return u.type === r.Tag || u.type === r.Script || u.type === r.Style;
  }
  t.isTag = a, t.Root = r.Root, t.Text = r.Text, t.Directive = r.Directive, t.Comment = r.Comment, t.Script = r.Script, t.Style = r.Style, t.Tag = r.Tag, t.CDATA = r.CDATA, t.Doctype = r.Doctype;
})(Bm);
var qr = {}, ql = rn && rn.__extends || /* @__PURE__ */ function() {
  var t = function(r, a) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, h) {
      u.__proto__ = h;
    } || function(u, h) {
      for (var b in h) Object.prototype.hasOwnProperty.call(h, b) && (u[b] = h[b]);
    }, t(r, a);
  };
  return function(r, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
    t(r, a);
    function u() {
      this.constructor = r;
    }
    r.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
  };
}(), By = rn && rn.__assign || function() {
  return By = Object.assign || function(t) {
    for (var r, a = 1, u = arguments.length; a < u; a++) {
      r = arguments[a];
      for (var h in r) Object.prototype.hasOwnProperty.call(r, h) && (t[h] = r[h]);
    }
    return t;
  }, By.apply(this, arguments);
};
Object.defineProperty(qr, "__esModule", { value: !0 });
qr.cloneNode = qr.hasChildren = qr.isDocument = qr.isDirective = qr.isComment = qr.isText = qr.isCDATA = qr.isTag = qr.Element = qr.Document = qr.CDATA = qr.NodeWithChildren = qr.ProcessingInstruction = qr.Comment = qr.Text = qr.DataNode = qr.Node = void 0;
var Eo = Bm, Cw = (
  /** @class */
  function() {
    function t() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(r) {
        this.parent = r;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(r) {
        this.prev = r;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(r) {
        this.next = r;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.cloneNode = function(r) {
      return r === void 0 && (r = !1), Sw(this, r);
    }, t;
  }()
);
qr.Node = Cw;
var cA = (
  /** @class */
  function(t) {
    ql(r, t);
    function r(a) {
      var u = t.call(this) || this;
      return u.data = a, u;
    }
    return Object.defineProperty(r.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(a) {
        this.data = a;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(Cw)
);
qr.DataNode = cA;
var gG = (
  /** @class */
  function(t) {
    ql(r, t);
    function r() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.type = Eo.ElementType.Text, a;
    }
    return Object.defineProperty(r.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(cA)
);
qr.Text = gG;
var mG = (
  /** @class */
  function(t) {
    ql(r, t);
    function r() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.type = Eo.ElementType.Comment, a;
    }
    return Object.defineProperty(r.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(cA)
);
qr.Comment = mG;
var EG = (
  /** @class */
  function(t) {
    ql(r, t);
    function r(a, u) {
      var h = t.call(this, u) || this;
      return h.name = a, h.type = Eo.ElementType.Directive, h;
    }
    return Object.defineProperty(r.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(cA)
);
qr.ProcessingInstruction = EG;
var uA = (
  /** @class */
  function(t) {
    ql(r, t);
    function r(a) {
      var u = t.call(this) || this;
      return u.children = a, u;
    }
    return Object.defineProperty(r.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var a;
        return (a = this.children[0]) !== null && a !== void 0 ? a : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(a) {
        this.children = a;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(Cw)
);
qr.NodeWithChildren = uA;
var yG = (
  /** @class */
  function(t) {
    ql(r, t);
    function r() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.type = Eo.ElementType.CDATA, a;
    }
    return Object.defineProperty(r.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(uA)
);
qr.CDATA = yG;
var vG = (
  /** @class */
  function(t) {
    ql(r, t);
    function r() {
      var a = t !== null && t.apply(this, arguments) || this;
      return a.type = Eo.ElementType.Root, a;
    }
    return Object.defineProperty(r.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(uA)
);
qr.Document = vG;
var TG = (
  /** @class */
  function(t) {
    ql(r, t);
    function r(a, u, h, b) {
      h === void 0 && (h = []), b === void 0 && (b = a === "script" ? Eo.ElementType.Script : a === "style" ? Eo.ElementType.Style : Eo.ElementType.Tag);
      var l = t.call(this, h) || this;
      return l.name = a, l.attribs = u, l.type = b, l;
    }
    return Object.defineProperty(r.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(a) {
        this.name = a;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "attributes", {
      get: function() {
        var a = this;
        return Object.keys(this.attribs).map(function(u) {
          var h, b;
          return {
            name: u,
            value: a.attribs[u],
            namespace: (h = a["x-attribsNamespace"]) === null || h === void 0 ? void 0 : h[u],
            prefix: (b = a["x-attribsPrefix"]) === null || b === void 0 ? void 0 : b[u]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(uA)
);
qr.Element = TG;
function bG(t) {
  return (0, Eo.isTag)(t);
}
qr.isTag = bG;
function AG(t) {
  return t.type === Eo.ElementType.CDATA;
}
qr.isCDATA = AG;
function OG(t) {
  return t.type === Eo.ElementType.Text;
}
qr.isText = OG;
function CG(t) {
  return t.type === Eo.ElementType.Comment;
}
qr.isComment = CG;
function SG(t) {
  return t.type === Eo.ElementType.Directive;
}
qr.isDirective = SG;
function IG(t) {
  return t.type === Eo.ElementType.Root;
}
qr.isDocument = IG;
function Ume(t) {
  return Object.prototype.hasOwnProperty.call(t, "children");
}
qr.hasChildren = Ume;
function Sw(t, r) {
  r === void 0 && (r = !1);
  var a;
  if (OG(t))
    a = new gG(t.data);
  else if (CG(t))
    a = new mG(t.data);
  else if (bG(t)) {
    var u = r ? HR(t.children) : [], h = new TG(t.name, By({}, t.attribs), u);
    u.forEach(function(s) {
      return s.parent = h;
    }), t.namespace != null && (h.namespace = t.namespace), t["x-attribsNamespace"] && (h["x-attribsNamespace"] = By({}, t["x-attribsNamespace"])), t["x-attribsPrefix"] && (h["x-attribsPrefix"] = By({}, t["x-attribsPrefix"])), a = h;
  } else if (AG(t)) {
    var u = r ? HR(t.children) : [], b = new yG(u);
    u.forEach(function(c) {
      return c.parent = b;
    }), a = b;
  } else if (IG(t)) {
    var u = r ? HR(t.children) : [], l = new vG(u);
    u.forEach(function(c) {
      return c.parent = l;
    }), t["x-mode"] && (l["x-mode"] = t["x-mode"]), a = l;
  } else if (SG(t)) {
    var v = new EG(t.name, t.data);
    t["x-name"] != null && (v["x-name"] = t["x-name"], v["x-publicId"] = t["x-publicId"], v["x-systemId"] = t["x-systemId"]), a = v;
  } else
    throw new Error("Not implemented yet: ".concat(t.type));
  return a.startIndex = t.startIndex, a.endIndex = t.endIndex, t.sourceCodeLocation != null && (a.sourceCodeLocation = t.sourceCodeLocation), a;
}
qr.cloneNode = Sw;
function HR(t) {
  for (var r = t.map(function(u) {
    return Sw(u, !0);
  }), a = 1; a < r.length; a++)
    r[a].prev = r[a - 1], r[a - 1].next = r[a];
  return r;
}
(function(t) {
  var r = rn && rn.__createBinding || (Object.create ? function(v, s, c, d) {
    d === void 0 && (d = c);
    var p = Object.getOwnPropertyDescriptor(s, c);
    (!p || ("get" in p ? !s.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return s[c];
    } }), Object.defineProperty(v, d, p);
  } : function(v, s, c, d) {
    d === void 0 && (d = c), v[d] = s[c];
  }), a = rn && rn.__exportStar || function(v, s) {
    for (var c in v) c !== "default" && !Object.prototype.hasOwnProperty.call(s, c) && r(s, v, c);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomHandler = void 0;
  var u = Bm, h = qr;
  a(qr, t);
  var b = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, l = (
    /** @class */
    function() {
      function v(s, c, d) {
        this.dom = [], this.root = new h.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof c == "function" && (d = c, c = b), typeof s == "object" && (c = s, s = void 0), this.callback = s ?? null, this.options = c ?? b, this.elementCB = d ?? null;
      }
      return v.prototype.onparserinit = function(s) {
        this.parser = s;
      }, v.prototype.onreset = function() {
        this.dom = [], this.root = new h.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, v.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, v.prototype.onerror = function(s) {
        this.handleCallback(s);
      }, v.prototype.onclosetag = function() {
        this.lastNode = null;
        var s = this.tagStack.pop();
        this.options.withEndIndices && (s.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s);
      }, v.prototype.onopentag = function(s, c) {
        var d = this.options.xmlMode ? u.ElementType.Tag : void 0, p = new h.Element(s, c, void 0, d);
        this.addNode(p), this.tagStack.push(p);
      }, v.prototype.ontext = function(s) {
        var c = this.lastNode;
        if (c && c.type === u.ElementType.Text)
          c.data += s, this.options.withEndIndices && (c.endIndex = this.parser.endIndex);
        else {
          var d = new h.Text(s);
          this.addNode(d), this.lastNode = d;
        }
      }, v.prototype.oncomment = function(s) {
        if (this.lastNode && this.lastNode.type === u.ElementType.Comment) {
          this.lastNode.data += s;
          return;
        }
        var c = new h.Comment(s);
        this.addNode(c), this.lastNode = c;
      }, v.prototype.oncommentend = function() {
        this.lastNode = null;
      }, v.prototype.oncdatastart = function() {
        var s = new h.Text(""), c = new h.CDATA([s]);
        this.addNode(c), s.parent = c, this.lastNode = s;
      }, v.prototype.oncdataend = function() {
        this.lastNode = null;
      }, v.prototype.onprocessinginstruction = function(s, c) {
        var d = new h.ProcessingInstruction(s, c);
        this.addNode(d);
      }, v.prototype.handleCallback = function(s) {
        if (typeof this.callback == "function")
          this.callback(s, this.dom);
        else if (s)
          throw s;
      }, v.prototype.addNode = function(s) {
        var c = this.tagStack[this.tagStack.length - 1], d = c.children[c.children.length - 1];
        this.options.withStartIndices && (s.startIndex = this.parser.startIndex), this.options.withEndIndices && (s.endIndex = this.parser.endIndex), c.children.push(s), d && (s.prev = d, d.next = s), s.parent = c, this.lastNode = null;
      }, v;
    }()
  );
  t.DomHandler = l, t.default = l;
})(Ma);
var zm = {}, RG = {}, bm = {}, Iw = {};
Object.defineProperty(Iw, "__esModule", { value: !0 });
Iw.default = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function(t) {
    return t.charCodeAt(0);
  })
);
var Rw = {};
Object.defineProperty(Rw, "__esModule", { value: !0 });
Rw.default = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function(t) {
    return t.charCodeAt(0);
  })
);
var aN = {};
(function(t) {
  var r;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.replaceCodePoint = t.fromCodePoint = void 0;
  var a = /* @__PURE__ */ new Map([
    [0, 65533],
    // C1 Unicode control character reference replacements
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376]
  ]);
  t.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (r = String.fromCodePoint) !== null && r !== void 0 ? r : function(b) {
    var l = "";
    return b > 65535 && (b -= 65536, l += String.fromCharCode(b >>> 10 & 1023 | 55296), b = 56320 | b & 1023), l += String.fromCharCode(b), l;
  };
  function u(b) {
    var l;
    return b >= 55296 && b <= 57343 || b > 1114111 ? 65533 : (l = a.get(b)) !== null && l !== void 0 ? l : b;
  }
  t.replaceCodePoint = u;
  function h(b) {
    return (0, t.fromCodePoint)(u(b));
  }
  t.default = h;
})(aN);
(function(t) {
  var r = rn && rn.__createBinding || (Object.create ? function(F, j, G, U) {
    U === void 0 && (U = G);
    var M = Object.getOwnPropertyDescriptor(j, G);
    (!M || ("get" in M ? !j.__esModule : M.writable || M.configurable)) && (M = { enumerable: !0, get: function() {
      return j[G];
    } }), Object.defineProperty(F, U, M);
  } : function(F, j, G, U) {
    U === void 0 && (U = G), F[U] = j[G];
  }), a = rn && rn.__setModuleDefault || (Object.create ? function(F, j) {
    Object.defineProperty(F, "default", { enumerable: !0, value: j });
  } : function(F, j) {
    F.default = j;
  }), u = rn && rn.__importStar || function(F) {
    if (F && F.__esModule) return F;
    var j = {};
    if (F != null) for (var G in F) G !== "default" && Object.prototype.hasOwnProperty.call(F, G) && r(j, F, G);
    return a(j, F), j;
  }, h = rn && rn.__importDefault || function(F) {
    return F && F.__esModule ? F : { default: F };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXML = t.decodeHTMLStrict = t.decodeHTMLAttribute = t.decodeHTML = t.determineBranch = t.EntityDecoder = t.DecodingMode = t.BinTrieFlags = t.fromCodePoint = t.replaceCodePoint = t.decodeCodePoint = t.xmlDecodeTree = t.htmlDecodeTree = void 0;
  var b = h(Iw);
  t.htmlDecodeTree = b.default;
  var l = h(Rw);
  t.xmlDecodeTree = l.default;
  var v = u(aN);
  t.decodeCodePoint = v.default;
  var s = aN;
  Object.defineProperty(t, "replaceCodePoint", { enumerable: !0, get: function() {
    return s.replaceCodePoint;
  } }), Object.defineProperty(t, "fromCodePoint", { enumerable: !0, get: function() {
    return s.fromCodePoint;
  } });
  var c;
  (function(F) {
    F[F.NUM = 35] = "NUM", F[F.SEMI = 59] = "SEMI", F[F.EQUALS = 61] = "EQUALS", F[F.ZERO = 48] = "ZERO", F[F.NINE = 57] = "NINE", F[F.LOWER_A = 97] = "LOWER_A", F[F.LOWER_F = 102] = "LOWER_F", F[F.LOWER_X = 120] = "LOWER_X", F[F.LOWER_Z = 122] = "LOWER_Z", F[F.UPPER_A = 65] = "UPPER_A", F[F.UPPER_F = 70] = "UPPER_F", F[F.UPPER_Z = 90] = "UPPER_Z";
  })(c || (c = {}));
  var d = 32, p;
  (function(F) {
    F[F.VALUE_LENGTH = 49152] = "VALUE_LENGTH", F[F.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", F[F.JUMP_TABLE = 127] = "JUMP_TABLE";
  })(p = t.BinTrieFlags || (t.BinTrieFlags = {}));
  function m(F) {
    return F >= c.ZERO && F <= c.NINE;
  }
  function E(F) {
    return F >= c.UPPER_A && F <= c.UPPER_F || F >= c.LOWER_A && F <= c.LOWER_F;
  }
  function y(F) {
    return F >= c.UPPER_A && F <= c.UPPER_Z || F >= c.LOWER_A && F <= c.LOWER_Z || m(F);
  }
  function g(F) {
    return F === c.EQUALS || y(F);
  }
  var C;
  (function(F) {
    F[F.EntityStart = 0] = "EntityStart", F[F.NumericStart = 1] = "NumericStart", F[F.NumericDecimal = 2] = "NumericDecimal", F[F.NumericHex = 3] = "NumericHex", F[F.NamedEntity = 4] = "NamedEntity";
  })(C || (C = {}));
  var O;
  (function(F) {
    F[F.Legacy = 0] = "Legacy", F[F.Strict = 1] = "Strict", F[F.Attribute = 2] = "Attribute";
  })(O = t.DecodingMode || (t.DecodingMode = {}));
  var N = (
    /** @class */
    function() {
      function F(j, G, U) {
        this.decodeTree = j, this.emitCodePoint = G, this.errors = U, this.state = C.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = O.Strict;
      }
      return F.prototype.startEntity = function(j) {
        this.decodeMode = j, this.state = C.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
      }, F.prototype.write = function(j, G) {
        switch (this.state) {
          case C.EntityStart:
            return j.charCodeAt(G) === c.NUM ? (this.state = C.NumericStart, this.consumed += 1, this.stateNumericStart(j, G + 1)) : (this.state = C.NamedEntity, this.stateNamedEntity(j, G));
          case C.NumericStart:
            return this.stateNumericStart(j, G);
          case C.NumericDecimal:
            return this.stateNumericDecimal(j, G);
          case C.NumericHex:
            return this.stateNumericHex(j, G);
          case C.NamedEntity:
            return this.stateNamedEntity(j, G);
        }
      }, F.prototype.stateNumericStart = function(j, G) {
        return G >= j.length ? -1 : (j.charCodeAt(G) | d) === c.LOWER_X ? (this.state = C.NumericHex, this.consumed += 1, this.stateNumericHex(j, G + 1)) : (this.state = C.NumericDecimal, this.stateNumericDecimal(j, G));
      }, F.prototype.addToNumericResult = function(j, G, U, M) {
        if (G !== U) {
          var V = U - G;
          this.result = this.result * Math.pow(M, V) + parseInt(j.substr(G, V), M), this.consumed += V;
        }
      }, F.prototype.stateNumericHex = function(j, G) {
        for (var U = G; G < j.length; ) {
          var M = j.charCodeAt(G);
          if (m(M) || E(M))
            G += 1;
          else
            return this.addToNumericResult(j, U, G, 16), this.emitNumericEntity(M, 3);
        }
        return this.addToNumericResult(j, U, G, 16), -1;
      }, F.prototype.stateNumericDecimal = function(j, G) {
        for (var U = G; G < j.length; ) {
          var M = j.charCodeAt(G);
          if (m(M))
            G += 1;
          else
            return this.addToNumericResult(j, U, G, 10), this.emitNumericEntity(M, 2);
        }
        return this.addToNumericResult(j, U, G, 10), -1;
      }, F.prototype.emitNumericEntity = function(j, G) {
        var U;
        if (this.consumed <= G)
          return (U = this.errors) === null || U === void 0 || U.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
        if (j === c.SEMI)
          this.consumed += 1;
        else if (this.decodeMode === O.Strict)
          return 0;
        return this.emitCodePoint((0, v.replaceCodePoint)(this.result), this.consumed), this.errors && (j !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
      }, F.prototype.stateNamedEntity = function(j, G) {
        for (var U = this.decodeTree, M = U[this.treeIndex], V = (M & p.VALUE_LENGTH) >> 14; G < j.length; G++, this.excess++) {
          var J = j.charCodeAt(G);
          if (this.treeIndex = _(U, M, this.treeIndex + Math.max(1, V), J), this.treeIndex < 0)
            return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === O.Attribute && // We shouldn't have consumed any characters after the entity,
            (V === 0 || // And there should be no invalid characters.
            g(J)) ? 0 : this.emitNotTerminatedNamedEntity();
          if (M = U[this.treeIndex], V = (M & p.VALUE_LENGTH) >> 14, V !== 0) {
            if (J === c.SEMI)
              return this.emitNamedEntityData(this.treeIndex, V, this.consumed + this.excess);
            this.decodeMode !== O.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
          }
        }
        return -1;
      }, F.prototype.emitNotTerminatedNamedEntity = function() {
        var j, G = this, U = G.result, M = G.decodeTree, V = (M[U] & p.VALUE_LENGTH) >> 14;
        return this.emitNamedEntityData(U, V, this.consumed), (j = this.errors) === null || j === void 0 || j.missingSemicolonAfterCharacterReference(), this.consumed;
      }, F.prototype.emitNamedEntityData = function(j, G, U) {
        var M = this.decodeTree;
        return this.emitCodePoint(G === 1 ? M[j] & ~p.VALUE_LENGTH : M[j + 1], U), G === 3 && this.emitCodePoint(M[j + 2], U), U;
      }, F.prototype.end = function() {
        var j;
        switch (this.state) {
          case C.NamedEntity:
            return this.result !== 0 && (this.decodeMode !== O.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
          case C.NumericDecimal:
            return this.emitNumericEntity(0, 2);
          case C.NumericHex:
            return this.emitNumericEntity(0, 3);
          case C.NumericStart:
            return (j = this.errors) === null || j === void 0 || j.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
          case C.EntityStart:
            return 0;
        }
      }, F;
    }()
  );
  t.EntityDecoder = N;
  function w(F) {
    var j = "", G = new N(F, function(U) {
      return j += (0, v.fromCodePoint)(U);
    });
    return function(M, V) {
      for (var J = 0, ue = 0; (ue = M.indexOf("&", ue)) >= 0; ) {
        j += M.slice(J, ue), G.startEntity(V);
        var se = G.write(
          M,
          // Skip the "&"
          ue + 1
        );
        if (se < 0) {
          J = ue + G.end();
          break;
        }
        J = ue + se, ue = se === 0 ? J + 1 : J;
      }
      var ee = j + M.slice(J);
      return j = "", ee;
    };
  }
  function _(F, j, G, U) {
    var M = (j & p.BRANCH_LENGTH) >> 7, V = j & p.JUMP_TABLE;
    if (M === 0)
      return V !== 0 && U === V ? G : -1;
    if (V) {
      var J = U - V;
      return J < 0 || J >= M ? -1 : F[G + J] - 1;
    }
    for (var ue = G, se = ue + M - 1; ue <= se; ) {
      var ee = ue + se >>> 1, de = F[ee];
      if (de < U)
        ue = ee + 1;
      else if (de > U)
        se = ee - 1;
      else
        return F[ee + M];
    }
    return -1;
  }
  t.determineBranch = _;
  var I = w(b.default), k = w(l.default);
  function H(F, j) {
    return j === void 0 && (j = O.Legacy), I(F, j);
  }
  t.decodeHTML = H;
  function S(F) {
    return I(F, O.Attribute);
  }
  t.decodeHTMLAttribute = S;
  function B(F) {
    return I(F, O.Strict);
  }
  t.decodeHTMLStrict = B;
  function D(F) {
    return k(F, O.Strict);
  }
  t.decodeXML = D;
})(bm);
var oh = {}, Nw = {};
Object.defineProperty(Nw, "__esModule", { value: !0 });
function D0(t) {
  for (var r = 1; r < t.length; r++)
    t[r][0] += t[r - 1][0] + 1;
  return t;
}
Nw.default = new Map(/* @__PURE__ */ D0([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, { v: "&lt;", n: 8402, o: "&nvlt;" }], [0, { v: "&equals;", n: 8421, o: "&bne;" }], [0, { v: "&gt;", n: 8402, o: "&nvgt;" }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, { n: 106, o: "&fjlig;" }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, { v: "&MediumSpace;", n: 8202, o: "&ThickSpace;" }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, { v: "&rarrw;", n: 824, o: "&nrarrw;" }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, { v: "&part;", n: 824, o: "&npart;" }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, { v: "&ang;", n: 8402, o: "&nang;" }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, { v: "&cap;", n: 65024, o: "&caps;" }], [0, { v: "&cup;", n: 65024, o: "&cups;" }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, { v: "&sim;", n: 8402, o: "&nvsim;" }], [0, { v: "&backsim;", n: 817, o: "&race;" }], [0, { v: "&ac;", n: 819, o: "&acE;" }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, { v: "&eqsim;", n: 824, o: "&nesim;" }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, { v: "&apid;", n: 824, o: "&napid;" }], [0, "&backcong;"], [0, { v: "&asympeq;", n: 8402, o: "&nvap;" }], [0, { v: "&bump;", n: 824, o: "&nbump;" }], [0, { v: "&bumpe;", n: 824, o: "&nbumpe;" }], [0, { v: "&doteq;", n: 824, o: "&nedot;" }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, { v: "&Congruent;", n: 8421, o: "&bnequiv;" }], [0, "&nequiv;"], [1, { v: "&le;", n: 8402, o: "&nvle;" }], [0, { v: "&ge;", n: 8402, o: "&nvge;" }], [0, { v: "&lE;", n: 824, o: "&nlE;" }], [0, { v: "&gE;", n: 824, o: "&ngE;" }], [0, { v: "&lnE;", n: 65024, o: "&lvertneqq;" }], [0, { v: "&gnE;", n: 65024, o: "&gvertneqq;" }], [0, { v: "&ll;", n: new Map(/* @__PURE__ */ D0([[824, "&nLtv;"], [7577, "&nLt;"]])) }], [0, { v: "&gg;", n: new Map(/* @__PURE__ */ D0([[824, "&nGtv;"], [7577, "&nGt;"]])) }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, { v: "&scsim;", n: 824, o: "&NotSucceedsTilde;" }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, { v: "&sub;", n: 8402, o: "&NotSubset;" }], [0, { v: "&sup;", n: 8402, o: "&NotSuperset;" }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, { v: "&subne;", n: 65024, o: "&varsubsetneq;" }], [0, { v: "&supne;", n: 65024, o: "&varsupsetneq;" }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, { v: "&sqsub;", n: 824, o: "&NotSquareSubset;" }], [0, { v: "&sqsup;", n: 824, o: "&NotSquareSuperset;" }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, { v: "&sqcap;", n: 65024, o: "&sqcaps;" }], [0, { v: "&sqcup;", n: 65024, o: "&sqcups;" }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, { v: "&LeftTriangleEqual;", n: 8402, o: "&nvltrie;" }], [0, { v: "&RightTriangleEqual;", n: 8402, o: "&nvrtrie;" }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, { v: "&Ll;", n: 824, o: "&nLl;" }], [0, { v: "&Gg;", n: 824, o: "&nGg;" }], [0, { v: "&leg;", n: 65024, o: "&lesg;" }], [0, { v: "&gel;", n: 65024, o: "&gesl;" }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, { v: "&isindot;", n: 824, o: "&notindot;" }], [0, "&notinvc;"], [0, "&notinvb;"], [1, { v: "&isinE;", n: 824, o: "&notinE;" }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, { v: "&rarrc;", n: 824, o: "&nrarrc;" }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, { v: "&LeftTriangleBar;", n: 824, o: "&NotLeftTriangleBar;" }], [0, { v: "&RightTriangleBar;", n: 824, o: "&NotRightTriangleBar;" }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, { v: "&congdot;", n: 824, o: "&ncongdot;" }], [0, "&easter;"], [0, "&apacir;"], [0, { v: "&apE;", n: 824, o: "&napE;" }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, { v: "&leqslant;", n: 824, o: "&nleqslant;" }], [0, { v: "&geqslant;", n: 824, o: "&ngeqslant;" }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, { v: "&LessLess;", n: 824, o: "&NotNestedLessLess;" }], [0, { v: "&GreaterGreater;", n: 824, o: "&NotNestedGreaterGreater;" }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, { v: "&smte;", n: 65024, o: "&smtes;" }], [0, { v: "&late;", n: 65024, o: "&lates;" }], [0, "&bumpE;"], [0, { v: "&PrecedesEqual;", n: 824, o: "&NotPrecedesEqual;" }], [0, { v: "&sce;", n: 824, o: "&NotSucceedsEqual;" }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, { v: "&subE;", n: 824, o: "&nsubE;" }], [0, { v: "&supE;", n: 824, o: "&nsupE;" }], [0, "&subsim;"], [0, "&supsim;"], [2, { v: "&subnE;", n: 65024, o: "&varsubsetneqq;" }], [0, { v: "&supnE;", n: 65024, o: "&varsupsetneqq;" }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, { v: "&parsl;", n: 8421, o: "&nparsl;" }], [44343, { n: new Map(/* @__PURE__ */ D0([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]])) }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
var tv = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.getCodePoint = t.xmlReplacer = void 0, t.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
  var r = /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [39, "&apos;"],
    [60, "&lt;"],
    [62, "&gt;"]
  ]);
  t.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? function(h, b) {
    return h.codePointAt(b);
  } : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    function(h, b) {
      return (h.charCodeAt(b) & 64512) === 55296 ? (h.charCodeAt(b) - 55296) * 1024 + h.charCodeAt(b + 1) - 56320 + 65536 : h.charCodeAt(b);
    }
  );
  function a(h) {
    for (var b = "", l = 0, v; (v = t.xmlReplacer.exec(h)) !== null; ) {
      var s = v.index, c = h.charCodeAt(s), d = r.get(c);
      d !== void 0 ? (b += h.substring(l, s) + d, l = s + 1) : (b += "".concat(h.substring(l, s), "&#x").concat((0, t.getCodePoint)(h, s).toString(16), ";"), l = t.xmlReplacer.lastIndex += +((c & 64512) === 55296));
    }
    return b + h.substr(l);
  }
  t.encodeXML = a, t.escape = a;
  function u(h, b) {
    return function(v) {
      for (var s, c = 0, d = ""; s = h.exec(v); )
        c !== s.index && (d += v.substring(c, s.index)), d += b.get(s[0].charCodeAt(0)), c = s.index + 1;
      return d + v.substring(c);
    };
  }
  t.escapeUTF8 = u(/[&<>'"]/g, r), t.escapeAttribute = u(/["&\u00A0]/g, /* @__PURE__ */ new Map([
    [34, "&quot;"],
    [38, "&amp;"],
    [160, "&nbsp;"]
  ])), t.escapeText = u(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
    [38, "&amp;"],
    [60, "&lt;"],
    [62, "&gt;"],
    [160, "&nbsp;"]
  ]));
})(tv);
var Hme = rn && rn.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(oh, "__esModule", { value: !0 });
oh.encodeNonAsciiHTML = oh.encodeHTML = void 0;
var Bme = Hme(Nw), NG = tv, zme = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function Fme(t) {
  return wG(zme, t);
}
oh.encodeHTML = Fme;
function Gme(t) {
  return wG(NG.xmlReplacer, t);
}
oh.encodeNonAsciiHTML = Gme;
function wG(t, r) {
  for (var a = "", u = 0, h; (h = t.exec(r)) !== null; ) {
    var b = h.index;
    a += r.substring(u, b);
    var l = r.charCodeAt(b), v = Bme.default.get(l);
    if (typeof v == "object") {
      if (b + 1 < r.length) {
        var s = r.charCodeAt(b + 1), c = typeof v.n == "number" ? v.n === s ? v.o : void 0 : v.n.get(s);
        if (c !== void 0) {
          a += c, u = t.lastIndex += 1;
          continue;
        }
      }
      v = v.v;
    }
    if (v !== void 0)
      a += v, u = b + 1;
    else {
      var d = (0, NG.getCodePoint)(r, b);
      a += "&#x".concat(d.toString(16), ";"), u = t.lastIndex += +(d !== l);
    }
  }
  return a + r.substr(u);
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLAttribute = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.DecodingMode = t.EntityDecoder = t.encodeHTML5 = t.encodeHTML4 = t.encodeNonAsciiHTML = t.encodeHTML = t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.encode = t.decodeStrict = t.decode = t.EncodingMode = t.EntityLevel = void 0;
  var r = bm, a = oh, u = tv, h;
  (function(m) {
    m[m.XML = 0] = "XML", m[m.HTML = 1] = "HTML";
  })(h = t.EntityLevel || (t.EntityLevel = {}));
  var b;
  (function(m) {
    m[m.UTF8 = 0] = "UTF8", m[m.ASCII = 1] = "ASCII", m[m.Extensive = 2] = "Extensive", m[m.Attribute = 3] = "Attribute", m[m.Text = 4] = "Text";
  })(b = t.EncodingMode || (t.EncodingMode = {}));
  function l(m, E) {
    E === void 0 && (E = h.XML);
    var y = typeof E == "number" ? E : E.level;
    if (y === h.HTML) {
      var g = typeof E == "object" ? E.mode : void 0;
      return (0, r.decodeHTML)(m, g);
    }
    return (0, r.decodeXML)(m);
  }
  t.decode = l;
  function v(m, E) {
    var y;
    E === void 0 && (E = h.XML);
    var g = typeof E == "number" ? { level: E } : E;
    return (y = g.mode) !== null && y !== void 0 || (g.mode = r.DecodingMode.Strict), l(m, g);
  }
  t.decodeStrict = v;
  function s(m, E) {
    E === void 0 && (E = h.XML);
    var y = typeof E == "number" ? { level: E } : E;
    return y.mode === b.UTF8 ? (0, u.escapeUTF8)(m) : y.mode === b.Attribute ? (0, u.escapeAttribute)(m) : y.mode === b.Text ? (0, u.escapeText)(m) : y.level === h.HTML ? y.mode === b.ASCII ? (0, a.encodeNonAsciiHTML)(m) : (0, a.encodeHTML)(m) : (0, u.encodeXML)(m);
  }
  t.encode = s;
  var c = tv;
  Object.defineProperty(t, "encodeXML", { enumerable: !0, get: function() {
    return c.encodeXML;
  } }), Object.defineProperty(t, "escape", { enumerable: !0, get: function() {
    return c.escape;
  } }), Object.defineProperty(t, "escapeUTF8", { enumerable: !0, get: function() {
    return c.escapeUTF8;
  } }), Object.defineProperty(t, "escapeAttribute", { enumerable: !0, get: function() {
    return c.escapeAttribute;
  } }), Object.defineProperty(t, "escapeText", { enumerable: !0, get: function() {
    return c.escapeText;
  } });
  var d = oh;
  Object.defineProperty(t, "encodeHTML", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } }), Object.defineProperty(t, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return d.encodeNonAsciiHTML;
  } }), Object.defineProperty(t, "encodeHTML4", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } }), Object.defineProperty(t, "encodeHTML5", { enumerable: !0, get: function() {
    return d.encodeHTML;
  } });
  var p = bm;
  Object.defineProperty(t, "EntityDecoder", { enumerable: !0, get: function() {
    return p.EntityDecoder;
  } }), Object.defineProperty(t, "DecodingMode", { enumerable: !0, get: function() {
    return p.DecodingMode;
  } }), Object.defineProperty(t, "decodeXML", { enumerable: !0, get: function() {
    return p.decodeXML;
  } }), Object.defineProperty(t, "decodeHTML", { enumerable: !0, get: function() {
    return p.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return p.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTMLAttribute", { enumerable: !0, get: function() {
    return p.decodeHTMLAttribute;
  } }), Object.defineProperty(t, "decodeHTML4", { enumerable: !0, get: function() {
    return p.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML5", { enumerable: !0, get: function() {
    return p.decodeHTML;
  } }), Object.defineProperty(t, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return p.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return p.decodeHTMLStrict;
  } }), Object.defineProperty(t, "decodeXMLStrict", { enumerable: !0, get: function() {
    return p.decodeXML;
  } });
})(RG);
var Am = {};
Object.defineProperty(Am, "__esModule", { value: !0 });
Am.attributeNames = Am.elementNames = void 0;
Am.elementNames = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map(function(t) {
  return [t.toLowerCase(), t];
}));
Am.attributeNames = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map(function(t) {
  return [t.toLowerCase(), t];
}));
var Qp = rn && rn.__assign || function() {
  return Qp = Object.assign || function(t) {
    for (var r, a = 1, u = arguments.length; a < u; a++) {
      r = arguments[a];
      for (var h in r) Object.prototype.hasOwnProperty.call(r, h) && (t[h] = r[h]);
    }
    return t;
  }, Qp.apply(this, arguments);
}, Vme = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), Yme = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), Xme = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && Vme(r, t, a);
  return Yme(r, t), r;
};
Object.defineProperty(zm, "__esModule", { value: !0 });
zm.render = void 0;
var Ad = Xme(Bm), bb = RG, _G = Am, Wme = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function qme(t) {
  return t.replace(/"/g, "&quot;");
}
function Kme(t, r) {
  var a;
  if (t) {
    var u = ((a = r.encodeEntities) !== null && a !== void 0 ? a : r.decodeEntities) === !1 ? qme : r.xmlMode || r.encodeEntities !== "utf8" ? bb.encodeXML : bb.escapeAttribute;
    return Object.keys(t).map(function(h) {
      var b, l, v = (b = t[h]) !== null && b !== void 0 ? b : "";
      return r.xmlMode === "foreign" && (h = (l = _G.attributeNames.get(h)) !== null && l !== void 0 ? l : h), !r.emptyAttrs && !r.xmlMode && v === "" ? h : "".concat(h, '="').concat(u(v), '"');
    }).join(" ");
  }
}
var OU = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function dA(t, r) {
  r === void 0 && (r = {});
  for (var a = ("length" in t) ? t : [t], u = "", h = 0; h < a.length; h++)
    u += Jme(a[h], r);
  return u;
}
zm.render = dA;
zm.default = dA;
function Jme(t, r) {
  switch (t.type) {
    case Ad.Root:
      return dA(t.children, r);
    case Ad.Doctype:
    case Ad.Directive:
      return eEe(t);
    case Ad.Comment:
      return rEe(t);
    case Ad.CDATA:
      return nEe(t);
    case Ad.Script:
    case Ad.Style:
    case Ad.Tag:
      return $me(t, r);
    case Ad.Text:
      return tEe(t, r);
  }
}
var Zme = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), Qme = /* @__PURE__ */ new Set(["svg", "math"]);
function $me(t, r) {
  var a;
  r.xmlMode === "foreign" && (t.name = (a = _G.elementNames.get(t.name)) !== null && a !== void 0 ? a : t.name, t.parent && Zme.has(t.parent.name) && (r = Qp(Qp({}, r), { xmlMode: !1 }))), !r.xmlMode && Qme.has(t.name) && (r = Qp(Qp({}, r), { xmlMode: "foreign" }));
  var u = "<".concat(t.name), h = Kme(t.attribs, r);
  return h && (u += " ".concat(h)), t.children.length === 0 && (r.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    r.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    r.selfClosingTags && OU.has(t.name)
  )) ? (r.xmlMode || (u += " "), u += "/>") : (u += ">", t.children.length > 0 && (u += dA(t.children, r)), (r.xmlMode || !OU.has(t.name)) && (u += "</".concat(t.name, ">"))), u;
}
function eEe(t) {
  return "<".concat(t.data, ">");
}
function tEe(t, r) {
  var a, u = t.data || "";
  return ((a = r.encodeEntities) !== null && a !== void 0 ? a : r.decodeEntities) !== !1 && !(!r.xmlMode && t.parent && Wme.has(t.parent.name)) && (u = r.xmlMode || r.encodeEntities !== "utf8" ? (0, bb.encodeXML)(u) : (0, bb.escapeText)(u)), u;
}
function nEe(t) {
  return "<![CDATA[".concat(t.children[0].data, "]]>");
}
function rEe(t) {
  return "<!--".concat(t.data, "-->");
}
var iEe = rn && rn.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Wl, "__esModule", { value: !0 });
Wl.getOuterHTML = PG;
Wl.getInnerHTML = oEe;
Wl.getText = Z0;
Wl.textContent = oN;
Wl.innerText = cN;
var zu = Ma, sEe = iEe(zm), aEe = Bm;
function PG(t, r) {
  return (0, sEe.default)(t, r);
}
function oEe(t, r) {
  return (0, zu.hasChildren)(t) ? t.children.map(function(a) {
    return PG(a, r);
  }).join("") : "";
}
function Z0(t) {
  return Array.isArray(t) ? t.map(Z0).join("") : (0, zu.isTag)(t) ? t.name === "br" ? `
` : Z0(t.children) : (0, zu.isCDATA)(t) ? Z0(t.children) : (0, zu.isText)(t) ? t.data : "";
}
function oN(t) {
  return Array.isArray(t) ? t.map(oN).join("") : (0, zu.hasChildren)(t) && !(0, zu.isComment)(t) ? oN(t.children) : (0, zu.isText)(t) ? t.data : "";
}
function cN(t) {
  return Array.isArray(t) ? t.map(cN).join("") : (0, zu.hasChildren)(t) && (t.type === aEe.ElementType.Tag || (0, zu.isCDATA)(t)) ? cN(t.children) : (0, zu.isText)(t) ? t.data : "";
}
var Xu = {};
Object.defineProperty(Xu, "__esModule", { value: !0 });
Xu.getChildren = xG;
Xu.getParent = DG;
Xu.getSiblings = cEe;
Xu.getAttributeValue = uEe;
Xu.hasAttrib = dEe;
Xu.getName = lEe;
Xu.nextElementSibling = fEe;
Xu.prevElementSibling = hEe;
var ww = Ma;
function xG(t) {
  return (0, ww.hasChildren)(t) ? t.children : [];
}
function DG(t) {
  return t.parent || null;
}
function cEe(t) {
  var r, a, u = DG(t);
  if (u != null)
    return xG(u);
  for (var h = [t], b = t.prev, l = t.next; b != null; )
    h.unshift(b), r = b, b = r.prev;
  for (; l != null; )
    h.push(l), a = l, l = a.next;
  return h;
}
function uEe(t, r) {
  var a;
  return (a = t.attribs) === null || a === void 0 ? void 0 : a[r];
}
function dEe(t, r) {
  return t.attribs != null && Object.prototype.hasOwnProperty.call(t.attribs, r) && t.attribs[r] != null;
}
function lEe(t) {
  return t.name;
}
function fEe(t) {
  for (var r, a = t.next; a !== null && !(0, ww.isTag)(a); )
    r = a, a = r.next;
  return a;
}
function hEe(t) {
  for (var r, a = t.prev; a !== null && !(0, ww.isTag)(a); )
    r = a, a = r.prev;
  return a;
}
var Kl = {};
Object.defineProperty(Kl, "__esModule", { value: !0 });
Kl.removeElement = Sv;
Kl.replaceElement = pEe;
Kl.appendChild = gEe;
Kl.append = mEe;
Kl.prependChild = EEe;
Kl.prepend = yEe;
function Sv(t) {
  if (t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.parent) {
    var r = t.parent.children, a = r.lastIndexOf(t);
    a >= 0 && r.splice(a, 1);
  }
  t.next = null, t.prev = null, t.parent = null;
}
function pEe(t, r) {
  var a = r.prev = t.prev;
  a && (a.next = r);
  var u = r.next = t.next;
  u && (u.prev = r);
  var h = r.parent = t.parent;
  if (h) {
    var b = h.children;
    b[b.lastIndexOf(t)] = r, t.parent = null;
  }
}
function gEe(t, r) {
  if (Sv(r), r.next = null, r.parent = t, t.children.push(r) > 1) {
    var a = t.children[t.children.length - 2];
    a.next = r, r.prev = a;
  } else
    r.prev = null;
}
function mEe(t, r) {
  Sv(r);
  var a = t.parent, u = t.next;
  if (r.next = u, r.prev = t, t.next = r, r.parent = a, u) {
    if (u.prev = r, a) {
      var h = a.children;
      h.splice(h.lastIndexOf(u), 0, r);
    }
  } else a && a.children.push(r);
}
function EEe(t, r) {
  if (Sv(r), r.parent = t, r.prev = null, t.children.unshift(r) !== 1) {
    var a = t.children[1];
    a.prev = r, r.next = a;
  } else
    r.next = null;
}
function yEe(t, r) {
  Sv(r);
  var a = t.parent;
  if (a) {
    var u = a.children;
    u.splice(u.indexOf(t), 0, r);
  }
  t.prev && (t.prev.next = r), r.parent = a, r.prev = t.prev, r.next = t, t.prev = r;
}
var Ud = {};
Object.defineProperty(Ud, "__esModule", { value: !0 });
Ud.filter = vEe;
Ud.find = MG;
Ud.findOneChild = TEe;
Ud.findOne = LG;
Ud.existsOne = kG;
Ud.findAll = bEe;
var ch = Ma;
function vEe(t, r, a, u) {
  return a === void 0 && (a = !0), u === void 0 && (u = 1 / 0), MG(t, Array.isArray(r) ? r : [r], a, u);
}
function MG(t, r, a, u) {
  for (var h = [], b = [Array.isArray(r) ? r : [r]], l = [0]; ; ) {
    if (l[0] >= b[0].length) {
      if (l.length === 1)
        return h;
      b.shift(), l.shift();
      continue;
    }
    var v = b[0][l[0]++];
    if (t(v) && (h.push(v), --u <= 0))
      return h;
    a && (0, ch.hasChildren)(v) && v.children.length > 0 && (l.unshift(0), b.unshift(v.children));
  }
}
function TEe(t, r) {
  return r.find(t);
}
function LG(t, r, a) {
  a === void 0 && (a = !0);
  for (var u = Array.isArray(r) ? r : [r], h = 0; h < u.length; h++) {
    var b = u[h];
    if ((0, ch.isTag)(b) && t(b))
      return b;
    if (a && (0, ch.hasChildren)(b) && b.children.length > 0) {
      var l = LG(t, b.children, !0);
      if (l)
        return l;
    }
  }
  return null;
}
function kG(t, r) {
  return (Array.isArray(r) ? r : [r]).some(function(a) {
    return (0, ch.isTag)(a) && t(a) || (0, ch.hasChildren)(a) && kG(t, a.children);
  });
}
function bEe(t, r) {
  for (var a = [], u = [Array.isArray(r) ? r : [r]], h = [0]; ; ) {
    if (h[0] >= u[0].length) {
      if (u.length === 1)
        return a;
      u.shift(), h.shift();
      continue;
    }
    var b = u[0][h[0]++];
    (0, ch.isTag)(b) && t(b) && a.push(b), (0, ch.hasChildren)(b) && b.children.length > 0 && (h.unshift(0), u.unshift(b.children));
  }
}
var Hd = {};
Object.defineProperty(Hd, "__esModule", { value: !0 });
Hd.testElement = OEe;
Hd.getElements = CEe;
Hd.getElementById = SEe;
Hd.getElementsByTagName = IEe;
Hd.getElementsByClassName = REe;
Hd.getElementsByTagType = NEe;
var Qf = Ma, Iv = Ud, Ab = {
  tag_name: function(t) {
    return typeof t == "function" ? function(r) {
      return (0, Qf.isTag)(r) && t(r.name);
    } : t === "*" ? Qf.isTag : function(r) {
      return (0, Qf.isTag)(r) && r.name === t;
    };
  },
  tag_type: function(t) {
    return typeof t == "function" ? function(r) {
      return t(r.type);
    } : function(r) {
      return r.type === t;
    };
  },
  tag_contains: function(t) {
    return typeof t == "function" ? function(r) {
      return (0, Qf.isText)(r) && t(r.data);
    } : function(r) {
      return (0, Qf.isText)(r) && r.data === t;
    };
  }
};
function _w(t, r) {
  return typeof r == "function" ? function(a) {
    return (0, Qf.isTag)(a) && r(a.attribs[t]);
  } : function(a) {
    return (0, Qf.isTag)(a) && a.attribs[t] === r;
  };
}
function AEe(t, r) {
  return function(a) {
    return t(a) || r(a);
  };
}
function jG(t) {
  var r = Object.keys(t).map(function(a) {
    var u = t[a];
    return Object.prototype.hasOwnProperty.call(Ab, a) ? Ab[a](u) : _w(a, u);
  });
  return r.length === 0 ? null : r.reduce(AEe);
}
function OEe(t, r) {
  var a = jG(t);
  return a ? a(r) : !0;
}
function CEe(t, r, a, u) {
  u === void 0 && (u = 1 / 0);
  var h = jG(t);
  return h ? (0, Iv.filter)(h, r, a, u) : [];
}
function SEe(t, r, a) {
  return a === void 0 && (a = !0), Array.isArray(r) || (r = [r]), (0, Iv.findOne)(_w("id", t), r, a);
}
function IEe(t, r, a, u) {
  return a === void 0 && (a = !0), u === void 0 && (u = 1 / 0), (0, Iv.filter)(Ab.tag_name(t), r, a, u);
}
function REe(t, r, a, u) {
  return a === void 0 && (a = !0), u === void 0 && (u = 1 / 0), (0, Iv.filter)(_w("class", t), r, a, u);
}
function NEe(t, r, a, u) {
  return a === void 0 && (a = !0), u === void 0 && (u = 1 / 0), (0, Iv.filter)(Ab.tag_type(t), r, a, u);
}
var Eh = {};
Object.defineProperty(Eh, "__esModule", { value: !0 });
Eh.DocumentPosition = void 0;
Eh.removeSubsets = wEe;
Eh.compareDocumentPosition = UG;
Eh.uniqueSort = _Ee;
var CU = Ma;
function wEe(t) {
  for (var r = t.length; --r >= 0; ) {
    var a = t[r];
    if (r > 0 && t.lastIndexOf(a, r - 1) >= 0) {
      t.splice(r, 1);
      continue;
    }
    for (var u = a.parent; u; u = u.parent)
      if (t.includes(u)) {
        t.splice(r, 1);
        break;
      }
  }
  return t;
}
var qc;
(function(t) {
  t[t.DISCONNECTED = 1] = "DISCONNECTED", t[t.PRECEDING = 2] = "PRECEDING", t[t.FOLLOWING = 4] = "FOLLOWING", t[t.CONTAINS = 8] = "CONTAINS", t[t.CONTAINED_BY = 16] = "CONTAINED_BY";
})(qc || (Eh.DocumentPosition = qc = {}));
function UG(t, r) {
  var a = [], u = [];
  if (t === r)
    return 0;
  for (var h = (0, CU.hasChildren)(t) ? t : t.parent; h; )
    a.unshift(h), h = h.parent;
  for (h = (0, CU.hasChildren)(r) ? r : r.parent; h; )
    u.unshift(h), h = h.parent;
  for (var b = Math.min(a.length, u.length), l = 0; l < b && a[l] === u[l]; )
    l++;
  if (l === 0)
    return qc.DISCONNECTED;
  var v = a[l - 1], s = v.children, c = a[l], d = u[l];
  return s.indexOf(c) > s.indexOf(d) ? v === r ? qc.FOLLOWING | qc.CONTAINED_BY : qc.FOLLOWING : v === t ? qc.PRECEDING | qc.CONTAINS : qc.PRECEDING;
}
function _Ee(t) {
  return t = t.filter(function(r, a, u) {
    return !u.includes(r, a + 1);
  }), t.sort(function(r, a) {
    var u = UG(r, a);
    return u & qc.PRECEDING ? -1 : u & qc.FOLLOWING ? 1 : 0;
  }), t;
}
var Pw = {};
Object.defineProperty(Pw, "__esModule", { value: !0 });
Pw.getFeed = xEe;
var PEe = Wl, Rv = Hd;
function xEe(t) {
  var r = Ob(jEe, t);
  return r ? r.name === "feed" ? DEe(r) : MEe(r) : null;
}
function DEe(t) {
  var r, a = t.children, u = {
    type: "atom",
    items: (0, Rv.getElementsByTagName)("entry", a).map(function(l) {
      var v, s = l.children, c = { media: HG(s) };
      mo(c, "id", "id", s), mo(c, "title", "title", s);
      var d = (v = Ob("link", s)) === null || v === void 0 ? void 0 : v.attribs.href;
      d && (c.link = d);
      var p = _l("summary", s) || _l("content", s);
      p && (c.description = p);
      var m = _l("updated", s);
      return m && (c.pubDate = new Date(m)), c;
    })
  };
  mo(u, "id", "id", a), mo(u, "title", "title", a);
  var h = (r = Ob("link", a)) === null || r === void 0 ? void 0 : r.attribs.href;
  h && (u.link = h), mo(u, "description", "subtitle", a);
  var b = _l("updated", a);
  return b && (u.updated = new Date(b)), mo(u, "author", "email", a, !0), u;
}
function MEe(t) {
  var r, a, u = (a = (r = Ob("channel", t.children)) === null || r === void 0 ? void 0 : r.children) !== null && a !== void 0 ? a : [], h = {
    type: t.name.substr(0, 3),
    id: "",
    items: (0, Rv.getElementsByTagName)("item", t.children).map(function(l) {
      var v = l.children, s = { media: HG(v) };
      mo(s, "id", "guid", v), mo(s, "title", "title", v), mo(s, "link", "link", v), mo(s, "description", "description", v);
      var c = _l("pubDate", v) || _l("dc:date", v);
      return c && (s.pubDate = new Date(c)), s;
    })
  };
  mo(h, "title", "title", u), mo(h, "link", "link", u), mo(h, "description", "description", u);
  var b = _l("lastBuildDate", u);
  return b && (h.updated = new Date(b)), mo(h, "author", "managingEditor", u, !0), h;
}
var LEe = ["url", "type", "lang"], kEe = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function HG(t) {
  return (0, Rv.getElementsByTagName)("media:content", t).map(function(r) {
    for (var a = r.attribs, u = {
      medium: a.medium,
      isDefault: !!a.isDefault
    }, h = 0, b = LEe; h < b.length; h++) {
      var l = b[h];
      a[l] && (u[l] = a[l]);
    }
    for (var v = 0, s = kEe; v < s.length; v++) {
      var l = s[v];
      a[l] && (u[l] = parseInt(a[l], 10));
    }
    return a.expression && (u.expression = a.expression), u;
  });
}
function Ob(t, r) {
  return (0, Rv.getElementsByTagName)(t, r, !0, 1)[0];
}
function _l(t, r, a) {
  return a === void 0 && (a = !1), (0, PEe.textContent)((0, Rv.getElementsByTagName)(t, r, a, 1)).trim();
}
function mo(t, r, a, u, h) {
  h === void 0 && (h = !1);
  var b = _l(a, u, h);
  b && (t[r] = b);
}
function jEe(t) {
  return t === "rss" || t === "feed" || t === "rdf:RDF";
}
(function(t) {
  var r = rn && rn.__createBinding || (Object.create ? function(h, b, l, v) {
    v === void 0 && (v = l);
    var s = Object.getOwnPropertyDescriptor(b, l);
    (!s || ("get" in s ? !b.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return b[l];
    } }), Object.defineProperty(h, v, s);
  } : function(h, b, l, v) {
    v === void 0 && (v = l), h[v] = b[l];
  }), a = rn && rn.__exportStar || function(h, b) {
    for (var l in h) l !== "default" && !Object.prototype.hasOwnProperty.call(b, l) && r(b, h, l);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.hasChildren = t.isDocument = t.isComment = t.isText = t.isCDATA = t.isTag = void 0, a(Wl, t), a(Xu, t), a(Kl, t), a(Ud, t), a(Hd, t), a(Eh, t), a(Pw, t);
  var u = Ma;
  Object.defineProperty(t, "isTag", { enumerable: !0, get: function() {
    return u.isTag;
  } }), Object.defineProperty(t, "isCDATA", { enumerable: !0, get: function() {
    return u.isCDATA;
  } }), Object.defineProperty(t, "isText", { enumerable: !0, get: function() {
    return u.isText;
  } }), Object.defineProperty(t, "isComment", { enumerable: !0, get: function() {
    return u.isComment;
  } }), Object.defineProperty(t, "isDocument", { enumerable: !0, get: function() {
    return u.isDocument;
  } }), Object.defineProperty(t, "hasChildren", { enumerable: !0, get: function() {
    return u.hasChildren;
  } });
})(tu);
var th = rn && rn.__assign || function() {
  return th = Object.assign || function(t) {
    for (var r, a = 1, u = arguments.length; a < u; a++) {
      r = arguments[a];
      for (var h in r) Object.prototype.hasOwnProperty.call(r, h) && (t[h] = r[h]);
    }
    return t;
  }, th.apply(this, arguments);
}, UEe = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), HEe = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), BEe = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && UEe(r, t, a);
  return HEe(r, t), r;
};
Object.defineProperty(Ls, "__esModule", { value: !0 });
Ls.merge = Ls.contains = Ls.root = Ls.parseHTML = Ls.text = Ls.xml = Ls.html = void 0;
var zEe = tu, uN = BEe(Hm);
function BG(t, r, a) {
  return t ? t(r ?? t._root.children, null, void 0, a).toString() : "";
}
function FEe(t, r) {
  return typeof t == "object" && t != null && !("length" in t) && !("type" in t);
}
function GEe(t, r) {
  var a = FEe(t) ? (r = t, void 0) : t, u = th(th(th({}, uN.default), this === null || this === void 0 ? void 0 : this._options), (0, uN.flatten)(r ?? {}));
  return BG(this, a, u);
}
Ls.html = GEe;
function VEe(t) {
  var r = th(th({}, this._options), { xmlMode: !0 });
  return BG(this, t, r);
}
Ls.xml = VEe;
function YEe(t) {
  for (var r = t || (this ? this.root() : []), a = "", u = 0; u < r.length; u++)
    a += (0, zEe.textContent)(r[u]);
  return a;
}
Ls.text = YEe;
function XEe(t, r, a) {
  if (a === void 0 && (a = typeof r == "boolean" ? r : !1), !t || typeof t != "string")
    return null;
  typeof r == "boolean" && (a = r);
  var u = this.load(t, uN.default, !1);
  return a || u("script").remove(), u.root()[0].children.slice();
}
Ls.parseHTML = XEe;
function WEe() {
  return this(this._root);
}
Ls.root = WEe;
function qEe(t, r) {
  if (r === t)
    return !1;
  for (var a = r; a && a !== a.parent; )
    if (a = a.parent, a === t)
      return !0;
  return !1;
}
Ls.contains = qEe;
function KEe(t, r) {
  if (!(!SU(t) || !SU(r))) {
    for (var a = t.length, u = +r.length, h = 0; h < u; h++)
      t[a++] = r[h];
    return t.length = a, t;
  }
}
Ls.merge = KEe;
function SU(t) {
  if (Array.isArray(t))
    return !0;
  if (typeof t != "object" || !Object.prototype.hasOwnProperty.call(t, "length") || typeof t.length != "number" || t.length < 0)
    return !1;
  for (var r = 0; r < t.length; r++)
    if (!(r in t))
      return !1;
  return !0;
}
var lA = {}, Bs = {}, yh = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.isHtml = t.cloneDom = t.domEach = t.cssCase = t.camelCase = t.isCheerio = t.isTag = void 0;
  var r = Ma, a = Ma;
  Object.defineProperty(t, "isTag", { enumerable: !0, get: function() {
    return a.isTag;
  } });
  function u(d) {
    return d.cheerio != null;
  }
  t.isCheerio = u;
  function h(d) {
    return d.replace(/[_.-](\w|$)/g, function(p, m) {
      return m.toUpperCase();
    });
  }
  t.camelCase = h;
  function b(d) {
    return d.replace(/[A-Z]/g, "-$&").toLowerCase();
  }
  t.cssCase = b;
  function l(d, p) {
    for (var m = d.length, E = 0; E < m; E++)
      p(d[E], E);
    return d;
  }
  t.domEach = l;
  function v(d) {
    var p = "length" in d ? Array.prototype.map.call(d, function(E) {
      return (0, r.cloneNode)(E, !0);
    }) : [(0, r.cloneNode)(d, !0)], m = new r.Document(p);
    return p.forEach(function(E) {
      E.parent = m;
    }), p;
  }
  t.cloneDom = v;
  var s;
  (function(d) {
    d[d.LowerA = 97] = "LowerA", d[d.LowerZ = 122] = "LowerZ", d[d.UpperA = 65] = "UpperA", d[d.UpperZ = 90] = "UpperZ", d[d.Exclamation = 33] = "Exclamation";
  })(s || (s = {}));
  function c(d) {
    var p = d.indexOf("<");
    if (p < 0 || p > d.length - 3)
      return !1;
    var m = d.charCodeAt(p + 1);
    return (m >= s.LowerA && m <= s.LowerZ || m >= s.UpperA && m <= s.UpperZ || m === s.Exclamation) && d.includes(">", p + 2);
  }
  t.isHtml = c;
})(yh);
Object.defineProperty(Bs, "__esModule", { value: !0 });
Bs.toggleClass = Bs.removeClass = Bs.addClass = Bs.hasClass = Bs.removeAttr = Bs.val = Bs.data = Bs.prop = Bs.attr = void 0;
var zG = Ls, vi = yh, IU = tu, ag = Object.prototype.hasOwnProperty, nv = /\s+/, BR = "data-", RU = {
  null: null,
  true: !0,
  false: !1
}, xw = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, JEe = /^{[^]*}$|^\[[^]*]$/;
function Cb(t, r, a) {
  var u;
  if (!(!t || !(0, vi.isTag)(t))) {
    if ((u = t.attribs) !== null && u !== void 0 || (t.attribs = {}), !r)
      return t.attribs;
    if (ag.call(t.attribs, r))
      return !a && xw.test(r) ? r : t.attribs[r];
    if (t.name === "option" && r === "value")
      return (0, zG.text)(t.children);
    if (t.name === "input" && (t.attribs.type === "radio" || t.attribs.type === "checkbox") && r === "value")
      return "on";
  }
}
function og(t, r, a) {
  a === null ? FG(t, r) : t.attribs[r] = "".concat(a);
}
function ZEe(t, r) {
  if (typeof t == "object" || r !== void 0) {
    if (typeof r == "function") {
      if (typeof t != "string")
        throw new Error("Bad combination of arguments.");
      return (0, vi.domEach)(this, function(a, u) {
        (0, vi.isTag)(a) && og(a, t, r.call(a, u, a.attribs[t]));
      });
    }
    return (0, vi.domEach)(this, function(a) {
      (0, vi.isTag)(a) && (typeof t == "object" ? Object.keys(t).forEach(function(u) {
        var h = t[u];
        og(a, u, h);
      }) : og(a, t, r));
    });
  }
  return arguments.length > 1 ? this : Cb(this[0], t, this.options.xmlMode);
}
Bs.attr = ZEe;
function NU(t, r, a) {
  if (!(!t || !(0, vi.isTag)(t)))
    return r in t ? (
      // @ts-expect-error TS doesn't like us accessing the value directly here.
      t[r]
    ) : !a && xw.test(r) ? Cb(t, r, !1) !== void 0 : Cb(t, r, a);
}
function zR(t, r, a, u) {
  r in t ? t[r] = a : og(t, r, !u && xw.test(r) ? a ? "" : null : "".concat(a));
}
function QEe(t, r) {
  var a = this, u;
  if (typeof t == "string" && r === void 0)
    switch (t) {
      case "style": {
        var h = this.css(), b = Object.keys(h);
        return b.forEach(function(s, c) {
          h[c] = s;
        }), h.length = b.length, h;
      }
      case "tagName":
      case "nodeName": {
        var l = this[0];
        return (0, vi.isTag)(l) ? l.name.toUpperCase() : void 0;
      }
      case "href":
      case "src": {
        var l = this[0];
        if (!(0, vi.isTag)(l))
          return;
        var v = (u = l.attribs) === null || u === void 0 ? void 0 : u[t];
        return typeof URL < "u" && (t === "href" && (l.tagName === "a" || l.name === "link") || t === "src" && (l.tagName === "img" || l.tagName === "iframe" || l.tagName === "audio" || l.tagName === "video" || l.tagName === "source")) && v !== void 0 && this.options.baseURI ? new URL(v, this.options.baseURI).href : v;
      }
      case "innerText":
        return (0, IU.innerText)(this[0]);
      case "textContent":
        return (0, IU.textContent)(this[0]);
      case "outerHTML":
        return this.clone().wrap("<container />").parent().html();
      case "innerHTML":
        return this.html();
      default:
        return NU(this[0], t, this.options.xmlMode);
    }
  if (typeof t == "object" || r !== void 0) {
    if (typeof r == "function") {
      if (typeof t == "object")
        throw new Error("Bad combination of arguments.");
      return (0, vi.domEach)(this, function(s, c) {
        (0, vi.isTag)(s) && zR(s, t, r.call(s, c, NU(s, t, a.options.xmlMode)), a.options.xmlMode);
      });
    }
    return (0, vi.domEach)(this, function(s) {
      (0, vi.isTag)(s) && (typeof t == "object" ? Object.keys(t).forEach(function(c) {
        var d = t[c];
        zR(s, c, d, a.options.xmlMode);
      }) : zR(s, t, r, a.options.xmlMode));
    });
  }
}
Bs.prop = QEe;
function wU(t, r, a) {
  var u, h = t;
  (u = h.data) !== null && u !== void 0 || (h.data = {}), typeof r == "object" ? Object.assign(h.data, r) : typeof r == "string" && a !== void 0 && (h.data[r] = a);
}
function _U(t, r) {
  var a, u, h;
  r == null ? (a = Object.keys(t.attribs).filter(function(s) {
    return s.startsWith(BR);
  }), u = a.map(function(s) {
    return (0, vi.camelCase)(s.slice(BR.length));
  })) : (a = [BR + (0, vi.cssCase)(r)], u = [r]);
  for (var b = 0; b < a.length; ++b) {
    var l = a[b], v = u[b];
    if (ag.call(t.attribs, l) && !ag.call(t.data, v)) {
      if (h = t.attribs[l], ag.call(RU, h))
        h = RU[h];
      else if (h === String(Number(h)))
        h = Number(h);
      else if (JEe.test(h))
        try {
          h = JSON.parse(h);
        } catch {
        }
      t.data[v] = h;
    }
  }
  return r == null ? t.data : h;
}
function $Ee(t, r) {
  var a, u = this[0];
  if (!(!u || !(0, vi.isTag)(u))) {
    var h = u;
    return (a = h.data) !== null && a !== void 0 || (h.data = {}), t ? typeof t == "object" || r !== void 0 ? ((0, vi.domEach)(this, function(b) {
      (0, vi.isTag)(b) && (typeof t == "object" ? wU(b, t) : wU(b, t, r));
    }), this) : ag.call(h.data, t) ? h.data[t] : _U(h, t) : _U(h);
  }
}
Bs.data = $Ee;
function eye(t) {
  var r = arguments.length === 0, a = this[0];
  if (!a || !(0, vi.isTag)(a))
    return r ? void 0 : this;
  switch (a.name) {
    case "textarea":
      return this.text(t);
    case "select": {
      var u = this.find("option:selected");
      if (!r) {
        if (this.attr("multiple") == null && typeof t == "object")
          return this;
        this.find("option").removeAttr("selected");
        for (var h = typeof t != "object" ? [t] : t, b = 0; b < h.length; b++)
          this.find('option[value="'.concat(h[b], '"]')).attr("selected", "");
        return this;
      }
      return this.attr("multiple") ? u.toArray().map(function(l) {
        return (0, zG.text)(l.children);
      }) : u.attr("value");
    }
    case "input":
    case "option":
      return r ? this.attr("value") : this.attr("value", t);
  }
}
Bs.val = eye;
function FG(t, r) {
  !t.attribs || !ag.call(t.attribs, r) || delete t.attribs[r];
}
function Sb(t) {
  return t ? t.trim().split(nv) : [];
}
function tye(t) {
  for (var r = Sb(t), a = function(b) {
    (0, vi.domEach)(u, function(l) {
      (0, vi.isTag)(l) && FG(l, r[b]);
    });
  }, u = this, h = 0; h < r.length; h++)
    a(h);
  return this;
}
Bs.removeAttr = tye;
function nye(t) {
  return this.toArray().some(function(r) {
    var a = (0, vi.isTag)(r) && r.attribs.class, u = -1;
    if (a && t.length)
      for (; (u = a.indexOf(t, u + 1)) > -1; ) {
        var h = u + t.length;
        if ((u === 0 || nv.test(a[u - 1])) && (h === a.length || nv.test(a[h])))
          return !0;
      }
    return !1;
  });
}
Bs.hasClass = nye;
function GG(t) {
  if (typeof t == "function")
    return (0, vi.domEach)(this, function(c, d) {
      if ((0, vi.isTag)(c)) {
        var p = c.attribs.class || "";
        GG.call([c], t.call(c, d, p));
      }
    });
  if (!t || typeof t != "string")
    return this;
  for (var r = t.split(nv), a = this.length, u = 0; u < a; u++) {
    var h = this[u];
    if ((0, vi.isTag)(h)) {
      var b = Cb(h, "class", !1);
      if (!b)
        og(h, "class", r.join(" ").trim());
      else {
        for (var l = " ".concat(b, " "), v = 0; v < r.length; v++) {
          var s = "".concat(r[v], " ");
          l.includes(" ".concat(s)) || (l += s);
        }
        og(h, "class", l.trim());
      }
    }
  }
  return this;
}
Bs.addClass = GG;
function VG(t) {
  if (typeof t == "function")
    return (0, vi.domEach)(this, function(h, b) {
      (0, vi.isTag)(h) && VG.call([h], t.call(h, b, h.attribs.class || ""));
    });
  var r = Sb(t), a = r.length, u = arguments.length === 0;
  return (0, vi.domEach)(this, function(h) {
    if ((0, vi.isTag)(h))
      if (u)
        h.attribs.class = "";
      else {
        for (var b = Sb(h.attribs.class), l = !1, v = 0; v < a; v++) {
          var s = b.indexOf(r[v]);
          s >= 0 && (b.splice(s, 1), l = !0, v--);
        }
        l && (h.attribs.class = b.join(" "));
      }
  });
}
Bs.removeClass = VG;
function YG(t, r) {
  if (typeof t == "function")
    return (0, vi.domEach)(this, function(p, m) {
      (0, vi.isTag)(p) && YG.call([p], t.call(p, m, p.attribs.class || "", r), r);
    });
  if (!t || typeof t != "string")
    return this;
  for (var a = t.split(nv), u = a.length, h = typeof r == "boolean" ? r ? 1 : -1 : 0, b = this.length, l = 0; l < b; l++) {
    var v = this[l];
    if ((0, vi.isTag)(v)) {
      for (var s = Sb(v.attribs.class), c = 0; c < u; c++) {
        var d = s.indexOf(a[c]);
        h >= 0 && d < 0 ? s.push(a[c]) : h <= 0 && d >= 0 && s.splice(d, 1);
      }
      v.attribs.class = s.join(" ");
    }
  }
  return this;
}
Bs.toggleClass = YG;
var qn = {}, XG = {}, $r;
(function(t) {
  t.Attribute = "attribute", t.Pseudo = "pseudo", t.PseudoElement = "pseudo-element", t.Tag = "tag", t.Universal = "universal", t.Adjacent = "adjacent", t.Child = "child", t.Descendant = "descendant", t.Parent = "parent", t.Sibling = "sibling", t.ColumnCombinator = "column-combinator";
})($r || ($r = {}));
const rye = {
  Unknown: null,
  QuirksMode: "quirks",
  IgnoreCase: !0,
  CaseSensitive: !1
};
var hs;
(function(t) {
  t.Any = "any", t.Element = "element", t.End = "end", t.Equals = "equals", t.Exists = "exists", t.Hyphen = "hyphen", t.Not = "not", t.Start = "start";
})(hs || (hs = {}));
const PU = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, iye = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, sye = /* @__PURE__ */ new Map([
  [126, hs.Element],
  [94, hs.Start],
  [36, hs.End],
  [42, hs.Any],
  [33, hs.Not],
  [124, hs.Hyphen]
]), aye = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function WG(t) {
  switch (t.type) {
    case $r.Adjacent:
    case $r.Child:
    case $r.Descendant:
    case $r.Parent:
    case $r.Sibling:
    case $r.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const oye = /* @__PURE__ */ new Set(["contains", "icontains"]);
function cye(t, r, a) {
  const u = parseInt(r, 16) - 65536;
  return u !== u || a ? r : u < 0 ? (
    // BMP codepoint
    String.fromCharCode(u + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(u >> 10 | 55296, u & 1023 | 56320)
  );
}
function Oy(t) {
  return t.replace(iye, cye);
}
function FR(t) {
  return t === 39 || t === 34;
}
function xU(t) {
  return t === 32 || t === 9 || t === 10 || t === 12 || t === 13;
}
function uye(t) {
  const r = [], a = qG(r, `${t}`, 0);
  if (a < t.length)
    throw new Error(`Unmatched selector: ${t.slice(a)}`);
  return r;
}
function qG(t, r, a) {
  let u = [];
  function h(m) {
    const E = r.slice(a + m).match(PU);
    if (!E)
      throw new Error(`Expected name, found ${r.slice(a)}`);
    const [y] = E;
    return a += m + y.length, Oy(y);
  }
  function b(m) {
    for (a += m; a < r.length && xU(r.charCodeAt(a)); )
      a++;
  }
  function l() {
    a += 1;
    const m = a;
    let E = 1;
    for (; E > 0 && a < r.length; a++)
      r.charCodeAt(a) === 40 && !v(a) ? E++ : r.charCodeAt(a) === 41 && !v(a) && E--;
    if (E)
      throw new Error("Parenthesis not matched");
    return Oy(r.slice(m, a - 1));
  }
  function v(m) {
    let E = 0;
    for (; r.charCodeAt(--m) === 92; )
      E++;
    return (E & 1) === 1;
  }
  function s() {
    if (u.length > 0 && WG(u[u.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function c(m) {
    if (u.length > 0 && u[u.length - 1].type === $r.Descendant) {
      u[u.length - 1].type = m;
      return;
    }
    s(), u.push({ type: m });
  }
  function d(m, E) {
    u.push({
      type: $r.Attribute,
      name: m,
      action: E,
      value: h(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function p() {
    if (u.length && u[u.length - 1].type === $r.Descendant && u.pop(), u.length === 0)
      throw new Error("Empty sub-selector");
    t.push(u);
  }
  if (b(0), r.length === a)
    return a;
  e: for (; a < r.length; ) {
    const m = r.charCodeAt(a);
    switch (m) {
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        (u.length === 0 || u[0].type !== $r.Descendant) && (s(), u.push({ type: $r.Descendant })), b(1);
        break;
      }
      case 62: {
        c($r.Child), b(1);
        break;
      }
      case 60: {
        c($r.Parent), b(1);
        break;
      }
      case 126: {
        c($r.Sibling), b(1);
        break;
      }
      case 43: {
        c($r.Adjacent), b(1);
        break;
      }
      case 46: {
        d("class", hs.Element);
        break;
      }
      case 35: {
        d("id", hs.Equals);
        break;
      }
      case 91: {
        b(1);
        let E, y = null;
        r.charCodeAt(a) === 124 ? E = h(1) : r.startsWith("*|", a) ? (y = "*", E = h(2)) : (E = h(0), r.charCodeAt(a) === 124 && r.charCodeAt(a + 1) !== 61 && (y = E, E = h(1))), b(0);
        let g = hs.Exists;
        const C = sye.get(r.charCodeAt(a));
        if (C) {
          if (g = C, r.charCodeAt(a + 1) !== 61)
            throw new Error("Expected `=`");
          b(2);
        } else r.charCodeAt(a) === 61 && (g = hs.Equals, b(1));
        let O = "", N = null;
        if (g !== "exists") {
          if (FR(r.charCodeAt(a))) {
            const I = r.charCodeAt(a);
            let k = a + 1;
            for (; k < r.length && (r.charCodeAt(k) !== I || v(k)); )
              k += 1;
            if (r.charCodeAt(k) !== I)
              throw new Error("Attribute value didn't end");
            O = Oy(r.slice(a + 1, k)), a = k + 1;
          } else {
            const I = a;
            for (; a < r.length && (!xU(r.charCodeAt(a)) && r.charCodeAt(a) !== 93 || v(a)); )
              a += 1;
            O = Oy(r.slice(I, a));
          }
          b(0);
          const _ = r.charCodeAt(a) | 32;
          _ === 115 ? (N = !1, b(1)) : _ === 105 && (N = !0, b(1));
        }
        if (r.charCodeAt(a) !== 93)
          throw new Error("Attribute selector didn't terminate");
        a += 1;
        const w = {
          type: $r.Attribute,
          name: E,
          action: g,
          value: O,
          namespace: y,
          ignoreCase: N
        };
        u.push(w);
        break;
      }
      case 58: {
        if (r.charCodeAt(a + 1) === 58) {
          u.push({
            type: $r.PseudoElement,
            name: h(2).toLowerCase(),
            data: r.charCodeAt(a) === 40 ? l() : null
          });
          continue;
        }
        const E = h(1).toLowerCase();
        let y = null;
        if (r.charCodeAt(a) === 40)
          if (aye.has(E)) {
            if (FR(r.charCodeAt(a + 1)))
              throw new Error(`Pseudo-selector ${E} cannot be quoted`);
            if (y = [], a = qG(y, r, a + 1), r.charCodeAt(a) !== 41)
              throw new Error(`Missing closing parenthesis in :${E} (${r})`);
            a += 1;
          } else {
            if (y = l(), oye.has(E)) {
              const g = y.charCodeAt(0);
              g === y.charCodeAt(y.length - 1) && FR(g) && (y = y.slice(1, -1));
            }
            y = Oy(y);
          }
        u.push({ type: $r.Pseudo, name: E, data: y });
        break;
      }
      case 44: {
        p(), u = [], b(1);
        break;
      }
      default: {
        if (r.startsWith("/*", a)) {
          const g = r.indexOf("*/", a + 2);
          if (g < 0)
            throw new Error("Comment was not terminated");
          a = g + 2, u.length === 0 && b(0);
          break;
        }
        let E = null, y;
        if (m === 42)
          a += 1, y = "*";
        else if (m === 124) {
          if (y = "", r.charCodeAt(a + 1) === 124) {
            c($r.ColumnCombinator), b(2);
            break;
          }
        } else if (PU.test(r.slice(a)))
          y = h(0);
        else
          break e;
        r.charCodeAt(a) === 124 && r.charCodeAt(a + 1) !== 124 && (E = y, r.charCodeAt(a + 1) === 42 ? (y = "*", a += 2) : y = h(1)), u.push(y === "*" ? { type: $r.Universal, namespace: E } : { type: $r.Tag, name: y, namespace: E });
      }
    }
  }
  return p(), a;
}
const KG = ["\\", '"'], JG = [...KG, "(", ")"], dye = new Set(KG.map((t) => t.charCodeAt(0))), DU = new Set(JG.map((t) => t.charCodeAt(0))), $p = new Set([
  ...JG,
  "~",
  "^",
  "$",
  "*",
  "+",
  "!",
  "|",
  ":",
  "[",
  "]",
  " ",
  "."
].map((t) => t.charCodeAt(0)));
function ZG(t) {
  return t.map((r) => r.map(lye).join("")).join(", ");
}
function lye(t, r, a) {
  switch (t.type) {
    case $r.Child:
      return r === 0 ? "> " : " > ";
    case $r.Parent:
      return r === 0 ? "< " : " < ";
    case $r.Sibling:
      return r === 0 ? "~ " : " ~ ";
    case $r.Adjacent:
      return r === 0 ? "+ " : " + ";
    case $r.Descendant:
      return " ";
    case $r.ColumnCombinator:
      return r === 0 ? "|| " : " || ";
    case $r.Universal:
      return t.namespace === "*" && r + 1 < a.length && "name" in a[r + 1] ? "" : `${QG(t.namespace)}*`;
    case $r.Tag:
      return MU(t);
    case $r.PseudoElement:
      return `::${Cd(t.name, $p)}${t.data === null ? "" : `(${Cd(t.data, DU)})`}`;
    case $r.Pseudo:
      return `:${Cd(t.name, $p)}${t.data === null ? "" : `(${typeof t.data == "string" ? Cd(t.data, DU) : ZG(t.data)})`}`;
    case $r.Attribute: {
      if (t.name === "id" && t.action === hs.Equals && t.ignoreCase === "quirks" && !t.namespace)
        return `#${Cd(t.value, $p)}`;
      if (t.name === "class" && t.action === hs.Element && t.ignoreCase === "quirks" && !t.namespace)
        return `.${Cd(t.value, $p)}`;
      const u = MU(t);
      return t.action === hs.Exists ? `[${u}]` : `[${u}${fye(t.action)}="${Cd(t.value, dye)}"${t.ignoreCase === null ? "" : t.ignoreCase ? " i" : " s"}]`;
    }
  }
}
function fye(t) {
  switch (t) {
    case hs.Equals:
      return "";
    case hs.Element:
      return "~";
    case hs.Start:
      return "^";
    case hs.End:
      return "$";
    case hs.Any:
      return "*";
    case hs.Not:
      return "!";
    case hs.Hyphen:
      return "|";
    case hs.Exists:
      throw new Error("Shouldn't be here");
  }
}
function MU(t) {
  return `${QG(t.namespace)}${Cd(t.name, $p)}`;
}
function QG(t) {
  return t !== null ? `${t === "*" ? "*" : Cd(t, $p)}|` : "";
}
function Cd(t, r) {
  let a = 0, u = "";
  for (let h = 0; h < t.length; h++)
    r.has(t.charCodeAt(h)) && (u += `${t.slice(a, h)}\\${t.charAt(h)}`, a = h + 1);
  return u.length > 0 ? u + t.slice(a) : t;
}
const hye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AttributeAction() {
    return hs;
  },
  IgnoreCaseMode: rye,
  get SelectorType() {
    return $r;
  },
  isTraversal: WG,
  parse: uye,
  stringify: ZG
}, Symbol.toStringTag, { value: "Module" })), Nv = /* @__PURE__ */ KN(hye);
var dN = {}, vh = {
  trueFunc: function() {
    return !0;
  },
  falseFunc: function() {
    return !1;
  }
}, Dl = {}, Fm = {};
Object.defineProperty(Fm, "__esModule", { value: !0 });
Fm.isTraversal = void 0;
var ko = Nv, $G = /* @__PURE__ */ new Map([
  [ko.SelectorType.Universal, 50],
  [ko.SelectorType.Tag, 30],
  [ko.SelectorType.Attribute, 1],
  [ko.SelectorType.Pseudo, 0]
]);
function pye(t) {
  return !$G.has(t.type);
}
Fm.isTraversal = pye;
var gye = /* @__PURE__ */ new Map([
  [ko.AttributeAction.Exists, 10],
  [ko.AttributeAction.Equals, 8],
  [ko.AttributeAction.Not, 7],
  [ko.AttributeAction.Start, 6],
  [ko.AttributeAction.End, 6],
  [ko.AttributeAction.Any, 5]
]);
function mye(t) {
  for (var r = t.map(eV), a = 1; a < t.length; a++) {
    var u = r[a];
    if (!(u < 0))
      for (var h = a - 1; h >= 0 && u < r[h]; h--) {
        var b = t[h + 1];
        t[h + 1] = t[h], t[h] = b, r[h + 1] = r[h], r[h] = u;
      }
  }
}
Fm.default = mye;
function eV(t) {
  var r, a, u = (r = $G.get(t.type)) !== null && r !== void 0 ? r : -1;
  return t.type === ko.SelectorType.Attribute ? (u = (a = gye.get(t.action)) !== null && a !== void 0 ? a : 4, t.action === ko.AttributeAction.Equals && t.name === "id" && (u = 9), t.ignoreCase && (u >>= 1)) : t.type === ko.SelectorType.Pseudo && (t.data ? t.name === "has" || t.name === "contains" ? u = 0 : Array.isArray(t.data) ? (u = Math.min.apply(Math, t.data.map(function(h) {
    return Math.min.apply(Math, h.map(eV));
  })), u < 0 && (u = 0)) : u = 2 : u = 3), u;
}
var fA = {}, hA = {}, Eye = rn && rn.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(hA, "__esModule", { value: !0 });
hA.attributeRules = void 0;
var M0 = Eye(vh), yye = /[-[\]{}()*+?.,\\^$|#\s]/g;
function LU(t) {
  return t.replace(yye, "\\$&");
}
var vye = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function Jf(t, r) {
  return typeof t.ignoreCase == "boolean" ? t.ignoreCase : t.ignoreCase === "quirks" ? !!r.quirksMode : !r.xmlMode && vye.has(t.name);
}
hA.attributeRules = {
  equals: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value;
    return Jf(r, a) ? (b = b.toLowerCase(), function(l) {
      var v = u.getAttributeValue(l, h);
      return v != null && v.length === b.length && v.toLowerCase() === b && t(l);
    }) : function(l) {
      return u.getAttributeValue(l, h) === b && t(l);
    };
  },
  hyphen: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value, l = b.length;
    return Jf(r, a) ? (b = b.toLowerCase(), function(s) {
      var c = u.getAttributeValue(s, h);
      return c != null && (c.length === l || c.charAt(l) === "-") && c.substr(0, l).toLowerCase() === b && t(s);
    }) : function(s) {
      var c = u.getAttributeValue(s, h);
      return c != null && (c.length === l || c.charAt(l) === "-") && c.substr(0, l) === b && t(s);
    };
  },
  element: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value;
    if (/\s/.test(b))
      return M0.default.falseFunc;
    var l = new RegExp("(?:^|\\s)".concat(LU(b), "(?:$|\\s)"), Jf(r, a) ? "i" : "");
    return function(s) {
      var c = u.getAttributeValue(s, h);
      return c != null && c.length >= b.length && l.test(c) && t(s);
    };
  },
  exists: function(t, r, a) {
    var u = r.name, h = a.adapter;
    return function(b) {
      return h.hasAttrib(b, u) && t(b);
    };
  },
  start: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value, l = b.length;
    return l === 0 ? M0.default.falseFunc : Jf(r, a) ? (b = b.toLowerCase(), function(v) {
      var s = u.getAttributeValue(v, h);
      return s != null && s.length >= l && s.substr(0, l).toLowerCase() === b && t(v);
    }) : function(v) {
      var s;
      return !!(!((s = u.getAttributeValue(v, h)) === null || s === void 0) && s.startsWith(b)) && t(v);
    };
  },
  end: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value, l = -b.length;
    return l === 0 ? M0.default.falseFunc : Jf(r, a) ? (b = b.toLowerCase(), function(v) {
      var s;
      return ((s = u.getAttributeValue(v, h)) === null || s === void 0 ? void 0 : s.substr(l).toLowerCase()) === b && t(v);
    }) : function(v) {
      var s;
      return !!(!((s = u.getAttributeValue(v, h)) === null || s === void 0) && s.endsWith(b)) && t(v);
    };
  },
  any: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value;
    if (b === "")
      return M0.default.falseFunc;
    if (Jf(r, a)) {
      var l = new RegExp(LU(b), "i");
      return function(s) {
        var c = u.getAttributeValue(s, h);
        return c != null && c.length >= b.length && l.test(c) && t(s);
      };
    }
    return function(v) {
      var s;
      return !!(!((s = u.getAttributeValue(v, h)) === null || s === void 0) && s.includes(b)) && t(v);
    };
  },
  not: function(t, r, a) {
    var u = a.adapter, h = r.name, b = r.value;
    return b === "" ? function(l) {
      return !!u.getAttributeValue(l, h) && t(l);
    } : Jf(r, a) ? (b = b.toLowerCase(), function(l) {
      var v = u.getAttributeValue(l, h);
      return (v == null || v.length !== b.length || v.toLowerCase() !== b) && t(l);
    }) : function(l) {
      return u.getAttributeValue(l, h) !== b && t(l);
    };
  }
};
var Dw = {}, tV = {}, nV = {}, pA = {};
Object.defineProperty(pA, "__esModule", { value: !0 });
pA.parse = void 0;
var Tye = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), kU = 48, bye = 57;
function Aye(t) {
  if (t = t.trim().toLowerCase(), t === "even")
    return [2, 0];
  if (t === "odd")
    return [2, 1];
  var r = 0, a = 0, u = b(), h = l();
  if (r < t.length && t.charAt(r) === "n" && (r++, a = u * (h ?? 1), v(), r < t.length ? (u = b(), v(), h = l()) : u = h = 0), h === null || r < t.length)
    throw new Error("n-th rule couldn't be parsed ('".concat(t, "')"));
  return [a, u * h];
  function b() {
    return t.charAt(r) === "-" ? (r++, -1) : (t.charAt(r) === "+" && r++, 1);
  }
  function l() {
    for (var s = r, c = 0; r < t.length && t.charCodeAt(r) >= kU && t.charCodeAt(r) <= bye; )
      c = c * 10 + (t.charCodeAt(r) - kU), r++;
    return r === s ? null : c;
  }
  function v() {
    for (; r < t.length && Tye.has(t.charCodeAt(r)); )
      r++;
  }
}
pA.parse = Aye;
var Om = {}, Oye = rn && rn.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Om, "__esModule", { value: !0 });
Om.generate = Om.compile = void 0;
var jU = Oye(vh);
function Cye(t) {
  var r = t[0], a = t[1] - 1;
  if (a < 0 && r <= 0)
    return jU.default.falseFunc;
  if (r === -1)
    return function(b) {
      return b <= a;
    };
  if (r === 0)
    return function(b) {
      return b === a;
    };
  if (r === 1)
    return a < 0 ? jU.default.trueFunc : function(b) {
      return b >= a;
    };
  var u = Math.abs(r), h = (a % u + u) % u;
  return r > 1 ? function(b) {
    return b >= a && b % u === h;
  } : function(b) {
    return b <= a && b % u === h;
  };
}
Om.compile = Cye;
function Sye(t) {
  var r = t[0], a = t[1] - 1, u = 0;
  if (r < 0) {
    var h = -r, b = (a % h + h) % h;
    return function() {
      var l = b + h * u++;
      return l > a ? null : l;
    };
  }
  return r === 0 ? a < 0 ? (
    // There are no result — always return `null`
    function() {
      return null;
    }
  ) : (
    // Return `b` exactly once
    function() {
      return u++ === 0 ? a : null;
    }
  ) : (a < 0 && (a += r * Math.ceil(-a / r)), function() {
    return r * u++ + a;
  });
}
Om.generate = Sye;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.sequence = t.generate = t.compile = t.parse = void 0;
  var r = pA;
  Object.defineProperty(t, "parse", { enumerable: !0, get: function() {
    return r.parse;
  } });
  var a = Om;
  Object.defineProperty(t, "compile", { enumerable: !0, get: function() {
    return a.compile;
  } }), Object.defineProperty(t, "generate", { enumerable: !0, get: function() {
    return a.generate;
  } });
  function u(b) {
    return (0, a.compile)((0, r.parse)(b));
  }
  t.default = u;
  function h(b) {
    return (0, a.generate)((0, r.parse)(b));
  }
  t.sequence = h;
})(nV);
(function(t) {
  var r = rn && rn.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.filters = void 0;
  var a = r(nV), u = r(vh);
  function h(l, v) {
    return function(s) {
      var c = v.getParent(s);
      return c != null && v.isTag(c) && l(s);
    };
  }
  t.filters = {
    contains: function(l, v, s) {
      var c = s.adapter;
      return function(p) {
        return l(p) && c.getText(p).includes(v);
      };
    },
    icontains: function(l, v, s) {
      var c = s.adapter, d = v.toLowerCase();
      return function(m) {
        return l(m) && c.getText(m).toLowerCase().includes(d);
      };
    },
    // Location specific methods
    "nth-child": function(l, v, s) {
      var c = s.adapter, d = s.equals, p = (0, a.default)(v);
      return p === u.default.falseFunc ? u.default.falseFunc : p === u.default.trueFunc ? h(l, c) : function(E) {
        for (var y = c.getSiblings(E), g = 0, C = 0; C < y.length && !d(E, y[C]); C++)
          c.isTag(y[C]) && g++;
        return p(g) && l(E);
      };
    },
    "nth-last-child": function(l, v, s) {
      var c = s.adapter, d = s.equals, p = (0, a.default)(v);
      return p === u.default.falseFunc ? u.default.falseFunc : p === u.default.trueFunc ? h(l, c) : function(E) {
        for (var y = c.getSiblings(E), g = 0, C = y.length - 1; C >= 0 && !d(E, y[C]); C--)
          c.isTag(y[C]) && g++;
        return p(g) && l(E);
      };
    },
    "nth-of-type": function(l, v, s) {
      var c = s.adapter, d = s.equals, p = (0, a.default)(v);
      return p === u.default.falseFunc ? u.default.falseFunc : p === u.default.trueFunc ? h(l, c) : function(E) {
        for (var y = c.getSiblings(E), g = 0, C = 0; C < y.length; C++) {
          var O = y[C];
          if (d(E, O))
            break;
          c.isTag(O) && c.getName(O) === c.getName(E) && g++;
        }
        return p(g) && l(E);
      };
    },
    "nth-last-of-type": function(l, v, s) {
      var c = s.adapter, d = s.equals, p = (0, a.default)(v);
      return p === u.default.falseFunc ? u.default.falseFunc : p === u.default.trueFunc ? h(l, c) : function(E) {
        for (var y = c.getSiblings(E), g = 0, C = y.length - 1; C >= 0; C--) {
          var O = y[C];
          if (d(E, O))
            break;
          c.isTag(O) && c.getName(O) === c.getName(E) && g++;
        }
        return p(g) && l(E);
      };
    },
    // TODO determine the actual root element
    root: function(l, v, s) {
      var c = s.adapter;
      return function(d) {
        var p = c.getParent(d);
        return (p == null || !c.isTag(p)) && l(d);
      };
    },
    scope: function(l, v, s, c) {
      var d = s.equals;
      return !c || c.length === 0 ? t.filters.root(l, v, s) : c.length === 1 ? function(p) {
        return d(c[0], p) && l(p);
      } : function(p) {
        return c.includes(p) && l(p);
      };
    },
    hover: b("isHovered"),
    visited: b("isVisited"),
    active: b("isActive")
  };
  function b(l) {
    return function(s, c, d) {
      var p = d.adapter, m = p[l];
      return typeof m != "function" ? u.default.falseFunc : function(y) {
        return m(y) && s(y);
      };
    };
  }
})(tV);
var Cm = {};
Object.defineProperty(Cm, "__esModule", { value: !0 });
Cm.verifyPseudoArgs = Cm.pseudos = void 0;
Cm.pseudos = {
  empty: function(t, r) {
    var a = r.adapter;
    return !a.getChildren(t).some(function(u) {
      return a.isTag(u) || a.getText(u) !== "";
    });
  },
  "first-child": function(t, r) {
    var a = r.adapter, u = r.equals;
    if (a.prevElementSibling)
      return a.prevElementSibling(t) == null;
    var h = a.getSiblings(t).find(function(b) {
      return a.isTag(b);
    });
    return h != null && u(t, h);
  },
  "last-child": function(t, r) {
    for (var a = r.adapter, u = r.equals, h = a.getSiblings(t), b = h.length - 1; b >= 0; b--) {
      if (u(t, h[b]))
        return !0;
      if (a.isTag(h[b]))
        break;
    }
    return !1;
  },
  "first-of-type": function(t, r) {
    for (var a = r.adapter, u = r.equals, h = a.getSiblings(t), b = a.getName(t), l = 0; l < h.length; l++) {
      var v = h[l];
      if (u(t, v))
        return !0;
      if (a.isTag(v) && a.getName(v) === b)
        break;
    }
    return !1;
  },
  "last-of-type": function(t, r) {
    for (var a = r.adapter, u = r.equals, h = a.getSiblings(t), b = a.getName(t), l = h.length - 1; l >= 0; l--) {
      var v = h[l];
      if (u(t, v))
        return !0;
      if (a.isTag(v) && a.getName(v) === b)
        break;
    }
    return !1;
  },
  "only-of-type": function(t, r) {
    var a = r.adapter, u = r.equals, h = a.getName(t);
    return a.getSiblings(t).every(function(b) {
      return u(t, b) || !a.isTag(b) || a.getName(b) !== h;
    });
  },
  "only-child": function(t, r) {
    var a = r.adapter, u = r.equals;
    return a.getSiblings(t).every(function(h) {
      return u(t, h) || !a.isTag(h);
    });
  }
};
function Iye(t, r, a, u) {
  if (a === null) {
    if (t.length > u)
      throw new Error("Pseudo-class :".concat(r, " requires an argument"));
  } else if (t.length === u)
    throw new Error("Pseudo-class :".concat(r, " doesn't have any arguments"));
}
Cm.verifyPseudoArgs = Iye;
var gA = {};
Object.defineProperty(gA, "__esModule", { value: !0 });
gA.aliases = void 0;
gA.aliases = {
  // Links
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  // Forms
  // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
  disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  // JQuery extensions
  // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
};
var mA = {};
(function(t) {
  var r = rn && rn.__spreadArray || function(c, d, p) {
    if (p || arguments.length === 2) for (var m = 0, E = d.length, y; m < E; m++)
      (y || !(m in d)) && (y || (y = Array.prototype.slice.call(d, 0, m)), y[m] = d[m]);
    return c.concat(y || Array.prototype.slice.call(d));
  }, a = rn && rn.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.subselects = t.getNextSiblings = t.ensureIsTag = t.PLACEHOLDER_ELEMENT = void 0;
  var u = a(vh), h = Fm;
  t.PLACEHOLDER_ELEMENT = {};
  function b(c, d) {
    return c === u.default.falseFunc ? u.default.falseFunc : function(p) {
      return d.isTag(p) && c(p);
    };
  }
  t.ensureIsTag = b;
  function l(c, d) {
    var p = d.getSiblings(c);
    if (p.length <= 1)
      return [];
    var m = p.indexOf(c);
    return m < 0 || m === p.length - 1 ? [] : p.slice(m + 1).filter(d.isTag);
  }
  t.getNextSiblings = l;
  function v(c) {
    return {
      xmlMode: !!c.xmlMode,
      lowerCaseAttributeNames: !!c.lowerCaseAttributeNames,
      lowerCaseTags: !!c.lowerCaseTags,
      quirksMode: !!c.quirksMode,
      cacheResults: !!c.cacheResults,
      pseudos: c.pseudos,
      adapter: c.adapter,
      equals: c.equals
    };
  }
  var s = function(c, d, p, m, E) {
    var y = E(d, v(p), m);
    return y === u.default.trueFunc ? c : y === u.default.falseFunc ? u.default.falseFunc : function(g) {
      return y(g) && c(g);
    };
  };
  t.subselects = {
    is: s,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */
    matches: s,
    where: s,
    not: function(c, d, p, m, E) {
      var y = E(d, v(p), m);
      return y === u.default.falseFunc ? c : y === u.default.trueFunc ? u.default.falseFunc : function(g) {
        return !y(g) && c(g);
      };
    },
    has: function(c, d, p, m, E) {
      var y = p.adapter, g = v(p);
      g.relativeSelector = !0;
      var C = d.some(function(I) {
        return I.some(h.isTraversal);
      }) ? (
        // Used as a placeholder. Will be replaced with the actual element.
        [t.PLACEHOLDER_ELEMENT]
      ) : void 0, O = E(d, g, C);
      if (O === u.default.falseFunc)
        return u.default.falseFunc;
      var N = b(O, y);
      if (C && O !== u.default.trueFunc) {
        var w = O.shouldTestNextSiblings, _ = w === void 0 ? !1 : w;
        return function(I) {
          if (!c(I))
            return !1;
          C[0] = I;
          var k = y.getChildren(I), H = _ ? r(r([], k, !0), l(I, y), !0) : k;
          return y.existsOne(N, H);
        };
      }
      return function(I) {
        return c(I) && y.existsOne(N, y.getChildren(I));
      };
    }
  };
})(mA);
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.compilePseudoSelector = t.aliases = t.pseudos = t.filters = void 0;
  var r = Nv, a = tV;
  Object.defineProperty(t, "filters", { enumerable: !0, get: function() {
    return a.filters;
  } });
  var u = Cm;
  Object.defineProperty(t, "pseudos", { enumerable: !0, get: function() {
    return u.pseudos;
  } });
  var h = gA;
  Object.defineProperty(t, "aliases", { enumerable: !0, get: function() {
    return h.aliases;
  } });
  var b = mA;
  function l(v, s, c, d, p) {
    var m, E = s.name, y = s.data;
    if (Array.isArray(y)) {
      if (!(E in b.subselects))
        throw new Error("Unknown pseudo-class :".concat(E, "(").concat(y, ")"));
      return b.subselects[E](v, y, c, d, p);
    }
    var g = (m = c.pseudos) === null || m === void 0 ? void 0 : m[E], C = typeof g == "string" ? g : h.aliases[E];
    if (typeof C == "string") {
      if (y != null)
        throw new Error("Pseudo ".concat(E, " doesn't have any arguments"));
      var O = (0, r.parse)(C);
      return b.subselects.is(v, O, c, d, p);
    }
    if (typeof g == "function")
      return (0, u.verifyPseudoArgs)(g, E, y, 1), function(w) {
        return g(w, y) && v(w);
      };
    if (E in a.filters)
      return a.filters[E](v, y, c, d);
    if (E in u.pseudos) {
      var N = u.pseudos[E];
      return (0, u.verifyPseudoArgs)(N, E, y, 2), function(w) {
        return N(w, c, y) && v(w);
      };
    }
    throw new Error("Unknown pseudo-class :".concat(E));
  }
  t.compilePseudoSelector = l;
})(Dw);
Object.defineProperty(fA, "__esModule", { value: !0 });
fA.compileGeneralSelector = void 0;
var Rye = hA, Nye = Dw, Vc = Nv;
function GR(t, r) {
  var a = r.getParent(t);
  return a && r.isTag(a) ? a : null;
}
function wye(t, r, a, u, h) {
  var b = a.adapter, l = a.equals;
  switch (r.type) {
    case Vc.SelectorType.PseudoElement:
      throw new Error("Pseudo-elements are not supported by css-select");
    case Vc.SelectorType.ColumnCombinator:
      throw new Error("Column combinators are not yet supported by css-select");
    case Vc.SelectorType.Attribute: {
      if (r.namespace != null)
        throw new Error("Namespaced attributes are not yet supported by css-select");
      return (!a.xmlMode || a.lowerCaseAttributeNames) && (r.name = r.name.toLowerCase()), Rye.attributeRules[r.action](t, r, a);
    }
    case Vc.SelectorType.Pseudo:
      return (0, Nye.compilePseudoSelector)(t, r, a, u, h);
    case Vc.SelectorType.Tag: {
      if (r.namespace != null)
        throw new Error("Namespaced tag names are not yet supported by css-select");
      var v = r.name;
      return (!a.xmlMode || a.lowerCaseTags) && (v = v.toLowerCase()), function(d) {
        return b.getName(d) === v && t(d);
      };
    }
    case Vc.SelectorType.Descendant: {
      if (a.cacheResults === !1 || typeof WeakSet > "u")
        return function(d) {
          for (var p = d; p = GR(p, b); )
            if (t(p))
              return !0;
          return !1;
        };
      var s = /* @__PURE__ */ new WeakSet();
      return function(d) {
        for (var p = d; p = GR(p, b); )
          if (!s.has(p)) {
            if (b.isTag(p) && t(p))
              return !0;
            s.add(p);
          }
        return !1;
      };
    }
    case "_flexibleDescendant":
      return function(d) {
        var p = d;
        do
          if (t(p))
            return !0;
        while (p = GR(p, b));
        return !1;
      };
    case Vc.SelectorType.Parent:
      return function(d) {
        return b.getChildren(d).some(function(p) {
          return b.isTag(p) && t(p);
        });
      };
    case Vc.SelectorType.Child:
      return function(d) {
        var p = b.getParent(d);
        return p != null && b.isTag(p) && t(p);
      };
    case Vc.SelectorType.Sibling:
      return function(d) {
        for (var p = b.getSiblings(d), m = 0; m < p.length; m++) {
          var E = p[m];
          if (l(d, E))
            break;
          if (b.isTag(E) && t(E))
            return !0;
        }
        return !1;
      };
    case Vc.SelectorType.Adjacent:
      return b.prevElementSibling ? function(d) {
        var p = b.prevElementSibling(d);
        return p != null && t(p);
      } : function(d) {
        for (var p = b.getSiblings(d), m, E = 0; E < p.length; E++) {
          var y = p[E];
          if (l(d, y))
            break;
          b.isTag(y) && (m = y);
        }
        return !!m && t(m);
      };
    case Vc.SelectorType.Universal: {
      if (r.namespace != null && r.namespace !== "*")
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      return t;
    }
  }
}
fA.compileGeneralSelector = wye;
var _ye = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), Pye = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), xye = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && _ye(r, t, a);
  return Pye(r, t), r;
}, Dye = rn && rn.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Dl, "__esModule", { value: !0 });
Dl.compileToken = Dl.compileUnsafe = Dl.compile = void 0;
var wd = Nv, Pl = Dye(vh), lN = xye(Fm), Mye = fA, rV = mA;
function Lye(t, r, a) {
  var u = iV(t, r, a);
  return (0, rV.ensureIsTag)(u, r.adapter);
}
Dl.compile = Lye;
function iV(t, r, a) {
  var u = typeof t == "string" ? (0, wd.parse)(t) : t;
  return Mw(u, r, a);
}
Dl.compileUnsafe = iV;
function sV(t) {
  return t.type === wd.SelectorType.Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some(function(r) {
    return r.some(sV);
  }));
}
var kye = { type: wd.SelectorType.Descendant }, jye = {
  type: "_flexibleDescendant"
}, Uye = {
  type: wd.SelectorType.Pseudo,
  name: "scope",
  data: null
};
function Hye(t, r, a) {
  for (var u = r.adapter, h = !!(a != null && a.every(function(s) {
    var c = u.isTag(s) && u.getParent(s);
    return s === rV.PLACEHOLDER_ELEMENT || c && u.isTag(c);
  })), b = 0, l = t; b < l.length; b++) {
    var v = l[b];
    if (!(v.length > 0 && (0, lN.isTraversal)(v[0]) && v[0].type !== wd.SelectorType.Descendant)) if (h && !v.some(sV))
      v.unshift(kye);
    else
      continue;
    v.unshift(Uye);
  }
}
function Mw(t, r, a) {
  var u;
  t.forEach(lN.default), a = (u = r.context) !== null && u !== void 0 ? u : a;
  var h = Array.isArray(a), b = a && (Array.isArray(a) ? a : [a]);
  if (r.relativeSelector !== !1)
    Hye(t, r, b);
  else if (t.some(function(s) {
    return s.length > 0 && (0, lN.isTraversal)(s[0]);
  }))
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  var l = !1, v = t.map(function(s) {
    if (s.length >= 2) {
      var c = s[0], d = s[1];
      c.type !== wd.SelectorType.Pseudo || c.name !== "scope" || (h && d.type === wd.SelectorType.Descendant ? s[1] = jye : (d.type === wd.SelectorType.Adjacent || d.type === wd.SelectorType.Sibling) && (l = !0));
    }
    return Bye(s, r, b);
  }).reduce(zye, Pl.default.falseFunc);
  return v.shouldTestNextSiblings = l, v;
}
Dl.compileToken = Mw;
function Bye(t, r, a) {
  var u;
  return t.reduce(function(h, b) {
    return h === Pl.default.falseFunc ? Pl.default.falseFunc : (0, Mye.compileGeneralSelector)(h, b, r, a, Mw);
  }, (u = r.rootFunc) !== null && u !== void 0 ? u : Pl.default.trueFunc);
}
function zye(t, r) {
  return r === Pl.default.falseFunc || t === Pl.default.trueFunc ? t : t === Pl.default.falseFunc || r === Pl.default.trueFunc ? r : function(u) {
    return t(u) || r(u);
  };
}
(function(t) {
  var r = rn && rn.__createBinding || (Object.create ? function(N, w, _, I) {
    I === void 0 && (I = _);
    var k = Object.getOwnPropertyDescriptor(w, _);
    (!k || ("get" in k ? !w.__esModule : k.writable || k.configurable)) && (k = { enumerable: !0, get: function() {
      return w[_];
    } }), Object.defineProperty(N, I, k);
  } : function(N, w, _, I) {
    I === void 0 && (I = _), N[I] = w[_];
  }), a = rn && rn.__setModuleDefault || (Object.create ? function(N, w) {
    Object.defineProperty(N, "default", { enumerable: !0, value: w });
  } : function(N, w) {
    N.default = w;
  }), u = rn && rn.__importStar || function(N) {
    if (N && N.__esModule) return N;
    var w = {};
    if (N != null) for (var _ in N) _ !== "default" && Object.prototype.hasOwnProperty.call(N, _) && r(w, N, _);
    return a(w, N), w;
  }, h = rn && rn.__importDefault || function(N) {
    return N && N.__esModule ? N : { default: N };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.aliases = t.pseudos = t.filters = t.is = t.selectOne = t.selectAll = t.prepareContext = t._compileToken = t._compileUnsafe = t.compile = void 0;
  var b = u(tu), l = h(vh), v = Dl, s = mA, c = function(N, w) {
    return N === w;
  }, d = {
    adapter: b,
    equals: c
  };
  function p(N) {
    var w, _, I, k, H = N ?? d;
    return (w = H.adapter) !== null && w !== void 0 || (H.adapter = b), (_ = H.equals) !== null && _ !== void 0 || (H.equals = (k = (I = H.adapter) === null || I === void 0 ? void 0 : I.equals) !== null && k !== void 0 ? k : c), H;
  }
  function m(N) {
    return function(_, I, k) {
      var H = p(I);
      return N(_, H, k);
    };
  }
  t.compile = m(v.compile), t._compileUnsafe = m(v.compileUnsafe), t._compileToken = m(v.compileToken);
  function E(N) {
    return function(_, I, k) {
      var H = p(k);
      typeof _ != "function" && (_ = (0, v.compileUnsafe)(_, H, I));
      var S = y(I, H.adapter, _.shouldTestNextSiblings);
      return N(_, S, H);
    };
  }
  function y(N, w, _) {
    return _ === void 0 && (_ = !1), _ && (N = g(N, w)), Array.isArray(N) ? w.removeSubsets(N) : w.getChildren(N);
  }
  t.prepareContext = y;
  function g(N, w) {
    for (var _ = Array.isArray(N) ? N.slice(0) : [N], I = _.length, k = 0; k < I; k++) {
      var H = (0, s.getNextSiblings)(_[k], w);
      _.push.apply(_, H);
    }
    return _;
  }
  t.selectAll = E(function(N, w, _) {
    return N === l.default.falseFunc || !w || w.length === 0 ? [] : _.adapter.findAll(N, w);
  }), t.selectOne = E(function(N, w, _) {
    return N === l.default.falseFunc || !w || w.length === 0 ? null : _.adapter.findOne(N, w);
  });
  function C(N, w, _) {
    var I = p(_);
    return (typeof w == "function" ? w : (0, v.compile)(w, I))(N);
  }
  t.is = C, t.default = t.selectAll;
  var O = Dw;
  Object.defineProperty(t, "filters", { enumerable: !0, get: function() {
    return O.filters;
  } }), Object.defineProperty(t, "pseudos", { enumerable: !0, get: function() {
    return O.pseudos;
  } }), Object.defineProperty(t, "aliases", { enumerable: !0, get: function() {
    return O.aliases;
  } });
})(dN);
var Sm = {}, Lw = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getLimit = t.isFilter = t.filterNames = void 0, t.filterNames = /* @__PURE__ */ new Set([
    "first",
    "last",
    "eq",
    "gt",
    "nth",
    "lt",
    "even",
    "odd"
  ]);
  function r(u) {
    return u.type !== "pseudo" ? !1 : t.filterNames.has(u.name) ? !0 : u.name === "not" && Array.isArray(u.data) ? u.data.some(function(h) {
      return h.some(r);
    }) : !1;
  }
  t.isFilter = r;
  function a(u, h, b) {
    var l = h != null ? parseInt(h, 10) : NaN;
    switch (u) {
      case "first":
        return 1;
      case "nth":
      case "eq":
        return isFinite(l) ? l >= 0 ? l + 1 : 1 / 0 : 0;
      case "lt":
        return isFinite(l) ? l >= 0 ? Math.min(l, b) : 1 / 0 : 0;
      case "gt":
        return isFinite(l) ? 1 / 0 : 0;
      case "odd":
        return 2 * b;
      case "even":
        return 2 * b - 1;
      case "last":
      case "not":
        return 1 / 0;
    }
  }
  t.getLimit = a;
})(Lw);
Object.defineProperty(Sm, "__esModule", { value: !0 });
Sm.groupSelectors = Sm.getDocumentRoot = void 0;
var Fye = Lw;
function Gye(t) {
  for (; t.parent; )
    t = t.parent;
  return t;
}
Sm.getDocumentRoot = Gye;
function Vye(t) {
  for (var r = [], a = [], u = 0, h = t; u < h.length; u++) {
    var b = h[u];
    b.some(Fye.isFilter) ? r.push(b) : a.push(b);
  }
  return [a, r];
}
Sm.groupSelectors = Vye;
(function(t) {
  var r = rn && rn.__assign || function() {
    return r = Object.assign || function(D) {
      for (var F, j = 1, G = arguments.length; j < G; j++) {
        F = arguments[j];
        for (var U in F) Object.prototype.hasOwnProperty.call(F, U) && (D[U] = F[U]);
      }
      return D;
    }, r.apply(this, arguments);
  }, a = rn && rn.__createBinding || (Object.create ? function(D, F, j, G) {
    G === void 0 && (G = j);
    var U = Object.getOwnPropertyDescriptor(F, j);
    (!U || ("get" in U ? !F.__esModule : U.writable || U.configurable)) && (U = { enumerable: !0, get: function() {
      return F[j];
    } }), Object.defineProperty(D, G, U);
  } : function(D, F, j, G) {
    G === void 0 && (G = j), D[G] = F[j];
  }), u = rn && rn.__setModuleDefault || (Object.create ? function(D, F) {
    Object.defineProperty(D, "default", { enumerable: !0, value: F });
  } : function(D, F) {
    D.default = F;
  }), h = rn && rn.__importStar || function(D) {
    if (D && D.__esModule) return D;
    var F = {};
    if (D != null) for (var j in D) j !== "default" && Object.prototype.hasOwnProperty.call(D, j) && a(F, D, j);
    return u(F, D), F;
  }, b = rn && rn.__spreadArray || function(D, F, j) {
    if (j || arguments.length === 2) for (var G = 0, U = F.length, M; G < U; G++)
      (M || !(G in F)) && (M || (M = Array.prototype.slice.call(F, 0, G)), M[G] = F[G]);
    return D.concat(M || Array.prototype.slice.call(F));
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.select = t.filter = t.some = t.is = t.aliases = t.pseudos = t.filters = void 0;
  var l = Nv, v = dN, s = h(tu), c = h(vh), d = Sm, p = Lw, m = dN;
  Object.defineProperty(t, "filters", { enumerable: !0, get: function() {
    return m.filters;
  } }), Object.defineProperty(t, "pseudos", { enumerable: !0, get: function() {
    return m.pseudos;
  } }), Object.defineProperty(t, "aliases", { enumerable: !0, get: function() {
    return m.aliases;
  } });
  var E = {
    type: l.SelectorType.Universal,
    namespace: null
  }, y = {
    type: l.SelectorType.Pseudo,
    name: "scope",
    data: null
  };
  function g(D, F, j) {
    return j === void 0 && (j = {}), C([D], F, j);
  }
  t.is = g;
  function C(D, F, j) {
    if (j === void 0 && (j = {}), typeof F == "function")
      return D.some(F);
    var G = (0, d.groupSelectors)((0, l.parse)(F)), U = G[0], M = G[1];
    return U.length > 0 && D.some((0, v._compileToken)(U, j)) || M.some(function(V) {
      return _(V, D, j).length > 0;
    });
  }
  t.some = C;
  function O(D, F, j, G) {
    var U = typeof j == "string" ? parseInt(j, 10) : NaN;
    switch (D) {
      case "first":
      case "lt":
        return F;
      case "last":
        return F.length > 0 ? [F[F.length - 1]] : F;
      case "nth":
      case "eq":
        return isFinite(U) && Math.abs(U) < F.length ? [U < 0 ? F[F.length + U] : F[U]] : [];
      case "gt":
        return isFinite(U) ? F.slice(U + 1) : [];
      case "even":
        return F.filter(function(V, J) {
          return J % 2 === 0;
        });
      case "odd":
        return F.filter(function(V, J) {
          return J % 2 === 1;
        });
      case "not": {
        var M = new Set(w(j, F, G));
        return F.filter(function(V) {
          return !M.has(V);
        });
      }
    }
  }
  function N(D, F, j) {
    return j === void 0 && (j = {}), w((0, l.parse)(D), F, j);
  }
  t.filter = N;
  function w(D, F, j) {
    if (F.length === 0)
      return [];
    var G = (0, d.groupSelectors)(D), U = G[0], M = G[1], V;
    if (U.length) {
      var J = B(F, U, j);
      if (M.length === 0)
        return J;
      J.length && (V = new Set(J));
    }
    for (var ue = 0; ue < M.length && (V == null ? void 0 : V.size) !== F.length; ue++) {
      var se = M[ue], ee = V ? F.filter(function(he) {
        return s.isTag(he) && !V.has(he);
      }) : F;
      if (ee.length === 0)
        break;
      var J = _(se, F, j);
      if (J.length)
        if (V)
          J.forEach(function(he) {
            return V.add(he);
          });
        else {
          if (ue === M.length - 1)
            return J;
          V = new Set(J);
        }
    }
    return typeof V < "u" ? V.size === F.length ? F : (
      // Filter elements to preserve order
      F.filter(function(de) {
        return V.has(de);
      })
    ) : [];
  }
  function _(D, F, j) {
    var G;
    if (D.some(l.isTraversal)) {
      var U = (G = j.root) !== null && G !== void 0 ? G : (0, d.getDocumentRoot)(F[0]), M = r(r({}, j), { context: F, relativeSelector: !1 });
      return D.push(y), k(U, D, M, !0, F.length);
    }
    return k(F, D, j, !1, F.length);
  }
  function I(D, F, j, G) {
    if (j === void 0 && (j = {}), G === void 0 && (G = 1 / 0), typeof D == "function")
      return S(F, D);
    var U = (0, d.groupSelectors)((0, l.parse)(D)), M = U[0], V = U[1], J = V.map(function(ue) {
      return k(F, ue, j, !0, G);
    });
    return M.length && J.push(H(F, M, j, G)), J.length === 0 ? [] : J.length === 1 ? J[0] : s.uniqueSort(J.reduce(function(ue, se) {
      return b(b([], ue, !0), se, !0);
    }));
  }
  t.select = I;
  function k(D, F, j, G, U) {
    var M = F.findIndex(p.isFilter), V = F.slice(0, M), J = F[M], ue = F.length - 1 === M ? U : 1 / 0, se = (0, p.getLimit)(J.name, J.data, ue);
    if (se === 0)
      return [];
    var ee = V.length === 0 && !Array.isArray(D) ? s.getChildren(D).filter(s.isTag) : V.length === 0 ? (Array.isArray(D) ? D : [D]).filter(s.isTag) : G || V.some(l.isTraversal) ? H(D, [V], j, se) : B(D, [V], j), de = ee.slice(0, se), he = O(J.name, de, J.data, j);
    if (he.length === 0 || F.length === M + 1)
      return he;
    var pe = F.slice(M + 1), Ce = pe.some(l.isTraversal);
    if (Ce) {
      if ((0, l.isTraversal)(pe[0])) {
        var _e = pe[0].type;
        (_e === l.SelectorType.Sibling || _e === l.SelectorType.Adjacent) && (he = (0, v.prepareContext)(he, s, !0)), pe.unshift(E);
      }
      j = r(r({}, j), {
        // Avoid absolutizing the selector
        relativeSelector: !1,
        /*
         * Add a custom root func, to make sure traversals don't match elements
         * that aren't a part of the considered tree.
         */
        rootFunc: function(Le) {
          return he.includes(Le);
        }
      });
    } else j.rootFunc && j.rootFunc !== c.trueFunc && (j = r(r({}, j), { rootFunc: c.trueFunc }));
    return pe.some(p.isFilter) ? k(he, pe, j, !1, U) : Ce ? (
      // Query existing elements to resolve traversal.
      H(he, [pe], j, U)
    ) : (
      // If we don't have any more traversals, simply filter elements.
      B(he, [pe], j)
    );
  }
  function H(D, F, j, G) {
    var U = (0, v._compileToken)(F, j, D);
    return S(D, U, G);
  }
  function S(D, F, j) {
    j === void 0 && (j = 1 / 0);
    var G = (0, v.prepareContext)(D, s, F.shouldTestNextSiblings);
    return s.find(function(U) {
      return s.isTag(U) && F(U);
    }, G, !0, j);
  }
  function B(D, F, j) {
    var G = (Array.isArray(D) ? D : [D]).filter(s.isTag);
    if (G.length === 0)
      return G;
    var U = (0, v._compileToken)(F, j);
    return U === c.trueFunc ? G : G.filter(U);
  }
})(XG);
var Yye = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), Xye = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), Wye = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && Yye(r, t, a);
  return Xye(r, t), r;
}, fN = rn && rn.__spreadArray || function(t, r, a) {
  if (a || arguments.length === 2) for (var u = 0, h = r.length, b; u < h; u++)
    (b || !(u in r)) && (b || (b = Array.prototype.slice.call(r, 0, u)), b[u] = r[u]);
  return t.concat(b || Array.prototype.slice.call(r));
};
Object.defineProperty(qn, "__esModule", { value: !0 });
qn.addBack = qn.add = qn.end = qn.slice = qn.index = qn.toArray = qn.get = qn.eq = qn.last = qn.first = qn.has = qn.not = qn.is = qn.filterArray = qn.filter = qn.map = qn.each = qn.contents = qn.children = qn.siblings = qn.prevUntil = qn.prevAll = qn.prev = qn.nextUntil = qn.nextAll = qn.next = qn.closest = qn.parentsUntil = qn.parents = qn.parent = qn.find = void 0;
var EA = Ma, Gm = Wye(XG), iu = yh, qye = Ls, Vu = tu, Kye = /^\s*[~+]/;
function Jye(t) {
  var r;
  if (!t)
    return this._make([]);
  var a = this.toArray();
  if (typeof t != "string") {
    var u = (0, iu.isCheerio)(t) ? t.toArray() : [t];
    return this._make(u.filter(function(l) {
      return a.some(function(v) {
        return (0, qye.contains)(v, l);
      });
    }));
  }
  var h = Kye.test(t) ? a : this.children().toArray(), b = {
    context: a,
    root: (r = this._root) === null || r === void 0 ? void 0 : r[0],
    // Pass options that are recognized by `cheerio-select`
    xmlMode: this.options.xmlMode,
    lowerCaseTags: this.options.lowerCaseTags,
    lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
    pseudos: this.options.pseudos,
    quirksMode: this.options.quirksMode
  };
  return this._make(Gm.select(t, h, b));
}
qn.find = Jye;
function kw(t) {
  return function(r) {
    for (var a = [], u = 1; u < arguments.length; u++)
      a[u - 1] = arguments[u];
    return function(h) {
      var b, l = t(r, this);
      return h && (l = Hw(l, h, this.options.xmlMode, (b = this._root) === null || b === void 0 ? void 0 : b[0])), this._make(
        // Post processing is only necessary if there is more than one element.
        this.length > 1 && l.length > 1 ? a.reduce(function(v, s) {
          return s(v);
        }, l) : l
      );
    };
  };
}
var wv = kw(function(t, r) {
  for (var a, u = [], h = 0; h < r.length; h++) {
    var b = t(r[h]);
    u.push(b);
  }
  return (a = new Array()).concat.apply(a, u);
}), jw = kw(function(t, r) {
  for (var a = [], u = 0; u < r.length; u++) {
    var h = t(r[u]);
    h !== null && a.push(h);
  }
  return a;
});
function Uw(t) {
  for (var r = [], a = 1; a < arguments.length; a++)
    r[a - 1] = arguments[a];
  var u = null, h = kw(function(b, l) {
    var v = [];
    return (0, iu.domEach)(l, function(s) {
      for (var c; (c = b(s)) && !(u != null && u(c, v.length)); s = c)
        v.push(c);
    }), v;
  }).apply(void 0, fN([t], r, !1));
  return function(b, l) {
    var v = this;
    u = typeof b == "string" ? function(c) {
      return Gm.is(c, b, v.options);
    } : b ? _v(b) : null;
    var s = h.call(this, l);
    return u = null, s;
  };
}
function Vm(t) {
  return Array.from(new Set(t));
}
qn.parent = jw(function(t) {
  var r = t.parent;
  return r && !(0, EA.isDocument)(r) ? r : null;
}, Vm);
qn.parents = wv(function(t) {
  for (var r = []; t.parent && !(0, EA.isDocument)(t.parent); )
    r.push(t.parent), t = t.parent;
  return r;
}, Vu.uniqueSort, function(t) {
  return t.reverse();
});
qn.parentsUntil = Uw(function(t) {
  var r = t.parent;
  return r && !(0, EA.isDocument)(r) ? r : null;
}, Vu.uniqueSort, function(t) {
  return t.reverse();
});
function Zye(t) {
  var r, a = [];
  if (!t)
    return this._make(a);
  var u = {
    xmlMode: this.options.xmlMode,
    root: (r = this._root) === null || r === void 0 ? void 0 : r[0]
  }, h = typeof t == "string" ? function(b) {
    return Gm.is(b, t, u);
  } : _v(t);
  return (0, iu.domEach)(this, function(b) {
    for (; b && (0, iu.isTag)(b); ) {
      if (h(b, 0)) {
        a.includes(b) || a.push(b);
        break;
      }
      b = b.parent;
    }
  }), this._make(a);
}
qn.closest = Zye;
qn.next = jw(function(t) {
  return (0, Vu.nextElementSibling)(t);
});
qn.nextAll = wv(function(t) {
  for (var r = []; t.next; )
    t = t.next, (0, iu.isTag)(t) && r.push(t);
  return r;
}, Vm);
qn.nextUntil = Uw(function(t) {
  return (0, Vu.nextElementSibling)(t);
}, Vm);
qn.prev = jw(function(t) {
  return (0, Vu.prevElementSibling)(t);
});
qn.prevAll = wv(function(t) {
  for (var r = []; t.prev; )
    t = t.prev, (0, iu.isTag)(t) && r.push(t);
  return r;
}, Vm);
qn.prevUntil = Uw(function(t) {
  return (0, Vu.prevElementSibling)(t);
}, Vm);
qn.siblings = wv(function(t) {
  return (0, Vu.getSiblings)(t).filter(function(r) {
    return (0, iu.isTag)(r) && r !== t;
  });
}, Vu.uniqueSort);
qn.children = wv(function(t) {
  return (0, Vu.getChildren)(t).filter(iu.isTag);
}, Vm);
function Qye() {
  var t = this.toArray().reduce(function(r, a) {
    return (0, EA.hasChildren)(a) ? r.concat(a.children) : r;
  }, []);
  return this._make(t);
}
qn.contents = Qye;
function $ye(t) {
  for (var r = 0, a = this.length; r < a && t.call(this[r], r, this[r]) !== !1; )
    ++r;
  return this;
}
qn.each = $ye;
function eve(t) {
  for (var r = [], a = 0; a < this.length; a++) {
    var u = this[a], h = t.call(u, a, u);
    h != null && (r = r.concat(h));
  }
  return this._make(r);
}
qn.map = eve;
function _v(t) {
  return typeof t == "function" ? function(r, a) {
    return t.call(r, a, r);
  } : (0, iu.isCheerio)(t) ? function(r) {
    return Array.prototype.includes.call(t, r);
  } : function(r) {
    return t === r;
  };
}
function tve(t) {
  var r;
  return this._make(Hw(this.toArray(), t, this.options.xmlMode, (r = this._root) === null || r === void 0 ? void 0 : r[0]));
}
qn.filter = tve;
function Hw(t, r, a, u) {
  return typeof r == "string" ? Gm.filter(r, t, { xmlMode: a, root: u }) : t.filter(_v(r));
}
qn.filterArray = Hw;
function nve(t) {
  var r = this.toArray();
  return typeof t == "string" ? Gm.some(r.filter(iu.isTag), t, this.options) : t ? r.some(_v(t)) : !1;
}
qn.is = nve;
function rve(t) {
  var r = this.toArray();
  if (typeof t == "string") {
    var a = new Set(Gm.filter(t, r, this.options));
    r = r.filter(function(h) {
      return !a.has(h);
    });
  } else {
    var u = _v(t);
    r = r.filter(function(h, b) {
      return !u(h, b);
    });
  }
  return this._make(r);
}
qn.not = rve;
function ive(t) {
  var r = this;
  return this.filter(typeof t == "string" ? (
    // Using the `:has` selector here short-circuits searches.
    ":has(".concat(t, ")")
  ) : function(a, u) {
    return r._make(u).find(t).length > 0;
  });
}
qn.has = ive;
function sve() {
  return this.length > 1 ? this._make(this[0]) : this;
}
qn.first = sve;
function ave() {
  return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
qn.last = ave;
function ove(t) {
  var r;
  return t = +t, t === 0 && this.length <= 1 ? this : (t < 0 && (t = this.length + t), this._make((r = this[t]) !== null && r !== void 0 ? r : []));
}
qn.eq = ove;
function cve(t) {
  return t == null ? this.toArray() : this[t < 0 ? this.length + t : t];
}
qn.get = cve;
function uve() {
  return Array.prototype.slice.call(this);
}
qn.toArray = uve;
function dve(t) {
  var r, a;
  return t == null ? (r = this.parent().children(), a = this[0]) : typeof t == "string" ? (r = this._make(t), a = this[0]) : (r = this, a = (0, iu.isCheerio)(t) ? t[0] : t), Array.prototype.indexOf.call(r, a);
}
qn.index = dve;
function lve(t, r) {
  return this._make(Array.prototype.slice.call(this, t, r));
}
qn.slice = lve;
function fve() {
  var t;
  return (t = this.prevObject) !== null && t !== void 0 ? t : this._make([]);
}
qn.end = fve;
function hve(t, r) {
  var a = this._make(t, r), u = (0, Vu.uniqueSort)(fN(fN([], this.get(), !0), a.get(), !0));
  return this._make(u);
}
qn.add = hve;
function pve(t) {
  return this.prevObject ? this.add(t ? this.prevObject.filter(t) : this.prevObject) : this;
}
qn.addBack = pve;
var Lr = {}, uh = {};
Object.defineProperty(uh, "__esModule", { value: !0 });
uh.update = uh.getParse = void 0;
var gve = tu, UU = Ma;
function mve(t) {
  return function(a, u, h, b) {
    if (typeof Buffer < "u" && Buffer.isBuffer(a) && (a = a.toString()), typeof a == "string")
      return t(a, u, h, b);
    var l = a;
    if (!Array.isArray(l) && (0, UU.isDocument)(l))
      return l;
    var v = new UU.Document([]);
    return aV(l, v), v;
  };
}
uh.getParse = mve;
function aV(t, r) {
  var a = Array.isArray(t) ? t : [t];
  r ? r.children = a : r = null;
  for (var u = 0; u < a.length; u++) {
    var h = a[u];
    h.parent && h.parent.children !== a && (0, gve.removeElement)(h), r ? (h.prev = a[u - 1] || null, h.next = a[u + 1] || null) : h.prev = h.next = null, h.parent = r;
  }
  return r;
}
uh.update = aV;
var Eve = rn && rn.__spreadArray || function(t, r, a) {
  if (a || arguments.length === 2) for (var u = 0, h = r.length, b; u < h; u++)
    (b || !(u in r)) && (b || (b = Array.prototype.slice.call(r, 0, u)), b[u] = r[u]);
  return t.concat(b || Array.prototype.slice.call(r));
};
Object.defineProperty(Lr, "__esModule", { value: !0 });
Lr.clone = Lr.text = Lr.toString = Lr.html = Lr.empty = Lr.replaceWith = Lr.remove = Lr.insertBefore = Lr.before = Lr.insertAfter = Lr.after = Lr.wrapAll = Lr.unwrap = Lr.wrapInner = Lr.wrap = Lr.prepend = Lr.append = Lr.prependTo = Lr.appendTo = Lr._makeDomArray = void 0;
var Yu = Ma, Im = uh, HU = Ls, Qs = yh, yve = tu;
function vve(t, r) {
  var a = this;
  return t == null ? [] : (0, Qs.isCheerio)(t) ? r ? (0, Qs.cloneDom)(t.get()) : t.get() : Array.isArray(t) ? t.reduce(function(u, h) {
    return u.concat(a._makeDomArray(h, r));
  }, []) : typeof t == "string" ? this._parse(t, this.options, !1, null).children : r ? (0, Qs.cloneDom)([t]) : [t];
}
Lr._makeDomArray = vve;
function oV(t) {
  return function() {
    for (var r = this, a = [], u = 0; u < arguments.length; u++)
      a[u] = arguments[u];
    var h = this.length - 1;
    return (0, Qs.domEach)(this, function(b, l) {
      if ((0, Yu.hasChildren)(b)) {
        var v = typeof a[0] == "function" ? a[0].call(b, l, r._render(b.children)) : a, s = r._makeDomArray(v, l < h);
        t(s, b.children, b);
      }
    });
  };
}
function Jl(t, r, a, u, h) {
  for (var b, l, v = Eve([
    r,
    a
  ], u, !0), s = r === 0 ? null : t[r - 1], c = r + a >= t.length ? null : t[r + a], d = 0; d < u.length; ++d) {
    var p = u[d], m = p.parent;
    if (m) {
      var E = m.children, y = E.indexOf(p);
      y > -1 && (m.children.splice(y, 1), h === m && r > y && v[0]--);
    }
    p.parent = h, p.prev && (p.prev.next = (b = p.next) !== null && b !== void 0 ? b : null), p.next && (p.next.prev = (l = p.prev) !== null && l !== void 0 ? l : null), p.prev = d === 0 ? s : u[d - 1], p.next = d === u.length - 1 ? c : u[d + 1];
  }
  return s && (s.next = u[0]), c && (c.prev = u[u.length - 1]), t.splice.apply(t, v);
}
function Tve(t) {
  var r = (0, Qs.isCheerio)(t) ? t : this._make(t);
  return r.append(this), this;
}
Lr.appendTo = Tve;
function bve(t) {
  var r = (0, Qs.isCheerio)(t) ? t : this._make(t);
  return r.prepend(this), this;
}
Lr.prependTo = bve;
Lr.append = oV(function(t, r, a) {
  Jl(r, r.length, 0, t, a);
});
Lr.prepend = oV(function(t, r, a) {
  Jl(r, 0, 0, t, a);
});
function cV(t) {
  return function(r) {
    for (var a = this.length - 1, u = this.parents().last(), h = 0; h < this.length; h++) {
      var b = this[h], l = typeof r == "function" ? r.call(b, h, b) : typeof r == "string" && !(0, Qs.isHtml)(r) ? u.find(r).clone() : r, v = this._makeDomArray(l, h < a)[0];
      if (!(!v || !(0, Yu.hasChildren)(v))) {
        for (var s = v, c = 0; c < s.children.length; ) {
          var d = s.children[c];
          (0, Qs.isTag)(d) ? (s = d, c = 0) : c++;
        }
        t(b, s, [v]);
      }
    }
    return this;
  };
}
Lr.wrap = cV(function(t, r, a) {
  var u = t.parent;
  if (u) {
    var h = u.children, b = h.indexOf(t);
    (0, Im.update)([t], r), Jl(h, b, 0, a, u);
  }
});
Lr.wrapInner = cV(function(t, r, a) {
  (0, Yu.hasChildren)(t) && ((0, Im.update)(t.children, r), (0, Im.update)(a, t));
});
function Ave(t) {
  var r = this;
  return this.parent(t).not("body").each(function(a, u) {
    r._make(u).replaceWith(u.children);
  }), this;
}
Lr.unwrap = Ave;
function Ove(t) {
  var r = this[0];
  if (r) {
    for (var a = this._make(typeof t == "function" ? t.call(r, 0, r) : t).insertBefore(r), u = void 0, h = 0; h < a.length; h++)
      a[h].type === "tag" && (u = a[h]);
    for (var b = 0; u && b < u.children.length; ) {
      var l = u.children[b];
      l.type === "tag" ? (u = l, b = 0) : b++;
    }
    u && this._make(u).append(this);
  }
  return this;
}
Lr.wrapAll = Ove;
function Cve() {
  for (var t = this, r = [], a = 0; a < arguments.length; a++)
    r[a] = arguments[a];
  var u = this.length - 1;
  return (0, Qs.domEach)(this, function(h, b) {
    var l = h.parent;
    if (!(!(0, Yu.hasChildren)(h) || !l)) {
      var v = l.children, s = v.indexOf(h);
      if (!(s < 0)) {
        var c = typeof r[0] == "function" ? r[0].call(h, b, t._render(h.children)) : r, d = t._makeDomArray(c, b < u);
        Jl(v, s + 1, 0, d, l);
      }
    }
  });
}
Lr.after = Cve;
function Sve(t) {
  var r = this;
  typeof t == "string" && (t = this._make(t)), this.remove();
  var a = [];
  return this._makeDomArray(t).forEach(function(u) {
    var h = r.clone().toArray(), b = u.parent;
    if (b) {
      var l = b.children, v = l.indexOf(u);
      v < 0 || (Jl(l, v + 1, 0, h, b), a.push.apply(a, h));
    }
  }), this._make(a);
}
Lr.insertAfter = Sve;
function Ive() {
  for (var t = this, r = [], a = 0; a < arguments.length; a++)
    r[a] = arguments[a];
  var u = this.length - 1;
  return (0, Qs.domEach)(this, function(h, b) {
    var l = h.parent;
    if (!(!(0, Yu.hasChildren)(h) || !l)) {
      var v = l.children, s = v.indexOf(h);
      if (!(s < 0)) {
        var c = typeof r[0] == "function" ? r[0].call(h, b, t._render(h.children)) : r, d = t._makeDomArray(c, b < u);
        Jl(v, s, 0, d, l);
      }
    }
  });
}
Lr.before = Ive;
function Rve(t) {
  var r = this, a = this._make(t);
  this.remove();
  var u = [];
  return (0, Qs.domEach)(a, function(h) {
    var b = r.clone().toArray(), l = h.parent;
    if (l) {
      var v = l.children, s = v.indexOf(h);
      s < 0 || (Jl(v, s, 0, b, l), u.push.apply(u, b));
    }
  }), this._make(u);
}
Lr.insertBefore = Rve;
function Nve(t) {
  var r = t ? this.filter(t) : this;
  return (0, Qs.domEach)(r, function(a) {
    (0, yve.removeElement)(a), a.prev = a.next = a.parent = null;
  }), this;
}
Lr.remove = Nve;
function wve(t) {
  var r = this;
  return (0, Qs.domEach)(this, function(a, u) {
    var h = a.parent;
    if (h) {
      var b = h.children, l = typeof t == "function" ? t.call(a, u, a) : t, v = r._makeDomArray(l);
      (0, Im.update)(v, null);
      var s = b.indexOf(a);
      Jl(b, s, 1, v, h), v.includes(a) || (a.parent = a.prev = a.next = null);
    }
  });
}
Lr.replaceWith = wve;
function _ve() {
  return (0, Qs.domEach)(this, function(t) {
    (0, Yu.hasChildren)(t) && (t.children.forEach(function(r) {
      r.next = r.prev = r.parent = null;
    }), t.children.length = 0);
  });
}
Lr.empty = _ve;
function Pve(t) {
  var r = this;
  if (t === void 0) {
    var a = this[0];
    return !a || !(0, Yu.hasChildren)(a) ? null : this._render(a.children);
  }
  return (0, Qs.domEach)(this, function(u) {
    if ((0, Yu.hasChildren)(u)) {
      u.children.forEach(function(b) {
        b.next = b.prev = b.parent = null;
      });
      var h = (0, Qs.isCheerio)(t) ? t.toArray() : r._parse("".concat(t), r.options, !1, u).children;
      (0, Im.update)(h, u);
    }
  });
}
Lr.html = Pve;
function xve() {
  return this._render(this);
}
Lr.toString = xve;
function Dve(t) {
  var r = this;
  return t === void 0 ? (0, HU.text)(this) : typeof t == "function" ? (0, Qs.domEach)(this, function(a, u) {
    return r._make(a).text(t.call(a, u, (0, HU.text)([a])));
  }) : (0, Qs.domEach)(this, function(a) {
    if ((0, Yu.hasChildren)(a)) {
      a.children.forEach(function(h) {
        h.next = h.prev = h.parent = null;
      });
      var u = new Yu.Text("".concat(t));
      (0, Im.update)(u, a);
    }
  });
}
Lr.text = Dve;
function Mve() {
  return this._make((0, Qs.cloneDom)(this.get()));
}
Lr.clone = Mve;
var yA = {};
Object.defineProperty(yA, "__esModule", { value: !0 });
yA.css = void 0;
var hN = yh;
function Lve(t, r) {
  if (t != null && r != null || // When `prop` is a "plain" object
  typeof t == "object" && !Array.isArray(t))
    return (0, hN.domEach)(this, function(a, u) {
      (0, hN.isTag)(a) && uV(a, t, r, u);
    });
  if (this.length !== 0)
    return dV(this[0], t);
}
yA.css = Lve;
function uV(t, r, a, u) {
  if (typeof r == "string") {
    var h = dV(t), b = typeof a == "function" ? a.call(t, u, h[r]) : a;
    b === "" ? delete h[r] : b != null && (h[r] = b), t.attribs.style = kve(h);
  } else typeof r == "object" && Object.keys(r).forEach(function(l, v) {
    uV(t, l, r[l], v);
  });
}
function dV(t, r) {
  if (!(!t || !(0, hN.isTag)(t))) {
    var a = jve(t.attribs.style);
    if (typeof r == "string")
      return a[r];
    if (Array.isArray(r)) {
      var u = {};
      return r.forEach(function(h) {
        a[h] != null && (u[h] = a[h]);
      }), u;
    }
    return a;
  }
}
function kve(t) {
  return Object.keys(t).reduce(function(r, a) {
    return "".concat(r).concat(r ? " " : "").concat(a, ": ").concat(t[a], ";");
  }, "");
}
function jve(t) {
  if (t = (t || "").trim(), !t)
    return {};
  for (var r = {}, a, u = 0, h = t.split(";"); u < h.length; u++) {
    var b = h[u], l = b.indexOf(":");
    if (l < 1 || l === b.length - 1) {
      var v = b.trimEnd();
      v.length > 0 && a !== void 0 && (r[a] += ";".concat(v));
    } else
      a = b.slice(0, l).trim(), r[a] = b.slice(l + 1).trim();
  }
  return r;
}
var Rm = {};
Object.defineProperty(Rm, "__esModule", { value: !0 });
Rm.serializeArray = Rm.serialize = void 0;
var Uve = yh, BU = "input,select,textarea,keygen", Hve = /%20/g, zU = /\r?\n/g;
function Bve() {
  var t = this.serializeArray(), r = t.map(function(a) {
    return "".concat(encodeURIComponent(a.name), "=").concat(encodeURIComponent(a.value));
  });
  return r.join("&").replace(Hve, "+");
}
Rm.serialize = Bve;
function zve() {
  var t = this;
  return this.map(function(r, a) {
    var u = t._make(a);
    return (0, Uve.isTag)(a) && a.name === "form" ? u.find(BU).toArray() : u.filter(BU).toArray();
  }).filter(
    // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
    // Convert each of the elements to its value(s)
  ).map(function(r, a) {
    var u, h = t._make(a), b = h.attr("name"), l = (u = h.val()) !== null && u !== void 0 ? u : "";
    return Array.isArray(l) ? l.map(function(v) {
      return { name: b, value: v.replace(zU, `\r
`) };
    }) : { name: b, value: l.replace(zU, `\r
`) };
  }).toArray();
}
Rm.serializeArray = zve;
var Fve = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), Gve = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), Pv = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && Fve(r, t, a);
  return Gve(r, t), r;
};
Object.defineProperty(lA, "__esModule", { value: !0 });
lA.Cheerio = void 0;
var Vve = Pv(Bs), Yve = Pv(qn), Xve = Pv(Lr), Wve = Pv(yA), qve = Pv(Rm), xv = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r, a, u) {
      if (this.length = 0, this.options = u, this._root = a, r) {
        for (var h = 0; h < r.length; h++)
          this[h] = r[h];
        this.length = r.length;
      }
    }
    return t;
  }()
);
lA.Cheerio = xv;
xv.prototype.cheerio = "[cheerio object]";
xv.prototype.splice = Array.prototype.splice;
xv.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
Object.assign(xv.prototype, Vve, Yve, Xve, Wve, qve);
var Kve = rn && rn.__extends || /* @__PURE__ */ function() {
  var t = function(r, a) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, h) {
      u.__proto__ = h;
    } || function(u, h) {
      for (var b in h) Object.prototype.hasOwnProperty.call(h, b) && (u[b] = h[b]);
    }, t(r, a);
  };
  return function(r, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
    t(r, a);
    function u() {
      this.constructor = r;
    }
    r.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
  };
}(), eg = rn && rn.__assign || function() {
  return eg = Object.assign || function(t) {
    for (var r, a = 1, u = arguments.length; a < u; a++) {
      r = arguments[a];
      for (var h in r) Object.prototype.hasOwnProperty.call(r, h) && (t[h] = r[h]);
    }
    return t;
  }, eg.apply(this, arguments);
}, Jve = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), Zve = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), lV = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && Jve(r, t, a);
  return Zve(r, t), r;
};
Object.defineProperty(oA, "__esModule", { value: !0 });
oA.getLoad = void 0;
var VR = lV(Hm), Qve = lV(Ls), $ve = lA, Cy = yh;
function e1e(t, r) {
  return function a(u, h, b) {
    if (b === void 0 && (b = !0), u == null)
      throw new Error("cheerio.load() expects a string");
    var l = eg(eg({}, VR.default), (0, VR.flatten)(h)), v = t(u, l, b, null), s = (
      /** @class */
      function(d) {
        Kve(p, d);
        function p() {
          return d !== null && d.apply(this, arguments) || this;
        }
        return p.prototype._make = function(m, E) {
          var y = c(m, E);
          return y.prevObject = this, y;
        }, p.prototype._parse = function(m, E, y, g) {
          return t(m, E, y, g);
        }, p.prototype._render = function(m) {
          return r(m, this.options);
        }, p;
      }($ve.Cheerio)
    );
    function c(d, p, m, E) {
      if (m === void 0 && (m = v), d && (0, Cy.isCheerio)(d))
        return d;
      var y = eg(eg({}, l), (0, VR.flatten)(E)), g = typeof m == "string" ? [t(m, y, !1, null)] : "length" in m ? m : [m], C = (0, Cy.isCheerio)(g) ? g : new s(g, null, y);
      if (C._root = C, !d)
        return new s(void 0, C, y);
      var O = typeof d == "string" && (0, Cy.isHtml)(d) ? (
        // $(<html>)
        t(d, y, !1, null).children
      ) : t1e(d) ? (
        // $(dom)
        [d]
      ) : Array.isArray(d) ? (
        // $([dom])
        d
      ) : void 0, N = new s(O, C, y);
      if (O)
        return N;
      if (typeof d != "string")
        throw new Error("Unexpected type of selector");
      var w = d, _ = p ? typeof p == "string" ? (0, Cy.isHtml)(p) ? (
        // $('li', '<ul>...</ul>')
        new s([t(p, y, !1, null)], C, y)
      ) : (
        // $('li', 'ul')
        (w = "".concat(p, " ").concat(w), C)
      ) : (0, Cy.isCheerio)(p) ? (
        // $('li', $)
        p
      ) : (
        // $('li', node), $('li', [nodes])
        new s(Array.isArray(p) ? p : [p], C, y)
      ) : (
        // If we don't have a context, maybe we have a root, from loading
        C
      );
      return _ ? _.find(w) : N;
    }
    return Object.assign(c, Qve, {
      load: a,
      // `_root` and `_options` are used in static methods.
      _root: v,
      _options: l,
      // Add `fn` for plugins
      fn: s.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: s.prototype
    }), c;
  };
}
oA.getLoad = e1e;
function t1e(t) {
  return !!t.name || t.type === "root" || t.type === "text" || t.type === "comment";
}
var Nm = {}, Bw = {}, rv = {}, dh = {}, vA = {}, Ka = {};
Object.defineProperty(Ka, "__esModule", { value: !0 });
Ka.SEQUENCES = Ka.CODE_POINTS = Ka.REPLACEMENT_CHARACTER = void 0;
Ka.isSurrogate = r1e;
Ka.isSurrogatePair = i1e;
Ka.getSurrogatePairCodePoint = s1e;
Ka.isControlCodePoint = a1e;
Ka.isUndefinedCodePoint = o1e;
const n1e = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]);
Ka.REPLACEMENT_CHARACTER = "�";
var FU;
(function(t) {
  t[t.EOF = -1] = "EOF", t[t.NULL = 0] = "NULL", t[t.TABULATION = 9] = "TABULATION", t[t.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", t[t.LINE_FEED = 10] = "LINE_FEED", t[t.FORM_FEED = 12] = "FORM_FEED", t[t.SPACE = 32] = "SPACE", t[t.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", t[t.QUOTATION_MARK = 34] = "QUOTATION_MARK", t[t.AMPERSAND = 38] = "AMPERSAND", t[t.APOSTROPHE = 39] = "APOSTROPHE", t[t.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", t[t.SOLIDUS = 47] = "SOLIDUS", t[t.DIGIT_0 = 48] = "DIGIT_0", t[t.DIGIT_9 = 57] = "DIGIT_9", t[t.SEMICOLON = 59] = "SEMICOLON", t[t.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", t[t.EQUALS_SIGN = 61] = "EQUALS_SIGN", t[t.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", t[t.QUESTION_MARK = 63] = "QUESTION_MARK", t[t.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", t[t.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", t[t.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", t[t.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", t[t.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", t[t.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(FU || (Ka.CODE_POINTS = FU = {}));
Ka.SEQUENCES = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function r1e(t) {
  return t >= 55296 && t <= 57343;
}
function i1e(t) {
  return t >= 56320 && t <= 57343;
}
function s1e(t, r) {
  return (t - 55296) * 1024 + 9216 + r;
}
function a1e(t) {
  return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
}
function o1e(t) {
  return t >= 64976 && t <= 65007 || n1e.has(t);
}
var Th = {};
Object.defineProperty(Th, "__esModule", { value: !0 });
Th.ERR = void 0;
var GU;
(function(t) {
  t.controlCharacterInInputStream = "control-character-in-input-stream", t.noncharacterInInputStream = "noncharacter-in-input-stream", t.surrogateInInputStream = "surrogate-in-input-stream", t.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", t.endTagWithAttributes = "end-tag-with-attributes", t.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", t.unexpectedSolidusInTag = "unexpected-solidus-in-tag", t.unexpectedNullCharacter = "unexpected-null-character", t.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", t.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", t.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", t.missingEndTagName = "missing-end-tag-name", t.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", t.unknownNamedCharacterReference = "unknown-named-character-reference", t.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", t.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", t.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", t.eofBeforeTagName = "eof-before-tag-name", t.eofInTag = "eof-in-tag", t.missingAttributeValue = "missing-attribute-value", t.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", t.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", t.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", t.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", t.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", t.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", t.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", t.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", t.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", t.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", t.cdataInHtmlContent = "cdata-in-html-content", t.incorrectlyOpenedComment = "incorrectly-opened-comment", t.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", t.eofInDoctype = "eof-in-doctype", t.nestedComment = "nested-comment", t.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", t.eofInComment = "eof-in-comment", t.incorrectlyClosedComment = "incorrectly-closed-comment", t.eofInCdata = "eof-in-cdata", t.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", t.nullCharacterReference = "null-character-reference", t.surrogateCharacterReference = "surrogate-character-reference", t.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", t.controlCharacterReference = "control-character-reference", t.noncharacterCharacterReference = "noncharacter-character-reference", t.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", t.missingDoctypeName = "missing-doctype-name", t.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", t.duplicateAttribute = "duplicate-attribute", t.nonConformingDoctype = "non-conforming-doctype", t.missingDoctype = "missing-doctype", t.misplacedDoctype = "misplaced-doctype", t.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", t.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", t.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", t.openElementsLeftAfterEof = "open-elements-left-after-eof", t.abandonedHeadElementChild = "abandoned-head-element-child", t.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", t.nestedNoscriptInHead = "nested-noscript-in-head", t.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(GU || (Th.ERR = GU = {}));
Object.defineProperty(vA, "__esModule", { value: !0 });
vA.Preprocessor = void 0;
const Ya = Ka, YR = Th, c1e = 65536;
class u1e {
  constructor(r) {
    this.handler = r, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = c1e, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(r, a) {
    const { line: u, col: h, offset: b } = this, l = h + a, v = b + a;
    return {
      code: r,
      startLine: u,
      endLine: u,
      startCol: l,
      endCol: l,
      startOffset: v,
      endOffset: v
    };
  }
  _err(r) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(r, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(r) {
    if (this.pos !== this.html.length - 1) {
      const a = this.html.charCodeAt(this.pos + 1);
      if ((0, Ya.isSurrogatePair)(a))
        return this.pos++, this._addGap(), (0, Ya.getSurrogatePairCodePoint)(r, a);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, Ya.CODE_POINTS.EOF;
    return this._err(YR.ERR.surrogateInInputStream), r;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(r, a) {
    this.html.length > 0 ? this.html += r : this.html = r, this.endOfChunkHit = !1, this.lastChunkWritten = a;
  }
  insertHtmlAtCurrentPos(r) {
    this.html = this.html.substring(0, this.pos + 1) + r + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(r, a) {
    if (this.pos + r.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (a)
      return this.html.startsWith(r, this.pos);
    for (let u = 0; u < r.length; u++)
      if ((this.html.charCodeAt(this.pos + u) | 32) !== r.charCodeAt(u))
        return !1;
    return !0;
  }
  peek(r) {
    const a = this.pos + r;
    if (a >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, Ya.CODE_POINTS.EOF;
    const u = this.html.charCodeAt(a);
    return u === Ya.CODE_POINTS.CARRIAGE_RETURN ? Ya.CODE_POINTS.LINE_FEED : u;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, Ya.CODE_POINTS.EOF;
    let r = this.html.charCodeAt(this.pos);
    return r === Ya.CODE_POINTS.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, Ya.CODE_POINTS.LINE_FEED) : r === Ya.CODE_POINTS.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, (0, Ya.isSurrogate)(r) && (r = this._processSurrogate(r)), this.handler.onParseError === null || r > 31 && r < 127 || r === Ya.CODE_POINTS.LINE_FEED || r === Ya.CODE_POINTS.CARRIAGE_RETURN || r > 159 && r < 64976 || this._checkForProblematicCharacters(r), r);
  }
  _checkForProblematicCharacters(r) {
    (0, Ya.isControlCodePoint)(r) ? this._err(YR.ERR.controlCharacterInInputStream) : (0, Ya.isUndefinedCodePoint)(r) && this._err(YR.ERR.noncharacterInInputStream);
  }
  retreat(r) {
    for (this.pos -= r; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
vA.Preprocessor = u1e;
var bh = {};
Object.defineProperty(bh, "__esModule", { value: !0 });
bh.TokenType = void 0;
bh.getTokenAttr = d1e;
var VU;
(function(t) {
  t[t.CHARACTER = 0] = "CHARACTER", t[t.NULL_CHARACTER = 1] = "NULL_CHARACTER", t[t.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", t[t.START_TAG = 3] = "START_TAG", t[t.END_TAG = 4] = "END_TAG", t[t.COMMENT = 5] = "COMMENT", t[t.DOCTYPE = 6] = "DOCTYPE", t[t.EOF = 7] = "EOF", t[t.HIBERNATION = 8] = "HIBERNATION";
})(VU || (bh.TokenType = VU = {}));
function d1e(t, r) {
  for (let a = t.attrs.length - 1; a >= 0; a--)
    if (t.attrs[a].name === r)
      return t.attrs[a].value;
  return null;
}
var ss = {};
Object.defineProperty(ss, "__esModule", { value: !0 });
ss.NUMBERED_HEADERS = ss.SPECIAL_ELEMENTS = ss.TAG_ID = ss.TAG_NAMES = ss.DOCUMENT_MODE = ss.ATTRS = ss.NS = void 0;
ss.getTagID = f1e;
ss.hasUnescapedText = p1e;
var Il;
(function(t) {
  t.HTML = "http://www.w3.org/1999/xhtml", t.MATHML = "http://www.w3.org/1998/Math/MathML", t.SVG = "http://www.w3.org/2000/svg", t.XLINK = "http://www.w3.org/1999/xlink", t.XML = "http://www.w3.org/XML/1998/namespace", t.XMLNS = "http://www.w3.org/2000/xmlns/";
})(Il || (ss.NS = Il = {}));
var YU;
(function(t) {
  t.TYPE = "type", t.ACTION = "action", t.ENCODING = "encoding", t.PROMPT = "prompt", t.NAME = "name", t.COLOR = "color", t.FACE = "face", t.SIZE = "size";
})(YU || (ss.ATTRS = YU = {}));
var XU;
(function(t) {
  t.NO_QUIRKS = "no-quirks", t.QUIRKS = "quirks", t.LIMITED_QUIRKS = "limited-quirks";
})(XU || (ss.DOCUMENT_MODE = XU = {}));
var un;
(function(t) {
  t.A = "a", t.ADDRESS = "address", t.ANNOTATION_XML = "annotation-xml", t.APPLET = "applet", t.AREA = "area", t.ARTICLE = "article", t.ASIDE = "aside", t.B = "b", t.BASE = "base", t.BASEFONT = "basefont", t.BGSOUND = "bgsound", t.BIG = "big", t.BLOCKQUOTE = "blockquote", t.BODY = "body", t.BR = "br", t.BUTTON = "button", t.CAPTION = "caption", t.CENTER = "center", t.CODE = "code", t.COL = "col", t.COLGROUP = "colgroup", t.DD = "dd", t.DESC = "desc", t.DETAILS = "details", t.DIALOG = "dialog", t.DIR = "dir", t.DIV = "div", t.DL = "dl", t.DT = "dt", t.EM = "em", t.EMBED = "embed", t.FIELDSET = "fieldset", t.FIGCAPTION = "figcaption", t.FIGURE = "figure", t.FONT = "font", t.FOOTER = "footer", t.FOREIGN_OBJECT = "foreignObject", t.FORM = "form", t.FRAME = "frame", t.FRAMESET = "frameset", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.HEAD = "head", t.HEADER = "header", t.HGROUP = "hgroup", t.HR = "hr", t.HTML = "html", t.I = "i", t.IMG = "img", t.IMAGE = "image", t.INPUT = "input", t.IFRAME = "iframe", t.KEYGEN = "keygen", t.LABEL = "label", t.LI = "li", t.LINK = "link", t.LISTING = "listing", t.MAIN = "main", t.MALIGNMARK = "malignmark", t.MARQUEE = "marquee", t.MATH = "math", t.MENU = "menu", t.META = "meta", t.MGLYPH = "mglyph", t.MI = "mi", t.MO = "mo", t.MN = "mn", t.MS = "ms", t.MTEXT = "mtext", t.NAV = "nav", t.NOBR = "nobr", t.NOFRAMES = "noframes", t.NOEMBED = "noembed", t.NOSCRIPT = "noscript", t.OBJECT = "object", t.OL = "ol", t.OPTGROUP = "optgroup", t.OPTION = "option", t.P = "p", t.PARAM = "param", t.PLAINTEXT = "plaintext", t.PRE = "pre", t.RB = "rb", t.RP = "rp", t.RT = "rt", t.RTC = "rtc", t.RUBY = "ruby", t.S = "s", t.SCRIPT = "script", t.SEARCH = "search", t.SECTION = "section", t.SELECT = "select", t.SOURCE = "source", t.SMALL = "small", t.SPAN = "span", t.STRIKE = "strike", t.STRONG = "strong", t.STYLE = "style", t.SUB = "sub", t.SUMMARY = "summary", t.SUP = "sup", t.TABLE = "table", t.TBODY = "tbody", t.TEMPLATE = "template", t.TEXTAREA = "textarea", t.TFOOT = "tfoot", t.TD = "td", t.TH = "th", t.THEAD = "thead", t.TITLE = "title", t.TR = "tr", t.TRACK = "track", t.TT = "tt", t.U = "u", t.UL = "ul", t.SVG = "svg", t.VAR = "var", t.WBR = "wbr", t.XMP = "xmp";
})(un || (ss.TAG_NAMES = un = {}));
var dn;
(function(t) {
  t[t.UNKNOWN = 0] = "UNKNOWN", t[t.A = 1] = "A", t[t.ADDRESS = 2] = "ADDRESS", t[t.ANNOTATION_XML = 3] = "ANNOTATION_XML", t[t.APPLET = 4] = "APPLET", t[t.AREA = 5] = "AREA", t[t.ARTICLE = 6] = "ARTICLE", t[t.ASIDE = 7] = "ASIDE", t[t.B = 8] = "B", t[t.BASE = 9] = "BASE", t[t.BASEFONT = 10] = "BASEFONT", t[t.BGSOUND = 11] = "BGSOUND", t[t.BIG = 12] = "BIG", t[t.BLOCKQUOTE = 13] = "BLOCKQUOTE", t[t.BODY = 14] = "BODY", t[t.BR = 15] = "BR", t[t.BUTTON = 16] = "BUTTON", t[t.CAPTION = 17] = "CAPTION", t[t.CENTER = 18] = "CENTER", t[t.CODE = 19] = "CODE", t[t.COL = 20] = "COL", t[t.COLGROUP = 21] = "COLGROUP", t[t.DD = 22] = "DD", t[t.DESC = 23] = "DESC", t[t.DETAILS = 24] = "DETAILS", t[t.DIALOG = 25] = "DIALOG", t[t.DIR = 26] = "DIR", t[t.DIV = 27] = "DIV", t[t.DL = 28] = "DL", t[t.DT = 29] = "DT", t[t.EM = 30] = "EM", t[t.EMBED = 31] = "EMBED", t[t.FIELDSET = 32] = "FIELDSET", t[t.FIGCAPTION = 33] = "FIGCAPTION", t[t.FIGURE = 34] = "FIGURE", t[t.FONT = 35] = "FONT", t[t.FOOTER = 36] = "FOOTER", t[t.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", t[t.FORM = 38] = "FORM", t[t.FRAME = 39] = "FRAME", t[t.FRAMESET = 40] = "FRAMESET", t[t.H1 = 41] = "H1", t[t.H2 = 42] = "H2", t[t.H3 = 43] = "H3", t[t.H4 = 44] = "H4", t[t.H5 = 45] = "H5", t[t.H6 = 46] = "H6", t[t.HEAD = 47] = "HEAD", t[t.HEADER = 48] = "HEADER", t[t.HGROUP = 49] = "HGROUP", t[t.HR = 50] = "HR", t[t.HTML = 51] = "HTML", t[t.I = 52] = "I", t[t.IMG = 53] = "IMG", t[t.IMAGE = 54] = "IMAGE", t[t.INPUT = 55] = "INPUT", t[t.IFRAME = 56] = "IFRAME", t[t.KEYGEN = 57] = "KEYGEN", t[t.LABEL = 58] = "LABEL", t[t.LI = 59] = "LI", t[t.LINK = 60] = "LINK", t[t.LISTING = 61] = "LISTING", t[t.MAIN = 62] = "MAIN", t[t.MALIGNMARK = 63] = "MALIGNMARK", t[t.MARQUEE = 64] = "MARQUEE", t[t.MATH = 65] = "MATH", t[t.MENU = 66] = "MENU", t[t.META = 67] = "META", t[t.MGLYPH = 68] = "MGLYPH", t[t.MI = 69] = "MI", t[t.MO = 70] = "MO", t[t.MN = 71] = "MN", t[t.MS = 72] = "MS", t[t.MTEXT = 73] = "MTEXT", t[t.NAV = 74] = "NAV", t[t.NOBR = 75] = "NOBR", t[t.NOFRAMES = 76] = "NOFRAMES", t[t.NOEMBED = 77] = "NOEMBED", t[t.NOSCRIPT = 78] = "NOSCRIPT", t[t.OBJECT = 79] = "OBJECT", t[t.OL = 80] = "OL", t[t.OPTGROUP = 81] = "OPTGROUP", t[t.OPTION = 82] = "OPTION", t[t.P = 83] = "P", t[t.PARAM = 84] = "PARAM", t[t.PLAINTEXT = 85] = "PLAINTEXT", t[t.PRE = 86] = "PRE", t[t.RB = 87] = "RB", t[t.RP = 88] = "RP", t[t.RT = 89] = "RT", t[t.RTC = 90] = "RTC", t[t.RUBY = 91] = "RUBY", t[t.S = 92] = "S", t[t.SCRIPT = 93] = "SCRIPT", t[t.SEARCH = 94] = "SEARCH", t[t.SECTION = 95] = "SECTION", t[t.SELECT = 96] = "SELECT", t[t.SOURCE = 97] = "SOURCE", t[t.SMALL = 98] = "SMALL", t[t.SPAN = 99] = "SPAN", t[t.STRIKE = 100] = "STRIKE", t[t.STRONG = 101] = "STRONG", t[t.STYLE = 102] = "STYLE", t[t.SUB = 103] = "SUB", t[t.SUMMARY = 104] = "SUMMARY", t[t.SUP = 105] = "SUP", t[t.TABLE = 106] = "TABLE", t[t.TBODY = 107] = "TBODY", t[t.TEMPLATE = 108] = "TEMPLATE", t[t.TEXTAREA = 109] = "TEXTAREA", t[t.TFOOT = 110] = "TFOOT", t[t.TD = 111] = "TD", t[t.TH = 112] = "TH", t[t.THEAD = 113] = "THEAD", t[t.TITLE = 114] = "TITLE", t[t.TR = 115] = "TR", t[t.TRACK = 116] = "TRACK", t[t.TT = 117] = "TT", t[t.U = 118] = "U", t[t.UL = 119] = "UL", t[t.SVG = 120] = "SVG", t[t.VAR = 121] = "VAR", t[t.WBR = 122] = "WBR", t[t.XMP = 123] = "XMP";
})(dn || (ss.TAG_ID = dn = {}));
const l1e = /* @__PURE__ */ new Map([
  [un.A, dn.A],
  [un.ADDRESS, dn.ADDRESS],
  [un.ANNOTATION_XML, dn.ANNOTATION_XML],
  [un.APPLET, dn.APPLET],
  [un.AREA, dn.AREA],
  [un.ARTICLE, dn.ARTICLE],
  [un.ASIDE, dn.ASIDE],
  [un.B, dn.B],
  [un.BASE, dn.BASE],
  [un.BASEFONT, dn.BASEFONT],
  [un.BGSOUND, dn.BGSOUND],
  [un.BIG, dn.BIG],
  [un.BLOCKQUOTE, dn.BLOCKQUOTE],
  [un.BODY, dn.BODY],
  [un.BR, dn.BR],
  [un.BUTTON, dn.BUTTON],
  [un.CAPTION, dn.CAPTION],
  [un.CENTER, dn.CENTER],
  [un.CODE, dn.CODE],
  [un.COL, dn.COL],
  [un.COLGROUP, dn.COLGROUP],
  [un.DD, dn.DD],
  [un.DESC, dn.DESC],
  [un.DETAILS, dn.DETAILS],
  [un.DIALOG, dn.DIALOG],
  [un.DIR, dn.DIR],
  [un.DIV, dn.DIV],
  [un.DL, dn.DL],
  [un.DT, dn.DT],
  [un.EM, dn.EM],
  [un.EMBED, dn.EMBED],
  [un.FIELDSET, dn.FIELDSET],
  [un.FIGCAPTION, dn.FIGCAPTION],
  [un.FIGURE, dn.FIGURE],
  [un.FONT, dn.FONT],
  [un.FOOTER, dn.FOOTER],
  [un.FOREIGN_OBJECT, dn.FOREIGN_OBJECT],
  [un.FORM, dn.FORM],
  [un.FRAME, dn.FRAME],
  [un.FRAMESET, dn.FRAMESET],
  [un.H1, dn.H1],
  [un.H2, dn.H2],
  [un.H3, dn.H3],
  [un.H4, dn.H4],
  [un.H5, dn.H5],
  [un.H6, dn.H6],
  [un.HEAD, dn.HEAD],
  [un.HEADER, dn.HEADER],
  [un.HGROUP, dn.HGROUP],
  [un.HR, dn.HR],
  [un.HTML, dn.HTML],
  [un.I, dn.I],
  [un.IMG, dn.IMG],
  [un.IMAGE, dn.IMAGE],
  [un.INPUT, dn.INPUT],
  [un.IFRAME, dn.IFRAME],
  [un.KEYGEN, dn.KEYGEN],
  [un.LABEL, dn.LABEL],
  [un.LI, dn.LI],
  [un.LINK, dn.LINK],
  [un.LISTING, dn.LISTING],
  [un.MAIN, dn.MAIN],
  [un.MALIGNMARK, dn.MALIGNMARK],
  [un.MARQUEE, dn.MARQUEE],
  [un.MATH, dn.MATH],
  [un.MENU, dn.MENU],
  [un.META, dn.META],
  [un.MGLYPH, dn.MGLYPH],
  [un.MI, dn.MI],
  [un.MO, dn.MO],
  [un.MN, dn.MN],
  [un.MS, dn.MS],
  [un.MTEXT, dn.MTEXT],
  [un.NAV, dn.NAV],
  [un.NOBR, dn.NOBR],
  [un.NOFRAMES, dn.NOFRAMES],
  [un.NOEMBED, dn.NOEMBED],
  [un.NOSCRIPT, dn.NOSCRIPT],
  [un.OBJECT, dn.OBJECT],
  [un.OL, dn.OL],
  [un.OPTGROUP, dn.OPTGROUP],
  [un.OPTION, dn.OPTION],
  [un.P, dn.P],
  [un.PARAM, dn.PARAM],
  [un.PLAINTEXT, dn.PLAINTEXT],
  [un.PRE, dn.PRE],
  [un.RB, dn.RB],
  [un.RP, dn.RP],
  [un.RT, dn.RT],
  [un.RTC, dn.RTC],
  [un.RUBY, dn.RUBY],
  [un.S, dn.S],
  [un.SCRIPT, dn.SCRIPT],
  [un.SEARCH, dn.SEARCH],
  [un.SECTION, dn.SECTION],
  [un.SELECT, dn.SELECT],
  [un.SOURCE, dn.SOURCE],
  [un.SMALL, dn.SMALL],
  [un.SPAN, dn.SPAN],
  [un.STRIKE, dn.STRIKE],
  [un.STRONG, dn.STRONG],
  [un.STYLE, dn.STYLE],
  [un.SUB, dn.SUB],
  [un.SUMMARY, dn.SUMMARY],
  [un.SUP, dn.SUP],
  [un.TABLE, dn.TABLE],
  [un.TBODY, dn.TBODY],
  [un.TEMPLATE, dn.TEMPLATE],
  [un.TEXTAREA, dn.TEXTAREA],
  [un.TFOOT, dn.TFOOT],
  [un.TD, dn.TD],
  [un.TH, dn.TH],
  [un.THEAD, dn.THEAD],
  [un.TITLE, dn.TITLE],
  [un.TR, dn.TR],
  [un.TRACK, dn.TRACK],
  [un.TT, dn.TT],
  [un.U, dn.U],
  [un.UL, dn.UL],
  [un.SVG, dn.SVG],
  [un.VAR, dn.VAR],
  [un.WBR, dn.WBR],
  [un.XMP, dn.XMP]
]);
function f1e(t) {
  var r;
  return (r = l1e.get(t)) !== null && r !== void 0 ? r : dn.UNKNOWN;
}
const Nn = dn;
ss.SPECIAL_ELEMENTS = {
  [Il.HTML]: /* @__PURE__ */ new Set([
    Nn.ADDRESS,
    Nn.APPLET,
    Nn.AREA,
    Nn.ARTICLE,
    Nn.ASIDE,
    Nn.BASE,
    Nn.BASEFONT,
    Nn.BGSOUND,
    Nn.BLOCKQUOTE,
    Nn.BODY,
    Nn.BR,
    Nn.BUTTON,
    Nn.CAPTION,
    Nn.CENTER,
    Nn.COL,
    Nn.COLGROUP,
    Nn.DD,
    Nn.DETAILS,
    Nn.DIR,
    Nn.DIV,
    Nn.DL,
    Nn.DT,
    Nn.EMBED,
    Nn.FIELDSET,
    Nn.FIGCAPTION,
    Nn.FIGURE,
    Nn.FOOTER,
    Nn.FORM,
    Nn.FRAME,
    Nn.FRAMESET,
    Nn.H1,
    Nn.H2,
    Nn.H3,
    Nn.H4,
    Nn.H5,
    Nn.H6,
    Nn.HEAD,
    Nn.HEADER,
    Nn.HGROUP,
    Nn.HR,
    Nn.HTML,
    Nn.IFRAME,
    Nn.IMG,
    Nn.INPUT,
    Nn.LI,
    Nn.LINK,
    Nn.LISTING,
    Nn.MAIN,
    Nn.MARQUEE,
    Nn.MENU,
    Nn.META,
    Nn.NAV,
    Nn.NOEMBED,
    Nn.NOFRAMES,
    Nn.NOSCRIPT,
    Nn.OBJECT,
    Nn.OL,
    Nn.P,
    Nn.PARAM,
    Nn.PLAINTEXT,
    Nn.PRE,
    Nn.SCRIPT,
    Nn.SECTION,
    Nn.SELECT,
    Nn.SOURCE,
    Nn.STYLE,
    Nn.SUMMARY,
    Nn.TABLE,
    Nn.TBODY,
    Nn.TD,
    Nn.TEMPLATE,
    Nn.TEXTAREA,
    Nn.TFOOT,
    Nn.TH,
    Nn.THEAD,
    Nn.TITLE,
    Nn.TR,
    Nn.TRACK,
    Nn.UL,
    Nn.WBR,
    Nn.XMP
  ]),
  [Il.MATHML]: /* @__PURE__ */ new Set([Nn.MI, Nn.MO, Nn.MN, Nn.MS, Nn.MTEXT, Nn.ANNOTATION_XML]),
  [Il.SVG]: /* @__PURE__ */ new Set([Nn.TITLE, Nn.FOREIGN_OBJECT, Nn.DESC]),
  [Il.XLINK]: /* @__PURE__ */ new Set(),
  [Il.XML]: /* @__PURE__ */ new Set(),
  [Il.XMLNS]: /* @__PURE__ */ new Set()
};
ss.NUMBERED_HEADERS = /* @__PURE__ */ new Set([Nn.H1, Nn.H2, Nn.H3, Nn.H4, Nn.H5, Nn.H6]);
const h1e = /* @__PURE__ */ new Set([
  un.STYLE,
  un.SCRIPT,
  un.XMP,
  un.IFRAME,
  un.NOEMBED,
  un.NOFRAMES,
  un.PLAINTEXT
]);
function p1e(t, r) {
  return h1e.has(t) || r && t === un.NOSCRIPT;
}
Object.defineProperty(dh, "__esModule", { value: !0 });
dh.Tokenizer = dh.TokenizerMode = void 0;
const g1e = vA, At = Ka, ho = bh, L0 = bm, On = Th, XR = ss;
var Dt;
(function(t) {
  t[t.DATA = 0] = "DATA", t[t.RCDATA = 1] = "RCDATA", t[t.RAWTEXT = 2] = "RAWTEXT", t[t.SCRIPT_DATA = 3] = "SCRIPT_DATA", t[t.PLAINTEXT = 4] = "PLAINTEXT", t[t.TAG_OPEN = 5] = "TAG_OPEN", t[t.END_TAG_OPEN = 6] = "END_TAG_OPEN", t[t.TAG_NAME = 7] = "TAG_NAME", t[t.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", t[t.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", t[t.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", t[t.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", t[t.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", t[t.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", t[t.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", t[t.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", t[t.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", t[t.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", t[t.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", t[t.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", t[t.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", t[t.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", t[t.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", t[t.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", t[t.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", t[t.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", t[t.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", t[t.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", t[t.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", t[t.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", t[t.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", t[t.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", t[t.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", t[t.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", t[t.COMMENT_START = 42] = "COMMENT_START", t[t.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", t[t.COMMENT = 44] = "COMMENT", t[t.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", t[t.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", t[t.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", t[t.COMMENT_END = 50] = "COMMENT_END", t[t.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", t[t.DOCTYPE = 52] = "DOCTYPE", t[t.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", t[t.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", t[t.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", t[t.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", t[t.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", t[t.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", t[t.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", t[t.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", t[t.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", t[t.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", t[t.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", t[t.CDATA_SECTION = 68] = "CDATA_SECTION", t[t.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", t[t.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", t[t.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", t[t.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(Dt || (Dt = {}));
dh.TokenizerMode = {
  DATA: Dt.DATA,
  RCDATA: Dt.RCDATA,
  RAWTEXT: Dt.RAWTEXT,
  SCRIPT_DATA: Dt.SCRIPT_DATA,
  PLAINTEXT: Dt.PLAINTEXT,
  CDATA_SECTION: Dt.CDATA_SECTION
};
function m1e(t) {
  return t >= At.CODE_POINTS.DIGIT_0 && t <= At.CODE_POINTS.DIGIT_9;
}
function My(t) {
  return t >= At.CODE_POINTS.LATIN_CAPITAL_A && t <= At.CODE_POINTS.LATIN_CAPITAL_Z;
}
function E1e(t) {
  return t >= At.CODE_POINTS.LATIN_SMALL_A && t <= At.CODE_POINTS.LATIN_SMALL_Z;
}
function Sl(t) {
  return E1e(t) || My(t);
}
function WU(t) {
  return Sl(t) || m1e(t);
}
function k0(t) {
  return t + 32;
}
function fV(t) {
  return t === At.CODE_POINTS.SPACE || t === At.CODE_POINTS.LINE_FEED || t === At.CODE_POINTS.TABULATION || t === At.CODE_POINTS.FORM_FEED;
}
function qU(t) {
  return fV(t) || t === At.CODE_POINTS.SOLIDUS || t === At.CODE_POINTS.GREATER_THAN_SIGN;
}
function y1e(t) {
  return t === At.CODE_POINTS.NULL ? On.ERR.nullCharacterReference : t > 1114111 ? On.ERR.characterReferenceOutsideUnicodeRange : (0, At.isSurrogate)(t) ? On.ERR.surrogateCharacterReference : (0, At.isUndefinedCodePoint)(t) ? On.ERR.noncharacterCharacterReference : (0, At.isControlCodePoint)(t) || t === At.CODE_POINTS.CARRIAGE_RETURN ? On.ERR.controlCharacterReference : null;
}
let v1e = class {
  constructor(r, a) {
    this.options = r, this.handler = a, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = Dt.DATA, this.returnState = Dt.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new g1e.Preprocessor(a), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new L0.EntityDecoder(L0.htmlDecodeTree, (u, h) => {
      this.preprocessor.pos = this.entityStartPos + h - 1, this._flushCodePointConsumedAsCharacterReference(u);
    }, a.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(On.ERR.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (u) => {
        this._err(On.ERR.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + u);
      },
      validateNumericCharacterReference: (u) => {
        const h = y1e(u);
        h && this._err(h, 1);
      }
    } : void 0);
  }
  //Errors
  _err(r, a = 0) {
    var u, h;
    (h = (u = this.handler).onParseError) === null || h === void 0 || h.call(u, this.preprocessor.getError(r, a));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(r) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - r,
      startOffset: this.preprocessor.offset - r,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const r = this._consume();
        this._ensureHibernation() || this._callState(r);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(r) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || r == null || r());
  }
  write(r, a, u) {
    this.active = !0, this.preprocessor.write(r, a), this._runParsingLoop(), this.paused || u == null || u();
  }
  insertHtmlAtCurrentPos(r) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(r), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(r) {
    this.consumedAfterSnapshot += r;
    for (let a = 0; a < r; a++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(r, a) {
    return this.preprocessor.startsWith(r, a) ? (this._advanceBy(r.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: ho.TokenType.START_TAG,
      tagName: "",
      tagID: XR.TAG_ID.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: ho.TokenType.END_TAG,
      tagName: "",
      tagID: XR.TAG_ID.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(r) {
    this.currentToken = {
      type: ho.TokenType.COMMENT,
      data: "",
      location: this.getCurrentLocation(r)
    };
  }
  _createDoctypeToken(r) {
    this.currentToken = {
      type: ho.TokenType.DOCTYPE,
      name: r,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(r, a) {
    this.currentCharacterToken = {
      type: r,
      chars: a,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(r) {
    this.currentAttr = {
      name: r,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var r, a;
    const u = this.currentToken;
    if ((0, ho.getTokenAttr)(u, this.currentAttr.name) === null) {
      if (u.attrs.push(this.currentAttr), u.location && this.currentLocation) {
        const h = (r = (a = u.location).attrs) !== null && r !== void 0 ? r : a.attrs = /* @__PURE__ */ Object.create(null);
        h[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(On.ERR.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(r) {
    this._emitCurrentCharacterToken(r.location), this.currentToken = null, r.location && (r.location.endLine = this.preprocessor.line, r.location.endCol = this.preprocessor.col + 1, r.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const r = this.currentToken;
    this.prepareToken(r), r.tagID = (0, XR.getTagID)(r.tagName), r.type === ho.TokenType.START_TAG ? (this.lastStartTagName = r.tagName, this.handler.onStartTag(r)) : (r.attrs.length > 0 && this._err(On.ERR.endTagWithAttributes), r.selfClosing && this._err(On.ERR.endTagWithTrailingSolidus), this.handler.onEndTag(r)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(r) {
    this.prepareToken(r), this.handler.onComment(r), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(r) {
    this.prepareToken(r), this.handler.onDoctype(r), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(r) {
    if (this.currentCharacterToken) {
      switch (r && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = r.startLine, this.currentCharacterToken.location.endCol = r.startCol, this.currentCharacterToken.location.endOffset = r.startOffset), this.currentCharacterToken.type) {
        case ho.TokenType.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case ho.TokenType.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case ho.TokenType.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const r = this.getCurrentLocation(0);
    r && (r.endLine = r.startLine, r.endCol = r.startCol, r.endOffset = r.startOffset), this._emitCurrentCharacterToken(r), this.handler.onEof({ type: ho.TokenType.EOF, location: r }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(r, a) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === r) {
        this.currentCharacterToken.chars += a;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(r, a);
  }
  _emitCodePoint(r) {
    const a = fV(r) ? ho.TokenType.WHITESPACE_CHARACTER : r === At.CODE_POINTS.NULL ? ho.TokenType.NULL_CHARACTER : ho.TokenType.CHARACTER;
    this._appendCharToCurrentCharacterToken(a, String.fromCodePoint(r));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(r) {
    this._appendCharToCurrentCharacterToken(ho.TokenType.CHARACTER, r);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = Dt.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? L0.DecodingMode.Attribute : L0.DecodingMode.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === Dt.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === Dt.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === Dt.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(r) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(r) : this._emitCodePoint(r);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(r) {
    switch (this.state) {
      case Dt.DATA: {
        this._stateData(r);
        break;
      }
      case Dt.RCDATA: {
        this._stateRcdata(r);
        break;
      }
      case Dt.RAWTEXT: {
        this._stateRawtext(r);
        break;
      }
      case Dt.SCRIPT_DATA: {
        this._stateScriptData(r);
        break;
      }
      case Dt.PLAINTEXT: {
        this._statePlaintext(r);
        break;
      }
      case Dt.TAG_OPEN: {
        this._stateTagOpen(r);
        break;
      }
      case Dt.END_TAG_OPEN: {
        this._stateEndTagOpen(r);
        break;
      }
      case Dt.TAG_NAME: {
        this._stateTagName(r);
        break;
      }
      case Dt.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(r);
        break;
      }
      case Dt.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(r);
        break;
      }
      case Dt.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(r);
        break;
      }
      case Dt.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(r);
        break;
      }
      case Dt.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(r);
        break;
      }
      case Dt.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(r);
        break;
      }
      case Dt.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(r);
        break;
      }
      case Dt.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(r);
        break;
      }
      case Dt.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(r);
        break;
      }
      case Dt.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(r);
        break;
      }
      case Dt.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(r);
        break;
      }
      case Dt.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(r);
        break;
      }
      case Dt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(r);
        break;
      }
      case Dt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(r);
        break;
      }
      case Dt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(r);
        break;
      }
      case Dt.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(r);
        break;
      }
      case Dt.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(r);
        break;
      }
      case Dt.ATTRIBUTE_NAME: {
        this._stateAttributeName(r);
        break;
      }
      case Dt.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(r);
        break;
      }
      case Dt.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(r);
        break;
      }
      case Dt.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(r);
        break;
      }
      case Dt.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(r);
        break;
      }
      case Dt.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(r);
        break;
      }
      case Dt.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(r);
        break;
      }
      case Dt.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(r);
        break;
      }
      case Dt.BOGUS_COMMENT: {
        this._stateBogusComment(r);
        break;
      }
      case Dt.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(r);
        break;
      }
      case Dt.COMMENT_START: {
        this._stateCommentStart(r);
        break;
      }
      case Dt.COMMENT_START_DASH: {
        this._stateCommentStartDash(r);
        break;
      }
      case Dt.COMMENT: {
        this._stateComment(r);
        break;
      }
      case Dt.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(r);
        break;
      }
      case Dt.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(r);
        break;
      }
      case Dt.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(r);
        break;
      }
      case Dt.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(r);
        break;
      }
      case Dt.COMMENT_END_DASH: {
        this._stateCommentEndDash(r);
        break;
      }
      case Dt.COMMENT_END: {
        this._stateCommentEnd(r);
        break;
      }
      case Dt.COMMENT_END_BANG: {
        this._stateCommentEndBang(r);
        break;
      }
      case Dt.DOCTYPE: {
        this._stateDoctype(r);
        break;
      }
      case Dt.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(r);
        break;
      }
      case Dt.DOCTYPE_NAME: {
        this._stateDoctypeName(r);
        break;
      }
      case Dt.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(r);
        break;
      }
      case Dt.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(r);
        break;
      }
      case Dt.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(r);
        break;
      }
      case Dt.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(r);
        break;
      }
      case Dt.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(r);
        break;
      }
      case Dt.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(r);
        break;
      }
      case Dt.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(r);
        break;
      }
      case Dt.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(r);
        break;
      }
      case Dt.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(r);
        break;
      }
      case Dt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(r);
        break;
      }
      case Dt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(r);
        break;
      }
      case Dt.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(r);
        break;
      }
      case Dt.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(r);
        break;
      }
      case Dt.CDATA_SECTION: {
        this._stateCdataSection(r);
        break;
      }
      case Dt.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(r);
        break;
      }
      case Dt.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(r);
        break;
      }
      case Dt.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case Dt.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(r);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(r) {
    switch (r) {
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.TAG_OPEN;
        break;
      }
      case At.CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitCodePoint(r);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(r) {
    switch (r) {
      case At.CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(r) {
    switch (r) {
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(r) {
    switch (r) {
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(r) {
    switch (r) {
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(r) {
    if (Sl(r))
      this._createStartTagToken(), this.state = Dt.TAG_NAME, this._stateTagName(r);
    else
      switch (r) {
        case At.CODE_POINTS.EXCLAMATION_MARK: {
          this.state = Dt.MARKUP_DECLARATION_OPEN;
          break;
        }
        case At.CODE_POINTS.SOLIDUS: {
          this.state = Dt.END_TAG_OPEN;
          break;
        }
        case At.CODE_POINTS.QUESTION_MARK: {
          this._err(On.ERR.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = Dt.BOGUS_COMMENT, this._stateBogusComment(r);
          break;
        }
        case At.CODE_POINTS.EOF: {
          this._err(On.ERR.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(On.ERR.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = Dt.DATA, this._stateData(r);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(r) {
    if (Sl(r))
      this._createEndTagToken(), this.state = Dt.TAG_NAME, this._stateTagName(r);
    else
      switch (r) {
        case At.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(On.ERR.missingEndTagName), this.state = Dt.DATA;
          break;
        }
        case At.CODE_POINTS.EOF: {
          this._err(On.ERR.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(On.ERR.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = Dt.BOGUS_COMMENT, this._stateBogusComment(r);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this.state = Dt.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case At.CODE_POINTS.SOLIDUS: {
        this.state = Dt.SELF_CLOSING_START_TAG;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentTagToken();
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.tagName += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        a.tagName += String.fromCodePoint(My(r) ? k0(r) : r);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(r) {
    r === At.CODE_POINTS.SOLIDUS ? this.state = Dt.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = Dt.RCDATA, this._stateRcdata(r));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(r) {
    Sl(r) ? (this.state = Dt.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(r)) : (this._emitChars("</"), this.state = Dt.RCDATA, this._stateRcdata(r));
  }
  handleSpecialEndTag(r) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const a = this.currentToken;
    switch (a.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = Dt.BEFORE_ATTRIBUTE_NAME, !1;
      case At.CODE_POINTS.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = Dt.SELF_CLOSING_START_TAG, !1;
      case At.CODE_POINTS.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = Dt.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(r) {
    this.handleSpecialEndTag(r) && (this._emitChars("</"), this.state = Dt.RCDATA, this._stateRcdata(r));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(r) {
    r === At.CODE_POINTS.SOLIDUS ? this.state = Dt.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = Dt.RAWTEXT, this._stateRawtext(r));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(r) {
    Sl(r) ? (this.state = Dt.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(r)) : (this._emitChars("</"), this.state = Dt.RAWTEXT, this._stateRawtext(r));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(r) {
    this.handleSpecialEndTag(r) && (this._emitChars("</"), this.state = Dt.RAWTEXT, this._stateRawtext(r));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(r) {
    switch (r) {
      case At.CODE_POINTS.SOLIDUS: {
        this.state = Dt.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case At.CODE_POINTS.EXCLAMATION_MARK: {
        this.state = Dt.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = Dt.SCRIPT_DATA, this._stateScriptData(r);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(r) {
    Sl(r) ? (this.state = Dt.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(r)) : (this._emitChars("</"), this.state = Dt.SCRIPT_DATA, this._stateScriptData(r));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(r) {
    this.handleSpecialEndTag(r) && (this._emitChars("</"), this.state = Dt.SCRIPT_DATA, this._stateScriptData(r));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(r) {
    r === At.CODE_POINTS.HYPHEN_MINUS ? (this.state = Dt.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = Dt.SCRIPT_DATA, this._stateScriptData(r));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(r) {
    r === At.CODE_POINTS.HYPHEN_MINUS ? (this.state = Dt.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = Dt.SCRIPT_DATA, this._stateScriptData(r));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.state = Dt.SCRIPT_DATA_ESCAPED, this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Dt.SCRIPT_DATA_ESCAPED, this._emitCodePoint(r);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.state = Dt.SCRIPT_DATA_ESCAPED, this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Dt.SCRIPT_DATA_ESCAPED, this._emitCodePoint(r);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(r) {
    r === At.CODE_POINTS.SOLIDUS ? this.state = Dt.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Sl(r) ? (this._emitChars("<"), this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(r)) : (this._emitChars("<"), this.state = Dt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(r));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(r) {
    Sl(r) ? (this.state = Dt.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(r)) : (this._emitChars("</"), this.state = Dt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(r));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(r) {
    this.handleSpecialEndTag(r) && (this._emitChars("</"), this.state = Dt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(r));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(r) {
    if (this.preprocessor.startsWith(At.SEQUENCES.SCRIPT, !1) && qU(this.preprocessor.peek(At.SEQUENCES.SCRIPT.length))) {
      this._emitCodePoint(r);
      for (let a = 0; a < At.SEQUENCES.SCRIPT.length; a++)
        this._emitCodePoint(this._consume());
      this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = Dt.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(r));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(r);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(At.REPLACEMENT_CHARACTER);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(r);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(r) {
    r === At.CODE_POINTS.SOLIDUS ? (this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(r));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(r) {
    if (this.preprocessor.startsWith(At.SEQUENCES.SCRIPT, !1) && qU(this.preprocessor.peek(At.SEQUENCES.SCRIPT.length))) {
      this._emitCodePoint(r);
      for (let a = 0; a < At.SEQUENCES.SCRIPT.length; a++)
        this._emitCodePoint(this._consume());
      this.state = Dt.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = Dt.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(r));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.SOLIDUS:
      case At.CODE_POINTS.GREATER_THAN_SIGN:
      case At.CODE_POINTS.EOF: {
        this.state = Dt.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(r);
        break;
      }
      case At.CODE_POINTS.EQUALS_SIGN: {
        this._err(On.ERR.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Dt.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = Dt.ATTRIBUTE_NAME, this._stateAttributeName(r);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
      case At.CODE_POINTS.SOLIDUS:
      case At.CODE_POINTS.GREATER_THAN_SIGN:
      case At.CODE_POINTS.EOF: {
        this._leaveAttrName(), this.state = Dt.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(r);
        break;
      }
      case At.CODE_POINTS.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = Dt.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case At.CODE_POINTS.QUOTATION_MARK:
      case At.CODE_POINTS.APOSTROPHE:
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        this._err(On.ERR.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(r);
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.currentAttr.name += At.REPLACEMENT_CHARACTER;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(My(r) ? k0(r) : r);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.SOLIDUS: {
        this.state = Dt.SELF_CLOSING_START_TAG;
        break;
      }
      case At.CODE_POINTS.EQUALS_SIGN: {
        this.state = Dt.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentTagToken();
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = Dt.ATTRIBUTE_NAME, this._stateAttributeName(r);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.QUOTATION_MARK: {
        this.state = Dt.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        this.state = Dt.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.missingAttributeValue), this.state = Dt.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = Dt.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(r);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(r) {
    switch (r) {
      case At.CODE_POINTS.QUOTATION_MARK: {
        this.state = Dt.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case At.CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.currentAttr.value += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(r);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(r) {
    switch (r) {
      case At.CODE_POINTS.APOSTROPHE: {
        this.state = Dt.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case At.CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.currentAttr.value += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(r);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this._leaveAttrValue(), this.state = Dt.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case At.CODE_POINTS.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = Dt.DATA, this.emitCurrentTagToken();
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), this.currentAttr.value += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.QUOTATION_MARK:
      case At.CODE_POINTS.APOSTROPHE:
      case At.CODE_POINTS.LESS_THAN_SIGN:
      case At.CODE_POINTS.EQUALS_SIGN:
      case At.CODE_POINTS.GRAVE_ACCENT: {
        this._err(On.ERR.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(r);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(r);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this._leaveAttrValue(), this.state = Dt.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case At.CODE_POINTS.SOLIDUS: {
        this._leaveAttrValue(), this.state = Dt.SELF_CLOSING_START_TAG;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = Dt.DATA, this.emitCurrentTagToken();
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingWhitespaceBetweenAttributes), this.state = Dt.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(r);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(r) {
    switch (r) {
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        const a = this.currentToken;
        a.selfClosing = !0, this.state = Dt.DATA, this.emitCurrentTagToken();
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.unexpectedSolidusInTag), this.state = Dt.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(r);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentComment(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this.emitCurrentComment(a), this._emitEOFToken();
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.data += At.REPLACEMENT_CHARACTER;
        break;
      }
      default:
        a.data += String.fromCodePoint(r);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(r) {
    this._consumeSequenceIfMatch(At.SEQUENCES.DASH_DASH, !0) ? (this._createCommentToken(At.SEQUENCES.DASH_DASH.length + 1), this.state = Dt.COMMENT_START) : this._consumeSequenceIfMatch(At.SEQUENCES.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(At.SEQUENCES.DOCTYPE.length + 1), this.state = Dt.DOCTYPE) : this._consumeSequenceIfMatch(At.SEQUENCES.CDATA_START, !0) ? this.inForeignNode ? this.state = Dt.CDATA_SECTION : (this._err(On.ERR.cdataInHtmlContent), this._createCommentToken(At.SEQUENCES.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = Dt.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(On.ERR.incorrectlyOpenedComment), this._createCommentToken(2), this.state = Dt.BOGUS_COMMENT, this._stateBogusComment(r));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(r) {
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.COMMENT_START_DASH;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.abruptClosingOfEmptyComment), this.state = Dt.DATA;
        const a = this.currentToken;
        this.emitCurrentComment(a);
        break;
      }
      default:
        this.state = Dt.COMMENT, this._stateComment(r);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.COMMENT_END;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.abruptClosingOfEmptyComment), this.state = Dt.DATA, this.emitCurrentComment(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInComment), this.emitCurrentComment(a), this._emitEOFToken();
        break;
      }
      default:
        a.data += "-", this.state = Dt.COMMENT, this._stateComment(r);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.COMMENT_END_DASH;
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        a.data += "<", this.state = Dt.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.data += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInComment), this.emitCurrentComment(a), this._emitEOFToken();
        break;
      }
      default:
        a.data += String.fromCodePoint(r);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.EXCLAMATION_MARK: {
        a.data += "!", this.state = Dt.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case At.CODE_POINTS.LESS_THAN_SIGN: {
        a.data += "<";
        break;
      }
      default:
        this.state = Dt.COMMENT, this._stateComment(r);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(r) {
    r === At.CODE_POINTS.HYPHEN_MINUS ? this.state = Dt.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = Dt.COMMENT, this._stateComment(r));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(r) {
    r === At.CODE_POINTS.HYPHEN_MINUS ? this.state = Dt.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = Dt.COMMENT_END_DASH, this._stateCommentEndDash(r));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(r) {
    r !== At.CODE_POINTS.GREATER_THAN_SIGN && r !== At.CODE_POINTS.EOF && this._err(On.ERR.nestedComment), this.state = Dt.COMMENT_END, this._stateCommentEnd(r);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        this.state = Dt.COMMENT_END;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInComment), this.emitCurrentComment(a), this._emitEOFToken();
        break;
      }
      default:
        a.data += "-", this.state = Dt.COMMENT, this._stateComment(r);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentComment(a);
        break;
      }
      case At.CODE_POINTS.EXCLAMATION_MARK: {
        this.state = Dt.COMMENT_END_BANG;
        break;
      }
      case At.CODE_POINTS.HYPHEN_MINUS: {
        a.data += "-";
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInComment), this.emitCurrentComment(a), this._emitEOFToken();
        break;
      }
      default:
        a.data += "--", this.state = Dt.COMMENT, this._stateComment(r);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.HYPHEN_MINUS: {
        a.data += "--!", this.state = Dt.COMMENT_END_DASH;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.incorrectlyClosedComment), this.state = Dt.DATA, this.emitCurrentComment(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInComment), this.emitCurrentComment(a), this._emitEOFToken();
        break;
      }
      default:
        a.data += "--!", this.state = Dt.COMMENT, this._stateComment(r);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(r) {
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this.state = Dt.BEFORE_DOCTYPE_NAME;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(r);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), this._createDoctypeToken(null);
        const a = this.currentToken;
        a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingWhitespaceBeforeDoctypeName), this.state = Dt.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(r);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(r) {
    if (My(r))
      this._createDoctypeToken(String.fromCharCode(k0(r))), this.state = Dt.DOCTYPE_NAME;
    else
      switch (r) {
        case At.CODE_POINTS.SPACE:
        case At.CODE_POINTS.LINE_FEED:
        case At.CODE_POINTS.TABULATION:
        case At.CODE_POINTS.FORM_FEED:
          break;
        case At.CODE_POINTS.NULL: {
          this._err(On.ERR.unexpectedNullCharacter), this._createDoctypeToken(At.REPLACEMENT_CHARACTER), this.state = Dt.DOCTYPE_NAME;
          break;
        }
        case At.CODE_POINTS.GREATER_THAN_SIGN: {
          this._err(On.ERR.missingDoctypeName), this._createDoctypeToken(null);
          const a = this.currentToken;
          a.forceQuirks = !0, this.emitCurrentDoctype(a), this.state = Dt.DATA;
          break;
        }
        case At.CODE_POINTS.EOF: {
          this._err(On.ERR.eofInDoctype), this._createDoctypeToken(null);
          const a = this.currentToken;
          a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(r)), this.state = Dt.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this.state = Dt.AFTER_DOCTYPE_NAME;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.name += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        a.name += String.fromCodePoint(My(r) ? k0(r) : r);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(At.SEQUENCES.PUBLIC, !1) ? this.state = Dt.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(At.SEQUENCES.SYSTEM, !1) ? this.state = Dt.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(On.ERR.invalidCharacterSequenceAfterDoctypeName), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this.state = Dt.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case At.CODE_POINTS.QUOTATION_MARK: {
        this._err(On.ERR.missingWhitespaceAfterDoctypePublicKeyword), a.publicId = "", this.state = Dt.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        this._err(On.ERR.missingWhitespaceAfterDoctypePublicKeyword), a.publicId = "", this.state = Dt.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.missingDoctypePublicIdentifier), a.forceQuirks = !0, this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingQuoteBeforeDoctypePublicIdentifier), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.QUOTATION_MARK: {
        a.publicId = "", this.state = Dt.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        a.publicId = "", this.state = Dt.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.missingDoctypePublicIdentifier), a.forceQuirks = !0, this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingQuoteBeforeDoctypePublicIdentifier), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.QUOTATION_MARK: {
        this.state = Dt.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.publicId += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.abruptDoctypePublicIdentifier), a.forceQuirks = !0, this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        a.publicId += String.fromCodePoint(r);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.APOSTROPHE: {
        this.state = Dt.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.publicId += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.abruptDoctypePublicIdentifier), a.forceQuirks = !0, this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        a.publicId += String.fromCodePoint(r);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this.state = Dt.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.QUOTATION_MARK: {
        this._err(On.ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        this._err(On.ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingQuoteBeforeDoctypeSystemIdentifier), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.QUOTATION_MARK: {
        a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingQuoteBeforeDoctypeSystemIdentifier), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED: {
        this.state = Dt.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case At.CODE_POINTS.QUOTATION_MARK: {
        this._err(On.ERR.missingWhitespaceAfterDoctypeSystemKeyword), a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        this._err(On.ERR.missingWhitespaceAfterDoctypeSystemKeyword), a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.missingDoctypeSystemIdentifier), a.forceQuirks = !0, this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingQuoteBeforeDoctypeSystemIdentifier), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.QUOTATION_MARK: {
        a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.APOSTROPHE: {
        a.systemId = "", this.state = Dt.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.missingDoctypeSystemIdentifier), a.forceQuirks = !0, this.state = Dt.DATA, this.emitCurrentDoctype(a);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.missingQuoteBeforeDoctypeSystemIdentifier), a.forceQuirks = !0, this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.QUOTATION_MARK: {
        this.state = Dt.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.systemId += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.abruptDoctypeSystemIdentifier), a.forceQuirks = !0, this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        a.systemId += String.fromCodePoint(r);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.APOSTROPHE: {
        this.state = Dt.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter), a.systemId += At.REPLACEMENT_CHARACTER;
        break;
      }
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this._err(On.ERR.abruptDoctypeSystemIdentifier), a.forceQuirks = !0, this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        a.systemId += String.fromCodePoint(r);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.SPACE:
      case At.CODE_POINTS.LINE_FEED:
      case At.CODE_POINTS.TABULATION:
      case At.CODE_POINTS.FORM_FEED:
        break;
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInDoctype), a.forceQuirks = !0, this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
      default:
        this._err(On.ERR.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = Dt.BOGUS_DOCTYPE, this._stateBogusDoctype(r);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(r) {
    const a = this.currentToken;
    switch (r) {
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(a), this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.NULL: {
        this._err(On.ERR.unexpectedNullCharacter);
        break;
      }
      case At.CODE_POINTS.EOF: {
        this.emitCurrentDoctype(a), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(r) {
    switch (r) {
      case At.CODE_POINTS.RIGHT_SQUARE_BRACKET: {
        this.state = Dt.CDATA_SECTION_BRACKET;
        break;
      }
      case At.CODE_POINTS.EOF: {
        this._err(On.ERR.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(r);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(r) {
    r === At.CODE_POINTS.RIGHT_SQUARE_BRACKET ? this.state = Dt.CDATA_SECTION_END : (this._emitChars("]"), this.state = Dt.CDATA_SECTION, this._stateCdataSection(r));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(r) {
    switch (r) {
      case At.CODE_POINTS.GREATER_THAN_SIGN: {
        this.state = Dt.DATA;
        break;
      }
      case At.CODE_POINTS.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = Dt.CDATA_SECTION, this._stateCdataSection(r);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let r = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (r < 0)
      if (this.preprocessor.lastChunkWritten)
        r = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    r === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(At.CODE_POINTS.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && WU(this.preprocessor.peek(1)) ? Dt.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(r) {
    WU(r) ? this._flushCodePointConsumedAsCharacterReference(r) : (r === At.CODE_POINTS.SEMICOLON && this._err(On.ERR.unknownNamedCharacterReference), this.state = this.returnState, this._callState(r));
  }
};
dh.Tokenizer = v1e;
var TA = {};
Object.defineProperty(TA, "__esModule", { value: !0 });
TA.OpenElementStack = void 0;
const Mn = ss, hV = /* @__PURE__ */ new Set([Mn.TAG_ID.DD, Mn.TAG_ID.DT, Mn.TAG_ID.LI, Mn.TAG_ID.OPTGROUP, Mn.TAG_ID.OPTION, Mn.TAG_ID.P, Mn.TAG_ID.RB, Mn.TAG_ID.RP, Mn.TAG_ID.RT, Mn.TAG_ID.RTC]), KU = /* @__PURE__ */ new Set([
  ...hV,
  Mn.TAG_ID.CAPTION,
  Mn.TAG_ID.COLGROUP,
  Mn.TAG_ID.TBODY,
  Mn.TAG_ID.TD,
  Mn.TAG_ID.TFOOT,
  Mn.TAG_ID.TH,
  Mn.TAG_ID.THEAD,
  Mn.TAG_ID.TR
]), Ib = /* @__PURE__ */ new Set([
  Mn.TAG_ID.APPLET,
  Mn.TAG_ID.CAPTION,
  Mn.TAG_ID.HTML,
  Mn.TAG_ID.MARQUEE,
  Mn.TAG_ID.OBJECT,
  Mn.TAG_ID.TABLE,
  Mn.TAG_ID.TD,
  Mn.TAG_ID.TEMPLATE,
  Mn.TAG_ID.TH
]), T1e = /* @__PURE__ */ new Set([...Ib, Mn.TAG_ID.OL, Mn.TAG_ID.UL]), b1e = /* @__PURE__ */ new Set([...Ib, Mn.TAG_ID.BUTTON]), JU = /* @__PURE__ */ new Set([Mn.TAG_ID.ANNOTATION_XML, Mn.TAG_ID.MI, Mn.TAG_ID.MN, Mn.TAG_ID.MO, Mn.TAG_ID.MS, Mn.TAG_ID.MTEXT]), ZU = /* @__PURE__ */ new Set([Mn.TAG_ID.DESC, Mn.TAG_ID.FOREIGN_OBJECT, Mn.TAG_ID.TITLE]), A1e = /* @__PURE__ */ new Set([Mn.TAG_ID.TR, Mn.TAG_ID.TEMPLATE, Mn.TAG_ID.HTML]), O1e = /* @__PURE__ */ new Set([Mn.TAG_ID.TBODY, Mn.TAG_ID.TFOOT, Mn.TAG_ID.THEAD, Mn.TAG_ID.TEMPLATE, Mn.TAG_ID.HTML]), C1e = /* @__PURE__ */ new Set([Mn.TAG_ID.TABLE, Mn.TAG_ID.TEMPLATE, Mn.TAG_ID.HTML]), S1e = /* @__PURE__ */ new Set([Mn.TAG_ID.TD, Mn.TAG_ID.TH]);
class I1e {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(r, a, u) {
    this.treeAdapter = a, this.handler = u, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = Mn.TAG_ID.UNKNOWN, this.current = r;
  }
  //Index of element
  _indexOf(r) {
    return this.items.lastIndexOf(r, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === Mn.TAG_ID.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Mn.NS.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(r, a) {
    this.stackTop++, this.items[this.stackTop] = r, this.current = r, this.tagIDs[this.stackTop] = a, this.currentTagId = a, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(r, a, !0);
  }
  pop() {
    const r = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(r, !0);
  }
  replace(r, a) {
    const u = this._indexOf(r);
    this.items[u] = a, u === this.stackTop && (this.current = a);
  }
  insertAfter(r, a, u) {
    const h = this._indexOf(r) + 1;
    this.items.splice(h, 0, a), this.tagIDs.splice(h, 0, u), this.stackTop++, h === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, h === this.stackTop);
  }
  popUntilTagNamePopped(r) {
    let a = this.stackTop + 1;
    do
      a = this.tagIDs.lastIndexOf(r, a - 1);
    while (a > 0 && this.treeAdapter.getNamespaceURI(this.items[a]) !== Mn.NS.HTML);
    this.shortenToLength(a < 0 ? 0 : a);
  }
  shortenToLength(r) {
    for (; this.stackTop >= r; ) {
      const a = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(a, this.stackTop < r);
    }
  }
  popUntilElementPopped(r) {
    const a = this._indexOf(r);
    this.shortenToLength(a < 0 ? 0 : a);
  }
  popUntilPopped(r, a) {
    const u = this._indexOfTagNames(r, a);
    this.shortenToLength(u < 0 ? 0 : u);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(Mn.NUMBERED_HEADERS, Mn.NS.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(S1e, Mn.NS.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(r, a) {
    for (let u = this.stackTop; u >= 0; u--)
      if (r.has(this.tagIDs[u]) && this.treeAdapter.getNamespaceURI(this.items[u]) === a)
        return u;
    return -1;
  }
  clearBackTo(r, a) {
    const u = this._indexOfTagNames(r, a);
    this.shortenToLength(u + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(C1e, Mn.NS.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(O1e, Mn.NS.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(A1e, Mn.NS.HTML);
  }
  remove(r) {
    const a = this._indexOf(r);
    a >= 0 && (a === this.stackTop ? this.pop() : (this.items.splice(a, 1), this.tagIDs.splice(a, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(r, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === Mn.TAG_ID.BODY ? this.items[1] : null;
  }
  contains(r) {
    return this._indexOf(r) > -1;
  }
  getCommonAncestor(r) {
    const a = this._indexOf(r) - 1;
    return a >= 0 ? this.items[a] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === Mn.TAG_ID.HTML;
  }
  //Element in scope
  hasInDynamicScope(r, a) {
    for (let u = this.stackTop; u >= 0; u--) {
      const h = this.tagIDs[u];
      switch (this.treeAdapter.getNamespaceURI(this.items[u])) {
        case Mn.NS.HTML: {
          if (h === r)
            return !0;
          if (a.has(h))
            return !1;
          break;
        }
        case Mn.NS.SVG: {
          if (ZU.has(h))
            return !1;
          break;
        }
        case Mn.NS.MATHML: {
          if (JU.has(h))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(r) {
    return this.hasInDynamicScope(r, Ib);
  }
  hasInListItemScope(r) {
    return this.hasInDynamicScope(r, T1e);
  }
  hasInButtonScope(r) {
    return this.hasInDynamicScope(r, b1e);
  }
  hasNumberedHeaderInScope() {
    for (let r = this.stackTop; r >= 0; r--) {
      const a = this.tagIDs[r];
      switch (this.treeAdapter.getNamespaceURI(this.items[r])) {
        case Mn.NS.HTML: {
          if (Mn.NUMBERED_HEADERS.has(a))
            return !0;
          if (Ib.has(a))
            return !1;
          break;
        }
        case Mn.NS.SVG: {
          if (ZU.has(a))
            return !1;
          break;
        }
        case Mn.NS.MATHML: {
          if (JU.has(a))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(r) {
    for (let a = this.stackTop; a >= 0; a--)
      if (this.treeAdapter.getNamespaceURI(this.items[a]) === Mn.NS.HTML)
        switch (this.tagIDs[a]) {
          case r:
            return !0;
          case Mn.TAG_ID.TABLE:
          case Mn.TAG_ID.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let r = this.stackTop; r >= 0; r--)
      if (this.treeAdapter.getNamespaceURI(this.items[r]) === Mn.NS.HTML)
        switch (this.tagIDs[r]) {
          case Mn.TAG_ID.TBODY:
          case Mn.TAG_ID.THEAD:
          case Mn.TAG_ID.TFOOT:
            return !0;
          case Mn.TAG_ID.TABLE:
          case Mn.TAG_ID.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(r) {
    for (let a = this.stackTop; a >= 0; a--)
      if (this.treeAdapter.getNamespaceURI(this.items[a]) === Mn.NS.HTML)
        switch (this.tagIDs[a]) {
          case r:
            return !0;
          case Mn.TAG_ID.OPTION:
          case Mn.TAG_ID.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; hV.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; KU.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(r) {
    for (; this.currentTagId !== r && KU.has(this.currentTagId); )
      this.pop();
  }
}
TA.OpenElementStack = I1e;
var wm = {};
Object.defineProperty(wm, "__esModule", { value: !0 });
wm.FormattingElementList = wm.EntryType = void 0;
const WR = 3;
var Sd;
(function(t) {
  t[t.Marker = 0] = "Marker", t[t.Element = 1] = "Element";
})(Sd || (wm.EntryType = Sd = {}));
const QU = { type: Sd.Marker };
class R1e {
  constructor(r) {
    this.treeAdapter = r, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(r, a) {
    const u = [], h = a.length, b = this.treeAdapter.getTagName(r), l = this.treeAdapter.getNamespaceURI(r);
    for (let v = 0; v < this.entries.length; v++) {
      const s = this.entries[v];
      if (s.type === Sd.Marker)
        break;
      const { element: c } = s;
      if (this.treeAdapter.getTagName(c) === b && this.treeAdapter.getNamespaceURI(c) === l) {
        const d = this.treeAdapter.getAttrList(c);
        d.length === h && u.push({ idx: v, attrs: d });
      }
    }
    return u;
  }
  _ensureNoahArkCondition(r) {
    if (this.entries.length < WR)
      return;
    const a = this.treeAdapter.getAttrList(r), u = this._getNoahArkConditionCandidates(r, a);
    if (u.length < WR)
      return;
    const h = new Map(a.map((l) => [l.name, l.value]));
    let b = 0;
    for (let l = 0; l < u.length; l++) {
      const v = u[l];
      v.attrs.every((s) => h.get(s.name) === s.value) && (b += 1, b >= WR && this.entries.splice(v.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(QU);
  }
  pushElement(r, a) {
    this._ensureNoahArkCondition(r), this.entries.unshift({
      type: Sd.Element,
      element: r,
      token: a
    });
  }
  insertElementAfterBookmark(r, a) {
    const u = this.entries.indexOf(this.bookmark);
    this.entries.splice(u, 0, {
      type: Sd.Element,
      element: r,
      token: a
    });
  }
  removeEntry(r) {
    const a = this.entries.indexOf(r);
    a >= 0 && this.entries.splice(a, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const r = this.entries.indexOf(QU);
    r >= 0 ? this.entries.splice(0, r + 1) : this.entries.length = 0;
  }
  //Search
  getElementEntryInScopeWithTagName(r) {
    const a = this.entries.find((u) => u.type === Sd.Marker || this.treeAdapter.getTagName(u.element) === r);
    return a && a.type === Sd.Element ? a : null;
  }
  getElementEntry(r) {
    return this.entries.find((a) => a.type === Sd.Element && a.element === r);
  }
}
wm.FormattingElementList = R1e;
var bA = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.defaultTreeAdapter = void 0;
  const r = ss;
  t.defaultTreeAdapter = {
    //Node construction
    createDocument() {
      return {
        nodeName: "#document",
        mode: r.DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
      };
    },
    createDocumentFragment() {
      return {
        nodeName: "#document-fragment",
        childNodes: []
      };
    },
    createElement(a, u, h) {
      return {
        nodeName: a,
        tagName: a,
        attrs: h,
        namespaceURI: u,
        childNodes: [],
        parentNode: null
      };
    },
    createCommentNode(a) {
      return {
        nodeName: "#comment",
        data: a,
        parentNode: null
      };
    },
    createTextNode(a) {
      return {
        nodeName: "#text",
        value: a,
        parentNode: null
      };
    },
    //Tree mutation
    appendChild(a, u) {
      a.childNodes.push(u), u.parentNode = a;
    },
    insertBefore(a, u, h) {
      const b = a.childNodes.indexOf(h);
      a.childNodes.splice(b, 0, u), u.parentNode = a;
    },
    setTemplateContent(a, u) {
      a.content = u;
    },
    getTemplateContent(a) {
      return a.content;
    },
    setDocumentType(a, u, h, b) {
      const l = a.childNodes.find((v) => v.nodeName === "#documentType");
      if (l)
        l.name = u, l.publicId = h, l.systemId = b;
      else {
        const v = {
          nodeName: "#documentType",
          name: u,
          publicId: h,
          systemId: b,
          parentNode: null
        };
        t.defaultTreeAdapter.appendChild(a, v);
      }
    },
    setDocumentMode(a, u) {
      a.mode = u;
    },
    getDocumentMode(a) {
      return a.mode;
    },
    detachNode(a) {
      if (a.parentNode) {
        const u = a.parentNode.childNodes.indexOf(a);
        a.parentNode.childNodes.splice(u, 1), a.parentNode = null;
      }
    },
    insertText(a, u) {
      if (a.childNodes.length > 0) {
        const h = a.childNodes[a.childNodes.length - 1];
        if (t.defaultTreeAdapter.isTextNode(h)) {
          h.value += u;
          return;
        }
      }
      t.defaultTreeAdapter.appendChild(a, t.defaultTreeAdapter.createTextNode(u));
    },
    insertTextBefore(a, u, h) {
      const b = a.childNodes[a.childNodes.indexOf(h) - 1];
      b && t.defaultTreeAdapter.isTextNode(b) ? b.value += u : t.defaultTreeAdapter.insertBefore(a, t.defaultTreeAdapter.createTextNode(u), h);
    },
    adoptAttributes(a, u) {
      const h = new Set(a.attrs.map((b) => b.name));
      for (let b = 0; b < u.length; b++)
        h.has(u[b].name) || a.attrs.push(u[b]);
    },
    //Tree traversing
    getFirstChild(a) {
      return a.childNodes[0];
    },
    getChildNodes(a) {
      return a.childNodes;
    },
    getParentNode(a) {
      return a.parentNode;
    },
    getAttrList(a) {
      return a.attrs;
    },
    //Node data
    getTagName(a) {
      return a.tagName;
    },
    getNamespaceURI(a) {
      return a.namespaceURI;
    },
    getTextNodeContent(a) {
      return a.value;
    },
    getCommentNodeContent(a) {
      return a.data;
    },
    getDocumentTypeNodeName(a) {
      return a.name;
    },
    getDocumentTypeNodePublicId(a) {
      return a.publicId;
    },
    getDocumentTypeNodeSystemId(a) {
      return a.systemId;
    },
    //Node types
    isTextNode(a) {
      return a.nodeName === "#text";
    },
    isCommentNode(a) {
      return a.nodeName === "#comment";
    },
    isDocumentTypeNode(a) {
      return a.nodeName === "#documentType";
    },
    isElementNode(a) {
      return Object.prototype.hasOwnProperty.call(a, "tagName");
    },
    // Source code location
    setNodeSourceCodeLocation(a, u) {
      a.sourceCodeLocation = u;
    },
    getNodeSourceCodeLocation(a) {
      return a.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation(a, u) {
      a.sourceCodeLocation = Object.assign(Object.assign({}, a.sourceCodeLocation), u);
    }
  };
})(bA);
var AA = {};
Object.defineProperty(AA, "__esModule", { value: !0 });
AA.isConforming = D1e;
AA.getDocumentMode = M1e;
const Hp = ss, pV = "html", N1e = "about:legacy-compat", w1e = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", gV = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], _1e = [
  ...gV,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], P1e = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), mV = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], x1e = [
  ...mV,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function $U(t, r) {
  return r.some((a) => t.startsWith(a));
}
function D1e(t) {
  return t.name === pV && t.publicId === null && (t.systemId === null || t.systemId === N1e);
}
function M1e(t) {
  if (t.name !== pV)
    return Hp.DOCUMENT_MODE.QUIRKS;
  const { systemId: r } = t;
  if (r && r.toLowerCase() === w1e)
    return Hp.DOCUMENT_MODE.QUIRKS;
  let { publicId: a } = t;
  if (a !== null) {
    if (a = a.toLowerCase(), P1e.has(a))
      return Hp.DOCUMENT_MODE.QUIRKS;
    let u = r === null ? _1e : gV;
    if ($U(a, u))
      return Hp.DOCUMENT_MODE.QUIRKS;
    if (u = r === null ? mV : x1e, $U(a, u))
      return Hp.DOCUMENT_MODE.LIMITED_QUIRKS;
  }
  return Hp.DOCUMENT_MODE.NO_QUIRKS;
}
var zw = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.SVG_TAG_NAMES_ADJUSTMENT_MAP = void 0, t.causesExit = s, t.adjustTokenMathMLAttrs = c, t.adjustTokenSVGAttrs = d, t.adjustTokenXMLAttrs = p, t.adjustTokenSVGTagName = m, t.isIntegrationPoint = g;
  const r = ss, a = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
  }, u = "definitionurl", h = "definitionURL", b = new Map([
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
  ].map((C) => [C.toLowerCase(), C])), l = /* @__PURE__ */ new Map([
    ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: r.NS.XLINK }],
    ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: r.NS.XLINK }],
    ["xlink:href", { prefix: "xlink", name: "href", namespace: r.NS.XLINK }],
    ["xlink:role", { prefix: "xlink", name: "role", namespace: r.NS.XLINK }],
    ["xlink:show", { prefix: "xlink", name: "show", namespace: r.NS.XLINK }],
    ["xlink:title", { prefix: "xlink", name: "title", namespace: r.NS.XLINK }],
    ["xlink:type", { prefix: "xlink", name: "type", namespace: r.NS.XLINK }],
    ["xml:lang", { prefix: "xml", name: "lang", namespace: r.NS.XML }],
    ["xml:space", { prefix: "xml", name: "space", namespace: r.NS.XML }],
    ["xmlns", { prefix: "", name: "xmlns", namespace: r.NS.XMLNS }],
    ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: r.NS.XMLNS }]
  ]);
  t.SVG_TAG_NAMES_ADJUSTMENT_MAP = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
  ].map((C) => [C.toLowerCase(), C]));
  const v = /* @__PURE__ */ new Set([
    r.TAG_ID.B,
    r.TAG_ID.BIG,
    r.TAG_ID.BLOCKQUOTE,
    r.TAG_ID.BODY,
    r.TAG_ID.BR,
    r.TAG_ID.CENTER,
    r.TAG_ID.CODE,
    r.TAG_ID.DD,
    r.TAG_ID.DIV,
    r.TAG_ID.DL,
    r.TAG_ID.DT,
    r.TAG_ID.EM,
    r.TAG_ID.EMBED,
    r.TAG_ID.H1,
    r.TAG_ID.H2,
    r.TAG_ID.H3,
    r.TAG_ID.H4,
    r.TAG_ID.H5,
    r.TAG_ID.H6,
    r.TAG_ID.HEAD,
    r.TAG_ID.HR,
    r.TAG_ID.I,
    r.TAG_ID.IMG,
    r.TAG_ID.LI,
    r.TAG_ID.LISTING,
    r.TAG_ID.MENU,
    r.TAG_ID.META,
    r.TAG_ID.NOBR,
    r.TAG_ID.OL,
    r.TAG_ID.P,
    r.TAG_ID.PRE,
    r.TAG_ID.RUBY,
    r.TAG_ID.S,
    r.TAG_ID.SMALL,
    r.TAG_ID.SPAN,
    r.TAG_ID.STRONG,
    r.TAG_ID.STRIKE,
    r.TAG_ID.SUB,
    r.TAG_ID.SUP,
    r.TAG_ID.TABLE,
    r.TAG_ID.TT,
    r.TAG_ID.U,
    r.TAG_ID.UL,
    r.TAG_ID.VAR
  ]);
  function s(C) {
    const O = C.tagID;
    return O === r.TAG_ID.FONT && C.attrs.some(({ name: w }) => w === r.ATTRS.COLOR || w === r.ATTRS.SIZE || w === r.ATTRS.FACE) || v.has(O);
  }
  function c(C) {
    for (let O = 0; O < C.attrs.length; O++)
      if (C.attrs[O].name === u) {
        C.attrs[O].name = h;
        break;
      }
  }
  function d(C) {
    for (let O = 0; O < C.attrs.length; O++) {
      const N = b.get(C.attrs[O].name);
      N != null && (C.attrs[O].name = N);
    }
  }
  function p(C) {
    for (let O = 0; O < C.attrs.length; O++) {
      const N = l.get(C.attrs[O].name);
      N && (C.attrs[O].prefix = N.prefix, C.attrs[O].name = N.name, C.attrs[O].namespace = N.namespace);
    }
  }
  function m(C) {
    const O = t.SVG_TAG_NAMES_ADJUSTMENT_MAP.get(C.tagName);
    O != null && (C.tagName = O, C.tagID = (0, r.getTagID)(C.tagName));
  }
  function E(C, O) {
    return O === r.NS.MATHML && (C === r.TAG_ID.MI || C === r.TAG_ID.MO || C === r.TAG_ID.MN || C === r.TAG_ID.MS || C === r.TAG_ID.MTEXT);
  }
  function y(C, O, N) {
    if (O === r.NS.MATHML && C === r.TAG_ID.ANNOTATION_XML) {
      for (let w = 0; w < N.length; w++)
        if (N[w].name === r.ATTRS.ENCODING) {
          const _ = N[w].value.toLowerCase();
          return _ === a.TEXT_HTML || _ === a.APPLICATION_XML;
        }
    }
    return O === r.NS.SVG && (C === r.TAG_ID.FOREIGN_OBJECT || C === r.TAG_ID.DESC || C === r.TAG_ID.TITLE);
  }
  function g(C, O, N, w) {
    return (!w || w === r.NS.HTML) && y(C, O, N) || (!w || w === r.NS.MATHML) && E(C, O);
  }
})(zw);
Object.defineProperty(rv, "__esModule", { value: !0 });
rv.Parser = void 0;
const Wa = dh, L1e = TA, eH = wm, k1e = bA, tH = AA, Mu = zw, Ta = Th, EV = Ka, Ue = ss, Js = bh, j1e = "hidden", U1e = 8, H1e = 3;
var Bt;
(function(t) {
  t[t.INITIAL = 0] = "INITIAL", t[t.BEFORE_HTML = 1] = "BEFORE_HTML", t[t.BEFORE_HEAD = 2] = "BEFORE_HEAD", t[t.IN_HEAD = 3] = "IN_HEAD", t[t.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", t[t.AFTER_HEAD = 5] = "AFTER_HEAD", t[t.IN_BODY = 6] = "IN_BODY", t[t.TEXT = 7] = "TEXT", t[t.IN_TABLE = 8] = "IN_TABLE", t[t.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", t[t.IN_CAPTION = 10] = "IN_CAPTION", t[t.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", t[t.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", t[t.IN_ROW = 13] = "IN_ROW", t[t.IN_CELL = 14] = "IN_CELL", t[t.IN_SELECT = 15] = "IN_SELECT", t[t.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", t[t.IN_TEMPLATE = 17] = "IN_TEMPLATE", t[t.AFTER_BODY = 18] = "AFTER_BODY", t[t.IN_FRAMESET = 19] = "IN_FRAMESET", t[t.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", t[t.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", t[t.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(Bt || (Bt = {}));
const B1e = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, yV = /* @__PURE__ */ new Set([Ue.TAG_ID.TABLE, Ue.TAG_ID.TBODY, Ue.TAG_ID.TFOOT, Ue.TAG_ID.THEAD, Ue.TAG_ID.TR]), nH = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: k1e.defaultTreeAdapter,
  onParseError: null
};
let z1e = class {
  constructor(r, a, u = null, h = null) {
    this.fragmentContext = u, this.scriptHandler = h, this.currentToken = null, this.stopped = !1, this.insertionMode = Bt.INITIAL, this.originalInsertionMode = Bt.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = Object.assign(Object.assign({}, nH), r), this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = a ?? this.treeAdapter.createDocument(), this.tokenizer = new Wa.Tokenizer(this.options, this), this.activeFormattingElements = new eH.FormattingElementList(this.treeAdapter), this.fragmentContextID = u ? (0, Ue.getTagID)(this.treeAdapter.getTagName(u)) : Ue.TAG_ID.UNKNOWN, this._setContextModes(u ?? this.document, this.fragmentContextID), this.openElements = new L1e.OpenElementStack(this.document, this.treeAdapter, this);
  }
  // API
  static parse(r, a) {
    const u = new this(a);
    return u.tokenizer.write(r, !0), u.document;
  }
  static getFragmentParser(r, a) {
    const u = Object.assign(Object.assign({}, nH), a);
    r ?? (r = u.treeAdapter.createElement(Ue.TAG_NAMES.TEMPLATE, Ue.NS.HTML, []));
    const h = u.treeAdapter.createElement("documentmock", Ue.NS.HTML, []), b = new this(u, h, r);
    return b.fragmentContextID === Ue.TAG_ID.TEMPLATE && b.tmplInsertionModeStack.unshift(Bt.IN_TEMPLATE), b._initTokenizerForFragmentParsing(), b._insertFakeRootElement(), b._resetInsertionMode(), b._findFormInFragmentContext(), b;
  }
  getFragment() {
    const r = this.treeAdapter.getFirstChild(this.document), a = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(r, a), a;
  }
  //Errors
  /** @internal */
  _err(r, a, u) {
    var h;
    if (!this.onParseError)
      return;
    const b = (h = r.location) !== null && h !== void 0 ? h : B1e, l = {
      code: a,
      startLine: b.startLine,
      startCol: b.startCol,
      startOffset: b.startOffset,
      endLine: u ? b.startLine : b.endLine,
      endCol: u ? b.startCol : b.endCol,
      endOffset: u ? b.startOffset : b.endOffset
    };
    this.onParseError(l);
  }
  //Stack events
  /** @internal */
  onItemPush(r, a, u) {
    var h, b;
    (b = (h = this.treeAdapter).onItemPush) === null || b === void 0 || b.call(h, r), u && this.openElements.stackTop > 0 && this._setContextModes(r, a);
  }
  /** @internal */
  onItemPop(r, a) {
    var u, h;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(r, this.currentToken), (h = (u = this.treeAdapter).onItemPop) === null || h === void 0 || h.call(u, r, this.openElements.current), a) {
      let b, l;
      this.openElements.stackTop === 0 && this.fragmentContext ? (b = this.fragmentContext, l = this.fragmentContextID) : { current: b, currentTagId: l } = this.openElements, this._setContextModes(b, l);
    }
  }
  _setContextModes(r, a) {
    const u = r === this.document || this.treeAdapter.getNamespaceURI(r) === Ue.NS.HTML;
    this.currentNotInHTML = !u, this.tokenizer.inForeignNode = !u && !this._isIntegrationPoint(a, r);
  }
  /** @protected */
  _switchToTextParsing(r, a) {
    this._insertElement(r, Ue.NS.HTML), this.tokenizer.state = a, this.originalInsertionMode = this.insertionMode, this.insertionMode = Bt.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Bt.TEXT, this.originalInsertionMode = Bt.IN_BODY, this.tokenizer.state = Wa.TokenizerMode.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let r = this.fragmentContext;
    for (; r; ) {
      if (this.treeAdapter.getTagName(r) === Ue.TAG_NAMES.FORM) {
        this.formElement = r;
        break;
      }
      r = this.treeAdapter.getParentNode(r);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== Ue.NS.HTML))
      switch (this.fragmentContextID) {
        case Ue.TAG_ID.TITLE:
        case Ue.TAG_ID.TEXTAREA: {
          this.tokenizer.state = Wa.TokenizerMode.RCDATA;
          break;
        }
        case Ue.TAG_ID.STYLE:
        case Ue.TAG_ID.XMP:
        case Ue.TAG_ID.IFRAME:
        case Ue.TAG_ID.NOEMBED:
        case Ue.TAG_ID.NOFRAMES:
        case Ue.TAG_ID.NOSCRIPT: {
          this.tokenizer.state = Wa.TokenizerMode.RAWTEXT;
          break;
        }
        case Ue.TAG_ID.SCRIPT: {
          this.tokenizer.state = Wa.TokenizerMode.SCRIPT_DATA;
          break;
        }
        case Ue.TAG_ID.PLAINTEXT: {
          this.tokenizer.state = Wa.TokenizerMode.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(r) {
    const a = r.name || "", u = r.publicId || "", h = r.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, a, u, h), r.location) {
      const l = this.treeAdapter.getChildNodes(this.document).find((v) => this.treeAdapter.isDocumentTypeNode(v));
      l && this.treeAdapter.setNodeSourceCodeLocation(l, r.location);
    }
  }
  /** @protected */
  _attachElementToTree(r, a) {
    if (this.options.sourceCodeLocationInfo) {
      const u = a && Object.assign(Object.assign({}, a), { startTag: a });
      this.treeAdapter.setNodeSourceCodeLocation(r, u);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(r);
    else {
      const u = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(u, r);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(r, a) {
    const u = this.treeAdapter.createElement(r.tagName, a, r.attrs);
    this._attachElementToTree(u, r.location);
  }
  /** @protected */
  _insertElement(r, a) {
    const u = this.treeAdapter.createElement(r.tagName, a, r.attrs);
    this._attachElementToTree(u, r.location), this.openElements.push(u, r.tagID);
  }
  /** @protected */
  _insertFakeElement(r, a) {
    const u = this.treeAdapter.createElement(r, Ue.NS.HTML, []);
    this._attachElementToTree(u, null), this.openElements.push(u, a);
  }
  /** @protected */
  _insertTemplate(r) {
    const a = this.treeAdapter.createElement(r.tagName, Ue.NS.HTML, r.attrs), u = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(a, u), this._attachElementToTree(a, r.location), this.openElements.push(a, r.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(u, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const r = this.treeAdapter.createElement(Ue.TAG_NAMES.HTML, Ue.NS.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null), this.treeAdapter.appendChild(this.openElements.current, r), this.openElements.push(r, Ue.TAG_ID.HTML);
  }
  /** @protected */
  _appendCommentNode(r, a) {
    const u = this.treeAdapter.createCommentNode(r.data);
    this.treeAdapter.appendChild(a, u), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(u, r.location);
  }
  /** @protected */
  _insertCharacters(r) {
    let a, u;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: a, beforeElement: u } = this._findFosterParentingLocation(), u ? this.treeAdapter.insertTextBefore(a, r.chars, u) : this.treeAdapter.insertText(a, r.chars)) : (a = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(a, r.chars)), !r.location)
      return;
    const h = this.treeAdapter.getChildNodes(a), b = u ? h.lastIndexOf(u) : h.length, l = h[b - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(l)) {
      const { endLine: s, endCol: c, endOffset: d } = r.location;
      this.treeAdapter.updateNodeSourceCodeLocation(l, { endLine: s, endCol: c, endOffset: d });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(l, r.location);
  }
  /** @protected */
  _adoptNodes(r, a) {
    for (let u = this.treeAdapter.getFirstChild(r); u; u = this.treeAdapter.getFirstChild(r))
      this.treeAdapter.detachNode(u), this.treeAdapter.appendChild(a, u);
  }
  /** @protected */
  _setEndLocation(r, a) {
    if (this.treeAdapter.getNodeSourceCodeLocation(r) && a.location) {
      const u = a.location, h = this.treeAdapter.getTagName(r), b = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        a.type === Js.TokenType.END_TAG && h === a.tagName ? {
          endTag: Object.assign({}, u),
          endLine: u.endLine,
          endCol: u.endCol,
          endOffset: u.endOffset
        } : {
          endLine: u.startLine,
          endCol: u.startCol,
          endOffset: u.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(r, b);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(r) {
    if (!this.currentNotInHTML)
      return !1;
    let a, u;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (a = this.fragmentContext, u = this.fragmentContextID) : { current: a, currentTagId: u } = this.openElements, r.tagID === Ue.TAG_ID.SVG && this.treeAdapter.getTagName(a) === Ue.TAG_NAMES.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(a) === Ue.NS.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (r.tagID === Ue.TAG_ID.MGLYPH || r.tagID === Ue.TAG_ID.MALIGNMARK) && !this._isIntegrationPoint(u, a, Ue.NS.HTML)
    );
  }
  /** @protected */
  _processToken(r) {
    switch (r.type) {
      case Js.TokenType.CHARACTER: {
        this.onCharacter(r);
        break;
      }
      case Js.TokenType.NULL_CHARACTER: {
        this.onNullCharacter(r);
        break;
      }
      case Js.TokenType.COMMENT: {
        this.onComment(r);
        break;
      }
      case Js.TokenType.DOCTYPE: {
        this.onDoctype(r);
        break;
      }
      case Js.TokenType.START_TAG: {
        this._processStartTag(r);
        break;
      }
      case Js.TokenType.END_TAG: {
        this.onEndTag(r);
        break;
      }
      case Js.TokenType.EOF: {
        this.onEof(r);
        break;
      }
      case Js.TokenType.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(r);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(r, a, u) {
    const h = this.treeAdapter.getNamespaceURI(a), b = this.treeAdapter.getAttrList(a);
    return Mu.isIntegrationPoint(r, h, b, u);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const r = this.activeFormattingElements.entries.length;
    if (r) {
      const a = this.activeFormattingElements.entries.findIndex((h) => h.type === eH.EntryType.Marker || this.openElements.contains(h.element)), u = a < 0 ? r - 1 : a - 1;
      for (let h = u; h >= 0; h--) {
        const b = this.activeFormattingElements.entries[h];
        this._insertElement(b.token, this.treeAdapter.getNamespaceURI(b.element)), b.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Bt.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(Ue.TAG_ID.P), this.openElements.popUntilTagNamePopped(Ue.TAG_ID.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let r = this.openElements.stackTop; r >= 0; r--)
      switch (r === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[r]) {
        case Ue.TAG_ID.TR: {
          this.insertionMode = Bt.IN_ROW;
          return;
        }
        case Ue.TAG_ID.TBODY:
        case Ue.TAG_ID.THEAD:
        case Ue.TAG_ID.TFOOT: {
          this.insertionMode = Bt.IN_TABLE_BODY;
          return;
        }
        case Ue.TAG_ID.CAPTION: {
          this.insertionMode = Bt.IN_CAPTION;
          return;
        }
        case Ue.TAG_ID.COLGROUP: {
          this.insertionMode = Bt.IN_COLUMN_GROUP;
          return;
        }
        case Ue.TAG_ID.TABLE: {
          this.insertionMode = Bt.IN_TABLE;
          return;
        }
        case Ue.TAG_ID.BODY: {
          this.insertionMode = Bt.IN_BODY;
          return;
        }
        case Ue.TAG_ID.FRAMESET: {
          this.insertionMode = Bt.IN_FRAMESET;
          return;
        }
        case Ue.TAG_ID.SELECT: {
          this._resetInsertionModeForSelect(r);
          return;
        }
        case Ue.TAG_ID.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case Ue.TAG_ID.HTML: {
          this.insertionMode = this.headElement ? Bt.AFTER_HEAD : Bt.BEFORE_HEAD;
          return;
        }
        case Ue.TAG_ID.TD:
        case Ue.TAG_ID.TH: {
          if (r > 0) {
            this.insertionMode = Bt.IN_CELL;
            return;
          }
          break;
        }
        case Ue.TAG_ID.HEAD: {
          if (r > 0) {
            this.insertionMode = Bt.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = Bt.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(r) {
    if (r > 0)
      for (let a = r - 1; a > 0; a--) {
        const u = this.openElements.tagIDs[a];
        if (u === Ue.TAG_ID.TEMPLATE)
          break;
        if (u === Ue.TAG_ID.TABLE) {
          this.insertionMode = Bt.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = Bt.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(r) {
    return yV.has(r);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let r = this.openElements.stackTop; r >= 0; r--) {
      const a = this.openElements.items[r];
      switch (this.openElements.tagIDs[r]) {
        case Ue.TAG_ID.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(a) === Ue.NS.HTML)
            return { parent: this.treeAdapter.getTemplateContent(a), beforeElement: null };
          break;
        }
        case Ue.TAG_ID.TABLE: {
          const u = this.treeAdapter.getParentNode(a);
          return u ? { parent: u, beforeElement: a } : { parent: this.openElements.items[r - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(r) {
    const a = this._findFosterParentingLocation();
    a.beforeElement ? this.treeAdapter.insertBefore(a.parent, r, a.beforeElement) : this.treeAdapter.appendChild(a.parent, r);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(r, a) {
    const u = this.treeAdapter.getNamespaceURI(r);
    return Ue.SPECIAL_ELEMENTS[u].has(a);
  }
  /** @internal */
  onCharacter(r) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      E0e(this, r);
      return;
    }
    switch (this.insertionMode) {
      case Bt.INITIAL: {
        Sy(this, r);
        break;
      }
      case Bt.BEFORE_HTML: {
        zy(this, r);
        break;
      }
      case Bt.BEFORE_HEAD: {
        Fy(this, r);
        break;
      }
      case Bt.IN_HEAD: {
        Gy(this, r);
        break;
      }
      case Bt.IN_HEAD_NO_SCRIPT: {
        Vy(this, r);
        break;
      }
      case Bt.AFTER_HEAD: {
        Yy(this, r);
        break;
      }
      case Bt.IN_BODY:
      case Bt.IN_CAPTION:
      case Bt.IN_CELL:
      case Bt.IN_TEMPLATE: {
        TV(this, r);
        break;
      }
      case Bt.TEXT:
      case Bt.IN_SELECT:
      case Bt.IN_SELECT_IN_TABLE: {
        this._insertCharacters(r);
        break;
      }
      case Bt.IN_TABLE:
      case Bt.IN_TABLE_BODY:
      case Bt.IN_ROW: {
        qR(this, r);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        IV(this, r);
        break;
      }
      case Bt.IN_COLUMN_GROUP: {
        Rb(this, r);
        break;
      }
      case Bt.AFTER_BODY: {
        Nb(this, r);
        break;
      }
      case Bt.AFTER_AFTER_BODY: {
        Q0(this, r);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(r) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      m0e(this, r);
      return;
    }
    switch (this.insertionMode) {
      case Bt.INITIAL: {
        Sy(this, r);
        break;
      }
      case Bt.BEFORE_HTML: {
        zy(this, r);
        break;
      }
      case Bt.BEFORE_HEAD: {
        Fy(this, r);
        break;
      }
      case Bt.IN_HEAD: {
        Gy(this, r);
        break;
      }
      case Bt.IN_HEAD_NO_SCRIPT: {
        Vy(this, r);
        break;
      }
      case Bt.AFTER_HEAD: {
        Yy(this, r);
        break;
      }
      case Bt.TEXT: {
        this._insertCharacters(r);
        break;
      }
      case Bt.IN_TABLE:
      case Bt.IN_TABLE_BODY:
      case Bt.IN_ROW: {
        qR(this, r);
        break;
      }
      case Bt.IN_COLUMN_GROUP: {
        Rb(this, r);
        break;
      }
      case Bt.AFTER_BODY: {
        Nb(this, r);
        break;
      }
      case Bt.AFTER_AFTER_BODY: {
        Q0(this, r);
        break;
      }
    }
  }
  /** @internal */
  onComment(r) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      pN(this, r);
      return;
    }
    switch (this.insertionMode) {
      case Bt.INITIAL:
      case Bt.BEFORE_HTML:
      case Bt.BEFORE_HEAD:
      case Bt.IN_HEAD:
      case Bt.IN_HEAD_NO_SCRIPT:
      case Bt.AFTER_HEAD:
      case Bt.IN_BODY:
      case Bt.IN_TABLE:
      case Bt.IN_CAPTION:
      case Bt.IN_COLUMN_GROUP:
      case Bt.IN_TABLE_BODY:
      case Bt.IN_ROW:
      case Bt.IN_CELL:
      case Bt.IN_SELECT:
      case Bt.IN_SELECT_IN_TABLE:
      case Bt.IN_TEMPLATE:
      case Bt.IN_FRAMESET:
      case Bt.AFTER_FRAMESET: {
        pN(this, r);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        Iy(this, r);
        break;
      }
      case Bt.AFTER_BODY: {
        q1e(this, r);
        break;
      }
      case Bt.AFTER_AFTER_BODY:
      case Bt.AFTER_AFTER_FRAMESET: {
        K1e(this, r);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(r) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case Bt.INITIAL: {
        J1e(this, r);
        break;
      }
      case Bt.BEFORE_HEAD:
      case Bt.IN_HEAD:
      case Bt.IN_HEAD_NO_SCRIPT:
      case Bt.AFTER_HEAD: {
        this._err(r, Ta.ERR.misplacedDoctype);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        Iy(this, r);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(r) {
    this.skipNextNewLine = !1, this.currentToken = r, this._processStartTag(r), r.selfClosing && !r.ackSelfClosing && this._err(r, Ta.ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(r) {
    this.shouldProcessStartTagTokenInForeignContent(r) ? y0e(this, r) : this._startTagOutsideForeignContent(r);
  }
  /** @protected */
  _startTagOutsideForeignContent(r) {
    switch (this.insertionMode) {
      case Bt.INITIAL: {
        Sy(this, r);
        break;
      }
      case Bt.BEFORE_HTML: {
        Z1e(this, r);
        break;
      }
      case Bt.BEFORE_HEAD: {
        $1e(this, r);
        break;
      }
      case Bt.IN_HEAD: {
        su(this, r);
        break;
      }
      case Bt.IN_HEAD_NO_SCRIPT: {
        nTe(this, r);
        break;
      }
      case Bt.AFTER_HEAD: {
        iTe(this, r);
        break;
      }
      case Bt.IN_BODY: {
        La(this, r);
        break;
      }
      case Bt.IN_TABLE: {
        _m(this, r);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        Iy(this, r);
        break;
      }
      case Bt.IN_CAPTION: {
        e0e(this, r);
        break;
      }
      case Bt.IN_COLUMN_GROUP: {
        Vw(this, r);
        break;
      }
      case Bt.IN_TABLE_BODY: {
        SA(this, r);
        break;
      }
      case Bt.IN_ROW: {
        IA(this, r);
        break;
      }
      case Bt.IN_CELL: {
        r0e(this, r);
        break;
      }
      case Bt.IN_SELECT: {
        wV(this, r);
        break;
      }
      case Bt.IN_SELECT_IN_TABLE: {
        s0e(this, r);
        break;
      }
      case Bt.IN_TEMPLATE: {
        o0e(this, r);
        break;
      }
      case Bt.AFTER_BODY: {
        u0e(this, r);
        break;
      }
      case Bt.IN_FRAMESET: {
        d0e(this, r);
        break;
      }
      case Bt.AFTER_FRAMESET: {
        f0e(this, r);
        break;
      }
      case Bt.AFTER_AFTER_BODY: {
        p0e(this, r);
        break;
      }
      case Bt.AFTER_AFTER_FRAMESET: {
        g0e(this, r);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(r) {
    this.skipNextNewLine = !1, this.currentToken = r, this.currentNotInHTML ? v0e(this, r) : this._endTagOutsideForeignContent(r);
  }
  /** @protected */
  _endTagOutsideForeignContent(r) {
    switch (this.insertionMode) {
      case Bt.INITIAL: {
        Sy(this, r);
        break;
      }
      case Bt.BEFORE_HTML: {
        Q1e(this, r);
        break;
      }
      case Bt.BEFORE_HEAD: {
        eTe(this, r);
        break;
      }
      case Bt.IN_HEAD: {
        tTe(this, r);
        break;
      }
      case Bt.IN_HEAD_NO_SCRIPT: {
        rTe(this, r);
        break;
      }
      case Bt.AFTER_HEAD: {
        sTe(this, r);
        break;
      }
      case Bt.IN_BODY: {
        CA(this, r);
        break;
      }
      case Bt.TEXT: {
        VTe(this, r);
        break;
      }
      case Bt.IN_TABLE: {
        iv(this, r);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        Iy(this, r);
        break;
      }
      case Bt.IN_CAPTION: {
        t0e(this, r);
        break;
      }
      case Bt.IN_COLUMN_GROUP: {
        n0e(this, r);
        break;
      }
      case Bt.IN_TABLE_BODY: {
        gN(this, r);
        break;
      }
      case Bt.IN_ROW: {
        NV(this, r);
        break;
      }
      case Bt.IN_CELL: {
        i0e(this, r);
        break;
      }
      case Bt.IN_SELECT: {
        _V(this, r);
        break;
      }
      case Bt.IN_SELECT_IN_TABLE: {
        a0e(this, r);
        break;
      }
      case Bt.IN_TEMPLATE: {
        c0e(this, r);
        break;
      }
      case Bt.AFTER_BODY: {
        xV(this, r);
        break;
      }
      case Bt.IN_FRAMESET: {
        l0e(this, r);
        break;
      }
      case Bt.AFTER_FRAMESET: {
        h0e(this, r);
        break;
      }
      case Bt.AFTER_AFTER_BODY: {
        Q0(this, r);
        break;
      }
    }
  }
  /** @internal */
  onEof(r) {
    switch (this.insertionMode) {
      case Bt.INITIAL: {
        Sy(this, r);
        break;
      }
      case Bt.BEFORE_HTML: {
        zy(this, r);
        break;
      }
      case Bt.BEFORE_HEAD: {
        Fy(this, r);
        break;
      }
      case Bt.IN_HEAD: {
        Gy(this, r);
        break;
      }
      case Bt.IN_HEAD_NO_SCRIPT: {
        Vy(this, r);
        break;
      }
      case Bt.AFTER_HEAD: {
        Yy(this, r);
        break;
      }
      case Bt.IN_BODY:
      case Bt.IN_TABLE:
      case Bt.IN_CAPTION:
      case Bt.IN_COLUMN_GROUP:
      case Bt.IN_TABLE_BODY:
      case Bt.IN_ROW:
      case Bt.IN_CELL:
      case Bt.IN_SELECT:
      case Bt.IN_SELECT_IN_TABLE: {
        CV(this, r);
        break;
      }
      case Bt.TEXT: {
        YTe(this, r);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        Iy(this, r);
        break;
      }
      case Bt.IN_TEMPLATE: {
        PV(this, r);
        break;
      }
      case Bt.AFTER_BODY:
      case Bt.IN_FRAMESET:
      case Bt.AFTER_FRAMESET:
      case Bt.AFTER_AFTER_BODY:
      case Bt.AFTER_AFTER_FRAMESET: {
        Gw(this, r);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(r) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, r.chars.charCodeAt(0) === EV.CODE_POINTS.LINE_FEED)) {
      if (r.chars.length === 1)
        return;
      r.chars = r.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(r);
      return;
    }
    switch (this.insertionMode) {
      case Bt.IN_HEAD:
      case Bt.IN_HEAD_NO_SCRIPT:
      case Bt.AFTER_HEAD:
      case Bt.TEXT:
      case Bt.IN_COLUMN_GROUP:
      case Bt.IN_SELECT:
      case Bt.IN_SELECT_IN_TABLE:
      case Bt.IN_FRAMESET:
      case Bt.AFTER_FRAMESET: {
        this._insertCharacters(r);
        break;
      }
      case Bt.IN_BODY:
      case Bt.IN_CAPTION:
      case Bt.IN_CELL:
      case Bt.IN_TEMPLATE:
      case Bt.AFTER_BODY:
      case Bt.AFTER_AFTER_BODY:
      case Bt.AFTER_AFTER_FRAMESET: {
        vV(this, r);
        break;
      }
      case Bt.IN_TABLE:
      case Bt.IN_TABLE_BODY:
      case Bt.IN_ROW: {
        qR(this, r);
        break;
      }
      case Bt.IN_TABLE_TEXT: {
        SV(this, r);
        break;
      }
    }
  }
};
rv.Parser = z1e;
function F1e(t, r) {
  let a = t.activeFormattingElements.getElementEntryInScopeWithTagName(r.tagName);
  return a ? t.openElements.contains(a.element) ? t.openElements.hasInScope(r.tagID) || (a = null) : (t.activeFormattingElements.removeEntry(a), a = null) : OV(t, r), a;
}
function G1e(t, r) {
  let a = null, u = t.openElements.stackTop;
  for (; u >= 0; u--) {
    const h = t.openElements.items[u];
    if (h === r.element)
      break;
    t._isSpecialElement(h, t.openElements.tagIDs[u]) && (a = h);
  }
  return a || (t.openElements.shortenToLength(u < 0 ? 0 : u), t.activeFormattingElements.removeEntry(r)), a;
}
function V1e(t, r, a) {
  let u = r, h = t.openElements.getCommonAncestor(r);
  for (let b = 0, l = h; l !== a; b++, l = h) {
    h = t.openElements.getCommonAncestor(l);
    const v = t.activeFormattingElements.getElementEntry(l), s = v && b >= H1e;
    !v || s ? (s && t.activeFormattingElements.removeEntry(v), t.openElements.remove(l)) : (l = Y1e(t, v), u === r && (t.activeFormattingElements.bookmark = v), t.treeAdapter.detachNode(u), t.treeAdapter.appendChild(l, u), u = l);
  }
  return u;
}
function Y1e(t, r) {
  const a = t.treeAdapter.getNamespaceURI(r.element), u = t.treeAdapter.createElement(r.token.tagName, a, r.token.attrs);
  return t.openElements.replace(r.element, u), r.element = u, u;
}
function X1e(t, r, a) {
  const u = t.treeAdapter.getTagName(r), h = (0, Ue.getTagID)(u);
  if (t._isElementCausesFosterParenting(h))
    t._fosterParentElement(a);
  else {
    const b = t.treeAdapter.getNamespaceURI(r);
    h === Ue.TAG_ID.TEMPLATE && b === Ue.NS.HTML && (r = t.treeAdapter.getTemplateContent(r)), t.treeAdapter.appendChild(r, a);
  }
}
function W1e(t, r, a) {
  const u = t.treeAdapter.getNamespaceURI(a.element), { token: h } = a, b = t.treeAdapter.createElement(h.tagName, u, h.attrs);
  t._adoptNodes(r, b), t.treeAdapter.appendChild(r, b), t.activeFormattingElements.insertElementAfterBookmark(b, h), t.activeFormattingElements.removeEntry(a), t.openElements.remove(a.element), t.openElements.insertAfter(r, b, h.tagID);
}
function Fw(t, r) {
  for (let a = 0; a < U1e; a++) {
    const u = F1e(t, r);
    if (!u)
      break;
    const h = G1e(t, u);
    if (!h)
      break;
    t.activeFormattingElements.bookmark = u;
    const b = V1e(t, h, u.element), l = t.openElements.getCommonAncestor(u.element);
    t.treeAdapter.detachNode(b), l && X1e(t, l, b), W1e(t, h, u);
  }
}
function pN(t, r) {
  t._appendCommentNode(r, t.openElements.currentTmplContentOrNode);
}
function q1e(t, r) {
  t._appendCommentNode(r, t.openElements.items[0]);
}
function K1e(t, r) {
  t._appendCommentNode(r, t.document);
}
function Gw(t, r) {
  if (t.stopped = !0, r.location) {
    const a = t.fragmentContext ? 0 : 2;
    for (let u = t.openElements.stackTop; u >= a; u--)
      t._setEndLocation(t.openElements.items[u], r);
    if (!t.fragmentContext && t.openElements.stackTop >= 0) {
      const u = t.openElements.items[0], h = t.treeAdapter.getNodeSourceCodeLocation(u);
      if (h && !h.endTag && (t._setEndLocation(u, r), t.openElements.stackTop >= 1)) {
        const b = t.openElements.items[1], l = t.treeAdapter.getNodeSourceCodeLocation(b);
        l && !l.endTag && t._setEndLocation(b, r);
      }
    }
  }
}
function J1e(t, r) {
  t._setDocumentType(r);
  const a = r.forceQuirks ? Ue.DOCUMENT_MODE.QUIRKS : tH.getDocumentMode(r);
  tH.isConforming(r) || t._err(r, Ta.ERR.nonConformingDoctype), t.treeAdapter.setDocumentMode(t.document, a), t.insertionMode = Bt.BEFORE_HTML;
}
function Sy(t, r) {
  t._err(r, Ta.ERR.missingDoctype, !0), t.treeAdapter.setDocumentMode(t.document, Ue.DOCUMENT_MODE.QUIRKS), t.insertionMode = Bt.BEFORE_HTML, t._processToken(r);
}
function Z1e(t, r) {
  r.tagID === Ue.TAG_ID.HTML ? (t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.BEFORE_HEAD) : zy(t, r);
}
function Q1e(t, r) {
  const a = r.tagID;
  (a === Ue.TAG_ID.HTML || a === Ue.TAG_ID.HEAD || a === Ue.TAG_ID.BODY || a === Ue.TAG_ID.BR) && zy(t, r);
}
function zy(t, r) {
  t._insertFakeRootElement(), t.insertionMode = Bt.BEFORE_HEAD, t._processToken(r);
}
function $1e(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.HEAD: {
      t._insertElement(r, Ue.NS.HTML), t.headElement = t.openElements.current, t.insertionMode = Bt.IN_HEAD;
      break;
    }
    default:
      Fy(t, r);
  }
}
function eTe(t, r) {
  const a = r.tagID;
  a === Ue.TAG_ID.HEAD || a === Ue.TAG_ID.BODY || a === Ue.TAG_ID.HTML || a === Ue.TAG_ID.BR ? Fy(t, r) : t._err(r, Ta.ERR.endTagWithoutMatchingOpenElement);
}
function Fy(t, r) {
  t._insertFakeElement(Ue.TAG_NAMES.HEAD, Ue.TAG_ID.HEAD), t.headElement = t.openElements.current, t.insertionMode = Bt.IN_HEAD, t._processToken(r);
}
function su(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.BASE:
    case Ue.TAG_ID.BASEFONT:
    case Ue.TAG_ID.BGSOUND:
    case Ue.TAG_ID.LINK:
    case Ue.TAG_ID.META: {
      t._appendElement(r, Ue.NS.HTML), r.ackSelfClosing = !0;
      break;
    }
    case Ue.TAG_ID.TITLE: {
      t._switchToTextParsing(r, Wa.TokenizerMode.RCDATA);
      break;
    }
    case Ue.TAG_ID.NOSCRIPT: {
      t.options.scriptingEnabled ? t._switchToTextParsing(r, Wa.TokenizerMode.RAWTEXT) : (t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_HEAD_NO_SCRIPT);
      break;
    }
    case Ue.TAG_ID.NOFRAMES:
    case Ue.TAG_ID.STYLE: {
      t._switchToTextParsing(r, Wa.TokenizerMode.RAWTEXT);
      break;
    }
    case Ue.TAG_ID.SCRIPT: {
      t._switchToTextParsing(r, Wa.TokenizerMode.SCRIPT_DATA);
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      t._insertTemplate(r), t.activeFormattingElements.insertMarker(), t.framesetOk = !1, t.insertionMode = Bt.IN_TEMPLATE, t.tmplInsertionModeStack.unshift(Bt.IN_TEMPLATE);
      break;
    }
    case Ue.TAG_ID.HEAD: {
      t._err(r, Ta.ERR.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Gy(t, r);
  }
}
function tTe(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HEAD: {
      t.openElements.pop(), t.insertionMode = Bt.AFTER_HEAD;
      break;
    }
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.BR:
    case Ue.TAG_ID.HTML: {
      Gy(t, r);
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      Ah(t, r);
      break;
    }
    default:
      t._err(r, Ta.ERR.endTagWithoutMatchingOpenElement);
  }
}
function Ah(t, r) {
  t.openElements.tmplCount > 0 ? (t.openElements.generateImpliedEndTagsThoroughly(), t.openElements.currentTagId !== Ue.TAG_ID.TEMPLATE && t._err(r, Ta.ERR.closingOfElementWithOpenChildElements), t.openElements.popUntilTagNamePopped(Ue.TAG_ID.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode()) : t._err(r, Ta.ERR.endTagWithoutMatchingOpenElement);
}
function Gy(t, r) {
  t.openElements.pop(), t.insertionMode = Bt.AFTER_HEAD, t._processToken(r);
}
function nTe(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.BASEFONT:
    case Ue.TAG_ID.BGSOUND:
    case Ue.TAG_ID.HEAD:
    case Ue.TAG_ID.LINK:
    case Ue.TAG_ID.META:
    case Ue.TAG_ID.NOFRAMES:
    case Ue.TAG_ID.STYLE: {
      su(t, r);
      break;
    }
    case Ue.TAG_ID.NOSCRIPT: {
      t._err(r, Ta.ERR.nestedNoscriptInHead);
      break;
    }
    default:
      Vy(t, r);
  }
}
function rTe(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.NOSCRIPT: {
      t.openElements.pop(), t.insertionMode = Bt.IN_HEAD;
      break;
    }
    case Ue.TAG_ID.BR: {
      Vy(t, r);
      break;
    }
    default:
      t._err(r, Ta.ERR.endTagWithoutMatchingOpenElement);
  }
}
function Vy(t, r) {
  const a = r.type === Js.TokenType.EOF ? Ta.ERR.openElementsLeftAfterEof : Ta.ERR.disallowedContentInNoscriptInHead;
  t._err(r, a), t.openElements.pop(), t.insertionMode = Bt.IN_HEAD, t._processToken(r);
}
function iTe(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.BODY: {
      t._insertElement(r, Ue.NS.HTML), t.framesetOk = !1, t.insertionMode = Bt.IN_BODY;
      break;
    }
    case Ue.TAG_ID.FRAMESET: {
      t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_FRAMESET;
      break;
    }
    case Ue.TAG_ID.BASE:
    case Ue.TAG_ID.BASEFONT:
    case Ue.TAG_ID.BGSOUND:
    case Ue.TAG_ID.LINK:
    case Ue.TAG_ID.META:
    case Ue.TAG_ID.NOFRAMES:
    case Ue.TAG_ID.SCRIPT:
    case Ue.TAG_ID.STYLE:
    case Ue.TAG_ID.TEMPLATE:
    case Ue.TAG_ID.TITLE: {
      t._err(r, Ta.ERR.abandonedHeadElementChild), t.openElements.push(t.headElement, Ue.TAG_ID.HEAD), su(t, r), t.openElements.remove(t.headElement);
      break;
    }
    case Ue.TAG_ID.HEAD: {
      t._err(r, Ta.ERR.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Yy(t, r);
  }
}
function sTe(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.HTML:
    case Ue.TAG_ID.BR: {
      Yy(t, r);
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      Ah(t, r);
      break;
    }
    default:
      t._err(r, Ta.ERR.endTagWithoutMatchingOpenElement);
  }
}
function Yy(t, r) {
  t._insertFakeElement(Ue.TAG_NAMES.BODY, Ue.TAG_ID.BODY), t.insertionMode = Bt.IN_BODY, OA(t, r);
}
function OA(t, r) {
  switch (r.type) {
    case Js.TokenType.CHARACTER: {
      TV(t, r);
      break;
    }
    case Js.TokenType.WHITESPACE_CHARACTER: {
      vV(t, r);
      break;
    }
    case Js.TokenType.COMMENT: {
      pN(t, r);
      break;
    }
    case Js.TokenType.START_TAG: {
      La(t, r);
      break;
    }
    case Js.TokenType.END_TAG: {
      CA(t, r);
      break;
    }
    case Js.TokenType.EOF: {
      CV(t, r);
      break;
    }
  }
}
function vV(t, r) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(r);
}
function TV(t, r) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(r), t.framesetOk = !1;
}
function aTe(t, r) {
  t.openElements.tmplCount === 0 && t.treeAdapter.adoptAttributes(t.openElements.items[0], r.attrs);
}
function oTe(t, r) {
  const a = t.openElements.tryPeekProperlyNestedBodyElement();
  a && t.openElements.tmplCount === 0 && (t.framesetOk = !1, t.treeAdapter.adoptAttributes(a, r.attrs));
}
function cTe(t, r) {
  const a = t.openElements.tryPeekProperlyNestedBodyElement();
  t.framesetOk && a && (t.treeAdapter.detachNode(a), t.openElements.popAllUpToHtmlElement(), t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_FRAMESET);
}
function uTe(t, r) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._insertElement(r, Ue.NS.HTML);
}
function dTe(t, r) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), Ue.NUMBERED_HEADERS.has(t.openElements.currentTagId) && t.openElements.pop(), t._insertElement(r, Ue.NS.HTML);
}
function lTe(t, r) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._insertElement(r, Ue.NS.HTML), t.skipNextNewLine = !0, t.framesetOk = !1;
}
function fTe(t, r) {
  const a = t.openElements.tmplCount > 0;
  (!t.formElement || a) && (t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._insertElement(r, Ue.NS.HTML), a || (t.formElement = t.openElements.current));
}
function hTe(t, r) {
  t.framesetOk = !1;
  const a = r.tagID;
  for (let u = t.openElements.stackTop; u >= 0; u--) {
    const h = t.openElements.tagIDs[u];
    if (a === Ue.TAG_ID.LI && h === Ue.TAG_ID.LI || (a === Ue.TAG_ID.DD || a === Ue.TAG_ID.DT) && (h === Ue.TAG_ID.DD || h === Ue.TAG_ID.DT)) {
      t.openElements.generateImpliedEndTagsWithExclusion(h), t.openElements.popUntilTagNamePopped(h);
      break;
    }
    if (h !== Ue.TAG_ID.ADDRESS && h !== Ue.TAG_ID.DIV && h !== Ue.TAG_ID.P && t._isSpecialElement(t.openElements.items[u], h))
      break;
  }
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._insertElement(r, Ue.NS.HTML);
}
function pTe(t, r) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._insertElement(r, Ue.NS.HTML), t.tokenizer.state = Wa.TokenizerMode.PLAINTEXT;
}
function gTe(t, r) {
  t.openElements.hasInScope(Ue.TAG_ID.BUTTON) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(Ue.TAG_ID.BUTTON)), t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML), t.framesetOk = !1;
}
function mTe(t, r) {
  const a = t.activeFormattingElements.getElementEntryInScopeWithTagName(Ue.TAG_NAMES.A);
  a && (Fw(t, r), t.openElements.remove(a.element), t.activeFormattingElements.removeEntry(a)), t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML), t.activeFormattingElements.pushElement(t.openElements.current, r);
}
function ETe(t, r) {
  t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML), t.activeFormattingElements.pushElement(t.openElements.current, r);
}
function yTe(t, r) {
  t._reconstructActiveFormattingElements(), t.openElements.hasInScope(Ue.TAG_ID.NOBR) && (Fw(t, r), t._reconstructActiveFormattingElements()), t._insertElement(r, Ue.NS.HTML), t.activeFormattingElements.pushElement(t.openElements.current, r);
}
function vTe(t, r) {
  t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1;
}
function TTe(t, r) {
  t.treeAdapter.getDocumentMode(t.document) !== Ue.DOCUMENT_MODE.QUIRKS && t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._insertElement(r, Ue.NS.HTML), t.framesetOk = !1, t.insertionMode = Bt.IN_TABLE;
}
function bV(t, r) {
  t._reconstructActiveFormattingElements(), t._appendElement(r, Ue.NS.HTML), t.framesetOk = !1, r.ackSelfClosing = !0;
}
function AV(t) {
  const r = (0, Js.getTokenAttr)(t, Ue.ATTRS.TYPE);
  return r != null && r.toLowerCase() === j1e;
}
function bTe(t, r) {
  t._reconstructActiveFormattingElements(), t._appendElement(r, Ue.NS.HTML), AV(r) || (t.framesetOk = !1), r.ackSelfClosing = !0;
}
function ATe(t, r) {
  t._appendElement(r, Ue.NS.HTML), r.ackSelfClosing = !0;
}
function OTe(t, r) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._appendElement(r, Ue.NS.HTML), t.framesetOk = !1, r.ackSelfClosing = !0;
}
function CTe(t, r) {
  r.tagName = Ue.TAG_NAMES.IMG, r.tagID = Ue.TAG_ID.IMG, bV(t, r);
}
function STe(t, r) {
  t._insertElement(r, Ue.NS.HTML), t.skipNextNewLine = !0, t.tokenizer.state = Wa.TokenizerMode.RCDATA, t.originalInsertionMode = t.insertionMode, t.framesetOk = !1, t.insertionMode = Bt.TEXT;
}
function ITe(t, r) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) && t._closePElement(), t._reconstructActiveFormattingElements(), t.framesetOk = !1, t._switchToTextParsing(r, Wa.TokenizerMode.RAWTEXT);
}
function RTe(t, r) {
  t.framesetOk = !1, t._switchToTextParsing(r, Wa.TokenizerMode.RAWTEXT);
}
function rH(t, r) {
  t._switchToTextParsing(r, Wa.TokenizerMode.RAWTEXT);
}
function NTe(t, r) {
  t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML), t.framesetOk = !1, t.insertionMode = t.insertionMode === Bt.IN_TABLE || t.insertionMode === Bt.IN_CAPTION || t.insertionMode === Bt.IN_TABLE_BODY || t.insertionMode === Bt.IN_ROW || t.insertionMode === Bt.IN_CELL ? Bt.IN_SELECT_IN_TABLE : Bt.IN_SELECT;
}
function wTe(t, r) {
  t.openElements.currentTagId === Ue.TAG_ID.OPTION && t.openElements.pop(), t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML);
}
function _Te(t, r) {
  t.openElements.hasInScope(Ue.TAG_ID.RUBY) && t.openElements.generateImpliedEndTags(), t._insertElement(r, Ue.NS.HTML);
}
function PTe(t, r) {
  t.openElements.hasInScope(Ue.TAG_ID.RUBY) && t.openElements.generateImpliedEndTagsWithExclusion(Ue.TAG_ID.RTC), t._insertElement(r, Ue.NS.HTML);
}
function xTe(t, r) {
  t._reconstructActiveFormattingElements(), Mu.adjustTokenMathMLAttrs(r), Mu.adjustTokenXMLAttrs(r), r.selfClosing ? t._appendElement(r, Ue.NS.MATHML) : t._insertElement(r, Ue.NS.MATHML), r.ackSelfClosing = !0;
}
function DTe(t, r) {
  t._reconstructActiveFormattingElements(), Mu.adjustTokenSVGAttrs(r), Mu.adjustTokenXMLAttrs(r), r.selfClosing ? t._appendElement(r, Ue.NS.SVG) : t._insertElement(r, Ue.NS.SVG), r.ackSelfClosing = !0;
}
function iH(t, r) {
  t._reconstructActiveFormattingElements(), t._insertElement(r, Ue.NS.HTML);
}
function La(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.I:
    case Ue.TAG_ID.S:
    case Ue.TAG_ID.B:
    case Ue.TAG_ID.U:
    case Ue.TAG_ID.EM:
    case Ue.TAG_ID.TT:
    case Ue.TAG_ID.BIG:
    case Ue.TAG_ID.CODE:
    case Ue.TAG_ID.FONT:
    case Ue.TAG_ID.SMALL:
    case Ue.TAG_ID.STRIKE:
    case Ue.TAG_ID.STRONG: {
      ETe(t, r);
      break;
    }
    case Ue.TAG_ID.A: {
      mTe(t, r);
      break;
    }
    case Ue.TAG_ID.H1:
    case Ue.TAG_ID.H2:
    case Ue.TAG_ID.H3:
    case Ue.TAG_ID.H4:
    case Ue.TAG_ID.H5:
    case Ue.TAG_ID.H6: {
      dTe(t, r);
      break;
    }
    case Ue.TAG_ID.P:
    case Ue.TAG_ID.DL:
    case Ue.TAG_ID.OL:
    case Ue.TAG_ID.UL:
    case Ue.TAG_ID.DIV:
    case Ue.TAG_ID.DIR:
    case Ue.TAG_ID.NAV:
    case Ue.TAG_ID.MAIN:
    case Ue.TAG_ID.MENU:
    case Ue.TAG_ID.ASIDE:
    case Ue.TAG_ID.CENTER:
    case Ue.TAG_ID.FIGURE:
    case Ue.TAG_ID.FOOTER:
    case Ue.TAG_ID.HEADER:
    case Ue.TAG_ID.HGROUP:
    case Ue.TAG_ID.DIALOG:
    case Ue.TAG_ID.DETAILS:
    case Ue.TAG_ID.ADDRESS:
    case Ue.TAG_ID.ARTICLE:
    case Ue.TAG_ID.SEARCH:
    case Ue.TAG_ID.SECTION:
    case Ue.TAG_ID.SUMMARY:
    case Ue.TAG_ID.FIELDSET:
    case Ue.TAG_ID.BLOCKQUOTE:
    case Ue.TAG_ID.FIGCAPTION: {
      uTe(t, r);
      break;
    }
    case Ue.TAG_ID.LI:
    case Ue.TAG_ID.DD:
    case Ue.TAG_ID.DT: {
      hTe(t, r);
      break;
    }
    case Ue.TAG_ID.BR:
    case Ue.TAG_ID.IMG:
    case Ue.TAG_ID.WBR:
    case Ue.TAG_ID.AREA:
    case Ue.TAG_ID.EMBED:
    case Ue.TAG_ID.KEYGEN: {
      bV(t, r);
      break;
    }
    case Ue.TAG_ID.HR: {
      OTe(t, r);
      break;
    }
    case Ue.TAG_ID.RB:
    case Ue.TAG_ID.RTC: {
      _Te(t, r);
      break;
    }
    case Ue.TAG_ID.RT:
    case Ue.TAG_ID.RP: {
      PTe(t, r);
      break;
    }
    case Ue.TAG_ID.PRE:
    case Ue.TAG_ID.LISTING: {
      lTe(t, r);
      break;
    }
    case Ue.TAG_ID.XMP: {
      ITe(t, r);
      break;
    }
    case Ue.TAG_ID.SVG: {
      DTe(t, r);
      break;
    }
    case Ue.TAG_ID.HTML: {
      aTe(t, r);
      break;
    }
    case Ue.TAG_ID.BASE:
    case Ue.TAG_ID.LINK:
    case Ue.TAG_ID.META:
    case Ue.TAG_ID.STYLE:
    case Ue.TAG_ID.TITLE:
    case Ue.TAG_ID.SCRIPT:
    case Ue.TAG_ID.BGSOUND:
    case Ue.TAG_ID.BASEFONT:
    case Ue.TAG_ID.TEMPLATE: {
      su(t, r);
      break;
    }
    case Ue.TAG_ID.BODY: {
      oTe(t, r);
      break;
    }
    case Ue.TAG_ID.FORM: {
      fTe(t, r);
      break;
    }
    case Ue.TAG_ID.NOBR: {
      yTe(t, r);
      break;
    }
    case Ue.TAG_ID.MATH: {
      xTe(t, r);
      break;
    }
    case Ue.TAG_ID.TABLE: {
      TTe(t, r);
      break;
    }
    case Ue.TAG_ID.INPUT: {
      bTe(t, r);
      break;
    }
    case Ue.TAG_ID.PARAM:
    case Ue.TAG_ID.TRACK:
    case Ue.TAG_ID.SOURCE: {
      ATe(t, r);
      break;
    }
    case Ue.TAG_ID.IMAGE: {
      CTe(t, r);
      break;
    }
    case Ue.TAG_ID.BUTTON: {
      gTe(t, r);
      break;
    }
    case Ue.TAG_ID.APPLET:
    case Ue.TAG_ID.OBJECT:
    case Ue.TAG_ID.MARQUEE: {
      vTe(t, r);
      break;
    }
    case Ue.TAG_ID.IFRAME: {
      RTe(t, r);
      break;
    }
    case Ue.TAG_ID.SELECT: {
      NTe(t, r);
      break;
    }
    case Ue.TAG_ID.OPTION:
    case Ue.TAG_ID.OPTGROUP: {
      wTe(t, r);
      break;
    }
    case Ue.TAG_ID.NOEMBED:
    case Ue.TAG_ID.NOFRAMES: {
      rH(t, r);
      break;
    }
    case Ue.TAG_ID.FRAMESET: {
      cTe(t, r);
      break;
    }
    case Ue.TAG_ID.TEXTAREA: {
      STe(t, r);
      break;
    }
    case Ue.TAG_ID.NOSCRIPT: {
      t.options.scriptingEnabled ? rH(t, r) : iH(t, r);
      break;
    }
    case Ue.TAG_ID.PLAINTEXT: {
      pTe(t, r);
      break;
    }
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TR:
    case Ue.TAG_ID.HEAD:
    case Ue.TAG_ID.FRAME:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD:
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COLGROUP:
      break;
    default:
      iH(t, r);
  }
}
function MTe(t, r) {
  if (t.openElements.hasInScope(Ue.TAG_ID.BODY) && (t.insertionMode = Bt.AFTER_BODY, t.options.sourceCodeLocationInfo)) {
    const a = t.openElements.tryPeekProperlyNestedBodyElement();
    a && t._setEndLocation(a, r);
  }
}
function LTe(t, r) {
  t.openElements.hasInScope(Ue.TAG_ID.BODY) && (t.insertionMode = Bt.AFTER_BODY, xV(t, r));
}
function kTe(t, r) {
  const a = r.tagID;
  t.openElements.hasInScope(a) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(a));
}
function jTe(t) {
  const r = t.openElements.tmplCount > 0, { formElement: a } = t;
  r || (t.formElement = null), (a || r) && t.openElements.hasInScope(Ue.TAG_ID.FORM) && (t.openElements.generateImpliedEndTags(), r ? t.openElements.popUntilTagNamePopped(Ue.TAG_ID.FORM) : a && t.openElements.remove(a));
}
function UTe(t) {
  t.openElements.hasInButtonScope(Ue.TAG_ID.P) || t._insertFakeElement(Ue.TAG_NAMES.P, Ue.TAG_ID.P), t._closePElement();
}
function HTe(t) {
  t.openElements.hasInListItemScope(Ue.TAG_ID.LI) && (t.openElements.generateImpliedEndTagsWithExclusion(Ue.TAG_ID.LI), t.openElements.popUntilTagNamePopped(Ue.TAG_ID.LI));
}
function BTe(t, r) {
  const a = r.tagID;
  t.openElements.hasInScope(a) && (t.openElements.generateImpliedEndTagsWithExclusion(a), t.openElements.popUntilTagNamePopped(a));
}
function zTe(t) {
  t.openElements.hasNumberedHeaderInScope() && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilNumberedHeaderPopped());
}
function FTe(t, r) {
  const a = r.tagID;
  t.openElements.hasInScope(a) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(a), t.activeFormattingElements.clearToLastMarker());
}
function GTe(t) {
  t._reconstructActiveFormattingElements(), t._insertFakeElement(Ue.TAG_NAMES.BR, Ue.TAG_ID.BR), t.openElements.pop(), t.framesetOk = !1;
}
function OV(t, r) {
  const a = r.tagName, u = r.tagID;
  for (let h = t.openElements.stackTop; h > 0; h--) {
    const b = t.openElements.items[h], l = t.openElements.tagIDs[h];
    if (u === l && (u !== Ue.TAG_ID.UNKNOWN || t.treeAdapter.getTagName(b) === a)) {
      t.openElements.generateImpliedEndTagsWithExclusion(u), t.openElements.stackTop >= h && t.openElements.shortenToLength(h);
      break;
    }
    if (t._isSpecialElement(b, l))
      break;
  }
}
function CA(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.A:
    case Ue.TAG_ID.B:
    case Ue.TAG_ID.I:
    case Ue.TAG_ID.S:
    case Ue.TAG_ID.U:
    case Ue.TAG_ID.EM:
    case Ue.TAG_ID.TT:
    case Ue.TAG_ID.BIG:
    case Ue.TAG_ID.CODE:
    case Ue.TAG_ID.FONT:
    case Ue.TAG_ID.NOBR:
    case Ue.TAG_ID.SMALL:
    case Ue.TAG_ID.STRIKE:
    case Ue.TAG_ID.STRONG: {
      Fw(t, r);
      break;
    }
    case Ue.TAG_ID.P: {
      UTe(t);
      break;
    }
    case Ue.TAG_ID.DL:
    case Ue.TAG_ID.UL:
    case Ue.TAG_ID.OL:
    case Ue.TAG_ID.DIR:
    case Ue.TAG_ID.DIV:
    case Ue.TAG_ID.NAV:
    case Ue.TAG_ID.PRE:
    case Ue.TAG_ID.MAIN:
    case Ue.TAG_ID.MENU:
    case Ue.TAG_ID.ASIDE:
    case Ue.TAG_ID.BUTTON:
    case Ue.TAG_ID.CENTER:
    case Ue.TAG_ID.FIGURE:
    case Ue.TAG_ID.FOOTER:
    case Ue.TAG_ID.HEADER:
    case Ue.TAG_ID.HGROUP:
    case Ue.TAG_ID.DIALOG:
    case Ue.TAG_ID.ADDRESS:
    case Ue.TAG_ID.ARTICLE:
    case Ue.TAG_ID.DETAILS:
    case Ue.TAG_ID.SEARCH:
    case Ue.TAG_ID.SECTION:
    case Ue.TAG_ID.SUMMARY:
    case Ue.TAG_ID.LISTING:
    case Ue.TAG_ID.FIELDSET:
    case Ue.TAG_ID.BLOCKQUOTE:
    case Ue.TAG_ID.FIGCAPTION: {
      kTe(t, r);
      break;
    }
    case Ue.TAG_ID.LI: {
      HTe(t);
      break;
    }
    case Ue.TAG_ID.DD:
    case Ue.TAG_ID.DT: {
      BTe(t, r);
      break;
    }
    case Ue.TAG_ID.H1:
    case Ue.TAG_ID.H2:
    case Ue.TAG_ID.H3:
    case Ue.TAG_ID.H4:
    case Ue.TAG_ID.H5:
    case Ue.TAG_ID.H6: {
      zTe(t);
      break;
    }
    case Ue.TAG_ID.BR: {
      GTe(t);
      break;
    }
    case Ue.TAG_ID.BODY: {
      MTe(t, r);
      break;
    }
    case Ue.TAG_ID.HTML: {
      LTe(t, r);
      break;
    }
    case Ue.TAG_ID.FORM: {
      jTe(t);
      break;
    }
    case Ue.TAG_ID.APPLET:
    case Ue.TAG_ID.OBJECT:
    case Ue.TAG_ID.MARQUEE: {
      FTe(t, r);
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      Ah(t, r);
      break;
    }
    default:
      OV(t, r);
  }
}
function CV(t, r) {
  t.tmplInsertionModeStack.length > 0 ? PV(t, r) : Gw(t, r);
}
function VTe(t, r) {
  var a;
  r.tagID === Ue.TAG_ID.SCRIPT && ((a = t.scriptHandler) === null || a === void 0 || a.call(t, t.openElements.current)), t.openElements.pop(), t.insertionMode = t.originalInsertionMode;
}
function YTe(t, r) {
  t._err(r, Ta.ERR.eofInElementThatCanContainOnlyText), t.openElements.pop(), t.insertionMode = t.originalInsertionMode, t.onEof(r);
}
function qR(t, r) {
  if (yV.has(t.openElements.currentTagId))
    switch (t.pendingCharacterTokens.length = 0, t.hasNonWhitespacePendingCharacterToken = !1, t.originalInsertionMode = t.insertionMode, t.insertionMode = Bt.IN_TABLE_TEXT, r.type) {
      case Js.TokenType.CHARACTER: {
        IV(t, r);
        break;
      }
      case Js.TokenType.WHITESPACE_CHARACTER: {
        SV(t, r);
        break;
      }
    }
  else
    Dv(t, r);
}
function XTe(t, r) {
  t.openElements.clearBackToTableContext(), t.activeFormattingElements.insertMarker(), t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_CAPTION;
}
function WTe(t, r) {
  t.openElements.clearBackToTableContext(), t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_COLUMN_GROUP;
}
function qTe(t, r) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(Ue.TAG_NAMES.COLGROUP, Ue.TAG_ID.COLGROUP), t.insertionMode = Bt.IN_COLUMN_GROUP, Vw(t, r);
}
function KTe(t, r) {
  t.openElements.clearBackToTableContext(), t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_TABLE_BODY;
}
function JTe(t, r) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(Ue.TAG_NAMES.TBODY, Ue.TAG_ID.TBODY), t.insertionMode = Bt.IN_TABLE_BODY, SA(t, r);
}
function ZTe(t, r) {
  t.openElements.hasInTableScope(Ue.TAG_ID.TABLE) && (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.TABLE), t._resetInsertionMode(), t._processStartTag(r));
}
function QTe(t, r) {
  AV(r) ? t._appendElement(r, Ue.NS.HTML) : Dv(t, r), r.ackSelfClosing = !0;
}
function $Te(t, r) {
  !t.formElement && t.openElements.tmplCount === 0 && (t._insertElement(r, Ue.NS.HTML), t.formElement = t.openElements.current, t.openElements.pop());
}
function _m(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.TR: {
      JTe(t, r);
      break;
    }
    case Ue.TAG_ID.STYLE:
    case Ue.TAG_ID.SCRIPT:
    case Ue.TAG_ID.TEMPLATE: {
      su(t, r);
      break;
    }
    case Ue.TAG_ID.COL: {
      qTe(t, r);
      break;
    }
    case Ue.TAG_ID.FORM: {
      $Te(t, r);
      break;
    }
    case Ue.TAG_ID.TABLE: {
      ZTe(t, r);
      break;
    }
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD: {
      KTe(t, r);
      break;
    }
    case Ue.TAG_ID.INPUT: {
      QTe(t, r);
      break;
    }
    case Ue.TAG_ID.CAPTION: {
      XTe(t, r);
      break;
    }
    case Ue.TAG_ID.COLGROUP: {
      WTe(t, r);
      break;
    }
    default:
      Dv(t, r);
  }
}
function iv(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.TABLE: {
      t.openElements.hasInTableScope(Ue.TAG_ID.TABLE) && (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.TABLE), t._resetInsertionMode());
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      Ah(t, r);
      break;
    }
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.HTML:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.THEAD:
    case Ue.TAG_ID.TR:
      break;
    default:
      Dv(t, r);
  }
}
function Dv(t, r) {
  const a = t.fosterParentingEnabled;
  t.fosterParentingEnabled = !0, OA(t, r), t.fosterParentingEnabled = a;
}
function SV(t, r) {
  t.pendingCharacterTokens.push(r);
}
function IV(t, r) {
  t.pendingCharacterTokens.push(r), t.hasNonWhitespacePendingCharacterToken = !0;
}
function Iy(t, r) {
  let a = 0;
  if (t.hasNonWhitespacePendingCharacterToken)
    for (; a < t.pendingCharacterTokens.length; a++)
      Dv(t, t.pendingCharacterTokens[a]);
  else
    for (; a < t.pendingCharacterTokens.length; a++)
      t._insertCharacters(t.pendingCharacterTokens[a]);
  t.insertionMode = t.originalInsertionMode, t._processToken(r);
}
const RV = /* @__PURE__ */ new Set([Ue.TAG_ID.CAPTION, Ue.TAG_ID.COL, Ue.TAG_ID.COLGROUP, Ue.TAG_ID.TBODY, Ue.TAG_ID.TD, Ue.TAG_ID.TFOOT, Ue.TAG_ID.TH, Ue.TAG_ID.THEAD, Ue.TAG_ID.TR]);
function e0e(t, r) {
  const a = r.tagID;
  RV.has(a) ? t.openElements.hasInTableScope(Ue.TAG_ID.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(Ue.TAG_ID.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Bt.IN_TABLE, _m(t, r)) : La(t, r);
}
function t0e(t, r) {
  const a = r.tagID;
  switch (a) {
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.TABLE: {
      t.openElements.hasInTableScope(Ue.TAG_ID.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(Ue.TAG_ID.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Bt.IN_TABLE, a === Ue.TAG_ID.TABLE && iv(t, r));
      break;
    }
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.HTML:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.THEAD:
    case Ue.TAG_ID.TR:
      break;
    default:
      CA(t, r);
  }
}
function Vw(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.COL: {
      t._appendElement(r, Ue.NS.HTML), r.ackSelfClosing = !0;
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      su(t, r);
      break;
    }
    default:
      Rb(t, r);
  }
}
function n0e(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.COLGROUP: {
      t.openElements.currentTagId === Ue.TAG_ID.COLGROUP && (t.openElements.pop(), t.insertionMode = Bt.IN_TABLE);
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      Ah(t, r);
      break;
    }
    case Ue.TAG_ID.COL:
      break;
    default:
      Rb(t, r);
  }
}
function Rb(t, r) {
  t.openElements.currentTagId === Ue.TAG_ID.COLGROUP && (t.openElements.pop(), t.insertionMode = Bt.IN_TABLE, t._processToken(r));
}
function SA(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.TR: {
      t.openElements.clearBackToTableBodyContext(), t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_ROW;
      break;
    }
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.TD: {
      t.openElements.clearBackToTableBodyContext(), t._insertFakeElement(Ue.TAG_NAMES.TR, Ue.TAG_ID.TR), t.insertionMode = Bt.IN_ROW, IA(t, r);
      break;
    }
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE, _m(t, r));
      break;
    }
    default:
      _m(t, r);
  }
}
function gN(t, r) {
  const a = r.tagID;
  switch (r.tagID) {
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD: {
      t.openElements.hasInTableScope(a) && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE);
      break;
    }
    case Ue.TAG_ID.TABLE: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE, iv(t, r));
      break;
    }
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.HTML:
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.TR:
      break;
    default:
      iv(t, r);
  }
}
function IA(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.TH:
    case Ue.TAG_ID.TD: {
      t.openElements.clearBackToTableRowContext(), t._insertElement(r, Ue.NS.HTML), t.insertionMode = Bt.IN_CELL, t.activeFormattingElements.insertMarker();
      break;
    }
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD:
    case Ue.TAG_ID.TR: {
      t.openElements.hasInTableScope(Ue.TAG_ID.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE_BODY, SA(t, r));
      break;
    }
    default:
      _m(t, r);
  }
}
function NV(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.TR: {
      t.openElements.hasInTableScope(Ue.TAG_ID.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE_BODY);
      break;
    }
    case Ue.TAG_ID.TABLE: {
      t.openElements.hasInTableScope(Ue.TAG_ID.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE_BODY, gN(t, r));
      break;
    }
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD: {
      (t.openElements.hasInTableScope(r.tagID) || t.openElements.hasInTableScope(Ue.TAG_ID.TR)) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = Bt.IN_TABLE_BODY, gN(t, r));
      break;
    }
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.HTML:
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TH:
      break;
    default:
      iv(t, r);
  }
}
function r0e(t, r) {
  const a = r.tagID;
  RV.has(a) ? (t.openElements.hasInTableScope(Ue.TAG_ID.TD) || t.openElements.hasInTableScope(Ue.TAG_ID.TH)) && (t._closeTableCell(), IA(t, r)) : La(t, r);
}
function i0e(t, r) {
  const a = r.tagID;
  switch (a) {
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TH: {
      t.openElements.hasInTableScope(a) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(a), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = Bt.IN_ROW);
      break;
    }
    case Ue.TAG_ID.TABLE:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD:
    case Ue.TAG_ID.TR: {
      t.openElements.hasInTableScope(a) && (t._closeTableCell(), NV(t, r));
      break;
    }
    case Ue.TAG_ID.BODY:
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COL:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.HTML:
      break;
    default:
      CA(t, r);
  }
}
function wV(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.OPTION: {
      t.openElements.currentTagId === Ue.TAG_ID.OPTION && t.openElements.pop(), t._insertElement(r, Ue.NS.HTML);
      break;
    }
    case Ue.TAG_ID.OPTGROUP: {
      t.openElements.currentTagId === Ue.TAG_ID.OPTION && t.openElements.pop(), t.openElements.currentTagId === Ue.TAG_ID.OPTGROUP && t.openElements.pop(), t._insertElement(r, Ue.NS.HTML);
      break;
    }
    case Ue.TAG_ID.HR: {
      t.openElements.currentTagId === Ue.TAG_ID.OPTION && t.openElements.pop(), t.openElements.currentTagId === Ue.TAG_ID.OPTGROUP && t.openElements.pop(), t._appendElement(r, Ue.NS.HTML), r.ackSelfClosing = !0;
      break;
    }
    case Ue.TAG_ID.INPUT:
    case Ue.TAG_ID.KEYGEN:
    case Ue.TAG_ID.TEXTAREA:
    case Ue.TAG_ID.SELECT: {
      t.openElements.hasInSelectScope(Ue.TAG_ID.SELECT) && (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.SELECT), t._resetInsertionMode(), r.tagID !== Ue.TAG_ID.SELECT && t._processStartTag(r));
      break;
    }
    case Ue.TAG_ID.SCRIPT:
    case Ue.TAG_ID.TEMPLATE: {
      su(t, r);
      break;
    }
  }
}
function _V(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.OPTGROUP: {
      t.openElements.stackTop > 0 && t.openElements.currentTagId === Ue.TAG_ID.OPTION && t.openElements.tagIDs[t.openElements.stackTop - 1] === Ue.TAG_ID.OPTGROUP && t.openElements.pop(), t.openElements.currentTagId === Ue.TAG_ID.OPTGROUP && t.openElements.pop();
      break;
    }
    case Ue.TAG_ID.OPTION: {
      t.openElements.currentTagId === Ue.TAG_ID.OPTION && t.openElements.pop();
      break;
    }
    case Ue.TAG_ID.SELECT: {
      t.openElements.hasInSelectScope(Ue.TAG_ID.SELECT) && (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.SELECT), t._resetInsertionMode());
      break;
    }
    case Ue.TAG_ID.TEMPLATE: {
      Ah(t, r);
      break;
    }
  }
}
function s0e(t, r) {
  const a = r.tagID;
  a === Ue.TAG_ID.CAPTION || a === Ue.TAG_ID.TABLE || a === Ue.TAG_ID.TBODY || a === Ue.TAG_ID.TFOOT || a === Ue.TAG_ID.THEAD || a === Ue.TAG_ID.TR || a === Ue.TAG_ID.TD || a === Ue.TAG_ID.TH ? (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.SELECT), t._resetInsertionMode(), t._processStartTag(r)) : wV(t, r);
}
function a0e(t, r) {
  const a = r.tagID;
  a === Ue.TAG_ID.CAPTION || a === Ue.TAG_ID.TABLE || a === Ue.TAG_ID.TBODY || a === Ue.TAG_ID.TFOOT || a === Ue.TAG_ID.THEAD || a === Ue.TAG_ID.TR || a === Ue.TAG_ID.TD || a === Ue.TAG_ID.TH ? t.openElements.hasInTableScope(a) && (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.SELECT), t._resetInsertionMode(), t.onEndTag(r)) : _V(t, r);
}
function o0e(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.BASE:
    case Ue.TAG_ID.BASEFONT:
    case Ue.TAG_ID.BGSOUND:
    case Ue.TAG_ID.LINK:
    case Ue.TAG_ID.META:
    case Ue.TAG_ID.NOFRAMES:
    case Ue.TAG_ID.SCRIPT:
    case Ue.TAG_ID.STYLE:
    case Ue.TAG_ID.TEMPLATE:
    case Ue.TAG_ID.TITLE: {
      su(t, r);
      break;
    }
    case Ue.TAG_ID.CAPTION:
    case Ue.TAG_ID.COLGROUP:
    case Ue.TAG_ID.TBODY:
    case Ue.TAG_ID.TFOOT:
    case Ue.TAG_ID.THEAD: {
      t.tmplInsertionModeStack[0] = Bt.IN_TABLE, t.insertionMode = Bt.IN_TABLE, _m(t, r);
      break;
    }
    case Ue.TAG_ID.COL: {
      t.tmplInsertionModeStack[0] = Bt.IN_COLUMN_GROUP, t.insertionMode = Bt.IN_COLUMN_GROUP, Vw(t, r);
      break;
    }
    case Ue.TAG_ID.TR: {
      t.tmplInsertionModeStack[0] = Bt.IN_TABLE_BODY, t.insertionMode = Bt.IN_TABLE_BODY, SA(t, r);
      break;
    }
    case Ue.TAG_ID.TD:
    case Ue.TAG_ID.TH: {
      t.tmplInsertionModeStack[0] = Bt.IN_ROW, t.insertionMode = Bt.IN_ROW, IA(t, r);
      break;
    }
    default:
      t.tmplInsertionModeStack[0] = Bt.IN_BODY, t.insertionMode = Bt.IN_BODY, La(t, r);
  }
}
function c0e(t, r) {
  r.tagID === Ue.TAG_ID.TEMPLATE && Ah(t, r);
}
function PV(t, r) {
  t.openElements.tmplCount > 0 ? (t.openElements.popUntilTagNamePopped(Ue.TAG_ID.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode(), t.onEof(r)) : Gw(t, r);
}
function u0e(t, r) {
  r.tagID === Ue.TAG_ID.HTML ? La(t, r) : Nb(t, r);
}
function xV(t, r) {
  var a;
  if (r.tagID === Ue.TAG_ID.HTML) {
    if (t.fragmentContext || (t.insertionMode = Bt.AFTER_AFTER_BODY), t.options.sourceCodeLocationInfo && t.openElements.tagIDs[0] === Ue.TAG_ID.HTML) {
      t._setEndLocation(t.openElements.items[0], r);
      const u = t.openElements.items[1];
      u && !(!((a = t.treeAdapter.getNodeSourceCodeLocation(u)) === null || a === void 0) && a.endTag) && t._setEndLocation(u, r);
    }
  } else
    Nb(t, r);
}
function Nb(t, r) {
  t.insertionMode = Bt.IN_BODY, OA(t, r);
}
function d0e(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.FRAMESET: {
      t._insertElement(r, Ue.NS.HTML);
      break;
    }
    case Ue.TAG_ID.FRAME: {
      t._appendElement(r, Ue.NS.HTML), r.ackSelfClosing = !0;
      break;
    }
    case Ue.TAG_ID.NOFRAMES: {
      su(t, r);
      break;
    }
  }
}
function l0e(t, r) {
  r.tagID === Ue.TAG_ID.FRAMESET && !t.openElements.isRootHtmlElementCurrent() && (t.openElements.pop(), !t.fragmentContext && t.openElements.currentTagId !== Ue.TAG_ID.FRAMESET && (t.insertionMode = Bt.AFTER_FRAMESET));
}
function f0e(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.NOFRAMES: {
      su(t, r);
      break;
    }
  }
}
function h0e(t, r) {
  r.tagID === Ue.TAG_ID.HTML && (t.insertionMode = Bt.AFTER_AFTER_FRAMESET);
}
function p0e(t, r) {
  r.tagID === Ue.TAG_ID.HTML ? La(t, r) : Q0(t, r);
}
function Q0(t, r) {
  t.insertionMode = Bt.IN_BODY, OA(t, r);
}
function g0e(t, r) {
  switch (r.tagID) {
    case Ue.TAG_ID.HTML: {
      La(t, r);
      break;
    }
    case Ue.TAG_ID.NOFRAMES: {
      su(t, r);
      break;
    }
  }
}
function m0e(t, r) {
  r.chars = EV.REPLACEMENT_CHARACTER, t._insertCharacters(r);
}
function E0e(t, r) {
  t._insertCharacters(r), t.framesetOk = !1;
}
function DV(t) {
  for (; t.treeAdapter.getNamespaceURI(t.openElements.current) !== Ue.NS.HTML && !t._isIntegrationPoint(t.openElements.currentTagId, t.openElements.current); )
    t.openElements.pop();
}
function y0e(t, r) {
  if (Mu.causesExit(r))
    DV(t), t._startTagOutsideForeignContent(r);
  else {
    const a = t._getAdjustedCurrentElement(), u = t.treeAdapter.getNamespaceURI(a);
    u === Ue.NS.MATHML ? Mu.adjustTokenMathMLAttrs(r) : u === Ue.NS.SVG && (Mu.adjustTokenSVGTagName(r), Mu.adjustTokenSVGAttrs(r)), Mu.adjustTokenXMLAttrs(r), r.selfClosing ? t._appendElement(r, u) : t._insertElement(r, u), r.ackSelfClosing = !0;
  }
}
function v0e(t, r) {
  if (r.tagID === Ue.TAG_ID.P || r.tagID === Ue.TAG_ID.BR) {
    DV(t), t._endTagOutsideForeignContent(r);
    return;
  }
  for (let a = t.openElements.stackTop; a > 0; a--) {
    const u = t.openElements.items[a];
    if (t.treeAdapter.getNamespaceURI(u) === Ue.NS.HTML) {
      t._endTagOutsideForeignContent(r);
      break;
    }
    const h = t.treeAdapter.getTagName(u);
    if (h.toLowerCase() === r.tagName) {
      r.tagName = h, t.openElements.shortenToLength(a);
      break;
    }
  }
}
var RA = {};
Object.defineProperty(RA, "__esModule", { value: !0 });
RA.serialize = A0e;
RA.serializeOuter = O0e;
const es = ss, MV = tv, T0e = bA, b0e = /* @__PURE__ */ new Set([
  es.TAG_NAMES.AREA,
  es.TAG_NAMES.BASE,
  es.TAG_NAMES.BASEFONT,
  es.TAG_NAMES.BGSOUND,
  es.TAG_NAMES.BR,
  es.TAG_NAMES.COL,
  es.TAG_NAMES.EMBED,
  es.TAG_NAMES.FRAME,
  es.TAG_NAMES.HR,
  es.TAG_NAMES.IMG,
  es.TAG_NAMES.INPUT,
  es.TAG_NAMES.KEYGEN,
  es.TAG_NAMES.LINK,
  es.TAG_NAMES.META,
  es.TAG_NAMES.PARAM,
  es.TAG_NAMES.SOURCE,
  es.TAG_NAMES.TRACK,
  es.TAG_NAMES.WBR
]);
function LV(t, r) {
  return r.treeAdapter.isElementNode(t) && r.treeAdapter.getNamespaceURI(t) === es.NS.HTML && b0e.has(r.treeAdapter.getTagName(t));
}
const kV = { treeAdapter: T0e.defaultTreeAdapter, scriptingEnabled: !0 };
function A0e(t, r) {
  const a = Object.assign(Object.assign({}, kV), r);
  return LV(t, a) ? "" : jV(t, a);
}
function O0e(t, r) {
  const a = Object.assign(Object.assign({}, kV), r);
  return UV(t, a);
}
function jV(t, r) {
  let a = "";
  const u = r.treeAdapter.isElementNode(t) && r.treeAdapter.getTagName(t) === es.TAG_NAMES.TEMPLATE && r.treeAdapter.getNamespaceURI(t) === es.NS.HTML ? r.treeAdapter.getTemplateContent(t) : t, h = r.treeAdapter.getChildNodes(u);
  if (h)
    for (const b of h)
      a += UV(b, r);
  return a;
}
function UV(t, r) {
  return r.treeAdapter.isElementNode(t) ? C0e(t, r) : r.treeAdapter.isTextNode(t) ? I0e(t, r) : r.treeAdapter.isCommentNode(t) ? R0e(t, r) : r.treeAdapter.isDocumentTypeNode(t) ? N0e(t, r) : "";
}
function C0e(t, r) {
  const a = r.treeAdapter.getTagName(t);
  return `<${a}${S0e(t, r)}>${LV(t, r) ? "" : `${jV(t, r)}</${a}>`}`;
}
function S0e(t, { treeAdapter: r }) {
  let a = "";
  for (const u of r.getAttrList(t)) {
    if (a += " ", u.namespace)
      switch (u.namespace) {
        case es.NS.XML: {
          a += `xml:${u.name}`;
          break;
        }
        case es.NS.XMLNS: {
          u.name !== "xmlns" && (a += "xmlns:"), a += u.name;
          break;
        }
        case es.NS.XLINK: {
          a += `xlink:${u.name}`;
          break;
        }
        default:
          a += `${u.prefix}:${u.name}`;
      }
    else
      a += u.name;
    a += `="${(0, MV.escapeAttribute)(u.value)}"`;
  }
  return a;
}
function I0e(t, r) {
  const { treeAdapter: a } = r, u = a.getTextNodeContent(t), h = a.getParentNode(t), b = h && a.isElementNode(h) && a.getTagName(h);
  return b && a.getNamespaceURI(h) === es.NS.HTML && (0, es.hasUnescapedText)(b, r.scriptingEnabled) ? u : (0, MV.escapeText)(u);
}
function R0e(t, { treeAdapter: r }) {
  return `<!--${r.getCommentNodeContent(t)}-->`;
}
function N0e(t, { treeAdapter: r }) {
  return `<!DOCTYPE ${r.getDocumentTypeNodeName(t)}>`;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.TokenizerMode = t.Tokenizer = t.Token = t.html = t.foreignContent = t.ErrorCodes = t.serializeOuter = t.serialize = t.Parser = t.defaultTreeAdapter = void 0, t.parse = v, t.parseFragment = s;
  const r = rv;
  var a = bA;
  Object.defineProperty(t, "defaultTreeAdapter", { enumerable: !0, get: function() {
    return a.defaultTreeAdapter;
  } });
  var u = rv;
  Object.defineProperty(t, "Parser", { enumerable: !0, get: function() {
    return u.Parser;
  } });
  var h = RA;
  Object.defineProperty(t, "serialize", { enumerable: !0, get: function() {
    return h.serialize;
  } }), Object.defineProperty(t, "serializeOuter", { enumerable: !0, get: function() {
    return h.serializeOuter;
  } });
  var b = Th;
  Object.defineProperty(t, "ErrorCodes", { enumerable: !0, get: function() {
    return b.ERR;
  } }), t.foreignContent = zw, t.html = ss, t.Token = bh;
  var l = dh;
  Object.defineProperty(t, "Tokenizer", { enumerable: !0, get: function() {
    return l.Tokenizer;
  } }), Object.defineProperty(t, "TokenizerMode", { enumerable: !0, get: function() {
    return l.TokenizerMode;
  } });
  function v(c, d) {
    return r.Parser.parse(c, d);
  }
  function s(c, d, p) {
    typeof c == "string" && (p = d, d = c, c = null);
    const m = r.Parser.getFragmentParser(c, p);
    return m.tokenizer.write(d, !0), m.getFragment();
  }
})(Bw);
var HV = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.adapter = void 0, t.serializeDoctypeContent = h;
  const r = Bw, a = Ma;
  function u(b) {
    const l = b.includes('"') ? "'" : '"';
    return l + b + l;
  }
  function h(b, l, v) {
    let s = "!DOCTYPE ";
    return b && (s += b), l ? s += ` PUBLIC ${u(l)}` : v && (s += " SYSTEM"), v && (s += ` ${u(v)}`), s;
  }
  t.adapter = {
    // Re-exports from domhandler
    isCommentNode: a.isComment,
    isElementNode: a.isTag,
    isTextNode: a.isText,
    //Node construction
    createDocument() {
      const b = new a.Document([]);
      return b["x-mode"] = r.html.DOCUMENT_MODE.NO_QUIRKS, b;
    },
    createDocumentFragment() {
      return new a.Document([]);
    },
    createElement(b, l, v) {
      const s = /* @__PURE__ */ Object.create(null), c = /* @__PURE__ */ Object.create(null), d = /* @__PURE__ */ Object.create(null);
      for (let m = 0; m < v.length; m++) {
        const E = v[m].name;
        s[E] = v[m].value, c[E] = v[m].namespace, d[E] = v[m].prefix;
      }
      const p = new a.Element(b, s, []);
      return p.namespace = l, p["x-attribsNamespace"] = c, p["x-attribsPrefix"] = d, p;
    },
    createCommentNode(b) {
      return new a.Comment(b);
    },
    createTextNode(b) {
      return new a.Text(b);
    },
    //Tree mutation
    appendChild(b, l) {
      const v = b.children[b.children.length - 1];
      v && (v.next = l, l.prev = v), b.children.push(l), l.parent = b;
    },
    insertBefore(b, l, v) {
      const s = b.children.indexOf(v), { prev: c } = v;
      c && (c.next = l, l.prev = c), v.prev = l, l.next = v, b.children.splice(s, 0, l), l.parent = b;
    },
    setTemplateContent(b, l) {
      t.adapter.appendChild(b, l);
    },
    getTemplateContent(b) {
      return b.children[0];
    },
    setDocumentType(b, l, v, s) {
      const c = h(l, v, s);
      let d = b.children.find((p) => (0, a.isDirective)(p) && p.name === "!doctype");
      d ? d.data = c ?? null : (d = new a.ProcessingInstruction("!doctype", c), t.adapter.appendChild(b, d)), d["x-name"] = l, d["x-publicId"] = v, d["x-systemId"] = s;
    },
    setDocumentMode(b, l) {
      b["x-mode"] = l;
    },
    getDocumentMode(b) {
      return b["x-mode"];
    },
    detachNode(b) {
      if (b.parent) {
        const l = b.parent.children.indexOf(b), { prev: v, next: s } = b;
        b.prev = null, b.next = null, v && (v.next = s), s && (s.prev = v), b.parent.children.splice(l, 1), b.parent = null;
      }
    },
    insertText(b, l) {
      const v = b.children[b.children.length - 1];
      v && (0, a.isText)(v) ? v.data += l : t.adapter.appendChild(b, t.adapter.createTextNode(l));
    },
    insertTextBefore(b, l, v) {
      const s = b.children[b.children.indexOf(v) - 1];
      s && (0, a.isText)(s) ? s.data += l : t.adapter.insertBefore(b, t.adapter.createTextNode(l), v);
    },
    adoptAttributes(b, l) {
      for (let v = 0; v < l.length; v++) {
        const s = l[v].name;
        b.attribs[s] === void 0 && (b.attribs[s] = l[v].value, b["x-attribsNamespace"][s] = l[v].namespace, b["x-attribsPrefix"][s] = l[v].prefix);
      }
    },
    //Tree traversing
    getFirstChild(b) {
      return b.children[0];
    },
    getChildNodes(b) {
      return b.children;
    },
    getParentNode(b) {
      return b.parent;
    },
    getAttrList(b) {
      return b.attributes;
    },
    //Node data
    getTagName(b) {
      return b.name;
    },
    getNamespaceURI(b) {
      return b.namespace;
    },
    getTextNodeContent(b) {
      return b.data;
    },
    getCommentNodeContent(b) {
      return b.data;
    },
    getDocumentTypeNodeName(b) {
      var l;
      return (l = b["x-name"]) !== null && l !== void 0 ? l : "";
    },
    getDocumentTypeNodePublicId(b) {
      var l;
      return (l = b["x-publicId"]) !== null && l !== void 0 ? l : "";
    },
    getDocumentTypeNodeSystemId(b) {
      var l;
      return (l = b["x-systemId"]) !== null && l !== void 0 ? l : "";
    },
    //Node types
    isDocumentTypeNode(b) {
      return (0, a.isDirective)(b) && b.name === "!doctype";
    },
    // Source code location
    setNodeSourceCodeLocation(b, l) {
      l && (b.startIndex = l.startOffset, b.endIndex = l.endOffset), b.sourceCodeLocation = l;
    },
    getNodeSourceCodeLocation(b) {
      return b.sourceCodeLocation;
    },
    updateNodeSourceCodeLocation(b, l) {
      l.endOffset != null && (b.endIndex = l.endOffset), b.sourceCodeLocation = Object.assign(Object.assign({}, b.sourceCodeLocation), l);
    }
  };
})(HV);
var w0e = rn && rn.__spreadArray || function(t, r, a) {
  if (a || arguments.length === 2) for (var u = 0, h = r.length, b; u < h; u++)
    (b || !(u in r)) && (b || (b = Array.prototype.slice.call(r, 0, u)), b[u] = r[u]);
  return t.concat(b || Array.prototype.slice.call(r));
};
Object.defineProperty(Nm, "__esModule", { value: !0 });
Nm.renderWithParse5 = Nm.parseWithParse5 = void 0;
var _0e = Ma, mN = Bw, BV = HV;
function P0e(t, r, a, u) {
  var h = {
    scriptingEnabled: typeof r.scriptingEnabled == "boolean" ? r.scriptingEnabled : !0,
    treeAdapter: BV.adapter,
    sourceCodeLocationInfo: r.sourceCodeLocationInfo
  };
  return a ? (0, mN.parse)(t, h) : (0, mN.parseFragment)(u, t, h);
}
Nm.parseWithParse5 = P0e;
var x0e = { treeAdapter: BV.adapter };
function D0e(t) {
  for (var r, a = ("length" in t) ? t : [t], u = 0; u < a.length; u += 1) {
    var h = a[u];
    (0, _0e.isDocument)(h) && (r = Array.prototype.splice).call.apply(r, w0e([a, u, 1], h.children, !1));
  }
  for (var b = "", u = 0; u < a.length; u += 1) {
    var h = a[u];
    b += (0, mN.serializeOuter)(h, x0e);
  }
  return b;
}
Nm.renderWithParse5 = D0e;
var zV = {}, sv = {}, Yw = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.QuoteType = void 0;
  var r = bm, a;
  (function(m) {
    m[m.Tab = 9] = "Tab", m[m.NewLine = 10] = "NewLine", m[m.FormFeed = 12] = "FormFeed", m[m.CarriageReturn = 13] = "CarriageReturn", m[m.Space = 32] = "Space", m[m.ExclamationMark = 33] = "ExclamationMark", m[m.Number = 35] = "Number", m[m.Amp = 38] = "Amp", m[m.SingleQuote = 39] = "SingleQuote", m[m.DoubleQuote = 34] = "DoubleQuote", m[m.Dash = 45] = "Dash", m[m.Slash = 47] = "Slash", m[m.Zero = 48] = "Zero", m[m.Nine = 57] = "Nine", m[m.Semi = 59] = "Semi", m[m.Lt = 60] = "Lt", m[m.Eq = 61] = "Eq", m[m.Gt = 62] = "Gt", m[m.Questionmark = 63] = "Questionmark", m[m.UpperA = 65] = "UpperA", m[m.LowerA = 97] = "LowerA", m[m.UpperF = 70] = "UpperF", m[m.LowerF = 102] = "LowerF", m[m.UpperZ = 90] = "UpperZ", m[m.LowerZ = 122] = "LowerZ", m[m.LowerX = 120] = "LowerX", m[m.OpeningSquareBracket = 91] = "OpeningSquareBracket";
  })(a || (a = {}));
  var u;
  (function(m) {
    m[m.Text = 1] = "Text", m[m.BeforeTagName = 2] = "BeforeTagName", m[m.InTagName = 3] = "InTagName", m[m.InSelfClosingTag = 4] = "InSelfClosingTag", m[m.BeforeClosingTagName = 5] = "BeforeClosingTagName", m[m.InClosingTagName = 6] = "InClosingTagName", m[m.AfterClosingTagName = 7] = "AfterClosingTagName", m[m.BeforeAttributeName = 8] = "BeforeAttributeName", m[m.InAttributeName = 9] = "InAttributeName", m[m.AfterAttributeName = 10] = "AfterAttributeName", m[m.BeforeAttributeValue = 11] = "BeforeAttributeValue", m[m.InAttributeValueDq = 12] = "InAttributeValueDq", m[m.InAttributeValueSq = 13] = "InAttributeValueSq", m[m.InAttributeValueNq = 14] = "InAttributeValueNq", m[m.BeforeDeclaration = 15] = "BeforeDeclaration", m[m.InDeclaration = 16] = "InDeclaration", m[m.InProcessingInstruction = 17] = "InProcessingInstruction", m[m.BeforeComment = 18] = "BeforeComment", m[m.CDATASequence = 19] = "CDATASequence", m[m.InSpecialComment = 20] = "InSpecialComment", m[m.InCommentLike = 21] = "InCommentLike", m[m.BeforeSpecialS = 22] = "BeforeSpecialS", m[m.SpecialStartSequence = 23] = "SpecialStartSequence", m[m.InSpecialTag = 24] = "InSpecialTag", m[m.BeforeEntity = 25] = "BeforeEntity", m[m.BeforeNumericEntity = 26] = "BeforeNumericEntity", m[m.InNamedEntity = 27] = "InNamedEntity", m[m.InNumericEntity = 28] = "InNumericEntity", m[m.InHexEntity = 29] = "InHexEntity";
  })(u || (u = {}));
  function h(m) {
    return m === a.Space || m === a.NewLine || m === a.Tab || m === a.FormFeed || m === a.CarriageReturn;
  }
  function b(m) {
    return m === a.Slash || m === a.Gt || h(m);
  }
  function l(m) {
    return m >= a.Zero && m <= a.Nine;
  }
  function v(m) {
    return m >= a.LowerA && m <= a.LowerZ || m >= a.UpperA && m <= a.UpperZ;
  }
  function s(m) {
    return m >= a.UpperA && m <= a.UpperF || m >= a.LowerA && m <= a.LowerF;
  }
  var c;
  (function(m) {
    m[m.NoValue = 0] = "NoValue", m[m.Unquoted = 1] = "Unquoted", m[m.Single = 2] = "Single", m[m.Double = 3] = "Double";
  })(c = t.QuoteType || (t.QuoteType = {}));
  var d = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    CdataEnd: new Uint8Array([93, 93, 62]),
    CommentEnd: new Uint8Array([45, 45, 62]),
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
    // `</title`
  }, p = (
    /** @class */
    function() {
      function m(E, y) {
        var g = E.xmlMode, C = g === void 0 ? !1 : g, O = E.decodeEntities, N = O === void 0 ? !0 : O;
        this.cbs = y, this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = C, this.decodeEntities = N, this.entityTrie = C ? r.xmlDecodeTree : r.htmlDecodeTree;
      }
      return m.prototype.reset = function() {
        this.state = u.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = u.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
      }, m.prototype.write = function(E) {
        this.offset += this.buffer.length, this.buffer = E, this.parse();
      }, m.prototype.end = function() {
        this.running && this.finish();
      }, m.prototype.pause = function() {
        this.running = !1;
      }, m.prototype.resume = function() {
        this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
      }, m.prototype.getIndex = function() {
        return this.index;
      }, m.prototype.getSectionStart = function() {
        return this.sectionStart;
      }, m.prototype.stateText = function(E) {
        E === a.Lt || !this.decodeEntities && this.fastForwardTo(a.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = u.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && E === a.Amp && (this.state = u.BeforeEntity);
      }, m.prototype.stateSpecialStartSequence = function(E) {
        var y = this.sequenceIndex === this.currentSequence.length, g = y ? (
          // If we are at the end of the sequence, make sure the tag name has ended
          b(E)
        ) : (
          // Otherwise, do a case-insensitive comparison
          (E | 32) === this.currentSequence[this.sequenceIndex]
        );
        if (!g)
          this.isSpecial = !1;
        else if (!y) {
          this.sequenceIndex++;
          return;
        }
        this.sequenceIndex = 0, this.state = u.InTagName, this.stateInTagName(E);
      }, m.prototype.stateInSpecialTag = function(E) {
        if (this.sequenceIndex === this.currentSequence.length) {
          if (E === a.Gt || h(E)) {
            var y = this.index - this.currentSequence.length;
            if (this.sectionStart < y) {
              var g = this.index;
              this.index = y, this.cbs.ontext(this.sectionStart, y), this.index = g;
            }
            this.isSpecial = !1, this.sectionStart = y + 2, this.stateInClosingTagName(E);
            return;
          }
          this.sequenceIndex = 0;
        }
        (E | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === d.TitleEnd ? this.decodeEntities && E === a.Amp && (this.state = u.BeforeEntity) : this.fastForwardTo(a.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(E === a.Lt);
      }, m.prototype.stateCDATASequence = function(E) {
        E === d.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === d.Cdata.length && (this.state = u.InCommentLike, this.currentSequence = d.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = u.InDeclaration, this.stateInDeclaration(E));
      }, m.prototype.fastForwardTo = function(E) {
        for (; ++this.index < this.buffer.length + this.offset; )
          if (this.buffer.charCodeAt(this.index - this.offset) === E)
            return !0;
        return this.index = this.buffer.length + this.offset - 1, !1;
      }, m.prototype.stateInCommentLike = function(E) {
        E === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === d.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = u.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : E !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
      }, m.prototype.isTagStartChar = function(E) {
        return this.xmlMode ? !b(E) : v(E);
      }, m.prototype.startSpecial = function(E, y) {
        this.isSpecial = !0, this.currentSequence = E, this.sequenceIndex = y, this.state = u.SpecialStartSequence;
      }, m.prototype.stateBeforeTagName = function(E) {
        if (E === a.ExclamationMark)
          this.state = u.BeforeDeclaration, this.sectionStart = this.index + 1;
        else if (E === a.Questionmark)
          this.state = u.InProcessingInstruction, this.sectionStart = this.index + 1;
        else if (this.isTagStartChar(E)) {
          var y = E | 32;
          this.sectionStart = this.index, !this.xmlMode && y === d.TitleEnd[2] ? this.startSpecial(d.TitleEnd, 3) : this.state = !this.xmlMode && y === d.ScriptEnd[2] ? u.BeforeSpecialS : u.InTagName;
        } else E === a.Slash ? this.state = u.BeforeClosingTagName : (this.state = u.Text, this.stateText(E));
      }, m.prototype.stateInTagName = function(E) {
        b(E) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(E));
      }, m.prototype.stateBeforeClosingTagName = function(E) {
        h(E) || (E === a.Gt ? this.state = u.Text : (this.state = this.isTagStartChar(E) ? u.InClosingTagName : u.InSpecialComment, this.sectionStart = this.index));
      }, m.prototype.stateInClosingTagName = function(E) {
        (E === a.Gt || h(E)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterClosingTagName, this.stateAfterClosingTagName(E));
      }, m.prototype.stateAfterClosingTagName = function(E) {
        (E === a.Gt || this.fastForwardTo(a.Gt)) && (this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateBeforeAttributeName = function(E) {
        E === a.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = u.InSpecialTag, this.sequenceIndex = 0) : this.state = u.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : E === a.Slash ? this.state = u.InSelfClosingTag : h(E) || (this.state = u.InAttributeName, this.sectionStart = this.index);
      }, m.prototype.stateInSelfClosingTag = function(E) {
        E === a.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = u.Text, this.baseState = u.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : h(E) || (this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(E));
      }, m.prototype.stateInAttributeName = function(E) {
        (E === a.Eq || b(E)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = u.AfterAttributeName, this.stateAfterAttributeName(E));
      }, m.prototype.stateAfterAttributeName = function(E) {
        E === a.Eq ? this.state = u.BeforeAttributeValue : E === a.Slash || E === a.Gt ? (this.cbs.onattribend(c.NoValue, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(E)) : h(E) || (this.cbs.onattribend(c.NoValue, this.index), this.state = u.InAttributeName, this.sectionStart = this.index);
      }, m.prototype.stateBeforeAttributeValue = function(E) {
        E === a.DoubleQuote ? (this.state = u.InAttributeValueDq, this.sectionStart = this.index + 1) : E === a.SingleQuote ? (this.state = u.InAttributeValueSq, this.sectionStart = this.index + 1) : h(E) || (this.sectionStart = this.index, this.state = u.InAttributeValueNq, this.stateInAttributeValueNoQuotes(E));
      }, m.prototype.handleInAttributeValue = function(E, y) {
        E === y || !this.decodeEntities && this.fastForwardTo(y) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(y === a.DoubleQuote ? c.Double : c.Single, this.index), this.state = u.BeforeAttributeName) : this.decodeEntities && E === a.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, m.prototype.stateInAttributeValueDoubleQuotes = function(E) {
        this.handleInAttributeValue(E, a.DoubleQuote);
      }, m.prototype.stateInAttributeValueSingleQuotes = function(E) {
        this.handleInAttributeValue(E, a.SingleQuote);
      }, m.prototype.stateInAttributeValueNoQuotes = function(E) {
        h(E) || E === a.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(c.Unquoted, this.index), this.state = u.BeforeAttributeName, this.stateBeforeAttributeName(E)) : this.decodeEntities && E === a.Amp && (this.baseState = this.state, this.state = u.BeforeEntity);
      }, m.prototype.stateBeforeDeclaration = function(E) {
        E === a.OpeningSquareBracket ? (this.state = u.CDATASequence, this.sequenceIndex = 0) : this.state = E === a.Dash ? u.BeforeComment : u.InDeclaration;
      }, m.prototype.stateInDeclaration = function(E) {
        (E === a.Gt || this.fastForwardTo(a.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateInProcessingInstruction = function(E) {
        (E === a.Gt || this.fastForwardTo(a.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = u.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateBeforeComment = function(E) {
        E === a.Dash ? (this.state = u.InCommentLike, this.currentSequence = d.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = u.InDeclaration;
      }, m.prototype.stateInSpecialComment = function(E) {
        (E === a.Gt || this.fastForwardTo(a.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = u.Text, this.sectionStart = this.index + 1);
      }, m.prototype.stateBeforeSpecialS = function(E) {
        var y = E | 32;
        y === d.ScriptEnd[3] ? this.startSpecial(d.ScriptEnd, 4) : y === d.StyleEnd[3] ? this.startSpecial(d.StyleEnd, 4) : (this.state = u.InTagName, this.stateInTagName(E));
      }, m.prototype.stateBeforeEntity = function(E) {
        this.entityExcess = 1, this.entityResult = 0, E === a.Number ? this.state = u.BeforeNumericEntity : E === a.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = u.InNamedEntity, this.stateInNamedEntity(E));
      }, m.prototype.stateInNamedEntity = function(E) {
        if (this.entityExcess += 1, this.trieIndex = (0, r.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, E), this.trieIndex < 0) {
          this.emitNamedEntity(), this.index--;
          return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var y = this.trieCurrent & r.BinTrieFlags.VALUE_LENGTH;
        if (y) {
          var g = (y >> 14) - 1;
          if (!this.allowLegacyEntity() && E !== a.Semi)
            this.trieIndex += g;
          else {
            var C = this.index - this.entityExcess + 1;
            C > this.sectionStart && this.emitPartial(this.sectionStart, C), this.entityResult = this.trieIndex, this.trieIndex += g, this.entityExcess = 0, this.sectionStart = this.index + 1, g === 0 && this.emitNamedEntity();
          }
        }
      }, m.prototype.emitNamedEntity = function() {
        if (this.state = this.baseState, this.entityResult !== 0) {
          var E = (this.entityTrie[this.entityResult] & r.BinTrieFlags.VALUE_LENGTH) >> 14;
          switch (E) {
            case 1: {
              this.emitCodePoint(this.entityTrie[this.entityResult] & ~r.BinTrieFlags.VALUE_LENGTH);
              break;
            }
            case 2: {
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
              break;
            }
            case 3:
              this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
          }
        }
      }, m.prototype.stateBeforeNumericEntity = function(E) {
        (E | 32) === a.LowerX ? (this.entityExcess++, this.state = u.InHexEntity) : (this.state = u.InNumericEntity, this.stateInNumericEntity(E));
      }, m.prototype.emitNumericEntity = function(E) {
        var y = this.index - this.entityExcess - 1, g = y + 2 + +(this.state === u.InHexEntity);
        g !== this.index && (y > this.sectionStart && this.emitPartial(this.sectionStart, y), this.sectionStart = this.index + Number(E), this.emitCodePoint((0, r.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
      }, m.prototype.stateInNumericEntity = function(E) {
        E === a.Semi ? this.emitNumericEntity(!0) : l(E) ? (this.entityResult = this.entityResult * 10 + (E - a.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, m.prototype.stateInHexEntity = function(E) {
        E === a.Semi ? this.emitNumericEntity(!0) : l(E) ? (this.entityResult = this.entityResult * 16 + (E - a.Zero), this.entityExcess++) : s(E) ? (this.entityResult = this.entityResult * 16 + ((E | 32) - a.LowerA + 10), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
      }, m.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === u.Text || this.baseState === u.InSpecialTag);
      }, m.prototype.cleanup = function() {
        this.running && this.sectionStart !== this.index && (this.state === u.Text || this.state === u.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === u.InAttributeValueDq || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
      }, m.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
      }, m.prototype.parse = function() {
        for (; this.shouldContinue(); ) {
          var E = this.buffer.charCodeAt(this.index - this.offset);
          switch (this.state) {
            case u.Text: {
              this.stateText(E);
              break;
            }
            case u.SpecialStartSequence: {
              this.stateSpecialStartSequence(E);
              break;
            }
            case u.InSpecialTag: {
              this.stateInSpecialTag(E);
              break;
            }
            case u.CDATASequence: {
              this.stateCDATASequence(E);
              break;
            }
            case u.InAttributeValueDq: {
              this.stateInAttributeValueDoubleQuotes(E);
              break;
            }
            case u.InAttributeName: {
              this.stateInAttributeName(E);
              break;
            }
            case u.InCommentLike: {
              this.stateInCommentLike(E);
              break;
            }
            case u.InSpecialComment: {
              this.stateInSpecialComment(E);
              break;
            }
            case u.BeforeAttributeName: {
              this.stateBeforeAttributeName(E);
              break;
            }
            case u.InTagName: {
              this.stateInTagName(E);
              break;
            }
            case u.InClosingTagName: {
              this.stateInClosingTagName(E);
              break;
            }
            case u.BeforeTagName: {
              this.stateBeforeTagName(E);
              break;
            }
            case u.AfterAttributeName: {
              this.stateAfterAttributeName(E);
              break;
            }
            case u.InAttributeValueSq: {
              this.stateInAttributeValueSingleQuotes(E);
              break;
            }
            case u.BeforeAttributeValue: {
              this.stateBeforeAttributeValue(E);
              break;
            }
            case u.BeforeClosingTagName: {
              this.stateBeforeClosingTagName(E);
              break;
            }
            case u.AfterClosingTagName: {
              this.stateAfterClosingTagName(E);
              break;
            }
            case u.BeforeSpecialS: {
              this.stateBeforeSpecialS(E);
              break;
            }
            case u.InAttributeValueNq: {
              this.stateInAttributeValueNoQuotes(E);
              break;
            }
            case u.InSelfClosingTag: {
              this.stateInSelfClosingTag(E);
              break;
            }
            case u.InDeclaration: {
              this.stateInDeclaration(E);
              break;
            }
            case u.BeforeDeclaration: {
              this.stateBeforeDeclaration(E);
              break;
            }
            case u.BeforeComment: {
              this.stateBeforeComment(E);
              break;
            }
            case u.InProcessingInstruction: {
              this.stateInProcessingInstruction(E);
              break;
            }
            case u.InNamedEntity: {
              this.stateInNamedEntity(E);
              break;
            }
            case u.BeforeEntity: {
              this.stateBeforeEntity(E);
              break;
            }
            case u.InHexEntity: {
              this.stateInHexEntity(E);
              break;
            }
            case u.InNumericEntity: {
              this.stateInNumericEntity(E);
              break;
            }
            default:
              this.stateBeforeNumericEntity(E);
          }
          this.index++;
        }
        this.cleanup();
      }, m.prototype.finish = function() {
        this.state === u.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
      }, m.prototype.handleTrailingData = function() {
        var E = this.buffer.length + this.offset;
        this.state === u.InCommentLike ? this.currentSequence === d.CdataEnd ? this.cbs.oncdata(this.sectionStart, E, 0) : this.cbs.oncomment(this.sectionStart, E, 0) : this.state === u.InNumericEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === u.InTagName || this.state === u.BeforeAttributeName || this.state === u.BeforeAttributeValue || this.state === u.AfterAttributeName || this.state === u.InAttributeName || this.state === u.InAttributeValueSq || this.state === u.InAttributeValueDq || this.state === u.InAttributeValueNq || this.state === u.InClosingTagName || this.cbs.ontext(this.sectionStart, E);
      }, m.prototype.emitPartial = function(E, y) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribdata(E, y) : this.cbs.ontext(E, y);
      }, m.prototype.emitCodePoint = function(E) {
        this.baseState !== u.Text && this.baseState !== u.InSpecialTag ? this.cbs.onattribentity(E) : this.cbs.ontextentity(E);
      }, m;
    }()
  );
  t.default = p;
})(Yw);
var M0e = rn && rn.__createBinding || (Object.create ? function(t, r, a, u) {
  u === void 0 && (u = a);
  var h = Object.getOwnPropertyDescriptor(r, a);
  (!h || ("get" in h ? !r.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
    return r[a];
  } }), Object.defineProperty(t, u, h);
} : function(t, r, a, u) {
  u === void 0 && (u = a), t[u] = r[a];
}), L0e = rn && rn.__setModuleDefault || (Object.create ? function(t, r) {
  Object.defineProperty(t, "default", { enumerable: !0, value: r });
} : function(t, r) {
  t.default = r;
}), k0e = rn && rn.__importStar || function(t) {
  if (t && t.__esModule) return t;
  var r = {};
  if (t != null) for (var a in t) a !== "default" && Object.prototype.hasOwnProperty.call(t, a) && M0e(r, t, a);
  return L0e(r, t), r;
};
Object.defineProperty(sv, "__esModule", { value: !0 });
sv.Parser = void 0;
var j0 = k0e(Yw), sH = bm, Bp = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), Vi = /* @__PURE__ */ new Set(["p"]), aH = /* @__PURE__ */ new Set(["thead", "tbody"]), oH = /* @__PURE__ */ new Set(["dd", "dt"]), cH = /* @__PURE__ */ new Set(["rt", "rp"]), j0e = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", Vi],
  ["h1", Vi],
  ["h2", Vi],
  ["h3", Vi],
  ["h4", Vi],
  ["h5", Vi],
  ["h6", Vi],
  ["select", Bp],
  ["input", Bp],
  ["output", Bp],
  ["button", Bp],
  ["datalist", Bp],
  ["textarea", Bp],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", oH],
  ["dt", oH],
  ["address", Vi],
  ["article", Vi],
  ["aside", Vi],
  ["blockquote", Vi],
  ["details", Vi],
  ["div", Vi],
  ["dl", Vi],
  ["fieldset", Vi],
  ["figcaption", Vi],
  ["figure", Vi],
  ["footer", Vi],
  ["form", Vi],
  ["header", Vi],
  ["hr", Vi],
  ["main", Vi],
  ["nav", Vi],
  ["ol", Vi],
  ["pre", Vi],
  ["section", Vi],
  ["table", Vi],
  ["ul", Vi],
  ["rt", cH],
  ["rp", cH],
  ["tbody", aH],
  ["tfoot", aH]
]), U0e = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), uH = /* @__PURE__ */ new Set(["math", "svg"]), dH = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), H0e = /\s|\//, B0e = (
  /** @class */
  function() {
    function t(r, a) {
      a === void 0 && (a = {});
      var u, h, b, l, v;
      this.options = a, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = r ?? {}, this.lowerCaseTagNames = (u = a.lowerCaseTags) !== null && u !== void 0 ? u : !a.xmlMode, this.lowerCaseAttributeNames = (h = a.lowerCaseAttributeNames) !== null && h !== void 0 ? h : !a.xmlMode, this.tokenizer = new ((b = a.Tokenizer) !== null && b !== void 0 ? b : j0.default)(this.options, this), (v = (l = this.cbs).onparserinit) === null || v === void 0 || v.call(l, this);
    }
    return t.prototype.ontext = function(r, a) {
      var u, h, b = this.getSlice(r, a);
      this.endIndex = a - 1, (h = (u = this.cbs).ontext) === null || h === void 0 || h.call(u, b), this.startIndex = a;
    }, t.prototype.ontextentity = function(r) {
      var a, u, h = this.tokenizer.getSectionStart();
      this.endIndex = h - 1, (u = (a = this.cbs).ontext) === null || u === void 0 || u.call(a, (0, sH.fromCodePoint)(r)), this.startIndex = h;
    }, t.prototype.isVoidElement = function(r) {
      return !this.options.xmlMode && U0e.has(r);
    }, t.prototype.onopentagname = function(r, a) {
      this.endIndex = a;
      var u = this.getSlice(r, a);
      this.lowerCaseTagNames && (u = u.toLowerCase()), this.emitOpenTag(u);
    }, t.prototype.emitOpenTag = function(r) {
      var a, u, h, b;
      this.openTagStart = this.startIndex, this.tagname = r;
      var l = !this.options.xmlMode && j0e.get(r);
      if (l)
        for (; this.stack.length > 0 && l.has(this.stack[this.stack.length - 1]); ) {
          var v = this.stack.pop();
          (u = (a = this.cbs).onclosetag) === null || u === void 0 || u.call(a, v, !0);
        }
      this.isVoidElement(r) || (this.stack.push(r), uH.has(r) ? this.foreignContext.push(!0) : dH.has(r) && this.foreignContext.push(!1)), (b = (h = this.cbs).onopentagname) === null || b === void 0 || b.call(h, r), this.cbs.onopentag && (this.attribs = {});
    }, t.prototype.endOpenTag = function(r) {
      var a, u;
      this.startIndex = this.openTagStart, this.attribs && ((u = (a = this.cbs).onopentag) === null || u === void 0 || u.call(a, this.tagname, this.attribs, r), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
    }, t.prototype.onopentagend = function(r) {
      this.endIndex = r, this.endOpenTag(!1), this.startIndex = r + 1;
    }, t.prototype.onclosetag = function(r, a) {
      var u, h, b, l, v, s;
      this.endIndex = a;
      var c = this.getSlice(r, a);
      if (this.lowerCaseTagNames && (c = c.toLowerCase()), (uH.has(c) || dH.has(c)) && this.foreignContext.pop(), this.isVoidElement(c))
        !this.options.xmlMode && c === "br" && ((h = (u = this.cbs).onopentagname) === null || h === void 0 || h.call(u, "br"), (l = (b = this.cbs).onopentag) === null || l === void 0 || l.call(b, "br", {}, !0), (s = (v = this.cbs).onclosetag) === null || s === void 0 || s.call(v, "br", !1));
      else {
        var d = this.stack.lastIndexOf(c);
        if (d !== -1)
          if (this.cbs.onclosetag)
            for (var p = this.stack.length - d; p--; )
              this.cbs.onclosetag(this.stack.pop(), p !== 0);
          else
            this.stack.length = d;
        else !this.options.xmlMode && c === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
      }
      this.startIndex = a + 1;
    }, t.prototype.onselfclosingtag = function(r) {
      this.endIndex = r, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = r + 1) : this.onopentagend(r);
    }, t.prototype.closeCurrentTag = function(r) {
      var a, u, h = this.tagname;
      this.endOpenTag(r), this.stack[this.stack.length - 1] === h && ((u = (a = this.cbs).onclosetag) === null || u === void 0 || u.call(a, h, !r), this.stack.pop());
    }, t.prototype.onattribname = function(r, a) {
      this.startIndex = r;
      var u = this.getSlice(r, a);
      this.attribname = this.lowerCaseAttributeNames ? u.toLowerCase() : u;
    }, t.prototype.onattribdata = function(r, a) {
      this.attribvalue += this.getSlice(r, a);
    }, t.prototype.onattribentity = function(r) {
      this.attribvalue += (0, sH.fromCodePoint)(r);
    }, t.prototype.onattribend = function(r, a) {
      var u, h;
      this.endIndex = a, (h = (u = this.cbs).onattribute) === null || h === void 0 || h.call(u, this.attribname, this.attribvalue, r === j0.QuoteType.Double ? '"' : r === j0.QuoteType.Single ? "'" : r === j0.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
    }, t.prototype.getInstructionName = function(r) {
      var a = r.search(H0e), u = a < 0 ? r : r.substr(0, a);
      return this.lowerCaseTagNames && (u = u.toLowerCase()), u;
    }, t.prototype.ondeclaration = function(r, a) {
      this.endIndex = a;
      var u = this.getSlice(r, a);
      if (this.cbs.onprocessinginstruction) {
        var h = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("!".concat(h), "!".concat(u));
      }
      this.startIndex = a + 1;
    }, t.prototype.onprocessinginstruction = function(r, a) {
      this.endIndex = a;
      var u = this.getSlice(r, a);
      if (this.cbs.onprocessinginstruction) {
        var h = this.getInstructionName(u);
        this.cbs.onprocessinginstruction("?".concat(h), "?".concat(u));
      }
      this.startIndex = a + 1;
    }, t.prototype.oncomment = function(r, a, u) {
      var h, b, l, v;
      this.endIndex = a, (b = (h = this.cbs).oncomment) === null || b === void 0 || b.call(h, this.getSlice(r, a - u)), (v = (l = this.cbs).oncommentend) === null || v === void 0 || v.call(l), this.startIndex = a + 1;
    }, t.prototype.oncdata = function(r, a, u) {
      var h, b, l, v, s, c, d, p, m, E;
      this.endIndex = a;
      var y = this.getSlice(r, a - u);
      this.options.xmlMode || this.options.recognizeCDATA ? ((b = (h = this.cbs).oncdatastart) === null || b === void 0 || b.call(h), (v = (l = this.cbs).ontext) === null || v === void 0 || v.call(l, y), (c = (s = this.cbs).oncdataend) === null || c === void 0 || c.call(s)) : ((p = (d = this.cbs).oncomment) === null || p === void 0 || p.call(d, "[CDATA[".concat(y, "]]")), (E = (m = this.cbs).oncommentend) === null || E === void 0 || E.call(m)), this.startIndex = a + 1;
    }, t.prototype.onend = function() {
      var r, a;
      if (this.cbs.onclosetag) {
        this.endIndex = this.startIndex;
        for (var u = this.stack.length; u > 0; this.cbs.onclosetag(this.stack[--u], !0))
          ;
      }
      (a = (r = this.cbs).onend) === null || a === void 0 || a.call(r);
    }, t.prototype.reset = function() {
      var r, a, u, h;
      (a = (r = this.cbs).onreset) === null || a === void 0 || a.call(r), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (h = (u = this.cbs).onparserinit) === null || h === void 0 || h.call(u, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
    }, t.prototype.parseComplete = function(r) {
      this.reset(), this.end(r);
    }, t.prototype.getSlice = function(r, a) {
      for (; r - this.bufferOffset >= this.buffers[0].length; )
        this.shiftBuffer();
      for (var u = this.buffers[0].slice(r - this.bufferOffset, a - this.bufferOffset); a - this.bufferOffset > this.buffers[0].length; )
        this.shiftBuffer(), u += this.buffers[0].slice(0, a - this.bufferOffset);
      return u;
    }, t.prototype.shiftBuffer = function() {
      this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
    }, t.prototype.write = function(r) {
      var a, u;
      if (this.ended) {
        (u = (a = this.cbs).onerror) === null || u === void 0 || u.call(a, new Error(".write() after done!"));
        return;
      }
      this.buffers.push(r), this.tokenizer.running && (this.tokenizer.write(r), this.writeIndex++);
    }, t.prototype.end = function(r) {
      var a, u;
      if (this.ended) {
        (u = (a = this.cbs).onerror) === null || u === void 0 || u.call(a, new Error(".end() after done!"));
        return;
      }
      r && this.write(r), this.ended = !0, this.tokenizer.end();
    }, t.prototype.pause = function() {
      this.tokenizer.pause();
    }, t.prototype.resume = function() {
      for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
        this.tokenizer.write(this.buffers[this.writeIndex++]);
      this.ended && this.tokenizer.end();
    }, t.prototype.parseChunk = function(r) {
      this.write(r);
    }, t.prototype.done = function(r) {
      this.end(r);
    }, t;
  }()
);
sv.Parser = B0e;
(function(t) {
  var r = rn && rn.__createBinding || (Object.create ? function(O, N, w, _) {
    _ === void 0 && (_ = w);
    var I = Object.getOwnPropertyDescriptor(N, w);
    (!I || ("get" in I ? !N.__esModule : I.writable || I.configurable)) && (I = { enumerable: !0, get: function() {
      return N[w];
    } }), Object.defineProperty(O, _, I);
  } : function(O, N, w, _) {
    _ === void 0 && (_ = w), O[_] = N[w];
  }), a = rn && rn.__setModuleDefault || (Object.create ? function(O, N) {
    Object.defineProperty(O, "default", { enumerable: !0, value: N });
  } : function(O, N) {
    O.default = N;
  }), u = rn && rn.__importStar || function(O) {
    if (O && O.__esModule) return O;
    var N = {};
    if (O != null) for (var w in O) w !== "default" && Object.prototype.hasOwnProperty.call(O, w) && r(N, O, w);
    return a(N, O), N;
  }, h = rn && rn.__importDefault || function(O) {
    return O && O.__esModule ? O : { default: O };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.DomUtils = t.parseFeed = t.getFeed = t.ElementType = t.Tokenizer = t.createDomStream = t.parseDOM = t.parseDocument = t.DefaultHandler = t.DomHandler = t.Parser = void 0;
  var b = sv, l = sv;
  Object.defineProperty(t, "Parser", { enumerable: !0, get: function() {
    return l.Parser;
  } });
  var v = Ma, s = Ma;
  Object.defineProperty(t, "DomHandler", { enumerable: !0, get: function() {
    return s.DomHandler;
  } }), Object.defineProperty(t, "DefaultHandler", { enumerable: !0, get: function() {
    return s.DomHandler;
  } });
  function c(O, N) {
    var w = new v.DomHandler(void 0, N);
    return new b.Parser(w, N).end(O), w.root;
  }
  t.parseDocument = c;
  function d(O, N) {
    return c(O, N).children;
  }
  t.parseDOM = d;
  function p(O, N, w) {
    var _ = new v.DomHandler(O, N, w);
    return new b.Parser(_, N);
  }
  t.createDomStream = p;
  var m = Yw;
  Object.defineProperty(t, "Tokenizer", { enumerable: !0, get: function() {
    return h(m).default;
  } }), t.ElementType = u(Bm);
  var E = tu, y = tu;
  Object.defineProperty(t, "getFeed", { enumerable: !0, get: function() {
    return y.getFeed;
  } });
  var g = { xmlMode: !0 };
  function C(O, N) {
    return N === void 0 && (N = g), (0, E.getFeed)(d(O, N));
  }
  t.parseFeed = C, t.DomUtils = u(tu);
})(zV);
(function(t) {
  var r = rn && rn.__createBinding || (Object.create ? function(y, g, C, O) {
    O === void 0 && (O = C);
    var N = Object.getOwnPropertyDescriptor(g, C);
    (!N || ("get" in N ? !g.__esModule : N.writable || N.configurable)) && (N = { enumerable: !0, get: function() {
      return g[C];
    } }), Object.defineProperty(y, O, N);
  } : function(y, g, C, O) {
    O === void 0 && (O = C), y[O] = g[C];
  }), a = rn && rn.__setModuleDefault || (Object.create ? function(y, g) {
    Object.defineProperty(y, "default", { enumerable: !0, value: g });
  } : function(y, g) {
    y.default = g;
  }), u = rn && rn.__exportStar || function(y, g) {
    for (var C in y) C !== "default" && !Object.prototype.hasOwnProperty.call(g, C) && r(g, y, C);
  }, h = rn && rn.__importStar || function(y) {
    if (y && y.__esModule) return y;
    var g = {};
    if (y != null) for (var C in y) C !== "default" && Object.prototype.hasOwnProperty.call(y, C) && r(g, y, C);
    return a(g, y), g;
  }, b = rn && rn.__importDefault || function(y) {
    return y && y.__esModule ? y : { default: y };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.root = t.parseHTML = t.merge = t.contains = t.text = t.xml = t.html = t.load = void 0, u(pG, t);
  var l = oA, v = uh, s = Nm, c = b(zm), d = zV, p = (0, v.getParse)(function(y, g, C, O) {
    return g.xmlMode || g._useHtmlParser2 ? (0, d.parseDocument)(y, g) : (0, s.parseWithParse5)(y, g, C, O);
  });
  t.load = (0, l.getLoad)(p, function(y, g) {
    return g.xmlMode || g._useHtmlParser2 ? (0, c.default)(y, g) : (0, s.renderWithParse5)(y);
  }), t.default = (0, t.load)([]);
  var m = Ls;
  Object.defineProperty(t, "html", { enumerable: !0, get: function() {
    return m.html;
  } }), Object.defineProperty(t, "xml", { enumerable: !0, get: function() {
    return m.xml;
  } }), Object.defineProperty(t, "text", { enumerable: !0, get: function() {
    return m.text;
  } });
  var E = h(Ls);
  t.contains = E.contains, t.merge = E.merge, t.parseHTML = E.parseHTML, t.root = E.root;
})(hG);
var EN = { exports: {} };
(function(t, r) {
  var a = typeof self < "u" ? self : rn, u = function() {
    function b() {
      this.fetch = !1, this.DOMException = a.DOMException;
    }
    return b.prototype = a, new b();
  }();
  (function(b) {
    (function(l) {
      var v = {
        searchParams: "URLSearchParams" in b,
        iterable: "Symbol" in b && "iterator" in Symbol,
        blob: "FileReader" in b && "Blob" in b && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in b,
        arrayBuffer: "ArrayBuffer" in b
      };
      function s(U) {
        return U && DataView.prototype.isPrototypeOf(U);
      }
      if (v.arrayBuffer)
        var c = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], d = ArrayBuffer.isView || function(U) {
          return U && c.indexOf(Object.prototype.toString.call(U)) > -1;
        };
      function p(U) {
        if (typeof U != "string" && (U = String(U)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(U))
          throw new TypeError("Invalid character in header field name");
        return U.toLowerCase();
      }
      function m(U) {
        return typeof U != "string" && (U = String(U)), U;
      }
      function E(U) {
        var M = {
          next: function() {
            var V = U.shift();
            return { done: V === void 0, value: V };
          }
        };
        return v.iterable && (M[Symbol.iterator] = function() {
          return M;
        }), M;
      }
      function y(U) {
        this.map = {}, U instanceof y ? U.forEach(function(M, V) {
          this.append(V, M);
        }, this) : Array.isArray(U) ? U.forEach(function(M) {
          this.append(M[0], M[1]);
        }, this) : U && Object.getOwnPropertyNames(U).forEach(function(M) {
          this.append(M, U[M]);
        }, this);
      }
      y.prototype.append = function(U, M) {
        U = p(U), M = m(M);
        var V = this.map[U];
        this.map[U] = V ? V + ", " + M : M;
      }, y.prototype.delete = function(U) {
        delete this.map[p(U)];
      }, y.prototype.get = function(U) {
        return U = p(U), this.has(U) ? this.map[U] : null;
      }, y.prototype.has = function(U) {
        return this.map.hasOwnProperty(p(U));
      }, y.prototype.set = function(U, M) {
        this.map[p(U)] = m(M);
      }, y.prototype.forEach = function(U, M) {
        for (var V in this.map)
          this.map.hasOwnProperty(V) && U.call(M, this.map[V], V, this);
      }, y.prototype.keys = function() {
        var U = [];
        return this.forEach(function(M, V) {
          U.push(V);
        }), E(U);
      }, y.prototype.values = function() {
        var U = [];
        return this.forEach(function(M) {
          U.push(M);
        }), E(U);
      }, y.prototype.entries = function() {
        var U = [];
        return this.forEach(function(M, V) {
          U.push([V, M]);
        }), E(U);
      }, v.iterable && (y.prototype[Symbol.iterator] = y.prototype.entries);
      function g(U) {
        if (U.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        U.bodyUsed = !0;
      }
      function C(U) {
        return new Promise(function(M, V) {
          U.onload = function() {
            M(U.result);
          }, U.onerror = function() {
            V(U.error);
          };
        });
      }
      function O(U) {
        var M = new FileReader(), V = C(M);
        return M.readAsArrayBuffer(U), V;
      }
      function N(U) {
        var M = new FileReader(), V = C(M);
        return M.readAsText(U), V;
      }
      function w(U) {
        for (var M = new Uint8Array(U), V = new Array(M.length), J = 0; J < M.length; J++)
          V[J] = String.fromCharCode(M[J]);
        return V.join("");
      }
      function _(U) {
        if (U.slice)
          return U.slice(0);
        var M = new Uint8Array(U.byteLength);
        return M.set(new Uint8Array(U)), M.buffer;
      }
      function I() {
        return this.bodyUsed = !1, this._initBody = function(U) {
          this._bodyInit = U, U ? typeof U == "string" ? this._bodyText = U : v.blob && Blob.prototype.isPrototypeOf(U) ? this._bodyBlob = U : v.formData && FormData.prototype.isPrototypeOf(U) ? this._bodyFormData = U : v.searchParams && URLSearchParams.prototype.isPrototypeOf(U) ? this._bodyText = U.toString() : v.arrayBuffer && v.blob && s(U) ? (this._bodyArrayBuffer = _(U.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : v.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(U) || d(U)) ? this._bodyArrayBuffer = _(U) : this._bodyText = U = Object.prototype.toString.call(U) : this._bodyText = "", this.headers.get("content-type") || (typeof U == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : v.searchParams && URLSearchParams.prototype.isPrototypeOf(U) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, v.blob && (this.blob = function() {
          var U = g(this);
          if (U)
            return U;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? g(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(O);
        }), this.text = function() {
          var U = g(this);
          if (U)
            return U;
          if (this._bodyBlob)
            return N(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(w(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, v.formData && (this.formData = function() {
          return this.text().then(B);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var k = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function H(U) {
        var M = U.toUpperCase();
        return k.indexOf(M) > -1 ? M : U;
      }
      function S(U, M) {
        M = M || {};
        var V = M.body;
        if (U instanceof S) {
          if (U.bodyUsed)
            throw new TypeError("Already read");
          this.url = U.url, this.credentials = U.credentials, M.headers || (this.headers = new y(U.headers)), this.method = U.method, this.mode = U.mode, this.signal = U.signal, !V && U._bodyInit != null && (V = U._bodyInit, U.bodyUsed = !0);
        } else
          this.url = String(U);
        if (this.credentials = M.credentials || this.credentials || "same-origin", (M.headers || !this.headers) && (this.headers = new y(M.headers)), this.method = H(M.method || this.method || "GET"), this.mode = M.mode || this.mode || null, this.signal = M.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && V)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(V);
      }
      S.prototype.clone = function() {
        return new S(this, { body: this._bodyInit });
      };
      function B(U) {
        var M = new FormData();
        return U.trim().split("&").forEach(function(V) {
          if (V) {
            var J = V.split("="), ue = J.shift().replace(/\+/g, " "), se = J.join("=").replace(/\+/g, " ");
            M.append(decodeURIComponent(ue), decodeURIComponent(se));
          }
        }), M;
      }
      function D(U) {
        var M = new y(), V = U.replace(/\r?\n[\t ]+/g, " ");
        return V.split(/\r?\n/).forEach(function(J) {
          var ue = J.split(":"), se = ue.shift().trim();
          if (se) {
            var ee = ue.join(":").trim();
            M.append(se, ee);
          }
        }), M;
      }
      I.call(S.prototype);
      function F(U, M) {
        M || (M = {}), this.type = "default", this.status = M.status === void 0 ? 200 : M.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in M ? M.statusText : "OK", this.headers = new y(M.headers), this.url = M.url || "", this._initBody(U);
      }
      I.call(F.prototype), F.prototype.clone = function() {
        return new F(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new y(this.headers),
          url: this.url
        });
      }, F.error = function() {
        var U = new F(null, { status: 0, statusText: "" });
        return U.type = "error", U;
      };
      var j = [301, 302, 303, 307, 308];
      F.redirect = function(U, M) {
        if (j.indexOf(M) === -1)
          throw new RangeError("Invalid status code");
        return new F(null, { status: M, headers: { location: U } });
      }, l.DOMException = b.DOMException;
      try {
        new l.DOMException();
      } catch {
        l.DOMException = function(M, V) {
          this.message = M, this.name = V;
          var J = Error(M);
          this.stack = J.stack;
        }, l.DOMException.prototype = Object.create(Error.prototype), l.DOMException.prototype.constructor = l.DOMException;
      }
      function G(U, M) {
        return new Promise(function(V, J) {
          var ue = new S(U, M);
          if (ue.signal && ue.signal.aborted)
            return J(new l.DOMException("Aborted", "AbortError"));
          var se = new XMLHttpRequest();
          function ee() {
            se.abort();
          }
          se.onload = function() {
            var de = {
              status: se.status,
              statusText: se.statusText,
              headers: D(se.getAllResponseHeaders() || "")
            };
            de.url = "responseURL" in se ? se.responseURL : de.headers.get("X-Request-URL");
            var he = "response" in se ? se.response : se.responseText;
            V(new F(he, de));
          }, se.onerror = function() {
            J(new TypeError("Network request failed"));
          }, se.ontimeout = function() {
            J(new TypeError("Network request failed"));
          }, se.onabort = function() {
            J(new l.DOMException("Aborted", "AbortError"));
          }, se.open(ue.method, ue.url, !0), ue.credentials === "include" ? se.withCredentials = !0 : ue.credentials === "omit" && (se.withCredentials = !1), "responseType" in se && v.blob && (se.responseType = "blob"), ue.headers.forEach(function(de, he) {
            se.setRequestHeader(he, de);
          }), ue.signal && (ue.signal.addEventListener("abort", ee), se.onreadystatechange = function() {
            se.readyState === 4 && ue.signal.removeEventListener("abort", ee);
          }), se.send(typeof ue._bodyInit > "u" ? null : ue._bodyInit);
        });
      }
      return G.polyfill = !0, b.fetch || (b.fetch = G, b.Headers = y, b.Request = S, b.Response = F), l.Headers = y, l.Request = S, l.Response = F, l.fetch = G, Object.defineProperty(l, "__esModule", { value: !0 }), l;
    })({});
  })(u), u.fetch.ponyfill = !0, delete u.fetch.polyfill;
  var h = u;
  r = h.fetch, r.default = h.fetch, r.fetch = h.fetch, r.Headers = h.Headers, r.Request = h.Request, r.Response = h.Response, t.exports = r;
})(EN, EN.exports);
var z0e = EN.exports, NA = { exports: {} };
const { AbortController: FV, AbortSignal: F0e } = typeof self < "u" ? self : typeof window < "u" ? window : (
  /* otherwise */
  void 0
);
NA.exports = FV;
NA.exports.AbortSignal = F0e;
NA.exports.default = FV;
var G0e = NA.exports, Ym = {}, wb = { exports: {} };
/*! https://mths.be/punycode v1.3.2 by @mathias */
wb.exports;
(function(t, r) {
  (function(a) {
    var u = r && !r.nodeType && r, h = !t.nodeType && t, b = typeof rn == "object" && rn;
    (b.global === b || b.window === b || b.self === b) && (a = b);
    var l, v = 2147483647, s = 36, c = 1, d = 26, p = 38, m = 700, E = 72, y = 128, g = "-", C = /^xn--/, O = /[^\x20-\x7E]/, N = /[\x2E\u3002\uFF0E\uFF61]/g, w = {
      overflow: "Overflow: input needs wider integers to process",
      "not-basic": "Illegal input >= 0x80 (not a basic code point)",
      "invalid-input": "Invalid input"
    }, _ = s - c, I = Math.floor, k = String.fromCharCode, H;
    function S(ee) {
      throw RangeError(w[ee]);
    }
    function B(ee, de) {
      for (var he = ee.length, pe = []; he--; )
        pe[he] = de(ee[he]);
      return pe;
    }
    function D(ee, de) {
      var he = ee.split("@"), pe = "";
      he.length > 1 && (pe = he[0] + "@", ee = he[1]), ee = ee.replace(N, ".");
      var Ce = ee.split("."), _e = B(Ce, de).join(".");
      return pe + _e;
    }
    function F(ee) {
      for (var de = [], he = 0, pe = ee.length, Ce, _e; he < pe; )
        Ce = ee.charCodeAt(he++), Ce >= 55296 && Ce <= 56319 && he < pe ? (_e = ee.charCodeAt(he++), (_e & 64512) == 56320 ? de.push(((Ce & 1023) << 10) + (_e & 1023) + 65536) : (de.push(Ce), he--)) : de.push(Ce);
      return de;
    }
    function j(ee) {
      return B(ee, function(de) {
        var he = "";
        return de > 65535 && (de -= 65536, he += k(de >>> 10 & 1023 | 55296), de = 56320 | de & 1023), he += k(de), he;
      }).join("");
    }
    function G(ee) {
      return ee - 48 < 10 ? ee - 22 : ee - 65 < 26 ? ee - 65 : ee - 97 < 26 ? ee - 97 : s;
    }
    function U(ee, de) {
      return ee + 22 + 75 * (ee < 26) - ((de != 0) << 5);
    }
    function M(ee, de, he) {
      var pe = 0;
      for (ee = he ? I(ee / m) : ee >> 1, ee += I(ee / de); ee > _ * d >> 1; pe += s)
        ee = I(ee / _);
      return I(pe + (_ + 1) * ee / (ee + p));
    }
    function V(ee) {
      var de = [], he = ee.length, pe, Ce = 0, _e = y, Le = E, Te, K, Oe, Pe, xe, be, $e, Be, Ke;
      for (Te = ee.lastIndexOf(g), Te < 0 && (Te = 0), K = 0; K < Te; ++K)
        ee.charCodeAt(K) >= 128 && S("not-basic"), de.push(ee.charCodeAt(K));
      for (Oe = Te > 0 ? Te + 1 : 0; Oe < he; ) {
        for (Pe = Ce, xe = 1, be = s; Oe >= he && S("invalid-input"), $e = G(ee.charCodeAt(Oe++)), ($e >= s || $e > I((v - Ce) / xe)) && S("overflow"), Ce += $e * xe, Be = be <= Le ? c : be >= Le + d ? d : be - Le, !($e < Be); be += s)
          Ke = s - Be, xe > I(v / Ke) && S("overflow"), xe *= Ke;
        pe = de.length + 1, Le = M(Ce - Pe, pe, Pe == 0), I(Ce / pe) > v - _e && S("overflow"), _e += I(Ce / pe), Ce %= pe, de.splice(Ce++, 0, _e);
      }
      return j(de);
    }
    function J(ee) {
      var de, he, pe, Ce, _e, Le, Te, K, Oe, Pe, xe, be = [], $e, Be, Ke, Ze;
      for (ee = F(ee), $e = ee.length, de = y, he = 0, _e = E, Le = 0; Le < $e; ++Le)
        xe = ee[Le], xe < 128 && be.push(k(xe));
      for (pe = Ce = be.length, Ce && be.push(g); pe < $e; ) {
        for (Te = v, Le = 0; Le < $e; ++Le)
          xe = ee[Le], xe >= de && xe < Te && (Te = xe);
        for (Be = pe + 1, Te - de > I((v - he) / Be) && S("overflow"), he += (Te - de) * Be, de = Te, Le = 0; Le < $e; ++Le)
          if (xe = ee[Le], xe < de && ++he > v && S("overflow"), xe == de) {
            for (K = he, Oe = s; Pe = Oe <= _e ? c : Oe >= _e + d ? d : Oe - _e, !(K < Pe); Oe += s)
              Ze = K - Pe, Ke = s - Pe, be.push(
                k(U(Pe + Ze % Ke, 0))
              ), K = I(Ze / Ke);
            be.push(k(U(K, 0))), _e = M(he, Be, pe == Ce), he = 0, ++pe;
          }
        ++he, ++de;
      }
      return be.join("");
    }
    function ue(ee) {
      return D(ee, function(de) {
        return C.test(de) ? V(de.slice(4).toLowerCase()) : de;
      });
    }
    function se(ee) {
      return D(ee, function(de) {
        return O.test(de) ? "xn--" + J(de) : de;
      });
    }
    if (l = {
      /**
       * A string representing the current Punycode.js version number.
       * @memberOf punycode
       * @type String
       */
      version: "1.3.2",
      /**
       * An object of methods to convert from JavaScript's internal character
       * representation (UCS-2) to Unicode code points, and back.
       * @see <https://mathiasbynens.be/notes/javascript-encoding>
       * @memberOf punycode
       * @type Object
       */
      ucs2: {
        decode: F,
        encode: j
      },
      decode: V,
      encode: J,
      toASCII: se,
      toUnicode: ue
    }, u && h)
      if (t.exports == u)
        h.exports = l;
      else
        for (H in l)
          l.hasOwnProperty(H) && (u[H] = l[H]);
    else
      a.punycode = l;
  })(rn);
})(wb, wb.exports);
var V0e = wb.exports, Y0e = {
  isString: function(t) {
    return typeof t == "string";
  },
  isObject: function(t) {
    return typeof t == "object" && t !== null;
  },
  isNull: function(t) {
    return t === null;
  },
  isNullOrUndefined: function(t) {
    return t == null;
  }
}, av = {};
function X0e(t, r) {
  return Object.prototype.hasOwnProperty.call(t, r);
}
var W0e = function(t, r, a, u) {
  r = r || "&", a = a || "=";
  var h = {};
  if (typeof t != "string" || t.length === 0)
    return h;
  var b = /\+/g;
  t = t.split(r);
  var l = 1e3;
  u && typeof u.maxKeys == "number" && (l = u.maxKeys);
  var v = t.length;
  l > 0 && v > l && (v = l);
  for (var s = 0; s < v; ++s) {
    var c = t[s].replace(b, "%20"), d = c.indexOf(a), p, m, E, y;
    d >= 0 ? (p = c.substr(0, d), m = c.substr(d + 1)) : (p = c, m = ""), E = decodeURIComponent(p), y = decodeURIComponent(m), X0e(h, E) ? Array.isArray(h[E]) ? h[E].push(y) : h[E] = [h[E], y] : h[E] = y;
  }
  return h;
}, Ry = function(t) {
  switch (typeof t) {
    case "string":
      return t;
    case "boolean":
      return t ? "true" : "false";
    case "number":
      return isFinite(t) ? t : "";
    default:
      return "";
  }
}, q0e = function(t, r, a, u) {
  return r = r || "&", a = a || "=", t === null && (t = void 0), typeof t == "object" ? Object.keys(t).map(function(h) {
    var b = encodeURIComponent(Ry(h)) + a;
    return Array.isArray(t[h]) ? t[h].map(function(l) {
      return b + encodeURIComponent(Ry(l));
    }).join(r) : b + encodeURIComponent(Ry(t[h]));
  }).join(r) : u ? encodeURIComponent(Ry(u)) + a + encodeURIComponent(Ry(t)) : "";
};
av.decode = av.parse = W0e;
av.encode = av.stringify = q0e;
var K0e = V0e, Du = Y0e;
Ym.parse = Mv;
Ym.resolve = sbe;
Ym.resolveObject = abe;
Ym.format = ibe;
Ym.Url = Cc;
function Cc() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
var J0e = /^([a-z0-9.+-]+:)/i, Z0e = /:[0-9]*$/, Q0e = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, $0e = ["<", ">", '"', "`", " ", "\r", `
`, "	"], ebe = ["{", "}", "|", "\\", "^", "`"].concat($0e), yN = ["'"].concat(ebe), lH = ["%", "/", "?", ";", "#"].concat(yN), fH = ["/", "?", "#"], tbe = 255, hH = /^[+a-z0-9A-Z_-]{0,63}$/, nbe = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, rbe = {
  javascript: !0,
  "javascript:": !0
}, vN = {
  javascript: !0,
  "javascript:": !0
}, cg = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
}, TN = av;
function Mv(t, r, a) {
  if (t && Du.isObject(t) && t instanceof Cc) return t;
  var u = new Cc();
  return u.parse(t, r, a), u;
}
Cc.prototype.parse = function(t, r, a) {
  if (!Du.isString(t))
    throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
  var u = t.indexOf("?"), h = u !== -1 && u < t.indexOf("#") ? "?" : "#", b = t.split(h), l = /\\/g;
  b[0] = b[0].replace(l, "/"), t = b.join(h);
  var v = t;
  if (v = v.trim(), !a && t.split("#").length === 1) {
    var s = Q0e.exec(v);
    if (s)
      return this.path = v, this.href = v, this.pathname = s[1], s[2] ? (this.search = s[2], r ? this.query = TN.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : r && (this.search = "", this.query = {}), this;
  }
  var c = J0e.exec(v);
  if (c) {
    c = c[0];
    var d = c.toLowerCase();
    this.protocol = d, v = v.substr(c.length);
  }
  if (a || c || v.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var p = v.substr(0, 2) === "//";
    p && !(c && vN[c]) && (v = v.substr(2), this.slashes = !0);
  }
  if (!vN[c] && (p || c && !cg[c])) {
    for (var m = -1, E = 0; E < fH.length; E++) {
      var y = v.indexOf(fH[E]);
      y !== -1 && (m === -1 || y < m) && (m = y);
    }
    var g, C;
    m === -1 ? C = v.lastIndexOf("@") : C = v.lastIndexOf("@", m), C !== -1 && (g = v.slice(0, C), v = v.slice(C + 1), this.auth = decodeURIComponent(g)), m = -1;
    for (var E = 0; E < lH.length; E++) {
      var y = v.indexOf(lH[E]);
      y !== -1 && (m === -1 || y < m) && (m = y);
    }
    m === -1 && (m = v.length), this.host = v.slice(0, m), v = v.slice(m), this.parseHost(), this.hostname = this.hostname || "";
    var O = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!O)
      for (var N = this.hostname.split(/\./), E = 0, w = N.length; E < w; E++) {
        var _ = N[E];
        if (_ && !_.match(hH)) {
          for (var I = "", k = 0, H = _.length; k < H; k++)
            _.charCodeAt(k) > 127 ? I += "x" : I += _[k];
          if (!I.match(hH)) {
            var S = N.slice(0, E), B = N.slice(E + 1), D = _.match(nbe);
            D && (S.push(D[1]), B.unshift(D[2])), B.length && (v = "/" + B.join(".") + v), this.hostname = S.join(".");
            break;
          }
        }
      }
    this.hostname.length > tbe ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), O || (this.hostname = K0e.toASCII(this.hostname));
    var F = this.port ? ":" + this.port : "", j = this.hostname || "";
    this.host = j + F, this.href += this.host, O && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), v[0] !== "/" && (v = "/" + v));
  }
  if (!rbe[d])
    for (var E = 0, w = yN.length; E < w; E++) {
      var G = yN[E];
      if (v.indexOf(G) !== -1) {
        var U = encodeURIComponent(G);
        U === G && (U = escape(G)), v = v.split(G).join(U);
      }
    }
  var M = v.indexOf("#");
  M !== -1 && (this.hash = v.substr(M), v = v.slice(0, M));
  var V = v.indexOf("?");
  if (V !== -1 ? (this.search = v.substr(V), this.query = v.substr(V + 1), r && (this.query = TN.parse(this.query)), v = v.slice(0, V)) : r && (this.search = "", this.query = {}), v && (this.pathname = v), cg[d] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
    var F = this.pathname || "", J = this.search || "";
    this.path = F + J;
  }
  return this.href = this.format(), this;
};
function ibe(t) {
  return Du.isString(t) && (t = Mv(t)), t instanceof Cc ? t.format() : Cc.prototype.format.call(t);
}
Cc.prototype.format = function() {
  var t = this.auth || "";
  t && (t = encodeURIComponent(t), t = t.replace(/%3A/i, ":"), t += "@");
  var r = this.protocol || "", a = this.pathname || "", u = this.hash || "", h = !1, b = "";
  this.host ? h = t + this.host : this.hostname && (h = t + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (h += ":" + this.port)), this.query && Du.isObject(this.query) && Object.keys(this.query).length && (b = TN.stringify(this.query));
  var l = this.search || b && "?" + b || "";
  return r && r.substr(-1) !== ":" && (r += ":"), this.slashes || (!r || cg[r]) && h !== !1 ? (h = "//" + (h || ""), a && a.charAt(0) !== "/" && (a = "/" + a)) : h || (h = ""), u && u.charAt(0) !== "#" && (u = "#" + u), l && l.charAt(0) !== "?" && (l = "?" + l), a = a.replace(/[?#]/g, function(v) {
    return encodeURIComponent(v);
  }), l = l.replace("#", "%23"), r + h + a + l + u;
};
function sbe(t, r) {
  return Mv(t, !1, !0).resolve(r);
}
Cc.prototype.resolve = function(t) {
  return this.resolveObject(Mv(t, !1, !0)).format();
};
function abe(t, r) {
  return t ? Mv(t, !1, !0).resolveObject(r) : r;
}
Cc.prototype.resolveObject = function(t) {
  if (Du.isString(t)) {
    var r = new Cc();
    r.parse(t, !1, !0), t = r;
  }
  for (var a = new Cc(), u = Object.keys(this), h = 0; h < u.length; h++) {
    var b = u[h];
    a[b] = this[b];
  }
  if (a.hash = t.hash, t.href === "")
    return a.href = a.format(), a;
  if (t.slashes && !t.protocol) {
    for (var l = Object.keys(t), v = 0; v < l.length; v++) {
      var s = l[v];
      s !== "protocol" && (a[s] = t[s]);
    }
    return cg[a.protocol] && a.hostname && !a.pathname && (a.path = a.pathname = "/"), a.href = a.format(), a;
  }
  if (t.protocol && t.protocol !== a.protocol) {
    if (!cg[t.protocol]) {
      for (var c = Object.keys(t), d = 0; d < c.length; d++) {
        var p = c[d];
        a[p] = t[p];
      }
      return a.href = a.format(), a;
    }
    if (a.protocol = t.protocol, !t.host && !vN[t.protocol]) {
      for (var w = (t.pathname || "").split("/"); w.length && !(t.host = w.shift()); ) ;
      t.host || (t.host = ""), t.hostname || (t.hostname = ""), w[0] !== "" && w.unshift(""), w.length < 2 && w.unshift(""), a.pathname = w.join("/");
    } else
      a.pathname = t.pathname;
    if (a.search = t.search, a.query = t.query, a.host = t.host || "", a.auth = t.auth, a.hostname = t.hostname || t.host, a.port = t.port, a.pathname || a.search) {
      var m = a.pathname || "", E = a.search || "";
      a.path = m + E;
    }
    return a.slashes = a.slashes || t.slashes, a.href = a.format(), a;
  }
  var y = a.pathname && a.pathname.charAt(0) === "/", g = t.host || t.pathname && t.pathname.charAt(0) === "/", C = g || y || a.host && t.pathname, O = C, N = a.pathname && a.pathname.split("/") || [], w = t.pathname && t.pathname.split("/") || [], _ = a.protocol && !cg[a.protocol];
  if (_ && (a.hostname = "", a.port = null, a.host && (N[0] === "" ? N[0] = a.host : N.unshift(a.host)), a.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && (w[0] === "" ? w[0] = t.host : w.unshift(t.host)), t.host = null), C = C && (w[0] === "" || N[0] === "")), g)
    a.host = t.host || t.host === "" ? t.host : a.host, a.hostname = t.hostname || t.hostname === "" ? t.hostname : a.hostname, a.search = t.search, a.query = t.query, N = w;
  else if (w.length)
    N || (N = []), N.pop(), N = N.concat(w), a.search = t.search, a.query = t.query;
  else if (!Du.isNullOrUndefined(t.search)) {
    if (_) {
      a.hostname = a.host = N.shift();
      var I = a.host && a.host.indexOf("@") > 0 ? a.host.split("@") : !1;
      I && (a.auth = I.shift(), a.host = a.hostname = I.shift());
    }
    return a.search = t.search, a.query = t.query, (!Du.isNull(a.pathname) || !Du.isNull(a.search)) && (a.path = (a.pathname ? a.pathname : "") + (a.search ? a.search : "")), a.href = a.format(), a;
  }
  if (!N.length)
    return a.pathname = null, a.search ? a.path = "/" + a.search : a.path = null, a.href = a.format(), a;
  for (var k = N.slice(-1)[0], H = (a.host || t.host || N.length > 1) && (k === "." || k === "..") || k === "", S = 0, B = N.length; B >= 0; B--)
    k = N[B], k === "." ? N.splice(B, 1) : k === ".." ? (N.splice(B, 1), S++) : S && (N.splice(B, 1), S--);
  if (!C && !O)
    for (; S--; S)
      N.unshift("..");
  C && N[0] !== "" && (!N[0] || N[0].charAt(0) !== "/") && N.unshift(""), H && N.join("/").substr(-1) !== "/" && N.push("");
  var D = N[0] === "" || N[0] && N[0].charAt(0) === "/";
  if (_) {
    a.hostname = a.host = D ? "" : N.length ? N.shift() : "";
    var I = a.host && a.host.indexOf("@") > 0 ? a.host.split("@") : !1;
    I && (a.auth = I.shift(), a.host = a.hostname = I.shift());
  }
  return C = C || a.host && N.length, C && !D && N.unshift(""), N.length ? a.pathname = N.join("/") : (a.pathname = null, a.path = null), (!Du.isNull(a.pathname) || !Du.isNull(a.search)) && (a.path = (a.pathname ? a.pathname : "") + (a.search ? a.search : "")), a.auth = t.auth || a.auth, a.slashes = a.slashes || t.slashes, a.href = a.format(), a;
};
Cc.prototype.parseHost = function() {
  var t = this.host, r = Z0e.exec(t);
  r && (r = r[0], r !== ":" && (this.port = r.substr(1)), t = t.substr(0, t.length - r.length)), t && (this.hostname = t);
};
var wA = {};
Object.defineProperty(wA, "__esModule", { value: !0 });
wA.CONSTANTS = void 0;
wA.CONSTANTS = {
  REGEX_VALID_URL: new RegExp("^(?:(?:https?|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$", "i"),
  REGEX_LOOPBACK: new RegExp("^(?:127(?:\\.\\d{1,3}){3})|(?:10(?:\\.\\d{1,3}){3})|(?:172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})|(?:192\\.168(?:\\.\\d{1,3}){2})|(?:169\\.254(?:\\.\\d{1,3}){2})|(?:192\\.0\\.2(?:\\.\\d{1,3}){1})|(?:198\\.51\\.100(?:\\.\\d{1,3}){1})|(?:203\\.0\\.113(?:\\.\\d{1,3}){1})|(?:100\\.(?:6[4-9]|[7-9]\\d|1[0-1]\\d)(?:\\.\\d{1,3}){2})$", "i"),
  REGEX_CONTENT_TYPE_IMAGE: new RegExp("image/.*", "i"),
  REGEX_CONTENT_TYPE_AUDIO: new RegExp("audio/.*", "i"),
  REGEX_CONTENT_TYPE_VIDEO: new RegExp("video/.*", "i"),
  REGEX_CONTENT_TYPE_TEXT: new RegExp("text/.*", "i"),
  REGEX_CONTENT_TYPE_APPLICATION: new RegExp("application/.*", "i")
};
var go = rn && rn.__assign || function() {
  return go = Object.assign || function(t) {
    for (var r, a = 1, u = arguments.length; a < u; a++) {
      r = arguments[a];
      for (var h in r) Object.prototype.hasOwnProperty.call(r, h) && (t[h] = r[h]);
    }
    return t;
  }, go.apply(this, arguments);
}, GV = rn && rn.__awaiter || function(t, r, a, u) {
  function h(b) {
    return b instanceof a ? b : new a(function(l) {
      l(b);
    });
  }
  return new (a || (a = Promise))(function(b, l) {
    function v(d) {
      try {
        c(u.next(d));
      } catch (p) {
        l(p);
      }
    }
    function s(d) {
      try {
        c(u.throw(d));
      } catch (p) {
        l(p);
      }
    }
    function c(d) {
      d.done ? b(d.value) : h(d.value).then(v, s);
    }
    c((u = u.apply(t, r || [])).next());
  });
}, VV = rn && rn.__generator || function(t, r) {
  var a = { label: 0, sent: function() {
    if (b[0] & 1) throw b[1];
    return b[1];
  }, trys: [], ops: [] }, u, h, b, l;
  return l = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function v(c) {
    return function(d) {
      return s([c, d]);
    };
  }
  function s(c) {
    if (u) throw new TypeError("Generator is already executing.");
    for (; a; ) try {
      if (u = 1, h && (b = c[0] & 2 ? h.return : c[0] ? h.throw || ((b = h.return) && b.call(h), 0) : h.next) && !(b = b.call(h, c[1])).done) return b;
      switch (h = 0, b && (c = [c[0] & 2, b.value]), c[0]) {
        case 0:
        case 1:
          b = c;
          break;
        case 4:
          return a.label++, { value: c[1], done: !1 };
        case 5:
          a.label++, h = c[1], c = [0];
          continue;
        case 7:
          c = a.ops.pop(), a.trys.pop();
          continue;
        default:
          if (b = a.trys, !(b = b.length > 0 && b[b.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            a = 0;
            continue;
          }
          if (c[0] === 3 && (!b || c[1] > b[0] && c[1] < b[3])) {
            a.label = c[1];
            break;
          }
          if (c[0] === 6 && a.label < b[1]) {
            a.label = b[1], b = c;
            break;
          }
          if (b && a.label < b[2]) {
            a.label = b[2], a.ops.push(c);
            break;
          }
          b[2] && a.ops.pop(), a.trys.pop();
          continue;
      }
      c = r.call(t, a);
    } catch (d) {
      c = [6, d], h = 0;
    } finally {
      u = b = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, Xw = rn && rn.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(ev, "__esModule", { value: !0 });
ev.getPreviewFromContent = WV = ev.getLinkPreview = void 0;
var obe = Xw(hG), pH = z0e, cbe = Xw(G0e), Xy = Xw(Ym), $f = wA;
function gH(t) {
  if ($f.CONSTANTS.REGEX_LOOPBACK.test(t))
    throw new Error("SSRF request detected, trying to query host");
}
function Id(t, r, a) {
  var u = t("meta[".concat(a, "='").concat(r, "']"));
  return u.length ? u : null;
}
function Ho(t, r, a) {
  return t("meta[".concat(a, "='").concat(r, "']")).attr("content");
}
function ube(t) {
  var r = Ho(t, "og:title", "property") || Ho(t, "og:title", "name");
  return r || (r = t("head > title").text()), r;
}
function dbe(t) {
  var r = Ho(t, "og:site_name", "property") || Ho(t, "og:site_name", "name");
  return r;
}
function lbe(t) {
  var r = Ho(t, "description", "name") || Ho(t, "Description", "name") || Ho(t, "og:description", "property");
  return r;
}
function fbe(t) {
  var r = Id(t, "medium", "name");
  if (r) {
    var a = r.attr("content");
    return a === "image" ? "photo" : a;
  }
  return Ho(t, "og:type", "property") || Ho(t, "og:type", "name");
}
function hbe(t, r, a) {
  var u = [], h, b, l = {}, v = a ?? "og";
  return h = Id(t, "".concat(v, ":image"), "property") || Id(t, "".concat(v, ":image"), "name"), h && h.each(function(s, c) {
    c.type === "tag" && (b = c.attribs.content, b && (b = Xy.default.resolve(r, b), u.push(b)));
  }), u.length <= 0 && !a && (b = t("link[rel=image_src]").attr("href"), b ? (b = Xy.default.resolve(r, b), u = [b]) : (h = t("img"), h != null && h.length && (l = {}, u = [], h.each(function(s, c) {
    c.type === "tag" && (b = c.attribs.src), b && !l[b] && (l[b] = !0, u.push(Xy.default.resolve(r, b)));
  })))), u;
}
function pbe(t) {
  var r = [], a, u, h, b, l, v, s, c, d, p, m, E = Id(t, "og:video", "property") || Id(t, "og:video", "name");
  if (E != null && E.length)
    for (a = Id(t, "og:video:type", "property") || Id(t, "og:video:type", "name"), u = Id(t, "og:video:secure_url", "property") || Id(t, "og:video:secure_url", "name"), c = Ho(t, "og:video:width", "property") || Ho(t, "og:video:width", "name"), d = Ho(t, "og:video:height", "property") || Ho(t, "og:video:height", "name"), m = 0; m < E.length; m += 1) {
      var y = E[m];
      y.type === "tag" && (l = y.attribs.content), h = a == null ? void 0 : a[m], (h == null ? void 0 : h.type) === "tag" && (v = h ? h.attribs.content : null), b = u == null ? void 0 : u[m], (b == null ? void 0 : b.type) === "tag" && (s = b ? b.attribs.content : null), p = {
        url: l,
        secureUrl: s,
        type: v,
        width: c,
        height: d
      }, v && v.indexOf("video/") === 0 ? r.splice(0, 0, p) : r.push(p);
    }
  return r;
}
function Lv(t) {
  return Xy.default.resolve(t, "/favicon.ico");
}
function gbe(t, r) {
  var a = [], u = [], h, b = [
    "rel=icon",
    'rel="shortcut icon"',
    "rel=apple-touch-icon"
  ];
  return b.forEach(function(l) {
    u = t("link[".concat(l, "]")), u.length && u.each(function(v, s) {
      s.type === "tag" && (h = s.attribs.href), h && (h = Xy.default.resolve(r, h), a.push(h));
    });
  }), a.length <= 0 && a.push(Lv(r)), a;
}
function mbe(t, r) {
  return {
    url: t,
    mediaType: "image",
    contentType: r,
    favicons: [Lv(t)]
  };
}
function Ebe(t, r) {
  return {
    url: t,
    mediaType: "audio",
    contentType: r,
    favicons: [Lv(t)]
  };
}
function ybe(t, r) {
  return {
    url: t,
    mediaType: "video",
    contentType: r,
    favicons: [Lv(t)]
  };
}
function vbe(t, r) {
  return {
    url: t,
    mediaType: "application",
    contentType: r,
    favicons: [Lv(t)]
  };
}
function YV(t, r, a, u) {
  a === void 0 && (a = {});
  var h = obe.default.load(t);
  return {
    url: r,
    title: ube(h),
    siteName: dbe(h),
    description: lbe(h),
    mediaType: fbe(h) || "website",
    contentType: u,
    images: hbe(h, r, a.imagesPropertyType),
    videos: pbe(h),
    favicons: gbe(h, r)
  };
}
function mH(t, r, a, u) {
  return a === void 0 && (a = {}), YV(t, r, a, u);
}
function XV(t, r) {
  try {
    var a = t.headers["content-type"], u = [], h = null;
    if (!a)
      return mH(t.data, t.url, r);
    if (a.includes(";")) {
      u = a.split(";"), a = u[0];
      for (var b = 0, l = u; b < l.length; b++) {
        var v = l[b];
        v.indexOf("charset=") !== -1 && (h = v.split("=")[1]);
      }
    }
    if ($f.CONSTANTS.REGEX_CONTENT_TYPE_IMAGE.test(a))
      return go(go({}, mbe(t.url, a)), { charset: h });
    if ($f.CONSTANTS.REGEX_CONTENT_TYPE_AUDIO.test(a))
      return go(go({}, Ebe(t.url, a)), { charset: h });
    if ($f.CONSTANTS.REGEX_CONTENT_TYPE_VIDEO.test(a))
      return go(go({}, ybe(t.url, a)), { charset: h });
    if ($f.CONSTANTS.REGEX_CONTENT_TYPE_TEXT.test(a)) {
      var s = t.data;
      return go(go({}, YV(s, t.url, r, a)), { charset: h });
    }
    if ($f.CONSTANTS.REGEX_CONTENT_TYPE_APPLICATION.test(a))
      return go(go({}, vbe(t.url, a)), { charset: h });
    var c = t.data;
    return go(go({}, mH(c, t.url, r)), { charset: h });
  } catch (d) {
    throw new Error("link-preview-js could not fetch link information ".concat(d.toString()));
  }
}
function Tbe(t, r) {
  var a, u, h;
  return GV(this, void 0, void 0, function() {
    var b, E, l, v, s, c, d, p, m, E, y, g, C;
    return VV(this, function(O) {
      switch (O.label) {
        case 0:
          if (!t || typeof t != "string")
            throw new Error("link-preview-js did not receive a valid url or text");
          if (b = t.replace(/\n/g, " ").split(" ").find(function(N) {
            return $f.CONSTANTS.REGEX_VALID_URL.test(N);
          }), !b)
            throw new Error("link-preview-js did not receive a valid a url or text");
          if ((r == null ? void 0 : r.followRedirects) === "manual" && !(r != null && r.handleRedirects))
            throw new Error("link-preview-js followRedirects is set to manual, but no handleRedirects function was provided");
          return r != null && r.resolveDNSHost ? [4, r.resolveDNSHost(b)] : [3, 2];
        case 1:
          E = O.sent(), gH(E), O.label = 2;
        case 2:
          return l = (a = r == null ? void 0 : r.timeout) !== null && a !== void 0 ? a : 3e3, v = Abe(), s = setTimeout(function() {
            return v.abort();
          }, l), c = {
            headers: (u = r == null ? void 0 : r.headers) !== null && u !== void 0 ? u : {},
            redirect: (h = r == null ? void 0 : r.followRedirects) !== null && h !== void 0 ? h : "error",
            signal: v.signal
          }, d = r != null && r.proxyUrl ? r.proxyUrl.concat(b) : b, [4, (0, pH.fetch)(d, c).catch(function(N) {
            throw N.name === "AbortError" ? new Error("Request timeout") : (clearTimeout(s), N);
          })];
        case 3:
          if (p = O.sent(), !(p.status > 300 && p.status < 309 && c.redirect === "manual" && (r != null && r.handleRedirects))) return [3, 7];
          if (m = p.headers.get("location") || "", !r.handleRedirects(d, m))
            throw new Error("link-preview-js could not handle redirect");
          return r != null && r.resolveDNSHost ? [4, r.resolveDNSHost(m)] : [3, 5];
        case 4:
          E = O.sent(), gH(E), O.label = 5;
        case 5:
          return [4, (0, pH.fetch)(m, c)];
        case 6:
          p = O.sent(), O.label = 7;
        case 7:
          return clearTimeout(s), y = {}, p.headers.forEach(function(N, w) {
            y[w] = N;
          }), C = {
            url: r != null && r.proxyUrl ? p.url.replace(r.proxyUrl, "") : p.url,
            headers: y
          }, [4, p.text()];
        case 8:
          return g = (C.data = O.sent(), C), [2, XV(g, r)];
      }
    });
  });
}
var WV = ev.getLinkPreview = Tbe;
function bbe(t, r) {
  return GV(this, void 0, void 0, function() {
    return VV(this, function(a) {
      if (!t || typeof t != "object")
        throw new Error("link-preview-js did not receive a valid response object");
      if (!t.url)
        throw new Error("link-preview-js did not receive a valid response object");
      return [2, XV(t, r)];
    });
  });
}
ev.getPreviewFromContent = bbe;
function Abe() {
  return typeof AbortController > "u" ? new cbe.default() : new AbortController();
}
const Obe = (t) => {
  const { mediaType: r, url: a, title: u = "", description: h = "", favicons: b, images: l, isLoading: v } = t, s = Zn(Vn), { theme: c } = s, d = (c == null ? void 0 : c.mode) || "light", p = () => /* @__PURE__ */ q.jsx("div", { className: "message-text-url-loading", children: "parsing..." });
  let m;
  if (!r) return null;
  if (r === "website") {
    const E = l == null ? void 0 : l[0];
    m = /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
      /* @__PURE__ */ q.jsx("div", { children: E && /* @__PURE__ */ q.jsx("img", { src: E, alt: "image", className: "message-text-url-img" }) }),
      /* @__PURE__ */ q.jsxs(
        "div",
        {
          className: En("message-text-url-info", {
            "message-text-url-info-dark": d === "dark"
          }),
          children: [
            /* @__PURE__ */ q.jsx("div", { className: "message-text-url-title", children: u }),
            /* @__PURE__ */ q.jsx("div", { className: "message-text-url-desc", children: h })
          ]
        }
      )
    ] });
  }
  return v && (m = /* @__PURE__ */ q.jsx(p, {})), /* @__PURE__ */ q.jsx("div", { className: "message-text-url", children: m });
}, EH = Pd(Obe, (t, r) => t.url == r.url);
var Cbe = function(t) {
  return t instanceof RegExp;
}, Sbe = function(r) {
  var a = /[\\^$.*+?()[\]{}|]/g, u = RegExp(a.source);
  return r && u.test(r) ? r.replace(a, "\\$&") : r;
}, qV = function(t) {
  return typeof t == "string";
}, Ibe = function(t) {
  var r = [];
  return t.forEach(function(a) {
    Array.isArray(a) ? r = r.concat(a) : r.push(a);
  }), r;
};
function Rbe(t, r, a) {
  var u = 0, h = 0;
  if (t === "")
    return t;
  if (!t || !qV(t))
    throw new TypeError("First argument to react-string-replace#replaceString must be a string");
  var b = r;
  Cbe(b) || (b = new RegExp("(" + Sbe(b) + ")", "gi"));
  for (var l = t.split(b), v = 1, s = l.length; v < s; v += 2) {
    if (l[v] === void 0 || l[v - 1] === void 0) {
      console.warn("reactStringReplace: Encountered undefined value during string replacement. Your RegExp may not be working the way you expect.");
      continue;
    }
    h = l[v].length, u += l[v - 1].length, l[v] = a(l[v], v, u), u += h;
  }
  return l;
}
var Nbe = function(r, a, u) {
  return Array.isArray(r) || (r = [r]), Ibe(r.map(function(h) {
    return qV(h) ? Rbe(h, a, u) : h;
  }));
};
const wbe = /* @__PURE__ */ Gl(Nbe);
function yH(t, r, a) {
  let u = r;
  return !u && a && (u = `${t}-${a}`), u;
}
function vH(t, r) {
  let a = t[`page${r ? "Y" : "X"}Offset`];
  const u = `scroll${r ? "Top" : "Left"}`;
  if (typeof a != "number") {
    const h = t.document;
    a = h.documentElement[u], typeof a != "number" && (a = h.body[u]);
  }
  return a;
}
function _be(t) {
  const r = t.getBoundingClientRect(), a = {
    left: r.left,
    top: r.top
  }, u = t.ownerDocument, h = u.defaultView || u.parentWindow;
  return a.left += vH(h), a.top += vH(h, !0), a;
}
var Ww = {};
Object.defineProperty(Ww, "__esModule", {
  value: !0
});
var bN = Ww.default = void 0, mr = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(r) {
    var a = r.keyCode;
    if (r.altKey && !r.ctrlKey || r.metaKey || // Function keys don't generate text
    a >= mr.F1 && a <= mr.F12)
      return !1;
    switch (a) {
      case mr.ALT:
      case mr.CAPS_LOCK:
      case mr.CONTEXT_MENU:
      case mr.CTRL:
      case mr.DOWN:
      case mr.END:
      case mr.ESC:
      case mr.HOME:
      case mr.INSERT:
      case mr.LEFT:
      case mr.MAC_FF_META:
      case mr.META:
      case mr.NUMLOCK:
      case mr.NUM_CENTER:
      case mr.PAGE_DOWN:
      case mr.PAGE_UP:
      case mr.PAUSE:
      case mr.PRINT_SCREEN:
      case mr.RIGHT:
      case mr.SHIFT:
      case mr.UP:
      case mr.WIN_KEY:
      case mr.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(r) {
    if (r >= mr.ZERO && r <= mr.NINE || r >= mr.NUM_ZERO && r <= mr.NUM_MULTIPLY || r >= mr.A && r <= mr.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && r === 0)
      return !0;
    switch (r) {
      case mr.SPACE:
      case mr.QUESTION_MARK:
      case mr.NUM_PLUS:
      case mr.NUM_MINUS:
      case mr.NUM_PERIOD:
      case mr.NUM_DIVISION:
      case mr.SEMICOLON:
      case mr.DASH:
      case mr.EQUALS:
      case mr.COMMA:
      case mr.PERIOD:
      case mr.SLASH:
      case mr.APOSTROPHE:
      case mr.SINGLE_QUOTE:
      case mr.OPEN_SQUARE_BRACKET:
      case mr.BACKSLASH:
      case mr.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
};
bN = Ww.default = mr;
var _A = {}, KV = { exports: {} }, JV = { exports: {} }, ZV = { exports: {} }, QV = { exports: {} };
(function(t) {
  var r = nA.default;
  function a(u, h) {
    if (r(u) != "object" || !u) return u;
    var b = u[Symbol.toPrimitive];
    if (b !== void 0) {
      var l = b.call(u, h || "default");
      if (r(l) != "object") return l;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (h === "string" ? String : Number)(u);
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})(QV);
var Pbe = QV.exports;
(function(t) {
  var r = nA.default, a = Pbe;
  function u(h) {
    var b = a(h, "string");
    return r(b) == "symbol" ? b : b + "";
  }
  t.exports = u, t.exports.__esModule = !0, t.exports.default = t.exports;
})(ZV);
var xbe = ZV.exports;
(function(t) {
  var r = xbe;
  function a(u, h, b) {
    return (h = r(h)) in u ? Object.defineProperty(u, h, {
      value: b,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : u[h] = b, u;
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})(JV);
var Dbe = JV.exports;
(function(t) {
  var r = Dbe;
  function a(h, b) {
    var l = Object.keys(h);
    if (Object.getOwnPropertySymbols) {
      var v = Object.getOwnPropertySymbols(h);
      b && (v = v.filter(function(s) {
        return Object.getOwnPropertyDescriptor(h, s).enumerable;
      })), l.push.apply(l, v);
    }
    return l;
  }
  function u(h) {
    for (var b = 1; b < arguments.length; b++) {
      var l = arguments[b] != null ? arguments[b] : {};
      b % 2 ? a(Object(l), !0).forEach(function(v) {
        r(h, v, l[v]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(h, Object.getOwnPropertyDescriptors(l)) : a(Object(l)).forEach(function(v) {
        Object.defineProperty(h, v, Object.getOwnPropertyDescriptor(l, v));
      });
    }
    return h;
  }
  t.exports = u, t.exports.__esModule = !0, t.exports.default = t.exports;
})(KV);
var $V = KV.exports, Mbe = rA.default, eY = Cv.default;
Object.defineProperty(_A, "__esModule", {
  value: !0
});
var tY = _A.default = void 0;
_A.resetUuid = Ube;
var Lbe = eY(mw), kbe = eY($V), AN = Mbe(_t);
function jbe() {
  var t = (0, kbe.default)({}, AN);
  return t.useId;
}
var ON = 0;
function Ube() {
  process.env.NODE_ENV !== "production" && (ON = 0);
}
var TH = jbe();
tY = _A.default = TH ? (
  // Use React `useId`
  function(r) {
    var a = TH();
    return r || (process.env.NODE_ENV === "test" ? "test-id" : a);
  }
) : (
  // Use compatible of `useId`
  function(r) {
    var a = AN.useState("ssr-id"), u = (0, Lbe.default)(a, 2), h = u[0], b = u[1];
    return AN.useEffect(function() {
      var l = ON;
      ON += 1, b("rc_unique_".concat(l));
    }, []), r || (process.env.NODE_ENV === "test" ? "test-id" : h);
  }
);
var nY = {};
Object.defineProperty(nY, "__esModule", {
  value: !0
});
var bH = nY.default = Hbe;
function Hbe(t, r) {
  if (!t)
    return !1;
  if (t.contains)
    return t.contains(r);
  for (var a = r; a; ) {
    if (a === t)
      return !0;
    a = a.parentNode;
  }
  return !1;
}
var rY = {}, Bbe = Cv.default;
Object.defineProperty(rY, "__esModule", {
  value: !0
});
var zbe = rY.default = qbe, Fbe = Bbe($V), Gbe = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, Vbe = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, Ybe = "".concat(Gbe, " ").concat(Vbe).split(/[\s\n]+/), Xbe = "aria-", Wbe = "data-";
function AH(t, r) {
  return t.indexOf(r) === 0;
}
function qbe(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a;
  r === !1 ? a = {
    aria: !0,
    data: !0,
    attr: !0
  } : r === !0 ? a = {
    aria: !0
  } : a = (0, Fbe.default)({}, r);
  var u = {};
  return Object.keys(t).forEach(function(h) {
    // Aria
    (a.aria && (h === "role" || AH(h, Xbe)) || // Data
    a.data && AH(h, Wbe) || // Attr
    a.attr && Ybe.includes(h)) && (u[h] = t[h]);
  }), u;
}
function iY(t) {
  const { prefixCls: r, style: a, visible: u, maskProps: h, motionName: b } = t;
  return /* @__PURE__ */ q.jsx(
    mh,
    {
      visible: u,
      motionName: b,
      leavedClassName: `${r}-mask-hidden`,
      children: ({ className: l, style: v }, s) => /* @__PURE__ */ q.jsx(
        "div",
        {
          ref: s,
          style: { ...v, ...a },
          className: En(`${r}-mask`, l),
          ...h
        }
      )
    },
    "mask"
  );
}
const Kbe = ht.memo(
  ({ children: t }) => t,
  (t, { shouldUpdate: r }) => !r
), sY = _t.forwardRef((t, r) => {
  const {
    title: a,
    holderRef: u,
    style: h,
    prefixCls: b,
    className: l,
    onMouseDown: v,
    onMouseUp: s,
    sentinelStyle: c,
    visible: d,
    forceRender: p,
    closable: m,
    onClose: E,
    closeIcon: y,
    bodyStyle: g,
    bodyProps: C,
    children: O,
    footer: N,
    width: w,
    height: _,
    modalRender: I,
    onVisibleChanged: k,
    mousePosition: H,
    motionName: S,
    destroyOnClose: B
  } = t, { theme: D } = _t.useContext(Vn), F = D == null ? void 0 : D.mode, j = D == null ? void 0 : D.componentsShape;
  let G;
  m && (G = /* @__PURE__ */ q.jsx("button", { type: "button", onClick: E, className: `${b}-close`, children: y || /* @__PURE__ */ q.jsx("span", { className: `${b}-close-x` }) }));
  let U;
  a && (U = /* @__PURE__ */ q.jsx("div", { className: `${b}-header`, children: /* @__PURE__ */ q.jsx("div", { className: `${b}-title`, children: a }) }));
  let M;
  N && (M = /* @__PURE__ */ q.jsx("div", { className: `${b}-footer`, children: N }));
  const V = En(`${b}-content`, {
    [`${b}-content-${F}`]: !!F,
    // 大圆角小圆角
    [`${b}-content-${j}`]: !!j
  }), J = /* @__PURE__ */ q.jsxs("div", { className: V, children: [
    G,
    U,
    /* @__PURE__ */ q.jsx("div", { className: `${b}-body`, style: g, ...C, children: O }),
    M
  ] }), ue = er(null), se = er(null);
  _t.useImperativeHandle(r, () => ({
    focus: () => {
      var _e;
      (_e = ue.current) == null || _e.focus();
    },
    changeActive: (_e) => {
      var Te, K;
      const { activeElement: Le } = document;
      _e && Le === se.current ? (Te = ue.current) == null || Te.focus() : !_e && Le === ue.current && ((K = se.current) == null || K.focus());
    }
  }));
  const ee = {};
  w !== void 0 && (ee.width = w), _ !== void 0 && (ee.height = _);
  const de = er(), [he, pe] = _t.useState();
  he && (ee.transformOrigin = he);
  function Ce() {
    const _e = _be(de.current);
    pe(
      H ? `${H.x - _e.left}px ${H.y - _e.top}px` : ""
    );
  }
  return /* @__PURE__ */ q.jsx(
    mh,
    {
      visible: d,
      onVisibleChanged: k,
      onAppearPrepare: Ce,
      onEnterPrepare: Ce,
      forceRender: p,
      motionName: S,
      removeOnLeave: B,
      ref: de,
      children: ({ className: _e, style: Le }, Te) => /* @__PURE__ */ q.jsxs(
        "div",
        {
          role: "dialog",
          ref: Te,
          style: {
            ...h,
            ...ee,
            ...Le
          },
          className: En(b, l, _e),
          onMouseDown: v,
          onMouseUp: s,
          children: [
            /* @__PURE__ */ q.jsx("div", { tabIndex: 0, ref: ue, style: c, "aria-hidden": "true" }),
            /* @__PURE__ */ q.jsx(Kbe, { shouldUpdate: d || p, children: I ? I(J) : J }),
            /* @__PURE__ */ q.jsx("div", { tabIndex: 0, ref: se, style: c })
          ]
        },
        "dialog-element"
      )
    }
  );
});
sY.displayName = "Content";
function Jbe(t) {
  const {
    prefixCls: r = "rc-dialog",
    zIndex: a,
    visible: u = !1,
    keyboard: h = !0,
    focusTriggerAfterClose: b = !0,
    // scrollLocker,
    // Wrapper
    wrapStyle: l,
    wrapClassName: v,
    wrapProps: s,
    onClose: c,
    afterClose: d,
    // Dialog
    transitionName: p,
    animation: m,
    closable: E = !0,
    // Mask
    mask: y = !0,
    maskTransitionName: g,
    maskAnimation: C,
    maskClosable: O = !0,
    maskStyle: N,
    maskProps: w,
    rootClassName: _
  } = t, I = er(null), k = er(), H = er(null), [S, B] = _t.useState(u);
  tY();
  function D() {
    bH(k.current, document.activeElement) || (I.current = document.activeElement);
  }
  function F() {
    var ee;
    bH(k.current, document.activeElement) || (ee = H.current) == null || ee.focus();
  }
  function j(ee) {
    if (ee)
      F();
    else {
      if (B(!1), y && I.current && b) {
        try {
          I.current.focus({
            preventScroll: !0
          });
        } catch {
        }
        I.current = null;
      }
      S && (d == null || d());
    }
  }
  function G(ee) {
    c == null || c(ee);
  }
  const U = er(!1), M = er(), V = () => {
    clearTimeout(M.current), U.current = !0;
  }, J = () => {
    M.current = setTimeout(() => {
      U.current = !1;
    });
  };
  let ue = () => {
  };
  O && (ue = (ee) => {
    U.current ? U.current = !1 : k.current === ee.target && G(ee);
  });
  function se(ee) {
    var de;
    if (h && ee.keyCode === bN.ESC) {
      ee.stopPropagation(), G(ee);
      return;
    }
    u && ee.keyCode === bN.TAB && ((de = H.current) == null || de.changeActive(!ee.shiftKey));
  }
  return Pn(() => {
    u && (B(!0), D());
  }, [u]), Pn(
    () => () => {
      clearTimeout(M.current);
    },
    []
  ), /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: En(`${r}-root`, _),
      ...zbe(t, { data: !0 }),
      children: [
        /* @__PURE__ */ q.jsx(
          iY,
          {
            prefixCls: r,
            visible: y && u,
            motionName: yH(
              r,
              g,
              C
            ),
            style: {
              zIndex: a,
              ...N
            },
            maskProps: w
          }
        ),
        /* @__PURE__ */ q.jsx(
          "div",
          {
            tabIndex: -1,
            onKeyDown: se,
            className: En(`${r}-wrap`, v),
            ref: k,
            onClick: ue,
            style: {
              zIndex: a,
              ...l,
              display: S ? null : "none"
            },
            ...s,
            children: /* @__PURE__ */ q.jsx(
              sY,
              {
                ...t,
                onMouseDown: V,
                onMouseUp: J,
                ref: H,
                closable: E,
                prefixCls: r,
                visible: u && S,
                onClose: G,
                onVisibleChanged: j,
                motionName: yH(
                  r,
                  p,
                  m
                )
              }
            )
          }
        )
      ]
    }
  );
}
const qw = (t) => {
  const [r, a] = tn([]), u = er(null), { theme: h } = Zn(Vn), b = h == null ? void 0 : h.mode, {
    color: l = b == "dark" ? "var(--cui-primary-color4)" : "var(--cui-primary-color7)"
  } = t, v = (s) => {
    var y, g;
    const c = (g = (y = u.current).getBoundingClientRect) == null ? void 0 : g.call(y), d = Math.max(c == null ? void 0 : c.width, c.height), p = s.clientX - c.left - d / 2, m = s.clientY - c.top - d / 2, E = {
      id: (/* @__PURE__ */ new Date()).getTime(),
      x: p,
      y: m,
      size: d,
      color: l
    };
    a([...r, E]), setTimeout(() => {
      a((C) => C.filter((O) => O.id !== E.id));
    }, 600);
  };
  return /* @__PURE__ */ q.jsx("div", { className: "ripple-container", ref: u, onClick: v, children: r.map((s) => /* @__PURE__ */ q.jsx(
    "span",
    {
      className: "ripple",
      style: {
        top: s.y,
        left: s.x,
        width: s.size,
        height: s.size,
        backgroundColor: s.color
      }
    },
    s.id
  )) });
}, gi = ({
  className: t,
  type: r = "default",
  size: a = "medium",
  shape: u,
  disabled: h = !1,
  icon: b,
  children: l = "button",
  style: v = {},
  onClick: s,
  ripple: c,
  rippleColor: d
}) => {
  const { theme: p } = Zn(Vn), m = p == null ? void 0 : p.mode, E = p == null ? void 0 : p.ripple, { getPrefixCls: y } = _t.useContext(Hn), g = y("button"), C = u || (p == null ? void 0 : p.componentsShape) || "default", O = En(
    g,
    {
      [`${g}-${r}`]: r,
      [`${g}-${a}`]: a,
      [`${g}-${C}`]: C,
      [`${g}-${m}`]: !!m
    },
    t
  ), N = c === void 0 ? E : c;
  return /* @__PURE__ */ q.jsxs(
    "button",
    {
      type: "button",
      onClick: s,
      className: O,
      disabled: h,
      style: { ...v },
      children: [
        N && /* @__PURE__ */ q.jsx(qw, { color: d }),
        l
      ]
    }
  );
}, Zbe = () => !!(typeof window < "u" && window.document && window.document.createElement), Qbe = () => Zbe() && window.document.documentElement;
let CN;
const $be = (t) => {
  CN = {
    x: t.pageX,
    y: t.pageY
  }, setTimeout(() => {
    CN = null;
  }, 100);
};
Qbe() && document.documentElement.addEventListener("click", $be, !0);
const ca = (t) => {
  const { getPrefixCls: r } = ht.useContext(Hn), a = (D) => {
    const { onCancel: F } = t;
    F == null || F(D);
  }, u = (D) => {
    const { onOk: F } = t;
    F == null || F(D);
  }, {
    prefixCls: h,
    footer: b,
    open: l = !1,
    wrapClassName: v,
    centered: s,
    getContainer: c,
    closeIcon: d,
    focusTriggerAfterClose: p = !0,
    width: m = 520,
    okText: E,
    okType: y = "primary",
    cancelType: g = "default",
    cancelText: C,
    confirmLoading: O = !1,
    forceRender: N = !1,
    ...w
  } = t, _ = r("modal", h), I = r(), { t: k } = Yr(), H = /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx(
      gi,
      {
        className: `${_}-button`,
        type: y,
        onClick: u,
        ...t.okButtonProps,
        children: E ?? k("confirmBtn")
      }
    ),
    /* @__PURE__ */ q.jsx(
      gi,
      {
        className: `${_}-button`,
        onClick: a,
        type: g,
        ...t.cancelButtonProps,
        children: C || k("cancelBtn")
      }
    )
  ] }), S = /* @__PURE__ */ q.jsx("span", { className: `${_}-close-x`, children: d || /* @__PURE__ */ q.jsx(pn, { type: "CLOSE_THIN", width: 24, height: 24 }) }), B = En(v, {
    [`${_}-centered`]: !!s
  });
  return /* @__PURE__ */ q.jsx(
    Jbe,
    {
      forceRender: N,
      width: m,
      ...w,
      prefixCls: _,
      wrapClassName: B,
      footer: b === void 0 ? H : b,
      visible: l,
      mousePosition: CN,
      onClose: a,
      closeIcon: S,
      focusTriggerAfterClose: p,
      transitionName: q2(I, "zoom", t.transitionName),
      maskTransitionName: q2(I, "fade", t.maskTransitionName)
    }
  );
}, SN = (t, r = !0) => {
  var a = function() {
    var u = [], h = document.createElement("div");
    h.innerHTML = t.replace(/\\/g, "###h###");
    for (var b = h.querySelectorAll("img"), l = h.querySelectorAll("div"), v = b.length, s = l.length; v--; ) {
      var c = document.createTextNode(b[v].getAttribute("data-key"));
      b[v].parentNode.insertBefore(c, b[v]), b[v].parentNode.removeChild(b[v]);
    }
    for (; s--; )
      u.push(l[s].innerHTML), l[s].parentNode.removeChild(l[s]);
    var d = (u = u.reverse()).length ? `
` + u.join(`
`) : u.join(`
`);
    return r ? (h.innerText + d).replace(/###h###/g, "&#92;").replace(/<br>/g, `
`).replace(/&amp;/g, "&") : (h.innerHTML.indexOf("</span>") && (h.innerHTML = h.innerHTML.replace(/<span.*?>/g, ""), h.innerHTML = h.innerHTML.replace(/<\/span>/g, "")), (h.innerHTML + d).replace(/###h###/g, "\\").replace(/<br>/g, `
`).replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">"));
  }();
  return a.replace(/&nbsp;/g, " ").trim();
}, Kw = Gu((t, r) => {
  const {
    placeholder: a,
    hasSendButton: u,
    sendButtonActiveColor: h = "var(--cui-primary-color)",
    enableEnterSend: b = !0,
    enabledMention: l = !0,
    isChatThread: v = !1,
    onSendMessage: s,
    conversation: c,
    onBeforeSendMessage: d,
    enabledTyping: p = !0,
    style: m = {},
    onChange: E,
    onFocus: y
  } = t, { t: g } = Yr(), [C, O] = tn(""), { prefix: N, className: w } = t, { getPrefixCls: _ } = _t.useContext(Hn), I = _("textarea", N), k = Zn(Vn), { rootStore: H, theme: S } = k, B = (S == null ? void 0 : S.mode) || "light", D = (S == null ? void 0 : S.componentsShape) || "round", { client: F, messageStore: j, conversationStore: G, addressStore: U } = H, { currentCVS: M } = j, V = er(null), [J, ue] = tn(""), [se, ee] = tn(!1), [de, he] = tn({
    x: 0,
    y: 0
  }), [pe, Ce] = tn(M);
  Pn(() => {
    M != null && M.conversationId && Ce(M), c != null && c.conversationId && Ce(c);
  }, [c == null ? void 0 : c.conversationId, M]);
  const _e = l && pe.chatType === "groupChat", Le = Uy(() => {
    if (_e)
      if (Sge()) {
        const gt = Cge();
        he(gt);
        const it = Ige();
        ue(it || ""), ee(!0);
      } else
        ee(!1);
  }, [_e]), Te = (gt) => {
    _e && se ? (gt.code === "ArrowUp" || gt.code === "ArrowDown" || gt.code === "Enter") && gt.preventDefault() : pt(gt);
  }, K = Uy((gt) => {
    var Tt;
    wge(gt);
    const it = SN(((Tt = V == null ? void 0 : V.current) == null ? void 0 : Tt.innerHTML) || "").trim();
    O(it), ee(!1);
  }, []), Oe = () => {
    ee(!1);
  }, Pe = () => {
    ee(!0);
  }, xe = En(
    I,
    {
      [`${I}-hasBtn`]: !!u,
      [`${I}-${B}`]: !!B
    },
    w
  ), [be, $e] = tn(!1), Be = (gt) => {
    const it = gt.target.innerHTML, Tt = SN(it, !1).trim();
    O(Tt), E == null || E(Tt), pe.chatType == "singleChat" && !be && p && ($e(!0), j.sendTypingCmd(pe), setTimeout(() => {
      $e(!1);
    }, 5e3));
  }, Ke = (gt) => {
    j.sendMessage(gt).then(() => {
      s && s(gt);
    }), V.current.innerHTML = "", O(""), E == null || E(""), pe.chatType == "singleChat" && pe.conversationId.includes("chatbot_") && (H.messageStore.typing[pe.conversationId] ? (j.setTyping(pe, !1), setTimeout(() => {
      j.setTyping(pe, !0);
    }, 200)) : j.setTyping(pe, !0));
  }, Ze = () => {
    var st;
    if (!C) {
      console.warn("No text message");
      return;
    }
    if (!pe.conversationId) {
      console.warn("No specified conversation");
      return;
    }
    let gt = !1;
    const it = ((st = V.current) == null ? void 0 : st.querySelectorAll(".at-button")) || [], Tt = Array.from(it).map((Ot) => {
      if (Ot instanceof HTMLElement)
        return Ot == null ? void 0 : Ot.dataset.user;
    });
    Tt.includes(ym) && (gt = !0);
    const Ut = Zs.message.create({
      to: pe.conversationId,
      chatType: pe.chatType,
      type: "txt",
      msg: C,
      isChatThread: v,
      ext: {
        em_at_list: gt ? ym : Tt
      }
    });
    d ? d(Ut).then((Ot) => {
      Ot && (Ut.to = Ot.conversationId, Ut.chatType = Ot.chatType), Ke(Ut);
    }) : Ke(Ut);
  }, at = u ? /* @__PURE__ */ q.jsx("div", { className: `${I}-sendBtn`, title: g("send"), children: /* @__PURE__ */ q.jsx(
    pn,
    {
      type: "AIR_PLANE",
      width: 20,
      height: 20,
      color: C != null && C.length ? h : "#464E53",
      onClick: Ze
    }
  ) }) : null, pt = (gt) => {
    gt.code === "Enter" && gt.keyCode === 13 && !gt.shiftKey && (gt.preventDefault(), b && Ze());
  }, It = Uy((gt) => {
    gt.preventDefault(), document.execCommand(
      "insertHTML",
      !1,
      lG(fG(gt == null ? void 0 : gt.clipboardData.getData("text")))
    );
  }, []), Rt = (gt) => {
    O(gt);
  };
  return lv(r, () => ({
    setTextareaValue: Rt,
    sendMessage: Ze,
    divRef: V
  })), Pn(() => {
    if (b) {
      const gt = (it) => {
        var Tt;
        (Tt = V == null ? void 0 : V.current) != null && Tt.contains(it.target) || ee(!1);
      };
      return b && document.addEventListener("click", gt), () => {
        document.removeEventListener("click", gt);
      };
    }
  }, [b]), /* @__PURE__ */ q.jsxs("div", { className: xe, style: { ...m }, children: [
    /* @__PURE__ */ q.jsx(
      "div",
      {
        placeholder: a || g("say something"),
        ref: V,
        className: En(`${I}-input`, {
          [`${I}-input-square`]: D == "square"
        }),
        contentEditable: "true",
        onInput: Be,
        onKeyUp: Le,
        onKeyDown: Te,
        onPaste: It,
        onFocus: () => {
          y == null || y();
        }
      }
    ),
    _e && /* @__PURE__ */ q.jsx(
      xge,
      {
        visible: se,
        position: de,
        queryString: J,
        onPickUser: K,
        onHide: Oe,
        onShow: Pe
      }
    ),
    at
  ] });
});
Kw.displayName = "Textarea";
const Rc = (t) => {
  const r = Zn(Vn).rootStore, { pinnedMessagesStore: a } = r, { client: u } = r, { conversationId: h = "", conversationType: b = "groupChat" } = (t == null ? void 0 : t.conversation) || {}, { pageSize: l = 20 } = t || {}, { list: v = [], cursor: s = "" } = (a == null ? void 0 : a.messages[b][h]) || {}, { visible: c = !1 } = a || {};
  return {
    list: v,
    cursor: s,
    pageSize: l,
    visible: c,
    show: () => {
      a.changeVisible(!0);
    },
    hide: () => {
      a.changeVisible(!1);
    },
    pinMessage: (C) => u.pinMessage({
      conversationId: h,
      conversationType: b,
      messageId: C
    }).then(() => {
      const O = Date.now();
      a.updatePinnedMessage(b, h, C, O), a.pushPinNoticeMessage({
        conversationId: h,
        conversationType: b,
        operatorId: u.user,
        noticeType: "pin",
        time: O
      }), mn.dispatchSuccess("pinMessage");
    }).catch((O) => {
      mn.dispatchError("pinMessage", O);
    }),
    unpinMessage: (C) => u.unpinMessage({
      conversationId: h,
      conversationType: b,
      messageId: C
    }).then(() => {
      a.deletePinnedMessage(b, h, C), a.pushPinNoticeMessage({
        conversationId: h,
        conversationType: b,
        operatorId: u.user,
        noticeType: "unpin",
        time: Date.now()
      }), mn.dispatchSuccess("unpinMessage");
    }).catch((O) => {
      mn.dispatchError("unpinMessage", O);
    }),
    getPinnedMessages: () => {
      u.getServerPinnedMessages({
        conversationId: h,
        conversationType: b,
        pageSize: l,
        cursor: s
      }).then((C) => {
        var O, N;
        (O = C.data) == null || O.list.forEach((w) => {
          a.pushPinnedMessage(b, h, w);
        }), a.setPinnedMessageCursor(b, h, ((N = C.data) == null ? void 0 : N.cursor) || null), mn.dispatchSuccess("getPinnedMessages");
      }).catch((C) => {
        mn.dispatchError("getPinnedMessages", C);
      });
    },
    clearPinnedMessages: () => {
      a.clearPinnedMessages(b, h);
    }
  };
}, Nd = (t, r = !0) => {
  const a = /(https?:\/\/\S+)/gi;
  if (t == null)
    return [];
  const u = [];
  let h;
  const b = /(U\+1F600|U\+1F604|U\+1F609|U\+1F62E|U\+1F92A|U\+1F60E|U\+1F971|U\+1F974|U\+263A|U\+1F641|U\+1F62D|U\+1F610|U\+1F607|U\+1F62C|U\+1F913|U\+1F633|U\+1F973|U\+1F620|U\+1F644|U\+1F910|U\+1F97A|U\+1F928|U\+1F62B|U\+1F637|U\+1F912|U\+1F631|U\+1F618|U\+1F60D|U\+1F922|U\+1F47F|U\+1F92C|U\+1F621|U\+1F44D|U\+1F44E|U\+1F44F|U\+1F64C|U\+1F91D|U\+1F64F|U\+2764|U\+1F494|U\+1F495|U\+1F4A9|U\+1F48B|U\+2600|U\+1F31C|U\+1F308|U\+2B50|U\+1F31F|U\+1F389|U\+1F490|U\+1F382|U\+1F381|😀|😄|😉|😮|🤪|😎|🥱|🥴|☺|🙁|😭|😐|😇|😬|🤓|😳|🥳|😠|🙄|🤐|🥺|🤨|😫|😷|🤒|😱|😘|😍|🤢|👿|🤬|😡|👍|👎|👏|🙌|🤝|🙏|❤️|💔|💕|💩|💋|☀️|🌜|🌈|⭐|🌟|🎉|💐|🎂|🎁)/g;
  let l = 0, v = 0;
  for (; h = b.exec(t); ) {
    if (v = h.index, v > l && u.push(t.substring(l, v)), h[1] in vm.oldMap) {
      const s = vm.oldMap[h[1]];
      u.push(
        /* @__PURE__ */ q.jsx(
          "img",
          {
            alt: h[1],
            src: new URL((/* @__PURE__ */ Object.assign({ "/module/assets/reactions/U+1F308.png": lg, "/module/assets/reactions/U+1F31C.png": fg, "/module/assets/reactions/U+1F31F.png": hg, "/module/assets/reactions/U+1F381.png": pg, "/module/assets/reactions/U+1F382.png": gg, "/module/assets/reactions/U+1F389.png": mg, "/module/assets/reactions/U+1F44D.png": Eg, "/module/assets/reactions/U+1F44E.png": yg, "/module/assets/reactions/U+1F44F.png": vg, "/module/assets/reactions/U+1F47F.png": Tg, "/module/assets/reactions/U+1F48B.png": bg, "/module/assets/reactions/U+1F490.png": Ag, "/module/assets/reactions/U+1F494.png": Og, "/module/assets/reactions/U+1F495.png": Cg, "/module/assets/reactions/U+1F4A9.png": Sg, "/module/assets/reactions/U+1F600.png": Ig, "/module/assets/reactions/U+1F604.png": Rg, "/module/assets/reactions/U+1F607.png": Ng, "/module/assets/reactions/U+1F609.png": wg, "/module/assets/reactions/U+1F60D.png": _g, "/module/assets/reactions/U+1F60E.png": Pg, "/module/assets/reactions/U+1F610.png": xg, "/module/assets/reactions/U+1F618.png": Dg, "/module/assets/reactions/U+1F620.png": Mg, "/module/assets/reactions/U+1F621.png": Lg, "/module/assets/reactions/U+1F62B.png": kg, "/module/assets/reactions/U+1F62C.png": jg, "/module/assets/reactions/U+1F62D.png": Ug, "/module/assets/reactions/U+1F62E.png": Hg, "/module/assets/reactions/U+1F631.png": Bg, "/module/assets/reactions/U+1F633.png": zg, "/module/assets/reactions/U+1F637.png": Fg, "/module/assets/reactions/U+1F641.png": Gg, "/module/assets/reactions/U+1F644.png": Vg, "/module/assets/reactions/U+1F64C.png": Yg, "/module/assets/reactions/U+1F64F.png": Xg, "/module/assets/reactions/U+1F910.png": Wg, "/module/assets/reactions/U+1F912.png": qg, "/module/assets/reactions/U+1F913.png": Kg, "/module/assets/reactions/U+1F91D.png": Jg, "/module/assets/reactions/U+1F922.png": Zg, "/module/assets/reactions/U+1F928.png": Qg, "/module/assets/reactions/U+1F92A.png": $g, "/module/assets/reactions/U+1F92C.png": em, "/module/assets/reactions/U+1F971.png": tm, "/module/assets/reactions/U+1F973.png": nm, "/module/assets/reactions/U+1F974.png": rm, "/module/assets/reactions/U+1F97A.png": im, "/module/assets/reactions/U+2600.png": sm, "/module/assets/reactions/U+263A.png": am, "/module/assets/reactions/U+2764.png": om, "/module/assets/reactions/U+2B50.png": cm }))[`/module/assets/reactions/${s}`], import.meta.url).href,
            width: 20,
            height: 20,
            style: {
              verticalAlign: "text-top"
            }
          },
          Math.floor(Math.random() * 1e5 + 1) + (/* @__PURE__ */ new Date()).getTime().toString()
        )
      );
    } else
      u.push(h[1]);
    l = v + h[1].length;
  }
  return u.push(t.substring(l, t.length)), r && u.forEach((s, c) => {
    if (a.test(s.toString())) {
      const d = wbe((s == null ? void 0 : s.toString()) || "", a, (p, m) => /* @__PURE__ */ q.jsx(
        "a",
        {
          target: "_blank",
          rel: "noopener noreferrer",
          href: p,
          className: "message-text-url-link",
          children: p
        },
        p + m
      ));
      u[c] = d;
    }
  }), u;
}, eAe = new RegExp(
  "^(?:(?:https?|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$",
  "i"
);
let Dd = (t) => {
  var X, re, Me, Se, ke, Ge, nt, rt;
  let {
    prefix: r,
    textMessage: a,
    className: u,
    style: h,
    nickName: b,
    type: l,
    bubbleClass: v,
    renderUserProfile: s,
    thread: c,
    onTranslateTextMessage: d,
    targetLanguage: p,
    showTranslation: m = !0,
    onlyContent: E = !1,
    onOpenThreadPanel: y,
    showEditedTag: g = !0,
    ...C
  } = t;
  if (!a.chatType) return null;
  const { getPrefixCls: O } = _t.useContext(Hn), N = O("message-text", r), { t: w } = Yr(), [_, I] = tn(null), [k, H] = tn(!1), S = ar(a);
  let { bySelf: B, time: D, from: F, msg: j, reactions: G } = a;
  const U = En(N, u), M = er(null), V = _t.useContext(Vn), { initConfig: J } = V, { translationTargetLanguage: ue } = J, se = p || ue || "en", [ee, de] = tn(!1), { pinMessage: he } = Rc({
    conversation: {
      conversationId: S,
      conversationType: a.chatType
    }
  }), [pe, Ce] = tn("");
  let _e = "";
  ((X = _ == null ? void 0 : _.images) == null ? void 0 : X.length) > 0 && (_e = "message-text-hasImage");
  let Le = "";
  v && (Le = v + " " + _e);
  const [Te, K] = tn("hide"), [Oe, Pe] = tn("translated"), xe = O("message-text-translation", r), be = O("modify-textarea", r);
  typeof B > "u" && (B = F == ((re = Zt.client.context) == null ? void 0 : re.userId));
  const $e = En(xe, {
    [`${xe}-left`]: !B,
    [`${xe}-right`]: B,
    [`${xe}-hide`]: Te === "show"
  });
  l || (l = B ? "primary" : "secondly");
  const Be = er(null), Ke = j == null ? void 0 : j.replace(/\n/g, " ").split(" ").find(function(dt) {
    return eAe.test(dt);
  });
  Pn(() => {
    Ke && (H(!0), WV(j).then((dt) => (Be.current = dt, H(!1), I(dt))).catch((dt) => {
      H(!1), console.error(dt);
    }));
  }, [Ke]);
  const Ze = () => {
    Zt.messageStore.setRepliedMessage(a);
  }, at = () => {
    const dt = ar(a);
    Zt.messageStore.deleteMessage(
      {
        chatType: a.chatType,
        conversationId: dt
      },
      // @ts-ignore
      a.mid || a.id
    );
  }, pt = () => {
    he(a.mid || a.id);
  };
  let It;
  (Me = a.ext) != null && Me.msgQuote && (It = a);
  const Rt = (dt) => {
    const lt = ar(a);
    Zt.messageStore.addReaction(
      {
        chatType: a.chatType,
        conversationId: lt
      },
      // @ts-ignore
      a.mid || a.id,
      dt
    );
  }, gt = (dt) => {
    const lt = ar(a);
    Zt.messageStore.deleteReaction(
      {
        chatType: a.chatType,
        conversationId: lt
      },
      // @ts-ignore
      a.mid || a.id,
      dt
    );
  }, it = (dt) => {
    const lt = ar(a);
    G == null || G.forEach((Ct) => {
      if (Ct.reaction === dt && (Ct.count > 3 && Ct.userList.length <= 3 && Zt.messageStore.getReactionUserList(
        {
          chatType: a.chatType,
          conversationId: lt
        },
        // @ts-ignore
        a.mid || a.id,
        dt
      ), Ct.isAddedBySelf)) {
        const Ie = Ct.userList.indexOf(Zt.client.user);
        if (Ie > -1) {
          const x = Ct.userList.splice(Ie, 1)[0];
          Ct.userList.unshift(x);
        } else
          Ct.userList.unshift(Zt.client.user);
      }
    });
  }, Tt = () => {
    const dt = ar(a);
    Zt.messageStore.recallMessage(
      {
        chatType: a.chatType,
        conversationId: dt
      },
      // @ts-ignore
      a.mid || a.id,
      a.isChatThread,
      !0
    );
  }, Ut = () => {
    if (Te == "retry")
      return st();
    K(Te === "hide" ? "show" : "hide");
  }, st = () => {
    var Ct;
    if ((d == null ? void 0 : d(a)) == !1)
      return;
    Pe("translating");
    const lt = ar(a);
    (Ct = Zt.messageStore.translateMessage(
      {
        chatType: a.chatType,
        conversationId: lt
      },
      // @ts-ignore
      a.mid || a.id,
      se
    )) == null || Ct.then(() => {
      Pe("translated");
    }).catch(() => {
      Pe("translationFailed"), K("retry");
    });
  }, Ot = () => {
    var Ct;
    const dt = ar(a);
    (Ct = Zt.messageStore.selectedMessage[a.chatType][dt]) != null && Ct.selectable || Zt.messageStore.setSelectedMessage(
      {
        chatType: a.chatType,
        conversationId: dt
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, kt = () => {
    Zt.messageStore.sendMessage(a);
  }, wt = (Se = Zt.messageStore.selectedMessage[a.chatType][S]) == null ? void 0 : Se.selectable, Et = (dt) => {
    var Ie;
    const lt = (Ie = Zt.messageStore.selectedMessage[a.chatType][S]) == null ? void 0 : Ie.selectedMessage;
    let Ct = lt;
    dt ? Ct.push(a) : Ct = lt.filter((x) => !(x.id == a.id || x.mid == a.id)), Zt.messageStore.setSelectedMessage(
      {
        chatType: a.chatType,
        conversationId: S
      },
      {
        selectable: !0,
        selectedMessage: Ct
      }
    );
  }, ut = () => {
    de(!0);
  }, St = () => {
    de(!1);
  }, Ft = () => {
    var Z, ge, me;
    de(!1);
    const dt = Zt.conversationStore.currentCvs, lt = SN(((me = (ge = (Z = M == null ? void 0 : M.current) == null ? void 0 : Z.divRef) == null ? void 0 : ge.current) == null ? void 0 : me.innerHTML) || "").trim(), { isChatThread: Ct, to: Ie, chatThread: x } = a, ae = !!(Ct || x), Q = Zs.message.create({
      to: ae ? Ie : dt.conversationId,
      chatType: dt.chatType,
      type: "txt",
      isChatThread: ae,
      msg: lt
    });
    Zt.messageStore.modifyServerMessage((a == null ? void 0 : a.mid) || (a == null ? void 0 : a.id), Q);
  };
  Pn(() => {
    ee && setTimeout(() => {
      var dt;
      (dt = M == null ? void 0 : M.current) != null && dt.divRef.current && (M.current.divRef.current.innerHTML = lG(
        fG(a.msg)
      ));
    }, 200);
  }, [ee]);
  const Ht = () => {
    Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: a
    }), Zt.threadStore.setThreadVisible(!0);
  }, zt = (
    // @ts-ignore
    a.chatType == "groupChat" && c && // @ts-ignore
    !a.chatThread && !a.isChatThread
  ), ze = () => {
    var dt, lt, Ct;
    Zt.threadStore.joinChatThread(((dt = a.chatThreadOverview) == null ? void 0 : dt.id) || ""), Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: a,
      info: a.chatThreadOverview
    }), Zt.threadStore.setThreadVisible(!0), Zt.threadStore.getChatThreadDetail(((lt = a == null ? void 0 : a.chatThreadOverview) == null ? void 0 : lt.id) || ""), y == null || y(((Ct = a.chatThreadOverview) == null ? void 0 : Ct.id) || "");
  }, [Ne, le] = tn(0);
  return Pn(() => {
    if (a.printed != !1)
      return;
    const dt = Nd(j, !0), lt = dt.length > 1 ? dt : dt[0] || "";
    if (Ne >= lt.length)
      return;
    const Ct = setInterval(() => {
      Ce((Ie) => Ie + (lt == null ? void 0 : lt[Ne])), le((Ie) => Ie + 1), a.printed = !0, Ne >= lt.length - 1 && clearInterval(Ct);
    }, 30);
    return () => {
      clearInterval(Ct);
    };
  }, [j, Ne]), /* @__PURE__ */ q.jsx(q.Fragment, { children: E ? /* @__PURE__ */ q.jsxs("div", { className: _ != null && _.title || _ != null && _.description ? `${N}-url-container` : "", children: [
    /* @__PURE__ */ q.jsx("span", { className: U, children: Nd(j, !0) }),
    ((_ == null ? void 0 : _.title) || (_ == null ? void 0 : _.description)) && /* @__PURE__ */ q.jsx(EH, { ..._, isLoading: k }),
    g && (a != null && a.modifiedInfo) ? /* @__PURE__ */ q.jsx("div", { className: `${U}-edit-tag`, children: w("edited") }) : "",
    // @ts-ignore
    (a.translations || Oe == "translating") && m && /* @__PURE__ */ q.jsxs("div", { className: $e, children: [
      /* @__PURE__ */ q.jsx("div", { className: `${xe}-line` }),
      /* @__PURE__ */ q.jsx("span", {
        className: `${xe}-text`,
        // @ts-ignore
        children: Nd((Ge = (ke = a.translations) == null ? void 0 : ke[0]) == null ? void 0 : Ge.text, !0)
      }),
      /* @__PURE__ */ q.jsxs("div", { className: `${xe}-action`, children: [
        /* @__PURE__ */ q.jsx(pn, { type: "TRANSLATION", width: 16, height: 16 }),
        /* @__PURE__ */ q.jsx("span", { children: w(`${Oe}`) }),
        /* @__PURE__ */ q.jsx("span", { onClick: Ut, children: w(`${Te}`) })
      ] })
    ] })
  ] }) : /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx(
      Oh,
      {
        id: a.id,
        direction: B ? "rtl" : "ltr",
        time: D,
        message: a,
        nickName: b,
        bubbleType: l,
        className: Le,
        onReplyMessage: Ze,
        onDeleteMessage: at,
        onPinMessage: pt,
        repliedMessage: It,
        reactionData: G,
        onAddReactionEmoji: Rt,
        onDeleteReactionEmoji: gt,
        onShowReactionUserList: it,
        onRecallMessage: Tt,
        onTranslateMessage: st,
        onModifyMessage: ut,
        onSelectMessage: Ot,
        onResendMessage: kt,
        select: wt,
        onMessageCheckChange: Et,
        renderUserProfile: s,
        onCreateThread: Ht,
        thread: zt,
        chatThreadOverview: a.chatThreadOverview,
        onClickThreadTitle: ze,
        ...C,
        children: /* @__PURE__ */ q.jsxs(
          "div",
          {
            className: _ != null && _.title || _ != null && _.description ? `${N}-url-container` : "",
            children: [
              /* @__PURE__ */ q.jsx("span", { className: U, style: { ...h }, children: a.printed == !1 ? pe : Nd(j, !0) }),
              ((_ == null ? void 0 : _.title) || (_ == null ? void 0 : _.description)) && /* @__PURE__ */ q.jsx(EH, { ..._, isLoading: k }),
              g && (a != null && a.modifiedInfo) ? /* @__PURE__ */ q.jsx("div", { className: `${U}-edit-tag`, children: w("edited") }) : "",
              // @ts-ignore
              (a.translations || Oe == "translating") && m && /* @__PURE__ */ q.jsxs("div", { className: $e, children: [
                /* @__PURE__ */ q.jsx("div", { className: `${xe}-line` }),
                /* @__PURE__ */ q.jsx("span", {
                  className: `${xe}-text`,
                  // @ts-ignore
                  children: Nd((rt = (nt = a.translations) == null ? void 0 : nt[0]) == null ? void 0 : rt.text, !0)
                }),
                /* @__PURE__ */ q.jsxs("div", { className: `${xe}-action`, children: [
                  /* @__PURE__ */ q.jsx(pn, { type: "TRANSLATION", width: 16, height: 16 }),
                  /* @__PURE__ */ q.jsx("span", { children: w(`${Oe}`) }),
                  /* @__PURE__ */ q.jsx("span", { onClick: Ut, children: w(`${Te}`) })
                ] })
              ] })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        title: w("modifyTitle"),
        okText: w("confirmBtn"),
        cancelText: w("cancelBtn"),
        wrapClassName: "modify-message-modal",
        onCancel: St,
        onOk: Ft,
        open: ee,
        children: /* @__PURE__ */ q.jsx(
          Kw,
          {
            className: be,
            ref: M,
            enableEnterSend: !1,
            enabledMention: !1
          }
        )
      }
    )
  ] }) });
};
Dd = Pd(mi(Dd));
const aY = (t) => {
  var N, w, _;
  const { getPrefixCls: r } = _t.useContext(Hn), a = Zn(Vn), { rootStore: u, theme: h } = a, b = (h == null ? void 0 : h.mode) || "light", { prefixCls: l, className: v, type: s } = t, c = r("message-reply", l), { t: d } = Yr(), p = En(
    c,
    {
      [`${c}-${s}`]: s == "summary",
      [`${c}-${b}`]: !!b
    },
    v
  ), m = u.messageStore.repliedMessage, E = (I) => {
    var H;
    let k;
    switch (I.type) {
      case "txt":
        k = /* @__PURE__ */ q.jsx("div", { className: `${c}-summary-desc`, children: Nd(I.msg, "") });
        break;
      case "file":
        k = /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-desc`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "DOC", color: "#75828A", width: 16, height: 16 }),
          /* @__PURE__ */ q.jsxs("span", { children: [
            d("file"),
            ":"
          ] }),
          I.filename
        ] });
        break;
      case "audio":
        k = /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-desc`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "WAVE3", color: "#75828A", width: 16, height: 16 }),
          /* @__PURE__ */ q.jsxs("span", { children: [
            d("audio"),
            ":"
          ] }),
          I.length,
          '"'
        ] });
        break;
      case "img":
        k = /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-desc`, children: [
          /* @__PURE__ */ q.jsx("span", { children: d("image") }),
          /* @__PURE__ */ q.jsx("div", { className: `${c}-summary-desc-img`, children: /* @__PURE__ */ q.jsx("img", { src: I.thumb || I.url }) })
        ] });
        break;
      case "combine":
        k = /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-desc`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "TIME", color: "#75828A", width: 16, height: 16 }),
          /* @__PURE__ */ q.jsx("span", { children: d("chatHistory") })
        ] });
        break;
      case "custom":
        I.customEvent === "userCard" && (k = /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-desc`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "PERSON_SINGLE_FILL", color: "#75828A", width: 16, height: 16 }),
          /* @__PURE__ */ q.jsxs("span", { children: [
            d("Contact"),
            ":"
          ] }),
          (H = I.customExts) == null ? void 0 : H.nickname
        ] }));
        break;
      case "video":
        k = /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-desc`, children: [
          /* @__PURE__ */ q.jsx("span", { children: d("video") }),
          /* @__PURE__ */ q.jsx("div", { className: `${c}-summary-desc-img`, children: /* @__PURE__ */ q.jsx(pn, { type: "TRIANGLE_IN_RECTANGLE_FILL", color: "#75828A", width: 24, height: 24 }) })
        ] });
        break;
      default:
        k = "";
        break;
    }
    return k;
  }, y = () => {
    u.messageStore.setRepliedMessage(null);
  }, g = u.client.user;
  (m == null ? void 0 : m.from) === g ? d("yourself") : m == null || m.from;
  let C = (N = m == null ? void 0 : m.ext) == null ? void 0 : N.msgQuote;
  typeof C == "string" && (C = JSON.parse(C));
  const O = (m == null ? void 0 : m.from) === g ? d("yourself") : ((_ = (w = u.addressStore.appUsersInfo) == null ? void 0 : w[m == null ? void 0 : m.from]) == null ? void 0 : _.nickname) || (C == null ? void 0 : C.msgSender);
  return /* @__PURE__ */ q.jsxs("div", { className: p, children: [
    /* @__PURE__ */ q.jsxs("div", { className: `${c}-summary-title`, children: [
      d("replyingTo"),
      " ",
      /* @__PURE__ */ q.jsx("span", { children: O })
    ] }),
    E(m),
    /* @__PURE__ */ q.jsx(
      pn,
      {
        className: `${c}-summary-close`,
        width: 16,
        height: 16,
        type: "CLOSE_CIRCLE",
        onClick: y
      }
    )
  ] });
};
function Jw(t, r, a) {
  var u = window, h = "application/octet-stream", b = a || h, l = t, v = !r && !a && l, s = document.createElement("a"), c = function(I) {
    return String(I);
  }, d = u.Blob || u.MozBlob || u.WebKitBlob || c, p = r || "download", m, E;
  if (d = d.call ? d.bind(u) : Blob, String(this) === "true" && (l = [l, b], b = l[0], l = l[1]), v && v.length < 2048 && (p = v.split("/").pop().split("?")[0], s.href = v, s.href.indexOf(v) !== -1)) {
    var y = new XMLHttpRequest();
    return y.open("GET", v, !0), y.responseType = "blob", y.onload = function(I) {
      Jw(I.target.response, p, h);
    }, setTimeout(function() {
      y.send();
    }, 0), y;
  }
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(l))
    if (l.length > 1024 * 1024 * 1.999 && d !== c)
      l = N(l), b = l.type || h;
    else
      return navigator.msSaveBlob ? navigator.msSaveBlob(N(l), p) : _(l);
  else if (/([\x80-\xff])/.test(l)) {
    var g = 0, C = new Uint8Array(l.length), O = C.length;
    for (g; g < O; ++g) C[g] = l.charCodeAt(g);
    l = new d([C], { type: b });
  }
  m = l instanceof d ? l : new d([l], { type: b });
  function N(I) {
    var k = I.split(/[:;,]/), H = k[1], S = I.indexOf("charset") > 0 ? 3 : 2, B = k[S] == "base64" ? atob : decodeURIComponent, D = B(k.pop()), F = D.length, j = 0, G = new Uint8Array(F);
    for (j; j < F; ++j) G[j] = D.charCodeAt(j);
    return new d([G], { type: H });
  }
  const w = function(I) {
    I.stopPropagation(), this.removeEventListener("click", w);
  };
  function _(I, k) {
    if ("download" in s)
      return s.href = I, s.setAttribute("download", p), s.className = "download-js-link", s.innerHTML = "downloading...", s.style.display = "none", s.addEventListener("click", w), document.body.appendChild(s), setTimeout(function() {
        s.click(), document.body.removeChild(s), k === !0 && setTimeout(function() {
          u.URL.revokeObjectURL(s.href);
        }, 250);
      }, 66), !0;
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(
      navigator.userAgent
    ))
      return /^data:/.test(I) && (I = "data:" + I.replace(/^data:([\w\/\-\+]+)/, h)), window.open(I) || confirm(
        `Displaying New Document

Use Save As... to download, then click back to return to this page.`
      ) && (location.href = I), !0;
    var H = document.createElement("iframe");
    document.body.appendChild(H), !k && /^data:/.test(I) && (I = "data:" + I.replace(/^data:([\w\/\-\+]+)/, h)), H.src = I, setTimeout(function() {
      document.body.removeChild(H);
    }, 333);
  }
  if (navigator.msSaveBlob)
    return navigator.msSaveBlob(m, p);
  if (u.URL)
    _(u.URL.createObjectURL(m), !0);
  else {
    if (typeof m == "string" || m.constructor === c)
      try {
        return _(
          "data:" + b + ";base64," + u.btoa(m)
        );
      } catch {
        return _(
          "data:" + b + "," + encodeURIComponent(m)
        );
      }
    E = new FileReader(), E.onload = function(I) {
      _(this.result);
    }, E.readAsDataURL(m);
  }
  return !0;
}
const tAe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJJSURBVHgB7VZRVhMxFH0vM0fql11CWIHNQYXqz7ADWIG4AtkBZQXgCqgrEFdQfnRE4YSugLoC4U/RzvO9dMpkSkvTDj389J7T5uQ1yb3Ju3kpwBJLPDLQ71hr6zeg3lNGGuZEv08f3rwyF1++20asQK+/MMel9fuQ+LHYn/wnQwswP7kgUnDNzW4U4wERJKe221o3z/dTazWv3+Et669ndvt1LuJWQPrDJtxo/vQIaB/mRC0CtzARfUTAhE+zxSLq3G4N1qfu0whOhuOLE1COXHDSXDNtqAhZIz23vGE8YvLdQZS6KwoSY8xVQbtIKLfTXtFXHZ98MCQAYqjTM7uVplZDICTnKDnP0+qCfBKcjr2ZBMiEKEJLiJ/wCXZCRSDhEeQ5X1Fk2FfvJC6eyP0WJoAn7HhdzSL2IAR9+szf7WHOxRNItA3EJv1XpCWetg4B1EvFgugaArDx0hyOxvL7f+zHpp4AZsWVZDFX9BcOx42TIuN84h3vpHEzCZCdkKJVyWGN22bT9EbHsE/e/s7w0vlEYefb+cXlOK/wtWxxMfrli5yaAkHTONL2uN+EnH3SxnJY54bdLAkmNiXmbY5KdUCup5BP+FmH3Jq5BQi5itw9vw9OxGjeKwsYkvNp1gOG6xuaLGJmATOSO/Cr2BARSHfnBJmwCrkvAhQ2RuPBJ1CF/D4EP0aLIBcUKci4Pg/kJFwwdsrD8OBBybF4C0r1QyoYQFEkFoTexlpjddgpmZBL7iZmwP9e8BksAFy0ftbi8W/JEks8Gv4D39kVqSMHRzgAAAAASUVORK5CYII=", nAe = (t) => {
  var Be, Ke, Ze, at;
  const {
    imageMessage: r,
    style: a,
    onClickImage: u,
    renderUserProfile: h,
    thread: b,
    nickName: l,
    className: v,
    shape: s,
    prefix: c,
    bubbleClass: d,
    imgProps: p,
    ...m
  } = t;
  let E = t.type, { bySelf: y, from: g, reactions: C, status: O } = r;
  const { getPrefixCls: N } = _t.useContext(Hn), w = N("message-img", c), _ = Zn(Vn), I = ar(r), { theme: k } = _, { pinMessage: H } = Rc({
    conversation: {
      conversationId: I,
      conversationType: r.chatType
    }
  });
  let S = s;
  k != null && k.bubbleShape && (S = k == null ? void 0 : k.bubbleShape);
  const B = En(
    w,
    {
      [`${w}-${S}`]: !!S
    },
    v
  ), [D, F] = tn(
    r.url || ((Be = r == null ? void 0 : r.file) == null ? void 0 : Be.url) || r.thumb
  ), [j, G] = tn(!1), U = (pt, It, Rt) => {
    const gt = new Image();
    gt.src = pt, gt.setAttribute("crossOrigin", "Anonymous"), gt.onload = function() {
      const it = this, Tt = it.width, Ut = it.height;
      let st = 1;
      const Ot = document.createElement("canvas"), kt = Ot.getContext("2d"), wt = document.createAttribute("width");
      wt.nodeValue = Tt.toString();
      const Et = document.createAttribute("height");
      Et.nodeValue = Ut.toString(), Ot.setAttributeNode(wt), Ot.setAttributeNode(Et), kt.drawImage(it, 0, 0, Tt, Ut), It.quality && It.quality <= 1 && It.quality > 0 && (st = It.quality);
      const ut = Ot.toDataURL("image/jpeg", st);
      F(ut);
    };
  }, M = (pt) => {
    G(!0), U(pt, { quality: 1 }), u == null || u(pt);
  }, V = y ? r.url || ((Ke = r == null ? void 0 : r.file) == null ? void 0 : Ke.url) : r.thumb || r.url, [J, ue] = tn(V);
  typeof y > "u" && (y = r.from === Zt.client.context.userId);
  const se = () => {
    Zt.messageStore.setRepliedMessage(r);
  }, ee = () => {
    const pt = ar(r);
    Zt.messageStore.deleteMessage(
      {
        chatType: r.chatType,
        conversationId: pt
      },
      // @ts-ignore
      r.mid || r.id
    );
  }, de = () => {
    H(r.mid || r.id);
  }, he = (pt) => {
    const It = ar(r);
    Zt.messageStore.addReaction(
      {
        chatType: r.chatType,
        conversationId: It
      },
      // @ts-ignore
      r.mid || r.id,
      pt
    );
  }, pe = (pt) => {
    const It = ar(r);
    Zt.messageStore.deleteReaction(
      {
        chatType: r.chatType,
        conversationId: It
      },
      // @ts-ignore
      r.mid || r.id,
      pt
    );
  }, Ce = (pt) => {
    const It = ar(r);
    C == null || C.forEach((Rt) => {
      if (Rt.reaction === pt && (Rt.count > 3 && Rt.userList.length <= 3 && Zt.messageStore.getReactionUserList(
        {
          chatType: r.chatType,
          conversationId: It
        },
        // @ts-ignore
        textMessage.mid || textMessage.id,
        pt
      ), Rt.isAddedBySelf)) {
        const gt = Rt.userList.indexOf(Zt.client.user);
        if (gt > -1) {
          const it = Rt.userList.splice(gt, 1)[0];
          Rt.userList.unshift(it);
        } else
          Rt.userList.unshift(Zt.client.user);
      }
    });
  }, _e = () => {
    const pt = ar(r);
    Zt.messageStore.recallMessage(
      {
        chatType: r.chatType,
        conversationId: pt
      },
      // @ts-ignore
      r.mid || r.id,
      r.isChatThread,
      !0
    );
  }, Le = () => {
    var It;
    (It = Zt.messageStore.selectedMessage[r.chatType][I]) != null && It.selectable || Zt.messageStore.setSelectedMessage(
      {
        chatType: r.chatType,
        conversationId: I
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, Te = () => {
    Zt.messageStore.sendMessage(r);
  }, K = (Ze = Zt.messageStore.selectedMessage[r.chatType][I]) == null ? void 0 : Ze.selectable, Oe = (pt) => {
    var gt;
    const It = (gt = Zt.messageStore.selectedMessage[r.chatType][I]) == null ? void 0 : gt.selectedMessage;
    let Rt = It;
    pt ? Rt.push(r) : Rt = It.filter((it) => !(it.id == r.id || it.mid == r.id)), Zt.messageStore.setSelectedMessage(
      {
        chatType: r.chatType,
        conversationId: I
      },
      {
        selectable: !0,
        selectedMessage: Rt
      }
    );
  }, Pe = (
    // @ts-ignore
    r.chatType == "groupChat" && b && // @ts-ignore
    !r.chatThread && !r.isChatThread
  ), xe = () => {
    Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: r
    }), Zt.threadStore.setThreadVisible(!0);
  }, be = () => {
    var pt, It;
    Zt.threadStore.joinChatThread(((pt = r.chatThreadOverview) == null ? void 0 : pt.id) || ""), Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: r,
      info: r.chatThreadOverview
    }), Zt.threadStore.setThreadVisible(!0), Zt.threadStore.getChatThreadDetail(((It = r == null ? void 0 : r.chatThreadOverview) == null ? void 0 : It.id) || "");
  };
  E || (E = y ? "primary" : "secondly");
  const $e = er(null);
  return /* @__PURE__ */ q.jsxs("div", { children: [
    /* @__PURE__ */ q.jsx(
      Oh,
      {
        id: r.id,
        className: d,
        message: r,
        time: r.time,
        bubbleType: E,
        direction: y ? "rtl" : "ltr",
        nickName: l,
        onReplyMessage: se,
        onDeleteMessage: ee,
        reactionData: C,
        onAddReactionEmoji: he,
        onDeleteReactionEmoji: pe,
        onShowReactionUserList: Ce,
        onRecallMessage: _e,
        onSelectMessage: Le,
        onResendMessage: Te,
        onPinMessage: de,
        select: K,
        onMessageCheckChange: Oe,
        renderUserProfile: h,
        onCreateThread: xe,
        thread: Pe,
        chatThreadOverview: r.chatThreadOverview,
        onClickThreadTitle: be,
        bubbleStyle: {
          padding: 0,
          background: r.chatThreadOverview ? void 0 : "transparent"
        },
        shape: s,
        status: O,
        ...m,
        children: /* @__PURE__ */ q.jsx("div", { className: B, style: a, children: /* @__PURE__ */ q.jsx(
          "img",
          {
            ref: $e,
            onError: function() {
              ue(tAe), $e.current && ($e.current.style.padding = "22px 34px", $e.current.style.border = "1px solid #e5e5e5", $e.current.style.backgroundColor = "#E3E6E8");
            },
            src: J,
            alt: (at = r.file) == null ? void 0 : at.filename,
            onClick: () => M(r.url || V),
            ...p
          }
        ) })
      }
    ),
    j && /* @__PURE__ */ q.jsx(
      oY,
      {
        visible: j,
        previewImageUrl: r.url,
        onCancel: () => {
          G(!1);
        }
      }
    )
  ] });
}, oY = (t) => {
  const { visible: r, previewImageUrl: a, alt: u, onCancel: h } = t;
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx(iY, { prefixCls: "", visible: !0 }),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: r,
        closable: !0,
        footer: "",
        wrapClassName: "message-image-preview-wrap",
        width: "70%",
        style: { overflow: "hidden", height: "70%" },
        maskClosable: !0,
        onCancel: () => {
          h == null || h();
        },
        children: /* @__PURE__ */ q.jsx(
          "img",
          {
            className: "message-image-big",
            src: a,
            alt: u
          }
        )
      }
    )
  ] });
}, kv = mi(nAe);
kv.displayName = "ImageMessage";
const rAe = (t) => {
  var Te;
  let {
    iconType: r = "DOC",
    bubbleClass: a,
    fileMessage: u,
    shape: h,
    prefix: b,
    style: l,
    type: v,
    className: s,
    nickName: c,
    renderUserProfile: d,
    thread: p,
    ...m
  } = t;
  const { filename: E, file_length: y, from: g, reactions: C, status: O } = u, { getPrefixCls: N } = _t.useContext(Hn), w = N("message-file", b);
  let { bySelf: _ } = u;
  const I = ar(u), k = Zn(Vn), { rootStore: H, theme: S } = k, B = (S == null ? void 0 : S.mode) || "light", { pinMessage: D } = Rc({
    conversation: {
      conversationId: I,
      conversationType: u.chatType
    }
  });
  typeof _ > "u" && (_ = u.from === H.client.context.userId), v || (v = _ ? "primary" : "secondly");
  const F = En(
    w,
    {
      [`${w}-${v}`]: !!v,
      [`${w}-${B}`]: !!B
    },
    s
  ), j = () => {
    fetch(u.url).then((K) => K.blob()).then((K) => {
      Jw(K, E), u.chatType == "singleChat" && u.from != H.client.context.userId && // @ts-ignore
      u.status != "read" && !u.isChatThread && u.to == H.client.context.userId && H.messageStore.sendReadAck(u.id, u.from || "");
    }).catch((K) => !1);
  }, G = () => {
    H.messageStore.setRepliedMessage(u);
  }, U = () => {
    const K = ar(u);
    H.messageStore.deleteMessage(
      {
        chatType: u.chatType,
        conversationId: K
      },
      // @ts-ignore
      u.mid || u.id
    );
  }, M = () => {
    D(u.mid || u.id);
  }, V = (K) => {
    const Oe = ar(u);
    H.messageStore.addReaction(
      {
        chatType: u.chatType,
        conversationId: Oe
      },
      // @ts-ignore
      u.mid || u.id,
      K
    );
  }, J = (K) => {
    const Oe = ar(u);
    H.messageStore.deleteReaction(
      {
        chatType: u.chatType,
        conversationId: Oe
      },
      // @ts-ignore
      u.mid || u.id,
      K
    );
  }, ue = (K) => {
    const Oe = ar(u);
    C == null || C.forEach((Pe) => {
      if (Pe.reaction === K && (Pe.count > 3 && Pe.userList.length <= 3 && H.messageStore.getReactionUserList(
        {
          chatType: u.chatType,
          conversationId: Oe
        },
        // @ts-ignore
        u.mid || u.id,
        K
      ), Pe.isAddedBySelf)) {
        const xe = Pe.userList.indexOf(H.client.user);
        if (xe > -1) {
          const be = Pe.userList.splice(xe, 1)[0];
          Pe.userList.unshift(be);
        } else
          Pe.userList.unshift(H.client.user);
      }
    });
  }, se = () => {
    const K = ar(u);
    H.messageStore.recallMessage(
      {
        chatType: u.chatType,
        conversationId: K
      },
      // @ts-ignore
      u.mid || u.id,
      u.isChatThread,
      !0
    );
  }, ee = () => {
    var Oe;
    (Oe = H.messageStore.selectedMessage[u.chatType][I]) != null && Oe.selectable || H.messageStore.setSelectedMessage(
      {
        chatType: u.chatType,
        conversationId: I
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, de = () => {
    H.messageStore.sendMessage(u);
  }, he = H.messageStore && ((Te = H.messageStore.selectedMessage[u.chatType][I]) == null ? void 0 : Te.selectable), pe = (K) => {
    var xe;
    const Oe = (xe = H.messageStore.selectedMessage[u.chatType][I]) == null ? void 0 : xe.selectedMessage;
    let Pe = Oe;
    K ? Pe.push(u) : Pe = Oe.filter((be) => !(be.id == u.id || be.mid == u.id)), H.messageStore.setSelectedMessage(
      {
        chatType: u.chatType,
        conversationId: I
      },
      {
        selectable: !0,
        selectedMessage: Pe
      }
    );
  }, Ce = (
    // @ts-ignore
    u.chatType == "groupChat" && p && // @ts-ignore
    !u.chatThread && !u.isChatThread
  ), _e = () => {
    H.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: u
    }), H.threadStore.setThreadVisible(!0);
  }, Le = () => {
    var K, Oe;
    H.threadStore.joinChatThread(((K = u.chatThreadOverview) == null ? void 0 : K.id) || ""), H.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: u,
      info: u.chatThreadOverview
    }), H.threadStore.setThreadVisible(!0), H.threadStore.getChatThreadDetail(((Oe = u == null ? void 0 : u.chatThreadOverview) == null ? void 0 : Oe.id) || "");
  };
  return /* @__PURE__ */ q.jsx(
    Oh,
    {
      id: u.id,
      className: a,
      message: u,
      bubbleType: v,
      direction: _ ? "rtl" : "ltr",
      shape: h,
      time: u.time,
      nickName: c,
      onReplyMessage: G,
      onDeleteMessage: U,
      onPinMessage: M,
      reactionData: C,
      onAddReactionEmoji: V,
      onDeleteReactionEmoji: J,
      onShowReactionUserList: ue,
      onRecallMessage: se,
      onSelectMessage: ee,
      onResendMessage: de,
      renderUserProfile: d,
      select: he,
      onMessageCheckChange: pe,
      onCreateThread: _e,
      thread: Ce,
      chatThreadOverview: u.chatThreadOverview,
      onClickThreadTitle: Le,
      status: O,
      ...m,
      children: /* @__PURE__ */ q.jsxs("div", { className: F, style: l, children: [
        /* @__PURE__ */ q.jsxs("div", { className: `${w}-info`, children: [
          /* @__PURE__ */ q.jsx("span", { onClick: j, children: E }),
          /* @__PURE__ */ q.jsxs("span", { children: [
            (y / 1024).toFixed(2),
            "kb"
          ] })
        ] }),
        /* @__PURE__ */ q.jsx("div", { className: `${w}-icon`, children: /* @__PURE__ */ q.jsx(pn, { type: r, height: "32px", width: "32px", color: "#ACB4B9" }) })
      ] })
    }
  );
}, jv = mi(rAe);
jv.displayName = "FileMessage";
let IN = (t) => {
  var Be;
  const {
    customMessage: r,
    renderUserProfile: a,
    nickName: u,
    prefix: h,
    className: b,
    style: l,
    bubbleClass: v,
    thread: s,
    onUserIdCopied: c,
    ...d
  } = t;
  let { bySelf: p, from: m, reactions: E, status: y } = r;
  const { conversationStore: g, addressStore: C } = Zt, { getPrefixCls: O } = _t.useContext(Hn), N = O("message-card", h), { t: w } = Yr(), _ = r.customExts, { nickname: I, uid: k, avatar: H } = _, { pinMessage: S } = Rc({
    conversation: {
      conversationId: ar(r),
      conversationType: r.chatType
    }
  });
  typeof p > "u" && (p = m === Zt.client.context.userId);
  let B = t.type;
  B || (B = p ? "primary" : "secondly");
  const D = En(
    N,
    {
      [`${N}-${B}`]: !!B
    },
    b
  ), F = () => {
    Zt.messageStore.setRepliedMessage(r);
  }, j = () => {
    const Ke = ar(r);
    Zt.messageStore.deleteMessage(
      {
        chatType: r.chatType,
        conversationId: Ke
      },
      // @ts-ignore
      r.mid || r.id
    );
  }, G = () => {
    S(r.mid || r.id);
  }, U = (Ke) => {
    const Ze = ar(r);
    Zt.messageStore.addReaction(
      {
        chatType: r.chatType,
        conversationId: Ze
      },
      // @ts-ignore
      r.mid || r.id,
      Ke
    );
  }, M = (Ke) => {
    const Ze = ar(r);
    Zt.messageStore.deleteReaction(
      {
        chatType: r.chatType,
        conversationId: Ze
      },
      // @ts-ignore
      r.mid || r.id,
      Ke
    );
  }, V = (Ke) => {
    const Ze = ar(r);
    E == null || E.forEach((at) => {
      if (at.reaction === Ke && (at.count > 3 && at.userList.length <= 3 && Zt.messageStore.getReactionUserList(
        {
          chatType: r.chatType,
          conversationId: Ze
        },
        // @ts-ignore
        r.mid || r.id,
        Ke
      ), at.isAddedBySelf)) {
        const pt = at.userList.indexOf(Zt.client.user);
        if (pt > -1) {
          const It = at.userList.splice(pt, 1)[0];
          at.userList.unshift(It);
        } else
          at.userList.unshift(Zt.client.user);
      }
    });
  }, J = () => {
    const Ke = ar(r);
    Zt.messageStore.recallMessage(
      {
        chatType: r.chatType,
        conversationId: Ke
      },
      // @ts-ignore
      r.mid || r.id,
      r.isChatThread,
      !0
    );
  }, ue = () => {
    var at;
    const Ke = ar(r);
    (at = Zt.messageStore.selectedMessage[r.chatType][Ke]) != null && at.selectable || Zt.messageStore.setSelectedMessage(
      {
        chatType: r.chatType,
        conversationId: Ke
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, se = () => {
    Zt.messageStore.sendMessage(r);
  }, ee = ar(r), de = (Be = Zt.messageStore.selectedMessage[r.chatType][ee]) == null ? void 0 : Be.selectable, he = (Ke) => {
    var pt;
    const Ze = (pt = Zt.messageStore.selectedMessage[r.chatType][ee]) == null ? void 0 : pt.selectedMessage;
    let at = Ze;
    Ke ? at.push(r) : at = Ze.filter((It) => !(It.id == r.id || It.mid == r.id)), Zt.messageStore.setSelectedMessage(
      {
        chatType: r.chatType,
        conversationId: ee
      },
      {
        selectable: !0,
        selectedMessage: at
      }
    );
  }, pe = () => {
    Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: r
    }), Zt.threadStore.setThreadVisible(!0);
  }, Ce = (
    // @ts-ignore
    r.chatType == "groupChat" && s && // @ts-ignore
    !r.chatThread && !r.isChatThread
  ), _e = () => {
    var Ke, Ze;
    Zt.threadStore.joinChatThread(((Ke = r.chatThreadOverview) == null ? void 0 : Ke.id) || ""), Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: r,
      info: r.chatThreadOverview
    }), Zt.threadStore.setThreadVisible(!0), Zt.threadStore.getChatThreadDetail(((Ze = r == null ? void 0 : r.chatThreadOverview) == null ? void 0 : Ze.id) || "");
  }, Le = () => {
    const Ke = document.createElement("textarea");
    Ke.value = k, document.body.appendChild(Ke), Ke.select(), document.execCommand("copy"), document.body.removeChild(Ke), c == null || c(k);
  }, Te = () => {
    $e(!0), C.addContact(k);
  }, K = () => {
    g.addConversation({
      chatType: "singleChat",
      conversationId: k,
      name: I,
      lastMessage: {
        time: Date.now(),
        type: "txt",
        msg: "",
        id: "",
        chatType: "singleChat",
        to: k
      },
      unreadCount: 0
    }), g.setCurrentCvs({
      chatType: "singleChat",
      conversationId: k,
      name: I
    }), xe(!1);
  }, Oe = C.contacts.some((Ke) => Ke.userId === k), [Pe, xe] = tn(!1), [be, $e] = tn(!1);
  return /* @__PURE__ */ q.jsxs("div", { children: [
    /* @__PURE__ */ q.jsx(
      Oh,
      {
        time: r.time,
        id: r.id,
        className: v,
        message: r,
        bubbleType: B,
        direction: p ? "rtl" : "ltr",
        nickName: u,
        onReplyMessage: F,
        onDeleteMessage: j,
        onPinMessage: G,
        reactionData: E,
        onAddReactionEmoji: U,
        onDeleteReactionEmoji: M,
        onShowReactionUserList: V,
        onRecallMessage: J,
        onSelectMessage: ue,
        onResendMessage: se,
        select: de,
        onMessageCheckChange: he,
        renderUserProfile: a,
        onCreateThread: pe,
        thread: Ce,
        chatThreadOverview: r.chatThreadOverview,
        onClickThreadTitle: _e,
        status: y,
        ...d,
        children: /* @__PURE__ */ q.jsxs(
          "div",
          {
            className: D,
            style: l,
            onClick: () => {
              xe(!0);
            },
            children: [
              /* @__PURE__ */ q.jsxs("div", { className: `${N}-info`, children: [
                /* @__PURE__ */ q.jsx(zs, { size: 44, src: H, children: I }),
                I
              ] }),
              /* @__PURE__ */ q.jsx("div", { className: `${N}-tag`, children: w("contact") })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        title: null,
        open: Pe,
        footer: null,
        width: 326,
        closable: !1,
        onCancel: () => {
          xe(!1);
        },
        children: /* @__PURE__ */ q.jsxs("div", { className: `${N}-modal`, children: [
          /* @__PURE__ */ q.jsx(zs, { size: 100, src: H, children: I }),
          /* @__PURE__ */ q.jsxs("div", { className: `${N}-modal-content`, children: [
            /* @__PURE__ */ q.jsx("div", { className: `${N}-content-name`, children: I }),
            /* @__PURE__ */ q.jsxs("div", { className: `${N}-content-id`, children: [
              /* @__PURE__ */ q.jsxs("div", { children: [
                w("user"),
                " ID:"
              ] }),
              k,
              /* @__PURE__ */ q.jsx(pn, { type: "DOC_ON_DOC", style: { cursor: "copy" }, onClick: Le })
            ] })
          ] }),
          Oe ? /* @__PURE__ */ q.jsxs(
            gi,
            {
              type: "primary",
              className: `${N}-content-btn`,
              onClick: K,
              children: [
                /* @__PURE__ */ q.jsx(pn, { type: "BUBBLE_FILL", width: 24, height: 24 }),
                w("message")
              ]
            }
          ) : k == Zt.client.user ? null : /* @__PURE__ */ q.jsxs(
            gi,
            {
              type: "primary",
              className: `${N}-content-btn`,
              onClick: Te,
              disabled: be,
              children: [
                /* @__PURE__ */ q.jsx(pn, { type: "BUBBLE_FILL", width: 24, height: 24 }),
                w("addContact")
              ]
            }
          )
        ] })
      }
    )
  ] });
};
IN = mi(IN);
const PA = IN, iAe = (t) => {
  var Ce, _e;
  const r = er(null), {
    videoMessage: a,
    renderUserProfile: u,
    type: h,
    shape: b,
    nickName: l,
    thread: v,
    className: s,
    prefix: c,
    videoProps: d,
    bubbleClass: p,
    ...m
  } = t;
  let { bySelf: E, from: y, reactions: g, status: C } = a;
  const { pinMessage: O } = Rc({
    conversation: {
      conversationId: ar(a),
      conversationType: a.chatType
    }
  }), { getPrefixCls: N } = _t.useContext(Hn), w = N("message-video", c), _ = Zn(Vn), { theme: I } = _;
  let k = b;
  I != null && I.bubbleShape && (k = I == null ? void 0 : I.bubbleShape);
  const H = En(
    w,
    {
      [`${w}-${k}`]: !!k
    },
    s
  );
  typeof E > "u" && (E = y == Zt.client.context.userId);
  const S = () => {
    Zt.messageStore.setRepliedMessage(a);
  }, B = () => {
    const Le = ar(a);
    Zt.messageStore.deleteMessage(
      {
        chatType: a.chatType,
        conversationId: Le
      },
      // @ts-ignore
      a.mid || a.id
    );
  }, D = () => {
    O(a.mid || a.id);
  }, F = (Le) => {
    const Te = ar(a);
    Zt.messageStore.addReaction(
      {
        chatType: a.chatType,
        conversationId: Te
      },
      // @ts-ignore
      a.mid || a.id,
      Le
    );
  }, j = (Le) => {
    const Te = ar(a);
    Zt.messageStore.deleteReaction(
      {
        chatType: a.chatType,
        conversationId: Te
      },
      // @ts-ignore
      a.mid || a.id,
      Le
    );
  }, G = (Le) => {
    const Te = ar(a);
    g == null || g.forEach((K) => {
      if (K.reaction === Le && (K.count > 3 && K.userList.length <= 3 && Zt.messageStore.getReactionUserList(
        {
          chatType: a.chatType,
          conversationId: Te
        },
        // @ts-ignore
        a.mid || a.id,
        Le
      ), K.isAddedBySelf)) {
        const Oe = K.userList.indexOf(Zt.client.user);
        if (Oe > -1) {
          const Pe = K.userList.splice(Oe, 1)[0];
          K.userList.unshift(Pe);
        } else
          K.userList.unshift(Zt.client.user);
      }
    });
  }, U = () => {
    const Le = ar(a);
    Zt.messageStore.recallMessage(
      {
        chatType: a.chatType,
        conversationId: Le
      },
      // @ts-ignore
      a.mid || a.id,
      a.isChatThread,
      !0
    );
  }, M = ar(a), V = () => {
    var Te;
    (Te = Zt.messageStore.selectedMessage[a.chatType][M]) != null && Te.selectable || Zt.messageStore.setSelectedMessage(
      {
        chatType: a.chatType,
        conversationId: M
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, J = () => {
    Zt.messageStore.sendMessage(a);
  }, ue = (Ce = Zt.messageStore.selectedMessage[a.chatType][M]) == null ? void 0 : Ce.selectable, se = (Le) => {
    var Oe;
    const Te = (Oe = Zt.messageStore.selectedMessage[a.chatType][M]) == null ? void 0 : Oe.selectedMessage;
    let K = Te;
    Le ? K.push(a) : K = Te.filter((Pe) => !(Pe.id == a.id || Pe.mid == a.id)), Zt.messageStore.setSelectedMessage(
      {
        chatType: a.chatType,
        conversationId: M
      },
      {
        selectable: !0,
        selectedMessage: K
      }
    );
  }, ee = (
    // @ts-ignore
    a.chatType == "groupChat" && v && // @ts-ignore
    !a.chatThread && !a.isChatThread
  ), de = () => {
    Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: a
    }), Zt.threadStore.setThreadVisible(!0);
  }, he = () => {
    var Le, Te;
    Zt.threadStore.joinChatThread(((Le = a.chatThreadOverview) == null ? void 0 : Le.id) || ""), Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: a,
      info: a.chatThreadOverview
    }), Zt.threadStore.setThreadVisible(!0), Zt.threadStore.getChatThreadDetail(((Te = a == null ? void 0 : a.chatThreadOverview) == null ? void 0 : Te.id) || "");
  }, pe = () => {
    a.chatType == "singleChat" && a.from != Zt.client.context.userId && // @ts-ignore
    a.status != "read" && !a.isChatThread && a.to == Zt.client.context.userId && Zt.messageStore.sendReadAck(a.id, a.from || "");
  };
  return /* @__PURE__ */ q.jsx(
    Oh,
    {
      id: a.id,
      className: p,
      message: a,
      bubbleType: h,
      direction: E ? "rtl" : "ltr",
      shape: b,
      bubbleStyle: {
        padding: 0,
        background: a.chatThreadOverview ? void 0 : "transparent"
      },
      time: a.time,
      nickName: l,
      onReplyMessage: S,
      onDeleteMessage: B,
      onPinMessage: D,
      reactionData: g,
      onAddReactionEmoji: F,
      onDeleteReactionEmoji: j,
      onShowReactionUserList: G,
      onRecallMessage: U,
      onSelectMessage: V,
      onResendMessage: J,
      renderUserProfile: u,
      select: ue,
      onMessageCheckChange: se,
      onCreateThread: de,
      thread: ee,
      chatThreadOverview: a.chatThreadOverview,
      onClickThreadTitle: he,
      status: C,
      ...m,
      children: /* @__PURE__ */ q.jsx("div", { className: H, children: /* @__PURE__ */ q.jsx(
        "video",
        {
          id: "videoEle",
          ref: r,
          autoPlay: !1,
          controls: !0,
          crossOrigin: "anonymous",
          preload: "metadata",
          onPlay: pe,
          poster: a.thumb,
          src: `${a.url}${(_e = a == null ? void 0 : a.url) != null && _e.includes("?") ? "&origin-file=true" : "?em-redirect=true&origin-file=true"}`,
          ...d
        }
      ) })
    }
  );
}, Uv = mi(iAe);
Uv.displayName = "VideoMessage";
const sAe = (t) => {
  const { visible: r, prefix: a, className: u, size: h = 48, style: b = {} } = t, { getPrefixCls: l } = _t.useContext(Hn), v = l("loading", a), s = En(v, u);
  return /* @__PURE__ */ q.jsx(q.Fragment, { children: r && /* @__PURE__ */ q.jsx("div", { className: s, style: { ...b }, children: /* @__PURE__ */ q.jsx(pn, { className: "circle", type: "LOADING", width: h, height: h }) }) });
}, cY = (t) => {
  var Be, Ke;
  const {
    combinedMessage: r,
    style: a,
    nickName: u,
    bubbleClass: h,
    prefix: b,
    className: l,
    renderUserProfile: v,
    thread: s,
    showSummary: c = !0,
    onlyContent: d = !1,
    ...p
  } = t;
  let { bySelf: m, time: E, from: y, reactions: g, title: C, summary: O } = r;
  const N = ar(r), { pinMessage: w } = Rc({
    conversation: {
      conversationId: N,
      conversationType: r.chatType
    }
  });
  typeof m > "u" && (m = y == Zt.client.context.userId);
  let _ = t.type;
  _ || (_ = m ? "primary" : "secondly");
  const { t: I } = Yr(), k = () => {
    Zt.messageStore.setRepliedMessage(r);
  }, H = () => {
    const Ze = ar(r);
    Zt.messageStore.deleteMessage(
      {
        chatType: r.chatType,
        conversationId: Ze
      },
      // @ts-ignore
      r.mid || r.id
    );
  };
  let S;
  (Be = r.ext) != null && Be.msgQuote && (S = r);
  const B = (Ze) => {
    const at = ar(r);
    Zt.messageStore.addReaction(
      {
        chatType: r.chatType,
        conversationId: at
      },
      // @ts-ignore
      r.mid || r.id,
      Ze
    );
  }, D = (Ze) => {
    const at = ar(r);
    Zt.messageStore.deleteReaction(
      {
        chatType: r.chatType,
        conversationId: at
      },
      // @ts-ignore
      r.mid || r.id,
      Ze
    );
  }, F = (Ze) => {
    const at = ar(r);
    g == null || g.forEach(
      (pt) => {
        if (pt.reaction === Ze && (pt.count > 3 && pt.userList.length <= 3 && Zt.messageStore.getReactionUserList(
          {
            chatType: r.chatType,
            conversationId: at
          },
          // @ts-ignore
          r.mid || r.id,
          Ze
        ), pt.isAddedBySelf)) {
          const It = pt.userList.indexOf(Zt.client.user);
          if (It > -1) {
            const Rt = pt.userList.splice(It, 1)[0];
            pt.userList.unshift(Rt);
          } else
            pt.userList.unshift(Zt.client.user);
        }
      }
    );
  }, j = () => {
    const Ze = ar(r);
    Zt.messageStore.recallMessage(
      {
        chatType: r.chatType,
        conversationId: Ze
      },
      // @ts-ignore
      r.mid || r.id,
      r.isChatThread,
      !0
    );
  }, { getPrefixCls: G } = _t.useContext(Hn), U = G("message-combine", b), M = Zn(Vn), { theme: V, features: J } = M, ue = (V == null ? void 0 : V.mode) || "light", se = En(
    U,
    {
      [`${U}-secondly`]: _ == "secondly",
      [`${U}-primary`]: _ == "primary",
      [`${U}-${ue}`]: !!ue
    },
    l
  ), [ee, de] = tn(
    /* @__PURE__ */ q.jsx(sAe, { size: 48, visible: !0 })
  ), he = (Ze) => {
    const at = Ze.map((pt) => {
      let It;
      switch (pt.bySelf = !1, pt == null ? void 0 : pt.type) {
        case "txt":
          It = /* @__PURE__ */ q.jsx(
            Dd,
            {
              select: !1,
              customAction: { visible: !1 },
              reaction: !1,
              bubbleType: "none",
              textMessage: pt,
              direction: "ltr",
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          );
          break;
        case "img":
          It = /* @__PURE__ */ q.jsx(
            kv,
            {
              select: !1,
              imageMessage: pt,
              direction: "ltr",
              reaction: !1,
              customAction: { visible: !1 },
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          );
          break;
        case "file":
          It = /* @__PURE__ */ q.jsx(
            jv,
            {
              select: !1,
              fileMessage: pt,
              direction: "ltr",
              type: "secondly",
              reaction: !1,
              customAction: { visible: !1 },
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          );
          break;
        case "audio":
          It = /* @__PURE__ */ q.jsx(
            Xm,
            {
              select: !1,
              audioMessage: pt,
              type: "secondly",
              reaction: !1,
              customAction: { visible: !1 },
              direction: "ltr",
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          );
          break;
        case "video":
          It = /* @__PURE__ */ q.jsx(
            Uv,
            {
              select: !1,
              videoMessage: pt,
              direction: "ltr",
              type: "secondly",
              reaction: !1,
              customAction: { visible: !1 },
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          );
          break;
        case "custom":
          pt.customEvent == "userCard" ? It = /* @__PURE__ */ q.jsx(
            PA,
            {
              select: !1,
              customMessage: pt,
              direction: "ltr",
              type: "secondly",
              reaction: !1,
              customAction: { visible: !1 },
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          ) : It = /* @__PURE__ */ q.jsx(
            Dd,
            {
              select: !1,
              bubbleType: "none",
              textMessage: pt,
              direction: "ltr",
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0,
              children: I("customMessage")
            },
            pt.id
          );
          break;
        case "combine":
          It = /* @__PURE__ */ q.jsx(
            cY,
            {
              select: !1,
              combinedMessage: pt,
              direction: "ltr",
              type: "secondly",
              reaction: !1,
              customAction: { visible: !1 },
              thread: !1,
              renderUserProfile: v,
              showNicknamesForAllMessages: !0
            },
            pt.id
          );
          break;
        default:
          It = null;
          break;
      }
      return It;
    });
    de(at);
  }, pe = () => {
    if (_e(!0), r.messages) {
      he(r.messages);
      return;
    }
    Zt.client.downloadAndParseCombineMessage({
      url: r.url || "",
      secret: r.secret || ""
    }).then((Ze) => {
      r.messages = Ze, he(Ze), r.chatType == "singleChat" && r.from != Zt.client.context.userId && // @ts-ignore
      r.status != "read" && !r.isChatThread && r.to == Zt.client.context.userId && Zt.messageStore.sendReadAck(r.id, r.from || "");
    }).catch(() => {
      de(/* @__PURE__ */ q.jsx("div", { children: "download message failed" }));
    });
  }, [Ce, _e] = tn(!1), Le = () => {
    var at;
    // @ts-ignore
    (at = Zt.messageStore.selectedMessage[r.chatType][N]) != null && at.selectable || Zt.messageStore.setSelectedMessage(
      {
        chatType: r.chatType,
        conversationId: N
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, Te = () => {
    Zt.messageStore.sendMessage(r);
  }, K = (
    // @ts-ignore
    (Ke = Zt.messageStore.selectedMessage[r.chatType][N]) == null ? void 0 : Ke.selectable
  ), Oe = (Ze) => {
    var It;
    const at = (
      // @ts-ignore
      (It = Zt.messageStore.selectedMessage[r.chatType][N]) == null ? void 0 : It.selectedMessage
    );
    let pt = at;
    Ze ? pt.push(r) : pt = at.filter((Rt) => !(Rt.id == r.id || Rt.mid == r.id)), Zt.messageStore.setSelectedMessage(
      {
        chatType: r.chatType,
        conversationId: N
      },
      {
        selectable: !0,
        selectedMessage: pt
      }
    );
  }, Pe = (
    // @ts-ignore
    r.chatType == "groupChat" && s && // @ts-ignore
    !r.chatThread && !r.isChatThread
  ), xe = () => {
    Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: r
    }), Zt.threadStore.setThreadVisible(!0);
  }, be = () => {
    var Ze, at;
    Zt.threadStore.joinChatThread(((Ze = r.chatThreadOverview) == null ? void 0 : Ze.id) || ""), Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: r,
      info: r.chatThreadOverview
    }), Zt.threadStore.setThreadVisible(!0), Zt.threadStore.getChatThreadDetail(((at = r == null ? void 0 : r.chatThreadOverview) == null ? void 0 : at.id) || "");
  }, $e = () => {
    w(r.mid || r.id);
  };
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    d ? /* @__PURE__ */ q.jsxs("div", { className: se, style: a, children: [
      /* @__PURE__ */ q.jsxs("div", { className: `${U}-title`, onClick: pe, children: [
        /* @__PURE__ */ q.jsx(pn, { className: `${U}-icon`, type: "TIME", width: 20, height: 20 }),
        /* @__PURE__ */ q.jsx("p", { children: C }),
        c && /* @__PURE__ */ q.jsx(
          pn,
          {
            className: `${U}-icon`,
            type: "ARROW_RIGHT",
            width: 20,
            height: 20
          }
        )
      ] }),
      c && /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
        /* @__PURE__ */ q.jsx("span", { className: `${U}-line` }),
        /* @__PURE__ */ q.jsx("div", { className: `${U}-content`, children: O })
      ] })
    ] }) : /* @__PURE__ */ q.jsx(
      Oh,
      {
        id: r.id,
        message: r,
        direction: m ? "rtl" : "ltr",
        time: E,
        nickName: u,
        bubbleType: _,
        className: h,
        onReplyMessage: k,
        onDeleteMessage: H,
        repliedMessage: S,
        reactionData: g,
        onAddReactionEmoji: B,
        onDeleteReactionEmoji: D,
        onShowReactionUserList: F,
        onRecallMessage: j,
        renderUserProfile: v,
        onSelectMessage: Le,
        onResendMessage: Te,
        select: K,
        onMessageCheckChange: Oe,
        onCreateThread: xe,
        thread: Pe,
        chatThreadOverview: r.chatThreadOverview,
        onClickThreadTitle: be,
        onPinMessage: $e,
        ...p,
        children: /* @__PURE__ */ q.jsxs("div", { className: se, style: a, children: [
          /* @__PURE__ */ q.jsxs("div", { className: `${U}-title`, onClick: pe, children: [
            /* @__PURE__ */ q.jsx(pn, { className: `${U}-icon`, type: "TIME", width: 20, height: 20 }),
            /* @__PURE__ */ q.jsx("p", { children: C }),
            c && /* @__PURE__ */ q.jsx(
              pn,
              {
                className: `${U}-icon`,
                type: "ARROW_RIGHT",
                width: 20,
                height: 20
              }
            )
          ] }),
          c && /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
            /* @__PURE__ */ q.jsx("span", { className: `${U}-line` }),
            /* @__PURE__ */ q.jsx("div", { className: `${U}-content`, children: O })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: Ce,
        title: I("chatHistory"),
        footer: "",
        onCancel: () => {
          _e(!1);
        },
        children: /* @__PURE__ */ q.jsx("div", { className: `${U}-detail`, children: ee })
      }
    )
  ] });
}, Hv = mi(cY);
Hv.displayName = "CombinedMessage";
const RN = (t) => {
  const { message: r, prefixCls: a, className: u, onlyContent: h, style: b = {} } = t, { getPrefixCls: l } = _t.useContext(Hn), v = l("message-recall", a), s = En(v, u);
  if (!(r != null && r.chatType))
    return null;
  const { t: c } = Yr(), d = { ...r, msg: c("unsupportedMessageType") };
  return /* @__PURE__ */ q.jsx(
    Dd,
    {
      style: b,
      onlyContent: h,
      customAction: { visible: !1 },
      reaction: !1,
      className: s,
      bubbleClass: s,
      textMessage: d
    }
  );
}, aAe = ["txt", "file", "img", "audio", "custom", "video", "recall"], oAe = (t) => {
  var ue, se, ee, de, he;
  const { getPrefixCls: r } = _t.useContext(Hn), {
    prefixCls: a,
    className: u,
    shape: h = "square",
    direction: b = "ltr",
    message: l,
    style: v = {}
  } = t;
  if (!l)
    return null;
  const { t: s } = Yr(), c = r("reply-message", a), [d, p] = tn(!1), m = _t.useContext(Vn), { rootStore: E, theme: y } = m;
  let g = h;
  y != null && y.bubbleShape && !h && (g = y == null ? void 0 : y.bubbleShape);
  const C = (y == null ? void 0 : y.mode) || "light", O = En(
    c,
    {
      [`${c}-${g}`]: !!g,
      [`${c}-left`]: b == "ltr",
      [`${c}-right`]: b == "rtl",
      [`${c}-${C}`]: !!C
    },
    u
  ), [N, w] = tn(), [_, I] = tn(), [k, H] = tn(), S = ar(l), B = ((ue = E.messageStore.message[l.chatType]) == null ? void 0 : ue[S]) || [];
  Pn(() => {
    if (aAe.includes(l.type)) {
      let pe = l.ext.msgQuote;
      typeof pe == "string" && (pe = JSON.parse(pe)), w(pe);
      const Ce = B.filter((_e) => _e.mid === pe.msgID || _e.id === pe.msgID);
      Ce.length > 0 ? I(Ce[0]) : I(void 0), Ce[0] && H(document.getElementById(Ce[0].id));
    }
  }, [B.length]);
  const [D, F] = tn(!1), j = (pe) => {
    fetch(pe.url).then((Ce) => Ce.blob()).then((Ce) => {
      Jw(Ce, pe.filename);
    }).catch((Ce) => !1);
  }, G = () => {
    var Ce;
    let pe;
    if (!_)
      return pe = /* @__PURE__ */ q.jsx("div", { className: `${c}-content-text-not`, children: s("messageNotFound") });
    if (_.type === "recall") {
      const _e = s("messageNotFound");
      return pe = /* @__PURE__ */ q.jsx("div", { className: `${c}-content-text-not`, children: _e });
    }
    switch (N == null ? void 0 : N.msgType) {
      case "txt":
        pe = /* @__PURE__ */ q.jsx("div", { className: `${c}-content-text`, children: Nd(N.msgPreview, "") });
        break;
      case "file":
        pe = /* @__PURE__ */ q.jsxs(
          "div",
          {
            className: `${c}-content-text`,
            style: { cursor: "pointer" },
            onClick: () => {
              j(_);
            },
            children: [
              /* @__PURE__ */ q.jsx(pn, { type: "DOC", color: "#75828A", width: 20, height: 20 }),
              /* @__PURE__ */ q.jsx("span", { children: "Attachment:" }),
              " ",
              _.filename
            ]
          }
        );
        break;
      case "audio":
        (() => {
          const _e = E.client.user == l.from, Le = { ..._, bySelf: _e };
          pe = /* @__PURE__ */ q.jsx(
            Xm,
            {
              type: "secondly",
              className: "cui-message-base-reply",
              onlyContent: !0,
              audioMessage: Le
            }
          );
        })();
        break;
      case "img":
        pe = /* @__PURE__ */ q.jsxs("div", { className: `${c}-content-text`, children: [
          /* @__PURE__ */ q.jsx("div", { className: `${c}-summary-desc-img`, children: /* @__PURE__ */ q.jsx(
            "img",
            {
              onClick: () => {
                F(!0);
              },
              height: 75,
              src: _.thumb || _.url
            }
          ) }),
          /* @__PURE__ */ q.jsx(
            oY,
            {
              visible: D,
              previewImageUrl: _.url,
              onCancel: () => {
                F(!1);
              }
            }
          )
        ] });
        break;
      case "video":
        pe = /* @__PURE__ */ q.jsx("div", { className: `${c}-content-text`, children: /* @__PURE__ */ q.jsx("div", { className: `${c}-summary-desc-img`, children: /* @__PURE__ */ q.jsx(
          "video",
          {
            onClick: () => {
              F(!0);
            },
            height: 75,
            src: _.url || _.file.url
          }
        ) }) });
        break;
      case "combine":
        pe = /* @__PURE__ */ q.jsx(
          Hv,
          {
            combinedMessage: _,
            onlyContent: !0,
            showSummary: !1,
            type: "secondly"
          }
        );
        break;
      case "loc":
        pe = //@ts-ignore
        /* @__PURE__ */ q.jsx(
          RN,
          {
            message: _,
            onlyContent: !0
          }
        );
        break;
      case "custom":
        _.customEvent === "userCard" && (pe = /* @__PURE__ */ q.jsxs("div", { className: `${c}-content-text`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "PERSON_SINGLE_FILL", color: "#75828A", width: 20, height: 20 }),
          /* @__PURE__ */ q.jsx("span", { children: "Contact:" }),
          " ",
          (Ce = _.customExts) == null ? void 0 : Ce.nickname
        ] }));
        break;
      default:
        pe = //@ts-ignore
        /* @__PURE__ */ q.jsx(
          RN,
          {
            message: _,
            onlyContent: !0
          }
        );
        break;
    }
    return pe;
  }, U = () => {
    k == null || k.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" }), k == null || k.classList.add("reply-message-twinkle"), setTimeout(() => {
      k == null || k.classList.remove("reply-message-twinkle");
    }, 1500);
  }, M = E.client.user, V = l.from === M ? s("you") : Bu(l), J = ((N == null ? void 0 : N.msgSender) === M || (N == null ? void 0 : N.msgSender) == ((se = E.addressStore.appUsersInfo[M]) == null ? void 0 : se.nickname)) && l.from == M ? s("yourself") : (N == null ? void 0 : N.msgSender) === M || (N == null ? void 0 : N.msgSender) == ((ee = E.addressStore.appUsersInfo[M]) == null ? void 0 : ee.nickname) ? s("you") : ((he = (de = E.addressStore.appUsersInfo) == null ? void 0 : de[N == null ? void 0 : N.msgSender]) == null ? void 0 : he.nickname) || (N == null ? void 0 : N.msgSender);
  return /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: O,
      style: { ...v },
      onMouseOver: () => p(!0),
      onMouseLeave: () => {
        p(!1);
      },
      children: [
        /* @__PURE__ */ q.jsxs("div", { className: `${c}-nick`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "ARROW_TURN_LEFT", width: 20, height: 20, color: "#5270AD" }),
          /* @__PURE__ */ q.jsx("span", { children: V }),
          s("repliedTo"),
          /* @__PURE__ */ q.jsx("span", { children: J })
        ] }),
        /* @__PURE__ */ q.jsxs("div", { className: `${c}-box`, children: [
          /* @__PURE__ */ q.jsx(
            "div",
            {
              className: `${c}-content`,
              style: {
                width: (_ == null ? void 0 : _.type) == "audio" ? `calc(${_.length || 0}% + 48px)` : "auto"
              },
              onClick: U,
              children: G()
            }
          ),
          d && /* @__PURE__ */ q.jsx("div", { title: s("Click to view the original message"), children: /* @__PURE__ */ q.jsx(
            pn,
            {
              className: `${c}-arrow`,
              type: "ARROW_UP_THICK",
              height: 18,
              width: 18,
              onClick: U
            }
          ) })
        ] })
      ]
    }
  );
}, U0 = 25, uY = (t) => {
  const {
    onSelected: r,
    icon: a,
    trigger: u = "click",
    onClick: h,
    selectedList: b,
    onDelete: l,
    emojiConfig: v,
    style: s = {},
    className: c,
    prefix: d,
    emojiContainerStyle: p = {},
    placement: m = "bottom",
    closeAfterClick: E = !0,
    onOpenChange: y
  } = t, { t: g } = Yr(), [C, O] = tn(!1), N = v || vm, { getPrefixCls: w } = _t.useContext(Hn), _ = w("emoji-container", d), I = En(
    _,
    // {
    //   [`${prefixCls}-${themeMode}`]: !!themeMode,
    // },
    c
  ), k = () => Object.keys(N.map).map((j) => {
    const G = N.map[j];
    let U = "text";
    return b && b.length > 0 && b.includes(j) && (U = "primary"), /* @__PURE__ */ q.jsx(gi, { type: U, style: { border: "none" }, ripple: !1, children: /* @__PURE__ */ q.jsx("div", { className: "cui-emoji-box", style: { ...p }, children: v ? typeof G == "string" ? /* @__PURE__ */ q.jsx(
      "img",
      {
        src: new URL((/* @__PURE__ */ Object.assign({ "/module/assets/reactions/U+1F308.png": lg, "/module/assets/reactions/U+1F31C.png": fg, "/module/assets/reactions/U+1F31F.png": hg, "/module/assets/reactions/U+1F381.png": pg, "/module/assets/reactions/U+1F382.png": gg, "/module/assets/reactions/U+1F389.png": mg, "/module/assets/reactions/U+1F44D.png": Eg, "/module/assets/reactions/U+1F44E.png": yg, "/module/assets/reactions/U+1F44F.png": vg, "/module/assets/reactions/U+1F47F.png": Tg, "/module/assets/reactions/U+1F48B.png": bg, "/module/assets/reactions/U+1F490.png": Ag, "/module/assets/reactions/U+1F494.png": Og, "/module/assets/reactions/U+1F495.png": Cg, "/module/assets/reactions/U+1F4A9.png": Sg, "/module/assets/reactions/U+1F600.png": Ig, "/module/assets/reactions/U+1F604.png": Rg, "/module/assets/reactions/U+1F607.png": Ng, "/module/assets/reactions/U+1F609.png": wg, "/module/assets/reactions/U+1F60D.png": _g, "/module/assets/reactions/U+1F60E.png": Pg, "/module/assets/reactions/U+1F610.png": xg, "/module/assets/reactions/U+1F618.png": Dg, "/module/assets/reactions/U+1F620.png": Mg, "/module/assets/reactions/U+1F621.png": Lg, "/module/assets/reactions/U+1F62B.png": kg, "/module/assets/reactions/U+1F62C.png": jg, "/module/assets/reactions/U+1F62D.png": Ug, "/module/assets/reactions/U+1F62E.png": Hg, "/module/assets/reactions/U+1F631.png": Bg, "/module/assets/reactions/U+1F633.png": zg, "/module/assets/reactions/U+1F637.png": Fg, "/module/assets/reactions/U+1F641.png": Gg, "/module/assets/reactions/U+1F644.png": Vg, "/module/assets/reactions/U+1F64C.png": Yg, "/module/assets/reactions/U+1F64F.png": Xg, "/module/assets/reactions/U+1F910.png": Wg, "/module/assets/reactions/U+1F912.png": qg, "/module/assets/reactions/U+1F913.png": Kg, "/module/assets/reactions/U+1F91D.png": Jg, "/module/assets/reactions/U+1F922.png": Zg, "/module/assets/reactions/U+1F928.png": Qg, "/module/assets/reactions/U+1F92A.png": $g, "/module/assets/reactions/U+1F92C.png": em, "/module/assets/reactions/U+1F971.png": tm, "/module/assets/reactions/U+1F973.png": nm, "/module/assets/reactions/U+1F974.png": rm, "/module/assets/reactions/U+1F97A.png": im, "/module/assets/reactions/U+2600.png": sm, "/module/assets/reactions/U+263A.png": am, "/module/assets/reactions/U+2764.png": om, "/module/assets/reactions/U+2B50.png": cm }))[`/module/assets/reactions/${G}`], import.meta.url).href,
        alt: j,
        width: U0,
        height: U0
      }
    ) : G : /* @__PURE__ */ q.jsx(
      "img",
      {
        src: new URL((/* @__PURE__ */ Object.assign({ "/module/assets/reactions/U+1F308.png": lg, "/module/assets/reactions/U+1F31C.png": fg, "/module/assets/reactions/U+1F31F.png": hg, "/module/assets/reactions/U+1F381.png": pg, "/module/assets/reactions/U+1F382.png": gg, "/module/assets/reactions/U+1F389.png": mg, "/module/assets/reactions/U+1F44D.png": Eg, "/module/assets/reactions/U+1F44E.png": yg, "/module/assets/reactions/U+1F44F.png": vg, "/module/assets/reactions/U+1F47F.png": Tg, "/module/assets/reactions/U+1F48B.png": bg, "/module/assets/reactions/U+1F490.png": Ag, "/module/assets/reactions/U+1F494.png": Og, "/module/assets/reactions/U+1F495.png": Cg, "/module/assets/reactions/U+1F4A9.png": Sg, "/module/assets/reactions/U+1F600.png": Ig, "/module/assets/reactions/U+1F604.png": Rg, "/module/assets/reactions/U+1F607.png": Ng, "/module/assets/reactions/U+1F609.png": wg, "/module/assets/reactions/U+1F60D.png": _g, "/module/assets/reactions/U+1F60E.png": Pg, "/module/assets/reactions/U+1F610.png": xg, "/module/assets/reactions/U+1F618.png": Dg, "/module/assets/reactions/U+1F620.png": Mg, "/module/assets/reactions/U+1F621.png": Lg, "/module/assets/reactions/U+1F62B.png": kg, "/module/assets/reactions/U+1F62C.png": jg, "/module/assets/reactions/U+1F62D.png": Ug, "/module/assets/reactions/U+1F62E.png": Hg, "/module/assets/reactions/U+1F631.png": Bg, "/module/assets/reactions/U+1F633.png": zg, "/module/assets/reactions/U+1F637.png": Fg, "/module/assets/reactions/U+1F641.png": Gg, "/module/assets/reactions/U+1F644.png": Vg, "/module/assets/reactions/U+1F64C.png": Yg, "/module/assets/reactions/U+1F64F.png": Xg, "/module/assets/reactions/U+1F910.png": Wg, "/module/assets/reactions/U+1F912.png": qg, "/module/assets/reactions/U+1F913.png": Kg, "/module/assets/reactions/U+1F91D.png": Jg, "/module/assets/reactions/U+1F922.png": Zg, "/module/assets/reactions/U+1F928.png": Qg, "/module/assets/reactions/U+1F92A.png": $g, "/module/assets/reactions/U+1F92C.png": em, "/module/assets/reactions/U+1F971.png": tm, "/module/assets/reactions/U+1F973.png": nm, "/module/assets/reactions/U+1F974.png": rm, "/module/assets/reactions/U+1F97A.png": im, "/module/assets/reactions/U+2600.png": sm, "/module/assets/reactions/U+263A.png": am, "/module/assets/reactions/U+2764.png": om, "/module/assets/reactions/U+2B50.png": cm }))[`/module/assets/reactions/${G}`], import.meta.url).href,
        alt: j,
        width: U0,
        height: U0
      }
    ) }) }, j);
  }), H = (F) => {
    F.preventDefault();
    const j = F.target.alt || F.target.children[0].alt;
    if (O(!1), b && b.length > 0 && b.includes(j))
      return l && l(j);
    r && r(j), E != !1 && y && y(!1);
  }, S = (F) => {
    h && h(F), O(!0);
  }, B = /* @__PURE__ */ q.jsx("div", { className: I, onClick: H, children: k() }), D = a ? /* @__PURE__ */ q.jsx(
    "div",
    {
      onClick: S,
      style: { display: "flex", justifyContent: "center", alignItems: "center" },
      children: a
    }
  ) : /* @__PURE__ */ q.jsx("span", { className: `${_}-iconBox`, style: { ...s }, title: g("emoji"), children: /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", children: /* @__PURE__ */ q.jsx(
    pn,
    {
      type: "FACE",
      width: 24,
      height: 24,
      onClick: S
    }
  ) }) });
  return E == !1 ? /* @__PURE__ */ q.jsx(
    va,
    {
      title: B,
      trigger: u,
      arrowPointAtCenter: !1,
      arrow: !1,
      placement: m,
      children: D
    }
  ) : /* @__PURE__ */ q.jsx(
    va,
    {
      title: B,
      trigger: u,
      arrowPointAtCenter: !1,
      arrow: !1,
      placement: m,
      onOpenChange: (F) => {
        O(!C), y && y(F);
      },
      open: C,
      children: D
    }
  );
}, dY = {
  path: "/module/assets/reactions/",
  map: {
    // 'U+1F600': 'U+1F600.png',
    // 'U+1F604': 'U+1F604.png',
    // 'U+1F609': 'U+1F609.png',
    // 'U+1F62E': 'U+1F62E.png',
    // 'U+1F92A': 'U+1F92A.png',
    // 'U+1F60E': 'U+1F60E.png',
    // 'U+1F971': 'U+1F971.png',
    // 'U+1F974': 'U+1F974.png',
    // 'U+263A': 'U+263A.png',
    // 'U+1F641': 'U+1F641.png',
    // 'U+1F62D': 'U+1F62D.png',
    // 'U+1F610': 'U+1F610.png',
    // 'U+1F607': 'U+1F607.png',
    // 'U+1F62C': 'U+1F62C.png',
    // 'U+1F913': 'U+1F913.png',
    // 'U+1F633': 'U+1F633.png',
    // 'U+1F973': 'U+1F973.png',
    // 'U+1F620': 'U+1F620.png',
    // 'U+1F644': 'U+1F644.png',
    // 'U+1F910': 'U+1F910.png',
    // 'U+1F97A': 'U+1F97A.png',
    // 'U+1F928': 'U+1F928.png',
    // 'U+1F62B': 'U+1F62B.png',
    // 'U+1F637': 'U+1F637.png',
    // 'U+1F912': 'U+1F912.png',
    // 'U+1F631': 'U+1F631.png',
    // 'U+1F618': 'U+1F618.png',
    // 'U+1F60D': 'U+1F60D.png',
    // 'U+1F922': 'U+1F922.png',
    // 'U+1F47F': 'U+1F47F.png',
    // 'U+1F92C': 'U+1F92C.png',
    // 'U+1F621': 'U+1F621.png',
    // 'U+1F44D': 'U+1F44D.png',
    // 'U+1F44E': 'U+1F44E.png',
    // 'U+1F44F': 'U+1F44F.png',
    // 'U+1F64C': 'U+1F64C.png',
    // 'U+1F91D': 'U+1F91D.png',
    // 'U+1F64F': 'U+1F64F.png',
    // 'U+2764': 'U+2764.png',
    // 'U+1F494': 'U+1F494.png',
    // 'U+1F495': 'U+1F495.png',
    // 'U+1F4A9': 'U+1F4A9.png',
    // 'U+1F48B': 'U+1F48B.png',
    // 'U+2600': 'U+2600.png',
    // 'U+1F31C': 'U+1F31C.png',
    // 'U+1F308': 'U+1F308.png',
    // 'U+2B50': 'U+2B50.png',
    // 'U+1F31F': 'U+1F31F.png',
    // 'U+1F389': 'U+1F389.png',
    // 'U+1F490': 'U+1F490.png',
    // 'U+1F382': 'U+1F382.png',
    // 'U+1F381': 'U+1F381.png',
    "😀": "U+1F600.png",
    "😄": "U+1F604.png",
    "😉": "U+1F609.png",
    "😮": "U+1F62E.png",
    "🤪": "U+1F92A.png",
    "😎": "U+1F60E.png",
    "🥱": "U+1F971.png",
    "🥴": "U+1F974.png",
    "☺️": "U+263A.png",
    "🙁": "U+1F641.png",
    "😭": "U+1F62D.png",
    "😐": "U+1F610.png",
    "😇": "U+1F607.png",
    "😬": "U+1F62C.png",
    "🤓": "U+1F913.png",
    "😳": "U+1F633.png",
    "🥳": "U+1F973.png",
    "😠": "U+1F620.png",
    "🙄": "U+1F644.png",
    "🤐": "U+1F910.png",
    "🥺": "U+1F97A.png",
    "🤨": "U+1F928.png",
    "😫": "U+1F62B.png",
    "😷": "U+1F637.png",
    "🤒": "U+1F912.png",
    "😱": "U+1F631.png",
    "😘": "U+1F618.png",
    "😍": "U+1F60D.png",
    "🤢": "U+1F922.png",
    "👿": "U+1F47F.png",
    "🤬": "U+1F92C.png",
    "😡": "U+1F621.png",
    "👍": "U+1F44D.png",
    "👎": "U+1F44E.png",
    "👏": "U+1F44F.png",
    "🙌": "U+1F64C.png",
    "🤝": "U+1F91D.png",
    "🙏": "U+1F64F.png",
    "❤️": "U+2764.png",
    "💔": "U+1F494.png",
    "💕": "U+1F495.png",
    "💩": "U+1F4A9.png",
    "💋": "U+1F48B.png",
    "☀️": "U+2600.png",
    "🌜": "U+1F31C.png",
    "🌈": "U+1F308.png",
    "⭐": "U+2B50.png",
    "🌟": "U+1F31F.png",
    "🎉": "U+1F389.png",
    "💐": "U+1F490.png",
    "🎂": "U+1F382.png",
    "🎁": "U+1F381.png"
  },
  oldMap: {
    "U+1F600": "U+1F600.png",
    "U+1F604": "U+1F604.png",
    "U+1F609": "U+1F609.png",
    "U+1F62E": "U+1F62E.png",
    "U+1F92A": "U+1F92A.png",
    "U+1F60E": "U+1F60E.png",
    "U+1F971": "U+1F971.png",
    "U+1F974": "U+1F974.png",
    "U+263A": "U+263A.png",
    "U+1F641": "U+1F641.png",
    "U+1F62D": "U+1F62D.png",
    "U+1F610": "U+1F610.png",
    "U+1F607": "U+1F607.png",
    "U+1F62C": "U+1F62C.png",
    "U+1F913": "U+1F913.png",
    "U+1F633": "U+1F633.png",
    "U+1F973": "U+1F973.png",
    "U+1F620": "U+1F620.png",
    "U+1F644": "U+1F644.png",
    "U+1F910": "U+1F910.png",
    "U+1F97A": "U+1F97A.png",
    "U+1F928": "U+1F928.png",
    "U+1F62B": "U+1F62B.png",
    "U+1F637": "U+1F637.png",
    "U+1F912": "U+1F912.png",
    "U+1F631": "U+1F631.png",
    "U+1F618": "U+1F618.png",
    "U+1F60D": "U+1F60D.png",
    "U+1F922": "U+1F922.png",
    "U+1F47F": "U+1F47F.png",
    "U+1F92C": "U+1F92C.png",
    "U+1F621": "U+1F621.png",
    "U+1F44D": "U+1F44D.png",
    "U+1F44E": "U+1F44E.png",
    "U+1F44F": "U+1F44F.png",
    "U+1F64C": "U+1F64C.png",
    "U+1F91D": "U+1F91D.png",
    "U+1F64F": "U+1F64F.png",
    "U+2764": "U+2764.png",
    "U+1F494": "U+1F494.png",
    "U+1F495": "U+1F495.png",
    "U+1F4A9": "U+1F4A9.png",
    "U+1F48B": "U+1F48B.png",
    "U+2600": "U+2600.png",
    "U+1F31C": "U+1F31C.png",
    "U+1F308": "U+1F308.png",
    "U+2B50": "U+2B50.png",
    "U+1F31F": "U+1F31F.png",
    "U+1F389": "U+1F389.png",
    "U+1F490": "U+1F490.png",
    "U+1F382": "U+1F382.png",
    "U+1F381": "U+1F381.png",
    "😀": "U+1F600.png",
    "😄": "U+1F604.png",
    "😉": "U+1F609.png",
    "😮": "U+1F62E.png",
    "🤪": "U+1F92A.png",
    "😎": "U+1F60E.png",
    "🥱": "U+1F971.png",
    "🥴": "U+1F974.png",
    "☺️": "U+263A.png",
    "🙁": "U+1F641.png",
    "😭": "U+1F62D.png",
    "😐": "U+1F610.png",
    "😇": "U+1F607.png",
    "😬": "U+1F62C.png",
    "🤓": "U+1F913.png",
    "😳": "U+1F633.png",
    "🥳": "U+1F973.png",
    "😠": "U+1F620.png",
    "🙄": "U+1F644.png",
    "🤐": "U+1F910.png",
    "🥺": "U+1F97A.png",
    "🤨": "U+1F928.png",
    "😫": "U+1F62B.png",
    "😷": "U+1F637.png",
    "🤒": "U+1F912.png",
    "😱": "U+1F631.png",
    "😘": "U+1F618.png",
    "😍": "U+1F60D.png",
    "🤢": "U+1F922.png",
    "👿": "U+1F47F.png",
    "🤬": "U+1F92C.png",
    "😡": "U+1F621.png",
    "👍": "U+1F44D.png",
    "👎": "U+1F44E.png",
    "👏": "U+1F44F.png",
    "🙌": "U+1F64C.png",
    "🤝": "U+1F91D.png",
    "🙏": "U+1F64F.png",
    "❤️": "U+2764.png",
    "💔": "U+1F494.png",
    "💕": "U+1F495.png",
    "💩": "U+1F4A9.png",
    "💋": "U+1F48B.png",
    "☀️": "U+2600.png",
    "🌜": "U+1F31C.png",
    "🌈": "U+1F308.png",
    "⭐": "U+2B50.png",
    "🌟": "U+1F31F.png",
    "🎉": "U+1F389.png",
    "💐": "U+1F490.png",
    "🎂": "U+1F382.png",
    "🎁": "U+1F381.png"
  }
}, lY = (t) => {
  const {
    onSelected: r,
    selectedList: a,
    onDelete: u,
    prefixCls: h,
    reactionConfig: b,
    placement: l,
    onClick: v,
    onOpenChange: s
  } = t, c = Zn(Vn), { reactionConfig: d } = c, { getPrefixCls: p } = _t.useContext(Hn), m = p("reaction-icon", h), E = (C) => {
    r == null || r(C);
  }, y = (C) => {
    u == null || u(C);
  }, g = En(m);
  return /* @__PURE__ */ q.jsx(
    uY,
    {
      emojiConfig: b || d || dY,
      selectedList: a,
      onSelected: E,
      onDelete: y,
      icon: /* @__PURE__ */ q.jsx(pn, { type: "FACE_PLUS", width: 20, height: 20, className: g }),
      placement: l,
      onClick: (C) => {
        v == null || v(C);
      },
      onOpenChange: (C) => {
        s == null || s(C);
      }
    }
  );
};
let OH;
const CH = 18, cAe = (t) => {
  const { getPrefixCls: r } = _t.useContext(Hn), {
    className: a,
    prefixCls: u,
    reaction: h,
    count: b,
    isAddedBySelf: l,
    userList: v,
    onClick: s,
    onDelete: c,
    onShowUserList: d,
    emojiConfig: p
  } = t, m = r("reaction-btn", u), E = Zn(Vn), { rootStore: y, theme: g } = E, C = (g == null ? void 0 : g.mode) || "light", O = y.client.user, { appUsersInfo: N } = y.addressStore, w = dY.oldMap[h], _ = En(
    m,
    {
      [`${m}-checked`]: l,
      [`${m}-${C}`]: !!C
    },
    a
  ), I = () => {
    OH = setTimeout(() => {
      F(!0);
    }, 1e3);
  }, k = () => {
    clearTimeout(OH);
  }, H = () => {
    c == null || c(h);
  }, S = () => /* @__PURE__ */ q.jsx("ul", { className: `${m}-userList`, children: v.map((j) => {
    var G, U, M;
    return /* @__PURE__ */ q.jsxs("li", { className: C == "dark" ? "cui-li-dark" : "", children: [
      /* @__PURE__ */ q.jsx(zs, { src: (G = N[j]) == null ? void 0 : G.avatarurl, size: 24, children: ((U = N[j]) == null ? void 0 : U.nickname) || j }),
      /* @__PURE__ */ q.jsx("span", { className: `${m}-userList-name`, children: ((M = N[j]) == null ? void 0 : M.nickname) || j }),
      O == j && /* @__PURE__ */ q.jsx(
        pn,
        {
          type: "CROSS",
          onClick: H,
          className: `${m}-userList-close`
        }
      )
    ] }, j);
  }) }), B = () => {
    l ? c == null || c(h) : s == null || s(h);
  }, [D, F] = tn(!1);
  return v.length === 0 ? null : /* @__PURE__ */ q.jsx(
    va,
    {
      title: S(),
      trigger: "hover",
      arrowPointAtCenter: !1,
      arrow: !1,
      onOpenChange: (j) => {
        j ? d == null || d(h) : F(!1);
      },
      open: D,
      children: /* @__PURE__ */ q.jsxs(
        "button",
        {
          className: _,
          onMouseLeave: k,
          onMouseEnter: I,
          onClick: B,
          children: [
            p ? p.map[h] : /* @__PURE__ */ q.jsx(
              "img",
              {
                src: new URL((/* @__PURE__ */ Object.assign({ "/module/assets/reactions/U+1F308.png": lg, "/module/assets/reactions/U+1F31C.png": fg, "/module/assets/reactions/U+1F31F.png": hg, "/module/assets/reactions/U+1F381.png": pg, "/module/assets/reactions/U+1F382.png": gg, "/module/assets/reactions/U+1F389.png": mg, "/module/assets/reactions/U+1F44D.png": Eg, "/module/assets/reactions/U+1F44E.png": yg, "/module/assets/reactions/U+1F44F.png": vg, "/module/assets/reactions/U+1F47F.png": Tg, "/module/assets/reactions/U+1F48B.png": bg, "/module/assets/reactions/U+1F490.png": Ag, "/module/assets/reactions/U+1F494.png": Og, "/module/assets/reactions/U+1F495.png": Cg, "/module/assets/reactions/U+1F4A9.png": Sg, "/module/assets/reactions/U+1F600.png": Ig, "/module/assets/reactions/U+1F604.png": Rg, "/module/assets/reactions/U+1F607.png": Ng, "/module/assets/reactions/U+1F609.png": wg, "/module/assets/reactions/U+1F60D.png": _g, "/module/assets/reactions/U+1F60E.png": Pg, "/module/assets/reactions/U+1F610.png": xg, "/module/assets/reactions/U+1F618.png": Dg, "/module/assets/reactions/U+1F620.png": Mg, "/module/assets/reactions/U+1F621.png": Lg, "/module/assets/reactions/U+1F62B.png": kg, "/module/assets/reactions/U+1F62C.png": jg, "/module/assets/reactions/U+1F62D.png": Ug, "/module/assets/reactions/U+1F62E.png": Hg, "/module/assets/reactions/U+1F631.png": Bg, "/module/assets/reactions/U+1F633.png": zg, "/module/assets/reactions/U+1F637.png": Fg, "/module/assets/reactions/U+1F641.png": Gg, "/module/assets/reactions/U+1F644.png": Vg, "/module/assets/reactions/U+1F64C.png": Yg, "/module/assets/reactions/U+1F64F.png": Xg, "/module/assets/reactions/U+1F910.png": Wg, "/module/assets/reactions/U+1F912.png": qg, "/module/assets/reactions/U+1F913.png": Kg, "/module/assets/reactions/U+1F91D.png": Jg, "/module/assets/reactions/U+1F922.png": Zg, "/module/assets/reactions/U+1F928.png": Qg, "/module/assets/reactions/U+1F92A.png": $g, "/module/assets/reactions/U+1F92C.png": em, "/module/assets/reactions/U+1F971.png": tm, "/module/assets/reactions/U+1F973.png": nm, "/module/assets/reactions/U+1F974.png": rm, "/module/assets/reactions/U+1F97A.png": im, "/module/assets/reactions/U+2600.png": sm, "/module/assets/reactions/U+263A.png": am, "/module/assets/reactions/U+2764.png": om, "/module/assets/reactions/U+2B50.png": cm }))[`/module/assets/reactions/${w}`], import.meta.url).href,
                width: CH,
                height: CH
              }
            ),
            /* @__PURE__ */ q.jsx("span", { className: `${m}-count`, children: b })
          ]
        }
      )
    }
  );
}, uAe = (t) => {
  const {
    onSelected: r,
    icon: a,
    trigger: u = "click",
    onClick: h,
    reactionData: b,
    onDelete: l,
    prefixCls: v,
    className: s,
    style: c,
    direction: d = "ltr",
    onShowUserList: p,
    reactionConfig: m
  } = t, E = Zn(Vn), { reactionConfig: y } = E, { getPrefixCls: g } = _t.useContext(Hn), C = g("reaction-box", v), O = En(
    C,
    {
      [`${C}-left`]: d == "ltr",
      [`${C}-right`]: d == "rtl"
    },
    s
  ), [N, w] = tn(!1), _ = (S) => {
    h && h(S);
  }, I = (S) => {
    l && l(S);
  }, k = (S) => {
    p && p(S);
  }, H = [];
  return b && b.forEach((S) => {
    S.isAddedBySelf && H.push(S.reaction);
  }), /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: O,
      style: { ...c },
      onMouseOver: () => {
        w(!0);
      },
      onMouseLeave: () => {
        w(!1);
      },
      children: [
        b.map((S, B) => /* @__PURE__ */ q.jsx(
          cAe,
          {
            emojiConfig: m || y,
            count: S.count,
            reaction: S.reaction,
            isAddedBySelf: S.isAddedBySelf || !1,
            userList: S.userList,
            onClick: _,
            onDelete: I,
            onShowUserList: k
          },
          S.reaction + B
        )),
        N && /* @__PURE__ */ q.jsx(
          lY,
          {
            onSelected: _,
            selectedList: H,
            onDelete: I
          }
        )
      ]
    }
  );
}, Bv = Gu(
  ({
    id: t,
    checked: r,
    defaultChecked: a = !1,
    disabled: u = !1,
    children: h,
    className: b,
    onChange: l,
    shape: v = "round",
    prefix: s,
    style: c = {}
  }, d) => {
    const { getPrefixCls: p } = _t.useContext(Hn), m = p("checkbox", s), E = En(
      m,
      {
        [`${m}-round`]: v == "round"
      },
      b
    ), [y, g] = tn(r || !1), C = (N) => {
      l == null || l(N);
    };
    let O = a || y;
    return r != null && (O = r), /* @__PURE__ */ q.jsxs("label", { className: `${m}-wrapper`, style: { ...c }, htmlFor: t, children: [
      /* @__PURE__ */ q.jsxs("span", { className: E, children: [
        /* @__PURE__ */ q.jsx(
          "input",
          {
            ref: d,
            disabled: u,
            id: t,
            type: "checkbox",
            checked: O,
            onClick: () => {
              typeof r < "u" || u || g(!y);
            },
            onChange: C
          }
        ),
        /* @__PURE__ */ q.jsx("span", { className: En(`${m}--mark`, u ? "disabled" : "") })
      ] }),
      h !== void 0 && /* @__PURE__ */ q.jsx("span", { children: h })
    ] });
  }
);
Bv.displayName = "Checkbox";
const dAe = (t) => {
  var k;
  const { prefix: r, className: a, style: u, userId: h } = t, { addressStore: b } = gr(), { getPrefixCls: l } = _t.useContext(Hn), v = l("user-profile", r), s = En(v, a), { avatarurl: c, nickname: d, isOnline: p } = ((k = b.appUsersInfo) == null ? void 0 : k[h]) || {}, { t: m } = Yr(), { conversationStore: E } = Zt, y = _t.useContext(Vn), { initConfig: g } = y, { useUserInfo: C } = g;
  Pn(() => {
    var H;
    !((H = b.appUsersInfo) != null && H[h]) && C && xd({
      userIdList: [h]
    }).catch((S) => {
      console.warn("get getUsersInfo failed", S);
    });
  }, []);
  const O = b.contacts.some((H) => H.userId === h), N = () => {
    E.addConversation({
      chatType: "singleChat",
      conversationId: h,
      name: d,
      lastMessage: {
        time: Date.now(),
        type: "txt",
        msg: "",
        id: "",
        chatType: "singleChat",
        to: h
      },
      unreadCount: 0
    }), E.setCurrentCvs({
      chatType: "singleChat",
      conversationId: h,
      name: d
    });
  }, w = () => {
    I(!0), b.acceptContactInvite(h);
  }, [_, I] = tn(!1);
  return /* @__PURE__ */ q.jsxs("div", { className: s, style: u, children: [
    /* @__PURE__ */ q.jsx(zs, { size: 80, isOnline: p, src: c, children: h }),
    /* @__PURE__ */ q.jsx("div", { className: `${v}-nick`, children: d }),
    /* @__PURE__ */ q.jsxs("div", { className: `${v}-id`, children: [
      m("user"),
      " ID: ",
      h
    ] }),
    O ? /* @__PURE__ */ q.jsx(gi, { type: "primary", className: `${v}-action-btn`, onClick: N, children: /* @__PURE__ */ q.jsxs("div", { className: `${v}-action`, children: [
      /* @__PURE__ */ q.jsx(pn, { type: "BUBBLE_FILL", width: 24, height: 24 }),
      m("message")
    ] }) }) : h == Zt.client.user ? null : /* @__PURE__ */ q.jsx(
      gi,
      {
        type: "primary",
        className: `${v}-action-btn`,
        onClick: w,
        disabled: _,
        children: /* @__PURE__ */ q.jsxs("div", { className: `${v}-action`, children: [
          /* @__PURE__ */ q.jsx(pn, { type: "BUBBLE_FILL", width: 24, height: 24 }),
          m("addContact")
        ] })
      }
    )
  ] });
}, fY = mi(dAe);
fY.displayName = "UserProfile";
const lAe = (t) => (t == null ? void 0 : t.from) === gr().client.user || (t == null ? void 0 : t.from) === "", fAe = (t) => {
  var r;
  if (t.chatType === "groupChat") {
    const a = jd(t.to);
    if (a)
      return (r = a.admins) == null ? void 0 : r.includes(gr().client.user);
  }
}, hAe = (t) => {
  var r, a;
  if (t.chatType === "groupChat") {
    const u = jd(t.to);
    if (u)
      return ((a = (r = u.members) == null ? void 0 : r.find((h) => h.role === "owner")) == null ? void 0 : a.userId) === gr().client.user;
  }
};
let NN = (t) => {
  var Ye, ne, Qe, W;
  const {
    message: r,
    avatar: a,
    avatarShape: u = "circle",
    showAvatar: h = !0,
    showMessageInfo: b = !0,
    direction: l = "ltr",
    status: v = "default",
    prefix: s,
    className: c,
    bubbleType: d = "primary",
    style: p,
    bubbleStyle: m,
    time: E,
    nickName: y,
    shape: g = "round",
    arrow: C,
    hasRepliedMsg: O = !1,
    onReplyMessage: N,
    repliedMessage: w,
    onDeleteMessage: _,
    id: I,
    reactionData: k,
    onAddReactionEmoji: H,
    onDeleteReactionEmoji: S,
    onShowReactionUserList: B,
    onRecallMessage: D,
    customAction: F,
    reaction: j = !0,
    onTranslateMessage: G,
    onModifyMessage: U,
    onSelectMessage: M,
    onResendMessage: V,
    onForwardMessage: J,
    onReportMessage: ue,
    onPinMessage: se,
    onMessageCheckChange: ee,
    renderUserProfile: de,
    onCreateThread: he,
    select: pe = !1,
    thread: Ce = !0,
    messageStatus: _e = !0,
    showNicknamesForAllMessages: Le = !1,
    chatThreadOverview: Te,
    onClickThreadTitle: K,
    reactionConfig: Oe,
    formatDateTime: Pe
  } = t, { t: xe } = Yr(), { getPrefixCls: be } = _t.useContext(Hn), $e = Zn(Vn), { theme: Be } = $e, Ke = (Be == null ? void 0 : Be.mode) || "light", Ze = be("message-base", s);
  let at = a;
  const { appUsersInfo: pt, groups: It } = gr().addressStore, Rt = y || r && Bu(r), gt = (r == null ? void 0 : r.from) || "";
  if (a)
    at = a;
  else {
    let ce = u;
    Be != null && Be.avatarShape && (ce = Be == null ? void 0 : Be.avatarShape), at = /* @__PURE__ */ q.jsx(zs, { src: (Ye = pt == null ? void 0 : pt[gt]) == null ? void 0 : Ye.avatarurl, shape: ce, size: 24, children: ((ne = pt == null ? void 0 : pt[gt]) == null ? void 0 : ne.nickname) || gt });
  }
  let it = g, Tt = C;
  Be != null && Be.bubbleShape && (it = Be == null ? void 0 : Be.bubbleShape), it == "square" && typeof C > "u" && (Tt = !0), ((r == null ? void 0 : r.type) == "video" || (r == null ? void 0 : r.type) == "img") && (Tt = !1);
  const Ut = typeof w == "object" && typeof w.type == "string", st = En(
    Ze,
    {
      [`${Ze}-left`]: l == "ltr",
      [`${Ze}-right`]: l == "rtl",
      [`${Ze}-hasAvatar`]: !!a,
      [`${Ze}-${d}`]: !!d,
      [`${Ze}-${it}`]: !!it,
      [`${Ze}-arrow`]: !!Tt,
      [`${Ze}-reply`]: Ut && it === "round",
      [`${Ze}-${Ke}`]: !!Ke
    },
    c
  ), Ot = d !== "none", kt = de == null ? void 0 : de({ userId: (r == null ? void 0 : r.from) || "" }), [wt, Et] = tn(!1), [ut, St] = tn(!1), [Ft, Ht] = tn(!1), zt = () => {
    K == null || K();
  }, ze = () => {
    var bt, ot, Lt;
    const { name: ce, messageCount: fe = 0, lastMessage: we = {} } = Te || {}, { from: Fe, type: je, time: qe } = we || {};
    let et = "";
    switch (je) {
      case "txt":
        et = we.msg;
        break;
      case "img":
        et = "[图片]";
        break;
      case "file":
        et = "[文件]";
        break;
      case "audio":
        et = "[语音]";
        break;
      case "video":
        et = "[视频]";
        break;
      case "custom":
        et = "[自定义消息]";
        break;
      case "combine":
        et = "[合并消息]";
        break;
      default:
        et = "";
        break;
    }
    return /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-thread`, children: [
      /* @__PURE__ */ q.jsx("span", { className: `${Ze}-thread-line` }),
      /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-thread-name`, onClick: zt, children: [
        /* @__PURE__ */ q.jsxs("div", { children: [
          /* @__PURE__ */ q.jsx(
            pn,
            {
              width: 20,
              height: 20,
              type: "THREAD",
              className: `${Ze}-thread-name-icon`
            }
          ),
          /* @__PURE__ */ q.jsx("span", { children: ce })
        ] }),
        /* @__PURE__ */ q.jsxs("div", { children: [
          /* @__PURE__ */ q.jsx("span", { children: fe > 100 ? "100 +" : fe }),
          /* @__PURE__ */ q.jsx(
            pn,
            {
              width: 16,
              height: 16,
              type: "ARROW_RIGHT",
              className: `${Ze}-thread-name-icon`
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-thread-message`, children: [
        et && /* @__PURE__ */ q.jsx(zs, { size: 16, src: (bt = pt == null ? void 0 : pt[Fe]) == null ? void 0 : bt.avatarurl, children: ((ot = pt == null ? void 0 : pt[Fe]) == null ? void 0 : ot.nickname) || Fe }),
        /* @__PURE__ */ q.jsx("span", { children: ((Lt = pt[Fe]) == null ? void 0 : Lt.nickname) || Fe }),
        /* @__PURE__ */ q.jsx("span", { children: et }),
        /* @__PURE__ */ q.jsx("span", { children: (Pe == null ? void 0 : Pe(qe)) || Tm(qe) })
      ] })
    ] });
  }, Ne = Ot ? /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-content`, style: m, children: [
    t.children,
    Ce && Te && ze()
  ] }) : Vl(t.children, (ce) => ({
    style: {
      width: "100%",
      ...ce.style
    }
  }));
  let le = { visible: !1 };
  F ? le = F : le = {
    visible: !0,
    icon: null,
    actions: [
      {
        content: "REPLY",
        onClick: () => {
        }
      },
      {
        content: "DELETE",
        onClick: () => {
        }
      },
      {
        content: "UNSEND",
        onClick: () => {
        }
      },
      {
        content: "TRANSLATE",
        onClick: () => {
        }
      },
      {
        content: "Modify",
        onClick: () => {
        }
      },
      {
        content: "SELECT",
        onClick: () => {
        }
      },
      {
        content: "FORWARD",
        onClick: () => {
        }
      },
      {
        content: "REPORT",
        onClick: () => {
        }
      },
      {
        content: "PIN",
        onClick: () => {
        }
      }
    ]
  }, v == "failed" && (le = {
    visible: !0,
    icon: null,
    actions: [
      {
        content: "RESEND",
        onClick: () => {
        }
      },
      {
        content: "DELETE",
        onClick: () => {
        }
      }
    ]
  });
  const X = be("moreAction", s), re = r && lAe(r);
  r && hAe(r), r && fAe(r);
  const Me = () => {
    St(!1), N && N();
  }, Se = () => {
    St(!1), _ && _(r);
  }, ke = () => {
    St(!1), D && D(r);
  }, Ge = () => {
    St(!1), G && G();
  }, nt = () => {
    St(!1), U && U();
  }, rt = () => {
    St(!1), M && M();
  }, dt = () => {
    St(!1), V && V();
  }, lt = () => {
    St(!1), J && J(r);
  }, Ct = () => {
    St(!1), ue && ue(r);
  }, Ie = () => {
    St(!1), se && se();
  };
  let x;
  le != null && le.visible && (x = /* @__PURE__ */ q.jsx("ul", { className: X, children: (Qe = le == null ? void 0 : le.actions) == null ? void 0 : Qe.map((ce, fe) => ce.content === "DELETE" && ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: Se,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "DELETE", width: 16, height: 16 }),
        xe("delete")
      ]
    },
    fe
  ) : ce.content === "REPLY" && ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: Me,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "ARROW_TURN_LEFT", width: 16, height: 16 }),
        xe("reply")
      ]
    },
    fe
  ) : ce.content === "UNSEND" && ce.visible !== !1 ? re && /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: ke,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "ARROW_BACK", width: 16, height: 16 }),
        xe("unsend")
      ]
    },
    fe
  ) : ce.content === "TRANSLATE" && ce.visible !== !1 ? (r == null ? void 0 : r.type) === "txt" && /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: Ge,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "TRANSLATION", width: 16, height: 16 }),
        xe("translate")
      ]
    },
    fe
  ) : ce.content === "Modify" && ce.visible !== !1 ? re && (r == null ? void 0 : r.type) === "txt" && /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: nt,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "MODIFY_MESSAGE", width: 16, height: 16 }),
        xe("modify")
      ]
    },
    fe
  ) : ce.content === "SELECT" && ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: rt,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "SELECT", width: 16, height: 16 }),
        xe("select")
      ]
    },
    fe
  ) : ce.content === "RESEND" && ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: dt,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "LOOP", width: 16, height: 16 }),
        xe("resend")
      ]
    },
    fe
  ) : ce.content === "FORWARD" && ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: lt,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "ARROW_TURN_RIGHT", width: 16, height: 16 }),
        xe("forward")
      ]
    },
    fe
  ) : ce.content === "REPORT" && ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: Ct,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        ce.icon ? ce.icon : /* @__PURE__ */ q.jsx(pn, { type: "ENVELOPE", width: 16, height: 16 }),
        xe("report")
      ]
    },
    fe
  ) : ce.content === "PIN" ? !(r != null && r.chatThread) && /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: Ie,
      className: Ke == "dark" ? "cui-li-dark" : "",
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: "PIN", width: 16, height: 16 }),
        xe("Pin")
      ]
    },
    fe
  ) : ce.visible !== !1 ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      className: Ke == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        var we;
        (we = ce.onClick) == null || we.call(ce, r);
      },
      children: [
        ce.icon && ce.icon,
        ce.content
      ]
    },
    fe
  ) : null) }));
  let ae = !1;
  (r == null ? void 0 : r.type) === "txt" && ((W = r == null ? void 0 : r.ext) == null ? void 0 : W.msgType) === "rtcCallWithAgora" && (ae = !0);
  const Q = (ce) => {
    H && H(ce);
  }, Z = (ce) => {
    S && S(ce);
  }, ge = (ce) => {
    B && B(ce);
  }, me = [];
  k && k.forEach((ce) => {
    ce.isAddedBySelf && me.push(ce.reaction);
  });
  const ve = (ce) => {
    const fe = ce.target.checked;
    ee == null || ee(fe);
  }, ie = () => {
    he == null || he();
  }, ye = er(null);
  return /* @__PURE__ */ q.jsxs("div", { children: [
    /* @__PURE__ */ q.jsxs("div", { className: "thread-container", children: [
      pe && /* @__PURE__ */ q.jsx(
        Bv,
        {
          ref: ye,
          shape: g,
          className: "checkbox",
          onChange: ve
        }
      ),
      /* @__PURE__ */ q.jsxs(
        "div",
        {
          id: I,
          className: st,
          style: { ...p, paddingLeft: pe ? "38px" : "" },
          onMouseOver: () => {
            Et(!0);
          },
          onMouseLeave: () => {
            !ut && !Ft && Et(!1);
          },
          children: [
            /* @__PURE__ */ q.jsx(q.Fragment, { children: h ? de && !kt ? /* @__PURE__ */ q.jsx(q.Fragment, { children: at }) : /* @__PURE__ */ q.jsx(
              va,
              {
                title: kt || /* @__PURE__ */ q.jsx(fY, { userId: (r == null ? void 0 : r.from) || "" }),
                trigger: "click",
                placement: "topLeft",
                children: at
              }
            ) : /* @__PURE__ */ q.jsx(q.Fragment, {}) }),
            /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-box`, children: [
              /* @__PURE__ */ q.jsx(q.Fragment, { children: b ? Ut ? /* @__PURE__ */ q.jsx(
                oAe,
                {
                  message: w,
                  shape: it,
                  direction: l
                }
              ) : /* @__PURE__ */ q.jsx("div", { className: `${Ze}-info`, children: ((r == null ? void 0 : r.chatType) !== "singleChat" && !re || Le) && /* @__PURE__ */ q.jsx("span", { className: `${Ze}-nickname`, children: Rt }) }) : /* @__PURE__ */ q.jsx(q.Fragment, {}) }),
              /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-body`, children: [
                Ne,
                wt && le.visible && !pe && !ae ? /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
                  le.visible && /* @__PURE__ */ q.jsx(
                    va,
                    {
                      open: ut,
                      onOpenChange: (ce) => {
                        St(ce), Et(ce);
                      },
                      title: x,
                      trigger: "click",
                      placement: re ? "bottomRight" : "bottomLeft",
                      children: le.icon || /* @__PURE__ */ q.jsx(
                        pn,
                        {
                          type: "ELLIPSIS",
                          className: `${Ze}-body-action`,
                          height: 20,
                          width: 20
                        }
                      )
                    }
                  ),
                  j && v != "failed" && /* @__PURE__ */ q.jsx(
                    lY,
                    {
                      reactionConfig: Oe,
                      onSelected: Q,
                      selectedList: me,
                      onDelete: Z,
                      placement: re ? "bottomRight" : "bottomLeft",
                      onClick: (ce) => {
                        Ht(!0);
                      },
                      onOpenChange: (ce) => {
                        Ht(ce), Et(ce);
                      }
                    }
                  ),
                  Ce && !Te && v != "failed" && /* @__PURE__ */ q.jsx(
                    pn,
                    {
                      type: "THREAD",
                      onClick: ie,
                      className: `${Ze}-body-action`,
                      height: 20,
                      width: 20
                    }
                  )
                ] }) : b ? /* @__PURE__ */ q.jsxs("div", { className: `${Ze}-time-and-status-box`, children: [
                  _e && !ae && /* @__PURE__ */ q.jsx(Lde, { status: v, type: "icon" }),
                  /* @__PURE__ */ q.jsx("span", { className: `${Ze}-time`, children: (Pe == null ? void 0 : Pe(E)) || Tm(E) })
                ] }) : /* @__PURE__ */ q.jsx(q.Fragment, {})
              ] })
            ] })
          ]
        }
      )
    ] }),
    k && j && /* @__PURE__ */ q.jsx(
      uAe,
      {
        reactionConfig: Oe,
        direction: l,
        reactionData: k,
        onClick: Q,
        onDelete: Z,
        onShowUserList: ge,
        style: { padding: Tt ? "0 64px" : "0 60px" }
      }
    )
  ] });
};
NN = mi(NN);
const Oh = NN, SH = (t) => {
  const { play: r = !1, reverse: a = !1, size: u = 16, prefix: h, className: b } = t, { getPrefixCls: l } = _t.useContext(Hn), v = l("message-audio-player", h), s = En(
    v,
    {
      [`${v}-play`]: !!r,
      [`${v}-reverse`]: !!a
    },
    b
  ), c = {
    width: typeof u == "string" ? u : `${u}px`,
    height: typeof u == "string" ? u : `${u}px`
  };
  return /* @__PURE__ */ q.jsxs("div", { className: s, style: { ...c }, children: [
    /* @__PURE__ */ q.jsx(pn, { type: "WAVE1", height: u, width: u }),
    /* @__PURE__ */ q.jsx(pn, { type: "WAVE2", height: u, width: u }),
    /* @__PURE__ */ q.jsx(pn, { type: "WAVE3", height: u, width: u })
  ] });
}, pAe = (t) => {
  var Ke;
  const [r, a] = tn(!1), {
    audioMessage: u,
    style: h,
    prefix: b,
    className: l,
    type: v,
    // renderUserProfile,
    // nickName,
    thread: s,
    onlyContent: c = !1,
    bubbleClass: d,
    ...p
  } = t, m = er(null), {
    url: E,
    file_length: y,
    length: g,
    file: C,
    time: O,
    from: N,
    status: w,
    reactions: _
  } = u, { getPrefixCls: I } = _t.useContext(Hn), k = I("message-audio", b), H = _t.useContext(Vn), { theme: S } = H, B = S == null ? void 0 : S.mode;
  let { bySelf: D } = u;
  typeof D > "u" && (D = N == Zt.client.context.userId);
  const F = v || (D ? "primary" : "secondly"), { pinMessage: j } = Rc({
    conversation: {
      conversationId: ar(u),
      conversationType: u.chatType
    }
  }), G = En(
    k,
    {
      [`${k}-${F}`]: !!F,
      [`${k}-${B}`]: !!B
    },
    l
  ), [U, M] = tn("");
  Pn(() => {
    if (!u.url) return;
    const Ze = {
      url: u.url,
      headers: {
        Accept: "audio/mp3"
      },
      onFileDownloadComplete: function(at) {
        const pt = Zs.utils.parseDownloadResponse.call(Zt.client, at);
        M(pt);
      },
      onFileDownloadError: function() {
      }
    };
    Zs.utils.download.call(Zt.client, Ze);
  }, [u.url]);
  const V = () => {
    a(!0), console.log("audioRef", m.current), m.current.play().catch((Ze) => {
      console.error("err", Ze), a(!1);
    }), u.chatType == "singleChat" && u.from != Zt.client.context.userId && u.status != "read" && !u.isChatThread && u.to == Zt.client.context.userId && Zt.messageStore.sendReadAck(u.id, u.from);
  }, J = () => {
    a(!1);
  }, ue = Number.isInteger(g) ? g : C.duration || 0, se = {
    width: `calc(${ue}% + 40px)`,
    maxWidth: "calc(100% - 128px)"
  }, ee = () => {
    Zt.messageStore.setRepliedMessage(u);
  }, de = () => {
    const Ze = ar(u);
    Zt.messageStore.deleteMessage(
      {
        chatType: u.chatType,
        conversationId: Ze
      },
      // @ts-ignore
      u.mid || u.id
    );
  }, he = () => {
    j(u.mid || u.id);
  }, pe = (Ze) => {
    const at = ar(u);
    Zt.messageStore.addReaction(
      {
        chatType: u.chatType,
        conversationId: at
      },
      // @ts-ignore
      u.mid || u.id,
      Ze
    );
  }, Ce = (Ze) => {
    const at = ar(u);
    Zt.messageStore.deleteReaction(
      {
        chatType: u.chatType,
        conversationId: at
      },
      // @ts-ignore
      u.mid || u.id,
      Ze
    );
  }, _e = (Ze) => {
    const at = ar(u);
    _ == null || _.forEach((pt) => {
      if (pt.reaction === Ze && (pt.count > 3 && pt.userList.length <= 3 && Zt.messageStore.getReactionUserList(
        {
          chatType: u.chatType,
          conversationId: at
        },
        // @ts-ignore
        textMessage.mid || textMessage.id,
        Ze
      ), pt.isAddedBySelf)) {
        const It = pt.userList.indexOf(Zt.client.user);
        if (It > -1) {
          const Rt = pt.userList.splice(It, 1)[0];
          pt.userList.unshift(Rt);
        } else
          pt.userList.unshift(Zt.client.user);
      }
    });
  }, Le = () => {
    const Ze = ar(u);
    Zt.messageStore.recallMessage(
      {
        chatType: u.chatType,
        conversationId: Ze
      },
      // @ts-ignore
      u.mid || u.id,
      u.isChatThread,
      !0
    );
  }, Te = ar(u), K = () => {
    var at;
    // @ts-ignore
    (at = Zt.messageStore.selectedMessage[u.chatType][Te]) != null && at.selectable || Zt.messageStore.setSelectedMessage(
      {
        chatType: u.chatType,
        conversationId: Te
      },
      {
        selectable: !0,
        selectedMessage: []
      }
    );
  }, Oe = () => {
    Zt.messageStore.sendMessage(u);
  }, Pe = (
    // @ts-ignore
    (Ke = Zt.messageStore.selectedMessage[u.chatType][Te]) == null ? void 0 : Ke.selectable
  ), xe = (Ze) => {
    var It;
    const at = (
      // @ts-ignore
      (It = Zt.messageStore.selectedMessage[u.chatType][Te]) == null ? void 0 : It.selectedMessage
    );
    let pt = at;
    Ze ? pt.push(u) : pt = at.filter((Rt) => !(Rt.id == u.id || Rt.mid == u.id)), Zt.messageStore.setSelectedMessage(
      {
        chatType: u.chatType,
        conversationId: Te
      },
      {
        selectable: !0,
        selectedMessage: pt
      }
    );
  }, be = (
    // @ts-ignore
    u.chatType == "groupChat" && s && // @ts-ignore
    !u.chatThread && !u.isChatThread
  ), $e = () => {
    Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !0,
      originalMessage: u
    }), Zt.threadStore.setThreadVisible(!0);
  }, Be = () => {
    var Ze, at;
    Zt.threadStore.joinChatThread(((Ze = u.chatThreadOverview) == null ? void 0 : Ze.id) || ""), Zt.threadStore.setCurrentThread({
      visible: !0,
      creating: !1,
      originalMessage: u,
      info: u.chatThreadOverview
    }), Zt.threadStore.setThreadVisible(!0), Zt.threadStore.getChatThreadDetail(((at = u == null ? void 0 : u.chatThreadOverview) == null ? void 0 : at.id) || "");
  };
  return /* @__PURE__ */ q.jsx(q.Fragment, { children: c ? /* @__PURE__ */ q.jsxs("div", { className: G, onClick: V, style: { ...h, width: "100%" }, children: [
    /* @__PURE__ */ q.jsx(SH, { play: r, reverse: D, size: 20 }),
    /* @__PURE__ */ q.jsx("span", { className: `${k}-duration`, children: ue + '"' || 0 }),
    /* @__PURE__ */ q.jsx(
      "audio",
      {
        src: U,
        ref: m,
        onEnded: J,
        onError: J,
        onStalled: J
      }
    )
  ] }) : /* @__PURE__ */ q.jsx(
    Oh,
    {
      id: u.id,
      className: d,
      direction: D ? "rtl" : "ltr",
      message: u,
      time: O,
      status: w,
      bubbleType: F,
      onReplyMessage: ee,
      onDeleteMessage: de,
      onPinMessage: he,
      reactionData: _,
      onAddReactionEmoji: pe,
      onDeleteReactionEmoji: Ce,
      onShowReactionUserList: _e,
      onRecallMessage: Le,
      onSelectMessage: K,
      onResendMessage: Oe,
      select: Pe,
      onMessageCheckChange: xe,
      onCreateThread: $e,
      thread: be,
      chatThreadOverview: u.chatThreadOverview,
      onClickThreadTitle: Be,
      bubbleStyle: se,
      ...p,
      children: /* @__PURE__ */ q.jsxs("div", { className: G, onClick: V, style: { ...h }, children: [
        /* @__PURE__ */ q.jsx(SH, { play: r, reverse: D, size: 20 }),
        /* @__PURE__ */ q.jsx("span", { className: `${k}-duration`, children: ue + '"' || 0 }),
        /* @__PURE__ */ q.jsx(
          "audio",
          {
            src: U ?? C.url,
            ref: m,
            onEnded: J,
            onError: J,
            onStalled: J
          }
        )
      ] })
    }
  ) });
}, Xm = mi(pAe);
Xm.displayName = "AudioMessage";
const au = (t) => {
  const {
    icon: r,
    avatar: a,
    avatarSrc: u = "",
    content: h = /* @__PURE__ */ q.jsx("div", { children: "Header" }),
    prefix: b,
    back: l = !1,
    onClickBack: v,
    renderContent: s,
    onClickEllipsis: c,
    moreAction: d,
    onClickAvatar: p,
    close: m,
    onClickClose: E,
    suffixIcon: y,
    style: g = {},
    className: C,
    subtitle: O,
    presence: N
  } = t, { theme: w } = _t.useContext(Vn), _ = w == null ? void 0 : w.mode;
  let I = t.avatarShape || "circle";
  w != null && w.avatarShape && (I = w == null ? void 0 : w.avatarShape);
  const { getPrefixCls: k } = _t.useContext(Hn), H = k("header", b), S = En(
    H,
    {
      [`${H}-${_}`]: !!_
    },
    C
  ), B = () => {
    E == null || E();
  }, [D, F] = tn(!1);
  let j;
  d != null && d.visible && (j = /* @__PURE__ */ q.jsx("ul", { className: `${H}-more`, children: d.actions.map((U, M) => U.visible == !1 ? null : /* @__PURE__ */ q.jsxs(
    "li",
    {
      className: _ == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        var V;
        F(!1), (V = U.onClick) == null || V.call(U);
      },
      children: [
        U.icon,
        U.content
      ]
    },
    M
  )) }));
  let G;
  return typeof s == "function" ? G = s() : G = /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsxs("div", { className: `${H}-content`, children: [
      l ? /* @__PURE__ */ q.jsx(
        gi,
        {
          type: "text",
          onClick: () => {
            v == null || v();
          },
          children: /* @__PURE__ */ q.jsx(
            pn,
            {
              type: "ARROW_LEFT",
              width: 24,
              height: 24
            }
          )
        }
      ) : null,
      a || /* @__PURE__ */ q.jsx(
        zs,
        {
          shape: I,
          src: u,
          onClick: (U) => {
            p == null || p(U);
          },
          size: 40,
          style: { marginRight: 12 },
          presence: N,
          children: h
        }
      ),
      /* @__PURE__ */ q.jsxs("div", { className: `${H}-content-box`, children: [
        /* @__PURE__ */ q.jsx("span", { className: `${H}-content-text`, children: h || null }),
        O && /* @__PURE__ */ q.jsx("span", { className: `${H}-content-sub`, children: O })
      ] })
    ] }),
    /* @__PURE__ */ q.jsxs("div", { className: `${H}-iconBox`, children: [
      y,
      (d == null ? void 0 : d.visible) && (d.actions.length > 0 ? /* @__PURE__ */ q.jsx(
        va,
        {
          title: j,
          trigger: "click",
          placement: "bottom",
          open: D,
          onOpenChange: (U) => {
            F(U);
          },
          ...d == null ? void 0 : d.tooltipProps,
          children: /* @__PURE__ */ q.jsx(
            gi,
            {
              type: "text",
              shape: "circle",
              onClick: () => {
                c == null || c();
              },
              children: d.icon ? d.icon : /* @__PURE__ */ q.jsx(
                pn,
                {
                  type: "ELLIPSIS",
                  color: _ == "dark" ? "#C8CDD0" : "#464E53",
                  width: 24,
                  height: 24
                }
              )
            }
          )
        }
      ) : /* @__PURE__ */ q.jsx(
        gi,
        {
          type: "text",
          shape: "circle",
          onClick: () => {
            c == null || c();
          },
          children: /* @__PURE__ */ q.jsx(
            pn,
            {
              type: "ELLIPSIS",
              color: _ == "dark" ? "#C8CDD0" : "#464E53",
              width: 24,
              height: 24
            }
          )
        }
      )),
      m && /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", onClick: B, children: /* @__PURE__ */ q.jsx(
        pn,
        {
          type: "CLOSE",
          color: _ == "dark" ? "#C8CDD0" : "#464E53",
          width: 24,
          height: 24
        }
      ) })
    ] })
  ] }), /* @__PURE__ */ q.jsx("div", { className: S, style: { ...g }, children: G });
}, gAe = (t) => {
  const { t: r } = Yr(), { message: a, bubbleClass: u } = t, h = {
    ...a,
    id: `pin-${a.id}`
  };
  h.bySelf = !1;
  let b = null;
  switch (h == null ? void 0 : h.type) {
    case "txt":
      b = /* @__PURE__ */ q.jsx(
        Dd,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          showEditedTag: !1,
          showTranslation: !1,
          status: "default",
          bubbleClass: u,
          select: !1,
          customAction: { visible: !1 },
          reaction: !1,
          messageStatus: !1,
          bubbleType: "none",
          textMessage: h,
          direction: "ltr",
          style: { display: "block" },
          thread: !1
        },
        h.id
      );
      break;
    case "img":
      b = /* @__PURE__ */ q.jsx(
        kv,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          bubbleClass: u,
          select: !1,
          status: "default",
          imageMessage: h,
          direction: "ltr",
          bubbleStyle: { padding: 0 },
          reaction: !1,
          customAction: { visible: !1 },
          thread: !1
        },
        h.id
      );
      break;
    case "file":
      b = /* @__PURE__ */ q.jsx(
        jv,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          bubbleClass: u,
          select: !1,
          status: "default",
          fileMessage: h,
          direction: "ltr",
          type: "secondly",
          reaction: !1,
          customAction: { visible: !1 },
          thread: !1
        },
        h.id
      );
      break;
    case "audio":
      b = /* @__PURE__ */ q.jsx(
        Xm,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          bubbleClass: u,
          select: !1,
          status: "default",
          audioMessage: h,
          type: "secondly",
          reaction: !1,
          customAction: { visible: !1 },
          direction: "ltr",
          thread: !1
        },
        h.id
      );
      break;
    case "video":
      b = /* @__PURE__ */ q.jsx(
        Uv,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          bubbleClass: u,
          select: !1,
          status: "default",
          videoMessage: h,
          direction: "ltr",
          type: "secondly",
          reaction: !1,
          customAction: { visible: !1 },
          thread: !1
        },
        h.id
      );
      break;
    case "custom":
      h.customEvent == "userCard" ? b = /* @__PURE__ */ q.jsx(
        PA,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          bubbleClass: u,
          select: !1,
          status: "default",
          customMessage: h,
          direction: "ltr",
          type: "secondly",
          reaction: !1,
          customAction: { visible: !1 },
          thread: !1
        },
        h.id
      ) : b = /* @__PURE__ */ q.jsx(
        Dd,
        {
          showAvatar: !1,
          bubbleClass: u,
          showMessageInfo: !1,
          select: !1,
          status: "default",
          bubbleType: "none",
          textMessage: h,
          direction: "ltr",
          thread: !1,
          children: r("customMessage")
        },
        h.id
      );
      break;
    case "combine":
      b = /* @__PURE__ */ q.jsx(
        Hv,
        {
          showAvatar: !1,
          showMessageInfo: !1,
          status: "default",
          bubbleClass: u,
          select: !1,
          combinedMessage: h,
          direction: "ltr",
          type: "secondly",
          reaction: !1,
          customAction: { visible: !1 },
          thread: !1
        },
        h.id
      );
      break;
    default:
      b = null;
      break;
  }
  return b;
}, mAe = (t) => {
  const r = Zn(Vn), { rootStore: a, theme: u } = r, h = (u == null ? void 0 : u.mode) || "light", { prefix: b, className: l, style: v = {} } = t, { getPrefixCls: s } = _t.useContext(Hn), c = s("pinned-messages", b), { t: d } = Yr(), { conversationStore: p } = a, m = p.currentCvs, [E, y] = tn(!1), [g, C] = tn(""), { list: O, cursor: N, getPinnedMessages: w, hide: _, unpinMessage: I } = Rc({
    conversation: {
      conversationType: m.chatType,
      conversationId: m.conversationId
    },
    pageSize: 50
  }), k = En(
    c,
    {
      [`${c}-${h}`]: !!h
    },
    l
  ), H = () => {
    _();
  }, S = (B) => {
    const D = a.messageStore.message.byId.get(B);
    D && (B = D.id);
    const F = document.getElementById(B);
    if (!F) {
      mn.dispatchError("jumpToPinnedMessage", {
        type: 51,
        message: "The pinned message does not exist"
      });
      return;
    }
    F == null || F.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" }), F == null || F.classList.add("reply-message-twinkle"), mn.dispatchSuccess("jumpToPinnedMessage"), setTimeout(() => {
      F == null || F.classList.remove("reply-message-twinkle");
    }, 1500);
  };
  return Pn(() => {
    N !== null && w();
  }, [N, m]), /* @__PURE__ */ q.jsxs("div", { className: k, style: { ...v }, children: [
    /* @__PURE__ */ q.jsx(
      au,
      {
        className: `${c}-header`,
        avatar: /* @__PURE__ */ q.jsx(q.Fragment, {}),
        content: `${O.length || ""} ${d("Pinned Messages")}`,
        close: !0,
        onClickClose: H
      }
    ),
    /* @__PURE__ */ q.jsx("div", { className: `${c}-wrap`, children: O.length > 0 ? O.map((B) => /* @__PURE__ */ q.jsxs("div", { className: `${c}-item-wrap`, children: [
      /* @__PURE__ */ q.jsxs("div", { className: `${c}-info-wrap`, children: [
        /* @__PURE__ */ q.jsx("div", { className: `${c}-info`, children: `${Bu({
          ...B.message,
          from: B.operatorId
        })} ${d("pinned")} ${Bu(
          B.message
        )}${d("'s message")}` }),
        /* @__PURE__ */ q.jsx("div", { className: `${c}-time`, children: Tm(B.pinTime) })
      ] }),
      /* @__PURE__ */ q.jsxs("div", { className: `${c}-opt-wrap`, children: [
        /* @__PURE__ */ q.jsx(
          gAe,
          {
            bubbleClass: `${c}-message-bubble`,
            message: B.message
          }
        ),
        /* @__PURE__ */ q.jsxs("div", { className: `${c}-opt`, children: [
          /* @__PURE__ */ q.jsx("span", { title: d("Click to view the original message"), children: /* @__PURE__ */ q.jsx(
            pn,
            {
              type: "ARROW_TO",
              className: `${c}-opt-icon`,
              style: { marginRight: "4px" },
              onClick: () => {
                S(B.message.id);
              }
            }
          ) }),
          /* @__PURE__ */ q.jsx("span", { title: d("remove"), children: /* @__PURE__ */ q.jsx(
            pn,
            {
              type: "UNPIN",
              onClick: () => {
                C(B.message.id), y(!0);
              },
              className: `${c}-opt-icon`
            }
          ) })
        ] })
      ] })
    ] }, B.message.id)) : /* @__PURE__ */ q.jsx(pn, { className: `${c}-empty`, type: "EMPTY" }) }),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        title: d("Remove pin message"),
        open: E,
        onCancel: () => {
          C(""), y(!1);
        },
        onOk: () => {
          I(g), y(!1);
        },
        children: /* @__PURE__ */ q.jsx("div", { children: `${d("Confirm to remove pin message ?")}` })
      }
    )
  ] });
}, EAe = mi(mAe);
EAe.displayName = "PinnedMessage";
window.URL = window.URL || window.webkitURL;
const ov = function(t, r) {
  r = r || {}, r.sampleBits = r.sampleBits || 16, r.sampleRate = r.sampleRate || 16e3;
  var a = new AudioContext(), u = a.createMediaStreamSource(t), h = a.createScriptProcessor(16 * 1024, 1, 1), b = 0;
  const l = (c, d, p) => {
    var m = Math.round(c.length * (d / p)), E = new Array(), y = new Number((c.length - 1) / (m - 1));
    E[0] = c[0];
    for (var g = 1; g < m - 1; g++) {
      var C = g * y, O = new Number(Math.floor(C)).toFixed(), N = new Number(Math.ceil(C)).toFixed(), w = C - O;
      E[g] = v(
        c[O],
        c[N],
        w
      );
    }
    return E[m - 1] = c[c.length - 1], E;
  }, v = (c, d, p) => c + (d - c) * p;
  var s = {
    size: 0,
    // 录音文件长度
    buffer: [],
    // 录音缓存
    inputSampleRate: a.sampleRate,
    // 输入采样率
    inputSampleBits: 16,
    // 输入采样数位 8, 16
    outputSampleRate: r.sampleRate,
    // 输出采样率
    outputSampleBits: r.sampleBits,
    // 输出采样数位 8, 16
    input: function(c) {
      this.buffer.push(new Float32Array(c)), this.size += c.length;
    },
    compress: function() {
      for (var c = new Float32Array(this.size), d = 0, p = 0; p < this.buffer.length; p++)
        c.set(this.buffer[p], d), d += this.buffer[p].length;
      var m = l(c, this.outputSampleRate, this.inputSampleRate);
      return m;
    },
    encodeWAV: function() {
      var c = Math.min(this.inputSampleRate, this.outputSampleRate), d = Math.min(this.inputSampleBits, this.outputSampleBits), p = this.compress(), m = p.length * (d / 8), E = new ArrayBuffer(44 + m), y = new DataView(E), g = 1, C = 0, O = function(I) {
        for (var k = 0; k < I.length; k++)
          y.setUint8(C + k, I.charCodeAt(k));
      };
      if (O("RIFF"), C += 4, y.setUint32(C, 36 + m, !0), C += 4, O("WAVE"), C += 4, O("fmt "), C += 4, y.setUint32(C, 16, !0), C += 4, y.setUint16(C, 1, !0), C += 2, y.setUint16(C, g, !0), C += 2, y.setUint32(C, c, !0), C += 4, y.setUint32(C, g * c * (d / 8), !0), C += 4, y.setUint16(C, g * (d / 8), !0), C += 2, y.setUint16(C, d, !0), C += 2, O("data"), C += 4, y.setUint32(C, m, !0), C += 4, d === 8)
        for (var N = 0; N < p.length; N++, C++) {
          var w = Math.max(-1, Math.min(1, p[N])), _ = w < 0 ? w * 32768 : w * 32767;
          _ = parseInt(255 / (65535 / (_ + 32768))), y.setInt8(C, _, !0);
        }
      else
        for (var N = 0; N < p.length; N++, C += 2) {
          var w = Math.max(-1, Math.min(1, p[N]));
          y.setInt16(C, w < 0 ? w * 32768 : w * 32767, !0);
        }
      return new Blob([y], { type: "audio/wav" });
    }
  };
  this.start = function() {
    u.connect(h), h.connect(a.destination);
  }, this.isEmptyData = function(c) {
    for (var d = Math.floor(c.length / 10), p = 0, m = 0; m < d; m++)
      p += Math.abs(c[m * 10]);
    if (p < 10) {
      if (b++, b > 10)
        return !0;
    } else
      b = 0;
    return !1;
  }, this.stop = function() {
    a.state === "running" && a.close(), h.disconnect();
  }, this.getBlob = function() {
    return this.stop(), s.encodeWAV();
  }, this.play = function(c) {
    c.src = window.URL.createObjectURL(this.getBlob());
  }, h.onaudioprocess = (c) => {
    s.input(c.inputBuffer.getChannelData(0));
  };
};
ov.setErrorInfoText = (t) => {
  ov.errorMessage = t;
};
ov.get = function(t, r) {
  t && navigator.mediaDevices.getUserMedia(
    { audio: !0 }
    // 只启用音频
  ).then((a) => {
    let u = new ov(a, r);
    t(u, a);
  }).catch((a) => {
    switch (a.code || a.name) {
      case "PERMISSION_DENIED":
      case "PermissionDeniedError":
        console.warn("The user refuses to provide information.");
        break;
      case "NOT_SUPPORTED_ERROR":
      case "NotSupportedError":
        console.warn("The browser does not support hardware devices.");
        break;
      case "MANDATORY_UNSATISFIED_ERROR":
      case "MandatoryUnsatisfiedError":
        console.warn("The specified hardware device cannot be discovered.");
        break;
      default:
        console.warn("The current browser does not support recording. (Chrome recommended)");
        break;
    }
    console.warn("The current browser does not support recording.");
  });
};
let KR, Tl, H0;
const yAe = (t) => {
  const r = Zn(Vn), { rootStore: a, theme: u } = r, h = (u == null ? void 0 : u.mode) || "light", b = (u == null ? void 0 : u.componentsShape) || "round", { t: l } = Yr(), { messageStore: v, client: s } = a, {
    prefix: c,
    onShow: d,
    onHide: p,
    onSend: m,
    conversation: E,
    onBeforeSendMessage: y,
    isChatThread: g = !1,
    style: C = {},
    iconStyle: O = {},
    liveContentStyle: N = {},
    className: w
  } = t, { getPrefixCls: _ } = _t.useContext(Hn), I = _("recorder", c), k = En(
    I,
    {
      [`${I}-${h}`]: !!h
    },
    w
  ), [H, S] = tn(!1), [B, D] = tn(0), F = () => {
    H0 = window.setInterval(() => {
      D((ee) => ee + 1);
    }, 1e3);
  };
  Pn(() => {
    B >= 60 && J();
  }, [B]);
  const j = () => {
    ov.get((ee, de) => {
      Tl = ee, KR = de, ee.start();
    });
  }, G = () => {
    Tl && (Tl.stop(), KR.getTracks()[0].stop());
  }, U = (ee) => {
    S(ee == "start"), ee == "start" ? (d && d(), j(), F()) : (p && p(), G(), D(0), clearInterval(H0));
  }, M = E || v.currentCVS;
  Pn(() => {
    Tl && Tl.stop(), S(!1), p && p(), G(), D(0), clearInterval(H0);
  }, [M]);
  const V = (ee) => {
    v.sendMessage(ee), G(), D(0), clearInterval(H0), S(!1), m && m(ee);
  }, J = () => {
    if (M.conversationId || console.warn("No specified conversation"), Tl) {
      Tl.stop();
      const ee = Tl.getBlob(), de = {
        url: Zs.utils.parseDownloadResponse.call(s, ee),
        filename: "audio-message.wav",
        filetype: "audio",
        data: ee,
        length: B < 1 ? 1 : B,
        duration: B < 1 ? 1 : B
      };
      KR.getTracks()[0].stop();
      const he = Zs.message.create({
        type: "audio",
        to: M.conversationId,
        chatType: M.chatType,
        file: de,
        filename: "",
        length: B < 1 ? 1 : B,
        isChatThread: g
      });
      y ? y(he).then((pe) => {
        pe && (he.to = pe.conversationId, he.chatType = pe.chatType), V(he);
      }) : V(he);
    }
  }, ue = /* @__PURE__ */ q.jsx("div", { className: `${I}-iconBox`, style: { ...O }, title: l("record"), children: /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", onClick: () => U("start"), children: /* @__PURE__ */ q.jsx(pn, { type: "CIRCLE_WAVE", width: 24, height: 24 }) }) }), se = /* @__PURE__ */ q.jsxs("div", { className: `${I}-content`, style: { ...N }, children: [
    /* @__PURE__ */ q.jsxs("div", { className: `${I}-content-left`, children: [
      /* @__PURE__ */ q.jsx(
        "div",
        {
          className: En(`${I}-iconBox`, `${I}-iconBox-stop`, {
            [`${I}-iconBox-round`]: b == "round"
          }),
          title: l("cancel"),
          children: /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", onClick: () => U("stop"), children: /* @__PURE__ */ q.jsx(pn, { type: "DELETE", width: 24, height: 24 }) })
        }
      ),
      /* @__PURE__ */ q.jsx("div", { className: `${I}-time`, children: /* @__PURE__ */ q.jsx("span", { children: B + "''" }) })
    ] }),
    /* @__PURE__ */ q.jsxs("div", { className: `${I}-content-right`, children: [
      /* @__PURE__ */ q.jsxs("span", { children: [
        l("recording"),
        "..."
      ] }),
      /* @__PURE__ */ q.jsx(
        "div",
        {
          onClick: J,
          className: En(`${I}-send`, {
            [`${I}-send-round`]: b == "round"
          }),
          title: l("send"),
          children: /* @__PURE__ */ q.jsx(pn, { type: "AIR_PLANE", width: 24, height: 24, color: "#fff" })
        }
      )
    ] })
  ] });
  return /* @__PURE__ */ q.jsx("div", { style: { width: H ? "100%" : "fit-content", ...C }, className: k, children: H ? se : ue });
};
let wN = (t) => {
  const {
    prefix: r,
    className: a,
    nickname: u,
    avatarShape: h = "circle",
    avatarSize: b = 50,
    avatar: l,
    onClick: v,
    data: s,
    moreAction: c,
    selected: d,
    checkable: p,
    onCheckboxChange: m,
    checked: E,
    closeable: y,
    onClose: g,
    disabled: C,
    ripple: O,
    ...N
  } = t, { t: w } = Yr(), { getPrefixCls: _ } = _t.useContext(Hn), { theme: I } = Zn(Vn), k = I == null ? void 0 : I.mode, H = (I == null ? void 0 : I.componentsShape) || "round", S = I == null ? void 0 : I.ripple, B = _("userItem", r), [D, F] = tn(!1), [j, G] = tn(!1), U = En(
    B,
    {
      [`${B}-${k}`]: !!k,
      [`${B}-selected`]: d,
      [`${B}-${H}`]: H
    },
    a
  ), M = (pe) => {
    v && v(pe);
  }, V = () => {
    c != null && c.visible && F(!0);
  }, J = () => {
    j || F(!1);
  }, ue = _("moreAction", r), se = En(ue, {
    [`${ue}-${k}`]: !!k
  });
  let ee;
  c != null && c.visible && (ee = /* @__PURE__ */ q.jsx("ul", { className: se, children: c.actions.map((pe, Ce) => /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: () => {
        var _e;
        (_e = pe.onClick) == null || _e.call(pe, s), G(!1);
      },
      children: [
        pe.icon ? pe.icon : null,
        typeof pe.content == "string" ? w(pe.content) : pe.content
      ]
    },
    Ce
  )) }));
  const de = (pe) => {
    m == null || m(pe.target.checked, s);
  }, he = O === void 0 ? S : O;
  return /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: U,
      onClick: M,
      style: N.style,
      onMouseOver: V,
      onMouseLeave: J,
      children: [
        l || /* @__PURE__ */ q.jsx(zs, { src: s.avatarUrl, isOnline: s.isOnline, size: b, shape: h, children: s.nickname || s.userId }),
        /* @__PURE__ */ q.jsxs("div", { className: `${B}-content`, children: [
          /* @__PURE__ */ q.jsx("span", { className: `${B}-nickname`, children: s.nickname || s.userId }),
          /* @__PURE__ */ q.jsx("span", { className: `${B}-message`, children: s.description })
        ] }),
        /* @__PURE__ */ q.jsx("div", { className: `${B}-info`, children: D && /* @__PURE__ */ q.jsx(
          va,
          {
            title: ee,
            trigger: "click",
            placement: "bottomRight",
            open: j,
            onOpenChange: (pe) => {
              G(pe), F(pe);
            },
            children: (c == null ? void 0 : c.icon) || /* @__PURE__ */ q.jsx(
              pn,
              {
                type: "ELLIPSIS",
                color: k === "dark" ? "var(--cui-primary-color6)" : "var(--cui-primary-color5)",
                height: 20,
                style: { cursor: "pointer", zIndex: 10 }
              }
            )
          }
        ) }),
        p && /* @__PURE__ */ q.jsx(
          "div",
          {
            onClick: (pe) => {
              pe.stopPropagation();
            },
            children: /* @__PURE__ */ q.jsx(
              Bv,
              {
                disabled: C,
                checked: E,
                onChange: de
              }
            )
          }
        ),
        y && /* @__PURE__ */ q.jsx("div", { children: /* @__PURE__ */ q.jsx(
          pn,
          {
            width: 24,
            height: 24,
            type: "CLOSE_CIRCLE",
            onClick: () => {
              g == null || g(s);
            }
          }
        ) }),
        he && /* @__PURE__ */ q.jsx(qw, {})
      ]
    }
  );
};
wN = mi(wN);
const Md = wN, vAe = (t) => {
  var G;
  const {
    prefix: r,
    className: a,
    avatarShape: u = "circle",
    avatarSize: h = 40,
    onClick: b,
    isActive: l = !1,
    contactId: v,
    children: s,
    data: c,
    selectedId: d,
    checkable: p,
    checkedUserList: m,
    defaultCheckedList: E,
    onCheckboxChange: y,
    ...g
  } = t, { getPrefixCls: C } = _t.useContext(Hn), O = C("contactItem", r), N = Zn(Vn), { rootStore: w, theme: _, features: I } = N, k = (_ == null ? void 0 : _.mode) || "light", H = _ != null && _.avatarShape ? _ == null ? void 0 : _.avatarShape : u, S = En(O, a), { addressStore: B } = w, D = (U, M) => {
    b && b(U, M);
  }, F = En(`${O}-tag`, {
    [`${O}-${k}`]: !!k
  }), j = (U, M) => {
    y && y(U, M);
  };
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx("div", { className: F, children: c.region }),
    (G = c.brands) == null ? void 0 : G.map((U) => {
      var M;
      return /* @__PURE__ */ q.jsx(
        "div",
        {
          className: `${S} ${d == U.brandId ? `${O}-selected` : ""}`,
          onClick: (V) => {
            D(V, U.brandId);
          },
          style: g.style,
          children: /* @__PURE__ */ q.jsx(
            Md,
            {
              avatarSize: 40,
              avatarShape: H,
              checked: m && m.includes(U.brandId) || E && E.includes(U.brandId),
              disabled: E && E.includes(U.brandId),
              nickname: U.name,
              data: {
                userId: U.brandId,
                nickname: U.name,
                avatarUrl: U.avatarUrl || ((M = B.appUsersInfo[U.brandId]) == null ? void 0 : M.avatarurl) || ""
              },
              selected: d == U.brandId,
              checkable: p,
              onCheckboxChange: j
            }
          )
        },
        U.brandId
      );
    })
  ] });
};
function _b(t) {
  const {
    onChange: r,
    prefix: a,
    className: u,
    shape: h,
    style: b = {},
    placeholder: l,
    inputStyle: v,
    ...s
  } = t, { t: c } = Yr(), { getPrefixCls: d } = _t.useContext(Hn), { theme: p } = _t.useContext(Vn), m = p == null ? void 0 : p.mode, E = h || (p == null ? void 0 : p.componentsShape) || "round", y = d("search", a), g = En(
    y,
    {
      [`${y}-${E}`]: E,
      [`${y}-${m}`]: !!m
    },
    u
  ), C = (O) => {
    r && r(O);
  };
  return /* @__PURE__ */ q.jsxs("div", { className: g, style: { ...b }, children: [
    /* @__PURE__ */ q.jsx(pn, { type: "SEARCH", className: `${y}-icon` }),
    /* @__PURE__ */ q.jsx(
      "input",
      {
        type: "text",
        placeholder: l || c("search"),
        onChange: C,
        className: `${y}-input`,
        style: { ...v },
        ...s
      }
    )
  ] });
}
const IH = (t) => {
  const {
    prefix: r,
    children: a,
    title: u,
    itemCount: h,
    onclickTitle: b,
    hasMenu: l = !0,
    itemHeight: v,
    unreadCount: s,
    highlightUnread: c = !1
  } = t, { getPrefixCls: d } = _t.useContext(Hn), p = d("contactGroup", r), m = _t.useContext(Vn), { rootStore: E, theme: y, features: g } = m, C = (y == null ? void 0 : y.mode) || "light", O = En(p, {
    [`${p}-${C}`]: !!C
  }), [N, w] = tn(!l), [_, I] = tn(0), [k, H] = tn(l ? 0 : "auto"), S = (j) => {
    var G;
    w((U) => !U), I((U) => U == 0 ? 90 : 0), b == null || b(j), H(N ? 0 : `${(G = D == null ? void 0 : D.current) == null ? void 0 : G.scrollHeight}px`);
  };
  Pn(() => {
    N && H("auto");
  }, [h]);
  const B = En(`${p}-children`, {
    [`${p}-children-show`]: N,
    [`${p}-children-hide`]: !N
  }), D = er(null), F = En(`${p}-title-count`, {
    [`${p}-title-count-unread`]: c
  });
  return /* @__PURE__ */ q.jsxs("div", { className: O, children: [
    l && /* @__PURE__ */ q.jsxs("div", { className: `${p}-title`, onClick: () => S(u), children: [
      /* @__PURE__ */ q.jsxs("div", { children: [
        " ",
        u
      ] }),
      /* @__PURE__ */ q.jsxs("div", { children: [
        s ?? !1 ? /* @__PURE__ */ q.jsx("span", { className: F, children: s }) : /* @__PURE__ */ q.jsx("span", {}),
        /* @__PURE__ */ q.jsx("div", { className: `${p}-icon`, style: { transform: `rotate(${_}deg)` }, children: /* @__PURE__ */ q.jsx(pn, { type: "ARROW_RIGHT" }) })
      ] })
    ] }),
    /* @__PURE__ */ q.jsx(
      "div",
      {
        className: B,
        ref: D,
        style: {
          height: k
        },
        children: a
      }
    )
  ] });
}, Zw = () => {
  const t = Zn(Vn).rootStore, { client: r, addressStore: a } = t, [u, h] = tn(
    t.addressStore.contacts
  );
  return Pn(() => {
    var b;
    ((b = t.addressStore.contacts) == null ? void 0 : b.length) > 0 || t.loginState && r.getAllContacts().then((l) => {
      var s;
      const v = (s = l.data) == null ? void 0 : s.map((c) => ({
        userId: c.userId,
        nickname: "",
        remark: c.remark
      }));
      h(v || []), a.setContacts(v), mn.dispatchSuccess("getAllContacts");
    }).catch((l) => {
      console.warn("get contacts failed", l), mn.dispatchError("getAllContacts", l);
    });
  }, [t.loginState]), u;
}, Qw = (t, r) => {
  const a = Zn(Vn).rootStore;
  Pn(() => {
    if (!a.loginState) return;
    const u = Object.keys(a.addressStore.appUsersInfo), h = a.conversationStore.conversationList.filter((v) => v.chatType === "singleChat" && !u.includes(v.conversationId)).map((v) => v.conversationId), b = a.addressStore.contacts.filter((v) => !u.includes(v.userId)).map((v) => v.userId), l = a.addressStore.blockList.filter((v) => !u.includes(v));
    if (t === "blocklist") {
      xd({
        userIdList: l,
        withPresence: !1
      }).catch((v) => {
        console.warn("get getUsersInfo failed", v);
      });
      return;
    }
    xd({
      userIdList: t == "conversation" ? h : b,
      withPresence: r
    }).catch((v) => {
      console.warn("get getUsersInfo failed", v);
    });
  }, [
    a.conversationStore.conversationList.length,
    a.addressStore.contacts.length,
    a.addressStore.blockList.length,
    a.loginState
  ]);
}, hY = () => {
  let r = 1;
  const { client: a, addressStore: u } = gr(), h = u.hasGroupsNext, b = () => {
    h && a.getJoinedGroups({
      pageNum: r,
      pageSize: 200
    }).then((l) => {
      var v;
      l != null && l.data && u.setGroups(l.data), (((v = l.data) == null ? void 0 : v.length) || 0) === 200 ? (r++, b()) : u.setHasGroupsNext(!1), mn.dispatchSuccess("getJoinedGroups");
    }).catch((l) => {
      mn.dispatchError("getJoinedGroups", l);
    });
  };
  return {
    getJoinedGroupList: b
  };
}, $w = (t, r) => {
  if (!t) return {};
  const a = 20;
  let u = 1;
  const { client: h, addressStore: b } = gr(), l = jd(t);
  let v = l == null ? void 0 : l.hasMembersNext;
  v === void 0 && (v = !0);
  const s = () => {
    if (v)
      return h.listGroupMembers({
        groupId: t,
        pageNum: u,
        pageSize: a
      }).then((c) => {
        var p, m;
        c != null && c.data && b.setGroupMembers(t, c.data);
        let d = ((p = c.data) == null ? void 0 : p.map((E) => E.owner || E.member)) || [];
        if (d.length && pY(t, d).getMemberAttributes(), r == !0) {
          const E = Object.keys(b.appUsersInfo);
          d = d.filter((y) => !E.includes(y)), xd({
            userIdList: d,
            withPresence: !1
          }).catch((y) => {
            console.warn("get getUsersInfo failed", y);
          });
        }
        (((m = c.data) == null ? void 0 : m.length) || 0) === a ? (u++, s()) : b.setGroupItemHasMembersNext(t, !1);
      });
  };
  return {
    getGroupMemberList: s
  };
}, pY = (t, r, a) => {
  const { client: u, addressStore: h } = gr();
  return {
    getMemberAttributes: () => {
      let l = [];
      if (r.length > 10)
        for (let v = 0; v < r.length; v += 10)
          l.push(r.slice(v, v + 10));
      else
        l = [r];
      l.forEach((v) => {
        u.getGroupMembersAttributes({
          groupId: t,
          userIds: v,
          keys: a
        }).then((s) => {
          s.data && Object.keys(s.data).forEach((c) => {
            s != null && s.data && h.setGroupMemberAttributes(t, c, s.data[c]);
          });
        });
      });
    }
  };
}, TAe = (t) => {
  const { client: r, addressStore: a } = gr(), u = jd(t);
  return { getGroupAdmins: () => {
    u != null && u.admins || r.getGroupAdmin({
      groupId: t
    }).then((b) => {
      a.setGroupAdmins(t, b.data || []), a.setGroupMembers(
        t,
        (b.data || []).map((l) => ({
          member: l
        }))
      );
    });
  } };
};
function JR(t) {
  var l;
  if (t.length === 0) return [];
  const r = t.concat();
  r.forEach((v) => {
    var s;
    v.name = v.userId ? v.remark || ((s = Zt.addressStore.appUsersInfo[v.userId]) == null ? void 0 : s.nickname) || v.userId : v.groupname, v.userId && (v.nickname = v.name), Zp(v.name.substring(0, 1)) == "en" ? v.initial = v.name.substring(0, 1).toUpperCase() : Zp(v.name.substring(0, 1)) == "zh" ? v.initial = nN(v.name.substring(0, 1), { toneType: "none" })[0][0].toUpperCase() : v.initial = "#";
  }), r.sort((v, s) => v.initial.charCodeAt(0) - s.initial.charCodeAt(0));
  let a = null;
  const u = [];
  let h, b;
  for (let v = 0; v < r.length; v++) {
    const s = {
      brandId: r[v].userId || r[v].groupid,
      name: r[v].name,
      avatarUrl: r[v].avatarUrl || ((l = Zt.addressStore.appUsersInfo[r[v].userId]) == null ? void 0 : l.avatarurl)
    };
    r[v].initial === "#" ? (h || (h = {
      id: v,
      region: "#",
      brands: []
    }), h.brands.push(s)) : (r[v].initial !== a && (a = r[v].initial, b = {
      id: v,
      region: a,
      brands: []
    }, u.push(b)), b == null || b.brands.push(s));
  }
  return u.sort((v, s) => v.region.charCodeAt(0) - s.region.charCodeAt(0)), h && u.push(h), u;
}
let _N = (t) => {
  var Ce, _e;
  const {
    prefix: r,
    className: a,
    onSearch: u,
    onItemClick: h,
    menu: b = ["requests", "groups", "contacts"],
    style: l,
    hasMenu: v = !1,
    checkable: s = !1,
    onCheckboxChange: c,
    header: d,
    checkedList: p,
    defaultCheckedList: m,
    searchStyle: E,
    searchInputStyle: y,
    searchPlaceholder: g
  } = t, { getPrefixCls: C } = _t.useContext(Hn), O = C("contactList", r), [N, w] = tn([]), { t: _ } = Yr(), I = Zn(Vn), { rootStore: k, theme: H, features: S, initConfig: B } = I, { useUserInfo: D } = B, F = (H == null ? void 0 : H.mode) || "light", { addressStore: j } = k, G = En(
    O,
    {
      [`${O}-${F}`]: !!F
    },
    a
  );
  if (Zw(), D) {
    const Le = ((_e = (Ce = S == null ? void 0 : S.conversationList) == null ? void 0 : Ce.item) == null ? void 0 : _e.presence) != !1;
    Qw("contacts", Le);
  }
  const { getJoinedGroupList: U } = hY();
  Pn(() => {
    k.loginState && U();
  }, [k.loginState]);
  const [M, V] = tn(""), [J, ue] = tn(!1), se = (Le, Te) => {
    c == null || c(Le, Te);
  };
  Pn(() => {
    const Le = {};
    b.forEach((K) => {
      K == "requests" ? Le.newRequests = [] : K == "contacts" || K == "groups" ? Le[K] = void 0 : Le[K.title] = K.data;
    }), b.forEach((K) => {
      K == "contacts" ? Le.contacts = JR(j.contacts) : K == "groups" ? Le.groups = JR(j.groups) : K == "requests" ? Le.newRequests = j.requests : Le[K.title] = JR(K.data);
    });
    const Te = Object.keys(Le).map((K, Oe) => {
      var xe, be;
      const Pe = (xe = Le[K]) == null ? void 0 : xe.map(($e) => /* @__PURE__ */ q.jsx(
        vAe,
        {
          checkedUserList: p && p.map((Be) => Be.id),
          defaultCheckedList: m && m.map((Be) => Be.id),
          data: $e,
          contactId: $e.region,
          onClick: (Be, Ke) => {
            Be.preventDefault();
            const Ze = pe(Ke);
            h == null || h({
              id: Ke,
              type: Ze.type,
              name: Ze.name
            }), V(Ke);
          },
          selectedId: M,
          checkable: s,
          onCheckboxChange: se
        },
        $e.region
      ));
      if (K == "newRequests") {
        const $e = j.requests.filter((Be) => Be.requestStatus == "pending").length || 0;
        return /* @__PURE__ */ q.jsx(
          IH,
          {
            title: _("newRequests"),
            itemCount: j.requests.length,
            unreadCount: $e,
            itemHeight: 84,
            hasMenu: v || b.length !== 1,
            highlightUnread: !0,
            children: /* @__PURE__ */ q.jsx("div", { children: (be = j.requests) == null ? void 0 : be.map((Be, Ke) => {
              var at, pt;
              const Ze = ((at = j.appUsersInfo[Be.from]) == null ? void 0 : at.nickname) || Be.from;
              return /* @__PURE__ */ q.jsx(
                Md,
                {
                  data: {
                    avatarUrl: (pt = j.appUsersInfo[Be.from]) == null ? void 0 : pt.avatarurl,
                    nickname: Ze,
                    userId: Be.from,
                    description: _("requestToAddContact")
                  },
                  onClick: (It) => {
                    V(Be.from), j.readContactInvite(Be.from), h == null || h({
                      id: Be.from,
                      type: "request",
                      name: Ze
                    });
                  },
                  selected: M == Be.from
                },
                Be.from
              );
            }) })
          },
          K
        );
      }
      return Pe ? /* @__PURE__ */ q.jsx(
        IH,
        {
          title: _(K),
          unreadCount: K == "contacts" ? j.contacts.length : j.groups.length,
          itemCount: K == "contacts" ? j.contacts.length : j.groups.length,
          itemHeight: 74,
          hasMenu: v || b.length !== 1,
          children: Pe
        },
        K
      ) : /* @__PURE__ */ q.jsx("div", {}, "no");
    });
    w(Te);
  }, [
    M,
    j.contacts,
    j.groups,
    j.appUsersInfo,
    j.requests,
    p
  ]);
  const ee = (Le) => {
    const Te = Le.target.value;
    if ((u == null ? void 0 : u(Le)) === !1) return;
    const Oe = b.includes("contacts") && j.contacts.filter(
      (xe) => !!xe.nickname.includes(Te)
    ) || [], Pe = b.includes("groups") && j.groups.filter(
      (xe) => !!xe.groupname.includes(Te)
    ) || [];
    ue(Te.length > 0), j.setSearchList(Oe.concat(Pe));
  }, [de, he] = tn();
  Pn(() => {
    const Le = j.searchList.map(
      (Te) => {
        var xe;
        const K = Te.userId || Te.groupid, Oe = Te.nickname || Te.groupname, Pe = {
          userId: K,
          nickname: Oe,
          avatarUrl: Te.avatarUrl || ((xe = j.appUsersInfo[K]) == null ? void 0 : xe.avatarurl)
        };
        return /* @__PURE__ */ q.jsx(
          Md,
          {
            checked: p && p.map((be) => be.id).includes(K),
            onClick: (be) => {
              V(K), h == null || h({
                id: K,
                type: Te.userId ? "contact" : "group",
                name: Oe
              });
            },
            data: Pe,
            selected: M == Te.userId,
            checkable: s,
            onCheckboxChange: se
          },
          K
        );
      }
    );
    he(Le);
  }, [j.searchList, M, p == null ? void 0 : p.length, j.appUsersInfo]);
  const pe = (Le) => {
    var Pe, xe;
    let Te, K = "contact";
    const Oe = j.contacts.find((be) => be.userId == Le);
    return Oe && Oe.remark ? (Te = Oe.remark, K = "contact") : (Pe = j.appUsersInfo[Le]) != null && Pe.nickname ? (Te = (xe = j.appUsersInfo[Le]) == null ? void 0 : xe.nickname, K = "contact") : j.groups.forEach((be) => {
      be.groupid == Le && (Te = be.groupname, K = "group");
    }), Te || (Te = Le), { name: Te, type: K };
  };
  return /* @__PURE__ */ q.jsxs("div", { className: G, style: { ...l }, children: [
    d || /* @__PURE__ */ q.jsx(au, { avatar: /* @__PURE__ */ q.jsx(q.Fragment, {}), content: _("contacts") }),
    /* @__PURE__ */ q.jsx(
      _b,
      {
        placeholder: g,
        style: { margin: "0 4px", width: "auto", ...E },
        onChange: ee,
        inputStyle: { ...y }
      }
    ),
    /* @__PURE__ */ q.jsx("div", { className: `${O}-content`, children: J ? de : N })
  ] });
};
_N = mi(_N);
const Pm = (t) => {
  const { icon: r, text: a = "No Data", prefix: u, style: h = {}, className: b } = t, { getPrefixCls: l } = _t.useContext(Hn), v = l("empty", u), s = En(v, b);
  return /* @__PURE__ */ q.jsxs("div", { className: s, style: { ...h }, children: [
    r,
    /* @__PURE__ */ q.jsx("span", { children: a })
  ] });
}, bAe = (t) => {
  var J, ue, se, ee;
  const {
    style: r,
    className: a,
    prefix: u,
    data: h,
    onUserIdCopied: b,
    onMessageBtnClick: l,
    onAudioCall: v,
    onVideoCall: s,
    renderEmpty: c
  } = t, { type: d, id: p, name: m } = h, { t: E } = Yr(), { getPrefixCls: y } = _t.useContext(Hn), g = y("contact-detail", u), C = _t.useContext(Vn), { rootStore: O, theme: N, features: w, presenceMap: _ } = C, I = O.addressStore.requests.find((de) => de.from === p), k = (N == null ? void 0 : N.mode) || "light", H = En(
    g,
    {
      [`${g}-${k}`]: !!k
    },
    a
  ), { addressStore: S, conversationStore: B } = O, D = S.appUsersInfo[p];
  let F = D == null ? void 0 : D.avatarurl, j;
  h.type === "contact" || h.type === "request" ? j = S.contacts.find((de) => de.userId === h.id) : (j = S.groups.find((de) => de.groupid === h.id), F = j == null ? void 0 : j.avatarUrl);
  const G = () => {
    const de = document.createElement("textarea");
    de.value = p, document.body.appendChild(de), de.select(), document.execCommand("copy"), document.body.removeChild(de), b == null || b(p);
  }, U = (de) => () => {
    let he;
    de === "message" ? he = l == null ? void 0 : l() : de === "audio" ? he = v == null ? void 0 : v() : de === "video" && (he = s == null ? void 0 : s()), he != !1 && (B.addConversation({
      chatType: h.type == "contact" || h.type == "request" ? "singleChat" : "groupChat",
      conversationId: h.id,
      name: (D == null ? void 0 : D.nickname) || h.name || p,
      lastMessage: {
        time: Date.now(),
        type: "txt",
        msg: "",
        id: "",
        chatType: h.type == "contact" || h.type == "request" ? "singleChat" : "groupChat",
        to: h.id
      },
      unreadCount: 0
    }), B.setCurrentCvs({
      chatType: h.type == "contact" || h.type == "request" ? "singleChat" : "groupChat",
      conversationId: h.id,
      name: (D == null ? void 0 : D.nickname) || h.name || p
    }));
  }, M = () => {
    S.acceptContactInvite(h.id);
  }, V = S.contacts.findIndex((de) => de.userId === h.id) >= 0;
  return /* @__PURE__ */ q.jsx("div", { className: H, style: { ...r }, children: h.id ? /* @__PURE__ */ q.jsx(q.Fragment, { children: /* @__PURE__ */ q.jsxs("div", { className: `${g}-content`, children: [
    /* @__PURE__ */ q.jsxs("div", { className: `${g}-content-header`, children: [
      /* @__PURE__ */ q.jsx(
        zs,
        {
          src: F,
          size: 100,
          shape: N == null ? void 0 : N.avatarShape,
          presence: {
            visible: h.type !== "group" && ((ue = (J = w == null ? void 0 : w.conversationList) == null ? void 0 : J.item) == null ? void 0 : ue.presence) && h.type !== "request" && !p.includes("chatbot"),
            icon: (_ == null ? void 0 : _[(se = O.addressStore.appUsersInfo[p]) != null && se.isOnline ? ((ee = O.addressStore.appUsersInfo[p]) == null ? void 0 : ee.presenceExt) ?? "Online" : "Offline"]) || (_ == null ? void 0 : _.Custom)
          },
          children: (D == null ? void 0 : D.nickname) || m || p
        }
      ),
      /* @__PURE__ */ q.jsxs("div", { children: [
        /* @__PURE__ */ q.jsx("div", { className: `${g}-content-header-name`, children: (D == null ? void 0 : D.nickname) || m || p }),
        /* @__PURE__ */ q.jsxs("div", { className: `${g}-content-header-id`, children: [
          /* @__PURE__ */ q.jsxs("div", { children: [
            h.type == "group" ? E("group") : E("user"),
            " ID:"
          ] }),
          p,
          /* @__PURE__ */ q.jsx(pn, { type: "DOC_ON_DOC", style: { cursor: "copy" }, onClick: G })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ q.jsx("div", { className: `${g}-content-body`, children: d === "request" && (I == null ? void 0 : I.requestStatus) !== "accepted" && !V ? /* @__PURE__ */ q.jsxs(gi, { type: "text", className: `${g}-content-btn`, onClick: M, children: [
      /* @__PURE__ */ q.jsx(pn, { type: "BUBBLE_FILL", width: 24, height: 24 }),
      E("addContact")
    ] }) : /* @__PURE__ */ q.jsxs("div", { className: `${g}-content-btn-container`, children: [
      /* @__PURE__ */ q.jsxs(
        gi,
        {
          type: "text",
          className: `${g}-content-btn`,
          onClick: U("message"),
          children: [
            /* @__PURE__ */ q.jsx(pn, { type: "BUBBLE_FILL", width: 24, height: 24 }),
            E("message")
          ]
        }
      ),
      h.id.includes("chatbot_") ? null : /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
        "|",
        /* @__PURE__ */ q.jsxs(
          gi,
          {
            type: "text",
            className: `${g}-content-btn`,
            onClick: U("audio"),
            children: [
              /* @__PURE__ */ q.jsx(pn, { type: "PHONE_PICK", width: 24, height: 24 }),
              E("audioCall")
            ]
          }
        ),
        "|",
        /* @__PURE__ */ q.jsxs(
          gi,
          {
            type: "text",
            className: `${g}-content-btn`,
            onClick: U("video"),
            children: [
              /* @__PURE__ */ q.jsx(pn, { type: "VIDEO_CAMERA", width: 24, height: 24 }),
              E("videoCall")
            ]
          }
        )
      ] })
    ] }) })
  ] }) }) : (c == null ? void 0 : c()) || /* @__PURE__ */ q.jsx(
    Pm,
    {
      text: E("no contact"),
      icon: /* @__PURE__ */ q.jsx(pn, { type: "EMPTY", width: 120, height: 120 })
    }
  ) });
}, U3e = mi(bAe), gY = (t) => {
  var de, he;
  const {
    onUserSelect: r,
    prefix: a,
    className: u,
    style: h,
    title: b = "",
    footer: l = "",
    closable: v = !1,
    open: s,
    enableMultipleSelection: c,
    selectedPanelHeader: d,
    selectedPanelFooter: p,
    onCancel: m,
    onConfirm: E,
    users: y,
    checkedUsers: g,
    disabled: C,
    disableUserIds: O,
    searchPlaceholder: N,
    ...w
  } = t, { getPrefixCls: _ } = _t.useContext(Hn), I = _("user-select", a), k = Zn(Vn), { rootStore: H, theme: S, features: B } = k, { addressStore: D } = H, F = (S == null ? void 0 : S.mode) || "light", { t: j } = Yr(), G = En(
    I,
    {
      [`${I}-${F}`]: !!F
    },
    u
  );
  tn(s);
  const [U, M] = tn([]), V = (he = (de = H.addressStore) == null ? void 0 : de.contacts) == null ? void 0 : he.filter((pe) => {
    if (pe.userId.indexOf("chatbot_") > -1) return !0;
  });
  V.forEach(
    (pe) => {
      var Ce;
      pe.avatarUrl = (Ce = D.appUsersInfo[pe.userId]) == null ? void 0 : Ce.avatarurl;
    }
  ), Pn(() => {
    s ? y || (M(V), V.length > 0 && (r == null || r(
      {
        ...V[0],
        type: "add"
      },
      V
    ))) : M([]);
  }, [s]);
  const J = (pe, Ce) => {
    if (pe) {
      if (!c) {
        M((_e) => [Ce]), r == null || r(
          {
            ...Ce,
            type: "add"
          },
          [Ce]
        );
        return;
      }
      M((_e) => (r == null || r(
        {
          ...Ce,
          type: "add"
        },
        [..._e, Ce]
      ), [..._e, Ce]));
    } else {
      if (!c) {
        M([]), r == null || r(
          {
            ...Ce,
            type: "delete"
          },
          []
        );
        return;
      }
      M((_e) => {
        const Le = _e.filter((Te) => Te.userId !== Ce.userId);
        return r == null || r(
          {
            ...Ce,
            type: "delete"
          },
          Le
        ), Le;
      });
    }
  }, ue = (pe) => {
    pe.userId.indexOf("chatbot_") > -1 || M((Ce) => {
      const _e = Ce.filter((Le) => Le.userId !== pe.userId);
      return r == null || r(
        {
          ...pe,
          type: "delete"
        },
        _e
      ), _e;
    });
  }, se = U.map((pe) => ({
    id: pe.userId,
    type: "contact",
    name: pe.nickname
  })), ee = (g == null ? void 0 : g.map((pe) => ({
    type: "contact",
    id: pe.userId
  }))) || [];
  return V.length > 0 && V.forEach((pe) => {
    ee == null || ee.push({
      id: pe.userId,
      type: "contact"
    });
  }), /* @__PURE__ */ q.jsx(
    ca,
    {
      open: s,
      width: 720,
      title: b,
      footer: l,
      bodyStyle: { padding: 0 },
      closable: v,
      onCancel: (pe) => {
        m == null || m(pe);
      },
      ...w,
      children: /* @__PURE__ */ q.jsxs("div", { className: G, children: [
        /* @__PURE__ */ q.jsx("div", { className: `${I}-container-left`, children: y && y.length > 0 ? y.map((pe) => /* @__PURE__ */ q.jsx(
          Md,
          {
            avatarSize: 40,
            avatarShape: S == null ? void 0 : S.avatarShape,
            data: pe,
            onCheckboxChange: J,
            checkable: !0,
            disabled: (g == null ? void 0 : g.some((Ce) => Ce.userId == pe.userId)) || C || (O == null ? void 0 : O.includes(pe.userId)),
            checked: se && se.map((Ce) => Ce.id).includes(pe.userId) || (g == null ? void 0 : g.some((Ce) => Ce.userId == pe.userId)),
            onClick: (Ce) => {
              Ce.preventDefault(), !(g != null && g.some((_e) => _e.userId == pe.userId) || C || O != null && O.includes(pe.userId)) && J(!se.map((_e) => _e.id).includes(pe.userId), pe);
            }
          },
          pe.userId
        )) : (
          //  左侧待选择的人，直接使用联系人列表
          /* @__PURE__ */ q.jsx(
            _N,
            {
              searchPlaceholder: N,
              searchInputStyle: F == "dark" ? { backgroundColor: "#464E53" } : {},
              style: F == "dark" ? { backgroundColor: "#2F3437" } : {},
              onCheckboxChange: J,
              onItemClick: (pe) => {
                var Le, Te;
                if (pe.id.indexOf("chatbot_") > -1 || (ee == null ? void 0 : ee.find((K) => K.id === pe.id))) return;
                se.find((K) => K.id === pe.id) ? J(!1, {
                  userId: pe.id,
                  nickname: pe.name,
                  avatarUrl: (Le = D.appUsersInfo[pe.id]) == null ? void 0 : Le.avatarurl
                }) : J(!0, {
                  userId: pe.id,
                  nickname: pe.name,
                  avatarUrl: (Te = D.appUsersInfo[pe.id]) == null ? void 0 : Te.avatarurl
                });
              },
              checkable: !0,
              menu: ["contacts"],
              hasMenu: !1,
              header: /* @__PURE__ */ q.jsx(q.Fragment, {}),
              checkedList: se,
              defaultCheckedList: ee
            }
          )
        ) }),
        /* @__PURE__ */ q.jsxs("div", { className: `${I}-container`, children: [
          d ? /* @__PURE__ */ q.jsx("div", { className: `${I}-header`, children: d }) : /* @__PURE__ */ q.jsx("div", { className: `${I}-header`, children: `${j("Selected group members")}（${U.length}）` }),
          /* @__PURE__ */ q.jsx("div", { className: `${I}-body`, children: U.map((pe) => /* @__PURE__ */ q.jsx(
            Md,
            {
              avatarSize: 40,
              data: pe,
              checked: !0,
              closeable: pe.userId.indexOf("chatbot_") === -1,
              onClose: ue,
              onClick: (Ce) => {
                ue(pe);
              }
            },
            pe.userId
          )) }),
          p ? /* @__PURE__ */ q.jsx("div", { className: `${I}-footer`, children: p }) : /* @__PURE__ */ q.jsx("div", { className: `${I}-footer`, children: /* @__PURE__ */ q.jsxs("div", { children: [
            /* @__PURE__ */ q.jsx(
              gi,
              {
                style: { marginRight: "24px", width: "68px" },
                type: "primary",
                onClick: (pe) => {
                  E == null || E(U);
                },
                disabled: U.length === 0,
                children: (w == null ? void 0 : w.okText) || j("confirmBtn")
              }
            ),
            /* @__PURE__ */ q.jsx(
              gi,
              {
                style: { width: "68px" },
                type: "default",
                onClick: (pe) => {
                  m == null || m(pe);
                },
                children: w.cancelText || j("cancelBtn")
              }
            )
          ] }) })
        ] })
      ] })
    }
  );
};
let PN = (t) => {
  const {
    icon: r,
    customActions: a,
    prefix: u,
    conversation: h,
    isChatThread: b,
    onBeforeSendMessage: l,
    style: v = {},
    itemContainerStyle: s = {},
    className: c
  } = t, { getPrefixCls: d } = _t.useContext(Hn), p = d("moreAction", u), m = En(p, c), E = er(null), y = er(null), g = er(null), { t: C } = Yr(), O = Zn(Vn), { rootStore: N, theme: w } = O, _ = (w == null ? void 0 : w.mode) || "light", { client: I, messageStore: k } = N, H = r || /* @__PURE__ */ q.jsx("span", { className: `${p}-iconBox`, style: { ...v }, title: C("more"), children: /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", children: /* @__PURE__ */ q.jsx(
    pn,
    {
      type: "PLUS_CIRCLE",
      width: 24,
      height: 24
    }
  ) }) }), S = () => {
    var _e, Le;
    (_e = E.current) == null || _e.focus(), (Le = E.current) == null || Le.click();
  }, B = () => {
    var _e, Le;
    (_e = y.current) == null || _e.focus(), (Le = y.current) == null || Le.click();
  }, [D, F] = tn(!1), [j, G] = tn([]), U = () => {
    F(!0);
  }, M = () => {
    var Pe;
    if (j.length == 0)
      return;
    const _e = j[0], Le = "userCard", Te = {
      uid: _e.userId || "",
      nickname: ((Pe = N.addressStore.appUsersInfo[_e.userId]) == null ? void 0 : Pe.nickname) || _e.nickname || "",
      avatar: _e.avatarUrl || ""
    }, K = {
      type: "custom",
      customEvent: Le,
      customExts: Te,
      to: ee.conversationId,
      chatType: ee.chatType,
      isChatThread: b
    }, Oe = Zs.message.create(K);
    l ? l(Oe).then((xe) => {
      xe && (Oe.to = xe.conversationId, Oe.chatType = xe.chatType), k.sendMessage(Oe);
    }) : k.sendMessage(Oe);
  }, V = () => {
    var _e, Le;
    (_e = g.current) == null || _e.focus(), (Le = g.current) == null || Le.click();
  }, J = [
    {
      content: "IMAGE",
      title: C("image"),
      onClick: S,
      icon: null
    },
    { content: "VIDEO", title: C("video"), onClick: V, icon: null },
    { content: "FILE", title: C("file"), onClick: B, icon: null },
    { content: "CARD", title: C("card"), onClick: U, icon: null }
  ];
  let ue = [];
  a ? ue = a : ue = J;
  const se = /* @__PURE__ */ q.jsx("ul", { className: m, style: { ...s }, children: ue.map((_e, Le) => _e.content == "IMAGE" ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      className: _ == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        Ce(!1), S();
      },
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: "IMG", width: 18, height: 18 }),
        C("image")
      ]
    },
    _e.content || Le
  ) : _e.content == "FILE" ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      className: _ == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        Ce(!1), B();
      },
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: "FOLDER", width: 18, height: 18 }),
        C("file")
      ]
    },
    _e.content || Le
  ) : _e.content == "CARD" ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      className: _ == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        Ce(!1), U();
      },
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: "PERSON_SINGLE_FILL", width: 18, height: 18 }),
        C("userCard")
      ]
    },
    _e.content || Le
  ) : _e.content == "VIDEO" ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      className: _ == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        Ce(!1), V();
      },
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: "TRIANGLE_IN_RECTANGLE", width: 18, height: 18 }),
        C("videoBtn")
      ]
    },
    _e.content || Le
  ) : /* @__PURE__ */ q.jsx(
    "li",
    {
      className: _ == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        Ce(!1), _e.onClick && (_e == null || _e.onClick());
      },
      children: _e.content
    },
    _e.content || Le
  )) }), ee = h || k.currentCVS, de = (_e) => {
    const Le = Zs.utils.getFileUrl(_e.target);
    if (!Le.filename)
      return !1;
    if (!ee.conversationId) {
      console.warn("No specified conversation");
      return;
    }
    const Te = {
      type: "img",
      to: ee.conversationId,
      chatType: ee.chatType,
      file: Le,
      isChatThread: b,
      onFileUploadComplete: (Oe) => {
        const Pe = k.message.byId.get(K.id);
        Pe.thumb = Oe.thumb, Pe.url = Oe.url, k.modifyMessage(K.id, Pe);
      }
    }, K = Zs.message.create(Te);
    l ? l(K).then((Oe) => {
      Oe && (K.to = Oe.conversationId, K.chatType = Oe.chatType), k.sendMessage(K);
    }) : k.sendMessage(K), E.current.value = "";
  }, he = (_e, Le) => {
    const Te = Zs.utils.getFileUrl(_e.target);
    if (!Te.filename)
      return !1;
    if (!ee.conversationId) {
      console.warn("No specified conversation");
      return;
    }
    const K = {
      type: Le,
      to: ee.conversationId,
      chatType: ee.chatType,
      file: Te,
      filename: Te.filename,
      file_length: Te.data.size,
      url: Te.url,
      isChatThread: b,
      onFileUploadComplete(Pe) {
        Le === "video" && (Oe.thumb = Pe.thumb);
      }
    }, Oe = Zs.message.create(K);
    l ? l(Oe).then((Pe) => {
      Pe && (Oe.to = Pe.conversationId, Oe.chatType = Pe.chatType), k.sendMessage(Oe);
    }) : k.sendMessage(Oe), Le === "file" ? y.current.value = "" : g.current.value = "";
  }, [pe, Ce] = tn(!1);
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx(
      va,
      {
        title: se,
        trigger: "click",
        arrowPointAtCenter: !1,
        arrow: !1,
        open: pe,
        onOpenChange: (_e) => {
          Ce(_e);
        },
        placement: "bottomRight",
        children: H
      }
    ),
    /* @__PURE__ */ q.jsx(
      "input",
      {
        type: "file",
        accept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
        ref: E,
        onChange: de,
        style: { display: "none", position: "absolute" }
      }
    ),
    /* @__PURE__ */ q.jsx(
      "input",
      {
        ref: y,
        onChange: (_e) => {
          he(_e, "file");
        },
        type: "file",
        style: { display: "none", position: "absolute" }
      }
    ),
    /* @__PURE__ */ q.jsx(
      "input",
      {
        ref: g,
        onChange: (_e) => {
          he(_e, "video");
        },
        type: "file",
        style: { display: "none", position: "absolute" },
        accept: "video/*"
      }
    ),
    /* @__PURE__ */ q.jsx("div", { style: { position: "absolute" }, children: /* @__PURE__ */ q.jsx(
      gY,
      {
        title: `${C("share")} ${C("contacts")}`,
        selectedPanelHeader: /* @__PURE__ */ q.jsx(q.Fragment, {}),
        onCancel: () => {
          F(!1);
        },
        selectedPanelFooter: /* @__PURE__ */ q.jsxs("div", { children: [
          /* @__PURE__ */ q.jsx(
            gi,
            {
              style: { marginRight: "24px", width: "68px" },
              type: "primary",
              onClick: () => {
                M(), F(!1);
              },
              children: C("confirmBtn")
            }
          ),
          /* @__PURE__ */ q.jsx(
            gi,
            {
              style: { width: "68px" },
              type: "default",
              onClick: () => {
                F(!1);
              },
              children: C("cancelBtn")
            }
          )
        ] }),
        closable: !0,
        enableMultipleSelection: !1,
        open: D,
        onUserSelect: (_e, Le) => {
          G(Le);
        },
        onConfirm: (_e) => {
        }
      }
    ) })
  ] });
};
PN = mi(PN);
const AAe = PN, OAe = (t) => {
  var B;
  const { getPrefixCls: r } = _t.useContext(Hn), { t: a } = Yr(), {
    prefix: u,
    onHide: h,
    conversation: b,
    onSendMessage: l,
    style: v = {},
    className: s
  } = t, c = r("selected-controls", u), d = Zn(Vn), { rootStore: p, theme: m } = d, { addressStore: E } = p, y = (m == null ? void 0 : m.mode) || "light", g = En(
    c,
    {
      [`${c}-${y}`]: !!y
    },
    s
  ), C = b || p.messageStore.currentCVS, O = ((B = p.messageStore.selectedMessage[C.chatType][C.conversationId]) == null ? void 0 : B.selectedMessage) || [], N = (D) => {
    D.keyCode === 27 && w();
  };
  Pn(() => (document.addEventListener("keydown", N, !1), () => {
    document.removeEventListener("keydown", N, !1);
  }), []);
  const w = () => {
    p.messageStore.setSelectedMessage(C, {
      selectable: !1,
      selectedMessage: []
    }), h && h();
  }, _ = () => {
    let D = p.messageStore.selectedMessage[C.chatType][C.conversationId].selectedMessage;
    if (D.length == 0)
      return;
    D = D.sort((M, V) => M.time - V.time);
    const F = D.slice(0, 3);
    let j = "";
    F.forEach((M) => {
      var V, J, ue, se, ee, de, he;
      switch (M.type) {
        case "txt":
          j = j + (((V = E.appUsersInfo[M.from]) == null ? void 0 : V.nickname) || M.from) + ": " + M.msg + `
`;
          break;
        case "img":
          j = `${j}${((J = E.appUsersInfo[M.from]) == null ? void 0 : J.nickname) || M.from}: /${a(
            "image"
          )}/
`;
          break;
        case "audio":
          j = `${j}${((ue = E.appUsersInfo[M.from]) == null ? void 0 : ue.nickname) || M.from}: /${a(
            "audio"
          )}/
`;
          break;
        case "file":
          j = `${j}${((se = E.appUsersInfo[M.from]) == null ? void 0 : se.nickname) || M.from}: /${a(
            "file"
          )}/
`;
          break;
        case "video":
          j = `${j}${((ee = E.appUsersInfo[M.from]) == null ? void 0 : ee.nickname) || M.from}: /${a(
            "video"
          )}/
`;
          break;
        case "custom":
          j = `${j}${((de = E.appUsersInfo[M.from]) == null ? void 0 : de.nickname) || M.from}: /${a(
            "custom"
          )}/
`;
          break;
        case "combine":
          j = `${j}${((he = E.appUsersInfo[M.from]) == null ? void 0 : he.nickname) || M.from}: /${a(
            "chatHistory"
          )}/
`;
          break;
      }
    });
    const G = {
      chatType: C.chatType,
      type: "combine",
      to: C.conversationId,
      deliverOnlineOnly: !1,
      compatibleText: "the combine message",
      title: a("chatHistory"),
      summary: j,
      messageList: D,
      onFileUploadComplete: (M) => {
        p.messageStore.message.byId.get(U.id).url = M.url, p.messageStore.message.byId.get(U.id).secret = M.secret;
      }
    }, U = Zs.message.create(G);
    l == null || l(U);
  }, I = En(`${c}-iconBox`, {
    [`${c}-iconBox-disable`]: O.length == 0
  }), k = () => {
    if (O.length == 0)
      return;
    const D = O.map((F) => F.mid || F.id);
    p.messageStore.deleteMessage(C, D), S(!1), p.messageStore.setSelectedMessage(
      {
        chatType: C.chatType,
        conversationId: C.conversationId
      },
      {
        selectable: !1,
        selectedMessage: []
      }
    );
  }, [H, S] = tn(!1);
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx("div", { className: g, style: { ...v }, children: /* @__PURE__ */ q.jsxs("div", { className: `${c}-content`, children: [
      /* @__PURE__ */ q.jsx("div", { className: `${c}-content-left`, children: /* @__PURE__ */ q.jsx("div", { className: `${c}-iconBox`, onClick: w, children: /* @__PURE__ */ q.jsx(pn, { type: "CLOSE_THIN", width: 24, height: 24 }) }) }),
      /* @__PURE__ */ q.jsxs("div", { className: `${c}-content-right`, children: [
        /* @__PURE__ */ q.jsx(
          "div",
          {
            title: a("cancel"),
            className: I,
            style: { cursor: O.length > 0 ? "pointer" : "not-allowed" },
            onClick: () => {
              O.length > 0 && S(!0);
            },
            children: /* @__PURE__ */ q.jsx(
              pn,
              {
                className: `${c}-content-delete`,
                type: "DELETE",
                width: 24,
                height: 24
              }
            )
          }
        ),
        /* @__PURE__ */ q.jsx(
          "div",
          {
            title: a("forward"),
            className: I,
            style: { cursor: O.length > 0 ? "pointer" : "not-allowed" },
            onClick: _,
            children: /* @__PURE__ */ q.jsx(pn, { type: "FORWARD_LIST", width: 24, height: 24 })
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: H,
        title: a("batchDeletion"),
        okText: a("delete"),
        cancelText: a("cancel"),
        onCancel: () => {
          S(!1);
        },
        onOk: k,
        children: /* @__PURE__ */ q.jsx("div", { className: `${c}-detail`, children: `${a("delete")} ${O.length} ${a(
          "messages"
        )}` })
      }
    )
  ] });
}, CAe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHmSURBVHgBVZHNaxNRFMV/7yUzrVaSiTGRUpREFAQXBgoiurFLQdAsXLiSLlyLa/8I+x+I7lwpLt004FcVxBQFldJmSlNCU23GZNJ8zMfzOqWlfZvHe+ece+85V3HoGNNw6LYfMvxcIY4rmLFLmH1GZNVUed7d56kDgd+sMHy9iP/GMf5IkBjSFsqWm7Muu2eq6tLj+oHIDBolvOdfzZ8PznD0i1C7qBB0JDp9Ecu5gFIZj05hTl1ZqKeTNr1XT+kuOX7wDtuZ5YR9TSpB7LtonSHeaZKaPu8w2Xoi7DllWh9LxC8aQfst0ZTFpF0g7qxigoBU7py0gmjtC6owi7ZlsBZljRVcJmoSBx6WNYPptRj1fhD2V4j//paO4imQOf0uWDJz1K+khZEAyqRQwY4YyYgXk3iSR4LpUB6CJwUiT37H3WVMltREgbCzhjo+gTVzm/Tp6+hTxT3iOEBlTsJgKEZ7da3K92QXxVoqU0SNhoTN7+jBFvp/5O5P8dCU2HOQz0K/V1M3XVfvpXfsEZHtpaevolJ54vVPJl5ZwrRXBcxD5ZaIv3m0NuaPLvf9gwq5rZdMUcJMyYfEZtkSwqYI1j02N6rqrl87IkqEi3dK2N0b2KP7RMMShHW2t5cJdxdU1fP2ef8AE+zZe/Pyvt0AAAAASUVORK5CYII=", SAe = (t) => {
  const {
    className: r,
    prefix: a,
    title: u,
    subTitle: h,
    selected: b,
    action: l,
    onClick: v,
    giftId: s,
    image: c
  } = t, { getPrefixCls: d } = _t.useContext(Hn), p = d("gift", a);
  tn(b), tn(!1);
  const m = En(
    p,
    {
      [`${p}-selected`]: b
    },
    r
  ), E = () => {
    v && (v == null || v(s));
  }, y = () => {
  };
  return /* @__PURE__ */ q.jsxs("div", { className: m, onClick: E, children: [
    /* @__PURE__ */ q.jsx("img", { src: c, alt: u }),
    !b && /* @__PURE__ */ q.jsx("div", { className: `${p}-title`, children: u }),
    /* @__PURE__ */ q.jsxs("div", { className: `${p}-subtitle`, children: [
      /* @__PURE__ */ q.jsx("img", { src: CAe, alt: "coin" }),
      " ",
      h
    ] }),
    b && /* @__PURE__ */ q.jsx("div", { className: `${p}-button`, onClick: (l == null ? void 0 : l.onClick) || y, children: l == null ? void 0 : l.text })
  ] }, u);
}, IAe = {
  gifts: [
    {
      giftId: "2665752a-e273-427c-ac5a-4b2a9c82b255",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift1.png",
      giftName: "Heart",
      giftPrice: "1"
    },
    {
      giftId: "ff3bbb9e-ef18-430f-aa61-5bddf75eb722",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift2.png",
      giftName: "Rose",
      giftPrice: "2"
    },
    {
      giftId: "94f296fa-86d9-4552-84db-025b05ed9f8d",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift3.png",
      giftName: "Super Cube",
      giftPrice: "5"
    },
    {
      giftId: "d4cd0526-d8db-4e00-8fc0-d5228907a517",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift4.png",
      giftName: "Alpha",
      giftPrice: "10"
    },
    {
      giftId: "c1997f02-d927-46f5-adda-e6af6714bd75",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift5.png",
      giftName: "Star",
      giftPrice: "20"
    },
    {
      giftId: "0c62b402-376f-4fbb-b584-769a8249189e",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift6.png",
      giftName: "Lollipop",
      giftPrice: "30"
    },
    {
      giftId: "ce3f8bc3-74d7-43be-a040-c397d5c49f6d",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift7.png",
      giftName: "Diamond",
      giftPrice: "50"
    },
    {
      giftId: "948b1a3b-b2c6-41fc-99b7-a5b9457cd159",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift8.png",
      giftName: "Crown",
      giftPrice: "100"
    },
    {
      giftId: "f1e12397-feb7-4c01-b834-f11faf321dbf",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift9.png",
      giftName: "Mic",
      giftPrice: "500"
    },
    {
      giftId: "e915438c-7fbd-4e03-840f-0036ec97c824",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift10.png",
      giftEffect: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pag/ballon.pag",
      giftName: "Balloon",
      giftPrice: "666",
      effectMD5: "141761700268c0290852af8f6a501c10"
    },
    {
      giftId: "0c832b52-8f2e-4202-958b-9410db2d9438",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift11.png",
      giftEffect: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pag/planet.pag",
      giftName: "Planet",
      giftPrice: "888",
      effectMD5: "41f3eeff249be268004d82a1d1eaf481"
    },
    {
      giftId: "beada6a3-eae6-450e-869c-743d02fa95e7",
      giftIcon: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pictures/gift/AUIKitGift12.png",
      giftEffect: "https://fullapp.oss-cn-beijing.aliyuncs.com/uikit/pag/rocket.pag",
      giftName: "Rocket",
      giftPrice: "1000",
      effectMD5: "de5094b30eebeadf8b8f5d8357a19578"
    }
  ]
}, mY = (t) => {
  const {
    icon: r,
    trigger: a = "click",
    gifts: u,
    conversation: h,
    onSendMessage: b,
    onBeforeSendMessage: l,
    giftConfig: v,
    prefix: s,
    className: c,
    closeAfterClick: d
  } = t, { t: p } = Yr(), m = Zn(Vn), { rootStore: E } = m, { messageStore: y, conversationStore: g } = E, C = g.currentCvs, O = h || C, { getPrefixCls: N } = _t.useContext(Hn), w = N("giftKeyboard", s), [_, I] = tn(!1), k = En(
    w,
    // {
    //   [`${prefixCls}-${themeMode}`]: !!themeMode,
    // },
    c
  ), H = r || /* @__PURE__ */ q.jsx("span", { className: k, title: p("gift"), children: /* @__PURE__ */ q.jsx(
    pn,
    {
      type: "GIFT",
      width: 24,
      height: 24,
      onClick: () => I(!0)
    }
  ) }), S = (M) => {
    if (console.log("conversation", h), !O)
      throw new Error("currentConversation is null");
    const V = {
      type: "custom",
      to: O.conversationId,
      chatType: O.chatType,
      customEvent: "CHATROOMUIKITGIFT",
      customExts: {
        chatroom_uikit_gift: JSON.stringify(M)
      },
      ext: {}
    }, J = Zs.message.create(V);
    y.sendMessage(J).then(() => {
      b && b(J);
    });
  }, [B, D] = tn(""), F = (M) => {
    console.log("e", M), D(M);
  }, j = (M) => {
    S(M);
  };
  let G;
  u && (G = /* @__PURE__ */ q.jsx("div", { className: "content", children: u }));
  const U = v || IAe;
  return G = /* @__PURE__ */ q.jsx("div", { className: "content", children: U.gifts.map((M, V) => /* @__PURE__ */ q.jsx(
    SAe,
    {
      giftId: M.giftId,
      title: p(M.giftName),
      subTitle: M.giftPrice,
      onClick: F,
      image: M.giftIcon,
      action: {
        visible: !0,
        text: p("send"),
        onClick: () => {
          const J = {
            ...M,
            giftCount: 1
          };
          j(J), I(!1);
        }
      },
      selected: B == M.giftId
    },
    M.giftId
  )) }), d == !1 ? /* @__PURE__ */ q.jsx(va, { title: G, trigger: a, arrowPointAtCenter: !1, arrow: !1, children: H }) : /* @__PURE__ */ q.jsx(
    va,
    {
      title: G,
      trigger: a,
      arrowPointAtCenter: !1,
      arrow: !1,
      onOpenChange: () => {
        I(!_);
      },
      open: _,
      children: H
    }
  );
};
function RAe(t) {
  return function() {
    var c, d, p;
    let a = [], u = document.createElement("div");
    u.innerHTML = t.replace(/\\/g, "###h###");
    const h = u.querySelectorAll("img"), b = u.querySelectorAll("div");
    let l = h.length, v = b.length;
    for (; l--; ) {
      const m = document.createTextNode(h[l].getAttribute("data-key"));
      (c = h[l].parentNode) == null || c.insertBefore(m, h[l]), (d = h[l].parentNode) == null || d.removeChild(h[l]);
    }
    for (; v--; ) a.push(b[v].innerHTML), (p = b[v].parentNode) == null || p.removeChild(b[v]);
    const s = (a = a.reverse()).length ? `
` + a.join(`
`) : a.join(`
`);
    return (u.innerText + s).replace(/###h###/g, "&#92;").replace(/<br>/g, `
`).replace(/&amp;/g, "&");
  }().replace(/&nbsp;/g, " ").trim();
}
const EY = [
  {
    name: "RECORDER",
    visible: !0,
    icon: ""
  },
  {
    name: "TEXTAREA",
    visible: !0,
    icon: ""
  },
  {
    name: "EMOJI",
    visible: !0,
    icon: ""
  },
  {
    name: "MORE",
    visible: !0,
    icon: ""
  }
], yY = (t) => {
  var Ce, _e;
  const [r, a] = tn(!0), [u, h] = tn(!0), [b, l] = tn(!1);
  tn(null);
  const v = er(null), s = Zn(Vn), { rootStore: c, theme: d } = s, p = (d == null ? void 0 : d.mode) || "light", m = (d == null ? void 0 : d.componentsShape) || "round", { t: E } = Yr(), y = (Le, Te) => {
    if (!v.current) return;
    const K = v.current.divRef.current;
    K.innerText.length;
    let Oe, Pe;
    if ("getSelection" in window) {
      const be = window.getSelection();
      be && be.rangeCount === 1 && (K.focus(), Oe = be.getRangeAt(0), Pe = new Image(), Pe.src = Le, Pe.setAttribute("data-key", Te), Pe.setAttribute("width", "16px"), Pe.setAttribute("height", "16px"), Pe.draggable = !1, Pe.className = "message-text-emoji", Pe.setAttribute("title", Te.replace("[", "").replace("]", "")), Pe.setAttribute("style", "vertical-align: middle"), Oe.deleteContents(), Oe.insertNode(Pe), Oe.collapse(!1), be.removeAllRanges(), be.addRange(Oe));
    } else "selection" in document && (K.focus(), // @ts-ignore
    (Oe = document.selection.createRange()).pasteHTML(
      '<img class="emoj-insert" draggable="false" data-key="' + Te + '" title="' + Te.replace("[", "").replace("]", "") + '" src="' + Le + '">'
    ), K.focus());
    const xe = RAe(K.innerHTML).trim();
    v.current.setTextareaValue(xe);
  }, g = () => {
    if (!v.current) return;
    const Le = v.current.divRef.current, Te = document.createRange();
    Te.selectNodeContents(Le), Te.collapse(!1);
    const K = window.getSelection();
    K == null || K.removeAllRanges(), K == null || K.addRange(Te);
  }, C = (Le) => {
    if (!Le) return;
    v.current.setTextareaValue((K) => K + Le);
    const Te = new URL((/* @__PURE__ */ Object.assign({ "/module/assets/reactions/U+1F308.png": lg, "/module/assets/reactions/U+1F31C.png": fg, "/module/assets/reactions/U+1F31F.png": hg, "/module/assets/reactions/U+1F381.png": pg, "/module/assets/reactions/U+1F382.png": gg, "/module/assets/reactions/U+1F389.png": mg, "/module/assets/reactions/U+1F44D.png": Eg, "/module/assets/reactions/U+1F44E.png": yg, "/module/assets/reactions/U+1F44F.png": vg, "/module/assets/reactions/U+1F47F.png": Tg, "/module/assets/reactions/U+1F48B.png": bg, "/module/assets/reactions/U+1F490.png": Ag, "/module/assets/reactions/U+1F494.png": Og, "/module/assets/reactions/U+1F495.png": Cg, "/module/assets/reactions/U+1F4A9.png": Sg, "/module/assets/reactions/U+1F600.png": Ig, "/module/assets/reactions/U+1F604.png": Rg, "/module/assets/reactions/U+1F607.png": Ng, "/module/assets/reactions/U+1F609.png": wg, "/module/assets/reactions/U+1F60D.png": _g, "/module/assets/reactions/U+1F60E.png": Pg, "/module/assets/reactions/U+1F610.png": xg, "/module/assets/reactions/U+1F618.png": Dg, "/module/assets/reactions/U+1F620.png": Mg, "/module/assets/reactions/U+1F621.png": Lg, "/module/assets/reactions/U+1F62B.png": kg, "/module/assets/reactions/U+1F62C.png": jg, "/module/assets/reactions/U+1F62D.png": Ug, "/module/assets/reactions/U+1F62E.png": Hg, "/module/assets/reactions/U+1F631.png": Bg, "/module/assets/reactions/U+1F633.png": zg, "/module/assets/reactions/U+1F637.png": Fg, "/module/assets/reactions/U+1F641.png": Gg, "/module/assets/reactions/U+1F644.png": Vg, "/module/assets/reactions/U+1F64C.png": Yg, "/module/assets/reactions/U+1F64F.png": Xg, "/module/assets/reactions/U+1F910.png": Wg, "/module/assets/reactions/U+1F912.png": qg, "/module/assets/reactions/U+1F913.png": Kg, "/module/assets/reactions/U+1F91D.png": Jg, "/module/assets/reactions/U+1F922.png": Zg, "/module/assets/reactions/U+1F928.png": Qg, "/module/assets/reactions/U+1F92A.png": $g, "/module/assets/reactions/U+1F92C.png": em, "/module/assets/reactions/U+1F971.png": tm, "/module/assets/reactions/U+1F973.png": nm, "/module/assets/reactions/U+1F974.png": rm, "/module/assets/reactions/U+1F97A.png": im, "/module/assets/reactions/U+2600.png": sm, "/module/assets/reactions/U+263A.png": am, "/module/assets/reactions/U+2764.png": om, "/module/assets/reactions/U+2B50.png": cm }))[`/module/assets/reactions/${vm.map[Le]}`], import.meta.url).href;
    y(Te, Le);
  }, {
    actions: O = EY,
    placeHolder: N,
    disabled: w,
    className: _,
    prefix: I,
    isChatThread: k,
    onSendMessage: H,
    conversation: S,
    onBeforeSendMessage: B,
    enabledTyping: D,
    customActions: F,
    style: j = {},
    giftKeyboardProps: G,
    onChange: U,
    onFocus: M
  } = t;
  Pn(() => {
    const Le = O == null ? void 0 : O.find((Te) => Te.name === "RECORDER");
    h(!!Le);
  }, []);
  const V = S || c.conversationStore.currentCvs || {};
  Pn(() => {
    v.current && (v.current.divRef.current.innerHTML = "", v.current.setTextareaValue(""));
  }, [V.conversationId]), Pn(() => {
    var Le, Te;
    (Te = (Le = c.messageStore.selectedMessage[V.chatType]) == null ? void 0 : Le[V.conversationId]) != null && Te.selectable ? (l(!0), a(!1), h(!1)) : (l(!1), a(!0), O != null && O.find((Oe) => Oe.name === "RECORDER") && h(!0));
  }, [
    (_e = (Ce = c.messageStore.selectedMessage[V.chatType]) == null ? void 0 : Ce[V.conversationId]) == null ? void 0 : _e.selectable
  ]);
  const { getPrefixCls: J } = _t.useContext(Hn), ue = J("message-editor", I), se = En(
    ue,
    {
      [`${ue}-disabled`]: w,
      [`${ue}-${p}`]: !!p
    },
    _
  ), ee = (Le) => {
    H && H(Le);
  }, [de, he] = tn(!1), pe = (O == null ? void 0 : O.find((Le) => Le.name === "TEXTAREA")) && r && de;
  return /* @__PURE__ */ q.jsxs("div", { className: se, style: { ...j }, children: [
    u && !de && /* @__PURE__ */ q.jsx(
      yAe,
      {
        isChatThread: k,
        onBeforeSendMessage: B,
        conversation: S,
        onShow: () => a(!1),
        onHide: () => a(!0),
        onSend: () => a(!0)
      }
    ),
    r && /* @__PURE__ */ q.jsx(q.Fragment, { children: O.map((Le, Te) => {
      if (Le.name === "RECORDER" && Le.visible)
        return null;
      if (Le.name === "TEXTAREA" && Le.visible)
        return /* @__PURE__ */ q.jsx(
          Kw,
          {
            enabledTyping: D,
            isChatThread: k,
            ref: v,
            hasSendButton: !1,
            placeholder: N,
            onSendMessage: H,
            onChange: (K) => {
              K.length > 0 ? he(!0) : he(!1), U == null || U(K);
            },
            onFocus: M,
            conversation: S,
            enabledMention: t.enabledMention,
            onBeforeSendMessage: B
          },
          Le.name
        );
      if (Le.name === "EMOJI" && Le.visible)
        return /* @__PURE__ */ q.jsx(
          uY,
          {
            onSelected: C,
            onClick: g,
            placement: "bottomRight"
          },
          Le.name
        );
      if (Le.name === "MORE" && Le.visible)
        return de ? null : /* @__PURE__ */ q.jsx(
          AAe,
          {
            isChatThread: k,
            onBeforeSendMessage: B,
            customActions: F
          },
          Le.name
        );
      if (Le.name === "GIFT" && Le.visible)
        return de ? null : /* @__PURE__ */ q.jsx(mY, { conversation: S, ...G }, Le.name);
      if (Le.visible)
        return /* @__PURE__ */ q.jsx(
          "span",
          {
            className: "icon-container",
            onClick: () => {
              var K;
              (K = Le == null ? void 0 : Le.onClick) == null || K.call(Le);
            },
            children: Le.icon
          },
          Le.name
        );
    }) }),
    pe && /* @__PURE__ */ q.jsx(
      "div",
      {
        className: En(`${ue}-sendBtn`, {
          [`${ue}-sendBtn-round`]: m == "round"
        }),
        title: E("send"),
        children: /* @__PURE__ */ q.jsx(
          pn,
          {
            type: "AIR_PLANE",
            width: 24,
            height: 24,
            color: "#F9FAFA",
            onClick: () => {
              var Le;
              (Le = v.current) == null || Le.sendMessage();
            }
          }
        )
      }
    ),
    b && /* @__PURE__ */ q.jsx(
      OAe,
      {
        onSendMessage: ee,
        conversation: S,
        onHide: () => {
          a(!0), l(!1);
        }
      }
    )
  ] });
};
yY.defaultActions = EY;
const zv = mi(yY);
zv.displayName = "MessageInput";
function NAe(t, r) {
  var a = typeof Symbol == "function" && t[Symbol.iterator];
  if (!a) return t;
  var u = a.call(t), h, b = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(h = u.next()).done; ) b.push(h.value);
  } catch (v) {
    l = { error: v };
  } finally {
    try {
      h && !h.done && (a = u.return) && a.call(u);
    } finally {
      if (l) throw l.error;
    }
  }
  return b;
}
function wAe(t, r, a) {
  if (a || arguments.length === 2) for (var u = 0, h = r.length, b; u < h; u++)
    (b || !(u in r)) && (b || (b = Array.prototype.slice.call(r, 0, u)), b[u] = r[u]);
  return t.concat(b || Array.prototype.slice.call(r));
}
var vY = function(t) {
  return typeof t == "function";
}, TY = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
function bY(t) {
  var r = er(t);
  return r.current = t, r;
}
var _Ae = function(t) {
  TY && (vY(t) || console.error("useUnmount expected parameter is a function, got ".concat(typeof t)));
  var r = bY(t);
  Pn(function() {
    return function() {
      r.current();
    };
  }, []);
};
function PAe(t) {
  var r = typeof t;
  return t != null && (r == "object" || r == "function");
}
var AY = PAe, xAe = typeof rn == "object" && rn && rn.Object === Object && rn, DAe = xAe, MAe = DAe, LAe = typeof self == "object" && self && self.Object === Object && self, kAe = MAe || LAe || Function("return this")(), OY = kAe, jAe = OY, UAe = function() {
  return jAe.Date.now();
}, HAe = UAe, BAe = /\s/;
function zAe(t) {
  for (var r = t.length; r-- && BAe.test(t.charAt(r)); )
    ;
  return r;
}
var FAe = zAe, GAe = FAe, VAe = /^\s+/;
function YAe(t) {
  return t && t.slice(0, GAe(t) + 1).replace(VAe, "");
}
var XAe = YAe, WAe = OY, qAe = WAe.Symbol, CY = qAe, RH = CY, SY = Object.prototype, KAe = SY.hasOwnProperty, JAe = SY.toString, Ny = RH ? RH.toStringTag : void 0;
function ZAe(t) {
  var r = KAe.call(t, Ny), a = t[Ny];
  try {
    t[Ny] = void 0;
    var u = !0;
  } catch {
  }
  var h = JAe.call(t);
  return u && (r ? t[Ny] = a : delete t[Ny]), h;
}
var QAe = ZAe, $Ae = Object.prototype, eOe = $Ae.toString;
function tOe(t) {
  return eOe.call(t);
}
var nOe = tOe, NH = CY, rOe = QAe, iOe = nOe, sOe = "[object Null]", aOe = "[object Undefined]", wH = NH ? NH.toStringTag : void 0;
function oOe(t) {
  return t == null ? t === void 0 ? aOe : sOe : wH && wH in Object(t) ? rOe(t) : iOe(t);
}
var cOe = oOe;
function uOe(t) {
  return t != null && typeof t == "object";
}
var dOe = uOe, lOe = cOe, fOe = dOe, hOe = "[object Symbol]";
function pOe(t) {
  return typeof t == "symbol" || fOe(t) && lOe(t) == hOe;
}
var gOe = pOe, mOe = XAe, _H = AY, EOe = gOe, PH = NaN, yOe = /^[-+]0x[0-9a-f]+$/i, vOe = /^0b[01]+$/i, TOe = /^0o[0-7]+$/i, bOe = parseInt;
function AOe(t) {
  if (typeof t == "number")
    return t;
  if (EOe(t))
    return PH;
  if (_H(t)) {
    var r = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = _H(r) ? r + "" : r;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = mOe(t);
  var a = vOe.test(t);
  return a || TOe.test(t) ? bOe(t.slice(2), a ? 2 : 8) : yOe.test(t) ? PH : +t;
}
var OOe = AOe, COe = AY, ZR = HAe, xH = OOe, SOe = "Expected a function", IOe = Math.max, ROe = Math.min;
function NOe(t, r, a) {
  var u, h, b, l, v, s, c = 0, d = !1, p = !1, m = !0;
  if (typeof t != "function")
    throw new TypeError(SOe);
  r = xH(r) || 0, COe(a) && (d = !!a.leading, p = "maxWait" in a, b = p ? IOe(xH(a.maxWait) || 0, r) : b, m = "trailing" in a ? !!a.trailing : m);
  function E(k) {
    var H = u, S = h;
    return u = h = void 0, c = k, l = t.apply(S, H), l;
  }
  function y(k) {
    return c = k, v = setTimeout(O, r), d ? E(k) : l;
  }
  function g(k) {
    var H = k - s, S = k - c, B = r - H;
    return p ? ROe(B, b - S) : B;
  }
  function C(k) {
    var H = k - s, S = k - c;
    return s === void 0 || H >= r || H < 0 || p && S >= b;
  }
  function O() {
    var k = ZR();
    if (C(k))
      return N(k);
    v = setTimeout(O, g(k));
  }
  function N(k) {
    return v = void 0, m && u ? E(k) : (u = h = void 0, l);
  }
  function w() {
    v !== void 0 && clearTimeout(v), c = 0, u = s = h = v = void 0;
  }
  function _() {
    return v === void 0 ? l : N(ZR());
  }
  function I() {
    var k = ZR(), H = C(k);
    if (u = arguments, h = this, s = k, H) {
      if (v === void 0)
        return y(s);
      if (p)
        return clearTimeout(v), v = setTimeout(O, r), E(s);
    }
    return v === void 0 && (v = setTimeout(O, r)), l;
  }
  return I.cancel = w, I.flush = _, I;
}
var wOe = NOe;
const _Oe = /* @__PURE__ */ Gl(wOe);
function POe() {
  var t = (typeof global > "u" ? "undefined" : typeof global) == "object" && global && global.Object === Object && global, r = typeof self == "object" && self && self.Object === Object && self;
  return t || r;
}
POe() || (global.Date = Date);
function xOe(t, r) {
  var a;
  TY && (vY(t) || console.error("useDebounceFn expected parameter is a function, got ".concat(typeof t)));
  var u = bY(t), h = (a = r == null ? void 0 : r.wait) !== null && a !== void 0 ? a : 1e3, b = Wy(function() {
    return _Oe(function() {
      for (var l = [], v = 0; v < arguments.length; v++)
        l[v] = arguments[v];
      return u.current.apply(u, wAe([], NAe(l), !1));
    }, h, r);
  }, []);
  return _Ae(function() {
    b.cancel();
  }), {
    run: b,
    cancel: b.cancel,
    flush: b.flush
  };
}
const Fv = function() {
  return Pd(
    mi(
      Gu(function(a, u) {
        const {
          className: h,
          style: b,
          renderItem: l,
          paddingHeight: v,
          loadMoreItems: s,
          scrollTo: c,
          hasMore: d = !0,
          prefix: p,
          loading: m = !1,
          scrollDirection: E = "up",
          data: y,
          onScroll: g
        } = a, { run: C } = xOe(
          () => {
            s == null || s();
          },
          {
            wait: 100
          }
        ), { getPrefixCls: O } = _t.useContext(Hn), N = O("scrollList", p), { theme: w } = _t.useContext(Vn), _ = w == null ? void 0 : w.mode, I = En(
          N,
          {
            [`${N}-${_}`]: !!_
          },
          h
        ), k = er(null);
        lv(u, () => {
          var j;
          return {
            scrollTo: H,
            scrollHeight: ((j = k == null ? void 0 : k.current) == null ? void 0 : j.scrollHeight) || 0,
            scrollTop: S
          };
        });
        const H = (j) => {
          var G;
          k && (j === "top" ? k.current.scrollTop = 0 : j === "bottom" ? k.current.scrollTop = ((G = k == null ? void 0 : k.current) == null ? void 0 : G.scrollHeight) || 0 : k.current.scrollTop = j || 0);
        }, [S, B] = tn(0), [D, F] = tn(0);
        return Pn(() => {
          var G;
          const j = (U) => {
            var ue;
            if (g == null || g(U), !d || m) return;
            const M = (ue = U.target) == null ? void 0 : ue.scrollHeight, V = U.target.scrollTop, J = U.target.offsetHeight;
            if (B(V), E === "up" && V < 100) {
              const se = M - (V + J);
              F(se), C();
            }
            if (E === "down") {
              const se = M - (V + J);
              F(se), se < 50 && C();
            }
          };
          return (G = k.current) == null || G.addEventListener("scroll", j), () => {
            var U;
            (U = k.current) == null || U.removeEventListener("scroll", j);
          };
        }, [d, m]), Pn(() => {
          if (k.current && E == "up" && S < 100) {
            const j = k.current.scrollHeight, G = k.current.offsetHeight;
            k.current.scrollTop = j - D - G;
          }
        }, [y.length]), /* @__PURE__ */ q.jsx("div", { className: I, style: b, ref: k, children: /* @__PURE__ */ q.jsx("div", { style: { overflowAnchor: "none" }, children: /* @__PURE__ */ q.jsx(IY, { data: y, renderItem: l }) }) });
      })
    )
  );
}, IY = Pd(
  (t) => {
    const { data: r, renderItem: a } = t;
    return /* @__PURE__ */ q.jsx(q.Fragment, { children: r.map((u, h) => a(u, h)) });
  }
);
IY.displayName = "RenderItem";
const DOe = Fv();
let cv = (t) => {
  var U;
  const r = Zn(Vn).rootStore, { messageStore: a } = r, {
    prefix: u,
    className: h,
    renderMessage: b,
    renderUserProfile: l,
    conversation: v,
    isThread: s,
    messageProps: c,
    style: d = {}
  } = t, { t: p } = Yr(), { getPrefixCls: m } = _t.useContext(Hn), E = m("messageList", u), y = En(E, h), g = Zn(Vn), { initConfig: C } = g, { useUserInfo: O } = C, N = er(null), w = _t.useMemo(() => ({
    messageProps: c
  }), []), _ = v || a.currentCVS || {}, { loadMore: I, isLoading: k } = Lge(_), H = ((U = a.message[_.chatType]) == null ? void 0 : U[_.conversationId]) || [], S = (M) => {
    if (b) {
      const V = b(H[M.index]);
      return Vl(V, (J) => ({
        style: {
          ...M.style,
          ...J.style
        }
      })), V;
    }
    if (H[M.index].type == "audio")
      return /* @__PURE__ */ q.jsx(
        Xm,
        {
          audioMessage: H[M.index],
          style: M.style,
          renderUserProfile: l,
          thread: s,
          ...c
        },
        H[M.index].id
      );
    if (H[M.index].type == "img")
      return /* @__PURE__ */ q.jsx(
        kv,
        {
          imageMessage: H[M.index],
          style: M.style,
          renderUserProfile: l,
          thread: s,
          imgProps: {
            onLoad: () => {
              var V;
              a.unreadMessageCount <= 0 && //@ts-ignore
              F.current.scrollHeight - F.current.scrollTop - 10 < //@ts-ignore
              ((V = N.current) == null ? void 0 : V.clientHeight) && G();
            }
          },
          ...c
        },
        H[M.index].id
      );
    if (H[M.index].type == "file")
      return /* @__PURE__ */ q.jsx(
        jv,
        {
          fileMessage: H[M.index],
          style: M.style,
          renderUserProfile: l,
          thread: s,
          ...c
        },
        H[M.index].id
      );
    if (H[M.index].type == "notice" || H[M.index].type == "recall")
      return /* @__PURE__ */ q.jsx(Dge, { noticeMessage: H[M.index] });
    if (H[M.index].type == "txt")
      return /* @__PURE__ */ q.jsx(
        Dd,
        {
          status: H[M.index].status,
          textMessage: H[M.index],
          renderUserProfile: l,
          thread: s,
          onOpenThreadPanel: t.onOpenThreadPanel || (() => {
          }),
          ...w.messageProps
        },
        H[M.index].id
      );
    if (H[M.index].type == "combine")
      return /* @__PURE__ */ q.jsx(
        Hv,
        {
          style: M.style,
          status: H[M.index].status,
          combinedMessage: H[M.index],
          renderUserProfile: l,
          thread: s,
          ...c
        },
        H[M.index].id
      );
    if (H[M.index].type == "video")
      return /* @__PURE__ */ q.jsx(
        Uv,
        {
          videoMessage: H[M.index],
          style: M.style,
          renderUserProfile: l,
          thread: s,
          videoProps: {
            onLoadedMetadata: () => {
              var V;
              a.unreadMessageCount <= 0 && //@ts-ignore
              F.current.scrollHeight - F.current.scrollTop - 10 < //@ts-ignore
              ((V = N.current) == null ? void 0 : V.clientHeight) && G();
            }
          },
          ...c
        },
        H[M.index].id
      );
    if (H[M.index].type == "loc")
      return /* @__PURE__ */ q.jsx(
        RN,
        {
          style: M.style,
          status: H[M.index].status,
          message: H[M.index],
          children: H[M.index].msg
        },
        H[M.index].id
      );
    if (H[M.index].type == "custom" && H[M.index].customEvent == "userCard")
      return /* @__PURE__ */ q.jsx(
        PA,
        {
          renderUserProfile: l,
          style: M.style,
          thread: s,
          customMessage: H[M.index],
          ...c
        },
        H[M.index].id
      );
  }, B = H[H.length - 1], D = (B == null ? void 0 : B.id) || "", F = _t.useRef(null);
  Pn(() => {
    if ((B == null ? void 0 : B.type) === "recall")
      return;
    const M = B == null ? void 0 : B.from;
    (B == null ? void 0 : B.type) != "notice" && a.holding && M != "" && M != r.client.user || setTimeout(() => {
      var V;
      (V = F == null ? void 0 : F.current) == null || V.scrollTo("bottom");
    }, 10);
  }, [D, B == null ? void 0 : B.reactions]), Pn(() => {
    var M;
    if (!s && ((M = F == null ? void 0 : F.current) == null || M.scrollTo("bottom"), _ && _.chatType === "groupChat")) {
      if (!_.conversationId) return;
      const { getGroupMemberList: V } = $w(
        _.conversationId,
        O ?? !0
      ), { getGroupAdmins: J } = TAe(_.conversationId);
      J(), V == null || V();
    }
  }, [_]);
  const j = (M) => {
    var ee;
    const V = (ee = M.target) == null ? void 0 : ee.scrollHeight, J = M.target.scrollTop, ue = M.target.offsetHeight;
    V - (J + ue) > 10 ? !a.holding && a.setHoldingStatus(!0) : (a.holding && a.setHoldingStatus(!1), a.setUnreadMessageCount(0));
  }, G = () => {
    var M;
    (M = F == null ? void 0 : F.current) == null || M.scrollTo("bottom");
  };
  return /* @__PURE__ */ q.jsxs("div", { className: y, style: { ...d }, ref: N, id: "listContainer", children: [
    /* @__PURE__ */ q.jsx(
      DOe,
      {
        ref: F,
        hasMore: !0,
        data: H,
        loading: k,
        loadMoreItems: I,
        onScroll: j,
        renderItem: (M, V) => /* @__PURE__ */ q.jsx("div", { className: `${y}-msgItem`, children: S({ index: V, style: {} }) }, M.id)
      }
    ),
    a.unreadMessageCount > 0 && /* @__PURE__ */ q.jsxs("div", { className: "cui-unread-message-count", onClick: G, children: [
      /* @__PURE__ */ q.jsx(pn, { type: "ARROW_DOWN_THICK", width: 20, height: 20 }),
      a.unreadMessageCount > 99 ? "99+" : a.unreadMessageCount,
      " ",
      p("newMessage")
    ] })
  ] });
};
cv = mi(cv);
let xN = (t) => {
  var N, w;
  const { prefix: r, className: a, style: u, onHide: h, onShow: b, conversation: l } = t, { getPrefixCls: v } = _t.useContext(Hn), s = v("typing", r), c = En(s, a), d = Zt.messageStore.typing[l.conversationId], [p, m] = tn(!1), E = er(), y = () => {
    m(!0), b == null || b(), E.current && clearTimeout(E.current), E.current = setTimeout(() => {
      g();
    }, 5e3);
  }, g = () => {
    m(!1), h == null || h(), E.current && clearTimeout(E.current);
  };
  Pn(() => {
    d ? y() : g();
  }, [d]);
  const C = (N = Zt.addressStore.appUsersInfo[l.conversationId]) == null ? void 0 : N.avatarurl, O = (w = Zt.addressStore.appUsersInfo[l.conversationId]) == null ? void 0 : w.nickname;
  return /* @__PURE__ */ q.jsxs("div", { className: c, style: { ...u, display: p ? "flex" : "none" }, children: [
    /* @__PURE__ */ q.jsx(zs, { size: 16, src: C, style: { fontSize: "12px" }, children: O || l.conversationId }),
    /* @__PURE__ */ q.jsxs("div", { className: "loading", children: [
      /* @__PURE__ */ q.jsx("div", { className: "loading-dot" }),
      /* @__PURE__ */ q.jsx("div", { className: "loading-dot" }),
      /* @__PURE__ */ q.jsx("div", { className: "loading-dot" })
    ] })
  ] });
};
xN = mi(xN);
const MOe = xN, Ml = Gu((t, r) => {
  const {
    className: a,
    size: u,
    required: h,
    value: b = "",
    onChange: l,
    prefix: v,
    onClear: s,
    placeholder: c,
    shape: d,
    close: p,
    suffixIcon: m,
    style: E = {},
    onFocus: y,
    onBlur: g,
    ...C
  } = t, { getPrefixCls: O } = _t.useContext(Hn), N = O("input", v), [w, _] = tn(b), [I, k] = tn(!1), [H, S] = tn(!1), { theme: B } = _t.useContext(Vn), D = B == null ? void 0 : B.mode, F = d || (B == null ? void 0 : B.componentsShape) || "round", j = En(
    N,
    {
      [`${N}-${u}`]: u,
      [`${N}-required`]: h,
      [`${N}-disabled`]: t.disabled,
      [`${N}-${F}`]: F,
      [`${N}-error`]: h && !w,
      [`${N}-suffixIcon`]: m,
      [`${N}-${D}`]: !!D
    },
    a
  );
  Pn(() => {
    _(b), p && b.length > 0 && S(!0);
  }, [b]);
  const G = (se) => {
    _(se.target.value), l == null || l(se), se.target.value.length > 0 && p && S(!0);
  }, U = () => {
    _(""), s == null || s(), S(!1);
  }, M = () => {
    k(!0), y == null || y();
  }, V = () => {
    k(!1), g == null || g();
  }, J = (se) => {
    S(se.target.value.length > 0);
  }, ue = () => {
    const { suffix: se } = t;
    return se ? /* @__PURE__ */ q.jsx("span", { className: `${N}-suffixIcon`, children: se }) : H ? /* @__PURE__ */ q.jsx("span", { className: `${N}-suffixIcon`, children: /* @__PURE__ */ q.jsx(pn, { type: "CLOSE_CIRCLE", className: `${N}-clear`, onClick: U }) }) : null;
  };
  return /* @__PURE__ */ q.jsxs("div", { className: j, style: { ...E }, children: [
    /* @__PURE__ */ q.jsx(
      "input",
      {
        ref: r,
        disabled: t.disabled,
        placeholder: c,
        value: w,
        onChange: G,
        onFocus: M,
        onBlur: V,
        onInput: J,
        className: `${N}-input`,
        type: "text",
        ...C
      }
    ),
    ue()
  ] });
});
Ml.displayName = "Input";
const LOe = Fv(), kOe = mi((t) => {
  var ue, se;
  const { prefix: r, onClose: a, className: u, headerContent: h } = t, { getPrefixCls: b } = _t.useContext(Hn), l = Zn(Vn), { theme: v, rootStore: s } = l;
  s.addressStore;
  const c = (v == null ? void 0 : v.mode) || "light", d = b("thread-panel", r), { t: p } = Yr(), m = En(d, u, `${d}-${c}`), [E, y] = tn(!1), [g, C] = tn(`${p("thread")}${p("members")}`), O = (ee) => {
    var Ce;
    const de = ee.target.value, pe = (((Ce = w.currentThread.info) == null ? void 0 : Ce.members) || []).filter((_e) => _e.includes(de));
    I(pe);
  }, N = () => /* @__PURE__ */ q.jsx("div", { className: `${d}-header`, children: E ? /* @__PURE__ */ q.jsx(
    Ml,
    {
      className: `${d}-header-title-input`,
      close: !0,
      onChange: O,
      onClear: () => {
        var ee;
        I(((ee = w.currentThread.info) == null ? void 0 : ee.members) || []), y(!1);
      }
    }
  ) : /* @__PURE__ */ q.jsx("div", { className: `${d}-header-title`, children: h || g }) }), w = s.threadStore, [_, I] = tn([]), [k, H] = tn("member");
  Pn(() => {
    var ee, de;
    (ee = w.currentThread.info) != null && ee.members && I((de = w.currentThread.info) == null ? void 0 : de.members);
  }, [(ue = w.currentThread.info) == null ? void 0 : ue.members]);
  const S = [
    {
      content: p("remove"),
      onClick: (ee) => {
        var de, he;
        w.removeChatThreadMember(
          ((de = w.currentThread.info) == null ? void 0 : de.parentId) || "",
          ((he = w.currentThread.info) == null ? void 0 : he.id) || "",
          ee
        );
      }
    }
  ], B = er(null), [D, F] = tn(""), j = () => {
    var ee, de;
    w.getThreadMembers(
      ((ee = w.currentThread.info) == null ? void 0 : ee.parentId) || "",
      ((de = w.currentThread.info) == null ? void 0 : de.id) || "",
      D
    ).then((he) => {
      F((he == null ? void 0 : he.cursor) || ""), C(`${p("threadMembers")}(${he.length})`), setTimeout(() => {
        var pe, Ce, _e;
        (_e = (pe = B == null ? void 0 : B.current) == null ? void 0 : pe.scrollTo) == null || _e.call(pe, ((Ce = w.currentThread.info) == null ? void 0 : Ce.members) * 64);
      }, 100);
    });
  }, G = k != "member", U = s.client.user, M = (ee) => {
    var Ce, _e, Le, Te;
    const de = (_e = (Ce = s.addressStore.appUsersInfo) == null ? void 0 : Ce[ee]) == null ? void 0 : _e.nickname, he = (Te = (Le = s.addressStore.appUsersInfo) == null ? void 0 : Le[ee]) == null ? void 0 : Te.avatarurl, pe = (K) => /* @__PURE__ */ q.jsx("ul", { className: `${b("header")}-more`, children: S.map((Oe, Pe) => /* @__PURE__ */ q.jsx(
      "li",
      {
        onClick: () => {
          var xe;
          (xe = Oe.onClick) == null || xe.call(Oe, K);
        },
        children: Oe.content
      },
      Pe
    )) });
    return /* @__PURE__ */ q.jsxs("div", { className: "cui-thread-members-item", children: [
      /* @__PURE__ */ q.jsxs("div", { className: "cui-thread-members-item-name", children: [
        /* @__PURE__ */ q.jsx(zs, { src: he, size: 40, children: de }),
        /* @__PURE__ */ q.jsx("div", { children: de || ee })
      ] }),
      G && U != ee && /* @__PURE__ */ q.jsx(va, { title: pe(ee), trigger: "click", placement: "bottom", children: /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", children: /* @__PURE__ */ q.jsx(pn, { type: "ELLIPSIS" }) }) })
    ] }, ee);
  }, V = () => {
    const ee = _ || [];
    return /* @__PURE__ */ q.jsx(
      LOe,
      {
        ref: B,
        loading: !1,
        loadMoreItems: j,
        scrollDirection: "down",
        paddingHeight: 50,
        data: ee,
        renderItem: M
      }
    );
  }, J = s.threadStore.currentThread;
  return Pn(() => {
    var he;
    const ee = s.addressStore.groups || [], de = s.client.user;
    (he = J == null ? void 0 : J.info) != null && he.parentId && ee.forEach((pe) => {
      var Ce, _e, Le;
      if (pe.groupid == ((Ce = J == null ? void 0 : J.info) == null ? void 0 : Ce.parentId)) {
        const Te = pe.members || [];
        if (Te.length > 0) {
          for (let K = 0; K < Te.length; K++)
            if (Te[K].userId == de) {
              Te[K].role == "member" && ((_e = pe.admins) != null && _e.includes(de) ? H("admin") : ((Le = J == null ? void 0 : J.info) == null ? void 0 : Le.owner) == de && H("threadOwner")), H(Te[K].role);
              break;
            }
        }
      }
    });
  }, [(se = J == null ? void 0 : J.info) == null ? void 0 : se.id]), Pn(() => {
    var ee, de;
    w.getThreadMembers(
      ((ee = w.currentThread.info) == null ? void 0 : ee.parentId) || "",
      ((de = w.currentThread.info) == null ? void 0 : de.id) || ""
    ).then((he) => {
      F((he == null ? void 0 : he.cursor) || ""), C(`${p("threadMembers")}(${he.length})`);
    });
  }, []), /* @__PURE__ */ q.jsxs("div", { className: m, children: [
    /* @__PURE__ */ q.jsx(
      au,
      {
        avatar: !0,
        close: !0,
        moreAction: { visible: !1, actions: [] },
        onClickClose: () => {
          a == null || a();
        },
        content: N(),
        suffixIcon: /* @__PURE__ */ q.jsx(
          gi,
          {
            type: "text",
            shape: "circle",
            onClick: () => {
              y(!0);
            },
            children: /* @__PURE__ */ q.jsx(pn, { type: "SEARCH", width: 24, height: 24 })
          }
        )
      }
    ),
    /* @__PURE__ */ q.jsx("div", { className: `${d}-content`, children: /* @__PURE__ */ q.jsx("div", { className: "cui-chat-threads-box", children: V() }) })
  ] });
}), jOe = (t) => {
  var $e, Be;
  const r = Zn(Vn), { rootStore: a, features: u, theme: h } = r, b = (h == null ? void 0 : h.mode) || "light", { prefix: l, className: v, messageListProps: s, messageInputProps: c, style: d = {} } = t, { getPrefixCls: p } = _t.useContext(Hn), m = p("thread", l), { t: E } = Yr(), y = a.threadStore.currentThread.originalMessage, { threadStore: g } = a, C = (Ke = {}) => {
    let Ze;
    switch (Ke.type) {
      case "txt":
        Ze = /* @__PURE__ */ q.jsx(
          Dd,
          {
            renderUserProfile: () => null,
            messageStatus: !1,
            customAction: { visible: !1 },
            reaction: !1,
            thread: !1,
            bubbleType: "none",
            textMessage: Ke,
            direction: "ltr"
          },
          Ke.id
        );
        break;
      case "img":
        Ze = /* @__PURE__ */ q.jsx(
          kv,
          {
            renderUserProfile: () => null,
            messageStatus: !1,
            imageMessage: Ke,
            direction: "ltr",
            reaction: !1,
            thread: !1,
            customAction: { visible: !1 }
          },
          Ke.id
        );
        break;
      case "file":
        Ze = /* @__PURE__ */ q.jsx(
          jv,
          {
            renderUserProfile: () => null,
            messageStatus: !1,
            bubbleStyle: { minWidth: "160px" },
            fileMessage: Ke,
            direction: "ltr",
            type: "secondly",
            reaction: !1,
            thread: !1,
            customAction: { visible: !1 }
          },
          Ke.id
        );
        break;
      case "audio":
        Ze = /* @__PURE__ */ q.jsx(
          Xm,
          {
            renderUserProfile: () => null,
            messageStatus: !1,
            audioMessage: Ke,
            direction: "ltr",
            type: "secondly",
            reaction: !1,
            thread: !1,
            customAction: { visible: !1 }
          },
          Ke.id
        );
        break;
      case "combine":
        Ze = /* @__PURE__ */ q.jsx(
          Hv,
          {
            renderUserProfile: () => null,
            messageStatus: !1,
            combinedMessage: Ke,
            direction: "ltr",
            type: "secondly",
            reaction: !1,
            thread: !1,
            customAction: { visible: !1 }
          },
          Ke.id
        );
        break;
      case "video":
        Ze = /* @__PURE__ */ q.jsx(
          Uv,
          {
            videoMessage: Ke,
            renderUserProfile: () => null,
            thread: !1,
            type: "secondly",
            reaction: !1,
            direction: "ltr",
            customAction: { visible: !1 }
          },
          Ke.id
        );
        break;
      case "custom":
        Ke.customEvent == "userCard" && (Ze = /* @__PURE__ */ q.jsx(
          PA,
          {
            renderUserProfile: () => null,
            thread: !1,
            customMessage: Ke,
            type: "secondly",
            reaction: !1,
            direction: "ltr",
            customAction: { visible: !1 },
            bubbleStyle: { maxWidth: "calc(100% - 48px)" }
          },
          Ke.id
        ));
        break;
      default:
        Ze = null;
        break;
    }
    return Ze;
  }, O = En(
    m,
    {
      [`${m}-${b}`]: !!b
    },
    v
  ), [N, w] = tn(!1), [_, I] = tn(E("aThread")), [k, H] = tn("member"), S = (Ke) => {
    I(Ke.target.value), Ke.target.value.length == 0 ? w(!0) : w(!1);
  }, B = () => {
    var Ke, Ze;
    return /* @__PURE__ */ q.jsxs("div", { className: `${m}-original`, children: [
      /* @__PURE__ */ q.jsxs("div", { className: `${m}-original-start`, children: [
        E("startedBy"),
        " ",
        /* @__PURE__ */ q.jsx("span", { children: Bu({
          chatType: "groupChat",
          to: ((Ke = g.currentThread.info) == null ? void 0 : Ke.parentId) || "",
          from: ((Ze = g.currentThread.info) == null ? void 0 : Ze.owner) || ""
        }) })
      ] }),
      /* @__PURE__ */ q.jsx("div", { className: `${m}-original-msg`, children: C(y) }),
      /* @__PURE__ */ q.jsx("span", { className: `${m}-original-line` })
    ] });
  }, D = () => /* @__PURE__ */ q.jsxs("div", { className: `${m}-create`, children: [
    /* @__PURE__ */ q.jsx("div", { className: `${m}-create-title`, children: E("threadNameRequired") }),
    /* @__PURE__ */ q.jsx("div", { className: `${m}-create-content`, children: /* @__PURE__ */ q.jsx(
      Ml,
      {
        onChange: S,
        onClear: () => {
          w(!0);
        },
        close: !0,
        required: !0,
        value: E("aThread"),
        placeholder: E("enterThreadName")
      }
    ) }),
    /* @__PURE__ */ q.jsx("div", { children: C(y) })
  ] }), [F, j] = tn({
    chatType: "groupChat",
    conversationId: ""
  }), G = a.messageStore.repliedMessage, U = G == null ? void 0 : G.to, M = G && U === F.conversationId, V = (Ke) => {
    var It;
    const Ze = a.threadStore.currentThread.originalMessage || {}, at = a.threadStore.currentThread;
    if (at.creating) {
      const Rt = {
        name: (_ == null ? void 0 : _.replace(/(^\s*)|(\s*$)/g, "")) || E("aThread"),
        // @ts-ignore
        messageId: Ze.mid || Ze.id,
        parentId: Ze.to
      };
      return new Promise((gt, it) => {
        a.client.createChatThread(Rt).then((Tt) => {
          var Ut, st;
          j({
            chatType: "groupChat",
            conversationId: ((Ut = Tt.data) == null ? void 0 : Ut.chatThreadId) || ""
          }), a.threadStore.setCurrentThread({
            ...at,
            info: { owner: a.client.user },
            creating: !1
          }), mn.dispatchSuccess("createChatThread"), gt({
            chatType: "groupChat",
            conversationId: ((st = Tt.data) == null ? void 0 : st.chatThreadId) || ""
          });
        }).catch((Tt) => {
          mn.dispatchError("createChatThread", Tt), it(Tt);
        });
      });
    }
    const pt = {
      chatType: "groupChat",
      conversationId: ((It = at.info) == null ? void 0 : It.id) || ""
    };
    return Promise.resolve(pt);
  }, J = g.currentThread;
  let ue = "";
  const se = a.addressStore.groups || [];
  Pn(() => {
    var at, pt;
    const Ke = a.threadStore.currentThread;
    j({
      chatType: "groupChat",
      conversationId: ((at = Ke == null ? void 0 : Ke.info) == null ? void 0 : at.id) || ""
    });
    const Ze = a.client.user;
    (pt = Ke == null ? void 0 : Ke.info) != null && pt.parentId && se.forEach((It) => {
      var Rt, gt, it;
      if (It.groupid == ((Rt = Ke == null ? void 0 : Ke.info) == null ? void 0 : Rt.parentId)) {
        const Tt = It.members || [];
        if (Tt.length > 0) {
          for (let Ut = 0; Ut < Tt.length; Ut++)
            if (Tt[Ut].userId == Ze) {
              Tt[Ut].role == "member" && ((gt = It.admins) != null && gt.includes(Ze) ? H("admin") : ((it = Ke == null ? void 0 : Ke.info) == null ? void 0 : it.owner) == Ze && H("threadOwner")), H(Tt[Ut].role);
              break;
            }
        }
      }
    }), a.messageStore.setRepliedMessage(null), a.messageStore.setSelectedMessage(F, {
      selectable: !1,
      selectedMessage: []
    });
  }, [($e = J == null ? void 0 : J.info) == null ? void 0 : $e.id]), Pn(() => {
    F.conversationId && a.messageStore.setSelectedMessage(F, {
      selectable: !1,
      selectedMessage: []
    });
  }, [a.conversationStore.currentCvs]);
  const ee = () => {
    a.messageStore.setRepliedMessage(null), a.messageStore.setSelectedMessage(F, {
      selectable: !1,
      selectedMessage: []
    }), a.threadStore.setThreadVisible(!1);
  }, [de, he] = tn({
    open: !1,
    title: "",
    content: "",
    okText: "",
    cancelText: "",
    onOk: () => {
    }
  }), pe = () => {
    he({
      open: !0,
      title: E("destroyThread"),
      content: E("are you sure you want to destroy this thread"),
      okText: E("destroy"),
      cancelText: E("cancel"),
      onOk: () => {
        var Ke;
        a.client.destroyChatThread({
          chatThreadId: ((Ke = g.currentThread.info) == null ? void 0 : Ke.id) || ""
        }).then((Ze) => {
          he({
            ...de,
            open: !1
          }), ee(), mn.dispatchSuccess("destroyChatThread");
        }).catch((Ze) => {
          mn.dispatchError("destroyChatThread", Ze), console.error(Ze);
        });
      }
    });
  }, Ce = () => {
    he({
      open: !0,
      title: `${E("leave")} ${E("thread")}`,
      content: E("Are you sure you want to leave this thread"),
      okText: E("leave"),
      cancelText: E("cancel"),
      onOk: () => {
        var Ke;
        a.client.leaveChatThread({
          chatThreadId: ((Ke = g.currentThread.info) == null ? void 0 : Ke.id) || ""
        }).then((Ze) => {
          he({
            ...de,
            open: !1
          }), ee(), mn.dispatchSuccess("leaveChatThread");
        }).catch((Ze) => {
          mn.dispatchError("leaveChatThread", Ze);
        });
      }
    });
  }, _e = (Ke) => {
    ue = Ke.target.value;
  }, Le = () => {
    var Ke;
    he({
      open: !0,
      title: E("editThreadName"),
      content: /* @__PURE__ */ q.jsx(
        Ml,
        {
          value: (Ke = g.currentThread.info) == null ? void 0 : Ke.name,
          onChange: (Ze) => {
            _e(Ze);
          }
        }
      ),
      okText: E("save"),
      cancelText: E("cancel"),
      onOk: () => {
        var Ze;
        a.client.changeChatThreadName({
          chatThreadId: ((Ze = g.currentThread.info) == null ? void 0 : Ze.id) || "",
          name: ue
        }).then((at) => {
          he({
            ...de,
            open: !1
          });
        }).catch((at) => {
          console.error(at);
        });
      }
    });
  }, Te = () => {
    xe(!0), he({
      ...de,
      open: !1
    });
  }, K = {
    visible: !g.currentThread.creating,
    actions: [
      {
        content: `${E("threadMembers")}`,
        onClick: () => {
          Te();
        }
      },
      {
        visible: k != "member",
        content: `${E("modifyThread")}`,
        onClick: () => {
          Le();
        }
      },
      {
        content: `${E("leaveThread")}`,
        onClick: () => {
          Ce();
        }
      },
      {
        visible: k == "admin" || k == "owner",
        content: `${E("destroyThread")}`,
        onClick: () => {
          pe();
        }
      }
    ]
  }, Oe = er(null), [Pe, xe] = tn(!1), be = {
    customAction: {
      visible: !0,
      icon: null,
      actions: [
        {
          content: "REPLY",
          onClick: () => {
          }
        },
        {
          content: "TRANSLATE",
          onClick: () => {
          }
        },
        {
          content: "Modify",
          onClick: () => {
          }
        },
        {
          content: "SELECT",
          onClick: () => {
          }
        },
        {
          content: "FORWARD",
          onClick: () => {
          }
        }
      ]
    }
  };
  return /* @__PURE__ */ q.jsxs("div", { className: O, style: { ...d }, children: [
    /* @__PURE__ */ q.jsx("div", { ref: Oe, children: /* @__PURE__ */ q.jsx(
      au,
      {
        avatar: /* @__PURE__ */ q.jsx(
          pn,
          {
            type: "THREAD",
            color: b == "dark" ? "#C8CDD0" : "#464E53",
            width: 24,
            height: 24,
            style: { marginRight: "12px" }
          }
        ),
        content: ((Be = g.currentThread.info) == null ? void 0 : Be.name) || E("aThread"),
        close: !0,
        onClickClose: ee,
        moreAction: K
      }
    ) }),
    g.currentThread.creating ? D() : B(),
    /* @__PURE__ */ q.jsx(
      cv,
      {
        ...be,
        ...s,
        isThread: !0,
        conversation: F
      }
    ),
    M && /* @__PURE__ */ q.jsx(aY, { type: "summary" }),
    /* @__PURE__ */ q.jsx(
      zv,
      {
        disabled: g.currentThread.creating && N,
        isChatThread: !0,
        enabledMention: !1,
        onBeforeSendMessage: V,
        conversation: F,
        ...c
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: de.open,
        title: de.title,
        okText: de.okText,
        cancelText: de.cancelText,
        onCancel: () => {
          he({
            ...de,
            open: !1
          });
        },
        onOk: de.onOk,
        children: /* @__PURE__ */ q.jsx("div", { className: `${m}-detail`, children: de.content })
      }
    ),
    Pe && /* @__PURE__ */ q.jsx("div", { className: `${m}-members-box`, children: /* @__PURE__ */ q.jsx(
      kOe,
      {
        onClose: () => {
          xe(!1);
        }
      }
    ) })
  ] });
}, UOe = mi(jOe);
function DH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function MH(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? DH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : DH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
var HOe = {
  type: "logger",
  log: function(r) {
    this.output("log", r);
  },
  warn: function(r) {
    this.output("warn", r);
  },
  error: function(r) {
    this.output("error", r);
  },
  output: function(r, a) {
    console && console[r] && console[r].apply(console, a);
  }
}, BOe = function() {
  function t(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    yo(this, t), this.init(r, a);
  }
  return vo(t, [{
    key: "init",
    value: function(a) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = u.prefix || "i18next:", this.logger = a || HOe, this.options = u, this.debug = u.debug;
    }
  }, {
    key: "setDebug",
    value: function(a) {
      this.debug = a;
    }
  }, {
    key: "log",
    value: function() {
      for (var a = arguments.length, u = new Array(a), h = 0; h < a; h++)
        u[h] = arguments[h];
      return this.forward(u, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var a = arguments.length, u = new Array(a), h = 0; h < a; h++)
        u[h] = arguments[h];
      return this.forward(u, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var a = arguments.length, u = new Array(a), h = 0; h < a; h++)
        u[h] = arguments[h];
      return this.forward(u, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var a = arguments.length, u = new Array(a), h = 0; h < a; h++)
        u[h] = arguments[h];
      return this.forward(u, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(a, u, h, b) {
      return b && !this.debug ? null : (typeof a[0] == "string" && (a[0] = "".concat(h).concat(this.prefix, " ").concat(a[0])), this.logger[u](a));
    }
  }, {
    key: "create",
    value: function(a) {
      return new t(this.logger, MH(MH({}, {
        prefix: "".concat(this.prefix, ":").concat(a, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(a) {
      return a = a || this.options, a.prefix = a.prefix || this.prefix, new t(this.logger, a);
    }
  }]), t;
}(), ku = new BOe(), Bl = function() {
  function t() {
    yo(this, t), this.observers = {};
  }
  return vo(t, [{
    key: "on",
    value: function(a, u) {
      var h = this;
      return a.split(" ").forEach(function(b) {
        h.observers[b] = h.observers[b] || [], h.observers[b].push(u);
      }), this;
    }
  }, {
    key: "off",
    value: function(a, u) {
      if (this.observers[a]) {
        if (!u) {
          delete this.observers[a];
          return;
        }
        this.observers[a] = this.observers[a].filter(function(h) {
          return h !== u;
        });
      }
    }
  }, {
    key: "emit",
    value: function(a) {
      for (var u = arguments.length, h = new Array(u > 1 ? u - 1 : 0), b = 1; b < u; b++)
        h[b - 1] = arguments[b];
      if (this.observers[a]) {
        var l = [].concat(this.observers[a]);
        l.forEach(function(s) {
          s.apply(void 0, h);
        });
      }
      if (this.observers["*"]) {
        var v = [].concat(this.observers["*"]);
        v.forEach(function(s) {
          s.apply(s, [a].concat(h));
        });
      }
    }
  }]), t;
}();
function wy() {
  var t, r, a = new Promise(function(u, h) {
    t = u, r = h;
  });
  return a.resolve = t, a.reject = r, a;
}
function LH(t) {
  return t == null ? "" : "" + t;
}
function zOe(t, r, a) {
  t.forEach(function(u) {
    r[u] && (a[u] = r[u]);
  });
}
function e_(t, r, a) {
  function u(v) {
    return v && v.indexOf("###") > -1 ? v.replace(/###/g, ".") : v;
  }
  function h() {
    return !t || typeof t == "string";
  }
  for (var b = typeof r != "string" ? [].concat(r) : r.split("."); b.length > 1; ) {
    if (h()) return {};
    var l = u(b.shift());
    !t[l] && a && (t[l] = new a()), Object.prototype.hasOwnProperty.call(t, l) ? t = t[l] : t = {};
  }
  return h() ? {} : {
    obj: t,
    k: u(b.shift())
  };
}
function kH(t, r, a) {
  var u = e_(t, r, Object), h = u.obj, b = u.k;
  h[b] = a;
}
function FOe(t, r, a, u) {
  var h = e_(t, r, Object), b = h.obj, l = h.k;
  b[l] = b[l] || [], b[l].push(a);
}
function Pb(t, r) {
  var a = e_(t, r), u = a.obj, h = a.k;
  if (u)
    return u[h];
}
function GOe(t, r, a) {
  var u = Pb(t, a);
  return u !== void 0 ? u : Pb(r, a);
}
function RY(t, r, a) {
  for (var u in r)
    u !== "__proto__" && u !== "constructor" && (u in t ? typeof t[u] == "string" || t[u] instanceof String || typeof r[u] == "string" || r[u] instanceof String ? a && (t[u] = r[u]) : RY(t[u], r[u], a) : t[u] = r[u]);
  return t;
}
function zp(t) {
  return t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var VOe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function YOe(t) {
  return typeof t == "string" ? t.replace(/[&<>"'\/]/g, function(r) {
    return VOe[r];
  }) : t;
}
var xA = typeof window < "u" && window.navigator && typeof window.navigator.userAgentData > "u" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, XOe = [" ", ",", "?", "!", ";"];
function WOe(t, r, a) {
  r = r || "", a = a || "";
  var u = XOe.filter(function(v) {
    return r.indexOf(v) < 0 && a.indexOf(v) < 0;
  });
  if (u.length === 0) return !0;
  var h = new RegExp("(".concat(u.map(function(v) {
    return v === "?" ? "\\?" : v;
  }).join("|"), ")")), b = !h.test(t);
  if (!b) {
    var l = t.indexOf(a);
    l > 0 && !h.test(t.substring(0, l)) && (b = !0);
  }
  return b;
}
function xb(t, r) {
  var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (t) {
    if (t[r]) return t[r];
    for (var u = r.split(a), h = t, b = 0; b < u.length; ++b) {
      if (!h || typeof h[u[b]] == "string" && b + 1 < u.length)
        return;
      if (h[u[b]] === void 0) {
        for (var l = 2, v = u.slice(b, b + l).join(a), s = h[v]; s === void 0 && u.length > b + l; )
          l++, v = u.slice(b, b + l).join(a), s = h[v];
        if (s === void 0) return;
        if (s === null) return null;
        if (r.endsWith(v)) {
          if (typeof s == "string") return s;
          if (v && typeof s[v] == "string") return s[v];
        }
        var c = u.slice(b + l).join(a);
        return c ? xb(s, c, a) : void 0;
      }
      h = h[u[b]];
    }
    return h;
  }
}
function jH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function B0(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? jH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : jH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function qOe(t) {
  var r = KOe();
  return function() {
    var u = Sc(t), h;
    if (r) {
      var b = Sc(this).constructor;
      h = Reflect.construct(u, arguments, b);
    } else
      h = u.apply(this, arguments);
    return Um(this, h);
  };
}
function KOe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var JOe = function(t) {
  gh(a, t);
  var r = qOe(a);
  function a(u) {
    var h, b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return yo(this, a), h = r.call(this), xA && Bl.call(Er(h)), h.data = u || {}, h.options = b, h.options.keySeparator === void 0 && (h.options.keySeparator = "."), h.options.ignoreJSONStructure === void 0 && (h.options.ignoreJSONStructure = !0), h;
  }
  return vo(a, [{
    key: "addNamespaces",
    value: function(h) {
      this.options.ns.indexOf(h) < 0 && this.options.ns.push(h);
    }
  }, {
    key: "removeNamespaces",
    value: function(h) {
      var b = this.options.ns.indexOf(h);
      b > -1 && this.options.ns.splice(b, 1);
    }
  }, {
    key: "getResource",
    value: function(h, b, l) {
      var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = v.keySeparator !== void 0 ? v.keySeparator : this.options.keySeparator, c = v.ignoreJSONStructure !== void 0 ? v.ignoreJSONStructure : this.options.ignoreJSONStructure, d = [h, b];
      l && typeof l != "string" && (d = d.concat(l)), l && typeof l == "string" && (d = d.concat(s ? l.split(s) : l)), h.indexOf(".") > -1 && (d = h.split("."));
      var p = Pb(this.data, d);
      return p || !c || typeof l != "string" ? p : xb(this.data && this.data[h] && this.data[h][b], l, s);
    }
  }, {
    key: "addResource",
    value: function(h, b, l, v) {
      var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, c = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, d = [h, b];
      l && (d = d.concat(c ? l.split(c) : l)), h.indexOf(".") > -1 && (d = h.split("."), v = b, b = d[1]), this.addNamespaces(b), kH(this.data, d, v), s.silent || this.emit("added", h, b, l, v);
    }
  }, {
    key: "addResources",
    value: function(h, b, l) {
      var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var s in l)
        (typeof l[s] == "string" || Object.prototype.toString.apply(l[s]) === "[object Array]") && this.addResource(h, b, s, l[s], {
          silent: !0
        });
      v.silent || this.emit("added", h, b, l);
    }
  }, {
    key: "addResourceBundle",
    value: function(h, b, l, v, s) {
      var c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, d = [h, b];
      h.indexOf(".") > -1 && (d = h.split("."), v = l, l = b, b = d[1]), this.addNamespaces(b);
      var p = Pb(this.data, d) || {};
      v ? RY(p, l, s) : p = B0(B0({}, p), l), kH(this.data, d, p), c.silent || this.emit("added", h, b, l);
    }
  }, {
    key: "removeResourceBundle",
    value: function(h, b) {
      this.hasResourceBundle(h, b) && delete this.data[h][b], this.removeNamespaces(b), this.emit("removed", h, b);
    }
  }, {
    key: "hasResourceBundle",
    value: function(h, b) {
      return this.getResource(h, b) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(h, b) {
      return b || (b = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? B0(B0({}, {}), this.getResource(h, b)) : this.getResource(h, b);
    }
  }, {
    key: "getDataByLanguage",
    value: function(h) {
      return this.data[h];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(h) {
      var b = this.getDataByLanguage(h), l = b && Object.keys(b) || [];
      return !!l.find(function(v) {
        return b[v] && Object.keys(b[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), a;
}(Bl), NY = {
  processors: {},
  addPostProcessor: function(r) {
    this.processors[r.name] = r;
  },
  handle: function(r, a, u, h, b) {
    var l = this;
    return r.forEach(function(v) {
      l.processors[v] && (a = l.processors[v].process(a, u, h, b));
    }), a;
  }
};
function UH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function Pa(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? UH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : UH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function ZOe(t) {
  var r = QOe();
  return function() {
    var u = Sc(t), h;
    if (r) {
      var b = Sc(this).constructor;
      h = Reflect.construct(u, arguments, b);
    } else
      h = u.apply(this, arguments);
    return Um(this, h);
  };
}
function QOe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var HH = {}, BH = function(t) {
  gh(a, t);
  var r = ZOe(a);
  function a(u) {
    var h, b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return yo(this, a), h = r.call(this), xA && Bl.call(Er(h)), zOe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], u, Er(h)), h.options = b, h.options.keySeparator === void 0 && (h.options.keySeparator = "."), h.logger = ku.create("translator"), h;
  }
  return vo(a, [{
    key: "changeLanguage",
    value: function(h) {
      h && (this.language = h);
    }
  }, {
    key: "exists",
    value: function(h) {
      var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (h == null)
        return !1;
      var l = this.resolve(h, b);
      return l && l.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(h, b) {
      var l = b.nsSeparator !== void 0 ? b.nsSeparator : this.options.nsSeparator;
      l === void 0 && (l = ":");
      var v = b.keySeparator !== void 0 ? b.keySeparator : this.options.keySeparator, s = b.ns || this.options.defaultNS || [], c = l && h.indexOf(l) > -1, d = !this.options.userDefinedKeySeparator && !b.keySeparator && !this.options.userDefinedNsSeparator && !b.nsSeparator && !WOe(h, l, v);
      if (c && !d) {
        var p = h.match(this.interpolator.nestingRegexp);
        if (p && p.length > 0)
          return {
            key: h,
            namespaces: s
          };
        var m = h.split(l);
        (l !== v || l === v && this.options.ns.indexOf(m[0]) > -1) && (s = m.shift()), h = m.join(v);
      }
      return typeof s == "string" && (s = [s]), {
        key: h,
        namespaces: s
      };
    }
  }, {
    key: "translate",
    value: function(h, b, l) {
      var v = this;
      if (as(b) !== "object" && this.options.overloadTranslationOptionHandler && (b = this.options.overloadTranslationOptionHandler(arguments)), as(b) === "object" && (b = Pa({}, b)), b || (b = {}), h == null) return "";
      Array.isArray(h) || (h = [String(h)]);
      var s = b.returnDetails !== void 0 ? b.returnDetails : this.options.returnDetails, c = b.keySeparator !== void 0 ? b.keySeparator : this.options.keySeparator, d = this.extractFromKey(h[h.length - 1], b), p = d.key, m = d.namespaces, E = m[m.length - 1], y = b.lng || this.language, g = b.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (y && y.toLowerCase() === "cimode") {
        if (g) {
          var C = b.nsSeparator || this.options.nsSeparator;
          return s ? {
            res: "".concat(E).concat(C).concat(p),
            usedKey: p,
            exactUsedKey: p,
            usedLng: y,
            usedNS: E
          } : "".concat(E).concat(C).concat(p);
        }
        return s ? {
          res: p,
          usedKey: p,
          exactUsedKey: p,
          usedLng: y,
          usedNS: E
        } : p;
      }
      var O = this.resolve(h, b), N = O && O.res, w = O && O.usedKey || p, _ = O && O.exactUsedKey || p, I = Object.prototype.toString.apply(N), k = ["[object Number]", "[object Function]", "[object RegExp]"], H = b.joinArrays !== void 0 ? b.joinArrays : this.options.joinArrays, S = !this.i18nFormat || this.i18nFormat.handleAsObject, B = typeof N != "string" && typeof N != "boolean" && typeof N != "number";
      if (S && N && B && k.indexOf(I) < 0 && !(typeof H == "string" && I === "[object Array]")) {
        if (!b.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var D = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(w, N, Pa(Pa({}, b), {}, {
            ns: m
          })) : "key '".concat(p, " (").concat(this.language, ")' returned an object instead of string.");
          return s ? (O.res = D, O) : D;
        }
        if (c) {
          var F = I === "[object Array]", j = F ? [] : {}, G = F ? _ : w;
          for (var U in N)
            if (Object.prototype.hasOwnProperty.call(N, U)) {
              var M = "".concat(G).concat(c).concat(U);
              j[U] = this.translate(M, Pa(Pa({}, b), {
                joinArrays: !1,
                ns: m
              })), j[U] === M && (j[U] = N[U]);
            }
          N = j;
        }
      } else if (S && typeof H == "string" && I === "[object Array]")
        N = N.join(H), N && (N = this.extendTranslation(N, h, b, l));
      else {
        var V = !1, J = !1, ue = b.count !== void 0 && typeof b.count != "string", se = a.hasDefaultValue(b), ee = ue ? this.pluralResolver.getSuffix(y, b.count, b) : "", de = b["defaultValue".concat(ee)] || b.defaultValue;
        !this.isValidLookup(N) && se && (V = !0, N = de), this.isValidLookup(N) || (J = !0, N = p);
        var he = b.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, pe = he && J ? void 0 : N, Ce = se && de !== N && this.options.updateMissing;
        if (J || V || Ce) {
          if (this.logger.log(Ce ? "updateKey" : "missingKey", y, E, p, Ce ? de : N), c) {
            var _e = this.resolve(p, Pa(Pa({}, b), {}, {
              keySeparator: !1
            }));
            _e && _e.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var Le = [], Te = this.languageUtils.getFallbackCodes(this.options.fallbackLng, b.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && Te && Te[0])
            for (var K = 0; K < Te.length; K++)
              Le.push(Te[K]);
          else this.options.saveMissingTo === "all" ? Le = this.languageUtils.toResolveHierarchy(b.lng || this.language) : Le.push(b.lng || this.language);
          var Oe = function(xe, be, $e) {
            var Be = se && $e !== N ? $e : pe;
            v.options.missingKeyHandler ? v.options.missingKeyHandler(xe, E, be, Be, Ce, b) : v.backendConnector && v.backendConnector.saveMissing && v.backendConnector.saveMissing(xe, E, be, Be, Ce, b), v.emit("missingKey", xe, E, be, N);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && ue ? Le.forEach(function(Pe) {
            v.pluralResolver.getSuffixes(Pe, b).forEach(function(xe) {
              Oe([Pe], p + xe, b["defaultValue".concat(xe)] || de);
            });
          }) : Oe(Le, p, de));
        }
        N = this.extendTranslation(N, h, b, O, l), J && N === p && this.options.appendNamespaceToMissingKey && (N = "".concat(E, ":").concat(p)), (J || V) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? N = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(E, ":").concat(p) : p, V ? N : void 0) : N = this.options.parseMissingKeyHandler(N));
      }
      return s ? (O.res = N, O) : N;
    }
  }, {
    key: "extendTranslation",
    value: function(h, b, l, v, s) {
      var c = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        h = this.i18nFormat.parse(h, Pa(Pa({}, this.options.interpolation.defaultVariables), l), v.usedLng, v.usedNS, v.usedKey, {
          resolved: v
        });
      else if (!l.skipInterpolation) {
        l.interpolation && this.interpolator.init(Pa(Pa({}, l), {
          interpolation: Pa(Pa({}, this.options.interpolation), l.interpolation)
        }));
        var d = typeof h == "string" && (l && l.interpolation && l.interpolation.skipOnVariables !== void 0 ? l.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), p;
        if (d) {
          var m = h.match(this.interpolator.nestingRegexp);
          p = m && m.length;
        }
        var E = l.replace && typeof l.replace != "string" ? l.replace : l;
        if (this.options.interpolation.defaultVariables && (E = Pa(Pa({}, this.options.interpolation.defaultVariables), E)), h = this.interpolator.interpolate(h, E, l.lng || this.language, l), d) {
          var y = h.match(this.interpolator.nestingRegexp), g = y && y.length;
          p < g && (l.nest = !1);
        }
        !l.lng && this.options.compatibilityAPI !== "v1" && v && v.res && (l.lng = v.usedLng), l.nest !== !1 && (h = this.interpolator.nest(h, function() {
          for (var N = arguments.length, w = new Array(N), _ = 0; _ < N; _++)
            w[_] = arguments[_];
          return s && s[0] === w[0] && !l.context ? (c.logger.warn("It seems you are nesting recursively key: ".concat(w[0], " in key: ").concat(b[0])), null) : c.translate.apply(c, w.concat([b]));
        }, l)), l.interpolation && this.interpolator.reset();
      }
      var C = l.postProcess || this.options.postProcess, O = typeof C == "string" ? [C] : C;
      return h != null && O && O.length && l.applyPostProcessor !== !1 && (h = NY.handle(O, h, b, this.options && this.options.postProcessPassResolved ? Pa({
        i18nResolved: v
      }, l) : l, this)), h;
    }
  }, {
    key: "resolve",
    value: function(h) {
      var b = this, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, v, s, c, d, p;
      return typeof h == "string" && (h = [h]), h.forEach(function(m) {
        if (!b.isValidLookup(v)) {
          var E = b.extractFromKey(m, l), y = E.key;
          s = y;
          var g = E.namespaces;
          b.options.fallbackNS && (g = g.concat(b.options.fallbackNS));
          var C = l.count !== void 0 && typeof l.count != "string", O = C && !l.ordinal && l.count === 0 && b.pluralResolver.shouldUseIntlApi(), N = l.context !== void 0 && (typeof l.context == "string" || typeof l.context == "number") && l.context !== "", w = l.lngs ? l.lngs : b.languageUtils.toResolveHierarchy(l.lng || b.language, l.fallbackLng);
          g.forEach(function(_) {
            b.isValidLookup(v) || (p = _, !HH["".concat(w[0], "-").concat(_)] && b.utils && b.utils.hasLoadedNamespace && !b.utils.hasLoadedNamespace(p) && (HH["".concat(w[0], "-").concat(_)] = !0, b.logger.warn('key "'.concat(s, '" for languages "').concat(w.join(", "), `" won't get resolved as namespace "`).concat(p, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), w.forEach(function(I) {
              if (!b.isValidLookup(v)) {
                d = I;
                var k = [y];
                if (b.i18nFormat && b.i18nFormat.addLookupKeys)
                  b.i18nFormat.addLookupKeys(k, y, I, _, l);
                else {
                  var H;
                  C && (H = b.pluralResolver.getSuffix(I, l.count, l));
                  var S = "".concat(b.options.pluralSeparator, "zero");
                  if (C && (k.push(y + H), O && k.push(y + S)), N) {
                    var B = "".concat(y).concat(b.options.contextSeparator).concat(l.context);
                    k.push(B), C && (k.push(B + H), O && k.push(B + S));
                  }
                }
                for (var D; D = k.pop(); )
                  b.isValidLookup(v) || (c = D, v = b.getResource(I, _, D, l));
              }
            }));
          });
        }
      }), {
        res: v,
        usedKey: s,
        exactUsedKey: c,
        usedLng: d,
        usedNS: p
      };
    }
  }, {
    key: "isValidLookup",
    value: function(h) {
      return h !== void 0 && !(!this.options.returnNull && h === null) && !(!this.options.returnEmptyString && h === "");
    }
  }, {
    key: "getResource",
    value: function(h, b, l) {
      var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(h, b, l, v) : this.resourceStore.getResource(h, b, l, v);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(h) {
      var b = "defaultValue";
      for (var l in h)
        if (Object.prototype.hasOwnProperty.call(h, l) && b === l.substring(0, b.length) && h[l] !== void 0)
          return !0;
      return !1;
    }
  }]), a;
}(Bl);
function QR(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
var zH = function() {
  function t(r) {
    yo(this, t), this.options = r, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ku.create("languageUtils");
  }
  return vo(t, [{
    key: "getScriptPartFromCode",
    value: function(a) {
      if (!a || a.indexOf("-") < 0) return null;
      var u = a.split("-");
      return u.length === 2 || (u.pop(), u[u.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(u.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(a) {
      if (!a || a.indexOf("-") < 0) return a;
      var u = a.split("-");
      return this.formatLanguageCode(u[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(a) {
      if (typeof a == "string" && a.indexOf("-") > -1) {
        var u = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], h = a.split("-");
        return this.options.lowerCaseLng ? h = h.map(function(b) {
          return b.toLowerCase();
        }) : h.length === 2 ? (h[0] = h[0].toLowerCase(), h[1] = h[1].toUpperCase(), u.indexOf(h[1].toLowerCase()) > -1 && (h[1] = QR(h[1].toLowerCase()))) : h.length === 3 && (h[0] = h[0].toLowerCase(), h[1].length === 2 && (h[1] = h[1].toUpperCase()), h[0] !== "sgn" && h[2].length === 2 && (h[2] = h[2].toUpperCase()), u.indexOf(h[1].toLowerCase()) > -1 && (h[1] = QR(h[1].toLowerCase())), u.indexOf(h[2].toLowerCase()) > -1 && (h[2] = QR(h[2].toLowerCase()))), h.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? a.toLowerCase() : a;
    }
  }, {
    key: "isSupportedCode",
    value: function(a) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (a = this.getLanguagePartFromCode(a)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(a) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(a) {
      var u = this;
      if (!a) return null;
      var h;
      return a.forEach(function(b) {
        if (!h) {
          var l = u.formatLanguageCode(b);
          (!u.options.supportedLngs || u.isSupportedCode(l)) && (h = l);
        }
      }), !h && this.options.supportedLngs && a.forEach(function(b) {
        if (!h) {
          var l = u.getLanguagePartFromCode(b);
          if (u.isSupportedCode(l)) return h = l;
          h = u.options.supportedLngs.find(function(v) {
            if (v === l) return v;
            if (!(v.indexOf("-") < 0 && l.indexOf("-") < 0) && v.indexOf(l) === 0)
              return v;
          });
        }
      }), h || (h = this.getFallbackCodes(this.options.fallbackLng)[0]), h;
    }
  }, {
    key: "getFallbackCodes",
    value: function(a, u) {
      if (!a) return [];
      if (typeof a == "function" && (a = a(u)), typeof a == "string" && (a = [a]), Object.prototype.toString.apply(a) === "[object Array]") return a;
      if (!u) return a.default || [];
      var h = a[u];
      return h || (h = a[this.getScriptPartFromCode(u)]), h || (h = a[this.formatLanguageCode(u)]), h || (h = a[this.getLanguagePartFromCode(u)]), h || (h = a.default), h || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(a, u) {
      var h = this, b = this.getFallbackCodes(u || this.options.fallbackLng || [], a), l = [], v = function(c) {
        c && (h.isSupportedCode(c) ? l.push(c) : h.logger.warn("rejecting language code not found in supportedLngs: ".concat(c)));
      };
      return typeof a == "string" && a.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && v(this.formatLanguageCode(a)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && v(this.getScriptPartFromCode(a)), this.options.load !== "currentOnly" && v(this.getLanguagePartFromCode(a))) : typeof a == "string" && v(this.formatLanguageCode(a)), b.forEach(function(s) {
        l.indexOf(s) < 0 && v(h.formatLanguageCode(s));
      }), l;
    }
  }]), t;
}(), $Oe = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], eCe = {
  1: function(r) {
    return +(r > 1);
  },
  2: function(r) {
    return +(r != 1);
  },
  3: function(r) {
    return 0;
  },
  4: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  5: function(r) {
    return r == 0 ? 0 : r == 1 ? 1 : r == 2 ? 2 : r % 100 >= 3 && r % 100 <= 10 ? 3 : r % 100 >= 11 ? 4 : 5;
  },
  6: function(r) {
    return r == 1 ? 0 : r >= 2 && r <= 4 ? 1 : 2;
  },
  7: function(r) {
    return r == 1 ? 0 : r % 10 >= 2 && r % 10 <= 4 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  8: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r != 8 && r != 11 ? 2 : 3;
  },
  9: function(r) {
    return +(r >= 2);
  },
  10: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r < 7 ? 2 : r < 11 ? 3 : 4;
  },
  11: function(r) {
    return r == 1 || r == 11 ? 0 : r == 2 || r == 12 ? 1 : r > 2 && r < 20 ? 2 : 3;
  },
  12: function(r) {
    return +(r % 10 != 1 || r % 100 == 11);
  },
  13: function(r) {
    return +(r !== 0);
  },
  14: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : r == 3 ? 2 : 3;
  },
  15: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r % 10 >= 2 && (r % 100 < 10 || r % 100 >= 20) ? 1 : 2;
  },
  16: function(r) {
    return r % 10 == 1 && r % 100 != 11 ? 0 : r !== 0 ? 1 : 2;
  },
  17: function(r) {
    return r == 1 || r % 10 == 1 && r % 100 != 11 ? 0 : 1;
  },
  18: function(r) {
    return r == 0 ? 0 : r == 1 ? 1 : 2;
  },
  19: function(r) {
    return r == 1 ? 0 : r == 0 || r % 100 > 1 && r % 100 < 11 ? 1 : r % 100 > 10 && r % 100 < 20 ? 2 : 3;
  },
  20: function(r) {
    return r == 1 ? 0 : r == 0 || r % 100 > 0 && r % 100 < 20 ? 1 : 2;
  },
  21: function(r) {
    return r % 100 == 1 ? 1 : r % 100 == 2 ? 2 : r % 100 == 3 || r % 100 == 4 ? 3 : 0;
  },
  22: function(r) {
    return r == 1 ? 0 : r == 2 ? 1 : (r < 0 || r > 10) && r % 10 == 0 ? 2 : 3;
  }
}, tCe = ["v1", "v2", "v3"], FH = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function nCe() {
  var t = {};
  return $Oe.forEach(function(r) {
    r.lngs.forEach(function(a) {
      t[a] = {
        numbers: r.nr,
        plurals: eCe[r.fc]
      };
    });
  }), t;
}
var rCe = function() {
  function t(r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    yo(this, t), this.languageUtils = r, this.options = a, this.logger = ku.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = nCe();
  }
  return vo(t, [{
    key: "addRule",
    value: function(a, u) {
      this.rules[a] = u;
    }
  }, {
    key: "getRule",
    value: function(a) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(a, {
            type: u.ordinal ? "ordinal" : "cardinal"
          });
        } catch {
          return;
        }
      return this.rules[a] || this.rules[this.languageUtils.getLanguagePartFromCode(a)];
    }
  }, {
    key: "needsPlural",
    value: function(a) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = this.getRule(a, u);
      return this.shouldUseIntlApi() ? h && h.resolvedOptions().pluralCategories.length > 1 : h && h.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(a, u) {
      var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(a, h).map(function(b) {
        return "".concat(u).concat(b);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(a) {
      var u = this, h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = this.getRule(a, h);
      return b ? this.shouldUseIntlApi() ? b.resolvedOptions().pluralCategories.sort(function(l, v) {
        return FH[l] - FH[v];
      }).map(function(l) {
        return "".concat(u.options.prepend).concat(l);
      }) : b.numbers.map(function(l) {
        return u.getSuffix(a, l, h);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(a, u) {
      var h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, b = this.getRule(a, h);
      return b ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(b.select(u)) : this.getSuffixRetroCompatible(b, u) : (this.logger.warn("no plural rule found for: ".concat(a)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(a, u) {
      var h = this, b = a.noAbs ? a.plurals(u) : a.plurals(Math.abs(u)), l = a.numbers[b];
      this.options.simplifyPluralSuffix && a.numbers.length === 2 && a.numbers[0] === 1 && (l === 2 ? l = "plural" : l === 1 && (l = ""));
      var v = function() {
        return h.options.prepend && l.toString() ? h.options.prepend + l.toString() : l.toString();
      };
      return this.options.compatibilityJSON === "v1" ? l === 1 ? "" : typeof l == "number" ? "_plural_".concat(l.toString()) : v() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && a.numbers.length === 2 && a.numbers[0] === 1 ? v() : this.options.prepend && b.toString() ? this.options.prepend + b.toString() : b.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !tCe.includes(this.options.compatibilityJSON);
    }
  }]), t;
}();
function GH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function Yc(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? GH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : GH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function VH(t, r, a) {
  var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", h = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, b = GOe(t, r, a);
  return !b && h && typeof a == "string" && (b = xb(t, a, u), b === void 0 && (b = xb(r, a, u))), b;
}
var iCe = function() {
  function t() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    yo(this, t), this.logger = ku.create("interpolator"), this.options = r, this.format = r.interpolation && r.interpolation.format || function(a) {
      return a;
    }, this.init(r);
  }
  return vo(t, [{
    key: "init",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      a.interpolation || (a.interpolation = {
        escapeValue: !0
      });
      var u = a.interpolation;
      this.escape = u.escape !== void 0 ? u.escape : YOe, this.escapeValue = u.escapeValue !== void 0 ? u.escapeValue : !0, this.useRawValueToEscape = u.useRawValueToEscape !== void 0 ? u.useRawValueToEscape : !1, this.prefix = u.prefix ? zp(u.prefix) : u.prefixEscaped || "{{", this.suffix = u.suffix ? zp(u.suffix) : u.suffixEscaped || "}}", this.formatSeparator = u.formatSeparator ? u.formatSeparator : u.formatSeparator || ",", this.unescapePrefix = u.unescapeSuffix ? "" : u.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u.unescapeSuffix || "", this.nestingPrefix = u.nestingPrefix ? zp(u.nestingPrefix) : u.nestingPrefixEscaped || zp("$t("), this.nestingSuffix = u.nestingSuffix ? zp(u.nestingSuffix) : u.nestingSuffixEscaped || zp(")"), this.nestingOptionsSeparator = u.nestingOptionsSeparator ? u.nestingOptionsSeparator : u.nestingOptionsSeparator || ",", this.maxReplaces = u.maxReplaces ? u.maxReplaces : 1e3, this.alwaysFormat = u.alwaysFormat !== void 0 ? u.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var a = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(a, "g");
      var u = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(u, "g");
      var h = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(h, "g");
    }
  }, {
    key: "interpolate",
    value: function(a, u, h, b) {
      var l = this, v, s, c, d = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function p(C) {
        return C.replace(/\$/g, "$$$$");
      }
      var m = function(O) {
        if (O.indexOf(l.formatSeparator) < 0) {
          var N = VH(u, d, O, l.options.keySeparator, l.options.ignoreJSONStructure);
          return l.alwaysFormat ? l.format(N, void 0, h, Yc(Yc(Yc({}, b), u), {}, {
            interpolationkey: O
          })) : N;
        }
        var w = O.split(l.formatSeparator), _ = w.shift().trim(), I = w.join(l.formatSeparator).trim();
        return l.format(VH(u, d, _, l.options.keySeparator, l.options.ignoreJSONStructure), I, h, Yc(Yc(Yc({}, b), u), {}, {
          interpolationkey: _
        }));
      };
      this.resetRegExp();
      var E = b && b.missingInterpolationHandler || this.options.missingInterpolationHandler, y = b && b.interpolation && b.interpolation.skipOnVariables !== void 0 ? b.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, g = [{
        regex: this.regexpUnescape,
        safeValue: function(O) {
          return p(O);
        }
      }, {
        regex: this.regexp,
        safeValue: function(O) {
          return l.escapeValue ? p(l.escape(O)) : p(O);
        }
      }];
      return g.forEach(function(C) {
        for (c = 0; v = C.regex.exec(a); ) {
          var O = v[1].trim();
          if (s = m(O), s === void 0)
            if (typeof E == "function") {
              var N = E(a, v, b);
              s = typeof N == "string" ? N : "";
            } else if (b && Object.prototype.hasOwnProperty.call(b, O))
              s = "";
            else if (y) {
              s = v[0];
              continue;
            } else
              l.logger.warn("missed to pass in variable ".concat(O, " for interpolating ").concat(a)), s = "";
          else typeof s != "string" && !l.useRawValueToEscape && (s = LH(s));
          var w = C.safeValue(s);
          if (a = a.replace(v[0], w), y ? (C.regex.lastIndex += s.length, C.regex.lastIndex -= v[0].length) : C.regex.lastIndex = 0, c++, c >= l.maxReplaces)
            break;
        }
      }), a;
    }
  }, {
    key: "nest",
    value: function(a, u) {
      var h = this, b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l, v, s;
      function c(E, y) {
        var g = this.nestingOptionsSeparator;
        if (E.indexOf(g) < 0) return E;
        var C = E.split(new RegExp("".concat(g, "[ ]*{"))), O = "{".concat(C[1]);
        E = C[0], O = this.interpolate(O, s);
        var N = O.match(/'/g), w = O.match(/"/g);
        (N && N.length % 2 === 0 && !w || w.length % 2 !== 0) && (O = O.replace(/'/g, '"'));
        try {
          s = JSON.parse(O), y && (s = Yc(Yc({}, y), s));
        } catch (_) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(E), _), "".concat(E).concat(g).concat(O);
        }
        return delete s.defaultValue, E;
      }
      for (; l = this.nestingRegexp.exec(a); ) {
        var d = [];
        s = Yc({}, b), s = s.replace && typeof s.replace != "string" ? s.replace : s, s.applyPostProcessor = !1, delete s.defaultValue;
        var p = !1;
        if (l[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(l[1])) {
          var m = l[1].split(this.formatSeparator).map(function(E) {
            return E.trim();
          });
          l[1] = m.shift(), d = m, p = !0;
        }
        if (v = u(c.call(this, l[1].trim(), s), s), v && l[0] === a && typeof v != "string") return v;
        typeof v != "string" && (v = LH(v)), v || (this.logger.warn("missed to resolve ".concat(l[1], " for nesting ").concat(a)), v = ""), p && (v = d.reduce(function(E, y) {
          return h.format(E, y, b.lng, Yc(Yc({}, b), {}, {
            interpolationkey: l[1].trim()
          }));
        }, v.trim())), a = a.replace(l[0], v), this.regexp.lastIndex = 0;
      }
      return a;
    }
  }]), t;
}();
function YH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function Od(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? YH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : YH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function sCe(t) {
  var r = t.toLowerCase().trim(), a = {};
  if (t.indexOf("(") > -1) {
    var u = t.split("(");
    r = u[0].toLowerCase().trim();
    var h = u[1].substring(0, u[1].length - 1);
    if (r === "currency" && h.indexOf(":") < 0)
      a.currency || (a.currency = h.trim());
    else if (r === "relativetime" && h.indexOf(":") < 0)
      a.range || (a.range = h.trim());
    else {
      var b = h.split(";");
      b.forEach(function(l) {
        if (l) {
          var v = l.split(":"), s = Kfe(v), c = s[0], d = s.slice(1), p = d.join(":").trim().replace(/^'+|'+$/g, "");
          a[c.trim()] || (a[c.trim()] = p), p === "false" && (a[c.trim()] = !1), p === "true" && (a[c.trim()] = !0), isNaN(p) || (a[c.trim()] = parseInt(p, 10));
        }
      });
    }
  }
  return {
    formatName: r,
    formatOptions: a
  };
}
function Fp(t) {
  var r = {};
  return function(u, h, b) {
    var l = h + JSON.stringify(b), v = r[l];
    return v || (v = t(h, b), r[l] = v), v(u);
  };
}
var aCe = function() {
  function t() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    yo(this, t), this.logger = ku.create("formatter"), this.options = r, this.formats = {
      number: Fp(function(a, u) {
        var h = new Intl.NumberFormat(a, Od({}, u));
        return function(b) {
          return h.format(b);
        };
      }),
      currency: Fp(function(a, u) {
        var h = new Intl.NumberFormat(a, Od(Od({}, u), {}, {
          style: "currency"
        }));
        return function(b) {
          return h.format(b);
        };
      }),
      datetime: Fp(function(a, u) {
        var h = new Intl.DateTimeFormat(a, Od({}, u));
        return function(b) {
          return h.format(b);
        };
      }),
      relativetime: Fp(function(a, u) {
        var h = new Intl.RelativeTimeFormat(a, Od({}, u));
        return function(b) {
          return h.format(b, u.range || "day");
        };
      }),
      list: Fp(function(a, u) {
        var h = new Intl.ListFormat(a, Od({}, u));
        return function(b) {
          return h.format(b);
        };
      })
    }, this.init(r);
  }
  return vo(t, [{
    key: "init",
    value: function(a) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, h = u.interpolation;
      this.formatSeparator = h.formatSeparator ? h.formatSeparator : h.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(a, u) {
      this.formats[a.toLowerCase().trim()] = u;
    }
  }, {
    key: "addCached",
    value: function(a, u) {
      this.formats[a.toLowerCase().trim()] = Fp(u);
    }
  }, {
    key: "format",
    value: function(a, u, h) {
      var b = this, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, v = u.split(this.formatSeparator), s = v.reduce(function(c, d) {
        var p = sCe(d), m = p.formatName, E = p.formatOptions;
        if (b.formats[m]) {
          var y = c;
          try {
            var g = l && l.formatParams && l.formatParams[l.interpolationkey] || {}, C = g.locale || g.lng || l.locale || l.lng || h;
            y = b.formats[m](c, C, Od(Od(Od({}, E), l), g));
          } catch (O) {
            b.logger.warn(O);
          }
          return y;
        } else
          b.logger.warn("there was no format function for ".concat(m));
        return c;
      }, a);
      return s;
    }
  }]), t;
}();
function XH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function WH(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? XH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : XH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function oCe(t) {
  var r = cCe();
  return function() {
    var u = Sc(t), h;
    if (r) {
      var b = Sc(this).constructor;
      h = Reflect.construct(u, arguments, b);
    } else
      h = u.apply(this, arguments);
    return Um(this, h);
  };
}
function cCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function uCe(t, r) {
  t.pending[r] !== void 0 && (delete t.pending[r], t.pendingCount--);
}
var dCe = function(t) {
  gh(a, t);
  var r = oCe(a);
  function a(u, h, b) {
    var l, v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return yo(this, a), l = r.call(this), xA && Bl.call(Er(l)), l.backend = u, l.store = h, l.services = b, l.languageUtils = b.languageUtils, l.options = v, l.logger = ku.create("backendConnector"), l.waitingReads = [], l.maxParallelReads = v.maxParallelReads || 10, l.readingCalls = 0, l.maxRetries = v.maxRetries >= 0 ? v.maxRetries : 5, l.retryTimeout = v.retryTimeout >= 1 ? v.retryTimeout : 350, l.state = {}, l.queue = [], l.backend && l.backend.init && l.backend.init(b, v.backend, v), l;
  }
  return vo(a, [{
    key: "queueLoad",
    value: function(h, b, l, v) {
      var s = this, c = {}, d = {}, p = {}, m = {};
      return h.forEach(function(E) {
        var y = !0;
        b.forEach(function(g) {
          var C = "".concat(E, "|").concat(g);
          !l.reload && s.store.hasResourceBundle(E, g) ? s.state[C] = 2 : s.state[C] < 0 || (s.state[C] === 1 ? d[C] === void 0 && (d[C] = !0) : (s.state[C] = 1, y = !1, d[C] === void 0 && (d[C] = !0), c[C] === void 0 && (c[C] = !0), m[g] === void 0 && (m[g] = !0)));
        }), y || (p[E] = !0);
      }), (Object.keys(c).length || Object.keys(d).length) && this.queue.push({
        pending: d,
        pendingCount: Object.keys(d).length,
        loaded: {},
        errors: [],
        callback: v
      }), {
        toLoad: Object.keys(c),
        pending: Object.keys(d),
        toLoadLanguages: Object.keys(p),
        toLoadNamespaces: Object.keys(m)
      };
    }
  }, {
    key: "loaded",
    value: function(h, b, l) {
      var v = h.split("|"), s = v[0], c = v[1];
      b && this.emit("failedLoading", s, c, b), l && this.store.addResourceBundle(s, c, l), this.state[h] = b ? -1 : 2;
      var d = {};
      this.queue.forEach(function(p) {
        FOe(p.loaded, [s], c), uCe(p, h), b && p.errors.push(b), p.pendingCount === 0 && !p.done && (Object.keys(p.loaded).forEach(function(m) {
          d[m] || (d[m] = {});
          var E = p.loaded[m];
          E.length && E.forEach(function(y) {
            d[m][y] === void 0 && (d[m][y] = !0);
          });
        }), p.done = !0, p.errors.length ? p.callback(p.errors) : p.callback());
      }), this.emit("loaded", d), this.queue = this.queue.filter(function(p) {
        return !p.done;
      });
    }
  }, {
    key: "read",
    value: function(h, b, l) {
      var v = this, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, c = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, d = arguments.length > 5 ? arguments[5] : void 0;
      if (!h.length) return d(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: h,
          ns: b,
          fcName: l,
          tried: s,
          wait: c,
          callback: d
        });
        return;
      }
      this.readingCalls++;
      var p = function(g, C) {
        if (v.readingCalls--, v.waitingReads.length > 0) {
          var O = v.waitingReads.shift();
          v.read(O.lng, O.ns, O.fcName, O.tried, O.wait, O.callback);
        }
        if (g && C && s < v.maxRetries) {
          setTimeout(function() {
            v.read.call(v, h, b, l, s + 1, c * 2, d);
          }, c);
          return;
        }
        d(g, C);
      }, m = this.backend[l].bind(this.backend);
      if (m.length === 2) {
        try {
          var E = m(h, b);
          E && typeof E.then == "function" ? E.then(function(y) {
            return p(null, y);
          }).catch(p) : p(null, E);
        } catch (y) {
          p(y);
        }
        return;
      }
      return m(h, b, p);
    }
  }, {
    key: "prepareLoading",
    value: function(h, b) {
      var l = this, v = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
      typeof h == "string" && (h = this.languageUtils.toResolveHierarchy(h)), typeof b == "string" && (b = [b]);
      var c = this.queueLoad(h, b, v, s);
      if (!c.toLoad.length)
        return c.pending.length || s(), null;
      c.toLoad.forEach(function(d) {
        l.loadOne(d);
      });
    }
  }, {
    key: "load",
    value: function(h, b, l) {
      this.prepareLoading(h, b, {}, l);
    }
  }, {
    key: "reload",
    value: function(h, b, l) {
      this.prepareLoading(h, b, {
        reload: !0
      }, l);
    }
  }, {
    key: "loadOne",
    value: function(h) {
      var b = this, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", v = h.split("|"), s = v[0], c = v[1];
      this.read(s, c, "read", void 0, void 0, function(d, p) {
        d && b.logger.warn("".concat(l, "loading namespace ").concat(c, " for language ").concat(s, " failed"), d), !d && p && b.logger.log("".concat(l, "loaded namespace ").concat(c, " for language ").concat(s), p), b.loaded(h, d, p);
      });
    }
  }, {
    key: "saveMissing",
    value: function(h, b, l, v, s) {
      var c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, d = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
      };
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(b)) {
        this.logger.warn('did not save key "'.concat(l, '" as the namespace "').concat(b, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      if (!(l == null || l === "")) {
        if (this.backend && this.backend.create) {
          var p = WH(WH({}, c), {}, {
            isUpdate: s
          }), m = this.backend.create.bind(this.backend);
          if (m.length < 6)
            try {
              var E;
              m.length === 5 ? E = m(h, b, l, v, p) : E = m(h, b, l, v), E && typeof E.then == "function" ? E.then(function(y) {
                return d(null, y);
              }).catch(d) : d(null, E);
            } catch (y) {
              d(y);
            }
          else
            m(h, b, l, v, d, p);
        }
        !h || !h[0] || this.store.addResource(h[0], b, l, v);
      }
    }
  }]), a;
}(Bl);
function qH() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(r) {
      var a = {};
      if (as(r[1]) === "object" && (a = r[1]), typeof r[1] == "string" && (a.defaultValue = r[1]), typeof r[2] == "string" && (a.tDescription = r[2]), as(r[2]) === "object" || as(r[3]) === "object") {
        var u = r[3] || r[2];
        Object.keys(u).forEach(function(h) {
          a[h] = u[h];
        });
      }
      return a;
    },
    interpolation: {
      escapeValue: !0,
      format: function(r, a, u, h) {
        return r;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function KH(t) {
  return typeof t.ns == "string" && (t.ns = [t.ns]), typeof t.fallbackLng == "string" && (t.fallbackLng = [t.fallbackLng]), typeof t.fallbackNS == "string" && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t;
}
function JH(t, r) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var u = Object.getOwnPropertySymbols(t);
    r && (u = u.filter(function(h) {
      return Object.getOwnPropertyDescriptor(t, h).enumerable;
    })), a.push.apply(a, u);
  }
  return a;
}
function xu(t) {
  for (var r = 1; r < arguments.length; r++) {
    var a = arguments[r] != null ? arguments[r] : {};
    r % 2 ? JH(Object(a), !0).forEach(function(u) {
      Jn(t, u, a[u]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : JH(Object(a)).forEach(function(u) {
      Object.defineProperty(t, u, Object.getOwnPropertyDescriptor(a, u));
    });
  }
  return t;
}
function lCe(t) {
  var r = fCe();
  return function() {
    var u = Sc(t), h;
    if (r) {
      var b = Sc(this).constructor;
      h = Reflect.construct(u, arguments, b);
    } else
      h = u.apply(this, arguments);
    return Um(this, h);
  };
}
function fCe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function z0() {
}
function hCe(t) {
  var r = Object.getOwnPropertyNames(Object.getPrototypeOf(t));
  r.forEach(function(a) {
    typeof t[a] == "function" && (t[a] = t[a].bind(t));
  });
}
var Db = function(t) {
  gh(a, t);
  var r = lCe(a);
  function a() {
    var u, h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, b = arguments.length > 1 ? arguments[1] : void 0;
    if (yo(this, a), u = r.call(this), xA && Bl.call(Er(u)), u.options = KH(h), u.services = {}, u.logger = ku, u.modules = {
      external: []
    }, hCe(Er(u)), b && !u.isInitialized && !h.isClone) {
      if (!u.options.initImmediate)
        return u.init(h, b), Um(u, Er(u));
      setTimeout(function() {
        u.init(h, b);
      }, 0);
    }
    return u;
  }
  return vo(a, [{
    key: "init",
    value: function() {
      var h = this, b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = arguments.length > 1 ? arguments[1] : void 0;
      typeof b == "function" && (l = b, b = {}), !b.defaultNS && b.defaultNS !== !1 && b.ns && (typeof b.ns == "string" ? b.defaultNS = b.ns : b.ns.indexOf("translation") < 0 && (b.defaultNS = b.ns[0]));
      var v = qH();
      this.options = xu(xu(xu({}, v), this.options), KH(b)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = xu(xu({}, v.interpolation), this.options.interpolation)), b.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = b.keySeparator), b.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = b.nsSeparator);
      function s(O) {
        return O ? typeof O == "function" ? new O() : O : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? ku.init(s(this.modules.logger), this.options) : ku.init(null, this.options);
        var c;
        this.modules.formatter ? c = this.modules.formatter : typeof Intl < "u" && (c = aCe);
        var d = new zH(this.options);
        this.store = new JOe(this.options.resources, this.options);
        var p = this.services;
        p.logger = ku, p.resourceStore = this.store, p.languageUtils = d, p.pluralResolver = new rCe(d, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), c && (!this.options.interpolation.format || this.options.interpolation.format === v.interpolation.format) && (p.formatter = s(c), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new iCe(this.options), p.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, p.backendConnector = new dCe(s(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(O) {
          for (var N = arguments.length, w = new Array(N > 1 ? N - 1 : 0), _ = 1; _ < N; _++)
            w[_ - 1] = arguments[_];
          h.emit.apply(h, [O].concat(w));
        }), this.modules.languageDetector && (p.languageDetector = s(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = s(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new BH(this.services, this.options), this.translator.on("*", function(O) {
          for (var N = arguments.length, w = new Array(N > 1 ? N - 1 : 0), _ = 1; _ < N; _++)
            w[_ - 1] = arguments[_];
          h.emit.apply(h, [O].concat(w));
        }), this.modules.external.forEach(function(O) {
          O.init && O.init(h);
        });
      }
      if (this.format = this.options.interpolation.format, l || (l = z0), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var m = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        m.length > 0 && m[0] !== "dev" && (this.options.lng = m[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var E = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      E.forEach(function(O) {
        h[O] = function() {
          var N;
          return (N = h.store)[O].apply(N, arguments);
        };
      });
      var y = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      y.forEach(function(O) {
        h[O] = function() {
          var N;
          return (N = h.store)[O].apply(N, arguments), h;
        };
      });
      var g = wy(), C = function() {
        var N = function(_, I) {
          h.isInitialized && !h.initializedStoreOnce && h.logger.warn("init: i18next is already initialized. You should call init just once!"), h.isInitialized = !0, h.options.isClone || h.logger.log("initialized", h.options), h.emit("initialized", h.options), g.resolve(I), l(_, I);
        };
        if (h.languages && h.options.compatibilityAPI !== "v1" && !h.isInitialized) return N(null, h.t.bind(h));
        h.changeLanguage(h.options.lng, N);
      };
      return this.options.resources || !this.options.initImmediate ? C() : setTimeout(C, 0), g;
    }
  }, {
    key: "loadResources",
    value: function(h) {
      var b = this, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : z0, v = l, s = typeof h == "string" ? h : this.language;
      if (typeof h == "function" && (v = h), !this.options.resources || this.options.partialBundledLanguages) {
        if (s && s.toLowerCase() === "cimode") return v();
        var c = [], d = function(E) {
          if (E) {
            var y = b.services.languageUtils.toResolveHierarchy(E);
            y.forEach(function(g) {
              c.indexOf(g) < 0 && c.push(g);
            });
          }
        };
        if (s)
          d(s);
        else {
          var p = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          p.forEach(function(m) {
            return d(m);
          });
        }
        this.options.preload && this.options.preload.forEach(function(m) {
          return d(m);
        }), this.services.backendConnector.load(c, this.options.ns, function(m) {
          !m && !b.resolvedLanguage && b.language && b.setResolvedLanguage(b.language), v(m);
        });
      } else
        v(null);
    }
  }, {
    key: "reloadResources",
    value: function(h, b, l) {
      var v = wy();
      return h || (h = this.languages), b || (b = this.options.ns), l || (l = z0), this.services.backendConnector.reload(h, b, function(s) {
        v.resolve(), l(s);
      }), v;
    }
  }, {
    key: "use",
    value: function(h) {
      if (!h) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!h.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return h.type === "backend" && (this.modules.backend = h), (h.type === "logger" || h.log && h.warn && h.error) && (this.modules.logger = h), h.type === "languageDetector" && (this.modules.languageDetector = h), h.type === "i18nFormat" && (this.modules.i18nFormat = h), h.type === "postProcessor" && NY.addPostProcessor(h), h.type === "formatter" && (this.modules.formatter = h), h.type === "3rdParty" && this.modules.external.push(h), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(h) {
      if (!(!h || !this.languages) && !(["cimode", "dev"].indexOf(h) > -1))
        for (var b = 0; b < this.languages.length; b++) {
          var l = this.languages[b];
          if (!(["cimode", "dev"].indexOf(l) > -1) && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(h, b) {
      var l = this;
      this.isLanguageChangingTo = h;
      var v = wy();
      this.emit("languageChanging", h);
      var s = function(m) {
        l.language = m, l.languages = l.services.languageUtils.toResolveHierarchy(m), l.resolvedLanguage = void 0, l.setResolvedLanguage(m);
      }, c = function(m, E) {
        E ? (s(E), l.translator.changeLanguage(E), l.isLanguageChangingTo = void 0, l.emit("languageChanged", E), l.logger.log("languageChanged", E)) : l.isLanguageChangingTo = void 0, v.resolve(function() {
          return l.t.apply(l, arguments);
        }), b && b(m, function() {
          return l.t.apply(l, arguments);
        });
      }, d = function(m) {
        !h && !m && l.services.languageDetector && (m = []);
        var E = typeof m == "string" ? m : l.services.languageUtils.getBestMatchFromCodes(m);
        E && (l.language || s(E), l.translator.language || l.translator.changeLanguage(E), l.services.languageDetector && l.services.languageDetector.cacheUserLanguage && l.services.languageDetector.cacheUserLanguage(E)), l.loadResources(E, function(y) {
          c(y, E);
        });
      };
      return !h && this.services.languageDetector && !this.services.languageDetector.async ? d(this.services.languageDetector.detect()) : !h && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(d) : this.services.languageDetector.detect(d) : d(h), v;
    }
  }, {
    key: "getFixedT",
    value: function(h, b, l) {
      var v = this, s = function c(d, p) {
        var m;
        if (as(p) !== "object") {
          for (var E = arguments.length, y = new Array(E > 2 ? E - 2 : 0), g = 2; g < E; g++)
            y[g - 2] = arguments[g];
          m = v.options.overloadTranslationOptionHandler([d, p].concat(y));
        } else
          m = xu({}, p);
        m.lng = m.lng || c.lng, m.lngs = m.lngs || c.lngs, m.ns = m.ns || c.ns, m.keyPrefix = m.keyPrefix || l || c.keyPrefix;
        var C = v.options.keySeparator || ".", O;
        return m.keyPrefix && Array.isArray(d) ? O = d.map(function(N) {
          return "".concat(m.keyPrefix).concat(C).concat(N);
        }) : O = m.keyPrefix ? "".concat(m.keyPrefix).concat(C).concat(d) : d, v.t(O, m);
      };
      return typeof h == "string" ? s.lng = h : s.lngs = h, s.ns = b, s.keyPrefix = l, s;
    }
  }, {
    key: "t",
    value: function() {
      var h;
      return this.translator && (h = this.translator).translate.apply(h, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var h;
      return this.translator && (h = this.translator).exists.apply(h, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(h) {
      this.options.defaultNS = h;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(h) {
      var b = this, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var v = l.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, c = this.languages[this.languages.length - 1];
      if (v.toLowerCase() === "cimode") return !0;
      var d = function(E, y) {
        var g = b.services.backendConnector.state["".concat(E, "|").concat(y)];
        return g === -1 || g === 2;
      };
      if (l.precheck) {
        var p = l.precheck(this, d);
        if (p !== void 0) return p;
      }
      return !!(this.hasResourceBundle(v, h) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || d(v, h) && (!s || d(c, h)));
    }
  }, {
    key: "loadNamespaces",
    value: function(h, b) {
      var l = this, v = wy();
      return this.options.ns ? (typeof h == "string" && (h = [h]), h.forEach(function(s) {
        l.options.ns.indexOf(s) < 0 && l.options.ns.push(s);
      }), this.loadResources(function(s) {
        v.resolve(), b && b(s);
      }), v) : (b && b(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(h, b) {
      var l = wy();
      typeof h == "string" && (h = [h]);
      var v = this.options.preload || [], s = h.filter(function(c) {
        return v.indexOf(c) < 0;
      });
      return s.length ? (this.options.preload = v.concat(s), this.loadResources(function(c) {
        l.resolve(), b && b(c);
      }), l) : (b && b(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(h) {
      if (h || (h = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !h) return "rtl";
      var b = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], l = this.services && this.services.languageUtils || new zH(qH());
      return b.indexOf(l.getLanguagePartFromCode(h)) > -1 || h.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var h = this, b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : z0, v = xu(xu(xu({}, this.options), b), {
        isClone: !0
      }), s = new a(v);
      (b.debug !== void 0 || b.prefix !== void 0) && (s.logger = s.logger.clone(b));
      var c = ["store", "services", "language"];
      return c.forEach(function(d) {
        s[d] = h[d];
      }), s.services = xu({}, this.services), s.services.utils = {
        hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
      }, s.translator = new BH(s.services, s.options), s.translator.on("*", function(d) {
        for (var p = arguments.length, m = new Array(p > 1 ? p - 1 : 0), E = 1; E < p; E++)
          m[E - 1] = arguments[E];
        s.emit.apply(s, [d].concat(m));
      }), s.init(v, l), s.translator.options = s.options, s.translator.backendConnector.services.utils = {
        hasLoadedNamespace: s.hasLoadedNamespace.bind(s)
      }, s;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), a;
}(Bl);
Jn(Db, "createInstance", function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
  return new Db(t, r);
});
var ua = Db.createInstance();
ua.createInstance = Db.createInstance;
ua.createInstance;
ua.dir;
ua.init;
ua.loadResources;
ua.reloadResources;
ua.use;
ua.changeLanguage;
ua.getFixedT;
ua.t;
ua.exists;
ua.setDefaultNamespace;
ua.hasLoadedNamespace;
ua.loadNamespaces;
ua.loadLanguages;
const pCe = (t) => {
  const { getPrefixCls: r } = _t.useContext(Hn), { prefix: a, style: u, onSearch: h, onClear: b, headerContent: l, className: v, renderHeader: s, onClickItem: c } = t, d = Zn(Vn), { theme: p, rootStore: m } = d, { appUsersInfo: E } = m.addressStore || {}, y = (p == null ? void 0 : p.mode) || "light", g = r("thread-panel", a), { t: C } = Yr(), O = En(
    g,
    {
      [`${g}-${y}`]: !!y
    },
    v
  ), N = Fv(), [w, _] = tn(!1), I = () => {
    var se;
    (se = t.onClose) == null || se.call(t);
  }, k = (se) => {
    h == null || h(se);
    const ee = se.target.value, de = G.filter((he) => he.name.includes(ee));
    M(de);
  }, H = () => /* @__PURE__ */ q.jsx("div", { className: `${g}-header`, children: w ? /* @__PURE__ */ q.jsx(
    Ml,
    {
      className: `${g}-header-title-input`,
      close: !0,
      onChange: k,
      onClear: () => {
        b == null || b(), M(G), _(!1);
      }
    }
  ) : /* @__PURE__ */ q.jsx("div", { className: `${g}-header-title`, children: l || ua.t("threadList") }) }), S = () => {
    _(!0);
  }, B = er(null), [D, F] = tn(), j = m.conversationStore.currentCvs, G = m.threadStore.threadList[j.conversationId] || [], [U, M] = tn(G), V = (se) => {
    c == null || c(se), m.threadStore.joinChatThread(se.id || ""), m.threadStore.setThreadVisible(!0), m.threadStore.getChatThreadDetail(se.id);
  }, J = () => {
    var se;
    D !== null && ((se = m.threadStore.getGroupChatThreads(j.conversationId, D)) == null || se.then((ee) => {
      F(ee), setTimeout(() => {
        var de, he;
        (he = (de = B == null ? void 0 : B.current) == null ? void 0 : de.scrollTo) == null || he.call(de, G.length * 56);
      }, 100);
    }));
  }, ue = () => {
    const se = (de, he) => {
      var Ce, _e, Le, Te, K, Oe, Pe, xe, be, $e;
      let pe = "";
      switch ((Ce = de.lastMessage) == null ? void 0 : Ce.type) {
        case "txt":
          pe = (_e = de.lastMessage) == null ? void 0 : _e.msg;
          break;
        case "img":
          pe = `/${C("image")}/`;
          break;
        case "audio":
          pe = `/${C("audio")}/`;
          break;
        case "file":
          pe = `/${C("file")}/`;
          break;
        case "video":
          pe = `/${C("video")}/`;
          break;
        case "custom":
          pe = `/${C("custom")}/`;
          break;
        case "combine":
          pe = `/${C("combine")}/`;
          break;
        default:
          console.warn("unexpected message type:", (Le = de.lastMessage) == null ? void 0 : Le.type);
          break;
      }
      return /* @__PURE__ */ q.jsxs(
        "div",
        {
          className: `${g}-item`,
          onClick: () => {
            V(de);
          },
          children: [
            /* @__PURE__ */ q.jsxs("span", { className: `${g}-item-name`, children: [
              " ",
              de.name
            ] }),
            ((Te = de.lastMessage) == null ? void 0 : Te.type) && /* @__PURE__ */ q.jsxs("div", { className: `${g}-item-msgBox`, children: [
              /* @__PURE__ */ q.jsx(zs, { size: 12, src: (Oe = E == null ? void 0 : E[(K = de.lastMessage) == null ? void 0 : K.from]) == null ? void 0 : Oe.avatarurl, children: ((xe = E == null ? void 0 : E[(Pe = de.lastMessage) == null ? void 0 : Pe.from]) == null ? void 0 : xe.nickname) || ((be = de.lastMessage) == null ? void 0 : be.from) }),
              /* @__PURE__ */ q.jsx("div", { className: `${g}-item-msgBox-name`, children: Bu(
                de.lastMessage,
                de.parentId
              ) }),
              /* @__PURE__ */ q.jsx("div", { children: pe }),
              /* @__PURE__ */ q.jsx("div", { children: Tm(($e = de.lastMessage) == null ? void 0 : $e.time) })
            ] })
          ]
        },
        he
      );
    };
    return /* @__PURE__ */ q.jsx(
      N,
      {
        ref: B,
        loading: !1,
        loadMoreItems: J,
        scrollDirection: "down",
        paddingHeight: 50,
        data: U,
        renderItem: se
      }
    );
  };
  return Pn(() => {
    var se;
    j.conversationId && ((se = m.threadStore.getGroupChatThreads(j.conversationId)) == null || se.then((ee) => {
      F(ee);
    }));
  }, [j.conversationId]), Pn(() => {
    M(G);
  }, [G.length, j.conversationId]), /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: O,
      style: {
        ...u
      },
      children: [
        " ",
        s ? s() : /* @__PURE__ */ q.jsx(
          au,
          {
            avatar: !0,
            close: !0,
            moreAction: { visible: !1, actions: [] },
            onClickClose: I,
            content: H(),
            suffixIcon: /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", onClick: S, children: /* @__PURE__ */ q.jsx(pn, { type: "SEARCH", width: 24, height: 24 }) })
          }
        ),
        /* @__PURE__ */ q.jsx("div", { className: `${g}-content`, children: /* @__PURE__ */ q.jsx("div", { className: `${g}-threads-box`, children: ue() }) })
      ]
    }
  );
}, gCe = mi(pCe), mCe = (t) => {
  const { style: r, icon: a } = t, u = () => {
    var l;
    b(!1), (l = t.onClose) == null || l.call(t);
  }, [h, b] = tn(!1);
  return /* @__PURE__ */ q.jsx(
    va,
    {
      overlayInnerStyle: { padding: 0 },
      title: /* @__PURE__ */ q.jsx(
        gCe,
        {
          style: {
            ...r
          },
          onClose: u,
          onClickItem: () => {
            b(!1);
          }
        }
      ),
      trigger: "click",
      arrowPointAtCenter: !1,
      arrow: !1,
      placement: "bottomLeft",
      open: h,
      onOpenChange: (l) => {
        b(l);
      },
      children: a || /* @__PURE__ */ q.jsx(gi, { type: "text", shape: "circle", children: /* @__PURE__ */ q.jsx(pn, { type: "HASHTAG_IN_BUBBLE_FILL", width: 24, height: 24 }) })
    }
  );
}, ECe = mi(mCe);
UOe.displayName = "Thread";
var DN = { exports: {} }, $R = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ZH;
function yCe() {
  if (ZH) return $R;
  ZH = 1;
  var t = _t;
  function r(p, m) {
    return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
  }
  var a = typeof Object.is == "function" ? Object.is : r, u = t.useState, h = t.useEffect, b = t.useLayoutEffect, l = t.useDebugValue;
  function v(p, m) {
    var E = m(), y = u({ inst: { value: E, getSnapshot: m } }), g = y[0].inst, C = y[1];
    return b(
      function() {
        g.value = E, g.getSnapshot = m, s(g) && C({ inst: g });
      },
      [p, E, m]
    ), h(
      function() {
        return s(g) && C({ inst: g }), p(function() {
          s(g) && C({ inst: g });
        });
      },
      [p]
    ), l(E), E;
  }
  function s(p) {
    var m = p.getSnapshot;
    p = p.value;
    try {
      var E = m();
      return !a(p, E);
    } catch {
      return !0;
    }
  }
  function c(p, m) {
    return m();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : v;
  return $R.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : d, $R;
}
var e2 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var QH;
function vCe() {
  return QH || (QH = 1, process.env.NODE_ENV !== "production" && function() {
    function t(E, y) {
      return E === y && (E !== 0 || 1 / E === 1 / y) || E !== E && y !== y;
    }
    function r(E, y) {
      d || h.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = y();
      if (!p) {
        var C = y();
        b(g, C) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), p = !0);
      }
      C = l({
        inst: { value: g, getSnapshot: y }
      });
      var O = C[0].inst, N = C[1];
      return s(
        function() {
          O.value = g, O.getSnapshot = y, a(O) && N({ inst: O });
        },
        [E, g, y]
      ), v(
        function() {
          return a(O) && N({ inst: O }), E(function() {
            a(O) && N({ inst: O });
          });
        },
        [E]
      ), c(g), g;
    }
    function a(E) {
      var y = E.getSnapshot;
      E = E.value;
      try {
        var g = y();
        return !b(E, g);
      } catch {
        return !0;
      }
    }
    function u(E, y) {
      return y();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var h = _t, b = typeof Object.is == "function" ? Object.is : t, l = h.useState, v = h.useEffect, s = h.useLayoutEffect, c = h.useDebugValue, d = !1, p = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : r;
    e2.useSyncExternalStore = h.useSyncExternalStore !== void 0 ? h.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), e2;
}
process.env.NODE_ENV === "production" ? DN.exports = yCe() : DN.exports = vCe();
var wY = DN.exports, MN = { exports: {} }, t2 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $H;
function TCe() {
  if ($H) return t2;
  $H = 1;
  var t = _t, r = wY;
  function a(c, d) {
    return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
  }
  var u = typeof Object.is == "function" ? Object.is : a, h = r.useSyncExternalStore, b = t.useRef, l = t.useEffect, v = t.useMemo, s = t.useDebugValue;
  return t2.useSyncExternalStoreWithSelector = function(c, d, p, m, E) {
    var y = b(null);
    if (y.current === null) {
      var g = { hasValue: !1, value: null };
      y.current = g;
    } else g = y.current;
    y = v(
      function() {
        function O(k) {
          if (!N) {
            if (N = !0, w = k, k = m(k), E !== void 0 && g.hasValue) {
              var H = g.value;
              if (E(H, k))
                return _ = H;
            }
            return _ = k;
          }
          if (H = _, u(w, k)) return H;
          var S = m(k);
          return E !== void 0 && E(H, S) ? (w = k, H) : (w = k, _ = S);
        }
        var N = !1, w, _, I = p === void 0 ? null : p;
        return [
          function() {
            return O(d());
          },
          I === null ? void 0 : function() {
            return O(I());
          }
        ];
      },
      [d, p, m, E]
    );
    var C = h(c, y[0], y[1]);
    return l(
      function() {
        g.hasValue = !0, g.value = C;
      },
      [C]
    ), s(C), C;
  }, t2;
}
var n2 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eB;
function bCe() {
  return eB || (eB = 1, process.env.NODE_ENV !== "production" && function() {
    function t(c, d) {
      return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = _t, a = wY, u = typeof Object.is == "function" ? Object.is : t, h = a.useSyncExternalStore, b = r.useRef, l = r.useEffect, v = r.useMemo, s = r.useDebugValue;
    n2.useSyncExternalStoreWithSelector = function(c, d, p, m, E) {
      var y = b(null);
      if (y.current === null) {
        var g = { hasValue: !1, value: null };
        y.current = g;
      } else g = y.current;
      y = v(
        function() {
          function O(k) {
            if (!N) {
              if (N = !0, w = k, k = m(k), E !== void 0 && g.hasValue) {
                var H = g.value;
                if (E(H, k))
                  return _ = H;
              }
              return _ = k;
            }
            if (H = _, u(w, k))
              return H;
            var S = m(k);
            return E !== void 0 && E(H, S) ? (w = k, H) : (w = k, _ = S);
          }
          var N = !1, w, _, I = p === void 0 ? null : p;
          return [
            function() {
              return O(d());
            },
            I === null ? void 0 : function() {
              return O(I());
            }
          ];
        },
        [d, p, m, E]
      );
      var C = h(c, y[0], y[1]);
      return l(
        function() {
          g.hasValue = !0, g.value = C;
        },
        [C]
      ), s(C), C;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), n2;
}
process.env.NODE_ENV === "production" ? MN.exports = TCe() : MN.exports = bCe();
var ACe = MN.exports;
function OCe(t) {
  t();
}
let _Y = OCe;
const CCe = (t) => _Y = t, SCe = () => _Y, tB = Symbol.for("react-redux-context"), nB = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function ICe() {
  var t;
  if (!ht.createContext) return {};
  const r = (t = nB[tB]) != null ? t : nB[tB] = /* @__PURE__ */ new Map();
  let a = r.get(ht.createContext);
  return a || (a = ht.createContext(null), process.env.NODE_ENV !== "production" && (a.displayName = "ReactRedux"), r.set(ht.createContext, a)), a;
}
const zl = /* @__PURE__ */ ICe();
function t_(t = zl) {
  return function() {
    const a = Zn(t);
    if (process.env.NODE_ENV !== "production" && !a)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return a;
  };
}
const PY = /* @__PURE__ */ t_(), RCe = () => {
  throw new Error("uSES not initialized!");
};
let xY = RCe;
const NCe = (t) => {
  xY = t;
}, wCe = (t, r) => t === r;
function _Ce(t = zl) {
  const r = t === zl ? PY : t_(t);
  return function(u, h = {}) {
    const {
      equalityFn: b = wCe,
      stabilityCheck: l = void 0,
      noopCheck: v = void 0
    } = typeof h == "function" ? {
      equalityFn: h
    } : h;
    if (process.env.NODE_ENV !== "production") {
      if (!u)
        throw new Error("You must pass a selector to useSelector");
      if (typeof u != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof b != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: s,
      subscription: c,
      getServerState: d,
      stabilityCheck: p,
      noopCheck: m
    } = r(), E = er(!0), y = Uy({
      [u.name](C) {
        const O = u(C);
        if (process.env.NODE_ENV !== "production") {
          const N = typeof l > "u" ? p : l;
          if (N === "always" || N === "once" && E.current) {
            const _ = u(C);
            if (!b(O, _)) {
              let I;
              try {
                throw new Error();
              } catch (k) {
                ({
                  stack: I
                } = k);
              }
              console.warn("Selector " + (u.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
                state: C,
                selected: O,
                selected2: _,
                stack: I
              });
            }
          }
          const w = typeof v > "u" ? m : v;
          if ((w === "always" || w === "once" && E.current) && O === C) {
            let _;
            try {
              throw new Error();
            } catch (I) {
              ({
                stack: _
              } = I);
            }
            console.warn("Selector " + (u.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`, {
              stack: _
            });
          }
          E.current && (E.current = !1);
        }
        return O;
      }
    }[u.name], [u, p, l]), g = xY(c.addNestedSub, s.getState, d || s.getState, y, b);
    return Fce(g), g;
  };
}
const Ja = /* @__PURE__ */ _Ce();
var LN = { exports: {} }, Ii = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rB;
function PCe() {
  if (rB) return Ii;
  rB = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, h = t ? Symbol.for("react.strict_mode") : 60108, b = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, v = t ? Symbol.for("react.context") : 60110, s = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, E = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
  function w(I) {
    if (typeof I == "object" && I !== null) {
      var k = I.$$typeof;
      switch (k) {
        case r:
          switch (I = I.type, I) {
            case s:
            case c:
            case u:
            case b:
            case h:
            case p:
              return I;
            default:
              switch (I = I && I.$$typeof, I) {
                case v:
                case d:
                case y:
                case E:
                case l:
                  return I;
                default:
                  return k;
              }
          }
        case a:
          return k;
      }
    }
  }
  function _(I) {
    return w(I) === c;
  }
  return Ii.AsyncMode = s, Ii.ConcurrentMode = c, Ii.ContextConsumer = v, Ii.ContextProvider = l, Ii.Element = r, Ii.ForwardRef = d, Ii.Fragment = u, Ii.Lazy = y, Ii.Memo = E, Ii.Portal = a, Ii.Profiler = b, Ii.StrictMode = h, Ii.Suspense = p, Ii.isAsyncMode = function(I) {
    return _(I) || w(I) === s;
  }, Ii.isConcurrentMode = _, Ii.isContextConsumer = function(I) {
    return w(I) === v;
  }, Ii.isContextProvider = function(I) {
    return w(I) === l;
  }, Ii.isElement = function(I) {
    return typeof I == "object" && I !== null && I.$$typeof === r;
  }, Ii.isForwardRef = function(I) {
    return w(I) === d;
  }, Ii.isFragment = function(I) {
    return w(I) === u;
  }, Ii.isLazy = function(I) {
    return w(I) === y;
  }, Ii.isMemo = function(I) {
    return w(I) === E;
  }, Ii.isPortal = function(I) {
    return w(I) === a;
  }, Ii.isProfiler = function(I) {
    return w(I) === b;
  }, Ii.isStrictMode = function(I) {
    return w(I) === h;
  }, Ii.isSuspense = function(I) {
    return w(I) === p;
  }, Ii.isValidElementType = function(I) {
    return typeof I == "string" || typeof I == "function" || I === u || I === c || I === b || I === h || I === p || I === m || typeof I == "object" && I !== null && (I.$$typeof === y || I.$$typeof === E || I.$$typeof === l || I.$$typeof === v || I.$$typeof === d || I.$$typeof === C || I.$$typeof === O || I.$$typeof === N || I.$$typeof === g);
  }, Ii.typeOf = w, Ii;
}
var Ri = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iB;
function xCe() {
  return iB || (iB = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, h = t ? Symbol.for("react.strict_mode") : 60108, b = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, v = t ? Symbol.for("react.context") : 60110, s = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, E = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
    function w(be) {
      return typeof be == "string" || typeof be == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      be === u || be === c || be === b || be === h || be === p || be === m || typeof be == "object" && be !== null && (be.$$typeof === y || be.$$typeof === E || be.$$typeof === l || be.$$typeof === v || be.$$typeof === d || be.$$typeof === C || be.$$typeof === O || be.$$typeof === N || be.$$typeof === g);
    }
    function _(be) {
      if (typeof be == "object" && be !== null) {
        var $e = be.$$typeof;
        switch ($e) {
          case r:
            var Be = be.type;
            switch (Be) {
              case s:
              case c:
              case u:
              case b:
              case h:
              case p:
                return Be;
              default:
                var Ke = Be && Be.$$typeof;
                switch (Ke) {
                  case v:
                  case d:
                  case y:
                  case E:
                  case l:
                    return Ke;
                  default:
                    return $e;
                }
            }
          case a:
            return $e;
        }
      }
    }
    var I = s, k = c, H = v, S = l, B = r, D = d, F = u, j = y, G = E, U = a, M = b, V = h, J = p, ue = !1;
    function se(be) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ee(be) || _(be) === s;
    }
    function ee(be) {
      return _(be) === c;
    }
    function de(be) {
      return _(be) === v;
    }
    function he(be) {
      return _(be) === l;
    }
    function pe(be) {
      return typeof be == "object" && be !== null && be.$$typeof === r;
    }
    function Ce(be) {
      return _(be) === d;
    }
    function _e(be) {
      return _(be) === u;
    }
    function Le(be) {
      return _(be) === y;
    }
    function Te(be) {
      return _(be) === E;
    }
    function K(be) {
      return _(be) === a;
    }
    function Oe(be) {
      return _(be) === b;
    }
    function Pe(be) {
      return _(be) === h;
    }
    function xe(be) {
      return _(be) === p;
    }
    Ri.AsyncMode = I, Ri.ConcurrentMode = k, Ri.ContextConsumer = H, Ri.ContextProvider = S, Ri.Element = B, Ri.ForwardRef = D, Ri.Fragment = F, Ri.Lazy = j, Ri.Memo = G, Ri.Portal = U, Ri.Profiler = M, Ri.StrictMode = V, Ri.Suspense = J, Ri.isAsyncMode = se, Ri.isConcurrentMode = ee, Ri.isContextConsumer = de, Ri.isContextProvider = he, Ri.isElement = pe, Ri.isForwardRef = Ce, Ri.isFragment = _e, Ri.isLazy = Le, Ri.isMemo = Te, Ri.isPortal = K, Ri.isProfiler = Oe, Ri.isStrictMode = Pe, Ri.isSuspense = xe, Ri.isValidElementType = w, Ri.typeOf = _;
  }()), Ri;
}
process.env.NODE_ENV === "production" ? LN.exports = PCe() : LN.exports = xCe();
var DCe = LN.exports, DY = DCe, MCe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, LCe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, MY = {};
MY[DY.ForwardRef] = MCe;
MY[DY.Memo] = LCe;
var Ni = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sB;
function kCe() {
  if (sB) return Ni;
  sB = 1;
  var t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), l = Symbol.for("react.context"), v = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function g(C) {
    if (typeof C == "object" && C !== null) {
      var O = C.$$typeof;
      switch (O) {
        case t:
          switch (C = C.type, C) {
            case a:
            case h:
            case u:
            case c:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case v:
                case l:
                case s:
                case m:
                case p:
                case b:
                  return C;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  return Ni.ContextConsumer = l, Ni.ContextProvider = b, Ni.Element = t, Ni.ForwardRef = s, Ni.Fragment = a, Ni.Lazy = m, Ni.Memo = p, Ni.Portal = r, Ni.Profiler = h, Ni.StrictMode = u, Ni.Suspense = c, Ni.SuspenseList = d, Ni.isAsyncMode = function() {
    return !1;
  }, Ni.isConcurrentMode = function() {
    return !1;
  }, Ni.isContextConsumer = function(C) {
    return g(C) === l;
  }, Ni.isContextProvider = function(C) {
    return g(C) === b;
  }, Ni.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Ni.isForwardRef = function(C) {
    return g(C) === s;
  }, Ni.isFragment = function(C) {
    return g(C) === a;
  }, Ni.isLazy = function(C) {
    return g(C) === m;
  }, Ni.isMemo = function(C) {
    return g(C) === p;
  }, Ni.isPortal = function(C) {
    return g(C) === r;
  }, Ni.isProfiler = function(C) {
    return g(C) === h;
  }, Ni.isStrictMode = function(C) {
    return g(C) === u;
  }, Ni.isSuspense = function(C) {
    return g(C) === c;
  }, Ni.isSuspenseList = function(C) {
    return g(C) === d;
  }, Ni.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === a || C === h || C === u || C === c || C === d || C === E || typeof C == "object" && C !== null && (C.$$typeof === m || C.$$typeof === p || C.$$typeof === b || C.$$typeof === l || C.$$typeof === s || C.$$typeof === y || C.getModuleId !== void 0);
  }, Ni.typeOf = g, Ni;
}
var wi = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aB;
function jCe() {
  return aB || (aB = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), l = Symbol.for("react.context"), v = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), y = !1, g = !1, C = !1, O = !1, N = !1, w;
    w = Symbol.for("react.module.reference");
    function _(Be) {
      return !!(typeof Be == "string" || typeof Be == "function" || Be === a || Be === h || N || Be === u || Be === c || Be === d || O || Be === E || y || g || C || typeof Be == "object" && Be !== null && (Be.$$typeof === m || Be.$$typeof === p || Be.$$typeof === b || Be.$$typeof === l || Be.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Be.$$typeof === w || Be.getModuleId !== void 0));
    }
    function I(Be) {
      if (typeof Be == "object" && Be !== null) {
        var Ke = Be.$$typeof;
        switch (Ke) {
          case t:
            var Ze = Be.type;
            switch (Ze) {
              case a:
              case h:
              case u:
              case c:
              case d:
                return Ze;
              default:
                var at = Ze && Ze.$$typeof;
                switch (at) {
                  case v:
                  case l:
                  case s:
                  case m:
                  case p:
                  case b:
                    return at;
                  default:
                    return Ke;
                }
            }
          case r:
            return Ke;
        }
      }
    }
    var k = l, H = b, S = t, B = s, D = a, F = m, j = p, G = r, U = h, M = u, V = c, J = d, ue = !1, se = !1;
    function ee(Be) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function de(Be) {
      return se || (se = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function he(Be) {
      return I(Be) === l;
    }
    function pe(Be) {
      return I(Be) === b;
    }
    function Ce(Be) {
      return typeof Be == "object" && Be !== null && Be.$$typeof === t;
    }
    function _e(Be) {
      return I(Be) === s;
    }
    function Le(Be) {
      return I(Be) === a;
    }
    function Te(Be) {
      return I(Be) === m;
    }
    function K(Be) {
      return I(Be) === p;
    }
    function Oe(Be) {
      return I(Be) === r;
    }
    function Pe(Be) {
      return I(Be) === h;
    }
    function xe(Be) {
      return I(Be) === u;
    }
    function be(Be) {
      return I(Be) === c;
    }
    function $e(Be) {
      return I(Be) === d;
    }
    wi.ContextConsumer = k, wi.ContextProvider = H, wi.Element = S, wi.ForwardRef = B, wi.Fragment = D, wi.Lazy = F, wi.Memo = j, wi.Portal = G, wi.Profiler = U, wi.StrictMode = M, wi.Suspense = V, wi.SuspenseList = J, wi.isAsyncMode = ee, wi.isConcurrentMode = de, wi.isContextConsumer = he, wi.isContextProvider = pe, wi.isElement = Ce, wi.isForwardRef = _e, wi.isFragment = Le, wi.isLazy = Te, wi.isMemo = K, wi.isPortal = Oe, wi.isProfiler = Pe, wi.isStrictMode = xe, wi.isSuspense = be, wi.isSuspenseList = $e, wi.isValidElementType = _, wi.typeOf = I;
  }()), wi;
}
process.env.NODE_ENV === "production" ? kCe() : jCe();
function UCe() {
  const t = SCe();
  let r = null, a = null;
  return {
    clear() {
      r = null, a = null;
    },
    notify() {
      t(() => {
        let u = r;
        for (; u; )
          u.callback(), u = u.next;
      });
    },
    get() {
      let u = [], h = r;
      for (; h; )
        u.push(h), h = h.next;
      return u;
    },
    subscribe(u) {
      let h = !0, b = a = {
        callback: u,
        next: null,
        prev: a
      };
      return b.prev ? b.prev.next = b : r = b, function() {
        !h || r === null || (h = !1, b.next ? b.next.prev = b.prev : a = b.prev, b.prev ? b.prev.next = b.next : r = b.next);
      };
    }
  };
}
const oB = {
  notify() {
  },
  get: () => []
};
function HCe(t, r) {
  let a, u = oB, h = 0, b = !1;
  function l(g) {
    d();
    const C = u.subscribe(g);
    let O = !1;
    return () => {
      O || (O = !0, C(), p());
    };
  }
  function v() {
    u.notify();
  }
  function s() {
    y.onStateChange && y.onStateChange();
  }
  function c() {
    return b;
  }
  function d() {
    h++, a || (a = t.subscribe(s), u = UCe());
  }
  function p() {
    h--, a && h === 0 && (a(), a = void 0, u.clear(), u = oB);
  }
  function m() {
    b || (b = !0, d());
  }
  function E() {
    b && (b = !1, p());
  }
  const y = {
    addNestedSub: l,
    notifyNestedSubs: v,
    handleChangeWrapper: s,
    isSubscribed: c,
    trySubscribe: m,
    tryUnsubscribe: E,
    getListeners: () => u
  };
  return y;
}
const BCe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", zCe = BCe ? ht.useLayoutEffect : ht.useEffect;
function FCe({
  store: t,
  context: r,
  children: a,
  serverState: u,
  stabilityCheck: h = "once",
  noopCheck: b = "once"
}) {
  const l = ht.useMemo(() => {
    const c = HCe(t);
    return {
      store: t,
      subscription: c,
      getServerState: u ? () => u : void 0,
      stabilityCheck: h,
      noopCheck: b
    };
  }, [t, u, h, b]), v = ht.useMemo(() => t.getState(), [t]);
  zCe(() => {
    const {
      subscription: c
    } = l;
    return c.onStateChange = c.notifyNestedSubs, c.trySubscribe(), v !== t.getState() && c.notifyNestedSubs(), () => {
      c.tryUnsubscribe(), c.onStateChange = void 0;
    };
  }, [l, v]);
  const s = r || zl;
  return /* @__PURE__ */ ht.createElement(s.Provider, {
    value: l
  }, a);
}
function LY(t = zl) {
  const r = (
    // @ts-ignore
    t === zl ? PY : (
      // @ts-ignore
      t_(t)
    )
  );
  return function() {
    const {
      store: u
    } = r();
    return u;
  };
}
const GCe = /* @__PURE__ */ LY();
function VCe(t = zl) {
  const r = (
    // @ts-ignore
    t === zl ? GCe : LY(t)
  );
  return function() {
    return r().dispatch;
  };
}
const DA = /* @__PURE__ */ VCe();
NCe(ACe.useSyncExternalStoreWithSelector);
CCe(nz);
function oa(t) {
  for (var r = arguments.length, a = Array(r > 1 ? r - 1 : 0), u = 1; u < r; u++) a[u - 1] = arguments[u];
  if (process.env.NODE_ENV !== "production") {
    var h = $Ce[t], b = h ? typeof h == "function" ? h.apply(null, a) : h : "unknown error nr: " + t;
    throw Error("[Immer] " + b);
  }
  throw Error("[Immer] minified error nr: " + t + (a.length ? " " + a.map(function(l) {
    return "'" + l + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Fl(t) {
  return !!t && !!t[fs];
}
function Ld(t) {
  var r;
  return !!t && (function(a) {
    if (!a || typeof a != "object") return !1;
    var u = Object.getPrototypeOf(a);
    if (u === null) return !0;
    var h = Object.hasOwnProperty.call(u, "constructor") && u.constructor;
    return h === Object || typeof h == "function" && Function.toString.call(h) === eSe;
  }(t) || Array.isArray(t) || !!t[pB] || !!(!((r = t.constructor) === null || r === void 0) && r[pB]) || n_(t) || r_(t));
}
function lh(t, r, a) {
  a === void 0 && (a = !1), Wm(t) === 0 ? (a ? Object.keys : dg)(t).forEach(function(u) {
    a && typeof u == "symbol" || r(u, t[u], t);
  }) : t.forEach(function(u, h) {
    return r(h, u, t);
  });
}
function Wm(t) {
  var r = t[fs];
  return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(t) ? 1 : n_(t) ? 2 : r_(t) ? 3 : 0;
}
function ug(t, r) {
  return Wm(t) === 2 ? t.has(r) : Object.prototype.hasOwnProperty.call(t, r);
}
function YCe(t, r) {
  return Wm(t) === 2 ? t.get(r) : t[r];
}
function kY(t, r, a) {
  var u = Wm(t);
  u === 2 ? t.set(r, a) : u === 3 ? t.add(a) : t[r] = a;
}
function jY(t, r) {
  return t === r ? t !== 0 || 1 / t == 1 / r : t != t && r != r;
}
function n_(t) {
  return ZCe && t instanceof Map;
}
function r_(t) {
  return QCe && t instanceof Set;
}
function Rl(t) {
  return t.o || t.t;
}
function i_(t) {
  if (Array.isArray(t)) return Array.prototype.slice.call(t);
  var r = HY(t);
  delete r[fs];
  for (var a = dg(r), u = 0; u < a.length; u++) {
    var h = a[u], b = r[h];
    b.writable === !1 && (b.writable = !0, b.configurable = !0), (b.get || b.set) && (r[h] = { configurable: !0, writable: !0, enumerable: b.enumerable, value: t[h] });
  }
  return Object.create(Object.getPrototypeOf(t), r);
}
function s_(t, r) {
  return r === void 0 && (r = !1), a_(t) || Fl(t) || !Ld(t) || (Wm(t) > 1 && (t.set = t.add = t.clear = t.delete = XCe), Object.freeze(t), r && lh(t, function(a, u) {
    return s_(u, !0);
  }, !0)), t;
}
function XCe() {
  oa(2);
}
function a_(t) {
  return t == null || typeof t != "object" || Object.isFrozen(t);
}
function Fu(t) {
  var r = HN[t];
  return r || oa(18, t), r;
}
function WCe(t, r) {
  HN[t] || (HN[t] = r);
}
function kN() {
  return process.env.NODE_ENV === "production" || xm || oa(0), xm;
}
function r2(t, r) {
  r && (Fu("Patches"), t.u = [], t.s = [], t.v = r);
}
function Mb(t) {
  jN(t), t.p.forEach(qCe), t.p = null;
}
function jN(t) {
  t === xm && (xm = t.l);
}
function cB(t) {
  return xm = { p: [], l: xm, h: t, m: !0, _: 0 };
}
function qCe(t) {
  var r = t[fs];
  r.i === 0 || r.i === 1 ? r.j() : r.g = !0;
}
function i2(t, r) {
  r._ = r.p.length;
  var a = r.p[0], u = t !== void 0 && t !== a;
  return r.h.O || Fu("ES5").S(r, t, u), u ? (a[fs].P && (Mb(r), oa(4)), Ld(t) && (t = Lb(r, t), r.l || kb(r, t)), r.u && Fu("Patches").M(a[fs].t, t, r.u, r.s)) : t = Lb(r, a, []), Mb(r), r.u && r.v(r.u, r.s), t !== UY ? t : void 0;
}
function Lb(t, r, a) {
  if (a_(r)) return r;
  var u = r[fs];
  if (!u) return lh(r, function(v, s) {
    return uB(t, u, r, v, s, a);
  }, !0), r;
  if (u.A !== t) return r;
  if (!u.P) return kb(t, u.t, !0), u.t;
  if (!u.I) {
    u.I = !0, u.A._--;
    var h = u.i === 4 || u.i === 5 ? u.o = i_(u.k) : u.o, b = h, l = !1;
    u.i === 3 && (b = new Set(h), h.clear(), l = !0), lh(b, function(v, s) {
      return uB(t, u, h, v, s, a, l);
    }), kb(t, h, !1), a && t.u && Fu("Patches").N(u, a, t.u, t.s);
  }
  return u.o;
}
function uB(t, r, a, u, h, b, l) {
  if (process.env.NODE_ENV !== "production" && h === a && oa(5), Fl(h)) {
    var v = Lb(t, h, b && r && r.i !== 3 && !ug(r.R, u) ? b.concat(u) : void 0);
    if (kY(a, u, v), !Fl(v)) return;
    t.m = !1;
  } else l && a.add(h);
  if (Ld(h) && !a_(h)) {
    if (!t.h.D && t._ < 1) return;
    Lb(t, h), r && r.A.l || kb(t, h);
  }
}
function kb(t, r, a) {
  a === void 0 && (a = !1), !t.l && t.h.D && t.m && s_(r, a);
}
function s2(t, r) {
  var a = t[fs];
  return (a ? Rl(a) : t)[r];
}
function dB(t, r) {
  if (r in t) for (var a = Object.getPrototypeOf(t); a; ) {
    var u = Object.getOwnPropertyDescriptor(a, r);
    if (u) return u;
    a = Object.getPrototypeOf(a);
  }
}
function Nl(t) {
  t.P || (t.P = !0, t.l && Nl(t.l));
}
function a2(t) {
  t.o || (t.o = i_(t.t));
}
function UN(t, r, a) {
  var u = n_(r) ? Fu("MapSet").F(r, a) : r_(r) ? Fu("MapSet").T(r, a) : t.O ? function(h, b) {
    var l = Array.isArray(h), v = { i: l ? 1 : 0, A: b ? b.A : kN(), P: !1, I: !1, R: {}, l: b, t: h, k: null, o: null, j: null, C: !1 }, s = v, c = uv;
    l && (s = [v], c = Ly);
    var d = Proxy.revocable(s, c), p = d.revoke, m = d.proxy;
    return v.k = m, v.j = p, m;
  }(r, a) : Fu("ES5").J(r, a);
  return (a ? a.A : kN()).p.push(u), u;
}
function KCe(t) {
  return Fl(t) || oa(22, t), function r(a) {
    if (!Ld(a)) return a;
    var u, h = a[fs], b = Wm(a);
    if (h) {
      if (!h.P && (h.i < 4 || !Fu("ES5").K(h))) return h.t;
      h.I = !0, u = lB(a, b), h.I = !1;
    } else u = lB(a, b);
    return lh(u, function(l, v) {
      h && YCe(h.t, l) === v || kY(u, l, r(v));
    }), b === 3 ? new Set(u) : u;
  }(t);
}
function lB(t, r) {
  switch (r) {
    case 2:
      return new Map(t);
    case 3:
      return Array.from(t);
  }
  return i_(t);
}
function JCe() {
  function t(l, v) {
    var s = b[l];
    return s ? s.enumerable = v : b[l] = s = { configurable: !0, enumerable: v, get: function() {
      var c = this[fs];
      return process.env.NODE_ENV !== "production" && h(c), uv.get(c, l);
    }, set: function(c) {
      var d = this[fs];
      process.env.NODE_ENV !== "production" && h(d), uv.set(d, l, c);
    } }, s;
  }
  function r(l) {
    for (var v = l.length - 1; v >= 0; v--) {
      var s = l[v][fs];
      if (!s.P) switch (s.i) {
        case 5:
          u(s) && Nl(s);
          break;
        case 4:
          a(s) && Nl(s);
      }
    }
  }
  function a(l) {
    for (var v = l.t, s = l.k, c = dg(s), d = c.length - 1; d >= 0; d--) {
      var p = c[d];
      if (p !== fs) {
        var m = v[p];
        if (m === void 0 && !ug(v, p)) return !0;
        var E = s[p], y = E && E[fs];
        if (y ? y.t !== m : !jY(E, m)) return !0;
      }
    }
    var g = !!v[fs];
    return c.length !== dg(v).length + (g ? 0 : 1);
  }
  function u(l) {
    var v = l.k;
    if (v.length !== l.t.length) return !0;
    var s = Object.getOwnPropertyDescriptor(v, v.length - 1);
    if (s && !s.get) return !0;
    for (var c = 0; c < v.length; c++) if (!v.hasOwnProperty(c)) return !0;
    return !1;
  }
  function h(l) {
    l.g && oa(3, JSON.stringify(Rl(l)));
  }
  var b = {};
  WCe("ES5", { J: function(l, v) {
    var s = Array.isArray(l), c = function(p, m) {
      if (p) {
        for (var E = Array(m.length), y = 0; y < m.length; y++) Object.defineProperty(E, "" + y, t(y, !0));
        return E;
      }
      var g = HY(m);
      delete g[fs];
      for (var C = dg(g), O = 0; O < C.length; O++) {
        var N = C[O];
        g[N] = t(N, p || !!g[N].enumerable);
      }
      return Object.create(Object.getPrototypeOf(m), g);
    }(s, l), d = { i: s ? 5 : 4, A: v ? v.A : kN(), P: !1, I: !1, R: {}, l: v, t: l, k: c, o: null, g: !1, C: !1 };
    return Object.defineProperty(c, fs, { value: d, writable: !0 }), c;
  }, S: function(l, v, s) {
    s ? Fl(v) && v[fs].A === l && r(l.p) : (l.u && function c(d) {
      if (d && typeof d == "object") {
        var p = d[fs];
        if (p) {
          var m = p.t, E = p.k, y = p.R, g = p.i;
          if (g === 4) lh(E, function(_) {
            _ !== fs && (m[_] !== void 0 || ug(m, _) ? y[_] || c(E[_]) : (y[_] = !0, Nl(p)));
          }), lh(m, function(_) {
            E[_] !== void 0 || ug(E, _) || (y[_] = !1, Nl(p));
          });
          else if (g === 5) {
            if (u(p) && (Nl(p), y.length = !0), E.length < m.length) for (var C = E.length; C < m.length; C++) y[C] = !1;
            else for (var O = m.length; O < E.length; O++) y[O] = !0;
            for (var N = Math.min(E.length, m.length), w = 0; w < N; w++) E.hasOwnProperty(w) || (y[w] = !0), y[w] === void 0 && c(E[w]);
          }
        }
      }
    }(l.p[0]), r(l.p));
  }, K: function(l) {
    return l.i === 4 ? a(l) : u(l);
  } });
}
var fB, xm, o_ = typeof Symbol < "u" && typeof Symbol("x") == "symbol", ZCe = typeof Map < "u", QCe = typeof Set < "u", hB = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", UY = o_ ? Symbol.for("immer-nothing") : ((fB = {})["immer-nothing"] = !0, fB), pB = o_ ? Symbol.for("immer-draftable") : "__$immer_draftable", fs = o_ ? Symbol.for("immer-state") : "__$immer_state", $Ce = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(t) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(t) {
  return "Cannot apply patch, path doesn't resolve: " + t;
}, 16: 'Sets cannot have "replace" patches.', 17: function(t) {
  return "Unsupported patch operation: " + t;
}, 18: function(t) {
  return "The plugin for '" + t + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + t + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(t) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + t + "'";
}, 22: function(t) {
  return "'current' expects a draft, got: " + t;
}, 23: function(t) {
  return "'original' expects a draft, got: " + t;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, eSe = "" + Object.prototype.constructor, dg = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Object.getOwnPropertyNames, HY = Object.getOwnPropertyDescriptors || function(t) {
  var r = {};
  return dg(t).forEach(function(a) {
    r[a] = Object.getOwnPropertyDescriptor(t, a);
  }), r;
}, HN = {}, uv = { get: function(t, r) {
  if (r === fs) return t;
  var a = Rl(t);
  if (!ug(a, r)) return function(h, b, l) {
    var v, s = dB(b, l);
    return s ? "value" in s ? s.value : (v = s.get) === null || v === void 0 ? void 0 : v.call(h.k) : void 0;
  }(t, a, r);
  var u = a[r];
  return t.I || !Ld(u) ? u : u === s2(t.t, r) ? (a2(t), t.o[r] = UN(t.A.h, u, t)) : u;
}, has: function(t, r) {
  return r in Rl(t);
}, ownKeys: function(t) {
  return Reflect.ownKeys(Rl(t));
}, set: function(t, r, a) {
  var u = dB(Rl(t), r);
  if (u != null && u.set) return u.set.call(t.k, a), !0;
  if (!t.P) {
    var h = s2(Rl(t), r), b = h == null ? void 0 : h[fs];
    if (b && b.t === a) return t.o[r] = a, t.R[r] = !1, !0;
    if (jY(a, h) && (a !== void 0 || ug(t.t, r))) return !0;
    a2(t), Nl(t);
  }
  return t.o[r] === a && (a !== void 0 || r in t.o) || Number.isNaN(a) && Number.isNaN(t.o[r]) || (t.o[r] = a, t.R[r] = !0), !0;
}, deleteProperty: function(t, r) {
  return s2(t.t, r) !== void 0 || r in t.t ? (t.R[r] = !1, a2(t), Nl(t)) : delete t.R[r], t.o && delete t.o[r], !0;
}, getOwnPropertyDescriptor: function(t, r) {
  var a = Rl(t), u = Reflect.getOwnPropertyDescriptor(a, r);
  return u && { writable: !0, configurable: t.i !== 1 || r !== "length", enumerable: u.enumerable, value: a[r] };
}, defineProperty: function() {
  oa(11);
}, getPrototypeOf: function(t) {
  return Object.getPrototypeOf(t.t);
}, setPrototypeOf: function() {
  oa(12);
} }, Ly = {};
lh(uv, function(t, r) {
  Ly[t] = function() {
    return arguments[0] = arguments[0][0], r.apply(this, arguments);
  };
}), Ly.deleteProperty = function(t, r) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(r)) && oa(13), Ly.set.call(this, t, r, void 0);
}, Ly.set = function(t, r, a) {
  return process.env.NODE_ENV !== "production" && r !== "length" && isNaN(parseInt(r)) && oa(14), uv.set.call(this, t[0], r, a, t[0]);
};
var tSe = function() {
  function t(a) {
    var u = this;
    this.O = hB, this.D = !0, this.produce = function(h, b, l) {
      if (typeof h == "function" && typeof b != "function") {
        var v = b;
        b = h;
        var s = u;
        return function(g) {
          var C = this;
          g === void 0 && (g = v);
          for (var O = arguments.length, N = Array(O > 1 ? O - 1 : 0), w = 1; w < O; w++) N[w - 1] = arguments[w];
          return s.produce(g, function(_) {
            var I;
            return (I = b).call.apply(I, [C, _].concat(N));
          });
        };
      }
      var c;
      if (typeof b != "function" && oa(6), l !== void 0 && typeof l != "function" && oa(7), Ld(h)) {
        var d = cB(u), p = UN(u, h, void 0), m = !0;
        try {
          c = b(p), m = !1;
        } finally {
          m ? Mb(d) : jN(d);
        }
        return typeof Promise < "u" && c instanceof Promise ? c.then(function(g) {
          return r2(d, l), i2(g, d);
        }, function(g) {
          throw Mb(d), g;
        }) : (r2(d, l), i2(c, d));
      }
      if (!h || typeof h != "object") {
        if ((c = b(h)) === void 0 && (c = h), c === UY && (c = void 0), u.D && s_(c, !0), l) {
          var E = [], y = [];
          Fu("Patches").M(h, c, E, y), l(E, y);
        }
        return c;
      }
      oa(21, h);
    }, this.produceWithPatches = function(h, b) {
      if (typeof h == "function") return function(c) {
        for (var d = arguments.length, p = Array(d > 1 ? d - 1 : 0), m = 1; m < d; m++) p[m - 1] = arguments[m];
        return u.produceWithPatches(c, function(E) {
          return h.apply(void 0, [E].concat(p));
        });
      };
      var l, v, s = u.produce(h, b, function(c, d) {
        l = c, v = d;
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then(function(c) {
        return [c, l, v];
      }) : [s, l, v];
    }, typeof (a == null ? void 0 : a.useProxies) == "boolean" && this.setUseProxies(a.useProxies), typeof (a == null ? void 0 : a.autoFreeze) == "boolean" && this.setAutoFreeze(a.autoFreeze);
  }
  var r = t.prototype;
  return r.createDraft = function(a) {
    Ld(a) || oa(8), Fl(a) && (a = KCe(a));
    var u = cB(this), h = UN(this, a, void 0);
    return h[fs].C = !0, jN(u), h;
  }, r.finishDraft = function(a, u) {
    var h = a && a[fs];
    process.env.NODE_ENV !== "production" && (h && h.C || oa(9), h.I && oa(10));
    var b = h.A;
    return r2(b, u), i2(void 0, b);
  }, r.setAutoFreeze = function(a) {
    this.D = a;
  }, r.setUseProxies = function(a) {
    a && !hB && oa(20), this.O = a;
  }, r.applyPatches = function(a, u) {
    var h;
    for (h = u.length - 1; h >= 0; h--) {
      var b = u[h];
      if (b.path.length === 0 && b.op === "replace") {
        a = b.value;
        break;
      }
    }
    h > -1 && (u = u.slice(h + 1));
    var l = Fu("Patches").$;
    return Fl(a) ? l(a, u) : this.produce(a, function(v) {
      return l(v, u);
    });
  }, t;
}(), Vo = new tSe(), BY = Vo.produce;
Vo.produceWithPatches.bind(Vo);
Vo.setAutoFreeze.bind(Vo);
Vo.setUseProxies.bind(Vo);
Vo.applyPatches.bind(Vo);
Vo.createDraft.bind(Vo);
Vo.finishDraft.bind(Vo);
function Da(t) {
  return "Minified Redux error #" + t + "; visit https://redux.js.org/Errors?code=" + t + " for the full message or use the non-minified dev environment for full errors. ";
}
var gB = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), o2 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, nh = {
  INIT: "@@redux/INIT" + o2(),
  REPLACE: "@@redux/REPLACE" + o2(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + o2();
  }
};
function zY(t) {
  if (typeof t != "object" || t === null) return !1;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return Object.getPrototypeOf(t) === r;
}
function nSe(t) {
  if (t === void 0) return "undefined";
  if (t === null) return "null";
  var r = typeof t;
  switch (r) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return r;
  }
  if (Array.isArray(t)) return "array";
  if (sSe(t)) return "date";
  if (iSe(t)) return "error";
  var a = rSe(t);
  switch (a) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return a;
  }
  return r.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function rSe(t) {
  return typeof t.constructor == "function" ? t.constructor.name : null;
}
function iSe(t) {
  return t instanceof Error || typeof t.message == "string" && t.constructor && typeof t.constructor.stackTraceLimit == "number";
}
function sSe(t) {
  return t instanceof Date ? !0 : typeof t.toDateString == "function" && typeof t.getDate == "function" && typeof t.setDate == "function";
}
function Zf(t) {
  var r = typeof t;
  return process.env.NODE_ENV !== "production" && (r = nSe(t)), r;
}
function FY(t, r, a) {
  var u;
  if (typeof r == "function" && typeof a == "function" || typeof a == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Da(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof r == "function" && typeof a > "u" && (a = r, r = void 0), typeof a < "u") {
    if (typeof a != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Da(1) : "Expected the enhancer to be a function. Instead, received: '" + Zf(a) + "'");
    return a(FY)(t, r);
  }
  if (typeof t != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Da(2) : "Expected the root reducer to be a function. Instead, received: '" + Zf(t) + "'");
  var h = t, b = r, l = [], v = l, s = !1;
  function c() {
    v === l && (v = l.slice());
  }
  function d() {
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? Da(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return b;
  }
  function p(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Da(4) : "Expected the listener to be a function. Instead, received: '" + Zf(g) + "'");
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? Da(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var C = !0;
    return c(), v.push(g), function() {
      if (C) {
        if (s)
          throw new Error(process.env.NODE_ENV === "production" ? Da(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        C = !1, c();
        var N = v.indexOf(g);
        v.splice(N, 1), l = null;
      }
    };
  }
  function m(g) {
    if (!zY(g))
      throw new Error(process.env.NODE_ENV === "production" ? Da(7) : "Actions must be plain objects. Instead, the actual type was: '" + Zf(g) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof g.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Da(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (s)
      throw new Error(process.env.NODE_ENV === "production" ? Da(9) : "Reducers may not dispatch actions.");
    try {
      s = !0, b = h(b, g);
    } finally {
      s = !1;
    }
    for (var C = l = v, O = 0; O < C.length; O++) {
      var N = C[O];
      N();
    }
    return g;
  }
  function E(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Da(10) : "Expected the nextReducer to be a function. Instead, received: '" + Zf(g));
    h = g, m({
      type: nh.REPLACE
    });
  }
  function y() {
    var g, C = p;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(N) {
        if (typeof N != "object" || N === null)
          throw new Error(process.env.NODE_ENV === "production" ? Da(11) : "Expected the observer to be an object. Instead, received: '" + Zf(N) + "'");
        function w() {
          N.next && N.next(d());
        }
        w();
        var _ = C(w);
        return {
          unsubscribe: _
        };
      }
    }, g[gB] = function() {
      return this;
    }, g;
  }
  return m({
    type: nh.INIT
  }), u = {
    dispatch: m,
    subscribe: p,
    getState: d,
    replaceReducer: E
  }, u[gB] = y, u;
}
function mB(t) {
  typeof console < "u" && typeof console.error == "function" && console.error(t);
  try {
    throw new Error(t);
  } catch {
  }
}
function aSe(t, r, a, u) {
  var h = Object.keys(r), b = a && a.type === nh.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (h.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!zY(t))
    return "The " + b + ' has unexpected type of "' + Zf(t) + '". Expected argument to be an object with the following ' + ('keys: "' + h.join('", "') + '"');
  var l = Object.keys(t).filter(function(v) {
    return !r.hasOwnProperty(v) && !u[v];
  });
  if (l.forEach(function(v) {
    u[v] = !0;
  }), !(a && a.type === nh.REPLACE) && l.length > 0)
    return "Unexpected " + (l.length > 1 ? "keys" : "key") + " " + ('"' + l.join('", "') + '" found in ' + b + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + h.join('", "') + '". Unexpected keys will be ignored.');
}
function oSe(t) {
  Object.keys(t).forEach(function(r) {
    var a = t[r], u = a(void 0, {
      type: nh.INIT
    });
    if (typeof u > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Da(12) : 'The slice reducer for key "' + r + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof a(void 0, {
      type: nh.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Da(13) : 'The slice reducer for key "' + r + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + nh.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function cSe(t) {
  for (var r = Object.keys(t), a = {}, u = 0; u < r.length; u++) {
    var h = r[u];
    process.env.NODE_ENV !== "production" && typeof t[h] > "u" && mB('No reducer provided for key "' + h + '"'), typeof t[h] == "function" && (a[h] = t[h]);
  }
  var b = Object.keys(a), l;
  process.env.NODE_ENV !== "production" && (l = {});
  var v;
  try {
    oSe(a);
  } catch (s) {
    v = s;
  }
  return function(c, d) {
    if (c === void 0 && (c = {}), v)
      throw v;
    if (process.env.NODE_ENV !== "production") {
      var p = aSe(c, a, d, l);
      p && mB(p);
    }
    for (var m = !1, E = {}, y = 0; y < b.length; y++) {
      var g = b[y], C = a[g], O = c[g], N = C(O, d);
      if (typeof N > "u") {
        var w = d && d.type;
        throw new Error(process.env.NODE_ENV === "production" ? Da(14) : "When called with an action of type " + (w ? '"' + String(w) + '"' : "(unknown type)") + ', the slice reducer for key "' + g + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      E[g] = N, m = m || N !== O;
    }
    return m = m || b.length !== Object.keys(c).length, m ? E : c;
  };
}
function jb() {
  for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  return r.length === 0 ? function(u) {
    return u;
  } : r.length === 1 ? r[0] : r.reduce(function(u, h) {
    return function() {
      return u(h.apply(void 0, arguments));
    };
  });
}
function uSe() {
  for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  return function(u) {
    return function() {
      var h = u.apply(void 0, arguments), b = function() {
        throw new Error(process.env.NODE_ENV === "production" ? Da(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, l = {
        getState: h.getState,
        dispatch: function() {
          return b.apply(void 0, arguments);
        }
      }, v = r.map(function(s) {
        return s(l);
      });
      return b = jb.apply(void 0, v)(h.dispatch), jr(jr({}, h), {}, {
        dispatch: b
      });
    };
  };
}
function GY(t) {
  var r = function(u) {
    var h = u.dispatch, b = u.getState;
    return function(l) {
      return function(v) {
        return typeof v == "function" ? v(h, b, t) : l(v);
      };
    };
  };
  return r;
}
var BN = GY();
BN.withExtraArgument = GY;
var VY = /* @__PURE__ */ function() {
  var t = function(r, a) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, h) {
      u.__proto__ = h;
    } || function(u, h) {
      for (var b in h) Object.prototype.hasOwnProperty.call(h, b) && (u[b] = h[b]);
    }, t(r, a);
  };
  return function(r, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
    t(r, a);
    function u() {
      this.constructor = r;
    }
    r.prototype = a === null ? Object.create(a) : (u.prototype = a.prototype, new u());
  };
}(), dSe = function(t, r) {
  var a = { label: 0, sent: function() {
    if (b[0] & 1) throw b[1];
    return b[1];
  }, trys: [], ops: [] }, u, h, b, l;
  return l = { next: v(0), throw: v(1), return: v(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function v(c) {
    return function(d) {
      return s([c, d]);
    };
  }
  function s(c) {
    if (u) throw new TypeError("Generator is already executing.");
    for (; a; ) try {
      if (u = 1, h && (b = c[0] & 2 ? h.return : c[0] ? h.throw || ((b = h.return) && b.call(h), 0) : h.next) && !(b = b.call(h, c[1])).done) return b;
      switch (h = 0, b && (c = [c[0] & 2, b.value]), c[0]) {
        case 0:
        case 1:
          b = c;
          break;
        case 4:
          return a.label++, { value: c[1], done: !1 };
        case 5:
          a.label++, h = c[1], c = [0];
          continue;
        case 7:
          c = a.ops.pop(), a.trys.pop();
          continue;
        default:
          if (b = a.trys, !(b = b.length > 0 && b[b.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            a = 0;
            continue;
          }
          if (c[0] === 3 && (!b || c[1] > b[0] && c[1] < b[3])) {
            a.label = c[1];
            break;
          }
          if (c[0] === 6 && a.label < b[1]) {
            a.label = b[1], b = c;
            break;
          }
          if (b && a.label < b[2]) {
            a.label = b[2], a.ops.push(c);
            break;
          }
          b[2] && a.ops.pop(), a.trys.pop();
          continue;
      }
      c = r.call(t, a);
    } catch (d) {
      c = [6, d], h = 0;
    } finally {
      u = b = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}, Dm = function(t, r) {
  for (var a = 0, u = r.length, h = t.length; a < u; a++, h++)
    t[h] = r[a];
  return t;
}, lSe = Object.defineProperty, fSe = Object.defineProperties, hSe = Object.getOwnPropertyDescriptors, EB = Object.getOwnPropertySymbols, pSe = Object.prototype.hasOwnProperty, gSe = Object.prototype.propertyIsEnumerable, yB = function(t, r, a) {
  return r in t ? lSe(t, r, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[r] = a;
}, Ll = function(t, r) {
  for (var a in r || (r = {}))
    pSe.call(r, a) && yB(t, a, r[a]);
  if (EB)
    for (var u = 0, h = EB(r); u < h.length; u++) {
      var a = h[u];
      gSe.call(r, a) && yB(t, a, r[a]);
    }
  return t;
}, c2 = function(t, r) {
  return fSe(t, hSe(r));
}, mSe = function(t, r, a) {
  return new Promise(function(u, h) {
    var b = function(s) {
      try {
        v(a.next(s));
      } catch (c) {
        h(c);
      }
    }, l = function(s) {
      try {
        v(a.throw(s));
      } catch (c) {
        h(c);
      }
    }, v = function(s) {
      return s.done ? u(s.value) : Promise.resolve(s.value).then(b, l);
    };
    v((a = a.apply(t, r)).next());
  });
}, ESe = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? jb : jb.apply(null, arguments);
};
function YY(t) {
  if (typeof t != "object" || t === null)
    return !1;
  var r = Object.getPrototypeOf(t);
  if (r === null)
    return !0;
  for (var a = r; Object.getPrototypeOf(a) !== null; )
    a = Object.getPrototypeOf(a);
  return r === a;
}
var ySe = function(t) {
  return t && typeof t.match == "function";
};
function kl(t, r) {
  function a() {
    for (var u = [], h = 0; h < arguments.length; h++)
      u[h] = arguments[h];
    if (r) {
      var b = r.apply(void 0, u);
      if (!b)
        throw new Error("prepareAction did not return an object");
      return Ll(Ll({
        type: t,
        payload: b.payload
      }, "meta" in b && { meta: b.meta }), "error" in b && { error: b.error });
    }
    return { type: t, payload: u[0] };
  }
  return a.toString = function() {
    return "" + t;
  }, a.type = t, a.match = function(u) {
    return u.type === t;
  }, a;
}
function vSe(t) {
  return typeof t == "function" && "type" in t && ySe(t);
}
function TSe(t) {
  var r = t ? ("" + t).split("/") : [], a = r[r.length - 1] || "actionCreator";
  return 'Detected an action creator with type "' + (t || "unknown") + `" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(` + a + "())` instead of `dispatch(" + a + ")`. This is necessary even if the action has no payload.";
}
function bSe(t) {
  if (t === void 0 && (t = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(u) {
        return function(h) {
          return u(h);
        };
      };
    };
  var r = t.isActionCreator, a = r === void 0 ? vSe : r;
  return function() {
    return function(u) {
      return function(h) {
        return a(h) && console.warn(TSe(h.type)), u(h);
      };
    };
  };
}
function XY(t, r) {
  var a = 0;
  return {
    measureTime: function(u) {
      var h = Date.now();
      try {
        return u();
      } finally {
        var b = Date.now();
        a += b - h;
      }
    },
    warnIfExceeded: function() {
      a > t && console.warn(r + " took " + a + "ms, which is more than the warning threshold of " + t + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var ASe = (
  /** @class */
  function(t) {
    VY(r, t);
    function r() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      var h = t.apply(this, a) || this;
      return Object.setPrototypeOf(h, r.prototype), h;
    }
    return Object.defineProperty(r, Symbol.species, {
      get: function() {
        return r;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.concat = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      return t.prototype.concat.apply(this, a);
    }, r.prototype.prepend = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      return a.length === 1 && Array.isArray(a[0]) ? new (r.bind.apply(r, Dm([void 0], a[0].concat(this))))() : new (r.bind.apply(r, Dm([void 0], a.concat(this))))();
    }, r;
  }(Array)
), OSe = (
  /** @class */
  function(t) {
    VY(r, t);
    function r() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      var h = t.apply(this, a) || this;
      return Object.setPrototypeOf(h, r.prototype), h;
    }
    return Object.defineProperty(r, Symbol.species, {
      get: function() {
        return r;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.concat = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      return t.prototype.concat.apply(this, a);
    }, r.prototype.prepend = function() {
      for (var a = [], u = 0; u < arguments.length; u++)
        a[u] = arguments[u];
      return a.length === 1 && Array.isArray(a[0]) ? new (r.bind.apply(r, Dm([void 0], a[0].concat(this))))() : new (r.bind.apply(r, Dm([void 0], a.concat(this))))();
    }, r;
  }(Array)
);
function zN(t) {
  return Ld(t) ? BY(t, function() {
  }) : t;
}
var CSe = process.env.NODE_ENV === "production", vB = "Invariant failed";
function TB(t, r) {
  if (!t)
    throw CSe ? new Error(vB) : new Error(vB + ": " + (r || ""));
}
function SSe(t, r, a, u) {
  return JSON.stringify(t, ISe(r, u), a);
}
function ISe(t, r) {
  var a = [], u = [];
  return r || (r = function(h, b) {
    return a[0] === b ? "[Circular ~]" : "[Circular ~." + u.slice(0, a.indexOf(b)).join(".") + "]";
  }), function(h, b) {
    if (a.length > 0) {
      var l = a.indexOf(this);
      ~l ? a.splice(l + 1) : a.push(this), ~l ? u.splice(l, 1 / 0, h) : u.push(h), ~a.indexOf(b) && (b = r.call(this, h, b));
    } else
      a.push(b);
    return t == null ? b : t.call(this, h, b);
  };
}
function RSe(t) {
  return typeof t != "object" || t == null || Object.isFrozen(t);
}
function NSe(t, r, a) {
  var u = WY(t, r, a);
  return {
    detectMutations: function() {
      return qY(t, r, u, a);
    }
  };
}
function WY(t, r, a, u, h) {
  r === void 0 && (r = []), u === void 0 && (u = ""), h === void 0 && (h = /* @__PURE__ */ new Set());
  var b = { value: a };
  if (!t(a) && !h.has(a)) {
    h.add(a), b.children = {};
    for (var l in a) {
      var v = u ? u + "." + l : l;
      r.length && r.indexOf(v) !== -1 || (b.children[l] = WY(t, r, a[l], v));
    }
  }
  return b;
}
function qY(t, r, a, u, h, b) {
  r === void 0 && (r = []), h === void 0 && (h = !1), b === void 0 && (b = "");
  var l = a ? a.value : void 0, v = l === u;
  if (h && !v && !Number.isNaN(u))
    return { wasMutated: !0, path: b };
  if (t(l) || t(u))
    return { wasMutated: !1 };
  var s = {};
  for (var c in a.children)
    s[c] = !0;
  for (var c in u)
    s[c] = !0;
  var d = r.length > 0, p = function(E) {
    var y = b ? b + "." + E : E;
    if (d) {
      var g = r.some(function(O) {
        return O instanceof RegExp ? O.test(y) : y === O;
      });
      if (g)
        return "continue";
    }
    var C = qY(t, r, a.children[E], u[E], v, y);
    if (C.wasMutated)
      return { value: C };
  };
  for (var c in s) {
    var m = p(c);
    if (typeof m == "object")
      return m.value;
  }
  return { wasMutated: !1 };
}
function wSe(t) {
  if (t === void 0 && (t = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(s) {
        return function(c) {
          return s(c);
        };
      };
    };
  var r = t.isImmutable, a = r === void 0 ? RSe : r, u = t.ignoredPaths, h = t.warnAfter, b = h === void 0 ? 32 : h, l = t.ignore;
  u = u || l;
  var v = NSe.bind(null, a, u);
  return function(s) {
    var c = s.getState, d = c(), p = v(d), m;
    return function(E) {
      return function(y) {
        var g = XY(b, "ImmutableStateInvariantMiddleware");
        g.measureTime(function() {
          d = c(), m = p.detectMutations(), p = v(d), TB(!m.wasMutated, "A state mutation was detected between dispatches, in the path '" + (m.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var C = E(y);
        return g.measureTime(function() {
          d = c(), m = p.detectMutations(), p = v(d), m.wasMutated && TB(!m.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (m.path || "") + ". Take a look at the reducer(s) handling the action " + SSe(y) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), g.warnIfExceeded(), C;
      };
    };
  };
}
function KY(t) {
  var r = typeof t;
  return t == null || r === "string" || r === "boolean" || r === "number" || Array.isArray(t) || YY(t);
}
function FN(t, r, a, u, h, b) {
  r === void 0 && (r = ""), a === void 0 && (a = KY), h === void 0 && (h = []);
  var l;
  if (!a(t))
    return {
      keyPath: r || "<root>",
      value: t
    };
  if (typeof t != "object" || t === null || b != null && b.has(t))
    return !1;
  for (var v = u != null ? u(t) : Object.entries(t), s = h.length > 0, c = function(C, O) {
    var N = r ? r + "." + C : C;
    if (s) {
      var w = h.some(function(_) {
        return _ instanceof RegExp ? _.test(N) : N === _;
      });
      if (w)
        return "continue";
    }
    if (!a(O))
      return { value: {
        keyPath: N,
        value: O
      } };
    if (typeof O == "object" && (l = FN(O, N, a, u, h, b), l))
      return { value: l };
  }, d = 0, p = v; d < p.length; d++) {
    var m = p[d], E = m[0], y = m[1], g = c(E, y);
    if (typeof g == "object")
      return g.value;
  }
  return b && JY(t) && b.add(t), !1;
}
function JY(t) {
  if (!Object.isFrozen(t))
    return !1;
  for (var r = 0, a = Object.values(t); r < a.length; r++) {
    var u = a[r];
    if (!(typeof u != "object" || u === null) && !JY(u))
      return !1;
  }
  return !0;
}
function _Se(t) {
  if (t === void 0 && (t = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(w) {
        return function(_) {
          return w(_);
        };
      };
    };
  var r = t.isSerializable, a = r === void 0 ? KY : r, u = t.getEntries, h = t.ignoredActions, b = h === void 0 ? [] : h, l = t.ignoredActionPaths, v = l === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : l, s = t.ignoredPaths, c = s === void 0 ? [] : s, d = t.warnAfter, p = d === void 0 ? 32 : d, m = t.ignoreState, E = m === void 0 ? !1 : m, y = t.ignoreActions, g = y === void 0 ? !1 : y, C = t.disableCache, O = C === void 0 ? !1 : C, N = !O && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(w) {
    return function(_) {
      return function(I) {
        var k = _(I), H = XY(p, "SerializableStateInvariantMiddleware");
        return !g && !(b.length && b.indexOf(I.type) !== -1) && H.measureTime(function() {
          var S = FN(I, "", a, u, v, N);
          if (S) {
            var B = S.keyPath, D = S.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + B + "`. Value:", D, `
Take a look at the logic that dispatched this action: `, I, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), E || (H.measureTime(function() {
          var S = w.getState(), B = FN(S, "", a, u, c, N);
          if (B) {
            var D = B.keyPath, F = B.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + D + "`. Value:", F, `
Take a look at the reducer(s) handling this action type: ` + I.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), H.warnIfExceeded()), k;
      };
    };
  };
}
function F0(t) {
  return typeof t == "boolean";
}
function PSe() {
  return function(r) {
    return xSe(r);
  };
}
function xSe(t) {
  t === void 0 && (t = {});
  var r = t.thunk, a = r === void 0 ? !0 : r, u = t.immutableCheck, h = u === void 0 ? !0 : u, b = t.serializableCheck, l = b === void 0 ? !0 : b, v = t.actionCreatorCheck, s = v === void 0 ? !0 : v, c = new ASe();
  if (a && (F0(a) ? c.push(BN) : c.push(BN.withExtraArgument(a.extraArgument))), process.env.NODE_ENV !== "production") {
    if (h) {
      var d = {};
      F0(h) || (d = h), c.unshift(wSe(d));
    }
    if (l) {
      var p = {};
      F0(l) || (p = l), c.push(_Se(p));
    }
    if (s) {
      var m = {};
      F0(s) || (m = s), c.unshift(bSe(m));
    }
  }
  return c;
}
var u2 = process.env.NODE_ENV === "production";
function DSe(t) {
  var r = PSe(), a = t, u = a.reducer, h = u === void 0 ? void 0 : u, b = a.middleware, l = b === void 0 ? r() : b, v = a.devTools, s = v === void 0 ? !0 : v, c = a.preloadedState, d = c === void 0 ? void 0 : c, p = a.enhancers, m = p === void 0 ? void 0 : p, E;
  if (typeof h == "function")
    E = h;
  else if (YY(h))
    E = cSe(h);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var y = l;
  if (typeof y == "function" && (y = y(r), !u2 && !Array.isArray(y)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!u2 && y.some(function(_) {
    return typeof _ != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var g = uSe.apply(void 0, y), C = jb;
  s && (C = ESe(Ll({
    trace: !u2
  }, typeof s == "object" && s)));
  var O = new OSe(g), N = O;
  Array.isArray(m) ? N = Dm([g], m) : typeof m == "function" && (N = m(O));
  var w = C.apply(void 0, N);
  return FY(E, d, w);
}
function ZY(t) {
  var r = {}, a = [], u, h = {
    addCase: function(b, l) {
      if (process.env.NODE_ENV !== "production") {
        if (a.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (u)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var v = typeof b == "string" ? b : b.type;
      if (!v)
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      if (v in r)
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      return r[v] = l, h;
    },
    addMatcher: function(b, l) {
      if (process.env.NODE_ENV !== "production" && u)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return a.push({ matcher: b, reducer: l }), h;
    },
    addDefaultCase: function(b) {
      if (process.env.NODE_ENV !== "production" && u)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return u = b, h;
    }
  };
  return t(h), [r, a, u];
}
function MSe(t) {
  return typeof t == "function";
}
var bB = !1;
function LSe(t, r, a, u) {
  a === void 0 && (a = []), process.env.NODE_ENV !== "production" && typeof r == "object" && (bB || (bB = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var h = typeof r == "function" ? ZY(r) : [r, a, u], b = h[0], l = h[1], v = h[2], s;
  if (MSe(t))
    s = function() {
      return zN(t());
    };
  else {
    var c = zN(t);
    s = function() {
      return c;
    };
  }
  function d(p, m) {
    p === void 0 && (p = s());
    var E = Dm([
      b[m.type]
    ], l.filter(function(y) {
      var g = y.matcher;
      return g(m);
    }).map(function(y) {
      var g = y.reducer;
      return g;
    }));
    return E.filter(function(y) {
      return !!y;
    }).length === 0 && (E = [v]), E.reduce(function(y, g) {
      if (g)
        if (Fl(y)) {
          var C = y, O = g(C, m);
          return O === void 0 ? y : O;
        } else {
          if (Ld(y))
            return BY(y, function(N) {
              return g(N, m);
            });
          var O = g(y, m);
          if (O === void 0) {
            if (y === null)
              return y;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return O;
        }
      return y;
    }, p);
  }
  return d.getInitialState = s, d;
}
var AB = !1;
function kSe(t, r) {
  return t + "/" + r;
}
function jSe(t) {
  var r = t.name;
  if (!r)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && t.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var a = typeof t.initialState == "function" ? t.initialState : zN(t.initialState), u = t.reducers || {}, h = Object.keys(u), b = {}, l = {}, v = {};
  h.forEach(function(d) {
    var p = u[d], m = kSe(r, d), E, y;
    "reducer" in p ? (E = p.reducer, y = p.prepare) : E = p, b[d] = E, l[m] = E, v[d] = y ? kl(m, y) : kl(m);
  });
  function s() {
    process.env.NODE_ENV !== "production" && typeof t.extraReducers == "object" && (AB || (AB = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var d = typeof t.extraReducers == "function" ? ZY(t.extraReducers) : [t.extraReducers], p = d[0], m = p === void 0 ? {} : p, E = d[1], y = E === void 0 ? [] : E, g = d[2], C = g === void 0 ? void 0 : g, O = Ll(Ll({}, m), l);
    return LSe(a, function(N) {
      for (var w in O)
        N.addCase(w, O[w]);
      for (var _ = 0, I = y; _ < I.length; _++) {
        var k = I[_];
        N.addMatcher(k.matcher, k.reducer);
      }
      C && N.addDefaultCase(C);
    });
  }
  var c;
  return {
    name: r,
    reducer: function(d, p) {
      return c || (c = s()), c(d, p);
    },
    actions: v,
    caseReducers: b,
    getInitialState: function() {
      return c || (c = s()), c.getInitialState();
    }
  };
}
var USe = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", HSe = function(t) {
  t === void 0 && (t = 21);
  for (var r = "", a = t; a--; )
    r += USe[Math.random() * 64 | 0];
  return r;
}, BSe = [
  "name",
  "message",
  "stack",
  "code"
], d2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r, a) {
      this.payload = r, this.meta = a;
    }
    return t;
  }()
), OB = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(r, a) {
      this.payload = r, this.meta = a;
    }
    return t;
  }()
), zSe = function(t) {
  if (typeof t == "object" && t !== null) {
    for (var r = {}, a = 0, u = BSe; a < u.length; a++) {
      var h = u[a];
      typeof t[h] == "string" && (r[h] = t[h]);
    }
    return r;
  }
  return { message: String(t) };
};
(function() {
  function t(r, a, u) {
    var h = kl(r + "/fulfilled", function(d, p, m, E) {
      return {
        payload: d,
        meta: c2(Ll({}, E || {}), {
          arg: m,
          requestId: p,
          requestStatus: "fulfilled"
        })
      };
    }), b = kl(r + "/pending", function(d, p, m) {
      return {
        payload: void 0,
        meta: c2(Ll({}, m || {}), {
          arg: p,
          requestId: d,
          requestStatus: "pending"
        })
      };
    }), l = kl(r + "/rejected", function(d, p, m, E, y) {
      return {
        payload: E,
        error: (u && u.serializeError || zSe)(d || "Rejected"),
        meta: c2(Ll({}, y || {}), {
          arg: m,
          requestId: p,
          rejectedWithValue: !!E,
          requestStatus: "rejected",
          aborted: (d == null ? void 0 : d.name) === "AbortError",
          condition: (d == null ? void 0 : d.name) === "ConditionError"
        })
      };
    }), v = !1, s = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function d() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return d.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (v || (v = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, d;
      }()
    );
    function c(d) {
      return function(p, m, E) {
        var y = u != null && u.idGenerator ? u.idGenerator(d) : HSe(), g = new s(), C;
        function O(w) {
          C = w, g.abort();
        }
        var N = function() {
          return mSe(this, null, function() {
            var w, _, I, k, H, S, B;
            return dSe(this, function(D) {
              switch (D.label) {
                case 0:
                  return D.trys.push([0, 4, , 5]), k = (w = u == null ? void 0 : u.condition) == null ? void 0 : w.call(u, d, { getState: m, extra: E }), GSe(k) ? [4, k] : [3, 2];
                case 1:
                  k = D.sent(), D.label = 2;
                case 2:
                  if (k === !1 || g.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return H = new Promise(function(F, j) {
                    return g.signal.addEventListener("abort", function() {
                      return j({
                        name: "AbortError",
                        message: C || "Aborted"
                      });
                    });
                  }), p(b(y, d, (_ = u == null ? void 0 : u.getPendingMeta) == null ? void 0 : _.call(u, { requestId: y, arg: d }, { getState: m, extra: E }))), [4, Promise.race([
                    H,
                    Promise.resolve(a(d, {
                      dispatch: p,
                      getState: m,
                      extra: E,
                      requestId: y,
                      signal: g.signal,
                      abort: O,
                      rejectWithValue: function(F, j) {
                        return new d2(F, j);
                      },
                      fulfillWithValue: function(F, j) {
                        return new OB(F, j);
                      }
                    })).then(function(F) {
                      if (F instanceof d2)
                        throw F;
                      return F instanceof OB ? h(F.payload, y, d, F.meta) : h(F, y, d);
                    })
                  ])];
                case 3:
                  return I = D.sent(), [3, 5];
                case 4:
                  return S = D.sent(), I = S instanceof d2 ? l(null, y, d, S.payload, S.meta) : l(S, y, d), [3, 5];
                case 5:
                  return B = u && !u.dispatchConditionRejection && l.match(I) && I.meta.condition, B || p(I), [2, I];
              }
            });
          });
        }();
        return Object.assign(N, {
          abort: O,
          requestId: y,
          arg: d,
          unwrap: function() {
            return N.then(FSe);
          }
        });
      };
    }
    return Object.assign(c, {
      pending: b,
      rejected: l,
      fulfilled: h,
      typePrefix: r
    });
  }
  return t.withTypes = function() {
    return t;
  }, t;
})();
function FSe(t) {
  if (t.meta && t.meta.rejectedWithValue)
    throw t.payload;
  if (t.error)
    throw t.error;
  return t.payload;
}
function GSe(t) {
  return t !== null && typeof t == "object" && typeof t.then == "function";
}
var c_ = "listenerMiddleware";
kl(c_ + "/add");
kl(c_ + "/removeAll");
kl(c_ + "/remove");
var CB;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
JCe();
var Qn = {
  idle: 0,
  inviting: 1,
  alerting: 2,
  confirmRing: 3,
  // caller
  receivedConfirmRing: 4,
  // callee
  answerCall: 5,
  receivedAnswerCall: 6,
  confirmCallee: 7
}, QY = jSe({
  name: "call",
  initialState: {
    callStatus: Qn.idle,
    windowSize: "normal",
    callDuration: "00:00",
    confr: {
      channel: "",
      token: "",
      type: null,
      callId: null,
      callerDevId: null,
      calleeDevId: null,
      confrName: "",
      callerIMName: "",
      calleeIMName: ""
    },
    groupId: "",
    groupName: "",
    uid2userId: {},
    joinedMembers: [],
    invitedMembers: [],
    userInfo: {}
  },
  reducers: {
    changeWinSize: function(r, a) {
      r.windowSize = a.payload;
    },
    setCallStatus: function(r, a) {
      r.callStatus = a.payload;
    },
    setCallDuration: function(r, a) {
      r.callDuration = a.payload;
    },
    updateConfr: function(r, a) {
      var u = a.payload, h = a.payload.ext || {}, b, l, v = {
        channel: h.channelName,
        token: h.token,
        type: h.type,
        callId: h.callId,
        callerDevId: h.callerDevId,
        calleeDevId: h.calleeDevId
      };
      h.type === 2 || h.type === 3 ? v.confrName = u.to : v.confrName = u.from, h.calleeIMName && (v.calleeIMName = h.calleeIMName), h.callerIMName && (v.callerIMName = h.callerIMName), h.ext && (b = h.ext.groupId, l = h.ext.groupName), r.groupName = l, r.groupId = b, r.confr = v;
    },
    setUidToUserId: function(r, a) {
      r.uid2userId = a.payload;
    },
    setUserInfos: function(r, a) {
      r.userInfo = a.payload;
    },
    updateJoinedMembers: function(r, a, u) {
      var h = a.payload.action;
      if (h === "add") {
        var b = !1, l = [].concat(r.joinedMembers);
        l.forEach(function(v, s) {
          (v.name === a.payload.name || v.value === a.payload.name) && (v.videoElm = a.payload.videoElm, v.mediaType = a.payload.mediaType, v.audio = a.payload.audio || !1, v.video = a.payload.video || !1, v.isSelf = a.payload.isSelf, r.joinedMembers = l, b = !0);
        }), b || (delete a.payload.action, l.push(a.payload), r.joinedMembers = l);
      } else
        r.joinedMembers = a.payload;
    },
    updateInvitedMembers: function(r, a) {
      r.invitedMembers = a.payload;
    }
  }
}), Zl = QY.actions, Ub = Zl.changeWinSize, Ki = Zl.setCallStatus, SB = Zl.setCallDuration, fh = Zl.updateConfr, VSe = Zl.setUidToUserId, IB = Zl.setUserInfos, Kc = Zl.updateJoinedMembers, RB = Zl.updateInvitedMembers;
const YSe = QY.reducer, hi = DSe({
  reducer: YSe
});
var MA = { exports: {} }, $Y = {}, GN = { exports: {} }, G0 = { exports: {} }, _i = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NB;
function XSe() {
  if (NB) return _i;
  NB = 1;
  var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, h = t ? Symbol.for("react.strict_mode") : 60108, b = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, v = t ? Symbol.for("react.context") : 60110, s = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, E = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
  function w(I) {
    if (typeof I == "object" && I !== null) {
      var k = I.$$typeof;
      switch (k) {
        case r:
          switch (I = I.type, I) {
            case s:
            case c:
            case u:
            case b:
            case h:
            case p:
              return I;
            default:
              switch (I = I && I.$$typeof, I) {
                case v:
                case d:
                case y:
                case E:
                case l:
                  return I;
                default:
                  return k;
              }
          }
        case a:
          return k;
      }
    }
  }
  function _(I) {
    return w(I) === c;
  }
  return _i.AsyncMode = s, _i.ConcurrentMode = c, _i.ContextConsumer = v, _i.ContextProvider = l, _i.Element = r, _i.ForwardRef = d, _i.Fragment = u, _i.Lazy = y, _i.Memo = E, _i.Portal = a, _i.Profiler = b, _i.StrictMode = h, _i.Suspense = p, _i.isAsyncMode = function(I) {
    return _(I) || w(I) === s;
  }, _i.isConcurrentMode = _, _i.isContextConsumer = function(I) {
    return w(I) === v;
  }, _i.isContextProvider = function(I) {
    return w(I) === l;
  }, _i.isElement = function(I) {
    return typeof I == "object" && I !== null && I.$$typeof === r;
  }, _i.isForwardRef = function(I) {
    return w(I) === d;
  }, _i.isFragment = function(I) {
    return w(I) === u;
  }, _i.isLazy = function(I) {
    return w(I) === y;
  }, _i.isMemo = function(I) {
    return w(I) === E;
  }, _i.isPortal = function(I) {
    return w(I) === a;
  }, _i.isProfiler = function(I) {
    return w(I) === b;
  }, _i.isStrictMode = function(I) {
    return w(I) === h;
  }, _i.isSuspense = function(I) {
    return w(I) === p;
  }, _i.isValidElementType = function(I) {
    return typeof I == "string" || typeof I == "function" || I === u || I === c || I === b || I === h || I === p || I === m || typeof I == "object" && I !== null && (I.$$typeof === y || I.$$typeof === E || I.$$typeof === l || I.$$typeof === v || I.$$typeof === d || I.$$typeof === C || I.$$typeof === O || I.$$typeof === N || I.$$typeof === g);
  }, _i.typeOf = w, _i;
}
var Pi = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wB;
function WSe() {
  return wB || (wB = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, a = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, h = t ? Symbol.for("react.strict_mode") : 60108, b = t ? Symbol.for("react.profiler") : 60114, l = t ? Symbol.for("react.provider") : 60109, v = t ? Symbol.for("react.context") : 60110, s = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, m = t ? Symbol.for("react.suspense_list") : 60120, E = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, C = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
    function w(be) {
      return typeof be == "string" || typeof be == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      be === u || be === c || be === b || be === h || be === p || be === m || typeof be == "object" && be !== null && (be.$$typeof === y || be.$$typeof === E || be.$$typeof === l || be.$$typeof === v || be.$$typeof === d || be.$$typeof === C || be.$$typeof === O || be.$$typeof === N || be.$$typeof === g);
    }
    function _(be) {
      if (typeof be == "object" && be !== null) {
        var $e = be.$$typeof;
        switch ($e) {
          case r:
            var Be = be.type;
            switch (Be) {
              case s:
              case c:
              case u:
              case b:
              case h:
              case p:
                return Be;
              default:
                var Ke = Be && Be.$$typeof;
                switch (Ke) {
                  case v:
                  case d:
                  case y:
                  case E:
                  case l:
                    return Ke;
                  default:
                    return $e;
                }
            }
          case a:
            return $e;
        }
      }
    }
    var I = s, k = c, H = v, S = l, B = r, D = d, F = u, j = y, G = E, U = a, M = b, V = h, J = p, ue = !1;
    function se(be) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ee(be) || _(be) === s;
    }
    function ee(be) {
      return _(be) === c;
    }
    function de(be) {
      return _(be) === v;
    }
    function he(be) {
      return _(be) === l;
    }
    function pe(be) {
      return typeof be == "object" && be !== null && be.$$typeof === r;
    }
    function Ce(be) {
      return _(be) === d;
    }
    function _e(be) {
      return _(be) === u;
    }
    function Le(be) {
      return _(be) === y;
    }
    function Te(be) {
      return _(be) === E;
    }
    function K(be) {
      return _(be) === a;
    }
    function Oe(be) {
      return _(be) === b;
    }
    function Pe(be) {
      return _(be) === h;
    }
    function xe(be) {
      return _(be) === p;
    }
    Pi.AsyncMode = I, Pi.ConcurrentMode = k, Pi.ContextConsumer = H, Pi.ContextProvider = S, Pi.Element = B, Pi.ForwardRef = D, Pi.Fragment = F, Pi.Lazy = j, Pi.Memo = G, Pi.Portal = U, Pi.Profiler = M, Pi.StrictMode = V, Pi.Suspense = J, Pi.isAsyncMode = se, Pi.isConcurrentMode = ee, Pi.isContextConsumer = de, Pi.isContextProvider = he, Pi.isElement = pe, Pi.isForwardRef = Ce, Pi.isFragment = _e, Pi.isLazy = Le, Pi.isMemo = Te, Pi.isPortal = K, Pi.isProfiler = Oe, Pi.isStrictMode = Pe, Pi.isSuspense = xe, Pi.isValidElementType = w, Pi.typeOf = _;
  }()), Pi;
}
var _B;
function eX() {
  return _B || (_B = 1, process.env.NODE_ENV === "production" ? G0.exports = XSe() : G0.exports = WSe()), G0.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var l2, PB;
function qSe() {
  if (PB) return l2;
  PB = 1;
  var t = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function u(b) {
    if (b == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(b);
  }
  function h() {
    try {
      if (!Object.assign)
        return !1;
      var b = new String("abc");
      if (b[5] = "de", Object.getOwnPropertyNames(b)[0] === "5")
        return !1;
      for (var l = {}, v = 0; v < 10; v++)
        l["_" + String.fromCharCode(v)] = v;
      var s = Object.getOwnPropertyNames(l).map(function(d) {
        return l[d];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return l2 = h() ? Object.assign : function(b, l) {
    for (var v, s = u(b), c, d = 1; d < arguments.length; d++) {
      v = Object(arguments[d]);
      for (var p in v)
        r.call(v, p) && (s[p] = v[p]);
      if (t) {
        c = t(v);
        for (var m = 0; m < c.length; m++)
          a.call(v, c[m]) && (s[c[m]] = v[c[m]]);
      }
    }
    return s;
  }, l2;
}
var f2, xB;
function u_() {
  if (xB) return f2;
  xB = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return f2 = t, f2;
}
var h2, DB;
function tX() {
  return DB || (DB = 1, h2 = Function.call.bind(Object.prototype.hasOwnProperty)), h2;
}
var p2, MB;
function KSe() {
  if (MB) return p2;
  MB = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = u_(), a = {}, u = tX();
    t = function(b) {
      var l = "Warning: " + b;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function h(b, l, v, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in b)
        if (u(b, d)) {
          var p;
          try {
            if (typeof b[d] != "function") {
              var m = Error(
                (s || "React class") + ": " + v + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw m.name = "Invariant Violation", m;
            }
            p = b[d](l, d, s, v, null, r);
          } catch (y) {
            p = y;
          }
          if (p && !(p instanceof Error) && t(
            (s || "React class") + ": type specification of " + v + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in a)) {
            a[p.message] = !0;
            var E = c ? c() : "";
            t(
              "Failed " + v + " type: " + p.message + (E ?? "")
            );
          }
        }
    }
  }
  return h.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, p2 = h, p2;
}
var g2, LB;
function JSe() {
  if (LB) return g2;
  LB = 1;
  var t = eX(), r = qSe(), a = u_(), u = tX(), h = KSe(), b = function() {
  };
  process.env.NODE_ENV !== "production" && (b = function(v) {
    var s = "Warning: " + v;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return g2 = function(v, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function p(ee) {
      var de = ee && (c && ee[c] || ee[d]);
      if (typeof de == "function")
        return de;
    }
    var m = "<<anonymous>>", E = {
      array: O("array"),
      bigint: O("bigint"),
      bool: O("boolean"),
      func: O("function"),
      number: O("number"),
      object: O("object"),
      string: O("string"),
      symbol: O("symbol"),
      any: N(),
      arrayOf: w,
      element: _(),
      elementType: I(),
      instanceOf: k,
      node: D(),
      objectOf: S,
      oneOf: H,
      oneOfType: B,
      shape: j,
      exact: G
    };
    function y(ee, de) {
      return ee === de ? ee !== 0 || 1 / ee === 1 / de : ee !== ee && de !== de;
    }
    function g(ee, de) {
      this.message = ee, this.data = de && typeof de == "object" ? de : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function C(ee) {
      if (process.env.NODE_ENV !== "production")
        var de = {}, he = 0;
      function pe(_e, Le, Te, K, Oe, Pe, xe) {
        if (K = K || m, Pe = Pe || Te, xe !== a) {
          if (s) {
            var be = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw be.name = "Invariant Violation", be;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var $e = K + ":" + Te;
            !de[$e] && // Avoid spamming the console because they are often not actionable except for lib authors
            he < 3 && (b(
              "You are manually calling a React.PropTypes validation function for the `" + Pe + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), de[$e] = !0, he++);
          }
        }
        return Le[Te] == null ? _e ? Le[Te] === null ? new g("The " + Oe + " `" + Pe + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new g("The " + Oe + " `" + Pe + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : ee(Le, Te, K, Oe, Pe);
      }
      var Ce = pe.bind(null, !1);
      return Ce.isRequired = pe.bind(null, !0), Ce;
    }
    function O(ee) {
      function de(he, pe, Ce, _e, Le, Te) {
        var K = he[pe], Oe = V(K);
        if (Oe !== ee) {
          var Pe = J(K);
          return new g(
            "Invalid " + _e + " `" + Le + "` of type " + ("`" + Pe + "` supplied to `" + Ce + "`, expected ") + ("`" + ee + "`."),
            { expectedType: ee }
          );
        }
        return null;
      }
      return C(de);
    }
    function N() {
      return C(l);
    }
    function w(ee) {
      function de(he, pe, Ce, _e, Le) {
        if (typeof ee != "function")
          return new g("Property `" + Le + "` of component `" + Ce + "` has invalid PropType notation inside arrayOf.");
        var Te = he[pe];
        if (!Array.isArray(Te)) {
          var K = V(Te);
          return new g("Invalid " + _e + " `" + Le + "` of type " + ("`" + K + "` supplied to `" + Ce + "`, expected an array."));
        }
        for (var Oe = 0; Oe < Te.length; Oe++) {
          var Pe = ee(Te, Oe, Ce, _e, Le + "[" + Oe + "]", a);
          if (Pe instanceof Error)
            return Pe;
        }
        return null;
      }
      return C(de);
    }
    function _() {
      function ee(de, he, pe, Ce, _e) {
        var Le = de[he];
        if (!v(Le)) {
          var Te = V(Le);
          return new g("Invalid " + Ce + " `" + _e + "` of type " + ("`" + Te + "` supplied to `" + pe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(ee);
    }
    function I() {
      function ee(de, he, pe, Ce, _e) {
        var Le = de[he];
        if (!t.isValidElementType(Le)) {
          var Te = V(Le);
          return new g("Invalid " + Ce + " `" + _e + "` of type " + ("`" + Te + "` supplied to `" + pe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(ee);
    }
    function k(ee) {
      function de(he, pe, Ce, _e, Le) {
        if (!(he[pe] instanceof ee)) {
          var Te = ee.name || m, K = se(he[pe]);
          return new g("Invalid " + _e + " `" + Le + "` of type " + ("`" + K + "` supplied to `" + Ce + "`, expected ") + ("instance of `" + Te + "`."));
        }
        return null;
      }
      return C(de);
    }
    function H(ee) {
      if (!Array.isArray(ee))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? b(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : b("Invalid argument supplied to oneOf, expected an array.")), l;
      function de(he, pe, Ce, _e, Le) {
        for (var Te = he[pe], K = 0; K < ee.length; K++)
          if (y(Te, ee[K]))
            return null;
        var Oe = JSON.stringify(ee, function(xe, be) {
          var $e = J(be);
          return $e === "symbol" ? String(be) : be;
        });
        return new g("Invalid " + _e + " `" + Le + "` of value `" + String(Te) + "` " + ("supplied to `" + Ce + "`, expected one of " + Oe + "."));
      }
      return C(de);
    }
    function S(ee) {
      function de(he, pe, Ce, _e, Le) {
        if (typeof ee != "function")
          return new g("Property `" + Le + "` of component `" + Ce + "` has invalid PropType notation inside objectOf.");
        var Te = he[pe], K = V(Te);
        if (K !== "object")
          return new g("Invalid " + _e + " `" + Le + "` of type " + ("`" + K + "` supplied to `" + Ce + "`, expected an object."));
        for (var Oe in Te)
          if (u(Te, Oe)) {
            var Pe = ee(Te, Oe, Ce, _e, Le + "." + Oe, a);
            if (Pe instanceof Error)
              return Pe;
          }
        return null;
      }
      return C(de);
    }
    function B(ee) {
      if (!Array.isArray(ee))
        return process.env.NODE_ENV !== "production" && b("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var de = 0; de < ee.length; de++) {
        var he = ee[de];
        if (typeof he != "function")
          return b(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(he) + " at index " + de + "."
          ), l;
      }
      function pe(Ce, _e, Le, Te, K) {
        for (var Oe = [], Pe = 0; Pe < ee.length; Pe++) {
          var xe = ee[Pe], be = xe(Ce, _e, Le, Te, K, a);
          if (be == null)
            return null;
          be.data && u(be.data, "expectedType") && Oe.push(be.data.expectedType);
        }
        var $e = Oe.length > 0 ? ", expected one of type [" + Oe.join(", ") + "]" : "";
        return new g("Invalid " + Te + " `" + K + "` supplied to " + ("`" + Le + "`" + $e + "."));
      }
      return C(pe);
    }
    function D() {
      function ee(de, he, pe, Ce, _e) {
        return U(de[he]) ? null : new g("Invalid " + Ce + " `" + _e + "` supplied to " + ("`" + pe + "`, expected a ReactNode."));
      }
      return C(ee);
    }
    function F(ee, de, he, pe, Ce) {
      return new g(
        (ee || "React class") + ": " + de + " type `" + he + "." + pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ce + "`."
      );
    }
    function j(ee) {
      function de(he, pe, Ce, _e, Le) {
        var Te = he[pe], K = V(Te);
        if (K !== "object")
          return new g("Invalid " + _e + " `" + Le + "` of type `" + K + "` " + ("supplied to `" + Ce + "`, expected `object`."));
        for (var Oe in ee) {
          var Pe = ee[Oe];
          if (typeof Pe != "function")
            return F(Ce, _e, Le, Oe, J(Pe));
          var xe = Pe(Te, Oe, Ce, _e, Le + "." + Oe, a);
          if (xe)
            return xe;
        }
        return null;
      }
      return C(de);
    }
    function G(ee) {
      function de(he, pe, Ce, _e, Le) {
        var Te = he[pe], K = V(Te);
        if (K !== "object")
          return new g("Invalid " + _e + " `" + Le + "` of type `" + K + "` " + ("supplied to `" + Ce + "`, expected `object`."));
        var Oe = r({}, he[pe], ee);
        for (var Pe in Oe) {
          var xe = ee[Pe];
          if (u(ee, Pe) && typeof xe != "function")
            return F(Ce, _e, Le, Pe, J(xe));
          if (!xe)
            return new g(
              "Invalid " + _e + " `" + Le + "` key `" + Pe + "` supplied to `" + Ce + "`.\nBad object: " + JSON.stringify(he[pe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ee), null, "  ")
            );
          var be = xe(Te, Pe, Ce, _e, Le + "." + Pe, a);
          if (be)
            return be;
        }
        return null;
      }
      return C(de);
    }
    function U(ee) {
      switch (typeof ee) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ee;
        case "object":
          if (Array.isArray(ee))
            return ee.every(U);
          if (ee === null || v(ee))
            return !0;
          var de = p(ee);
          if (de) {
            var he = de.call(ee), pe;
            if (de !== ee.entries) {
              for (; !(pe = he.next()).done; )
                if (!U(pe.value))
                  return !1;
            } else
              for (; !(pe = he.next()).done; ) {
                var Ce = pe.value;
                if (Ce && !U(Ce[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(ee, de) {
      return ee === "symbol" ? !0 : de ? de["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && de instanceof Symbol : !1;
    }
    function V(ee) {
      var de = typeof ee;
      return Array.isArray(ee) ? "array" : ee instanceof RegExp ? "object" : M(de, ee) ? "symbol" : de;
    }
    function J(ee) {
      if (typeof ee > "u" || ee === null)
        return "" + ee;
      var de = V(ee);
      if (de === "object") {
        if (ee instanceof Date)
          return "date";
        if (ee instanceof RegExp)
          return "regexp";
      }
      return de;
    }
    function ue(ee) {
      var de = J(ee);
      switch (de) {
        case "array":
        case "object":
          return "an " + de;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + de;
        default:
          return de;
      }
    }
    function se(ee) {
      return !ee.constructor || !ee.constructor.name ? m : ee.constructor.name;
    }
    return E.checkPropTypes = h, E.resetWarningCache = h.resetWarningCache, E.PropTypes = E, E;
  }, g2;
}
var m2, kB;
function ZSe() {
  if (kB) return m2;
  kB = 1;
  var t = u_();
  function r() {
  }
  function a() {
  }
  return a.resetWarningCache = r, m2 = function() {
    function u(l, v, s, c, d, p) {
      if (p !== t) {
        var m = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw m.name = "Invariant Violation", m;
      }
    }
    u.isRequired = u;
    function h() {
      return u;
    }
    var b = {
      array: u,
      bigint: u,
      bool: u,
      func: u,
      number: u,
      object: u,
      string: u,
      symbol: u,
      any: u,
      arrayOf: h,
      element: u,
      elementType: u,
      instanceOf: h,
      node: u,
      objectOf: h,
      oneOf: h,
      oneOfType: h,
      shape: h,
      exact: h,
      checkPropTypes: a,
      resetWarningCache: r
    };
    return b.PropTypes = b, b;
  }, m2;
}
if (process.env.NODE_ENV !== "production") {
  var QSe = eX(), $Se = !0;
  GN.exports = JSe()(QSe.isElement, $Se);
} else
  GN.exports = ZSe()();
var nX = GN.exports;
function rX(t) {
  var r, a, u = "";
  if (typeof t == "string" || typeof t == "number") u += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (r = 0; r < t.length; r++) t[r] && (a = rX(t[r])) && (u && (u += " "), u += a);
  else for (r in t) t[r] && (u && (u += " "), u += r);
  return u;
}
function jB() {
  for (var t, r, a = 0, u = ""; a < arguments.length; ) (t = arguments[a++]) && (r = rX(t)) && (u && (u += " "), u += r);
  return u;
}
const eIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: jB,
  default: jB
}, Symbol.toStringTag, { value: "Module" })), tIe = /* @__PURE__ */ KN(eIe);
var Ps = {}, Wu = {};
Object.defineProperty(Wu, "__esModule", {
  value: !0
});
Wu.dontSetMe = aIe;
Wu.findInArray = nIe;
Wu.int = sIe;
Wu.isFunction = rIe;
Wu.isNum = iIe;
function nIe(t, r) {
  for (let a = 0, u = t.length; a < u; a++)
    if (r.apply(r, [t[a], a, t])) return t[a];
}
function rIe(t) {
  return typeof t == "function" || Object.prototype.toString.call(t) === "[object Function]";
}
function iIe(t) {
  return typeof t == "number" && !isNaN(t);
}
function sIe(t) {
  return parseInt(t, 10);
}
function aIe(t, r, a) {
  if (t[r])
    return new Error("Invalid prop ".concat(r, " passed to ").concat(a, " - do not set this, set it on the child."));
}
var Ch = {};
Object.defineProperty(Ch, "__esModule", {
  value: !0
});
Ch.browserPrefixToKey = sX;
Ch.browserPrefixToStyle = oIe;
Ch.default = void 0;
Ch.getPrefix = iX;
const E2 = ["Moz", "Webkit", "O", "ms"];
function iX() {
  var t;
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u") return "";
  const a = (t = window.document) === null || t === void 0 || (t = t.documentElement) === null || t === void 0 ? void 0 : t.style;
  if (!a || r in a) return "";
  for (let u = 0; u < E2.length; u++)
    if (sX(r, E2[u]) in a) return E2[u];
  return "";
}
function sX(t, r) {
  return r ? "".concat(r).concat(cIe(t)) : t;
}
function oIe(t, r) {
  return r ? "-".concat(r.toLowerCase(), "-").concat(t) : t;
}
function cIe(t) {
  let r = "", a = !0;
  for (let u = 0; u < t.length; u++)
    a ? (r += t[u].toUpperCase(), a = !1) : t[u] === "-" ? a = !0 : r += t[u];
  return r;
}
Ch.default = iX();
Object.defineProperty(Ps, "__esModule", {
  value: !0
});
Ps.addClassName = cX;
Ps.addEvent = lIe;
Ps.addUserSelectStyles = AIe;
Ps.createCSSTransform = yIe;
Ps.createSVGTransform = vIe;
Ps.getTouch = TIe;
Ps.getTouchIdentifier = bIe;
Ps.getTranslation = d_;
Ps.innerHeight = gIe;
Ps.innerWidth = mIe;
Ps.matchesSelector = oX;
Ps.matchesSelectorAndParentsTo = dIe;
Ps.offsetXYFromParent = EIe;
Ps.outerHeight = hIe;
Ps.outerWidth = pIe;
Ps.removeClassName = uX;
Ps.removeEvent = fIe;
Ps.removeUserSelectStyles = OIe;
var Fo = Wu, UB = uIe(Ch);
function aX(t) {
  if (typeof WeakMap != "function") return null;
  var r = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
  return (aX = function(u) {
    return u ? a : r;
  })(t);
}
function uIe(t, r) {
  if (t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var a = aX(r);
  if (a && a.has(t))
    return a.get(t);
  var u = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var b in t)
    if (b !== "default" && Object.prototype.hasOwnProperty.call(t, b)) {
      var l = h ? Object.getOwnPropertyDescriptor(t, b) : null;
      l && (l.get || l.set) ? Object.defineProperty(u, b, l) : u[b] = t[b];
    }
  return u.default = t, a && a.set(t, u), u;
}
let V0 = "";
function oX(t, r) {
  return V0 || (V0 = (0, Fo.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(a) {
    return (0, Fo.isFunction)(t[a]);
  })), (0, Fo.isFunction)(t[V0]) ? t[V0](r) : !1;
}
function dIe(t, r, a) {
  let u = t;
  do {
    if (oX(u, r)) return !0;
    if (u === a) return !1;
    u = u.parentNode;
  } while (u);
  return !1;
}
function lIe(t, r, a, u) {
  if (!t) return;
  const h = {
    capture: !0,
    ...u
  };
  t.addEventListener ? t.addEventListener(r, a, h) : t.attachEvent ? t.attachEvent("on" + r, a) : t["on" + r] = a;
}
function fIe(t, r, a, u) {
  if (!t) return;
  const h = {
    capture: !0,
    ...u
  };
  t.removeEventListener ? t.removeEventListener(r, a, h) : t.detachEvent ? t.detachEvent("on" + r, a) : t["on" + r] = null;
}
function hIe(t) {
  let r = t.clientHeight;
  const a = t.ownerDocument.defaultView.getComputedStyle(t);
  return r += (0, Fo.int)(a.borderTopWidth), r += (0, Fo.int)(a.borderBottomWidth), r;
}
function pIe(t) {
  let r = t.clientWidth;
  const a = t.ownerDocument.defaultView.getComputedStyle(t);
  return r += (0, Fo.int)(a.borderLeftWidth), r += (0, Fo.int)(a.borderRightWidth), r;
}
function gIe(t) {
  let r = t.clientHeight;
  const a = t.ownerDocument.defaultView.getComputedStyle(t);
  return r -= (0, Fo.int)(a.paddingTop), r -= (0, Fo.int)(a.paddingBottom), r;
}
function mIe(t) {
  let r = t.clientWidth;
  const a = t.ownerDocument.defaultView.getComputedStyle(t);
  return r -= (0, Fo.int)(a.paddingLeft), r -= (0, Fo.int)(a.paddingRight), r;
}
function EIe(t, r, a) {
  const h = r === r.ownerDocument.body ? {
    left: 0,
    top: 0
  } : r.getBoundingClientRect(), b = (t.clientX + r.scrollLeft - h.left) / a, l = (t.clientY + r.scrollTop - h.top) / a;
  return {
    x: b,
    y: l
  };
}
function yIe(t, r) {
  const a = d_(t, r, "px");
  return {
    [(0, UB.browserPrefixToKey)("transform", UB.default)]: a
  };
}
function vIe(t, r) {
  return d_(t, r, "");
}
function d_(t, r, a) {
  let {
    x: u,
    y: h
  } = t, b = "translate(".concat(u).concat(a, ",").concat(h).concat(a, ")");
  if (r) {
    const l = "".concat(typeof r.x == "string" ? r.x : r.x + a), v = "".concat(typeof r.y == "string" ? r.y : r.y + a);
    b = "translate(".concat(l, ", ").concat(v, ")") + b;
  }
  return b;
}
function TIe(t, r) {
  return t.targetTouches && (0, Fo.findInArray)(t.targetTouches, (a) => r === a.identifier) || t.changedTouches && (0, Fo.findInArray)(t.changedTouches, (a) => r === a.identifier);
}
function bIe(t) {
  if (t.targetTouches && t.targetTouches[0]) return t.targetTouches[0].identifier;
  if (t.changedTouches && t.changedTouches[0]) return t.changedTouches[0].identifier;
}
function AIe(t) {
  if (!t) return;
  let r = t.getElementById("react-draggable-style-el");
  r || (r = t.createElement("style"), r.type = "text/css", r.id = "react-draggable-style-el", r.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, r.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, t.getElementsByTagName("head")[0].appendChild(r)), t.body && cX(t.body, "react-draggable-transparent-selection");
}
function OIe(t) {
  if (t)
    try {
      if (t.body && uX(t.body, "react-draggable-transparent-selection"), t.selection)
        t.selection.empty();
      else {
        const r = (t.defaultView || window).getSelection();
        r && r.type !== "Caret" && r.removeAllRanges();
      }
    } catch {
    }
}
function cX(t, r) {
  t.classList ? t.classList.add(r) : t.className.match(new RegExp("(?:^|\\s)".concat(r, "(?!\\S)"))) || (t.className += " ".concat(r));
}
function uX(t, r) {
  t.classList ? t.classList.remove(r) : t.className = t.className.replace(new RegExp("(?:^|\\s)".concat(r, "(?!\\S)"), "g"), "");
}
var qu = {};
Object.defineProperty(qu, "__esModule", {
  value: !0
});
qu.canDragX = IIe;
qu.canDragY = RIe;
qu.createCoreData = wIe;
qu.createDraggableData = _Ie;
qu.getBoundPosition = CIe;
qu.getControlPosition = NIe;
qu.snapToGrid = SIe;
var Lo = Wu, tg = Ps;
function CIe(t, r, a) {
  if (!t.props.bounds) return [r, a];
  let {
    bounds: u
  } = t.props;
  u = typeof u == "string" ? u : PIe(u);
  const h = l_(t);
  if (typeof u == "string") {
    const {
      ownerDocument: b
    } = h, l = b.defaultView;
    let v;
    if (u === "parent" ? v = h.parentNode : v = b.querySelector(u), !(v instanceof l.HTMLElement))
      throw new Error('Bounds selector "' + u + '" could not find an element.');
    const s = v, c = l.getComputedStyle(h), d = l.getComputedStyle(s);
    u = {
      left: -h.offsetLeft + (0, Lo.int)(d.paddingLeft) + (0, Lo.int)(c.marginLeft),
      top: -h.offsetTop + (0, Lo.int)(d.paddingTop) + (0, Lo.int)(c.marginTop),
      right: (0, tg.innerWidth)(s) - (0, tg.outerWidth)(h) - h.offsetLeft + (0, Lo.int)(d.paddingRight) - (0, Lo.int)(c.marginRight),
      bottom: (0, tg.innerHeight)(s) - (0, tg.outerHeight)(h) - h.offsetTop + (0, Lo.int)(d.paddingBottom) - (0, Lo.int)(c.marginBottom)
    };
  }
  return (0, Lo.isNum)(u.right) && (r = Math.min(r, u.right)), (0, Lo.isNum)(u.bottom) && (a = Math.min(a, u.bottom)), (0, Lo.isNum)(u.left) && (r = Math.max(r, u.left)), (0, Lo.isNum)(u.top) && (a = Math.max(a, u.top)), [r, a];
}
function SIe(t, r, a) {
  const u = Math.round(r / t[0]) * t[0], h = Math.round(a / t[1]) * t[1];
  return [u, h];
}
function IIe(t) {
  return t.props.axis === "both" || t.props.axis === "x";
}
function RIe(t) {
  return t.props.axis === "both" || t.props.axis === "y";
}
function NIe(t, r, a) {
  const u = typeof r == "number" ? (0, tg.getTouch)(t, r) : null;
  if (typeof r == "number" && !u) return null;
  const h = l_(a), b = a.props.offsetParent || h.offsetParent || h.ownerDocument.body;
  return (0, tg.offsetXYFromParent)(u || t, b, a.props.scale);
}
function wIe(t, r, a) {
  const u = !(0, Lo.isNum)(t.lastX), h = l_(t);
  return u ? {
    node: h,
    deltaX: 0,
    deltaY: 0,
    lastX: r,
    lastY: a,
    x: r,
    y: a
  } : {
    node: h,
    deltaX: r - t.lastX,
    deltaY: a - t.lastY,
    lastX: t.lastX,
    lastY: t.lastY,
    x: r,
    y: a
  };
}
function _Ie(t, r) {
  const a = t.props.scale;
  return {
    node: r.node,
    x: t.state.x + r.deltaX / a,
    y: t.state.y + r.deltaY / a,
    deltaX: r.deltaX / a,
    deltaY: r.deltaY / a,
    lastX: t.state.x,
    lastY: t.state.y
  };
}
function PIe(t) {
  return {
    left: t.left,
    top: t.top,
    right: t.right,
    bottom: t.bottom
  };
}
function l_(t) {
  const r = t.findDOMNode();
  if (!r)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return r;
}
var LA = {}, kA = {};
Object.defineProperty(kA, "__esModule", {
  value: !0
});
kA.default = xIe;
function xIe() {
}
Object.defineProperty(LA, "__esModule", {
  value: !0
});
LA.default = void 0;
var y2 = MIe(_t), po = f_(nX), DIe = f_(jl), xa = Ps, bl = qu, v2 = Wu, _y = f_(kA);
function f_(t) {
  return t && t.__esModule ? t : { default: t };
}
function dX(t) {
  if (typeof WeakMap != "function") return null;
  var r = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
  return (dX = function(u) {
    return u ? a : r;
  })(t);
}
function MIe(t, r) {
  if (t && t.__esModule)
    return t;
  if (t === null || typeof t != "object" && typeof t != "function")
    return { default: t };
  var a = dX(r);
  if (a && a.has(t))
    return a.get(t);
  var u = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var b in t)
    if (b !== "default" && Object.prototype.hasOwnProperty.call(t, b)) {
      var l = h ? Object.getOwnPropertyDescriptor(t, b) : null;
      l && (l.get || l.set) ? Object.defineProperty(u, b, l) : u[b] = t[b];
    }
  return u.default = t, a && a.set(t, u), u;
}
function Xa(t, r, a) {
  return r = LIe(r), r in t ? Object.defineProperty(t, r, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = a, t;
}
function LIe(t) {
  var r = kIe(t, "string");
  return typeof r == "symbol" ? r : String(r);
}
function kIe(t, r) {
  if (typeof t != "object" || t === null) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var u = a.call(t, r || "default");
    if (typeof u != "object") return u;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
const Xc = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let Al = Xc.mouse, jA = class extends y2.Component {
  constructor() {
    super(...arguments), Xa(this, "dragging", !1), Xa(this, "lastX", NaN), Xa(this, "lastY", NaN), Xa(this, "touchIdentifier", null), Xa(this, "mounted", !1), Xa(this, "handleDragStart", (r) => {
      if (this.props.onMouseDown(r), !this.props.allowAnyClick && typeof r.button == "number" && r.button !== 0) return !1;
      const a = this.findDOMNode();
      if (!a || !a.ownerDocument || !a.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: u
      } = a;
      if (this.props.disabled || !(r.target instanceof u.defaultView.Node) || this.props.handle && !(0, xa.matchesSelectorAndParentsTo)(r.target, this.props.handle, a) || this.props.cancel && (0, xa.matchesSelectorAndParentsTo)(r.target, this.props.cancel, a))
        return;
      r.type === "touchstart" && r.preventDefault();
      const h = (0, xa.getTouchIdentifier)(r);
      this.touchIdentifier = h;
      const b = (0, bl.getControlPosition)(r, h, this);
      if (b == null) return;
      const {
        x: l,
        y: v
      } = b, s = (0, bl.createCoreData)(this, l, v);
      (0, _y.default)("DraggableCore: handleDragStart: %j", s), (0, _y.default)("calling", this.props.onStart), !(this.props.onStart(r, s) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, xa.addUserSelectStyles)(u), this.dragging = !0, this.lastX = l, this.lastY = v, (0, xa.addEvent)(u, Al.move, this.handleDrag), (0, xa.addEvent)(u, Al.stop, this.handleDragStop));
    }), Xa(this, "handleDrag", (r) => {
      const a = (0, bl.getControlPosition)(r, this.touchIdentifier, this);
      if (a == null) return;
      let {
        x: u,
        y: h
      } = a;
      if (Array.isArray(this.props.grid)) {
        let v = u - this.lastX, s = h - this.lastY;
        if ([v, s] = (0, bl.snapToGrid)(this.props.grid, v, s), !v && !s) return;
        u = this.lastX + v, h = this.lastY + s;
      }
      const b = (0, bl.createCoreData)(this, u, h);
      if ((0, _y.default)("DraggableCore: handleDrag: %j", b), this.props.onDrag(r, b) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const s = document.createEvent("MouseEvents");
          s.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(s);
        }
        return;
      }
      this.lastX = u, this.lastY = h;
    }), Xa(this, "handleDragStop", (r) => {
      if (!this.dragging) return;
      const a = (0, bl.getControlPosition)(r, this.touchIdentifier, this);
      if (a == null) return;
      let {
        x: u,
        y: h
      } = a;
      if (Array.isArray(this.props.grid)) {
        let s = u - this.lastX || 0, c = h - this.lastY || 0;
        [s, c] = (0, bl.snapToGrid)(this.props.grid, s, c), u = this.lastX + s, h = this.lastY + c;
      }
      const b = (0, bl.createCoreData)(this, u, h);
      if (this.props.onStop(r, b) === !1 || this.mounted === !1) return !1;
      const v = this.findDOMNode();
      v && this.props.enableUserSelectHack && (0, xa.removeUserSelectStyles)(v.ownerDocument), (0, _y.default)("DraggableCore: handleDragStop: %j", b), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, v && ((0, _y.default)("DraggableCore: Removing handlers"), (0, xa.removeEvent)(v.ownerDocument, Al.move, this.handleDrag), (0, xa.removeEvent)(v.ownerDocument, Al.stop, this.handleDragStop));
    }), Xa(this, "onMouseDown", (r) => (Al = Xc.mouse, this.handleDragStart(r))), Xa(this, "onMouseUp", (r) => (Al = Xc.mouse, this.handleDragStop(r))), Xa(this, "onTouchStart", (r) => (Al = Xc.touch, this.handleDragStart(r))), Xa(this, "onTouchEnd", (r) => (Al = Xc.touch, this.handleDragStop(r)));
  }
  componentDidMount() {
    this.mounted = !0;
    const r = this.findDOMNode();
    r && (0, xa.addEvent)(r, Xc.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const r = this.findDOMNode();
    if (r) {
      const {
        ownerDocument: a
      } = r;
      (0, xa.removeEvent)(a, Xc.mouse.move, this.handleDrag), (0, xa.removeEvent)(a, Xc.touch.move, this.handleDrag), (0, xa.removeEvent)(a, Xc.mouse.stop, this.handleDragStop), (0, xa.removeEvent)(a, Xc.touch.stop, this.handleDragStop), (0, xa.removeEvent)(r, Xc.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, xa.removeUserSelectStyles)(a);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var r, a;
    return (r = this.props) !== null && r !== void 0 && r.nodeRef ? (a = this.props) === null || a === void 0 || (a = a.nodeRef) === null || a === void 0 ? void 0 : a.current : DIe.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ y2.cloneElement(y2.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
LA.default = jA;
Xa(jA, "displayName", "DraggableCore");
Xa(jA, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: po.default.bool,
  children: po.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: po.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: po.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(t, r) {
    if (t[r] && t[r].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: po.default.arrayOf(po.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: po.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: po.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: po.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: po.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: po.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: po.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: po.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: po.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: v2.dontSetMe,
  style: v2.dontSetMe,
  transform: v2.dontSetMe
});
Xa(jA, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), t.default = void 0;
  var r = m(_t), a = d(nX), u = d(jl), h = d(tIe), b = Ps, l = qu, v = Wu, s = d(LA), c = d(kA);
  function d(N) {
    return N && N.__esModule ? N : { default: N };
  }
  function p(N) {
    if (typeof WeakMap != "function") return null;
    var w = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (p = function(I) {
      return I ? _ : w;
    })(N);
  }
  function m(N, w) {
    if (N && N.__esModule)
      return N;
    if (N === null || typeof N != "object" && typeof N != "function")
      return { default: N };
    var _ = p(w);
    if (_ && _.has(N))
      return _.get(N);
    var I = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var H in N)
      if (H !== "default" && Object.prototype.hasOwnProperty.call(N, H)) {
        var S = k ? Object.getOwnPropertyDescriptor(N, H) : null;
        S && (S.get || S.set) ? Object.defineProperty(I, H, S) : I[H] = N[H];
      }
    return I.default = N, _ && _.set(N, I), I;
  }
  function E() {
    return E = Object.assign ? Object.assign.bind() : function(N) {
      for (var w = 1; w < arguments.length; w++) {
        var _ = arguments[w];
        for (var I in _)
          Object.prototype.hasOwnProperty.call(_, I) && (N[I] = _[I]);
      }
      return N;
    }, E.apply(this, arguments);
  }
  function y(N, w, _) {
    return w = g(w), w in N ? Object.defineProperty(N, w, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : N[w] = _, N;
  }
  function g(N) {
    var w = C(N, "string");
    return typeof w == "symbol" ? w : String(w);
  }
  function C(N, w) {
    if (typeof N != "object" || N === null) return N;
    var _ = N[Symbol.toPrimitive];
    if (_ !== void 0) {
      var I = _.call(N, w || "default");
      if (typeof I != "object") return I;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (w === "string" ? String : Number)(N);
  }
  class O extends r.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(w, _) {
      let {
        position: I
      } = w, {
        prevPropsPosition: k
      } = _;
      return I && (!k || I.x !== k.x || I.y !== k.y) ? ((0, c.default)("Draggable: getDerivedStateFromProps %j", {
        position: I,
        prevPropsPosition: k
      }), {
        x: I.x,
        y: I.y,
        prevPropsPosition: {
          ...I
        }
      }) : null;
    }
    constructor(w) {
      super(w), y(this, "onDragStart", (_, I) => {
        if ((0, c.default)("Draggable: onDragStart: %j", I), this.props.onStart(_, (0, l.createDraggableData)(this, I)) === !1) return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), y(this, "onDrag", (_, I) => {
        if (!this.state.dragging) return !1;
        (0, c.default)("Draggable: onDrag: %j", I);
        const k = (0, l.createDraggableData)(this, I), H = {
          x: k.x,
          y: k.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: B,
            y: D
          } = H;
          H.x += this.state.slackX, H.y += this.state.slackY;
          const [F, j] = (0, l.getBoundPosition)(this, H.x, H.y);
          H.x = F, H.y = j, H.slackX = this.state.slackX + (B - H.x), H.slackY = this.state.slackY + (D - H.y), k.x = H.x, k.y = H.y, k.deltaX = H.x - this.state.x, k.deltaY = H.y - this.state.y;
        }
        if (this.props.onDrag(_, k) === !1) return !1;
        this.setState(H);
      }), y(this, "onDragStop", (_, I) => {
        if (!this.state.dragging || this.props.onStop(_, (0, l.createDraggableData)(this, I)) === !1) return !1;
        (0, c.default)("Draggable: onDragStop: %j", I);
        const H = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (!!this.props.position) {
          const {
            x: B,
            y: D
          } = this.props.position;
          H.x = B, H.y = D;
        }
        this.setState(H);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: w.position ? w.position.x : w.defaultPosition.x,
        y: w.position ? w.position.y : w.defaultPosition.y,
        prevPropsPosition: {
          ...w.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, w.position && !(w.onDrag || w.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var w, _;
      return (w = (_ = this.props) === null || _ === void 0 || (_ = _.nodeRef) === null || _ === void 0 ? void 0 : _.current) !== null && w !== void 0 ? w : u.default.findDOMNode(this);
    }
    render() {
      const {
        axis: w,
        bounds: _,
        children: I,
        defaultPosition: k,
        defaultClassName: H,
        defaultClassNameDragging: S,
        defaultClassNameDragged: B,
        position: D,
        positionOffset: F,
        scale: j,
        ...G
      } = this.props;
      let U = {}, M = null;
      const J = !!!D || this.state.dragging, ue = D || k, se = {
        // Set left if horizontal drag is enabled
        x: (0, l.canDragX)(this) && J ? this.state.x : ue.x,
        // Set top if vertical drag is enabled
        y: (0, l.canDragY)(this) && J ? this.state.y : ue.y
      };
      this.state.isElementSVG ? M = (0, b.createSVGTransform)(se, F) : U = (0, b.createCSSTransform)(se, F);
      const ee = (0, h.default)(I.props.className || "", H, {
        [S]: this.state.dragging,
        [B]: this.state.dragged
      });
      return /* @__PURE__ */ r.createElement(s.default, E({}, G, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ r.cloneElement(r.Children.only(I), {
        className: ee,
        style: {
          ...I.props.style,
          ...U
        },
        transform: M
      }));
    }
  }
  t.default = O, y(O, "displayName", "Draggable"), y(O, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...s.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: a.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: a.default.oneOfType([a.default.shape({
      left: a.default.number,
      right: a.default.number,
      top: a.default.number,
      bottom: a.default.number
    }), a.default.string, a.default.oneOf([!1])]),
    defaultClassName: a.default.string,
    defaultClassNameDragging: a.default.string,
    defaultClassNameDragged: a.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: a.default.shape({
      x: a.default.number,
      y: a.default.number
    }),
    positionOffset: a.default.shape({
      x: a.default.oneOfType([a.default.number, a.default.string]),
      y: a.default.oneOfType([a.default.number, a.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: a.default.shape({
      x: a.default.number,
      y: a.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: v.dontSetMe,
    style: v.dontSetMe,
    transform: v.dontSetMe
  }), y(O, "defaultProps", {
    ...s.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})($Y);
const {
  default: lX,
  DraggableCore: jIe
} = $Y;
MA.exports = lX;
MA.exports.default = lX;
MA.exports.DraggableCore = jIe;
var UIe = MA.exports;
const fX = /* @__PURE__ */ Gl(UIe);
var HIe = ["className", "spin", "style", "children"];
function VN() {
  return VN = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a)
        Object.prototype.hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, VN.apply(this, arguments);
}
function BIe(t, r) {
  if (t == null) return {};
  var a = {}, u = Object.keys(t), h, b;
  for (b = 0; b < u.length; b++)
    h = u[b], !(r.indexOf(h) >= 0) && (a[h] = t[h]);
  return a;
}
function ei(t) {
  var r = t.className, a = t.spin, u = t.style, h = t.children, b = BIe(t, HIe), l = En(r, {
    "callkit-component-icon": !0,
    "icon-spin": !!a
  });
  return /* @__PURE__ */ _t.createElement("i", VN({
    className: l,
    style: u
  }, b), h);
}
function zIe(t) {
  var r = DA(), a = Ja(function(d) {
    return d.windowSize;
  }), u = Ja(function(d) {
    return d.confr;
  }), h = Ja(function(d) {
    return d;
  }), b = u.type === 2 || u.type === 3, l = function() {
    var p = a === "normal" ? "large" : "normal";
    r(Ub(p));
  }, v = function() {
    r(Ub("mini"));
  }, s = function() {
    var p = Object.assign({}, u);
    p.groupId = h.groupId, p.groupName = h.groupName;
    var m = [].concat(h.joinedMembers);
    p.joinedMembers = m.map(function(E) {
      return {
        imUserId: E.name,
        agoraUid: E.value
      };
    }), t.onAddPerson && t.onAddPerson(p);
  }, c = u.type === 0 || u.type === 3 ? "Audio Call" : "Video Call";
  return /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-header-cantainer"
  }, /* @__PURE__ */ _t.createElement("span", {
    className: "callkit-header-name"
  }, c), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-header-contral"
  }, b && /* @__PURE__ */ _t.createElement("span", {
    onClick: s
  }, /* @__PURE__ */ _t.createElement(ei, {
    className: "iconfont icon-add_person icon-style"
  })), a === "normal" ? /* @__PURE__ */ _t.createElement("span", {
    onClick: l
  }, /* @__PURE__ */ _t.createElement(ei, {
    className: "iconfont icon-a-4_arrows_separation icon-style"
  })) : a === "large" ? /* @__PURE__ */ _t.createElement("span", {
    onClick: l
  }, /* @__PURE__ */ _t.createElement(ei, {
    className: "iconfont icon-a-4_arrows_gathering icon-style"
  })) : null, /* @__PURE__ */ _t.createElement("span", {
    onClick: v
  }, /* @__PURE__ */ _t.createElement(ei, {
    className: "iconfont icon-x icon-style"
  }))));
}
var hX = { exports: {} };
(function(t) {
  var r = nA.default;
  function a() {
    t.exports = a = function() {
      return h;
    }, t.exports.__esModule = !0, t.exports.default = t.exports;
    var u, h = {}, b = Object.prototype, l = b.hasOwnProperty, v = Object.defineProperty || function(se, ee, de) {
      se[ee] = de.value;
    }, s = typeof Symbol == "function" ? Symbol : {}, c = s.iterator || "@@iterator", d = s.asyncIterator || "@@asyncIterator", p = s.toStringTag || "@@toStringTag";
    function m(se, ee, de) {
      return Object.defineProperty(se, ee, {
        value: de,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), se[ee];
    }
    try {
      m({}, "");
    } catch {
      m = function(de, he, pe) {
        return de[he] = pe;
      };
    }
    function E(se, ee, de, he) {
      var pe = ee && ee.prototype instanceof _ ? ee : _, Ce = Object.create(pe.prototype), _e = new J(he || []);
      return v(Ce, "_invoke", {
        value: G(se, de, _e)
      }), Ce;
    }
    function y(se, ee, de) {
      try {
        return {
          type: "normal",
          arg: se.call(ee, de)
        };
      } catch (he) {
        return {
          type: "throw",
          arg: he
        };
      }
    }
    h.wrap = E;
    var g = "suspendedStart", C = "suspendedYield", O = "executing", N = "completed", w = {};
    function _() {
    }
    function I() {
    }
    function k() {
    }
    var H = {};
    m(H, c, function() {
      return this;
    });
    var S = Object.getPrototypeOf, B = S && S(S(ue([])));
    B && B !== b && l.call(B, c) && (H = B);
    var D = k.prototype = _.prototype = Object.create(H);
    function F(se) {
      ["next", "throw", "return"].forEach(function(ee) {
        m(se, ee, function(de) {
          return this._invoke(ee, de);
        });
      });
    }
    function j(se, ee) {
      function de(pe, Ce, _e, Le) {
        var Te = y(se[pe], se, Ce);
        if (Te.type !== "throw") {
          var K = Te.arg, Oe = K.value;
          return Oe && r(Oe) == "object" && l.call(Oe, "__await") ? ee.resolve(Oe.__await).then(function(Pe) {
            de("next", Pe, _e, Le);
          }, function(Pe) {
            de("throw", Pe, _e, Le);
          }) : ee.resolve(Oe).then(function(Pe) {
            K.value = Pe, _e(K);
          }, function(Pe) {
            return de("throw", Pe, _e, Le);
          });
        }
        Le(Te.arg);
      }
      var he;
      v(this, "_invoke", {
        value: function(Ce, _e) {
          function Le() {
            return new ee(function(Te, K) {
              de(Ce, _e, Te, K);
            });
          }
          return he = he ? he.then(Le, Le) : Le();
        }
      });
    }
    function G(se, ee, de) {
      var he = g;
      return function(pe, Ce) {
        if (he === O) throw Error("Generator is already running");
        if (he === N) {
          if (pe === "throw") throw Ce;
          return {
            value: u,
            done: !0
          };
        }
        for (de.method = pe, de.arg = Ce; ; ) {
          var _e = de.delegate;
          if (_e) {
            var Le = U(_e, de);
            if (Le) {
              if (Le === w) continue;
              return Le;
            }
          }
          if (de.method === "next") de.sent = de._sent = de.arg;
          else if (de.method === "throw") {
            if (he === g) throw he = N, de.arg;
            de.dispatchException(de.arg);
          } else de.method === "return" && de.abrupt("return", de.arg);
          he = O;
          var Te = y(se, ee, de);
          if (Te.type === "normal") {
            if (he = de.done ? N : C, Te.arg === w) continue;
            return {
              value: Te.arg,
              done: de.done
            };
          }
          Te.type === "throw" && (he = N, de.method = "throw", de.arg = Te.arg);
        }
      };
    }
    function U(se, ee) {
      var de = ee.method, he = se.iterator[de];
      if (he === u) return ee.delegate = null, de === "throw" && se.iterator.return && (ee.method = "return", ee.arg = u, U(se, ee), ee.method === "throw") || de !== "return" && (ee.method = "throw", ee.arg = new TypeError("The iterator does not provide a '" + de + "' method")), w;
      var pe = y(he, se.iterator, ee.arg);
      if (pe.type === "throw") return ee.method = "throw", ee.arg = pe.arg, ee.delegate = null, w;
      var Ce = pe.arg;
      return Ce ? Ce.done ? (ee[se.resultName] = Ce.value, ee.next = se.nextLoc, ee.method !== "return" && (ee.method = "next", ee.arg = u), ee.delegate = null, w) : Ce : (ee.method = "throw", ee.arg = new TypeError("iterator result is not an object"), ee.delegate = null, w);
    }
    function M(se) {
      var ee = {
        tryLoc: se[0]
      };
      1 in se && (ee.catchLoc = se[1]), 2 in se && (ee.finallyLoc = se[2], ee.afterLoc = se[3]), this.tryEntries.push(ee);
    }
    function V(se) {
      var ee = se.completion || {};
      ee.type = "normal", delete ee.arg, se.completion = ee;
    }
    function J(se) {
      this.tryEntries = [{
        tryLoc: "root"
      }], se.forEach(M, this), this.reset(!0);
    }
    function ue(se) {
      if (se || se === "") {
        var ee = se[c];
        if (ee) return ee.call(se);
        if (typeof se.next == "function") return se;
        if (!isNaN(se.length)) {
          var de = -1, he = function pe() {
            for (; ++de < se.length; ) if (l.call(se, de)) return pe.value = se[de], pe.done = !1, pe;
            return pe.value = u, pe.done = !0, pe;
          };
          return he.next = he;
        }
      }
      throw new TypeError(r(se) + " is not iterable");
    }
    return I.prototype = k, v(D, "constructor", {
      value: k,
      configurable: !0
    }), v(k, "constructor", {
      value: I,
      configurable: !0
    }), I.displayName = m(k, p, "GeneratorFunction"), h.isGeneratorFunction = function(se) {
      var ee = typeof se == "function" && se.constructor;
      return !!ee && (ee === I || (ee.displayName || ee.name) === "GeneratorFunction");
    }, h.mark = function(se) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(se, k) : (se.__proto__ = k, m(se, p, "GeneratorFunction")), se.prototype = Object.create(D), se;
    }, h.awrap = function(se) {
      return {
        __await: se
      };
    }, F(j.prototype), m(j.prototype, d, function() {
      return this;
    }), h.AsyncIterator = j, h.async = function(se, ee, de, he, pe) {
      pe === void 0 && (pe = Promise);
      var Ce = new j(E(se, ee, de, he), pe);
      return h.isGeneratorFunction(ee) ? Ce : Ce.next().then(function(_e) {
        return _e.done ? _e.value : Ce.next();
      });
    }, F(D), m(D, p, "Generator"), m(D, c, function() {
      return this;
    }), m(D, "toString", function() {
      return "[object Generator]";
    }), h.keys = function(se) {
      var ee = Object(se), de = [];
      for (var he in ee) de.push(he);
      return de.reverse(), function pe() {
        for (; de.length; ) {
          var Ce = de.pop();
          if (Ce in ee) return pe.value = Ce, pe.done = !1, pe;
        }
        return pe.done = !0, pe;
      };
    }, h.values = ue, J.prototype = {
      constructor: J,
      reset: function(ee) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = u, this.done = !1, this.delegate = null, this.method = "next", this.arg = u, this.tryEntries.forEach(V), !ee) for (var de in this) de.charAt(0) === "t" && l.call(this, de) && !isNaN(+de.slice(1)) && (this[de] = u);
      },
      stop: function() {
        this.done = !0;
        var ee = this.tryEntries[0].completion;
        if (ee.type === "throw") throw ee.arg;
        return this.rval;
      },
      dispatchException: function(ee) {
        if (this.done) throw ee;
        var de = this;
        function he(K, Oe) {
          return _e.type = "throw", _e.arg = ee, de.next = K, Oe && (de.method = "next", de.arg = u), !!Oe;
        }
        for (var pe = this.tryEntries.length - 1; pe >= 0; --pe) {
          var Ce = this.tryEntries[pe], _e = Ce.completion;
          if (Ce.tryLoc === "root") return he("end");
          if (Ce.tryLoc <= this.prev) {
            var Le = l.call(Ce, "catchLoc"), Te = l.call(Ce, "finallyLoc");
            if (Le && Te) {
              if (this.prev < Ce.catchLoc) return he(Ce.catchLoc, !0);
              if (this.prev < Ce.finallyLoc) return he(Ce.finallyLoc);
            } else if (Le) {
              if (this.prev < Ce.catchLoc) return he(Ce.catchLoc, !0);
            } else {
              if (!Te) throw Error("try statement without catch or finally");
              if (this.prev < Ce.finallyLoc) return he(Ce.finallyLoc);
            }
          }
        }
      },
      abrupt: function(ee, de) {
        for (var he = this.tryEntries.length - 1; he >= 0; --he) {
          var pe = this.tryEntries[he];
          if (pe.tryLoc <= this.prev && l.call(pe, "finallyLoc") && this.prev < pe.finallyLoc) {
            var Ce = pe;
            break;
          }
        }
        Ce && (ee === "break" || ee === "continue") && Ce.tryLoc <= de && de <= Ce.finallyLoc && (Ce = null);
        var _e = Ce ? Ce.completion : {};
        return _e.type = ee, _e.arg = de, Ce ? (this.method = "next", this.next = Ce.finallyLoc, w) : this.complete(_e);
      },
      complete: function(ee, de) {
        if (ee.type === "throw") throw ee.arg;
        return ee.type === "break" || ee.type === "continue" ? this.next = ee.arg : ee.type === "return" ? (this.rval = this.arg = ee.arg, this.method = "return", this.next = "end") : ee.type === "normal" && de && (this.next = de), w;
      },
      finish: function(ee) {
        for (var de = this.tryEntries.length - 1; de >= 0; --de) {
          var he = this.tryEntries[de];
          if (he.finallyLoc === ee) return this.complete(he.completion, he.afterLoc), V(he), w;
        }
      },
      catch: function(ee) {
        for (var de = this.tryEntries.length - 1; de >= 0; --de) {
          var he = this.tryEntries[de];
          if (he.tryLoc === ee) {
            var pe = he.completion;
            if (pe.type === "throw") {
              var Ce = pe.arg;
              V(he);
            }
            return Ce;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function(ee, de, he) {
        return this.delegate = {
          iterator: ue(ee),
          resultName: de,
          nextLoc: he
        }, this.method === "next" && (this.arg = u), w;
      }
    }, h;
  }
  t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})(hX);
var FIe = hX.exports, $0 = FIe(), GIe = $0;
try {
  regeneratorRuntime = $0;
} catch {
  typeof globalThis == "object" ? globalThis.regeneratorRuntime = $0 : Function("r", "regeneratorRuntime = r")($0);
}
const vc = /* @__PURE__ */ Gl(GIe);
var VIe = ["src", "alt", "className"];
function YN() {
  return YN = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a)
        Object.prototype.hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, YN.apply(this, arguments);
}
function YIe(t, r) {
  if (t == null) return {};
  var a = {}, u = Object.keys(t), h, b;
  for (b = 0; b < u.length; b++)
    h = u[b], !(r.indexOf(h) >= 0) && (a[h] = t[h]);
  return a;
}
function rh(t) {
  var r = t.src, a = t.alt, u = t.className, h = YIe(t, VIe), b = En("callkit-component-avatar", u);
  return /* @__PURE__ */ _t.createElement("div", YN({
    className: b
  }, h), /* @__PURE__ */ _t.createElement("img", {
    src: r,
    alt: a,
    draggable: !1
  }));
}
var XIe = ["className", "circle", "children", "right", "danger", "primary"];
function XN() {
  return XN = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a)
        Object.prototype.hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, XN.apply(this, arguments);
}
function WIe(t, r) {
  if (t == null) return {};
  var a = {}, u = Object.keys(t), h, b;
  for (b = 0; b < u.length; b++)
    h = u[b], !(r.indexOf(h) >= 0) && (a[h] = t[h]);
  return a;
}
function Yi(t) {
  var r = t.className, a = t.circle, u = t.children, h = t.right, b = t.danger, l = t.primary, v = WIe(t, XIe), s = En("callkit-component-button", {
    "callkit-component-button-circle": !!a,
    "callkit-root-button-right": !!h,
    "callkit-root-button-danger": !!b,
    "callkit-root-button-primary": !!l,
    "callkit-root-button-default": !l && !b && !h
  }, r);
  return /* @__PURE__ */ _t.createElement("button", XN({
    className: s
  }, v), u);
}
const _d = "data:image/png;base64,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";
var pX = { exports: {} };
(function(t, r) {
  (function(a, u) {
    t.exports = u();
  })(rn, function() {
    function a(e, n) {
      return n.forEach(function(i) {
        i && typeof i != "string" && !Array.isArray(i) && Object.keys(i).forEach(function(o) {
          if (o !== "default" && !(o in e)) {
            var f = Object.getOwnPropertyDescriptor(i, o);
            Object.defineProperty(e, o, f.get ? f : { enumerable: !0, get: function() {
              return i[o];
            } });
          }
        });
      }), Object.freeze(e);
    }
    var u = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof rn < "u" ? rn : typeof self < "u" ? self : {};
    function h(e) {
      return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    var b = function(e) {
      try {
        return !!e();
      } catch {
        return !0;
      }
    }, l = !b(function() {
      var e = (function() {
      }).bind();
      return typeof e != "function" || e.hasOwnProperty("prototype");
    }), v = l, s = Function.prototype, c = s.call, d = v && s.bind.bind(c, c), p = v ? d : function(e) {
      return function() {
        return c.apply(e, arguments);
      };
    }, m = p({}.isPrototypeOf), E = function(e) {
      return e && e.Math == Math && e;
    }, y = E(typeof globalThis == "object" && globalThis) || E(typeof window == "object" && window) || E(typeof self == "object" && self) || E(typeof u == "object" && u) || /* @__PURE__ */ function() {
      return this;
    }() || u || Function("return this")(), g = l, C = Function.prototype, O = C.apply, N = C.call, w = typeof Reflect == "object" && Reflect.apply || (g ? N.bind(O) : function() {
      return N.apply(O, arguments);
    }), _ = p, I = _({}.toString), k = _("".slice), H = function(e) {
      return k(I(e), 8, -1);
    }, S = H, B = p, D = function(e) {
      if (S(e) === "Function") return B(e);
    }, F = typeof document == "object" && document.all, j = { all: F, IS_HTMLDDA: F === void 0 && F !== void 0 }, G = j.all, U = j.IS_HTMLDDA ? function(e) {
      return typeof e == "function" || e === G;
    } : function(e) {
      return typeof e == "function";
    }, M = {}, V = !b(function() {
      return Object.defineProperty({}, 1, { get: function() {
        return 7;
      } })[1] != 7;
    }), J = l, ue = Function.prototype.call, se = J ? ue.bind(ue) : function() {
      return ue.apply(ue, arguments);
    }, ee = {}, de = {}.propertyIsEnumerable, he = Object.getOwnPropertyDescriptor, pe = he && !de.call({ 1: 2 }, 1);
    ee.f = pe ? function(e) {
      var n = he(this, e);
      return !!n && n.enumerable;
    } : de;
    var Ce, _e, Le = function(e, n) {
      return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: n };
    }, Te = b, K = H, Oe = Object, Pe = p("".split), xe = Te(function() {
      return !Oe("z").propertyIsEnumerable(0);
    }) ? function(e) {
      return K(e) == "String" ? Pe(e, "") : Oe(e);
    } : Oe, be = function(e) {
      return e == null;
    }, $e = be, Be = TypeError, Ke = function(e) {
      if ($e(e)) throw Be("Can't call method on " + e);
      return e;
    }, Ze = xe, at = Ke, pt = function(e) {
      return Ze(at(e));
    }, It = U, Rt = j.all, gt = j.IS_HTMLDDA ? function(e) {
      return typeof e == "object" ? e !== null : It(e) || e === Rt;
    } : function(e) {
      return typeof e == "object" ? e !== null : It(e);
    }, it = {}, Tt = it, Ut = y, st = U, Ot = function(e) {
      return st(e) ? e : void 0;
    }, kt = function(e, n) {
      return arguments.length < 2 ? Ot(Tt[e]) || Ot(Ut[e]) : Tt[e] && Tt[e][n] || Ut[e] && Ut[e][n];
    }, wt = typeof navigator < "u" && String(navigator.userAgent) || "", Et = y, ut = wt, St = Et.process, Ft = Et.Deno, Ht = St && St.versions || Ft && Ft.version, zt = Ht && Ht.v8;
    zt && (_e = (Ce = zt.split("."))[0] > 0 && Ce[0] < 4 ? 1 : +(Ce[0] + Ce[1])), !_e && ut && (!(Ce = ut.match(/Edge\/(\d+)/)) || Ce[1] >= 74) && (Ce = ut.match(/Chrome\/(\d+)/)) && (_e = +Ce[1]);
    var ze = _e, Ne = ze, le = b, X = y.String, re = !!Object.getOwnPropertySymbols && !le(function() {
      var e = Symbol();
      return !X(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Ne && Ne < 41;
    }), Me = re && !Symbol.sham && typeof Symbol.iterator == "symbol", Se = kt, ke = U, Ge = m, nt = Object, rt = Me ? function(e) {
      return typeof e == "symbol";
    } : function(e) {
      var n = Se("Symbol");
      return ke(n) && Ge(n.prototype, nt(e));
    }, dt = String, lt = function(e) {
      try {
        return dt(e);
      } catch {
        return "Object";
      }
    }, Ct = U, Ie = lt, x = TypeError, ae = function(e) {
      if (Ct(e)) return e;
      throw x(Ie(e) + " is not a function");
    }, Q = ae, Z = be, ge = function(e, n) {
      var i = e[n];
      return Z(i) ? void 0 : Q(i);
    }, me = se, ve = U, ie = gt, ye = TypeError, Ye = { exports: {} }, ne = y, Qe = Object.defineProperty, W = function(e, n) {
      try {
        Qe(ne, e, { value: n, configurable: !0, writable: !0 });
      } catch {
        ne[e] = n;
      }
      return n;
    }, ce = "__core-js_shared__", fe = y[ce] || W(ce, {}), we = fe;
    (Ye.exports = function(e, n) {
      return we[e] || (we[e] = n !== void 0 ? n : {});
    })("versions", []).push({ version: "3.31.1", mode: "pure", copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.31.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    var Fe = Ye.exports, je = Ke, qe = Object, et = function(e) {
      return qe(je(e));
    }, bt = et, ot = p({}.hasOwnProperty), Lt = Object.hasOwn || function(e, n) {
      return ot(bt(e), n);
    }, Kt = p, $t = 0, yt = Math.random(), Wt = Kt(1 .toString), In = function(e) {
      return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Wt(++$t + yt, 36);
    }, gn = Fe, zn = Lt, Xn = In, yr = re, ur = Me, Yn = y.Symbol, xi = gn("wks"), gs = ur ? Yn.for || Yn : Yn && Yn.withoutSetter || Xn, Or = function(e) {
      return zn(xi, e) || (xi[e] = yr && zn(Yn, e) ? Yn[e] : gs("Symbol." + e)), xi[e];
    }, da = se, Za = gt, js = rt, Fs = ge, la = function(e, n) {
      var i, o;
      if (ve(i = e.toString) && !ie(o = me(i, e)) || ve(i = e.valueOf) && !ie(o = me(i, e))) return o;
      throw ye("Can't convert object to primitive value");
    }, Gs = TypeError, ka = Or("toPrimitive"), Vs = function(e, n) {
      if (!Za(e) || js(e)) return e;
      var i, o = Fs(e, ka);
      if (o) {
        if (i = da(o, e, n), !Za(i) || js(i)) return i;
        throw Gs("Can't convert object to primitive value");
      }
      return la(e);
    }, ja = rt, Xt = function(e) {
      var n = Vs(e, "string");
      return ja(n) ? n : n + "";
    }, Wn = gt, Mt = y.document, Nc = Wn(Mt) && Wn(Mt.createElement), To = function(e) {
      return Nc ? Mt.createElement(e) : {};
    }, ou = To, Ku = !V && !b(function() {
      return Object.defineProperty(ou("div"), "a", { get: function() {
        return 7;
      } }).a != 7;
    }), cu = V, bo = se, Ju = ee, Yo = Le, Xo = pt, Bd = Xt, zd = Lt, wc = Ku, Qa = Object.getOwnPropertyDescriptor;
    M.f = cu ? Qa : function(e, n) {
      if (e = Xo(e), n = Bd(n), wc) try {
        return Qa(e, n);
      } catch {
      }
      if (zd(e, n)) return Yo(!bo(Ju.f, e, n), e[n]);
    };
    var Ql = b, $l = U, ef = /#|\.prototype\./, Ua = function(e, n) {
      var i = nf[tf(e)];
      return i == Wo || i != Zu && ($l(n) ? Ql(n) : !!n);
    }, tf = Ua.normalize = function(e) {
      return String(e).replace(ef, ".").toLowerCase();
    }, nf = Ua.data = {}, Zu = Ua.NATIVE = "N", Wo = Ua.POLYFILL = "P", Qu = Ua, rf = ae, $u = l, qo = D(D.bind), ba = function(e, n) {
      return rf(e), n === void 0 ? e : $u ? qo(e, n) : function() {
        return e.apply(n, arguments);
      };
    }, Ts = {}, Fd = V && b(function() {
      return Object.defineProperty(function() {
      }, "prototype", { value: 42, writable: !1 }).prototype != 42;
    }), Kr = gt, uu = String, Ko = TypeError, Zi = function(e) {
      if (Kr(e)) return e;
      throw Ko(uu(e) + " is not an object");
    }, Hr = V, Di = Ku, os = Fd, Aa = Zi, Ao = Xt, Hi = TypeError, Qi = Object.defineProperty, Ha = Object.getOwnPropertyDescriptor, ed = "enumerable", Ei = "configurable", cs = "writable";
    Ts.f = Hr ? os ? function(e, n, i) {
      if (Aa(e), n = Ao(n), Aa(i), typeof e == "function" && n === "prototype" && "value" in i && cs in i && !i[cs]) {
        var o = Ha(e, n);
        o && o[cs] && (e[n] = i.value, i = { configurable: Ei in i ? i[Ei] : o[Ei], enumerable: ed in i ? i[ed] : o[ed], writable: !1 });
      }
      return Qi(e, n, i);
    } : Qi : function(e, n, i) {
      if (Aa(e), n = Ao(n), Aa(i), Di) try {
        return Qi(e, n, i);
      } catch {
      }
      if ("get" in i || "set" in i) throw Hi("Accessors not supported");
      return "value" in i && (e[n] = i.value), e;
    };
    var ci = Ts, bs = Le, Oa = V ? function(e, n, i) {
      return ci.f(e, n, bs(1, i));
    } : function(e, n, i) {
      return e[n] = i, e;
    }, Gd = y, CX = w, SX = D, IX = U, RX = M.f, NX = Qu, Ih = it, wX = ba, Rh = Oa, h_ = Lt, _X = function(e) {
      var n = function(i, o, f) {
        if (this instanceof n) {
          switch (arguments.length) {
            case 0:
              return new e();
            case 1:
              return new e(i);
            case 2:
              return new e(i, o);
          }
          return new e(i, o, f);
        }
        return CX(e, this, arguments);
      };
      return n.prototype = e.prototype, n;
    }, _r = function(e, n) {
      var i, o, f, T, A, R, P, L, z, Y = e.target, te = e.global, oe = e.stat, He = e.proto, Re = te ? Gd : oe ? Gd[Y] : (Gd[Y] || {}).prototype, De = te ? Ih : Ih[Y] || Rh(Ih, Y, {})[Y], Xe = De.prototype;
      for (T in n) o = !(i = NX(te ? T : Y + (oe ? "." : "#") + T, e.forced)) && Re && h_(Re, T), R = De[T], o && (P = e.dontCallGetSet ? (z = RX(Re, T)) && z.value : Re[T]), A = o && P ? P : n[T], o && typeof R == typeof A || (L = e.bind && o ? wX(A, Gd) : e.wrap && o ? _X(A) : He && IX(A) ? SX(A) : A, (e.sham || A && A.sham || R && R.sham) && Rh(L, "sham", !0), Rh(De, T, L), He && (h_(Ih, f = Y + "Prototype") || Rh(Ih, f, {}), Rh(Ih[f], T, A), e.real && Xe && (i || !Xe[T]) && Rh(Xe, T, A)));
    }, PX = Math.ceil, xX = Math.floor, DX = Math.trunc || function(e) {
      var n = +e;
      return (n > 0 ? xX : PX)(n);
    }, MX = DX, UA = function(e) {
      var n = +e;
      return n != n || n === 0 ? 0 : MX(n);
    }, LX = UA, kX = Math.max, jX = Math.min, HA = function(e, n) {
      var i = LX(e);
      return i < 0 ? kX(i + n, 0) : jX(i, n);
    }, UX = UA, HX = Math.min, p_ = function(e) {
      return e > 0 ? HX(UX(e), 9007199254740991) : 0;
    }, BX = p_, td = function(e) {
      return BX(e.length);
    }, zX = pt, FX = HA, GX = td, g_ = function(e) {
      return function(n, i, o) {
        var f, T = zX(n), A = GX(T), R = FX(o, A);
        if (e && i != i) {
          for (; A > R; ) if ((f = T[R++]) != f) return !0;
        } else for (; A > R; R++) if ((e || R in T) && T[R] === i) return e || R || 0;
        return !e && -1;
      };
    }, BA = { includes: g_(!0), indexOf: g_(!1) }, VX = BA.includes;
    _r({ target: "Array", proto: !0, forced: b(function() {
      return !Array(1).includes();
    }) }, { includes: function(e) {
      return VX(this, e, arguments.length > 1 ? arguments[1] : void 0);
    } });
    var YX = it, Jo = function(e) {
      return YX[e + "Prototype"];
    }, XX = Jo("Array").includes, WX = gt, qX = H, KX = Or("match"), m_ = function(e) {
      var n;
      return WX(e) && ((n = e[KX]) !== void 0 ? !!n : qX(e) == "RegExp");
    }, JX = m_, ZX = TypeError, E_ = {};
    E_[Or("toStringTag")] = "z";
    var zA = String(E_) === "[object z]", QX = zA, $X = U, Gv = H, eW = Or("toStringTag"), tW = Object, nW = Gv(/* @__PURE__ */ function() {
      return arguments;
    }()) == "Arguments", du = QX ? Gv : function(e) {
      var n, i, o;
      return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (i = function(f, T) {
        try {
          return f[T];
        } catch {
        }
      }(n = tW(e), eW)) == "string" ? i : nW ? Gv(n) : (o = Gv(n)) == "Object" && $X(n.callee) ? "Arguments" : o;
    }, rW = du, iW = String, Oo = function(e) {
      if (rW(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
      return iW(e);
    }, sW = Or("match"), aW = _r, oW = function(e) {
      if (JX(e)) throw ZX("The method doesn't accept regular expressions");
      return e;
    }, cW = Ke, y_ = Oo, uW = function(e) {
      var n = /./;
      try {
        "/./"[e](n);
      } catch {
        try {
          return n[sW] = !1, "/./"[e](n);
        } catch {
        }
      }
      return !1;
    }, dW = p("".indexOf);
    aW({ target: "String", proto: !0, forced: !uW("includes") }, { includes: function(e) {
      return !!~dW(y_(cW(this)), y_(oW(e)), arguments.length > 1 ? arguments[1] : void 0);
    } });
    var lW = Jo("String").includes, v_ = m, fW = XX, hW = lW, FA = Array.prototype, GA = String.prototype, pW = function(e) {
      var n = e.includes;
      return e === FA || v_(FA, e) && n === FA.includes ? fW : typeof e == "string" || e === GA || v_(GA, e) && n === GA.includes ? hW : n;
    }, on = h(pW), gW = ae, mW = et, EW = xe, yW = td, vW = TypeError, T_ = function(e) {
      return function(n, i, o, f) {
        gW(i);
        var T = mW(n), A = EW(T), R = yW(T), P = e ? R - 1 : 0, L = e ? -1 : 1;
        if (o < 2) for (; ; ) {
          if (P in A) {
            f = A[P], P += L;
            break;
          }
          if (P += L, e ? P < 0 : R <= P) throw vW("Reduce of empty array with no initial value");
        }
        for (; e ? P >= 0 : R > P; P += L) P in A && (f = i(f, A[P], P, T));
        return f;
      };
    }, TW = { left: T_(!1), right: T_(!0) }, bW = b, Vv = function(e, n) {
      var i = [][e];
      return !!i && bW(function() {
        i.call(null, n || function() {
          return 1;
        }, 1);
      });
    }, Nh = typeof process < "u" && H(process) == "process", AW = TW.left;
    _r({ target: "Array", proto: !0, forced: !Nh && ze > 79 && ze < 83 || !Vv("reduce") }, { reduce: function(e) {
      var n = arguments.length;
      return AW(this, e, n, n > 1 ? arguments[1] : void 0);
    } });
    var OW = Jo("Array").reduce, CW = m, SW = OW, VA = Array.prototype, IW = function(e) {
      var n = e.reduce;
      return e === VA || CW(VA, e) && n === VA.reduce ? SW : n;
    }, b_ = IW, _c = h(b_), RW = H, qm = Array.isArray || function(e) {
      return RW(e) == "Array";
    }, NW = _r, wW = qm, _W = p([].reverse), A_ = [1, 2];
    NW({ target: "Array", proto: !0, forced: String(A_) === String(A_.reverse()) }, { reverse: function() {
      return wW(this) && (this.length = this.length), _W(this);
    } });
    var PW = Jo("Array").reverse, xW = m, DW = PW, YA = Array.prototype, MW = function(e) {
      var n = e.reverse;
      return e === YA || xW(YA, e) && n === YA.reverse ? DW : n;
    }, O_ = MW, LW = h(O_), kW = In, C_ = Fe("keys"), Yv = function(e) {
      return C_[e] || (C_[e] = kW(e));
    }, jW = !b(function() {
      function e() {
      }
      return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
    }), UW = Lt, HW = U, BW = et, zW = jW, S_ = Yv("IE_PROTO"), XA = Object, FW = XA.prototype, WA = zW ? XA.getPrototypeOf : function(e) {
      var n = BW(e);
      if (UW(n, S_)) return n[S_];
      var i = n.constructor;
      return HW(i) && n instanceof i ? i.prototype : n instanceof XA ? FW : null;
    }, GW = p, VW = ae, YW = U, XW = String, WW = TypeError, qW = function(e, n, i) {
      try {
        return GW(VW(Object.getOwnPropertyDescriptor(e, n)[i]));
      } catch {
      }
    }, KW = Zi, JW = function(e) {
      if (typeof e == "object" || YW(e)) return e;
      throw WW("Can't set " + XW(e) + " as a prototype");
    }, ZW = Object.setPrototypeOf || ("__proto__" in {} ? function() {
      var e, n = !1, i = {};
      try {
        (e = qW(Object.prototype, "__proto__", "set"))(i, []), n = i instanceof Array;
      } catch {
      }
      return function(o, f) {
        return KW(o), JW(f), n ? e(o, f) : o.__proto__ = f, o;
      };
    }() : void 0), Xv = {}, Wv = {}, qA = Lt, QW = pt, $W = BA.indexOf, eq = Wv, I_ = p([].push), R_ = function(e, n) {
      var i, o = QW(e), f = 0, T = [];
      for (i in o) !qA(eq, i) && qA(o, i) && I_(T, i);
      for (; n.length > f; ) qA(o, i = n[f++]) && (~$W(T, i) || I_(T, i));
      return T;
    }, KA = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"], tq = R_, nq = KA.concat("length", "prototype");
    Xv.f = Object.getOwnPropertyNames || function(e) {
      return tq(e, nq);
    };
    var Km = {};
    Km.f = Object.getOwnPropertySymbols;
    var rq = kt, iq = Xv, sq = Km, aq = Zi, oq = p([].concat), cq = rq("Reflect", "ownKeys") || function(e) {
      var n = iq.f(aq(e)), i = sq.f;
      return i ? oq(n, i(e)) : n;
    }, N_ = Lt, uq = cq, dq = M, lq = Ts, JA = {}, fq = R_, hq = KA, qv = Object.keys || function(e) {
      return fq(e, hq);
    }, pq = V, gq = Fd, mq = Ts, Eq = Zi, yq = pt, vq = qv;
    JA.f = pq && !gq ? Object.defineProperties : function(e, n) {
      Eq(e);
      for (var i, o = yq(n), f = vq(n), T = f.length, A = 0; T > A; ) mq.f(e, i = f[A++], o[i]);
      return e;
    };
    var Kv, w_ = kt("document", "documentElement"), Tq = Zi, bq = JA, __ = KA, Aq = Wv, Oq = w_, Cq = To, ZA = "prototype", QA = "script", P_ = Yv("IE_PROTO"), $A = function() {
    }, x_ = function(e) {
      return "<" + QA + ">" + e + "</" + QA + ">";
    }, D_ = function(e) {
      e.write(x_("")), e.close();
      var n = e.parentWindow.Object;
      return e = null, n;
    }, Jv = function() {
      try {
        Kv = new ActiveXObject("htmlfile");
      } catch {
      }
      var e, n, i;
      Jv = typeof document < "u" ? document.domain && Kv ? D_(Kv) : (n = Cq("iframe"), i = "java" + QA + ":", n.style.display = "none", Oq.appendChild(n), n.src = String(i), (e = n.contentWindow.document).open(), e.write(x_("document.F=Object")), e.close(), e.F) : D_(Kv);
      for (var o = __.length; o--; ) delete Jv[ZA][__[o]];
      return Jv();
    };
    Aq[P_] = !0;
    var Jm = Object.create || function(e, n) {
      var i;
      return e !== null ? ($A[ZA] = Tq(e), i = new $A(), $A[ZA] = null, i[P_] = e) : i = Jv(), n === void 0 ? i : bq.f(i, n);
    }, Sq = gt, Iq = Oa, M_ = Error, Rq = p("".replace), Nq = String(M_("zxcasd").stack), L_ = /\n\s*at [^:]*:[^\n]*/, wq = L_.test(Nq), _q = Le, Pq = !b(function() {
      var e = Error("a");
      return !("stack" in e) || (Object.defineProperty(e, "stack", _q(1, 7)), e.stack !== 7);
    }), xq = Oa, Dq = function(e, n) {
      if (wq && typeof e == "string" && !M_.prepareStackTrace) for (; n--; ) e = Rq(e, L_, "");
      return e;
    }, Mq = Pq, k_ = Error.captureStackTrace, sf = {}, Lq = sf, kq = Or("iterator"), jq = Array.prototype, j_ = function(e) {
      return e !== void 0 && (Lq.Array === e || jq[kq] === e);
    }, Uq = du, U_ = ge, Hq = be, Bq = sf, zq = Or("iterator"), Zv = function(e) {
      if (!Hq(e)) return U_(e, zq) || U_(e, "@@iterator") || Bq[Uq(e)];
    }, Fq = se, Gq = ae, Vq = Zi, Yq = lt, Xq = Zv, Wq = TypeError, eO = function(e, n) {
      var i = arguments.length < 2 ? Xq(e) : n;
      if (Gq(i)) return Vq(Fq(i, e));
      throw Wq(Yq(e) + " is not iterable");
    }, Kq = se, H_ = Zi, Jq = ge, B_ = function(e, n, i) {
      var o, f;
      H_(e);
      try {
        if (!(o = Jq(e, "return"))) {
          if (n === "throw") throw i;
          return i;
        }
        o = Kq(o, e);
      } catch (T) {
        f = !0, o = T;
      }
      if (n === "throw") throw i;
      if (f) throw o;
      return H_(o), i;
    }, Zq = ba, Qq = se, $q = Zi, eK = lt, tK = j_, nK = td, z_ = m, rK = eO, iK = Zv, F_ = B_, sK = TypeError, Qv = function(e, n) {
      this.stopped = e, this.result = n;
    }, G_ = Qv.prototype, Zm = function(e, n, i) {
      var o, f, T, A, R, P, L, z = i && i.that, Y = !(!i || !i.AS_ENTRIES), te = !(!i || !i.IS_RECORD), oe = !(!i || !i.IS_ITERATOR), He = !(!i || !i.INTERRUPTED), Re = Zq(n, z), De = function(We) {
        return o && F_(o, "normal", We), new Qv(!0, We);
      }, Xe = function(We) {
        return Y ? ($q(We), He ? Re(We[0], We[1], De) : Re(We[0], We[1])) : He ? Re(We, De) : Re(We);
      };
      if (te) o = e.iterator;
      else if (oe) o = e;
      else {
        if (!(f = iK(e))) throw sK(eK(e) + " is not iterable");
        if (tK(f)) {
          for (T = 0, A = nK(e); A > T; T++) if ((R = Xe(e[T])) && z_(G_, R)) return R;
          return new Qv(!1);
        }
        o = rK(e, f);
      }
      for (P = te ? e.next : o.next; !(L = Qq(P, o)).done; ) {
        try {
          R = Xe(L.value);
        } catch (We) {
          F_(o, "throw", We);
        }
        if (typeof R == "object" && R && z_(G_, R)) return R;
      }
      return new Qv(!1);
    }, aK = Oo, oK = _r, cK = m, uK = WA, $v = ZW, dK = function(e, n, i) {
      for (var o = uq(n), f = lq.f, T = dq.f, A = 0; A < o.length; A++) {
        var R = o[A];
        N_(e, R) || N_(i, R) || f(e, R, T(n, R));
      }
    }, V_ = Jm, tO = Oa, nO = Le, lK = function(e, n) {
      Sq(n) && "cause" in n && Iq(e, "cause", n.cause);
    }, fK = function(e, n, i, o) {
      Mq && (k_ ? k_(e, n) : xq(e, "stack", Dq(i, o)));
    }, hK = Zm, pK = function(e, n) {
      return e === void 0 ? arguments.length < 2 ? "" : n : aK(e);
    }, gK = Or("toStringTag"), e1 = Error, mK = [].push, wh = function(e, n) {
      var i, o = cK(rO, this);
      $v ? i = $v(e1(), o ? uK(this) : rO) : (i = o ? this : V_(rO), tO(i, gK, "Error")), n !== void 0 && tO(i, "message", pK(n)), fK(i, wh, i.stack, 1), arguments.length > 2 && lK(i, arguments[2]);
      var f = [];
      return hK(e, mK, { that: f }), tO(i, "errors", f), i;
    };
    $v ? $v(wh, e1) : dK(wh, e1, { name: !0 });
    var rO = wh.prototype = V_(e1.prototype, { constructor: nO(1, wh), message: nO(1, ""), name: nO(1, "AggregateError") });
    oK({ global: !0, constructor: !0, arity: 2 }, { AggregateError: wh });
    var t1, Qm, n1, EK = U, Y_ = y.WeakMap, yK = EK(Y_) && /native code/.test(String(Y_)), X_ = y, vK = gt, TK = Oa, iO = Lt, sO = fe, bK = Yv, AK = Wv, W_ = "Object already initialized", aO = X_.TypeError, OK = X_.WeakMap;
    if (yK || sO.state) {
      var lu = sO.state || (sO.state = new OK());
      lu.get = lu.get, lu.has = lu.has, lu.set = lu.set, t1 = function(e, n) {
        if (lu.has(e)) throw aO(W_);
        return n.facade = e, lu.set(e, n), n;
      }, Qm = function(e) {
        return lu.get(e) || {};
      }, n1 = function(e) {
        return lu.has(e);
      };
    } else {
      var _h = bK("state");
      AK[_h] = !0, t1 = function(e, n) {
        if (iO(e, _h)) throw aO(W_);
        return n.facade = e, TK(e, _h, n), n;
      }, Qm = function(e) {
        return iO(e, _h) ? e[_h] : {};
      }, n1 = function(e) {
        return iO(e, _h);
      };
    }
    var af, q_, K_, of = { set: t1, get: Qm, has: n1, enforce: function(e) {
      return n1(e) ? Qm(e) : t1(e, {});
    }, getterFor: function(e) {
      return function(n) {
        var i;
        if (!vK(n) || (i = Qm(n)).type !== e) throw aO("Incompatible receiver, " + e + " required");
        return i;
      };
    } }, oO = V, CK = Lt, J_ = Function.prototype, SK = oO && Object.getOwnPropertyDescriptor, cO = CK(J_, "name"), Z_ = { EXISTS: cO, PROPER: cO && (function() {
    }).name === "something", CONFIGURABLE: cO && (!oO || oO && SK(J_, "name").configurable) }, IK = Oa, Vd = function(e, n, i, o) {
      return o && o.enumerable ? e[n] = i : IK(e, n, i), e;
    }, RK = b, NK = U, wK = gt, _K = Jm, Q_ = WA, PK = Vd, uO = Or("iterator"), $_ = !1;
    [].keys && ("next" in (K_ = [].keys()) ? (q_ = Q_(Q_(K_))) !== Object.prototype && (af = q_) : $_ = !0);
    var xK = !wK(af) || RK(function() {
      var e = {};
      return af[uO].call(e) !== e;
    });
    NK((af = xK ? {} : _K(af))[uO]) || PK(af, uO, function() {
      return this;
    });
    var eP = { IteratorPrototype: af, BUGGY_SAFARI_ITERATORS: $_ }, DK = du, MK = zA ? {}.toString : function() {
      return "[object " + DK(this) + "]";
    }, LK = zA, kK = Ts.f, jK = Oa, UK = Lt, HK = MK, tP = Or("toStringTag"), Yd = function(e, n, i, o) {
      if (e) {
        var f = i ? e : e.prototype;
        UK(f, tP) || kK(f, tP, { configurable: !0, value: n }), o && !LK && jK(f, "toString", HK);
      }
    }, BK = eP.IteratorPrototype, zK = Jm, FK = Le, GK = Yd, VK = sf, YK = function() {
      return this;
    }, dO = function(e, n, i, o) {
      var f = n + " Iterator";
      return e.prototype = zK(BK, { next: FK(+!o, i) }), GK(e, f, !1, !0), VK[f] = YK, e;
    }, XK = _r, WK = se, qK = Z_, KK = dO, JK = WA, ZK = Yd, nP = Vd, rP = sf, QK = eP, $K = qK.PROPER, r1 = QK.BUGGY_SAFARI_ITERATORS, lO = Or("iterator"), iP = "keys", i1 = "values", sP = "entries", eJ = function() {
      return this;
    }, aP = function(e, n, i, o, f, T, A) {
      KK(i, n, o);
      var R, P, L, z = function(Xe) {
        if (Xe === f && Re) return Re;
        if (!r1 && Xe in oe) return oe[Xe];
        switch (Xe) {
          case iP:
          case i1:
          case sP:
            return function() {
              return new i(this, Xe);
            };
        }
        return function() {
          return new i(this);
        };
      }, Y = n + " Iterator", te = !1, oe = e.prototype, He = oe[lO] || oe["@@iterator"] || f && oe[f], Re = !r1 && He || z(f), De = n == "Array" && oe.entries || He;
      if (De && (R = JK(De.call(new e()))) !== Object.prototype && R.next && (ZK(R, Y, !0, !0), rP[Y] = eJ), $K && f == i1 && He && He.name !== i1 && (te = !0, Re = function() {
        return WK(He, this);
      }), f) if (P = { values: z(i1), keys: T ? Re : z(iP), entries: z(sP) }, A) for (L in P) (r1 || te || !(L in oe)) && nP(oe, L, P[L]);
      else XK({ target: n, proto: !0, forced: r1 || te }, P);
      return A && oe[lO] !== Re && nP(oe, lO, Re, { name: f }), rP[n] = Re, P;
    }, fO = function(e, n) {
      return { value: e, done: n };
    }, tJ = pt, oP = sf, cP = of;
    Ts.f;
    var nJ = aP, uP = fO, dP = "Array Iterator", rJ = cP.set, iJ = cP.getterFor(dP);
    nJ(Array, "Array", function(e, n) {
      rJ(this, { type: dP, target: tJ(e), index: 0, kind: n });
    }, function() {
      var e = iJ(this), n = e.target, i = e.kind, o = e.index++;
      return !n || o >= n.length ? (e.target = void 0, uP(void 0, !0)) : uP(i == "keys" ? o : i == "values" ? n[o] : [o, n[o]], !1);
    }, "values"), oP.Arguments = oP.Array;
    var sJ = Ts, s1 = function(e, n, i) {
      return sJ.f(e, n, i);
    }, aJ = kt, oJ = s1, cJ = V, lP = Or("species"), uJ = m, dJ = TypeError, hO = function(e, n) {
      if (uJ(n, e)) return e;
      throw dJ("Incorrect invocation");
    }, lJ = U, pO = fe, fJ = p(Function.toString);
    lJ(pO.inspectSource) || (pO.inspectSource = function(e) {
      return fJ(e);
    });
    var fP = pO.inspectSource, hJ = p, pJ = b, hP = U, gJ = du, mJ = fP, pP = function() {
    }, EJ = [], gP = kt("Reflect", "construct"), gO = /^\s*(?:class|function)\b/, yJ = hJ(gO.exec), vJ = !gO.exec(pP), $m = function(e) {
      if (!hP(e)) return !1;
      try {
        return gP(pP, EJ, e), !0;
      } catch {
        return !1;
      }
    }, mP = function(e) {
      if (!hP(e)) return !1;
      switch (gJ(e)) {
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
          return !1;
      }
      try {
        return vJ || !!yJ(gO, mJ(e));
      } catch {
        return !0;
      }
    };
    mP.sham = !0;
    var eE, Ph, EP, mO, a1 = !gP || pJ(function() {
      var e;
      return $m($m.call) || !$m(Object) || !$m(function() {
        e = !0;
      }) || e;
    }) ? mP : $m, TJ = a1, bJ = lt, AJ = TypeError, yP = Zi, OJ = function(e) {
      if (TJ(e)) return e;
      throw AJ(bJ(e) + " is not a constructor");
    }, CJ = be, SJ = Or("species"), EO = function(e, n) {
      var i, o = yP(e).constructor;
      return o === void 0 || CJ(i = yP(o)[SJ]) ? n : OJ(i);
    }, o1 = p([].slice), IJ = TypeError, xh = function(e, n) {
      if (e < n) throw IJ("Not enough arguments");
      return e;
    }, vP = /(?:ipad|iphone|ipod).*applewebkit/i.test(wt), Co = y, RJ = w, NJ = ba, TP = U, wJ = Lt, bP = b, AP = w_, _J = o1, OP = To, PJ = xh, xJ = vP, DJ = Nh, yO = Co.setImmediate, vO = Co.clearImmediate, MJ = Co.process, TO = Co.Dispatch, LJ = Co.Function, CP = Co.MessageChannel, kJ = Co.String, bO = 0, tE = {}, SP = "onreadystatechange";
    bP(function() {
      eE = Co.location;
    });
    var AO = function(e) {
      if (wJ(tE, e)) {
        var n = tE[e];
        delete tE[e], n();
      }
    }, OO = function(e) {
      return function() {
        AO(e);
      };
    }, IP = function(e) {
      AO(e.data);
    }, RP = function(e) {
      Co.postMessage(kJ(e), eE.protocol + "//" + eE.host);
    };
    yO && vO || (yO = function(e) {
      PJ(arguments.length, 1);
      var n = TP(e) ? e : LJ(e), i = _J(arguments, 1);
      return tE[++bO] = function() {
        RJ(n, void 0, i);
      }, Ph(bO), bO;
    }, vO = function(e) {
      delete tE[e];
    }, DJ ? Ph = function(e) {
      MJ.nextTick(OO(e));
    } : TO && TO.now ? Ph = function(e) {
      TO.now(OO(e));
    } : CP && !xJ ? (mO = (EP = new CP()).port2, EP.port1.onmessage = IP, Ph = NJ(mO.postMessage, mO)) : Co.addEventListener && TP(Co.postMessage) && !Co.importScripts && eE && eE.protocol !== "file:" && !bP(RP) ? (Ph = RP, Co.addEventListener("message", IP, !1)) : Ph = SP in OP("script") ? function(e) {
      AP.appendChild(OP("script"))[SP] = function() {
        AP.removeChild(this), AO(e);
      };
    } : function(e) {
      setTimeout(OO(e), 0);
    });
    var c1 = { set: yO, clear: vO }, NP = function() {
      this.head = null, this.tail = null;
    };
    NP.prototype = { add: function(e) {
      var n = { item: e, next: null }, i = this.tail;
      i ? i.next = n : this.head = n, this.tail = n;
    }, get: function() {
      var e = this.head;
      if (e) return (this.head = e.next) === null && (this.tail = null), e.item;
    } };
    var Dh, CO, SO, IO, wP, _P = NP, jJ = /ipad|iphone|ipod/i.test(wt) && typeof Pebble < "u", UJ = /web0s(?!.*chrome)/i.test(wt), cf = y, PP = ba, HJ = M.f, RO = c1.set, BJ = _P, zJ = vP, FJ = jJ, GJ = UJ, NO = Nh, xP = cf.MutationObserver || cf.WebKitMutationObserver, DP = cf.document, MP = cf.process, u1 = cf.Promise, LP = HJ(cf, "queueMicrotask"), wO = LP && LP.value;
    if (!wO) {
      var d1 = new BJ(), l1 = function() {
        var e, n;
        for (NO && (e = MP.domain) && e.exit(); n = d1.get(); ) try {
          n();
        } catch (i) {
          throw d1.head && Dh(), i;
        }
        e && e.enter();
      };
      zJ || NO || GJ || !xP || !DP ? !FJ && u1 && u1.resolve ? ((IO = u1.resolve(void 0)).constructor = u1, wP = PP(IO.then, IO), Dh = function() {
        wP(l1);
      }) : NO ? Dh = function() {
        MP.nextTick(l1);
      } : (RO = PP(RO, cf), Dh = function() {
        RO(l1);
      }) : (CO = !0, SO = DP.createTextNode(""), new xP(l1).observe(SO, { characterData: !0 }), Dh = function() {
        SO.data = CO = !CO;
      }), wO = function(e) {
        d1.head || Dh(), d1.add(e);
      };
    }
    var kP = wO, Mh = function(e) {
      try {
        return { error: !1, value: e() };
      } catch (n) {
        return { error: !0, value: n };
      }
    }, uf = y.Promise, jP = typeof Deno == "object" && Deno && typeof Deno.version == "object", VJ = !jP && !Nh && typeof window == "object" && typeof document == "object", YJ = y, nE = uf, XJ = U, WJ = Qu, qJ = fP, KJ = Or, JJ = VJ, ZJ = jP, _O = ze, UP = nE && nE.prototype, QJ = KJ("species"), HP = !1, BP = XJ(YJ.PromiseRejectionEvent), $J = WJ("Promise", function() {
      var e = qJ(nE), n = e !== String(nE);
      if (!n && _O === 66 || !UP.catch || !UP.finally) return !0;
      if (!_O || _O < 51 || !/native code/.test(e)) {
        var i = new nE(function(f) {
          f(1);
        }), o = function(f) {
          f(function() {
          }, function() {
          });
        };
        if ((i.constructor = {})[QJ] = o, !(HP = i.then(function() {
        }) instanceof o)) return !0;
      }
      return !n && (JJ || ZJ) && !BP;
    }), rE = { CONSTRUCTOR: $J, REJECTION_EVENT: BP, SUBCLASSING: HP }, fu = {}, zP = ae, eZ = TypeError, tZ = function(e) {
      var n, i;
      this.promise = new e(function(o, f) {
        if (n !== void 0 || i !== void 0) throw eZ("Bad Promise constructor");
        n = o, i = f;
      }), this.resolve = zP(n), this.reject = zP(i);
    };
    fu.f = function(e) {
      return new tZ(e);
    };
    var PO, FP, nZ = _r, f1 = Nh, Xd = y, iE = se, rZ = Vd, iZ = Yd, sZ = function(e) {
      var n = aJ(e);
      cJ && n && !n[lP] && oJ(n, lP, { configurable: !0, get: function() {
        return this;
      } });
    }, aZ = ae, xO = U, oZ = gt, cZ = hO, uZ = EO, GP = c1.set, DO = kP, dZ = function(e, n) {
      try {
        arguments.length == 1 ? console.error(e) : console.error(e, n);
      } catch {
      }
    }, lZ = Mh, fZ = _P, VP = of, MO = uf, YP = rE, XP = fu, h1 = "Promise", WP = YP.CONSTRUCTOR, hZ = YP.REJECTION_EVENT, LO = VP.getterFor(h1), pZ = VP.set, gZ = MO && MO.prototype, sE = MO, kO = gZ, qP = Xd.TypeError, jO = Xd.document, UO = Xd.process, HO = XP.f, mZ = HO, EZ = !!(jO && jO.createEvent && Xd.dispatchEvent), KP = "unhandledrejection", JP = function(e) {
      var n;
      return !(!oZ(e) || !xO(n = e.then)) && n;
    }, ZP = function(e, n) {
      var i, o, f, T = n.value, A = n.state == 1, R = A ? e.ok : e.fail, P = e.resolve, L = e.reject, z = e.domain;
      try {
        R ? (A || (n.rejection === 2 && vZ(n), n.rejection = 1), R === !0 ? i = T : (z && z.enter(), i = R(T), z && (z.exit(), f = !0)), i === e.promise ? L(qP("Promise-chain cycle")) : (o = JP(i)) ? iE(o, i, P, L) : P(i)) : L(T);
      } catch (Y) {
        z && !f && z.exit(), L(Y);
      }
    }, QP = function(e, n) {
      e.notified || (e.notified = !0, DO(function() {
        for (var i, o = e.reactions; i = o.get(); ) ZP(i, e);
        e.notified = !1, n && !e.rejection && yZ(e);
      }));
    }, $P = function(e, n, i) {
      var o, f;
      EZ ? ((o = jO.createEvent("Event")).promise = n, o.reason = i, o.initEvent(e, !1, !0), Xd.dispatchEvent(o)) : o = { promise: n, reason: i }, !hZ && (f = Xd["on" + e]) ? f(o) : e === KP && dZ("Unhandled promise rejection", i);
    }, yZ = function(e) {
      iE(GP, Xd, function() {
        var n, i = e.facade, o = e.value;
        if (e3(e) && (n = lZ(function() {
          f1 ? UO.emit("unhandledRejection", o, i) : $P(KP, i, o);
        }), e.rejection = f1 || e3(e) ? 2 : 1, n.error)) throw n.value;
      });
    }, e3 = function(e) {
      return e.rejection !== 1 && !e.parent;
    }, vZ = function(e) {
      iE(GP, Xd, function() {
        var n = e.facade;
        f1 ? UO.emit("rejectionHandled", n) : $P("rejectionhandled", n, e.value);
      });
    }, Lh = function(e, n, i) {
      return function(o) {
        e(n, o, i);
      };
    }, kh = function(e, n, i) {
      e.done || (e.done = !0, i && (e = i), e.value = n, e.state = 2, QP(e, !0));
    }, BO = function(e, n, i) {
      if (!e.done) {
        e.done = !0, i && (e = i);
        try {
          if (e.facade === n) throw qP("Promise can't be resolved itself");
          var o = JP(n);
          o ? DO(function() {
            var f = { done: !1 };
            try {
              iE(o, n, Lh(BO, f, e), Lh(kh, f, e));
            } catch (T) {
              kh(f, T, e);
            }
          }) : (e.value = n, e.state = 1, QP(e, !1));
        } catch (f) {
          kh({ done: !1 }, f, e);
        }
      }
    };
    WP && (kO = (sE = function(e) {
      cZ(this, kO), aZ(e), iE(PO, this);
      var n = LO(this);
      try {
        e(Lh(BO, n), Lh(kh, n));
      } catch (i) {
        kh(n, i);
      }
    }).prototype, (PO = function(e) {
      pZ(this, { type: h1, done: !1, notified: !1, parent: !1, reactions: new fZ(), rejection: !1, state: 0, value: void 0 });
    }).prototype = rZ(kO, "then", function(e, n) {
      var i = LO(this), o = HO(uZ(this, sE));
      return i.parent = !0, o.ok = !xO(e) || e, o.fail = xO(n) && n, o.domain = f1 ? UO.domain : void 0, i.state == 0 ? i.reactions.add(o) : DO(function() {
        ZP(o, i);
      }), o.promise;
    }), FP = function() {
      var e = new PO(), n = LO(e);
      this.promise = e, this.resolve = Lh(BO, n), this.reject = Lh(kh, n);
    }, XP.f = HO = function(e) {
      return e === sE || e === void 0 ? new FP(e) : mZ(e);
    }), nZ({ global: !0, constructor: !0, wrap: !0, forced: WP }, { Promise: sE }), iZ(sE, h1, !1, !0), sZ(h1);
    var t3 = Or("iterator"), n3 = !1;
    try {
      var TZ = 0, r3 = { next: function() {
        return { done: !!TZ++ };
      }, return: function() {
        n3 = !0;
      } };
      r3[t3] = function() {
        return this;
      }, Array.from(r3, function() {
        throw 2;
      });
    } catch {
    }
    var bZ = uf, AZ = function(e, n) {
      if (!n3) return !1;
      var i = !1;
      try {
        var o = {};
        o[t3] = function() {
          return { next: function() {
            return { done: i = !0 };
          } };
        }, e(o);
      } catch {
      }
      return i;
    }, p1 = rE.CONSTRUCTOR || !AZ(function(e) {
      bZ.all(e).then(void 0, function() {
      });
    }), OZ = se, CZ = ae, SZ = fu, IZ = Mh, RZ = Zm;
    _r({ target: "Promise", stat: !0, forced: p1 }, { all: function(e) {
      var n = this, i = SZ.f(n), o = i.resolve, f = i.reject, T = IZ(function() {
        var A = CZ(n.resolve), R = [], P = 0, L = 1;
        RZ(e, function(z) {
          var Y = P++, te = !1;
          L++, OZ(A, n, z).then(function(oe) {
            te || (te = !0, R[Y] = oe, --L || o(R));
          }, f);
        }), --L || o(R);
      });
      return T.error && f(T.value), i.promise;
    } });
    var NZ = _r, wZ = rE.CONSTRUCTOR;
    uf && uf.prototype, NZ({ target: "Promise", proto: !0, forced: wZ, real: !0 }, { catch: function(e) {
      return this.then(void 0, e);
    } });
    var _Z = se, PZ = ae, xZ = fu, DZ = Mh, MZ = Zm;
    _r({ target: "Promise", stat: !0, forced: p1 }, { race: function(e) {
      var n = this, i = xZ.f(n), o = i.reject, f = DZ(function() {
        var T = PZ(n.resolve);
        MZ(e, function(A) {
          _Z(T, n, A).then(i.resolve, o);
        });
      });
      return f.error && o(f.value), i.promise;
    } });
    var LZ = se, kZ = fu;
    _r({ target: "Promise", stat: !0, forced: rE.CONSTRUCTOR }, { reject: function(e) {
      var n = kZ.f(this);
      return LZ(n.reject, void 0, e), n.promise;
    } });
    var jZ = Zi, UZ = gt, HZ = fu, i3 = function(e, n) {
      if (jZ(e), UZ(n) && n.constructor === e) return n;
      var i = HZ.f(e);
      return (0, i.resolve)(n), i.promise;
    }, BZ = _r, zZ = uf, FZ = rE.CONSTRUCTOR, GZ = i3, VZ = kt("Promise"), YZ = !FZ;
    BZ({ target: "Promise", stat: !0, forced: !0 }, { resolve: function(e) {
      return GZ(YZ && this === VZ ? zZ : this, e);
    } });
    var XZ = se, WZ = ae, qZ = fu, KZ = Mh, JZ = Zm;
    _r({ target: "Promise", stat: !0, forced: p1 }, { allSettled: function(e) {
      var n = this, i = qZ.f(n), o = i.resolve, f = i.reject, T = KZ(function() {
        var A = WZ(n.resolve), R = [], P = 0, L = 1;
        JZ(e, function(z) {
          var Y = P++, te = !1;
          L++, XZ(A, n, z).then(function(oe) {
            te || (te = !0, R[Y] = { status: "fulfilled", value: oe }, --L || o(R));
          }, function(oe) {
            te || (te = !0, R[Y] = { status: "rejected", reason: oe }, --L || o(R));
          });
        }), --L || o(R);
      });
      return T.error && f(T.value), i.promise;
    } });
    var ZZ = se, QZ = ae, $Z = kt, eQ = fu, tQ = Mh, nQ = Zm, s3 = "No one promise resolved";
    _r({ target: "Promise", stat: !0, forced: p1 }, { any: function(e) {
      var n = this, i = $Z("AggregateError"), o = eQ.f(n), f = o.resolve, T = o.reject, A = tQ(function() {
        var R = QZ(n.resolve), P = [], L = 0, z = 1, Y = !1;
        nQ(e, function(te) {
          var oe = L++, He = !1;
          z++, ZZ(R, n, te).then(function(Re) {
            He || Y || (Y = !0, f(Re));
          }, function(Re) {
            He || Y || (He = !0, P[oe] = Re, --z || T(new i(P, s3)));
          });
        }), --z || T(new i(P, s3));
      });
      return A.error && T(A.value), o.promise;
    } });
    var rQ = _r, zO = uf, iQ = b, sQ = kt, aQ = U, oQ = EO, a3 = i3, cQ = zO && zO.prototype;
    rQ({ target: "Promise", proto: !0, real: !0, forced: !!zO && iQ(function() {
      cQ.finally.call({ then: function() {
      } }, function() {
      });
    }) }, { finally: function(e) {
      var n = oQ(this, sQ("Promise")), i = aQ(e);
      return this.then(i ? function(o) {
        return a3(n, e()).then(function() {
          return o;
        });
      } : e, i ? function(o) {
        return a3(n, e()).then(function() {
          throw o;
        });
      } : e);
    } });
    var FO = p, uQ = UA, dQ = Oo, lQ = Ke, fQ = FO("".charAt), o3 = FO("".charCodeAt), hQ = FO("".slice), c3 = function(e) {
      return function(n, i) {
        var o, f, T = dQ(lQ(n)), A = uQ(i), R = T.length;
        return A < 0 || A >= R ? e ? "" : void 0 : (o = o3(T, A)) < 55296 || o > 56319 || A + 1 === R || (f = o3(T, A + 1)) < 56320 || f > 57343 ? e ? fQ(T, A) : o : e ? hQ(T, A, A + 2) : f - 56320 + (o - 55296 << 10) + 65536;
      };
    }, GO = { codeAt: c3(!1), charAt: c3(!0) }, pQ = GO.charAt, gQ = Oo, u3 = of, mQ = aP, d3 = fO, l3 = "String Iterator", EQ = u3.set, yQ = u3.getterFor(l3);
    mQ(String, "String", function(e) {
      EQ(this, { type: l3, string: gQ(e), index: 0 });
    }, function() {
      var e, n = yQ(this), i = n.string, o = n.index;
      return o >= i.length ? d3(void 0, !0) : (e = pQ(i, o), n.index += e.length, d3(e, !1));
    });
    var vQ = it.Promise, TQ = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 }, bQ = y, AQ = du, OQ = Oa, f3 = sf, h3 = Or("toStringTag");
    for (var VO in TQ) {
      var p3 = bQ[VO], YO = p3 && p3.prototype;
      YO && AQ(YO) !== h3 && OQ(YO, h3, VO), f3[VO] = f3.Array;
    }
    var g3 = vQ, cn = h(g3), CQ = Jo("Array").values, SQ = du, IQ = Lt, RQ = m, NQ = CQ, XO = Array.prototype, wQ = { DOMTokenList: !0, NodeList: !0 }, _Q = function(e) {
      var n = e.values;
      return e === XO || RQ(XO, e) && n === XO.values || IQ(wQ, SQ(e)) ? NQ : n;
    }, nd = h(_Q), PQ = b, xQ = Or("iterator"), WO = !PQ(function() {
      var e = new URL("b?a=1&b=2&c=3", "http://a"), n = e.searchParams, i = new URLSearchParams("a=1&a=2"), o = "";
      return e.pathname = "c%20d", n.forEach(function(f, T) {
        n.delete("b"), o += T + f;
      }), i.delete("a", 2), !e.toJSON || !i.has("a", 1) || i.has("a", 2) || !n.size && !0 || !n.sort || e.href !== "http://a/c%20d?a=1&c=3" || n.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !n[xQ] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || o !== "a1c3" || new URL("http://x", void 0).host !== "x";
    }), DQ = Vd, MQ = Xt, LQ = Ts, kQ = Le, g1 = function(e, n, i) {
      var o = MQ(n);
      o in e ? LQ.f(e, o, kQ(0, i)) : e[o] = i;
    }, m3 = HA, jQ = td, UQ = g1, HQ = Array, BQ = Math.max, qO = function(e, n, i) {
      for (var o = jQ(e), f = m3(n, o), T = m3(i === void 0 ? o : i, o), A = HQ(BQ(T - f, 0)), R = 0; f < T; f++, R++) UQ(A, R, e[f]);
      return A.length = R, A;
    }, E3 = qO, zQ = Math.floor, KO = function(e, n) {
      var i = e.length, o = zQ(i / 2);
      return i < 8 ? FQ(e, n) : GQ(e, KO(E3(e, 0, o), n), KO(E3(e, o), n), n);
    }, FQ = function(e, n) {
      for (var i, o, f = e.length, T = 1; T < f; ) {
        for (o = T, i = e[T]; o && n(e[o - 1], i) > 0; ) e[o] = e[--o];
        o !== T++ && (e[o] = i);
      }
      return e;
    }, GQ = function(e, n, i, o) {
      for (var f = n.length, T = i.length, A = 0, R = 0; A < f || R < T; ) e[A + R] = A < f && R < T ? o(n[A], i[R]) <= 0 ? n[A++] : i[R++] : A < f ? n[A++] : i[R++];
      return e;
    }, y3 = KO, JO = _r, jh = y, m1 = se, hu = p, Uh = V, v3 = WO, T3 = Vd, VQ = s1, YQ = function(e, n, i) {
      for (var o in n) i.unsafe && e[o] ? e[o] = n[o] : DQ(e, o, n[o], i);
      return e;
    }, XQ = Yd, WQ = dO, ZO = of, b3 = hO, QO = U, qQ = Lt, KQ = ba, JQ = du, ZQ = Zi, A3 = gt, Ba = Oo, QQ = Jm, O3 = Le, $O = eO, $Q = Zv, Hh = xh, e$ = y3, t$ = Or("iterator"), aE = "URLSearchParams", C3 = aE + "Iterator", S3 = ZO.set, Zo = ZO.getterFor(aE), n$ = ZO.getterFor(C3), r$ = Object.getOwnPropertyDescriptor, eC = function(e) {
      if (!Uh) return jh[e];
      var n = r$(jh, e);
      return n && n.value;
    }, I3 = eC("fetch"), E1 = eC("Request"), oE = eC("Headers"), tC = E1 && E1.prototype, R3 = oE && oE.prototype, i$ = jh.RegExp, s$ = jh.TypeError, N3 = jh.decodeURIComponent, a$ = jh.encodeURIComponent, o$ = hu("".charAt), w3 = hu([].join), df = hu([].push), nC = hu("".replace), c$ = hu([].shift), _3 = hu([].splice), P3 = hu("".split), u$ = hu("".slice), d$ = /\+/g, x3 = Array(4), l$ = function(e) {
      return x3[e - 1] || (x3[e - 1] = i$("((?:%[\\da-f]{2}){" + e + "})", "gi"));
    }, f$ = function(e) {
      try {
        return N3(e);
      } catch {
        return e;
      }
    }, D3 = function(e) {
      var n = nC(e, d$, " "), i = 4;
      try {
        return N3(n);
      } catch {
        for (; i; ) n = nC(n, l$(i--), f$);
        return n;
      }
    }, h$ = /[!'()~]|%20/g, p$ = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+" }, g$ = function(e) {
      return p$[e];
    }, M3 = function(e) {
      return nC(a$(e), h$, g$);
    }, rC = WQ(function(e, n) {
      S3(this, { type: C3, iterator: $O(Zo(e).entries), kind: n });
    }, "Iterator", function() {
      var e = n$(this), n = e.kind, i = e.iterator.next(), o = i.value;
      return i.done || (i.value = n === "keys" ? o.key : n === "values" ? o.value : [o.key, o.value]), i;
    }, !0), L3 = function(e) {
      this.entries = [], this.url = null, e !== void 0 && (A3(e) ? this.parseObject(e) : this.parseQuery(typeof e == "string" ? o$(e, 0) === "?" ? u$(e, 1) : e : Ba(e)));
    };
    L3.prototype = { type: aE, bindURL: function(e) {
      this.url = e, this.update();
    }, parseObject: function(e) {
      var n, i, o, f, T, A, R, P = $Q(e);
      if (P) for (i = (n = $O(e, P)).next; !(o = m1(i, n)).done; ) {
        if (T = (f = $O(ZQ(o.value))).next, (A = m1(T, f)).done || (R = m1(T, f)).done || !m1(T, f).done) throw s$("Expected sequence with length 2");
        df(this.entries, { key: Ba(A.value), value: Ba(R.value) });
      }
      else for (var L in e) qQ(e, L) && df(this.entries, { key: L, value: Ba(e[L]) });
    }, parseQuery: function(e) {
      if (e) for (var n, i, o = P3(e, "&"), f = 0; f < o.length; ) (n = o[f++]).length && (i = P3(n, "="), df(this.entries, { key: D3(c$(i)), value: D3(w3(i, "=")) }));
    }, serialize: function() {
      for (var e, n = this.entries, i = [], o = 0; o < n.length; ) e = n[o++], df(i, M3(e.key) + "=" + M3(e.value));
      return w3(i, "&");
    }, update: function() {
      this.entries.length = 0, this.parseQuery(this.url.query);
    }, updateURL: function() {
      this.url && this.url.update();
    } };
    var y1 = function() {
      b3(this, Bh);
      var e = S3(this, new L3(arguments.length > 0 ? arguments[0] : void 0));
      Uh || (this.size = e.entries.length);
    }, Bh = y1.prototype;
    if (YQ(Bh, { append: function(e, n) {
      var i = Zo(this);
      Hh(arguments.length, 2), df(i.entries, { key: Ba(e), value: Ba(n) }), Uh || this.length++, i.updateURL();
    }, delete: function(e) {
      for (var n = Zo(this), i = Hh(arguments.length, 1), o = n.entries, f = Ba(e), T = i < 2 ? void 0 : arguments[1], A = T === void 0 ? T : Ba(T), R = 0; R < o.length; ) {
        var P = o[R];
        if (P.key !== f || A !== void 0 && P.value !== A) R++;
        else if (_3(o, R, 1), A !== void 0) break;
      }
      Uh || (this.size = o.length), n.updateURL();
    }, get: function(e) {
      var n = Zo(this).entries;
      Hh(arguments.length, 1);
      for (var i = Ba(e), o = 0; o < n.length; o++) if (n[o].key === i) return n[o].value;
      return null;
    }, getAll: function(e) {
      var n = Zo(this).entries;
      Hh(arguments.length, 1);
      for (var i = Ba(e), o = [], f = 0; f < n.length; f++) n[f].key === i && df(o, n[f].value);
      return o;
    }, has: function(e) {
      for (var n = Zo(this).entries, i = Hh(arguments.length, 1), o = Ba(e), f = i < 2 ? void 0 : arguments[1], T = f === void 0 ? f : Ba(f), A = 0; A < n.length; ) {
        var R = n[A++];
        if (R.key === o && (T === void 0 || R.value === T)) return !0;
      }
      return !1;
    }, set: function(e, n) {
      var i = Zo(this);
      Hh(arguments.length, 1);
      for (var o, f = i.entries, T = !1, A = Ba(e), R = Ba(n), P = 0; P < f.length; P++) (o = f[P]).key === A && (T ? _3(f, P--, 1) : (T = !0, o.value = R));
      T || df(f, { key: A, value: R }), Uh || (this.size = f.length), i.updateURL();
    }, sort: function() {
      var e = Zo(this);
      e$(e.entries, function(n, i) {
        return n.key > i.key ? 1 : -1;
      }), e.updateURL();
    }, forEach: function(e) {
      for (var n, i = Zo(this).entries, o = KQ(e, arguments.length > 1 ? arguments[1] : void 0), f = 0; f < i.length; ) o((n = i[f++]).value, n.key, this);
    }, keys: function() {
      return new rC(this, "keys");
    }, values: function() {
      return new rC(this, "values");
    }, entries: function() {
      return new rC(this, "entries");
    } }, { enumerable: !0 }), T3(Bh, t$, Bh.entries, { name: "entries" }), T3(Bh, "toString", function() {
      return Zo(this).serialize();
    }, { enumerable: !0 }), Uh && VQ(Bh, "size", { get: function() {
      return Zo(this).entries.length;
    }, configurable: !0, enumerable: !0 }), XQ(y1, aE), JO({ global: !0, constructor: !0, forced: !v3 }, { URLSearchParams: y1 }), !v3 && QO(oE)) {
      var m$ = hu(R3.has), E$ = hu(R3.set), k3 = function(e) {
        if (A3(e)) {
          var n, i = e.body;
          if (JQ(i) === aE) return n = e.headers ? new oE(e.headers) : new oE(), m$(n, "content-type") || E$(n, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), QQ(e, { body: O3(0, Ba(i)), headers: O3(0, n) });
        }
        return e;
      };
      if (QO(I3) && JO({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, { fetch: function(e) {
        return I3(e, arguments.length > 1 ? k3(arguments[1]) : {});
      } }), QO(E1)) {
        var iC = function(e) {
          return b3(this, tC), new E1(e, arguments.length > 1 ? k3(arguments[1]) : {});
        };
        tC.constructor = iC, iC.prototype = tC, JO({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, { Request: iC });
      }
    }
    var Qo, y$ = { URLSearchParams: y1, getState: Zo }, v$ = it.URLSearchParams, j3 = V, T$ = p, b$ = se, A$ = b, sC = qv, O$ = Km, C$ = ee, S$ = et, I$ = xe, zh = Object.assign, U3 = Object.defineProperty, R$ = T$([].concat), N$ = !zh || A$(function() {
      if (j3 && zh({ b: 1 }, zh(U3({}, "a", { enumerable: !0, get: function() {
        U3(this, "b", { value: 3, enumerable: !1 });
      } }), { b: 2 })).b !== 1) return !0;
      var e = {}, n = {}, i = Symbol(), o = "abcdefghijklmnopqrst";
      return e[i] = 7, o.split("").forEach(function(f) {
        n[f] = f;
      }), zh({}, e)[i] != 7 || sC(zh({}, n)).join("") != o;
    }) ? function(e, n) {
      for (var i = S$(e), o = arguments.length, f = 1, T = O$.f, A = C$.f; o > f; ) for (var R, P = I$(arguments[f++]), L = T ? R$(sC(P), T(P)) : sC(P), z = L.length, Y = 0; z > Y; ) R = L[Y++], j3 && !b$(A, P, R) || (i[R] = P[R]);
      return i;
    } : zh, w$ = Zi, _$ = B_, P$ = ba, x$ = se, D$ = et, M$ = function(e, n, i, o) {
      try {
        return o ? n(w$(i)[0], i[1]) : n(i);
      } catch (f) {
        _$(e, "throw", f);
      }
    }, L$ = j_, k$ = a1, j$ = td, H3 = g1, U$ = eO, H$ = Zv, B3 = Array, lf = p, aC = 2147483647, B$ = /[^\0-\u007E]/, z3 = /[.\u3002\uFF0E\uFF61]/g, F3 = "Overflow: input needs wider integers to process", G3 = RangeError, z$ = lf(z3.exec), Fh = Math.floor, oC = String.fromCharCode, V3 = lf("".charCodeAt), Y3 = lf([].join), Wd = lf([].push), F$ = lf("".replace), G$ = lf("".split), V$ = lf("".toLowerCase), X3 = function(e) {
      return e + 22 + 75 * (e < 26);
    }, Y$ = function(e, n, i) {
      var o = 0;
      for (e = i ? Fh(e / 700) : e >> 1, e += Fh(e / n); e > 455; ) e = Fh(e / 35), o += 36;
      return Fh(o + 36 * e / (e + 38));
    }, X$ = function(e) {
      var n = [];
      e = function(Xe) {
        for (var We = [], mt = 0, Pt = Xe.length; mt < Pt; ) {
          var xt = V3(Xe, mt++);
          if (xt >= 55296 && xt <= 56319 && mt < Pt) {
            var Nt = V3(Xe, mt++);
            (64512 & Nt) == 56320 ? Wd(We, ((1023 & xt) << 10) + (1023 & Nt) + 65536) : (Wd(We, xt), mt--);
          } else Wd(We, xt);
        }
        return We;
      }(e);
      var i, o, f = e.length, T = 128, A = 0, R = 72;
      for (i = 0; i < e.length; i++) (o = e[i]) < 128 && Wd(n, oC(o));
      var P = n.length, L = P;
      for (P && Wd(n, "-"); L < f; ) {
        var z = aC;
        for (i = 0; i < e.length; i++) (o = e[i]) >= T && o < z && (z = o);
        var Y = L + 1;
        if (z - T > Fh((aC - A) / Y)) throw G3(F3);
        for (A += (z - T) * Y, T = z, i = 0; i < e.length; i++) {
          if ((o = e[i]) < T && ++A > aC) throw G3(F3);
          if (o == T) {
            for (var te = A, oe = 36; ; ) {
              var He = oe <= R ? 1 : oe >= R + 26 ? 26 : oe - R;
              if (te < He) break;
              var Re = te - He, De = 36 - He;
              Wd(n, oC(X3(He + Re % De))), te = Fh(Re / De), oe += 36;
            }
            Wd(n, oC(X3(te))), R = Y$(A, Y, L == P), A = 0, L++;
          }
        }
        A++, T++;
      }
      return Y3(n, "");
    }, W$ = _r, cC = V, q$ = WO, uC = y, W3 = ba, $o = p, v1 = Vd, ec = s1, K$ = hO, dC = Lt, lC = N$, Gh = function(e) {
      var n = D$(e), i = k$(this), o = arguments.length, f = o > 1 ? arguments[1] : void 0, T = f !== void 0;
      T && (f = P$(f, o > 2 ? arguments[2] : void 0));
      var A, R, P, L, z, Y, te = H$(n), oe = 0;
      if (!te || this === B3 && L$(te)) for (A = j$(n), R = i ? new this(A) : B3(A); A > oe; oe++) Y = T ? f(n[oe], oe) : n[oe], H3(R, oe, Y);
      else for (z = (L = U$(n, te)).next, R = i ? new this() : []; !(P = x$(z, L)).done; oe++) Y = T ? M$(L, f, [P.value, oe], !0) : P.value, H3(R, oe, Y);
      return R.length = oe, R;
    }, Pc = qO, J$ = GO.codeAt, Z$ = function(e) {
      var n, i, o = [], f = G$(F$(V$(e), z3, "."), ".");
      for (n = 0; n < f.length; n++) i = f[n], Wd(o, z$(B$, i) ? "xn--" + X$(i) : i);
      return Y3(o, ".");
    }, rd = Oo, Q$ = Yd, $$ = xh, q3 = y$, K3 = of, eee = K3.set, T1 = K3.getterFor("URL"), tee = q3.URLSearchParams, nee = q3.getState, cE = uC.URL, fC = uC.TypeError, b1 = uC.parseInt, ree = Math.floor, J3 = Math.pow, tc = $o("".charAt), xc = $o(/./.exec), uE = $o([].join), iee = $o(1 .toString), see = $o([].pop), Vh = $o([].push), hC = $o("".replace), aee = $o([].shift), oee = $o("".split), dE = $o("".slice), A1 = $o("".toLowerCase), cee = $o([].unshift), pC = "Invalid scheme", ff = "Invalid host", Z3 = "Invalid port", Q3 = /[a-z]/i, uee = /[\d+-.a-z]/i, gC = /\d/, dee = /^0x/i, lee = /^[0-7]+$/, fee = /^\d+$/, $3 = /^[\da-f]+$/i, hee = /[\0\t\n\r #%/:<>?@[\\\]^|]/, pee = /[\0\t\n\r #/:<>?@[\\\]^|]/, gee = /^[\u0000-\u0020]+/, mee = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, Eee = /[\t\n\r]/g, lE = function(e) {
      var n, i, o, f;
      if (typeof e == "number") {
        for (n = [], i = 0; i < 4; i++) cee(n, e % 256), e = ree(e / 256);
        return uE(n, ".");
      }
      if (typeof e == "object") {
        for (n = "", o = function(T) {
          for (var A = null, R = 1, P = null, L = 0, z = 0; z < 8; z++) T[z] !== 0 ? (L > R && (A = P, R = L), P = null, L = 0) : (P === null && (P = z), ++L);
          return L > R && (A = P, R = L), A;
        }(e), i = 0; i < 8; i++) f && e[i] === 0 || (f && (f = !1), o === i ? (n += i ? ":" : "::", f = !0) : (n += iee(e[i], 16), i < 7 && (n += ":")));
        return "[" + n + "]";
      }
      return e;
    }, O1 = {}, e4 = lC({}, O1, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }), t4 = lC({}, e4, { "#": 1, "?": 1, "{": 1, "}": 1 }), mC = lC({}, t4, { "/": 1, ":": 1, ";": 1, "=": 1, "@": 1, "[": 1, "\\": 1, "]": 1, "^": 1, "|": 1 }), qd = function(e, n) {
      var i = J$(e, 0);
      return i > 32 && i < 127 && !dC(n, e) ? e : encodeURIComponent(e);
    }, C1 = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 }, fE = function(e, n) {
      var i;
      return e.length == 2 && xc(Q3, tc(e, 0)) && ((i = tc(e, 1)) == ":" || !n && i == "|");
    }, n4 = function(e) {
      var n;
      return e.length > 1 && fE(dE(e, 0, 2)) && (e.length == 2 || (n = tc(e, 2)) === "/" || n === "\\" || n === "?" || n === "#");
    }, yee = function(e) {
      return e === "." || A1(e) === "%2e";
    }, EC = {}, r4 = {}, yC = {}, i4 = {}, s4 = {}, vC = {}, a4 = {}, o4 = {}, S1 = {}, I1 = {}, TC = {}, bC = {}, AC = {}, OC = {}, c4 = {}, CC = {}, Yh = {}, pu = {}, u4 = {}, hf = {}, id = {}, SC = function(e, n, i) {
      var o, f, T, A = rd(e);
      if (n) {
        if (f = this.parse(A)) throw fC(f);
        this.searchParams = null;
      } else {
        if (i !== void 0 && (o = new SC(i, !0)), f = this.parse(A, null, o)) throw fC(f);
        (T = nee(new tee())).bindURL(this), this.searchParams = T;
      }
    };
    SC.prototype = { type: "URL", parse: function(e, n, i) {
      var o, f, T, A, R, P = this, L = n || EC, z = 0, Y = "", te = !1, oe = !1, He = !1;
      for (e = rd(e), n || (P.scheme = "", P.username = "", P.password = "", P.host = null, P.port = null, P.path = [], P.query = null, P.fragment = null, P.cannotBeABaseURL = !1, e = hC(e, gee, ""), e = hC(e, mee, "$1")), e = hC(e, Eee, ""), o = Gh(e); z <= o.length; ) {
        switch (f = o[z], L) {
          case EC:
            if (!f || !xc(Q3, f)) {
              if (n) return pC;
              L = yC;
              continue;
            }
            Y += A1(f), L = r4;
            break;
          case r4:
            if (f && (xc(uee, f) || f == "+" || f == "-" || f == ".")) Y += A1(f);
            else {
              if (f != ":") {
                if (n) return pC;
                Y = "", L = yC, z = 0;
                continue;
              }
              if (n && (P.isSpecial() != dC(C1, Y) || Y == "file" && (P.includesCredentials() || P.port !== null) || P.scheme == "file" && !P.host)) return;
              if (P.scheme = Y, n) return void (P.isSpecial() && C1[P.scheme] == P.port && (P.port = null));
              Y = "", P.scheme == "file" ? L = OC : P.isSpecial() && i && i.scheme == P.scheme ? L = i4 : P.isSpecial() ? L = o4 : o[z + 1] == "/" ? (L = s4, z++) : (P.cannotBeABaseURL = !0, Vh(P.path, ""), L = u4);
            }
            break;
          case yC:
            if (!i || i.cannotBeABaseURL && f != "#") return pC;
            if (i.cannotBeABaseURL && f == "#") {
              P.scheme = i.scheme, P.path = Pc(i.path), P.query = i.query, P.fragment = "", P.cannotBeABaseURL = !0, L = id;
              break;
            }
            L = i.scheme == "file" ? OC : vC;
            continue;
          case i4:
            if (f != "/" || o[z + 1] != "/") {
              L = vC;
              continue;
            }
            L = S1, z++;
            break;
          case s4:
            if (f == "/") {
              L = I1;
              break;
            }
            L = pu;
            continue;
          case vC:
            if (P.scheme = i.scheme, f == Qo) P.username = i.username, P.password = i.password, P.host = i.host, P.port = i.port, P.path = Pc(i.path), P.query = i.query;
            else if (f == "/" || f == "\\" && P.isSpecial()) L = a4;
            else if (f == "?") P.username = i.username, P.password = i.password, P.host = i.host, P.port = i.port, P.path = Pc(i.path), P.query = "", L = hf;
            else {
              if (f != "#") {
                P.username = i.username, P.password = i.password, P.host = i.host, P.port = i.port, P.path = Pc(i.path), P.path.length--, L = pu;
                continue;
              }
              P.username = i.username, P.password = i.password, P.host = i.host, P.port = i.port, P.path = Pc(i.path), P.query = i.query, P.fragment = "", L = id;
            }
            break;
          case a4:
            if (!P.isSpecial() || f != "/" && f != "\\") {
              if (f != "/") {
                P.username = i.username, P.password = i.password, P.host = i.host, P.port = i.port, L = pu;
                continue;
              }
              L = I1;
            } else L = S1;
            break;
          case o4:
            if (L = S1, f != "/" || tc(Y, z + 1) != "/") continue;
            z++;
            break;
          case S1:
            if (f != "/" && f != "\\") {
              L = I1;
              continue;
            }
            break;
          case I1:
            if (f == "@") {
              te && (Y = "%40" + Y), te = !0, T = Gh(Y);
              for (var Re = 0; Re < T.length; Re++) {
                var De = T[Re];
                if (De != ":" || He) {
                  var Xe = qd(De, mC);
                  He ? P.password += Xe : P.username += Xe;
                } else He = !0;
              }
              Y = "";
            } else if (f == Qo || f == "/" || f == "?" || f == "#" || f == "\\" && P.isSpecial()) {
              if (te && Y == "") return "Invalid authority";
              z -= Gh(Y).length + 1, Y = "", L = TC;
            } else Y += f;
            break;
          case TC:
          case bC:
            if (n && P.scheme == "file") {
              L = CC;
              continue;
            }
            if (f != ":" || oe) {
              if (f == Qo || f == "/" || f == "?" || f == "#" || f == "\\" && P.isSpecial()) {
                if (P.isSpecial() && Y == "") return ff;
                if (n && Y == "" && (P.includesCredentials() || P.port !== null)) return;
                if (A = P.parseHost(Y)) return A;
                if (Y = "", L = Yh, n) return;
                continue;
              }
              f == "[" ? oe = !0 : f == "]" && (oe = !1), Y += f;
            } else {
              if (Y == "") return ff;
              if (A = P.parseHost(Y)) return A;
              if (Y = "", L = AC, n == bC) return;
            }
            break;
          case AC:
            if (!xc(gC, f)) {
              if (f == Qo || f == "/" || f == "?" || f == "#" || f == "\\" && P.isSpecial() || n) {
                if (Y != "") {
                  var We = b1(Y, 10);
                  if (We > 65535) return Z3;
                  P.port = P.isSpecial() && We === C1[P.scheme] ? null : We, Y = "";
                }
                if (n) return;
                L = Yh;
                continue;
              }
              return Z3;
            }
            Y += f;
            break;
          case OC:
            if (P.scheme = "file", f == "/" || f == "\\") L = c4;
            else {
              if (!i || i.scheme != "file") {
                L = pu;
                continue;
              }
              if (f == Qo) P.host = i.host, P.path = Pc(i.path), P.query = i.query;
              else if (f == "?") P.host = i.host, P.path = Pc(i.path), P.query = "", L = hf;
              else {
                if (f != "#") {
                  n4(uE(Pc(o, z), "")) || (P.host = i.host, P.path = Pc(i.path), P.shortenPath()), L = pu;
                  continue;
                }
                P.host = i.host, P.path = Pc(i.path), P.query = i.query, P.fragment = "", L = id;
              }
            }
            break;
          case c4:
            if (f == "/" || f == "\\") {
              L = CC;
              break;
            }
            i && i.scheme == "file" && !n4(uE(Pc(o, z), "")) && (fE(i.path[0], !0) ? Vh(P.path, i.path[0]) : P.host = i.host), L = pu;
            continue;
          case CC:
            if (f == Qo || f == "/" || f == "\\" || f == "?" || f == "#") {
              if (!n && fE(Y)) L = pu;
              else if (Y == "") {
                if (P.host = "", n) return;
                L = Yh;
              } else {
                if (A = P.parseHost(Y)) return A;
                if (P.host == "localhost" && (P.host = ""), n) return;
                Y = "", L = Yh;
              }
              continue;
            }
            Y += f;
            break;
          case Yh:
            if (P.isSpecial()) {
              if (L = pu, f != "/" && f != "\\") continue;
            } else if (n || f != "?") if (n || f != "#") {
              if (f != Qo && (L = pu, f != "/")) continue;
            } else P.fragment = "", L = id;
            else P.query = "", L = hf;
            break;
          case pu:
            if (f == Qo || f == "/" || f == "\\" && P.isSpecial() || !n && (f == "?" || f == "#")) {
              if ((R = A1(R = Y)) === ".." || R === "%2e." || R === ".%2e" || R === "%2e%2e" ? (P.shortenPath(), f == "/" || f == "\\" && P.isSpecial() || Vh(P.path, "")) : yee(Y) ? f == "/" || f == "\\" && P.isSpecial() || Vh(P.path, "") : (P.scheme == "file" && !P.path.length && fE(Y) && (P.host && (P.host = ""), Y = tc(Y, 0) + ":"), Vh(P.path, Y)), Y = "", P.scheme == "file" && (f == Qo || f == "?" || f == "#")) for (; P.path.length > 1 && P.path[0] === ""; ) aee(P.path);
              f == "?" ? (P.query = "", L = hf) : f == "#" && (P.fragment = "", L = id);
            } else Y += qd(f, t4);
            break;
          case u4:
            f == "?" ? (P.query = "", L = hf) : f == "#" ? (P.fragment = "", L = id) : f != Qo && (P.path[0] += qd(f, O1));
            break;
          case hf:
            n || f != "#" ? f != Qo && (f == "'" && P.isSpecial() ? P.query += "%27" : P.query += f == "#" ? "%23" : qd(f, O1)) : (P.fragment = "", L = id);
            break;
          case id:
            f != Qo && (P.fragment += qd(f, e4));
        }
        z++;
      }
    }, parseHost: function(e) {
      var n, i, o;
      if (tc(e, 0) == "[") {
        if (tc(e, e.length - 1) != "]" || (n = function(f) {
          var T, A, R, P, L, z, Y, te = [0, 0, 0, 0, 0, 0, 0, 0], oe = 0, He = null, Re = 0, De = function() {
            return tc(f, Re);
          };
          if (De() == ":") {
            if (tc(f, 1) != ":") return;
            Re += 2, He = ++oe;
          }
          for (; De(); ) {
            if (oe == 8) return;
            if (De() != ":") {
              for (T = A = 0; A < 4 && xc($3, De()); ) T = 16 * T + b1(De(), 16), Re++, A++;
              if (De() == ".") {
                if (A == 0 || (Re -= A, oe > 6)) return;
                for (R = 0; De(); ) {
                  if (P = null, R > 0) {
                    if (!(De() == "." && R < 4)) return;
                    Re++;
                  }
                  if (!xc(gC, De())) return;
                  for (; xc(gC, De()); ) {
                    if (L = b1(De(), 10), P === null) P = L;
                    else {
                      if (P == 0) return;
                      P = 10 * P + L;
                    }
                    if (P > 255) return;
                    Re++;
                  }
                  te[oe] = 256 * te[oe] + P, ++R != 2 && R != 4 || oe++;
                }
                if (R != 4) return;
                break;
              }
              if (De() == ":") {
                if (Re++, !De()) return;
              } else if (De()) return;
              te[oe++] = T;
            } else {
              if (He !== null) return;
              Re++, He = ++oe;
            }
          }
          if (He !== null) for (z = oe - He, oe = 7; oe != 0 && z > 0; ) Y = te[oe], te[oe--] = te[He + z - 1], te[He + --z] = Y;
          else if (oe != 8) return;
          return te;
        }(dE(e, 1, -1)), !n)) return ff;
        this.host = n;
      } else if (this.isSpecial()) {
        if (e = Z$(e), xc(hee, e) || (n = function(f) {
          var T, A, R, P, L, z, Y, te = oee(f, ".");
          if (te.length && te[te.length - 1] == "" && te.length--, (T = te.length) > 4) return f;
          for (A = [], R = 0; R < T; R++) {
            if ((P = te[R]) == "") return f;
            if (L = 10, P.length > 1 && tc(P, 0) == "0" && (L = xc(dee, P) ? 16 : 8, P = dE(P, L == 8 ? 1 : 2)), P === "") z = 0;
            else {
              if (!xc(L == 10 ? fee : L == 8 ? lee : $3, P)) return f;
              z = b1(P, L);
            }
            Vh(A, z);
          }
          for (R = 0; R < T; R++) if (z = A[R], R == T - 1) {
            if (z >= J3(256, 5 - T)) return null;
          } else if (z > 255) return null;
          for (Y = see(A), R = 0; R < A.length; R++) Y += A[R] * J3(256, 3 - R);
          return Y;
        }(e), n === null)) return ff;
        this.host = n;
      } else {
        if (xc(pee, e)) return ff;
        for (n = "", i = Gh(e), o = 0; o < i.length; o++) n += qd(i[o], O1);
        this.host = n;
      }
    }, cannotHaveUsernamePasswordPort: function() {
      return !this.host || this.cannotBeABaseURL || this.scheme == "file";
    }, includesCredentials: function() {
      return this.username != "" || this.password != "";
    }, isSpecial: function() {
      return dC(C1, this.scheme);
    }, shortenPath: function() {
      var e = this.path, n = e.length;
      !n || this.scheme == "file" && n == 1 && fE(e[0], !0) || e.length--;
    }, serialize: function() {
      var e = this, n = e.scheme, i = e.username, o = e.password, f = e.host, T = e.port, A = e.path, R = e.query, P = e.fragment, L = n + ":";
      return f !== null ? (L += "//", e.includesCredentials() && (L += i + (o ? ":" + o : "") + "@"), L += lE(f), T !== null && (L += ":" + T)) : n == "file" && (L += "//"), L += e.cannotBeABaseURL ? A[0] : A.length ? "/" + uE(A, "/") : "", R !== null && (L += "?" + R), P !== null && (L += "#" + P), L;
    }, setHref: function(e) {
      var n = this.parse(e);
      if (n) throw fC(n);
      this.searchParams.update();
    }, getOrigin: function() {
      var e = this.scheme, n = this.port;
      if (e == "blob") try {
        return new Xh(e.path[0]).origin;
      } catch {
        return "null";
      }
      return e != "file" && this.isSpecial() ? e + "://" + lE(this.host) + (n !== null ? ":" + n : "") : "null";
    }, getProtocol: function() {
      return this.scheme + ":";
    }, setProtocol: function(e) {
      this.parse(rd(e) + ":", EC);
    }, getUsername: function() {
      return this.username;
    }, setUsername: function(e) {
      var n = Gh(rd(e));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.username = "";
        for (var i = 0; i < n.length; i++) this.username += qd(n[i], mC);
      }
    }, getPassword: function() {
      return this.password;
    }, setPassword: function(e) {
      var n = Gh(rd(e));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.password = "";
        for (var i = 0; i < n.length; i++) this.password += qd(n[i], mC);
      }
    }, getHost: function() {
      var e = this.host, n = this.port;
      return e === null ? "" : n === null ? lE(e) : lE(e) + ":" + n;
    }, setHost: function(e) {
      this.cannotBeABaseURL || this.parse(e, TC);
    }, getHostname: function() {
      var e = this.host;
      return e === null ? "" : lE(e);
    }, setHostname: function(e) {
      this.cannotBeABaseURL || this.parse(e, bC);
    }, getPort: function() {
      var e = this.port;
      return e === null ? "" : rd(e);
    }, setPort: function(e) {
      this.cannotHaveUsernamePasswordPort() || ((e = rd(e)) == "" ? this.port = null : this.parse(e, AC));
    }, getPathname: function() {
      var e = this.path;
      return this.cannotBeABaseURL ? e[0] : e.length ? "/" + uE(e, "/") : "";
    }, setPathname: function(e) {
      this.cannotBeABaseURL || (this.path = [], this.parse(e, Yh));
    }, getSearch: function() {
      var e = this.query;
      return e ? "?" + e : "";
    }, setSearch: function(e) {
      (e = rd(e)) == "" ? this.query = null : (tc(e, 0) == "?" && (e = dE(e, 1)), this.query = "", this.parse(e, hf)), this.searchParams.update();
    }, getSearchParams: function() {
      return this.searchParams.facade;
    }, getHash: function() {
      var e = this.fragment;
      return e ? "#" + e : "";
    }, setHash: function(e) {
      (e = rd(e)) != "" ? (tc(e, 0) == "#" && (e = dE(e, 1)), this.fragment = "", this.parse(e, id)) : this.fragment = null;
    }, update: function() {
      this.query = this.searchParams.serialize() || null;
    } };
    var Xh = function(e) {
      var n = K$(this, za), i = $$(arguments.length, 1) > 1 ? arguments[1] : void 0, o = eee(n, new SC(e, !1, i));
      cC || (n.href = o.serialize(), n.origin = o.getOrigin(), n.protocol = o.getProtocol(), n.username = o.getUsername(), n.password = o.getPassword(), n.host = o.getHost(), n.hostname = o.getHostname(), n.port = o.getPort(), n.pathname = o.getPathname(), n.search = o.getSearch(), n.searchParams = o.getSearchParams(), n.hash = o.getHash());
    }, za = Xh.prototype, nc = function(e, n) {
      return { get: function() {
        return T1(this)[e]();
      }, set: n && function(i) {
        return T1(this)[n](i);
      }, configurable: !0, enumerable: !0 };
    };
    if (cC && (ec(za, "href", nc("serialize", "setHref")), ec(za, "origin", nc("getOrigin")), ec(za, "protocol", nc("getProtocol", "setProtocol")), ec(za, "username", nc("getUsername", "setUsername")), ec(za, "password", nc("getPassword", "setPassword")), ec(za, "host", nc("getHost", "setHost")), ec(za, "hostname", nc("getHostname", "setHostname")), ec(za, "port", nc("getPort", "setPort")), ec(za, "pathname", nc("getPathname", "setPathname")), ec(za, "search", nc("getSearch", "setSearch")), ec(za, "searchParams", nc("getSearchParams")), ec(za, "hash", nc("getHash", "setHash"))), v1(za, "toJSON", function() {
      return T1(this).serialize();
    }, { enumerable: !0 }), v1(za, "toString", function() {
      return T1(this).serialize();
    }, { enumerable: !0 }), cE) {
      var d4 = cE.createObjectURL, l4 = cE.revokeObjectURL;
      d4 && v1(Xh, "createObjectURL", W3(d4, cE)), l4 && v1(Xh, "revokeObjectURL", W3(l4, cE));
    }
    Q$(Xh, "URL"), W$({ global: !0, constructor: !0, forced: !q$, sham: !cC }, { URL: Xh });
    var vee = _r, Tee = b, bee = xh, f4 = Oo, Aee = WO, h4 = kt("URL");
    vee({ target: "URL", stat: !0, forced: !(Aee && Tee(function() {
      h4.canParse();
    })) }, { canParse: function(e) {
      var n = bee(arguments.length, 1), i = f4(e), o = n < 2 || arguments[1] === void 0 ? void 0 : f4(arguments[1]);
      try {
        return !!new h4(i, o);
      } catch {
        return !1;
      }
    } });
    var p4 = h(it.URL);
    let g4 = !0, m4 = !0;
    function R1(e, n, i) {
      const o = e.match(n);
      return o && o.length >= i && parseInt(o[i], 10);
    }
    function pf(e, n, i) {
      if (!e.RTCPeerConnection) return;
      const o = e.RTCPeerConnection.prototype, f = o.addEventListener;
      o.addEventListener = function(A, R) {
        if (A !== n) return f.apply(this, arguments);
        const P = (L) => {
          const z = i(L);
          z && (R.handleEvent ? R.handleEvent(z) : R(z));
        };
        return this._eventMap = this._eventMap || {}, this._eventMap[n] || (this._eventMap[n] = /* @__PURE__ */ new Map()), this._eventMap[n].set(R, P), f.apply(this, [A, P]);
      };
      const T = o.removeEventListener;
      o.removeEventListener = function(A, R) {
        if (A !== n || !this._eventMap || !this._eventMap[n]) return T.apply(this, arguments);
        if (!this._eventMap[n].has(R)) return T.apply(this, arguments);
        const P = this._eventMap[n].get(R);
        return this._eventMap[n].delete(R), this._eventMap[n].size === 0 && delete this._eventMap[n], Object.keys(this._eventMap).length === 0 && delete this._eventMap, T.apply(this, [A, P]);
      }, Object.defineProperty(o, "on" + n, { get() {
        return this["_on" + n];
      }, set(A) {
        this["_on" + n] && (this.removeEventListener(n, this["_on" + n]), delete this["_on" + n]), A && this.addEventListener(n, this["_on" + n] = A);
      }, enumerable: !0, configurable: !0 });
    }
    function Oee(e) {
      return typeof e != "boolean" ? new Error("Argument type: " + typeof e + ". Please use a boolean.") : (g4 = e, e ? "adapter.js logging disabled" : "adapter.js logging enabled");
    }
    function Cee(e) {
      return typeof e != "boolean" ? new Error("Argument type: " + typeof e + ". Please use a boolean.") : (m4 = !e, "adapter.js deprecation warnings " + (e ? "disabled" : "enabled"));
    }
    function E4() {
      if (typeof window == "object") {
        if (g4) return;
        typeof console < "u" && typeof console.log == "function" && console.log.apply(console, arguments);
      }
    }
    function IC(e, n) {
      m4 && console.warn(e + " is deprecated, please use " + n + " instead.");
    }
    function y4(e) {
      return Object.prototype.toString.call(e) === "[object Object]";
    }
    function v4(e) {
      var n;
      return y4(e) ? _c(n = Object.keys(e)).call(n, function(i, o) {
        const f = y4(e[o]), T = f ? v4(e[o]) : e[o], A = f && !Object.keys(T).length;
        return T === void 0 || A ? i : Object.assign(i, { [o]: T });
      }, {}) : e;
    }
    function RC(e, n, i) {
      n && !i.has(n.id) && (i.set(n.id, n), Object.keys(n).forEach((o) => {
        o.endsWith("Id") ? RC(e, e.get(n[o]), i) : o.endsWith("Ids") && n[o].forEach((f) => {
          RC(e, e.get(f), i);
        });
      }));
    }
    function T4(e, n, i) {
      const o = i ? "outbound-rtp" : "inbound-rtp", f = /* @__PURE__ */ new Map();
      if (n === null) return f;
      const T = [];
      return e.forEach((A) => {
        A.type === "track" && A.trackIdentifier === n.id && T.push(A);
      }), T.forEach((A) => {
        e.forEach((R) => {
          R.type === o && R.trackId === A.id && RC(e, R, f);
        });
      }), f;
    }
    const b4 = E4;
    function A4(e, n) {
      const i = e && e.navigator;
      if (!i.mediaDevices) return;
      const o = function(A) {
        if (typeof A != "object" || A.mandatory || A.optional) return A;
        const R = {};
        return Object.keys(A).forEach((P) => {
          if (P === "require" || P === "advanced" || P === "mediaSource") return;
          const L = typeof A[P] == "object" ? A[P] : { ideal: A[P] };
          L.exact !== void 0 && typeof L.exact == "number" && (L.min = L.max = L.exact);
          const z = function(Y, te) {
            return Y ? Y + te.charAt(0).toUpperCase() + te.slice(1) : te === "deviceId" ? "sourceId" : te;
          };
          if (L.ideal !== void 0) {
            R.optional = R.optional || [];
            let Y = {};
            typeof L.ideal == "number" ? (Y[z("min", P)] = L.ideal, R.optional.push(Y), Y = {}, Y[z("max", P)] = L.ideal, R.optional.push(Y)) : (Y[z("", P)] = L.ideal, R.optional.push(Y));
          }
          L.exact !== void 0 && typeof L.exact != "number" ? (R.mandatory = R.mandatory || {}, R.mandatory[z("", P)] = L.exact) : ["min", "max"].forEach((Y) => {
            L[Y] !== void 0 && (R.mandatory = R.mandatory || {}, R.mandatory[z(Y, P)] = L[Y]);
          });
        }), A.advanced && (R.optional = (R.optional || []).concat(A.advanced)), R;
      }, f = function(A, R) {
        if (n.version >= 61) return R(A);
        if ((A = JSON.parse(JSON.stringify(A))) && typeof A.audio == "object") {
          const P = function(L, z, Y) {
            z in L && !(Y in L) && (L[Y] = L[z], delete L[z]);
          };
          P((A = JSON.parse(JSON.stringify(A))).audio, "autoGainControl", "googAutoGainControl"), P(A.audio, "noiseSuppression", "googNoiseSuppression"), A.audio = o(A.audio);
        }
        if (A && typeof A.video == "object") {
          let P = A.video.facingMode;
          P = P && (typeof P == "object" ? P : { ideal: P });
          const L = n.version < 66;
          if (P && (P.exact === "user" || P.exact === "environment" || P.ideal === "user" || P.ideal === "environment") && (!i.mediaDevices.getSupportedConstraints || !i.mediaDevices.getSupportedConstraints().facingMode || L)) {
            let z;
            if (delete A.video.facingMode, P.exact === "environment" || P.ideal === "environment" ? z = ["back", "rear"] : P.exact !== "user" && P.ideal !== "user" || (z = ["front"]), z) return i.mediaDevices.enumerateDevices().then((Y) => {
              let te = (Y = Y.filter((oe) => oe.kind === "videoinput")).find((oe) => z.some((He) => {
                var Re;
                return on(Re = oe.label.toLowerCase()).call(Re, He);
              }));
              return !te && Y.length && on(z).call(z, "back") && (te = Y[Y.length - 1]), te && (A.video.deviceId = P.exact ? { exact: te.deviceId } : { ideal: te.deviceId }), A.video = o(A.video), b4("chrome: " + JSON.stringify(A)), R(A);
            });
          }
          A.video = o(A.video);
        }
        return b4("chrome: " + JSON.stringify(A)), R(A);
      }, T = function(A) {
        return n.version >= 64 ? A : { name: { PermissionDeniedError: "NotAllowedError", PermissionDismissedError: "NotAllowedError", InvalidStateError: "NotAllowedError", DevicesNotFoundError: "NotFoundError", ConstraintNotSatisfiedError: "OverconstrainedError", TrackStartError: "NotReadableError", MediaDeviceFailedDueToShutdown: "NotAllowedError", MediaDeviceKillSwitchOn: "NotAllowedError", TabCaptureError: "AbortError", ScreenCaptureError: "AbortError", DeviceCaptureError: "AbortError" }[A.name] || A.name, message: A.message, constraint: A.constraint || A.constraintName, toString() {
          return this.name + (this.message && ": ") + this.message;
        } };
      };
      if (i.getUserMedia = (function(A, R, P) {
        f(A, (L) => {
          i.webkitGetUserMedia(L, R, (z) => {
            P && P(T(z));
          });
        });
      }).bind(i), i.mediaDevices.getUserMedia) {
        const A = i.mediaDevices.getUserMedia.bind(i.mediaDevices);
        i.mediaDevices.getUserMedia = function(R) {
          return f(R, (P) => A(P).then((L) => {
            if (P.audio && !L.getAudioTracks().length || P.video && !L.getVideoTracks().length) throw L.getTracks().forEach((z) => {
              z.stop();
            }), new DOMException("", "NotFoundError");
            return L;
          }, (L) => cn.reject(T(L))));
        };
      }
    }
    function O4(e) {
      e.MediaStream = e.MediaStream || e.webkitMediaStream;
    }
    function C4(e) {
      if (typeof e == "object" && e.RTCPeerConnection && !("ontrack" in e.RTCPeerConnection.prototype)) {
        Object.defineProperty(e.RTCPeerConnection.prototype, "ontrack", { get() {
          return this._ontrack;
        }, set(i) {
          this._ontrack && this.removeEventListener("track", this._ontrack), this.addEventListener("track", this._ontrack = i);
        }, enumerable: !0, configurable: !0 });
        const n = e.RTCPeerConnection.prototype.setRemoteDescription;
        e.RTCPeerConnection.prototype.setRemoteDescription = function() {
          return this._ontrackpoly || (this._ontrackpoly = (i) => {
            i.stream.addEventListener("addtrack", (o) => {
              let f;
              f = e.RTCPeerConnection.prototype.getReceivers ? this.getReceivers().find((A) => A.track && A.track.id === o.track.id) : { track: o.track };
              const T = new Event("track");
              T.track = o.track, T.receiver = f, T.transceiver = { receiver: f }, T.streams = [i.stream], this.dispatchEvent(T);
            }), i.stream.getTracks().forEach((o) => {
              let f;
              f = e.RTCPeerConnection.prototype.getReceivers ? this.getReceivers().find((A) => A.track && A.track.id === o.id) : { track: o };
              const T = new Event("track");
              T.track = o, T.receiver = f, T.transceiver = { receiver: f }, T.streams = [i.stream], this.dispatchEvent(T);
            });
          }, this.addEventListener("addstream", this._ontrackpoly)), n.apply(this, arguments);
        };
      } else pf(e, "track", (n) => (n.transceiver || Object.defineProperty(n, "transceiver", { value: { receiver: n.receiver } }), n));
    }
    function S4(e) {
      if (typeof e == "object" && e.RTCPeerConnection && !("getSenders" in e.RTCPeerConnection.prototype) && "createDTMFSender" in e.RTCPeerConnection.prototype) {
        const n = function(f, T) {
          return { track: T, get dtmf() {
            return this._dtmf === void 0 && (T.kind === "audio" ? this._dtmf = f.createDTMFSender(T) : this._dtmf = null), this._dtmf;
          }, _pc: f };
        };
        if (!e.RTCPeerConnection.prototype.getSenders) {
          e.RTCPeerConnection.prototype.getSenders = function() {
            return this._senders = this._senders || [], this._senders.slice();
          };
          const f = e.RTCPeerConnection.prototype.addTrack;
          e.RTCPeerConnection.prototype.addTrack = function(A, R) {
            let P = f.apply(this, arguments);
            return P || (P = n(this, A), this._senders.push(P)), P;
          };
          const T = e.RTCPeerConnection.prototype.removeTrack;
          e.RTCPeerConnection.prototype.removeTrack = function(A) {
            T.apply(this, arguments);
            const R = this._senders.indexOf(A);
            R !== -1 && this._senders.splice(R, 1);
          };
        }
        const i = e.RTCPeerConnection.prototype.addStream;
        e.RTCPeerConnection.prototype.addStream = function(f) {
          this._senders = this._senders || [], i.apply(this, [f]), f.getTracks().forEach((T) => {
            this._senders.push(n(this, T));
          });
        };
        const o = e.RTCPeerConnection.prototype.removeStream;
        e.RTCPeerConnection.prototype.removeStream = function(f) {
          this._senders = this._senders || [], o.apply(this, [f]), f.getTracks().forEach((T) => {
            const A = this._senders.find((R) => R.track === T);
            A && this._senders.splice(this._senders.indexOf(A), 1);
          });
        };
      } else if (typeof e == "object" && e.RTCPeerConnection && "getSenders" in e.RTCPeerConnection.prototype && "createDTMFSender" in e.RTCPeerConnection.prototype && e.RTCRtpSender && !("dtmf" in e.RTCRtpSender.prototype)) {
        const n = e.RTCPeerConnection.prototype.getSenders;
        e.RTCPeerConnection.prototype.getSenders = function() {
          const i = n.apply(this, []);
          return i.forEach((o) => o._pc = this), i;
        }, Object.defineProperty(e.RTCRtpSender.prototype, "dtmf", { get() {
          return this._dtmf === void 0 && (this.track.kind === "audio" ? this._dtmf = this._pc.createDTMFSender(this.track) : this._dtmf = null), this._dtmf;
        } });
      }
    }
    function I4(e) {
      if (!e.RTCPeerConnection) return;
      const n = e.RTCPeerConnection.prototype.getStats;
      e.RTCPeerConnection.prototype.getStats = function() {
        const [i, o, f] = arguments;
        if (arguments.length > 0 && typeof i == "function") return n.apply(this, arguments);
        if (n.length === 0 && (arguments.length === 0 || typeof i != "function")) return n.apply(this, []);
        const T = function(R) {
          const P = {};
          return R.result().forEach((L) => {
            const z = { id: L.id, timestamp: L.timestamp, type: { localcandidate: "local-candidate", remotecandidate: "remote-candidate" }[L.type] || L.type };
            L.names().forEach((Y) => {
              z[Y] = L.stat(Y);
            }), P[z.id] = z;
          }), P;
        }, A = function(R) {
          return new Map(Object.keys(R).map((P) => [P, R[P]]));
        };
        if (arguments.length >= 2) {
          const R = function(P) {
            o(A(T(P)));
          };
          return n.apply(this, [R, i]);
        }
        return new cn((R, P) => {
          n.apply(this, [function(L) {
            R(A(T(L)));
          }, P]);
        }).then(o, f);
      };
    }
    function R4(e) {
      if (!(typeof e == "object" && e.RTCPeerConnection && e.RTCRtpSender && e.RTCRtpReceiver)) return;
      if (!("getStats" in e.RTCRtpSender.prototype)) {
        const i = e.RTCPeerConnection.prototype.getSenders;
        i && (e.RTCPeerConnection.prototype.getSenders = function() {
          const f = i.apply(this, []);
          return f.forEach((T) => T._pc = this), f;
        });
        const o = e.RTCPeerConnection.prototype.addTrack;
        o && (e.RTCPeerConnection.prototype.addTrack = function() {
          const f = o.apply(this, arguments);
          return f._pc = this, f;
        }), e.RTCRtpSender.prototype.getStats = function() {
          const f = this;
          return this._pc.getStats().then((T) => T4(T, f.track, !0));
        };
      }
      if (!("getStats" in e.RTCRtpReceiver.prototype)) {
        const i = e.RTCPeerConnection.prototype.getReceivers;
        i && (e.RTCPeerConnection.prototype.getReceivers = function() {
          const o = i.apply(this, []);
          return o.forEach((f) => f._pc = this), o;
        }), pf(e, "track", (o) => (o.receiver._pc = o.srcElement, o)), e.RTCRtpReceiver.prototype.getStats = function() {
          const o = this;
          return this._pc.getStats().then((f) => T4(f, o.track, !1));
        };
      }
      if (!("getStats" in e.RTCRtpSender.prototype) || !("getStats" in e.RTCRtpReceiver.prototype)) return;
      const n = e.RTCPeerConnection.prototype.getStats;
      e.RTCPeerConnection.prototype.getStats = function() {
        if (arguments.length > 0 && arguments[0] instanceof e.MediaStreamTrack) {
          const i = arguments[0];
          let o, f, T;
          return this.getSenders().forEach((A) => {
            A.track === i && (o ? T = !0 : o = A);
          }), this.getReceivers().forEach((A) => (A.track === i && (f ? T = !0 : f = A), A.track === i)), T || o && f ? cn.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError")) : o ? o.getStats() : f ? f.getStats() : cn.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return n.apply(this, arguments);
      };
    }
    function N4(e) {
      e.RTCPeerConnection.prototype.getLocalStreams = function() {
        return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, Object.keys(this._shimmedLocalStreams).map((T) => this._shimmedLocalStreams[T][0]);
      };
      const n = e.RTCPeerConnection.prototype.addTrack;
      e.RTCPeerConnection.prototype.addTrack = function(T, A) {
        if (!A) return n.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const R = n.apply(this, arguments);
        return this._shimmedLocalStreams[A.id] ? this._shimmedLocalStreams[A.id].indexOf(R) === -1 && this._shimmedLocalStreams[A.id].push(R) : this._shimmedLocalStreams[A.id] = [A, R], R;
      };
      const i = e.RTCPeerConnection.prototype.addStream;
      e.RTCPeerConnection.prototype.addStream = function(T) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {}, T.getTracks().forEach((P) => {
          if (this.getSenders().find((z) => z.track === P)) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const A = this.getSenders();
        i.apply(this, arguments);
        const R = this.getSenders().filter((P) => A.indexOf(P) === -1);
        this._shimmedLocalStreams[T.id] = [T].concat(R);
      };
      const o = e.RTCPeerConnection.prototype.removeStream;
      e.RTCPeerConnection.prototype.removeStream = function(T) {
        return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, delete this._shimmedLocalStreams[T.id], o.apply(this, arguments);
      };
      const f = e.RTCPeerConnection.prototype.removeTrack;
      e.RTCPeerConnection.prototype.removeTrack = function(T) {
        return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, T && Object.keys(this._shimmedLocalStreams).forEach((A) => {
          const R = this._shimmedLocalStreams[A].indexOf(T);
          R !== -1 && this._shimmedLocalStreams[A].splice(R, 1), this._shimmedLocalStreams[A].length === 1 && delete this._shimmedLocalStreams[A];
        }), f.apply(this, arguments);
      };
    }
    function w4(e, n) {
      if (!e.RTCPeerConnection) return;
      if (e.RTCPeerConnection.prototype.addTrack && n.version >= 65) return N4(e);
      const i = e.RTCPeerConnection.prototype.getLocalStreams;
      e.RTCPeerConnection.prototype.getLocalStreams = function() {
        const P = i.apply(this);
        return this._reverseStreams = this._reverseStreams || {}, P.map((L) => this._reverseStreams[L.id]);
      };
      const o = e.RTCPeerConnection.prototype.addStream;
      e.RTCPeerConnection.prototype.addStream = function(P) {
        if (this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, P.getTracks().forEach((L) => {
          if (this.getSenders().find((Y) => Y.track === L)) throw new DOMException("Track already exists.", "InvalidAccessError");
        }), !this._reverseStreams[P.id]) {
          const L = new e.MediaStream(P.getTracks());
          this._streams[P.id] = L, this._reverseStreams[L.id] = P, P = L;
        }
        o.apply(this, [P]);
      };
      const f = e.RTCPeerConnection.prototype.removeStream;
      function T(P, L) {
        let z = L.sdp;
        return Object.keys(P._reverseStreams || []).forEach((Y) => {
          const te = P._reverseStreams[Y], oe = P._streams[te.id];
          z = z.replace(new RegExp(oe.id, "g"), te.id);
        }), new RTCSessionDescription({ type: L.type, sdp: z });
      }
      e.RTCPeerConnection.prototype.removeStream = function(P) {
        this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {}, f.apply(this, [this._streams[P.id] || P]), delete this._reverseStreams[this._streams[P.id] ? this._streams[P.id].id : P.id], delete this._streams[P.id];
      }, e.RTCPeerConnection.prototype.addTrack = function(P, L) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const z = [].slice.call(arguments, 1);
        if (z.length !== 1 || !z[0].getTracks().find((oe) => oe === P)) throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        if (this.getSenders().find((oe) => oe.track === P)) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {}, this._reverseStreams = this._reverseStreams || {};
        const te = this._streams[L.id];
        if (te) te.addTrack(P), cn.resolve().then(() => {
          this.dispatchEvent(new Event("negotiationneeded"));
        });
        else {
          const oe = new e.MediaStream([P]);
          this._streams[L.id] = oe, this._reverseStreams[oe.id] = L, this.addStream(oe);
        }
        return this.getSenders().find((oe) => oe.track === P);
      }, ["createOffer", "createAnswer"].forEach(function(P) {
        const L = e.RTCPeerConnection.prototype[P], z = { [P]() {
          const Y = arguments;
          return arguments.length && typeof arguments[0] == "function" ? L.apply(this, [(te) => {
            const oe = T(this, te);
            Y[0].apply(null, [oe]);
          }, (te) => {
            Y[1] && Y[1].apply(null, te);
          }, arguments[2]]) : L.apply(this, arguments).then((te) => T(this, te));
        } };
        e.RTCPeerConnection.prototype[P] = z[P];
      });
      const A = e.RTCPeerConnection.prototype.setLocalDescription;
      e.RTCPeerConnection.prototype.setLocalDescription = function() {
        return arguments.length && arguments[0].type ? (arguments[0] = function(P, L) {
          let z = L.sdp;
          return Object.keys(P._reverseStreams || []).forEach((Y) => {
            const te = P._reverseStreams[Y], oe = P._streams[te.id];
            z = z.replace(new RegExp(te.id, "g"), oe.id);
          }), new RTCSessionDescription({ type: L.type, sdp: z });
        }(this, arguments[0]), A.apply(this, arguments)) : A.apply(this, arguments);
      };
      const R = Object.getOwnPropertyDescriptor(e.RTCPeerConnection.prototype, "localDescription");
      Object.defineProperty(e.RTCPeerConnection.prototype, "localDescription", { get() {
        const P = R.get.apply(this);
        return P.type === "" ? P : T(this, P);
      } }), e.RTCPeerConnection.prototype.removeTrack = function(P) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        if (!P._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        if (P._pc !== this) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        let L;
        this._streams = this._streams || {}, Object.keys(this._streams).forEach((z) => {
          this._streams[z].getTracks().find((Y) => P.track === Y) && (L = this._streams[z]);
        }), L && (L.getTracks().length === 1 ? this.removeStream(this._reverseStreams[L.id]) : L.removeTrack(P.track), this.dispatchEvent(new Event("negotiationneeded")));
      };
    }
    function NC(e, n) {
      !e.RTCPeerConnection && e.webkitRTCPeerConnection && (e.RTCPeerConnection = e.webkitRTCPeerConnection), e.RTCPeerConnection && n.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(i) {
        const o = e.RTCPeerConnection.prototype[i], f = { [i]() {
          return arguments[0] = new (i === "addIceCandidate" ? e.RTCIceCandidate : e.RTCSessionDescription)(arguments[0]), o.apply(this, arguments);
        } };
        e.RTCPeerConnection.prototype[i] = f[i];
      });
    }
    function _4(e, n) {
      pf(e, "negotiationneeded", (i) => {
        const o = i.target;
        if (!(n.version < 72 || o.getConfiguration && o.getConfiguration().sdpSemantics === "plan-b") || o.signalingState === "stable") return i;
      });
    }
    var P4 = Object.freeze({ __proto__: null, fixNegotiationNeeded: _4, shimAddTrackRemoveTrack: w4, shimAddTrackRemoveTrackWithNative: N4, shimGetDisplayMedia: function(e, n) {
      e.navigator.mediaDevices && "getDisplayMedia" in e.navigator.mediaDevices || e.navigator.mediaDevices && (typeof n == "function" ? e.navigator.mediaDevices.getDisplayMedia = function(i) {
        return n(i).then((o) => {
          const f = i.video && i.video.width, T = i.video && i.video.height, A = i.video && i.video.frameRate;
          return i.video = { mandatory: { chromeMediaSource: "desktop", chromeMediaSourceId: o, maxFrameRate: A || 3 } }, f && (i.video.mandatory.maxWidth = f), T && (i.video.mandatory.maxHeight = T), e.navigator.mediaDevices.getUserMedia(i);
        });
      } : console.error("shimGetDisplayMedia: getSourceId argument is not a function"));
    }, shimGetSendersWithDtmf: S4, shimGetStats: I4, shimGetUserMedia: A4, shimMediaStream: O4, shimOnTrack: C4, shimPeerConnection: NC, shimSenderReceiverGetStats: R4 });
    function x4(e, n) {
      const i = e && e.navigator, o = e && e.MediaStreamTrack;
      if (i.getUserMedia = function(f, T, A) {
        IC("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia"), i.mediaDevices.getUserMedia(f).then(T, A);
      }, !(n.version > 55 && "autoGainControl" in i.mediaDevices.getSupportedConstraints())) {
        const f = function(A, R, P) {
          R in A && !(P in A) && (A[P] = A[R], delete A[R]);
        }, T = i.mediaDevices.getUserMedia.bind(i.mediaDevices);
        if (i.mediaDevices.getUserMedia = function(A) {
          return typeof A == "object" && typeof A.audio == "object" && (A = JSON.parse(JSON.stringify(A)), f(A.audio, "autoGainControl", "mozAutoGainControl"), f(A.audio, "noiseSuppression", "mozNoiseSuppression")), T(A);
        }, o && o.prototype.getSettings) {
          const A = o.prototype.getSettings;
          o.prototype.getSettings = function() {
            const R = A.apply(this, arguments);
            return f(R, "mozAutoGainControl", "autoGainControl"), f(R, "mozNoiseSuppression", "noiseSuppression"), R;
          };
        }
        if (o && o.prototype.applyConstraints) {
          const A = o.prototype.applyConstraints;
          o.prototype.applyConstraints = function(R) {
            return this.kind === "audio" && typeof R == "object" && (R = JSON.parse(JSON.stringify(R)), f(R, "autoGainControl", "mozAutoGainControl"), f(R, "noiseSuppression", "mozNoiseSuppression")), A.apply(this, [R]);
          };
        }
      }
    }
    function D4(e) {
      typeof e == "object" && e.RTCTrackEvent && "receiver" in e.RTCTrackEvent.prototype && !("transceiver" in e.RTCTrackEvent.prototype) && Object.defineProperty(e.RTCTrackEvent.prototype, "transceiver", { get() {
        return { receiver: this.receiver };
      } });
    }
    function wC(e, n) {
      if (typeof e != "object" || !e.RTCPeerConnection && !e.mozRTCPeerConnection) return;
      !e.RTCPeerConnection && e.mozRTCPeerConnection && (e.RTCPeerConnection = e.mozRTCPeerConnection), n.version < 53 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(f) {
        const T = e.RTCPeerConnection.prototype[f], A = { [f]() {
          return arguments[0] = new (f === "addIceCandidate" ? e.RTCIceCandidate : e.RTCSessionDescription)(arguments[0]), T.apply(this, arguments);
        } };
        e.RTCPeerConnection.prototype[f] = A[f];
      });
      const i = { inboundrtp: "inbound-rtp", outboundrtp: "outbound-rtp", candidatepair: "candidate-pair", localcandidate: "local-candidate", remotecandidate: "remote-candidate" }, o = e.RTCPeerConnection.prototype.getStats;
      e.RTCPeerConnection.prototype.getStats = function() {
        const [f, T, A] = arguments;
        return o.apply(this, [f || null]).then((R) => {
          if (n.version < 53 && !T) try {
            R.forEach((P) => {
              P.type = i[P.type] || P.type;
            });
          } catch (P) {
            if (P.name !== "TypeError") throw P;
            R.forEach((L, z) => {
              R.set(z, Object.assign({}, L, { type: i[L.type] || L.type }));
            });
          }
          return R;
        }).then(T, A);
      };
    }
    function M4(e) {
      if (typeof e != "object" || !e.RTCPeerConnection || !e.RTCRtpSender || e.RTCRtpSender && "getStats" in e.RTCRtpSender.prototype) return;
      const n = e.RTCPeerConnection.prototype.getSenders;
      n && (e.RTCPeerConnection.prototype.getSenders = function() {
        const o = n.apply(this, []);
        return o.forEach((f) => f._pc = this), o;
      });
      const i = e.RTCPeerConnection.prototype.addTrack;
      i && (e.RTCPeerConnection.prototype.addTrack = function() {
        const o = i.apply(this, arguments);
        return o._pc = this, o;
      }), e.RTCRtpSender.prototype.getStats = function() {
        return this.track ? this._pc.getStats(this.track) : cn.resolve(/* @__PURE__ */ new Map());
      };
    }
    function L4(e) {
      if (typeof e != "object" || !e.RTCPeerConnection || !e.RTCRtpSender || e.RTCRtpSender && "getStats" in e.RTCRtpReceiver.prototype) return;
      const n = e.RTCPeerConnection.prototype.getReceivers;
      n && (e.RTCPeerConnection.prototype.getReceivers = function() {
        const i = n.apply(this, []);
        return i.forEach((o) => o._pc = this), i;
      }), pf(e, "track", (i) => (i.receiver._pc = i.srcElement, i)), e.RTCRtpReceiver.prototype.getStats = function() {
        return this._pc.getStats(this.track);
      };
    }
    function k4(e) {
      e.RTCPeerConnection && !("removeStream" in e.RTCPeerConnection.prototype) && (e.RTCPeerConnection.prototype.removeStream = function(n) {
        IC("removeStream", "removeTrack"), this.getSenders().forEach((i) => {
          var o;
          i.track && on(o = n.getTracks()).call(o, i.track) && this.removeTrack(i);
        });
      });
    }
    function j4(e) {
      e.DataChannel && !e.RTCDataChannel && (e.RTCDataChannel = e.DataChannel);
    }
    function U4(e) {
      if (typeof e != "object" || !e.RTCPeerConnection) return;
      const n = e.RTCPeerConnection.prototype.addTransceiver;
      n && (e.RTCPeerConnection.prototype.addTransceiver = function() {
        this.setParametersPromises = [];
        let i = arguments[1] && arguments[1].sendEncodings;
        i === void 0 && (i = []), i = [...i];
        const o = i.length > 0;
        o && i.forEach((T) => {
          if ("rid" in T && !/^[a-z0-9]{0,16}$/i.test(T.rid))
            throw new TypeError("Invalid RID value provided.");
          if ("scaleResolutionDownBy" in T && !(parseFloat(T.scaleResolutionDownBy) >= 1)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
          if ("maxFramerate" in T && !(parseFloat(T.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
        });
        const f = n.apply(this, arguments);
        if (o) {
          const { sender: T } = f, A = T.getParameters();
          (!("encodings" in A) || A.encodings.length === 1 && Object.keys(A.encodings[0]).length === 0) && (A.encodings = i, T.sendEncodings = i, this.setParametersPromises.push(T.setParameters(A).then(() => {
            delete T.sendEncodings;
          }).catch(() => {
            delete T.sendEncodings;
          })));
        }
        return f;
      });
    }
    function H4(e) {
      if (typeof e != "object" || !e.RTCRtpSender) return;
      const n = e.RTCRtpSender.prototype.getParameters;
      n && (e.RTCRtpSender.prototype.getParameters = function() {
        const i = n.apply(this, arguments);
        return "encodings" in i || (i.encodings = [].concat(this.sendEncodings || [{}])), i;
      });
    }
    function B4(e) {
      if (typeof e != "object" || !e.RTCPeerConnection) return;
      const n = e.RTCPeerConnection.prototype.createOffer;
      e.RTCPeerConnection.prototype.createOffer = function() {
        return this.setParametersPromises && this.setParametersPromises.length ? cn.all(this.setParametersPromises).then(() => n.apply(this, arguments)).finally(() => {
          this.setParametersPromises = [];
        }) : n.apply(this, arguments);
      };
    }
    function z4(e) {
      if (typeof e != "object" || !e.RTCPeerConnection) return;
      const n = e.RTCPeerConnection.prototype.createAnswer;
      e.RTCPeerConnection.prototype.createAnswer = function() {
        return this.setParametersPromises && this.setParametersPromises.length ? cn.all(this.setParametersPromises).then(() => n.apply(this, arguments)).finally(() => {
          this.setParametersPromises = [];
        }) : n.apply(this, arguments);
      };
    }
    var F4 = Object.freeze({ __proto__: null, shimAddTransceiver: U4, shimCreateAnswer: z4, shimCreateOffer: B4, shimGetDisplayMedia: function(e, n) {
      e.navigator.mediaDevices && "getDisplayMedia" in e.navigator.mediaDevices || e.navigator.mediaDevices && (e.navigator.mediaDevices.getDisplayMedia = function(i) {
        if (!i || !i.video) {
          const o = new DOMException("getDisplayMedia without video constraints is undefined");
          return o.name = "NotFoundError", o.code = 8, cn.reject(o);
        }
        return i.video === !0 ? i.video = { mediaSource: n } : i.video.mediaSource = n, e.navigator.mediaDevices.getUserMedia(i);
      });
    }, shimGetParameters: H4, shimGetUserMedia: x4, shimOnTrack: D4, shimPeerConnection: wC, shimRTCDataChannel: j4, shimReceiverGetStats: L4, shimRemoveStream: k4, shimSenderGetStats: M4 });
    function G4(e) {
      if (typeof e == "object" && e.RTCPeerConnection) {
        if ("getLocalStreams" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.getLocalStreams = function() {
          return this._localStreams || (this._localStreams = []), this._localStreams;
        }), !("addStream" in e.RTCPeerConnection.prototype)) {
          const n = e.RTCPeerConnection.prototype.addTrack;
          e.RTCPeerConnection.prototype.addStream = function(i) {
            var o;
            this._localStreams || (this._localStreams = []), on(o = this._localStreams).call(o, i) || this._localStreams.push(i), i.getAudioTracks().forEach((f) => n.call(this, f, i)), i.getVideoTracks().forEach((f) => n.call(this, f, i));
          }, e.RTCPeerConnection.prototype.addTrack = function(i) {
            for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), T = 1; T < o; T++) f[T - 1] = arguments[T];
            return f && f.forEach((A) => {
              var R;
              this._localStreams ? on(R = this._localStreams).call(R, A) || this._localStreams.push(A) : this._localStreams = [A];
            }), n.apply(this, arguments);
          };
        }
        "removeStream" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.removeStream = function(n) {
          this._localStreams || (this._localStreams = []);
          const i = this._localStreams.indexOf(n);
          if (i === -1) return;
          this._localStreams.splice(i, 1);
          const o = n.getTracks();
          this.getSenders().forEach((f) => {
            on(o).call(o, f.track) && this.removeTrack(f);
          });
        });
      }
    }
    function V4(e) {
      if (typeof e == "object" && e.RTCPeerConnection && ("getRemoteStreams" in e.RTCPeerConnection.prototype || (e.RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this._remoteStreams ? this._remoteStreams : [];
      }), !("onaddstream" in e.RTCPeerConnection.prototype))) {
        Object.defineProperty(e.RTCPeerConnection.prototype, "onaddstream", { get() {
          return this._onaddstream;
        }, set(i) {
          this._onaddstream && (this.removeEventListener("addstream", this._onaddstream), this.removeEventListener("track", this._onaddstreampoly)), this.addEventListener("addstream", this._onaddstream = i), this.addEventListener("track", this._onaddstreampoly = (o) => {
            o.streams.forEach((f) => {
              var T;
              if (this._remoteStreams || (this._remoteStreams = []), on(T = this._remoteStreams).call(T, f)) return;
              this._remoteStreams.push(f);
              const A = new Event("addstream");
              A.stream = f, this.dispatchEvent(A);
            });
          });
        } });
        const n = e.RTCPeerConnection.prototype.setRemoteDescription;
        e.RTCPeerConnection.prototype.setRemoteDescription = function() {
          const i = this;
          return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(o) {
            o.streams.forEach((f) => {
              if (i._remoteStreams || (i._remoteStreams = []), i._remoteStreams.indexOf(f) >= 0) return;
              i._remoteStreams.push(f);
              const T = new Event("addstream");
              T.stream = f, i.dispatchEvent(T);
            });
          }), n.apply(i, arguments);
        };
      }
    }
    function Y4(e) {
      if (typeof e != "object" || !e.RTCPeerConnection) return;
      const n = e.RTCPeerConnection.prototype, i = n.createOffer, o = n.createAnswer, f = n.setLocalDescription, T = n.setRemoteDescription, A = n.addIceCandidate;
      n.createOffer = function(P, L) {
        const z = arguments.length >= 2 ? arguments[2] : arguments[0], Y = i.apply(this, [z]);
        return L ? (Y.then(P, L), cn.resolve()) : Y;
      }, n.createAnswer = function(P, L) {
        const z = arguments.length >= 2 ? arguments[2] : arguments[0], Y = o.apply(this, [z]);
        return L ? (Y.then(P, L), cn.resolve()) : Y;
      };
      let R = function(P, L, z) {
        const Y = f.apply(this, [P]);
        return z ? (Y.then(L, z), cn.resolve()) : Y;
      };
      n.setLocalDescription = R, R = function(P, L, z) {
        const Y = T.apply(this, [P]);
        return z ? (Y.then(L, z), cn.resolve()) : Y;
      }, n.setRemoteDescription = R, R = function(P, L, z) {
        const Y = A.apply(this, [P]);
        return z ? (Y.then(L, z), cn.resolve()) : Y;
      }, n.addIceCandidate = R;
    }
    function X4(e) {
      const n = e && e.navigator;
      if (n.mediaDevices && n.mediaDevices.getUserMedia) {
        const i = n.mediaDevices, o = i.getUserMedia.bind(i);
        n.mediaDevices.getUserMedia = (f) => o(W4(f));
      }
      !n.getUserMedia && n.mediaDevices && n.mediaDevices.getUserMedia && (n.getUserMedia = (function(i, o, f) {
        n.mediaDevices.getUserMedia(i).then(o, f);
      }).bind(n));
    }
    function W4(e) {
      return e && e.video !== void 0 ? Object.assign({}, e, { video: v4(e.video) }) : e;
    }
    function q4(e) {
      if (!e.RTCPeerConnection) return;
      const n = e.RTCPeerConnection;
      e.RTCPeerConnection = function(i, o) {
        if (i && i.iceServers) {
          const f = [];
          for (let T = 0; T < i.iceServers.length; T++) {
            let A = i.iceServers[T];
            !A.hasOwnProperty("urls") && A.hasOwnProperty("url") ? (IC("RTCIceServer.url", "RTCIceServer.urls"), A = JSON.parse(JSON.stringify(A)), A.urls = A.url, delete A.url, f.push(A)) : f.push(i.iceServers[T]);
          }
          i.iceServers = f;
        }
        return new n(i, o);
      }, e.RTCPeerConnection.prototype = n.prototype, "generateCertificate" in n && Object.defineProperty(e.RTCPeerConnection, "generateCertificate", { get: () => n.generateCertificate });
    }
    function K4(e) {
      typeof e == "object" && e.RTCTrackEvent && "receiver" in e.RTCTrackEvent.prototype && !("transceiver" in e.RTCTrackEvent.prototype) && Object.defineProperty(e.RTCTrackEvent.prototype, "transceiver", { get() {
        return { receiver: this.receiver };
      } });
    }
    function J4(e) {
      const n = e.RTCPeerConnection.prototype.createOffer;
      e.RTCPeerConnection.prototype.createOffer = function(i) {
        if (i) {
          i.offerToReceiveAudio !== void 0 && (i.offerToReceiveAudio = !!i.offerToReceiveAudio);
          const o = this.getTransceivers().find((T) => T.receiver.track.kind === "audio");
          i.offerToReceiveAudio === !1 && o ? o.direction === "sendrecv" ? o.setDirection ? o.setDirection("sendonly") : o.direction = "sendonly" : o.direction === "recvonly" && (o.setDirection ? o.setDirection("inactive") : o.direction = "inactive") : i.offerToReceiveAudio !== !0 || o || this.addTransceiver("audio", { direction: "recvonly" }), i.offerToReceiveVideo !== void 0 && (i.offerToReceiveVideo = !!i.offerToReceiveVideo);
          const f = this.getTransceivers().find((T) => T.receiver.track.kind === "video");
          i.offerToReceiveVideo === !1 && f ? f.direction === "sendrecv" ? f.setDirection ? f.setDirection("sendonly") : f.direction = "sendonly" : f.direction === "recvonly" && (f.setDirection ? f.setDirection("inactive") : f.direction = "inactive") : i.offerToReceiveVideo !== !0 || f || this.addTransceiver("video", { direction: "recvonly" });
        }
        return n.apply(this, arguments);
      };
    }
    function Z4(e) {
      typeof e != "object" || e.AudioContext || (e.AudioContext = e.webkitAudioContext);
    }
    var Q4 = Object.freeze({ __proto__: null, shimAudioContext: Z4, shimCallbacksAPI: Y4, shimConstraints: W4, shimCreateOfferLegacy: J4, shimGetUserMedia: X4, shimLocalStreamsAPI: G4, shimRTCIceServerUrls: q4, shimRemoteStreamsAPI: V4, shimTrackEventTransceiver: K4 }), $4 = `	
\v\f\r                　\u2028\u2029\uFEFF`, See = Ke, Iee = Oo, _C = $4, ex = p("".replace), Ree = RegExp("^[" + _C + "]+"), Nee = RegExp("(^|[^" + _C + "])[" + _C + "]+$"), PC = function(e) {
      return function(n) {
        var i = Iee(See(n));
        return 1 & e && (i = ex(i, Ree, "")), 2 & e && (i = ex(i, Nee, "$1")), i;
      };
    }, wee = { start: PC(1), end: PC(2), trim: PC(3) }, _ee = Z_.PROPER, Pee = b, tx = $4, xee = wee.trim;
    _r({ target: "String", proto: !0, forced: function(e) {
      return Pee(function() {
        return !!tx[e]() || "​᠎"[e]() !== "​᠎" || _ee && tx[e].name !== e;
      });
    }("trim") }, { trim: function() {
      return xee(this);
    } });
    var Dee = Jo("String").trim, Mee = m, Lee = Dee, xC = String.prototype, kee = function(e) {
      var n = e.trim;
      return typeof e == "string" || e === xC || Mee(xC, e) && n === xC.trim ? Lee : n;
    }, Ys = h(kee), nx = { exports: {} };
    (function(e) {
      const n = { generateIdentifier: function() {
        return Math.random().toString(36).substring(2, 12);
      } };
      n.localCName = n.generateIdentifier(), n.splitLines = function(i) {
        return i.trim().split(`
`).map((o) => o.trim());
      }, n.splitSections = function(i) {
        return i.split(`
m=`).map((o, f) => (f > 0 ? "m=" + o : o).trim() + `\r
`);
      }, n.getDescription = function(i) {
        const o = n.splitSections(i);
        return o && o[0];
      }, n.getMediaSections = function(i) {
        const o = n.splitSections(i);
        return o.shift(), o;
      }, n.matchPrefix = function(i, o) {
        return n.splitLines(i).filter((f) => f.indexOf(o) === 0);
      }, n.parseCandidate = function(i) {
        let o;
        o = i.indexOf("a=candidate:") === 0 ? i.substring(12).split(" ") : i.substring(10).split(" ");
        const f = { foundation: o[0], component: { 1: "rtp", 2: "rtcp" }[o[1]] || o[1], protocol: o[2].toLowerCase(), priority: parseInt(o[3], 10), ip: o[4], address: o[4], port: parseInt(o[5], 10), type: o[7] };
        for (let T = 8; T < o.length; T += 2) switch (o[T]) {
          case "raddr":
            f.relatedAddress = o[T + 1];
            break;
          case "rport":
            f.relatedPort = parseInt(o[T + 1], 10);
            break;
          case "tcptype":
            f.tcpType = o[T + 1];
            break;
          case "ufrag":
            f.ufrag = o[T + 1], f.usernameFragment = o[T + 1];
            break;
          default:
            f[o[T]] === void 0 && (f[o[T]] = o[T + 1]);
        }
        return f;
      }, n.writeCandidate = function(i) {
        const o = [];
        o.push(i.foundation);
        const f = i.component;
        f === "rtp" ? o.push(1) : f === "rtcp" ? o.push(2) : o.push(f), o.push(i.protocol.toUpperCase()), o.push(i.priority), o.push(i.address || i.ip), o.push(i.port);
        const T = i.type;
        return o.push("typ"), o.push(T), T !== "host" && i.relatedAddress && i.relatedPort && (o.push("raddr"), o.push(i.relatedAddress), o.push("rport"), o.push(i.relatedPort)), i.tcpType && i.protocol.toLowerCase() === "tcp" && (o.push("tcptype"), o.push(i.tcpType)), (i.usernameFragment || i.ufrag) && (o.push("ufrag"), o.push(i.usernameFragment || i.ufrag)), "candidate:" + o.join(" ");
      }, n.parseIceOptions = function(i) {
        return i.substring(14).split(" ");
      }, n.parseRtpMap = function(i) {
        let o = i.substring(9).split(" ");
        const f = { payloadType: parseInt(o.shift(), 10) };
        return o = o[0].split("/"), f.name = o[0], f.clockRate = parseInt(o[1], 10), f.channels = o.length === 3 ? parseInt(o[2], 10) : 1, f.numChannels = f.channels, f;
      }, n.writeRtpMap = function(i) {
        let o = i.payloadType;
        i.preferredPayloadType !== void 0 && (o = i.preferredPayloadType);
        const f = i.channels || i.numChannels || 1;
        return "a=rtpmap:" + o + " " + i.name + "/" + i.clockRate + (f !== 1 ? "/" + f : "") + `\r
`;
      }, n.parseExtmap = function(i) {
        const o = i.substring(9).split(" ");
        return { id: parseInt(o[0], 10), direction: o[0].indexOf("/") > 0 ? o[0].split("/")[1] : "sendrecv", uri: o[1], attributes: o.slice(2).join(" ") };
      }, n.writeExtmap = function(i) {
        return "a=extmap:" + (i.id || i.preferredId) + (i.direction && i.direction !== "sendrecv" ? "/" + i.direction : "") + " " + i.uri + (i.attributes ? " " + i.attributes : "") + `\r
`;
      }, n.parseFmtp = function(i) {
        const o = {};
        let f;
        const T = i.substring(i.indexOf(" ") + 1).split(";");
        for (let A = 0; A < T.length; A++) f = T[A].trim().split("="), o[f[0].trim()] = f[1];
        return o;
      }, n.writeFmtp = function(i) {
        let o = "", f = i.payloadType;
        if (i.preferredPayloadType !== void 0 && (f = i.preferredPayloadType), i.parameters && Object.keys(i.parameters).length) {
          const T = [];
          Object.keys(i.parameters).forEach((A) => {
            i.parameters[A] !== void 0 ? T.push(A + "=" + i.parameters[A]) : T.push(A);
          }), o += "a=fmtp:" + f + " " + T.join(";") + `\r
`;
        }
        return o;
      }, n.parseRtcpFb = function(i) {
        const o = i.substring(i.indexOf(" ") + 1).split(" ");
        return { type: o.shift(), parameter: o.join(" ") };
      }, n.writeRtcpFb = function(i) {
        let o = "", f = i.payloadType;
        return i.preferredPayloadType !== void 0 && (f = i.preferredPayloadType), i.rtcpFeedback && i.rtcpFeedback.length && i.rtcpFeedback.forEach((T) => {
          o += "a=rtcp-fb:" + f + " " + T.type + (T.parameter && T.parameter.length ? " " + T.parameter : "") + `\r
`;
        }), o;
      }, n.parseSsrcMedia = function(i) {
        const o = i.indexOf(" "), f = { ssrc: parseInt(i.substring(7, o), 10) }, T = i.indexOf(":", o);
        return T > -1 ? (f.attribute = i.substring(o + 1, T), f.value = i.substring(T + 1)) : f.attribute = i.substring(o + 1), f;
      }, n.parseSsrcGroup = function(i) {
        const o = i.substring(13).split(" ");
        return { semantics: o.shift(), ssrcs: o.map((f) => parseInt(f, 10)) };
      }, n.getMid = function(i) {
        const o = n.matchPrefix(i, "a=mid:")[0];
        if (o) return o.substring(6);
      }, n.parseFingerprint = function(i) {
        const o = i.substring(14).split(" ");
        return { algorithm: o[0].toLowerCase(), value: o[1].toUpperCase() };
      }, n.getDtlsParameters = function(i, o) {
        return { role: "auto", fingerprints: n.matchPrefix(i + o, "a=fingerprint:").map(n.parseFingerprint) };
      }, n.writeDtlsParameters = function(i, o) {
        let f = "a=setup:" + o + `\r
`;
        return i.fingerprints.forEach((T) => {
          f += "a=fingerprint:" + T.algorithm + " " + T.value + `\r
`;
        }), f;
      }, n.parseCryptoLine = function(i) {
        const o = i.substring(9).split(" ");
        return { tag: parseInt(o[0], 10), cryptoSuite: o[1], keyParams: o[2], sessionParams: o.slice(3) };
      }, n.writeCryptoLine = function(i) {
        return "a=crypto:" + i.tag + " " + i.cryptoSuite + " " + (typeof i.keyParams == "object" ? n.writeCryptoKeyParams(i.keyParams) : i.keyParams) + (i.sessionParams ? " " + i.sessionParams.join(" ") : "") + `\r
`;
      }, n.parseCryptoKeyParams = function(i) {
        if (i.indexOf("inline:") !== 0) return null;
        const o = i.substring(7).split("|");
        return { keyMethod: "inline", keySalt: o[0], lifeTime: o[1], mkiValue: o[2] ? o[2].split(":")[0] : void 0, mkiLength: o[2] ? o[2].split(":")[1] : void 0 };
      }, n.writeCryptoKeyParams = function(i) {
        return i.keyMethod + ":" + i.keySalt + (i.lifeTime ? "|" + i.lifeTime : "") + (i.mkiValue && i.mkiLength ? "|" + i.mkiValue + ":" + i.mkiLength : "");
      }, n.getCryptoParameters = function(i, o) {
        return n.matchPrefix(i + o, "a=crypto:").map(n.parseCryptoLine);
      }, n.getIceParameters = function(i, o) {
        const f = n.matchPrefix(i + o, "a=ice-ufrag:")[0], T = n.matchPrefix(i + o, "a=ice-pwd:")[0];
        return f && T ? { usernameFragment: f.substring(12), password: T.substring(10) } : null;
      }, n.writeIceParameters = function(i) {
        let o = "a=ice-ufrag:" + i.usernameFragment + `\r
a=ice-pwd:` + i.password + `\r
`;
        return i.iceLite && (o += `a=ice-lite\r
`), o;
      }, n.parseRtpParameters = function(i) {
        const o = { codecs: [], headerExtensions: [], fecMechanisms: [], rtcp: [] }, f = n.splitLines(i)[0].split(" ");
        o.profile = f[2];
        for (let A = 3; A < f.length; A++) {
          const R = f[A], P = n.matchPrefix(i, "a=rtpmap:" + R + " ")[0];
          if (P) {
            const L = n.parseRtpMap(P), z = n.matchPrefix(i, "a=fmtp:" + R + " ");
            switch (L.parameters = z.length ? n.parseFmtp(z[0]) : {}, L.rtcpFeedback = n.matchPrefix(i, "a=rtcp-fb:" + R + " ").map(n.parseRtcpFb), o.codecs.push(L), L.name.toUpperCase()) {
              case "RED":
              case "ULPFEC":
                o.fecMechanisms.push(L.name.toUpperCase());
            }
          }
        }
        n.matchPrefix(i, "a=extmap:").forEach((A) => {
          o.headerExtensions.push(n.parseExtmap(A));
        });
        const T = n.matchPrefix(i, "a=rtcp-fb:* ").map(n.parseRtcpFb);
        return o.codecs.forEach((A) => {
          T.forEach((R) => {
            A.rtcpFeedback.find((P) => P.type === R.type && P.parameter === R.parameter) || A.rtcpFeedback.push(R);
          });
        }), o;
      }, n.writeRtpDescription = function(i, o) {
        let f = "";
        f += "m=" + i + " ", f += o.codecs.length > 0 ? "9" : "0", f += " " + (o.profile || "UDP/TLS/RTP/SAVPF") + " ", f += o.codecs.map((A) => A.preferredPayloadType !== void 0 ? A.preferredPayloadType : A.payloadType).join(" ") + `\r
`, f += `c=IN IP4 0.0.0.0\r
`, f += `a=rtcp:9 IN IP4 0.0.0.0\r
`, o.codecs.forEach((A) => {
          f += n.writeRtpMap(A), f += n.writeFmtp(A), f += n.writeRtcpFb(A);
        });
        let T = 0;
        return o.codecs.forEach((A) => {
          A.maxptime > T && (T = A.maxptime);
        }), T > 0 && (f += "a=maxptime:" + T + `\r
`), o.headerExtensions && o.headerExtensions.forEach((A) => {
          f += n.writeExtmap(A);
        }), f;
      }, n.parseRtpEncodingParameters = function(i) {
        const o = [], f = n.parseRtpParameters(i), T = f.fecMechanisms.indexOf("RED") !== -1, A = f.fecMechanisms.indexOf("ULPFEC") !== -1, R = n.matchPrefix(i, "a=ssrc:").map((te) => n.parseSsrcMedia(te)).filter((te) => te.attribute === "cname"), P = R.length > 0 && R[0].ssrc;
        let L;
        const z = n.matchPrefix(i, "a=ssrc-group:FID").map((te) => te.substring(17).split(" ").map((oe) => parseInt(oe, 10)));
        z.length > 0 && z[0].length > 1 && z[0][0] === P && (L = z[0][1]), f.codecs.forEach((te) => {
          if (te.name.toUpperCase() === "RTX" && te.parameters.apt) {
            let oe = { ssrc: P, codecPayloadType: parseInt(te.parameters.apt, 10) };
            P && L && (oe.rtx = { ssrc: L }), o.push(oe), T && (oe = JSON.parse(JSON.stringify(oe)), oe.fec = { ssrc: P, mechanism: A ? "red+ulpfec" : "red" }, o.push(oe));
          }
        }), o.length === 0 && P && o.push({ ssrc: P });
        let Y = n.matchPrefix(i, "b=");
        return Y.length && (Y = Y[0].indexOf("b=TIAS:") === 0 ? parseInt(Y[0].substring(7), 10) : Y[0].indexOf("b=AS:") === 0 ? 1e3 * parseInt(Y[0].substring(5), 10) * 0.95 - 16e3 : void 0, o.forEach((te) => {
          te.maxBitrate = Y;
        })), o;
      }, n.parseRtcpParameters = function(i) {
        const o = {}, f = n.matchPrefix(i, "a=ssrc:").map((R) => n.parseSsrcMedia(R)).filter((R) => R.attribute === "cname")[0];
        f && (o.cname = f.value, o.ssrc = f.ssrc);
        const T = n.matchPrefix(i, "a=rtcp-rsize");
        o.reducedSize = T.length > 0, o.compound = T.length === 0;
        const A = n.matchPrefix(i, "a=rtcp-mux");
        return o.mux = A.length > 0, o;
      }, n.writeRtcpParameters = function(i) {
        let o = "";
        return i.reducedSize && (o += `a=rtcp-rsize\r
`), i.mux && (o += `a=rtcp-mux\r
`), i.ssrc !== void 0 && i.cname && (o += "a=ssrc:" + i.ssrc + " cname:" + i.cname + `\r
`), o;
      }, n.parseMsid = function(i) {
        let o;
        const f = n.matchPrefix(i, "a=msid:");
        if (f.length === 1) return o = f[0].substring(7).split(" "), { stream: o[0], track: o[1] };
        const T = n.matchPrefix(i, "a=ssrc:").map((A) => n.parseSsrcMedia(A)).filter((A) => A.attribute === "msid");
        return T.length > 0 ? (o = T[0].value.split(" "), { stream: o[0], track: o[1] }) : void 0;
      }, n.parseSctpDescription = function(i) {
        const o = n.parseMLine(i), f = n.matchPrefix(i, "a=max-message-size:");
        let T;
        f.length > 0 && (T = parseInt(f[0].substring(19), 10)), isNaN(T) && (T = 65536);
        const A = n.matchPrefix(i, "a=sctp-port:");
        if (A.length > 0) return { port: parseInt(A[0].substring(12), 10), protocol: o.fmt, maxMessageSize: T };
        const R = n.matchPrefix(i, "a=sctpmap:");
        if (R.length > 0) {
          const P = R[0].substring(10).split(" ");
          return { port: parseInt(P[0], 10), protocol: P[1], maxMessageSize: T };
        }
      }, n.writeSctpDescription = function(i, o) {
        let f = [];
        return f = i.protocol !== "DTLS/SCTP" ? ["m=" + i.kind + " 9 " + i.protocol + " " + o.protocol + `\r
`, `c=IN IP4 0.0.0.0\r
`, "a=sctp-port:" + o.port + `\r
`] : ["m=" + i.kind + " 9 " + i.protocol + " " + o.port + `\r
`, `c=IN IP4 0.0.0.0\r
`, "a=sctpmap:" + o.port + " " + o.protocol + ` 65535\r
`], o.maxMessageSize !== void 0 && f.push("a=max-message-size:" + o.maxMessageSize + `\r
`), f.join("");
      }, n.generateSessionId = function() {
        return Math.random().toString().substr(2, 22);
      }, n.writeSessionBoilerplate = function(i, o, f) {
        let T;
        const A = o !== void 0 ? o : 2;
        return T = i || n.generateSessionId(), `v=0\r
o=` + (f || "thisisadapterortc") + " " + T + " " + A + ` IN IP4 127.0.0.1\r
s=-\r
t=0 0\r
`;
      }, n.getDirection = function(i, o) {
        const f = n.splitLines(i);
        for (let T = 0; T < f.length; T++) switch (f[T]) {
          case "a=sendrecv":
          case "a=sendonly":
          case "a=recvonly":
          case "a=inactive":
            return f[T].substring(2);
        }
        return o ? n.getDirection(o) : "sendrecv";
      }, n.getKind = function(i) {
        return n.splitLines(i)[0].split(" ")[0].substring(2);
      }, n.isRejected = function(i) {
        return i.split(" ", 2)[1] === "0";
      }, n.parseMLine = function(i) {
        const o = n.splitLines(i)[0].substring(2).split(" ");
        return { kind: o[0], port: parseInt(o[1], 10), protocol: o[2], fmt: o.slice(3).join(" ") };
      }, n.parseOLine = function(i) {
        const o = n.matchPrefix(i, "o=")[0].substring(2).split(" ");
        return { username: o[0], sessionId: o[1], sessionVersion: parseInt(o[2], 10), netType: o[3], addressType: o[4], address: o[5] };
      }, n.isValidSDP = function(i) {
        if (typeof i != "string" || i.length === 0) return !1;
        const o = n.splitLines(i);
        for (let f = 0; f < o.length; f++) if (o[f].length < 2 || o[f].charAt(1) !== "=") return !1;
        return !0;
      }, e.exports = n;
    })(nx);
    var rx = nx.exports, Wh = h(rx), jee = a({ __proto__: null, default: Wh }, [rx]);
    function N1(e) {
      if (!e.RTCIceCandidate || e.RTCIceCandidate && "foundation" in e.RTCIceCandidate.prototype) return;
      const n = e.RTCIceCandidate;
      e.RTCIceCandidate = function(i) {
        if (typeof i == "object" && i.candidate && i.candidate.indexOf("a=") === 0 && ((i = JSON.parse(JSON.stringify(i))).candidate = i.candidate.substr(2)), i.candidate && i.candidate.length) {
          const o = new n(i), f = Wh.parseCandidate(i.candidate), T = Object.assign(o, f);
          return T.toJSON = function() {
            return { candidate: T.candidate, sdpMid: T.sdpMid, sdpMLineIndex: T.sdpMLineIndex, usernameFragment: T.usernameFragment };
          }, T;
        }
        return new n(i);
      }, e.RTCIceCandidate.prototype = n.prototype, pf(e, "icecandidate", (i) => (i.candidate && Object.defineProperty(i, "candidate", { value: new e.RTCIceCandidate(i.candidate), writable: "false" }), i));
    }
    function DC(e) {
      !e.RTCIceCandidate || e.RTCIceCandidate && "relayProtocol" in e.RTCIceCandidate.prototype || pf(e, "icecandidate", (n) => {
        if (n.candidate) {
          const i = Wh.parseCandidate(n.candidate.candidate);
          i.type === "relay" && (n.candidate.relayProtocol = { 0: "tls", 1: "tcp", 2: "udp" }[i.priority >> 24]);
        }
        return n;
      });
    }
    function w1(e, n) {
      if (!e.RTCPeerConnection) return;
      "sctp" in e.RTCPeerConnection.prototype || Object.defineProperty(e.RTCPeerConnection.prototype, "sctp", { get() {
        return this._sctp === void 0 ? null : this._sctp;
      } });
      const i = function(R) {
        if (!R || !R.sdp) return !1;
        const P = Wh.splitSections(R.sdp);
        return P.shift(), P.some((L) => {
          const z = Wh.parseMLine(L);
          return z && z.kind === "application" && z.protocol.indexOf("SCTP") !== -1;
        });
      }, o = function(R) {
        const P = R.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (P === null || P.length < 2) return -1;
        const L = parseInt(P[1], 10);
        return L != L ? -1 : L;
      }, f = function(R) {
        let P = 65536;
        return n.browser === "firefox" && (P = n.version < 57 ? R === -1 ? 16384 : 2147483637 : n.version < 60 ? n.version === 57 ? 65535 : 65536 : 2147483637), P;
      }, T = function(R, P) {
        let L = 65536;
        n.browser === "firefox" && n.version === 57 && (L = 65535);
        const z = Wh.matchPrefix(R.sdp, "a=max-message-size:");
        return z.length > 0 ? L = parseInt(z[0].substr(19), 10) : n.browser === "firefox" && P !== -1 && (L = 2147483637), L;
      }, A = e.RTCPeerConnection.prototype.setRemoteDescription;
      e.RTCPeerConnection.prototype.setRemoteDescription = function() {
        if (this._sctp = null, n.browser === "chrome" && n.version >= 76) {
          const { sdpSemantics: R } = this.getConfiguration();
          R === "plan-b" && Object.defineProperty(this, "sctp", { get() {
            return this._sctp === void 0 ? null : this._sctp;
          }, enumerable: !0, configurable: !0 });
        }
        if (i(arguments[0])) {
          const R = o(arguments[0]), P = f(R), L = T(arguments[0], R);
          let z;
          z = P === 0 && L === 0 ? Number.POSITIVE_INFINITY : P === 0 || L === 0 ? Math.max(P, L) : Math.min(P, L);
          const Y = {};
          Object.defineProperty(Y, "maxMessageSize", { get: () => z }), this._sctp = Y;
        }
        return A.apply(this, arguments);
      };
    }
    function _1(e) {
      if (!e.RTCPeerConnection || !("createDataChannel" in e.RTCPeerConnection.prototype)) return;
      function n(o, f) {
        const T = o.send;
        o.send = function() {
          const A = arguments[0], R = A.length || A.size || A.byteLength;
          if (o.readyState === "open" && f.sctp && R > f.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + f.sctp.maxMessageSize + " bytes)");
          return T.apply(o, arguments);
        };
      }
      const i = e.RTCPeerConnection.prototype.createDataChannel;
      e.RTCPeerConnection.prototype.createDataChannel = function() {
        const o = i.apply(this, arguments);
        return n(o, this), o;
      }, pf(e, "datachannel", (o) => (n(o.channel, o.target), o));
    }
    function MC(e) {
      if (!e.RTCPeerConnection || "connectionState" in e.RTCPeerConnection.prototype) return;
      const n = e.RTCPeerConnection.prototype;
      Object.defineProperty(n, "connectionState", { get() {
        return { completed: "connected", checking: "connecting" }[this.iceConnectionState] || this.iceConnectionState;
      }, enumerable: !0, configurable: !0 }), Object.defineProperty(n, "onconnectionstatechange", { get() {
        return this._onconnectionstatechange || null;
      }, set(i) {
        this._onconnectionstatechange && (this.removeEventListener("connectionstatechange", this._onconnectionstatechange), delete this._onconnectionstatechange), i && this.addEventListener("connectionstatechange", this._onconnectionstatechange = i);
      }, enumerable: !0, configurable: !0 }), ["setLocalDescription", "setRemoteDescription"].forEach((i) => {
        const o = n[i];
        n[i] = function() {
          return this._connectionstatechangepoly || (this._connectionstatechangepoly = (f) => {
            const T = f.target;
            if (T._lastConnectionState !== T.connectionState) {
              T._lastConnectionState = T.connectionState;
              const A = new Event("connectionstatechange", f);
              T.dispatchEvent(A);
            }
            return f;
          }, this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly)), o.apply(this, arguments);
        };
      });
    }
    function LC(e, n) {
      if (!e.RTCPeerConnection || n.browser === "chrome" && n.version >= 71 || n.browser === "safari" && n.version >= 605) return;
      const i = e.RTCPeerConnection.prototype.setRemoteDescription;
      e.RTCPeerConnection.prototype.setRemoteDescription = function(o) {
        if (o && o.sdp && o.sdp.indexOf(`
a=extmap-allow-mixed`) !== -1) {
          const f = o.sdp.split(`
`).filter((T) => Ys(T).call(T) !== "a=extmap-allow-mixed").join(`
`);
          e.RTCSessionDescription && o instanceof e.RTCSessionDescription ? arguments[0] = new e.RTCSessionDescription({ type: o.type, sdp: f }) : o.sdp = f;
        }
        return i.apply(this, arguments);
      };
    }
    function P1(e, n) {
      if (!e.RTCPeerConnection || !e.RTCPeerConnection.prototype) return;
      const i = e.RTCPeerConnection.prototype.addIceCandidate;
      i && i.length !== 0 && (e.RTCPeerConnection.prototype.addIceCandidate = function() {
        return arguments[0] ? (n.browser === "chrome" && n.version < 78 || n.browser === "firefox" && n.version < 68 || n.browser === "safari") && arguments[0] && arguments[0].candidate === "" ? cn.resolve() : i.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), cn.resolve());
      });
    }
    function x1(e, n) {
      if (!e.RTCPeerConnection || !e.RTCPeerConnection.prototype) return;
      const i = e.RTCPeerConnection.prototype.setLocalDescription;
      i && i.length !== 0 && (e.RTCPeerConnection.prototype.setLocalDescription = function() {
        let o = arguments[0] || {};
        if (typeof o != "object" || o.type && o.sdp) return i.apply(this, arguments);
        if (o = { type: o.type, sdp: o.sdp }, !o.type) switch (this.signalingState) {
          case "stable":
          case "have-local-offer":
          case "have-remote-pranswer":
            o.type = "offer";
            break;
          default:
            o.type = "answer";
        }
        return o.sdp || o.type !== "offer" && o.type !== "answer" ? i.apply(this, [o]) : (o.type === "offer" ? this.createOffer : this.createAnswer).apply(this).then((f) => i.apply(this, [f]));
      });
    }
    var Uee = Object.freeze({ __proto__: null, removeExtmapAllowMixed: LC, shimAddIceCandidateNullOrEmpty: P1, shimConnectionState: MC, shimMaxMessageSize: w1, shimParameterlessSetLocalDescription: x1, shimRTCIceCandidate: N1, shimRTCIceCandidateRelayProtocol: DC, shimSendThrowTypeError: _1 });
    (function() {
      let { window: e } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { shimChrome: !0, shimFirefox: !0, shimSafari: !0 };
      const i = E4, o = function(T) {
        const A = { browser: null, version: null };
        if (T === void 0 || !T.navigator) return A.browser = "Not a browser.", A;
        const { navigator: R } = T;
        if (R.mozGetUserMedia) A.browser = "firefox", A.version = R1(R.userAgent, /Firefox\/(\d+)\./, 1);
        else if (R.webkitGetUserMedia || T.isSecureContext === !1 && T.webkitRTCPeerConnection) A.browser = "chrome", A.version = R1(R.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
        else {
          if (!T.RTCPeerConnection || !R.userAgent.match(/AppleWebKit\/(\d+)\./)) return A.browser = "Not a supported browser.", A;
          A.browser = "safari", A.version = R1(R.userAgent, /AppleWebKit\/(\d+)\./, 1), A.supportsUnifiedPlan = T.RTCRtpTransceiver && "currentDirection" in T.RTCRtpTransceiver.prototype;
        }
        return A;
      }(e), f = { browserDetails: o, commonShim: Uee, extractVersion: R1, disableLog: Oee, disableWarnings: Cee, sdp: jee };
      switch (o.browser) {
        case "chrome":
          if (!P4 || !NC || !n.shimChrome) return i("Chrome shim is not included in this adapter release."), f;
          if (o.version === null) return i("Chrome shim can not determine version, not shimming."), f;
          i("adapter.js shimming chrome."), f.browserShim = P4, P1(e, o), x1(e), A4(e, o), O4(e), NC(e, o), C4(e), w4(e, o), S4(e), I4(e), R4(e), _4(e, o), N1(e), DC(e), MC(e), w1(e, o), _1(e), LC(e, o);
          break;
        case "firefox":
          if (!F4 || !wC || !n.shimFirefox) return i("Firefox shim is not included in this adapter release."), f;
          i("adapter.js shimming firefox."), f.browserShim = F4, P1(e, o), x1(e), x4(e, o), wC(e, o), D4(e), k4(e), M4(e), L4(e), j4(e), U4(e), H4(e), B4(e), z4(e), N1(e), MC(e), w1(e, o), _1(e);
          break;
        case "safari":
          if (!Q4 || !n.shimSafari) return i("Safari shim is not included in this adapter release."), f;
          i("adapter.js shimming safari."), f.browserShim = Q4, P1(e, o), x1(e), q4(e), J4(e), Y4(e), G4(e), V4(e), K4(e), X4(e), Z4(e), N1(e), DC(e), w1(e, o), _1(e), LC(e, o);
          break;
        default:
          i("Unsupported browser!");
      }
    })({ window: typeof window > "u" ? void 0 : window });
    var ix = lt, Hee = TypeError, sx = wt.match(/firefox\/(\d+)/i), Bee = !!sx && +sx[1], zee = /MSIE|Trident/.test(wt), ax = wt.match(/AppleWebKit\/(\d+)\./), Fee = !!ax && +ax[1], Gee = _r, ox = p, Vee = ae, Yee = et, cx = td, Xee = function(e, n) {
      if (!delete e[n]) throw Hee("Cannot delete property " + ix(n) + " of " + ix(e));
    }, ux = Oo, kC = b, Wee = y3, qee = Vv, dx = Bee, Kee = zee, lx = ze, fx = Fee, Kd = [], hx = ox(Kd.sort), Jee = ox(Kd.push), Zee = kC(function() {
      Kd.sort(void 0);
    }), Qee = kC(function() {
      Kd.sort(null);
    }), $ee = qee("sort"), px = !kC(function() {
      if (lx) return lx < 70;
      if (!(dx && dx > 3)) {
        if (Kee) return !0;
        if (fx) return fx < 603;
        var e, n, i, o, f = "";
        for (e = 65; e < 76; e++) {
          switch (n = String.fromCharCode(e), e) {
            case 66:
            case 69:
            case 70:
            case 72:
              i = 3;
              break;
            case 68:
            case 71:
              i = 4;
              break;
            default:
              i = 2;
          }
          for (o = 0; o < 47; o++) Kd.push({ k: n + o, v: i });
        }
        for (Kd.sort(function(T, A) {
          return A.v - T.v;
        }), o = 0; o < Kd.length; o++) n = Kd[o].k.charAt(0), f.charAt(f.length - 1) !== n && (f += n);
        return f !== "DGBEFHACIJK";
      }
    });
    Gee({ target: "Array", proto: !0, forced: Zee || !Qee || !$ee || !px }, { sort: function(e) {
      e !== void 0 && Vee(e);
      var n = Yee(this);
      if (px) return e === void 0 ? hx(n) : hx(n, e);
      var i, o, f = [], T = cx(n);
      for (o = 0; o < T; o++) o in n && Jee(f, n[o]);
      for (Wee(f, /* @__PURE__ */ function(A) {
        return function(R, P) {
          return P === void 0 ? -1 : R === void 0 ? 1 : A !== void 0 ? +A(R, P) || 0 : ux(R) > ux(P) ? 1 : -1;
        };
      }(e)), i = cx(f), o = 0; o < i; ) n[o] = f[o++];
      for (; o < T; ) Xee(n, o++);
      return n;
    } });
    var ete = Jo("Array").sort, tte = m, nte = ete, jC = Array.prototype, rte = function(e) {
      var n = e.sort;
      return e === jC || tte(jC, e) && n === jC.sort ? nte : n;
    }, hE = h(rte), UC = y;
    _r({ global: !0, forced: UC.globalThis !== UC }, { globalThis: UC });
    var gx = h(y), HC = { exports: {} };
    (function(e, n) {
      (function(i, o) {
        var f = "function", T = "undefined", A = "object", R = "string", P = "major", L = "model", z = "name", Y = "type", te = "vendor", oe = "version", He = "architecture", Re = "console", De = "mobile", Xe = "tablet", We = "smarttv", mt = "wearable", Pt = "embedded", xt = "Amazon", Nt = "Apple", Vt = "ASUS", nn = "BlackBerry", fn = "Browser", hn = "Chrome", ir = "Firefox", sr = "Google", Gr = "Huawei", Ai = "LG", fi = "Microsoft", Ea = "Motorola", qt = "Opera", sn = "Samsung", An = "Sharp", Jt = "Sony", Ae = "Xiaomi", ct = "Zebra", vt = "Facebook", en = "Chromium OS", Bn = "Mac OS", Mr = function(Gi) {
          for (var is = {}, Jr = 0; Jr < Gi.length; Jr++) is[Gi[Jr].toUpperCase()] = Gi[Jr];
          return is;
        }, rs = function(Gi, is) {
          return typeof Gi === R && wa(is).indexOf(wa(Gi)) !== -1;
        }, wa = function(Gi) {
          return Gi.toLowerCase();
        }, bd = function(Gi, is) {
          if (typeof Gi === R) return Gi = Gi.replace(/^\s\s*/, ""), typeof is === T ? Gi : Gi.substring(0, 350);
        }, Gf = function(Gi, is) {
          for (var Jr, Va, Pu, Oi, Tr, _a, vl = 0; vl < is.length && !Tr; ) {
            var Gc = is[vl], j9 = is[vl + 1];
            for (Jr = Va = 0; Jr < Gc.length && !Tr && Gc[Jr]; ) if (Tr = Gc[Jr++].exec(Gi)) for (Pu = 0; Pu < j9.length; Pu++) _a = Tr[++Va], typeof (Oi = j9[Pu]) === A && Oi.length > 0 ? Oi.length === 2 ? typeof Oi[1] == f ? this[Oi[0]] = Oi[1].call(this, _a) : this[Oi[0]] = Oi[1] : Oi.length === 3 ? typeof Oi[1] !== f || Oi[1].exec && Oi[1].test ? this[Oi[0]] = _a ? _a.replace(Oi[1], Oi[2]) : o : this[Oi[0]] = _a ? Oi[1].call(this, _a, Oi[2]) : o : Oi.length === 4 && (this[Oi[0]] = _a ? Oi[3].call(this, _a.replace(Oi[1], Oi[2])) : o) : this[Oi] = _a || o;
            vl += 2;
          }
        }, Ey = function(Gi, is) {
          for (var Jr in is) if (typeof is[Jr] === A && is[Jr].length > 0) {
            for (var Va = 0; Va < is[Jr].length; Va++) if (rs(is[Jr][Va], Gi)) return Jr === "?" ? o : Jr;
          } else if (rs(is[Jr], Gi)) return Jr === "?" ? o : Jr;
          return Gi;
        }, T0 = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, b0 = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [oe, [z, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [oe, [z, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [z, oe], [/opios[\/ ]+([\w\.]+)/i], [oe, [z, qt + " Mini"]], [/\bopr\/([\w\.]+)/i], [oe, [z, qt]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, /(ba?idubrowser)[\/ ]?([\w\.]+)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(weibo)__([\d\.]+)/i], [z, oe], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [oe, [z, "UC" + fn]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i], [oe, [z, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [oe, [z, "WeChat"]], [/konqueror\/([\w\.]+)/i], [oe, [z, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [oe, [z, "IE"]], [/yabrowser\/([\w\.]+)/i], [oe, [z, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[z, /(.+)/, "$1 Secure " + fn], oe], [/\bfocus\/([\w\.]+)/i], [oe, [z, ir + " Focus"]], [/\bopt\/([\w\.]+)/i], [oe, [z, qt + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [oe, [z, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [oe, [z, "Dolphin"]], [/coast\/([\w\.]+)/i], [oe, [z, qt + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [oe, [z, "MIUI " + fn]], [/fxios\/([-\w\.]+)/i], [oe, [z, ir]], [/\bqihu|(qi?ho?o?|360)browser/i], [[z, "360 " + fn]], [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i], [[z, /(.+)/, "$1 " + fn], oe], [/(comodo_dragon)\/([\w\.]+)/i], [[z, /_/g, " "], oe], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i], [z, oe], [/(metasr)[\/ ]?([\w\.]+)/i, /(lbbrowser)/i, /\[(linkedin)app\]/i], [z], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[z, vt], oe], [/(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/ ]([-\w\.]+)/i], [z, oe], [/\bgsa\/([\w\.]+) .*safari\//i], [oe, [z, "GSA"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [oe, [z, hn + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[z, hn + " WebView"], oe], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [oe, [z, "Android " + fn]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [z, oe], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [oe, [z, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [oe, z], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [z, [oe, Ey, { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }]], [/(webkit|khtml)\/([\w\.]+)/i], [z, oe], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[z, "Netscape"], oe], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [oe, [z, ir + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [z, oe], [/(cobalt)\/([\w\.]+)/i], [z, [oe, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[He, "amd64"]], [/(ia32(?=;))/i], [[He, wa]], [/((?:i[346]|x)86)[;\)]/i], [[He, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[He, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[He, "armhf"]], [/windows (ce|mobile); ppc;/i], [[He, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[He, /ower/, "", wa]], [/(sun4\w)[;\)]/i], [[He, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[He, wa]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [L, [te, sn], [Y, Xe]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [L, [te, sn], [Y, De]], [/\((ip(?:hone|od)[\w ]*);/i], [L, [te, Nt], [Y, De]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [L, [te, Nt], [Y, Xe]], [/(macintosh);/i], [L, [te, Nt]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [L, [te, An], [Y, De]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [L, [te, Gr], [Y, Xe]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [L, [te, Gr], [Y, De]], [/\b(poco[\w ]+)(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[L, /_/g, " "], [te, Ae], [Y, De]], [/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[L, /_/g, " "], [te, Ae], [Y, Xe]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [L, [te, "OPPO"], [Y, De]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [L, [te, "Vivo"], [Y, De]], [/\b(rmx[12]\d{3})(?: bui|;|\))/i], [L, [te, "Realme"], [Y, De]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [L, [te, Ea], [Y, De]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [L, [te, Ea], [Y, Xe]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [L, [te, Ai], [Y, Xe]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [L, [te, Ai], [Y, De]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [L, [te, "Lenovo"], [Y, Xe]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[L, /_/g, " "], [te, "Nokia"], [Y, De]], [/(pixel c)\b/i], [L, [te, sr], [Y, Xe]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [L, [te, sr], [Y, De]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [L, [te, Jt], [Y, De]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[L, "Xperia Tablet"], [te, Jt], [Y, Xe]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [L, [te, "OnePlus"], [Y, De]], [/(alexa)webm/i, /(kf[a-z]{2}wi)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [L, [te, xt], [Y, Xe]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[L, /(.+)/g, "Fire Phone $1"], [te, xt], [Y, De]], [/(playbook);[-\w\),; ]+(rim)/i], [L, te, [Y, Xe]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [L, [te, nn], [Y, De]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [L, [te, Vt], [Y, Xe]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [L, [te, Vt], [Y, De]], [/(nexus 9)/i], [L, [te, "HTC"], [Y, Xe]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [te, [L, /_/g, " "], [Y, De]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [L, [te, "Acer"], [Y, Xe]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [L, [te, "Meizu"], [Y, De]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [te, L, [Y, De]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [te, L, [Y, Xe]], [/(surface duo)/i], [L, [te, fi], [Y, Xe]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [L, [te, "Fairphone"], [Y, De]], [/(u304aa)/i], [L, [te, "AT&T"], [Y, De]], [/\bsie-(\w*)/i], [L, [te, "Siemens"], [Y, De]], [/\b(rct\w+) b/i], [L, [te, "RCA"], [Y, Xe]], [/\b(venue[\d ]{2,7}) b/i], [L, [te, "Dell"], [Y, Xe]], [/\b(q(?:mv|ta)\w+) b/i], [L, [te, "Verizon"], [Y, Xe]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [L, [te, "Barnes & Noble"], [Y, Xe]], [/\b(tm\d{3}\w+) b/i], [L, [te, "NuVision"], [Y, Xe]], [/\b(k88) b/i], [L, [te, "ZTE"], [Y, Xe]], [/\b(nx\d{3}j) b/i], [L, [te, "ZTE"], [Y, De]], [/\b(gen\d{3}) b.+49h/i], [L, [te, "Swiss"], [Y, De]], [/\b(zur\d{3}) b/i], [L, [te, "Swiss"], [Y, Xe]], [/\b((zeki)?tb.*\b) b/i], [L, [te, "Zeki"], [Y, Xe]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[te, "Dragon Touch"], L, [Y, Xe]], [/\b(ns-?\w{0,9}) b/i], [L, [te, "Insignia"], [Y, Xe]], [/\b((nxa|next)-?\w{0,9}) b/i], [L, [te, "NextBook"], [Y, Xe]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[te, "Voice"], L, [Y, De]], [/\b(lvtel\-)?(v1[12]) b/i], [[te, "LvTel"], L, [Y, De]], [/\b(ph-1) /i], [L, [te, "Essential"], [Y, De]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [L, [te, "Envizen"], [Y, Xe]], [/\b(trio[-\w\. ]+) b/i], [L, [te, "MachSpeed"], [Y, Xe]], [/\btu_(1491) b/i], [L, [te, "Rotor"], [Y, Xe]], [/(shield[\w ]+) b/i], [L, [te, "Nvidia"], [Y, Xe]], [/(sprint) (\w+)/i], [te, L, [Y, De]], [/(kin\.[onetw]{3})/i], [[L, /\./g, " "], [te, fi], [Y, De]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [L, [te, ct], [Y, Xe]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [L, [te, ct], [Y, De]], [/smart-tv.+(samsung)/i], [te, [Y, We]], [/hbbtv.+maple;(\d+)/i], [[L, /^/, "SmartTV"], [te, sn], [Y, We]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[te, Ai], [Y, We]], [/(apple) ?tv/i], [te, [L, Nt + " TV"], [Y, We]], [/crkey/i], [[L, hn + "cast"], [te, sr], [Y, We]], [/droid.+aft(\w)( bui|\))/i], [L, [te, xt], [Y, We]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [L, [te, An], [Y, We]], [/(bravia[\w ]+)( bui|\))/i], [L, [te, Jt], [Y, We]], [/(mitv-\w{5}) bui/i], [L, [te, Ae], [Y, We]], [/Hbbtv.*(technisat) (.*);/i], [te, L, [Y, We]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[te, bd], [L, bd], [Y, We]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[Y, We]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [te, L, [Y, Re]], [/droid.+; (shield) bui/i], [L, [te, "Nvidia"], [Y, Re]], [/(playstation [345portablevi]+)/i], [L, [te, Jt], [Y, Re]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [L, [te, fi], [Y, Re]], [/((pebble))app/i], [te, L, [Y, mt]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [L, [te, Nt], [Y, mt]], [/droid.+; (glass) \d/i], [L, [te, sr], [Y, mt]], [/droid.+; (wt63?0{2,3})\)/i], [L, [te, ct], [Y, mt]], [/(quest( 2| pro)?)/i], [L, [te, vt], [Y, mt]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [te, [Y, Pt]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i], [L, [Y, De]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [L, [Y, Xe]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[Y, Xe]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[Y, De]], [/(android[-\w\. ]{0,9});.+buil/i], [L, [te, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [oe, [z, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [oe, [z, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i], [z, oe], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [oe, z]], os: [[/microsoft (windows) (vista|xp)/i], [z, oe], [/(windows) nt 6\.2; (arm)/i, /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i], [z, [oe, Ey, T0]], [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[z, "Windows"], [oe, Ey, T0]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /cfnetwork\/.+darwin/i], [[oe, /_/g, "."], [z, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[z, Bn], [oe, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [oe, z], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [z, oe], [/\(bb(10);/i], [oe, [z, nn]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [oe, [z, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [oe, [z, ir + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [oe, [z, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [oe, [z, "watchOS"]], [/crkey\/([\d\.]+)/i], [oe, [z, hn + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[z, en], oe], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [z, oe], [/(sunos) ?([\w\.\d]*)/i], [[z, "Solaris"], oe], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, /(unix) ?([\w\.]*)/i], [z, oe]] }, Mo = function(Gi, is) {
          if (typeof Gi === A && (is = Gi, Gi = o), !(this instanceof Mo)) return new Mo(Gi, is).getResult();
          var Jr = typeof i !== T && i.navigator ? i.navigator : o, Va = Gi || (Jr && Jr.userAgent ? Jr.userAgent : ""), Pu = Jr && Jr.userAgentData ? Jr.userAgentData : o, Oi = is ? function(Tr, _a) {
            var vl = {};
            for (var Gc in Tr) _a[Gc] && _a[Gc].length % 2 == 0 ? vl[Gc] = _a[Gc].concat(Tr[Gc]) : vl[Gc] = Tr[Gc];
            return vl;
          }(b0, is) : b0;
          return this.getBrowser = function() {
            var Tr = {};
            return Tr[z] = o, Tr[oe] = o, Gf.call(Tr, Va, Oi.browser), Tr[P] = function(_a) {
              return typeof _a === R ? _a.replace(/[^\d\.]/g, "").split(".")[0] : o;
            }(Tr[oe]), Jr && Jr.brave && typeof Jr.brave.isBrave == f && (Tr[z] = "Brave"), Tr;
          }, this.getCPU = function() {
            var Tr = {};
            return Tr[He] = o, Gf.call(Tr, Va, Oi.cpu), Tr;
          }, this.getDevice = function() {
            var Tr = {};
            return Tr[te] = o, Tr[L] = o, Tr[Y] = o, Gf.call(Tr, Va, Oi.device), !Tr[Y] && Pu && Pu.mobile && (Tr[Y] = De), Tr[L] == "Macintosh" && Jr && typeof Jr.standalone !== T && Jr.maxTouchPoints && Jr.maxTouchPoints > 2 && (Tr[L] = "iPad", Tr[Y] = Xe), Tr;
          }, this.getEngine = function() {
            var Tr = {};
            return Tr[z] = o, Tr[oe] = o, Gf.call(Tr, Va, Oi.engine), Tr;
          }, this.getOS = function() {
            var Tr = {};
            return Tr[z] = o, Tr[oe] = o, Gf.call(Tr, Va, Oi.os), !Tr[z] && Pu && Pu.platform != "Unknown" && (Tr[z] = Pu.platform.replace(/chrome os/i, en).replace(/macos/i, Bn)), Tr;
          }, this.getResult = function() {
            return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
          }, this.getUA = function() {
            return Va;
          }, this.setUA = function(Tr) {
            return Va = typeof Tr === R && Tr.length > 350 ? bd(Tr, 350) : Tr, this;
          }, this.setUA(Va), this;
        };
        Mo.VERSION = "0.7.34", Mo.BROWSER = Mr([z, oe, P]), Mo.CPU = Mr([He]), Mo.DEVICE = Mr([L, te, Y, Re, De, We, Xe, mt, Pt]), Mo.ENGINE = Mo.OS = Mr([z, oe]), e.exports && (n = e.exports = Mo), n.UAParser = Mo;
        var yl = typeof i !== T && (i.jQuery || i.Zepto);
        if (yl && !yl.ua) {
          var Vf = new Mo();
          yl.ua = Vf.getResult(), yl.ua.get = function() {
            return Vf.getUA();
          }, yl.ua.set = function(Gi) {
            Vf.setUA(Gi);
            var is = Vf.getResult();
            for (var Jr in is) yl.ua[Jr] = is[Jr];
          };
        }
      })(typeof window == "object" ? window : u);
    })(HC, HC.exports);
    var ite = h(HC.exports), ste = du, ate = Lt, ote = be, cte = sf, ute = Or("iterator"), dte = Object, lte = function(e) {
      if (ote(e)) return !1;
      var n = dte(e);
      return n[ute] !== void 0 || "@@iterator" in n || ate(cte, ste(n));
    }, fte = h(lte), mx = c1.clear;
    _r({ global: !0, bind: !0, enumerable: !0, forced: y.clearImmediate !== mx }, { clearImmediate: mx });
    var hte = typeof Bun == "function" && Bun && typeof Bun.version == "string", Ex = y, pte = w, gte = U, mte = hte, Ete = wt, yte = o1, vte = xh, Tte = Ex.Function, bte = /MSIE .\./.test(Ete) || mte && function() {
      var e = Ex.Bun.version.split(".");
      return e.length < 3 || e[0] == 0 && (e[1] < 3 || e[1] == 3 && e[2] == 0);
    }(), Ate = _r, yx = y, vx = c1.set, Ote = function(e, n) {
      var i = 1;
      return bte ? function(o, f) {
        var T = vte(arguments.length, 1) > i, A = gte(o) ? o : Tte(o), R = T ? yte(arguments, i) : [], P = T ? function() {
          pte(A, this, R);
        } : A;
        return e(P);
      } : e;
    }, Tx = yx.setImmediate ? Ote(vx) : vx;
    Ate({ global: !0, bind: !0, enumerable: !0, forced: yx.setImmediate !== Tx }, { setImmediate: Tx });
    var bx = h(it.setImmediate), Cte = _r, Ste = kP, Ite = ae, Rte = xh, Nte = Nh, wte = y.process;
    Cte({ global: !0, enumerable: !0, dontCallGetSet: !0 }, { queueMicrotask: function(e) {
      Rte(arguments.length, 1), Ite(e);
      var n = Nte && wte.domain;
      Ste(n ? n.bind(e) : e);
    } });
    var Ax = h(it.queueMicrotask);
    function Ox(e, n) {
      return function() {
        return e.apply(n, arguments);
      };
    }
    const { toString: _te } = Object.prototype, { getPrototypeOf: BC } = Object, D1 = (zC = /* @__PURE__ */ Object.create(null), (e) => {
      const n = _te.call(e);
      return zC[n] || (zC[n] = n.slice(8, -1).toLowerCase());
    });
    var zC;
    const Dc = (e) => (e = e.toLowerCase(), (n) => D1(n) === e), M1 = (e) => (n) => typeof n === e, { isArray: qh } = Array, pE = M1("undefined"), Cx = Dc("ArrayBuffer"), Pte = M1("string"), So = M1("function"), Sx = M1("number"), L1 = (e) => e !== null && typeof e == "object", k1 = (e) => {
      if (D1(e) !== "object") return !1;
      const n = BC(e);
      return !(n !== null && n !== Object.prototype && Object.getPrototypeOf(n) !== null || Symbol.toStringTag in e || fte(e));
    }, xte = Dc("Date"), Dte = Dc("File"), Mte = Dc("Blob"), Lte = Dc("FileList"), kte = Dc("URLSearchParams"), [jte, Ute, Hte, Bte] = ["ReadableStream", "Request", "Response", "Headers"].map(Dc);
    function gE(e, n) {
      let i, o, { allOwnKeys: f = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (e != null) if (typeof e != "object" && (e = [e]), qh(e)) for (i = 0, o = e.length; i < o; i++) n.call(null, e[i], i, e);
      else {
        const T = f ? Object.getOwnPropertyNames(e) : Object.keys(e), A = T.length;
        let R;
        for (i = 0; i < A; i++) R = T[i], n.call(null, e[R], R, e);
      }
    }
    function Ix(e, n) {
      n = n.toLowerCase();
      const i = Object.keys(e);
      let o, f = i.length;
      for (; f-- > 0; ) if (o = i[f], n === o.toLowerCase()) return o;
      return null;
    }
    const gf = gx !== void 0 ? gx : typeof self < "u" ? self : typeof window < "u" ? window : rn, Rx = (e) => !pE(e) && e !== gf, zte = (FC = typeof Uint8Array < "u" && BC(Uint8Array), (e) => FC && e instanceof FC);
    var FC;
    const Fte = Dc("HTMLFormElement"), Nx = ((e) => {
      let { hasOwnProperty: n } = e;
      return (i, o) => n.call(i, o);
    })(Object.prototype), Gte = Dc("RegExp"), _x = (e, n) => {
      const i = Object.getOwnPropertyDescriptors(e), o = {};
      gE(i, (f, T) => {
        let A;
        (A = n(f, T, e)) !== !1 && (o[T] = A || f);
      }), Object.defineProperties(e, o);
    }, GC = "abcdefghijklmnopqrstuvwxyz", Px = "0123456789", xx = { DIGIT: Px, ALPHA: GC, ALPHA_DIGIT: GC + GC.toUpperCase() + Px }, Vte = Dc("AsyncFunction"), Dx = (Mx = typeof bx == "function", Lx = So(gf.postMessage), Mx ? bx : Lx ? (VC = "axios@".concat(Math.random()), j1 = [], gf.addEventListener("message", (e) => {
      let { source: n, data: i } = e;
      n === gf && i === VC && j1.length && j1.shift()();
    }, !1), (e) => {
      j1.push(e), gf.postMessage(VC, "*");
    }) : (e) => setTimeout(e));
    var Mx, Lx, VC, j1;
    const Yte = Ax !== void 0 ? Ax.bind(gf) : typeof process < "u" && process.nextTick || Dx;
    var an = { isArray: qh, isArrayBuffer: Cx, isBuffer: function(e) {
      return e !== null && !pE(e) && e.constructor !== null && !pE(e.constructor) && So(e.constructor.isBuffer) && e.constructor.isBuffer(e);
    }, isFormData: (e) => {
      let n;
      return e && (typeof FormData == "function" && e instanceof FormData || So(e.append) && ((n = D1(e)) === "formdata" || n === "object" && So(e.toString) && e.toString() === "[object FormData]"));
    }, isArrayBufferView: function(e) {
      let n;
      return n = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && Cx(e.buffer), n;
    }, isString: Pte, isNumber: Sx, isBoolean: (e) => e === !0 || e === !1, isObject: L1, isPlainObject: k1, isReadableStream: jte, isRequest: Ute, isResponse: Hte, isHeaders: Bte, isUndefined: pE, isDate: xte, isFile: Dte, isBlob: Mte, isRegExp: Gte, isFunction: So, isStream: (e) => L1(e) && So(e.pipe), isURLSearchParams: kte, isTypedArray: zte, isFileList: Lte, forEach: gE, merge: function e() {
      const { caseless: n } = Rx(this) && this || {}, i = {}, o = (f, T) => {
        const A = n && Ix(i, T) || T;
        k1(i[A]) && k1(f) ? i[A] = e(i[A], f) : k1(f) ? i[A] = e({}, f) : qh(f) ? i[A] = f.slice() : i[A] = f;
      };
      for (let f = 0, T = arguments.length; f < T; f++) arguments[f] && gE(arguments[f], o);
      return i;
    }, extend: function(e, n, i) {
      let { allOwnKeys: o } = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return gE(n, (f, T) => {
        i && So(f) ? e[T] = Ox(f, i) : e[T] = f;
      }, { allOwnKeys: o }), e;
    }, trim: (e) => Ys(e) ? Ys(e).call(e) : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits: (e, n, i, o) => {
      e.prototype = Object.create(n.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: n.prototype }), i && Object.assign(e.prototype, i);
    }, toFlatObject: (e, n, i, o) => {
      let f, T, A;
      const R = {};
      if (n = n || {}, e == null) return n;
      do {
        for (f = Object.getOwnPropertyNames(e), T = f.length; T-- > 0; ) A = f[T], o && !o(A, e, n) || R[A] || (n[A] = e[A], R[A] = !0);
        e = i !== !1 && BC(e);
      } while (e && (!i || i(e, n)) && e !== Object.prototype);
      return n;
    }, kindOf: D1, kindOfTest: Dc, endsWith: (e, n, i) => {
      e = String(e), (i === void 0 || i > e.length) && (i = e.length), i -= n.length;
      const o = e.indexOf(n, i);
      return o !== -1 && o === i;
    }, toArray: (e) => {
      if (!e) return null;
      if (qh(e)) return e;
      let n = e.length;
      if (!Sx(n)) return null;
      const i = new Array(n);
      for (; n-- > 0; ) i[n] = e[n];
      return i;
    }, forEachEntry: (e, n) => {
      const i = (e && e[Symbol.iterator]).call(e);
      let o;
      for (; (o = i.next()) && !o.done; ) {
        const f = o.value;
        n.call(e, f[0], f[1]);
      }
    }, matchAll: (e, n) => {
      let i;
      const o = [];
      for (; (i = e.exec(n)) !== null; ) o.push(i);
      return o;
    }, isHTMLForm: Fte, hasOwnProperty: Nx, hasOwnProp: Nx, reduceDescriptors: _x, freezeMethods: (e) => {
      _x(e, (n, i) => {
        if (So(e) && ["arguments", "caller", "callee"].indexOf(i) !== -1) return !1;
        const o = e[i];
        So(o) && (n.enumerable = !1, "writable" in n ? n.writable = !1 : n.set || (n.set = () => {
          throw Error("Can not rewrite read-only method '" + i + "'");
        }));
      });
    }, toObjectSet: (e, n) => {
      const i = {}, o = (f) => {
        f.forEach((T) => {
          i[T] = !0;
        });
      };
      return qh(e) ? o(e) : o(String(e).split(n)), i;
    }, toCamelCase: (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, i, o) {
      return i.toUpperCase() + o;
    }), noop: () => {
    }, toFiniteNumber: (e, n) => e != null && Number.isFinite(e = +e) ? e : n, findKey: Ix, global: gf, isContextDefined: Rx, ALPHABET: xx, generateString: function() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : xx.ALPHA_DIGIT, i = "";
      const { length: o } = n;
      for (; e--; ) i += n[Math.random() * o | 0];
      return i;
    }, isSpecCompliantForm: function(e) {
      return !!(e && So(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
    }, toJSONObject: (e) => {
      const n = new Array(10), i = (o, f) => {
        if (L1(o)) {
          if (n.indexOf(o) >= 0) return;
          if (!("toJSON" in o)) {
            n[f] = o;
            const T = qh(o) ? [] : {};
            return gE(o, (A, R) => {
              const P = i(A, f + 1);
              !pE(P) && (T[R] = P);
            }), n[f] = void 0, T;
          }
        }
        return o;
      };
      return i(e, 0);
    }, isAsyncFn: Vte, isThenable: (e) => e && (L1(e) || So(e)) && So(e.then) && So(e.catch), setImmediate: Dx, asap: Yte };
    function Pr(e, n, i, o, f) {
      Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), i && (this.config = i), o && (this.request = o), f && (this.response = f, this.status = f.status ? f.status : null);
    }
    an.inherits(Pr, Error, { toJSON: function() {
      return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: an.toJSONObject(this.config), code: this.code, status: this.status };
    } });
    const kx = Pr.prototype, jx = {};
    ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
      jx[e] = { value: e };
    }), Object.defineProperties(Pr, jx), Object.defineProperty(kx, "isAxiosError", { value: !0 }), Pr.from = (e, n, i, o, f, T) => {
      const A = Object.create(kx);
      return an.toFlatObject(e, A, function(R) {
        return R !== Error.prototype;
      }, (R) => R !== "isAxiosError"), Pr.call(A, e.message, n, i, o, f), A.cause = e, A.name = e.name, T && Object.assign(A, T), A;
    };
    function YC(e) {
      return an.isPlainObject(e) || an.isArray(e);
    }
    function Ux(e) {
      return an.endsWith(e, "[]") ? e.slice(0, -2) : e;
    }
    function Hx(e, n, i) {
      return e ? e.concat(n).map(function(o, f) {
        return o = Ux(o), !i && f ? "[" + o + "]" : o;
      }).join(i ? "." : "") : n;
    }
    const Xte = an.toFlatObject(an, {}, null, function(e) {
      return /^is[A-Z]/.test(e);
    });
    function U1(e, n, i) {
      if (!an.isObject(e)) throw new TypeError("target must be an object");
      n = n || new FormData();
      const o = (i = an.toFlatObject(i, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(te, oe) {
        return !an.isUndefined(oe[te]);
      })).metaTokens, f = i.visitor || L, T = i.dots, A = i.indexes, R = (i.Blob || typeof Blob < "u" && Blob) && an.isSpecCompliantForm(n);
      if (!an.isFunction(f)) throw new TypeError("visitor must be a function");
      function P(te) {
        if (te === null) return "";
        if (an.isDate(te)) return te.toISOString();
        if (!R && an.isBlob(te)) throw new Pr("Blob is not supported. Use a Buffer instead.");
        return an.isArrayBuffer(te) || an.isTypedArray(te) ? R && typeof Blob == "function" ? new Blob([te]) : Buffer.from(te) : te;
      }
      function L(te, oe, He) {
        let Re = te;
        if (te && !He && typeof te == "object") {
          if (an.endsWith(oe, "{}")) oe = o ? oe : oe.slice(0, -2), te = JSON.stringify(te);
          else if (an.isArray(te) && function(De) {
            return an.isArray(De) && !De.some(YC);
          }(te) || (an.isFileList(te) || an.endsWith(oe, "[]")) && (Re = an.toArray(te))) return oe = Ux(oe), Re.forEach(function(De, Xe) {
            !an.isUndefined(De) && De !== null && n.append(A === !0 ? Hx([oe], Xe, T) : A === null ? oe : oe + "[]", P(De));
          }), !1;
        }
        return !!YC(te) || (n.append(Hx(He, oe, T), P(te)), !1);
      }
      const z = [], Y = Object.assign(Xte, { defaultVisitor: L, convertValue: P, isVisitable: YC });
      if (!an.isObject(e)) throw new TypeError("data must be an object");
      return function te(oe, He) {
        if (!an.isUndefined(oe)) {
          if (z.indexOf(oe) !== -1) throw Error("Circular reference detected in " + He.join("."));
          z.push(oe), an.forEach(oe, function(Re, De) {
            (!(an.isUndefined(Re) || Re === null) && f.call(n, Re, an.isString(De) ? Ys(De).call(De) : De, He, Y)) === !0 && te(Re, He ? He.concat(De) : [De]);
          }), z.pop();
        }
      }(e), n;
    }
    function Bx(e) {
      const n = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
      return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
        return n[i];
      });
    }
    function XC(e, n) {
      this._pairs = [], e && U1(e, this, n);
    }
    const zx = XC.prototype;
    function Wte(e) {
      return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    function Fx(e, n, i) {
      if (!n) return e;
      const o = i && i.encode || Wte, f = i && i.serialize;
      let T;
      if (T = f ? f(n, i) : an.isURLSearchParams(n) ? n.toString() : new XC(n, i).toString(o), T) {
        const A = e.indexOf("#");
        A !== -1 && (e = e.slice(0, A)), e += (e.indexOf("?") === -1 ? "?" : "&") + T;
      }
      return e;
    }
    zx.append = function(e, n) {
      this._pairs.push([e, n]);
    }, zx.toString = function(e) {
      const n = e ? function(i) {
        return e.call(this, i, Bx);
      } : Bx;
      return this._pairs.map(function(i) {
        return n(i[0]) + "=" + n(i[1]);
      }, "").join("&");
    };
    var Gx = class {
      constructor() {
        this.handlers = [];
      }
      use(e, n, i) {
        return this.handlers.push({ fulfilled: e, rejected: n, synchronous: !!i && i.synchronous, runWhen: i ? i.runWhen : null }), this.handlers.length - 1;
      }
      eject(e) {
        this.handlers[e] && (this.handlers[e] = null);
      }
      clear() {
        this.handlers && (this.handlers = []);
      }
      forEach(e) {
        an.forEach(this.handlers, function(n) {
          n !== null && e(n);
        });
      }
    }, Vx = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Yx = { exports: {} }, qte = _r, Kte = V, Xx = Ts.f;
    qte({ target: "Object", stat: !0, forced: Object.defineProperty !== Xx, sham: !Kte }, { defineProperty: Xx });
    var Wx = it.Object, Jte = Yx.exports = function(e, n, i) {
      return Wx.defineProperty(e, n, i);
    };
    Wx.defineProperty.sham && (Jte.sham = !0);
    var qx = h(Yx.exports), Zte = TypeError, Kx = qm, Qte = a1, $te = gt, ene = Or("species"), Jx = Array, tne = function(e) {
      var n;
      return Kx(e) && (n = e.constructor, (Qte(n) && (n === Jx || Kx(n.prototype)) || $te(n) && (n = n[ene]) === null) && (n = void 0)), n === void 0 ? Jx : n;
    }, Zx = function(e, n) {
      return new (tne(e))(n === 0 ? 0 : n);
    }, nne = b, rne = ze, ine = Or("species"), Qx = function(e) {
      return rne >= 51 || !nne(function() {
        var n = [];
        return (n.constructor = {})[ine] = function() {
          return { foo: 1 };
        }, n[e](Boolean).foo !== 1;
      });
    }, sne = _r, ane = b, one = qm, cne = gt, une = et, dne = td, $x = function(e) {
      if (e > 9007199254740991) throw Zte("Maximum allowed index exceeded");
      return e;
    }, eD = g1, lne = Zx, fne = Qx, hne = ze, tD = Or("isConcatSpreadable"), pne = hne >= 51 || !ane(function() {
      var e = [];
      return e[tD] = !1, e.concat()[0] !== e;
    }), gne = function(e) {
      if (!cne(e)) return !1;
      var n = e[tD];
      return n !== void 0 ? !!n : one(e);
    };
    sne({ target: "Array", proto: !0, arity: 1, forced: !pne || !fne("concat") }, { concat: function(e) {
      var n, i, o, f, T, A = une(this), R = lne(A, 0), P = 0;
      for (n = -1, o = arguments.length; n < o; n++) if (gne(T = n === -1 ? A : arguments[n])) for (f = dne(T), $x(P + f), i = 0; i < f; i++, P++) i in T && eD(R, P, T[i]);
      else $x(P + 1), eD(R, P++, T);
      return R.length = P, R;
    } });
    var nD = {}, mne = H, Ene = pt, rD = Xv.f, yne = qO, iD = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    nD.f = function(e) {
      return iD && mne(e) == "Window" ? function(n) {
        try {
          return rD(n);
        } catch {
          return yne(iD);
        }
      }(e) : rD(Ene(e));
    };
    var Kh = {}, vne = Or;
    Kh.f = vne;
    var sD = it, Tne = Lt, bne = Kh, Ane = Ts.f, As = function(e) {
      var n = sD.Symbol || (sD.Symbol = {});
      Tne(n, e) || Ane(n, e, { value: bne.f(e) });
    }, One = se, Cne = kt, Sne = Or, Ine = Vd, aD = function() {
      var e = Cne("Symbol"), n = e && e.prototype, i = n && n.valueOf, o = Sne("toPrimitive");
      n && !n[o] && Ine(n, o, function(f) {
        return One(i, this);
      }, { arity: 1 });
    }, Rne = ba, Nne = xe, wne = et, _ne = td, Pne = Zx, oD = p([].push), Jd = function(e) {
      var n = e == 1, i = e == 2, o = e == 3, f = e == 4, T = e == 6, A = e == 7, R = e == 5 || T;
      return function(P, L, z, Y) {
        for (var te, oe, He = wne(P), Re = Nne(He), De = Rne(L, z), Xe = _ne(Re), We = 0, mt = Y || Pne, Pt = n ? mt(P, Xe) : i || A ? mt(P, 0) : void 0; Xe > We; We++) if ((R || We in Re) && (oe = De(te = Re[We], We, He), e)) if (n) Pt[We] = oe;
        else if (oe) switch (e) {
          case 3:
            return !0;
          case 5:
            return te;
          case 6:
            return We;
          case 2:
            oD(Pt, te);
        }
        else switch (e) {
          case 4:
            return !1;
          case 7:
            oD(Pt, te);
        }
        return T ? -1 : o || f ? f : Pt;
      };
    }, cD = { forEach: Jd(0), map: Jd(1), filter: Jd(2), some: Jd(3), every: Jd(4), find: Jd(5), findIndex: Jd(6), filterReject: Jd(7) }, H1 = _r, WC = y, qC = se, xne = p, Jh = V, Zh = re, Dne = b, ea = Lt, Mne = m, KC = Zi, B1 = pt, JC = Xt, Lne = Oo, ZC = Le, mE = Jm, uD = qv, kne = Xv, dD = nD, jne = Km, lD = M, fD = Ts, Une = JA, hD = ee, pD = Vd, Hne = s1, QC = Fe, gD = Wv, mD = In, Bne = Or, zne = Kh, Fne = As, Gne = aD, Vne = Yd, ED = of, z1 = cD.forEach, $a = Yv("hidden"), F1 = "Symbol", EE = "prototype", Yne = ED.set, yD = ED.getterFor(F1), Mc = Object[EE], mf = WC.Symbol, G1 = mf && mf[EE], Xne = WC.TypeError, $C = WC.QObject, vD = lD.f, Ef = fD.f, TD = dD.f, Wne = hD.f, bD = xne([].push), sd = QC("symbols"), yE = QC("op-symbols"), qne = QC("wks"), eS = !$C || !$C[EE] || !$C[EE].findChild, tS = Jh && Dne(function() {
      return mE(Ef({}, "a", { get: function() {
        return Ef(this, "a", { value: 7 }).a;
      } })).a != 7;
    }) ? function(e, n, i) {
      var o = vD(Mc, n);
      o && delete Mc[n], Ef(e, n, i), o && e !== Mc && Ef(Mc, n, o);
    } : Ef, nS = function(e, n) {
      var i = sd[e] = mE(G1);
      return Yne(i, { type: F1, tag: e, description: n }), Jh || (i.description = n), i;
    }, V1 = function(e, n, i) {
      e === Mc && V1(yE, n, i), KC(e);
      var o = JC(n);
      return KC(i), ea(sd, o) ? (i.enumerable ? (ea(e, $a) && e[$a][o] && (e[$a][o] = !1), i = mE(i, { enumerable: ZC(0, !1) })) : (ea(e, $a) || Ef(e, $a, ZC(1, {})), e[$a][o] = !0), tS(e, o, i)) : Ef(e, o, i);
    }, rS = function(e, n) {
      KC(e);
      var i = B1(n), o = uD(i).concat(SD(i));
      return z1(o, function(f) {
        Jh && !qC(AD, i, f) || V1(e, f, i[f]);
      }), e;
    }, AD = function(e) {
      var n = JC(e), i = qC(Wne, this, n);
      return !(this === Mc && ea(sd, n) && !ea(yE, n)) && (!(i || !ea(this, n) || !ea(sd, n) || ea(this, $a) && this[$a][n]) || i);
    }, OD = function(e, n) {
      var i = B1(e), o = JC(n);
      if (i !== Mc || !ea(sd, o) || ea(yE, o)) {
        var f = vD(i, o);
        return !f || !ea(sd, o) || ea(i, $a) && i[$a][o] || (f.enumerable = !0), f;
      }
    }, CD = function(e) {
      var n = TD(B1(e)), i = [];
      return z1(n, function(o) {
        ea(sd, o) || ea(gD, o) || bD(i, o);
      }), i;
    }, SD = function(e) {
      var n = e === Mc, i = TD(n ? yE : B1(e)), o = [];
      return z1(i, function(f) {
        !ea(sd, f) || n && !ea(Mc, f) || bD(o, sd[f]);
      }), o;
    };
    Zh || (mf = function() {
      if (Mne(G1, this)) throw Xne("Symbol is not a constructor");
      var e = arguments.length && arguments[0] !== void 0 ? Lne(arguments[0]) : void 0, n = mD(e), i = function(o) {
        this === Mc && qC(i, yE, o), ea(this, $a) && ea(this[$a], n) && (this[$a][n] = !1), tS(this, n, ZC(1, o));
      };
      return Jh && eS && tS(Mc, n, { configurable: !0, set: i }), nS(n, e);
    }, pD(G1 = mf[EE], "toString", function() {
      return yD(this).tag;
    }), pD(mf, "withoutSetter", function(e) {
      return nS(mD(e), e);
    }), hD.f = AD, fD.f = V1, Une.f = rS, lD.f = OD, kne.f = dD.f = CD, jne.f = SD, zne.f = function(e) {
      return nS(Bne(e), e);
    }, Jh && Hne(G1, "description", { configurable: !0, get: function() {
      return yD(this).description;
    } })), H1({ global: !0, constructor: !0, wrap: !0, forced: !Zh, sham: !Zh }, { Symbol: mf }), z1(uD(qne), function(e) {
      Fne(e);
    }), H1({ target: F1, stat: !0, forced: !Zh }, { useSetter: function() {
      eS = !0;
    }, useSimple: function() {
      eS = !1;
    } }), H1({ target: "Object", stat: !0, forced: !Zh, sham: !Jh }, { create: function(e, n) {
      return n === void 0 ? mE(e) : rS(mE(e), n);
    }, defineProperty: V1, defineProperties: rS, getOwnPropertyDescriptor: OD }), H1({ target: "Object", stat: !0, forced: !Zh }, { getOwnPropertyNames: CD }), Gne(), Vne(mf, F1), gD[$a] = !0;
    var ID = re && !!Symbol.for && !!Symbol.keyFor, Kne = _r, Jne = kt, Zne = Lt, Qne = Oo, RD = Fe, $ne = ID, iS = RD("string-to-symbol-registry"), ere = RD("symbol-to-string-registry");
    Kne({ target: "Symbol", stat: !0, forced: !$ne }, { for: function(e) {
      var n = Qne(e);
      if (Zne(iS, n)) return iS[n];
      var i = Jne("Symbol")(n);
      return iS[n] = i, ere[i] = n, i;
    } });
    var tre = _r, nre = Lt, rre = rt, ire = lt, sre = ID, ND = Fe("symbol-to-string-registry");
    tre({ target: "Symbol", stat: !0, forced: !sre }, { keyFor: function(e) {
      if (!rre(e)) throw TypeError(ire(e) + " is not a symbol");
      if (nre(ND, e)) return ND[e];
    } });
    var wD = qm, are = U, _D = H, ore = Oo, PD = p([].push), cre = _r, xD = kt, DD = w, ure = se, vE = p, MD = b, LD = U, kD = rt, jD = o1, dre = function(e) {
      if (are(e)) return e;
      if (wD(e)) {
        for (var n = e.length, i = [], o = 0; o < n; o++) {
          var f = e[o];
          typeof f == "string" ? PD(i, f) : typeof f != "number" && _D(f) != "Number" && _D(f) != "String" || PD(i, ore(f));
        }
        var T = i.length, A = !0;
        return function(R, P) {
          if (A) return A = !1, P;
          if (wD(this)) return P;
          for (var L = 0; L < T; L++) if (i[L] === R) return P;
        };
      }
    }, lre = re, fre = String, Zd = xD("JSON", "stringify"), Y1 = vE(/./.exec), UD = vE("".charAt), hre = vE("".charCodeAt), pre = vE("".replace), gre = vE(1 .toString), mre = /[\uD800-\uDFFF]/g, HD = /^[\uD800-\uDBFF]$/, BD = /^[\uDC00-\uDFFF]$/, zD = !lre || MD(function() {
      var e = xD("Symbol")();
      return Zd([e]) != "[null]" || Zd({ a: e }) != "{}" || Zd(Object(e)) != "{}";
    }), FD = MD(function() {
      return Zd("\uDF06\uD834") !== '"\\udf06\\ud834"' || Zd("\uDEAD") !== '"\\udead"';
    }), Ere = function(e, n) {
      var i = jD(arguments), o = dre(n);
      if (LD(o) || e !== void 0 && !kD(e)) return i[1] = function(f, T) {
        if (LD(o) && (T = ure(o, this, fre(f), T)), !kD(T)) return T;
      }, DD(Zd, null, i);
    }, yre = function(e, n, i) {
      var o = UD(i, n - 1), f = UD(i, n + 1);
      return Y1(HD, e) && !Y1(BD, f) || Y1(BD, e) && !Y1(HD, o) ? "\\u" + gre(hre(e, 0), 16) : e;
    };
    Zd && cre({ target: "JSON", stat: !0, arity: 3, forced: zD || FD }, { stringify: function(e, n, i) {
      var o = jD(arguments), f = DD(zD ? Ere : Zd, null, o);
      return FD && typeof f == "string" ? pre(f, mre, yre) : f;
    } });
    var GD = Km, vre = et;
    _r({ target: "Object", stat: !0, forced: !re || b(function() {
      GD.f(1);
    }) }, { getOwnPropertySymbols: function(e) {
      var n = GD.f;
      return n ? n(vre(e)) : [];
    } }), As("asyncIterator"), As("hasInstance"), As("isConcatSpreadable"), As("iterator"), As("match"), As("matchAll"), As("replace"), As("search"), As("species"), As("split");
    var Tre = aD;
    As("toPrimitive"), Tre();
    var bre = kt, Are = Yd;
    As("toStringTag"), Are(bre("Symbol"), "Symbol"), As("unscopables"), Yd(y.JSON, "JSON", !0);
    var Ore = it.Symbol, Cre = Or, Sre = Ts.f, VD = Cre("metadata"), YD = Function.prototype;
    YD[VD] === void 0 && Sre(YD, VD, { value: null }), As("dispose"), As("metadata");
    var Ire = Ore;
    As("asyncDispose");
    var Rre = p, sS = kt("Symbol"), Nre = sS.keyFor, wre = Rre(sS.prototype.valueOf), XD = sS.isRegisteredSymbol || function(e) {
      try {
        return Nre(wre(e)) !== void 0;
      } catch {
        return !1;
      }
    };
    _r({ target: "Symbol", stat: !0 }, { isRegisteredSymbol: XD });
    for (var _re = Fe, WD = kt, Pre = p, xre = rt, Dre = Or, X1 = WD("Symbol"), qD = X1.isWellKnownSymbol, KD = WD("Object", "getOwnPropertyNames"), Mre = Pre(X1.prototype.valueOf), JD = _re("wks"), aS = 0, ZD = KD(X1), Lre = ZD.length; aS < Lre; aS++) try {
      var QD = ZD[aS];
      xre(X1[QD]) && Dre(QD);
    } catch {
    }
    var $D = function(e) {
      if (qD && qD(e)) return !0;
      try {
        for (var n = Mre(e), i = 0, o = KD(JD), f = o.length; i < f; i++) if (JD[o[i]] == n) return !0;
      } catch {
      }
      return !1;
    };
    _r({ target: "Symbol", stat: !0, forced: !0 }, { isWellKnownSymbol: $D }), As("matcher"), As("observable"), _r({ target: "Symbol", stat: !0, name: "isRegisteredSymbol" }, { isRegistered: XD }), _r({ target: "Symbol", stat: !0, name: "isWellKnownSymbol", forced: !0 }, { isWellKnown: $D }), As("metadataKey"), As("patternMatch"), As("replaceAll");
    var Qh = h(Ire), eM = h(Kh.f("iterator"));
    function TE(e) {
      return TE = typeof Qh == "function" && typeof eM == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Qh == "function" && n.constructor === Qh && n !== Qh.prototype ? "symbol" : typeof n;
      }, TE(e);
    }
    var kre = h(Kh.f("toPrimitive"));
    function jre(e) {
      var n = function(i, o) {
        if (TE(i) !== "object" || i === null) return i;
        var f = i[kre];
        if (f !== void 0) {
          var T = f.call(i, o || "default");
          if (TE(T) !== "object") return T;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (o === "string" ? String : Number)(i);
      }(e, "string");
      return TE(n) === "symbol" ? n : String(n);
    }
    function Ve(e, n, i) {
      return (n = jre(n)) in e ? qx(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
    }
    var tM = h(v$), Ure = { isBrowser: !0, classes: { URLSearchParams: tM !== void 0 ? tM : XC, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] };
    const oS = typeof window < "u" && typeof document < "u", cS = typeof navigator == "object" && navigator || void 0, Hre = oS && (!cS || ["ReactNative", "NativeScript", "NS"].indexOf(cS.product) < 0), Bre = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", zre = oS && window.location.href || "http://localhost";
    function nM(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function rM(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? nM(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : nM(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    var eo = rM(rM({}, Object.freeze({ __proto__: null, hasBrowserEnv: oS, hasStandardBrowserEnv: Hre, hasStandardBrowserWebWorkerEnv: Bre, navigator: cS, origin: zre })), Ure), Fre = Zi, Gre = se, Vre = Lt, Yre = m, Xre = function() {
      var e = Fre(this), n = "";
      return e.hasIndices && (n += "d"), e.global && (n += "g"), e.ignoreCase && (n += "i"), e.multiline && (n += "m"), e.dotAll && (n += "s"), e.unicode && (n += "u"), e.unicodeSets && (n += "v"), e.sticky && (n += "y"), n;
    }, iM = RegExp.prototype, sM = function(e) {
      var n = e.flags;
      return n !== void 0 || "flags" in iM || Vre(e, "flags") || !Yre(iM, e) ? n : Gre(Xre, e);
    }, Wre = GO.charAt, aM = se, qre = Zi, Kre = U, Jre = H, Zre = /./.exec, Qre = TypeError, $re = _r, oM = se, cM = D, eie = dO, W1 = fO, uM = Ke, dM = p_, bE = Oo, tie = Zi, nie = be, rie = H, iie = m_, lM = sM, sie = ge, aie = b, oie = EO, cie = function(e, n, i) {
      return n + (i ? Wre(e, n).length : 1);
    }, uie = function(e, n) {
      var i = e.exec;
      if (Kre(i)) {
        var o = aM(i, e, n);
        return o !== null && qre(o), o;
      }
      if (Jre(e) === "RegExp") return aM(Zre, e, n);
      throw Qre("RegExp#exec called on incompatible receiver");
    }, fM = of, die = Or("matchAll"), hM = "RegExp String", pM = hM + " Iterator", lie = fM.set, fie = fM.getterFor(pM), hie = TypeError, uS = cM("".indexOf), q1 = cM("".matchAll), dS = !!q1 && !aie(function() {
      q1("a", /./);
    }), pie = eie(function(e, n, i, o) {
      lie(this, { type: pM, regexp: e, string: n, global: i, unicode: o, done: !1 });
    }, hM, function() {
      var e = fie(this);
      if (e.done) return W1(void 0, !0);
      var n = e.regexp, i = e.string, o = uie(n, i);
      return o === null ? (e.done = !0, W1(void 0, !0)) : e.global ? (bE(o[0]) === "" && (n.lastIndex = cie(i, dM(n.lastIndex), e.unicode)), W1(o, !1)) : (e.done = !0, W1(o, !1));
    }), gM = function(e) {
      var n, i, o, f = tie(this), T = bE(e), A = oie(f, RegExp), R = bE(lM(f));
      return n = new A(A === RegExp ? f.source : f, R), i = !!~uS(R, "g"), o = !!~uS(R, "u"), n.lastIndex = dM(f.lastIndex), new pie(n, T, i, o);
    };
    $re({ target: "String", proto: !0, forced: dS }, { matchAll: function(e) {
      var n, i, o, f, T = uM(this);
      if (nie(e)) {
        if (dS) return q1(T, e);
      } else {
        if (iie(e) && (n = bE(uM(lM(e))), !~uS(n, "g"))) throw hie("`.matchAll` does not allow non-global regexes");
        if (dS) return q1(T, e);
        if ((o = sie(e, die)) === void 0 && rie(e) == "RegExp" && (o = gM), o) return oM(o, e, T);
      }
      return i = bE(T), f = new RegExp(e, "g"), oM(gM, f, i);
    } });
    var gie = Jo("String").matchAll, mie = m, Eie = gie, lS = String.prototype, yie = function(e) {
      var n = e.matchAll;
      return typeof e == "string" || e === lS || mie(lS, e) && n === lS.matchAll ? Eie : n;
    }, vie = h(yie);
    function mM(e) {
      function n(i, o, f, T) {
        let A = i[T++];
        if (A === "__proto__") return !0;
        const R = Number.isFinite(+A), P = T >= i.length;
        return A = !A && an.isArray(f) ? f.length : A, P ? (an.hasOwnProp(f, A) ? f[A] = [f[A], o] : f[A] = o, !R) : (f[A] && an.isObject(f[A]) || (f[A] = []), n(i, o, f[A], T) && an.isArray(f[A]) && (f[A] = function(L) {
          const z = {}, Y = Object.keys(L);
          let te;
          const oe = Y.length;
          let He;
          for (te = 0; te < oe; te++) He = Y[te], z[He] = L[He];
          return z;
        }(f[A])), !R);
      }
      if (an.isFormData(e) && an.isFunction(e.entries)) {
        const i = {};
        return an.forEachEntry(e, (o, f) => {
          n(function(T) {
            return vie(an).call(an, /\w+|\[(\w*)]/g, T).map((A) => A[0] === "[]" ? "" : A[1] || A[0]);
          }(o), f, i, 0);
        }), i;
      }
      return null;
    }
    const fS = { transitional: Vx, adapter: ["xhr", "http", "fetch"], transformRequest: [function(e, n) {
      const i = n.getContentType() || "", o = i.indexOf("application/json") > -1, f = an.isObject(e);
      if (f && an.isHTMLForm(e) && (e = new FormData(e)), an.isFormData(e)) return o ? JSON.stringify(mM(e)) : e;
      if (an.isArrayBuffer(e) || an.isBuffer(e) || an.isStream(e) || an.isFile(e) || an.isBlob(e) || an.isReadableStream(e)) return e;
      if (an.isArrayBufferView(e)) return e.buffer;
      if (an.isURLSearchParams(e)) return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
      let T;
      if (f) {
        if (i.indexOf("application/x-www-form-urlencoded") > -1) return function(A, R) {
          return U1(A, new eo.classes.URLSearchParams(), Object.assign({ visitor: function(P, L, z, Y) {
            return eo.isNode && an.isBuffer(P) ? (this.append(L, P.toString("base64")), !1) : Y.defaultVisitor.apply(this, arguments);
          } }, R));
        }(e, this.formSerializer).toString();
        if ((T = an.isFileList(e)) || i.indexOf("multipart/form-data") > -1) {
          const A = this.env && this.env.FormData;
          return U1(T ? { "files[]": e } : e, A && new A(), this.formSerializer);
        }
      }
      return f || o ? (n.setContentType("application/json", !1), function(A, R, P) {
        if (an.isString(A)) try {
          return (R || JSON.parse)(A), Ys(an).call(an, A);
        } catch (L) {
          if (L.name !== "SyntaxError") throw L;
        }
        return (0, JSON.stringify)(A);
      }(e)) : e;
    }], transformResponse: [function(e) {
      const n = this.transitional || fS.transitional, i = n && n.forcedJSONParsing, o = this.responseType === "json";
      if (an.isResponse(e) || an.isReadableStream(e)) return e;
      if (e && an.isString(e) && (i && !this.responseType || o)) {
        const f = !(n && n.silentJSONParsing) && o;
        try {
          return JSON.parse(e);
        } catch (T) {
          if (f)
            throw T.name === "SyntaxError" ? Pr.from(T, Pr.ERR_BAD_RESPONSE, this, null, this.response) : T;
        }
      }
      return e;
    }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: eo.classes.FormData, Blob: eo.classes.Blob }, validateStatus: function(e) {
      return e >= 200 && e < 300;
    }, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
    an.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
      fS.headers[e] = {};
    });
    var hS = fS;
    const Tie = an.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), EM = Symbol("internals");
    function AE(e) {
      var n;
      return e && Ys(n = String(e)).call(n).toLowerCase();
    }
    function K1(e) {
      return e === !1 || e == null ? e : an.isArray(e) ? e.map(K1) : String(e);
    }
    function pS(e, n, i, o, f) {
      return an.isFunction(o) ? o.call(this, n, i) : (f && (n = i), an.isString(n) ? an.isString(o) ? n.indexOf(o) !== -1 : an.isRegExp(o) ? o.test(n) : void 0 : void 0);
    }
    class J1 {
      constructor(n) {
        n && this.set(n);
      }
      set(n, i, o) {
        const f = this;
        function T(P, L, z) {
          const Y = AE(L);
          if (!Y) throw new Error("header name must be a non-empty string");
          const te = an.findKey(f, Y);
          (!te || f[te] === void 0 || z === !0 || z === void 0 && f[te] !== !1) && (f[te || L] = K1(P));
        }
        const A = (P, L) => an.forEach(P, (z, Y) => T(z, Y, L));
        if (an.isPlainObject(n) || n instanceof this.constructor) A(n, i);
        else if (an.isString(n) && (n = Ys(n).call(n)) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(Ys(R = n).call(R))) A(((P) => {
          const L = {};
          let z, Y, te;
          return P && P.split(`
`).forEach(function(oe) {
            var He, Re;
            te = oe.indexOf(":"), z = Ys(He = oe.substring(0, te)).call(He).toLowerCase(), Y = Ys(Re = oe.substring(te + 1)).call(Re), !z || L[z] && Tie[z] || (z === "set-cookie" ? L[z] ? L[z].push(Y) : L[z] = [Y] : L[z] = L[z] ? L[z] + ", " + Y : Y);
          }), L;
        })(n), i);
        else if (an.isHeaders(n)) for (const [P, L] of n.entries()) T(L, P, o);
        else n != null && T(i, n, o);
        var R;
        return this;
      }
      get(n, i) {
        if (n = AE(n)) {
          const o = an.findKey(this, n);
          if (o) {
            const f = this[o];
            if (!i) return f;
            if (i === !0) return function(T) {
              const A = /* @__PURE__ */ Object.create(null), R = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
              let P;
              for (; P = R.exec(T); ) A[P[1]] = P[2];
              return A;
            }(f);
            if (an.isFunction(i)) return i.call(this, f, o);
            if (an.isRegExp(i)) return i.exec(f);
            throw new TypeError("parser must be boolean|regexp|function");
          }
        }
      }
      has(n, i) {
        if (n = AE(n)) {
          const o = an.findKey(this, n);
          return !(!o || this[o] === void 0 || i && !pS(0, this[o], o, i));
        }
        return !1;
      }
      delete(n, i) {
        const o = this;
        let f = !1;
        function T(A) {
          if (A = AE(A)) {
            const R = an.findKey(o, A);
            !R || i && !pS(0, o[R], R, i) || (delete o[R], f = !0);
          }
        }
        return an.isArray(n) ? n.forEach(T) : T(n), f;
      }
      clear(n) {
        const i = Object.keys(this);
        let o = i.length, f = !1;
        for (; o--; ) {
          const T = i[o];
          n && !pS(0, this[T], T, n, !0) || (delete this[T], f = !0);
        }
        return f;
      }
      normalize(n) {
        const i = this, o = {};
        return an.forEach(this, (f, T) => {
          var A;
          const R = an.findKey(o, T);
          if (R) return i[R] = K1(f), void delete i[T];
          const P = n ? function(L) {
            return Ys(L).call(L).toLowerCase().replace(/([a-z\d])(\w*)/g, (z, Y, te) => Y.toUpperCase() + te);
          }(T) : Ys(A = String(T)).call(A);
          P !== T && delete i[T], i[P] = K1(f), o[P] = !0;
        }), this;
      }
      concat() {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
        return this.constructor.concat(this, ...i);
      }
      toJSON(n) {
        const i = /* @__PURE__ */ Object.create(null);
        return an.forEach(this, (o, f) => {
          o != null && o !== !1 && (i[f] = n && an.isArray(o) ? o.join(", ") : o);
        }), i;
      }
      [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
      }
      toString() {
        return Object.entries(this.toJSON()).map((n) => {
          let [i, o] = n;
          return i + ": " + o;
        }).join(`
`);
      }
      get [Symbol.toStringTag]() {
        return "AxiosHeaders";
      }
      static from(n) {
        return n instanceof this ? n : new this(n);
      }
      static concat(n) {
        const i = new this(n);
        for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), T = 1; T < o; T++) f[T - 1] = arguments[T];
        return f.forEach((A) => i.set(A)), i;
      }
      static accessor(n) {
        const i = (this[EM] = this[EM] = { accessors: {} }).accessors, o = this.prototype;
        function f(T) {
          const A = AE(T);
          i[A] || (function(R, P) {
            const L = an.toCamelCase(" " + P);
            ["get", "set", "has"].forEach((z) => {
              Object.defineProperty(R, z + L, { value: function(Y, te, oe) {
                return this[z].call(this, P, Y, te, oe);
              }, configurable: !0 });
            });
          }(o, T), i[A] = !0);
        }
        return an.isArray(n) ? n.forEach(f) : f(n), this;
      }
    }
    J1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), an.reduceDescriptors(J1.prototype, (e, n) => {
      let { value: i } = e, o = n[0].toUpperCase() + n.slice(1);
      return { get: () => i, set(f) {
        this[o] = f;
      } };
    }), an.freezeMethods(J1);
    var Lc = J1;
    function gS(e, n) {
      const i = this || hS, o = n || i, f = Lc.from(o.headers);
      let T = o.data;
      return an.forEach(e, function(A) {
        T = A.call(i, T, f.normalize(), n ? n.status : void 0);
      }), f.normalize(), T;
    }
    function yM(e) {
      return !(!e || !e.__CANCEL__);
    }
    function $h(e, n, i) {
      Pr.call(this, e ?? "canceled", Pr.ERR_CANCELED, n, i), this.name = "CanceledError";
    }
    function vM(e, n, i) {
      const o = i.config.validateStatus;
      i.status && o && !o(i.status) ? n(new Pr("Request failed with status code " + i.status, [Pr.ERR_BAD_REQUEST, Pr.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4], i.config, i.request, i)) : e(i);
    }
    an.inherits($h, Pr, { __CANCEL__: !0 });
    const Z1 = function(e, n) {
      let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3, o = 0;
      const f = function(T, A) {
        T = T || 10;
        const R = new Array(T), P = new Array(T);
        let L, z = 0, Y = 0;
        return A = A !== void 0 ? A : 1e3, function(te) {
          const oe = Date.now(), He = P[Y];
          L || (L = oe), R[z] = te, P[z] = oe;
          let Re = Y, De = 0;
          for (; Re !== z; ) De += R[Re++], Re %= T;
          if (z = (z + 1) % T, z === Y && (Y = (Y + 1) % T), oe - L < A) return;
          const Xe = He && oe - He;
          return Xe ? Math.round(1e3 * De / Xe) : void 0;
        };
      }(50, 250);
      return function(T, A) {
        let R, P, L = 0, z = 1e3 / A;
        const Y = function(te) {
          L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), R = null, P && (clearTimeout(P), P = null), T.apply(null, te);
        };
        return [function() {
          const te = Date.now(), oe = te - L;
          for (var He = arguments.length, Re = new Array(He), De = 0; De < He; De++) Re[De] = arguments[De];
          oe >= z ? Y(Re, te) : (R = Re, P || (P = setTimeout(() => {
            P = null, Y(R);
          }, z - oe)));
        }, () => R && Y(R)];
      }((T) => {
        const A = T.loaded, R = T.lengthComputable ? T.total : void 0, P = A - o, L = f(P);
        o = A, e({ loaded: A, total: R, progress: R ? A / R : void 0, bytes: P, rate: L || void 0, estimated: L && R && A <= R ? (R - A) / L : void 0, event: T, lengthComputable: R != null, [n ? "download" : "upload"]: !0 });
      }, i);
    }, TM = (e, n) => {
      const i = e != null;
      return [(o) => n[0]({ lengthComputable: i, total: e, loaded: o }), n[1]];
    }, bM = (e) => function() {
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
      return an.asap(() => e(...i));
    };
    var bie = eo.hasStandardBrowserEnv ? function() {
      const e = eo.navigator && /(msie|trident)/i.test(eo.navigator.userAgent), n = document.createElement("a");
      let i;
      function o(f) {
        let T = f;
        return e && (n.setAttribute("href", T), T = n.href), n.setAttribute("href", T), { href: n.href, protocol: n.protocol ? n.protocol.replace(/:$/, "") : "", host: n.host, search: n.search ? n.search.replace(/^\?/, "") : "", hash: n.hash ? n.hash.replace(/^#/, "") : "", hostname: n.hostname, port: n.port, pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname };
      }
      return i = o(window.location.href), function(f) {
        const T = an.isString(f) ? o(f) : f;
        return T.protocol === i.protocol && T.host === i.host;
      };
    }() : function() {
      return !0;
    }, Aie = eo.hasStandardBrowserEnv ? { write(e, n, i, o, f, T) {
      const A = [e + "=" + encodeURIComponent(n)];
      an.isNumber(i) && A.push("expires=" + new Date(i).toGMTString()), an.isString(o) && A.push("path=" + o), an.isString(f) && A.push("domain=" + f), T === !0 && A.push("secure"), document.cookie = A.join("; ");
    }, read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    }, remove(e) {
      this.write(e, "", Date.now() - 864e5);
    } } : { write() {
    }, read: () => null, remove() {
    } };
    function AM(e, n) {
      return e && !function(i) {
        return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(i);
      }(n) ? function(i, o) {
        return o ? i.replace(/\/?\/$/, "") + "/" + o.replace(/^\/+/, "") : i;
      }(e, n) : n;
    }
    function OM(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    const CM = (e) => e instanceof Lc ? function(n) {
      for (var i = 1; i < arguments.length; i++) {
        var o = arguments[i] != null ? arguments[i] : {};
        i % 2 ? OM(Object(o), !0).forEach(function(f) {
          Ve(n, f, o[f]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : OM(Object(o)).forEach(function(f) {
          Object.defineProperty(n, f, Object.getOwnPropertyDescriptor(o, f));
        });
      }
      return n;
    }({}, e) : e;
    function yf(e, n) {
      n = n || {};
      const i = {};
      function o(L, z, Y) {
        return an.isPlainObject(L) && an.isPlainObject(z) ? an.merge.call({ caseless: Y }, L, z) : an.isPlainObject(z) ? an.merge({}, z) : an.isArray(z) ? z.slice() : z;
      }
      function f(L, z, Y) {
        return an.isUndefined(z) ? an.isUndefined(L) ? void 0 : o(void 0, L, Y) : o(L, z, Y);
      }
      function T(L, z) {
        if (!an.isUndefined(z)) return o(void 0, z);
      }
      function A(L, z) {
        return an.isUndefined(z) ? an.isUndefined(L) ? void 0 : o(void 0, L) : o(void 0, z);
      }
      function R(L, z, Y) {
        return Y in n ? o(L, z) : Y in e ? o(void 0, L) : void 0;
      }
      const P = { url: T, method: T, data: T, baseURL: A, transformRequest: A, transformResponse: A, paramsSerializer: A, timeout: A, timeoutMessage: A, withCredentials: A, withXSRFToken: A, adapter: A, responseType: A, xsrfCookieName: A, xsrfHeaderName: A, onUploadProgress: A, onDownloadProgress: A, decompress: A, maxContentLength: A, maxBodyLength: A, beforeRedirect: A, transport: A, httpAgent: A, httpsAgent: A, cancelToken: A, socketPath: A, responseEncoding: A, validateStatus: R, headers: (L, z) => f(CM(L), CM(z), !0) };
      return an.forEach(Object.keys(Object.assign({}, e, n)), function(L) {
        const z = P[L] || f, Y = z(e[L], n[L], L);
        an.isUndefined(Y) && z !== R || (i[L] = Y);
      }), i;
    }
    var SM = (e) => {
      const n = yf({}, e);
      let i, { data: o, withXSRFToken: f, xsrfHeaderName: T, xsrfCookieName: A, headers: R, auth: P } = n;
      if (n.headers = R = Lc.from(R), n.url = Fx(AM(n.baseURL, n.url), e.params, e.paramsSerializer), P && R.set("Authorization", "Basic " + btoa((P.username || "") + ":" + (P.password ? unescape(encodeURIComponent(P.password)) : ""))), an.isFormData(o)) {
        if (eo.hasStandardBrowserEnv || eo.hasStandardBrowserWebWorkerEnv) R.setContentType(void 0);
        else if ((i = R.getContentType()) !== !1) {
          const [L, ...z] = i ? i.split(";").map((Y) => Ys(Y).call(Y)).filter(Boolean) : [];
          R.setContentType([L || "multipart/form-data", ...z].join("; "));
        }
      }
      if (eo.hasStandardBrowserEnv && (f && an.isFunction(f) && (f = f(n)), f || f !== !1 && bie(n.url))) {
        const L = T && A && Aie.read(A);
        L && R.set(T, L);
      }
      return n;
    }, Oie = typeof XMLHttpRequest < "u" && function(e) {
      return new cn(function(n, i) {
        const o = SM(e);
        let f = o.data;
        const T = Lc.from(o.headers).normalize();
        let A, R, P, L, z, { responseType: Y, onUploadProgress: te, onDownloadProgress: oe } = o;
        function He() {
          L && L(), z && z(), o.cancelToken && o.cancelToken.unsubscribe(A), o.signal && o.signal.removeEventListener("abort", A);
        }
        let Re = new XMLHttpRequest();
        function De() {
          if (!Re) return;
          const We = Lc.from("getAllResponseHeaders" in Re && Re.getAllResponseHeaders());
          vM(function(mt) {
            n(mt), He();
          }, function(mt) {
            i(mt), He();
          }, { data: Y && Y !== "text" && Y !== "json" ? Re.response : Re.responseText, status: Re.status, statusText: Re.statusText, headers: We, config: e, request: Re }), Re = null;
        }
        Re.open(o.method.toUpperCase(), o.url, !0), Re.timeout = o.timeout, "onloadend" in Re ? Re.onloadend = De : Re.onreadystatechange = function() {
          Re && Re.readyState === 4 && (Re.status !== 0 || Re.responseURL && Re.responseURL.indexOf("file:") === 0) && setTimeout(De);
        }, Re.onabort = function() {
          Re && (i(new Pr("Request aborted", Pr.ECONNABORTED, e, Re)), Re = null);
        }, Re.onerror = function() {
          i(new Pr("Network Error", Pr.ERR_NETWORK, e, Re)), Re = null;
        }, Re.ontimeout = function() {
          let We = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
          const mt = o.transitional || Vx;
          o.timeoutErrorMessage && (We = o.timeoutErrorMessage), i(new Pr(We, mt.clarifyTimeoutError ? Pr.ETIMEDOUT : Pr.ECONNABORTED, e, Re)), Re = null;
        }, f === void 0 && T.setContentType(null), "setRequestHeader" in Re && an.forEach(T.toJSON(), function(We, mt) {
          Re.setRequestHeader(mt, We);
        }), an.isUndefined(o.withCredentials) || (Re.withCredentials = !!o.withCredentials), Y && Y !== "json" && (Re.responseType = o.responseType), oe && ([P, z] = Z1(oe, !0), Re.addEventListener("progress", P)), te && Re.upload && ([R, L] = Z1(te), Re.upload.addEventListener("progress", R), Re.upload.addEventListener("loadend", L)), (o.cancelToken || o.signal) && (A = (We) => {
          Re && (i(!We || We.type ? new $h(null, e, Re) : We), Re.abort(), Re = null);
        }, o.cancelToken && o.cancelToken.subscribe(A), o.signal && (o.signal.aborted ? A() : o.signal.addEventListener("abort", A)));
        const Xe = function(We) {
          const mt = /^([-+\w]{1,25})(:?\/\/|:)/.exec(We);
          return mt && mt[1] || "";
        }(o.url);
        Xe && eo.protocols.indexOf(Xe) === -1 ? i(new Pr("Unsupported protocol " + Xe + ":", Pr.ERR_BAD_REQUEST, e)) : Re.send(f || null);
      });
    }, Cie = (e, n) => {
      const { length: i } = e = e ? e.filter(Boolean) : [];
      if (n || i) {
        let o, f = new AbortController();
        const T = function(L) {
          if (!o) {
            o = !0, R();
            const z = L instanceof Error ? L : this.reason;
            f.abort(z instanceof Pr ? z : new $h(z instanceof Error ? z.message : z));
          }
        };
        let A = n && setTimeout(() => {
          A = null, T(new Pr("timeout ".concat(n, " of ms exceeded"), Pr.ETIMEDOUT));
        }, n);
        const R = () => {
          e && (A && clearTimeout(A), A = null, e.forEach((L) => {
            L.unsubscribe ? L.unsubscribe(T) : L.removeEventListener("abort", T);
          }), e = null);
        };
        e.forEach((L) => L.addEventListener("abort", T));
        const { signal: P } = f;
        return P.unsubscribe = () => an.asap(R), P;
      }
    }, Sie = g3, Iie = fu;
    _r({ target: "Promise", stat: !0, forced: !0 }, { withResolvers: function() {
      var e = Iie.f(this);
      return { promise: e.promise, resolve: e.resolve, reject: e.reject };
    } });
    var Rie = fu, Nie = Mh;
    _r({ target: "Promise", stat: !0, forced: !0 }, { try: function(e) {
      var n = Rie.f(this), i = Nie(e);
      return (i.error ? n.reject : n.resolve)(i.value), n.promise;
    } });
    var mS = h(Sie), IM = Kh.f("asyncIterator"), wie = h(IM);
    function ES(e, n) {
      this.v = e, this.k = n;
    }
    function OE(e) {
      var n, i;
      function o(T, A) {
        try {
          var R = e[T](A), P = R.value, L = P instanceof ES;
          mS.resolve(L ? P.v : P).then(function(z) {
            if (L) {
              var Y = T === "return" ? "return" : "next";
              if (!P.k || z.done) return o(Y, z);
              z = e[Y](z).value;
            }
            f(R.done ? "return" : "normal", z);
          }, function(z) {
            o("throw", z);
          });
        } catch (z) {
          f("throw", z);
        }
      }
      function f(T, A) {
        switch (T) {
          case "return":
            n.resolve({ value: A, done: !0 });
            break;
          case "throw":
            n.reject(A);
            break;
          default:
            n.resolve({ value: A, done: !1 });
        }
        (n = n.next) ? o(n.key, n.arg) : i = null;
      }
      this._invoke = function(T, A) {
        return new mS(function(R, P) {
          var L = { key: T, arg: A, resolve: R, reject: P, next: null };
          i ? i = i.next = L : (n = i = L, o(T, A));
        });
      }, typeof e.return != "function" && (this.return = void 0);
    }
    function Io(e) {
      return function() {
        return new OE(e.apply(this, arguments));
      };
    }
    function dr(e) {
      return new ES(e, 0);
    }
    function Q1(e) {
      var n = {}, i = !1;
      function o(f, T) {
        return i = !0, { done: !1, value: new ES(T = new mS(function(A) {
          A(e[f](T));
        }), 1) };
      }
      return n[Qh !== void 0 && eM || "@@iterator"] = function() {
        return this;
      }, n.next = function(f) {
        return i ? (i = !1, f) : o("next", f);
      }, typeof e.throw == "function" && (n.throw = function(f) {
        if (i) throw i = !1, f;
        return o("throw", f);
      }), typeof e.return == "function" && (n.return = function(f) {
        return i ? (i = !1, f) : o("return", f);
      }), n;
    }
    OE.prototype[typeof Qh == "function" && wie || "@@asyncIterator"] = function() {
      return this;
    }, OE.prototype.next = function(e) {
      return this._invoke("next", e);
    }, OE.prototype.throw = function(e) {
      return this._invoke("throw", e);
    }, OE.prototype.return = function(e) {
      return this._invoke("return", e);
    };
    var yS = h(IM);
    function vS(e) {
      var n, i, o, f = 2;
      for (typeof Symbol < "u" && (i = yS, o = Symbol.iterator); f--; ) {
        if (i && (n = e[i]) != null) return n.call(e);
        if (o && (n = e[o]) != null) return new $1(n.call(e));
        i = "@@asyncIterator", o = "@@iterator";
      }
      throw new TypeError("Object is not async iterable");
    }
    function $1(e) {
      function n(i) {
        if (Object(i) !== i) return cn.reject(new TypeError(i + " is not an object."));
        var o = i.done;
        return cn.resolve(i.value).then(function(f) {
          return { value: f, done: o };
        });
      }
      return $1 = function(i) {
        this.s = i, this.n = i.next;
      }, $1.prototype = { s: null, n: null, next: function() {
        return n(this.n.apply(this.s, arguments));
      }, return: function(i) {
        var o = this.s.return;
        return o === void 0 ? cn.resolve({ value: i, done: !0 }) : n(o.apply(this.s, arguments));
      }, throw: function(i) {
        var o = this.s.return;
        return o === void 0 ? cn.reject(i) : n(o.apply(this.s, arguments));
      } }, new $1(e);
    }
    const _ie = function* (e, n) {
      let i = e.byteLength;
      if (!n || i < n) return void (yield e);
      let o, f = 0;
      for (; f < i; ) o = f + n, yield e.slice(f, o), f = o;
    }, Pie = function() {
      var e = Io(function* (n, i) {
        var o, f = !1, T = !1;
        try {
          for (var A, R = vS(xie(n)); f = !(A = yield dr(R.next())).done; f = !1) {
            const P = A.value;
            yield* Q1(vS(_ie(P, i)));
          }
        } catch (P) {
          T = !0, o = P;
        } finally {
          try {
            f && R.return != null && (yield dr(R.return()));
          } finally {
            if (T) throw o;
          }
        }
      });
      return function(n, i) {
        return e.apply(this, arguments);
      };
    }(), xie = function() {
      var e = Io(function* (n) {
        if (n[yS]) return void (yield* Q1(vS(n)));
        const i = n.getReader();
        try {
          for (; ; ) {
            const { done: o, value: f } = yield dr(i.read());
            if (o) break;
            yield f;
          }
        } finally {
          yield dr(i.cancel());
        }
      });
      return function(n) {
        return e.apply(this, arguments);
      };
    }(), RM = (e, n, i, o) => {
      const f = Pie(e, n);
      let T, A = 0, R = (P) => {
        T || (T = !0, o && o(P));
      };
      return new ReadableStream({ async pull(P) {
        try {
          const { done: L, value: z } = await f.next();
          if (L) return R(), void P.close();
          let Y = z.byteLength;
          if (i) {
            let te = A += Y;
            i(te);
          }
          P.enqueue(new Uint8Array(z));
        } catch (L) {
          throw R(L), L;
        }
      }, cancel: (P) => (R(P), f.return()) }, { highWaterMark: 2 });
    };
    function NM(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function wM(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? NM(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : NM(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const eT = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", _M = eT && typeof ReadableStream == "function", Die = eT && (typeof TextEncoder == "function" ? (PM = new TextEncoder(), (e) => PM.encode(e)) : async (e) => new Uint8Array(await new Response(e).arrayBuffer()));
    var PM;
    const xM = function(e) {
      try {
        for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) i[o - 1] = arguments[o];
        return !!e(...i);
      } catch {
        return !1;
      }
    }, Mie = _M && xM(() => {
      let e = !1;
      const n = new Request(eo.origin, { body: new ReadableStream(), method: "POST", get duplex() {
        return e = !0, "half";
      } }).headers.has("Content-Type");
      return e && !n;
    }), TS = _M && xM(() => an.isReadableStream(new Response("").body)), tT = { stream: TS && ((e) => e.body) };
    var DM;
    eT && (DM = new Response(), ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
      !tT[e] && (tT[e] = an.isFunction(DM[e]) ? (n) => n[e]() : (n, i) => {
        throw new Pr("Response type '".concat(e, "' is not supported"), Pr.ERR_NOT_SUPPORT, i);
      });
    }));
    const Lie = async (e, n) => {
      const i = an.toFiniteNumber(e.getContentLength());
      return i ?? (async (o) => o == null ? 0 : an.isBlob(o) ? o.size : an.isSpecCompliantForm(o) ? (await new Request(eo.origin, { method: "POST", body: o }).arrayBuffer()).byteLength : an.isArrayBufferView(o) || an.isArrayBuffer(o) ? o.byteLength : (an.isURLSearchParams(o) && (o += ""), an.isString(o) ? (await Die(o)).byteLength : void 0))(n);
    };
    var kie = eT && (async (e) => {
      let { url: n, method: i, data: o, signal: f, cancelToken: T, timeout: A, onDownloadProgress: R, onUploadProgress: P, responseType: L, headers: z, withCredentials: Y = "same-origin", fetchOptions: te } = SM(e);
      L = L ? (L + "").toLowerCase() : "text";
      let oe, He = Cie([f, T && T.toAbortSignal()], A);
      const Re = He && He.unsubscribe && (() => {
        He.unsubscribe();
      });
      let De;
      try {
        if (P && Mie && i !== "get" && i !== "head" && (De = await Lie(z, o)) !== 0) {
          let xt, Nt = new Request(n, { method: "POST", body: o, duplex: "half" });
          if (an.isFormData(o) && (xt = Nt.headers.get("content-type")) && z.setContentType(xt), Nt.body) {
            const [Vt, nn] = TM(De, Z1(bM(P)));
            o = RM(Nt.body, 65536, Vt, nn);
          }
        }
        an.isString(Y) || (Y = Y ? "include" : "omit");
        const Xe = "credentials" in Request.prototype;
        oe = new Request(n, wM(wM({}, te), {}, { signal: He, method: i.toUpperCase(), headers: z.normalize().toJSON(), body: o, duplex: "half", credentials: Xe ? Y : void 0 }));
        let We = await fetch(oe);
        const mt = TS && (L === "stream" || L === "response");
        if (TS && (R || mt && Re)) {
          const xt = {};
          ["status", "statusText", "headers"].forEach((fn) => {
            xt[fn] = We[fn];
          });
          const Nt = an.toFiniteNumber(We.headers.get("content-length")), [Vt, nn] = R && TM(Nt, Z1(bM(R), !0)) || [];
          We = new Response(RM(We.body, 65536, Vt, () => {
            nn && nn(), Re && Re();
          }), xt);
        }
        L = L || "text";
        let Pt = await tT[an.findKey(tT, L) || "text"](We, e);
        return !mt && Re && Re(), await new cn((xt, Nt) => {
          vM(xt, Nt, { data: Pt, headers: Lc.from(We.headers), status: We.status, statusText: We.statusText, config: e, request: oe });
        });
      } catch (Xe) {
        throw Re && Re(), Xe && Xe.name === "TypeError" && /fetch/i.test(Xe.message) ? Object.assign(new Pr("Network Error", Pr.ERR_NETWORK, e, oe), { cause: Xe.cause || Xe }) : Pr.from(Xe, Xe && Xe.code, e, oe);
      }
    });
    const bS = { http: null, xhr: Oie, fetch: kie };
    an.forEach(bS, (e, n) => {
      if (e) {
        try {
          Object.defineProperty(e, "name", { value: n });
        } catch {
        }
        Object.defineProperty(e, "adapterName", { value: n });
      }
    });
    const MM = (e) => "- ".concat(e), jie = (e) => an.isFunction(e) || e === null || e === !1;
    var LM = { getAdapter: (e) => {
      e = an.isArray(e) ? e : [e];
      const { length: n } = e;
      let i, o;
      const f = {};
      for (let T = 0; T < n; T++) {
        let A;
        if (i = e[T], o = i, !jie(i) && (o = bS[(A = String(i)).toLowerCase()], o === void 0)) throw new Pr("Unknown adapter '".concat(A, "'"));
        if (o) break;
        f[A || "#" + T] = o;
      }
      if (!o) {
        const T = Object.entries(f).map((A) => {
          let [R, P] = A;
          return "adapter ".concat(R, " ") + (P === !1 ? "is not supported by the environment" : "is not available in the build");
        });
        throw new Pr("There is no suitable adapter to dispatch the request " + (n ? T.length > 1 ? `since :
` + T.map(MM).join(`
`) : " " + MM(T[0]) : "as no adapter specified"), "ERR_NOT_SUPPORT");
      }
      return o;
    }, adapters: bS };
    function AS(e) {
      if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new $h(null, e);
    }
    function kM(e) {
      return AS(e), e.headers = Lc.from(e.headers), e.data = gS.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), LM.getAdapter(e.adapter || hS.adapter)(e).then(function(n) {
        return AS(e), n.data = gS.call(e, e.transformResponse, n), n.headers = Lc.from(n.headers), n;
      }, function(n) {
        return yM(n) || (AS(e), n && n.response && (n.response.data = gS.call(e, e.transformResponse, n.response), n.response.headers = Lc.from(n.response.headers))), cn.reject(n);
      });
    }
    const jM = "1.7.7", OS = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
      OS[e] = function(i) {
        return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
      };
    });
    const UM = {};
    OS.transitional = function(e, n, i) {
      function o(f, T) {
        return "[Axios v" + jM + "] Transitional option '" + f + "'" + T + (i ? ". " + i : "");
      }
      return (f, T, A) => {
        if (e === !1) throw new Pr(o(T, " has been removed" + (n ? " in " + n : "")), Pr.ERR_DEPRECATED);
        return n && !UM[T] && (UM[T] = !0, console.warn(o(T, " has been deprecated since v" + n + " and will be removed in the near future"))), !e || e(f, T, A);
      };
    };
    var CS = { assertOptions: function(e, n, i) {
      if (typeof e != "object") throw new Pr("options must be an object", Pr.ERR_BAD_OPTION_VALUE);
      const o = Object.keys(e);
      let f = o.length;
      for (; f-- > 0; ) {
        const T = o[f], A = n[T];
        if (A) {
          const R = e[T], P = R === void 0 || A(R, T, e);
          if (P !== !0) throw new Pr("option " + T + " must be " + P, Pr.ERR_BAD_OPTION_VALUE);
        } else if (i !== !0) throw new Pr("Unknown option " + T, Pr.ERR_BAD_OPTION);
      }
    }, validators: OS };
    const Qd = CS.validators;
    let nT = class {
      constructor(e) {
        this.defaults = e, this.interceptors = { request: new Gx(), response: new Gx() };
      }
      async request(e, n) {
        try {
          return await this._request(e, n);
        } catch (i) {
          if (i instanceof Error) {
            let o;
            Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
            const f = o.stack ? o.stack.replace(/^.+\n/, "") : "";
            try {
              i.stack ? f && !String(i.stack).endsWith(f.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + f) : i.stack = f;
            } catch {
            }
          }
          throw i;
        }
      }
      _request(e, n) {
        typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = yf(this.defaults, n);
        const { transitional: i, paramsSerializer: o, headers: f } = n;
        i !== void 0 && CS.assertOptions(i, { silentJSONParsing: Qd.transitional(Qd.boolean), forcedJSONParsing: Qd.transitional(Qd.boolean), clarifyTimeoutError: Qd.transitional(Qd.boolean) }, !1), o != null && (an.isFunction(o) ? n.paramsSerializer = { serialize: o } : CS.assertOptions(o, { encode: Qd.function, serialize: Qd.function }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
        let T = f && an.merge(f.common, f[n.method]);
        f && an.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (oe) => {
          delete f[oe];
        }), n.headers = Lc.concat(T, f);
        const A = [];
        let R = !0;
        this.interceptors.request.forEach(function(oe) {
          typeof oe.runWhen == "function" && oe.runWhen(n) === !1 || (R = R && oe.synchronous, A.unshift(oe.fulfilled, oe.rejected));
        });
        const P = [];
        let L;
        this.interceptors.response.forEach(function(oe) {
          P.push(oe.fulfilled, oe.rejected);
        });
        let z, Y = 0;
        if (!R) {
          const oe = [kM.bind(this), void 0];
          for (oe.unshift.apply(oe, A), oe.push.apply(oe, P), z = oe.length, L = cn.resolve(n); Y < z; ) L = L.then(oe[Y++], oe[Y++]);
          return L;
        }
        z = A.length;
        let te = n;
        for (Y = 0; Y < z; ) {
          const oe = A[Y++], He = A[Y++];
          try {
            te = oe(te);
          } catch (Re) {
            He.call(this, Re);
            break;
          }
        }
        try {
          L = kM.call(this, te);
        } catch (oe) {
          return cn.reject(oe);
        }
        for (Y = 0, z = P.length; Y < z; ) L = L.then(P[Y++], P[Y++]);
        return L;
      }
      getUri(e) {
        return Fx(AM((e = yf(this.defaults, e)).baseURL, e.url), e.params, e.paramsSerializer);
      }
    };
    an.forEach(["delete", "get", "head", "options"], function(e) {
      nT.prototype[e] = function(n, i) {
        return this.request(yf(i || {}, { method: e, url: n, data: (i || {}).data }));
      };
    }), an.forEach(["post", "put", "patch"], function(e) {
      function n(i) {
        return function(o, f, T) {
          return this.request(yf(T || {}, { method: e, headers: i ? { "Content-Type": "multipart/form-data" } : {}, url: o, data: f }));
        };
      }
      nT.prototype[e] = n(), nT.prototype[e + "Form"] = n(!0);
    });
    var rT = nT;
    class SS {
      constructor(n) {
        if (typeof n != "function") throw new TypeError("executor must be a function.");
        let i;
        this.promise = new cn(function(f) {
          i = f;
        });
        const o = this;
        this.promise.then((f) => {
          if (!o._listeners) return;
          let T = o._listeners.length;
          for (; T-- > 0; ) o._listeners[T](f);
          o._listeners = null;
        }), this.promise.then = (f) => {
          let T;
          const A = new cn((R) => {
            o.subscribe(R), T = R;
          }).then(f);
          return A.cancel = function() {
            o.unsubscribe(T);
          }, A;
        }, n(function(f, T, A) {
          o.reason || (o.reason = new $h(f, T, A), i(o.reason));
        });
      }
      throwIfRequested() {
        if (this.reason) throw this.reason;
      }
      subscribe(n) {
        this.reason ? n(this.reason) : this._listeners ? this._listeners.push(n) : this._listeners = [n];
      }
      unsubscribe(n) {
        if (!this._listeners) return;
        const i = this._listeners.indexOf(n);
        i !== -1 && this._listeners.splice(i, 1);
      }
      toAbortSignal() {
        const n = new AbortController(), i = (o) => {
          n.abort(o);
        };
        return this.subscribe(i), n.signal.unsubscribe = () => this.unsubscribe(i), n.signal;
      }
      static source() {
        let n;
        return { token: new SS(function(o) {
          n = o;
        }), cancel: n };
      }
    }
    var Uie = SS;
    const IS = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
    Object.entries(IS).forEach((e) => {
      let [n, i] = e;
      IS[i] = n;
    });
    var Hie = IS;
    const Us = function e(n) {
      const i = new rT(n), o = Ox(rT.prototype.request, i);
      return an.extend(o, rT.prototype, i, { allOwnKeys: !0 }), an.extend(o, i, null, { allOwnKeys: !0 }), o.create = function(f) {
        return e(yf(n, f));
      }, o;
    }(hS);
    Us.Axios = rT, Us.CanceledError = $h, Us.CancelToken = Uie, Us.isCancel = yM, Us.VERSION = jM, Us.toFormData = U1, Us.AxiosError = Pr, Us.Cancel = Us.CanceledError, Us.all = function(e) {
      return cn.all(e);
    }, Us.spread = function(e) {
      return function(n) {
        return e.apply(null, n);
      };
    }, Us.isAxiosError = function(e) {
      return an.isObject(e) && e.isAxiosError === !0;
    }, Us.mergeConfig = yf, Us.AxiosHeaders = Lc, Us.formToJSON = (e) => mM(an.isHTMLForm(e) ? new FormData(e) : e), Us.getAdapter = LM.getAdapter, Us.HttpStatusCode = Hie, Us.default = Us;
    var fa = Us;
    const Bie = () => {
    };
    function CE() {
      const e = { promise: void 0, isResolved: !1, isRejected: !1, isFinished: !1, resolve: void 0, reject: void 0, cancel: Bie };
      return e.promise = new cn((n, i) => {
        e.resolve = (o) => {
          e.isFinished || (e.isResolved = !0, e.isFinished = !0, n(o), e.value = o);
        }, e.reject = (o) => {
          e.isFinished || (e.isRejected = !0, e.isFinished = !0, i(o));
        };
      }), e;
    }
    const iT = /* @__PURE__ */ new Map(), sT = /* @__PURE__ */ new Map(), gu = /* @__PURE__ */ new Map();
    let ts = function(e) {
      return e.WIN_10 = "Windows 10", e.WIN_81 = "Windows 8.1", e.WIN_8 = "Windows 8", e.WIN_7 = "Windows 7", e.WIN_VISTA = "Windows Vista", e.WIN_SERVER_2003 = "Windows Server 2003", e.WIN_XP = "Windows XP", e.WIN_2000 = "Windows 2000", e.ANDROID = "Android", e.HARMONY_OS = "HarmonyOS", e.OPEN_BSD = "Open BSD", e.SUN_OS = "Sun OS", e.LINUX = "Linux", e.IOS = "iOS", e.MAC_OS = "Mac OS", e.CHROMIUM_OS = "Chromium OS", e.QNX = "QNX", e.UNIX = "UNIX", e.BEOS = "BeOS", e.OS_2 = "OS/2", e.SEARCH_BOT = "Search Bot", e;
    }({}), Cr = function(e) {
      return e.CHROME = "Chrome", e.SAFARI = "Safari", e.EDGE = "Edge", e.FIREFOX = "Firefox", e.OPERA = "OPR", e.QQ = "QQBrowser", e.WECHAT = "MicroMessenger", e;
    }({});
    const HM = new ite();
    let kc = HM.getResult(), RS = null;
    function hr(e) {
      if (!RS) {
        kc = HM.getResult();
        const n = function(R) {
          if (R.engine.name === "Blink" && R.browser.name !== "WeChat") return Cr.CHROME;
          switch (R.browser.name) {
            case "Chrome Headless":
            case "Chrome":
            case "Chromium":
              return Cr.CHROME;
            case "Safari":
            case "Mobile Safari":
              return Cr.SAFARI;
            case "Edge":
              return Cr.EDGE;
            case "Firefox":
              return Cr.FIREFOX;
            case "QQ":
            case "QQBrowser":
              return Cr.QQ;
            case "Opera":
              return Cr.OPERA;
            case "WeChat":
              return Cr.WECHAT;
            default:
              return R.browser.name || "";
          }
        }(kc), i = BM(kc), o = function(R) {
          return R.os.name === "Windows" ? R.os.version ? R.os.name + " " + R.os.version : R.os.name : R.os.name || "";
        }(kc), f = kc.os.version, T = BM(kc, !1), A = kc.device.type;
        if (!(n && i && o && f)) return { name: n, version: i, os: o, osVersion: f, browserVersion: T, deviceType: A };
        RS = { name: n, version: i, os: o, osVersion: f, browserVersion: T, deviceType: A };
      }
      return RS;
    }
    function BM(e) {
      let n, i = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      return n = e.engine.name === "Blink" ? e.engine.version || "" : e.browser.version || "", i ? n.split(".")[0] : n;
    }
    function aT() {
      return hr().os;
    }
    function zM() {
      const e = hr();
      return "".concat(e.os, " ").concat(e.osVersion);
    }
    function oT() {
      const e = hr();
      return !!(kc.engine.name === "WebKit" && e.os === ts.MAC_OS && navigator.maxTouchPoints && navigator.maxTouchPoints > 0 && e.name !== Cr.SAFARI || ta() && e.name !== Cr.SAFARI);
    }
    function $d() {
      return hr().name === Cr.CHROME;
    }
    function Os() {
      return hr().name === Cr.SAFARI;
    }
    function FM() {
      return hr().name === Cr.EDGE;
    }
    function ui() {
      return hr().name === Cr.FIREFOX;
    }
    function ta() {
      return hr().os === ts.IOS;
    }
    function cT(e) {
      const n = hr();
      return !(n.name !== Cr.CHROME || !n.osVersion) && Number(n.version) >= e;
    }
    function GM(e) {
      const n = hr();
      return !(n.name !== Cr.CHROME || !n.osVersion) && Number(n.version) < e;
    }
    function NS(e) {
      const n = hr();
      return !(n.name !== Cr.EDGE || !n.osVersion) && Number(n.version) >= e;
    }
    function VM(e) {
      const n = hr();
      return !(n.name !== Cr.SAFARI || !n.osVersion) && Number(n.version) >= e;
    }
    function YM(e, n, i) {
      const o = hr();
      if (o.os !== ts.IOS || !o.osVersion) return !1;
      const f = o.osVersion.split(".");
      return i ? n && Number(f[0]) === e && Number(f[1]) < n || Number(f[0]) < e : n ? Number(f[0]) === e && Number(f[1]) <= n || Number(f[0]) < e : Number(f[0]) <= e;
    }
    function XM(e, n, i) {
      const o = hr();
      if (o.name !== Cr.SAFARI || !o.osVersion || !o.browserVersion) return !1;
      const f = o.browserVersion.split(".");
      return i ? n && Number(f[0]) === e && Number(f[1]) < n || Number(f[0]) < e : n ? Number(f[0]) === e && Number(f[1]) <= n || Number(f[0]) < e : Number(f[0]) <= e;
    }
    function wS(e) {
      const n = hr();
      return !(n.name !== Cr.OPERA || !n.osVersion) && Number(n.version) >= e;
    }
    function WM() {
      const e = hr();
      if (e.os !== ts.IOS || !e.osVersion) return !1;
      const n = e.osVersion.split(".");
      return Number(n[0]) < 14 || Number(n[0]) === 14 && Number(n[1]) <= 6;
    }
    function ep() {
      const e = hr();
      if (e.os !== ts.IOS || !e.osVersion) return !1;
      const n = e.osVersion.split(".");
      return Number(n[0]) === 15;
    }
    function _S() {
      const e = hr();
      if (e.os !== ts.IOS || !e.osVersion) return !1;
      const n = e.osVersion.split(".");
      return Number(n[0]) === 16;
    }
    function qM() {
      const e = hr();
      if (e.os !== ts.IOS || !e.osVersion) return !1;
      const n = e.osVersion.split(".");
      return Number(n[0]) === 15 && Number(n[1]) >= 1;
    }
    function rc() {
      return Os() && navigator.maxTouchPoints > 0;
    }
    function KM() {
      return hr().name === Cr.WECHAT;
    }
    function JM() {
      return window.navigator.appVersion && window.navigator.appVersion.match(/Chrome\/([\w\W]*?)\./) !== null && window.navigator.appVersion.match(/Chrome\/([\w\W]*?)\./)[1] <= 35;
    }
    function PS() {
      const e = aT();
      return function() {
        const { deviceType: n } = hr();
        return n === "mobile" || n === "tablet";
      }() || e === ts.ANDROID || e === ts.IOS || e === ts.HARMONY_OS;
    }
    function ad() {
      const e = hr();
      return e.name !== Cr.EDGE && e.name !== Cr.SAFARI && !!navigator.userAgent.toLocaleLowerCase().match(/chrome\/[\d]./i);
    }
    function uT() {
      return aT() === ts.ANDROID;
    }
    function SE() {
      const e = hr();
      return uT() && (e.name === Cr.CHROME || e.name === Cr.WECHAT || /chrome|chromium/i.test(navigator.userAgent));
    }
    function Un(e, n, i) {
      return (n = function(o) {
        var f = function(T, A) {
          if (typeof T != "object" || !T) return T;
          var R = T[Symbol.toPrimitive];
          if (R !== void 0) {
            var P = R.call(T, "string");
            if (typeof P != "object") return P;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(T);
        }(o);
        return typeof f == "symbol" ? f : f + "";
      }(n)) in e ? Object.defineProperty(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
    }
    function ZM(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function yn(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? ZM(Object(i), !0).forEach(function(o) {
          Un(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ZM(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    let Je = function(e) {
      return e.UNEXPECTED_ERROR = "UNEXPECTED_ERROR", e.UNEXPECTED_RESPONSE = "UNEXPECTED_RESPONSE", e.TIMEOUT = "TIMEOUT", e.INVALID_PARAMS = "INVALID_PARAMS", e.NOT_READABLE = "NOT_READABLE", e.NOT_SUPPORTED = "NOT_SUPPORTED", e.INVALID_OPERATION = "INVALID_OPERATION", e.OPERATION_ABORTED = "OPERATION_ABORTED", e.WEB_SECURITY_RESTRICT = "WEB_SECURITY_RESTRICT", e.EXCHANGE_SDP_FAILED = "EXCHANGE_SDP_FAILED", e.ADD_CANDIDATE_FAILED = "ADD_CANDIDATE_FAILED", e.DATACHANNEL_FAILED = "DATACHANNEL_FAILED", e.NETWORK_ERROR = "NETWORK_ERROR", e.NETWORK_TIMEOUT = "NETWORK_TIMEOUT", e.NETWORK_RESPONSE_ERROR = "NETWORK_RESPONSE_ERROR", e.API_INVOKE_TIMEOUT = "API_INVOKE_TIMEOUT", e.ENUMERATE_DEVICES_FAILED = "ENUMERATE_DEVICES_FAILED", e.DEVICE_NOT_FOUND = "DEVICE_NOT_FOUND", e.ELECTRON_IS_NULL = "ELECTRON_IS_NULL", e.ELECTRON_DESKTOP_CAPTURER_GET_SOURCES_ERROR = "ELECTRON_DESKTOP_CAPTURER_GET_SOURCES_ERROR", e.CHROME_PLUGIN_NO_RESPONSE = "CHROME_PLUGIN_NO_RESPONSE", e.CHROME_PLUGIN_NOT_INSTALL = "CHROME_PLUGIN_NOT_INSTALL", e.MEDIA_OPTION_INVALID = "MEDIA_OPTION_INVALID", e.PERMISSION_DENIED = "PERMISSION_DENIED", e.CONSTRAINT_NOT_SATISFIED = "CONSTRAINT_NOT_SATISFIED", e.TRACK_IS_DISABLED = "TRACK_IS_DISABLED", e.GET_VIDEO_ELEMENT_VISIBLE_ERROR = "GET_VIDEO_ELEMENT_VISIBLE_ERROR", e.SHARE_AUDIO_NOT_ALLOWED = "SHARE_AUDIO_NOT_ALLOWED", e.LOW_STREAM_ENCODING_ERROR = "LOW_STREAM_ENCODING_ERROR", e.SET_ENCODING_PARAMETER_ERROR = "SET_ENCODING_PARAMETER_ERROR", e.TRACK_STATE_UNREACHABLE = "TRACK_STATE_UNREACHABLE", e.INVALID_UINT_UID_FROM_STRING_UID = "INVALID_UINT_UID_FROM_STRING_UID", e.CAN_NOT_GET_PROXY_SERVER = "CAN_NOT_GET_PROXY_SERVER", e.CAN_NOT_GET_GATEWAY_SERVER = "CAN_NOT_GET_GATEWAY_SERVER", e.VOID_GATEWAY_ADDRESS = "VOID_GATEWAY_ADDRESS", e.UID_CONFLICT = "UID_CONFLICT", e.MULTI_UNILBS_RESPONSE_ERROR = "MULTI_UNILBS_RESPONSE_ERROR", e.UPDATE_TICKET_FAILED = "UPDATE_TICKET_FAILED", e.TOKEN_EXPIRE = "TOKEN_EXPIRE", e.INVALID_LOCAL_TRACK = "INVALID_LOCAL_TRACK", e.INVALID_TRACK = "INVALID_TRACK", e.SENDER_NOT_FOUND = "SENDER_NOT_FOUND", e.CREATE_OFFER_FAILED = "CREATE_OFFER_FAILED", e.SET_ANSWER_FAILED = "SET_ANSWER_FAILED", e.ICE_FAILED = "ICE_FAILED", e.PC_CLOSED = "PC_CLOSED", e.SENDER_REPLACE_FAILED = "SENDER_REPLACE_FAILED", e.GET_LOCAL_CAPABILITIES_FAILED = "GET_LOCAL_CAPABILITIES_FAILED", e.GET_LOCAL_CONNECTION_PARAMS_FAILED = "GET_LOCAL_CONNECTION_PARAMS_FAILED", e.SUBSCRIBE_FAILED = "SUBSCRIBE_FAILED", e.UNSUBSCRIBE_FAILED = "UNSUBSCRIBE_FAILED", e.GATEWAY_P2P_LOST = "GATEWAY_P2P_LOST", e.NO_ICE_CANDIDATE = "NO_ICE_CANDIDATE", e.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS = "CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS", e.EXIST_DISABLED_VIDEO_TRACK = "EXIST_DISABLED_VIDEO_TRACK", e.INVALID_REMOTE_USER = "INVALID_REMOTE_USER", e.REMOTE_USER_IS_NOT_PUBLISHED = "REMOTE_USER_IS_NOT_PUBLISHED", e.CUSTOM_REPORT_SEND_FAILED = "CUSTOM_REPORT_SEND_FAILED", e.CUSTOM_REPORT_FREQUENCY_TOO_HIGH = "CUSTOM_REPORT_FREQUENCY_TOO_HIGH", e.FETCH_AUDIO_FILE_FAILED = "FETCH_AUDIO_FILE_FAILED", e.READ_LOCAL_AUDIO_FILE_ERROR = "READ_LOCAL_AUDIO_FILE_ERROR", e.DECODE_AUDIO_FILE_FAILED = "DECODE_AUDIO_FILE_FAILED", e.WS_ABORT = "WS_ABORT", e.WS_DISCONNECT = "WS_DISCONNECT", e.WS_ERR = "WS_ERR", e.EXTERNAL_SIGNAL_ABORT = "EXTERNAL_SIGNAL_ABORT", e.LIVE_STREAMING_TASK_CONFLICT = "LIVE_STREAMING_TASK_CONFLICT", e.LIVE_STREAMING_INVALID_ARGUMENT = "LIVE_STREAMING_INVALID_ARGUMENT", e.LIVE_STREAMING_INTERNAL_SERVER_ERROR = "LIVE_STREAMING_INTERNAL_SERVER_ERROR", e.LIVE_STREAMING_PUBLISH_STREAM_NOT_AUTHORIZED = "LIVE_STREAMING_PUBLISH_STREAM_NOT_AUTHORIZED", e.LIVE_STREAMING_TRANSCODING_NOT_SUPPORTED = "LIVE_STREAMING_TRANSCODING_NOT_SUPPORTED", e.LIVE_STREAMING_CDN_ERROR = "LIVE_STREAMING_CDN_ERROR", e.LIVE_STREAMING_INVALID_RAW_STREAM = "LIVE_STREAMING_INVALID_RAW_STREAM", e.LIVE_STREAMING_WARN_STREAM_NUM_REACH_LIMIT = "LIVE_STREAMING_WARN_STREAM_NUM_REACH_LIMIT", e.LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE = "LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE", e.LIVE_STREAMING_WARN_FREQUENT_REQUEST = "LIVE_STREAMING_WARN_FREQUENT_REQUEST", e.WEBGL_INTERNAL_ERROR = "WEBGL_INTERNAL_ERROR", e.BEAUTY_PROCESSOR_INTERNAL_ERROR = "BEAUTY_PROCESSOR_INTERNAL_ERROR", e.CROSS_CHANNEL_WAIT_STATUS_ERROR = "CROSS_CHANNEL_WAIT_STATUS_ERROR", e.CROSS_CHANNEL_FAILED_JOIN_SRC = "CROSS_CHANNEL_FAILED_JOIN_SEC", e.CROSS_CHANNEL_FAILED_JOIN_DEST = "CROSS_CHANNEL_FAILED_JOIN_DEST", e.CROSS_CHANNEL_FAILED_PACKET_SENT_TO_DEST = "CROSS_CHANNEL_FAILED_PACKET_SENT_TO_DEST", e.CROSS_CHANNEL_SERVER_ERROR_RESPONSE = "CROSS_CHANNEL_SERVER_ERROR_RESPONSE", e.METADATA_OUT_OF_RANGE = "METADATA_OUT_OF_RANGE", e.LOCAL_AEC_ERROR = "LOCAL_AEC_ERROR", e.INVALID_PLUGIN = "INVALID_PLUGIN", e.DISCONNECT_P2P = "DISCONNECT_P2P", e.CONVERTING_IMAGEDATA_TO_BLOB_FAILED = "CONVERTING_IMAGEDATA_TO_BLOB_FAILED", e.CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED = "CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED", e.INIT_DATACHANNEL_TIMEOUT = "INIT_DATACHANNEL_TIMEOUT", e.CREATE_DATACHANNEL_ERROR = "CREATE_DATACHANNEL_ERROR", e.DATACHANNEL_CONNECTION_TIMEOUT = "DATACHANNEL_CONNECTION_TIMEOUT", e.PROHIBITED_OPERATION = "PROHIBITED_OPERATION", e.IMAGE_MODERATION_UPLOAD_FAILED = "IMAGE_MODERATION_UPLOAD_FAILED", e.P2P_MESSAGE_FAILED = "P2P_MESSAGE_FAILED", e;
    }({});
    class Gt extends Error {
      constructor(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", o = arguments.length > 2 ? arguments[2] : void 0;
        super(i), Un(this, "code", void 0), Un(this, "message", void 0), Un(this, "data", void 0), Un(this, "name", "AgoraRTCException"), this.code = n, this.message = "AgoraRTCError ".concat(this.code, ": ").concat(i), this.data = o;
      }
      toString() {
        return this.data ? "".concat(this.message, `
data: `).concat(JSON.stringify(this.data)) : this.message;
      }
      print() {
        let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "error", i = arguments.length > 1 ? arguments[1] : void 0;
        return n === "error" && (i || console).error(this.toString()), n === "warning" && (i || console).warn(this.toString()), this;
      }
      throw(n) {
        throw this.print("error", n), this;
      }
    }
    function od(e, n) {
      if (typeof e != "boolean") throw new Gt(Je.INVALID_PARAMS, "Invalid ".concat(n, ": The value is of the boolean type."));
    }
    function $i(e, n, i) {
      if (!on(i).call(i, e)) throw new Gt(Je.INVALID_PARAMS, "".concat(n, " can only be set as ").concat(JSON.stringify(i)));
    }
    function xr(e, n) {
      let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1e4;
      if (e < i || e > o || (!(arguments.length > 4 && arguments[4] !== void 0) || arguments[4]) && !function(f) {
        return typeof f == "number" && f % 1 == 0;
      }(e)) throw new Gt(Je.INVALID_PARAMS, "invalid ".concat(n, ": the value range is [").concat(i, ", ").concat(o, "]. integer only"));
    }
    function xS(e, n) {
      if (typeof e != "number") {
        if (!(e.min || e.max || e.ideal || e.exact)) throw new Gt(Je.INVALID_PARAMS, "".concat(n, " is not a valid ConstrainLong"));
        e.min !== void 0 && xr(e.min, "".concat(n, ".min"), 0, 1 / 0), e.max !== void 0 && xr(e.max, "".concat(n, ".max"), 1, 1 / 0), e.exact !== void 0 && xr(e.exact, "".concat(n, ".exact"), 1, 1 / 0), e.ideal !== void 0 && xr(e.ideal, "".concat(n, ".ideal"), 1, 1 / 0);
      } else xr(e, n, 1, 1 / 0);
    }
    function ms(e, n) {
      let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 255, f = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4];
      if (e == null) throw new Gt(Je.INVALID_PARAMS, "".concat(n || "param", " cannot be empty"));
      if (!QM(e, i, o, f)) throw new Gt(Je.INVALID_PARAMS, "Invalid ".concat(n || "string param", ": Length of the string: [").concat(i, ",").concat(o, "].").concat(f ? " ASCII characters only." : ""));
    }
    function cd(e, n) {
      if (!Array.isArray(e)) throw new Gt(Je.INVALID_PARAMS, "".concat(n, " should be an array"));
    }
    function ri(e) {
      return e == null;
    }
    function QM(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 255, o = !(arguments.length > 3 && arguments[3] !== void 0) || arguments[3];
      return typeof e == "string" && e.length <= i && e.length >= n && (!o || function(f) {
        if (typeof f != "string") return !1;
        for (let T = 0; T < f.length; T += 1) {
          const A = f.charCodeAt(T);
          if (A < 0 || A > 255) return !1;
        }
        return !0;
      }(e));
    }
    var IE = function(e) {
      return e.COVERED = "COVERED", e.POSITION = "POSITION", e.SIZE = "SIZE", e.STYLE = "STYLE", e;
    }(IE || {}), DS = function(e) {
      return e.UNMOUNTED = "UNMOUNTED", e.INVALID_HTML_ELEMENT = "INVALID_HTML_ELEMENT", e;
    }(DS || {});
    const $M = new class {
      constructor() {
        Un(this, "_clientSize", null), Un(this, "getClientWidth", () => document.documentElement ? document.documentElement.clientWidth : document.body.clientWidth), Un(this, "getClientHeight", () => document.documentElement ? document.documentElement.clientHeight : document.body.clientHeight), Un(this, "getStyle", (e) => window.getComputedStyle(e, null)), Un(this, "checkCssVisibleProperty", (e) => {
          var n;
          let i = !0;
          const o = this.getStyle(e), { display: f, visibility: T, opacity: A, filter: R } = o;
          return (f === "none" || on(n = ["hidden", "collapse"]).call(n, T) || Number(A) < 0.1) && (i = !1), !!i && (R && R.split(" ").filter((P) => {
            var L;
            const z = P.split("(")[0];
            return on(L = ["brightness", "blur", "opacity"]).call(L, z);
          }).map((P) => {
            const [L, z] = P.split(/\(|\)/);
            return [L, Number(z.match(/^[0-9\.]+/))];
          }).forEach((P) => {
            const [L, z] = P;
            switch (L) {
              case "brightness":
                (z < 0.1 || z > 3) && (i = !1);
                break;
              case "blur":
                z > 3 && (i = !1);
                break;
              case "opacity":
                z < 0.1 && (i = !1);
            }
          }), i);
        }), Un(this, "checkPropertyUpToAllParentNodes", (e, n) => {
          let i = !0, o = !0;
          const f = (A) => n(A);
          let T = e;
          for (; T && o; ) f(T) || (i = !1, o = !1), T = T.parentElement, T || (o = !1);
          return i;
        }), Un(this, "checkActualCssVisibleIncludeInherit", (e) => this.checkPropertyUpToAllParentNodes(e, this.checkCssVisibleProperty)), Un(this, "getSizeAboutClient", (e) => {
          const { width: n, height: i, left: o, right: f, top: T, bottom: A } = e.getBoundingClientRect(), R = this.getClientWidth(), P = this.getClientHeight();
          return { width: n, height: i, left: o, right: f, top: T, bottom: A, clientWidth: R, clientHeight: P, clientMin: Math.min(R, P) };
        }), Un(this, "checkActualSize", () => {
          const { width: e, height: n, clientMin: i } = this._clientSize;
          return this.checkSizeIsVisible(e, n, i);
        }), Un(this, "elementFromPoint", (e, n) => document.elementFromPoint ? document.elementFromPoint(e, n) : null), Un(this, "checkCoverForAPoint", (e, n, i) => {
          const o = this.elementFromPoint(e, n);
          return o !== null && o !== i;
        }), Un(this, "getPointPositionList", () => {
          const { width: e, height: n, left: i, top: o } = this._clientSize, f = e / 6, T = n / 6, A = [], R = 10 ** 6;
          for (let P = 0; P < 5; P++) for (let L = 0; L < 5; L++) {
            const z = (i * R + (P === 0 ? 0.1 : P === 4 ? (f * P * R - 1e5) / R : f * P) * R) / R, Y = (o * R + (L === 0 ? 0.1 : L === 4 ? (T * L * R - 1e5) / R : T * L) * R) / R;
            A.push({ x: z, y: Y });
          }
          return [...A];
        }), Un(this, "checkElementCover", (e) => this.getPointPositionList().map((n) => this.checkCoverForAPoint(n.x, n.y, e)).filter((n) => !!n).length > 6), Un(this, "checkSizeIsVisible", (e, n, i) => (e > 50 || i / e <= 10) && (n > 50 || i / n <= 10)), Un(this, "checkSizeOfPartInClient", () => {
          const { left: e, right: n, top: i, bottom: o, clientHeight: f, clientWidth: T, clientMin: A } = this._clientSize;
          let R, P, L, z;
          if (e < 0) R = 0;
          else {
            if (!(e < T)) return !1;
            R = e;
          }
          if (n < 0) return !1;
          if (P = n < T ? n : T, i < 0) L = 0;
          else {
            if (!(i < f)) return !1;
            L = i;
          }
          if (o < 0) return !1;
          z = o < f ? o : f;
          const Y = P - R, te = z - L;
          return this.checkSizeIsVisible(Y, te, A);
        }), Un(this, "returnHiddenResult", (e) => (this._clientSize = null, { visible: !1, reason: e })), Un(this, "checkOneElementVisible", (e) => {
          if (e instanceof HTMLElement) {
            if (this.checkElementIsMountedOnDom(e)) {
              if (this.checkActualCssVisibleIncludeInherit(e)) {
                if (this._clientSize = this.getSizeAboutClient(e), this.checkElementCover(e)) return this.returnHiddenResult(IE.COVERED);
                {
                  const n = this.checkActualSize(), i = this.checkSizeOfPartInClient();
                  return n && !i ? this.returnHiddenResult(IE.POSITION) : n ? (this._clientSize = null, { visible: !0 }) : this.returnHiddenResult(IE.SIZE);
                }
              }
              return this.returnHiddenResult(IE.STYLE);
            }
            return this.returnHiddenResult(DS.UNMOUNTED);
          }
          return this.returnHiddenResult(DS.INVALID_HTML_ELEMENT);
        }), Un(this, "checkElementIsMountedOnDom", (e) => this.checkPropertyUpToAllParentNodes(e, (n) => n.nodeName.toUpperCase() !== "HTML" ? n.parentElement !== null : !!document.documentElement));
      }
    }();
    function MS(e) {
      return new TextEncoder().encode(e);
    }
    const e5 = function(e, n) {
      const i = new Uint8Array(e.byteLength + n.byteLength);
      return i.set(new Uint8Array(e), 0), i.set(new Uint8Array(n), e.byteLength), i;
    }, LS = async (e) => function(n, i) {
      let o = "";
      return new Uint8Array(n).forEach((f) => {
        o += f.toString(i).padStart(2, "0");
      }), o;
    }(await crypto.subtle.digest("SHA-256", MS(e)), 16);
    let ii = class {
      constructor() {
        Un(this, "_events", {}), Un(this, "addListener", this.on);
      }
      getListeners(e) {
        return this._events[e] ? this._events[e].map((n) => n.listener) : [];
      }
      on(e, n) {
        this._events[e] || (this._events[e] = []);
        const i = this._events[e];
        this._indexOfListener(i, n) === -1 && i.push({ listener: n, once: !1 });
      }
      once(e, n) {
        this._events[e] || (this._events[e] = []);
        const i = this._events[e];
        this._indexOfListener(i, n) === -1 && i.push({ listener: n, once: !0 });
      }
      off(e, n) {
        if (!this._events[e]) return;
        const i = this._events[e], o = this._indexOfListener(i, n);
        o !== -1 && i.splice(o, 1), this._events[e].length === 0 && delete this._events[e];
      }
      removeAllListeners(e) {
        e ? delete this._events[e] : this._events = {};
      }
      emit(e) {
        this._events[e] || (this._events[e] = []);
        const n = this._events[e].map((T) => T);
        for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), f = 1; f < i; f++) o[f - 1] = arguments[f];
        for (let T = 0; T < n.length; T += 1) {
          const A = n[T];
          A.once && this.off(e, A.listener), A.listener.apply(this, o || []);
        }
      }
      safeEmit(e) {
        for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) i[o - 1] = arguments[o];
        [...this._events[e] || []].forEach((f) => {
          f.once && this.off(e, f.listener);
          try {
            f.listener.apply(this, i);
          } catch (T) {
            console.error("safeEmit event:".concat(e, " error ").concat(T == null ? void 0 : T.toString()));
          }
        });
      }
      _indexOfListener(e, n) {
        let i = e.length;
        for (; i--; ) if (e[i].listener === n) return i;
        return -1;
      }
    }, RE = null;
    function t5() {
      if (RE) return RE;
      if (window.electron) return RE = window.electron;
      if (!window.require) return null;
      try {
        return RE = window.require("electron"), RE;
      } catch {
        return null;
      }
    }
    let Bi = function(e) {
      return e.CREATE_CLIENT = "createClient", e.CHECK_SYSTEM_REQUIREMENTS = "checkSystemRequirements", e.SET_AREA = "setArea", e.PRELOAD = "PRELOAD", e.CHECK_VIDEO_TRACK_IS_ACTIVE = "checkVideoTrackIsActive", e.CHECK_AUDIO_TRACK_IS_ACTIVE = "checkAudioTrackIsActive", e.CREATE_MIC_AUDIO_TRACK = "createMicrophoneAudioTrack", e.CREATE_CUSTOM_AUDIO_TRACK = "createCustomAudioTrack", e.CREATE_BUFFER_AUDIO_TRACK = "createBufferSourceAudioTrack", e.CREATE_CAM_VIDEO_TRACK = "createCameraVideoTrack", e.CREATE_CUSTOM_VIDEO_TRACK = "createCustomVideoTrack", e.CREATE_MIC_AND_CAM_TRACKS = "createMicrophoneAndCameraTracks", e.CREATE_SCREEN_VIDEO_TRACK = "createScreenVideoTrack", e.SET_ENCRYPTION_CONFIG = "Client.setEncryptionConfig", e.START_PROXY_SERVER = "Client.startProxyServer", e.STOP_PROXY_SERVER = "Client.stopProxyServer", e.SET_PROXY_SERVER = "Client.setProxyServer", e.SET_TURN_SERVER = "Client.setTurnServer", e.SET_CLIENT_ROLE = "Client.setClientRole", e.SET_LOW_STREAM_PARAMETER = "Client.setLowStreamParameter", e.ENABLE_DUAL_STREAM = "Client.enableDualStream", e.DISABLE_DUAL_STREAM = "Client.disableDualStream", e.JOIN = "Client.join", e.LEAVE = "Client.leave", e.PUBLISH = "Client.publish", e.UNPUBLISH = "Client.unpublish", e.SUBSCRIBE = "Client.subscribe", e.MASS_SUBSCRIBE = "Client.massSubscribe", e.MASS_UNSUBSCRIBE = "Client.massUnsubscribe", e.UNSUBSCRIBE = "Client.unsubscribe", e.RENEW_TOKEN = "Client.renewToken", e.SET_REMOTE_VIDEO_STREAM_TYPE = "Client.setRemoteVideoStreamType", e.SET_STREAM_FALLBACK_OPTION = "Client.setStreamFallbackOption", e.ENABLE_AUDIO_VOLUME_INDICATOR = "Client.enableAudioVolumeIndicator", e.SEND_CUSTOM_REPORT_MESSAGE = "Client.sendCustomReportMessage", e.INSPECT_VIDEO_CONTENT = "Client.inspectVideoContent", e.STOP_INSPECT_VIDEO_CONTENT = "Client.stopInspectVideoContent", e.JOIN_FALLBACK_TO_PROXY = "Client._joinFallbackToProxy", e.ON_LIVE_STREAM_WARNING = "Client.onLiveStreamWarning", e.ON_LIVE_STREAM_ERROR = "Client.onLiveStreamingError", e.START_LIVE_STREAMING = "Client.startLiveStreaming", e.SET_LIVE_TRANSCODING = "Client.setLiveTranscoding", e.STOP_LIVE_STREAMING = "Client.stopLiveStreaming", e.START_CHANNEL_MEDIA_RELAY = "Client.startChannelMediaRelay", e.UPDATE_CHANNEL_MEDIA_RELAY = "Client.updateChannelMediaRelay", e.STOP_CHANNEL_MEDIA_RELAY = "Client.stopChannelMediaRelay", e.REQUEST_CONFIG_DISTRIBUTE = "_config-distribute-request", e.SET_CONFIG_DISTRIBUTE = "_configDistribute", e.LOCAL_TRACK_SET_MUTED = "LocalTrack.setMute", e.LOCAL_AUDIO_TRACK_PLAY = "LocalAudioTrack.play", e.LOCAL_AUDIO_TRACK_PLAY_IN_ELEMENT = "LocalAudioTrack.playInElement", e.LOCAL_AUDIO_TRACK_STOP = "LocalAudioTrack.stop", e.LOCAL_AUDIO_TRACK_SET_VOLUME = "LocalAudioTrack.setVolume", e.MIC_AUDIO_TRACK_SET_DEVICE = "MicrophoneAudioTrack.setDevice", e.BUFFER_AUDIO_TRACK_START = "BufferSourceAudioTrack.startProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_STOP = "BufferSourceAudioTrack.stopProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_PAUSE = "BufferSourceAudioTrack.pauseProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_RESUME = "BufferSourceAudioTrack.resumeProcessAudioBuffer", e.BUFFER_AUDIO_TRACK_SEEK = "BufferSourceAudioTrack.seekAudioBuffer", e.LOCAL_VIDEO_TRACK_PLAY = "LocalVideoTrack.play", e.LOCAL_VIDEO_TRACK_STOP = "LocalVideoTrack.stop", e.LOCAL_VIDEO_TRACK_GET_VIDEO_VISIBLE = "LocalVideoTrack.getVideoElementVisibleStatus", e.LOCAL_VIDEO_TRACK_BEAUTY = "LocalVideoTrack.setBeautyEffect", e.LOCAL_VIDEO_SEND_SEI_DATA = "LocalVideoTrack.sendSeiData", e.CAM_VIDEO_TRACK_SET_DEVICE = "CameraVideoTrack.setDevice", e.CAM_VIDEO_TRACK_SET_ENCODER_CONFIG = "CameraVideoTrack.setEncoderConfiguration", e.REMOTE_VIDEO_TRACK_PLAY = "RemoteVideoTrack.play", e.REMOTE_VIDEO_TRACK_STOP = "RemoteVideoTrack.stop", e.REMOTE_VIDEO_TRACK_GET_VIDEO_VISIBLE = "RemoteVideoTrack.getVideoElementVisibleStatus", e.REMOTE_AUDIO_TRACK_PLAY = "RemoteAudioTrack.play", e.REMOTE_AUDIO_TRACK_STOP = "RemoteAudioTrack.stop", e.REMOTE_AUDIO_SET_VOLUME = "RemoteAudioTrack.setVolume", e.REMOTE_AUDIO_SET_OUTPUT_DEVICE = "RemoteAudioTrack.setOutputDevice", e.GET_MEDIA_STREAM_TRACK = "Track.getMediaStreamTrack", e.STREAM_TYPE_CHANGE = "streamTypeChange", e.CONNECTION_STATE_CHANGE = "connectionStateChange", e.LOAD_CONFIG_FROM_LOCALSTORAGE = "loadConfigFromLocalStorage", e.IMAGE_MODERATION_UPLOAD = "imageModerationUpload", e.REPUB_AFTER_PC_CONNECTED = "repubAfterPCConnected", e;
    }({}), si = function(e) {
      return e.TRACER = "tracer", e;
    }({});
    function n5(e) {
      return xr(e.timeout, "config.timeout", 0, 1e5), xr(e.timeoutFactor, "config.timeoutFactor", 0, 100, !1), xr(e.maxRetryCount, "config.maxRetryConfig", 0, 1 / 0), xr(e.maxRetryTimeout, "config.maxRetryTimeout", 0, 1 / 0), !0;
    }
    let zie = function(e) {
      return e[e.AUDIENCE_LEVEL_LOW_LATENCY = 1] = "AUDIENCE_LEVEL_LOW_LATENCY", e[e.AUDIENCE_LEVEL_ULTRA_LOW_LATENCY = 2] = "AUDIENCE_LEVEL_ULTRA_LOW_LATENCY", e[e.AUDIENCE_LEVEL_SYNC_LATENCY = 3] = "AUDIENCE_LEVEL_SYNC_LATENCY", e;
    }({}), br = function(e) {
      return e.LEAVE = "LEAVE", e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.UID_BANNED = "UID_BANNED", e.FALLBACK = "FALLBACK", e.IP_BANNED = "IP_BANNED", e.CHANNEL_BANNED = "CHANNEL_BANNED", e.LICENSE_MISSING = "LICENSE_MISSING", e.LICENSE_EXPIRED = "LICENSE_EXPIRED", e.LICENSE_MINUTES_EXCEEDED = "LICENSE_MINUTES_EXCEEDED", e.LICENSE_PERIOD_INVALID = "LICENSE_PERIOD_INVALID", e.LICENSE_MULTIPLE_SDK_SERVICE = "LICENSE_MULTIPLE_SDK_SERVICE", e.LICENSE_ILLEGAL = "LICENSE_ILLEGAL", e.TOKEN_EXPIRE = "TOKEN_EXPIRE", e;
    }({});
    function NE(e) {
      if (!Array.isArray(e) || e.length < 1) return !1;
      try {
        e.forEach((n) => {
          if (!n.urls) throw Error();
        });
      } catch {
        return !1;
      }
      return !0;
    }
    function r5(e) {
      return ms(e.turnServerURL, "turnServerURL"), ms(e.username, "username"), ms(e.password, "password"), e.udpport && xr(e.udpport, "udpport", 1, 99999, !0), e.forceturn && od(e.forceturn, "forceturn"), e.security && od(e.security, "security"), e.tcpport && xr(e.tcpport, "tcpport", 1, 99999, !0), !0;
    }
    function kS(e) {
      return e.level !== void 0 && $i(e.level, "level", [1, 2, 3]), e.delay !== void 0 && xr(e.delay, "delay", 0, 3e3, !0), !0;
    }
    let rr = function(e) {
      return e.PEERCONNECTION_STATE_CHANGE = "peerconnection-state-change", e.CONNECTION_STATE_CHANGE = "connection-state-change", e.MEDIA_RECONNECT_START = "media-reconnect-start", e.MEDIA_RECONNECT_END = "media-reconnect-end", e.IS_USING_CLOUD_PROXY = "is-using-cloud-proxy", e.USER_JOINED = "user-joined", e.USER_LEAVED = "user-left", e.USER_PUBLISHED = "user-published", e.USER_UNPUBLISHED = "user-unpublished", e.USER_INFO_UPDATED = "user-info-updated", e.CLIENT_BANNED = "client-banned", e.CHANNEL_MEDIA_RELAY_STATE = "channel-media-relay-state", e.CHANNEL_MEDIA_RELAY_EVENT = "channel-media-relay-event", e.VOLUME_INDICATOR = "volume-indicator", e.CRYPT_ERROR = "crypt-error", e.ON_TOKEN_PRIVILEGE_WILL_EXPIRE = "token-privilege-will-expire", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "token-privilege-did-expire", e.NETWORK_QUALITY = "network-quality", e.STREAM_TYPE_CHANGED = "stream-type-changed", e.STREAM_FALLBACK = "stream-fallback", e.RECEIVE_METADATA = "receive-metadata", e.STREAM_MESSAGE = "stream-message", e.LIVE_STREAMING_ERROR = "live-streaming-error", e.LIVE_STREAMING_WARNING = "live-streaming-warning", e.EXCEPTION = "exception", e.ERROR = "error", e.P2P_LOST = "p2p_lost", e.JOIN_FALLBACK_TO_PROXY = "join-fallback-to-proxy", e.CHANNEL_FALLBACK_TO_WEBSOCKET = "channel-fallback-to-websocket", e.MEDIA_CONNECTION_TYPE_CHANGE = "media-connection-type-change", e.PUBLISHED_USER_LIST = "published-user-list", e.CONTENT_INSPECT_CONNECTION_STATE_CHANGE = "content-inspect-connection-state-change", e.CONTENT_INSPECT_ERROR = "content-inspect-error", e.CONTENT_INSPECT_RESULT = "content-inspect-result", e.IMAGE_MODERATION_CONNECTION_STATE_CHANGE = "image-moderation-connection-state-change", e;
    }({}), Cs = function(e) {
      return e.NETWORK_ERROR = "NETWORK_ERROR", e.SERVER_ERROR = "SERVER_ERROR", e.MULTI_IP = "MULTI_IP", e.TIMEOUT = "TIMEOUT", e.OFFLINE = "OFFLINE", e.LEAVE = "LEAVE", e.P2P_FAILED = "P2P_FAILED", e.FALLBACK = "FALLBACK", e.REGIONAL_DISTRIBUTION = "REGIONAL_DISTRIBUTION", e;
    }({}), Fa = function(e) {
      return e.ONLINE = "ONLINE", e.OFFLINE = "OFFLINE", e;
    }({}), tp = function(e) {
      return e.NETWORK_STATE_CHANGE = "NETWORK_STATE_CHANGE", e.ONLINE = "ONLINE", e.OFFLINE = "OFFLINE", e;
    }({});
    function Ss(e, n) {
      for (var i = arguments.length, o = new Array(i > 2 ? i - 2 : 0), f = 2; f < i; f++) o[f - 2] = arguments[f];
      return e.getListeners(n).length === 0 ? cn.reject(new Gt(Je.UNEXPECTED_ERROR, "can not emit promise")) : new cn((T, A) => {
        e.emit(n, ...o, T, A);
      });
    }
    function Br(e, n) {
      if (e.getListeners(n).length === 0) return cn.resolve();
      for (var i = arguments.length, o = new Array(i > 2 ? i - 2 : 0), f = 2; f < i; f++) o[f - 2] = arguments[f];
      return Ss(e, n, ...o);
    }
    function to(e, n) {
      if (e.getListeners(n).length === 0) return null;
      for (var i = arguments.length, o = new Array(i > 2 ? i - 2 : 0), f = 2; f < i; f++) o[f - 2] = arguments[f];
      return wE(e, n, ...o);
    }
    function wE(e, n) {
      let i = null, o = null;
      for (var f = arguments.length, T = new Array(f > 2 ? f - 2 : 0), A = 2; A < f; A++) T[A - 2] = arguments[A];
      if (e.emit(n, ...T, (R) => {
        i = R;
      }, (R) => {
        o = R;
      }), o !== null) throw o;
      if (i === null) throw new Gt(Je.UNEXPECTED_ERROR, "handler is not sync");
      return i;
    }
    const Mi = new class extends ii {
      set networkState(e) {
        this.emit(tp.NETWORK_STATE_CHANGE, e, this._networkState), e === Fa.ONLINE ? this.emit(tp.ONLINE) : e === Fa.OFFLINE && (this.onlineWaiter = new cn((n) => {
          this.once(tp.ONLINE, () => {
            this.onlineWaiter = void 0, n(Fa.ONLINE);
          });
        }), this.emit(tp.OFFLINE)), this._networkState = e;
      }
      get networkState() {
        return this._networkState;
      }
      get isOnline() {
        return this._networkState === Fa.ONLINE;
      }
      constructor() {
        super(), Un(this, "_moduleName", "network-indicator"), Un(this, "_networkState", Fa.ONLINE), Un(this, "onlineWaiter", void 0), window.addEventListener("online", () => {
          this.networkState = Fa.ONLINE;
        }), window.addEventListener("offline", () => {
          this.networkState = Fa.OFFLINE;
        });
      }
    }();
    function dT(e, n) {
      const i = e.indexOf(n);
      i !== -1 && e.splice(i, 1);
    }
    function np(e) {
      const n = [];
      return e.forEach((i) => {
        n.indexOf(i) === -1 && n.push(i);
      }), n;
    }
    function lT(e) {
      cn !== void 0 ? cn.resolve().then(e) : setTimeout(e, 0);
    }
    function di(e) {
      return JSON.parse(JSON.stringify(e));
    }
    function vf(e) {
      try {
        return di(e);
      } catch {
        return e;
      }
    }
    const i5 = {};
    function el(e, n) {
      i5[n] || (i5[n] = !0, e());
    }
    function Tf(e) {
      const n = window.atob(e), i = new Uint8Array(new ArrayBuffer(n.length));
      for (let o = 0; o < n.length; o += 1) i[o] = n.charCodeAt(o);
      return i;
    }
    function tl(e) {
      let n = "";
      for (let i = 0; i < e.length; i += 1) n += String.fromCharCode(e[i]);
      return window.btoa(n);
    }
    function s5(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16, i = new TextEncoder().encode(e);
      if (i.length > n) i = i.slice(0, n);
      else if (i.length < n) {
        const o = new Uint8Array(n);
        o.set(i), i = o;
      }
      return i;
    }
    function a5() {
      for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
      const o = _c(n).call(n, (A, R) => A + R.length, 0), f = new Uint8Array(new ArrayBuffer(o));
      let T = 0;
      return n.forEach((A) => {
        f.set(A, T), T += A.length;
      }), f;
    }
    function mu(e) {
      return window.TextEncoder ? new TextEncoder().encode(e).length : e.length;
    }
    function o5(e) {
      let n = 0;
      return (/DingTalk/i.test(navigator.userAgent) || /AliApp/i.test(navigator.userAgent)) && e.realFormData && (e = e.realFormData), e.forEach((i) => {
        n += typeof i == "string" ? mu(i) : i.size;
      }), n + 138;
    }
    function Fie(e) {
      const n = new Gt(Je.TIMEOUT, "timeout");
      return new cn((i, o) => {
        window.setTimeout(() => o(n), e);
      });
    }
    function Es(e) {
      return new cn((n) => {
        window.setTimeout(n, e);
      });
    }
    function zr() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 7, n = arguments.length > 1 ? arguments[1] : void 0;
      const i = Math.random().toString(16).substr(2, e).toLowerCase();
      return i.length === e ? "".concat(n).concat(i) : "".concat(n).concat(i) + zr(e - i.length, "");
    }
    function rp() {
      return zr(32, "").toUpperCase();
    }
    const fT = () => {
    }, c5 = new class {
      constructor() {
        Un(this, "fnMap", /* @__PURE__ */ new Map());
      }
      throttleByKey(e, n, i, o) {
        for (var f = arguments.length, T = new Array(f > 4 ? f - 4 : 0), A = 4; A < f; A++) T[A - 4] = arguments[A];
        if (this.fnMap.has(n)) {
          const R = this.fnMap.get(n);
          if (R.threshold !== i) {
            R.fn(...R.args), clearTimeout(R.timer);
            const P = window.setTimeout(() => {
              const L = this.fnMap.get(n);
              L && L.fn(...L.args), this.fnMap.delete(n);
            }, i);
            this.fnMap.set(n, { fn: e, threshold: i, timer: P, args: T, skipFn: o });
          } else R.skipFn && R.skipFn(...R.args), this.fnMap.set(n, yn(yn({}, R), {}, { fn: e, args: T, skipFn: o }));
        } else {
          const R = window.setTimeout(() => {
            const P = this.fnMap.get(n);
            P && P.fn(...P.args), this.fnMap.delete(n);
          }, i);
          this.fnMap.set(n, { fn: e, threshold: i, timer: R, args: T, skipFn: o });
        }
      }
    }(), u5 = c5.throttleByKey.bind(c5);
    function d5(e) {
      return typeof e == "object" && e !== null && !(e instanceof RegExp);
    }
    function jS(e, n) {
      if (!d5(e) || !d5(n) || Array.isArray(e) && !Array.isArray(n) || !Array.isArray(e) && Array.isArray(n)) return n;
      if (Array.isArray(n) && Array.isArray(e)) {
        const i = [...e];
        for (let o = 0; o < n.length; o++) i[o] = jS(e[o], n[o]);
        return i;
      }
      {
        const i = yn({}, e);
        for (const o in n) Object.prototype.hasOwnProperty.call(n, o) && (Object.prototype.hasOwnProperty.call(e, o) ? i[o] = jS(e[o], n[o]) : i[o] = n[o]);
        return i;
      }
    }
    function l5(e, n) {
      let i = [0];
      if (i = new Array(n).fill(0), e === 0) return i;
      let o = 0;
      for (; e > 0 && (i[o] = 255 & e, e >>= 8, o++, o !== n); ) ;
      return i;
    }
    function US(e) {
      return typeof e == "number" ? e : e.exact || e.ideal || e.max || e.min || 0;
    }
    function f5(e) {
      const n = "0123456789abcdef";
      function i(mt) {
        let Pt, xt = "";
        for (Pt = 0; Pt <= 3; Pt++) xt += n.charAt(mt >> 8 * Pt + 4 & 15) + n.charAt(mt >> 8 * Pt & 15);
        return xt;
      }
      function o(mt, Pt) {
        const xt = (65535 & mt) + (65535 & Pt);
        return (mt >> 16) + (Pt >> 16) + (xt >> 16) << 16 | 65535 & xt;
      }
      function f(mt, Pt, xt, Nt, Vt, nn) {
        return o(function(fn, hn) {
          return fn << hn | fn >>> 32 - hn;
        }(o(o(Pt, mt), o(Nt, nn)), Vt), xt);
      }
      function T(mt, Pt, xt, Nt, Vt, nn, fn) {
        return f(Pt & xt | ~Pt & Nt, mt, Pt, Vt, nn, fn);
      }
      function A(mt, Pt, xt, Nt, Vt, nn, fn) {
        return f(Pt & Nt | xt & ~Nt, mt, Pt, Vt, nn, fn);
      }
      function R(mt, Pt, xt, Nt, Vt, nn, fn) {
        return f(Pt ^ xt ^ Nt, mt, Pt, Vt, nn, fn);
      }
      function P(mt, Pt, xt, Nt, Vt, nn, fn) {
        return f(xt ^ (Pt | ~Nt), mt, Pt, Vt, nn, fn);
      }
      const L = function(mt) {
        let Pt;
        const xt = 1 + (mt.length + 8 >> 6), Nt = new Array(16 * xt);
        for (Pt = 0; Pt < 16 * xt; Pt++) Nt[Pt] = 0;
        for (Pt = 0; Pt < mt.length; Pt++) Nt[Pt >> 2] |= mt.charCodeAt(Pt) << Pt % 4 * 8;
        return Nt[Pt >> 2] |= 128 << Pt % 4 * 8, Nt[16 * xt - 2] = 8 * mt.length, Nt;
      }(e);
      let z, Y, te, oe, He, Re = 1732584193, De = -271733879, Xe = -1732584194, We = 271733878;
      for (z = 0; z < L.length; z += 16) Y = Re, te = De, oe = Xe, He = We, Re = T(Re, De, Xe, We, L[z + 0], 7, -680876936), We = T(We, Re, De, Xe, L[z + 1], 12, -389564586), Xe = T(Xe, We, Re, De, L[z + 2], 17, 606105819), De = T(De, Xe, We, Re, L[z + 3], 22, -1044525330), Re = T(Re, De, Xe, We, L[z + 4], 7, -176418897), We = T(We, Re, De, Xe, L[z + 5], 12, 1200080426), Xe = T(Xe, We, Re, De, L[z + 6], 17, -1473231341), De = T(De, Xe, We, Re, L[z + 7], 22, -45705983), Re = T(Re, De, Xe, We, L[z + 8], 7, 1770035416), We = T(We, Re, De, Xe, L[z + 9], 12, -1958414417), Xe = T(Xe, We, Re, De, L[z + 10], 17, -42063), De = T(De, Xe, We, Re, L[z + 11], 22, -1990404162), Re = T(Re, De, Xe, We, L[z + 12], 7, 1804603682), We = T(We, Re, De, Xe, L[z + 13], 12, -40341101), Xe = T(Xe, We, Re, De, L[z + 14], 17, -1502002290), De = T(De, Xe, We, Re, L[z + 15], 22, 1236535329), Re = A(Re, De, Xe, We, L[z + 1], 5, -165796510), We = A(We, Re, De, Xe, L[z + 6], 9, -1069501632), Xe = A(Xe, We, Re, De, L[z + 11], 14, 643717713), De = A(De, Xe, We, Re, L[z + 0], 20, -373897302), Re = A(Re, De, Xe, We, L[z + 5], 5, -701558691), We = A(We, Re, De, Xe, L[z + 10], 9, 38016083), Xe = A(Xe, We, Re, De, L[z + 15], 14, -660478335), De = A(De, Xe, We, Re, L[z + 4], 20, -405537848), Re = A(Re, De, Xe, We, L[z + 9], 5, 568446438), We = A(We, Re, De, Xe, L[z + 14], 9, -1019803690), Xe = A(Xe, We, Re, De, L[z + 3], 14, -187363961), De = A(De, Xe, We, Re, L[z + 8], 20, 1163531501), Re = A(Re, De, Xe, We, L[z + 13], 5, -1444681467), We = A(We, Re, De, Xe, L[z + 2], 9, -51403784), Xe = A(Xe, We, Re, De, L[z + 7], 14, 1735328473), De = A(De, Xe, We, Re, L[z + 12], 20, -1926607734), Re = R(Re, De, Xe, We, L[z + 5], 4, -378558), We = R(We, Re, De, Xe, L[z + 8], 11, -2022574463), Xe = R(Xe, We, Re, De, L[z + 11], 16, 1839030562), De = R(De, Xe, We, Re, L[z + 14], 23, -35309556), Re = R(Re, De, Xe, We, L[z + 1], 4, -1530992060), We = R(We, Re, De, Xe, L[z + 4], 11, 1272893353), Xe = R(Xe, We, Re, De, L[z + 7], 16, -155497632), De = R(De, Xe, We, Re, L[z + 10], 23, -1094730640), Re = R(Re, De, Xe, We, L[z + 13], 4, 681279174), We = R(We, Re, De, Xe, L[z + 0], 11, -358537222), Xe = R(Xe, We, Re, De, L[z + 3], 16, -722521979), De = R(De, Xe, We, Re, L[z + 6], 23, 76029189), Re = R(Re, De, Xe, We, L[z + 9], 4, -640364487), We = R(We, Re, De, Xe, L[z + 12], 11, -421815835), Xe = R(Xe, We, Re, De, L[z + 15], 16, 530742520), De = R(De, Xe, We, Re, L[z + 2], 23, -995338651), Re = P(Re, De, Xe, We, L[z + 0], 6, -198630844), We = P(We, Re, De, Xe, L[z + 7], 10, 1126891415), Xe = P(Xe, We, Re, De, L[z + 14], 15, -1416354905), De = P(De, Xe, We, Re, L[z + 5], 21, -57434055), Re = P(Re, De, Xe, We, L[z + 12], 6, 1700485571), We = P(We, Re, De, Xe, L[z + 3], 10, -1894986606), Xe = P(Xe, We, Re, De, L[z + 10], 15, -1051523), De = P(De, Xe, We, Re, L[z + 1], 21, -2054922799), Re = P(Re, De, Xe, We, L[z + 8], 6, 1873313359), We = P(We, Re, De, Xe, L[z + 15], 10, -30611744), Xe = P(Xe, We, Re, De, L[z + 6], 15, -1560198380), De = P(De, Xe, We, Re, L[z + 13], 21, 1309151649), Re = P(Re, De, Xe, We, L[z + 4], 6, -145523070), We = P(We, Re, De, Xe, L[z + 11], 10, -1120210379), Xe = P(Xe, We, Re, De, L[z + 2], 15, 718787259), De = P(De, Xe, We, Re, L[z + 9], 21, -343485551), Re = o(Re, Y), De = o(De, te), Xe = o(Xe, oe), We = o(We, He);
      return i(Re) + i(De) + i(Xe) + i(We);
    }
    let Gie = 1, h5 = console, xs = class {
      static setLogger(e) {
        h5 = e;
      }
      constructor(e, n) {
        Un(this, "id", void 0), Un(this, "lockingPromise", cn.resolve()), Un(this, "locks", 0), Un(this, "name", ""), Un(this, "lockId", void 0), this.lockId = Gie++, e && (this.name = e), n && (this.id = n), this.logger("created");
      }
      logger(e, n) {
        const i = (this.id ? "[".concat(this.id, "]") : "") + "[lock-".concat(this.name, "-").concat(this.lockId, "]"), o = e === "created" ? "is ".concat(e, ".") : "is ".concat(e, ", current queue ").concat(this.locks, ". ").concat(n ?? "");
        h5.debug("".concat(i, " ").concat(o));
      }
      setId(e) {
        this.id = e;
      }
      get isLocked() {
        return this.locks > 0;
      }
      lock(e) {
        let n;
        this.locks += 1, this.logger("locked", e);
        const i = new cn((f) => {
          n = () => {
            this.locks -= 1, this.logger("unlocked", e), f();
          };
        }), o = this.lockingPromise.then(() => n);
        return this.lockingPromise = this.lockingPromise.then(() => i), o;
      }
    };
    function ip(e, n) {
      return function(i, o, f) {
        const T = f.value;
        if (typeof T != "function") throw new Error("Cannot use mutex on object property.");
        return f.value = async function() {
          const A = this[n];
          if (!A) throw new Error("mutex property key ".concat(n, " doesn't exist on ").concat(e));
          const R = await A.lock("From ".concat(e, ".").concat(o));
          try {
            for (var P = arguments.length, L = new Array(P), z = 0; z < P; z++) L[z] = arguments[z];
            return await T.apply(this, L);
          } finally {
            R();
          }
        }, f;
      };
    }
    const zi = { timeout: 500, timeoutFactor: 1.5, maxRetryCount: 1 / 0, maxRetryTimeout: 1e4 };
    function HS(e, n) {
      const i = Math.floor(n.timeout * Math.pow(n.timeoutFactor, e));
      return Math.min(n.maxRetryTimeout, i);
    }
    function jc(e, n, i, o) {
      const f = Object.assign({}, zi, o);
      let T = f.timeout;
      const A = async () => {
        await function(L) {
          return new cn((z) => {
            window.setTimeout(z, L);
          });
        }(T), T *= f.timeoutFactor, T = Math.min(f.maxRetryTimeout, T);
      };
      let R = !1;
      const P = new cn(async (L, z) => {
        n = n || (() => !1), i = i || (() => !0);
        for (let Y = 0; Y < f.maxRetryCount; Y += 1) {
          if (R) return z(new Gt(Je.OPERATION_ABORTED));
          try {
            const te = await e();
            if (!n(te, Y) || Y + 1 === f.maxRetryCount) return L(te);
            await A();
          } catch (te) {
            if (!i(te, Y) || Y + 1 === f.maxRetryCount) return z(te);
            await A();
          }
        }
      });
      return P.cancel = () => R = !0, P;
    }
    let hT, p5 = class {
      constructor(e) {
        Un(this, "input", []), Un(this, "size", void 0), this.size = e;
      }
      add(e) {
        this.input.push(e), this.input.length > this.size && this.input.splice(0, 1);
      }
      mean() {
        var e;
        return this.input.length === 0 ? 0 : _c(e = this.input).call(e, (n, i) => n + i) / this.input.length;
      }
    }, pT = 0, BS = 0;
    function zS(e, n, i, o) {
      return new cn((f, T) => {
        n.responseType = n.responseType || "json", n.data && !i ? (n.data = JSON.stringify(n.data), pT += mu(n.data)) : i && (n.data.size ? pT += n.data.size : n.data instanceof FormData ? pT += o5(n.data) : pT += mu(JSON.stringify(n.data))), n.headers = n.headers || {}, n.headers["Content-Type"] = n.headers["Content-Type"] || "application/json", n.method = "POST", n.url = e, fa.request(n).then((A) => {
          typeof A.data == "string" ? BS += mu(A.data) : A.data instanceof ArrayBuffer || A.data instanceof Uint8Array ? BS += A.data.byteLength : BS += mu(JSON.stringify(A.data)), f(A.data);
        }).catch((A) => {
          fa.isCancel(A) ? T(new Gt(Je.OPERATION_ABORTED, "cancel token canceled")) : A.code === "ECONNABORTED" ? T(new Gt(Je.NETWORK_TIMEOUT, A.message)) : A.response ? T(new Gt(Je.NETWORK_RESPONSE_ERROR, A.response.status)) : T(new Gt(Je.NETWORK_ERROR, A.message));
        });
      });
    }
    async function Vie(e, n) {
      const i = new Blob([n.data], { type: "buffer" });
      return await zS(e, yn(yn({}, n), {}, { data: i, headers: { "Content-Type": "application/octet-stream" } }), !0);
    }
    const g5 = () => window.isSecureContext !== void 0;
    function ic(e) {
      if (Array.isArray(e)) return e.map((i) => i);
      if (!m5(e)) return e;
      const n = {};
      for (const i in e) {
        const o = e[i];
        m5(o) || Array.isArray(o) ? n[i] = ic(o) : n[i] = o;
      }
      return n;
    }
    function m5(e) {
      return !(typeof e != "object" || Array.isArray(e) || !e);
    }
    let FS = class {
      constructor(e) {
        Un(this, "input", []), Un(this, "size", void 0), this.size = e;
      }
      add(e) {
        this.input.push(e), this.input.length > this.size && this.input.splice(0, 1);
      }
      diffMean() {
        return this.input.length === 0 ? 0 : (this.input[this.input.length - 1] - this.input[0]) / this.input.length;
      }
    };
    const Eu = { address: "unknown", candidateType: "unknown", id: "unknown", port: 0, priority: 0, protocol: "unknown", type: "unknown" }, _E = { timestamp: 0, bitrate: { actualEncoded: 0, transmit: 0 }, sendPacketLossRate: 0, recvPacketLossRate: 0, videoRecv: [], videoSend: [], audioRecv: [], audioSend: [], selectedCandidatePair: { id: "unknown", localCandidate: Eu, remoteCandidate: Eu }, updateInterval: 0 }, E5 = { firsCount: 0, nacksCount: 0, plisCount: 0, framesDecodeCount: 0, framesDecodeInterval: 0, framesDecodeFreezeTime: 0, decodeFrameRate: 0, bytes: 0, packetsLost: 0, packetLostRate: 0, packets: 0, ssrc: 0, qpSumPerFrame: 0, framesDroppedCount: 0, outputFrameRate: 0, packetsDiscarded: 0, framesAssembledFromMultiplePackets: 0, totalProcessingDelay: 0, avgDecodeMs: 0, avgFramesAssembledFromMultiplePacketsMs: 0, avgProcessingDelayMs: 0, avgInterFrameDelayMs: 0, totalAssemblyTime: 0 }, y5 = { firsCount: 0, nacksCount: 0, plisCount: 0, frameCount: 0, bytes: 0, packets: 0, packetsLost: 0, packetLostRate: 0, ssrc: 0, rttMs: 0, jitterMs: 0, qpSumPerFrame: 0 }, v5 = { bytes: 0, packets: 0, packetsLost: 0, packetLostRate: 0, ssrc: 0, rttMs: 0, jitterMs: 0 }, T5 = { jitterBufferMs: 0, jitterMs: 0, bytes: 0, packetsLost: 0, packetLostRate: 0, packetsDiscarded: 0, packets: 0, ssrc: 0, receivedFrames: 0, droppedFrames: 0, concealedSamples: 0 };
    let GS = class {
      constructor(e, n) {
        Un(this, "onFirstVideoReceived", void 0), Un(this, "onFirstVideoDecoded", void 0), Un(this, "onFirstAudioReceived", void 0), Un(this, "onFirstVideoDecodedTimeout", void 0), Un(this, "onFirstAudioDecoded", void 0), Un(this, "onSelectedLocalCandidateChanged", void 0), Un(this, "onSelectedRemoteCandidateChanged", void 0), Un(this, "videoIsReady", !1), Un(this, "videoIsReady2", {}), Un(this, "pc", void 0), Un(this, "options", void 0), Un(this, "intervalTimer", void 0), Un(this, "stats", ic(_E)), Un(this, "isFirstVideoReceived", {}), Un(this, "isFirstVideoDecoded", {}), Un(this, "isFirstAudioReceived", {}), Un(this, "isFirstAudioDecoded", {}), Un(this, "isFirstVideoDecodedTimeout", {}), Un(this, "lossRateWindowStats", []), this.pc = e, this.options = n, this.intervalTimer = window.setInterval(async () => {
          this.updateStats();
        }, this.options.updateInterval);
      }
      getStats() {
        return this.stats;
      }
      getSelectedCandidatePair() {
        return new cn((e) => {
          e({ local: yn({}, Eu), remote: yn({}, Eu) });
        });
      }
      setVideoIsReady(e) {
        this.videoIsReady = e;
      }
      setVideoIsReady2(e, n) {
        this.videoIsReady2[e] = n;
      }
      getVideoIsReady(e) {
        return this.videoIsReady2[e] || !1;
      }
      setIsFirstAudioDecoded(e) {
      }
      destroy() {
        window.clearInterval(this.intervalTimer), this.pc = void 0;
      }
      calcLossRate(e) {
        this.lossRateWindowStats.push(e), this.lossRateWindowStats.length > this.options.lossRateInterval && this.lossRateWindowStats.splice(0, 1);
        const n = this.lossRateWindowStats.length, i = ["videoSend", "audioSend", "videoRecv", "audioRecv"];
        let o = 0, f = 0, T = 0, A = 0;
        for (const R of i) e[R].forEach((P, L) => {
          if (!this.lossRateWindowStats[n - 1][R][L] || !this.lossRateWindowStats[0][R][L]) return;
          const z = this.lossRateWindowStats[n - 1][R][L].packets - this.lossRateWindowStats[0][R][L].packets, Y = this.lossRateWindowStats[n - 1][R][L].packetsLost - this.lossRateWindowStats[0][R][L].packetsLost;
          R === "videoSend" || R === "audioSend" ? (o += z, T += Y) : (f += z, A += Y), Number.isNaN(z) || Number.isNaN(z) ? P.packetLostRate = 0 : P.packetLostRate = z <= 0 || Y <= 0 ? 0 : Y / (z + Y);
        });
        e.sendPacketLossRate = o <= 0 || T <= 0 ? 0 : T / (o + T), e.recvPacketLossRate = f <= 0 || A <= 0 ? 0 : A / (f + A);
      }
    }, Yie = class extends GS {
      constructor() {
        super(...arguments), Un(this, "_stats", _E), Un(this, "lastDecodeVideoReceiverStats", /* @__PURE__ */ new Map());
      }
      async updateStats() {
        const e = await this._getStats(), n = this.statsResponsesToObjects(e);
        this._stats = ic(_E);
        const i = n.filter((f) => f.type === "ssrc");
        this.processSSRCStats(i);
        const o = n.find((f) => f.type === "VideoBwe");
        o && this.processBandwidthStats(o), this._stats.timestamp = Date.now(), this.calcLossRate(this._stats), this.stats = this._stats;
      }
      processBandwidthStats(e) {
        this._stats.bitrate = { actualEncoded: Number(e.googActualEncBitrate), targetEncoded: Number(e.googTargetEncBitrate), retransmit: Number(e.googRetransmitBitrate), transmit: Number(e.googTransmitBitrate) }, this._stats.sendBandwidth = Number(e.googAvailableSendBandwidth);
      }
      processSSRCStats(e) {
        e.forEach((n) => {
          var i;
          const o = on(i = n.id).call(i, "send");
          switch ("".concat(n.mediaType, "_").concat(o ? "send" : "recv")) {
            case "video_send": {
              const f = ic(y5);
              f.codec = n.googCodecName, f.adaptionChangeReason = "none", n.googCpuLimitedResolution && (f.adaptionChangeReason = "cpu"), n.googBandwidthLimitedResolution && (f.adaptionChangeReason = "bandwidth"), f.avgEncodeMs = Number(n.googAvgEncodeMs), f.inputFrame = { width: Number(n.googFrameWidthInput) || Number(n.googFrameWidthSent), height: Number(n.googFrameHeightInput) || Number(n.googFrameHeightSent), frameRate: Number(n.googFrameRateInput) }, f.sentFrame = { width: Number(n.googFrameWidthSent), height: Number(n.googFrameHeightSent), frameRate: Number(n.googFrameRateInput) }, f.firsCount = Number(n.googFirReceived), f.nacksCount = Number(n.googNacksReceived), f.plisCount = Number(n.googPlisReceived), f.frameCount = Number(n.framesEncoded), f.bytes = Number(n.bytesSent), f.packets = Number(n.packetsSent), f.packetsLost = Number(n.packetsLost), f.ssrc = Number(n.ssrc), f.rttMs = Number(n.googRtt || 0), this._stats.videoSend.push(f), this._stats.rtt = f.rttMs;
              break;
            }
            case "video_recv": {
              const f = ic(E5), T = this.lastDecodeVideoReceiverStats.get(Number(n.ssrc));
              if (f.codec = n.googCodecName, f.targetDelayMs = Number(n.googTargetDelayMs), f.renderDelayMs = Number(n.googRenderDelayMs), f.currentDelayMs = Number(n.googCurrentDelayMs), f.minPlayoutDelayMs = Number(n.googMinPlayoutDelayMs), f.decodeMs = Number(n.googDecodeMs), f.maxDecodeMs = Number(n.googMaxDecodeMs), f.receivedFrame = { width: Number(n.googFrameWidthReceived), height: Number(n.googFrameHeightReceived), frameRate: Number(n.googFrameRateReceived) }, f.decodedFrame = { width: Number(n.googFrameWidthReceived), height: Number(n.googFrameHeightReceived), frameRate: Number(n.googFrameRateDecoded) }, f.decodeFrameRate = Number(n.googFrameRateDecoded), f.outputFrame = { width: Number(n.googFrameWidthReceived), height: Number(n.googFrameHeightReceived), frameRate: Number(n.googFrameRateOutput) }, f.jitterBufferMs = Number(n.googJitterBufferMs), f.firsCount = Number(n.googFirsSent), f.nacksCount = Number(n.googNacksSent), f.plisCount = Number(n.googPlisSent), f.framesDecodeCount = Number(n.framesDecoded), f.bytes = Number(n.bytesReceived), f.packets = Number(n.packetsReceived), f.packetsLost = Number(n.packetsLost), f.ssrc = Number(n.ssrc), f.packets > 0 && !this.isFirstVideoReceived[f.ssrc] && (this.onFirstVideoReceived && this.onFirstVideoReceived(f.ssrc), this.isFirstVideoReceived[f.ssrc] = !0), f.framesDecodeCount > 0 && !this.isFirstVideoDecoded[f.ssrc] && (this.onFirstVideoDecoded && this.onFirstVideoDecoded(f.ssrc, f.decodedFrame.width, f.decodedFrame.height), this.isFirstVideoDecoded[f.ssrc] = !0), T) {
                const A = T.stats, R = Date.now() - T.lts;
                f.framesDecodeFreezeTime = A.framesDecodeFreezeTime, f.framesDecodeInterval = A.framesDecodeInterval, f.framesDecodeCount > A.framesDecodeCount && this.isFirstVideoDecoded[f.ssrc] ? (T.lts = Date.now(), f.framesDecodeInterval = R, f.framesDecodeInterval >= this.options.freezeRateLimit && (this.getVideoIsReady(parseInt(n.ssrc, 10)) ? f.framesDecodeFreezeTime += f.framesDecodeInterval : this.setVideoIsReady2(parseInt(n.ssrc, 10), !0))) : f.framesDecodeCount < T.stats.framesDecodeCount && (f.framesDecodeInterval = 0);
              }
              this.lastDecodeVideoReceiverStats.set(f.ssrc, { stats: yn({}, f), lts: Date.now() }), this._stats.videoRecv.push(f);
              break;
            }
            case "audio_recv": {
              const f = ic(T5);
              f.codec = n.googCodecName, f.outputLevel = Math.abs(Number(n.audioOutputLevel)) / 32767, f.decodingCNG = Number(n.googDecodingCNG), f.decodingCTN = Number(n.googDecodingCTN), f.decodingCTSG = Number(n.googDecodingCTSG), f.decodingNormal = Number(n.googDecodingNormal), f.decodingPLC = Number(n.googDecodingPLC), f.decodingPLCCNG = Number(n.googDecodingPLCCNG), f.expandRate = Number(n.googExpandRate), f.accelerateRate = Number(n.googAccelerateRate), f.preemptiveExpandRate = Number(n.googPreemptiveExpandRate), f.secondaryDecodedRate = Number(n.googSecondaryDecodedRate), f.speechExpandRate = Number(n.googSpeechExpandRate), f.preferredJitterBufferMs = Number(n.googPreferredJitterBufferMs), f.jitterBufferMs = Number(n.googJitterBufferMs), f.jitterMs = Number(n.googJitterReceived), f.bytes = Number(n.bytesReceived), f.packets = Number(n.packetsReceived), f.packetsLost = Number(n.packetsLost), f.ssrc = Number(n.ssrc), f.receivedFrames = Number(n.googDecodingCTN) || Number(n.packetsReceived), f.droppedFrames = Number(n.googDecodingPLC) + Number(n.googDecodingPLCCNG) || Number(n.packetsLost), f.receivedFrames > 0 && !this.isFirstAudioReceived[f.ssrc] && (this.onFirstAudioReceived && this.onFirstAudioReceived(f.ssrc), this.isFirstAudioReceived[f.ssrc] = !0), f.decodingNormal > 0 && !this.isFirstAudioDecoded[f.ssrc] && (this.onFirstAudioDecoded && this.onFirstAudioDecoded(f.ssrc), this.isFirstAudioDecoded[f.ssrc] = !0), this._stats.audioRecv.push(f);
              break;
            }
            case "audio_send": {
              const f = ic(v5);
              f.codec = n.googCodecName, f.inputLevel = Math.abs(Number(n.audioInputLevel)) / 32767, f.aecReturnLoss = Number(n.googEchoCancellationReturnLoss || 0), f.aecReturnLossEnhancement = Number(n.googEchoCancellationReturnLossEnhancement || 0), f.residualEchoLikelihood = Number(n.googResidualEchoLikelihood || 0), f.residualEchoLikelihoodRecentMax = Number(n.googResidualEchoLikelihoodRecentMax || 0), f.bytes = Number(n.bytesSent), f.packets = Number(n.packetsSent), f.packetsLost = Number(n.packetsLost), f.ssrc = Number(n.ssrc), f.rttMs = Number(n.googRtt || 0), this._stats.rtt = f.rttMs, this._stats.audioSend.push(f);
              break;
            }
          }
        });
      }
      _getStats() {
        return new cn((e, n) => {
          this.pc.getStats(e, n);
        });
      }
      statsResponsesToObjects(e) {
        const n = [];
        return e.result().forEach((i) => {
          const o = { id: i.id, timestamp: i.timestamp.valueOf().toString(), type: i.type };
          i.names().forEach((f) => {
            o[f] = i.stat(f);
          }), n.push(o);
        }), n;
      }
    }, PE = function(e) {
      return e.BANDWIDTH = "bandwidth", e.CPU = "cpu", e.NONE = "none", e.OTHER = "other", e;
    }({}), gT = function(e) {
      return e.L1T1 = "L1T1", e.L1T2 = "L1T2", e.L1T3 = "L1T3", e.L1T3_KEY = "L1T3_KEY", e.L2T1_KEY = "L2T1_KEY", e.L2T2_KEY = "L2T2_KEY", e.L2T3_KEY = "L2T3_KEY", e.L3T1_KEY = "L3T1_KEY", e.L3T2_KEY = "L3T2_KEY", e.L3T3_KEY = "L3T3_KEY", e;
    }({}), VS = function(e) {
      return e[e.new = 0] = "new", e[e.connecting = 1] = "connecting", e[e.connected = 2] = "connected", e[e.disconnected = 3] = "disconnected", e[e.failed = 4] = "failed", e[e.closed = 5] = "closed", e;
    }({}), no = function(e) {
      return e.CERTIFICATE = "certificate", e.CODEC = "codec", e.CANDIDATE_PAIR = "candidate-pair", e.LOCAL_CANDIDATE = "local-candidate", e.REMOTE_CANDIDATE = "remote-candidate", e.INBOUND = "inbound-rtp", e.TRACK = "track", e.OUTBOUND = "outbound-rtp", e.PC = "peer-connection", e.REMOTE_INBOUND = "remote-inbound-rtp", e.REMOTE_OUTBOUND = "remote-outbound-rtp", e.TRANSPORT = "transport", e.CSRC = "csrc", e.DATA_CHANNEL = "data-channel", e.STREAM = "stream", e.SENDER = "sender", e.RECEIVER = "receiver", e;
    }({});
    var sp = function(e) {
      return e[e.kNone = 1] = "kNone", e[e.kMillisecondsFromSeconds = 1e3] = "kMillisecondsFromSeconds", e[e.kBytesToBits = 8] = "kBytesToBits", e;
    }(sp || {});
    function xE(e, n, i, o) {
      let f = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : sp.kNone;
      if (!n) return;
      const T = Number(n[i]);
      if (typeof T != "number") return;
      const A = Number(n[o]);
      if (typeof A != "number") return;
      if (!e) return A ? T / A * f : void 0;
      const R = Number(e[i]);
      if (typeof R != "number") return;
      const P = Number(e[o]);
      if (typeof P != "number") return;
      const L = A - P;
      return L ? (T - R) / L * f : void 0;
    }
    let b5 = class extends GS {
      constructor() {
        super(...arguments), Un(this, "_stats", _E), Un(this, "report", void 0), Un(this, "lastDecodeVideoReceiverStats", /* @__PURE__ */ new Map()), Un(this, "lastVideoFramesRecv", /* @__PURE__ */ new Map()), Un(this, "lastVideoFramesSent", /* @__PURE__ */ new Map()), Un(this, "lastVideoFramesDecode", /* @__PURE__ */ new Map()), Un(this, "lastVideoFramesOutput", /* @__PURE__ */ new Map()), Un(this, "lastVideoJBDelay", /* @__PURE__ */ new Map()), Un(this, "lastAudioJBDelay", /* @__PURE__ */ new Map()), Un(this, "mediaBytesSent", /* @__PURE__ */ new Map()), Un(this, "mediaBytesRetransmit", /* @__PURE__ */ new Map()), Un(this, "mediaBytesTargetEncode", /* @__PURE__ */ new Map()), Un(this, "lastDecodeAudioReceiverStats", /* @__PURE__ */ new Map()), Un(this, "lastEncoderMs", /* @__PURE__ */ new Map());
      }
      async updateStats() {
        this.report = await this.pc.getStats(), this._stats = ic(_E), this.report.forEach((e) => {
          switch (e.type) {
            case no.OUTBOUND:
            case no.INBOUND: {
              const n = e.mediaType || e.kind, i = !n && "frameWidth" in e, o = !n && !("frameWidth" in e);
              e.type === no.OUTBOUND ? n === "audio" || o ? this.processAudioOutboundStats(e) : (n === "video" || i) && this.processVideoOutboundStats(e) : e.type === no.INBOUND && (n === "audio" || o ? this.processAudioInboundStats(e) : (n === "video" || i) && this.processVideoInboundStats(e));
              break;
            }
            case no.TRANSPORT: {
              const n = this.report.get(e.selectedCandidatePairId);
              n && this.processCandidatePairStats(n);
              break;
            }
            case no.CANDIDATE_PAIR:
              e.selected && this.processCandidatePairStats(e);
          }
        }), this.updateSendBitrate(), this._stats.updateInterval = Date.now() - this.stats.timestamp, this._stats.timestamp = Date.now(), this.calcLossRate(this._stats), this.stats = this._stats;
      }
      async getSelectedCandidatePair() {
        const e = await this.pc.getStats(), n = { local: yn({}, Eu), remote: yn({}, Eu) };
        return e.forEach((i) => {
          let o;
          if (i.type === no.TRANSPORT && (o = e.get(i.selectedCandidatePairId)), i.type === no.CANDIDATE_PAIR && i.selected && (o = i), o) {
            const f = (T, A) => {
              T.type = A.type, T.id = A.id, A.address && (T.address = A.address), A.candidateType && (T.candidateType = A.candidateType), A.port && (T.port = A.port), A.priority && (T.priority = A.priority), A.protocol && (T.protocol = A.protocol), A.relayProtocol && (T.relayProtocol = A.relayProtocol);
            };
            if (o.localCandidateId) {
              const T = e.get(o.localCandidateId);
              T && f(n.local, T);
            }
            if (o.remoteCandidateId) {
              const T = e.get(o.remoteCandidateId);
              T && f(n.remote, T);
            }
          }
        }), n;
      }
      processCandidatePairStats(e) {
        if (this._stats.sendBandwidth = e.availableOutgoingBitrate || 0, e.currentRoundTripTime && (this._stats.rtt = 1e3 * e.currentRoundTripTime), this._stats.videoSend.forEach((n) => {
          e.currentRoundTripTime && (n.rttMs = 1e3 * e.currentRoundTripTime);
        }), this._stats.audioSend.forEach((n) => {
          e.currentRoundTripTime && (n.rttMs = 1e3 * e.currentRoundTripTime);
        }), this._stats.selectedCandidatePair.id = e.id, e.localCandidateId) {
          const n = this.report.get(e.localCandidateId);
          n && this.processCandidateStats(n);
        }
        if (e.remoteCandidateId) {
          const n = this.report.get(e.remoteCandidateId);
          n && this.processCandidateStats(n);
        }
      }
      processCandidateStats(e) {
        let n;
        e.type === no.LOCAL_CANDIDATE && (n = this._stats.selectedCandidatePair.localCandidate), e.type === no.REMOTE_CANDIDATE && (n = this._stats.selectedCandidatePair.remoteCandidate), n && (n.type = e.type, n.id = e.id, e.address && (n.address = e.address), e.candidateType && (n.candidateType = e.candidateType), e.port && (n.port = e.port), e.priority && (n.priority = e.priority), e.protocol && (n.protocol = e.protocol), e.relayProtocol && (n.relayProtocol = e.relayProtocol), e.type === no.LOCAL_CANDIDATE && this.stats.selectedCandidatePair.localCandidate.id !== n.id && this.onSelectedLocalCandidateChanged && this.onSelectedLocalCandidateChanged(yn({}, n), yn({}, this.stats.selectedCandidatePair.localCandidate)), e.type === no.REMOTE_CANDIDATE && this.stats.selectedCandidatePair.remoteCandidate.id !== n.id && this.onSelectedRemoteCandidateChanged && this.onSelectedRemoteCandidateChanged(yn({}, n), yn({}, this.stats.selectedCandidatePair.remoteCandidate)));
      }
      processAudioInboundStats(e) {
        let n = this._stats.audioRecv.find((o) => o.ssrc === e.ssrc);
        n || (n = ic(T5), this._stats.audioRecv.push(n)), n.ssrc = e.ssrc, n.packets = e.packetsReceived, n.packetsLost = e.packetsLost, n.packetsDiscarded = e.packetsDiscarded, n.bytes = e.bytesReceived, n.jitterMs = 1e3 * e.jitter, n.retransmittedBytesReceived = e.retransmittedBytesReceived, n.retransmittedPacketsReceived = e.retransmittedPacketsReceived, n.totalProcessingDelay = e.totalProcessingDelay, n.jitterBufferEmittedCount = e.jitterBufferEmittedCount;
        const i = this.lastDecodeAudioReceiverStats.get(n.ssrc);
        n.avgProcessingDelayMs = xE(i, n, "totalProcessingDelay", "jitterBufferEmittedCount", sp.kMillisecondsFromSeconds), this.processAudioTrackReceiverStats(e, e.trackId, n), e.codecId && (n.codec = this.getCodecFromCodecStats(e.codecId)), n.receivedFrames || (n.receivedFrames = e.packetsReceived), n.droppedFrames || (n.droppedFrames = e.packetsLost), n.receivedFrames > 0 && !this.isFirstAudioReceived[n.ssrc] && (this.onFirstAudioReceived && this.onFirstAudioReceived(n.ssrc), this.isFirstAudioReceived[n.ssrc] = !0), n.outputLevel && n.outputLevel > 0 && !this.isFirstAudioDecoded[n.ssrc] && (this.onFirstAudioDecoded && this.onFirstAudioDecoded(n.ssrc), this.isFirstAudioDecoded[n.ssrc] = !0), typeof e.concealedSamples == "number" && (n.concealedSamples = e.concealedSamples), this.lastDecodeAudioReceiverStats.set(n.ssrc, yn({}, n));
      }
      processVideoInboundStats(e) {
        let n = this._stats.videoRecv.find((A) => A.ssrc === e.ssrc);
        n || (n = ic(E5), this._stats.videoRecv.push(n)), n.ssrc = e.ssrc, n.packets = e.packetsReceived, n.packetsLost = e.packetsLost, n.bytes = e.bytesReceived, n.firsCount = e.firCount, n.nacksCount = e.nackCount, n.plisCount = e.pliCount, n.framesDecodeCount = e.framesDecoded, n.framesDroppedCount = e.framesDropped, n.totalInterFrameDelay = e.totalInterFrameDelay, n.totalSquaredInterFrameDelay = e.totalSquaredInterFrameDelay, n.totalFreezesDuration = e.totalFreezesDuration, n.totalProcessingDelay = e.totalProcessingDelay, n.packetsDiscarded = e.packetsDiscarded, n.framesAssembledFromMultiplePackets = e.framesAssembledFromMultiplePackets, n.totalAssemblyTime = e.totalAssemblyTime, n.keyFramesDecoded = e.keyFramesDecoded, n.retransmittedBytesReceived = e.retransmittedBytesReceived, n.retransmittedPacketsReceived = e.retransmittedPacketsReceived;
        const i = this.lastDecodeVideoReceiverStats.get(n.ssrc), o = this.lastVideoFramesDecode.get(n.ssrc), f = this.lastVideoFramesOutput.get(n.ssrc), T = Date.now();
        if (n.framesDecodeCount > 0 && !this.isFirstVideoDecoded[n.ssrc]) {
          const A = n.decodedFrame ? n.decodedFrame.width : 0, R = n.decodedFrame ? n.decodedFrame.height : 0;
          this.onFirstVideoDecoded && this.onFirstVideoDecoded(n.ssrc, A, R), this.isFirstVideoDecoded[n.ssrc] = !0;
        }
        if (i) {
          const A = i.stats, R = T - i.lts;
          n.framesDecodeFreezeTime = A.framesDecodeFreezeTime, n.framesDecodeInterval = A.framesDecodeInterval, !this.isFirstVideoDecoded[n.ssrc] && R > this.options.firstVideoDecodedTimeout && !this.isFirstVideoDecodedTimeout[n.ssrc] && (this.onFirstVideoDecodedTimeout && this.onFirstVideoDecodedTimeout(n.ssrc), this.isFirstVideoDecodedTimeout[n.ssrc] = !0), n.framesDecodeCount > A.framesDecodeCount && this.isFirstVideoDecoded[n.ssrc] ? (i.lts = Date.now(), n.framesDecodeInterval = R, n.framesDecodeInterval >= this.options.freezeRateLimit && (this.getVideoIsReady(parseInt(e.ssrc)) ? n.framesDecodeFreezeTime += n.framesDecodeInterval : this.setVideoIsReady2(parseInt(e.ssrc, 10), !0))) : n.framesDecodeCount < A.framesDecodeCount && (n.framesDecodeInterval = 0), e.framesDecoded && e.qpSum && (i.stats.framesDecodeCount > e.framesDecoded ? n.qpSumPerFrame = e.qpSum / e.framesDecoded : n.qpSumPerFrame = (e.qpSum - i.qpSum) / (e.framesDecoded - i.stats.framesDecodeCount));
        }
        e.totalDecodeTime && (n.decodeMs = 1e3 * e.totalDecodeTime, n.avgDecodeMs = xE(i == null ? void 0 : i.stats, n, "decodeMs", "framesDecodeCount")), n.avgProcessingDelayMs = xE(i == null ? void 0 : i.stats, n, "totalProcessingDelay", "framesDecodeCount", sp.kMillisecondsFromSeconds), n.avgFramesAssembledFromMultiplePacketsMs = xE(i == null ? void 0 : i.stats, n, "totalAssemblyTime", "framesAssembledFromMultiplePackets", sp.kMillisecondsFromSeconds), n.avgInterFrameDelayMs = xE(i == null ? void 0 : i.stats, n, "totalInterFrameDelay", "framesDecodeCount", sp.kMillisecondsFromSeconds), o && T - o.lts >= 800 ? (n.decodeFrameRate = Math.round((n.framesDecodeCount - o.count) / ((T - o.lts) / 1e3)), this.lastVideoFramesDecode.set(n.ssrc, { count: n.framesDecodeCount, lts: T, rate: n.decodeFrameRate })) : o ? n.decodeFrameRate = o.rate : this.lastVideoFramesDecode.set(n.ssrc, { count: n.framesDecodeCount, lts: T, rate: 0 }), n.framesDroppedCount && e.framesReceived && (f && T - f.lts >= 800 ? (n.outputFrameRate = Math.round((e.framesReceived - n.framesDroppedCount - f.count) / ((T - f.lts) / 1e3)), this.lastVideoFramesOutput.set(n.ssrc, { count: e.framesReceived - n.framesDroppedCount, lts: T, rate: Math.max(n.outputFrameRate, 0) })) : f ? n.outputFrameRate = f.rate : this.lastVideoFramesOutput.set(n.ssrc, { count: e.framesReceived - n.framesDroppedCount, lts: T, rate: 0 })), this.processVideoTrackReceiverStats(e, e.trackId, n), e.codecId && (n.codec = this.getCodecFromCodecStats(e.codecId)), e.framerateMean && (n.framesRateFirefox = e.framerateMean), n.packets > 0 && !this.isFirstVideoReceived[n.ssrc] && (this.onFirstVideoReceived && this.onFirstVideoReceived(n.ssrc), this.isFirstVideoReceived[n.ssrc] = !0), this.lastDecodeVideoReceiverStats.set(n.ssrc, { stats: yn({}, n), lts: i ? i.lts : Date.now(), qpSum: e.qpSum });
      }
      processVideoOutboundStats(e) {
        let n = this._stats.videoSend.find((o) => o.ssrc === e.ssrc);
        n || (n = ic(y5), this._stats.videoSend.push(n));
        const i = this.mediaBytesSent.get(e.ssrc);
        if (i) i.add(e.bytesSent);
        else {
          const o = new FS(10);
          o.add(e.bytesSent), this.mediaBytesSent.set(e.ssrc, o);
        }
        if (e.retransmittedBytesSent !== void 0) {
          const o = this.mediaBytesRetransmit.get(e.ssrc);
          if (o) o.add(e.retransmittedBytesSent);
          else {
            const f = new FS(10);
            f.add(e.retransmittedBytesSent), this.mediaBytesRetransmit.set(e.ssrc, f);
          }
        }
        if (e.totalEncodedBytesTarget) {
          const o = this.mediaBytesTargetEncode.get(e.ssrc);
          if (o) o.add(e.totalEncodedBytesTarget);
          else {
            const f = new FS(10);
            f.add(e.totalEncodedBytesTarget), this.mediaBytesTargetEncode.set(e.ssrc, f);
          }
        }
        if (n.ssrc = e.ssrc, n.bytes = e.bytesSent, n.packets = e.packetsSent, n.firsCount = e.firCount, n.nacksCount = e.nackCount, n.plisCount = e.pliCount, n.frameCount = e.framesEncoded, n.adaptionChangeReason = e.qualityLimitationReason, n.scalabilityMode = e.scalabilityMode, n.retransmittedBytesSent = e.retransmittedBytesSent, n.retransmittedPacketsSent = e.retransmittedPacketsSent, n.hugeFramesSent = e.hugeFramesSent, n.keyFramesEncoded = e.keyFramesEncoded, e.totalEncodeTime && e.framesEncoded) {
          const o = this.lastEncoderMs.get(e.ssrc);
          if (!o || o.lastFrameCount > e.framesEncoded) n.avgEncodeMs = 1e3 * e.totalEncodeTime / e.framesEncoded;
          else {
            const f = e.framesEncoded - o.lastFrameCount, T = e.totalEncodeTime - o.lastEncoderTime;
            n.avgEncodeMs = 1e3 * T / f;
          }
        }
        if (e.framesEncoded && e.qpSum) {
          const o = this.lastEncoderMs.get(e.ssrc);
          !o || o.lastFrameCount > e.framesEncoded ? n.qpSumPerFrame = e.qpSum / e.framesEncoded : n.qpSumPerFrame = (e.qpSum - o.lastQpSum) / (e.framesEncoded - o.lastFrameCount);
        }
        if (this.lastEncoderMs.set(e.ssrc, { lastFrameCount: e.framesEncoded, lastEncoderTime: e.totalEncodeTime, lastQpSum: e.qpSum, lts: Date.now() }), e.codecId && (n.codec = this.getCodecFromCodecStats(e.codecId)), e.mediaSourceId && this.processVideoMediaSource(e.mediaSourceId, n), this.processVideoTrackSenderStats(e, e.trackId, n), e.remoteId) this.processRemoteInboundStats(e.remoteId, n);
        else {
          const o = this.findRemoteStatsId(e.ssrc, no.REMOTE_INBOUND);
          o && this.processRemoteInboundStats(o, n);
        }
      }
      processAudioOutboundStats(e) {
        let n = this._stats.audioSend.find((i) => i.ssrc === e.ssrc);
        if (n || (n = ic(v5), this._stats.audioSend.push(n)), n.ssrc = e.ssrc, n.packets = e.packetsSent, n.bytes = e.bytesSent, n.retransmittedBytesSent = e.retransmittedBytesSent, n.retransmittedPacketsSent = e.retransmittedPacketsSent, e.mediaSourceId && this.processAudioMediaSource(e.mediaSourceId, n), e.codecId && (n.codec = this.getCodecFromCodecStats(e.codecId)), this.processAudioTrackSenderStats(e, e.trackId, n), e.remoteId) this.processRemoteInboundStats(e.remoteId, n);
        else {
          const i = this.findRemoteStatsId(e.ssrc, no.REMOTE_INBOUND);
          i && this.processRemoteInboundStats(i, n);
        }
      }
      findRemoteStatsId(e, n) {
        var i;
        const o = Array.from(nd(i = this.report).call(i)).find((f) => f.type === n && f.ssrc === e);
        return o ? o.id : null;
      }
      processVideoMediaSource(e, n) {
        const i = this.report.get(e);
        i && i.width && i.height && i.framesPerSecond && (n.inputFrame = { width: i.width, height: i.height, frameRate: i.framesPerSecond });
      }
      processAudioMediaSource(e, n) {
        const i = this.report.get(e);
        i && (n.inputLevel = i.audioLevel);
      }
      processVideoTrackSenderStats(e, n, i) {
        var o, f, T, A;
        const R = n ? this.report.get(n) : void 0, P = (o = R == null ? void 0 : R.framesSent) !== null && o !== void 0 ? o : e.framesSent;
        if (typeof P != "number") return;
        let L = (f = R == null ? void 0 : R.frameWidth) !== null && f !== void 0 ? f : e.frameWidth, z = (T = R == null ? void 0 : R.frameHeight) !== null && T !== void 0 ? T : e.frameHeight, Y = (A = R == null ? void 0 : R.framesPerSecond) !== null && A !== void 0 ? A : e.framesPerSecond;
        if (typeof L == "number" && typeof z == "number" || (L = 0, z = 0), Y == null) {
          const te = Date.now(), oe = this.lastVideoFramesSent.get(i.ssrc);
          oe && te - oe.lts >= 800 ? (Y = Math.round((P - oe.count) / ((te - oe.lts) / 1e3)), this.lastVideoFramesSent.set(i.ssrc, { count: P, lts: te, rate: Y })) : oe ? Y = oe.rate : this.lastVideoFramesSent.set(i.ssrc, { count: P, lts: te, rate: 0 });
        }
        i.sentFrame = { width: L, height: z, frameRate: Math.max(0, Y) };
      }
      processVideoTrackReceiverStats(e, n, i) {
        var o, f, T, A, R;
        const P = n ? this.report.get(n) : void 0, L = (o = P == null ? void 0 : P.framesReceived) !== null && o !== void 0 ? o : e.framesReceived, z = (f = P == null ? void 0 : P.frameWidth) !== null && f !== void 0 ? f : e.frameWidth, Y = (T = P == null ? void 0 : P.frameHeight) !== null && T !== void 0 ? T : e.frameHeight, te = (A = P == null ? void 0 : P.jitterBufferDelay) !== null && A !== void 0 ? A : e.jitterBufferDelay, oe = (R = P == null ? void 0 : P.jitterBufferEmittedCount) !== null && R !== void 0 ? R : e.jitterBufferEmittedCount;
        if (typeof L == "number") {
          const He = this.lastVideoFramesRecv.get(i.ssrc), Re = Date.now();
          i.framesReceivedCount = L;
          let De = 0;
          He && Re - He.lts >= 800 ? (De = Math.round((L - He.count) / ((Re - He.lts) / 1e3)), this.lastVideoFramesRecv.set(i.ssrc, { count: L, lts: Re, rate: De })) : He ? De = He.rate : this.lastVideoFramesRecv.set(i.ssrc, { count: L, lts: Re, rate: 0 }), i.receivedFrame = { width: z || 0, height: Y || 0, frameRate: De || 0 }, i.decodedFrame = { width: z || 0, height: Y || 0, frameRate: i.decodeFrameRate || 0 }, i.outputFrame = { width: z || 0, height: Y || 0, frameRate: i.outputFrameRate || i.decodeFrameRate || 0 };
        }
        if (te && oe) {
          const He = this.lastVideoJBDelay.get(i.ssrc) || { jitterBufferDelay: 0, jitterBufferEmittedCount: 0, jitterBufferMs: 0 };
          let Re = He.jitterBufferMs;
          const De = oe - He.jitterBufferEmittedCount;
          De > 0 && (Re = 1e3 * (te - He.jitterBufferDelay) / De), i.jitterBufferMs = Re, i.currentDelayMs = Math.round(Re), this.lastVideoJBDelay.set(i.ssrc, { jitterBufferDelay: te, jitterBufferEmittedCount: oe, jitterBufferMs: i.currentDelayMs });
        }
      }
      processAudioTrackSenderStats(e, n, i) {
        var o, f, T, A;
        const R = n ? this.report.get(n) : void 0, P = (o = (f = R == null ? void 0 : R.echoReturnLoss) !== null && f !== void 0 ? f : e.echoReturnLoss) !== null && o !== void 0 ? o : 0, L = (T = (A = R == null ? void 0 : R.echoReturnLossEnhancement) !== null && A !== void 0 ? A : e.echoReturnLossEnhancement) !== null && T !== void 0 ? T : 0;
        i.aecReturnLoss = P, i.aecReturnLossEnhancement = L;
      }
      processAudioTrackReceiverStats(e, n, i) {
        var o, f, T, A, R, P, L;
        const z = n ? this.report.get(n) : void 0, Y = (o = z == null ? void 0 : z.removedSamplesForAcceleration) !== null && o !== void 0 ? o : e.removedSamplesForAcceleration, te = (f = z == null ? void 0 : z.totalSamplesReceived) !== null && f !== void 0 ? f : e.totalSamplesReceived, oe = (T = z == null ? void 0 : z.jitterBufferDelay) !== null && T !== void 0 ? T : e.jitterBufferDelay, He = (A = z == null ? void 0 : z.jitterBufferEmittedCount) !== null && A !== void 0 ? A : e.jitterBufferEmittedCount, Re = (R = z == null ? void 0 : z.audioLevel) !== null && R !== void 0 ? R : e == null ? void 0 : e.audioLevel, De = (P = z == null ? void 0 : z.totalSamplesDuration) !== null && P !== void 0 ? P : e == null ? void 0 : e.totalSamplesDuration, Xe = (L = z == null ? void 0 : z.concealedSamples) !== null && L !== void 0 ? L : e.concealedSamples;
        if (Y && te && (i.accelerateRate = Y / te), oe && He) {
          const mt = this.lastAudioJBDelay.get(i.ssrc) || { jitterBufferDelay: 0, jitterBufferEmittedCount: 0, jitterBufferMs: 0 };
          let Pt = mt.jitterBufferMs;
          const xt = He - mt.jitterBufferEmittedCount;
          xt > 0 && (Pt = 1e3 * (oe - mt.jitterBufferDelay) / xt), i.jitterBufferMs = Math.round(Pt), this.lastAudioJBDelay.set(i.ssrc, { jitterBufferDelay: oe, jitterBufferEmittedCount: He, jitterBufferMs: i.jitterBufferMs });
        }
        i.outputLevel = Re;
        let We = 1920;
        De && te && (We = te / De / 50, i.receivedFrames = Math.round(te / We)), Xe && (i.droppedFrames = Math.round(Xe / We));
      }
      processRemoteInboundStats(e, n) {
        const i = this.report.get(e);
        i && (n.packetsLost = i.packetsLost, i.roundTripTime && (n.rttMs = 1e3 * i.roundTripTime), i.jitter && (n.jitterMs = 1e3 * i.jitter), i.timestamp && (n.timestamp = i.timestamp));
      }
      getCodecFromCodecStats(e) {
        const n = this.report.get(e);
        if (!n) return "";
        const i = n.mimeType.match(/\/(.*)$/);
        return i && i[1] ? i[1] : "";
      }
      updateSendBitrate() {
        let e = 0, n = null, i = null;
        this.mediaBytesSent.forEach((f) => {
          e += f.diffMean();
        }), this.mediaBytesRetransmit.forEach((f) => {
          n = n === null ? f.diffMean() : n + f.diffMean();
        }), this.mediaBytesTargetEncode.forEach((f) => {
          i = i === null ? f.diffMean() : i + f.diffMean();
        });
        const o = n !== null ? e - n : e;
        this._stats.bitrate = { actualEncoded: 8 * o / (this.options.updateInterval / 1e3), transmit: 8 * e / (this.options.updateInterval / 1e3) }, n !== null && (this._stats.bitrate.retransmit = 8 * n / (this.options.updateInterval / 1e3)), i !== null && (this._stats.bitrate.targetEncoded = 8 * i / (this.options.updateInterval / 1e3));
      }
    }, Xie = class extends GS {
      updateStats() {
        return cn.resolve();
      }
    };
    function YS(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 250, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 500, f = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1e4;
      const T = function() {
        const A = navigator.userAgent.toLocaleLowerCase().match(/chrome\/[\d]*/i);
        return A && A[0] ? Number(A[0].split("/")[1]) : null;
      }();
      return T ? T < 76 ? new Yie(e, { updateInterval: n, lossRateInterval: i, freezeRateLimit: o, firstVideoDecodedTimeout: f }) : new b5(e, { updateInterval: n, lossRateInterval: i, freezeRateLimit: o, firstVideoDecodedTimeout: f }) : function(A) {
        if (!window.RTCStatsReport) return !1;
        const R = A.getStats();
        return !!(R instanceof cn || function(P) {
          return !!P && (typeof P == "object" || typeof P == "function") && typeof P.then == "function";
        }(R));
      }(e) ? new b5(e, { updateInterval: n, lossRateInterval: i, freezeRateLimit: o, firstVideoDecodedTimeout: f }) : new Xie(e, { updateInterval: n, lossRateInterval: i, freezeRateLimit: o, firstVideoDecodedTimeout: f });
    }
    const Ro = function(e) {
      if (e.match(/[0-9]+\.[0-9]+\.[0-9]+$/)) return e;
      const n = e.match(/([0-9]+\.[0-9]+\.[0-9]+)\-([0-9]+)/);
      if (n && n[1] && n[2]) {
        const i = n[1], o = n[2];
        return "".concat(i, ".").concat(o);
      }
      return "4.0.0.999";
    }("4.23.0"), XS = function() {
      try {
        return JSON.parse("true") === !0;
      } catch {
        return !0;
      }
    }();
    let bf = function(e) {
      return e.Default = "default", e.Auto = "auto", e.Relay = "relay", e.SdRtn = "sd-rtn", e;
    }({});
    const Is = function() {
      const e = "us".concat("erna", "me"), n = "pa".concat("sswo", "rd"), i = ["t", "s", "t"];
      i.splice(1, 0, "e");
      const o = i.join(""), f = [];
      for (let R = 0; R < 6; R++) f.push("1");
      const T = f.join(""), A = {};
      return A[e] = o, A[n] = T, Object.assign(A, { turnServerURL: "", tcpport: 3433, udpport: 3478, forceturn: !1 });
    }();
    window.DEFAULT_TURN_CONFIG = Is;
    const WS = { MIN_FRAME_RATE: 1, MAX_FRAME_RATE: 30, MAX_THRESHOLD_FRAMERATE: 30, BITRATE_MIN_THRESHOLD: 100, BITRATE_MAX_THRESHOLD: 100, MAX_SCALE: 5, BWE_SCALE_UP_THRESHOLD: 0.6, BWE_SCALE_DOWN_THRESHOLD: 0.6, PERF_SCALE_UP_THRESHOLD: 0.7, PERF_SCALE_DOWN_THRESHOLD: 0.6, MOTION_RESOLUTION_FACTOR: 0.8, MOTION_BITRATE_FACTOR: 0.6, DETAIL_FRAMERATE_FACTOR: 0.8, DETAIL_BITRATE_FACTOR: 0.6, BALANCE_RESOLUTION_FACTOR: 0.9, BALANCE_FRAMERATE_FACTOR: 0.9, BALANCE_BITRATE_FACTOR: 0.6, OVERUSE_TIMES_THRESHOLD: 10, UNDERUSE_TIMES_THRESHOLD: 40 }, qS = "v4.23.0-0-g98fcf352-dirty(12/19/2024, 4:39:56 PM)", ai = yn(yn({ PROCESS_ID: "", ENCRYPT_AES: !0, AREAS: ["CHINA", "GLOBAL"], WEBCS_DOMAIN: ["webrtc2-ap-web-1.agora.io", "webrtc2-2.ap.sd-rtn.com"], WEBCS_DOMAIN_BACKUP_LIST: ["webrtc2-ap-web-3.agora.io", "webrtc2-4.ap.sd-rtn.com"], PROXY_CS: ["ap-proxy-1.agora.io", "ap-proxy-2.agora.io"], CDS_AP: ["cds-ap-web-1.agora.io", "cds-web-2.ap.sd-rtn.com", "cds-ap-web-3.agora.io", "cds-web-4.ap.sd-rtn.com"], ACCOUNT_REGISTER: ["sua-ap-web-1.agora.io", "sua-web-2.ap.sd-rtn.com", "sua-ap-web-3.agora.io", "sua-web-4.ap.sd-rtn.com"], UAP_AP: ["uap-ap-web-1.agora.io", "uap-web-2.ap.sd-rtn.com", "uap-ap-web-3.agora.io", "uap-web-4.ap.sd-rtn.com"], LOG_UPLOAD_SERVER: "logservice.agora.io", EVENT_REPORT_DOMAIN: "statscollector-1.agora.io", EVENT_REPORT_BACKUP_DOMAIN: "web-2.statscollector.sd-rtn.com", ENABLE_EVENT_REPORT: !0, GATEWAY_ADDRESS: [], GATEWAY_WSS_ADDRESS: "", LIVE_STREAMING_ADDRESS: "", HTTP_CONNECT_TIMEOUT: 5e3, SIGNAL_REQUEST_TIMEOUT: 1e4, REPORT_STATS: !0, UPLOAD_LOG: !1, NOT_REPORT_EVENT: [], PING_PONG_TIME_OUT: 10, WEBSOCKET_TIMEOUT_MIN: 1e4, EVENT_REPORT_SEND_INTERVAL: 3e3, CONFIG_DISTRIBUTE_INTERVAL: 3e5, ENABLE_CONFIG_DISTRIBUTE: !0, CANDIDATE_TIMEOUT: 5e3, SHOW_REPORT_INVOKER_LOG: !1, SHOW_REPORT_USER_INVOKER_LOG: !0, JOIN_EXTEND: "", PUB_EXTEND: "", SUB_EXTEND: "", FORCE_TURN: !1, TURN_ENABLE_TCP: !0, TURN_ENABLE_UDP: !0, MAX_UPLOAD_CACHE: 50, UPLOAD_CACHE_INTERVAL: 2e3, AJAX_REQUEST_CONCURRENT: 3, REPORT_APP_SCENARIO: void 0, GATEWAY_DOMAINS: ["edge.agora.io", "edge.sd-rtn.com"], CONNECT_GATEWAY_WITHOUT_DOMAIN: !1, WORKER_DOMAIN: "edge.agora.io", TURN_DOMAIN: "edge.agora.io", EVENT_REPORT_RETRY: !0, CHROME_FORCE_PLAN_B: !1, AUDIO_SOURCE_VOLUME_UPDATE_INTERVAL: 400, AUDIO_SOURCE_AVG_VOLUME_DURATION: 3e3, AUDIO_VOLUME_INDICATION_INTERVAL: 2e3, VOLUME_VOICE_WEIGHT: 10, GET_VOLUME_OF_MUTED_AUDIO_TRACK: !1, STATS_UPDATE_INTERVAL: 250, NORMAL_EVENT_QUEUE_CAPACITY: 100, CUSTOM_REPORT: !0, CUSTOM_REPORT_LIMIT: 20, PROXY_SERVER_TYPE2: "webnginx-proxy.agora.io", PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy.sd-rtn.com", "webrtc-cloud-proxy.agora.io"], CUSTOM_PUB_ANSWER_MODIFIER: null, CUSTOM_SUB_ANSWER_MODIFIER: null, CUSTOM_PUB_OFFER_MODIFIER: null, CUSTOM_SUB_OFFER_MODIFIER: null, DSCP_TYPE: "high", REMOVE_NEW_CODECS: !0, FRAGEMENT_LENGTH: 3, WEBSOCKET_COMPRESS: !1, SIMULCAST: !1, PRELOAD_MEDIA_COUNT: 0, CHECK_VIDEO_VISIBLE_INTERVAL: 3e4, CHECK_LOCAL_STATS_INTERVAL: 250, PROFILE_SWITCH_INTERVAL: 2e3, UNSUPPORTED_VIDEO_CODEC: [], ENUMERATE_DEVICES_INTERVAL: !1, ENUMERATE_DEVICES_INTERVAL_TIME: 1e4, USE_NEW_TOKEN: !1, CLOSE_AFB_FOR_LOCAL_AP: !0, JOIN_MAX_CONCURRENCY: 6, JOIN_WITH_FALLBACK_SIGNAL_PROXY: !0, JOIN_WITH_FALLBACK_MEDIA_PROXY: !0, JOIN_WITH_FALLBACK_MEDIA_PROXY_FORCE: !1, JOIN_GATEWAY_TRY_443PORT_DURATION: 2e3, JOIN_GATEWAY_USE_443PORT_ONLY: !1, JOIN_GATEWAY_USE_DUAL_DOMAIN: !0, JOIN_GATEWAY_FALLBACK_PORT: 443, USE_TURN_SERVER_OF_GATEWAY: !1, H264_PROFILE_LEVEL_ID: "", USE_NEW_LOG: !1, LOG_VERSION: 3, MEDIA_DEVICE_CONSTRAINTS: null, ENCRYPT_PROXY_USERNAME_AND_PSW: !0, SDP_LOGGING: !1, CSP_DETECTED_HOSTNAME_LIST: ["agora.io", "sd-rtn.com"], REMOTE_AUDIO_TRACK_USES_WEB_AUDIO: !1, LOCAL_AUDIO_TRACK_USES_WEB_AUDIO: !1, BITRATE_ADAPTER_TYPE: "STANDARD_BITRATE", AI_DENOISER_PARAMETERS: { excludedLinks: [] }, ADJUST_3A_FROM_PLUGINS: !0, RAISE_H264_BASELINE_PRIORITY: !0, FILTER_SEND_H264_BASELINE: !1, FIRST_H264_PROFILE_LEVEL_ID: "42001f", FIRST_PACKETIZATION_MODE: "", X_GOOGLE_START_BITRATE: void 0, NEW_REPORT_SERVER: !1, NEW_REPORT_SERVER_DOMAINS: ["data-reporting.agora.io", "data-reporting.agora.io"], VIDEO_INSPECT_WORKER_MESSAGE_LENGTH_LIMIT: 3e5, VIDEO_INSPECT_INTERVAL_MINIMUM: 1e3, VIDEO_INSPECT_QUALITY_RATIO: 0.9, VIDEO_INSPECT_WORKER_MANAGER_HOST: "edge.agora.io", VIDEO_INSPECT_WORKER_MANAGER_PORT: "", VIDEO_INSPECT_WORKER_PORT: "", SHOW_VIDEO_INSPECT_WORKER_MESSAGE: !1, STATS_COLLECTOR_PORT: 443, FORCE_TURN_TCP: !1, WEBAUDIO_INIT_OPTIONS: void 0, FILTER_VIDEO_FEC: !0, FILTER_AUDIO_FEC: !1, CHROME_DUAL_STREAM_USE_ENCODING: !0, DISABLE_DUAL_STREAM_USE_ENCODING: !1, EXTENSION_USAGE_UPLOAD_INTERVAL: 1e4, ICE_RESTART: !0, ICE_RESTART_INTERVAL: 1e4, NEW_ICE_RESTART: !1, TRANSMITTER_INITIAL_RTT: 30, TRANSMITTER_INITIAL_RTO: 30, TRANSMITTER_MAX_BATCH_ACK_COUNT: 2, TRANSMITTER_MAX_RTO: 500, DATACHANNEL_COMPRESS: !1, FINGERPRINT: null, DC_JOIN_WITH_FAILBACK: 5e3, ENABLE_VIDEO_FRAME_CALLBACK: !0, VIDEO_FREEZE_DURATION: 500, SPATIALIZER_PARAMETERS: {}, UPLOAD_LOG_INTERVAL: 3e3, UPLOAD_LOG_REQUEST_RETRY_INTERVAL: 2e3, UPLOAD_LOG_REQUEST_MAX_RETRY_INTERVAL: 2e4, UPLOAD_LOG_TRY_INTERVAL_WHILE_OFF: 5e3, UPLOAD_LOG_RETRY_INTERVAL_V1: 1e4, UPLOAD_LOG_TWICE_RETRY_INTERVAL_V1: 200, UPLOAD_LOG_LENGTH_EACH_TIME: 10, APP_TYPE: 0, DISABLE_WEBAUDIO: !1, CHANNEL_MEDIA_RELAY_SERVERS: void 0, KEEP_LAST_FRAME: !0, FORWARD_P2P_CREATION: !0, SYNC_GROUP: !0, BLOCK_LOCAL_CLIENT: !1, AP_AREA: !0, ENABLE_ENCODED_TRANSFORM: !1, ENABLE_VIDEO_SEI: !1, IMAGE_MODERATION_WORKER_HOST: "edge.agora.io", IMAGE_MODERATION_WORKER_MESSAGE_LENGTH_LIMIT: 3e5, IMAGE_MODERATION_INTERVAL_MINIMUM: 1e3, SHOW_IMAGE_MODERATION_WORKER_MESSAGE: !1, IMAGE_MODERATION_QUALITY_RATIO: 0.9, IMAGE_MODERATION_UPLOAD_REPORT_INTERVAL: 5e3, SHOW_GLOBAL_CLIENT_LIST: !1, DATASTREAM_MAX_RETRANSMITS: 10, TCP_CANDIDATE_ONLY: !1, EXTERNAL_SIGNAL_REQUEST_TIMEOUT: 3e3, SHOW_P2P_LOG: !1, MAX_P2P_TIMEOUT: 3e4, P2P_TOKEN_INTERVAL: 1e3, SHOW_DATASTREAM2_LOG: !1, RESTRICTION_SET_PLAYBACK_DEVICE: !0, USE_PURE_ENCRYPTION_MASTER_KEY: !1, ACCOUNT_REGISTER_RETRY_TIMEOUT: 1, ACCOUNT_REGISTER_RETRY_RATIO: 2, ACCOUNT_REGISTER_RETRY_TIMEOUT_MAX: 6e4, ACCOUNT_REGISTER_RETRY_COUNT_MAX: 1e5, AUDIO_CONTEXT: null, WEBCS_BACKUP_CONNECT_TIMEOUT: 6e3, PLAYER_STATE_DEFER: 2e3, SIGNAL_REQUEST_WATCH_INTERVAL: 1e3, FILEPATH_LENMAX: 255, DUALSTREAM_OPERATION_CHECK: !0, MEDIA_ELEMENT_EXISTS_DEPTH: 3, SHIM_CANDIDATE: !1, LEAVE_MSG_TIMEOUT: 2e3, STATS_FILTER: { transportId: !0, googTrackId: !0 }, FILTER_VIDEO_CODEC: [], USE_NEW_NETWORK_CONFIG: !1, AUTO_RESET_AUDIO_ROUTE: !1, PLUGIN_INFO: [], OVERUSE_DETECTOR_PARAMS: WS, ENABLE_AG_ADAPTATION: !0, FORCE_AG_HIGH_FRAMERATE: !1, FORCE_SUPPORT_AG_ADAPTATION: !1, CUSTOM_ADAPTATION_DEFAULT_MODE: "", ENCODER_CONFIG_LIMIT: {}, CAMERA_CAPTURE_CONFIG: void 0, HIDE_NO_POSTER: !1, AP_CACHE_NUM: 10, AP_UPDATE_INTERVAL: 12e4, AP_CACHE_LIFETIME: 12e4, MAX_PRELOAD_ASYNC_LENGTH: 3, ENABLE_PRELOAD: !0, DISABLE_SCREEN_SHARE_REMB: !1 }, { ENABLE_PUBLISHED_USER_LIST: !0, MAX_SUBSCRIPTION: 50, SUBSCRIBE_AUDIO_FILTER_TOPN: void 0, ENABLE_PUBLISH_AUDIO_FILTER: void 0, ENABLE_USER_LICENSE_CHECK: !0, USE_PUB_RTX: !0, USE_SUB_RTX: !0, DISABLE_FEC: void 0, ENABLE_NTP_REPORT: !1, ENABLE_INSTANT_VIDEO: !1, ENABLE_DATASTREAM_2: !1, ENABLE_USER_AUTO_REBALANCE_CHECK: !0, USE_XR: !0, ENABLE_LOSSBASED_BWE: !0, ENABLE_AUT_CC: !1, ENABLE_CC_FALLBACK: void 0, ENABLE_PREALLOC_PC: !1, SUBSCRIBE_TWCC: !0, PUBLISH_TWCC: !1, ENABLE_SVC: !1, ENABLE_SVC_DEFAULT_CODECS: ["H264", "VP8", "VP9", "AV1"], SVC: [], ENABLE_FULL_LINK_AV_SYNC: !1, SVC_MODE: null, PRE_SUB_NUM: 2, ENABLE_PRE_SUB: !1, ENABLE_AUT_FEEDBACK: !1, SVC_EXTENDED: ["VP9"] }), {}, { USE_CANDIDATE_FROM_AP_DETAIL: !1, AP_REQUEST_DETAIL: void 0, ENABLE_ROLE_SELECT_EDGE: !1, CLIENT_ROLE_OPTIONS: void 0, RESTART_SEQUENCE: ["udp_tcp_relay", "relay"], COMPATIBLE_SDP_EXTENSION: ["gdpr_forbidden"], LIMIT_BITRATE: void 0, EXPERIMENTS: {} });
    function Dr(e, n, i) {
      var o, f, T;
      on(o = Object.keys(ai)).call(o, e) && (!i && on(f = Object.keys(ud)).call(f, e) || (ai[e] = n, e === "ENABLE_VIDEO_SEI" && n === !0 && (ai.ENABLE_ENCODED_TRANSFORM = !0), e === "USE_NEW_NETWORK_CONFIG" && n && (T = !!n, ai.USE_NEW_NETWORK_CONFIG = T, T && (ai.WEBCS_DOMAIN = ["webrtc2-2.ap.sd-rtn.com"], ai.WEBCS_DOMAIN_BACKUP_LIST = ["webrtc2-4.ap.sd-rtn.com"], ai.CDS_AP = ["cds-web-2.ap.sd-rtn.com", "cds-web-4.ap.sd-rtn.com"], ai.ACCOUNT_REGISTER = ["sua-web-2.ap.sd-rtn.com", "sua-web-4.ap.sd-rtn.com"], ai.EVENT_REPORT_DOMAIN = "web-2.statscollector.sd-rtn.com", ai.EVENT_REPORT_BACKUP_DOMAIN = "statscollector-1.agora.io", ai.GATEWAY_DOMAINS = ["edge.sd-rtn.com"])), e === "ENABLE_PRE_SUB" && n && (ai.ENABLE_INSTANT_VIDEO = !0, ai.ENABLE_PREALLOC_PC = !0), e === "ENABLE_SVC" && n && (ai.ENABLE_AUT_CC = !0)));
    }
    function ft(e) {
      return ai[e];
    }
    XS || (ai.WEBCS_DOMAIN = ["ap-web-1-oversea.agora.io", "ap-web-1-north-america.agora.io"], ai.WEBCS_DOMAIN_BACKUP_LIST = ["ap-web-2-oversea.agora.io", "ap-web-2-north-america.agora.io"], ai.PROXY_CS = ["proxy-ap-web-oversea.agora.io", "proxy-ap-web-america.agora.io"], ai.CDS_AP = ["cds-ap-web-oversea.agora.io", "cds-ap-web-america.agora.io", "cds-ap-web-america2.agora.io"], ai.ACCOUNT_REGISTER = ["sua-ap-web-oversea.agora.io", "sua-ap-web-america.agora.io", "sua-ap-web-america2.agora.io"], ai.UAP_AP = ["uap-ap-web-oversea.agora.io", "uap-ap-web-america.agora.io", "uap-ap-web-america2.agora.io"], ai.LOG_UPLOAD_SERVER = "logservice-oversea.agora.io", ai.EVENT_REPORT_DOMAIN = "statscollector-1-oversea.agora.io", ai.EVENT_REPORT_BACKUP_DOMAIN = "statscollector-2-oversea.agora.io", ai.PROXY_SERVER_TYPE3 = "webrtc-cloud-proxy.agora.io", ai.AREAS = ["NORTH_AMERICA", "OVERSEA"]);
    const ud = {};
    var tr = function(e) {
      return e.SET_SESSION_ID = "SET_SESSION_ID", e.SET_P2P_ID = "SET_P2P_id", e.SET_DC_ID = "SET_DC_id", e.SET_UID = "SET_UID", e.SET_INT_UID = "SET_INT_UID", e.SET_PUB_ID = "SET_PUB_ID", e.SET_CLOUD_PROXY_SERVER_MODE = "SET_CLOUD_PROXY_SERVER_MODE", e.KEY_METRIC_CLIENT_CREATED = "KEY_METRIC_CLIENT_CREATED", e.KEY_METRIC_JOIN_START = "KEY_METRIC_JOIN_START", e.AVOID_JOIN_START = "AVOID_JOIN_START", e.KEY_METRIC_JOIN_END = "KEY_METRIC_JOIN_END", e.KEY_METRIC_REQUEST_AP_START = "KEY_METRIC_REQUEST_AP_START", e.KEY_METRIC_REQUEST_AP_END = "KEY_METRIC_REQUEST_AP_END", e.KEY_METRIC_JOIN_GATEWAY_START = "KEY_METRIC_JOIN_GATEWAY_START", e.KEY_METRIC_JOIN_GATEWAY_END = "KEY_METRIC_JOIN_GATEWAY_END", e.KEY_METRIC_PEER_CONNECTION_START = "KEY_METRIC_PEER_CONNECTION_START", e.KEY_METRIC_PEER_CONNECTION_END = "KEY_METRIC_PEER_CONNECTION_END", e.KEY_METRIC_DESCRIPTION_START = "KEY_METRIC_DESCRIPTION_START", e.KEY_METRIC_ICE_CONNECTION_END = "KEY_METRIC_ICE_CONNECTION_END", e.KEY_METRIC_SIGNAL_CHANNEL_OPEN = "KEY_METRIC_SIGNAL_CHANNEL_OPEN", e.KEY_METRIC_PUBLISH = "KEY_METRIC_PUBLISH", e.KEY_METRIC_SUBSCRIBE = "KEY_METRIC_SUBSCRIBE", e.RECORD_JOIN_CHANNEL_SERVICE = "RECORD_JOIN_CHANNEL_SERVICE", e.RESET_JOIN_CHANNEL_SERVICE_RECORDS = "RESET_JOIN_CHANNEL_SERVICE_RECORDS", e.RESET_KEY_METRICS = "RESET_KEY_METRICS", e.SET_USE_P2P = "SET_USE_P2P", e.SET_TRANSPORT_TYPE = "SET_TRANSPORT_TYPE", e;
    }(tr || {});
    let mT = function(e) {
      return e.h264 = "h264", e.h265 = "h265", e.vp8 = "vp8", e.vp9 = "vp9", e.av1 = "av1", e;
    }({});
    (function(e) {
      e.opus = "opus", e.pcma = "pcma", e.pcmu = "pcmu", e.g722 = "g722";
    })({});
    const A5 = 128, Wie = 96, O5 = 1e3, ap = 10;
    let qie = 0;
    var C5 = (() => {
      var e = { 8: (o, f, T) => {
        T.r(f), T.d(f, { Parser: () => fn, Printer: () => Ai, parse: () => sn, print: () => An });
        const A = `
`, R = "".concat("\r").concat(A), P = " ";
        let L;
        function z(Jt) {
          return Jt >= "0" && Jt <= "9";
        }
        function Y(Jt) {
          return Jt >= "!" && Jt <= "~";
        }
        function te(Jt) {
          return Y(Jt) || Jt >= "" && Jt <= "ÿ";
        }
        function oe(Jt) {
          return Jt === "!" || Jt >= "#" && Jt <= "'" || Jt >= "*" && Jt <= "+" || Jt >= "-" && Jt <= "." || Jt >= "0" && Jt <= "9" || Jt >= "A" && Jt <= "Z" || Jt >= "^" && Jt <= "~";
        }
        function He(Jt) {
          return Jt >= "1" && Jt <= "9";
        }
        function Re(Jt) {
          return Jt >= "A" && Jt <= "Z" || Jt >= "a" && Jt <= "z";
        }
        function De(Jt) {
          return Jt === "d" || Jt === "h" || Jt === "m" || Jt === "s";
        }
        function Xe(Jt) {
          return Jt > "" && Jt < "	" || Jt > "\v" && Jt < "\f" || Jt > "" && Jt < "ÿ";
        }
        function We(Jt) {
          return Re(Jt) || z(Jt) || Jt === "+" || Jt === "/";
        }
        function mt(Jt) {
          return z(Jt) || Re(Jt) || Jt === "+" || Jt === "/" || Jt === "-" || Jt === "_";
        }
        function Pt(Jt) {
          return Re(Jt) || z(Jt) || Jt === "+" || Jt === "/";
        }
        function xt(Jt, Ae) {
          var ct = Object.keys(Jt);
          if (Object.getOwnPropertySymbols) {
            var vt = Object.getOwnPropertySymbols(Jt);
            Ae && (vt = vt.filter(function(en) {
              return Object.getOwnPropertyDescriptor(Jt, en).enumerable;
            })), ct.push.apply(ct, vt);
          }
          return ct;
        }
        function Nt(Jt) {
          for (var Ae = 1; Ae < arguments.length; Ae++) {
            var ct = arguments[Ae] != null ? arguments[Ae] : {};
            Ae % 2 ? xt(Object(ct), !0).forEach(function(vt) {
              Vt(Jt, vt, ct[vt]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Jt, Object.getOwnPropertyDescriptors(ct)) : xt(Object(ct)).forEach(function(vt) {
              Object.defineProperty(Jt, vt, Object.getOwnPropertyDescriptor(ct, vt));
            });
          }
          return Jt;
        }
        function Vt(Jt, Ae, ct) {
          return Ae in Jt ? Object.defineProperty(Jt, Ae, { value: ct, enumerable: !0, configurable: !0, writable: !0 }) : Jt[Ae] = ct, Jt;
        }
        (function(Jt) {
          Jt.VERSION = "v", Jt.ORIGIN = "o", Jt.SESSION_NAME = "s", Jt.INFORMATION = "i", Jt.URI = "u", Jt.EMAIL = "e", Jt.PHONE = "p", Jt.CONNECTION = "c", Jt.BANDWIDTH = "b", Jt.TIME = "t", Jt.REPEAT = "r", Jt.ZONE_ADJUSTMENTS = "z", Jt.KEY = "k", Jt.ATTRIBUTE = "a", Jt.MEDIA = "m";
        })(L || (L = {}));
        class nn {
          consumeText(Ae, ct) {
            let vt = ct;
            for (; vt < Ae.length; ) {
              const en = Ae[vt];
              if (en === "\0" || en === "\r" || en === A) break;
              vt += 1;
            }
            if (vt - ct == 0) throw new Error("Invalid text, at ".concat(Ae));
            return vt;
          }
          consumeUnicastAddress(Ae, ct, vt) {
            return this.consumeTill(Ae, ct, P);
          }
          consumeOneOrMore(Ae, ct, vt) {
            let en = ct;
            for (; vt(Ae[en]); ) en++;
            if (en - ct == 0) throw new Error("Invalid rule at ".concat(ct, "."));
            return en;
          }
          consumeSpace(Ae, ct) {
            if (Ae[ct] === P) return ct + 1;
            throw new Error("Invalid space at ".concat(ct, "."));
          }
          consumeIP4Address(Ae, ct) {
            let vt = ct;
            for (let en = 0; en < 4; en++) if (vt = this.consumeDecimalUChar(Ae, vt), en !== 3) {
              if (Ae[vt] !== ".") throw new Error("Invalid IP4 address.");
              vt++;
            }
            return vt;
          }
          consumeDecimalUChar(Ae, ct) {
            let vt = ct;
            for (let Bn = 0; Bn < 3 && z(Ae[vt]); Bn++, vt++) ;
            if (vt - ct == 0) throw new Error("Invalid decimal uchar.");
            const en = parseInt(Ae.slice(ct, vt));
            if (en >= 0 && en <= 255) return vt;
            throw new Error("Invalid decimal uchar");
          }
          consumeIP6Address(Ae, ct) {
            let vt = this.consumeHexpart(Ae, ct);
            return Ae[vt] === ":" && (vt += 1, vt = this.consumeIP4Address(Ae, vt)), vt;
          }
          consumeHexpart(Ae, ct) {
            let vt = ct;
            if (Ae[vt] === ":" && Ae[vt + 1] === ":") {
              vt += 2;
              try {
                vt = this.consumeHexseq(Ae, vt);
              } catch {
              }
              return vt;
            }
            if (vt = this.consumeHexseq(Ae, vt), Ae[vt] === ":" && Ae[vt + 1] === ":") {
              vt += 2;
              try {
                vt = this.consumeHexseq(Ae, vt);
              } catch {
              }
              return vt;
            }
            return vt;
          }
          consumeHexseq(Ae, ct) {
            let vt = ct;
            for (; vt = this.consumeHex4(Ae, vt), Ae[vt] === ":" && Ae[vt + 1] !== ":"; ) vt += 1;
            return vt;
          }
          consumeHex4(Ae, ct) {
            let vt = 0;
            for (; vt < 4; vt++) if (!((en = Ae[ct + vt]) >= "0" && en <= "9" || en >= "a" && en <= "f" || en >= "A" && en <= "F")) {
              if (vt === 0) throw new Error("Invalid hex 4");
              break;
            }
            var en;
            return ct + vt;
          }
          consumeFQDN(Ae, ct) {
            let vt = ct;
            for (; z(Ae[vt]) || Re(Ae[vt]) || Ae[vt] === "-" || Ae[vt] === "."; ) vt += 1;
            if (vt - ct < 4) throw new Error("Invalid FQDN");
            return vt;
          }
          consumeExtnAddr(Ae, ct) {
            return this.consumeOneOrMore(Ae, ct, te);
          }
          consumeMulticastAddress(Ae, ct, vt) {
            switch (vt) {
              case "IP4":
              case "ip4":
                return this.consumeIP4MulticastAddress(Ae, ct);
              case "IP6":
              case "ip6":
                return this.consumeIP6MulticastAddress(Ae, ct);
              default:
                try {
                  return this.consumeFQDN(Ae, ct);
                } catch {
                  return this.consumeExtnAddr(Ae, ct);
                }
            }
          }
          consumeIP6MulticastAddress(Ae, ct) {
            const vt = this.consumeHexpart(Ae, ct);
            return Ae[vt] === "/" ? this.consumeInteger(Ae, vt + 1) : vt;
          }
          consumeIP4MulticastAddress(Ae, ct) {
            let vt = ct + 3;
            const en = Ae.slice(ct, vt), Bn = parseInt(en);
            if (Bn < 224 || Bn > 239) throw new Error("Invalid IP4 multicast address, IPv4 multicast addresses may be in the range 224.0.0.0 to 239.255.255.255.");
            for (let Mr = 0; Mr < 3; Mr++) {
              if (Ae[vt] !== ".") throw new Error("Invalid IP4 multicast address.");
              vt += 1, vt = this.consumeDecimalUChar(Ae, vt);
            }
            return Ae[vt] === "/" && (vt += 1), vt = this.consumeTTL(Ae, vt), Ae[vt] === "/" && (vt = this.consumeInteger(Ae, vt)), vt;
          }
          consumeInteger(Ae, ct) {
            if (!He(Ae[ct])) throw new Error("Invalid integer.");
            for (ct += 1; z(Ae[ct]); ) ct += 1;
            return ct;
          }
          consumeTTL(Ae, ct) {
            if (Ae[ct] === "0") return ct + 1;
            if (!He(Ae[ct])) throw new Error("Invalid TTL.");
            ct += 1;
            for (let vt = 0; vt < 2 && z(Ae[ct]); vt++) ct += 1;
            return ct;
          }
          consumeToken(Ae, ct) {
            return this.consumeOneOrMore(Ae, ct, oe);
          }
          consumeTime(Ae, ct) {
            let vt = ct;
            if (Ae[vt] === "0") return vt + 1;
            for (He(Ae[vt]) && (vt += 1); z(Ae[vt]); ) vt++;
            if (vt - ct < 10) throw new Error("Invalid time");
            return vt;
          }
          consumeAddress(Ae, ct) {
            return this.consumeTill(Ae, ct, P);
          }
          consumeTypedTime(Ae, ct) {
            let vt = ct;
            return vt = this.consumeOneOrMore(Ae, vt, z), De(Ae[vt]) ? vt + 1 : vt;
          }
          consumeRepeatInterval(Ae, ct) {
            if (!He(Ae[ct])) throw new Error("Invalid repeat interval");
            for (ct += 1; z(Ae[ct]); ) ct += 1;
            return De(Ae[ct]) && (ct += 1), ct;
          }
          consumePort(Ae, ct) {
            return this.consumeOneOrMore(Ae, ct, z);
          }
          consume(Ae, ct, vt) {
            for (let en = 0; en < vt.length; en++) {
              if (ct + en >= Ae.length) throw new Error("consume exceeding value length");
              if (Ae[ct + en] !== vt[en]) throw new Error("consume ".concat(vt, " failed at ").concat(en));
            }
            return ct + vt.length;
          }
          consumeTill(Ae, ct, vt) {
            let en = ct;
            for (; en < Ae.length && (typeof vt != "string" || Ae[en] !== vt) && (typeof vt != "function" || !vt(Ae[en])); ) en++;
            return en;
          }
        }
        class fn extends nn {
          constructor() {
            super(), Vt(this, "records", []), Vt(this, "currentLine", 0);
          }
          parse(Ae) {
            const ct = this.probeEOL(Ae);
            this.records = Ae.split(ct).filter((Vf) => !!Ys(Vf).call(Vf)).map(this.parseLine), this.currentLine = 0;
            const vt = this.parseVersion(), en = this.parseOrigin(), Bn = this.parseSessionName(), Mr = this.parseInformation(), rs = this.parseUri(), wa = this.parseEmail(), bd = this.parsePhone(), Gf = this.parseConnection(), Ey = this.parseBandWidth(), T0 = this.parseTimeFields(), b0 = this.parseKey(), Mo = this.parseSessionAttribute(), yl = this.parseMediaDescription();
            if (this.currentLine !== this.records.length) throw new Error("parsing failed, non exhaustive sdp lines.");
            return { version: vt, origin: en, sessionName: Bn, information: Mr, uri: rs, emails: wa, phones: bd, connection: Gf, bandwidths: Ey, timeFields: T0, key: b0, attributes: Mo, mediaDescriptions: yl };
          }
          getCurrentRecord() {
            const Ae = this.records[this.currentLine];
            if (!Ae) throw new Error("Record doesn't exit.");
            return Ae;
          }
          probeEOL(Ae) {
            for (let ct = 0; ct < Ae.length; ct++) if (Ae[ct] === A) return Ae[ct - 1] === "\r" ? R : A;
            throw new Error("Invalid newline character.");
          }
          parseLine(Ae, ct) {
            if (Ae.length < 2) throw new Error("Invalid sdp line, sdp line should be of form <type>=<value>.");
            const vt = Ae[0];
            if (Ae[1] !== "=") throw new Error('Invalid sdp line, <type> should be a single character followed by an "=" sign.');
            return { type: vt, value: Ae.slice(2), line: ct, cur: 0 };
          }
          parseSessionAttribute() {
            const Ae = new ir();
            for (; this.currentLine < this.records.length; ) {
              const ct = this.getCurrentRecord();
              if (ct.type !== L.ATTRIBUTE) break;
              const vt = { attField: this.extractOneOrMore(ct, (en) => oe(en) && en !== ":"), _cur: 0 };
              ct.value[ct.cur] === ":" && (ct.cur += 1, vt.attValue = this.extractOneOrMore(ct, Xe)), Ae.parse(vt), this.currentLine++;
            }
            return Ae.digest();
          }
          parseMediaAttributes(Ae) {
            const ct = new sr(Ae);
            for (; this.currentLine < this.records.length; ) {
              const vt = this.getCurrentRecord();
              if (vt.type !== L.ATTRIBUTE) break;
              const en = { attField: this.extractOneOrMore(vt, (Bn) => oe(Bn) && Bn !== ":"), _cur: 0 };
              vt.value[vt.cur] === ":" && (vt.cur += 1, en.attValue = this.extractOneOrMore(vt, Xe)), ct.parse(en), this.currentLine++;
            }
            return ct.digest();
          }
          parseKey() {
            const Ae = this.getCurrentRecord();
            if (Ae.type === L.KEY) {
              if (Ae.value === "prompt" || Ae.value === "clear:" || Ae.value === "base64:" || Ae.value === "uri:") return Ae.value;
              throw this.currentLine++, new Error("Invalid key.");
            }
          }
          parseZone() {
            const Ae = this.getCurrentRecord();
            if (Ae.type === L.ZONE_ADJUSTMENTS) {
              const ct = [];
              for (; ; ) try {
                const vt = this.extract(Ae, this.consumeTime);
                this.consumeSpaceForRecord(Ae);
                let en = !1;
                Ae.value[Ae.cur] === "-" && (en = !0, Ae.cur += 1);
                const Bn = this.extract(Ae, this.consumeTypedTime);
                ct.push({ time: vt, typedTime: Bn, back: en });
              } catch {
                break;
              }
              if (ct.length === 0) throw new Error("Invalid zone adjustments");
              return this.currentLine++, ct;
            }
            return [];
          }
          parseRepeat() {
            const Ae = [];
            for (; ; ) {
              const ct = this.getCurrentRecord();
              if (ct.type !== L.REPEAT) break;
              {
                const vt = this.extract(ct, this.consumeRepeatInterval), en = this.parseTypedTime(ct);
                Ae.push({ repeatInterval: vt, typedTimes: en }), this.currentLine++;
              }
            }
            return Ae;
          }
          parseTypedTime(Ae) {
            const ct = [];
            for (; ; ) try {
              this.consumeSpaceForRecord(Ae), ct.push(this.extract(Ae, this.consumeTypedTime));
            } catch {
              break;
            }
            if (ct.length === 0) throw new Error("Invalid typed time.");
            return ct;
          }
          parseTime() {
            const Ae = this.getCurrentRecord(), ct = this.extract(Ae, this.consumeTime);
            this.consumeSpaceForRecord(Ae);
            const vt = this.extract(Ae, this.consumeTime);
            return this.currentLine++, { startTime: ct, stopTime: vt };
          }
          parseBandWidth() {
            const Ae = [];
            for (; this.currentLine < this.records.length; ) {
              const ct = this.getCurrentRecord();
              if (ct.type !== L.BANDWIDTH) break;
              {
                const vt = this.extractOneOrMore(ct, oe);
                if (ct.value[ct.cur] !== ":") throw new Error("Invalid bandwidth field.");
                ct.cur++;
                const en = this.extractOneOrMore(ct, z);
                Ae.push({ bwtype: vt, bandwidth: en }), this.currentLine++;
              }
            }
            return Ae;
          }
          parseVersion() {
            const Ae = this.getCurrentRecord();
            if (Ae.type !== L.VERSION) throw new Error("first sdp record must be version");
            const ct = Ae.value.slice(0, this.consumeOneOrMore(Ae.value, 0, z));
            if (ct.length !== Ae.value.length) throw new Error('invalid proto version, "v='.concat(Ae.value, '"'));
            return this.currentLine++, ct;
          }
          parseOrigin() {
            const Ae = this.getCurrentRecord();
            if (Ae.type !== L.ORIGIN) throw new Error("second line of sdp must be origin");
            const ct = this.extractOneOrMore(Ae, te);
            this.consumeSpaceForRecord(Ae);
            const vt = this.extractOneOrMore(Ae, z);
            this.consumeSpaceForRecord(Ae);
            const en = this.extractOneOrMore(Ae, z);
            this.consumeSpaceForRecord(Ae);
            const Bn = this.extractOneOrMore(Ae, oe);
            this.consumeSpaceForRecord(Ae);
            const Mr = this.extractOneOrMore(Ae, oe);
            this.consumeSpaceForRecord(Ae);
            const rs = this.extract(Ae, this.consumeUnicastAddress);
            return this.currentLine++, { username: ct, sessId: vt, sessVersion: en, nettype: Bn, addrtype: Mr, unicastAddress: rs };
          }
          parseSessionName() {
            const Ae = this.getCurrentRecord();
            if (Ae.type === L.SESSION_NAME) {
              const ct = this.extract(Ae, this.consumeText);
              return this.currentLine++, ct;
            }
          }
          parseInformation() {
            const Ae = this.getCurrentRecord();
            if (Ae.type !== L.INFORMATION) return;
            const ct = this.extract(Ae, this.consumeText);
            return this.currentLine++, ct;
          }
          parseUri() {
            const Ae = this.getCurrentRecord();
            if (Ae.type === L.URI) return this.currentLine++, Ae.value;
          }
          parseEmail() {
            const Ae = [];
            for (; ; ) {
              const ct = this.getCurrentRecord();
              if (ct.type !== L.EMAIL) break;
              Ae.push(ct.value), this.currentLine++;
            }
            return Ae;
          }
          parsePhone() {
            const Ae = [];
            for (; ; ) {
              const ct = this.getCurrentRecord();
              if (ct.type !== L.PHONE) break;
              Ae.push(ct.value), this.currentLine++;
            }
            return Ae;
          }
          parseConnection() {
            const Ae = this.getCurrentRecord();
            if (Ae.type === L.CONNECTION) {
              const ct = this.extractOneOrMore(Ae, oe);
              this.consumeSpaceForRecord(Ae);
              const vt = this.extractOneOrMore(Ae, oe);
              this.consumeSpaceForRecord(Ae);
              const en = this.extract(Ae, this.consumeAddress);
              return this.currentLine++, { nettype: ct, addrtype: vt, address: en };
            }
          }
          parseMedia() {
            const Ae = this.getCurrentRecord(), ct = this.extract(Ae, this.consumeToken);
            this.consumeSpaceForRecord(Ae);
            let vt = this.extract(Ae, this.consumePort);
            Ae.value[Ae.cur] === "/" && (Ae.cur += 1, vt += this.extract(Ae, this.consumeInteger)), this.consumeSpaceForRecord(Ae);
            const en = [];
            for (en.push(this.extract(Ae, this.consumeToken)); Ae.value[Ae.cur] === "/"; ) Ae.cur += 1, en.push(this.extract(Ae, this.consumeToken));
            if (en.length === 0) throw new Error("Invalid proto");
            const Bn = this.parseFmt(Ae);
            return this.currentLine++, { mediaType: ct, port: vt, protos: en, fmts: Bn };
          }
          parseTimeFields() {
            const Ae = [];
            for (; this.getCurrentRecord().type === L.TIME; ) {
              const ct = this.parseTime(), vt = this.parseRepeat(), en = this.parseZone();
              Ae.push({ time: ct, repeats: vt, zones: en });
            }
            return Ae;
          }
          parseMediaDescription() {
            const Ae = [];
            for (; this.currentLine < this.records.length && this.getCurrentRecord().type === L.MEDIA; ) {
              const ct = this.parseMedia(), vt = this.parseInformation(), en = this.parseConnections(), Bn = this.parseBandWidth(), Mr = this.parseKey(), rs = this.parseMediaAttributes(ct);
              Ae.push({ media: ct, information: vt, connections: en, bandwidths: Bn, key: Mr, attributes: rs });
            }
            return Ae;
          }
          parseConnections() {
            const Ae = [];
            for (; this.currentLine < this.records.length && this.getCurrentRecord().type === L.CONNECTION; ) Ae.push(this.parseConnection());
            return Ae;
          }
          parseFmt(Ae) {
            const ct = [];
            for (; ; ) try {
              this.consumeSpaceForRecord(Ae), ct.push(this.extract(Ae, this.consumeToken));
            } catch {
              break;
            }
            if (ct.length === 0) throw new Error("Invalid fmts");
            return ct;
          }
          extract(Ae, ct) {
            for (var vt = arguments.length, en = new Array(vt > 2 ? vt - 2 : 0), Bn = 2; Bn < vt; Bn++) en[Bn - 2] = arguments[Bn];
            const Mr = ct.call(this, Ae.value, Ae.cur, ...en), rs = Ae.value.slice(Ae.cur, Mr);
            return Ae.cur = Mr, rs;
          }
          extractOneOrMore(Ae, ct) {
            const vt = this.consumeOneOrMore(Ae.value, Ae.cur, ct), en = Ae.value.slice(Ae.cur, vt);
            return Ae.cur = vt, en;
          }
          consumeSpaceForRecord(Ae) {
            if (Ae.value[Ae.cur] !== P) throw new Error("Invalid space at ".concat(Ae.cur, "."));
            Ae.cur += 1;
          }
        }
        class hn extends nn {
          constructor() {
            super(...arguments), Vt(this, "attributes", void 0), Vt(this, "digested", !1);
          }
          extractOneOrMore(Ae, ct, vt) {
            const en = this.consumeOneOrMore(Ae.attValue, Ae._cur, ct), Bn = Ae.attValue.slice(Ae._cur, en), [Mr, rs] = vt || [];
            if (typeof Mr == "number" && Bn.length < Mr) throw new Error("error in length, should be more or equal than ".concat(Mr, " characters."));
            if (typeof rs == "number" && Bn.length > rs) throw new Error("error in length, should be less or equal than ".concat(rs, " characters."));
            return Ae._cur = en, Bn;
          }
          consumeAttributeSpace(Ae) {
            if (Ae.attValue[Ae._cur] !== P) throw new Error("Invalid space at ".concat(Ae._cur, "."));
            Ae._cur += 1;
          }
          extract(Ae, ct) {
            if (!Ae.attValue) throw new Error("Nothing to extract from attValue.");
            for (var vt = arguments.length, en = new Array(vt > 2 ? vt - 2 : 0), Bn = 2; Bn < vt; Bn++) en[Bn - 2] = arguments[Bn];
            const Mr = ct.call(this, Ae.attValue, Ae._cur, ...en), rs = Ae.attValue.slice(Ae._cur, Mr);
            return Ae._cur = Mr, rs;
          }
          atEnd(Ae) {
            if (!Ae.attValue) throw new Error();
            return Ae._cur >= Ae.attValue.length;
          }
          peekChar(Ae) {
            if (!Ae.attValue) throw new Error();
            return Ae.attValue[Ae._cur];
          }
          peek(Ae, ct) {
            if (!Ae.attValue) throw new Error();
            for (let vt = 0; vt < ct.length; vt++) if (ct[vt] !== Ae.attValue[Ae._cur + vt]) return !1;
            return !0;
          }
          parseIceUfrag(Ae) {
            if (this.attributes.iceUfrag) throw new Error("Invalid ice-ufrag, should be only a single line if 'a=ice-ufrag'");
            this.attributes.iceUfrag = this.extractOneOrMore(Ae, We, [4, 256]);
          }
          parseIcePwd(Ae) {
            if (this.attributes.icePwd) throw new Error("Invalid ice-pwd, should be only a single line if 'a=ice-pwd'");
            this.attributes.icePwd = this.extractOneOrMore(Ae, We, [22, 256]);
          }
          parseIceOptions(Ae) {
            if (this.attributes.iceOptions) throw new Error("Invalid ice-options, should be only one 'ice-options' line");
            const ct = [];
            for (; !this.atEnd(Ae); ) {
              ct.push(this.extractOneOrMore(Ae, We));
              try {
                this.consumeAttributeSpace(Ae);
              } catch (vt) {
                if (this.atEnd(Ae)) break;
                throw vt;
              }
            }
            this.attributes.iceOptions = ct;
          }
          parseFingerprint(Ae) {
            const ct = this.extract(Ae, this.consumeToken);
            this.consumeAttributeSpace(Ae);
            const vt = this.extract(Ae, this.consumeTill);
            this.attributes.fingerprints.push({ hashFunction: ct, fingerprint: vt });
          }
          parseExtmap(Ae) {
            const ct = this.extractOneOrMore(Ae, z);
            let vt;
            this.peekChar(Ae) === "/" && (this.extract(Ae, this.consume, "/"), vt = this.extract(Ae, this.consumeToken)), this.consumeAttributeSpace(Ae);
            const en = this.extract(Ae, this.consumeTill, P), Bn = Nt(Nt({ entry: parseInt(ct, 10) }, vt && { direction: vt }), {}, { extensionName: en });
            this.peekChar(Ae) === P && (this.consumeAttributeSpace(Ae), Bn.extensionAttributes = this.extract(Ae, this.consumeTill)), this.attributes.extmaps.push(Bn);
          }
          parseSetup(Ae) {
            if (this.attributes.setup) throw new Error("must only be one single 'a=setup' line.");
            const ct = this.extract(Ae, this.consumeTill);
            if (ct !== "active" && ct !== "passive" && ct !== "actpass" && ct !== "holdconn") throw new Error("role must be one of 'active', 'passive', 'actpass', 'holdconn'.");
            this.attributes.setup = ct;
          }
        }
        class ir extends hn {
          constructor() {
            super(...arguments), Vt(this, "attributes", { unrecognized: [], groups: [], extmaps: [], fingerprints: [], identities: [] });
          }
          parse(Ae) {
            if (this.digested) throw new Error("already digested");
            try {
              switch (Ae.attField) {
                case "group":
                  this.parseGroup(Ae);
                  break;
                case "ice-lite":
                  this.parseIceLite();
                  break;
                case "ice-ufrag":
                  this.parseIceUfrag(Ae);
                  break;
                case "ice-pwd":
                  this.parseIcePwd(Ae);
                  break;
                case "ice-options":
                  this.parseIceOptions(Ae);
                  break;
                case "fingerprint":
                  this.parseFingerprint(Ae);
                  break;
                case "setup":
                  this.parseSetup(Ae);
                  break;
                case "tls-id":
                  this.parseTlsId(Ae);
                  break;
                case "identity":
                  this.parseIdentity(Ae);
                  break;
                case "extmap":
                  this.parseExtmap(Ae);
                  break;
                case "msid-semantic":
                  this.parseMsidSemantic(Ae);
                  break;
                default:
                  Ae.ignored = !0, this.attributes.unrecognized.push(Ae);
              }
            } catch (ct) {
              throw console.error("parsing session attribute ".concat(Ae.attField, ' error, "a=').concat(Ae.attField, ":").concat(Ae.attValue, '"')), ct;
            }
            if (!Ae.ignored && Ae.attValue && !this.atEnd(Ae)) throw new Error("attribute parsing error");
          }
          digest() {
            return this.digested = !0, this.attributes;
          }
          parseGroup(Ae) {
            const ct = this.extract(Ae, this.consumeToken), vt = [];
            for (; !this.atEnd(Ae) && this.peekChar(Ae) === P; ) this.consumeAttributeSpace(Ae), vt.push(this.extract(Ae, this.consumeToken));
            this.attributes.groups.push({ semantic: ct, identificationTag: vt });
          }
          parseIceLite() {
            if (this.attributes.iceLite) throw new Error("Invalid ice-lite, should be only a single line of 'a=ice-lite'");
            this.attributes.iceLite = !0;
          }
          parseTlsId(Ae) {
            if (this.attributes.tlsId) throw new Error("must be only one tld-id line");
            this.attributes.tlsId = this.extractOneOrMore(Ae, mt);
          }
          parseIdentity(Ae) {
            const ct = this.extractOneOrMore(Ae, Pt), vt = [];
            for (; !this.atEnd(Ae) && this.peekChar(Ae) === P; ) {
              this.consumeAttributeSpace(Ae);
              const en = this.extract(Ae, this.consumeToken);
              this.extract(Ae, this.consume, "=");
              const Bn = this.extractOneOrMore(Ae, (Mr) => Mr !== P && Xe(Mr));
              vt.push({ name: en, value: Bn });
            }
            this.attributes.identities.push({ assertionValue: ct, extensions: vt });
          }
          parseMsidSemantic(Ae) {
            this.peekChar(Ae) === P && this.consumeAttributeSpace(Ae);
            const ct = { semantic: this.extract(Ae, this.consumeToken), identifierList: [] };
            for (; ; ) {
              try {
                this.consumeAttributeSpace(Ae);
              } catch {
                break;
              }
              if (this.peekChar(Ae) === "*") {
                this.extract(Ae, this.consume, "*"), ct.applyForAll = !0;
                break;
              }
              {
                const vt = this.extract(Ae, this.consumeTill, P);
                ct.identifierList.push(vt);
              }
            }
            this.attributes.msidSemantic = ct;
          }
        }
        class sr extends hn {
          constructor(Ae) {
            super(), Vt(this, "attributes", void 0), Ae.protos.indexOf("RTP") !== -1 || Ae.protos.indexOf("rtp"), this.attributes = { unrecognized: [], candidates: [], extmaps: [], fingerprints: [], imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: [], ssrcGroups: [], rtcpFeedbackWildcards: [], payloads: [] };
          }
          parse(Ae) {
            if (this.digested) throw new Error("already digested");
            try {
              switch (Ae.attField) {
                case "extmap":
                  this.parseExtmap(Ae);
                  break;
                case "setup":
                  this.parseSetup(Ae);
                  break;
                case "ice-ufrag":
                  this.parseIceUfrag(Ae);
                  break;
                case "ice-pwd":
                  this.parseIcePwd(Ae);
                  break;
                case "ice-options":
                  this.parseIceOptions(Ae);
                  break;
                case "candidate":
                  this.parseCandidate(Ae);
                  break;
                case "remote-candidate":
                  this.parseRemoteCandidate(Ae);
                  break;
                case "end-of-candidates":
                  this.parseEndOfCandidates();
                  break;
                case "fingerprint":
                  this.parseFingerprint(Ae);
                  break;
                case "rtpmap":
                  this.parseRtpmap(Ae);
                  break;
                case "ptime":
                  this.parsePtime(Ae);
                  break;
                case "maxptime":
                  this.parseMaxPtime(Ae);
                  break;
                case "sendrecv":
                case "recvonly":
                case "sendonly":
                case "inactive":
                  this.parseDirection(Ae);
                  break;
                case "ssrc":
                  this.parseSSRC(Ae);
                  break;
                case "fmtp":
                  this.parseFmtp(Ae);
                  break;
                case "rtcp-fb":
                  this.parseRtcpFb(Ae);
                  break;
                case "rtcp-mux":
                  this.parseRTCPMux();
                  break;
                case "rtcp-mux-only":
                  this.parseRTCPMuxOnly();
                  break;
                case "rtcp-rsize":
                  this.parseRTCPRsize();
                  break;
                case "rtcp":
                  this.parseRTCP(Ae);
                  break;
                case "mid":
                  this.parseMid(Ae);
                  break;
                case "msid":
                  this.parseMsid(Ae);
                  break;
                case "imageattr":
                  this.parseImageAttr(Ae);
                  break;
                case "rid":
                  this.parseRid(Ae);
                  break;
                case "simulcast":
                  this.parseSimulcast(Ae);
                  break;
                case "sctp-port":
                  this.parseSctpPort(Ae);
                  break;
                case "max-message-size":
                  this.parseMaxMessageSize(Ae);
                  break;
                case "ssrc-group":
                  this.parseSSRCGroup(Ae);
                  break;
                default:
                  Ae.ignored = !0, this.attributes.unrecognized.push(Ae);
              }
            } catch (ct) {
              throw console.error("parsing media attribute ".concat(Ae.attField, ' error, "a=').concat(Ae.attField, ":").concat(Ae.attValue, '"')), ct;
            }
            if (!Ae.ignored && Ae.attValue && !this.atEnd(Ae)) throw new Error("attribute parsing error");
          }
          parseCandidate(Ae) {
            const ct = this.extractOneOrMore(Ae, We, [1, 32]);
            this.consumeAttributeSpace(Ae);
            const vt = this.extractOneOrMore(Ae, z, [1, 5]);
            this.consumeAttributeSpace(Ae);
            const en = this.extract(Ae, this.consumeToken);
            this.consumeAttributeSpace(Ae);
            const Bn = this.extractOneOrMore(Ae, z, [1, 10]);
            this.consumeAttributeSpace(Ae);
            const Mr = this.extract(Ae, this.consumeAddress);
            this.consumeAttributeSpace(Ae);
            const rs = this.extract(Ae, this.consumePort);
            this.consumeAttributeSpace(Ae), this.extract(Ae, this.consume, "typ"), this.consumeAttributeSpace(Ae);
            const wa = { foundation: ct, componentId: vt, transport: en, priority: Bn, connectionAddress: Mr, port: rs, type: this.extract(Ae, this.consumeToken), extension: {} };
            for (this.peek(Ae, " raddr") && (this.extract(Ae, this.consume, " raddr"), this.consumeAttributeSpace(Ae), wa.relAddr = this.extract(Ae, this.consumeAddress)), this.peek(Ae, " rport") && (this.extract(Ae, this.consume, " rport"), this.consumeAttributeSpace(Ae), wa.relPort = this.extract(Ae, this.consumePort)); this.peekChar(Ae) === P; ) {
              this.consumeAttributeSpace(Ae);
              const bd = this.extract(Ae, this.consumeToken);
              this.consumeAttributeSpace(Ae), wa.extension[bd] = this.extractOneOrMore(Ae, Y);
            }
            this.attributes.candidates.push(wa);
          }
          parseRemoteCandidate(Ae) {
            const ct = [];
            for (; ; ) {
              const vt = this.extractOneOrMore(Ae, z, [1, 5]);
              this.consumeAttributeSpace(Ae);
              const en = this.extract(Ae, this.consumeAddress);
              this.consumeAttributeSpace(Ae);
              const Bn = this.extract(Ae, this.consumePort);
              ct.push({ componentId: vt, connectionAddress: en, port: Bn });
              try {
                this.consumeAttributeSpace(Ae);
              } catch {
                break;
              }
            }
            this.attributes.remoteCandidatesList.push(ct);
          }
          parseEndOfCandidates() {
            if (this.attributes.endOfCandidates) throw new Error("must be only one line of end-of-candidates");
            this.attributes.endOfCandidates = !0;
          }
          parseRtpmap(Ae) {
            const ct = this.extract(Ae, this.consumeToken);
            this.consumeAttributeSpace(Ae);
            const vt = this.extract(Ae, this.consumeTill, "/");
            this.extract(Ae, this.consume, "/");
            const en = { encodingName: vt, clockRate: this.extractOneOrMore(Ae, z) };
            this.atEnd(Ae) || this.peekChar(Ae) !== "/" || (this.extract(Ae, this.consume, "/"), en.encodingParameters = parseInt(this.extract(Ae, this.consumeTill), 10));
            const Bn = this.attributes.payloads.find((Mr) => Mr.payloadType === parseInt(ct, 10));
            Bn ? Bn.rtpMap = en : this.attributes.payloads.push({ payloadType: parseInt(ct, 10), rtpMap: en, rtcpFeedbacks: [] });
          }
          parsePtime(Ae) {
            if (this.attributes.ptime) throw new Error("must be only one line of ptime");
            this.attributes.ptime = this.extract(Ae, this.consumeTill);
          }
          parseMaxPtime(Ae) {
            if (this.attributes.maxPtime) throw new Error("must be only one line of ptime");
            this.attributes.maxPtime = this.extract(Ae, this.consumeTill);
          }
          parseDirection(Ae) {
            if (this.attributes.direction) throw new Error("must be only one line of direction info");
            this.attributes.direction = Ae.attField;
          }
          parseSSRC(Ae) {
            const ct = this.extractOneOrMore(Ae, z);
            this.consumeAttributeSpace(Ae);
            const vt = this.extract(Ae, this.consumeTill, ":");
            let en;
            this.peekChar(Ae) === ":" && (this.extract(Ae, this.consume, ":"), en = this.extract(Ae, this.consumeTill));
            const Bn = this.attributes.ssrcs.find((Mr) => Mr.ssrcId === parseInt(ct, 10));
            Bn ? Bn.attributes[vt] = en : this.attributes.ssrcs.push({ ssrcId: parseInt(ct, 10), attributes: { [vt]: en } });
          }
          parseFmtp(Ae) {
            const ct = this.extract(Ae, this.consumeTill, P);
            this.consumeAttributeSpace(Ae);
            const vt = this.extract(Ae, this.consumeTill), en = {};
            vt.split(";").forEach((Mr) => {
              let [rs, wa] = Mr.split("=");
              rs = Ys(rs).call(rs);
              const bd = typeof wa == "string" ? Ys(wa).call(wa) : null;
              typeof rs == "string" && rs.length > 0 && (en[rs] = bd);
            });
            const Bn = this.attributes.payloads.find((Mr) => Mr.payloadType === parseInt(ct, 10));
            Bn ? Bn.fmtp = { parameters: en } : this.attributes.payloads.push({ payloadType: parseInt(ct, 10), rtcpFeedbacks: [], fmtp: { parameters: en } });
          }
          parseFmtParameters(Ae) {
            const ct = {}, vt = this.extract(Ae, this.consumeTill, "=");
            Ae._cur++;
            const en = this.extract(Ae, this.consumeTill, ";");
            for (ct[vt] = en; Ae.attValue[Ae._cur] === ";"; ) {
              const Bn = this.extract(Ae, this.consumeTill, "=");
              Ae._cur++;
              const Mr = this.extract(Ae, this.consumeTill, ";");
              ct[Bn] = Mr;
            }
            return ct;
          }
          parseRtcpFb(Ae) {
            let ct = "";
            ct = this.peekChar(Ae) === "*" ? this.extract(Ae, this.consume, "*") : this.extract(Ae, this.consumeTill, P), this.consumeAttributeSpace(Ae);
            const vt = this.extract(Ae, this.consumeTill, P);
            let en;
            if (vt === "trr-int") en = { type: vt, interval: this.extract(Ae, this.consumeTill) };
            else {
              const Bn = { type: vt };
              this.peekChar(Ae) === P && (this.consumeAttributeSpace(Ae), Bn.parameter = this.extract(Ae, this.consumeToken), this.peekChar(Ae) === P && (Bn.additional = this.extract(Ae, this.consumeTill))), en = Bn;
            }
            if (ct === "*") this.attributes.rtcpFeedbackWildcards.push(en);
            else {
              const Bn = this.attributes.payloads.find((Mr) => Mr.payloadType === parseInt(ct, 10));
              Bn ? Bn.rtcpFeedbacks.push(en) : this.attributes.payloads.push({ payloadType: parseInt(ct, 10), rtcpFeedbacks: [en] });
            }
          }
          parseRTCPMux() {
            if (this.attributes.rtcpMux) throw new Error("must be single line of rtcp-mux");
            this.attributes.rtcpMux = !0;
          }
          parseRTCPMuxOnly() {
            if (this.attributes.rtcpMuxOnly) throw new Error("must be single line of rtcp-only");
            this.attributes.rtcpMuxOnly = !0;
          }
          parseRTCPRsize() {
            if (this.attributes.rtcpRsize) throw new Error("must be single line of rtcp-rsize");
            this.attributes.rtcpRsize = !0;
          }
          parseRTCP(Ae) {
            if (this.attributes.rtcp) throw new Error("must be single line of rtcp");
            const ct = { port: this.extract(Ae, this.consumePort) };
            this.peekChar(Ae) === P && (this.consumeAttributeSpace(Ae), ct.netType = this.extractOneOrMore(Ae, oe), this.consumeAttributeSpace(Ae), ct.addressType = this.extractOneOrMore(Ae, oe), this.consumeAttributeSpace(Ae), ct.address = this.extract(Ae, this.consumeAddress)), this.attributes.rtcp = ct;
          }
          parseMsid(Ae) {
            const ct = { id: this.extractOneOrMore(Ae, oe, [1, 64]) };
            this.peekChar(Ae) === P && (this.consumeAttributeSpace(Ae), ct.appdata = this.extractOneOrMore(Ae, oe, [1, 64])), this.attributes.msids.push(ct);
          }
          parseImageAttr(Ae) {
            this.attributes.imageattr.push(Ae.attValue);
          }
          parseRid(Ae) {
            const ct = this.extractOneOrMore(Ae, (en) => Re(en) || z(en) || en === "_" || en === "-");
            this.consumeAttributeSpace(Ae);
            const vt = { id: ct, direction: this.extract(Ae, this.consumeToken), params: [] };
            if (this.peekChar(Ae) === P) {
              if (this.consumeAttributeSpace(Ae), this.peek(Ae, "pt=")) {
                this.extract(Ae, this.consume, "pt=");
                const en = [];
                for (; ; ) {
                  const Bn = this.extract(Ae, this.consumeToken);
                  en.push(Bn);
                  try {
                    this.extract(Ae, this.consume, ",");
                  } catch {
                    break;
                  }
                }
                vt.payloads = en, this.peekChar(Ae) === P && this.extract(Ae, this.consume, P);
              }
              for (; ; ) {
                const en = this.extract(Ae, this.consumeToken);
                switch (en) {
                  case "depend": {
                    const Bn = { type: en, rids: this.extract(Ae, this.consume, "=").split(",") };
                    vt.params.push(Bn);
                    break;
                  }
                  default: {
                    const Bn = { type: en };
                    this.peekChar(Ae) === "=" && (this.extract(Ae, this.consume, "="), Bn.val = this.extract(Ae, this.consumeTill, ";")), vt.params.push(Bn);
                  }
                }
                try {
                  this.extract(Ae, this.consume, ";");
                } catch {
                  break;
                }
              }
            }
            this.attributes.rids.push(vt);
          }
          parseSimulcast(Ae) {
            if (this.attributes.simulcast) throw new Error("must be single line of simulcast");
            this.attributes.simulcast = Ae.attValue, this.extract(Ae, this.consumeTill);
          }
          parseSctpPort(Ae) {
            this.attributes.sctpPort = this.extractOneOrMore(Ae, z, [1, 5]);
          }
          parseMaxMessageSize(Ae) {
            this.attributes.maxMessageSize = this.extractOneOrMore(Ae, z, [1, void 0]);
          }
          digest() {
            return this.digested = !0, this.attributes;
          }
          parseMid(Ae) {
            this.attributes.mid = this.extract(Ae, this.consumeToken);
          }
          parseSSRCGroup(Ae) {
            const ct = this.extract(Ae, this.consumeToken), vt = [];
            for (; ; ) try {
              this.consumeAttributeSpace(Ae);
              const en = this.extract(Ae, this.consumeInteger);
              vt.push(parseInt(en, 10));
            } catch {
              break;
            }
            this.attributes.ssrcGroups.push({ semantic: ct, ssrcIds: vt });
          }
        }
        function Gr(Jt, Ae, ct) {
          return Ae in Jt ? Object.defineProperty(Jt, Ae, { value: ct, enumerable: !0, configurable: !0, writable: !0 }) : Jt[Ae] = ct, Jt;
        }
        class Ai {
          constructor() {
            Gr(this, "eol", R);
          }
          print(Ae, ct) {
            let vt = "";
            return ct && (this.eol = ct), vt += this.printVersion(Ae.version), vt += this.printOrigin(Ae.origin), vt += this.printSessionName(Ae.sessionName), vt += this.printInformation(Ae.information), vt += this.printUri(Ae.uri), vt += this.printEmail(Ae.emails), vt += this.printPhone(Ae.phones), vt += this.printConnection(Ae.connection), vt += this.printBandwidth(Ae.bandwidths), vt += this.printTimeFields(Ae.timeFields), vt += this.printKey(Ae.key), vt += this.printSessionAttributes(Ae.attributes), vt += this.printMediaDescription(Ae.mediaDescriptions), vt;
          }
          printVersion(Ae) {
            return "v=".concat(Ae).concat(this.eol);
          }
          printOrigin(Ae) {
            return "o=".concat(Ae.username, " ").concat(Ae.sessId, " ").concat(Ae.sessVersion, " ").concat(Ae.nettype, " ").concat(Ae.addrtype, " ").concat(Ae.unicastAddress).concat(this.eol);
          }
          printSessionName(Ae) {
            return Ae ? "s=".concat(Ae).concat(this.eol) : "";
          }
          printInformation(Ae) {
            return Ae ? "i=".concat(Ae).concat(this.eol) : "";
          }
          printUri(Ae) {
            return Ae ? "u=".concat(Ae).concat(this.eol) : "";
          }
          printEmail(Ae) {
            let ct = "";
            for (const vt of Ae) ct += "e=".concat(vt).concat(this.eol);
            return ct;
          }
          printPhone(Ae) {
            let ct = "";
            for (const vt of Ae) ct += "e=".concat(vt).concat(this.eol);
            return ct;
          }
          printConnection(Ae) {
            return Ae ? "c=".concat(Ae.nettype, " ").concat(Ae.addrtype, " ").concat(Ae.address).concat(this.eol) : "";
          }
          printBandwidth(Ae) {
            let ct = "";
            for (const vt of Ae) ct += "b=".concat(vt.bwtype, ":").concat(vt.bandwidth).concat(this.eol);
            return ct;
          }
          printTimeFields(Ae) {
            let ct = "";
            for (const vt of Ae) {
              ct += "t=".concat(vt.time.startTime, " ").concat(vt.time.startTime).concat(this.eol);
              for (const en of vt.repeats) ct += "r=".concat(en.repeatInterval, " ").concat(en.typedTimes.join(" ")).concat(this.eol);
              vt.zoneAdjustments && (ct += "z=", ct += "z=".concat(vt.zoneAdjustments.map((en) => "".concat(en.time, " ").concat(en.back ? "-" : "", " ").concat(en.typedTime)).join(" ")).concat(this.eol), ct += this.eol);
            }
            return ct;
          }
          printKey(Ae) {
            return Ae ? "k=".concat(Ae).concat(this.eol) : "";
          }
          printAttributes(Ae) {
            let ct = "";
            for (const vt of Ae) ct += "a=".concat(vt.attField).concat(vt.attValue ? ":".concat(vt.attValue) : "").concat(this.eol);
            return ct;
          }
          printMediaDescription(Ae) {
            let ct = "";
            for (const vt of Ae) ct += this.printMedia(vt.media), ct += this.printInformation(vt.information), ct += this.printConnections(vt.connections), ct += this.printBandwidth(vt.bandwidths), ct += this.printKey(vt.key), ct += this.printMediaAttributes(vt);
            return ct;
          }
          printConnections(Ae) {
            let ct = "";
            for (const vt of Ae) ct += this.printConnection(vt);
            return ct;
          }
          printMedia(Ae) {
            return "m=".concat(Ae.mediaType, " ").concat(Ae.port, " ").concat(Ae.protos.join("/"), " ").concat(Ae.fmts.join(" ")).concat(this.eol);
          }
          printSessionAttributes(Ae) {
            return new Ea(this.eol).print(Ae);
          }
          printMediaAttributes(Ae) {
            return new qt(this.eol).print(Ae);
          }
        }
        class fi {
          constructor(Ae) {
            Gr(this, "eol", void 0), this.eol = Ae;
          }
          printIceUfrag(Ae) {
            return Ae === void 0 ? "" : "a=ice-ufrag:".concat(Ae).concat(this.eol);
          }
          printIcePwd(Ae) {
            return Ae === void 0 ? "" : "a=ice-pwd:".concat(Ae).concat(this.eol);
          }
          printIceOptions(Ae) {
            return Ae === void 0 ? "" : "a=ice-options:".concat(Ae.join(P)).concat(this.eol);
          }
          printFingerprints(Ae) {
            return Ae.length > 0 ? Ae.map((ct) => "a=fingerprint:".concat(ct.hashFunction).concat(P).concat(ct.fingerprint)).join(this.eol) + this.eol : "";
          }
          printExtmap(Ae) {
            return Ae.map((ct) => "a=extmap:".concat(ct.entry).concat(ct.direction ? "/".concat(ct.direction) : "").concat(P).concat(ct.extensionName).concat(ct.extensionAttributes ? "".concat(P).concat(ct.extensionAttributes) : "").concat(this.eol)).join("");
          }
          printSetup(Ae) {
            return Ae === void 0 ? "" : "a=setup:".concat(Ae).concat(this.eol);
          }
          printUnrecognized(Ae) {
            return Ae.map((ct) => "a=".concat(ct.attField).concat(ct.attValue ? ":".concat(ct.attValue) : "").concat(this.eol)).join("");
          }
        }
        class Ea extends fi {
          print(Ae) {
            let ct = "";
            return ct += this.printGroups(Ae.groups), ct += this.printMsidSemantic(Ae.msidSemantic), ct += this.printIceLite(Ae.iceLite), ct += this.printIceUfrag(Ae.iceUfrag), ct += this.printIcePwd(Ae.icePwd), ct += this.printIceOptions(Ae.iceOptions), ct += this.printFingerprints(Ae.fingerprints), ct += this.printSetup(Ae.setup), ct += this.printTlsId(Ae.tlsId), ct += this.printIdentity(Ae.identities), ct += this.printExtmap(Ae.extmaps), ct += this.printUnrecognized(Ae.unrecognized), ct;
          }
          printGroups(Ae) {
            let ct = "";
            return Ae.length > 0 && (ct += Ae.map((vt) => "a=group:".concat(vt.semantic).concat(vt.identificationTag.map((en) => "".concat(P).concat(en)).join("")).concat(this.eol)).join("")), ct;
          }
          printIceLite(Ae) {
            return Ae === void 0 ? "" : "a=ice-lite" + this.eol;
          }
          printTlsId(Ae) {
            return Ae ? "a=tls-id:".concat(Ae).concat(this.eol) : "";
          }
          printIdentity(Ae) {
            return Ae.length === 0 ? "" : Ae.map((ct) => "a=identity:".concat(ct.assertionValue).concat(ct.extensions.map((vt) => "".concat(P).concat(vt.name).concat(vt.value ? "=".concat(vt.value) : "")))).join(this.eol) + this.eol;
          }
          printMsidSemantic(Ae) {
            if (!Ae) return "";
            let ct = "a=msid-semantic:".concat(Ae.semantic);
            return Ae.applyForAll ? ct += "".concat(P, "*") : Ae.identifierList.length > 0 && (ct += Ae.identifierList.map((vt) => "".concat(P).concat(vt))), ct + this.eol;
          }
        }
        class qt extends fi {
          print(Ae) {
            const ct = Ae.attributes;
            let vt = "";
            return vt += this.printRTCP(ct.rtcp), vt += this.printIceUfrag(ct.iceUfrag), vt += this.printIcePwd(ct.icePwd), vt += this.printIceOptions(ct.iceOptions), vt += this.printCandidates(ct.candidates), vt += this.printRemoteCandidatesList(ct.remoteCandidatesList), vt += this.printEndOfCandidates(ct.endOfCandidates), vt += this.printFingerprints(ct.fingerprints), vt += this.printSetup(ct.setup), vt += this.printMid(ct.mid), vt += this.printExtmap(ct.extmaps), vt += this.printRTPRelated(ct), vt += this.printPtime(ct.ptime), vt += this.printMaxPtime(ct.maxPtime), vt += this.printDirection(ct.direction), vt += this.printSSRCGroups(ct.ssrcGroups), vt += this.printSSRC(ct.ssrcs), vt += this.printRTCPMux(ct.rtcpMux), vt += this.printRTCPMuxOnly(ct.rtcpMuxOnly), vt += this.printRTCPRsize(ct.rtcpRsize), vt += this.printMSId(ct.msids), vt += this.printImageattr(ct.imageattr), vt += this.printRid(ct.rids), vt += this.printSimulcast(ct.simulcast), vt += this.printSCTPPort(ct.sctpPort), vt += this.printMaxMessageSize(ct.maxMessageSize), vt += this.printUnrecognized(ct.unrecognized), vt;
          }
          printCandidates(Ae) {
            return Ae.map((ct) => "a=candidate:".concat(ct.foundation).concat(P).concat(ct.componentId).concat(P).concat(ct.transport).concat(P).concat(ct.priority).concat(P).concat(ct.connectionAddress).concat(P).concat(ct.port).concat(P, "typ").concat(P).concat(ct.type).concat(ct.relAddr ? "".concat(P, "raddr").concat(P).concat(ct.relAddr) : "").concat(ct.relPort ? "".concat(P, "rport").concat(P).concat(ct.relPort) : "").concat(Object.keys(ct.extension).map((vt) => "".concat(P).concat(vt).concat(P).concat(ct.extension[vt])).join("")).concat(this.eol)).join("");
          }
          printRemoteCandidatesList(Ae) {
            return Ae.map((ct) => "a=remote-candidates:".concat(ct.join(P)).concat(this.eol)).join("");
          }
          printEndOfCandidates(Ae) {
            return Ae === void 0 ? "" : "a=end-of-candidates" + this.eol;
          }
          printRTPRelated(Ae) {
            if (!Ae.payloads) return "";
            const ct = Ae.payloads;
            let vt = "";
            vt += Ae.rtcpFeedbackWildcards.map((en) => this.printRTCPFeedback("*", en)).join("");
            for (const en of ct) vt += this.printRtpMap(en.payloadType, en.rtpMap), vt += this.printFmtp(en.payloadType, en.fmtp), vt += en.rtcpFeedbacks.map((Bn) => this.printRTCPFeedback(en.payloadType, Bn)).join("");
            return vt;
          }
          printFmtp(Ae, ct) {
            if (!ct) return "";
            const vt = Object.keys(ct.parameters);
            return vt.length === 1 && ct.parameters[vt[0]] === null ? "a=fmtp:".concat(Ae).concat(P).concat(vt[0]).concat(this.eol) : "a=fmtp:".concat(Ae).concat(P).concat(Object.keys(ct.parameters).map((en) => "".concat(en, "=").concat(ct.parameters[en])).join(";")).concat(this.eol);
          }
          printRtpMap(Ae, ct) {
            return ct ? "a=rtpmap:".concat(Ae).concat(P).concat(ct.encodingName, "/").concat(ct.clockRate).concat(ct.encodingParameters ? "/".concat(ct.encodingParameters) : "").concat(this.eol) : "";
          }
          printRTCPFeedback(Ae, ct) {
            let vt = "a=rtcp-fb:".concat(Ae).concat(P), en = ct;
            return en.type === "trr-int" ? vt += "ttr-int".concat(P).concat(en.interval) : (vt += "".concat(en.type), en.parameter && (vt += "".concat(P).concat(en.parameter), en.additional && (vt += "".concat(P).concat(en.additional)))), vt + this.eol;
          }
          printPtime(Ae) {
            return Ae === void 0 ? "" : "a=ptime:".concat(Ae).concat(this.eol);
          }
          printMaxPtime(Ae) {
            return Ae === void 0 ? "" : "a=maxptime:".concat(Ae).concat(this.eol);
          }
          printDirection(Ae) {
            return Ae === void 0 ? "" : "a=".concat(Ae).concat(this.eol);
          }
          printSSRC(Ae) {
            return Ae.map((ct) => Object.keys(ct.attributes).map((vt) => "a=ssrc:".concat(ct.ssrcId.toString(10)).concat(P).concat(vt).concat(ct.attributes[vt] ? ":".concat(ct.attributes[vt]) : "").concat(this.eol)).join("")).join("");
          }
          printRTCPMux(Ae) {
            return Ae === void 0 ? "" : "a=rtcp-mux".concat(this.eol);
          }
          printRTCPMuxOnly(Ae) {
            return Ae === void 0 ? "" : "a=rtcp-mux-only".concat(this.eol);
          }
          printRTCPRsize(Ae) {
            return Ae === void 0 ? "" : "a=rtcp-rsize".concat(this.eol);
          }
          printRTCP(Ae) {
            if (Ae === void 0) return "";
            let ct = "a=rtcp:".concat(Ae.port);
            return Ae.netType && (ct += "".concat(P).concat(Ae.netType)), Ae.addressType && (ct += "".concat(P).concat(Ae.addressType)), Ae.address && (ct += "".concat(P).concat(Ae.address)), ct + this.eol;
          }
          printMSId(Ae) {
            return Ae.map((ct) => "a=msid:".concat(ct.id).concat(ct.appdata ? "".concat(P).concat(ct.appdata) : "").concat(this.eol)).join("");
          }
          printImageattr(Ae) {
            return Ae.map((ct) => "a=imageattr:".concat(ct).concat(this.eol)).join("");
          }
          printRid(Ae) {
            return Ae.map((ct) => {
              let vt = "a=rid:".concat(ct.id).concat(P).concat(ct.direction);
              return ct.payloads && (vt += "".concat(P, "pt=").concat(ct.payloads.join(","))), ct.params.length > 0 && (vt += "".concat(P).concat(ct.params.map((en) => en.type === "depend" ? "depend=".concat(en.rids.join(",")) : "".concat(en.type, "=").concat(en.val)).join(";"))), vt + this.eol;
            }).join("");
          }
          printSimulcast(Ae) {
            return Ae === void 0 ? "" : "a=simulcast:".concat(Ae).concat(this.eol);
          }
          printSCTPPort(Ae) {
            return Ae === void 0 ? "" : "a=sctp-port:".concat(Ae).concat(this.eol);
          }
          printMaxMessageSize(Ae) {
            return Ae === void 0 ? "" : "a=max-message-size:".concat(Ae).concat(this.eol);
          }
          printMid(Ae) {
            return Ae === void 0 ? "" : "a=mid:".concat(Ae).concat(this.eol);
          }
          printSSRCGroups(Ae) {
            return Ae.map((ct) => "a=ssrc-group:".concat(ct.semantic).concat(ct.ssrcIds.map((vt) => "".concat(P).concat(vt.toString(10))).join("")).concat(this.eol)).join("");
          }
        }
        function sn(Jt) {
          return new fn().parse(Jt);
        }
        function An(Jt, Ae) {
          return new Ai().print(Jt, Ae);
        }
      } }, n = {};
      function i(o) {
        if (n[o]) return n[o].exports;
        var f = n[o] = { exports: {} };
        return e[o](f, f.exports, i), f.exports;
      }
      return i.d = (o, f) => {
        for (var T in f) i.o(f, T) && !i.o(o, T) && Object.defineProperty(o, T, { enumerable: !0, get: f[T] });
      }, i.o = (o, f) => Object.prototype.hasOwnProperty.call(o, f), i.r = (o) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
      }, i(8);
    })();
    function Ca(e) {
      return C5.parse(e);
    }
    function nl(e, n) {
      return C5.print(e, n);
    }
    var Kie = Jo("Array").keys, Jie = du, Zie = Lt, Qie = m, $ie = Kie, KS = Array.prototype, ese = { DOMTokenList: !0, NodeList: !0 }, tse = function(e) {
      var n = e.keys;
      return e === KS || Qie(KS, e) && n === KS.keys || Zie(ese, Jie(e)) ? $ie : n;
    }, ro = h(tse);
    function oi(e, n, i) {
      return (n = function(o) {
        var f = function(T, A) {
          if (typeof T != "object" || !T) return T;
          var R = T[Symbol.toPrimitive];
          if (R !== void 0) {
            var P = R.call(T, "string");
            if (typeof P != "object") return P;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(T);
        }(o);
        return typeof f == "symbol" ? f : f + "";
      }(n)) in e ? Object.defineProperty(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
    }
    function S5(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function Kn(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? S5(Object(i), !0).forEach(function(o) {
          oi(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : S5(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const I5 = new class extends ii {
      constructor() {
        super(...arguments), oi(this, "currentUploadLogID", 0);
      }
      reportLogUploadError(e) {
        const { errorRange: n } = e;
        n[n.length - 1] && n[n.length - 1] > this.currentUploadLogID && (this.currentUploadLogID = n[n.length - 1], this.emit("REPORT_LOG_UPLOAD", e));
      }
    }();
    class nse {
      constructor(n) {
        oi(this, "logger", void 0), oi(this, "prefixLists", []), this.logger = n;
      }
      debug() {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
        this.logger.debug(...this.prefixLists, ...i);
      }
      info() {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
        this.logger.info(...this.prefixLists, ...i);
      }
      warning() {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
        this.logger.warning(...this.prefixLists, ...i);
      }
      error() {
        for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
        this.logger.error(...this.prefixLists, ...i);
      }
      prefix(n) {
        return this.prefixLists.push(n), this;
      }
      popPrefix() {
        return this.prefixLists.pop(), this;
      }
    }
    function JS() {
      const e = /* @__PURE__ */ new Date();
      return e.toTimeString().split(" ")[0] + ":" + e.getMilliseconds();
    }
    function R5() {
      const e = /* @__PURE__ */ new Date(), n = /((\d+:){2}\d+)/.exec((/* @__PURE__ */ new Date()).toUTCString());
      return n ? (n == null ? void 0 : n[0]) + ":" + e.getUTCMilliseconds() : e.toTimeString().split(" ")[0] + ":" + e.getMilliseconds();
    }
    const No = { DEBUG: 0, INFO: 1, WARNING: 2, ERROR: 3, NONE: 4 }, ET = Date.now(), DE = (e) => {
      for (const n in No) if (Object.prototype.hasOwnProperty.call(No, n) && No[n] === e) return n;
      return "DEFAULT";
    }, Ee = new class {
      constructor() {
        oi(this, "proxyServerURL", void 0), oi(this, "logLevel", No.DEBUG), oi(this, "uploadState", "collecting"), oi(this, "uploadLogWaitingList", []), oi(this, "uploadLogUploadingList", []), oi(this, "uploadErrorCount", 0), oi(this, "currentLogID", 0), oi(this, "url", void 0), oi(this, "extLog", (e, n) => {
          this.appendLogToWaitingList(e, ...n);
        });
      }
      debug() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        const o = [No.DEBUG].concat(n);
        this.log.apply(this, o);
      }
      info() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        const o = [No.INFO].concat(n);
        this.log.apply(this, o);
      }
      warning() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        const o = [No.WARNING].concat(n);
        this.log.apply(this, o);
      }
      warn() {
        this.warning(...arguments);
      }
      error() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        const o = [No.ERROR].concat(n);
        this.log.apply(this, o);
      }
      upload() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        const o = [No.DEBUG].concat(n);
        this.uploadLog.apply(this, o);
      }
      setLogLevel(e) {
        e = Math.min(Math.max(0, e), 4), this.logLevel = e;
      }
      enableLogUpload() {
        Dr("UPLOAD_LOG", !0);
      }
      disableLogUpload() {
        Dr("UPLOAD_LOG", !1), this.uploadLogUploadingList = [], this.uploadLogWaitingList = [];
      }
      setProxyServer(e) {
        this.proxyServerURL = e;
      }
      prefix(e) {
        return new nse(this).prefix(e);
      }
      log() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        if (Date.now() - ET < 100) return void setTimeout(() => {
          this.log(...n);
        }, Date.now() - ET);
        const o = Math.max(0, Math.min(4, n[0]));
        if (n[0] = JS() + " Agora-SDK [".concat(DE(o), "]:"), this.appendLogToWaitingList(o, ...n), o < this.logLevel) return;
        const f = JS() + " %cAgora-SDK [".concat(DE(o), "]:");
        let T = [];
        if (!ft("USE_NEW_LOG")) switch (o) {
          case No.DEBUG:
            T = [f, "color: #64B5F6;"].concat(n.slice(1)), console.log.apply(console, T);
            break;
          case No.INFO:
            T = [f, "color: #1E88E5; font-weight: bold;"].concat(n.slice(1)), console.log.apply(console, T);
            break;
          case No.WARNING:
            T = [f, "color: #FB8C00; font-weight: bold;"].concat(n.slice(1)), console.warn.apply(console, T);
            break;
          case No.ERROR:
            T = [f, "color: #B00020; font-weight: bold;"].concat(n.slice(1)), console.error.apply(console, T);
        }
      }
      uploadLog() {
        for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
        if (Date.now() - ET < 100) return void setTimeout(() => {
          this.uploadLog(...n);
        }, Date.now() - ET);
        const o = Math.max(0, Math.min(4, n[0]));
        n[0] = JS() + " Agora-SDK [".concat(DE(o), "]:"), this.appendLogToWaitingList(o, ...n);
      }
      appendLogToWaitingList(e) {
        if (!ft("UPLOAD_LOG")) return;
        for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) i[o - 1] = arguments[o];
        Array.isArray(i[0]) ? i[0][0] = R5() + " Agora-SDK [".concat(DE(e), "]:") : i[0] = R5() + " Agora-SDK [".concat(DE(e), "]:");
        let f = "";
        i.forEach((T) => {
          typeof T == "object" && (T = JSON.stringify(T)), f += "".concat(T, " ");
        }), this.uploadLogWaitingList.push({ payload_str: f, log_level: e, log_item_id: this.currentLogID++ }), this.uploadState === "uploading" && this.uploadLogUploadingList.length === 0 && this.uploadLogInterval();
      }
      startUpload() {
        this.uploadState = "uploading", this.uploadLogUploadingList.length === 0 && this.uploadLogInterval();
      }
      async uploadLogs() {
        const e = this.uploadLogUploadingList, n = { sdk_version: Ro, process_id: ft("PROCESS_ID"), payload: JSON.stringify(e) };
        return jc(async () => {
          const i = await fa.post(this.url || (this.proxyServerURL ? "https://".concat(this.proxyServerURL, "/ls/?h=").concat(ft("LOG_UPLOAD_SERVER"), "&p=443&d=upload/v1") : "https://".concat(ft("LOG_UPLOAD_SERVER"), "/upload/v1")), n, { responseType: "text" });
          if (i.data !== "OK") {
            const o = new Error("unexpected upload log response");
            throw o.response = i, o;
          }
        }, () => (this.uploadLogUploadingList = [], !1), (i) => {
          const o = { status: -1, message: i.message, errorRange: e.map((f) => f.log_item_id) };
          return i.response ? (o.status = i.response.status, o.data = i.response.data, o.headers = i.response.headers) : i.request && (o.status = i.request.status), I5.reportLogUploadError(o), !0;
        }, { timeout: ft("UPLOAD_LOG_REQUEST_RETRY_INTERVAL"), maxRetryTimeout: ft("UPLOAD_LOG_REQUEST_MAX_RETRY_INTERVAL") });
      }
      uploadLogInterval() {
        this.uploadLogUploadingList.length === 0 && this.uploadLogWaitingList.length === 0 || (this.uploadLogUploadingList.length === 0 && (this.uploadLogUploadingList = this.uploadLogWaitingList.splice(0, ft("UPLOAD_LOG_LENGTH_EACH_TIME"))), this.uploadLogs().then(() => {
          this.uploadErrorCount = 0, this.uploadLogWaitingList.length > 0 && window.setTimeout(() => this.uploadLogInterval(), ft("UPLOAD_LOG_INTERVAL"));
        }).catch((e) => {
          this.uploadErrorCount += 1, this.uploadErrorCount < 2 ? window.setTimeout(() => this.uploadLogInterval(), ft("UPLOAD_LOG_TWICE_RETRY_INTERVAL_V1")) : window.setTimeout(() => this.uploadLogInterval(), ft("UPLOAD_LOG_RETRY_INTERVAL_V1"));
        }));
      }
    }();
    var N5;
    function rse(e) {
      return ms(e.reportId, "params.reportId", 0, 100, !1), ms(e.category, "params.category", 0, 100, !1), ms(e.event, "params.event", 0, 100, !1), ms(e.label, "params.label", 0, 100, !1), xr(e.value, "params.value", Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, !1), !0;
    }
    (N5 = {}).FREE = "free", N5.UPLOADING = "uploading", function(e) {
      e[e.MISC = 0] = "MISC", e[e.INTERNAL_EVENT = 1] = "INTERNAL_EVENT", e[e.PUBLIC_EVENT = 2] = "PUBLIC_EVENT", e[e.WEB_EVENT = 3] = "WEB_EVENT", e[e.INTERNAL_API = 4] = "INTERNAL_API", e[e.WEB_API = 5] = "WEB_API", e[e.PUBLIC_API = 6] = "PUBLIC_API";
    }({});
    const ise = { sid: "", lts: 0, success: null, cname: null, uid: null, peer: null, cid: null, elapse: null, extend: null, vid: 0 };
    let us = function(e) {
      return e.PUBLISH = "publish", e.SUBSCRIBE = "subscribe", e.WS_COMPRESSOR_INIT = "ws_compressor_init", e.SESSION_INIT = "session_init", e.JOIN_CHOOSE_SERVER = "join_choose_server", e.REQ_USER_ACCOUNT = "req_user_account", e.JOIN_GATEWAY = "join_gateway", e.REJOIN_GATEWAY = "rejoin_gateway", e.STREAM_SWITCH = "stream_switch", e.REQUEST_PROXY_WORKER_MANAGER = "request_proxy_worker_manager", e.REQUEST_PROXY_APPCENTER = "request_proxy_appcenter", e.FIRST_VIDEO_RECEIVED = "first_video_received", e.FIRST_AUDIO_RECEIVED = "first_audio_received", e.FIRST_VIDEO_DECODE = "first_video_decode", e.FIRST_AUDIO_DECODE = "first_audio_decode", e.ON_ADD_AUDIO_STREAM = "on_add_audio_stream", e.ON_ADD_VIDEO_STREAM = "on_add_video_stream", e.ON_UPDATE_STREAM = "on_update_stream", e.ON_REMOVE_STREAM = "on_remove_stream", e.USER_ANALYTICS = "req_user_analytics", e.PC_STATS = "pc_stats", e.UPDATE_REMOTE_RTPCAPABILITIES = "update_remote_rtpCapabilities", e;
    }({}), ti = function(e) {
      return e.SESSION = "io.agora.pb.Wrtc.Session", e.JOIN_CHOOSE_SERVER = "io.agora.pb.Wrtc.JoinChooseServer", e.REQ_USER_ACCOUNT = "io.agora.pb.Wrtc.ReqUserAccount", e.JOIN_GATEWAY = "io.agora.pb.Wrtc.JoinGateway", e.RE_JOIN_GATEWAY = "io.agora.pb.Wrtc.ReJoinGateway", e.PUBLISH = "io.agora.pb.Wrtc.Publish", e.SUBSCRIBE = "io.agora.pb.Wrtc.Subscribe", e.WS_COMPRESSOR_INIT = "io.agora.pb.Wrtc.WsCompressorInit", e.STREAM_SWITCH = "io.agora.pb.Wrtc.StreamSwitch", e.AUDIO_SENDING_STOPPED = "io.agora.pb.Wrtc.AudioSendingStopped", e.VIDEO_SENDING_STOPPED = "io.agora.pb.Wrtc.VideoSendingStopped", e.REQUEST_PROXY_APPCENTER = "io.agora.pb.Wrtc.RequestProxyAppCenter", e.REQUEST_PROXY_WORKER_MANAGER = "io.agora.pb.Wrtc.RequestProxyWorkerManager", e.API_INVOKE = "io.agora.pb.Wrtc.ApiInvoke", e.FIRST_VIDEO_RECEIVED = "io.agora.pb.Wrtc.FirstVideoReceived", e.FIRST_AUDIO_RECEIVED = "io.agora.pb.Wrtc.FirstAudioReceived", e.FIRST_VIDEO_DECODE = "io.agora.pb.Wrtc.FirstVideoDecode", e.FIRST_AUDIO_DECODE = "io.agora.pb.Wrtc.FirstAudioDecode", e.ON_ADD_AUDIO_STREAM = "io.agora.pb.Wrtc.OnAddAudioStream", e.ON_ADD_VIDEO_STREAM = "io.agora.pb.Wrtc.OnAddVideoStream", e.ON_UPDATE_STREAM = "io.agora.pb.Wrtc.OnUpdateStream", e.ON_REMOVE_STREAM = "io.agora.pb.Wrtc.OnRemoveStream", e.JOIN_CHANNEL_TIMEOUT = "io.agora.pb.Wrtc.JoinChannelTimeout", e.PEER_PUBLISH_STATUS = "io.agora.pb.Wrtc.PeerPublishStatus", e.WORKER_EVENT = "io.agora.pb.Wrtc.WorkerEvent", e.AP_WORKER_EVENT = "io.agora.pb.Wrtc.APWorkerEvent", e.JOIN_WEB_PROXY_AP = "io.agora.pb.Wrtc.JoinWebProxyAP", e.WEBSOCKET_QUIT = "io.agora.pb.Wrtc.WebSocketQuit", e.USER_ANALYTICS = "io.agora.pb.Wrtc.UserAnalytics", e.AUTOPLAY_FAILED = "io.agora.pb.Wrtc.AutoplayFailed", e.PC_STATS = "io.agora.pb.Wrtc.PCStats", e.UPDATE_REMOTE_RTPCAPABILITIES = "io.agora.pb.Wrtc.UpdateRemoteRTPCapabilities", e;
    }({});
    (function(e) {
      e[e.WORKER_EVENT = 156] = "WORKER_EVENT", e[e.AP_WORKER_EVENT = 160] = "AP_WORKER_EVENT";
    })({});
    let sse = function(e) {
      return e[e.SESSION = 26] = "SESSION", e[e.JOIN_CHOOSE_SERVER = 27] = "JOIN_CHOOSE_SERVER", e[e.REQ_USER_ACCOUNT = 196] = "REQ_USER_ACCOUNT", e[e.JOIN_GATEWAY = 28] = "JOIN_GATEWAY", e[e.PUBLISH = 30] = "PUBLISH", e[e.SUBSCRIBE = 29] = "SUBSCRIBE", e[e.WS_COMPRESSOR_INIT = 9430] = "WS_COMPRESSOR_INIT", e[e.STREAM_SWITCH = 32] = "STREAM_SWITCH", e[e.AUDIO_SENDING_STOPPED = 33] = "AUDIO_SENDING_STOPPED", e[e.VIDEO_SENDING_STOPPED = 34] = "VIDEO_SENDING_STOPPED", e[e.REQUEST_PROXY_APPCENTER = 35] = "REQUEST_PROXY_APPCENTER", e[e.REQUEST_PROXY_WORKER_MANAGER = 36] = "REQUEST_PROXY_WORKER_MANAGER", e[e.API_INVOKE = 41] = "API_INVOKE", e[e.FIRST_VIDEO_RECEIVED = 348] = "FIRST_VIDEO_RECEIVED", e[e.FIRST_AUDIO_RECEIVED = 349] = "FIRST_AUDIO_RECEIVED", e[e.FIRST_VIDEO_DECODE = 350] = "FIRST_VIDEO_DECODE", e[e.FIRST_AUDIO_DECODE = 351] = "FIRST_AUDIO_DECODE", e[e.ON_ADD_AUDIO_STREAM = 352] = "ON_ADD_AUDIO_STREAM", e[e.ON_ADD_VIDEO_STREAM = 353] = "ON_ADD_VIDEO_STREAM", e[e.ON_UPDATE_STREAM = 356] = "ON_UPDATE_STREAM", e[e.ON_REMOVE_STREAM = 355] = "ON_REMOVE_STREAM", e[e.JOIN_CHANNEL_TIMEOUT = 407] = "JOIN_CHANNEL_TIMEOUT", e[e.PEER_PUBLISH_STATUS = 408] = "PEER_PUBLISH_STATUS", e[e.WORKER_EVENT = 156] = "WORKER_EVENT", e[e.AP_WORKER_EVENT = 160] = "AP_WORKER_EVENT", e[e.JOIN_WEB_PROXY_AP = 700] = "JOIN_WEB_PROXY_AP", e[e.WEBSOCKET_QUIT = 671] = "WEBSOCKET_QUIT", e[e.USER_ANALYTICS = 1e4] = "USER_ANALYTICS", e[e.AUTOPLAY_FAILED = 9178] = "AUTOPLAY_FAILED", e;
    }({});
    function Dn() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return function(n, i, o) {
        const f = o.value;
        if (typeof f == "function") {
          const T = e.className || n.__className__ || (n.constructor.name === "AgoraRTCClient" ? "Client" : n.constructor.name);
          o.value = function() {
            for (var A, R = arguments.length, P = new Array(R), L = 0; L < R; L++) P[L] = arguments[L];
            let z = P;
            if (e.argsMap) try {
              z = e.argsMap(this, ...P);
            } catch (te) {
              Ee.warning(te), z = [];
            }
            try {
              JSON.stringify(z);
            } catch {
              Ee.warning("arguments for method ".concat(T, ".").concat(String(i), " not serializable for apiInvoke.")), z = [];
            }
            const Y = (e.report || Cn).reportApiInvoke(this._sessionId || null, { id: this._clientId || ((A = this.store) === null || A === void 0 ? void 0 : A.clientId) || this._ID, name: "".concat(T, ".").concat(String(i)), options: z, tag: si.TRACER, reportResult: e.reportResult }, e.throttleTime);
            try {
              const te = f.apply(this, P);
              return te instanceof cn ? te.then((oe) => (Y.onSuccess(e.reportResult && oe), oe)).catch((oe) => {
                throw Y.onError(oe), oe;
              }) : (Y.onSuccess(e.reportResult && te), te);
            } catch (te) {
              throw Y.onError(te), te;
            }
          };
        }
        return o;
      };
    }
    const Cn = new class {
      constructor() {
        oi(this, "baseInfoMap", /* @__PURE__ */ new Map()), oi(this, "proxyServer", void 0), oi(this, "eventUploadTimer", void 0), oi(this, "setSessionIdTimer", void 0), oi(this, "url", void 0), oi(this, "sids", /* @__PURE__ */ new Set()), oi(this, "backupUrl", void 0), oi(this, "_appId", void 0), oi(this, "_aid", 0), oi(this, "keyEventUploadPendingItems", []), oi(this, "normalEventUploadPendingItems", []), oi(this, "apiInvokeUploadPendingItems", []), oi(this, "apiInvokeCount", 0), oi(this, "apiInvokeLoggedCount", 0), oi(this, "ltsList", []), oi(this, "lastSendNormalEventTime", Date.now()), oi(this, "customReportCounterTimer", void 0), oi(this, "customReportCount", 0), oi(this, "extApiInvoke", async (e) => {
          for (const n of e) {
            const i = Kn(Kn({}, n), {}, { sid: null, invokeId: ++this.apiInvokeCount, tag: si.TRACER });
            this.sendApiInvoke(i);
          }
        }), this.eventUploadTimer = window.setInterval(this.doSend.bind(this), ft("EVENT_REPORT_SEND_INTERVAL")), this.setSessionIdTimer = window.setInterval(this.appendSessionId.bind(this), ft("EVENT_REPORT_SEND_INTERVAL"));
      }
      getBaseInfoBySessionId(e) {
        return this.baseInfoMap.get(e);
      }
      setAppId(e) {
        this._appId = e, this._aid = parseInt(e.replace(/[a-fA-F0-9]{8}/g, (n) => {
          let [i, o] = n;
          return i + o;
        }), 16) || 0;
      }
      reportApiInvoke(e, n, i) {
        n.timeout = n.timeout || 6e4, n.reportResult = n.reportResult === void 0 || n.reportResult;
        const o = Date.now();
        this.apiInvokeCount += 1;
        const f = this.apiInvokeCount, T = !!ft("SHOW_REPORT_INVOKER_LOG"), A = !!ft("SHOW_REPORT_USER_INVOKER_LOG"), R = T || A && n.id;
        R && (this.apiInvokeLoggedCount += 1);
        const P = this.apiInvokeLoggedCount;
        function L(oe, He) {
          if (R) {
            let Re = "[apiInvoke-".concat(P, "]");
            n.id && (Re += "[".concat(n.id, "]")), n.name && (Re += "[".concat(n.name, "]")), Ee.info("".concat(Re, " ").concat(oe), oe === "start" ? n.options : He || "");
          }
        }
        const z = () => ({ tag: n.tag, invokeId: f, sid: e, name: n.name, apiInvokeTime: o, options: n.options, states: n.states || null });
        L("start");
        let Y = !1;
        Es(n.timeout).then(() => {
          Y || (this.sendApiInvoke(Kn(Kn({}, z()), {}, { error: Je.API_INVOKE_TIMEOUT, success: !1 })), L("timeout"));
        });
        const te = new Gt(Je.UNEXPECTED_ERROR, "".concat(n.name, ": this api invoke is end"));
        return { onSuccess: (oe) => {
          const He = () => {
            if (Y) throw te;
            return Y = !0, this.sendApiInvoke(Kn(Kn({}, z()), {}, { success: !0 }, n.reportResult && { result: oe })), L("onSuccess"), oe;
          };
          return i ? u5(He, n.name + "Success", i, () => Y = !0) : He();
        }, onError: (oe) => {
          const He = () => {
            if (Y) throw oe;
            Y = !0, this.sendApiInvoke(Kn(Kn({}, z()), {}, { success: !1, error: oe })), L("onFailure", oe.toString());
          };
          return i ? u5(He, n.name + "Error", i, () => Y = !0) : He();
        } };
      }
      sessionInit(e, n) {
        if (this.baseInfoMap.has(e)) return;
        const i = Date.now(), o = this.createBaseInfo(e, i);
        o.cname = n.cname;
        const f = Object.assign({}, { willUploadConsoleLog: ft("UPLOAD_LOG"), maxTouchPoints: navigator.maxTouchPoints, areaVersion: XS ? "global" : "oversea", areas: ft("AREAS") && ft("AREAS").join(",") }, n.extend), { stringUid: T, channelProfile: A, channelMode: R, isABTestSuccess: P, lsid: L, clientRole: z } = n, Y = Date.now(), te = Kn(Kn({}, o), {}, { eventType: us.SESSION_INIT, appid: n.appid, browser: navigator.userAgent, buildFormat: n.buildFormat, build: qS, lts: Y, elapse: Y - i, extend: JSON.stringify(f), mode: n.mode, process: ft("PROCESS_ID"), appType: ft("APP_TYPE"), success: !0, version: Ro, stringUid: T, channelProfile: A, channelMode: R, isABTestSuccess: P, lsid: L, clientType: on(oe = window.navigator.userAgent).call(oe, "AgoraWebView") ? 42 : 20, clientRole: z, serviceId: ft("PROCESS_ID"), extensionID: ft("PLUGIN_INFO").join(",") || "" });
        var oe;
        this.send({ type: ti.SESSION, data: te }, !0);
      }
      joinChooseServer(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { role: n.role, eventType: us.JOIN_CHOOSE_SERVER, lts: f, eventElapse: n.elapse || f - n.lts, chooseServerAddr: n.csAddr, errorCode: n.ec, elapse: f - i.startTime, success: n.succ, chooseServerAddrList: JSON.stringify(n.serverList), uid: n.uid ? parseInt(n.uid) : null, cid: n.cid ? parseInt(n.cid) : null, chooseServerIp: n.csIp || "", opid: n.opid, unilbsServerIds: n.unilbsServerIds, extend: n.extend || void 0, isHttp3: n.isHttp3, corssRegionTagReq: n.corssRegionTagReq || void 0, corssRegionTagRes: n.corssRegionTagRes || void 0 });
        this.send({ type: ti.JOIN_CHOOSE_SERVER, data: T }, !0);
      }
      reqUserAccount(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { eventType: us.REQ_USER_ACCOUNT, lts: f, success: n.success, serverAddress: n.serverAddr, stringUid: n.stringUid, uid: n.uid, errorCode: n.errorCode, elapse: n.elapse || f - i.startTime, eventElapse: f - n.lts, extend: JSON.stringify(n.extend) });
        this.send({ type: ti.REQ_USER_ACCOUNT, data: T }, !0);
      }
      joinGateway(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info;
        n.vid && (o.vid = n.vid), o.uid = n.uid, o.cid = n.cid;
        const f = Date.now(), { firstSuccess: T, avoidJoinStartTime: A, addr: R, isProxy: P } = n, L = f - (T && A ? A : i.startTime), z = Kn(Kn({}, o), {}, { eventType: us.JOIN_GATEWAY, lts: f, gatewayAddr: n.addr, success: n.succ, errorCode: n.ec, errorMsg: n.errorMsg || "", elapse: L, eventElapse: f - n.lts, firstSuccess: T, signalChannel: n.signalChannel, preload: n.preload ? 1 : 0 }), Y = z.success ? 1 : 0;
        if (n.succ && (i.lastJoinSuccessTime = f), T) this.send({ type: ti.JOIN_GATEWAY, data: z }, !0);
        else {
          let te;
          if (R) if (P) {
            const He = R.match(/h=(\d{1,3}-){3}\d{1,3}/g), Re = R.match(/p=[0-9]{1,6}/g);
            te = { isSuccess: Y, gatewayIp: He && He.length ? He[0].split("=")[1].replace(/-/g, ".") : "", port: Re && Re.length ? Re[0].split("=")[1] : "", isProxy: P ? 1 : 0 };
          } else {
            const He = R.match(/wss:\/\/(\d{1,3}-){3}\d{1,3}/g), Re = R.match(/(:|p=)[0-9]{1,6}/g);
            te = { isSuccess: Y, gatewayIp: He && He.length ? He[0].split("//")[1].replace(/-/g, ".") : "", port: Re && Re.length ? Re[0].split(/:|p=/g)[1] : "", isProxy: P ? 1 : 0 };
          }
          else te = { isSuccess: Y, gatewayIp: "", port: "", isProxy: P ? 1 : 0 };
          delete z.success, delete z.eventType, delete z.firstSuccess, z.vid = Number(z.vid);
          const oe = Object.assign({}, z, te, { eventType: us.REJOIN_GATEWAY });
          this.send({ type: ti.RE_JOIN_GATEWAY, data: oe }, !0);
        }
      }
      joinChannelTimeout(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = Date.now(), f = Kn(Kn({}, i.info), {}, { lts: o, timeout: n, elapse: o - i.startTime });
        this.send({ type: ti.JOIN_CHANNEL_TIMEOUT, data: f }, !0);
      }
      publish(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { eventType: us.PUBLISH, lts: f, eventElapse: n.eventElapse, elapse: f - i.startTime, success: n.succ, errorCode: n.ec, videoName: n.videoName, audioName: n.audioName, screenName: n.screenName, screenshare: n.screenshare, audio: n.audio, video: n.video, p2pid: n.p2pid, publishRequestid: n.publishRequestid });
        this.send({ type: ti.PUBLISH, data: T }, !0);
      }
      subscribe(e, n, i) {
        const o = this.baseInfoMap.get(e);
        if (!o) return;
        const f = o.info, T = Date.now(), A = Kn(Kn({}, f), {}, { eventType: us.SUBSCRIBE, lts: T, eventElapse: n.eventElapse, elapse: T - o.startTime, success: n.succ, errorCode: n.ec, video: n.video, audio: n.audio, subscribeRequestid: n.subscribeRequestid, p2pid: n.p2pid, preSsrc: n.preSsrc ? 1 : 0 }, i && { extend: JSON.stringify({ isMassSubscribe: !0 }) });
        typeof n.peerid == "string" ? A.peerSuid = n.peerid : A.peer = n.peerid, this.send({ type: ti.SUBSCRIBE, data: A }, !0);
      }
      wsCompressorInit(e) {
        var n;
        const i = [...ro(n = this.baseInfoMap).call(n)], o = i.length ? i[0] : "UnableToGetSid", f = this.baseInfoMap.get(o);
        if (!f) return;
        const T = f.info, A = Date.now(), R = Kn(Kn({}, T), {}, { eventType: us.WS_COMPRESSOR_INIT, lts: A, eventElapse: e.eventElapse, elapse: A - f.startTime, status: e.status ? 1 : 2 });
        this.send({ type: ti.WS_COMPRESSOR_INIT, data: R }, !0);
      }
      firstRemoteVideoDecode(e, n, i, o) {
        const f = this.baseInfoMap.get(e);
        if (!f) return;
        const T = f.info, A = Date.now(), R = Kn(Kn(Kn({}, T), o), {}, { elapse: A - f.startTime, eventType: n, lts: A, firstDecodeFrame: Math.max((o.firstFrame || A) - f.startTime, 0), apEnd: Math.max(o.apEnd - f.startTime, 0), apStart: Math.max(o.apStart - f.startTime, 0), joinGwEnd: Math.max(o.joinGwEnd - f.startTime, 0), joinGwStart: Math.max(o.joinGwStart - f.startTime, 0), pcEnd: Math.max(o.pcEnd - f.startTime, 0), pcStart: Math.max(o.pcStart - f.startTime, 0), subscriberEnd: Math.max(o.subscriberEnd - f.startTime, 0), subscriberStart: Math.max(o.subscriberStart - f.startTime, 0), videoAddNotify: Math.max(o.videoAddNotify - f.startTime, 0) });
        this.send({ type: i, data: R }, !0);
      }
      firstRemoteFrame(e, n, i, o) {
        const f = this.baseInfoMap.get(e);
        if (!f) return;
        const T = f.info, A = Date.now(), R = Kn(Kn(Kn({}, T), o), {}, { elapse: A - f.startTime, eventType: n, lts: A });
        this.send({ type: i, data: R }, !0);
      }
      pcStats(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn(Kn({}, o), n), {}, { vid: o.vid === void 0 ? 0 : Number(o.vid), elapse: f - i.startTime, eventType: us.PC_STATS, lts: f, preallocation: n.preallocation ? 1 : 0 });
        this.send({ type: ti.PC_STATS, data: T }, !0);
      }
      updateRemoteRTPCapabilities(e, n) {
        if (e) {
          const i = this.baseInfoMap.get(e);
          if (!i) return;
          const o = i.info, f = Date.now(), T = Kn(Kn(Kn({}, o), n), {}, { vid: o.vid === void 0 ? 0 : Number(o.vid), eventType: us.UPDATE_REMOTE_RTPCAPABILITIES, lts: f });
          this.send({ type: ti.UPDATE_REMOTE_RTPCAPABILITIES, data: T }, !0);
        }
      }
      onGatewayStream(e, n, i, o) {
        const f = this.baseInfoMap.get(e);
        if (!f) return;
        const T = f.info, A = Date.now(), R = Kn(Kn(Kn({}, T), o), {}, { eventType: n, lts: A });
        this.send({ type: i, data: R }, !0);
      }
      streamSwitch(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { eventType: us.STREAM_SWITCH, lts: f, isDual: n.isdual, elapse: f - i.startTime, success: n.succ });
        this.send({ type: ti.STREAM_SWITCH, data: T }, !0);
      }
      requestProxyAppCenter(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { eventType: us.REQUEST_PROXY_APPCENTER, lts: f, eventElapse: f - n.lts, elapse: f - i.startTime, APAddr: n.APAddr, workerManagerList: n.workerManagerList, response: n.response, errorCode: n.ec, success: n.succ });
        this.send({ type: ti.REQUEST_PROXY_APPCENTER, data: T }, !0);
      }
      requestProxyWorkerManager(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { eventType: us.REQUEST_PROXY_WORKER_MANAGER, lts: f, eventElapse: f - n.lts, elapse: f - i.startTime, workerManagerAddr: n.workerManagerAddr, response: n.response, errorCode: n.ec, success: n.succ });
        this.send({ type: ti.REQUEST_PROXY_WORKER_MANAGER, data: T }, !0);
      }
      setProxyServer(e) {
        this.proxyServer = e, e ? Ee.debug("reportProxyServerurl: ".concat(e)) : Ee.debug("disable reportProxyServerurl: ".concat(e));
      }
      peerPublishStatus(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn({}, o), {}, { subscribeElapse: n.subscribeElapse, peer: n.peer, peerPublishDuration: Math.max(n.audioPublishDuration, n.videoPublishDuration), audiotag: n.audioPublishDuration > 0 ? 1 : -1, videotag: n.videoPublishDuration > 0 ? 1 : -1, lts: f, elapse: f - i.startTime, joinChannelSuccessElapse: f - (i.lastJoinSuccessTime || f), peerPublishDurationVideo: n.videoPublishDuration, peerPublishDurationAudio: n.audioPublishDuration });
        this.send({ type: ti.PEER_PUBLISH_STATUS, data: T }, !0);
      }
      workerEvent(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now();
        (function(T, A, R) {
          const P = T[A];
          if (!P || typeof P != "string") return [T];
          T[A] = "";
          const L = mu(JSON.stringify(T));
          let z = 0;
          const Y = [];
          let te = 0;
          for (let oe = 0; oe < P.length; oe++) te += P.charCodeAt(oe) <= 127 ? 1 : 3, te <= R - L || (Y[Y.length] = yn(yn({}, T), {}, { [A]: P.substring(z, oe) }), z = oe, te = P.charCodeAt(oe) <= 127 ? 1 : 3);
          return z !== P.length - 1 && (Y[Y.length] = yn(yn({}, T), {}, { [A]: P.substring(z) })), Y;
        })(Kn(Kn(Kn({}, o), n), {}, { elapse: f - i.startTime, lts: f, productType: "WebRTC" }), "payload", 1300).forEach((T) => this.send({ type: ti.WORKER_EVENT, data: T }, !0));
      }
      apworkerEvent(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn(Kn({}, o), n), {}, { elapse: f - i.startTime, lts: f });
        this.send({ type: ti.AP_WORKER_EVENT, data: T }, !0);
      }
      joinWebProxyAP(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn(Kn({}, o), n), {}, { elapse: f - i.startTime, lts: f, extend: n.extend || void 0 });
        this.send({ type: ti.JOIN_WEB_PROXY_AP, data: T }, !0);
      }
      WebSocketQuit(e, n) {
        const i = this.baseInfoMap.get(e);
        if (!i) return;
        const o = i.info, f = Date.now(), T = Kn(Kn(Kn({}, o), n), {}, { elapse: f - i.startTime, lts: f });
        this.send({ type: ti.WEBSOCKET_QUIT, data: T }, !0);
      }
      async sendCustomReportMessage(e, n) {
        if (this.customReportCount += n.length, this.customReportCount > ft("CUSTOM_REPORT_LIMIT")) throw new Gt(Je.CUSTOM_REPORT_FREQUENCY_TOO_HIGH);
        this.customReportCounterTimer || (this.customReportCounterTimer = window.setInterval(() => {
          this.customReportCount = 0;
        }, 5e3));
        const i = Date.now(), o = n.map((f) => ({ type: ti.USER_ANALYTICS, data: Kn(Kn({ sid: e }, f), {}, { lts: i }) }));
        try {
          ft("NEW_REPORT_SERVER") ? await this.postDataToStatsCollector2(o) : await this.postDataToStatsCollector(o);
        } catch (f) {
          throw Ee.error("send custom report message failed", f.toString()), new Gt(Je.CUSTOM_REPORT_SEND_FAILED, f.message);
        }
      }
      sendApiInvoke(e) {
        const n = ft("NOT_REPORT_EVENT");
        if (e.tag && on(n) && on(n).call(n, e.tag)) return !1;
        if (e.sid === null) return this.apiInvokeUploadPendingItems.push(e), !1;
        const i = this.baseInfoMap.get(e.sid);
        if (!i) return this.apiInvokeUploadPendingItems.push(e), !1;
        const { cname: o, uid: f, cid: T } = i.info;
        let A;
        if (e.lts = e.lts || Date.now(), e.error) if (e.error instanceof Gt) {
          const { code: P, message: L } = e.error;
          A = P || L || e.error.toString();
        } else A = e.error.toString();
        const R = { invokeId: e.invokeId, sid: e.sid, cname: o, cid: T, uid: f, lts: e.lts, success: e.success, elapse: e.lts - i.startTime, execElapse: e.lts - e.apiInvokeTime, apiName: e.name, options: e.options ? JSON.stringify(e.options) : void 0, execStates: e.states ? JSON.stringify(e.states) : void 0, execResult: e.result ? JSON.stringify(e.result) : void 0, errorCode: e.error ? A : void 0, errorMsg: e.error ? JSON.stringify(e.error) : void 0 };
        return this.send({ type: ti.API_INVOKE, data: R }, !1), !0;
      }
      addSid(e) {
        this.sids.add(e);
      }
      removeSid(e) {
        this.sids.delete(e);
      }
      appendSessionId() {
        const e = this.apiInvokeUploadPendingItems;
        if (e.length === 0) return;
        const n = Array.from(this.sids).find((i) => i !== null);
        n && e.forEach((i) => {
          i && (i.sid = n, this.sendApiInvoke(Object.assign({}, i)));
        }), e.length = 0;
      }
      send(e, n) {
        if (n) return this.keyEventUploadPendingItems.push(e), void this.sendItems(this.keyEventUploadPendingItems, !0);
        this.normalEventUploadPendingItems.push(e), this.normalEventUploadPendingItems.length > ft("NORMAL_EVENT_QUEUE_CAPACITY") && this.normalEventUploadPendingItems.splice(0, 1), this.normalEventUploadPendingItems.length >= 10 && this.sendItems(this.normalEventUploadPendingItems, !1);
      }
      doSend() {
        this.keyEventUploadPendingItems.length > 0 && this.sendItems(this.keyEventUploadPendingItems, !0), this.normalEventUploadPendingItems.length > 0 && Date.now() - this.lastSendNormalEventTime >= 5e3 && this.sendItems(this.normalEventUploadPendingItems, !1);
      }
      sendItems(e, n) {
        const i = [], o = [];
        for (; e.length; ) {
          const T = e.shift();
          i.length < 20 ? i.push(T) : o.push(T);
        }
        e.push(...o);
        for (const T of [...i]) {
          var f;
          this.ltsList.indexOf(T.data.lts) !== -1 ? (T.data.lts = this.ltsList[this.ltsList.length - 1] + 1, this.ltsList.push(T.data.lts)) : (this.ltsList.push(T.data.lts), hE(f = this.ltsList).call(f, (A, R) => A - R));
        }
        return n || (this.lastSendNormalEventTime = Date.now()), ft("ENABLE_EVENT_REPORT") && i.length && (ft("NEW_REPORT_SERVER") ? this.postDataToStatsCollector2(i) : this.postDataToStatsCollector(i)).catch(/* @__PURE__ */ ((T) => (A) => {
          ft("EVENT_REPORT_RETRY") && (n ? this.keyEventUploadPendingItems = this.keyEventUploadPendingItems.concat(T) : (this.normalEventUploadPendingItems = this.normalEventUploadPendingItems.concat(T), this.normalEventUploadPendingItems.length > ft("NORMAL_EVENT_QUEUE_CAPACITY") && (this.normalEventUploadPendingItems.splice(0, this.normalEventUploadPendingItems.length - ft("NORMAL_EVENT_QUEUE_CAPACITY")), Ee.warning("report: drop normal events"))));
        })(i)), e;
      }
      async postDataToStatsCollector2(e) {
        Mi.networkState === Fa.OFFLINE && await cn.race([Mi.onlineWaiter, Es(2 * zi.maxRetryTimeout)]);
        const n = (f) => {
          let T = new Uint8Array();
          return f.forEach((A) => {
            const R = MS(JSON.stringify(A.data)), P = new ArrayBuffer(5), L = ((Y) => {
              let te = 0;
              return Object.entries(ti).forEach((oe) => {
                let [He, Re] = oe;
                Re === Y.type && (te = sse[He]);
              }), te;
            })(A), z = new DataView(P);
            z.setUint16(0, R.byteLength, !0), z.setUint8(2, 255 & L), z.setUint8(3, L >>> 8 & 255), z.setUint8(4, L >>> 16 & 255), T = e5(T, new Uint8Array(P)), T = e5(T, R);
          }), T;
        }, i = "event";
        let o = this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(ft("NEW_REPORT_SERVER_DOMAINS")[0], "&p=443&d=").concat(i) : "https://".concat(ft("NEW_REPORT_SERVER_DOMAINS")[0], "/").concat(i);
        for (let f = 0; f < 2; f += 1) {
          f === 1 && (o = this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(ft("NEW_REPORT_SERVER_DOMAINS")[1], "&p=443&d=").concat(i) : "https://".concat(ft("NEW_REPORT_SERVER_DOMAINS")[1], "/").concat(i));
          try {
            await zS(o, { timeout: 1e4, data: n(e), headers: Kn(Kn({ biz: "webrtc", sendts: Math.round(Date.now() / 1e3), debug: "false" }, this._appId && { appid: this._appId }), {}, { "Content-Type": "application/octet-stream" }) }, !0);
          } catch (T) {
            if (f === 1) throw T;
            continue;
          }
          return;
        }
      }
      async postDataToStatsCollector(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
        const i = ((R) => {
          const P = R && R.data.sid && this.baseInfoMap.get(R.data.sid);
          return P && P.info.vid && +P.info.vid || 0;
        })(e[0]), o = i ? void 0 : this._aid, f = { msgType: "EventMessages", sentTs: Math.round(Date.now() / 1e3), payloads: e.map((R) => JSON.stringify(R)), vid: i, aid: o };
        Mi.networkState === Fa.OFFLINE && await cn.race([Mi.onlineWaiter, Es(2 * zi.maxRetryTimeout)]);
        const T = n ? "/events/proto-raws" : "/events/messages";
        let A = this.url || (this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(ft("EVENT_REPORT_DOMAIN"), "&p=").concat(ft("STATS_COLLECTOR_PORT"), "&d=").concat(T) : "https://".concat(ft("EVENT_REPORT_DOMAIN"), ":").concat(ft("STATS_COLLECTOR_PORT")).concat(T));
        for (let R = 0; R < 2; R += 1) {
          R === 1 && (A = this.backupUrl || (this.proxyServer ? "https://".concat(this.proxyServer, "/rs/?h=").concat(ft("EVENT_REPORT_BACKUP_DOMAIN"), "&p=").concat(ft("STATS_COLLECTOR_PORT"), "&d=").concat(T) : "https://".concat(ft("EVENT_REPORT_BACKUP_DOMAIN"), ":").concat(ft("STATS_COLLECTOR_PORT")).concat(T)));
          try {
            n ? await Vie(A, { timeout: 1e4, data: f }) : await zS(A, { timeout: 1e4, data: f });
          } catch (P) {
            if (R === 1) throw P;
            continue;
          }
          return;
        }
      }
      createBaseInfo(e, n) {
        const i = Object.assign({}, ise);
        return i.sid = e, this.baseInfoMap.set(e, { info: i, startTime: n }), i;
      }
      reportResourceTiming(e, n) {
        const i = performance.getEntriesByName(e), o = i[i.length - 1];
        o && this.reportApiInvoke(n, { name: "Client.resourceTiming", options: o, tag: si.TRACER }).onSuccess();
      }
    }();
    I5.on("REPORT_LOG_UPLOAD", (e) => {
      e.networkState = Mi.networkState, Cn.reportApiInvoke(null, { name: "logUploadError", options: e, tag: si.TRACER }).onSuccess("logUploadError");
    });
    class jt extends Gt {
      constructor(n) {
        super(n, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", arguments.length > 2 ? arguments[2] : void 0), oi(this, "name", "AgoraRTCException");
      }
      print() {
        let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "error";
        return super.print(n, Ee);
      }
      throw() {
        super.throw(Ee);
      }
    }
    const ys = { getDisplayMedia: !1, getStreamFromExtension: !1, supportUnifiedPlan: !1, supportMinBitrate: !1, supportSetRtpSenderParameters: !1, supportDualStream: !0, webAudioMediaStreamDest: !1, supportReplaceTrack: !1, supportWebGL: !1, webAudioWithAEC: !1, supportRequestFrame: !1, supportShareAudio: !1, supportDualStreamEncoding: !1, supportDataChannel: !1, supportPCSetConfiguration: !1, supportWebRTCEncodedTransform: !1, supportWebRTCInsertableStream: !1, supportRequestVideoFrameCallback: !1, supportWebCrypto: !1 };
    function pr() {
      return ys;
    }
    function w5() {
      return "setSinkId" in HTMLAudioElement.prototype && (!ft("RESTRICTION_SET_PLAYBACK_DEVICE") || ($d() || FM()) && !PS());
    }
    function _5() {
      return !ys.supportUnifiedPlan || ft("CHROME_FORCE_PLAN_B") && ad();
    }
    let vs = function(e) {
      return e.IOS_15_16_INTERRUPTION_START = "ios15_16-interruption-start", e.IOS_15_16_INTERRUPTION_END = "ios15_16-interruption-end", e.IOS_INTERRUPTION_START = "ios-interruption-start", e.IOS_INTERRUPTION_END = "ios-interruption-end", e.STATE_CHANGE = "state-change", e;
    }({});
    function op(e, n, i) {
      return { sampleRate: e, stereo: n, bitrate: i };
    }
    function lr(e, n, i, o, f) {
      return { width: e, height: n, frameRate: i, bitrateMin: o, bitrateMax: f };
    }
    function sc(e, n, i, o, f) {
      return { width: { max: e }, height: { max: n }, frameRate: i, bitrateMin: o, bitrateMax: f };
    }
    function ZS(e, n) {
      return { numSpatialLayers: e, numTemporalLayers: n };
    }
    const ase = { "90p": lr(160, 90), "90p_1": lr(160, 90), "120p": lr(160, 120, 15, 30, 65), "120p_1": lr(160, 120, 15, 30, 65), "120p_3": lr(120, 120, 15, 30, 50), "120p_4": lr(212, 120), "180p": lr(320, 180, 15, 30, 140), "180p_1": lr(320, 180, 15, 30, 140), "180p_3": lr(180, 180, 15, 30, 100), "180p_4": lr(240, 180, 15, 30, 120), "240p": lr(320, 240, 15, 40, 200), "240p_1": lr(320, 240, 15, 40, 200), "240p_3": lr(240, 240, 15, 40, 140), "240p_4": lr(424, 240, 15, 40, 220), "360p": lr(640, 360, 15, 80, 400), "360p_1": lr(640, 360, 15, 80, 400), "360p_3": lr(360, 360, 15, 80, 260), "360p_4": lr(640, 360, 30, 80, 600), "360p_6": lr(360, 360, 30, 80, 400), "360p_7": lr(480, 360, 15, 80, 320), "360p_8": lr(480, 360, 30, 80, 490), "360p_9": lr(640, 360, 15, 80, 800), "360p_10": lr(640, 360, 24, 80, 800), "360p_11": lr(640, 360, 24, 80, 1e3), "480p": lr(640, 480, 15, 100, 500), "480p_1": lr(640, 480, 15, 100, 500), "480p_2": lr(640, 480, 30, 100, 1e3), "480p_3": lr(480, 480, 15, 100, 400), "480p_4": lr(640, 480, 30, 100, 750), "480p_6": lr(480, 480, 30, 100, 600), "480p_8": lr(848, 480, 15, 100, 610), "480p_9": lr(848, 480, 30, 100, 930), "480p_10": lr(640, 480, 10, 100, 400), "720p": lr(1280, 720, 15, 120, 1130), "720p_auto": lr(1280, 720, 30, 900, 3e3), "720p_1": lr(1280, 720, 15, 120, 1130), "720p_2": lr(1280, 720, 30, 120, 2e3), "720p_3": lr(1280, 720, 30, 120, 1710), "720p_5": lr(960, 720, 15, 120, 910), "720p_6": lr(960, 720, 30, 120, 1380), "1080p": lr(1920, 1080, 15, 120, 2080), "1080p_1": lr(1920, 1080, 15, 120, 2080), "1080p_2": lr(1920, 1080, 30, 120, 3e3), "1080p_3": lr(1920, 1080, 30, 120, 3150), "1080p_5": lr(1920, 1080, 60, 120, 4780), "1440p": lr(2560, 1440, 30, 120, 4850), "1440p_1": lr(2560, 1440, 30, 120, 4850), "1440p_2": lr(2560, 1440, 60, 120, 7350), "4k": lr(3840, 2160, 30, 120, 8910), "4k_1": lr(3840, 2160, 30, 120, 8910), "4k_3": lr(3840, 2160, 60, 120, 13500) }, ose = { "480p": sc(640, 480, 5), "480p_1": sc(640, 480, 5), "480p_2": sc(640, 480, 30), "480p_3": sc(640, 480, 15), "720p": sc(1280, 720, 5), "720p_auto": lr(1280, 720, 30, 900, 3e3), "720p_1": sc(1280, 720, 5), "720p_2": sc(1280, 720, 30), "720p_3": sc(1280, 720, 15), "1080p": sc(1920, 1080, 5), "1080p_1": sc(1920, 1080, 5), "1080p_2": sc(1920, 1080, 30), "1080p_3": sc(1920, 1080, 15) }, cse = { "1SL1TL": ZS(1, 1), "3SL3TL": ZS(3, 3), "2SL3TL": ZS(2, 3) };
    function yu(e) {
      return e || (e = "480p_1"), typeof e == "string" ? Object.assign({}, ase[e]) : e;
    }
    function QS(e) {
      return typeof e == "string" ? Object.assign({}, ose[e]) : e;
    }
    function yT(e) {
      return typeof e == "string" ? Object.assign({}, cse[e]) : e;
    }
    const use = { speech_low_quality: op(16e3, !1), speech_standard: op(32e3, !1, 18), music_standard: op(48e3, !1), standard_stereo: op(48e3, !0, 56), high_quality: op(48e3, !1, 128), high_quality_stereo: op(48e3, !0, 192) };
    function vT(e) {
      return typeof e == "string" ? Object.assign({}, use[e]) : e;
    }
    const cp = [];
    function P5(e) {
      return $i(e, "mediaSource", ["screen", "window", "application"]), !0;
    }
    let Tn = function(e) {
      return e.NEED_RENEGOTIATE = "@need_renegotiate", e.NEED_REPLACE_TRACK = "@need_replace_track", e.NEED_REPLACE_MIXING_TRACK = "@need_replace_mixing_track", e.NEED_CLOSE = "@need_close", e.NEED_ENABLE_TRACK = "@need_enable_track", e.NEED_DISABLE_TRACK = "@need_disable_track", e.NEED_SESSION_ID = "@need_sid", e.SET_OPTIMIZATION_MODE = "@set_optimization_mode", e.GET_STATS = "@get_stats", e.GET_RTC_STATS = "@get_rtc_stats", e.GET_LOW_VIDEO_TRACK = "@get_low_video_track", e.NEED_RESET_REMOTE_SDP = "@need_reset_remote_sdp", e.NEED_UPDATE_VIDEO_ENCODER = "@need_update_video_encoder", e.NEED_UPDATE_VIDEO_SEND_PARAMETERS = "@need_update_video_send_parameters", e.NEED_MUTE_TRACK = "@need_mute_track", e.NEED_UNMUTE_TRACK = "@need_unmute_track", e;
    }({}), Fr = function(e) {
      return e.SCREEN_TRACK = "screen_track", e.CUSTOM_TRACK = "custome_track", e.LOW_STREAM = "low_stream", e.SCREEN_LOW_TRACK = "screen_low_track", e;
    }({}), up = function(e) {
      return e[e.HIGH_STREAM = 0] = "HIGH_STREAM", e[e.LOW_STREAM = 1] = "LOW_STREAM", e;
    }({}), dse = function(e) {
      return e[e.HIGH_STREAM = 0] = "HIGH_STREAM", e[e.LOW_STREAM = 1] = "LOW_STREAM", e[e.HIGH_STREAM_LAYER1 = 4] = "HIGH_STREAM_LAYER1", e[e.HIGH_STREAM_LAYER2 = 5] = "HIGH_STREAM_LAYER2", e[e.HIGH_STREAM_LAYER3 = 6] = "HIGH_STREAM_LAYER3", e[e.HIGH_STREAM_LAYER4 = 7] = "HIGH_STREAM_LAYER4", e[e.HIGH_STREAM_LAYER5 = 8] = "HIGH_STREAM_LAYER5", e[e.HIGH_STREAM_LAYER6 = 9] = "HIGH_STREAM_LAYER6", e;
    }({}), lse = function(e) {
      return e[e.DISABLE = 0] = "DISABLE", e[e.LOW_STREAM = 1] = "LOW_STREAM", e[e.AUDIO_ONLY = 2] = "AUDIO_ONLY", e[e.HIGH_STREAM_LAYER1 = 3] = "HIGH_STREAM_LAYER1", e[e.HIGH_STREAM_LAYER2 = 4] = "HIGH_STREAM_LAYER2", e[e.HIGH_STREAM_LAYER3 = 5] = "HIGH_STREAM_LAYER3", e[e.HIGH_STREAM_LAYER4 = 6] = "HIGH_STREAM_LAYER4", e[e.HIGH_STREAM_LAYER5 = 7] = "HIGH_STREAM_LAYER5", e[e.HIGH_STREAM_LAYER6 = 8] = "HIGH_STREAM_LAYER6", e;
    }({}), Af = function(e) {
      return e.TRANSCEIVER_UPDATED = "transceiver-updated", e.SEI_TO_SEND = "sei-to-send", e.SEI_RECEIVED = "sei-received", e.TRACK_UPDATED = "track-updated", e;
    }({}), dp = function(e) {
      return e.SOURCE_STATE_CHANGE = "source-state-change", e.TRACK_ENDED = "track-ended", e.BEAUTY_EFFECT_OVERLOAD = "beauty-effect-overload", e.VIDEO_ELEMENT_VISIBLE_STATUS = "video-element-visible-status", e.CLOSED = "closed", e;
    }({}), lp = function(e) {
      return e.FIRST_FRAME_DECODED = "first-frame-decoded", e.VIDEO_ELEMENT_VISIBLE_STATUS = "video-element-visible-status", e.VIDEO_STATE_CHANGED = "video-state-changed", e;
    }({}), fp = function(e) {
      return e.AUDIO = "audio", e.VIDEO = "video", e.DATA = "data", e;
    }({}), io = function(e) {
      return e.AUDIO_SOURCE_STATE_CHANGE = "audio_source_state_change", e.RECEIVE_TRACK_BUFFER = "receive_track_buffer", e.ON_AUDIO_BUFFER = "on_audio_buffer", e.UPDATE_SOURCE = "update_source", e;
    }({});
    (function(e) {
      e.UPDATE_TRACK_SOURCE = "update-track-source";
    })({});
    const $S = { sendVolumeLevel: 0, sendBitrate: 0, sendBytes: 0, sendPackets: 0, sendPacketsLost: 0, sendJitterMs: 0, sendRttMs: 0, currentPacketLossRate: 0 }, eI = { sendBytes: 0, sendBitrate: 0, sendPackets: 0, sendPacketsLost: 0, sendJitterMs: 0, sendRttMs: 0, sendResolutionHeight: 0, sendResolutionWidth: 0, captureResolutionHeight: 0, captureResolutionWidth: 0, targetSendBitrate: 0, totalDuration: 0, totalFreezeTime: 0, currentPacketLossRate: 0 }, x5 = { transportDelay: 0, end2EndDelay: 0, receiveBitrate: 0, receiveLevel: 0, receiveBytes: 0, receiveDelay: 0, receivePackets: 0, receivePacketsLost: 0, receivePacketsDiscarded: 0, totalDuration: 0, totalFreezeTime: 0, freezeRate: 0, packetLossRate: 0, currentPacketLossRate: 0, publishDuration: -1 }, fse = { uplinkNetworkQuality: 0, downlinkNetworkQuality: 0 }, D5 = { transportDelay: 0, end2EndDelay: 0, receiveBitrate: 0, receiveBytes: 0, receiveDelay: 0, receivePackets: 0, receivePacketsLost: 0, receiveResolutionHeight: 0, receiveResolutionWidth: 0, totalDuration: 0, totalFreezeTime: 0, freezeRate: 0, packetLossRate: 0, currentPacketLossRate: 0, publishDuration: -1 };
    let na = function(e) {
      return e.ON_TRACK = "on_track", e.ON_NODE = "on_node", e;
    }({}), so = function(e) {
      return e.REQUEST_UPDATE_CONSTRAINTS = "request_update_constraints", e.REQUEST_CONSTRAINTS = "request_constraints", e;
    }({}), ME = function(e) {
      return e.IDLE = "IDLE", e.INITING = "INITING", e.INITEND = "INITEND", e;
    }({}), Of = function(e) {
      return e.STATE_CHANGE = "state_change", e.RECORDING_DEVICE_CHANGED = "recordingDeviceChanged", e.PLAYOUT_DEVICE_CHANGED = "playoutDeviceChanged", e.CAMERA_DEVICE_CHANGED = "cameraDeviceChanged", e;
    }({}), Xs = function(e) {
      return e.NONE = "none", e.INIT = "init", e.CANPLAY = "canplay", e.PLAYING = "playing", e.PAUSED = "paused", e.SUSPEND = "suspend", e.STALLED = "stalled", e.WAITING = "waiting", e.ERROR = "error", e.DESTROYED = "destroyed", e.ABORT = "abort", e.ENDED = "ended", e.EMPTIED = "emptied", e.LOADEDDATA = "loadeddata", e;
    }({}), vu = function(e) {
      return e[e.VideoStateStopped = 0] = "VideoStateStopped", e[e.VideoStateStarting = 1] = "VideoStateStarting", e[e.VideoStateDecoding = 2] = "VideoStateDecoding", e[e.VideoStateFrozen = 3] = "VideoStateFrozen", e;
    }({});
    const tI = { uninit: 100, none: 110, init: 120, loadeddata: 130, canplay: 200, playing: 210, paused: 220, suspend: 300, stalled: 310, waiting: 320, error: 330, destroyed: 340, abort: 350, ended: 360, emptied: 370 };
    let TT = function(e) {
      return e.OPEN = "open", e.MESSAGE = "message", e.CLOSE = "close", e.CLOSING = "closing", e.ERROR = "error", e;
    }({});
    function fr(e, n, i, o, f) {
      var T, A, R = {};
      return Object.keys(o).forEach(function(P) {
        R[P] = o[P];
      }), R.enumerable = !!R.enumerable, R.configurable = !!R.configurable, ("value" in R || R.initializer) && (R.writable = !0), R = _c(T = LW(A = i.slice()).call(A)).call(T, function(P, L) {
        return L(e, n, P) || P;
      }, R), f && R.initializer !== void 0 && (R.value = R.initializer ? R.initializer.call(f) : void 0, R.initializer = void 0), R.initializer === void 0 && (Object.defineProperty(e, n, R), R = null), R;
    }
    function Yt(e, n, i) {
      return (n = function(o) {
        var f = function(T, A) {
          if (typeof T != "object" || !T) return T;
          var R = T[Symbol.toPrimitive];
          if (R !== void 0) {
            var P = R.call(T, "string");
            if (typeof P != "object") return P;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(T);
        }(o);
        return typeof f == "symbol" ? f : f + "";
      }(n)) in e ? Object.defineProperty(e, n, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = i, e;
    }
    function M5(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function Zr(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? M5(Object(i), !0).forEach(function(o) {
          Yt(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : M5(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    class L5 extends ii {
      set _mediaStreamTrack(n) {
        n !== this.mediaStreamTrack && (this.safeEmit(Af.TRACK_UPDATED, n), this.mediaStreamTrack = n);
      }
      get _mediaStreamTrack() {
        return this.mediaStreamTrack;
      }
      constructor(n, i) {
        super(), Yt(this, "trackMediaType", void 0), Yt(this, "_ID", void 0), Yt(this, "_rtpTransceiver", void 0), Yt(this, "_lowRtpTransceiver", void 0), Yt(this, "_hints", []), Yt(this, "_isClosed", !1), Yt(this, "_originMediaStreamTrack", void 0), Yt(this, "mediaStreamTrack", void 0), Yt(this, "_external", {}), this._ID = i || zr(8, "track-"), this._originMediaStreamTrack = n, this.mediaStreamTrack = n, function(o) {
          on(cp).call(cp, o) || cp.push(o);
        }(this);
      }
      toString() {
        return this._ID;
      }
      getTrackId() {
        return this._ID;
      }
      getMediaStreamTrack(n) {
        return n || el(() => {
          var i;
          Cn.reportApiInvoke(null, { name: Bi.GET_MEDIA_STREAM_TRACK, options: [], tag: si.TRACER }).onSuccess(((i = this._mediaStreamTrack) === null || i === void 0 ? void 0 : i.label) || "");
        }, this.mediaStreamTrack.id || this.getTrackId()), this._mediaStreamTrack;
      }
      getRTCRtpTransceiver(n) {
        return n === up.LOW_STREAM ? this._lowRtpTransceiver : this._rtpTransceiver;
      }
      getMediaStreamTrackSettings() {
        return this.getMediaStreamTrack(!0).getSettings();
      }
      close() {
        this._isClosed = !0, this._lowRtpTransceiver = void 0, this._rtpTransceiver = void 0, function(n) {
          const i = cp.indexOf(n);
          i !== -1 && cp.splice(i, 1);
        }(this), this.emit(dp.CLOSED), this.removeAllListeners(Af.SEI_RECEIVED);
      }
      _updateRtpTransceiver(n, i) {
        if (i === up.LOW_STREAM) {
          if (this._lowRtpTransceiver === n) return;
          this._lowRtpTransceiver = n;
        } else {
          if (this._rtpTransceiver === n) return;
          this._rtpTransceiver = n;
        }
        this.emit(Af.TRANSCEIVER_UPDATED, n, i);
      }
    }
    class hp extends L5 {
      get isExternalTrack() {
        return this._isExternalTrack;
      }
      get muted() {
        return this._muted;
      }
      get enabled() {
        return this._enabled;
      }
      get processorContext() {
        return this._processorContext;
      }
      constructor(n, i) {
        super(n, i), Yt(this, "_enabled", !0), Yt(this, "_muted", !1), Yt(this, "_isExternalTrack", !1), Yt(this, "_isClosed", !1), Yt(this, "_enabledMutex", void 0), Yt(this, "processor", void 0), Yt(this, "_processorContext", void 0), Yt(this, "_handleTrackEnded", () => {
          this.onTrackEnded();
        }), this._enabledMutex = new xs("".concat(this.getTrackId())), n.addEventListener("ended", this._handleTrackEnded);
      }
      getTrackLabel() {
        var n, i;
        return (n = (i = this._originMediaStreamTrack) === null || i === void 0 ? void 0 : i.label) !== null && n !== void 0 ? n : "";
      }
      close() {
        this._isClosed || (this.stop(), this._originMediaStreamTrack.stop(), this._mediaStreamTrack !== this._originMediaStreamTrack && (this._mediaStreamTrack.stop(), this._mediaStreamTrack = null), this._originMediaStreamTrack = null, this._enabledMutex = null, Ee.debug("[".concat(this.getTrackId(), "] close")), this.emit(Tn.NEED_CLOSE), super.close());
      }
      async _updateOriginMediaStreamTrack(n, i) {
        let o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
        this._isExternalTrack = o, n !== this._originMediaStreamTrack && (this._originMediaStreamTrack && (this._originMediaStreamTrack.removeEventListener("ended", this._handleTrackEnded), i && this._originMediaStreamTrack.stop()), n.addEventListener("ended", this._handleTrackEnded), this._originMediaStreamTrack = n, this._muted && (this._originMediaStreamTrack.enabled = !1), this._mediaStreamTrack = this._originMediaStreamTrack, this._updatePlayerSource(), await Br(this, Tn.NEED_REPLACE_TRACK, this), this.processor && this._processorContext && this.processor.updateInput({ track: this._originMediaStreamTrack, context: this._processorContext }));
      }
      _getDefaultPlayerConfig() {
        return {};
      }
      onTrackEnded() {
        Ee.debug("[".concat(this.getTrackId(), "] track ended")), this.safeEmit(dp.TRACK_ENDED);
      }
      stateCheck(n, i) {
        if (Ee.debug("check track state, [muted: ".concat(this._muted, ", enabled: ").concat(this._enabled, "] to [").concat(n, ": ").concat(i, "]")), od(i, n), this._enabled && this._muted && n === "enabled" && i === !1) throw new Gt(Je.TRACK_STATE_UNREACHABLE, "cannot set enabled while the track is muted").print("error", Ee);
        if (!this._enabled && !this._muted && n === "muted" && i === !0) throw new Gt(Je.TRACK_STATE_UNREACHABLE, "cannot set muted while the track is disabled").print("error", Ee);
      }
      getProcessorStats() {
        return this._processorContext && this._processorContext.gatherStats() || [];
      }
      getProcessorUsage() {
        return this._processorContext ? this._processorContext.gatherUsage() : cn.resolve([]);
      }
    }
    const k5 = window.AudioContext || window.webkitAudioContext;
    let ao = null;
    const wr = new class extends ii {
      constructor() {
        super(...arguments), Yt(this, "prevState", void 0), Yt(this, "curState", void 0), Yt(this, "currentTime", void 0), Yt(this, "currentTimeStuckAt", void 0), Yt(this, "interruptDetectorTrack", void 0), Yt(this, "onLocalAudioTrackMute", () => {
          Ee.info("ios15-interruption-start"), this.emit(vs.IOS_15_16_INTERRUPTION_START);
        }), Yt(this, "onLocalAudioTrackUnmute", async () => {
          Ee.info("ios15-interruption-end"), this.curState !== "running" || this.duringInterruption ? Ee.info("ios15-interruption-end-canceled") : (ao && await ao.suspend(), this.emit(vs.IOS_15_16_INTERRUPTION_END));
        });
      }
      get duringInterruption() {
        return this.prevState === "running" && this.curState === "interrupted";
      }
      bindInterruptDetectorTrack(e) {
        Ee.debug("webaudio bindInterruptDetectorTrack ".concat(e.getTrackId())), this.interruptDetectorTrack || (this.interruptDetectorTrack = e, this.interruptDetectorTrack._mediaStreamTrack.onmute = this.onLocalAudioTrackMute, this.interruptDetectorTrack._mediaStreamTrack.onunmute = this.onLocalAudioTrackUnmute);
      }
      unbindInterruptDetectorTrack(e) {
        Ee.debug("webaudio unbindInterruptDetectorTrack ".concat(e.getTrackId())), this.interruptDetectorTrack && this.interruptDetectorTrack === e && (this.interruptDetectorTrack._mediaStreamTrack && (this.interruptDetectorTrack._mediaStreamTrack.onmute = null, this.interruptDetectorTrack._mediaStreamTrack.onunmute = null), this.interruptDetectorTrack = void 0);
      }
    }();
    function pp() {
      if (!ao) {
        if (function() {
          if (!k5) return void Ee.error("your browser is not support web audio");
          Ee.info("create audio context");
          const e = Zr({}, ft("WEBAUDIO_INIT_OPTIONS"));
          Ee.debug("audio context init option:", JSON.stringify(e)), ao = new k5(e), wr.curState = ao.state, ao.onstatechange = () => {
            wr.prevState = wr.curState, wr.curState = ao ? ao.state : void 0;
            const { prevState: n, curState: i } = wr, o = i === "running", f = i === "interrupted", T = n === "running", A = n === "suspended", R = n === "interrupted", P = hr().osVersion;
            (ta() || rc()) && T && f && (Ee.info("ios".concat(P, "-interruption-start")), wr.emit(vs.IOS_INTERRUPTION_START)), (ta() || rc()) && (A || R) && o && (Ee.info("ios".concat(P, "-interruption-end")), wr.emit(vs.IOS_INTERRUPTION_END)), n !== i && wr.emit(vs.STATE_CHANGE, i, n);
          }, setInterval(() => {
            var n;
            const i = (n = ao) === null || n === void 0 ? void 0 : n.currentTime;
            wr.currentTime !== i ? (wr.currentTimeStuckAt && (Ee.debug("AudioContext current time resume at ".concat(i)), wr.currentTimeStuckAt = void 0), wr.currentTime = i) : (i !== wr.currentTimeStuckAt && (Cn.reportApiInvoke(null, { name: "WEB_AUDIO_CURRENT_TIME_STUCK", options: { currentTime: i }, tag: si.TRACER }).onSuccess(), Ee.warning("AudioContext current time stuck at ".concat(i))), wr.currentTimeStuckAt = i);
          }, 5e3), async function(n) {
            const i = ["click", "contextmenu", "auxclick", "dblclick", "mousedown", "mouseup", "touchend", "keydown", "keyup"];
            let o, f = !1, T = !1, A = !1;
            function R(Re) {
              n.state === "running" ? P(!1) : ta() || rc() ? n.state === "suspended" && (P(!0), Re && n.resume().then(L, L)) : n.state !== "closed" && (P(!0), Re && n.resume().then(L, L));
            }
            function P(Re) {
              if (f !== Re) {
                f = Re;
                for (let De = 0, Xe = i; De < Xe.length; De += 1) {
                  const We = Xe[De];
                  Re ? window.addEventListener(We, z, { capture: !0, passive: !0 }) : window.removeEventListener(We, z, { capture: !0, passive: !0 });
                }
              }
            }
            function L() {
              R(!1);
            }
            function z() {
              R(!0);
            }
            function Y(Re) {
              if (!A) if (o.paused) if (Re) {
                let De;
                te(!1), A = !0;
                try {
                  De = o.play(), De ? De.then(oe, oe) : (o.addEventListener("playing", oe), o.addEventListener("abort", oe), o.addEventListener("error", oe));
                } catch {
                  oe();
                }
              } else te(!0);
              else te(!1);
            }
            function te(Re) {
              if (T !== Re) {
                T = Re;
                for (let De = 0, Xe = i; De < Xe.length; De++) {
                  const We = Xe[De];
                  Re ? window.addEventListener(We, He, { capture: !0, passive: !0 }) : window.removeEventListener(We, He, { capture: !0, passive: !0 });
                }
              }
            }
            function oe() {
              o.removeEventListener("playing", oe), o.removeEventListener("abort", oe), o.removeEventListener("error", oe), A = !1, Y(!1);
            }
            function He() {
              Y(!0);
            }
            if (ta()) {
              const Re = n.createMediaStreamDestination(), De = document.createElement("div");
              De.innerHTML = "<audio x-webkit-airplay='deny'></audio>", o = De.children.item(0), o.controls = !1, o.disableRemotePlayback = !0, o.preload = "auto", o.srcObject = Re.stream, Y(!0);
            }
            wr.on(vs.STATE_CHANGE, function() {
              R(!0);
            }), R(!1);
          }(ao);
        }(), !ao) throw new Gt(Je.NOT_SUPPORTED, "can not create audio context");
        return ao;
      }
      return ao;
    }
    function Cf(e) {
      if (function() {
        if (nI !== null) return nI;
        const o = pp(), f = o.createBufferSource(), T = o.createGain(), A = o.createGain();
        f.connect(T), f.connect(A), f.disconnect(T);
        let R = !1;
        try {
          f.disconnect(T);
        } catch {
          R = !0;
        }
        return f.disconnect(), nI = R, R;
      }()) return;
      const n = e.connect, i = e.disconnect;
      e.connect = (o, f, T) => {
        var A;
        return e._inputNodes || (e._inputNodes = []), on(A = e._inputNodes).call(A, o) || (o instanceof AudioNode ? (e._inputNodes.push(o), n.call(e, o, f, T)) : n.call(e, o, f)), e;
      }, e.disconnect = (o, f, T) => {
        i.call(e), o ? dT(e._inputNodes, o) : e._inputNodes = [];
        for (const A of e._inputNodes) n.call(e, A);
      };
    }
    let nI = null;
    function rI(e, n) {
      let i = !1;
      const o = 1 / n;
      if (ft("DISABLE_WEBAUDIO")) {
        const f = window.setInterval(() => {
          i ? window.clearInterval(f) : e(performance.now() / 1e3);
        }, 1e3 * o);
      } else {
        const f = pp();
        let T = f.createGain();
        T.gain.value = 0, T.connect(f.destination);
        const A = () => {
          if (i) return void (T = null);
          const R = f.createOscillator();
          R.onended = A, R.connect(T), R.start(0), R.stop(f.currentTime + o), e(f.currentTime);
        };
        A();
      }
      return () => {
        i = !0;
      };
    }
    class j5 {
      constructor() {
        Yt(this, "context", void 0), Yt(this, "analyserNode", void 0), Yt(this, "sourceNode", void 0), this.context = pp(), this.analyserNode = this.context.createAnalyser(), this.analyserNode.fftSize = 2048, this.analyserNode.smoothingTimeConstant = 0.4;
      }
      updateSource(n) {
        if (n !== this.sourceNode) {
          if (this.sourceNode) try {
            this.sourceNode.disconnect(this.analyserNode);
          } catch {
          }
          this.sourceNode = n, n == null || n.connect(this.analyserNode);
        }
      }
      getVolumeLevel() {
        if (!this.sourceNode || (!this.context || ta() || rc() || this.context.state !== "running" && this.context.resume(), !this.analyserNode)) return 0;
        const n = new Float32Array(this.analyserNode.fftSize);
        if (this.analyserNode.getFloatTimeDomainData) this.analyserNode.getFloatTimeDomainData(n);
        else {
          const o = new Uint8Array(this.analyserNode.fftSize);
          this.analyserNode.getByteTimeDomainData(o);
          for (let f = 0; f < n.length; ++f) n[f] = o[f] / 128 - 1;
        }
        const i = _c(n).call(n, (o, f) => o + f * f, 0) / n.length;
        return Math.max(10 * Math.log10(i) + 100, 0) / 100;
      }
      getAnalyserNode() {
        return this.analyserNode;
      }
      rebuildAnalyser() {
        try {
          var n, i;
          (n = this.sourceNode) === null || n === void 0 || n.disconnect(this.analyserNode), this.analyserNode = this.context.createAnalyser(), this.analyserNode.fftSize = 2048, this.analyserNode.smoothingTimeConstant = 0.4, (i = this.sourceNode) === null || i === void 0 || i.connect(this.analyserNode);
        } catch {
          Ee.warning("rebuild analyser node failed.");
        }
      }
      destroy() {
        this.updateSource(void 0);
      }
    }
    class U5 extends ii {
      get processSourceNode() {
        return this.sourceNode;
      }
      set processedNode(n) {
        var i;
        if (!this.isDestroyed && this._processedNode !== n) {
          try {
            var o;
            (o = this.sourceNode) === null || o === void 0 || o.disconnect(this.outputNode);
          } catch {
          }
          (i = this._processedNode) === null || i === void 0 || i.disconnect(), this._processedNode = n, this.connect();
        }
      }
      get processedNode() {
        return this._processedNode;
      }
      constructor() {
        super(), Yt(this, "outputNode", void 0), Yt(this, "outputTrack", void 0), Yt(this, "isPlayed", !1), Yt(this, "sourceNode", void 0), Yt(this, "context", void 0), Yt(this, "audioBufferNode", void 0), Yt(this, "destNode", void 0), Yt(this, "audioOutputLevel", 0), Yt(this, "volumeLevelAnalyser", void 0), Yt(this, "_processedNode", void 0), Yt(this, "playNode", void 0), Yt(this, "isDestroyed", !1), Yt(this, "onNoAudioInput", void 0), Yt(this, "isNoAudioInput", !1), Yt(this, "_noAudioInputCount", 0), this.context = pp(), this.playNode = this.context.destination, this.outputNode = this.context.createGain(), Cf(this.outputNode), this.volumeLevelAnalyser = new j5();
      }
      startGetAudioBuffer(n) {
        this.audioBufferNode || (this.audioBufferNode = this.context.createScriptProcessor(n), this.outputNode.connect(this.audioBufferNode), this.audioBufferNode.connect(this.context.destination), this.audioBufferNode.onaudioprocess = (i) => {
          this.emit(io.ON_AUDIO_BUFFER, function(o) {
            for (let f = 0; f < o.outputBuffer.numberOfChannels; f += 1) {
              const T = o.outputBuffer.getChannelData(f);
              for (let A = 0; A < T.length; A += 1) T[A] = 0;
            }
            return o.inputBuffer;
          }(i));
        });
      }
      stopGetAudioBuffer() {
        this.audioBufferNode && (this.audioBufferNode.onaudioprocess = null, this.outputNode.disconnect(this.audioBufferNode), this.audioBufferNode = void 0);
      }
      createOutputTrack() {
        if (!pr().webAudioMediaStreamDest) throw new Gt(Je.NOT_SUPPORTED, "your browser is not support audio processor");
        return this.destNode && this.outputTrack || (this.destNode = this.context.createMediaStreamDestination(), this.outputNode.connect(this.destNode), this.outputTrack = this.destNode.stream.getAudioTracks()[0]), this.outputTrack;
      }
      play(n) {
        this.context.state !== "running" && lT(() => {
          wr.emit("autoplay-failed");
        }), this.isPlayed = !0, this.playNode = n || this.context.destination, this.outputNode.connect(this.playNode);
      }
      stop() {
        if (this.isPlayed) try {
          this.outputNode.disconnect(this.playNode);
        } catch {
        }
        this.isPlayed = !1;
      }
      getAccurateVolumeLevel() {
        return this.volumeLevelAnalyser.getVolumeLevel();
      }
      async checkHasAudioInput() {
        let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (n > 5) return this.isNoAudioInput = !0, this.onNoAudioInput && this.onNoAudioInput(), !1;
        ta() || rc() ? this.context.state === "suspended" && this.context.resume() : this.context.state !== "running" && this.context.resume();
        const i = this.volumeLevelAnalyser.getAnalyserNode();
        let o;
        i.getFloatTimeDomainData ? (o = new Float32Array(i.fftSize), i.getFloatTimeDomainData(o)) : (o = new Uint8Array(i.fftSize), i.getByteTimeDomainData(o));
        let f = !1;
        for (let T = 0; T < o.length; T++) o[T] !== 0 && (f = !0);
        return f ? (this.isNoAudioInput = !1, !0) : (await Es(200), await this.checkHasAudioInput(n ? n + 1 : 1) && f);
      }
      getAudioVolume() {
        return this.outputNode.gain.value;
      }
      setVolume(n) {
        this.outputNode.gain.setValueAtTime(n, this.context.currentTime);
      }
      destroy() {
        this.disconnect(), this.stop(), this.isDestroyed = !0, this.onNoAudioInput = void 0;
      }
      disconnect() {
        var n, i;
        (n = this.processedNode) === null || n === void 0 || n.disconnect(), (i = this.sourceNode) === null || i === void 0 || i.disconnect(), this.outputNode && this.outputNode.disconnect();
      }
      connect() {
        var n;
        this.processedNode ? (n = this.processedNode) === null || n === void 0 || n.connect(this.outputNode) : this.sourceNode && this.sourceNode.connect(this.outputNode), this.volumeLevelAnalyser.updateSource(this.outputNode);
      }
    }
    class H5 extends U5 {
      get isFreeze() {
        return !1;
      }
      constructor(n, i, o) {
        var f;
        if (super(), Yt(this, "sourceNode", void 0), Yt(this, "track", void 0), Yt(this, "clonedTrack", void 0), Yt(this, "audioElement", void 0), Yt(this, "isCurrentTrackCloned", !1), Yt(this, "isRemoteTrack", !1), Yt(this, "originVolumeLevelAnalyser", void 0), Yt(this, "rebuildWebAudio", async () => {
          if (Ee.debug("ready to rebuild web audio, state:", this.context.state), this.isNoAudioInput && await this.checkHasAudioInput(), !this.isNoAudioInput || this.isDestroyed) return document.body.removeEventListener("click", this.rebuildWebAudio, !0), void Ee.debug("rebuild web audio success, current volume status", this.getAccurateVolumeLevel());
          this.context.resume().then(() => Ee.info("resume success")), Ee.debug("rebuild web audio because of ios 12 bugs"), this.disconnect();
          const R = this.track;
          this.track = this.track.clone(), this.isCurrentTrackCloned ? R.stop() : this.isCurrentTrackCloned = !0;
          const P = new MediaStream([this.track]);
          this.sourceNode = this.context.createMediaStreamSource(P), Cf(this.sourceNode), this.volumeLevelAnalyser.rebuildAnalyser();
          const L = this.outputNode.gain.value;
          this.outputNode = this.context.createGain(), this.outputNode.gain.setValueAtTime(L, this.context.currentTime), Cf(this.outputNode), this.emit(io.UPDATE_SOURCE), this.connect(), this.audioElement.srcObject = P, this.isPlayed && this.play(this.playNode), this.checkHasAudioInput();
        }), n.kind !== "audio") throw new Gt(Je.UNEXPECTED_ERROR);
        this.track = n;
        const T = new MediaStream([this.track]);
        if (this.isRemoteTrack = !!i, this.sourceNode = this.context.createMediaStreamSource(T), Cf(this.sourceNode), o) {
          const R = o.clone();
          R.enabled = !0, this.clonedTrack = R, Ee.debug("create an unmuted track ".concat(R.id, " from the original track ").concat(o.id, " to get the volume"));
          const P = this.context.createMediaStreamSource(new MediaStream([R]));
          Cf(P), this.originVolumeLevelAnalyser = new j5(), this.originVolumeLevelAnalyser.updateSource(P);
        }
        this.connect(), this.audioElement = document.createElement("audio"), this.audioElement.srcObject = T;
        const A = hr();
        i && A.os === ts.IOS && Number((f = A.osVersion) === null || f === void 0 ? void 0 : f.split(".")[0]) < 15 && (wr.on(vs.STATE_CHANGE, () => {
          this.context.state === "suspended" ? document.body.addEventListener("click", this.rebuildWebAudio, !0) : this.context.state === "running" && this.rebuildWebAudio();
        }), this.checkHasAudioInput().then((R) => {
          R || document.body.addEventListener("click", this.rebuildWebAudio, !0);
        }));
      }
      updateTrack(n) {
        this.sourceNode.disconnect(), this.track = n, this.isCurrentTrackCloned = !1;
        const i = new MediaStream([n]);
        this.sourceNode = this.context.createMediaStreamSource(i), Cf(this.sourceNode), this.processedNode || this.sourceNode.connect(this.outputNode), this.emit(io.UPDATE_SOURCE), this.audioElement.srcObject = i;
      }
      destroy() {
        var n;
        this.audioElement.srcObject = null, this.audioElement.remove(), wr.off("state-change", this.rebuildWebAudio), (n = this.originVolumeLevelAnalyser) === null || n === void 0 || n.destroy(), this.clonedTrack = void 0, super.destroy();
      }
      createMediaStreamSourceNode(n) {
        return this.context.createMediaStreamSource(new MediaStream([n]));
      }
      updateOriginTrack(n) {
        const i = n.clone();
        i.enabled = !0, this.clonedTrack && (this.clonedTrack.stop(), this.clonedTrack = i), Ee.debug("create an unmuted track ".concat(i.id, " from the original track ").concat(n.id, " to get the volume"));
        const o = this.context.createMediaStreamSource(new MediaStream([i]));
        Cf(o), this.originVolumeLevelAnalyser && this.originVolumeLevelAnalyser.updateSource(o);
      }
      getOriginVolumeLevel() {
        return this.originVolumeLevelAnalyser ? this.originVolumeLevelAnalyser.getVolumeLevel() : this.getAccurateVolumeLevel();
      }
    }
    async function B5(e, n, i) {
      const o = (T, A) => T ? typeof T != "number" ? T.max || T.exact || T.ideal || T.min || A : T : A, f = { audio: !!i && { mandatory: { chromeMediaSource: "desktop" } }, video: { mandatory: { chromeMediaSource: "desktop", chromeMediaSourceId: e, maxHeight: o(n.height, 1080), maxWidth: o(n.width, 1920) } } };
      return n.frameRate && typeof n.frameRate != "number" ? (f.video.mandatory.maxFrameRate = n.frameRate.max, f.video.mandatory.minFrameRate = n.frameRate.min) : typeof n.frameRate == "number" && (f.video.mandatory.maxFrameRate = n.frameRate), await navigator.mediaDevices.getUserMedia(f);
    }
    async function hse(e, n) {
      const i = await z5(e.mediaSource), { sourceId: o, audio: f } = await function(T) {
        let A = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
        return new cn((R, P) => {
          const L = document.createElement("div");
          L.innerText = "share screen", L.setAttribute("style", "text-align: center; height: 25px; line-height: 25px; border-radius: 4px 4px 0 0; background: #D4D2D4; border-bottom:  solid 1px #B9B8B9;");
          const z = document.createElement("div");
          z.setAttribute("style", "width: 100%; height: 500px; padding: 15px 25px ; box-sizing: border-box;");
          const Y = document.createElement("div");
          Y.innerText = "Agora Web Screensharing wants to share the contents of your screen with webdemo.agorabeckon.com. Choose what you'd like to share.", Y.setAttribute("style", "height: 12%;");
          const te = document.createElement("div");
          te.setAttribute("style", "width: 100%; height: 80%; background: #FFF; border:  solid 1px #CBCBCB; display: flex; flex-wrap: wrap; justify-content: space-around; overflow-y: scroll; padding: 0 15px; box-sizing: border-box;");
          const oe = document.createElement("div");
          oe.setAttribute("style", "display: flex; justify-content: space-between; padding: 16px 0;");
          const He = document.createElement("button");
          He.innerHTML = "cancel", He.setAttribute("style", "width: 85px;"), He.onclick = () => {
            document.body.removeChild(Xe);
            const We = new Error("NotAllowedError");
            We.name = "NotAllowedError", P(We);
          };
          let Re = A;
          const De = document.createElement("div");
          if (A) {
            const We = document.createElement("input");
            We.setAttribute("type", "checkbox");
            const mt = document.createElement("span");
            We.setAttribute("style", "margin-right: 6px;"), mt.innerText = "Share audio", We.checked = Re, We.onchange = () => {
              Re = We.checked;
            }, De.appendChild(We), De.appendChild(mt);
          }
          oe.appendChild(De), oe.appendChild(He), z.appendChild(Y), z.appendChild(te), z.appendChild(oe);
          const Xe = document.createElement("div");
          Xe.setAttribute("style", "position: fixed; z-index: 99999999; top: 50%; left: 50%; width: 620px; height: 525px; background: #ECECEC; border-radius: 4px; -webkit-transform: translate(-50%,-50%); transform: translate(-50%,-50%);"), Xe.appendChild(L), Xe.appendChild(z), document.body.appendChild(Xe), T.map((We) => {
            if (We.id) {
              const mt = document.createElement("div");
              mt.setAttribute("style", "width: 30%; height: 160px; padding: 20px 0; text-align: center;box-sizing: content-box;");
              let Pt = We.thumbnail;
              try {
                const { width: xt } = Pt.getSize();
                xt > 1920 && (Pt = Pt.resize({ width: 1920 }));
              } catch (xt) {
                throw xt && xt.message.startsWith("Illegal invocation") && console.error("Operate thumbnail error, please try to set contextIsolation: false. (https://github.com/electron/electron/issues/34953)"), xt;
              }
              mt.innerHTML = '<div style="height: 120px; display: table-cell; vertical-align: middle;"><img style="width: 100%; background: #333333; box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);" src=' + Pt.toDataURL() + ' /></div><span style="	height: 40px; line-height: 40px; display: inline-block; width: 70%; word-break: keep-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">' + We.name.replace(/[\u00A0-\u9999<>\&]/g, function(xt) {
                return "&#" + xt.charCodeAt(0) + ";";
              }) + "</span>", mt.onclick = () => {
                document.body.removeChild(Xe), R({ sourceId: We.id, audio: Re });
              }, te.appendChild(mt);
            }
          });
        });
      }(i, n);
      return await B5(o, e, f);
    }
    async function z5(e) {
      let n = ["window", "screen"];
      e !== "application" && e !== "window" || (n = ["window"]), e === "screen" && (n = ["screen"]);
      const i = t5();
      if (!i) throw console.error("failed to fetch electron, please mount it to window"), new Gt(Je.ELECTRON_IS_NULL);
      let o = null;
      try {
        var f;
        o = ((f = i.desktopCapturer) === null || f === void 0 ? void 0 : f.getSources({ types: n })) || i.ipcRenderer.invoke("DESKTOP_CAPTURER_GET_SOURCES", { types: n });
      } catch {
        o = null;
      }
      o && o.then || (o = new cn((T, A) => {
        i.desktopCapturer.getSources({ types: n }, (R, P) => {
          R ? A(R) : T(P);
        });
      }));
      try {
        return await o;
      } catch (T) {
        throw new Gt(Je.ELECTRON_DESKTOP_CAPTURER_GET_SOURCES_ERROR, T.toString());
      }
    }
    const iI = new xs("safari");
    let F5 = !1, G5 = !1;
    async function oo(e, n) {
      let i = 0, o = null;
      for (; i < 2; ) try {
        o = await pse(e, n, i > 0);
        break;
      } catch (f) {
        if (f instanceof Gt) throw Ee.error("[".concat(n, "] ").concat(f.toString())), f;
        const T = bT(f.name || f.code || f, f.message);
        if (T.code === Je.MEDIA_OPTION_INVALID) {
          Ee.debug("[".concat(n, "] detect media option invalid, retry")), i += 1, await Es(500);
          continue;
        }
        throw Ee.error("[".concat(n, "] ").concat(T.toString())), T;
      }
      if (!o) throw new Gt(Je.UNEXPECTED_ERROR, "can not find stream after getUserMedia");
      return o;
    }
    async function pse(e, n, i) {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new Gt(Je.NOT_SUPPORTED, "can not find getUserMedia");
      i && (e.video && (delete e.video.width, delete e.video.height), e.screen && (delete e.screen.width, delete e.screen.height));
      const o = pr(), f = new MediaStream();
      if (e.audioSource && f.addTrack(e.audioSource), e.videoSource && f.addTrack(e.videoSource), !e.audio && !e.video && !e.screen) return Ee.debug("Using Video Source/ Audio Source"), f;
      if (e.screen) if (t5()) e.screen.sourceId ? gp(f, await B5(e.screen.sourceId, e.screen, !!e.screenAudio)) : gp(f, await hse(e.screen, !!e.screenAudio));
      else if ($d() && e.screen.extensionId && e.screen.mandatory) {
        if (!o.getStreamFromExtension) throw new Gt(Je.NOT_SUPPORTED, "This browser does not support screen sharing");
        Ee.debug("[".concat(n, '] Screen access on chrome stable, looking for extension"'));
        const te = await (A = e.screen.extensionId, R = n, new cn((oe, He) => {
          try {
            chrome.runtime.sendMessage(A, { getStream: !0 }, (Re) => {
              if (!Re || !Re.streamId) return Ee.error("[".concat(R, "] No response from Chrome Plugin. Plugin not installed properly"), Re), void He(new Gt(Je.CHROME_PLUGIN_NO_RESPONSE, "No response from Chrome Plugin. Plugin not installed properly"));
              oe(Re.streamId);
            });
          } catch (Re) {
            Ee.error("[".concat(R, "] AgoraRTC screensharing plugin is not accessible(").concat(A, ")"), Re.toString()), He(new Gt(Je.CHROME_PLUGIN_NOT_INSTALL));
          }
        }));
        e.screen.mandatory.chromeMediaSourceId = te, gp(f, await navigator.mediaDevices.getUserMedia({ video: { mandatory: e.screen.mandatory } }));
      } else if (o.getDisplayMedia) {
        var T;
        e.screen.mediaSource && P5(e.screen.mediaSource);
        const te = { width: e.screen.width, height: e.screen.height, frameRate: e.screen.frameRate, displaySurface: (T = e.screen.displaySurface) !== null && T !== void 0 ? T : e.screen.mediaSource === "screen" ? "monitor" : e.screen.mediaSource }, { selfBrowserSurface: oe, surfaceSwitching: He, systemAudio: Re, preferCurrentTab: De } = e.screen, Xe = { selfBrowserSurface: oe, surfaceSwitching: He, systemAudio: Re, preferCurrentTab: De };
        !oe && delete Xe.selfBrowserSurface, !He && delete Xe.surfaceSwitching, !Re && delete Xe.systemAudio, !De && delete Xe.preferCurrentTab, Ee.debug("[".concat(n, "] getDisplayMedia:"), JSON.stringify({ video: te, audio: e.screenAudio, controls: Xe })), gp(f, await navigator.mediaDevices.getDisplayMedia(Zr({ video: te, audio: e.screenAudio }, Xe)));
      } else {
        if (!ui()) throw Ee.error("[".concat(n, "] This browser does not support screenSharing")), new Gt(Je.NOT_SUPPORTED, "This browser does not support screen sharing");
        {
          e.screen.mediaSource && P5(e.screen.mediaSource);
          const te = { video: { mediaSource: e.screen.mediaSource, width: e.screen.width, height: e.screen.height, frameRate: e.screen.frameRate } };
          Ee.debug("[".concat(n, "] getUserMedia: ").concat(JSON.stringify(te))), gp(f, await navigator.mediaDevices.getUserMedia(te));
        }
      }
      var A, R;
      if (!e.video && !e.audio) return f;
      let P = { video: e.video, audio: e.audio }, L = ft("MEDIA_DEVICE_CONSTRAINTS");
      if (L) try {
        typeof L == "string" && (L = JSON.parse(L)), P = jS(P, L);
      } catch {
      }
      Ee.debug("[".concat(n, "] GetUserMedia"), JSON.stringify(P)), hr();
      let z, Y = null;
      (Os() || ta() || oT()) && (Y = await iI.lock());
      try {
        z = await navigator.mediaDevices.getUserMedia(P);
      } catch (te) {
        throw Y && Y(), te;
      }
      return P.audio && (F5 = !0), P.video && (G5 = !0), gp(f, z), Y && Y(), f;
    }
    function bT(e, n) {
      switch (e) {
        case "Starting video failed":
        case "OverconstrainedError":
        case "TrackStartError":
          return new Gt(Je.MEDIA_OPTION_INVALID, "".concat(e, ": ").concat(n));
        case "NotFoundError":
        case "DevicesNotFoundError":
          return new Gt(Je.DEVICE_NOT_FOUND, "".concat(e, ": ").concat(n));
        case "NotSupportedError":
          return new Gt(Je.NOT_SUPPORTED, "".concat(e, ": ").concat(n));
        case "NotReadableError":
          return new Gt(Je.NOT_READABLE, "".concat(e, ": ").concat(n));
        case "InvalidStateError":
        case "NotAllowedError":
        case "PERMISSION_DENIED":
        case "PermissionDeniedError":
          return new Gt(Je.PERMISSION_DENIED, "".concat(e, ": ").concat(n));
        case "ConstraintNotSatisfiedError":
          return new Gt(Je.CONSTRAINT_NOT_SATISFIED, "".concat(e, ": ").concat(n));
        default:
          return Ee.error("getUserMedia unexpected error", e), new Gt(Je.UNEXPECTED_ERROR, "".concat(e, ": ").concat(n));
      }
    }
    function gp(e, n) {
      const i = e.getVideoTracks()[0], o = e.getAudioTracks()[0], f = n.getVideoTracks()[0], T = n.getAudioTracks()[0];
      T && (o && e.removeTrack(o), e.addTrack(T)), f && (i && e.removeTrack(i), e.addTrack(f));
    }
    const co = new class extends ii {
      get state() {
        return this._state;
      }
      set state(e) {
        e !== this._state && (this.emit(Of.STATE_CHANGE, e), this._state = e);
      }
      constructor() {
        super(), Yt(this, "_state", ME.IDLE), Yt(this, "isAccessMicrophonePermission", !1), Yt(this, "isAccessCameraPermission", !1), Yt(this, "lastAccessMicrophonePermission", !1), Yt(this, "lastAccessCameraPermission", !1), Yt(this, "checkdeviceMatched", !1), Yt(this, "deviceInfoMap", /* @__PURE__ */ new Map()), this.init().then(() => {
          navigator.mediaDevices.addEventListener && navigator.mediaDevices.addEventListener("devicechange", this.updateDevicesInfo.bind(this)), window.setInterval(() => {
            (ft("ENUMERATE_DEVICES_INTERVAL") || (uT() || aT() === ts.HARMONY_OS) && ad()) && this.updateDevicesInfo();
          }, ft("ENUMERATE_DEVICES_INTERVAL_TIME"));
        }).catch((e) => Ee.error(e.toString()));
      }
      async enumerateDevices(e, n) {
        let i = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return new Gt(Je.NOT_SUPPORTED, "enumerateDevices() not supported.").throw();
        const o = await navigator.mediaDevices.enumerateDevices(), f = this.checkMediaDeviceInfoIsOk(o);
        let T = !this.isAccessMicrophonePermission && e, A = !this.isAccessCameraPermission && n;
        f.audio && (T = !1), f.video && (A = !1);
        let R = null, P = null, L = null;
        if (!i && (T || A)) {
          if (iI.isLocked && (Ee.debug("[device manager] wait GUM lock"), (await iI.lock())(), Ee.debug("[device manager] GUM unlock")), F5 && (T = !1, this.isAccessMicrophonePermission = !0), G5 && (A = !1, this.isAccessCameraPermission = !0), Ee.debug("[device manager] check media device permissions", e, n, T, A), T && A) {
            try {
              L = await navigator.mediaDevices.getUserMedia({ audio: !0, video: !0 });
            } catch (z) {
              const Y = bT(z.name || z.code || z, z.message);
              if (Y.code === Je.PERMISSION_DENIED) throw Y;
              Ee.warning("getUserMedia failed in getDevices", Y);
            }
            this.isAccessCameraPermission = !0, this.isAccessMicrophonePermission = !0;
          } else if (T) {
            try {
              R = await navigator.mediaDevices.getUserMedia({ audio: e });
            } catch (z) {
              const Y = bT(z.name || z.code || z, z.message);
              if (Y.code === Je.PERMISSION_DENIED) throw Y;
              Ee.warning("getUserMedia failed in getDevices", Y);
            }
            this.isAccessMicrophonePermission = !0;
          } else if (A) {
            try {
              P = await navigator.mediaDevices.getUserMedia({ video: n });
            } catch (z) {
              const Y = bT(z.name || z.code || z, z.message);
              if (Y.code === Je.PERMISSION_DENIED) throw Y;
              Ee.warning("getUserMedia failed in getDevices", Y);
            }
            this.isAccessCameraPermission = !0;
          }
          Ee.debug("[device manager] mic permission", e, "cam permission", n);
        }
        try {
          const z = await navigator.mediaDevices.enumerateDevices();
          return R && R.getTracks().forEach((Y) => Y.stop()), P && P.getTracks().forEach((Y) => Y.stop()), L && L.getTracks().forEach((Y) => Y.stop()), R = null, P = null, L = null, z;
        } catch (z) {
          return R && R.getTracks().forEach((Y) => Y.stop()), P && P.getTracks().forEach((Y) => Y.stop()), L && L.getTracks().forEach((Y) => Y.stop()), R = null, P = null, L = null, new Gt(Je.ENUMERATE_DEVICES_FAILED, z.toString()).throw();
        }
      }
      async getRecordingDevices() {
        let e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
        return (await this.enumerateDevices(!0, !1, e)).filter((n) => n.kind === "audioinput");
      }
      async getCamerasDevices() {
        let e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
        return (await this.enumerateDevices(!1, !0, e)).filter((n) => n.kind === "videoinput");
      }
      async getSpeakers() {
        let e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
        return (await this.enumerateDevices(!0, !1, e)).filter((n) => n.kind === "audiooutput");
      }
      searchDeviceIdByName(e) {
        let n = null;
        return this.deviceInfoMap.forEach((i) => {
          i.device.label === e && (n = i.device.deviceId);
        }), n;
      }
      async getDeviceById(e) {
        const n = (await this.enumerateDevices(!0, !0, !0)).find((i) => i.deviceId === e);
        if (!n) throw new Gt(Je.DEVICE_NOT_FOUND, "deviceId: ".concat(e));
        return n;
      }
      async init() {
        this.state = ME.INITING;
        try {
          await this.updateDevicesInfo(), this.state = ME.INITEND;
        } catch (e) {
          throw Ee.warning("Device Detection functionality cannot start properly.", e.toString()), this.state = ME.IDLE, (typeof isSecureContext == "boolean" ? isSecureContext : location.protocol === "https:" || location.protocol === "file:" || location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "::1") || new Gt(Je.WEB_SECURITY_RESTRICT, "Your context is limited by web security, please try using https protocol or localhost.").throw(), e;
        }
      }
      async updateDevicesInfo() {
        const e = await this.enumerateDevices(!0, !0, !0), n = Date.now(), i = [];
        if (e[0] && e[0].label && this.checkdeviceMatched === !1) {
          this.checkdeviceMatched = !0;
          const f = e.find((A) => A.kind === "audioinput" && A.deviceId === "default"), T = e.find((A) => A.kind === "audiooutput" && A.deviceId === "default");
          f && T ? T.groupId === f.groupId ? Ee.debug("[device-check] default input ".concat(f.label, " and output ").concat(T.label, " is the same group")) : Ee.debug("[device-check] default input ".concat(f.label, " and output ").concat(T.label, " is not the same group")) : Ee.debug("[device-check] default input or output not found");
        }
        const o = this.checkMediaDeviceInfoIsOk(e);
        if (e.forEach((f) => {
          if (!f.deviceId) return;
          const T = this.deviceInfoMap.get("".concat(f.kind, "_").concat(f.deviceId));
          if ((T ? T.state : "INACTIVE") !== "ACTIVE") {
            const A = { initAt: n, updateAt: n, device: f, state: "ACTIVE" };
            this.deviceInfoMap.set("".concat(f.kind, "_").concat(f.deviceId), A), i.push(A);
          }
          T && (T.updateAt = n);
        }), this.deviceInfoMap.forEach((f, T) => {
          f.state === "ACTIVE" && f.updateAt !== n && (f.state = "INACTIVE", i.push(f));
        }), this.state !== ME.INITEND) return o.audio && (this.lastAccessMicrophonePermission = !0, this.isAccessMicrophonePermission = !0), void (o.video && (this.lastAccessCameraPermission = !0, this.isAccessCameraPermission = !0));
        i.forEach((f) => {
          switch (f.device.kind) {
            case "audioinput":
              this.lastAccessMicrophonePermission && this.isAccessMicrophonePermission && this.emit(Of.RECORDING_DEVICE_CHANGED, f);
              break;
            case "videoinput":
              this.lastAccessCameraPermission && this.isAccessCameraPermission && this.emit(Of.CAMERA_DEVICE_CHANGED, f);
              break;
            case "audiooutput":
              this.lastAccessMicrophonePermission && this.isAccessMicrophonePermission && this.emit(Of.PLAYOUT_DEVICE_CHANGED, f);
          }
        }), o.audio && (this.lastAccessMicrophonePermission = !0, this.isAccessMicrophonePermission = !0), o.video && (this.lastAccessCameraPermission = !0, this.isAccessCameraPermission = !0);
      }
      checkMediaDeviceInfoIsOk(e) {
        const n = e.filter((f) => f.kind === "audioinput"), i = e.filter((f) => f.kind === "videoinput"), o = { audio: !1, video: !1 };
        for (const f of n) if (f.label && f.deviceId) {
          o.audio = !0;
          break;
        }
        for (const f of i) if (f.label && f.deviceId) {
          o.video = !0;
          break;
        }
        return o;
      }
    }();
    let sI = !1;
    const uo = new class extends ii {
      constructor() {
        super(...arguments), Yt(this, "onAutoplayFailed", void 0), Yt(this, "onAudioAutoplayFailed", void 0);
      }
    }();
    function V5() {
      if (hr(), !sI) {
        const e = (n) => {
          n.preventDefault(), sI = !1, SE() ? document.body.removeEventListener("click", e, !0) : (document.body.removeEventListener("touchstart", e, !0), document.body.removeEventListener("mousedown", e, !0));
        };
        sI = !0, SE() ? document.body.addEventListener("click", e, !0) : (document.body.addEventListener("touchstart", e, !0), document.body.addEventListener("mousedown", e, !0)), Ee.info("detect media autoplay failed, document: https://docs.agora.io/cn/Voice/autoplay_policy_web_ng?platform=Web"), uo.onAutoplayFailed ? uo.onAutoplayFailed() : uo.onAudioAutoplayFailed ? Ee.warning(`AgoraRTC.onAudioAutoplayFailed has been deprecated in favor of AgoraRTC.onAutoplayFailed.

  Please refer to the Agora document to migrate the newer API, https://docs.agora.io/en/Voice/autoplay_policy_web_ng?platform=Web .`) : Ee.warning(`We have detected a media autoplay failed event, and found out that you haven't implemented AgoraRTC.onAutoplayFailed callback yet.

  It will cause audio/video element not playing automatically on some browsers without user interaction, possibly hurting user experiences.

  Please refer to the Agora document to properly handle autoplay failed event, https://docs.agora.io/en/Voice/autoplay_policy_web_ng?platform=Web .`), uo.emit("autoplay-failed");
      }
    }
    function Y5(e, n, i, o) {
      if (!e) return;
      const f = Cn.getBaseInfoBySessionId(e);
      if (!f) return;
      const T = f.info, A = Date.now(), R = Zr(Zr({}, T), {}, { vid: T.vid === void 0 ? 0 : Number(T.vid), lts: A, elapse: A - f.startTime, cbRegistered: uo.onAutoplayFailed || uo.onAudioAutoplayFailed ? 1 : -1, errorMsg: i, mediaType: n, trackId: o, extend: void 0 });
      Cn.send({ type: ti.AUTOPLAY_FAILED, data: R }, !0);
    }
    const gse = ["play", "playing", "loadeddata", "canplay", "pause", "stalled", "suspend", "waiting", "abort", "emptied", "ended", "error"], ha = new class {
      constructor() {
        Yt(this, "onAutoplayFailed", void 0), Yt(this, "elementMap", /* @__PURE__ */ new Map()), Yt(this, "elementStateMap", /* @__PURE__ */ new Map()), Yt(this, "elementsNeedToResume", []), Yt(this, "sinkIdMap", /* @__PURE__ */ new Map()), Yt(this, "autoResumeAfterInterruption", (e) => {
          Array.from(this.elementMap.entries()).forEach((n) => {
            let [i, o] = n;
            const f = this.elementStateMap.get(i), T = o.srcObject.getAudioTracks()[0], A = T && T.readyState;
            if (Ee.debug("resume after interrupted, ele: ".concat(f, " audio: ").concat(A, " ").concat(e)), A === "live") {
              if (e) return o.pause(), void o.play();
              if (wr.curState === "running") return ep() ? (o.pause(), void o.play()) : void (f && f === "paused" && o.play());
            }
          });
        }), Yt(this, "autoResumeAfterInterruptionOnIOS15_16", () => {
          Array.from(this.elementMap.entries()).forEach((e) => {
            let [n, i] = e;
            const o = i.srcObject.getAudioTracks()[0];
            o && o.readyState === "live" && (Ee.debug("auto resume after interruption inside autoResumeAfterInterruptionOnIOS15"), i.pause(), i.play());
          });
        }), this.autoResumeAudioElement(), wr.on(vs.IOS_INTERRUPTION_END, this.autoResumeAfterInterruption), wr.on(vs.IOS_15_16_INTERRUPTION_END, this.autoResumeAfterInterruptionOnIOS15_16), wr.on(vs.STATE_CHANGE, () => {
          ta() && wr.prevState === "suspended" && wr.curState === "running" && this.autoResumeAfterInterruption();
        });
      }
      async setSinkID(e, n) {
        const i = this.elementMap.get(e);
        if (this.sinkIdMap.set(e, n), i) try {
          await i.setSinkId(n);
        } catch (o) {
          throw new Gt(Je.PERMISSION_DENIED, "can not set sink id: " + o.toString());
        }
      }
      play(e, n, i, o) {
        if (this.elementMap.has(n)) return;
        const f = document.createElement("audio");
        f.autoplay = !0, f.srcObject = new MediaStream([e]), this.bindAudioElementEvents(n, f), this.elementMap.set(n, f), this.elementStateMap.set(n, Xs.INIT), this.setVolume(n, i);
        const T = this.sinkIdMap.get(n);
        if (T) try {
          f.setSinkId(T).catch((R) => {
            Ee.warning("[".concat(n, "] set sink id failed"), R.toString());
          });
        } catch (R) {
          Ee.warning("[".concat(n, "] set sink id failed"), R.toString());
        }
        const A = f.play();
        A && A.then && A.catch((R) => {
          o && Y5(o, "audio", R.message, n), Ee.warning("audio element play warning", R.toString()), this.elementMap.has(n) && R.name === "NotAllowedError" && (Ee.warning("detected audio element autoplay failed"), this.elementsNeedToResume.push(f), lT(() => {
            this.onAutoplayFailed && this.onAutoplayFailed(), V5();
          }));
        });
      }
      updateTrack(e, n) {
        const i = this.elementMap.get(e);
        i && (i.srcObject = new MediaStream([n]));
      }
      isPlaying(e) {
        return this.elementMap.has(e) && this.elementStateMap.get(e) === "playing";
      }
      setVolume(e, n) {
        const i = this.elementMap.get(e);
        i && (n = Math.max(0, Math.min(100, n)), i.volume = n / 100);
      }
      stop(e) {
        const n = this.elementMap.get(e);
        if (this.sinkIdMap.delete(e), !n) return;
        const i = this.elementsNeedToResume.indexOf(n);
        this.elementsNeedToResume.splice(i, 1), n.srcObject = null, n.remove(), this.elementMap.delete(e), this.elementStateMap.delete(e);
      }
      bindAudioElementEvents(e, n) {
        gse.forEach((i) => {
          n.addEventListener(i, (o) => {
            const f = this.elementStateMap.get(e), T = o.type === "pause" ? "paused" : o.type;
            if (Ee.debug("[".concat(e, "] audio-element-status change ").concat(f, " => ").concat(T)), o.type === "error") {
              const A = n == null ? void 0 : n.error;
              A && Ee.error("[".concat(e, "] media error, code: ").concat(A.code, ", message: ").concat(A.message));
            }
            this.elementStateMap.set(e, T);
          });
        });
      }
      getPlayerState(e) {
        return this.elementStateMap.get(e) || "uninit";
      }
      autoResumeAudioElement() {
        const e = () => {
          this.elementsNeedToResume.forEach((n) => {
            n.play().then((i) => {
              Ee.debug("Auto resume audio element success");
            }).catch((i) => {
              Ee.warning("Auto resume audio element failed!", i);
            });
          }), this.elementsNeedToResume = [];
        };
        new cn((n) => {
          document.body ? n() : window.addEventListener("load", () => n());
        }).then(() => {
          SE() ? document.body.addEventListener("click", e, !0) : (document.body.addEventListener("touchstart", e, !0), document.body.addEventListener("mousedown", e, !0));
        });
      }
    }();
    function Ti() {
      return function(e, n, i) {
        const o = i.value;
        return typeof o == "function" && (i.value = function() {
          this._isClosed && new Gt(Je.INVALID_OPERATION, "[".concat(this.getTrackId(), "] cannot operate a closed track")).print("warning", Ee);
          for (var f = arguments.length, T = new Array(f), A = 0; A < f; A++) T[A] = arguments[A];
          const R = o.apply(this, T);
          return R instanceof cn ? new cn((P, L) => {
            R.then(P).catch(L);
          }) : R;
        }), i;
      };
    }
    class X5 extends ii {
      constructor(n) {
        super(), Yt(this, "name", "VideoProcessorDestination"), Yt(this, "ID", "0"), Yt(this, "_source", void 0), Yt(this, "videoContext", void 0), Yt(this, "inputTrack", void 0), this.videoContext = n;
      }
      get kind() {
        return "video";
      }
      get enabled() {
        return !0;
      }
      pipe() {
        throw new Gt(Je.NOT_SUPPORTED, "VideoProcessor cannot pipe to any other Processor");
      }
      unpipe() {
        throw new Gt(Je.NOT_SUPPORTED, "VideoProcessor cannot unpipe to any other Processor");
      }
      enable() {
      }
      disable() {
      }
      updateInput(n) {
        if (n.context !== this.videoContext) throw new Error(`ProcessorContext passed to VideoTrack.processorDestination doesn't match it's belonging VideoTrack's context.
Probably you are making pipeline like this:
videoTrack1.pipe(processor).pipe(videoTrack2.processorDestination).`);
        n.track && n.track !== this.inputTrack && (this.videoContext.chained = !0, this.inputTrack = n.track, this.emit(na.ON_TRACK, n.track));
      }
      reset() {
        this.inputTrack = void 0, this.videoContext.chained = !1, this.emit(na.ON_TRACK, void 0);
      }
    }
    class W5 extends ii {
      set chained(n) {
        this._chained = n;
      }
      get chained() {
        return this._chained;
      }
      constructor(n, i) {
        super(), Yt(this, "constraintsMap", /* @__PURE__ */ new Map()), Yt(this, "statsRegistry", []), Yt(this, "usageRegistry", []), Yt(this, "trackId", void 0), Yt(this, "direction", void 0), Yt(this, "_chained", !1), this.trackId = n, this.direction = i;
      }
      async getConstraints() {
        return await Ss(this, so.REQUEST_CONSTRAINTS);
      }
      async requestApplyConstraints(n, i) {
        var o;
        return Ee.info("processor ".concat(i.name, " requestApplyConstraints for ").concat(this.trackId)), n && this.constraintsMap.set(i, n), Br(this, so.REQUEST_UPDATE_CONSTRAINTS, Array.from(nd(o = this.constraintsMap).call(o)));
      }
      async requestRevertConstraints(n) {
        var i;
        if (this.constraintsMap.has(n)) return Ee.info("processor ".concat(n.name, " requestRevertConstraints for ").concat(this.trackId)), this.constraintsMap.delete(n), Br(this, so.REQUEST_UPDATE_CONSTRAINTS, Array.from(nd(i = this.constraintsMap).call(i)));
      }
      registerStats(n, i, o) {
        this.statsRegistry.find((f) => f.processorID === n.ID && f.processorName === n.name && f.type === i) || this.statsRegistry.push({ processorName: n.name, processorID: n.ID, type: i, cb: o });
      }
      unregisterStats(n, i) {
        const o = this.statsRegistry.findIndex((f) => f.processorID === n.ID && f.processorName === n.name && f.type === i);
        o !== -1 && this.statsRegistry.splice(o, 1);
      }
      gatherStats() {
        const n = [];
        for (const { processorID: i, processorName: o, type: f, cb: T } of this.statsRegistry) try {
          const A = T();
          n.push({ processorID: i, processorName: o, type: f, stats: A });
        } catch (A) {
          Ee.error(new Gt(Je.UNEXPECTED_ERROR, A.message));
        }
        return n;
      }
      registerUsage(n, i) {
        this.usageRegistry.find((o) => o.processorID === n.ID && o.processorName === n.name) || this.usageRegistry.push({ processorID: n.ID, processorName: n.name, cb: i });
      }
      unregisterUsage(n) {
        const i = this.usageRegistry.findIndex((o) => o.processorID === n.ID && o.processorName === n.name);
        i !== -1 && this.usageRegistry.splice(i, 1);
      }
      async gatherUsage() {
        const n = [];
        if (!this.chained) return [];
        for (const { cb: i } of this.usageRegistry) try {
          let o = i();
          o instanceof cn && (o = await o), n.push(Zr(Zr({}, o), {}, { direction: this.direction }));
        } catch (o) {
          Ee.error("gather extension usage error", o);
        }
        return n;
      }
      getDirection() {
        return this.direction;
      }
    }
    class q5 extends ii {
      constructor(n) {
        super(), Yt(this, "name", "AudioProcessorDestination"), Yt(this, "ID", "0"), Yt(this, "inputTrack", void 0), Yt(this, "inputNode", void 0), Yt(this, "audioProcessorContext", void 0), Yt(this, "_source", void 0), this.audioProcessorContext = n;
      }
      get kind() {
        return "audio";
      }
      get enabled() {
        return !0;
      }
      pipe() {
        throw new Gt(Je.NOT_SUPPORTED, "AudioProcessorDestination cannot pipe to any other Processor");
      }
      unpipe() {
        throw new Gt(Je.NOT_SUPPORTED, "AudioProcessor cannot unpipe to any other Processor");
      }
      enable() {
      }
      disable() {
      }
      reset() {
        this.inputTrack = void 0, this.inputNode = void 0, this.audioProcessorContext.chained = !1, this.emit(na.ON_TRACK, void 0), this.emit(na.ON_NODE, void 0);
      }
      updateInput(n) {
        if (n.context !== this.audioProcessorContext) throw new Error(`ProcessorContext passed to AudioTrack.processorDestination doesn't match it's belonging AudioTrack's context.
        Probably you are making pipeline like this: audioTrack1.pipe(processor).pipe(audioTrack2.processorDestination).`);
        n.track && this.inputTrack !== n.track && (this.audioProcessorContext.chained = !0, this.inputTrack = n.track, this.emit(na.ON_TRACK, this.inputTrack)), n.node && this.inputNode !== n.node && (this.audioProcessorContext.chained = !0, this.inputNode = n.node, this.emit(na.ON_NODE, this.inputNode));
      }
    }
    class K5 extends ii {
      set chained(n) {
        this._chained = n;
      }
      get chained() {
        return this._chained;
      }
      constructor(n, i, o) {
        super(), Yt(this, "constraintsMap", /* @__PURE__ */ new Map()), Yt(this, "statsRegistry", []), Yt(this, "audioContext", void 0), Yt(this, "trackId", void 0), Yt(this, "direction", void 0), Yt(this, "usageRegistry", []), Yt(this, "_chained", !1), this.audioContext = n, this.trackId = i, this.direction = o;
      }
      async getConstraints() {
        return Ss(this, so.REQUEST_CONSTRAINTS);
      }
      getAudioContext() {
        return this.audioContext;
      }
      async requestApplyConstraints(n, i) {
        var o;
        return Ee.info("processor ".concat(i.name, " requestApplyConstraints for ").concat(this.trackId)), n && this.constraintsMap.set(i, n), Br(this, so.REQUEST_UPDATE_CONSTRAINTS, Array.from(nd(o = this.constraintsMap).call(o)));
      }
      async requestRevertConstraints(n) {
        var i;
        if (this.constraintsMap.has(n)) return this.constraintsMap.delete(n), Br(this, so.REQUEST_UPDATE_CONSTRAINTS, Array.from(nd(i = this.constraintsMap).call(i)));
      }
      registerStats(n, i, o) {
        this.statsRegistry.find((f) => f.processorID === n.ID && f.processorName === n.name && f.type === i) || this.statsRegistry.push({ processorName: n.name, processorID: n.ID, type: i, cb: o });
      }
      unregisterStats(n, i) {
        const o = this.statsRegistry.findIndex((f) => f.processorID === n.ID && f.processorName === n.name && f.type === i);
        o !== -1 && this.statsRegistry.splice(o, 1);
      }
      gatherStats() {
        const n = [];
        for (const { processorID: i, processorName: o, type: f, cb: T } of this.statsRegistry) try {
          const A = T();
          n.push({ processorID: i, processorName: o, type: f, stats: A });
        } catch (A) {
          Ee.error(new Gt(Je.UNEXPECTED_ERROR, A.message));
        }
        return n;
      }
      registerUsage(n, i) {
        this.usageRegistry.find((o) => o.processorID === n.ID && o.processorName === n.name) || this.usageRegistry.push({ processorID: n.ID, processorName: n.name, cb: i });
      }
      unregisterUsage(n) {
        const i = this.usageRegistry.findIndex((o) => o.processorID === n.ID && o.processorName === n.name);
        i !== -1 && this.usageRegistry.splice(i, 1);
      }
      async gatherUsage() {
        const n = [];
        if (!this.chained) return [];
        for (const { cb: i } of this.usageRegistry) try {
          let o = i();
          o instanceof cn && (o = await o), n.push(Zr(Zr({}, o), {}, { direction: this.direction }));
        } catch (o) {
          Ee.error("gather extension usage error", o);
        }
        return n;
      }
      getDirection() {
        return this.direction;
      }
    }
    class aI extends ii {
      get isPlayed() {
        return !0;
      }
      get isFreeze() {
        return !1;
      }
      constructor() {
        super(), Yt(this, "context", void 0), Yt(this, "processSourceNode", void 0), Yt(this, "outputTrack", void 0), Yt(this, "processedNode", void 0), Yt(this, "clonedTrack", void 0), Yt(this, "outputNode", void 0), this.outputNode = new mse();
      }
      setVolume() {
      }
      createOutputTrack() {
        throw new Gt(Je.NOT_SUPPORTED, "can not create output MediaStreamTrack when WebAudio disabled");
      }
      getOriginVolumeLevel() {
        return 0;
      }
      getAccurateVolumeLevel() {
        return 0;
      }
      stopGetAudioBuffer() {
      }
      startGetAudioBuffer() {
      }
      play() {
      }
      stop() {
      }
      destroy() {
      }
      updateTrack() {
      }
      updateOriginTrack() {
      }
      createMediaStreamSourceNode() {
      }
    }
    class mse {
      disconnect() {
      }
      connect() {
      }
    }
    function J5(e) {
      return new cn((n, i) => {
        let o = !1;
        const f = document.createElement("video");
        f.setAttribute("autoplay", ""), f.setAttribute("muted", ""), f.muted = !0, f.autoplay = !0, f.setAttribute("playsinline", ""), f.setAttribute("style", "position: fixed; top: 0; left: 0; width: 1px; height: 1px"), document.body.appendChild(f);
        const T = ta() ? "canplay" : "playing";
        f.addEventListener(T, () => {
          const A = f.videoWidth, R = f.videoHeight;
          !A && ui() || (o = !0, f.srcObject = null, f.remove(), n([A, R]));
        }), f.srcObject = new MediaStream([e]), f.play().catch(fT), setTimeout(() => {
          o || (f.srcObject = null, f.remove(), n([f.videoWidth, f.videoHeight]));
        }, 4e3);
      });
    }
    function AT(e) {
      const n = {};
      e.facingMode && (n.facingMode = e.facingMode), e.cameraId && (n.deviceId = { exact: e.cameraId });
      const i = yu(e.encoderConfig);
      return i.width != null && (n.width = i.width), i.height != null && (n.height = i.height), !JM() && i.frameRate && (n.frameRate = i.frameRate), FM() && typeof n.frameRate == "object" && (n.frameRate.max = 60), ui() && (n.frameRate = { ideal: 30, max: 30 }), n;
    }
    function Z5(e) {
      const n = {};
      return JM() || (e.AGC !== void 0 && (n.autoGainControl = e.AGC), e.AEC !== void 0 && (n.echoCancellation = e.AEC), e.ANS !== void 0 && (n.noiseSuppression = e.ANS, $d() && e.ANS && (n.googHighpassFilter = e.ANS))), n;
    }
    function Q5(e) {
      const n = Z5(e);
      if (e.encoderConfig) {
        const i = vT(e.encoderConfig);
        n.channelCount = i.stereo ? 2 : 1, n.sampleRate = i.sampleRate, n.sampleSize = i.sampleSize;
      }
      return e.microphoneId && (n.deviceId = { exact: e.microphoneId }), uT() && (n.sampleRate = void 0), n;
    }
    const Ese = (e) => {
      const n = e._encoderConfig;
      if (!n) return;
      const { frameRate: i, width: o, height: f } = e.getMediaStreamTrackSettings();
      let { frameRate: T = i, width: A = o, height: R = f } = n;
      if (!T || !A || !R) return;
      A = US(A), R = US(R), T = US(T);
      const { max: P, min: L } = function(oe, He, Re) {
        const De = 200 * Math.pow(Re / 15, 0.6) * Math.pow(oe * He / 640 / 360, 0.75);
        return { min: Math.floor(De), max: Math.floor(4 * De) };
      }(A, R, T), { bitrateMax: z, bitrateMin: Y } = n || {};
      z || Ee.debug("calculate bitrate: [w: ".concat(A, ", h: ").concat(R, ", fps: ").concat(T, "] => [brMax: ").concat(z, ", brMin: ").concat(Y, "]"));
      const { maxFramerate: te } = ft("ENCODER_CONFIG_LIMIT");
      return te && typeof te == "number" && (T = Math.min(T, te)), { frameRate: T, bitrateMax: z || P, bitrateMin: Y || L, scaleResolutionDownBy: 1, scale: 0 };
    }, $5 = async (e, n, i) => await (async (o, f, T) => {
      const A = function(L) {
        const z = [];
        for (let Y = 0; Y < L.length; Y += 2) z.push(parseInt(L.slice(Y, Y + 2), 16));
        return Uint8Array.from(z);
      }(f5("" + f + T)).slice(0, 16), R = A.slice(0, 12), P = await window.crypto.subtle.importKey("raw", A, "AES-GCM", !0, ["encrypt"]);
      return new Uint8Array(await window.crypto.subtle.encrypt({ name: "AES-GCM", iv: R }, P, o));
    })(e.buffer, n, i), oI = (e) => {
      const n = document.createElement("canvas");
      return n.width = 2, n.height = 2, new cn((i, o) => {
        n.toBlob(async (f) => {
          if (n.remove(), f) {
            const T = await eL(f);
            i({ buffer: T, width: n.width, height: n.height });
          } else o(new Gt(Je.CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED));
        }, e, 1);
      });
    }, eL = async (e) => {
      const n = await e.arrayBuffer();
      return new Uint8Array(n);
    };
    var tL, nL, rL, iL, sL, aL, oL, cL, uL, dL, lL, fL, hL, pL, gL, mL, EL, yL, ni, vL, TL, bL, AL, OL, CL, Tu, SL, IL, RL, NL, wL, _L, PL, xL, DL, ML, LL, kL, jL, Rs;
    let li = (tL = Dn({ argsMap: (e, n) => [e.getTrackId(), n], throttleTime: 300 }), nL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), rL = Ti(), iL = ip("LocalAudioTrack", "_enabledMutex"), sL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), aL = Ti(), oL = ip("LocalAudioTrack", "_enabledMutex"), cL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), uL = Ti(), dL = Ti(), lL = Ti(), fL = Dn({ argsMap: (e) => [e.getTrackId()] }), hL = Ti(), pL = Dn({ argsMap: (e) => [e.getTrackId()] }), gL = Ti(), mL = Dn({ argsMap: (e) => [e.getTrackId()] }), EL = Dn({ argsMap: (e, n) => [e.getTrackId(), n.name] }), yL = Dn({ argsMap: (e) => [e.getTrackId()] }), fr((ni = class extends hp {
      get _source() {
        return this.initWebAudio();
      }
      set _source(e) {
        this._trackSource = e;
      }
      get processorContext() {
        return this._processorContext || (this._processorContext = this.initProcessor().processorContext), this._processorContext;
      }
      get processorDestination() {
        return this._processorDestination || (this._processorDestination = this.initProcessor().processorDestination), this._processorDestination;
      }
      get isPlaying() {
        return this._useAudioElement ? ha.isPlaying(this.getTrackId()) : this._source.isPlayed;
      }
      get __className__() {
        return "LocalAudioTrack";
      }
      constructor(e, n, i, o) {
        super(e, i), Yt(this, "trackMediaType", fp.AUDIO), Yt(this, "_encoderConfig", void 0), Yt(this, "_trackSource", void 0), Yt(this, "_enabled", !0), Yt(this, "_volume", 100), Yt(this, "_useAudioElement", !0), Yt(this, "_bypassWebAudio", !1), Yt(this, "processor", void 0), Yt(this, "_processorContext", void 0), Yt(this, "_processorDestination", void 0), Yt(this, "_getOriginVolumeLevel", void 0), this._encoderConfig = n, this._getOriginVolumeLevel = !!o, this._trackSource = new aI(), ft("DISABLE_WEBAUDIO") && (this._bypassWebAudio = !0), ft("LOCAL_AUDIO_TRACK_USES_WEB_AUDIO") && (this._useAudioElement = !1), Os() && !ao ? setTimeout(() => this.initWebAudio()) : this.initWebAudio();
      }
      setVolume(e) {
        xr(e, "volume", 0, 1e3), this._volume = e, this._source.setVolume(e / 100), this._useAudioElement && ha.setVolume(this.getTrackId(), e);
        try {
          if (this._bypassWebAudio) return void Ee.debug("[".concat(this.getTrackId(), "] setVolume returned because no pass through WebAudio."));
          const n = this._source.createOutputTrack();
          this._mediaStreamTrack !== n && (this._mediaStreamTrack = n, Br(this, Tn.NEED_REPLACE_TRACK, this).then(() => {
            Ee.debug("[".concat(this.getTrackId(), "] replace web audio track success"));
          }).catch((i) => {
            Ee.warning("[".concat(this.getTrackId(), "] replace web audio track failed"), i);
          }));
        } catch {
        }
      }
      getVolumeLevel() {
        return this._muted && this.enabled && this._getOriginVolumeLevel ? this._source.getOriginVolumeLevel() : this._source.getAccurateVolumeLevel();
      }
      async setPlaybackDevice(e) {
        if (!this._useAudioElement || !w5()) throw new Gt(Je.NOT_SUPPORTED, "your browser does not support setting the audio output device");
        await ha.setSinkID(this.getTrackId(), e);
      }
      async setEnabled(e, n, i) {
        return this._setEnabled(e, n, i);
      }
      async _setEnabled(e, n, i) {
        if (!i) {
          if (e === this._enabled) return;
          this.stateCheck("enabled", e);
        }
        if (Ee.info("[".concat(this.getTrackId(), "] start setEnabled"), e), e) {
          this._originMediaStreamTrack.enabled = !0;
          try {
            i || (this._enabled = !0), await Br(this, Tn.NEED_ENABLE_TRACK, this), Ee.info("[".concat(this.getTrackId(), "] setEnabled to ").concat(e, " success"));
          } catch (o) {
            throw i || (this._enabled = !1), Ee.error("[".concat(this.getTrackId(), "] setEnabled to true error"), o.toString()), o;
          }
        } else {
          this._originMediaStreamTrack.enabled = !1, i || (this._enabled = !1);
          try {
            await Br(this, Tn.NEED_DISABLE_TRACK, this);
          } catch (o) {
            throw i || (this._enabled = !0), Ee.error("[".concat(this.getTrackId(), "] setEnabled to false error"), o.toString()), o;
          }
        }
      }
      async setMuted(e) {
        e !== this._muted && (this.stateCheck("muted", e), this._muted = e, this._originMediaStreamTrack.enabled = !e, Ee.debug("[".concat(this.getTrackId(), "] start set muted: ").concat(e)), e ? await Br(this, Tn.NEED_MUTE_TRACK, this) : await Br(this, Tn.NEED_UNMUTE_TRACK, this));
      }
      getStats() {
        return el(() => {
          Ee.warning("[deprecated] LocalAudioTrack.getStats will be removed in the future, use AgoraRTCClient.getLocalAudioStats instead");
        }, "localAudioTrackGetStatsWarning"), to(this, Tn.GET_STATS) || Zr({}, $S);
      }
      setAudioFrameCallback(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4096;
        if (!e) return this._source.removeAllListeners(io.ON_AUDIO_BUFFER), void this._source.stopGetAudioBuffer();
        this._source.startGetAudioBuffer(n), this._source.removeAllListeners(io.ON_AUDIO_BUFFER), this._source.on(io.ON_AUDIO_BUFFER, (i) => e(i));
      }
      play() {
        Ee.debug("[".concat(this.getTrackId(), "] start audio playback")), this._useAudioElement ? (Ee.debug("[".concat(this.getTrackId(), "] start audio playback in element")), ha.play(this._mediaStreamTrack, this.getTrackId(), this._volume)) : this._source.play();
      }
      stop() {
        Ee.debug("[".concat(this.getTrackId(), "] stop audio playback")), this._useAudioElement ? ha.stop(this.getTrackId()) : this._source.stop();
      }
      close() {
        super.close(), this._processorDestination && this.unbindProcessorDestinationEvents(this._processorDestination), this._processorContext && this.unbindProcessorContextEvents(this._processorContext), this.unpipe(), this._processorDestination && this._processorDestination._source && this._processorDestination._source.unpipe(), this._source.destroy();
      }
      _updatePlayerSource() {
        let e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
        Ee.debug("[".concat(this.getTrackId(), "] update player source track")), e && this._source.updateTrack(this._mediaStreamTrack), this._useAudioElement && ha.updateTrack(this.getTrackId(), this._mediaStreamTrack);
      }
      async _updateOriginMediaStreamTrack(e, n) {
        this._originMediaStreamTrack !== e && (this._originMediaStreamTrack && (this._originMediaStreamTrack.removeEventListener("ended", this._handleTrackEnded), n && this._originMediaStreamTrack.stop()), e.addEventListener("ended", this._handleTrackEnded), this._originMediaStreamTrack = e, this._muted && (this._originMediaStreamTrack.enabled = !1), this.processor && this._processorContext && this.processor.updateInput({ track: e, context: this._processorContext }), this._mediaStreamTrack !== this._source.outputTrack ? (this._mediaStreamTrack = this._originMediaStreamTrack, this._updatePlayerSource(), await Br(this, Tn.NEED_REPLACE_TRACK, this)) : this._source.updateTrack(this._originMediaStreamTrack), this._getOriginVolumeLevel && this._source.updateOriginTrack(e));
      }
      renewMediaStreamTrack(e) {
        return cn.resolve(void 0);
      }
      pipe(e) {
        if (this._bypassWebAudio) throw new Gt(Je.INVALID_OPERATION, "Can not process AudioTrack when bypassWebAudio set to true.");
        if (this.processor === e) return e;
        if (e._source) throw new Gt(Je.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({ track: this._originMediaStreamTrack, node: this._source.processSourceNode, context: this.processorContext }), e;
      }
      unpipe() {
        var e;
        if (!this.processor) return;
        const n = this.processor;
        (e = this._source.processSourceNode) === null || e === void 0 || e.disconnect(), this.processor._source = !1, this.processor = void 0, n.reset();
      }
      bindProcessorDestinationEvents(e) {
        e.on(na.ON_TRACK, async (n) => {
          n ? n !== this._mediaStreamTrack && (this._mediaStreamTrack = n, this._updatePlayerSource(!1), this._source.processedNode = this._source.createMediaStreamSourceNode(n), await Br(this, Tn.NEED_REPLACE_TRACK, this)) : this._mediaStreamTrack !== this._originMediaStreamTrack && (this._mediaStreamTrack = this._originMediaStreamTrack, this._updatePlayerSource(), await Br(this, Tn.NEED_REPLACE_TRACK, this));
        }), e.on(na.ON_NODE, (n) => {
          this._source.processedNode = n;
        });
      }
      unbindProcessorDestinationEvents(e) {
        e.removeAllListeners(na.ON_TRACK), e.removeAllListeners(na.ON_NODE);
      }
      bindProcessorContextEvents(e) {
        e.on(so.REQUEST_CONSTRAINTS, async (n) => {
          n(this._originMediaStreamTrack.getSettings());
        });
      }
      unbindProcessorContextEvents(e) {
        e.removeAllListeners(so.REQUEST_CONSTRAINTS);
      }
      initWebAudio() {
        return this._trackSource instanceof aI && (this._trackSource = new H5(this._mediaStreamTrack, !1, this._getOriginVolumeLevel ? this._mediaStreamTrack : void 0)), this._trackSource;
      }
      initProcessor() {
        const e = new K5(this._source.context, this.getTrackId(), "local"), n = new q5(e);
        return this._processorContext = e, this._processorDestination = n, this.bindProcessorContextEvents(e), this.bindProcessorDestinationEvents(n), this._source.on(io.UPDATE_SOURCE, () => {
          this.processor && this.processor.updateInput({ node: this._source.processSourceNode, context: e });
        }), this._useAudioElement && (this._useAudioElement = !1, this.isPlaying && (ha.stop(this.getTrackId()), this._source.play()), Br(this, Tn.NEED_REPLACE_MIXING_TRACK, this).then(() => {
          Ee.debug("[".concat(this.getTrackId(), "] replace from origin track to web audio track success"));
        }).catch((i) => {
          Ee.warning("[".concat(this.getTrackId(), "] replace from origin track to web audio track failed"), i);
        })), { processorContext: e, processorDestination: n };
      }
    }).prototype, "setVolume", [tL], Object.getOwnPropertyDescriptor(ni.prototype, "setVolume"), ni.prototype), fr(ni.prototype, "setPlaybackDevice", [nL, rL], Object.getOwnPropertyDescriptor(ni.prototype, "setPlaybackDevice"), ni.prototype), fr(ni.prototype, "setEnabled", [iL, sL, aL], Object.getOwnPropertyDescriptor(ni.prototype, "setEnabled"), ni.prototype), fr(ni.prototype, "setMuted", [oL, cL, uL], Object.getOwnPropertyDescriptor(ni.prototype, "setMuted"), ni.prototype), fr(ni.prototype, "getStats", [dL], Object.getOwnPropertyDescriptor(ni.prototype, "getStats"), ni.prototype), fr(ni.prototype, "setAudioFrameCallback", [lL], Object.getOwnPropertyDescriptor(ni.prototype, "setAudioFrameCallback"), ni.prototype), fr(ni.prototype, "play", [fL, hL], Object.getOwnPropertyDescriptor(ni.prototype, "play"), ni.prototype), fr(ni.prototype, "stop", [pL, gL], Object.getOwnPropertyDescriptor(ni.prototype, "stop"), ni.prototype), fr(ni.prototype, "close", [mL], Object.getOwnPropertyDescriptor(ni.prototype, "close"), ni.prototype), fr(ni.prototype, "pipe", [EL], Object.getOwnPropertyDescriptor(ni.prototype, "pipe"), ni.prototype), fr(ni.prototype, "unpipe", [yL], Object.getOwnPropertyDescriptor(ni.prototype, "unpipe"), ni.prototype), ni), OT = (vL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), TL = Ti(), bL = ip("MicrophoneAudioTrack", "_enabledMutex"), AL = Dn({ argsMap: (e, n, i) => [e.getTrackId(), n, i] }), OL = Ti(), CL = Dn({ argsMap: (e) => [e.getTrackId()] }), fr((Tu = class extends li {
      get __className__() {
        return "MicrophoneAudioTrack";
      }
      constructor(e, n, i, o) {
        super(e, n.encoderConfig ? vT(n.encoderConfig) : {}, o, ft("GET_VOLUME_OF_MUTED_AUDIO_TRACK")), Yt(this, "_config", void 0), Yt(this, "_deviceName", "default"), Yt(this, "_constraints", void 0), Yt(this, "_originalConstraints", void 0), Yt(this, "_enabled", !0), this._config = n, this._constraints = i, this._originalConstraints = i, this._deviceName = e.label, typeof n.bypassWebAudio == "boolean" && (this._bypassWebAudio = n.bypassWebAudio), (ep() || _S()) && wr.bindInterruptDetectorTrack(this);
      }
      async setDevice(e) {
        if (Ee.info("[".concat(this.getTrackId(), "] start set device to ").concat(e)), this._enabled) try {
          const n = await co.getDeviceById(e), i = {};
          i.audio = Zr({}, this._constraints), i.audio.deviceId = { exact: e }, this._originMediaStreamTrack.stop();
          let o = null;
          try {
            o = await oo(i, this.getTrackId());
          } catch (f) {
            throw Ee.error("[".concat(this.getTrackId(), "] setDevice failed"), f.toString()), o = await oo({ audio: this._constraints }, this.getTrackId()), await this._updateOriginMediaStreamTrack(o.getAudioTracks()[0], !1), f;
          }
          await this._updateOriginMediaStreamTrack(o.getAudioTracks()[0], !1), this._deviceName = n.label, this._config.microphoneId = e, this._constraints.deviceId = { exact: e };
        } catch (n) {
          throw Ee.error("[".concat(this.getTrackId(), "] setDevice error"), n.toString()), n;
        }
        else try {
          const n = await co.getDeviceById(e);
          this._deviceName = n.label, this._config.microphoneId = e, this._constraints.deviceId = { exact: e };
        } catch (n) {
          throw Ee.error("[".concat(this.getTrackId(), "] setDevice error"), n.toString()), n;
        }
        Ee.info("[".concat(this.getTrackId(), "] set device to ").concat(e, " success"));
      }
      async setEnabled(e, n, i) {
        if (n) return Ee.debug("[".concat(this.getTrackId(), "] setEnabled false (do not close microphone)")), await super._setEnabled(e);
        if (!i) {
          if (e === this._enabled) return;
          this.stateCheck("enabled", e);
        }
        if (Ee.info("[".concat(this.getTrackId(), "] start setEnabled"), e), ft("AUTO_RESET_AUDIO_ROUTE") && (ta() || rc())) {
          const A = navigator.audioSession;
          A && (e || (A.type = "playback"), A.type = "auto");
        }
        if (!e) {
          var o;
          this._originMediaStreamTrack.onended = null, this._originMediaStreamTrack.stop(), (o = this._source.clonedTrack) === null || o === void 0 || o.stop(), i || (this._enabled = !1);
          try {
            await Br(this, Tn.NEED_DISABLE_TRACK, this);
          } catch (A) {
            throw Ee.error("[".concat(this.getTrackId(), "] setEnabled false failed"), A.toString()), A;
          }
          return;
        }
        const f = Zr({}, this._constraints), T = co.searchDeviceIdByName(this._deviceName);
        T && !f.deviceId && (f.deviceId = T);
        try {
          i || (this._enabled = !0);
          const A = await oo({ audio: this._constraints }, this.getTrackId());
          await this._updateOriginMediaStreamTrack(A.getAudioTracks()[0], !1), await Br(this, Tn.NEED_ENABLE_TRACK, this);
        } catch (A) {
          throw i || (this._enabled = !1), Ee.error("[".concat(this.getTrackId(), "] setEnabled true failed"), A.toString()), A;
        }
        Ee.info("[".concat(this.getTrackId(), "] setEnabled success"));
      }
      close() {
        super.close(), (ep() || _S()) && wr.unbindInterruptDetectorTrack(this);
      }
      onTrackEnded() {
        if ((ta() || rc()) && this._enabled && !this._isClosed && wr.duringInterruption) {
          const e = async () => {
            wr.off(vs.IOS_INTERRUPTION_END, e), this._enabled && !this._isClosed && (Ee.debug("[".concat(this.getTrackId(), "] try capture microphone media device for interrupted iOS device.")), await this.setEnabled(!1), await this.setEnabled(!0));
          };
          wr.on(vs.IOS_INTERRUPTION_END, e);
        } else Ee.debug("[".concat(this.getTrackId(), "] track ended")), this.safeEmit(dp.TRACK_ENDED);
      }
      async renewMediaStreamTrack(e) {
        const n = e || this._constraints, i = co.searchDeviceIdByName(this._deviceName);
        if (i && !n.deviceId && (n.deviceId = i), this._constraints = n, this._enabled) {
          this._originMediaStreamTrack.stop();
          const o = await oo({ audio: this._constraints }, this.getTrackId());
          await this._updateOriginMediaStreamTrack(o.getAudioTracks()[0], !0);
        }
      }
      bindProcessorContextEvents(e) {
        super.bindProcessorContextEvents(e), e.on(so.REQUEST_UPDATE_CONSTRAINTS, async (n, i, o) => {
          try {
            const f = Object.assign({}, this._originalConstraints, ...n);
            await this.renewMediaStreamTrack(f), i();
          } catch (f) {
            o(f);
          }
        });
      }
      unbindProcessorContextEvents(e) {
        super.unbindProcessorContextEvents(e), e.removeAllListeners(so.REQUEST_UPDATE_CONSTRAINTS);
      }
    }).prototype, "setDevice", [vL, TL], Object.getOwnPropertyDescriptor(Tu.prototype, "setDevice"), Tu.prototype), fr(Tu.prototype, "setEnabled", [bL, AL, OL], Object.getOwnPropertyDescriptor(Tu.prototype, "setEnabled"), Tu.prototype), fr(Tu.prototype, "close", [CL], Object.getOwnPropertyDescriptor(Tu.prototype, "close"), Tu.prototype), Tu), yse = (SL = Dn({ argsMap: (e, n) => [e.getTrackId(), n, e.duration] }), IL = Ti(), RL = Dn({ argsMap: (e) => [e.getTrackId()] }), NL = Ti(), wL = Dn({ argsMap: (e) => [e.getTrackId()] }), _L = Ti(), PL = Dn({ argsMap: (e) => [e.getTrackId()] }), xL = Ti(), DL = Dn({ argsMap: (e) => [e.getTrackId()] }), ML = Ti(), LL = Dn({ argsMap: (e) => [e.getTrackId()] }), kL = Dn({ argsMap: (e) => [e.getTrackId()] }), jL = Ti(), fr((Rs = class extends li {
      get __className__() {
        return "BufferSourceAudioTrack";
      }
      constructor(e, n, i, o) {
        super(n.createOutputTrack(), i, o), Yt(this, "source", void 0), Yt(this, "_bufferSource", void 0), this._useAudioElement = !1, this.source = e, this._bufferSource = n, this._bufferSource.on(io.AUDIO_SOURCE_STATE_CHANGE, (f) => {
          this.safeEmit(dp.SOURCE_STATE_CHANGE, f);
        });
        try {
          this._mediaStreamTrack = this._source.createOutputTrack();
        } catch {
        }
      }
      get currentState() {
        return this._bufferSource.currentState;
      }
      get duration() {
        return this._bufferSource.duration;
      }
      get playbackSpeed() {
        return this._bufferSource.playbackSpeed;
      }
      getCurrentTime() {
        return this._bufferSource.currentTime;
      }
      startProcessAudioBuffer(e) {
        e && this._bufferSource.updateOptions(e), this._bufferSource.startProcessAudioBuffer();
      }
      pauseProcessAudioBuffer() {
        this._bufferSource.pauseProcessAudioBuffer();
      }
      seekAudioBuffer(e) {
        this._bufferSource.seekAudioBuffer(e);
      }
      resumeProcessAudioBuffer() {
        this._bufferSource.resumeProcessAudioBuffer();
      }
      stopProcessAudioBuffer() {
        this._bufferSource.stopProcessAudioBuffer();
      }
      close() {
        this.source = null, this._bufferSource.destroy(), super.close();
      }
      setAudioBufferPlaybackSpeed(e) {
        xr(e, "speed", 0), this._bufferSource.setAudioBufferPlaybackSpeed(e);
      }
    }).prototype, "startProcessAudioBuffer", [SL, IL], Object.getOwnPropertyDescriptor(Rs.prototype, "startProcessAudioBuffer"), Rs.prototype), fr(Rs.prototype, "pauseProcessAudioBuffer", [RL, NL], Object.getOwnPropertyDescriptor(Rs.prototype, "pauseProcessAudioBuffer"), Rs.prototype), fr(Rs.prototype, "seekAudioBuffer", [wL, _L], Object.getOwnPropertyDescriptor(Rs.prototype, "seekAudioBuffer"), Rs.prototype), fr(Rs.prototype, "resumeProcessAudioBuffer", [PL, xL], Object.getOwnPropertyDescriptor(Rs.prototype, "resumeProcessAudioBuffer"), Rs.prototype), fr(Rs.prototype, "stopProcessAudioBuffer", [DL, ML], Object.getOwnPropertyDescriptor(Rs.prototype, "stopProcessAudioBuffer"), Rs.prototype), fr(Rs.prototype, "close", [LL], Object.getOwnPropertyDescriptor(Rs.prototype, "close"), Rs.prototype), fr(Rs.prototype, "setAudioBufferPlaybackSpeed", [kL, jL], Object.getOwnPropertyDescriptor(Rs.prototype, "setAudioBufferPlaybackSpeed"), Rs.prototype), Rs);
    class Xi extends li {
      get __className__() {
        return "MixingAudioTrack";
      }
      get isActive() {
        for (const n of this.trackList) if (n._enabled && !n._isClosed && !n.muted) return !0;
        return !1;
      }
      constructor() {
        const n = pp().createMediaStreamDestination();
        super(n.stream.getAudioTracks()[0], void 0, zr(8, "track-mix-")), Yt(this, "trackList", void 0), Yt(this, "destNode", void 0), this._useAudioElement = !1;
        try {
          this._mediaStreamTrack = this._source.createOutputTrack();
        } catch {
        }
        this.destNode = n, this.trackList = [];
      }
      hasAudioTrack(n) {
        return this.trackList.indexOf(n) !== -1;
      }
      addAudioTrack(n) {
        this.trackList.indexOf(n) === -1 ? (Ee.debug("add ".concat(n.getTrackId(), " to mixing track")), n._source.outputNode.connect(this.destNode), this.trackList.push(n), this.updateEncoderConfig()) : Ee.debug("track ".concat(n.getTrackId(), " is already added"));
      }
      removeAudioTrack(n) {
        if (this.trackList.indexOf(n) !== -1) {
          Ee.debug("remove ".concat(n.getTrackId(), " from mixing track"));
          try {
            n._source.outputNode.disconnect(this.destNode);
          } catch {
          }
          dT(this.trackList, n), this.updateEncoderConfig();
        }
      }
      updateEncoderConfig() {
        const n = {};
        this.trackList.forEach((i) => {
          i._encoderConfig && ((i._encoderConfig.bitrate || 0) > (n.bitrate || 0) && (n.bitrate = i._encoderConfig.bitrate), (i._encoderConfig.sampleRate || 0) > (n.sampleRate || 0) && (n.sampleRate = i._encoderConfig.sampleRate), (i._encoderConfig.sampleSize || 0) > (n.sampleSize || 0) && (n.sampleSize = i._encoderConfig.sampleSize), i._encoderConfig.stereo && (n.stereo = !0));
        }), this._encoderConfig = n;
      }
      _updateRtpTransceiver(n) {
        this._rtpTransceiver !== n && (this._rtpTransceiver = n, this.trackList.forEach((i) => {
          i instanceof Xi ? i.emit(Af.TRANSCEIVER_UPDATED, n) : i._updateRtpTransceiver(n);
        }));
      }
    }
    class vse extends U5 {
      set currentState(n) {
        n !== this._currentState && (this._currentState = n, this.safeEmit(io.AUDIO_SOURCE_STATE_CHANGE, this._currentState));
      }
      get currentState() {
        return this._currentState;
      }
      constructor(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        super(), Yt(this, "audioBuffer", void 0), Yt(this, "sourceNode", void 0), Yt(this, "startPlayTime", 0), Yt(this, "startPlayOffset", 0), Yt(this, "pausePlayTime", 0), Yt(this, "options", void 0), Yt(this, "currentLoopCount", 0), Yt(this, "currentPlaybackSpeed", 100), Yt(this, "_currentState", "stopped"), this.audioBuffer = n, this.options = i, this.startPlayOffset = this.options.startPlayTime || 0;
      }
      createWebAudioDiagram() {
        return this.context.createGain();
      }
      get duration() {
        return this.audioBuffer ? this.audioBuffer.duration : 0;
      }
      get playbackSpeed() {
        return this.currentPlaybackSpeed;
      }
      get currentTime() {
        return this.audioBuffer ? this.currentState === "stopped" ? 0 : this.currentState === "paused" ? this.pausePlayTime : ((this.context.currentTime - this.startPlayTime) * (this.playbackSpeed / 100) + this.startPlayOffset) % this.audioBuffer.duration : 0;
      }
      updateOptions(n) {
        this.currentState === "stopped" ? (this.options = n, this.startPlayOffset = this.options.startPlayTime || 0) : Ee.warning("can not set audio source options");
      }
      startProcessAudioBuffer() {
        this.sourceNode && this.stopProcessAudioBuffer(), this.sourceNode = this.createSourceNode(), this.startSourceNode(), this.currentState = "playing";
      }
      pauseProcessAudioBuffer() {
        this.sourceNode && this.currentState === "playing" && (this.pausePlayTime = this.currentTime, this.sourceNode.onended = null, this.sourceNode.stop(), this.sourceNode.buffer = null, this.sourceNode = this.createSourceNode(), this.currentState = "paused");
      }
      seekAudioBuffer(n) {
        this.sourceNode && (this.sourceNode.onended = null, this.currentState === "playing" && this.sourceNode.stop(), this.sourceNode = this.createSourceNode(), this.currentState === "playing" ? (this.startPlayOffset = n, this.startSourceNode()) : this.currentState === "paused" && (this.pausePlayTime = n));
      }
      resumeProcessAudioBuffer() {
        this.currentState === "paused" && this.sourceNode && (this.startPlayOffset = this.pausePlayTime, this.pausePlayTime = 0, this.startSourceNode(), this.currentState = "playing");
      }
      stopProcessAudioBuffer() {
        if (this.sourceNode) {
          this.sourceNode.onended = null;
          try {
            this.sourceNode.stop();
          } catch {
          }
          this.reset();
        }
      }
      destroy() {
        this.audioBuffer = null, super.destroy();
      }
      setAudioBufferPlaybackSpeed(n) {
        this.sourceNode && (this.currentState === "playing" && (this.startPlayOffset = this.currentTime, this.startPlayTime = this.context.currentTime), this.sourceNode.playbackRate.value = n / 100), this.currentPlaybackSpeed = n;
      }
      startSourceNode() {
        this.sourceNode && this.sourceNode.buffer && (this.sourceNode.start(0, this.startPlayOffset), this.startPlayTime = this.context.currentTime, this.sourceNode.onended = this.handleSourceNodeEnded.bind(this));
      }
      createSourceNode() {
        const n = this.context.createBufferSource();
        return n.buffer = this.audioBuffer, n.loop = !!this.options.loop, n.connect(this.outputNode), n.playbackRate.value = this.currentPlaybackSpeed / 100, n;
      }
      handleSourceNodeEnded() {
        if (this.currentLoopCount += 1, this.options.cycle && this.options.cycle > this.currentLoopCount) return this.startPlayOffset = 0, this.sourceNode = void 0, void this.startProcessAudioBuffer();
        this.reset();
      }
      reset() {
        this.startPlayOffset = this.options.startPlayTime || 0, this.currentState = "stopped", this.sourceNode && (this.sourceNode.disconnect(), this.sourceNode = void 0), this.currentLoopCount = 0;
      }
    }
    const UL = /* @__PURE__ */ new Map();
    class cI {
      get rendFrameRate() {
        if (this.renderStats && this.renderStats.curTs !== this.renderStats.lastTs) {
          const n = this.renderStats.curTs - this.renderStats.lastTs, i = (this.renderStats.renderNum - this.renderStats.lastRenderNum) / n;
          return this.renderStats.lastRenderNum = this.renderStats.renderNum, this.renderStats.lastTs = this.renderStats.curTs, i;
        }
        return 0;
      }
      get videoElementStatus() {
        return this._videoElementStatus;
      }
      set videoElementStatus(n) {
        n !== this._videoElementStatus && (Ee.debug("[".concat(this.trackId, "] video-element-status change ").concat(this._videoElementStatus, " => ").concat(n)), this._videoElementStatus = n);
      }
      get videoState() {
        return this._videoState;
      }
      set videoState(n) {
        var i;
        n !== this._videoState && (this._videoState = n, (i = this.onVideoStateChanged) === null || i === void 0 || i.call(this, this.videoState));
      }
      constructor(n) {
        Yt(this, "trackId", void 0), Yt(this, "config", void 0), Yt(this, "onFirstVideoFrameDecoded", void 0), Yt(this, "onVideoStateChanged", void 0), Yt(this, "freezeTimeCounterList", []), Yt(this, "renderFreezeAccTime", 0), Yt(this, "isKeepLastFrame", !1), Yt(this, "timeUpdatedCount", 0), Yt(this, "freezeTime", 0), Yt(this, "playbackTime", 0), Yt(this, "lastTimeUpdatedTime", 0), Yt(this, "autoplayFailed", !1), Yt(this, "videoTrack", void 0), Yt(this, "videoElement", void 0), Yt(this, "cacheVideoElement", void 0), Yt(this, "renderStats", void 0), Yt(this, "_videoState", vu.VideoStateStopped), Yt(this, "videoElementCheckInterval", void 0), Yt(this, "videoElementFreezeTimeout", void 0), Yt(this, "_videoElementStatus", Xs.NONE), Yt(this, "isGettingVideoDimensions", !1), Yt(this, "startGetVideoDimensions", () => {
          const i = () => {
            if (this.isGettingVideoDimensions = !0, this.videoElement.videoWidth * this.videoElement.videoHeight > 4) return Ee.debug("[".concat(this.trackId, "] current video dimensions:"), this.videoElement.videoWidth, this.videoElement.videoHeight), void (this.isGettingVideoDimensions = !1);
            setTimeout(i, 500);
          };
          !this.isGettingVideoDimensions && i();
        }), Yt(this, "autoResumeAfterInterruption", () => {
          this.videoTrack && this.videoTrack.readyState === "live" && wr.curState === "running" && (Ee.debug("[track-".concat(this.trackId, "] video element paused, auto resume for ").concat(zM())), qM() ? (this.videoElement.srcObject = null, this.videoElement.srcObject = new MediaStream([this.videoTrack]), this.videoElement.play()) : (this.videoElement.pause(), this.videoElement.play()));
        }), Yt(this, "handleVideoEvents", (i) => {
          switch (i.type) {
            case "play":
            case "playing":
              this.startGetVideoDimensions(), this.videoElementStatus = Xs.PLAYING;
              break;
            case "loadeddata":
              if (this.videoState = vu.VideoStateStarting, this.onFirstVideoFrameDecoded && this.onFirstVideoFrameDecoded(), this.cacheVideoElement) {
                try {
                  this.cacheVideoElement.srcObject = null, this.cacheVideoElement.remove();
                } catch {
                }
                this.cacheVideoElement = void 0;
              }
              break;
            case "canplay":
              this.videoElementStatus = Xs.CANPLAY;
              break;
            case "stalled":
              this.videoElementStatus = Xs.STALLED;
              break;
            case "suspend":
              this.videoElementStatus = Xs.SUSPEND;
              break;
            case "pause":
              this.videoElementStatus = Xs.PAUSED, ta() || rc() || Os() && this.autoplayFailed || !this.videoTrack || this.videoTrack.readyState !== "live" || (Ee.debug("[track-".concat(this.trackId, "] video element paused, auto resume")), this.videoElement.play());
              break;
            case "waiting":
              this.videoElementStatus = Xs.WAITING;
              break;
            case "abort":
              this.videoElementStatus = Xs.ABORT;
              break;
            case "ended":
              this.videoElementStatus = Xs.ENDED;
              break;
            case "emptied":
              this.videoElementStatus = Xs.EMPTIED;
              break;
            case "error": {
              const o = this.videoElement.error;
              o && (this.videoElementStatus = Xs.ERROR, Ee.error("[".concat(this.trackId, "] media error: ").concat(o.message, " (").concat(o.code, ")")));
              break;
            }
            case "timeupdate": {
              const o = performance.now();
              if (this.timeUpdatedCount += 1, this.timeUpdatedCount < 10) return void (this.lastTimeUpdatedTime = o);
              const f = o - this.lastTimeUpdatedTime, T = this.lastTimeUpdatedTime;
              if (this.lastTimeUpdatedTime = o, ld.lastVisibleTime < ld.lastHiddenTime || T < ld.lastHiddenTime || T < ld.lastVisibleTime) return;
              for (f > ft("VIDEO_FREEZE_DURATION") && (this.freezeTime += f), this.playbackTime += f; this.playbackTime >= 6e3; ) {
                this.playbackTime -= 6e3;
                const A = Math.min(6e3, this.freezeTime);
                this.freezeTimeCounterList.push(A), this.freezeTime = Math.max(0, this.freezeTime - 6e3);
              }
              break;
            }
          }
        }), Yt(this, "autoResumeAfterInterruptionOnIOS15_16", () => {
          this.videoTrack && this.videoTrack.readyState === "live" && (Ee.debug("[track-".concat(this.trackId, "] video element paused, auto resume for ").concat(zM())), qM() ? (this.videoElement.srcObject = null, this.videoElement.srcObject = new MediaStream([this.videoTrack]), this.videoElement.play()) : (this.videoElement.pause(), this.videoElement.play()));
        }), this.trackId = n.trackId, this.config = n, n.element instanceof HTMLVideoElement ? this.videoElement = n.element : this.videoElement = document.createElement("video"), wr.on(vs.IOS_INTERRUPTION_END, this.autoResumeAfterInterruption), wr.on(vs.IOS_15_16_INTERRUPTION_END, this.autoResumeAfterInterruptionOnIOS15_16);
      }
      getVideoElement() {
        return this.videoElement;
      }
      getContainerElement() {
        var n;
        return (n = this.videoElement.parentElement) !== null && n !== void 0 ? n : void 0;
      }
      updateConfig(n) {
        this.config = n, this.trackId = n.trackId, n.element !== this.videoElement && (this.destroy(), this.videoElement = n.element), this.videoTrack && this.initVideoElement();
      }
      updateVideoTrack(n) {
        this.videoTrack !== n && (this.videoTrack = n, this.initVideoElement());
      }
      play(n) {
        const i = this.videoElement.play();
        i && i.catch && i.catch((f) => {
          n && Y5(n, "video", f.message, this.trackId), f.name === "NotAllowedError" ? (Ee.warning("detected video element autoplay failed", f), this.autoplayFailed = !0, this.handleAutoPlayFailed()) : Ee.warning("[".concat(this.trackId, "] play warning: "), f);
        });
        const o = hr();
        if ((o.name === "Safari" && Number(o.version) === 15 || ep()) && i && i.then) {
          const f = () => {
            this.config.mirror && (this.videoElement.style.transform = "rotateY(180deg)");
          };
          i.then(f).catch(f);
        }
      }
      getCurrentFrame() {
        const n = document.createElement("canvas");
        n.width = this.videoElement.videoWidth, n.height = this.videoElement.videoHeight;
        const i = n.getContext("2d");
        if (!i) return Ee.error("create canvas context failed!"), new ImageData(2, 2);
        i.drawImage(this.videoElement, 0, 0, n.width, n.height);
        const o = i.getImageData(0, 0, n.width, n.height);
        return n.remove(), o;
      }
      async getCurrentFrameToUint8Array(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        const o = document.createElement("canvas");
        o.width = this.videoElement.videoWidth, o.height = this.videoElement.videoHeight;
        const f = o.getContext("2d");
        return f ? (f.drawImage(this.videoElement, 0, 0, o.width, o.height), new cn((T, A) => {
          o.toBlob(async (R) => {
            if (o.remove(), R) {
              const P = await eL(R);
              T({ buffer: P, width: o.width, height: o.height });
            } else A(new Gt(Je.CONVERTING_VIDEO_FRAME_TO_BLOB_FAILED));
          }, n, i < 0 ? 0.1 : i > 1 ? 1 : i);
        })) : await oI(n);
      }
      destroy() {
        this.renderStats = void 0, wr.off(vs.IOS_INTERRUPTION_END, this.autoResumeAfterInterruption), wr.off(vs.IOS_15_16_INTERRUPTION_END, this.autoResumeAfterInterruptionOnIOS15_16), this.videoElement.srcObject = null, this.resetVideoElement(), this.freezeTimeCounterList = [], this.videoState = vu.VideoStateStopped;
      }
      initVideoElement() {
        if (this.videoElementStatus = Xs.INIT, !this.videoElementCheckInterval && (HL.forEach((T) => {
          this.videoElement.addEventListener(T, this.handleVideoEvents);
        }), this.videoElementCheckInterval = window.setInterval(() => {
          (function(T) {
            return T !== document.body && document.body.contains(T);
          })(this.videoElement) || (this.videoElementStatus = Xs.DESTROYED);
        }, 1e3), ft("ENABLE_VIDEO_FRAME_CALLBACK"))) {
          var n, i;
          let T;
          const A = () => {
            document.visibilityState === "visible" && (document.removeEventListener("visibilitychange", A), this.videoElementFreezeTimeout = window.setTimeout(R, ft("VIDEO_FREEZE_DURATION")));
          }, R = () => {
            this.videoElementFreezeTimeout = void 0, this.videoState === vu.VideoStateDecoding && (document.visibilityState === "visible" ? this.videoState = vu.VideoStateFrozen : document.addEventListener("visibilitychange", A));
          }, P = (L, z) => {
            if (this.videoElementStatus === Xs.PLAYING) {
              if (this.renderStats ? (this.renderStats.renderNum++, this.renderStats.curTs = z.mediaTime) : this.renderStats = { lastTs: z.mediaTime, curTs: z.mediaTime, lastRenderNum: 0, renderNum: 0 }, T) {
                const oe = z.presentationTime - T.presentationTime;
                this.videoState === vu.VideoStateStarting && (this.videoState = vu.VideoStateDecoding), this.videoState === vu.VideoStateDecoding && this.onVideoStateChanged && (this.videoElementFreezeTimeout && window.clearTimeout(this.videoElementFreezeTimeout), this.videoElementFreezeTimeout = window.setTimeout(R, ft("VIDEO_FREEZE_DURATION"))), oe < ft("VIDEO_FREEZE_DURATION") && this.videoState === vu.VideoStateFrozen && (this.videoState = vu.VideoStateDecoding), oe > ft("VIDEO_FREEZE_DURATION") && ld.lastVisibleTime >= ld.lastHiddenTime && T.timestamp > ld.lastVisibleTime && T.timestamp > ld.lastHiddenTime && (this.renderFreezeAccTime += oe);
              }
              T = Zr(Zr({}, z), {}, { timestamp: L });
            }
            var Y, te;
            ft("ENABLE_VIDEO_FRAME_CALLBACK") && ((Y = (te = this.videoElement).requestVideoFrameCallback) === null || Y === void 0 || Y.call(te, P));
          };
          (n = (i = this.videoElement).requestVideoFrameCallback) === null || n === void 0 || n.call(i, P);
        }
        this.videoElement.controls = !1, this.videoElement.setAttribute("playsinline", ""), uT() && !ft("HIDE_NO_POSTER") && (this.videoElement.poster = "noposter");
        const o = hr();
        o.name === "Safari" && Number(o.version) === 15 || ep() || !this.config.mirror || (this.videoElement.style.transform = "rotateY(180deg)"), this.config.fit ? this.videoElement.style.objectFit = this.config.fit : this.videoElement.style.objectFit = "cover", this.videoElement.setAttribute("muted", ""), this.videoElement.muted = !0, this.videoElement.srcObject && this.videoElement.srcObject instanceof MediaStream ? this.videoElement.srcObject.getVideoTracks()[0] !== this.videoTrack && (this.videoElement.srcObject = this.videoTrack ? new MediaStream([this.videoTrack]) : null, ui() && this.videoElement.load()) : (this.videoElement.srcObject = this.videoTrack ? new MediaStream([this.videoTrack]) : null, ui() && this.videoElement.load());
        const f = this.videoElement.play();
        f !== void 0 && f.catch((T) => {
          Ee.debug("[".concat(this.trackId, "] playback interrupted"), T.toString());
        });
      }
      resetVideoElement() {
        HL.forEach((n) => {
          this.videoElement && this.videoElement.removeEventListener(n, this.handleVideoEvents);
        }), this.videoElementCheckInterval && (window.clearInterval(this.videoElementCheckInterval), this.videoElementCheckInterval = void 0), this.videoElementStatus = Xs.NONE;
      }
      handleAutoPlayFailed() {
        const n = (i) => {
          i.preventDefault(), this.videoElement.play().then(() => {
            Ee.debug("[".concat(this.trackId, "] Video element for trackId:").concat(this.trackId, " autoplay resumed."));
          }).catch((o) => {
            Ee.error(o);
          }), this.autoplayFailed = !1, SE() ? document.body.removeEventListener("click", n, !0) : (document.body.removeEventListener("touchstart", n, !0), document.body.removeEventListener("mousedown", n, !0));
        };
        SE() ? document.body.addEventListener("click", n, !0) : (document.body.addEventListener("touchstart", n, !0), document.body.addEventListener("mousedown", n, !0)), V5();
      }
    }
    const HL = ["play", "playing", "loadeddata", "canplay", "pause", "stalled", "suspend", "waiting", "abort", "emptied", "ended", "timeupdate", "error"];
    class BL extends cI {
      constructor(n) {
        super(n), Yt(this, "container", void 0), Yt(this, "slot", void 0), this.slot = n.element, this.updateConfig(n);
      }
      updateConfig(n) {
        this.config = n, this.trackId = n.trackId;
        const i = n.element;
        i !== this.slot && (this.destroy(), this.slot = i), this.createElements();
      }
      updateVideoTrack(n) {
        this.videoTrack !== n && (this.videoTrack = n, this.createElements());
      }
      play(n) {
        var i;
        (i = this.container) !== null && i !== void 0 && i.contains(this.videoElement) && super.play(n);
      }
      getCurrentFrame() {
        var n;
        return (n = this.container) !== null && n !== void 0 && n.contains(this.videoElement) ? super.getCurrentFrame() : new ImageData(2, 2);
      }
      async getCurrentFrameToUint8Array(n) {
        var i;
        let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return (i = this.container) !== null && i !== void 0 && i.contains(this.videoElement) ? await super.getCurrentFrameToUint8Array(n, o) : await oI(n);
      }
      destroy() {
        if (super.destroy(), this.videoElement.remove(), this.videoElement = document.createElement("video"), this.container) {
          try {
            this.container.remove(), this.slot.removeChild(this.container);
          } catch {
          }
          this.container = void 0;
        }
      }
      createElements() {
        this.container || (this.container = document.createElement("div")), this.container.id = "agora-video-player-".concat(this.trackId), this.container.style.width = "100%", this.container.style.height = "100%", this.container.style.position = "relative", this.container.style.overflow = "hidden", this.videoTrack ? (this.container.style.backgroundColor = "black", ft("KEEP_LAST_FRAME") && this.isKeepLastFrame && this.videoElement.paused && this.resetVideoElement(), this.mountedVideoElement()) : this.unmountedVideoElement(), this.slot.appendChild(this.container);
      }
      mountedVideoElement() {
        var n;
        !this.container || (n = this.container) !== null && n !== void 0 && n.contains(this.videoElement) || this.container.appendChild(this.videoElement), super.initVideoElement(), this.videoElement.id = "video_".concat(this.trackId), this.videoElement.className = "agora_video_player", this.videoElement.style.width = "100%", this.videoElement.style.height = "100%", this.videoElement.style.position = "absolute", this.videoElement.style.left = "0", this.videoElement.style.top = "0";
      }
      unmountedVideoElement() {
        var n;
        if ((n = this.container) !== null && n !== void 0 && n.contains(this.videoElement)) {
          super.resetVideoElement();
          try {
            this.container && this.container.removeChild(this.videoElement);
          } catch {
          }
          this.videoElement = document.createElement("video");
        }
      }
      resetVideoElement() {
        var n;
        (n = this.container) !== null && n !== void 0 && n.contains(this.videoElement) && (super.resetVideoElement(), this.cacheVideoElement = this.videoElement, this.videoElement = document.createElement("video"));
      }
      getContainerElement() {
        return this.container;
      }
    }
    var zL, FL, GL, VL, YL, XL, WL, qL, KL, JL, ZL, QL, $L, e8, t8, n8, r8, i8, s8, a8, o8, c8, u8, d8, or, l8, f8, h8, p8, g8, m8, E8, y8, lo;
    let Wr = (zL = Dn({ argsMap: (e, n, i) => [e.getTrackId(), typeof n == "string" ? n : n instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement", i] }), FL = Ti(), GL = Dn({ argsMap: (e) => [e.getTrackId()] }), VL = ip("LocalVideoTrack", "_enabledMutex"), YL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), XL = Ti(), WL = ip("LocalVideoTrack", "_enabledMutex"), qL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), KL = Ti(), JL = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), ZL = Ti(), QL = Ti(), $L = Dn({ argsMap: (e, n, i) => [e.getTrackId(), n, i] }), e8 = Ti(), t8 = Ti(), n8 = Ti(), r8 = Ti(), i8 = Ti(), s8 = Ti(), a8 = Ti(), o8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n.name] }), c8 = Dn({ argsMap: (e) => [e.getTrackId()] }), u8 = Dn({ argsMap: (e) => [e.getTrackId()] }), d8 = Dn({ argsMap: (e, n, i) => [e.getTrackId(), n.label, i] }), or = class gX extends hp {
      get videoHeight() {
        if (Os()) {
          const { height: n } = this._mediaStreamTrack.getSettings();
          return this._videoHeight = n, this._videoHeight;
        }
        return this._videoHeight;
      }
      get videoWidth() {
        if (Os()) {
          const { width: n } = this._mediaStreamTrack.getSettings();
          return this._videoWidth = n, this._videoWidth;
        }
        return this._videoWidth;
      }
      get isPlaying() {
        return !(!this._player || this._player.videoElementStatus !== Xs.PLAYING);
      }
      get processorDestination() {
        return this._processorDestination;
      }
      get processorContext() {
        return this._processorContext;
      }
      set processorContext(n) {
        this._processorContext = n;
      }
      get __className__() {
        return "LocalVideoTrack";
      }
      constructor(n, i, o, f, T, A) {
        if (super(n, T), Yt(this, "trackMediaType", fp.VIDEO), Yt(this, "_player", void 0), Yt(this, "isUseScaleResolutionDownBy", !1), Yt(this, "_videoVisibleTimer", null), Yt(this, "_previousVideoVisibleStatus", void 0), Yt(this, "_clearPreviousVideoVisibleStatus", () => this._previousVideoVisibleStatus = void 0), Yt(this, "_encoderConfig", void 0), Yt(this, "_scalabilityMode", { numSpatialLayers: 1, numTemporalLayers: 1 }), Yt(this, "_optimizationMode", void 0), Yt(this, "_videoHeight", void 0), Yt(this, "_videoWidth", void 0), Yt(this, "_forceBitrateLimit", void 0), Yt(this, "_enabled", !0), Yt(this, "_processorDestination", void 0), Yt(this, "_processorContext", void 0), Os()) {
          const { width: R, height: P } = n.getSettings();
          this._videoWidth = R, this._videoHeight = P;
        } else this.updateMediaStreamTrackResolution();
        if (this._encoderConfig = i, this._scalabilityMode = o, this._optimizationMode = f, this._hints = A || [], this._hints.indexOf(Fr.SCREEN_TRACK) === -1) this.updateBitrateFromProfile();
        else if (function(R, P, L) {
          const z = hr();
          return !(z.name !== R || !z.osVersion) && Number(z.version) === P;
        }(Cr.CHROME, 115) && aT().indexOf("Windows") !== -1) {
          const R = function(P, L) {
            if ("VideoFrame" in window && "TransformStream" in window && pr().supportWebRTCInsertableStream) {
              const z = new MediaStreamTrackProcessor(P), Y = new MediaStreamTrackGenerator({ kind: "video" });
              let te, oe, He = Date.now();
              const Re = () => {
                De && (clearInterval(De), De = void 0), te && (te.close(), te = void 0), P.stop(), oe = void 0, Y.removeEventListener("ended", Re);
              };
              let De = window.setInterval(() => {
                if (oe && te && Date.now() - He > 1e3) try {
                  Y.readyState === "live" ? oe.enqueue(te.clone()) : Re();
                } catch {
                  Re();
                }
              }, 1e3);
              const Xe = new TransformStream({ transform: (We, mt) => {
                Y.readyState === "live" ? (oe = mt, He = Date.now(), te === void 0 ? (te = We, mt.enqueue(We.clone())) : (mt.enqueue(te), te = We)) : We.close();
              } });
              return Y.addEventListener("ended", Re), z.readable.pipeThrough(Xe).pipeTo(Y.writable), Y;
            }
          }(n);
          R && (Ee.info("local screen video track begin to inject frame"), this._mediaStreamTrack = R);
        }
        i && this._hints.indexOf(Fr.CUSTOM_TRACK) !== -1 && this.setEncoderConfiguration(i), this._processorContext = new W5(this.getTrackId(), "local"), this._processorDestination = new X5(this.processorContext), this.bindProcessorDestinationEvents();
      }
      play(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (typeof n == "string") {
          const f = document.getElementById(n);
          f ? n = f : (Ee.warning("[".concat(this.getTrackId(), '] can not find "#').concat(n, '" element, use document.body')), n = document.body);
        }
        Ee.debug("[".concat(this.getTrackId(), "] start video playback in ").concat(n instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement"), JSON.stringify(i));
        const o = Zr(Zr(Zr({}, this._getDefaultPlayerConfig()), i), {}, { trackId: this.getTrackId(), element: n });
        this._player ? this._player.updateConfig(o) : (n instanceof HTMLVideoElement ? this._player = new cI(o) : this._player = new BL(o), this._player.updateVideoTrack(this._mediaStreamTrack)), this._player.play(), this._videoVisibleTimer && window.clearInterval(this._videoVisibleTimer), this._clearPreviousVideoVisibleStatus(), this._videoVisibleTimer = window.setInterval(() => {
          try {
            const f = this.getVideoElementVisibleStatus();
            this.safeEmit(dp.VIDEO_ELEMENT_VISIBLE_STATUS, f);
          } catch {
          }
        }, ft("CHECK_VIDEO_VISIBLE_INTERVAL"));
      }
      stop() {
        this._player && (this._videoVisibleTimer && (window.clearInterval(this._videoVisibleTimer), this._videoVisibleTimer = null), this._clearPreviousVideoVisibleStatus(), this._player.destroy(), this._player = void 0, Ee.debug("[".concat(this.getTrackId(), "] stop video playback")));
      }
      async setEnabled(n, i) {
        if (!i) {
          if (n === this._enabled) return;
          this.stateCheck("enabled", n);
        }
        if (Ee.info("[".concat(this.getTrackId(), "] start setEnabled"), n), !n) {
          this._originMediaStreamTrack.enabled = !1;
          try {
            await Br(this, Tn.NEED_DISABLE_TRACK, this);
          } catch (o) {
            throw Ee.error("[".concat(this.getTrackId(), "] setEnabled to false error"), o.toString()), o;
          }
          return i || (this._enabled = !1), void Ee.info("[".concat(this.getTrackId(), "] setEnabled to false success"));
        }
        this._originMediaStreamTrack.enabled = !0;
        try {
          await Br(this, Tn.NEED_ENABLE_TRACK, this);
        } catch (o) {
          throw Ee.error("[".concat(this.getTrackId(), "] setEnabled to true error"), o.toString()), o;
        }
        Ee.info("[".concat(this.getTrackId(), "] setEnabled to true success")), i || (this._enabled = !0);
      }
      async setMuted(n) {
        n !== this._muted && (this.stateCheck("muted", n), this._muted = n, this._originMediaStreamTrack.enabled = !n, Ee.debug("[".concat(this.getTrackId(), "] start set muted: ").concat(n)), n ? await Br(this, Tn.NEED_MUTE_TRACK, this) : await Br(this, Tn.NEED_UNMUTE_TRACK, this));
      }
      async setEncoderConfiguration(n, i) {
        if (!this._enabled) throw new Gt(Je.TRACK_IS_DISABLED, "can not set encoder configuration when track is disabled");
        if (n = yu(n), this._forceBitrateLimit && (n.bitrateMax = this._forceBitrateLimit.max_bitrate ? this._forceBitrateLimit.max_bitrate : n.bitrateMax, n.bitrateMin = this._forceBitrateLimit.min_bitrate ? this._forceBitrateLimit.min_bitrate : n.bitrateMin), n.width || n.height || n.frameRate) {
          const o = AT({ encoderConfig: n });
          (Os() || ta() || rc()) && (o.deviceId = void 0), Ee.debug("[".concat(this.getTrackId(), "] setEncoderConfiguration applyConstraints"), JSON.stringify(n), JSON.stringify(o));
          try {
            await this._originMediaStreamTrack.applyConstraints(o), this.updateMediaStreamTrackResolution();
          } catch (f) {
            const T = new Gt(Je.UNEXPECTED_ERROR, f.toString());
            throw Ee.error("[".concat(this.getTrackId(), "] applyConstraints error"), T.toString()), T;
          }
        }
        this._encoderConfig = n, this._hints.indexOf(Fr.SCREEN_TRACK) === -1 && this.updateBitrateFromProfile();
        try {
          await Br(this, Tn.NEED_UPDATE_VIDEO_ENCODER, this);
        } catch (o) {
          return o.throw(Ee);
        }
      }
      getStats() {
        return el(() => {
          Ee.warning("[deprecated] LocalVideoTrack.getStats will be removed in the future, use AgoraRTCClient.getLocalVideoStats instead");
        }, "localVideoTrackGetStatsWarning"), to(this, Tn.GET_STATS) || Zr({}, eI);
      }
      async setBeautyEffect(n) {
        Ee.error("LocalVideoTrack.setBeautyEffect was deprecated, please migrate to agora-extension-beauty-effect");
      }
      getCurrentFrameData() {
        return this._player ? this._player.getCurrentFrame() : new ImageData(2, 2);
      }
      async getCurrentFrameImage(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return this._player ? this._player.getCurrentFrameToUint8Array(n, i) : await oI(n);
      }
      async setBitrateLimit(n) {
        Ee.debug("[".concat(this.getTrackId(), "] set bitrate limit, ").concat(JSON.stringify(n))), n && (this._forceBitrateLimit = n, this._encoderConfig && (this._encoderConfig.bitrateMax ? this._encoderConfig.bitrateMax = this._encoderConfig.bitrateMax < n.max_bitrate ? this._encoderConfig.bitrateMax : n.max_bitrate : this._encoderConfig.bitrateMax = n.max_bitrate, this._encoderConfig.bitrateMin, this._encoderConfig.bitrateMin = n.min_bitrate));
      }
      async setOptimizationMode(n) {
        if (n !== "motion" && n !== "detail" && n !== "balanced") return void Ee.error(Je.INVALID_PARAMS, "optimization mode must be motion, detail or balanced");
        const i = this._optimizationMode;
        try {
          this._optimizationMode = n, await Br(this, Tn.NEED_UPDATE_VIDEO_SEND_PARAMETERS, this);
        } catch (o) {
          throw this._optimizationMode = i, Ee.error("[".concat(this.getTrackId(), "] set optimization mode failed"), o.toString()), o;
        }
        Ee.info("[".concat(this.getTrackId(), "] set optimization mode success (").concat(n, ")"));
      }
      setScalabiltyMode(n) {
        if (n.numSpatialLayers === 1 && n.numTemporalLayers !== 1) return Ee.error(Je.INVALID_PARAMS, "scalability mode currently not supported, no SVC."), void (this._scalabilityMode = { numSpatialLayers: 1, numTemporalLayers: 1 });
        this._scalabilityMode = n, Ee.info("[".concat(this.getTrackId(), "] set scalability mode success (").concat(n, ")"));
      }
      updateMediaStreamTrackResolution() {
        J5(this._originMediaStreamTrack).then((n) => {
          let [i, o] = n;
          this._videoHeight = o, this._videoWidth = i;
        }).catch(fT);
      }
      _updatePlayerSource() {
        this._player && this._player.updateVideoTrack(this._mediaStreamTrack);
      }
      _getDefaultPlayerConfig() {
        return { fit: "contain" };
      }
      async setSenderConfiguration(n) {
        if (!this._enabled) throw new Gt(Je.TRACK_IS_DISABLED, "can not set encoder configuration when track is disabled");
        Ee.debug("[".concat(this.getTrackId(), "] setSenderConfiguration applyConstraints"), JSON.stringify(n)), n = yu(n), this._forceBitrateLimit && (n.bitrateMax = this._forceBitrateLimit.max_bitrate ? this._forceBitrateLimit.max_bitrate : n.bitrateMax, n.bitrateMin = this._forceBitrateLimit.min_bitrate ? this._forceBitrateLimit.min_bitrate : n.bitrateMin), this._encoderConfig = n, this._hints.indexOf(Fr.SCREEN_TRACK) === -1 && this.updateBitrateFromProfile();
        try {
          await Br(this, Tn.NEED_UPDATE_VIDEO_ENCODER, this);
        } catch (i) {
          return i.throw(Ee);
        }
      }
      updateBitrateFromProfile() {
        if (!this._encoderConfig) return;
        const { width: n, height: i, frameRate: o } = this.getMediaStreamTrackSettings();
        if (!n || !i || !o) return;
        const { bitrateMax: f, bitrateMin: T } = this._encoderConfig;
        if (T == null || f == null) {
          const { max: A, min: R } = function(P, L, z, Y, te) {
            const oe = ft("BITRATE_ADAPTER_TYPE");
            if (oe === "DEFAULT_BITRATE") return { min: Y, max: te };
            if (te === void 0) {
              var He;
              const De = Math.floor(200 * Math.pow(z / 15, 0.6) * Math.pow(P * L / 640 / 360, 0.75));
              te = oe === "STANDARD_BITRATE" ? 4 * De : 2 * De, Y = (He = Y) !== null && He !== void 0 ? He : De;
            } else {
              var Re;
              Y = (Re = Y) !== null && Re !== void 0 ? Re : Math.floor(te / 10);
            }
            return { min: Y, max: te };
          }(n, i, o, T, f);
          this._encoderConfig.bitrateMin = R, this._encoderConfig.bitrateMax = A, Ee.debug("[".concat(this.getTrackId(), "] update bitrate from profile, [w: ").concat(n, ", h: ").concat(i, ", fps: ").concat(o, "] => [brMax: ").concat(A, ", brMin: ").concat(R, "]"));
        }
      }
      getVideoElementVisibleStatus() {
        try {
          var n, i;
          const o = this == null || (n = this._player) === null || n === void 0 ? void 0 : n.getContainerElement(), f = { track: this, element: this == null || (i = this._player) === null || i === void 0 ? void 0 : i.getVideoElement(), slot: o == null ? void 0 : o.parentElement }, { element: T, slot: A } = f;
          if (this.isPlaying && T instanceof HTMLVideoElement && A instanceof HTMLElement) {
            const R = $M.checkOneElementVisible(T), P = Object.assign({}, R);
            if (P.visible !== this._previousVideoVisibleStatus) {
              this._previousVideoVisibleStatus = P.visible;
              const L = Cn.reportApiInvoke(null, { tag: si.TRACER, name: Bi.LOCAL_VIDEO_TRACK_GET_VIDEO_VISIBLE, options: [this.getTrackId()] });
              P.visible ? L.onSuccess("Video is visible") : L.onSuccess("Invisible because of ".concat(P.reason));
            }
            return P;
          }
          return;
        } catch (o) {
          throw new Gt(Je.GET_VIDEO_ELEMENT_VISIBLE_ERROR, o.message);
        }
      }
      async renewMediaStreamTrack(n) {
      }
      pipe(n) {
        if (this.processor === n) return n;
        if (n._source) throw new Gt(Je.INVALID_OPERATION, "Processor ".concat(n.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = n, this.processor._source = this, n.updateInput({ track: this._originMediaStreamTrack, context: this.processorContext }), n;
      }
      unpipe() {
        if (!this.processor) return;
        const n = this.processor;
        this.processor._source = void 0, this.processor = void 0, n.reset();
      }
      close() {
        super.close(), this.unbindProcessorDestinationEvents(), this.unbindProcessorContextEvents(), this.unpipe(), this.processorDestination._source && this.processorDestination._source.unpipe();
      }
      clone(n) {
        let i = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], o = this._encoderConfig;
        n && (o = Zr(Zr({}, o), yu(n))), o = vf(o);
        const f = zr(8, "track-video-cloned-"), T = new gX(i ? this._mediaStreamTrack.clone() : this._mediaStreamTrack, o, vf(this._scalabilityMode), this._optimizationMode, f, vf(this._hints));
        return n && o && T.setEncoderConfiguration(o), Ee.debug("clone video track from ".concat(this.getTrackId(), " to ").concat(f, ", clone ").concat(i)), T;
      }
      async replaceTrack(n, i) {
        if (!(n instanceof MediaStreamTrack)) throw new Gt(Je.INVALID_PARAMS, "track should be an instance of MediaStreamTrack");
        if (n.kind !== "video") throw new Gt(Je.INVALID_PARAMS, "track should be a video MediaStreamTrack");
        await this._updateOriginMediaStreamTrack(n, i, !0), this.updateMediaStreamTrackResolution();
      }
      sendSeiData(n) {
        if (el(() => {
          Cn.reportApiInvoke(null, { name: Bi.LOCAL_VIDEO_SEND_SEI_DATA, options: [], tag: si.TRACER }).onSuccess("");
        }, this._mediaStreamTrack.id || this.getTrackId()), !ft("ENABLE_VIDEO_SEI") || !ft("ENABLE_ENCODED_TRANSFORM")) return void Ee.warning('To send/receive SEI, please call AgoraRTC.setParameter("ENABLE_VIDEO_SEI", true) before instantiate IAgoraRtcClient');
        if (n instanceof Uint8Array == 0) return new Gt(Je.INVALID_PARAMS, "Invalid argument type, ILocalVideoTrack.sendSeiData() only accept Uint8Array argument.").throw();
        const i = this.getRTCRtpTransceiver();
        if (!i) return void Ee.warning("Video track is not published, SEI can not be send");
        const o = i.sender.getParameters();
        if (o.codecs.length === 0) return;
        const f = o.codecs[0].mimeType.toLocaleLowerCase();
        f === "video/h264" ? this.safeEmit("sei-to-send", n) : Ee.warning("SEI is not supported by ".concat(f));
      }
      bindProcessorDestinationEvents() {
        this.processorDestination.on(na.ON_TRACK, async (n) => {
          n ? n !== this._mediaStreamTrack && (this._mediaStreamTrack = n, this._updatePlayerSource(), await Br(this, Tn.NEED_REPLACE_TRACK, this)) : this._mediaStreamTrack !== this._originMediaStreamTrack && (this._mediaStreamTrack = this._originMediaStreamTrack, this._updatePlayerSource(), await Br(this, Tn.NEED_REPLACE_TRACK, this));
        });
      }
      unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(na.ON_TRACK);
      }
      unbindProcessorContextEvents() {
        this.processorContext.removeAllListeners(so.REQUEST_UPDATE_CONSTRAINTS), this.processorContext.removeAllListeners(so.REQUEST_CONSTRAINTS);
      }
    }, fr(or.prototype, "play", [zL, FL], Object.getOwnPropertyDescriptor(or.prototype, "play"), or.prototype), fr(or.prototype, "stop", [GL], Object.getOwnPropertyDescriptor(or.prototype, "stop"), or.prototype), fr(or.prototype, "setEnabled", [VL, YL, XL], Object.getOwnPropertyDescriptor(or.prototype, "setEnabled"), or.prototype), fr(or.prototype, "setMuted", [WL, qL, KL], Object.getOwnPropertyDescriptor(or.prototype, "setMuted"), or.prototype), fr(or.prototype, "setEncoderConfiguration", [JL, ZL], Object.getOwnPropertyDescriptor(or.prototype, "setEncoderConfiguration"), or.prototype), fr(or.prototype, "getStats", [QL], Object.getOwnPropertyDescriptor(or.prototype, "getStats"), or.prototype), fr(or.prototype, "setBeautyEffect", [$L, e8], Object.getOwnPropertyDescriptor(or.prototype, "setBeautyEffect"), or.prototype), fr(or.prototype, "getCurrentFrameData", [t8], Object.getOwnPropertyDescriptor(or.prototype, "getCurrentFrameData"), or.prototype), fr(or.prototype, "getCurrentFrameImage", [n8], Object.getOwnPropertyDescriptor(or.prototype, "getCurrentFrameImage"), or.prototype), fr(or.prototype, "setBitrateLimit", [r8], Object.getOwnPropertyDescriptor(or.prototype, "setBitrateLimit"), or.prototype), fr(or.prototype, "setOptimizationMode", [i8], Object.getOwnPropertyDescriptor(or.prototype, "setOptimizationMode"), or.prototype), fr(or.prototype, "setScalabiltyMode", [s8], Object.getOwnPropertyDescriptor(or.prototype, "setScalabiltyMode"), or.prototype), fr(or.prototype, "updateMediaStreamTrackResolution", [a8], Object.getOwnPropertyDescriptor(or.prototype, "updateMediaStreamTrackResolution"), or.prototype), fr(or.prototype, "pipe", [o8], Object.getOwnPropertyDescriptor(or.prototype, "pipe"), or.prototype), fr(or.prototype, "unpipe", [c8], Object.getOwnPropertyDescriptor(or.prototype, "unpipe"), or.prototype), fr(or.prototype, "close", [u8], Object.getOwnPropertyDescriptor(or.prototype, "close"), or.prototype), fr(or.prototype, "replaceTrack", [d8], Object.getOwnPropertyDescriptor(or.prototype, "replaceTrack"), or.prototype), or), uI = (l8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), f8 = Ti(), h8 = ip("CameraVideoTrack", "_enabledMutex"), p8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), g8 = Ti(), m8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), E8 = Ti(), y8 = Dn({ argsMap: (e) => [e.getTrackId()] }), lo = class mX extends Wr {
      get __className__() {
        return "CameraVideoTrack";
      }
      constructor(n, i, o, f, T, A) {
        super(n, yu(i.encoderConfig), f, T, A), Yt(this, "_config", void 0), Yt(this, "_originalConstraints", void 0), Yt(this, "_constraints", void 0), Yt(this, "_enabled", !0), Yt(this, "_deviceName", "default"), Yt(this, "tryResumeVideoForIOS15_16WeChat", async () => {
          (ep() || _S()) && !function() {
            const R = hr();
            if (R.os !== ts.IOS || !R.osVersion) return !1;
            const P = R.osVersion.split(".");
            return Number(P[0]) === 15 && Number(P[1]) >= 2;
          }() && KM() && this._enabled && !this._isClosed && (Ee.debug("[".concat(this.getTrackId(), "] try capture camera media device for interrupted iOS 15 device on WeChat.")), await this.renewMediaStreamTrack());
        }), this._config = i, this._originalConstraints = o, this._constraints = o, this._deviceName = n.label, this._encoderConfig = yu(this._config.encoderConfig), wr.on(vs.IOS_15_16_INTERRUPTION_END, this.tryResumeVideoForIOS15_16WeChat), wr.on(vs.IOS_INTERRUPTION_END, this.tryResumeVideoForIOS15_16WeChat), this.bindProcessorContextEvents();
      }
      async setDevice(n) {
        return typeof n == "string" ? this._setDeviceById(n) : n.deviceId ? this._setDeviceById(n.deviceId) : n.facingMode ? this._setDeviceByFacingModel(n.facingMode) : void 0;
      }
      async _setDeviceById(n) {
        if (Ee.info("[".concat(this.getTrackId(), "] set device to ").concat(n)), this._enabled) try {
          const i = await co.getDeviceById(n), o = {};
          o.video = Zr({}, this._constraints), o.video.deviceId = { exact: n }, o.video.facingMode = void 0, this._originMediaStreamTrack.stop();
          let f = null;
          try {
            f = await oo(o, this.getTrackId());
          } catch (T) {
            throw Ee.error("[".concat(this.getTrackId(), "] setDevice failed"), T.toString()), f = await oo({ video: this._constraints }, this.getTrackId()), await this._updateOriginMediaStreamTrack(f.getVideoTracks()[0], !1), T;
          }
          await this._updateOriginMediaStreamTrack(f.getVideoTracks()[0], !1), this.updateMediaStreamTrackResolution(), this._deviceName = i.label, this._config.cameraId = n, this._constraints.deviceId = { exact: n };
        } catch (i) {
          throw Ee.error("[".concat(this.getTrackId(), "] setDevice error"), i.toString()), i;
        }
        else try {
          const i = await co.getDeviceById(n);
          this._deviceName = i.label, this._config.cameraId = n, this._constraints.deviceId = { exact: n };
        } catch (i) {
          throw Ee.error("[".concat(this.getTrackId(), "] setDevice error"), i.toString()), i;
        }
        Ee.info("[".concat(this.getTrackId(), "] setDevice success"));
      }
      async _setDeviceByFacingModel(n) {
        Ee.info("[".concat(this.getTrackId(), "] set facingMode ").concat(n));
        const i = { video: Zr(Zr({}, this._constraints), {}, { deviceId: void 0, facingMode: { exact: n } }) };
        if (this._enabled) {
          this._originMediaStreamTrack.stop();
          let o = null;
          try {
            o = await oo(i, this.getTrackId());
          } catch (f) {
            throw Ee.error("[".concat(this.getTrackId(), "] setDeviceByFacingModel failed"), f.toString()), o = await oo({ video: this._constraints }, this.getTrackId()), await this._updateOriginMediaStreamTrack(o.getVideoTracks()[0], !1), f;
          }
          await this._updateOriginMediaStreamTrack(o.getVideoTracks()[0], !1), this.updateMediaStreamTrackResolution();
        }
        this._deviceName = "", this._config.facingMode = n, this._config.cameraId = void 0, this._constraints = Zr({}, i.video), Ee.info("[".concat(this.getTrackId(), "] setDeviceByFacingModel success"));
      }
      async setEnabled(n, i) {
        if (!i) {
          if (n === this._enabled) return;
          this.stateCheck("enabled", n);
        }
        if (Ee.info("[".concat(this.getTrackId(), "] start setEnabled"), n), n) {
          try {
            if (this.isExternalTrack) this._originMediaStreamTrack.enabled = !0;
            else {
              const o = await oo({ video: this._constraints }, this.getTrackId());
              await this._updateOriginMediaStreamTrack(o.getVideoTracks()[0], !1);
            }
            await Br(this, Tn.NEED_ENABLE_TRACK, this);
          } catch (o) {
            throw Ee.error("[".concat(this.getTrackId(), "] setEnabled true error"), o.toString()), o;
          }
          this.updateMediaStreamTrackResolution(), Ee.info("[".concat(this.getTrackId(), "] setEnabled to true success")), i || (this._enabled = !0);
        } else {
          this.isExternalTrack ? this._originMediaStreamTrack.enabled = !1 : (this._originMediaStreamTrack.onended = null, this._originMediaStreamTrack.stop()), i || (this._enabled = !1);
          try {
            await Br(this, Tn.NEED_DISABLE_TRACK, this);
          } catch (o) {
            throw Ee.error("[".concat(this.getTrackId(), "] setEnabled to false error"), o.toString()), o;
          }
          Ee.info("[".concat(this.getTrackId(), "] setEnabled to false success"));
        }
      }
      async setEncoderConfiguration(n, i) {
        if (!this._enabled) throw new Gt(Je.TRACK_IS_DISABLED, "can not set encoder configuration when track is disabled");
        n = yu(n), this._forceBitrateLimit && (n.bitrateMax = this._forceBitrateLimit.max_bitrate || n.bitrateMax, n.bitrateMin = this._forceBitrateLimit.min_bitrate || n.bitrateMin);
        const o = di(this._config);
        o.encoderConfig = n;
        const f = AT(o);
        (Os() || ta() || rc()) && (f.deviceId = void 0), Ee.debug("[".concat(this.getTrackId(), "] setEncoderConfiguration applyConstraints"), JSON.stringify(n), JSON.stringify(f));
        try {
          await this._originMediaStreamTrack.applyConstraints(f), this.updateMediaStreamTrackResolution();
        } catch (T) {
          const A = new Gt(Je.UNEXPECTED_ERROR, T.toString());
          throw Ee.error("[".concat(this.getTrackId(), "] applyConstraints error"), A.toString()), A;
        }
        this._config = o, this._constraints = f, this._originalConstraints = f, this._encoderConfig = n, this._hints.indexOf(Fr.SCREEN_TRACK) === -1 && this.updateBitrateFromProfile();
        try {
          await Br(this, Tn.NEED_UPDATE_VIDEO_ENCODER, this);
        } catch (T) {
          return T.throw(Ee);
        }
      }
      _getDefaultPlayerConfig() {
        return { mirror: !0, fit: "cover" };
      }
      onTrackEnded() {
        if ((ta() || rc()) && this._enabled && !this._isClosed && wr.duringInterruption) {
          const n = async () => {
            wr.off(vs.IOS_INTERRUPTION_END, n), this._enabled && !this._isClosed && (Ee.debug("[".concat(this.getTrackId(), "] try capture camera media device for interrupted iOS device.")), await this.setEnabled(!1), await this.setEnabled(!0));
          };
          wr.on(vs.IOS_INTERRUPTION_END, n);
        } else Ee.debug("[".concat(this.getTrackId(), "] track ended")), this.safeEmit(dp.TRACK_ENDED);
      }
      async renewMediaStreamTrack(n) {
        const i = n || this._constraints, o = co.searchDeviceIdByName(this._deviceName);
        if (o && !i.deviceId && (i.deviceId = { exact: o }), this._enabled) {
          const f = await oo({ video: i }, this.getTrackId());
          this._constraints = i, await this._updateOriginMediaStreamTrack(f.getVideoTracks()[0], !0), this.updateMediaStreamTrackResolution();
        }
      }
      close() {
        super.close(), wr.off(vs.IOS_15_16_INTERRUPTION_END, this.tryResumeVideoForIOS15_16WeChat), wr.off(vs.IOS_INTERRUPTION_END, this.tryResumeVideoForIOS15_16WeChat);
      }
      clone(n) {
        let i = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], o = this._encoderConfig;
        n && (o = Zr(Zr({}, o), yu(n))), o = vf(o);
        const f = zr(8, "track-cam-cloned-"), T = new mX(i ? this._mediaStreamTrack.clone() : this._mediaStreamTrack, vf(Zr(Zr({}, this._config), {}, { encoderConfig: o })), vf(this._constraints), vf(this._scalabilityMode), this._optimizationMode, f);
        return n && o && T.setEncoderConfiguration(o), Ee.debug("clone track from ".concat(this.getTrackId(), " to ").concat(f, ", clone ").concat(i)), T;
      }
      bindProcessorContextEvents() {
        this.processorContext.on(so.REQUEST_UPDATE_CONSTRAINTS, async (n, i, o) => {
          try {
            const f = Object.assign({}, this._originalConstraints, ...n);
            await this.renewMediaStreamTrack(f), i();
          } catch (f) {
            o(f);
          }
        }), this.processorContext.on(so.REQUEST_CONSTRAINTS, async (n) => {
          n(this._originMediaStreamTrack.getSettings());
        });
      }
    }, fr(lo.prototype, "setDevice", [l8, f8], Object.getOwnPropertyDescriptor(lo.prototype, "setDevice"), lo.prototype), fr(lo.prototype, "setEnabled", [h8, p8, g8], Object.getOwnPropertyDescriptor(lo.prototype, "setEnabled"), lo.prototype), fr(lo.prototype, "setEncoderConfiguration", [m8, E8], Object.getOwnPropertyDescriptor(lo.prototype, "setEncoderConfiguration"), lo.prototype), fr(lo.prototype, "close", [y8], Object.getOwnPropertyDescriptor(lo.prototype, "close"), lo.prototype), lo);
    function dI(e, n, i, o) {
      i.optimizationMode && (o && o.width && o.height ? (i.encoderConfig = Zr(Zr({}, o), {}, { bitrateMin: o.bitrateMin, bitrateMax: o.bitrateMax }), i.optimizationMode !== "motion" && i.optimizationMode !== "detail" || (n.contentHint = i.optimizationMode, n.contentHint === i.optimizationMode ? Ee.debug("[".concat(e, "] set content hint to"), i.optimizationMode) : Ee.debug("[".concat(e, "] set content hint failed")))) : Ee.warning("[".concat(e, "] can not apply optimization mode bitrate config, no encoderConfig")));
    }
    var v8, T8, b8, A8, wo, O8, C8, S8, I8, R8, N8, Ws;
    class w8 extends L5 {
      getUserId() {
        return this._userId;
      }
      constructor(n, i, o, f) {
        super(n, "track-".concat(n.kind, "-").concat(i, "-").concat(f.clientId, "_").concat(zr(5, ""))), Yt(this, "_userId", void 0), Yt(this, "_uintId", void 0), Yt(this, "_isDestroyed", !1), Yt(this, "store", void 0), Yt(this, "processor", void 0), Yt(this, "processorContext", void 0), this._userId = i, this._uintId = o, this.store = f;
      }
      _updateOriginMediaStreamTrack(n) {
        this._originMediaStreamTrack = n, this._mediaStreamTrack = n, this._updatePlayerSource(), this.processor && this.processor.updateInput({ track: this._originMediaStreamTrack, context: this.processorContext });
      }
      _destroy() {
        this._isDestroyed = !0, Ee.info("[".concat(this.getTrackId(), "] is destroyed")), this.stop(), super.close();
      }
      getProcessorStats() {
        return this.processorContext.gatherStats();
      }
      getProcessorUsage() {
        return this.processorContext.gatherUsage();
      }
    }
    let mp = (v8 = Dn({ argsMap: (e, n, i) => [e.getTrackId(), typeof n == "string" ? n : n instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement", i] }), T8 = Dn({ argsMap: (e) => [e.getTrackId()] }), b8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n.name] }), A8 = Dn({ argsMap: (e) => [e.getTrackId()] }), fr((wo = class extends w8 {
      get isPlaying() {
        return !(!this._player || this._player.videoElementStatus !== Xs.PLAYING);
      }
      get __className__() {
        return "RemoteVideoTrack";
      }
      constructor(e, n, i, o) {
        super(e, n, i, o), Yt(this, "_videoVisibleTimer", null), Yt(this, "_previousVideoVisibleStatus", void 0), Yt(this, "_clearPreviousVideoVisibleStatus", () => this._previousVideoVisibleStatus = void 0), Yt(this, "trackMediaType", fp.VIDEO), Yt(this, "_videoWidth", void 0), Yt(this, "_videoHeight", void 0), Yt(this, "_player", void 0), Yt(this, "processorDestination", void 0), Yt(this, "processorContext", void 0), this.updateMediaStreamTrackResolution(), this.processorContext = new W5(this.getTrackId(), "remote"), this.processorDestination = new X5(this.processorContext), this.bindProcessorDestinationEvents();
      }
      getStats() {
        return el(() => {
          Ee.warning("[deprecated] RemoteVideoTrack.getStats will be removed in the future, use AgoraRTCClient.getRemoteVideoStats instead");
        }, "remoteVideoTrackGetStatsWarning"), to(this, Tn.GET_STATS) || Zr({}, D5);
      }
      play(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (typeof e == "string") {
          const o = document.getElementById(e);
          o ? e = o : (Ee.warning("[".concat(this.getTrackId(), '] can not find "#').concat(e, '" element, use document.body')), e = document.body);
        }
        Ee.debug("[".concat(this.getTrackId(), "] start video playback in ").concat(e instanceof HTMLVideoElement ? "HTMLVideoElement" : "HTMLElement"), JSON.stringify(n));
        const i = Zr(Zr({ fit: "cover" }, n), {}, { trackId: this.getTrackId(), element: e });
        this._player ? this._player.updateConfig(i) : (e instanceof HTMLVideoElement ? this._player = new cI(i) : this._player = new BL(i), this._player.updateVideoTrack(this._mediaStreamTrack), this._player.onFirstVideoFrameDecoded = () => {
          this.store.subscribe(this.getUserId(), "video", void 0, void 0, Date.now()), this.safeEmit(lp.FIRST_FRAME_DECODED);
        }, this._player.onVideoStateChanged = (o) => {
          this.safeEmit(lp.VIDEO_STATE_CHANGED, o);
        }), this._player.play(this.store.sessionId || void 0), this._videoVisibleTimer && window.clearInterval(this._videoVisibleTimer), this._clearPreviousVideoVisibleStatus(), this._videoVisibleTimer = window.setInterval(() => {
          try {
            const o = this.getVideoElementVisibleStatus();
            this.safeEmit(lp.VIDEO_ELEMENT_VISIBLE_STATUS, o);
          } catch {
          }
        }, ft("CHECK_VIDEO_VISIBLE_INTERVAL"));
      }
      stop() {
        this._player && (this._videoVisibleTimer && (window.clearInterval(this._videoVisibleTimer), this._videoVisibleTimer = null), this._clearPreviousVideoVisibleStatus(), this._player.destroy(), this._player = void 0, Ee.debug("[".concat(this.getTrackId(), "] stop video playback")));
      }
      getCurrentFrameData() {
        return this._player ? this._player.getCurrentFrame() : new ImageData(2, 2);
      }
      updateMediaStreamTrackResolution() {
        J5(this._originMediaStreamTrack).then((e) => {
          let [n, i] = e;
          this._videoHeight = i, this._videoWidth = n;
        }).catch(fT);
      }
      _updatePlayerSource() {
        Ee.debug("[".concat(this.getTrackId(), "] update player source track")), this._player && this._player.updateVideoTrack(this._mediaStreamTrack);
      }
      getVideoElementVisibleStatus() {
        try {
          var e, n;
          const i = this == null || (e = this._player) === null || e === void 0 ? void 0 : e.getContainerElement(), o = { track: this, element: this == null || (n = this._player) === null || n === void 0 ? void 0 : n.getVideoElement(), slot: i == null ? void 0 : i.parentElement }, { element: f, slot: T } = o;
          if (this.isPlaying && f instanceof HTMLVideoElement && T instanceof HTMLElement) {
            const A = $M.checkOneElementVisible(f), R = Object.assign({}, A);
            if (R.visible !== this._previousVideoVisibleStatus) {
              this._previousVideoVisibleStatus = R.visible;
              const P = Cn.reportApiInvoke(null, { tag: si.TRACER, name: Bi.REMOTE_VIDEO_TRACK_GET_VIDEO_VISIBLE, options: [this.getTrackId()] });
              R.visible ? P.onSuccess("Video is visible") : P.onSuccess("Invisible because of ".concat(R.reason));
            }
            return R;
          }
          return;
        } catch (i) {
          throw new Gt(Je.GET_VIDEO_ELEMENT_VISIBLE_ERROR, i.message);
        }
      }
      pipe(e) {
        if (this.processor === e) return e;
        if (e._source) throw new Gt(Je.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({ track: this._originMediaStreamTrack, context: this.processorContext }), e;
      }
      unpipe() {
        if (!this.processor) return;
        const e = this.processor;
        this.processor._source = void 0, this.processor = void 0, e.reset();
      }
      bindProcessorDestinationEvents() {
        this.processorDestination.on(na.ON_TRACK, async (e) => {
          e ? e !== this._mediaStreamTrack && (this._mediaStreamTrack = e, this._updatePlayerSource()) : this._mediaStreamTrack !== this._originMediaStreamTrack && (this._mediaStreamTrack = this._originMediaStreamTrack, this._updatePlayerSource());
        });
      }
      unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(na.ON_TRACK);
      }
      _destroy() {
        super._destroy(), this.unbindProcessorDestinationEvents();
      }
      _onSei(e) {
        this.emit(Af.SEI_RECEIVED, e);
      }
    }).prototype, "play", [v8], Object.getOwnPropertyDescriptor(wo.prototype, "play"), wo.prototype), fr(wo.prototype, "stop", [T8], Object.getOwnPropertyDescriptor(wo.prototype, "stop"), wo.prototype), fr(wo.prototype, "pipe", [b8], Object.getOwnPropertyDescriptor(wo.prototype, "pipe"), wo.prototype), fr(wo.prototype, "unpipe", [A8], Object.getOwnPropertyDescriptor(wo.prototype, "unpipe"), wo.prototype), wo), Ep = (O8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n], throttleTime: 300 }), C8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n] }), S8 = Dn({ argsMap: (e) => [e.getTrackId()] }), I8 = Dn({ argsMap: (e) => [e.getTrackId()] }), R8 = Dn({ argsMap: (e, n) => [e.getTrackId(), n.name] }), N8 = Dn({ argsMap: (e) => [e.getTrackId()] }), fr((Ws = class extends w8 {
      get isPlaying() {
        return this._useAudioElement ? ha.isPlaying(this.getTrackId()) : this._source.isPlayed;
      }
      get __className__() {
        return "RemoteAudioTrack";
      }
      constructor(e, n, i, o) {
        super(e, n, i, o), Yt(this, "trackMediaType", fp.AUDIO), Yt(this, "_source", void 0), Yt(this, "_useAudioElement", !0), Yt(this, "_volume", 100), Yt(this, "processorContext", void 0), Yt(this, "processorDestination", void 0), Yt(this, "_played", !1), Yt(this, "_bypassWebAudio", !1), ft("DISABLE_WEBAUDIO") ? (this._source = new aI(), this._bypassWebAudio = !0, this._useAudioElement = !0) : (this._source = new H5(e, !0), ft("REMOTE_AUDIO_TRACK_USES_WEB_AUDIO") && (this._useAudioElement = !1)), this._source.once(io.RECEIVE_TRACK_BUFFER, () => {
          this.safeEmit(lp.FIRST_FRAME_DECODED);
        }), this.processorContext = new K5(this._source.context, this.getTrackId(), "remote"), this.processorDestination = new q5(this.processorContext), this.bindProcessorDestinationEvents(), this._source.on(io.UPDATE_SOURCE, () => {
          this.processor && this.processor.updateInput({ node: this._source.processSourceNode, context: this.processorContext });
        });
      }
      setAudioFrameCallback(e) {
        let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4096;
        if (!e) return this._source.removeAllListeners(io.ON_AUDIO_BUFFER), void this._source.stopGetAudioBuffer();
        this._source.startGetAudioBuffer(n), this._source.removeAllListeners(io.ON_AUDIO_BUFFER), this._source.on(io.ON_AUDIO_BUFFER, (i) => e(i));
      }
      setVolume(e) {
        this._volume = e, this._useAudioElement ? ha.setVolume(this.getTrackId(), e) : this._source.setVolume(e / 100);
      }
      async setPlaybackDevice(e) {
        if (!this._useAudioElement || !w5()) throw new Gt(Je.NOT_SUPPORTED, "your browser does not support setting the audio output device");
        await ha.setSinkID(this.getTrackId(), e);
      }
      getVolumeLevel() {
        return this._source.getAccurateVolumeLevel();
      }
      getStats() {
        return el(() => {
          Ee.warning("[deprecated] RemoteAudioTrack.getStats will be removed in the future, use AgoraRTCClient.getRemoteAudioStats instead");
        }, "remoteAudioTrackGetStatsWarning"), to(this, Tn.GET_STATS) || Zr({}, x5);
      }
      play() {
        Ee.debug("[".concat(this.getTrackId(), "] start audio playback")), this._played = !0, this._useAudioElement ? (Ee.debug("[".concat(this.getTrackId(), "] use audio element to play")), ha.play(this._mediaStreamTrack, this.getTrackId(), this._volume, this.store.sessionId || void 0)) : this._source.play();
      }
      stop() {
        Ee.debug("[".concat(this.getTrackId(), "] stop audio playback")), this._played = !1, this._useAudioElement ? ha.stop(this.getTrackId()) : this._source.stop();
      }
      _destroy() {
        super._destroy(), this._played = !1, this.unbindProcessorDestinationEvents(), this._source.destroy();
      }
      _isFreeze() {
        return this._source.isFreeze;
      }
      _updatePlayerSource() {
        let e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
        Ee.debug("[".concat(this.getTrackId(), "] update player source track")), e && this._source.updateTrack(this._mediaStreamTrack), this._useAudioElement && ha.updateTrack(this.getTrackId(), this._mediaStreamTrack);
      }
      pipe(e) {
        if (this._bypassWebAudio) throw new Gt(Je.NOT_SUPPORTED, "can not pipe extension when WebAudio disabled");
        if (this.processor === e) return e;
        if (e._source) throw new Gt(Je.INVALID_OPERATION, "Processor ".concat(e.name, " already piped, please call unpipe beforehand."));
        return this.unpipe(), this.processor = e, this.processor._source = this, e.updateInput({ track: this._originMediaStreamTrack, node: this._source.processSourceNode, context: this.processorContext }), e;
      }
      unpipe() {
        var e;
        if (this._bypassWebAudio) throw new Gt(Je.NOT_SUPPORTED, "can not unpipe extension when WebAudio disabled");
        if (!this.processor) return;
        const n = this.processor;
        (e = this._source.processSourceNode) === null || e === void 0 || e.disconnect(), this.processor._source = !1, this.processor = void 0, n.reset();
      }
      bindProcessorDestinationEvents() {
        this.processorDestination.on(na.ON_TRACK, async (e) => {
          e ? e !== this._mediaStreamTrack && (this._mediaStreamTrack = e, this._updatePlayerSource(!1), this._source.processedNode = this._source.createMediaStreamSourceNode(e)) : this._mediaStreamTrack !== this._originMediaStreamTrack && (this._mediaStreamTrack = this._originMediaStreamTrack, this._updatePlayerSource());
        }), this.processorDestination.on(na.ON_NODE, (e) => {
          this._source.processedNode = e;
          const n = !e;
          this._useAudioElement !== n && (this._played ? (this.stop(), this._useAudioElement = n, this.play()) : this._useAudioElement = n);
        });
      }
      unbindProcessorDestinationEvents() {
        this.processorDestination.removeAllListeners(na.ON_TRACK), this.processorDestination.removeAllListeners(na.ON_NODE);
      }
    }).prototype, "setVolume", [O8], Object.getOwnPropertyDescriptor(Ws.prototype, "setVolume"), Ws.prototype), fr(Ws.prototype, "setPlaybackDevice", [C8], Object.getOwnPropertyDescriptor(Ws.prototype, "setPlaybackDevice"), Ws.prototype), fr(Ws.prototype, "play", [S8], Object.getOwnPropertyDescriptor(Ws.prototype, "play"), Ws.prototype), fr(Ws.prototype, "stop", [I8], Object.getOwnPropertyDescriptor(Ws.prototype, "stop"), Ws.prototype), fr(Ws.prototype, "pipe", [R8], Object.getOwnPropertyDescriptor(Ws.prototype, "pipe"), Ws.prototype), fr(Ws.prototype, "unpipe", [N8], Object.getOwnPropertyDescriptor(Ws.prototype, "unpipe"), Ws.prototype), Ws);
    const ld = new class extends ii {
      get visibility() {
        return document.visibilityState;
      }
      get lastHiddenTime() {
        return this._lastHiddenTime;
      }
      get lastVisibleTime() {
        return this._lastVisibleTime;
      }
      constructor() {
        super(), Yt(this, "_lastHiddenTime", 0), Yt(this, "_lastVisibleTime", 0), document.addEventListener("visibilitychange", () => {
          document.visibilityState === "hidden" ? this._lastHiddenTime = performance.now() : this._lastVisibleTime = performance.now(), Ee.debug("current web page is ".concat(document.visibilityState)), this.emit("VISIBILITY_CHANGE", document.visibilityState);
        });
      }
    }();
    class _8 extends ii {
      constructor(n, i) {
        super(), Yt(this, "trackMediaType", fp.DATA), Yt(this, "_version", 1), Yt(this, "_type", 3), Yt(this, "_config", void 0), Yt(this, "_originDataChannel", void 0), Yt(this, "_dataStreamPacketHeader", new ArrayBuffer(4)), Yt(this, "_dataStreamPacketHandler", { serialize: (o) => o, deserialize: (o) => o }), Yt(this, "_datachannelEventMap", /* @__PURE__ */ new Map()), this._config = n, i && (this._originDataChannel = i, this._bandDataChannelEvents(i)), this._initPacketHeader();
      }
      useDataStream(n) {
        this._dataStreamPacketHandler = n;
      }
      get id() {
        return this._config.id;
      }
      get ordered() {
        return this._config.ordered;
      }
      get maxRetransmits() {
        return ft("DATASTREAM_MAX_RETRANSMITS");
      }
      get metadata() {
        return this._config.metadata;
      }
      get readyState() {
        var n, i;
        return (n = (i = this._originDataChannel) === null || i === void 0 ? void 0 : i.readyState) !== null && n !== void 0 ? n : "connecting";
      }
      get _originDataChannelId() {
        var n, i;
        return (n = (i = this._originDataChannel) === null || i === void 0 ? void 0 : i.id) !== null && n !== void 0 ? n : null;
      }
      getChannelId() {
        return this.id;
      }
      getConfig() {
        return this._config;
      }
      _close() {
        this._originDataChannel && (this._unbindDataChannelEvents(this._originDataChannel), this._originDataChannel = void 0);
      }
      async _waitTillOpen() {
        return new cn((n, i) => {
          if (this._originDataChannel) {
            this._originDataChannel.readyState === "open" && n();
            const o = setTimeout(() => {
              var f;
              i(new Gt(Je.DATACHANNEL_CONNECTION_TIMEOUT, "Cannot create datachannel, id: ".concat((f = this._originDataChannel) === null || f === void 0 ? void 0 : f.id)));
            }, 1e4);
            this._originDataChannel.onopen = () => {
              clearTimeout(o), this._originDataChannel && this._bandDataChannelEvents(this._originDataChannel), n();
            }, this._originDataChannel.onerror = () => {
              throw clearTimeout(o), new Gt(Je.DATACHANNEL_CONNECTION_TIMEOUT);
            };
          } else i(new Gt(Je.DATACHANNEL_CONNECTION_TIMEOUT, "cannot find dataChannel"));
        });
      }
      _updateOriginDataChannel(n) {
        this._originDataChannel = n, this._bandDataChannelEvents(n);
      }
      _initPacketHeader() {
        const n = new DataView(this._dataStreamPacketHeader);
        n.setUint16(0, this._version), n.setUint8(2, this._type), n.setUint8(3, this._config.id);
      }
      _bandDataChannelEvents(n) {
        this._unbindDataChannelEvents(n), [TT.OPEN, TT.CLOSE, TT.ERROR].forEach((i) => {
          const o = () => {
            this.emit(i);
          };
          this._datachannelEventMap.set(i, o), n.addEventListener(i, o);
        });
      }
      _unbindDataChannelEvents(n) {
        Array.from(this._datachannelEventMap.entries()).forEach((i) => {
          let [o, f] = i;
          n.removeEventListener(o, f);
        }), this._datachannelEventMap.clear();
      }
    }
    class Tse extends _8 {
      constructor(n) {
        super(n), Yt(this, "_messageListener", void 0), this._messageListener = (i) => {
          if (i.data.byteLength < this._dataStreamPacketHeader.byteLength) throw Error("invalid byteLength: the byte length must exceed " + this._dataStreamPacketHeader.byteLength);
          const o = i.data.slice(0, this._dataStreamPacketHeader.byteLength), f = new DataView(o).getUint8(3);
          if (f !== this.id) return void (ft("SHOW_DATASTREAM2_LOG") && Ee.debug("invalid datachannel id: ".concat(f, " !== ").concat(this.id)));
          let T = i.data.slice(this._dataStreamPacketHeader.byteLength);
          T = this._dataStreamPacketHandler.deserialize(T), this.emit(TT.MESSAGE, T);
        };
      }
      _updateOriginDataChannel(n) {
        super._updateOriginDataChannel(n), this._bandRemoteDataChannelEvents();
      }
      _close() {
        this._originDataChannel && (this._originDataChannel.removeEventListener("message", this._messageListener), super._close());
      }
      _bandRemoteDataChannelEvents() {
        this._originDataChannel && this._originDataChannel.addEventListener("message", this._messageListener);
      }
    }
    class bse extends _8 {
      send(n) {
        if (this._originDataChannel) {
          let i = n;
          i = this._dataStreamPacketHandler.serialize(n);
          const o = new Uint8Array(this._dataStreamPacketHeader.byteLength + i.byteLength);
          o.set(new Uint8Array(this._dataStreamPacketHeader), 0), o.set(new Uint8Array(i), this._dataStreamPacketHeader.byteLength), this._originDataChannel.send(o.buffer);
        }
      }
    }
    function CT() {
      const e = new Blob([atob("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")], { type: "text/javascript" });
      return setTimeout(() => p4.revokeObjectURL(e), 0), new Worker(p4.createObjectURL(e));
    }
    const ST = /* @__PURE__ */ new Map(), IT = /* @__PURE__ */ new Map();
    async function P8(e) {
      if (!pr().supportWebRTCEncodedTransform) return void Ee.warning("browser not support audio encoded transform");
      if (IT.has(e)) return;
      const n = { track: e.track };
      if ($d()) {
        if (!e.createEncodedStreams) return void Ee.warning("browser not support createEncodedStreams() API");
        let o = null;
        try {
          o = e.createEncodedStreams();
        } catch (T) {
          return void Ee.error("create audio-encoded-streams error", T && T.message);
        }
        const f = new TransformStream({ transform(T, A) {
          n.controller || (n.controller = A), e.track && e.track.id !== n.track.id && (Ee.debug("audio track changed: ".concat(n.track.id, " => ").concat(e.track.id)), n.track.removeEventListener("ended", i), n.track = e.track, n.track.addEventListener("ended", i)), A.enqueue(T);
        } });
        o.readable.pipeThrough(f).pipeTo(o.writable);
      } else if (Os()) {
        if (typeof RTCRtpScriptTransform > "u") return void Ee.warning("browser not support RTCRtpScriptTransform");
        const o = CT(), f = new MessageChannel();
        await new cn((A) => o.onmessage = (R) => {
          R.data === "registered" && A(void 0);
        });
        const T = new RTCRtpScriptTransform(o, { name: "rx", port: f.port2 }, [f.port2]);
        e.transform = T, await new cn((A) => o.onmessage = (R) => {
          R.data === "started" && A(void 0);
        }), f.port1.onmessage = (A) => {
          var R;
          A.data.transformed && e.track && ((R = e.track) === null || R === void 0 ? void 0 : R.id) !== n.track.id && (Ee.debug("audio track changed: ".concat(n.track.id, " => ").concat(e.track.id)), n.track.removeEventListener("ended", i), n.track = e.track, n.track.addEventListener("ended", i));
        }, n.worker = o;
      }
      function i() {
        e.track.removeEventListener("ended", i), function(o) {
          const f = IT.get(o);
          if (f) {
            IT.delete(o);
            try {
              var T, A;
              (T = f.controller) === null || T === void 0 || T.terminate(), (A = f.worker) === null || A === void 0 || A.terminate();
            } catch (R) {
              Ee.warning(R && R.message);
            }
          }
        }(e);
      }
      IT.set(e, n), e.track.addEventListener("ended", i);
    }
    function Ase(e, n, i) {
      let o = new Uint8Array(e, n, i), f = [], T = 0;
      for (; f.length < i; ) T + 3 < i && o[T] === 0 && o[T + 1] === 0 && o[T + 2] === 3 && (o[T + 3] === 0 || o[T + 3] === 1 || o[T + 3] === 2 || o[T + 3] === 3) ? (f.push(o[T], o[T + 1], o[T + 3]), T += 4) : (f.push(o[T]), T++);
      return new Uint8Array(f);
    }
    const RT = /* @__PURE__ */ new Map();
    async function Ose(e, n) {
      if (!pr().supportWebRTCEncodedTransform) return void Ee.warning("browser not support video encoded transform");
      if (RT.has(e) || !e.track) return;
      const i = { track: e.track };
      if ($d()) {
        if (!e.createEncodedStreams) return void Ee.warning("browser not support createEncodedStreams() API");
        let f = null;
        try {
          f = e.createEncodedStreams();
        } catch (R) {
          return void Ee.error("create video-encoded-streams error", R && R.message);
        }
        let T = [];
        n.on("sei-to-send", (R) => {
          T.push(R);
        });
        const A = new TransformStream({ transform(R, P) {
          i.controller || (i.controller = P), e.track && e.track.id !== i.track.id && (Ee.debug("video track changed: ".concat(i.track.id, " => ").concat(e.track.id)), i.track.removeEventListener("ended", o), i.track = e.track, i.track.addEventListener("ended", o));
          const L = T.shift();
          L && (R.data = function(z, Y) {
            const te = function(We) {
              const mt = We.length;
              let Pt = [], xt = 0;
              for (; xt < mt; ) xt + 2 < mt && We[xt] === 0 && We[xt + 1] === 0 && (We[xt + 2] === 0 || We[xt + 2] === 1 || We[xt + 2] === 2 || We[xt + 2] === 3) ? (Pt.push(We[xt], We[xt + 1], 3, We[xt + 2]), xt += 3) : (Pt.push(We[xt]), xt++);
              return new Uint8Array(Pt);
            }(Y), oe = te.length, He = Math.floor(oe / 255), Re = oe % 255, De = new Uint8Array(6 + He + 1 + oe + z.byteLength);
            De[0] = 0, De[1] = 0, De[2] = 0, De[3] = 1, De[4] = 6, De[5] = 101;
            let Xe = 0;
            for (; Xe < He; ) De[6 + Xe] = 255, Xe++;
            return De[6 + Xe] = Re, Xe++, De.set(te, 6 + Xe), De.set(new Uint8Array(z), 6 + Xe + oe), De.buffer;
          }(R.data, L)), P.enqueue(R);
        } });
        f.readable.pipeThrough(A).pipeTo(f.writable);
      } else {
        if (!Os()) return;
        {
          if (typeof RTCRtpScriptTransform > "u") return void Ee.warning("browser not support RTCRtpScriptTransform");
          const f = CT(), T = new MessageChannel();
          await new cn((R) => f.onmessage = (P) => {
            P.data === "registered" && R(void 0);
          });
          const A = new RTCRtpScriptTransform(f, { name: "tx", port: T.port2 }, [T.port2]);
          e.transform = A, await new cn((R) => f.onmessage = (P) => {
            P.data === "started" && R(void 0);
          }), n.on("sei-to-send", (R) => {
            T.port1.postMessage({ sei: R });
          }), T.port1.onmessage = (R) => {
            var P;
            R.data.transformed && e.track && ((P = e.track) === null || P === void 0 ? void 0 : P.id) !== i.track.id && (Ee.debug("video track changed: ".concat(i.track.id, " => ").concat(e.track.id)), i.track.removeEventListener("ended", o), i.track = e.track, i.track.addEventListener("ended", o));
          }, i.worker = f;
        }
      }
      function o() {
        if (e.track) {
          if (this.id !== e.track.id) return;
          e.track.removeEventListener("ended", o);
        }
        const f = RT.get(e);
        if (f) {
          RT.delete(e);
          try {
            var T, A;
            (T = f.controller) === null || T === void 0 || T.terminate(), (A = f.worker) === null || A === void 0 || A.terminate();
          } catch (R) {
            Ee.warning(R && R.message);
          }
        }
      }
      RT.set(e, i), e.track.addEventListener("ended", o);
    }
    const LE = /* @__PURE__ */ new Map();
    async function x8(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!pr().supportWebRTCEncodedTransform) return void Ee.warning("browser not support video encoded transform");
      if (!e.track) return;
      if (LE.has(e)) {
        const f = LE.get(e);
        return void (f && (f.onSei = n.onSei));
      }
      const i = { track: e.track, onSei: n.onSei };
      if ($d()) {
        if (!e.createEncodedStreams) return void Ee.warning("browser not support createEncodedStreams() API");
        let f = null;
        try {
          f = e.createEncodedStreams();
        } catch (A) {
          return void Ee.error("create video-encoded-streams error", A && A.message);
        }
        const T = new TransformStream({ transform(A, R) {
          i.controller || (i.controller = R), e.track && e.track.id !== i.track.id && (Ee.debug("video track changed: ".concat(i.track.id, " => ").concat(e.track.id)), i.track.removeEventListener("ended", o), i.track = e.track, i.track.addEventListener("ended", o));
          const P = function(L) {
            const z = new DataView(L.data);
            let Y = 0;
            for (; Y + 4 < L.data.byteLength; ) {
              if (z.getUint8(Y + 0) === 0 && z.getUint8(Y + 1) === 0 && z.getUint8(Y + 2) === 0 && z.getUint8(Y + 3) === 1 && z.getUint8(Y + 4) === 6) {
                let te = Y + 6, oe = 0, He = 0;
                for (; (He = z.getUint8(te++)) === 255; ) oe += 255;
                oe += He;
                const Re = Ase(L.data, te, oe);
                return new Uint8Array(Re);
              }
              Y++;
            }
            return null;
          }(A);
          P && i.onSei && i.onSei(P), R.enqueue(A);
        } });
        f.readable.pipeThrough(T).pipeTo(f.writable);
      } else if (Os()) {
        if (typeof RTCRtpScriptTransform > "u") return void Ee.warning("browser not support RTCRtpScriptTransform");
        const f = CT(), T = new MessageChannel();
        await new cn((R) => f.onmessage = (P) => {
          P.data === "registered" && R(void 0);
        });
        const A = new RTCRtpScriptTransform(f, { name: "rx", port: T.port2 }, [T.port2]);
        e.transform = A, await new cn((R) => f.onmessage = (P) => {
          P.data === "started" && R(void 0);
        }), T.port1.onmessage = (R) => {
          var P;
          R.data.transformed && e.track && ((P = e.track) === null || P === void 0 ? void 0 : P.id) !== i.track.id ? (Ee.debug("video track changed: ".concat(i.track.id, " => ").concat(e.track.id)), i.track.removeEventListener("ended", o), i.track = e.track, i.track.addEventListener("ended", o)) : R.data.sei && i.onSei && i.onSei(R.data.sei);
        }, i.worker = f;
      }
      function o() {
        if (e.track) {
          if (this.id !== e.track.id) return;
          e.track.removeEventListener("ended", o);
        }
        (function(f) {
          const T = LE.get(f);
          if (T) {
            LE.delete(f);
            try {
              var A, R;
              (A = T.controller) === null || A === void 0 || A.terminate(), (R = T.worker) === null || R === void 0 || R.terminate();
            } catch (P) {
              Ee.warning(P && P.message);
            }
          }
        })(e);
      }
      LE.set(e, i), e.track.addEventListener("ended", o);
    }
    (function() {
      const e = hr();
      ys.getDisplayMedia = !(!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia), ys.getStreamFromExtension = e.name === Cr.CHROME && Number(e.version) > 34, ys.supportUnifiedPlan = function() {
        if (!window.RTCRtpTransceiver || !("currentDirection" in RTCRtpTransceiver.prototype)) return !1;
        const n = new RTCPeerConnection();
        let i = !1;
        try {
          n.addTransceiver("audio"), i = !0;
        } catch {
        }
        return n.close(), i;
      }(), ys.supportMinBitrate = e.name === Cr.CHROME || e.name === Cr.EDGE, ys.supportSetRtpSenderParameters = function() {
        const n = hr();
        return !!(window.RTCRtpSender && window.RTCRtpSender.prototype.setParameters && window.RTCRtpSender.prototype.getParameters) && (!!ad() || !(!Os() && !oT()) || n.name === Cr.FIREFOX && Number(n.version) >= 64);
      }(), e.name === Cr.SAFARI && (Number(e.version) >= 14 ? ys.supportDualStream = !0 : ys.supportDualStream = !1), ys.webAudioMediaStreamDest = function() {
        const n = hr();
        return !(n.name === Cr.SAFARI && Number(n.version) < 12);
      }(), ys.supportReplaceTrack = !!window.RTCRtpSender && typeof RTCRtpSender.prototype.replaceTrack == "function", ys.supportWebGL = typeof WebGLRenderingContext < "u", ys.supportRequestFrame = !!window.CanvasCaptureMediaStreamTrack, ad() || (ys.webAudioWithAEC = !0), ys.supportShareAudio = function() {
        const n = hr();
        return (n.os === ts.WIN_10 || n.os === ts.WIN_81 || n.os === ts.WIN_7 || n.os === ts.LINUX || n.os === ts.MAC_OS || n.os === ts.CHROMIUM_OS) && n.name === Cr.CHROME && Number(n.version) >= 74;
      }(), ys.supportDataChannel = !!(cT(76) || function(n) {
        const i = hr();
        return !(i.name !== Cr.FIREFOX || !i.osVersion) && Number(i.version) >= n;
      }(68) || VM(14)), ys.supportPCSetConfiguration = function() {
        const n = window.RTCPeerConnection;
        return !ui() && !!n && n.prototype.setConfiguration instanceof Function;
      }(), ys.supportWebRTCEncodedTransform = function() {
        const n = hr();
        return n.name === "Chrome" && Number(n.version) >= 86 || n.name === "Safari" && Number(n.version) >= 15;
      }(), ys.supportWebRTCInsertableStream = function() {
        const n = hr();
        return (n.name === Cr.CHROME || n.name === Cr.EDGE) && Number(n.version) >= 94 && "MediaStreamTrackGenerator" in window && "MediaStreamTrackProcessor" in window;
      }(), ys.supportRequestVideoFrameCallback = "requestVideoFrameCallback" in HTMLVideoElement.prototype, ys.supportWebCrypto = typeof window < "u" && window.crypto !== void 0 && window.crypto.subtle !== void 0, lT(() => {
        ys.supportDualStreamEncoding = function() {
          const n = hr();
          return !!ft("DISABLE_WEBAUDIO") || n.name === "Safari" && Number(n.version) >= 14 || !!(n.name === "Chrome" && /Windows/i.test(n.os || "") && Number(n.version) >= 100 && ft("CHROME_DUAL_STREAM_USE_ENCODING"));
        }(), Ee.debug("browser ua: ", navigator.userAgent), Ee.info("browser info: ", e), Ee.info("browser compatibility: ", ys);
      });
    })();
    const Cse = ["CHINA", "GLOBAL"], D8 = [[0, 1, 2, 3, 4, 5, 5], [0, 2, 2, 3, 4, 5, 5], [0, 3, 3, 3, 4, 5, 5], [0, 4, 4, 4, 4, 5, 5], [0, 5, 5, 5, 5, 5, 5]], Sf = [];
    function If(e, n) {
      return !!n && Sf.some((i) => i.uid === e && i.channelName === n);
    }
    var Sse = cD.forEach, M8 = Vv("forEach") ? [].forEach : function(e) {
      return Sse(this, e, arguments.length > 1 ? arguments[1] : void 0);
    };
    _r({ target: "Array", proto: !0, forced: [].forEach != M8 }, { forEach: M8 });
    var Ise = Jo("Array").forEach, Rse = du, Nse = Lt, wse = m, _se = Ise, lI = Array.prototype, Pse = { DOMTokenList: !0, NodeList: !0 }, xse = function(e) {
      var n = e.forEach;
      return e === lI || wse(lI, e) && n === lI.forEach || Nse(Pse, Rse(e)) ? _se : n;
    }, Dse = h(xse), Mse = et, L8 = qv;
    _r({ target: "Object", stat: !0, forced: b(function() {
      L8(1);
    }) }, { keys: function(e) {
      return L8(Mse(e));
    } });
    var k8 = h(it.Object.keys), Lse = h(b_), kse = h(O_), jse = _r, j8 = qm, Use = a1, Hse = gt, U8 = HA, Bse = td, zse = pt, Fse = g1, Gse = Or, Vse = o1, Yse = Qx("slice"), Xse = Gse("species"), fI = Array, Wse = Math.max;
    jse({ target: "Array", proto: !0, forced: !Yse }, { slice: function(e, n) {
      var i, o, f, T = zse(this), A = Bse(T), R = U8(e, A), P = U8(n === void 0 ? A : n, A);
      if (j8(T) && (i = T.constructor, (Use(i) && (i === fI || j8(i.prototype)) || Hse(i) && (i = i[Xse]) === null) && (i = void 0), i === fI || i === void 0)) return Vse(T, R, P);
      for (o = new (i === void 0 ? fI : i)(Wse(P - R, 0)), f = 0; R < P; R++, f++) R in T && Fse(o, f, T[R]);
      return o.length = f, o;
    } });
    var qse = Jo("Array").slice, Kse = m, Jse = qse, hI = Array.prototype, Zse = function(e) {
      var n = e.slice;
      return e === hI || Kse(hI, e) && n === hI.slice ? Jse : n;
    }, Qse = h(Zse);
    function bn(e, n, i, o, f) {
      var T, A, R, P = {};
      return Dse(T = k8(o)).call(T, function(L) {
        P[L] = o[L];
      }), P.enumerable = !!P.enumerable, P.configurable = !!P.configurable, ("value" in P || P.initializer) && (P.writable = !0), P = Lse(A = kse(R = Qse(i).call(i)).call(R)).call(A, function(L, z) {
        return z(e, n, L) || L;
      }, P), f && P.initializer !== void 0 && (P.value = P.initializer ? P.initializer.call(f) : void 0, P.initializer = void 0), P.initializer === void 0 && (qx(e, n, P), P = null), P;
    }
    let NT = function(e) {
      return e[e.ACCESS_POINT = 101] = "ACCESS_POINT", e[e.UNILBS = 201] = "UNILBS", e[e.STRING_UID_ALLOCATOR = 901] = "STRING_UID_ALLOCATOR", e;
    }({}), pI = function(e) {
      return e[e.IIIEGAL_APPID = 1] = "IIIEGAL_APPID", e[e.IIIEGAL_UID = 2] = "IIIEGAL_UID", e[e.INTERNAL_ERROR = 3] = "INTERNAL_ERROR", e;
    }({}), ac = function(e) {
      return e[e.INVALID_VENDOR_KEY = 5] = "INVALID_VENDOR_KEY", e[e.INVALID_CHANNEL_NAME = 7] = "INVALID_CHANNEL_NAME", e[e.INTERNAL_ERROR = 8] = "INTERNAL_ERROR", e[e.NO_AUTHORIZED = 9] = "NO_AUTHORIZED", e[e.DYNAMIC_KEY_TIMEOUT = 10] = "DYNAMIC_KEY_TIMEOUT", e[e.NO_ACTIVE_STATUS = 11] = "NO_ACTIVE_STATUS", e[e.DYNAMIC_KEY_EXPIRED = 13] = "DYNAMIC_KEY_EXPIRED", e[e.STATIC_USE_DYNAMIC_KEY = 14] = "STATIC_USE_DYNAMIC_KEY", e[e.DYNAMIC_USE_STATIC_KEY = 15] = "DYNAMIC_USE_STATIC_KEY", e[e.USER_OVERLOAD = 16] = "USER_OVERLOAD", e[e.FORBIDDEN_REGION = 18] = "FORBIDDEN_REGION", e[e.CANNOT_MEET_AREA_DEMAND = 19] = "CANNOT_MEET_AREA_DEMAND", e;
    }({}), ra = function(e) {
      return e[e.NO_FLAG_SET = 100] = "NO_FLAG_SET", e[e.FLAG_SET_BUT_EMPTY = 101] = "FLAG_SET_BUT_EMPTY", e[e.INVALID_FALG_SET = 102] = "INVALID_FALG_SET", e[e.FLAG_SET_BUT_NO_RE = 103] = "FLAG_SET_BUT_NO_RE", e[e.INVALID_SERVICE_ID = 104] = "INVALID_SERVICE_ID", e[e.NO_SERVICE_AVAILABLE = 200] = "NO_SERVICE_AVAILABLE", e[e.NO_SERVICE_AVAILABLE_P2P = 201] = "NO_SERVICE_AVAILABLE_P2P", e[e.NO_SERVICE_AVAILABLE_VOICE = 202] = "NO_SERVICE_AVAILABLE_VOICE", e[e.NO_SERVICE_AVAILABLE_WEBRTC = 203] = "NO_SERVICE_AVAILABLE_WEBRTC", e[e.NO_SERVICE_AVAILABLE_CDS = 204] = "NO_SERVICE_AVAILABLE_CDS", e[e.NO_SERVICE_AVAILABLE_CDN = 205] = "NO_SERVICE_AVAILABLE_CDN", e[e.NO_SERVICE_AVAILABLE_TDS = 206] = "NO_SERVICE_AVAILABLE_TDS", e[e.NO_SERVICE_AVAILABLE_REPORT = 207] = "NO_SERVICE_AVAILABLE_REPORT", e[e.NO_SERVICE_AVAILABLE_APP_CENTER = 208] = "NO_SERVICE_AVAILABLE_APP_CENTER", e[e.NO_SERVICE_AVAILABLE_ENV0 = 209] = "NO_SERVICE_AVAILABLE_ENV0", e[e.NO_SERVICE_AVAILABLE_VOET = 210] = "NO_SERVICE_AVAILABLE_VOET", e[e.NO_SERVICE_AVAILABLE_STRING_UID = 211] = "NO_SERVICE_AVAILABLE_STRING_UID", e[e.NO_SERVICE_AVAILABLE_WEBRTC_UNILBS = 212] = "NO_SERVICE_AVAILABLE_WEBRTC_UNILBS", e[e.NO_SERVICE_AVAILABLE_UNILBS_FLV = 213] = "NO_SERVICE_AVAILABLE_UNILBS_FLV", e;
    }({}), xn = function(e) {
      return e[e.K_TIMESTAMP_EXPIRED = 2] = "K_TIMESTAMP_EXPIRED", e[e.K_CHANNEL_PERMISSION_INVALID = 3] = "K_CHANNEL_PERMISSION_INVALID", e[e.K_CERTIFICATE_INVALID = 4] = "K_CERTIFICATE_INVALID", e[e.K_CHANNEL_NAME_EMPTY = 5] = "K_CHANNEL_NAME_EMPTY", e[e.K_CHANNEL_NOT_FOUND = 6] = "K_CHANNEL_NOT_FOUND", e[e.K_TICKET_INVALID = 7] = "K_TICKET_INVALID", e[e.K_CHANNEL_CONFLICTED = 8] = "K_CHANNEL_CONFLICTED", e[e.K_SERVICE_NOT_READY = 9] = "K_SERVICE_NOT_READY", e[e.K_SERVICE_TOO_HEAVY = 10] = "K_SERVICE_TOO_HEAVY", e[e.K_UID_BANNED = 14] = "K_UID_BANNED", e[e.K_IP_BANNED = 15] = "K_IP_BANNED", e[e.K_CHANNEL_BANNED = 16] = "K_CHANNEL_BANNED", e[e.DATASTREAM2_NOT_AVAILABLE = 27] = "DATASTREAM2_NOT_AVAILABLE", e[e.K_AUTO_REBALANCE = 28] = "K_AUTO_REBALANCE", e[e.WARN_NO_AVAILABLE_CHANNEL = 103] = "WARN_NO_AVAILABLE_CHANNEL", e[e.WARN_LOOKUP_CHANNEL_TIMEOUT = 104] = "WARN_LOOKUP_CHANNEL_TIMEOUT", e[e.WARN_LOOKUP_CHANNEL_REJECTED = 105] = "WARN_LOOKUP_CHANNEL_REJECTED", e[e.WARN_OPEN_CHANNEL_TIMEOUT = 106] = "WARN_OPEN_CHANNEL_TIMEOUT", e[e.WARN_OPEN_CHANNEL_REJECTED = 107] = "WARN_OPEN_CHANNEL_REJECTED", e[e.WARN_REQUEST_DEFERRED = 108] = "WARN_REQUEST_DEFERRED", e[e.ERR_DYNAMIC_KEY_TIMEOUT = 109] = "ERR_DYNAMIC_KEY_TIMEOUT", e[e.ERR_NO_AUTHORIZED = 110] = "ERR_NO_AUTHORIZED", e[e.ERR_VOM_SERVICE_UNAVAILABLE = 111] = "ERR_VOM_SERVICE_UNAVAILABLE", e[e.ERR_NO_CHANNEL_AVAILABLE_CODE = 112] = "ERR_NO_CHANNEL_AVAILABLE_CODE", e[e.ERR_MASTER_VOCS_UNAVAILABLE = 114] = "ERR_MASTER_VOCS_UNAVAILABLE", e[e.ERR_INTERNAL_ERROR = 115] = "ERR_INTERNAL_ERROR", e[e.ERR_NO_ACTIVE_STATUS = 116] = "ERR_NO_ACTIVE_STATUS", e[e.ERR_INVALID_UID = 117] = "ERR_INVALID_UID", e[e.ERR_DYNAMIC_KEY_EXPIRED = 118] = "ERR_DYNAMIC_KEY_EXPIRED", e[e.ERR_STATIC_USE_DYANMIC_KE = 119] = "ERR_STATIC_USE_DYANMIC_KE", e[e.ERR_DYNAMIC_USE_STATIC_KE = 120] = "ERR_DYNAMIC_USE_STATIC_KE", e[e.ERR_NO_VOCS_AVAILABLE = 2e3] = "ERR_NO_VOCS_AVAILABLE", e[e.ERR_NO_VOS_AVAILABLE = 2001] = "ERR_NO_VOS_AVAILABLE", e[e.ERR_JOIN_CHANNEL_TIMEOUT = 2002] = "ERR_JOIN_CHANNEL_TIMEOUT", e[e.ERR_REPEAT_JOIN_CHANNEL = 2003] = "ERR_REPEAT_JOIN_CHANNEL", e[e.ERR_JOIN_BY_MULTI_IP = 2004] = "ERR_JOIN_BY_MULTI_IP", e[e.ERR_NOT_JOINED = 2011] = "ERR_NOT_JOINED", e[e.ERR_REPEAT_JOIN_REQUEST = 2012] = "ERR_REPEAT_JOIN_REQUEST", e[e.ERR_INVALID_VENDOR_KEY = 2013] = "ERR_INVALID_VENDOR_KEY", e[e.ERR_INVALID_CHANNEL_NAME = 2014] = "ERR_INVALID_CHANNEL_NAME", e[e.ERR_INVALID_STRINGUID = 2015] = "ERR_INVALID_STRINGUID", e[e.ERR_TOO_MANY_USERS = 2016] = "ERR_TOO_MANY_USERS", e[e.ERR_SET_CLIENT_ROLE_TIMEOUT = 2017] = "ERR_SET_CLIENT_ROLE_TIMEOUT", e[e.ERR_SET_CLIENT_ROLE_NO_PERMISSION = 2018] = "ERR_SET_CLIENT_ROLE_NO_PERMISSION", e[e.ERR_SET_CLIENT_ROLE_ALREADY_IN_USE = 2019] = "ERR_SET_CLIENT_ROLE_ALREADY_IN_USE", e[e.ERR_PUBLISH_REQUEST_INVALID = 2020] = "ERR_PUBLISH_REQUEST_INVALID", e[e.ERR_SUBSCRIBE_REQUEST_INVALID = 2021] = "ERR_SUBSCRIBE_REQUEST_INVALID", e[e.ERR_NOT_SUPPORTED_MESSAGE = 2022] = "ERR_NOT_SUPPORTED_MESSAGE", e[e.ERR_ILLEAGAL_PLUGIN = 2023] = "ERR_ILLEAGAL_PLUGIN", e[e.ERR_REJOIN_TOKEN_INVALID = 2024] = "ERR_REJOIN_TOKEN_INVALID", e[e.ERR_REJOIN_USER_NOT_JOINED = 2025] = "ERR_REJOIN_USER_NOT_JOINED", e[e.ERR_INVALID_OPTIONAL_INFO = 2027] = "ERR_INVALID_OPTIONAL_INFO", e[e.ILLEGAL_AES_PASSWORD = 2028] = "ILLEGAL_AES_PASSWORD", e[e.ILLEGAL_CLIENT_ROLE_LEVEL = 2029] = "ILLEGAL_CLIENT_ROLE_LEVEL", e[e.ERR_TOO_MANY_BROADCASTERS = 2031] = "ERR_TOO_MANY_BROADCASTERS", e[e.ERR_TOO_MANY_SUBSCRIBERS = 2032] = "ERR_TOO_MANY_SUBSCRIBERS", e[e.ERR_LICENSE_MISSING = 32769] = "ERR_LICENSE_MISSING", e[e.ERR_LICENSE_EXPIRED = 32771] = "ERR_LICENSE_EXPIRED", e[e.ERR_LICENSE_MINUTES_EXCEEDED = 32773] = "ERR_LICENSE_MINUTES_EXCEEDED", e[e.ERR_LICENSE_PERIOD_INVALID = 32774] = "ERR_LICENSE_PERIOD_INVALID", e[e.ERR_LICENSE_MULTIPLE_SDK_SERVICE = 32778] = "ERR_LICENSE_MULTIPLE_SDK_SERVICE", e[e.ERR_LICENSE_ILLEGAL = 32783] = "ERR_LICENSE_ILLEGAL", e[e.ERR_TEST_RECOVER = 9e3] = "ERR_TEST_RECOVER", e[e.ERR_TEST_TRYNEXT = 9001] = "ERR_TEST_TRYNEXT", e[e.ERR_TEST_RETRY = 9002] = "ERR_TEST_RETRY", e;
    }({}), Vr = function(e) {
      return e.CONNECTING = "connecting", e.CONNECTED = "connected", e.RECONNECTING = "reconnecting", e.CLOSED = "closed", e;
    }({}), jn = function(e) {
      return e.WS_CONNECTED = "ws_connected", e.WS_RECONNECTING = "ws_reconnecting", e.WS_CLOSED = "ws_closed", e.WS_RECONNECT_CREATE_CONNECTION = "ws_reconnect_create_connection", e.ON_BINARY_DATA = "on_binary_data", e.REQUEST_RECOVER = "request_recover", e.REQUEST_JOIN_INFO = "request_join_info", e.REQUEST_REJOIN_INFO = "req_rejoin_info", e.IS_P2P_DISCONNECTED = "is_p2p_dis", e.DISCONNECT_P2P = "dis_p2p", e.ABORT_P2P_EXECUTION = "abort_p2p_execution", e.NEED_RENEW_SESSION = "need-sid", e.REPORT_JOIN_GATEWAY = "report_join_gateway", e.REQUEST_TIMEOUT = "request_timeout", e.REQUEST_SUCCESS = "request_success", e.JOIN_RESPONSE = "join_response", e.PRE_CONNECT_PC = "pre_connect_pc", e.P2P_CONNECTION = "p2p_connection", e.P2P_REMOTE_CANDIDATE_UPDATE = "p2p_remote_candidate_update", e.P2P_SUBSCRIBE = "p2p_subscribe", e.P2P_UNSUBSCRIBE = "p2p_unsubscribe", e.P2P_EXCHANGE_SDP = "p2p_exchange_sdp", e.P2P_ON_ADD_VIDEO_STREAM = "p2p_on_add_video_stream", e.P2P_ON_ADD_AUDIO_STREAM = "p2p_on_add_audio_stream", e.RECOVER_NOTIFICATION = "recover_notification", e;
    }({}), kn = function(e) {
      return e.PING = "ping", e.PING_BACK = "ping_back", e.JOIN = "join_v3", e.REJOIN = "rejoin_v3", e.LEAVE = "leave", e.SET_CLIENT_ROLE = "set_client_role", e.PUBLISH = "publish", e.PUBLISH_DATASTREAM = "publish_datastream", e.UNPUBLISH = "unpublish", e.UNPUBLISH_DATASTREAM = "unpublish_datastream", e.SUBSCRIBE = "subscribe", e.PRE_SUBSCRIBE = "pre_subscribe", e.SUBSCRIBE_DATASTREAM = "subscribe_datastream", e.SUBSCRIBE_STREAMS = "subscribe_streams", e.UNSUBSCRIBE = "unsubscribe", e.UNSUBSCRIBE_DATASTREAM = "unsubscribe_datastream", e.UNSUBSCRIBE_STREAMS = "unsubscribe_streams", e.SUBSCRIBE_CHANGE = "subscribe_change", e.TRAFFIC_STATS = "traffic_stats", e.RENEW_TOKEN = "renew_token", e.SWITCH_VIDEO_STREAM = "switch_video_stream", e.DEFAULT_VIDEO_STREAM = "default_video_stream", e.SET_FALLBACK_OPTION = "set_fallback_option", e.GATEWAY_INFO = "gateway_info", e.CONTROL = "control", e.SEND_METADATA = "send_metadata", e.DATA_STREAM = "data_stream", e.PICK_SVC_LAYER = "pick_svc_layer", e.RESTART_ICE = "restart_ice", e.CONNECT_PC = "connect_pc", e.SET_VIDEO_PROFILE = "set_video_profile", e.SET_PARAMETER = "set_parameter", e.SET_RTM2_FLAG = "set_rtm2_flag", e;
    }({}), kE = function(e) {
      return e.WRTC_STATS = "wrtc_stats", e.WS_INFLATE_DATA_LENGTH = "ws_inflate_data_length", e.DENOISER_STATS = "denoiser_stats", e.EXTENSION_USAGE_STATS = "extension_usage_stats", e;
    }({}), nr = function(e) {
      return e.ON_USER_ONLINE = "on_user_online", e.ON_USER_OFFLINE = "on_user_offline", e.ON_STREAM_FALLBACK_UPDATE = "on_stream_fallback_update", e.ON_PUBLISH_STREAM = "on_publish_stream", e.ON_UPLINK_STATS = "on_uplink_stats", e.ON_P2P_LOST = "on_p2p_lost", e.ON_REMOVE_STREAM = "on_remove_stream", e.ON_ADD_AUDIO_STREAM = "on_add_audio_stream", e.ON_ADD_VIDEO_STREAM = "on_add_video_stream", e.ON_TOKEN_PRIVILEGE_WILL_EXPIRE = "on_token_privilege_will_expire", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "on_token_privilege_did_expire", e.ON_USER_BANNED = "on_user_banned", e.ON_USER_LICENSE_BANNED = "on_user_license_banned", e.ON_NOTIFICATION = "on_notification", e.ON_CRYPT_ERROR = "on_crypt_error", e.MUTE_AUDIO = "mute_audio", e.MUTE_VIDEO = "mute_video", e.UNMUTE_AUDIO = "unmute_audio", e.UNMUTE_VIDEO = "unmute_video", e.ON_P2P_OK = "on_p2p_ok", e.RECEIVE_METADATA = "receive_metadata", e.ON_DATA_STREAM = "on_data_stream", e.ON_RTP_CAPABILITY_CHANGE = "on_rtp_capability_change", e.ON_REMOTE_DATASTREAM_UPDATE = "on_remote_datastream_update", e.ON_REMOTE_FULL_DATASTREAM_INFO = "on_remote_full_datastream_info", e.ENABLE_LOCAL_VIDEO = "enable_local_video", e.DISABLE_LOCAL_VIDEO = "disable_local_video", e.ENABLE_LOCAL_AUDIO = "enable_local_audio", e.DISABLE_LOCAL_AUDIO = "disable_local_audio", e.ON_PUBLISHED_USER_LIST = "on_published_user_list", e;
    }({}), ia = function(e) {
      return e.SEND_ONLY = "SEND_ONLY", e.RECEIVE_ONLY = "RECEIVE_ONLY", e;
    }({}), Fn = function(e) {
      return e.CONNECTED = "websocket:connected", e.RECONNECTING = "websocket:reconnecting", e.WILL_RECONNECT = "websocket:will_reconnect", e.CLOSED = "websocket:closed", e.FAILED = "websocket:failed", e.ON_MESSAGE = "websocket:on_message", e.REQUEST_NEW_URLS = "websocket:request_new_urls", e.RECONNECT_CREATE_CONNECTION = "websocket:reconnect_create_connection", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "websocket:on_token_privilege_did_expire", e;
    }({});
    function wT(e) {
      if (typeof e != "string" || !/^[a-zA-Z0-9 \!\#\$\%\&\(\)\+\-\:\;\<\=\.\>\?\@\[\]\^\_\{\}\|\~\,]{1,64}$/.test(e)) throw Ee.error("Invalid Channel Name ".concat(e)), new jt(Je.INVALID_PARAMS, "The length must be within 64 bytes. The supported characters: a-z,A-Z,0-9,space,!, #, $, %, &, (, ), +, -, :, ;, <, =, ., >, ?, @, [, ], ^, _,  {, }, |, ~, ,");
    }
    function _T(e) {
      if (n = e, !(typeof n == "number" && Math.floor(n) === n && 0 <= n && n <= 4294967295 || QM(e, 1, 255))) throw new jt(Je.INVALID_PARAMS, "[String uid] Length of the string: [1,255]. ASCII characters only. [Number uid] The value range is [0,10000]");
      var n;
      typeof e == "string" && Ee.warn("You input a string as the user ID, to ensure better end-user experience, Agora highly suggests not using a string as the user ID.");
    }
    let fd = function(e) {
      return e.TRANSCODE = "mix_streaming", e.RAW = "raw_streaming", e;
    }({});
    const $se = { alpha: 1, height: 640, width: 360, x: 0, y: 0, zOrder: 0, audioChannel: 0 }, gI = { x: 0, y: 0, width: 160, height: 160, zOrder: 255, alpha: 1 };
    function mI(e, n) {
      ms(e.url, "".concat(n, ".url"), 1, 1e3, !1), ri(e.x) || xr(e.x, "".concat(n, ".x"), 0, 1e4), ri(e.y) || xr(e.y, "".concat(n, ".y"), 0, 1e4), ri(e.width) || xr(e.width, "".concat(n, ".width"), 0, 1e4), ri(e.height) || xr(e.height, "".concat(n, ".height"), 0, 1e4), ri(e.zOrder) || xr(e.zOrder, "".concat(n, ".zOrder"), 0, 255), ri(e.alpha) || xr(e.alpha, "".concat(n, ".alpha"), 0, 1, !1);
    }
    const eae = { audioBitrate: 48, audioChannels: 1, audioSampleRate: 48e3, backgroundColor: 0, height: 360, lowLatency: !1, videoBitrate: 400, videoCodecProfile: 100, videoCodecType: 1, videoFrameRate: 15, videoGop: 30, width: 640, images: [], userConfigs: [], userConfigExtraInfo: "" };
    let rl = function(e) {
      return e.WARNING = "@live_uap-warning", e.ERROR = "@line_uap-error", e.PUBLISH_STREAM_STATUS = "@live_uap-publish-status", e.WORKER_STATUS = "@live_uap-worker-status", e.REQUEST_NEW_ADDRESS = "@live_uap-request-address", e;
    }({}), EI = function(e) {
      return e.REQUEST_WORKER_MANAGER_LIST = "@live_req_worker_manager", e;
    }({}), Wi = function(e) {
      return e[e.LIVE_STREAM_RESPONSE_SUCCEED = 200] = "LIVE_STREAM_RESPONSE_SUCCEED", e[e.LIVE_STREAM_RESPONSE_ALREADY_EXISTS_STREAM = 454] = "LIVE_STREAM_RESPONSE_ALREADY_EXISTS_STREAM", e[e.LIVE_STREAM_RESPONSE_TRANSCODING_PARAMETER_ERROR = 450] = "LIVE_STREAM_RESPONSE_TRANSCODING_PARAMETER_ERROR", e[e.LIVE_STREAM_RESPONSE_BAD_STREAM = 451] = "LIVE_STREAM_RESPONSE_BAD_STREAM", e[e.LIVE_STREAM_RESPONSE_WM_PARAMETER_ERROR = 400] = "LIVE_STREAM_RESPONSE_WM_PARAMETER_ERROR", e[e.LIVE_STREAM_RESPONSE_WM_WORKER_NOT_EXIST = 404] = "LIVE_STREAM_RESPONSE_WM_WORKER_NOT_EXIST", e[e.LIVE_STREAM_RESPONSE_NOT_AUTHORIZED = 456] = "LIVE_STREAM_RESPONSE_NOT_AUTHORIZED", e[e.LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE = 457] = "LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE", e[e.LIVE_STREAM_RESPONSE_REQUEST_TOO_OFTEN = 429] = "LIVE_STREAM_RESPONSE_REQUEST_TOO_OFTEN", e[e.LIVE_STREAM_RESPONSE_NOT_FOUND_PUBLISH = 452] = "LIVE_STREAM_RESPONSE_NOT_FOUND_PUBLISH", e[e.LIVE_STREAM_RESPONSE_NOT_SUPPORTED = 453] = "LIVE_STREAM_RESPONSE_NOT_SUPPORTED", e[e.LIVE_STREAM_RESPONSE_MAX_STREAM_NUM = 455] = "LIVE_STREAM_RESPONSE_MAX_STREAM_NUM", e[e.LIVE_STREAM_RESPONSE_INTERNAL_SERVER_ERROR = 500] = "LIVE_STREAM_RESPONSE_INTERNAL_SERVER_ERROR", e[e.LIVE_STREAM_RESPONSE_WORKER_LOST = 501] = "LIVE_STREAM_RESPONSE_WORKER_LOST", e[e.LIVE_STREAM_RESPONSE_RESOURCE_LIMIT = 502] = "LIVE_STREAM_RESPONSE_RESOURCE_LIMIT", e[e.LIVE_STREAM_RESPONSE_WORKER_QUIT = 503] = "LIVE_STREAM_RESPONSE_WORKER_QUIT", e[e.ERROR_FAIL_SEND_MESSAGE = 504] = "ERROR_FAIL_SEND_MESSAGE", e[e.PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE = 30] = "PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE", e[e.PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT = 31] = "PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT", e[e.PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH = 32] = "PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH", e[e.PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN = 33] = "PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN", e;
    }({});
    function H8(e) {
      if (!e.channelName) throw new jt(Je.INVALID_PARAMS, "invalid channelName in info");
      if (typeof e.uid != "number") throw new jt(Je.INVALID_PARAMS, "invalid uid in info, uid must be a number");
      return e.token && ms(e.token, "info.token", 1, 2047), _T(e.uid), wT(e.channelName), !0;
    }
    let sa = function(e) {
      return e[e.SetSdkProfile = 0] = "SetSdkProfile", e[e.SetSourceChannel = 1] = "SetSourceChannel", e[e.SetSourceUserId = 2] = "SetSourceUserId", e[e.SetDestChannel = 3] = "SetDestChannel", e[e.StartPacketTransfer = 4] = "StartPacketTransfer", e[e.StopPacketTransfer = 5] = "StopPacketTransfer", e[e.UpdateDestChannel = 6] = "UpdateDestChannel", e[e.Reconnect = 7] = "Reconnect", e[e.SetVideoProfile = 8] = "SetVideoProfile", e;
    }({}), hd = function(e) {
      return e.NETWORK_DISCONNECTED = "NETWORK_DISCONNECTED", e.NETWORK_CONNECTED = "NETWORK_CONNECTED", e.PACKET_JOINED_SRC_CHANNEL = "PACKET_JOINED_SRC_CHANNEL", e.PACKET_JOINED_DEST_CHANNEL = "PACKET_JOINED_DEST_CHANNEL", e.PACKET_SENT_TO_DEST_CHANNEL = "PACKET_SENT_TO_DEST_CHANNEL", e.PACKET_RECEIVED_VIDEO_FROM_SRC = "PACKET_RECEIVED_VIDEO_FROM_SRC", e.PACKET_RECEIVED_AUDIO_FROM_SRC = "PACKET_RECEIVED_AUDIO_FROM_SRC", e.PACKET_UPDATE_DEST_CHANNEL = "PACKET_UPDATE_DEST_CHANNEL", e.PACKET_UPDATE_DEST_CHANNEL_REFUSED = "PACKET_UPDATE_DEST_CHANNEL_REFUSED", e.PACKET_UPDATE_DEST_CHANNEL_NOT_CHANGE = "PACKET_UPDATE_DEST_CHANNEL_NOT_CHANGE", e;
    }({}), Sa = function(e) {
      return e.RELAY_STATE_IDLE = "RELAY_STATE_IDLE", e.RELAY_STATE_CONNECTING = "RELAY_STATE_CONNECTING", e.RELAY_STATE_RUNNING = "RELAY_STATE_RUNNING", e.RELAY_STATE_FAILURE = "RELAY_STATE_FAILURE", e;
    }({}), yp = function(e) {
      return e.RELAY_OK = "RELAY_OK", e.SERVER_CONNECTION_LOST = "SERVER_CONNECTION_LOST", e.SRC_TOKEN_EXPIRED = "SRC_TOKEN_EXPIRED", e.DEST_TOKEN_EXPIRED = "DEST_TOKEN_EXPIRED", e;
    }({}), Sr = function(e) {
      return e.High = "high", e.Low = "low", e.Audio = "audio", e.Screen = "screen", e.ScreenLow = "screen_low", e;
    }({}), Ns = function(e) {
      return e.DISCONNECT = "disconnect", e.CONNECTION_STATE_CHANGE = "connection-state-change", e.NETWORK_QUALITY = "network-quality", e.STREAM_TYPE_CHANGE = "stream-type-change", e.IS_P2P_DISCONNECTED = "is-p2p-dis", e.DISCONNECT_P2P = "dis-p2p", e.REQUEST_NEW_GATEWAY_LIST = "req-gate-url", e.NEED_RENEW_SESSION = "need-sid", e.REQUEST_P2P_CONNECTION_PARAMS = "request-p2p-connection-params", e.JOIN_RESPONSE = "join-response", e.RESET_CONNECTION_EVENTS = "reset-connection-events", e.PRE_CONNECT_PC = "pre-connect_pc", e;
    }({}), PT = function(e) {
      return e.P2P_DISCONNECTED = "P2P_DISCONNECTED", e.A_ROUND_WS_FAILED = "A_ROUND_WS_FAILED", e.TIMEOUT = "TIMEOUT", e.UNKNOWN_REASON = "UNKNOWN_REASON", e;
    }({}), ns = function(e) {
      return e[e.Nothing = 0] = "Nothing", e[e.Audio = 1] = "Audio", e[e.LwoVideo = 2] = "LwoVideo", e[e.Video = 4] = "Video", e[e.Data = 8] = "Data", e[e.DataStream0 = 256] = "DataStream0", e[e.DataStream1 = 512] = "DataStream1", e[e.DataStream2 = 1024] = "DataStream2", e[e.DataStream3 = 2048] = "DataStream3", e[e.DataStream4 = 4096] = "DataStream4", e[e.DataStream5 = 8192] = "DataStream5", e[e.DataStream6 = 16384] = "DataStream6", e[e.DataStream7 = 32768] = "DataStream7", e;
    }({}), vr = function(e) {
      return e.CHINA = "CHINA", e.ASIA = "ASIA", e.NORTH_AMERICA = "NORTH_AMERICA", e.EUROPE = "EUROPE", e.JAPAN = "JAPAN", e.INDIA = "INDIA", e.KOREA = "KOREA", e.HKMC = "HKMC", e.US = "US", e.OCEANIA = "OCEANIA", e.SOUTH_AMERICA = "SOUTH_AMERICA", e.AFRICA = "AFRICA", e.OVERSEA = "OVERSEA", e.GLOBAL = "GLOBAL", e.EXTENSIONS = "EXTENSIONS", e;
    }({});
    const B8 = [vr.AFRICA, vr.ASIA, vr.CHINA, vr.EUROPE, vr.GLOBAL, vr.INDIA, vr.JAPAN, vr.NORTH_AMERICA, vr.OCEANIA, vr.OVERSEA, vr.SOUTH_AMERICA];
    let Ds = function(e) {
      return e.CHINA = "CN", e.ASIA = "AS", e.NORTH_AMERICA = "NA", e.EUROPE = "EU", e.JAPAN = "JP", e.INDIA = "IN", e.KOREA = "KR", e.HKMC = "HK", e.US = "US", e.OCEANIA = "OC", e.SOUTH_AMERICA = "SA", e.AFRICA = "AF", e.OVERSEA = "OVERSEA", e.GLOBAL = "GLOBAL", e.EXTENSIONS = "GLOBAL", e;
    }({});
    const xT = { CHINA: {}, ASIA: { CODE: Ds.ASIA, WEBCS_DOMAIN: ["ap-web-1-asia.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-asia.agora.io"], PROXY_CS: ["proxy-ap-web-asia.agora.io"], CDS_AP: ["cds-ap-web-asia.agora.io", "cds-ap-web-asia2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-asia.agora.io", "sua-ap-web-asia2.agora.io"], UAP_AP: ["uap-ap-web-asia.agora.io", "uap-ap-web-asia2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-asia.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-asia.agora.io"], LOG_UPLOAD_SERVER: ["logservice-asia.agora.io"], PROXY_SERVER_TYPE3: ["southeast-asia.webrtc-cloud-proxy.sd-rtn.com"] }, NORTH_AMERICA: { CODE: Ds.NORTH_AMERICA, WEBCS_DOMAIN: ["ap-web-1-north-america.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-north-america.agora.io"], PROXY_CS: ["proxy-ap-web-america.agora.io"], CDS_AP: ["cds-ap-web-america.agora.io", "cds-ap-web-america2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-america.agora.io", "sua-ap-web-america2.agora.io"], UAP_AP: ["uap-ap-web-america.agora.io", "uap-ap-web-america2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-north-america.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-north-america.agora.io"], LOG_UPLOAD_SERVER: ["logservice-north-america.agora.io"], PROXY_SERVER_TYPE3: ["east-usa.webrtc-cloud-proxy.sd-rtn.com"] }, EUROPE: { CODE: Ds.EUROPE, WEBCS_DOMAIN: ["ap-web-1-europe.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-europe.agora.io"], PROXY_CS: ["proxy-ap-web-europe.agora.io"], CDS_AP: ["cds-ap-web-europe.agora.io", "cds-ap-web-europe2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-europe.agora.io", "sua-ap-web-europe.agora.io"], UAP_AP: ["uap-ap-web-europe.agora.io", "uap-ap-web-europe2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-europe.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-europe.agora.io"], LOG_UPLOAD_SERVER: ["logservice-europe.agora.io"], PROXY_SERVER_TYPE3: ["europe.webrtc-cloud-proxy.sd-rtn.com"] }, JAPAN: { CODE: Ds.JAPAN, WEBCS_DOMAIN: ["ap-web-1-japan.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-japan.agora.io"], PROXY_CS: ["proxy-ap-web-japan.agora.io"], CDS_AP: ["cds-ap-web-japan.agora.io", "cds-ap-web-japan2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-japan.agora.io", "sua-ap-web-japan2.agora.io"], UAP_AP: ["uap-ap-web-japan.agora.io", "uap-ap-web-japan2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-japan.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-japan.agora.io"], LOG_UPLOAD_SERVER: ["logservice-japan.agora.io"], PROXY_SERVER_TYPE3: ["japan.webrtc-cloud-proxy.sd-rtn.com"] }, INDIA: { CODE: Ds.INDIA, WEBCS_DOMAIN: ["ap-web-1-india.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-india.agora.io"], PROXY_CS: ["proxy-ap-web-india.agora.io"], CDS_AP: ["cds-ap-web-india.agora.io", "cds-ap-web-india2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-india.agora.io", "sua-ap-web-india2.agora.io"], UAP_AP: ["uap-ap-web-india.agora.io", "uap-ap-web-india2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-india.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-india.agora.io"], LOG_UPLOAD_SERVER: ["logservice-india.agora.io"], PROXY_SERVER_TYPE3: ["india.webrtc-cloud-proxy.sd-rtn.com"] }, KOREA: { CODE: Ds.KOREA, WEBCS_DOMAIN: ["ap-web-1-korea.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-korea.agora.io"], PROXY_CS: ["proxy-ap-web-korea.agora.io"], CDS_AP: ["cds-ap-web-korea.agora.io", "cds-ap-web-korea2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-korea.agora.io", "sua-ap-web-korea2.agora.io"], UAP_AP: ["uap-ap-web-korea.agora.io", "uap-ap-web-korea2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-korea.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-korea.agora.io"], LOG_UPLOAD_SERVER: ["logservice-korea.agora.io"], PROXY_SERVER_TYPE3: ["korea.webrtc-cloud-proxy.sd-rtn.com"] }, HKMC: { CODE: Ds.HKMC, WEBCS_DOMAIN: ["ap-web-1-hkmc.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-hkmc.agora.io"], PROXY_CS: ["proxy-ap-web-hkmc.agora.io"], CDS_AP: ["cds-ap-web-hkmc.agora.io", "cds-ap-web-hkmc2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-hkmc.agora.io", "sua-ap-web-hkmc2.agora.io"], UAP_AP: ["uap-ap-web-hkmc.agora.io", "uap-ap-web-hkmc2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-hkmc.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-hkmc.agora.io"], LOG_UPLOAD_SERVER: ["logservice-hkmc.agora.io"], PROXY_SERVER_TYPE3: ["hkmc.webrtc-cloud-proxy.sd-rtn.com"] }, US: { CODE: Ds.US, WEBCS_DOMAIN: ["ap-web-1-us.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-us.agora.io"], PROXY_CS: ["proxy-ap-web-us.agora.io"], CDS_AP: ["cds-ap-web-us.agora.io", "cds-ap-web-us2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-us.agora.io", "sua-ap-web-us2.agora.io"], UAP_AP: ["uap-ap-web-us.agora.io", "uap-ap-web-us2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-us.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-us.agora.io"], LOG_UPLOAD_SERVER: ["logservice-us.agora.io"], PROXY_SERVER_TYPE3: ["us.webrtc-cloud-proxy.sd-rtn.com"] }, OVERSEA: { CODE: Ds.OVERSEA, WEBCS_DOMAIN: ["ap-web-1-oversea.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-oversea.agora.io"], PROXY_CS: ["proxy-ap-web-oversea.agora.io"], CDS_AP: ["cds-ap-web-oversea.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-oversea.agora.io"], UAP_AP: ["uap-ap-web-oversea.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-oversea.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-oversea.agora.io"], LOG_UPLOAD_SERVER: ["logservice-oversea.agora.io"], PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy.agora.io"] }, GLOBAL: { CODE: Ds.GLOBAL, WEBCS_DOMAIN: ["webrtc2-ap-web-1.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["webrtc2-ap-web-3.agora.io"], PROXY_CS: ["ap-proxy-1.agora.io", "ap-proxy-2.agora.io"], CDS_AP: ["cds-ap-web-1.agora.io", "cds-ap-web-3.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-1.agora.io", "sua-ap-web-3.agora.io"], UAP_AP: ["uap-ap-web-1.agora.io", "uap-ap-web-3.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2.agora.io"], LOG_UPLOAD_SERVER: ["logservice.agora.io"], PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy.sd-rtn.com"] }, OCEANIA: { CODE: Ds.OCEANIA, WEBCS_DOMAIN: ["ap-web-1-oceania.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-oceania.agora.io"], PROXY_CS: ["proxy-ap-web-oceania.agora.io"], CDS_AP: ["cds-ap-web-oceania.agora.io", "cds-ap-web-oceania2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-oceania.agora.io", "sua-ap-web-oceania2.agora.io"], UAP_AP: ["uap-ap-web-oceania.agora.io", "uap-ap-web-oceania2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-oceania.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-oceania.agora.io"], LOG_UPLOAD_SERVER: ["logservice-oceania.agora.io"], PROXY_SERVER_TYPE3: ["oceania.webrtc-cloud-proxy.sd-rtn.com"] }, SOUTH_AMERICA: { CODE: Ds.SOUTH_AMERICA, WEBCS_DOMAIN: ["ap-web-1-south-america.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-south-america.agora.io"], PROXY_CS: ["proxy-ap-web-south-america.agora.io"], CDS_AP: ["cds-ap-web-south-america.agora.io", "cds-ap-web-south-america2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-south-america.agora.io", "sua-ap-web-south-america2.agora.io"], UAP_AP: ["uap-ap-web-south-america.agora.io", "uap-ap-web-south-america2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-south-america.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-south-america.agora.io"], LOG_UPLOAD_SERVER: ["logservice-south-america.agora.io"], PROXY_SERVER_TYPE3: ["south-america.webrtc-cloud-proxy.sd-rtn.com"] }, AFRICA: { CODE: Ds.AFRICA, WEBCS_DOMAIN: ["ap-web-1-africa.agora.io"], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-africa.agora.io"], PROXY_CS: ["proxy-ap-web-africa.agora.io"], CDS_AP: ["cds-ap-web-africa.agora.io", "cds-ap-web-africa2.agora.io"], ACCOUNT_REGISTER: ["sua-ap-web-africa.agora.io", "sua-ap-web-africa2.agora.io"], UAP_AP: ["uap-ap-web-africa.agora.io", "uap-ap-web-africa2.agora.io"], EVENT_REPORT_DOMAIN: ["statscollector-1-africa.agora.io"], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-africa.agora.io"], LOG_UPLOAD_SERVER: ["logservice-south-africa.agora.io"], PROXY_SERVER_TYPE3: ["africa.webrtc-cloud-proxy.sd-rtn.com"] }, EXTENSIONS: {} };
    XS && (xT.CHINA = { CODE: Ds.CHINA, WEBCS_DOMAIN: ["webrtc2-2.ap.sd-rtn.com"], WEBCS_DOMAIN_BACKUP_LIST: ["webrtc2-4.ap.sd-rtn.com"], PROXY_CS: ["proxy-web.ap.sd-rtn.com"], CDS_AP: ["cds-web-2.ap.sd-rtn.com", "cds-web-4.ap.sd-rtn.com"], ACCOUNT_REGISTER: ["sua-web-2.ap.sd-rtn.com", "sua-web-4.ap.sd-rtn.com"], UAP_AP: ["uap-web-2.ap.sd-rtn.com", "uap-web-4.ap.sd-rtn.com"], EVENT_REPORT_DOMAIN: ["web-3.statscollector.sd-rtn.com"], EVENT_REPORT_BACKUP_DOMAIN: ["web-4.statscollector.sd-rtn.com"], LOG_UPLOAD_SERVER: ["logservice-china.agora.io"], PROXY_SERVER_TYPE3: ["east-cn.webrtc-cloud-proxy.sd-rtn.com"] });
    let jE = function(e) {
      return e.UPDATE_BITRATE_LIMIT = "update_bitrate_limit", e.UPDATE_CLIENT_ROLE_OPTIONS = "update_client_role_options", e;
    }({});
    function z8(e) {
      return !!e && !(!e.uplink || !e.id) && e.uplink.max_bitrate !== void 0 && e.uplink.min_bitrate !== void 0;
    }
    class F8 extends ii {
      constructor(n, i) {
        super(), Ve(this, "onICEConnectionStateChange", void 0), Ve(this, "onConnectionStateChange", void 0), Ve(this, "onDTLSTransportStateChange", void 0), Ve(this, "onDTLSTransportError", void 0), Ve(this, "onICETransportStateChange", void 0), Ve(this, "onFirstAudioReceived", void 0), Ve(this, "onFirstVideoReceived", void 0), Ve(this, "onFirstAudioDecoded", void 0), Ve(this, "onFirstVideoDecoded", void 0), Ve(this, "onFirstVideoDecodedTimeout", void 0), Ve(this, "onSelectedLocalCandidateChanged", void 0), Ve(this, "onSelectedRemoteCandidateChanged", void 0), Ve(this, "onICECandidateError", void 0), Ve(this, "getLocalVideoStats", void 0);
      }
    }
    class G8 extends F8 {
      constructor(n, i) {
        super(n, i), Ve(this, "establishPromise", void 0);
      }
    }
    let vn = function(e) {
      return e.VIDEO = "video", e.AUDIO = "audio", e;
    }({}), Hs = function(e) {
      return e.UDP_RELAY = "udp_relay", e.UDP_TCP_RELAY = "udp_tcp_relay", e.TCP_RELAY = "tcp_relay", e.RELAY = "relay", e;
    }({}), pd = function(e) {
      return e[e.FIRST_CONNECTION = 0] = "FIRST_CONNECTION", e[e.UDP_TCP_RESTART = 1] = "UDP_TCP_RESTART", e[e.RELAY_RESTART = 2] = "RELAY_RESTART", e[e.TCP_RESTART = 3] = "TCP_RESTART", e[e.OLD_FIRST_CONNECTION = 10] = "OLD_FIRST_CONNECTION", e[e.OLD_RESTART = 11] = "OLD_RESTART", e[e.DISCONNECTED_OR_FAILED = 20] = "DISCONNECTED_OR_FAILED", e;
    }({});
    const V8 = ["disconnected", "failed"];
    let Qt = function(e) {
      return e.LocalVideoTrack = "videoTrack", e.LocalAudioTrack = "audioTrack", e.LocalVideoLowTrack = "videoLowTrack", e;
    }({}), Ir = function(e) {
      return e.New = "new", e.Connected = "connected", e.Reconnecting = "reconnecting", e.Disconnected = "disconnected", e;
    }({}), wn = function(e) {
      return e.StateChange = "stateChange", e.IceConnectionStateChange = "iceConnectionStateChange", e.RequestMuteLocal = "requestMuteLocal", e.RequestUnmuteLocal = "requestUnmuteLocal", e.RequestRePublish = "requestRePublish", e.RequestRePublishDataChannel = "requestRePublishDataChannel", e.RequestReSubscribe = "requestReSubscribe", e.RequestUploadStats = "requestUploadStats", e.RequestUpload = "requestUpload", e.MediaReconnectStart = "MediaReconnectStart", e.MediaReconnectEnd = "MediaReconnectEnd", e.NeedSignalRTT = "NeedSignalRTT", e.RequestRestartICE = "RequestRestartIce", e.PeerConnectionStateChange = "PeerConnectionStateChange", e.RequestReconnect = "RequestReconnect", e.RequestReconnectPC = "RequestReconnectPC", e.RequestUnpublishForReconnectPC = "RequestUnpublishForReconnectPC", e.P2PLost = "P2PLost", e.UpdateVideoEncoder = "UpdateVideoEncoder", e.ConnectionTypeChange = "ConnectionTypeChange", e.RequestLowStreamParameter = "RequestLowStreamParameter", e.QueryClientConnectionState = "QueryClientConnectionState", e.LocalCandidate = "LocalCandidate", e.RequestP2PMuteLocal = "requestP2PMuteLocal", e.RequestP2PUnPublish = "RequestP2PUnPublish", e.RequestP2PUnmuteRemote = "RequestP2PUnmuteRemote", e.RequestP2PMuteRemote = "RequestP2PMuteRemote", e.RequestP2PRestartICE = "RequestP2PRestartICE", e;
    }({}), oc = function(e) {
      return e.CONNECTING = "CONNECTING", e.RECONNECTING = "RECONNECTING", e.CONNECTED = "CONNECTED", e.CLOSED = "CLOSED", e;
    }({}), cc = function(e) {
      return e[e.CONNECT_AP = 0] = "CONNECT_AP", e[e.AP_CONNECTED = 1] = "AP_CONNECTED", e[e.CONNECT_WORKER_MANAGER = 2] = "CONNECT_WORKER_MANAGER", e[e.WORKER_MANAGER_CONNECTED = 3] = "WORKER_MANAGER_CONNECTED", e[e.GET_WORKER_MANAGER_RESPONSE = 4] = "GET_WORKER_MANAGER_RESPONSE", e[e.CONNECT_WORKER = 5] = "CONNECT_WORKER", e[e.WORKER_CONNECTED = 6] = "WORKER_CONNECTED", e[e.CLOSED = 7] = "CLOSED", e;
    }({}), ds = function(e) {
      return e.CONNECTION_STATE_CHANGE = "connection-state-change", e.STATE_CHANGE = "state-change", e.INSPECT_RESULT = "inspect-result", e.CLIENT_LOCAL_VIDEO_TRACK = "client-local-video-track", e.REQUEST_NEW_WORKER_URL = "request-new-worker-url", e;
    }({}), Y8 = function(e) {
      return e.CONNECTED = "transmitter:connected", e.RECONNECTING = "transmitter:reconnecting", e.WILL_RECONNECT = "transmitter:will_reconnect", e.CLOSED = "transmitter:closed", e.FAILED = "transmitter:failed", e.ON_MESSAGE = "transmitter:on_message", e.REQUEST_NEW_URLS = "transmitter:request_new_urls", e.RECONNECT_CREATE_CONNECTION = "transmitter:reconnect_create_connection", e.ON_TOKEN_PRIVILEGE_DID_EXPIRE = "transmitter:on_token_privilege_did_expire", e.TO_CONNECT_DATACHANNEL = "transmitter:to_connect_datachannel", e.FAILBACK = "transmitter:failback", e.PRE_CONNECT_PC = "transmitter:pre_connect_pc", e;
    }({}), bu = function(e) {
      return e.CAMERA_CHANGED = "camera-changed", e.MICROPHONE_CHANGED = "microphone-changed", e.PLAYBACK_DEVICE_CHANGED = "playback-device-changed", e.AUDIO_AUTOPLAY_FAILED = "audio-autoplay-failed", e.AUTOPLAY_FAILED = "autoplay-failed", e.AUDIO_CONTEXT_STATE_CHANGED = "audio-context-state-changed", e.SECURITY_POLICY_VIOLATION = "security-policy-violation", e;
    }({}), _o = function(e) {
      return e.CONNECTING = "CONNECTING", e.RECONNECTING = "RECONNECTING", e.CONNECTED = "CONNECTED", e.CLOSED = "CLOSED", e;
    }({}), Uc = function(e) {
      return e.CONNECTION_STATE_CHANGE = "connection-state-change", e.STATE_CHANGE = "state-change", e.INSPECT_RESULT = "inspect-result", e.CLIENT_LOCAL_VIDEO_TRACK = "client-local-video-track", e.REQUEST_NEW_WORKER_URL = "request-new-worker-url", e;
    }({}), vp = function(e) {
      return e[e.CONNECT_AP = 0] = "CONNECT_AP", e[e.AP_CONNECTED = 1] = "AP_CONNECTED", e[e.CONNECT_WORKER_MANAGER = 2] = "CONNECT_WORKER_MANAGER", e[e.WORKER_MANAGER_CONNECTED = 3] = "WORKER_MANAGER_CONNECTED", e[e.GET_WORKER_MANAGER_RESPONSE = 4] = "GET_WORKER_MANAGER_RESPONSE", e[e.CONNECT_WORKER = 5] = "CONNECT_WORKER", e[e.WORKER_CONNECTED = 6] = "WORKER_CONNECTED", e[e.CLOSED = 7] = "CLOSED", e;
    }({}), bi = function(e) {
      return e.CALL = "call", e.CANDIDATE = "candidate", e.PUBLISH = "publish", e.UNPUBLISH = "unpublish", e.CONTROL = "control", e.RESTART_ICE = "restart_ice", e.ACK = "ack", e.RESPONSE = "response", e.JOIN = "join", e.CHECK = "check", e;
    }({}), Tp = function(e) {
      return e.ABORT = "abort", e;
    }({}), il = function(e) {
      return e.MUTE_LOCAL_AUDIO = "mute_local_audio", e.MUTE_LOCAL_VIDEO = "mute_local_video", e.UNMUTE_LOCAL_AUDIO = "unmute_local_audio", e.UNMUTE_LOCAL_VIDEO = "unmute_local_video", e;
    }({}), tae = function(e) {
      return e.P2P_TOKEN_TIMEOUT = "p2p_token_timeout", e.P2P_TOKEN_CHANGED = "p2p_token_changed", e;
    }({});
    const nae = { [NT.ACCESS_POINT]: { [ra.NO_FLAG_SET]: { desc: "flag is zero", retry: !1 }, [ra.FLAG_SET_BUT_EMPTY]: { desc: "flag is empty", retry: !1 }, [ra.INVALID_FALG_SET]: { desc: "invalid flag", retry: !1 }, [ra.FLAG_SET_BUT_NO_RE]: { desc: "flag set unilbs but no request", retry: !1 }, [ra.INVALID_SERVICE_ID]: { desc: "invalid service id", retry: !1 }, [ra.NO_SERVICE_AVAILABLE]: { desc: "no service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_P2P]: { desc: "no unilbs p2p service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_VOICE]: { desc: "no unilbs voice service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_WEBRTC]: { desc: "no unilbs webrtc service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_CDS]: { desc: "no cds service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_CDN]: { desc: "no cdn dispatcher service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_TDS]: { desc: "no tds service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_REPORT]: { desc: "no unilbs report service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_APP_CENTER]: { desc: "no app center service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_ENV0]: { desc: "no unilbs sig env0 service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_VOET]: { desc: "no unilbs voet service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_STRING_UID]: { desc: "no string uid service available", retry: !0 }, [ra.NO_SERVICE_AVAILABLE_WEBRTC_UNILBS]: { desc: "no webrtc unilbs service available", retry: !0 } }, [NT.UNILBS]: { [ac.INVALID_VENDOR_KEY]: { desc: "invalid vendor key, can not find appid", retry: !1 }, [ac.INVALID_CHANNEL_NAME]: { desc: "invalid channel name", retry: !1 }, [ac.INTERNAL_ERROR]: { desc: "unilbs internal error", retry: !1 }, [ac.NO_AUTHORIZED]: { desc: "invalid token, authorized failed", retry: !1 }, [ac.DYNAMIC_KEY_TIMEOUT]: { desc: "dynamic key or token timeout", retry: !1 }, [ac.NO_ACTIVE_STATUS]: { desc: "no active status", retry: !1 }, [ac.DYNAMIC_KEY_EXPIRED]: { desc: "dynamic key expired", retry: !1 }, [ac.STATIC_USE_DYNAMIC_KEY]: { desc: "static use dynamic key", retry: !1 }, [ac.DYNAMIC_USE_STATIC_KEY]: { desc: "dynamic use static key", retry: !1 }, [ac.USER_OVERLOAD]: { desc: "amount of users over load", retry: !1 }, [ac.FORBIDDEN_REGION]: { desc: "the request is forbidden in this area", retry: !1 }, [ac.CANNOT_MEET_AREA_DEMAND]: { desc: "unable to allocate services in this area", retry: !1 } }, [NT.STRING_UID_ALLOCATOR]: { [pI.IIIEGAL_APPID]: { desc: "invalid appid", retry: !1 }, [pI.IIIEGAL_UID]: { desc: "invalid string uid", retry: !1 }, [pI.INTERNAL_ERROR]: { desc: "string uid allocator internal error", retry: !0 } } };
    function bp(e) {
      const n = nae[Math.floor(e / 1e4)];
      if (!n) return { desc: "unknown error", retry: !1 };
      const i = n[e % 1e4];
      if (!i) {
        if (Math.floor(e / 1e4) === NT.ACCESS_POINT) {
          const o = e % 1e4;
          if (o.toString()[0] === "1") return { desc: e.toString(), retry: !1 };
          if (o.toString()[0] === "2") return { desc: e.toString(), retry: !0 };
        }
        return { desc: "unknown error", retry: !1 };
      }
      return i;
    }
    const rae = { [xn.K_TIMESTAMP_EXPIRED]: { desc: "K_TIMESTAMP_EXPIRED", action: "failed" }, [xn.K_CHANNEL_PERMISSION_INVALID]: { desc: "K_CHANNEL_PERMISSION_INVALID", action: "failed" }, [xn.K_CERTIFICATE_INVALID]: { desc: "K_CERTIFICATE_INVALID", action: "failed" }, [xn.K_CHANNEL_NAME_EMPTY]: { desc: "K_CHANNEL_NAME_EMPTY", action: "failed" }, [xn.K_CHANNEL_NOT_FOUND]: { desc: "K_CHANNEL_NOT_FOUND", action: "failed" }, [xn.K_TICKET_INVALID]: { desc: "K_TICKET_INVALID", action: "failed" }, [xn.K_CHANNEL_CONFLICTED]: { desc: "K_CHANNEL_CONFLICTED", action: "failed" }, [xn.K_SERVICE_NOT_READY]: { desc: "K_SERVICE_NOT_READY", action: "tryNext" }, [xn.K_SERVICE_TOO_HEAVY]: { desc: "K_SERVICE_TOO_HEAVY", action: "tryNext" }, [xn.K_UID_BANNED]: { desc: "K_UID_BANNED", action: "failed" }, [xn.K_IP_BANNED]: { desc: "K_IP_BANNED", action: "failed" }, [xn.DATASTREAM2_NOT_AVAILABLE]: { desc: "DATASTREAM2_NOT_AVAILABLE", action: "quit" }, [xn.K_AUTO_REBALANCE]: { desc: "k_AUTO_REBALANCE", action: "recover" }, [xn.ERR_INVALID_VENDOR_KEY]: { desc: "ERR_INVALID_VENDOR_KEY", action: "failed" }, [xn.ERR_INVALID_CHANNEL_NAME]: { desc: "ERR_INVALID_CHANNEL_NAME", action: "failed" }, [xn.WARN_NO_AVAILABLE_CHANNEL]: { desc: "WARN_NO_AVAILABLE_CHANNEL", action: "failed" }, [xn.WARN_LOOKUP_CHANNEL_TIMEOUT]: { desc: "WARN_LOOKUP_CHANNEL_TIMEOUT", action: "tryNext" }, [xn.WARN_LOOKUP_CHANNEL_REJECTED]: { desc: "WARN_LOOKUP_CHANNEL_REJECTED", action: "failed" }, [xn.WARN_OPEN_CHANNEL_TIMEOUT]: { desc: "WARN_OPEN_CHANNEL_TIMEOUT", action: "tryNext" }, [xn.WARN_OPEN_CHANNEL_REJECTED]: { desc: "WARN_OPEN_CHANNEL_REJECTED", action: "failed" }, [xn.WARN_REQUEST_DEFERRED]: { desc: "WARN_REQUEST_DEFERRED", action: "failed" }, [xn.ERR_DYNAMIC_KEY_TIMEOUT]: { desc: "ERR_DYNAMIC_KEY_TIMEOUT", action: "failed" }, [xn.ERR_NO_AUTHORIZED]: { desc: "ERR_NO_AUTHORIZED", action: "failed" }, [xn.ERR_VOM_SERVICE_UNAVAILABLE]: { desc: "ERR_VOM_SERVICE_UNAVAILABLE", action: "tryNext" }, [xn.ERR_NO_CHANNEL_AVAILABLE_CODE]: { desc: "ERR_NO_CHANNEL_AVAILABLE_CODE", action: "failed" }, [xn.ERR_MASTER_VOCS_UNAVAILABLE]: { desc: "ERR_MASTER_VOCS_UNAVAILABLE", action: "tryNext" }, [xn.ERR_INTERNAL_ERROR]: { desc: "ERR_INTERNAL_ERROR", action: "tryNext" }, [xn.ERR_NO_ACTIVE_STATUS]: { desc: "ERR_NO_ACTIVE_STATUS", action: "failed" }, [xn.ERR_INVALID_UID]: { desc: "ERR_INVALID_UID", action: "failed" }, [xn.ERR_DYNAMIC_KEY_EXPIRED]: { desc: "ERR_DYNAMIC_KEY_EXPIRED", action: "failed" }, [xn.ERR_STATIC_USE_DYANMIC_KE]: { desc: "ERR_STATIC_USE_DYANMIC_KE", action: "failed" }, [xn.ERR_DYNAMIC_USE_STATIC_KE]: { desc: "ERR_DYNAMIC_USE_STATIC_KE", action: "failed" }, [xn.ERR_NO_VOCS_AVAILABLE]: { desc: "ERR_NO_VOCS_AVAILABLE", action: "tryNext" }, [xn.ERR_NO_VOS_AVAILABLE]: { desc: "ERR_NO_VOS_AVAILABLE", action: "tryNext" }, [xn.ERR_JOIN_CHANNEL_TIMEOUT]: { desc: "ERR_JOIN_CHANNEL_TIMEOUT", action: "tryNext" }, [xn.ERR_JOIN_BY_MULTI_IP]: { desc: "ERR_JOIN_BY_MULTI_IP", action: "recover" }, [xn.ERR_NOT_JOINED]: { desc: "ERR_NOT_JOINED", action: "failed" }, [xn.ERR_REPEAT_JOIN_REQUEST]: { desc: "ERR_REPEAT_JOIN_REQUEST", action: "quit" }, [xn.ERR_REPEAT_JOIN_CHANNEL]: { desc: "ERR_REPEAT_JOIN_CHANNEL", action: "quit" }, [xn.ERR_INVALID_STRINGUID]: { desc: "ERR_INVALID_STRINGUID", action: "failed" }, [xn.ERR_TOO_MANY_USERS]: { desc: "ERR_TOO_MANY_USERS", action: "tryNext" }, [xn.ERR_SET_CLIENT_ROLE_TIMEOUT]: { desc: "ERR_SET_CLIENT_ROLE_TIMEOUT", action: "failed" }, [xn.ERR_SET_CLIENT_ROLE_NO_PERMISSION]: { desc: "ERR_SET_CLIENT_ROLE_TIMEOUT", action: "failed" }, [xn.ERR_SET_CLIENT_ROLE_ALREADY_IN_USE]: { desc: "ERR_SET_CLIENT_ROLE_ALREADY_IN_USE", action: "success" }, [xn.ERR_PUBLISH_REQUEST_INVALID]: { desc: "ERR_PUBLISH_REQUEST_INVALID", action: "failed" }, [xn.ERR_SUBSCRIBE_REQUEST_INVALID]: { desc: "ERR_SUBSCRIBE_REQUEST_INVALID", action: "failed" }, [xn.ERR_NOT_SUPPORTED_MESSAGE]: { desc: "ERR_NOT_SUPPORTED_MESSAGE", action: "failed" }, [xn.ERR_ILLEAGAL_PLUGIN]: { desc: "ERR_ILLEAGAL_PLUGIN", action: "failed" }, [xn.ILLEGAL_CLIENT_ROLE_LEVEL]: { desc: "ILLEGAL_CLIENT_ROLE_LEVEL", action: "failed" }, [xn.ERR_REJOIN_TOKEN_INVALID]: { desc: "ERR_REJOIN_TOKEN_INVALID", action: "failed" }, [xn.ERR_REJOIN_USER_NOT_JOINED]: { desc: "ERR_REJOIN_NOT_JOINED", action: "failed" }, [xn.ERR_INVALID_OPTIONAL_INFO]: { desc: "ERR_INVALID_OPTIONAL_INFO", action: "quit" }, [xn.ERR_TEST_RECOVER]: { desc: "ERR_TEST_RECOVER", action: "recover" }, [xn.ERR_TEST_TRYNEXT]: { desc: "ERR_TEST_TRYNEXT", action: "recover" }, [xn.ERR_TEST_RETRY]: { desc: "ERR_TEST_RETRY", action: "recover" }, [xn.ILLEGAL_AES_PASSWORD]: { desc: "ERR_TEST_RETRY", action: "failed" }, [xn.ERR_TOO_MANY_BROADCASTERS]: { desc: "ERR_TOO_MANY_BROADCASTERS", action: "failed" }, [xn.ERR_TOO_MANY_SUBSCRIBERS]: { desc: "ERR_TOO_MANY_SUBSCRIBERS", action: "failed" }, [xn.ERR_LICENSE_ILLEGAL]: { desc: "ERR_LICENSE_ILLEGAL", action: "quit" }, [xn.ERR_LICENSE_MISSING]: { desc: "ERR_LICENSE_MISSING", action: "quit" }, [xn.ERR_LICENSE_EXPIRED]: { desc: "ERR_LICENSE_EXPIRED", action: "quit" }, [xn.ERR_LICENSE_MINUTES_EXCEEDED]: { desc: "ERR_LICENSE_MINUTES_EXCEEDED", action: "quit" }, [xn.ERR_LICENSE_PERIOD_INVALID]: { desc: "ERR_LICENSE_PERIOD_INVALID", action: "quit" }, [xn.ERR_LICENSE_MULTIPLE_SDK_SERVICE]: { desc: "ERR_LICENSE_MULTIPLE_SDK_SERVICE", action: "quit" } };
    function UE(e) {
      return rae[e] || { desc: "UNKNOWN_ERROR_".concat(e), action: "failed" };
    }
    function X8(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function yI(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? X8(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : X8(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    function W8(e, n) {
      if (typeof e == "string") return e;
      const { proxy: i, host: o, port: f } = e;
      if (n) {
        const T = ft("JOIN_GATEWAY_FALLBACK_PORT") || 443;
        return T === 443 ? "wss://".concat(o, "/ws/?p=").concat(Number(f) + 150) : "wss://".concat(o, ":").concat(T, "/ws/?p=").concat(Number(f) + 150);
      }
      return i ? "wss://".concat(i, "/ws/?h=").concat(o, "&p=").concat(f) : "wss://".concat(o, ":").concat(f);
    }
    const iae = /wss:\/\/(.+)\/ws\/\?h=(.+)&p=([0-9]+)\/?/, sae = /wss:\/\/(.+)\/ws\/\?p=([0-9]+)\/?/, aae = /wss:\/\/(.+):([0-9]+)\/?/, oae = /wss:\/\/(.[^\/]+)\/?/;
    let cae = 0;
    class uae {
      constructor(n, i) {
        Ve(this, "id", 0), Ve(this, "store", void 0), Ve(this, "recordIndex", void 0), Ve(this, "websockets", []), Ve(this, "try443PortDuration", 2e3), Ve(this, "forceCloseWSDuration", 5e3), Ve(this, "try443PortTimeout", null), Ve(this, "forceCloseTimeout", null), Ve(this, "isTry443PortFailed", !1), Ve(this, "isNormalPortFailed", !1), Ve(this, "useDoubleDomain", !1), Ve(this, "useProxy", !1), Ve(this, "startTime", Date.now()), this.id = ++cae, this.try443PortDuration = ft("JOIN_GATEWAY_TRY_443PORT_DURATION") || 2e3, this.forceCloseWSDuration = n || 5e3, this.store = i;
      }
      closeAllWebsockets() {
        this.websockets.forEach((n) => {
          n.onopen = null, n.onclose = null, n.onmessage = null, n.close();
        }), this.websockets.length = 0;
      }
      clearTimeout() {
        this.forceCloseTimeout && clearTimeout(this.forceCloseTimeout), this.try443PortTimeout && clearTimeout(this.try443PortTimeout), this.forceCloseTimeout = null, this.try443PortTimeout = null;
      }
      logger() {
        var n;
        const i = Date.now() - this.startTime;
        for (var o = arguments.length, f = new Array(o), T = 0; T < o; T++) f[T] = arguments[T];
        Ee.debug("[choose-best-ws ".concat((n = this.store) === null || n === void 0 ? void 0 : n.clientId, " ").concat(this.id, "] ").concat(i, "ms:"), ...f);
      }
      createWebSocket(n, i, o) {
        this.logger("createWebSocket:", n, { isTry443Port: i, hasTimeoutDetection: o });
        const f = ft("GATEWAY_DOMAINS"), T = Date.now(), A = [], R = f.find((te) => {
          var oe;
          return on(oe = n.host).call(oe, te);
        });
        R || (this.useDoubleDomain = !1);
        const P = [];
        if (this.useDoubleDomain) f.forEach((te) => {
          P.push(W8(yI(yI({}, n), {}, { host: n.host.replace(R, te) }), i));
        });
        else {
          const te = yI({}, n);
          if (i && R) {
            const oe = f.find((He) => He !== R);
            oe && (te.host = te.host.replace(R, oe));
          }
          P.push(W8(te, i));
        }
        try {
          P.forEach((te) => {
            const oe = new WebSocket(te);
            oe.binaryType = "arraybuffer", A.push(oe), this.logger("ws is connecting:", oe.url);
          });
        } catch (te) {
          if (this.logger("ws create failed"), A.forEach((oe) => oe.close()), A.length = 0, this.useDoubleDomain) return this.useDoubleDomain = !1, this.createWebSocket(n, i, o);
          if (!i && Number(n.port) !== 443) return this.createWebSocket(n, !0, o);
          throw new jt(Je.WS_ERR, "init websocket failed! Error: ".concat(te.toString()));
        }
        const L = CE();
        this.store && this.store.recordJoinChannelService({ urls: A.map((te) => te.url), service: "gateway" }, this.recordIndex), A.forEach((te) => {
          te.onopen = () => {
            this.logger("onopen: ws ".concat(te.url, " open cost ").concat(Date.now() - T, "ms")), this.websockets.forEach((oe) => {
              oe !== te && (oe.onopen = null, oe.onclose = null, oe.onmessage = null, oe.close(), this.logger("close backup websocket: ".concat(oe.url)));
            }), this.websockets.length = 0, L.resolve(te);
          }, te.onclose = (oe) => {
            this.logger("onclose: ws ".concat(te.url, " closed cost ").concat(Date.now() - T, "ms state: ").concat(te.readyState));
            const He = A.every((Re) => Re.readyState === WebSocket.CLOSED || Re.readyState === WebSocket.CLOSING);
            this.logger("".concat(i ? "443" : "47xx", " websocket closed, all failed: ").concat(He)), He && (i || this.isTry443PortFailed || this.useProxy) ? (this.logger("onclose: all websocket is closed, ".concat(oe.reason)), L.reject({ code: oe.code, reason: PT.A_ROUND_WS_FAILED })) : !i && He && !this.isNormalPortFailed && this.try443PortTimeout && (this.logger("all 47xx websocket is closed, try 443 port"), this.clearTimeout(), Y()), i ? this.isTry443PortFailed = He : this.isNormalPortFailed = He;
          }, te.onmessage = (oe) => this.logger("".concat(te.url, " onmessage: ").concat(oe.data));
        }), this.websockets.push(...A);
        const z = () => {
          this.websockets.forEach((te) => te.readyState !== WebSocket.OPEN && te.close());
        }, Y = () => {
          if (L.isResolved) return z();
          hr().os === ts.MAC_OS && ui() && z(), this.createWebSocket(n, !0, !0).then((te) => {
            L.resolve(te);
          }).catch((te) => {
            this.isNormalPortFailed && L.reject(te), this.logger("try 443 port to create ws failed");
          }), this.forceCloseTimeout = window.setTimeout(() => {
            this.logger("5s timeout close un-opens, isWebsocket created: ", L.isResolved), this.forceCloseTimeout = null, z();
          }, this.forceCloseWSDuration);
        };
        return o || (() => {
          if (i || this.useProxy) return this.logger("add 5s timeout at ".concat(i ? "try-443" : "proxy", " condition")), this.forceCloseTimeout = window.setTimeout(() => {
            this.forceCloseTimeout = null, z();
          }, this.forceCloseWSDuration);
          this.try443PortTimeout = window.setTimeout(() => {
            this.logger("2s timeout, isWebsocket created: ", L.isResolved), this.try443PortTimeout = null, Y();
          }, this.try443PortDuration);
        })(), L.promise;
      }
      chooseBestWebsocket(n, i, o, f) {
        return this.useDoubleDomain = !!i, typeof n == "string" && (n = function(T) {
          let A, R, P;
          return [, A, R, P] = T.match(iae) || [], A || ([, R, P] = T.match(sae) || []), R && P || ([, R, P] = T.match(aae) || []), R && P || ([, R] = T.match(oae) || []), R || Ee.warning("un-destructible url: ", T), { proxy: A, host: R, port: P || "443" };
        }(n)), this.recordIndex = f, this.useProxy = !!n.proxy, o && this.useProxy && (Ee.warn("cannot use 443 only when use proxy"), o = !1), this.createWebSocket(n, !!o, !1).finally(() => this.clearTimeout());
      }
    }
    function q8(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    class K8 extends ii {
      get url() {
        return this.websocket && this.websocket.url || null;
      }
      get reconnectMode() {
        return this._reconnectMode;
      }
      set reconnectMode(n) {
        var i;
        on(i = ["tryNext", "recover"]).call(i, n) && this.resetReconnectCount(n), this._reconnectMode = n;
      }
      get state() {
        return this._state;
      }
      set state(n) {
        n !== this._state && (this._state = n, this._state === "reconnecting" ? this.emit(Fn.RECONNECTING, this.reconnectReason) : this._state === "connected" ? this.emit(Fn.CONNECTED) : this._state === "closed" ? this.emit(Fn.CLOSED) : this._state === "failed" && this.emit(Fn.FAILED));
      }
      resetReconnectCount(n) {
        Ee.debug("websocket reset reconnect count, reason: " + n), this.reconnectCount = 0;
      }
      constructor(n, i) {
        let o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], f = arguments.length > 3 && arguments[3] !== void 0 && arguments[3], T = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], A = arguments.length > 5 ? arguments[5] : void 0;
        super(), Ve(this, "connectionID", 0), Ve(this, "currentURLIndex", 0), Ve(this, "urls", []), Ve(this, "_reconnectMode", "tryNext"), Ve(this, "reconnectReason", void 0), Ve(this, "_initMutex", void 0), Ve(this, "name", void 0), Ve(this, "_state", "closed"), Ve(this, "reconnectInterrupter", void 0), Ve(this, "websocket", void 0), Ve(this, "retryConfig", void 0), Ve(this, "reconnectCount", 0), Ve(this, "forceCloseTimeout", 5e3), Ve(this, "onlineReconnectListener", void 0), Ve(this, "useCompress", void 0), Ve(this, "tryDoubleDomain", !1), Ve(this, "use443PortOnly", !1), Ve(this, "wsInflateLength", 0), Ve(this, "wsDeflateLength", 0), Ve(this, "closeEstablishingWs", () => {
        }), Ve(this, "store", void 0), Ve(this, "joinGatewayRecordIndex", void 0), this.store = A, this.name = n, this.retryConfig = function(Y) {
          for (var te = 1; te < arguments.length; te++) {
            var oe = arguments[te] != null ? arguments[te] : {};
            te % 2 ? q8(Object(oe), !0).forEach(function(He) {
              Ve(Y, He, oe[He]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(oe)) : q8(Object(oe)).forEach(function(He) {
              Object.defineProperty(Y, He, Object.getOwnPropertyDescriptor(oe, He));
            });
          }
          return Y;
        }({}, i), this.useCompress = o, this.tryDoubleDomain = f, this.use443PortOnly = T, this._initMutex = new xs("websocket", A ? A.clientId : void 0);
        const { timeout: R, timeoutFactor: P } = i, L = Math.max(300, Math.floor(3 * R / 5)), z = Math.max(1.2, Math.floor(8 * P) / 10);
        Fa.ONLINE && (this.retryConfig.timeout = L, this.retryConfig.timeoutFactor = z), Mi.on(tp.NETWORK_STATE_CHANGE, (Y, te) => {
          Y !== te && (this.resetReconnectCount("network state change: ".concat(te, " -> ").concat(Y)), Y === Fa.ONLINE ? (this.retryConfig.timeout = L, this.retryConfig.timeoutFactor = z) : (this.retryConfig.timeout = R, this.retryConfig.timeoutFactor = P));
        });
      }
      getConnection() {
        return this.websocket || void 0;
      }
      async init(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5e3;
        const o = await this._initMutex.lock();
        this._reconnectMode = "tryNext", this.forceCloseTimeout = i, this.urls = n, this.state = "connecting";
        try {
          const f = CE(), T = this.urls[this.currentURLIndex];
          ft("ENABLE_PREALLOC_PC") && this.emit(Y8.PRE_CONNECT_PC), this.createWebSocketConnection(T).then(f.resolve).catch(f.reject), this.once(Fn.CLOSED, () => {
            f.reject(new Gt(Je.WS_DISCONNECT));
          }), this.once(Fn.CONNECTED, f.resolve), await f.promise;
        } catch {
        } finally {
          o();
        }
      }
      close(n, i) {
        if (this.currentURLIndex = 0, this.resetReconnectCount("close"), this.reconnectInterrupter && this.reconnectInterrupter(), this.websocket) {
          this.websocket.onclose = null, this.websocket.onopen = null, this.websocket.onmessage = null;
          const o = this.websocket;
          i ? setTimeout(() => o.close(), 500) : o.close(), this.websocket = void 0;
        }
        this.state = n ? "failed" : "closed", this.closeEstablishingWs && this.closeEstablishingWs();
      }
      reconnect(n, i) {
        if (!this.websocket) return void Ee.warning("[".concat(this.name, "] can not reconnect, no websocket"));
        n !== void 0 && (this.reconnectMode = n), Ee.debug("[".concat(this.name, "] reconnect is triggered initiative")), typeof this.joinGatewayRecordIndex == "number" && this.store && this.store.recordJoinChannelService({ status: "error", errors: [new Error(i)] }, this.joinGatewayRecordIndex);
        const o = this.websocket.onclose;
        this.websocket.onclose = null, this.websocket.close(), o && o.bind(this.websocket)({ code: 9999, reason: i });
      }
      sendMessage(n) {
        let i = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
        if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) throw new Gt(Je.WS_ABORT, "websocket is not ready");
        try {
          i || (n = JSON.stringify(n)), this.websocket.send(n);
        } catch (o) {
          throw new Gt(Je.WS_ERR, "send websocket message error" + o.toString());
        }
      }
      setWsInflateData(n) {
        this.wsDeflateLength = this.wsDeflateLength + n.originLength, this.wsInflateLength = this.wsInflateLength + n.compressedLength;
      }
      getWsInflateData() {
        const n = this.wsInflateLength, i = this.wsDeflateLength;
        return this.clearWsInflateData(), { wsInflateLength: n, wsDeflateLength: i };
      }
      clearWsInflateData() {
        this.wsInflateLength = 0, this.wsDeflateLength = 0;
      }
      async createWebSocketConnection(n) {
        var i;
        const o = CE();
        this.connectionID += 1, this.joinGatewayRecordIndex = void 0;
        const f = (z) => {
          var Y;
          (Y = this.store) === null || Y === void 0 || Y.signalChannelOpen(), Ee.debug("[".concat(this.name, "] websocket opened:"), z), this.reconnectMode = "retry", this.state = "connected", this.resetReconnectCount("opened"), o.resolve();
        }, T = async (z) => {
          var Y;
          if (Ee.debug("[".concat(this.name, "] websocket close ").concat((Y = this.websocket) === null || Y === void 0 ? void 0 : Y.url, ", code: ").concat(z.code, ", reason: ").concat(z.reason, ", current mode: ").concat(this.reconnectMode)), this.reconnectCount >= this.retryConfig.maxRetryCount) o.reject(new Gt(Je.WS_DISCONNECT, "websocket close: ".concat(z.code))), this.close();
          else {
            this.state === "connected" && (this.reconnectReason = z.reason, this.state = "reconnecting");
            const te = to(this, Fn.WILL_RECONNECT, this.reconnectMode, z.reason) || this.reconnectMode, oe = await this.reconnectWithAction(te);
            if (this.state === "closed") return void Ee.debug("[".concat(this.connectionID, "] ws is closed, no need to reconnect"));
            if (!oe) return o.reject(new Gt(Je.WS_DISCONNECT, "websocket reconnect failed: ".concat(z.code))), this.close(!0);
            o.resolve();
          }
        }, A = (z) => {
          this.emit(Fn.ON_MESSAGE, z);
        }, R = (z) => {
          Ee.warn("[".concat(this.connectionID, "] ws open error ").concat(z));
        };
        this.websocket && (this.websocket.onclose = null, this.websocket.close()), ft("GATEWAY_WSS_ADDRESS") && this.name.startsWith("gateway") && (n = ft("GATEWAY_WSS_ADDRESS")), Ee.debug("[".concat(this.name, "] start connect, url:"), n);
        const P = (i = this.store) === null || i === void 0 ? void 0 : i.recordJoinChannelService({ startTs: Date.now(), status: "pending", service: "gateway" });
        try {
          var L;
          const z = await this.chooseBestWebsocketConnection(n);
          this.websocket = z, f && f(this.websocket.url), this.websocket.onclose = T, this.websocket.onmessage = A, this.websocket.onerror = R, (L = this.store) === null || L === void 0 || L.recordJoinChannelService({ endTs: Date.now(), status: "success" }, P), this.joinGatewayRecordIndex = P;
        } catch (z) {
          const Y = this.state === "closed", te = z instanceof Gt, oe = te && z.code === Je.WS_ABORT, He = te && z.code === Je.WS_ERR, Re = te ? z.message : z && (z.reason || z.toString());
          Ee.warning("[choose-best-ws] chooseBestWebsocket error: ".concat(Re)), this.store && this.store.recordJoinChannelService({ endTs: Date.now(), status: oe ? "aborted" : "error", errors: [z] }, P), Y || He ? (o.reject(Y ? new Gt(Je.WS_DISCONNECT, "websocket is closed: ".concat(Re)) : new Gt(Je.WS_ERR, "init websocket failed: ".concat(Re))), He && Ee.error("[".concat(this.name, "] init websocket failed: ").concat(Re))) : T(z);
        }
        return o.promise;
      }
      async reconnectWithAction(n) {
        let i = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        if (this.reconnectCount >= this.retryConfig.maxRetryCount || this.urls.length === 0 || this.state === "closed") return !1;
        Ee.warning("[choose-best-ws] action: =>", n), this.onlineReconnectListener || Mi.isOnline || !Mi.onlineWaiter || (this.onlineReconnectListener = Mi.onlineWaiter.then(() => {
          this.onlineReconnectListener = void 0;
        }));
        let o = !0;
        if (this.reconnectInterrupter = () => o = !1, i) {
          const A = HS(this.reconnectCount, this.retryConfig);
          Ee.debug("[".concat(this.name, "] wait ").concat(A, "ms to reconnect websocket, mode: ").concat(n)), await cn.race([Es(A), this.onlineReconnectListener || new cn(() => {
          })]);
        }
        if (this._state === "closed" || !o) return !1;
        this.reconnectCount += 1;
        const f = async (A, R) => {
          this.emit(Fn.RECONNECT_CREATE_CONNECTION, R), await this.createWebSocketConnection(A);
        };
        try {
          if (n === "retry") await f(this.urls[this.currentURLIndex], n);
          else if (n === "tryNext") {
            if (this.currentURLIndex += 1, this.currentURLIndex >= this.urls.length) return this.reconnectWithAction("recover", !1);
            Ee.debug("[".concat(this.name, "] websocket url length: ").concat(this.urls.length, " current index: ").concat(this.currentURLIndex)), await f(this.urls[this.currentURLIndex], n);
          } else n === "recover" && (Ee.debug("[".concat(this.name, "] request new urls")), this.resetReconnectCount("recover mode"), this.urls = await Ss(this, Fn.REQUEST_NEW_URLS), this.currentURLIndex = 0, await f(this.urls[this.currentURLIndex], n));
        } catch (A) {
          var T;
          Ee.error("[".concat(this.name, "] reconnect failed ").concat(A && A.toString()));
          const R = A == null || (T = A.data) === null || T === void 0 ? void 0 : T.desc;
          return Array.isArray(R) && on(R).call(R, "dynamic key expired") ? (this.emit(Fn.ON_TOKEN_PRIVILEGE_DID_EXPIRE), !1) : this.reconnectWithAction(n, i);
        }
        return !0;
      }
    }
    class vI extends K8 {
      constructor(n, i) {
        super(n, i, arguments.length > 2 && arguments[2] !== void 0 && arguments[2], arguments.length > 3 && arguments[3] !== void 0 && arguments[3], arguments.length > 4 && arguments[4] !== void 0 && arguments[4], arguments.length > 5 ? arguments[5] : void 0);
      }
      async chooseBestWebsocketConnection(n, i) {
        const o = CE(), f = function(A, R) {
          return new uae(A, R);
        }(this.forceCloseTimeout, this.store);
        this.closeEstablishingWs = () => {
          Ee.debug("[choose-best-ws] close establishing websockets"), f.closeAllWebsockets(), o.reject(new Gt(Je.WS_ABORT, "choose best websocket aborted"));
        };
        const T = ft("GATEWAY_DOMAINS");
        return Ee.debug("[choose-best-ws] currentDomain: ", n, ", domains: ", T, "total: ".concat(this.urls.length), "current: ".concat(this.currentURLIndex + 1)), f.chooseBestWebsocket(n, this.tryDoubleDomain, this.use443PortOnly, i).then(o.resolve).catch(o.reject), o.promise.finally(() => {
          this.closeEstablishingWs = void 0;
        });
      }
    }
    class HE extends K8 {
      constructor(n, i) {
        super(n, i, arguments.length > 2 && arguments[2] !== void 0 && arguments[2], arguments.length > 3 && arguments[3] !== void 0 && arguments[3], arguments.length > 4 && arguments[4] !== void 0 && arguments[4], arguments.length > 5 ? arguments[5] : void 0);
      }
      async chooseBestWebsocketConnection(n, i) {
        return new cn((o, f) => {
          let T = !1;
          const A = [];
          this.closeEstablishingWs = () => {
            Ee.debug("[choose-best-ws] close establishing websockets"), A.forEach((He) => {
              He.onclose = null, He.onopen = null, He.onmessage = null, He.close();
            }), f(new Gt(Je.WS_ABORT, "choose best websocket aborted"));
          };
          const R = ft("GATEWAY_DOMAINS");
          let P;
          const L = n.indexOf("?h="), z = R.find((He) => L !== -1 ? on(n).call(n, He, L) : on(n).call(n, He));
          Ee.debug("[choose-best-ws] currentDomain: ", z, ", domains: ", R);
          let Y = !this.tryDoubleDomain || !z;
          if (!Y && z) {
            var te;
            const He = Date.now();
            try {
              R.forEach((Re) => {
                const De = L === -1 ? n.replace(z, Re) : n.substr(0, L) + n.substr(L).replace(z, Re), Xe = new WebSocket(De);
                Xe.binaryType = "arraybuffer", A.push(Xe), Ee.debug("[choose-best-ws] ws is connecting:", Xe.url);
              });
            } catch {
              for (Ee.debug("[choose-best-ws] ws create failed, fallback to single url"), A.forEach((De) => De.close()); A.length; ) A.pop();
              Y = !0;
            }
            (te = this.store) === null || te === void 0 || te.recordJoinChannelService({ urls: A.map((Re) => Re.url), service: "gateway" }, i), A.forEach((Re) => {
              Re.onopen = () => {
                if (T) return;
                const De = Date.now() - He;
                Ee.debug("[choose-best-ws] ws open cost ".concat(De, "ms")), A.filter((Xe) => Xe !== Re).forEach((Xe) => {
                  Ee.debug("[choose-best-ws]close backup websocket: ".concat(Xe.url)), Xe.close();
                }), T = !0, o(Re);
              }, Re.onclose = (De) => {
                P = De, !T && (A.find((Xe) => !(Xe.readyState === WebSocket.CLOSED || Xe.readyState === WebSocket.CLOSING)) || (Ee.debug("[choose-best-ws] all websocket is closed"), T = !0, f(P)));
              }, Re.onmessage = (De) => {
                Ee.debug("[choose-best-ws]".concat(Re.url, " onmessage: ").concat(De.data));
              };
            }), Es(this.forceCloseTimeout).then(() => {
              A.forEach((Re) => {
                Re.readyState !== WebSocket.OPEN && Re.close();
              });
            });
          }
          if (Y) {
            var oe;
            let He;
            Ee.debug("[choose-best-ws] use single url: ", n), (oe = this.store) === null || oe === void 0 || oe.recordJoinChannelService({ urls: [n], service: "gateway" }, i);
            try {
              He = new WebSocket(n), A.push(He), He.binaryType = "arraybuffer";
            } catch (Re) {
              const De = new Gt(Je.WS_ERR, "init websocket failed! Error: ".concat(Re.toString()));
              return Ee.error("[".concat(this.name, "]").concat(De)), void f(De);
            }
            He.onopen = () => {
              o(He);
            }, He.onclose = (Re) => {
              f(Re);
            }, He.onmessage = (Re) => {
              Ee.debug("[choose-best-ws]".concat(He.url, " onmessage: ").concat(Re.data));
            }, Es(this.forceCloseTimeout).then(() => {
              He && He.readyState !== WebSocket.OPEN && He.close();
            });
          }
        }).then((o) => (this.closeEstablishingWs = void 0, o)).catch((o) => {
          throw this.closeEstablishingWs = void 0, o;
        });
      }
    }
    class dae extends ii {
      get connectionState() {
        return this._connectionState;
      }
      set connectionState(n) {
        n !== this._connectionState && (this._connectionState = n, n === Vr.CONNECTED ? this.emit(jn.WS_CONNECTED) : n === Vr.RECONNECTING ? this.emit(jn.WS_RECONNECTING, this._websocketReconnectReason) : n === Vr.CLOSED && this.emit(jn.WS_CLOSED, this._disconnectedReason));
      }
      get currentURLIndex() {
        return this.websocket.currentURLIndex;
      }
      get url() {
        return this.websocket && this.websocket.url || null;
      }
      get rtt() {
        return this.rttRolling.mean();
      }
      constructor(n, i) {
        super(), Ve(this, "_disconnectedReason", void 0), Ve(this, "_websocketReconnectReason", void 0), Ve(this, "_connectionState", Vr.CLOSED), Ve(this, "reconnectToken", void 0), Ve(this, "websocket", void 0), Ve(this, "openConnectionTime", void 0), Ve(this, "clientId", void 0), Ve(this, "lastMsgTime", Date.now()), Ve(this, "uploadCache", []), Ve(this, "uploadCacheInterval", void 0), Ve(this, "rttRolling", new p5(5)), Ve(this, "pingpongTimer", void 0), Ve(this, "wsInflateDataTimer", void 0), Ve(this, "pingpongTimeoutCount", 0), Ve(this, "joinResponse", void 0), Ve(this, "multiIpOption", void 0), Ve(this, "initError", void 0), Ve(this, "spec", void 0), Ve(this, "store", void 0), Ve(this, "onWebsocketMessage", (o) => {
          if (o.data instanceof ArrayBuffer) return void this.emit(jn.ON_BINARY_DATA, o.data);
          const f = JSON.parse(o.data);
          if (this.lastMsgTime = Date.now(), Object.prototype.hasOwnProperty.call(f, "_id")) {
            const T = "res-@".concat(f._id);
            this.emit(T, f._result, f._message);
          } else if (Object.prototype.hasOwnProperty.call(f, "_type")) {
            if (this.emit(f._type, f._message), f._type === nr.ON_NOTIFICATION && this.handleNotification(f._message), f._type === nr.ON_USER_BANNED) switch (f._message.error_code) {
              case 14:
                this.close(br.UID_BANNED);
                break;
              case 15:
                this.close(br.IP_BANNED);
                break;
              case 16:
                this.close(br.CHANNEL_BANNED);
            }
            if (f._type === nr.ON_USER_LICENSE_BANNED) switch (f._message.error_code) {
              case xn.ERR_LICENSE_MISSING:
                this.close(br.LICENSE_MISSING);
                break;
              case xn.ERR_LICENSE_EXPIRED:
                this.close(br.LICENSE_EXPIRED);
                break;
              case xn.ERR_LICENSE_MINUTES_EXCEEDED:
                this.close(br.LICENSE_MINUTES_EXCEEDED);
                break;
              case xn.ERR_LICENSE_PERIOD_INVALID:
                this.close(br.LICENSE_PERIOD_INVALID);
                break;
              case xn.ERR_LICENSE_MULTIPLE_SDK_SERVICE:
                this.close(br.LICENSE_MULTIPLE_SDK_SERVICE);
                break;
              case xn.ERR_LICENSE_ILLEGAL:
                this.close(br.LICENSE_ILLEGAL);
                break;
              default:
                this.close();
            }
          }
        }), this.clientId = n.clientId, this.spec = n, this.store = i, this.websocket = new vI("gateway-".concat(this.clientId), this.spec.retryConfig, !0, ft("JOIN_GATEWAY_USE_DUAL_DOMAIN"), ft("JOIN_GATEWAY_USE_443PORT_ONLY"), i), this.handleWebsocketEvents(), window.addEventListener("offline", () => {
          this.connectionState === Vr.CONNECTED && this.reconnect("retry", Cs.OFFLINE);
        });
      }
      async request(n, i, o, f) {
        const T = zr(6, ""), A = { _id: T, _type: n, _message: i }, R = this.websocket.connectionID, P = () => new cn((He, Re) => {
          if (this.connectionState === Vr.CONNECTED) return He();
          const De = () => {
            this.off(jn.WS_CLOSED, Xe), He();
          }, Xe = () => {
            this.off(jn.WS_CONNECTED, De), Re(new jt(Je.WS_ABORT));
          };
          this.once(jn.WS_CONNECTED, De), this.once(jn.WS_CLOSED, Xe), n !== kn.PUBLISH && n !== kn.PUBLISH_DATASTREAM && n !== kn.SUBSCRIBE && n !== kn.SUBSCRIBE_DATASTREAM && n !== kn.UNSUBSCRIBE && n !== kn.UNSUBSCRIBE_DATASTREAM && n !== kn.UNPUBLISH && n !== kn.UNPUBLISH_DATASTREAM && n !== kn.CONTROL && n !== kn.RESTART_ICE || this.once(jn.DISCONNECT_P2P, () => {
            Re(new jt(Je.DISCONNECT_P2P));
          }), n !== kn.PUBLISH && n !== kn.RESTART_ICE || this.once(jn.ABORT_P2P_EXECUTION, () => {
            Re(new jt(Je.DISCONNECT_P2P));
          });
        });
        if (this.connectionState !== Vr.CONNECTING && this.connectionState !== Vr.RECONNECTING || n === kn.JOIN || n === kn.REJOIN || await P(), this.websocket.sendMessage(A, !0), f) return;
        const L = new cn((He, Re) => {
          let De = !1;
          const Xe = (mt, Pt) => {
            De = !0, He({ isSuccess: mt === "success", message: Pt || {} }), this.off(jn.WS_CLOSED, We), this.off(jn.WS_RECONNECTING, We), this.emit(jn.REQUEST_SUCCESS, n, i);
          };
          this.once("res-@".concat(T), Xe);
          const We = () => {
            Re(new jt(Je.WS_ABORT, "type: ".concat(n))), this.off(jn.WS_CLOSED, We), this.off(jn.WS_RECONNECTING, We), this.off("res-@".concat(T), Xe);
          };
          this.once(jn.WS_CLOSED, We), this.once(jn.WS_RECONNECTING, We), Es(ft("SIGNAL_REQUEST_TIMEOUT")).then(() => {
            this.websocket.connectionID !== R || De || (Ee.warning("[".concat(this.clientId, "] ws request timeout, type: ").concat(n)), this.emit(jn.REQUEST_TIMEOUT, n, i));
          });
        });
        let z = null;
        try {
          z = await L;
        } catch (He) {
          if (this.connectionState === Vr.CLOSED || n === kn.LEAVE) throw new jt(Je.WS_ABORT);
          return !this.spec.forceWaitGatewayResponse || o ? He.throw() : n === kn.JOIN || n === kn.REJOIN ? null : (await P(), await this.request(n, i));
        }
        if (z.isSuccess) return z.message;
        const Y = Number(z.message.error_code || z.message.code), te = UE(Y), oe = new jt(Je.UNEXPECTED_RESPONSE, "".concat(te.desc, ": ").concat(z.message.error_str), { code: Y, data: z.message, desc: te.desc });
        return te.action === "success" ? z.message : (Ee.warning("[".concat(this.clientId, "] [").concat(this.websocket.connectionID, "] unexpected response from type ").concat(n, ", error_code: ").concat(Y, ", message: ").concat(te.desc, ", action: ").concat(te.action)), Y === xn.ERR_TOO_MANY_BROADCASTERS ? ((n === kn.JOIN || n === kn.REJOIN) && (this.initError = oe, this.close()), oe.throw()) : te.action === "failed" ? oe.throw() : te.action === "quit" ? (this.initError = oe, this.close(), oe.throw()) : (Y === xn.ERR_JOIN_BY_MULTI_IP ? (this.multiIpOption = z.message.option, Ee.warning("[".concat(this.clientId, "] detect multi ip, recover")), this.reconnect("recover", Cs.MULTI_IP)) : this.reconnect(te.action, Cs.SERVER_ERROR), n === kn.JOIN || n === kn.REJOIN ? null : await this.request(n, i)));
      }
      waitMessage(n, i) {
        return new cn((o) => {
          const f = (T) => {
            (!i || i(T)) && (this.off(n, f), o(T));
          };
          this.on(n, f);
        });
      }
      uploadWRTCStats(n) {
        if (!this.store.sessionId) return void Ee.warn("[".concat(this.clientId, "] no session id when upload wrtc stats"));
        const i = { lts: Date.now(), sid: this.store.sessionId, uid: this.store.intUid, stats: n };
        this.upload(kE.WRTC_STATS, i);
      }
      upload(n, i) {
        const o = { _type: n, _message: i };
        try {
          this.websocket.sendMessage(o);
        } catch {
          const T = ft("MAX_UPLOAD_CACHE") || 50;
          this.uploadCache.push(o), this.uploadCache.length > T && this.uploadCache.splice(0, 1), this.uploadCache.length > 0 && !this.uploadCacheInterval && (this.uploadCacheInterval = window.setInterval(() => {
            if (this.connectionState !== Vr.CONNECTED) return;
            const A = this.uploadCache.splice(0, 1)[0];
            this.uploadCache.length === 0 && (window.clearInterval(this.uploadCacheInterval), this.uploadCacheInterval = void 0), this.upload(A._type, A._message);
          }, ft("UPLOAD_CACHE_INTERVAL") || 2e3));
        }
      }
      send(n, i) {
        const o = { _type: n, _message: i };
        this.websocket.sendMessage(o);
      }
      init(n) {
        return this.initError = void 0, this.multiIpOption = void 0, this.joinResponse = void 0, this.reconnectToken = void 0, this.openConnectionTime = void 0, new cn((i, o) => {
          this.once(jn.WS_CONNECTED, () => i(this.joinResponse)), this.once(jn.WS_CLOSED, (f) => o(this.initError || new jt(Je.WS_ABORT, f))), this.connectionState = Vr.CONNECTING, this.websocket.init(n).catch(o), this.wsInflateDataTimer && window.clearInterval(this.wsInflateDataTimer), this.wsInflateDataTimer = window.setInterval(() => {
            this.handleWsInflateData();
          }, 2e4);
        });
      }
      close(n) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.wsInflateDataTimer && (this.handleWsInflateData(), window.clearInterval(this.wsInflateDataTimer), this.wsInflateDataTimer = void 0), this.reconnectToken = void 0, this.joinResponse = void 0, this._disconnectedReason = n || br.LEAVE, this.connectionState = Vr.CLOSED, Ee.debug("[".concat(this.clientId, "] ") + "will close websocket in signal"), this.websocket.close();
      }
      async join() {
        if (!this.joinResponse) {
          this.emit(jn.ABORT_P2P_EXECUTION);
          const n = await Ss(this, jn.REQUEST_JOIN_INFO), i = await this.request(kn.JOIN, n);
          if (!i) return this.emit(jn.REPORT_JOIN_GATEWAY, PT.TIMEOUT, this.url || ""), !1;
          this.joinResponse = i, this.emit(jn.JOIN_RESPONSE, this.joinResponse), this.reconnectToken = this.joinResponse.rejoin_token;
        }
        return this.connectionState = Vr.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), !0;
      }
      async rejoin() {
        if (!this.reconnectToken) throw new jt(Je.UNEXPECTED_ERROR, "can not rejoin, no rejoin token");
        const n = wE(this, jn.REQUEST_REJOIN_INFO);
        n.token = this.reconnectToken;
        const i = await this.request(kn.REJOIN, n);
        return !!i && (this.connectionState = Vr.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), i.peers && i.peers.forEach((o) => {
          this.emit(nr.ON_USER_ONLINE, { uid: o.uid }), o.audio && this.emit(nr.ON_ADD_AUDIO_STREAM, { uid: o.uid, uint_id: o.uint_id, audio: !0, ssrcId: o.audio_ssrc }), o.video && this.emit(nr.ON_ADD_VIDEO_STREAM, { uid: o.uid, uint_id: o.uint_id, video: !0, ssrcId: o.video_ssrc }), o.audio_mute ? this.emit(nr.MUTE_AUDIO, { uid: o.uid }) : this.emit(nr.UNMUTE_AUDIO, { uid: o.uid }), o.video_mute ? this.emit(nr.MUTE_VIDEO, { uid: o.uid }) : this.emit(nr.UNMUTE_VIDEO, { uid: o.uid }), o.audio_enable_local ? this.emit(nr.ENABLE_LOCAL_AUDIO, { uid: o.uid }) : this.emit(nr.DISABLE_LOCAL_AUDIO, { uid: o.uid }), o.video_enable_local ? this.emit(nr.ENABLE_LOCAL_VIDEO, { uid: o.uid }) : this.emit(nr.DISABLE_LOCAL_VIDEO, { uid: o.uid }), o.audio || o.video || this.emit(nr.ON_REMOVE_STREAM, { uid: o.uid, uint_id: o.uint_id });
        }), !0);
      }
      reconnect(n, i) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.websocket.reconnect(n, i);
      }
      handleNotification(n) {
        Ee.debug("[".concat(this.clientId, "] receive notification: "), n);
        const i = UE(n.code);
        if (n.code === 28 && "detail" in n && (Ee.info("[".concat(this.clientId, "] receive recover notification: "), n.detail), this.emit(jn.RECOVER_NOTIFICATION, n.detail)), i.action !== "success") {
          if (i.action !== "failed") return i.action === "quit" ? (i.desc === "ERR_REPEAT_JOIN_CHANNEL" && this.close(br.UID_BANNED), void this.close()) : void this.reconnect(i.action, Cs.SERVER_ERROR);
          Ee.error("[".concat(this.clientId, "] ignore error: "), i.desc);
        }
      }
      handlePingPong() {
        if (!this.websocket || this.websocket.state !== "connected") return;
        this.pingpongTimeoutCount > 0 && this.rttRolling.add(3e3), this.pingpongTimeoutCount += 1;
        const n = ft("PING_PONG_TIME_OUT"), i = Date.now();
        this.pingpongTimeoutCount >= n && (Ee.warning("[".concat(this.clientId, "] PING-PONG Timeout. Last Socket Message: ").concat(i - this.lastMsgTime, "ms")), i - this.lastMsgTime > ft("WEBSOCKET_TIMEOUT_MIN")) ? this.reconnect("retry", Cs.TIMEOUT) : this.request(kn.PING, void 0, !0).then(() => {
          this.pingpongTimeoutCount = 0;
          const o = Date.now() - i;
          this.rttRolling.add(o), ft("REPORT_STATS") && this.send(kn.PING_BACK, { pingpongElapse: o });
        }).catch((o) => {
        });
      }
      handleWsInflateData() {
        const { wsInflateLength: n, wsDeflateLength: i } = this.websocket.getWsInflateData();
        n !== 0 && i !== 0 && this.upload(kE.WS_INFLATE_DATA_LENGTH, { ws_deflate_length: i, ws_inflate_length: n });
      }
      handleWebsocketEvents() {
        this.websocket.on(Fn.RECONNECT_CREATE_CONNECTION, (n) => {
          this.emit(jn.WS_RECONNECT_CREATE_CONNECTION, n);
        }), this.websocket.on(Fn.ON_MESSAGE, this.onWebsocketMessage), this.websocket.on(Fn.CLOSED, () => {
          this.connectionState = Vr.CLOSED;
        }), this.websocket.on(Fn.FAILED, () => {
          this._disconnectedReason = br.NETWORK_ERROR, this.connectionState = Vr.CLOSED;
        }), this.websocket.on(Fn.RECONNECTING, (n) => {
          this._websocketReconnectReason = n, this.joinResponse = void 0, this.connectionState === Vr.CONNECTED ? this.connectionState = Vr.RECONNECTING : this.connectionState = Vr.CONNECTING;
        }), this.websocket.on(Fn.WILL_RECONNECT, (n, i, o) => {
          const f = wE(this, jn.IS_P2P_DISCONNECTED), T = f || n !== "retry";
          f && n === "retry" && (Ee.debug("".concat(this.clientId, " reconnect mode is retry, but p2p lost, change to tryNext")), n = "tryNext", i = PT.P2P_DISCONNECTED), T && (Ee.debug("".concat(this.clientId, " will renewSession, reconnect mode: ").concat(n)), this.emit(jn.REPORT_JOIN_GATEWAY, i || PT.UNKNOWN_REASON, this.url || ""), this.reconnectToken = void 0, this.emit(jn.DISCONNECT_P2P)), o(n);
        }), this.websocket.on(Fn.CONNECTED, () => {
          this.openConnectionTime = Date.now(), this.reconnectToken ? this.rejoin().catch((n) => {
            Ee.warning("[".concat(this.clientId, "] rejoin failed ").concat(n)), this.reconnect("tryNext", Cs.SERVER_ERROR);
          }) : this.join().catch((n) => {
            if (this.emit(jn.REPORT_JOIN_GATEWAY, n, this.url || ""), n instanceof jt) {
              if (n.code === Je.UNEXPECTED_RESPONSE && n.data.code === xn.ERR_NO_AUTHORIZED) return this.initError = new jt(Je.TOKEN_EXPIRE, "dynamic key expired"), void this.close(br.TOKEN_EXPIRE);
              Ee.error("[".concat(this.clientId, "] join gateway request failed"), n.toString()), this.spec.forceWaitGatewayResponse ? this.reconnect("tryNext", Cs.SERVER_ERROR) : (this.initError = n, this.close());
            }
          });
        }), this.websocket.on(Fn.REQUEST_NEW_URLS, (n, i) => {
          Ss(this, jn.REQUEST_RECOVER, this.multiIpOption).then(n).catch(i);
        }), this.websocket.on(Fn.ON_TOKEN_PRIVILEGE_DID_EXPIRE, () => {
          this.emit(nr.ON_TOKEN_PRIVILEGE_DID_EXPIRE);
        }), this.websocket.on(Y8.PRE_CONNECT_PC, () => {
          this.emit(jn.PRE_CONNECT_PC);
        });
      }
    }
    let Li = function(e) {
      return e[e.CHOOSE_SERVER = 11] = "CHOOSE_SERVER", e[e.CLOUD_PROXY = 18] = "CLOUD_PROXY", e[e.CLOUD_PROXY_5 = 20] = "CLOUD_PROXY_5", e[e.CLOUD_PROXY_FALLBACK = 26] = "CLOUD_PROXY_FALLBACK", e;
    }({});
    function J8(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function DT(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? J8(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : J8(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    function Ap(e) {
      return e.match(/^[\.\:\d]+$/) ? "".concat(e.replace(/[^\d]/g, "-"), ".").concat(ft("TURN_DOMAIN")) : (Ee.debug("Cannot recognized as ip address: ".concat(e, ", use as host")), e);
    }
    function TI(e, n) {
      e.addresses || (e.addresses = []);
      const i = function(R, P) {
        if (ft("CONNECT_GATEWAY_WITHOUT_DOMAIN")) return R.map((Y) => {
          let { ip: te, port: oe } = Y;
          return { address: "".concat(te, ":").concat(oe) };
        });
        const L = ft("GATEWAY_DOMAINS");
        let z = L[1] && on(P).call(P, L[1]) ? 1 : 0;
        return R.map((Y) => {
          let { domain_prefix: te, port: oe, ip: He } = Y;
          if (te) return { address: "".concat(te, ".").concat(L[z++ % L.length], ":").concat(oe) };
          const Re = /^[\.\:\d]+$/.test(He), De = Re ? "".concat(He.replace(/[^\d]/g, "-"), ".").concat(L[z++ % L.length], ":").concat(oe) : "".concat(He, ":").concat(oe);
          return Re || Ee.debug("Cannot recognized as ip address: ".concat(He, ", use as host")), { ip: He, port: oe, address: De };
        });
      }(e.addresses, n), o = Array.isArray(e.detail) && e.detail[18];
      if (o && typeof o == "string") {
        const R = o.split(";");
        for (let P = 0; P < R.length; P++) {
          var f;
          const L = Ys(f = R[P]).call(f);
          i[P] && L && (i[P].ip6 = L);
        }
      }
      const T = e.detail && e.detail.candidate;
      let A;
      if (T) {
        const [R, P] = T.split(":");
        R && P && (A = { port: Number(P), ip: R, address: "".concat(R, ":").concat(P) });
      }
      return { gatewayAddrs: i, apGatewayAddress: A, uid: e.uid, cid: e.cid, cert: e.cert, vid: e.detail && e.detail[8], uni_lbs_ip: e.detail && e.detail[1], res: e, csIp: e.detail && e.detail[502] };
    }
    function Ga(e) {
      return typeof e == "number" ? e : e.exact || e.ideal || e.max || e.min || 0;
    }
    function Z8(e) {
      const n = e._encoderConfig;
      if (!n) return {};
      const i = { resolution: n.width && n.height ? "".concat(Ga(n.width), "x").concat(Ga(n.height)) : void 0, maxVideoBW: n.bitrateMax, minVideoBW: n.bitrateMin };
      return typeof n.frameRate == "number" ? (i.maxFrameRate = n.frameRate, i.minFrameRate = n.frameRate) : n.frameRate && (i.maxFrameRate = n.frameRate.max || n.frameRate.ideal || n.frameRate.exact || n.frameRate.min, i.minFrameRate = n.frameRate.min || n.frameRate.ideal || n.frameRate.exact || n.frameRate.max), i;
    }
    function Q8(e) {
      return e >= 0 && e < 0.17 ? 1 : e >= 0.17 && e < 0.36 ? 2 : e >= 0.36 && e < 0.59 ? 3 : e >= 0.59 && e <= 1 ? 4 : e > 1 ? 5 : 0;
    }
    function BE(e, n) {
      let i, o, f;
      switch (n) {
        case Li.CHOOSE_SERVER:
          o = 4096, f = "choose server";
          break;
        case Li.CLOUD_PROXY:
          o = 1048576, f = "proxy";
          break;
        case Li.CLOUD_PROXY_5:
          o = 4194304, f = "proxy5";
          break;
        case Li.CLOUD_PROXY_FALLBACK:
          o = 4194310, f = "proxy fallback";
          break;
        default:
          throw new jt(Je.UNEXPECTED_ERROR, "multi unlibs response transformer get unknown service id", { csIp: e.detail && e.detail[502], retry: !1 });
      }
      if (e.response_body.forEach((T) => {
        T.buffer && T.buffer.flag === o && (i = { code: T.buffer.code, addresses: (T.buffer.edges_services || []).map((A) => DT(DT({}, A), {}, { ticket: T.buffer.cert })), server_ts: e.enter_ts, uid: T.buffer.uid, cid: T.buffer.cid, cname: T.buffer.cname, detail: DT(DT({}, T.buffer.detail), e.detail), flag: T.buffer.flag, opid: e.opid, cert: T.buffer.cert });
      }), !i) throw new jt(Je.MULTI_UNILBS_RESPONSE_ERROR, "cannot parse response ".concat(f, " from multi unilbs response"), { csIp: e.detail && e.detail[502] });
      return i;
    }
    async function $8(e, n) {
      return await cn.all(e.addresses.map(async (i) => ({ address: Ap(i.ip), tcpport: i.port, udpport: i.port, username: n && ft("ENCRYPT_PROXY_USERNAME_AND_PSW") && window.isSecureContext ? n.toString() : Is.username, password: n && ft("ENCRYPT_PROXY_USERNAME_AND_PSW") && window.isSecureContext ? await LS(n.toString()) : Is.password })));
    }
    function bI(e, n) {
      const i = n.getMediaStreamTrack(!0).getSettings(), o = n.videoHeight || i.height, f = n.videoWidth || i.width;
      return o && f ? Math.max(Math.min(o, f) / Math.min(Ga(e.height), Ga(e.width)), 1) : (Ee.warning("can't get ori-track's height, default scale down 4 times for low stream"), 4);
    }
    function sl(e) {
      let { candidateType: n, relayProtocol: i, type: o, address: f, port: T, protocol: A } = e;
      const R = { candidateType: n, relayProtocol: i, protocol: A };
      if (o !== "local-candidate") {
        const P = f.split(".");
        P.length >= 4 && (P[1] = "*", P[2] = "*"), R.address = P.join("."), R.port = T;
      }
      return R;
    }
    function MT() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ft("SVC_MODE");
      if (ft("ENABLE_SVC")) return function(n) {
        return n in gT;
      }(e) ? e : gT.L1T3;
    }
    const e6 = { [vn.VIDEO]: [{ key: "abs-send-time", extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time" }, { key: "video-orientation", extensionName: "urn:3gpp:video-orientation" }, { key: "draft-holmer-rmcat-transport-wide-cc-extensions-01", extensionName: "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" }, { key: "playout-delay", extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/playout-delay" }, { key: "video-content-type", extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/video-content-type" }, { key: "color-space", extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/color-space" }, { key: "video-timing", extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/video-timing" }], [vn.AUDIO]: [{ key: "ssrc-audio-level", extensionName: "urn:ietf:params:rtp-hdrext:ssrc-audio-level" }, { key: "draft-holmer-rmcat-transport-wide-cc-extensions-01", extensionName: "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" }, { key: "abs-send-time", extensionName: "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time" }] };
    function LT(e, n, i) {
      n.forEach((o) => {
        var f;
        const T = e6[e].find((R) => {
          var P;
          let { key: L } = R;
          return on(P = o.extensionName).call(P, L);
        });
        if (!T) return;
        const A = i.find((R) => {
          let { extensionName: P } = R;
          return on(P).call(P, T.key);
        });
        A && on(f = A.extensionName).call(f, "gdpr_forbidden") && (o.extensionName = A.extensionName);
      });
    }
    function Op(e, n) {
      n.forEach((i) => {
        var o;
        const f = e6[e].find((T) => {
          var A;
          let { key: R } = T;
          return on(A = i.extensionName).call(A, R);
        });
        on(o = i.extensionName).call(o, "gdpr_forbidden") && f && (i.extensionName = f.extensionName);
      });
    }
    function t6(e) {
      return e === "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time" || on(e).call(e, "abs-send-time");
    }
    function kT(e) {
      return e === "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01" || on(e).call(e, "draft-holmer-rmcat-transport-wide-cc-extensions-01");
    }
    function n6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function r6(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? n6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : n6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    function zE(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = arguments.length > 3 ? arguments[3] : void 0;
      const { filterRTX: f, filterVideoFec: T, filterAudioFec: A, filterAudioCodec: R, filterVideoCodec: P } = n, { useXR: L } = i;
      let z = [], Y = [], te = [], oe = [], He = !1, Re = !1;
      if (Ca(e).mediaDescriptions.forEach((Xe) => {
        o && o !== Xe.attributes.direction || (Xe.media.mediaType !== "video" || He || (Y = Xe.attributes.payloads, oe = Xe.attributes.extmaps, He = !0), Xe.media.mediaType !== "audio" || Re || (z = Xe.attributes.payloads, te = Xe.attributes.extmaps, Re = !0));
      }), !oe || Y.length === 0) throw new Error("Cannot get video capabilities from SDP.");
      if (!te || z.length === 0) throw new Error("Cannot get audio capabilities from SDP.");
      if (Y.forEach((Xe) => {
        var We;
        (We = Xe.rtpMap) !== null && We !== void 0 && We.clockRate && (Xe.rtpMap.clockRate = parseInt(Xe.rtpMap.clockRate)), L && Xe.rtcpFeedbacks.push({ type: "rrtr" });
      }), z.forEach((Xe) => {
        var We;
        (We = Xe.rtpMap) !== null && We !== void 0 && We.clockRate && (Xe.rtpMap.clockRate = parseInt(Xe.rtpMap.clockRate)), L && Xe.rtcpFeedbacks.push({ type: "rrtr" });
      }), f && (z = z.filter((Xe) => {
        var We;
        return ((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName.toLowerCase()) !== "rtx";
      }), Y = Y.filter((Xe) => {
        var We;
        return ((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName.toLowerCase()) !== "rtx";
      })), T && (Y = Y.filter((Xe) => {
        var We;
        return !/(red)|(ulpfec)|(flexfec)/i.test(((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName) || "");
      })), A && (z = z.filter((Xe) => {
        var We;
        return !/(red)|(ulpfec)|(flexfec)/i.test(((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName) || "");
      })), R && (R == null ? void 0 : R.length) > 0 && (z = z.filter((Xe) => {
        var We;
        return on(R).call(R, ((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName.toLowerCase()) || "");
      })), P && (P == null ? void 0 : P.length) > 0) {
        const Xe = Y.filter((We) => {
          var mt;
          return on(P).call(P, ((mt = We.rtpMap) === null || mt === void 0 ? void 0 : mt.encodingName.toLowerCase()) || "");
        });
        Y = Xe.concat(f ? [] : CI(Xe, Y));
      }
      const De = ft("UNSUPPORTED_VIDEO_CODEC");
      return De && De.length > 0 && (Y = Y.filter((Xe) => !(Xe.rtpMap && on(De).call(De, Xe.rtpMap.encodingName.toLowerCase())))), { audioCodecs: z, videoCodecs: Y, audioExtensions: te, videoExtensions: oe };
    }
    function al(e) {
      const n = Ca(e);
      let i, o;
      for (const f of n.mediaDescriptions) {
        if (!i) {
          const T = f.attributes.iceUfrag, A = f.attributes.icePwd;
          if (!T || !A) throw new Error("Cannot get iceUfrag or icePwd from SDP.");
          i = { iceUfrag: T, icePwd: A };
        }
        if (!o) {
          const T = f.attributes.fingerprints;
          T.length > 0 && (o = { fingerprints: T });
        }
      }
      if (!o && n.attributes.fingerprints.length > 0 && (o = { fingerprints: n.attributes.fingerprints }), !o || !i) throw new Error("Cannot get iceParameters or dtlsParameters from SDP.");
      return { iceParameters: i, dtlsParameters: o };
    }
    function i6(e, n) {
      const i = [], o = e.attributes.ssrcGroups.filter((A) => A.semantic === "FID"), f = e.attributes.ssrcGroups.find((A) => A.semantic === "SIM"), T = e.attributes.ssrcs;
      if (f) f.ssrcIds.forEach((A) => {
        var R;
        const P = (R = o.find((L) => L.ssrcIds[0] === A)) === null || R === void 0 ? void 0 : R.ssrcIds[1];
        i.push({ ssrcId: A, rtx: n ? P : void 0 });
      });
      else if (o.length > 0) {
        const A = o[0].ssrcIds[0], R = o[0].ssrcIds[1];
        i.push({ ssrcId: A, rtx: n ? R : void 0 });
      } else {
        if (T.length === 0) throw new Error("No ssrcs found on local media description.");
        i.push({ ssrcId: T[0].ssrcId });
      }
      return i;
    }
    function s6(e, n, i) {
      const { cname: o } = e;
      let f = [];
      n && (f = a6(n)), f.length === 0 && (f = e.iceParameters.candidates.map((z) => ({ foundation: z.foundation, componentId: "1", transport: z.protocol, priority: z.priority.toString(), connectionAddress: z.ip, port: z.port.toString(), type: z.type, extension: {} })), Ee.debug("Using candidates from gateway."));
      const T = { fingerprints: e.dtlsParameters.fingerprints.map((z) => ({ hashFunction: z.algorithm, fingerprint: z.fingerprint })) }, A = { iceUfrag: e.iceParameters.iceUfrag, icePwd: e.iceParameters.icePwd };
      let R;
      switch (e.dtlsParameters.role) {
        case "server":
          R = "passive";
          break;
        case "client":
          R = "active";
          break;
        case "auto":
          R = "actpass";
      }
      const P = UT(e.rtpCapabilities), L = [];
      return Array.isArray(i) && i.length > 0 && i.forEach((z) => {
        L.push({ kind: vn.VIDEO, ssrcId: z.v, rtx: z.v_rtx, mslabel: "".concat(z.v, "_").concat(z.a) }, { kind: vn.AUDIO, ssrcId: z.a, mslabel: "".concat(z.v, "_").concat(z.a) });
      }), { dtlsParameters: T, iceParameters: A, candidates: f, rtpCapabilities: P, setup: R, cname: o, preSSRCs: L };
    }
    function a6(e) {
      let n = [];
      return e.ip && typeof e.port == "number" && (n = [{ foundation: "udpcandidate", componentId: "1", transport: "udp", priority: "2103266323", connectionAddress: e.ip, port: e.port.toString(), type: "host", extension: {} }], Ee.debug("Using remote candidate from AP ".concat(e.ip, ":").concat(e.port)), e.ip6 && (n.push({ foundation: "udpcandidate", componentId: "1", transport: "udp", priority: "2103266323", connectionAddress: e.ip6, port: e.port.toString(), type: "host", extension: {} }), Ee.debug("Using IPV6 remote candidate from AP ".concat(e.ip6, ":").concat(e.port)))), n;
    }
    function Rf(e, n, i) {
      const o = [], f = [];
      return e.forEach((T) => {
        let { ssrcId: A, rtx: R } = T;
        const P = zr(8, "track-"), L = { ssrcId: A, attributes: r6({ label: P, mslabel: i = i || zr(10, ""), msid: "".concat(i, " ").concat(P) }, n && { cname: n }) };
        if (o.push(L), R !== void 0) {
          const z = { ssrcId: R, attributes: r6({ label: P, mslabel: i, msid: "".concat(i, " ").concat(P) }, n && { cname: n }) };
          o.push(z), f.push({ semantic: "FID", ssrcIds: [A, R] });
        }
      }), e.length > 1 && f.push({ semantic: "SIM", ssrcIds: e.map((T) => {
        let { ssrcId: A } = T;
        return A;
      }) }), { ssrcs: o, ssrcGroups: f };
    }
    function Cp(e, n) {
      n instanceof li && e.attributes.payloads.forEach((i) => {
        var o;
        const f = (o = i.rtpMap) === null || o === void 0 ? void 0 : o.encodingName.toLowerCase();
        if (!f || ["opus", "pcmu", "pcma", "g722"].indexOf(f) === -1) return;
        i.fmtp || (i.fmtp = { parameters: {} }), i.fmtp.parameters.minptime = "10", i.fmtp.parameters.useinbandfec = "1";
        const T = n._encoderConfig;
        T && f !== "pcmu" && f !== "pcma" && f !== "g722" && (T.bitrate && !ui() && (i.fmtp.parameters.maxaveragebitrate = "".concat(Math.floor(1e3 * T.bitrate))), T.sampleRate && (i.fmtp.parameters.maxplaybackrate = "".concat(T.sampleRate), i.fmtp.parameters["sprop-maxcapturerate"] = "".concat(T.sampleRate)), T.stereo && (i.fmtp.parameters.stereo = "1", i.fmtp.parameters["sprop-stereo"] = "1"));
      });
    }
    function AI(e) {
      const n = e.attributes.unrecognized.findIndex((i) => i.attField === "x-google-flag" && i.attValue === "conference");
      n !== -1 && e.attributes.unrecognized.splice(n, 1);
    }
    function OI(e, n) {
      var i;
      if (!(n instanceof Wr && n._encoderConfig && n._hints.indexOf(Fr.SCREEN_TRACK) === -1)) return;
      const o = n._encoderConfig;
      pr().supportMinBitrate && o.bitrateMin && e.attributes.payloads.forEach((f) => {
        var T, A;
        on(T = ["h264", "h265", "vp8", "vp9", "av1"]).call(T, ((A = f.rtpMap) === null || A === void 0 ? void 0 : A.encodingName.toLowerCase()) || "") && (f.fmtp || (f.fmtp = { parameters: {} }), f.fmtp.parameters["x-google-min-bitrate"] = "".concat(o.bitrateMin));
      }), pr().supportMinBitrate && !on(i = n._hints).call(i, Fr.LOW_STREAM) && o.bitrateMax && e.attributes.payloads.forEach((f) => {
        var T, A;
        on(T = ["h264", "h265", "vp8", "vp9", "av1"]).call(T, ((A = f.rtpMap) === null || A === void 0 ? void 0 : A.encodingName.toLowerCase()) || "") && (f.fmtp || (f.fmtp = { parameters: {} }), f.fmtp.parameters["x-google-start-bitrate"] = "".concat(ft("X_GOOGLE_START_BITRATE") || Math.floor(o.bitrateMax)));
      });
    }
    function o6(e) {
      if (e.media.mediaType !== "video") return;
      const n = hr();
      if (n.name !== Cr.SAFARI && n.os !== ts.IOS) return;
      const i = e.attributes.extmaps.findIndex((o) => /video-orientation/g.test(o.extensionName));
      i !== -1 && e.attributes.extmaps.splice(i, 1);
    }
    function jT(e, n, i) {
      if (!n) return;
      let o, f;
      if (e.media.mediaType === "video" ? (o = i.videoExtensions, f = i.videoCodecs) : (o = i.audioExtensions, f = i.audioCodecs), n.twcc === !0) {
        const T = o.find((A) => kT(A.extensionName));
        if (T) {
          const A = T.extensionName;
          e.attributes.extmaps.find((P) => kT(P.extensionName)) || e.attributes.extmaps.push({ entry: T.entry, extensionName: A }), function(P, L) {
            return L.filter((z) => !!P.find((Y) => Y.payloadType === z.payloadType && !!Y.rtcpFeedbacks.find((te) => te.type === "transport-cc")));
          }(f, e.attributes.payloads).forEach((P) => {
            P.rtcpFeedbacks.find((L) => L.type === "transport-cc") || P.rtcpFeedbacks.push({ type: "transport-cc" });
          });
        }
      } else if (n.twcc === !1) {
        const T = e.attributes.extmaps.findIndex((A) => kT(A.extensionName));
        T !== -1 && e.attributes.extmaps.splice(T, 1), e.attributes.payloads.forEach((A) => {
          const R = A.rtcpFeedbacks.findIndex((P) => P.type === "transport-cc");
          R !== -1 && A.rtcpFeedbacks.splice(R, 1);
        });
      }
      if (n.remb === !0) {
        const T = o.find((A) => t6(A.extensionName));
        if (T) {
          const A = T.extensionName;
          e.attributes.extmaps.find((P) => P.extensionName === A) || e.attributes.extmaps.push({ entry: T.entry, extensionName: A }), function(P, L) {
            return L.filter((z) => !!P.find((Y) => Y.payloadType === z.payloadType && !!Y.rtcpFeedbacks.find((te) => te.type === "goog-remb")));
          }(f, e.attributes.payloads).forEach((P) => {
            P.rtcpFeedbacks.find((L) => L.type === "goog-remb") || P.rtcpFeedbacks.push({ type: "goog-remb" });
          });
        }
      } else if (n.remb === !1) {
        const T = e.attributes.extmaps.findIndex((A) => t6(A.extensionName));
        T !== -1 && e.attributes.extmaps.splice(T, 1), e.attributes.payloads.forEach((A) => {
          const R = A.rtcpFeedbacks.findIndex((P) => P.type === "goog-remb");
          R !== -1 && A.rtcpFeedbacks.splice(R, 1);
        });
      }
    }
    function c6(e, n, i) {
      if (ui() || e.media.mediaType !== "video" || !(n instanceof Wr) || i !== "vp9" && i !== "vp8" || i === "vp8" && !ft("SIMULCAST") || i === "vp9" && ft("ENABLE_SVC") || n._scalabilityMode === void 0 || n._scalabilityMode.numSpatialLayers <= 1) return;
      const o = i === "vp8" ? 2 : n._scalabilityMode.numSpatialLayers, f = e.attributes.ssrcs[0], T = e.attributes.ssrcGroups.find((R) => R.semantic === "FID" && R.ssrcIds[0] === f.ssrcId), A = { semantic: "SIM", ssrcIds: [f.ssrcId] };
      for (let R = 1; R < o; R++) e.attributes.ssrcs.push({ ssrcId: f.ssrcId + R, attributes: di(f.attributes) }), A.ssrcIds.push(f.ssrcId + R), T && (e.attributes.ssrcs.push({ ssrcId: T.ssrcIds[1] + R, attributes: di(f.attributes) }), e.attributes.ssrcGroups.push({ semantic: "FID", ssrcIds: [f.ssrcId + R, T.ssrcIds[1] + R] }));
      e.attributes.ssrcGroups.unshift(A);
    }
    async function u6() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const i = new RTCPeerConnection();
      i.addTransceiver("video", { direction: "sendonly" }), i.addTransceiver("audio", { direction: "sendonly" }), i.addTransceiver("video", { direction: "recvonly" }), i.addTransceiver("audio", { direction: "recvonly" });
      const o = (await i.createOffer()).sdp, { send: f, recv: T, sendrecv: A } = function() {
        let R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, L = arguments.length > 2 ? arguments[2] : void 0;
        const z = zE(L, R, P, "sendonly"), Y = zE(L, R, P, "recvonly"), te = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, oe = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, He = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] };
        if (uc(z, Y, "videoExtensions", te, oe, He), uc(z, Y, "videoCodecs", te, oe, He), uc(z, Y, "audioExtensions", te, oe, He), uc(z, Y, "audioCodecs", te, oe, He), ft("RAISE_H264_BASELINE_PRIORITY")) {
          const Re = [], De = [];
          He.videoCodecs.forEach((Xe, We) => {
            var mt;
            if (((mt = Xe.rtpMap) === null || mt === void 0 ? void 0 : mt.encodingName.toLocaleLowerCase()) === "h264") {
              var Pt, xt;
              const Nt = He.videoCodecs[We + 1], Vt = Nt && p6(Xe, Nt), nn = (Pt = Xe.fmtp) === null || Pt === void 0 ? void 0 : Pt.parameters["profile-level-id"], fn = (xt = Xe.fmtp) === null || xt === void 0 ? void 0 : xt.parameters["packetization-mode"];
              !nn || nn !== ft("FIRST_H264_PROFILE_LEVEL_ID") || ft("FIRST_PACKETIZATION_MODE") && fn !== ft("FIRST_PACKETIZATION_MODE") ? Vt ? De.push([Xe, Nt]) : De.push([Xe]) : Vt ? Re.push([Xe, Nt]) : Re.push([Xe]);
            }
          }), Re.length > 0 && De.length > 0 && (Ee.debug("raising H264 baseline profile priority"), He.videoCodecs.forEach((Xe, We) => {
            var mt;
            if (((mt = Xe.rtpMap) === null || mt === void 0 ? void 0 : mt.encodingName.toLocaleLowerCase()) === "h264") {
              const Pt = p6(Xe, He.videoCodecs[We + 1]), xt = Re.shift() || De.shift() || [];
              xt.length > 0 && (Pt ? He.videoCodecs.splice(We, 2, ...xt) : He.videoCodecs.splice(We, 1, ...xt));
            }
          }), oe.videoCodecs = oe.videoCodecs.filter((Xe) => {
            var We, mt;
            return !(((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName.toLocaleLowerCase()) === "h264" && ((mt = Xe.fmtp) === null || mt === void 0 ? void 0 : mt.parameters["profile-level-id"]) !== ft("FIRST_H264_PROFILE_LEVEL_ID"));
          }), ft("FILTER_SEND_H264_BASELINE") && (te.videoCodecs = te.videoCodecs.filter((Xe) => {
            var We, mt;
            return !(((We = Xe.rtpMap) === null || We === void 0 ? void 0 : We.encodingName.toLocaleLowerCase()) === "h264" && ((mt = Xe.fmtp) === null || mt === void 0 ? void 0 : mt.parameters["profile-level-id"]) !== ft("FIRST_H264_PROFILE_LEVEL_ID"));
          })));
        }
        return { send: te, recv: oe, sendrecv: He };
      }(e, n, o);
      try {
        i.close();
      } catch {
      }
      return { send: f, recv: T, sendrecv: A };
    }
    function d6() {
      const e = { audioCodecs: [], videoCodecs: [], audioExtensions: [], videoExtensions: [] }, n = zE(arguments.length > 2 ? arguments[2] : void 0, arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, "recvonly"), i = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, o = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, f = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] };
      if (uc(e, n, "videoExtensions", i, o, f), uc(e, n, "videoCodecs", i, o, f), uc(e, n, "audioExtensions", i, o, f), uc(e, n, "audioCodecs", i, o, f), ft("RAISE_H264_BASELINE_PRIORITY")) {
        const T = f.videoCodecs.findIndex((A) => A.rtpMap && A.rtpMap.encodingName.toLocaleLowerCase() === "h264" && A.fmtp && A.fmtp.parameters["profile-level-id"] === "42001f");
        if (T !== -1) {
          const A = f.videoCodecs.findIndex((R) => R.rtpMap && R.rtpMap.encodingName.toLocaleLowerCase() === "h264");
          if (A < T) {
            Ee.debug("raising H264 baseline profile priority");
            const R = f.videoCodecs[T];
            f.videoCodecs.splice(T, 1), f.videoCodecs.splice(A, 0, R);
          }
          A !== -1 && (o.videoCodecs = o.videoCodecs.filter((R) => !(R.rtpMap && R.rtpMap.encodingName.toLocaleLowerCase() === "h264" && R.fmtp && R.fmtp.parameters["profile-level-id"] !== "42001f")));
        }
      }
      return { send: i, recv: o, sendrecv: f };
    }
    function uc(e, n, i, o, f, T) {
      if (i === "videoExtensions" || i === "audioExtensions") {
        const A = [];
        return e[i].forEach((R) => {
          n[i].some((P, L) => {
            if (R.entry === P.entry && R.extensionName === P.extensionName) return A.push(L), !0;
          }) ? T[i].push(R) : o[i].push(R);
        }), void n[i].forEach((R, P) => {
          A.indexOf(P) === -1 && f[i].push(R);
        });
      }
      if (i === "videoCodecs" || i === "audioCodecs") {
        const A = [];
        return e[i].forEach((R) => {
          n[i].some((P, L) => {
            if (R.payloadType === P.payloadType && JSON.stringify(R) === JSON.stringify(P)) return A.push(L), !0;
          }) ? T[i].push(R) : o[i].push(R);
        }), void n[i].forEach((R, P) => {
          A.indexOf(P) === -1 && f[i].push(R);
        });
      }
    }
    function UT(e) {
      const { send: n, recv: i, sendrecv: o } = e;
      if (!o) {
        if (!n || !i) throw new Error("cannot merge rtp capabilities because one of send or recv is empty!");
        return { send: n, recv: i };
      }
      let f, T;
      return n ? (f = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, f.audioCodecs = [...n.audioCodecs, ...o.audioCodecs], f.videoCodecs = [...n.videoCodecs, ...o.videoCodecs], f.audioExtensions = [...n.audioExtensions, ...o.audioExtensions], f.videoExtensions = [...n.videoExtensions, ...o.videoExtensions]) : f = o, i ? (T = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, T.audioCodecs = [...i.audioCodecs, ...o.audioCodecs], T.videoCodecs = [...i.videoCodecs, ...o.videoCodecs], T.audioExtensions = [...i.audioExtensions, ...o.audioExtensions], T.videoExtensions = [...i.videoExtensions, ...o.videoExtensions]) : T = o, { send: f, recv: T };
    }
    function Sp(e) {
      e.media.mediaType === "audio" && e.attributes.payloads.filter((n) => {
        var i;
        return ((i = n.rtpMap) === null || i === void 0 ? void 0 : i.encodingName.toLowerCase()) === "opus";
      }).forEach((n) => {
        n.fmtp || (n.fmtp = { parameters: {} }), n.fmtp.parameters.stereo = "1", n.fmtp.parameters["sprop-stereo"] = "1";
      });
    }
    function FE(e, n, i, o) {
      let f = [];
      if (e === vn.VIDEO) {
        if (ft("H264_PROFILE_LEVEL_ID") && o === "h264" && (f = n.videoCodecs.filter((T) => {
          var A;
          return on(A = T.rtpMap && T.rtpMap.encodingName.toLowerCase() || "").call(A, o) && T && T.fmtp && T.fmtp.parameters["profile-level-id"] === ft("H264_PROFILE_LEVEL_ID");
        })), !Array.isArray(f) || f.length === 0) {
          let T = [];
          const A = [], R = [], P = [];
          if (i.videoCodecs.forEach((L) => {
            const z = L.rtpMap && L.rtpMap.encodingName.toLowerCase() || "";
            on(z).call(z, o) ? T.push(L) : on(z).call(z, "vp9") ? A.push(L) : on(z).call(z, "vp8") ? R.push(L) : on(z).call(z, "h264") && P.push(L);
          }), T.length === 0) {
            let L = "";
            A.length !== 0 ? (T = A, L = "vp9") : R.length !== 0 ? (T = R, L = "vp8") : P.length !== 0 && (T = P, L = "h264"), Ee.warning("codec ".concat(o, " not included in rtpCapabilities, fallback to default payloads: ").concat(L));
          }
          T.length !== 0 && (f = n.videoCodecs.filter((L) => T.some((z) => z.payloadType === L.payloadType)));
        }
        if (f.length === 0 && (Ee.warning("codec ".concat(o, " not included in rtpCapabilities, fallback to default payloads: ").concat(n.videoCodecs[0].rtpMap && n.videoCodecs[0].rtpMap.encodingName)), f = n.videoCodecs), ft("USE_PUB_RTX") || ft("USE_SUB_RTX")) {
          const T = CI(f, n.videoCodecs);
          f = [...f, ...T];
        }
      } else f = n.audioCodecs.filter((T) => {
        var A;
        return on(A = T.rtpMap && T.rtpMap.encodingName.toLowerCase() || "").call(A, o);
      }), f.length === 0 && (Ee.warning("codec ".concat(o, " not included in rtpCapabilities, fallback to opus")), f = n.audioCodecs.filter((T) => {
        var A;
        return on(A = T.rtpMap && T.rtpMap.encodingName.toLowerCase() || "").call(A, "opus");
      }));
      return f;
    }
    function CI(e, n) {
      const i = e.map((o) => o.payloadType.toString());
      return n.filter((o) => o.rtpMap && o.rtpMap.encodingName === "rtx" && o.fmtp && o.fmtp.parameters.apt && on(i).call(i, o.fmtp && o.fmtp.parameters.apt));
    }
    async function HT(e, n, i) {
      const o = n.toString(), f = f6(o, "offer", "remote", "exchangeSDP");
      await e.setRemoteDescription({ type: "offer", sdp: o });
      const T = await e.createAnswer();
      if (!T.sdp) throw new Error("cannot get answer sdp");
      let A = T.sdp;
      A = l6(A, i || {}), f == null || f(A || ""), await e.setLocalDescription({ type: "answer", sdp: A });
    }
    function l6(e, n, i) {
      const o = Ca(e), { useXR: f } = n;
      return o.mediaDescriptions.forEach((T) => {
        var A;
        T.attributes.mid && (Array.isArray(i) && !on(i).call(i, T.attributes.mid) || (T.media.mediaType === "audio" && Sp(T), f && on(A = ["audio", "video"]).call(A, T.media.mediaType) && T.attributes.payloads.forEach((R) => {
          R.rtcpFeedbacks.findIndex((P) => P.type === "rrtr") === -1 && R.rtcpFeedbacks.push({ type: "rrtr" });
        })));
      }), nl(o);
    }
    function f6(e, n, i, o) {
      if (ft("SDP_LOGGING")) return Ee.upload("exchanging ".concat(i, " ").concat(n, " SDP during P2PConnection.").concat(o, `
`), e), n === "offer" ? (f) => {
        f6(f, "answer", i === "local" ? "remote" : "local", o);
      } : void 0;
    }
    function h6(e) {
      const n = ft("COMPATIBLE_SDP_EXTENSION");
      return !!(Array.isArray(n) && n.length > 0) && n.some((i) => on(e).call(e, i));
    }
    function p6(e, n) {
      try {
        var i;
        return ((i = e.fmtp) === null || i === void 0 ? void 0 : i.parameters.apt) === n.payloadType.toString();
      } catch {
        return !1;
      }
    }
    function g6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function Au(e, n) {
      return typeof ft(e) === n ? ft(e) : void 0;
    }
    function lae() {
      try {
        const e = ft("EXPERIMENTS") || {};
        return typeof e == "string" || Array.isArray(e) ? {} : function(n) {
          for (var i = 1; i < arguments.length; i++) {
            var o = arguments[i] != null ? arguments[i] : {};
            i % 2 ? g6(Object(o), !0).forEach(function(f) {
              Ve(n, f, o[f]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : g6(Object(o)).forEach(function(f) {
              Object.defineProperty(n, f, Object.getOwnPropertyDescriptor(o, f));
            });
          }
          return n;
        }({}, e);
      } catch (e) {
        return Ee.debug("handle gateway attributes failed: ", e), {};
      }
    }
    const m6 = {};
    function Nf(e) {
      (!(arguments.length > 1 && arguments[1] !== void 0) || arguments[1]) && Ee.debug("install service ".concat(e.name)), m6[e.name] = e;
    }
    function ol(e) {
      const n = m6[e];
      if (!n) throw new Gt(Je.INVALID_OPERATION, "".concat(e, " not found, please use AgoraRTC.use(").concat(e, "Service) to load it first"));
      return n;
    }
    function E6(e, n) {
      return ol("DataStream").create(e, n);
    }
    function y6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function gd(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? y6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : y6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const SI = /* @__PURE__ */ new Map();
    class fae extends ii {
      get state() {
        return this._state;
      }
      set state(n) {
        if (n === this._state) return;
        const i = this._state;
        this._state = n, n === "DISCONNECTED" && this._disconnectedReason ? this.emit(Ns.CONNECTION_STATE_CHANGE, n, i, this._disconnectedReason) : this.emit(Ns.CONNECTION_STATE_CHANGE, n, i);
      }
      get joinGatewayStartTime() {
        return this._joinGatewayStartTime;
      }
      set joinGatewayStartTime(n) {
        Ee.debug("[".concat(this.store.clientId, "] set joinGatewayStartTime at ").concat(n)), this._joinGatewayStartTime = n;
      }
      constructor(n, i) {
        var o, f, T;
        super(), Ve(this, "store", void 0), Ve(this, "joinInfo", void 0), Ve(this, "key", void 0), Ve(this, "ntpOffset", 0), Ve(this, "signal", void 0), Ve(this, "role", void 0), Ve(this, "inChannelInfo", { joinAt: null, duration: 0 }), Ve(this, "spec", void 0), Ve(this, "_state", "DISCONNECTED"), Ve(this, "_statsCollector", void 0), Ve(this, "_disconnectedReason", void 0), Ve(this, "isSignalRecover", !1), Ve(this, "hasChangeBGPAddress", !1), Ve(this, "trafficStatsInterval", void 0), Ve(this, "networkQualityInterval", void 0), Ve(this, "_joinGatewayStartTime", 0), Ve(this, "_signalTimeout", !1), Ve(this, "_clientRoleOptions", void 0), Ve(this, "_isProactiveJoin", !1), this.store = n, this.spec = i, this.signal = this.store.useP2P ? (o = { spec: gd(gd({}, i), {}, { retryConfig: i.websocketRetryConfig }), store: n }, (f = (T = ol("P2PChannel")).createSubmodule) === null || f === void 0 ? void 0 : f.call(T, o)) : new dae(gd(gd({}, i), {}, { retryConfig: i.websocketRetryConfig }), n), this._statsCollector = i.statsCollector, this.role = i.role || "audience", this._clientRoleOptions = i.clientRoleOptions, this.handleSignalEvents();
      }
      async join(n, i, o) {
        this.store.joinGatewayStart(), n.cloudProxyServer !== "disabled" && (this.hasChangeBGPAddress = !0);
        const f = Date.now();
        let T = SI.get(n.cname);
        if (T || (T = /* @__PURE__ */ new Map(), SI.set(n.cname, T)), this._isProactiveJoin = !0, T.has(n.uid)) {
          const L = new jt(Je.UID_CONFLICT);
          throw Cn.joinGateway(n.sid, { lts: f, succ: !1, ec: L.code, addr: null, uid: n.uid, cid: n.cid, firstSuccess: this._isProactiveJoin, avoidJoinStartTime: this.store.avoidJoinStart, isProxy: !!n.proxyServer, signalChannel: "0", preload: n.preload }), L;
        }
        T.set(n.uid, !0), this.joinInfo = n, this.key = i;
        let A = 0;
        this.joinGatewayStartTime = f;
        const R = n.proxyServer;
        try {
          Ee.debug("[".concat(this.store.clientId, "] use websocket join uid ").concat(A));
          const L = n.gatewayAddrs.map((z) => {
            let { address: Y } = z;
            const [te, oe] = Y.split(":"), He = { host: te, port: oe };
            return n.proxyServer && (He.proxy = n.proxyServer), He;
          });
          A = (await this.signal.init(L)).uid, Ee.debug("[".concat(this.store.clientId, "] websocket join uid ").concat(A, " cost ").concat(Date.now() - this.joinGatewayStartTime));
        } catch (L) {
          var P;
          throw Ee.error("[".concat(this.store.clientId, "] User join failed"), L.toString()), Cn.joinGateway(n.sid, { lts: f, succ: !1, ec: ((P = L.data) === null || P === void 0 ? void 0 : P.desc) || L.code, errorMsg: L.message, addr: this.signal.url, uid: n.uid, cid: n.cid, firstSuccess: this._isProactiveJoin, avoidJoinStartTime: this.store.avoidJoinStart, isProxy: !!R, signalChannel: "0", preload: n.preload }), T.delete(n.uid), this.signal.close(), L;
        }
        return this.state = "CONNECTED", this.inChannelInfo.joinAt = Date.now(), Ee.debug("[".concat(this.store.clientId, "] Connected to gateway server")), this.trafficStatsInterval = window.setInterval(() => {
          this.updateTrafficStats().catch((L) => {
            Ee.warning("[".concat(this.store.clientId, "] get traffic stats error"), L.toString());
          });
        }, 3e3), this.networkQualityInterval = window.setInterval(() => {
          navigator && navigator.onLine !== void 0 && !navigator.onLine ? this.emit(Ns.NETWORK_QUALITY, { downlinkNetworkQuality: 6, uplinkNetworkQuality: 6 }) : this._signalTimeout ? this.emit(Ns.NETWORK_QUALITY, { downlinkNetworkQuality: 5, uplinkNetworkQuality: 5 }) : this.state === "CONNECTED" && this._statsCollector.trafficStats ? this.emit(Ns.NETWORK_QUALITY, { uplinkNetworkQuality: Q8(this._statsCollector.trafficStats.B_unq), downlinkNetworkQuality: Q8(this._statsCollector.trafficStats.B_dnq) }) : this.emit(Ns.NETWORK_QUALITY, { uplinkNetworkQuality: 0, downlinkNetworkQuality: 0 });
        }, 2e3), this.store.joinGatewayEnd(), A;
      }
      async leave() {
        let n = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], i = arguments.length > 1 ? arguments[1] : void 0;
        if (this.state !== "DISCONNECTED") {
          i !== br.FALLBACK && (this.state = "DISCONNECTING");
          try {
            n || this.signal.connectionState !== Vr.CONNECTED || await function(o, f) {
              return f === 1 / 0 ? o : cn.race([o, Fie(f)]);
            }(this.signal.request(kn.LEAVE, void 0, !0), 3e3);
          } catch (o) {
            Ee.warning("[".concat(this.store.clientId, "] leave request failed, ignore"), o);
          }
          this.signal.close(i), i !== br.FALLBACK && (this.state = "DISCONNECTED"), this.reset();
        }
      }
      async publish(n, i, o) {
        if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));
        const f = { state: "offer", p2p_id: this.store.p2pId, ortc: i, mode: this.spec.mode, extend: ft("PUB_EXTEND"), twcc: !!ft("PUBLISH_TWCC"), rtx: !!ft("USE_PUB_RTX") };
        try {
          return (await this.signal.request(kn.PUBLISH, f, !0))._message;
        } catch (T) {
          if (o && T.data && T.data.code === xn.ERR_PUBLISH_REQUEST_INVALID) return Ee.warning("[".concat(this.store.clientId, "] receive publish error code, retry"), T.toString()), await this.tryUnpubBeforeRepub(n, i), this.publish(n, i, !1);
          throw T;
        }
      }
      async publishDataChannel(n, i, o) {
        var f;
        if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));
        const T = { stream_id: i.streamId, ordered: i.ordered ? 1 : 0, max_retrans_times: (f = i.maxRetransmits) !== null && f !== void 0 ? f : 10, channel_id: i.channelId, metadata: i.metadata };
        try {
          await this.signal.request(kn.PUBLISH_DATASTREAM, T, !0);
        } catch (A) {
          if (o && A.data && A.data.code === xn.ERR_PUBLISH_REQUEST_INVALID) return Ee.warning("[".concat(this.store.clientId, "] receive publish datachannels error code, retry"), A.toString()), await this.tryUnpubDataChannelBeforeRepub(n, i), this.publishDataChannel(n, i, !1);
          throw A;
        }
      }
      async unpublish(n, i) {
        try {
          if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));
          await this.signal.request(kn.UNPUBLISH, { stream_id: i, ortc: n }, !0);
        } catch (o) {
          Ee.warning("[".concat(this.store.clientId, "] unpublish warning: "), o);
        }
      }
      async unpublishDataChannel(n) {
        try {
          if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));
          await cn.all(n.map((i) => this.signal.request(kn.UNPUBLISH_DATASTREAM, { channel_id: i }, !0)));
        } catch (i) {
          Ee.warning("unpublish datachannels warning: ", i);
        }
      }
      async presubscribe(n, i, o) {
        if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not presubscribe when connection state is ".concat(this.state));
        const f = { stream_id: n, stream_type: i, mode: this.spec.mode, codec: this.spec.codec, p2p_id: this.store.p2pId, twcc: !!ft("SUBSCRIBE_TWCC"), rtx: !!ft("USE_SUB_RTX") || void 0, extend: ft("SUB_EXTEND"), svc: Array.isArray(ft("SVC")) && ft("SVC").length !== 0 ? ft("SVC") : void 0 };
        try {
          return await this.signal.request(kn.PRE_SUBSCRIBE, f, !0);
        } catch (T) {
          if (o && T.data && T.data.code === xn.ERR_SUBSCRIBE_REQUEST_INVALID) return Ee.warning("[".concat(this.store.clientId, "] pre-subscribe error, retry"), T.toString()), this.presubscribe(n, i, !1);
          throw T;
        }
      }
      async subscribe(n, i, o) {
        if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not subscribe when connection state is ".concat(this.state));
        const f = { stream_id: n, stream_type: i.stream_type, mode: this.spec.mode, codec: this.spec.codec, p2p_id: this.store.p2pId, twcc: !!ft("SUBSCRIBE_TWCC"), rtx: !!ft("USE_SUB_RTX"), extend: ft("SUB_EXTEND"), ssrcId: i.ssrcId, svc: Array.isArray(ft("SVC")) && ft("SVC").length !== 0 ? ft("SVC") : void 0 };
        try {
          return (await this.signal.request(kn.SUBSCRIBE, f, !0))._message;
        } catch (T) {
          if (o && T.data && T.data.code === xn.ERR_SUBSCRIBE_REQUEST_INVALID) return Ee.warning("[".concat(this.store.clientId, "] receiver subscribe error code, retry"), T.toString()), await this.tryUnsubBeforeResub(n, i), await this.subscribe(n, i, !1);
          throw T;
        }
      }
      async subscribeDataChannel(n, i, o) {
        if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not subscribe datachannel when connection state is ".concat(this.state));
        const f = { uid: n, stream_id: i.id, channel_id: i.datachannelId };
        try {
          return void await this.signal.request(kn.SUBSCRIBE_DATASTREAM, f, !0);
        } catch (T) {
          if (o && T.data && T.data.code === xn.ERR_SUBSCRIBE_REQUEST_INVALID) return Ee.warning("[".concat(this.store.clientId, "] receiver subscribe datachannel error code, retry"), T.toString()), await this.tryUnsubDataChannelBeforeResub(n, i), await this.subscribeDataChannel(n, i, !1);
          throw T;
        }
      }
      async subscribeAll(n, i) {
        if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not massSubscribe when connection state is ".concat(this.state));
        const o = { p2p_id: this.store.p2pId, users: n, dtx: !1, rtx: !!ft("USE_SUB_RTX"), twcc: !!ft("SUBSCRIBE_TWCC"), svc: Array.isArray(ft("SVC")) && ft("SVC").length !== 0 ? ft("SVC") : void 0 };
        try {
          return await this.signal.request(kn.SUBSCRIBE_STREAMS, o, !0);
        } catch (f) {
          if (i && f.data && f.data.code === xn.ERR_SUBSCRIBE_REQUEST_INVALID) return Ee.warning("[".concat(this.store.clientId, "] receiver massSubscribe error code, retry"), f.toString()), await this.tryMassUnsubBeforeResub(n), await this.subscribeAll(n, !1);
          throw f;
        }
      }
      async setVideoProfile(n) {
        const i = function(o) {
          if (!(o.bitrateMax && o.bitrateMin && o.frameRate && o.height && o.width)) return;
          let f = o.frameRate, T = o.width, A = o.height, R = !0;
          return typeof f != "number" && (f = f.exact || f.ideal || f.max || f.min || 0, f || (R = !1)), typeof T != "number" && (T = T.exact || T.ideal || T.max || T.min || 0, T || (R = !1)), typeof A != "number" && (A = A.exact || A.ideal || A.max || A.min || 0, f || (R = !1)), R ? { stream_type: 0, width: T, height: A, fps: f, start_bps: 1e3 * o.bitrateMax, min_bps: 1e3 * o.bitrateMin, target_bps: 1e3 * o.bitrateMax } : void 0;
        }(n);
        if (i) return this.signal.request(kn.SET_VIDEO_PROFILE, i);
        Ee.debug("[".concat(this.store.clientId, "] encoder config is not complete, do not report to gateway"));
      }
      async unsubscribe(n, i) {
        try {
          await this.signal.request(kn.UNSUBSCRIBE, { p2p_id: this.store.p2pId, ortc: n, stream_id: i }, !0);
        } catch (o) {
          Ee.warning("[".concat(this.store.clientId, "] unsubscribe warning: "), o);
        }
      }
      async unsubscribeDataChannel(n, i) {
        try {
          if (this.state !== "CONNECTED" && this.state !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish when connection state is ".concat(this.state));
          await cn.all(n.map((o) => this.signal.request(kn.UNSUBSCRIBE_DATASTREAM, { stream_id: o, uid: i }, !0)));
        } catch (o) {
          Ee.warning("unsubscribeDataChannel warning: ", o);
        }
      }
      async massUnsubscribe(n) {
        try {
          await this.signal.request(kn.UNSUBSCRIBE_STREAMS, n, !0);
        } catch (i) {
          Ee.warning("[".concat(this.store.clientId, "] massUnsubscribeAll warning: "), i);
        }
      }
      async reconnectPC(n) {
        const { iceParameters: i, dtlsParameters: o, rtpCapabilities: f } = n;
        return { gatewayEstablishParams: await this.signal.request(kn.CONNECT_PC, { p2p_id: this.store.p2pId, stream_id: this.store.uid, ortc: { iceParameters: i, dtlsParameters: o, rtpCapabilities: f } }, !0), gatewayAddress: this.getCurrentGatewayAddress() };
      }
      getGatewayInfo() {
        return this.signal.request(kn.GATEWAY_INFO);
      }
      async renewToken(n) {
        await this.signal.request(kn.RENEW_TOKEN, n), this.key = n.token;
      }
      updateClientRole(n, i) {
        i && (this._clientRoleOptions = Object.assign({}, i)), ft("CLIENT_ROLE_OPTIONS") && (Ee.debug("[".concat(this.store.clientId, "] Set roleOptions for ").concat(JSON.stringify(ft("CLIENT_ROLE_OPTIONS")), " instead of ").concat(JSON.stringify(this._clientRoleOptions), " ")), this._clientRoleOptions = Object.assign({}, ft("CLIENT_ROLE_OPTIONS"))), this.role = n;
      }
      async setClientRole(n, i) {
        if (i && (this._clientRoleOptions = Object.assign({}, i)), ft("CLIENT_ROLE_OPTIONS") && (this._clientRoleOptions = Object.assign({}, ft("CLIENT_ROLE_OPTIONS")), Ee.debug("[".concat(this.store.clientId, "] Set roleOptions for ").concat(JSON.stringify(ft("CLIENT_ROLE_OPTIONS")), " instead of ").concat(JSON.stringify(this._clientRoleOptions), " "))), this.state !== "CONNECTED") return void (this.role = n);
        let o, f = 0;
        n === "audience" ? this._clientRoleOptions && this._clientRoleOptions.delay ? (o = this._clientRoleOptions.delay, f = 1) : f = this._clientRoleOptions && this._clientRoleOptions.level ? this._clientRoleOptions.level : 2 : f = 0, await this.signal.request(kn.SET_CLIENT_ROLE, { role: n, level: f, delay: o, client_ts: Date.now() }), this.role = n;
      }
      async setRemoteVideoStreamType(n, i) {
        await this.signal.request(kn.SWITCH_VIDEO_STREAM, { stream_id: n, stream_type: i });
      }
      async setDefaultRemoteVideoStreamType(n) {
        await this.signal.request(kn.DEFAULT_VIDEO_STREAM, { stream_type: n });
      }
      async setStreamFallbackOption(n, i) {
        await this.signal.request(kn.SET_FALLBACK_OPTION, { stream_id: n, fallback_type: i });
      }
      async pickSVCLayer(n, i) {
        await this.signal.request(kn.PICK_SVC_LAYER, { stream_id: n, spatial_layer: i.spatialLayer, temporal_layer: i.temporalLayer });
      }
      async setRTM2Flag(n) {
        await this.signal.request(kn.SET_RTM2_FLAG, { rtm2_flag: n });
      }
      async sendExtensionMessage(n, i, o) {
        if (this.store.useP2P) return this.signal.sendExtensionMessage(n, i, o);
      }
      getInChannelInfo() {
        return this.inChannelInfo.joinAt && (this.inChannelInfo.duration = Date.now() - this.inChannelInfo.joinAt), gd({}, this.inChannelInfo);
      }
      async getGatewayVersion() {
        return (await this.signal.request(kn.GATEWAY_INFO)).version;
      }
      reset() {
        if (this.inChannelInfo.joinAt && (this.inChannelInfo.duration = Date.now() - this.inChannelInfo.joinAt, this.inChannelInfo.joinAt = null), this.trafficStatsInterval && (window.clearInterval(this.trafficStatsInterval), this.trafficStatsInterval = void 0), this.joinInfo) {
          const n = SI.get(this.joinInfo.cname);
          n && n.delete(this.joinInfo.uid);
        }
        this.joinInfo = void 0, this.key = void 0, this.networkQualityInterval && (window.clearInterval(this.networkQualityInterval), this.networkQualityInterval = void 0);
      }
      updateTurnConfigFromSignal() {
        if (!this.joinInfo) return;
        const n = function(i) {
          let o;
          return o = i.startsWith("dc") ? i.match(/(dc\:\/\/)?([^:]+):(\d+)/) : i.match(/(wss\:\/\/)?([^:]+):(\d+)/), o ? { username: Is.username, password: Is.password, turnServerURL: o[2], tcpport: parseInt(o[3]) + 30, udpport: parseInt(o[3]) + 30, forceturn: !1 } : null;
        }((this.joinInfo.cloudProxyServer === "disabled" ? this.signal.url : this.joinInfo.gatewayAddrs[this.signal.currentURLIndex].address) || "");
        this.joinInfo.turnServer.serversFromGateway = [], n && this.joinInfo.turnServer.mode !== "off" && this.joinInfo.cloudProxyServer === "disabled" && this.joinInfo.turnServer.serversFromGateway.push(gd(gd({}, Is), {}, { turnServerURL: n.turnServerURL, tcpport: n.tcpport, udpport: n.udpport, username: this.joinInfo.uid.toString(), password: this.joinInfo.token }));
      }
      async updateTrafficStats() {
        if (this.state !== "CONNECTED") return;
        const n = await this.signal.request(kn.TRAFFIC_STATS, void 0, !0);
        n.timestamp = Date.now(), n.ntp_offset != null && (this.ntpOffset = n.ntp_offset), n.peer_delay.forEach((i) => {
          const o = this._statsCollector.trafficStats && this._statsCollector.trafficStats.peer_delay.find((f) => f.peer_uid === i.peer_uid);
          o && o.B_st !== i.B_st && lT(() => {
            this.emit(Ns.STREAM_TYPE_CHANGE, i.peer_uid, i.B_st);
          });
        }), this._statsCollector.updateTrafficStats(n);
      }
      getJoinMessage(n) {
        if (!this.joinInfo || !this.key) throw new jt(Je.UNEXPECTED_ERROR, "can not generate join message, no join info");
        const i = Object.assign({}, this.joinInfo.apResponse);
        let o = ft("REPORT_APP_SCENARIO");
        if (typeof o != "string") try {
          o = JSON.stringify(o);
        } catch {
          o = void 0;
        }
        o && o.length > 128 && (o = void 0);
        const f = !(ui() || GM(87) || _5()) && typeof ft("ENABLE_PRE_SUB") == "boolean" && ft("ENABLE_PRE_SUB"), T = !_5() && Au("ENABLE_PREALLOC_PC", "boolean"), A = lae(), R = gd({ license: this.joinInfo.license, p2p_id: this.store.p2pId, session_id: this.joinInfo.sid, app_id: this.joinInfo.appId, channel_key: this.key, channel_name: this.joinInfo.cname, sdk_version: Ro, browser: navigator.userAgent, process_id: ft("PROCESS_ID"), mode: this.store.useP2P ? "p2p" : this.spec.mode, codec: this.spec.codec, role: this.role, has_changed_gateway: this.hasChangeBGPAddress, ap_response: i, extend: ft("JOIN_EXTEND"), details: { 6: this.joinInfo.stringUid, cservice_map: this.joinInfo.cloudProxyServer === "proxy3" ? "1" : this.joinInfo.cloudProxyServer === "proxy5" ? "2" : void 0 }, features: { rejoin: !0 }, optionalInfo: this.joinInfo.optionalInfo, appScenario: o, attributes: { userAttributes: gd({ enablePublishedUserList: ft("ENABLE_PUBLISHED_USER_LIST"), maxSubscription: ft("MAX_SUBSCRIPTION"), subscribeAudioFilterTopN: typeof ft("SUBSCRIBE_AUDIO_FILTER_TOPN") == "number" ? ft("SUBSCRIBE_AUDIO_FILTER_TOPN") : void 0, enablePublishAudioFilter: typeof ft("ENABLE_PUBLISH_AUDIO_FILTER") == "boolean" ? ft("ENABLE_PUBLISH_AUDIO_FILTER") : void 0, enableUserLicenseCheck: typeof ft("ENABLE_USER_LICENSE_CHECK") == "boolean" ? ft("ENABLE_USER_LICENSE_CHECK") : void 0, enableRTX: ft("USE_PUB_RTX") === !0 || ft("USE_SUB_RTX") === !0 || void 0, disableFEC: ft("DISABLE_FEC"), enableNTPReport: !!ft("ENABLE_NTP_REPORT") || void 0, enableInstantVideo: !!ft("ENABLE_INSTANT_VIDEO") || void 0, enableFulllinkAvSync: !!ft("ENABLE_FULL_LINK_AV_SYNC") || void 0, enableDataStream2: Au("ENABLE_DATASTREAM_2", "boolean"), enableAutFeedback: !!ft("ENABLE_AUT_FEEDBACK") || void 0, rtm2Flag: typeof this.joinInfo.rtmFlag == "number" ? this.joinInfo.rtmFlag : void 0, enableUserAutoRebalanceCheck: !!ft("ENABLE_USER_AUTO_REBALANCE_CHECK"), enableXR: Au("USE_XR", "boolean"), enableLossbasedBwe: Au("ENABLE_LOSSBASED_BWE", "boolean"), enableAutCC: !!ft("ENABLE_AUT_CC") || void 0, enableCCFallback: Au("ENABLE_CC_FALLBACK", "boolean"), enablePreallocPC: T, preSubNum: f ? Au("PRE_SUB_NUM", "number") : void 0, enablePubTWCC: Au("PUBLISH_TWCC", "boolean"), enableSubTWCC: Au("SUBSCRIBE_TWCC", "boolean"), enablePubRTX: Au("USE_PUB_RTX", "boolean"), enableSubRTX: Au("USE_SUB_RTX", "boolean"), enableSubSVC: ft("ENABLE_SVC") ? ft("ENABLE_SVC_DEFAULT_CODECS") : Array.isArray(ft("SVC")) && ft("SVC").length !== 0 ? ft("SVC") : void 0, enableSvcExtended: ft("ENABLE_SVC") && Array.isArray(ft("SVC_EXTENDED")) && ft("SVC_EXTENDED").length !== 0 ? ft("SVC_EXTENDED") : void 0 }, A) }, join_ts: this.joinGatewayStartTime }, n);
        return this.joinInfo.stringUid && (R.string_uid = this.joinInfo.stringUid), this.joinInfo.aesmode && this.joinInfo.aespassword && (R.aes_mode = this.joinInfo.aesmode, ft("ENCRYPT_AES") ? (R.aes_secret = this.joinInfo.aespassword, R.aes_encrypt = !0) : R.aes_secret = this.joinInfo.aespassword, this.joinInfo.aessalt && (R.aes_salt = this.joinInfo.aessalt)), i.addresses[this.signal.websocket.currentURLIndex] && (R.ap_response.ticket = i.addresses[this.signal.websocket.currentURLIndex].ticket, delete i.addresses), this.joinInfo.defaultVideoStream !== void 0 && (R.default_video_stream = this.joinInfo.defaultVideoStream), R;
      }
      getRejoinMessage() {
        if (!this.joinInfo) throw new jt(Je.UNEXPECTED_ERROR, "can not generate rejoin message, no join info");
        return { session_id: this.joinInfo.sid, channel_name: this.joinInfo.cname, cid: this.joinInfo.cid, uid: this.joinInfo.uid, vid: Number(this.joinInfo.vid) };
      }
      handleSignalEvents() {
        this.signal.on(jn.WS_RECONNECT_CREATE_CONNECTION, (n) => {
          this.joinGatewayStartTime = Date.now();
        }), this.signal.on(jn.WS_RECONNECTING, (n) => {
          this.joinInfo && Cn.WebSocketQuit(this.joinInfo.sid, { lts: Date.now(), succ: -1, cname: this.joinInfo.cname, uid: this.joinInfo.uid, cid: this.joinInfo.cid, errorCode: n || Cs.NETWORK_ERROR }), this.joinInfo && (this.state = "RECONNECTING", Cn.sessionInit(this.joinInfo.sid, { lts: (/* @__PURE__ */ new Date()).getTime(), extend: this.isSignalRecover ? { recover: !0 } : { rejoin: !0 }, cname: this.joinInfo.cname, appid: this.joinInfo.appId, mode: this.spec.mode, stringUid: this.joinInfo.stringUid, channelProfile: this.spec.mode === "live" ? 1 : 0, channelMode: 0, lsid: this.joinInfo.sid, clientRole: this.role === "audience" ? 2 : 1, buildFormat: 1 }), this.isSignalRecover = !1, this.joinGatewayStartTime = Date.now());
        }), this.signal.on(jn.WS_CLOSED, (n) => {
          let i;
          switch (n) {
            case br.LEAVE:
              i = Cs.LEAVE;
              break;
            case br.UID_BANNED:
            case br.IP_BANNED:
            case br.CHANNEL_BANNED:
            case br.SERVER_ERROR:
              i = Cs.SERVER_ERROR;
              break;
            case br.FALLBACK:
              i = Cs.FALLBACK;
              break;
            case br.LICENSE_MISSING:
            case br.LICENSE_EXPIRED:
            case br.LICENSE_MINUTES_EXCEEDED:
            case br.LICENSE_PERIOD_INVALID:
            case br.LICENSE_MULTIPLE_SDK_SERVICE:
            case br.LICENSE_ILLEGAL:
            case br.TOKEN_EXPIRE:
              i = n;
              break;
            default:
              i = Cs.NETWORK_ERROR;
          }
          Ee.debug("[".concat(this.store.clientId, "] [signal] websocket closed, reason: ").concat(i || "undefined -> " + Cs.NETWORK_ERROR)), this.joinInfo && Cn.WebSocketQuit(this.joinInfo.sid, { lts: Date.now(), succ: n === br.LEAVE ? 1 : -1, cname: this.joinInfo.cname, uid: this.joinInfo.uid, cid: this.joinInfo.cid, errorCode: i }), this._disconnectedReason = n, n !== br.FALLBACK && (this.state = "DISCONNECTED"), this.reset();
        }), this.signal.on(jn.WS_CONNECTED, () => {
          if (this.updateTurnConfigFromSignal(), this.state = "CONNECTED", this.joinInfo) {
            if (this.role === "audience") {
              const n = ft("CLIENT_ROLE_OPTIONS") || this._clientRoleOptions;
              n && (n.level || n.delay) && (Ee.debug("[".concat(this.store.clientId, "] patch to send set client role, role: ").concat(this.role, ", mode: ").concat(this.spec.mode, ", level: ").concat(n.level, ", delay: ").concat(n.delay)), this.setClientRole(this.role, n));
            }
            if (Cn.joinGateway(this.joinInfo.sid, { lts: this.joinGatewayStartTime, succ: !0, ec: null, vid: this.joinInfo.vid, addr: this.signal.url, uid: this.joinInfo.uid, cid: this.joinInfo.cid, firstSuccess: this._isProactiveJoin, avoidJoinStartTime: this.store.avoidJoinStart, isProxy: !!this.joinInfo.proxyServer, signalChannel: "0", preload: this.joinInfo.preload }), this._isProactiveJoin = !1, this.joinInfo.useLocalAccessPoint && this.joinInfo.setLocalAPVersion === 1) {
              const n = this.signal.url && this.signal.url.match(/wss\:\/\/([^:]+):(\d+)/);
              if (!n) return void Ee.error("[".concat(this.store.clientId, "] set local access point after joined failed: ").concat(n));
              Dr("EVENT_REPORT_DOMAIN", n[1]), Dr("EVENT_REPORT_BACKUP_DOMAIN", n[1]), Dr("LOG_UPLOAD_SERVER", "".concat(n[1], ":6444"));
            }
          }
        }), this.signal.on(nr.ON_UPLINK_STATS, (n) => {
          this._statsCollector.updateUplinkStats(n);
        }), this.signal.on(jn.REQUEST_RECOVER, (n, i, o) => {
          if (!this.joinInfo) return o(new jt(Je.UNEXPECTED_ERROR, "gateway: can not recover, no join info"));
          n && (this.joinInfo.multiIP = n, this.hasChangeBGPAddress = !0), this.isSignalRecover = !0, Ss(this, Ns.REQUEST_NEW_GATEWAY_LIST).then(i).catch(o);
        }), this.signal.on(jn.REQUEST_JOIN_INFO, async (n, i, o) => {
          var f;
          if (this.updateTurnConfigFromSignal(), this.store.useP2P) return void n(this.getJoinMessage({ ortc: {} }));
          const { iceParameters: T, dtlsParameters: A, rtpCapabilities: R } = await Ss(this, Ns.REQUEST_P2P_CONNECTION_PARAMS, { turnServer: (f = this.joinInfo) === null || f === void 0 ? void 0 : f.turnServer });
          try {
            n(this.getJoinMessage({ ortc: { iceParameters: T, dtlsParameters: A, rtpCapabilities: R, version: "2" } }));
          } catch (P) {
            i(P);
          }
        }), this.signal.on(jn.REQUEST_REJOIN_INFO, (n) => {
          n(this.getRejoinMessage());
        }), this.signal.on(jn.REPORT_JOIN_GATEWAY, (n, i) => {
          if (!this.joinInfo) return;
          let o, f = "";
          var T;
          n instanceof jt ? (o = ((T = n.data) === null || T === void 0 ? void 0 : T.desc) || n.code, f = n.message) : o = n, Cn.joinGateway(this.joinInfo.sid, { lts: this.joinGatewayStartTime, succ: !1, ec: o, errorMsg: f, addr: i, uid: this.joinInfo.uid, cid: this.joinInfo.cid, firstSuccess: this._isProactiveJoin, avoidJoinStartTime: this.store.avoidJoinStart, isProxy: !!this.joinInfo.proxyServer, signalChannel: "0", preload: this.joinInfo.preload });
        }), this.signal.on(jn.IS_P2P_DISCONNECTED, (n) => {
          n(wE(this, Ns.IS_P2P_DISCONNECTED));
        }), this.signal.on(jn.DISCONNECT_P2P, () => {
          this.emit(Ns.DISCONNECT_P2P);
        }), this.signal.on(jn.REQUEST_SUCCESS, () => {
          this._signalTimeout = !1;
        }), this.signal.on(jn.REQUEST_TIMEOUT, () => {
          this._signalTimeout = !0;
        }), this.signal.on(jn.JOIN_RESPONSE, (n) => {
          const i = this.getCurrentGatewayAddress();
          this.emit(Ns.JOIN_RESPONSE, n, i);
        }), this.signal.on(jn.PRE_CONNECT_PC, async () => {
          if (this.joinInfo) {
            this.updateTurnConfigFromSignal();
            const n = this.getCurrentGatewayAddress(), i = ft("FINGERPRINT") || this.joinInfo.apResponse.addresses[this.signal.currentURLIndex].fingerprint;
            if (n && i) {
              const o = a6(n);
              this.emit(Ns.PRE_CONNECT_PC, { candidates: o, fingerprint: i });
            }
          }
        }), this.signal.on(jn.RECOVER_NOTIFICATION, (n) => {
          this.joinInfo && typeof ft("AP_REQUEST_DETAIL") == "string" && (this.joinInfo.apRequestDetail = "".concat(ft("AP_REQUEST_DETAIL"), ";").concat(n));
        });
      }
      async tryUnsubBeforeResub(n, i) {
        try {
          await this.signal.request(kn.UNSUBSCRIBE, { p2p_id: this.store.p2pId, stream_id: n, ortc: [i] }, !0);
        } catch (o) {
          throw Ee.warning("[".concat(this.store.clientId, "] tryUnsubBeforeResub warning"), o), o;
        }
      }
      async tryUnsubDataChannelBeforeResub(n, i) {
        try {
          await this.signal.request(kn.UNSUBSCRIBE, { stream_id: i.id }, !0);
        } catch (o) {
          throw Ee.warning("unsubscribe datachannel warning", o), o;
        }
      }
      async tryUnpubBeforeRepub(n, i) {
        try {
          await this.signal.request(kn.UNPUBLISH, { stream_id: n, ortc: i }, !0);
        } catch (o) {
          throw Ee.warning("[".concat(this.store.clientId, "] tryUnpubBeforeRepub warning: "), o), o;
        }
      }
      async tryUnpubDataChannelBeforeRepub(n, i) {
        try {
          await this.signal.request(kn.UNPUBLISH_DATASTREAM, { channnel_id: i.channelId }, !0);
        } catch (o) {
          throw Ee.warning("unpublish datastream warning: ", o), o;
        }
      }
      async tryMassUnsubBeforeResub(n) {
        const i = { users: n.map((o) => ({ stream_id: o.stream_id, stream_type: o.stream_type })) };
        try {
          await this.signal.request(kn.UNSUBSCRIBE_STREAMS, i, !0);
        } catch (o) {
          throw Ee.warning("[".concat(this.store.clientId, "] tryMassUnsubBeforeResub warning"), o), o;
        }
      }
      async muteLocal(n, i) {
        const o = { action: n.find((f) => f.stream_type === Sr.Audio) ? "mute_local_audio" : "mute_local_video", p2p_id: this.store.p2pId, ortc: n, stream_id: i };
        try {
          await this.signal.request(kn.CONTROL, o, !0, !0);
        } catch (f) {
          throw Ee.warning("[".concat(this.store.clientId, "] gateway muteLocal warning: "), f), f;
        }
      }
      async unmuteLocal(n, i) {
        const o = { action: n.find((f) => f.stream_type === Sr.Audio) ? "unmute_local_audio" : "unmute_local_video", p2p_id: this.store.p2pId, ortc: n, stream_id: i };
        try {
          await this.signal.request(kn.CONTROL, o, !0, !0);
        } catch (f) {
          throw Ee.warning("[".concat(this.store.clientId, "] gateway unmuteLocal warning: "), f), f;
        }
      }
      async muteRemote(n, i) {
        const o = { action: n === vn.AUDIO ? "mute_remote_audio" : "mute_remote_video", p2p_id: this.store.p2pId, stream_id: i };
        try {
          await this.signal.request(kn.CONTROL, o, !0, !0);
        } catch (f) {
          throw Ee.warning("[".concat(this.store.clientId, "] gateway muteRemote warning: "), f), f;
        }
      }
      async unmuteRemote(n, i) {
        const o = { action: n === vn.AUDIO ? "unmute_remote_audio" : "unmute_remote_video", p2p_id: this.store.p2pId, stream_id: i };
        try {
          await this.signal.request(kn.CONTROL, o, !0, !0);
        } catch (f) {
          throw Ee.warning("[".concat(this.store.clientId, "] gateway unmuteRemote warning: "), f), f;
        }
      }
      uploadWRTCStats(n) {
        this.signal.uploadWRTCStats(n);
      }
      upload(n, i) {
        this.signal.upload(n, i);
      }
      getSignalRTT() {
        return this.signal.rtt;
      }
      async restartICE(n) {
        const i = { p2p_id: this.store.p2pId, stream_id: this.store.uid, ortc: n };
        try {
          return await this.signal.request(kn.RESTART_ICE, i, !0);
        } catch (o) {
          throw Ee.warning("[".concat(this.store.clientId, "] P2PChannel.restartICE warning: "), o), o;
        }
      }
      reconnect(n, i) {
        this.state === "CONNECTED" && this.signal.reconnect(n || void 0, i || Cs.P2P_FAILED);
      }
      getCurrentGatewayAddress() {
        var n, i;
        if (!ft("GATEWAY_WSS_ADDRESS")) return ft("USE_CANDIDATE_FROM_AP_DETAIL") && (n = this.joinInfo) !== null && n !== void 0 && n.apGatewayAddress ? (Ee.debug("[".concat(this.store.clientId, "] use candidate from ap detail, ").concat(JSON.stringify(this.joinInfo.apGatewayAddress))), this.joinInfo.apGatewayAddress) : (i = this.joinInfo) !== null && i !== void 0 && i.gatewayAddrs ? this.joinInfo.gatewayAddrs[this.signal.currentURLIndex] : void 0;
      }
      async setPublishAudioFilterEnabled(n) {
        await this.signal.request(kn.SET_PARAMETER, { enablePublishAudioFilter: n });
      }
    }
    let BT = 0, II = 0;
    function Hc(e, n, i, o) {
      return new cn((f, T) => {
        n.timeout = n.timeout || ft("HTTP_CONNECT_TIMEOUT"), n.responseType = n.responseType || "json", n.data && !i ? (n.data = JSON.stringify(n.data), BT += mu(n.data)) : i && (n.data.size ? BT += n.data.size : n.data instanceof FormData ? BT += o5(n.data) : BT += mu(JSON.stringify(n.data))), n.headers = n.headers || {}, n.headers["Content-Type"] = n.headers["Content-Type"] || "application/json", n.method = "POST", n.url = e, fa.request(n).then((A) => {
          typeof A.data == "string" ? II += mu(A.data) : A.data instanceof ArrayBuffer || A.data instanceof Uint8Array ? II += A.data.byteLength : II += mu(JSON.stringify(A.data)), o && f({ data: A.data, headers: A.headers }), f(A.data);
        }).catch((A) => {
          fa.isCancel(A) ? T(new jt(Je.OPERATION_ABORTED, "cancel token canceled")) : A.code === "ECONNABORTED" ? T(new jt(Je.NETWORK_TIMEOUT, A.message)) : A.response ? T(new jt(Je.NETWORK_RESPONSE_ERROR, A.response.status)) : T(new jt(Je.NETWORK_ERROR, A.message));
        });
      });
    }
    /*! formdata-polyfill. MIT License. Jimmy W?rting <https://jimmy.warting.se/opensource> */
    (function() {
      var e;
      function n(qt) {
        var sn = 0;
        return function() {
          return sn < qt.length ? { done: !1, value: qt[sn++] } : { done: !0 };
        };
      }
      var i = typeof Object.defineProperties == "function" ? Object.defineProperty : function(qt, sn, An) {
        return qt == Array.prototype || qt == Object.prototype || (qt[sn] = An.value), qt;
      }, o, f = function(qt) {
        qt = [typeof globalThis == "object" && globalThis, qt, typeof window == "object" && window, typeof self == "object" && self, typeof u == "object" && u];
        for (var sn = 0; sn < qt.length; ++sn) {
          var An = qt[sn];
          if (An && An.Math == Math) return An;
        }
        throw Error("Cannot find global object");
      }(this);
      function T(qt, sn) {
        if (sn) e: {
          var An = f;
          qt = qt.split(".");
          for (var Jt = 0; Jt < qt.length - 1; Jt++) {
            var Ae = qt[Jt];
            if (!(Ae in An)) break e;
            An = An[Ae];
          }
          (sn = sn(Jt = An[qt = qt[qt.length - 1]])) != Jt && sn != null && i(An, qt, { configurable: !0, writable: !0, value: sn });
        }
      }
      function A(qt) {
        return (qt = { next: qt })[Symbol.iterator] = function() {
          return this;
        }, qt;
      }
      function R(qt) {
        var sn = typeof Symbol < "u" && Symbol.iterator && qt[Symbol.iterator];
        return sn ? sn.call(qt) : { next: n(qt) };
      }
      if (T("Symbol", function(qt) {
        function sn(Ae, ct) {
          this.A = Ae, i(this, "description", { configurable: !0, writable: !0, value: ct });
        }
        if (qt) return qt;
        sn.prototype.toString = function() {
          return this.A;
        };
        var An = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", Jt = 0;
        return function Ae(ct) {
          if (this instanceof Ae) throw new TypeError("Symbol is not a constructor");
          return new sn(An + (ct || "") + "_" + Jt++, ct);
        };
      }), T("Symbol.iterator", function(qt) {
        if (qt) return qt;
        qt = Symbol("Symbol.iterator");
        for (var sn = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), An = 0; An < sn.length; An++) {
          var Jt = f[sn[An]];
          typeof Jt == "function" && typeof Jt.prototype[qt] != "function" && i(Jt.prototype, qt, { configurable: !0, writable: !0, value: function() {
            return A(n(this));
          } });
        }
        return qt;
      }), typeof Object.setPrototypeOf == "function") o = Object.setPrototypeOf;
      else {
        var P;
        e: {
          var L = {};
          try {
            L.__proto__ = { a: !0 }, P = L.a;
            break e;
          } catch {
          }
          P = !1;
        }
        o = P ? function(qt, sn) {
          if (qt.__proto__ = sn, qt.__proto__ !== sn) throw new TypeError(qt + " is not extensible");
          return qt;
        } : null;
      }
      var z = o;
      function Y() {
        this.m = !1, this.j = null, this.v = void 0, this.h = 1, this.u = this.C = 0, this.l = null;
      }
      function te(qt) {
        if (qt.m) throw new TypeError("Generator is already running");
        qt.m = !0;
      }
      function oe(qt, sn) {
        return qt.h = 3, { value: sn };
      }
      function He(qt) {
        this.g = new Y(), this.G = qt;
      }
      function Re(qt, sn, An, Jt) {
        try {
          var Ae = sn.call(qt.g.j, An);
          if (!(Ae instanceof Object)) throw new TypeError("Iterator result " + Ae + " is not an object");
          if (!Ae.done) return qt.g.m = !1, Ae;
          var ct = Ae.value;
        } catch (vt) {
          return qt.g.j = null, qt.g.s(vt), De(qt);
        }
        return qt.g.j = null, Jt.call(qt.g, ct), De(qt);
      }
      function De(qt) {
        for (; qt.g.h; ) try {
          var sn = qt.G(qt.g);
          if (sn) return qt.g.m = !1, { value: sn.value, done: !1 };
        } catch (An) {
          qt.g.v = void 0, qt.g.s(An);
        }
        if (qt.g.m = !1, qt.g.l) {
          if (sn = qt.g.l, qt.g.l = null, sn.F) throw sn.D;
          return { value: sn.return, done: !0 };
        }
        return { value: void 0, done: !0 };
      }
      function Xe(qt) {
        this.next = function(sn) {
          return qt.o(sn);
        }, this.throw = function(sn) {
          return qt.s(sn);
        }, this.return = function(sn) {
          return function(An, Jt) {
            te(An.g);
            var Ae = An.g.j;
            return Ae ? Re(An, "return" in Ae ? Ae.return : function(ct) {
              return { value: ct, done: !0 };
            }, Jt, An.g.return) : (An.g.return(Jt), De(An));
          }(qt, sn);
        }, this[Symbol.iterator] = function() {
          return this;
        };
      }
      function We(qt, sn) {
        return sn = new Xe(new He(sn)), z && qt.prototype && z(sn, qt.prototype), sn;
      }
      if (Y.prototype.o = function(qt) {
        this.v = qt;
      }, Y.prototype.s = function(qt) {
        this.l = { D: qt, F: !0 }, this.h = this.C || this.u;
      }, Y.prototype.return = function(qt) {
        this.l = { return: qt }, this.h = this.u;
      }, He.prototype.o = function(qt) {
        return te(this.g), this.g.j ? Re(this, this.g.j.next, qt, this.g.o) : (this.g.o(qt), De(this));
      }, He.prototype.s = function(qt) {
        return te(this.g), this.g.j ? Re(this, this.g.j.throw, qt, this.g.o) : (this.g.s(qt), De(this));
      }, T("Array.prototype.entries", function(qt) {
        return qt || function() {
          return function(sn, An) {
            sn instanceof String && (sn += "");
            var Jt = 0, Ae = !1, ct = { next: function() {
              if (!Ae && Jt < sn.length) {
                var vt = Jt++;
                return { value: An(vt, sn[vt]), done: !1 };
              }
              return Ae = !0, { done: !0, value: void 0 };
            } };
            return ct[Symbol.iterator] = function() {
              return ct;
            }, ct;
          }(this, function(sn, An) {
            return [sn, An];
          });
        };
      }), typeof Blob < "u" && (typeof FormData > "u" || !FormData.prototype.keys)) {
        var mt = function(qt, sn) {
          for (var An = 0; An < qt.length; An++) sn(qt[An]);
        }, Pt = function(qt) {
          return qt.replace(/\r?\n|\r/g, `\r
`);
        }, xt = function(qt, sn, An) {
          return sn instanceof Blob ? (An = An !== void 0 ? An + "" : typeof sn.name == "string" ? sn.name : "blob", sn.name === An && Object.prototype.toString.call(sn) !== "[object Blob]" || (sn = new File([sn], An)), [String(qt), sn]) : [String(qt), String(sn)];
        }, Nt = function(qt, sn) {
          if (qt.length < sn) throw new TypeError(sn + " argument required, but only " + qt.length + " present.");
        }, Vt = typeof globalThis == "object" ? globalThis : typeof window == "object" ? window : typeof self == "object" ? self : this, nn = Vt.FormData, fn = Vt.XMLHttpRequest && Vt.XMLHttpRequest.prototype.send, hn = Vt.Request && Vt.fetch, ir = Vt.navigator && Vt.navigator.sendBeacon, sr = Vt.Element && Vt.Element.prototype, Gr = Vt.Symbol && Symbol.toStringTag;
        Gr && (Blob.prototype[Gr] || (Blob.prototype[Gr] = "Blob"), "File" in Vt && !File.prototype[Gr] && (File.prototype[Gr] = "File"));
        try {
          new File([], "");
        } catch {
          Vt.File = function(sn, An, Jt) {
            return sn = new Blob(sn, Jt || {}), Object.defineProperties(sn, { name: { value: An }, lastModified: { value: +(Jt && Jt.lastModified !== void 0 ? new Date(Jt.lastModified) : /* @__PURE__ */ new Date()) }, toString: { value: function() {
              return "[object File]";
            } } }), Gr && Object.defineProperty(sn, Gr, { value: "File" }), sn;
          };
        }
        var Ai = function(qt) {
          return qt.replace(/\n/g, "%0A").replace(/\r/g, "%0D").replace(/"/g, "%22");
        }, fi = function(qt) {
          this.i = [];
          var sn = this;
          qt && mt(qt.elements, function(An) {
            if (An.name && !An.disabled && An.type !== "submit" && An.type !== "button" && !An.matches("form fieldset[disabled] *")) if (An.type === "file") {
              var Jt = An.files && An.files.length ? An.files : [new File([], "", { type: "application/octet-stream" })];
              mt(Jt, function(Ae) {
                sn.append(An.name, Ae);
              });
            } else An.type === "select-multiple" || An.type === "select-one" ? mt(An.options, function(Ae) {
              !Ae.disabled && Ae.selected && sn.append(An.name, Ae.value);
            }) : An.type === "checkbox" || An.type === "radio" ? An.checked && sn.append(An.name, An.value) : (Jt = An.type === "textarea" ? Pt(An.value) : An.value, sn.append(An.name, Jt));
          });
        };
        if ((e = fi.prototype).append = function(qt, sn, An) {
          Nt(arguments, 2), this.i.push(xt(qt, sn, An));
        }, e.delete = function(qt) {
          Nt(arguments, 1);
          var sn = [];
          qt = String(qt), mt(this.i, function(An) {
            An[0] !== qt && sn.push(An);
          }), this.i = sn;
        }, e.entries = function qt() {
          var sn, An = this;
          return We(qt, function(Jt) {
            if (Jt.h == 1 && (sn = 0), Jt.h != 3) return sn < An.i.length ? Jt = oe(Jt, An.i[sn]) : (Jt.h = 0, Jt = void 0), Jt;
            sn++, Jt.h = 2;
          });
        }, e.forEach = function(qt, sn) {
          Nt(arguments, 1);
          for (var An = R(this), Jt = An.next(); !Jt.done; Jt = An.next()) {
            var Ae = R(Jt.value);
            Jt = Ae.next().value, Ae = Ae.next().value, qt.call(sn, Ae, Jt, this);
          }
        }, e.get = function(qt) {
          Nt(arguments, 1);
          var sn = this.i;
          qt = String(qt);
          for (var An = 0; An < sn.length; An++) if (sn[An][0] === qt) return sn[An][1];
          return null;
        }, e.getAll = function(qt) {
          Nt(arguments, 1);
          var sn = [];
          return qt = String(qt), mt(this.i, function(An) {
            An[0] === qt && sn.push(An[1]);
          }), sn;
        }, e.has = function(qt) {
          Nt(arguments, 1), qt = String(qt);
          for (var sn = 0; sn < this.i.length; sn++) if (this.i[sn][0] === qt) return !0;
          return !1;
        }, e.keys = function qt() {
          var sn, An, Jt, Ae, ct = this;
          return We(qt, function(vt) {
            if (vt.h == 1 && (sn = R(ct), An = sn.next()), vt.h != 3) return An.done ? void (vt.h = 0) : (Jt = An.value, Ae = R(Jt), oe(vt, Ae.next().value));
            An = sn.next(), vt.h = 2;
          });
        }, e.set = function(qt, sn, An) {
          Nt(arguments, 2), qt = String(qt);
          var Jt = [], Ae = xt(qt, sn, An), ct = !0;
          mt(this.i, function(vt) {
            vt[0] === qt ? ct && (ct = !Jt.push(Ae)) : Jt.push(vt);
          }), ct && Jt.push(Ae), this.i = Jt;
        }, e.values = function qt() {
          var sn, An, Jt, Ae, ct = this;
          return We(qt, function(vt) {
            if (vt.h == 1 && (sn = R(ct), An = sn.next()), vt.h != 3) return An.done ? void (vt.h = 0) : (Jt = An.value, (Ae = R(Jt)).next(), oe(vt, Ae.next().value));
            An = sn.next(), vt.h = 2;
          });
        }, fi.prototype._asNative = function() {
          for (var qt = new nn(), sn = R(this), An = sn.next(); !An.done; An = sn.next()) {
            var Jt = R(An.value);
            An = Jt.next().value, Jt = Jt.next().value, qt.append(An, Jt);
          }
          return qt;
        }, fi.prototype._blob = function() {
          var qt = "----formdata-polyfill-" + Math.random(), sn = [], An = "--" + qt + `\r
Content-Disposition: form-data; name="`;
          return this.forEach(function(Jt, Ae) {
            return typeof Jt == "string" ? sn.push(An + Ai(Pt(Ae)) + `"\r
\r
` + Pt(Jt) + `\r
`) : sn.push(An + Ai(Pt(Ae)) + '"; filename="' + Ai(Jt.name) + `"\r
Content-Type: ` + (Jt.type || "application/octet-stream") + `\r
\r
`, Jt, `\r
`);
          }), sn.push("--" + qt + "--"), new Blob(sn, { type: "multipart/form-data; boundary=" + qt });
        }, fi.prototype[Symbol.iterator] = function() {
          return this.entries();
        }, fi.prototype.toString = function() {
          return "[object FormData]";
        }, sr && !sr.matches && (sr.matches = sr.matchesSelector || sr.mozMatchesSelector || sr.msMatchesSelector || sr.oMatchesSelector || sr.webkitMatchesSelector || function(qt) {
          for (var sn = (qt = (this.document || this.ownerDocument).querySelectorAll(qt)).length; 0 <= --sn && qt.item(sn) !== this; ) ;
          return -1 < sn;
        }), Gr && (fi.prototype[Gr] = "FormData"), fn) {
          var Ea = Vt.XMLHttpRequest.prototype.setRequestHeader;
          Vt.XMLHttpRequest.prototype.setRequestHeader = function(qt, sn) {
            Ea.call(this, qt, sn), qt.toLowerCase() === "content-type" && (this.B = !0);
          }, Vt.XMLHttpRequest.prototype.send = function(qt) {
            qt instanceof fi ? (qt = qt._blob(), this.B || this.setRequestHeader("Content-Type", qt.type), fn.call(this, qt)) : fn.call(this, qt);
          };
        }
        hn && (Vt.fetch = function(qt, sn) {
          return sn && sn.body && sn.body instanceof fi && (sn.body = sn.body._blob()), hn.call(this, qt, sn);
        }), ir && (Vt.navigator.sendBeacon = function(qt, sn) {
          return sn instanceof fi && (sn = sn._asNative()), ir.call(this, qt, sn);
        }), Vt.FormData = fi;
      }
    })();
    const GE = () => {
      const e = ft("AREAS");
      return e.length === 0 && e.push(vr.GLOBAL), _c(e).call(e, (n, i, o) => {
        const f = v6(i);
        return f ? o === 0 ? f : "".concat(n, ",").concat(f) : n;
      }, "");
    }, v6 = (e) => e === vr.OVERSEA ? "".concat(Ds.ASIA, ",").concat(Ds.EUROPE, ",").concat(Ds.AFRICA, ",").concat(Ds.NORTH_AMERICA, ",").concat(Ds.SOUTH_AMERICA, ",").concat(Ds.OCEANIA) : Ds[e], hae = (e) => {
      const n = { CODE: "", WEBCS_DOMAIN: [], WEBCS_DOMAIN_BACKUP_LIST: [], PROXY_CS: [], CDS_AP: [], ACCOUNT_REGISTER: [], UAP_AP: [], EVENT_REPORT_DOMAIN: [], EVENT_REPORT_BACKUP_DOMAIN: [], LOG_UPLOAD_SERVER: [], PROXY_SERVER_TYPE3: [] };
      return e.map((i) => {
        const o = xT[i], f = Object.keys(o);
        f && f.map((T) => {
          T !== "CODE" && (n[T] = n[T].concat(o[T]));
        });
      }), n;
    }, zT = { GLOBAL: { ASIA: [vr.CHINA, vr.JAPAN, vr.INDIA, vr.KOREA, vr.HKMC], EUROPE: [], NORTH_AMERICA: [vr.US], SOUTH_AMERICA: [], OCEANIA: [], AFRICA: [] } }, FT = Object.keys(zT[vr.GLOBAL]), RI = [vr.CHINA, vr.NORTH_AMERICA, vr.EUROPE, vr.ASIA, vr.JAPAN, vr.INDIA, vr.OCEANIA, vr.SOUTH_AMERICA, vr.AFRICA, vr.KOREA, vr.HKMC, vr.US], pae = function(e, n) {
      let i = [];
      if (on(e).call(e, vr.GLOBAL)) {
        const T = [vr.GLOBAL, vr.OVERSEA], A = Object.keys(xT);
        if (n === vr.GLOBAL) throw new jt(Je.INVALID_PARAMS, "GLOBAL is an invalid excludedArea value");
        if (n === vr.CHINA) i = [vr.OVERSEA];
        else if (f = n, on(FT).call(FT, f)) {
          const R = (o = n, zT[vr.GLOBAL][o] || []), P = [...T, n, ...R];
          i = A.filter((L) => !on(P).call(P, L));
        } else if (function(R) {
          let P = !1;
          return FT.forEach((L) => {
            var z;
            on(z = zT[vr.GLOBAL][L]).call(z, R) && (P = !0);
          }), P;
        }(n)) {
          const R = function(L) {
            let z;
            return FT.forEach((Y) => {
              var te;
              on(te = zT[vr.GLOBAL][Y]).call(te, L) && (z = Y);
            }), z;
          }(n), P = [...T, R, n];
          i = A.filter((L) => !on(P).call(P, L));
        } else i = e;
        i = function(R) {
          const P = [];
          return RI.forEach((L) => {
            on(R).call(R, L) && P.push(L);
          }), P.concat(R.filter((L) => !on(RI).call(RI, L)));
        }(i);
      } else i = e;
      var o, f;
      return i;
    };
    function T6(e) {
      var n, i;
      if (!e && on(n = ft("AREAS")).call(n, vr.EXTENSIONS)) return Ee.debug("update area from ap : reset"), void NI(Cse, !0);
      if (!on(i = ft("AREAS")).call(i, vr.GLOBAL) || !e) return;
      let o = xT.EXTENSIONS;
      o && (o = { CODE: v6(vr.EXTENSIONS), WEBCS_DOMAIN: ["ap-web-1-".concat(e, ".agora.io")], WEBCS_DOMAIN_BACKUP_LIST: ["ap-web-2-".concat(e, ".ap.sd-rtn.com")], PROXY_CS: ["proxy-ap-web-".concat(e, ".agora.io")], CDS_AP: ["cds-ap-web-1-".concat(e, ".agora.io"), "cds-ap-web-2-".concat(e, ".ap.sd-rtn.com")], ACCOUNT_REGISTER: ["sua-ap-web-1-".concat(e, ".agora.io"), "sua-ap-web-2-".concat(e, ".ap.sd-rtn.com")], UAP_AP: ["uap-ap-web-1-".concat(e, ".agora.io"), "uap-ap-web-2-".concat(e, ".ap.sd-rtn.com")], EVENT_REPORT_DOMAIN: ["statscollector-1-".concat(e, ".agora.io")], EVENT_REPORT_BACKUP_DOMAIN: ["statscollector-2-".concat(e, ".agora.io")], LOG_UPLOAD_SERVER: ["logservice-".concat(e, ".agora.io")], PROXY_SERVER_TYPE3: ["webrtc-cloud-proxy-".concat(e, ".agora.io")] }, Ee.debug("update area from ap success: ".concat(e, ",config is "), o), Dr("AREAS", [vr.EXTENSIONS], !0), Object.keys(o).map((f) => {
        f === "LOG_UPLOAD_SERVER" || f === "EVENT_REPORT_DOMAIN" || f === "EVENT_REPORT_BACKUP_DOMAIN" || f === "PROXY_SERVER_TYPE3" ? Dr(f, o[f][0]) : Dr(f, o[f]);
      }));
    }
    function NI(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      const i = Cn.reportApiInvoke(null, { name: Bi.SET_AREA, options: e, tag: si.TRACER });
      try {
        let o = [];
        if (typeof e == "string" && (o = [e]), Array.isArray(e) && (e.forEach((T) => {
          if (!on(B8).call(B8, T)) throw new jt(Je.INVALID_PARAMS, "invalid area code");
        }), o = e), Object.prototype.toString.call(e) === "[object Object]") {
          const { areaCode: T, excludedArea: A } = e;
          if (!T) throw new jt(Je.INVALID_PARAMS, "area code is needed");
          let R = T;
          typeof T == "string" && (R = [T]), o = A ? pae(R, A) : R;
        }
        if (!n) {
          if (ud.AREAS) {
            const T = new jt(Je.PROHIBITED_OPERATION, "setArea is prohibited because of config-distribute");
            return i.onError(T), void Ee.warning("setArea is prohibited because of config-distribute");
          }
          if (on(o).call(o, vr.GLOBAL) && ft("AREAS") === vr.EXTENSIONS) {
            const T = new jt(Je.PROHIBITED_OPERATION, "setArea is prohibited because of ap extensions");
            return i.onError(T), void Ee.warning("setArea is prohibited because of ap extensions");
          }
        }
        Dr("AREAS", o, n);
        const f = hae(o);
        Object.keys(f).map((T) => {
          T === "LOG_UPLOAD_SERVER" || T === "EVENT_REPORT_DOMAIN" || T === "EVENT_REPORT_BACKUP_DOMAIN" || T === "PROXY_SERVER_TYPE3" ? Dr(T, f[T][0]) : Dr(T, f[T]);
        }), Ee.debug("set area success:", o.join(","));
      } catch (o) {
        throw i.onError(o), o;
      }
      i.onSuccess();
    }
    function b6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function VE(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? b6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : b6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    let wI = 1;
    function gae(e, n, i, o, f) {
      wI += 1;
      const T = { sid: i.sid, command: "convergeAllocateEdge", uid: "666", appId: i.appId, ts: Math.floor(Date.now() / 1e3), seq: wI, requestId: wI, version: Ro, cname: i.cname }, A = { service_name: n, json_body: JSON.stringify(T) };
      let R, P, L = e[0];
      return jc(async () => {
        R = Date.now();
        const z = await Hc(L, { data: A, cancelToken: o, headers: { "X-Packet-Service-Type": "0", "X-Packet-URI": "61" } });
        if (P = Date.now() - R, z.code !== 0) {
          const oe = new jt(Je.UNEXPECTED_RESPONSE, "live streaming ap error, code" + z.code, { retry: !0, responseTime: P });
          throw Ee.error(oe.toString()), oe;
        }
        const Y = JSON.parse(z.json_body);
        if (Y.code !== 200) {
          const oe = new jt(Je.UNEXPECTED_RESPONSE, "live streaming app center error, code: ".concat(Y.code, ", reason: ").concat(Y.reason), { code: Y.code, responseTime: P });
          throw Ee.error(oe.toString()), oe;
        }
        if (!Y.servers || Y.servers.length === 0) {
          const oe = new jt(Je.UNEXPECTED_RESPONSE, "live streaming app center empty server", { code: Y.code, responseTime: P });
          throw Ee.error(oe.toString()), oe;
        }
        const te = function(oe, He) {
          return { addressList: oe.servers.map((Re) => "wss://".concat(Re.address.replace(/\./g, "-"), ".").concat(ft("WORKER_DOMAIN"), ":").concat(Re.wss, "?serviceName=").concat(encodeURIComponent(He))), workerToken: oe.workerToken, vid: oe.vid };
        }(Y, n);
        return ft("LIVE_STREAMING_ADDRESS") && (te.addressList = ft("LIVE_STREAMING_ADDRESS") instanceof Array ? ft("LIVE_STREAMING_ADDRESS") : [ft("LIVE_STREAMING_ADDRESS")]), VE(VE({}, te), {}, { responseTime: P });
      }, (z, Y) => (Cn.apworkerEvent(i.sid, { success: !0, sc: 200, serviceName: n, responseDetail: JSON.stringify(z.addressList), firstSuccess: Y === 0, responseTime: P, serverIp: e[Y % e.length] }), !1), (z, Y) => (Cn.apworkerEvent(i.sid, { success: !1, sc: z.data && z.data.code || 200, serviceName: n, responseTime: P, serverIp: e[Y % e.length] }), !!(z.code !== Je.OPERATION_ABORTED && z.code !== Je.UNEXPECTED_RESPONSE || z.data && z.data.retry) && (L = e[(Y + 1) % e.length], !0)), f);
    }
    let _I = 1;
    function A6(e, n, i, o) {
      let { url: f, areaCode: T } = e;
      const { clientId: A, sid: R } = n, P = Date.now();
      let L;
      const z = n.role, [Y, te] = xI(n, T, [Li.CHOOSE_SERVER]);
      let oe = Mi.networkState;
      return jc(async () => {
        oe && Mi.networkState === Fa.OFFLINE && Mi.onlineWaiter && await cn.race([Mi.onlineWaiter, Es(o && o.maxRetryTimeout || zi.maxRetryTimeout)]), oe = Mi.networkState;
        const { data: He, headers: Re } = await Hc(f, { data: Y, cancelToken: i, headers: { "Content-Type": "multipart/form-data;" } }, !0, !0);
        L = Re.http3 === "1" ? 1 : -1, Cn.reportResourceTiming(f, R), C6(He, f, n, P, [Li.CHOOSE_SERVER], L);
        const De = BE(He, Li.CHOOSE_SERVER);
        return PI(De), TI(De, f);
      }, (He) => (He && Cn.joinChooseServer(R, { role: z, lts: P, succ: !0, csAddr: f, opid: te, serverList: He.gatewayAddrs.map((Re) => Re.address), ec: null, cid: He.cid.toString(), uid: He.uid.toString(), csIp: He.csIp, unilbsServerIds: [Li.CHOOSE_SERVER].toString(), isHttp3: L, corssRegionTagReq: n.apRequestDetail, corssRegionTagRes: He.res.detail && He.res.detail[38] }), !1), (He) => He.code !== Je.OPERATION_ABORTED && (He.code === Je.CAN_NOT_GET_GATEWAY_SERVER ? He.data.retry : (Cn.joinChooseServer(R, { role: z, lts: P, succ: !1, csAddr: f, serverList: null, opid: te, ec: He.code, csIp: He.data && He.data.csIp, unilbsServerIds: [Li.CHOOSE_SERVER].toString(), extend: JSON.stringify({ networkState: oe }), isHttp3: L, corssRegionTagReq: n.apRequestDetail }), Ee.warning("[".concat(A || "sid-".concat(R.slice(0, 6)), "] Choose server network error, retry"), He), !0)), o);
    }
    function O6(e, n, i, o) {
      let f, { url: T, areaCode: A, serviceIds: R } = e;
      const P = Date.now(), L = n.role, [z, Y] = xI(n, A, R);
      let te;
      return jc(async () => {
        te && Mi.networkState === Fa.OFFLINE && Mi.onlineWaiter && await cn.race([Mi.onlineWaiter, Es(o && o.maxRetryTimeout || zi.maxRetryTimeout)]), te = Mi.networkState;
        const { data: oe, headers: He } = await Hc(T, { data: z, cancelToken: i, headers: { "Content-Type": "multipart/form-data;" } }, !0, !0);
        f = He.http3 === "1" ? 1 : -1, Cn.reportResourceTiming(T, n.sid), C6(oe, T, n, P, R, f);
        const Re = BE(oe, Li.CHOOSE_SERVER), De = BE(oe, n.cloudProxyServer === "proxy5" ? Li.CLOUD_PROXY_5 : n.cloudProxyServer === "proxy3" || n.cloudProxyServer === "proxy4" ? Li.CLOUD_PROXY : Li.CLOUD_PROXY_FALLBACK);
        return PI(Re), { gatewayInfo: TI(Re, T), proxyInfo: De, url: T };
      }, (oe) => (oe.gatewayInfo && Cn.joinChooseServer(n.sid, { role: L, lts: P, succ: !0, csAddr: T, serverList: oe.gatewayInfo.gatewayAddrs.map((He) => He.address), ec: null, opid: Y, cid: oe.gatewayInfo.cid.toString(), uid: oe.gatewayInfo.uid.toString(), csIp: oe.gatewayInfo.csIp, unilbsServerIds: R.toString(), isHttp3: f, corssRegionTagReq: n.apRequestDetail, corssRegionTagRes: oe.gatewayInfo.res.detail && oe.gatewayInfo.res.detail[38] }), oe.proxyInfo && Cn.joinWebProxyAP(n.sid, { lts: P, sucess: 1, apServerAddr: T, turnServerAddrList: oe.proxyInfo.addresses.map((He) => He.ip).join(","), errorCode: null, eventType: n.cloudProxyServer, unilbsServerIds: R.toString() }), !1), (oe) => oe.code !== Je.OPERATION_ABORTED && (oe.code === Je.CAN_NOT_GET_GATEWAY_SERVER ? oe.data.retry : (Cn.joinWebProxyAP(n.sid, { lts: P, sucess: 0, apServerAddr: T, turnServerAddrList: null, errorCode: oe.code, eventType: n.cloudProxyServer, unilbsServerIds: R.toString(), extend: JSON.stringify({ networkState: te }) }), Ee.warning("[".concat(n.clientId, "] multi unilbs network error, retry"), oe), !0)), o);
    }
    const C6 = (e, n, i, o, f, T) => {
      const { sid: A, clientId: R, cloudProxyServer: P } = i, L = [], z = (Y) => {
        Y.flag === 4096 ? Cn.joinChooseServer(A, { role: i.role, lts: o, succ: !1, csAddr: n, opid: e.opid, serverList: null, ec: Y.error.message, csIp: Y.error.data && Y.error.data.csIp, unilbsServerIds: f.toString(), isHttp3: T, corssRegionTagReq: i.apRequestDetail }) : Y.flag !== 1048576 && Y.flag !== 4194304 && Y.flag !== 4194310 || Cn.joinWebProxyAP(A, { lts: o, sucess: 0, apServerAddr: n, turnServerAddrList: null, errorCode: Y.error.code, eventType: P, unilbsServerIds: f.toString() });
      };
      if (e.response_body.forEach((Y) => {
        const te = Y.buffer.code;
        if (Y.uri === 23 && te === 0 && !Y.buffer.edges_services) if (Y.buffer.flag === 4194310) Ee.warning("no edge services in ap response of proxy fallback, will not set proxy in iceServers"), Y.buffer.edges_services = [];
        else {
          const oe = { error: new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, "no edge services in ap response", { retry: !0, csIp: e.detail[502] }), flag: Y.buffer.flag };
          L.push(oe), z(oe);
        }
        if (te !== 0) {
          const oe = bp(te), He = { error: new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, oe.desc, { desc: oe.desc, retry: oe.retry, csIp: e.detail[502] }), flag: Y.buffer.flag };
          Y.buffer.flag === 4194310 ? Ee.warning(He.error.toString()) : L.push(He), z(He);
        }
      }), L.length) throw Ee.warning("[".concat(R || "sid-".concat(A.slice(0, 6)), "] multi unilbs ").concat(n, " failed, ").concat(L.map((Y) => "flag: ".concat(Y.flag, ", message: ").concat(Y.error.message, ", retry: ").concat(Y.error.data.retry)).join(" | "))), new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, L.map((Y) => "flag: ".concat(Y.flag, ", message: ").concat(Y.error.message)).join(" | "), { retry: !!L.find((Y) => Y.error.data.retry), csIp: e.detail[502], desc: [...new Set(L.map((Y) => {
        var te;
        return Y == null || (te = Y.error) === null || te === void 0 || (te = te.data) === null || te === void 0 ? void 0 : te.desc;
      }).filter((Y) => !!Y))] });
    }, PI = (e) => {
      var n, i, o, f;
      if (e.addresses && e.addresses.length === 0 && e.code === 0) throw new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, "void gateway address", { retry: !0, csIp: e.detail && e.detail[502] });
      if (ft("AP_AREA") && ((o = e.detail) !== null && o !== void 0 && o[23] && typeof ((f = e.detail) === null || f === void 0 ? void 0 : f[23]) == "string" ? T6(e.detail[23].toLowerCase()) : T6()), (n = e.detail) !== null && n !== void 0 && n[19] && typeof ((i = e.detail) === null || i === void 0 ? void 0 : i[19]) == "string") {
        const A = e.detail[19], R = A == null ? void 0 : A.split(";");
        for (let P = 0; P < R.length; P++) {
          var T;
          const L = Ys(T = R[P]).call(T);
          e.addresses[P] && R && (e.addresses[P].fingerprint = L);
        }
      }
      if (ft("GATEWAY_ADDRESS") && ft("GATEWAY_ADDRESS").length > 0) {
        Ee.debug("assign gateway address to", ft("GATEWAY_ADDRESS"));
        const A = ft("GATEWAY_ADDRESS").map((R) => {
          var P, L;
          const z = (P = (L = e.addresses.find((Y) => Y.ip === R.ip && Y.port === R.port)) === null || L === void 0 ? void 0 : L.fingerprint) !== null && P !== void 0 ? P : "";
          return { ip: R.ip, port: R.port, ticket: e.addresses[0] && e.addresses[0].ticket, fingerprint: z };
        });
        e.addresses = A;
      }
    }, mae = (e, n) => {
      if (e.response_body && e.response_body.length) {
        const i = e.response_body[0];
        if (i.buffer.code !== 0) {
          const o = bp(i.buffer.code);
          throw new jt(Je.UPDATE_TICKET_FAILED, "[".concat(i.buffer.code, "]: ").concat(o.desc), { retry: o.retry });
        }
        return i.buffer.ticket;
      }
      throw Ee.debug("update ticket request received ap response without response body:", n), new jt(Je.UPDATE_TICKET_FAILED, "cannot find response body from ap response", { retry: !1 });
    }, xI = (e, n, i) => {
      const o = Math.floor(Math.random() * 1e12), f = e.role === "host" ? "1" : e.role === "audience" ? "2" : void 0, T = { appid: e.appId, client_ts: Date.now(), opid: o, sid: e.sid, request_bodies: [{ uri: 22, buffer: { cname: e.cname, detail: VE(VE(VE({ 6: e.stringUid, 11: n, 12: ft("USE_NEW_TOKEN") ? "1" : void 0 }, f ? { 17: f } : {}), {}, { 22: n }, e.apRequestDetail ? { 33: e.apRequestDetail } : {}), e.apRTM ? { 26: "RTM2" } : {}), key: e.token, service_ids: i, uid: e.uid || 0 } }] };
      T.request_bodies.forEach((R) => {
        e.multiIP && e.multiIP.gateway_ip && (R.buffer.detail[5] = JSON.stringify({ vocs_ip: [e.multiIP.uni_lbs_ip], vos_ip: [e.multiIP.gateway_ip] }));
      });
      const A = new FormData();
      return A.append("request", JSON.stringify(T)), [A, o];
    }, Eae = (e, n) => {
      const i = Math.floor(Math.random() * 1e12), o = { appid: e.appId, client_ts: Date.now(), opid: i, sid: e.sid, request_bodies: [{ uri: 28, buffer: { cname: e.cname, detail: { 1: "", 6: e.stringUid, 12: "1" }, token: e.token, service_ids: n, uid: e.uid || 0, edges_services: e.apResponse.addresses.map((T) => ({ ip: T.ip, port: T.port })) } }] }, f = new FormData();
      return f.append("request", JSON.stringify(o)), [f, i];
    };
    let Ip = 0;
    function Rp(e) {
      return cn.all(e.map((n) => n.then((i) => {
        throw i;
      }, (i) => i))).then((n) => {
        throw n;
      }, (n) => n);
    }
    const YE = async (e) => {
      let { fragementLength: n, referenceList: i, asyncMapHandler: o, allFailedhandler: f, promisesCollector: T } = e, A = 0;
      const R = n;
      let P, L = 0;
      const z = async () => {
        const Y = (() => {
          const te = A * R, oe = te + R;
          return i.slice(te, oe).map(o);
        })();
        T && T.push(...Y);
        try {
          P = await Rp(Y);
        } catch (te) {
          if (L += R, A++, !(L >= i.length)) return void await z();
          f(te);
        }
        Y.forEach((te) => te.cancel());
      };
      return await z(), P;
    }, S6 = async (e) => {
      let { referenceList: n, asyncMapHandler: i, closeFn: o } = e;
      const f = n.length;
      let T = 0;
      const A = async () => {
        const R = i(n.shift());
        try {
          return await R;
        } catch (P) {
          if (T++, T >= f || o != null && o(P)) throw P;
          return A();
        }
      };
      return A();
    };
    async function DI(e, n, i, o) {
      return { gatewayInfo: await async function(T, A, R, P) {
        let L = null;
        const z = [], Y = async () => {
          const oe = ft("WEBCS_DOMAIN").slice(0, ft("AJAX_REQUEST_CONCURRENT")).map((De) => ({ url: T.proxyServer ? "https://".concat(T.proxyServer, "/ap/?url=").concat(De + "/api/v2/transpond/webrtc?v=2") : "https://".concat(De, "/api/v2/transpond/webrtc?v=2"), areaCode: GE() })), He = P.recordJoinChannelService({ startTs: Date.now(), status: "pending", service: "chooseServer", urls: oe.map((De) => De.url) }), Re = await YE({ fragementLength: ft("FRAGEMENT_LENGTH"), referenceList: oe, asyncMapHandler: (De) => (Ee.debug("[".concat(T.clientId, "] Connect to choose_server:"), De.url), A6(De, T, A, R)), allFailedhandler: (De) => {
            throw P.recordJoinChannelService({ endTs: Date.now(), status: "error", errors: De }, He), De[0];
          }, promisesCollector: z });
          return P.recordJoinChannelService({ endTs: Date.now(), status: "success" }, He), Re;
        }, te = async () => {
          if (await Es(1e3), L !== null) return L;
          const oe = ft("WEBCS_DOMAIN_BACKUP_LIST").map((De) => ({ url: T.proxyServer ? "https://".concat(T.proxyServer, "/ap/?url=").concat(De + "/api/v2/transpond/webrtc?v=2") : "https://".concat(De, "/api/v2/transpond/webrtc?v=2"), areaCode: GE() })), He = P.recordJoinChannelService({ endTs: void 0, startTs: Date.now(), status: "pending", service: "chooseServer", urls: oe.map((De) => De.url) }), Re = await YE({ fragementLength: ft("FRAGEMENT_LENGTH"), referenceList: oe, asyncMapHandler: (De) => (Ee.debug("[".concat(T.clientId, "] Connect to backup choose_server:"), De.url), A6(De, T, A, R)), allFailedhandler: (De) => {
            throw P.recordJoinChannelService({ endTs: Date.now(), status: "error", errors: De }, He), De[0];
          }, promisesCollector: z });
          return P.recordJoinChannelService({ endTs: Date.now(), status: "success" }, He), Re;
        };
        try {
          return L = await Rp([Y(), te()]), z.length && z.forEach((oe) => oe.cancel && typeof oe.cancel == "function" && oe.cancel()), L;
        } catch (oe) {
          throw oe[0];
        }
      }(e, n, i, o) };
    }
    async function I6(e, n, i, o, f) {
      const T = e.cloudProxyServer;
      if (T === "disabled") {
        if (e.useLocalAccessPoint) return await DI(e, n, i, f);
        if (ft("JOIN_WITH_FALLBACK_MEDIA_PROXY")) {
          const { gatewayInfo: te, proxyInfo: oe } = await w6(e, n, i, f);
          if (e.turnServer && e.turnServer.mode !== "auto") return { gatewayInfo: te };
          const He = oe.map((Re) => ({ turnServerURL: Re.address, tcpport: Re.tcpport || Is.tcpport, udpport: Re.udpport || Is.udpport, username: Re.username || Is.username, password: Re.password || Is.password, forceturn: !1, security: !0 }));
          if (f.useP2P) {
            var A;
            const Re = (A = e.uid) !== null && A !== void 0 ? A : te.uid, De = "glb:".concat(Re.toString()), Xe = await LS(De), We = oe.map((mt) => ({ turnServerURL: mt.address, tcpport: mt.tcpport || Is.tcpport, udpport: mt.udpport || Is.udpport, username: De, password: Xe, forceturn: !1, security: !0 }));
            He.push(...We);
          }
          return e.turnServer = { mode: "manual", servers: He }, { gatewayInfo: te };
        }
        return await DI(e, n, i, f);
      }
      const { proxyInfo: R, gatewayInfo: P } = await w6(e, n, i, f), L = { gatewayInfo: P }, z = R.map((te) => ({ turnServerURL: te.address, tcpport: T === "proxy3" ? void 0 : te.tcpport ? te.tcpport : Is.tcpport, udpport: T === "proxy4" ? void 0 : te.udpport ? te.udpport : Is.udpport, username: te.username || Is.username, password: te.password || Is.password, forceturn: T !== "proxy4", security: T === "proxy5" }));
      if (f.useP2P) {
        var Y;
        const te = (Y = e.uid) !== null && Y !== void 0 ? Y : P.uid, oe = "glb:".concat(te.toString()), He = await LS(oe), Re = R.map((De) => ({ turnServerURL: De.address, tcpport: T === "proxy3" ? void 0 : De.tcpport || Is.tcpport, udpport: T === "proxy4" ? void 0 : De.udpport || Is.udpport, username: oe, password: He, forceturn: T !== "proxy4", security: T === "proxy5" }));
        z.push(...Re);
      }
      return e.turnServer = { mode: "manual", servers: z }, Ee.debug("[".concat(e.clientId, "] set proxy server: ").concat(e.proxyServer, ", mode: ").concat(T)), L;
    }
    async function R6(e, n, i, o, f) {
      const T = ft("ACCOUNT_REGISTER").slice(0, ft("AJAX_REQUEST_CONCURRENT"));
      let A = [];
      A = n.proxyServer ? T.map((P) => "https://".concat(n.proxyServer, "/ap/?url=").concat(P + "/api/v1")) : T.map((P) => "https://".concat(P, "/api/v1"));
      const R = f == null ? void 0 : f.recordJoinChannelService({ startTs: Date.now(), status: "pending", service: "stringUID", urls: A });
      try {
        const P = await async function(L, z, Y, te, oe) {
          const He = Date.now(), Re = { sid: Y.sid, opid: 10, appid: Y.appId, string_uid: z };
          let De = L[0];
          const Xe = await jc(() => Hc(De + "".concat(De.indexOf("?") === -1 ? "?" : "&", "action=stringuid"), { data: Re, cancelToken: te, headers: { "X-Packet-Service-Type": 0, "X-Packet-URI": 72 } }), (We, mt) => {
            if (We.code === 0) {
              if (We.uid <= 0 || We.uid >= Math.pow(2, 32)) throw Ee.error("Invalid Uint Uid ".concat(z, " => ").concat(We.uid), We), Cn.reqUserAccount(Re.sid, { lts: He, success: !1, serverAddr: De, stringUid: Re.string_uid, uid: We.uid, errorCode: Je.INVALID_UINT_UID_FROM_STRING_UID, extend: Re }), new jt(Je.INVALID_UINT_UID_FROM_STRING_UID);
              return Cn.reqUserAccount(Re.sid, { lts: He, success: !0, serverAddr: De, stringUid: Re.string_uid, uid: We.uid, errorCode: null, extend: Re }), !1;
            }
            const Pt = bp(We.code);
            return Pt.retry && (De = L[(mt + 1) % L.length]), Cn.reqUserAccount(Re.sid, { lts: He, success: !1, serverAddr: De, stringUid: Re.string_uid, uid: We.uid, errorCode: Pt.desc, extend: Re }), Pt.retry;
          }, (We, mt) => We.code !== Je.OPERATION_ABORTED && (Cn.reqUserAccount(Re.sid, { lts: He, success: !1, serverAddr: De, stringUid: Re.string_uid, uid: null, errorCode: We.code, extend: Re }), De = L[(mt + 1) % L.length], !0), oe);
          if (Xe.code !== 0) {
            const We = bp(Xe.code);
            throw new jt(Je.UNEXPECTED_RESPONSE, We.desc);
          }
          return Xe;
        }(A, e, n, i, o);
        return f == null || f.recordJoinChannelService({ status: "success", endTs: Date.now() }, R), P.uid;
      } catch (P) {
        throw f == null || f.recordJoinChannelService({ status: "error", endTs: Date.now(), errors: [P] }, R), P;
      }
    }
    async function yae(e, n, i) {
      const o = ft("ACCOUNT_REGISTER");
      let f = [];
      f = n.proxyServer ? o.map((T) => "https://".concat(n.proxyServer, "/ap/?url=").concat(T + "/api/v1")) : o.map((T) => "https://".concat(T, "/api/v1"));
      try {
        return await S6({ referenceList: f, asyncMapHandler: (A) => async function(R, P, L, z) {
          const Y = Date.now(), te = { sid: L.sid, opid: 10, appid: L.appId, string_uid: P };
          try {
            const oe = await Hc(R + "".concat(R.indexOf("?") === -1 ? "?" : "&", "action=stringuid"), { data: te, cancelToken: z, headers: { "X-Packet-Service-Type": 0, "X-Packet-URI": 72 } });
            if (oe.code !== 0) {
              const He = bp(oe.code);
              throw new jt(Je.UNEXPECTED_RESPONSE, "preload sua error:".concat(He.desc), He);
            }
            if (oe.uid <= 0 || oe.uid >= Math.pow(2, 32)) throw new jt(Je.INVALID_UINT_UID_FROM_STRING_UID);
            return { requestTime: Y, url: R, req: te, uid: oe.uid, elapse: Date.now() - Y };
          } catch (oe) {
            throw oe;
          }
        }(A, e, n, i), closeFn: (A) => A.code === Je.OPERATION_ABORTED || A.code === Je.UNEXPECTED_RESPONSE && !A.data.retry });
      } catch (T) {
        throw T;
      }
    }
    async function vae(e, n, i) {
      const o = ft("CDS_AP").slice(0, ft("AJAX_REQUEST_CONCURRENT")).map((P) => e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(P + "/api/v1") : "https://".concat(P, "/api/v1?action=config")), f = o.map((P) => function(L, z, Y, te) {
        const oe = hr(), He = { flag: 64, cipher_method: 0, features: { device: oe.name, system: oe.os, system_general: navigator.userAgent, vendor: z.appId, version: Ro, cname: z.cname, sid: z.sid, session_id: z.sid, detail: "", proxyServer: z.proxyServer } };
        return jc(() => Hc(L, { data: He, timeout: 1e3, cancelToken: Y, headers: { "X-Packet-Service-Type": 0, "X-Packet-URI": 54 } }), void 0, (Re) => Re.code !== Je.OPERATION_ABORTED, te);
      }(P, e, n, i));
      let T = null, A = null, R = {};
      try {
        T = await Rp(f);
      } catch (P) {
        if (P.code === Je.OPERATION_ABORTED) throw P;
        A = P;
      }
      if (f.forEach((P) => P.cancel()), Cn.reportApiInvoke(e.sid, { name: Bi.REQUEST_CONFIG_DISTRIBUTE, options: { error: A, res: T } }).onSuccess(), T && T.test_tags) try {
        R = function(P) {
          if (!P.test_tags) return {};
          const L = P.test_tags, z = Object.keys(L), Y = {};
          return z.forEach((te) => {
            var oe;
            const He = Ys(oe = te.slice(4)).call(oe), Re = JSON.parse(L[te])[1];
            Y[He] = Re;
          }), Y;
        }(T);
      } catch {
      }
      return R;
    }
    async function N6(e, n) {
      const i = ft("WEBCS_DOMAIN").concat(ft("WEBCS_DOMAIN_BACKUP_LIST")).map((o) => ({ url: "https://".concat(o, "/api/v2/transpond/webrtc?v=2"), areaCode: GE(), serviceIds: [Li.CHOOSE_SERVER, Li.CLOUD_PROXY_FALLBACK] }));
      try {
        return await S6({ referenceList: i, asyncMapHandler: (f) => async function(T, A, R) {
          let P, { url: L, areaCode: z, serviceIds: Y } = T;
          const te = Date.now(), [oe, He] = xI(A, z, Y);
          let Re = Mi.networkState;
          try {
            Re && Mi.networkState === Fa.OFFLINE && Mi.onlineWaiter && await cn.race([Mi.onlineWaiter, Es(zi.maxRetryTimeout)]), Re = Mi.networkState;
            const { data: De, headers: Xe } = await Hc(L, { data: oe, cancelToken: R, headers: { "Content-Type": "multipart/form-data;" } }, !0, !0);
            P = Xe.http3 === "1" ? 1 : -1, ((xt) => {
              const Nt = [];
              if (xt.response_body.forEach((Vt) => {
                const nn = Vt.buffer.code;
                if (Vt.uri === 23 && nn === 0 && !Vt.buffer.edges_services) if (Vt.buffer.flag === 4194310) Vt.buffer.edges_services = [];
                else {
                  const fn = { error: new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, "no edge services in ap response", { retry: !0, csIp: xt.detail[502] }), flag: Vt.buffer.flag };
                  Nt.push(fn);
                }
                if (nn !== 0) {
                  const fn = bp(nn), hn = { error: new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, fn.desc, { desc: fn.desc, retry: fn.retry, csIp: xt.detail[502] }), flag: Vt.buffer.flag };
                  Vt.buffer.flag === 4194310 ? Ee.warning(hn.error.toString()) : Nt.push(hn);
                }
              }), Nt.length) throw new jt(Je.CAN_NOT_GET_GATEWAY_SERVER, Nt.map((Vt) => "flag: ".concat(Vt.flag, ", message: ").concat(Vt.error.message)).join(" | "), { retry: !!Nt.find((Vt) => Vt.error.data.retry), csIp: xt.detail[502], desc: [...new Set(Nt.map((Vt) => {
                var nn;
                return Vt == null || (nn = Vt.error) === null || nn === void 0 || (nn = nn.data) === null || nn === void 0 ? void 0 : nn.desc;
              }).filter((Vt) => !!Vt))] });
            })(De);
            const mt = BE(De, Li.CHOOSE_SERVER), Pt = BE(De, Li.CLOUD_PROXY_FALLBACK);
            return PI(mt), { gatewayInfo: TI(mt, L), proxyInfo: Pt, opid: He, requestTime: te, url: L, isHttp3: P, elapse: Date.now() - te };
          } catch (De) {
            throw De;
          }
        }(f, e, n), closeFn: (f) => f.code === Je.OPERATION_ABORTED || f.code === Je.CAN_NOT_GET_GATEWAY_SERVER && !f.data.retry });
      } catch (o) {
        throw o;
      }
    }
    async function w6(e, n, i, o) {
      const f = ft("PROXY_SERVER_TYPE3"), T = (oe, He, Re) => {
        let De = Re || f;
        return Array.isArray(De) && (De = He % 2 == 0 ? f[1] : f[0]), "https://".concat(De, "/ap/?url=").concat(oe);
      };
      let A = null;
      const R = [], P = async () => {
        const oe = ft("WEBCS_DOMAIN").slice(0, ft("AJAX_REQUEST_CONCURRENT")).map((De, Xe) => {
          let We;
          return We = e.cloudProxyServer === "disabled" && e.proxyServer ? T("".concat(De, "/api/v2/transpond/webrtc?v=2"), Xe, e.proxyServer) : e.cloudProxyServer === "disabled" || e.cloudProxyServer === "fallback" ? "https://".concat(De, "/api/v2/transpond/webrtc?v=2") : T("".concat(De, "/api/v2/transpond/webrtc?v=2"), Xe), { url: We, areaCode: GE(), serviceIds: [Li.CHOOSE_SERVER, e.cloudProxyServer === "proxy5" ? Li.CLOUD_PROXY_5 : e.cloudProxyServer === "proxy3" || e.cloudProxyServer === "proxy4" ? Li.CLOUD_PROXY : Li.CLOUD_PROXY_FALLBACK] };
        }), He = o.recordJoinChannelService({ startTs: Date.now(), status: "pending", service: "chooseServer", urls: oe.map((De) => De.url) }), Re = await YE({ fragementLength: ft("FRAGEMENT_LENGTH"), referenceList: oe, asyncMapHandler: (De) => (Ee.debug("[".concat(e.clientId, "] Connect to choose_server:"), De.url), O6(De, e, n, i)), allFailedhandler: (De) => {
          throw o.recordJoinChannelService({ endTs: Date.now(), status: "error", errors: De }, He), De[0];
        }, promisesCollector: R });
        return o.recordJoinChannelService({ endTs: Date.now(), status: "success" }, He), Re;
      }, L = async () => {
        if (await Es(1e3), A !== null) return A;
        const oe = ft("WEBCS_DOMAIN_BACKUP_LIST").map((De, Xe) => {
          let We;
          return We = e.cloudProxyServer === "disabled" && e.proxyServer ? T("".concat(De, "/api/v2/transpond/webrtc?v=2"), Xe, e.proxyServer) : e.cloudProxyServer === "disabled" || e.cloudProxyServer === "fallback" ? "https://".concat(De, "/api/v2/transpond/webrtc?v=2") : T("".concat(De, "/api/v2/transpond/webrtc?v=2"), Xe), { url: We, areaCode: GE(), serviceIds: [Li.CHOOSE_SERVER, e.cloudProxyServer === "proxy5" ? Li.CLOUD_PROXY_5 : e.cloudProxyServer === "proxy3" || e.cloudProxyServer === "proxy4" ? Li.CLOUD_PROXY : Li.CLOUD_PROXY_FALLBACK] };
        }), He = o.recordJoinChannelService({ startTs: Date.now(), status: "pending", service: "chooseServer", urls: oe.map((De) => De.url) }), Re = await YE({ fragementLength: ft("FRAGEMENT_LENGTH"), referenceList: oe, asyncMapHandler: (De) => (Ee.debug("[".concat(e.clientId, "] Connect to backup choose_server:"), De.url), O6(De, e, n, i)), allFailedhandler: (De) => {
          throw o.recordJoinChannelService({ endTs: Date.now(), status: "error", errors: De }, He), De[0];
        }, promisesCollector: R });
        return o.recordJoinChannelService({ endTs: Date.now(), status: "success" }, He), Re;
      };
      let z, Y, te;
      try {
        ({ gatewayInfo: z, proxyInfo: Y, url: te } = await Rp([P(), L()]));
      } catch (oe) {
        throw oe[0];
      }
      if (R.length && R.forEach((oe) => oe.cancel && typeof oe.cancel == "function" && oe.cancel()), !z || !Y) throw new jt(Je.UNEXPECTED_ERROR, "missing gateway or proxy response").print();
      if (e.apUrl = te, e.cloudProxyServer !== "disabled" && Array.isArray(f) && te) {
        const oe = /^https?:\/\/(.+?)(\/.*)?$/.exec(te)[1];
        on(f).call(f, oe) && (e.proxyServer = oe, Ee.setProxyServer(oe), Cn.setProxyServer(oe));
      }
      return A = { gatewayInfo: z, proxyInfo: await $8(Y, z.uid) }, A;
    }
    async function Tae(e, n, i) {
      const o = ft("UAP_AP").slice(0, ft("AJAX_REQUEST_CONCURRENT")).map((T) => e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(T + "/api/v1?action=uap") : "https://".concat(T, "/api/v1?action=uap")), f = o.map((T) => function(A, R, P, L) {
        const z = { command: "convergeAllocateEdge", sid: R.sid, appId: R.appId, token: R.token, ts: Date.now(), version: Ro, cname: R.cname, uid: R.uid.toString(), requestId: _I, seq: _I };
        _I += 1;
        const Y = { service_name: "tele_channel", json_body: JSON.stringify(z) };
        return jc(async () => {
          const te = await Hc(A, { data: Y, cancelToken: P, headers: { "X-Packet-Service-Type": 0, "X-Packet-URI": 61 } });
          if (te.code !== 0) {
            const He = new jt(Je.UNEXPECTED_RESPONSE, "cross channel ap error, code" + te.code, { retry: !0 });
            throw Ee.error(He.toString()), He;
          }
          const oe = JSON.parse(te.json_body);
          if (oe.code !== 200) {
            const He = new jt(Je.UNEXPECTED_RESPONSE, "cross channel app center error, code: ".concat(oe.code, ", reason: ").concat(oe.reason));
            throw Ee.error(He.toString()), He;
          }
          if (!oe.servers || oe.servers.length === 0) {
            const He = new jt(Je.UNEXPECTED_RESPONSE, "cross channel app center empty server");
            throw Ee.error(He.toString()), He;
          }
          return { vid: oe.vid, workerToken: oe.workerToken, addressList: (ft("CHANNEL_MEDIA_RELAY_SERVERS") || oe.servers).map((He) => "wss://".concat(He.address.replace(/\./g, "-"), ".").concat(ft("WORKER_DOMAIN"), ":").concat(He.wss)) };
        }, void 0, (te) => !!(te.code !== Je.OPERATION_ABORTED && te.code !== Je.UNEXPECTED_RESPONSE || te.data && te.data.retry), L);
      }(T, e, n, i));
      try {
        const T = await Rp(f);
        return f.forEach((A) => A.cancel()), T;
      } catch (T) {
        throw T[0];
      }
    }
    async function bae(e, n, i) {
      let o = null;
      const f = [], T = async (A) => {
        const R = ft(A ? "WEBCS_DOMAIN_BACKUP_LIST" : "WEBCS_DOMAIN").map((P) => e.proxyServer ? "https://".concat(e.proxyServer, "/ap/?url=").concat(P + "/api/v2/transpond/webrtc?v=2") : "https://".concat(P, "/api/v2/transpond/webrtc?v=2"));
        return A && (await Es(1e3), o !== null) ? o : await YE({ fragementLength: ft("FRAGEMENT_LENGTH"), referenceList: R, asyncMapHandler: (P) => (Ee.debug("[".concat(e.clientId, "] update ticket, Connect to ").concat(A ? "backup" : "", " choose_server:"), P), function(L, z, Y, te) {
          const [oe] = Eae(z, [Li.CHOOSE_SERVER]);
          let He = Mi.networkState;
          return jc(async () => {
            He && Mi.networkState === Fa.OFFLINE && Mi.onlineWaiter && await cn.race([Mi.onlineWaiter, Es(te && te.maxRetryTimeout || zi.maxRetryTimeout)]), He = Mi.networkState;
            const Re = await Hc(L, { data: oe, cancelToken: Y, headers: { "Content-Type": "multipart/form-data;" } }, !0);
            return mae(Re, L);
          }, () => !1, (Re) => Re.code !== Je.OPERATION_ABORTED && (Re.code === Je.UPDATE_TICKET_FAILED ? Re.data.retry : (Ee.warning("[".concat(z.clientId, "] update ticket network error, retry"), Re), !0)), te);
        }(P, e, n, i)), allFailedhandler: (P) => {
          throw P[0];
        }, promisesCollector: f });
      };
      try {
        return o = await Rp([T(!1), T(!0)]), f.length && f.forEach((A) => A.cancel && typeof A.cancel == "function" && A.cancel()), o;
      } catch (A) {
        throw A[0];
      }
    }
    function _6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function P6(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? _6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : _6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    class Aae extends ii {
      get isSuccess() {
        return !!this.configs;
      }
      constructor(n) {
        super(), Ve(this, "configs", void 0), Ve(this, "joinInfo", void 0), Ve(this, "cancelToken", void 0), Ve(this, "retryConfig", { timeout: 3e3, timeoutFactor: 1.5, maxRetryCount: 1, maxRetryTimeout: 1e4 }), Ve(this, "interval", void 0), Ve(this, "mutex", void 0), Ve(this, "mutableParamsRead", !1), this.mutex = new xs("config-distribute", n);
      }
      startGetConfigDistribute(n, i) {
        this.joinInfo = n, this.cancelToken = i, this.interval && this.stopGetConfigDistribute(), ft("ENABLE_CONFIG_DISTRIBUTE") && (this.updateConfigDistribute(), this.interval = window.setInterval(() => {
          this.updateConfigDistribute();
        }, ft("CONFIG_DISTRIBUTE_INTERVAL")));
      }
      stopGetConfigDistribute() {
        this.interval && clearInterval(this.interval), this.interval = void 0, this.joinInfo = void 0, this.cancelToken = void 0;
      }
      async awaitConfigDistributeComplete() {
        this.mutex.isLocked && (await this.mutex.lock())();
      }
      async updateConfigDistribute() {
        if (this.mutableParamsRead || (this.mutableParamsRead = !0, Cn.reportApiInvoke(null, { options: void 0, name: Bi.LOAD_CONFIG_FROM_LOCALSTORAGE, tag: si.TRACER }).onSuccess(JSON.stringify(ud))), !this.joinInfo || !this.cancelToken || !this.retryConfig) return void Ee.debug("[config-distribute] get config distribute interrupted have no joininfo");
        let n;
        const i = await this.mutex.lock();
        try {
          n = await vae(this.joinInfo, this.cancelToken, this.retryConfig), Ee.debug("[config-distribute] get config distribute", JSON.stringify(n)), n.limit_bitrate && this.handleBitrateLimit(n.limit_bitrate), this.cacheGlobalParameterConfig(n), this.configs = n;
        } catch (o) {
          const f = new jt(Je.NETWORK_RESPONSE_ERROR, o);
          Ee.warning("[config-distribute] ".concat(f.toString()));
        } finally {
          i();
        }
      }
      getBitrateLimit() {
        return this.configs ? this.configs.limit_bitrate : void 0;
      }
      handleBitrateLimit(n) {
        z8(n) && (this.configs && this.configs.limit_bitrate ? this.configs && this.configs.limit_bitrate && this.configs.limit_bitrate.id !== n.id && this.emit(jE.UPDATE_BITRATE_LIMIT, n) : this.emit(jE.UPDATE_BITRATE_LIMIT, n));
      }
      getLowStreamConfigDistribute() {
        return this.configs && this.configs.limit_bitrate && P6({}, this.configs.limit_bitrate.low_stream_uplink);
      }
      cacheGlobalParameterConfig(n) {
        var i;
        const o = hE(i = Object.keys(n).filter((A) => /^webrtc_ng_global_parameter/.test(A))).call(i);
        for (let A = 0; A < o.length; A++) for (let R = o.length - 1; R > A; R--) {
          const P = o[R];
          if (typeof n[P].__priority == "number") {
            const L = n[P].__priority, z = o[R - 1];
            if (typeof n[z].__priority == "number") {
              if (!(L > n[z].__priority)) continue;
              {
                const Y = P;
                o[R] = o[R - 1], o[R - 1] = Y;
              }
            } else {
              const Y = P;
              o[R] = o[R - 1], o[R - 1] = Y;
            }
          }
        }
        const f = {};
        o.forEach((A) => {
          const R = n[A], P = R.__expires;
          Object.keys(R).forEach((L) => {
            L === "__priority" || L === "__expires" || Object.prototype.hasOwnProperty.call(f, L) || (f[L] = P6({ value: R[L] }, P && { expires: P }));
          });
        });
        try {
          var T;
          const A = (T = f.LIMIT_BITRATE) === null || T === void 0 ? void 0 : T.value;
          delete f.LIMIT_BITRATE, this.handleGlobalParameterConfig(f), function(L) {
            try {
              const z = Date.now();
              Object.keys(L).forEach((Y) => {
                switch (Y) {
                  case "ENABLE_EVENT_REPORT":
                  case "UPLOAD_LOG":
                  case "ENABLE_AG_ADAPTATION":
                  case "FORCE_AG_HIGH_FRAMERATE":
                  case "FORCE_SUPPORT_AG_ADAPTATION":
                  case "ENCODER_CONFIG_LIMIT":
                  case "CAMERA_CAPTURE_CONFIG":
                  case "ENABLE_PRELOAD":
                  case "NEW_ICE_RESTART":
                  case "ICE_RESTART_INTERVAL":
                  case "RESTART_SEQUENCE":
                    if (Object.prototype.hasOwnProperty.call(ai, Y)) {
                      const { value: te, expires: oe } = L[Y];
                      if (oe && oe <= z) return;
                      ud[Y] = te, ai[Y] = te, Ee.debug("Update global parameters from config distribute", Y, te);
                    }
                }
              });
            } catch (z) {
              Ee.error("Error update config immediately: ".concat(L), z.message);
            }
          }(f);
          const R = JSON.stringify(f), P = window.btoa(R);
          window.localStorage.setItem("websdk_ng_global_parameter", P), Ee.debug("Caching global parameters ".concat(R)), A && z8(A) && (this.handleBitrateLimit(A), n.limit_bitrate = A);
        } catch (A) {
          Ee.error("Error caching global parameters:", A.message);
        }
      }
      handleGlobalParameterConfig(n) {
        try {
          const i = Date.now();
          Object.keys(n).forEach((o) => {
            if (o === "CLIENT_ROLE_OPTIONS" && Object.prototype.hasOwnProperty.call(ai, o)) {
              const { value: f, expires: T } = n[o];
              if (T && T <= i) return;
              (function(A, R) {
                try {
                  return typeof A == "object" && typeof R == "object" && JSON.stringify(A) === JSON.stringify(R);
                } catch {
                  return !1;
                }
              })(ai[o], f) || (ud[o] = f, ai[o] = f, this.emit(jE.UPDATE_CLIENT_ROLE_OPTIONS, f), Ee.debug("Updating client role options: ".concat(JSON.stringify(f))));
            }
          });
        } catch (i) {
          Ee.error("Error handling global parameter config:", i.message);
        }
      }
    }
    class Oae extends ii {
      constructor() {
        super(...arguments), Ve(this, "resultStorage", /* @__PURE__ */ new Map());
      }
      setLocalAudioStats(n, i, o) {
        this.record("AUDIO_INPUT_LEVEL_TOO_LOW", n, this.checkAudioInputLevel(o, i)), this.record("SEND_AUDIO_BITRATE_TOO_LOW", n, this.checkSendAudioBitrate(o, i));
      }
      setLocalVideoStats(n, i, o) {
        this.record("SEND_VIDEO_BITRATE_TOO_LOW", n, this.checkSendVideoBitrate(o, i)), this.record("FRAMERATE_INPUT_TOO_LOW", n, this.checkFramerateInput(o, i)), this.record("FRAMERATE_SENT_TOO_LOW", n, this.checkFramerateSent(o));
      }
      setRemoteAudioStats(n, i) {
        const o = n.getUserId();
        this.record("AUDIO_OUTPUT_LEVEL_TOO_LOW", o, this.checkAudioOutputLevel(i));
      }
      setRemoteVideoStats(n, i) {
        const o = n.getUserId();
        this.record("RECV_VIDEO_DECODE_FAILED", o, this.checkVideoDecode(i));
      }
      record(n, i, o) {
        if (ft("STATS_UPDATE_INTERVAL") > 500) return;
        this.resultStorage.has(n) || this.resultStorage.set(n, { result: [], isPrevNormal: !0 });
        const f = this.resultStorage.get(n);
        if (f && (f.result.push(o), f.result.length >= 5)) {
          var T;
          const A = on(T = f.result).call(T, !0);
          f.isPrevNormal && !A && this.emit("exception", x6[n], n, i), !f.isPrevNormal && A && this.emit("exception", x6[n] + 2e3, n + "_RECOVER", i), f.isPrevNormal = A, f.result = [];
        }
      }
      checkAudioOutputLevel(n) {
        return !(n.receiveBitrate > 0 && n.receiveLevel === 0);
      }
      checkAudioInputLevel(n, i) {
        return i instanceof Xi && !i.isActive || !!i.muted || n.sendVolumeLevel !== 0;
      }
      checkFramerateInput(n, i) {
        let o = null;
        i._encoderConfig && i._encoderConfig.frameRate && (o = Ga(i._encoderConfig.frameRate));
        const f = n.captureFrameRate;
        return !o || !f || !(o > 10 && f < 5 || o < 10 && o >= 5 && f <= 1);
      }
      checkFramerateSent(n) {
        return !(n.captureFrameRate && n.sendFrameRate && n.captureFrameRate > 5 && n.sendFrameRate <= 1);
      }
      checkSendVideoBitrate(n, i) {
        return !!i.muted || n.sendBitrate !== 0;
      }
      checkSendAudioBitrate(n, i) {
        return i instanceof Xi && !i.isActive || !!i.muted || n.sendBitrate !== 0;
      }
      checkVideoDecode(n) {
        return n.receiveBitrate === 0 || n.decodeFrameRate !== 0;
      }
    }
    const x6 = { FRAMERATE_INPUT_TOO_LOW: 1001, FRAMERATE_SENT_TOO_LOW: 1002, SEND_VIDEO_BITRATE_TOO_LOW: 1003, RECV_VIDEO_DECODE_FAILED: 1005, AUDIO_INPUT_LEVEL_TOO_LOW: 2001, AUDIO_OUTPUT_LEVEL_TOO_LOW: 2002, SEND_AUDIO_BITRATE_TOO_LOW: 2003 }, Ms = new class {
      markSubscribeStart(e, n) {
        performance.mark("agora-web-sdk/".concat(e, "/subscribe-").concat(n));
      }
      markPublishStart(e, n) {
        performance.mark("agora-web-sdk/".concat(e, "/publish-").concat(n));
      }
      measureFromSubscribeStart(e, n) {
        const i = performance.getEntriesByName("agora-web-sdk/".concat(e, "/subscribe-").concat(n));
        if (i.length > 0) {
          const o = i[i.length - 1];
          return Math.round(performance.now() - o.startTime);
        }
        return 0;
      }
      measureFromPublishStart(e, n) {
        const i = performance.getEntriesByName("agora-web-sdk/".concat(e, "/publish-").concat(n));
        if (i.length > 0) {
          const o = i[i.length - 1];
          return Math.round(performance.now() - o.startTime);
        }
        return 0;
      }
    }();
    function D6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function wf(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? D6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : D6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    class XE {
      constructor(n) {
        Ve(this, "store", void 0), Ve(this, "onStatsException", void 0), Ve(this, "onUploadPublishDuration", void 0), Ve(this, "onStatsChanged", void 0), Ve(this, "localStats", /* @__PURE__ */ new Map()), Ve(this, "remoteStats", /* @__PURE__ */ new Map()), Ve(this, "updateStatsInterval", void 0), Ve(this, "trafficStats", void 0), Ve(this, "trafficStatsPeerList", []), Ve(this, "uplinkStats", void 0), Ve(this, "exceptionMonitor", void 0), Ve(this, "p2pChannel", void 0), Ve(this, "scalabilityMode", gT.L1T1), Ve(this, "updateStats", () => {
          this.p2pChannel && (this.updateRemoteStats(this.p2pChannel), this.updateLocalStats(this.p2pChannel));
        }), this.store = n, this.exceptionMonitor = new Oae(), this.exceptionMonitor.on("exception", (i, o, f) => {
          this.onStatsException && this.onStatsException(i, o, f);
        });
      }
      startUpdateStats() {
        this.updateStatsInterval || (this.updateStatsInterval = window.setInterval(this.updateStats, 1e3));
      }
      stopUpdateStats() {
        this.updateStatsInterval && (window.clearInterval(this.updateStatsInterval), this.updateStatsInterval = void 0);
      }
      reset() {
        this.localStats = /* @__PURE__ */ new Map(), this.remoteStats = /* @__PURE__ */ new Map(), this.trafficStats = void 0, this.trafficStatsPeerList = [], this.uplinkStats = void 0;
      }
      getLocalAudioTrackStats() {
        return this.localStats.get(Qt.LocalAudioTrack) || wf({}, $S);
      }
      getLocalVideoTrackStats() {
        return this.localStats.get(Qt.LocalVideoTrack) || wf({}, eI);
      }
      getRemoteAudioTrackStats(n) {
        const i = (T, A) => {
          if (!this.trafficStats) return A;
          const R = this.trafficStats.peer_delay.find((P) => P.peer_uid === T);
          return R && (A.publishDuration = R.B_ppad + (Date.now() - this.trafficStats.timestamp)), A;
        }, o = {};
        if (n) {
          var f;
          const T = (f = this.remoteStats.get(n)) === null || f === void 0 ? void 0 : f.audioStats;
          T && (o[n] = i(n, T));
        } else Array.from(this.remoteStats.entries()).forEach((T) => {
          let [A, { audioStats: R }] = T;
          R && (o[A] = i(A, R));
        });
        return o;
      }
      getRemoteNetworkQualityStats(n) {
        const i = {};
        if (n) {
          var o;
          const f = (o = this.remoteStats.get(n)) === null || o === void 0 ? void 0 : o.networkStats;
          f && (i[n] = f);
        } else Array.from(this.remoteStats.entries()).forEach((f) => {
          let [T, { networkStats: A }] = f;
          A && (i[T] = A);
        });
        return i;
      }
      getRemoteVideoTrackStats(n) {
        const i = (T, A) => {
          if (!this.trafficStats) return A;
          const R = this.trafficStats.peer_delay.find((P) => P.peer_uid === T);
          return R && (A.publishDuration = R.B_ppvd + (Date.now() - this.trafficStats.timestamp)), A;
        }, o = {};
        if (n) {
          var f;
          const T = (f = this.remoteStats.get(n)) === null || f === void 0 ? void 0 : f.videoStats;
          T && (o[n] = i(n, T));
        } else Array.from(this.remoteStats.entries()).forEach((T) => {
          let [A, { videoStats: R }] = T;
          R && (o[A] = i(A, R));
        });
        return o;
      }
      getRTCStats() {
        let n = 0, i = 0, o = 0, f = 0;
        const T = this.localStats.get(Qt.LocalAudioTrack);
        T && (n += T.sendBytes, i += T.sendBitrate);
        const A = this.localStats.get(Qt.LocalVideoTrack);
        A && (n += A.sendBytes, i += A.sendBitrate);
        const R = this.localStats.get(Qt.LocalVideoLowTrack);
        R && (n += R.sendBytes, i += R.sendBitrate), this.remoteStats.forEach((L) => {
          let { audioStats: z, videoStats: Y } = L;
          z && (o += z.receiveBytes, f += z.receiveBitrate), Y && (o += Y.receiveBytes, f += Y.receiveBitrate);
        });
        let P = 1;
        return this.trafficStats && (P += this.trafficStats.peer_delay.length), { Duration: 0, UserCount: P, SendBitrate: i, SendBytes: n, RecvBytes: o, RecvBitrate: f, OutgoingAvailableBandwidth: this.uplinkStats ? this.uplinkStats.B_uab / 1e3 : 0, RTT: this.trafficStats ? 2 * this.trafficStats.B_acd : 0 };
      }
      addLocalStats(n) {
        this.localStats.set(n, void 0);
      }
      removeLocalStats(n) {
        n ? this.localStats.delete(n) : this.localStats.clear();
      }
      addRemoteStats(n) {
        this.remoteStats.set(n, {});
      }
      removeRemoteStats(n) {
        n ? this.remoteStats.delete(n) : this.remoteStats.clear();
      }
      addP2PChannel(n) {
        this.p2pChannel = n;
      }
      updateTrafficStats(n) {
        n.peer_delay = n.peer_delay.filter((i) => i.B_ppad !== void 0 || i.B_ppvd !== void 0), n.peer_delay.filter((i) => this.trafficStatsPeerList.indexOf(i.peer_uid) === -1).forEach((i) => {
          var o;
          const f = (o = this.p2pChannel) === null || o === void 0 ? void 0 : o.getRemoteMedia(i.peer_uid), T = f != null && f.videoSSRC ? Ms.measureFromSubscribeStart(this.store.clientId, f.videoSSRC) : 0, A = f != null && f.audioSSRC ? Ms.measureFromSubscribeStart(this.store.clientId, f.audioSSRC) : 0;
          i.B_ppad !== void 0 && i.B_ppvd !== void 0 && (this.onUploadPublishDuration && this.onUploadPublishDuration(i.peer_uid, i.B_ppad, i.B_ppvd, T > A ? T : A), this.trafficStatsPeerList.push(i.peer_uid));
        }), this.trafficStats = n;
      }
      updateUplinkStats(n) {
        this.uplinkStats && this.uplinkStats.B_fir !== n.B_fir && Ee.debug("[".concat(this.store.clientId, "]: Period fir changes to ").concat(n.B_fir)), this.uplinkStats = n;
      }
      static isRemoteVideoFreeze(n, i, o) {
        if (!n) return !1;
        const f = !!o && i.framesDecodeFreezeTime > o.framesDecodeFreezeTime, T = !o || i.framesDecodeCount > o.framesDecodeCount;
        return f || !T;
      }
      static isRemoteAudioFreeze(n) {
        return !!n && n._isFreeze();
      }
      isLocalVideoFreeze(n) {
        return !(!n.inputFrame || !n.sentFrame) && n.inputFrame.frameRate > 5 && n.sentFrame.frameRate < 3;
      }
      updateLocalStats(n) {
        Array.from(this.localStats.entries()).forEach((i) => {
          let [o, f] = i;
          switch (o) {
            case Qt.LocalVideoTrack:
            case Qt.LocalVideoLowTrack: {
              const A = f, R = wf({}, eI), P = n.getStats(), L = n.getLocalMedia(o);
              if (P) {
                const z = P.videoSend.find((Y) => Y.ssrc === (L == null ? void 0 : L.ssrcs[0].ssrcId));
                if (z) {
                  const Y = n.getLocalVideoSize(), te = n.getEncoderConfig(Qt.LocalVideoTrack);
                  z.codec !== "H264" && z.codec !== "H265" && z.codec !== "VP8" && z.codec !== "VP9" && z.codec !== "AV1X" && z.codec !== "AV1" || (R.codecType = z.codec), R.sendBytes = z.bytes, R.sendBitrate = A ? 8 * Math.max(0, R.sendBytes - A.sendBytes) : 0, z.inputFrame ? (R.captureFrameRate = z.inputFrame.frameRate, R.captureResolutionHeight = z.inputFrame.height, R.captureResolutionWidth = z.inputFrame.width) : Y && (R.captureResolutionWidth = Y.width, R.captureResolutionHeight = Y.height), z.sentFrame ? (R.sendFrameRate = z.sentFrame.frameRate, R.sendResolutionHeight = z.sentFrame.height, R.sendResolutionWidth = z.sentFrame.width) : Y && (R.sendResolutionWidth = Y.width, R.sendResolutionHeight = Y.height), z.avgEncodeMs && (R.encodeDelay = z.avgEncodeMs), te && te.bitrateMax && (R.targetSendBitrate = 1e3 * te.bitrateMax), R.sendPackets = z.packets, R.sendPacketsLost = z.packetsLost, R.sendJitterMs = z.jitterMs, R.sendRttMs = z.rttMs, R.totalDuration = A ? A.totalDuration + 1 : 1, R.totalFreezeTime = A ? A.totalFreezeTime : 0, this.isLocalVideoFreeze(z) && (R.totalFreezeTime += 1), z.scalabilityMode && this.scalabilityMode !== z.scalabilityMode && (Ee.debug("[".concat(this.store.clientId, "]: The scalabilityMode of the video sending stream is ").concat(z.scalabilityMode)), this.scalabilityMode = z.scalabilityMode);
                }
                this.trafficStats && (R.currentPacketLossRate = (this.trafficStats.B_pvlr4 || 0) / 100);
              }
              var T;
              this.localStats.set(o, R), ((A == null ? void 0 : A.sendResolutionWidth) !== R.sendResolutionWidth || (A == null ? void 0 : A.sendResolutionHeight) !== R.sendResolutionHeight) && ((T = this.onStatsChanged) === null || T === void 0 || T.call(this, "resolution", { width: R.sendResolutionWidth, height: R.sendResolutionHeight })), R && L && this.exceptionMonitor.setLocalVideoStats(this.store.uid, L.track, R);
              break;
            }
            case Qt.LocalAudioTrack: {
              const A = f, R = wf({}, $S), P = n.getStats(), L = n.getLocalMedia(o);
              if (P) {
                const z = P.audioSend.find((Y) => Y.ssrc === (L == null ? void 0 : L.ssrcs[0].ssrcId));
                if (z) {
                  if (z.codec !== "opus" && z.codec !== "aac" && z.codec !== "PCMU" && z.codec !== "PCMA" && z.codec !== "G722" || (R.codecType = z.codec), z.inputLevel) R.sendVolumeLevel = Math.round(32767 * z.inputLevel);
                  else {
                    const Y = n.getLocalAudioVolume();
                    Y && (R.sendVolumeLevel = Math.round(32767 * Y));
                  }
                  R.sendBytes = z.bytes, R.sendPackets = z.packets, R.sendPacketsLost = z.packetsLost, R.sendJitterMs = z.jitterMs, R.sendRttMs = z.rttMs, R.sendBitrate = A ? 8 * Math.max(0, R.sendBytes - A.sendBytes) : 0;
                }
              }
              this.trafficStats && (R.currentPacketLossRate = (this.trafficStats.B_palr4 || 0) / 100), this.localStats.set(Qt.LocalAudioTrack, R), R && L && this.exceptionMonitor.setLocalAudioStats(this.store.uid, L.track, R);
              break;
            }
          }
        });
      }
      updateRemoteStats(n) {
        Array.from(this.remoteStats.entries()).forEach((i) => {
          var o, f;
          let [T, { videoStats: A, audioStats: R, videoPcStats: P }] = i;
          const L = R, z = A, Y = P, te = wf({}, x5), oe = wf({}, D5), He = wf({}, fse), { audioTrack: Re, videoTrack: De, audioSSRC: Xe, videoSSRC: We } = n.getRemoteMedia(T);
          let mt;
          mt = this.store.useP2P ? n.getStats(!0) : n.getStats();
          const Pt = (o = mt) === null || o === void 0 ? void 0 : o.audioRecv.find((nn) => nn.ssrc === Xe), xt = (f = mt) === null || f === void 0 ? void 0 : f.videoRecv.find((nn) => nn.ssrc === We), Nt = this.trafficStats && this.trafficStats.peer_delay.find((nn) => nn.peer_uid === T);
          if (Pt && (Pt.codec !== "opus" && Pt.codec !== "aac" && Pt.codec !== "PCMU" && Pt.codec !== "PCMA" && Pt.codec !== "G722" || (te.codecType = Pt.codec), Pt.outputLevel ? te.receiveLevel = Math.round(32767 * Pt.outputLevel) : Re && (te.receiveLevel = Math.round(32767 * Re.getVolumeLevel())), te.receiveBytes = Pt.bytes, te.receivePackets = Pt.packets, te.receivePacketsLost = Pt.packetsLost, te.receivePacketsDiscarded = Pt.packetsDiscarded, te.packetLossRate = te.receivePacketsLost / (te.receivePackets + te.receivePacketsLost), te.receiveBitrate = L ? 8 * Math.max(0, te.receiveBytes - L.receiveBytes) : 0, te.totalDuration = L ? L.totalDuration + 1 : 1, te.totalFreezeTime = L ? L.totalFreezeTime : 0, te.freezeRate = te.totalFreezeTime / te.totalDuration, te.receiveDelay = Pt.jitterBufferMs, te.totalDuration > 10 && XE.isRemoteAudioFreeze(Re) && (te.totalFreezeTime += 1)), xt) {
            var Vt;
            xt.codec !== "H264" && xt.codec !== "H265" && xt.codec !== "VP8" && xt.codec !== "VP9" && xt.codec !== "AV1X" && xt.codec !== "AV1" || (oe.codecType = xt.codec), oe.receiveBytes = xt.bytes, oe.receiveBitrate = z ? 8 * Math.max(0, oe.receiveBytes - z.receiveBytes) : 0, oe.decodeFrameRate = xt.decodeFrameRate < 0 ? 0 : xt.decodeFrameRate, oe.renderFrameRate = xt.decodeFrameRate < 0 ? 0 : xt.decodeFrameRate, xt.outputFrame && (oe.renderFrameRate = xt.outputFrame.frameRate), xt.receivedFrame ? (oe.receiveFrameRate = xt.receivedFrame.frameRate, oe.receiveResolutionHeight = xt.receivedFrame.height, oe.receiveResolutionWidth = xt.receivedFrame.width) : De && (oe.receiveResolutionHeight = De._videoHeight || 0, oe.receiveResolutionWidth = De._videoWidth || 0), xt.framesRateFirefox !== void 0 && (oe.receiveFrameRate = Math.round(xt.framesRateFirefox)), oe.receivePackets = xt.packets, oe.receivePacketsLost = xt.packetsLost, oe.packetLossRate = oe.receivePacketsLost / (oe.receivePackets + oe.receivePacketsLost);
            const nn = z ? z.totalFreezeTime : 0, fn = z ? z.totalDuration : 0;
            oe.totalDuration = z ? z.totalDuration + 1 : 1, oe.totalFreezeTime = (Vt = xt.totalFreezesDuration) !== null && Vt !== void 0 ? Vt : nn || 0, oe.receiveDelay = xt.jitterBufferMs || 0;
            const hn = !!We && n.getRemoteVideoIsReady(We);
            xt.totalFreezesDuration === void 0 && De && hn && XE.isRemoteVideoFreeze(De, xt, Y) && (oe.totalFreezeTime += 1), oe.freezeRate = Math.max(0, Math.min((oe.totalFreezeTime - nn) / (oe.totalDuration - fn), 1));
          }
          Nt && (te.end2EndDelay = Nt.B_ad, oe.end2EndDelay = Nt.B_vd, te.transportDelay = Nt.B_ed, oe.transportDelay = Nt.B_ed, te.currentPacketLossRate = Nt.B_ealr4 / 100, oe.currentPacketLossRate = Nt.B_evlr4 / 100, He.uplinkNetworkQuality = Nt.B_punq ? Nt.B_punq : 0, He.downlinkNetworkQuality = Nt.B_pdnq ? Nt.B_pdnq : 0), this.remoteStats.set(T, { audioStats: te, videoStats: oe, videoPcStats: xt, networkStats: He }), Re && this.exceptionMonitor.setRemoteAudioStats(Re, te), De && this.exceptionMonitor.setRemoteVideoStats(De, oe);
        });
      }
    }
    class M6 {
      constructor() {
        Ve(this, "destChannelMediaInfos", /* @__PURE__ */ new Map()), Ve(this, "srcChannelMediaInfo", void 0);
      }
      setSrcChannelInfo(n) {
        H8(n), this.srcChannelMediaInfo = n;
      }
      addDestChannelInfo(n) {
        H8(n), this.destChannelMediaInfos.set(n.channelName, n);
      }
      removeDestChannelInfo(n) {
        wT(n), this.destChannelMediaInfos.delete(n);
      }
      getSrcChannelMediaInfo() {
        return this.srcChannelMediaInfo;
      }
      getDestChannelMediaInfo() {
        return this.destChannelMediaInfos;
      }
    }
    function L6(e) {
      if (!(e instanceof M6))
        return new jt(Je.INVALID_PARAMS, "Config should be instance of [ChannelMediaRelayConfiguration]").throw();
      const n = e.getSrcChannelMediaInfo(), i = e.getDestChannelMediaInfo();
      if (!n)
        return new jt(Je.INVALID_PARAMS, "srcChannelMediaInfo should not be empty").throw();
      if (i.size === 0)
        return new jt(Je.INVALID_PARAMS, "destChannelMediaInfo should not be empty").throw();
    }
    class cl {
      get hasVideo() {
        return this._video_enabled_ && !this._video_muted_ && this._video_added_;
      }
      get hasAudio() {
        return this._audio_enabled_ && !this._audio_muted_ && this._audio_added_;
      }
      get audioTrack() {
        if (this.hasAudio || this._audio_pre_subscribed) return this._audioTrack;
      }
      get videoTrack() {
        if (this.hasVideo || this._video_pre_subscribed) return this._videoTrack;
      }
      get dataChannels() {
        return this._dataChannels;
      }
      constructor(n, i) {
        Ve(this, "uid", void 0), Ve(this, "_uintid", void 0), Ve(this, "_trust_in_room_", !0), Ve(this, "_trust_audio_enabled_state_", !0), Ve(this, "_trust_video_enabled_state_", !0), Ve(this, "_trust_audio_mute_state_", !0), Ve(this, "_trust_video_mute_state_", !0), Ve(this, "_audio_muted_", !1), Ve(this, "_video_muted_", !1), Ve(this, "_audio_enabled_", !0), Ve(this, "_video_enabled_", !0), Ve(this, "_audio_added_", !1), Ve(this, "_video_added_", !1), Ve(this, "_is_pre_created", !1), Ve(this, "_video_pre_subscribed", !1), Ve(this, "_audio_pre_subscribed", !1), Ve(this, "_trust_video_stream_added_state_", !0), Ve(this, "_trust_audio_stream_added_state_", !0), Ve(this, "_audioTrack", void 0), Ve(this, "_videoTrack", void 0), Ve(this, "_dataChannels", []), Ve(this, "_audioSSRC", void 0), Ve(this, "_videoSSRC", void 0), Ve(this, "_audioOrtc", void 0), Ve(this, "_videoOrtc", void 0), Ve(this, "_cname", void 0), Ve(this, "_rtxSsrcId", void 0), Ve(this, "_videoMid", void 0), Ve(this, "_audioMid", void 0), this.uid = n, this._uintid = i;
      }
    }
    function k6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function j6(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? k6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : k6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const WE = "9", U6 = 4e4;
    function H6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function md(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? H6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : H6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    var Np = function(e) {
      return e[e.DOWN = 0] = "DOWN", e[e.UP = 1] = "UP", e;
    }(Np || {});
    const GT = /* @__PURE__ */ new Map();
    function B6(e, n, i, o) {
      let { scale: f } = e;
      if (f === 0 && o === Np.UP || f >= n.length - 1 && o === Np.DOWN) return e;
      let T = md(md({}, e), {}, { scale: o === Np.DOWN ? ++f : --f });
      switch (i) {
        case "maintain-framerate":
          T = md(md({}, T), n[f].motion);
          break;
        case "maintain-resolution":
          T = md(md({}, T), n[f].detail);
          break;
        case "balanced":
          T = md(md({}, T), n[f].balanced);
      }
      return T;
    }
    function z6(e, n) {
      if (n) {
        const i = { overUse: 0, underUse: 0, adaptationList: F6(n) };
        GT.set(e, i);
      } else GT.delete(e);
    }
    function F6(e) {
      const n = md({}, e), { bitrateMax: i, frameRate: o, scaleResolutionDownBy: f, bitrateMin: T } = n, { MIN_FRAME_RATE: A, MAX_THRESHOLD_FRAMERATE: R, MAX_SCALE: P, BITRATE_MIN_THRESHOLD: L, BITRATE_MAX_THRESHOLD: z, BWE_SCALE_UP_THRESHOLD: Y, BWE_SCALE_DOWN_THRESHOLD: te, PERF_SCALE_DOWN_THRESHOLD: oe, PERF_SCALE_UP_THRESHOLD: He, BALANCE_BITRATE_FACTOR: Re, BALANCE_FRAMERATE_FACTOR: De, BALANCE_RESOLUTION_FACTOR: Xe, MOTION_RESOLUTION_FACTOR: We, MOTION_BITRATE_FACTOR: mt, DETAIL_FRAMERATE_FACTOR: Pt, DETAIL_BITRATE_FACTOR: xt } = WS, Nt = Math.min(n.frameRate, R), Vt = [{ scale: 0, threshold: { bwe_down: Math.round(Math.pow(te, 1) * i), bwe_up: i, fps_down: Math.round(Math.pow(oe, 1) * Nt), fps_up: o }, balanced: { scaleResolutionDownBy: 1, frameRate: o, bitrateMax: i, bitrateMin: T }, motion: { scaleResolutionDownBy: 1, frameRate: o, bitrateMax: i, bitrateMin: T }, detail: { scaleResolutionDownBy: 1, frameRate: o, bitrateMax: i, bitrateMin: T } }];
      for (let nn = 1; nn <= P; nn++) {
        const fn = { bwe_up: Math.round(Math.pow(Y, nn) * i), bwe_down: Math.round(Math.pow(te, nn + 1) * i), fps_up: Math.round(Math.pow(He, nn) * Nt), fps_down: Math.round(Math.pow(oe, nn + 1) * Nt) }, hn = { scaleResolutionDownBy: f / Math.pow(Xe, nn), frameRate: Math.max(Math.round(Math.pow(De, nn) * o), A), bitrateMax: Math.max(Math.round(Math.pow(Re, nn) * i), z), bitrateMin: Math.max(Math.round(Math.pow(Re, nn) * T), L) }, ir = { scaleResolutionDownBy: f / Math.pow(We, nn), frameRate: o, bitrateMax: Math.max(Math.round(Math.pow(mt, nn) * i), z), bitrateMin: Math.max(Math.round(Math.pow(mt, nn) * T), L) }, sr = { scaleResolutionDownBy: 1, frameRate: Math.max(Math.round(Math.pow(Pt, nn) * o), A), bitrateMax: Math.max(Math.round(Math.pow(xt, nn) * i), z), bitrateMin: Math.max(Math.round(Math.pow(xt, nn) * T), L) };
        Vt.push({ scale: nn, threshold: fn, balanced: hn, motion: ir, detail: sr });
      }
      return Vt;
    }
    function Cae(e, n, i, o, f, T) {
      const A = GT.get(e) || { overUse: 0, underUse: 0, adaptationList: F6(f) }, { adaptationList: R } = A;
      GT.set(e, A);
      const { OVERUSE_TIMES_THRESHOLD: P, UNDERUSE_TIMES_THRESHOLD: L } = WS, { scale: z } = o;
      let Y, te;
      return typeof n == "number" && n > 0 && function(oe, He, Re, De) {
        if (He >= Re.length) return !1;
        let { threshold: { fps_down: Xe } } = Re[He];
        return ft("FORCE_AG_HIGH_FRAMERATE") && De === "maintain-framerate" && (Xe = Re[0].threshold.fps_down), oe < Xe;
      }(n, z, R, T) && (A.overUse++, te = PE.CPU, A.overUse > P) || typeof i == "number" && i > 0 && function(oe, He, Re) {
        if (He >= Re.length) return !1;
        const { threshold: { bwe_down: De } } = Re[He];
        return oe < De;
      }(i, z, R) && (A.overUse++, te = PE.BANDWIDTH, A.overUse > P) ? (A.overUse = 0, A.underUse = 0, Y = B6(o, R, T, Np.DOWN), [Y, te]) : (typeof n == "number" && n > 0 && typeof i == "number" && i > 0 && function(oe, He, Re, De) {
        if (He === 0) return;
        let { threshold: { fps_up: Xe } } = Re[He];
        return ft("FORCE_AG_HIGH_FRAMERATE") && De === "maintain-framerate" && (Xe = Re[1].threshold.fps_up), oe > Xe;
      }(n, z, R, T) && function(oe, He, Re) {
        if (He === 0) return;
        const { threshold: { bwe_up: De } } = Re[He];
        return oe > De;
      }(i, z, R) && (A.underUse++, A.underUse > L && (A.overUse = 0, A.underUse = 0, Y = B6(o, R, T, Np.UP), Y.scale === 0 && (te = PE.NONE))), [Y, te]);
    }
    function G6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function MI(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? G6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : G6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    function Sae(e) {
      var n;
      return !!ft("ENABLE_AG_ADAPTATION") && !!(e instanceof uI || on(n = e._hints).call(n, Fr.CUSTOM_TRACK)) && (!!ft("FORCE_SUPPORT_AG_ADAPTATION") || !!(function(i) {
        const o = hr();
        if (o.os !== ts.IOS || !o.osVersion) return !1;
        const f = o.osVersion.split(".");
        return Number(f[0]) >= i;
      }(14) && YM(17, 4, !0) || VM(14) && XM(17, 4, !0)));
    }
    const VT = /* @__PURE__ */ new Map();
    function YT(e, n) {
      const i = VT.get(e);
      if (i) {
        const { timer: o } = i;
        window.clearTimeout(o), VT.delete(e);
      }
      n.qualityLimitationReason = PE.NONE, z6(e);
    }
    function Iae(e, n) {
      var i;
      let o;
      switch (n) {
        case Qt.LocalAudioTrack:
          o = Sr.Audio;
          break;
        case Qt.LocalVideoTrack:
          o = on(i = e._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
          break;
        case Qt.LocalVideoLowTrack:
          o = Sr.Low;
      }
      return o;
    }
    function LI(e) {
      const n = pr();
      if (e.some((i) => i._bypassWebAudio)) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");
      if (!n.webAudioMediaStreamDest) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks because your browser does not support audio mixing");
    }
    function kI(e, n) {
      LI(e);
      const i = new Xi();
      return e.forEach((o) => i.addAudioTrack(o)), i;
    }
    const Rae = !pr().supportUnifiedPlan || ft("CHROME_FORCE_PLAN_B") && ad();
    function XT(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var i;
      return Rae ? (i = { spec: n, store: e }, ol("PlanBConnection").create(i)) : new Ed(n, e);
    }
    function jI(e) {
      return e && (e.iceConnectionState === "disconnected" || e.iceConnectionState === "checking" || e.iceConnectionState === "failed");
    }
    function V6(e) {
      try {
        if (e.iceServers) return !1;
        if (e.turnServer && e.turnServer.mode !== "off") {
          if (NE(e.turnServer.servers)) return !1;
          if (ft("FORCE_TURN_TCP") || e.turnServer.servers.concat(e.turnServer.serversFromGateway || []).some((n) => n.forceturn)) return !0;
        }
        return !1;
      } catch {
        return !1;
      }
    }
    var cr;
    function Y6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function Bc(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? Y6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Y6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    let Ed = (cr = class ky extends G8 {
      get currentLocalDescription() {
        return this.peerConnection.currentLocalDescription;
      }
      get currentRemoteDescription() {
        return this.peerConnection.currentRemoteDescription;
      }
      get peerConnectionState() {
        return this.peerConnection.connectionState;
      }
      get iceConnectionState() {
        return this.peerConnection.iceConnectionState;
      }
      get dtlsTransportState() {
        var n, i;
        return (n = (i = this.peerConnection.getReceivers()[0]) === null || i === void 0 || (i = i.transport) === null || i === void 0 ? void 0 : i.state) !== null && n !== void 0 ? n : null;
      }
      get localCodecs() {
        return [...new Set(this.localCapabilities && this.localCapabilities.send.videoCodecs.map((n) => n.rtpMap && n.rtpMap.encodingName.toLowerCase() || "").filter((n) => {
          var i;
          return on(i = Object.keys(mT)).call(i, n);
        }))];
      }
      constructor(n, i) {
        super(n, i), Ve(this, "id", zr(5, "connection-")), Ve(this, "store", void 0), Ve(this, "peerConnection", void 0), Ve(this, "forceTurn", !1), Ve(this, "remoteSDP", void 0), Ve(this, "initialOffer", void 0), Ve(this, "transportEventReceiver", void 0), Ve(this, "statsFilter", void 0), Ve(this, "extension", { useXR: ft("USE_XR") }), Ve(this, "localCapabilities", void 0), Ve(this, "remoteCodecs", void 0), Ve(this, "localCandidateCount", 0), Ve(this, "allCandidatesReceived", !1), Ve(this, "isPreallocation", !1), Ve(this, "preSSRCMap", /* @__PURE__ */ new Map()), Ve(this, "dataStreamChannelMap", /* @__PURE__ */ new Map()), Ve(this, "establishPromise", void 0), Ve(this, "recoveredDataChannelIds", []), Ve(this, "currentDataChannelId", 1), Ve(this, "supportAV1RtpSpec", !1), Ve(this, "mutex", void 0), Ve(this, "qualityLimitationReason", PE.NONE), this.store = i, this.forceTurn = V6(n), this.mutex = new xs("P2PConnection-mutex", i.clientId), this.peerConnection = new RTCPeerConnection(ky.resolvePCConfiguration(n), { optional: [{ googDscp: !0 }] }), this.statsFilter = YS(this.peerConnection, ft("STATS_UPDATE_INTERVAL"), void 0, ui() ? 1200 : void 0), this.bindPCEvents(), this.bindStatsEvents(), this.store.p2pId = this.store.p2pId + 1, this.establishPromise = this.establish();
      }
      getPreMedia(n) {
        const i = this.preSSRCMap.get(n);
        if (i !== void 0) {
          const o = this.peerConnection.getTransceivers().find((f) => f.mid === i);
          if (o) return { transceiver: o, track: o.receiver.track, id: i };
        }
      }
      async updateRemoteRTPCapabilities(n, i) {
        if (this.remoteCodecs = i, !this.remoteSDP) return void Ee.debug("[P2PConnection] cannot updateRemoteRTPCapabilities before remote SDP created, local codecs: ".concat(this.localCodecs, ", codecs: ").concat(i));
        if (this.remoteSDP.updateRemoteCodec(n, i, this.store.codec)) {
          const o = await this.peerConnection.createOffer(), f = this.logSDPExchange(o.sdp || "", "offer", "local", "muteLocal");
          await this.peerConnection.setLocalDescription(o);
          const T = this.remoteSDP.toString();
          f == null || f(T), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: T });
        } else Ee.debug("[P2PConnection] updateRemoteRTPCapabilities no need to exchange SDP.");
      }
      async establish() {
        try {
          this.peerConnection.addTransceiver("video", { direction: "recvonly" }), this.peerConnection.addTransceiver("audio", { direction: "recvonly" });
          const o = await this.peerConnection.createOffer();
          if (!o.sdp) throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");
          const f = al(o.sdp), T = await u6({ filterRTX: !ft("USE_PUB_RTX") && !ft("USE_SUB_RTX"), filterVideoFec: ft("FILTER_VIDEO_FEC"), filterAudioFec: ft("FILTER_AUDIO_FEC"), filterVideoCodec: ft("FILTER_VIDEO_CODEC") }, this.extension);
          if (this.localCapabilities = UT(T), this.initialOffer = o, ft("ENABLE_SVC") && this.store.codec == "av1") {
            const R = await async function() {
              try {
                const P = new RTCPeerConnection();
                P.addTransceiver("video", { direction: "sendonly", sendEncodings: [{ scalabilityMode: gT.L1T3 }] });
                const L = await P.createOffer();
                if (!L.sdp) return void P.close();
                const z = Ca(L.sdp).mediaDescriptions[0];
                if (!z) return;
                const Y = z.attributes.extmaps.find((te) => te.extensionName === "https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension");
                return P.close(), Y;
              } catch {
                return;
              }
            }();
            var n;
            R && (this.supportAV1RtpSpec = !0, (n = T.send) === null || n === void 0 || n.videoExtensions.push(R));
          }
          let A;
          return o.sdp && h6(o.sdp) && (A = di(T), (i = A).send && (Op(vn.VIDEO, i.send.videoExtensions), Op(vn.AUDIO, i.send.audioExtensions)), i.recv && (Op(vn.VIDEO, i.recv.videoExtensions), Op(vn.AUDIO, i.recv.audioExtensions)), i.sendrecv && (Op(vn.VIDEO, i.sendrecv.videoExtensions), Op(vn.AUDIO, i.sendrecv.audioExtensions))), Bc(Bc({}, f), {}, { rtpCapabilities: A || T, offerSDP: o.sdp });
        } catch (o) {
          throw new Gt(Je.GET_LOCAL_CONNECTION_PARAMS_FAILED, o.toString());
        }
        var i;
      }
      async connect(n) {
        try {
          if (!this.initialOffer) throw new Error("Cannot establish P2PConnection without initial offer.");
          this.initialOffer.sdp && h6(this.initialOffer.sdp) && (i = n.rtpCapabilities, o = this.localCapabilities, i.send && (LT(vn.VIDEO, i.send.videoExtensions, o.send.videoExtensions), LT(vn.AUDIO, i.send.audioExtensions, o.send.audioExtensions)), i.recv && (LT(vn.VIDEO, i.recv.videoExtensions, o.recv.videoExtensions), LT(vn.AUDIO, i.recv.audioExtensions, o.recv.audioExtensions))), this.remoteSDP = new class {
            get localCapabilities() {
              return di(this._localCapabilities);
            }
            get rtpCapabilities() {
              return di(this._rtpCapabilities);
            }
            get candidates() {
              return di(this._candidates);
            }
            get iceParameters() {
              return di(this._iceParameters);
            }
            get dtlsParameters() {
              return di(this._dtlsParameters);
            }
            constructor(L) {
              let z = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
              Ve(this, "sessionDesc", void 0), Ve(this, "_localCapabilities", void 0), Ve(this, "_rtpCapabilities", void 0), Ve(this, "_candidates", void 0), Ve(this, "_originCandidates", void 0), Ve(this, "_iceParameters", void 0), Ve(this, "_isUseExtmapAllowMixed", void 0), Ve(this, "_dtlsParameters", void 0), Ve(this, "setup", void 0), Ve(this, "currentMidIndex", void 0), Ve(this, "cname", void 0), Ve(this, "firefoxSsrcMidMap", /* @__PURE__ */ new Map()), this._isUseExtmapAllowMixed = z, L = di(L);
              const { iceParameters: Y, dtlsParameters: te, candidates: oe, rtpCapabilities: He, setup: Re, localCapabilities: De, cname: Xe } = L;
              this._rtpCapabilities = He, this._candidates = oe, this._originCandidates = di(oe), this._iceParameters = Y, this._dtlsParameters = te, this._localCapabilities = De, this.setup = Re, this.cname = Xe, this.sessionDesc = this.updateRemoteRTPCapabilities(He), this.currentMidIndex = this.sessionDesc.mediaDescriptions.length - 1;
            }
            preloadRemoteMedia(L) {
              const z = this.candidates, Y = this.dtlsParameters, te = this.iceParameters, oe = this.rtpCapabilities.send;
              let He = this.sessionDesc.mediaDescriptions.length - 1;
              for (let Re = 1; Re < L; Re++) {
                const De = 2 * Re + 2e4, Xe = 2 * Re + U6, { ssrcs: We, ssrcGroups: mt } = Rf([{ ssrcId: De }], this.cname), { ssrcs: Pt, ssrcGroups: xt } = Rf([{ ssrcId: Xe, rtx: ft("USE_SUB_RTX") ? Xe + 1 : void 0 }], this.cname);
                this.sessionDesc.mediaDescriptions.push({ media: { mediaType: "video", port: WE, protos: ["UDP", "TLS", "RTP", "SAVPF"], fmts: oe.videoCodecs.map((Nt) => Nt.payloadType.toString(10)) }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: te.iceUfrag, icePwd: te.icePwd, unrecognized: [], candidates: z, extmaps: oe.videoExtensions, fingerprints: Y.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: Pt, ssrcGroups: xt, rtcpFeedbackWildcards: [], payloads: oe.videoCodecs, rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, direction: "sendonly", rtcpMux: !0, rtcpRsize: !0, mid: "".concat(++He) } }), this.sessionDesc.mediaDescriptions.push({ media: { mediaType: "audio", port: WE, protos: ["UDP", "TLS", "RTP", "SAVPF"], fmts: oe.audioCodecs.map((Nt) => Nt.payloadType.toString(10)) }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: te.iceUfrag, icePwd: te.icePwd, unrecognized: [], candidates: z, extmaps: oe.audioExtensions, fingerprints: Y.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: We, ssrcGroups: mt, rtcpFeedbackWildcards: [], payloads: oe.audioCodecs, rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, direction: "sendonly", rtcpMux: !0, rtcpRsize: !0, mid: "".concat(++He) } }), this.currentMidIndex += 2;
              }
              this.updateBundleMids();
            }
            toString() {
              return nl(this.sessionDesc);
            }
            send(L, z, Y, te) {
              const { ssrcs: oe, ssrcGroups: He } = Rf(z, this.cname, ft("SYNC_GROUP") ? Y : void 0), Re = this.findPreloadMediaDesc(oe);
              if (Re) {
                if (ui() && this.firefoxSsrcMidMap.set(oe[0].ssrcId, Re.attributes.mid), te && (te.twcc || te.remb)) {
                  const De = this.sessionDesc.mediaDescriptions.indexOf(Re);
                  return this.sessionDesc.mediaDescriptions[De] = this.mungSendMediaDesc(Re, te), { mid: Re.attributes.mid, needExchangeSDP: !0 };
                }
                return { mid: Re.attributes.mid, needExchangeSDP: !1 };
              }
              {
                const De = this.findAvailableMediaIndex(L, oe);
                let Xe;
                return De === -1 || De === 1 && (Os() || function() {
                  const We = hr();
                  return !(We.name !== Cr.CHROME || !We.osVersion) && Number(We.version) <= 90;
                }()) || De === 0 && ft("USE_SUB_RTX") || WM() ? (Xe = this.createOrRecycleSendMedia(L, oe, He, "sendonly", te), this.updateBundleMids()) : (Xe = di(this.sessionDesc.mediaDescriptions[De]), Xe.attributes.direction = "sendonly", Xe.attributes.ssrcs = oe, Xe.attributes.ssrcGroups = He, this.sessionDesc.mediaDescriptions[De] = this.mungSendMediaDesc(Xe, te)), ui() && this.firefoxSsrcMidMap.set(oe[0].ssrcId, Xe.attributes.mid), { mid: Xe.attributes.mid, needExchangeSDP: !0 };
              }
            }
            sendDataChannel() {
              const { mediaDesc: L, needExchangeSDP: z } = this.createOrRecycleDataChannel();
              return this.updateBundleMids(), { mid: L.attributes.mid, needExchangeSDP: z };
            }
            batchSend(L) {
              const z = L.map((oe) => {
                let { kind: He, ssrcMsg: Re, mslabel: De } = oe;
                return this.send(He, Re, De);
              }), Y = [];
              let te = !1;
              return z.forEach((oe) => {
                let { mid: He, needExchangeSDP: Re } = oe;
                Re && (te = !0), Y.push(He);
              }), { mids: Y, needExchangeSDP: te };
            }
            stopSending(L) {
              const z = this.sessionDesc.mediaDescriptions.filter((Y) => Y.attributes.mid && L.indexOf(Y.attributes.mid) !== -1);
              if (z.length !== L.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.stopSending.");
              z.forEach((Y) => {
                Y.attributes.mid === "0" || ui() || WM() ? Y.attributes.ssrcs = [] : (Y.attributes.ssrcs = [], Y.attributes.direction = "inactive", Y.media.port = "0");
              }), this.updateBundleMids();
            }
            mute(L) {
              const z = this.sessionDesc.mediaDescriptions.find((Y) => Y.attributes.mid === L);
              if (!z) throw new Error("mediaDescription not found with ".concat(L, " in remote SDP when calling RemoteSDP.mute."));
              z.attributes.direction = "inactive";
            }
            unmute(L) {
              const z = this.sessionDesc.mediaDescriptions.find((Y) => Y.attributes.mid === L);
              if (!z) throw new Error("mediaDescription not found with ".concat(L, " in remote SDP when calling RemoteSDP.unmute."));
              z.attributes.direction = "sendonly";
            }
            muteRemote(L) {
              const z = this.sessionDesc.mediaDescriptions.filter((Y) => on(L).call(L, Y.attributes.mid || ""));
              if (z.length !== L.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
              z.forEach((Y) => {
                Y.attributes.direction = "inactive";
              });
            }
            unmuteRemote(L) {
              const z = this.sessionDesc.mediaDescriptions.filter((Y) => on(L).call(L, Y.attributes.mid || ""));
              if (z.length !== L.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
              z.forEach((Y) => {
                Y.attributes.direction = "recvonly";
              });
            }
            receive(L, z, Y, te) {
              L.forEach((oe, He) => {
                this.createOrRecycleRecvMedia(oe, [], "recvonly", z, Y, te[He]);
              }), this.updateBundleMids();
            }
            stopReceiving(L) {
              const z = this.sessionDesc.mediaDescriptions.filter((Y) => L.indexOf(Y.attributes.mid) !== -1);
              if (z.length !== L.length) throw new Error("MediaDescriptions' length doesn't match mids's length when calling RemoteSDP.receive.");
              z.forEach((Y) => {
                Y.media.port = "0", Y.attributes.direction = "inactive";
              }), this.updateBundleMids();
            }
            updateRemoteRTPCapabilities(L) {
              const z = this.sessionDesc || Ca((Y = this._isUseExtmapAllowMixed, `v=0
o=- 0 0 IN IP4 127.0.0.1
s=AgoraGateway
t=0 0
a=group:BUNDLE 0 1
a=msid-semantic: WMS
a=ice-lite`.concat(Y ? `
a=extmap-allow-mixed` : "", `
m=video 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=sendonly
a=rtcp-mux
a=rtcp-rsize
a=mid:0
m=audio 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=sendonly
a=rtcp-mux
a=rtcp-rsize
a=mid:1
`)));
              var Y;
              this._rtpCapabilities = L;
              const te = this.rtpCapabilities.send, oe = this.localCapabilities.send;
              for (const He of z.mediaDescriptions) {
                if (He.attributes.iceUfrag = this._iceParameters.iceUfrag, He.attributes.icePwd = this._iceParameters.icePwd, He.attributes.fingerprints = this._dtlsParameters.fingerprints, He.attributes.candidates = this._candidates, He.attributes.setup = this.setup, He.media.mediaType === "application" && (He.attributes.sctpPort = "5000"), He.media.mediaType === "video") {
                  if (te.videoCodecs.length === 0) {
                    const Re = oe.videoCodecs.filter((De) => {
                      var Xe, We;
                      return (Xe = De.rtpMap) === null || Xe === void 0 ? void 0 : on(We = Xe.encodingName.toLowerCase()).call(We, "vp8");
                    }) || [oe.videoCodecs[0]];
                    He.media.fmts = Re.map((De) => De.payloadType.toString(10)), He.attributes.payloads = Re, He.attributes.extmaps = [];
                  } else if (He.media.fmts = te.videoCodecs.map((Re) => Re.payloadType.toString(10)), He.attributes.payloads = te.videoCodecs, He.attributes.extmaps = te.videoExtensions, ft("PRELOAD_MEDIA_COUNT") > 0) {
                    const { ssrcs: Re, ssrcGroups: De } = Rf([{ ssrcId: U6, rtx: ft("USE_SUB_RTX") ? 40001 : void 0 }], this.cname);
                    He.attributes.ssrcs = Re, He.attributes.ssrcGroups = De;
                  }
                }
                if (He.media.mediaType === "audio") {
                  if (te.audioCodecs.length === 0) {
                    const Re = oe.audioCodecs.filter((De) => {
                      var Xe, We;
                      return (Xe = De.rtpMap) === null || Xe === void 0 ? void 0 : on(We = Xe.encodingName.toLowerCase()).call(We, "opus");
                    }) || [oe.audioCodecs[0]];
                    He.media.fmts = Re.map((De) => De.payloadType.toString(10)), He.attributes.payloads = Re, He.attributes.extmaps = [];
                  } else if (He.media.fmts = te.audioCodecs.map((Re) => Re.payloadType.toString(10)), He.attributes.payloads = te.audioCodecs, He.attributes.extmaps = te.audioExtensions, Sp(He), ft("PRELOAD_MEDIA_COUNT") > 0) {
                    const { ssrcs: Re, ssrcGroups: De } = Rf([{ ssrcId: 2e4 }], this.cname);
                    He.attributes.ssrcs = Re, He.attributes.ssrcGroups = De;
                  }
                }
              }
              return this.sessionDesc = z, this.currentMidIndex = z.mediaDescriptions.length - 1, this.sessionDesc;
            }
            updateCandidates(L) {
              const z = this._originCandidates.filter((te) => te.transport === "udp"), Y = [];
              if (z.forEach((te) => {
                Y.push(j6(j6({}, te), {}, { foundation: "tcpcandidate", priority: Number(te.priority) - 1 + "", transport: "tcp", port: Number(te.port) + 90 + "" }));
              }), z.length !== 0) {
                switch (L) {
                  case Hs.TCP_RELAY:
                    this._candidates = Y;
                    break;
                  case Hs.UDP_TCP_RELAY:
                  case Hs.RELAY:
                    this._candidates = [...z, ...Y];
                    break;
                  default:
                    this._candidates = z;
                }
                for (const te of this.sessionDesc.mediaDescriptions) te.attributes.candidates = this.candidates;
              }
            }
            restartICE(L) {
              L = di(L), this._iceParameters = L, this.sessionDesc.mediaDescriptions.forEach((z) => {
                z.attributes.iceUfrag = L.iceUfrag, z.attributes.icePwd = L.icePwd;
              });
            }
            predictReceivingMids(L) {
              const z = [];
              for (let Y = 0; Y < L; Y++) z.push((this.currentMidIndex + Y + 1).toString(10));
              return z;
            }
            findAvailableMediaIndex(L, z) {
              return this.sessionDesc.mediaDescriptions.findIndex((Y) => {
                const te = Y.media.mediaType === L && Y.media.port !== "0" && (Y.attributes.direction === "sendonly" || Y.attributes.direction === "sendrecv") && Y.attributes.ssrcs.length === 0;
                if (ui()) {
                  if (te) {
                    const oe = this.firefoxSsrcMidMap.get(z[0].ssrcId);
                    return !(oe || Y.attributes.mid !== "0" && Y.attributes.mid !== "1") || !(!oe || oe !== Y.attributes.mid);
                  }
                  return !1;
                }
                return te;
              });
            }
            createOrRecycleDataChannel() {
              for (const Y of this.sessionDesc.mediaDescriptions) if (Y.media.mediaType === "application") return { mediaDesc: Y, needExchangeSDP: !1 };
              this.currentMidIndex += 1;
              const L = "".concat(this.currentMidIndex), z = { media: { mediaType: "application", port: WE, protos: ["UDP", "DTLS", "SCTP"], fmts: ["webrtc-datachannel"] }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: this.iceParameters.iceUfrag, icePwd: this.iceParameters.icePwd, unrecognized: [], candidates: this.candidates, extmaps: [], fingerprints: this.dtlsParameters.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: [], ssrcGroups: [], rtcpFeedbackWildcards: [], payloads: [], rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, mid: "".concat(L), sctpPort: "5000" } };
              return this.sessionDesc.mediaDescriptions.push(z), { mediaDesc: z, needExchangeSDP: !0 };
            }
            createOrRecycleRecvMedia(L, z, Y, te, oe, He) {
              const Re = L._mediaStreamTrack.kind, De = this.rtpCapabilities.recv, Xe = FE(Re, De, this.localCapabilities.send, Re === vn.VIDEO ? te : oe), We = Re === vn.VIDEO ? De.videoExtensions : De.audioExtensions;
              this.currentMidIndex += 1;
              const mt = "".concat(this.currentMidIndex);
              let Pt = { media: { mediaType: Re, port: WE, protos: ["UDP", "TLS", "RTP", "SAVPF"], fmts: Xe.map((Nt) => Nt.payloadType.toString(10)) }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: this.iceParameters.iceUfrag, icePwd: this.iceParameters.icePwd, unrecognized: [], candidates: this.candidates, extmaps: We, fingerprints: this.dtlsParameters.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: z, ssrcGroups: [], rtcpFeedbackWildcards: [], payloads: Xe, rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, direction: Y, rtcpMux: !0, rtcpRsize: !0, mid: "".concat(mt) } };
              Pt = this.mungRecvMediaDsec(Pt, L, He);
              const xt = this.findFirstClosedMedia(Re);
              if (xt) {
                const Nt = this.sessionDesc.mediaDescriptions.indexOf(xt);
                this.sessionDesc.mediaDescriptions[Nt] = Pt;
              } else this.sessionDesc.mediaDescriptions.push(Pt);
              return Pt;
            }
            updateRemoteCodec(L, z, Y) {
              const te = [...new Set(this._rtpCapabilities.recv.videoCodecs.map((Pt) => Pt.rtpMap && Pt.rtpMap.encodingName.toLowerCase() || "").filter((Pt) => {
                var xt;
                return on(xt = Object.keys(mT)).call(xt, Pt);
              }))], oe = new Set(z);
              if (te.every((Pt) => oe.has(Pt))) return Ee.debug("codecs has not changed, no need to updateRemoteCodec, codecs: ".concat(z)), !1;
              const He = this._rtpCapabilities.recv.videoCodecs.filter((Pt) => z.some((xt) => {
                var Nt;
                return on(Nt = Pt.rtpMap && Pt.rtpMap.encodingName.toLowerCase() || "").call(Nt, xt);
              }));
              if (He.length === 0) return Ee.debug("updateRemoteCodec failed, because cannot find matched codec, remoteCapabilities codecs: ".concat(te, " codecs: ").concat(z)), !1;
              const Re = [...new Set(He.map((Pt) => Pt.rtpMap && Pt.rtpMap.encodingName.toLowerCase() || ""))];
              let De;
              if (Ee.debug("updateRemoteCodec, from ".concat(te, " to ").concat(Re)), L.length === 0) De = this.sessionDesc.mediaDescriptions.filter((Pt) => Pt.media.mediaType === "video" && Pt.attributes.direction === "recvonly");
              else if (De = this.sessionDesc.mediaDescriptions.filter((Pt) => Pt.attributes.mid && on(L).call(L, Pt.attributes.mid) && Pt.attributes.direction === "recvonly"), De.length !== L.length) return Ee.debug("updateRemoteCodec failed, because cannot find mids, mids: ".concat(L, ", codecs: ").concat(z)), !1;
              if (ft("USE_PUB_RTX") || ft("USE_SUB_RTX")) {
                const Pt = CI(He, this.rtpCapabilities.recv.videoCodecs);
                He.push(...Pt);
              }
              this._rtpCapabilities.recv.videoCodecs = He;
              const Xe = this.localCapabilities.send, We = this.rtpCapabilities.recv, mt = FE(vn.VIDEO, We, Xe, Y);
              return De.forEach((Pt) => {
                const xt = mt.map((Nt) => Nt.payloadType.toString(10));
                Ee.debug("updateRemoteCodec mid: ".concat(Pt.attributes.mid, ", from"), Pt.attributes.payloads, "to", mt), Pt.attributes.payloads = mt, Pt.media.fmts = xt;
              }), !0;
            }
            createOrRecycleSendMedia(L, z, Y, te, oe) {
              const He = this.rtpCapabilities.send, Re = L === vn.VIDEO ? He.videoCodecs : He.audioCodecs, De = L === vn.VIDEO ? He.videoExtensions : He.audioExtensions;
              this.currentMidIndex += 1;
              const Xe = "".concat(this.currentMidIndex);
              let We = { media: { mediaType: L, port: WE, protos: ["UDP", "TLS", "RTP", "SAVPF"], fmts: Re.map((Pt) => Pt.payloadType.toString(10)) }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: this.iceParameters.iceUfrag, icePwd: this.iceParameters.icePwd, unrecognized: [], candidates: this.candidates, extmaps: De, fingerprints: this.dtlsParameters.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: z, ssrcGroups: Y, rtcpFeedbackWildcards: [], payloads: Re, rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, direction: te, rtcpMux: !0, rtcpRsize: !0, mid: "".concat(Xe) } };
              We = this.mungSendMediaDesc(We, oe);
              const mt = this.findFirstClosedMedia(L);
              if (mt) {
                const Pt = this.sessionDesc.mediaDescriptions.indexOf(mt);
                this.sessionDesc.mediaDescriptions[Pt] = We;
              } else this.sessionDesc.mediaDescriptions.push(We);
              return We;
            }
            updateBundleMids() {
              this.sessionDesc.attributes.groups[0].identificationTag = this.sessionDesc.mediaDescriptions.filter((L) => L.media.port !== "0").map((L) => L.attributes.mid);
            }
            mungRecvMediaDsec(L, z, Y) {
              const te = di(L);
              return AI(te), Cp(te, z), OI(te, z), o6(te), jT(te, Y, this.localCapabilities.send), te;
            }
            mungSendMediaDesc(L, z) {
              const Y = di(L);
              return jT(Y, z, this.localCapabilities.recv), Sp(Y), Y;
            }
            updateRecvMedia(L, z) {
              const Y = this.sessionDesc.mediaDescriptions.findIndex((te) => te.attributes.mid === L);
              if (Y !== -1) {
                const te = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[Y], z);
                this.sessionDesc.mediaDescriptions[Y] = te;
              }
            }
            bumpMid(L) {
              this.currentMidIndex += L;
            }
            findFirstClosedMedia(L) {
              return this.sessionDesc.mediaDescriptions.find((z) => ui() ? z.media.port === "0" && z.media.mediaType === L : z.media.port === "0");
            }
            findPreloadMediaDesc(L) {
              return this.sessionDesc.mediaDescriptions.find((z) => {
                var Y;
                return ((Y = z.attributes) === null || Y === void 0 || (Y = Y.ssrcs[0]) === null || Y === void 0 ? void 0 : Y.ssrcId) === L[0].ssrcId;
              });
            }
            getSSRC(L) {
              var z;
              return (z = this.sessionDesc.mediaDescriptions.find((Y) => Y.attributes.mid === L)) === null || z === void 0 ? void 0 : z.attributes.ssrcs;
            }
          }(Bc(Bc({}, n), {}, { localCapabilities: this.localCapabilities }), this.supportAV1RtpSpec), n.preallocation && (this.isPreallocation = !0), Array.isArray(this.remoteCodecs) && this.remoteCodecs.length > 0 && this.remoteSDP.updateRemoteCodec([], this.remoteCodecs, this.store.codec);
          const f = this.remoteSDP.toString(), T = l6(this.initialOffer.sdp, this.extension), A = this.logSDPExchange(T || "", "offer", "local", "connect");
          this.store.descriptionStart(), await this.peerConnection.setLocalDescription({ type: "offer", sdp: T }), A == null || A(f), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: f });
          const R = this.peerConnection.getTransceivers()[0];
          if (R != null && R.receiver && this.tryBindTransportEvents(R.receiver), ft("PRELOAD_MEDIA_COUNT") > 0) {
            this.remoteSDP.preloadRemoteMedia(ft("PRELOAD_MEDIA_COUNT"));
            const L = this.remoteSDP.toString();
            await this.peerConnection.setRemoteDescription({ type: "offer", sdp: L });
            const z = await this.peerConnection.createAnswer();
            await this.peerConnection.setLocalDescription(z);
          }
          const { preSSRCs: P } = n;
          if (Array.isArray(P) && P.length > 0) {
            const { mids: L } = this.remoteSDP.batchSend(P.map((z) => ({ kind: z.kind, ssrcMsg: [{ ssrcId: z.ssrcId, rtx: z.rtx }], mslabel: z.mslabel })));
            L.forEach((z, Y) => {
              this.preSSRCMap.set(P[Y].ssrcId, z);
            }), await HT(this.peerConnection, this.remoteSDP, this.extension), Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] pre-batchReceive exchange SDP."));
          }
        } catch (f) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.connect failed; ".concat(f.toString()));
        }
        var i, o;
      }
      async updateRemoteConnect(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.updateRemoteConnect before remote SDP created");
          const { rtpCapabilities: i } = n;
          this.remoteSDP.updateRemoteRTPCapabilities(i), Array.isArray(this.remoteCodecs) && this.remoteCodecs.length > 0 && this.remoteSDP.updateRemoteCodec([], this.remoteCodecs, this.store.codec);
          const { preSSRCs: o } = n;
          if (Array.isArray(o) && o.length > 0) {
            const { mids: f } = this.remoteSDP.batchSend(o.map((T) => Object.assign({}, { kind: T.kind, ssrcMsg: [{ ssrcId: T.ssrcId, rtx: T.rtx }], mslabel: T.mslabel })));
            f.forEach((T, A) => {
              this.preSSRCMap.set(o[A].ssrcId, T);
            });
          }
          await HT(this.peerConnection, this.remoteSDP, this.extension), Ee.debug("[P2PConnection] updateRemoteRTPCapabilities by exchanging SDP.");
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.updateRemoteConnect failed; ".concat(i.toString()));
        }
      }
      send(n, i, o) {
        var f = this;
        return Io(function* () {
          const T = yield dr(f.mutex.lock("From P2PConnection.send"));
          try {
            if (!f.remoteSDP) throw new Error("Cannot call P2PConnection.send before remote SDP created");
            const A = [], R = MT();
            n.forEach((De) => {
              const Xe = f.peerConnection.addTransceiver(De._mediaStreamTrack, Bc({ direction: "sendonly" }, De.trackMediaType === "video" && f.supportAV1RtpSpec && R ? { sendEncodings: [{ scalabilityMode: R }] } : {}));
              A.push(Xe), De._updateRtpTransceiver(Xe);
            }), ui() && ft("SIMULCAST") === !0 && (yield dr(f.applySimulcastForFirefox(A, n)));
            const P = yield dr(f.peerConnection.createOffer()), L = f.remoteSDP.predictReceivingMids(n.length), z = f.mungSendOfferSDP(P.sdp, n, L), Y = Ca(z), te = L.map((De) => {
              const Xe = Y.mediaDescriptions.find((We) => We.attributes.mid === De);
              if (!Xe) throw new Error("Cannot extract ssrc from mediaDescription.");
              return i6(Xe, ft("USE_PUB_RTX"));
            });
            let oe;
            try {
              oe = yield te;
            } catch (De) {
              oe = [], f.remoteSDP.receive(n, i, o, oe);
              const Xe = f.remoteSDP.toString();
              throw yield dr(f.peerConnection.setLocalDescription({ type: "offer", sdp: z })), yield dr(f.peerConnection.setRemoteDescription({ type: "answer", sdp: Xe })), yield dr(f.stopSending(L, !0)), De;
            }
            f.remoteSDP.receive(n, i, o, oe);
            const He = f.remoteSDP.toString(), Re = f.logSDPExchange(z, "offer", "local", "send");
            return yield dr(f.peerConnection.setLocalDescription({ type: "offer", sdp: z })), yield dr(f.applySimulcastEncodings(A, n)), yield dr(f.applySendEncodings(A, n)), Re == null || Re(He), yield dr(f.peerConnection.setRemoteDescription({ type: "answer", sdp: He })), A.map((De, Xe) => {
              const We = L[Xe];
              return { localSSRC: te[Xe], id: We, transceiver: De };
            });
          } catch (A) {
            throw A instanceof Gt ? A : new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.send failed; ".concat(A.toString()));
          } finally {
            T();
          }
        })();
      }
      async createDataChannels(n, i) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.createDataChannels before remote SDP created");
          let o = this.dataStreamChannelMap.get(n);
          if (o && o.readyState === "open") Ee.debug("[P2PConnection] Channels are already available and can be reused directly.");
          else {
            const T = this.currentDataChannelId < 1023 ? this.currentDataChannelId++ : this.recoveredDataChannelIds.shift();
            if (typeof T != "number") throw new Error("create DataChannel error, because cannot get dc id");
            o = this.peerConnection.createDataChannel("datastream-channel", { id: T, negotiated: !0, ordered: !1, maxRetransmits: ft("DATASTREAM_MAX_RETRANSMITS") }), o.binaryType = "arraybuffer", this.dataStreamChannelMap.set(n, o);
          }
          i.forEach((T) => {
            T._updateOriginDataChannel(o);
          });
          const { needExchangeSDP: f } = this.remoteSDP.sendDataChannel();
          if (f) {
            const T = this.remoteSDP.toString();
            await this.peerConnection.setRemoteDescription({ type: "offer", sdp: T });
            const A = await this.peerConnection.createAnswer();
            await this.peerConnection.setLocalDescription(A), Ee.debug("[P2PConnection] createDataChannels by exchanging SDP.");
          } else Ee.debug("[P2PConnection] createDataChannels no need to exchange SDP.");
          return;
        } catch (o) {
          throw o instanceof Gt ? o : new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.createDataChannels failed; ".concat(o.toString()));
        }
      }
      async stopDataChannels(n) {
        try {
          const i = this.dataStreamChannelMap.get(n);
          return i && (i.id && this.recoveredDataChannelIds.push(i.id), i.close()), void this.dataStreamChannelMap.delete(n);
        } catch (i) {
          throw i instanceof Gt ? i : new Gt(Je.DATACHANNEL_FAILED, "P2PConnection.stopDataChannels failed; ".concat(i.toString()));
        }
      }
      async stopSending(n, i) {
        const o = i ? void 0 : await this.mutex.lock("From P2PConnection.stopSending");
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopSending before remote SDP created");
          const f = this.peerConnection.getTransceivers().filter((P) => n.indexOf(P.mid) !== -1);
          if (f.length !== n.length) throw new Error("Transceivers' length doesn't match mids' length when trying to call P2PConnection.stopSending.");
          f.map((P) => {
            var L;
            YT(this.id + P.mid, this), P.direction = "inactive", (L = P.stop) === null || L === void 0 || L.call(P);
          });
          const T = await this.peerConnection.createOffer(), A = this.logSDPExchange(T.sdp || "", "offer", "local", "stopSending");
          await this.peerConnection.setLocalDescription(T), this.remoteSDP.stopReceiving(n);
          const R = this.remoteSDP.toString();
          A == null || A(R), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: R });
        } catch (f) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.stopSending failed; ".concat(f.toString()));
        } finally {
          o && o();
        }
      }
      async receive(n, i, o, f) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.receive ".concat(n, " before remoteSDP created."));
          const { mid: T, needExchangeSDP: A } = this.remoteSDP.send(n, i, o, f);
          A && (await HT(this.peerConnection, this.remoteSDP, this.extension), Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(n, " by exchanging SDP.")));
          const R = this.peerConnection.getTransceivers().find((P) => P.mid === T);
          if (!R) throw new Error("Cannot get transceiver after setLocalDescription.");
          return { track: R.receiver.track, id: T, transceiver: R };
        } catch (T) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(T.toString()));
        }
      }
      async batchReceive(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.batchReceive before remoteSDP created.");
          const { mids: i, needExchangeSDP: o } = this.remoteSDP.batchSend(n);
          return o && (await HT(this.peerConnection, this.remoteSDP, this.extension), Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] batchReceive by exchanging SDP."))), i.map((f) => {
            const T = this.peerConnection.getTransceivers().find((A) => A.mid === f);
            if (!T) throw new Error("Cannot get transceiver after setLocalDescription.");
            return { track: T.receiver.track, id: f, transceiver: T };
          });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(i.toString()));
        }
      }
      async stopReceiving(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");
          n.forEach((T) => {
            Array.from(this.preSSRCMap.entries()).some((A) => {
              let [R, P] = A;
              if (P === T) return this.preSSRCMap.delete(R), !0;
            });
          }), this.remoteSDP.stopSending(n);
          const i = this.remoteSDP.toString(), o = this.logSDPExchange(i, "offer", "remote", "stopReceiving");
          await this.peerConnection.setRemoteDescription({ type: "offer", sdp: i });
          const f = await this.peerConnection.createAnswer();
          o == null || o(f.sdp || ""), await this.peerConnection.setLocalDescription(f);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(i.toString()));
        }
      }
      async muteRemote(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.muteRemote mid=".concat(n, " before remote SDP created."));
          this.remoteSDP.mute(n);
          const i = this.remoteSDP.toString(), o = this.logSDPExchange(i, "offer", "remote", "muteRemote");
          await this.peerConnection.setRemoteDescription({ type: "offer", sdp: i });
          const f = await this.peerConnection.createAnswer();
          o == null || o(f.sdp || ""), await this.peerConnection.setLocalDescription(f);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.muteRemote failed; ".concat(i.toString()));
        }
      }
      async unmuteRemote(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.unmuteRemote mid=".concat(n, " before remote SDP created."));
          this.remoteSDP.unmute(n);
          const i = this.remoteSDP.toString(), o = this.logSDPExchange(i, "offer", "remote", "unmuteRemote");
          await this.peerConnection.setRemoteDescription({ type: "offer", sdp: i });
          const f = await this.peerConnection.createAnswer();
          o == null || o(f.sdp || ""), await this.peerConnection.setLocalDescription(f);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteRemote failed; ".concat(i.toString()));
        }
      }
      async muteLocal(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.muteLocal before remote SDP created.");
          const i = this.peerConnection.getTransceivers().filter((A) => A.mid && n.indexOf(A.mid) !== -1);
          if (i.length !== n.length) throw new Error("Transceivers' length doesn't match mids' length.");
          i.map((A) => {
            A.direction = "inactive";
          });
          const o = await this.peerConnection.createOffer(), f = this.logSDPExchange(o.sdp || "", "offer", "local", "muteLocal");
          await this.peerConnection.setLocalDescription(o), this.remoteSDP.muteRemote(n);
          const T = this.remoteSDP.toString();
          f == null || f(T), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: T });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.muteLocal failed; ".concat(i.toString()));
        }
      }
      async unmuteLocal(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.unmuteLocal before remote SDP created.");
          const i = this.peerConnection.getTransceivers().filter((A) => A.mid && n.indexOf(A.mid) !== -1);
          if (i.length !== n.length) throw new Error("Transceivers' length doesn't match mids' length.");
          i.map(async (A, R) => {
            A.direction = "sendonly";
          });
          const o = await this.peerConnection.createOffer(), f = this.logSDPExchange(o.sdp || "", "offer", "local", "unmuteLocal");
          await this.peerConnection.setLocalDescription(o), this.remoteSDP.unmuteRemote(n), Array.isArray(this.remoteCodecs) && this.remoteCodecs.length > 0 && this.remoteSDP.updateRemoteCodec(n, this.remoteCodecs, this.store.codec);
          const T = this.remoteSDP.toString();
          f == null || f(T), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: T });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteLocal failed; ".concat(i.toString()));
        }
      }
      restartICE(n) {
        var i = this;
        return Io(function* () {
          const o = yield dr(i.mutex.lock("From P2PConnection.restartICE"));
          try {
            if (!i.remoteSDP) throw new Error("Cannot restartICE before remoteSDP created.");
            const f = pr().supportPCSetConfiguration, T = ft("FORCE_TURN_TCP") || i.forceTurn;
            if (n === Hs.RELAY && !f) return;
            if (f && !T) {
              const Y = n === Hs.RELAY ? "relay" : "all", te = i.peerConnection.getConfiguration();
              te.iceTransportPolicy !== Y && (Ee.debug("[".concat(i.store.clientId, "] restartICE change iceTransportPolicy from [").concat(te.iceTransportPolicy, "] to [").concat(Y, "]")), te.iceTransportPolicy = Y, i.peerConnection.setConfiguration(te));
            }
            i.remoteSDP.updateCandidates(n);
            const A = yield dr(i.peerConnection.createOffer({ iceRestart: !0 }));
            if (!A.sdp) throw new Error("Cannot restartICE because restart offer SDP does not exist.");
            const R = al(A.sdp), { remoteIceParameters: P } = yield R.iceParameters;
            i.remoteSDP.restartICE(P);
            const L = i.remoteSDP.toString(), z = i.logSDPExchange(A.sdp || "", "offer", "local", "restartICE");
            i.store.descriptionStart(), yield dr(i.peerConnection.setLocalDescription(A)), z == null || z(L), yield dr(i.peerConnection.setRemoteDescription({ type: "answer", sdp: L }));
          } catch (f) {
            Ee.warning("[".concat(i.store.clientId, "] restart ICE failed, abort operation"), f);
          } finally {
            o();
          }
        })();
      }
      close() {
        var n;
        this.peerConnection.getTransceivers().forEach((i) => {
          YT(this.id + i.mid, this);
        }), this.preSSRCMap.clear(), this.peerConnection.close(), (n = this.onConnectionStateChange) === null || n === void 0 || n.call(this, "closed"), this.tryUnbindTransportEvents(), this.unbindPCEvents(), this.unbindStatsEvents(), this.removeAllListeners(), this.transportEventReceiver = void 0, this.statsFilter.destroy(), this.dataStreamChannelMap.clear(), this.recoveredDataChannelIds = [], this.currentDataChannelId = 1;
      }
      getStats() {
        return Bc(Bc({}, this.statsFilter.getStats()), {}, { qualityLimitationReason: this.qualityLimitationReason });
      }
      getRemoteVideoIsReady(n) {
        return this.statsFilter.getVideoIsReady(n);
      }
      async updateEncoderConfig(n, i) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.updateEncoderConfig before remote SDP created.");
          const o = await this.peerConnection.createOffer(), f = this.mungSendOfferSDP(o.sdp, [i], [n]);
          this.remoteSDP.updateRecvMedia(n, i);
          const T = this.remoteSDP.toString(), A = this.logSDPExchange(f, "offer", "local", "updateEncoderConfig");
          await this.peerConnection.setLocalDescription({ type: "offer", sdp: f }), A == null || A(T), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: T });
        } catch (o) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, o.toString());
        }
      }
      async updateSendParameters(n, i) {
        const o = this.peerConnection.getTransceivers().filter((f) => f.mid === n);
        o.length === 1 && (this.isVP8Simulcast(i) ? ui() || await this.applySimulcastEncodings(o, [i]) : await this.applySendEncodings(o, [i]));
      }
      setStatsRemoteVideoIsReady(n, i) {
        this.statsFilter.setVideoIsReady2(n, i);
      }
      async replaceTrack(n, i) {
        const o = this.peerConnection.getTransceivers().find((f) => f.mid === i);
        o && await o.sender.replaceTrack(n._mediaStreamTrack);
      }
      async getSelectedCandidatePair() {
        const n = this.peerConnection.getReceivers();
        if (n.length > 0 && n[0].transport && n[0].transport.iceTransport && n[0].transport.iceTransport.getSelectedCandidatePair && n[0].transport.iceTransport.getSelectedCandidatePair()) {
          const i = n[0].transport.iceTransport, { local: o, remote: f } = i.getSelectedCandidatePair();
          return { local: Bc(Bc({}, Eu), {}, { candidateType: o.type, protocol: o.protocol, address: o.address, port: o.port }), remote: Bc(Bc({}, Eu), {}, { candidateType: f.type, protocol: f.protocol, address: f.address, port: f.port }) };
        }
        return this.statsFilter.getSelectedCandidatePair();
      }
      bindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = () => {
          var n;
          (n = this.onICEConnectionStateChange) === null || n === void 0 || n.call(this, this.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = () => {
          var n;
          (n = this.onConnectionStateChange) === null || n === void 0 || n.call(this, this.peerConnection.connectionState);
        }, this.peerConnection.onicecandidateerror = (n) => {
          if (n && (n.errorCode || n.errorText)) {
            var i;
            const o = "code: ".concat(n.errorCode, ", message: ").concat(n.errorText), f = n.port ? "local: ".concat(n.port) : "";
            Ee.debug("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onICECandidateError(").concat(o, "), url: ").concat(n.url || "", ", host_candidate:").concat(f)), (i = this.onICECandidateError) === null || i === void 0 || i.call(this, o);
          }
        }, this.peerConnection.onicegatheringstatechange = (n) => {
          n && n.target && "iceGatheringState" in n.target && Ee.debug("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] RTCPeerConnection.onicegatheringstatechange(").concat(n.target.iceGatheringState, ")"));
        }, this.peerConnection.onicecandidate = (n) => {
          n.candidate ? this.localCandidateCount += 1 : (this.peerConnection.onicecandidate = null, this.allCandidatesReceived = !0, Ee.debug("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] local candidate count"), this.localCandidateCount));
        }, setTimeout(() => {
          this.allCandidatesReceived || (this.allCandidatesReceived = !0, Ee.debug("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] onicecandidate timeout, local candidate count"), this.localCandidateCount));
        }, ft("CANDIDATE_TIMEOUT"));
      }
      unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
      static resolvePCConfiguration(n) {
        const i = { iceServers: [] };
        return n.iceServers ? i.iceServers = n.iceServers : n.turnServer && n.turnServer.mode !== "off" && (NE(n.turnServer.servers) ? i.iceServers = n.turnServer.servers : (i.iceServers && i.iceServers.push(...ky.turnServerConfigToIceServers(n.turnServer.servers)), ft("USE_TURN_SERVER_OF_GATEWAY") && i.iceServers && n.turnServer.serversFromGateway && i.iceServers.push(...ky.turnServerConfigToIceServers(n.turnServer.serversFromGateway)), ft("FORCE_TURN_TCP") ? i.iceTransportPolicy = "relay" : n.turnServer.servers.concat(n.turnServer.serversFromGateway || []).forEach((o) => {
          o.forceturn && (i.iceTransportPolicy = "relay");
        }))), ft("ENABLE_ENCODED_TRANSFORM") && pr().supportWebRTCEncodedTransform && (i.encodedInsertableStreams = !0), i;
      }
      static turnServerConfigToIceServers(n) {
        const i = [];
        return n.forEach((o) => {
          o.security ? o.tcpport && i.push({ username: o.username, credential: o.password, credentialType: "password", urls: "turns:".concat(Ap(o.turnServerURL), ":").concat(o.tcpport, "?transport=tcp") }) : (o.udpport && !ft("FORCE_TURN_TCP") && i.push({ username: o.username, credential: o.password, credentialType: "password", urls: "turn:".concat(o.turnServerURL, ":").concat(o.udpport, "?transport=udp") }), o.tcpport && i.push({ username: o.username, credential: o.password, credentialType: "password", urls: "turn:".concat(o.turnServerURL, ":").concat(o.tcpport, "?transport=tcp") }));
        }), i;
      }
      tryBindTransportEvents(n) {
        const i = n.transport;
        if (i) {
          this.transportEventReceiver = n, i.onstatechange = () => {
            var f;
            i != null && i.state && ((f = this.onDTLSTransportStateChange) === null || f === void 0 || f.call(this, i.state));
          }, i.onerror = (f) => {
            var T;
            (T = this.onDTLSTransportError) === null || T === void 0 || T.call(this, "error" in f ? f.error : f);
          };
          const o = i.iceTransport;
          o && (o.onstatechange = () => {
            const f = i == null ? void 0 : i.iceTransport.state;
            var T;
            f && ((T = this.onICETransportStateChange) === null || T === void 0 || T.call(this, f));
          }, o.getSelectedCandidatePair && (o.onselectedcandidatepairchange = () => {
            if (o.getSelectedCandidatePair()) {
              const { local: f, remote: T } = o.getSelectedCandidatePair();
              Ee.info("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] selectedcandidatepairchange: local ").concat(JSON.stringify({ candidateType: f.type, protocol: f.protocol }), ", remote ").concat(JSON.stringify({ candidateType: T.type, protocol: T.protocol, address: T.address, port: T.port }), " )"));
            }
          }));
        }
      }
      tryUnbindTransportEvents() {
        this.transportEventReceiver && this.transportEventReceiver.transport && (this.transportEventReceiver.transport.onstatechange = null, this.transportEventReceiver.transport.onerror = null, this.transportEventReceiver.transport.iceTransport && (this.transportEventReceiver.transport.iceTransport.onstatechange = null));
      }
      async updateRtpSenderEncodings(n, i) {
        var o, f;
        if (i || (i = this.peerConnection.getSenders().find((De) => De.track === n._mediaStreamTrack)), !i) return Ee.warn("[".concat(n.getTrackId(), "] no rtpSender found}"));
        if (this.isVP8Simulcast(n)) return Ee.warn("[updateRtpSenderEncodings] Track is VP8 simulcast, please apply simulcast encodings");
        if (!pr().supportSetRtpSenderParameters) return Ee.warn("[updateRtpSenderEncodings] Browser not support set rtp-sender parameters");
        const T = {}, A = {};
        switch (n._optimizationMode) {
          case "motion":
            T.degradationPreference = "maintain-framerate";
            break;
          case "detail":
            T.degradationPreference = "maintain-resolution";
            break;
          case "balanced":
            T.degradationPreference = "balanced";
        }
        const R = function(Re, De) {
          return Re.getTransceivers().find((Xe) => Xe.sender.track === De || Xe.receiver.track === De);
        }(this.peerConnection, n._mediaStreamTrack), P = Ese(n);
        if (Sae(n) && R && i && P && this.getLocalVideoStats && on(o = ["vp8", "vp9"]).call(o, this.store.codec)) {
          var L;
          const Re = T.degradationPreference || (on(L = n._hints).call(L, Fr.CUSTOM_TRACK) ? ft("CUSTOM_ADAPTATION_DEFAULT_MODE") : "maintain-framerate");
          (function(De, Xe, We, mt, Pt, xt) {
            if (YT(De, We), Pt(Xe), mt !== "balanced" && mt !== "maintain-framerate" && mt !== "maintain-resolution") return;
            let Nt = -1;
            z6(De, Xe);
            const Vt = window.setInterval(() => {
              const fn = VT.get(De);
              if (!ft("ENABLE_AG_ADAPTATION") || !fn) return YT(De, We), void Pt(Xe);
              const hn = xt();
              if (hn.sendPackets > 0 && hn.OutgoingAvailableBandwidth > 0) {
                if (Nt === -1) return void (Nt = Date.now());
                if (Date.now() - Nt < 1e3) return;
                const ir = hn.sendFrameRate, sr = hn.OutgoingAvailableBandwidth, [Gr, Ai] = Cae(De, ir, sr, fn.adaptationConfig, Xe, mt);
                Ai && (We.qualityLimitationReason = Ai), Gr && fn.adaptationConfig.scale !== Gr.scale && (Ee.debug("[".concat(De, "] applyAdaptation: ").concat(We.qualityLimitationReason, `
           sendFps `).concat(ir, ", bwe ").concat(sr, ", switch from ").concat(fn.adaptationConfig.scale, " to ").concat(Gr.scale, " ")), fn.adaptationConfig = MI(MI({}, fn.adaptationConfig), Gr), Pt(Gr));
              }
            }, ft("CHECK_LOCAL_STATS_INTERVAL")), nn = MI({}, Xe);
            VT.set(De, { timer: Vt, adaptationConfig: nn, originConfig: Xe, adaptationFunc: Pt }), Ee.debug("[".concat(De, "] start adaptation, originConfig: ").concat(JSON.stringify(Xe), ", degradationPreference: ").concat(mt));
          })(this.id + R.mid, P, this, Re, (De) => {
            i && this.updateAdaptation(i, De);
          }, this.getLocalVideoStats.bind(this));
        }
        if (n._encoderConfig) {
          var z;
          const { bitrateMax: Re, frameRate: De, scaleResolutionDownBy: Xe } = n._encoderConfig;
          Re && (A.maxBitrate = 1e3 * Re), (on(z = n._hints).call(z, Fr.LOW_STREAM) || n.isUseScaleResolutionDownBy) && (De && (A.maxFramerate = Ga(De)), Xe && Xe >= 1 && (A.scaleResolutionDownBy = Xe));
        }
        const { maxFramerate: Y } = ft("ENCODER_CONFIG_LIMIT");
        if (Y && typeof Y == "number" && (A.maxFramerate = A.maxFramerate ? Math.min(A.maxFramerate, Y) : Y), ft("DSCP_TYPE") && ad()) {
          var te;
          const Re = ft("DSCP_TYPE");
          on(te = ["very-low", "low", "medium", "high"]).call(te, Re) && (A.networkPriority = Re);
        }
        const oe = i.getParameters(), He = (f = oe.encodings) === null || f === void 0 ? void 0 : f[0];
        ui() && !He && (T.encodings = [A]), He && Object.assign(He, A), Object.assign(oe, T), Ee.debug("[".concat(n.getTrackId(), "] updateRtpSenderEncodings: ").concat(JSON.stringify(oe.encodings))), await i.setParameters(oe), await async function(Re, De, Xe) {
          try {
            var We;
            if (!pr().supportSetRtpSenderParameters || !/* @__PURE__ */ function(Vt) {
              return Vt === "vp9" || Vt === "av1";
            }(Re) || !ft("ENABLE_SVC")) return;
            const mt = {}, Pt = {}, xt = De.getParameters(), Nt = (We = xt.encodings) === null || We === void 0 ? void 0 : We[0];
            Pt.scalabilityMode = MT(Xe), Nt && Object.assign(Nt, Pt), Object.assign(xt, mt), await De.setParameters(xt), Ee.debug("[updateAdaptation] updateRtpSenderEncodings scalabilityMode success: ".concat(JSON.stringify(xt.encodings)));
          } catch (mt) {
            Ee.debug("[updateAdaptation] updateRtpSenderEncodings scalabilityMode failed", mt);
          }
        }(this.store.codec, i, ft("SVC_MODE"));
      }
      async updateAdaptation(n, i) {
        var o, f;
        if (!n) return Ee.debug("[updateAdaptation] no rtpSender found");
        if (!pr().supportSetRtpSenderParameters) return Ee.debug("[updateAdaptation] Browser not support set rtp-sender parameters");
        const T = {}, { bitrateMax: A, frameRate: R, scaleResolutionDownBy: P } = i;
        A && (T.maxBitrate = 1e3 * A), R && (T.maxFramerate = Ga(R)), P && P >= 1 && on(o = ["vp8", "vp9"]).call(o, this.store.codec) && (T.scaleResolutionDownBy = P);
        const L = n.getParameters(), z = (f = L.encodings) === null || f === void 0 ? void 0 : f[0];
        z && Object.assign(z, T), Object.assign(L, {});
        try {
          await n.setParameters(L), Ee.debug("[updateAdaptation] updateRtpSenderEncodings: ".concat(JSON.stringify(L.encodings)));
        } catch (Y) {
          !("transport" in n) || n.transport && n.transport.state === "connected" ? this.peerConnectionState !== "connected" ? Ee.debug("[updateAdaptation] peerConnection not connected}") : Ee.debug("[updateAdaptation] updateRtpSenderEncodings failed", Y) : Ee.debug("[updateAdaptation] rtpSender transport not connected}");
        }
      }
      async applySendEncodings(n, i) {
        try {
          if (!pr().supportSetRtpSenderParameters || n.length !== i.length) return;
          for (let o = 0; o < n.length; o++) {
            const f = n[o], T = i[o];
            T instanceof Wr && !this.isVP8Simulcast(T) && await this.updateRtpSenderEncodings(T, f.sender);
          }
        } catch {
          Ee.debug("[".concat(this.store.clientId, "] Apply RTPSendEncodings failed."));
        }
      }
      mungSendOfferSDP(n, i, o) {
        const f = Ca(n);
        return i.forEach((T, A) => {
          const R = o[A], P = f.mediaDescriptions.find((L) => L.attributes.mid === R);
          P && (Cp(P, T), c6(P, T, this.store.codec));
        }), nl(f);
      }
      bindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = (n) => {
          var i;
          (i = this.onFirstAudioReceived) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstVideoReceived = (n) => {
          var i;
          (i = this.onFirstVideoReceived) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstAudioDecoded = (n) => {
          var i;
          (i = this.onFirstAudioDecoded) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstVideoDecoded = (n, i, o) => {
          var f;
          (f = this.onFirstVideoDecoded) === null || f === void 0 || f.call(this, n, i, o);
        }, this.statsFilter.onSelectedLocalCandidateChanged = (n, i) => {
          var o;
          (o = this.onSelectedLocalCandidateChanged) === null || o === void 0 || o.call(this, n, i);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = (n, i) => {
          var o;
          (o = this.onSelectedRemoteCandidateChanged) === null || o === void 0 || o.call(this, n, i);
        }, this.statsFilter.onFirstVideoDecodedTimeout = (n) => {
          var i;
          (i = this.onFirstVideoDecodedTimeout) === null || i === void 0 || i.call(this, n);
        };
      }
      unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0, this.statsFilter.onFirstVideoDecodedTimeout = void 0;
      }
      async applySimulcastForFirefox(n, i) {
        if (n.length === i.length) for (let P = 0; P < n.length; P++) {
          var o, f, T, A, R;
          const L = n[P], z = i[P];
          if (z instanceof Wr && !on(o = z._hints).call(o, Fr.LOW_STREAM) && (f = z._encoderConfig) !== null && f !== void 0 && f.bitrateMax && ((T = z._encoderConfig) === null || T === void 0 ? void 0 : T.bitrateMax) > 200 && (A = z._scalabilityMode) !== null && A !== void 0 && A.numSpatialLayers && ((R = z._scalabilityMode) === null || R === void 0 ? void 0 : R.numSpatialLayers) > 1 && this.store.codec === "vp8") {
            const Y = {}, te = { high: 1e3 * (z._encoderConfig.bitrateMax - 50), medium: 5e4 };
            Y.encodings = [{ rid: "m", active: !0, maxBitrate: te.medium, scaleResolutionDownBy: 4 }, { rid: "h", active: !0, maxBitrate: te.high }];
            const oe = L.sender.getParameters();
            await L.sender.setParameters(Object.assign(oe, Y));
          }
        }
      }
      async applySimulcastEncodings(n, i) {
        if (!ui() && n.length === i.length) for (let o = 0; o < n.length; o++) {
          const f = i[o];
          if (f instanceof Wr && this.isVP8Simulcast(f)) {
            const T = n[o], A = {}, R = { high: 1e3 * (f._encoderConfig.bitrateMax - 50), medium: 5e4 };
            A.encodings = [{ active: !0, adaptivePtime: !1, networkPriority: "high", priority: "high", maxBitrate: R.high }, { active: !0, adaptivePtime: !1, networkPriority: "low", priority: "low", maxBitrate: R.medium, scaleResolutionDownBy: 4 }];
            const P = T.sender.getParameters();
            await T.sender.setParameters(Object.assign(P, A));
          }
        }
      }
      isVP8Simulcast(n) {
        var i, o, f, T, A;
        return !!(n instanceof Wr && ft("SIMULCAST") && this.store.codec === "vp8" && !on(i = n._hints).call(i, Fr.LOW_STREAM) && (o = n._encoderConfig) !== null && o !== void 0 && o.bitrateMax && ((f = n._encoderConfig) === null || f === void 0 ? void 0 : f.bitrateMax) > 200 && (T = n._scalabilityMode) !== null && T !== void 0 && T.numSpatialLayers && ((A = n._scalabilityMode) === null || A === void 0 ? void 0 : A.numSpatialLayers) > 1);
      }
      logSDPExchange(n, i, o, f) {
        if (ft("SDP_LOGGING")) return Ee.upload("[".concat(this.store.clientId, "] exchanging ").concat(o, " ").concat(i, " SDP during P2PConnection.").concat(f, `
`), n), i === "offer" ? (T) => {
          this.logSDPExchange(T, "answer", o === "local" ? "remote" : "local", f);
        } : void 0;
      }
      async getRemoteSSRC(n) {
        if (!this.remoteSDP) return;
        const i = this.remoteSDP.getSSRC(n);
        return i && i.length !== 0 ? i[0].ssrcId : void 0;
      }
      setConfiguration(n) {
        if (pr().supportPCSetConfiguration) {
          const i = ky.resolvePCConfiguration(n);
          this.peerConnection.setConfiguration(i);
        }
      }
    }, bn(cr.prototype, "updateRemoteRTPCapabilities", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "updateRemoteRTPCapabilities"), cr.prototype), bn(cr.prototype, "connect", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "connect"), cr.prototype), bn(cr.prototype, "updateRemoteConnect", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "updateRemoteConnect"), cr.prototype), bn(cr.prototype, "createDataChannels", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "createDataChannels"), cr.prototype), bn(cr.prototype, "receive", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "receive"), cr.prototype), bn(cr.prototype, "batchReceive", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "batchReceive"), cr.prototype), bn(cr.prototype, "stopReceiving", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "stopReceiving"), cr.prototype), bn(cr.prototype, "muteRemote", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "muteRemote"), cr.prototype), bn(cr.prototype, "unmuteRemote", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "unmuteRemote"), cr.prototype), bn(cr.prototype, "muteLocal", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "muteLocal"), cr.prototype), bn(cr.prototype, "unmuteLocal", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "unmuteLocal"), cr.prototype), bn(cr.prototype, "close", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "close"), cr.prototype), bn(cr.prototype, "updateEncoderConfig", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "updateEncoderConfig"), cr.prototype), bn(cr.prototype, "updateSendParameters", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "updateSendParameters"), cr.prototype), bn(cr.prototype, "replaceTrack", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "replaceTrack"), cr.prototype), bn(cr.prototype, "updateAdaptation", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "updateAdaptation"), cr.prototype), bn(cr.prototype, "getRemoteSSRC", [pa], Object.getOwnPropertyDescriptor(cr.prototype, "getRemoteSSRC"), cr.prototype), cr);
    function pa(e, n, i) {
      const o = e[n];
      if (typeof o != "function") throw new Error("Cannot use mutex on object property.");
      return i.value = async function() {
        const f = this.mutex, T = await f.lock("From P2PConnection.".concat(n));
        try {
          for (var A = arguments.length, R = new Array(A), P = 0; P < A; P++) R[P] = arguments[P];
          return await o.apply(this, R);
        } finally {
          T();
        }
      }, i;
    }
    function UI(e, n) {
      let i = document.createElement("video"), o = document.createElement("canvas");
      i.setAttribute("style", "display:none"), o.setAttribute("style", "display:none"), i.setAttribute("muted", ""), i.muted = !0, i.setAttribute("autoplay", ""), i.autoplay = !0, i.setAttribute("playsinline", ""), o.width = Ga(n.width), o.height = Ga(n.height);
      const f = Ga(n.framerate || 15);
      document.body.append(i), document.body.append(o);
      let T = e._mediaStreamTrack;
      i.srcObject = new MediaStream([T]), i.play();
      const A = o.getContext("2d");
      if (!A) throw new jt(Je.UNEXPECTED_ERROR, "can not get canvas context");
      const R = pr(), P = o.captureStream(R.supportRequestFrame ? 0 : f).getVideoTracks()[0];
      P.canvas || (P.canvas = o), o.startCapture = () => {
        if (!i) return o.stopCapture && o.stopCapture();
        if (i.paused && i.play(), i.videoHeight > 2 && i.videoWidth > 2) {
          const z = i.videoWidth, Y = i.videoHeight / z, te = o.width * Y;
          Math.abs(te - o.height) >= 2 && (Ee.debug("adjust low stream resolution", "".concat(o.width, "x").concat(o.height, " -> ").concat(o.width, "x").concat(te)), o.height = te);
        }
        A.drawImage(i, 0, 0, o.width, o.height), P.requestFrame && P.requestFrame(), T !== e._mediaStreamTrack && (T = e._mediaStreamTrack, i.srcObject = new MediaStream([T]));
      }, o.stopCapture = rI(() => o.startCapture && o.startCapture(), f);
      const L = P.stop;
      return P.stop = () => {
        L.call(P), i && (i.remove(), i.srcObject = null, i = null), o && (o.width = 0, o.remove(), o.stopCapture && o.stopCapture(), o.startCapture = void 0, o.stopCapture = void 0, o = null), Ee.debug("clean low stream renderer");
      }, P;
    }
    var WT = function(e) {
      return e[e.HEIGHT = 2033] = "HEIGHT", e[e.FRAME_RATE = 2034] = "FRAME_RATE", e[e.WIDTH = 2035] = "WIDTH", e;
    }(WT || {}), ki = function(e) {
      return e[e.FRAME_RATE = 2002] = "FRAME_RATE", e[e.WIDTH = 2003] = "WIDTH", e[e.HEIGHT = 2004] = "HEIGHT", e[e.PACKAGE_LOST = 2005] = "PACKAGE_LOST", e[e.AVG_ENCODE = 2007] = "AVG_ENCODE", e[e.NACKS = 2009] = "NACKS", e[e.PLIS = 2010] = "PLIS", e[e.FIRS = 2011] = "FIRS", e[e.BITRATE = 2012] = "BITRATE", e[e.PACKAGE_RATE = 2031] = "PACKAGE_RATE", e[e.ADAPTATION = 2032] = "ADAPTATION", e[e.ACTUAL_ENCODED = 2060] = "ACTUAL_ENCODED", e[e.BANDWIDTH = 2061] = "BANDWIDTH", e[e.RETRANSMIT = 2062] = "RETRANSMIT", e[e.TARGET_ENCODED = 2064] = "TARGET_ENCODED", e[e.TRANSMIT = 2066] = "TRANSMIT", e[e.FREEZE = 2082] = "FREEZE", e[e.DISABLED = 2095] = "DISABLED", e[e.PLAYER_STATUS = 2128] = "PLAYER_STATUS", e[e.QP_SUM = 2143] = "QP_SUM", e[e.BYTES_RETRANSMIT = 2173] = "BYTES_RETRANSMIT", e[e.PACKAGES_RETRANSMIT = 2172] = "PACKAGES_RETRANSMIT", e[e.HUGE_FRAME_SENT = 2174] = "HUGE_FRAME_SENT", e[e.KEY_FRAMES_ENCODED = 2207] = "KEY_FRAMES_ENCODED", e;
    }(ki || {}), _f = function(e) {
      return e[e.BITRATE = 2069] = "BITRATE", e[e.PACKAGE_LOST = 2070] = "PACKAGE_LOST", e[e.PACKAGE_RATE = 2071] = "PACKAGE_RATE", e[e.HEIGHT = 2073] = "HEIGHT", e[e.FRAME_RATE = 2075] = "FRAME_RATE", e[e.WIDTH = 2077] = "WIDTH", e;
    }(_f || {}), ji = function(e) {
      return e[e.JITTER = -1] = "JITTER", e[e.PACKAGE_LOST = 2014] = "PACKAGE_LOST", e[e.WIDTH = 2018] = "WIDTH", e[e.HEIGHT = 2019] = "HEIGHT", e[e.FRAME_RATE = 2020] = "FRAME_RATE", e[e.JITTER_BUFFER = 2023] = "JITTER_BUFFER", e[e.CURRENT_DELAY = 2024] = "CURRENT_DELAY", e[e.NACKS = 2026] = "NACKS", e[e.PLIS = 2027] = "PLIS", e[e.FIRS = 2028] = "FIRS", e[e.BITRATE = 2029] = "BITRATE", e[e.PACKAGE_RATE = 2078] = "PACKAGE_RATE", e[e.FREEZE = 2084] = "FREEZE", e[e.DISABLED = 2101] = "DISABLED", e[e.PLAYER_STATUS = 2129] = "PLAYER_STATUS", e[e.QP_SUM = 2144] = "QP_SUM", e[e.I_FRAME_DELAY = 2149] = "I_FRAME_DELAY", e[e.FRAMES_DROPPED = 2181] = "FRAMES_DROPPED", e[e.BYTES_RETRANSMIT = 2175] = "BYTES_RETRANSMIT", e[e.PACKAGES_RETRANSMIT = 2176] = "PACKAGES_RETRANSMIT", e[e.PACKAGES_DISCARDED = 2198] = "PACKAGES_DISCARDED", e[e.AVG_DECODE = 2200] = "AVG_DECODE", e[e.AVG_PROCESSING_DELAY = 2202] = "AVG_PROCESSING_DELAY", e[e.AVG_ASSEMBLY_TIME = 2203] = "AVG_ASSEMBLY_TIME", e[e.AVG_INTER_FRAME_DELAY = 2204] = "AVG_INTER_FRAME_DELAY", e[e.KEY_FRAMES_DECODED = 2206] = "KEY_FRAMES_DECODED", e;
    }(ji || {}), Pf = function(e) {
      return e[e.FRAME_RATE_DECODE = 2021] = "FRAME_RATE_DECODE", e[e.FRAME_RATE_RENDER = 2022] = "FRAME_RATE_RENDER", e[e.FRAME_RATE_OUTPUT = 2155] = "FRAME_RATE_OUTPUT", e[e.FREEZE_TIME = 2109] = "FREEZE_TIME", e[e.FREEZE_TIME_RENDER = 2147] = "FREEZE_TIME_RENDER", e[e.FREEZE_DURATION = 2156] = "FREEZE_DURATION", e;
    }(Pf || {}), X6 = function(e) {
      return e[e.PCM_LEVEL = 2104] = "PCM_LEVEL", e;
    }(X6 || {}), Ou = function(e) {
      return e[e.PACKAGE_LOST = -1] = "PACKAGE_LOST", e[e.LEVEL = 2038] = "LEVEL", e[e.BITRATE = 2039] = "BITRATE", e[e.PACKAGE_RATE = 2040] = "PACKAGE_RATE", e[e.AEC_RETURN_LOSS = 2041] = "AEC_RETURN_LOSS", e[e.AEC_RETURN_LOSS_ENH = 2042] = "AEC_RETURN_LOSS_ENH", e[e.FREEZE = 2081] = "FREEZE", e[e.DISABLED = 2096] = "DISABLED", e[e.BYTES_RETRANSMIT = 2179] = "BYTES_RETRANSMIT", e[e.PACKAGES_RETRANSMIT = 2180] = "PACKAGES_RETRANSMIT", e;
    }(Ou || {}), Ia = function(e) {
      return e[e.BITRATE = 2044] = "BITRATE", e[e.PACKAGE_LOST = 2045] = "PACKAGE_LOST", e[e.PACKAGE_RATE = 2046] = "PACKAGE_RATE", e[e.CURRENT_DELAY = 2047] = "CURRENT_DELAY", e[e.JITTER_BUFFER = 2054] = "JITTER_BUFFER", e[e.JITTER = 2055] = "JITTER", e[e.FREEZE = 2083] = "FREEZE", e[e.DISABLED = 2102] = "DISABLED", e[e.PCM_LEVEL = 2105] = "PCM_LEVEL", e[e.PLAYER_STATUS = 2130] = "PLAYER_STATUS", e[e.CONCEALED_SAMPLES = 2148] = "CONCEALED_SAMPLES", e[e.BYTES_RETRANSMIT = 2178] = "BYTES_RETRANSMIT", e[e.PACKAGES_RETRANSMIT = 2177] = "PACKAGES_RETRANSMIT", e[e.PACKAGES_DISCARDED = 2199] = "PACKAGES_DISCARDED", e[e.AVG_PROCESSING_DELAY = 2201] = "AVG_PROCESSING_DELAY", e;
    }(Ia || {}), W6 = function(e) {
      return e[e.FREEZE_TIME = -1] = "FREEZE_TIME", e[e.LEVEL = 2043] = "LEVEL", e;
    }(W6 || {}), ga = function(e) {
      return e[e.RTT = 2006] = "RTT", e[e.CONN_TYPE = 801] = "CONN_TYPE", e[e.STATS_UPDATE_INTERVAL = 2205] = "STATS_UPDATE_INTERVAL", e;
    }(ga || {}), qT = function(e) {
      return e[e.RTC_PEER_CONNECTION_STATE = 2219] = "RTC_PEER_CONNECTION_STATE", e;
    }(qT || {});
    const xf = 1e3, Df = 6, KT = 3, Nae = Math.max(Df, KT);
    function Ln(e, n, i) {
      i != null && Number.isFinite(i) && (e[n] = Math.round(Math.max(0, i)));
    }
    function q6(e) {
      const n = { [ga.CONN_TYPE]: 0, [ga.RTT]: e.rtt, [ga.STATS_UPDATE_INTERVAL]: e.updateInterval ? Math.round(Math.max(0, e.updateInterval)) : void 0 };
      switch (e.selectedCandidatePair.localCandidate.candidateType) {
        case "relay": {
          const i = e.selectedCandidatePair.localCandidate.relayProtocol;
          i === "udp" && (n[ga.CONN_TYPE] = 1), i === "tcp" && (n[ga.CONN_TYPE] = 3), i === "tls" && (n[ga.CONN_TYPE] = 4);
          break;
        }
        case "srflx":
          n[ga.CONN_TYPE] = 2;
          break;
        case "unknown":
          n[ga.CONN_TYPE] = 5;
          break;
        default:
          n[ga.CONN_TYPE] = 0;
      }
      return n;
    }
    function K6(e) {
      let n = 0;
      switch (e) {
        case "none":
          n = 0;
          break;
        case "cpu":
          n = 1;
          break;
        case "bandwidth":
          n = 2;
          break;
        case "other":
          n = 3;
      }
      return n;
    }
    class J6 extends ii {
      constructor(n) {
        super(), Ve(this, "store", void 0), Ve(this, "uploadWRTCStatsTimer", void 0), Ve(this, "uploadOutboundDenoiserStatsTimer", void 0), Ve(this, "uploadExtStatsTimer", void 0), Ve(this, "uploadExtUsageStatsTimer", void 0), Ve(this, "uploadInboundExtStatsTimer", void 0), Ve(this, "requestStats", void 0), Ve(this, "requestTransportStats", void 0), Ve(this, "requestLocalMedia", void 0), Ve(this, "requestRemoteMedia", void 0), Ve(this, "requestAllTracks", void 0), Ve(this, "requestVideoIsReady", void 0), Ve(this, "requestUploadStats", void 0), Ve(this, "requestUpload", void 0), Ve(this, "uploadOutboundStarted", !1), Ve(this, "uploadInboundStarted", !1), Ve(this, "uploadTransportStarted", !1), Ve(this, "uploadBaseStatsStarted", !1), Ve(this, "uploadExtensionUsageStarted", !1), Ve(this, "lastRecvStats", void 0), Ve(this, "lastSendStats", void 0), Ve(this, "lastRefRecvStats", void 0), Ve(this, "lastRefSendStats", void 0), Ve(this, "lastFullRecvStats", void 0), Ve(this, "lastFullSendStats", void 0), Ve(this, "needUploadRenderFreezeTime", !0), this.store = n;
      }
      uploadWRTCStats(n) {
        if (!this.requestStats || !this.requestUploadStats) return;
        const i = n % KT == 0, o = n % Df == 0;
        let f, T;
        if (this.uploadTransportStarted && (f = this.requestStats(), this.store.useP2P && (T = this.requestStats(!0))), !f && this.uploadOutboundStarted && (f = this.requestStats()), !T && this.uploadInboundStarted && (T = this.requestStats(!0)), f || T) {
          var A;
          const R = {};
          if (this.uploadTransportStarted && f) {
            const L = this.getTransportStats(f, T, i);
            L && (R.misc = [L]);
          }
          if (this.uploadOutboundStarted && f) {
            const L = this.getOutboundStats(f, o ? this.lastFullSendStats : i ? this.lastRefSendStats : this.lastSendStats, i, o);
            L && (R.outbound = [L]);
          }
          if (this.uploadInboundStarted && T) {
            const L = this.getInboundStats(T, o ? this.lastFullRecvStats : i ? this.lastRefRecvStats : this.lastRecvStats, i, o);
            L && (R.inbound = L);
          }
          const P = (A = this.requestTransportStats) === null || A === void 0 ? void 0 : A.call(this).connectState;
          P && (Array.isArray(R.misc) ? R.misc[0] && R.misc[0].addition && (R.misc[0].addition[qT.RTC_PEER_CONNECTION_STATE] = VS[P]) : R.misc = [{ addition: { [qT.RTC_PEER_CONNECTION_STATE]: VS[P] } }]), this.requestUploadStats(R);
        }
        this.lastRecvStats = T, this.lastSendStats = f, o && (this.lastFullRecvStats = T, this.lastFullSendStats = f), i && (this.lastRefRecvStats = T, this.lastRefSendStats = f);
      }
      startUploadWRTCStats() {
        if (this.uploadWRTCStatsTimer) return;
        this.uploadBaseStatsStarted = !0;
        let n = 1;
        this.uploadWRTCStatsTimer = window.setInterval(() => {
          if (!this.uploadTransportStarted && !this.uploadInboundStarted && !this.uploadOutboundStarted) {
            if (this.uploadBaseStatsStarted) {
              var i, o;
              const f = (i = this.requestTransportStats) === null || i === void 0 ? void 0 : i.call(this);
              return void (f && ((o = this.requestUploadStats) === null || o === void 0 || o.call(this, { misc: [{ addition: { [qT.RTC_PEER_CONNECTION_STATE]: VS[f.connectState] } }] })));
            }
            return this.stopUploadWRTCStats();
          }
          this.uploadWRTCStats(n), ++n === Nae + 1 && (n = 1);
        }, xf);
      }
      stopUploadWRTCStats() {
        window.clearInterval(this.uploadWRTCStatsTimer), this.uploadWRTCStatsTimer = void 0, this.lastSendStats && (this.lastSendStats.videoSend = [], this.lastSendStats.audioSend = [], this.lastSendStats = void 0), this.lastRecvStats && (this.lastRecvStats.videoRecv = [], this.lastRecvStats.audioRecv = [], this.lastRecvStats = void 0);
      }
      getTransportStats(n, i, o) {
        if (!this.requestStats) return;
        if (!o) return n.rtt == null ? void 0 : { addition: { [ga.RTT]: n.rtt, [ga.CONN_TYPE]: void 0, [ga.STATS_UPDATE_INTERVAL]: n.updateInterval || void 0 } };
        const f = q6(n);
        if (this.store.useP2P) {
          if (i) {
            const T = q6(i);
            f[ga.CONN_TYPE] += T[ga.CONN_TYPE] << 3;
          }
          f[ga.CONN_TYPE] += 110;
        } else f[ga.CONN_TYPE] += 100;
        return { addition: f };
      }
      getOutboundStats(n, i, o, f) {
        if (!this.requestUploadStats || !this.requestLocalMedia) return;
        const T = this.requestLocalMedia();
        if (!T || T.length === 0) return;
        let A, R, P;
        return T.forEach((L) => {
          let [z, { track: Y, ssrcs: te }] = L;
          switch (z) {
            case Qt.LocalVideoLowTrack:
            case Qt.LocalVideoTrack:
              if (z === Qt.LocalVideoTrack) {
                const oe = function(De, Xe, We, mt, Pt, xt) {
                  const Nt = Xe.videoSend.find((hn) => hn.ssrc === De);
                  if (!Nt) return;
                  const Vt = {}, { sentFrame: nn, inputFrame: fn } = Nt;
                  if (xt && (Ln(Vt, ki.QP_SUM, Nt.qpSumPerFrame), fn && nn)) {
                    const hn = fn.frameRate, ir = nn.frameRate;
                    Vt[ki.FREEZE] = function(sr, Gr) {
                      let Ai = !0;
                      return Ai = !(sr <= 5) && (sr <= 10 ? Gr < 3 : sr <= 20 ? Gr < 4 : Gr < 5), Ai;
                    }(hn, ir) ? 1 : 0;
                  }
                  if (Pt) {
                    switch (nn && (Ln(Vt, ki.HEIGHT, nn.height), Ln(Vt, ki.WIDTH, nn.width), Ln(Vt, ki.FRAME_RATE, nn.frameRate)), Vt[ki.DISABLED] = mt._originMediaStreamTrack && !mt._originMediaStreamTrack.enabled || mt._mediaStreamTrack && !mt._mediaStreamTrack.enabled ? 1 : 0, Nt.adaptionChangeReason) {
                      case "none":
                        Vt[ki.ADAPTATION] = 0;
                        break;
                      case "cpu":
                        Vt[ki.ADAPTATION] = 1;
                        break;
                      case "bandwidth":
                        Vt[ki.ADAPTATION] = 2;
                        break;
                      case "other":
                        Vt[ki.ADAPTATION] = 3;
                    }
                    let hn = 0;
                    Nt.adaptionChangeReason && (hn += K6(Nt.adaptionChangeReason)), Xe.qualityLimitationReason && (hn += K6(Xe.qualityLimitationReason) << 3), Vt[ki.ADAPTATION] = hn, Vt[ki.PLAYER_STATUS] = tI[mt._player ? mt._player.videoElementStatus : "uninit"], Ln(Vt, ki.NACKS, Nt.nacksCount), Ln(Vt, ki.PLIS, Nt.plisCount), Ln(Vt, ki.FIRS, Nt.firsCount), Ln(Vt, ki.AVG_ENCODE, Nt.avgEncodeMs), Ln(Vt, ki.HUGE_FRAME_SENT, Nt.hugeFramesSent), Ln(Vt, ki.BYTES_RETRANSMIT, Nt.retransmittedBytesSent), Ln(Vt, ki.PACKAGES_RETRANSMIT, Nt.retransmittedPacketsSent), Ln(Vt, ki.KEY_FRAMES_ENCODED, Nt.keyFramesEncoded);
                    const ir = We && We.videoSend.find((sr) => sr.ssrc === De);
                    if (ir) {
                      let sr = Pt ? xf : xf * Df;
                      ir.timestamp && Nt.timestamp && (sr = Nt.timestamp - ir.timestamp), ir.packets != null && Nt.packets != null && Ln(Vt, ki.PACKAGE_RATE, 1e3 * (Nt.packets - ir.packets) / sr), Nt.packetsLost != null && ir.packetsLost != null && Ln(Vt, ki.PACKAGE_LOST, Nt.packetsLost - ir.packetsLost), ir.bytes != null && Nt.bytes != null && Ln(Vt, ki.BITRATE, 8 * (Nt.bytes - ir.bytes) / sr);
                    }
                  }
                  return Vt;
                }(te[0].ssrcId, n, i, Y, o, f), He = Y && function(De, Xe, We, mt) {
                  const Pt = Xe.videoSend.find((Nt) => Nt.ssrc === De);
                  if (!Pt) return null;
                  const xt = {};
                  if (mt) {
                    const Nt = Pt.inputFrame, Vt = Nt && Nt.height || We.videoHeight || 0, nn = Nt && Nt.width || We.videoWidth || 0, fn = Nt && Nt.frameRate || 0;
                    Ln(xt, WT.HEIGHT, Vt), Ln(xt, WT.WIDTH, nn), Ln(xt, WT.FRAME_RATE, fn);
                  }
                  return xt;
                }(te[0].ssrcId, n, Y, o), Re = function(De, Xe) {
                  const We = {};
                  return Xe && (Ln(We, ki.RETRANSMIT, De.bitrate.retransmit), Ln(We, ki.TARGET_ENCODED, De.bitrate.targetEncoded), Ln(We, ki.ACTUAL_ENCODED, De.bitrate.actualEncoded), Ln(We, ki.TRANSMIT, De.bitrate.transmit), Ln(We, ki.BANDWIDTH, De.sendBandwidth)), We;
                }(n, o);
                R = Object.assign({}, oe, He, Re);
              } else P = function(oe, He, Re, De) {
                const Xe = He.videoSend.find((mt) => mt.ssrc === oe);
                if (!Xe) return;
                const We = {};
                if (De) {
                  const mt = Xe.sentFrame;
                  if (mt && (Ln(We, _f.HEIGHT, mt.height), Ln(We, _f.WIDTH, mt.width), Ln(We, _f.FRAME_RATE, mt.frameRate)), Re) {
                    const Pt = Re.videoSend.find((xt) => xt.ssrc === oe);
                    if (Pt) {
                      let xt = xf * Df;
                      Pt.timestamp && Xe.timestamp && (xt = Xe.timestamp - Pt.timestamp), Pt.packets != null && Xe.packets != null && Ln(We, _f.PACKAGE_RATE, 1e3 * (Xe.packets - Pt.packets) / xt), Xe.packetsLost != null && Pt.packetsLost != null && Ln(We, _f.PACKAGE_LOST, Xe.packetsLost - Pt.packetsLost), Pt.bytes != null && Xe.bytes != null && Ln(We, _f.BITRATE, 8 * (Xe.bytes - Pt.bytes) / xt);
                    }
                  }
                }
                return We;
              }(te[0].ssrcId, n, i, o);
              break;
            case Qt.LocalAudioTrack:
              A = Y && function(oe, He, Re, De, Xe) {
                const We = He.audioSend.find((Pt) => Pt.ssrc === oe);
                if (!We) return;
                const mt = {};
                if (Xe) {
                  mt[Ou.DISABLED] = De._originMediaStreamTrack && !De._originMediaStreamTrack.enabled || De._mediaStreamTrack && !De._mediaStreamTrack.enabled ? 1 : 0;
                  const Pt = 100 * De._source.getAccurateVolumeLevel(), xt = We.inputLevel;
                  if (xt != null) {
                    const Vt = Math.ceil(50 * Math.log10(100 * xt + 1));
                    Ln(mt, Ou.LEVEL, Vt);
                  }
                  Ln(mt, X6.PCM_LEVEL, Pt), Ln(mt, Ou.AEC_RETURN_LOSS, We.aecReturnLoss), Ln(mt, Ou.AEC_RETURN_LOSS_ENH, We.aecReturnLossEnhancement), Ln(mt, Ou.BYTES_RETRANSMIT, We.retransmittedBytesSent), Ln(mt, Ou.PACKAGES_RETRANSMIT, We.retransmittedPacketsSent), mt[Ou.FREEZE] = 0;
                  const Nt = Re && Re.audioSend.find((Vt) => Vt.ssrc === oe);
                  if (Nt) {
                    let Vt = xf * Df;
                    Nt.timestamp && We.timestamp && (Vt = We.timestamp - Nt.timestamp), Nt.bytes != null && We.bytes != null && Ln(mt, Ou.BITRATE, 8 * (We.bytes - Nt.bytes) / Vt), Nt.packets != null && We.packets != null && Ln(mt, Ou.PACKAGE_RATE, 1e3 * (We.packets - Nt.packets) / Vt);
                  }
                }
                return mt;
              }(te[0].ssrcId, n, i, Y, o);
          }
        }), { high: R, low: P, audio: A };
      }
      getInboundStats(n, i, o, f) {
        if (!this.requestRemoteMedia) return;
        const T = this.requestRemoteMedia() || [], A = [];
        return T.forEach((R) => {
          let [P, L] = R;
          const z = { peer: P.uid };
          if (L.has(vn.VIDEO) && P.videoTrack) {
            const Y = P._videoSSRC && this.requestVideoIsReady && this.requestVideoIsReady(P._videoSSRC) || !1, te = P.videoTrack ? function(oe, He, Re, De, Xe, We, mt, Pt) {
              const xt = He.videoRecv.find((sr) => sr.ssrc === oe);
              if (!xt) return;
              const Nt = {}, { receivedFrame: Vt, outputFrame: nn, decodeFrameRate: fn } = xt, hn = Re && Re.videoRecv.find((sr) => sr.ssrc === oe);
              if (Ln(Nt, Pf.FRAME_RATE_DECODE, fn), xt.framesRateFirefox && Ln(Nt, ji.FRAME_RATE, xt.framesRateFirefox), Vt && Ln(Nt, ji.FRAME_RATE, Vt.frameRate), Ln(Nt, ji.FRAMES_DROPPED, xt.framesDroppedCount), Ln(Nt, ji.BYTES_RETRANSMIT, xt.retransmittedBytesReceived), Ln(Nt, ji.PACKAGES_RETRANSMIT, xt.retransmittedPacketsReceived), Ln(Nt, ji.PACKAGES_DISCARDED, xt.packetsDiscarded), Ln(Nt, ji.AVG_DECODE, xt.avgDecodeMs), Ln(Nt, ji.AVG_PROCESSING_DELAY, xt.avgProcessingDelayMs), Ln(Nt, ji.AVG_ASSEMBLY_TIME, xt.avgFramesAssembledFromMultiplePacketsMs), Ln(Nt, ji.AVG_INTER_FRAME_DELAY, xt.avgInterFrameDelayMs), Ln(Nt, ji.KEY_FRAMES_DECODED, xt.keyFramesDecoded), hn) {
                const sr = He.timestamp - Re.timestamp || xf * (Pt ? Df : mt ? KT : 1);
                xt.packetsLost != null && hn.packetsLost != null && Ln(Nt, ji.PACKAGE_LOST, xt.packetsLost - hn.packetsLost), hn.bytes != null && xt.bytes != null && Ln(Nt, ji.BITRATE, 8 * (xt.bytes - hn.bytes) / sr), hn.packets != null && xt.packets != null && Ln(Nt, ji.PACKAGE_RATE, 1e3 * (xt.packets - hn.packets) / sr);
              }
              if (Pt && (Ln(Nt, ji.QP_SUM, xt.qpSumPerFrame), Nt[ji.FREEZE] = Xe && XE.isRemoteVideoFreeze(De, xt, hn) ? 1 : 0), mt) {
                var ir;
                Vt ? (Ln(Nt, ji.HEIGHT, Vt.height), Ln(Nt, ji.WIDTH, Vt.width)) : De && (Ln(Nt, ji.HEIGHT, De._videoHeight || 0), Ln(Nt, ji.WIDTH, De._videoWidth || 0)), nn && Ln(Nt, Pf.FRAME_RATE_OUTPUT, nn.frameRate);
                const sr = (ir = De._player) === null || ir === void 0 ? void 0 : ir.rendFrameRate.toFixed(0);
                if (sr && Ln(Nt, Pf.FRAME_RATE_RENDER, +sr), Ln(Nt, ji.JITTER_BUFFER, xt.jitterBufferMs), Ln(Nt, ji.CURRENT_DELAY, xt.currentDelayMs), Ln(Nt, ji.FIRS, xt.firsCount), Ln(Nt, ji.NACKS, xt.nacksCount), Ln(Nt, ji.PLIS, xt.plisCount), De) {
                  Nt[ji.DISABLED] = De._originMediaStreamTrack.enabled && De._mediaStreamTrack.enabled ? 0 : 1;
                  const Gr = De._player;
                  if (Gr) {
                    const { freezeTimeCounterList: Ai, renderFreezeAccTime: fi, videoElementStatus: Ea } = Gr;
                    if (Ai && Ai.length > 0 && Ln(Nt, Pf.FREEZE_TIME, Ai.splice(0, 1)[0]), We && ld.visibility === "visible" && Ea === Xs.PLAYING && pr().supportRequestVideoFrameCallback) {
                      const qt = Math.min(6e3, fi);
                      Gr.renderFreezeAccTime = Math.max(0, fi - qt), Ln(Nt, Pf.FREEZE_TIME_RENDER, qt);
                    }
                    if (typeof xt.totalFreezesDuration == "number") {
                      const qt = hn && hn.totalFreezesDuration ? xt.totalFreezesDuration - hn.totalFreezesDuration : xt.totalFreezesDuration;
                      Ln(Nt, Pf.FREEZE_DURATION, 1e3 * qt);
                    }
                  }
                }
                if (Nt[ji.PLAYER_STATUS] = tI[De._player ? De._player.videoElementStatus : "uninit"], hn && xt.totalInterFrameDelay !== void 0 && xt.totalSquaredInterFrameDelay !== void 0 && hn.totalInterFrameDelay !== void 0 && hn.totalSquaredInterFrameDelay !== void 0) {
                  const Gr = xt.totalInterFrameDelay - hn.totalInterFrameDelay, Ai = xt.totalSquaredInterFrameDelay - hn.totalSquaredInterFrameDelay, fi = xt.framesDecodeCount - hn.framesDecodeCount, Ea = Gr / fi * 1e3, qt = Math.round(1e3 * Math.sqrt((Ai - Math.pow(Gr, 2) / fi) / fi));
                  !isNaN(qt) && Ea + qt > Math.max(3 * Ea, Ea + 150) && (Nt[ji.I_FRAME_DELAY] = qt);
                }
              }
              return Nt;
            }(P._videoSSRC, n, i, P.videoTrack, Y === !0, this.needUploadRenderFreezeTime, o, f) : void 0;
            te && (z.video = te);
          }
          if (L.has(vn.AUDIO) && P.audioTrack) {
            const Y = P.audioTrack ? function(te, oe, He, Re, De, Xe) {
              const We = oe.audioRecv.find((Nt) => Nt.ssrc === te);
              if (!We) return;
              const mt = {}, Pt = He && He.audioRecv.find((Nt) => Nt.ssrc === te);
              if (Ln(mt, Ia.JITTER, We.jitterMs), Ln(mt, Ia.BYTES_RETRANSMIT, We.retransmittedBytesReceived), Ln(mt, Ia.PACKAGES_RETRANSMIT, We.retransmittedPacketsReceived), Ln(mt, Ia.PACKAGES_DISCARDED, We.packetsDiscarded), Ln(mt, Ia.AVG_PROCESSING_DELAY, We.avgProcessingDelayMs), Pt) {
                const Nt = oe.timestamp - He.timestamp || xf * (Xe ? Df : De ? KT : 1);
                We.packets != null && Pt.packets != null && Ln(mt, Ia.PACKAGE_RATE, 1e3 * (We.packets - Pt.packets) / Nt), De && Pt.bytes != null && We.bytes != null && Ln(mt, Ia.BITRATE, 8 * (We.bytes - Pt.bytes) / Nt), We.packetsLost != null && Pt.packetsLost != null && Ln(mt, Ia.PACKAGE_LOST, We.packetsLost - Pt.packetsLost);
              }
              if (Xe) {
                const { receivedFrames: Nt, droppedFrames: Vt } = We;
                Nt != null && Vt != null && (mt[Ia.FREEZE] = (xt = Nt) === 0 || 100 * Vt / xt > 20 ? 1 : 0);
              }
              var xt;
              if (De) {
                const Nt = 100 * Re._source.getAccurateVolumeLevel(), Vt = We.outputLevel;
                if (Vt != null) {
                  const nn = Math.ceil(50 * Math.log10(100 * Vt + 1));
                  Ln(mt, W6.LEVEL, nn);
                }
                if (Ln(mt, Ia.PCM_LEVEL, Nt), Re && (mt[Ia.DISABLED] = Re._originMediaStreamTrack.enabled && Re._mediaStreamTrack.enabled ? 0 : 1), Ln(mt, Ia.JITTER_BUFFER, We.jitterBufferMs), Ln(mt, Ia.CURRENT_DELAY, We.jitterBufferMs), mt[Ia.PLAYER_STATUS] = tI[ha.getPlayerState(Re.getTrackId())], Pt) {
                  const nn = We.concealedSamples - Pt.concealedSamples;
                  nn > 0 && Ln(mt, Ia.CONCEALED_SAMPLES, nn);
                }
              }
              return mt;
            }(P._audioSSRC, n, i, P.audioTrack, o, f) : void 0;
            Y && (z.audio = Y);
          }
          (z.video || z.audio) && A.push(z);
        }), this.needUploadRenderFreezeTime = !this.needUploadRenderFreezeTime, A;
      }
      startUploadTransportStats() {
        this.uploadTransportStarted = !0, this.uploadWRTCStatsTimer || this.startUploadWRTCStats();
      }
      stopUploadTransportStats() {
        this.uploadTransportStarted = !1;
      }
      startUploadOutboundStats() {
        this.uploadOutboundStarted || (this.uploadOutboundStarted = !0, this.uploadWRTCStatsTimer || this.startUploadWRTCStats(), this.uploadOutboundDenoiserStatsTimer && window.clearInterval(this.uploadOutboundDenoiserStatsTimer), this.uploadOutboundDenoiserStatsTimer = window.setInterval(() => {
          if (!this.requestAllTracks || !this.requestUpload) return;
          const n = (this.requestAllTracks() || []).find((i) => i instanceof OT);
          if (n && n._external.getDenoiserStats) {
            const i = n._external.getDenoiserStats();
            i && this.requestUpload(kE.DENOISER_STATS, i);
          }
        }, 2e3), this.uploadExtStatsTimer && window.clearInterval(this.uploadExtStatsTimer), this.uploadExtStatsTimer = window.setInterval(() => {
          !this.requestAllTracks || !this.requestUpload || this.requestAllTracks().forEach((n) => {
            n.getProcessorStats().forEach((i) => {
              this.requestUpload && this.requestUpload(i.type, i.stats);
            });
          });
        }, 2e3));
      }
      stopUploadOutboundStats() {
        this.uploadOutboundStarted && (this.uploadOutboundStarted = !1, this.lastSendStats && (this.lastSendStats.videoSend = [], this.lastSendStats.audioSend = [], this.lastSendStats = void 0), this.uploadOutboundDenoiserStatsTimer && window.clearInterval(this.uploadOutboundDenoiserStatsTimer), this.uploadOutboundDenoiserStatsTimer = void 0);
      }
      startUploadInboundStats() {
        this.uploadInboundStarted || (this.uploadInboundStarted = !0, this.uploadWRTCStatsTimer || this.startUploadWRTCStats(), this.uploadInboundExtStatsTimer && window.clearInterval(this.uploadInboundExtStatsTimer), this.uploadInboundExtStatsTimer = window.setInterval(() => {
          !this.requestUpload || !this.requestRemoteMedia || (this.requestRemoteMedia() || []).forEach((n) => {
            let [i, o] = n;
            o.has(vn.VIDEO) && i.videoTrack && i.videoTrack.getProcessorStats().forEach((f) => {
              this.requestUpload && this.requestUpload(f.type, f.stats);
            }), o.has(vn.AUDIO) && i.audioTrack && i.audioTrack.getProcessorStats().forEach((f) => {
              this.requestUpload && this.requestUpload(f.type, f.stats);
            });
          });
        }, 2e3));
      }
      stopUploadInboundStats() {
        this.uploadInboundStarted && (this.uploadInboundStarted = !1, this.lastRecvStats && (this.lastRecvStats.videoRecv = [], this.lastRecvStats.audioRecv = [], this.lastRecvStats = void 0));
      }
      startUploadExtensionUsageStats() {
        if (this.uploadExtensionUsageStarted) return;
        this.uploadExtensionUsageStarted = !0, this.uploadExtUsageStatsTimer && window.clearInterval(this.uploadExtUsageStatsTimer);
        const n = /* @__PURE__ */ new Map();
        this.uploadExtUsageStatsTimer = window.setInterval(async () => {
          const i = Date.now(), o = { connectionInterval: ft("EXTENSION_USAGE_UPLOAD_INTERVAL") / 1e3, details: [], lts: i };
          let f = [];
          const T = this.requestAllTracks && this.requestAllTracks() || [];
          for (const L of T) !L.muted && L.enabled && (f = f.concat(await L.getProcessorUsage()));
          const A = this.requestRemoteMedia && this.requestRemoteMedia() || [];
          for (const [L, z] of A) z.has(vn.VIDEO) && L.videoTrack && (f = f.concat(await L.videoTrack.getProcessorUsage())), z.has(vn.AUDIO) && L.audioTrack && (f = f.concat(await L.audioTrack.getProcessorUsage()));
          if (f.length === 0) return;
          o.details = function(L, z) {
            const Y = {};
            for (const { id: Re, value: De, level: Xe, direction: We } of L) {
              var te;
              const mt = (te = z.get(Re)) !== null && te !== void 0 ? te : 0, Pt = De === 2 ? mt + ft("EXTENSION_USAGE_UPLOAD_INTERVAL") / 1e3 : mt;
              var oe, He;
              z.set(Re, Pt), Y[Re] ? (De === 2 && (Y[Re].value = De), Xe > Y[Re].level && (Y[Re].level = Xe), We === "remote" && (Y[Re].remoteUidCount += 1), Y[Re].totalTs = (oe = z.get(Re)) !== null && oe !== void 0 ? oe : 0) : Y[Re] = { value: De, level: Xe, remoteUidCount: We === "local" ? 0 : 1, totalTs: (He = z.get(Re)) !== null && He !== void 0 ? He : 0 };
            }
            return Object.keys(Y).map((Re) => {
              const { level: De, value: Xe, totalTs: We } = Y[Re];
              return { id: Re, level: De, value: Xe, totalTs: We };
            });
          }(f, n);
          const R = Date.now(), P = R > i ? R : i + 1;
          this.requestUpload && this.requestUpload(kE.EXTENSION_USAGE_STATS, { usageStats: o, sendTs: P });
        }, ft("EXTENSION_USAGE_UPLOAD_INTERVAL"));
      }
      stopUploadExtensionUsageStats() {
        this.uploadExtensionUsageStarted && (this.uploadExtensionUsageStarted = !1, this.uploadExtUsageStatsTimer && window.clearInterval(this.uploadExtUsageStatsTimer), this.uploadExtUsageStatsTimer = void 0);
      }
      stopUploadBaseStats() {
        this.uploadBaseStatsStarted = !1;
      }
    }
    const wae = ft("ICE_RESTART_INTERVAL");
    let JT = /* @__PURE__ */ new Map(), wp = /* @__PURE__ */ new Map(), ul = [Hs.UDP_TCP_RELAY, Hs.TCP_RELAY, Hs.RELAY], HI = ft("JOIN_WITH_FALLBACK_MEDIA_PROXY_FORCE") && pr().supportPCSetConfiguration;
    function Z6(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      const i = JT.get(e.id);
      i && (window.clearTimeout(i), JT.delete(e.id));
      const o = wp.get(e.id);
      n && o && o.index === ul.length - 1 && (Ee.debug("[".concat(e.id, "] reset ICE restart policy")), wp.delete(e.id));
    }
    function Q6(e, n, i) {
      if (JT.size === 0 && wp.size === 0 && (Array.isArray(ft("RESTART_SEQUENCE")) && ft("RESTART_SEQUENCE").length > 0 && !function(R, P) {
        if (R.length !== P.length) return !1;
        for (let L = 0; L < R.length; L += 1) {
          const z = R[L];
          if (R.filter((Y) => Y === z).length !== P.filter((Y) => Y === z).length) return !1;
        }
        return !0;
      }(ul, ft("RESTART_SEQUENCE")) && (ul = ft("RESTART_SEQUENCE").filter((R) => {
        var P;
        if (on(P = Object.values(Hs)).call(P, R)) return !0;
      }), Ee.debug("use reconnection policy from config distribution, queues: ".concat(ul.join(" => ")))), HI = ft("JOIN_WITH_FALLBACK_MEDIA_PROXY_FORCE") && pr().supportPCSetConfiguration), ul.length === 0) return void i();
      let o, { index: f = 0, type: T } = wp.get(e.id) || {};
      if (HI && T === Hs.RELAY) return void i();
      let A = T && f >= ul.length - 1;
      if (HI) T = Hs.RELAY;
      else {
        if (A) return void i();
        T ? (f++, T = ul[f]) : (T = ul[0], f = 0);
      }
      Ee.debug("[".concat(e.id, "] choose ICE restart policy: ").concat(T, ", index: ").concat(f)), n(T), wp.set(e.id, { index: f, type: T }), o = window.setTimeout(() => Q6(e, n, i), wae), JT.set(e.id, o);
    }
    var $n;
    function $6(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function Cu(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $6(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : $6(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    function e7(e) {
      var n, i, o, f = 2;
      for (typeof Symbol < "u" && (i = yS, o = Symbol.iterator); f--; ) {
        if (i && (n = e[i]) != null) return n.call(e);
        if (o && (n = e[o]) != null) return new ZT(n.call(e));
        i = "@@asyncIterator", o = "@@iterator";
      }
      throw new TypeError("Object is not async iterable");
    }
    function ZT(e) {
      function n(i) {
        if (Object(i) !== i) return cn.reject(new TypeError(i + " is not an object."));
        var o = i.done;
        return cn.resolve(i.value).then(function(f) {
          return { value: f, done: o };
        });
      }
      return ZT = function(i) {
        this.s = i, this.n = i.next;
      }, ZT.prototype = { s: null, n: null, next: function() {
        return n(this.n.apply(this.s, arguments));
      }, return: function(i) {
        var o = this.s.return;
        return o === void 0 ? cn.resolve({ value: i, done: !0 }) : n(o.apply(this.s, arguments));
      }, throw: function(i) {
        var o = this.s.return;
        return o === void 0 ? cn.reject(i) : n(o.apply(this.s, arguments));
      } }, new ZT(e);
    }
    let QT = ($n = class extends ii {
      get state() {
        return this._state;
      }
      set state(e) {
        const n = this._state;
        this._state = e, this.emit(wn.StateChange, n, this._state);
      }
      constructor(e, n) {
        super(), Ve(this, "isPlanB", void 0), Ve(this, "store", void 0), Ve(this, "statsUploader", void 0), Ve(this, "connection", void 0), Ve(this, "localTrackMap", /* @__PURE__ */ new Map()), Ve(this, "remoteUserMap", /* @__PURE__ */ new Map()), Ve(this, "localDataChannels", []), Ve(this, "remoteDataChannelMap", /* @__PURE__ */ new Map()), Ve(this, "pendingLocalTracks", []), Ve(this, "pendingRemoteTracks", []), Ve(this, "pendingLocalDataChannels", []), Ve(this, "pendingRemoteDataChannels", []), Ve(this, "statsCollector", void 0), Ve(this, "shouldForwardP2PCreation", void 0), Ve(this, "iceFailedCount", 0), Ve(this, "dtlsFailedCount", 0), Ve(this, "mutex", void 0), Ve(this, "_state", Ir.Disconnected), Ve(this, "_pcStatsUploadType", ft("NEW_ICE_RESTART") ? pd.FIRST_CONNECTION : pd.OLD_FIRST_CONNECTION), Ve(this, "_isStartRestartIce", !1), Ve(this, "_restartTimer", void 0), Ve(this, "_isTryConnecting", !1), Ve(this, "_iceError", null), Ve(this, "_forceTurn", !1), Ve(this, "_isWaitPcToRePub", !1), Ve(this, "handleMuteLocalTrack", async (i, o, f) => {
          const T = await this.mutex.lock("Locking from P2PChannel.handleMuteLocalTrack");
          try {
            if (!this.connection || this.state !== Ir.Connected) return void f(new Gt(Je.INVALID_OPERATION, "Cannot call P2PChannel.handleMuteLocalTrack before connection established."));
            const A = this.filterTobeMutedTracks(i);
            if (A.length === 0) return void o();
            const R = A.find((L) => L[0] === "videoLowTrack");
            R && R[1].track._originMediaStreamTrack.stop(), await this.connection.muteLocal(A.map((L) => {
              let [, { id: z }] = L;
              return z;
            }));
            const P = this.createMuteMessage(A);
            await Br(this, wn.RequestMuteLocal, P), o();
          } catch (A) {
            f(A);
          } finally {
            T();
          }
        }), Ve(this, "handleUnmuteLocalTrack", async (i, o, f) => {
          const T = await this.mutex.lock("Locking from P2PChannel.handleUnmuteLocalTrack");
          try {
            if (!this.connection || this.state !== Ir.Connected) return void f(new Gt(Je.INVALID_OPERATION, "Cannot call P2PChannel.handleUnmuteLocalTrack before connection established."));
            const A = this.filterTobeUnmutedTracks(i);
            if (A.length === 0) return void o();
            const R = A.find((L) => L[0] === "videoLowTrack");
            if (R) {
              const L = R[1];
              if (L.track._originMediaStreamTrack.stop(), !ft("DISABLE_DUAL_STREAM_USE_ENCODING") && pr().supportDualStreamEncoding) {
                const z = i._mediaStreamTrack.clone();
                L.track._mediaStreamTrack = z, L.track._originMediaStreamTrack = z;
              } else {
                const z = UI(i, wE(this, wn.RequestLowStreamParameter));
                L.track._mediaStreamTrack = z, L.track._originMediaStreamTrack = z;
              }
              await new cn((z, Y) => {
                this.handleReplaceTrack(L.track, z, Y, !0);
              });
            }
            await this.connection.unmuteLocal(A.map((L) => {
              let [, { id: z }] = L;
              return z;
            }));
            const P = this.createUnmuteMessage(A);
            await Br(this, wn.RequestUnmuteLocal, P), o();
          } catch (A) {
            f(A);
          } finally {
            T();
          }
        }), Ve(this, "handleUpdateVideoEncoder", async (i, o, f, T) => {
          let A;
          T || (A = await this.mutex.lock("Locking from P2PChannel.handleUpdateVideoEncoder"));
          try {
            const P = this.localTrackMap.get(Qt.LocalVideoTrack);
            if (!this.connection || !P || P.track !== i || this.state !== Ir.Connected) return void o();
            const { id: L, track: z } = P;
            await this.connection.updateSendParameters(L, z), await this.connection.updateEncoderConfig(L, z), this.emit(wn.UpdateVideoEncoder, z), o();
          } catch (P) {
            f(P);
          } finally {
            var R;
            (R = A) === null || R === void 0 || R();
          }
        }), Ve(this, "handleUpdateVideoSendParameters", async (i, o, f) => {
          const T = await this.mutex.lock("Locking from P2PChannel.handleUpdateVideoSendParameters");
          try {
            const A = this.localTrackMap.get(Qt.LocalVideoTrack);
            if (!this.connection || !A || A.track !== i || this.state !== Ir.Connected) return void o();
            const { id: R, track: P } = A;
            await this.connection.updateSendParameters(R, P), o();
          } catch (A) {
            f(A);
          } finally {
            T();
          }
        }), Ve(this, "handleReplaceMixingTrack", async (i, o, f, T) => {
          if (!this.connection || this.state !== Ir.Connected) return void o();
          const A = kI([i]);
          let R;
          Ee.debug("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection will replace audioTrack [").concat(A.getTrackId(), "]")), typeof T == "boolean" && T || (R = await this.mutex.lock("From P2PChannel.handleReplaceMixingTrack"));
          try {
            await this.replaceTrack(i, A), o();
          } catch (L) {
            f(L);
          } finally {
            var P;
            (P = R) === null || P === void 0 || P();
          }
        }), Ve(this, "handleReplaceTrack", async (i, o, f, T) => {
          let A;
          Ee.debug("[".concat(this.store.clientId, "] P2PChannel handleReplaceTrack for [track-id-").concat(i.getTrackId(), "]")), typeof T == "boolean" && T || (A = await this.mutex.lock("From P2PChannel.handleReplaceTrack"));
          try {
            var R;
            const L = Array.from(this.localTrackMap.entries()).find((z) => {
              let [, { track: Y }] = z;
              return i === Y;
            });
            if (!this.connection || !L || this.state !== Ir.Connected) return void o();
            if (await ((R = this.connection) === null || R === void 0 ? void 0 : R.replaceTrack(i, L[1].id)), this.isPlanB) {
              const z = L[1];
              z.id = i._mediaStreamTrack.id, this.localTrackMap.set(L[0], z);
            }
            if (L[0] === Qt.LocalVideoTrack && !ft("DISABLE_DUAL_STREAM_USE_ENCODING") && pr().supportDualStreamEncoding) {
              const z = this.localTrackMap.get(Qt.LocalVideoLowTrack);
              if (z) {
                const Y = i._mediaStreamTrack.clone();
                z.track._originMediaStreamTrack.stop(), z.track._mediaStreamTrack = Y, z.track._originMediaStreamTrack = Y, await new cn((te, oe) => {
                  this.handleReplaceTrack(z.track, te, oe, !0);
                });
              }
            }
            o();
          } catch (L) {
            f(L);
          } finally {
            var P;
            (P = A) === null || P === void 0 || P();
          }
        }), Ve(this, "handleGetRTCStats", (i) => {
          i(this.statsCollector.getRTCStats());
        }), Ve(this, "handleGetLocalVideoStats", (i) => {
          i(this.statsCollector.getLocalVideoTrackStats());
        }), Ve(this, "handleGetLocalAudioStats", (i) => {
          i(this.statsCollector.getLocalAudioTrackStats());
        }), Ve(this, "handleGetRemoteVideoStats", (i) => this.statsCollector.getRemoteVideoTrackStats(i.uid)[i.uid]), Ve(this, "handleGetRemoteAudioStats", (i) => this.statsCollector.getRemoteAudioTrackStats(i.uid)[i.uid]), this.store = e, this.statsCollector = n, this.statsCollector.addP2PChannel(this), this.statsUploader = new J6(this.store), this.bindStatsUploaderEvents(), this.mutex = new xs("P2PChannel-mutex", this.store.clientId), this.isPlanB = !pr().supportUnifiedPlan || ft("CHROME_FORCE_PLAN_B") && ad(), this.shouldForwardP2PCreation = ft("FORWARD_P2P_CREATION") && pr().supportPCSetConfiguration && PS(), this.shouldForwardP2PCreation && (this.connection = XT(this.store), this.emit(wn.PeerConnectionStateChange, this.connection.peerConnectionState), this.bindConnectionEvents(this.connection));
      }
      async startP2PConnection(e) {
        var n;
        this.state = Ir.New, this._forceTurn = V6(e), Ee.debug("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] forceTurn: ").concat(this._forceTurn));
        const i = this.shouldForwardP2PCreation && ((n = this.connection) === null || n === void 0 ? void 0 : n.peerConnectionState) === "closed";
        if (this.shouldForwardP2PCreation && !i || (i && this.connection && (Ee.warning("[".concat(this.store.clientId, "] P2PChannel.startP2PConnection ForwardP2P closed.")), this.resetConnection(this.connection)), this.connection = XT(this.store, e), this.emit(wn.PeerConnectionStateChange, this.connection.peerConnectionState), this.bindConnectionEvents(this.connection)), !this.connection) throw new Gt(Je.UNEXPECTED_ERROR, "Cannot P2PChannel.startConnection before P2PConnection initialization .");
        return this._pcStatsUploadType = ft("NEW_ICE_RESTART") ? pd.FIRST_CONNECTION : pd.OLD_FIRST_CONNECTION, this._isTryConnecting = !0, this._isStartRestartIce = !1, this._iceError = null, this.connection.setConfiguration(e), this.connection.establishPromise;
      }
      async connect(e) {
        if (!this.connection) throw new Gt(Je.UNEXPECTED_ERROR, "Cannot P2PChannel.connect before P2PChannel.startP2PConnection .");
        ft("ENABLE_PREALLOC_PC") && this.state === Ir.Connected ? await this.connection.updateRemoteConnect(e) : (this.store.peerConnectionStart(), await this.connection.connect(e), this.statsUploader.startUploadTransportStats(), this.statsUploader.startUploadExtensionUsageStats(), this.state = Ir.Connected);
      }
      updateRemoteRTPCapabilities(e) {
        const n = Array.from(this.localTrackMap.entries()).filter((f) => {
          var T;
          let [A] = f;
          return on(T = [Qt.LocalVideoLowTrack, Qt.LocalVideoTrack]).call(T, A);
        }), i = n.map((f) => {
          let [, { id: T }] = f;
          return T;
        }), o = n.map((f) => {
          let [T] = f;
          return T;
        });
        if (this.connection instanceof Ed) {
          if (Cn.updateRemoteRTPCapabilities(this.store.sessionId, { trackTypes: JSON.stringify(o), localCodecs: JSON.stringify(this.connection.localCodecs), remoteCodecs: JSON.stringify(e) }), !on(e).call(e, this.store.codec)) {
            const f = ["vp9", "vp8", "h264"].find((T) => on(e).call(e, T));
            f && (this.store.codec = f, Ee.debug("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, " updateRemoteRTPCapabilities] default codec is not available, hence the fallback to ").concat(f, ".")));
          }
          this.connection.updateRemoteRTPCapabilities(i, e);
        }
      }
      async getEstablishParams() {
        var e;
        if (this.connection instanceof Ed && this.connection.peerConnectionState !== "closed" && on(e = [Ir.New, Ir.Connected]).call(e, this.state)) return this.connection.establishPromise;
      }
      async publishDataChannel(e) {
        if (!this.connection || this.state !== Ir.Connected) {
          if (this.state === Ir.Disconnected) throw new Gt(Je.UNEXPECTED_ERROR, "PeerConnection already disconnected.");
          return e.forEach((i) => {
            var o;
            on(o = this.pendingLocalDataChannels).call(o, i) || this.pendingLocalDataChannels.push(i);
          }), [];
        }
        const n = this.filterTobePublishedDataChannels(e);
        return n.length === 0 ? [] : (n.forEach((i) => {
          const o = Date.now();
          this.store.publish(i.id.toString(), "datachannel", o);
        }), await this.connection.createDataChannels(this.store.uid, n), n.forEach((i) => {
          this.localDataChannels.push(i);
          const o = Date.now();
          this.store.publish(i.id + "", "datachannel", void 0, o);
        }), e.map((i) => ({ streamId: i.id, ordered: i.ordered, maxRetransmits: i.maxRetransmits, metadata: i.metadata, channelId: i._originDataChannelId })));
      }
      publish(e, n, i) {
        var o = this;
        return Io(function* () {
          const f = yield dr(o.mutex.lock("From P2PChannel.publish"));
          try {
            var T;
            const A = o.connection && on(T = ["disconnected", "failed"]).call(T, o.connection.peerConnectionState);
            if (!o.connection || o.state !== Ir.Connected || A) {
              if (o.state === Ir.Disconnected) throw new Gt(Je.UNEXPECTED_ERROR, "PeerConnection already disconnected.");
              o.throwIfTrackTypeNotMatch(e);
              const P = e.filter((L) => o.pendingLocalTracks.indexOf(L) === -1);
              return o.pendingLocalTracks = o.pendingLocalTracks.concat(P), void (A && (o._isWaitPcToRePub = !0));
            }
            o.store.pubId = o.store.pubId + 1, Ms.markPublishStart(o.store.clientId, o.store.pubId);
            const R = o.filterTobePublishedTracks(e, n, i);
            if (R.length === 0) return void (yield dr(o.tryToUnmuteAudio(e)));
            yield* Q1(e7(o.doPublish(o.connection, R)));
          } finally {
            f();
          }
        })();
      }
      doPublish(e, n) {
        var i = this;
        return Io(function* () {
          n.forEach((Y) => {
            let { track: te, type: oe } = Y;
            const He = Date.now();
            i.store.publish(te.getTrackId(), oe === Qt.LocalAudioTrack ? "audio" : "video", He);
          }), i.bindLocalTrackEvents(n);
          const o = n.map((Y) => {
            let { track: te } = Y;
            return te;
          }), f = yield dr(e.send(o, i.store.codec, i.store.audioCodec)), T = (yield dr(f.next())).value, A = i.createGatewayPublishMessage(n, T);
          let R;
          try {
            R = yield A;
          } catch (Y) {
            throw f.throw(Y), (Y == null ? void 0 : Y.code) === Je.WS_ABORT && n.forEach((te) => {
              let { track: oe } = te;
              i.pendingLocalTracks.indexOf(oe) === -1 && i.pendingLocalTracks.push(oe);
            }), i.unbindLocalTrackEvents(n), Y;
          }
          const P = i.mapPubResToRemoteConfig(A, R, o), L = (yield dr(f.next(P))).value, z = ft("ENABLE_VIDEO_SEI");
          o.forEach(async (Y) => {
            const te = Y.getRTCRtpTransceiver();
            te && z && (Y.trackMediaType === vn.VIDEO ? await Ose(te.sender, Y) : Y.trackMediaType === vn.AUDIO && await async function(oe) {
              if (!pr().supportWebRTCEncodedTransform) return void Ee.warning("browser not support audio encoded transform");
              if (ST.has(oe) || !oe.track) return;
              const He = { track: oe.track };
              if ($d()) {
                if (!oe.createEncodedStreams) return void Ee.warning("browser not support createEncodedStreams() API");
                let De = null;
                try {
                  De = oe.createEncodedStreams();
                } catch (We) {
                  return void Ee.error("create audio-encoded-streams error", We && We.message);
                }
                const Xe = new TransformStream({ transform(We, mt) {
                  He.controller || (He.controller = mt), oe.track && oe.track.id !== He.track.id && (Ee.debug("audio track changed: ".concat(He.track.id, " => ").concat(oe.track.id)), He.track.removeEventListener("ended", Re), He.track = oe.track, He.track.addEventListener("ended", Re)), mt.enqueue(We);
                } });
                De.readable.pipeThrough(Xe).pipeTo(De.writable);
              } else if (Os()) {
                if (typeof RTCRtpScriptTransform > "u") return void Ee.warning("browser not support RTCRtpScriptTransform");
                const De = CT(), Xe = new MessageChannel();
                await new cn((mt) => De.onmessage = (Pt) => {
                  Pt.data === "registered" && mt(void 0);
                });
                const We = new RTCRtpScriptTransform(De, { name: "tx", port: Xe.port2 }, [Xe.port2]);
                oe.transform = We, await new cn((mt) => De.onmessage = (Pt) => {
                  Pt.data === "started" && mt(void 0);
                }), Xe.port1.onmessage = (mt) => {
                  var Pt;
                  mt.data.transformed && oe.track && ((Pt = oe.track) === null || Pt === void 0 ? void 0 : Pt.id) !== He.track.id && (Ee.debug("audio track changed: ".concat(He.track.id, " => ").concat(oe.track.id)), He.track.removeEventListener("ended", Re), He.track = oe.track, He.track.addEventListener("ended", Re));
                }, He.worker = De;
              }
              function Re() {
                if (oe.track) {
                  if (this.id !== oe.track.id) return;
                  oe.track.removeEventListener("ended", Re);
                }
                const De = ST.get(oe);
                if (De) {
                  ST.delete(oe);
                  try {
                    var Xe, We;
                    (Xe = De.controller) === null || Xe === void 0 || Xe.terminate(), (We = De.worker) === null || We === void 0 || We.terminate();
                  } catch (mt) {
                    Ee.warning(mt && mt.message);
                  }
                }
              }
              ST.set(oe, He), oe.track.addEventListener("ended", Re);
            }(te.sender));
          }), n.forEach((Y) => {
            let { type: te } = Y;
            i.statsCollector.addLocalStats(te);
          }), i.assignLocalTracks(n, L), i.statsUploader.startUploadOutboundStats(), n.forEach((Y) => {
            let { track: te, type: oe } = Y;
            const He = Date.now();
            i.store.publish(te.getTrackId(), oe === Qt.LocalAudioTrack ? "audio" : "video", void 0, He);
          });
        })();
      }
      async updateVideoStreamParameter(e, n) {
        const i = this.localTrackMap.get(n);
        if (!i || !this.connection) return;
        if (!(i.track instanceof Wr)) return Ee.warn("[updateVideoStreamParameter]: track is not an instance of LocalVideoTrack");
        const { track: o } = i, f = function(T, A) {
          const R = {};
          return T.height && T.width && (R.scaleResolutionDownBy = bI(T, A)), R.maxFramerate = T.framerate ? Ga(T.framerate) : void 0, R.maxBitrate = T.bitrate ? 1e3 * T.bitrate : void 0, R;
        }(e, o);
        if (o._encoderConfig || (o._encoderConfig = {}), n !== Qt.LocalVideoLowTrack || !ft("DISABLE_DUAL_STREAM_USE_ENCODING") && pr().supportDualStreamEncoding) f.scaleResolutionDownBy != null && (o._encoderConfig.scaleResolutionDownBy = f.scaleResolutionDownBy);
        else {
          const T = o._originMediaStreamTrack;
          if (!T.canvas) return Ee.warn("[".concat(o.getTrackId(), "] no canvas on track"));
          (function(A, R) {
            const P = A.canvas;
            R.width && (P.width = Ga(R.width)), R.height && (P.height = Ga(R.height)), R.framerate && (P.stopCapture && P.stopCapture(), P.stopCapture = rI(() => {
              !P.startCapture && P.stopCapture && P.stopCapture(), P.startCapture && P.startCapture();
            }, Ga(R.framerate)));
          })(T, e);
        }
        f.maxBitrate != null && (o._encoderConfig.bitrateMax = f.maxBitrate / 1e3), f.maxFramerate != null && (o._encoderConfig.frameRate && typeof o._encoderConfig.frameRate == "object" ? o._encoderConfig.frameRate.max = f.maxFramerate : o._encoderConfig.frameRate = { max: f.maxFramerate }), Ee.debug("[".concat(o.getTrackId(), "] LowStreamEncoderConfig: , ").concat(JSON.stringify(o._encoderConfig))), await this.connection.updateRtpSenderEncodings(o);
      }
      publishLowStream(e) {
        var n = this;
        return Io(function* () {
          if (!n.connection || n.state !== Ir.Connected) return;
          const i = yield dr(n.mutex.lock("Locking from P2PChannel.publishLowStream"));
          try {
            const f = n.localTrackMap.get(Qt.LocalVideoTrack);
            if (!f) throw new Gt(Je.UNEXPECTED_ERROR, "Could not find high stream");
            if (n.localTrackMap.has(Qt.LocalVideoLowTrack)) throw new Gt(Je.UNEXPECTED_ERROR, "[".concat(n.store.clientId, "] Can't publish low stream when stream already publish"));
            const T = [{ track: n.getLowVideoTrack(f.track, e), type: Qt.LocalVideoLowTrack }];
            if (yield* Q1(e7(n.doPublish(n.connection, T))), f.track.muted || !f.track.enabled) {
              var o;
              const A = (o = n.localTrackMap.get(Qt.LocalVideoLowTrack)) === null || o === void 0 ? void 0 : o.id;
              A !== void 0 && (yield dr(n.connection.muteLocal([A])));
            }
          } finally {
            i();
          }
        })();
      }
      async republish() {
        this.pendingLocalTracks.length > 0 && (Ee.debug("[".concat(this.store.clientId, "] Emit P2PChannelEvents.RequestRePublish to republish tracks.")), await Ss(this, wn.RequestRePublish, this.pendingLocalTracks), this.emit(wn.MediaReconnectEnd, this.store.uid), this.pendingLocalTracks = []), this.pendingLocalDataChannels.length > 0 && (Ee.debug("Emit P2PChannelEvents.RequestRePublishDataChannel to republish datachannels."), await Ss(this, wn.RequestRePublishDataChannel, this.pendingLocalDataChannels), this.pendingLocalDataChannels = []), this._isWaitPcToRePub = !1;
      }
      async reSubscribe(e) {
        for (let n = this.pendingRemoteTracks.length - 1; n >= 0; n--) {
          const { user: i, kind: o } = this.pendingRemoteTracks[n];
          (o !== vn.AUDIO || i._audio_added_ && i._audioSSRC) && (o !== vn.VIDEO || i._video_added_ && i._videoSSRC) || this.pendingRemoteTracks.splice(n, 1);
        }
        if (e) await Ss(this, wn.RequestReSubscribe, this.pendingRemoteTracks);
        else for (const { user: n, kind: i } of this.pendingRemoteTracks) await this.subscribe(n, i, i === vn.VIDEO ? n._videoSSRC : n._audioSSRC);
        this.pendingRemoteTracks.forEach((n) => {
          let { user: i } = n;
          this.emit(wn.MediaReconnectEnd, i.uid);
        }), this.pendingRemoteTracks = [];
      }
      async unpublish(e) {
        if (!this.connection || this.state !== Ir.Connected) return void e.forEach((o) => {
          const f = this.pendingLocalTracks.indexOf(o);
          f !== -1 && this.pendingLocalTracks.splice(f, 1);
        });
        const n = this.filterTobeUnpublishedTracks(e);
        if (n.length === 0) return;
        const i = n.find((o) => o[0] === "videoLowTrack");
        return i && i[1].track.close(), this.doUnpublish(this.connection, n);
      }
      async unpublishDataChannel(e) {
        if (!this.connection || this.state !== Ir.Connected) return void e.forEach((i) => {
          const o = this.pendingLocalDataChannels.indexOf(i);
          o !== -1 && this.pendingLocalDataChannels.splice(o, 1);
        });
        const n = this.filterTobeUnpublishedDataChannels(e);
        return n.length !== 0 ? (n.forEach((i) => {
          const o = this.localDataChannels.indexOf(i);
          o !== -1 && this.localDataChannels.splice(o, 1);
        }), this.localDataChannels.length === 0 && await this.connection.stopDataChannels(this.store.uid), n.map((i) => i.id)) : void 0;
      }
      async unpublishLowStream() {
        if (!this.connection || this.state !== Ir.Connected) return;
        const e = this.localTrackMap.get(Qt.LocalVideoLowTrack);
        if (!e) return;
        e.track.close();
        const n = [[Qt.LocalVideoLowTrack, e]];
        return this.doUnpublish(this.connection, n);
      }
      async doUnpublish(e, n) {
        const i = this.createGatewayUnpublishMessage(n);
        return await e.stopSending(n.map((o) => {
          let [, { id: f }] = o;
          return f;
        })), this.withdrawLocalTracks(n), this.unbindLocalTrackEvents(n.map((o) => {
          let [f, { track: T }] = o;
          return { type: f, track: T };
        })), n.forEach((o) => {
          let [f] = o;
          this.statsCollector.removeLocalStats(f);
        }), this.localTrackMap.size === 0 && this.statsUploader.stopUploadOutboundStats(), i;
      }
      async subscribeDataChannel(e, n) {
        if (!this.connection || this.state !== Ir.Connected) throw new Gt(Je.INVALID_OPERATION, "Cannot subscribe remote user when peerConnection disconnected.");
        const i = n.filter((o) => {
          var f;
          return !((f = this.remoteDataChannelMap.get(e)) !== null && f !== void 0 && f.get(o.id));
        });
        if (i.length !== 0) return await this.connection.createDataChannels(e.uid, i), i.forEach((o) => {
          var f;
          this.remoteDataChannelMap.has(e) ? (f = this.remoteDataChannelMap.get(e)) === null || f === void 0 || f.set(o.id, o) : this.remoteDataChannelMap.set(e, /* @__PURE__ */ new Map([[o.id, o]]));
          const T = this.pendingRemoteDataChannels.findIndex((A) => {
            let { user: R, id: P } = A;
            return R.uid === e.uid && P === o.id;
          });
          T !== -1 && this.pendingRemoteDataChannels.splice(T, 1);
        }), i.map((o) => o.id);
      }
      async subscribe(e, n, i, o, f) {
        var T;
        if (!this.connection || this.state !== Ir.Connected) throw new Gt(Je.INVALID_OPERATION, "Cannot subscribe remote user when peerConnection disconnected.");
        if ((T = this.remoteUserMap.get(e)) !== null && T !== void 0 && T.has(n)) return;
        let A, R, P;
        const L = this.connection.getPreMedia(i);
        if (L) Ee.debug("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] preSSRCMap has ssrcId: ").concat(i, ", no need to send sub to gateway.")), P = L.transceiver, A = L.track, R = L.id;
        else if (f) {
          const te = f.find((He) => {
            let { stream_type: Re } = He;
            return Re === n;
          });
          if (!te) throw new Gt(Je.UNEXPECTED_ERROR, "Cannot subscribe to remote ".concat(n, " for user: ").concat(e.uid, " because subscribe answer from gateway does not contain stream_type: ").concat(n, "."));
          const oe = await this.connection.receive(n, te.ssrcs, String(e._uintid), te.attributes);
          this.connection instanceof Ed && (P = oe.transceiver), A = oe.track, R = oe.id;
        } else {
          const te = await this.connection.receive(n, [{ ssrcId: i, rtx: o }], String(e._uintid), void 0);
          this.connection instanceof Ed && (P = te.transceiver), A = te.track, R = te.id;
        }
        n === vn.AUDIO ? (e._audioTrack ? e._audioTrack._updateOriginMediaStreamTrack(A) : (e._audioTrack = new Ep(A, e.uid, e._uintid, this.store), Ee.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote audio track: ").concat(e._audioTrack.getTrackId()))), P && e._audioTrack._updateRtpTransceiver(P), this.bindRemoteTrackEvents(e, e._audioTrack)) : (e._videoTrack ? e._videoTrack._updateOriginMediaStreamTrack(A) : (e._videoTrack = new mp(A, e.uid, e._uintid, this.store), Ee.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote video track: ").concat(e._videoTrack.getTrackId()))), P && e._videoTrack._updateRtpTransceiver(P), this.bindRemoteTrackEvents(e, e._videoTrack)), ft("ENABLE_VIDEO_SEI") && P && (n == vn.VIDEO ? await x8(P.receiver, { onSei: (te) => {
          var oe;
          (oe = e._videoTrack) === null || oe === void 0 || oe._onSei(te);
        } }) : n == vn.AUDIO && await P8(P.receiver));
        const z = this.remoteUserMap.get(e);
        z ? z.set(n, R) : this.remoteUserMap.set(e, /* @__PURE__ */ new Map([[n, R]])), this.statsCollector.addRemoteStats(e.uid), this.statsUploader.startUploadInboundStats();
        const Y = this.pendingRemoteTracks.findIndex((te) => {
          let { user: oe, kind: He } = te;
          return oe.uid === e.uid && n === He;
        });
        Y !== -1 && (this.pendingRemoteTracks.splice(Y, 1), this.emit(wn.MediaReconnectEnd, e.uid));
      }
      async massSubscribe(e) {
        return this.massSubscribeNoLock(e);
      }
      async massSubscribeNoLock(e) {
        if (!this.connection || this.state !== Ir.Connected) throw new Gt(Je.INVALID_OPERATION, "Cannot subscribeAll remote users when peerConnection disconnected.");
        e = e.filter((f) => {
          var T;
          let { user: A, mediaType: R } = f;
          return !((T = this.remoteUserMap.get(A)) !== null && T !== void 0 && T.has(R));
        });
        const n = [], i = /* @__PURE__ */ new Map();
        e.forEach((f) => {
          if (!this.connection) return;
          const T = this.connection.getPreMedia(f.ssrcId);
          T ? i.set(f.ssrcId, T) : n.push(f);
        });
        const o = await this.connection.batchReceive(n.map((f) => {
          let { user: T, mediaType: A, ssrcId: R, rtxSsrcId: P } = f;
          return { kind: A, ssrcMsg: [{ ssrcId: R, rtx: P }], mslabel: String(T._uintid) };
        }));
        n.forEach((f, T) => {
          i.set(f.ssrcId, o[T]);
        });
        for (const { user: f, mediaType: T, ssrcId: A } of e) {
          const R = i.get(A);
          if (!R) return void Ee.debug("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] cannot find ").concat(f.uid, " subscribe data,").concat(T, ", ").concat(A));
          const { track: P, id: L, transceiver: z } = R;
          T === vn.AUDIO ? (f._audioTrack ? f._audioTrack._updateOriginMediaStreamTrack(P) : (f._audioTrack = new Ep(P, f.uid, f._uintid, this.store), Ee.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote audio track: ").concat(f._audioTrack.getTrackId()))), z && f._audioTrack._updateRtpTransceiver(z), this.bindRemoteTrackEvents(f, f._audioTrack)) : (f._videoTrack ? f._videoTrack._updateOriginMediaStreamTrack(P) : (f._videoTrack = new mp(P, f.uid, f._uintid, this.store), Ee.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote video track: ").concat(f._videoTrack.getTrackId()))), z && f._videoTrack._updateRtpTransceiver(z), this.bindRemoteTrackEvents(f, f._videoTrack)), ft("ENABLE_VIDEO_SEI") && z && (T == vn.VIDEO ? await x8(z.receiver, { onSei: (oe) => {
            var He;
            (He = f._videoTrack) === null || He === void 0 || He._onSei(oe);
          } }) : T == vn.AUDIO && await P8(z.receiver));
          const Y = this.remoteUserMap.get(f);
          Y ? Y.set(T, L) : this.remoteUserMap.set(f, /* @__PURE__ */ new Map([[T, L]])), this.statsCollector.addRemoteStats(f.uid), this.statsUploader.startUploadInboundStats();
          const te = this.pendingRemoteTracks.findIndex((oe) => {
            let { user: He, kind: Re } = oe;
            return He.uid === f.uid && T === Re;
          });
          te !== -1 && (this.pendingRemoteTracks.splice(te, 1), this.emit(wn.MediaReconnectEnd, f.uid));
        }
      }
      async unsubscribe(e, n, i) {
        const o = this.pendingRemoteTracks.filter((A) => {
          let { user: R, kind: P } = A;
          return n !== void 0 ? R.uid === e.uid && n === P : R.uid === e.uid;
        });
        if (o.forEach((A) => {
          const R = this.pendingRemoteTracks.indexOf(A);
          this.pendingRemoteTracks.splice(R, 1);
        }), this.connection && this.state === Ir.Connected || i || o.forEach((A) => {
          let { kind: R } = A;
          var P;
          if (R === vn.AUDIO) (P = e._audioTrack) === null || P === void 0 || P._destroy(), e._audioTrack = void 0;
          else if (R === vn.VIDEO) {
            var L;
            (L = e._videoTrack) === null || L === void 0 || L._destroy(), e._videoTrack = void 0;
          }
        }), !this.connection || this.state !== Ir.Connected) return;
        const f = this.filterTobeUnSubscribedTracks(e, n);
        if (f.length === 0) return;
        await this.connection.stopReceiving(f.map((A) => {
          let [, { id: R }] = A;
          return R;
        }));
        const T = this.createUnsubscribeMessage(f);
        return this.withdrawRemoteTracks(f), this.remoteUserMap.size === 0 && this.statsUploader.stopUploadInboundStats(), f.forEach((A) => {
          let [R, { kind: P }] = A;
          var L, z;
          if (P === vn.VIDEO && R._videoSSRC && ((L = this.connection) === null || L === void 0 || L.setStatsRemoteVideoIsReady(R._videoSSRC, !1)), P === vn.VIDEO) this.unbindRemoteTrackEvents(R._videoTrack), i || ((z = R._videoTrack) === null || z === void 0 || z._destroy(), R._videoTrack = void 0);
          else if (P === vn.AUDIO) {
            var Y;
            this.unbindRemoteTrackEvents(R._audioTrack), !i && ((Y = R._audioTrack) === null || Y === void 0 || Y._destroy(), R._audioTrack = void 0);
          }
        }), T;
      }
      async unsubscribeDataChannel(e, n) {
        if (n.forEach((f) => {
          const T = this.pendingRemoteDataChannels.findIndex((A) => A.id === f.id);
          T !== -1 && this.pendingRemoteDataChannels.splice(T, 1);
        }), !this.connection) return;
        const i = this.filterTobeUnSubscribedDataChannels(e, n);
        if (i.length === 0) return;
        n.forEach((f) => {
          f._close();
        });
        const o = this.remoteDataChannelMap.get(e);
        return i.forEach((f) => {
          o && o.delete(f.id);
        }), o && o.size === 0 && (this.remoteDataChannelMap.delete(e), await this.connection.stopDataChannels(e.uid)), i.map((f) => f.id);
      }
      async massUnsubscribe(e) {
        return this.massUnsubscribeNoLock(e);
      }
      async massUnsubscribeNoLock(e) {
        let n = [];
        for (const { user: f, mediaType: T } of e) {
          const A = this.pendingRemoteTracks.filter((R) => {
            let { user: P, kind: L } = R;
            return T !== void 0 ? P.uid === f.uid && T === L : P.uid === f.uid;
          });
          A.forEach((R) => {
            const P = this.pendingRemoteTracks.indexOf(R);
            this.pendingRemoteTracks.splice(P, 1);
          }), n = n.concat(A);
        }
        if (!this.connection || this.state !== Ir.Connected) return void n.forEach((f) => {
          let { user: T, kind: A } = f;
          var R;
          if (A === vn.AUDIO) (R = T._audioTrack) === null || R === void 0 || R._destroy(), T._audioTrack = void 0;
          else if (A === vn.VIDEO) {
            var P;
            (P = T._videoTrack) === null || P === void 0 || P._destroy(), T._videoTrack = void 0;
          }
        });
        const i = _c(e).call(e, (f, T) => {
          let { user: A, mediaType: R } = T;
          const P = this.filterTobeUnSubscribedTracks(A, R);
          return f.concat(P);
        }, []);
        if (i.length === 0) return;
        await this.connection.stopReceiving(i.map((f) => {
          let [, { id: T }] = f;
          return T;
        }));
        const o = this.createUnsubscribeAllMessage(i);
        return this.withdrawRemoteTracks(i), this.remoteUserMap.size === 0 && this.statsUploader.stopUploadInboundStats(), i.forEach((f) => {
          let [T, { kind: A }] = f;
          var R, P;
          if (A === vn.VIDEO && T._videoSSRC && ((R = this.connection) === null || R === void 0 || R.setStatsRemoteVideoIsReady(T._videoSSRC, !1)), A === vn.VIDEO) this.unbindRemoteTrackEvents(T._videoTrack), (P = T._videoTrack) === null || P === void 0 || P._destroy(), T._videoTrack = void 0;
          else if (A === vn.AUDIO) {
            var L;
            this.unbindRemoteTrackEvents(T._audioTrack), (L = T._audioTrack) === null || L === void 0 || L._destroy(), T._audioTrack = void 0;
          }
        }), o;
      }
      isPreSubScribe(e) {
        return !this.connection || this.state !== Ir.Connected ? !1 : !!this.connection.getPreMedia(e);
      }
      async muteRemote(e, n) {
        if (!this.connection) return;
        const i = this.remoteUserMap.get(e);
        if (!i) return void Ee.warning("[".concat(this.store.clientId, "] P2PChannel.muteRemote has no remote user ").concat(e.uid, "."));
        if (!i.get(n)) return void Ee.warning("[".concat(this.store.clientId, "] P2PChannel.muteRemote has no remote user ").concat(e.uid, " media type ").concat(n, "."));
        const o = n === vn.VIDEO ? e._videoSSRC : e._audioSSRC;
        o !== void 0 && this.connection.setStatsRemoteVideoIsReady(o, !1);
      }
      async unmuteRemote(e, n) {
        return this.unmuteRemoteNoLock(e, n);
      }
      async unmuteRemoteNoLock(e, n) {
        if (!this.connection) return;
        const i = this.remoteUserMap.get(e);
        if (!i) return void Ee.warning("[".concat(this.store.clientId, "] P2PChannel.unmuteRemote has no remote user ").concat(e.uid, "."));
        i.get(n) || Ee.warning("[".concat(this.store.clientId, "] P2PChannel.unmuteRemote has no remote user ").concat(e.uid, " media type ").concat(n, "."));
      }
      getAllTracks(e) {
        const n = this.localTrackMap.get(Qt.LocalAudioTrack);
        if ((n == null ? void 0 : n.track) instanceof Xi) {
          const i = n.track;
          return Array.from(this.localTrackMap.entries()).filter((o) => {
            let [f] = o;
            return f !== Qt.LocalAudioTrack;
          }).filter((o) => {
            let [f] = o;
            return !(e && f === Qt.LocalVideoLowTrack);
          }).map((o) => {
            let [, { track: f }] = o;
            return f;
          }).concat(i.trackList);
        }
        return Array.from(this.localTrackMap.entries()).filter((i) => {
          let [o] = i;
          return !(e && o === Qt.LocalVideoLowTrack);
        }).map((i) => {
          let [, { track: o }] = i;
          return o;
        });
      }
      getAllDataChannels() {
        return this.localDataChannels;
      }
      reportPublishEvent(e, n, i, o, f) {
        if (e) {
          const A = this.localTrackMap.get(Qt.LocalAudioTrack), R = o ? this.localTrackMap.get(Qt.LocalVideoLowTrack) : this.localTrackMap.get(Qt.LocalVideoTrack);
          Cn.publish(this.store.sessionId, { eventElapse: Ms.measureFromPublishStart(this.store.clientId, this.store.pubId), succ: e, ec: n, audioName: A == null ? void 0 : A.track.getTrackLabel(), videoName: R == null ? void 0 : R.track.getTrackLabel(), screenshare: (R == null ? void 0 : R.track._hints.indexOf(Fr.SCREEN_TRACK)) !== -1, audio: !!A, video: !!R, p2pid: this.store.p2pId, publishRequestid: this.store.pubId, extend: f });
        } else {
          var T;
          i || (i = []);
          const A = i.find((P) => P instanceof li), R = o ? (T = this.localTrackMap.get(Qt.LocalVideoTrack)) === null || T === void 0 ? void 0 : T.track : i.find((P) => P instanceof Wr);
          Cn.publish(this.store.sessionId, { eventElapse: Ms.measureFromPublishStart(this.store.clientId, this.store.pubId), succ: e, ec: n, audioName: A == null ? void 0 : A.getTrackLabel(), videoName: R == null ? void 0 : R.getTrackLabel(), screenshare: (R == null ? void 0 : R._hints.indexOf(Fr.SCREEN_TRACK)) !== -1, audio: !!A, video: !!R, p2pid: this.store.p2pId, publishRequestid: this.store.pubId, extend: f });
        }
      }
      reportSubscribeEvent(e, n, i, o) {
        const f = o === vn.VIDEO ? i._videoSSRC : i._audioSSRC;
        f && Cn.subscribe(this.store.sessionId, { succ: e, ec: n, video: o === vn.VIDEO, audio: o === vn.AUDIO, peerid: i.uid, subscribeRequestid: f, p2pid: this.store.p2pId, eventElapse: Ms.measureFromSubscribeStart(this.store.clientId, f), preSsrc: this.isPreSubScribe(f) });
      }
      reset() {
        Ee.debug("[".concat(this.store.clientId, "] P2PChannel.reset")), this.mutex = new xs("P2PChannel-mutex", this.store.clientId), this.connection && (this.resetConnection(this.connection), this.connection = void 0), this.shouldForwardP2PCreation && (this.connection = XT(this.store), this.emit(wn.PeerConnectionStateChange, this.connection.peerConnectionState), this.bindConnectionEvents(this.connection)), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), this.statsUploader.stopUploadExtensionUsageStats(), this.statsUploader.stopUploadBaseStats(), this.unbindLocalTrackEvents(), this.unbindAllRemoteTrackEvents(), this.unbindRtpTransceiver();
        const e = this.localTrackMap.get(Qt.LocalAudioTrack);
        if ((e == null ? void 0 : e.track) instanceof Xi) {
          if (e.track.trackList.length > 0) {
            const n = e.track;
            e.track.trackList.forEach((i) => {
              n.removeAudioTrack(i);
            });
          }
          e.track.close();
        }
        this.localTrackMap.clear(), this.remoteUserMap.clear(), this.statsCollector.removeRemoteStats(), this.statsCollector.removeLocalStats(), this.iceFailedCount = 0, this.dtlsFailedCount = 0, this.pendingLocalTracks = [], this.pendingRemoteTracks = [], this.localDataChannels = [], this.remoteDataChannelMap.clear(), this.pendingLocalDataChannels = [], this.pendingRemoteDataChannels = [], this.state = Ir.Disconnected;
      }
      getStats() {
        var e;
        return (e = this.connection) === null || e === void 0 ? void 0 : e.getStats();
      }
      getRemoteVideoIsReady(e) {
        var n;
        return ((n = this.connection) === null || n === void 0 ? void 0 : n.getRemoteVideoIsReady(e)) || !1;
      }
      getLocalAudioVolume() {
        const e = this.localTrackMap.get(Qt.LocalAudioTrack);
        if (e) return e.track.getVolumeLevel();
      }
      getLocalVideoSize() {
        const e = this.localTrackMap.get(Qt.LocalVideoTrack);
        if (e) return { width: e.track.videoWidth || 0, height: e.track.videoHeight || 0 };
      }
      getEncoderConfig(e) {
        const n = this.localTrackMap.get(e);
        return n && n.track instanceof Wr || n && n.track instanceof li ? n.track._encoderConfig : void 0;
      }
      getLocalMedia(e) {
        return this.localTrackMap.get(e);
      }
      hasLocalMedia() {
        return this.localTrackMap.size > 0;
      }
      hasRemoteMedia(e, n) {
        if (!e) return this.remoteUserMap.size > 0;
        const i = this.remoteUserMap.get(e);
        return !!i && (!n || i.has(n));
      }
      async hasRemoteMediaWithLock(e, n) {
        if (!e) return this.remoteUserMap.size > 0;
        const i = this.remoteUserMap.get(e);
        return !!i && (!n || i.has(n));
      }
      getRemoteMedia(e) {
        var n;
        const i = Array.from(ro(n = this.remoteUserMap).call(n)).find((o) => o.uid === e);
        return i ? { audioTrack: i.audioTrack, audioSSRC: i._audioSSRC, videoTrack: i.videoTrack, videoSSRC: i._videoSSRC } : {};
      }
      getAudioLevels() {
        let e = Array.from(this.remoteUserMap.entries()).map((i) => {
          let [o] = i;
          return { uid: o.uid, level: o.audioTrack ? 100 * o.audioTrack._source.getAccurateVolumeLevel() : 0 };
        });
        const n = this.localTrackMap.get(Qt.LocalAudioTrack);
        return n && e.push({ level: 100 * n.track._source.getAccurateVolumeLevel(), uid: this.store.uid }), e = hE(e).call(e, (i, o) => i.level - o.level), e;
      }
      async disconnectForReconnect() {
        this.connection && (Ee.debug("[".concat(this.store.clientId, "] P2PChannel.disconnectForReconnect closing P2PConnection")), this.state = Ir.Reconnecting, ft("KEEP_LAST_FRAME") && this.remoteUserMap.size !== 0 && Array.from(this.remoteUserMap.entries()).forEach((e) => {
          let [n] = e;
          var i;
          n._videoTrack && n._videoTrack._player && ((i = n._videoTrack._player.getVideoElement()) === null || i === void 0 || i.pause(), n._videoTrack._player.isKeepLastFrame = !0, n._videoTrack._originMediaStreamTrack.stop());
        }), this.resetConnection(this.connection), this.connection = void 0, this.shouldForwardP2PCreation && (this.connection = XT(this.store), this.emit(wn.PeerConnectionStateChange, this.connection.peerConnectionState), this.bindConnectionEvents(this.connection)), this.localTrackMap.size !== 0 && (Array.from(this.localTrackMap.entries()).forEach((e) => {
          var n;
          let [i, { track: o }] = e;
          switch (i) {
            case Qt.LocalVideoTrack:
              on(n = o._hints).call(n, Fr.LOW_STREAM) ? o.close() : this.pendingLocalTracks.push(o);
              break;
            case Qt.LocalAudioTrack:
              o instanceof Xi ? this.pendingLocalTracks = this.pendingLocalTracks.concat(o.trackList) : this.pendingLocalTracks.push(o);
            case Qt.LocalVideoLowTrack:
          }
        }), this.emit(wn.MediaReconnectStart, this.store.uid)), this.unbindLocalTrackEvents(), this.localTrackMap.clear(), this.remoteUserMap.size !== 0 && Array.from(this.remoteUserMap.entries()).forEach((e) => {
          let [n, i] = e;
          Array.from(ro(i).call(i)).forEach((o) => {
            this.setPendingRemoteMedia(n, o);
          }), this.emit(wn.MediaReconnectStart, n.uid);
        }), this.unbindAllRemoteTrackEvents(), this.remoteUserMap.clear(), this.localDataChannels.length !== 0 && (this.localDataChannels.forEach((e) => {
          this.pendingLocalDataChannels.push(e);
        }), this.localDataChannels.length = 0), this.remoteDataChannelMap.size !== 0 && (Array.from(this.remoteDataChannelMap.entries()).forEach((e) => {
          let [n, i] = e;
          Array.from(ro(i).call(i)).forEach((o) => {
            this.setPendingRemoteDataChannel(n, o);
          });
        }), this.remoteDataChannelMap.clear()), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), Ee.debug("[".concat(this.store.clientId, "] P2PChannel disconnected, waiting to reconnect.")));
      }
      hasPendingRemoteDataChannel(e, n) {
        for (const i of this.pendingRemoteDataChannels) {
          const { user: o, id: f } = i;
          if ((e instanceof cl ? e.uid : e) === o.uid && f === n) return !0;
        }
        return !1;
      }
      setPendingRemoteDataChannel(e, n) {
        this.hasPendingRemoteDataChannel(e, n) || this.pendingRemoteDataChannels.push({ user: e, id: n });
      }
      hasPendingRemoteMedia(e, n) {
        for (const i of this.pendingRemoteTracks) {
          const { user: o, kind: f } = i;
          if ((e instanceof cl ? e.uid : e) === o.uid && n === f) return !0;
        }
        return !1;
      }
      setPendingRemoteMedia(e, n) {
        this.hasPendingRemoteMedia(e, n) || this.pendingRemoteTracks.push({ user: e, kind: n });
      }
      restartICE(e) {
        var n = this;
        return Io(function* () {
          if (!n.connection || n.state !== Ir.Connected) return;
          const i = yield dr(n.mutex.lock("From P2PChannel.restartICE"));
          let o;
          try {
            o = yield dr(n.connection.restartICE(e));
            const T = yield dr(o.next());
            if (T.done) return;
            const A = T.value, R = yield A;
            switch (jI(n.connection) && n.reportPCStats(Date.now(), !1, n._pcStatsUploadType), e) {
              case Hs.UDP_TCP_RELAY:
                n._pcStatsUploadType = pd.UDP_TCP_RESTART;
                break;
              case Hs.TCP_RELAY:
                n._pcStatsUploadType = pd.TCP_RESTART;
                break;
              case Hs.RELAY:
                n._pcStatsUploadType = pd.RELAY_RESTART;
                break;
              default:
                n._pcStatsUploadType = pd.OLD_RESTART;
            }
            n._isTryConnecting = !0, o.next(R);
          } catch (T) {
            var f;
            (f = o) === null || f === void 0 || f.throw(T);
          } finally {
            i();
          }
        })();
      }
      getUplinkNetworkQuality() {
        if (!this.connection) return 0;
        const e = this.connection.getStats(), n = this.localTrackMap.get(Qt.LocalVideoTrack), i = this.localTrackMap.get(Qt.LocalAudioTrack), o = e.videoSend.find((oe) => oe.ssrc === (n == null ? void 0 : n.ssrcs[0].ssrcId)), f = e.audioSend.find((oe) => oe.ssrc === (i == null ? void 0 : i.ssrcs[0].ssrcId));
        if (!o || !f) return 1;
        const T = to(this, wn.NeedSignalRTT), A = o ? o.rttMs : void 0, R = f ? f.rttMs : void 0, P = A && R ? (A + R) / 2 : A || R, L = (P && T ? (P + T) / 2 : P || T) || 0, z = 100 * e.sendPacketLossRate * 0.7 / 50 + 0.3 * L / 1500, Y = z < 0.17 ? 1 : z < 0.36 ? 2 : z < 0.59 ? 3 : z < 0.1 ? 4 : 5, te = n == null ? void 0 : n.track;
        if (te && te._encoderConfig && te._hints.indexOf(Fr.SCREEN_TRACK) === -1) {
          const oe = te._encoderConfig.bitrateMax, He = e.bitrate.actualEncoded;
          if (oe && He) {
            const Re = (1e3 * oe - He) / (1e3 * oe);
            return D8[Re < 0.15 ? 0 : Re < 0.3 ? 1 : Re < 0.45 ? 2 : Re < 0.6 ? 3 : 4][Y];
          }
        }
        return Y;
      }
      getDownlinkNetworkQuality() {
        if (!this.connection) return 0;
        const e = this.connection.getStats();
        let n = 0;
        return Array.from(this.remoteUserMap.entries()).forEach((i) => {
          let [o] = i;
          const f = o._audioSSRC, T = o._videoSSRC, A = e.audioRecv.find((He) => He.ssrc === f), R = e.videoRecv.find((He) => He.ssrc === T);
          if (!A && !R) return void (n += 1);
          const P = to(this, wn.NeedSignalRTT), L = e.rtt, z = (L && P ? (L + P) / 2 : L || P) || 0, Y = A ? A.jitterMs : void 0, te = e.recvPacketLossRate;
          let oe = 0.7 * te * 100 / 50 + 0.3 * z / 1500;
          Y && (oe = 0.6 * te * 100 / 50 + 0.2 * z / 1500 + 0.2 * Y / 400), n += oe < 0.1 ? 1 : oe < 0.17 ? 2 : oe < 0.36 ? 3 : oe < 0.59 ? 4 : 5;
        }), this.remoteUserMap.size > 0 ? Math.round(n / this.remoteUserMap.size) : n;
      }
      async muteLocalTrack(e) {
        return new cn((n, i) => {
          this.handleMuteLocalTrack(e, n, i);
        });
      }
      async replaceTrack(e, n) {
        var i;
        if (Ee.debug("[".concat(this.store.clientId, "] P2PChannel replaceTrack from [").concat(e.getTrackId(), "] to [").concat(n.getTrackId(), "]")), !this.connection || this.state !== Ir.Connected) return;
        const o = Array.from(this.localTrackMap.entries()).find((T) => {
          let [, { track: A }] = T;
          return e === A;
        });
        if (!o) return;
        const f = o[0];
        if (e !== n && (this.unbindLocalTrackEvents([{ track: e, type: f }]), this.bindLocalTrackEvents([{ track: n, type: f }]), o[1].track = n), await ((i = this.connection) === null || i === void 0 ? void 0 : i.replaceTrack(n, o[1].id)), this.isPlanB) {
          const T = o[1];
          T.id = n._mediaStreamTrack.id, this.localTrackMap.set(f, T);
        }
        if (f === Qt.LocalVideoTrack && !ft("DISABLE_DUAL_STREAM_USE_ENCODING") && pr().supportDualStreamEncoding) {
          const T = this.localTrackMap.get(Qt.LocalVideoLowTrack);
          if (T) {
            const A = e._mediaStreamTrack.clone();
            T.track._originMediaStreamTrack.stop(), T.track._mediaStreamTrack = A, T.track._originMediaStreamTrack = A, await new cn((R, P) => {
              this.handleReplaceTrack(T.track, R, P, !0);
            });
          }
        }
      }
      filterTobePublishedTracks(e, n, i) {
        const o = [], f = this.getAllTracks();
        e = np(e = e.filter((P) => f.indexOf(P) === -1));
        let T, A = !1;
        const R = this.localTrackMap.get(Qt.LocalAudioTrack);
        for (const P of e) {
          if (P instanceof Wr && (this.localTrackMap.has(Qt.LocalVideoTrack) || A ? new Gt(Je.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS).throw() : (o.push({ track: P, type: Qt.LocalVideoTrack }), A = !0), n)) {
            const L = this.getLowVideoTrack(P, i);
            o.push({ track: L, type: Qt.LocalVideoLowTrack });
          }
          if (P instanceof li) if (R) {
            const L = R.track;
            if (L instanceof Xi) LI([P]), L.addAudioTrack(P), this.bindLocalAudioTrackEvents(P, !0);
            else {
              const z = kI([L, P]);
              Ee.debug("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection will replace audioTrack [").concat(z.getTrackId(), "]")), this.replaceTrack(L, z);
            }
          } else T instanceof Xi ? (LI([P]), T.addAudioTrack(P)) : T || !P._useAudioElement && pr().webAudioMediaStreamDest && !P._bypassWebAudio ? T = kI(T ? [P, T] : [P]) : T = P;
        }
        return T && (Ee.debug("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection will send audioTrack [").concat(T.getTrackId(), "]")), o.push({ track: T, type: Qt.LocalAudioTrack })), o;
      }
      filterTobeUnpublishedTracks(e) {
        const n = [], i = this.getAllTracks();
        e = np(e = e.filter((o) => i.indexOf(o) !== -1));
        for (const o of e) {
          if (o instanceof li) {
            const f = this.localTrackMap.get(Qt.LocalAudioTrack);
            if (!f) continue;
            f.track instanceof Xi ? (f.track.removeAudioTrack(o), this.unbindLocalAudioTrackEvents(o), f.track.trackList.length === 0 && (n.push([Qt.LocalAudioTrack, f]), f.track.close())) : n.push([Qt.LocalAudioTrack, f]);
          }
          if (o instanceof Wr) {
            const f = this.localTrackMap.get(Qt.LocalVideoTrack);
            if (!f) continue;
            n.push([Qt.LocalVideoTrack, f]);
            const T = this.localTrackMap.get(Qt.LocalVideoLowTrack);
            T && n.push([Qt.LocalVideoLowTrack, T]);
          }
        }
        return n;
      }
      filterTobePublishedDataChannels(e) {
        return e = (e = np(e)).filter((n) => this.localDataChannels.findIndex((i) => i.id === n.id) === -1);
      }
      filterTobeUnpublishedDataChannels(e) {
        return e = (e = (e = np(e)).filter((n) => this.localDataChannels.indexOf(n) !== -1)).filter((n) => n._originDataChannel);
      }
      bindLocalTrackEvents(e) {
        e.forEach((n) => {
          let { track: i, type: o } = n;
          switch (o) {
            case Qt.LocalVideoTrack:
              i.addListener(Tn.GET_STATS, this.handleGetLocalVideoStats), i.addListener(Tn.GET_RTC_STATS, this.handleGetRTCStats), i.addListener(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), i.addListener(Tn.NEED_UPDATE_VIDEO_ENCODER, this.handleUpdateVideoEncoder), i.addListener(Tn.NEED_UPDATE_VIDEO_SEND_PARAMETERS, this.handleUpdateVideoSendParameters), i.addListener(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), i.addListener(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
              break;
            case Qt.LocalAudioTrack:
              this.bindLocalAudioTrackEvents(i);
            case Qt.LocalVideoLowTrack:
          }
        });
      }
      bindLocalAudioTrackEvents(e, n) {
        e instanceof Xi ? e.trackList.forEach((i) => {
          i.addListener(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), i.addListener(Tn.GET_STATS, this.handleGetLocalAudioStats), i.addListener(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
        }) : (e.addListener(Tn.GET_STATS, this.handleGetLocalAudioStats), e.addListener(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.addListener(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.addListener(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.addListener(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack), n || (e.addListener(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), e.addListener(Tn.NEED_REPLACE_MIXING_TRACK, this.handleReplaceMixingTrack)));
      }
      unbindLocalTrackEvents(e) {
        e || (e = Array.from(this.localTrackMap.entries()).map((n) => {
          let [i, { track: o }] = n;
          return { track: o, type: i };
        })), e.forEach((n) => {
          let { track: i, type: o } = n;
          switch (o) {
            case Qt.LocalVideoTrack:
              i.off(Tn.GET_STATS, this.handleGetLocalVideoStats), i.off(Tn.GET_RTC_STATS, this.handleGetRTCStats), i.off(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), i.off(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), i.off(Tn.NEED_UPDATE_VIDEO_ENCODER, this.handleUpdateVideoEncoder), i.off(Tn.NEED_UPDATE_VIDEO_SEND_PARAMETERS, this.handleUpdateVideoSendParameters), i.off(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), i.off(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), i.off(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
              break;
            case Qt.LocalAudioTrack:
              this.unbindLocalAudioTrackEvents(i);
            case Qt.LocalVideoLowTrack:
          }
        });
      }
      unbindLocalAudioTrackEvents(e) {
        e instanceof Xi ? e.trackList.forEach((n) => {
          n.off(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), n.off(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), n.off(Tn.GET_STATS, this.handleGetLocalAudioStats), n.off(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), n.off(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
        }) : (e.off(Tn.GET_STATS, this.handleGetLocalAudioStats), e.off(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.off(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.off(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), e.off(Tn.NEED_REPLACE_MIXING_TRACK, this.handleReplaceMixingTrack), e.off(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.off(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack));
      }
      bindRemoteTrackEvents(e, n) {
        n instanceof mp && n.addListener(Tn.GET_STATS, (i) => {
          i(this.handleGetRemoteVideoStats(e));
        }), n instanceof Ep && n.addListener(Tn.GET_STATS, (i) => {
          i(this.handleGetRemoteAudioStats(e));
        });
      }
      unbindRemoteTrackEvents(e) {
        e && e.removeAllListeners(Tn.GET_STATS);
      }
      unbindAllRemoteTrackEvents() {
        Array.from(this.remoteUserMap.entries()).forEach((e) => {
          let [n, i] = e;
          i.has(vn.AUDIO) && this.unbindRemoteTrackEvents(n._audioTrack), i.has(vn.VIDEO) && this.unbindRemoteTrackEvents(n._videoTrack);
        });
      }
      createGatewayPublishMessage(e, n) {
        return e.map((i, o) => {
          var f;
          let T, A, { track: R, type: P } = i;
          switch (P) {
            case Qt.LocalAudioTrack:
              T = Sr.Audio, A = { dtx: R instanceof OT && R._config.DTX, hq: !1, lq: !1, stereo: !1, speech: !1 };
              break;
            case Qt.LocalVideoTrack:
              T = on(f = R._hints).call(f, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High, A = Cu(Cu({}, Z8(R)), {}, { codec: this.store.codec, svc_mode: MT() });
              break;
            case Qt.LocalVideoLowTrack:
              T = Sr.Low, A = Cu(Cu({}, Z8(R)), {}, { codec: this.store.codec, svc_mode: MT() });
          }
          return { stream_type: T, attributes: A, ssrcs: n[o] };
        });
      }
      createGatewayUnpublishMessage(e) {
        return e.map((n) => {
          var i;
          let o, [f, { track: T, ssrcs: A, id: R }] = n;
          switch (f) {
            case Qt.LocalVideoTrack:
              o = on(i = T._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalAudioTrack:
              o = Sr.Audio;
              break;
            case Qt.LocalVideoLowTrack:
              o = Sr.Low;
          }
          return { stream_type: o, ssrcs: A, mid: R };
        });
      }
      assignLocalTracks(e, n) {
        e.forEach((i, o) => {
          let { track: f, type: T } = i;
          this.localTrackMap.set(T, { track: f, id: n[o].id, ssrcs: n[o].localSSRC });
        });
      }
      withdrawLocalTracks(e) {
        e.forEach((n) => {
          let [i] = n;
          this.localTrackMap.delete(i);
        });
      }
      bindConnectionEvents(e) {
        e.onConnectionStateChange = async (n) => {
          if (Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onConnectionStateChange(").concat(n, ")")), this.emit(wn.PeerConnectionStateChange, n), n !== "connected" || this.store.keyMetrics.peerConnectionEnd || this.store.peerConnectionEnd(), n === "connected" && (this._restartTimer && (window.clearTimeout(this._restartTimer), this._restartTimer = void 0), e instanceof Ed && Z6(e, !0), this._isTryConnecting && this.reportPCStats(Date.now(), !0, this._pcStatsUploadType), this._isTryConnecting = !1, this._isStartRestartIce = !1, this._pcStatsUploadType = pd.DISCONNECTED_OR_FAILED, to(this, wn.QueryClientConnectionState) === "CONNECTED" && this._isWaitPcToRePub)) {
            const i = this.pendingLocalTracks.map((f) => f.getTrackId()), o = this.pendingLocalDataChannels.map((f) => "dc_".concat(f.id));
            Cn.reportApiInvoke(this.store.sessionId, { name: Bi.REPUB_AFTER_PC_CONNECTED, options: i.concat(o), tag: si.TRACER }).onSuccess(), this.republish();
          }
          if (ft("NEW_ICE_RESTART") && e instanceof Ed && !ui() && !this._forceTurn) {
            if (on(V8).call(V8, n)) {
              if (this._isStartRestartIce) return;
              this._isStartRestartIce = !0;
              const i = (f) => {
                jI(e) && (Ee.debug("[".concat(this.store.clientId, "] [P2PChannel] try to restartICE, type is ").concat(f)), to(this, wn.QueryClientConnectionState) === "CONNECTED" && this.emit(wn.RequestRestartICE, f));
              }, o = () => {
                jI(e) && (this.reportPCStats(Date.now(), !1, this._pcStatsUploadType), Ee.debug("[".concat(this.store.clientId, "] P2PConnection disconnected timeout, force reconnect")), setTimeout(() => this.emit(wn.P2PLost), 0), this.iceFailedCount += 1, this.requestReconnect());
              };
              return void (this._restartTimer = window.setTimeout(() => {
                Q6(e, i, o);
              }, 800));
            }
          } else {
            if (n === "disconnected" && e.iceConnectionState === "disconnected") return setTimeout(() => {
              e.iceConnectionState === "disconnected" && ft("ICE_RESTART") && to(this, wn.QueryClientConnectionState) === "CONNECTED" && this.emit(wn.RequestRestartICE);
            }, 800), void setTimeout(() => {
              e.peerConnectionState === "disconnected" && (Ee.debug("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection disconnected timeout 4000ms, force reconnect")), this.reportPCStats(Date.now(), !1, this._pcStatsUploadType), this._isTryConnecting = !1, setTimeout(() => this.emit(wn.P2PLost), 0), this.iceFailedCount += 1, this.requestReconnect());
            }, 4e3);
            n === "failed" && (Ee.debug("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection state failed, force reconnect")), this.reportPCStats(Date.now(), !1, this._pcStatsUploadType), setTimeout(() => this.emit(wn.P2PLost), 0), this.iceFailedCount += 1, await this.requestReconnect());
          }
        }, e.onICEConnectionStateChange = (n) => {
          n !== "connected" || this.store.keyMetrics.iceConnectionEnd || this.store.iceConnectionEnd(), Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onICEConnectionStateChange(").concat(n, ")")), Cn.reportApiInvoke(this.store.sessionId, { name: "ICEConnectionStateChange", options: n, tag: si.TRACER }).onSuccess(), this.emit(wn.IceConnectionStateChange, n);
        }, e.onICETransportStateChange = (n) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onICETransportStateChange(").concat(n, ")"));
        }, e.onDTLSTransportStateChange = (n) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onDTLSTransportStateChange(").concat(n, ")"));
        }, e.onDTLSTransportError = (n) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onDTLSTransportError(").concat(n, ")"));
        }, e.onFirstAudioDecoded = (n) => {
          var i;
          const o = Array.from(ro(i = this.remoteUserMap).call(i)).find((T) => T._audioSSRC === n);
          var f;
          o && (this.store.subscribe(o.uid, "audio", void 0, void 0, void 0, Date.now()), (f = o.audioTrack) === null || f === void 0 || f.emit(lp.FIRST_FRAME_DECODED), Cn.firstRemoteFrame(this.store.sessionId, us.FIRST_AUDIO_DECODE, ti.FIRST_AUDIO_DECODE, { peer: o._uintid, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, n), subscribeRequestid: n, p2pid: this.store.p2pId }));
        }, e.onFirstAudioReceived = (n) => {
          var i;
          const o = Array.from(ro(i = this.remoteUserMap).call(i)).find((f) => f._audioSSRC === n);
          o && Cn.firstRemoteFrame(this.store.sessionId, us.FIRST_AUDIO_RECEIVED, ti.FIRST_AUDIO_RECEIVED, { peer: o._uintid, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, n), subscribeRequestid: n, p2pid: this.store.p2pId });
        }, e.onFirstVideoDecoded = (n, i, o) => {
          this.reportVideoFirstFrameDecoded(n, i, o);
        }, e.onFirstVideoReceived = (n) => {
          var i;
          const o = Array.from(ro(i = this.remoteUserMap).call(i)).find((f) => f._videoSSRC === n);
          o && Cn.firstRemoteFrame(this.store.sessionId, us.FIRST_VIDEO_RECEIVED, ti.FIRST_VIDEO_RECEIVED, { peer: o._uintid, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, n), subscribeRequestid: n, p2pid: this.store.p2pId });
        }, e.onSelectedLocalCandidateChanged = (n, i) => {
          const o = n.candidateType === "relay", f = i.candidateType === "relay";
          i.candidateType !== "unknown" && o === f || this.emit(wn.ConnectionTypeChange, o), Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.SelectedLocalCandidateChanged(").concat(JSON.stringify(sl(i)), " -> ").concat(JSON.stringify(sl(n)), ")"));
        }, e.onSelectedRemoteCandidateChanged = (n, i) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.SelectedRemoteCandidateChanged(").concat(JSON.stringify(sl(i)), " -> ").concat(JSON.stringify(sl(n)), ")"));
        }, e.onFirstVideoDecodedTimeout = (n) => {
          this.reportVideoFirstFrameDecoded(n, void 0, void 0, !0);
        }, e.getLocalVideoStats = () => {
          const n = this.statsCollector.getLocalVideoTrackStats(), i = this.statsCollector.getRTCStats();
          return Cu(Cu({}, n), i);
        }, e.onICECandidateError = (n) => {
          this._iceError = n;
        };
      }
      resetConnection(e) {
        e instanceof Ed && function(n) {
          wp.delete(n.id), Z6(n);
        }(e), e.close(), this.emit(wn.PeerConnectionStateChange, "closed"), function(n) {
          n.onConnectionStateChange = void 0, n.onICEConnectionStateChange = void 0, n.onICETransportStateChange = void 0, n.onDTLSTransportStateChange = void 0, n.onDTLSTransportError = void 0, n.onFirstAudioDecoded = void 0, n.onFirstAudioReceived = void 0, n.onFirstVideoDecoded = void 0, n.onFirstVideoReceived = void 0, n.onSelectedLocalCandidateChanged = void 0, n.onSelectedRemoteCandidateChanged = void 0, n.onFirstVideoDecodedTimeout = void 0, n.getLocalVideoStats = void 0;
        }(e), this._isWaitPcToRePub = !1;
      }
      filterTobeMutedTracks(e) {
        const n = [];
        if (this.getAllTracks().indexOf(e) === -1) return n;
        const i = this.localTrackMap.get(Qt.LocalAudioTrack);
        if (e instanceof li && (i == null ? void 0 : i.track) instanceof Xi) return i.track.isActive || n.push([Qt.LocalAudioTrack, i]), n;
        const o = Array.from(this.localTrackMap.entries()).find((f) => {
          let [, { track: T }] = f;
          return e === T;
        });
        if (o && (n.push(o), o[0] === Qt.LocalVideoTrack)) {
          const f = this.localTrackMap.get(Qt.LocalVideoLowTrack);
          f && n.push([Qt.LocalVideoLowTrack, f]);
        }
        return n;
      }
      filterTobeUnmutedTracks(e) {
        const n = [], i = this.localTrackMap.get(Qt.LocalAudioTrack);
        if (e instanceof li && (i == null ? void 0 : i.track) instanceof Xi) return i.track.isActive && n.push([Qt.LocalAudioTrack, i]), n;
        const o = Array.from(this.localTrackMap.entries()).find((f) => {
          let [, { track: T }] = f;
          return e === T;
        });
        if (o) if (o[0] === Qt.LocalVideoTrack) {
          n.push(o);
          const f = this.localTrackMap.get(Qt.LocalVideoLowTrack);
          f && n.push([Qt.LocalVideoLowTrack, f]);
        } else n.push(o);
        return n;
      }
      createMuteMessage(e) {
        return e.map((n) => {
          var i;
          let o, [f, { track: T, ssrcs: A, id: R }] = n;
          switch (f) {
            case Qt.LocalAudioTrack:
              o = Sr.Audio;
              break;
            case Qt.LocalVideoTrack:
              o = on(i = T._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalVideoLowTrack:
              o = Sr.Low;
          }
          return { stream_type: o, ssrcs: A, mid: R };
        });
      }
      createUnmuteMessage(e) {
        return e.map((n) => {
          var i;
          let o, [f, { track: T, ssrcs: A, id: R }] = n;
          switch (f) {
            case Qt.LocalAudioTrack:
              o = Sr.Audio;
              break;
            case Qt.LocalVideoTrack:
              o = on(i = T._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalVideoLowTrack:
              o = Sr.Low;
          }
          return { stream_type: o, ssrcs: A, mid: R };
        });
      }
      filterTobeUnSubscribedTracks(e, n) {
        const i = [], o = this.remoteUserMap.get(e);
        if (!o) return i;
        if (n) {
          const f = o.get(n);
          if (!f) return i;
          i.push([e, { kind: n, id: f }]);
        } else Array.from(o.entries()).forEach((f) => {
          let [T, A] = f;
          i.push([e, { kind: T, id: A }]);
        });
        return i;
      }
      filterTobeUnSubscribedDataChannels(e, n) {
        const i = [];
        return n.forEach((o) => {
          var f;
          (f = this.remoteDataChannelMap.get(e)) !== null && f !== void 0 && f.has(o.id) && i.push(o);
        }), i;
      }
      createUnsubscribeMessage(e) {
        const n = [];
        return e.forEach((i) => {
          let [o, { kind: f, id: T }] = i;
          switch (f) {
            case vn.VIDEO:
              return void (o._videoSSRC && n.push({ stream_type: vn.VIDEO, ssrcId: o._videoSSRC }));
            case vn.AUDIO:
              return void (o._audioSSRC && n.push({ stream_type: vn.AUDIO, ssrcId: o._audioSSRC }));
          }
        }), n;
      }
      createUnsubscribeAllMessage(e) {
        const n = /* @__PURE__ */ new Map();
        return e.forEach((i) => {
          let [o, { kind: f }] = i;
          if (n.has(o)) {
            let T = n.get(o);
            f === vn.VIDEO ? T |= ns.Video : T |= ns.Audio, n.set(o, T);
          } else f === vn.VIDEO ? n.set(o, ns.Video) : n.set(o, ns.Audio);
        }), { users: Array.from(n.entries()).map((i) => {
          let [o, f] = i;
          return { stream_id: o.uid, stream_type: f };
        }) };
      }
      withdrawRemoteTracks(e) {
        e.forEach((n) => {
          let [i, { kind: o }] = n;
          const f = this.remoteUserMap.get(i);
          f && (f.delete(o), Array.from(f.entries()).length === 0 && this.remoteUserMap.delete(i));
        });
      }
      async updateBitrateLimit(e) {
        const n = this.localTrackMap.get(Qt.LocalVideoTrack), i = this.localTrackMap.get(Qt.LocalVideoLowTrack);
        n && (await n.track.setBitrateLimit(e.uplink), await new cn((o, f) => {
          this.handleUpdateVideoEncoder(n.track, o, f, !0);
        })), i && e.low_stream_uplink && (await i.track.setBitrateLimit({ max_bitrate: e.low_stream_uplink.bitrate, min_bitrate: e.low_stream_uplink.bitrate || 0 }), await new cn((o, f) => {
          this.handleUpdateVideoEncoder(i.track, o, f, !0);
        }));
      }
      isP2PDisconnected() {
        return this.connection ? this.connection.peerConnectionState !== "connected" : !0;
      }
      mapPubResToRemoteConfig(e, n, i) {
        return e.map((o, f) => {
          var T;
          let { stream_type: A } = o;
          const R = (T = n.find((P) => {
            let { stream_type: L } = P;
            return A === L;
          })) === null || T === void 0 ? void 0 : T.attributes;
          if (R && ft("DISABLE_SCREEN_SHARE_REMB")) {
            const P = i[f]._hints;
            (on(P).call(P, Fr.SCREEN_TRACK) || on(P).call(P, Fr.SCREEN_LOW_TRACK)) && (R.remb = !1, Ee.debug("disable remb for screen share, hints:", P));
          }
          return R;
        });
      }
      async tryToUnmuteAudio(e) {
        for (let i = 0; i < e.length; i++) if (e[i] instanceof li) {
          var n;
          const o = this.filterTobeUnmutedTracks(e[i]);
          if (o.length === 0) continue;
          await ((n = this.connection) === null || n === void 0 ? void 0 : n.unmuteLocal(o.map((T) => {
            let [, { id: A }] = T;
            return A;
          })));
          const f = this.createUnmuteMessage(o);
          return void await Br(this, wn.RequestUnmuteLocal, f);
        }
      }
      bindStatsUploaderEvents() {
        this.statsUploader.requestStats = () => this.getStats(), this.statsUploader.requestLocalMedia = () => Array.from(this.localTrackMap.entries()), this.statsUploader.requestRemoteMedia = () => Array.from(this.remoteUserMap.entries()), this.statsUploader.requestVideoIsReady = (e) => {
          var n;
          return !((n = this.connection) === null || n === void 0 || !n.getRemoteVideoIsReady(e));
        }, this.statsUploader.requestUpload = (e, n) => this.emit(wn.RequestUpload, e, n), this.statsUploader.requestUploadStats = (e) => this.emit(wn.RequestUploadStats, e), this.statsUploader.requestAllTracks = () => this.getAllTracks(), this.statsUploader.requestTransportStats = () => {
          var e;
          return { connectState: ((e = this.connection) === null || e === void 0 ? void 0 : e.peerConnectionState) || "closed" };
        };
      }
      unbindStatsUploaderEvents() {
        this.statsUploader.requestStats = void 0, this.statsUploader.requestLocalMedia = void 0, this.statsUploader.requestRemoteMedia = void 0, this.statsUploader.requestVideoIsReady = void 0;
      }
      async requestReconnect() {
        this.dtlsFailedCount += 1, await Es(HS(this.dtlsFailedCount, zi)), this.emit(wn.RequestReconnect);
      }
      async reconnectP2P() {
        const e = Array.from(this.localTrackMap.entries()), n = this.createGatewayUnpublishMessage(e);
        Array.from(this.remoteUserMap.entries()), n.length > 0 && await Ss(this, wn.RequestUnpublishForReconnectPC, n), this.disconnectForReconnect(), this.emit(wn.RequestReconnectPC);
      }
      canPublishLowStream() {
        return this.localTrackMap.has(Qt.LocalVideoTrack) || this.pendingLocalTracks.some((e) => e instanceof Wr);
      }
      throwIfTrackTypeNotMatch(e) {
        if (e.filter((n) => n instanceof Wr).length > 1) throw new Gt(Je.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
        if (e.filter((n) => n instanceof li).length > 1 && (e.some((n) => n instanceof li && n._bypassWebAudio) || !pr().webAudioMediaStreamDest)) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");
        for (const n of e) {
          if (n instanceof Wr && this.pendingLocalTracks.some((i) => i instanceof Wr)) throw new Gt(Je.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
          if (n instanceof li && this.pendingLocalTracks.some((i) => i instanceof li) && (!pr().webAudioMediaStreamDest || n._bypassWebAudio || this.pendingLocalTracks.some((i) => i instanceof li && i._bypassWebAudio))) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");
        }
      }
      getLowVideoTrack(e, n) {
        var i;
        const o = !ft("DISABLE_DUAL_STREAM_USE_ENCODING") && pr().supportDualStreamEncoding, f = Cu(Cu({}, { width: 160, height: 120, framerate: 15, bitrate: 50 }), n);
        let T;
        T = o ? e._mediaStreamTrack.clone() : UI(e, f);
        const A = zr(8, "track-low-"), R = new Wr(T, Cu(Cu({}, o && { scaleResolutionDownBy: bI(f, e) }), {}, { frameRate: f.framerate, bitrateMax: f.bitrate, bitrateMin: f.bitrate }), void 0, void 0, A);
        return R.on(Af.TRANSCEIVER_UPDATED, (P) => {
          e._updateRtpTransceiver(P, up.LOW_STREAM);
        }), R._hints.push(Fr.LOW_STREAM), on(i = e._hints).call(i, Fr.SCREEN_TRACK) && R._hints.push(Fr.SCREEN_LOW_TRACK), e.on("sei-to-send", (P) => {
          R.emit("sei-to-send", P);
        }), e.addListener(Tn.NEED_CLOSE, () => {
          R.close();
        }), R;
      }
      async globalLock() {
        return this.mutex.lock("From P2PChannel.globalLock");
      }
      async reportPCStats(e, n, i) {
        let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        if (this.connection && this.connection instanceof Ed) {
          var f, T, A, R;
          const P = this.store.keyMetrics.descriptionStart || 0, { iceConnectionState: L, dtlsTransportState: z, peerConnectionState: Y } = this.connection, { local: te, remote: oe } = await this.connection.getSelectedCandidatePair();
          Cn.pcStats(this.store.sessionId, { startTime: P, eventElapse: e - P || 0, iceconnectionsate: L, dtlsstate: z, connectionstate: Y, intSucc: n ? 1 : 2, error: this._iceError || o || "", selectedLocalCandidateProtocol: (f = te == null ? void 0 : te.protocol) !== null && f !== void 0 ? f : "", selectedLocalCandidateType: (T = te.candidateType) !== null && T !== void 0 ? T : "", selectedLocalCandidateAddress: "".concat(te.address, ":").concat(te.port), selectedRemoteCandidateProtocol: (A = oe.protocol) !== null && A !== void 0 ? A : "", selectedRemoteCandidateType: (R = oe.candidateType) !== null && R !== void 0 ? R : "", selectedRemoteCandidateAddress: "".concat(oe.address, ":").concat(oe.port), restartCnt: i, preallocation: this.connection.isPreallocation }), this._iceError = null;
        }
      }
      reportVideoFirstFrameDecoded(e, n, i, o) {
        var f;
        const T = Array.from(ro(f = this.remoteUserMap).call(f)).find((A) => A._videoSSRC === e);
        if (T) {
          o || this.store.subscribe(T.uid, "video", void 0, void 0, void 0, void 0, Date.now());
          const A = this.store.keyMetrics, R = A.subscribe.find((P) => P.userId === T.uid && P.type === "video");
          Cn.firstRemoteVideoDecode(this.store.sessionId, us.FIRST_VIDEO_DECODE, ti.FIRST_VIDEO_DECODE, { peer: T._uintid, videowidth: n, videoheight: i, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, e), subscribeRequestid: e, p2pid: this.store.p2pId, apEnd: A.requestAPEnd || 0, apStart: A.requestAPStart || 0, joinGwEnd: A.joinGatewayEnd || 0, joinGwStart: A.joinGatewayStart || 0, pcEnd: A.peerConnectionEnd || 0, pcStart: A.peerConnectionStart || 0, subscriberEnd: (R == null ? void 0 : R.subscribeEnd) || 0, subscriberStart: (R == null ? void 0 : R.subscribeStart) || 0, videoAddNotify: (R == null ? void 0 : R.streamAdded) || 0, state: o ? 1 : 0, firstFrame: (R == null ? void 0 : R.firstFrame) || 0 });
        }
      }
      async remoteMediaSsrcChanged(e, n, i) {
        if (!this.connection) return !1;
        const o = this.remoteUserMap.get(e);
        if (!o) return !1;
        const f = o.get(n);
        if (!f) return !1;
        const T = await this.connection.getRemoteSSRC(f);
        return T !== void 0 && T !== i;
      }
      unbindRtpTransceiver() {
        this.localTrackMap.size !== 0 && Array.from(this.localTrackMap.entries()).forEach((e) => {
          let [n, { track: i }] = e;
          n === Qt.LocalVideoLowTrack ? i._updateRtpTransceiver(void 0, up.LOW_STREAM) : i._updateRtpTransceiver(void 0);
        });
      }
    }, bn($n.prototype, "startP2PConnection", [qs], Object.getOwnPropertyDescriptor($n.prototype, "startP2PConnection"), $n.prototype), bn($n.prototype, "connect", [qs], Object.getOwnPropertyDescriptor($n.prototype, "connect"), $n.prototype), bn($n.prototype, "updateRemoteRTPCapabilities", [qs], Object.getOwnPropertyDescriptor($n.prototype, "updateRemoteRTPCapabilities"), $n.prototype), bn($n.prototype, "publishDataChannel", [qs], Object.getOwnPropertyDescriptor($n.prototype, "publishDataChannel"), $n.prototype), bn($n.prototype, "unpublish", [qs], Object.getOwnPropertyDescriptor($n.prototype, "unpublish"), $n.prototype), bn($n.prototype, "unpublishDataChannel", [qs], Object.getOwnPropertyDescriptor($n.prototype, "unpublishDataChannel"), $n.prototype), bn($n.prototype, "unpublishLowStream", [qs], Object.getOwnPropertyDescriptor($n.prototype, "unpublishLowStream"), $n.prototype), bn($n.prototype, "subscribeDataChannel", [qs], Object.getOwnPropertyDescriptor($n.prototype, "subscribeDataChannel"), $n.prototype), bn($n.prototype, "subscribe", [qs], Object.getOwnPropertyDescriptor($n.prototype, "subscribe"), $n.prototype), bn($n.prototype, "massSubscribe", [qs], Object.getOwnPropertyDescriptor($n.prototype, "massSubscribe"), $n.prototype), bn($n.prototype, "unsubscribe", [qs], Object.getOwnPropertyDescriptor($n.prototype, "unsubscribe"), $n.prototype), bn($n.prototype, "unsubscribeDataChannel", [qs], Object.getOwnPropertyDescriptor($n.prototype, "unsubscribeDataChannel"), $n.prototype), bn($n.prototype, "massUnsubscribe", [qs], Object.getOwnPropertyDescriptor($n.prototype, "massUnsubscribe"), $n.prototype), bn($n.prototype, "muteRemote", [qs], Object.getOwnPropertyDescriptor($n.prototype, "muteRemote"), $n.prototype), bn($n.prototype, "unmuteRemote", [qs], Object.getOwnPropertyDescriptor($n.prototype, "unmuteRemote"), $n.prototype), bn($n.prototype, "hasRemoteMediaWithLock", [qs], Object.getOwnPropertyDescriptor($n.prototype, "hasRemoteMediaWithLock"), $n.prototype), bn($n.prototype, "disconnectForReconnect", [qs], Object.getOwnPropertyDescriptor($n.prototype, "disconnectForReconnect"), $n.prototype), bn($n.prototype, "updateBitrateLimit", [qs], Object.getOwnPropertyDescriptor($n.prototype, "updateBitrateLimit"), $n.prototype), bn($n.prototype, "remoteMediaSsrcChanged", [qs], Object.getOwnPropertyDescriptor($n.prototype, "remoteMediaSsrcChanged"), $n.prototype), $n);
    function qs(e, n, i) {
      const o = e[n];
      if (typeof o != "function") throw new Error("Cannot use mutex on object property.");
      return i.value = async function() {
        const f = this.mutex, T = await f.lock("From P2PChannel.".concat(n));
        try {
          for (var A = arguments.length, R = new Array(A), P = 0; P < A; P++) R[P] = arguments[P];
          return await o.apply(this, R);
        } finally {
          T();
        }
      }, i;
    }
    function t7(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function n7(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? t7(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t7(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const _ae = Date.now(), Pae = 20, BI = /* @__PURE__ */ new Map(), $T = /* @__PURE__ */ new Map();
    async function r7(e) {
      const n = BI.get(e), i = Array.isArray(n) && n[n.length - 1], o = $T.get(e);
      if (!i) return void (o.isSyncing = !1);
      const f = { uid: i.uid, payload: i.payload };
      o.firstRecvTs === 0 && (o.firstRecvTs = i.recvTs, o.firstSendTs = i.sendTs);
      const T = i.sendTs - o.firstSendTs, A = T - (Date.now() - o.firstRecvTs);
      A > 0 && (o.firstRecvTs = Date.now() - T);
      let R = i.mediaDelay + A;
      R <= 0 ? (n.pop(), i7(i.context, f), R = 0) : R = Math.min(R, Pae), setTimeout(() => n.length && r7(e), R);
    }
    function i7(e, n) {
      e.safeEmit(rr.STREAM_MESSAGE, n.uid, n.payload), e.onStreamMessage && e.onStreamMessage(n);
    }
    function xae(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 ? arguments[2] : void 0;
      if (!e.syncWithAudio) return i7(i, { uid: e.uid, payload: e.payload });
      const o = "".concat(i.id, "-").concat(e.uid), f = BI.get(o) || [], T = f.findIndex((L) => e.sendTs >= L.sendTs), A = n7(n7({}, e), {}, { context: i, mediaDelay: n, recvTs: Date.now() });
      T === -1 ? f.push(A) : f.splice(T, 0, A), BI.set(o, f);
      let R = !1;
      var P;
      $T.has(o) ? R = !((P = $T.get(o)) === null || P === void 0 || !P.isSyncing) : $T.set(o, { isSyncing: R, firstRecvTs: 0, firstSendTs: 0 }), R || r7(o);
    }
    const Dae = hr().name;
    function s7(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function a7(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? s7(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : s7(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const _p = "websdk_ng_cache_parameter", Mae = ft("MAX_PRELOAD_ASYNC_LENGTH"), Lae = 1e4, Mf = /* @__PURE__ */ new Map(), Lf = [];
    let zI = null, FI = 0, GI = 0;
    const e0 = /* @__PURE__ */ new Map(), kae = /* @__PURE__ */ function(e, n) {
      const i = [];
      let o = 0;
      const f = async () => {
        const T = i.shift();
        T && await T(), i.length > 0 && o < n ? f() : o--;
      };
      return async function() {
        for (var T = arguments.length, A = new Array(T), R = 0; R < T; R++) A[R] = arguments[R];
        return new cn(async (P, L) => {
          i.push(async () => {
            try {
              const z = await e(...A);
              P(z);
            } catch (z) {
              L(z);
            }
          }), o < n && (o++, f());
        });
      };
    }(o7, Mae), VI = fa.CancelToken.source();
    async function o7(e, n, i, o, f, T) {
      try {
        if (!ft("ENABLE_PRELOAD")) return;
        if (!pr().supportWebCrypto) return void el(() => {
          Ee.warn("Your browser does not support preloading, this feature  be run in a secure environment");
        }, "preload_webcrypto_not_supported");
        if (!i && i !== null) throw new Gt(Je.INVALID_PARAMS, "Invalid token: ".concat(i, ". If you don not use token, set it to null"));
        i && ms(i, "token", 1, 2047), ms(e, "appid", 1, 2047), wT(n), o && _T(o);
        const A = rp();
        Ee.debug("preload channel ".concat(n, ", uid is ").concat(o));
        const R = { appId: e, cname: n, token: i || e, uid: typeof o != "string" ? o : null, sid: A, proxyServer: f };
        let P, L;
        typeof o == "string" ? (R.stringUid = o, [L, P] = await cn.all([yae(o, { sid: A, appId: e }, VI.token), N6(a7(a7({}, R), {}, { token: i || e, uid: 0 }), VI.token)]), R.uid = L.uid, P.gatewayInfo.uid = R.uid, P.gatewayInfo.res.uid = R.uid) : (T && (R.stringUid = T), P = await N6(R, VI.token));
        const z = { sid: A, appId: e, cname: n, token: i || e, uid: R.stringUid || o, intUid: R.uid || P.gatewayInfo.uid, stringUid: R.stringUid, ts: Date.now(), sua: L, ap: P };
        await async function(Y) {
          let te;
          try {
            Y.uid && u7({ appId: Y.appId, cname: Y.cname, token: Y.token, uid: Y.uid, stringUid: Y.stringUid });
            const oe = h7(Y), He = await async function(De, Xe) {
              try {
                const We = await window.crypto.subtle.importKey("raw", s5(Xe), "AES-GCM", !1, ["encrypt"]), mt = await window.crypto.subtle.encrypt({ name: "AES-GCM", iv: new Uint8Array(1) }, We, Tf(window.btoa(JSON.stringify(De))));
                return tl(new Uint8Array(mt));
              } catch {
                return;
              }
            }(Y, Y.token || Y.appId);
            if (!He) return;
            te = f7(_p);
            const Re = te ? JSON.parse(te) : [];
            Re.push({ [oe]: He }), Re.length > ft("AP_CACHE_NUM") && Re.shift(), t0(_p, JSON.stringify(Re));
          } catch (oe) {
            Ee.warn("Error caching server parameters:", oe.message), t0(_p, "");
          }
        }(z), FI++;
      } catch (A) {
        throw GI++, function(R) {
          zI || (zI = window.setTimeout(() => {
            let L = "";
            e0.forEach((z, Y) => {
              L += "".concat(Y, ": ").concat(z, " ;");
            }), Cn.reportApiInvoke(null, { name: Bi.PRELOAD, options: { success: FI, failed: GI, err: L } }).onError(R), FI = 0, GI = 0, e0.clear(), zI = null;
          }, Lae));
          const P = e0.get(R.code) || 0;
          e0.set(R.code, P + 1);
        }(A), A;
      }
    }
    async function c7(e) {
      try {
        if (ft("AP_REQUEST_DETAIL") || ft("ENABLE_ROLE_SELECT_EDGE")) return;
        const n = u7(e);
        if (!n || e.cloudProxyServer !== "disabled") return;
        const i = await async function(o, f) {
          try {
            const T = await window.crypto.subtle.importKey("raw", s5(f), "AES-GCM", !1, ["decrypt"]), A = await window.crypto.subtle.decrypt({ name: "AES-GCM", iv: new Uint8Array(1) }, T, Tf(o));
            return JSON.parse(window.atob(tl(new Uint8Array(A))));
          } catch {
            return;
          }
        }(n, e.token || e.appId);
        if (!i || !function(o, f) {
          return o.cname === f.cname && o.appId === f.appId && o.token === f.token ? f.stringUid ? o.stringUid === f.stringUid : typeof f.uid == "number" ? o.uid === f.uid : o.uid == f.uid : !1;
        }(i, e)) return;
        if (i && Date.now() - i.ts < ft("AP_CACHE_LIFETIME")) return i;
      } catch (n) {
        Ee.warn("Error get preloadInfo", n.message);
      }
    }
    function u7(e) {
      let n;
      try {
        if (n = f7(_p), !n) return;
        const i = JSON.parse(n), o = h7(e), f = function(A, R) {
          for (let P = A.length - 1; P >= 0; P--) if (R(A[P])) return P;
          return -1;
        }(i, (A) => o in A);
        if (f === -1) return;
        const T = i.splice(f, 1)[0];
        return t0(_p, JSON.stringify(i)), T[o];
      } catch (i) {
        Ee.warn("Error delete preload info: ".concat(n), i.message), t0(_p, "");
      }
    }
    function YI(e) {
      if (e) {
        let n = Mf.get(e);
        n && (window.clearTimeout(n), n = null, Mf.delete(e)), on(Lf).call(Lf, e) || e.cloudProxyServer !== "disabled" || Lf.push(e);
      }
      if (Mf.size < ft("AP_CACHE_NUM") && Lf.length > 0) {
        const n = Lf.shift();
        Mf.set(n, window.setTimeout(async () => {
          const { appId: i, cname: o, token: f, stringUid: T, uid: A, proxyServer: R } = n;
          try {
            await kae(i, o, f, A, R, T), Mf.has(n) && YI(n);
          } catch (P) {
            Ee.warn("update preload failed", P.message), d7(n);
          }
        }, ft("AP_UPDATE_INTERVAL")));
      }
    }
    function d7(e) {
      const n = Lf.indexOf(e);
      n !== -1 && Lf.splice(n, 1);
      let i = Mf.get(e);
      i && (window.clearTimeout(i), i = null, Mf.delete(e), YI());
    }
    function l7(e, n) {
      const i = e.sua, o = e.ap;
      n && i && Cn.reqUserAccount(e.sid, { lts: i.requestTime, elapse: i.elapse, success: !0, serverAddr: i.url, stringUid: n, uid: e.intUid, errorCode: null, extend: i.req }), Cn.reportResourceTiming(e.ap.url, e.sid), Cn.joinWebProxyAP(e.sid, { lts: o.requestTime, elapse: o.elapse, sucess: 1, apServerAddr: o.url, turnServerAddrList: o.proxyInfo.addresses.map((f) => f.ip).join(","), eventType: "disabled", unilbsServerIds: [Li.CHOOSE_SERVER, Li.CLOUD_PROXY_FALLBACK].toString() }), Cn.joinChooseServer(e.sid, { lts: o.requestTime, elapse: o.elapse, succ: !0, csAddr: o.url, opid: o.opid, serverList: o.gatewayInfo.gatewayAddrs.map((f) => f.address), ec: null, cid: o.gatewayInfo.cid.toString(), uid: o.gatewayInfo.uid.toString(), csIp: o.gatewayInfo.csIp, unilbsServerIds: [Li.CHOOSE_SERVER].toString(), isHttp3: o.isHttp3 });
    }
    function f7(e) {
      return window.atob(window.localStorage.getItem(e) || "");
    }
    function t0(e, n) {
      window.localStorage.setItem(e, window.btoa(n));
    }
    function h7(e) {
      let n = "".concat(e.appId, "_").concat(e.cname);
      return typeof e.uid == "string" && (n += "_s_".concat(e.uid)), typeof e.uid == "number" && (n += "_".concat(e.uid)), e.token && (n += "_".concat(e.token)), f5(n);
    }
    function jae(e) {
      let n = function() {
        const i = Bae.pop();
        return i ? (i.offset = i.limit = 0, i) : { bytes: new Uint8Array(64), offset: 0, limit: 0 };
      }();
      return function(i, o) {
        let f = i.appId;
        f !== void 0 && (Ui(o, 10), dl(o, f));
        let T = i.cid;
        T !== void 0 && (Ui(o, 16), Ui(o, T));
        let A = i.cname;
        A !== void 0 && (Ui(o, 26), dl(o, A));
        let R = i.deviceId;
        R !== void 0 && (Ui(o, 34), dl(o, R));
        let P = i.elapse;
        P !== void 0 && (Ui(o, 40), ll(o, P));
        let L = i.fileSize;
        L !== void 0 && (Ui(o, 48), ll(o, Pp(L)));
        let z = i.height;
        z !== void 0 && (Ui(o, 56), ll(o, Pp(z)));
        let Y = i.jpg;
        Y !== void 0 && (Ui(o, 66), Ui(o, Y.length), g7(o, Y));
        let te = i.networkType;
        te !== void 0 && (Ui(o, 72), ll(o, Pp(te)));
        let oe = i.osType;
        oe !== void 0 && (Ui(o, 80), ll(o, Pp(oe)));
        let He = i.requestId;
        He !== void 0 && (Ui(o, 90), dl(o, He));
        let Re = i.sdkVersion;
        Re !== void 0 && (Ui(o, 98), dl(o, Re));
        let De = i.sequence;
        De !== void 0 && (Ui(o, 104), ll(o, Pp(De)));
        let Xe = i.sid;
        Xe !== void 0 && (Ui(o, 114), dl(o, Xe));
        let We = i.timestamp;
        We !== void 0 && (Ui(o, 120), ll(o, We));
        let mt = i.uid;
        mt !== void 0 && (Ui(o, 128), Ui(o, mt));
        let Pt = i.vid;
        Pt !== void 0 && (Ui(o, 136), Ui(o, Pt));
        let xt = i.width;
        xt !== void 0 && (Ui(o, 144), ll(o, Pp(xt)));
        let Nt = i.service;
        Nt !== void 0 && (Ui(o, 152), Ui(o, Nt));
        let Vt = i.callbackData;
        Vt !== void 0 && (Ui(o, 162), Ui(o, Vt.length), g7(o, Vt));
        let nn = i.ticket;
        nn !== void 0 && (Ui(o, 170), dl(o, nn));
        let fn = i.vendorConfigs;
        fn !== void 0 && (Ui(o, 178), dl(o, fn));
      }(e, n), function(i) {
        let o = i.bytes, f = i.limit;
        return o.length === f ? o : o.subarray(0, f);
      }(n);
    }
    function Uae(e) {
      return function(i) {
        let o = {};
        e: for (; !zae(i); ) {
          let f = qE(i);
          switch (f >>> 3) {
            case 0:
              break e;
            case 1:
              o.code = qE(i);
              break;
            case 2:
              o.msg = m7(i, qE(i));
              break;
            case 3:
              o.requestId = m7(i, qE(i));
              break;
            case 4:
              o.timestamp = Fae(i, !1);
              break;
            default:
              Hae(i, 7 & f);
          }
        }
        return o;
      }({ bytes: n = e, offset: 0, limit: n.length });
      var n;
    }
    function Hae(e, n) {
      switch (n) {
        case 0:
          for (; 128 & dc(e); ) ;
          break;
        case 2:
          XI(e, qE(e));
          break;
        case 5:
          XI(e, 4);
          break;
        case 1:
          XI(e, 8);
          break;
        default:
          throw new Error("Unimplemented type: " + n);
      }
    }
    function Pp(e) {
      return { low: e |= 0, high: e >> 31, unsigned: e >= 0 };
    }
    let Bae = [];
    function XI(e, n) {
      if (e.offset + n > e.limit) throw new Error("Skip past limit");
      e.offset += n;
    }
    function zae(e) {
      return e.offset >= e.limit;
    }
    function n0(e, n) {
      let i = e.bytes, o = e.offset, f = e.limit, T = o + n;
      if (T > i.length) {
        let A = new Uint8Array(2 * T);
        A.set(i), e.bytes = A;
      }
      return e.offset = T, T > f && (e.limit = T), o;
    }
    function p7(e, n) {
      let i = e.offset;
      if (i + n > e.limit) throw new Error("Read past limit");
      return e.offset += n, i;
    }
    function g7(e, n) {
      let i = n0(e, n.length);
      e.bytes.set(n, i);
    }
    function m7(e, n) {
      let i = p7(e, n), o = String.fromCharCode, f = e.bytes, T = "�", A = "";
      for (let R = 0; R < n; R++) {
        let P, L, z, Y, te = f[R + i];
        128 & te ? (224 & te) == 192 ? R + 1 >= n ? A += T : (P = f[R + i + 1], (192 & P) != 128 ? A += T : (Y = (31 & te) << 6 | 63 & P, Y < 128 ? A += T : (A += o(Y), R++))) : (240 & te) == 224 ? R + 2 >= n ? A += T : (P = f[R + i + 1], L = f[R + i + 2], (49344 & (P | L << 8)) != 32896 ? A += T : (Y = (15 & te) << 12 | (63 & P) << 6 | 63 & L, Y < 2048 || Y >= 55296 && Y <= 57343 ? A += T : (A += o(Y), R += 2))) : (248 & te) == 240 ? R + 3 >= n ? A += T : (P = f[R + i + 1], L = f[R + i + 2], z = f[R + i + 3], (12632256 & (P | L << 8 | z << 16)) != 8421504 ? A += T : (Y = (7 & te) << 18 | (63 & P) << 12 | (63 & L) << 6 | 63 & z, Y < 65536 || Y > 1114111 ? A += T : (Y -= 65536, A += o(55296 + (Y >> 10), 56320 + (1023 & Y)), R += 3))) : A += T : A += o(te);
      }
      return A;
    }
    function dl(e, n) {
      let i = n.length, o = 0;
      for (let A = 0; A < i; A++) {
        let R = n.charCodeAt(A);
        R >= 55296 && R <= 56319 && A + 1 < i && (R = (R << 10) + n.charCodeAt(++A) - 56613888), o += R < 128 ? 1 : R < 2048 ? 2 : R < 65536 ? 3 : 4;
      }
      Ui(e, o);
      let f = n0(e, o), T = e.bytes;
      for (let A = 0; A < i; A++) {
        let R = n.charCodeAt(A);
        R >= 55296 && R <= 56319 && A + 1 < i && (R = (R << 10) + n.charCodeAt(++A) - 56613888), R < 128 ? T[f++] = R : (R < 2048 ? T[f++] = R >> 6 & 31 | 192 : (R < 65536 ? T[f++] = R >> 12 & 15 | 224 : (T[f++] = R >> 18 & 7 | 240, T[f++] = R >> 12 & 63 | 128), T[f++] = R >> 6 & 63 | 128), T[f++] = 63 & R | 128);
      }
    }
    function dc(e) {
      return e.bytes[p7(e, 1)];
    }
    function E7(e, n) {
      let i = n0(e, 1);
      e.bytes[i] = n;
    }
    function qE(e) {
      let n, i = 0, o = 0;
      do
        n = dc(e), i < 32 && (o |= (127 & n) << i), i += 7;
      while (128 & n);
      return o;
    }
    function Ui(e, n) {
      for (n >>>= 0; n >= 128; ) E7(e, 127 & n | 128), n >>>= 7;
      E7(e, n);
    }
    function Fae(e, n) {
      let i, o = 0, f = 0, T = 0;
      return i = dc(e), o = 127 & i, 128 & i && (i = dc(e), o |= (127 & i) << 7, 128 & i && (i = dc(e), o |= (127 & i) << 14, 128 & i && (i = dc(e), o |= (127 & i) << 21, 128 & i && (i = dc(e), f = 127 & i, 128 & i && (i = dc(e), f |= (127 & i) << 7, 128 & i && (i = dc(e), f |= (127 & i) << 14, 128 & i && (i = dc(e), f |= (127 & i) << 21, 128 & i && (i = dc(e), T = 127 & i, 128 & i && (i = dc(e), T |= (127 & i) << 7))))))))), { low: o | f << 28, high: f >>> 4 | T << 24, unsigned: n };
    }
    function ll(e, n) {
      let i = n.low >>> 0, o = (n.low >>> 28 | n.high << 4) >>> 0, f = n.high >>> 24, T = f === 0 ? o === 0 ? i < 16384 ? i < 128 ? 1 : 2 : i < 1 << 21 ? 3 : 4 : o < 16384 ? o < 128 ? 5 : 6 : o < 1 << 21 ? 7 : 8 : f < 128 ? 9 : 10, A = n0(e, T), R = e.bytes;
      switch (T) {
        case 10:
          R[A + 9] = f >>> 7 & 1;
        case 9:
          R[A + 8] = T !== 9 ? 128 | f : 127 & f;
        case 8:
          R[A + 7] = T !== 8 ? o >>> 21 | 128 : o >>> 21 & 127;
        case 7:
          R[A + 6] = T !== 7 ? o >>> 14 | 128 : o >>> 14 & 127;
        case 6:
          R[A + 5] = T !== 6 ? o >>> 7 | 128 : o >>> 7 & 127;
        case 5:
          R[A + 4] = T !== 5 ? 128 | o : 127 & o;
        case 4:
          R[A + 3] = T !== 4 ? i >>> 21 | 128 : i >>> 21 & 127;
        case 3:
          R[A + 2] = T !== 3 ? i >>> 14 | 128 : i >>> 14 & 127;
        case 2:
          R[A + 1] = T !== 2 ? i >>> 7 | 128 : i >>> 7 & 127;
        case 1:
          R[A] = T !== 1 ? 128 | i : 127 & i;
      }
    }
    const y7 = {}, v7 = {}, r0 = 4294967296, Gae = r0 * r0, Vae = Gae / 2;
    b7(0, !0);
    const T7 = b7(0), Yae = KE(0, -2147483648, !1), Xae = KE(-1, 2147483647, !1);
    function b7(e, n) {
      let i, o, f;
      return n ? (f = 0 <= (e >>>= 0) && e < 256) && (o = v7[e], o) ? o : (i = KE(e, 0, !0), f && (v7[e] = i), i) : (f = -128 <= (e |= 0) && e < 128) && (o = y7[e], o) ? o : (i = KE(e, e < 0 ? -1 : 0, !1), f && (y7[e] = i), i);
    }
    function KE(e, n, i) {
      return { low: 0 | e, high: 0 | n, unsigned: !!i };
    }
    function A7(e, n) {
      if (isNaN(e)) return T7;
      {
        if (e <= -9223372036854776e3) return Yae;
        if (e + 1 >= Vae) return Xae;
      }
      return e < 0 ? T7 : KE(e % r0 | 0, e / r0 | 0, n);
    }
    function O7(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    class WI extends ii {
      get connectionState() {
        return this._connectionState;
      }
      set connectionState(n) {
        if (this._connectionState === n) return;
        const i = this._connectionState;
        this._connectionState = n, this.emit(Uc.CONNECTION_STATE_CHANGE, n, i);
      }
      get quality() {
        return this._quality;
      }
      set quality(n) {
        this._quality = n > 1 ? 1 : n < 0.1 ? 0.1 : n, this._qualityTimer && (window.clearTimeout(this._qualityTimer), this._qualityTimer = null), this._quality >= 1 || (this._qualityTimer = window.setTimeout(() => {
          this.quality = this._quality / this._qualityRatio;
        }, 6e4));
      }
      constructor(n) {
        var i;
        super(), Ve(this, "name", "AgoraRTCImageModeration"), Ve(this, "_connectionState", _o.CONNECTING), Ve(this, "_sequence", 0), Ve(this, "_moderationStartTime", void 0), Ve(this, "_workerConnection", void 0), Ve(this, "_workerMessageLengthLimit", void 0), Ve(this, "_qualityRatio", void 0), Ve(this, "_connectInfo", void 0), Ve(this, "_cancelTokenSource", fa.CancelToken.source()), Ve(this, "_retryConfig", void 0), Ve(this, "_moderationInterval", void 0), Ve(this, "_moderationTimer", null), Ve(this, "_moderationMode", 1), Ve(this, "_quality", 1), Ve(this, "_qualityTimer", null), Ve(this, "_ticket", void 0), Ve(this, "_moderationIntervalMinimum", void 0), Ve(this, "_uploadFailedNum", 0), Ve(this, "_uploadNum", 0), Ve(this, "_uploadTimer", null), Ve(this, "_extraInfo", void 0), Ve(this, "_vendor", ""), Ve(this, "_encoder", new TextEncoder()), Ve(this, "_moderationId", void 0), Ve(this, "inspectImage", () => {
          if (this.connectionState !== _o.CONNECTED) throw new jt(Je.OPERATION_ABORTED, "image moderation service connection status is ".concat(this.connectionState));
          this._moderationTimer && (window.clearInterval(this._moderationTimer), this._moderationTimer = null), this._moderationTimer = window.setInterval(() => {
            this.connectionState === _o.CONNECTED ? this.requestToInspectImage() : Ee.debug("[".concat(this._moderationId, "] Moderation State is not connected , "), this.connectionState);
          }, this._moderationInterval < this._moderationIntervalMinimum ? this._moderationIntervalMinimum : this._moderationInterval), this.requestToInspectImage();
        }), this._moderationId = zr(5, "image-moderation-"), this._workerMessageLengthLimit = ft("IMAGE_MODERATION_WORKER_MESSAGE_LENGTH_LIMIT"), this._moderationIntervalMinimum = ft("IMAGE_MODERATION_INTERVAL_MINIMUM"), this._moderationInterval = (i = n.interval) !== null && i !== void 0 ? i : 1e3, n.extraInfo && (this._extraInfo = this._encoder.encode(n.extraInfo)), n.vendor && (this._vendor = n.vendor), this._qualityRatio = ft("IMAGE_MODERATION_QUALITY_RATIO"), this._moderationStartTime = Number(Date.now()), this._workerConnection = new HE("worker-" + this._moderationId, zi), this.on(Uc.STATE_CHANGE, (o, f) => {
          Ee.debug("[".concat(this._moderationId, "] Moderation operation :").concat(vp[o], " ").concat(f || ""));
        }), this.handleWorkerEvents();
      }
      async init(n, i) {
        this.emit(Uc.STATE_CHANGE, vp.CONNECT_AP), this._connectInfo = n;
        const o = this._cancelTokenSource.token;
        return this._retryConfig = i, new cn((f, T) => {
          this.on(Uc.CONNECTION_STATE_CHANGE, (A, R) => {
            A === _o.CONNECTED && f();
          }), this.requestAP(n, o, i).then((A) => {
            this.connectWorker(A);
          }).catch((A) => {
            T(A);
          });
        });
      }
      updateConfig(n) {
        var i;
        this._moderationInterval = (i = n.interval) !== null && i !== void 0 ? i : 1e3, n.extraInfo && (this._extraInfo = this._encoder.encode(n.extraInfo)), n.vendor && (this._vendor = n.vendor), Ee.debug("[".concat(this._moderationId, "] updateConfig: ").concat(JSON.stringify(n))), this.connectionState === _o.CONNECTED && this.inspectImage();
      }
      async requestAP(n, i, o) {
        const f = ft("WEBCS_DOMAIN").map((P) => "https://".concat(P, "/api/v1")), T = await function(P, L, z, Y) {
          let { appId: te, areaCode: oe, cname: He, sid: Re, token: De, uid: Xe } = L;
          Ip++;
          const We = "moderation_plugin", mt = { service_name: We, json_body: JSON.stringify({ appId: te, areaCode: oe, cname: He, command: "allocateEdge", requestId: Ip, seq: Ip, sid: Re, appToken: De, ts: Date.now(), uid: Xe + "" }) };
          let Pt, xt, Nt = P[0];
          return jc(async () => {
            Pt = Date.now();
            const Vt = await Hc(Nt, { data: mt, cancelToken: z, headers: { "X-Packet-Service-Type": "0", "X-Packet-URI": "61" }, params: { action: "wrtc_gateway" } });
            if (xt = Date.now() - Pt, Vt.code !== 0) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "moderation plugin ap error, code" + Vt.code, { retry: !0, responseTime: xt });
              throw Ee.error(hn.toString()), hn;
            }
            const nn = JSON.parse(Vt.json_body);
            if (nn.code !== 200) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "moderation plugin ap error, code: ".concat(nn.code, ", reason: ").concat(nn.reason), { code: nn.code, responseTime: xt });
              throw Ee.error(hn.toString()), hn;
            }
            if (!nn.servers || !Array.isArray(nn.servers) || nn.servers.length === 0) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "moderation plugin ap empty server", { code: nn.code, responseTime: xt });
              throw Ee.error(hn.toString()), hn;
            }
            if (!nn.servers.some((hn) => !!hn.wss)) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "moderation plugin ap empty port", { code: nn.code, responseTime: xt });
              throw Ee.error(hn.toString()), hn;
            }
            const fn = ft("IMAGE_MODERATION_WORKER_HOST");
            return { addressList: nn.servers.map((hn) => {
              let { address: ir, wss: sr } = hn;
              if (ir && sr) return "wss://".concat(ir.replace(/\./g, "-"), ".").concat(fn, ":").concat(sr, "/moderation");
            }).filter((hn) => !!hn), workerToken: nn.workerToken, vid: nn.vid, ticket: nn.appTicket, responseTime: xt };
          }, (Vt, nn) => (Cn.apworkerEvent(Re, { success: !0, sc: 200, serviceName: We, responseDetail: JSON.stringify(Vt.addressList), firstSuccess: nn === 0, responseTime: xt, serverIp: P[nn % P.length] }), !1), (Vt, nn) => (Cn.apworkerEvent(Re, { success: !1, sc: Vt.data && Vt.data.code || 200, serviceName: We, responseTime: xt, serverIp: P[nn % P.length] }), !!(Vt.code !== Je.OPERATION_ABORTED && Vt.code !== Je.UNEXPECTED_RESPONSE || Vt.data && Vt.data.retry) && (Nt = P[(nn + 1) % P.length], !0)), Y);
        }(f, n, i, o);
        this.emit(Uc.STATE_CHANGE, vp.AP_CONNECTED);
        const { addressList: A, ticket: R } = T;
        return this._ticket = R, A;
      }
      async connectWorker(n) {
        this.emit(Uc.STATE_CHANGE, vp.CONNECT_WORKER), await this._workerConnection.init(n, 1e4);
      }
      handleWorkerEvents() {
        this._workerConnection.on(Fn.CONNECTED, async () => {
          this.emit(Uc.STATE_CHANGE, vp.WORKER_CONNECTED, this._workerConnection.url), this.connectionState = _o.CONNECTED;
        }), this._workerConnection.on(Fn.CLOSED, () => {
          this.connectionState = _o.CLOSED;
        }), this._workerConnection.on(Fn.FAILED, () => {
          this.connectionState = _o.CLOSED;
        }), this._workerConnection.on(Fn.RECONNECTING, () => {
          this.connectionState = this.connectionState === _o.CONNECTED ? _o.RECONNECTING : _o.CONNECTING;
        }), this._workerConnection.on(Fn.ON_MESSAGE, async (n) => {
          if (n.data instanceof ArrayBuffer) {
            const i = Uae(new Uint8Array(n.data));
            ft("SHOW_IMAGE_MODERATION_WORKER_MESSAGE") && Ee.debug("[".concat(this._moderationId, "] Response message for worker of image moderation "), JSON.stringify(i)), this._uploadNum++, i.code === void 0 || i.code === 0 || (this._uploadFailedNum++, Ee.error("[".concat(this._moderationId, "] Error response from worke, code is ").concat(i.code, ", msg is ").concat(i.msg)), this._uploadTimer || (this._uploadTimer = window.setTimeout(() => {
              Cn.reportApiInvoke(this._connectInfo.sid || null, { name: Bi.IMAGE_MODERATION_UPLOAD, options: [this._uploadFailedNum, this._uploadNum, i.code], tag: si.TRACER }).onError(new jt(Je.IMAGE_MODERATION_UPLOAD_FAILED, i.msg)), this._uploadTimer = null;
            }, ft("IMAGE_MODERATION_UPLOAD_REPORT_INTERVAL"))));
          } else Ee.error("[".concat(this._moderationId, "] Unexpected message type from worker"));
        }), this._workerConnection.on(Fn.WILL_RECONNECT, (n, i, o) => {
          n === "recover" && o(n), o("tryNext");
        }), this._workerConnection.on(Fn.REQUEST_NEW_URLS, (n, i) => {
          this.requestAP(this._connectInfo, this._cancelTokenSource.token, this._retryConfig).then(n).catch(i);
        });
      }
      static intToLong(n) {
        return { low: n |= 0, high: n >> 31, unsigned: n >= 0 };
      }
      async requestToInspectImage() {
        const n = to(this, Uc.CLIENT_LOCAL_VIDEO_TRACK), i = { appId: this._connectInfo.appId, cname: this._connectInfo.cname, cid: this._connectInfo.cid, sid: this._connectInfo.sid, uid: this._connectInfo.uid, vid: this._connectInfo.vid };
        if (n) {
          if (!n.isPlaying) return void (ft("SHOW_IMAGE_MODERATION_WORKER_MESSAGE") && Ee.debug("Only the track being played can be inspected"));
          this._sequence++;
          const o = await this.generateRequestData(n, i);
          this._workerConnection.sendMessage(o, !0, !0);
        } else ft("SHOW_IMAGE_MODERATION_WORKER_MESSAGE") && Ee.debug("Only the track being published can be inspected");
      }
      async generateRequestData(n, i) {
        let { appId: o, cname: f, cid: T, vid: A, sid: R, uid: P } = i;
        const L = Date.now(), z = await n.getCurrentFrameImage("image/jpeg", this.quality), Y = await $5(z, o, f), te = this._sequence + "-" + T + "-" + P + "-" + L + "-" + zr(12, ""), oe = { appId: o, cid: T, cname: f, deviceId: "", elapse: WI.intToLong(Number(L - this._moderationStartTime)), fileSize: z.buffer.byteLength, height: z.height, width: z.width, jpg: Y, networkType: 6, osType: 7, requestId: te, sdkVersion: "4.23.0", sequence: this._sequence, sid: R, timestamp: A7(L), uid: P, vid: A, service: this._moderationMode, ticket: this._ticket, callbackData: this._extraInfo, vendorConfigs: this._vendor };
        this._extraInfo === void 0 && delete oe.callbackData;
        const He = jae(oe);
        if (He.byteLength < this._workerMessageLengthLimit) {
          if (ft("SHOW_IMAGE_MODERATION_WORKER_MESSAGE")) {
            const Re = function(De) {
              for (var Xe = 1; Xe < arguments.length; Xe++) {
                var We = arguments[Xe] != null ? arguments[Xe] : {};
                Xe % 2 ? O7(Object(We), !0).forEach(function(mt) {
                  Ve(De, mt, We[mt]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(De, Object.getOwnPropertyDescriptors(We)) : O7(Object(We)).forEach(function(mt) {
                  Object.defineProperty(De, mt, Object.getOwnPropertyDescriptor(We, mt));
                });
              }
              return De;
            }({}, oe);
            delete Re.jpg, Ee.debug("[".concat(this._moderationId, "] Request message for worker of image moderation service: "), JSON.stringify(Re));
          }
          return He;
        }
        {
          const Re = this.quality * this._qualityRatio;
          return this.quality = Re, await this.generateRequestData(n, { appId: o, cname: f, cid: T, vid: A, sid: R, uid: P });
        }
      }
      close() {
        this._cancelTokenSource.cancel(), this._cancelTokenSource = fa.CancelToken.source(), this._workerConnection && this._workerConnection.close(), this._moderationTimer && window.clearInterval(this._moderationTimer), this._moderationTimer = null, this._uploadTimer && window.clearTimeout(this._uploadTimer), this._uploadTimer = null, this.connectionState = _o.CLOSED, this.emit(Uc.STATE_CHANGE, vp.CLOSED);
      }
    }
    function C7(e) {
      if (xr(e.interval, "interval", 1e3, 1 / 0), e && e.extraInfo && e.extraInfo.length > 1024) throw new jt(Je.INVALID_PARAMS, "config.extraInfo length cannot exceed 1024 bytes");
      if (e && e.vendor && e.vendor.length > 1024) throw new jt(Je.INVALID_PARAMS, "config.vendor length cannot exceed 1024 bytes");
    }
    const Wae = { name: "ImageModeration", create: function(e) {
      let { config: n } = e;
      return C7(n), new WI(n);
    } };
    var S7, I7, R7, N7, w7, _7, P7, x7, D7, M7, L7, k7, j7, U7, H7, B7, z7, F7, G7, V7, Y7, X7, W7, q7, K7, J7, Z7, Q7, $7, ek, tk, nk, rk, ik, sk, ak, ok, ck, uk, dk, lk, ln;
    function fk(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function lc(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? fk(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : fk(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    xs.setLogger(Ee);
    let qae = (S7 = Dn(), I7 = Dn({ argsMap: (e, n) => {
      if (!Array.isArray(n)) {
        if (!(n instanceof hp)) return [n];
        n = [n];
      }
      return n.map((i) => i ? Object(i).toString() : "null");
    } }), R7 = Dn({ argsMap: (e, n) => (n || (n = []), Array.isArray(n) || n.trackMediaType !== fp.DATA ? (Array.isArray(n) || (n = [n]), n.map((i) => i.getTrackId())) : [n.getChannelId()]) }), N7 = Dn({ argsMap: (e, n, i, o) => [typeof n == "object" ? n.uid : n, i, o] }), w7 = Dn({ argsMap: (e, n, i) => [n, i] }), _7 = Dn({ argsMap: (e, n) => n.map((i) => {
      let { user: o, mediaType: f } = i;
      return [o == null ? void 0 : o.uid, f];
    }) }), P7 = Dn({ argsMap: (e, n, i, o) => [typeof n == "object" ? n.uid : n, i, o] }), x7 = Dn({ argsMap: (e, n) => n.map((i) => {
      let { user: o, mediaType: f } = i;
      return { uid: o == null ? void 0 : o.uid, mediaType: f };
    }) }), D7 = Dn(), M7 = Dn(), L7 = Dn(), k7 = Dn(), j7 = Dn(), U7 = Dn(), H7 = Dn(), B7 = Dn(), z7 = Dn(), F7 = Dn(), G7 = Dn(), V7 = Dn(), Y7 = Dn(), X7 = Dn(), W7 = Dn(), q7 = Dn({ argsMap: (e, n) => [n] }), K7 = Dn(), J7 = Dn(), Z7 = Dn(), Q7 = Dn(), $7 = Dn(), ek = Dn(), tk = Dn(), nk = Dn(), rk = Dn({ argsMap: (e, n) => (Array.isArray(n) || (n = [n]), [JSON.stringify(n)]) }), ik = Dn(), sk = Dn(), ak = Dn(), ok = Dn(), ck = Dn(), uk = Dn(), dk = Dn({ reportResult: !0 }), lk = Dn(), ln = class extends ii {
      get connectionState() {
        return this._gateway.state;
      }
      get remoteUsers() {
        return this._users;
      }
      get localTracks() {
        return this._p2pChannel.getAllTracks(!0);
      }
      get uid() {
        return this._uid;
      }
      get channelName() {
        return this._channelName;
      }
      get localDataChannels() {
        return this._p2pChannel.getAllDataChannels();
      }
      get mode() {
        return this._config.mode;
      }
      get role() {
        var e;
        return ((e = this._config) === null || e === void 0 ? void 0 : e.role) || "audience";
      }
      get codec() {
        return this._config.codec;
      }
      get audioCodec() {
        return this._config.audioCodec || "opus";
      }
      get isStringUID() {
        return !!this._joinInfo && !!this._joinInfo.stringUid;
      }
      get __className__() {
        return "Client";
      }
      constructor(e, n) {
        let i;
        if (super(), Ve(this, "store", void 0), Ve(this, "_uid", void 0), Ve(this, "_channelName", void 0), Ve(this, "_uintUid", void 0), Ve(this, "_users", []), Ve(this, "_config", void 0), Ve(this, "_clientId", void 0), Ve(this, "_appId", void 0), Ve(this, "_sessionId", null), Ve(this, "_key", void 0), Ve(this, "_rtmConfig", {}), Ve(this, "_joinInfo", void 0), Ve(this, "_gateway", void 0), Ve(this, "_statsCollector", void 0), Ve(this, "_configDistribute", void 0), Ve(this, "_leaveMutex", void 0), Ve(this, "_publishMutex", void 0), Ve(this, "_renewTokenMutex", void 0), Ve(this, "_subscribeMutex", void 0), Ve(this, "_encryptionMode", "none"), Ve(this, "_encryptionSecret", null), Ve(this, "_encryptionSalt", null), Ve(this, "_encryptDataStream", !1), Ve(this, "_encryptDataStreamKey", null), Ve(this, "_encryptDataStreamIv", null), Ve(this, "_proxyServer", void 0), Ve(this, "_turnServer", { servers: [], mode: "auto" }), Ve(this, "_cloudProxyServerMode", "disabled"), Ve(this, "_isDualStreamEnabled", !1), Ve(this, "_defaultStreamFallbackType", void 0), Ve(this, "_lowStreamParameter", void 0), Ve(this, "_streamFallbackTypeCacheMap", /* @__PURE__ */ new Map()), Ve(this, "_remoteStreamTypeCacheMap", /* @__PURE__ */ new Map()), Ve(this, "_axiosCancelSource", fa.CancelToken.source()), Ve(this, "_audioVolumeIndicationInterval", void 0), Ve(this, "_networkQualityInterval", void 0), Ve(this, "_userOfflineTimeout", void 0), Ve(this, "_streamRemovedTimeout", void 0), Ve(this, "_liveTranscodeStreamingClient", void 0), Ve(this, "_liveRawStreamingClient", void 0), Ve(this, "_channelMediaRelayClient", void 0), Ve(this, "_networkQualitySensitivity", "normal"), Ve(this, "_p2pChannel", void 0), Ve(this, "_useLocalAccessPoint", !1), Ve(this, "_setLocalAPVersion", void 0), Ve(this, "_joinAndNotLeaveYet", !1), Ve(this, "_numberOfJoinCount", 0), Ve(this, "_remoteDefaultVideoStreamType", void 0), Ve(this, "_inspect", void 0), Ve(this, "_moderation", void 0), Ve(this, "_license", void 0), Ve(this, "_pendingPublishedUsers", []), Ve(this, "ntpAlignErrorCount", 0), Ve(this, "remoteInboundOffset", 0), Ve(this, "_peerConnectionState", void 0), Ve(this, "_handleLocalTrackEnable", (f, T, A) => {
          this.publish(f, !1).then(T).catch(A);
        }), Ve(this, "_handleLocalTrackDisable", (f, T, A) => {
          this.unpublish(f).then(T).catch(A);
        }), Ve(this, "_handleUserOnline", (f) => {
          if (ft("BLOCK_LOCAL_CLIENT") && If(f.uid, this.channelName)) return void Ee.debug("[".concat(f.uid, "] will be ignored in local"));
          this.isStringUID && typeof f.uid != "string" && Ee.error("[".concat(this._clientId, "] StringUID is Mixed with UintUID"));
          const T = this._users.find((A) => A.uid === f.uid);
          if (T) T._trust_in_room_ = !0, T._is_pre_created && (T._is_pre_created = !1, this.safeEmit(rr.USER_JOINED, T));
          else {
            const A = new cl(f.uid, f.uint_id || f.uid);
            this._users.push(A), Ee.debug("[".concat(this._clientId, "] user online"), f.uid), this.safeEmit(rr.USER_JOINED, A);
          }
        }), Ve(this, "_handleUserOffline", (f) => {
          if (ft("BLOCK_LOCAL_CLIENT") && If(f.uid, this.channelName)) return;
          const T = this._users.find((A) => A.uid === f.uid);
          T && (this._handleRemoveStream(f), this._handleRemoveDataChannels(f), T._audio_pre_subscribed || T._video_pre_subscribed ? T._is_pre_created = !0 : dT(this._users, T), this._remoteStreamTypeCacheMap.delete(T.uid), this._streamFallbackTypeCacheMap.delete(T.uid), Ee.debug("[".concat(this._clientId, "] user offline"), f.uid, "reason:", f.reason), this.safeEmit(rr.USER_LEAVED, T, f.reason));
        }), Ve(this, "_handleAddAudioOrVideoStream", (f, T, A, R, P, L, z) => {
          if (ft("BLOCK_LOCAL_CLIENT") && If(T, this.channelName)) return;
          const Y = this._users.find((oe) => oe.uid === T);
          if (!Y) return void Ee.error("[".concat(this._clientId, "] can not find target user!(on_add_stream)"));
          Ee.debug("[".concat(this._clientId, "] stream added with uid ").concat(T, ", type ").concat(f)), this.store.subscribe(Y.uid, f, void 0, void 0, void 0, Date.now());
          const te = f === "audio" ? Y.hasAudio : Y.hasVideo;
          Y._uintid || (Y._uintid = P || T), f === "audio" ? Y._trust_audio_stream_added_state_ = !0 : Y._trust_video_stream_added_state_ = !0, f === "audio" ? (Y._audio_added_ = !0, A !== void 0 && (Y._audioSSRC = A), R !== void 0 && (Y._cname = R), L && (Y._audioOrtc = L)) : (Y._video_added_ = !0, A !== void 0 && (Y._videoSSRC = A), R !== void 0 && (Y._cname = R), z !== void 0 && (Y._rtxSsrcId = z), L && (Y._videoOrtc = L)), (f === "audio" ? Y.hasAudio : Y.hasVideo) && !te && (Ee.info("[".concat(this._clientId, "] remote user ").concat(Y.uid, " published ").concat(f)), this.safeEmit(rr.USER_PUBLISHED, Y, f)), f === "video" ? Cn.onGatewayStream(this._sessionId, us.ON_ADD_VIDEO_STREAM, ti.ON_ADD_VIDEO_STREAM, { peer: P || T, ssrc: Y._videoSSRC }) : Cn.onGatewayStream(this._sessionId, us.ON_ADD_AUDIO_STREAM, ti.ON_ADD_AUDIO_STREAM, { peer: P || T, ssrc: Y._audioSSRC }), this._p2pChannel.remoteMediaSsrcChanged(Y, f, A).then((oe) => {
            if (oe && (Ee.debug("[".concat(this._clientId, "] resubscribe ").concat(f, " for user ").concat(Y.uid, " after rejoin because SSRC id changed.")), this._p2pChannel instanceof QT)) return this._p2pChannel.unsubscribe(Y, f, !0).then(() => this._subscribe(Y, f, !0).catch((He) => {
              Ee.error("[".concat(this._clientId, "] resubscribe error"), He.toString());
            }));
          }), this._p2pChannel.hasPendingRemoteMedia(Y, f) && (Ee.debug("[".concat(this._clientId, "] resubscribe ").concat(f, " for user ").concat(Y.uid, " after reconnect.")), this._subscribe(Y, f, !0).catch((oe) => {
            Ee.error("[".concat(this._clientId, "] resubscribe error"), oe.toString());
          }));
        }), Ve(this, "_handleRemoveStream", (f) => {
          if (ft("BLOCK_LOCAL_CLIENT") && If(f.uid, this.channelName)) return;
          const T = this._users.find((R) => R.uid === f.uid);
          if (!T) return void Ee.warning("[".concat(this._clientId, "] can not find target user!(on_remove_stream)"));
          Ee.debug("[".concat(this._clientId, "] stream removed with uid ").concat(f.uid));
          let A = () => {
          };
          T.hasAudio && T.hasVideo ? A = () => {
            Ee.info("[".concat(this._clientId, "] remote user ").concat(T.uid, " unpublished audio track")), this.safeEmit(rr.USER_UNPUBLISHED, T, "audio"), Ee.info("[".concat(this._clientId, "] remote user ").concat(T.uid, " unpublished video track")), this.safeEmit(rr.USER_UNPUBLISHED, T, "video");
          } : T.hasVideo ? A = () => {
            Ee.info("[".concat(this._clientId, "] remote user ").concat(T.uid, " unpublished video track")), this.safeEmit(rr.USER_UNPUBLISHED, T, "video");
          } : T.hasAudio && (A = () => {
            Ee.info("[".concat(this._clientId, "] remote user ").concat(T.uid, " unpublished audio track")), this.safeEmit(rr.USER_UNPUBLISHED, T, "audio");
          }), T._video_pre_subscribed || T._audio_pre_subscribed || (T._trust_audio_stream_added_state_ = !0, T._trust_video_stream_added_state_ = !0, T._audio_added_ = !1, T._video_added_ = !1, this._p2pChannel instanceof QT && this._p2pChannel.unsubscribe(T).then((R) => {
            if (R) return this._gateway.unsubscribe(R, T.uid);
          }), T._audioSSRC = void 0, T._videoSSRC = void 0, T._audioOrtc = void 0, T._videoOrtc = void 0, T._rtxSsrcId = void 0), Cn.onGatewayStream(this._sessionId, us.ON_REMOVE_STREAM, ti.ON_REMOVE_STREAM, { peer: f.uint_id || f.uid }), A();
        }), Ve(this, "_handleSetStreamLocalEnable", (f, T, A) => {
          if (ft("BLOCK_LOCAL_CLIENT") && If(T, this.channelName)) return;
          const R = this._users.find((z) => z.uid === T);
          if (!R) return void Ee.error("[".concat(this._clientId, "] can not find target user!(disable_local)"));
          Ee.debug("[".concat(this._clientId, "] local ").concat(f, " ").concat(A ? "enabled" : "disabled", " with uid ").concat(T));
          const P = f === "audio" ? R.hasAudio : R.hasVideo;
          if (f === "audio") {
            R._trust_audio_enabled_state_ = !0;
            const z = R._audio_enabled_;
            if (R._audio_enabled_ = A, R._audio_enabled_ === z) return;
            {
              const Y = R._audio_enabled_ ? "enable-local-audio" : "disable-local-audio";
              Ee.debug("[".concat(this._clientId, "] user-info-updated, uid: ").concat(T, ", msg: ").concat(Y)), this.safeEmit(rr.USER_INFO_UPDATED, T, Y);
            }
          } else {
            R._trust_video_enabled_state_ = !0;
            const z = R._video_enabled_;
            if (R._video_enabled_ = A, R._video_enabled_ === z) return;
            {
              const Y = R._video_enabled_ ? "enable-local-video" : "disable-local-video";
              Ee.debug("[".concat(this._clientId, "] user-info-update, uid: ").concat(T, ", msg: ").concat(Y)), this.safeEmit(rr.USER_INFO_UPDATED, T, Y);
            }
          }
          const L = f === "audio" ? R.hasAudio : R.hasVideo;
          return P !== L ? !P && L ? (Ee.info("[".concat(this._clientId, "] remote user ").concat(T, " published ").concat(f)), void this.safeEmit(rr.USER_PUBLISHED, R, f)) : (f === "video" && R._videoTrack && R._videoTrack._destroy(), f === "audio" && R._audioTrack, this._p2pChannel.muteRemote(R, f), Ee.info("[".concat(this._clientId, "] remote user ").concat(T, " unpublished ").concat(f)), void this.safeEmit(rr.USER_UNPUBLISHED, R, f)) : void 0;
        }), Ve(this, "_handleMuteStream", (f, T, A) => {
          if (ft("BLOCK_LOCAL_CLIENT") && If(f, this.channelName)) return;
          Ee.debug("[".concat(this._clientId, "] receive mute message"), f, T, A);
          const R = this._users.find((z) => z.uid === f);
          if (!R) return void Ee.warning("[".concat(this._clientId, "] can not find remote user, ignore mute event, uid: ").concat(f));
          const P = T === "audio" ? R.hasAudio : R.hasVideo;
          if (T === "audio") {
            R._trust_audio_mute_state_ = !0;
            const z = R._audio_muted_;
            if (R._audio_muted_ = A, R._audio_muted_ === z) return;
            {
              const Y = R._audio_muted_ ? "mute-audio" : "unmute-audio";
              Ee.debug("[".concat(this._clientId, "] user-info-update, uid: ").concat(f, ", msg: ").concat(Y)), this.safeEmit(rr.USER_INFO_UPDATED, f, Y);
            }
          } else {
            R._trust_video_mute_state_ = !0;
            const z = R._video_muted_;
            if (R._video_muted_ = A, R._video_muted_ === z) return;
            {
              const Y = R._video_muted_ ? "mute-video" : "unmute-video";
              Ee.debug("[".concat(this._clientId, "] user-info-update, uid: ").concat(f, ", msg: ").concat(Y)), this.safeEmit(rr.USER_INFO_UPDATED, f, Y);
            }
          }
          const L = T === "audio" ? R.hasAudio : R.hasVideo;
          if (P !== L) {
            if (!P && L)
              return (T === "audio" ? R._audioSSRC : R._videoSSRC) ? (Ee.info("[".concat(this._clientId, "] remote user ").concat(f, " published ").concat(T)), void this.safeEmit(rr.USER_PUBLISHED, R, T)) : void Ee.warning("[".concat(this._clientId, "] remote user ").concat(f, " receive ").concat(T, " unmute message  before add stream message, ").concat(T, " SSRC doesn't exist yet."));
            T === "video" && R._videoTrack && !R._video_pre_subscribed && R._videoTrack._destroy(), T === "audio" && R._audioTrack, this._p2pChannel.muteRemote(R, T), Ee.info("[".concat(this._clientId, "] remote user ").concat(f, " unpublished ").concat(T)), this.safeEmit(rr.USER_UNPUBLISHED, R, T);
          }
        }), Ve(this, "_handleP2PLost", async (f) => {
          Ee.debug("[".concat(this._clientId, "] receive p2p lost"), f), parseInt(f.p2pid, 10) === this.store.p2pId ? await this._p2pChannel.requestReconnect() : Ee.warning("[".concat(this._clientId, "] P2PLost stream not found"), f);
        }), Ve(this, "_handleTokenWillExpire", () => {
          Ee.debug("[".concat(this._clientId, "] received message onTokenPrivilegeWillExpire")), this.safeEmit(rr.ON_TOKEN_PRIVILEGE_WILL_EXPIRE);
        }), Ve(this, "_handleBeforeUnload", (f) => {
          f.type === "beforeunload" && f.returnValue !== void 0 && f.returnValue !== "" || (this.leave(), Ee.info("[".concat(this._clientId, "] auto leave onbeforeunload or pagehide")));
        }), Ve(this, "_handleUpdateNetworkQuality", () => {
          if (this._networkQualitySensitivity === "normal") return;
          if (navigator && navigator.onLine !== void 0 && !navigator.onLine) return void this.safeEmit(rr.NETWORK_QUALITY, { downlinkNetworkQuality: 6, uplinkNetworkQuality: 6 });
          const f = { downlinkNetworkQuality: 0, uplinkNetworkQuality: 0 };
          f.uplinkNetworkQuality = this._p2pChannel.getUplinkNetworkQuality(), f.downlinkNetworkQuality = this._p2pChannel.getDownlinkNetworkQuality(), this.safeEmit(rr.NETWORK_QUALITY, f);
        }), Ve(this, "_handleP2PAddAudioOrVideoStream", (f, T, A, R) => {
          const P = this._users.find((z) => z.uid === T);
          if (!P) return void Ee.error("[".concat(this._clientId, "] can not find target user!(on_add_stream)"));
          Ee.debug("[".concat(this._clientId, "] stream added with uid ").concat(T, ", type ").concat(f)), this.store.subscribe(P.uid, f, void 0, void 0, void 0, Date.now());
          const L = f === "audio" ? P.hasAudio : P.hasVideo;
          f === "audio" ? P._trust_audio_stream_added_state_ = !0 : P._trust_video_stream_added_state_ = !0, f === "audio" ? (P._audio_added_ = !0, A !== void 0 && (P._audioSSRC = A), R !== void 0 && (P._audioMid = R)) : (P._video_added_ = !0, A !== void 0 && (P._videoSSRC = A), R !== void 0 && (P._videoMid = R)), (f === "audio" ? P.hasAudio : P.hasVideo) && !L && (Ee.info("[".concat(this._clientId, "] remote user ").concat(P.uid, " published ").concat(f)), this.safeEmit(rr.USER_PUBLISHED, P, f)), this._p2pChannel.hasPendingRemoteMedia(P, f) && (Ee.debug("[".concat(this._clientId, "] resubscribe ").concat(f, " for user ").concat(P.uid, " after reconnect.")), this._subscribe(P, f, !0).catch((z) => {
            Ee.error("[".concat(this._clientId, "] resubscribe error"), z.toString());
          }));
        }), this._config = e, this._clientId = n || zr(5, "client-"), this.store = new class {
          constructor(f, T, A, R) {
            Un(this, "state", void 0), this.state = { codec: f, audioCodec: T, mode: A, clientId: R, sessionId: null, p2pId: 0, dcId: 0, pubId: 0, subId: 0, avoidJoinStart: 0, keyMetrics: { publish: [], subscribe: [] }, joinChannelServiceRecords: [], cloudProxyServerMode: "disabled", useP2P: !1, p2pTransport: bf.Default };
          }
          dispatch(f) {
            this.state = function(T, A) {
              switch (A.type) {
                case tr.SET_SESSION_ID:
                  return yn(yn({}, T), {}, { sessionId: A.sessionId });
                case tr.SET_P2P_ID:
                  return yn(yn({}, T), {}, { p2pId: A.p2pId });
                case tr.SET_UID:
                  return yn(yn({}, T), {}, { uid: A.uid });
                case tr.SET_INT_UID:
                  return yn(yn({}, T), {}, { intUid: A.intUid });
                case tr.SET_PUB_ID:
                  return yn(yn({}, T), {}, { pubId: A.pubId });
                case tr.KEY_METRIC_CLIENT_CREATED:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { clientCreated: A.metric }) });
                case tr.KEY_METRIC_JOIN_START:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { joinStart: A.metric }) });
                case tr.AVOID_JOIN_START:
                  return yn(yn({}, T), {}, { avoidJoinStart: A.avoidJoinStart });
                case tr.KEY_METRIC_JOIN_END:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { joinEnd: A.metric }) });
                case tr.KEY_METRIC_REQUEST_AP_START:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { requestAPStart: A.metric }) });
                case tr.KEY_METRIC_REQUEST_AP_END:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { requestAPEnd: A.metric }) });
                case tr.KEY_METRIC_JOIN_GATEWAY_START:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { joinGatewayStart: A.metric }) });
                case tr.KEY_METRIC_JOIN_GATEWAY_END:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { joinGatewayEnd: A.metric }) });
                case tr.KEY_METRIC_PEER_CONNECTION_START:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { peerConnectionStart: A.metric }) });
                case tr.KEY_METRIC_PEER_CONNECTION_END:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { peerConnectionEnd: A.metric }) });
                case tr.KEY_METRIC_DESCRIPTION_START:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { descriptionStart: A.metric }) });
                case tr.KEY_METRIC_SIGNAL_CHANNEL_OPEN:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { signalChannelOpen: A.metric }) });
                case tr.KEY_METRIC_ICE_CONNECTION_END:
                  return yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { iceConnectionEnd: A.metric }) });
                case tr.KEY_METRIC_PUBLISH: {
                  const R = T.keyMetrics.publish, P = R.findIndex((L) => L.trackId === A.metric.trackId);
                  return P !== -1 ? (R[P] = yn(yn({}, R[P]), A.metric), yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { publish: [...R] }) })) : yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { publish: [...T.keyMetrics.publish, A.metric] }) });
                }
                case tr.KEY_METRIC_SUBSCRIBE: {
                  const R = T.keyMetrics.subscribe, P = R.findIndex((L) => L.userId === A.metric.userId && L.type === A.metric.type);
                  return P !== -1 ? (R[P] = yn(yn({}, R[P]), A.metric), yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { subscribe: [...R] }) })) : yn(yn({}, T), {}, { keyMetrics: yn(yn({}, T.keyMetrics), {}, { subscribe: [...T.keyMetrics.subscribe, A.metric] }) });
                }
                case tr.SET_CLOUD_PROXY_SERVER_MODE:
                  return T.cloudProxyServerMode = A.mode, T;
                case tr.RECORD_JOIN_CHANNEL_SERVICE:
                  return typeof A.index != "number" ? T.joinChannelServiceRecords = [...T.joinChannelServiceRecords, A.record] : (T.joinChannelServiceRecords[A.index] = yn(yn({}, T.joinChannelServiceRecords[A.index]), A.record), T.joinChannelServiceRecords = [...T.joinChannelServiceRecords]), T;
                case tr.RESET_JOIN_CHANNEL_SERVICE_RECORDS:
                  return T.joinChannelServiceRecords = [], T;
                case tr.RESET_KEY_METRICS:
                  return T.keyMetrics = { publish: [], subscribe: [] }, T;
                case tr.SET_USE_P2P:
                  return yn(yn({}, T), {}, { useP2P: A.val });
                case tr.SET_TRANSPORT_TYPE:
                  return yn(yn({}, T), {}, { p2pTransport: A.val });
                default:
                  return T;
              }
            }(this.state, f);
          }
          set sessionId(f) {
            this.dispatch({ type: tr.SET_SESSION_ID, sessionId: f });
          }
          get sessionId() {
            return this.state.sessionId;
          }
          set codec(f) {
            this.state.codec = f;
          }
          get codec() {
            return this.state.codec;
          }
          get mode() {
            return this.state.mode;
          }
          get audioCodec() {
            return this.state.audioCodec;
          }
          get clientId() {
            return this.state.clientId;
          }
          set p2pId(f) {
            this.dispatch({ type: tr.SET_P2P_ID, p2pId: f });
          }
          get p2pId() {
            return this.state.p2pId;
          }
          set dcId(f) {
            this.dispatch({ type: tr.SET_DC_ID, dcId: f });
          }
          get dcId() {
            return this.state.dcId;
          }
          set uid(f) {
            this.dispatch({ type: tr.SET_UID, uid: f });
          }
          get uid() {
            return this.state.uid;
          }
          set intUid(f) {
            this.dispatch({ type: tr.SET_INT_UID, intUid: f });
          }
          get intUid() {
            return this.state.intUid;
          }
          set pubId(f) {
            this.dispatch({ type: tr.SET_PUB_ID, pubId: f });
          }
          get pubId() {
            return this.state.pubId;
          }
          set cloudProxyServerMode(f) {
            this.dispatch({ type: tr.SET_CLOUD_PROXY_SERVER_MODE, mode: f });
          }
          get cloudProxyServerMode() {
            return this.state.cloudProxyServerMode;
          }
          set useP2P(f) {
            this.dispatch({ type: tr.SET_USE_P2P, val: f });
          }
          get useP2P() {
            return this.state.useP2P;
          }
          set p2pTransport(f) {
            this.dispatch({ type: tr.SET_TRANSPORT_TYPE, val: f });
          }
          get p2pTransport() {
            return this.state.p2pTransport;
          }
          clientCreated() {
            this.dispatch({ type: tr.KEY_METRIC_CLIENT_CREATED, metric: Date.now() });
          }
          joinStart() {
            this.dispatch({ type: tr.KEY_METRIC_JOIN_START, metric: Date.now() });
          }
          joinEnd() {
            this.dispatch({ type: tr.KEY_METRIC_JOIN_END, metric: Date.now() });
          }
          requestAPStart() {
            this.dispatch({ type: tr.KEY_METRIC_REQUEST_AP_START, metric: Date.now() });
          }
          requestAPEnd() {
            this.dispatch({ type: tr.KEY_METRIC_REQUEST_AP_END, metric: Date.now() });
          }
          joinGatewayStart() {
            this.dispatch({ type: tr.KEY_METRIC_JOIN_GATEWAY_START, metric: Date.now() });
          }
          joinGatewayEnd() {
            this.dispatch({ type: tr.KEY_METRIC_JOIN_GATEWAY_END, metric: Date.now() });
          }
          peerConnectionStart() {
            this.dispatch({ type: tr.KEY_METRIC_PEER_CONNECTION_START, metric: Date.now() });
          }
          peerConnectionEnd() {
            this.dispatch({ type: tr.KEY_METRIC_PEER_CONNECTION_END, metric: Date.now() });
          }
          descriptionStart() {
            this.dispatch({ type: tr.KEY_METRIC_DESCRIPTION_START, metric: Date.now() });
          }
          signalChannelOpen() {
            this.dispatch({ type: tr.KEY_METRIC_SIGNAL_CHANNEL_OPEN, metric: Date.now() });
          }
          iceConnectionEnd() {
            this.dispatch({ type: tr.KEY_METRIC_ICE_CONNECTION_END, metric: Date.now() });
          }
          publish(f, T, A, R) {
            this.dispatch({ type: tr.KEY_METRIC_PUBLISH, metric: yn(yn({ trackId: f, type: T }, A && { publishStart: A }), R && { publishEnd: R }) });
          }
          subscribe(f, T, A, R, P, L, z) {
            this.dispatch({ type: tr.KEY_METRIC_SUBSCRIBE, metric: yn(yn(yn(yn(yn({ userId: f, type: T }, A && { subscribeStart: A }), R && { subscribeEnd: R }), P && { firstFrame: P }), L && { streamAdded: L }), z && { firstDecoded: z }) });
          }
          massSubscribe(f, T, A, R) {
            f.forEach((P) => {
              this.dispatch({ type: tr.KEY_METRIC_SUBSCRIBE, metric: yn(yn(yn({ userId: P.userId, type: P.type }, T && { subscribeStart: T }), A && { subscribeEnd: A }), R && { firstFrame: R }) });
            });
          }
          get keyMetrics() {
            return this.state.keyMetrics;
          }
          recordJoinChannelService(f, T) {
            f.service === "gateway" && Array.isArray(f.urls) && (f.urls = f.urls.map((A) => A.replace(/(\d+)-\d+-\d+-(\d+)/, "$1-*-*-$2")));
            try {
              return typeof T != "number" ? (this.dispatch({ type: tr.RECORD_JOIN_CHANNEL_SERVICE, record: yn(yn({}, f), {}, { sessionId: this.sessionId, cloudProxyMode: this.cloudProxyServerMode, uid: this.uid }) }), this.state.joinChannelServiceRecords.length - 1) : (T < 0 || T >= this.state.joinChannelServiceRecords.length || this.dispatch({ type: tr.RECORD_JOIN_CHANNEL_SERVICE, record: f, index: T }), T);
            } catch {
              return 0;
            }
          }
          resetJoinChannelServiceRecords() {
            this.dispatch({ type: tr.RESET_JOIN_CHANNEL_SERVICE_RECORDS });
          }
          resetKeyMetrics() {
            this.dispatch({ type: tr.RESET_KEY_METRICS });
          }
          get joinChannelServiceRecords() {
            try {
              return this.state.joinChannelServiceRecords;
            } catch {
              return [];
            }
          }
          get avoidJoinStart() {
            return this.state.avoidJoinStart;
          }
          set avoidJoinStart(f) {
            this.dispatch({ type: tr.AVOID_JOIN_START, avoidJoinStart: f });
          }
        }(e.codec, e.audioCodec, e.mode, this._clientId), this._leaveMutex = new xs("client-leave", this._clientId), this._publishMutex = new xs("client-publish", this._clientId), this._renewTokenMutex = new xs("client-renewtoken", this._clientId), this._subscribeMutex = new xs("client-subscribe", this._clientId), this.store.clientCreated(), e.proxyServer && this.setProxyServer(e.proxyServer, !0), e.turnServer && this.setTurnServer(e.turnServer, !0), Ee.info("[".concat(this._clientId, "] Initializing AgoraRTC client v").concat(Ro, " build: ").concat(qS, ", mode: ").concat(this.mode, ", codec: ").concat(this.codec)), e.clientRoleOptions) try {
          kS(e.clientRoleOptions), i = Object.assign({}, e.clientRoleOptions);
        } catch (f) {
          Ee.warning("[".concat(this._clientId, "] ").concat(f.toString()));
        }
        var o;
        this._statsCollector = new XE(this.store), this._statsCollector.onStatsException = (f, T, A) => {
          Ee.warn("[".concat(this._clientId, "] receive exception msg, code: ").concat(f, ", msg: ").concat(T, ", uid: ").concat(A)), this.safeEmit(rr.EXCEPTION, { code: f, msg: T, uid: A });
        }, this._statsCollector.onUploadPublishDuration = (f, T, A, R) => {
          const P = this._users.find((L) => L.uid === f);
          P && Cn.peerPublishStatus(this._sessionId, { subscribeElapse: R, audioPublishDuration: T, videoPublishDuration: A, peer: P._uintid });
        }, this.store.useP2P = e.mode === "p2p", this._gateway = new fae(this.store, { clientId: this._clientId, mode: this.mode, codec: this.codec, websocketRetryConfig: e.websocketRetryConfig || zi, httpRetryConfig: e.httpRetryConfig || zi, forceWaitGatewayResponse: e.forceWaitGatewayResponse === void 0 || e.forceWaitGatewayResponse, statsCollector: this._statsCollector, role: e.role, clientRoleOptions: i }), this._configDistribute = new Aae(this._clientId), this.store.useP2P ? (this._p2pChannel = (o = { store: this.store, statsCollector: this._statsCollector }, ol("P2PChannel").create(o)), this._handleP2PEvents()) : this._p2pChannel = new QT(this.store, this._statsCollector), this._handleP2PChannelEvents(), this._handleGatewayEvents(), this._handleGatewaySignalEvents();
      }
      async joinMeta(e, n, i, o, f) {
        let T = !(arguments.length > 5 && arguments[5] !== void 0) || arguments[5], A = arguments.length > 6 && arguments[6] !== void 0 && arguments[6];
        Dr("JOIN_GATEWAY_USE_443PORT_ONLY", T), Dr("JOIN_GATEWAY_USE_DUAL_DOMAIN", A);
        const R = this._gateway.signal.websocket;
        return R instanceof vI && (R.use443PortOnly = T, R.tryDoubleDomain = A), async function(P, L, z) {
          iT.get(P) || iT.set(P, []), sT.get(P) || sT.set(P, L), gu.get(P) || gu.set(P, 0);
          const Y = iT.get(P), te = sT.get(P);
          if (!Y || !te) throw new Error("concurrent: deferQueue or maxConcurrency is null");
          if (gu.get(P) === te) {
            const Xe = CE();
            Y.push(Xe), await Xe.promise;
          }
          gu.set(P, gu.get(P) + 1);
          for (var oe = arguments.length, He = new Array(oe > 3 ? oe - 3 : 0), Re = 3; Re < oe; Re++) He[Re - 3] = arguments[Re];
          const De = await z(...He);
          return gu.set(P, gu.get(P) - 1), gu.get(P) === te - 1 && Y.length > 0 && (Y[0].resolve(), Y.shift()), gu.get(P) === 0 && (iT.set(P, []), sT.set(P, 0), gu.set(P, 0)), De;
        }("client.join", ft("JOIN_MAX_CONCURRENCY"), this.join.bind(this), e, n, i, o, f);
      }
      async join(e, n, i, o, f) {
        const T = ++this._numberOfJoinCount;
        this.store.joinStart(), o && (this.store.uid = o);
        const A = (hT || hT || (hT = (window.location.protocol.split(":")[0] || "").toUpperCase(), hT)) === "HTTPS", R = g5() ? window.isSecureContext : "Browser Not Support";
        (!g5() && !A || !window.isSecureContext) && Ee.warning("The website must be running in a secure context (About secure context: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts ), otherwise the media collection will be restricted by the browser"), this.connectionState === "DISCONNECTED" && (this.store.avoidJoinStart = Math.round(Date.now()), Ee.debug("[".concat(this._clientId, "] set avoidJoinStart to ").concat(this.store.avoidJoinStart))), Cn.setAppId(e);
        try {
          if (!i && i !== null) throw new jt(Je.INVALID_PARAMS, "Invalid token: ".concat(i, ". If you don not use token, set it to null"));
          i && ms(i, "token", 1, 2047), ms(e, "appid", 1, 2047), wT(n), o && _T(o), f && ms(f, "optionalInfo", 1, 2047);
        } catch (Re) {
          throw Cn.reportApiInvoke(rp(), { name: Bi.JOIN, options: [e, n, i, o], states: { isHttps: A, isSecureContext: R }, tag: si.TRACER }).onError(Re), Re;
        }
        if (this._leaveMutex.isLocked && (Ee.debug("[".concat(this._clientId, "] join: waiting leave operation")), (await this._leaveMutex.lock())(), Ee.debug("[".concat(this._clientId, "] join: continue"))), this._joinAndNotLeaveYet = !0, this.connectionState !== "DISCONNECTED") {
          const Re = new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] Client already in connecting/connected state"));
          throw Cn.reportApiInvoke(rp(), { name: Bi.JOIN, options: [e, n, i, o], states: { isHttps: A, isSecureContext: R }, tag: si.TRACER }).onError(Re), Re;
        }
        this._gateway.state = "CONNECTING";
        const P = await c7({ appId: e, cname: n, uid: o, stringUid: typeof o == "string" ? o : void 0, token: i || e, cloudProxyServer: this._cloudProxyServerMode });
        if (!this._joinAndNotLeaveYet) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));
        const L = (P == null ? void 0 : P.sid) || rp();
        Ee.info("[".concat(this._clientId, "] start join channel ").concat(n, ", join number: ").concat(T)), this._sessionId || (this._sessionId = L, this.store.sessionId = this._sessionId);
        const z = Cn.reportApiInvoke(L, { id: this._clientId, name: Bi.JOIN, options: [e, n, i, o], states: { isHttps: A, isSecureContext: R }, tag: si.TRACER }), Y = lc(lc(lc({}, this._rtmConfig), {}, { role: this.role, clientId: this._clientId, appId: e, sid: this._sessionId, cname: n, uid: typeof o != "string" ? o : null, turnServer: this._turnServer, proxyServer: this._proxyServer, token: i || e, cloudProxyServer: this._cloudProxyServerMode, optionalInfo: f, license: this._license, useLocalAccessPoint: this._useLocalAccessPoint, preload: !!P }, this._remoteDefaultVideoStreamType !== void 0 && { defaultVideoStream: this._remoteDefaultVideoStreamType }), {}, { apRequestDetail: ft("AP_REQUEST_DETAIL") || void 0 });
        if (this._useLocalAccessPoint && (Y.setLocalAPVersion = this._setLocalAPVersion), typeof o == "string" && (Y.stringUid = o, this._uintUid ? (Y.uid = this._uintUid, this._uintUid = void 0) : Y.uid = 0), this._encryptionMode !== "none" && this._encryptionSecret) {
          if (Y.aesmode = this._encryptionMode, Y.aespassword = await (async (Re) => {
            const De = function(Pt) {
              const xt = window.atob(`MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCMnXAHkKIGAM+x4N22gCI+Wyu
STM9ztkT3uYslTT2PuKmZfPzhH6kVdO7PTjGCOZnAsyb3oTtWat0KcxQ4jxvqQV+
HvYl3iI1Yd4vl2c3qRMJPLtRDfNxa2Mcxgq7e9aEUibzdd0st+OJAy3tOj/Y0aVy
xQiYDz3vqa6bP29adwIDAQAB`), Nt = new Uint8Array(new ArrayBuffer(xt.length));
              for (let Vt = 0; Vt < xt.length; Vt += 1) Nt[Vt] = xt.charCodeAt(Vt);
              return Nt;
            }(), Xe = await window.crypto.subtle.importKey("spki", De, { name: "RSA-OAEP", hash: "SHA-256" }, !0, ["encrypt"]), We = MS(Re), mt = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, Xe, We);
            return function(Pt) {
              let xt = "";
              for (let Nt = 0; Nt < Pt.length; Nt += 1) xt += String.fromCharCode(Pt[Nt]);
              return window.btoa(xt);
            }(new Uint8Array(mt));
          })(this._encryptionSecret), !this._joinAndNotLeaveYet) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));
          this._encryptionSalt && (Y.aessalt = this._encryptionSalt);
        }
        if (this._encryptDataStream && (this._encryptionMode === "aes-128-gcm2" || this._encryptionMode === "aes-256-gcm2")) if (this._encryptionSalt && this._encryptionSecret) if (window.crypto.subtle) {
          const Re = new TextEncoder(), De = ft("USE_PURE_ENCRYPTION_MASTER_KEY") ? Re.encode(Y.appId + this._encryptionSecret + this._encryptionSecret) : Re.encode(Y.appId + Y.cname + this._encryptionSecret);
          this._encryptDataStreamIv = await async function(Xe, We, mt) {
            const Pt = await window.crypto.subtle.importKey("raw", We, "PBKDF2", !1, ["deriveBits", "deriveKey"]), xt = Xe === "aes-128-gcm2" ? 128 : 256, Nt = await window.crypto.subtle.deriveBits({ name: "PBKDF2", iterations: O5, hash: "SHA-256", salt: mt }, Pt, xt + Wie);
            return new Uint8Array(Nt).subarray(xt / 8);
          }(this._encryptionMode, De, Tf(this._encryptionSalt)), this._encryptDataStreamKey = await async function(Xe, We, mt) {
            const Pt = await window.crypto.subtle.importKey("raw", We, "PBKDF2", !1, ["deriveBits", "deriveKey"]), xt = Xe === "aes-128-gcm2" ? 128 : 256;
            return await window.crypto.subtle.deriveKey({ name: "PBKDF2", iterations: O5, hash: "SHA-256", salt: mt }, Pt, { name: "AES-GCM", length: xt }, !0, ["encrypt", "decrypt"]);
          }(this._encryptionMode, De, Tf(this._encryptionSalt));
        } else R ? Ee.warning("[".concat(this._clientId, "] encrypt datastream must be running in a secure context, fallback to plain data stream")) : Ee.warning("[".concat(this._clientId, "] current browser do not support WebCrypto ,fallback to plain data stream")), this._encryptDataStream = !1;
        else this._encryptDataStream = !1, Ee.debug("[".concat(this._clientId, "] no salt / secret, cannot support encrypt data stream, fallback to plain data stream"));
        this._startSession(this._sessionId, { channel: n, appId: e, stringUid: Y.stringUid });
        const te = this._sessionId;
        setTimeout(() => {
          this.connectionState === "CONNECTING" && te === this._sessionId && Cn.joinChannelTimeout(this._sessionId, 5);
        }, 5e3);
        try {
          var oe;
          let Re;
          const De = Y.cloudProxyServer;
          if (on(oe = ["proxy3", "proxy4", "proxy5"]).call(oe, De)) {
            const xt = ft("PROXY_SERVER_TYPE3");
            Array.isArray(xt) ? Y.proxyServer = xt[0] : Y.proxyServer = xt;
          }
          if (Cn.setProxyServer(Y.proxyServer), Ee.setProxyServer(Y.proxyServer), this.store.requestAPStart(), P) {
            if (Ee.debug("[".concat(this._clientId, "] get serverInfo Success from Preload Cache ").concat(Y.stringUid ? ", ".concat(Y.stringUid, " => ").concat(P.intUid) : "", " ")), Y.stringUid && !Y.uid && (Y.uid = P.intUid), Re = { gatewayInfo: P.ap.gatewayInfo }, ft("JOIN_WITH_FALLBACK_MEDIA_PROXY") && Y.turnServer.mode === "auto") if (P.ap.proxyInfo.addresses.length === 0) Ee.warning("no edge services in ap response of proxy fallback, will not set proxy in iceServers");
            else {
              const xt = (await $8(P.ap.proxyInfo, P.ap.gatewayInfo.uid)).map((Nt) => ({ turnServerURL: Nt.address, tcpport: Nt.tcpport || Is.tcpport, udpport: Nt.udpport || Is.udpport, username: Nt.username || Is.username, password: Nt.password || Is.password, forceturn: !1, security: !0 }));
              Y.turnServer = { mode: "manual", servers: xt };
            }
            l7(P, Y.stringUid);
          } else {
            if (Y.stringUid && !Y.uid) {
              let xt;
              [xt, Re] = await cn.all([R6(Y.stringUid, Y, this._axiosCancelSource.token, this._config.httpRetryConfig || zi, this.store), I6(Y, this._axiosCancelSource.token, this._config.httpRetryConfig || zi, !0, this.store)]), Ee.debug("[".concat(this._clientId, "] getUserAccount Success ").concat(Y.stringUid, " => ").concat(xt)), Y.uid = xt, Re.gatewayInfo.uid = xt, Re.gatewayInfo.res.uid = xt;
            } else Re = await I6(Y, this._axiosCancelSource.token, this._config.httpRetryConfig || zi, !0, this.store);
            if (!this._joinAndNotLeaveYet) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));
          }
          this.store.requestAPEnd(), setTimeout(() => {
            this._configDistribute.startGetConfigDistribute(Y, this._axiosCancelSource.token), this._configDistribute.on(jE.UPDATE_BITRATE_LIMIT, (xt) => {
              this._p2pChannel.updateBitrateLimit(xt);
            }), this._configDistribute.on(jE.UPDATE_CLIENT_ROLE_OPTIONS, (xt) => {
              this._setClientRoleOptions(xt);
            });
          }, 0), this._key = i || e;
          const Xe = Re.gatewayInfo, We = Y.uid ? Y.uid : Xe.uid;
          this._joinInfo = lc(lc({}, Y), {}, { cid: Xe.cid, uid: We, vid: Xe.vid, apResponse: Xe.res, apGatewayAddress: Xe.apGatewayAddress, uni_lbs_ip: Xe.uni_lbs_ip, gatewayAddrs: Xe.gatewayAddrs }), this.store.intUid = We;
          const mt = await this._joinGateway();
          if (!this._joinAndNotLeaveYet) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] Client already left"));
          z.onSuccess(mt), this._appId = e, this._channelName = Y.cname, this._uid = mt, this.store.uid = mt, setTimeout(() => {
            this._networkQualityInterval && window.clearInterval(this._networkQualityInterval), this._networkQualityInterval = window.setInterval(this._handleUpdateNetworkQuality, 2e3), window.addEventListener(Os() ? "beforeunload" : "pagehide", this._handleBeforeUnload), this._statsCollector.startUpdateStats();
          }, 0);
          const Pt = Y.stringUid ? "string uid: ".concat(Y.stringUid, ",uid: ").concat(Y.uid) : "uid: ".concat(this._uid);
          return Ee.info("[".concat(this._clientId, "] Joining channel success: channel: ").concat(n, ",").concat(Pt)), setTimeout(() => {
            Ee.startUpload();
          }, 5e3), this.store.joinEnd(), He = this, on(Sf).call(Sf, He) || Sf.push(He), this._cloudProxyServerMode === "disabled" && pr().supportWebCrypto && ft("ENABLE_PRELOAD") && YI(this._joinInfo), mt;
        } catch (Re) {
          const De = Array.isArray(Re) ? Re[0] : Re;
          throw De && De.code === Je.OPERATION_ABORTED ? Ee.warning("[".concat(this._clientId, "] join number: ").concat(T, ", Joining channel failed, rollback"), De) : Ee.error("[".concat(this._clientId, "] join number: ").concat(T, ", Joining channel failed, rollback"), De), De.code !== Je.OPERATION_ABORTED && this._numberOfJoinCount === T && (this._gateway.state = "DISCONNECTED", this._reset()), z.onError(De), De;
        }
        var He;
      }
      _joinGateway() {
        if (!this._joinInfo || !this._key) throw new jt(Je.INVALID_OPERATION);
        return this._gateway.join(this._joinInfo, this._key, !(this._joinInfo.cloudProxyServer !== "disabled" || this._joinInfo.proxyServer || !ft("JOIN_WITH_FALLBACK_SIGNAL_PROXY")));
      }
      async leave() {
        Ee.info("[".concat(this._clientId, "] Leaving channel")), window.removeEventListener(Os() ? "beforeunload" : "pagehide", this._handleBeforeUnload), this._reset(), function(n) {
          const i = Sf.indexOf(n);
          i !== -1 && Sf.splice(i, 1);
        }(this), this._statsCollector.stopUpdateStats();
        const e = await this._leaveMutex.lock();
        if (this.connectionState === "DISCONNECTED") return Ee.info("[".concat(this._clientId, "] Leaving channel repeated, success")), void e();
        await this._gateway.leave(this.connectionState !== "CONNECTED", br.LEAVE), Ee.info("[".concat(this._clientId, "] Leaving channel success")), this._joinAndNotLeaveYet = !1, this.store.resetJoinChannelServiceRecords(), e();
      }
      async publish(e) {
        let n = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        if (!Array.isArray(e)) {
          if (!(e instanceof hp)) return this._publishDataChannel(e);
          e = [e];
        }
        if (e.length === 0) throw new jt(Je.INVALID_PARAMS, "param list is empty");
        const i = e;
        if (this._gateway.role === "audience") throw new jt(Je.INVALID_OPERATION, "audience can not publish stream");
        for (const f of i) {
          if (!(f instanceof hp)) throw new jt(Je.INVALID_PARAMS, "parameter is not local track");
          if (!f._enabled && n) throw new jt(Je.TRACK_IS_DISABLED, "can not publish a disabled track: ".concat(f.getTrackId()));
        }
        Ee.info("[".concat(this._clientId, "] Publishing tracks, id ").concat(i.map((f) => "".concat(f.getTrackId(), " "))));
        const o = await this._publishMutex.lock();
        await this._configDistribute.awaitConfigDistributeComplete(), n && i.forEach((f) => {
          const T = this._configDistribute.getBitrateLimit();
          f instanceof Wr && T && f.setBitrateLimit(T.uplink);
        });
        try {
          await this._publishHighStream(i), Ee.info("[".concat(this._clientId, "] Publish success, id ").concat(i.map((f) => "".concat(f.getTrackId(), " "))));
        } catch (f) {
          throw Ee.error("[".concat(this._clientId, "] publish error"), f.toString()), f;
        } finally {
          o();
        }
      }
      async _publishDataChannel(e) {
        xr(e.id, "id", 0, 65535, !0), od(e.ordered, "ordered"), ms(e.metadata, "metadata", 0, 512), Ee.info("[".concat(this._clientId, "] Publishing datachannels, id ").concat(e.id));
        const n = await this._publishMutex.lock();
        try {
          if (this._p2pChannel.getAllDataChannels().findIndex((f) => f.id === e.id) !== -1) throw new jt(Je.INVALID_PARAMS, "Invalid id: ".concat(e.id, ". If you want to republish the datachannel, unpublish first"));
          if (!this._joinInfo || this._uid === void 0) throw new jt(Je.INVALID_OPERATION, "Can't publish datachannel, haven't joined yet!");
          if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish datachannel in ".concat(this.connectionState, " state"));
          if (this._turnServer.mode === "auto" && ft("FORCE_TURN") && !ft("TURN_ENABLE_TCP") && !ft("TURN_ENABLE_UDP")) throw new jt(Je.UNEXPECTED_ERROR, "force TURN With No TURN Configuration");
          const i = function(f) {
            return E6(f, !1);
          }(e), o = await this._p2pChannel.publishDataChannel([i]);
          if (o.length > 0) {
            if (typeof i._originDataChannelId != "number") throw Ee.error("[".concat(this._clientId, "] can not publish with mediaType datachannel, cannot get RTCDatachannel id")), new jt(Je.CREATE_DATACHANNEL_ERROR);
            try {
              await cn.all(o.map((f) => this._uid && this._gateway.publishDataChannel(this._uid, f, !0))), await i._waitTillOpen();
            } catch (f) {
              if (f.code !== Je.DISCONNECT_P2P) throw f;
            }
          }
          return Ee.info("[".concat(this._clientId, "] Publish dataChannels success, id ").concat(i.id)), i;
        } catch (i) {
          throw Ee.error("[".concat(this._clientId, "] publish datachannels error"), i.toString()), i;
        } finally {
          n();
        }
      }
      async unpublish(e) {
        if (!this._joinInfo || this._uid === void 0) throw new jt(Je.INVALID_OPERATION, "Can't unpublish stream, haven't joined yet!");
        let n = [];
        if (e) if (Array.isArray(e)) n = e;
        else {
          if (!(e instanceof hp)) return this._unpublishDataChannel([e]);
          n = [e];
        }
        else this.store.useP2P || await this._unpublishDataChannel(), n = this._p2pChannel.getAllTracks(!0);
        Ee.info("[".concat(this._clientId, "] Unpublish tracks, tracks ").concat(n.map((o) => "".concat(o.getTrackId(), " ")), " "));
        const i = await this._publishMutex.lock();
        try {
          if (this.store.useP2P) {
            const o = await this._p2pChannel.unpublish(n);
            o && await this._gateway.sendExtensionMessage(bi.UNPUBLISH, { unpubMsg: o }, !0);
          } else {
            const o = await this._p2pChannel.unpublish(n);
            o && await this._gateway.unpublish(o, this._uid), Ee.info("[".concat(this._clientId, "] Unpublish success,tracks ").concat(n.map((f) => "".concat(f.getTrackId()))));
          }
        } catch (o) {
          throw Ee.error("[".concat(this._clientId, "] unpublish error"), o.toString()), o;
        } finally {
          i && i();
        }
      }
      async _unpublishDataChannel(e) {
        e !== void 0 && e.length !== 0 || (e = this._p2pChannel.getAllDataChannels()), Ee.info("[".concat(this._clientId, "] Unpublish datachannels, datachannels ").concat(e.map((i) => "".concat(i.id, " ")), " "));
        const n = await this._publishMutex.lock();
        try {
          const i = await this._p2pChannel.unpublishDataChannel(e);
          i && await this._gateway.unpublishDataChannel(i), Ee.info("[".concat(this._clientId, "] Unpublish dataChannel success,dataChannel ").concat(e.map((o) => "".concat(o.id))));
        } catch (i) {
          throw Ee.error("[".concat(this._clientId, "] unpublish dataChannel error"), i.toString()), i;
        } finally {
          n && n();
        }
      }
      async subscribe(e, n, i) {
        if (!(e instanceof cl)) {
          const o = this.remoteUsers.find((f) => f.uid === e);
          if (!o) throw new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
          e = o;
        }
        return n === "datachannel" ? this._subscribeDataChannel(e, i) : this._subscribe(e, n);
      }
      async presubscribe(e, n) {
        if ($i(n, "mediaType", ["audio", "video"]), this.store.useP2P) throw new jt(Je.INVALID_OPERATION, "can't presub at p2p mode");
        if (!this._joinInfo) throw new jt(Je.INVALID_OPERATION, "can't presub when not join");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can't presub in ".concat(this.connectionState, " state"));
        const i = n === vn.AUDIO, o = n === vn.VIDEO, f = await this._subscribeMutex.lock();
        try {
          const { ssrcId: T, ortc: A, rtxSsrcId: R, cname: P, uint_id: L } = await this._gateway.presubscribe(e, n, !0);
          if (T == null) throw new jt(Je.UNEXPECTED_RESPONSE, "no ssrc id");
          let z = this._users.find((te) => te.uid === e);
          z || (z = new cl(e, L || e), z._is_pre_created = !0, this._users.push(z)), P && (z._cname = P), z._uintid || (z._uintid = L || e), i && (z._audioSSRC = T, z._audio_pre_subscribed = !0, A && (z._audioOrtc = A)), o && (z._videoSSRC = T, z._video_pre_subscribed = !0, A && (z._videoOrtc = A), R != null && (z._rtxSsrcId = R)), Ee.info("[".concat(this._clientId, "] presub succeed ssrc: ").concat(T)), await this._p2pChannel.subscribe(z, n, T, R, A);
          const Y = i ? z._audioTrack : z._videoTrack;
          if (!Y) throw new jt(Je.UNEXPECTED_ERROR, "can not find remote track in user");
          return i && (z._trust_audio_stream_added_state_ = !0, z._audio_added_ = !0), o && (z._trust_video_stream_added_state_ = !0, z._video_added_ = !0), Y;
        } catch (T) {
          throw Ee.error("[".concat(this._clientId, "] presub user ").concat(e, " error"), T), T;
        } finally {
          f();
        }
      }
      async _subscribeDataChannel(e, n) {
        var i;
        if (xr(n, "channelId", 0, 65535, !0), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't subscribe datachannel, not joined");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "Can't subscribe datachannel in ".concat(this.connectionState, " state"));
        if (!this._users.find((R) => R === e)) throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", this user is not in the channel")), new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
        if (!e.hasAudio && !e.hasVideo && e._dataChannels.length === 0) throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", user is not published")), new jt(Je.INVALID_REMOTE_USER, "user is not published");
        const f = (i = e._dataChannels) === null || i === void 0 ? void 0 : i.find((R) => R.id === n);
        if (!f) throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType datachannel, remote datachannel is not published")), new jt(Je.REMOTE_USER_IS_NOT_PUBLISHED);
        const T = await this._subscribeMutex.lock();
        Ee.info("[".concat(this._clientId, "] subscribe user ").concat(e.uid, ", mediaType: datachannel"));
        try {
          const R = await this._p2pChannel.subscribeDataChannel(e, [f]);
          if (R && on(R).call(R, f.id)) try {
            var A;
            if (typeof f._originDataChannelId != "number") throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType datachannel, cannot get RTCDatachannel")), new jt(Je.CREATE_DATACHANNEL_ERROR);
            const P = { id: f.id, datachannelId: f._originDataChannelId, ordered: f.ordered, maxRetransmits: f.maxRetransmits, metadata: (A = f.metadata) !== null && A !== void 0 ? A : "" };
            await this._gateway.subscribeDataChannel(e.uid, P, !0), await f._waitTillOpen();
          } catch (P) {
            if ((P == null ? void 0 : P.code) !== Je.WS_ABORT) throw await this._p2pChannel.unsubscribeDataChannel(e, [f]), P;
            await this._p2pChannel.unsubscribeDataChannel(e, [f]), this._p2pChannel.setPendingRemoteDataChannel(e, f.id);
          }
          return Ee.info("[".concat(this._clientId, "] subscribe success user ").concat(e.uid, ", mediaType: datachannel")), f;
        } finally {
          T();
        }
      }
      async _p2pSubscribe(e, n, i) {
        if ($i(n, "mediaType", ["audio", "video"]), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't subscribe stream, not joined");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "Can't subscribe stream in ".concat(this.connectionState, " state"));
        if (!this._users.find((T) => T === e)) {
          const T = new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
          throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", this user is not in the channel")), T;
        }
        if (!e.hasAudio && !e.hasVideo) {
          const T = new jt(Je.INVALID_REMOTE_USER, "user is not published");
          throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", user is not published")), T;
        }
        if (!i && (n === "audio" && !e.hasAudio || n === "video" && !e.hasVideo)) {
          const T = new jt(Je.REMOTE_USER_IS_NOT_PUBLISHED);
          throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType ").concat(n, ", remote track is not published")), T;
        }
        const f = await this._subscribeMutex.lock();
        Ee.info("[".concat(this._clientId, "] subscribe user ").concat(e.uid, ", mediaType: ").concat(n));
        try {
          if (await this._p2pChannel.hasRemoteMediaWithLock(e, n)) await this._p2pChannel.unmuteRemote(e, n);
          else try {
            const A = n === "audio" ? e._audioSSRC : e._videoSSRC, R = n === "audio" ? e._audioMid : e._videoMid;
            this.store.subscribe(e.uid, n, Date.now()), this.store.useP2P && await this._p2pChannel.subscribe(e, n, A, R);
          } catch (A) {
            throw A;
          }
          Ee.info("[".concat(this._clientId, "] subscribe success user ").concat(e.uid, ", mediaType: ").concat(n)), this._defaultStreamFallbackType && this.setStreamFallbackOption(e.uid, this._defaultStreamFallbackType).catch((A) => {
            Ee.warning("[".concat(this._clientId, "] auto set fallback failed"), A);
          });
          const T = n === "audio" ? e._audioTrack : e._videoTrack;
          if (!T) throw new jt(Je.UNEXPECTED_ERROR, "can not find remote track in user object");
          return T;
        } catch (T) {
          throw Ee.error("[".concat(this._clientId, "] subscribe user ").concat(e.uid, " error"), T), T;
        } finally {
          f();
        }
      }
      async _subscribe(e, n, i) {
        if (this.store.useP2P) return this._p2pSubscribe(e, n);
        if ($i(n, "mediaType", ["audio", "video"]), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't subscribe stream, not joined");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "Can't subscribe stream in ".concat(this.connectionState, " state"));
        if (!this._users.find((L) => L === e)) {
          const L = new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
          throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", this user is not in the channel")), L;
        }
        if (!e.hasAudio && !e.hasVideo) {
          const L = new jt(Je.INVALID_REMOTE_USER, "user is not published");
          throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, ", user is not published")), L;
        }
        if (!(i || (n !== "audio" || e.hasAudio && e._audioSSRC !== void 0) && (n !== "video" || e.hasVideo && e._videoSSRC !== void 0))) {
          const L = new jt(Je.REMOTE_USER_IS_NOT_PUBLISHED);
          throw Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(e.uid, " with mediaType ").concat(n, ", remote track is not published")), L;
        }
        let f = n === "audio" ? e._audioSSRC : e._videoSSRC, T = n === "audio" ? e._audioOrtc : e._videoOrtc, A = n === "video" ? e._rtxSsrcId : void 0, R = { stream_type: n === "audio" ? vn.AUDIO : vn.VIDEO, ssrcId: f };
        const P = await this._subscribeMutex.lock();
        Ee.info("[".concat(this._clientId, "] subscribe user ").concat(e.uid, ", mediaType: ").concat(n));
        try {
          if (await this._p2pChannel.hasRemoteMediaWithLock(e, n)) await this._p2pChannel.unmuteRemote(e, n);
          else try {
            const z = n === "audio" ? e._audioSSRC : e._videoSSRC;
            z !== void 0 && z !== f && (f = z, T = n === "audio" ? e._audioOrtc : e._videoOrtc, A = n === "video" ? e._rtxSsrcId : void 0, R = { stream_type: n === "audio" ? vn.AUDIO : vn.VIDEO, ssrcId: f }), Ms.markSubscribeStart(this.store.clientId, f), this.store.subscribe(e.uid, n, Date.now()), await this._p2pChannel.subscribe(e, n, f, A, T);
            try {
              this._p2pChannel.isPreSubScribe(f) || await this._gateway.subscribe(e.uid, R, !0);
            } catch (Y) {
              if ((Y == null ? void 0 : Y.code) !== Je.WS_ABORT) throw await this._p2pChannel.unsubscribe(e, n), Y;
              await this._p2pChannel.unsubscribe(e, n, !0), this._p2pChannel.setPendingRemoteMedia(e, n);
            }
            this.store.subscribe(e.uid, n, void 0, Date.now()), this._p2pChannel.reportSubscribeEvent(!0, null, e, n);
          } catch (z) {
            throw this._p2pChannel.reportSubscribeEvent(!1, z == null ? void 0 : z.code, e, n), z;
          }
          Ee.info("[".concat(this._clientId, "] subscribe success user ").concat(e.uid, ", mediaType: ").concat(n)), this._defaultStreamFallbackType && this.setStreamFallbackOption(e.uid, this._defaultStreamFallbackType).catch((z) => {
            Ee.warning("[".concat(this._clientId, "] auto set fallback failed"), z);
          });
          const L = n === "audio" ? e._audioTrack : e._videoTrack;
          if (!L) throw new jt(Je.UNEXPECTED_ERROR, "can not find remote track in user object");
          return L;
        } catch (L) {
          throw Ee.error("[".concat(this._clientId, "] subscribe user ").concat(e.uid, " error"), L), L;
        } finally {
          P();
        }
      }
      async massSubscribe(e) {
        if (cd(e, "subscribeList"), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't subscribe stream, not joined");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "Can't subscribe stream in ".concat(this.connectionState, " state"));
        const n = Date.now(), i = /* @__PURE__ */ new Map(), o = await this._subscribeMutex.lock();
        Ee.info("[".concat(this._clientId, "]start massSubscribe user ").concat(e.map((R) => {
          let { user: P, mediaType: L } = R;
          return "user: ".concat(P == null ? void 0 : P.uid, ", mediaType: ").concat(L);
        }).join("; ")));
        const f = (e = [...e]).map((R) => {
          let { user: P, mediaType: L } = R;
          return { user: P, mediaType: L };
        }), T = await this._p2pChannel.globalLock();
        try {
          var A;
          for (let P = e.length - 1; P >= 0; P--) {
            const L = e[P], { user: z, mediaType: Y } = L;
            if ($i(Y, "mediaType", ["audio", "video"]), !z) {
              const Re = new jt(Je.INVALID_PARAMS, "user property does not exist in subscribeList item");
              throw Ee.error("[".concat(this._clientId, "] user property does not exist in subscribeList item")), Re;
            }
            if (!this._users.find((Re) => Re === z)) {
              const Re = new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
              Ee.error("[".concat(this._clientId, "] can not massSubscribe ").concat(z.uid, ", this user is not in the channel")), f[P].error = Re, e.splice(P, 1);
              continue;
            }
            if (Y === "audio" && (!z.hasAudio || z._audioSSRC === void 0) || Y === "video" && (!z.hasVideo || z._videoSSRC === void 0)) {
              const Re = new jt(Je.REMOTE_USER_IS_NOT_PUBLISHED);
              Ee.error("[".concat(this._clientId, "] can not subscribe ").concat(z.uid, " with mediaType ").concat(Y, ", remote user is not published")), f[P].error = Re, e.splice(P, 1);
              continue;
            }
            const oe = ns.Video | ns.LwoVideo, He = i.get(z);
            if (He) {
              if (Y === "video" ? He & oe : He & ns.Audio) {
                e.splice(P, 1), Ee.warning("[".concat(this._clientId, "] repeat massSubscribe user:").concat(z.uid, ", mediaType:").concat(Y, " twice"));
                continue;
              }
              i.set(z, He | (Y === "video" ? oe : ns.Audio));
            } else i.set(z, Y === "video" ? oe : ns.Audio);
          }
          for (let P = e.length - 1; P >= 0; P--) {
            const L = e[P], { user: z, mediaType: Y } = L, te = ns.Video | ns.LwoVideo;
            if (this._p2pChannel.hasRemoteMedia(z, Y)) {
              await this._p2pChannel.unmuteRemoteNoLock(z, Y);
              const oe = i.get(z);
              i.set(z, Y === "video" ? oe ^ te : oe ^ ns.Audio), e.splice(P, 1);
            }
          }
          this.store.massSubscribe(e.map((P) => ({ userId: P.user.uid, type: P.mediaType })), n);
          let R = _c(A = Array.from(i.entries())).call(A, (P, L) => {
            let [z, Y] = L;
            if (Y === 0) return P;
            const te = { stream_id: z.uid, stream_type: Y };
            return Y & ns.Audio && (te.audio_ssrc = z._audioSSRC), Y & ns.Video && (te.video_ssrc = z._videoSSRC), P.push(te), P;
          }, []);
          try {
            e.length > 0 && await this._p2pChannel.massSubscribeNoLock(e.map((L) => {
              let { user: z, mediaType: Y } = L;
              return { user: z, mediaType: Y, ssrcId: Y === vn.VIDEO ? z._videoSSRC : z._audioSSRC, rtxSsrcId: Y === vn.VIDEO ? z._rtxSsrcId : void 0 };
            }));
            const P = /* @__PURE__ */ new Map();
            if (R = R.filter((L) => L.video_ssrc && !this._p2pChannel.isPreSubScribe(L.video_ssrc) || L.audio_ssrc && !this._p2pChannel.isPreSubScribe(L.audio_ssrc) || !L.video_ssrc && !L.audio_ssrc), R.length > 0) {
              const L = await this._gateway.subscribeAll(R, !0);
              ((L == null ? void 0 : L.users) || []).forEach((z) => {
                let { stream_id: Y, video_error_code: te, audio_error_code: oe, error_code: He } = z;
                (te || oe || He) && P.set(Y, { video_error_code: te, audio_error_code: oe, error_code: He });
              });
            }
            if (Array.from(P.entries()).length > 0) {
              const L = [];
              Array.from(P.entries()).forEach((z) => {
                let [Y, te] = z;
                const oe = this.remoteUsers.find((He) => He.uid === Y);
                if (oe) {
                  let He;
                  te.error_code || te.video_error_code && te.audio_error_code ? He = void 0 : te.video_error_code ? He = vn.VIDEO : te.audio_error_code && (He = vn.AUDIO), L.push({ user: oe, mediaType: He });
                }
              }), L.length > 0 && await this._p2pChannel.massUnsubscribeNoLock(L);
            }
            for (const L of f) {
              const z = P.get(L.user.uid);
              if (z) {
                const Y = z.error_code || L.mediaType === "audio" && z.audio_error_code || L.mediaType === "video" && z.video_error_code;
                if (Y) {
                  const te = UE(Y);
                  Ee.error("user:".concat(L.user.uid, " mediaType:").concat(L.mediaType, " has massSubscribe error ").concat(te.desc)), L.error = new jt(Je.SUBSCRIBE_FAILED, "code ".concat(Y, ": ").concat(te.desc));
                }
              }
              L.error || (L.mediaType === "video" ? L.track = L.user.videoTrack : L.track = L.user.audioTrack);
            }
            return this.store.massSubscribe(f.filter((L) => !L.error).map((L) => ({ userId: L.user.uid, type: L.mediaType })), void 0, Date.now()), f.forEach((L) => {
              var z;
              Cn.subscribe(this.store.sessionId, { succ: !!L.error, ec: ((z = L.error) === null || z === void 0 ? void 0 : z.code) || null, video: L.mediaType === vn.VIDEO, audio: L.mediaType === vn.AUDIO, peerid: L.user.uid, subscribeRequestid: L.mediaType === vn.VIDEO ? L.user._videoSSRC : L.user._audioSSRC, p2pid: this.store.p2pId, eventElapse: Math.floor(performance.now() - n), preSsrc: this._p2pChannel.isPreSubScribe(L.user._videoSSRC) }, !0);
            }), Ee.info("[".concat(this._clientId, "] massSubscribe success ").concat(e.map((L) => {
              let { user: z, mediaType: Y } = L;
              return "user: ".concat(z == null ? void 0 : z.uid, ", mediaType: ").concat(Y);
            }).join("; "))), f;
          } catch (P) {
            throw await this._p2pChannel.massUnsubscribeNoLock(e), P;
          }
        } finally {
          T(), o();
        }
      }
      async unsubscribe(e, n, i) {
        if (!(e instanceof cl)) {
          const T = this.remoteUsers.find((A) => A.uid === e);
          if (!T) throw new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
          e = T;
        }
        if (n || this.store.useP2P) {
          if (n === "datachannel") return this._unsubscribeDataChannel(e, i);
        } else await this._unsubscribeDataChannel(e, i);
        if (n && $i(n, "mediaType", ["audio", "video"]), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't unsubscribe stream, haven't joined yet!");
        if (!this._users.find((T) => T === e)) {
          const T = new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
          throw Ee.error("[".concat(this._clientId, "] can not unsubscribe ").concat(e.uid, ", user is not in the channel")), T;
        }
        Ee.info("[".concat(this._clientId, "] unsubscribe uid: ").concat(e.uid, ", mediaType: ").concat(n));
        const f = await this._subscribeMutex.lock();
        try {
          if (this.store.useP2P) await this._p2pChannel.unsubscribe(e, n);
          else {
            const T = await this._p2pChannel.unsubscribe(e, n);
            T && await this._gateway.unsubscribe(T, e.uid), n && n !== "audio" || (e._audio_pre_subscribed = !1), n && n !== "video" || (e._video_pre_subscribed = !1), e._is_pre_created && dT(this._users, e), Ee.info("[".concat(this._clientId, "] unsubscribe success uid: ").concat(e.uid, ", mediaType: ").concat(n));
          }
        } catch (T) {
          if (T.code === Je.DISCONNECT_P2P) return void Ee.warning("disconnecting p2p, abort unsubscribe request.");
          throw Ee.error("[".concat(this._clientId, "] unsubscribe user ").concat(e.uid, " error"), T.toString()), T;
        } finally {
          f();
        }
      }
      async _unsubscribeDataChannel(e, n) {
        if (n && xr(n, "id", 0, 65535, !0), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't unsubscribe datachannel, haven't joined yet!");
        if (!this._users.find((f) => f === e)) {
          const f = new jt(Je.INVALID_REMOTE_USER, "user is not in the channel");
          throw Ee.error("[".concat(this._clientId, "] can not unsubscribe ").concat(e.uid, ", user is not in the channel")), f;
        }
        let o;
        if (typeof n == "number") {
          const f = e._dataChannels.find((T) => T.id === n);
          f && (o = [f]);
        } else o = e._dataChannels;
        if (o === void 0) {
          const f = new jt(Je.REMOTE_USER_IS_NOT_PUBLISHED);
          throw Ee.error("[".concat(this._clientId, "] can not unsubscribe ").concat(e.uid, " with channelId ").concat(n, ", remote datachannel is not published")), f;
        }
        Ee.info("[".concat(this._clientId, "] unsubscribe uid: ").concat(e.uid, ", mediaType: datachannel, ids: ").concat(o.map((f) => f.id)));
        try {
          const f = await this._p2pChannel.unsubscribeDataChannel(e, o);
          f && await this._gateway.unsubscribeDataChannel(f, e.uid), Ee.info("[".concat(this._clientId, "] unsubscribe datachannel success uid: ").concat(e.uid, ", mediaType: datachannel, ids: ").concat(f));
        } catch (f) {
          if (f.code === Je.DISCONNECT_P2P) return void Ee.warning("disconnecting p2p, abort unsubscribe request.");
          throw Ee.error("[".concat(this._clientId, "] unsubscribe user ").concat(e.uid, " error"), f.toString()), f;
        }
      }
      async massUnsubscribe(e) {
        if (cd(e, "unsubscribeList"), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't unsubscribeAll stream, haven't joined yet!");
        Ee.info("[".concat(this._clientId, "] start massUnsubscribe ").concat(e.map((i) => {
          let { user: o, mediaType: f } = i;
          return "user: ".concat(o == null ? void 0 : o.uid, ", mediaType: ").concat(f, ";");
        }).join())), e = [...e];
        const n = /* @__PURE__ */ new Map();
        for (let i = e.length - 1; i >= 0; i--) {
          const { user: o, mediaType: f } = e[i];
          if (!o) {
            const R = new jt(Je.INVALID_PARAMS, "user property does not exist in unsubscribeList item");
            throw Ee.error("[".concat(this._clientId, "] user property does not exist in unsubscribeList item")), R;
          }
          if ($i(f, "mediaType", ["video", "audio", void 0]), !this._users.find((R) => R === o)) {
            Ee.warning("[".concat(this._clientId, "] can not unsubscribe ").concat(o.uid, ", user is not in the channel")), e.splice(i, 1);
            continue;
          }
          const A = ns.Video | ns.LwoVideo;
          if (n.has(o)) {
            const R = n.get(o);
            let P;
            switch (f) {
              case "video":
                P = R & A;
                break;
              case "audio":
                P = R & ns.Audio;
                break;
              default:
                P = R & (ns.Audio | A);
            }
            if (P) {
              Ee.warning("[".concat(this._clientId, "] repeat massUnsubscribe user:").concat(o.uid, ",mediaType:").concat(f, " twice.")), e.splice(i, 1);
              continue;
            }
            f ? f === "audio" ? n.set(o, R | ns.Audio) : f === "video" && n.set(o, R | A) : n.set(o, R | ns.Audio | A);
          } else f ? f === "audio" ? n.set(o, ns.Audio) : f === "video" && n.set(o, A) : n.set(o, ns.Audio | A);
        }
        try {
          const i = await this._p2pChannel.massUnsubscribe(e);
          i && await this._gateway.massUnsubscribe(i), Ee.info("[".concat(this._clientId, "] massUnsubscribe success ").concat(e.map((o) => {
            let { user: f, mediaType: T } = o;
            return "user: ".concat(f == null ? void 0 : f.uid, ", mediaType: ").concat(T, ";");
          }).join()));
        } catch (i) {
          if (i.code === Je.DISCONNECT_P2P) return void Ee.warning("[".concat(this._clientId, "] disconnecting p2p, abort unsubscribe request."));
          throw Ee.error("[".concat(this._clientId, "] massUnsubscribe error"), i.toString()), i;
        }
      }
      async setLowStreamParameter(e) {
        (function(i) {
          if (!i) throw new Gt(Je.INVALID_PARAMS);
          ri(i.width) || xS(i.width, "streamParameter.width"), ri(i.height) || xS(i.height, "streamParameter.height"), ri(i.framerate) || xS(i.framerate, "streamParameter.framerate"), ri(i.bitrate) || xr(i.bitrate, "streamParameter.bitrate");
        })(e), (!e.width && e.height || e.width && !e.height) && Ee.warning("[".concat(this._clientId, "] The width and height parameters take effect only when both are set")), Ee.info("[".concat(this._clientId, "] set low stream parameter to"), JSON.stringify(e));
        const n = this._configDistribute.getLowStreamConfigDistribute();
        if (n && n.bitrate && e.bitrate && n.bitrate < e.bitrate && (e.bitrate = n.bitrate), this._lowStreamParameter = e, this._isDualStreamEnabled) return this._p2pChannel.updateVideoStreamParameter(e, Qt.LocalVideoLowTrack);
      }
      async enableDualStream() {
        if (!pr().supportDualStream) throw Cn.streamSwitch(this._sessionId, { lts: Date.now(), isdual: !0, succ: !1 }), new jt(Je.NOT_SUPPORTED, "Your browser is not support dual stream");
        if (this._isDualStreamEnabled) throw new jt(Je.INVALID_OPERATION, "Dual stream is already enabled");
        if (this._p2pChannel.canPublishLowStream()) try {
          await this._publishLowStream();
        } catch (e) {
          throw Cn.streamSwitch(this._sessionId, { lts: Date.now(), isdual: !0, succ: !1 }), e;
        }
        this._isDualStreamEnabled = !0, Cn.streamSwitch(this._sessionId, { lts: Date.now(), isdual: !0, succ: !0 }), Ee.info("[".concat(this._clientId, "] enable dual stream"));
      }
      async disableDualStream() {
        if (this._isDualStreamEnabled) {
          if (!this._joinInfo) throw new jt(Je.INVALID_OPERATION, "Can't publish stream, haven't joined yet!");
          if (this._p2pChannel.getLocalMedia(Qt.LocalVideoLowTrack)) try {
            const e = await this._p2pChannel.unpublishLowStream();
            e && await this._gateway.unpublish(e, this._joinInfo.stringUid || this._joinInfo.uid);
          } catch (e) {
            throw Cn.streamSwitch(this._sessionId, { lts: Date.now(), isdual: !1, succ: !1 }), e;
          }
          this._isDualStreamEnabled = !1, Cn.streamSwitch(this._sessionId, { lts: Date.now(), isdual: !1, succ: !0 }), Ee.info("[".concat(this._clientId, "] disable dual stream"));
        }
      }
      async setClientRole(e, n) {
        if (function(o) {
          $i(o, "role", ["audience", "host"]);
        }(e), n && kS(n), this.mode === "rtc" || this.mode === "p2p") throw Ee.warning("[".concat(this._clientId, "]").concat(this.mode, " mode can not use setClientRole")), new jt(Je.INVALID_OPERATION, "".concat(this.mode, " mode can not use setClientRole"));
        if (n && n.level && e === "host") throw new jt(Je.INVALID_OPERATION, "host mode can not set audience latency level");
        if (e === "audience" && this._p2pChannel.hasLocalMedia()) throw new jt(Je.INVALID_OPERATION, "can not set client role to audience when publishing stream");
        const i = this._config.role;
        this._joinInfo && (this._joinInfo.role = e), e !== i && ft("ENABLE_ROLE_SELECT_EDGE") ? (this._gateway.updateClientRole(e, n), this._config.role = e, this._gateway.reconnect("recover", Cs.REGIONAL_DISTRIBUTION)) : (await this._gateway.setClientRole(e, n), this._config.role = e), Ee.info("[".concat(this._clientId, "] set client role to ").concat(e, ", level: ").concat(n && n.level));
      }
      async _setClientRoleOptions(e) {
        if (this.mode === "rtc" || this.mode === "p2p" || this._config.role !== "audience" || this._p2pChannel.hasLocalMedia()) return;
        let n = !1;
        try {
          e && kS(e), await this._gateway.setClientRole(this._config.role, e), n = !0;
        } catch {
        } finally {
          Ee.info("[".concat(this._clientId, "] set client role options ").concat(n ? "succeed" : "failed", ", options is ").concat(e));
        }
      }
      getRemoteInboundOffset() {
        var e;
        const n = (e = this._p2pChannel.getStats()) === null || e === void 0 ? void 0 : e.audioSend[0];
        if (!n || !n.timestamp) return 0;
        const i = n.timestamp - Date.now();
        return Math.abs(i) > 1e3 + n.rttMs + 100 ? this.ntpAlignErrorCount += 1 : this.ntpAlignErrorCount = 0, this.ntpAlignErrorCount >= 3 ? i : 0;
      }
      getNtpWallTimeInMs() {
        return document.visibilityState === "visible" && (this.remoteInboundOffset = this.getRemoteInboundOffset()), this.remoteInboundOffset + Date.now() + this._gateway.ntpOffset;
      }
      setProxyServer(e, n) {
        if (ms(e, "proxyServer"), !n) {
          if (this.connectionState !== "DISCONNECTED") throw new jt(Je.INVALID_OPERATION, "Set proxy server before join channel");
          if (this._cloudProxyServerMode !== "disabled" || this._useLocalAccessPoint) throw new jt(Je.INVALID_OPERATION, "You have already set the proxy");
        }
        this._proxyServer = e, Cn.setProxyServer(this._proxyServer), Ee.setProxyServer(this._proxyServer), Ee.info("[".concat(this._clientId, "] Set proxy server ").concat(n ? "by initialize call" : "", " success."));
      }
      setTurnServer(e, n) {
        if (Array.isArray(e) || (e = [e]), !n) {
          if (this.connectionState !== "DISCONNECTED") throw new jt(Je.INVALID_OPERATION, "Set turn server before join channel");
          if (this._cloudProxyServerMode !== "disabled" || this._useLocalAccessPoint) throw new jt(Je.INVALID_OPERATION, "You have already set the proxy");
        }
        if (NE(e)) return this._turnServer = { servers: e, mode: "original-manual" }, void Ee.info("[".concat(this._clientId, "] Set original turnserver ").concat(n ? "by initialize call" : "", " success: ").concat(e.map((i) => i.urls).join(","), "."));
        e.forEach((i) => r5(i)), this._turnServer = { servers: e, mode: "manual" }, Ee.info("[".concat(this._clientId, "] Set turnserver ").concat(n ? "by initialize call" : "", " success."));
      }
      setLicense(e) {
        if (this.connectionState !== "DISCONNECTED")
          throw new jt(Je.INVALID_OPERATION, "you should set license before join channel");
        if (ms(e, "license", 32, 32), !/^[A-Za-z\d]+$/.test(e)) throw new jt(Je.INVALID_PARAMS, "license should only contains characters from A-Z a-z 0-9");
        this._license = e, Ee.info("[".concat(this._clientId, "] set license success"), e);
      }
      startProxyServer(e) {
        if (this.connectionState !== "DISCONNECTED") throw new jt(Je.INVALID_OPERATION, "Start proxy server before join channel");
        if (this._proxyServer || this._turnServer.mode === "manual" || this._useLocalAccessPoint) throw new jt(Je.INVALID_OPERATION, "You have already set the proxy");
        const n = [3, 4, 5];
        let i;
        switch (e === void 0 && (e = 3), e) {
          case 1:
          case 2:
            throw new jt(Je.NOT_SUPPORTED, "proxy mode 1/2 has been deprecated and not supported.");
          case 3:
            i = "proxy3";
            break;
          case 4:
            i = "proxy4";
            break;
          case 5:
            i = "proxy5";
            break;
          default:
            throw new jt(Je.INVALID_PARAMS, "proxy server mode must be ".concat(n.join("|")));
        }
        this._cloudProxyServerMode = i, this.store.cloudProxyServerMode = i, Ee.info("[".concat(this._clientId, "] set cloud proxy server mode to"), this._cloudProxyServerMode);
      }
      stopProxyServer() {
        if (this.connectionState !== "DISCONNECTED") throw new jt(Je.INVALID_OPERATION, "Stop proxy server after leave channel");
        Cn.setProxyServer(), Ee.setProxyServer(), this._cloudProxyServerMode = "disabled", this.store.cloudProxyServerMode = "disabled", Ee.info("[".concat(this._clientId, "] set cloud proxy server mode to"), this._cloudProxyServerMode), this._proxyServer = void 0, this._turnServer = { mode: "auto", servers: [] };
      }
      setLocalAccessPointsV2(e) {
        if (!e.accessPoints) throw new jt(Je.INVALID_PARAMS, "accessPoints is required.");
        cd(e.accessPoints.serverList, "accessPoints.serverList"), ms(e.accessPoints.domain, "accessPoints.domain");
        const n = (te, oe) => {
          xr(te, oe, 0, 65535, !0);
        };
        let i = 443;
        if (e.accessPoints.port && (n(e.accessPoints.port, "accessPoints.port"), i = e.accessPoints.port), this._proxyServer || this._cloudProxyServerMode !== "disabled") throw new jt(Je.INVALID_OPERATION, "set local access point failed, You have already set the cloud proxy");
        ft("CLOSE_AFB_FOR_LOCAL_AP") && (Dr("JOIN_WITH_FALLBACK_SIGNAL_PROXY", !1), Dr("JOIN_WITH_FALLBACK_MEDIA_PROXY", !1));
        const o = /^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/, f = e.accessPoints.domain, T = e.accessPoints.serverList.map((te) => o.test(te) ? "".concat(te.replace(/\./g, "-"), ".").concat(f) : te), A = T.map((te) => "".concat(te, ":").concat(i));
        this._useLocalAccessPoint = !0, this._setLocalAPVersion = 2, Dr("WEBCS_DOMAIN", A), Dr("WEBCS_DOMAIN_BACKUP_LIST", A), Dr("GATEWAY_DOMAINS", [f]), e.report && e.report.hostname && Array.isArray(e.report.hostname) && e.report.hostname.length ? (cd(e.report.hostname, "report.hostname"), Dr("EVENT_REPORT_DOMAIN", e.report.hostname[0]), Dr("EVENT_REPORT_BACKUP_DOMAIN", e.report.hostname[1] || e.report.hostname[0])) : (Dr("EVENT_REPORT_DOMAIN", T[0]), Dr("EVENT_REPORT_BACKUP_DOMAIN", T[1] || T[0]));
        let R = 6443;
        e.report && e.report.port && (n(e.report.port, "report.port"), R = e.report.port), Dr("STATS_COLLECTOR_PORT", R), e.report ? Dr("ENABLE_EVENT_REPORT", !0) : Dr("ENABLE_EVENT_REPORT", !1);
        let P = "";
        e.log && e.log.hostname && Array.isArray(e.log.hostname) && e.log.hostname.length ? (cd(e.log.hostname, "log.hostname"), P = e.log.hostname[0]) : P = T[0];
        let L = 6444;
        e.log && e.log.port && (n(e.log.port, "log.port"), L = e.log.port), Dr("LOG_UPLOAD_SERVER", "".concat(P, ":").concat(L));
        let z = [];
        e.cds && e.cds.hostname && Array.isArray(e.cds.hostname) && e.cds.hostname.length ? (cd(e.cds.hostname, "cds.hostname"), z = e.cds.hostname) : z = T;
        let Y = 443;
        e.cds && e.cds.port && (n(e.cds.port, "cds.port"), Y = e.cds.port), Dr("CDS_AP", z.map((te) => "".concat(te, ":").concat(Y))), e.cds ? Dr("ENABLE_CONFIG_DISTRIBUTE", !0) : Dr("ENABLE_CONFIG_DISTRIBUTE", !1), Ee.info("set local access point v2 success");
      }
      setLocalAccessPoints(e, n) {
        if (cd(e, "serverList"), ms(n, "domain"), this._proxyServer || this._cloudProxyServerMode !== "disabled") throw new jt(Je.INVALID_OPERATION, "set local access point failed, You have already set the cloud proxy");
        const i = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        e = e.map((o) => i.test(o) ? "".concat(o.replace(/\./g, "-"), ".").concat(n) : o), this._useLocalAccessPoint = !0, this._setLocalAPVersion = 1, Dr("WEBCS_DOMAIN", e), Dr("WEBCS_DOMAIN_BACKUP_LIST", e), Dr("GATEWAY_DOMAINS", [n]), Dr("EVENT_REPORT_DOMAIN", e[0]), Dr("EVENT_REPORT_BACKUP_DOMAIN", e[1] || e[0]), Dr("LOG_UPLOAD_SERVER", "".concat(e[0], ":6444")), Ee.info("[".concat(this._clientId, "] set local access point success"));
      }
      async setRemoteDefaultVideoStreamType(e) {
        if ($i(e, "streamType", [0, 1, 4, 5, 6, 7, 8, 9]), this._remoteDefaultVideoStreamType = e, this._joinInfo) try {
          await this._gateway.setDefaultRemoteVideoStreamType(e), this._joinInfo.defaultVideoStream = this._remoteDefaultVideoStreamType;
        } catch (n) {
          throw Ee.error("[".concat(this._clientId, "] set default remote video stream type error"), n.toString()), n;
        }
        else Ee.debug("[".concat(this._clientId, "] haven't joined yet, cache remoteDefaultVideoStreamType ").concat(e));
      }
      async setRemoteVideoStreamType(e, n) {
        $i(n, "streamType", [0, 1, 4, 5, 6, 7, 8, 9]);
        try {
          await this._gateway.setRemoteVideoStreamType(e, n), setTimeout(() => {
            const i = this._users.find((o) => o.uid === e);
            i && i.videoTrack && i.videoTrack.updateMediaStreamTrackResolution();
          }, 2e3);
        } catch (i) {
          throw Ee.error("[".concat(this._clientId, "] set remote video stream type error"), i.toString()), i;
        }
        Ee.info("[".concat(this._clientId, "] set remote ").concat(e, " video stream type to ").concat(n)), this._remoteStreamTypeCacheMap.set(e, n);
      }
      async setStreamFallbackOption(e, n) {
        $i(n, "fallbackType", [0, 1, 2, 3, 4, 5, 6, 7, 8]);
        try {
          await this._gateway.setStreamFallbackOption(e, n);
        } catch (i) {
          throw Ee.error("[".concat(this._clientId, "] set stream fallback option"), i.toString()), i;
        }
        Ee.info("[".concat(this._clientId, "] set remote ").concat(e, " stream fallback type to ").concat(n)), this._streamFallbackTypeCacheMap.set(e, n);
      }
      setEncryptionConfig(e, n, i, o) {
        (function(T) {
          $i(T, "encryptionMode", ["aes-128-xts", "aes-256-xts", "aes-128-ecb", "sm4-128-ecb", "aes-128-gcm", "aes-256-gcm", "aes-128-gcm2", "aes-256-gcm2", "none"]);
        })(e), ms(n, "secret");
        const f = ["aes-128-gcm2", "aes-256-gcm2"];
        if (on(f).call(f, e)) {
          if (!i || !(i instanceof Uint8Array && i.length === 32)) throw new jt(Je.INVALID_PARAMS, "salt must be an Uint8Array and exactly equal to 32 bytes");
        } else if (i) throw new jt(Je.INVALID_PARAMS, "current encrypt mode does not need salt");
        if (o) {
          if (od(o, "encryptDataStream"), !on(f).call(f, e)) throw new jt(Je.INVALID_PARAMS, "current encrypt mode does not support data stream");
          this._encryptDataStream = !0;
        }
        new RegExp(`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.<>?/:;'"|{}\\[\\]])(?=.{8,})`).test(n) || Ee.warning(`The secret is not strong:
      The secret must contain at least 1 lowercase alphabetical character,
      The secret must contain at least 1 uppercase alphabetical character,
      The secret must contain at least 1 numeric character,
      The secret must contain at least one special character,
      The secret must be eight characters or longer.
      `), this._encryptionMode = e, this._encryptionSecret = n, i && (this._encryptionSalt = tl(i));
      }
      async renewToken(e) {
        if (ms(e, "token", 1, 2047), !this._key || !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "renewToken should not be called before user join");
        const n = this._key;
        this._key = e, this._joinInfo && (this._joinInfo.token = e);
        const i = await this._renewTokenMutex.lock();
        try {
          if (ft("USE_NEW_TOKEN")) {
            Ee.debug("[".concat(this._clientId, "] start renew token with ticket from unilbs"));
            const o = await bae(this._joinInfo, this._axiosCancelSource.token, this._config.httpRetryConfig || zi);
            Ee.debug("[".concat(this._clientId, "] get ticket from unilbs success")), await this._gateway.renewToken({ token: e, ticket: o });
          } else Ee.debug("[".concat(this._clientId, "] start renew token without ticket")), await this._gateway.renewToken({ token: e });
          Ee.debug("[".concat(this._clientId, "] renewToken success"));
        } catch (o) {
          throw this._key = n, this._joinInfo.token = n, Ee.error("[".concat(this._clientId, "] renewToken failed"), o.toString()), o;
        } finally {
          i();
        }
      }
      enableAudioVolumeIndicator() {
        this._audioVolumeIndicationInterval ? Ee.warning("you have already enabled audio volume indicator!") : this._audioVolumeIndicationInterval = window.setInterval(() => {
          const e = this._p2pChannel.getAudioLevels();
          this.safeEmit(rr.VOLUME_INDICATOR, e);
        }, ft("AUDIO_VOLUME_INDICATION_INTERVAL") || 2e3);
      }
      getRTCStats() {
        const e = this._statsCollector.getRTCStats(), n = this._gateway.getInChannelInfo();
        return e.Duration = Math.round(n.duration / 1e3), e;
      }
      async startLiveStreaming(e, n) {
        if (!n) {
          if (this.codec !== "h264") throw new jt(Je.LIVE_STREAMING_INVALID_RAW_STREAM, "raw streaming is only support h264");
          if (!this._p2pChannel.hasLocalMedia()) throw new jt(Je.LIVE_STREAMING_INVALID_RAW_STREAM, "can not find stream to raw streaming");
        }
        if (this._liveRawStreamingClient && this._liveRawStreamingClient.hasUrl(e) || this._liveTranscodeStreamingClient && this._liveTranscodeStreamingClient.hasUrl(e)) throw new jt(Je.LIVE_STREAMING_TASK_CONFLICT);
        const i = n ? fd.TRANSCODE : fd.RAW;
        return this._createLiveStreamingClient(i).startLiveStreamingTask(e, i);
      }
      setLiveTranscoding(e) {
        return this._createLiveStreamingClient(fd.TRANSCODE).setTranscodingConfig(e);
      }
      async stopLiveStreaming(e) {
        const n = [this._liveRawStreamingClient, this._liveTranscodeStreamingClient].filter((i) => i && i.hasUrl(e));
        if (!n.length) throw new jt(Je.INVALID_PARAMS, "can not find live streaming url to stop");
        await cn.all(n.map((i) => i && i.stopLiveStreamingTask(e)));
      }
      async startChannelMediaRelay(e) {
        L6(e), await this._createChannelMediaRelayClient().startChannelMediaRelay(e);
      }
      async updateChannelMediaRelay(e) {
        L6(e), await this._createChannelMediaRelayClient().updateChannelMediaRelay(e);
      }
      async stopChannelMediaRelay() {
        await this._createChannelMediaRelayClient().stopChannelMediaRelay(), this._statsCollector.onStatsChanged && (this._statsCollector.onStatsChanged = void 0);
      }
      async sendStreamMessage(e) {
        var n;
        let i = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
        if (!this._joinInfo) throw new jt(Je.INVALID_OPERATION, "can not send data stream, not joined");
        if ((typeof e == "string" || e instanceof Uint8Array) && (e = { payload: e }), typeof e.payload == "string") {
          const f = new TextEncoder();
          e.payload = f.encode(e.payload);
        }
        let o = !1;
        if (this._encryptDataStream && this._encryptDataStreamIv && this._encryptDataStreamKey && window.crypto.subtle && on(n = ["aes-128-gcm2", "aes-256-gcm2"]).call(n, this._encryptionMode) && (o = !0, e.payload = await async function(f, T, A) {
          var R;
          const P = _c(R = Array.from(A)).call(R, (Re, De) => Re + De, 0), L = { serverTs: 0, seq: qie++, length: A.length, checkSum: P }, z = new Uint8Array(l5(P, 2)), Y = new ArrayBuffer(ap), te = new DataView(Y);
          te.setUint32(0, L.serverTs), te.setUint16(4, L.seq), te.setUint16(6, L.length), te.setUint16(8, L.checkSum);
          const oe = 16 - A.length % 16;
          A = a5(A, new Uint8Array(oe));
          const He = await window.crypto.subtle.encrypt({ name: "AES-GCM", iv: f, tagLength: A5, additionalData: z }, T, A);
          return a5(new Uint8Array(Y), new Uint8Array(He));
        }(this._encryptDataStreamIv, this._encryptDataStreamKey, e.payload)), new Blob([e.payload]).size > 1024) throw new jt(Je.INVALID_PARAMS, o ? "encrypted stream message out of range." : "stream message out of range.");
        return this._gateway.signal.request(kn.DATA_STREAM, { payload: tl(e.payload), syncWithAudio: e.syncWithAudio, sendTs: Date.now() - _ae }, !i);
      }
      sendMetadata(e) {
        if (!this._joinInfo) throw new jt(Je.INVALID_OPERATION, "can not send metadata, not joined");
        if (new Blob([e]).size > 1024) throw new jt(Je.METADATA_OUT_OF_RANGE);
        return this._gateway.signal.request(kn.SEND_METADATA, { session_id: this._joinInfo.sid, metadata: tl(e) });
      }
      async sendCustomReportMessage(e) {
        if (Array.isArray(e) || (e = [e]), e.forEach(rse), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "can not send custom report, not joined");
        await Cn.sendCustomReportMessage(this._joinInfo.sid, e);
      }
      getLocalAudioStats() {
        return this._statsCollector.getLocalAudioTrackStats();
      }
      getRemoteAudioStats() {
        return this._statsCollector.getRemoteAudioTrackStats();
      }
      getLocalVideoStats() {
        return this._statsCollector.getLocalVideoTrackStats();
      }
      getRemoteVideoStats() {
        return this._statsCollector.getRemoteVideoTrackStats();
      }
      getRemoteNetworkQuality() {
        return this._statsCollector.getRemoteNetworkQualityStats();
      }
      async pickSVCLayer(e, n) {
        $i(n.spatialLayer, "spatialLayer", [0, 1, 2, 3]), $i(n.temporalLayer, "temporalLayer", [0, 1, 2, 3]);
        try {
          await this._gateway.pickSVCLayer(e, n);
        } catch (i) {
          throw Ee.error("[".concat(this._clientId, "] pick SVC layer failed"), i.toString()), i;
        }
      }
      async setRTMConfig(e) {
        const { apRTM: n = !1, rtmFlag: i } = e;
        if (od(n, "apRTM"), xr(i, "rtmFlag", 0), this._rtmConfig.apRTM = n, this._rtmConfig.rtmFlag = i, Ee.debug("[".concat(this._clientId, "] setRTMconfig ").concat(JSON.stringify(e), " in ").concat(this.connectionState, " state")), (this.connectionState === "CONNECTED" || this.connectionState === "RECONNECTING") && this._joinInfo) return this._joinInfo.apRTM = n, this._joinInfo.rtmFlag = i, this._gateway.setRTM2Flag(i);
      }
      _reset() {
        if (Ee.debug("[".concat(this._clientId, "] reset client")), this._axiosCancelSource.cancel(), this._axiosCancelSource = fa.CancelToken.source(), this._streamFallbackTypeCacheMap = /* @__PURE__ */ new Map(), this._remoteStreamTypeCacheMap = /* @__PURE__ */ new Map(), this._configDistribute.stopGetConfigDistribute(), this._joinInfo && d7(this._joinInfo), this._joinInfo = void 0, this._proxyServer = void 0, this._defaultStreamFallbackType = void 0, this._sessionId && Cn.removeSid(this._sessionId), this._sessionId = null, this.store.sessionId = null, this._statsCollector.reset(), this._key = void 0, this._appId = void 0, this._uid = void 0, this.store.uid = void 0, this._channelName = void 0, this._encryptionMode = "none", this._encryptionSecret = null, this._encryptionSalt = null, this._encryptDataStreamKey = null, this._encryptDataStreamIv = null, this._pendingPublishedUsers = [], this._users.forEach((e) => {
          e._audioTrack && e._audioTrack._destroy(), e._videoTrack && e._videoTrack._destroy(), e._dataChannels && (e._dataChannels.forEach((n) => n._close()), e._dataChannels.length = 0);
        }), this._users = [], this._audioVolumeIndicationInterval && (window.clearInterval(this._audioVolumeIndicationInterval), this._audioVolumeIndicationInterval = void 0), this._cloudProxyServerMode === "fallback" && (this._cloudProxyServerMode = "disabled", this.store.cloudProxyServerMode = "disabled"), this._p2pChannel.reset(), this._publishMutex = new xs("client-publish", this._clientId), this._subscribeMutex = new xs("client-subscribe", this._clientId), this._networkQualityInterval && (window.clearInterval(this._networkQualityInterval), this._networkQualityInterval = void 0), this._liveRawStreamingClient && (this._liveRawStreamingClient.terminate(), this._liveRawStreamingClient.removeAllListeners(), this._liveRawStreamingClient = void 0), this._liveTranscodeStreamingClient && (this._liveTranscodeStreamingClient.terminate(), this._liveTranscodeStreamingClient.removeAllListeners(), this._liveTranscodeStreamingClient = void 0), this._channelMediaRelayClient && (this._channelMediaRelayClient.dispose(), this._channelMediaRelayClient = void 0), this._inspect) try {
          this._inspect.close(), this._inspect = void 0;
        } catch {
        }
        if (this._moderation) try {
          this.setImageModeration(!1);
        } catch {
        }
      }
      _startSession(e, n) {
        var i;
        const o = e || rp();
        e ? Ee.debug("[".concat(this._clientId, "] new Session ").concat(o)) : Ee.debug("[".concat(this._clientId, "] renewSession ").concat(this._sessionId, " => ").concat(o));
        const f = e ? "" : this._sessionId || "";
        this._sessionId = o, this.store.sessionId = o, Cn.addSid(o);
        const T = { lts: (/* @__PURE__ */ new Date()).getTime(), mode: this.mode, buildFormat: 1, stringUid: (n == null ? void 0 : n.stringUid) || ((i = this._joinInfo) === null || i === void 0 ? void 0 : i.stringUid), channelProfile: this.mode === "live" ? 1 : 0, channelMode: 0, isABTestSuccess: Number(this._configDistribute.isSuccess), lsid: f, clientRole: this.role === "audience" ? 2 : 1 };
        Cn.sessionInit(this._sessionId, lc({ cname: n.channel, appid: n.appId }, T)), this._joinInfo && (this._joinInfo.sid = o), this._gateway.joinInfo && (this._gateway.joinInfo.sid = o);
      }
      async _publishHighStream(e) {
        if (!this._joinInfo || this._uid === void 0) throw new jt(Je.INVALID_OPERATION, "Can't publish stream, haven't joined yet!");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish stream in ".concat(this.connectionState, " state"));
        if (this._turnServer.mode === "auto" && ft("FORCE_TURN") && !ft("TURN_ENABLE_TCP") && !ft("TURN_ENABLE_UDP")) throw new jt(Je.UNEXPECTED_ERROR, "force TURN With No TURN Configuration");
        Ee.debug("[".concat(this._clientId, "] publish high stream"));
        try {
          const i = await this._p2pChannel.publish(e, this._isDualStreamEnabled, this._lowStreamParameter);
          if (this.store.useP2P) {
            const o = (await i.next()).value;
            if (o) {
              try {
                await this._gateway.sendExtensionMessage(bi.PUBLISH, o, !0);
              } catch (f) {
                throw i.throw(f), f;
              }
              await i.next();
            }
            this._p2pChannel.reportPublishEvent(!0, null);
          } else {
            const o = (await i.next()).value;
            if (o) {
              var n;
              let f;
              try {
                f = await this._gateway.publish(this._uid, o, !0);
              } catch (T) {
                if (T.code !== Je.DISCONNECT_P2P) throw i.throw(T), T;
              }
              await i.next(((n = f) === null || n === void 0 ? void 0 : n.ortc) || []);
            }
            this._p2pChannel.reportPublishEvent(!0, null);
            for (const f of e) f instanceof Wr && f._encoderConfig && this._gateway.setVideoProfile(f._encoderConfig).catch((T) => {
              Ee.debug("[".concat(this._clientId, "] stop setVideoProfile, because websocket is closed"));
            }), !f.muted && f.enabled || await this._p2pChannel.muteLocalTrack(f);
          }
        } catch (i) {
          if (this._p2pChannel.reportPublishEvent(!1, i == null ? void 0 : i.code, e), (i == null ? void 0 : i.code) === Je.WS_ABORT) return;
          throw i;
        }
      }
      async _publishLowStream() {
        if (!this._joinInfo || this._uid === void 0) throw new jt(Je.INVALID_OPERATION, "Can't publish stream, haven't joined yet!");
        if (this.connectionState !== "CONNECTED" && this.connectionState !== "RECONNECTING") throw new jt(Je.INVALID_OPERATION, "can not publish stream in ".concat(this.connectionState, " state"));
        Ee.debug("[".concat(this._clientId, "] publish low stream"));
        const e = this._configDistribute.getLowStreamConfigDistribute();
        e && e.bitrate && (this._lowStreamParameter || (this._lowStreamParameter = { width: 160, height: 120, framerate: 15, bitrate: 50 }), this._lowStreamParameter && this._lowStreamParameter.bitrate && e.bitrate < this._lowStreamParameter.bitrate && (this._lowStreamParameter.bitrate = e.bitrate));
        try {
          const i = await this._p2pChannel.publishLowStream(this._lowStreamParameter), o = (await i.next()).value;
          if (o) {
            var n;
            let f;
            try {
              f = await this._gateway.publish(this._uid, o, !0);
            } catch (T) {
              if (T.code !== Je.DISCONNECT_P2P) throw i.throw(T), T;
            }
            i.next(((n = f) === null || n === void 0 ? void 0 : n.ortc) || []), this._p2pChannel.reportPublishEvent(!0, null, void 0, !0);
          }
        } catch (i) {
          if (this._p2pChannel.reportPublishEvent(!1, i == null ? void 0 : i.code, void 0, !0), (i == null ? void 0 : i.code) === Je.WS_ABORT) return;
          throw i;
        }
      }
      _createLiveStreamingClient(e) {
        const n = () => {
          if (!this._joinInfo || !this._appId)
            return new jt(Je.INVALID_OPERATION, "can not create live streaming client, please join channel first").throw();
          const i = (o = { joinInfo: this._joinInfo, appId: this._appId, websocketRetryConfig: this._config.websocketRetryConfig, httpRetryConfig: this._config.httpRetryConfig }, ol("LiveStreaming").create(o));
          var o;
          return i.onLiveStreamError = (f, T) => {
            Cn.reportApiInvoke(this._sessionId, { name: Bi.ON_LIVE_STREAM_ERROR, options: [f, T], tag: si.TRACER }).onSuccess(), this.safeEmit(rr.LIVE_STREAMING_ERROR, f, T);
          }, i.onLiveStreamWarning = (f, T) => {
            Cn.reportApiInvoke(this._sessionId, { name: Bi.ON_LIVE_STREAM_WARNING, options: [f, T], tag: si.TRACER }).onSuccess(), this.safeEmit(rr.LIVE_STREAMING_WARNING, f, T);
          }, i.on(EI.REQUEST_WORKER_MANAGER_LIST, (f, T, A) => {
            if (!this._joinInfo) return A(new jt(Je.INVALID_OPERATION, "can not find join info to get worker manager"));
            (async function(R, P, L, z) {
              const Y = ft("UAP_AP").slice(0, ft("AJAX_REQUEST_CONCURRENT")).map((te) => P.proxyServer ? "https://".concat(P.proxyServer, "/ap/?url=").concat(te + "/api/v1?action=uap") : "https://".concat(te, "/api/v1?action=uap"));
              return await gae(Y, R, P, L, z);
            })(f, this._joinInfo, this._axiosCancelSource.token, zi).then(T).catch(A);
          }), i;
        };
        return e === fd.RAW ? (this._liveRawStreamingClient = this._liveRawStreamingClient || n(), this._liveRawStreamingClient) : (this._liveTranscodeStreamingClient = this._liveTranscodeStreamingClient || n(), this._liveTranscodeStreamingClient);
      }
      _createChannelMediaRelayClient() {
        if (!this._joinInfo)
          return new jt(Je.INVALID_OPERATION, "can not create channel media relay client, please join channel first").throw();
        if (!this._channelMediaRelayClient) {
          const { sendResolutionWidth: n, sendResolutionHeight: i } = this.getLocalVideoStats(), o = (e = { joinInfo: this._joinInfo, clientId: this._clientId, websocketRetryConfig: this._config.websocketRetryConfig, httpRetryConfig: this._config.httpRetryConfig, resolution: { width: n, height: i } }, ol("ChannelMediaRelay").create(e));
          o.on("state", (f) => {
            f === Sa.RELAY_STATE_FAILURE && o && o.dispose(), this.safeEmit(rr.CHANNEL_MEDIA_RELAY_STATE, f);
          }), o.on("event", (f) => {
            this.safeEmit(rr.CHANNEL_MEDIA_RELAY_EVENT, f);
          }), this._channelMediaRelayClient = o, this._statsCollector.onStatsChanged = (f, T) => {
            var A;
            f === "resolution" && ((A = this._channelMediaRelayClient) === null || A === void 0 || A.setVideoProfile(T));
          };
        }
        var e;
        return this._channelMediaRelayClient;
      }
      _handleUpdateDataChannel(e, n) {
        const { added: i, deleted: o } = e, f = [];
        if (n) {
          const T = [];
          this._users.forEach((A) => {
            A._dataChannels.forEach((R) => {
              i.every((P) => P.uid !== A._uintid || P.stream_id !== R.id) && T.push({ uid: A._uintid, stream_id: R.id, ordered: R.ordered, max_retrans_times: R.maxRetransmits, metadata: R.metadata });
            });
          }), T.length > 0 && this._handleUpdateDataChannel({ added: [], deleted: T });
        }
        Array.isArray(i) && i.length > 0 && i.forEach((T) => {
          const { uid: A, stream_id: R, ordered: P, max_retrans_times: L, metadata: z } = T, Y = this._users.find((te) => te._uintid === A);
          if (!Y) return void Ee.error("[".concat(this._clientId, "] can not find target user!(on_add_data_channel)"));
          if (Ee.debug("[".concat(this._clientId, "] data_channel added with uid ").concat(A)), on(f).call(f, Y) || f.push(Y), Y._uintid || (Y._uintid = A), Y._dataChannels.findIndex((te) => te.id === T.stream_id) === -1) {
            const te = { id: R, ordered: !!P, maxRetransmits: L, metadata: z }, oe = function(He) {
              return E6(He, !0);
            }(te);
            Y._dataChannels.push(oe), Ee.info("[".concat(this._clientId, "] remote user ").concat(Y.uid, " published datachannel")), n || this.safeEmit(rr.USER_PUBLISHED, Y, "datachannel", te);
          }
          this._p2pChannel.hasPendingRemoteDataChannel(Y, T.stream_id) && (Ee.debug("[".concat(this._clientId, "] resubscribe datachannel for user ").concat(Y.uid, " after reconnect.")), this._subscribeDataChannel(Y, T.stream_id).catch((te) => {
            Ee.error("[".concat(this._clientId, "] resubscribe datachannel error"), te.toString());
          }));
        }), n && (this.safeEmit(rr.PUBLISHED_USER_LIST, this._pendingPublishedUsers), this._pendingPublishedUsers = []), Array.isArray(o) && o.length > 0 && o.forEach((T) => {
          const { uid: A, stream_id: R } = T, P = this._users.find((z) => z._uintid === A);
          if (!P) return void Ee.error("[".concat(this._clientId, "] can not find target user!(on_delete_data_channel)"));
          const L = P._dataChannels.find((z) => z.id === T.stream_id);
          L && (Ee.debug("[".concat(this._clientId, "] data_stream delete with uid ").concat(A)), this._p2pChannel.unsubscribeDataChannel(P, [L]).then((z) => {
            if (P._dataChannels = P._dataChannels.filter((Y) => Y !== L), z) return this._gateway.unsubscribeDataChannel(z, P.uid);
          }), Ee.info("[".concat(this._clientId, "] remote user ").concat(A, " unpublished datachannel ,id:").concat(L.id)), this.safeEmit(rr.USER_UNPUBLISHED, P, "datachannel", L._config));
        });
      }
      _handleRemoveDataChannels(e) {
        const n = this._users.find((i) => i.uid === e.uid);
        if (n) {
          if (n._dataChannels !== void 0 && n._dataChannels.length > 0) {
            Ee.debug("[".concat(this._clientId, "] datachannel removed with uid ").concat(e.uid));
            const i = () => {
              Ee.info("[".concat(this._clientId, "] remote user ").concat(n.uid, " unpublished datachannel")), n._dataChannels.forEach((o) => {
                this.safeEmit(rr.USER_UNPUBLISHED, n, "datachannel", o._config);
              });
            };
            this._p2pChannel.unsubscribeDataChannel(n, n._dataChannels).then((o) => {
              if (o) return this._gateway.unsubscribeDataChannel(o, n.uid);
            }), i();
          }
        } else Ee.warning("[".concat(this._clientId, "] can not find target user!(on_remove_datachannel)"));
      }
      _handleGatewayEvents() {
        this._gateway.on(Ns.DISCONNECT_P2P, async () => {
          await this._p2pChannel.disconnectForReconnect();
        }), this._gateway.on(Ns.CONNECTION_STATE_CHANGE, (e, n, i) => {
          var o;
          if (i === br.FALLBACK) return;
          const f = () => {
            this.safeEmit(rr.CONNECTION_STATE_CHANGE, e, n, i);
          };
          if (Cn.reportApiInvoke(this._sessionId || ((o = this._gateway.joinInfo) === null || o === void 0 ? void 0 : o.sid) || null, { name: Bi.CONNECTION_STATE_CHANGE, options: [e, n, i], tag: si.TRACER }).onSuccess(JSON.stringify({ cur: e, prev: n, reason: i })), Ee.info("[".concat(this._clientId, "] signal connection state change: ").concat(n, " -> ").concat(e)), e === "DISCONNECTED") return this._reset(), void f();
          if (e === "RECONNECTING") this._users.forEach((A) => {
            A._trust_in_room_ = !1, A._trust_audio_enabled_state_ = !1, A._trust_video_enabled_state_ = !1, A._trust_audio_mute_state_ = !1, A._trust_video_mute_state_ = !1, A._trust_audio_stream_added_state_ = !1, A._trust_video_stream_added_state_ = !1, A._is_pre_created || (A._audio_pre_subscribed || (A._audioSSRC = void 0, A._audioOrtc = void 0), A._video_pre_subscribed || (A._videoSSRC = void 0, A._videoOrtc = void 0, A._rtxSsrcId = void 0), A._cname = void 0);
          }), this._userOfflineTimeout && window.clearTimeout(this._userOfflineTimeout), this._streamRemovedTimeout && window.clearTimeout(this._streamRemovedTimeout), this._userOfflineTimeout = void 0, this._streamRemovedTimeout = void 0;
          else if (e === "CONNECTED") {
            var T;
            this._streamFallbackTypeCacheMap.forEach((A, R) => {
              this._gateway.setStreamFallbackOption(R, A).catch((P) => {
                Ee.warning("[".concat(this._clientId, "] auto set stream fallback option failed"), P);
              });
            }), this._remoteStreamTypeCacheMap.forEach((A, R) => {
              this._gateway.setRemoteVideoStreamType(R, A).catch((P) => {
                Ee.warning("[".concat(this._clientId, "] auto set remote stream type failed"), P);
              });
            }), this._remoteDefaultVideoStreamType !== void 0 && ((T = this._joinInfo) === null || T === void 0 ? void 0 : T.defaultVideoStream) === void 0 && this.setRemoteDefaultVideoStreamType(this._remoteDefaultVideoStreamType).then(() => {
              Ee.debug("[".concat(this._clientId, "] setRemoteDefaultVideoStreamType after gateway connected"));
            }).catch((A) => {
              Ee.error("[".concat(this._clientId, "] setRemoteDefaultVideoStreamType after gateway failed, ").concat(A));
            }), this.store.useP2P || (this._p2pChannel.republish(), this._userOfflineTimeout = window.setTimeout(() => {
              this.connectionState === "CONNECTED" && (this._userOfflineTimeout = void 0, this._users.filter((A) => !A._trust_in_room_).forEach((A) => {
                Ee.debug("[".concat(this._clientId, "] user offline timeout, emit user offline ").concat(A.uid)), this._handleUserOffline({ uid: A.uid });
              }));
            }, 3e3), this._streamRemovedTimeout = window.setTimeout(() => {
              this.connectionState === "CONNECTED" && (this._streamRemovedTimeout = void 0, this._users.forEach((A) => {
                A._trust_audio_mute_state_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch audio unmute event ").concat(A.uid)), this._handleMuteStream(A.uid, vn.AUDIO, !1)), A._trust_video_mute_state_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch video unmute event ").concat(A.uid)), this._handleMuteStream(A.uid, vn.VIDEO, !1)), A._trust_audio_enabled_state_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch enable local audio ").concat(A.uid)), this._handleSetStreamLocalEnable("audio", A.uid, !0)), A._trust_video_enabled_state_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch enable local video ").concat(A.uid)), this._handleSetStreamLocalEnable("video", A.uid, !0)), A._trust_video_stream_added_state_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch reset video stream added ").concat(A.uid)), this._handleResetAddStream(A, "video")), A._trust_audio_stream_added_state_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch reset audio stream added ").concat(A.uid)), this._handleResetAddStream(A, "audio")), A._video_added_ || A._audio_added_ || (Ee.debug("[".concat(this._clientId, "] auto dispatch stream remove ").concat(A.uid)), this._handleRemoveStream({ uid: A.uid, uint_id: A._uintid }));
              }));
            }, 1e3));
          }
          f();
        }), this._gateway.on(Ns.REQUEST_NEW_GATEWAY_LIST, async (e, n) => {
          if (!this._joinInfo) return n(new jt(Je.UNEXPECTED_ERROR, "can not recover, no join info"));
          try {
            let i;
            const o = await c7(lc(lc({}, this._joinInfo), {}, { uid: this._joinInfo.uid, stringUid: void 0 }));
            o ? (i = o.ap, l7(o), this._joinInfo.preload = !0) : (i = await DI(this._joinInfo, this._axiosCancelSource.token, this._config.httpRetryConfig || zi, this.store), this._joinInfo.preload = !1), this._joinInfo && (this._joinInfo.apResponse = i.gatewayInfo.res, this._joinInfo.gatewayAddrs = i.gatewayInfo.gatewayAddrs, this._joinInfo.uni_lbs_ip = i.gatewayInfo.uni_lbs_ip);
            const f = [];
            i.gatewayInfo.gatewayAddrs.forEach((T) => {
              let { address: A } = T;
              const [R, P] = A.split(":");
              this._joinInfo && this._joinInfo.proxyServer ? f.push({ proxy: this._joinInfo.proxyServer, host: R, port: P }) : f.push({ host: R, port: P });
            }), e(f);
          } catch (i) {
            n(i);
          }
        }), this._gateway.on(Ns.NETWORK_QUALITY, (e) => {
          this._networkQualitySensitivity === "normal" && this.safeEmit(rr.NETWORK_QUALITY, e);
        }), this._gateway.on(Ns.STREAM_TYPE_CHANGE, (e, n) => {
          this.safeEmit(rr.STREAM_TYPE_CHANGED, e, n), Cn.reportApiInvoke(this._sessionId, { name: Bi.STREAM_TYPE_CHANGE, options: [e, n], tag: si.TRACER }).onSuccess(JSON.stringify({ uid: e, streamType: n }));
        }), this._gateway.on(Ns.IS_P2P_DISCONNECTED, (e) => {
          this._p2pChannel.isP2PDisconnected() ? e(!0) : this._p2pChannel.hasLocalMedia() || this._p2pChannel.hasRemoteMedia() ? e(!1) : e(!0);
        }), this._gateway.on(Ns.REQUEST_P2P_CONNECTION_PARAMS, async (e, n, i) => {
          try {
            let o = await this._p2pChannel.getEstablishParams();
            ft("ENABLE_PREALLOC_PC") && o || (o = await this._p2pChannel.startP2PConnection(e)), n(o);
          } catch (o) {
            i(o);
          }
        }), this._gateway.on(Ns.JOIN_RESPONSE, (e, n) => {
          if (this.store.useP2P) return;
          let i;
          e.attributes ? i = e.attributes.userAttributes.preSubSsrcs : Ee.debug("no attributes in joinResponse");
          const o = s6(e.ortc, n, i);
          this._p2pChannel.connect(o);
        }), this._gateway.on(Ns.PRE_CONNECT_PC, async (e) => {
          const { candidates: n, fingerprint: i } = e;
          if (this._joinInfo && n.length > 0 && !this._p2pChannel.isPlanB) {
            var o;
            await this._p2pChannel.startP2PConnection({ turnServer: this._joinInfo.turnServer });
            const { cert: f, cid: T } = this._joinInfo.apResponse;
            await this._p2pChannel.connect({ iceParameters: { iceUfrag: "".concat(T, "_").concat(f), icePwd: "".concat(T, "_").concat(f) }, dtlsParameters: { fingerprints: [{ hashFunction: "sha-256", fingerprint: (o = ft("FINGERPRINT")) !== null && o !== void 0 ? o : i }] }, candidates: n, rtpCapabilities: { send: { audioCodecs: [], videoCodecs: [], audioExtensions: [], videoExtensions: [] }, recv: { audioCodecs: [], videoCodecs: [], audioExtensions: [], videoExtensions: [] } }, setup: "active", cname: "o/i14u9pJrxRKAsu", preallocation: !0 });
          }
        });
      }
      _handleGatewaySignalEvents() {
        this._gateway.signal.on(nr.ON_USER_ONLINE, this._handleUserOnline), this._gateway.signal.on(nr.ON_USER_OFFLINE, this._handleUserOffline), this._gateway.signal.on(nr.ON_ADD_AUDIO_STREAM, (e) => this._handleAddAudioOrVideoStream("audio", e.uid, e.ssrcId, e.cname, e.uint_id, e.ortc)), this._gateway.signal.on(nr.ON_ADD_VIDEO_STREAM, (e) => this._handleAddAudioOrVideoStream("video", e.uid, e.ssrcId, e.cname, e.uint_id, e.ortc, e.rtxSsrcId)), this._gateway.signal.on(nr.ON_REMOTE_DATASTREAM_UPDATE, (e) => {
          this._handleUpdateDataChannel(e);
        }), this._gateway.signal.on(nr.ON_REMOTE_FULL_DATASTREAM_INFO, (e) => {
          this._handleUpdateDataChannel({ added: e.datastreams || [], deleted: [] }, !0);
        }), this._gateway.signal.on(nr.ON_REMOVE_STREAM, this._handleRemoveStream), this._gateway.signal.on(nr.ON_P2P_LOST, this._handleP2PLost), this._gateway.signal.on(nr.MUTE_AUDIO, (e) => this._handleMuteStream(e.uid, vn.AUDIO, !0)), this._gateway.signal.on(nr.UNMUTE_AUDIO, (e) => this._handleMuteStream(e.uid, vn.AUDIO, !1)), this._gateway.signal.on(nr.MUTE_VIDEO, (e) => this._handleMuteStream(e.uid, vn.VIDEO, !0)), this._gateway.signal.on(nr.UNMUTE_VIDEO, (e) => this._handleMuteStream(e.uid, vn.VIDEO, !1)), this._gateway.signal.on(nr.RECEIVE_METADATA, (e) => {
          const n = Tf(e.metadata);
          this.safeEmit(rr.RECEIVE_METADATA, e.uid, n);
        }), this._gateway.signal.on(nr.ON_DATA_STREAM, async (e) => {
          var n;
          if (!e) return;
          let i = Tf(e.payload);
          if (this._encryptDataStream && this._encryptDataStreamIv && this._encryptDataStreamKey && window.crypto.subtle && on(n = ["aes-128-gcm2", "aes-256-gcm2"]).call(n, this._encryptionMode)) {
            if (e.payload.length < ap) throw new jt(Je.UNEXPECTED_RESPONSE, "payload length ".concat(e.payload.length, " is less than header length ").concat(ap));
            i = await async function(T, A, R) {
              const P = R.subarray(0, ap), L = P.slice(8, ap), z = (L[0] << 8) + L[1], Y = (P[6] << 8) + P[7], te = await window.crypto.subtle.decrypt({ name: "AES-GCM", iv: T, tagLength: A5, additionalData: new Uint8Array(l5(z, 2)) }, A, R.subarray(ap));
              return new Uint8Array(te).subarray(0, Y);
            }(this._encryptDataStreamIv, this._encryptDataStreamKey, i);
          }
          let o = 0;
          if (e.ordered || e.syncWithAudio) {
            const f = this._p2pChannel.getStats(), T = this.remoteUsers.find((R) => R.uid === e.uid), A = f == null ? void 0 : f.audioRecv.find((R) => R.ssrc === (T == null ? void 0 : T._audioSSRC));
            o = A == null ? void 0 : A.jitterBufferMs;
          }
          o == null && (o = 0), xae(lc(lc({}, e), {}, { payload: i }), o, { id: this._clientId, onStreamMessage: typeof this.onStreamMessage == "function" ? this.onStreamMessage.bind(this) : void 0, safeEmit: this.safeEmit.bind(this) });
        }), this._gateway.signal.on(nr.ON_CRYPT_ERROR, () => {
          el(() => {
            Ee.warning("[".concat(this._clientId, "] on crypt error")), this.safeEmit(rr.CRYPT_ERROR);
          }, this._sessionId);
        }), this._gateway.signal.on(nr.ON_TOKEN_PRIVILEGE_WILL_EXPIRE, this._handleTokenWillExpire), this._gateway.signal.on(nr.ON_TOKEN_PRIVILEGE_DID_EXPIRE, () => {
          Ee.warning("[".concat(this._clientId, "] received message onTokenPrivilegeDidExpire, please get new token and join again")), this._gateway.leave(!0, br.TOKEN_EXPIRE), this.safeEmit(rr.ON_TOKEN_PRIVILEGE_DID_EXPIRE), this._reset();
        }), this._gateway.signal.on(nr.ON_STREAM_FALLBACK_UPDATE, (e) => {
          Ee.debug("[".concat(this._clientId, "] stream fallback peerId: ").concat(e.stream_id, ", attr: ").concat(e.stream_type)), this.safeEmit(rr.STREAM_FALLBACK, e.stream_id, e.stream_type === 1 ? "fallback" : "recover");
        }), this._gateway.signal.on(nr.ON_PUBLISH_STREAM, (e) => {
          this.uid === this._uid && (this._p2pChannel.reportPublishEvent(!0, null, void 0, !1, JSON.stringify({ proxy: e.proxy })), Ee.info("[".concat(this._clientId, "] on publish stream, ").concat(JSON.stringify(e))));
        }), this._gateway.signal.on(nr.ENABLE_LOCAL_VIDEO, (e) => {
          this._handleSetStreamLocalEnable("video", e.uid, !0);
        }), this._gateway.signal.on(nr.DISABLE_LOCAL_VIDEO, (e) => {
          this._handleSetStreamLocalEnable("video", e.uid, !1);
        }), this._gateway.signal.on(jn.REQUEST_TIMEOUT, (e, n) => {
          if (this._joinInfo) switch (e) {
            case kn.PUBLISH: {
              if (!n) return;
              const f = n.ortc;
              if (f) {
                var i, o;
                const T = f.some((P) => {
                  let { stream_type: L } = P;
                  return L === Sr.Audio;
                }), A = f.some((P) => {
                  let { stream_type: L } = P;
                  return L !== Sr.Audio;
                }), R = f.some((P) => {
                  let { stream_type: L } = P;
                  return L === Sr.Screen || L === Sr.ScreenLow;
                });
                n.state === "offer" && Cn.publish(this._joinInfo.sid, { eventElapse: Ms.measureFromPublishStart(this.store.clientId, this.store.pubId), succ: !1, ec: Je.TIMEOUT, audio: T, video: A, p2pid: n.p2p_id, publishRequestid: this.store.pubId, screenshare: R, audioName: T ? (i = f.find((P) => {
                  let { stream_type: L } = P;
                  return L === Sr.Audio;
                })) === null || i === void 0 || (i = i.ssrcs[0]) === null || i === void 0 ? void 0 : i.ssrcId.toString() : void 0, videoName: A ? (o = f.find((P) => {
                  let { stream_type: L } = P;
                  return L !== Sr.Audio;
                })) === null || o === void 0 || (o = o.ssrcs[0]) === null || o === void 0 ? void 0 : o.ssrcId.toString() : void 0 });
              }
              break;
            }
            case kn.SUBSCRIBE:
              n && Cn.subscribe(this._joinInfo.sid, { succ: !1, ec: Je.TIMEOUT, audio: n.stream_type === vn.AUDIO, video: n.stream_type === vn.VIDEO, peerid: n.stream_id, subscribeRequestid: n.ssrcId, p2pid: this.store.p2pId, eventElapse: Ms.measureFromSubscribeStart(this.store.clientId, n.ssrcId), preSsrc: this._p2pChannel.isPreSubScribe(n.ssrcId) });
          }
        }), this._gateway.signal.on(nr.ON_P2P_OK, (e) => {
          this.uid, this._uid;
        }), this._gateway.signal.on(nr.ON_PUBLISHED_USER_LIST, (e) => {
          if (e == null || !e.users) return;
          ft("BLOCK_LOCAL_CLIENT") && (e.users = e.users.filter((o) => !If(o.string_id || o.stream_id, this.channelName)));
          const n = [], i = [];
          for (const o of e.users) {
            let f = this._users.find((z) => z._uintid === o.stream_id);
            f ? f._trust_in_room_ = !0 : (f = new cl(o.string_id || o.stream_id, o.stream_id), this._users.push(f), this.getListeners(rr.PUBLISHED_USER_LIST).length === 0 && (Ee.debug("[".concat(this._clientId, "] user online"), o.stream_id), this.safeEmit(rr.USER_JOINED, f)));
            const T = ns.Audio & o.stream_type, A = (ns.Video | ns.LwoVideo) & o.stream_type, R = (65280 & o.stream_type) != 0, P = T && f.hasAudio, L = A && f.hasVideo;
            A && (f._trust_video_stream_added_state_ = !0, f._video_added_ = !0, f._videoSSRC = o.video_ssrc, f._rtxSsrcId = o.video_rtx), T && (f._trust_audio_stream_added_state_ = !0, f._audio_added_ = !0, f._audioSSRC = o.audio_ssrc), T && !P && this.getListeners(rr.PUBLISHED_USER_LIST).length === 0 && (Ee.info("[".concat(this._clientId, "] remote user ").concat(f.uid, " published audio")), this.safeEmit(rr.USER_PUBLISHED, f, "audio")), A && !L && this.getListeners(rr.PUBLISHED_USER_LIST).length === 0 && (Ee.info("[".concat(this._clientId, "] remote user ").concat(f.uid, " published video")), this.safeEmit(rr.USER_PUBLISHED, f, "video")), (T && !P || A && !L || R) && n.push(f), A && this._p2pChannel.hasPendingRemoteMedia(f, "video") && i.push({ user: f, mediaType: "video" }), T && this._p2pChannel.hasPendingRemoteMedia(f, "audio") && i.push({ user: f, mediaType: "audio" });
          }
          i.length > 0 && (Ee.debug("[".concat(this._clientId, "] RE massSubscribe after reconnect ").concat(i.map((o) => "user: ".concat(o.user.uid, ", mediaType: ").concat(o.mediaType)).join("; "), " ")), this.massSubscribe(i).catch((o) => {
            Ee.error("[".concat(this._clientId, "] mass resubscribe error"), o.toString());
          })), this.getListeners(rr.PUBLISHED_USER_LIST).length > 0 ? ft("ENABLE_DATASTREAM_2") ? this._pendingPublishedUsers = n : (Ee.info("[".concat(this._clientId, "] client emit user-list event, users: ").concat(n.map((o) => o.uid).join(", "))), this.safeEmit(rr.PUBLISHED_USER_LIST, n)) : Ee.info("[".concat(this._clientId, "] client not emit user-list event case there is no user-list listener, users: ").concat(n.map((o) => o.uid).join(", ")));
        }), this._gateway.signal.on(nr.ON_RTP_CAPABILITY_CHANGE, (e) => {
          const { video_codec: n } = e;
          this._p2pChannel instanceof QT && this._p2pChannel.updateRemoteRTPCapabilities(n.map((i) => i.toLowerCase()).filter((i) => {
            var o;
            return on(o = Object.keys(mT)).call(o, i);
          }));
        });
      }
      _handleP2PEvents() {
        this._gateway.signal.on(nr.ON_USER_OFFLINE, () => {
          this._p2pChannel.disconnectForReconnect();
        }), this._gateway.signal.on(bi.PUBLISH, (e, n, i) => {
          const { uid: o } = e;
          e.forEach((f) => {
            const { kind: T, ssrcs: A, mid: R, isMuted: P } = f;
            this._handleP2PAddAudioOrVideoStream(T, o, A[0].ssrcId, R);
            const L = this._users.find((z) => z.uid === o);
            return L && this.store.useP2P ? this._p2pChannel.mockSubscribe(L, T, A[0].ssrcId, R).then(() => {
              n();
            }).catch(i) : n(), this._handleMuteStream(o, T, !!P);
          });
        }), this._gateway.signal.on(bi.CALL, async (e, n, i) => {
          if (this.store.useP2P) try {
            var o;
            n(await this._p2pChannel.startP2P({ turnServer: (o = this._joinInfo) === null || o === void 0 ? void 0 : o.turnServer }, e));
          } catch (f) {
            i(f);
          }
        }), this._gateway.signal.on(jn.P2P_CONNECTION, async (e) => {
          this.store.useP2P && (await this._p2pChannel).p2pConnect(e);
        }), this._gateway.signal.on(bi.UNPUBLISH, async (e, n, i) => {
          if (this.store.useP2P) {
            const { unpubMsg: o, uid: f } = e, T = this._users.find((A) => A.uid === f);
            if (!T) return Ee.warning("[".concat(this._clientId, "] can not find remote user, ignore mute event, uid: ").concat(f)), void n();
            try {
              o.forEach(async (A) => {
                let { stream_type: R } = A;
                const P = R === Sr.Audio ? vn.AUDIO : vn.VIDEO;
                await this._p2pChannel.unsubscribe(T, P), this._handleMuteStream(f, P, !0);
              }), n();
            } catch (A) {
              i(A);
            }
          }
        }), this._gateway.signal.on(bi.CONTROL, async (e, n) => {
          const { action: i } = e;
          switch (i) {
            case il.MUTE_LOCAL_VIDEO:
              this._handleMuteStream(n, vn.VIDEO, !0);
              break;
            case il.MUTE_LOCAL_AUDIO:
              this._handleMuteStream(n, vn.AUDIO, !0);
              break;
            case il.UNMUTE_LOCAL_VIDEO:
              this._handleP2PAddAudioOrVideoStream("video", n), this._handleMuteStream(n, vn.VIDEO, !1);
              break;
            case il.UNMUTE_LOCAL_AUDIO:
              this._handleP2PAddAudioOrVideoStream("audio", n), this._handleMuteStream(n, vn.AUDIO, !1);
          }
        }), this._gateway.signal.on(bi.RESTART_ICE, async (e, n, i) => {
          if (this.store.useP2P) try {
            const { direction: o, iceParameter: f } = e;
            o !== ia.SEND_ONLY || f ? n(await this._p2pChannel.restartICE(o, f)) : (this._p2pChannel.handleDisconnect(o), n());
          } catch (o) {
            i(o);
          }
        }), this._gateway.signal.on(bi.CANDIDATE, (e) => {
          if (this.store.useP2P) {
            const { candidate: n, direction: i } = e;
            this._p2pChannel.addRemoteCandidate(n, i);
          }
        }), this._p2pChannel.on(wn.RequestP2PRestartICE, async (e, n, i) => {
          try {
            const { direction: o } = e;
            n(await this._gateway.sendExtensionMessage(bi.RESTART_ICE, e, o === ia.SEND_ONLY));
          } catch (o) {
            i(o);
          }
        }), this._p2pChannel.on(wn.LocalCandidate, (e) => {
          this._gateway.sendExtensionMessage(bi.CANDIDATE, JSON.stringify(e), !0);
        }), this._p2pChannel.on(wn.RequestP2PMuteLocal, async (e, n, i) => {
          try {
            await this._gateway.sendExtensionMessage(bi.CONTROL, e, !0), n();
          } catch (o) {
            i(o);
          }
        }), this._p2pChannel.on(wn.RequestP2PUnmuteRemote, async (e, n, i) => {
          if (this._joinInfo) try {
            await this._gateway.unmuteRemote(e, this._joinInfo.stringUid || this._joinInfo.uid), n();
          } catch (o) {
            o.code === Je.DISCONNECT_P2P ? n() : i(o);
          }
          else n();
        }), this._p2pChannel.on(wn.RequestP2PMuteRemote, async (e, n, i) => {
          if (this._joinInfo) try {
            await this._gateway.muteRemote(e, this._joinInfo.stringUid || this._joinInfo.uid), n();
          } catch (o) {
            o.code === Je.DISCONNECT_P2P ? n() : i(o);
          }
          else n();
        }), this._p2pChannel.on(wn.StateChange, (e, n) => {
          n === Ir.Connected && this._p2pChannel.republish();
        });
      }
      _handleP2PChannelEvents() {
        this._p2pChannel.on(wn.PeerConnectionStateChange, (e) => {
          const n = this._peerConnectionState;
          e !== n && (this.safeEmit(rr.PEERCONNECTION_STATE_CHANGE, e, n), this._peerConnectionState = e);
        }), this._p2pChannel.on(wn.RequestMuteLocal, async (e, n, i) => {
          if (this._joinInfo) try {
            await this._gateway.muteLocal(e, this._joinInfo.stringUid || this._joinInfo.uid), n();
          } catch (o) {
            o.code === Je.DISCONNECT_P2P ? n() : i(o);
          }
          else n();
        }), this._p2pChannel.on(wn.RequestUnmuteLocal, async (e, n, i) => {
          if (this._joinInfo) try {
            await this._gateway.unmuteLocal(e, this._joinInfo.stringUid || this._joinInfo.uid), n();
          } catch (o) {
            o.code === Je.DISCONNECT_P2P ? n() : i(o);
          }
          else n();
        }), this._p2pChannel.on(wn.RequestRePublish, (e, n, i) => {
          this.publish(e, !1).then(n).catch(i);
        }), this._p2pChannel.on(wn.RequestRePublishDataChannel, (e, n, i) => {
          cn.all(e.map(async (o) => {
            const f = await this._p2pChannel.publishDataChannel([o]);
            try {
              f.forEach((T) => {
                this._uid && this._gateway.publishDataChannel(this._uid, T, !0);
              });
            } catch (T) {
              if (T.code !== Je.DISCONNECT_P2P) throw T;
            }
          })).then(n).catch(i);
        }), this._p2pChannel.on(wn.RequestReSubscribe, async (e, n, i) => {
          try {
            for (const { user: o, kind: f } of e) f === vn.VIDEO ? await this.subscribe(o, "video") : await this.subscribe(o, "audio");
            n();
          } catch (o) {
            i(o);
          }
        }), this._p2pChannel.on(wn.RequestUpload, (e, n) => {
          this._gateway.upload(e, n);
        }), this._p2pChannel.on(wn.RequestUploadStats, (e) => {
          this._gateway.uploadWRTCStats(e);
        }), this._p2pChannel.on(wn.MediaReconnectStart, (e) => {
          this.safeEmit(rr.MEDIA_RECONNECT_START, e);
        }), this._p2pChannel.on(wn.MediaReconnectEnd, (e) => {
          this.safeEmit(rr.MEDIA_RECONNECT_END, e);
        }), this._p2pChannel.on(wn.NeedSignalRTT, (e) => {
          e(this._gateway.getSignalRTT());
        }), this._p2pChannel.on(wn.RequestRestartICE, async (e) => {
          if (this.store.useP2P) return;
          const n = await this._p2pChannel.restartICE(e), i = await n.next();
          if (i.done) return;
          const o = i.value;
          let f;
          try {
            f = await this._gateway.restartICE({ iceParameters: o });
          } catch (A) {
            return void n.throw(A);
          }
          const { iceParameters: T } = function(A) {
            const R = A.iceParameters;
            return { iceParameters: { iceUfrag: R.iceUfrag, icePwd: R.icePwd } };
          }(f);
          await n.next({ remoteIceParameters: T });
        }), this._p2pChannel.on(wn.RequestReconnect, async () => {
          this._gateway.reconnect();
        }), this._p2pChannel.on(wn.RequestReconnectPC, async () => {
          var e;
          const { iceParameters: n, dtlsParameters: i, rtpCapabilities: o } = await this._p2pChannel.startP2PConnection({ turnServer: (e = this._joinInfo) === null || e === void 0 ? void 0 : e.turnServer }), { gatewayEstablishParams: f, gatewayAddress: T } = await this._gateway.reconnectPC({ iceParameters: n, dtlsParameters: i, rtpCapabilities: o }), A = s6(f, T);
          await this._p2pChannel.connect(A), await this._p2pChannel.republish(), await this._p2pChannel.reSubscribe();
        }), this._p2pChannel.on(wn.RequestUnpublishForReconnectPC, async (e, n, i) => {
          this._joinInfo && this._uid !== void 0 ? (await this._gateway.unpublish(e, this._uid), n()) : i();
        }), this._p2pChannel.on(wn.P2PLost, () => {
          this.safeEmit(rr.P2P_LOST, this.store.uid);
        }), this._p2pChannel.on(wn.UpdateVideoEncoder, (e) => {
          e._encoderConfig && this._gateway.setVideoProfile(e._encoderConfig);
        }), this._p2pChannel.on(wn.ConnectionTypeChange, (e) => {
          this.safeEmit(rr.IS_USING_CLOUD_PROXY, e);
        }), this._p2pChannel.on(wn.RequestLowStreamParameter, (e) => {
          e(this._lowStreamParameter || { width: 160, height: 120, framerate: 15, bitrate: 50 });
        }), this._p2pChannel.on(wn.QueryClientConnectionState, (e) => {
          e(this.connectionState);
        });
      }
      getKeyMetrics() {
        return this.store.keyMetrics;
      }
      async enableContentInspect(e) {
        if (!this._joinInfo || this.connectionState !== "CONNECTED") throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] can not create content inspect, please join channel first"));
        if (this._inspect) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] Inspect content service already in connecting/connected state"));
        try {
          const i = (n = { config: e }, ol("ContentInspect").create(n));
          this._inspect = i, this.handleVideoInspectEvents(i);
          const { appId: o, cname: f, sid: T, token: A, uid: R, cid: P, vid: L } = this._joinInfo;
          await i.init({ appId: o, areaCode: "", cname: f, sid: T, token: A, uid: R, cid: P, vid: L ? Number(L) : 0 }, zi);
        } catch (i) {
          throw Array.isArray(i) ? i[0] : i;
        }
        var n;
      }
      handleVideoInspectEvents(e) {
        e.on(ds.CONNECTION_STATE_CHANGE, (n, i) => {
          if (this.safeEmit(rr.CONTENT_INSPECT_CONNECTION_STATE_CHANGE, n, i), i === oc.CONNECTED) {
            if (this.connectionState !== "CONNECTED") return void this.safeEmit(rr.CONTENT_INSPECT_ERROR, new jt(Je.OPERATION_ABORTED, "Content inspect was cancelled because it left the channel"));
            e.inspectImage();
          }
        }), e.on(ds.INSPECT_RESULT, (n, i) => {
          var o;
          if ((i == null ? void 0 : i.code) === Je.INVALID_OPERATION && this.connectionState === "DISCONNECTED") return Ee.debug("Stop inspect content because that has left channel"), this == null || (o = this._inspect) === null || o === void 0 || o.close(), void (this._inspect = void 0);
          this.safeEmit(rr.CONTENT_INSPECT_RESULT, n, i);
        }), e.on(ds.CLIENT_LOCAL_VIDEO_TRACK, (n) => {
          n(this.localTracks.filter((i) => i.trackMediaType === "video")[0]);
        });
      }
      async disableContentInspect() {
        if (!this._inspect) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] inspectVideoContent not started"));
        try {
          this._inspect.close(), this._inspect = void 0;
        } catch (e) {
          throw Array.isArray(e) ? e[0] : e;
        }
      }
      async setImageModeration(e, n) {
        if (od(e, "enabled"), e) {
          if (!n) throw new jt(Je.INVALID_PARAMS, "config is required");
          if (C7(n), !this._joinInfo) throw new jt(Je.INVALID_OPERATION, "can not create image moderation, please join channel first");
          try {
            if (this._moderation) this._moderation.updateConfig(n);
            else {
              const o = (i = { config: n }, ol("ImageModeration").create(i));
              this._moderation = o, this.handleImageModerationEvents(o);
              const { appId: f, cname: T, sid: A, token: R, uid: P, cid: L, vid: z } = this._joinInfo;
              await o.init({ appId: f, areaCode: "", cname: T, sid: A, token: R, uid: P, cid: L, vid: z ? Number(z) : 0 }, zi);
            }
          } catch (o) {
            throw Array.isArray(o) ? o[0] : o;
          }
        } else {
          var i;
          if (!this._moderation) throw new jt(Je.INVALID_OPERATION, "[".concat(this._clientId, "] image moderation not started"));
          try {
            this._moderation.close(), this._moderation.removeAllListeners(), this._moderation = void 0;
          } catch (o) {
            throw Array.isArray(o) ? o[0] : o;
          }
        }
      }
      handleImageModerationEvents(e) {
        e.on(Uc.CONNECTION_STATE_CHANGE, (n, i) => {
          if (this.safeEmit(rr.IMAGE_MODERATION_CONNECTION_STATE_CHANGE, n, i), n === _o.CONNECTED) {
            if (this.connectionState !== "CONNECTED") throw this.setImageModeration(!1), new jt(Je.OPERATION_ABORTED, "Image moderation was cancelled because it left the channel");
            e.inspectImage();
          }
        }), e.on(Uc.CLIENT_LOCAL_VIDEO_TRACK, (n) => {
          n(this.localTracks.filter((i) => i.trackMediaType === "video")[0]);
        });
      }
      setP2PTransport(e) {
        if (function(n) {
          $i(n, "transport", ["default", "auto", "relay", "sd-rtn"]);
        }(e), this.mode !== "p2p") throw new jt(Je.INVALID_OPERATION, "only p2p mode can set p2pTransport");
        this.store.p2pTransport = e, Ee.info("[".concat(this._clientId, "] set client p2pTransport to ").concat(e));
      }
      getJoinChannelServiceRecords() {
        return Ee.debug("getJoinChannelServiceRecords"), this.store.joinChannelServiceRecords;
      }
      async setPublishAudioFilterEnabled(e) {
        od(e, "enabled"), Dr("ENABLE_PUBLISH_AUDIO_FILTER", e), this._joinInfo && await this._gateway.setPublishAudioFilterEnabled(e);
      }
      _handleResetAddStream(e, n) {
        switch (n) {
          case "audio":
            e._audio_added_ = !1, e._trust_audio_stream_added_state_ = !0;
            break;
          case "video":
            e._video_added_ = !1, e._trust_video_stream_added_state_ = !0;
        }
      }
    }, bn(ln.prototype, "leave", [S7], Object.getOwnPropertyDescriptor(ln.prototype, "leave"), ln.prototype), bn(ln.prototype, "publish", [I7], Object.getOwnPropertyDescriptor(ln.prototype, "publish"), ln.prototype), bn(ln.prototype, "unpublish", [R7], Object.getOwnPropertyDescriptor(ln.prototype, "unpublish"), ln.prototype), bn(ln.prototype, "subscribe", [N7], Object.getOwnPropertyDescriptor(ln.prototype, "subscribe"), ln.prototype), bn(ln.prototype, "presubscribe", [w7], Object.getOwnPropertyDescriptor(ln.prototype, "presubscribe"), ln.prototype), bn(ln.prototype, "massSubscribe", [_7], Object.getOwnPropertyDescriptor(ln.prototype, "massSubscribe"), ln.prototype), bn(ln.prototype, "unsubscribe", [P7], Object.getOwnPropertyDescriptor(ln.prototype, "unsubscribe"), ln.prototype), bn(ln.prototype, "massUnsubscribe", [x7], Object.getOwnPropertyDescriptor(ln.prototype, "massUnsubscribe"), ln.prototype), bn(ln.prototype, "setLowStreamParameter", [D7], Object.getOwnPropertyDescriptor(ln.prototype, "setLowStreamParameter"), ln.prototype), bn(ln.prototype, "enableDualStream", [M7], Object.getOwnPropertyDescriptor(ln.prototype, "enableDualStream"), ln.prototype), bn(ln.prototype, "disableDualStream", [L7], Object.getOwnPropertyDescriptor(ln.prototype, "disableDualStream"), ln.prototype), bn(ln.prototype, "setClientRole", [k7], Object.getOwnPropertyDescriptor(ln.prototype, "setClientRole"), ln.prototype), bn(ln.prototype, "_setClientRoleOptions", [j7], Object.getOwnPropertyDescriptor(ln.prototype, "_setClientRoleOptions"), ln.prototype), bn(ln.prototype, "setProxyServer", [U7], Object.getOwnPropertyDescriptor(ln.prototype, "setProxyServer"), ln.prototype), bn(ln.prototype, "setTurnServer", [H7], Object.getOwnPropertyDescriptor(ln.prototype, "setTurnServer"), ln.prototype), bn(ln.prototype, "setLicense", [B7], Object.getOwnPropertyDescriptor(ln.prototype, "setLicense"), ln.prototype), bn(ln.prototype, "startProxyServer", [z7], Object.getOwnPropertyDescriptor(ln.prototype, "startProxyServer"), ln.prototype), bn(ln.prototype, "stopProxyServer", [F7], Object.getOwnPropertyDescriptor(ln.prototype, "stopProxyServer"), ln.prototype), bn(ln.prototype, "setLocalAccessPointsV2", [G7], Object.getOwnPropertyDescriptor(ln.prototype, "setLocalAccessPointsV2"), ln.prototype), bn(ln.prototype, "setLocalAccessPoints", [V7], Object.getOwnPropertyDescriptor(ln.prototype, "setLocalAccessPoints"), ln.prototype), bn(ln.prototype, "setRemoteDefaultVideoStreamType", [Y7], Object.getOwnPropertyDescriptor(ln.prototype, "setRemoteDefaultVideoStreamType"), ln.prototype), bn(ln.prototype, "setRemoteVideoStreamType", [X7], Object.getOwnPropertyDescriptor(ln.prototype, "setRemoteVideoStreamType"), ln.prototype), bn(ln.prototype, "setStreamFallbackOption", [W7], Object.getOwnPropertyDescriptor(ln.prototype, "setStreamFallbackOption"), ln.prototype), bn(ln.prototype, "setEncryptionConfig", [q7], Object.getOwnPropertyDescriptor(ln.prototype, "setEncryptionConfig"), ln.prototype), bn(ln.prototype, "renewToken", [K7], Object.getOwnPropertyDescriptor(ln.prototype, "renewToken"), ln.prototype), bn(ln.prototype, "enableAudioVolumeIndicator", [J7], Object.getOwnPropertyDescriptor(ln.prototype, "enableAudioVolumeIndicator"), ln.prototype), bn(ln.prototype, "startLiveStreaming", [Z7], Object.getOwnPropertyDescriptor(ln.prototype, "startLiveStreaming"), ln.prototype), bn(ln.prototype, "setLiveTranscoding", [Q7], Object.getOwnPropertyDescriptor(ln.prototype, "setLiveTranscoding"), ln.prototype), bn(ln.prototype, "stopLiveStreaming", [$7], Object.getOwnPropertyDescriptor(ln.prototype, "stopLiveStreaming"), ln.prototype), bn(ln.prototype, "startChannelMediaRelay", [ek], Object.getOwnPropertyDescriptor(ln.prototype, "startChannelMediaRelay"), ln.prototype), bn(ln.prototype, "updateChannelMediaRelay", [tk], Object.getOwnPropertyDescriptor(ln.prototype, "updateChannelMediaRelay"), ln.prototype), bn(ln.prototype, "stopChannelMediaRelay", [nk], Object.getOwnPropertyDescriptor(ln.prototype, "stopChannelMediaRelay"), ln.prototype), bn(ln.prototype, "sendCustomReportMessage", [rk], Object.getOwnPropertyDescriptor(ln.prototype, "sendCustomReportMessage"), ln.prototype), bn(ln.prototype, "pickSVCLayer", [ik], Object.getOwnPropertyDescriptor(ln.prototype, "pickSVCLayer"), ln.prototype), bn(ln.prototype, "setRTMConfig", [sk], Object.getOwnPropertyDescriptor(ln.prototype, "setRTMConfig"), ln.prototype), bn(ln.prototype, "enableContentInspect", [ak], Object.getOwnPropertyDescriptor(ln.prototype, "enableContentInspect"), ln.prototype), bn(ln.prototype, "disableContentInspect", [ok], Object.getOwnPropertyDescriptor(ln.prototype, "disableContentInspect"), ln.prototype), bn(ln.prototype, "setImageModeration", [ck], Object.getOwnPropertyDescriptor(ln.prototype, "setImageModeration"), ln.prototype), bn(ln.prototype, "setP2PTransport", [uk], Object.getOwnPropertyDescriptor(ln.prototype, "setP2PTransport"), ln.prototype), bn(ln.prototype, "getJoinChannelServiceRecords", [dk], Object.getOwnPropertyDescriptor(ln.prototype, "getJoinChannelServiceRecords"), ln.prototype), bn(ln.prototype, "setPublishAudioFilterEnabled", [lk], Object.getOwnPropertyDescriptor(ln.prototype, "setPublishAudioFilterEnabled"), ln.prototype), ln);
    class JE {
      constructor(n, i) {
        Ve(this, "id", 0), Ve(this, "element", void 0), Ve(this, "peerPair", void 0), Ve(this, "context", void 0), Ve(this, "audioPlayerElement", void 0), Ve(this, "audioTrack", void 0), JE.count += 1, this.id = JE.count, this.element = n, this.context = i;
      }
      initPeers() {
        this.peerPair = [new RTCPeerConnection(), new RTCPeerConnection()], this.peerPair[1].ontrack = (n) => {
          const i = document.createElement("audio");
          i.srcObject = new MediaStream([n.track]), i.play(), this.audioPlayerElement = i;
        };
      }
      async switchSdp() {
        if (!this.peerPair) return;
        const n = async (o, f) => {
          const T = f === "offer" ? await o.createOffer() : await o.createAnswer();
          return await o.setLocalDescription(T), o.iceGatheringState === "complete" ? o.localDescription : new cn((A) => {
            o.onicegatheringstatechange = () => {
              o.iceGatheringState === "complete" && A(o.localDescription);
            };
          });
        }, i = async (o, f) => await o.setRemoteDescription(f);
        try {
          const o = await n(this.peerPair[0], "offer");
          await i(this.peerPair[1], o);
          const f = await n(this.peerPair[1], "answer");
          await i(this.peerPair[0], f);
        } catch (o) {
          throw new jt(Je.LOCAL_AEC_ERROR, o.toString()).print();
        }
      }
      async getTracksFromMediaElement(n) {
        if (this.audioTrack) return this.audioTrack;
        let i;
        try {
          n instanceof HTMLVideoElement && (n.captureStream ? n.captureStream() : n.mozCaptureStream()), i = this.context.createMediaStreamDestination(), this.context.createMediaElementSource(n).connect(i);
        } catch (f) {
          throw new jt(Je.LOCAL_AEC_ERROR, f.toString()).print();
        }
        if (!i)
          throw new jt(Je.LOCAL_AEC_ERROR, "no dest node when local aec").print();
        const o = i.stream.getAudioTracks()[0];
        return this.audioTrack = o, o;
      }
      getElement() {
        return this.element;
      }
      async startEchoCancellation() {
        this.context.resume(), this.peerPair && this.close(), this.initPeers();
        const n = this.element, i = await this.getTracksFromMediaElement(n);
        this.peerPair && this.peerPair[0].addTrack(i), await this.switchSdp();
      }
      close() {
        Ee.debug("close echo cancellation unit, id is", this.id), this.audioPlayerElement && this.audioPlayerElement.pause(), this.peerPair && this.peerPair.forEach((n) => {
          n.close();
        }), this.peerPair = void 0, this.audioPlayerElement = void 0;
      }
    }
    var hk, i0;
    Ve(JE, "count", 0);
    const Kae = window.AudioContext || window.webkitAudioContext, Jae = new (hk = Dn({ report: Cn }), bn((i0 = class {
      constructor() {
        Ve(this, "units", []), Ve(this, "context", void 0);
      }
      processExternalMediaAEC(e) {
        if (!this._doesEnvironmentNeedAEC()) return Ee.debug("the system does not need to process local aec"), -1;
        this.context || (this.context = new Kae());
        let n = this.units.find((i) => i && i.getElement() === e);
        return n || (n = new JE(e, this.context), this.units.push(n)), n.startEchoCancellation(), Ee.debug("start processing local audio echo cancellation, id is", n.id), n.id;
      }
      _doesEnvironmentNeedAEC() {
        return hr().name !== Cr.SAFARI;
      }
    }).prototype, "processExternalMediaAEC", [hk], Object.getOwnPropertyDescriptor(i0.prototype, "processExternalMediaAEC"), i0.prototype), i0)();
    function pk(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function gk(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? pk(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : pk(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    const qI = window || document;
    function mk(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      if (!qI) return;
      const i = Fi._cspEventHandlerPointer;
      if (i && n) return void console.error(i, n);
      const o = (f) => {
        if (!(f && f.blockedURI && (Fi.onSecurityPolicyViolation || Fi.getListeners(bu.SECURITY_POLICY_VIOLATION).length > 0))) return;
        const T = f.blockedURI;
        ft("CSP_DETECTED_HOSTNAME_LIST").some((A) => on(T).call(T, A)) && (Fi.onSecurityPolicyViolation && typeof Fi.onSecurityPolicyViolation == "function" && Fi.onSecurityPolicyViolation(f), Fi.getListeners(bu.SECURITY_POLICY_VIOLATION).length > 0 && Fi.safeEmit(bu.SECURITY_POLICY_VIOLATION, f));
      };
      i && qI.removeEventListener("securitypolicyviolation", i), (n || e && typeof e == "function" || Fi.getListeners(bu.SECURITY_POLICY_VIOLATION).length > 0) && qI.addEventListener("securitypolicyviolation", o), Fi._cspEventHandlerPointer = o;
    }
    var Zae = m, Qae = sM, Ek = RegExp.prototype, $ae = function(e) {
      return e === Ek || Zae(Ek, e) ? Qae(e) : e.flags;
    }, Ks = h($ae);
    function xp(e) {
      let n = e.length;
      for (; --n >= 0; ) e[n] = 0;
    }
    const KI = 256, yk = 286, ZE = 30, QE = 15, JI = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]), s0 = new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]), eoe = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]), vk = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), yd = new Array(576);
    xp(yd);
    const $E = new Array(60);
    xp($E);
    const ey = new Array(512);
    xp(ey);
    const ty = new Array(256);
    xp(ty);
    const ZI = new Array(29);
    xp(ZI);
    const a0 = new Array(ZE);
    function QI(e, n, i, o, f) {
      this.static_tree = e, this.extra_bits = n, this.extra_base = i, this.elems = o, this.max_length = f, this.has_stree = e && e.length;
    }
    let Tk, bk, Ak;
    function $I(e, n) {
      this.dyn_tree = e, this.max_code = 0, this.stat_desc = n;
    }
    xp(a0);
    const Ok = (e) => e < 256 ? ey[e] : ey[256 + (e >>> 7)], ny = (e, n) => {
      e.pending_buf[e.pending++] = 255 & n, e.pending_buf[e.pending++] = n >>> 8 & 255;
    }, fo = (e, n, i) => {
      e.bi_valid > 16 - i ? (e.bi_buf |= n << e.bi_valid & 65535, ny(e, e.bi_buf), e.bi_buf = n >> 16 - e.bi_valid, e.bi_valid += i - 16) : (e.bi_buf |= n << e.bi_valid & 65535, e.bi_valid += i);
    }, Su = (e, n, i) => {
      fo(e, i[2 * n], i[2 * n + 1]);
    }, Ck = (e, n) => {
      let i = 0;
      do
        i |= 1 & e, e >>>= 1, i <<= 1;
      while (--n > 0);
      return i >>> 1;
    }, Sk = (e, n, i) => {
      const o = new Array(16);
      let f, T, A = 0;
      for (f = 1; f <= QE; f++) A = A + i[f - 1] << 1, o[f] = A;
      for (T = 0; T <= n; T++) {
        let R = e[2 * T + 1];
        R !== 0 && (e[2 * T] = Ck(o[R]++, R));
      }
    }, Ik = (e) => {
      let n;
      for (n = 0; n < yk; n++) e.dyn_ltree[2 * n] = 0;
      for (n = 0; n < ZE; n++) e.dyn_dtree[2 * n] = 0;
      for (n = 0; n < 19; n++) e.bl_tree[2 * n] = 0;
      e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
    }, Rk = (e) => {
      e.bi_valid > 8 ? ny(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
    }, Nk = (e, n, i, o) => {
      const f = 2 * n, T = 2 * i;
      return e[f] < e[T] || e[f] === e[T] && o[n] <= o[i];
    }, eR = (e, n, i) => {
      const o = e.heap[i];
      let f = i << 1;
      for (; f <= e.heap_len && (f < e.heap_len && Nk(n, e.heap[f + 1], e.heap[f], e.depth) && f++, !Nk(n, o, e.heap[f], e.depth)); ) e.heap[i] = e.heap[f], i = f, f <<= 1;
      e.heap[i] = o;
    }, wk = (e, n, i) => {
      let o, f, T, A, R = 0;
      if (e.sym_next !== 0) do
        o = 255 & e.pending_buf[e.sym_buf + R++], o += (255 & e.pending_buf[e.sym_buf + R++]) << 8, f = e.pending_buf[e.sym_buf + R++], o === 0 ? Su(e, f, n) : (T = ty[f], Su(e, T + KI + 1, n), A = JI[T], A !== 0 && (f -= ZI[T], fo(e, f, A)), o--, T = Ok(o), Su(e, T, i), A = s0[T], A !== 0 && (o -= a0[T], fo(e, o, A)));
      while (R < e.sym_next);
      Su(e, 256, n);
    }, tR = (e, n) => {
      const i = n.dyn_tree, o = n.stat_desc.static_tree, f = n.stat_desc.has_stree, T = n.stat_desc.elems;
      let A, R, P, L = -1;
      for (e.heap_len = 0, e.heap_max = 573, A = 0; A < T; A++) i[2 * A] !== 0 ? (e.heap[++e.heap_len] = L = A, e.depth[A] = 0) : i[2 * A + 1] = 0;
      for (; e.heap_len < 2; ) P = e.heap[++e.heap_len] = L < 2 ? ++L : 0, i[2 * P] = 1, e.depth[P] = 0, e.opt_len--, f && (e.static_len -= o[2 * P + 1]);
      for (n.max_code = L, A = e.heap_len >> 1; A >= 1; A--) eR(e, i, A);
      P = T;
      do
        A = e.heap[1], e.heap[1] = e.heap[e.heap_len--], eR(e, i, 1), R = e.heap[1], e.heap[--e.heap_max] = A, e.heap[--e.heap_max] = R, i[2 * P] = i[2 * A] + i[2 * R], e.depth[P] = (e.depth[A] >= e.depth[R] ? e.depth[A] : e.depth[R]) + 1, i[2 * A + 1] = i[2 * R + 1] = P, e.heap[1] = P++, eR(e, i, 1);
      while (e.heap_len >= 2);
      e.heap[--e.heap_max] = e.heap[1], ((z, Y) => {
        const te = Y.dyn_tree, oe = Y.max_code, He = Y.stat_desc.static_tree, Re = Y.stat_desc.has_stree, De = Y.stat_desc.extra_bits, Xe = Y.stat_desc.extra_base, We = Y.stat_desc.max_length;
        let mt, Pt, xt, Nt, Vt, nn, fn = 0;
        for (Nt = 0; Nt <= QE; Nt++) z.bl_count[Nt] = 0;
        for (te[2 * z.heap[z.heap_max] + 1] = 0, mt = z.heap_max + 1; mt < 573; mt++) Pt = z.heap[mt], Nt = te[2 * te[2 * Pt + 1] + 1] + 1, Nt > We && (Nt = We, fn++), te[2 * Pt + 1] = Nt, Pt > oe || (z.bl_count[Nt]++, Vt = 0, Pt >= Xe && (Vt = De[Pt - Xe]), nn = te[2 * Pt], z.opt_len += nn * (Nt + Vt), Re && (z.static_len += nn * (He[2 * Pt + 1] + Vt)));
        if (fn !== 0) {
          do {
            for (Nt = We - 1; z.bl_count[Nt] === 0; ) Nt--;
            z.bl_count[Nt]--, z.bl_count[Nt + 1] += 2, z.bl_count[We]--, fn -= 2;
          } while (fn > 0);
          for (Nt = We; Nt !== 0; Nt--) for (Pt = z.bl_count[Nt]; Pt !== 0; ) xt = z.heap[--mt], xt > oe || (te[2 * xt + 1] !== Nt && (z.opt_len += (Nt - te[2 * xt + 1]) * te[2 * xt], te[2 * xt + 1] = Nt), Pt--);
        }
      })(e, n), Sk(i, L, e.bl_count);
    }, _k = (e, n, i) => {
      let o, f, T = -1, A = n[1], R = 0, P = 7, L = 4;
      for (A === 0 && (P = 138, L = 3), n[2 * (i + 1) + 1] = 65535, o = 0; o <= i; o++) f = A, A = n[2 * (o + 1) + 1], ++R < P && f === A || (R < L ? e.bl_tree[2 * f] += R : f !== 0 ? (f !== T && e.bl_tree[2 * f]++, e.bl_tree[32]++) : R <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, R = 0, T = f, A === 0 ? (P = 138, L = 3) : f === A ? (P = 6, L = 3) : (P = 7, L = 4));
    }, Pk = (e, n, i) => {
      let o, f, T = -1, A = n[1], R = 0, P = 7, L = 4;
      for (A === 0 && (P = 138, L = 3), o = 0; o <= i; o++) if (f = A, A = n[2 * (o + 1) + 1], !(++R < P && f === A)) {
        if (R < L) do
          Su(e, f, e.bl_tree);
        while (--R != 0);
        else f !== 0 ? (f !== T && (Su(e, f, e.bl_tree), R--), Su(e, 16, e.bl_tree), fo(e, R - 3, 2)) : R <= 10 ? (Su(e, 17, e.bl_tree), fo(e, R - 3, 3)) : (Su(e, 18, e.bl_tree), fo(e, R - 11, 7));
        R = 0, T = f, A === 0 ? (P = 138, L = 3) : f === A ? (P = 6, L = 3) : (P = 7, L = 4);
      }
    };
    let xk = !1;
    const Dk = (e, n, i, o) => {
      fo(e, 0 + (o ? 1 : 0), 3), Rk(e), ny(e, i), ny(e, ~i), i && e.pending_buf.set(e.window.subarray(n, n + i), e.pending), e.pending += i;
    };
    var toe = (e) => {
      xk || ((() => {
        let n, i, o, f, T;
        const A = new Array(16);
        for (o = 0, f = 0; f < 28; f++) for (ZI[f] = o, n = 0; n < 1 << JI[f]; n++) ty[o++] = f;
        for (ty[o - 1] = f, T = 0, f = 0; f < 16; f++) for (a0[f] = T, n = 0; n < 1 << s0[f]; n++) ey[T++] = f;
        for (T >>= 7; f < ZE; f++) for (a0[f] = T << 7, n = 0; n < 1 << s0[f] - 7; n++) ey[256 + T++] = f;
        for (i = 0; i <= QE; i++) A[i] = 0;
        for (n = 0; n <= 143; ) yd[2 * n + 1] = 8, n++, A[8]++;
        for (; n <= 255; ) yd[2 * n + 1] = 9, n++, A[9]++;
        for (; n <= 279; ) yd[2 * n + 1] = 7, n++, A[7]++;
        for (; n <= 287; ) yd[2 * n + 1] = 8, n++, A[8]++;
        for (Sk(yd, 287, A), n = 0; n < ZE; n++) $E[2 * n + 1] = 5, $E[2 * n] = Ck(n, 5);
        Tk = new QI(yd, JI, 257, yk, QE), bk = new QI($E, s0, 0, ZE, QE), Ak = new QI(new Array(0), eoe, 0, 19, 7);
      })(), xk = !0), e.l_desc = new $I(e.dyn_ltree, Tk), e.d_desc = new $I(e.dyn_dtree, bk), e.bl_desc = new $I(e.bl_tree, Ak), e.bi_buf = 0, e.bi_valid = 0, Ik(e);
    }, noe = (e, n, i, o) => {
      let f, T, A = 0;
      e.level > 0 ? (e.strm.data_type === 2 && (e.strm.data_type = ((R) => {
        let P, L = 4093624447;
        for (P = 0; P <= 31; P++, L >>>= 1) if (1 & L && R.dyn_ltree[2 * P] !== 0) return 0;
        if (R.dyn_ltree[18] !== 0 || R.dyn_ltree[20] !== 0 || R.dyn_ltree[26] !== 0) return 1;
        for (P = 32; P < KI; P++) if (R.dyn_ltree[2 * P] !== 0) return 1;
        return 0;
      })(e)), tR(e, e.l_desc), tR(e, e.d_desc), A = ((R) => {
        let P;
        for (_k(R, R.dyn_ltree, R.l_desc.max_code), _k(R, R.dyn_dtree, R.d_desc.max_code), tR(R, R.bl_desc), P = 18; P >= 3 && R.bl_tree[2 * vk[P] + 1] === 0; P--) ;
        return R.opt_len += 3 * (P + 1) + 5 + 5 + 4, P;
      })(e), f = e.opt_len + 3 + 7 >>> 3, T = e.static_len + 3 + 7 >>> 3, T <= f && (f = T)) : f = T = i + 5, i + 4 <= f && n !== -1 ? Dk(e, n, i, o) : e.strategy === 4 || T === f ? (fo(e, 2 + (o ? 1 : 0), 3), wk(e, yd, $E)) : (fo(e, 4 + (o ? 1 : 0), 3), ((R, P, L, z) => {
        let Y;
        for (fo(R, P - 257, 5), fo(R, L - 1, 5), fo(R, z - 4, 4), Y = 0; Y < z; Y++) fo(R, R.bl_tree[2 * vk[Y] + 1], 3);
        Pk(R, R.dyn_ltree, P - 1), Pk(R, R.dyn_dtree, L - 1);
      })(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, A + 1), wk(e, e.dyn_ltree, e.dyn_dtree)), Ik(e), o && Rk(e);
    }, roe = (e, n, i) => (e.pending_buf[e.sym_buf + e.sym_next++] = n, e.pending_buf[e.sym_buf + e.sym_next++] = n >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = i, n === 0 ? e.dyn_ltree[2 * i]++ : (e.matches++, n--, e.dyn_ltree[2 * (ty[i] + KI + 1)]++, e.dyn_dtree[2 * Ok(n)]++), e.sym_next === e.sym_end), ioe = (e) => {
      fo(e, 2, 3), Su(e, 256, yd), ((n) => {
        n.bi_valid === 16 ? (ny(n, n.bi_buf), n.bi_buf = 0, n.bi_valid = 0) : n.bi_valid >= 8 && (n.pending_buf[n.pending++] = 255 & n.bi_buf, n.bi_buf >>= 8, n.bi_valid -= 8);
      })(e);
    }, soe = { _tr_init: toe, _tr_stored_block: Dk, _tr_flush_block: noe, _tr_tally: roe, _tr_align: ioe }, ry = (e, n, i, o) => {
      let f = 65535 & e | 0, T = e >>> 16 & 65535 | 0, A = 0;
      for (; i !== 0; ) {
        A = i > 2e3 ? 2e3 : i, i -= A;
        do
          f = f + n[o++] | 0, T = T + f | 0;
        while (--A);
        f %= 65521, T %= 65521;
      }
      return f | T << 16 | 0;
    };
    const aoe = new Uint32Array((() => {
      let e, n = [];
      for (var i = 0; i < 256; i++) {
        e = i;
        for (var o = 0; o < 8; o++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
        n[i] = e;
      }
      return n;
    })());
    var aa = (e, n, i, o) => {
      const f = aoe, T = o + i;
      e ^= -1;
      for (let A = o; A < T; A++) e = e >>> 8 ^ f[255 & (e ^ n[A])];
      return -1 ^ e;
    }, kf = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" }, Dp = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_MEM_ERROR: -4, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    const { _tr_init: ooe, _tr_stored_block: nR, _tr_flush_block: coe, _tr_tally: fl, _tr_align: uoe } = soe, { Z_NO_FLUSH: hl, Z_PARTIAL_FLUSH: doe, Z_FULL_FLUSH: loe, Z_FINISH: fc, Z_BLOCK: Mk, Z_OK: ma, Z_STREAM_END: Lk, Z_STREAM_ERROR: Iu, Z_DATA_ERROR: foe, Z_BUF_ERROR: rR, Z_DEFAULT_COMPRESSION: hoe, Z_FILTERED: poe, Z_HUFFMAN_ONLY: o0, Z_RLE: goe, Z_FIXED: moe, Z_DEFAULT_STRATEGY: Eoe, Z_UNKNOWN: yoe, Z_DEFLATED: c0 } = Dp, iR = 286, voe = 30, Toe = 19, boe = 2 * iR + 1, Aoe = 15, jf = 258, Ru = 262, Mp = 42, Uf = 113, iy = 666, Hf = (e, n) => (e.msg = kf[n], n), kk = (e) => 2 * e - (e > 4 ? 9 : 0), pl = (e) => {
      let n = e.length;
      for (; --n >= 0; ) e[n] = 0;
    }, Ooe = (e) => {
      let n, i, o, f = e.w_size;
      n = e.hash_size, o = n;
      do
        i = e.head[--o], e.head[o] = i >= f ? i - f : 0;
      while (--n);
      n = f, o = n;
      do
        i = e.prev[--o], e.prev[o] = i >= f ? i - f : 0;
      while (--n);
    };
    let gl = (e, n, i) => (n << e.hash_shift ^ i) & e.hash_mask;
    const Po = (e) => {
      const n = e.state;
      let i = n.pending;
      i > e.avail_out && (i = e.avail_out), i !== 0 && (e.output.set(n.pending_buf.subarray(n.pending_out, n.pending_out + i), e.next_out), e.next_out += i, n.pending_out += i, e.total_out += i, e.avail_out -= i, n.pending -= i, n.pending === 0 && (n.pending_out = 0));
    }, xo = (e, n) => {
      coe(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, n), e.block_start = e.strstart, Po(e.strm);
    }, yi = (e, n) => {
      e.pending_buf[e.pending++] = n;
    }, sy = (e, n) => {
      e.pending_buf[e.pending++] = n >>> 8 & 255, e.pending_buf[e.pending++] = 255 & n;
    }, sR = (e, n, i, o) => {
      let f = e.avail_in;
      return f > o && (f = o), f === 0 ? 0 : (e.avail_in -= f, n.set(e.input.subarray(e.next_in, e.next_in + f), i), e.state.wrap === 1 ? e.adler = ry(e.adler, n, f, i) : e.state.wrap === 2 && (e.adler = aa(e.adler, n, f, i)), e.next_in += f, e.total_in += f, f);
    }, jk = (e, n) => {
      let i, o, f = e.max_chain_length, T = e.strstart, A = e.prev_length, R = e.nice_match;
      const P = e.strstart > e.w_size - Ru ? e.strstart - (e.w_size - Ru) : 0, L = e.window, z = e.w_mask, Y = e.prev, te = e.strstart + jf;
      let oe = L[T + A - 1], He = L[T + A];
      e.prev_length >= e.good_match && (f >>= 2), R > e.lookahead && (R = e.lookahead);
      do
        if (i = n, L[i + A] === He && L[i + A - 1] === oe && L[i] === L[T] && L[++i] === L[T + 1]) {
          T += 2, i++;
          do
            ;
          while (L[++T] === L[++i] && L[++T] === L[++i] && L[++T] === L[++i] && L[++T] === L[++i] && L[++T] === L[++i] && L[++T] === L[++i] && L[++T] === L[++i] && L[++T] === L[++i] && T < te);
          if (o = jf - (te - T), T = te - jf, o > A) {
            if (e.match_start = n, A = o, o >= R) break;
            oe = L[T + A - 1], He = L[T + A];
          }
        }
      while ((n = Y[n & z]) > P && --f != 0);
      return A <= e.lookahead ? A : e.lookahead;
    }, Lp = (e) => {
      const n = e.w_size;
      let i, o, f;
      do {
        if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= n + (n - Ru) && (e.window.set(e.window.subarray(n, n + n - o), 0), e.match_start -= n, e.strstart -= n, e.block_start -= n, e.insert > e.strstart && (e.insert = e.strstart), Ooe(e), o += n), e.strm.avail_in === 0) break;
        if (i = sR(e.strm, e.window, e.strstart + e.lookahead, o), e.lookahead += i, e.lookahead + e.insert >= 3) for (f = e.strstart - e.insert, e.ins_h = e.window[f], e.ins_h = gl(e, e.ins_h, e.window[f + 1]); e.insert && (e.ins_h = gl(e, e.ins_h, e.window[f + 3 - 1]), e.prev[f & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = f, f++, e.insert--, !(e.lookahead + e.insert < 3)); ) ;
      } while (e.lookahead < Ru && e.strm.avail_in !== 0);
    }, Uk = (e, n) => {
      let i, o, f, T = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, A = 0, R = e.strm.avail_in;
      do {
        if (i = 65535, f = e.bi_valid + 42 >> 3, e.strm.avail_out < f || (f = e.strm.avail_out - f, o = e.strstart - e.block_start, i > o + e.strm.avail_in && (i = o + e.strm.avail_in), i > f && (i = f), i < T && (i === 0 && n !== fc || n === hl || i !== o + e.strm.avail_in))) break;
        A = n === fc && i === o + e.strm.avail_in ? 1 : 0, nR(e, 0, 0, A), e.pending_buf[e.pending - 4] = i, e.pending_buf[e.pending - 3] = i >> 8, e.pending_buf[e.pending - 2] = ~i, e.pending_buf[e.pending - 1] = ~i >> 8, Po(e.strm), o && (o > i && (o = i), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + o), e.strm.next_out), e.strm.next_out += o, e.strm.avail_out -= o, e.strm.total_out += o, e.block_start += o, i -= o), i && (sR(e.strm, e.strm.output, e.strm.next_out, i), e.strm.next_out += i, e.strm.avail_out -= i, e.strm.total_out += i);
      } while (A === 0);
      return R -= e.strm.avail_in, R && (R >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= R && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - R, e.strm.next_in), e.strstart), e.strstart += R, e.insert += R > e.w_size - e.insert ? e.w_size - e.insert : R), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), A ? 4 : n !== hl && n !== fc && e.strm.avail_in === 0 && e.strstart === e.block_start ? 2 : (f = e.window_size - e.strstart, e.strm.avail_in > f && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, f += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), f > e.strm.avail_in && (f = e.strm.avail_in), f && (sR(e.strm, e.window, e.strstart, f), e.strstart += f, e.insert += f > e.w_size - e.insert ? e.w_size - e.insert : f), e.high_water < e.strstart && (e.high_water = e.strstart), f = e.bi_valid + 42 >> 3, f = e.pending_buf_size - f > 65535 ? 65535 : e.pending_buf_size - f, T = f > e.w_size ? e.w_size : f, o = e.strstart - e.block_start, (o >= T || (o || n === fc) && n !== hl && e.strm.avail_in === 0 && o <= f) && (i = o > f ? f : o, A = n === fc && e.strm.avail_in === 0 && i === o ? 1 : 0, nR(e, e.block_start, i, A), e.block_start += i, Po(e.strm)), A ? 3 : 1);
    }, aR = (e, n) => {
      let i, o;
      for (; ; ) {
        if (e.lookahead < Ru) {
          if (Lp(e), e.lookahead < Ru && n === hl) return 1;
          if (e.lookahead === 0) break;
        }
        if (i = 0, e.lookahead >= 3 && (e.ins_h = gl(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), i !== 0 && e.strstart - i <= e.w_size - Ru && (e.match_length = jk(e, i)), e.match_length >= 3) if (o = fl(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
          e.match_length--;
          do
            e.strstart++, e.ins_h = gl(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
          while (--e.match_length != 0);
          e.strstart++;
        } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = gl(e, e.ins_h, e.window[e.strstart + 1]);
        else o = fl(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
        if (o && (xo(e, !1), e.strm.avail_out === 0)) return 1;
      }
      return e.insert = e.strstart < 2 ? e.strstart : 2, n === fc ? (xo(e, !0), e.strm.avail_out === 0 ? 3 : 4) : e.sym_next && (xo(e, !1), e.strm.avail_out === 0) ? 1 : 2;
    }, kp = (e, n) => {
      let i, o, f;
      for (; ; ) {
        if (e.lookahead < Ru) {
          if (Lp(e), e.lookahead < Ru && n === hl) return 1;
          if (e.lookahead === 0) break;
        }
        if (i = 0, e.lookahead >= 3 && (e.ins_h = gl(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, i !== 0 && e.prev_length < e.max_lazy_match && e.strstart - i <= e.w_size - Ru && (e.match_length = jk(e, i), e.match_length <= 5 && (e.strategy === poe || e.match_length === 3 && e.strstart - e.match_start > 4096) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
          f = e.strstart + e.lookahead - 3, o = fl(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
          do
            ++e.strstart <= f && (e.ins_h = gl(e, e.ins_h, e.window[e.strstart + 3 - 1]), i = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
          while (--e.prev_length != 0);
          if (e.match_available = 0, e.match_length = 2, e.strstart++, o && (xo(e, !1), e.strm.avail_out === 0)) return 1;
        } else if (e.match_available) {
          if (o = fl(e, 0, e.window[e.strstart - 1]), o && xo(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0) return 1;
        } else e.match_available = 1, e.strstart++, e.lookahead--;
      }
      return e.match_available && (o = fl(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, n === fc ? (xo(e, !0), e.strm.avail_out === 0 ? 3 : 4) : e.sym_next && (xo(e, !1), e.strm.avail_out === 0) ? 1 : 2;
    };
    function Nu(e, n, i, o, f) {
      this.good_length = e, this.max_lazy = n, this.nice_length = i, this.max_chain = o, this.func = f;
    }
    const ay = [new Nu(0, 0, 0, 0, Uk), new Nu(4, 4, 8, 4, aR), new Nu(4, 5, 16, 8, aR), new Nu(4, 6, 32, 32, aR), new Nu(4, 4, 16, 16, kp), new Nu(8, 16, 32, 32, kp), new Nu(8, 16, 128, 128, kp), new Nu(8, 32, 128, 256, kp), new Nu(32, 128, 258, 1024, kp), new Nu(32, 258, 258, 4096, kp)];
    function Coe() {
      this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = c0, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(2 * boe), this.dyn_dtree = new Uint16Array(2 * (2 * voe + 1)), this.bl_tree = new Uint16Array(2 * (2 * Toe + 1)), pl(this.dyn_ltree), pl(this.dyn_dtree), pl(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(Aoe + 1), this.heap = new Uint16Array(2 * iR + 1), pl(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * iR + 1), pl(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
    }
    const oy = (e) => {
      if (!e) return 1;
      const n = e.state;
      return !n || n.strm !== e || n.status !== Mp && n.status !== 57 && n.status !== 69 && n.status !== 73 && n.status !== 91 && n.status !== 103 && n.status !== Uf && n.status !== iy ? 1 : 0;
    }, Hk = (e) => {
      if (oy(e)) return Hf(e, Iu);
      e.total_in = e.total_out = 0, e.data_type = yoe;
      const n = e.state;
      return n.pending = 0, n.pending_out = 0, n.wrap < 0 && (n.wrap = -n.wrap), n.status = n.wrap === 2 ? 57 : n.wrap ? Mp : Uf, e.adler = n.wrap === 2 ? 0 : 1, n.last_flush = -2, ooe(n), ma;
    }, Bk = (e) => {
      const n = Hk(e);
      return n === ma && ((i) => {
        i.window_size = 2 * i.w_size, pl(i.head), i.max_lazy_match = ay[i.level].max_lazy, i.good_match = ay[i.level].good_length, i.nice_match = ay[i.level].nice_length, i.max_chain_length = ay[i.level].max_chain, i.strstart = 0, i.block_start = 0, i.lookahead = 0, i.insert = 0, i.match_length = i.prev_length = 2, i.match_available = 0, i.ins_h = 0;
      })(e.state), n;
    }, zk = (e, n, i, o, f, T) => {
      if (!e) return Iu;
      let A = 1;
      if (n === hoe && (n = 6), o < 0 ? (A = 0, o = -o) : o > 15 && (A = 2, o -= 16), f < 1 || f > 9 || i !== c0 || o < 8 || o > 15 || n < 0 || n > 9 || T < 0 || T > moe || o === 8 && A !== 1) return Hf(e, Iu);
      o === 8 && (o = 9);
      const R = new Coe();
      return e.state = R, R.strm = e, R.status = Mp, R.wrap = A, R.gzhead = null, R.w_bits = o, R.w_size = 1 << R.w_bits, R.w_mask = R.w_size - 1, R.hash_bits = f + 7, R.hash_size = 1 << R.hash_bits, R.hash_mask = R.hash_size - 1, R.hash_shift = ~~((R.hash_bits + 3 - 1) / 3), R.window = new Uint8Array(2 * R.w_size), R.head = new Uint16Array(R.hash_size), R.prev = new Uint16Array(R.w_size), R.lit_bufsize = 1 << f + 6, R.pending_buf_size = 4 * R.lit_bufsize, R.pending_buf = new Uint8Array(R.pending_buf_size), R.sym_buf = R.lit_bufsize, R.sym_end = 3 * (R.lit_bufsize - 1), R.level = n, R.strategy = T, R.method = i, Bk(e);
    };
    var Soe = (e, n) => {
      if (oy(e) || n > Mk || n < 0) return e ? Hf(e, Iu) : Iu;
      const i = e.state;
      if (!e.output || e.avail_in !== 0 && !e.input || i.status === iy && n !== fc) return Hf(e, e.avail_out === 0 ? rR : Iu);
      const o = i.last_flush;
      if (i.last_flush = n, i.pending !== 0) {
        if (Po(e), e.avail_out === 0) return i.last_flush = -1, ma;
      } else if (e.avail_in === 0 && kk(n) <= kk(o) && n !== fc) return Hf(e, rR);
      if (i.status === iy && e.avail_in !== 0) return Hf(e, rR);
      if (i.status === Mp && i.wrap === 0 && (i.status = Uf), i.status === Mp) {
        let f = c0 + (i.w_bits - 8 << 4) << 8, T = -1;
        if (T = i.strategy >= o0 || i.level < 2 ? 0 : i.level < 6 ? 1 : i.level === 6 ? 2 : 3, f |= T << 6, i.strstart !== 0 && (f |= 32), f += 31 - f % 31, sy(i, f), i.strstart !== 0 && (sy(i, e.adler >>> 16), sy(i, 65535 & e.adler)), e.adler = 1, i.status = Uf, Po(e), i.pending !== 0) return i.last_flush = -1, ma;
      }
      if (i.status === 57) {
        if (e.adler = 0, yi(i, 31), yi(i, 139), yi(i, 8), i.gzhead) yi(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), yi(i, 255 & i.gzhead.time), yi(i, i.gzhead.time >> 8 & 255), yi(i, i.gzhead.time >> 16 & 255), yi(i, i.gzhead.time >> 24 & 255), yi(i, i.level === 9 ? 2 : i.strategy >= o0 || i.level < 2 ? 4 : 0), yi(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (yi(i, 255 & i.gzhead.extra.length), yi(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = aa(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69;
        else if (yi(i, 0), yi(i, 0), yi(i, 0), yi(i, 0), yi(i, 0), yi(i, i.level === 9 ? 2 : i.strategy >= o0 || i.level < 2 ? 4 : 0), yi(i, 3), i.status = Uf, Po(e), i.pending !== 0) return i.last_flush = -1, ma;
      }
      if (i.status === 69) {
        if (i.gzhead.extra) {
          let f = i.pending, T = (65535 & i.gzhead.extra.length) - i.gzindex;
          for (; i.pending + T > i.pending_buf_size; ) {
            let R = i.pending_buf_size - i.pending;
            if (i.pending_buf.set(i.gzhead.extra.subarray(i.gzindex, i.gzindex + R), i.pending), i.pending = i.pending_buf_size, i.gzhead.hcrc && i.pending > f && (e.adler = aa(e.adler, i.pending_buf, i.pending - f, f)), i.gzindex += R, Po(e), i.pending !== 0) return i.last_flush = -1, ma;
            f = 0, T -= R;
          }
          let A = new Uint8Array(i.gzhead.extra);
          i.pending_buf.set(A.subarray(i.gzindex, i.gzindex + T), i.pending), i.pending += T, i.gzhead.hcrc && i.pending > f && (e.adler = aa(e.adler, i.pending_buf, i.pending - f, f)), i.gzindex = 0;
        }
        i.status = 73;
      }
      if (i.status === 73) {
        if (i.gzhead.name) {
          let f, T = i.pending;
          do {
            if (i.pending === i.pending_buf_size) {
              if (i.gzhead.hcrc && i.pending > T && (e.adler = aa(e.adler, i.pending_buf, i.pending - T, T)), Po(e), i.pending !== 0) return i.last_flush = -1, ma;
              T = 0;
            }
            f = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, yi(i, f);
          } while (f !== 0);
          i.gzhead.hcrc && i.pending > T && (e.adler = aa(e.adler, i.pending_buf, i.pending - T, T)), i.gzindex = 0;
        }
        i.status = 91;
      }
      if (i.status === 91) {
        if (i.gzhead.comment) {
          let f, T = i.pending;
          do {
            if (i.pending === i.pending_buf_size) {
              if (i.gzhead.hcrc && i.pending > T && (e.adler = aa(e.adler, i.pending_buf, i.pending - T, T)), Po(e), i.pending !== 0) return i.last_flush = -1, ma;
              T = 0;
            }
            f = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, yi(i, f);
          } while (f !== 0);
          i.gzhead.hcrc && i.pending > T && (e.adler = aa(e.adler, i.pending_buf, i.pending - T, T));
        }
        i.status = 103;
      }
      if (i.status === 103) {
        if (i.gzhead.hcrc) {
          if (i.pending + 2 > i.pending_buf_size && (Po(e), i.pending !== 0)) return i.last_flush = -1, ma;
          yi(i, 255 & e.adler), yi(i, e.adler >> 8 & 255), e.adler = 0;
        }
        if (i.status = Uf, Po(e), i.pending !== 0) return i.last_flush = -1, ma;
      }
      if (e.avail_in !== 0 || i.lookahead !== 0 || n !== hl && i.status !== iy) {
        let f = i.level === 0 ? Uk(i, n) : i.strategy === o0 ? ((T, A) => {
          let R;
          for (; ; ) {
            if (T.lookahead === 0 && (Lp(T), T.lookahead === 0)) {
              if (A === hl) return 1;
              break;
            }
            if (T.match_length = 0, R = fl(T, 0, T.window[T.strstart]), T.lookahead--, T.strstart++, R && (xo(T, !1), T.strm.avail_out === 0)) return 1;
          }
          return T.insert = 0, A === fc ? (xo(T, !0), T.strm.avail_out === 0 ? 3 : 4) : T.sym_next && (xo(T, !1), T.strm.avail_out === 0) ? 1 : 2;
        })(i, n) : i.strategy === goe ? ((T, A) => {
          let R, P, L, z;
          const Y = T.window;
          for (; ; ) {
            if (T.lookahead <= jf) {
              if (Lp(T), T.lookahead <= jf && A === hl) return 1;
              if (T.lookahead === 0) break;
            }
            if (T.match_length = 0, T.lookahead >= 3 && T.strstart > 0 && (L = T.strstart - 1, P = Y[L], P === Y[++L] && P === Y[++L] && P === Y[++L])) {
              z = T.strstart + jf;
              do
                ;
              while (P === Y[++L] && P === Y[++L] && P === Y[++L] && P === Y[++L] && P === Y[++L] && P === Y[++L] && P === Y[++L] && P === Y[++L] && L < z);
              T.match_length = jf - (z - L), T.match_length > T.lookahead && (T.match_length = T.lookahead);
            }
            if (T.match_length >= 3 ? (R = fl(T, 1, T.match_length - 3), T.lookahead -= T.match_length, T.strstart += T.match_length, T.match_length = 0) : (R = fl(T, 0, T.window[T.strstart]), T.lookahead--, T.strstart++), R && (xo(T, !1), T.strm.avail_out === 0)) return 1;
          }
          return T.insert = 0, A === fc ? (xo(T, !0), T.strm.avail_out === 0 ? 3 : 4) : T.sym_next && (xo(T, !1), T.strm.avail_out === 0) ? 1 : 2;
        })(i, n) : ay[i.level].func(i, n);
        if (f !== 3 && f !== 4 || (i.status = iy), f === 1 || f === 3) return e.avail_out === 0 && (i.last_flush = -1), ma;
        if (f === 2 && (n === doe ? uoe(i) : n !== Mk && (nR(i, 0, 0, !1), n === loe && (pl(i.head), i.lookahead === 0 && (i.strstart = 0, i.block_start = 0, i.insert = 0))), Po(e), e.avail_out === 0)) return i.last_flush = -1, ma;
      }
      return n !== fc ? ma : i.wrap <= 0 ? Lk : (i.wrap === 2 ? (yi(i, 255 & e.adler), yi(i, e.adler >> 8 & 255), yi(i, e.adler >> 16 & 255), yi(i, e.adler >> 24 & 255), yi(i, 255 & e.total_in), yi(i, e.total_in >> 8 & 255), yi(i, e.total_in >> 16 & 255), yi(i, e.total_in >> 24 & 255)) : (sy(i, e.adler >>> 16), sy(i, 65535 & e.adler)), Po(e), i.wrap > 0 && (i.wrap = -i.wrap), i.pending !== 0 ? ma : Lk);
    }, Ioe = (e, n) => {
      let i = n.length;
      if (oy(e)) return Iu;
      const o = e.state, f = o.wrap;
      if (f === 2 || f === 1 && o.status !== Mp || o.lookahead) return Iu;
      if (f === 1 && (e.adler = ry(e.adler, n, i, 0)), o.wrap = 0, i >= o.w_size) {
        f === 0 && (pl(o.head), o.strstart = 0, o.block_start = 0, o.insert = 0);
        let P = new Uint8Array(o.w_size);
        P.set(n.subarray(i - o.w_size, i), 0), n = P, i = o.w_size;
      }
      const T = e.avail_in, A = e.next_in, R = e.input;
      for (e.avail_in = i, e.next_in = 0, e.input = n, Lp(o); o.lookahead >= 3; ) {
        let P = o.strstart, L = o.lookahead - 2;
        do
          o.ins_h = gl(o, o.ins_h, o.window[P + 3 - 1]), o.prev[P & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = P, P++;
        while (--L);
        o.strstart = P, o.lookahead = 2, Lp(o);
      }
      return o.strstart += o.lookahead, o.block_start = o.strstart, o.insert = o.lookahead, o.lookahead = 0, o.match_length = o.prev_length = 2, o.match_available = 0, e.next_in = A, e.input = R, e.avail_in = T, o.wrap = f, ma;
    }, cy = { deflateInit: (e, n) => zk(e, n, c0, 15, 8, Eoe), deflateInit2: zk, deflateReset: Bk, deflateResetKeep: Hk, deflateSetHeader: (e, n) => oy(e) || e.state.wrap !== 2 ? Iu : (e.state.gzhead = n, ma), deflate: Soe, deflateEnd: (e) => {
      if (oy(e)) return Iu;
      const n = e.state.status;
      return e.state = null, n === Uf ? Hf(e, foe) : ma;
    }, deflateSetDictionary: Ioe, deflateInfo: "pako deflate (from Nodeca project)" };
    const Roe = (e, n) => Object.prototype.hasOwnProperty.call(e, n);
    var u0 = { assign: function(e) {
      const n = Array.prototype.slice.call(arguments, 1);
      for (; n.length; ) {
        const i = n.shift();
        if (i) {
          if (typeof i != "object") throw new TypeError(i + "must be non-object");
          for (const o in i) Roe(i, o) && (e[o] = i[o]);
        }
      }
      return e;
    }, flattenChunks: (e) => {
      let n = 0;
      for (let o = 0, f = e.length; o < f; o++) n += e[o].length;
      const i = new Uint8Array(n);
      for (let o = 0, f = 0, T = e.length; o < T; o++) {
        let A = e[o];
        i.set(A, f), f += A.length;
      }
      return i;
    } };
    let Fk = !0;
    try {
      String.fromCharCode.apply(null, new Uint8Array(1));
    } catch {
      Fk = !1;
    }
    const uy = new Uint8Array(256);
    for (let e = 0; e < 256; e++) uy[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
    uy[254] = uy[254] = 1;
    var dy = { string2buf: (e) => {
      if (typeof TextEncoder == "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(e);
      let n, i, o, f, T, A = e.length, R = 0;
      for (f = 0; f < A; f++) i = e.charCodeAt(f), (64512 & i) == 55296 && f + 1 < A && (o = e.charCodeAt(f + 1), (64512 & o) == 56320 && (i = 65536 + (i - 55296 << 10) + (o - 56320), f++)), R += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
      for (n = new Uint8Array(R), T = 0, f = 0; T < R; f++) i = e.charCodeAt(f), (64512 & i) == 55296 && f + 1 < A && (o = e.charCodeAt(f + 1), (64512 & o) == 56320 && (i = 65536 + (i - 55296 << 10) + (o - 56320), f++)), i < 128 ? n[T++] = i : i < 2048 ? (n[T++] = 192 | i >>> 6, n[T++] = 128 | 63 & i) : i < 65536 ? (n[T++] = 224 | i >>> 12, n[T++] = 128 | i >>> 6 & 63, n[T++] = 128 | 63 & i) : (n[T++] = 240 | i >>> 18, n[T++] = 128 | i >>> 12 & 63, n[T++] = 128 | i >>> 6 & 63, n[T++] = 128 | 63 & i);
      return n;
    }, buf2string: (e, n) => {
      const i = n || e.length;
      if (typeof TextDecoder == "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(e.subarray(0, n));
      let o, f;
      const T = new Array(2 * i);
      for (f = 0, o = 0; o < i; ) {
        let A = e[o++];
        if (A < 128) {
          T[f++] = A;
          continue;
        }
        let R = uy[A];
        if (R > 4) T[f++] = 65533, o += R - 1;
        else {
          for (A &= R === 2 ? 31 : R === 3 ? 15 : 7; R > 1 && o < i; ) A = A << 6 | 63 & e[o++], R--;
          R > 1 ? T[f++] = 65533 : A < 65536 ? T[f++] = A : (A -= 65536, T[f++] = 55296 | A >> 10 & 1023, T[f++] = 56320 | 1023 & A);
        }
      }
      return ((A, R) => {
        if (R < 65534 && A.subarray && Fk) return String.fromCharCode.apply(null, A.length === R ? A : A.subarray(0, R));
        let P = "";
        for (let L = 0; L < R; L++) P += String.fromCharCode(A[L]);
        return P;
      })(T, f);
    }, utf8border: (e, n) => {
      (n = n || e.length) > e.length && (n = e.length);
      let i = n - 1;
      for (; i >= 0 && (192 & e[i]) == 128; ) i--;
      return i < 0 || i === 0 ? n : i + uy[e[i]] > n ? i : n;
    } }, Gk = function() {
      this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
    };
    const Vk = Object.prototype.toString, { Z_NO_FLUSH: Noe, Z_SYNC_FLUSH: woe, Z_FULL_FLUSH: _oe, Z_FINISH: Poe, Z_OK: d0, Z_STREAM_END: xoe, Z_DEFAULT_COMPRESSION: Doe, Z_DEFAULT_STRATEGY: Moe, Z_DEFLATED: Loe } = Dp;
    function ly(e) {
      this.options = u0.assign({ level: Doe, method: Loe, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: Moe }, e || {});
      let n = this.options;
      n.raw && n.windowBits > 0 ? n.windowBits = -n.windowBits : n.gzip && n.windowBits > 0 && n.windowBits < 16 && (n.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Gk(), this.strm.avail_out = 0;
      let i = cy.deflateInit2(this.strm, n.level, n.method, n.windowBits, n.memLevel, n.strategy);
      if (i !== d0) throw new Error(kf[i]);
      if (n.header && cy.deflateSetHeader(this.strm, n.header), n.dictionary) {
        let o;
        if (o = typeof n.dictionary == "string" ? dy.string2buf(n.dictionary) : Vk.call(n.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(n.dictionary) : n.dictionary, i = cy.deflateSetDictionary(this.strm, o), i !== d0) throw new Error(kf[i]);
        this._dict_set = !0;
      }
    }
    function oR(e, n) {
      const i = new ly(n);
      if (i.push(e, !0), i.err) throw i.msg || kf[i.err];
      return i.result;
    }
    ly.prototype.push = function(e, n) {
      const i = this.strm, o = this.options.chunkSize;
      let f, T;
      if (this.ended) return !1;
      for (T = n === ~~n ? n : n === !0 ? Poe : Noe, typeof e == "string" ? i.input = dy.string2buf(e) : Vk.call(e) === "[object ArrayBuffer]" ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length; ; ) if (i.avail_out === 0 && (i.output = new Uint8Array(o), i.next_out = 0, i.avail_out = o), (T === woe || T === _oe) && i.avail_out <= 6) this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;
      else {
        if (f = cy.deflate(i, T), f === xoe) return i.next_out > 0 && this.onData(i.output.subarray(0, i.next_out)), f = cy.deflateEnd(this.strm), this.onEnd(f), this.ended = !0, f === d0;
        if (i.avail_out !== 0) {
          if (T > 0 && i.next_out > 0) this.onData(i.output.subarray(0, i.next_out)), i.avail_out = 0;
          else if (i.avail_in === 0) break;
        } else this.onData(i.output);
      }
      return !0;
    }, ly.prototype.onData = function(e) {
      this.chunks.push(e);
    }, ly.prototype.onEnd = function(e) {
      e === d0 && (this.result = u0.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
    };
    var koe = { Deflate: ly, deflate: oR, deflateRaw: function(e, n) {
      return (n = n || {}).raw = !0, oR(e, n);
    }, gzip: function(e, n) {
      return (n = n || {}).gzip = !0, oR(e, n);
    }, constants: Dp };
    const l0 = 16209;
    var joe = function(e, n) {
      let i, o, f, T, A, R, P, L, z, Y, te, oe, He, Re, De, Xe, We, mt, Pt, xt, Nt, Vt, nn, fn;
      const hn = e.state;
      i = e.next_in, nn = e.input, o = i + (e.avail_in - 5), f = e.next_out, fn = e.output, T = f - (n - e.avail_out), A = f + (e.avail_out - 257), R = hn.dmax, P = hn.wsize, L = hn.whave, z = hn.wnext, Y = hn.window, te = hn.hold, oe = hn.bits, He = hn.lencode, Re = hn.distcode, De = (1 << hn.lenbits) - 1, Xe = (1 << hn.distbits) - 1;
      e: do {
        oe < 15 && (te += nn[i++] << oe, oe += 8, te += nn[i++] << oe, oe += 8), We = He[te & De];
        t: for (; ; ) {
          if (mt = We >>> 24, te >>>= mt, oe -= mt, mt = We >>> 16 & 255, mt === 0) fn[f++] = 65535 & We;
          else {
            if (!(16 & mt)) {
              if (!(64 & mt)) {
                We = He[(65535 & We) + (te & (1 << mt) - 1)];
                continue t;
              }
              if (32 & mt) {
                hn.mode = 16191;
                break e;
              }
              e.msg = "invalid literal/length code", hn.mode = l0;
              break e;
            }
            Pt = 65535 & We, mt &= 15, mt && (oe < mt && (te += nn[i++] << oe, oe += 8), Pt += te & (1 << mt) - 1, te >>>= mt, oe -= mt), oe < 15 && (te += nn[i++] << oe, oe += 8, te += nn[i++] << oe, oe += 8), We = Re[te & Xe];
            n: for (; ; ) {
              if (mt = We >>> 24, te >>>= mt, oe -= mt, mt = We >>> 16 & 255, !(16 & mt)) {
                if (!(64 & mt)) {
                  We = Re[(65535 & We) + (te & (1 << mt) - 1)];
                  continue n;
                }
                e.msg = "invalid distance code", hn.mode = l0;
                break e;
              }
              if (xt = 65535 & We, mt &= 15, oe < mt && (te += nn[i++] << oe, oe += 8, oe < mt && (te += nn[i++] << oe, oe += 8)), xt += te & (1 << mt) - 1, xt > R) {
                e.msg = "invalid distance too far back", hn.mode = l0;
                break e;
              }
              if (te >>>= mt, oe -= mt, mt = f - T, xt > mt) {
                if (mt = xt - mt, mt > L && hn.sane) {
                  e.msg = "invalid distance too far back", hn.mode = l0;
                  break e;
                }
                if (Nt = 0, Vt = Y, z === 0) {
                  if (Nt += P - mt, mt < Pt) {
                    Pt -= mt;
                    do
                      fn[f++] = Y[Nt++];
                    while (--mt);
                    Nt = f - xt, Vt = fn;
                  }
                } else if (z < mt) {
                  if (Nt += P + z - mt, mt -= z, mt < Pt) {
                    Pt -= mt;
                    do
                      fn[f++] = Y[Nt++];
                    while (--mt);
                    if (Nt = 0, z < Pt) {
                      mt = z, Pt -= mt;
                      do
                        fn[f++] = Y[Nt++];
                      while (--mt);
                      Nt = f - xt, Vt = fn;
                    }
                  }
                } else if (Nt += z - mt, mt < Pt) {
                  Pt -= mt;
                  do
                    fn[f++] = Y[Nt++];
                  while (--mt);
                  Nt = f - xt, Vt = fn;
                }
                for (; Pt > 2; ) fn[f++] = Vt[Nt++], fn[f++] = Vt[Nt++], fn[f++] = Vt[Nt++], Pt -= 3;
                Pt && (fn[f++] = Vt[Nt++], Pt > 1 && (fn[f++] = Vt[Nt++]));
              } else {
                Nt = f - xt;
                do
                  fn[f++] = fn[Nt++], fn[f++] = fn[Nt++], fn[f++] = fn[Nt++], Pt -= 3;
                while (Pt > 2);
                Pt && (fn[f++] = fn[Nt++], Pt > 1 && (fn[f++] = fn[Nt++]));
              }
              break;
            }
          }
          break;
        }
      } while (i < o && f < A);
      Pt = oe >> 3, i -= Pt, oe -= Pt << 3, te &= (1 << oe) - 1, e.next_in = i, e.next_out = f, e.avail_in = i < o ? o - i + 5 : 5 - (i - o), e.avail_out = f < A ? A - f + 257 : 257 - (f - A), hn.hold = te, hn.bits = oe;
    };
    const f0 = 15, Uoe = new Uint16Array([3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0]), Hoe = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78]), Boe = new Uint16Array([1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0]), zoe = new Uint8Array([16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64]);
    var fy = (e, n, i, o, f, T, A, R) => {
      const P = R.bits;
      let L, z, Y, te, oe, He, Re = 0, De = 0, Xe = 0, We = 0, mt = 0, Pt = 0, xt = 0, Nt = 0, Vt = 0, nn = 0, fn = null;
      const hn = new Uint16Array(16), ir = new Uint16Array(16);
      let sr, Gr, Ai, fi = null;
      for (Re = 0; Re <= f0; Re++) hn[Re] = 0;
      for (De = 0; De < o; De++) hn[n[i + De]]++;
      for (mt = P, We = f0; We >= 1 && hn[We] === 0; We--) ;
      if (mt > We && (mt = We), We === 0) return f[T++] = 20971520, f[T++] = 20971520, R.bits = 1, 0;
      for (Xe = 1; Xe < We && hn[Xe] === 0; Xe++) ;
      for (mt < Xe && (mt = Xe), Nt = 1, Re = 1; Re <= f0; Re++) if (Nt <<= 1, Nt -= hn[Re], Nt < 0) return -1;
      if (Nt > 0 && (e === 0 || We !== 1)) return -1;
      for (ir[1] = 0, Re = 1; Re < f0; Re++) ir[Re + 1] = ir[Re] + hn[Re];
      for (De = 0; De < o; De++) n[i + De] !== 0 && (A[ir[n[i + De]]++] = De);
      if (e === 0 ? (fn = fi = A, He = 20) : e === 1 ? (fn = Uoe, fi = Hoe, He = 257) : (fn = Boe, fi = zoe, He = 0), nn = 0, De = 0, Re = Xe, oe = T, Pt = mt, xt = 0, Y = -1, Vt = 1 << mt, te = Vt - 1, e === 1 && Vt > 852 || e === 2 && Vt > 592) return 1;
      for (; ; ) {
        sr = Re - xt, A[De] + 1 < He ? (Gr = 0, Ai = A[De]) : A[De] >= He ? (Gr = fi[A[De] - He], Ai = fn[A[De] - He]) : (Gr = 96, Ai = 0), L = 1 << Re - xt, z = 1 << Pt, Xe = z;
        do
          z -= L, f[oe + (nn >> xt) + z] = sr << 24 | Gr << 16 | Ai | 0;
        while (z !== 0);
        for (L = 1 << Re - 1; nn & L; ) L >>= 1;
        if (L !== 0 ? (nn &= L - 1, nn += L) : nn = 0, De++, --hn[Re] == 0) {
          if (Re === We) break;
          Re = n[i + A[De]];
        }
        if (Re > mt && (nn & te) !== Y) {
          for (xt === 0 && (xt = mt), oe += Xe, Pt = Re - xt, Nt = 1 << Pt; Pt + xt < We && (Nt -= hn[Pt + xt], !(Nt <= 0)); ) Pt++, Nt <<= 1;
          if (Vt += 1 << Pt, e === 1 && Vt > 852 || e === 2 && Vt > 592) return 1;
          Y = nn & te, f[Y] = mt << 24 | Pt << 16 | oe - T | 0;
        }
      }
      return nn !== 0 && (f[oe + nn] = Re - xt << 24 | 64 << 16 | 0), R.bits = mt, 0;
    };
    const { Z_FINISH: Yk, Z_BLOCK: Foe, Z_TREES: h0, Z_OK: Bf, Z_STREAM_END: Goe, Z_NEED_DICT: Voe, Z_STREAM_ERROR: hc, Z_DATA_ERROR: Xk, Z_MEM_ERROR: Wk, Z_BUF_ERROR: Yoe, Z_DEFLATED: qk } = Dp, p0 = 16180, g0 = 16190, vd = 16191, cR = 16192, uR = 16194, m0 = 16199, E0 = 16200, dR = 16206, ls = 16209, Kk = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
    function Xoe() {
      this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
    }
    const zf = (e) => {
      if (!e) return 1;
      const n = e.state;
      return !n || n.strm !== e || n.mode < p0 || n.mode > 16211 ? 1 : 0;
    }, Jk = (e) => {
      if (zf(e)) return hc;
      const n = e.state;
      return e.total_in = e.total_out = n.total = 0, e.msg = "", n.wrap && (e.adler = 1 & n.wrap), n.mode = p0, n.last = 0, n.havedict = 0, n.flags = -1, n.dmax = 32768, n.head = null, n.hold = 0, n.bits = 0, n.lencode = n.lendyn = new Int32Array(852), n.distcode = n.distdyn = new Int32Array(592), n.sane = 1, n.back = -1, Bf;
    }, Zk = (e) => {
      if (zf(e)) return hc;
      const n = e.state;
      return n.wsize = 0, n.whave = 0, n.wnext = 0, Jk(e);
    }, Qk = (e, n) => {
      let i;
      if (zf(e)) return hc;
      const o = e.state;
      return n < 0 ? (i = 0, n = -n) : (i = 5 + (n >> 4), n < 48 && (n &= 15)), n && (n < 8 || n > 15) ? hc : (o.window !== null && o.wbits !== n && (o.window = null), o.wrap = i, o.wbits = n, Zk(e));
    }, $k = (e, n) => {
      if (!e) return hc;
      const i = new Xoe();
      e.state = i, i.strm = e, i.window = null, i.mode = p0;
      const o = Qk(e, n);
      return o !== Bf && (e.state = null), o;
    };
    let lR, fR, e9 = !0;
    const Woe = (e) => {
      if (e9) {
        lR = new Int32Array(512), fR = new Int32Array(32);
        let n = 0;
        for (; n < 144; ) e.lens[n++] = 8;
        for (; n < 256; ) e.lens[n++] = 9;
        for (; n < 280; ) e.lens[n++] = 7;
        for (; n < 288; ) e.lens[n++] = 8;
        for (fy(1, e.lens, 0, 288, lR, 0, e.work, { bits: 9 }), n = 0; n < 32; ) e.lens[n++] = 5;
        fy(2, e.lens, 0, 32, fR, 0, e.work, { bits: 5 }), e9 = !1;
      }
      e.lencode = lR, e.lenbits = 9, e.distcode = fR, e.distbits = 5;
    }, t9 = (e, n, i, o) => {
      let f;
      const T = e.state;
      return T.window === null && (T.wsize = 1 << T.wbits, T.wnext = 0, T.whave = 0, T.window = new Uint8Array(T.wsize)), o >= T.wsize ? (T.window.set(n.subarray(i - T.wsize, i), 0), T.wnext = 0, T.whave = T.wsize) : (f = T.wsize - T.wnext, f > o && (f = o), T.window.set(n.subarray(i - o, i - o + f), T.wnext), (o -= f) ? (T.window.set(n.subarray(i - o, i), 0), T.wnext = o, T.whave = T.wsize) : (T.wnext += f, T.wnext === T.wsize && (T.wnext = 0), T.whave < T.wsize && (T.whave += f))), 0;
    };
    var qoe = (e, n) => {
      let i, o, f, T, A, R, P, L, z, Y, te, oe, He, Re, De, Xe, We, mt, Pt, xt, Nt, Vt, nn = 0;
      const fn = new Uint8Array(4);
      let hn, ir;
      const sr = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
      if (zf(e) || !e.output || !e.input && e.avail_in !== 0) return hc;
      i = e.state, i.mode === vd && (i.mode = cR), A = e.next_out, f = e.output, P = e.avail_out, T = e.next_in, o = e.input, R = e.avail_in, L = i.hold, z = i.bits, Y = R, te = P, Vt = Bf;
      e: for (; ; ) switch (i.mode) {
        case p0:
          if (i.wrap === 0) {
            i.mode = cR;
            break;
          }
          for (; z < 16; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          if (2 & i.wrap && L === 35615) {
            i.wbits === 0 && (i.wbits = 15), i.check = 0, fn[0] = 255 & L, fn[1] = L >>> 8 & 255, i.check = aa(i.check, fn, 2, 0), L = 0, z = 0, i.mode = 16181;
            break;
          }
          if (i.head && (i.head.done = !1), !(1 & i.wrap) || (((255 & L) << 8) + (L >> 8)) % 31) {
            e.msg = "incorrect header check", i.mode = ls;
            break;
          }
          if ((15 & L) !== qk) {
            e.msg = "unknown compression method", i.mode = ls;
            break;
          }
          if (L >>>= 4, z -= 4, Nt = 8 + (15 & L), i.wbits === 0 && (i.wbits = Nt), Nt > 15 || Nt > i.wbits) {
            e.msg = "invalid window size", i.mode = ls;
            break;
          }
          i.dmax = 1 << i.wbits, i.flags = 0, e.adler = i.check = 1, i.mode = 512 & L ? 16189 : vd, L = 0, z = 0;
          break;
        case 16181:
          for (; z < 16; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          if (i.flags = L, (255 & Ks(i)) !== qk) {
            e.msg = "unknown compression method", i.mode = ls;
            break;
          }
          if (57344 & Ks(i)) {
            e.msg = "unknown header flags set", i.mode = ls;
            break;
          }
          i.head && (i.head.text = L >> 8 & 1), 512 & Ks(i) && 4 & i.wrap && (fn[0] = 255 & L, fn[1] = L >>> 8 & 255, i.check = aa(i.check, fn, 2, 0)), L = 0, z = 0, i.mode = 16182;
        case 16182:
          for (; z < 32; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          i.head && (i.head.time = L), 512 & Ks(i) && 4 & i.wrap && (fn[0] = 255 & L, fn[1] = L >>> 8 & 255, fn[2] = L >>> 16 & 255, fn[3] = L >>> 24 & 255, i.check = aa(i.check, fn, 4, 0)), L = 0, z = 0, i.mode = 16183;
        case 16183:
          for (; z < 16; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          i.head && (i.head.xflags = 255 & L, i.head.os = L >> 8), 512 & Ks(i) && 4 & i.wrap && (fn[0] = 255 & L, fn[1] = L >>> 8 & 255, i.check = aa(i.check, fn, 2, 0)), L = 0, z = 0, i.mode = 16184;
        case 16184:
          if (1024 & Ks(i)) {
            for (; z < 16; ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            i.length = L, i.head && (i.head.extra_len = L), 512 & Ks(i) && 4 & i.wrap && (fn[0] = 255 & L, fn[1] = L >>> 8 & 255, i.check = aa(i.check, fn, 2, 0)), L = 0, z = 0;
          } else i.head && (i.head.extra = null);
          i.mode = 16185;
        case 16185:
          if (1024 & Ks(i) && (oe = i.length, oe > R && (oe = R), oe && (i.head && (Nt = i.head.extra_len - i.length, i.head.extra || (i.head.extra = new Uint8Array(i.head.extra_len)), i.head.extra.set(o.subarray(T, T + oe), Nt)), 512 & Ks(i) && 4 & i.wrap && (i.check = aa(i.check, o, oe, T)), R -= oe, T += oe, i.length -= oe), i.length)) break e;
          i.length = 0, i.mode = 16186;
        case 16186:
          if (2048 & Ks(i)) {
            if (R === 0) break e;
            oe = 0;
            do
              Nt = o[T + oe++], i.head && Nt && i.length < 65536 && (i.head.name += String.fromCharCode(Nt));
            while (Nt && oe < R);
            if (512 & Ks(i) && 4 & i.wrap && (i.check = aa(i.check, o, oe, T)), R -= oe, T += oe, Nt) break e;
          } else i.head && (i.head.name = null);
          i.length = 0, i.mode = 16187;
        case 16187:
          if (4096 & Ks(i)) {
            if (R === 0) break e;
            oe = 0;
            do
              Nt = o[T + oe++], i.head && Nt && i.length < 65536 && (i.head.comment += String.fromCharCode(Nt));
            while (Nt && oe < R);
            if (512 & Ks(i) && 4 & i.wrap && (i.check = aa(i.check, o, oe, T)), R -= oe, T += oe, Nt) break e;
          } else i.head && (i.head.comment = null);
          i.mode = 16188;
        case 16188:
          if (512 & Ks(i)) {
            for (; z < 16; ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            if (4 & i.wrap && L !== (65535 & i.check)) {
              e.msg = "header crc mismatch", i.mode = ls;
              break;
            }
            L = 0, z = 0;
          }
          i.head && (i.head.hcrc = Ks(i) >> 9 & 1, i.head.done = !0), e.adler = i.check = 0, i.mode = vd;
          break;
        case 16189:
          for (; z < 32; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          e.adler = i.check = Kk(L), L = 0, z = 0, i.mode = g0;
        case g0:
          if (i.havedict === 0) return e.next_out = A, e.avail_out = P, e.next_in = T, e.avail_in = R, i.hold = L, i.bits = z, Voe;
          e.adler = i.check = 1, i.mode = vd;
        case vd:
          if (n === Foe || n === h0) break e;
        case cR:
          if (i.last) {
            L >>>= 7 & z, z -= 7 & z, i.mode = dR;
            break;
          }
          for (; z < 3; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          switch (i.last = 1 & L, L >>>= 1, z -= 1, 3 & L) {
            case 0:
              i.mode = 16193;
              break;
            case 1:
              if (Woe(i), i.mode = m0, n === h0) {
                L >>>= 2, z -= 2;
                break e;
              }
              break;
            case 2:
              i.mode = 16196;
              break;
            case 3:
              e.msg = "invalid block type", i.mode = ls;
          }
          L >>>= 2, z -= 2;
          break;
        case 16193:
          for (L >>>= 7 & z, z -= 7 & z; z < 32; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          if ((65535 & L) != (L >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", i.mode = ls;
            break;
          }
          if (i.length = 65535 & L, L = 0, z = 0, i.mode = uR, n === h0) break e;
        case uR:
          i.mode = 16195;
        case 16195:
          if (oe = i.length, oe) {
            if (oe > R && (oe = R), oe > P && (oe = P), oe === 0) break e;
            f.set(o.subarray(T, T + oe), A), R -= oe, T += oe, P -= oe, A += oe, i.length -= oe;
            break;
          }
          i.mode = vd;
          break;
        case 16196:
          for (; z < 14; ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          if (i.nlen = 257 + (31 & L), L >>>= 5, z -= 5, i.ndist = 1 + (31 & L), L >>>= 5, z -= 5, i.ncode = 4 + (15 & L), L >>>= 4, z -= 4, i.nlen > 286 || i.ndist > 30) {
            e.msg = "too many length or distance symbols", i.mode = ls;
            break;
          }
          i.have = 0, i.mode = 16197;
        case 16197:
          for (; i.have < i.ncode; ) {
            for (; z < 3; ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            i.lens[sr[i.have++]] = 7 & L, L >>>= 3, z -= 3;
          }
          for (; i.have < 19; ) i.lens[sr[i.have++]] = 0;
          if (i.lencode = i.lendyn, i.lenbits = 7, hn = { bits: i.lenbits }, Vt = fy(0, i.lens, 0, 19, i.lencode, 0, i.work, hn), i.lenbits = hn.bits, Vt) {
            e.msg = "invalid code lengths set", i.mode = ls;
            break;
          }
          i.have = 0, i.mode = 16198;
        case 16198:
          for (; i.have < i.nlen + i.ndist; ) {
            for (; nn = i.lencode[L & (1 << i.lenbits) - 1], De = nn >>> 24, Xe = nn >>> 16 & 255, We = 65535 & nn, !(De <= z); ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            if (We < 16) L >>>= De, z -= De, i.lens[i.have++] = We;
            else {
              if (We === 16) {
                for (ir = De + 2; z < ir; ) {
                  if (R === 0) break e;
                  R--, L += o[T++] << z, z += 8;
                }
                if (L >>>= De, z -= De, i.have === 0) {
                  e.msg = "invalid bit length repeat", i.mode = ls;
                  break;
                }
                Nt = i.lens[i.have - 1], oe = 3 + (3 & L), L >>>= 2, z -= 2;
              } else if (We === 17) {
                for (ir = De + 3; z < ir; ) {
                  if (R === 0) break e;
                  R--, L += o[T++] << z, z += 8;
                }
                L >>>= De, z -= De, Nt = 0, oe = 3 + (7 & L), L >>>= 3, z -= 3;
              } else {
                for (ir = De + 7; z < ir; ) {
                  if (R === 0) break e;
                  R--, L += o[T++] << z, z += 8;
                }
                L >>>= De, z -= De, Nt = 0, oe = 11 + (127 & L), L >>>= 7, z -= 7;
              }
              if (i.have + oe > i.nlen + i.ndist) {
                e.msg = "invalid bit length repeat", i.mode = ls;
                break;
              }
              for (; oe--; ) i.lens[i.have++] = Nt;
            }
          }
          if (i.mode === ls) break;
          if (i.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", i.mode = ls;
            break;
          }
          if (i.lenbits = 9, hn = { bits: i.lenbits }, Vt = fy(1, i.lens, 0, i.nlen, i.lencode, 0, i.work, hn), i.lenbits = hn.bits, Vt) {
            e.msg = "invalid literal/lengths set", i.mode = ls;
            break;
          }
          if (i.distbits = 6, i.distcode = i.distdyn, hn = { bits: i.distbits }, Vt = fy(2, i.lens, i.nlen, i.ndist, i.distcode, 0, i.work, hn), i.distbits = hn.bits, Vt) {
            e.msg = "invalid distances set", i.mode = ls;
            break;
          }
          if (i.mode = m0, n === h0) break e;
        case m0:
          i.mode = E0;
        case E0:
          if (R >= 6 && P >= 258) {
            e.next_out = A, e.avail_out = P, e.next_in = T, e.avail_in = R, i.hold = L, i.bits = z, joe(e, te), A = e.next_out, f = e.output, P = e.avail_out, T = e.next_in, o = e.input, R = e.avail_in, L = i.hold, z = i.bits, i.mode === vd && (i.back = -1);
            break;
          }
          for (i.back = 0; nn = i.lencode[L & (1 << i.lenbits) - 1], De = nn >>> 24, Xe = nn >>> 16 & 255, We = 65535 & nn, !(De <= z); ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          if (Xe && !(240 & Xe)) {
            for (mt = De, Pt = Xe, xt = We; nn = i.lencode[xt + ((L & (1 << mt + Pt) - 1) >> mt)], De = nn >>> 24, Xe = nn >>> 16 & 255, We = 65535 & nn, !(mt + De <= z); ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            L >>>= mt, z -= mt, i.back += mt;
          }
          if (L >>>= De, z -= De, i.back += De, i.length = We, Xe === 0) {
            i.mode = 16205;
            break;
          }
          if (32 & Xe) {
            i.back = -1, i.mode = vd;
            break;
          }
          if (64 & Xe) {
            e.msg = "invalid literal/length code", i.mode = ls;
            break;
          }
          i.extra = 15 & Xe, i.mode = 16201;
        case 16201:
          if (i.extra) {
            for (ir = i.extra; z < ir; ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            i.length += L & (1 << i.extra) - 1, L >>>= i.extra, z -= i.extra, i.back += i.extra;
          }
          i.was = i.length, i.mode = 16202;
        case 16202:
          for (; nn = i.distcode[L & (1 << i.distbits) - 1], De = nn >>> 24, Xe = nn >>> 16 & 255, We = 65535 & nn, !(De <= z); ) {
            if (R === 0) break e;
            R--, L += o[T++] << z, z += 8;
          }
          if (!(240 & Xe)) {
            for (mt = De, Pt = Xe, xt = We; nn = i.distcode[xt + ((L & (1 << mt + Pt) - 1) >> mt)], De = nn >>> 24, Xe = nn >>> 16 & 255, We = 65535 & nn, !(mt + De <= z); ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            L >>>= mt, z -= mt, i.back += mt;
          }
          if (L >>>= De, z -= De, i.back += De, 64 & Xe) {
            e.msg = "invalid distance code", i.mode = ls;
            break;
          }
          i.offset = We, i.extra = 15 & Xe, i.mode = 16203;
        case 16203:
          if (i.extra) {
            for (ir = i.extra; z < ir; ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            i.offset += L & (1 << i.extra) - 1, L >>>= i.extra, z -= i.extra, i.back += i.extra;
          }
          if (i.offset > i.dmax) {
            e.msg = "invalid distance too far back", i.mode = ls;
            break;
          }
          i.mode = 16204;
        case 16204:
          if (P === 0) break e;
          if (oe = te - P, i.offset > oe) {
            if (oe = i.offset - oe, oe > i.whave && i.sane) {
              e.msg = "invalid distance too far back", i.mode = ls;
              break;
            }
            oe > i.wnext ? (oe -= i.wnext, He = i.wsize - oe) : He = i.wnext - oe, oe > i.length && (oe = i.length), Re = i.window;
          } else Re = f, He = A - i.offset, oe = i.length;
          oe > P && (oe = P), P -= oe, i.length -= oe;
          do
            f[A++] = Re[He++];
          while (--oe);
          i.length === 0 && (i.mode = E0);
          break;
        case 16205:
          if (P === 0) break e;
          f[A++] = i.length, P--, i.mode = E0;
          break;
        case dR:
          if (i.wrap) {
            for (; z < 32; ) {
              if (R === 0) break e;
              R--, L |= o[T++] << z, z += 8;
            }
            if (te -= P, e.total_out += te, i.total += te, 4 & i.wrap && te && (e.adler = i.check = Ks(i) ? aa(i.check, f, te, A - te) : ry(i.check, f, te, A - te)), te = P, 4 & i.wrap && (Ks(i) ? L : Kk(L)) !== i.check) {
              e.msg = "incorrect data check", i.mode = ls;
              break;
            }
            L = 0, z = 0;
          }
          i.mode = 16207;
        case 16207:
          if (i.wrap && Ks(i)) {
            for (; z < 32; ) {
              if (R === 0) break e;
              R--, L += o[T++] << z, z += 8;
            }
            if (4 & i.wrap && L !== (4294967295 & i.total)) {
              e.msg = "incorrect length check", i.mode = ls;
              break;
            }
            L = 0, z = 0;
          }
          i.mode = 16208;
        case 16208:
          Vt = Goe;
          break e;
        case ls:
          Vt = Xk;
          break e;
        case 16210:
          return Wk;
        default:
          return hc;
      }
      return e.next_out = A, e.avail_out = P, e.next_in = T, e.avail_in = R, i.hold = L, i.bits = z, (i.wsize || te !== e.avail_out && i.mode < ls && (i.mode < dR || n !== Yk)) && t9(e, e.output, e.next_out, te - e.avail_out), Y -= e.avail_in, te -= e.avail_out, e.total_in += Y, e.total_out += te, i.total += te, 4 & i.wrap && te && (e.adler = i.check = Ks(i) ? aa(i.check, f, te, e.next_out - te) : ry(i.check, f, te, e.next_out - te)), e.data_type = i.bits + (i.last ? 64 : 0) + (i.mode === vd ? 128 : 0) + (i.mode === m0 || i.mode === uR ? 256 : 0), (Y === 0 && te === 0 || n === Yk) && Vt === Bf && (Vt = Yoe), Vt;
    }, Td = { inflateReset: Zk, inflateReset2: Qk, inflateResetKeep: Jk, inflateInit: (e) => $k(e, 15), inflateInit2: $k, inflate: qoe, inflateEnd: (e) => {
      if (zf(e)) return hc;
      let n = e.state;
      return n.window && (n.window = null), e.state = null, Bf;
    }, inflateGetHeader: (e, n) => {
      if (zf(e)) return hc;
      const i = e.state;
      return 2 & i.wrap ? (i.head = n, n.done = !1, Bf) : hc;
    }, inflateSetDictionary: (e, n) => {
      const i = n.length;
      let o, f, T;
      return zf(e) ? hc : (o = e.state, o.wrap !== 0 && o.mode !== g0 ? hc : o.mode === g0 && (f = 1, f = ry(f, n, i, 0), f !== o.check) ? Xk : (T = t9(e, n, i, i), T ? (o.mode = 16210, Wk) : (o.havedict = 1, Bf)));
    }, inflateInfo: "pako inflate (from Nodeca project)" }, Koe = function() {
      this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
    };
    const n9 = Object.prototype.toString, { Z_NO_FLUSH: Joe, Z_FINISH: Zoe, Z_OK: hy, Z_STREAM_END: hR, Z_NEED_DICT: pR, Z_STREAM_ERROR: Qoe, Z_DATA_ERROR: r9, Z_MEM_ERROR: $oe } = Dp;
    function py(e) {
      this.options = u0.assign({ chunkSize: 65536, windowBits: 15, to: "" }, e || {});
      const n = this.options;
      n.raw && n.windowBits >= 0 && n.windowBits < 16 && (n.windowBits = -n.windowBits, n.windowBits === 0 && (n.windowBits = -15)), !(n.windowBits >= 0 && n.windowBits < 16) || e && e.windowBits || (n.windowBits += 32), n.windowBits > 15 && n.windowBits < 48 && !(15 & n.windowBits) && (n.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Gk(), this.strm.avail_out = 0;
      let i = Td.inflateInit2(this.strm, n.windowBits);
      if (i !== hy) throw new Error(kf[i]);
      if (this.header = new Koe(), Td.inflateGetHeader(this.strm, this.header), n.dictionary && (typeof n.dictionary == "string" ? n.dictionary = dy.string2buf(n.dictionary) : n9.call(n.dictionary) === "[object ArrayBuffer]" && (n.dictionary = new Uint8Array(n.dictionary)), n.raw && (i = Td.inflateSetDictionary(this.strm, n.dictionary), i !== hy))) throw new Error(kf[i]);
    }
    function gR(e, n) {
      const i = new py(n);
      if (i.push(e), i.err) throw i.msg || kf[i.err];
      return i.result;
    }
    py.prototype.push = function(e, n) {
      const i = this.strm, o = this.options.chunkSize, f = this.options.dictionary;
      let T, A, R;
      if (this.ended) return !1;
      for (A = n === ~~n ? n : n === !0 ? Zoe : Joe, n9.call(e) === "[object ArrayBuffer]" ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length; ; ) {
        for (i.avail_out === 0 && (i.output = new Uint8Array(o), i.next_out = 0, i.avail_out = o), T = Td.inflate(i, A), T === pR && f && (T = Td.inflateSetDictionary(i, f), T === hy ? T = Td.inflate(i, A) : T === r9 && (T = pR)); i.avail_in > 0 && T === hR && i.state.wrap > 0 && e[i.next_in] !== 0; ) Td.inflateReset(i), T = Td.inflate(i, A);
        switch (T) {
          case Qoe:
          case r9:
          case pR:
          case $oe:
            return this.onEnd(T), this.ended = !0, !1;
        }
        if (R = i.avail_out, i.next_out && (i.avail_out === 0 || T === hR)) if (this.options.to === "string") {
          let P = dy.utf8border(i.output, i.next_out), L = i.next_out - P, z = dy.buf2string(i.output, P);
          i.next_out = L, i.avail_out = o - L, L && i.output.set(i.output.subarray(P, P + L), 0), this.onData(z);
        } else this.onData(i.output.length === i.next_out ? i.output : i.output.subarray(0, i.next_out));
        if (T !== hy || R !== 0) {
          if (T === hR) return T = Td.inflateEnd(this.strm), this.onEnd(T), this.ended = !0, !0;
          if (i.avail_in === 0) break;
        }
      }
      return !0;
    }, py.prototype.onData = function(e) {
      this.chunks.push(e);
    }, py.prototype.onEnd = function(e) {
      e === hy && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = u0.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
    };
    var ece = { Inflate: py, inflate: gR, inflateRaw: function(e, n) {
      return (n = n || {}).raw = !0, gR(e, n);
    }, ungzip: gR, constants: Dp };
    const { Deflate: R3e, deflate: tce, deflateRaw: N3e, gzip: w3e } = koe, { Inflate: _3e, inflate: nce, inflateRaw: P3e, ungzip: x3e } = ece;
    var rce = tce, ice = nce, i9 = function(e) {
      return e[e.ONE_BYTE = 0] = "ONE_BYTE", e[e.TWO_BYTE = 1] = "TWO_BYTE", e;
    }(i9 || {});
    class sce {
      constructor() {
        Ve(this, "_sequence", 0), Ve(this, "_startTime", Date.now()), Ve(this, "isUseOneByte", !0);
      }
      get startTime() {
        const n = Date.now() - this._startTime;
        return n < Math.pow(2, 16) ? n : (this._startTime += Math.pow(2, 16), this.startTime);
      }
      get sequence() {
        return this._sequence < Math.pow(2, 32) ? this._sequence++ : (this._sequence -= Math.pow(2, 32), this.sequence);
      }
      serialize(n) {
        const i = { commonPacketHeader: { length: 0, reserved: 0, extension: 0, sequence: this.sequence }, commonStreamHeader: this.startTime, extension: void 0, payload: n };
        if (n.byteLength > 128) {
          const R = new Uint8Array(4);
          R.set([1, 0, 0, 0]);
          const P = { id: 0, length: 4, data: R.buffer }, L = { profile: this.isUseOneByte ? 0 : 1, length: this.isUseOneByte ? 5 : 6, datas: [P] };
          i.commonPacketHeader.extension = 1, i.extension = L, i.payload = this.compress(n), i.commonPacketHeader.length = 8 + (i.extension.length + 2) + i.payload.byteLength;
        } else i.commonPacketHeader.length = 8 + i.payload.byteLength;
        ft("SHOW_DATASTREAM2_LOG") && Ee.debug("send data header: ".concat(JSON.stringify(i.commonPacketHeader)));
        const o = new ArrayBuffer(i.commonPacketHeader.length), f = new Uint8Array(o), T = new DataView(o);
        let A = 0;
        if (T.setUint16(A, i.commonPacketHeader.extension << 15 | i.commonPacketHeader.reserved << 14 | i.commonPacketHeader.length, !0), A += 2, T.setUint32(A, i.commonPacketHeader.sequence, !0), A += 4, T.setUint16(A, i.commonStreamHeader, !0), A += 2, i.extension) {
          const R = this.serializeExtension(i.extension);
          f.set(new Uint8Array(R), A), A += R.byteLength;
        }
        if (f.set(new Uint8Array(i.payload), A), A += i.payload.byteLength, A !== i.commonPacketHeader.length) throw Error("serialize error!");
        return o;
      }
      deserialize(n) {
        if (n.byteLength < 4) return new ArrayBuffer(0);
        const i = new DataView(n);
        let o = 0;
        const f = i.getUint16(o, !0);
        o += 2;
        const T = { length: 16383 & f, reserved: (16384 & f) >> 14, extension: (32768 & f) >> 15, sequence: i.getUint16(o + 2, !0) << 16 | i.getUint16(o, !0) };
        let A, R;
        if (o += 4, ft("SHOW_DATASTREAM2_LOG") && Ee.debug("receive data header: ".concat(JSON.stringify(T))), i.getUint16(o, !0), o += 2, T.extension) {
          R = this.deserializeExtension(n.slice(o)), o += 2 + R.length, A = n.slice(o);
          let P = !1;
          if (R.datas.length > 0) {
            const L = R.datas.find((z) => z.id === 0);
            L && (P = (1 & new DataView(L.data).getUint32(0, !0)) == 1);
          }
          A = P ? this.decompress(A) : A;
        } else A = n.slice(8);
        return A;
      }
      serializeExtension(n) {
        const { profile: i, length: o, datas: f } = n, T = new ArrayBuffer(o + 2), A = new Uint8Array(T), R = new DataView(T);
        let P = 0;
        if (R.setUint8(P++, i), R.setUint8(P++, o), f.forEach((L) => {
          i ? (R.setUint8(P++, L.id), R.setUint8(P++, L.length), A.set(new Uint8Array(L.data), P), P += L.data.byteLength) : (R.setUint8(P++, L.id | L.length << 4), A.set(new Uint8Array(L.data), P), P += L.data.byteLength);
        }), P !== o + 2) throw Error("serialize extension error, is ".concat(P, "!==").concat(o + 2));
        return T;
      }
      deserializeExtension(n) {
        const i = new DataView(n);
        let o = 0;
        const f = i.getUint8(o);
        o++;
        const T = i.getUint8(o);
        o++;
        const A = f === i9.TWO_BYTE, R = [], P = new DataView(n, 2);
        let L = 0;
        for (; L < T; ) {
          let z = 0, Y = 0, te = new ArrayBuffer(0);
          A ? (z = P.getUint8(L), L++, Y = P.getUint8(L), L++) : (z = 15 & P.getUint8(L), Y = P.getUint8(L) >> 4, L++), Y > 0 && (te = P.buffer.slice(L + 2, L + 2 + Y), L += te.byteLength), R.push({ id: z, length: Y, data: te });
        }
        if (L !== T) throw Error("parse error");
        return { profile: f, length: T, datas: R };
      }
      decompress(n) {
        return ice(new Uint8Array(n));
      }
      compress(n) {
        return rce(new Uint8Array(n));
      }
    }
    const ace = { name: "DataStream", create: (e, n) => {
      const i = n ? new Tse(e) : new bse(e);
      return i.useDataStream(new sce()), i;
    } };
    class oce extends ii {
      constructor(n, i, o) {
        super(), Ve(this, "ws", void 0), Ve(this, "requestId", 1), Ve(this, "heartBeatTimer", void 0), Ve(this, "joinInfo", void 0), Ve(this, "clientId", void 0), Ve(this, "onOpen", () => {
          this.emit("open"), this.startHeartBeatCheck();
        }), Ve(this, "onClose", (f) => {
          this.emit("close"), this.dispose();
        }), Ve(this, "onMessage", (f) => {
          const T = JSON.parse(f.data);
          if (!T || T.command !== "serverResponse" || !T.requestId) return T && T.command === "serverStatus" && T.serverStatus && T.serverStatus.command ? (this.emit("status", T.serverStatus), void this.emit(T.serverStatus.command, T.serverStatus)) : void 0;
          this.emit("req_".concat(T.requestId), T);
        }), this.joinInfo = n, this.clientId = i, this.ws = new HE("cross-channel-".concat(this.clientId), o), this.ws.on(Fn.RECONNECTING, () => {
          this.ws.reconnectMode = "retry", this.emit("reconnecting");
        }), this.ws.on(Fn.CONNECTED, this.onOpen), this.ws.on(Fn.ON_MESSAGE, this.onMessage), this.ws.on(Fn.CLOSED, this.onClose);
      }
      isConnect() {
        return this.ws.state === "connected";
      }
      sendMessage(n) {
        const i = this.requestId++;
        return n.requestId = i, n.seq = i, this.ws.sendMessage(n), i;
      }
      waitStatus(n) {
        return new cn((i, o) => {
          const f = window.setTimeout(() => {
            o(new jt(Je.TIMEOUT, "wait status timeout, status: ".concat(n)));
          }, 5e3);
          this.once(n, (T) => {
            window.clearTimeout(f), T.state && T.state !== 0 ? o(new jt(Je.CROSS_CHANNEL_WAIT_STATUS_ERROR, "wait status error, status: ".concat(n))) : i(void 0);
          }), this.once("dispose", () => {
            window.clearTimeout(f), o(new jt(Je.WS_ABORT));
          });
        });
      }
      async request(n) {
        if (this.ws.state === "closed") throw new jt(Je.WS_DISCONNECT);
        const i = () => new cn((A, R) => {
          this.ws.once(Fn.CLOSED, () => R(new jt(Je.WS_ABORT))), this.ws.once(Fn.CONNECTED, A);
        });
        this.ws.state !== "connected" && await i();
        const o = this.sendMessage(n), f = new cn((A, R) => {
          const P = () => {
            R(new jt(Je.WS_ABORT));
          };
          this.ws.once(Fn.RECONNECTING, P), this.ws.once(Fn.CLOSED, P), this.once("req_".concat(o), A), Es(3e3).then(() => {
            this.removeAllListeners("req_".concat(o)), this.ws.off(Fn.RECONNECTING, P), this.ws.off(Fn.CLOSED, P), R(new jt(Je.TIMEOUT, "cross channel ws request timeout"));
          });
        }), T = await f;
        if (!T || T.code !== 200) throw new jt(Je.CROSS_CHANNEL_SERVER_ERROR_RESPONSE, "response: ".concat(JSON.stringify(T)));
        return T;
      }
      async connect(n) {
        this.ws.removeAllListeners(Fn.REQUEST_NEW_URLS), this.ws.on(Fn.REQUEST_NEW_URLS, (i) => {
          i(n);
        }), await this.ws.init(n);
      }
      dispose() {
        this.clearHeartBeatCheck(), this.emit("dispose"), this.removeAllListeners(), this.ws.close();
      }
      sendPing(n) {
        const i = this.requestId++;
        return n.requestId = i, this.ws.sendMessage(n), i;
      }
      startHeartBeatCheck() {
        this.heartBeatTimer && window.clearInterval(this.heartBeatTimer), this.heartBeatTimer = window.setInterval(() => {
          this.sendPing({ command: "ping", appId: this.joinInfo.appId, cname: this.joinInfo.cname, uid: this.joinInfo.uid.toString(), sid: this.joinInfo.sid, ts: +/* @__PURE__ */ new Date(), requestId: 0 });
        }, 3e3);
      }
      clearHeartBeatCheck() {
        window.clearInterval(this.heartBeatTimer), this.heartBeatTimer = void 0;
      }
    }
    class cce extends ii {
      set state(n) {
        n !== this._state && (n !== Sa.RELAY_STATE_FAILURE && (this.errorCode = yp.RELAY_OK), this.emit("state", n, this.errorCode), this._state = n);
      }
      get state() {
        return this._state;
      }
      constructor(n, i, o, f, T) {
        super(), Ve(this, "joinInfo", void 0), Ve(this, "sid", void 0), Ve(this, "clientId", void 0), Ve(this, "cancelToken", fa.CancelToken.source()), Ve(this, "workerToken", void 0), Ve(this, "requestId", 0), Ve(this, "signal", void 0), Ve(this, "prevChannelMediaConfig", void 0), Ve(this, "httpRetryConfig", void 0), Ve(this, "_resolution", void 0), Ve(this, "_state", Sa.RELAY_STATE_IDLE), Ve(this, "errorCode", yp.RELAY_OK), Ve(this, "onStatus", (A) => {
          Ee.debug("[".concat(this.clientId, "] ChannelMediaStatus: ").concat(JSON.stringify(A))), A && A.command && (A.command === "onAudioPacketReceived" && this.emit("event", hd.PACKET_RECEIVED_AUDIO_FROM_SRC), A.command === "onVideoPacketReceived" && this.emit("event", hd.PACKET_RECEIVED_VIDEO_FROM_SRC), A.command === "onSrcTokenPrivilegeDidExpire" && (this.errorCode = yp.SRC_TOKEN_EXPIRED, this.state = Sa.RELAY_STATE_FAILURE), A.command === "onDestTokenPrivilegeDidExpire" && (this.errorCode = yp.DEST_TOKEN_EXPIRED, this.state = Sa.RELAY_STATE_FAILURE));
        }), Ve(this, "onReconnect", async () => {
          Ee.debug("[".concat(this.clientId, "] ChannelMediaSocket disconnect, reconnecting")), this.emit("event", hd.NETWORK_DISCONNECTED), this.state = Sa.RELAY_STATE_IDLE, this.prevChannelMediaConfig && this.sendStartRelayMessage(this.prevChannelMediaConfig).catch((A) => {
            this.state !== Sa.RELAY_STATE_IDLE && (Ee.error("auto restart channel media relay failed", A.toString()), this.errorCode = yp.SERVER_CONNECTION_LOST, this.state = Sa.RELAY_STATE_FAILURE);
          });
        }), this.joinInfo = n, this.clientId = i, this.sid = rp(), this.signal = new oce(this.joinInfo, this.clientId, o), this.httpRetryConfig = f, this._resolution = T;
      }
      async startChannelMediaRelay(n) {
        if (this.state !== Sa.RELAY_STATE_IDLE) throw new jt(Je.INVALID_OPERATION);
        this.state = Sa.RELAY_STATE_CONNECTING, await this.connect(), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: connect success"));
        try {
          await this.sendStartRelayMessage(n);
        } catch (i) {
          throw i.data && i.data.serverResponse && i.data.serverResponse.command === "SetSourceChannel" ? new jt(Je.CROSS_CHANNEL_FAILED_JOIN_SRC) : i.data && i.data.serverResponse && i.serverResponse.command === "SetDestChannelStatus" ? new jt(Je.CROSS_CHANNEL_FAILED_JOIN_DEST) : i.data && i.data.serverResponse && i.serverResponse.command === "StartPacketTransfer" ? new jt(Je.CROSS_CHANNEL_FAILED_PACKET_SENT_TO_DEST) : i;
        }
        this.prevChannelMediaConfig = n;
      }
      async updateChannelMediaRelay(n) {
        if (this.state !== Sa.RELAY_STATE_RUNNING) throw new jt(Je.INVALID_OPERATION);
        await this.sendUpdateMessage(n), this.prevChannelMediaConfig = n;
      }
      async setVideoProfile(n) {
        if (this._resolution = n, this.state !== Sa.RELAY_STATE_RUNNING) throw new jt(Je.INVALID_OPERATION);
        const i = this.genMessage(sa.SetVideoProfile);
        await this.signal.request(i), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: setVideoProfile success"));
      }
      async stopChannelMediaRelay() {
        await this.sendStopRelayMessage(), Ee.debug("[".concat(this.clientId, "] stopChannelMediaRelay: send stop message success")), this.state = Sa.RELAY_STATE_IDLE, this.dispose();
      }
      dispose() {
        Ee.debug("[".concat(this.clientId, "] disposeChannelMediaRelay")), this.cancelToken.cancel(), this.cancelToken = fa.CancelToken.source(), this.state = Sa.RELAY_STATE_IDLE, this.emit("dispose"), this.signal.dispose(), this.prevChannelMediaConfig = void 0;
      }
      async connect() {
        const n = await Tae(this.joinInfo, this.cancelToken.token, this.httpRetryConfig);
        this.workerToken = n.workerToken, await this.signal.connect(n.addressList), this.emit("event", hd.NETWORK_CONNECTED), this.signal.on("status", this.onStatus), this.signal.on("reconnecting", this.onReconnect);
      }
      async sendStartRelayMessage(n) {
        const i = this.genMessage(sa.StopPacketTransfer);
        await this.signal.request(i), await this.signal.waitStatus("Normal Quit"), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: StopPacketTransfer success"));
        const o = this.genMessage(sa.SetSdkProfile, n);
        await this.signal.request(o), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetSdkProfile success"));
        const f = this.genMessage(sa.SetSourceChannel, n);
        await this.signal.request(f), await this.signal.waitStatus("SetSourceChannelStatus"), this.emit("event", hd.PACKET_JOINED_SRC_CHANNEL), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetSourceChannel success"));
        const T = this.genMessage(sa.SetSourceUserId, n);
        await this.signal.request(T), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetSourceUserId success"));
        const A = this.genMessage(sa.SetDestChannel, n);
        await this.signal.request(A), await this.signal.waitStatus("SetDestChannelStatus"), this.emit("event", hd.PACKET_JOINED_DEST_CHANNEL), Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: SetDestChannel success"));
        const R = this.genMessage(sa.StartPacketTransfer, n);
        await this.signal.request(R), this.emit("event", hd.PACKET_SENT_TO_DEST_CHANNEL), this.state = Sa.RELAY_STATE_RUNNING, Ee.debug("[".concat(this.clientId, "] startChannelMediaRelay: StartPacketTransfer success")), this.setVideoProfile(this._resolution);
      }
      async sendUpdateMessage(n) {
        const i = this.genMessage(sa.UpdateDestChannel, n);
        await this.signal.request(i), this.emit("event", hd.PACKET_UPDATE_DEST_CHANNEL), Ee.debug("[".concat(this.clientId, "] sendUpdateMessage: UpdateDestChannel success"));
      }
      async sendStopRelayMessage() {
        const n = this.genMessage(sa.StopPacketTransfer);
        await this.signal.request(n), Ee.debug("[".concat(this.clientId, "] sendStopRelayMessage: StopPacketTransfer success"));
      }
      genMessage(n, i) {
        const o = [], f = [], T = [];
        this.requestId += 1;
        const A = { appId: this.joinInfo.appId, cname: this.joinInfo.cname, uid: this.joinInfo.uid.toString(), sdkVersion: Ro, sid: this.sid, ts: Date.now(), requestId: this.requestId, seq: this.requestId, allocate: !0, clientRequest: {} };
        A.sdkVersion === "4.23.0" && (A.sdkVersion = "0.0.1");
        let R = null, P = null;
        switch (n) {
          case sa.SetSdkProfile:
            return A.clientRequest = { command: "SetSdkProfile", type: "multi_channel" }, A;
          case sa.SetSourceChannel:
            if (P = i && i.getSrcChannelMediaInfo(), !P) throw new jt(Je.UNEXPECTED_ERROR, "can not find source config");
            return A.clientRequest = { command: "SetSourceChannel", uid: "0", channelName: P.channelName, token: P.token || this.joinInfo.appId }, A;
          case sa.SetSourceUserId:
            if (P = i && i.getSrcChannelMediaInfo(), !P) throw new jt(Je.UNEXPECTED_ERROR, "can not find source config");
            return A.clientRequest = { command: "SetSourceUserId", uid: P.uid + "" }, A;
          case sa.SetDestChannel:
            if (R = i && i.getDestChannelMediaInfo(), !R) throw new jt(Je.UNEXPECTED_ERROR, "can not find dest config");
            return R.forEach((L) => {
              o.push(L.channelName), f.push(L.uid + ""), T.push(L.token || this.joinInfo.appId);
            }), A.clientRequest = { command: "SetDestChannel", channelName: o, uid: f, token: T }, A;
          case sa.StartPacketTransfer:
            return A.clientRequest = { command: "StartPacketTransfer" }, A;
          case sa.Reconnect:
            return A.clientRequest = { command: "Reconnect" }, A;
          case sa.StopPacketTransfer:
            return A.clientRequest = { command: "StopPacketTransfer" }, A;
          case sa.UpdateDestChannel:
            if (R = i && i.getDestChannelMediaInfo(), !R) throw new jt(Je.UNEXPECTED_ERROR, "can not find dest config");
            return R.forEach((L) => {
              o.push(L.channelName), f.push(L.uid + ""), T.push(L.token || this.joinInfo.appId);
            }), A.clientRequest = { command: "UpdateDestChannel", channelName: o, uid: f, token: T }, A;
          case sa.SetVideoProfile:
            A.clientRequest = { command: "SetVideoProfile", width: this._resolution.width, height: this._resolution.height };
        }
        return A;
      }
    }
    const uce = { name: "ChannelMediaRelay", create: function(e) {
      return new cce(e.joinInfo, e.clientId, e.websocketRetryConfig || zi, e.httpRetryConfig || zi, e.resolution);
    } };
    function s9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function gy(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? s9(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : s9(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    class dce extends ii {
      constructor(n, i, o, f) {
        super(), Ve(this, "spec", void 0), Ve(this, "token", void 0), Ve(this, "websocket", void 0), Ve(this, "pingpongTimer", void 0), Ve(this, "reconnectMode", "retry"), Ve(this, "serviceMode", void 0), Ve(this, "reqId", 0), Ve(this, "commandReqId", 0), Ve(this, "handleWebSocketOpen", () => {
          this.reconnectMode = "retry", this.startPingPong();
        }), Ve(this, "handleWebSocketMessage", (T) => {
          if (!T.data) return;
          const A = JSON.parse(T.data);
          A.requestId ? this.emit("@".concat(A.requestId, "-").concat(A.sid), A) : (Cn.workerEvent(this.spec.sid, { actionType: "status", serverCode: A.code, workerType: this.serviceMode === fd.TRANSCODE ? 1 : 2 }), this.emit(rl.PUBLISH_STREAM_STATUS, A));
        }), this.spec = i, this.token = n, this.serviceMode = f, this.websocket = new HE("live-streaming", o), this.websocket.on(Fn.CONNECTED, this.handleWebSocketOpen), this.websocket.on(Fn.ON_MESSAGE, this.handleWebSocketMessage), this.websocket.on(Fn.REQUEST_NEW_URLS, (T, A) => {
          Ss(this, rl.REQUEST_NEW_ADDRESS).then(T).catch(A);
        }), this.websocket.on(Fn.RECONNECTING, () => {
          this.websocket.reconnectMode = this.reconnectMode;
        });
      }
      init(n) {
        return this.websocket.init(n);
      }
      async request(n, i, o, f) {
        this.reqId += 1, n === "request" && (this.commandReqId += 1);
        const T = this.commandReqId, A = this.reqId;
        if (!A || !this.websocket) throw new jt(Je.UNEXPECTED_ERROR);
        const R = gy({ command: n, sdkVersion: Ro === "4.23.0" ? "0.0.1" : Ro, seq: A, requestId: A, allocate: o, cname: this.spec.cname, appId: this.spec.appId, sid: this.spec.sid, uid: this.spec.uid.toString(), ts: Math.floor(Date.now() / 1e3) }, i);
        if (this.websocket.state === "closed") throw new jt(Je.WS_DISCONNECT);
        const P = () => new cn((te, oe) => {
          this.websocket.once(Fn.CLOSED, () => oe(new jt(Je.WS_ABORT))), this.websocket.once(Fn.CONNECTED, te);
        });
        this.websocket.state !== "connected" && await P(), R.clientRequest && (R.clientRequest.workerToken = this.token);
        const L = new cn((te, oe) => {
          const He = () => {
            oe(new jt(Je.WS_ABORT));
          };
          this.websocket.once(Fn.RECONNECTING, He), this.websocket.once(Fn.CLOSED, He), this.once("@".concat(A, "-").concat(this.spec.sid), (Re) => {
            te(Re);
          });
        });
        f && Cn.workerEvent(this.spec.sid, gy(gy({}, f), {}, { requestId: T, actionType: "request", payload: JSON.stringify(i.clientRequest), serverCode: 0, code: 0 }));
        const z = Date.now();
        this.websocket.sendMessage(R);
        let Y = null;
        try {
          Y = await L;
        } catch (te) {
          if (this.websocket.state === "closed") throw te;
          return await P(), await this.request(n, i, o);
        }
        return f && Cn.workerEvent(this.spec.sid, gy(gy({}, f), {}, { requestId: T, actionType: "response", payload: JSON.stringify(Y.serverResponse), serverCode: Y.code, success: Y.code === 200, responseTime: Date.now() - z })), Y.code !== 200 && this.handleResponseError(Y), Y;
      }
      tryNextAddress() {
        this.reconnectMode = "tryNext", this.websocket.reconnect("tryNext");
      }
      close() {
        const n = Ro === "4.23.0" ? "0.0.1" : Ro;
        this.reqId += 1, this.websocket.state === "connected" ? (this.websocket.sendMessage({ command: "request", appId: this.spec.appId, cname: this.spec.cname, uid: this.spec.uid.toString(), sdkVersion: n, sid: this.spec.sid, seq: this.reqId, ts: Math.floor(Date.now() / 1e3), requestId: this.reqId, clientRequest: { command: "DestroyWorker" } }), this.websocket.close(!1, !0)) : this.websocket.close(!1), this.pingpongTimer && (window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0);
      }
      handleResponseError(n) {
        switch (n.code) {
          case Wi.LIVE_STREAM_RESPONSE_ALREADY_EXISTS_STREAM:
            return void Ee.warning("live stream response already exists stream");
          case Wi.LIVE_STREAM_RESPONSE_TRANSCODING_PARAMETER_ERROR:
          case Wi.LIVE_STREAM_RESPONSE_BAD_STREAM:
          case Wi.LIVE_STREAM_RESPONSE_WM_PARAMETER_ERROR:
            return new jt(Je.LIVE_STREAMING_INVALID_ARGUMENT, "", { code: n.code }).throw();
          case Wi.LIVE_STREAM_RESPONSE_WM_WORKER_NOT_EXIST:
            if (n.serverResponse.command === "UnpublishStream") return;
            throw new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "live stream response wm worker not exist", { retry: !0 });
          case Wi.LIVE_STREAM_RESPONSE_NOT_AUTHORIZED:
            return new jt(Je.LIVE_STREAMING_PUBLISH_STREAM_NOT_AUTHORIZED, "", { code: n.code }).throw();
          case Wi.LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE: {
            const i = new jt(Je.LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE);
            return this.emit(rl.WARNING, i, n.serverResponse.url);
          }
          case Wi.LIVE_STREAM_RESPONSE_REQUEST_TOO_OFTEN: {
            const i = new jt(Je.LIVE_STREAMING_WARN_FREQUENT_REQUEST);
            return this.emit(rl.WARNING, i, n.serverResponse.url);
          }
          case Wi.LIVE_STREAM_RESPONSE_NOT_FOUND_PUBLISH:
            throw new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "live stream response wm worker not exist", { retry: !0 });
          case Wi.LIVE_STREAM_RESPONSE_NOT_SUPPORTED:
            return new jt(Je.LIVE_STREAMING_TRANSCODING_NOT_SUPPORTED, "", { code: n.code }).throw();
          case Wi.LIVE_STREAM_RESPONSE_MAX_STREAM_NUM: {
            const i = new jt(Je.LIVE_STREAMING_WARN_STREAM_NUM_REACH_LIMIT);
            return this.emit(rl.WARNING, i, n.serverResponse.url);
          }
          case Wi.LIVE_STREAM_RESPONSE_INTERNAL_SERVER_ERROR:
            return new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "", { code: n.code }).throw();
          case Wi.LIVE_STREAM_RESPONSE_RESOURCE_LIMIT:
            throw new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "live stream resource limit", { retry: !0, changeAddress: !0 });
          case Wi.LIVE_STREAM_RESPONSE_WORKER_LOST:
          case Wi.LIVE_STREAM_RESPONSE_WORKER_QUIT:
            if (n.serverResponse.command === "UnpublishStream") return;
            throw new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "error fail send message", { retry: !0, changeAddress: !0 });
          case Wi.ERROR_FAIL_SEND_MESSAGE:
            if (n.serverResponse.command === "UnpublishStream") return;
            if (n.serverResponse.command === "UpdateTranscoding" || n.serverResponse.command === "ControlStream") return new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "error fail send message", { code: n.code }).throw();
            throw new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "error fail send message", { retry: !0, changeAddress: !0 });
          case Wi.PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN:
          case Wi.PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT:
          case Wi.PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE:
          case Wi.PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH:
            return new jt(Je.LIVE_STREAMING_CDN_ERROR, "", { code: n.code }).throw();
        }
      }
      startPingPong() {
        this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(() => {
          this.websocket.state === "connected" && this.request("ping", {}).catch(fT);
        }, 6e3);
      }
    }
    function a9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function Ra(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? a9(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : a9(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    class lce extends ii {
      constructor(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zi, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : zi;
        super(), Ve(this, "onLiveStreamWarning", void 0), Ve(this, "onLiveStreamError", void 0), Ve(this, "spec", void 0), Ve(this, "retryTimeout", 1e4), Ve(this, "connection", void 0), Ve(this, "httpRetryConfig", void 0), Ve(this, "wsRetryConfig", void 0), Ve(this, "streamingTasks", /* @__PURE__ */ new Map()), Ve(this, "isStartingStreamingTask", !1), Ve(this, "taskMutex", new xs("live-streaming")), Ve(this, "cancelToken", fa.CancelToken.source()), Ve(this, "transcodingConfig", void 0), Ve(this, "uapResponse", void 0), Ve(this, "lastTaskId", 1), Ve(this, "statusError", /* @__PURE__ */ new Map()), this.spec = n, this.httpRetryConfig = o, this.wsRetryConfig = i;
      }
      async setTranscodingConfig(n) {
        const i = Ra(Ra({}, eae), n);
        i.videoCodecProfile !== 66 && i.videoCodecProfile !== 77 && i.videoCodecProfile !== 100 && (Ee.debug("[".concat(this.spec.clientId, "] set transcoding config, fix video codec profile: ").concat(i.videoCodecProfile, " -> 100")), i.videoCodecProfile = 100), i.transcodingUsers || (i.transcodingUsers = i.userConfigs), i.transcodingUsers && (i.transcodingUsers = i.transcodingUsers.map((A) => Ra(Ra(Ra({}, $se), A), {}, { zOrder: A.zOrder ? A.zOrder + 1 : 1 }))), function(A) {
          ri(A.width) || xr(A.width, "config.width", 0, 1e4), ri(A.height) || xr(A.height, "config.height", 0, 1e4), ri(A.videoBitrate) || xr(A.videoBitrate, "config.videoBitrate", 1, 1e6), ri(A.videoFrameRate) || xr(A.videoFrameRate, "config.videoFrameRate"), ri(A.lowLatency) || od(A.lowLatency, "config.lowLatency"), ri(A.audioSampleRate) || $i(A.audioSampleRate, "config.audioSampleRate", [32e3, 44100, 48e3]), ri(A.audioBitrate) || xr(A.audioBitrate, "config.audioBitrate", 1, 128), ri(A.audioChannels) || $i(A.audioChannels, "config.audioChannels", [1, 2, 3, 4, 5]), ri(A.videoGop) || xr(A.videoGop, "config.videoGop"), ri(A.videoCodecProfile) || $i(A.videoCodecProfile, "config.videoCodecProfile", [66, 77, 100]), ri(A.userCount) || xr(A.userCount, "config.userCount", 0, 17), ri(A.backgroundColor) || xr(A.backgroundColor, "config.backgroundColor", 0, 16777215), ri(A.userConfigExtraInfo) || ms(A.userConfigExtraInfo, "config.userConfigExtraInfo", 0, 4096, !1), A.transcodingUsers && !ri(A.transcodingUsers) && (cd(A.transcodingUsers, "config.transcodingUsers"), A.transcodingUsers.forEach((R, P) => {
            _T(R.uid), ri(R.x) || xr(R.x, "transcodingUser[".concat(P, "].x"), 0, 1e4), ri(R.y) || xr(R.y, "transcodingUser[".concat(P, "].y"), 0, 1e4), ri(R.width) || xr(R.width, "transcodingUser[".concat(P, "].width"), 0, 1e4), ri(R.height) || xr(R.height, "transcodingUser[".concat(P, "].height"), 0, 1e4), ri(R.zOrder) || xr(R.zOrder - 1, "transcodingUser[".concat(P, "].zOrder"), 0, 100), ri(R.alpha) || xr(R.alpha, "transcodingUser[".concat(P, "].alpha"), 0, 1, !1);
          })), ri(A.watermark) || mI(A.watermark, "watermark"), ri(A.backgroundImage) || mI(A.backgroundImage, "backgroundImage"), A.images && !ri(A.images) && (cd(A.images, "config.images"), A.images.forEach((R, P) => {
            mI(R, "images[".concat(P, "]"));
          }));
        }(i);
        const o = [];
        i.images && o.push(...i.images.map((A) => Ra(Ra(Ra({}, gI), A), {}, { zOrder: 255 }))), i.backgroundImage && (o.push(Ra(Ra(Ra({}, gI), i.backgroundImage), {}, { zOrder: 0 })), delete i.backgroundImage), i.watermark && (o.push(Ra(Ra(Ra({}, gI), i.watermark), {}, { zOrder: 255 })), delete i.watermark), i.images = o, i.transcodingUsers && (i.userConfigs = i.transcodingUsers.map((A) => Ra({}, A)), i.userCount = i.transcodingUsers.length, delete i.transcodingUsers);
        const f = (i.userConfigs || []).map((A) => typeof A.uid == "number" ? cn.resolve(A.uid) : R6(A.uid, this.spec, this.cancelToken.token, this.httpRetryConfig));
        if ((await cn.all(f)).forEach((A, R) => {
          i.userConfigs && i.userConfigs[R] && (i.userConfigs[R].uid = A);
        }), this.transcodingConfig = i, this.connection) try {
          var T;
          const A = await this.connection.request("request", { clientRequest: { command: "UpdateTranscoding", transcodingConfig: this.transcodingConfig } }, !1, { command: "UpdateTranscoding", workerType: 1, requestByUser: !0, tid: Array.from(nd(T = this.streamingTasks).call(T)).map((R) => R.taskId).join("#") });
          Ee.debug("[".concat(this.spec.clientId, "] update live transcoding config success, code: ").concat(A.code, ", config:"), JSON.stringify(this.transcodingConfig));
        } catch (A) {
          if (!A.data || !A.data.retry) throw A;
          A.data.changeAddress && this.connection.tryNextAddress(), this.streamingTasks.forEach((R) => {
            Ee.warning("[".concat(this.spec.clientId, "] live streaming receive error"), A.toString(), "try to republish", R.url), this.startLiveStreamingTask(R.url, R.mode, A).then(() => {
              Ee.debug("[".concat(this.spec.clientId, "] live streaming republish ").concat(R.url, " success"));
            }).catch((P) => {
              Ee.error("[".concat(this.spec.clientId, "] live streaming republish failed"), R.url, P.toString()), this.onLiveStreamError && this.onLiveStreamError(R.url, P);
            });
          });
        }
      }
      async startLiveStreamingTask(n, i, o) {
        if (!this.transcodingConfig && i === fd.TRANSCODE) throw new jt(Je.INVALID_OPERATION, "[LiveStreaming] no transcoding config found, can not start transcoding streaming task");
        const f = { command: "PublishStream", ts: Date.now(), url: n, uid: this.spec.uid.toString(), autoDestroyTime: 100, acceptImageTimeout: !0 };
        Ee.debug("[".concat(this.spec.clientId, "] start live streaming ").concat(n, ", mode: ").concat(i));
        const T = await this.taskMutex.lock();
        if (!this.connection && o) return void T();
        if (this.streamingTasks.get(n) && !o) return T(), new jt(Je.LIVE_STREAMING_TASK_CONFLICT).throw();
        try {
          this.connection || (this.connection = await this.connect(i));
        } catch (R) {
          throw T(), R;
        }
        switch (i) {
          case fd.TRANSCODE:
            f.transcodingConfig = Ra({}, this.transcodingConfig);
        }
        this.uapResponse && this.uapResponse.vid && (f.vid = this.uapResponse.vid), this.isStartingStreamingTask = !0;
        const A = this.lastTaskId++;
        try {
          const R = new cn((L, z) => {
            Es(this.retryTimeout).then(() => {
              if (o) return z(o);
              const Y = this.statusError.get(n);
              return Y ? (this.statusError.delete(n), z(Y)) : void 0;
            });
          }), P = await cn.race([this.connection.request("request", { clientRequest: f }, !0, { url: n, command: "PublishStream", workerType: i === fd.TRANSCODE ? 1 : 2, requestByUser: !o, tid: A.toString() }), R]);
          this.isStartingStreamingTask = !1, Ee.debug("[".concat(this.spec.clientId, "] live streaming started, code: ").concat(P.code)), this.streamingTasks.set(n, { clientRequest: f, mode: i, url: n, taskId: A }), T();
        } catch (R) {
          if (T(), this.isStartingStreamingTask = !1, !R.data || !R.data.retry || o) throw R;
          return R.data.changeAddress ? (this.connection.tryNextAddress(), await this.startLiveStreamingTask(n, i, R)) : await this.startLiveStreamingTask(n, i, R);
        }
      }
      stopLiveStreamingTask(n) {
        return new cn((i, o) => {
          const f = this.streamingTasks.get(n);
          if (!f || !this.connection) return new jt(Je.UNEXPECTED_ERROR, "can not find streaming task to stop").throw();
          const T = f.mode;
          f.abortTask = () => {
            Ee.debug("[".concat(this.spec.clientId, "] stop live streaming success(worker exception)")), this.streamingTasks.delete(n), i();
          }, this.connection.request("request", { clientRequest: { command: "UnpublishStream", url: f.url } }, !1, { url: n, command: "UnPublishStream", workerType: T === fd.TRANSCODE ? 1 : 2, requestByUser: !0, tid: (this.lastTaskId++).toString() }).then((A) => {
            Ee.debug("[".concat(this.spec.clientId, "] stop live streaming success, code: ").concat(A.code)), this.streamingTasks.delete(n), this.streamingTasks.size === 0 && (this.connection && this.connection.close(), this.connection = void 0), i();
          }).catch(o);
        });
      }
      resetAllTask() {
        var n;
        const i = Array.from(nd(n = this.streamingTasks).call(n));
        this.terminate();
        for (const o of i) this.startLiveStreamingTask(o.url, o.mode).catch((f) => {
          this.onLiveStreamError && this.onLiveStreamError(o.url, f);
        });
      }
      terminate() {
        this.cancelToken && this.cancelToken.cancel(), this.streamingTasks = /* @__PURE__ */ new Map(), this.isStartingStreamingTask = !1, this.statusError = /* @__PURE__ */ new Map(), this.cancelToken = fa.CancelToken.source(), this.uapResponse = void 0, this.connection && this.connection.close(), this.connection = void 0;
      }
      async connect(n) {
        if (this.connection) throw new jt(Je.UNEXPECTED_ERROR, "live streaming connection has already connected");
        const i = await Ss(this, EI.REQUEST_WORKER_MANAGER_LIST, n);
        return this.uapResponse = i, this.connection = new dce(i.workerToken, this.spec, this.wsRetryConfig, n), this.connection.on(rl.WARNING, (o, f) => this.onLiveStreamWarning && this.onLiveStreamWarning(f, o)), this.connection.on(rl.PUBLISH_STREAM_STATUS, (o) => this.handlePublishStreamServer(o)), this.connection.on(rl.REQUEST_NEW_ADDRESS, (o, f) => {
          if (!this.connection) return f(new jt(Je.UNEXPECTED_ERROR, "can not get new live streaming address list"));
          Ss(this, EI.REQUEST_WORKER_MANAGER_LIST, n).then((T) => {
            this.uapResponse = T, o(T.addressList);
          }).catch(f);
        }), await this.connection.init(i.addressList), this.connection;
      }
      handlePublishStreamServer(n) {
        const i = n.serverStatus && n.serverStatus.url || "empty_url", o = this.streamingTasks.get(i), f = n.reason;
        switch (n.code) {
          case Wi.PUBLISH_STREAM_STATUS_ERROR_PUBLISH_BROKEN:
          case Wi.PUBLISH_STREAM_STATUS_ERROR_RTMP_CONNECT:
          case Wi.PUBLISH_STREAM_STATUS_ERROR_RTMP_HANDSHAKE:
          case Wi.PUBLISH_STREAM_STATUS_ERROR_RTMP_PUBLISH: {
            const A = new jt(Je.LIVE_STREAMING_CDN_ERROR, "", { code: n.code });
            if (o) return Ee.error(A.toString()), this.onLiveStreamError && this.onLiveStreamError(i, A);
            if (!this.isStartingStreamingTask) return;
            this.statusError.set(i, A);
          }
          case Wi.LIVE_STREAM_RESPONSE_FAILED_LOAD_IMAGE: {
            const A = new jt(Je.LIVE_STREAMING_WARN_FAILED_LOAD_IMAGE, f);
            return this.onLiveStreamWarning && this.onLiveStreamWarning(i, A);
          }
          case Wi.LIVE_STREAM_RESPONSE_WORKER_LOST:
          case Wi.LIVE_STREAM_RESPONSE_WORKER_QUIT: {
            var T;
            if (!this.connection) return;
            this.connection.tryNextAddress();
            const A = Array.from(nd(T = this.streamingTasks).call(T));
            for (const R of A) R.abortTask ? R.abortTask() : (Ee.warning("[".concat(this.spec.clientId, "] publish stream status code"), n.code, "try to republish", R.url), this.startLiveStreamingTask(R.url, R.mode, new jt(Je.LIVE_STREAMING_INTERNAL_SERVER_ERROR, "", { code: n.code })).then(() => {
              Ee.debug("[".concat(this.spec.clientId, "] republish live stream success"), R.url);
            }).catch((P) => {
              Ee.error(P.toString()), this.onLiveStreamError && this.onLiveStreamError(R.url, P);
            }));
            return;
          }
        }
      }
      hasUrl(n) {
        return this.streamingTasks.has(n);
      }
    }
    const fce = { name: "LiveStreaming", create: function(e) {
      return new lce(e.joinInfo, e.websocketRetryConfig || zi, e.httpRetryConfig || zi);
    } };
    function hce(e) {
      let n = u9();
      return function(i, o) {
        let f = i.appId;
        f !== void 0 && (Rr(o, 10), wu(o, f));
        let T = i.cid;
        T !== void 0 && (Rr(o, 16), Rr(o, T));
        let A = i.cname;
        A !== void 0 && (Rr(o, 26), wu(o, A));
        let R = i.deviceId;
        R !== void 0 && (Rr(o, 34), wu(o, R));
        let P = i.elapse;
        P !== void 0 && (Rr(o, 40), ml(o, P));
        let L = i.fileSize;
        L !== void 0 && (Rr(o, 48), ml(o, jp(L)));
        let z = i.height;
        z !== void 0 && (Rr(o, 56), ml(o, jp(z)));
        let Y = i.jpg;
        Y !== void 0 && (Rr(o, 66), Rr(o, Y.length), function(Ea, qt) {
          let sn = Up(Ea, qt.length);
          Ea.bytes.set(qt, sn);
        }(o, Y));
        let te = i.networkType;
        te !== void 0 && (Rr(o, 72), ml(o, jp(te)));
        let oe = i.osType;
        oe !== void 0 && (Rr(o, 80), ml(o, jp(oe)));
        let He = i.requestId;
        He !== void 0 && (Rr(o, 90), wu(o, He));
        let Re = i.sdkVersion;
        Re !== void 0 && (Rr(o, 98), wu(o, Re));
        let De = i.sequence;
        De !== void 0 && (Rr(o, 104), ml(o, jp(De)));
        let Xe = i.sid;
        Xe !== void 0 && (Rr(o, 114), wu(o, Xe));
        let We = i.timestamp;
        We !== void 0 && (Rr(o, 120), ml(o, We));
        let mt = i.uid;
        mt !== void 0 && (Rr(o, 128), Rr(o, mt));
        let Pt = i.vid;
        Pt !== void 0 && (Rr(o, 136), Rr(o, Pt));
        let xt = i.width;
        xt !== void 0 && (Rr(o, 144), ml(o, jp(xt)));
        let Nt = i.service;
        Nt !== void 0 && (Rr(o, 152), Rr(o, Nt));
        let Vt = i.callbackData;
        Vt !== void 0 && (Rr(o, 162), wu(o, Vt));
        let nn = i.jpgEncryption;
        nn !== void 0 && (Rr(o, 168), Rr(o, nn));
        let fn = i.requestType;
        fn !== void 0 && (Rr(o, 176), Rr(o, fn));
        let hn = i.scorePorn;
        hn !== void 0 && (Rr(o, 185), TR(o, hn));
        let ir = i.scoreSexy;
        ir !== void 0 && (Rr(o, 193), TR(o, ir));
        let sr = i.scoreNeutral;
        sr !== void 0 && (Rr(o, 201), TR(o, sr));
        let Gr = i.scene;
        Gr !== void 0 && (Rr(o, 208), Rr(o, Gr));
        let Ai = i.ossFilePrefix;
        Ai !== void 0 && (Rr(o, 218), wu(o, Ai));
        let fi = i.serviceVendor;
        if (fi !== void 0) for (let Ea of fi) {
          Rr(o, 226);
          let qt = u9();
          mce(Ea, qt), Rr(o, qt.limit), Tce(o, qt), vce(qt);
        }
      }(e, n), function(i) {
        let o = i.bytes, f = i.limit;
        return o.length === f ? o : o.subarray(0, f);
      }(n);
    }
    function pce(e) {
      return function(i) {
        let o = {};
        e: for (; !d9(i); ) {
          let f = _u(i);
          switch (f >>> 3) {
            case 0:
              break e;
            case 1:
              o.code = _u(i);
              break;
            case 2:
              o.msg = l9(i, _u(i));
              break;
            case 3: {
              let T = Ece(i);
              o.data = gce(i), i.limit = T;
              break;
            }
            default:
              o9(i, 7 & f);
          }
        }
        return o;
      }({ bytes: n = e, offset: 0, limit: n.length });
      var n;
    }
    function gce(e) {
      let n = {};
      e: for (; !d9(e); ) {
        let i = _u(e);
        switch (i >>> 3) {
          case 0:
            break e;
          case 1:
            n.requestId = l9(e, _u(e));
            break;
          case 2:
            n.requestType = _u(e) >>> 0;
            break;
          case 3:
            n.scorePorn = vR(e);
            break;
          case 4:
            n.scoreSexy = vR(e);
            break;
          case 5:
            n.scoreNeutral = vR(e);
            break;
          case 6:
            n.requestScene = _u(e) >>> 0;
            break;
          case 7:
            n.scene = _u(e) >>> 0;
            break;
          default:
            o9(e, 7 & i);
        }
      }
      return n;
    }
    function mce(e, n) {
      let i = e.service;
      i !== void 0 && (Rr(n, 8), Rr(n, i));
      let o = e.vendor;
      o !== void 0 && (Rr(n, 16), Rr(n, o));
      let f = e.token;
      f !== void 0 && (Rr(n, 26), wu(n, f));
      let T = e.callbackUrl;
      T !== void 0 && (Rr(n, 34), wu(n, T));
    }
    function Ece(e) {
      let n = _u(e), i = e.limit;
      return e.limit = e.offset + n, i;
    }
    function o9(e, n) {
      switch (n) {
        case 0:
          for (; 128 & f9(e); ) ;
          break;
        case 2:
          ER(e, _u(e));
          break;
        case 5:
          ER(e, 4);
          break;
        case 1:
          ER(e, 8);
          break;
        default:
          throw new Error("Unimplemented type: " + n);
      }
    }
    let yce = new Float32Array(1);
    new Uint8Array(yce.buffer);
    let mR = new Float64Array(1), Na = new Uint8Array(mR.buffer);
    function jp(e) {
      return { low: e |= 0, high: e >> 31, unsigned: e >= 0 };
    }
    let c9 = [];
    function u9() {
      const e = c9.pop();
      return e ? (e.offset = e.limit = 0, e) : { bytes: new Uint8Array(64), offset: 0, limit: 0 };
    }
    function vce(e) {
      c9.push(e);
    }
    function ER(e, n) {
      if (e.offset + n > e.limit) throw new Error("Skip past limit");
      e.offset += n;
    }
    function d9(e) {
      return e.offset >= e.limit;
    }
    function Up(e, n) {
      let i = e.bytes, o = e.offset, f = e.limit, T = o + n;
      if (T > i.length) {
        let A = new Uint8Array(2 * T);
        A.set(i), e.bytes = A;
      }
      return e.offset = T, T > f && (e.limit = T), o;
    }
    function yR(e, n) {
      let i = e.offset;
      if (i + n > e.limit) throw new Error("Read past limit");
      return e.offset += n, i;
    }
    function l9(e, n) {
      let i = yR(e, n), o = String.fromCharCode, f = e.bytes, T = "�", A = "";
      for (let R = 0; R < n; R++) {
        let P, L, z, Y, te = f[R + i];
        128 & te ? (224 & te) == 192 ? R + 1 >= n ? A += T : (P = f[R + i + 1], (192 & P) != 128 ? A += T : (Y = (31 & te) << 6 | 63 & P, Y < 128 ? A += T : (A += o(Y), R++))) : (240 & te) == 224 ? R + 2 >= n ? A += T : (P = f[R + i + 1], L = f[R + i + 2], (49344 & (P | L << 8)) != 32896 ? A += T : (Y = (15 & te) << 12 | (63 & P) << 6 | 63 & L, Y < 2048 || Y >= 55296 && Y <= 57343 ? A += T : (A += o(Y), R += 2))) : (248 & te) == 240 ? R + 3 >= n ? A += T : (P = f[R + i + 1], L = f[R + i + 2], z = f[R + i + 3], (12632256 & (P | L << 8 | z << 16)) != 8421504 ? A += T : (Y = (7 & te) << 18 | (63 & P) << 12 | (63 & L) << 6 | 63 & z, Y < 65536 || Y > 1114111 ? A += T : (Y -= 65536, A += o(55296 + (Y >> 10), 56320 + (1023 & Y)), R += 3))) : A += T : A += o(te);
      }
      return A;
    }
    function wu(e, n) {
      let i = n.length, o = 0;
      for (let A = 0; A < i; A++) {
        let R = n.charCodeAt(A);
        R >= 55296 && R <= 56319 && A + 1 < i && (R = (R << 10) + n.charCodeAt(++A) - 56613888), o += R < 128 ? 1 : R < 2048 ? 2 : R < 65536 ? 3 : 4;
      }
      Rr(e, o);
      let f = Up(e, o), T = e.bytes;
      for (let A = 0; A < i; A++) {
        let R = n.charCodeAt(A);
        R >= 55296 && R <= 56319 && A + 1 < i && (R = (R << 10) + n.charCodeAt(++A) - 56613888), R < 128 ? T[f++] = R : (R < 2048 ? T[f++] = R >> 6 & 31 | 192 : (R < 65536 ? T[f++] = R >> 12 & 15 | 224 : (T[f++] = R >> 18 & 7 | 240, T[f++] = R >> 12 & 63 | 128), T[f++] = R >> 6 & 63 | 128), T[f++] = 63 & R | 128);
      }
    }
    function Tce(e, n) {
      let i = Up(e, n.limit), o = e.bytes, f = n.bytes;
      for (let T = 0, A = n.limit; T < A; T++) o[T + i] = f[T];
    }
    function f9(e) {
      return e.bytes[yR(e, 1)];
    }
    function h9(e, n) {
      let i = Up(e, 1);
      e.bytes[i] = n;
    }
    function vR(e) {
      let n = yR(e, 8), i = e.bytes;
      return Na[0] = i[n++], Na[1] = i[n++], Na[2] = i[n++], Na[3] = i[n++], Na[4] = i[n++], Na[5] = i[n++], Na[6] = i[n++], Na[7] = i[n++], mR[0];
    }
    function TR(e, n) {
      let i = Up(e, 8), o = e.bytes;
      mR[0] = n, o[i++] = Na[0], o[i++] = Na[1], o[i++] = Na[2], o[i++] = Na[3], o[i++] = Na[4], o[i++] = Na[5], o[i++] = Na[6], o[i++] = Na[7];
    }
    function _u(e) {
      let n, i = 0, o = 0;
      do
        n = f9(e), i < 32 && (o |= (127 & n) << i), i += 7;
      while (128 & n);
      return o;
    }
    function Rr(e, n) {
      for (n >>>= 0; n >= 128; ) h9(e, 127 & n | 128), n >>>= 7;
      h9(e, n);
    }
    function ml(e, n) {
      let i = n.low >>> 0, o = (n.low >>> 28 | n.high << 4) >>> 0, f = n.high >>> 24, T = f === 0 ? o === 0 ? i < 16384 ? i < 128 ? 1 : 2 : i < 1 << 21 ? 3 : 4 : o < 16384 ? o < 128 ? 5 : 6 : o < 1 << 21 ? 7 : 8 : f < 128 ? 9 : 10, A = Up(e, T), R = e.bytes;
      switch (T) {
        case 10:
          R[A + 9] = f >>> 7 & 1;
        case 9:
          R[A + 8] = T !== 9 ? 128 | f : 127 & f;
        case 8:
          R[A + 7] = T !== 8 ? o >>> 21 | 128 : o >>> 21 & 127;
        case 7:
          R[A + 6] = T !== 7 ? o >>> 14 | 128 : o >>> 14 & 127;
        case 6:
          R[A + 5] = T !== 6 ? o >>> 7 | 128 : o >>> 7 & 127;
        case 5:
          R[A + 4] = T !== 5 ? 128 | o : 127 & o;
        case 4:
          R[A + 3] = T !== 4 ? i >>> 21 | 128 : i >>> 21 & 127;
        case 3:
          R[A + 2] = T !== 3 ? i >>> 14 | 128 : i >>> 14 & 127;
        case 2:
          R[A + 1] = T !== 2 ? i >>> 7 | 128 : i >>> 7 & 127;
        case 1:
          R[A] = T !== 1 ? 128 | i : 127 & i;
      }
    }
    function p9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    const bce = /* @__PURE__ */ new Map([["moderation", 1], ["supervise", 2]]);
    class Ace extends ii {
      get connectionState() {
        return this._connectionState;
      }
      set connectionState(n) {
        if (this._connectionState === n) return;
        const i = this._connectionState;
        this._connectionState = n, this.emit(ds.CONNECTION_STATE_CHANGE, i, n);
      }
      get inspectType() {
        return this._inspectType;
      }
      set inspectType(n) {
        var i;
        this._inspectMode = _c(i = n.map((o) => bce.get(o) || 0)).call(i, (o, f) => o + f), this._inspectType = n;
      }
      get quality() {
        return this._quality;
      }
      set quality(n) {
        this._quality = n > 1 ? 1 : n < 0.1 ? 0.1 : n, this.qualityTimer && (window.clearTimeout(this.qualityTimer), this.qualityTimer = null), this._quality >= 1 || (this.qualityTimer = window.setTimeout(() => {
          this.quality = this._quality / this.qualityRatio;
        }, 6e4));
      }
      constructor(n) {
        super(), Ve(this, "name", "AgoraRTCVideoContentInspect"), Ve(this, "_connectionState", oc.CONNECTING), Ve(this, "_innerConnectionState", void 0), Ve(this, "sequence", 0), Ve(this, "inspectStartTime", void 0), Ve(this, "workerManagerConnection", void 0), Ve(this, "workerConnection", void 0), Ve(this, "workerMessageLengthLimit", void 0), Ve(this, "inspectIntervalMinimum", void 0), Ve(this, "qualityRatio", void 0), Ve(this, "_connectInfo", void 0), Ve(this, "_cancelTokenSource", fa.CancelToken.source()), Ve(this, "_retryConfig", void 0), Ve(this, "wmSequence", 0), Ve(this, "inspectInterval", void 0), Ve(this, "inspectTimer", null), Ve(this, "ossFilePrefix", void 0), Ve(this, "extraInfo", void 0), Ve(this, "_inspectType", void 0), Ve(this, "_inspectMode", void 0), Ve(this, "_quality", 1), Ve(this, "qualityTimer", null), Ve(this, "_inspectId", void 0), Ve(this, "_needWorkUrlOnly", !1), Ve(this, "inspectImage", () => {
          if (this.connectionState !== oc.CONNECTED) throw new jt(Je.OPERATION_ABORTED, "content inspect service connection status is ".concat(this.connectionState));
          this.inspectTimer && (window.clearInterval(this.inspectTimer), this.inspectTimer = null), this.inspectTimer = window.setInterval(() => {
            this.connectionState === oc.CONNECTED ? this.requestToInspectImage() : Ee.debug("[".concat(this._inspectId, "] Inspect State is not connected , "), this.connectionState);
          }, this.inspectInterval < this.inspectIntervalMinimum ? this.inspectIntervalMinimum : this.inspectInterval), this.requestToInspectImage();
        }), this._inspectId = zr(5, "inspect-"), this.workerMessageLengthLimit = ft("VIDEO_INSPECT_WORKER_MESSAGE_LENGTH_LIMIT"), this.inspectIntervalMinimum = ft("VIDEO_INSPECT_INTERVAL_MINIMUM"), this.qualityRatio = ft("VIDEO_INSPECT_QUALITY_RATIO"), this.inspectInterval = n.interval, this.ossFilePrefix = n.ossFilePrefix, this.extraInfo = n.extraInfo, this.inspectType = n.inspectType, this.inspectStartTime = Number(Date.now()), this.workerManagerConnection = new HE("worker-manager-" + this._inspectId, zi), this.on(ds.STATE_CHANGE, (i, o) => {
          this._innerConnectionState = i, Ee.debug("[".concat(this._inspectId, "] Inspect operation :").concat(cc[i], " ").concat(o || ""));
        }), this.handleWorkerManagerEvents(), this.workerConnection = new HE("worker-" + this._inspectId, zi), this.handleWorkerEvents();
      }
      async init(n, i) {
        this.emit(ds.STATE_CHANGE, cc.CONNECT_AP), this._connectInfo = n;
        const o = this._cancelTokenSource.token;
        return this._retryConfig = i, new cn((f, T) => {
          this.on(ds.CONNECTION_STATE_CHANGE, (A, R) => {
            R === oc.CONNECTED && f();
          }), this.requestAP(n, o, i).then((A) => {
            this.connectWorkerManager(A);
          }).catch((A) => {
            T(A);
          });
        });
      }
      async requestAP(n, i, o) {
        const f = ft("WEBCS_DOMAIN").map((R) => "https://".concat(R, "/api/v1")), T = await function(R, P, L, z) {
          let { appId: Y, areaCode: te, cname: oe, sid: He, token: Re, uid: De } = P;
          Ip++;
          const Xe = "image_moderation_api", We = { service_name: Xe, json_body: JSON.stringify({ appId: Y, areaCode: te, cname: oe, command: "allocateEdge", requestId: Ip, seq: Ip, sid: He, token: Re, ts: Date.now(), uid: De + "" }) };
          let mt, Pt, xt = R[0];
          return jc(async () => {
            mt = Date.now();
            const Nt = await Hc(xt, { data: We, cancelToken: L, headers: { "X-Packet-Service-Type": "0", "X-Packet-URI": "61" }, params: { action: "wrtc_gateway" } });
            if (Pt = Date.now() - mt, Nt.code !== 0) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "image inspect ap error, code" + Nt.code, { retry: !0, responseTime: Pt });
              throw Ee.error(hn.toString()), hn;
            }
            const Vt = JSON.parse(Nt.json_body);
            if (Vt.code !== 200) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "image inspect ap error, code: ".concat(Vt.code, ", reason: ").concat(Vt.reason), { code: Vt.code, responseTime: Pt });
              throw Ee.error(hn.toString()), hn;
            }
            if (!Vt.servers || !Array.isArray(Vt.servers) || Vt.servers.length === 0) {
              const hn = new jt(Je.UNEXPECTED_RESPONSE, "image inspect ap empty server", { code: Vt.code, responseTime: Pt });
              throw Ee.error(hn.toString()), hn;
            }
            const nn = ft("VIDEO_INSPECT_WORKER_MANAGER_HOST"), fn = ft("VIDEO_INSPECT_WORKER_MANAGER_PORT");
            return { addressList: Vt.servers.map((hn) => {
              let { address: ir, wss: sr } = hn;
              if (ir && sr) return "wss://".concat(ir.replace(/\./g, "-"), ".").concat(nn, ":").concat(fn || sr);
            }).filter((hn) => !!hn), workerToken: Vt.workerToken, vid: Vt.vid, responseTime: Pt };
          }, (Nt, Vt) => (Cn.apworkerEvent(He, { success: !0, sc: 200, serviceName: Xe, responseDetail: JSON.stringify(Nt.addressList), firstSuccess: Vt === 0, responseTime: Pt, serverIp: R[Vt % R.length] }), !1), (Nt, Vt) => (Cn.apworkerEvent(He, { success: !1, sc: Nt.data && Nt.data.code || 200, serviceName: Xe, responseTime: Pt, serverIp: R[Vt % R.length] }), !!(Nt.code !== Je.OPERATION_ABORTED && Nt.code !== Je.UNEXPECTED_RESPONSE || Nt.data && Nt.data.retry) && (xt = R[(Vt + 1) % R.length], !0)), z);
        }(f, n, i, o);
        this.emit(ds.STATE_CHANGE, cc.AP_CONNECTED);
        const { addressList: A } = T;
        return this.wmSequence++, A;
      }
      async connectWorkerManager(n) {
        let i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
        this._needWorkUrlOnly = i, this.emit(ds.STATE_CHANGE, cc.CONNECT_WORKER_MANAGER), await this.workerManagerConnection.init(n, 1e4);
      }
      async connectWorker(n) {
        await this.workerConnection.init([n]);
      }
      handleWorkerManagerEvents() {
        this.workerManagerConnection.on(Fn.CONNECTED, async () => {
          this.emit(ds.STATE_CHANGE, cc.WORKER_MANAGER_CONNECTED, this.workerManagerConnection.url), this.workerManagerConnection.sendMessage({ appId: this._connectInfo.appId, cname: this._connectInfo.cname, uid: this._connectInfo.uid + "", sdkVersion: "4.23.0", sid: this._connectInfo.sid, seq: this.wmSequence, ts: Number(Date.now()), requestId: Math.floor(1e12 * Math.random()), allocate: !0, clientRequest: { command: "join" } }, !0);
        }), this.workerManagerConnection.on(Fn.CLOSED, () => {
          this._innerConnectionState < cc.GET_WORKER_MANAGER_RESPONSE && Ee.debug("[".concat(this._inspectId, "] Inspect worker manager is closed before connecting worker"));
        }), this.workerManagerConnection.on(Fn.FAILED, () => {
          this._innerConnectionState < cc.GET_WORKER_MANAGER_RESPONSE && Ee.debug("[".concat(this._inspectId, "] Connecting inspect worker manager is failed before connecting worker"));
        }), this.workerManagerConnection.on(Fn.RECONNECTING, () => {
          this._innerConnectionState < cc.GET_WORKER_MANAGER_RESPONSE && Ee.debug("[".concat(this._inspectId, "] Inspect worker manager is reconnecting before connecting worker"));
        }), this.workerManagerConnection.on(Fn.ON_MESSAGE, async (n) => {
          this.emit(ds.STATE_CHANGE, cc.GET_WORKER_MANAGER_RESPONSE);
          const i = this.workerManagerConnection.url;
          this.workerManagerConnection.close();
          const o = JSON.parse(n.data);
          if (o.code !== 200) throw Ee.error("[".concat(this._inspectId, "] Unexpected code ").concat(o.code, " from worker manager")), new jt(Je.UNEXPECTED_RESPONSE, "response code of worker is unexpected", o);
          if (!(o.serverResponse && o.serverResponse.portWss && i)) throw Ee.error("[".concat(this._inspectId, "] Unexpected content from worker manager : ").concat(JSON.stringify(o))), new jt(Je.UNEXPECTED_RESPONSE, "response content of worker is unexpected", o);
          {
            const f = ft("VIDEO_INSPECT_WORKER_PORT") || o.serverResponse.portWss, T = i.replace(/:\d+\/?$/, ":".concat(f));
            this.emit(ds.STATE_CHANGE, cc.CONNECT_WORKER, T), this._needWorkUrlOnly ? this.emit(ds.REQUEST_NEW_WORKER_URL, T) : await this.connectWorker(T);
          }
        }), this.workerManagerConnection.on(Fn.WILL_RECONNECT, (n, i, o) => {
          o(n);
        }), this.workerManagerConnection.on(Fn.REQUEST_NEW_URLS, (n, i) => {
          this.requestAP(this._connectInfo, this._cancelTokenSource.token, this._retryConfig).then(n).catch(i);
        });
      }
      handleWorkerEvents() {
        this.workerConnection.on(Fn.CONNECTED, async () => {
          this.emit(ds.STATE_CHANGE, cc.WORKER_CONNECTED, this.workerConnection.url), this.connectionState = oc.CONNECTED;
        }), this.workerConnection.on(Fn.ON_MESSAGE, async (n) => {
          if (n.data instanceof ArrayBuffer) {
            const o = pce(new Uint8Array(n.data));
            if (ft("SHOW_VIDEO_INSPECT_WORKER_MESSAGE") && Ee.debug("[".concat(this._inspectId, "] Response message for worker of inspect content "), JSON.stringify(o)), o.code === 200) {
              if (Array.isArray(this.inspectType) && this.inspectType.length === 1 && this.inspectType[0] === "supervise") return void this.emit(ds.INSPECT_RESULT, void 0, void 0);
              if (o.data && o.data.scorePorn && o.data.scoreSexy && o.data.scoreNeutral) {
                var i;
                const f = { porn: o.data.scorePorn, sexy: o.data.scoreSexy, neutral: o.data.scoreNeutral }, T = _c(i = Object.keys(f)).call(i, (R, P) => f[R] > f[P] ? R : P, "porn"), A = Object.keys(f).find((R) => R === T);
                this.emit(ds.INSPECT_RESULT, A);
              } else this.emit(ds.INSPECT_RESULT, void 0, new jt(Je.UNEXPECTED_RESPONSE, o.code + "", "There is an unexpected data on message"));
            } else this.emit(ds.INSPECT_RESULT, void 0, new jt(Je.UNEXPECTED_RESPONSE, o.code + "", o.msg));
          } else Ee.error("[".concat(this._inspectId, "] Unexpected message type from worker")), this.emit(ds.INSPECT_RESULT, void 0, new jt(Je.UNEXPECTED_RESPONSE, "invalid worker message type"));
        }), this.workerConnection.on(Fn.CLOSED, () => {
          this.connectionState = oc.CLOSED;
        }), this.workerConnection.on(Fn.FAILED, () => {
          this.connectionState = oc.CLOSED;
        }), this.workerConnection.on(Fn.RECONNECTING, () => {
          this.connectionState = this.connectionState === oc.CONNECTED ? oc.RECONNECTING : oc.CONNECTING;
        }), this.workerConnection.on(Fn.WILL_RECONNECT, (n, i, o) => {
          n === "recover" && o(n), o("tryNext");
        }), this.workerConnection.on(Fn.REQUEST_NEW_URLS, (n, i) => {
          this.workerManagerConnection.close(), this.once(ds.REQUEST_NEW_WORKER_URL, (o) => {
            n([o]);
          }), this.requestAP(this._connectInfo, this._cancelTokenSource.token, this._retryConfig).then((o) => {
            this.connectWorkerManager(o, !0);
          }).catch((o) => {
            i(o);
          });
        });
      }
      async requestToInspectImage() {
        this.sequence++;
        const n = to(this, ds.CLIENT_LOCAL_VIDEO_TRACK), i = { appId: this._connectInfo.appId, cname: this._connectInfo.cname, cid: this._connectInfo.cid, sid: this._connectInfo.sid, uid: this._connectInfo.uid, vid: this._connectInfo.vid };
        if (n) {
          if (!n.isPlaying) return void this.emit(ds.INSPECT_RESULT, void 0, new jt(Je.INVALID_OPERATION, "Only the track being played can be inspected"));
          const o = await this.generateRequestData(n, i);
          this.workerConnection.sendMessage(o, !0, !0);
        } else this.emit(ds.INSPECT_RESULT, void 0, new jt(Je.INVALID_OPERATION, "Only the track being published can be inspected"));
      }
      async generateRequestData(n, i) {
        let { appId: o, cname: f, cid: T, vid: A, sid: R, uid: P } = i;
        const L = Date.now(), z = await n.getCurrentFrameImage("image/jpeg", this.quality), Y = await $5(z, o, f), te = this.sequence + "-" + T + "-" + P + "-" + L + "-" + zr(12, ""), oe = { appId: o, cid: T, cname: f, deviceId: "", elapse: (He = Number(L - this.inspectStartTime), { low: He |= 0, high: He >> 31, unsigned: He >= 0 }), fileSize: Y.byteLength, jpgEncryption: 2, height: z.height, width: z.width, jpg: Y, networkType: 6, osType: 7, requestId: te, sdkVersion: "4.23.0", sequence: this.sequence, sid: R, timestamp: A7(L), uid: P, vid: A, service: this._inspectMode, callbackData: this.extraInfo, ossFilePrefix: this.ossFilePrefix };
        var He;
        this.extraInfo === void 0 && delete oe.callbackData, this.ossFilePrefix === void 0 && delete oe.ossFilePrefix;
        const Re = hce(oe);
        if (Re.byteLength < this.workerMessageLengthLimit) {
          if (ft("SHOW_VIDEO_INSPECT_WORKER_MESSAGE")) {
            const De = function(Xe) {
              for (var We = 1; We < arguments.length; We++) {
                var mt = arguments[We] != null ? arguments[We] : {};
                We % 2 ? p9(Object(mt), !0).forEach(function(Pt) {
                  Ve(Xe, Pt, mt[Pt]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Xe, Object.getOwnPropertyDescriptors(mt)) : p9(Object(mt)).forEach(function(Pt) {
                  Object.defineProperty(Xe, Pt, Object.getOwnPropertyDescriptor(mt, Pt));
                });
              }
              return Xe;
            }({}, oe);
            delete De.jpg, Ee.debug("[".concat(this._inspectId, "] Request message for worker of inspect content "), JSON.stringify(De));
          }
          return Re;
        }
        {
          const De = this.quality * this.qualityRatio;
          return this.quality = De, await this.generateRequestData(n, { appId: o, cname: f, cid: T, vid: A, sid: R, uid: P });
        }
      }
      close() {
        this._cancelTokenSource.cancel(), this._cancelTokenSource = fa.CancelToken.source(), this.workerManagerConnection && this.workerManagerConnection.close(), this.workerConnection && this.workerConnection.close(), this.inspectTimer && window.clearInterval(this.inspectTimer), this.inspectTimer = null, this.connectionState = oc.CLOSED, this.emit(ds.STATE_CHANGE, cc.CLOSED);
      }
    }
    const Oce = { name: "ContentInspect", create: function(e) {
      let { config: n } = e;
      return function(i) {
        if (!i) throw new jt(Je.INVALID_PARAMS, "inspectConfig is necessary.");
        if (!i.inspectType || !Array.isArray(i.inspectType)) throw new jt(Je.INVALID_PARAMS, "inspectConfig.inspectType is necessary and is an instance of Array.");
        {
          const o = [...new Set(i.inspectType)];
          o.forEach((f) => {
            var T;
            if (!on(T = ["supervise", "moderation"]).call(T, f)) throw new jt(Je.INVALID_PARAMS, "".concat(f, " is not a valid inspect type."));
          }), i.inspectType = o;
        }
        if (i && i.extraInfo && i.extraInfo.length > 1024) throw new jt(Je.INVALID_PARAMS, "inspectConfig.extraInfo length cannot exceed 1024 bytes");
      }(n), new Ace(n);
    } };
    var g9 = h(it.Object.getOwnPropertySymbols), Cce = _r, Sce = BA.indexOf, Ice = Vv, bR = D([].indexOf), m9 = !!bR && 1 / bR([1], 1, -0) < 0;
    Cce({ target: "Array", proto: !0, forced: m9 || !Ice("indexOf") }, { indexOf: function(e) {
      var n = arguments.length > 1 ? arguments[1] : void 0;
      return m9 ? bR(this, e, n) || 0 : Sce(this, e, n);
    } });
    var Rce = Jo("Array").indexOf, Nce = m, wce = Rce, AR = Array.prototype, _ce = function(e) {
      var n = e.indexOf;
      return e === AR || Nce(AR, e) && n === AR.indexOf ? wce : n;
    }, E9 = h(_ce);
    function Pce(e, n) {
      if (e == null) return {};
      var i, o, f = function(A, R) {
        if (A == null) return {};
        var P, L, z = {}, Y = k8(A);
        for (L = 0; L < Y.length; L++) P = Y[L], E9(R).call(R, P) >= 0 || (z[P] = A[P]);
        return z;
      }(e, n);
      if (g9) {
        var T = g9(e);
        for (o = 0; o < T.length; o++) i = T[o], E9(n).call(n, i) >= 0 || Object.prototype.propertyIsEnumerable.call(e, i) && (f[i] = e[i]);
      }
      return f;
    }
    let y9 = class {
      get localCapabilities() {
        return di(this._localCapabilities);
      }
      get rtpCapabilities() {
        return di(this._rtpCapabilities);
      }
      get candidates() {
        return di(this._candidates);
      }
      get iceParameters() {
        return di(this._iceParameters);
      }
      get dtlsParameters() {
        return di(this._dtlsParameters);
      }
      constructor(e) {
        Ve(this, "sessionDesc", void 0), Ve(this, "_localCapabilities", void 0), Ve(this, "_rtpCapabilities", void 0), Ve(this, "_candidates", void 0), Ve(this, "_iceParameters", void 0), Ve(this, "_dtlsParameters", void 0), Ve(this, "setup", void 0), Ve(this, "currentMidIndex", void 0), Ve(this, "cname", "o/i14u9pJrxRKAsu"), Ve(this, "firefoxSsrcMidMap", /* @__PURE__ */ new Map()), e = di(e);
        const { remoteIceParameters: n, remoteDtlsParameters: i, candidates: o, remoteRTPCapabilities: f, localCapabilities: T, direction: A, setup: R, videoCodec: P, audioCodec: L } = e;
        let z;
        this.setup = R, z = A === ia.RECEIVE_ONLY ? Ca(`v=0
o=- 0 0 IN IP4 127.0.0.1
s=AgoraGateway
t=0 0
a=group:BUNDLE 0 1
a=msid-semantic: WMS
a=extmap-allow-mixed
m=video 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=sendonly
a=rtcp-mux
a=rtcp-rsize
a=mid:0
m=audio 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=sendonly
a=rtcp-mux
a=rtcp-rsize
a=mid:1
`) : Ca(`v=0
o=- 0 0 IN IP4 127.0.0.1
s=AgoraGateway
t=0 0
a=group:BUNDLE 0 1
a=msid-semantic: WMS
a=extmap-allow-mixed
m=video 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=recvonly
a=rtcp-mux
a=rtcp-rsize
a=mid:0
m=audio 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=recvonly
a=rtcp-mux
a=rtcp-rsize
a=mid:1
`), this._rtpCapabilities = f, this._candidates = o, this._iceParameters = n, this._dtlsParameters = i, this._localCapabilities = T;
        const Y = A === ia.RECEIVE_ONLY ? this.rtpCapabilities.send : this.rtpCapabilities.recv, te = A === ia.RECEIVE_ONLY ? this._localCapabilities.recv : this._localCapabilities.send, oe = A === ia.RECEIVE_ONLY ? f.send.videoCodecs : FE(vn.VIDEO, Y, te, P), He = A === ia.RECEIVE_ONLY ? f.send.audioCodecs : FE(vn.AUDIO, Y, te, L);
        for (const Re of z.mediaDescriptions) Re.attributes.iceUfrag = n.iceUfrag, Re.attributes.icePwd = n.icePwd, Re.attributes.fingerprints = i.fingerprints, Re.attributes.candidates = o, Re.attributes.setup = this.setup, Re.media.mediaType === "application" && (Re.attributes.sctpPort = "5000"), Re.media.mediaType === "video" && (Re.media.fmts = oe.map((De) => De.payloadType.toString(10)), Re.attributes.payloads = oe, Re.attributes.extmaps = Y.videoExtensions), Re.media.mediaType === "audio" && (Re.media.fmts = He.map((De) => De.payloadType.toString(10)), Re.attributes.payloads = He, Re.attributes.extmaps = Y.audioExtensions, Sp(Re));
        this.sessionDesc = z, this.currentMidIndex = z.mediaDescriptions.length - 1;
      }
      toString() {
        return nl(this.sessionDesc);
      }
      hasMid(e) {
        return Array.isArray(e) ? e.every((n) => this.hasMid(n)) : this.sessionDesc.mediaDescriptions.some((n) => n.attributes.mid === e);
      }
      send(e, n, i, o, f) {
        i = i.replace(/ /g, "-");
        const { ssrcs: T, ssrcGroups: A } = Rf(n, this.cname, ft("SYNC_GROUP") ? i : void 0), R = this.findPreloadMediaDesc(T);
        if (R) {
          if (ui() && this.firefoxSsrcMidMap.set(T[0].ssrcId, R.attributes.mid), f && (f.twcc || f.remb)) {
            const P = this.sessionDesc.mediaDescriptions.indexOf(R);
            return this.sessionDesc.mediaDescriptions[P] = this.mungSendMediaDesc(R, f), { mid: R.attributes.mid, needExchangeSDP: !0 };
          }
          return { mid: R.attributes.mid, needExchangeSDP: !1 };
        }
        {
          const P = this.findAvailableMediaIndex(e, T, o);
          let L;
          return P === -1 ? (L = this.createOrRecycleSendMedia(e, T, A, "sendonly", o, f), this.updateBundleMids()) : (L = di(this.sessionDesc.mediaDescriptions[P]), L.attributes.direction = "sendonly", L.attributes.ssrcs = T, L.attributes.ssrcGroups = A, this.sessionDesc.mediaDescriptions[P] = this.mungSendMediaDesc(L, f)), ui() && this.firefoxSsrcMidMap.set(T[0].ssrcId, L.attributes.mid), { needExchangeSDP: !0, mid: L.attributes.mid };
        }
      }
      stopSending(e) {
        const n = this.sessionDesc.mediaDescriptions.filter((i) => i.attributes.mid && e.indexOf(i.attributes.mid) !== -1);
        if (n.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.stopSending.");
        n.forEach((i) => {
          i.attributes.ssrcs = [];
        }), this.updateBundleMids();
      }
      receive(e, n, i) {
        const o = [];
        return e.forEach((f) => {
          const T = f._mediaStreamTrack.kind, A = this.findAvailableRecvMediaIndex(T);
          let R, P = !1;
          A === -1 ? (P = !0, R = this.createOrRecycleRecvMedia(f, [], "recvonly", n, i), this.updateBundleMids()) : (R = di(this.sessionDesc.mediaDescriptions[A]), R.attributes.direction = "recvonly"), o.push({ mid: R.attributes.mid, needCreateTransceiver: P });
        }), o;
      }
      stopReceiving(e) {
        const n = this.sessionDesc.mediaDescriptions.filter((i) => e.indexOf(i.attributes.mid) !== -1);
        if (n.length !== e.length) throw new Error("MediaDescriptions' length doesn't match mids's length when calling RemoteSDP.receive.");
        n.forEach((i) => {
          i.media.port = "0", i.attributes.direction = "inactive";
        }), this.updateBundleMids();
      }
      addRemoteCandidate(e) {
        const { foundation: n, protocol: i, address: o, port: f, type: T, relatedAddress: A, relatedPort: R, priority: P } = new RTCIceCandidate(e), L = { foundation: n ?? "", componentId: "1", transport: i ?? "", priority: P ? P + "" : "", connectionAddress: o ?? "", port: f ? f + "" : "", type: T ? T + "" : "", relAddr: A ?? "", relPort: R ? R + "" : "", extension: {} };
        this.candidates.some((z) => z.priority === L.priority && z.connectionAddress === L.connectionAddress && z.port === L.port) || (this._candidates.push(L), this.sessionDesc.mediaDescriptions.forEach((z) => {
          z.attributes.candidates = this.candidates;
        }));
      }
      clearRemoteCandidate() {
        this._candidates = [], this.sessionDesc.mediaDescriptions[0].attributes.candidates = this._candidates;
      }
      createOrRecycleRecvMedia(e, n, i, o, f) {
        const T = e._mediaStreamTrack.kind, A = this.rtpCapabilities.recv, R = FE(T, A, this.localCapabilities.send, T === vn.AUDIO ? f : o), P = T === vn.VIDEO ? A.videoExtensions : A.audioExtensions, L = "".concat(++this.currentMidIndex);
        let z = { media: { mediaType: T, port: "9", protos: ["UDP", "TLS", "RTP", "SAVPF"], fmts: R.map((te) => te.payloadType.toString(10)) }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: this.iceParameters.iceUfrag, icePwd: this.iceParameters.icePwd, unrecognized: [], candidates: [], extmaps: P, fingerprints: this.dtlsParameters.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: n, ssrcGroups: [], rtcpFeedbackWildcards: [], payloads: R, rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, direction: i, rtcpMux: !0, rtcpRsize: !0, mid: "".concat(L) } };
        z = this.mungRecvMediaDsec(z, e);
        const Y = this.findFirstClosedMedia(T);
        if (Y) {
          const te = this.sessionDesc.mediaDescriptions.indexOf(Y);
          this.sessionDesc.mediaDescriptions[te] = z;
        } else this.sessionDesc.mediaDescriptions.push(z);
        return z;
      }
      muteRemote(e) {
        const n = this.sessionDesc.mediaDescriptions.filter((i) => on(e).call(e, i.attributes.mid || ""));
        if (n.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
        n.forEach((i) => {
          i.attributes.direction = "inactive";
        });
      }
      unmuteRemote(e) {
        const n = this.sessionDesc.mediaDescriptions.filter((i) => on(e).call(e, i.attributes.mid || ""));
        if (n.length !== e.length) throw new Error("mediaDescriptions' length doesn't match mids' length when calling RemoteSDP.muteRemote.");
        n.forEach((i) => {
          i.attributes.direction = "recvonly";
        });
      }
      findAvailableMediaIndex(e, n, i) {
        return this.sessionDesc.mediaDescriptions.findIndex((o) => {
          const f = o.media.mediaType === e && o.media.port !== "0" && (o.attributes.direction === "sendonly" || o.attributes.direction === "sendrecv") && o.attributes.ssrcs.length === 0;
          if (ui()) {
            if (f) {
              const T = this.firefoxSsrcMidMap.get(n[0].ssrcId);
              return !(T || o.attributes.mid !== "0" && o.attributes.mid !== "1") || !(!T || T !== o.attributes.mid);
            }
            return !1;
          }
          return f && o.attributes.mid === i;
        });
      }
      findAvailableRecvMediaIndex(e) {
        return this.sessionDesc.mediaDescriptions.findIndex((n) => {
          const i = n.media.mediaType === e && n.media.port !== "0" && (n.attributes.direction === "recvonly" || n.attributes.direction === "sendrecv");
          return n.attributes.mid !== "0" && n.attributes.mid !== "1" && i;
        });
      }
      predictReceivingMids(e) {
        const n = [];
        for (let i = 0; i < e; i++) n.push((this.currentMidIndex + i + 1).toString(10));
        return n;
      }
      restartICE(e) {
        e = di(e), this._iceParameters = e, this.sessionDesc.mediaDescriptions.forEach((n) => {
          n.attributes.iceUfrag = e.iceUfrag, n.attributes.icePwd = e.icePwd;
        });
      }
      createOrRecycleSendMedia(e, n, i, o, f, T) {
        const A = this.rtpCapabilities.send, R = e === vn.VIDEO ? A.videoCodecs : A.audioCodecs, P = e === vn.VIDEO ? A.videoExtensions : A.audioExtensions;
        ui() && (f = "".concat(++this.currentMidIndex));
        let L = { media: { mediaType: e, port: "9", protos: ["UDP", "TLS", "RTP", "SAVPF"], fmts: R.map((Y) => Y.payloadType.toString(10)) }, connections: [{ nettype: "IN", addrtype: "IP4", address: "127.0.0.1" }], bandwidths: [], attributes: { iceUfrag: this.iceParameters.iceUfrag, icePwd: this.iceParameters.icePwd, unrecognized: [], candidates: [], extmaps: P, fingerprints: this.dtlsParameters.fingerprints, imageattr: [], msids: [], remoteCandidatesList: [], rids: [], ssrcs: n, ssrcGroups: i, rtcpFeedbackWildcards: [], payloads: R, rtcp: { port: "9", netType: "IN", addressType: "IP4", address: "0.0.0.0" }, setup: this.setup, direction: o, rtcpMux: !0, rtcpRsize: !0, mid: f } };
        L = this.mungSendMediaDesc(L, T);
        const z = this.findFirstClosedMedia(e);
        if (z) {
          const Y = this.sessionDesc.mediaDescriptions.indexOf(z);
          this.sessionDesc.mediaDescriptions[Y] = L;
        } else this.sessionDesc.mediaDescriptions.push(L);
        return L;
      }
      mungRecvMediaDsec(e, n, i) {
        const o = di(e);
        return AI(o), Cp(o, n), OI(o, n), o6(o), jT(o, i, this.localCapabilities.send), o;
      }
      mungSendMediaDesc(e, n) {
        const i = di(e);
        return jT(i, n, this.localCapabilities.recv), Sp(i), i;
      }
      updateRecvMedia(e, n) {
        const i = this.sessionDesc.mediaDescriptions.findIndex((o) => o.attributes.mid === e);
        if (i !== -1) {
          const o = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[i], n);
          this.sessionDesc.mediaDescriptions[i] = o;
        }
      }
      updateBundleMids() {
        this.sessionDesc.attributes.groups[0].identificationTag = this.sessionDesc.mediaDescriptions.filter((e) => e.media.port !== "0").map((e) => e.attributes.mid);
      }
      findPreloadMediaDesc(e) {
        return this.sessionDesc.mediaDescriptions.find((n) => {
          var i;
          return ((i = n.attributes) === null || i === void 0 || (i = i.ssrcs[0]) === null || i === void 0 ? void 0 : i.ssrcId) === e[0].ssrcId;
        });
      }
      findFirstClosedMedia(e) {
        return this.sessionDesc.mediaDescriptions.find((n) => ui() ? n.media.port === "0" && n.media.mediaType === e : n.media.port === "0");
      }
    };
    const xce = ["sdp"];
    var Xr;
    function v9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function El(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? v9(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : v9(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    let T9 = (Xr = class Vp extends F8 {
      get currentLocalDescription() {
        return this.peerConnection.currentLocalDescription;
      }
      get currentRemoteDescription() {
        return this.peerConnection.currentRemoteDescription;
      }
      get peerConnectionState() {
        return this.peerConnection.connectionState;
      }
      get iceConnectionState() {
        return this.peerConnection.iceConnectionState;
      }
      get dtlsTransportState() {
        var n, i;
        return (n = (i = this.peerConnection.getReceivers()[0]) === null || i === void 0 || (i = i.transport) === null || i === void 0 ? void 0 : i.state) !== null && n !== void 0 ? n : null;
      }
      get localCodecs() {
        return [];
      }
      set isInRestartIce(n) {
        this._isInRestartIce = n;
      }
      get isInRestartIce() {
        return this._isInRestartIce;
      }
      constructor(n, i, o) {
        super(n, i), Ve(this, "direction", void 0), Ve(this, "name", void 0), Ve(this, "store", void 0), Ve(this, "spec", void 0), Ve(this, "peerConnection", void 0), Ve(this, "initialOffer", void 0), Ve(this, "transport", void 0), Ve(this, "statsFilter", void 0), Ve(this, "localCandidateCount", 0), Ve(this, "_isInRestartIce", !1), Ve(this, "mutex", void 0), Ve(this, "onLocalCandidate", void 0), Ve(this, "remoteSDP", void 0), Ve(this, "pendingCandidates", []), Ve(this, "localCapabilities", void 0), Ve(this, "isReady", !1), Ve(this, "restartCnt", 0), Ve(this, "curTurnServerIndex", 0), this.store = i, this.spec = n, this.mutex = new xs("P2PConnection-mutex", i.clientId), this.peerConnection = new RTCPeerConnection(Vp.resolvePCConfiguration(n, i.p2pTransport), { optional: [{ googDscp: !0 }] }), this.direction = o ?? ia.SEND_ONLY, this.name = this.direction === ia.SEND_ONLY ? "sendP2PConnection" : "recvP2PConnection", this.statsFilter = YS(this.peerConnection, ft("STATS_UPDATE_INTERVAL"), void 0, ui() ? 1200 : void 0), this.bindPCEvents(), this.bindStatsEvents(), this.store.p2pId = this.store.p2pId + 1;
      }
      async establish(n) {
        try {
          const i = await u6();
          if (this.localCapabilities = UT(i), n) {
            const { sdp: o } = n, f = Pce(n, xce), T = function() {
              const z = { audioCodecs: [], videoCodecs: [], audioExtensions: [], videoExtensions: [] }, Y = zE(arguments.length > 2 ? arguments[2] : void 0, arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, "sendonly"), te = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, oe = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, He = { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] };
              if (uc(Y, z, "videoExtensions", te, oe, He), uc(Y, z, "videoCodecs", te, oe, He), uc(Y, z, "audioExtensions", te, oe, He), uc(Y, z, "audioCodecs", te, oe, He), ft("RAISE_H264_BASELINE_PRIORITY")) {
                const Re = He.videoCodecs.findIndex((De) => De.rtpMap && De.rtpMap.encodingName.toLocaleLowerCase() === "h264" && De.fmtp && De.fmtp.parameters["profile-level-id"] === "42001f");
                if (Re !== -1) {
                  const De = He.videoCodecs.findIndex((Xe) => Xe.rtpMap && Xe.rtpMap.encodingName.toLocaleLowerCase() === "h264");
                  if (De < Re) {
                    Ee.debug("raising H264 baseline profile priority");
                    const Xe = He.videoCodecs[Re];
                    He.videoCodecs.splice(Re, 1), He.videoCodecs.splice(De, 0, Xe);
                  }
                  De !== -1 && ft("FILTER_SEND_H264_BASELINE") && (te.videoCodecs = te.videoCodecs.filter((Xe) => !(Xe.rtpMap && Xe.rtpMap.encodingName.toLocaleLowerCase() === "h264" && Xe.fmtp && Xe.fmtp.parameters["profile-level-id"] !== "42001f")));
                }
              }
              return { send: te, recv: oe, sendrecv: He };
            }({}, {}, o);
            this.remoteSDP = new y9({ remoteIceParameters: f.iceParameters, remoteDtlsParameters: f.dtlsParameters, candidates: [], remoteRTPCapabilities: T, localCapabilities: this.localCapabilities, direction: this.direction, setup: "actpass", videoCodec: this.store.codec, audioCodec: this.store.audioCodec }), await this.setRemoteDescription({ type: "offer", sdp: this.remoteSDP.toString() }), this.isReady = !0;
            const A = await this.peerConnection.createAnswer();
            if (!A.sdp) throw new Error("Cannot get answer sdp when trying to establish PeerConnection.");
            const R = al(A.sdp);
            await this.peerConnection.setLocalDescription(A);
            const P = await d6({}, {}, A.sdp);
            this.localCapabilities = UT(P);
            const L = this.peerConnection.getTransceivers()[0];
            return L != null && L.receiver && L.receiver.transport && this.tryBindTransportEvents(L.receiver.transport), El(El({}, R), {}, { sdp: A.sdp });
          }
          {
            this.peerConnection.addTransceiver("video", { direction: "sendonly" }), this.peerConnection.addTransceiver("audio", { direction: "sendonly" });
            const o = await this.peerConnection.createOffer();
            if (!o.sdp) throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");
            const f = al(o.sdp);
            return this.initialOffer = o, El(El({}, f), {}, { sdp: o.sdp });
          }
        } catch (i) {
          throw new Gt(Je.GET_LOCAL_CONNECTION_PARAMS_FAILED, i.toString());
        }
      }
      async connect(n) {
        try {
          if (!this.initialOffer) throw new Error("Cannot establish P2PConnection without initial offer.");
          await this.peerConnection.setLocalDescription(this.initialOffer);
          const { sdp: i, iceParameters: o, dtlsParameters: f } = n, T = await d6({}, {}, i);
          this.remoteSDP = new y9({ remoteIceParameters: o, remoteDtlsParameters: f, candidates: [], remoteRTPCapabilities: T, localCapabilities: this.localCapabilities, direction: this.direction, setup: "active", videoCodec: this.store.codec, audioCodec: this.store.audioCodec }), await this.setRemoteDescription({ type: "answer", sdp: this.remoteSDP.toString() });
          const A = this.peerConnection.getTransceivers()[0];
          A != null && A.sender && A.sender.transport && this.tryBindTransportEvents(A.sender.transport);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.connect failed; ".concat(i.toString()));
        }
      }
      async addRemoteCandidate(n) {
        try {
          n && this.pendingCandidates.push(n), this.peerConnection.remoteDescription && this.isReady && (this.pendingCandidates.forEach((i) => {
            this.peerConnection.addIceCandidate(i);
          }), this.pendingCandidates = []);
        } catch (i) {
          throw new Gt(Je.ADD_CANDIDATE_FAILED, "P2PConnection.addRemoteCandidate failed; ".concat(i.toString()));
        }
      }
      send(n, i, o) {
        var f = this;
        return Io(function* () {
          const T = yield dr(f.mutex.lock("From P2PConnection.send"));
          try {
            if (!f.remoteSDP) throw new Error("Cannot call P2PConnection.send before remote SDP created");
            const A = [], R = f.remoteSDP.receive(n, i, o);
            n.forEach((De, Xe) => {
              if (R[Xe].needCreateTransceiver) {
                const We = f.peerConnection.addTransceiver(De._mediaStreamTrack, { direction: "sendonly" });
                A.push(We), De._updateRtpTransceiver(We);
              } else {
                const We = f.peerConnection.getTransceivers().find((mt) => mt.mid === R[Xe].mid);
                if (!We) throw new Error("cannot find transceiver when sendPeerconnection send, mid is ".concat(R[Xe].mid));
                A.push(We), De._updateRtpTransceiver(We);
              }
            }), ui() && ft("SIMULCAST") === !0 && (yield dr(f.applySimulcastForFirefox(A, n)));
            const P = R.map((De) => De.mid), L = yield dr(f.peerConnection.createOffer()), z = f.mungSendOfferSDP(L.sdp, n, P), Y = Ca(z), te = P.map((De) => {
              const Xe = Y.mediaDescriptions.find((We) => We.attributes.mid === De);
              if (!Xe) throw new Error("Cannot extract ssrc from mediaDescription.");
              return i6(Xe, ft("USE_PUB_RTX"));
            }), oe = A.map((De, Xe) => {
              const We = P[Xe];
              return { localSSRC: te[Xe], id: We };
            });
            yield dr(f.peerConnection.setLocalDescription({ type: "offer", sdp: z }));
            try {
              yield oe;
            } catch (De) {
              const Xe = f.remoteSDP.toString();
              throw yield dr(f.peerConnection.setLocalDescription({ type: "offer", sdp: z })), yield dr(f.peerConnection.setRemoteDescription({ type: "answer", sdp: Xe })), yield dr(f.stopSending(P, !0)), De;
            }
            yield dr(f.applySimulcastEncodings(A, n)), yield dr(f.applySendEncodings(A, n));
            const He = f.remoteSDP.toString(), Re = f.logSDPExchange(z, "offer", "local", "send");
            return Re == null || Re(He), yield dr(f.setRemoteDescription({ type: "answer", sdp: He })), A.map((De, Xe) => {
              const We = P[Xe];
              return { localSSRC: te[Xe], id: We };
            });
          } catch (A) {
            throw A instanceof Gt ? A : new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.send failed; ".concat(A.toString()));
          } finally {
            T();
          }
        })();
      }
      async stopSending(n, i) {
        const o = i ? void 0 : await this.mutex.lock("From P2PConnection.stopSending");
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopSending before remote SDP created");
          const f = this.peerConnection.getTransceivers().filter((P) => n.indexOf(P.mid) !== -1);
          if (f.length !== n.length) throw new Error("Transceivers' length (".concat(f.length, ") doesn't match mids' length (").concat(n.length, ") when trying to call P2PConnection.stopSending."));
          f.map((P) => {
            var L;
            P.direction = "inactive", (L = P.stop) === null || L === void 0 || L.call(P);
          });
          const T = await this.peerConnection.createOffer(), A = this.logSDPExchange(T.sdp || "", "offer", "local", "stopSending");
          await this.peerConnection.setLocalDescription(T), this.remoteSDP.stopReceiving(n);
          const R = this.remoteSDP.toString();
          A == null || A(R), await this.setRemoteDescription({ type: "answer", sdp: R });
        } catch (f) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.stopSending failed; ".concat(f.toString()));
        } finally {
          o && o();
        }
      }
      async receive(n, i, o, f) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.receive ".concat(n, " before remoteSDP created."));
          const { mid: T, needExchangeSDP: A } = this.remoteSDP.send(n, i, o, f);
          if (A) {
            const P = this.remoteSDP.toString(), L = this.logSDPExchange(P, "offer", "remote", "receive");
            await this.setRemoteDescription({ type: "offer", sdp: P });
            const z = await this.peerConnection.createAnswer(), Y = this.mungReceiveAnswerSDP(z.sdp, T, n);
            L == null || L(Y || ""), await this.peerConnection.setLocalDescription({ type: "answer", sdp: Y }), Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(n, " by exchanging SDP."));
          } else Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(n, " no need to exchange SDP."));
          const R = this.peerConnection.getTransceivers().find((P) => P.mid === T);
          if (!R || R.mid === null) throw new Error("Cannot get transceiver after setLocalDescription.");
          return { track: R.receiver.track, mid: R.mid, transceiver: R };
        } catch (T) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(T.toString()));
        }
      }
      async mockReceive(n, i, o, f) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.receive ".concat(n, " before remoteSDP created."));
          const { mid: T, needExchangeSDP: A } = this.remoteSDP.send(n, i, o, f);
          if (A) {
            const R = this.remoteSDP.toString(), P = this.logSDPExchange(R, "offer", "remote", "receive");
            await this.setRemoteDescription({ type: "offer", sdp: R });
            const L = await this.peerConnection.createAnswer(), z = this.mungReceiveAnswerSDP(L.sdp, T, n);
            P == null || P(z || ""), await this.peerConnection.setLocalDescription({ type: "answer", sdp: z }), Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(n, " by exchanging SDP."));
          } else Ee.debug("[".concat(this.store.clientId, "] [P2PConnection] receive ").concat(n, " no need to exchange SDP."));
        } catch (T) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(T.toString()));
        }
      }
      async stopReceiving(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");
          this.remoteSDP.stopSending(n);
          const i = this.remoteSDP.toString(), o = this.logSDPExchange(i, "offer", "remote", "stopReceiving");
          await this.setRemoteDescription({ type: "offer", sdp: i });
          const f = await this.peerConnection.createAnswer();
          o == null || o(f.sdp || ""), await this.peerConnection.setLocalDescription(f);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(i.toString()));
        }
      }
      async restartICE(n) {
        try {
          if (this.store.p2pTransport === bf.Auto && (this.store.p2pTransport = bf.SdRtn, pr().supportPCSetConfiguration && this.peerConnection.setConfiguration(Vp.resolvePCConfiguration(this.spec, this.store.p2pTransport))), this.restartCnt > 3 && (this.restartCnt = 0, pr().supportPCSetConfiguration && this.peerConnection.setConfiguration(Vp.resolvePCConfiguration(this.spec, this.store.p2pTransport, ++this.curTurnServerIndex))), !n) {
            this.restartCnt++, this.isReady = !1;
            const i = await this.peerConnection.createOffer({ iceRestart: !0 });
            if (!i.sdp) throw new Error("Cannot restartICE because restart offer SDP does not exist.");
            const { iceParameters: o } = al(i.sdp);
            return this.store.descriptionStart(), this.direction === ia.SEND_ONLY && await this.peerConnection.setLocalDescription(i), o;
          }
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");
          if (this.remoteSDP.restartICE(n), this.store.descriptionStart(), this.direction === ia.RECEIVE_ONLY) {
            this.restartCnt++, await this.setRemoteDescription({ type: "offer", sdp: this.remoteSDP.toString() });
            const i = await this.peerConnection.createAnswer();
            if (!i.sdp) throw new Error("Cannot get answer sdp when trying to iceRestart.");
            const { iceParameters: o } = al(i.sdp);
            return await this.peerConnection.setLocalDescription(i), o;
          }
          await this.setRemoteDescription({ type: "answer", sdp: this.remoteSDP.toString() }), this.isReady = !0;
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(i.toString()));
        }
      }
      close() {
        var n;
        this.peerConnection.close(), this.peerConnection.onicecandidate = null, (n = this.onConnectionStateChange) === null || n === void 0 || n.call(this, "closed"), this.tryUnbindTransportEvents(), this.unbindPCEvents(), this.unbindStatsEvents(), this.transport = void 0, this.statsFilter.destroy();
      }
      getStats() {
        return this.statsFilter.getStats();
      }
      getRemoteVideoIsReady(n) {
        return this.statsFilter.getVideoIsReady(n);
      }
      async updateEncoderConfig(n, i) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.updateEncoderConfig before remote SDP created.");
          const o = await this.peerConnection.createOffer(), f = this.mungSendOfferSDP(o.sdp, [i], [n]);
          this.remoteSDP.updateRecvMedia(n, i);
          const T = this.remoteSDP.toString(), A = this.logSDPExchange(f, "offer", "local", "updateEncoderConfig");
          await this.peerConnection.setLocalDescription({ type: "offer", sdp: f }), A == null || A(T), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: T });
        } catch (o) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, o.toString());
        }
      }
      async updateSendParameters(n, i) {
        const o = this.peerConnection.getTransceivers().filter((f) => f.mid === n);
        o.length === 1 && (this.isVP8Simulcast(i) ? ui() || await this.applySimulcastEncodings(o, [i]) : await this.applySendEncodings(o, [i]));
      }
      setStatsRemoteVideoIsReady(n, i) {
        this.statsFilter.setVideoIsReady2(n, i);
      }
      async replaceTrack(n, i) {
        const o = this.peerConnection.getTransceivers().find((f) => f.mid === i);
        o && await o.sender.replaceTrack(n._mediaStreamTrack);
      }
      async getSelectedCandidatePair() {
        const n = this.peerConnection.getReceivers();
        if (n.length > 0 && n[0].transport && n[0].transport.iceTransport && n[0].transport.iceTransport.getSelectedCandidatePair && n[0].transport.iceTransport.getSelectedCandidatePair()) {
          const i = n[0].transport.iceTransport, { local: o, remote: f } = i.getSelectedCandidatePair();
          return { local: El(El({}, Eu), {}, { candidateType: o.type, protocol: o.protocol, address: o.address, port: o.port }), remote: El(El({}, Eu), {}, { candidateType: f.type, protocol: f.protocol, address: f.address, port: f.port }) };
        }
        return this.statsFilter.getSelectedCandidatePair();
      }
      bindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = () => {
          var n, i;
          on(n = ["connected", "completed"]).call(n, this.peerConnection.iceConnectionState) && (this.isReady = !1), (i = this.onICEConnectionStateChange) === null || i === void 0 || i.call(this, this.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = () => {
          var n;
          this.peerConnection.connectionState === "connected" && (this.restartCnt = 0), (n = this.onConnectionStateChange) === null || n === void 0 || n.call(this, this.peerConnection.connectionState);
        }, this.startICECandidate();
      }
      startICECandidate() {
        this.peerConnection.onicecandidate || (this.localCandidateCount = 0, this.peerConnection.onicecandidate = (n) => {
          if (n.candidate) {
            var i;
            n.candidate.candidate && ((i = this.onLocalCandidate) === null || i === void 0 || i.call(this, n.candidate.toJSON())), this.localCandidateCount += 1;
          } else Ee.debug("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] local candidate count"), this.localCandidateCount);
        });
      }
      unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
      static resolvePCConfiguration(n, i) {
        let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        const f = { iceServers: [] };
        var T;
        return n.iceServers ? f.iceServers = n.iceServers : n.turnServer && n.turnServer.mode !== "off" && (NE(n.turnServer.servers) ? f.iceServers = n.turnServer.servers : (f.iceServers && f.iceServers.push(...Vp.turnServerConfigToIceServers(n.turnServer.servers, i, o)), ft("USE_TURN_SERVER_OF_GATEWAY") && f.iceServers && n.turnServer.serversFromGateway && f.iceServers.push(...Vp.turnServerConfigToIceServers(n.turnServer.serversFromGateway, i, o)), on(T = [bf.Relay, bf.SdRtn]).call(T, i) && (f.iceTransportPolicy = "relay"), ft("FORCE_TURN_TCP") ? f.iceTransportPolicy = "relay" : n.turnServer.servers.concat(n.turnServer.serversFromGateway || []).forEach((A) => {
          A.forceturn && (f.iceTransportPolicy = "relay");
        }))), ft("ENABLE_ENCODED_TRANSFORM") && pr().supportWebRTCEncodedTransform && (f.encodedInsertableStreams = !0), Ee.debug("P2PConnection p2pTransport is ".concat(i)), f;
      }
      static turnServerConfigToIceServers(n, i) {
        let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        const f = [], T = n.filter((R) => R.tcpport);
        Ee.debug("P2PConnection turnServers is ".concat(T, ", current index is ").concat(o));
        const A = T.length > o ? T[o] : T[0];
        switch (i) {
          case bf.SdRtn:
            const R = n.filter((L) => {
              var z;
              return on(z = L.username).call(z, "glb:") && L.turnServerURL == L.turnServerURL;
            }), P = R.length > o ? R[o] : R[0];
            P && (f.push({ username: P.username, credential: P.password, credentialType: "password", urls: "turn:".concat(Ap(P.turnServerURL), ":").concat(P.tcpport, "?transport=udp") }), f.push({ username: P.username, credential: P.password, credentialType: "password", urls: "turns:".concat(Ap(P.turnServerURL), ":").concat(P.tcpport, "?transport=tcp") }));
            break;
          case bf.Relay:
            A && (f.push({ username: A.username, credential: A.password, credentialType: "password", urls: "turn:".concat(A.turnServerURL, ":").concat(A.tcpport, "?transport=udp") }), f.push({ username: A.username, credential: A.password, credentialType: "password", urls: "turns:".concat(Ap(A.turnServerURL), ":").concat(A.tcpport, "?transport=tcp") }));
            break;
          default:
            A && (f.push({ username: A.username, credential: A.password, credentialType: "password", urls: "turn:".concat(A.turnServerURL, ":").concat(A.tcpport, "?transport=udp") }), f.push({ username: A.username, credential: A.password, credentialType: "password", urls: "turns:".concat(Ap(A.turnServerURL), ":").concat(A.tcpport, "?transport=tcp") }), f.push({ username: A.username, credential: A.password, credentialType: "password", urls: "stun:".concat(A.turnServerURL, ":").concat(A.tcpport) }));
        }
        return f;
      }
      tryBindTransportEvents(n) {
        if (n) {
          this.transport = n, n.onstatechange = () => {
            var o;
            n != null && n.state && ((o = this.onDTLSTransportStateChange) === null || o === void 0 || o.call(this, n.state));
          }, n.onerror = (o) => {
            var f;
            (f = this.onDTLSTransportError) === null || f === void 0 || f.call(this, "error" in o ? o.error : o);
          };
          const i = n.iceTransport;
          i && (i.onstatechange = () => {
            const o = n == null ? void 0 : n.iceTransport.state;
            var f;
            o && ((f = this.onICETransportStateChange) === null || f === void 0 || f.call(this, o));
          }, i.getSelectedCandidatePair && (i.onselectedcandidatepairchange = () => {
            if (i.getSelectedCandidatePair()) {
              const { local: o, remote: f } = i.getSelectedCandidatePair();
              Ee.info("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] selectedcandidatepairchange: local ").concat(JSON.stringify({ candidateType: o.type, protocol: o.protocol }), ", remote ").concat(JSON.stringify({ candidateType: f.type, protocol: f.protocol, address: f.address, port: f.port }), " )"));
            }
          }));
        }
      }
      tryUnbindTransportEvents() {
        this.transport && (this.transport.onstatechange = null, this.transport.onerror = null, this.transport.iceTransport && (this.transport.iceTransport.onstatechange = null));
      }
      async updateRtpSenderEncodings(n, i) {
        var o;
        if (i || (i = this.peerConnection.getSenders().find((z) => z.track === n._mediaStreamTrack)), !i) return Ee.warn("[".concat(n.getTrackId(), "] no rtpSender found}"));
        if (this.isVP8Simulcast(n)) return Ee.warn("[updateRtpSenderEncodings] Track is VP8 simulcast, please apply simulcast encodings");
        if (!pr().supportSetRtpSenderParameters) return Ee.warn("[updateRtpSenderEncodings] Browser not support set rtp-sender parameters");
        const f = {}, T = {};
        switch (n._optimizationMode) {
          case "motion":
            f.degradationPreference = "maintain-framerate";
            break;
          case "detail":
            f.degradationPreference = "maintain-resolution";
            break;
          default:
            f.degradationPreference = "balanced";
        }
        if (n._encoderConfig) {
          var A;
          const { bitrateMax: z, frameRate: Y, scaleResolutionDownBy: te } = n._encoderConfig;
          z && (T.maxBitrate = 1e3 * z), on(A = n._hints).call(A, Fr.LOW_STREAM) && (Y && (T.maxFramerate = Ga(Y)), te && te >= 1 && (T.scaleResolutionDownBy = te));
        }
        if (ft("DSCP_TYPE") && ad()) {
          var R;
          const z = ft("DSCP_TYPE");
          on(R = ["very-low", "low", "medium", "high"]).call(R, z) && (T.networkPriority = z);
        }
        const P = i.getParameters(), L = (o = P.encodings) === null || o === void 0 ? void 0 : o[0];
        ui() && !L && (f.encodings = [T]), L && Object.assign(L, T), Object.assign(P, f), Ee.debug("[".concat(n.getTrackId(), "] updateRtpSenderEncodings: ").concat(JSON.stringify(P.encodings))), await i.setParameters(P);
      }
      async applySendEncodings(n, i) {
        try {
          if (!pr().supportSetRtpSenderParameters || n.length !== i.length) return;
          for (let o = 0; o < n.length; o++) {
            const f = n[o], T = i[o];
            T instanceof Wr && !this.isVP8Simulcast(T) && await this.updateRtpSenderEncodings(T, f.sender);
          }
        } catch {
          Ee.debug("[".concat(this.store.clientId, "] Apply RTPSendEncodings failed."));
        }
      }
      mungSendOfferSDP(n, i, o) {
        const f = Ca(n);
        return i.forEach((T, A) => {
          const R = o[A], P = f.mediaDescriptions.find((L) => L.attributes.mid === R);
          P && (Cp(P, T), c6(P, T, this.store.codec));
        }), nl(f);
      }
      bindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = (n) => {
          var i;
          (i = this.onFirstAudioReceived) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstVideoReceived = (n) => {
          var i;
          (i = this.onFirstVideoReceived) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstAudioDecoded = (n) => {
          var i;
          (i = this.onFirstAudioDecoded) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstVideoDecoded = (n, i, o) => {
          var f;
          (f = this.onFirstVideoDecoded) === null || f === void 0 || f.call(this, n, i, o);
        }, this.statsFilter.onSelectedLocalCandidateChanged = (n, i) => {
          var o;
          (o = this.onSelectedLocalCandidateChanged) === null || o === void 0 || o.call(this, n, i);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = (n, i) => {
          var o;
          (o = this.onSelectedRemoteCandidateChanged) === null || o === void 0 || o.call(this, n, i);
        }, this.statsFilter.onFirstVideoDecodedTimeout = (n) => {
          var i;
          (i = this.onFirstVideoDecodedTimeout) === null || i === void 0 || i.call(this, n);
        };
      }
      unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0, this.statsFilter.onFirstVideoDecodedTimeout = void 0;
      }
      async applySimulcastForFirefox(n, i) {
        if (n.length === i.length) for (let P = 0; P < n.length; P++) {
          var o, f, T, A, R;
          const L = n[P], z = i[P];
          if (z instanceof Wr && !on(o = z._hints).call(o, Fr.LOW_STREAM) && (f = z._encoderConfig) !== null && f !== void 0 && f.bitrateMax && ((T = z._encoderConfig) === null || T === void 0 ? void 0 : T.bitrateMax) > 200 && (A = z._scalabilityMode) !== null && A !== void 0 && A.numSpatialLayers && ((R = z._scalabilityMode) === null || R === void 0 ? void 0 : R.numSpatialLayers) > 1 && this.store.codec === "vp8") {
            const Y = {}, te = { high: 1e3 * (z._encoderConfig.bitrateMax - 50), medium: 5e4 };
            Y.encodings = [{ rid: "m", active: !0, maxBitrate: te.medium, scaleResolutionDownBy: 4 }, { rid: "h", active: !0, maxBitrate: te.high }];
            const oe = L.sender.getParameters();
            await L.sender.setParameters(Object.assign(oe, Y));
          }
        }
      }
      async applySimulcastEncodings(n, i) {
        if (!ui() && n.length === i.length) for (let o = 0; o < n.length; o++) {
          const f = i[o];
          if (f instanceof Wr && this.isVP8Simulcast(f)) {
            const T = n[o], A = {}, R = { high: 1e3 * (f._encoderConfig.bitrateMax - 50), medium: 5e4 };
            A.encodings = [{ active: !0, adaptivePtime: !1, networkPriority: "high", priority: "high", maxBitrate: R.high }, { active: !0, adaptivePtime: !1, networkPriority: "low", priority: "low", maxBitrate: R.medium, scaleResolutionDownBy: 4 }];
            const P = T.sender.getParameters();
            await T.sender.setParameters(Object.assign(P, A));
          }
        }
      }
      isVP8Simulcast(n) {
        var i, o, f, T, A;
        return !!(n instanceof Wr && ft("SIMULCAST") && this.store.codec === "vp8" && !on(i = n._hints).call(i, Fr.LOW_STREAM) && (o = n._encoderConfig) !== null && o !== void 0 && o.bitrateMax && ((f = n._encoderConfig) === null || f === void 0 ? void 0 : f.bitrateMax) > 200 && (T = n._scalabilityMode) !== null && T !== void 0 && T.numSpatialLayers && ((A = n._scalabilityMode) === null || A === void 0 ? void 0 : A.numSpatialLayers) > 1);
      }
      logSDPExchange(n, i, o, f) {
        if (ft("SDP_LOGGING")) return Ee.upload("[".concat(this.store.clientId, "] exchanging ").concat(o, " ").concat(i, " SDP during P2PConnection.").concat(f, `
`), n), i === "offer" ? (T) => {
          this.logSDPExchange(T, "answer", o === "local" ? "remote" : "local", f);
        } : void 0;
      }
      async muteLocal(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.muteLocal before remote SDP created.");
          const i = this.peerConnection.getTransceivers().filter((A) => A.mid && n.indexOf(A.mid) !== -1);
          if (i.length !== n.length) throw new Error("Transceivers' length doesn't match mids' length.");
          i.map((A) => {
            A.direction = "inactive";
          });
          const o = await this.peerConnection.createOffer(), f = this.logSDPExchange(o.sdp || "", "offer", "local", "muteLocal");
          await this.peerConnection.setLocalDescription(o), this.remoteSDP.muteRemote(n);
          const T = this.remoteSDP.toString();
          f == null || f(T), await this.setRemoteDescription({ type: "answer", sdp: T });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.muteLocal failed; ".concat(i.toString()));
        }
      }
      async unmuteLocal(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.unmuteLocal before remote SDP created.");
          const i = this.peerConnection.getTransceivers().filter((A) => A.mid && n.indexOf(A.mid) !== -1);
          if (i.length !== n.length) throw new Error("Transceivers' length doesn't match mids' length.");
          i.map(async (A) => {
            A.direction = "sendonly";
          });
          const o = await this.peerConnection.createOffer(), f = this.logSDPExchange(o.sdp || "", "offer", "local", "unmuteLocal");
          await this.peerConnection.setLocalDescription(o), this.remoteSDP.unmuteRemote(n);
          const T = this.remoteSDP.toString();
          f == null || f(T), await this.setRemoteDescription({ type: "answer", sdp: T });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteLocal failed; ".concat(i.toString()));
        }
      }
      async getRemoteSSRC(n, i) {
        var o, f;
        if (i = (o = i) !== null && o !== void 0 ? o : (f = this.currentRemoteDescription) === null || f === void 0 ? void 0 : f.sdp) {
          var T;
          const A = (T = Ca(i).mediaDescriptions.find((R) => R.attributes.mid === n)) === null || T === void 0 ? void 0 : T.attributes.ssrcs;
          return A == null ? void 0 : A[0].ssrcId;
        }
      }
      async setRemoteDescription(n) {
        var i;
        await this.peerConnection.setRemoteDescription(n), on(i = ["connected", "completed"]).call(i, this.peerConnection.iceConnectionState) || (this.isReady = !0, this.addRemoteCandidate());
      }
      mungReceiveAnswerSDP(n, i, o) {
        const f = Ca(n), T = f.mediaDescriptions.find((A) => A.attributes.mid === i);
        return T && o === vn.AUDIO && T.media.mediaType === "audio" && Sp(T), nl(f);
      }
    }, bn(Xr.prototype, "establish", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "establish"), Xr.prototype), bn(Xr.prototype, "connect", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "connect"), Xr.prototype), bn(Xr.prototype, "receive", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "receive"), Xr.prototype), bn(Xr.prototype, "mockReceive", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "mockReceive"), Xr.prototype), bn(Xr.prototype, "stopReceiving", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "stopReceiving"), Xr.prototype), bn(Xr.prototype, "restartICE", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "restartICE"), Xr.prototype), bn(Xr.prototype, "close", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "close"), Xr.prototype), bn(Xr.prototype, "updateEncoderConfig", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "updateEncoderConfig"), Xr.prototype), bn(Xr.prototype, "updateSendParameters", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "updateSendParameters"), Xr.prototype), bn(Xr.prototype, "replaceTrack", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "replaceTrack"), Xr.prototype), bn(Xr.prototype, "muteLocal", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "muteLocal"), Xr.prototype), bn(Xr.prototype, "unmuteLocal", [pc], Object.getOwnPropertyDescriptor(Xr.prototype, "unmuteLocal"), Xr.prototype), Xr);
    function pc(e, n, i) {
      const o = e[n];
      if (typeof o != "function") throw new Error("Cannot use mutex on object property.");
      return i.value = async function() {
        const f = this.mutex, T = await f.lock("From P2PConnection.".concat(n));
        try {
          for (var A = arguments.length, R = new Array(A), P = 0; P < A; P++) R[P] = arguments[P];
          return await o.apply(this, R);
        } finally {
          T();
        }
      }, i;
    }
    let zc = function(e) {
      return e.SEND_ONLY = "SEND_ONLY", e.RECEIVE_ONLY = "RECEIVE_ONLY", e;
    }({});
    var b9, A9, O9, C9, S9, I9, R9, N9, w9, _9, P9, Qr;
    function x9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function y0(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? x9(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : x9(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    let Dce = (b9 = Fc(zc.SEND_ONLY), A9 = Fc(zc.SEND_ONLY), O9 = Fc(), C9 = Fc(zc.RECEIVE_ONLY), S9 = Fc(zc.RECEIVE_ONLY), I9 = Fc(zc.RECEIVE_ONLY), R9 = Fc(zc.RECEIVE_ONLY), N9 = Fc(zc.RECEIVE_ONLY), w9 = Fc(zc.RECEIVE_ONLY), _9 = Fc(), P9 = Fc(zc.RECEIVE_ONLY), Qr = class extends ii {
      get state() {
        return this._state;
      }
      set state(e) {
        const n = this._state;
        this._state = e, this.emit(wn.StateChange, n, this._state);
      }
      constructor(e, n) {
        super(), Ve(this, "isPlanB", !1), Ve(this, "store", void 0), Ve(this, "statsUploader", void 0), Ve(this, "sendConnection", void 0), Ve(this, "recvConnection", void 0), Ve(this, "localTrackMap", /* @__PURE__ */ new Map()), Ve(this, "remoteUserMap", /* @__PURE__ */ new Map()), Ve(this, "localDataChannels", []), Ve(this, "pendingLocalTracks", []), Ve(this, "pendingRemoteTracks", []), Ve(this, "statsCollector", void 0), Ve(this, "dtlsFailedCount", 0), Ve(this, "sendMutex", void 0), Ve(this, "recvMutex", void 0), Ve(this, "_state", Ir.Disconnected), Ve(this, "_restartStates", ["disconnected", "failed"]), Ve(this, "reconnectInterval", void 0), Ve(this, "uploadUnplinkStarted", !1), Ve(this, "uploadDownlinkStarted", !1), Ve(this, "uplinkStateUploadInterval", void 0), Ve(this, "downlinkStatsUploadInterval", void 0), Ve(this, "handleMuteLocalTrack", async (i, o, f) => {
          const T = await this.sendMutex.lock("Locking from P2PChannel2.handleMuteLocalTrack");
          try {
            if (!this.sendConnection || this.state !== Ir.Connected) return void f(new Gt(Je.INVALID_OPERATION, "Cannot call P2PChannel2.handleMuteLocalTrack before sendConnection established."));
            const P = this.filterTobeMutedTracks(i);
            if (P.length === 0) return void o();
            const L = P.find((oe) => oe[0] === "videoLowTrack");
            L && L[1].track._originMediaStreamTrack.stop(), await this.sendConnection.muteLocal(P.map((oe) => {
              let [, { id: He }] = oe;
              return He;
            }));
            let z = !1;
            var A, R;
            i.trackMediaType === "video" ? z = !((A = this.localTrackMap.get(Qt.LocalAudioTrack)) === null || A === void 0 || !A.track._muted) : z = ((R = this.localTrackMap.get(Qt.LocalVideoTrack)) === null || R === void 0 ? void 0 : R.id) === void 0;
            const Y = this.createMuteMessage(P);
            await Br(this, wn.RequestMuteLocal, Y);
            const te = i.trackMediaType === "video" ? il.MUTE_LOCAL_VIDEO : il.MUTE_LOCAL_AUDIO;
            await Br(this, wn.RequestP2PMuteLocal, { action: te, message: Y, isMuteAll: z }), o();
          } catch (P) {
            f(P);
          } finally {
            T();
          }
        }), Ve(this, "handleUnmuteLocalTrack", async (i, o, f) => {
          const T = await this.sendMutex.lock("Locking from P2PChannel2.handleUnmuteLocalTrack");
          try {
            if (!this.sendConnection || this.state !== Ir.Connected) return void f(new Gt(Je.INVALID_OPERATION, "Cannot call P2PChannel2.handleUnmuteLocalTrack before sendConnection established."));
            const A = this.filterTobeUnmutedTracks(i);
            if (A.length === 0) return void o();
            await this.sendConnection.unmuteLocal(A.map((L) => {
              let [, { id: z }] = L;
              return z;
            }));
            const R = this.createUnmuteMessage(A), P = i.trackMediaType === "video" ? il.UNMUTE_LOCAL_VIDEO : il.UNMUTE_LOCAL_AUDIO;
            await Br(this, wn.RequestP2PMuteLocal, { action: P, message: R }), o();
          } catch (A) {
            f(A);
          } finally {
            T();
          }
        }), Ve(this, "handleUpdateVideoEncoder", async (i, o, f, T) => {
          let A;
          typeof T == "boolean" && T || (A = await this.sendMutex.lock("Locking from P2PChannel2.handleUpdateVideoEncoder"));
          try {
            const P = this.localTrackMap.get(Qt.LocalVideoTrack);
            if (!this.sendConnection || !P || P.track !== i || this.state !== Ir.Connected) return void o();
            const { id: L, track: z } = P;
            L && (await this.sendConnection.updateSendParameters(L, z), await this.sendConnection.updateEncoderConfig(L, z), this.emit(wn.UpdateVideoEncoder, z)), o();
          } catch (P) {
            f(P);
          } finally {
            var R;
            (R = A) === null || R === void 0 || R();
          }
        }), Ve(this, "handleUpdateVideoSendParameters", async (i, o, f) => {
          const T = await this.sendMutex.lock("Locking from P2PChannel2.handleUpdateVideoSendParameters");
          try {
            const A = this.localTrackMap.get(Qt.LocalVideoTrack);
            if (!this.sendConnection || !A || A.track !== i || this.state !== Ir.Connected) return void o();
            const { id: R, track: P } = A;
            R && await this.sendConnection.updateSendParameters(R, P), o();
          } catch (A) {
            f(A);
          } finally {
            T();
          }
        }), Ve(this, "handleReplaceTrack", async (i, o, f, T) => {
          let A;
          Ee.debug("[".concat(this.store.clientId, "] P2PChannel2 handleReplaceTrack for [track-id-").concat(i.getTrackId(), "]")), typeof T == "boolean" && T || (A = await this.sendMutex.lock("From P2PChannel2.handleReplaceTrack"));
          try {
            var R;
            const L = Array.from(this.localTrackMap.entries()).find((z) => {
              let [, { track: Y }] = z;
              return i === Y;
            });
            if (!this.sendConnection || !L || L[1].id === void 0 || this.state !== Ir.Connected) return void o();
            if (await ((R = this.sendConnection) === null || R === void 0 ? void 0 : R.replaceTrack(i, L[1].id)), L[0] === Qt.LocalVideoTrack && pr().supportDualStreamEncoding) {
              const z = this.localTrackMap.get(Qt.LocalVideoLowTrack);
              if (z) {
                const Y = i._mediaStreamTrack.clone();
                z.track._originMediaStreamTrack.stop(), z.track._mediaStreamTrack = Y, z.track._originMediaStreamTrack = Y, await new cn((te, oe) => {
                  this.handleReplaceTrack(z.track, te, oe, !0);
                });
              }
            }
            o();
          } catch (L) {
            f(L);
          } finally {
            var P;
            (P = A) === null || P === void 0 || P();
          }
        }), Ve(this, "handleGetLocalVideoStats", (i) => {
          i(this.statsCollector.getLocalVideoTrackStats());
        }), Ve(this, "handleGetLocalAudioStats", (i) => {
          i(this.statsCollector.getLocalAudioTrackStats());
        }), Ve(this, "handleGetRemoteVideoStats", (i) => this.statsCollector.getRemoteVideoTrackStats(i.uid)[i.uid]), Ve(this, "handleGetRemoteAudioStats", (i) => this.statsCollector.getRemoteAudioTrackStats(i.uid)[i.uid]), this.store = e, this.statsCollector = n, this.statsCollector.addP2PChannel(this), this.statsUploader = new J6(e), this.bindStatsUploaderEvents(), this.sendMutex = new xs("P2PChannel2-send-mutex", e.clientId), this.recvMutex = new xs("P2PChannel2-recv-mutex", e.clientId), this.reconnectInterval = window.setInterval(() => {
          [this.sendConnection, this.recvConnection].forEach((i) => {
            i && (i.iceConnectionState !== "disconnected" && i.iceConnectionState !== "failed" || this.handleDisconnect(i.direction));
          });
        }, ft("ICE_RESTART_INTERVAL"));
      }
      async startP2PConnection(e, n) {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support startP2PConnection.");
      }
      async connect(e) {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support connect.");
      }
      async startP2P(e, n) {
        let i;
        try {
          if (n) {
            this.recvConnection && (Ee.warning("[".concat(this.store.clientId, "] P2PChannel.startP2P reset recvConnection.")), this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection)), i = await this.recvMutex.lock("From P2PChannel.startP2P"), this.recvConnection = new T9(e, this.store, ia.RECEIVE_ONLY), this.bindConnectionEvents(this.recvConnection);
            const o = await this.recvConnection.establish(n);
            return { iceParameters: o.iceParameters, dtlsParameters: o.dtlsParameters, sdp: o.sdp };
          }
          {
            this.state = Ir.New, this.sendConnection && (Ee.warning("[".concat(this.store.clientId, "] P2PChannel.startP2P reset sendConnection.")), this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection)), i = await this.sendMutex.lock("From P2PChannel.startP2P"), this.sendConnection = new T9(e, this.store), this.store.peerConnectionStart(), this.bindConnectionEvents(this.sendConnection);
            const o = await this.sendConnection.establish();
            return { iceParameters: o.iceParameters, dtlsParameters: o.dtlsParameters, sdp: o.sdp };
          }
        } finally {
          i && i();
        }
      }
      async p2pConnect(e) {
        if (!this.sendConnection) throw new Gt(Je.UNEXPECTED_ERROR, "Cannot P2PChannel2.p2pConnect before P2PChannel2.startP2PConnection .");
        this.store.peerConnectionStart(), await this.sendConnection.connect(e), this.statsUploader.startUploadTransportStats(), this.statsUploader.startUploadExtensionUsageStats(), this.state = Ir.Connected;
      }
      async addRemoteCandidate(e, n) {
        if (n === ia.RECEIVE_ONLY) {
          if (!this.sendConnection) throw new Gt(Je.UNEXPECTED_ERROR, "Cannot P2PChannel2.connect before P2PChannel2.addRemoteCandidate .");
          await this.sendConnection.addRemoteCandidate(e);
        } else {
          if (!this.recvConnection) throw new Gt(Je.UNEXPECTED_ERROR, "Cannot P2PChannel2.connect before P2PChannel2.addRemoteCandidate .");
          await this.recvConnection.addRemoteCandidate(e);
        }
      }
      publish(e, n, i) {
        var o = this;
        return Io(function* () {
          const f = yield dr(o.sendMutex.lock("From P2PChannel.publish"));
          try {
            if (!o.sendConnection || o.state !== Ir.Connected) {
              o.throwIfTrackTypeNotMatch(e);
              const L = e.filter((z) => o.pendingLocalTracks.indexOf(z) === -1);
              return void (o.pendingLocalTracks = o.pendingLocalTracks.concat(L));
            }
            o.store.pubId = o.store.pubId + 1, Ms.markPublishStart(o.store.clientId, o.store.pubId);
            const T = o.filterTobePublishedTracks(e, n, i);
            if (T.length === 0) return void (yield dr(o.tryToUnmuteAudio(e)));
            T.forEach((L) => {
              let { track: z, type: Y } = L;
              const te = Date.now();
              o.store.publish(z.getTrackId(), Y === Qt.LocalAudioTrack ? "audio" : "video", te);
            }), o.bindLocalTrackEvents(T);
            const A = yield dr(o.sendConnection.send(T.map((L) => {
              let { track: z } = L;
              return z;
            }), o.store.codec, o.store.audioCodec)), R = (yield dr(A.next())).value, P = o.createGatewayPublishMessage(T, R);
            try {
              yield P;
            } catch (L) {
              throw A.throw(L), (L == null ? void 0 : L.code) === Je.WS_ABORT && T.forEach((z) => {
                let { track: Y } = z;
                o.pendingLocalTracks.indexOf(Y) === -1 && o.pendingLocalTracks.push(Y);
              }), o.unbindLocalTrackEvents(T), L;
            }
            yield dr(A.next()), T.forEach((L) => {
              let { type: z } = L;
              o.statsCollector.addLocalStats(z);
            }), o.statsUploader.startUploadOutboundStats(), o.assignLocalTracks(T, R), T.forEach((L) => {
              let { track: z, type: Y } = L;
              const te = Date.now();
              o.store.publish(z.getTrackId(), Y === Qt.LocalAudioTrack ? "audio" : "video", void 0, te);
            }), o.startUploadUplinkState();
          } finally {
            f();
          }
        })();
      }
      async unpublish(e) {
        if (!this.sendConnection || this.state !== Ir.Connected) return void (e.length === 0 ? this.pendingLocalTracks.length = 0 : this.pendingLocalTracks = this.pendingLocalTracks.filter((f) => !on(e).call(e, f)));
        const n = this.filterTobeUnpublishedTracks(e);
        if (n.length === 0) return;
        const i = n.find((f) => f[0] === "videoLowTrack");
        i && i[1].track.close();
        const o = this.createGatewayUnpublishMessage(n);
        if (await this.sendConnection.stopSending(n.map((f) => {
          let [, { id: T }] = f;
          return T;
        })), this.withdrawLocalTracks(n), this.unbindLocalTrackEvents(n.map((f) => {
          let [T, { track: A }] = f;
          return { type: T, track: A };
        })), n.forEach((f) => {
          let [T] = f;
          this.statsCollector.removeLocalStats(T);
        }), this.localTrackMap.size === 0 && (this.statsUploader.stopUploadOutboundStats(), this.stopUploadUplinkState()), this.sendConnection && this.state === Ir.Connected)
          return i && i[1].track.close(), o;
        e.forEach((f) => {
          const T = this.pendingLocalTracks.indexOf(f);
          T !== -1 && this.pendingLocalTracks.splice(T, 1);
        });
      }
      startUploadUplinkState() {
        if (this.uploadUnplinkStarted) return;
        this.uploadUnplinkStarted = !0, this.uplinkStateUploadInterval && window.clearInterval(this.uplinkStateUploadInterval);
        const e = () => {
          const n = [], i = [];
          Array.from(this.localTrackMap.entries()).forEach((o) => {
            let [f, { track: T, ssrcs: A }] = o;
            const R = { stream_type: Iae(T, f), ssrcs: A };
            T._muted || !T._enabled ? n.push(R) : i.push(R);
          }), n.length > 0 && n.forEach((o) => {
            Br(this, wn.RequestMuteLocal, [o]);
          }), i.length > 0 && i.forEach((o) => {
            Br(this, wn.RequestUnmuteLocal, [o]);
          });
        };
        e(), this.uplinkStateUploadInterval = window.setInterval(() => {
          e();
        }, 3e3);
      }
      stopUploadUplinkState() {
        this.uploadUnplinkStarted && (this.uploadUnplinkStarted = !1, this.uplinkStateUploadInterval && window.clearInterval(this.uplinkStateUploadInterval));
      }
      publishLowStream(e) {
        return Io(function* () {
          throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support publishLowStream.");
        })();
      }
      async republish() {
        this.pendingLocalTracks.length > 0 && (Ee.debug("[".concat(this.store.clientId, "] Emit P2PChannelEvents.RequestRePublish to republish tracks.")), await Ss(this, wn.RequestRePublish, this.pendingLocalTracks), this.emit(wn.MediaReconnectEnd, this.store.uid), this.pendingLocalTracks = []);
      }
      async unpublishLowStream() {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support unpublishLowStream.");
      }
      async subscribe(e, n, i, o) {
        var f;
        if (!this.recvConnection) throw new Gt(Je.INVALID_OPERATION, "Cannot subscribe remote user when recvConnection disconnected.");
        if ((f = this.remoteUserMap.get(e)) !== null && f !== void 0 && f.has(n)) return;
        const { track: T, mid: A, transceiver: R } = await this.recvConnection.receive(n, [{ ssrcId: i }], String(e.uid), o);
        n === vn.AUDIO ? (e._audioTrack ? e._audioTrack._updateOriginMediaStreamTrack(T) : (e._audioTrack = new Ep(T, e.uid, e._uintid, this.store), Ee.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote audio track: ").concat(e._audioTrack.getTrackId()))), R && e._audioTrack._updateRtpTransceiver(R), this.bindRemoteTrackEvents(e, e._audioTrack)) : (e._videoSSRC = i, e._videoTrack ? e._videoTrack._updateOriginMediaStreamTrack(T) : (e._videoTrack = new mp(T, e.uid, e._uintid, this.store), Ee.info("[".concat(this.store.clientId, "] [").concat(this.store.p2pId, "] create remote video track: ").concat(e._videoTrack.getTrackId()))), R && e._videoTrack._updateRtpTransceiver(R), this.bindRemoteTrackEvents(e, e._videoTrack));
        const P = this.remoteUserMap.get(e);
        P ? P.set(n, A) : this.remoteUserMap.set(e, /* @__PURE__ */ new Map([[n, A]])), this.statsCollector.addRemoteStats(e.uid), this.statsUploader.startUploadInboundStats(), this.startUploadDownlinkState();
        const L = this.pendingRemoteTracks.findIndex((z) => {
          let { user: Y, kind: te } = z;
          return Y.uid === e.uid && n === te;
        });
        L !== -1 && (this.pendingRemoteTracks.splice(L, 1), this.emit(wn.MediaReconnectEnd, e.uid));
      }
      async mockSubscribe(e, n, i, o) {
        if (!this.recvConnection) throw new Gt(Je.INVALID_OPERATION, "Cannot subscribe remote user when recvConnection disconnected.");
        await this.recvConnection.mockReceive(n, [{ ssrcId: i }], String(e.uid), o);
      }
      async unsubscribe(e, n, i) {
        const o = this.pendingRemoteTracks.filter((T) => {
          let { user: A, kind: R } = T;
          return n !== void 0 ? A.uid === e.uid && n === R : A.uid === e.uid;
        });
        if (o.forEach((T) => {
          const A = this.pendingRemoteTracks.indexOf(T);
          this.pendingRemoteTracks.splice(A, 1);
        }), this.recvConnection || i || o.forEach((T) => {
          let { kind: A } = T;
          var R;
          if (A === vn.AUDIO) (R = e._audioTrack) === null || R === void 0 || R._destroy(), e._audioTrack = void 0;
          else if (A === vn.VIDEO) {
            var P;
            (P = e._videoTrack) === null || P === void 0 || P._destroy(), e._videoTrack = void 0;
          }
        }), !this.recvConnection) return;
        const f = this.filterTobeUnSubscribedTracks(e, n);
        f.length !== 0 && (await this.recvConnection.stopReceiving(f.map((T) => {
          let [, { id: A }] = T;
          return A;
        })), this.withdrawRemoteTracks(f), this.remoteUserMap.size === 0 && (this.statsUploader.stopUploadInboundStats(), this.stopUploadDownlinkState()), f.forEach((T) => {
          let [A, { kind: R }] = T;
          var P, L;
          if (R === vn.VIDEO && A._videoSSRC && ((P = this.recvConnection) === null || P === void 0 || P.setStatsRemoteVideoIsReady(A._videoSSRC, !1)), R === vn.VIDEO) this.unbindRemoteTrackEvents(A._videoTrack), i || ((L = A._videoTrack) === null || L === void 0 || L._destroy(), A._videoTrack = void 0);
          else if (R === vn.AUDIO) {
            var z;
            this.unbindRemoteTrackEvents(A._audioTrack), !i && ((z = A._audioTrack) === null || z === void 0 || z._destroy(), A._audioTrack = void 0);
          }
        }), f.forEach((T) => {
          let [, { kind: A }] = T;
          Br(this, wn.RequestP2PMuteRemote, A);
        }));
      }
      startUploadDownlinkState() {
        if (this.uploadDownlinkStarted) return;
        this.uploadDownlinkStarted = !0, this.downlinkStatsUploadInterval && window.clearInterval(this.downlinkStatsUploadInterval);
        const e = () => Array.from(this.remoteUserMap.entries()).forEach((n) => {
          let [, i] = n;
          [vn.VIDEO, vn.AUDIO].forEach((o) => {
            i.has(o) ? Br(this, wn.RequestP2PUnmuteRemote, o) : Br(this, wn.RequestP2PMuteRemote, o);
          });
        });
        e(), this.downlinkStatsUploadInterval = window.setInterval(() => {
          e();
        }, 3e3);
      }
      stopUploadDownlinkState() {
        this.uploadDownlinkStarted && (this.uploadDownlinkStarted = !1, this.downlinkStatsUploadInterval && window.clearInterval(this.downlinkStatsUploadInterval));
      }
      getAllDataChannels() {
        return this.localDataChannels;
      }
      async massSubscribe(e) {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support massSubscribe.");
      }
      async massSubscribeNoLock(e) {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support massSubscribeNoLock.");
      }
      async massUnsubscribe(e) {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support massUnsubscribe.");
      }
      async massUnsubscribeNoLock(e) {
        throw new Gt(Je.NOT_SUPPORTED, "p2p mode does not support massUnsubscribeNoLock.");
      }
      async muteRemote(e, n) {
        if (!this.recvConnection) return;
        const i = this.remoteUserMap.get(e);
        if (!i) return void Ee.warning("[".concat(this.store.clientId, "] P2PChannel2.muteRemote has no remote user ").concat(e.uid, "."));
        if (!i.get(n)) return void Ee.warning("[".concat(this.store.clientId, "] P2PChannel2.muteRemote has no remote user ").concat(e.uid, " media type ").concat(n, "."));
        const o = n === vn.VIDEO ? e._videoSSRC : e._audioSSRC;
        o !== void 0 && this.recvConnection.setStatsRemoteVideoIsReady(o, !1);
      }
      async unmuteRemote(e, n) {
        return this.unmuteRemoteNoLock(e, n);
      }
      async unmuteRemoteNoLock(e, n) {
        if (!this.recvConnection) return;
        const i = this.remoteUserMap.get(e);
        if (!i) return void Ee.warning("[".concat(this.store.clientId, "] P2PChannel2.unmuteRemote has no remote user ").concat(e.uid, "."));
        i.get(n) || Ee.warning("[".concat(this.store.clientId, "] P2PChannel2.unmuteRemote has no remote user ").concat(e.uid, " media type ").concat(n, "."));
      }
      getAllTracks(e) {
        const n = this.localTrackMap.get(Qt.LocalAudioTrack);
        if ((n == null ? void 0 : n.track) instanceof Xi) {
          const i = n.track;
          return Array.from(this.localTrackMap.entries()).filter((o) => {
            let [f] = o;
            return f !== Qt.LocalAudioTrack;
          }).filter((o) => {
            let [f] = o;
            return !(e && f === Qt.LocalVideoLowTrack);
          }).map((o) => {
            let [, { track: f }] = o;
            return f;
          }).concat(i.trackList);
        }
        return Array.from(this.localTrackMap.entries()).filter((i) => {
          let [o] = i;
          return !(e && o === Qt.LocalVideoLowTrack);
        }).map((i) => {
          let [, { track: o }] = i;
          return o;
        });
      }
      reportPublishEvent(e, n, i, o, f) {
        if (e) {
          const A = this.localTrackMap.get(Qt.LocalAudioTrack), R = o ? this.localTrackMap.get(Qt.LocalVideoLowTrack) : this.localTrackMap.get(Qt.LocalVideoTrack);
          Cn.publish(this.store.sessionId, { eventElapse: Ms.measureFromPublishStart(this.store.clientId, this.store.pubId), succ: e, ec: n, audioName: A == null ? void 0 : A.track.getTrackLabel(), videoName: R == null ? void 0 : R.track.getTrackLabel(), screenshare: (R == null ? void 0 : R.track._hints.indexOf(Fr.SCREEN_TRACK)) !== -1, audio: !!A, video: !!R, p2pid: this.store.p2pId, publishRequestid: this.store.pubId, extend: f });
        } else {
          var T;
          i || (i = []);
          const A = i.find((P) => P instanceof li), R = o ? (T = this.localTrackMap.get(Qt.LocalVideoTrack)) === null || T === void 0 ? void 0 : T.track : i.find((P) => P instanceof Wr);
          Cn.publish(this.store.sessionId, { eventElapse: Ms.measureFromPublishStart(this.store.clientId, this.store.pubId), succ: e, ec: n, audioName: A == null ? void 0 : A.getTrackLabel(), videoName: R == null ? void 0 : R.getTrackLabel(), screenshare: (R == null ? void 0 : R._hints.indexOf(Fr.SCREEN_TRACK)) !== -1, audio: !!A, video: !!R, p2pid: this.store.p2pId, publishRequestid: this.store.pubId, extend: f });
        }
      }
      reportSubscribeEvent(e, n, i, o) {
        const f = o === vn.VIDEO ? i._videoSSRC : i._audioSSRC;
        f && Cn.subscribe(this.store.sessionId, { succ: e, ec: n, video: o === vn.VIDEO, audio: o === vn.AUDIO, peerid: i.uid, subscribeRequestid: o === vn.VIDEO ? i._videoSSRC : i._audioSSRC, p2pid: this.store.p2pId, eventElapse: Ms.measureFromSubscribeStart(this.store.clientId, f) });
      }
      reset() {
        Ee.debug("[".concat(this.store.clientId, "] P2PChannel2.reset")), this.sendMutex = new xs("P2PChannel2-send-mutex", this.store.clientId), this.sendMutex = new xs("P2PChannel2-recv-mutex", this.store.clientId), this.sendConnection && (this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection), this.sendConnection = void 0), this.recvConnection && (this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection), this.recvConnection = void 0), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), this.statsUploader.stopUploadExtensionUsageStats(), this.stopUploadUplinkState(), this.stopUploadDownlinkState(), this.unbindLocalTrackEvents(), this.unbindAllRemoteTrackEvents(), this.unbindRtpTransceiver();
        const e = this.localTrackMap.get(Qt.LocalAudioTrack);
        if ((e == null ? void 0 : e.track) instanceof Xi) {
          if (e.track.trackList.length > 0) {
            const n = e.track;
            e.track.trackList.forEach((i) => {
              n.removeAudioTrack(i);
            });
          }
          e.track.close();
        }
        this.localTrackMap.clear(), this.remoteUserMap.clear(), this.statsCollector.removeRemoteStats(), this.statsCollector.removeLocalStats(), this.dtlsFailedCount = 0, this.pendingLocalTracks = [], this.pendingRemoteTracks = [], this.reconnectInterval && (window.clearInterval(this.reconnectInterval), this.reconnectInterval = void 0), this.state = Ir.Disconnected;
      }
      getStats(e) {
        var n, i;
        return e ? (i = this.recvConnection) === null || i === void 0 ? void 0 : i.getStats() : (n = this.sendConnection) === null || n === void 0 ? void 0 : n.getStats();
      }
      getRemoteVideoIsReady(e) {
        var n;
        return ((n = this.recvConnection) === null || n === void 0 ? void 0 : n.getRemoteVideoIsReady(e)) || !1;
      }
      getLocalAudioVolume() {
        const e = this.localTrackMap.get(Qt.LocalAudioTrack);
        if (e) return e.track.getVolumeLevel();
      }
      getLocalVideoSize() {
        const e = this.localTrackMap.get(Qt.LocalVideoTrack);
        if (e) return { width: e.track.videoWidth || 0, height: e.track.videoHeight || 0 };
      }
      getEncoderConfig(e) {
        const n = this.localTrackMap.get(e);
        return n && n.track instanceof Wr || n && n.track instanceof li ? n.track._encoderConfig : void 0;
      }
      getLocalMedia(e) {
        return this.localTrackMap.get(e);
      }
      hasLocalMedia() {
        return this.localTrackMap.size > 0;
      }
      hasRemoteMedia(e, n) {
        if (!e) return this.remoteUserMap.size > 0;
        const i = this.remoteUserMap.get(e);
        return !!i && (!n || i.has(n));
      }
      async hasRemoteMediaWithLock(e, n) {
        if (!e) return this.remoteUserMap.size > 0;
        const i = this.remoteUserMap.get(e);
        return !!i && (!n || i.has(n));
      }
      getRemoteMedia(e) {
        var n;
        const i = Array.from(ro(n = this.remoteUserMap).call(n)).find((o) => o.uid === e);
        return i ? { audioTrack: i.audioTrack, audioSSRC: i._audioSSRC, videoTrack: i.videoTrack, videoSSRC: i._videoSSRC } : {};
      }
      getAudioLevels() {
        let e = Array.from(this.remoteUserMap.entries()).map((i) => {
          let [o] = i;
          return { uid: o.uid, level: o.audioTrack ? 100 * o.audioTrack._source.getAccurateVolumeLevel() : 0 };
        });
        const n = this.localTrackMap.get(Qt.LocalAudioTrack);
        return n && e.push({ level: 100 * n.track._source.getAccurateVolumeLevel(), uid: this.store.uid }), e = hE(e).call(e, (i, o) => i.level - o.level), e;
      }
      async disconnectForReconnect() {
        this.sendConnection && this.recvConnection && (Ee.debug("[".concat(this.store.clientId, "] P2PChannel2.disconnectForReconnect closing P2PConnection")), this.state = Ir.Reconnecting, ft("KEEP_LAST_FRAME") && this.remoteUserMap.size !== 0 && Array.from(this.remoteUserMap.entries()).forEach((e) => {
          let [n] = e;
          var i;
          n._videoTrack && n._videoTrack._player && ((i = n._videoTrack._player.getVideoElement()) === null || i === void 0 || i.pause(), n._videoTrack._player.isKeepLastFrame = !0, n._videoTrack._originMediaStreamTrack.stop());
        }), this.sendConnection.close(), this.unbindConnectionEvents(this.sendConnection), this.sendConnection = void 0, this.recvConnection.close(), this.unbindConnectionEvents(this.recvConnection), this.recvConnection = void 0, this.localTrackMap.size !== 0 && (Array.from(this.localTrackMap.entries()).forEach((e) => {
          var n;
          let [i, { track: o }] = e;
          switch (i) {
            case Qt.LocalVideoTrack:
              on(n = o._hints).call(n, Fr.LOW_STREAM) ? o.close() : this.pendingLocalTracks.push(o);
              break;
            case Qt.LocalAudioTrack:
              o instanceof Xi ? this.pendingLocalTracks = this.pendingLocalTracks.concat(o.trackList) : this.pendingLocalTracks.push(o);
            case Qt.LocalVideoLowTrack:
          }
        }), this.emit(wn.MediaReconnectStart, this.store.uid)), this.unbindLocalTrackEvents(), this.localTrackMap.clear(), this.remoteUserMap.size !== 0 && Array.from(this.remoteUserMap.entries()).forEach((e) => {
          let [n, i] = e;
          Array.from(ro(i).call(i)).forEach((o) => {
            this.setPendingRemoteMedia(n, o);
          }), this.emit(wn.MediaReconnectStart, n.uid);
        }), this.unbindAllRemoteTrackEvents(), this.remoteUserMap.clear(), this.stopUploadUplinkState(), this.stopUploadDownlinkState(), this.statsUploader.stopUploadOutboundStats(), this.statsUploader.stopUploadInboundStats(), this.statsUploader.stopUploadTransportStats(), Ee.debug("[".concat(this.store.clientId, "] P2PChannel2 disconnected, waiting to reconnect.")));
      }
      hasPendingRemoteMedia(e, n) {
        for (const i of this.pendingRemoteTracks) {
          const { user: o, kind: f } = i;
          if ((e instanceof cl ? e.uid : e) === o.uid && n === f) return !0;
        }
        return !1;
      }
      setPendingRemoteMedia(e, n) {
        this.hasPendingRemoteMedia(e, n) || this.pendingRemoteTracks.push({ user: e, kind: n });
      }
      async restartICE(e, n) {
        let i, o;
        if (e === ia.SEND_ONLY) {
          if (!this.sendConnection) throw new Gt(Je.INVALID_OPERATION, "Cannot call P2PChannel2.handleMuteLocalTrack before sendConnection established.");
          i = await this.sendMutex.lock("From P2PChannel.restartICE"), o = this.sendConnection;
        } else {
          if (!this.recvConnection) throw new Gt(Je.INVALID_OPERATION, "Cannot call P2PChannel2.handleMuteLocalTrack before recvConnection established.");
          i = await this.recvMutex.lock("From P2PChannel.restartICE"), o = this.recvConnection;
        }
        try {
          if (n) {
            const f = await o.restartICE(n);
            return o.isInRestartIce = !1, f;
          }
          {
            const f = await o.restartICE();
            if (f) {
              const T = await Ss(this, wn.RequestP2PRestartICE, { direction: ia.RECEIVE_ONLY, iceParameter: f });
              await o.restartICE(T), o.isInRestartIce = !1;
            }
          }
        } finally {
          i();
        }
      }
      getUplinkNetworkQuality() {
        if (!this.sendConnection) return 0;
        const e = this.sendConnection.getStats(), n = this.localTrackMap.get(Qt.LocalVideoTrack), i = this.localTrackMap.get(Qt.LocalAudioTrack), o = e.videoSend.find((oe) => {
          var He;
          return oe.ssrc === (n == null || (He = n.ssrcs) === null || He === void 0 ? void 0 : He[0].ssrcId);
        }), f = e.audioSend.find((oe) => {
          var He;
          return oe.ssrc === (i == null || (He = i.ssrcs) === null || He === void 0 ? void 0 : He[0].ssrcId);
        });
        if (!o || !f) return 1;
        const T = to(this, wn.NeedSignalRTT), A = o ? o.rttMs : void 0, R = f ? f.rttMs : void 0, P = A && R ? (A + R) / 2 : A || R, L = (P && T ? (P + T) / 2 : P || T) || 0, z = 100 * e.sendPacketLossRate * 0.7 / 50 + 0.3 * L / 1500, Y = z < 0.17 ? 1 : z < 0.36 ? 2 : z < 0.59 ? 3 : z < 0.1 ? 4 : 5, te = n == null ? void 0 : n.track;
        if (te && te._encoderConfig && te._hints.indexOf(Fr.SCREEN_TRACK) === -1) {
          const oe = te._encoderConfig.bitrateMax, He = e.bitrate.actualEncoded;
          if (oe && He) {
            const Re = (1e3 * oe - He) / (1e3 * oe);
            return D8[Re < 0.15 ? 0 : Re < 0.3 ? 1 : Re < 0.45 ? 2 : Re < 0.6 ? 3 : 4][Y];
          }
        }
        return Y;
      }
      getDownlinkNetworkQuality() {
        if (!this.recvConnection) return 0;
        const e = this.recvConnection.getStats();
        let n = 0;
        return Array.from(this.remoteUserMap.entries()).forEach((i) => {
          let [o] = i;
          const f = o._audioSSRC, T = o._videoSSRC, A = e.audioRecv.find((He) => He.ssrc === f), R = e.videoRecv.find((He) => He.ssrc === T);
          if (!A && !R) return void (n += 1);
          const P = to(this, wn.NeedSignalRTT), L = e.rtt, z = (L && P ? (L + P) / 2 : L || P) || 0, Y = A ? A.jitterMs : void 0, te = e.recvPacketLossRate;
          let oe = 0.7 * te * 100 / 50 + 0.3 * z / 1500;
          Y && (oe = 0.6 * te * 100 / 50 + 0.2 * z / 1500 + 0.2 * Y / 400), n += oe < 0.1 ? 1 : oe < 0.17 ? 2 : oe < 0.36 ? 3 : oe < 0.59 ? 4 : 5;
        }), this.remoteUserMap.size > 0 ? Math.round(n / this.remoteUserMap.size) : n;
      }
      async muteLocalTrack(e) {
        return new cn((n, i) => {
          this.handleMuteLocalTrack(e, n, i);
        });
      }
      filterTobePublishedTracks(e, n, i) {
        const o = [], f = pr(), T = this.getAllTracks();
        e = np(e = e.filter((P) => T.indexOf(P) === -1));
        let A = !1, R = !1;
        for (const P of e) {
          if (P instanceof Wr && (this.localTrackMap.has(Qt.LocalVideoTrack) || A ? new Gt(Je.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS).throw() : (o.push({ track: P, type: Qt.LocalVideoTrack }), A = !0), n)) {
            const L = this.getLowVideoTrack(P, i);
            o.push({ track: L, type: Qt.LocalVideoLowTrack });
          }
          if (P instanceof li) {
            const L = this.localTrackMap.get(Qt.LocalAudioTrack);
            if (L) {
              if (!(L.track instanceof Xi)) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser does not support audio mixing");
              if (P._bypassWebAudio) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");
              L.track.addAudioTrack(P), this.bindLocalAudioTrackEvents(P, !0);
            } else if (R) {
              const z = o.find((Y) => {
                let { type: te } = Y;
                return te === Qt.LocalAudioTrack;
              });
              if (!(z.track instanceof Xi)) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser does not support audio mixing");
              if (P._bypassWebAudio) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio");
              z.track.addAudioTrack(P);
            } else {
              if (!f.webAudioMediaStreamDest || P instanceof Xi || P._bypassWebAudio) o.push({ track: P, type: Qt.LocalAudioTrack });
              else {
                const z = new Xi();
                z.addAudioTrack(P), o.push({ track: z, type: Qt.LocalAudioTrack });
              }
              R = !0;
            }
          }
        }
        return o;
      }
      filterTobeUnpublishedTracks(e) {
        const n = [], i = this.getAllTracks();
        e = np(e = e.filter((o) => i.indexOf(o) !== -1));
        for (const o of e) {
          if (o instanceof li) {
            const f = this.localTrackMap.get(Qt.LocalAudioTrack);
            if (!f) continue;
            f.track instanceof Xi ? (f.track.removeAudioTrack(o), this.unbindLocalAudioTrackEvents(o), f.track.trackList.length === 0 && (n.push([Qt.LocalAudioTrack, f]), f.track.close())) : n.push([Qt.LocalAudioTrack, f]);
          }
          if (o instanceof Wr) {
            const f = this.localTrackMap.get(Qt.LocalVideoTrack);
            if (!f) continue;
            n.push([Qt.LocalVideoTrack, f]);
            const T = this.localTrackMap.get(Qt.LocalVideoLowTrack);
            T && n.push([Qt.LocalVideoLowTrack, T]);
          }
        }
        return n;
      }
      bindLocalTrackEvents(e) {
        e.forEach((n) => {
          let { track: i, type: o } = n;
          switch (o) {
            case Qt.LocalVideoTrack:
              i.addListener(Tn.GET_STATS, this.handleGetLocalVideoStats), i.addListener(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), i.addListener(Tn.NEED_UPDATE_VIDEO_ENCODER, this.handleUpdateVideoEncoder), i.addListener(Tn.NEED_UPDATE_VIDEO_SEND_PARAMETERS, this.handleUpdateVideoSendParameters), i.addListener(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), i.addListener(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
              break;
            case Qt.LocalAudioTrack:
              this.bindLocalAudioTrackEvents(i);
            case Qt.LocalVideoLowTrack:
          }
        });
      }
      bindLocalAudioTrackEvents(e, n) {
        e instanceof Xi ? e.trackList.forEach((i) => {
          i.addListener(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), i.addListener(Tn.GET_STATS, this.handleGetLocalAudioStats), i.addListener(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), i.addListener(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
        }) : (e.addListener(Tn.GET_STATS, this.handleGetLocalAudioStats), e.addListener(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.addListener(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.addListener(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.addListener(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack), n || e.addListener(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack));
      }
      unbindLocalTrackEvents(e) {
        e || (e = Array.from(this.localTrackMap.entries()).map((n) => {
          let [i, { track: o }] = n;
          return { track: o, type: i };
        })), e.forEach((n) => {
          let { track: i, type: o } = n;
          switch (o) {
            case Qt.LocalVideoTrack:
              i.off(Tn.GET_STATS, this.handleGetLocalVideoStats), i.off(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), i.off(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), i.off(Tn.NEED_UPDATE_VIDEO_ENCODER, this.handleUpdateVideoEncoder), i.off(Tn.NEED_UPDATE_VIDEO_SEND_PARAMETERS, this.handleUpdateVideoSendParameters), i.off(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), i.off(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), i.off(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
              break;
            case Qt.LocalAudioTrack:
              this.unbindLocalAudioTrackEvents(i);
            case Qt.LocalVideoLowTrack:
          }
        });
      }
      unbindLocalAudioTrackEvents(e) {
        e instanceof Xi ? e.trackList.forEach((n) => {
          n.off(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), n.off(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), n.off(Tn.GET_STATS, this.handleGetLocalAudioStats), n.off(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), n.off(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack);
        }) : (e.off(Tn.GET_STATS, this.handleGetLocalAudioStats), e.off(Tn.NEED_DISABLE_TRACK, this.handleMuteLocalTrack), e.off(Tn.NEED_ENABLE_TRACK, this.handleUnmuteLocalTrack), e.off(Tn.NEED_REPLACE_TRACK, this.handleReplaceTrack), e.off(Tn.NEED_MUTE_TRACK, this.handleMuteLocalTrack), e.off(Tn.NEED_UNMUTE_TRACK, this.handleUnmuteLocalTrack));
      }
      bindRemoteTrackEvents(e, n) {
        n instanceof mp && n.addListener(Tn.GET_STATS, (i) => {
          i(this.handleGetRemoteVideoStats(e));
        }), n instanceof Ep && n.addListener(Tn.GET_STATS, (i) => {
          i(this.handleGetRemoteAudioStats(e));
        });
      }
      unbindRemoteTrackEvents(e) {
        e && e.removeAllListeners(Tn.GET_STATS);
      }
      unbindAllRemoteTrackEvents() {
        Array.from(this.remoteUserMap.entries()).forEach((e) => {
          let [n, i] = e;
          i.has(vn.AUDIO) && this.unbindRemoteTrackEvents(n._audioTrack), i.has(vn.VIDEO) && this.unbindRemoteTrackEvents(n._videoTrack);
        });
      }
      createGatewayPublishMessage(e, n) {
        return e.map((i, o) => {
          var f;
          let T, { track: A, type: R } = i;
          switch (R) {
            case Qt.LocalAudioTrack:
              T = Sr.Audio;
              break;
            case Qt.LocalVideoTrack:
              T = on(f = A._hints).call(f, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalVideoLowTrack:
              T = Sr.Low;
          }
          return { kind: R === Qt.LocalAudioTrack ? vn.AUDIO : vn.VIDEO, stream_type: T, mid: n[o].id, ssrcs: n[o].localSSRC, isMuted: A.muted || !A.enabled };
        });
      }
      createGatewayUnpublishMessage(e) {
        return e.map((n) => {
          var i;
          let o, [f, { track: T, ssrcs: A, id: R }] = n;
          switch (f) {
            case Qt.LocalVideoTrack:
              o = on(i = T._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalAudioTrack:
              o = Sr.Audio;
              break;
            case Qt.LocalVideoLowTrack:
              o = Sr.Low;
          }
          return { stream_type: o, ssrcs: A, mid: R };
        });
      }
      assignLocalTracks(e, n) {
        e.forEach((i, o) => {
          let { track: f, type: T } = i;
          this.localTrackMap.set(T, { track: f, id: n[o].id, ssrcs: n[o].localSSRC });
        });
      }
      withdrawLocalTracks(e) {
        e.forEach((n) => {
          let [i] = n;
          this.localTrackMap.delete(i);
        });
      }
      bindConnectionEvents(e) {
        e.onConnectionStateChange = async (n) => {
          var i;
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: ").concat(e.name, ".onConnectionStateChange(").concat(n, ")")), this.emit(wn.PeerConnectionStateChange, n), n !== "connected" || this.store.keyMetrics.peerConnectionEnd || this.store.peerConnectionEnd(), n === "connected" && (e.isInRestartIce = !1), on(i = this._restartStates).call(i, n) && !e.isInRestartIce && (n === "disconnected" && await Es(800), e.iceConnectionState !== "disconnected" && e.iceConnectionState !== "failed" || this.handleDisconnect(e.direction));
        }, e.onICEConnectionStateChange = (n) => {
          n !== "connected" || this.store.keyMetrics.iceConnectionEnd || this.store.iceConnectionEnd(), Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onICEConnectionStateChange(").concat(n, ")")), Cn.reportApiInvoke(this.store.sessionId, { name: "ICEConnectionStateChange", options: n, tag: si.TRACER }).onSuccess(), this.emit(wn.IceConnectionStateChange, n);
        }, e.onICETransportStateChange = (n) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onICETransportStateChange(").concat(n, ")"));
        }, e.onDTLSTransportStateChange = (n) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onDTLSTransportStateChange(").concat(n, ")"));
        }, e.onDTLSTransportError = (n) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.onDTLSTransportError(").concat(n, ")"));
        }, e.onFirstAudioDecoded = (n) => {
          var i;
          const o = Array.from(ro(i = this.remoteUserMap).call(i)).find((T) => T._audioSSRC === n);
          var f;
          o && (this.store.subscribe(o.uid, "audio", void 0, void 0, void 0, Date.now()), (f = o.audioTrack) === null || f === void 0 || f.emit(lp.FIRST_FRAME_DECODED), Cn.firstRemoteFrame(this.store.sessionId, us.FIRST_AUDIO_DECODE, ti.FIRST_AUDIO_DECODE, { peer: o._uintid, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, n), subscribeRequestid: n, p2pid: this.store.p2pId }));
        }, e.onFirstAudioReceived = (n) => {
          var i;
          const o = Array.from(ro(i = this.remoteUserMap).call(i)).find((f) => f._audioSSRC === n);
          o && Cn.firstRemoteFrame(this.store.sessionId, us.FIRST_AUDIO_RECEIVED, ti.FIRST_AUDIO_RECEIVED, { peer: o._uintid, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, n), subscribeRequestid: n, p2pid: this.store.p2pId });
        }, e.onFirstVideoDecoded = (n, i, o) => {
          this.reportVideoFirstFrameDecoded(n, i, o);
        }, e.onFirstVideoReceived = (n) => {
          var i;
          const o = Array.from(ro(i = this.remoteUserMap).call(i)).find((f) => f._videoSSRC === n);
          o && Cn.firstRemoteFrame(this.store.sessionId, us.FIRST_VIDEO_RECEIVED, ti.FIRST_VIDEO_RECEIVED, { peer: o._uintid, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, n), subscribeRequestid: n, p2pid: this.store.p2pId });
        }, e.onSelectedLocalCandidateChanged = (n, i) => {
          const o = n.candidateType === "relay", f = i.candidateType === "relay";
          i.candidateType !== "unknown" && o === f || this.emit(wn.ConnectionTypeChange, o), Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.SelectedLocalCandidateChanged(").concat(JSON.stringify(sl(i)), " -> ").concat(JSON.stringify(sl(n)), ")"));
        }, e.onSelectedRemoteCandidateChanged = (n, i) => {
          Ee.info("[".concat(this.store.clientId, "] [p2pId: ").concat(this.store.p2pId, "]: P2PConnection.SelectedRemoteCandidateChanged(").concat(JSON.stringify(sl(i)), " -> ").concat(JSON.stringify(sl(n)), ")"));
        }, e.onFirstVideoDecodedTimeout = (n) => {
          this.reportVideoFirstFrameDecoded(n, void 0, void 0, !0);
        }, e.onLocalCandidate = (n) => {
          this.emit(wn.LocalCandidate, { candidate: n, direction: e.direction });
        };
      }
      unbindConnectionEvents(e) {
        e.onConnectionStateChange = void 0, e.onICEConnectionStateChange = void 0, e.onICETransportStateChange = void 0, e.onDTLSTransportStateChange = void 0, e.onDTLSTransportError = void 0, e.onFirstAudioDecoded = void 0, e.onFirstAudioReceived = void 0, e.onFirstVideoDecoded = void 0, e.onFirstVideoReceived = void 0, e.onSelectedLocalCandidateChanged = void 0, e.onSelectedRemoteCandidateChanged = void 0, e.onFirstVideoDecodedTimeout = void 0, e.onLocalCandidate = void 0;
      }
      async handleDisconnect(e) {
        const n = e === ia.SEND_ONLY ? this.sendConnection : this.recvConnection;
        n && !n.isInRestartIce && (n.isInRestartIce = !0, Ee.debug("[".concat(this.store.clientId, "] [P2PChannel-").concat(n.name, "] start use restartICE")), e === ia.SEND_ONLY ? this.restartICE(e) : Ss(this, wn.RequestP2PRestartICE, { direction: ia.SEND_ONLY }));
      }
      filterTobeMutedTracks(e) {
        const n = [];
        if (this.getAllTracks().indexOf(e) === -1) return n;
        const i = this.localTrackMap.get(Qt.LocalAudioTrack);
        if (e instanceof li && (i == null ? void 0 : i.track) instanceof Xi) return i.track.isActive || n.push([Qt.LocalAudioTrack, i]), n;
        const o = Array.from(this.localTrackMap.entries()).find((f) => {
          let [, { track: T }] = f;
          return e === T;
        });
        if (o && (n.push(o), o[0] === Qt.LocalVideoTrack)) {
          const f = this.localTrackMap.get(Qt.LocalVideoLowTrack);
          f && n.push([Qt.LocalVideoLowTrack, f]);
        }
        return n;
      }
      filterTobeUnmutedTracks(e) {
        const n = [], i = this.localTrackMap.get(Qt.LocalAudioTrack);
        if (e instanceof li && (i == null ? void 0 : i.track) instanceof Xi) return i.track.isActive && n.push([Qt.LocalAudioTrack, i]), n;
        const o = Array.from(this.localTrackMap.entries()).find((f) => {
          let [, { track: T }] = f;
          return e === T;
        });
        if (o) if (o[0] === Qt.LocalVideoTrack) {
          n.push(o);
          const f = this.localTrackMap.get(Qt.LocalVideoLowTrack);
          f && n.push([Qt.LocalVideoLowTrack, f]);
        } else n.push(o);
        return n;
      }
      createMuteMessage(e) {
        return e.map((n) => {
          var i;
          let o, [f, { track: T, ssrcs: A, id: R }] = n;
          switch (f) {
            case Qt.LocalAudioTrack:
              o = Sr.Audio;
              break;
            case Qt.LocalVideoTrack:
              o = on(i = T._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalVideoLowTrack:
              o = Sr.Low;
          }
          return { stream_type: o, ssrcs: A, mid: R };
        });
      }
      createUnmuteMessage(e) {
        return e.map((n) => {
          var i;
          let o, [f, { track: T, ssrcs: A, id: R }] = n;
          switch (f) {
            case Qt.LocalAudioTrack:
              o = Sr.Audio;
              break;
            case Qt.LocalVideoTrack:
              o = on(i = T._hints).call(i, Fr.SCREEN_TRACK) ? Sr.Screen : Sr.High;
              break;
            case Qt.LocalVideoLowTrack:
              o = Sr.Low;
          }
          return { stream_type: o, ssrcs: A, mid: R };
        });
      }
      filterTobeUnSubscribedTracks(e, n) {
        const i = [], o = this.remoteUserMap.get(e);
        if (!o) return i;
        if (n) {
          const f = o.get(n);
          if (!f) return i;
          i.push([e, { kind: n, id: f }]);
        } else Array.from(o.entries()).forEach((f) => {
          let [T, A] = f;
          i.push([e, { kind: T, id: A }]);
        });
        return i;
      }
      createUnsubscribeMessage(e) {
        const n = [];
        return e.forEach((i) => {
          let [o, { kind: f, id: T }] = i;
          switch (f) {
            case vn.VIDEO:
              return void (o._videoSSRC && n.push({ stream_type: vn.VIDEO, ssrcId: o._videoSSRC }));
            case vn.AUDIO:
              return void (o._audioSSRC && n.push({ stream_type: vn.AUDIO, ssrcId: o._audioSSRC }));
          }
        }), n;
      }
      withdrawRemoteTracks(e) {
        e.forEach((n) => {
          let [i, { kind: o }] = n;
          const f = this.remoteUserMap.get(i);
          f && (f.delete(o), Array.from(f.entries()).length === 0 && this.remoteUserMap.delete(i));
        });
      }
      async updateBitrateLimit(e) {
        const n = this.localTrackMap.get(Qt.LocalVideoTrack), i = this.localTrackMap.get(Qt.LocalVideoLowTrack);
        n && (await n.track.setBitrateLimit(e.uplink), await new cn((o, f) => {
          this.handleUpdateVideoEncoder(n.track, o, f, !0);
        })), i && e.low_stream_uplink && (await i.track.setBitrateLimit({ max_bitrate: e.low_stream_uplink.bitrate, min_bitrate: e.low_stream_uplink.bitrate || 0 }), await new cn((o, f) => {
          this.handleUpdateVideoEncoder(i.track, o, f, !0);
        }));
      }
      isP2PDisconnected() {
        if (this.sendConnection && this.recvConnection) {
          const e = this.sendConnection.peerConnectionState, n = this.recvConnection.peerConnectionState;
          return e !== "connected" && n !== "connected";
        }
        return !0;
      }
      async tryToUnmuteAudio(e) {
        for (let n = 0; n < e.length; n++) if (e[n] instanceof li) {
          const i = this.filterTobeUnmutedTracks(e[n]);
          if (i.length === 0) continue;
          const o = this.createUnmuteMessage(i);
          return void await Br(this, wn.RequestUnmuteLocal, o);
        }
      }
      bindStatsUploaderEvents() {
        this.statsUploader.requestStats = (e) => this.getStats(e), this.statsUploader.requestLocalMedia = () => Array.from(this.localTrackMap.entries()).filter((e) => {
          let [, { ssrcs: n }] = e;
          return !!n;
        }), this.statsUploader.requestRemoteMedia = () => Array.from(this.remoteUserMap.entries()), this.statsUploader.requestVideoIsReady = (e) => {
          var n;
          return !((n = this.recvConnection) === null || n === void 0 || !n.getRemoteVideoIsReady(e));
        }, this.statsUploader.requestUpload = (e, n) => this.emit(wn.RequestUpload, e, n), this.statsUploader.requestUploadStats = (e) => this.emit(wn.RequestUploadStats, e), this.statsUploader.requestAllTracks = () => this.getAllTracks();
      }
      unbindStatsUploaderEvents() {
        this.statsUploader.requestStats = void 0, this.statsUploader.requestLocalMedia = void 0, this.statsUploader.requestRemoteMedia = void 0, this.statsUploader.requestVideoIsReady = void 0;
      }
      async requestReconnect() {
        this.dtlsFailedCount += 1, await Es(HS(this.dtlsFailedCount, zi)), this.emit(wn.RequestReconnect);
      }
      async reconnectP2P() {
      }
      canPublishLowStream() {
        return this.localTrackMap.has(Qt.LocalVideoTrack) || this.pendingLocalTracks.some((e) => e instanceof Wr);
      }
      throwIfTrackTypeNotMatch(e) {
        if (e.filter((n) => n instanceof Wr).length > 1) throw new Gt(Je.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
        if (e.filter((n) => n instanceof li).length > 1 && (e.some((n) => n instanceof li && n._bypassWebAudio) || !pr().webAudioMediaStreamDest)) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");
        for (const n of e) {
          if (n instanceof Wr && this.pendingLocalTracks.some((i) => i instanceof Wr)) throw new Gt(Je.CAN_NOT_PUBLISH_MULTIPLE_VIDEO_TRACKS);
          if (n instanceof li && this.pendingLocalTracks.some((i) => i instanceof li) && (!pr().webAudioMediaStreamDest || n._bypassWebAudio || this.pendingLocalTracks.some((i) => i instanceof li && i._bypassWebAudio))) throw new Gt(Je.NOT_SUPPORTED, "cannot publish multiple tracks which one of them configured with bypassWebAudio or your browser doesn't support MediaStreamDestNode");
        }
      }
      getLowVideoTrack(e, n) {
        const i = !ft("DISABLE_DUAL_STREAM_USE_ENCODING") && pr().supportDualStreamEncoding, o = y0(y0({}, { width: 160, height: 120, framerate: 15, bitrate: 50 }), n);
        let f;
        f = i ? e._mediaStreamTrack.clone() : UI(e, o);
        const T = zr(8, "track-low-"), A = new Wr(f, y0(y0({}, i && { scaleResolutionDownBy: bI(o, e) }), {}, { frameRate: o.framerate, bitrateMax: o.bitrate, bitrateMin: o.bitrate }), void 0, void 0, T);
        return A.on(Af.TRANSCEIVER_UPDATED, (R) => {
          e._updateRtpTransceiver(R, up.LOW_STREAM);
        }), A._hints.push(Fr.LOW_STREAM), e.addListener(Tn.NEED_CLOSE, () => {
          A.close();
        }), A;
      }
      async globalLock() {
        return this.recvMutex.lock("From P2PChannel2.globalLock");
      }
      reportVideoFirstFrameDecoded(e, n, i, o) {
        var f;
        const T = Array.from(ro(f = this.remoteUserMap).call(f)).find((A) => A._videoSSRC === e);
        if (T) {
          o || this.store.subscribe(T.uid, "video", void 0, void 0, void 0, void 0, Date.now());
          const A = this.store.keyMetrics, R = A.subscribe.find((P) => P.userId === T.uid && P.type === "video");
          Cn.firstRemoteVideoDecode(this.store.sessionId, us.FIRST_VIDEO_DECODE, ti.FIRST_VIDEO_DECODE, { peer: T._uintid, videowidth: n, videoheight: i, subscribeElapse: Ms.measureFromSubscribeStart(this.store.clientId, e), subscribeRequestid: e, p2pid: this.store.p2pId, apEnd: A.requestAPEnd || 0, apStart: A.requestAPStart || 0, joinGwEnd: A.joinGatewayEnd || 0, joinGwStart: A.joinGatewayStart || 0, pcEnd: A.peerConnectionEnd || 0, pcStart: A.peerConnectionStart || 0, subscriberEnd: (R == null ? void 0 : R.subscribeEnd) || 0, subscriberStart: (R == null ? void 0 : R.subscribeStart) || 0, videoAddNotify: (R == null ? void 0 : R.streamAdded) || 0, state: o ? 1 : 0 });
        }
      }
      async remoteMediaSsrcChanged(e, n, i) {
        if (!this.recvConnection) return !1;
        const o = this.remoteUserMap.get(e);
        if (!o) return !1;
        const f = o.get(n);
        if (!f) return !1;
        const T = await this.recvConnection.getRemoteSSRC(f);
        return T !== void 0 && T !== i;
      }
      isPreSubScribe(e) {
        return !1;
      }
      async publishDataChannel(e) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      async unpublishDataChannel(e) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      async subscribeDataChannel(e, n) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      async unsubscribeDataChannel(e, n) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      hasPendingRemoteDataChannel(e, n) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      setPendingRemoteDataChannel(e, n) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      async preConnect(e) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      getEstablishParams() {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      async reSubscribe(e) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      async updateVideoStreamParameter(e, n) {
        throw new Gt(Je.NOT_SUPPORTED);
      }
      unbindRtpTransceiver() {
        this.localTrackMap.size !== 0 && Array.from(this.localTrackMap.entries()).forEach((e) => {
          let [n, { track: i }] = e;
          n === Qt.LocalVideoLowTrack ? i._updateRtpTransceiver(void 0, up.LOW_STREAM) : i._updateRtpTransceiver(void 0);
        });
      }
    }, bn(Qr.prototype, "p2pConnect", [b9], Object.getOwnPropertyDescriptor(Qr.prototype, "p2pConnect"), Qr.prototype), bn(Qr.prototype, "unpublish", [A9], Object.getOwnPropertyDescriptor(Qr.prototype, "unpublish"), Qr.prototype), bn(Qr.prototype, "unpublishLowStream", [O9], Object.getOwnPropertyDescriptor(Qr.prototype, "unpublishLowStream"), Qr.prototype), bn(Qr.prototype, "subscribe", [C9], Object.getOwnPropertyDescriptor(Qr.prototype, "subscribe"), Qr.prototype), bn(Qr.prototype, "mockSubscribe", [S9], Object.getOwnPropertyDescriptor(Qr.prototype, "mockSubscribe"), Qr.prototype), bn(Qr.prototype, "unsubscribe", [I9], Object.getOwnPropertyDescriptor(Qr.prototype, "unsubscribe"), Qr.prototype), bn(Qr.prototype, "muteRemote", [R9], Object.getOwnPropertyDescriptor(Qr.prototype, "muteRemote"), Qr.prototype), bn(Qr.prototype, "unmuteRemote", [N9], Object.getOwnPropertyDescriptor(Qr.prototype, "unmuteRemote"), Qr.prototype), bn(Qr.prototype, "hasRemoteMediaWithLock", [w9], Object.getOwnPropertyDescriptor(Qr.prototype, "hasRemoteMediaWithLock"), Qr.prototype), bn(Qr.prototype, "disconnectForReconnect", [_9], Object.getOwnPropertyDescriptor(Qr.prototype, "disconnectForReconnect"), Qr.prototype), bn(Qr.prototype, "remoteMediaSsrcChanged", [P9], Object.getOwnPropertyDescriptor(Qr.prototype, "remoteMediaSsrcChanged"), Qr.prototype), Qr);
    function Fc(e) {
      return function(n, i, o) {
        const f = n[i];
        if (typeof f != "function") throw new Error("Cannot use mutex on object property.");
        return o.value = async function() {
          for (var T = arguments.length, A = new Array(T), R = 0; R < T; R++) A[R] = arguments[R];
          switch (e) {
            case zc.SEND_ONLY: {
              const P = await this.sendMutex.lock("From P2PChannel2.".concat(i));
              try {
                return await f.apply(this, A);
              } finally {
                P();
              }
            }
            case zc.RECEIVE_ONLY: {
              const P = await this.recvMutex.lock("From P2PChannel2.".concat(i));
              try {
                return await f.apply(this, A);
              } finally {
                P();
              }
            }
            default: {
              const P = await this.sendMutex.lock("From P2PChannel2.".concat(i)), L = await this.recvMutex.lock("From P2PChannel2.".concat(i));
              try {
                return await f.apply(this, A);
              } finally {
                P(), L();
              }
            }
          }
        }, o;
      };
    }
    class Ff extends ii {
      constructor(n, i) {
        super(), Ve(this, "signal", void 0), Ve(this, "token", void 0), Ve(this, "tokenTimeout", void 0), Ve(this, "tokenInterval", void 0), Ve(this, "_sequence", 0), Ve(this, "userMap", /* @__PURE__ */ new Map()), Ve(this, "encoder", new TextEncoder()), this.signal = n, this.token = i;
        const o = () => {
          this.signal.connectionState === Vr.CONNECTED && this.check(), this.userMap.size === 0 ? this.tokenInterval = window.setTimeout(o, 1e3) : this.tokenInterval = window.setTimeout(o, 3 * ft("P2P_TOKEN_INTERVAL"));
        };
        o();
      }
      async send(n, i, o, f, T) {
        var A, R, P;
        if (this.userMap.size === 0) return;
        const L = Array.from(nd(A = this.userMap).call(A))[0].token;
        typeof i != "string" && (i = JSON.stringify(i)), f = (R = f) !== null && R !== void 0 ? R : zr(6, ""), T = (P = T) !== null && P !== void 0 ? P : this._sequence++;
        const z = { _id: f, _type: n, _seq: T, _message: i, token: "".concat(this.token, "_").concat(L) };
        ft("SHOW_P2P_LOG") && Ee.debug("send message", z, "noNeedResponse : ".concat(o)), this.splitMessage(JSON.stringify(z)).forEach((te) => {
          this.signal.request(kn.DATA_STREAM, { payload: tl(this.encoder.encode(te)) });
        });
        const Y = new cn((te, oe) => {
          const He = window.setTimeout(() => {
            this.off("res-@".concat(f, "_ack"), Re), this.off("res-@".concat(f), Xe), this.off(Tp.ABORT, De), Ee.debug("[external-signal] request timeout, type: ".concat(n, ", requestId: ").concat(f)), this.userMap.size === 0 ? oe(new Gt(Je.INVALID_REMOTE_USER)) : oe(new Gt(Je.TIMEOUT));
          }, ft("EXTERNAL_SIGNAL_REQUEST_TIMEOUT")), Re = () => {
            He && window.clearTimeout(He), this.off(Tp.ABORT, De), o && te();
          }, De = () => {
            He && window.clearTimeout(He), this.off("res-@".concat(f, "_ack"), Re), this.off("res-@".concat(f), Xe), oe(new Gt(Je.EXTERNAL_SIGNAL_ABORT, "type: ".concat(n, ", requestId: ").concat(f)));
          };
          this.once(Tp.ABORT, De), this.once("res-@".concat(f, "_ack"), Re);
          const Xe = (mt, Pt) => {
            We = !0, He && window.clearTimeout(He), this.off("res-@".concat(f, "_ack"), Re), this.off(Tp.ABORT, De), mt === "success" ? te(Pt) : oe(new Gt(Je.P2P_MESSAGE_FAILED, "request ".concat(n, " failed, requestId: ").concat(f)));
          };
          let We = !1;
          o || (this.once("res-@".concat(f), Xe), Es(ft("SIGNAL_REQUEST_TIMEOUT")).then(() => {
            We || Ee.warning("external_signal request timeout, type: ".concat(n, ", requestId: ").concat(f, ", ").concat(z));
          }));
        });
        try {
          return await Y;
        } catch (te) {
          if (te.code === Je.TIMEOUT) return await this.send(n, i, o, f, T);
          throw te;
        }
      }
      onMessage(n) {
        var i;
        const { _uid: o } = n;
        let f, T = this.userMap.get(o);
        if (T) f = T.splitMessageMap;
        else {
          if (this.userMap.size > 0 || !("_type" in n) || n._type !== bi.CHECK) return;
          const { token: L } = n;
          f = /* @__PURE__ */ new Map(), T = { uid: o, isStart: !0, token: L, splitMessageMap: f, nextExpectedSequenceNumber: 0, receivedMessagesMap: /* @__PURE__ */ new Map() }, this.userMap.set(o, T), this.signal.emit(nr.ON_USER_ONLINE, { uid: o }), this.handleUserOnline();
        }
        if ("id" in n && "total" in n) {
          var A;
          const { id: L, total: z } = n, Y = (A = f.get(L)) !== null && A !== void 0 ? A : [];
          if (Y.push(n), f.has(L) || f.set(L, Y), Y.length !== z) return;
          {
            const te = hE(Y).call(Y, (oe, He) => oe.index - He.index).map((oe) => oe.payload).join("");
            f.delete(L), (n = JSON.parse(te))._uid = o;
          }
        }
        const { _type: R, token: P } = n;
        if (on(i = [bi.ACK, bi.CHECK]).call(i, R)) return R === bi.CHECK && this.handleCheckToken(T, P), void this.receiveMessage(n);
        P === "".concat(T.token, "_").concat(this.token) ? this.handleReceivedMessage(n) : Ee.debug('Receive unexpected message", '.concat(P, ", cur_token: ").concat(T.token, "_").concat(this.token), n);
      }
      check() {
        const n = { _id: zr(6, ""), token: this.token, _type: bi.CHECK };
        ft("SHOW_P2P_LOG") && Ee.debug("send message", n), this.signal.request(kn.DATA_STREAM, { payload: tl(this.encoder.encode(JSON.stringify(n))) });
      }
      ack(n) {
        const i = { _id: n, _type: bi.ACK, token: this.token };
        ft("SHOW_P2P_LOG") && Ee.debug("send message", i), this.signal.request(kn.DATA_STREAM, { payload: tl(this.encoder.encode(JSON.stringify(i))) });
      }
      response(n, i, o) {
        this.send(bi.RESPONSE, JSON.stringify({ success: !o, message: i }), !0, n);
      }
      handleReceivedMessage(n) {
        const i = () => {
          this.userMap.forEach((L) => {
            const { receivedMessagesMap: z, nextExpectedSequenceNumber: Y } = L;
            for (; z.has(Y); ) {
              const te = z.get(Y);
              z.delete(Y), this.receiveMessage(te), L.nextExpectedSequenceNumber++;
            }
          });
        };
        if (!n) return void i();
        const { _uid: o, _seq: f } = n, T = this.userMap.get(o), { receivedMessagesMap: A, isStart: R, nextExpectedSequenceNumber: P } = T;
        if (f < P) return this.ack(n._id), void Ee.debug("[external-signal] receive old message, seq: ".concat(f, ", ").concat(n._message));
        A.set(f, n), R && f === P && (this.receiveMessage(n), A.delete(P), T.nextExpectedSequenceNumber++, i());
      }
      receiveMessage(n) {
        const { _id: i, _type: o, _message: f, _uid: T } = n;
        if (ft("SHOW_P2P_LOG") && Ee.debug("receive message", n), i) {
          let A;
          switch (n._type !== bi.ACK && (f && (A = JSON.parse(f)), this.ack(n._id)), n._type) {
            case bi.CANDIDATE:
            case bi.CONTROL:
              this.signal.emit(o, A, T);
              break;
            case bi.PUBLISH:
            case bi.UNPUBLISH:
            case bi.RESTART_ICE:
            case bi.CALL:
              A.uid = T, Ss(this.signal, o, A).then((R) => {
                this.response(n._id, R);
              }).catch(() => {
                this.response(n._id, void 0, !0);
              });
              break;
            case bi.ACK:
              this.getListeners("res-@".concat(i, "_ack")).length > 0 && this.emit("res-@".concat(i, "_ack"));
              break;
            case bi.RESPONSE: {
              const { success: R, message: P } = A;
              this.emit("res-@".concat(i), R ? "success" : "failed", P);
              break;
            }
          }
        }
      }
      splitMessage(n) {
        if (n.length < Ff.MAX_MESSAGE_SIZE) return [n];
        const i = [], { remoteToken: o } = JSON.parse(n), f = zr(6, "");
        let T = 0, A = 800;
        const R = Math.ceil(n.length / A);
        for (; n.length > 0; ) {
          T++;
          const P = { id: f, index: T, total: R, payload: n.slice(0, A), token: "".concat(this.token, "_").concat(o) };
          JSON.stringify(P).length > Ff.MAX_MESSAGE_SIZE ? A -= 50 : (i.push(P), n = n.slice(A));
        }
        return i.map((P) => JSON.stringify(P));
      }
      handleCheckToken(n, i) {
        return n.token !== i ? (Ee.debug("token changed, from ".concat(n.token, " to ").concat(i)), this.reset(n.uid, i), !1) : (this.tokenTimeout && (window.clearTimeout(this.tokenTimeout), this.tokenTimeout = void 0), this.tokenTimeout = window.setTimeout(() => {
          Ee.debug("token timeout, ".concat(i)), this.reset(n.uid);
        }, ft("MAX_P2P_TIMEOUT")), !0);
      }
      async handleUserOnline() {
        const n = await Ss(this.signal, bi.CALL, void 0), i = await this.send(bi.CALL, n);
        this.signal.emit(jn.P2P_CONNECTION, i, !0);
      }
      async reset(n, i) {
        const o = this.userMap.get(n);
        o && (this.emit(Tp.ABORT), this.signal.emit(nr.ON_USER_OFFLINE, { uid: o.uid, reason: tae.P2P_TOKEN_CHANGED }), this._sequence = 0, this.userMap.clear(), i || (Ee.debug("change local token from ".concat(i, " to ").concat(i)), this.token = zr(6, "")));
      }
      clear() {
        this._sequence = 0, this.userMap.clear(), this.tokenInterval && window.clearTimeout(this.tokenInterval), this.tokenInterval = void 0, this.tokenTimeout && window.clearTimeout(this.tokenTimeout), this.tokenTimeout = void 0, this.emit(Tp.ABORT);
      }
    }
    Ve(Ff, "MAX_SIZE", 1), Ve(Ff, "MAX_MESSAGE_SIZE", 1024);
    class Mce extends ii {
      get connectionState() {
        return this._connectionState;
      }
      set connectionState(n) {
        n !== this._connectionState && (this._connectionState = n, n === Vr.CONNECTED ? this.emit(jn.WS_CONNECTED) : n === Vr.RECONNECTING ? this.emit(jn.WS_RECONNECTING, this._websocketReconnectReason) : n === Vr.CLOSED && this.emit(jn.WS_CLOSED, this._disconnectedReason));
      }
      get currentURLIndex() {
        return this.websocket.currentURLIndex;
      }
      get url() {
        return this.websocket && this.websocket.url || null;
      }
      get rtt() {
        return this.rttRolling.mean();
      }
      constructor(n, i) {
        super(), Ve(this, "_disconnectedReason", void 0), Ve(this, "_websocketReconnectReason", void 0), Ve(this, "_connectionState", Vr.CLOSED), Ve(this, "reconnectToken", void 0), Ve(this, "p2pToken", void 0), Ve(this, "websocket", void 0), Ve(this, "openConnectionTime", void 0), Ve(this, "clientId", void 0), Ve(this, "lastMsgTime", Date.now()), Ve(this, "uploadCache", []), Ve(this, "uploadCacheInterval", void 0), Ve(this, "rttRolling", new p5(5)), Ve(this, "pingpongTimer", void 0), Ve(this, "pingpongTimeoutCount", 0), Ve(this, "joinResponse", void 0), Ve(this, "multiIpOption", void 0), Ve(this, "initError", void 0), Ve(this, "spec", void 0), Ve(this, "store", void 0), Ve(this, "_external_signal", void 0), Ve(this, "onWebsocketMessage", (o) => {
          if (o.data instanceof ArrayBuffer) return void this.emit(jn.ON_BINARY_DATA, o.data);
          const f = JSON.parse(o.data);
          if (this.lastMsgTime = Date.now(), Object.prototype.hasOwnProperty.call(f, "_id")) {
            const T = "res-@".concat(f._id);
            this.emit(T, f._result, f._message);
          } else if (Object.prototype.hasOwnProperty.call(f, "_type")) {
            switch (f._type) {
              case nr.ON_DATA_STREAM:
                return void this.handleDataStream(f._message);
              case nr.MUTE_AUDIO:
              case nr.MUTE_VIDEO:
              case nr.ON_P2P_LOST:
              case nr.ON_USER_ONLINE:
                return;
              case nr.ON_USER_OFFLINE:
                const { uid: T } = f._message;
                return Ee.debug("[".concat(this.clientId, "] user-offline uid: ").concat(T)), void this._external_signal.reset(T);
            }
            if (this.emit(f._type, f._message), f._type === nr.ON_NOTIFICATION && this.handleNotification(f._message), f._type === nr.ON_USER_BANNED) switch (f._message.error_code) {
              case 14:
                this.close(br.UID_BANNED);
                break;
              case 15:
                this.close(br.IP_BANNED);
                break;
              case 16:
                this.close(br.CHANNEL_BANNED);
            }
            if (f._type === nr.ON_USER_LICENSE_BANNED) switch (f._message.error_code) {
              case xn.ERR_LICENSE_MISSING:
                this.close(br.LICENSE_MISSING);
                break;
              case xn.ERR_LICENSE_EXPIRED:
                this.close(br.LICENSE_EXPIRED);
                break;
              case xn.ERR_LICENSE_MINUTES_EXCEEDED:
                this.close(br.LICENSE_MINUTES_EXCEEDED);
                break;
              case xn.ERR_LICENSE_PERIOD_INVALID:
                this.close(br.LICENSE_PERIOD_INVALID);
                break;
              case xn.ERR_LICENSE_MULTIPLE_SDK_SERVICE:
                this.close(br.LICENSE_MULTIPLE_SDK_SERVICE);
                break;
              case xn.ERR_LICENSE_ILLEGAL:
                this.close(br.LICENSE_ILLEGAL);
                break;
              default:
                this.close();
            }
          }
        }), this.clientId = n.clientId, this.spec = n, this.store = i, this.websocket = new vI("gateway-".concat(this.clientId), this.spec.retryConfig, !0, ft("JOIN_GATEWAY_USE_DUAL_DOMAIN"), ft("JOIN_GATEWAY_USE_443PORT_ONLY"), i), this.handleWebsocketEvents(), window.addEventListener("offline", () => {
          this.connectionState === Vr.CONNECTED && this.reconnect("retry", Cs.OFFLINE);
        }), this.p2pToken = zr(6, ""), this._external_signal = new Ff(this, this.p2pToken);
      }
      async request(n, i, o, f) {
        const T = zr(6, ""), A = { _id: T, _type: n, _message: i }, R = this.websocket.connectionID, P = () => new cn((He, Re) => {
          if (this.connectionState === Vr.CONNECTED) return He();
          const De = () => {
            this.off(jn.WS_CLOSED, Xe), He();
          }, Xe = () => {
            this.off(jn.WS_CONNECTED, De), Re(new Gt(Je.WS_ABORT));
          };
          this.once(jn.WS_CONNECTED, De), this.once(jn.WS_CLOSED, Xe);
        });
        if (this.connectionState !== Vr.CONNECTING && this.connectionState !== Vr.RECONNECTING || n === kn.JOIN || n === kn.REJOIN || await P(), this.websocket.sendMessage(A, !0), f) return;
        const L = new cn((He, Re) => {
          let De = !1;
          const Xe = (mt, Pt) => {
            De = !0, He({ isSuccess: mt === "success", message: Pt || {} }), this.off(jn.WS_CLOSED, We), this.off(jn.WS_RECONNECTING, We), this.emit(jn.REQUEST_SUCCESS, n, i);
          };
          this.once("res-@".concat(T), Xe);
          const We = () => {
            Re(new Gt(Je.WS_ABORT, "type: ".concat(n))), this.off(jn.WS_CLOSED, We), this.off(jn.WS_RECONNECTING, We), this.off("res-@".concat(T), Xe);
          };
          this.once(jn.WS_CLOSED, We), this.once(jn.WS_RECONNECTING, We), Es(ft("SIGNAL_REQUEST_TIMEOUT")).then(() => {
            this.websocket.connectionID !== R || De || (Ee.warning("[".concat(this.clientId, "] ws request timeout, type: ").concat(n)), this.emit(jn.REQUEST_TIMEOUT, n, i));
          });
        });
        let z = null;
        try {
          z = await L;
        } catch (He) {
          if (this.connectionState === Vr.CLOSED || n === kn.LEAVE) throw new Gt(Je.WS_ABORT);
          return !this.spec.forceWaitGatewayResponse || o ? He.throw() : n === kn.JOIN || n === kn.REJOIN ? null : (await P(), await this.request(n, i));
        }
        if (z.isSuccess) return z.message;
        const Y = Number(z.message.error_code || z.message.code), te = UE(Y), oe = new Gt(Je.UNEXPECTED_RESPONSE, "".concat(te.desc, ": ").concat(z.message.error_str), { code: Y, data: z.message, desc: te.desc });
        return te.action === "success" ? z.message : (Ee.warning("[".concat(this.clientId, "] [").concat(this.websocket.connectionID, "] unexpected response from type ").concat(n, ", error_code: ").concat(Y, ", message: ").concat(te.desc, ", action: ").concat(te.action)), Y === xn.ERR_TOO_MANY_BROADCASTERS ? ((n === kn.JOIN || n === kn.REJOIN) && (this.initError = oe, this.close()), oe.throw()) : te.action === "failed" ? oe.throw() : te.action === "quit" ? (this.initError = oe, this.close(), oe.throw()) : (Y === xn.ERR_JOIN_BY_MULTI_IP ? (this.multiIpOption = z.message.option, Ee.warning("[".concat(this.clientId, "] detect multi ip, recover")), this.reconnect("recover", Cs.MULTI_IP)) : this.reconnect(te.action, Cs.SERVER_ERROR), n === kn.JOIN || n === kn.REJOIN ? null : await this.request(n, i)));
      }
      waitMessage(n, i) {
        return new cn((o) => {
          const f = (T) => {
            (!i || i(T)) && (this.off(n, f), o(T));
          };
          this.on(n, f);
        });
      }
      uploadWRTCStats(n) {
        if (!this.store.sessionId) return void Ee.warn("[".concat(this.clientId, "] no session id when upload wrtc stats"));
        const i = { lts: Date.now(), sid: this.store.sessionId, uid: this.store.intUid, stats: n };
        this.upload(kE.WRTC_STATS, i);
      }
      upload(n, i) {
        const o = { _type: n, _message: i };
        try {
          this.websocket.sendMessage(o);
        } catch {
          const T = ft("MAX_UPLOAD_CACHE") || 50;
          this.uploadCache.push(o), this.uploadCache.length > T && this.uploadCache.splice(0, 1), this.uploadCache.length > 0 && !this.uploadCacheInterval && (this.uploadCacheInterval = window.setInterval(() => {
            if (this.connectionState !== Vr.CONNECTED) return;
            const A = this.uploadCache.splice(0, 1)[0];
            this.uploadCache.length === 0 && (window.clearInterval(this.uploadCacheInterval), this.uploadCacheInterval = void 0), this.upload(A._type, A._message);
          }, ft("UPLOAD_CACHE_INTERVAL") || 2e3));
        }
      }
      send(n, i) {
        const o = { _type: n, _message: i };
        this.websocket.sendMessage(o);
      }
      async sendExtensionMessage(n, i, o) {
        return await this._external_signal.send(n, i, o);
      }
      init(n) {
        return this.initError = void 0, this.multiIpOption = void 0, this.joinResponse = void 0, this.reconnectToken = void 0, this.openConnectionTime = void 0, new cn((i, o) => {
          this.once(jn.WS_CONNECTED, () => i(this.joinResponse)), this.once(jn.WS_CLOSED, () => o(this.initError || new Gt(Je.WS_ABORT))), this.connectionState = Vr.CONNECTING, this.websocket.init(n).catch(o);
        });
      }
      close(n) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.reconnectToken = void 0, this.joinResponse = void 0, this._external_signal.clear(), this._disconnectedReason = n || br.LEAVE, this.connectionState = Vr.CLOSED, Ee.debug("[".concat(this.clientId, "] ") + "will close websocket in signal"), this.websocket.close(), this.p2pToken = zr(6, ""), this._external_signal.clear(), this._external_signal = new Ff(this, this.p2pToken);
      }
      async join() {
        if (!this.joinResponse) {
          this.emit(jn.ABORT_P2P_EXECUTION);
          const n = await Ss(this, jn.REQUEST_JOIN_INFO), i = await this.request(kn.JOIN, n);
          if (!i) return this.emit(jn.REPORT_JOIN_GATEWAY, Je.TIMEOUT, this.url || ""), !1;
          this.joinResponse = i, this.emit(jn.JOIN_RESPONSE, this.joinResponse), this.reconnectToken = this.joinResponse.rejoin_token;
        }
        return this.connectionState = Vr.CONNECTED, this.pingpongTimer && window.clearInterval(this.pingpongTimer), this.pingpongTimer = window.setInterval(this.handlePingPong.bind(this), 3e3), !0;
      }
      reconnect(n, i) {
        this.pingpongTimer && (this.pingpongTimeoutCount = 0, window.clearInterval(this.pingpongTimer), this.pingpongTimer = void 0), this.websocket.reconnect(n, i);
      }
      handleDataStream(n) {
        try {
          var i;
          const o = Tf(n.payload), f = new TextDecoder().decode(o), T = JSON.parse(f);
          "total" in T && "id" in T || on(i = Object.values(bi)).call(i, T._type) ? (T._uid = n.uid, this._external_signal.onMessage(T)) : this.emit(nr.ON_DATA_STREAM, n);
        } catch {
          this.emit(nr.ON_DATA_STREAM, n);
        }
      }
      handleNotification(n) {
        Ee.debug("[".concat(this.clientId, "] receive notification: "), n);
        const i = UE(n.code);
        if (i.action !== "success") {
          if (i.action !== "failed") return i.action === "quit" ? (i.desc === "ERR_REPEAT_JOIN_CHANNEL" && this.close(br.UID_BANNED), void this.close()) : void this.reconnect(i.action, Cs.SERVER_ERROR);
          Ee.error("[".concat(this.clientId, "] ignore error: "), i.desc);
        }
      }
      handlePingPong() {
        if (!this.websocket || this.websocket.state !== "connected") return;
        this.pingpongTimeoutCount > 0 && this.rttRolling.add(3e3), this.pingpongTimeoutCount += 1;
        const n = ft("PING_PONG_TIME_OUT"), i = Date.now();
        this.pingpongTimeoutCount >= n && (Ee.warning("[".concat(this.clientId, "] PINGPONG Timeout. Last Socket Message: ").concat(i - this.lastMsgTime, "ms")), i - this.lastMsgTime > ft("WEBSOCKET_TIMEOUT_MIN")) ? this.reconnect("retry", Cs.TIMEOUT) : this.request(kn.PING, void 0, !0).then(() => {
          this.pingpongTimeoutCount = 0;
          const o = Date.now() - i;
          this.rttRolling.add(o), ft("REPORT_STATS") && this.send(kn.PING_BACK, { pingpongElapse: o });
        }).catch((o) => {
        });
      }
      handleWebsocketEvents() {
        this.websocket.on(Fn.RECONNECT_CREATE_CONNECTION, (n) => {
          this.emit(jn.WS_RECONNECT_CREATE_CONNECTION, n);
        }), this.websocket.on(Fn.ON_MESSAGE, this.onWebsocketMessage), this.websocket.on(Fn.CLOSED, () => {
          this.connectionState = Vr.CLOSED;
        }), this.websocket.on(Fn.FAILED, () => {
          this._disconnectedReason = br.NETWORK_ERROR, this.connectionState = Vr.CLOSED;
        }), this.websocket.on(Fn.RECONNECTING, (n) => {
          this._websocketReconnectReason = n, this.joinResponse = void 0, this.connectionState === Vr.CONNECTED ? this.connectionState = Vr.RECONNECTING : this.connectionState = Vr.CONNECTING;
        }), this.websocket.on(Fn.WILL_RECONNECT, (n, i, o) => {
          n !== "retry" ? (Ee.debug("".concat(this.clientId, " websocket will_connect event, renewSession reconnectMode is ").concat(n)), this.reconnectToken = void 0) : Ee.debug("".concat(this.clientId, " reconnect mode is retry, no need to renew session")), o(n);
        }), this.websocket.on(Fn.CONNECTED, () => {
          this.openConnectionTime = Date.now(), this.join().catch((n) => {
            if (this.emit(jn.REPORT_JOIN_GATEWAY, n, this.url || ""), n instanceof Gt && n.code === Je.UNEXPECTED_RESPONSE && n.data.code === xn.ERR_NO_AUTHORIZED) return Ee.warning("[".concat(this.clientId, "] reconnect no authorized, recover")), void this.reconnect("recover", Cs.SERVER_ERROR);
            Ee.error("[".concat(this.clientId, "] join gateway request failed"), n.toString()), this.spec.forceWaitGatewayResponse ? this.reconnect("tryNext", Cs.SERVER_ERROR) : (this.initError = n, this.close());
          });
        }), this.websocket.on(Fn.REQUEST_NEW_URLS, (n, i) => {
          Ss(this, jn.REQUEST_RECOVER, this.multiIpOption).then(n).catch(i);
        }), this.websocket.on(Fn.ON_TOKEN_PRIVILEGE_DID_EXPIRE, () => {
          this.emit(nr.ON_TOKEN_PRIVILEGE_DID_EXPIRE);
        });
      }
    }
    const Lce = { name: "P2PChannel", create: function(e) {
      let { store: n, statsCollector: i } = e;
      return new Dce(n, i);
    }, createSubmodule: function(e) {
      let { store: n, spec: i } = e;
      return new Mce(i, n);
    } };
    function D9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function M9(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? D9(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : D9(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    class kce {
      constructor(n) {
        Ve(this, "sessionDesc", void 0), Ve(this, "localCapabilities", void 0), Ve(this, "rtpCapabilities", void 0), Ve(this, "candidates", void 0), Ve(this, "_originCandidates", void 0), Ve(this, "iceParameters", void 0), Ve(this, "dtlsParameters", void 0), Ve(this, "setup", void 0), Ve(this, "currentMidIndex", void 0), Ve(this, "cname", void 0), n = di(n);
        const { iceParameters: i, dtlsParameters: o, candidates: f, rtpCapabilities: T, setup: A, localCapabilities: R, sdkCodec: P, cname: L } = n, z = Ca(`v=0
o=- 0 0 IN IP4 127.0.0.1
s=AgoraGateway
t=0 0
a=group:BUNDLE audio video
a=msid-semantic: WMS
a=ice-lite
m=audio 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=sendrecv
a=rtcp-mux
a=rtcp-rsize
a=mid:audio
m=video 9 UDP/TLS/RTP/SAVPF 0
c=IN IP4 127.0.0.1
a=rtcp:9 IN IP4 0.0.0.0
a=sendrecv
a=rtcp-mux
a=rtcp-rsize
a=mid:video
`);
        this.rtpCapabilities = T, this.candidates = f, this._originCandidates = di(f), this.iceParameters = i, this.dtlsParameters = o, this.setup = A, this.localCapabilities = R, this.cname = L;
        for (let Y = 0; Y < z.mediaDescriptions.length; Y++) {
          const te = z.mediaDescriptions[Y];
          if (te.attributes.iceUfrag = i.iceUfrag, te.attributes.icePwd = i.icePwd, te.attributes.fingerprints = o.fingerprints, te.attributes.candidates = f, te.attributes.setup = A, te.media.mediaType === "video") {
            te.media.fmts = T.videoCodecs.map((He) => He.payloadType.toString(10));
            let oe = T.videoCodecs.filter((He) => {
              var Re, De;
              return (Re = He.rtpMap) === null || Re === void 0 ? void 0 : on(De = Re.encodingName.toLowerCase()).call(De, P);
            });
            oe.length === 0 && (oe = T.videoCodecs), te.attributes.payloads = oe, te.attributes.extmaps = T.videoExtensions;
          }
          te.media.mediaType === "audio" && (te.media.fmts = T.audioCodecs.map((oe) => oe.payloadType.toString(10)), te.attributes.payloads = T.audioCodecs, te.attributes.extmaps = T.audioExtensions), z.mediaDescriptions[Y] = this.mungMediaDesc(te);
        }
        this.sessionDesc = z, this.currentMidIndex = z.mediaDescriptions.length - 1;
      }
      toString() {
        return nl(this.sessionDesc);
      }
      send(n, i, o) {
        const { ssrcs: f, ssrcGroups: T } = Rf(i, this.cname), A = this.sessionDesc.mediaDescriptions.find((L) => n === vn.VIDEO ? L.media.mediaType === "video" : L.media.mediaType === "audio"), R = f[0].attributes.label, P = f[0].attributes.mslabel;
        return A.attributes.ssrcs = A.attributes.ssrcs.concat(f), A.attributes.ssrcGroups = A.attributes.ssrcGroups.concat(T), { id: R, mslabel: P };
      }
      batchSend(n) {
        return n.map((i) => {
          let { kind: o, ssrcMsg: f } = i;
          return this.send(o, f, void 0);
        });
      }
      stopSending(n) {
        this.sessionDesc.mediaDescriptions.forEach((i) => {
          const o = [], f = [], T = [];
          i.attributes.ssrcs.forEach((A) => {
            on(n).call(n, A.attributes.label || "") ? T.push(A) : o.push(A);
          }), i.attributes.ssrcGroups.forEach((A) => {
            var R;
            on(R = T.map((P) => P.ssrcId)).call(R, A.ssrcIds[0]) || f.push(A);
          }), i.attributes.ssrcs = o, i.attributes.ssrcGroups = f;
        });
      }
      mute(n) {
        const i = this.sessionDesc.mediaDescriptions.find((o) => o.attributes.mid === n);
        if (!i) throw new Error("mediaDescription not found with ".concat(n, " in remote SDP when calling RemoteSDP.mute."));
        i.attributes.direction = "inactive";
      }
      unmute(n) {
        const i = this.sessionDesc.mediaDescriptions.find((o) => o.attributes.mid === n);
        if (!i) throw new Error("mediaDescription not found with ".concat(n, " in remote SDP when calling RemoteSDP.unmute."));
        i.attributes.direction = "sendonly";
      }
      receive(n, i, o) {
        n.forEach((f, T) => {
          const A = f._mediaStreamTrack, R = this.sessionDesc.mediaDescriptions.findIndex((L) => L.attributes.mid === A.kind), P = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[R], f);
          this.sessionDesc.mediaDescriptions[R] = P;
        });
      }
      stopReceiving(n) {
      }
      updateCandidates(n) {
        const i = this._originCandidates.filter((f) => f.transport === "udp"), o = [];
        if (i.forEach((f) => {
          o.push(M9(M9({}, f), {}, { foundation: "tcpcandidate", priority: Number(f.priority) - 1 + "", transport: "tcp", port: Number(f.port) + 90 + "" }));
        }), i.length !== 0) {
          switch (n) {
            case Hs.TCP_RELAY:
              this.candidates = o;
              break;
            case Hs.UDP_TCP_RELAY:
            case Hs.RELAY:
              this.candidates = [...i, ...o];
              break;
            default:
              this.candidates = i;
          }
          for (const f of this.sessionDesc.mediaDescriptions) f.attributes.candidates = this.candidates;
        }
      }
      restartICE(n) {
        n = di(n), this.iceParameters = n, this.sessionDesc.mediaDescriptions.forEach((i) => {
          i.attributes.iceUfrag = n.iceUfrag, i.attributes.icePwd = n.icePwd;
        });
      }
      predictReceivingMids(n) {
        const i = [];
        for (let o = 0; o < n; o++) i.push((this.currentMidIndex + o + 1).toString(10));
        return i;
      }
      mungRecvMediaDsec(n, i) {
        const o = di(n);
        return Cp(o, i), OI(o, i), o;
      }
      updateRecvMedia(n, i) {
        const o = this.sessionDesc.mediaDescriptions.findIndex((f) => f.attributes.mid === n);
        if (o !== -1) {
          const f = this.mungRecvMediaDsec(this.sessionDesc.mediaDescriptions[o], i);
          this.sessionDesc.mediaDescriptions[o] = f;
        }
      }
      bumpMid(n) {
        this.currentMidIndex += n;
      }
      updateTrackLabel(n, i, o) {
        const f = this.sessionDesc.mediaDescriptions.find((A) => n === vn.VIDEO ? A.attributes.mid === "video" : A.attributes.mid === "audio");
        if (f) {
          const A = f.attributes.ssrcs.find((R) => R.attributes.label === i);
          var T;
          A && (A.attributes.label = o, (T = A.attributes.msid) === null || T === void 0 || T.replace(i, o));
        }
      }
      mungMediaDesc(n) {
        const i = di(n);
        return AI(i), function(o) {
          const f = o.attributes.extmaps.find((T) => kT(T.extensionName));
          f && o.attributes.extmaps.splice(o.attributes.extmaps.indexOf(f), 1), o.attributes.payloads.forEach((T) => {
            const A = T.rtcpFeedbacks.findIndex((R) => R.type === "transport-cc");
            A !== -1 && T.rtcpFeedbacks.splice(A, 1);
          });
        }(i), i;
      }
      getSSRC(n) {
        for (const i of this.sessionDesc.mediaDescriptions) for (const o of i.attributes.ssrcs) if (o.attributes.label === n) return [o];
      }
    }
    var kr;
    function L9(e, n) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n && (o = o.filter(function(f) {
          return Object.getOwnPropertyDescriptor(e, f).enumerable;
        })), i.push.apply(i, o);
      }
      return i;
    }
    function v0(e) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n] != null ? arguments[n] : {};
        n % 2 ? L9(Object(i), !0).forEach(function(o) {
          Ve(e, o, i[o]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : L9(Object(i)).forEach(function(o) {
          Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(i, o));
        });
      }
      return e;
    }
    let jce = (kr = class jy extends G8 {
      get peerConnectionState() {
        return this.peerConnection.connectionState;
      }
      get iceConnectionState() {
        return this.peerConnection.iceConnectionState;
      }
      get currentLocalDescription() {
        return this.peerConnection.currentLocalDescription;
      }
      get currentRemoteDescription() {
        return this.peerConnection.currentRemoteDescription;
      }
      get localCodecs() {
        return [...new Set(this.localCapabilities && this.localCapabilities.videoCodecs.map((n) => n.rtpMap && n.rtpMap.encodingName.toLowerCase() || "").filter((n) => {
          var i;
          return on(i = Object.keys(mT)).call(i, n);
        }))];
      }
      constructor(n, i) {
        super(n, i), Ve(this, "store", void 0), Ve(this, "peerConnection", void 0), Ve(this, "remoteSDP", void 0), Ve(this, "initialOffer", void 0), Ve(this, "statsFilter", void 0), Ve(this, "useRTX", !1), Ve(this, "localCapabilities", void 0), Ve(this, "localCandidateCount", 0), Ve(this, "allCandidatesReceived", !1), Ve(this, "establishPromise", void 0), Ve(this, "mutex", void 0), this.store = i, this.mutex = new xs("P2PConnection-mutex", i.clientId), this.peerConnection = new RTCPeerConnection(jy.resolvePCConfiguration(n), { optional: [{ googDscp: !0 }] }), this.statsFilter = YS(this.peerConnection, ft("STATS_UPDATE_INTERVAL"), void 0, ui() ? 1200 : void 0), this.bindPCEvents(), this.bindStatsEvents(), this.store.p2pId = this.store.p2pId + 1, this.establishPromise = this.establish();
      }
      async establish() {
        try {
          const n = await this.peerConnection.createOffer({ offerToReceiveAudio: !0, offerToReceiveVideo: !0 });
          if (!n.sdp) throw new Error("Cannot get initialOffer.sdp when trying to establish PeerConnection.");
          const i = al(n.sdp), o = zE(n.sdp, { filterRTX: !this.useRTX, filterVideoFec: ft("FILTER_VIDEO_FEC"), filterAudioFec: ft("FILTER_AUDIO_FEC"), filterAudioCodec: ["opus"] });
          return this.localCapabilities = o, this.initialOffer = n, v0(v0({}, i), {}, { rtpCapabilities: { send: { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, recv: { audioCodecs: [], audioExtensions: [], videoCodecs: [], videoExtensions: [] }, sendrecv: o }, offerSDP: n.sdp });
        } catch (n) {
          throw new Gt(Je.GET_LOCAL_CONNECTION_PARAMS_FAILED, n.toString());
        }
      }
      async updateRemoteConnect() {
      }
      async connect(n) {
        try {
          if (!this.initialOffer) throw new Error("Cannot establish P2PConnection without initial offer.");
          this.remoteSDP = new kce(v0(v0({}, n), {}, { rtpCapabilities: n.rtpCapabilities.send, localCapabilities: this.localCapabilities, sdkCodec: this.store.codec }));
          const i = this.remoteSDP.toString();
          await this.peerConnection.setLocalDescription(this.initialOffer), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: i });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.connect failed; ".concat(i.toString()));
        }
      }
      async updateRemoteRTPCapabilities(n, i) {
        throw new Gt(Je.NOT_SUPPORTED, "Planb mode does not support createDataChannels.");
      }
      getPreMedia(n) {
      }
      send(n, i) {
        var o = this;
        return Io(function* () {
          const f = yield dr(o.mutex.lock());
          try {
            if (!o.remoteSDP) throw new Error("Cannot call P2PConnection.send before remote SDP created");
            const T = n.map((te) => o.peerConnection.addTrack(te._mediaStreamTrack)), A = yield dr(o.peerConnection.createOffer()), R = Ca(A.sdp), P = n.map((te) => {
              const oe = te._mediaStreamTrack, He = R.mediaDescriptions.find((Re) => Re.attributes.mid === oe.kind);
              if (!He) throw new Error("Cannot extract ssrc from mediaDescription.");
              return function(Re, De, Xe) {
                const We = Re.attributes.ssrcs.filter((Pt) => Pt.attributes.label === De), mt = Re.attributes.ssrcGroups;
                if (We.length === 0) throw new Error("Cannot extract ssrc from plan-b SDP.");
                if (mt && We.length > 1) {
                  const Pt = mt.find((xt) => xt.ssrcIds.indexOf(We[0].ssrcId) !== -1);
                  return Pt ? [{ ssrcId: Pt.ssrcIds[0], rtx: Xe ? Pt.ssrcIds[1] : void 0 }] : [{ ssrcId: We[0].ssrcId }];
                }
                return [{ ssrcId: We[0].ssrcId }];
              }(He, oe.id, o.useRTX);
            });
            let L;
            try {
              L = yield P;
            } catch (te) {
              throw T.forEach((oe) => {
                Os() && oe.replaceTrack(null), o.peerConnection.removeTrack(oe);
              }), te;
            }
            const z = o.mungSendOfferSDP(A.sdp, n);
            o.remoteSDP.receive(n, i, L);
            const Y = o.remoteSDP.toString();
            return yield dr(o.peerConnection.setLocalDescription({ type: "offer", sdp: z })), yield dr(o.applySendEncodings(T, n)), yield dr(o.peerConnection.setRemoteDescription({ type: "answer", sdp: Y })), n.map((te, oe) => {
              const He = te._mediaStreamTrack.id;
              return { localSSRC: P[oe], id: He };
            });
          } catch (T) {
            throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.send failed; ".concat(T.toString()));
          } finally {
            f();
          }
        })();
      }
      async stopSending(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopSending before remote SDP created");
          const i = this.peerConnection.getSenders().filter((T) => {
            var A;
            return n.indexOf(((A = T.track) === null || A === void 0 ? void 0 : A.id) || "") !== -1;
          });
          if (i.length !== n.length) throw new Error("Transceivers' length doesn't match mids' length when trying to call P2PConnection.stopSending.");
          i.map((T) => {
            Os() && T.replaceTrack(null), this.peerConnection.removeTrack(T);
          });
          const o = await this.peerConnection.createOffer();
          await this.peerConnection.setLocalDescription(o), this.remoteSDP.stopReceiving(n);
          const f = this.remoteSDP.toString();
          await this.peerConnection.setRemoteDescription({ type: "answer", sdp: f });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.stopSending failed; ".concat(i.toString()));
        }
      }
      async receive(n, i, o, f) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.receive ".concat(n, " before remoteSDP created."));
          const { id: T, mslabel: A } = this.remoteSDP.send(n, i, f), R = new cn((z, Y) => {
            const te = setTimeout(() => {
              Y(new Error("Cannot receive track, id: ".concat(T)));
            }, 1e4), oe = (He) => {
              const Re = hr();
              if ((Re.name === "Safari" && Number(Re.version) === 11 || ta()) && He.track.id !== T && He.streams[0].id === A) {
                var De;
                const Xe = He.streams[0].getTracks()[0];
                return (De = this.remoteSDP) === null || De === void 0 || De.updateTrackLabel(n, T, He.track.id), this.peerConnection.removeEventListener("track", oe), clearTimeout(te), void z(Xe);
              }
              if (He.track.id === T) return this.peerConnection.removeEventListener("track", oe), clearTimeout(te), void z(He.track);
            };
            this.peerConnection.addEventListener("track", oe);
          }), P = this.remoteSDP.toString();
          await this.peerConnection.setRemoteDescription({ type: "offer", sdp: P });
          const L = await this.peerConnection.createAnswer();
          return await this.peerConnection.setLocalDescription(L), { track: await R, id: T };
        } catch (T) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(T.toString()));
        }
      }
      async stopReceiving(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.stopReceiving before remote SDP created.");
          this.remoteSDP.stopSending(n);
          const i = this.remoteSDP.toString();
          await this.peerConnection.setRemoteDescription({ type: "offer", sdp: i });
          const o = await this.peerConnection.createAnswer();
          await this.peerConnection.setLocalDescription(o);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection stopReceiving failed; ".concat(i.toString()));
        }
      }
      async muteRemote(n) {
      }
      async unmuteRemote(n) {
      }
      async muteLocal(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.muteLocal before remote SDP created.");
          const i = this.peerConnection.getSenders().filter((o) => {
            var f;
            return n.indexOf(((f = o.track) === null || f === void 0 ? void 0 : f.id) || "") !== -1;
          });
          if (i.length !== n.length) throw new Error("sender' length doesn't match mids' length.");
          i.map((o) => {
            if (Os() && o.track) o.track.enabled = !1;
            else {
              const f = o.getParameters();
              f.encodings.forEach((T) => T.active = !1), o.setParameters(f);
            }
          });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.muteLocal failed; ".concat(i.toString()));
        }
      }
      async unmuteLocal(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.unmuteLocal before remote SDP created.");
          const i = this.peerConnection.getSenders().filter((T) => {
            var A;
            return n.indexOf(((A = T.track) === null || A === void 0 ? void 0 : A.id) || "") !== -1;
          });
          if (i.length !== n.length) throw new Error("Senders' length doesn't match mids' length.");
          i.map(async (T) => {
            if (Os() && T.track) T.track.enabled = !0;
            else {
              const A = T.getParameters();
              A.encodings.forEach((R) => R.active = !0), await T.setParameters(A);
            }
          });
          const o = await this.peerConnection.createOffer();
          await this.peerConnection.setLocalDescription(o);
          const f = this.remoteSDP.toString();
          await this.peerConnection.setRemoteDescription({ type: "answer", sdp: f });
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.unmuteLocal failed; ".concat(i.toString()));
        }
      }
      restartICE(n) {
        var i = this;
        return Io(function* () {
          const o = yield dr(i.mutex.lock("From P2PConnection.restartICE"));
          try {
            if (!i.remoteSDP) throw new Error("Cannot restartICE before remoteSDP created.");
            const f = pr().supportPCSetConfiguration;
            if (n === Hs.RELAY && !f) return;
            if (f) {
              const L = i.peerConnection.getConfiguration(), z = n === Hs.RELAY ? "relay" : "all";
              L.iceTransportPolicy !== z && (Ee.debug("[".concat(i.store.clientId, "] restartICE change iceTransportPolicy from [").concat(L.iceTransportPolicy, "] to [").concat(z, "]")), L.iceTransportPolicy = z, i.peerConnection.setConfiguration(L));
            }
            n !== Hs.RELAY && i.remoteSDP.updateCandidates(n);
            const T = yield dr(i.peerConnection.createOffer({ iceRestart: !0 }));
            if (!T.sdp) throw new Error("Cannot restartICE because restart offer SDP does not exist.");
            const A = al(T.sdp), { remoteIceParameters: R } = yield A.iceParameters;
            i.remoteSDP.restartICE(R);
            const P = i.remoteSDP.toString();
            yield dr(i.peerConnection.setLocalDescription(T)), yield dr(i.peerConnection.setRemoteDescription({ type: "answer", sdp: P }));
          } catch (f) {
            Ee.warning("[".concat(i.store.clientId, "] restart ICE failed, abort operation"), f);
          } finally {
            o();
          }
        })();
      }
      close() {
        var n;
        this.peerConnection.close(), (n = this.onConnectionStateChange) === null || n === void 0 || n.call(this, "closed"), this.unbindPCEvents(), this.unbindStatsEvents(), this.removeAllListeners(), this.statsFilter.destroy();
      }
      getStats() {
        return this.statsFilter.getStats();
      }
      getRemoteVideoIsReady(n) {
        return this.statsFilter.getVideoIsReady(n);
      }
      async updateEncoderConfig(n, i) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.updateEncoderConfig before remote SDP created.");
          const o = await this.peerConnection.createOffer(), f = this.mungSendOfferSDP(o.sdp, [i]);
          this.remoteSDP.updateRecvMedia(i._mediaStreamTrack.kind, i);
          const T = this.remoteSDP.toString();
          await this.peerConnection.setLocalDescription({ type: "offer", sdp: f }), await this.peerConnection.setRemoteDescription({ type: "answer", sdp: T });
        } catch (o) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, o.toString());
        }
      }
      async updateSendParameters(n, i) {
        const o = this.peerConnection.getSenders().filter((f) => {
          var T;
          return ((T = f.track) === null || T === void 0 ? void 0 : T.id) === n;
        });
        o.length === 1 && await this.applySendEncodings(o, [i]);
      }
      setStatsRemoteVideoIsReady(n, i) {
        this.statsFilter.setVideoIsReady2(n, i);
      }
      async replaceTrack(n, i) {
        const o = this.peerConnection.getSenders().find((f) => {
          var T;
          return ((T = f.track) === null || T === void 0 ? void 0 : T.id) === i;
        });
        o && await o.replaceTrack(n._mediaStreamTrack);
      }
      createDataChannels(n, i) {
        throw new Gt(Je.NOT_SUPPORTED, "Planb mode does not support createDataChannels.");
      }
      stopDataChannels(n) {
        throw new Gt(Je.NOT_SUPPORTED, "Planb mode does not support stopDataChannels.");
      }
      bindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = () => {
          var n;
          (n = this.onICEConnectionStateChange) === null || n === void 0 || n.call(this, this.peerConnection.iceConnectionState);
        }, this.peerConnection.onconnectionstatechange = () => {
          var n;
          (n = this.onConnectionStateChange) === null || n === void 0 || n.call(this, this.peerConnection.connectionState);
        }, this.peerConnection.onicecandidate = (n) => {
          n.candidate ? this.localCandidateCount += 1 : (this.peerConnection.onicecandidate = null, this.allCandidatesReceived = !0, Ee.debug("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] local candidate count"), this.localCandidateCount));
        }, setTimeout(() => {
          this.allCandidatesReceived || (this.allCandidatesReceived = !0, Ee.debug("[".concat(this.store.clientId, "] [pc-").concat(this.store.p2pId, "] onicecandidate timeout, local candidate count"), this.localCandidateCount));
        }, ft("CANDIDATE_TIMEOUT"));
      }
      unbindPCEvents() {
        this.peerConnection.oniceconnectionstatechange = null, this.peerConnection.onconnectionstatechange = null, this.peerConnection.onsignalingstatechange = null, this.peerConnection.onicecandidateerror = null, this.peerConnection.onicecandidate = null, this.peerConnection.ontrack = null;
      }
      static resolvePCConfiguration(n) {
        const i = { iceServers: [], sdpSemantics: "plan-b" };
        return n.iceServers ? i.iceServers = n.iceServers : n.turnServer && n.turnServer.mode !== "off" && (NE(n.turnServer.servers) ? i.iceServers = n.turnServer.servers : (i.iceServers && i.iceServers.push(...jy.turnServerConfigToIceServers(n.turnServer.servers)), ft("USE_TURN_SERVER_OF_GATEWAY") && i.iceServers && n.turnServer.serversFromGateway && i.iceServers.push(...jy.turnServerConfigToIceServers(n.turnServer.serversFromGateway)), n.turnServer.servers.concat(n.turnServer.serversFromGateway || []).forEach((o) => {
          o.forceturn && (i.iceTransportPolicy = "relay");
        }))), i;
      }
      static turnServerConfigToIceServers(n) {
        const i = [];
        return n.forEach((o) => {
          o.security ? o.tcpport && i.push({ username: o.username, credential: o.password, credentialType: "password", urls: "turns:".concat(o.turnServerURL, ":").concat(o.tcpport, "?transport=tcp") }) : (o.udpport && i.push({ username: o.username, credential: o.password, credentialType: "password", urls: "turn:".concat(o.turnServerURL, ":").concat(o.udpport, "?transport=udp") }), o.tcpport && i.push({ username: o.username, credential: o.password, credentialType: "password", urls: "turn:".concat(o.turnServerURL, ":").concat(o.tcpport, "?transport=tcp") }));
        }), i;
      }
      async updateRtpSenderEncodings(n, i) {
        var o;
        if (i || (i = this.peerConnection.getSenders().find((L) => {
          var z;
          return ((z = L.track) === null || z === void 0 ? void 0 : z.id) === n._mediaStreamTrack.id;
        })), !i) return Ee.warn("[".concat(n.getTrackId(), "] no rtpSender found}"));
        if (!pr().supportSetRtpSenderParameters) return Ee.warn("Browser not support set rtp-sender parameters");
        const f = {}, T = {};
        if (n instanceof Wr) switch (n._optimizationMode) {
          case "motion":
            f.degradationPreference = "maintain-framerate";
            break;
          case "detail":
            f.degradationPreference = "maintain-resolution";
            break;
          default:
            f.degradationPreference = "balanced";
        }
        if (ft("DSCP_TYPE") && ad()) {
          var A;
          const L = ft("DSCP_TYPE");
          on(A = ["very-low", "low", "medium", "high"]).call(A, L) && (T.networkPriority = L);
        }
        const R = i.getParameters(), P = (o = R.encodings) === null || o === void 0 ? void 0 : o[0];
        P && Object.assign(P, T), Object.assign(R, f), Ee.debug("[".concat(n.getTrackId(), "] updateRtpSenderEncodings: ").concat(JSON.stringify(R.encodings))), await i.setParameters(R);
      }
      async applySendEncodings(n, i) {
        try {
          if (!pr().supportSetRtpSenderParameters || n.length !== i.length) return;
          for (let o = 0; o < n.length; o++) {
            const f = n[o], T = i[o];
            f && T && await this.updateRtpSenderEncodings(T, f);
          }
        } catch {
          Ee.debug("[".concat(this.store.clientId, "] Apply RTPSendEncodings failed."));
        }
      }
      mungSendOfferSDP(n, i) {
        const o = Ca(n);
        return i.forEach((f, T) => {
          const A = f._mediaStreamTrack, R = o.mediaDescriptions.find((P) => P.attributes.mid === A.kind);
          R && Cp(R, f);
        }), nl(o);
      }
      bindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = (n) => {
          var i;
          (i = this.onFirstAudioReceived) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstVideoReceived = (n) => {
          var i;
          (i = this.onFirstVideoReceived) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstAudioDecoded = (n) => {
          var i;
          (i = this.onFirstAudioDecoded) === null || i === void 0 || i.call(this, n);
        }, this.statsFilter.onFirstVideoDecoded = (n, i, o) => {
          var f;
          (f = this.onFirstVideoDecoded) === null || f === void 0 || f.call(this, n, i, o);
        }, this.statsFilter.onSelectedLocalCandidateChanged = (n, i) => {
          var o;
          (o = this.onSelectedLocalCandidateChanged) === null || o === void 0 || o.call(this, n, i);
        }, this.statsFilter.onSelectedRemoteCandidateChanged = (n, i) => {
          var o;
          (o = this.onSelectedRemoteCandidateChanged) === null || o === void 0 || o.call(this, n, i);
        };
      }
      unbindStatsEvents() {
        this.statsFilter.onFirstAudioReceived = void 0, this.statsFilter.onFirstVideoReceived = void 0, this.statsFilter.onFirstAudioDecoded = void 0, this.statsFilter.onFirstVideoDecoded = void 0, this.statsFilter.onSelectedLocalCandidateChanged = void 0, this.statsFilter.onSelectedRemoteCandidateChanged = void 0;
      }
      async batchReceive(n) {
        try {
          if (!this.remoteSDP) throw new Error("Cannot call P2PConnection.batchReceive before remoteSDP created.");
          const i = this.remoteSDP.batchSend(n).map((T, A) => {
            let { id: R, mslabel: P } = T;
            const { kind: L } = n[A];
            return new cn((z, Y) => {
              const te = setTimeout(() => {
                Y(new Error("Cannot receive track, id: ".concat(R)));
              }, 1e4), oe = (He) => {
                const Re = hr();
                if (Re.name === "Safari" && Number(Re.version) === 11 && He.track.id !== R && He.streams[0].id === P) {
                  var De;
                  const Xe = He.streams[0].getTracks()[0];
                  return (De = this.remoteSDP) === null || De === void 0 || De.updateTrackLabel(L, R, He.track.id), this.peerConnection.removeEventListener("track", oe), clearTimeout(te), void z({ track: Xe, id: R });
                }
                if (He.track.id === R) return this.peerConnection.removeEventListener("track", oe), clearTimeout(te), void z({ track: He.track, id: R });
              };
              this.peerConnection.addEventListener("track", oe);
            });
          }), o = this.remoteSDP.toString();
          await this.peerConnection.setRemoteDescription({ type: "offer", sdp: o });
          const f = await this.peerConnection.createAnswer();
          return await this.peerConnection.setLocalDescription(f), await cn.all(i);
        } catch (i) {
          throw new Gt(Je.EXCHANGE_SDP_FAILED, "P2PConnection.receive failed; ".concat(i.toString()));
        }
      }
      async getRemoteSSRC(n) {
        if (!this.remoteSDP) return;
        const i = this.remoteSDP.getSSRC(n);
        return i == null ? void 0 : i[0].ssrcId;
      }
      setConfiguration(n) {
        if (pr().supportPCSetConfiguration) {
          const i = jy.resolvePCConfiguration(n);
          this.peerConnection.setConfiguration(i);
        }
      }
    }, bn(kr.prototype, "connect", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "connect"), kr.prototype), bn(kr.prototype, "stopSending", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "stopSending"), kr.prototype), bn(kr.prototype, "receive", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "receive"), kr.prototype), bn(kr.prototype, "stopReceiving", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "stopReceiving"), kr.prototype), bn(kr.prototype, "muteRemote", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "muteRemote"), kr.prototype), bn(kr.prototype, "unmuteRemote", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "unmuteRemote"), kr.prototype), bn(kr.prototype, "muteLocal", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "muteLocal"), kr.prototype), bn(kr.prototype, "unmuteLocal", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "unmuteLocal"), kr.prototype), bn(kr.prototype, "close", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "close"), kr.prototype), bn(kr.prototype, "updateEncoderConfig", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "updateEncoderConfig"), kr.prototype), bn(kr.prototype, "updateSendParameters", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "updateSendParameters"), kr.prototype), bn(kr.prototype, "replaceTrack", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "replaceTrack"), kr.prototype), bn(kr.prototype, "getRemoteSSRC", [Do], Object.getOwnPropertyDescriptor(kr.prototype, "getRemoteSSRC"), kr.prototype), kr);
    function Do(e, n, i) {
      const o = e[n];
      if (typeof o != "function") throw new Error("Cannot use mutex on object property.");
      return i.value = async function() {
        const f = this.mutex, T = await f.lock("Locking from P2PConnection.".concat(n));
        try {
          for (var A = arguments.length, R = new Array(A), P = 0; P < A; P++) R[P] = arguments[P];
          return await o.apply(this, R);
        } finally {
          T();
        }
      }, i;
    }
    const Uce = { name: "PlanBConnection", create: function(e) {
      let { store: n, spec: i } = e;
      return new jce(i, n);
    } };
    Dr("PROCESS_ID", "process-".concat(zr(8, ""), "-").concat(zr(4, ""), "-").concat(zr(4, ""), "-").concat(zr(4, ""), "-").concat(zr(12, ""))), function() {
      let e;
      try {
        e = window.localStorage.getItem("websdk_ng_global_parameter");
      } catch (n) {
        return void Ee.error("Error loading sdk config", n.message);
      }
      if (e) try {
        const n = JSON.parse(window.atob(e)), i = Date.now();
        Ee.debug("Loading global parameters from cache", n), Object.keys(n).forEach((o) => {
          if (Object.prototype.hasOwnProperty.call(ai, o)) {
            const { value: f, expires: T } = n[o];
            if (T && T <= i) return;
            ud[o] = f, ai[o] = f;
          }
        });
      } catch (n) {
        Ee.error("Error loading mutableParamsCache: ".concat(e), n.message);
      }
    }(), Array.isArray(ud.AREAS) && ud.AREAS.length > 0 && NI(ud.AREAS, !0);
    const k9 = (e, n, i) => {
      Ee.debug("setParameter key:".concat(e, ", value:").concat(JSON.stringify(n))), Dr(e, n, i);
    };
    Nf(uce, !1), Nf(fce, !1), Nf(Wae, !1), Nf(Oce, !1), Nf(ace, !1), Nf(Lce, !1), Nf(Uce, !1);
    const Fi = function(e) {
      const n = new ii(), i = e, o = { getListeners: n.getListeners.bind(n), on: (f, T) => (function(A, R) {
        A === bu.SECURITY_POLICY_VIOLATION && mk(R, !0);
      }(f, T), n.on.bind(n)(f, T)), addListener: n.addListener.bind(n), once: n.once.bind(n), off: n.off.bind(n), removeAllListeners: n.removeAllListeners.bind(n), emit: n.emit.bind(n), safeEmit: n.safeEmit.bind(n) };
      return gk(gk({}, i), o);
    }({ __TRACK_LIST__: cp, VERSION: Ro, BUILD: qS, ESM_BUNDLER: !1, ESM: !1, UMD: !0, DEV: !1, setParameter: k9, getParameter: ft, getSupportedCodec: async function() {
      let e = { audio: [], video: [] };
      try {
        let n = new RTCPeerConnection();
        const i = await async function(o) {
          let f;
          return pr().supportUnifiedPlan ? (o.addTransceiver("video", { direction: "recvonly" }), o.addTransceiver("audio", { direction: "recvonly" }), f = (await o.createOffer()).sdp) : f = (await o.createOffer({ offerToReceiveAudio: !0, offerToReceiveVideo: !0 })).sdp, f;
        }(n);
        if (!i) return e;
        n.close(), n = null, e = function(o) {
          const f = { video: [], audio: [] };
          return o.match(/ VP8/i) && f.video.push("VP8"), o.match(/ VP9/i) && f.video.push("VP9"), o.match(/ AV1/i) && f.video.push("AV1"), o.match(/ H264/i) && f.video.push("H264"), o.match(/ H265/i) && f.video.push("H265"), o.match(/ opus/i) && f.audio.push("OPUS"), o.match(/ PCMU/i) && f.audio.push("PCMU"), o.match(/ PCMA/i) && f.audio.push("PCMA"), o.match(/ G722/i) && f.audio.push("G722"), f;
        }(i);
      } catch (n) {
        throw new jt(Je.CREATE_OFFER_FAILED, n.toString && n.toString()).print();
      }
      return e;
    }, checkSystemRequirements: function() {
      const e = Cn.reportApiInvoke(null, { name: Bi.CHECK_SYSTEM_REQUIREMENTS, options: [], tag: si.TRACER });
      let n = !1;
      try {
        const T = window.RTCPeerConnection, A = navigator.mediaDevices && navigator.mediaDevices.getUserMedia, R = window.WebSocket;
        n = !!(T && A && R), n && PS() && GM(75) && new T().close();
      } catch (T) {
        return Ee.error("check system requirement failed: ", T), !1;
      }
      let i = !1;
      const o = hr();
      o.name === Cr.CHROME && Number(o.version) >= 58 && (kc.engine.name !== "WebKit" || function() {
        const T = hr();
        if (oT()) {
          if (T.os === ts.MAC_OS) return !0;
          if (T.os === ts.IOS) {
            const A = kc.os.version && kc.os.version.split(".");
            if (A && Number(A[0]) === 14 && A[1] && Number(A[1]) >= 3 || A && Number(A[0]) > 14) return !0;
          }
        }
        return !1;
      }()) && (i = !0), (o.name === Cr.FIREFOX && Number(o.version) >= 56 || o.name === Cr.OPERA && Number(o.version) >= 45 || o.name === Cr.SAFARI && Number(o.version) >= 11 || o.name === "WebKit" && (ta() || rc()) && o.osVersion && Number(o.osVersion.split(".")[0]) >= 11 || KM() || hr().name === Cr.QQ) && (i = !0), Ee.debug("checkSystemRequirements, api:", n, "browser", i);
      const f = n && i;
      return e.onSuccess(f), f;
    }, getDevices: function(e) {
      return co.enumerateDevices(!0, !0, e);
    }, getMicrophones: function(e) {
      return co.getRecordingDevices(e);
    }, getCameras: function(e) {
      return co.getCamerasDevices(e);
    }, getElectronScreenSources: z5, getPlaybackDevices: function(e) {
      return co.getSpeakers(e);
    }, createClient: function() {
      var e;
      let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { codec: "vp8", audioCodec: "opus", mode: "rtc" };
      const i = zr(5, "client-"), o = Cn.reportApiInvoke(null, { id: i, name: Bi.CREATE_CLIENT, options: [n], tag: si.TRACER });
      try {
        (function(f) {
          $i(f.codec, "config.codec", ["vp8", "vp9", "av1", "h264", "h265"]), $i(f.mode, "config.mode", ["rtc", "live", "p2p"]), f.audioCodec !== void 0 && $i(f.audioCodec, "config.audioCodec", ["opus", "pcmu", "pcma", "g722"]), f.proxyServer !== void 0 && ms(f.proxyServer, "config.proxyServer", 1, 1e4), f.turnServer !== void 0 && r5(f.turnServer), f.httpRetryConfig !== void 0 && n5(f.httpRetryConfig), f.websocketRetryConfig !== void 0 && n5(f.websocketRetryConfig);
        })(n);
      } catch (f) {
        throw o.onError(f), f;
      }
      return (YM(16, 0, !0) || XM(16, 0, !0)) && (n.codec === "vp9" && (n.codec = "vp8", Ee.debug("browser not support vp9, force use vp8")), Dr("UNSUPPORTED_VIDEO_CODEC", ["vp9"])), n.audioCodec === void 0 && (n.audioCodec = "opus"), o.onSuccess(), new qae(lc(lc({ forceWaitGatewayResponse: !0 }, n), {}, { role: on(e = ["rtc", "p2p"]).call(e, n.mode) ? "host" : n.role || "audience" }), i);
    }, createCameraVideoTrack: async function() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const n = ft("CAMERA_CAPTURE_CONFIG"), i = zr(8, "track-cam-"), o = Cn.reportApiInvoke(null, { id: i, tag: si.TRACER, name: Bi.CREATE_CAM_VIDEO_TRACK, options: [Zr({}, e), n] });
      n && (e.encoderConfig = n);
      const f = AT(e);
      let T = null;
      Ee.info("start create camera video track with config", JSON.stringify(e), "trackId", i);
      try {
        T = (await oo({ video: f }, i)).getVideoTracks()[0] || null;
      } catch (R) {
        throw o.onError(R), R;
      }
      if (!T) {
        const R = new Gt(Je.UNEXPECTED_ERROR, "can not find track in media stream");
        return o.onError(R), R.throw(Ee);
      }
      e.optimizationMode && dI(i, T, e, yu(e.encoderConfig));
      const A = new uI(T, e, f, e.scalabiltyMode ? yT(e.scalabiltyMode) : { numSpatialLayers: 1, numTemporalLayers: 1 }, e.optimizationMode, i);
      return o.onSuccess(A.getTrackId()), Ee.info("create camera video success, trackId:", i), A;
    }, createCustomVideoTrack: function(e) {
      const n = zr(8, "track-cus-"), i = Cn.reportApiInvoke(null, { id: n, tag: si.TRACER, name: Bi.CREATE_CUSTOM_VIDEO_TRACK, options: [e] }), o = new Wr(e.mediaStreamTrack, { width: e.width, height: e.height, frameRate: e.frameRate, bitrateMax: e.bitrateMax, bitrateMin: e.bitrateMin }, e.scalabiltyMode ? yT(e.scalabiltyMode) : { numSpatialLayers: 1, numTemporalLayers: 1 }, e.optimizationMode, n, [Fr.CUSTOM_TRACK]);
      return i.onSuccess(o.getTrackId()), Ee.info("create custom video track success with config", e, "trackId", o.getTrackId()), o;
    }, createScreenVideoTrack: async function() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "disable";
      const i = typeof n == "object" ? function(te) {
        return Z5(te);
      }(n) : void 0;
      i && (n = "auto");
      const o = zr(8, "track-scr-v-"), f = Cn.reportApiInvoke(null, { id: o, tag: si.TRACER, name: Bi.CREATE_SCREEN_VIDEO_TRACK, options: [Zr({}, e), n] });
      e.encoderConfig ? typeof e.encoderConfig == "string" || e.encoderConfig.width && e.encoderConfig.height || (e.encoderConfig.width = { max: 1920 }, e.encoderConfig.height = { max: 1080 }) : e.encoderConfig = "1080p_2";
      const T = function(te) {
        const oe = {};
        te.screenSourceType && (oe.mediaSource = te.screenSourceType), te.extensionId && $d() && (oe.extensionId = te.extensionId);
        const { displaySurface: He, selfBrowserSurface: Re, surfaceSwitching: De, systemAudio: Xe, preferCurrentTab: We } = te;
        (cT(107) || NS(107) || wS(93)) && (He && ($i(He, "displaySurface", ["browser", "window", "monitor"]), oe.displaySurface = He), Re ? ($i(Re, "selfBrowserSurface", ["exclude", "include"]), oe.selfBrowserSurface = Re) : oe.selfBrowserSurface = "include", De && ($i(De, "surfaceSwitching", ["exclude", "include"]), oe.surfaceSwitching = De)), (cT(105) || NS(105) || wS(91)) && Xe && ($i(Xe, "systemAudio", ["exclude", "include"]), oe.systemAudio = Xe), (cT(94) || NS(94) || wS(80)) && We && (oe.preferCurrentTab = !0), te.electronScreenSourceId && (oe.sourceId = te.electronScreenSourceId);
        const mt = te.encoderConfig ? QS(te.encoderConfig) : null;
        return oe.mandatory = { chromeMediaSource: "desktop", maxWidth: mt ? mt.width : void 0, maxHeight: mt ? mt.height : void 0 }, mt && (mt.frameRate && (typeof mt.frameRate == "number" ? (oe.mandatory.maxFrameRate = mt.frameRate, oe.mandatory.minFrameRate = mt.frameRate) : (oe.mandatory.maxFrameRate = mt.frameRate.max || mt.frameRate.ideal || mt.frameRate.exact || void 0, oe.mandatory.minFrameRate = mt.frameRate.min || mt.frameRate.ideal || mt.frameRate.exact || void 0), oe.frameRate = mt.frameRate), mt.width && (oe.width = mt.width), mt.height && (oe.height = mt.height)), oe;
      }(e);
      let A = null, R = null;
      const P = pr();
      if (!P.supportShareAudio && n === "enable") {
        const te = new Gt(Je.NOT_SUPPORTED, "your browser or platform is not support share-screen with audio");
        return f.onError(te), te.throw(Ee);
      }
      Ee.info("start create screen video track with config", e, "withAudio", n, "trackId", o);
      const L = P.supportShareAudio && n !== "disable";
      try {
        const te = await oo({ screen: T, screenAudio: L ? i || !0 : void 0 }, o);
        A = te.getVideoTracks()[0] || null, R = te.getAudioTracks()[0] || null;
      } catch (te) {
        throw f.onError(te), te;
      }
      if (!A) {
        const te = new Gt(Je.UNEXPECTED_ERROR, "can not find track in media stream");
        return f.onError(te), te.throw(Ee);
      }
      if (!R && n === "enable") {
        A && A.stop();
        const te = new Gt(Je.SHARE_AUDIO_NOT_ALLOWED);
        return f.onError(te), te.throw(Ee);
      }
      e.optimizationMode || (e.optimizationMode = "detail"), e.optimizationMode && (dI(o, A, e, e.encoderConfig && QS(e.encoderConfig) || void 0), e.encoderConfig && typeof e.encoderConfig != "string" && (e.encoderConfig.bitrateMin = e.encoderConfig.bitrateMax));
      const z = new Wr(A, e.encoderConfig ? QS(e.encoderConfig) : {}, e.scalabiltyMode ? yT(e.scalabiltyMode) : { numSpatialLayers: 1, numTemporalLayers: 1 }, e.optimizationMode, o, [Fr.SCREEN_TRACK]);
      if (!R) return f.onSuccess(z.getTrackId()), Ee.info("create screen video track success", "video:", z.getTrackId()), z;
      const Y = new li(R, void 0, zr(8, "track-scr-a-"), !1);
      return f.onSuccess([z.getTrackId(), Y.getTrackId()]), Ee.info("create screen video track success", "video:", z.getTrackId(), "audio:", Y.getTrackId()), [z, Y];
    }, createMicrophoneAndCameraTracks: async function() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      const i = ft("CAMERA_CAPTURE_CONFIG"), o = zr(8, "track-mic-"), f = zr(8, "track-cam-"), T = Cn.reportApiInvoke(null, { id: "".concat(o, "-").concat(f), tag: si.TRACER, name: Bi.CREATE_MIC_AND_CAM_TRACKS, options: [e, n, i] });
      i && (n.encoderConfig = i);
      const A = AT(n), R = Q5(e);
      let P = null, L = null;
      Ee.info("start create camera video track(".concat(f, ") and microphone audio track(").concat(o, ") with config, audio: ").concat(JSON.stringify(e), ", video: ").concat(JSON.stringify(n)));
      try {
        const te = await oo({ audio: R, video: A }, "".concat(o, "-").concat(f));
        P = te.getAudioTracks()[0], L = te.getVideoTracks()[0];
      } catch (te) {
        throw T.onError(te), te;
      }
      if (!P || !L) {
        const te = new Gt(Je.UNEXPECTED_ERROR, "can not find tracks in media stream");
        return T.onError(te), te.throw(Ee);
      }
      n.optimizationMode && dI(f, L, n, yu(n.encoderConfig));
      const z = new OT(P, e, R, o), Y = new uI(L, n, A, n.scalabiltyMode ? yT(n.scalabiltyMode) : { numSpatialLayers: 1, numTemporalLayers: 1 }, n.optimizationMode, f);
      return T.onSuccess([z.getTrackId(), Y.getTrackId()]), Ee.info("create camera video track(".concat(f, ") and microphone audio track(").concat(o, ") success")), [z, Y];
    }, createMicrophoneAudioTrack: async function() {
      let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      const n = zr(8, "track-mic-"), i = Cn.reportApiInvoke(null, { id: n, tag: si.TRACER, name: Bi.CREATE_MIC_AUDIO_TRACK, options: [e] }), o = Q5(e);
      let f = null;
      Ee.info("start create microphone audio track with config", JSON.stringify(e), "trackId", n);
      try {
        f = (await oo({ audio: o }, n)).getAudioTracks()[0] || null;
      } catch (A) {
        throw i.onError(A), A;
      }
      if (!f) {
        const A = new Gt(Je.UNEXPECTED_ERROR, "can not find track in media stream");
        return i.onError(A), A.throw(Ee);
      }
      const T = new OT(f, e, o, n);
      return i.onSuccess(T.getTrackId()), Ee.info("create microphone audio track success, trackId:", n), T;
    }, createCustomAudioTrack: function(e) {
      const n = zr(8, "track-cus-"), i = Cn.reportApiInvoke(null, { id: n, tag: si.TRACER, name: Bi.CREATE_CUSTOM_AUDIO_TRACK, options: [e] }), o = new li(e.mediaStreamTrack, e.encoderConfig ? vT(e.encoderConfig) : {}, n, !1);
      return Ee.info("create custom audio track success with config", e, "trackId", o.getTrackId()), i.onSuccess(o.getTrackId()), o;
    }, createBufferSourceAudioTrack: async function(e) {
      var n;
      const { cacheOnlineFile: i, encoderConfig: o } = e;
      let { source: f } = e;
      const T = { source: f instanceof AudioBuffer ? "AudioBuffer" : f instanceof File ? (n = File.name) !== null && n !== void 0 ? n : "File" : f, cacheOnlineFile: i, encoderConfig: o }, A = zr(8, "track-buf-"), R = Cn.reportApiInvoke(null, { id: A, tag: si.TRACER, name: Bi.CREATE_BUFFER_AUDIO_TRACK, options: [T] });
      if (ft("DISABLE_WEBAUDIO")) throw new Gt(Je.NOT_SUPPORTED, "can not create BufferSourceAudioTrack when WebAudio disabled");
      Ee.info("start create buffer source audio track with config", JSON.stringify(T), "trackId", A);
      const P = f;
      if (!(f instanceof AudioBuffer)) try {
        f = await async function(Y, te) {
          let oe = null;
          if (typeof Y == "string") {
            const Re = UL.get(Y);
            if (Re) return Ee.debug("use cached audio resource: ", Y), Re;
            try {
              oe = (await jc(() => fa.get(Y, { responseType: "arraybuffer" }), void 0, void 0, { maxRetryCount: 3 })).data;
            } catch (De) {
              throw new Gt(Je.FETCH_AUDIO_FILE_FAILED, De.toString());
            }
          } else
            oe = await new cn((De, Xe) => {
              const We = new FileReader();
              We.onload = (mt) => {
                mt.target ? De(mt.target.result) : Xe(new Gt(Je.READ_LOCAL_AUDIO_FILE_ERROR));
              }, We.onerror = () => {
                Xe(new Gt(Je.READ_LOCAL_AUDIO_FILE_ERROR));
              }, We.readAsArrayBuffer(Y);
            });
          const He = await function(Re) {
            const De = pp();
            return new cn((Xe, We) => {
              De.decodeAudioData(Re, (mt) => {
                Xe(mt);
              }, (mt) => {
                We(new Gt(Je.DECODE_AUDIO_FILE_FAILED, mt.toString()));
              });
            });
          }(oe);
          return typeof Y == "string" && te && UL.set(Y, He), He;
        }(f, i);
      } catch (Y) {
        return R.onError(Y), Y.throw(Ee);
      }
      const L = new vse(f), z = new yse(P, L, o ? vT(o) : {}, A);
      return Ee.info("create buffer source audio track success, trackId:", A), R.onSuccess(z.getTrackId()), z;
    }, setAppType: function(e) {
      if (Ee.debug("setAppType: ".concat(e)), !(Number.isInteger(e) && e >= 0)) throw Ee.debug("Invalid appType"), new jt(Je.INVALID_PARAMS, "invalid app type", e);
      Dr("APP_TYPE", Math.floor(e));
    }, setLogLevel: function(e) {
      Ee.setLogLevel(e);
    }, enableLogUpload: function() {
      ft("USE_NEW_LOG") ? Dr("UPLOAD_LOG", !0) : Ee.enableLogUpload();
    }, disableLogUpload: function() {
      ft("USE_NEW_LOG") ? Dr("UPLOAD_LOG", !1) : Ee.disableLogUpload();
    }, createChannelMediaRelayConfiguration: function() {
      return new M6();
    }, checkAudioTrackIsActive: async function(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5e3;
      const i = Cn.reportApiInvoke(null, { tag: si.TRACER, name: Bi.CHECK_AUDIO_TRACK_IS_ACTIVE, options: [n] });
      if (!(e instanceof li || e instanceof Ep)) {
        const P = new jt(Je.INVALID_TRACK, "the parameter is not a audio track");
        return i.onError(P), P.throw();
      }
      n && n < 1e3 && (n = 1e3);
      const o = e instanceof li ? e.getTrackLabel() : "remote_track", f = e.getVolumeLevel();
      let T = f, A = f;
      const R = Date.now();
      return new cn((P) => {
        const L = setInterval(() => {
          const z = e.getVolumeLevel();
          T = z > T ? z : T, A = z < A ? z : A;
          const Y = T - A > 1e-4, te = Date.now() - R;
          if (Y || te > n) {
            clearInterval(L);
            const oe = Y, He = { duration: te, deviceLabel: o, maxVolumeLevel: T, result: oe };
            Ee.info("[track-".concat(e.getTrackId(), "] check audio track active completed. ").concat(JSON.stringify(He))), i.onSuccess(He), P(oe);
          }
        }, 200);
      });
    }, checkVideoTrackIsActive: async function(e) {
      let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5e3;
      const i = Cn.reportApiInvoke(null, { tag: si.TRACER, name: Bi.CHECK_VIDEO_TRACK_IS_ACTIVE, options: [n] });
      if (!(e instanceof Wr || e instanceof mp)) {
        const Y = new jt(Je.INVALID_TRACK, "the parameter is not a video track");
        return i.onError(Y), Y.throw();
      }
      n && n < 1e3 && (n = 1e3);
      const o = e instanceof Wr ? e.getTrackLabel() : "remote_track", f = e.getMediaStreamTrack(!0), T = document.createElement("video");
      T.style.width = "1px", T.style.height = "1px", T.setAttribute("muted", ""), T.muted = !0, T.setAttribute("playsinline", ""), T.controls = !1, (Os() || oT()) && (T.style.opacity = "0.01", T.style.position = "fixed", T.style.left = "0", T.style.top = "0", document.body.appendChild(T)), T.srcObject = new MediaStream([f]), T.play();
      const A = document.createElement("canvas");
      A.width = 160, A.height = 120;
      let R = 0, P = 0;
      try {
        const Y = Date.now();
        R = await function(te, oe, He, Re) {
          let De, Xe = 0, We = null;
          return new cn((mt, Pt) => {
            function xt() {
              Xe > Re && De && (De(), mt(Xe));
              const Nt = He.getContext("2d");
              if (!Nt) {
                const fn = new jt(Je.UNEXPECTED_ERROR, "can not get canvas 2d context.");
                return Ee.error(fn.toString()), void Pt(fn);
              }
              Nt.drawImage(te, 0, 0, 160, 120);
              const Vt = Nt.getImageData(0, 0, He.width, He.height), nn = Math.floor(Vt.data.length / 3);
              if (We) {
                for (let fn = 0; fn < nn; fn += 3) if (Vt.data[fn] !== We[fn]) return Xe += 1, void (We = Vt.data);
                We = Vt.data;
              } else We = Vt.data;
            }
            setTimeout(() => {
              De && (De(), mt(Xe));
            }, oe), De = rI(() => {
              xt();
            }, 30);
          });
        }(T, n, A, 4), P = Date.now() - Y;
      } catch (Y) {
        throw i.onError(Y), Y;
      }
      Dae === Cr.SAFARI && (T.pause(), T.remove()), T.srcObject = null;
      const L = R > 4, z = { duration: P, changedPicNum: R, deviceLabel: o, result: L };
      return Ee.info("[track-".concat(e.getTrackId(), "] check video track active completed. ").concat(JSON.stringify(z))), i.onSuccess(z), L;
    }, setArea: NI, audioElementPlayCenter: ha, resumeAudioContext: function() {
      ha.autoResumeAfterInterruption(!0);
    }, processExternalMediaAEC: function(e) {
      Jae.processExternalMediaAEC(e);
    }, registerExtensions: function(e) {
      const n = ft("PLUGIN_INFO") || [];
      e.forEach((i) => {
        "name" in i && !on(n).call(n, i.name) && n.push(i.name);
        const o = i;
        o.__registered__ = !0, o.logger.hookLog = Ee.extLog, o.reporter.hookApiInvoke = Cn.extApiInvoke, o.parameters && Object.keys(o.parameters).forEach((f) => {
          o.parameters[f] = ft(f);
        });
      }), k9("PLUGIN_INFO", n);
    }, ChannelMediaRelayError: yp, ChannelMediaRelayEvent: hd, ChannelMediaRelayState: Sa, RemoteStreamFallbackType: lse, RemoteStreamType: dse, ConnectionDisconnectedReason: br, AudienceLatencyLevelType: zie, AREAS: vr, preload: async function(e, n, i, o) {
      return o7(e, n, i, o);
    } });
    return Object.defineProperties(Fi, { onAudioAutoplayFailed: { get: () => uo.onAudioAutoplayFailed, set: (e) => {
      uo.onAudioAutoplayFailed = e;
    } }, onAutoplayFailed: { get: () => uo.onAutoplayFailed, set: (e) => {
      uo.onAutoplayFailed = e;
    } }, _onSecurityPolicyViolation: { value: void 0, writable: !0 }, _cspEventHandlerPointer: { value: void 0, writable: !0 }, onSecurityPolicyViolation: { get: () => Fi._onSecurityPolicyViolation, set(e) {
      Fi._onSecurityPolicyViolation = e, mk(e);
    } }, __CLIENT_LIST__: { get: () => ft("SHOW_GLOBAL_CLIENT_LIST") ? Sf : [] } }), co.on(Of.CAMERA_DEVICE_CHANGED, (e) => {
      Ee.info("camera device changed", JSON.stringify(e)), Fi.onCameraChanged && Fi.onCameraChanged(e), Fi.safeEmit(bu.CAMERA_CHANGED, e);
    }), co.on(Of.RECORDING_DEVICE_CHANGED, (e) => {
      Ee.info("microphone device changed", JSON.stringify(e)), Fi.onMicrophoneChanged && Fi.onMicrophoneChanged(e), Fi.safeEmit(bu.MICROPHONE_CHANGED, e);
    }), co.on(Of.PLAYOUT_DEVICE_CHANGED, (e) => {
      Ee.debug("playout device changed", JSON.stringify(e)), Fi.onPlaybackDeviceChanged && Fi.onPlaybackDeviceChanged(e), Fi.safeEmit(bu.PLAYBACK_DEVICE_CHANGED, e);
    }), ha.onAutoplayFailed = () => {
      Ee.info("detect audio element autoplay failed"), uo.onAudioAutoplayFailed && uo.onAudioAutoplayFailed();
    }, wr.on("autoplay-failed", () => {
      Ee.info("detect webaudio autoplay failed"), uo.onAudioAutoplayFailed && uo.onAudioAutoplayFailed(), Fi.safeEmit(bu.AUTOPLAY_FAILED);
    }), wr.on(vs.STATE_CHANGE, (e, n) => {
      Ee.info("audio context state changed: ".concat(n, " => ").concat(e)), Fi.onAudioContextStateChanged && Fi.onAudioContextStateChanged(e, n), Fi.safeEmit(bu.AUDIO_CONTEXT_STATE_CHANGED, e, n);
    }), Mi.on(tp.NETWORK_STATE_CHANGE, (e, n) => {
      Ee.info("[network-indicator] network state changed, ".concat(n, " => ").concat(e));
    }), window && (window.__ARTC__ = Fi), Fi;
  });
})(pX);
var qIe = pX.exports;
const Hb = /* @__PURE__ */ Gl(qIe);
var EX = { exports: {} };
(function(t, r) {
  (function(a, u) {
    t.exports = u();
  })(self, function() {
    return function() {
      var a = { 4537: function(l) {
        l.exports = function(v, s) {
          for (var c = new Array(arguments.length - 1), d = 0, p = 2, m = !0; p < arguments.length; ) c[d++] = arguments[p++];
          return new Promise(function(E, y) {
            c[d] = function(g) {
              if (m) if (m = !1, g) y(g);
              else {
                for (var C = new Array(arguments.length - 1), O = 0; O < C.length; ) C[O++] = arguments[O];
                E.apply(null, C);
              }
            };
            try {
              v.apply(s || null, c);
            } catch (g) {
              m && (m = !1, y(g));
            }
          });
        };
      }, 7419: function(l, v) {
        var s = v;
        s.length = function(E) {
          var y = E.length;
          if (!y) return 0;
          for (var g = 0; --y % 4 > 1 && E.charAt(y) === "="; ) ++g;
          return Math.ceil(3 * E.length) / 4 - g;
        };
        for (var c = new Array(64), d = new Array(123), p = 0; p < 64; ) d[c[p] = p < 26 ? p + 65 : p < 52 ? p + 71 : p < 62 ? p - 4 : p - 59 | 43] = p++;
        s.encode = function(E, y, g) {
          for (var C, O = null, N = [], w = 0, _ = 0; y < g; ) {
            var I = E[y++];
            switch (_) {
              case 0:
                N[w++] = c[I >> 2], C = (3 & I) << 4, _ = 1;
                break;
              case 1:
                N[w++] = c[C | I >> 4], C = (15 & I) << 2, _ = 2;
                break;
              case 2:
                N[w++] = c[C | I >> 6], N[w++] = c[63 & I], _ = 0;
            }
            w > 8191 && ((O || (O = [])).push(String.fromCharCode.apply(String, N)), w = 0);
          }
          return _ && (N[w++] = c[C], N[w++] = 61, _ === 1 && (N[w++] = 61)), O ? (w && O.push(String.fromCharCode.apply(String, N.slice(0, w))), O.join("")) : String.fromCharCode.apply(String, N.slice(0, w));
        };
        var m = "invalid encoding";
        s.decode = function(E, y, g) {
          for (var C, O = g, N = 0, w = 0; w < E.length; ) {
            var _ = E.charCodeAt(w++);
            if (_ === 61 && N > 1) break;
            if ((_ = d[_]) === void 0) throw Error(m);
            switch (N) {
              case 0:
                C = _, N = 1;
                break;
              case 1:
                y[g++] = C << 2 | (48 & _) >> 4, C = _, N = 2;
                break;
              case 2:
                y[g++] = (15 & C) << 4 | (60 & _) >> 2, C = _, N = 3;
                break;
              case 3:
                y[g++] = (3 & C) << 6 | _, N = 0;
            }
          }
          if (N === 1) throw Error(m);
          return g - O;
        }, s.test = function(E) {
          return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(E);
        };
      }, 5124: function(l) {
        function v(s, c) {
          typeof s == "string" && (c = s, s = void 0);
          var d = [];
          function p(E) {
            if (typeof E != "string") {
              var y = m();
              if (v.verbose && console.log("codegen: " + y), y = "return " + y, E) {
                for (var g = Object.keys(E), C = new Array(g.length + 1), O = new Array(g.length), N = 0; N < g.length; ) C[N] = g[N], O[N] = E[g[N++]];
                return C[N] = y, Function.apply(null, C).apply(null, O);
              }
              return Function(y)();
            }
            for (var w = new Array(arguments.length - 1), _ = 0; _ < w.length; ) w[_] = arguments[++_];
            if (_ = 0, E = E.replace(/%([%dfijs])/g, function(I, k) {
              var H = w[_++];
              switch (k) {
                case "d":
                case "f":
                  return String(Number(H));
                case "i":
                  return String(Math.floor(H));
                case "j":
                  return JSON.stringify(H);
                case "s":
                  return String(H);
              }
              return "%";
            }), _ !== w.length) throw Error("parameter count mismatch");
            return d.push(E), p;
          }
          function m(E) {
            return "function " + (E || c || "") + "(" + (s && s.join(",") || "") + `){
  ` + d.join(`
  `) + `
}`;
          }
          return p.toString = m, p;
        }
        l.exports = v, v.verbose = !1;
      }, 9211: function(l) {
        function v() {
          this._listeners = {};
        }
        l.exports = v, v.prototype.on = function(s, c, d) {
          return (this._listeners[s] || (this._listeners[s] = [])).push({ fn: c, ctx: d || this }), this;
        }, v.prototype.off = function(s, c) {
          if (s === void 0) this._listeners = {};
          else if (c === void 0) this._listeners[s] = [];
          else for (var d = this._listeners[s], p = 0; p < d.length; ) d[p].fn === c ? d.splice(p, 1) : ++p;
          return this;
        }, v.prototype.emit = function(s) {
          var c = this._listeners[s];
          if (c) {
            for (var d = [], p = 1; p < arguments.length; ) d.push(arguments[p++]);
            for (p = 0; p < c.length; ) c[p].fn.apply(c[p++].ctx, d);
          }
          return this;
        };
      }, 9054: function(l, v, s) {
        l.exports = p;
        var c = s(4537), d = s(7199)("fs");
        function p(m, E, y) {
          return typeof E == "function" ? (y = E, E = {}) : E || (E = {}), y ? !E.xhr && d && d.readFile ? d.readFile(m, function(g, C) {
            return g && typeof XMLHttpRequest < "u" ? p.xhr(m, E, y) : g ? y(g) : y(null, E.binary ? C : C.toString("utf8"));
          }) : p.xhr(m, E, y) : c(p, this, m, E);
        }
        p.xhr = function(m, E, y) {
          var g = new XMLHttpRequest();
          g.onreadystatechange = function() {
            if (g.readyState === 4) {
              if (g.status !== 0 && g.status !== 200) return y(Error("status " + g.status));
              if (E.binary) {
                var C = g.response;
                if (!C) {
                  C = [];
                  for (var O = 0; O < g.responseText.length; ++O) C.push(255 & g.responseText.charCodeAt(O));
                }
                return y(null, typeof Uint8Array < "u" ? new Uint8Array(C) : C);
              }
              return y(null, g.responseText);
            }
          }, E.binary && ("overrideMimeType" in g && g.overrideMimeType("text/plain; charset=x-user-defined"), g.responseType = "arraybuffer"), g.open("GET", m), g.send();
        };
      }, 945: function(l) {
        function v(m) {
          return typeof Float32Array < "u" ? function() {
            var E = new Float32Array([-0]), y = new Uint8Array(E.buffer), g = y[3] === 128;
            function C(_, I, k) {
              E[0] = _, I[k] = y[0], I[k + 1] = y[1], I[k + 2] = y[2], I[k + 3] = y[3];
            }
            function O(_, I, k) {
              E[0] = _, I[k] = y[3], I[k + 1] = y[2], I[k + 2] = y[1], I[k + 3] = y[0];
            }
            function N(_, I) {
              return y[0] = _[I], y[1] = _[I + 1], y[2] = _[I + 2], y[3] = _[I + 3], E[0];
            }
            function w(_, I) {
              return y[3] = _[I], y[2] = _[I + 1], y[1] = _[I + 2], y[0] = _[I + 3], E[0];
            }
            m.writeFloatLE = g ? C : O, m.writeFloatBE = g ? O : C, m.readFloatLE = g ? N : w, m.readFloatBE = g ? w : N;
          }() : function() {
            function E(g, C, O, N) {
              var w = C < 0 ? 1 : 0;
              if (w && (C = -C), C === 0) g(1 / C > 0 ? 0 : 2147483648, O, N);
              else if (isNaN(C)) g(2143289344, O, N);
              else if (C > 34028234663852886e22) g((w << 31 | 2139095040) >>> 0, O, N);
              else if (C < 11754943508222875e-54) g((w << 31 | Math.round(C / 1401298464324817e-60)) >>> 0, O, N);
              else {
                var _ = Math.floor(Math.log(C) / Math.LN2);
                g((w << 31 | _ + 127 << 23 | 8388607 & Math.round(C * Math.pow(2, -_) * 8388608)) >>> 0, O, N);
              }
            }
            function y(g, C, O) {
              var N = g(C, O), w = 2 * (N >> 31) + 1, _ = N >>> 23 & 255, I = 8388607 & N;
              return _ === 255 ? I ? NaN : w * (1 / 0) : _ === 0 ? 1401298464324817e-60 * w * I : w * Math.pow(2, _ - 150) * (I + 8388608);
            }
            m.writeFloatLE = E.bind(null, s), m.writeFloatBE = E.bind(null, c), m.readFloatLE = y.bind(null, d), m.readFloatBE = y.bind(null, p);
          }(), typeof Float64Array < "u" ? function() {
            var E = new Float64Array([-0]), y = new Uint8Array(E.buffer), g = y[7] === 128;
            function C(_, I, k) {
              E[0] = _, I[k] = y[0], I[k + 1] = y[1], I[k + 2] = y[2], I[k + 3] = y[3], I[k + 4] = y[4], I[k + 5] = y[5], I[k + 6] = y[6], I[k + 7] = y[7];
            }
            function O(_, I, k) {
              E[0] = _, I[k] = y[7], I[k + 1] = y[6], I[k + 2] = y[5], I[k + 3] = y[4], I[k + 4] = y[3], I[k + 5] = y[2], I[k + 6] = y[1], I[k + 7] = y[0];
            }
            function N(_, I) {
              return y[0] = _[I], y[1] = _[I + 1], y[2] = _[I + 2], y[3] = _[I + 3], y[4] = _[I + 4], y[5] = _[I + 5], y[6] = _[I + 6], y[7] = _[I + 7], E[0];
            }
            function w(_, I) {
              return y[7] = _[I], y[6] = _[I + 1], y[5] = _[I + 2], y[4] = _[I + 3], y[3] = _[I + 4], y[2] = _[I + 5], y[1] = _[I + 6], y[0] = _[I + 7], E[0];
            }
            m.writeDoubleLE = g ? C : O, m.writeDoubleBE = g ? O : C, m.readDoubleLE = g ? N : w, m.readDoubleBE = g ? w : N;
          }() : function() {
            function E(g, C, O, N, w, _) {
              var I = N < 0 ? 1 : 0;
              if (I && (N = -N), N === 0) g(0, w, _ + C), g(1 / N > 0 ? 0 : 2147483648, w, _ + O);
              else if (isNaN(N)) g(0, w, _ + C), g(2146959360, w, _ + O);
              else if (N > 17976931348623157e292) g(0, w, _ + C), g((I << 31 | 2146435072) >>> 0, w, _ + O);
              else {
                var k;
                if (N < 22250738585072014e-324) g((k = N / 5e-324) >>> 0, w, _ + C), g((I << 31 | k / 4294967296) >>> 0, w, _ + O);
                else {
                  var H = Math.floor(Math.log(N) / Math.LN2);
                  H === 1024 && (H = 1023), g(4503599627370496 * (k = N * Math.pow(2, -H)) >>> 0, w, _ + C), g((I << 31 | H + 1023 << 20 | 1048576 * k & 1048575) >>> 0, w, _ + O);
                }
              }
            }
            function y(g, C, O, N, w) {
              var _ = g(N, w + C), I = g(N, w + O), k = 2 * (I >> 31) + 1, H = I >>> 20 & 2047, S = 4294967296 * (1048575 & I) + _;
              return H === 2047 ? S ? NaN : k * (1 / 0) : H === 0 ? 5e-324 * k * S : k * Math.pow(2, H - 1075) * (S + 4503599627370496);
            }
            m.writeDoubleLE = E.bind(null, s, 0, 4), m.writeDoubleBE = E.bind(null, c, 4, 0), m.readDoubleLE = y.bind(null, d, 0, 4), m.readDoubleBE = y.bind(null, p, 4, 0);
          }(), m;
        }
        function s(m, E, y) {
          E[y] = 255 & m, E[y + 1] = m >>> 8 & 255, E[y + 2] = m >>> 16 & 255, E[y + 3] = m >>> 24;
        }
        function c(m, E, y) {
          E[y] = m >>> 24, E[y + 1] = m >>> 16 & 255, E[y + 2] = m >>> 8 & 255, E[y + 3] = 255 & m;
        }
        function d(m, E) {
          return (m[E] | m[E + 1] << 8 | m[E + 2] << 16 | m[E + 3] << 24) >>> 0;
        }
        function p(m, E) {
          return (m[E] << 24 | m[E + 1] << 16 | m[E + 2] << 8 | m[E + 3]) >>> 0;
        }
        l.exports = v(v);
      }, 7199: function(l, v, s) {
        l.exports = function(c) {
          try {
            var d = s(822)(c);
            if (d && (d.length || Object.keys(d).length)) return d;
          } catch {
          }
          return null;
        };
      }, 822: function(l) {
        function v(s) {
          var c = new Error("Cannot find module '" + s + "'");
          throw c.code = "MODULE_NOT_FOUND", c;
        }
        v.keys = function() {
          return [];
        }, v.resolve = v, v.id = 822, l.exports = v;
      }, 8626: function(l, v) {
        var s = v, c = s.isAbsolute = function(p) {
          return /^(?:\/|\w+:)/.test(p);
        }, d = s.normalize = function(p) {
          var m = (p = p.replace(/\\/g, "/").replace(/\/{2,}/g, "/")).split("/"), E = c(p), y = "";
          E && (y = m.shift() + "/");
          for (var g = 0; g < m.length; ) m[g] === ".." ? g > 0 && m[g - 1] !== ".." ? m.splice(--g, 2) : E ? m.splice(g, 1) : ++g : m[g] === "." ? m.splice(g, 1) : ++g;
          return y + m.join("/");
        };
        s.resolve = function(p, m, E) {
          return E || (m = d(m)), c(m) ? m : (E || (p = d(p)), (p = p.replace(/(?:\/|^)[^/]+$/, "")).length ? d(p + "/" + m) : m);
        };
      }, 6662: function(l) {
        l.exports = function(v, s, c) {
          var d = c || 8192, p = d >>> 1, m = null, E = d;
          return function(y) {
            if (y < 1 || y > p) return v(y);
            E + y > d && (m = v(d), E = 0);
            var g = s.call(m, E, E += y);
            return 7 & E && (E = 1 + (7 | E)), g;
          };
        };
      }, 4997: function(l, v) {
        var s = v;
        s.length = function(c) {
          for (var d = 0, p = 0, m = 0; m < c.length; ++m) (p = c.charCodeAt(m)) < 128 ? d += 1 : p < 2048 ? d += 2 : (64512 & p) == 55296 && (64512 & c.charCodeAt(m + 1)) == 56320 ? (++m, d += 4) : d += 3;
          return d;
        }, s.read = function(c, d, p) {
          if (p - d < 1) return "";
          for (var m, E = null, y = [], g = 0; d < p; ) (m = c[d++]) < 128 ? y[g++] = m : m > 191 && m < 224 ? y[g++] = (31 & m) << 6 | 63 & c[d++] : m > 239 && m < 365 ? (m = ((7 & m) << 18 | (63 & c[d++]) << 12 | (63 & c[d++]) << 6 | 63 & c[d++]) - 65536, y[g++] = 55296 + (m >> 10), y[g++] = 56320 + (1023 & m)) : y[g++] = (15 & m) << 12 | (63 & c[d++]) << 6 | 63 & c[d++], g > 8191 && ((E || (E = [])).push(String.fromCharCode.apply(String, y)), g = 0);
          return E ? (g && E.push(String.fromCharCode.apply(String, y.slice(0, g))), E.join("")) : String.fromCharCode.apply(String, y.slice(0, g));
        }, s.write = function(c, d, p) {
          for (var m, E, y = p, g = 0; g < c.length; ++g) (m = c.charCodeAt(g)) < 128 ? d[p++] = m : m < 2048 ? (d[p++] = m >> 6 | 192, d[p++] = 63 & m | 128) : (64512 & m) == 55296 && (64512 & (E = c.charCodeAt(g + 1))) == 56320 ? (m = 65536 + ((1023 & m) << 10) + (1023 & E), ++g, d[p++] = m >> 18 | 240, d[p++] = m >> 12 & 63 | 128, d[p++] = m >> 6 & 63 | 128, d[p++] = 63 & m | 128) : (d[p++] = m >> 12 | 224, d[p++] = m >> 6 & 63 | 128, d[p++] = 63 & m | 128);
          return p - y;
        };
      }, 4188: function(l, v, s) {
        var c, d, p;
        (function(m) {
          if (v != null && typeof v.nodeType != "number") l.exports = m();
          else if (s.amdO != null) d = [], (p = typeof (c = m) == "function" ? c.apply(v, d) : c) === void 0 || (l.exports = p);
          else {
            var E = m(), y = typeof self < "u" ? self : $.global;
            typeof y.btoa != "function" && (y.btoa = E.btoa), typeof y.atob != "function" && (y.atob = E.atob);
          }
        })(function() {
          var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          function E(y) {
            this.message = y;
          }
          return E.prototype = new Error(), E.prototype.name = "InvalidCharacterError", { btoa: function(y) {
            for (var g, C, O = String(y), N = 0, w = m, _ = ""; O.charAt(0 | N) || (w = "=", N % 1); _ += w.charAt(63 & g >> 8 - N % 1 * 8)) {
              if ((C = O.charCodeAt(N += 0.75)) > 255) throw new E("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
              g = g << 8 | C;
            }
            return _;
          }, atob: function(y) {
            var g = String(y).replace(/[=]+$/, "");
            if (g.length % 4 == 1) throw new E("'atob' failed: The string to be decoded is not correctly encoded.");
            for (var C, O, N = 0, w = 0, _ = ""; O = g.charAt(w++); ~O && (C = N % 4 ? 64 * C + O : O, N++ % 4) ? _ += String.fromCharCode(255 & C >> (-2 * N & 6)) : 0) O = m.indexOf(O);
            return _;
          } };
        });
      }, 9667: function(l, v, s) {
        s.r(v), s.d(v, { addUsersToChatRoom: function() {
          return B;
        }, addUsersToChatRoomAllowlist: function() {
          return pt;
        }, addUsersToChatRoomWhitelist: function() {
          return at;
        }, blockChatRoomMember: function() {
          return _e;
        }, blockChatRoomMembers: function() {
          return Te;
        }, chatRoomBlockMulti: function() {
          return Le;
        }, chatRoomBlockSingle: function() {
          return Ce;
        }, createChatRoom: function() {
          return O;
        }, deleteChatRoomSharedFile: function() {
          return ut;
        }, destroyChatRoom: function() {
          return N;
        }, disableSendChatRoomMsg: function() {
          return Ke;
        }, enableSendChatRoomMsg: function() {
          return Ze;
        }, fetchChatRoomAnnouncement: function() {
          return kt;
        }, fetchChatRoomSharedFileList: function() {
          return St;
        }, getChatRoomAdmin: function() {
          return M;
        }, getChatRoomAllowlist: function() {
          return Tt;
        }, getChatRoomAttributes: function() {
          return Ht;
        }, getChatRoomBlacklist: function() {
          return $e;
        }, getChatRoomBlacklistNew: function() {
          return be;
        }, getChatRoomBlocklist: function() {
          return Be;
        }, getChatRoomDetails: function() {
          return w;
        }, getChatRoomMuteList: function() {
          return he;
        }, getChatRoomMuted: function() {
          return de;
        }, getChatRoomMutelist: function() {
          return pe;
        }, getChatRoomSharedFilelist: function() {
          return Ft;
        }, getChatRoomWhitelist: function() {
          return it;
        }, getChatRooms: function() {
          return C;
        }, getJoinedChatRooms: function() {
          return X;
        }, isChatRoomWhiteUser: function() {
          return Ut;
        }, isInChatRoomAllowlist: function() {
          return st;
        }, isInChatRoomMutelist: function() {
          return Ot;
        }, joinChatRoom: function() {
          return D;
        }, leaveChatRoom: function() {
          return j;
        }, listChatRoomMember: function() {
          return G;
        }, listChatRoomMembers: function() {
          return U;
        }, modifyChatRoom: function() {
          return _;
        }, muteChatRoomMember: function() {
          return ue;
        }, quitChatRoom: function() {
          return F;
        }, removeChatRoomAdmin: function() {
          return J;
        }, removeChatRoomAllowlistMember: function() {
          return gt;
        }, removeChatRoomAttribute: function() {
          return le;
        }, removeChatRoomAttributes: function() {
          return Ne;
        }, removeChatRoomBlockMulti: function() {
          return Pe;
        }, removeChatRoomBlockSingle: function() {
          return K;
        }, removeChatRoomMember: function() {
          return k;
        }, removeChatRoomMembers: function() {
          return S;
        }, removeChatRoomWhitelistMember: function() {
          return Rt;
        }, removeMultiChatRoomMember: function() {
          return H;
        }, removeMuteChatRoomMember: function() {
          return se;
        }, removeSingleChatRoomMember: function() {
          return I;
        }, rmUsersFromChatRoomWhitelist: function() {
          return It;
        }, setChatRoomAdmin: function() {
          return V;
        }, setChatRoomAttribute: function() {
          return ze;
        }, setChatRoomAttributes: function() {
          return zt;
        }, unblockChatRoomMember: function() {
          return Oe;
        }, unblockChatRoomMembers: function() {
          return xe;
        }, unmuteChatRoomMember: function() {
          return ee;
        }, updateChatRoomAnnouncement: function() {
          return wt;
        }, uploadChatRoomSharedFile: function() {
          return Et;
        } }), s(1539), s(8674), s(8309), s(2526), s(1817), s(2222), s(9753), s(9600), s(1249), s(4916), s(3123), s(2165), s(6992), s(8783), s(3948);
        var c = s(5531), d = s(7252), p = s(4024), m = s(3246), E = s(7360), y = s(1595);
        function g(re) {
          return g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Me) {
            return typeof Me;
          } : function(Me) {
            return Me && typeof Symbol == "function" && Me.constructor === Symbol && Me !== Symbol.prototype ? "symbol" : typeof Me;
          }, g(re);
        }
        function C(re) {
          var Me = this;
          if (typeof re.pagenum != "number" || typeof re.pagesize != "number") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Se = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Se);
          }
          var ke = { pagenum: re.pagenum || 1, pagesize: re.pagesize || 20 }, Ge = this.context, nt = Ge.orgName, rt = Ge.appName, dt = Ge.accessToken, lt = { url: this.apiUrl + "/" + nt + "/" + rt + "/chatrooms", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + dt }, data: ke, success: function(Ct) {
            typeof re.success == "function" && re.success(Ct);
          }, error: function(Ct) {
            Ct.error && Ct.error_description && Me.onError && Me.onError({ type: c.E.WEBIM_CONNCTION_LOAD_CHATROOM_ERROR, message: Ct.error_description, data: Ct }), typeof re.error == "function" && re.error(Ct);
          } };
          return E.kg.debug("Call getChatRooms", re), p.hj.call(this, lt, y.fI.GET_CHATROOM_LIST);
        }
        function O(re) {
          if (typeof re.name != "string") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = { name: re.name, description: re.description, maxusers: re.maxusers, owner: this.user, members: re.members }, ke = this.context, Ge = ke.orgName, nt = ke.appName, rt = ke.accessToken, dt = ke.jid, lt = { url: "".concat(this.apiUrl, "/").concat(Ge, "/").concat(nt, "/chatrooms?resource=").concat(dt.clientResource), dataType: "json", type: "POST", data: JSON.stringify(Se), headers: { Authorization: "Bearer " + (re.token || rt), "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call createChatRoom", re), p.hj.call(this, lt, y.fI.CREATE_CHATROOM);
        }
        function N(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(re.chatRoomId, "?resource=").concat(rt.clientResource, "&version=v3"), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + (re.token || nt) }, success: re.success, error: re.error };
          return E.kg.debug("Call destroyChatRoom", re), p.hj.call(this, dt, y.fI.DESTROY_CHATROOM);
        }
        function w(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + re.chatRoomId, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call getChatRoomDetails", re), p.hj.call(this, rt, y.fI.GET_CHATROOM_DETAIL);
        }
        function _(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { groupname: re.chatRoomName, description: re.description, maxusers: re.maxusers }, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "?resource=").concat(rt.clientResource), type: "PUT", data: JSON.stringify(lt), dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call modifyChatRoom", re), p.hj.call(this, Ct, y.fI.MODIFY_CHATROOM);
        }
        function I(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "" || typeof re.username != "string") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = re.username, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/users/").concat(lt, "?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call removeChatRoomMember", re), p.hj.call(this, Ct, y.fI.REMOVE_CHATROOM_MEMBER);
        }
        var k = I;
        function H(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "" || !Array.isArray(re.users)) throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = re.chatRoomId, ke = re.users.join(","), Ge = this.context, nt = Ge.orgName, rt = Ge.appName, dt = Ge.accessToken, lt = Ge.jid, Ct = { url: "".concat(this.apiUrl, "/").concat(nt, "/").concat(rt, "/chatrooms/").concat(Se, "/users/").concat(ke, "?resource=").concat(lt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + dt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call removeChatRoomMembers", re), p.hj.call(this, Ct, y.fI.MULTI_REMOVE_CHATROOM_MEMBER);
        }
        var S = H;
        function B(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "" || !Array.isArray(re.users)) throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = re.chatRoomId, ke = { usernames: re.users }, Ge = this.context, nt = Ge.orgName, rt = Ge.appName, dt = Ge.accessToken, lt = Ge.jid, Ct = { url: "".concat(this.apiUrl, "/").concat(nt, "/").concat(rt, "/chatrooms/").concat(Se, "/users?resource=").concat(lt.clientResource), type: "POST", data: JSON.stringify(ke), dataType: "json", headers: { Authorization: "Bearer " + dt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call addUsersToChatRoom", re), p.hj.call(this, Ct, y.fI.ADD_USERS_TO_CHATROOM);
        }
        function D(re) {
          var Me = re.roomId, Se = re.message, ke = Se === void 0 ? "" : Se, Ge = re.ext, nt = Ge === void 0 ? "" : Ge, rt = re.leaveOtherRooms, dt = rt !== void 0 && rt, lt = re.success, Ct = re.error;
          if (typeof Me != "string" || Me === "") throw Error("Invalid parameter roomId");
          if (typeof nt != "string") throw Error("Invalid parameter ext");
          if (typeof dt != "boolean") throw Error("Invalid parameter leaveOtherRooms");
          if (!m.XZ.call(this)) {
            var Ie = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Ie);
          }
          return E.kg.debug("Call joinChatRoom", re), this.logOut ? Promise.reject({ type: c.E.WEBIM_CONNECTION_CLOSED, message: "not login" }) : this.mSync.handleChatRoom({ roomId: Me, ext: nt, leaveOtherRooms: dt, message: ke, success: lt, error: Ct }, "join");
        }
        function F(re) {
          if (typeof re.roomId != "string" || re.roomId === "") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          return E.kg.debug("Call leaveChatRoom", re), this.logOut ? Promise.reject({ type: c.E.WEBIM_CONNECTION_CLOSED, message: "not login" }) : this.mSync.handleChatRoom(re, "leave");
        }
        var j = F;
        function G(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (isNaN(re.pageNum) || re.pageNum <= 0) throw Error('The parameter "pageNum" should be a positive number');
          if (isNaN(re.pageSize) || re.pageSize <= 0) throw Error('The parameter "pageSize" should be a positive number');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = { pagenum: re.pageNum, pagesize: re.pageSize }, ke = this.context, Ge = ke.orgName, nt = ke.appName, rt = ke.accessToken, dt = { url: this.apiUrl + "/" + Ge + "/" + nt + "/chatrooms/" + re.chatRoomId + "/users", dataType: "json", type: "GET", data: Se, headers: { Authorization: "Bearer " + rt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call listChatRoomMembers", re), p.hj.call(this, dt, y.fI.LIST_CHATROOM_MEMBERS);
        }
        var U = G;
        function M(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.chatRoomId, dt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + rt + "/admin", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call getChatRoomAdmin", re), p.hj.call(this, dt, y.fI.GET_CHATROOM_ADMIN);
        }
        function V(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.username != "string" || re.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { newadmin: re.username }, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/admin?resource=").concat(rt.clientResource), type: "POST", dataType: "json", data: JSON.stringify(lt), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call setChatRoomAdmin", re), p.hj.call(this, Ct, y.fI.SET_CHATROOM_ADMIN);
        }
        function J(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.username != "string" || re.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = re.username, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/admin/").concat(lt, "?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call removeChatRoomAdmin", re), p.hj.call(this, Ct, y.fI.REMOVE_CHATROOM_ADMIN);
        }
        function ue(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof re.username != "string" || re.username === "") throw Error('Invalid parameter: "username"');
          if (typeof re.muteDuration != "number") throw Error('Invalid parameter: "muteDuration"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { usernames: [re.username], mute_duration: re.muteDuration }, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/mute?resource=").concat(rt.clientResource), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, data: JSON.stringify(lt), success: re.success, error: re.error };
          return E.kg.debug("Call muteChatRoomMember", re), p.hj.call(this, Ct, y.fI.MUTE_CHATROOM_MEMBER);
        }
        function se(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.username != "string" || re.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = re.username, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/mute/").concat(lt, "?resource=").concat(rt.clientResource), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call unmuteChatRoomMember", re), p.hj.call(this, Ct, y.fI.REMOVE_MUTE_CHATROOM_MEMBER);
        }
        var ee = se;
        function de(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.chatRoomId, dt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + rt + "/mute", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call getChatRoomMutelist", re), p.hj.call(this, dt, y.fI.GET_MUTE_CHATROOM_MEMBERS);
        }
        var he = de, pe = de;
        function Ce(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.username != "string" || re.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = re.username, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/blocks/users/").concat(lt, "?resource=").concat(rt.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call blockChatRoomMember", re), p.hj.call(this, Ct, y.fI.SET_CHATROOM_MEMBER_TO_BLACK);
        }
        var _e = Ce;
        function Le(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!Array.isArray(re.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { usernames: re.usernames }, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/blocks/users?resource=").concat(rt.clientResource), data: JSON.stringify(lt), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Chat blockChatRoomMembers:", Ct), p.hj.call(this, Ct, y.fI.MULTI_SET_CHATROOM_MEMBER_TO_BLACK);
        }
        var Te = Le;
        function K(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.username != "string" || re.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = re.username, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/blocks/users/").concat(lt, "?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call unblockChatRoomMember", re), p.hj.call(this, Ct, y.fI.REMOVE_CHATROOM_MEMBER_BLACK);
        }
        var Oe = K;
        function Pe(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!Array.isArray(re.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = re.usernames.join(","), Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/blocks/users/").concat(lt, "?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call unblockChatRoomMembers", re), p.hj.call(this, Ct, y.fI.MULTI_REMOVE_CHATROOM_MEMBER_BLACK);
        }
        var xe = Pe;
        function be(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.chatRoomId, dt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + rt + "/blocks/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call getChatRoomBlocklist", re), p.hj.call(this, dt, y.fI.GET_CHATROOM_BLOCK_MEMBERS);
        }
        var $e = be, Be = be;
        function Ke(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/ban?resource=").concat(rt.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call disableSendChatRoomMsg", re), p.hj.call(this, lt, y.fI.DISABLED_CHATROOM_SEND_MSG);
        }
        function Ze(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/ban?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call enableSendChatRoomMsg", re), p.hj.call(this, lt, y.fI.ENABLE_CHATROOM_SEND_MSG);
        }
        function at(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!Array.isArray(re.users)) throw Error('Invalid parameter: "users"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { usernames: re.users }, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/white/users?resource=").concat(rt.clientResource), type: "POST", data: JSON.stringify(lt), dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call addUsersToChatRoomWhitelist", re), p.hj.call(this, Ct, y.fI.ADD_USERS_TO_CHATROOM);
        }
        var pt = at;
        function It(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.userName != "string" || re.userName === "") throw Error('Invalid parameter: "userName"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.chatRoomId, lt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/white/users/").concat(re.userName, "?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call removeChatRoomAllowlistMember", re), p.hj.call(this, lt, y.fI.REMOVE_CHATROOM_WHITE_USERS);
        }
        var Rt = It, gt = It;
        function it(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.chatRoomId, dt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + rt + "/white/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call getChatRoomAllowlist", re), p.hj.call(this, dt, y.fI.GET_CHATROOM_WHITE_USERS);
        }
        var Tt = it;
        function Ut(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (typeof re.userName != "string" || re.userName === "") throw Error('Invalid parameter: "userName"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.chatRoomId, dt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/chatrooms/" + rt + "/white/users/" + re.userName, type: "GET", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call isInChatRoomAllowlist", re), p.hj.call(this, dt, y.fI.CHECK_CHATROOM_WHITE_USER);
        }
        var st = Ut;
        function Ot(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error('Invalid parameter: "chatRoomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.userId, dt = { url: this.apiUrl + "/" + ke + "/" + Ge + "/sdk/chatrooms/" + re.chatRoomId + "/mute/" + rt, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + nt } };
          return E.kg.debug("Call isInChatRoomMutelist", re), p.hj.call(this, dt).then(function(lt) {
            return { type: lt.type, data: lt.data };
          });
        }
        function kt(re) {
          if (typeof re.roomId != "string" || re.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.roomId, dt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(rt, "/announcement"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call fetchChatRoomAnnouncement", re), p.hj.call(this, dt, y.fI.GET_CHATROOM_ANN);
        }
        function wt(re) {
          if (typeof re.roomId != "string" || re.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (typeof re.announcement != "string") throw Error('Invalid parameter: "announcement"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.roomId, lt = { announcement: re.announcement }, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/announcement?resource=").concat(rt.clientResource), type: "POST", dataType: "json", data: JSON.stringify(lt), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call updateChatRoomAnnouncement:", re), p.hj.call(this, Ct, y.fI.UPDATE_CHATROOM_ANN);
        }
        function Et(re) {
          if (typeof re.roomId != "string" || re.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (g(re.file) !== "object") throw Error('Invalid parameter: "file"');
          if (m.XZ.call(this)) {
            var Me = this.context, Se = Me.orgName, ke = Me.appName, Ge = Me.accessToken, nt = Me.jid, rt = re.roomId;
            p.cT.call(this, { uploadUrl: "".concat(this.apiUrl, "/").concat(Se, "/").concat(ke, "/chatrooms/").concat(rt, "/share_files?resource=").concat(nt.clientResource), onFileUploadProgress: re.onFileUploadProgress, onFileUploadComplete: re.onFileUploadComplete, onFileUploadError: re.onFileUploadError, onFileUploadCanceled: re.onFileUploadCanceled, accessToken: Ge, apiUrl: this.apiUrl, file: re.file, appKey: this.context.appKey }, y.fI.UPLOAD_CHATROOM_FILE), E.kg.debug("Call uploadChatRoomSharedFile", re);
          }
        }
        function ut(re) {
          if (typeof re.roomId != "string" || re.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (typeof re.fileId != "string" || re.fileId === "") throw Error('Invalid parameter: "fileId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.jid, dt = re.roomId, lt = re.fileId, Ct = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(dt, "/share_files/").concat(lt, "?resource=").concat(rt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call deleteChatRoomSharedFile", re), p.hj.call(this, Ct, y.fI.DELETE_CHATROOM_FILE);
        }
        function St(re) {
          if (typeof re.roomId != "string" || re.roomId === "") throw Error('Invalid parameter: "roomId"');
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = re.roomId, dt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/chatrooms/").concat(rt, "/share_files"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json", accept: "application/json" }, success: re.success, error: re.error };
          return E.kg.debug("Call fetchChatRoomSharedFileList", re), p.hj.call(this, dt, y.fI.GET_CHATROOM_FILES);
        }
        var Ft = St;
        function Ht(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + re.chatRoomId);
          if (re.attributeKeys && !Array.isArray(re.attributeKeys)) throw Error('"Invalid parameter attributeKeys": ' + re.attributeKeys);
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = (Se.jid, re.chatRoomId), dt = { keys: re.attributeKeys }, lt = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/metadata/chatroom/").concat(rt), type: "POST", dataType: "json", data: JSON.stringify(dt), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" } };
          return E.kg.debug("Call getChatRoomAttributes:", re), p.hj.call(this, lt, y.fI.GET_CHATROOM_ATTR).then(function(Ct) {
            return { data: Ct.data, type: Ct.type };
          });
        }
        function zt(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + re.chatRoomId);
          if (g(re.attributes) !== "object") throw Error("Invalid parameter attributes: " + re.attributes);
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.userId, dt = re.chatRoomId, lt = re.attributes, Ct = re.autoDelete, Ie = Ct === void 0 || Ct, x = re.isForced ? "/forced" : "", ae = { metaData: lt, autoDelete: Ie ? "DELETE" : "NO_DELETE" }, Q = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/metadata/chatroom/").concat(dt, "/user/").concat(rt) + x, type: "PUT", dataType: "json", data: JSON.stringify(ae), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" } };
          return E.kg.debug("Call setChatRoomAttributes:", re), p.hj.call(this, Q, y.fI.SET_CHATROOM_ATTR).then(function(Z) {
            return (0, m._W)(Z);
          });
        }
        function ze(re) {
          var Me;
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + re.chatRoomId);
          if (typeof re.attributeKey != "string" || re.attributeKey === "") throw Error("Invalid parameter attributeKey: " + re.attributeKey);
          if (typeof re.attributeValue != "string" || re.attributeValue === "") throw Error("Invalid parameter attributeValue: " + re.attributeValue);
          if (!m.XZ.call(this)) {
            var Se = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Se);
          }
          var ke = this.context, Ge = ke.orgName, nt = ke.appName, rt = ke.accessToken, dt = ke.userId, lt = re.chatRoomId, Ct = re.attributeKey, Ie = re.attributeValue, x = re.autoDelete, ae = x === void 0 || x, Q = re.isForced ? "/forced" : "", Z = { metaData: (Me = {}, Me[Ct] = Ie, Me), autoDelete: ae ? "DELETE" : "NO_DELETE" }, ge = { url: "".concat(this.apiUrl, "/").concat(Ge, "/").concat(nt, "/metadata/chatroom/").concat(lt, "/user/").concat(dt) + Q, type: "PUT", dataType: "json", data: JSON.stringify(Z), headers: { Authorization: "Bearer " + rt, "Content-Type": "application/json" } };
          return E.kg.debug("Call setChatRoomAttribute:", re), p.hj.call(this, ge, y.fI.SET_CHATROOM_ATTR).then(function(me) {
            var ve = (0, m.H7)(me);
            if (ve) throw ve;
          });
        }
        function Ne(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + re.chatRoomId);
          if (!Array.isArray(re.attributeKeys)) throw Error('"Invalid parameter attributes": ' + re.attributeKeys);
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.userId, dt = re.chatRoomId, lt = re.attributeKeys, Ct = re.isForced ? "/forced" : "", Ie = { keys: lt }, x = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/metadata/chatroom/").concat(dt, "/user/").concat(rt) + Ct, type: "DELETE", dataType: "json", data: JSON.stringify(Ie), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" } };
          return E.kg.debug("Call removeChatRoomAttributes:", re), p.hj.call(this, x, y.fI.DELETE_CHATROOM_ATTR).then(function(ae) {
            return (0, m._W)(ae);
          });
        }
        function le(re) {
          if (typeof re.chatRoomId != "string" || re.chatRoomId === "") throw Error("Invalid parameter chatRoomId: " + re.chatRoomId);
          if (typeof re.attributeKey != "string" || re.attributeKey === "") throw Error('"Invalid parameter attributeKey": ' + re.attributeKey);
          if (!m.XZ.call(this)) {
            var Me = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Me);
          }
          var Se = this.context, ke = Se.orgName, Ge = Se.appName, nt = Se.accessToken, rt = Se.userId, dt = re.chatRoomId, lt = re.attributeKey, Ct = re.isForced ? "/forced" : "", Ie = { keys: [lt] }, x = { url: "".concat(this.apiUrl, "/").concat(ke, "/").concat(Ge, "/metadata/chatroom/").concat(dt, "/user/").concat(rt) + Ct, type: "DELETE", dataType: "json", data: JSON.stringify(Ie), headers: { Authorization: "Bearer " + nt, "Content-Type": "application/json" } };
          return E.kg.debug("Call removeChatRoomAttribute:", re), p.hj.call(this, x, y.fI.DELETE_CHATROOM_ATTR).then(function(ae) {
            var Q = (0, m.H7)(ae);
            if (Q) throw Q;
          });
        }
        function X(re) {
          var Me = this, Se = re || {}, ke = Se.pageNum, Ge = Se.pageSize;
          if (isNaN(ke) || ke <= 0) throw Error("Invalid parameter pageNum:".concat(ke));
          if (isNaN(Ge) || Ge <= 0) throw Error("Invalid parameter pageSize:".concat(Ge));
          if (!m.XZ.call(this)) {
            var nt = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(nt);
          }
          var rt = { pagenum: ke, pagesize: Ge, detail: !0 }, dt = this.context, lt = dt.orgName, Ct = dt.appName, Ie = dt.accessToken, x = { url: "".concat(this.apiUrl, "/").concat(lt, "/").concat(Ct, "/users/").concat(this.user, "/joined_chatrooms"), dataType: "json", type: "GET", data: rt, headers: { Authorization: "Bearer " + Ie, "Content-Type": "application/json" } };
          return E.kg.debug("Call getJoinedChatRooms", re), p.hj.call(this, x, y.fI.GET_USER_JOINED_CHATROOM).then(function(ae) {
            var Q = (ae.data || []).map(function(Z) {
              var ge = Z.id, me = Z.title, ve = Z.owner, ie = Z.created, ye = Z.description, Ye = Z.max_users;
              return { id: ge, name: me, owner: ve.split("".concat(Me.appKey, "_"))[1], created: ie, description: ye, maxusers: Ye };
            });
            return { type: ae.type, data: Q };
          });
        }
      }, 4363: function(l, v, s) {
        s.d(v, { U: function() {
          return E;
        }, w: function() {
          return y;
        } }), s(9601), s(2772), s(1249);
        var c = s(7360), d = s(8161), p = s(4024), m = function() {
          return m = Object.assign || function(g) {
            for (var C, O = 1, N = arguments.length; O < N; O++) for (var w in C = arguments[O]) Object.prototype.hasOwnProperty.call(C, w) && (g[w] = C[w]);
            return g;
          }, m.apply(this, arguments);
        }, E = { chat: "singleChat", chatroom: "chatRoom", groupchat: "groupChat", singleChat: "singleChat", chatRoom: "chatRoom", groupChat: "groupChat" };
        function y(g, C) {
          var O, N, w, _ = C || {}, I = _.formatCustomExts, k = I === void 0 || I, H = _.formatChatType, S = H !== void 0 && H, B = g.id, D = g.payload, F = g.timestamp, j = g.to, G = D.bodies && D.bodies.length > 0 ? D.bodies[0] : {}, U = {}, M = {}, V = D.type ? D.type : j.indexOf("@conference.easemob.com") > -1 ? "groupChat" : "singleChat";
          V = V === "chat" ? "singleChat" : V, S && D.type && (V = E[D.type]);
          var J = "";
          switch (G.type) {
            case "txt":
              if (Object.prototype.hasOwnProperty.call(G, "subType") && G.subType === "sub_combine") J = d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "combine", chatType: V, to: D.to, from: D.from, ext: D.ext, time: F, title: G.title || "", summary: G.summary || "", url: J || "", secret: G.secret || "", file_length: G.file_length || 0, filename: G.filename || "", compatibleText: G.msg, combineLevel: G.combineLevel || 0 };
              else {
                var ue = (O = D == null ? void 0 : D.meta) === null || O === void 0 ? void 0 : O.edit_msg;
                if (U = { id: B, type: "txt", chatType: V, msg: G.msg || "", to: D.to || "", from: D.from, time: F, ext: D.ext }, ue) {
                  var se = ue.edit_time, ee = ue.operator, de = ue.count;
                  U.modifiedInfo = { operationTime: se, operatorId: ee, operationCount: de };
                }
              }
              break;
            case "img":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "img", chatType: V, to: D.to, from: D.from, time: F, ext: D.ext, width: ((N = G.size) === null || N === void 0 ? void 0 : N.width) || 0, height: ((w = G.size) === null || w === void 0 ? void 0 : w.height) || 0, thumb: this.useOwnUploadFun ? "" : "".concat(J, "&thumbnail=true"), thumb_secret: G.secret, secret: G.secret || "", url: J || "", file_length: G.file_length || 0, file: {} };
              break;
            case "video":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "video", chatType: V, from: D.from, to: D.to, thumb: p.P6.formatAttachUrl.call(this, G.thumb), thumb_secret: G.thumb_secret || "", url: J || "", secret: G.secret || "", filename: G.filename, length: G.length || 0, file: {}, file_length: G.file_length || 0, filetype: D.ext.file_type || "", ext: D.ext, time: F };
              break;
            case "loc":
              U = { id: B, type: "loc", chatType: V, from: D.from, to: D.to, buildingName: G.buildingName || "", addr: G.addr, lat: G.lat, lng: G.lng, ext: D.ext, time: F };
              break;
            case "audio":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "audio", chatType: V, from: D.from, to: D.to, secret: G.secret || "", ext: D.ext, time: F, url: J || "", file: {}, filename: G.filename, length: G.length || 0, file_length: G.file_length || 0, filetype: D.ext.file_type || "" };
              break;
            case "file":
              J = this.useOwnUploadFun ? G == null ? void 0 : G.url : d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "file", chatType: V, from: D.from, to: D.to, ext: D.ext, time: F, url: J || "", secret: G.secret || "", file: {}, filename: G.filename || "", file_length: G.file_length || 0, filetype: D.ext.file_type || "" };
              break;
            case "cmd":
              U = { id: B, type: "cmd", chatType: V, from: D.from, to: D.to, ext: D.ext, time: F, action: G.action || "" };
              break;
            case "custom":
              var he = G.customExts || {};
              k && G.customExts && (he = {}, G.customExts.map(function(Ce) {
                he = m(m({}, he), Ce);
              })), U = { id: B, type: "custom", chatType: V, from: D.from, to: D.to, ext: D.ext, time: F, customEvent: G.customEvent || "", customExts: he };
              break;
            case "combine":
              J = d.t.call(this, { remotePath: G == null ? void 0 : G.url, secret: G == null ? void 0 : G.secret }), U = { id: B, type: "combine", chatType: V, msg: G.msg || "", to: D.to || "", from: D.from, time: F, ext: D.ext, title: G.title || "", summary: G.summary || "", url: J || "", compatibleText: G.text, combineLevel: G.combineLevel || 0, secret: G.secret || "", filename: G.filename || "", file_length: G.file_length || 0 };
              break;
            default:
              c.kg.error("unexpected message: ".concat(g));
          }
          if (D.msgConfig && (M.msgConfig = D.msgConfig), D == null ? void 0 : D.meta) {
            var pe = D.meta;
            pe.thread && (M.chatThread = { messageId: pe.thread.msg_parent_id, parentId: pe.thread.muc_parent_id, chatThreadName: pe.thread.thread_name }), pe.reaction && (M.reactions = pe.reaction), pe.translations && (M.translations = pe.translations);
          }
          return m(m({}, U), M);
        }
      }, 2856: function(l, v, s) {
        s.r(v), s.d(v, { acceptGroupInvite: function() {
          return $e;
        }, acceptGroupJoinRequest: function() {
          return Oe;
        }, addUsersToGroupAllowlist: function() {
          return Se;
        }, addUsersToGroupWhitelist: function() {
          return Me;
        }, agreeInviteIntoGroup: function() {
          return be;
        }, agreeJoinGroup: function() {
          return K;
        }, blockGroup: function() {
          return _;
        }, blockGroupMember: function() {
          return wt;
        }, blockGroupMembers: function() {
          return ut;
        }, blockGroupMessages: function() {
          return I;
        }, changeGroupOwner: function() {
          return F;
        }, changeOwner: function() {
          return D;
        }, createGroup: function() {
          return w;
        }, createGroupNew: function() {
          return N;
        }, deleteGroupSharedFile: function() {
          return me;
        }, destroyGroup: function() {
          return he;
        }, disableSendGroupMsg: function() {
          return X;
        }, dissolveGroup: function() {
          return de;
        }, downloadGroupSharedFile: function() {
          return ye;
        }, enableSendGroupMsg: function() {
          return re;
        }, fetchGroupAnnouncement: function() {
          return Q;
        }, fetchGroupSharedFileList: function() {
          return ve;
        }, getGroup: function() {
          return S;
        }, getGroupAdmin: function() {
          return V;
        }, getGroupAllowlist: function() {
          return dt;
        }, getGroupBlacklist: function() {
          return Ne;
        }, getGroupBlacklistNew: function() {
          return ze;
        }, getGroupBlocklist: function() {
          return le;
        }, getGroupInfo: function() {
          return j;
        }, getGroupMemberAttributes: function() {
          return ne;
        }, getGroupMembersAttributes: function() {
          return Qe;
        }, getGroupMsgReadUser: function() {
          return ae;
        }, getGroupMuteList: function() {
          return st;
        }, getGroupMutelist: function() {
          return Ot;
        }, getGroupSharedFilelist: function() {
          return ie;
        }, getGroupWhitelist: function() {
          return rt;
        }, getJoinedGroups: function() {
          return B;
        }, getMuted: function() {
          return Ut;
        }, getPublicGroups: function() {
          return H;
        }, groupBlockMulti: function() {
          return Et;
        }, groupBlockSingle: function() {
          return kt;
        }, inviteToGroup: function() {
          return _e;
        }, inviteUsersToGroup: function() {
          return Le;
        }, isGroupWhiteUser: function() {
          return lt;
        }, isInGroupAllowlist: function() {
          return Ie;
        }, isInGroupMutelist: function() {
          return x;
        }, isInGroupWhiteList: function() {
          return Ct;
        }, joinGroup: function() {
          return Te;
        }, leaveGroup: function() {
          return Ce;
        }, listGroupMember: function() {
          return U;
        }, listGroupMembers: function() {
          return M;
        }, listGroups: function() {
          return k;
        }, modifyGroup: function() {
          return G;
        }, mute: function() {
          return Rt;
        }, muteGroupMember: function() {
          return gt;
        }, quitGroup: function() {
          return pe;
        }, rejectGroupInvite: function() {
          return Ke;
        }, rejectGroupJoinRequest: function() {
          return xe;
        }, rejectInviteIntoGroup: function() {
          return Be;
        }, rejectJoinGroup: function() {
          return Pe;
        }, removeAdmin: function() {
          return se;
        }, removeGroupAdmin: function() {
          return ee;
        }, removeGroupAllowlistMember: function() {
          return nt;
        }, removeGroupBlockMulti: function() {
          return Ht;
        }, removeGroupBlockSingle: function() {
          return St;
        }, removeGroupMember: function() {
          return at;
        }, removeGroupMembers: function() {
          return It;
        }, removeGroupWhitelistMember: function() {
          return Ge;
        }, removeMultiGroupMember: function() {
          return pt;
        }, removeMute: function() {
          return it;
        }, removeSingleGroupMember: function() {
          return Ze;
        }, rmUsersFromGroupWhitelist: function() {
          return ke;
        }, setAdmin: function() {
          return J;
        }, setGroupAdmin: function() {
          return ue;
        }, setGroupMemberAttributes: function() {
          return Ye;
        }, unblockGroupMember: function() {
          return Ft;
        }, unblockGroupMembers: function() {
          return zt;
        }, unmuteGroupMember: function() {
          return Tt;
        }, updateGroupAnnouncement: function() {
          return Z;
        }, uploadGroupSharedFile: function() {
          return ge;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(2222), s(6699), s(2023), s(9554), s(4747), s(8309), s(9753), s(9600);
        var c = s(5531), d = s(7252), p = s(4024), m = s(3246), E = s(7360), y = s(1595);
        function g(W) {
          return g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ce) {
            return typeof ce;
          } : function(ce) {
            return ce && typeof Symbol == "function" && ce.constructor === Symbol && ce !== Symbol.prototype ? "symbol" : typeof ce;
          }, g(W);
        }
        var C = function(W, ce, fe, we) {
          return new (fe || (fe = Promise))(function(Fe, je) {
            function qe(ot) {
              try {
                bt(we.next(ot));
              } catch (Lt) {
                je(Lt);
              }
            }
            function et(ot) {
              try {
                bt(we.throw(ot));
              } catch (Lt) {
                je(Lt);
              }
            }
            function bt(ot) {
              var Lt;
              ot.done ? Fe(ot.value) : (Lt = ot.value, Lt instanceof fe ? Lt : new fe(function(Kt) {
                Kt(Lt);
              })).then(qe, et);
            }
            bt((we = we.apply(W, [])).next());
          });
        }, O = function(W, ce) {
          var fe, we, Fe, je, qe = { label: 0, sent: function() {
            if (1 & Fe[0]) throw Fe[1];
            return Fe[1];
          }, trys: [], ops: [] };
          return je = { next: et(0), throw: et(1), return: et(2) }, typeof Symbol == "function" && (je[Symbol.iterator] = function() {
            return this;
          }), je;
          function et(bt) {
            return function(ot) {
              return function(Lt) {
                if (fe) throw new TypeError("Generator is already executing.");
                for (; qe; ) try {
                  if (fe = 1, we && (Fe = 2 & Lt[0] ? we.return : Lt[0] ? we.throw || ((Fe = we.return) && Fe.call(we), 0) : we.next) && !(Fe = Fe.call(we, Lt[1])).done) return Fe;
                  switch (we = 0, Fe && (Lt = [2 & Lt[0], Fe.value]), Lt[0]) {
                    case 0:
                    case 1:
                      Fe = Lt;
                      break;
                    case 4:
                      return qe.label++, { value: Lt[1], done: !1 };
                    case 5:
                      qe.label++, we = Lt[1], Lt = [0];
                      continue;
                    case 7:
                      Lt = qe.ops.pop(), qe.trys.pop();
                      continue;
                    default:
                      if (!((Fe = (Fe = qe.trys).length > 0 && Fe[Fe.length - 1]) || Lt[0] !== 6 && Lt[0] !== 2)) {
                        qe = 0;
                        continue;
                      }
                      if (Lt[0] === 3 && (!Fe || Lt[1] > Fe[0] && Lt[1] < Fe[3])) {
                        qe.label = Lt[1];
                        break;
                      }
                      if (Lt[0] === 6 && qe.label < Fe[1]) {
                        qe.label = Fe[1], Fe = Lt;
                        break;
                      }
                      if (Fe && qe.label < Fe[2]) {
                        qe.label = Fe[2], qe.ops.push(Lt);
                        break;
                      }
                      Fe[2] && qe.ops.pop(), qe.trys.pop();
                      continue;
                  }
                  Lt = ce.call(W, qe);
                } catch (Kt) {
                  Lt = [6, Kt], we = 0;
                } finally {
                  fe = Fe = 0;
                }
                if (5 & Lt[0]) throw Lt[1];
                return { value: Lt[0] ? Lt[1] : void 0, done: !0 };
              }([bt, ot]);
            };
          }
        };
        function N(W) {
          if (!W || !W.data) throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups?resource=").concat(qe.clientResource), dataType: "json", type: "POST", data: JSON.stringify({ owner: this.user, groupname: W.data.groupname, desc: W.data.desc, members: W.data.members, public: W.data.public, approval: W.data.approval, allowinvites: W.data.allowinvites, invite_need_confirm: W.data.inviteNeedConfirm, maxusers: W.data.maxusers, custom: W.data.ext }), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: function(bt) {
            W.success && W.success(bt);
          }, error: W.error };
          return E.kg.debug("Call createGroup:", W), p.hj.call(this, et, y.fI.CREATE_GROUP);
        }
        var w = N;
        function _(W) {
          var ce;
          if (typeof W.groupId != "string" || W.groupId === "") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var fe = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(fe);
          }
          var we = this.context, Fe = we.orgName, je = we.appName, qe = we.accessToken, et = we.jid, bt = { entities: [(ce = {}, ce["notification_ignore_" + W.groupId] = !0, ce)] }, ot = { type: "PUT", url: "".concat(this.apiUrl, "/").concat(Fe, "/").concat(je, "/users/").concat(this.user, "?resource=").concat(et.clientResource), data: JSON.stringify(bt), dataType: "json", headers: { Authorization: "Bearer " + qe, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call blockGroupMessages", W), p.hj.call(this, ot, y.fI.BLOCK_GROUP);
        }
        var I = _;
        function k(W) {
          if (typeof W.limit != "number") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = { limit: W.limit, cursor: W.cursor };
          W.cursor || delete qe.cursor;
          var et = { url: this.apiUrl + "/" + we + "/" + Fe + "/publicchatgroups", type: "GET", dataType: "json", data: qe, headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call listGroups", W), p.hj.call(this, et, y.fI.LIST_GROUP);
        }
        var H = k;
        function S(W) {
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = { url: this.apiUrl + "/" + we + "/" + Fe + "/users/" + this.user + "/joined_chatgroups", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W && (W == null ? void 0 : W.success), error: W && (W == null ? void 0 : W.error) };
          return E.kg.debug("Call getJoinedGroups", W), p.hj.call(this, qe, y.fI.GET_USER_GROUP);
        }
        function B(W) {
          if (typeof W.pageNum != "number" || typeof W.pageSize != "number") throw Error('Invalid parameter: "pageNum or pageSize"');
          if (W.pageNum < 0 || W.pageSize < 0) throw Error('"pageNum" should >= 0 and "pageSize" should >= 0');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.needAffiliations || W.needRole ? "/chatgroups/user/".concat(this.user, "?pagenum=").concat(W.pageNum, "&pagesize=").concat(W.pageSize, "&needAffiliations=").concat(W.needAffiliations, "&needRole=").concat(W.needRole) : "/users/".concat(this.user, "/joined_chatgroups?pagenum=").concat(W.pageNum, "&pagesize=").concat(W.pageSize), et = { url: this.apiUrl + "/" + we + "/" + Fe + qe, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W && (W == null ? void 0 : W.success), error: W && (W == null ? void 0 : W.error) };
          return E.kg.debug("Call getGroup", W), p.hj.call(this, et, y.fI.GET_USER_GROUP).then(function(bt) {
            var ot = bt.uri, Lt = bt.entities, Kt = [];
            return ot.includes("joined_chatgroups") || (Lt.forEach(function($t) {
              var yt = { affiliationsCount: $t.affiliations_count, groupName: $t.name, groupId: $t.groupId, role: $t.permission, disabled: $t.disabled, approval: $t.membersonly, allowInvites: $t.allowinvites, description: $t.description, maxUsers: $t.maxusers, public: $t.public };
              Kt.push(yt);
            }), bt.entities = Kt), bt;
          });
        }
        function D(W) {
          if (typeof W.groupId != "string" || typeof W.newOwner != "string") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = { newowner: W.newOwner }, we = this.context, Fe = we.orgName, je = we.appName, qe = we.accessToken, et = we.jid, bt = { url: "".concat(this.apiUrl, "/").concat(Fe, "/").concat(je, "/chatgroups/").concat(W.groupId, "?resource=").concat(et.clientResource), type: "PUT", dataType: "json", headers: { Authorization: "Bearer " + qe, "Content-Type": "application/json" }, data: JSON.stringify(fe), success: W.success, error: W.error };
          return E.kg.debug("Call changeOwner", W), p.hj.call(this, bt, y.fI.CHANGE_OWNER);
        }
        var F = D;
        function j(W) {
          if (typeof W.groupId != "string" && !Array.isArray(W.groupId)) throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + W.groupId + "?joined_time=true", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupInfo", W), p.hj.call(this, qe, y.fI.GET_GROUP_INFO);
        }
        function G(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error("Invalid parameter");
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { groupname: W.groupName, description: W.description, custom: W.ext }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "?resource=").concat(qe.clientResource), type: "PUT", data: JSON.stringify(bt), dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call modifyGroup", W), p.hj.call(this, ot, y.fI.MODIFY_GROUP);
        }
        function U(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (isNaN(W.pageNum) || W.pageNum <= 0) throw Error('The parameter "pageNum" should be a positive number');
          if (isNaN(W.pageSize) || W.pageSize <= 0) throw Error('The parameter "pageSize" should be a positive number');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = { pagenum: W.pageNum, pagesize: W.pageSize }, we = this.context, Fe = we.orgName, je = we.appName, qe = we.accessToken, et = { url: this.apiUrl + "/" + Fe + "/" + je + "/chatgroups/" + W.groupId + "/users", dataType: "json", type: "GET", data: fe, headers: { Authorization: "Bearer " + qe, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call listGroupMember", W), p.hj.call(this, et, y.fI.LIST_GROUP_MEMBER);
        }
        var M = U;
        function V(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.groupId, et = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + qe + "/admin", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupAdmin", W), p.hj.call(this, et, y.fI.GET_GROUP_ADMIN);
        }
        function J(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.username != "string" || W.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { newadmin: W.username }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/admin?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call setGroupAdmin", W), p.hj.call(this, ot, y.fI.SET_GROUP_ADMIN);
        }
        var ue = J;
        function se(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.username != "string" || W.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.username, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/admin/").concat(bt, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call removeAdmin", W), p.hj.call(this, ot, y.fI.REMOVE_GROUP_ADMIN);
        }
        var ee = se;
        function de(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "?version=v3&resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call destroyGroup", W), p.hj.call(this, bt, y.fI.DISSOLVE_GROUP);
        }
        var he = de;
        function pe(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/quit?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call quitGroup", W), p.hj.call(this, bt, y.fI.QUIT_GROUP);
        }
        var Ce = pe;
        function _e(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(W.users)) throw Error('Invalid parameter: "users"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = W.groupId, we = { usernames: W.users }, Fe = this.context, je = Fe.orgName, qe = Fe.appName, et = Fe.accessToken, bt = Fe.jid, ot = { url: "".concat(this.apiUrl, "/").concat(je, "/").concat(qe, "/chatgroups/").concat(fe, "/invite?resource=").concat(bt.clientResource), type: "POST", data: JSON.stringify(we), dataType: "json", headers: { Authorization: "Bearer " + et, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call inviteUsersToGroup", W), p.hj.call(this, ot, y.fI.INVITE_TO_GROUP);
        }
        var Le = _e;
        function Te(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(W.groupId, "/apply?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify({ message: W.message || "" }), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call joinGroup", W), p.hj.call(this, et, y.fI.JOIN_GROUP);
        }
        function K(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.applicant != "string" || W.applicant === "") throw Error('Invalid parameter: "applicant"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { applicant: W.applicant, verifyResult: !0, reason: "no clue" }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/apply_verify?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call agreeJoinGroup", W), p.hj.call(this, ot, y.fI.AGREE_JOIN_GROUP);
        }
        var Oe = K;
        function Pe(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.applicant != "string" || W.applicant === "") throw Error('Invalid parameter: "applicant"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { applicant: W.applicant, verifyResult: !1, reason: W.reason || "" }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/apply_verify?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call rejectGroupJoinRequest", W), p.hj.call(this, ot, y.fI.REJECT_JOIN_GROUP);
        }
        var xe = Pe;
        function be(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.invitee != "string" || W.invitee === "") throw Error('Invalid parameter: "invitee"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { invitee: W.invitee, verifyResult: !0 }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/invite_verify?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call acceptGroupInvite", W), p.hj.call(this, ot, y.fI.AGREE_INVITE_GROUP);
        }
        var $e = be;
        function Be(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.invitee != "string" || W.invitee === "") throw Error('Invalid parameter: "invitee"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { invitee: W.invitee, verifyResult: !1 }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/invite_verify?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call rejectGroupInvite", W), p.hj.call(this, ot, y.fI.REJECT_INVITE_GROUP);
        }
        var Ke = Be;
        function Ze(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.username != "string" || W.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = W.groupId, we = W.username, Fe = this.context, je = Fe.orgName, qe = Fe.appName, et = Fe.accessToken, bt = Fe.jid, ot = { url: "".concat(this.apiUrl, "/").concat(je, "/").concat(qe, "/chatgroups/").concat(fe, "/users/").concat(we, "?resource=").concat(bt.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + et, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call removeGroupMember", W), p.hj.call(this, ot, y.fI.REMOVE_GROUP_MEMBER);
        }
        var at = Ze;
        function pt(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(W.users)) throw Error('Invalid parameter: "users"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.users.join(","), ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/users/").concat(bt, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call removeGroupMembers", W), p.hj.call(this, ot, y.fI.MULTI_REMOVE_GROUP_MEMBER);
        }
        var It = pt;
        function Rt(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!(Array.isArray(W.username) || typeof W.username == "string" && W.username !== "")) throw Error('Invalid parameter: "username"');
          if (typeof W.muteDuration != "number") throw Error('Invalid parameter: "muteDuration"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { usernames: typeof W.username == "string" ? [W.username] : W.username, mute_duration: W.muteDuration }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/mute?resource=").concat(qe.clientResource), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, data: JSON.stringify(bt), success: W.success, error: W.error };
          return E.kg.debug("Call muteGroupMember", W), p.hj.call(this, ot, y.fI.MUTE_GROUP_MEMBER);
        }
        var gt = Rt;
        function it(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!(Array.isArray(W.username) || typeof W.username == "string" && W.username !== "")) throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.username, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/mute/").concat(bt, "?resource=").concat(qe.clientResource), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call unmuteGroupMember", W), p.hj.call(this, ot, y.fI.UNMUTE_GROUP_MEMBER);
        }
        var Tt = it;
        function Ut(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.groupId, et = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + qe + "/mute", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupMuteList", W), p.hj.call(this, et, y.fI.GET_GROUP_MUTE_LIST);
        }
        var st = Ut, Ot = Ut;
        function kt(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.username != "string" || W.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.username, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/blocks/users/").concat(bt, "?resource=").concat(qe.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call blockGroupMember", W), p.hj.call(this, ot, y.fI.BLOCK_GROUP_MEMBER);
        }
        var wt = kt;
        function Et(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(W.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { usernames: W.usernames }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/blocks/users?resource=").concat(qe.clientResource), data: JSON.stringify(bt), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call blockGroupMembers", W), p.hj.call(this, ot, y.fI.BLOCK_GROUP_MEMBERS);
        }
        var ut = Et;
        function St(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.username != "string" || W.username === "") throw Error('Invalid parameter: "username"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.username, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/blocks/users/").concat(bt, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call unblockGroupMember", W), p.hj.call(this, ot, y.fI.UNBLOCK_GROUP_MEMBER);
        }
        var Ft = St;
        function Ht(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(W.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.usernames.join(","), ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/blocks/users/").concat(bt, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call unblockGroupMembers", W), p.hj.call(this, ot, y.fI.UNBLOCK_GROUP_MEMBERS);
        }
        var zt = Ht;
        function ze(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.groupId, et = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + qe + "/blocks/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupBlacklist", W), p.hj.call(this, et, y.fI.GET_GROUP_BLACK_LIST);
        }
        var Ne = ze, le = ze;
        function X(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/ban?resource=").concat(qe.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call disableSendGroupMsg", W), p.hj.call(this, bt, y.fI.DISABLED_SEND_GROUP_MSG);
        }
        function re(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/ban?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call enableSendGroupMsg", W), p.hj.call(this, bt, y.fI.ENABLE_SEND_GROUP_MSG);
        }
        function Me(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(W.users)) throw Error('Invalid parameter: "users"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { usernames: W.users }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/white/users?resource=").concat(qe.clientResource), type: "POST", data: JSON.stringify(bt), dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call addUsersToGroupWhitelist", W), p.hj.call(this, ot, y.fI.ADD_USERS_TO_GROUP_WHITE);
        }
        var Se = Me;
        function ke(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.userName != "string" || W.userName === "") throw Error('Invalid parameter: "userName"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/white/users/").concat(W.userName, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call removeGroupAllowlistMember", W), p.hj.call(this, bt, y.fI.REMOVE_GROUP_WHITE_MEMBER);
        }
        var Ge = ke, nt = ke;
        function rt(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.groupId, et = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + qe + "/white/users", type: "GET", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupAllowlist", W), p.hj.call(this, et, y.fI.GET_GROUP_WHITE_LIST);
        }
        var dt = rt;
        function lt(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.userName != "string" || W.userName === "") throw Error('Invalid parameter: "userName"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.groupId, et = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + qe + "/white/users/" + W.userName, type: "GET", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call isInGroupAllowlist", W), p.hj.call(this, et, y.fI.IS_IN_GROUP_WHITE_LIST);
        }
        var Ct = lt, Ie = lt;
        function x(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.userId, et = { url: this.apiUrl + "/" + we + "/" + Fe + "/sdk/chatgroups/" + W.groupId + "/mute/" + qe, dataType: "json", type: "GET", headers: { Authorization: "Bearer " + je } };
          return E.kg.debug("Call isInGroupMutelist", W), p.hj.call(this, et).then(function(bt) {
            return { type: bt.type, data: bt.data };
          });
        }
        function ae(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.msgId != "string" || W.msgId === "") throw Error('Invalid parameter: "msgId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = { url: this.apiUrl + "/" + we + "/" + Fe + "/chatgroups/" + W.groupId + "/acks/" + W.msgId, dataType: "json", type: "GET", data: { limit: 500, key: void 0 }, headers: { Authorization: "Bearer " + je }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupMsgReadUser", W), p.hj.call(this, qe, y.fI.GET_GROUP_MSG_READ_USER);
        }
        function Q(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.groupId, et = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(qe, "/announcement"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call fetchGroupAnnouncement", W), p.hj.call(this, et, y.fI.GET_GROUP_ANN);
        }
        function Z(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.announcement != "string") throw Error('Invalid parameter: "announcement"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = { announcement: W.announcement }, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/announcement?resource=").concat(qe.clientResource), type: "POST", dataType: "json", data: JSON.stringify(bt), headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call updateGroupAnnouncement", W), p.hj.call(this, ot, y.fI.UPDATE_GROUP_ANN);
        }
        function ge(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (g(W.file) !== "object") throw Error('Invalid parameter: "file"');
          if (m.XZ.call(this)) {
            var ce = this.context, fe = ce.orgName, we = ce.appName, Fe = ce.accessToken, je = ce.jid, qe = W.groupId;
            p.cT.call(this, { uploadUrl: "".concat(this.apiUrl, "/").concat(fe, "/").concat(we, "/chatgroups/").concat(qe, "/share_files?resource=").concat(je.clientResource), onFileUploadProgress: W.onFileUploadProgress, onFileUploadComplete: W.onFileUploadComplete, onFileUploadError: W.onFileUploadError, onFileUploadCanceled: W.onFileUploadCanceled, accessToken: Fe, apiUrl: this.apiUrl, file: W.file, appKey: this.context.appKey }, y.fI.UPLOAD_GROUP_FILE), E.kg.debug("Call uploadGroupSharedFile", W);
          }
        }
        function me(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (typeof W.fileId != "string" || W.fileId === "") throw Error('Invalid parameter: "file"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = fe.jid, et = W.groupId, bt = W.fileId, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(et, "/share_files/").concat(bt, "?resource=").concat(qe.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call deleteGroupSharedFile", W), p.hj.call(this, ot, y.fI.DELETE_GROUP_FILE);
        }
        function ve(W) {
          if (typeof W.groupId != "string" || W.groupId === "") throw Error('Invalid parameter: "groupId"');
          if (!m.XZ.call(this)) {
            var ce = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ce);
          }
          var fe = this.context, we = fe.orgName, Fe = fe.appName, je = fe.accessToken, qe = W.pageNum || 1, et = W.pageSize || 10, bt = W.groupId, ot = { url: "".concat(this.apiUrl, "/").concat(we, "/").concat(Fe, "/chatgroups/").concat(bt, "/share_files?pagenum=").concat(qe, "&pagesize=").concat(et), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + je, "Content-Type": "application/json" }, success: W.success, error: W.error };
          return E.kg.debug("Call getGroupSharedFilelist", W), p.hj.call(this, ot, y.fI.GET_GROUP_FILE_LIST);
        }
        var ie = ve;
        function ye(W) {
          var ce = this.context, fe = ce.orgName, we = ce.appName, Fe = ce.accessToken, je = this.apiUrl, qe = W.groupId, et = W.fileId;
          p.LR.call(this, { url: "".concat(je, "/").concat(fe, "/").concat(we, "/chatgroups/").concat(qe, "/share_files/").concat(et), onFileDownloadComplete: W.onFileDownloadComplete, onFileDownloadError: W.onFileDownloadError, accessToken: Fe, id: et, secret: W.secret }, y.fI.DOWN_GROUP_FILE), E.kg.debug("Call downloadGroupSharedFile", W);
        }
        function Ye(W) {
          return C(this, void 0, void 0, function() {
            var ce, fe, we, Fe, je, qe, et, bt, ot, Lt, Kt;
            return O(this, function($t) {
              switch ($t.label) {
                case 0:
                  if (ce = W.groupId, fe = W.userId, we = W.memberAttributes, typeof ce != "string" || ce === "") throw Error('Invalid parameter: "groupId"');
                  if (typeof fe != "string" || fe === "") throw Error('Invalid parameter: "userId"');
                  if (g(we) !== "object") throw Error('Invalid parameter: "memberAttributes"');
                  return m.XZ.call(this) ? (je = this.context, qe = je.orgName, et = je.appName, bt = je.accessToken, ot = je.jid, Lt = { metaData: we }, Kt = { url: "".concat(this.apiUrl, "/").concat(qe, "/").concat(et, "/sdk/metadata/chatgroup/").concat(ce, "/user/").concat(fe, "?resource=").concat(ot.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(Lt), headers: { Authorization: "Bearer " + bt, "Content-Type": "application/json" } }, E.kg.debug("Call setGroupMemberAttributes", W), [4, p.hj.call(this, Kt, y.fI.SET_GROUP_MEMBER_ATTRS)]) : (Fe = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(Fe)]);
                case 1:
                  return $t.sent(), [2];
              }
            });
          });
        }
        function ne(W) {
          var ce = W.groupId, fe = W.userId;
          return Qe.call(this, { groupId: ce, userIds: [fe] }).then(function(we) {
            var Fe;
            return { type: we.type, data: (Fe = we.data) === null || Fe === void 0 ? void 0 : Fe[fe] };
          });
        }
        function Qe(W) {
          var ce = W.groupId, fe = W.userIds, we = W.keys, Fe = we === void 0 ? [] : we;
          if (typeof ce != "string" || ce === "") throw Error('Invalid parameter: "groupId"');
          if (!Array.isArray(fe) || (fe == null ? void 0 : fe.length) <= 0) throw Error('Invalid parameter: "userIds"');
          if (!Array.isArray(Fe)) throw Error('Invalid parameter: "keys"');
          if (!m.XZ.call(this)) {
            var je = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(je);
          }
          var qe = this.context, et = qe.orgName, bt = qe.appName, ot = qe.accessToken, Lt = { targets: fe, properties: Fe }, Kt = { url: "".concat(this.apiUrl, "/").concat(et, "/").concat(bt, "/sdk/metadata/chatgroup/").concat(ce, "/get"), type: "POST", dataType: "json", data: JSON.stringify(Lt), headers: { Authorization: "Bearer " + ot, "Content-Type": "application/json" } };
          return E.kg.debug("Call getGroupMembersAttributes", W), p.hj.call(this, Kt, y.fI.GET_GROUP_MEMBER_ATTR).then(function($t) {
            return { type: $t.type, data: ($t == null ? void 0 : $t.data) || {} };
          });
        }
      }, 7479: function(l, v, s) {
        s.r(v), s.d(v, { acceptContactInvite: function() {
          return Be;
        }, acceptInvitation: function() {
          return $e;
        }, addContact: function() {
          return Pe;
        }, addConversationMark: function() {
          return Me;
        }, addReaction: function() {
          return st;
        }, addToBlackList: function() {
          return at;
        }, addUsersToBlacklist: function() {
          return pt;
        }, addUsersToBlocklist: function() {
          return It;
        }, declineContactInvite: function() {
          return Ze;
        }, declineInvitation: function() {
          return Ke;
        }, deleteAllMessagesAndConversations: function() {
          return nt;
        }, deleteContact: function() {
          return be;
        }, deleteConversation: function() {
          return de;
        }, deleteReaction: function() {
          return Ot;
        }, deleteSession: function() {
          return ee;
        }, fetchHistoryMessages: function() {
          return Te;
        }, fetchUserInfoById: function() {
          return Ce;
        }, getAllContacts: function() {
          return le;
        }, getBlacklist: function() {
          return F;
        }, getBlocklist: function() {
          return j;
        }, getContacts: function() {
          return U;
        }, getContactsWithCursor: function() {
          return X;
        }, getConversationlist: function() {
          return ue;
        }, getHistoryMessages: function() {
          return Oe;
        }, getReactionDetail: function() {
          return Et;
        }, getReactionList: function() {
          return kt;
        }, getReactionlist: function() {
          return wt;
        }, getRoster: function() {
          return G;
        }, getSelfIdsOnOtherPlatform: function() {
          return Ge;
        }, getServerConversations: function() {
          return Ft;
        }, getServerConversationsByFilter: function() {
          return ke;
        }, getServerPinnedConversations: function() {
          return zt;
        }, getServerPinnedMessages: function() {
          return Ct;
        }, getSessionList: function() {
          return J;
        }, getTokenExpireTimestamp: function() {
          return Le;
        }, modifyMessage: function() {
          return Ut;
        }, pinConversation: function() {
          return ze;
        }, pinMessage: function() {
          return dt;
        }, recallMessage: function() {
          return Tt;
        }, removeConversationMark: function() {
          return Se;
        }, removeFromBlackList: function() {
          return Rt;
        }, removeHistoryMessages: function() {
          return St;
        }, removeRoster: function() {
          return xe;
        }, removeUserFromBlackList: function() {
          return gt;
        }, removeUserFromBlocklist: function() {
          return it;
        }, reportMessage: function() {
          return ut;
        }, setContactRemark: function() {
          return Ne;
        }, unbindPushToken: function() {
          return Ie;
        }, unpinMessage: function() {
          return lt;
        }, updateCurrentUserNick: function() {
          return _e;
        }, updateOwnUserInfo: function() {
          return he;
        }, updateUserInfo: function() {
          return pe;
        }, uploadPushToken: function() {
          return V;
        }, uploadToken: function() {
          return M;
        } }), s(9601), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(9554), s(4747), s(2222), s(7941), s(6699), s(3710), s(9714), s(9600), s(5069), s(561), s(9753), s(8309), s(1249), s(7327);
        var c = s(3246), d = s(5531), p = s(7252), m = s(4024), E = s(9937), y = s(8161), g = s(4188), C = s.n(g), O = s(7360), N = s(1595), w = s(4363), _ = s(7288), I = s(9743), k = s(6801), H = function() {
          return H = Object.assign || function(x) {
            for (var ae, Q = 1, Z = arguments.length; Q < Z; Q++) for (var ge in ae = arguments[Q]) Object.prototype.hasOwnProperty.call(ae, ge) && (x[ge] = ae[ge]);
            return x;
          }, H.apply(this, arguments);
        }, S = function(x, ae, Q, Z) {
          return new (Q || (Q = Promise))(function(ge, me) {
            function ve(Ye) {
              try {
                ye(Z.next(Ye));
              } catch (ne) {
                me(ne);
              }
            }
            function ie(Ye) {
              try {
                ye(Z.throw(Ye));
              } catch (ne) {
                me(ne);
              }
            }
            function ye(Ye) {
              var ne;
              Ye.done ? ge(Ye.value) : (ne = Ye.value, ne instanceof Q ? ne : new Q(function(Qe) {
                Qe(ne);
              })).then(ve, ie);
            }
            ye((Z = Z.apply(x, [])).next());
          });
        }, B = function(x, ae) {
          var Q, Z, ge, me, ve = { label: 0, sent: function() {
            if (1 & ge[0]) throw ge[1];
            return ge[1];
          }, trys: [], ops: [] };
          return me = { next: ie(0), throw: ie(1), return: ie(2) }, typeof Symbol == "function" && (me[Symbol.iterator] = function() {
            return this;
          }), me;
          function ie(ye) {
            return function(Ye) {
              return function(ne) {
                if (Q) throw new TypeError("Generator is already executing.");
                for (; ve; ) try {
                  if (Q = 1, Z && (ge = 2 & ne[0] ? Z.return : ne[0] ? Z.throw || ((ge = Z.return) && ge.call(Z), 0) : Z.next) && !(ge = ge.call(Z, ne[1])).done) return ge;
                  switch (Z = 0, ge && (ne = [2 & ne[0], ge.value]), ne[0]) {
                    case 0:
                    case 1:
                      ge = ne;
                      break;
                    case 4:
                      return ve.label++, { value: ne[1], done: !1 };
                    case 5:
                      ve.label++, Z = ne[1], ne = [0];
                      continue;
                    case 7:
                      ne = ve.ops.pop(), ve.trys.pop();
                      continue;
                    default:
                      if (!((ge = (ge = ve.trys).length > 0 && ge[ge.length - 1]) || ne[0] !== 6 && ne[0] !== 2)) {
                        ve = 0;
                        continue;
                      }
                      if (ne[0] === 3 && (!ge || ne[1] > ge[0] && ne[1] < ge[3])) {
                        ve.label = ne[1];
                        break;
                      }
                      if (ne[0] === 6 && ve.label < ge[1]) {
                        ve.label = ge[1], ge = ne;
                        break;
                      }
                      if (ge && ve.label < ge[2]) {
                        ve.label = ge[2], ve.ops.push(ne);
                        break;
                      }
                      ge[2] && ve.ops.pop(), ve.trys.pop();
                      continue;
                  }
                  ne = ae.call(x, ve);
                } catch (Qe) {
                  ne = [6, Qe], Z = 0;
                } finally {
                  Q = ge = 0;
                }
                if (5 & ne[0]) throw ne[1];
                return { value: ne[0] ? ne[1] : void 0, done: !0 };
              }([ye, Ye]);
            };
          }
        }, D = { singleChat: "chat", chatRoom: "chatroom", groupChat: "groupchat" };
        function F(x) {
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = { url: this.apiUrl + "/" + Z + "/" + ge + "/users/" + this.user + "/blocks/users", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + me }, success: function(ie) {
            ie.data.forEach(function(ye) {
            }), typeof (x == null ? void 0 : x.success) == "function" && x.success(ie);
          }, error: function(ie) {
            typeof (x == null ? void 0 : x.error) == "function" && x.error(ie);
          } };
          return O.kg.debug("Call getBlocklist"), m.hj.call(this, ve, N.fI.GET_BLACK_LIST);
        }
        var j = F, G = U;
        function U(x) {
          var ae = this;
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = { url: this.apiUrl + "/" + ge + "/" + me + "/users/" + this.user + "/contacts/users", dataType: "json", type: "GET", headers: { Authorization: "Bearer " + ve }, success: function(ye) {
            var Ye = [];
            ye.data.forEach(function(ne) {
              Ye.push({ name: ne, subscription: "both", jid: ae.context.jid });
            }), typeof (x == null ? void 0 : x.success) == "function" && x.success(Ye);
          }, error: function(ye) {
            typeof (x == null ? void 0 : x.error) == "function" && x.error(ye);
          } };
          return O.kg.debug("Call getContacts"), m.hj.call(this, ie, N.fI.GET_CONTACTS);
        }
        function M(x) {
          return O.kg.debug("Call uploadPushToken"), k.r.call(this, x);
        }
        var V = M;
        function J(x) {
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/user_channels"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" }, success: x && (x == null ? void 0 : x.success), error: x && (x == null ? void 0 : x.error) };
          return O.kg.debug("Call getSessionList"), m.hj.call(this, ve, N.fI.GET_SESSION_LIST);
        }
        function ue(x) {
          var ae = this;
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = !!(x && typeof x.pageNum == "number" && typeof x.pageSize == "number" && x.pageNum > 0 && x.pageSize > 0), ye = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/users/").concat(this.user, "/user_channels").concat(ie ? "/page" : ""), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" }, success: x && (x == null ? void 0 : x.success), error: x && (x == null ? void 0 : x.error) };
          return ie && (ye.data = { pageNum: x.pageNum, pageSize: x.pageSize }), O.kg.debug("Call getConversationlist"), m.hj.call(this, ye, N.fI.GET_SESSION_LIST).then(function(Ye) {
            return se.call(ae, Ye);
          });
        }
        function se(x) {
          var ae = this, Q = x.data.channel_infos;
          return Q == null || Q.forEach(function(Z) {
            Z.meta && JSON.stringify(Z.meta) !== "{}" ? (Z.meta.payload = JSON.parse(Z.meta.payload), Z.lastMessage = w.w.call(ae, Z.meta, { formatCustomExts: !1 })) : Z.lastMessage = Z.meta, delete Z.meta;
          }), x;
        }
        function ee(x) {
          if (x && typeof x.channel != "string") throw Error("Invalid parameter channel: ".concat(x.channel));
          if (x && x.chatType !== "singleChat" && x.chatType !== "groupChat") throw Error("Invalid parameter chatType: ".concat(x.chatType));
          if (x && typeof x.deleteRoam != "boolean") throw Error("Invalid parameter deleteRoam: ".concat(x.deleteRoam));
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          var Q, Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = Z.jid;
          Q = x.chatType === "singleChat" ? "chat" : "groupChat";
          var ye = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/user/").concat(this.user, "/user_channel?resource=").concat(ie.clientResource), dataType: "json", type: "DELETE", data: JSON.stringify({ channel: x.channel, type: Q, delete_roam: x.deleteRoam }), headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" }, success: x.success, error: x.error };
          return O.kg.debug("Call deleteSession", x), m.hj.call(this, ye, N.fI.DELETE_SESSION);
        }
        var de = ee;
        function he(x, ae) {
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = ["nickname", "avatarurl", "mail", "phone", "gender", "sign", "birth", "ext"], ye = {}, Ye = m.P6.getEnvInfo();
          if (Ye.platform === "wx" || Ye.platform === "qq") if (typeof x == "string" && ae !== void 0) {
            if (!ie.includes(x)) throw new Error("illegal key, only these keys: nickname, avatarurl, mail, phone, gender, sign, birth, ext are allowed");
            ye[x] = ae;
          } else {
            if (Object.prototype.toString.call(x) !== "[object Object]") throw new Error("illegal params");
            ie.forEach(function(W) {
              ie.includes(W) && x[W] !== void 0 && (ye[W] = x[W]);
            });
          }
          else if (typeof x == "string") {
            if (!ie.includes(x)) throw new Error("illegal key, only these keys: nickname, avatarurl, mail, phone, gender, sign, birth, ext are allowed");
            ye = x + "=" + ae;
          } else {
            if (Object.prototype.toString.call(x) !== "[object Object]") throw new Error("illegal params");
            var ne = [];
            ie.forEach(function(W) {
              if (ie.includes(W) && x[W] !== void 0) {
                var ce = encodeURIComponent(W), fe = encodeURIComponent(x[W]);
                ne.push(ce + "=" + fe);
              }
            }), ye = ne.join("&");
          }
          var Qe = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/metadata/user/").concat(this.user), type: "PUT", data: ye, dataType: "json", headers: { Authorization: "Bearer " + ve, "Content-Type": "application/x-www-form-urlencoded" } };
          return O.kg.debug("Call updateOwnUserInfo", x), m.hj.call(this, Qe, N.fI.UPDATE_USER_INFO);
        }
        var pe = he;
        function Ce(x, ae) {
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          var Z, ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = [];
          if (typeof x == "string") ye = [x];
          else {
            if (Object.prototype.toString.call(x) !== "[object Array]") throw new Error("illegal params");
            ye = x;
          }
          Z = typeof ae == "string" ? [ae] : ae && Object.prototype.toString.call(ae) === "[object Array]" ? ae : ["nickname", "avatarurl", "mail", "phone", "gender", "sign", "birth", "ext"];
          var Ye = { url: "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/metadata/user/get"), type: "POST", data: JSON.stringify({ targets: ye, properties: Z }), dataType: "json", headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } };
          return O.kg.debug("Call fetchUserInfoById", x), m.hj.call(this, Ye, N.fI.GET_USER_INFO);
        }
        function _e(x) {
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user), type: "PUT", dataType: "json", data: JSON.stringify({ nickname: x }), headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } };
          return O.kg.debug("Call updateCurrentUserNick", x), m.hj.call(this, ve);
        }
        function Le(x) {
          if (typeof x != "string" || x === "") throw Error('Invalid parameter: "token"');
          var ae = this.context, Q = ae.orgName, Z = ae.appName, ge = { url: "".concat(this.apiUrl, "/").concat(Q, "/").concat(Z, "/sdk/users/").concat(this.user, "/token/expires"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + x, "Content-Type": "application/json" } };
          return O.kg.debug("Call getTokenExpireTimestamp", x), m.hj.call(this, ge, N.fI.SDK_INTERNAL);
        }
        function Te(x) {
          var ae = this;
          return new Promise(function(Q, Z) {
            if (!x.queue) throw Error('Invalid parameter: "specified"');
            if (!c.XZ.call(ae)) {
              var ge = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
              return Promise.reject(ge);
            }
            (function me(ve) {
              var ie = this, ye = ve.count || 20;
              K.call(this, { count: ye, isGroup: !!ve.isGroup, queue: ve.queue, start: ve.start, format: ve.format, success: function(Ye) {
                if (Ye.msgs.length >= ye || Ye.is_last) {
                  var ne = Ye.msgs.splice(0, ye).reverse();
                  ve.success && ve.success(ne), Q(ne);
                } else me.call(ie, H(H({}, ve), { start: null }));
              }, fail: function(Ye) {
                Z(Ye), ve.fail && ve.fail(Ye);
              } });
            }).call(ae, x), O.kg.debug("Call fetchHistoryMessages", x);
          });
        }
        function K(x) {
          var ae = this, Q = x.queue, Z = this.mr_cache[Q] || (this.mr_cache[Q] = { msgs: [] }), ge = this.context.userId, me = x.start || -1, ve = x.count || 20;
          if (Z.msgs.length >= ve || Z.is_last) typeof x.success == "function" && x.success(Z);
          else {
            Z && Z.next_key && (me = Z.next_key), x.start && (me = x.start);
            var ie = { queue: Q + (x.isGroup ? "@conference.easemob.com" : "@easemob.com"), start: me, end: -1 }, ye = this.context, Ye = ye.orgName, ne = ye.appName, Qe = { url: "".concat(this.apiUrl, "/").concat(Ye, "/").concat(ne, "/users/").concat(ge, "/messageroaming"), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + this.token, "Content-Type": "application/json" }, data: JSON.stringify(ie), success: function(W) {
              return S(ae, void 0, void 0, function() {
                var ce, fe, we, Fe, je, qe, et = this;
                return B(this, function(bt) {
                  switch (bt.label) {
                    case 0:
                      if (ce = W == null ? void 0 : W.data, !W.data.msgs) return typeof x.success == "function" && x.success(Z), Z.is_last = !0, Z.next_key = "", [2];
                      fe = ce.msgs, we = fe.length, Z.is_last = ce.is_last, Z.next_key = ce.next_key, Fe = function(ot) {
                        return S(et, void 0, void 0, function() {
                          var Lt, Kt, $t, yt, Wt;
                          return B(this, function(In) {
                            switch (In.label) {
                              case 0:
                                for (Lt = [], ot = C().atob(ot), Kt = 0, $t = ot.length; Kt < $t; ++Kt) Lt.push(ot.charCodeAt(Kt));
                                return yt = (yt = this.context.root.lookup("easemob.pb.Meta")).decode(Lt), Wt = { errorCode: 0, reason: "" }, yt.ns !== 1 ? [3, 2] : [4, y.Z.call(this, yt, Wt, !0, x.format)];
                              case 1:
                                return [2, In.sent()];
                              case 2:
                                return [2];
                            }
                          });
                        });
                      }, je = 0, bt.label = 1;
                    case 1:
                      return je < we ? [4, Fe(fe[je].msg)] : [3, 4];
                    case 2:
                      (qe = bt.sent()) && Z.msgs.push(qe), bt.label = 3;
                    case 3:
                      return je++, [3, 1];
                    case 4:
                      return typeof x.success == "function" && x.success(Z), [2];
                  }
                });
              });
            }, error: function(W) {
              if (W.error && W.error_description) {
                var ce = p.Z.create({ type: d.E.WEBIM_CONNCTION_AJAX_ERROR, message: "fetch history messages error", data: W });
                ae.onError && ae.onError(ce);
              }
            } };
            m.hj.call(this, Qe, N.fI.GET_HISTORY_MSG).catch(function(W) {
              typeof x.fail == "function" && x.fail(W);
            });
          }
        }
        function Oe(x) {
          var ae = this;
          return new Promise(function(Q, Z) {
            var ge = x.targetId, me = x.cursor, ve = me === void 0 ? -1 : me, ie = x.pageSize, ye = ie === void 0 ? 20 : ie, Ye = x.chatType, ne = x.searchDirection, Qe = x.searchOptions, W = Qe === void 0 ? {} : Qe, ce = W.msgTypes, fe = ce === void 0 ? [] : ce, we = W.startTime, Fe = we === void 0 ? null : we, je = W.endTime, qe = je === void 0 ? null : je, et = W.from, bt = et === void 0 ? null : et;
            if (typeof ge != "string" || ge === "") throw Error('"Invalid parameter": "targetId"');
            if (bt && typeof bt != "string") throw Error('"Invalid parameter": "searchOptions.from"');
            if (fe && !Array.isArray(fe)) throw Error('"Invalid parameter": "searchOptions.msgTypes"');
            if (Fe && typeof Fe != "number") throw Error('"Invalid parameter": "searchOptions.startTime"');
            if (qe && typeof Fe != "number") throw Error('"Invalid parameter": "searchOptions.endTime"');
            if (!c.XZ.call(ae)) {
              var ot = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
              return Z(ot);
            }
            var Lt = ae.context, Kt = Lt.orgName, $t = Lt.appName, yt = Lt.userId, Wt = x.chatType === "singleChat" ? "@easemob.com" : "@conference.easemob.com", In = { queue: "".concat(ge).concat(Wt), start: ve, pull_number: ye, is_positive: ne === "down", msgType: fe.join(",") || "", end: -1, startTime: Fe, endTime: qe, userId: Ye === "singleChat" ? null : bt }, gn = { url: "".concat(ae.apiUrl, "/").concat(Kt, "/").concat($t, "/users/").concat(yt, "/messageroaming"), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + ae.token, "Content-Type": "application/json" }, data: JSON.stringify(In), success: function(zn) {
              return S(ae, void 0, void 0, function() {
                var Xn, yr, ur, Yn, xi, gs, Or, da, Za = this;
                return B(this, function(js) {
                  switch (js.label) {
                    case 0:
                      Xn = zn == null ? void 0 : zn.data, yr = Xn.msgs || [], ur = function(Fs) {
                        return S(Za, void 0, void 0, function() {
                          var la, Gs, ka, Vs, ja;
                          return B(this, function(Xt) {
                            switch (Xt.label) {
                              case 0:
                                for (la = [], Fs = C().atob(Fs), Gs = 0, ka = Fs.length; Gs < ka; ++Gs) la.push(Fs.charCodeAt(Gs));
                                return Vs = (Vs = this.context.root.lookup("easemob.pb.Meta")).decode(la), ja = { errorCode: 0, reason: "" }, Vs.ns !== 1 ? [3, 2] : [4, y.Z.call(this, Vs, ja, !0, !0)];
                              case 1:
                                return [2, Xt.sent()];
                              case 2:
                                return [2];
                            }
                          });
                        });
                      }, Yn = [], xi = 0, js.label = 1;
                    case 1:
                      return xi < yr.length ? [4, ur(yr[xi].msg)] : [3, 4];
                    case 2:
                      (gs = js.sent()) && Yn.push(gs), js.label = 3;
                    case 3:
                      return xi++, [3, 1];
                    case 4:
                      return Xn.msgs = Yn, Or = { cursor: Xn.next_key, messages: Yn, isLast: Xn.is_last }, (da = x.success) === null || da === void 0 || da.call(x, Or), Q(Or), [2];
                  }
                });
              });
            }, error: x.fail };
            m.hj.call(ae, gn).catch(function(zn) {
              Z(zn);
            }), O.kg.debug("Call getHistoryMessages", x);
          });
        }
        function Pe(x, ae) {
          return S(this, void 0, void 0, function() {
            var Q, Z, ge, me, ve, ie, ye;
            return B(this, function(Ye) {
              switch (Ye.label) {
                case 0:
                  if (!c.XZ.call(this)) return Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(Q)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call addContact", x, ae), Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = Z.jid, ye = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/users/").concat(this.user, "/contacts/apply?resource=").concat(ie.clientResource), type: "POST", dataType: "json", data: JSON.stringify({ usernames: [x], reason: ae }), headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" } }, [4, m.hj.call(this, ye, N.fI.ROSTER_ADD)];
                case 1:
                  return Ye.sent(), [2];
              }
            });
          });
        }
        var xe = be;
        function be(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie;
            return B(this, function(ye) {
              switch (ye.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call deleteContact", x), Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = Q.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/contacts/users/").concat(x, "?resource=").concat(ve.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ie, N.fI.ROSTER_REMOVE)];
                case 1:
                  return ye.sent(), [2];
              }
            });
          });
        }
        function $e(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie;
            return B(this, function(ye) {
              switch (ye.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call acceptInvitation", x), Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = Q.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/contacts/accept/users/").concat(x, "?resource=").concat(ve.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ie, N.fI.ROSTER_ACCEPT)];
                case 1:
                  return ye.sent(), [2];
              }
            });
          });
        }
        var Be = $e;
        function Ke(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie;
            return B(this, function(ye) {
              switch (ye.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (typeof x != "string" || x === "") throw Error('"Invalid parameter": "to"');
                  return O.kg.debug("Call declineInvitation", x), Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = Q.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/users/").concat(this.user, "/contacts/decline/users/").concat(x, "?resource=").concat(ve.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ie, N.fI.ROSTER_DECLINE)];
                case 1:
                  return ye.sent(), [2];
              }
            });
          });
        }
        var Ze = Ke;
        function at(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye;
            return B(this, function(ne) {
              switch (ne.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (Q = x.name, Z = [], typeof Q == "string") {
                    if (Q === "") throw Error('"Invalid parameter": "name"');
                    Z = [Q];
                  } else {
                    if (!Array.isArray(Q)) throw Error('"Invalid parameter": "name"');
                    Z = Q;
                  }
                  return O.kg.debug("Call addToBlockList", x), ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = ge.jid, Ye = { url: "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/sdk/user/").concat(this.user, "/blocks?resource=").concat(ye.clientResource), type: "POST", dataType: "json", data: JSON.stringify({ usernames: Z }), headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } }, [4, m.hj.call(this, Ye, N.fI.ROSTER_BAN).then(function(Qe) {
                    return { type: Qe.type, data: { userIds: (Qe == null ? void 0 : Qe.data) || [] } };
                  })];
                case 1:
                  return [2, ne.sent()];
              }
            });
          });
        }
        var pt = at, It = at;
        function Rt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye;
            return B(this, function(ne) {
              switch (ne.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (Q = x.name, Z = [], typeof Q == "string") {
                    if (Q === "") throw Error('"Invalid parameter": "name"');
                    Z = [Q];
                  } else {
                    if (!Array.isArray(Q)) throw Error('"Invalid parameter": "name"');
                    Z = Q;
                  }
                  return O.kg.debug("Call removeFromBlockList", x), ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = ge.jid, Ye = { url: "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/sdk/user/").concat(this.user, "/blocks?resource=").concat(ye.clientResource), type: "DELETE", dataType: "json", data: JSON.stringify({ usernames: Z }), headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } }, [4, m.hj.call(this, Ye, N.fI.ROSTER_ALLOW)];
                case 1:
                  return ne.sent(), [2];
              }
            });
          });
        }
        var gt = Rt, it = Rt;
        function Tt(x) {
          var ae = this, Q = (x == null ? void 0 : x.ext) || "";
          if (typeof Q != "string") throw Error('"Invalid parameter": "ext"', Q);
          var Z = this.getUniqueId(), ge = { id: Z, to: x.to };
          this._msgHash[Z] = H({}, ge);
          var me = "";
          x.chatType !== void 0 ? me = x.chatType : x.type !== void 0 && (me = x.type === "chat" ? "singleChat" : x.type);
          var ve = { id: Z, type: "recall", chatType: me, ackId: x.mid, to: x.to, isChatThread: x.isChatThread || !1, metaExt: Q, success: function(ie) {
            return S(ae, void 0, void 0, function() {
              var ye, Ye, ne, Qe, W, ce, fe, we, Fe;
              return B(this, function(je) {
                switch (je.label) {
                  case 0:
                    return je.trys.push([0, 5, , 6]), me !== "singleChat" && me !== "groupChat" ? [3, 4] : [4, (ne = (Ye = this._localCache) === null || Ye === void 0 ? void 0 : Ye.getInstance()) === null || ne === void 0 ? void 0 : ne.removeMsgByServerMsgId(x.mid)];
                  case 1:
                    return je.sent(), [4, (W = (Qe = this._localCache) === null || Qe === void 0 ? void 0 : Qe.getInstance()) === null || W === void 0 ? void 0 : W.getConversationLastMessage(x.to, me)];
                  case 2:
                    return ye = je.sent(), [4, (fe = (ce = this._localCache) === null || ce === void 0 ? void 0 : ce.getInstance()) === null || fe === void 0 ? void 0 : fe.updateLocalConversation((0, I.MQ)({ conversationId: x.to, conversationType: me }), { lastMessageId: ye == null ? void 0 : ye.serverMsgId })];
                  case 3:
                    je.sent(), je.label = 4;
                  case 4:
                    return (we = x == null ? void 0 : x.success) === null || we === void 0 || we.call(x, ie), [3, 6];
                  case 5:
                    return je.sent(), (Fe = x == null ? void 0 : x.success) === null || Fe === void 0 || Fe.call(x, ie), [3, 6];
                  case 6:
                    return [2];
                }
              });
            });
          }, fail: x.fail };
          return O.kg.debug("Call recallMessage", x), this.mSync.send(ve, this);
        }
        function Ut(x) {
          var ae = x || {}, Q = ae.messageId, Z = ae.modifiedMessage;
          if (O.kg.debug("Call modifyMessage", Q, Z), Q === "") throw Error('Invalid parameter: "messageId"');
          if (Z.type !== "txt") throw Error('Invalid parameter: "modifiedMessage.type"');
          return this.mSync.send(H({ editMessageId: Q }, Z));
        }
        function st(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye;
            return B(this, function(ne) {
              switch (ne.label) {
                case 0:
                  if (typeof x.messageId != "string" || !x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
                  if (typeof x.reaction != "string" || !x.reaction) throw Error("Invalid parameter reaction: ".concat(x.reaction));
                  return c.XZ.call(this) ? (Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.reaction, ie = x.messageId, ye = { msgId: ie, message: ve }, Ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user), type: "POST", data: JSON.stringify(ye), dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, Ye)]) : (ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)]);
                case 1:
                  return ne.sent(), [2];
              }
            });
          });
        }
        function Ot(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye;
            return B(this, function(Ye) {
              switch (Ye.label) {
                case 0:
                  if (typeof x.reaction != "string" || !x.reaction) throw Error("Invalid parameter reactionId: ".concat(x.reaction));
                  return c.XZ.call(this) ? (Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.messageId, ie = x.reaction, ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user, "?msgId=").concat(ve, "&message=").concat(ie), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, ye)]) : (ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)]);
                case 1:
                  return Ye.sent(), [2];
              }
            });
          });
        }
        function kt(x) {
          if (typeof x.chatType != "string" || !x.chatType) throw Error("Invalid parameter chatType: ".concat(x.chatType));
          if (!x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.chatType, ie = x.messageId, ye = { msgIdList: typeof ie == "string" ? [ie] : ie, msgType: ve === "singleChat" ? "chat" : "groupchat", groupId: x.groupId || null }, Ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user), type: "GET", data: ye, dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } };
          return m.hj.call(this, Ye).then(function(ne) {
            var Qe = ne.data;
            return Qe == null || Qe.forEach(function(W) {
              W == null || W.reactionList.forEach(function(ce) {
                ce.isAddedBySelf = ce.state, delete ce.state, delete ce.reactionId;
              });
            }), ne;
          });
        }
        var wt = kt;
        function Et(x) {
          if (typeof x.reaction != "string" || !x.reaction) throw Error("Invalid parameter reaction: ".concat(x.reaction));
          if (typeof x.messageId != "string" || !x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          var Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.cursor, ie = x.pageSize, ye = { msgId: x.messageId, message: x.reaction, currentPage: ve || null, pageSize: ie || 20 }, Ye = { url: "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/reaction/user/").concat(this.user, "/detail"), type: "GET", data: ye, dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } };
          return m.hj.call(this, Ye).then(function(ne) {
            return ne.data.isAddedBySelf = ne.data.state, delete ne.data.state, delete ne.data.reactionId, ne;
          });
        }
        function ut(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe;
            return B(this, function(W) {
              switch (W.label) {
                case 0:
                  if (typeof x.reportType != "string" || !x.reportType) throw Error("Invalid parameter reportType: ".concat(x.reportType));
                  if (typeof x.messageId != "string" || !x.messageId) throw Error("Invalid parameter messageId: ".concat(x.messageId));
                  if (typeof x.reportReason != "string" || !x.reportReason) throw Error("Invalid parameter messageId: ".concat(x.reportReason));
                  return c.XZ.call(this) ? (Q = this.context, Z = Q.orgName, ge = Q.appName, me = Q.accessToken, ve = x.reportType, ie = x.reportReason, ye = x.messageId, Ye = { username: this.user, reportType: ve, reportReason: ie }, ne = "".concat(this.apiUrl, "/").concat(Z, "/").concat(ge, "/user/").concat(this.user, "/moderation/report/message/").concat(ye), Qe = { url: ne, type: "POST", data: JSON.stringify(Ye), dataType: "json", headers: { Authorization: "Bearer " + me, "Content-Type": "application/json" } }, [4, m.hj.call(this, Qe)]) : (ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)]);
                case 1:
                  return W.sent(), [2];
              }
            });
          });
        }
        function St(x) {
          var ae;
          return S(this, void 0, void 0, function() {
            var Q, Z, ge, me, ve, ie, ye, Ye, ne;
            return B(this, function(Qe) {
              switch (Qe.label) {
                case 0:
                  if (typeof x.targetId != "string" || x.targetId === "") throw Error('"Invalid parameter targetId": ' + x.targetId);
                  if (!["singleChat", "groupChat", "chatRoom"].includes(x.chatType)) throw Error('"Invalid parameter chatType": ' + x.chatType);
                  if (x.beforeTimeStamp && (typeof x.beforeTimeStamp != "number" || x.beforeTimeStamp < 0 || ((ae = x.beforeTimeStamp) === null || ae === void 0 ? void 0 : ae.toString().length) > 18)) throw Error('"Invalid parameter beforeTimeStamp": ' + x.beforeTimeStamp);
                  if (x.messageIds && !(Array.isArray(x.messageIds) && x.messageIds.length > 0 && x.messageIds.length <= 20)) throw Error('"Invalid parameter messageIds": ' + x.messageIds);
                  if (!x.messageIds && !x.beforeTimeStamp) throw Error("messageIds or beforeTimeStamp field is required.");
                  return c.XZ.call(this) ? (Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.userId, ie = x.chatType === "singleChat" ? "userId" : "groupId", ye = x.chatType === "singleChat" ? "chat" : "group", Ye = x.messageIds ? "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/message/roaming/").concat(ye, "/user/").concat(ve, "?").concat(ie, "=").concat(x.targetId, "&msgIdList=").concat(x.messageIds, "&resource=").concat(this.clientResource) : "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/message/roaming/").concat(ye, "/user/").concat(ve, "/time?").concat(ie, "=").concat(x.targetId, "&delTime=").concat(x.beforeTimeStamp, "&&resource=").concat(this.clientResource), ne = { url: Ye, dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + this.token, "Content-Type": "application/json" } }, O.kg.debug("Call removeHistoryMessages", x), [4, m.hj.call(this, ne)]) : (Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(Q)]);
                case 1:
                  return Qe.sent(), [2];
              }
            });
          });
        }
        function Ft(x) {
          var ae = this;
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          if (x != null && x.pageSize && typeof x.pageSize != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          if (x != null && x.cursor && typeof x.cursor != "string") throw Error("Invalid parameter cursor: ".concat(x.cursor));
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/user/").concat(this.user, "/user_channels/list?"), type: "GET", dataType: "json", data: { limit: (x == null ? void 0 : x.pageSize) || 20, cursor: (x == null ? void 0 : x.cursor) || "", need_mark: !0 }, headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" } };
          return O.kg.debug("Call getServerConversations", x), new Promise(function(ye, Ye) {
            m.hj.call(ae, ie, N.fI.GET_SESSION_LIST).then(function(ne) {
              return S(ae, void 0, void 0, function() {
                var Qe, W, ce = this;
                return B(this, function(fe) {
                  switch (fe.label) {
                    case 0:
                      return Qe = Ht.call(this, ne), this._localCache ? (W = Qe.data.conversations.map(function(we) {
                        return S(ce, void 0, void 0, function() {
                          var Fe, je, qe, et;
                          return B(this, function(bt) {
                            switch (bt.label) {
                              case 0:
                                return [4, (je = (Fe = this._localCache) === null || Fe === void 0 ? void 0 : Fe.getInstance()) === null || je === void 0 ? void 0 : je.storeMessage(we.lastMessage, _.r.SUCCESS, !0)];
                              case 1:
                                return bt.sent(), [4, (et = (qe = this._localCache) === null || qe === void 0 ? void 0 : qe.getInstance()) === null || et === void 0 ? void 0 : et.updateLocalConversation((0, I.MQ)({ conversationId: we.conversationId, conversationType: we.conversationType }), { unReadCount: we.unReadCount })];
                              case 2:
                                return bt.sent(), [2];
                            }
                          });
                        });
                      }), [4, Promise.all(W)]) : [3, 2];
                    case 1:
                      fe.sent(), fe.label = 2;
                    case 2:
                      return ye(Qe), [2];
                  }
                });
              });
            }).catch(function(ne) {
              Ye(ne);
            });
          });
        }
        function Ht(x) {
          var ae = this, Q = x.data, Z = Q.cursor, ge = Q.channel_infos, me = [];
          ge == null || ge.forEach(function(ie) {
            var ye = null;
            ie != null && ie.meta && JSON.stringify(ie.meta) !== "{}" && (ie.meta.payload = JSON.parse(ie.meta.payload), (ye = w.w.call(ae, ie.meta)).type !== "delivery" && ye.type !== "read" && ye.type !== "channel" && (ye.chatType = w.U[ye.chatType]));
            var Ye = { conversationId: ie.session_to, conversationType: ie.session_type === "chat" ? "singleChat" : "groupChat", isPinned: ie.is_top, pinnedTime: ie.is_top ? ie.update_top_status_time : 0, unReadCount: ie.unread_num, lastMessage: ye };
            ie.marks && (Ye.marks = ie.marks.map(function(ne) {
              return E.Z[ne];
            })), me.push(Ye);
          });
          var ve = { conversations: me, cursor: Z || "" };
          return { type: x.type, data: ve };
        }
        function zt(x) {
          var ae = this;
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          if (x != null && x.pageSize && typeof x.pageSize != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          if (x != null && x.cursor && typeof x.cursor != "string") throw Error("Invalid parameter cursor: ".concat(x.cursor));
          var Z = this.context, ge = Z.orgName, me = Z.appName, ve = Z.accessToken, ie = { url: "".concat(this.apiUrl, "/").concat(ge, "/").concat(me, "/sdk/user/").concat(this.user, "/user_channels/list?"), type: "GET", dataType: "json", data: { limit: (x == null ? void 0 : x.pageSize) || 20, cursor: (x == null ? void 0 : x.cursor) || "", is_top: !0, need_mark: !0 }, headers: { Authorization: "Bearer " + ve, "Content-Type": "application/json" } };
          return O.kg.debug("Call getServerPinnedConversations", x), m.hj.call(this, ie, N.fI.GET_SESSION_LIST).then(function(ye) {
            return Ht.call(ae, ye);
          });
        }
        function ze(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe;
            return B(this, function(we) {
              if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
              if (Q = x.conversationId, Z = x.conversationType, ge = x.isPinned, me = Z === "singleChat" ? "chat" : "groupChat", typeof Q != "string" || Q === "") throw Error("Invalid parameter conversationId: ".concat(Q));
              if (!["singleChat", "groupChat"].includes(Z)) throw Error("Invalid parameter conversationType: ".concat(Z));
              if (typeof ge != "boolean") throw Error("Invalid parameter isPinned: ".concat(ge));
              return ve = this.context, ie = ve.orgName, ye = ve.appName, Ye = ve.accessToken, ne = ve.jid, Qe = { type: me, to: Q }, W = ge ? "" : "type=".concat(me, "&to=").concat(Q, "&"), ce = "".concat(this.apiUrl, "/").concat(ie, "/").concat(ye, "/sdk/user/").concat(this.user, "/user_channel/top?").concat(W, "resource=").concat(ne.clientResource), fe = { url: ce, type: ge ? "POST" : "DELETE", dataType: "json", headers: { Authorization: "Bearer " + Ye, "Content-Type": "application/json" } }, ge && (fe.data = JSON.stringify(Qe)), O.kg.debug("Call pinConversation", x), [2, m.hj.call(this, fe, N.fI.PIN_CONVERSATION).then(function(Fe) {
                var je = Fe.type, qe = Fe.data;
                return { type: je, data: { isPinned: qe.is_top || !1, pinnedTime: qe.is_top ? qe.update_top_status_time : 0 } };
              })];
            });
          });
        }
        function Ne(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne;
            return B(this, function(Qe) {
              switch (Qe.label) {
                case 0:
                  if (ae = x.userId, Q = x.remark, !c.XZ.call(this)) return Z = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(Z)];
                  if (typeof ae != "string" || ae === "") throw Error('Invalid parameter: "userId"');
                  if (typeof Q != "string") throw Error('Invalid parameter: "remark"');
                  return O.kg.debug("Call setContactRemark", x), ge = this.context, me = ge.orgName, ve = ge.appName, ie = ge.accessToken, ye = ge.jid, Ye = "".concat(this.apiUrl, "/").concat(me, "/").concat(ve, "/users/").concat(this.context.userId, "/contacts/users/").concat(ae, "?resource=").concat(ye.clientResource), ne = { url: Ye, type: "PUT", data: JSON.stringify({ remark: Q }), dataType: "json", headers: { Authorization: "Bearer " + ie, "Content-Type": "application/json" } }, [4, m.hj.call(this, ne, N.fI.ROSTER_SET_CONTACT_REMARK)];
                case 1:
                  return Qe.sent(), [2];
              }
            });
          });
        }
        function le() {
          if (!c.XZ.call(this)) {
            var x = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(x);
          }
          var ae = this.context, Q = ae.orgName, Z = ae.appName, ge = ae.accessToken, me = { url: "".concat(this.apiUrl, "/").concat(Q, "/").concat(Z, "/users/").concat(this.user, "/contacts/users?needReturnRemark=true"), dataType: "json", type: "GET", headers: { Authorization: "Bearer " + ge } };
          return O.kg.debug("Call getAllContacts"), m.hj.call(this, me, N.fI.ROSTER_GET_ALL_CONTACTS_REMARKS).then(function(ve) {
            var ie = ((ve == null ? void 0 : ve.entities) || []).map(function(ye) {
              return { userId: ye.username, remark: ye.remark };
            });
            return { type: ve.type, data: ie };
          });
        }
        function X(x) {
          if (!c.XZ.call(this)) {
            var ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ae);
          }
          O.kg.debug("Call getContactsWithCursor", x);
          var Q = x || {}, Z = Q.pageSize, ge = Z === void 0 ? 20 : Z, me = Q.cursor, ve = me === void 0 ? "" : me;
          if (ge && typeof ge != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          var ie = this.context, ye = ie.orgName, Ye = ie.appName, ne = ie.accessToken, Qe = { url: "".concat(this.apiUrl, "/").concat(ye, "/").concat(Ye, "/users/").concat(this.user, "/contacts?needReturnRemark=true&limit=").concat(ge, "&cursor=").concat(ve), dataType: "json", type: "GET", headers: { Authorization: "Bearer " + ne } };
          return m.hj.call(this, Qe, N.fI.ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE).then(function(W) {
            var ce, fe, we = ((ce = W == null ? void 0 : W.data) === null || ce === void 0 ? void 0 : ce.contacts) || [], Fe = ((fe = W == null ? void 0 : W.data) === null || fe === void 0 ? void 0 : fe.cursor) || "", je = we.map(function(qe) {
              return { userId: qe.username, remark: qe.remark };
            });
            return { type: W.type, data: { cursor: Fe, contacts: je } };
          });
        }
        function re(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we;
            return B(this, function(Fe) {
              switch (Fe.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (O.kg.debug("Call markConversation", x), Z = (Q = x || {}).conversations, ge = Z === void 0 ? [] : Z, me = Q.mark, ve = Q.isMarked, !Array.isArray(ge)) throw Error("Invalid parameter conversations");
                  if (ie = ge.map(function(je) {
                    if (!je.conversationId || !["singleChat", "groupChat"].includes(je.conversationType)) throw Error("Invalid parameter conversations");
                    return { to: je.conversationId, type: D[je.conversationType] };
                  }), typeof ve != "boolean") throw Error("Invalid parameter isMarked: ".concat(ve));
                  if (typeof me != "number") throw Error("Invalid parameter mark: ".concat(me));
                  return ye = this.context, Ye = ye.orgName, ne = ye.appName, Qe = ye.accessToken, W = ye.userId, ce = ye.jid, fe = { mark: E.Z[me], targets: ie }, we = { url: "".concat(this.apiUrl, "/").concat(Ye, "/").concat(ne, "/sdk/user/").concat(W, "/user_channels/mark?resource=").concat(ce.clientResource), dataType: "json", data: JSON.stringify(fe), type: ve ? "Post" : "Delete", headers: { Authorization: "Bearer " + Qe } }, [4, m.hj.call(this, we, N.fI.MARK_CONVERSATION).then(function(je) {
                    var qe, et = ((qe = je.data) === null || qe === void 0 ? void 0 : qe.ignore) || [];
                    Array.isArray(et) && et.length > 0 && O.kg.debug("markConversation has ignored conversations", et.map(function(bt) {
                      return { conversationId: bt.to, conversationType: w.U[bt.type] };
                    }));
                  })];
                case 1:
                  return Fe.sent(), [2];
              }
            });
          });
        }
        function Me(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q;
            return B(this, function(Z) {
              return O.kg.debug("Call addConversationMark", x), ae = x.conversations, Q = x.mark, [2, re.call(this, { conversations: ae, mark: Q, isMarked: !0 })];
            });
          });
        }
        function Se(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q;
            return B(this, function(Z) {
              return O.kg.debug("Call removeConversationMark", x), ae = x.conversations, Q = x.mark, [2, re.call(this, { conversations: ae, mark: Q, isMarked: !1 })];
            });
          });
        }
        function ke(x) {
          var ae, Q, Z = this;
          if (!c.XZ.call(this)) {
            var ge = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(ge);
          }
          if (O.kg.debug("Call getServerConversationsByFilter", x), (x == null ? void 0 : x.pageSize) && typeof x.pageSize != "number") throw Error("Invalid parameter pageSize: ".concat(x.pageSize));
          if (x != null && x.cursor && typeof x.cursor != "string") throw Error("Invalid parameter cursor: ".concat(x.cursor));
          if (typeof ((ae = x == null ? void 0 : x.filter) === null || ae === void 0 ? void 0 : ae.mark) != "number") throw Error("Invalid parameter mark: ".concat((Q = x == null ? void 0 : x.filter) === null || Q === void 0 ? void 0 : Q.mark));
          var me = this.context, ve = me.orgName, ie = me.appName, ye = me.accessToken, Ye = "".concat(this.apiUrl, "/").concat(ve, "/").concat(ie, "/sdk/user/").concat(this.user, "/user_channels/mark/search?"), ne = x.pageSize, Qe = x.cursor, W = ((x == null ? void 0 : x.filter) || {}).mark, ce = { url: Ye, type: "GET", dataType: "json", data: { limit: ne || 10, cursor: Qe || "", need_mark: !0, mark: E.Z[W] }, headers: { Authorization: "Bearer " + ye, "Content-Type": "application/json" } };
          return m.hj.call(this, ce, N.fI.GET_SESSION_LIST).then(function(fe) {
            return Ht.call(Z, fe);
          });
        }
        function Ge() {
          if (!c.XZ.call(this)) {
            var x = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(x);
          }
          O.kg.debug("Call getSelfIdsOnOtherPlatform");
          var ae = this.context, Q = ae.orgName, Z = ae.appName, ge = ae.accessToken, me = ae.userId, ve = ae.jid, ie = { url: "".concat(this.apiUrl, "/").concat(Q, "/").concat(Z, "/users/").concat(me, "/resources"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + ge, "Content-Type": "application/json" } };
          return m.hj.call(this, ie, N.fI.USER_LOGGEDIN_OTHER_PLATFORM).then(function(ye) {
            var Ye, ne = (Ye = ye.data) === null || Ye === void 0 ? void 0 : Ye.filter(function(W) {
              return W.res !== ve.clientResource;
            }), Qe = ne == null ? void 0 : ne.map(function(W) {
              return "".concat(me, "/").concat(W.res);
            });
            return { type: ye.type, data: Qe };
          });
        }
        function nt() {
          var x, ae, Q, Z, ge, me;
          return S(this, void 0, void 0, function() {
            var ve, ie, ye, Ye, ne, Qe, W, ce, fe;
            return B(this, function(we) {
              switch (we.label) {
                case 0:
                  return c.XZ.call(this) ? (O.kg.debug("Call deleteAllMessagesAndConversations"), ie = this.context, ye = ie.orgName, Ye = ie.appName, ne = ie.accessToken, Qe = ie.userId, W = ie.jid, ce = "".concat(this.apiUrl, "/").concat(ye, "/").concat(Ye, "/sdk/message/roaming/user/").concat(Qe, "/delete/all?resource=").concat(W.clientResource), fe = { url: ce, type: "POST", dataType: "json", headers: { Authorization: "Bearer " + ne, "Content-Type": "application/json" } }, [4, m.hj.call(this, fe, N.fI.REST_DELETE_MESSAGES_CONVERSATIONS)]) : (ve = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ve)]);
                case 1:
                  return we.sent(), (ae = (x = this._localCache) === null || x === void 0 ? void 0 : x.getInstance()) === null || ae === void 0 || ae.clearConversationMap(), [4, (Z = (Q = this._localCache) === null || Q === void 0 ? void 0 : Q.getInstance()) === null || Z === void 0 ? void 0 : Z.clearStoreData("conversationList")];
                case 2:
                  return we.sent(), [4, (me = (ge = this._localCache) === null || ge === void 0 ? void 0 : ge.getInstance()) === null || me === void 0 ? void 0 : me.clearStoreData("message")];
                case 3:
                  return we.sent(), [2];
              }
            });
          });
        }
        function rt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we;
            return B(this, function(Fe) {
              switch (Fe.label) {
                case 0:
                  if (!c.XZ.call(this)) return ae = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(ae)];
                  if (O.kg.debug("Call setMessagePinStatus", x), Z = (Q = x || {}).conversationId, ge = Z === void 0 ? "" : Z, me = Q.conversationType, ve = Q.messageId, ie = Q.isPinned, typeof ge != "string" || ge === "") throw Error("Invalid parameter conversationId");
                  if (typeof ve != "string" || ve === "") throw Error("Invalid parameter messageId");
                  if (typeof ie != "boolean") throw Error("Invalid parameter isPinned");
                  return ye = this.context, Ye = ye.orgName, ne = ye.appName, Qe = ye.accessToken, W = ye.userId, ce = ye.jid, fe = { to: ge, type: D[me], pin_msg_id: ve }, we = { url: "".concat(this.apiUrl, "/").concat(Ye, "/").concat(ne, "/sdk/user/").concat(W, "/user_channel/pin?resource=").concat(ce.clientResource), dataType: "json", data: JSON.stringify(fe), type: ie ? "Post" : "Delete", headers: { Authorization: "Bearer " + Qe } }, [4, m.hj.call(this, we, N.fI.REST_PIN_MESSAGE)];
                case 1:
                  return Fe.sent(), [2];
              }
            });
          });
        }
        function dt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge;
            return B(this, function(me) {
              return O.kg.debug("Call pinMessage", x), Q = (ae = x || {}).conversationType, Z = ae.conversationId, ge = ae.messageId, [2, rt.call(this, { conversationId: Z, conversationType: Q, messageId: ge, isPinned: !0 })];
            });
          });
        }
        function lt(x) {
          return S(this, void 0, void 0, function() {
            var ae, Q, Z, ge;
            return B(this, function(me) {
              return O.kg.debug("Call unpinMessage", x), Q = (ae = x || {}).conversationType, Z = ae.conversationId, ge = ae.messageId, [2, rt.call(this, { conversationId: Z, conversationType: Q, messageId: ge, isPinned: !1 })];
            });
          });
        }
        function Ct(x) {
          var ae = this;
          if (!c.XZ.call(this)) {
            var Q = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(Q);
          }
          O.kg.debug("Call getServerPinnedMessages", x);
          var Z = x.conversationId, ge = x.conversationType, me = x.pageSize, ve = x.cursor;
          if (typeof Z != "string" || Z === "") throw Error("Invalid parameter conversationId");
          if (me && typeof me != "number") throw Error("Invalid parameter pageSize: ".concat(me));
          if (ve && typeof ve != "string") throw Error("Invalid parameter cursor: ".concat(ve));
          var ie = this.context, ye = ie.orgName, Ye = ie.appName, ne = ie.accessToken, Qe = { url: "".concat(this.apiUrl, "/").concat(ye, "/").concat(Ye, "/sdk/user/").concat(this.user, "/user_channel/pin"), type: "GET", dataType: "json", data: { to: Z, type: D[ge], limit: me || 10, cursor: ve || "" }, headers: { Authorization: "Bearer " + ne, "Content-Type": "application/json" } };
          return m.hj.call(this, Qe, N.fI.GET_SESSION_LIST).then(function(W) {
            return { type: 0, data: { list: W.data.msg_infos.map(function(ce) {
              ce.message.payload = JSON.parse(ce.message.payload);
              var fe = ce.message, we = ce.pin_opt_at, Fe = ce.pin_operator;
              return { message: w.w.call(ae, fe, { formatChatType: !0 }), pinTime: we, operatorId: Fe };
            }), cursor: W.data.cursor || "" } };
          });
        }
        function Ie() {
          var x = this;
          O.kg.debug("Call unbindPushToken");
          var ae = { deviceId: this.clientResource, deviceToken: "", notifierName: this.pushCertificateName };
          return k.r.call(this, ae).then(function(Q) {
            return x.isRegisterPush = !1, Q;
          });
        }
      }, 3770: function(l, v, s) {
        s.r(v), s.d(v, { getPresenceStatus: function() {
          return I;
        }, getSubscribedPresenceList: function() {
          return w;
        }, getSubscribedPresencelist: function() {
          return _;
        }, publishPresence: function() {
          return C;
        }, subscribePresence: function() {
          return O;
        }, unsubscribePresence: function() {
          return N;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(2222), s(9753);
        var c = s(4024), d = s(3246), p = s(7252), m = s(5531), E = s(7360), y = function(k, H, S, B) {
          return new (S || (S = Promise))(function(D, F) {
            function j(M) {
              try {
                U(B.next(M));
              } catch (V) {
                F(V);
              }
            }
            function G(M) {
              try {
                U(B.throw(M));
              } catch (V) {
                F(V);
              }
            }
            function U(M) {
              var V;
              M.done ? D(M.value) : (V = M.value, V instanceof S ? V : new S(function(J) {
                J(V);
              })).then(j, G);
            }
            U((B = B.apply(k, [])).next());
          });
        }, g = function(k, H) {
          var S, B, D, F, j = { label: 0, sent: function() {
            if (1 & D[0]) throw D[1];
            return D[1];
          }, trys: [], ops: [] };
          return F = { next: G(0), throw: G(1), return: G(2) }, typeof Symbol == "function" && (F[Symbol.iterator] = function() {
            return this;
          }), F;
          function G(U) {
            return function(M) {
              return function(V) {
                if (S) throw new TypeError("Generator is already executing.");
                for (; j; ) try {
                  if (S = 1, B && (D = 2 & V[0] ? B.return : V[0] ? B.throw || ((D = B.return) && D.call(B), 0) : B.next) && !(D = D.call(B, V[1])).done) return D;
                  switch (B = 0, D && (V = [2 & V[0], D.value]), V[0]) {
                    case 0:
                    case 1:
                      D = V;
                      break;
                    case 4:
                      return j.label++, { value: V[1], done: !1 };
                    case 5:
                      j.label++, B = V[1], V = [0];
                      continue;
                    case 7:
                      V = j.ops.pop(), j.trys.pop();
                      continue;
                    default:
                      if (!((D = (D = j.trys).length > 0 && D[D.length - 1]) || V[0] !== 6 && V[0] !== 2)) {
                        j = 0;
                        continue;
                      }
                      if (V[0] === 3 && (!D || V[1] > D[0] && V[1] < D[3])) {
                        j.label = V[1];
                        break;
                      }
                      if (V[0] === 6 && j.label < D[1]) {
                        j.label = D[1], D = V;
                        break;
                      }
                      if (D && j.label < D[2]) {
                        j.label = D[2], j.ops.push(V);
                        break;
                      }
                      D[2] && j.ops.pop(), j.trys.pop();
                      continue;
                  }
                  V = H.call(k, j);
                } catch (J) {
                  V = [6, J], B = 0;
                } finally {
                  S = D = 0;
                }
                if (5 & V[0]) throw V[1];
                return { value: V[0] ? V[1] : void 0, done: !0 };
              }([U, M]);
            };
          }
        };
        function C(k) {
          return y(this, void 0, void 0, function() {
            var H, S, B, D, F, j, G, U, M;
            return g(this, function(V) {
              switch (V.label) {
                case 0:
                  if (typeof k.description != "string") throw Error('Invalid parameter: "description"');
                  return d.XZ.call(this) ? (S = this.context, B = S.accessToken, D = S.orgName, F = S.appName, j = S.userId, G = this.context.jid.clientResource, U = { ext: k.description }, M = { url: "".concat(this.apiUrl, "/").concat(D, "/").concat(F, "/users/").concat(j, "/presence/").concat(G, "/1"), type: "POST", dataType: "json", data: JSON.stringify(U), headers: { Authorization: "Bearer " + B, "Content-Type": "application/json" }, success: k.success, error: k.error }, E.kg.debug("Call publishPresence:", k), [4, c.hj.call(this, M)]) : (H = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(H)]);
                case 1:
                  return V.sent(), [2];
              }
            });
          });
        }
        function O(k) {
          if (!Array.isArray(k.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!k.usernames.length) throw Error('"usernames" can not be empty');
          if (typeof k.expiry != "number") throw Error('Invalid parameter: "expiry"');
          if (!d.XZ.call(this)) {
            var H = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(H);
          }
          var S = this.context, B = S.orgName, D = S.appName, F = S.userId, j = S.accessToken, G = { usernames: k.usernames }, U = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/presence/").concat(k.expiry), type: "POST", dataType: "json", data: JSON.stringify(G), headers: { Authorization: "Bearer " + j, "Content-Type": "application/json" }, success: k.success, error: k.error };
          return E.kg.debug("Call subscribePresence:", k), c.hj.call(this, U).then(function(M) {
            return M.data = { result: M == null ? void 0 : M.result }, M;
          });
        }
        function N(k) {
          return y(this, void 0, void 0, function() {
            var H, S, B, D, F, j, G;
            return g(this, function(U) {
              switch (U.label) {
                case 0:
                  if (!Array.isArray(k.usernames)) throw Error('Invalid parameter: "usernames"');
                  if (!k.usernames.length) throw Error('"usernames" can not be empty');
                  return d.XZ.call(this) ? (S = this.context, B = S.orgName, D = S.appName, F = S.userId, j = S.accessToken, G = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/presence"), type: "DELETE", dataType: "json", data: JSON.stringify(k.usernames), headers: { Authorization: "Bearer " + j, "Content-Type": "application/json" }, success: k.success, error: k.error }, E.kg.debug("Call unsubscribePresence:", k), [4, c.hj.call(this, G)]) : (H = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(H)]);
                case 1:
                  return U.sent(), [2];
              }
            });
          });
        }
        function w(k) {
          if (typeof k.pageNum != "number" || typeof k.pageSize != "number") throw Error('Invalid parameter: "pageNum or pageSize"');
          if (k.pageNum < 0 || k.pageSize < 0) throw Error('"pageNum" should >= 0 and "pageSize" should >= 0');
          if (!d.XZ.call(this)) {
            var H = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(H);
          }
          var S = this.context, B = S.orgName, D = S.appName, F = S.userId, j = S.accessToken, G = { url: "".concat(this.apiUrl, "/").concat(B, "/").concat(D, "/users/").concat(F, "/presence/sublist?pageNum=").concat(k.pageNum, "&pageSize=").concat(k.pageSize), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + j, "Content-Type": "application/json" }, success: k.success, error: k.error };
          return E.kg.debug("Call getSubscribedPresenceList:", k), c.hj.call(this, G).then(function(U) {
            return U.data = { result: U == null ? void 0 : U.result }, U;
          });
        }
        var _ = w;
        function I(k) {
          if (!Array.isArray(k.usernames)) throw Error('Invalid parameter: "usernames"');
          if (!k.usernames.length) throw Error('"usernames" can not be empty');
          if (!d.XZ.call(this)) {
            var H = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(H);
          }
          var S = { usernames: k.usernames }, B = this.context, D = B.orgName, F = B.appName, j = B.userId, G = B.accessToken, U = { url: "".concat(this.apiUrl, "/").concat(D, "/").concat(F, "/users/").concat(j, "/presence"), type: "POST", dataType: "json", data: JSON.stringify(S), headers: { Authorization: "Bearer " + G, "Content-Type": "application/json" }, success: k.success, error: k.error };
          return E.kg.debug("Call getPresenceStatus:", k), c.hj.call(this, U).then(function(M) {
            return M.data = { result: M == null ? void 0 : M.result }, M;
          });
        }
      }, 6801: function(l, v, s) {
        s.d(v, { r: function() {
          return g;
        } }), s(1539), s(8674), s(2222), s(4812);
        var c = s(3246), d = s(5531), p = s(7252), m = s(4024), E = s(7360), y = s(1595);
        function g(C) {
          if (typeof C.deviceId != "string" || C.deviceId === "") throw Error('Invalid parameter: "deviceId"');
          if (!c.XZ.call(this)) {
            var O = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(O);
          }
          var N = this.context, w = N.orgName, _ = N.appName, I = N.accessToken, k = { url: "".concat(this.apiUrl, "/").concat(w, "/").concat(_, "/users/").concat(this.user), type: "PUT", data: JSON.stringify({ device_id: C.deviceId, device_token: C.deviceToken, notifier_name: C.notifierName }), dataType: "json", headers: { Authorization: "Bearer " + I, "Content-Type": "application/json" }, success: C.success, error: C.error };
          E.kg.debug("Call uploadPushTokenToServer", C);
          var H = m.hj.bind(this, k, y.fI.UPLOAD_PUSH_TOKEN);
          return m.P6.retryPromise(H).then(function(S) {
            var B = S.entities[0] || {};
            return { type: S.type, data: B };
          });
        }
      }, 1735: function(l, v, s) {
        s.r(v), s.d(v, { clearRemindTypeForConversation: function() {
          return O;
        }, getPushPerformLanguage: function() {
          return I;
        }, getSilentModeForAll: function() {
          return g;
        }, getSilentModeForConversation: function() {
          return N;
        }, getSilentModeForConversations: function() {
          return w;
        }, getSilentModeRemindTypeConversations: function() {
          return k;
        }, setPushPerformLanguage: function() {
          return _;
        }, setSilentModeForAll: function() {
          return y;
        }, setSilentModeForConversation: function() {
          return C;
        } }), s(7941), s(1539), s(8674), s(2222), s(9753), s(9554), s(4747), s(9600), s(1249);
        var c = s(4024), d = s(3246), p = s(7252), m = s(5531), E = s(7360);
        function y(H) {
          if (!(H.options instanceof Object)) throw Error('Invalid parameter: "options"');
          var S = H.options.paramType;
          if (typeof S != "number" || S < 0 || S > 2) throw Error('Invalid parameter: "options of paramType"');
          if (S === 0) {
            if (typeof H.options.remindType != "string") throw Error('Invalid parameter: "options of remindType"');
          } else if (S === 1) {
            if (typeof H.options.duration != "number") throw Error('Invalid parameter: "options of duration"');
          } else if (S === 2) {
            var B = H.options, D = B.startTime, F = B.endTime;
            if (!(D instanceof Object && Object.keys(D).length)) throw Error('Invalid parameter: "options of startTime"');
            if (!D.hours || typeof D.hours != "number" || !D.minutes || typeof D.minutes != "number") throw Error('Invalid parameter: "options of startTime of hours or minutes"');
            if (!(F instanceof Object && Object.keys(F).length)) throw Error('Invalid parameter: "options of endTime"');
            if (!F.hours || typeof F.hours != "number" || !F.minutes || typeof F.minutes != "number") throw Error('Invalid parameter: "options of endTime of hours or minutes"');
          }
          if (!d.XZ.call(this)) {
            var j = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(j);
          }
          var G = this.context, U = G.accessToken, M = G.orgName, V = G.appName, J = G.userId, ue = G.jid, se = {};
          switch (S) {
            case 0:
              se = { type: H.options.remindType };
              break;
            case 1:
              se = { ignoreDuration: H.options.duration };
              break;
            case 2:
              var ee = H.options;
              D = ee.startTime, F = ee.endTime, se = { ignoreInterval: "".concat(D.hours, ":").concat(D.minutes, "-").concat(F.hours, ":").concat(F.minutes) };
          }
          var de = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/users/").concat(J, "/notification/user/").concat(J, "?resource=").concat(ue.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(se), headers: { Authorization: "Bearer " + U, "Content-Type": "application/json" }, success: H.success, error: H.error };
          return E.kg.debug("Call setSilentModeForAll:", H), c.hj.call(this, de);
        }
        function g(H) {
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          var B = this.context, D = B.accessToken, F = B.orgName, j = B.appName, G = B.userId, U = { url: "".concat(this.apiUrl, "/").concat(F, "/").concat(j, "/users/").concat(G, "/notification/user/").concat(G), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: H == null ? void 0 : H.success, error: H == null ? void 0 : H.error };
          return E.kg.debug("Call getSilentModeForAll:", H), c.hj.call(this, U);
        }
        function C(H) {
          if (typeof H.conversationId != "string" || !H.conversationId) throw Error('Invalid parameter: "conversationId"');
          if (typeof H.type != "string" || !H.type) throw Error('Invalid parameter: "type"');
          if (!(H.options instanceof Object)) throw Error('Invalid parameter: "options"');
          var S = H.options.paramType;
          if (typeof S != "number" || S < 0 || S > 2) throw Error('Invalid parameter: "options of paramType"');
          if (S === 0) {
            if (typeof H.options.remindType != "string") throw Error('Invalid parameter: "options of remindType"');
          } else if (S === 1) {
            if (typeof H.options.duration != "number") throw Error('Invalid parameter: "options of duration"');
          } else if (S === 2) {
            var B = H.options, D = B.startTime, F = B.endTime;
            if (!(D instanceof Object && Object.keys(D).length)) throw Error('Invalid parameter: "options of startTime"');
            if (!D.hours || typeof D.hours != "number" || !D.minutes || typeof D.minutes != "number") throw Error('Invalid parameter: "options of startTime of hours or minutes"');
            if (!(F instanceof Object && Object.keys(F).length)) throw Error('Invalid parameter: "options of endTime"');
            if (!F.hours || typeof F.hours != "number" || !F.minutes || typeof F.minutes != "number") throw Error('Invalid parameter: "options of endTime of hours or minutes"');
          }
          if (!d.XZ.call(this)) {
            var j = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(j);
          }
          var G = this.context, U = G.accessToken, M = G.orgName, V = G.appName, J = G.userId, ue = G.jid, se = "chatgroup", ee = {};
          switch (S) {
            case 0:
              ee = { type: H.options.remindType };
              break;
            case 1:
              ee = { ignoreDuration: H.options.duration };
              break;
            case 2:
              var de = H.options;
              D = de.startTime, F = de.endTime, ee = { ignoreInterval: "".concat(D.hours, ":").concat(D.minutes, "-").concat(F.hours, ":").concat(F.minutes) };
          }
          H.type === "singleChat" && (se = "user");
          var he = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/users/").concat(J, "/notification/").concat(se, "/").concat(H.conversationId, "?resource=").concat(ue.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(ee), headers: { Authorization: "Bearer " + U, "Content-Type": "application/json" }, success: H.success, error: H.error };
          return E.kg.debug("Call setSilentModeForConversation:", H), c.hj.call(this, he);
        }
        function O(H) {
          if (typeof H.conversationId != "string" || !H.conversationId) throw Error('Invalid parameter: "conversationId"');
          if (typeof H.type != "string" || !H.type) throw Error('Invalid parameter: "type"');
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          var B = this.context, D = B.accessToken, F = B.orgName, j = B.appName, G = B.userId, U = B.jid, M = "chatgroup";
          H.type === "singleChat" && (M = "user");
          var V = { url: "".concat(this.apiUrl, "/").concat(F, "/").concat(j, "/users/").concat(G, "/notification/").concat(M, "/").concat(H.conversationId, "?resource=").concat(U.clientResource), type: "PUT", dataType: "json", data: JSON.stringify({ type: "DEFAULT" }), headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: H.success, error: H.error };
          return E.kg.debug("Call clearRemindTypeForConversation:", H), c.hj.call(this, V);
        }
        function N(H) {
          if (typeof H.conversationId != "string" || !H.conversationId) throw Error('Invalid parameter: "conversationId"');
          if (typeof H.type != "string" || !H.type) throw Error('Invalid parameter: "type"');
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          var B = this.context, D = B.accessToken, F = B.orgName, j = B.appName, G = B.userId, U = "chatgroup";
          H.type === "singleChat" && (U = "user");
          var M = { url: "".concat(this.apiUrl, "/").concat(F, "/").concat(j, "/users/").concat(G, "/notification/").concat(U, "/").concat(H.conversationId), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: H.success, error: H.error };
          return E.kg.debug("Call getSilentModeForConversation:", H), c.hj.call(this, M);
        }
        function w(H) {
          if (!Array.isArray(H.conversationList)) throw Error('Invalid parameter: "conversationList"');
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          var B = this.context, D = B.accessToken, F = B.orgName, j = B.appName, G = B.userId, U = [], M = [];
          H.conversationList.forEach(function(se) {
            se.type === "singleChat" ? U.push(se.id) : M.push(se.id);
          });
          var V = U.length ? U.join(",") : "", J = M.length ? M.join(",") : "", ue = { url: "".concat(this.apiUrl, "/").concat(F, "/").concat(j, "/users/").concat(G, "/notification?user=").concat(V, "&group=").concat(J), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: H.success, error: H.error };
          return E.kg.debug("Call getSilentModeForConversations:", H), c.hj.call(this, ue);
        }
        function _(H) {
          if (typeof H.language != "string" || !H.language) throw Error('Invalid parameter: "language"');
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          var B = { translationLanguage: H.language }, D = this.context, F = D.accessToken, j = D.orgName, G = D.appName, U = D.userId, M = { url: "".concat(this.apiUrl, "/").concat(j, "/").concat(G, "/users/").concat(U, "/notification/language"), type: "PUT", dataType: "json", data: JSON.stringify(B), headers: { Authorization: "Bearer " + F, "Content-Type": "application/json" }, success: H.success, error: H.error };
          return E.kg.debug("Call setPushPerformLanguage:", H), c.hj.call(this, M);
        }
        function I(H) {
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          var B = this.context, D = B.accessToken, F = B.orgName, j = B.appName, G = B.userId, U = { url: "".concat(this.apiUrl, "/").concat(F, "/").concat(j, "/users/").concat(G, "/notification/language"), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" }, success: H == null ? void 0 : H.success, error: H == null ? void 0 : H.error };
          return E.kg.debug("Call getPushPerformLanguage:", H), c.hj.call(this, U);
        }
        function k(H) {
          if (!d.XZ.call(this)) {
            var S = p.Z.create({ type: m.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(S);
          }
          if (typeof H.pageSize != "number") throw Error('Invalid parameter: "pageSize"');
          var B = this.context, D = B.accessToken, F = B.orgName, j = B.appName, G = B.userId, U = { limit: H.pageSize || 10, cursor: H.cursor };
          H.cursor || delete U.cursor;
          var M = { url: "".concat(this.apiUrl, "/").concat(F, "/").concat(j, "/users/").concat(G, "/notification/mute/type"), type: "GET", dataType: "json", data: U, headers: { Authorization: "Bearer " + D, "Content-Type": "application/json" } };
          return E.kg.debug("Call getSilentModeRemindTypeConversations:", H), c.hj.call(this, M).then(function(V) {
            return V.data ? { data: { conversations: V.data.map(function(J) {
              return "user" in J ? { conversationId: J.user, type: "singleChat", remindType: J.value } : { conversationId: J.group, type: "groupChat", remindType: J.value };
            }), cursor: V.cursor }, type: V.type } : V;
          });
        }
      }, 7384: function(l, v, s) {
        s.r(v), s.d(v, { changeChatThreadName: function() {
          return _;
        }, createChatThread: function() {
          return C;
        }, destroyChatThread: function() {
          return w;
        }, getChatThreadDetail: function() {
          return F;
        }, getChatThreadLastMessage: function() {
          return B;
        }, getChatThreadMembers: function() {
          return I;
        }, getChatThreads: function() {
          return S;
        }, getJoinedChatThreads: function() {
          return H;
        }, joinChatThread: function() {
          return O;
        }, leaveChatThread: function() {
          return N;
        }, removeChatThreadMember: function() {
          return k;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(8309), s(2222), s(9554), s(4747), s(9753);
        var c = s(5531), d = s(7252), p = s(4024), m = s(3246), E = s(4363), y = function(j, G, U, M) {
          return new (U || (U = Promise))(function(V, J) {
            function ue(de) {
              try {
                ee(M.next(de));
              } catch (he) {
                J(he);
              }
            }
            function se(de) {
              try {
                ee(M.throw(de));
              } catch (he) {
                J(he);
              }
            }
            function ee(de) {
              var he;
              de.done ? V(de.value) : (he = de.value, he instanceof U ? he : new U(function(pe) {
                pe(he);
              })).then(ue, se);
            }
            ee((M = M.apply(j, [])).next());
          });
        }, g = function(j, G) {
          var U, M, V, J, ue = { label: 0, sent: function() {
            if (1 & V[0]) throw V[1];
            return V[1];
          }, trys: [], ops: [] };
          return J = { next: se(0), throw: se(1), return: se(2) }, typeof Symbol == "function" && (J[Symbol.iterator] = function() {
            return this;
          }), J;
          function se(ee) {
            return function(de) {
              return function(he) {
                if (U) throw new TypeError("Generator is already executing.");
                for (; ue; ) try {
                  if (U = 1, M && (V = 2 & he[0] ? M.return : he[0] ? M.throw || ((V = M.return) && V.call(M), 0) : M.next) && !(V = V.call(M, he[1])).done) return V;
                  switch (M = 0, V && (he = [2 & he[0], V.value]), he[0]) {
                    case 0:
                    case 1:
                      V = he;
                      break;
                    case 4:
                      return ue.label++, { value: he[1], done: !1 };
                    case 5:
                      ue.label++, M = he[1], he = [0];
                      continue;
                    case 7:
                      he = ue.ops.pop(), ue.trys.pop();
                      continue;
                    default:
                      if (!((V = (V = ue.trys).length > 0 && V[V.length - 1]) || he[0] !== 6 && he[0] !== 2)) {
                        ue = 0;
                        continue;
                      }
                      if (he[0] === 3 && (!V || he[1] > V[0] && he[1] < V[3])) {
                        ue.label = he[1];
                        break;
                      }
                      if (he[0] === 6 && ue.label < V[1]) {
                        ue.label = V[1], V = he;
                        break;
                      }
                      if (V && ue.label < V[2]) {
                        ue.label = V[2], ue.ops.push(he);
                        break;
                      }
                      V[2] && ue.ops.pop(), ue.trys.pop();
                      continue;
                  }
                  he = G.call(j, ue);
                } catch (pe) {
                  he = [6, pe], M = 0;
                } finally {
                  U = V = 0;
                }
                if (5 & he[0]) throw he[1];
                return { value: he[0] ? he[1] : void 0, done: !0 };
              }([ee, de]);
            };
          }
        };
        function C(j) {
          if (typeof j.name != "string" || j.name === "") throw Error("Invalid parameter name: ".concat(j.name));
          if (typeof j.messageId != "string" || j.messageId === "") throw Error("Invalid parameter messageId: ".concat(j.messageId));
          if (typeof j.parentId != "string" || j.parentId === "") throw Error("Invalid parameter parentId: ".concat(j.parentId));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = U.jid, se = { name: j.name, msg_id: j.messageId, group_id: j.parentId, owner: this.user }, ee = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread?resource=").concat(ue.clientResource), type: "POST", dataType: "json", data: JSON.stringify(se), headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, ee).then(function(de) {
            var he = de.data.thread_id;
            return de.data = { chatThreadId: he }, de;
          });
        }
        function O(j) {
          if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = U.jid, se = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId, "/user/").concat(this.user, "/join?resource=").concat(ue.clientResource), type: "POST", dataType: "json", headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, se).then(function(ee) {
            var de = ee.data.detail;
            return de.messageId = de.msgId, de.parentId = de.groupId, delete de.msgId, delete de.groupId, ee;
          });
        }
        function N(j) {
          return y(this, void 0, void 0, function() {
            var G, U, M, V, J, ue, se;
            return g(this, function(ee) {
              switch (ee.label) {
                case 0:
                  if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
                  return m.XZ.call(this) ? (U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = U.jid, se = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId, "/user/").concat(this.user, "/quit?resource=").concat(ue.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } }, [4, p.hj.call(this, se)]) : (G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(G)]);
                case 1:
                  return ee.sent(), [2];
              }
            });
          });
        }
        function w(j) {
          return y(this, void 0, void 0, function() {
            var G, U, M, V, J, ue, se;
            return g(this, function(ee) {
              switch (ee.label) {
                case 0:
                  if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
                  return m.XZ.call(this) ? (U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = U.jid, se = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId, "?resource=").concat(ue.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } }, [4, p.hj.call(this, se)]) : (G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" }), [2, Promise.reject(G)]);
                case 1:
                  return ee.sent(), [2];
              }
            });
          });
        }
        function _(j) {
          if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
          if (typeof j.name != "string" || j.name === "") throw Error("Invalid parameter name: ".concat(j.name));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = U.jid, se = { name: j.name }, ee = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId, "?resource=").concat(ue.clientResource), type: "PUT", dataType: "json", data: JSON.stringify(se), headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, ee);
        }
        function I(j) {
          if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = { limit: j.pageSize || 20, cursor: j.cursor || "" }, se = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId, "/users"), type: "GET", dataType: "json", data: ue, headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, se);
        }
        function k(j) {
          if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
          if (typeof j.username != "string" || j.username === "") throw Error("Invalid parameter username: ".concat(j.username));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = U.jid, se = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId, "/users/").concat(j.username, "?resource=").concat(ue.clientResource), type: "DELETE", dataType: "json", headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, se);
        }
        function H(j) {
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = { limit: j.pageSize || 20, cursor: j.cursor || "" }, se = { url: j.parentId ? "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/threads/chatgroups/").concat(j.parentId, "/user/").concat(this.user) : "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/threads/user/").concat(this.user), type: "GET", dataType: "json", data: ue, headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, se).then(function(ee) {
            var de = ee.entities;
            return de == null || de.forEach(function(he) {
              he.parentId = he.groupId, he.messageId = he.msgId, delete he.groupId, delete he.msgId;
            }), ee;
          });
        }
        function S(j) {
          if (typeof j.parentId != "string" || j.parentId === "") throw Error("Invalid parameter parentId: ".concat(j.parentId));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = { cursor: j.cursor || "", limit: j.pageSize || 20 }, se = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/threads/chatgroups/").concat(j.parentId), type: "GET", dataType: "json", data: ue, headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, se).then(function(ee) {
            var de = ee.entities;
            return de == null || de.forEach(function(he) {
              he.parentId = he.groupId, he.messageId = he.msgId, delete he.groupId, delete he.msgId;
            }), ee;
          });
        }
        function B(j) {
          var G = this;
          if (!Array.isArray(j.chatThreadIds)) throw Error("Invalid parameter chatThreadIds: ".concat(j.chatThreadIds));
          if (!m.XZ.call(this)) {
            var U = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(U);
          }
          var M = this.context, V = M.orgName, J = M.appName, ue = M.accessToken, se = { threadIds: j.chatThreadIds }, ee = { url: "".concat(this.apiUrl, "/").concat(V, "/").concat(J, "/thread/message"), type: "POST", dataType: "json", data: JSON.stringify(se), headers: { Authorization: "Bearer " + ue, "Content-Type": "application/json" } };
          return p.hj.call(this, ee).then(function(de) {
            return D.call(G, de);
          });
        }
        function D(j) {
          var G = this, U = j.entities;
          return U == null || U.forEach(function(M) {
            M.chatThreadId = M.thread_id, M.last_message && JSON.stringify(M.last_message) !== "{}" ? M.lastMessage = E.w.call(G, M.last_message) : M.lastMessage = M.last_message, delete M.thread_id, delete M.last_message;
          }), j;
        }
        function F(j) {
          if (typeof j.chatThreadId != "string" || j.chatThreadId === "") throw Error("Invalid parameter chatThreadId: ".concat(j.chatThreadId));
          if (!m.XZ.call(this)) {
            var G = d.Z.create({ type: c.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(G);
          }
          var U = this.context, M = U.orgName, V = U.appName, J = U.accessToken, ue = { url: "".concat(this.apiUrl, "/").concat(M, "/").concat(V, "/thread/").concat(j.chatThreadId), type: "GET", dataType: "json", headers: { Authorization: "Bearer " + J, "Content-Type": "application/json" } };
          return p.hj.call(this, ue).then(function(se) {
            return se.data.affiliationsCount = se.data.affiliations_count, se.data.messageId = se.data.msgId, se.data.parentId = se.data.groupId, delete se.data.affiliations_count, delete se.data.msgId, delete se.data.groupId, se;
          });
        }
      }, 70: function(l, v, s) {
        s.r(v), s.d(v, { getSupportedLanguages: function() {
          return y;
        }, translateMessage: function() {
          return g;
        } }), s(1539), s(8674), s(2222), s(9753);
        var c = s(3246), d = s(5531), p = s(7252), m = s(7360), E = s(4024);
        function y() {
          if (!c.XZ.call(this)) {
            var C = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(C);
          }
          var O = this.context, N = O.orgName, w = O.appName, _ = O.accessToken, I = { url: "".concat(this.apiUrl, "/").concat(N, "/").concat(w, "/users/").concat(this.user, "/translate/support/language"), dataType: "json", type: "GET", headers: { Authorization: "Bearer " + _ } };
          return m.kg.debug("Call getSupportedLanguages"), E.hj.call(this, I);
        }
        function g(C) {
          if (typeof C.text != "string" || C.text === "") throw Error('Invalid parameter: "text"');
          if (!Array.isArray(C.languages)) throw Error('Invalid parameter: "language"');
          if (!c.XZ.call(this)) {
            var O = p.Z.create({ type: d.E.REST_PARAMS_STATUS, message: "appkey or token error" });
            return Promise.reject(O);
          }
          var N = this.context, w = N.orgName, _ = N.appName, I = N.accessToken, k = "".concat(this.apiUrl, "/").concat(w, "/").concat(_, "/users/").concat(this.user, "/translate"), H = { text: C.text, to: C.languages }, S = { url: k, dataType: "json", type: "POST", data: JSON.stringify(H), headers: { Authorization: "Bearer " + I } };
          return m.kg.debug("Call translateMessage"), E.hj.call(this, S);
        }
      }, 3246: function(l, v, s) {
        s.d(v, { H7: function() {
          return C;
        }, XZ: function() {
          return y;
        }, _W: function() {
          return g;
        } }), s(7941), s(9554), s(1539), s(4747), s(6699), s(2023);
        var c = s(5531), d = s(7252), p = s(7360);
        function m() {
          var O = this.context.appName, N = this.context.orgName;
          return !(!O || !N) || (this.onError && this.onError({ type: c.E.WEBIM_CONNCTION_AUTH_ERROR, message: "appName or orgName is illegal" }), !1);
        }
        function E() {
          var O, N = this.context.accessToken;
          if (!N) {
            var w = d.Z.create({ type: c.E.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR, message: "token not assign error" });
            return p.kg.debug("token not assign error", N), this.onError && this.onError(w), (O = this.eventHandler) === null || O === void 0 || O.dispatch("onError", w), !1;
          }
          return !0;
        }
        function y() {
          return E.call(this) && m.call(this);
        }
        function g(O) {
          var N = O.data, w = O.type;
          return { data: { status: Object.keys(N.errorKeys).length > 0 ? "fail" : "success", errorKeys: N.errorKeys, successKeys: N.successKeys }, type: w };
        }
        function C(O) {
          var N = O.data, w = void 0;
          return Object.keys(N.errorKeys).length > 0 && Object.keys(N.errorKeys).forEach(function(_) {
            var I = N.errorKeys[_];
            w = I.includes("is not part of you") ? d.Z.create({ type: c.E.NO_PERMISSION, message: I }) : I.includes("size of metadata for this single chatroom exceeds the user defined limit") || I.includes("total size of chatroom metadata for this app exceeds the user defined limit") || I.includes("is exceeding maximum limit") ? d.Z.create({ type: c.E.MAX_LIMIT, message: I }) : I.includes("is not Legal") ? d.Z.create({ type: c.E.REQUEST_PARAMETER_ERROR, message: I }) : I.includes("Failed to update userMetadata. Concurrent updates not allowed") ? d.Z.create({ type: c.E.OPERATION_NOT_ALLOWED, message: I }) : d.Z.create({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: I });
          }), w;
        }
      }, 2071: function(l, v, s) {
        s.d(v, { $x: function() {
          return E;
        }, F3: function() {
          return y;
        }, TJ: function() {
          return d;
        }, Tp: function() {
          return O;
        }, Wc: function() {
          return c;
        }, el: function() {
          return p;
        }, iB: function() {
          return g;
        }, iO: function() {
          return m;
        }, yK: function() {
          return C;
        } }), s(6992), s(1532), s(1539), s(8783), s(3948);
        var c = 7, d = /* @__PURE__ */ new Map(), p = "im", m = /* @__PURE__ */ new Map(), E = "32f24ab2ddb74f508aa9286c356cec84", y = 1e3, g = { INIT: 9674, API: 9675 }, C = "direct", O = -1;
      }, 1595: function(l, v, s) {
        var c, d, p, m, E, y;
        s.d(v, { C8: function() {
          return c;
        }, aC: function() {
          return y;
        }, c: function() {
          return p;
        }, dd: function() {
          return E;
        }, fI: function() {
          return d;
        }, td: function() {
          return m;
        } }), function(g) {
          g[g.UNKNOWOPERATION = -1] = "UNKNOWOPERATION", g[g.REST_GET_SESSION_LIST = 1] = "REST_GET_SESSION_LIST", g[g.REST_DEL_SESSION = 2] = "REST_DEL_SESSION", g[g.REST_GET_HISTORY_MESSAGE = 3] = "REST_GET_HISTORY_MESSAGE", g[g.REST_PIN_CONVERSATION = 4] = "REST_PIN_CONVERSATION", g[g.REST_MARK_CONVERSATION = 5] = "REST_MARK_CONVERSATION", g[g.REST_UPLOAD_FILE_IN_PARTS = 6] = "REST_UPLOAD_FILE_IN_PARTS", g[g.REST_DELETE_MESSAGES_CONVERSATIONS = 7] = "REST_DELETE_MESSAGES_CONVERSATIONS", g[g.REST_PIN_MESSAGE = 8] = "REST_PIN_MESSAGE", g[g.REST_FETCH_PINMESSAGES = 9] = "REST_FETCH_PINMESSAGES", g[g.REST_OPERATE = 100] = "REST_OPERATE", g[g.MSYNC_SENDMESSAGE = 101] = "MSYNC_SENDMESSAGE", g[g.MSYNC_RECALLMESSAGE = 102] = "MSYNC_RECALLMESSAGE", g[g.MSYNC_MODIFYMESSAGE = 103] = "MSYNC_MODIFYMESSAGE", g[g.MSYNC_OPERATE = 200] = "MSYNC_OPERATE", g[g.ROSTER_ADD = 201] = "ROSTER_ADD", g[g.ROSTER_REMOVE = 202] = "ROSTER_REMOVE", g[g.ROSTER_ACCEPT = 203] = "ROSTER_ACCEPT", g[g.ROSTER_DECLINE = 204] = "ROSTER_DECLINE", g[g.ROSTER_BAN = 205] = "ROSTER_BAN", g[g.ROSTER_ALLOW = 206] = "ROSTER_ALLOW", g[g.ROSTER_BLACKLIST = 207] = "ROSTER_BLACKLIST", g[g.ROSTER_CONTACTS = 208] = "ROSTER_CONTACTS", g[g.ROSTER_GET_ALL_CONTACTS_REMARKS = 209] = "ROSTER_GET_ALL_CONTACTS_REMARKS", g[g.ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE = 210] = "ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE", g[g.ROSTER_SET_CONTACT_REMARK = 211] = "ROSTER_SET_CONTACT_REMARK", g[g.ROSTER_OPERATE = 300] = "ROSTER_OPERATE", g[g.USER_LOGIN = 301] = "USER_LOGIN", g[g.USER_CREATE = 302] = "USER_CREATE", g[g.USER_UPDATE_USERINFO = 303] = "USER_UPDATE_USERINFO", g[g.USER_FETCH_USERINFO = 304] = "USER_FETCH_USERINFO", g[g.USER_UPDATE_NICK = 305] = "USER_UPDATE_NICK", g[g.USER_UPLOAD_PUSH_TOKEN = 306] = "USER_UPLOAD_PUSH_TOKEN", g[g.USER_LOGGEDIN_OTHER_PLATFORM = 307] = "USER_LOGGEDIN_OTHER_PLATFORM", g[g.USER_OPERATE = 400] = "USER_OPERATE", g[g.GROUP_CREATEGROUP = 401] = "GROUP_CREATEGROUP", g[g.GROUP_BLOCK_MESSAGE = 402] = "GROUP_BLOCK_MESSAGE", g[g.GROUP_FETCH_PUBLICGROUPS_WITHCURSOR = 403] = "GROUP_FETCH_PUBLICGROUPS_WITHCURSOR", g[g.GROUP_FETCH_USERS_GROUP = 404] = "GROUP_FETCH_USERS_GROUP", g[g.GROUP_CHANGE_OWNER = 405] = "GROUP_CHANGE_OWNER", g[g.GROUP_FETCH_SPECIFICATION = 406] = "GROUP_FETCH_SPECIFICATION", g[g.GROUP_CHANGE_GROUPATTRIBUTE = 407] = "GROUP_CHANGE_GROUPATTRIBUTE", g[g.GROUP_FETCH_MEMEBERS = 408] = "GROUP_FETCH_MEMEBERS", g[g.GROUP_GET_ADMIN = 409] = "GROUP_GET_ADMIN", g[g.GROUP_SET_ADMIN = 410] = "GROUP_SET_ADMIN", g[g.GROUP_REMOVE_ADMIN = 411] = "GROUP_REMOVE_ADMIN", g[g.GROUP_DESTOTYGROUP = 412] = "GROUP_DESTOTYGROUP", g[g.GROUP_LEAVEGROUP = 413] = "GROUP_LEAVEGROUP", g[g.GROUP_INVITE_TO_GROUP = 414] = "GROUP_INVITE_TO_GROUP", g[g.GROUP_JOIN_PUBLICGROUP = 415] = "GROUP_JOIN_PUBLICGROUP", g[g.GROUP_ACCEPT_JOINPUBLICGROUPAPPL = 416] = "GROUP_ACCEPT_JOINPUBLICGROUPAPPL", g[g.GROUP_DECLINE_JOINPUBLICGROUPAPPL = 417] = "GROUP_DECLINE_JOINPUBLICGROUPAPPL", g[g.GROUP_ACCEPT_INVITATION = 418] = "GROUP_ACCEPT_INVITATION", g[g.GROUP_DECLINE_INVITATION = 419] = "GROUP_DECLINE_INVITATION", g[g.GROUP_REMOVE_MEMBER = 420] = "GROUP_REMOVE_MEMBER", g[g.GROUP_REMOVE_MEMBERS = 421] = "GROUP_REMOVE_MEMBERS", g[g.GROUP_MUTE_MEMBERS = 422] = "GROUP_MUTE_MEMBERS", g[g.GROUP_UNMUTE_MEMBERS = 423] = "GROUP_UNMUTE_MEMBERS", g[g.GROUP_FETCH_MUTES = 424] = "GROUP_FETCH_MUTES", g[g.GROUP_BLOCK_MEMBER = 425] = "GROUP_BLOCK_MEMBER", g[g.GROUP_BLOCK_MEMBERS = 426] = "GROUP_BLOCK_MEMBERS", g[g.GROUP_UNBLOCK_MEMBER = 427] = "GROUP_UNBLOCK_MEMBER", g[g.GROUP_UNBLOCK_MEMBERS = 428] = "GROUP_UNBLOCK_MEMBERS", g[g.GROUP_GET_BLOCK_LIST = 429] = "GROUP_GET_BLOCK_LIST", g[g.GROUP_MUTE_ALLMEMBERS = 430] = "GROUP_MUTE_ALLMEMBERS", g[g.GROUP_UNMUTE_ALLMEMBERS = 431] = "GROUP_UNMUTE_ALLMEMBERS", g[g.GROUP_ADD_WHITELIST = 432] = "GROUP_ADD_WHITELIST", g[g.GROUP_REMOVE_WHITELIST = 433] = "GROUP_REMOVE_WHITELIST", g[g.GROUP_FETCH_WHITELIST = 434] = "GROUP_FETCH_WHITELIST", g[g.GROUP_IS_IN_WHITELIST = 435] = "GROUP_IS_IN_WHITELIST", g[g.GROUP_GET_READ_USERS = 436] = "GROUP_GET_READ_USERS", g[g.GROUP_FETCH_ANNOUNCEMENT = 437] = "GROUP_FETCH_ANNOUNCEMENT", g[g.GROUP_UPDATE_ANNOUNCEMENT = 438] = "GROUP_UPDATE_ANNOUNCEMENT", g[g.GROUP_UPLOAD_SHAREDFILE = 439] = "GROUP_UPLOAD_SHAREDFILE", g[g.GROUP_DELETE_SHAREDFILE = 440] = "GROUP_DELETE_SHAREDFILE", g[g.GROUP_FETCH_SHAREDFILE = 441] = "GROUP_FETCH_SHAREDFILE", g[g.GROUP_DOWNLOAD_SHAREDFILE = 442] = "GROUP_DOWNLOAD_SHAREDFILE", g[g.GROUP_MEMBER_SET_META_DATA = 443] = "GROUP_MEMBER_SET_META_DATA", g[g.GROUP_MEMBER_FETCH_META_DATA = 444] = "GROUP_MEMBER_FETCH_META_DATA", g[g.GROUP_OPERATE = 500] = "GROUP_OPERATE", g[g.CHATROOM_FETCH_CHATROOMSWITHPAGE = 501] = "CHATROOM_FETCH_CHATROOMSWITHPAGE", g[g.CHATROOM_CREATECHATROOM = 502] = "CHATROOM_CREATECHATROOM", g[g.CHATROOM_DESTORYCHATROOM = 503] = "CHATROOM_DESTORYCHATROOM", g[g.CHATROOM_FETCH_SPECIFICATION = 504] = "CHATROOM_FETCH_SPECIFICATION", g[g.CHATROOM_CHANGE_ATTRIBUTE = 505] = "CHATROOM_CHANGE_ATTRIBUTE", g[g.CHATROOM_REMOVE_MEMBER = 506] = "CHATROOM_REMOVE_MEMBER", g[g.CHATROOM_REMOVE_MEMBERS = 507] = "CHATROOM_REMOVE_MEMBERS", g[g.CHATROOM_ADD_MEMBERS = 508] = "CHATROOM_ADD_MEMBERS", g[g.CHATROOM_JOINCAHTROOM = 509] = "CHATROOM_JOINCAHTROOM", g[g.CHATROOM_LEAVECAHTROOM = 510] = "CHATROOM_LEAVECAHTROOM", g[g.CHATROOM_FETCH_MEMBERS = 511] = "CHATROOM_FETCH_MEMBERS", g[g.CHATROOM_GET_ADMIN = 512] = "CHATROOM_GET_ADMIN", g[g.CHATROOM_SET_ADMIN = 513] = "CHATROOM_SET_ADMIN", g[g.CHATROOM_REMOVE_ADMIN = 514] = "CHATROOM_REMOVE_ADMIN", g[g.CHATROOM_MUTE_USER = 515] = "CHATROOM_MUTE_USER", g[g.CHATROOM_UNMUTE_USER = 516] = "CHATROOM_UNMUTE_USER", g[g.CHATROOM_FETCH_MUTES = 517] = "CHATROOM_FETCH_MUTES", g[g.CHATROOM_BLOCK_USER = 518] = "CHATROOM_BLOCK_USER", g[g.CHATROOM_BLOCK_USERS = 519] = "CHATROOM_BLOCK_USERS", g[g.CHATROOM_UNBLOCK_USER = 520] = "CHATROOM_UNBLOCK_USER", g[g.CHATROOM_UNBLOCK_USERS = 521] = "CHATROOM_UNBLOCK_USERS", g[g.CHATROOM_FETCH_BANS = 522] = "CHATROOM_FETCH_BANS", g[g.CHATROOM_MUTE_ALLMEMEBERS = 523] = "CHATROOM_MUTE_ALLMEMEBERS", g[g.CHATROOM_UNMUTE_ALLMEMEBERS = 524] = "CHATROOM_UNMUTE_ALLMEMEBERS", g[g.CHATROOM_ADD_WHITELIST = 525] = "CHATROOM_ADD_WHITELIST", g[g.CHATROOM_REMOVE_WHITELIST = 526] = "CHATROOM_REMOVE_WHITELIST", g[g.CHATROOM_FETCH_WHITELIST = 527] = "CHATROOM_FETCH_WHITELIST", g[g.CHATROOM_FETCH_MEMBERIN_WHITELIST = 528] = "CHATROOM_FETCH_MEMBERIN_WHITELIST", g[g.CHATROOM_FETCH_ANNOUNCEMENT = 529] = "CHATROOM_FETCH_ANNOUNCEMENT", g[g.CHATROOM_UPDATE_ANNOUNCEMENT = 530] = "CHATROOM_UPDATE_ANNOUNCEMENT", g[g.CHATROOM_REMOVE_SHARE_FILE = 531] = "CHATROOM_REMOVE_SHARE_FILE", g[g.CHATROOM_GET_SHARE_FILE_LIST = 532] = "CHATROOM_GET_SHARE_FILE_LIST", g[g.CHATROOM_UPLOAD_FILE = 533] = "CHATROOM_UPLOAD_FILE", g[g.CHATROOM_SET_META_DATA = 534] = "CHATROOM_SET_META_DATA", g[g.CHATROOM_DELETE_META_DATA = 535] = "CHATROOM_DELETE_META_DATA", g[g.CHATROOM_FETCH_META_DATA = 536] = "CHATROOM_FETCH_META_DATA", g[g.CHATROOM_FETCH_USER_JOINED_CHATROOM = 537] = "CHATROOM_FETCH_USER_JOINED_CHATROOM", g[g.CHATROOM_OPERATE = 600] = "CHATROOM_OPERATE";
        }(c || (c = {})), function(g) {
          g.SDK_INTERNAL = "SDK_INTERNAL", g.LOGIN = "USER_LOGIN", g.REGISTER = "USER_CREATE", g.GET_CHATROOM_LIST = "CHATROOM_FETCH_CHATROOMSWITHPAGE", g.CREATE_CHATROOM = "CHATROOM_CREATECHATROOM", g.DESTROY_CHATROOM = "CHATROOM_DESTORYCHATROOM", g.GET_CHATROOM_DETAIL = "CHATROOM_FETCH_SPECIFICATION", g.MODIFY_CHATROOM = "CHATROOM_CHANGE_ATTRIBUTE", g.REMOVE_CHATROOM_MEMBER = "CHATROOM_REMOVE_MEMBER", g.MULTI_REMOVE_CHATROOM_MEMBER = "CHATROOM_REMOVE_MEMBERS", g.ADD_USERS_TO_CHATROOM = "CHATROOM_ADD_MEMBERS", g.JOIN_CHATROOM = "CHATROOM_JOINCAHTROOM", g.QUIT_CHATROOM = "CHATROOM_LEAVECAHTROOM", g.LIST_CHATROOM_MEMBERS = "CHATROOM_FETCH_MEMBERS", g.GET_CHATROOM_ADMIN = "CHATROOM_GET_ADMIN", g.SET_CHATROOM_ADMIN = "CHATROOM_SET_ADMIN", g.REMOVE_CHATROOM_ADMIN = "CHATROOM_REMOVE_ADMIN", g.MUTE_CHATROOM_MEMBER = "CHATROOM_MUTE_USER", g.REMOVE_MUTE_CHATROOM_MEMBER = "CHATROOM_UNMUTE_USER", g.GET_MUTE_CHATROOM_MEMBERS = "CHATROOM_FETCH_MUTES", g.SET_CHATROOM_MEMBER_TO_BLACK = "CHATROOM_BLOCK_USER", g.MULTI_SET_CHATROOM_MEMBER_TO_BLACK = "CHATROOM_BLOCK_USERS", g.REMOVE_CHATROOM_MEMBER_BLACK = "CHATROOM_UNBLOCK_USER", g.MULTI_REMOVE_CHATROOM_MEMBER_BLACK = "CHATROOM_UNBLOCK_USERS", g.GET_CHATROOM_BLOCK_MEMBERS = "CHATROOM_FETCH_BANS", g.DISABLED_CHATROOM_SEND_MSG = "CHATROOM_MUTE_ALLMEMEBERS", g.ENABLE_CHATROOM_SEND_MSG = "CHATROOM_UNMUTE_ALLMEMEBERS", g.ADD_CHATROOM_WHITE_USERS = "CHATROOM_ADD_WHITELIST", g.REMOVE_CHATROOM_WHITE_USERS = "CHATROOM_REMOVE_WHITELIST", g.GET_CHATROOM_WHITE_USERS = "CHATROOM_FETCH_WHITELIST", g.CHECK_CHATROOM_WHITE_USER = "CHATROOM_FETCH_MEMBERIN_WHITELIST", g.GET_CHATROOM_ANN = "CHATROOM_FETCH_ANNOUNCEMENT", g.UPDATE_CHATROOM_ANN = "CHATROOM_UPDATE_ANNOUNCEMENT", g.DELETE_CHATROOM_FILE = "CHATROOM_REMOVE_SHARE_FILE", g.GET_CHATROOM_FILES = "CHATROOM_GET_SHARE_FILE_LIST", g.UPLOAD_CHATROOM_FILE = "CHATROOM_UPLOAD_FILE", g.SET_CHATROOM_ATTR = "CHATROOM_SET_META_DATA", g.DELETE_CHATROOM_ATTR = "CHATROOM_DELETE_META_DATA", g.GET_CHATROOM_ATTR = "CHATROOM_FETCH_META_DATA", g.GET_USER_JOINED_CHATROOM = "CHATROOM_FETCH_USER_JOINED_CHATROOM", g.CREATE_GROUP = "GROUP_CREATEGROUP", g.BLOCK_GROUP = "GROUP_BLOCK_MESSAGE", g.LIST_GROUP = "GROUP_FETCH_PUBLICGROUPS_WITHCURSOR", g.GET_USER_GROUP = "GROUP_FETCH_USERS_GROUP", g.CHANGE_OWNER = "GROUP_CHANGE_OWNER", g.GET_GROUP_INFO = "GROUP_FETCH_SPECIFICATION", g.MODIFY_GROUP = "GROUP_CHANGE_GROUPATTRIBUTE", g.LIST_GROUP_MEMBER = "GROUP_FETCH_MEMEBERS", g.GET_GROUP_ADMIN = "GROUP_GET_ADMIN", g.SET_GROUP_ADMIN = "GROUP_SET_ADMIN", g.REMOVE_GROUP_ADMIN = "GROUP_REMOVE_ADMIN", g.DISSOLVE_GROUP = "GROUP_DESTOTYGROUP", g.QUIT_GROUP = "GROUP_LEAVEGROUP", g.INVITE_TO_GROUP = "GROUP_INVITE_TO_GROUP", g.JOIN_GROUP = "GROUP_JOIN_PUBLICGROUP", g.AGREE_JOIN_GROUP = "GROUP_ACCEPT_JOINPUBLICGROUPAPPL", g.REJECT_JOIN_GROUP = "GROUP_DECLINE_JOINPUBLICGROUPAPPL", g.AGREE_INVITE_GROUP = "GROUP_ACCEPT_INVITATION", g.REJECT_INVITE_GROUP = "GROUP_DECLINE_INVITATION", g.REMOVE_GROUP_MEMBER = "GROUP_REMOVE_MEMBER", g.MULTI_REMOVE_GROUP_MEMBER = "GROUP_REMOVE_MEMBERS", g.MUTE_GROUP_MEMBER = "GROUP_MUTE_MEMBERS", g.UNMUTE_GROUP_MEMBER = "GROUP_UNMUTE_MEMBERS", g.GET_GROUP_MUTE_LIST = "GROUP_FETCH_MUTES", g.BLOCK_GROUP_MEMBER = "GROUP_BLOCK_MEMBER", g.BLOCK_GROUP_MEMBERS = "GROUP_BLOCK_MEMBERS", g.UNBLOCK_GROUP_MEMBER = "GROUP_UNBLOCK_MEMBER", g.UNBLOCK_GROUP_MEMBERS = "GROUP_UNBLOCK_MEMBERS", g.GET_GROUP_BLACK_LIST = "GROUP_GET_BLOCK_LIST", g.DISABLED_SEND_GROUP_MSG = "GROUP_MUTE_ALLMEMBERS", g.ENABLE_SEND_GROUP_MSG = "GROUP_UNMUTE_ALLMEMBERS", g.ADD_USERS_TO_GROUP_WHITE = "GROUP_ADD_WHITELIST", g.REMOVE_GROUP_WHITE_MEMBER = "GROUP_REMOVE_WHITELIST", g.GET_GROUP_WHITE_LIST = "GROUP_FETCH_WHITELIST", g.IS_IN_GROUP_WHITE_LIST = "GROUP_IS_IN_WHITELIST", g.GET_GROUP_MSG_READ_USER = "GROUP_GET_READ_USERS", g.GET_GROUP_ANN = "GROUP_FETCH_ANNOUNCEMENT", g.UPDATE_GROUP_ANN = "GROUP_UPDATE_ANNOUNCEMENT", g.UPLOAD_GROUP_FILE = "GROUP_UPLOAD_SHAREDFILE", g.DELETE_GROUP_FILE = "GROUP_DELETE_SHAREDFILE", g.GET_GROUP_FILE_LIST = "GROUP_FETCH_SHAREDFILE", g.DOWN_GROUP_FILE = "GROUP_DOWNLOAD_SHAREDFILE", g.SET_GROUP_MEMBER_ATTRS = "GROUP_MEMBER_SET_META_DATA", g.GET_GROUP_MEMBER_ATTR = "GROUP_MEMBER_FETCH_META_DATA", g.GET_SESSION_LIST = "REST_GET_SESSION_LIST", g.DELETE_SESSION = "REST_DEL_SESSION", g.GET_HISTORY_MSG = "REST_GET_HISTORY_MESSAGE", g.PIN_CONVERSATION = "REST_PIN_CONVERSATION", g.REST_UPLOAD_FILE_IN_PARTS = "REST_UPLOAD_FILE_IN_PARTS", g.REST_DELETE_MESSAGES_CONVERSATIONS = "REST_DELETE_MESSAGES_CONVERSATIONS", g.MARK_CONVERSATION = "REST_MARK_CONVERSATION", g.REST_FETCH_PINMESSAGES = "REST_FETCH_PINMESSAGES", g.REST_PIN_MESSAGE = "REST_PIN_MESSAGE", g.UPDATE_USER_INFO = "USER_UPDATE_USERINFO", g.GET_USER_INFO = "USER_FETCH_USERINFO", g.UPDATE_USER_NICK = "USER_UPDATE_NICK", g.UPLOAD_PUSH_TOKEN = "USER_UPLOAD_PUSH_TOKEN", g.USER_LOGGEDIN_OTHER_PLATFORM = "USER_LOGGEDIN_OTHER_PLATFORM", g.GET_BLACK_LIST = "ROSTER_BLACKLIST", g.GET_CONTACTS = "ROSTER_CONTACTS", g.ROSTER_GET_ALL_CONTACTS_REMARKS = "ROSTER_GET_ALL_CONTACTS_REMARKS", g.ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE = "ROSTER_GET_ALL_CONTACTS_REMARKS_FROM_SERVER_BY_PAGE", g.ROSTER_SET_CONTACT_REMARK = "ROSTER_SET_CONTACT_REMARK", g.ROSTER_ADD = "ROSTER_ADD", g.ROSTER_REMOVE = "ROSTER_REMOVE", g.ROSTER_ACCEPT = "ROSTER_ACCEPT", g.ROSTER_DECLINE = "ROSTER_DECLINE", g.ROSTER_BAN = "ROSTER_BAN", g.ROSTER_ALLOW = "ROSTER_ALLOW", g.SEND_MSG = "MSYNC_SENDMESSAGE", g.UPLOAD_MSG_ATTACH = "UPLOAD_MSG_ATTACH", g.SEND_RECALL_MSG = "MSYNC_RECALLMESSAGE", g.MODIFY_MESSAGE = "MSYNC_MODIFYMESSAGE";
        }(d || (d = {})), function(g) {
          g.GET_DNS = "REST_DNSLIST", g.LOGIN_BY_AGORA_TOKEN = "LOGIN_BY_AGORA_TOKEN", g.LOGIN_BY_PWD = "LOGIN_BY_PWD", g.RESISTER = "REGISTER", g.REST_INIT_UPLOAD_TASK_IN_PARTS = "REST_INIT_UPLOAD_TASK_IN_PARTS", g.REST_UPLOAD_PART = "REST_UPLOAD_PART", g.REST_COMPLETE_UPLOAD_PART = "REST_COMPLETE_UPLOAD_PART", g.REST_ABORT_UPLOAD_PART = "REST_ABORT_UPLOAD_PART";
        }(p || (p = {})), function(g) {
          g[g["5G"] = 7] = "5G", g[g["4G"] = 7] = "4G", g[g["3G"] = 7] = "3G", g[g["2G"] = 7] = "2G", g[g["SLOW-2G"] = 7] = "SLOW-2G", g[g.WIFI = 2] = "WIFI", g[g.LAN = 1] = "LAN", g[g.DISCONNECTED = 0] = "DISCONNECTED", g[g.NONE = 0] = "NONE", g[g.UNKNOWN = -1] = "UNKNOWN", g[g["WEBIM UNABLE TO GET"] = -2] = "WEBIM UNABLE TO GET";
        }(m || (m = {})), function(g) {
          g[g.success = 200] = "success", g[g.failed = 500] = "failed", g[g.disconnect = -1] = "disconnect", g[g.notFound = 404] = "notFound", g[g.reachLimit = 429] = "reachLimit";
        }(E || (E = {})), function(g) {
          g[g.web = 0] = "web", g[g.native = 1] = "native";
        }(y || (y = {}));
      }, 6424: function(l, v, s) {
        s.d(v, { gA: function() {
          return _e;
        }, ZP: function() {
          return Ie;
        } }), s(9601), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(7042), s(2222), s(3710), s(7941), s(9714), s(3843), s(8309), s(2772), s(5212), s(7327), s(5827), s(9826), s(4553), s(561), s(9653), s(1038), s(2564), s(9575), s(2472), s(2990), s(8927), s(3105), s(5035), s(4345), s(7174), s(2846), s(4731), s(7209), s(6319), s(8867), s(7789), s(3739), s(9368), s(4483), s(2056), s(3462), s(678), s(7462), s(3824), s(5021), s(2974), s(5016), s(6699), s(2023), s(3161), s(4048), s(9753), s(9554), s(4747), s(285), s(1637), s(8145), s(1249), s(4812);
        var c = s(4188), d = s.n(c), p = s(3720), m = s.n(p), E = s(5531), y = s(8161), g = s(7360), C = ["public", "members_only", "allow_user_invites", "invite_need_confirm"], O = { name: "name", title: "name", description: "description", public: "public", members_only: "approval", allow_user_invites: "allowInvites", max_users: "maxUsers", invite_need_confirm: "inviteNeedConfirm", custom: "ext", last_modified: "lastModified" };
        function N(x, ae) {
          var Q, Z, ge, me, ve, ie, ye = this, Ye = this.context, ne = Ye.userId, Qe = Ye.jid, W = ae.from.name === ne && Qe.clientResource !== ae.from.clientResource;
          return ae.isThread ? (ge = { id: ae.mucId.name, name: ae.mucName, operation: "", parentId: ae.mucParentId.name, operator: ae.from.name, userName: ae.to.length ? ae.to[0].name : "" }, me = { chatThreadId: ae.mucId.name, chatThreadName: ae.mucName, operation: "", parentId: ae.mucParentId.name }) : (Z = { type: "", owner: ae.from.name, gid: ae.mucId.name, from: ae.from.name, fromJid: ae.from, to: ae.to.length ? ae.to[0].name : "", toJid: ae.to, chatroom: ae.isChatroom, status: ae.status }, ve = { operation: "", id: ae.mucId.name, from: ae.from.name }, ae.isChatroom && (!((Q = ae == null ? void 0 : ae.eventInfo) === null || Q === void 0) && Q.ext) && (ie = JSON.parse(ae.eventInfo.ext))), ({ 45: function() {
            var ce, fe, we;
            ve.operation = "memberAttributesUpdate";
            var Fe = JSON.parse((ce = ae == null ? void 0 : ae.eventInfo) === null || ce === void 0 ? void 0 : ce.ext) || {};
            ve.attributes = Fe.properties || {}, ve.userId = Fe.username || "", W ? (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onMultiDeviceEvent", ve) : (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onGroupEvent", ve);
          }, 44: function() {
            var ce;
            ve.operation = "removeChatRoomAttributes", ve.attributes = ie.result.successKeys, ie.result.successKeys.length > 0 && ((ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomEvent", ve));
          }, 43: function() {
            var ce;
            ve.operation = "updateChatRoomAttributes";
            var fe = {};
            ie.result.successKeys.forEach(function(we) {
              fe[we] = ie.properties[we];
            }), ve.attributes = fe, ie.result.successKeys.length > 0 && ((ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomEvent", ve));
          }, 42: function() {
          }, 41: function() {
          }, 40: function() {
          }, 39: function() {
          }, 38: function() {
            var ce;
            me.operation = "chatThreadNameUpdate", (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onMultiDeviceEvent", me);
          }, 37: function() {
            var ce;
            ge.operation = "userRemove", (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatThreadChange", ge);
          }, 36: function() {
            var ce;
            me.operation = "chatThreadLeave", (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onMultiDeviceEvent", me);
          }, 35: function() {
            var ce;
            me.operation = "chatThreadJoin", (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onMultiDeviceEvent", me);
          }, 34: function() {
            var ce;
            me.operation = "chatThreadDestroy", (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onMultiDeviceEvent", me);
          }, 33: function() {
            var ce;
            me.operation = "chatThreadCreate", (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onMultiDeviceEvent", me);
          }, 32: function() {
            var ce, fe, we, Fe;
            Z.type = ae.isChatroom ? "rmChatRoomMute" : "rmGroupMute", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "unmuteAllMembers", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 31: function() {
            var ce, fe, we, Fe;
            Z.type = ae.isChatroom ? "muteChatRoom" : "muteGroup", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "muteAllMembers", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 30: function() {
            var ce, fe, we, Fe;
            Z.type = ae.isChatroom ? "rmUserFromChatRoomWhiteList" : "rmUserFromGroupWhiteList", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "removeAllowlistMember", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 29: function() {
            var ce, fe, we, Fe;
            Z.type = ae.isChatroom ? "addUserToChatRoomWhiteList" : "addUserToGroupWhiteList", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "addUserToAllowlist", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 28: function() {
            var ce, fe, we, Fe;
            Z.type = "deleteFile", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "deleteFile", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 27: function() {
            var ce, fe, we, Fe;
            Z.type = "uploadFile", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "uploadFile", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 26: function() {
            var ce, fe, we, Fe;
            Z.type = "deleteAnnouncement", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "deleteAnnouncement", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 25: function() {
            var ce, fe, we, Fe;
            Z.type = "updateAnnouncement", Z.announcement = ae.reason, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "updateAnnouncement", ve.announcement = ae.reason, ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 24: function() {
            var ce, fe, we, Fe;
            Z.type = "removeMute", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "unmuteMember", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 23: function() {
            var ce, fe, we, Fe;
            Z.type = "addMute", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "muteMember", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 22: function() {
            var ce, fe, we, Fe;
            Z.type = "removeAdmin", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "removeAdmin", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 21: function() {
            var ce, fe, we, Fe;
            Z.type = "addAdmin", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "setAdmin", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 20: function() {
            var ce, fe, we, Fe;
            Z.type = "changeOwner", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "changeOwner", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 19: function() {
            var ce, fe, we, Fe;
            Z.type = "direct_joined", Z.groupName = ae.mucName, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "directJoined", ve.name = ae.mucName, ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 18: function() {
            var ce, fe, we, Fe;
            Z.type = ae.isChatroom ? "leaveChatRoom" : "leaveGroup", ye.onPresence && ye.onPresence(Z);
            var je = ae.mucMemberCount;
            je && (ve.memberCount = je), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "memberAbsence", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 17: function() {
            var ce, fe, we, Fe;
            ae.isChatroom && ae.ext && (ve.ext = ae.ext, Z.ext = ae.ext), Z.type = ae.isChatroom ? "memberJoinChatRoomSuccess" : "memberJoinPublicGroupSuccess", ye.onPresence && ye.onPresence(Z);
            var je = ae.mucMemberCount;
            ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "memberPresence", je && (ve.memberCount = je), ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 16: function() {
            var ce, fe;
            Z.type = "unblock", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z);
          }, 15: function() {
            var ce, fe;
            Z.type = "block", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z);
          }, 14: function() {
            var ce, fe, we, Fe, je, qe = ae.isChatroom;
            if (!qe) {
              var et = JSON.parse(((ce = ae == null ? void 0 : ae.eventInfo) === null || ce === void 0 ? void 0 : ce.ext) || "{}", function(bt, ot) {
                return bt === "last_modified" ? Number(ot) : C.includes(bt) ? ot === "true" || ot === !0 : ot;
              });
              ve.detail = Z.detail = {}, Object.keys(et).forEach(function(bt) {
                var ot = O[bt];
                if (ot) {
                  var Lt = et[bt];
                  ve.detail && (ve.detail[ot] = Lt), Z.detail && (Z.detail[ot] = Lt);
                }
              });
            }
            Z.type = "update", ye.onPresence && ye.onPresence(Z), qe ? (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onChatroomChange", Z) : (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onGroupChange", Z), ve.operation = "updateInfo", qe ? (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onChatroomEvent", ve) : (je = ye.eventHandler) === null || je === void 0 || je.dispatch("onGroupEvent", ve);
          }, 13: function() {
            var ce, fe, we, Fe;
            Z.type = "allow", Z.reason = ae.reason, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ae.reason && (ve.reason = ae.reason), ve.operation = "unblockMember", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 12: function() {
            var ce, fe;
            Z.type = "ban", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z);
          }, 11: function() {
            var ce, fe;
            Z.type = "getBlackList", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z);
          }, 10: function() {
            var ce, fe, we, Fe;
            Z.type = "removedFromGroup", Z.kicked = Z.to, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "removeMember", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 9: function() {
            var ce, fe, we, Fe;
            Z.type = "invite_decline", Z.kicked = Z.to, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "rejectInvite", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 8: function() {
            var ce, fe, we, Fe;
            Z.type = "invite_accept", Z.kicked = Z.to, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "acceptInvite", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 7: function() {
            var ce, fe, we, Fe;
            Z.type = "invite", Z.kicked = Z.to, Z.groupName = ae.mucName, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "inviteToJoin", ve.name = ae.mucName, ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 6: function() {
            var ce, fe, we, Fe;
            Z.type = "joinPublicGroupDeclined", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "joinPublicGroupDeclined", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (ve.userId = ae.to.length ? ae.to[0].name : "", (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve));
          }, 5: function() {
            var ce, fe, we, Fe;
            Z.type = "joinPublicGroupSuccess", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "acceptRequest", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 4: function() {
            var ce, fe, we, Fe;
            Z.type = "joinGroupNotifications", Z.reason = ae.reason, ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ae.reason && (ve.reason = ae.reason), ve.operation = "requestToJoin", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 3: function() {
            var ce, fe;
            Z.type = "leave", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z);
          }, 2: function() {
            var ce, fe;
            Z.type = "join", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z);
          }, 1: function() {
            var ce, fe, we, Fe;
            Z.type = "deleteGroupChat", ye.onPresence && ye.onPresence(Z), ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomChange", Z) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupChange", Z), ve.operation = "destroy", ae.isChatroom ? (we = ye.eventHandler) === null || we === void 0 || we.dispatch("onChatroomEvent", ve) : (Fe = ye.eventHandler) === null || Fe === void 0 || Fe.dispatch("onGroupEvent", ve);
          }, 0: function() {
            var ce, fe;
            ve.operation = "create", ae.isChatroom ? (ce = ye.eventHandler) === null || ce === void 0 || ce.dispatch("onChatroomEvent", ve) : (fe = ye.eventHandler) === null || fe === void 0 || fe.dispatch("onGroupEvent", ve);
          } }[x] || function() {
            console.error("No match operation ".concat(x));
          })();
        }
        var w = function(x) {
          var ae = this.root.lookup("easemob.pb.MUCBody").decode(x.payload), Q = ae.operation;
          g.kg.debug("onMucMessage", ae), N.call(this, Q, ae);
        }, _ = { handleRosterMsg: function(x) {
          var ae, Q, Z, ge, me, ve, ie = this.root.lookup("easemob.pb.RosterBody").decode(x.payload), ye = { type: "", to: ie.to[0].name, from: ie.from.name, status: ie.reason };
          switch (ie.operation) {
            case 2:
              ye.type = "subscribe", this.onContactInvited && this.onContactInvited(ye), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onContactInvited", ye);
              break;
            case 3:
              ye.type = "unsubscribed", this.onContactDeleted && this.onContactDeleted(ye), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onContactDeleted", ye);
              break;
            case 4:
              ye.type = "subscribed", this.onContactAdded && this.onContactAdded(ye), (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onContactAdded", ye);
              break;
            case 5:
              ye.type = "unsubscribed", this.onContactRefuse && this.onContactRefuse(ye), (ge = this.eventHandler) === null || ge === void 0 || ge.dispatch("onContactRefuse", ye);
              break;
            case 6:
            case 7:
              break;
            case 8:
              ye.type = "subscribed", this.onContactAgreed && this.onContactAgreed(ye), (me = this.eventHandler) === null || me === void 0 || me.dispatch("onContactAgreed", ye);
              break;
            case 9:
              ye.type = "unsubscribed", this.onContactRefuse && this.onContactRefuse(ye), (ve = this.eventHandler) === null || ve === void 0 || ve.dispatch("onContactRefuse", ye);
              break;
            default:
              g.kg.error("handleRosterMsg:", ie);
          }
          this.onPresence && ye.type && this.onPresence(ye);
        } }, I = s(7252), k = function(x) {
          var ae, Q, Z, ge, me, ve, ie = this.root.lookup("easemob.pb.StatisticsBody").decode(x.payload), ye = ie.operation, Ye = ie.reason;
          switch (ye) {
            case 0:
              this.onStatisticMessage && this.onStatisticMessage(ie), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onStatisticMessage", ie);
              break;
            case 1:
              ve = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_REMOVED, message: "user has been removed" }), this.disconnectedReason = ve, this.logOut = !0, this.onError && this.onError(ve), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onError", ve);
              break;
            case 2:
              ve = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE, message: "the user is already logged on another device" }), Ye && (ve.data = { loginInfoCustomExt: ie.reason }), this.disconnectedReason = ve, this.logOut = !0, this.onError && this.onError(ve), (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onError", ve);
              break;
            case 3:
              ve = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_KICKED_BY_CHANGE_PASSWORD, message: "the user was kicked by changing password" }), this.disconnectedReason = ve, this.logOut = !0, this.onError && this.onError(ve), (ge = this.eventHandler) === null || ge === void 0 || ge.dispatch("onError", ve);
              break;
            case 4:
              ve = I.Z.create({ type: E.E.WEBIM_CONNCTION_USER_KICKED_BY_OTHER_DEVICE, message: "the user was kicked by other device" }), this.disconnectedReason = ve, this.logOut = !0, this.onError && this.onError(ve), (me = this.eventHandler) === null || me === void 0 || me.dispatch("onError", ve);
              break;
            default:
              g.kg.error("handleStatisticsMsg:", ie);
          }
        }, H = (s(9720), s(4024)), S = s(4363), B = s(9937);
        function D(x) {
          var ae, Q = [], Z = [], ge = x.data;
          ge && ge.values && ge.values.forEach(function(me) {
            Object.entries(me.status).forEach(function(ve) {
              Z.push({ device: ve[0], status: Number(ve[1]) });
            }), Q.push({ userId: me.uid, lastTime: Number(me.last_time), expire: Number(me.expiry), ext: me.ext, statusDetails: Z });
          }), this.onPresenceStatusChange && this.onPresenceStatusChange(Q), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onPresenceStatusChange", Q);
        }
        function F(x) {
          var ae = this;
          x.data.forEach(function(Q) {
            var Z, ge = { from: Q.from, to: Q.to, chatType: Q.channel_type === "chat" ? "singleChat" : "groupChat", messageId: Q.messageId, reactions: Q.reactions, ts: Q.ts };
            (Z = ae.eventHandler) === null || Z === void 0 || Z.dispatch("onReactionChange", ge);
          });
        }
        function j(x) {
          var ae, Q, Z, ge;
          if (x.data) {
            var me = x.data, ve = { id: me.id || "", name: me.name || "", parentId: me.muc_parent_id || "", messageId: me.msg_parent_id || "", timestamp: me.timestamp || 0, operator: me.from || "", operation: "" };
            switch (me.operation) {
              case "create":
                ve.operation = "create", ve.createTimestamp = ve.timestamp, ve.messageCount = 0, (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onChatThreadChange", ve);
                break;
              case "update_msg":
                ve.operation = "update", ve.messageCount = me.message_count, me.last_message && JSON.stringify(me.last_message) !== "{}" ? ve.lastMessage = S.w.call(this, me.last_message) : JSON.stringify(me.last_message) === "{}" && (ve.lastMessage = {}), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onChatThreadChange", ve);
                break;
              case "update":
                ve.operation = "update", ve.messageCount = me.message_count, (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onChatThreadChange", ve);
                break;
              case "delete":
                ve.operation = "destroy", (ge = this.eventHandler) === null || ge === void 0 || ge.dispatch("onChatThreadChange", ve);
            }
          }
        }
        function G(x) {
          var ae, Q = x.data;
          if (Q.resource !== this.clientResource) {
            var Z = { operation: "deleteRoaming", conversationId: Q.to, chatType: Q.chatType === "chat" ? "singleChat" : "groupChat", resource: Q.resource };
            (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onMultiDeviceEvent", Z);
          }
        }
        function U(x) {
          var ae, Q, Z = x.data, ge = "";
          if (this.clientResource !== Z.res) {
            switch (Z.op) {
              case "del":
                ge = "deleteConversation";
                break;
              case "top":
                ge = "pinnedConversation";
                break;
              case "not_top":
                ge = "unpinnedConversation";
                break;
              case "mark":
                ge = "markConversation";
                break;
              case "mark_delete":
                ge = "unMarkConversation";
                break;
              case "pin":
                ge = "pin";
                break;
              case "pin_delete":
                ge = "unpin";
                break;
              default:
                return void g.kg.error("unexpected conversation op:", Z.op);
            }
            if (ge !== "pin" && ge !== "unpin") {
              var me = { operation: ge, conversationId: Z.id, conversationType: Z.type === "chat" ? "singleChat" : "groupChat", timestamp: Z.ts };
              me.operation !== "markConversation" && me.operation !== "unMarkConversation" || Z.ext && (me.conversationMark = B.Z[Z.ext]), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onMultiDeviceEvent", me);
            } else {
              var ve = Z.ext, ie = Z.from, ye = Z.id, Ye = Z.type, ne = Z.ts, Qe = { messageId: ve || "", conversationId: ie === this.user ? ye : ie, conversationType: S.U[Ye], operation: ge, operatorId: ie, time: ne };
              (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onMessagePinEvent", Qe);
            }
          }
        }
        function M(x) {
          var ae, Q = this;
          (ae = x.values) === null || ae === void 0 || ae.forEach(function(Z) {
            var ge, me, ve, ie, ye;
            if (Z.operator_resource !== Q.clientResource) if ("ignoreInterval" in Z.data) {
              var Ye = { operation: "setSilentModeForUser", resource: Z.operator_resource, data: Z.data };
              (ge = Q.eventHandler) === null || ge === void 0 || ge.dispatch("onMultiDeviceEvent", Ye);
            } else "group" in Z ? (Ye = { operation: Object.keys((me = Z.data) !== null && me !== void 0 ? me : {}).length === 0 ? "removeSilentModeForConversation" : "setSilentModeForConversation", resource: Z.operator_resource, conversationId: Z.group, type: "groupChat", data: Z.data }, (ve = Q.eventHandler) === null || ve === void 0 || ve.dispatch("onMultiDeviceEvent", Ye)) : (Ye = { operation: Object.keys((ie = Z.data) !== null && ie !== void 0 ? ie : {}).length === 0 ? "removeSilentModeForConversation" : "setSilentModeForConversation", resource: Z.operator_resource, conversationId: Z.user, type: "singleChat", data: Z.data }, (ye = Q.eventHandler) === null || ye === void 0 || ye.dispatch("onMultiDeviceEvent", Ye));
          });
        }
        var V = function(x) {
          var ae = H.P6.parseNotify(x.payload);
          switch (ae.type) {
            case "presence":
              D.call(this, ae);
              break;
            case "reaction":
              F.call(this, ae);
              break;
            case "thread":
              j.call(this, ae);
              break;
            case "roaming_delete":
              G.call(this, ae);
              break;
            case "conv":
              U.call(this, ae);
              break;
            case "user_notification_mute":
              M.call(this, ae);
              break;
            default:
              g.kg.error("unexpected notify type: ".concat(ae.type));
          }
        }, J = s(7288), ue = s(9743), se = 2, ee = s(4998), de = s(6801), he = s(2071), pe = s(1595);
        function Ce(x) {
          return Ce = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ae) {
            return typeof ae;
          } : function(ae) {
            return ae && typeof Symbol == "function" && ae.constructor === Symbol && ae !== Symbol.prototype ? "symbol" : typeof ae;
          }, Ce(x);
        }
        var _e, Le, Te, K = function() {
          return K = Object.assign || function(x) {
            for (var ae, Q = 1, Z = arguments.length; Q < Z; Q++) for (var ge in ae = arguments[Q]) Object.prototype.hasOwnProperty.call(ae, ge) && (x[ge] = ae[ge]);
            return x;
          }, K.apply(this, arguments);
        }, Oe = function(x, ae, Q, Z) {
          return new (Q || (Q = Promise))(function(ge, me) {
            function ve(Ye) {
              try {
                ye(Z.next(Ye));
              } catch (ne) {
                me(ne);
              }
            }
            function ie(Ye) {
              try {
                ye(Z.throw(Ye));
              } catch (ne) {
                me(ne);
              }
            }
            function ye(Ye) {
              var ne;
              Ye.done ? ge(Ye.value) : (ne = Ye.value, ne instanceof Q ? ne : new Q(function(Qe) {
                Qe(ne);
              })).then(ve, ie);
            }
            ye((Z = Z.apply(x, [])).next());
          });
        }, Pe = function(x, ae) {
          var Q, Z, ge, me, ve = { label: 0, sent: function() {
            if (1 & ge[0]) throw ge[1];
            return ge[1];
          }, trys: [], ops: [] };
          return me = { next: ie(0), throw: ie(1), return: ie(2) }, typeof Symbol == "function" && (me[Symbol.iterator] = function() {
            return this;
          }), me;
          function ie(ye) {
            return function(Ye) {
              return function(ne) {
                if (Q) throw new TypeError("Generator is already executing.");
                for (; ve; ) try {
                  if (Q = 1, Z && (ge = 2 & ne[0] ? Z.return : ne[0] ? Z.throw || ((ge = Z.return) && ge.call(Z), 0) : Z.next) && !(ge = ge.call(Z, ne[1])).done) return ge;
                  switch (Z = 0, ge && (ne = [2 & ne[0], ge.value]), ne[0]) {
                    case 0:
                    case 1:
                      ge = ne;
                      break;
                    case 4:
                      return ve.label++, { value: ne[1], done: !1 };
                    case 5:
                      ve.label++, Z = ne[1], ne = [0];
                      continue;
                    case 7:
                      ne = ve.ops.pop(), ve.trys.pop();
                      continue;
                    default:
                      if (!((ge = (ge = ve.trys).length > 0 && ge[ge.length - 1]) || ne[0] !== 6 && ne[0] !== 2)) {
                        ve = 0;
                        continue;
                      }
                      if (ne[0] === 3 && (!ge || ne[1] > ge[0] && ne[1] < ge[3])) {
                        ve.label = ne[1];
                        break;
                      }
                      if (ne[0] === 6 && ve.label < ge[1]) {
                        ve.label = ge[1], ge = ne;
                        break;
                      }
                      if (ge && ve.label < ge[2]) {
                        ve.label = ge[2], ve.ops.push(ne);
                        break;
                      }
                      ge[2] && ve.ops.pop(), ve.trys.pop();
                      continue;
                  }
                  ne = ae.call(x, ve);
                } catch (Qe) {
                  ne = [6, Qe], Z = 0;
                } finally {
                  Q = ge = 0;
                }
                if (5 & ne[0]) throw ne[1];
                return { value: ne[0] ? ne[1] : void 0, done: !0 };
              }([ye, Ye]);
            };
          }
        }, xe = function(x, ae, Q) {
          for (var Z, ge = 0, me = ae.length; ge < me; ge++) !Z && ge in ae || (Z || (Z = Array.prototype.slice.call(ae, 0, ge)), Z[ge] = ae[ge]);
          return x.concat(Z || Array.prototype.slice.call(ae));
        };
        (function(x) {
          x[x.NORMAL = 0] = "NORMAL", x[x.SINGLECHAT = 1] = "SINGLECHAT", x[x.GROUPCHAT = 2] = "GROUPCHAT", x[x.CHATROOM = 3] = "CHATROOM", x[x.READ_ACK = 4] = "READ_ACK", x[x.DELIVER_ACK = 5] = "DELIVER_ACK", x[x.RECALL = 6] = "RECALL", x[x.CHANNEL_ACK = 7] = "CHANNEL_ACK", x[x.EDIT = 8] = "EDIT";
        })(_e || (_e = {})), function(x) {
          x[x.APNs = 0] = "APNs", x[x.FCM = 1] = "FCM", x[x.HMSPUSH = 2] = "HMSPUSH", x[x.MIPUSH = 3] = "MIPUSH", x[x.MEIZUPUSH = 4] = "MEIZUPUSH", x[x.VIVOPUSH = 5] = "VIVOPUSH", x[x.OPPOPUSH = 6] = "OPPOPUSH", x[x.HONORPUSH = 7] = "HONORPUSH";
        }(Le || (Le = {})), function(x) {
          x[x.OK = 0] = "OK", x[x.FAIL = 1] = "FAIL", x[x.UNAUTHORIZED = 2] = "UNAUTHORIZED", x[x.MISSING_PARAMETER = 3] = "MISSING_PARAMETER", x[x.WRONG_PARAMETER = 4] = "WRONG_PARAMETER", x[x.REDIRECT = 5] = "REDIRECT", x[x.TOKEN_EXPIRED = 6] = "TOKEN_EXPIRED", x[x.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", x[x.NO_ROUTE = 8] = "NO_ROUTE", x[x.UNKNOWN_COMMAND = 9] = "UNKNOWN_COMMAND", x[x.PB_PARSER_ERROR = 10] = "PB_PARSER_ERROR", x[x.BIND_ANOTHER_DEVICE = 11] = "BIND_ANOTHER_DEVICE", x[x.IM_FORBIDDEN = 12] = "IM_FORBIDDEN", x[x.TOO_MANY_DEVICES = 13] = "TOO_MANY_DEVICES", x[x.PLATFORM_LIMIT = 14] = "PLATFORM_LIMIT", x[x.USER_MUTED = 15] = "USER_MUTED", x[x.ENCRYPT_DISABLE = 16] = "ENCRYPT_DISABLE", x[x.ENCRYPT_ENABLE = 17] = "ENCRYPT_ENABLE", x[x.DECRYPT_FAILURE = 18] = "DECRYPT_FAILURE", x[x.PERMISSION_DENIED_EXTERNAL = 19] = "PERMISSION_DENIED_EXTERNAL";
        }(Te || (Te = {}));
        var be = ["txt", "img", "video", "audio", "file", "loc", "custom", "cmd", "combine"], $e = H.P6.getEnvInfo();
        function Be() {
          var x = "webim", ae = "", Q = "", Z = [], ge = (/* @__PURE__ */ new Date()).valueOf(), me = H.P6.getDevicePlatform($e);
          if (this.isFixedDeviceId) {
            var ve = H.P6.getLocalDeviceInfo();
            if (ve) {
              var ie = JSON.parse(ve);
              x = ie.deviceId, ae = ie.deviceName, Q = ie.deviceUuid;
            } else this.deviceId === "webim" ? (Q = "".concat(me, "_").concat(ge.toString()), x = "".concat(this.deviceId, "_").concat(Q), ae = this.deviceId) : x = ae = Q = "webim_".concat(me, "_").concat(this.deviceId), H.P6.setLocalDeviceInfo(JSON.stringify({ deviceId: x, deviceName: ae, deviceUuid: Q }));
          } else this.deviceId === "webim" ? (Q = "random_".concat(me, "_").concat(ge.toString()), x = "".concat(this.deviceId, "_").concat(Q), ae = this.deviceId) : x = ae = Q = "webim_".concat(me, "_").concat(this.deviceId);
          this.context.jid && (this.context.jid.clientResource = x);
          var ye = this.root.lookup("easemob.pb.Provision"), Ye = ye.decode(Z);
          Ye.compressType = this.compressType, Ye.encryptType = this.encryptType, Ye.osType = this.osType, Ye.version = this.version, Ye.deviceName = ae, Ye.resource = x, Ye.deviceUuid = Q, Ye.authToken = '{"token":"$t$' + this.token + '"}', Ye.sessionId = Date.now().toString() + ":", this.loginInfoCustomExt && (Ye.reason = this.loginInfoCustomExt), g.kg.debug("provision info", { version: this.version, resource: x, isFixedDeviceId: this.isFixedDeviceId, loginInfoCustomExt: !!this.loginInfoCustomExt, token: !!this.token }), Ye.actionVersion = "v5.0", Ye = ye.encode(Ye).finish();
          var ne = this.root.lookup("easemob.pb.MSync"), Qe = ne.decode(Z);
          return Qe.version = this.version, Qe.guid = this.context.jid, Qe.auth = "$t$" + this.token, Qe.command = 3, Qe.deviceId = ae, Qe.serviceId = this.dataReport.getServiceId(), Qe.encryptType = this.encryptType, Qe.payload = Ye, ne.encode(Qe).finish();
        }
        function Ke(x, ae) {
          var Q = this, Z = H.P6.getEnvInfo();
          if (Z.platform === "web" || Z.platform === "zfb" || Z.platform === "dd") {
            for (var ge = "", me = 0; me < x.length; me++) ge += String.fromCharCode(x[me]);
            return ge = d().btoa(ge), Z.platform === "web" ? ge : { data: ge, isBuffer: !1, complete: function() {
            }, fail: function(ie) {
              ie.errMsg !== "sendSocketMessage:fail taskID not exist" && ie.errMsg !== "SocketTast.send:fail SocketTask.readyState is not OPEN" || (g.kg.debug("send message fail and reconnect"), Q.reconnecting || Q.reconnect()), ae && Q._msgHash && Q._msgHash[ae] && Q._msgHash[ae].fail({ id: ae });
            } };
          }
          var ve = x;
          return { data: ve.buffer.slice(ve.byteOffset, ve.byteOffset + ve.byteLength), fail: function(ie) {
            ie.errMsg !== "sendSocketMessage:fail taskID not exist" && ie.errMsg !== "SocketTast.send:fail SocketTask.readyState is not OPEN" || Q.reconnecting || Q.reconnect(), ae && Q._msgHash && Q._msgHash[ae] && Q._msgHash[ae].fail({ id: ae });
          } };
        }
        function Ze(x, ae) {
          var Q;
          return Oe(this, void 0, void 0, function() {
            var Z, ge, me, ve, ie, ye;
            return Pe(this, function(Ye) {
              switch (Ye.label) {
                case 0:
                  for (g.kg.debug("distributeMeta, metas length: ", x.length), Z = [], ge = function(ne) {
                    var Qe = x[ne], W = new (m())(Qe.id.low, Qe.id.high, Qe.id.unsigned).toString(), ce = Qe.from.name, fe = Qe.to ? Qe.to.name : "", we = !!Qe.to && Qe.to.domain.indexOf("conference") !== -1;
                    if (me._load_msg_cache.some(function(Fe) {
                      return Fe.msgId === W;
                    })) return "continue";
                    switch (me._load_msg_cache.length <= me.max_cache_length || me._load_msg_cache.shift(), me._load_msg_cache.push({ msgId: W, from: ce, to: fe, isGroup: we }), Qe.ns) {
                      case 0:
                        k.call(me, Qe);
                        break;
                      case 1:
                        Z.push(y.Z.call(me, Qe, ae, !1, !0, !0));
                        break;
                      case 2:
                        w.call(me, Qe);
                        break;
                      case 3:
                        _.handleRosterMsg.call(me, Qe);
                        break;
                      case 4:
                        me.registerConfrIQHandler && me.registerConfrIQHandler(Qe, ae, me);
                        break;
                      case 5:
                        V.call(me, Qe);
                        break;
                      default:
                        g.kg.error("distributeMeta", Qe);
                    }
                  }, me = this, ve = 0; ve < x.length; ve++) ge(ve);
                  return [4, Promise.all(Z)];
                case 1:
                  return ie = Ye.sent(), (ye = ie.filter(function(ne) {
                    return ne && ne.type !== "cmd";
                  })).length > 0 && ((Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onMessage", ye)), [2];
              }
            });
          });
        }
        function at(x, ae) {
          Ze.call(this, x, ae);
        }
        function pt(x) {
          var ae;
          this._offlineMessagePullState === ee.a.SYNC_INIT && (this._offlineMessagePullState = ee.a.SYNC_START, this._offlineMessagePullQueue = x.unread.reduce(function(Q, Z) {
            return Q.find(function(ge) {
              return ge.name === Z.queue.name;
            }) || Q.push(Z.queue), Q;
          }, []), (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onOfflineMessageSyncStart"));
        }
        function It(x) {
          var ae;
          if (this._offlineMessagePullState === ee.a.SYNC_START) {
            var Q = this._offlineMessagePullQueue.findIndex(function(Z) {
              return Z.name === x.queue.name;
            });
            Q > -1 && this._offlineMessagePullQueue.splice(Q, 1), this._offlineMessagePullQueue.length === 0 && (this._offlineMessagePullState = ee.a.SYNC_FINISH, (ae = this.eventHandler) === null || ae === void 0 || ae.dispatch("onOfflineMessageSyncFinish"));
          }
        }
        function Rt(x) {
          var ae = this.root.lookup("easemob.pb.CommUnreadDL");
          ae = ae.decode(x.payload);
          var Q = new (m())(ae.timestamp.low, ae.timestamp.high, ae.timestamp.unsigned).toString();
          if (this.expirationTime && this.compareTokenExpireTime(Number(Q), this.expirationTime), ae.unread.length === 0) ut.call(this);
          else {
            pt.call(this, ae), g.kg.debug("pull unread message", ae.unread);
            for (var Z = 0; Z < ae.unread.length; Z++) {
              var ge = ze(this._queues, ae.unread[Z].queue), me = ze(this.unSyncQueue, ae.unread[Z].queue);
              ge || me ? g.kg.warn("receive unread message and already in queue") : this.unSyncQueue.push(ae.unread[Z].queue);
            }
            for (Z = 0; Z < this.unSyncQueue.length; Z++) this.unSyncQueue[Z].hasSync || Tt.call(this, this.unSyncQueue[Z]), this.unSyncQueue[Z].hasSync = !0;
          }
          ut.call(this);
        }
        function gt() {
          var x = [], ae = this.root.lookup("easemob.pb.StatisticsBody"), Q = ae.decode(x);
          Q.operation = 0, Q = ae.encode(Q).finish();
          var Z = this.root.lookup("easemob.pb.Meta").decode(x);
          Z.id = (/* @__PURE__ */ new Date()).valueOf(), Z.ns = 0, Z.payload = Q;
          var ge = this.root.lookup("easemob.pb.CommSyncUL"), me = ge.decode(x);
          me.meta = Z, me = ge.encode(me).finish();
          var ve = this.root.lookup("easemob.pb.MSync"), ie = ve.decode(x);
          return ie.version = this.version, ie.encryptType = [0], ie.command = 0, ie.payload = me, ve.encode(ie).finish();
        }
        function it(x) {
          var ae = [], Q = this.root.lookup("easemob.pb.CommSyncUL"), Z = Q.decode(ae);
          Z.queue = x, Z = Q.encode(Z).finish();
          var ge = this.root.lookup("easemob.pb.MSync"), me = ge.decode(ae);
          return me.version = this.version, me.encryptType = this.encryptType, me.command = 0, me.payload = Z, ge.encode(me).finish();
        }
        function Tt(x) {
          g.kg.debug("sendBackqueue");
          var ae = it.call(this, x);
          Ct.call(this, ae);
        }
        function Ut(x, ae) {
          var Q = [], Z = this.root.lookup("easemob.pb.CommSyncUL"), ge = Z.decode(Q);
          ge.queue = ae, ge.key = new (m())(x.low, x.high, x.unsigned).toString(), ge = Z.encode(ge).finish();
          var me = this.root.lookup("easemob.pb.MSync"), ve = me.decode(Q);
          return ve.version = this.version, ve.encryptType = this.encryptType, ve.command = 0, ve.payload = ge, me.encode(ve).finish();
        }
        function st() {
          var x = this;
          this.uniPush && this.isRegisterPush === !1 && (this.isRegisterPush = !0, this.uniPush.onRegister(function(ae) {
            g.kg.debug("push token onRegister", ae);
            var Q = x.uniPushConfig || {}, Z = Q.APNsCertificateName, ge = Z === void 0 ? "" : Z, me = Q.HMSCertificateName, ve = me === void 0 ? "" : me, ie = Q.HONORCertificateName, ye = ie === void 0 ? "" : ie, Ye = Q.MEIZUCertificateName, ne = Ye === void 0 ? "" : Ye, Qe = Q.MICertificateName, W = Qe === void 0 ? "" : Qe, ce = Q.OPPOCertificateName, fe = ce === void 0 ? "" : ce, we = Q.VIVOCertificateName, Fe = we === void 0 ? "" : we;
            switch (ae.push_type) {
              case Le.APNs:
                x.pushCertificateName = ge;
                break;
              case Le.HMSPUSH:
                x.pushCertificateName = ve;
                break;
              case Le.HONORPUSH:
                x.pushCertificateName = ye;
                break;
              case Le.MEIZUPUSH:
                x.pushCertificateName = ne;
                break;
              case Le.MIPUSH:
                x.pushCertificateName = W;
                break;
              case Le.OPPOPUSH:
                x.pushCertificateName = fe;
                break;
              case Le.VIVOPUSH:
                x.pushCertificateName = Fe;
                break;
              default:
                g.kg.error("unexpected push type", ae.push_type);
            }
            x.pushCertificateName && ae.push_token && de.r.call(x, { deviceId: x.clientResource, deviceToken: ae.push_token, notifierName: x.pushCertificateName }).then(function() {
              g.kg.debug("uploadPushToken success");
            }).catch(function(je) {
              g.kg.debug("uploadPushToken failed", je);
            });
          }));
        }
        function Ot() {
          var x;
          this._offlineMessagePullState = ee.a.SYNC_INIT, this._offlineMessagePullQueue = [], this.times = 1, this.autoReconnectNumTotal = 0, this.onOpened && this.onOpened(), st.call(this), (x = this.eventHandler) === null || x === void 0 || x.dispatch("onConnected"), Et.call(this), Ft.call(this), St.call(this), ut.call(this);
        }
        function kt(x, ae) {
          g.kg.debug("sendLastSession", x);
          var Q = Ut.call(this, x, ae);
          Ct.call(this, Q);
        }
        function wt(x) {
          var ae, Q, Z, ge, me, ve, ie, ye = this, Ye = this.root.lookup("easemob.pb.Provision").decode(x.payload);
          if (this.context.jid && (this.context.jid.clientResource = Ye.resource), this.clientResource = Ye.resource, Ye.status.errorCode === Te.OK) {
            if (this.disconnectedReason = void 0, Ye.authToken) {
              var ne = JSON.parse(Ye.authToken).expires_in;
              if (!this.tokenExpiredTimer && !this.tokenWillExpireTimer) {
                var Qe = Date.now();
                this.expirationTime = ne;
                var W = this.expirationTime - Qe;
                this.expiresIn = W < 0 ? 0 : W, this.tokenExpireTimeCountDown(this.expiresIn);
              }
            }
            this.reconnecting = !1, this.logOut = !1, $e.platform !== "zfb" && $e.platform !== "dd" || (this.sock.readyState = 1), this._localCache ? !((ae = this._localCache) === null || ae === void 0) && ae.getInstance() ? Ot.call(this) : this._localCache && new this._localCache({ user: this.user, dbName: "cache_".concat(Math.abs((0, ue.un)(this.appKey)), "_").concat(this.user), version: se, onInit: function() {
              return Oe(ye, void 0, void 0, function() {
                return Pe(this, function(je) {
                  return g.kg.debug("localCache init success"), Ot.call(this), [2];
                });
              });
            } }) : Ot.call(this);
          } else {
            var ce = void 0, fe = Ye.status, we = fe.reason, Fe = fe.errorCode;
            switch (g.kg.debug("provision errorCode: ", Fe), g.kg.debug("provision reason: ", we), Fe) {
              case Te.FAIL:
                ce = we === "Sorry, user register limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the number of user registrations limit has been reached" }) : we === "Sorry, user register rate limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, user register rate limit" }) : we === "Sorry, token expired" ? I.Z.create({ type: E.E.WEBIM_TOKEN_EXPIRED, message: "Sorry, token expired" }) : we === "Sorry, token or password does not match login info" ? I.Z.create({ type: E.E.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR, message: "INVALID_TOKEN" }) : we === "Sorry, user not found" ? I.Z.create({ type: E.E.USER_NOT_FOUND, message: "User not found" }) : I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: "Auth failed" }), (Q = this.eventHandler) === null || Q === void 0 || Q.dispatch("onError", ce);
                break;
              case Te.WRONG_PARAMETER:
                ce = I.Z.create({ type: E.E.REQUEST_PARAMETER_ERROR, message: "Invalid parameter" }), (Z = this.eventHandler) === null || Z === void 0 || Z.dispatch("onError", ce);
                break;
              case Te.UNAUTHORIZED:
                ce = I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: "Auth failed" }), (ge = this.eventHandler) === null || ge === void 0 || ge.dispatch("onError", ce);
                break;
              case Te.IM_FORBIDDEN:
                ce = I.Z.create({ type: E.E.WEBIM_SERVER_SERVING_DISABLED, message: "Server serving disabled." }), (me = this.eventHandler) === null || me === void 0 || me.dispatch("onError", ce);
                break;
              case Te.PERMISSION_DENIED:
                ce = we === "Sorry, the app month live count limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the monthly active user limit for this app has been reached" }) : we === "Sorry, the app day live count limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the daily active user limit for this app has been reached" }) : we === "Sorry, the app online count limit" ? I.Z.create({ type: E.E.MAX_LIMIT, message: "Sorry, the maximum number limit of online users for this app has been reached" }) : I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: "Auth failed" }), (ve = this.eventHandler) === null || ve === void 0 || ve.dispatch("onError", ce);
                break;
              default:
                ce = I.Z.create({ type: E.E.WEBIM_CONNCTION_AUTH_ERROR, message: we }), (ie = this.eventHandler) === null || ie === void 0 || ie.dispatch("onError", ce);
            }
            this.disconnectedReason = ce;
          }
        }
        function Et() {
          var x, ae;
          if (((x = this.unMSyncSendMsgMap) === null || x === void 0 ? void 0 : x.size) > 0) {
            for (var Q = Array.from(this.unMSyncSendMsgMap.keys()), Z = 0; Z < Q.length; Z++) {
              var ge = this.unMSyncSendMsgMap.get(Q[Z]);
              Ct.call(this, ge, Q[Z]);
            }
            (ae = this.unMSyncSendMsgMap) === null || ae === void 0 || ae.clear();
          }
        }
        function ut() {
          var x = gt.call(this);
          Ct.call(this, x);
        }
        function St() {
          g.kg.debug("sendUnreadDeal");
          var x = zt.call(this);
          Ct.call(this, x);
        }
        function Ft() {
          var x = this;
          Ht.call(this), this.heartBeatID = setInterval(function() {
            (Date.now() - x.lastHeartbeat) / 1e3 >= 30 && (g.kg.debug("send heart beat"), St.call(x), x.lastHeartbeat = Date.now());
          }, this.heartBeatWait);
        }
        function Ht() {
          clearInterval(this.heartBeatID);
        }
        function zt() {
          var x = this.root.lookup("easemob.pb.MSync"), ae = x.decode([]);
          return ae.version = this.version, ae.encryptType = this.encryptType, ae.command = 1, x.encode(ae).finish();
        }
        function ze(x, ae) {
          return x.some(function(Q) {
            return Q.name === ae.name;
          });
        }
        function Ne(x) {
          var ae = this.root.lookup("easemob.pb.CommNotice"), Q = ae.decode(x.payload), Z = ze(this._queues, Q.queue);
          g.kg.debug("receive notice", ae, this._queues);
          var ge = ze(this.unSyncQueue, Q.queue);
          Z || ge || this.clientResource === Q.queue.clientResource && Q.queue.name === this.context.userId || (this._queues.push(Q.queue), this._queues.length === 1 && Tt.call(this, Q.queue));
        }
        function le(x) {
          return Oe(this, void 0, void 0, function() {
            var ae, Q, Z, ge, me, ve, ie, ye;
            return Pe(this, function(Ye) {
              if (ae = H.P6.getEnvInfo(), Q = this.root.lookup("easemob.pb.MSync"), this.name === "miniCore") {
                try {
                  ge = new Uint8Array(x.data), Z = Q.decode(ge);
                } catch {
                  throw new Error("decode message fail.");
                }
                return [2, Z];
              }
              if (ae.platform === "web" || ae.platform === "zfb" || ae.platform === "dd") {
                for (me = d().atob(x.data), ve = [], ie = 0, ye = me.length; ie < ye; ++ie) ve.push(me.charCodeAt(ie));
                return [2, Q.decode(ve)];
              }
              try {
                Z = Q.decode(x.data);
              } catch {
                throw new Error("decode message fail.");
              }
              return [2, Z];
            });
          });
        }
        function X(x) {
          var ae = this;
          this.lastHeartbeat = Date.now(), x.then(function(Q) {
            if (Q) switch (Q.command) {
              case 0:
                re.call(ae, Q);
                break;
              case 1:
                Rt.call(ae, Q);
                break;
              case 2:
                Ne.call(ae, Q);
                break;
              case 3:
                wt.call(ae, Q);
                break;
              default:
                g.kg.error("unexpected msync command: ".concat(Q.command));
            }
            else g.kg.error("unexpected msync result: ".concat(Q));
          });
        }
        function re(x) {
          var ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we, Fe, je, qe, et, bt, ot, Lt, Kt, $t, yt, Wt, In, gn, zn, Xn, yr, ur, Yn, xi, gs, Or, da, Za, js, Fs, la, Gs, ka, Vs, ja;
          return Oe(this, void 0, void 0, function() {
            var Xt, Wn, Mt, Nc, To, ou, Ku, cu, bo, Ju, Yo, Xo, Bd, zd, wc, Qa, Ql, $l, ef, Ua, tf, nf, Zu, Wo, Qu, rf, $u, qo, ba, Ts, Fd, Kr, uu, Ko, Zi, Hr, Di, os, Aa, Ao, Hi, Qi, Ha, ed = this;
            return Pe(this, function(Ei) {
              switch (Ei.label) {
                case 0:
                  if (Xt = (Xt = this.root.lookup("easemob.pb.CommSyncDL")).decode(x.payload), Wn = new (m())(Xt.serverId.low, Xt.serverId.high, Xt.serverId.unsigned).toString(), Mt = new (m())(Xt.metaId.low, Xt.metaId.high, Xt.metaId.unsigned).toString(), !(Number(Mt) > 0)) return [3, 23];
                  if (!Xt.status) return [3, 22];
                  if (Xt.status.errorCode !== 0) return [3, 21];
                  if ((Nc = this._msgHash[Mt]) != null && Nc.isHandleChatroom) {
                    try {
                      To = ((ae = this._msgHash[Mt]) === null || ae === void 0 ? void 0 : ae.operation) === "join", ((Q = this._msgHash[Mt]) === null || Q === void 0 ? void 0 : Q.resolve) instanceof Function && To && this._msgHash[Mt].resolve({ type: 0, data: { action: "apply", id: this._msgHash[Mt].roomId, result: !0, user: this.context.userId } }), ((Z = this._msgHash[Mt]) === null || Z === void 0 ? void 0 : Z.success) instanceof Function && To && this._msgHash[Mt].success({ type: 0, data: { action: "apply", id: this._msgHash[Mt].roomId, result: !0, user: this.context.userId } }), ((ge = this._msgHash[Mt]) === null || ge === void 0 ? void 0 : ge.resolve) instanceof Function && !To && this._msgHash[Mt].resolve({ type: 0, data: { result: !0 } }), ((me = this._msgHash[Mt]) === null || me === void 0 ? void 0 : me.success) instanceof Function && !To && this._msgHash[Mt].success({ type: 0, data: { result: !0 } }), he.iO.has(Mt) && (ou = he.iO.get(Mt), Zi = ou.rpt, Hr = ou.requestName, Zi({ isEndApi: !0, data: { isSuccess: 1, requestName: Hr, requestMethod: "WEBSOCKET", requestUrl: this.url, code: pe.dd.success } }), he.iO.delete(Mt));
                    } catch (cs) {
                      he.iO.has(Mt) && (Ku = he.iO.get(Mt), Zi = Ku.rpt, Hr = Ku.requestName, Zi({ isEndApi: !0, data: { isSuccess: 0, requestName: Hr, requestMethod: "WEBSOCKET", requestUrl: this.url, code: pe.dd.failed, codeDesc: "when executing success function error" } }), he.iO.delete(Mt)), os = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "when executing success function error", data: cs }), this.onError && this.onError(os), (ve = this.eventHandler) === null || ve === void 0 || ve.dispatch("onError", os);
                    }
                    delete this._msgHash[Mt];
                  }
                  return !Nc || Nc.isHandleChatroom ? [3, 20] : (cu = null, bo = "", Ju = 0, Yo = null, this._msgHash[Mt].thirdMessage ? (this._msgHash[Mt].thirdMessage.id = Xt.serverId, this._msgHash[Mt].thirdMessage.timestamp = Xt.timestamp, [4, y.Z.call(this, this._msgHash[Mt].thirdMessage, Xt.status, !0, !0)]) : [3, 2]);
                case 1:
                  Yo = Ei.sent(), Ei.label = 2;
                case 2:
                  if (Xt.metas.length === 0) return [3, 13];
                  Ei.label = 3;
                case 3:
                  switch (Ei.trys.push([3, 12, , 13]), Xo = Xt.metas[0], Bd = Xt.status, Xo.ns) {
                    case 1:
                      return [3, 4];
                    case 5:
                      return [3, 9];
                  }
                  return [3, 10];
                case 4:
                  return this.useReplacedMessageContents ? [4, y.Z.call(this, Xo, Bd, !0, !0)] : [3, 8];
                case 5:
                  return Yo = Ei.sent(), [4, (ye = (ie = this._localCache) === null || ie === void 0 ? void 0 : ie.getInstance()) === null || ye === void 0 ? void 0 : ye.getMessageByServerMsgId(Mt)];
                case 6:
                  return (zd = Ei.sent()) ? [4, (ne = (Ye = this._localCache) === null || Ye === void 0 ? void 0 : Ye.getInstance()) === null || ne === void 0 ? void 0 : ne.putMessageToDB(K(K(K({}, zd), Yo), { id: Mt }))] : [3, 8];
                case 7:
                  Ei.sent(), Ei.label = 8;
                case 8:
                  return [3, 11];
                case 9:
                  return (wc = H.P6.parseNotify(Xt.metas[0].payload)).edit_msg && (Qa = wc.edit_msg, Ql = Qa.count, $l = Qa.operator, ef = Qa.edit_time, Ua = Qa.sender, tf = Qa.send_time, cu = { operationTime: ef, operatorId: $l, operationCount: Ql }, bo = Ua, Ju = Number(tf)), [3, 11];
                case 10:
                  return g.kg.error("decode local meta error", Xo), [3, 11];
                case 11:
                  return [3, 13];
                case 12:
                  return nf = Ei.sent(), os = I.Z.create({ type: E.E.WEBIM_LOAD_MSG_ERROR, message: "decode local meta message error", data: nf }), this.onError && this.onError(os), (Qe = this.eventHandler) === null || Qe === void 0 || Qe.dispatch("onError", os), [3, 13];
                case 13:
                  he.TJ.has(Mt) && (he.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 1, requestMethod: "WEBSOCKET", requestUrl: this.url, code: pe.dd.success, msgId: Wn } }), he.TJ.delete(Mt)), Ei.label = 14;
                case 14:
                  return Ei.trys.push([14, 18, , 19]), Zu = { localMsgId: Mt, serverMsgId: Wn }, cu && (this._msgHash[Mt].modifiedInfo = cu, Wo = this._msgHash[Mt], Qu = Wo.editMessageId, Kr = Wo.type, rf = Wo.chatType, $u = Wo.msg, qo = Wo.to, ba = Wo.translations, Ts = { id: Qu, type: Kr, chatType: rf, msg: $u, modifiedInfo: cu, to: qo, from: bo, time: Number(Ju) }, ba && (Ts.translations = ba), Zu.message = Ts, (fe = (ce = (W = this._localCache) === null || W === void 0 ? void 0 : W.getInstance()) === null || ce === void 0 ? void 0 : ce.getMessageByServerMsgId(Qu)) === null || fe === void 0 || fe.then(function(cs) {
                    var ci, bs;
                    cs && cs.type === "txt" && ((bs = (ci = ed._localCache) === null || ci === void 0 ? void 0 : ci.getInstance()) === null || bs === void 0 || bs.putMessageToDB(K(K({}, cs), { msg: Ts.msg, modifiedInfo: Ts.modifiedInfo, translations: Ts.translations })));
                  })), Yo && (Zu.message = Yo), [4, (Fe = (we = this._localCache) === null || we === void 0 ? void 0 : we.getInstance()) === null || Fe === void 0 ? void 0 : Fe.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.SUCCESS })];
                case 15:
                  return Ei.sent(), ((je = this._msgHash[Mt]) === null || je === void 0 ? void 0 : je.success) instanceof Function ? [4, this._msgHash[Mt].success(Mt, Wn)] : [3, 17];
                case 16:
                  Ei.sent(), Ei.label = 17;
                case 17:
                  return ((qe = this._msgHash[Mt]) === null || qe === void 0 ? void 0 : qe.resolve) instanceof Function && this._msgHash[Mt].resolve(Zu), [3, 19];
                case 18:
                  return Fd = Ei.sent(), os = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "when executing success function error", data: Fd }), this.onError && this.onError(os), (et = this.eventHandler) === null || et === void 0 || et.dispatch("onError", os), [3, 19];
                case 19:
                  this.onReceivedMessage && this.onReceivedMessage({ id: Mt, mid: Wn, to: this._msgHash[Mt].to, time: 0 }), (bt = this.eventHandler) === null || bt === void 0 || bt.dispatch("onReceivedMessage", { id: Mt, mid: Wn, to: this._msgHash[Mt].to }), delete this._msgHash[Mt], Ei.label = 20;
                case 20:
                  return [3, 22];
                case 21:
                  if (Xt.status.errorCode === 15) ((ot = this._msgHash[Mt]) === null || ot === void 0 ? void 0 : ot.fail) instanceof Function && this._msgHash[Mt].fail({ type: E.E.SERVICE_NOT_ALLOW_MESSAGING_MUTE, reason: "you were muted" }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject({ type: E.E.SERVICE_NOT_ALLOW_MESSAGING_MUTE, reason: "you were muted" }), (Kt = (Lt = this._localCache) === null || Lt === void 0 ? void 0 : Lt.getInstance()) === null || Kt === void 0 || Kt.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL });
                  else if (Xt.status.errorCode === 1) {
                    switch (Kr = void 0, Xt.status.reason) {
                      case "blocked":
                        Kr = E.E.PERMISSION_DENIED;
                        break;
                      case "group not found":
                        Kr = E.E.GROUP_NOT_EXIST;
                        break;
                      case "not in group or chatroom":
                        Kr = E.E.GROUP_NOT_JOINED;
                        break;
                      case "exceed recall time limit":
                        Kr = E.E.MESSAGE_RECALL_TIME_LIMIT;
                        break;
                      case "message recall disabled":
                        Kr = E.E.SERVICE_NOT_ENABLED;
                        break;
                      case "not in group or chatroom white list":
                        Kr = E.E.SERVICE_NOT_ALLOW_MESSAGING;
                        break;
                      case "nonroster":
                        Kr = E.E.USER_NOT_FRIEND, Xt.status.reason = "not contact";
                        break;
                      case "group is disabled":
                        Kr = E.E.GROUP_IS_DISABLED, Xt.status.reason = "group is disabled";
                        break;
                      case "limit directed users":
                        Kr = E.E.MAX_LIMIT;
                        break;
                      case "Sorry, edit limit reached":
                        Kr = E.E.MAX_LIMIT, Xt.status.reason = "Modify message limit reached";
                        break;
                      case "Sorry, message does not exist":
                        Kr = E.E.MODIFY_MESSAGE_NOT_EXIST, Xt.status.reason = "The message does not exist.";
                        break;
                      case "Sorry, You do not have permission":
                        Kr = E.E.PERMISSION_DENIED, Xt.status.reason = "You do not have the modified permission.";
                        break;
                      case "Sorry, format is incorrect":
                        Kr = E.E.MODIFY_MESSAGE_FORMAT_ERROR, Xt.status.reason = "The modify messaged format error.";
                        break;
                      case "Sorry, edit is not available":
                        Kr = E.E.SERVICE_NOT_ENABLED, Xt.status.reason = "The message modify function is not activated.";
                        break;
                      case "Sorry, edit fail":
                        Kr = E.E.MODIFY_MESSAGE_FAILED, Xt.status.reason = "Modify message failed.";
                        break;
                      default:
                        Xt.status.reason.includes("grpID") && Xt.status.reason.includes("does not exist!") ? (Kr = E.E.CHATROOM_NOT_EXIST, Xt.status.reason = "The chat room dose not exist.") : Xt.status.reason.includes("username") && Xt.status.reason.includes("doesn't exist!") ? Kr = E.E.USER_NOT_FOUND : Xt.status.reason === "group member list is full!" ? Kr = E.E.CHATROOM_MEMBERS_FULL : Xt.status.reason.includes("can not join this group") && Xt.status.reason.includes("is in the blacklist") ? (Kr = E.E.PERMISSION_DENIED, Xt.status.reason = "permission denied") : Xt.status.reason === "can not operate this group, reason: group is disabled" ? Kr = E.E.GROUP_IS_DISABLED : Xt.status.reason.includes("moderation") ? Kr = E.E.MESSAGE_MODERATION_BLOCKED : Xt.status.reason.includes("group ID illegal, please check it") ? (Kr = E.E.REQUEST_PARAMETER_ERROR, Xt.status.reason = "Invalid parameter") : Kr = Xt.status.reason.includes("has create too many chatrooms") || Xt.status.reason.includes("has joined too many chatrooms") ? E.E.MAX_LIMIT : Xt.status.reason.includes("auto create failed") ? E.E.SERVER_BUSY : E.E.SERVER_UNKNOWN_ERROR;
                    }
                    this._msgHash[Mt] && (!(($t = this._msgHash[Mt]) === null || $t === void 0) && $t.isHandleChatroom ? (Di = I.Z.create({ type: Kr, message: Xt.status.reason || "", data: "" }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].error instanceof Function && this._msgHash[Mt].error(Di), he.iO.has(Mt) && (uu = pe.dd.failed, Kr === E.E.CHATROOM_NOT_EXIST ? uu = pe.dd.notFound : Kr === E.E.CHATROOM_MEMBERS_FULL && (uu = pe.dd.reachLimit), Ko = he.iO.get(Mt), Zi = Ko.rpt, Hr = Ko.requestName, Zi({ isEndApi: !0, data: { isSuccess: 0, requestName: Hr, requestMethod: "WEBSOCKET", requestUrl: this.url, code: uu, codeDesc: Xt.status.reason } }), he.iO.delete(Mt))) : (Di = I.Z.create({ type: Kr, message: Xt.status.reason || "", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: Kr, reason: Xt.status.reason ? Xt.status.reason : "", data: { id: Mt, mid: Wn } }), (Wt = (yt = this._localCache) === null || yt === void 0 ? void 0 : yt.getInstance()) === null || Wt === void 0 || Wt.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })), delete this._msgHash[Mt]);
                  } else if (Xt.status.errorCode === 7) Xt.status.reason === "sensitive words" && this._msgHash[Mt] ? (Di = I.Z.create({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, message: "sensitive words", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, data: { id: Mt, mid: Wn, reason: "sensitive words" } }), (gn = (In = this._localCache) === null || In === void 0 ? void 0 : In.getInstance()) === null || gn === void 0 || gn.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "blocked by mod_antispam" && this._msgHash[Mt] ? (Di = I.Z.create({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, message: "blocked by mod_antispam", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.MESSAGE_INCLUDE_ILLEGAL_CONTENT, data: { id: Mt, mid: Wn, reason: "blocked by mod_antispam" } }), (Xn = (zn = this._localCache) === null || zn === void 0 ? void 0 : zn.getInstance()) === null || Xn === void 0 || Xn.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "user is mute" && this._msgHash[Mt] ? (Di = I.Z.create({ type: E.E.USER_MUTED_BY_ADMIN, message: "user is mute", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail(Di), (ur = (yr = this._localCache) === null || yr === void 0 ? void 0 : yr.getInstance()) === null || ur === void 0 || ur.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "traffic limit" && this._msgHash[Mt] ? (Di = I.Z.create({ type: E.E.MESSAGE_CURRENT_LIMITING, message: "traffic limit", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail(Di), (xi = (Yn = this._localCache) === null || Yn === void 0 ? void 0 : Yn.getInstance()) === null || xi === void 0 || xi.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL })) : Xt.status.reason === "Sorry, data is too large" && this._msgHash[Mt] && (Di = I.Z.create({ type: E.E.MESSAGE_SIZE_LIMIT, message: "Sorry, data is too large", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail(Di), (Or = (gs = this._localCache) === null || gs === void 0 ? void 0 : gs.getInstance()) === null || Or === void 0 || Or.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL }));
                  else if (Xt.status.errorCode === 19) this._msgHash[Mt] && (he.TJ.has(Mt) && (he.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "WEBSOCKET", requestUrl: this.url, code: E.E.MESSAGE_EXTERNAL_LOGIC_BLOCKED, codeDesc: Xt.status.reason || "", msgId: Wn } }), he.TJ.delete(Mt)), Di = I.Z.create({ type: E.E.MESSAGE_EXTERNAL_LOGIC_BLOCKED, message: Xt.status.reason || "", data: { id: Mt, mid: Wn } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.MESSAGE_EXTERNAL_LOGIC_BLOCKED, data: { id: Mt, mid: Wn, reason: Xt.status.reason } }), (Za = (da = this._localCache) === null || da === void 0 ? void 0 : da.getInstance()) === null || Za === void 0 || Za.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL }));
                  else if (this._msgHash[Mt]) {
                    he.TJ.has(Mt) && (he.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "WEBSOCKET", requestUrl: this.url, code: E.E.WEBIM_LOAD_MSG_ERROR, codeDesc: ((js = Xt.status) === null || js === void 0 ? void 0 : js.reason) || "", msgId: Wn } }), he.TJ.delete(Mt));
                    try {
                      Di = I.Z.create({ type: E.E.WEBIM_LOAD_MSG_ERROR, message: ((Fs = Xt.status) === null || Fs === void 0 ? void 0 : Fs.reason) || "", data: { id: Mt, mid: Wn, reason: Xt.status && Xt.status.reason } }), this._msgHash[Mt].reject instanceof Function && this._msgHash[Mt].reject(Di), (Gs = (la = this._localCache) === null || la === void 0 ? void 0 : la.getInstance()) === null || Gs === void 0 || Gs.updateLocalMessage(Mt, { serverMsgId: Wn, status: J.r.FAIL }), this._msgHash[Mt].fail instanceof Function && this._msgHash[Mt].fail({ type: E.E.WEBIM_LOAD_MSG_ERROR, data: { errorCode: Xt.status && Xt.status.errorCode, reason: Xt.status && Xt.status.reason } });
                    } catch (cs) {
                      os = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "when executing fail function error", data: cs }), this.onError && this.onError(os), (ka = this.eventHandler) === null || ka === void 0 || ka.dispatch("onError", os);
                    }
                    delete this._msgHash[Mt];
                  } else he.TJ.has(Mt) && (he.TJ.get(Mt).rpt({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "WEBSOCKET", requestUrl: this.url, code: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, codeDesc: "on message error", msgId: Wn } }), he.TJ.delete(Mt)), os = I.Z.create({ type: E.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, message: "on message error" }), this.onError && this.onError(os), (Vs = this.eventHandler) === null || Vs === void 0 || Vs.dispatch("onError", os);
                  Ei.label = 22;
                case 22:
                  return [2];
                case 23:
                  if (Xt.metas && Xt.metas.length !== 0) try {
                    at.call(this, Xt.metas, Xt.status);
                  } catch (cs) {
                    os = I.Z.create({ type: E.E.WEBIM_LOAD_MSG_ERROR, message: "decode message error", data: cs }), g.kg.error("decode message error", cs), this.onError && this.onError(os), (ja = this.eventHandler) === null || ja === void 0 || ja.dispatch("onError", os);
                  } finally {
                    Xt.isLast ? (g.kg.debug("metas & CommSyncDLMessage.isLast", Xt.isLast), Aa = -1, this._queues.some(function(cs, ci) {
                      return cs.name === Xt.name && (Aa = ci, !0);
                    }) && Aa > 0 && this._queues.splice(Aa, 1), this._queues.length > 0 && Tt.call(this, this._queues[0]), Ao = -1, this.unSyncQueue.some(function(cs, ci) {
                      return cs.name === Xt.queue.name && (Ao = ci, !0);
                    }) && this.unSyncQueue.splice(Ao, 1), It.call(this, Xt)) : Xt.nextKey && (Ha = new (m())(Xt.nextKey.low, Xt.nextKey.high, Xt.nextKey.unsigned).toString(), g.kg.debug("nexKey:", Ha, "this.nextKey:", this.nexKey), Ha !== this.nexKey && (this.nexKey = Ha, kt.call(this, Xt.nextKey, Xt.queue)));
                  }
                  else Xt.isLast ? (g.kg.debug("CommSyncDLMessage.isLast", Xt.isLast), Hi = -1, this._queues.some(function(cs, ci) {
                    return cs.name === Xt.queue.name && (Hi = ci, !0);
                  }) && this._queues.splice(Hi, 1), this._queues.length > 0 && Tt.call(this, this._queues[0]), Qi = -1, this.unSyncQueue.some(function(cs, ci) {
                    return cs.name === Xt.queue.name && (Qi = ci, !0);
                  }) && this.unSyncQueue.splice(Qi, 1), It.call(this, Xt)) : Xt.nextKey && (Ha = new (m())(Xt.nextKey.low, Xt.nextKey.high, Xt.nextKey.unsigned).toString(), g.kg.debug("nexKey:", Ha, "this.nextKey:", this.nexKey), Ha !== this.nexKey && (this.nexKey = Ha, kt.call(this, Xt.nextKey, Xt.queue)));
                  return [2];
              }
            });
          });
        }
        function Me(x) {
          var ae = [], Q = this.root.lookup("easemob.pb.KeyValue"), Z = [];
          for (var ge in x) {
            var me = Q.decode(ae);
            if (me.key = ge, x[ge] !== void 0) {
              if (Ce(x[ge]) === "object") me.type = 8, me.stringValue = JSON.stringify(x[ge]);
              else if (typeof x[ge] == "string") me.type = 7, me.stringValue = x[ge];
              else if (typeof x[ge] == "boolean") me.type = 1, me.varintValue = x[ge] === !0 ? 1 : 0;
              else if (Number.isInteger(x[ge])) me.type = 2, me.varintValue = x[ge];
              else if (typeof x[ge] == "bigint" || Ce(x[ge]) === "symbol" || typeof x[ge] == "function" || Number.isNaN(x[ge])) me.type = 7, me.stringValue = x[ge].toString();
              else {
                if (typeof x[ge] != "number" || Number.isInteger(x[ge])) continue;
                me.type = 6, me.doubleValue = x[ge];
              }
              Z.push(me);
            }
          }
          return Z;
        }
        function Se(x) {
          var ae, Q, Z, ge = [];
          if (this.root) {
            var me, ve = this.root.lookup("easemob.pb.MessageBody.Content").decode(ge);
            switch (me = !x.group && ((ae = x == null ? void 0 : x.chatType) === null || ae === void 0 ? void 0 : ae.toLowerCase()) !== "groupchat" || x.roomType ? x.group && x.roomType || ((Q = x == null ? void 0 : x.chatType) === null || Q === void 0 ? void 0 : Q.toLowerCase()) === "chatroom" ? "chatRoom" : "singleChat" : "groupChat", x.type) {
              case "txt":
                ve.type = 0, ve.text = x.msg;
                break;
              case "img":
                ve.type = 1, x.body ? (ve.displayName = x.body.filename, ve.remotePath = x.body.url, ve.secretKey = x.body.secret, ve.fileLength = x.body.file_length, ve.size = x.body.size, ve.thumbnailDisplayName = x.body.filename) : x.file ? (ve.displayName = x.file.filename, ve.remotePath = x.file.url, ve.secretKey = x.file.secret, ve.fileLength = x.file.file_length, ve.size = x.file.size, ve.thumbnailDisplayName = x.file.filename) : (ve.displayName = x.filename, ve.remotePath = x.url, ve.secretKey = x.secret, ve.fileLength = x.file_length, ve.size = x.size, ve.thumbnailDisplayName = x.filename), x.isBuildCombinedMsg && (ve.remotePath = x.url, ve.secretKey = x.secret, ve.size = { height: x.height, width: x.width });
                break;
              case "video":
                ve.type = 2, x.body ? (ve.displayName = x.body.filename, ve.remotePath = x.body.url, ve.secretKey = x.body.secret, ve.fileLength = x.body.file_length, ve.duration = x.body.length, ve.thumbnailDisplayName = x.body.filename, ve.thumbnailRemotePath = this.useOwnUploadFun ? "" : "".concat(x.body.url, "?vframe=true"), ve.thumbnailSecretKey = this.useOwnUploadFun ? "" : x.body.secret) : x.isBuildCombinedMsg && (ve.displayName = x.filename, ve.remotePath = x.url, ve.secretKey = x.secret, ve.fileLength = x.file_length, ve.duration = x.length, ve.thumbnailDisplayName = x.filename, ve.thumbnailRemotePath = x.thumb, ve.thumbnailSecretKey = x.thumb_secret);
                break;
              case "loc":
                ve.type = 3, ve.latitude = x.lat, ve.longitude = x.lng, ve.address = x.addr, ve.buildingName = x.buildingName, ve.latitude = x.lat;
                break;
              case "audio":
                ve.type = 4, x.body ? (ve.displayName = x.body.filename, ve.remotePath = x.body.url, ve.secretKey = x.body.secret, ve.fileLength = x.body.file_length, ve.duration = x.body.length, ve.thumbnailDisplayName = x.body.filename) : x.isBuildCombinedMsg && (ve.displayName = x.filename, ve.remotePath = x.url, ve.secretKey = x.secret, ve.fileLength = x.file_length, ve.duration = x.length, ve.thumbnailDisplayName = x.filename);
                break;
              case "file":
                ve.type = 5, x.body ? (ve.displayName = x.body.filename, ve.remotePath = x.body.url, ve.secretKey = x.body.secret, ve.fileLength = x.body.file_length, ve.thumbnailDisplayName = x.body.filename) : x.isBuildCombinedMsg && (ve.displayName = x.filename, ve.remotePath = x.url, ve.secretKey = x.secret, ve.fileLength = x.file_length, ve.thumbnailDisplayName = x.filename);
                break;
              case "cmd":
                ve.type = 6, ve.action = x.action;
                break;
              case "custom":
                ve.type = 7, ve.customEvent = x.customEvent, ve.customExts = Me.call(this, x.customExts);
                break;
              case "combine":
                ve.type = 0, ve.subType = 0, ve.text = x.compatibleText, ve.displayName = x.filename, ve.remotePath = x.url, ve.secretKey = x.secret, ve.fileLength = x.file_length, ve.title = x.title, ve.summary = x.summary, ve.combineLevel = x.combineLevel;
            }
            var ie = [];
            x.ext && (ie = Me.call(this, x.ext));
            var ye = this.root.lookup("easemob.pb.MessageBody"), Ye = ye.decode(ge), ne = x.from || this.context.jid.name;
            Ye.from = { name: x.isBuildCombinedMsg ? ne : this.context.jid.name };
            var Qe = x.to.indexOf("/"), W = Qe > -1 ? x.to.substring(0, Qe) : x.to;
            if (Ye.to = { name: W }, x.type === "channel") Ye.type = _e.CHANNEL_ACK;
            else if (x.type === "recall") Ye.type = _e.RECALL, Ye.ackMessageId = x.ackId;
            else if (x.type === "delivery") Ye.type = _e.DELIVER_ACK, Ye.ackMessageId = x.ackId;
            else if (x.type === "read") Ye.type = _e.READ_ACK, Ye.ackMessageId = x.ackId, me === "groupChat" && (Ye.msgConfig = { allowGroupAck: !0 }, Ye.ackContent = x.ackContent);
            else if (me === "chatRoom") Ye.type = _e.CHATROOM;
            else if (me === "groupChat") {
              if (Ye.type = _e.GROUPCHAT, x.msgConfig) {
                var ce = x.msgConfig.allowGroupAck;
                Ye.msgConfig = { allowGroupAck: !!ce };
              }
            } else me === "singleChat" && (Ye.type = _e.SINGLECHAT);
            x.editMessageId && (Ye.type = _e.EDIT, Ye.editMessageId = x.editMessageId), Ye.contents = [ve], Ye.ext = ie;
            var fe = function(Lt) {
              var Kt = {};
              return "translations" in Lt && (Kt.translations = Lt.translations), "isChatThread" in Lt && Lt.isChatThread && (Kt.thread = {}), Object.keys(Kt).length > 0 ? JSON.stringify(Kt) : "";
            }(x);
            fe && (Ye.meta = fe), Ye = ye.encode(Ye).finish();
            var we = this.root.lookup("easemob.pb.Meta"), Fe = we.decode(ge);
            Fe.id = x.id;
            var je = "easemob.com";
            if (me !== "chatRoom" && me !== "groupChat" || (je = "conference.easemob.com"), Fe.to = { appKey: this.appKey, name: W, domain: je }, Qe > -1 && (Fe.to.clientResource = x.to.substring(Qe + 1, x.to.length)), me === "chatRoom" && (Fe.ext = Me.call(this, function(Lt) {
              return { chatroom_msg_tag: Lt.priority === "high" ? 0 : Lt.priority === "low" ? 2 : 1 };
            }(x))), x.type === "recall" && x.metaExt && (Fe.ext = Me.call(this, { recallMessageExtensionInfo: x.metaExt })), Fe.ns = 1, Fe.payload = Ye, Fe.routetype = x.deliverOnlineOnly ? 1 : 0, me !== "singleChat" && Array.isArray(x.receiverList) && ((Z = x.receiverList) === null || Z === void 0 ? void 0 : Z.length) > 0 && (Fe.directedUsers = x.receiverList, Fe.routetype = 2), x.isBuildCombinedMsg) return Fe.timestamp = m().fromValue(x.time), we.encode(Fe).finish();
            var qe = this.root.lookup("easemob.pb.CommSyncUL"), et = qe.decode(ge);
            et.meta = Fe, Ge.call(this, x, Fe), et = qe.encode(et).finish();
            var bt = this.root.lookup("easemob.pb.MSync"), ot = bt.decode(ge);
            return ot.version = this.version, ot.encryptType = this.encryptType, ot.command = 0, ot.payload = et, bt.encode(ot).finish();
          }
          x.fail && x.fail({ type: E.E.WEBIM_CONNCTION_CLIENT_OFFLINE, message: "Not logged in" });
        }
        function ke(x) {
          var ae, Q, Z = this, ge = K({}, x);
          if (x.file) return ge.accessToken = this.token, ge.appKey = this.appKey, ge.apiUrl = this.apiUrl, ge.body && ge.body.url ? Se.call(this, ge) : new Promise(function(ye, Ye) {
            var ne = ge.onFileUploadComplete;
            ge.onFileUploadComplete = function(Qe) {
              var W, ce, fe, we, Fe, je;
              if (Qe.entities[0]["file-metadata"]) {
                var qe = Qe.entities[0]["file-metadata"]["content-length"];
                ge.file_length = qe, ge.filetype = Qe.entities[0]["file-metadata"]["content-type"], qe > 204800 && (ge.thumbnail = !0);
              }
              var et = "".concat(Z.apiUrl, "/").concat(Z.orgName, "/").concat(Z.appName, "/chatfiles/").concat(Qe.entities[0].uuid);
              ge.body = { type: ge.type || "file", secret: Qe.entities[0]["share-secret"], filename: ge.file.filename || ge.filename, url: et, length: ge.length || 0, filetype: ge.filetype || ge.file.filetype, file_length: ((ce = (W = ge.file) === null || W === void 0 ? void 0 : W.data) === null || ce === void 0 ? void 0 : ce.size) || 0, size: { width: ge.width || 0, height: ge.height || 0 } }, ge.file.url = Qe.uri, x.secret = Qe.entities[0]["share-secret"], Qe.url = x.url = "".concat(et, "?em-redirect=true&share-secret=").concat(Qe.entities[0]["share-secret"]), x.file_length = ge.file_length = ((we = (fe = ge.file) === null || fe === void 0 ? void 0 : fe.data) === null || we === void 0 ? void 0 : we.size) || 0, ge.type === "img" && (x.thumb = "".concat(x.url, "&thumbnail=true"), Qe.thumb = "".concat(Qe.url, "&thumbnail=true")), ge.type === "video" && (x.thumb = "".concat(x.url, "&vframe=true"), x.thumb_secret = Qe.entities[0]["share-secret"], Qe.thumb = "".concat(Qe.url, "&vframe=true")), ne instanceof Function && ne(Qe, ge.id);
              var bt = Se.call(Z, ge);
              he.TJ.size <= he.F3 && he.TJ.set(ge.id, { rpt: Z.dataReport.geOperateFun({ operationName: pe.fI.SEND_MSG }) }), (je = (Fe = Z._localCache) === null || Fe === void 0 ? void 0 : Fe.getInstance()) === null || je === void 0 || je.storeMessage(x, J.r.INPROGRESS), Ct.call(Z, bt);
            }, H.P6.uploadFile.call(Z, ge, pe.fI.UPLOAD_MSG_ATTACH);
          });
          if (x.type === "combine") {
            ge.accessToken = this.token, ge.appKey = this.appKey, ge.apiUrl = this.apiUrl;
            var me = ge.onFileUploadComplete, ve = ge.onFileUploadError;
            return new Promise(function(ye, Ye) {
              var ne, Qe, W, ce;
              if (((ne = x.messageList) === null || ne === void 0 ? void 0 : ne.length) > 300 || ((Qe = x.messageList) === null || Qe === void 0 ? void 0 : Qe.length) === 0) return Z._msgHash[ge.id].reject({ type: E.E.MAX_LIMIT, message: "The number of combined messages exceeded the limit." });
              var fe = xe([], x.messageList), we = 0;
              if (fe.forEach(function(Kt) {
                (Kt == null ? void 0 : Kt.combineLevel) > we && (we = Kt == null ? void 0 : Kt.combineLevel);
              }), ge.combineLevel = we + 1, ge.combineLevel > 10) return Z._msgHash[ge.id].reject({ type: E.E.MAX_LIMIT, message: "The level of the merged message exceeded the limit." });
              var Fe = nt.call(Z, fe), je = function(Kt, $t) {
                var yt, Wt, In, gn, zn, Xn, yr = "".concat(Z.apiUrl, "/").concat(Z.orgName, "/").concat(Z.appName, "/chatfiles/").concat(Kt.entities[0].uuid), ur = (yt = Kt.entities[0]) === null || yt === void 0 ? void 0 : yt["share-secret"], Yn = yr + "?em-redirect=true";
                ur && (Yn = "".concat(Yn, "&share-secret=").concat(ur)), me instanceof Function && me({ url: Yn, secret: ur }), x.url = Yn, x.secret = ur, ge.url = Yn, ge.secret = Kt.entities[0]["share-secret"], ge.filename = ((Wt = ge.file) === null || Wt === void 0 ? void 0 : Wt.filename) || ($t == null ? void 0 : $t.fileName), ge.file_length = ((gn = (In = ge.file) === null || In === void 0 ? void 0 : In.data) === null || gn === void 0 ? void 0 : gn.size) || ($t == null ? void 0 : $t.fileLength) || 0, (Xn = (zn = Z._localCache) === null || zn === void 0 ? void 0 : zn.getInstance()) === null || Xn === void 0 || Xn.storeMessage(x, J.r.INPROGRESS);
                var xi = Se.call(Z, ge);
                Ct.call(Z, xi);
              }, qe = H.P6.getEnvInfo();
              if (qe.platform !== "web" && qe.platform !== "node" && qe.platform !== "quick_app" && (!((ce = (W = qe.global) === null || W === void 0 ? void 0 : W.canIUse) === null || ce === void 0) && ce.call(W, "getFileSystemManager"))) {
                var et = qe.global.getFileSystemManager(), bt = "".concat(Z.apiUrl, "/").concat(Z.orgName, "/").concat(Z.appName, "/chatfiles");
                et.writeFile({ filePath: "".concat(qe.global.env.USER_DATA_PATH, "/combine"), data: Fe.buffer, encoding: "binary", success: function(Kt) {
                  qe.global.uploadFile({ url: bt, filePath: "".concat(qe.global.env.USER_DATA_PATH, "/combine"), name: "file", header: { "Content-Type": "multipart/form-data", Authorization: "Bearer " + ge.accessToken }, success: function($t) {
                    if ($t.statusCode === 200) {
                      g.kg.debug("upload success", $t);
                      var yt = JSON.parse($t.data);
                      je(yt, { fileName: "combine", fileLength: Fe.length });
                    } else g.kg.debug("upload fail"), ge.onFileUploadError instanceof Function && ge.onFileUploadError($t), this._msgHash[ge.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: $t });
                  }, fail: function($t) {
                    g.kg.debug("upload fail"), ge.onFileUploadError instanceof Function && ge.onFileUploadError(Kt), this._msgHash[ge.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: $t });
                  } });
                }, fail: function(Kt) {
                  g.kg.debug("write file fail", Kt), this._msgHash[ge.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: Kt });
                } });
              } else {
                var ot = new File([Fe], "combine", { type: "application/octet-stream" }), Lt = { url: URL.createObjectURL(ot), filename: ge.id, data: ot };
                ge.file = Lt, ge.onFileUploadComplete = function(Kt) {
                  je(Kt);
                }, ge.onFileUploadError = function(Kt) {
                  ve instanceof Function && ve(Kt), Z._msgHash[ge.id].reject({ type: E.E.WEBIM_UPLOADFILE_ERROR, message: "Failed to upload the merge message.Please try again", data: Kt });
                }, H.P6.uploadFile.call(Z, ge, pe.fI.UPLOAD_MSG_ATTACH);
              }
            });
          }
          x.type === "img" && (ge.body || (ge.body = K(K({}, ge), { size: { width: ge.width || 0, height: ge.height || 0 } }))), (Q = (ae = this._localCache) === null || ae === void 0 ? void 0 : ae.getInstance()) === null || Q === void 0 || Q.storeMessage(x, J.r.INPROGRESS);
          var ie = Se.call(this, ge);
          Ct.call(this, ie);
        }
        function Ge(x, ae) {
          x.editMessageId || be.includes(x.type) && (this._msgHash[x.id].thirdMessage = ae);
        }
        function nt(x) {
          for (var ae = Uint8Array.from("cm", function(W) {
            return W.charCodeAt(0);
          }), Q = 0; Q < x.length; Q++) {
            for (var Z = x[Q], ge = K(K({}, Z), { isBuildCombinedMsg: !0 }), me = this.mSync.encodeChatMsg.call(this, ge), ve = me.length, ie = new Uint8Array(4), ye = 0; ye < 4; ye++) ie[ye] = ve >> 8 * (3 - ye) & 255;
            g.kg.debug("message length:", ie);
            var Ye = new Uint8Array(ae.length + ie.length + me.length);
            Ye.set(ae), Ye.set(ie, ae.length), Ye.set(me, ae.length + ie.length), ae = Ye;
          }
          var ne = new Uint8Array(ae.length + 1), Qe = 0;
          for (Q = 2; Q < ae.length; Q++) Q % 2 == 1 && (Qe ^= ae[Q]);
          return ne.set(ae), g.kg.debug("checkResult:", Qe), ne[ae.length] = Qe, ne;
        }
        function rt(x, ae, Q) {
          var Z = [], ge = this.root.lookup("easemob.pb.MUCBody"), me = x.roomId, ve = x.ext, ie = ve === void 0 ? "" : ve, ye = x.leaveOtherRooms, Ye = ye !== void 0 && ye, ne = ge.decode(Z);
          ne.mucId = { appKey: this.appKey, name: me, domain: "conference.easemob.com" }, ne.operation = Q === "join" ? 2 : 3, ne.from = { name: this.context.userId }, ne.isChatroom = !0, Q === "join" && (ne.ext = ie, ne.leaveOtherRooms = Ye), ne = ge.encode(ne).finish();
          var Qe = this.root.lookup("easemob.pb.Meta").decode(Z);
          Qe.id = ae, Qe.from = { appKey: this.appKey, name: this.context.userId, domain: "easemob.com", client_resource: this.context.jid.clientResource }, Qe.to = { domain: "easemob.com" }, Qe.ns = 2, Qe.payload = ne;
          var W = this.root.lookup("easemob.pb.CommSyncUL"), ce = W.decode(Z);
          ce.meta = Qe, ce = W.encode(ce).finish();
          var fe = this.root.lookup("easemob.pb.MSync"), we = fe.decode(Z);
          return we.version = this.version, we.encryptType = this.encryptType, we.command = 0, we.payload = ce, fe.encode(we).finish();
        }
        function dt(x, ae) {
          var Q = H.P6.getUniqueId(), Z = rt.call(this, x, Q, ae), ge = ae === "join" ? pe.fI.JOIN_CHATROOM : pe.fI.QUIT_CHATROOM, me = this.dataReport.geOperateFun({ operationName: ge });
          return he.iO.size <= he.F3 && he.iO.set(Q, { rpt: me, requestName: ge }), Ct.call(this, K(K({}, x), { isHandleChatroom: !0, joinMsg: Z, id: Q, operation: ae }), Q);
        }
        function lt(x) {
          var ae = this;
          return new Promise(function(Q, Z) {
            var ge, me, ve, ie, ye, Ye;
            if (g.kg.debug("call send"), ae.logOut) return g.kg.debug("send message failed", E.E.WEBIM_CONNECTION_CLOSED), Z({ type: E.E.WEBIM_CONNECTION_CLOSED, message: "not login" });
            if (!x.id || typeof x.id != "string" || x.id === "") return Z({ type: E.E.MESSAGE_PARAMETER_ERROR, message: 'Missing required parameter: "id"' });
            if (!x.to || typeof x.to != "string" || x.to === "") return Z({ type: E.E.MESSAGE_PARAMETER_ERROR, message: 'Missing required parameter: "to"' });
            var ne = x.type === "file" || x.type === "img" || x.type === "audio" || x.type === "video", Qe = x.type === "delivery" || x.type === "read" || x.type === "channel", W = x.type === "cmd", ce = x.type === "recall", fe = x == null ? void 0 : x.editMessageId, we = !(Qe || ce || W || fe);
            if (x.id) {
              if (!ne && !Qe || ne && ae.useOwnUploadFun) {
                var Fe = x.type === "recall" ? pe.fI.SEND_RECALL_MSG : pe.fI.SEND_MSG;
                fe && (Fe = pe.fI.MODIFY_MESSAGE), he.TJ.size <= he.F3 && he.TJ.set(x.id, { rpt: ae.dataReport.geOperateFun({ operationName: Fe }) });
              }
              we && ((me = (ge = ae._localCache) === null || ge === void 0 ? void 0 : ge.getInstance()) === null || me === void 0 || me.storeMessage(x, J.r.CREATE)), ae._msgHash[x.id] = K(K({}, x), { resolve: Q, reject: Z });
            }
            if (ne || x.type === "combine") return ke.call(ae, x);
            if (x.type === "txt" && (!((ve = x.msgConfig) === null || ve === void 0) && ve.languages) && Array.isArray((ie = x.msgConfig) === null || ie === void 0 ? void 0 : ie.languages) && x.msgConfig.languages.length > 0) {
              var je = ae.translateMessage || ae.translation.translateMessage;
              if (!je) throw new Error("there is no method to translate message");
              je.call(ae, { text: x.msg, languages: x.msgConfig.languages }).then(function(et) {
                var bt, ot, Lt, Kt = (bt = et.data[0]) === null || bt === void 0 ? void 0 : bt.translations;
                Kt = Kt.map(function(yt) {
                  return { code: yt.to, text: yt.text };
                }), x.translations = Kt, ae._msgHash[x.id].translations = Kt, (Lt = (ot = ae._localCache) === null || ot === void 0 ? void 0 : ot.getInstance()) === null || Lt === void 0 || Lt.storeMessage(x, J.r.INPROGRESS);
                var $t = Se.call(ae, x);
                Ct.call(ae, $t, x.id);
              }).catch(function(et) {
                Z(et);
              });
            } else {
              we && ((Ye = (ye = ae._localCache) === null || ye === void 0 ? void 0 : ye.getInstance()) === null || Ye === void 0 || Ye.storeMessage(x, J.r.INPROGRESS));
              var qe = Se.call(ae, x);
              Ct.call(ae, qe, x.id);
            }
          });
        }
        function Ct(x, ae) {
          var Q, Z, ge = this;
          if (x.isHandleChatroom) {
            if (!this.isOpened()) {
              var me = { data: "", type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" };
              if (he.iO.has(x.id)) {
                var ve = he.iO.get(x.id);
                (0, ve.rpt)({ isEndApi: !0, data: { isSuccess: 0, requestName: ve.requestName, requestMethod: "WEBSOCKET", requestUrl: this.url, code: pe.dd.disconnect, codeDesc: "websocket has been disconnected" } }), he.iO.delete(x.id);
              }
              return Promise.reject(me);
            }
            return new Promise(function(ie, ye) {
              var Ye;
              ge._msgHash[x.id] = K(K({}, x), { resolve: ie, reject: ye }), Ye = ge.name === "miniCore" ? x.joinMsg : Ke.call(ge, x.joinMsg, ae), ge.sock.send(Ye);
            });
          }
          if (!this.isOpened()) return (Q = this.unMSyncSendMsgMap) === null || Q === void 0 || Q.set(ae, x), !this.logOut && this.autoReconnectNumTotal < this.autoReconnectNumMax && (g.kg.debug("need to reconnect", this.autoReconnectNumTotal, this.autoReconnectNumMax), this.offLineSendConnecting = !0, this.reconnecting || this.reconnect()), void (this.onError && this.onError({ type: E.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" }));
          Z = this.name === "miniCore" ? x : Ke.call(this, x, ae), this.sock.send(Z);
        }
        var Ie = function(x, ae) {
          return x.send = lt, x.sendMsg = lt, g.kg.debug("init Msync by ".concat(x.name)), { generateProvision: Be.bind(x), base64transform: Ke.bind(x), distributeMeta: Ze.bind(x), decodeMeta: at.bind(x), decodeUnreadDL: Rt.bind(x), _rebuild: gt.bind(x), _lastsession: Ut.bind(x), receiveProvision: wt.bind(x), isInQueue: ze.bind(x), decodeNotice: Ne.bind(x), decodeMSync: le.bind(x), distributeMSync: X.bind(x), encodeChatMsg: Se.bind(x), upLoadFile: ke.bind(x), send: lt.bind(x), stopHeartBeat: Ht.bind(x), handleChatRoom: dt.bind(x) };
        };
      }, 7252: function(l, v) {
        var s = function() {
          function c(d) {
            this.type = d.type, this.message = d.message, this.data = d.data;
          }
          return c.create = function(d) {
            return new c(d);
          }, c;
        }();
        v.Z = s;
      }, 8161: function(l, v, s) {
        s.d(v, { t: function() {
          return H;
        } }), s(9601), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(7941), s(3710), s(9714), s(9653), s(6699), s(2023), s(2222), s(8309), s(9554), s(4747), s(2772);
        var c = s(3720), d = s.n(c), p = s(4363), m = s(4024), E = s(6424), y = s(9743), g = s(7360), C = s(2449), O = s(7288), N = function() {
          return N = Object.assign || function(j) {
            for (var G, U = 1, M = arguments.length; U < M; U++) for (var V in G = arguments[U]) Object.prototype.hasOwnProperty.call(G, V) && (j[V] = G[V]);
            return j;
          }, N.apply(this, arguments);
        }, w = function(j, G, U, M) {
          return new (U || (U = Promise))(function(V, J) {
            function ue(de) {
              try {
                ee(M.next(de));
              } catch (he) {
                J(he);
              }
            }
            function se(de) {
              try {
                ee(M.throw(de));
              } catch (he) {
                J(he);
              }
            }
            function ee(de) {
              var he;
              de.done ? V(de.value) : (he = de.value, he instanceof U ? he : new U(function(pe) {
                pe(he);
              })).then(ue, se);
            }
            ee((M = M.apply(j, [])).next());
          });
        }, _ = function(j, G) {
          var U, M, V, J, ue = { label: 0, sent: function() {
            if (1 & V[0]) throw V[1];
            return V[1];
          }, trys: [], ops: [] };
          return J = { next: se(0), throw: se(1), return: se(2) }, typeof Symbol == "function" && (J[Symbol.iterator] = function() {
            return this;
          }), J;
          function se(ee) {
            return function(de) {
              return function(he) {
                if (U) throw new TypeError("Generator is already executing.");
                for (; ue; ) try {
                  if (U = 1, M && (V = 2 & he[0] ? M.return : he[0] ? M.throw || ((V = M.return) && V.call(M), 0) : M.next) && !(V = V.call(M, he[1])).done) return V;
                  switch (M = 0, V && (he = [2 & he[0], V.value]), he[0]) {
                    case 0:
                    case 1:
                      V = he;
                      break;
                    case 4:
                      return ue.label++, { value: he[1], done: !1 };
                    case 5:
                      ue.label++, M = he[1], he = [0];
                      continue;
                    case 7:
                      he = ue.ops.pop(), ue.trys.pop();
                      continue;
                    default:
                      if (!((V = (V = ue.trys).length > 0 && V[V.length - 1]) || he[0] !== 6 && he[0] !== 2)) {
                        ue = 0;
                        continue;
                      }
                      if (he[0] === 3 && (!V || he[1] > V[0] && he[1] < V[3])) {
                        ue.label = he[1];
                        break;
                      }
                      if (he[0] === 6 && ue.label < V[1]) {
                        ue.label = V[1], V = he;
                        break;
                      }
                      if (V && ue.label < V[2]) {
                        ue.label = V[2], ue.ops.push(he);
                        break;
                      }
                      V[2] && ue.ops.pop(), ue.trys.pop();
                      continue;
                  }
                  he = G.call(j, ue);
                } catch (pe) {
                  he = [6, pe], M = 0;
                } finally {
                  U = V = 0;
                }
                if (5 & he[0]) throw he[1];
                return { value: he[0] ? he[1] : void 0, done: !0 };
              }([ee, de]);
            };
          }
        }, I = { 0: "TEXT", 1: "IMAGE", 2: "VIDEO", 3: "LOCATION", 4: "VOICE", 5: "FILE", 6: "COMMAND", 7: "CUSTOM", 8: "COMBINE" };
        function k(j) {
          for (var G = {}, U = 0; U < j.length; U++) if (j[U].type === 8) G[j[U].key] = JSON.parse(j[U].stringValue);
          else if (j[U].type === 7) G[j[U].key] = j[U].stringValue;
          else if (j[U].type === 6) G[j[U].key] = j[U].doubleValue;
          else if (j[U].type === 5) G[j[U].key] = j[U].floatValue;
          else if (j[U].type === 1) {
            var M = j[U].varintValue, V = new (d())(M.low, M.high, M.unsigned).toString();
            G[j[U].key] = Number(V) !== 0;
          } else j[U].type !== 2 && j[U].type !== 3 && j[U].type !== 4 || (M = j[U].varintValue, V = new (d())(M.low, M.high, M.unsigned).toString(), G[j[U].key] = Number(V));
          return G;
        }
        function H(j) {
          var G = "";
          return j.remotePath && (G = m.P6.formatAttachUrl.call(this, j.remotePath), j.remotePath.includes("?em-redirect") || (G = "".concat(G, "?em-redirect=true"), j.secretKey && (G = "".concat(G, "&share-secret=").concat(j.secretKey)))), G;
        }
        function S(j, G) {
          var U, M, V = G.from && G.from.name;
          if (V === this.context.userId) {
            var J = (U = j == null ? void 0 : j.from) === null || U === void 0 ? void 0 : U.clientResource;
            V === ((M = G == null ? void 0 : G.to) === null || M === void 0 ? void 0 : M.name) && J && J !== this.clientResource && (V = "".concat(V, "/").concat(J));
          }
          return V;
        }
        function B(j, G) {
          var U, M = G.to && G.to.name;
          return !((U = j == null ? void 0 : j.to) === null || U === void 0) && U.clientResource && (M = "".concat(M, "/").concat(j.to.clientResource)), M;
        }
        function D(j) {
          var G, U, M, V, J, ue, se, ee, de, he, pe, Ce, _e, Le, Te, K, Oe, Pe, xe, be, $e, Be, Ke, Ze, at, pt, It;
          return w(this, void 0, void 0, function() {
            var Rt, gt, it, Tt, Ut, st, Ot, kt, wt, Et, ut, St, Ft, Ht, zt, ze, Ne, le, X, re, Me, Se, ke, Ge, nt, rt, dt, lt, Ct, Ie, x, ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W, ce, fe, we, Fe, je, qe, et, bt, ot;
            return _(this, function(Lt) {
              switch (Lt.label) {
                case 0:
                  switch (Rt = j.status, gt = j.thirdMessage, it = j.msgBody, Tt = j.msgId, Ut = j.type, st = j.from, Ot = j.to, kt = j.time, wt = j.onlineState, Et = j.chatType, ut = j.ignoreCallback, St = j.priority, Ft = j.format, Ht = j.broadcast, zt = Ht !== void 0 && Ht, ze = j.isContentReplaced, Ne = ze !== void 0 && ze, le = {}, X = {}, re = Rt.errorCode > 0, Me = Rt.errorCode, Se = Rt.reason, ke = {}, Ge = [], nt = [], rt = {}, dt = "", lt = 0, Ct = null, Ie = null, gt.ext && (ke = k(gt.ext)), gt.meta && typeof gt.meta == "string" && ((ae = JSON.parse(gt.meta)).reaction && (Ge = ae.reaction).forEach(function(Kt) {
                    Kt.isAddedBySelf = Kt.state, delete Kt.state;
                  }), ae.translations && (nt = ae.translations), ae.edit_msg && (Q = ae.edit_msg, Z = Q.count, ge = Q.operator, me = Q.edit_time, ve = Q.sender, ie = Q.send_time, rt = { operationTime: me, operatorId: ge, operationCount: Z }, dt = ve, lt = ie), ae.thread && JSON.stringify(ae.thread) !== "{}" && (Ct = { messageId: ae.thread.msg_parent_id, parentId: ae.thread.muc_parent_id, chatThreadName: ae.thread.thread_name }), ae.thread_overview && JSON.stringify(ae.thread_overview) !== "{}" && (Ie = { id: ae.thread_overview.id, parentId: ae.thread_overview.muc_parent_id, name: ae.thread_overview.name, lastMessage: ae.thread_overview.last_message && JSON.stringify(ae.thread_overview.last_message) !== "{}" ? p.w.call(this, ae.thread_overview.last_message) : null, createTimestamp: ae.thread_overview.create_timestamp, updateTimestamp: ae.thread_overview.update_timestamp, messageCount: ae.thread_overview.message_count || 0 })), it.type) {
                    case 0:
                      return [3, 1];
                    case 1:
                      return [3, 7];
                    case 2:
                      return [3, 10];
                    case 3:
                      return [3, 13];
                    case 4:
                      return [3, 16];
                    case 5:
                      return [3, 19];
                    case 6:
                      return [3, 22];
                    case 7:
                      return [3, 23];
                    case 8:
                      return [3, 26];
                  }
                  return [3, 27];
                case 1:
                  return Object.prototype.hasOwnProperty.call(it, "subType") && it.subType === 0 ? (x = H.call(this, it), ye = { id: Tt, type: "combine", chatType: Et, to: Ot, from: st, ext: ke, time: Number(kt), onlineState: wt, title: it.title || "", summary: it.summary || "", url: x || "", secret: it.secretKey || "", file_length: it.fileLength || 0, filename: it.displayName || "", compatibleText: it.text, combineLevel: it.combineLevel || 0 }, le.msgConfig && (ye.msgConfig = le.msgConfig), Ge.length > 0 && (ye.reactions = Ge), Ct && (ye.chatThread = Ct), Ie && (ye.chatThreadOverview = Ie), Et === "chatRoom" && (ye.priority = St, ye.broadcast = zt), Ne && (ye.isContentReplaced = Ne), X = ye, ut ? [3, 3] : [4, (U = (G = this._localCache) === null || G === void 0 ? void 0 : G.getInstance()) === null || U === void 0 ? void 0 : U.storeMessage(ye, O.r.SUCCESS)]) : [3, 4];
                case 2:
                  Lt.sent(), (M = this.eventHandler) === null || M === void 0 || M.dispatch("onCombineMessage", ye), Lt.label = 3;
                case 3:
                  return [3, 28];
                case 4:
                  return !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, data: it.text, ext: ke, sourceMsg: it.text, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onTextMessage && this.onTextMessage(le), Ye = { id: Tt, type: "txt", chatType: Et, msg: it.text, to: Ot, from: st, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (Ye.msgConfig = le.msgConfig), Ge.length > 0 && (Ye.reactions = Ge), Ct && (Ye.chatThread = Ct), Ie && (Ye.chatThreadOverview = Ie), nt.length > 0 && (Ye.translations = nt), rt.operationCount > 0 && (Ye.modifiedInfo = rt, gt.type === E.gA.EDIT && (Ye.from = dt, Ye.time = lt)), Et === "chatRoom" && (Ye.priority = St, Ye.broadcast = zt), Ne && (Ye.isContentReplaced = Ne), X = Ye, ut ? [3, 6] : [4, (J = (V = this._localCache) === null || V === void 0 ? void 0 : V.getInstance()) === null || J === void 0 ? void 0 : J.storeMessage(Ye, O.r.SUCCESS)];
                case 5:
                  Lt.sent(), (ue = this.eventHandler) === null || ue === void 0 || ue.dispatch("onTextMessage", Ye), Lt.label = 6;
                case 6:
                  return [3, 28];
                case 7:
                  return ne = ((se = it == null ? void 0 : it.size) === null || se === void 0 ? void 0 : se.width) || 0, Qe = ((ee = it == null ? void 0 : it.size) === null || ee === void 0 ? void 0 : ee.height) || 0, x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, thumb: this.useOwnUploadFun ? "" : "".concat(x, "&thumbnail=true"), thumb_secret: it.secretKey, file_length: it.fileLength || "", width: ne, height: Qe, filetype: it.filetype || "", accessToken: this.token, ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onPictureMessage && this.onPictureMessage(le), W = { id: Tt, type: "img", chatType: Et, from: st, to: Ot, url: x || "", width: ne, height: Qe, secret: it.secretKey || "", thumb: this.useOwnUploadFun ? "" : "".concat(x, "&thumbnail=true"), thumb_secret: it.secretKey, file_length: it.fileLength || 0, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (W.msgConfig = le.msgConfig), Ge.length > 0 && (W.reactions = Ge), Ct && (W.chatThread = Ct), Ie && (W.chatThreadOverview = Ie), Et === "chatRoom" && (W.priority = St, W.broadcast = zt), Ne && (W.isContentReplaced = Ne), X = W, ut ? [3, 9] : [4, (he = (de = this._localCache) === null || de === void 0 ? void 0 : de.getInstance()) === null || he === void 0 ? void 0 : he.storeMessage(W, O.r.SUCCESS)];
                case 8:
                  Lt.sent(), (pe = this.eventHandler) === null || pe === void 0 || pe.dispatch("onImageMessage", W), Lt.label = 9;
                case 9:
                  return [3, 28];
                case 10:
                  return x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, length: it.duration || "", file_length: it.fileLength || "", filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onVideoMessage && this.onVideoMessage(le), ce = { id: Tt, type: "video", chatType: Et, from: st, to: Ot, url: x, secret: it.secretKey, thumb: m.P6.formatAttachUrl.call(this, it.thumbnailRemotePath), thumb_secret: it.thumbnailSecretKey, filename: it.displayName, length: it.duration || 0, file: {}, file_length: it.fileLength || 0, filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (ce.msgConfig = le.msgConfig), Ge.length > 0 && (ce.reactions = Ge), Ct && (ce.chatThread = Ct), Ie && (ce.chatThreadOverview = Ie), Et === "chatRoom" && (ce.priority = St, ce.broadcast = zt), Ne && (ce.isContentReplaced = Ne), X = ce, ut ? [3, 12] : [4, (_e = (Ce = this._localCache) === null || Ce === void 0 ? void 0 : Ce.getInstance()) === null || _e === void 0 ? void 0 : _e.storeMessage(ce, O.r.SUCCESS)];
                case 11:
                  Lt.sent(), (Le = this.eventHandler) === null || Le === void 0 || Le.dispatch("onVideoMessage", ce), Lt.label = 12;
                case 12:
                  return [3, 28];
                case 13:
                  return !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, addr: it.address, buildingName: it.buildingName, lat: it.latitude, lng: it.longitude, ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onLocationMessage && this.onLocationMessage(le), fe = { id: Tt, type: "loc", chatType: Et, from: st, to: Ot, buildingName: it.buildingName, addr: it.address, lat: it.latitude, lng: it.longitude, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (fe.msgConfig = le.msgConfig), Ge.length > 0 && (fe.reactions = Ge), Ct && (fe.chatThread = Ct), Ie && (fe.chatThreadOverview = Ie), Et === "chatRoom" && (fe.priority = St, fe.broadcast = zt), Ne && (fe.isContentReplaced = Ne), X = fe, ut ? [3, 15] : [4, (K = (Te = this._localCache) === null || Te === void 0 ? void 0 : Te.getInstance()) === null || K === void 0 ? void 0 : K.storeMessage(fe, O.r.SUCCESS)];
                case 14:
                  Lt.sent(), (Oe = this.eventHandler) === null || Oe === void 0 || Oe.dispatch("onLocationMessage", fe), Lt.label = 15;
                case 15:
                  return [3, 28];
                case 16:
                  return x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, file_length: it.fileLength || "", accessToken: this.token || "", ext: ke, length: it.duration, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onAudioMessage && this.onAudioMessage(le), we = { id: Tt, type: "audio", chatType: Et, from: st, to: Ot, url: x, secret: it.secretKey, file: {}, filename: it.displayName, length: it.duration || 0, file_length: it.fileLength || 0, filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (we.msgConfig = le.msgConfig), Ge.length > 0 && (we.reactions = Ge), Ct && (we.chatThread = Ct), Ie && (we.chatThreadOverview = Ie), Et === "chatRoom" && (we.priority = St, we.broadcast = zt), Ne && (we.isContentReplaced = Ne), X = we, ut ? [3, 18] : [4, (xe = (Pe = this._localCache) === null || Pe === void 0 ? void 0 : Pe.getInstance()) === null || xe === void 0 ? void 0 : xe.storeMessage(we, O.r.SUCCESS)];
                case 17:
                  Lt.sent(), (be = this.eventHandler) === null || be === void 0 || be.dispatch("onAudioMessage", we), Lt.label = 18;
                case 18:
                  return [3, 28];
                case 19:
                  return x = this.useOwnUploadFun ? it.remotePath : H.call(this, it), !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, url: x, secret: it.secretKey, filename: it.displayName, file_length: it.fileLength, accessToken: this.token || "", ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).delay && delete le.delay, !le.msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onFileMessage && this.onFileMessage(le), Fe = { id: Tt, type: "file", chatType: Et, from: st, to: Ot, url: x, secret: it.secretKey, file: {}, filename: it.displayName, length: it.duration || 0, file_length: it.fileLength || 0, filetype: it.filetype || "", accessToken: this.token || "", ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (Fe.msgConfig = le.msgConfig), Ge.length > 0 && (Fe.reactions = Ge), Ct && (Fe.chatThread = Ct), Ie && (Fe.chatThreadOverview = Ie), Et === "chatRoom" && (Fe.priority = St, Fe.broadcast = zt), Ne && (Fe.isContentReplaced = Ne), X = Fe, ut ? [3, 21] : [4, (Be = ($e = this._localCache) === null || $e === void 0 ? void 0 : $e.getInstance()) === null || Be === void 0 ? void 0 : Be.storeMessage(Fe, O.r.SUCCESS)];
                case 20:
                  Lt.sent(), (Ke = this.eventHandler) === null || Ke === void 0 || Ke.dispatch("onFileMessage", Fe), Lt.label = 21;
                case 21:
                  return [3, 28];
                case 22:
                  return !(le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, action: it.action, ext: ke, time: kt, msgConfig: gt.msgConfig, onlineState: wt }).msgConfig && delete gt.msgConfig, le.error = re, le.errorText = Se, le.errorCode = Me, !ut && this.onCmdMessage && this.onCmdMessage(le), je = { id: Tt, type: "cmd", chatType: Et, from: st, to: Ot, action: it.action, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (je.msgConfig = le.msgConfig), Ge.length > 0 && (je.reactions = Ge), Ct && (je.chatThread = Ct), Ie && (je.chatThreadOverview = Ie), Et === "chatRoom" && (je.priority = St, je.broadcast = zt), Ne && (je.isContentReplaced = Ne), X = je, ut || (Ze = this.eventHandler) === null || Ze === void 0 || Ze.dispatch("onCmdMessage", je), [3, 28];
                case 23:
                  return qe = {}, et = {}, gt.contents[0].customExts && (qe = k(gt.contents[0].customExts)), gt.contents[0].params && (et = k(gt.contents[0].params)), le = { id: Tt, type: Ut, contentsType: I[it.type], from: st, to: Ot, customEvent: it.customEvent, params: et, customExts: qe, ext: ke, time: kt, onlineState: wt }, !ut && this.onCustomMessage && this.onCustomMessage(le), bt = { id: Tt, type: "custom", chatType: Et, from: st, to: Ot, customEvent: it.customEvent, params: et, customExts: qe, ext: ke, time: Number(kt), onlineState: wt }, le.msgConfig && (bt.msgConfig = le.msgConfig), Ge.length > 0 && (bt.reactions = Ge), Ct && (bt.chatThread = Ct), Ie && (bt.chatThreadOverview = Ie), rt.operationCount > 0 && (bt.modifiedInfo = rt, gt.type === E.gA.EDIT && (bt.from = dt, bt.time = lt)), Et === "chatRoom" && (bt.priority = St, bt.broadcast = zt), Ne && (bt.isContentReplaced = Ne), X = bt, ut ? [3, 25] : [4, (pt = (at = this._localCache) === null || at === void 0 ? void 0 : at.getInstance()) === null || pt === void 0 ? void 0 : pt.storeMessage(bt, O.r.SUCCESS)];
                case 24:
                  Lt.sent(), (It = this.eventHandler) === null || It === void 0 || It.dispatch("onCustomMessage", bt), Lt.label = 25;
                case 25:
                  return [3, 28];
                case 26:
                  return x = H.call(this, it), ot = { id: Tt, type: "combine", chatType: Et, to: Ot, from: st, ext: ke, time: Number(kt), onlineState: wt, title: it.title || "", summary: it.summary || "", url: x || "", secret: it.secretKey || "", file_length: it.fileLength || 0, filename: it.displayName || "", compatibleText: it.text, combineLevel: it.combineLevel || 0 }, le.msgConfig && (ot.msgConfig = le.msgConfig), Ge.length > 0 && (ot.reactions = Ge), Ct && (ot.chatThread = Ct), Ie && (ot.chatThreadOverview = Ie), Et === "chatRoom" && (ot.priority = St, ot.broadcast = zt), Ne && (ot.isContentReplaced = Ne), X = ot, !ut && this.eventHandler && this.eventHandler.dispatch("onCombineMessage", ot), [3, 28];
                case 27:
                  return g.kg.error("Unknow message type, message:", it), [3, 28];
                case 28:
                  return Ft ? [2, X] : [2, le];
              }
            });
          });
        }
        function F(j, G, U) {
          if (this.delivery && j !== G) {
            var M = this.getUniqueId(), V = new C.Message("delivery", M);
            V.set({ ackId: U, to: j }), g.kg.debug("send delivery ack"), this.send(V.body);
          }
        }
        v.Z = function(j, G, U, M, V) {
          var J, ue, se, ee, de, he, pe, Ce, _e, Le, Te, K, Oe, Pe, xe, be, $e, Be, Ke, Ze, at, pt, It, Rt, gt, it;
          return w(this, void 0, void 0, function() {
            var Tt, Ut, st, Ot, kt, wt, Et, ut, St, Ft, Ht, zt, ze, Ne, le, X, re, Me, Se, ke, Ge, nt, rt, dt, lt, Ct, Ie, x, ae, Q, Z, ge, me, ve, ie, ye, Ye, ne, Qe, W;
            return _(this, function(ce) {
              switch (ce.label) {
                case 0:
                  if (Tt = new (d())(j.timestamp.low, j.timestamp.high, j.timestamp.unsigned).toString(), Ut = this.root.lookup("easemob.pb.MessageBody"), st = Ut.decode(j.payload), Ot = 3, kt = !1, wt = new (d())(j.id.low, j.id.high, j.id.unsigned).toString(), V && j.from && j.from.name === this.context.userId && j.from.clientResource === this.clientResource && st.type === E.gA.CHATROOM) return [2, g.kg.debug("Discard your own chat room message:", wt)];
                  if (j.meta && j.meta.length) {
                    if (Et = m.P6.parseNotify(j.meta), ut = Et.is_online, St = Et.callback_replace, this.useReplacedMessageContents && St && (kt = !0), ut || ut === 0) switch (ut) {
                      case 0:
                        Ot = 0;
                        break;
                      case 1:
                        Ot = 1;
                        break;
                      default:
                        Ot = 2;
                    }
                  } else Ot = 3;
                  switch (Ft = st.ackMessageId ? new (d())(st.ackMessageId.low, st.ackMessageId.high, st.ackMessageId.unsigned).toString() : "", Ht = "", zt = S.call(this, j, st), ze = B.call(this, j, st), g.kg.debug("meta thirdMessage:", { metaId: wt, metaNs: j.ns, type: st.type, from: zt, to: ze, contentType: (ue = (J = st.contents) === null || J === void 0 ? void 0 : J[0]) === null || ue === void 0 ? void 0 : ue.type, contentLen: (se = st.contents) === null || se === void 0 ? void 0 : se.length }), st.type) {
                    case E.gA.SINGLECHAT:
                      return [3, 1];
                    case E.gA.GROUPCHAT:
                      return [3, 2];
                    case E.gA.CHATROOM:
                      return [3, 3];
                    case E.gA.READ_ACK:
                      return [3, 4];
                    case E.gA.DELIVER_ACK:
                      return [3, 5];
                    case E.gA.RECALL:
                      return [3, 6];
                    case E.gA.CHANNEL_ACK:
                      return [3, 15];
                    case E.gA.EDIT:
                      return [3, 16];
                  }
                  return [3, 20];
                case 1:
                  return Ht = "chat", this.grantType === "agoraToken" && (Ht = "singleChat"), this.delivery && !U && zt !== this.context.userId && F.call(this, zt, ze, wt), [3, 21];
                case 2:
                  return Ht = "groupchat", this.grantType === "agoraToken" && (Ht = "groupChat"), [3, 21];
                case 3:
                  return Ht = "chatroom", this.grantType === "agoraToken" && (Ht = "chatRoom"), Ot = 1, [3, 21];
                case 4:
                  return Ht = "read_ack", Ne = void 0, st.ext[0] && JSON.parse(st.ext[0].stringValue) ? (Ne = { id: wt, type: "read", from: zt, to: ze, mid: Ft, groupReadCount: st.ext[0] && JSON.parse(st.ext[0].stringValue), ackContent: st.ackContent, onlineState: Ot }, this.onReadMessage && this.onReadMessage(Ne), (ee = this.eventHandler) === null || ee === void 0 || ee.dispatch("onReadMessage", Ne), [2]) : (Ne = { id: wt, type: "read", from: zt, to: ze, mid: Ft, onlineState: Ot }, this.onReadMessage && this.onReadMessage(Ne), (de = this.eventHandler) === null || de === void 0 || de.dispatch("onReadMessage", Ne), [2]);
                case 5:
                  return Ht = "deliver_ack", this.onDeliveredMessage && this.onDeliveredMessage({ id: wt, type: "delivery", from: zt, to: ze, mid: Ft, onlineState: Ot }), le = { id: wt, type: "delivery", from: zt, to: ze, mid: Ft, onlineState: Ot }, (he = this.eventHandler) === null || he === void 0 || he.dispatch("onDeliveredMessage", le), [2];
                case 6:
                  return Ht = "recall", X = "", j.ext && (X = ((pe = k(j.ext)) === null || pe === void 0 ? void 0 : pe.recallMessageExtensionInfo) || ""), re = { id: wt, from: zt || "admin", to: ze, mid: Ft, ext: X, onlineState: Ot }, Me = ze === this.user ? zt : ze, [4, (_e = (Ce = this._localCache) === null || Ce === void 0 ? void 0 : Ce.getInstance()) === null || _e === void 0 ? void 0 : _e.getMessageByServerMsgId(re.mid)];
                case 7:
                  return (Se = ce.sent()) ? [4, (Te = (Le = this._localCache) === null || Le === void 0 ? void 0 : Le.getInstance()) === null || Te === void 0 ? void 0 : Te.removeMsgByServerMsgId(re.mid)] : [3, 9];
                case 8:
                  ce.sent(), ce.label = 9;
                case 9:
                  return (Se == null ? void 0 : Se.chatType) !== "singleChat" && (Se == null ? void 0 : Se.chatType) !== "groupChat" ? [3, 14] : (ke = (Se == null ? void 0 : Se.from) === this.user || (Se == null ? void 0 : Se.from) === "", [4, (Oe = (K = this._localCache) === null || K === void 0 ? void 0 : K.getInstance()) === null || Oe === void 0 ? void 0 : Oe.getConversationLastMessage(Me, Se.chatType)]);
                case 10:
                  return Ge = ce.sent(), [4, (xe = (Pe = this._localCache) === null || Pe === void 0 ? void 0 : Pe.getInstance()) === null || xe === void 0 ? void 0 : xe.getConversationBySessionId((0, y.MQ)({ conversationId: Me, conversationType: Se.chatType }))];
                case 11:
                  return (nt = ce.sent()) ? [4, ($e = (be = this._localCache) === null || be === void 0 ? void 0 : be.getInstance()) === null || $e === void 0 ? void 0 : $e.updateLocalConversation((0, y.MQ)({ conversationId: Me, conversationType: Se.chatType }), { lastMessageId: Ge == null ? void 0 : Ge.serverMsgId, unReadCount: (0, y.E7)({ conversation: nt, isRecallSelfMsg: ke, recalledMsgTime: Se.time }) })] : [3, 13];
                case 12:
                  ce.sent(), ce.label = 13;
                case 13:
                  ce.label = 14;
                case 14:
                  return this.onRecallMessage && this.onRecallMessage(re), (Be = this.eventHandler) === null || Be === void 0 || Be.dispatch("onRecallMessage", re), [2];
                case 15:
                  return this.onChannelMessage && this.onChannelMessage({ id: wt, type: "channel", chatType: "singleChat", from: zt, to: ze, time: Number(Tt), onlineState: Ot }), rt = { id: wt, type: "channel", chatType: "singleChat", from: zt, to: ze, time: Number(Tt), onlineState: Ot }, (Ke = this.eventHandler) === null || Ke === void 0 || Ke.dispatch("onChannelMessage", rt), [2];
                case 16:
                  return dt = { errorCode: 0, reason: "" }, [4, D.call(this, { status: dt, thirdMessage: st, msgBody: st.contents[0], msgId: wt, type: Ht, from: zt, to: ze, time: Tt, onlineState: Ot, ignoreCallback: !0, format: !0, isContentReplaced: kt })];
                case 17:
                  return lt = ce.sent(), Ct = !!j.to && j.to.domain.indexOf("conference") !== -1, lt.chatType = Ct ? "groupChat" : "singleChat", Ie = st.editMessageId && new (d())(st.editMessageId.low, st.editMessageId.high, st.editMessageId.unsigned).toString(), x = {}, lt.type === "txt" ? (ae = lt.type, Q = lt.chatType, Z = lt.to, ge = lt.from, me = lt.time, ve = lt.modifiedInfo, x = { id: Ie, type: ae, chatType: Q, to: Z, from: ge, time: me, modifiedInfo: ve, msg: lt.msg }, lt.translations && (x.translations = lt.translations)) : lt.type === "custom" && ((x = lt).id = Ie, delete x.onlineState), x ? [4, (at = (Ze = this._localCache) === null || Ze === void 0 ? void 0 : Ze.getInstance()) === null || at === void 0 ? void 0 : at.getMessageByServerMsgId(Ie)] : [3, 19];
                case 18:
                  ((ie = ce.sent()) == null ? void 0 : ie.type) === "txt" && x.type === "txt" ? (It = (pt = this._localCache) === null || pt === void 0 ? void 0 : pt.getInstance()) === null || It === void 0 || It.putMessageToDB(N(N({}, ie), { msg: x.msg, modifiedInfo: x.modifiedInfo, translations: x.translations })) : (ie == null ? void 0 : ie.type) === "custom" && x.type === "custom" && ((gt = (Rt = this._localCache) === null || Rt === void 0 ? void 0 : Rt.getInstance()) === null || gt === void 0 || gt.putMessageToDB(N(N({}, ie), { modifiedInfo: x.modifiedInfo, customEvent: x.customEvent, customExts: x.customExts, ext: x.ext }))), ce.label = 19;
                case 19:
                  return lt.type !== "txt" && lt.type !== "custom" || (it = this.eventHandler) === null || it === void 0 || it.dispatch("onModifiedMessage", x), [2];
                case 20:
                  return g.kg.error("unexpected message type: ".concat(st.type)), [2];
                case 21:
                  ye = "normal", ne = !1, Ht.toLowerCase() === "chat" || Ht === "singleChat" ? Ye = "singleChat" : Ht.toLowerCase() === "groupchat" || Ht === "groupChat" ? Ye = "groupChat" : (Ye = "chatRoom", Ot = 1, j.ext && (Qe = k(j.ext), ne = !!(Qe != null && Qe.is_broadcast), ye = Qe.chatroom_msg_tag === 0 ? "high" : Qe.chatroom_msg_tag === 2 ? "low" : "normal")), W = 0, ce.label = 22;
                case 22:
                  return W < st.contents.length ? [4, D.call(this, { status: G, thirdMessage: st, msgBody: st.contents[W], msgId: wt, type: Ht, from: zt, to: ze, time: Tt, onlineState: Ot, chatType: Ye, ignoreCallback: U, priority: ye, format: M, broadcast: ne, isContentReplaced: kt })] : [3, 25];
                case 23:
                  return [2, ce.sent()];
                case 24:
                  return W++, [3, 22];
                case 25:
                  return [2];
              }
            });
          });
        };
      }, 7288: function(l, v, s) {
        var c;
        s.d(v, { r: function() {
          return c;
        } }), function(d) {
          d[d.CREATE = 0] = "CREATE", d[d.FAIL = 1] = "FAIL", d[d.INPROGRESS = 2] = "INPROGRESS", d[d.SUCCESS = 3] = "SUCCESS";
        }(c || (c = {}));
      }, 9743: function(l, v, s) {
        s.d(v, { E7: function() {
          return d;
        }, MQ: function() {
          return c;
        }, un: function() {
          return p;
        } }), s(2222);
        var c = function(m) {
          return "".concat(m.conversationType, "-").concat(m.conversationId);
        }, d = function(m) {
          var E = m.isRecallSelfMsg, y = m.conversation, g = m.recalledMsgTime, C = y.unReadCount, O = C === void 0 ? 0 : C, N = y.unreadCountClearTimestamp;
          return E || (N === void 0 ? 0 : N) > g ? O : O && O > 0 ? O - 1 : 0;
        }, p = function(m) {
          var E, y = 0;
          if (m.length === 0) return y;
          for (E = 0; E < m.length; E++) y = (y << 5) - y + m.charCodeAt(E), y |= 0;
          return y;
        };
      }, 7360: function(l, v, s) {
        function c() {
          console.log && (console.log.apply ? console.log.apply(console, Array.prototype.slice.call(arguments)) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
        }
        s.d(v, { kg: function() {
          return w;
        } }), s(1539), s(8674), s(2526), s(1817), s(2165), s(6992), s(8783), s(3948), s(7042), s(2222), s(8309), s(9600), s(2564), s(285), s(1637), s(4812), s(3710), s(9554), s(2772), s(4916);
        var d = typeof window < "u" && window.navigator !== void 0 && /Trident\/|MSIE /.test(window.navigator.userAgent), p = s(4024);
        function m(_) {
          return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(I) {
            return typeof I;
          } : function(I) {
            return I && typeof Symbol == "function" && I.constructor === Symbol && I !== Symbol.prototype ? "symbol" : typeof I;
          }, m(_);
        }
        var E, y = function() {
        }, g = {};
        (function(_) {
          _[_.TRACE = 0] = "TRACE", _[_.DEBUG = 1] = "DEBUG", _[_.INFO = 2] = "INFO", _[_.WARN = 3] = "WARN", _[_.ERROR = 4] = "ERROR", _[_.SILENT = 5] = "SILENT";
        })(E || (E = {}));
        var C = function() {
          function _(I, k, H) {
            this.name = I || "defaultLogger", this.currentLevel = 0, this.useCookiePersist = !1, this.storageLogLevelKey = "loglevel", this.levels = E, this.consoleLogVisibility = !0, this.logMethods = ["trace", "debug", "info", "warn", "error"], this.methodFactory = H || this.defaultMethodFactory, this.report = !1;
            var S = this._getPersistedLevel();
            S == null && (S = k === null ? "WARN" : k), this.logs = [], this.reportLogs = [], this.reportInterval = 3e5, this.timer = null, this.config = { useCache: !1, maxCache: 3145728, color: "", background: "" }, this.logBytes = 0, this.setLevel(S, !1, "");
          }
          return _.prototype.reportLog = function() {
            var I, k, H, S, B, D, F;
            return S = this, B = void 0, F = function() {
              var j, G, U, M, V, J, ue, se;
              return function(ee, de) {
                var he, pe, Ce, _e, Le = { label: 0, sent: function() {
                  if (1 & Ce[0]) throw Ce[1];
                  return Ce[1];
                }, trys: [], ops: [] };
                return _e = { next: Te(0), throw: Te(1), return: Te(2) }, typeof Symbol == "function" && (_e[Symbol.iterator] = function() {
                  return this;
                }), _e;
                function Te(K) {
                  return function(Oe) {
                    return function(Pe) {
                      if (he) throw new TypeError("Generator is already executing.");
                      for (; Le; ) try {
                        if (he = 1, pe && (Ce = 2 & Pe[0] ? pe.return : Pe[0] ? pe.throw || ((Ce = pe.return) && Ce.call(pe), 0) : pe.next) && !(Ce = Ce.call(pe, Pe[1])).done) return Ce;
                        switch (pe = 0, Ce && (Pe = [2 & Pe[0], Ce.value]), Pe[0]) {
                          case 0:
                          case 1:
                            Ce = Pe;
                            break;
                          case 4:
                            return Le.label++, { value: Pe[1], done: !1 };
                          case 5:
                            Le.label++, pe = Pe[1], Pe = [0];
                            continue;
                          case 7:
                            Pe = Le.ops.pop(), Le.trys.pop();
                            continue;
                          default:
                            if (!((Ce = (Ce = Le.trys).length > 0 && Ce[Ce.length - 1]) || Pe[0] !== 6 && Pe[0] !== 2)) {
                              Le = 0;
                              continue;
                            }
                            if (Pe[0] === 3 && (!Ce || Pe[1] > Ce[0] && Pe[1] < Ce[3])) {
                              Le.label = Pe[1];
                              break;
                            }
                            if (Pe[0] === 6 && Le.label < Ce[1]) {
                              Le.label = Ce[1], Ce = Pe;
                              break;
                            }
                            if (Ce && Le.label < Ce[2]) {
                              Le.label = Ce[2], Le.ops.push(Pe);
                              break;
                            }
                            Ce[2] && Le.ops.pop(), Le.trys.pop();
                            continue;
                        }
                        Pe = de.call(ee, Le);
                      } catch (xe) {
                        Pe = [6, xe], pe = 0;
                      } finally {
                        he = Ce = 0;
                      }
                      if (5 & Pe[0]) throw Pe[1];
                      return { value: Pe[0] ? Pe[1] : void 0, done: !0 };
                    }([K, Oe]);
                  };
                }
              }(this, function(ee) {
                switch (ee.label) {
                  case 0:
                    if (((I = this.reportLogs) === null || I === void 0 ? void 0 : I.length) === 0) return [2];
                    for (j = 2097152, G = this.reportLogs.join(`
`) + `
`, U = G.length, M = []; U > j; ) M.push(G.substring(0, j)), U -= j, G = G.substring(j);
                    M.push(G), V = 0, J = M, ee.label = 1;
                  case 1:
                    if (!(V < J.length)) return [3, 8];
                    if (ue = J[V], this.reportLogs = [], !(!((H = (k = this.connection) === null || k === void 0 ? void 0 : k.context) === null || H === void 0) && H.accessToken)) return [2];
                    ee.label = 2;
                  case 2:
                    return ee.trys.push([2, 4, , 5]), [4, this.reportData(ue)];
                  case 3:
                    return ((se = ee.sent()) == null ? void 0 : se.status) !== "ok" && this.reportLogs.unshift(ue), [3, 5];
                  case 4:
                    return ee.sent(), this.reportLogs.unshift(ue), [3, 5];
                  case 5:
                    return [4, p.P6.delay(3e3)];
                  case 6:
                    ee.sent(), ee.label = 7;
                  case 7:
                    return V++, [3, 1];
                  case 8:
                    return [2];
                }
              });
            }, new ((D = void 0) || (D = Promise))(function(j, G) {
              function U(J) {
                try {
                  V(F.next(J));
                } catch (ue) {
                  G(ue);
                }
              }
              function M(J) {
                try {
                  V(F.throw(J));
                } catch (ue) {
                  G(ue);
                }
              }
              function V(J) {
                var ue;
                J.done ? j(J.value) : (ue = J.value, ue instanceof D ? ue : new D(function(se) {
                  se(ue);
                })).then(U, M);
              }
              V((F = F.apply(S, B || [])).next());
            });
          }, _.prototype.reportData = function(I) {
            var k, H = this;
            if (this.connection) {
              var S = this.connection.context || {}, B = S.orgName, D = S.appName, F = S.accessToken, j = S.userId, G = { url: "".concat((k = this.connection) === null || k === void 0 ? void 0 : k.apiUrl, "/").concat(B, "/").concat(D, "/sdk/users/").concat(j, "/client/logs"), type: "POST", data: JSON.stringify({ resource: this.connection.clientResource, logContent: I }), dataType: "json", headers: { Authorization: "Bearer " + F, "Content-Type": "application/json" } };
              return p.hj.call(this.connection, G).then(function(U) {
                return H.log("report log success", U), U;
              }).catch(function(U) {
                H.error("report log error", U);
              });
            }
            this.error("report log error", "connection is null");
          }, _.prototype._regularlyReportLogs = function() {
            var I, k = this;
            this.timer && clearInterval(this.timer), ((I = this.reportInterval) !== null && I !== void 0 ? I : 0) < 6e4 && (this.reportInterval = 6e4), this.timer = setInterval(function() {
              k.reportLog();
            }, this.reportInterval || 3e5);
          }, _.prototype._stopReportLogs = function() {
            this.reportLog(), clearInterval(this.timer);
          }, _.prototype.setConfig = function(I) {
            this.config = I;
          }, _.prototype.getLevel = function() {
            return this.currentLevel;
          }, _.prototype.setLevel = function(I, k, H) {
            if (typeof I == "string" && (I = E[I]), I === void 0 && (I = 0), !(typeof I == "number" && I >= 0 && I <= this.levels.SILENT)) throw Error("log.setLevel() called with invalid level: " + I);
            if (this.currentLevel = I, k !== !1 && this._persistLevel(I), this.replaceLoggingMethods(I, H || ""), typeof console > "u" && I < E.SILENT) throw Error("No console available for logging");
          }, _.prototype.setDefaultLevel = function(I) {
            this._getPersistedLevel() || this.setLevel(I, !1, "");
          }, _.prototype.enableAll = function(I) {
            this.setLevel(this.levels.TRACE, !0, "");
          }, _.prototype.disableAll = function(I) {
            this.setLevel(this.levels.SILENT, !0, "");
          }, _.prototype.getLogs = function() {
            return this.logs;
          }, _.prototype.download = function() {
            if (typeof window < "u" && typeof document < "u") {
              var I = this.getLogs().join(`
`), k = new Blob([I], { type: "text/plain;charset=UTF-8" }), H = window.URL.createObjectURL(k), S = document.createElement("a");
              S.style.display = "none", S.href = H, S.setAttribute("download", "sdklog"), document.body.appendChild(S), S.click();
            }
          }, _.prototype.setConsoleLogVisibility = function(I) {
            this.consoleLogVisibility = I;
          }, _.prototype._bindMethod = function(I, k, H) {
            var S = this, B = I[k], D = this.getTime();
            if (H) return this._cacheLog;
            if (typeof B.bind == "function") return function() {
              for (var F = [], j = 0; j < arguments.length; j++) F[j] = arguments[j];
              var G = S.getTime();
              S.consoleLogVisibility && B.call.apply(B, function(U, M, V) {
                if (arguments.length === 2) for (var J, ue = 0, se = M.length; ue < se; ue++) !J && ue in M || (J || (J = Array.prototype.slice.call(M, 0, ue)), J[ue] = M[ue]);
                return U.concat(J || Array.prototype.slice.call(M));
              }([I, "".concat(G, " IM SDK [").concat(k === "log" ? "debug" : k, "]: ")], F, !1)), S.onLog && S.onLog({ time: G, level: k === "log" ? "debug" : k, logs: F }), S._cacheReportLogs.apply(S, F);
            };
            try {
              return Function.prototype.bind.call(B, I, "".concat(D, " IM SDK [").concat(k === "log" ? "debug" : k, "]: "));
            } catch {
              return function() {
                return Function.prototype.apply.apply(B, [I, arguments]);
              };
            }
          }, _.prototype.getTime = function() {
            var I = /* @__PURE__ */ new Date();
            return I.toTimeString().split(" ")[0] + ":" + I.getMilliseconds();
          }, _.prototype._cacheLog = function() {
            for (var I = [], k = 0; k < arguments.length; k++) I[k] = arguments[k];
            var H = (/* @__PURE__ */ new Date()).toLocaleString() + ": ", S = "";
            I.forEach(function(B) {
              m(B) === "object" ? S += JSON.stringify(B) + " " : S += B + " ";
            }), this._cacheLogCall(H + S), this._cacheReportLogs.apply(this, I);
          }, _.prototype._cacheLogCall = function(I) {
            var k = I.length, H = this.logBytes + k, S = this.config.maxCache;
            if (!(k >= S)) {
              if (H < S) this.logBytes += k;
              else for (var B = H - S, D = 0; D < B; ) {
                var F = this.logs.shift();
                F !== void 0 && (D += F.length);
              }
              this.logs.push(I);
            }
          }, _.prototype._cacheReportLogs = function() {
            for (var I = [], k = 0; k < arguments.length; k++) I[k] = arguments[k];
            if (this.report) {
              var H = (/* @__PURE__ */ new Date()).toLocaleString() + ": ", S = "";
              I.forEach(function(B) {
                m(B) === "object" ? S += JSON.stringify(B) + " " : S += B + " ";
              }), this.reportLogs.push(H + S);
            }
          }, _.prototype._getPersistedLevel = function() {
            var I;
            if (typeof window > "u") return 5;
            if ((I = window && window.localStorage && window.localStorage[this.storageLogLevelKey]) === "undefined") {
              var k = window.document.cookie, H = k.indexOf(encodeURIComponent(this.storageLogLevelKey));
              H !== -1 && (I = /^([^;]+)/.exec(k.slice(H))[1]);
            }
            return I || 5;
          }, _.prototype._persistLevel = function(I) {
            var k = this.logMethods[I] || "SILENT";
            typeof window < "u" && (window.localStorage && (window.localStorage[this.storageLogLevelKey] = k), this.useCookiePersist && (window.document.cookie = encodeURIComponent(this.storageLogLevelKey) + "=" + k + ";"));
          }, _.prototype.replaceLoggingMethods = function(I, k) {
            for (var H = this, S = 0; S < this.logMethods.length; S++) {
              var B = this.logMethods[S];
              this[B] = S < I ? function() {
                for (var D = [], F = 0; F < arguments.length; F++) D[F] = arguments[F];
                H.report && H._cacheReportLogs.apply(H, D);
              } : this.methodFactory(B, I, k);
            }
            this.log = this.debug;
          }, _.prototype.defaultMethodFactory = function(I, k, H) {
            return this.realMethod(I) || this.enableLoggingWhenConsoleArrives.apply(this, [I, k, H]);
          }, _.prototype.realMethod = function(I) {
            return I === "debug" && (I = "log"), typeof console < "u" && (I === "trace" && d ? c : console[I] !== void 0 ? this._bindMethod(console, I, this.config.useCache) : console.log !== void 0 ? this._bindMethod(console, "log", this.config.useCache) : y);
          }, _.prototype.enableLoggingWhenConsoleArrives = function(I, k, H) {
            return (function() {
              typeof console < "u" && (this.replaceLoggingMethods.call(this, k, H), this[I].apply(this, arguments));
            }).bind(this);
          }, _;
        }(), O = new C();
        O.getLogger = function(_) {
          if (typeof _ != "string" || _ === "") throw new TypeError("You must supply a name when creating a logger.");
          return this;
        };
        var N = typeof window < "u" ? window.log : void 0;
        O.noConflict = function() {
          return typeof window < "u" && window.log === O && (window.log = N), O;
        }, O.getLoggers = function() {
          return g;
        }, O.initReport = function(_) {
          var I = _.report, k = _.reportInterval, H = _.connection;
          O.report = I, O.reportInterval = k, O.connection = H, I && O._regularlyReportLogs();
        };
        var w = O;
      }, 2449: function(l, v, s) {
        s.d(v, { Message: function() {
          return k;
        } });
        var c = s(4024), d = function() {
          function H(S) {
            var B = S.id;
            this.id = B, this.type = S.type;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, ackId: S.id, type: "read", to: S.to, from: S.from || "", chatType: S.chatType };
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType, ackId: S.id, type: "read", to: S.to, from: S.from || "", ackContent: S.ackContent, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly };
          }, H;
        }(), p = function() {
          function H(S) {
            this.id = S.id, this.type = S.type;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, ackId: S.ackId, type: "delivery", to: S.to, from: S.from || "" };
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), ackId: S.ackId, type: "delivery", to: S.to, from: S.from || "", isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly };
          }, H;
        }(), m = (s(3843), s(3710), function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "channel", to: S.to, from: S.from || "", time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), type: "channel", chatType: S.chatType || "singleChat", to: S.to, from: S.from || "", time: Date.now(), isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly };
          }, H;
        }()), E = (s(9753), function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B, this.value = "";
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "txt", to: S.to, msg: S.msg, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), isChatThread: S.isChatThread }, this.value = S.msg;
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            var B, D;
            return !((B = S.msgConfig) === null || B === void 0) && B.languages && Array.isArray((D = S.msgConfig) === null || D === void 0 ? void 0 : D.languages), { type: "txt", id: c.P6.getUniqueId(), msg: S.msg, to: S.to, from: S.from || "", chatType: S.chatType, ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }()), y = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D || c.P6.getUniqueId(), this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "cmd", to: S.to, action: S.action, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), type: "cmd", to: S.to, from: S.from || "", chatType: S.chatType || "singleChat", action: S.action, time: Date.now(), ext: S.ext, msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), g = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "custom", to: S.to, customEvent: S.customEvent, customExts: S.customExts, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "custom", to: S.to, customEvent: S.customEvent, customExts: S.customExts, from: S.from || "", ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), C = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D || c.P6.getUniqueId(), this.type = B;
          }
          return H.prototype.set = function(S) {
            this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "loc", to: S.to, addr: S.addr, buildingName: S.buildingName, lat: S.lat, lng: S.lng, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now() };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "loc", to: S.to, addr: S.addr, buildingName: S.buildingName, lat: S.lat, lng: S.lng, from: S.from || "", ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), O = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "img", file: S.file, width: S.width, height: S.height, to: S.to, from: S.from || "", roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType, type: "img", url: S.url, width: S.width, height: S.height, file: S.file, to: S.to, from: S.from || "", ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, file_length: S.file_length, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList, thumbnailWidth: S.thumbnailWidth, thumbnailHeight: S.thumbnailHeight };
          }, H;
        }(), N = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "audio", file: S.file, filename: S.filename, length: S.length, file_length: S.file_length, fileInputId: S.fileInputId, to: S.to, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType, type: "audio", filename: S.filename, length: S.length, file: S.file, to: S.to, from: S.from || "", ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, file_length: S.file_length, msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), w = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "video", file: S.file, filename: S.filename, length: S.length, file_length: S.file_length, fileInputId: S.fileInputId, to: S.to, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), apiUrl: S.apiUrl, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "video", file: S.file, filename: S.filename, length: S.length, file_length: S.file_length, fileInputId: S.fileInputId, to: S.to, from: S.from || "", ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), _ = function() {
          function H(S) {
            var B = S.type, D = S.id;
            this.id = D, this.type = B;
          }
          return H.prototype.set = function(S) {
            S.file = S.file || S.fileInputId && c.P6.getFileUrl(S.fileInputId), this.body = { id: this.id, chatType: S.chatType || "singleChat", type: "file", file: S.file, filename: S.filename, fileInputId: S.fileInputId, to: S.to, from: S.from, roomType: S.roomType, success: S.success, fail: S.fail, ext: S.ext, time: Date.now(), onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, isChatThread: S.isChatThread };
          }, H.prototype.setChatType = function(S) {
            return !!this.body && (this.body.chatType = S, !0);
          }, H.prototype.setGroup = function(S) {
            return !!this.body && (this.body.group = S, !0);
          }, H.create = function(S) {
            return { id: c.P6.getUniqueId(), chatType: S.chatType || "singleChat", type: "file", file: S.file, filename: S.filename, fileInputId: S.fileInputId, file_length: S.file_length, to: S.to, from: S.from || "", ext: S.ext, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete, onFileUploadProgress: S.onFileUploadProgress, body: S.body, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList };
          }, H;
        }(), I = function() {
          function H(S) {
            var B = S.type, D = S.id || c.P6.getUniqueId();
            this.id = D, this.type = B, this.value = "";
          }
          return H.create = function(S) {
            return { type: "combine", id: c.P6.getUniqueId(), to: S.to, from: S.from || "", chatType: S.chatType, ext: S.ext, time: Date.now(), msgConfig: S.msgConfig, isChatThread: S.isChatThread, priority: S.priority, deliverOnlineOnly: S.deliverOnlineOnly, receiverList: S.receiverList, compatibleText: S.compatibleText, title: S.title, summary: S.summary, messageList: S.messageList, onFileUploadError: S.onFileUploadError, onFileUploadComplete: S.onFileUploadComplete };
          }, H;
        }(), k = function() {
          function H(S, B) {
            return this.type = S, this.id = B || c.P6.getUniqueId(), H.createOldMsg({ type: S, id: this.id });
          }
          return H.createOldMsg = function(S) {
            switch (S.type) {
              case "read":
                return new d({ type: "read", id: S.id });
              case "delivery":
                return new p({ type: "delivery", id: S.id });
              case "channel":
                return new m({ type: "channel", id: S.id });
              case "txt":
                return new E({ type: "txt", id: S.id });
              case "cmd":
                return new y({ type: "cmd", id: S.id });
              case "custom":
                return new g({ type: "custom", id: S.id });
              case "loc":
                return new C({ type: "loc", id: S.id });
              case "img":
                return new O({ type: "img", id: S.id });
              case "audio":
                return new N({ type: "audio", id: S.id });
              case "video":
                return new w({ type: "video", id: S.id });
              case "file":
                return new _({ type: "file", id: S.id });
            }
          }, H.create = function(S) {
            return (B = S).type !== "txt" || "version" in B ? function(D) {
              return D.type === "img" && !("version" in D);
            }(S) ? O.create(S) : function(D) {
              return D.type === "cmd" && !("version" in D);
            }(S) ? y.create(S) : function(D) {
              return D.type === "file" && !("version" in D);
            }(S) ? _.create(S) : function(D) {
              return D.type === "audio" && !("version" in D);
            }(S) ? N.create(S) : function(D) {
              return D.type === "video" && !("version" in D);
            }(S) ? w.create(S) : function(D) {
              return D.type === "custom" && !("version" in D);
            }(S) ? g.create(S) : function(D) {
              return D.type === "loc" && !("version" in D);
            }(S) ? C.create(S) : function(D) {
              return D.type === "channel" && !("version" in D);
            }(S) ? m.create(S) : function(D) {
              return D.type === "delivery" && !("version" in D);
            }(S) ? p.create(S) : function(D) {
              return D.type === "read" && !("version" in D);
            }(S) ? d.create(S) : function(D) {
              return D.type === "combine" && !("version" in D);
            }(S) ? I.create(S) : {} : E.create(S);
            var B;
          }, H.prototype.set = function(S) {
          }, H.getFileUrl = c.P6.getFileUrl, H;
        }();
      }, 5531: function(l, v, s) {
        var c;
        s.d(v, { E: function() {
          return c;
        } }), function(d) {
          d[d.REQUEST_SUCCESS = 0] = "REQUEST_SUCCESS", d[d.REQUEST_TIMEOUT = -1] = "REQUEST_TIMEOUT", d[d.REQUEST_UNKNOWN = -2] = "REQUEST_UNKNOWN", d[d.REQUEST_PARAMETER_ERROR = -3] = "REQUEST_PARAMETER_ERROR", d[d.REQUEST_ABORT = -4] = "REQUEST_ABORT", d[d.WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR = 0] = "WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_OPEN_ERROR = 1] = "WEBIM_CONNCTION_OPEN_ERROR", d[d.WEBIM_CONNCTION_AUTH_ERROR = 2] = "WEBIM_CONNCTION_AUTH_ERROR", d[d.WEBIM_CONNCTION_OPEN_USERGRID_ERROR = 3] = "WEBIM_CONNCTION_OPEN_USERGRID_ERROR", d[d.WEBIM_CONNCTION_ATTACH_ERROR = 4] = "WEBIM_CONNCTION_ATTACH_ERROR", d[d.WEBIM_CONNCTION_ATTACH_USERGRID_ERROR = 5] = "WEBIM_CONNCTION_ATTACH_USERGRID_ERROR", d[d.WEBIM_CONNCTION_REOPEN_ERROR = 6] = "WEBIM_CONNCTION_REOPEN_ERROR", d[d.WEBIM_CONNCTION_SERVER_CLOSE_ERROR = 7] = "WEBIM_CONNCTION_SERVER_CLOSE_ERROR", d[d.WEBIM_CONNCTION_SERVER_ERROR = 8] = "WEBIM_CONNCTION_SERVER_ERROR", d[d.WEBIM_CONNCTION_IQ_ERROR = 9] = "WEBIM_CONNCTION_IQ_ERROR", d[d.WEBIM_CONNCTION_PING_ERROR = 10] = "WEBIM_CONNCTION_PING_ERROR", d[d.WEBIM_CONNCTION_NOTIFYVERSION_ERROR = 11] = "WEBIM_CONNCTION_NOTIFYVERSION_ERROR", d[d.WEBIM_CONNCTION_GETROSTER_ERROR = 12] = "WEBIM_CONNCTION_GETROSTER_ERROR", d[d.WEBIM_CONNCTION_CROSSDOMAIN_ERROR = 13] = "WEBIM_CONNCTION_CROSSDOMAIN_ERROR", d[d.WEBIM_CONNCTION_LISTENING_OUTOF_MAXRETRIES = 14] = "WEBIM_CONNCTION_LISTENING_OUTOF_MAXRETRIES", d[d.WEBIM_CONNCTION_RECEIVEMSG_CONTENTERROR = 15] = "WEBIM_CONNCTION_RECEIVEMSG_CONTENTERROR", d[d.WEBIM_CONNCTION_DISCONNECTED = 16] = "WEBIM_CONNCTION_DISCONNECTED", d[d.WEBIM_CONNCTION_AJAX_ERROR = 17] = "WEBIM_CONNCTION_AJAX_ERROR", d[d.WEBIM_CONNCTION_JOINROOM_ERROR = 18] = "WEBIM_CONNCTION_JOINROOM_ERROR", d[d.WEBIM_CONNCTION_GETROOM_ERROR = 19] = "WEBIM_CONNCTION_GETROOM_ERROR", d[d.WEBIM_CONNCTION_GETROOMINFO_ERROR = 20] = "WEBIM_CONNCTION_GETROOMINFO_ERROR", d[d.WEBIM_CONNCTION_GETROOMMEMBER_ERROR = 21] = "WEBIM_CONNCTION_GETROOMMEMBER_ERROR", d[d.WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR = 22] = "WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR", d[d.WEBIM_CONNCTION_LOAD_CHATROOM_ERROR = 23] = "WEBIM_CONNCTION_LOAD_CHATROOM_ERROR", d[d.WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR = 24] = "WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR", d[d.WEBIM_CONNCTION_JOINCHATROOM_ERROR = 25] = "WEBIM_CONNCTION_JOINCHATROOM_ERROR", d[d.WEBIM_CONNCTION_QUITCHATROOM_ERROR = 26] = "WEBIM_CONNCTION_QUITCHATROOM_ERROR", d[d.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR = 27] = "WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR = 28] = "WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR = 29] = "WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR = 30] = "WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR", d[d.WEBIM_CONNCTION_CALLBACK_INNER_ERROR = 31] = "WEBIM_CONNCTION_CALLBACK_INNER_ERROR", d[d.WEBIM_CONNCTION_CLIENT_OFFLINE = 32] = "WEBIM_CONNCTION_CLIENT_OFFLINE", d[d.WEBIM_CONNCTION_CLIENT_LOGOUT = 33] = "WEBIM_CONNCTION_CLIENT_LOGOUT", d[d.WEBIM_CONNCTION_CLIENT_TOO_MUCH_ERROR = 34] = "WEBIM_CONNCTION_CLIENT_TOO_MUCH_ERROR", d[d.WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP = 35] = "WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP", d[d.WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP = 36] = "WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP", d[d.WEBIM_CONNECTION_ACCEPT_JOIN_GROUP = 37] = "WEBIM_CONNECTION_ACCEPT_JOIN_GROUP", d[d.WEBIM_CONNECTION_DECLINE_JOIN_GROUP = 38] = "WEBIM_CONNECTION_DECLINE_JOIN_GROUP", d[d.WEBIM_CONNECTION_CLOSED = 39] = "WEBIM_CONNECTION_CLOSED", d[d.WEBIM_CONNECTION_ERROR = 40] = "WEBIM_CONNECTION_ERROR", d[d.MAX_LIMIT = 50] = "MAX_LIMIT", d[d.MESSAGE_NOT_FOUND = 51] = "MESSAGE_NOT_FOUND", d[d.NO_PERMISSION = 52] = "NO_PERMISSION", d[d.OPERATION_UNSUPPORTED = 53] = "OPERATION_UNSUPPORTED", d[d.OPERATION_NOT_ALLOWED = 54] = "OPERATION_NOT_ALLOWED", d[d.WEBIM_TOKEN_EXPIRED = 56] = "WEBIM_TOKEN_EXPIRED", d[d.WEBIM_SERVER_SERVING_DISABLED = 57] = "WEBIM_SERVER_SERVING_DISABLED", d[d.WEBIM_UPLOADFILE_BROWSER_ERROR = 100] = "WEBIM_UPLOADFILE_BROWSER_ERROR", d[d.WEBIM_UPLOADFILE_ERROR = 101] = "WEBIM_UPLOADFILE_ERROR", d[d.WEBIM_UPLOADFILE_NO_LOGIN = 102] = "WEBIM_UPLOADFILE_NO_LOGIN", d[d.WEBIM_UPLOADFILE_NO_FILE = 103] = "WEBIM_UPLOADFILE_NO_FILE", d[d.WEBIM_DOWNLOADFILE_ERROR = 200] = "WEBIM_DOWNLOADFILE_ERROR", d[d.WEBIM_DOWNLOADFILE_NO_LOGIN = 201] = "WEBIM_DOWNLOADFILE_NO_LOGIN", d[d.WEBIM_DOWNLOADFILE_BROWSER_ERROR = 202] = "WEBIM_DOWNLOADFILE_BROWSER_ERROR", d[d.PARSE_FILE_ERROR = 203] = "PARSE_FILE_ERROR", d[d.USER_NOT_FOUND = 204] = "USER_NOT_FOUND", d[d.MESSAGE_PARAMETER_ERROR = 205] = "MESSAGE_PARAMETER_ERROR", d[d.WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE = 206] = "WEBIM_CONNCTION_USER_LOGIN_ANOTHER_DEVICE", d[d.WEBIM_CONNCTION_USER_REMOVED = 207] = "WEBIM_CONNCTION_USER_REMOVED", d[d.WEBIM_CONNCTION_USER_KICKED_BY_CHANGE_PASSWORD = 216] = "WEBIM_CONNCTION_USER_KICKED_BY_CHANGE_PASSWORD", d[d.WEBIM_CONNCTION_USER_KICKED_BY_OTHER_DEVICE = 217] = "WEBIM_CONNCTION_USER_KICKED_BY_OTHER_DEVICE", d[d.USER_MUTED_BY_ADMIN = 219] = "USER_MUTED_BY_ADMIN", d[d.USER_NOT_FRIEND = 221] = "USER_NOT_FRIEND", d[d.WEBIM_MESSAGE_REC_TEXT = 300] = "WEBIM_MESSAGE_REC_TEXT", d[d.WEBIM_MESSAGE_REC_TEXT_ERROR = 301] = "WEBIM_MESSAGE_REC_TEXT_ERROR", d[d.WEBIM_MESSAGE_REC_EMOTION = 302] = "WEBIM_MESSAGE_REC_EMOTION", d[d.WEBIM_MESSAGE_REC_PHOTO = 303] = "WEBIM_MESSAGE_REC_PHOTO", d[d.SERVER_GET_DNSLIST_FAILED = 304] = "SERVER_GET_DNSLIST_FAILED", d[d.WEBIM_MESSAGE_REC_AUDIO_FILE = 305] = "WEBIM_MESSAGE_REC_AUDIO_FILE", d[d.WEBIM_MESSAGE_REC_VEDIO = 306] = "WEBIM_MESSAGE_REC_VEDIO", d[d.WEBIM_MESSAGE_REC_VEDIO_FILE = 307] = "WEBIM_MESSAGE_REC_VEDIO_FILE", d[d.WEBIM_MESSAGE_REC_FILE = 308] = "WEBIM_MESSAGE_REC_FILE", d[d.WEBIM_MESSAGE_SED_TEXT = 309] = "WEBIM_MESSAGE_SED_TEXT", d[d.WEBIM_MESSAGE_SED_EMOTION = 310] = "WEBIM_MESSAGE_SED_EMOTION", d[d.WEBIM_MESSAGE_SED_PHOTO = 311] = "WEBIM_MESSAGE_SED_PHOTO", d[d.WEBIM_MESSAGE_SED_AUDIO = 312] = "WEBIM_MESSAGE_SED_AUDIO", d[d.WEBIM_MESSAGE_SED_AUDIO_FILE = 313] = "WEBIM_MESSAGE_SED_AUDIO_FILE", d[d.WEBIM_MESSAGE_SED_VEDIO = 314] = "WEBIM_MESSAGE_SED_VEDIO", d[d.WEBIM_MESSAGE_SED_VEDIO_FILE = 315] = "WEBIM_MESSAGE_SED_VEDIO_FILE", d[d.WEBIM_MESSAGE_SED_FILE = 316] = "WEBIM_MESSAGE_SED_FILE", d[d.WEBIM_MESSAGE_SED_ERROR = 317] = "WEBIM_MESSAGE_SED_ERROR", d[d.STATUS_INIT = 400] = "STATUS_INIT", d[d.STATUS_DOLOGIN_USERGRID = 401] = "STATUS_DOLOGIN_USERGRID", d[d.STATUS_DOLOGIN_IM = 402] = "STATUS_DOLOGIN_IM", d[d.STATUS_OPENED = 403] = "STATUS_OPENED", d[d.STATUS_CLOSING = 404] = "STATUS_CLOSING", d[d.STATUS_CLOSED = 405] = "STATUS_CLOSED", d[d.STATUS_ERROR = 406] = "STATUS_ERROR", d[d.SERVER_BUSY = 500] = "SERVER_BUSY", d[d.MESSAGE_INCLUDE_ILLEGAL_CONTENT = 501] = "MESSAGE_INCLUDE_ILLEGAL_CONTENT", d[d.MESSAGE_EXTERNAL_LOGIC_BLOCKED = 502] = "MESSAGE_EXTERNAL_LOGIC_BLOCKED", d[d.SERVER_UNKNOWN_ERROR = 503] = "SERVER_UNKNOWN_ERROR", d[d.MESSAGE_RECALL_TIME_LIMIT = 504] = "MESSAGE_RECALL_TIME_LIMIT", d[d.SERVICE_NOT_ENABLED = 505] = "SERVICE_NOT_ENABLED", d[d.SERVICE_NOT_ALLOW_MESSAGING = 506] = "SERVICE_NOT_ALLOW_MESSAGING", d[d.SERVICE_NOT_ALLOW_MESSAGING_MUTE = 507] = "SERVICE_NOT_ALLOW_MESSAGING_MUTE", d[d.MESSAGE_MODERATION_BLOCKED = 508] = "MESSAGE_MODERATION_BLOCKED", d[d.MESSAGE_CURRENT_LIMITING = 509] = "MESSAGE_CURRENT_LIMITING", d[d.MESSAGE_WEBSOCKET_DISCONNECTED = 510] = "MESSAGE_WEBSOCKET_DISCONNECTED", d[d.MESSAGE_SIZE_LIMIT = 511] = "MESSAGE_SIZE_LIMIT", d[d.GROUP_NOT_EXIST = 605] = "GROUP_NOT_EXIST", d[d.GROUP_NOT_JOINED = 602] = "GROUP_NOT_JOINED", d[d.GROUP_MEMBERS_FULL = 606] = "GROUP_MEMBERS_FULL", d[d.PERMISSION_DENIED = 603] = "PERMISSION_DENIED", d[d.WEBIM_LOAD_MSG_ERROR = 604] = "WEBIM_LOAD_MSG_ERROR", d[d.GROUP_ALREADY_JOINED = 601] = "GROUP_ALREADY_JOINED", d[d.GROUP_MEMBERS_LIMIT = 607] = "GROUP_MEMBERS_LIMIT", d[d.GROUP_IS_DISABLED = 608] = "GROUP_IS_DISABLED", d[d.GROUP_MEMBER_ATTRIBUTES_SET_FAILED = 609] = "GROUP_MEMBER_ATTRIBUTES_SET_FAILED", d[d.REST_PARAMS_STATUS = 700] = "REST_PARAMS_STATUS", d[d.CHATROOM_NOT_JOINED = 702] = "CHATROOM_NOT_JOINED", d[d.CHATROOM_MEMBERS_FULL = 704] = "CHATROOM_MEMBERS_FULL", d[d.CHATROOM_NOT_EXIST = 705] = "CHATROOM_NOT_EXIST", d[d.LOCAL_DB_OPERATION_FAILED = 800] = "LOCAL_DB_OPERATION_FAILED", d[d.SDK_RUNTIME_ERROR = 999] = "SDK_RUNTIME_ERROR", d[d.PRESENCE_PARAM_EXCEED = 1100] = "PRESENCE_PARAM_EXCEED", d[d.REACTION_ALREADY_ADDED = 1101] = "REACTION_ALREADY_ADDED", d[d.REACTION_CREATING = 1102] = "REACTION_CREATING", d[d.REACTION_OPERATION_IS_ILLEGAL = 1103] = "REACTION_OPERATION_IS_ILLEGAL", d[d.TRANSLATION_NOT_VALID = 1200] = "TRANSLATION_NOT_VALID", d[d.TRANSLATION_TEXT_TOO_LONG = 1201] = "TRANSLATION_TEXT_TOO_LONG", d[d.TRANSLATION_FAILED = 1204] = "TRANSLATION_FAILED", d[d.THREAD_NOT_EXIST = 1300] = "THREAD_NOT_EXIST", d[d.THREAD_ALREADY_EXIST = 1301] = "THREAD_ALREADY_EXIST", d[d.MODIFY_MESSAGE_NOT_EXIST = 1302] = "MODIFY_MESSAGE_NOT_EXIST", d[d.MODIFY_MESSAGE_FORMAT_ERROR = 1303] = "MODIFY_MESSAGE_FORMAT_ERROR", d[d.MODIFY_MESSAGE_FAILED = 1304] = "MODIFY_MESSAGE_FAILED", d[d.CONVERSATION_NOT_EXIST = 1400] = "CONVERSATION_NOT_EXIST";
        }(c || (c = {}));
      }, 4998: function(l, v, s) {
        var c;
        s.d(v, { a: function() {
          return c;
        } }), s(7252), function(d) {
          d[d.SYNC_INIT = 0] = "SYNC_INIT", d[d.SYNC_START = 1] = "SYNC_START", d[d.SYNC_FINISH = 2] = "SYNC_FINISH";
        }(c || (c = {}));
      }, 9937: function(l, v, s) {
        var c;
        s.d(v, { Z: function() {
          return c;
        } }), function(d) {
          d[d.mark_0 = 0] = "mark_0", d[d.mark_1 = 1] = "mark_1", d[d.mark_2 = 2] = "mark_2", d[d.mark_3 = 3] = "mark_3", d[d.mark_4 = 4] = "mark_4", d[d.mark_5 = 5] = "mark_5", d[d.mark_6 = 6] = "mark_6", d[d.mark_7 = 7] = "mark_7", d[d.mark_8 = 8] = "mark_8", d[d.mark_9 = 9] = "mark_9", d[d.mark_10 = 10] = "mark_10", d[d.mark_11 = 11] = "mark_11", d[d.mark_12 = 12] = "mark_12", d[d.mark_13 = 13] = "mark_13", d[d.mark_14 = 14] = "mark_14", d[d.mark_15 = 15] = "mark_15", d[d.mark_16 = 16] = "mark_16", d[d.mark_17 = 17] = "mark_17", d[d.mark_18 = 18] = "mark_18", d[d.mark_19 = 19] = "mark_19";
        }(c || (c = {}));
      }, 4024: function(l, v, s) {
        s.d(v, { PU: function() {
          return j;
        }, iw: function() {
          return J;
        }, hj: function() {
          return G;
        }, LR: function() {
          return pe;
        }, cT: function() {
          return he;
        }, P6: function() {
          return Le;
        } }), s(9601), s(1539), s(8674), s(3710), s(7941), s(6699), s(7042), s(2772), s(9714), s(9653), s(6992), s(8783), s(3948), s(285), s(1637), s(8309), s(4986), s(2222), s(4916), s(2564);
        var c = s(5531), d = (s(2023), function() {
          return d = Object.assign || function(Te) {
            for (var K, Oe = 1, Pe = arguments.length; Oe < Pe; Oe++) for (var xe in K = arguments[Oe]) Object.prototype.hasOwnProperty.call(K, xe) && (Te[xe] = K[xe]);
            return Te;
          }, d.apply(this, arguments);
        }), p = function(Te, K, Oe, Pe) {
          var xe, be, $e, Be, Ke, Ze, at, pt, It, Rt, gt, it, Tt, Ut, st, Ot, kt, wt, Et, ut, St, Ft, Ht, zt, ze = Te.response;
          ze && typeof ze == "string" && (ze = JSON.parse(ze));
          var Ne = Te.status, le = { elapse: Pe, httpCode: Ne, errDesc: ze == null ? void 0 : ze.error_description };
          if (Ne === 400) {
            if (ze.error_code === 40002) return void K({ type: c.E.THREAD_ALREADY_EXIST, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
            if (ze.error_code === 40009) return void K({ type: c.E.OPERATION_UNSUPPORTED, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
            if (ze.error_code === 60005) return void K({ type: c.E.GROUP_MEMBER_ATTRIBUTES_SET_FAILED, message: (ze == null ? void 0 : ze.desc) || (ze == null ? void 0 : ze.error_description), extraInfo: le });
            if (ze.error_code === 60010) return void (ze != null && ze.error_description.includes("exceeds chatgroup user metadata single value limit") ? K({ type: c.E.MAX_LIMIT, message: (ze == null ? void 0 : ze.desc) || ze.error_description, extraInfo: le }) : K({ type: c.E.NO_PERMISSION, message: (ze == null ? void 0 : ze.desc) || ze.error_description, extraInfo: le }));
            if (ze.error_code === 60011) return void K({ type: c.E.CHATROOM_NOT_JOINED, message: ze == null ? void 0 : ze.desc, extraInfo: le });
            if (ze.error_code === 14403) return void K({ type: c.E.WEBIM_UPLOADFILE_ERROR, message: ze == null ? void 0 : ze.error_description, data: ze, extraInfo: le });
            if (ze.error_code === 60006 || ze.error_code === 60007 || ze.error_code === 60009 || ze.error_code === 60012) return void K({ type: c.E.MAX_LIMIT, message: (ze == null ? void 0 : ze.desc) || (ze == null ? void 0 : ze.error_description), extraInfo: le });
            if (ze.error_code === 91104) return void K({ type: c.E.NO_PERMISSION, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
            if (!((xe = ze.error_description) === null || xe === void 0) && xe.includes("are not members of this group")) return !((be = Te.responseURL) === null || be === void 0) && be.includes("chatgroups") ? K({ type: c.E.GROUP_NOT_JOINED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : K({ type: c.E.CHATROOM_NOT_JOINED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }), void Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: ze == null ? void 0 : ze.error_description, data: Te.responseText, extraInfo: le });
            if ((ze == null ? void 0 : ze.result) === "the app not open presence") return void K({ type: c.E.SERVICE_NOT_ENABLED, message: ze == null ? void 0 : ze.result, extraInfo: le });
            if (ze != null && ze.error_description.includes("remark length must less")) return void K({ type: c.E.MAX_LIMIT, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
            switch (ze == null ? void 0 : ze.error_description) {
              case "the user is already operation this message":
                K({ type: c.E.REACTION_ALREADY_ADDED, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "The quantity has exceeded the limit!":
                K({ type: c.E.MAX_LIMIT, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "The user not in this group!":
                K({ type: c.E.GROUP_NOT_JOINED, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "the user operation is illegal!":
                K({ type: c.E.REACTION_OPERATION_IS_ILLEGAL, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "this appKey is not open reaction service!":
              case "this appKey not open message roaming":
                K({ type: c.E.SERVICE_NOT_ENABLED, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "this message is creating reaction, please try again.":
                K({ type: c.E.REACTION_CREATING, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "groupId can not be null!":
                K({ type: c.E.GROUP_NOT_EXIST, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "The input text is too long.":
                K({ type: c.E.TRANSLATION_TEXT_TOO_LONG, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "The target language is not valid.":
                K({ type: c.E.TRANSLATION_NOT_VALID, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "report failed, get message by id failed":
                K({ type: c.E.MESSAGE_NOT_FOUND, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "ext is too big ":
                K({ type: c.E.PRESENCE_PARAM_EXCEED, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "Request body not readable.Please check content type is correct!":
              case "param mark must be not empty, please check!":
              case "param mark illegal, please check it!":
              case "param pin_msg_id illegal, please check it!":
                K({ type: c.E.REQUEST_PARAMETER_ERROR, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              case "updateRemark | they are not friends, please add as a friend first.":
                K({ type: c.E.USER_NOT_FRIEND, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
                break;
              default:
                K({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: ze == null ? void 0 : ze.error_description, data: Te.responseText, extraInfo: le }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, message: ze == null ? void 0 : ze.error_description, data: Te.responseText, extraInfo: le });
            }
          } else if (Ne === 401) ze.error_code === 40001 || ze.error_code === 60001 || ze.error_description === "Unable to authenticate (OAuth)" ? K({ type: c.E.NO_PERMISSION, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : (Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: Te.responseText, extraInfo: le }), K({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: Te.responseText, extraInfo: le }));
          else if (Ne === 403) ze.error_code === 4e4 || ze.error_code === 60004 || ze.error_code === 15002 ? K({ type: c.E.SERVICE_NOT_ENABLED, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 40003 || ze.error_code === 40004 ? K({ type: c.E.THREAD_ALREADY_EXIST, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 40005 || ze.error_code === 40007 || ze.error_code === 91002 ? K({ type: c.E.MAX_LIMIT, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 60002 ? K({ type: c.E.PERMISSION_DENIED, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 91101 ? K({ type: c.E.MAX_LIMIT, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 91102 && K({ type: c.E.REQUEST_PARAMETER_ERROR, message: ze.error_description, extraInfo: le }), ze.error_description === "group member list is full!" ? !(($e = Te.responseURL) === null || $e === void 0) && $e.includes("chatgroups") ? K({ type: c.E.GROUP_MEMBERS_FULL, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : K({ type: c.E.CHATROOM_MEMBERS_FULL, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : !((Be = ze.error_description) === null || Be === void 0) && Be.includes(ze.error_description.includes("already in group")) ? !((Ke = Te.responseURL) === null || Ke === void 0) && Ke.includes("chatgroups") && K({ type: c.E.GROUP_ALREADY_JOINED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : !((Ze = ze.error_description) === null || Ze === void 0) && Ze.includes("are not members of this group") ? !((at = Te.responseURL) === null || at === void 0) && at.includes("chatgroups") ? K({ type: c.E.GROUP_NOT_JOINED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : K({ type: c.E.CHATROOM_NOT_JOINED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : !((pt = ze.error_description) === null || pt === void 0) && pt.includes("service not open!") || !((It = ze.error_description) === null || It === void 0) && It.includes("message report not open") || !((Rt = ze.error_description) === null || Rt === void 0) && Rt.includes("messageroaming function not open") ? K({ type: c.E.SERVICE_NOT_ENABLED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : !((gt = ze.error_description) === null || gt === void 0) && gt.includes("members size is greater than max user size !") ? K({ type: c.E.GROUP_MEMBERS_LIMIT, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : !((it = ze.error_description) === null || it === void 0) && it.includes("can not operate this group, reason: group is disabled") ? K({ type: c.E.GROUP_IS_DISABLED, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : !((Tt = ze.error_description) === null || Tt === void 0) && Tt.includes("Invitee's contact max count") || !((Ut = ze.error_description) === null || Ut === void 0) && Ut.includes("Inviter's contact max count") ? K({ type: c.E.MAX_LIMIT, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : K({ type: c.E.PERMISSION_DENIED, data: Te.response || Te.responseText, message: "permission denied", extraInfo: d(d({}, le), { errDesc: "permission denied" }) }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: Te.responseText, extraInfo: le });
          else if (Ne === 404) ze.error_code === 40011 ? K({ type: c.E.THREAD_NOT_EXIST, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 40012 ? K({ type: c.E.NO_PERMISSION, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 60003 || ze.error_code === 20004 ? K({ type: c.E.GROUP_NOT_JOINED, message: ze == null ? void 0 : ze.error_description, extraInfo: le }) : ze.error_code === 91001 && K({ type: c.E.CONVERSATION_NOT_EXIST, message: ze == null ? void 0 : ze.error_description, extraInfo: le }), !((st = ze.error_description) === null || st === void 0) && st.includes("do not find this group") || !((Ot = ze.error_description) === null || Ot === void 0) && Ot.includes("does not exist") ? !((kt = Te.responseURL) === null || kt === void 0) && kt.includes("chatgroups") ? K({ type: c.E.GROUP_NOT_EXIST, data: Te.response || Te.responseText, message: "The chat room dose not exist.", extraInfo: d(d({}, le), { errDesc: "The chat room dose not exist." }) }) : K({ type: c.E.CHATROOM_NOT_EXIST, data: Te.response || Te.responseText, message: "The chat room dose not exist.", extraInfo: d(d({}, le), { errDesc: "The chat room dose not exist." }) }) : !((wt = ze.error_description) === null || wt === void 0) && wt.includes("username") && (!((Et = ze.error_description) === null || Et === void 0) && Et.includes("doesn't exist!'")) || !((ut = ze.error_description) === null || ut === void 0) && ut.includes("user not found") || !((St = ze.error_description) === null || St === void 0) && St.includes("Service resource not found") && (ze == null ? void 0 : ze.exception) === "UserNotFoundException" ? K({ type: c.E.USER_NOT_FOUND, data: Te.response || Te.responseText, message: ze.error_description, extraInfo: le }) : ze.error_description.includes("user session pin message not exist") ? K({ type: c.E.MESSAGE_NOT_FOUND, message: ze.error_description, extraInfo: le }) : K({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.response || Te.responseText, message: Te.responseText, extraInfo: le }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.response || Te.responseText, message: Te.responseText, extraInfo: le });
          else if (Ne === 406) ze.error_code === 90004 && K({ type: c.E.OPERATION_NOT_ALLOWED, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
          else if (Ne === 429 || Ne === 503) {
            if (!((Ft = ze.error_description) === null || Ft === void 0) && Ft.includes("The request has reached the maximum limit")) return void K({ type: c.E.MAX_LIMIT, message: Te.responseText, extraInfo: le });
            if (!((Ht = ze.error_description) === null || Ht === void 0) && Ht.includes("upload client logs reached limit")) return void K({ type: c.E.MAX_LIMIT, message: Te.responseText });
            K({ type: c.E.SERVER_BUSY, data: Te.response || Te.responseText, message: "Server is busy.", extraInfo: d(d({}, le), { errDesc: "Server is busy." }) }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: "Server is busy.", extraInfo: d(d({}, le), { errDesc: "Server is busy." }) });
          } else if (Ne === 500) {
            if (ze.error_code === 40006 || ze.error_code === 40008 || ze.error_code === 40010) return void K({ type: c.E.SERVER_UNKNOWN_ERROR, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
            if (ze.error_code === 90005 || ze.error_code === 99999) return void K({ type: c.E.REQUEST_UNKNOWN, message: ze == null ? void 0 : ze.error_description, extraInfo: le });
            if (!((zt = ze.error_description) === null || zt === void 0) && zt.includes("translte failed!")) return void K({ type: c.E.TRANSLATION_FAILED, message: Te.responseText, extraInfo: le });
            K({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: "", extraInfo: le }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: "", extraInfo: le });
          } else K({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: Te.responseText, extraInfo: d(d({}, le), { errDesc: "ajax error" }) }), Oe({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Te.responseText, message: Te.responseText, extraInfo: d(d({}, le), { errDesc: "ajax error" }) });
        }, m = s(1595), E = s(2071), y = s(7360), g = 5242880, C = 5242880, O = { size: 0 }, N = (s(2526), s(1817), s(2165), s(5827), s(4553), s(561), function() {
          return N = Object.assign || function(Te) {
            for (var K, Oe = 1, Pe = arguments.length; Oe < Pe; Oe++) for (var xe in K = arguments[Oe]) Object.prototype.hasOwnProperty.call(K, xe) && (Te[xe] = K[xe]);
            return Te;
          }, N.apply(this, arguments);
        });
        function w() {
          var Te = this.context, K = Te.orgName, Oe = Te.appName, Pe = Te.accessToken, xe = { url: "".concat(this.apiUrl, "/").concat(K, "/").concat(Oe, "/sdk/chatfiles/part-upload"), dataType: "json", type: "POST", headers: { Authorization: "Bearer " + Pe } };
          return y.kg.debug("Call multipartInit"), G.call(this, xe, m.fI.SDK_INTERNAL).then(function(be) {
            var $e = be.entities[0];
            return { data: { fileMaxSize: $e.file_upper_limit, partMinSize: $e.part_lower_limit, uuid: $e.uuid }, extraInfo: be.extraInfo, type: be.type };
          });
        }
        function _(Te) {
          var K = this;
          return new Promise(function(Oe, Pe) {
            var xe, be, $e = (/* @__PURE__ */ new Date()).getTime(), Be = K.context, Ke = Be.orgName, Ze = Be.appName, at = Be.accessToken, pt = Te.uuid, It = Te.partNumber, Rt = Te.part, gt = Te.onProgress, it = "".concat(K.apiUrl, "/").concat(Ke, "/").concat(Ze, "/sdk/chatfiles/part-upload/").concat(pt), Tt = new XMLHttpRequest();
            y.kg.debug("Call multipartUpload"), Tt.upload && ((be = (xe = Tt.upload).addEventListener) === null || be === void 0 || be.call(xe, "progress", function(st) {
              gt == null || gt(st);
            }, !1)), Tt.addEventListener("abort", function() {
              Pe({ type: c.E.REQUEST_ABORT, message: "Request Abort", errorType: "onabort", xhr: Tt, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - $e, httpCode: Tt.status || -1, errDesc: "Request Abort", url: it } });
            }, !1), Tt.addEventListener("error", function() {
              Pe({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: Tt, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - $e, httpCode: Tt.status || -1, errDesc: "request error", url: it } });
            }, !1), Tt.addEventListener("load", function() {
              try {
                var st = JSON.parse(Tt.responseText);
                if (Tt.status !== 200) return Pe({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: st, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - $e, httpCode: Tt.status || -1, errDesc: "part upload failed", url: it } }), !1;
                try {
                  Oe(N(N({}, st), { extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - $e, httpCode: Tt.status || -1, url: it } }));
                } catch (Ot) {
                  Pe({ type: c.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, data: Ot, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - $e, httpCode: Tt.status || -1, errDesc: "part upload failed", url: it } });
                }
              } catch {
                Pe({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: Tt.responseText, extraInfo: { elapse: (/* @__PURE__ */ new Date()).getTime() - $e, httpCode: Tt.status || -1, errDesc: "part upload failed", url: it } });
              }
            }, !1);
            var Ut = new FormData();
            Ut.append("part_file", Rt), Ut.append("part_number", It), Tt.open("PUT", it), Tt.setRequestHeader("restrict-access", "true"), Tt.setRequestHeader("Accept", "*/*"), Tt.setRequestHeader("Authorization", "Bearer " + at), Tt.send(Ut);
          });
        }
        function I(Te) {
          var K = Te.uuid, Oe = Te.thumbnailHeight, Pe = Te.thumbnailWidth, xe = this.context, be = xe.orgName, $e = xe.appName, Be = xe.accessToken, Ke = "".concat(this.apiUrl, "/").concat(be, "/").concat($e, "/sdk/chatfiles/part-upload/").concat(K, "?restrict-access=true");
          Pe && (Ke += "&thumbnail-width=".concat(Pe)), Oe && (Ke += "&thumbnail-height=".concat(Oe));
          var Ze = { url: Ke, dataType: "json", type: "POST", headers: { Authorization: "Bearer " + Be } };
          return y.kg.debug("Call multipartComplete"), G.call(this, Ze, m.fI.SDK_INTERNAL);
        }
        function k(Te) {
          var K = Te.uuid, Oe = this.context, Pe = Oe.orgName, xe = Oe.appName, be = Oe.accessToken, $e = { url: "".concat(this.apiUrl, "/").concat(Pe, "/").concat(xe, "/sdk/chatfiles/part-upload/").concat(K), dataType: "json", type: "DELETE", headers: { Authorization: "Bearer " + be } };
          return y.kg.debug("Call multipartAbort"), G.call(this, $e, m.fI.SDK_INTERNAL);
        }
        var H = function(Te, K, Oe, Pe) {
          return new (Oe || (Oe = Promise))(function(xe, be) {
            function $e(Ze) {
              try {
                Ke(Pe.next(Ze));
              } catch (at) {
                be(at);
              }
            }
            function Be(Ze) {
              try {
                Ke(Pe.throw(Ze));
              } catch (at) {
                be(at);
              }
            }
            function Ke(Ze) {
              var at;
              Ze.done ? xe(Ze.value) : (at = Ze.value, at instanceof Oe ? at : new Oe(function(pt) {
                pt(at);
              })).then($e, Be);
            }
            Ke((Pe = Pe.apply(Te, [])).next());
          });
        }, S = function(Te, K) {
          var Oe, Pe, xe, be, $e = { label: 0, sent: function() {
            if (1 & xe[0]) throw xe[1];
            return xe[1];
          }, trys: [], ops: [] };
          return be = { next: Be(0), throw: Be(1), return: Be(2) }, typeof Symbol == "function" && (be[Symbol.iterator] = function() {
            return this;
          }), be;
          function Be(Ke) {
            return function(Ze) {
              return function(at) {
                if (Oe) throw new TypeError("Generator is already executing.");
                for (; $e; ) try {
                  if (Oe = 1, Pe && (xe = 2 & at[0] ? Pe.return : at[0] ? Pe.throw || ((xe = Pe.return) && xe.call(Pe), 0) : Pe.next) && !(xe = xe.call(Pe, at[1])).done) return xe;
                  switch (Pe = 0, xe && (at = [2 & at[0], xe.value]), at[0]) {
                    case 0:
                    case 1:
                      xe = at;
                      break;
                    case 4:
                      return $e.label++, { value: at[1], done: !1 };
                    case 5:
                      $e.label++, Pe = at[1], at = [0];
                      continue;
                    case 7:
                      at = $e.ops.pop(), $e.trys.pop();
                      continue;
                    default:
                      if (!((xe = (xe = $e.trys).length > 0 && xe[xe.length - 1]) || at[0] !== 6 && at[0] !== 2)) {
                        $e = 0;
                        continue;
                      }
                      if (at[0] === 3 && (!xe || at[1] > xe[0] && at[1] < xe[3])) {
                        $e.label = at[1];
                        break;
                      }
                      if (at[0] === 6 && $e.label < xe[1]) {
                        $e.label = xe[1], xe = at;
                        break;
                      }
                      if (xe && $e.label < xe[2]) {
                        $e.label = xe[2], $e.ops.push(at);
                        break;
                      }
                      xe[2] && $e.ops.pop(), $e.trys.pop();
                      continue;
                  }
                  at = K.call(Te, $e);
                } catch (pt) {
                  at = [6, pt], Pe = 0;
                } finally {
                  Oe = xe = 0;
                }
                if (5 & at[0]) throw at[1];
                return { value: at[0] ? at[1] : void 0, done: !0 };
              }([Ke, Ze]);
            };
          }
        }, B = function() {
          function Te(K, Oe) {
            var Pe = this;
            this.handleUploadProgress = function(xe, be) {
              var $e, Be;
              if (xe.total) {
                Pe.progressArr[be] = xe.loaded;
                var Ke = Pe.progressArr.reduce(function(Ze, at) {
                  return Ze + at;
                }, 0);
                (Be = ($e = Pe.options).onFileUploadProgress) === null || Be === void 0 || Be.call($e, { isTrusted: xe.isTrusted, type: xe.type, loaded: Ke > Pe.file.size ? Pe.file.size : Ke, total: Pe.file.size, lengthComputable: xe.lengthComputable });
              }
            }, this.uuid = "", this.pool = [], this.progressArr = [], this.connection = K, this.options = Oe, this.partSize = g, this.file = Oe.file, this.init(), this.rpt = this.connection.dataReport.geOperateFun({ operationName: m.fI.REST_UPLOAD_FILE_IN_PARTS });
          }
          return Te.prototype.init = function() {
            var K, Oe, Pe, xe;
            return H(this, void 0, void 0, function() {
              var be, $e, Be, Ke, Ze, at, pt, It, Rt, gt, it, Tt, Ut, st, Ot;
              return S(this, function(kt) {
                switch (kt.label) {
                  case 0:
                    return kt.trys.push([0, 4, , 6]), [4, w.call(this.connection)];
                  case 1:
                    return be = kt.sent(), $e = be.data || {}, Be = $e.fileMaxSize, Ke = Be === void 0 ? 0 : Be, Ze = $e.partMinSize, at = Ze === void 0 ? g : Ze, pt = $e.uuid, It = pt === void 0 ? "" : pt, Rt = be.extraInfo, Tt = Rt.elapse, Ut = Rt.httpCode, Ot = Rt.url, this.partSize = at, this.uuid = It, O.size = at, y.kg.debug("multipartInit success", "uuid: ".concat(It), "fileMaxSize: ".concat(Ke), "partMinSize: ".concat(at)), this.file.size > Ke ? [4, this.multipartAbort()] : [3, 3];
                  case 2:
                    return kt.sent(), (Oe = (K = this.options).onFileUploadError) === null || Oe === void 0 || Oe.call(K, { code: c.E.WEBIM_UPLOADFILE_ERROR, message: "The file size exceeds the maximum limit" }), [2];
                  case 3:
                    return this.rpt({ data: { requestUrl: Ot, requestName: m.c.REST_INIT_UPLOAD_TASK_IN_PARTS, requestElapse: Tt, requestMethod: "POST", isSuccess: 1, code: Ut } }), this.upload(), [3, 6];
                  case 4:
                    return gt = kt.sent(), it = (gt == null ? void 0 : gt.extraInfo) || {}, Tt = it.elapse, Ut = it.httpCode, st = it.errDesc, Ot = it.url, this.rpt({ data: { requestUrl: Ot, requestName: m.c.REST_INIT_UPLOAD_TASK_IN_PARTS, requestElapse: Tt, requestMethod: "POST", isSuccess: 0, codeDesc: st, code: Ut } }), [4, this.multipartAbort()];
                  case 5:
                    return kt.sent(), (xe = (Pe = this.options) === null || Pe === void 0 ? void 0 : Pe.onInitFail) === null || xe === void 0 || xe.call(Pe), [3, 6];
                  case 6:
                    return [2];
                }
              });
            });
          }, Te.prototype.upload = function() {
            var K, Oe, Pe;
            return H(this, void 0, void 0, function() {
              var xe, be, $e, Be, Ke, Ze, at = this;
              return S(this, function(pt) {
                switch (pt.label) {
                  case 0:
                    new FileReader().readAsArrayBuffer(this.file), xe = this.file.size, be = Math.ceil(xe / this.partSize), pt.label = 1;
                  case 1:
                    pt.trys.push([1, 7, , 9]), $e = function(It) {
                      var Rt, gt, it, Tt;
                      return S(this, function(Ut) {
                        switch (Ut.label) {
                          case 0:
                            return Rt = It * Be.partSize, gt = Math.min(xe, Rt + Be.partSize), it = (K = Be.file) === null || K === void 0 ? void 0 : K.slice(Rt, gt), (Tt = _.call(Be.connection, { uuid: Be.uuid, partNumber: "".concat(It + 1), part: it, onProgress: function(st) {
                              at.handleUploadProgress(st, It);
                            } })).then(function(st) {
                              var Ot = (st == null ? void 0 : st.extraInfo) || {}, kt = Ot.elapse, wt = Ot.httpCode, Et = Ot.url;
                              at.rpt({ data: { requestUrl: Et, requestName: m.c.REST_UPLOAD_PART, requestElapse: kt, isSuccess: 1, requestMethod: "PUT", code: wt } }), at.handleTask(Tt);
                            }), Tt.catch(function(st) {
                              var Ot = (st == null ? void 0 : st.extraInfo) || {}, kt = Ot.elapse, wt = Ot.httpCode, Et = Ot.url, ut = Ot.errDesc;
                              at.rpt({ data: { requestUrl: Et, requestName: m.c.REST_UPLOAD_PART, requestElapse: kt, isSuccess: 0, requestMethod: "PUT", code: wt, codeDesc: ut } }), delete st.extraInfo;
                            }), Be.pool.push(Tt), Be.pool.length !== 4 ? [3, 2] : [4, Promise.race(Be.pool)];
                          case 1:
                            Ut.sent(), Ut.label = 2;
                          case 2:
                            return [2];
                        }
                      });
                    }, Be = this, Ke = 0, pt.label = 2;
                  case 2:
                    return Ke < be ? [5, $e(Ke)] : [3, 5];
                  case 3:
                    pt.sent(), pt.label = 4;
                  case 4:
                    return Ke++, [3, 2];
                  case 5:
                    return [4, Promise.all(this.pool)];
                  case 6:
                    return pt.sent(), this.multipartComplete(), [3, 9];
                  case 7:
                    return Ze = pt.sent(), [4, this.multipartAbort()];
                  case 8:
                    return pt.sent(), this.rpt({ data: { isLastApi: 1, isSuccess: 0 } }), (Pe = (Oe = this.options).onFileUploadError) === null || Pe === void 0 || Pe.call(Oe, Ze), [3, 9];
                  case 9:
                    return [2];
                }
              });
            });
          }, Te.prototype.multipartComplete = function() {
            var K, Oe, Pe, xe;
            return H(this, void 0, void 0, function() {
              var be, $e, Be, Ke, Ze, at, pt, It, Rt, gt, it;
              return S(this, function(Tt) {
                switch (Tt.label) {
                  case 0:
                    return Tt.trys.push([0, 2, , 3]), be = this.options.thumbnailInfo || {}, $e = be.width, Be = be.height, [4, I.call(this.connection, { uuid: this.uuid, thumbnailHeight: Be, thumbnailWidth: $e })];
                  case 1:
                    return Ke = Tt.sent(), Ze = (Ke == null ? void 0 : Ke.extraInfo) || {}, It = Ze.elapse, Rt = Ze.httpCode, it = Ze.url, this.rpt({ data: { requestUrl: it, requestName: m.c.REST_COMPLETE_UPLOAD_PART, requestElapse: It, requestMethod: "POST", isSuccess: 1, code: Rt } }), this.rpt({ data: { isLastApi: 1, isSuccess: 1 } }), (Oe = (K = this.options).onFileUploadComplete) === null || Oe === void 0 || Oe.call(K, Ke), [3, 3];
                  case 2:
                    return at = Tt.sent(), pt = (at == null ? void 0 : at.extraInfo) || {}, It = pt.elapse, Rt = pt.httpCode, gt = pt.errDesc, it = pt.url, this.rpt({ data: { requestUrl: it, requestName: m.c.REST_COMPLETE_UPLOAD_PART, requestElapse: It, requestMethod: "POST", isSuccess: 0, codeDesc: gt, code: Rt } }), this.rpt({ data: { isLastApi: 1, isSuccess: 0 } }), (xe = (Pe = this.options).onFileUploadError) === null || xe === void 0 || xe.call(Pe, at), [3, 3];
                  case 3:
                    return [2];
                }
              });
            });
          }, Te.prototype.multipartAbort = function() {
            return H(this, void 0, void 0, function() {
              var K, Oe, Pe, xe, be, $e, Be, Ke;
              return S(this, function(Ze) {
                switch (Ze.label) {
                  case 0:
                    if (!this.uuid) return [2];
                    Ze.label = 1;
                  case 1:
                    return Ze.trys.push([1, 3, , 4]), [4, k.call(this.connection, { uuid: this.uuid })];
                  case 2:
                    return K = Ze.sent(), Oe = (K == null ? void 0 : K.extraInfo) || {}, be = Oe.elapse, $e = Oe.httpCode, Ke = Oe.url, this.rpt({ data: { requestUrl: Ke, requestName: m.c.REST_ABORT_UPLOAD_PART, requestElapse: be, requestMethod: "DELETE", isSuccess: 1, code: $e } }), [3, 4];
                  case 3:
                    return Pe = Ze.sent(), xe = (Pe == null ? void 0 : Pe.extraInfo) || {}, be = xe.elapse, $e = xe.httpCode, Be = xe.errDesc, Ke = xe.url, this.rpt({ data: { requestUrl: Ke, requestName: m.c.REST_ABORT_UPLOAD_PART, requestElapse: be, requestMethod: "DELETE", isSuccess: 0, codeDesc: Be, code: $e } }), [3, 4];
                  case 4:
                    return [2];
                }
              });
            });
          }, Te.prototype.handleTask = function(K) {
            var Oe = this.pool.findIndex(function(Pe) {
              return Pe === K;
            });
            this.pool.splice(Oe, 1);
          }, Te;
        }(), D = function(Te) {
          var K, Oe, Pe = this, xe = (/* @__PURE__ */ new Date()).getTime(), be = Te.apiUrl, $e = Te.orgName, Be = Te.appName, Ke = Te.operateName, Ze = Te.accessToken, at = Te.uploadUrl || "".concat(be, "/").concat($e, "/").concat(Be, "/chatfiles"), pt = function(gt) {
            var it = (/* @__PURE__ */ new Date()).getTime() - xe;
            Pe.dataReport && Ke && [m.fI.UPLOAD_MSG_ATTACH, m.fI.UPLOAD_CHATROOM_FILE, m.fI.UPLOAD_GROUP_FILE].includes(Ke) && Pe.dataReport.geOperateFun({ operationName: Ke })({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "POST", requestName: Ke, requestElapse: it, requestUrl: at, code: (It == null ? void 0 : It.status) || 0, codeDesc: "upload file error" } }), Te.onFileUploadError && Te.onFileUploadError(gt);
          }, It = new XMLHttpRequest();
          It.upload && ((Oe = (K = It.upload).addEventListener) === null || Oe === void 0 || Oe.call(K, "progress", Te.onFileUploadProgress || j, !1)), It.addEventListener("abort", Te.onFileUploadCanceled || j, !1), It.addEventListener("error", function(gt) {
            pt({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: It });
          }, !1), It.addEventListener("load", function(gt) {
            try {
              var it = JSON.parse(It.responseText);
              if (It.status === 400) return pt({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: it }), !1;
              try {
                (function(Tt) {
                  var Ut = (/* @__PURE__ */ new Date()).getTime() - xe;
                  Pe.dataReport && Ke && [m.fI.UPLOAD_MSG_ATTACH, m.fI.UPLOAD_CHATROOM_FILE, m.fI.UPLOAD_GROUP_FILE].includes(Ke) && Pe.dataReport.geOperateFun({ operationName: Ke })({ isEndApi: !0, data: { isSuccess: Tt != null && Tt.error ? 0 : 1, requestMethod: "POST", requestName: Ke, requestElapse: Ut, requestUrl: at, code: It.status, codeDesc: (Tt == null ? void 0 : Tt.error_description) || "" } }), Te.onFileUploadComplete && Te.onFileUploadComplete(Tt);
                })(it);
              } catch (Tt) {
                pt({ type: c.E.WEBIM_CONNCTION_CALLBACK_INNER_ERROR, data: Tt });
              }
            } catch {
              pt({ type: c.E.WEBIM_UPLOADFILE_ERROR, data: It.responseText });
            }
          }, !1), It.open("POST", at), It.setRequestHeader("restrict-access", "true"), It.setRequestHeader("Accept", "*/*"), It.setRequestHeader("Authorization", "Bearer " + Ze);
          var Rt = new FormData();
          Rt.append("file", Te.file.data), Te.thumbnailWidth && Rt.append("thumbnail-width", Te.thumbnailWidth + ""), Te.thumbnailHeight && Rt.append("thumbnail-height", Te.thumbnailHeight + ""), It.send(Rt);
        }, F = function() {
          return F = Object.assign || function(Te) {
            for (var K, Oe = 1, Pe = arguments.length; Oe < Pe; Oe++) for (var xe in K = arguments[Oe]) Object.prototype.hasOwnProperty.call(K, xe) && (Te[xe] = K[xe]);
            return Te;
          }, F.apply(this, arguments);
        }, j = function() {
        };
        function G(Te, K) {
          var Oe, Pe = this;
          return ee().platform === J.WEB ? new Promise(function(xe, be) {
            var $e = Te.dataType || "text", Be = Te.success || j, Ke = Te.error || j, Ze = new XMLHttpRequest();
            Ze.ontimeout = function() {
              be({ type: c.E.REQUEST_TIMEOUT, message: "Request Timeout", errorType: "timeout_error", xhr: Ze });
            }, Ze.onerror = function() {
              be({ type: c.E.REQUEST_UNKNOWN, message: "Request Unknow Error", errorType: "onerror", xhr: Ze });
            }, Ze.onabort = function() {
              be({ type: c.E.REQUEST_ABORT, message: "Request Abort", errorType: "onabort", xhr: Ze });
            }, Ze.onreadystatechange = function() {
              if (Ze.readyState === 4) {
                var Tt = (/* @__PURE__ */ new Date()).getTime() - Oe, Ut = Ze.status || 0, st = { elapse: Tt, httpCode: Ut };
                if (Ut === 200) {
                  Le.ajaxUnconventionalErrorTimes = 0;
                  try {
                    switch ($e) {
                      case "text":
                        return Be(Ze.responseText), void xe(Ze.responseText);
                      case "json":
                        var Ot = JSON.parse(Ze.responseText);
                        return Ot.extraInfo = st, Be(Ot), void xe(Ot);
                      case "xml":
                        return Ze.responseXML && Ze.responseXML.documentElement ? (Be(Ze.responseXML.documentElement), void xe(Ze.responseXML.documentElement)) : (Ke({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Ze.responseText, message: "XHR.responseXML is null or XHR.responseXML.documentElement is null" }), void be({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Ze.responseText, message: "XHR.responseXML is null or XHR.responseXML.documentElement is null" }));
                      default:
                        Ke({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Ze.responseText, message: "Invalid dataType" }), be({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Ze.responseText, message: "Invalid dataType" });
                    }
                    return xe(Ze.response || Ze.responseText), void Be(Ze.response || Ze.responseText, Ze);
                  } catch (kt) {
                    be(kt);
                  }
                  return;
                }
                [400, 401, 403, 404, 429, 500, 503].includes(Ut) || (y.kg.debug("rest api request fail status:", Ut), Le.ajaxUnconventionalErrorTimes++), p(Ze, be, Ke, Tt);
              }
              Ze.readyState === 0 && (Ke({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Ze.responseText, message: "Request not initialized" }), be({ type: c.E.WEBIM_CONNCTION_AJAX_ERROR, data: Ze.responseText, message: "Request not initialized" }));
            }, Te.responseType && Ze.responseType && (Ze.responseType = Te.responseType), Te.mimeType && Ze.overrideMimeType(Te.mimeType);
            var at = Te.type || "POST", pt = Te.data || null, It = "";
            if (at.toLowerCase() === "get" && pt) {
              for (var Rt in pt) pt.hasOwnProperty(Rt) && (It += Rt + "=" + pt[Rt] + "&");
              It = It && It.slice(0, -1), Te.url += (Te.url.indexOf("?") > 0 ? "&" : "?") + (It && It + "&") + "_v=" + (/* @__PURE__ */ new Date()).getTime(), pt = null, It = "";
            }
            Oe = (/* @__PURE__ */ new Date()).getTime(), Ze.open(at, Te.url);
            var gt = Te.headers || {};
            for (var it in gt["Content-Type"] || (gt["Content-Type"] = "application/json"), gt) gt.hasOwnProperty(it) && Ze.setRequestHeader(it, gt[it]);
            Ze.send(pt);
          }).then(function(xe) {
            return Pe.dataReport && K && K !== m.fI.SDK_INTERNAL && Pe.dataReport.geOperateFun({ operationName: K })({ isEndApi: !0, data: F({ isSuccess: 1, requestUrl: Te.url, requestName: K, requestMethod: Te.type }, Ce(xe.extraInfo)) }), K === m.fI.SDK_INTERNAL && (xe.extraInfo.url = Te.url), K !== m.fI.SDK_INTERNAL && delete xe.extraInfo, U(xe) === "Object" ? F(F({}, xe), { type: c.E.REQUEST_SUCCESS }) : { data: xe, type: c.E.REQUEST_SUCCESS };
          }).catch(function(xe) {
            throw Pe.dataReport && K && K !== m.fI.SDK_INTERNAL && Pe.dataReport.geOperateFun({ operationName: K })({ isEndApi: !0, data: F({ isSuccess: 0, requestUrl: Te.url, requestName: K, requestMethod: Te.type }, Ce(xe.extraInfo)) }), K === m.fI.SDK_INTERNAL && (xe.extraInfo.url = Te.url), K !== m.fI.SDK_INTERNAL && delete xe.extraInfo, xe;
          }) : M.call(this, Te, K);
        }
        function U(Te) {
          return Object.prototype.toString.call(Te).slice(8, -1);
        }
        function M(Te, K) {
          var Oe = this;
          return new Promise(function(Pe, xe) {
            var be = Te.success || j, $e = Te.error || j, Be = Te.type || "POST", Ke = Te.data || null, Ze = "", at = (/* @__PURE__ */ new Date()).getTime(), pt = Le.getEnvInfo();
            if (Be.toLowerCase() === "get" && Ke) {
              for (var It in Ke) Ke.hasOwnProperty(It) && (Ze += It + "=" + Ke[It] + "&");
              Ze = Ze && Ze.slice(0, -1), Te.url += (Te.url.indexOf("?") > 0 ? "&" : "?") + (Ze && Ze + "&") + "_v=" + (/* @__PURE__ */ new Date()).getTime(), Ke = null, Ze = "";
            }
            var Rt = { url: Te.url, data: Te.data, method: Be, headers: {}, success: function(gt) {
              var it, Tt, Ut, st, Ot, kt = { elapse: (/* @__PURE__ */ new Date()).getTime() - at, httpCode: Number(((it = gt.statusCode) === null || it === void 0 ? void 0 : it.toString()) || ((Tt = gt.status) === null || Tt === void 0 ? void 0 : Tt.toString())), errDesc: ((Ut = gt == null ? void 0 : gt.data) === null || Ut === void 0 ? void 0 : Ut.error_description) || "" };
              if (((st = gt.statusCode) === null || st === void 0 ? void 0 : st.toString()) === "200" || ((Ot = gt.status) === null || Ot === void 0 ? void 0 : Ot.toString()) === "200") {
                gt.data.extraInfo = kt;
                var wt = gt.data;
                be(wt), Pe(wt);
              } else gt.extraInfo = kt, $e(wt = gt), xe(wt), y.kg.debug(K, "reject reason: ", wt);
            }, complete: function() {
            }, fail: function(gt) {
              var it = { elapse: (/* @__PURE__ */ new Date()).getTime() - at, httpCode: E.Tp, errDesc: "request:fail" };
              gt.extraInfo = it, gt.data = { error: "request:fail", error_description: "request:fail" }, $e(gt), xe(gt), y.kg.debug(K, "fail reason:", gt);
            } };
            if (pt.platform === "zfb" || pt.platform === "dd" ? Rt.headers = Te.headers : Rt.header = Te.headers, pt.platform === "dd") return dd.httpRequest(Rt);
            pt.global.request(Rt);
          }).then(function(Pe) {
            return Oe.dataReport && K && K !== m.fI.SDK_INTERNAL && Oe.dataReport.geOperateFun({ operationName: K })({ isEndApi: !0, data: F({ isSuccess: 1, requestUrl: Te.url, requestName: K, requestMethod: Te.type }, Ce(Pe.extraInfo)) }), K !== m.fI.SDK_INTERNAL && delete Pe.extraInfo, U(Pe) === "Object" ? F(F({}, Pe), { type: c.E.REQUEST_SUCCESS }) : { data: Pe, type: c.E.REQUEST_SUCCESS };
          }).catch(function(Pe) {
            throw Oe.dataReport && K && K !== m.fI.SDK_INTERNAL && Oe.dataReport.geOperateFun({ operationName: K })({ isEndApi: !0, data: F({ isSuccess: 0, requestUrl: Te.url, requestName: K, requestMethod: Te.type }, Ce(Pe.extraInfo)) }), K !== m.fI.SDK_INTERNAL && delete Pe.extraInfo, Pe;
          });
        }
        function V(Te, K) {
          var Oe;
          return function() {
            for (var Pe = [], xe = 0; xe < arguments.length; xe++) Pe[xe] = arguments[xe];
            if (!Te) return Oe;
            Oe = Te.apply(void 0, Pe), Te = null;
          };
        }
        var J, ue = V(function(Te, K) {
          var Oe = ee();
          if (Oe.platform !== J.WEB) {
            var Pe = Oe.global, xe = function(be) {
              be.isConnected ? Te() : K();
            };
            Pe.offNetworkStatusChange && Pe.offNetworkStatusChange(xe), Pe.onNetworkStatusChange && Pe.onNetworkStatusChange(xe);
          } else typeof addEventListener < "u" && (window.addEventListener("online", Te), window.addEventListener("offline", K));
        }), se = V(function(Te, K) {
          var Oe, Pe, xe = ee();
          if (xe.platform === J.WEB) document && document.addEventListener("visibilitychange", function() {
            document.hidden ? K == null || K() : Te == null || Te();
          }, !1);
          else {
            var be = xe.global;
            be.onAppShow && ((Oe = be.onAppShow) === null || Oe === void 0 || Oe.call(be, Te)), be.onAppHide && ((Pe = be.onAppHide) === null || Pe === void 0 || Pe.call(be, K));
          }
        });
        function ee() {
          return typeof swan < "u" && de(swan) ? { platform: J.BAIDU, global: swan } : typeof tt < "u" && de(tt) ? { platform: J.TT, global: tt } : typeof dd < "u" && de(dd) ? { platform: J.DD, global: dd } : typeof my < "u" && de(my) ? { platform: J.ZFB, global: my } : typeof wx < "u" && de(wx) ? { platform: J.WX, global: wx } : typeof qq < "u" && de(qq) ? { platform: J.QQ, global: qq } : typeof uni < "u" && de(uni) ? { platform: J.UNI, global: uni } : typeof window < "u" && window.WebSocket ? { platform: J.WEB, global: window } : { platform: J.NODE, global: s.g || {} };
        }
        function de(Te) {
          for (var K = ["canIUse", "getSystemInfo"], Oe = 0, Pe = K.length; Oe < Pe; Oe++) if (!Te[K[Oe]]) return !1;
          return !0;
        }
        function he(Te, K) {
          var Oe, Pe, xe, be = this, $e = Te.accessToken, Be = Te.appKey, Ke = (Pe = (Oe = Te == null ? void 0 : Te.file) === null || Oe === void 0 ? void 0 : Oe.data) === null || Pe === void 0 ? void 0 : Pe.size, Ze = [], at = "", pt = "";
          if ($e) if (Be && (Ze = Be.split("#"), at = Ze[0], pt = Ze[1]), at || pt) if (Ke <= 0) Te.onFileUploadError && Te.onFileUploadError({ type: c.E.WEBIM_UPLOADFILE_ERROR, message: "fileSize must be greater than 0" });
          else if (Te.uploadUrl) D.call(this, F(F({}, Te), { orgName: at, appName: pt, operateName: K }));
          else {
            var It = O.size || C;
            this.uploadPartEnable && Ke > 1.5 * It ? new B(this, { file: (xe = Te == null ? void 0 : Te.file) === null || xe === void 0 ? void 0 : xe.data, onFileUploadProgress: Te.onFileUploadProgress || j, onFileUploadComplete: Te.onFileUploadComplete || j, onFileUploadError: Te.onFileUploadError || j, onFileUploadCanceled: Te.onFileUploadCanceled || j, onInitFail: function() {
              D.call(be, F(F({}, Te), { orgName: at, appName: pt, operateName: K }));
            }, thumbnailInfo: { width: Te.thumbnailWidth, height: Te.thumbnailHeight } }) : D.call(this, F(F({}, Te), { orgName: at, appName: pt, operateName: K }));
          }
          else Te.onFileUploadError && Te.onFileUploadError({ type: c.E.WEBIM_UPLOADFILE_ERROR, message: "AppKey illegal" });
          else Te.onFileUploadError && Te.onFileUploadError({ type: c.E.WEBIM_UPLOADFILE_NO_LOGIN, message: "AccessToken cannot be empty" });
        }
        function pe(Te, K) {
          Te.onFileDownloadComplete = Te.onFileDownloadComplete || j, Te.onFileDownloadError = Te.onFileDownloadError || j;
          var Oe = (/* @__PURE__ */ new Date()).getTime(), Pe = new XMLHttpRequest(), xe = this;
          Pe.addEventListener("load", function(pt) {
            var It = (/* @__PURE__ */ new Date()).getTime() - Oe;
            xe.dataReport && K && K === m.fI.DOWN_GROUP_FILE && xe.dataReport.geOperateFun({ operationName: K })({ isEndApi: !0, data: { isSuccess: Pe.status === 200 ? 1 : 0, requestMethod: "POST", requestName: K, requestElapse: It, requestUrl: Te == null ? void 0 : Te.url, code: Pe.status, codeDesc: Pe.status === 200 ? "" : "download file error" } }), Te.onFileDownloadComplete && Te.onFileDownloadComplete(Pe.response);
          }, !1), Pe.addEventListener("error", function(pt) {
            var It = (/* @__PURE__ */ new Date()).getTime() - Oe;
            xe.dataReport && K && K === m.fI.DOWN_GROUP_FILE && xe.dataReport.geOperateFun({ operationName: K })({ isEndApi: !0, data: { isSuccess: 0, requestMethod: "POST", requestName: K, requestElapse: It, requestUrl: Te == null ? void 0 : Te.url, code: (Pe == null ? void 0 : Pe.status) || 0, codeDesc: "download file error" } }), Te.onFileDownloadError && Te.onFileDownloadError({ type: c.E.WEBIM_DOWNLOADFILE_ERROR, id: Te.id, xhr: Pe });
          }, !1);
          var be = Te.method || "GET", $e = Te.responseType || "blob", Be = Te.mimeType || "text/plain; charset=x-user-defined";
          Pe.open(be, Te.url), typeof Blob < "u" ? Pe.responseType = $e : Pe.overrideMimeType(Be);
          var Ke = { "X-Requested-With": "XMLHttpRequest", Accept: "application/octet-stream", "share-secret": Te.secret, Authorization: "Bearer " + this.context.accessToken }, Ze = Te.headers || {};
          for (var at in Ze) Ke[at] = Ze[at];
          for (var at in Ke) Ke[at] && Pe.setRequestHeader(at, Ke[at]);
          Pe.send(null);
        }
        function Ce(Te) {
          Te === void 0 && (Te = {});
          var K = Te.elapse, Oe = K === void 0 ? 0 : K, Pe = Te.httpCode, xe = Pe === void 0 ? 0 : Pe, be = Te.errDesc;
          return { requestElapse: Oe, code: xe, codeDesc: be === void 0 ? "" : be };
        }
        (function(Te) {
          Te.WEB = "web", Te.WX = "wx", Te.QQ = "qq", Te.ZFB = "zfb", Te.DD = "dd", Te.TT = "tt", Te.BAIDU = "baidu", Te.QUICK_APP = "quick_app", Te.UNI = "uni", Te.NODE = "node";
        })(J || (J = {}));
        var _e = "localDeviceInfo", Le = { autoIncrement: 0, ajaxUnconventionalErrorTimes: 0, ajax: G, getUniqueId: function() {
          this.autoIncrement ? this.autoIncrement++ : this.autoIncrement = 1;
          var Te = /* @__PURE__ */ new Date(), K = new Date(2010, 1, 1);
          return (Te.getTime() - K.getTime() + this.autoIncrement).toString();
        }, getFileUrl: function(Te) {
          var K = { url: "", filename: "", filetype: "", data: {} }, Oe = typeof Te == "string" ? document.getElementById(Te) : Te;
          if (window.URL.createObjectURL) {
            if (!Oe.files) throw Error("this is not HTMLInputElement");
            var Pe = Oe.files;
            if (Pe.length > 0) {
              var xe = Pe.item(0);
              K.data = xe, K.url = window.URL.createObjectURL(xe), K.filename = (xe == null ? void 0 : xe.name) || "";
            }
          } else {
            if (typeof Te != "string") throw Error("in IE fileInputId must be string");
            xe = document.getElementById(Te).value, K.url = xe;
            var be = xe.lastIndexOf("/"), $e = xe.lastIndexOf("\\"), Be = Math.max(be, $e);
            K.filename = Be < 0 ? xe : xe.substring(Be + 1);
          }
          var Ke = K.filename.lastIndexOf(".");
          return Ke !== -1 && (K.filetype = K.filename.substring(Ke + 1).toLowerCase()), K;
        }, uploadFile: he, flow: function(Te) {
          for (var K = Te.length, Oe = K; Oe--; ) if (typeof Te[Oe] != "function") throw new TypeError("Expected a function");
          return function() {
            for (var Pe = [], xe = 0; xe < arguments.length; xe++) Pe[xe] = arguments[xe];
            for (var be = 0, $e = K ? Te[be].apply(this, Pe) : Pe[0]; ++be < K; ) $e = Te[be].call(this, $e);
            return $e;
          };
        }, listenNetwork: ue, listenBrowserVisibility: se, getEnvInfo: ee, wxRequest: M, parseDownloadResponse: function(Te) {
          if (!window || !window.URL) throw Error("parseDownloadResponse can be used in broswer only");
          return Te && Te.type && Te.type === "application/json" || 0 > Object.prototype.toString.call(Te).indexOf("Blob") ? this.url + "?token=" : window.URL.createObjectURL(Te);
        }, download: pe, parseNotify: function(Te) {
          for (var K = "", Oe = 0; Oe < Te.length; Oe++) K += "%" + Te[Oe].toString(16);
          return JSON.parse(decodeURIComponent(K));
        }, getExtraData: Ce, retryPromise: function(Te, K, Oe) {
          return new Promise(function(Pe, xe) {
            (function be($e) {
              Te().then(Pe).catch(function(Be) {
                $e > 0 ? setTimeout(function() {
                  be($e - 1);
                }, Oe || 1e3) : xe(Be);
              });
            })(K || 3);
          });
        }, formatAttachUrl: function(Te) {
          return Te && typeof Te == "string" ? "".concat(this.apiUrl).concat(Te.substr(Te.indexOf("/", 9))) : "";
        }, Uint8ArrayToString: function(Te) {
          for (var K = "", Oe = 0; Oe < Te.length; Oe++) K += String.fromCharCode(Te[Oe]);
          return K;
        }, getLocalDeviceInfo: function() {
          return function(Te) {
            var K, Oe = Le.getEnvInfo(), Pe = Oe.platform, xe = "";
            Pe !== J.NODE && Pe !== J.QUICK_APP || (xe = "");
            try {
              Pe === J.WEB ? xe = localStorage.getItem(Te) || "" : Pe === J.WX || Pe === J.QQ || Pe === J.TT || Pe === J.BAIDU || Pe === J.UNI ? xe = Oe.global.getStorageSync(Te) || "" : Pe !== J.ZFB && Pe !== J.DD || (xe = ((K = Oe.global.getStorageSync({ key: Te })) === null || K === void 0 ? void 0 : K.data) || "");
            } catch (be) {
              y.kg.debug("get local ".concat(Te, " failed: "), be);
            }
            return y.kg.debug("".concat(Te, " "), xe), xe;
          }(_e);
        }, setLocalDeviceInfo: function(Te) {
          var K, Oe, Pe, xe;
          K = _e, Oe = Te, (xe = (Pe = Le.getEnvInfo()).platform) !== J.NODE && xe !== J.QUICK_APP && (xe === J.WEB ? localStorage.setItem(K, Oe) : Pe.global.setStorage({ key: K, data: Oe, success: function(be) {
            y.kg.debug("set local ".concat(K, " success: "), be);
          }, fail: function(be) {
            y.kg.error("set local ".concat(K, " failed: "), be);
          } }));
        }, detectBrowser: function() {
          if (typeof navigator > "u") return "unknown";
          var Te = navigator.userAgent;
          return /MicroMessenger/i.test(Te) ? "WeChat" : /QQBrowser/i.test(Te) ? "QQ" : !/Chrome/i.test(Te) || /Edg/i.test(Te) || /OPR/i.test(Te) ? !/Safari/i.test(Te) || /Chrome/i.test(Te) || /CriOS/i.test(Te) ? /Firefox/i.test(Te) ? "Firefox" : /MSIE/i.test(Te) || /Trident/i.test(Te) ? "IE" : /Edg/i.test(Te) ? "Edge" : "unknown" : "Safari" : "Chrome";
        }, getDevicePlatform: function(Te) {
          return Te.platform === J.WX && typeof uni < "u" && de(uni) ? J.UNI : Te.platform;
        }, delay: function(Te) {
          return new Promise(function(K) {
            return setTimeout(K, Te);
          });
        } };
      }, 9662: function(l, v, s) {
        var c = s(614), d = s(6330), p = TypeError;
        l.exports = function(m) {
          if (c(m)) return m;
          throw p(d(m) + " is not a function");
        };
      }, 9483: function(l, v, s) {
        var c = s(4411), d = s(6330), p = TypeError;
        l.exports = function(m) {
          if (c(m)) return m;
          throw p(d(m) + " is not a constructor");
        };
      }, 6077: function(l, v, s) {
        var c = s(614), d = String, p = TypeError;
        l.exports = function(m) {
          if (typeof m == "object" || c(m)) return m;
          throw p("Can't set " + d(m) + " as a prototype");
        };
      }, 1223: function(l, v, s) {
        var c = s(5112), d = s(30), p = s(3070).f, m = c("unscopables"), E = Array.prototype;
        E[m] == null && p(E, m, { configurable: !0, value: d(null) }), l.exports = function(y) {
          E[m][y] = !0;
        };
      }, 1530: function(l, v, s) {
        var c = s(8710).charAt;
        l.exports = function(d, p, m) {
          return p + (m ? c(d, p).length : 1);
        };
      }, 5787: function(l, v, s) {
        var c = s(7976), d = TypeError;
        l.exports = function(p, m) {
          if (c(m, p)) return p;
          throw d("Incorrect invocation");
        };
      }, 9670: function(l, v, s) {
        var c = s(111), d = String, p = TypeError;
        l.exports = function(m) {
          if (c(m)) return m;
          throw p(d(m) + " is not an object");
        };
      }, 3013: function(l) {
        l.exports = typeof ArrayBuffer < "u" && typeof DataView < "u";
      }, 7556: function(l, v, s) {
        var c = s(7293);
        l.exports = c(function() {
          if (typeof ArrayBuffer == "function") {
            var d = new ArrayBuffer(8);
            Object.isExtensible(d) && Object.defineProperty(d, "a", { value: 8 });
          }
        });
      }, 260: function(l, v, s) {
        var c, d, p, m = s(3013), E = s(9781), y = s(7854), g = s(614), C = s(111), O = s(2597), N = s(648), w = s(6330), _ = s(8880), I = s(8052), k = s(7045), H = s(7976), S = s(9518), B = s(7674), D = s(5112), F = s(9711), j = s(9909), G = j.enforce, U = j.get, M = y.Int8Array, V = M && M.prototype, J = y.Uint8ClampedArray, ue = J && J.prototype, se = M && S(M), ee = V && S(V), de = Object.prototype, he = y.TypeError, pe = D("toStringTag"), Ce = F("TYPED_ARRAY_TAG"), _e = "TypedArrayConstructor", Le = m && !!B && N(y.opera) !== "Opera", Te = !1, K = { Int8Array: 1, Uint8Array: 1, Uint8ClampedArray: 1, Int16Array: 2, Uint16Array: 2, Int32Array: 4, Uint32Array: 4, Float32Array: 4, Float64Array: 8 }, Oe = { BigInt64Array: 8, BigUint64Array: 8 }, Pe = function(be) {
          var $e = S(be);
          if (C($e)) {
            var Be = U($e);
            return Be && O(Be, _e) ? Be[_e] : Pe($e);
          }
        }, xe = function(be) {
          if (!C(be)) return !1;
          var $e = N(be);
          return O(K, $e) || O(Oe, $e);
        };
        for (c in K) (p = (d = y[c]) && d.prototype) ? G(p)[_e] = d : Le = !1;
        for (c in Oe) (p = (d = y[c]) && d.prototype) && (G(p)[_e] = d);
        if ((!Le || !g(se) || se === Function.prototype) && (se = function() {
          throw he("Incorrect invocation");
        }, Le)) for (c in K) y[c] && B(y[c], se);
        if ((!Le || !ee || ee === de) && (ee = se.prototype, Le)) for (c in K) y[c] && B(y[c].prototype, ee);
        if (Le && S(ue) !== ee && B(ue, ee), E && !O(ee, pe)) for (c in Te = !0, k(ee, pe, { configurable: !0, get: function() {
          return C(this) ? this[Ce] : void 0;
        } }), K) y[c] && _(y[c], Ce, c);
        l.exports = { NATIVE_ARRAY_BUFFER_VIEWS: Le, TYPED_ARRAY_TAG: Te && Ce, aTypedArray: function(be) {
          if (xe(be)) return be;
          throw he("Target is not a typed array");
        }, aTypedArrayConstructor: function(be) {
          if (g(be) && (!B || H(se, be))) return be;
          throw he(w(be) + " is not a typed array constructor");
        }, exportTypedArrayMethod: function(be, $e, Be, Ke) {
          if (E) {
            if (Be) for (var Ze in K) {
              var at = y[Ze];
              if (at && O(at.prototype, be)) try {
                delete at.prototype[be];
              } catch {
                try {
                  at.prototype[be] = $e;
                } catch {
                }
              }
            }
            ee[be] && !Be || I(ee, be, Be ? $e : Le && V[be] || $e, Ke);
          }
        }, exportTypedArrayStaticMethod: function(be, $e, Be) {
          var Ke, Ze;
          if (E) {
            if (B) {
              if (Be) {
                for (Ke in K) if ((Ze = y[Ke]) && O(Ze, be)) try {
                  delete Ze[be];
                } catch {
                }
              }
              if (se[be] && !Be) return;
              try {
                return I(se, be, Be ? $e : Le && se[be] || $e);
              } catch {
              }
            }
            for (Ke in K) !(Ze = y[Ke]) || Ze[be] && !Be || I(Ze, be, $e);
          }
        }, getTypedArrayConstructor: Pe, isView: function(be) {
          if (!C(be)) return !1;
          var $e = N(be);
          return $e === "DataView" || O(K, $e) || O(Oe, $e);
        }, isTypedArray: xe, TypedArray: se, TypedArrayPrototype: ee };
      }, 3331: function(l, v, s) {
        var c = s(7854), d = s(1702), p = s(9781), m = s(3013), E = s(6530), y = s(8880), g = s(7045), C = s(9190), O = s(7293), N = s(5787), w = s(9303), _ = s(7466), I = s(7067), k = s(1179), H = s(9518), S = s(7674), B = s(8006).f, D = s(1285), F = s(1589), j = s(8003), G = s(9909), U = E.PROPER, M = E.CONFIGURABLE, V = "ArrayBuffer", J = "DataView", ue = "prototype", se = "Wrong index", ee = G.getterFor(V), de = G.getterFor(J), he = G.set, pe = c[V], Ce = pe, _e = Ce && Ce[ue], Le = c[J], Te = Le && Le[ue], K = Object.prototype, Oe = c.Array, Pe = c.RangeError, xe = d(D), be = d([].reverse), $e = k.pack, Be = k.unpack, Ke = function(ut) {
          return [255 & ut];
        }, Ze = function(ut) {
          return [255 & ut, ut >> 8 & 255];
        }, at = function(ut) {
          return [255 & ut, ut >> 8 & 255, ut >> 16 & 255, ut >> 24 & 255];
        }, pt = function(ut) {
          return ut[3] << 24 | ut[2] << 16 | ut[1] << 8 | ut[0];
        }, It = function(ut) {
          return $e(ut, 23, 4);
        }, Rt = function(ut) {
          return $e(ut, 52, 8);
        }, gt = function(ut, St, Ft) {
          g(ut[ue], St, { configurable: !0, get: function() {
            return Ft(this)[St];
          } });
        }, it = function(ut, St, Ft, Ht) {
          var zt = I(Ft), ze = de(ut);
          if (zt + St > ze.byteLength) throw Pe(se);
          var Ne = ze.bytes, le = zt + ze.byteOffset, X = F(Ne, le, le + St);
          return Ht ? X : be(X);
        }, Tt = function(ut, St, Ft, Ht, zt, ze) {
          var Ne = I(Ft), le = de(ut);
          if (Ne + St > le.byteLength) throw Pe(se);
          for (var X = le.bytes, re = Ne + le.byteOffset, Me = Ht(+zt), Se = 0; Se < St; Se++) X[re + Se] = Me[ze ? Se : St - Se - 1];
        };
        if (m) {
          var Ut = U && pe.name !== V;
          if (O(function() {
            pe(1);
          }) && O(function() {
            new pe(-1);
          }) && !O(function() {
            return new pe(), new pe(1.5), new pe(NaN), pe.length != 1 || Ut && !M;
          })) Ut && M && y(pe, "name", V);
          else {
            (Ce = function(ut) {
              return N(this, _e), new pe(I(ut));
            })[ue] = _e;
            for (var st, Ot = B(pe), kt = 0; Ot.length > kt; ) (st = Ot[kt++]) in Ce || y(Ce, st, pe[st]);
            _e.constructor = Ce;
          }
          S && H(Te) !== K && S(Te, K);
          var wt = new Le(new Ce(2)), Et = d(Te.setInt8);
          wt.setInt8(0, 2147483648), wt.setInt8(1, 2147483649), !wt.getInt8(0) && wt.getInt8(1) || C(Te, { setInt8: function(ut, St) {
            Et(this, ut, St << 24 >> 24);
          }, setUint8: function(ut, St) {
            Et(this, ut, St << 24 >> 24);
          } }, { unsafe: !0 });
        } else _e = (Ce = function(ut) {
          N(this, _e);
          var St = I(ut);
          he(this, { type: V, bytes: xe(Oe(St), 0), byteLength: St }), p || (this.byteLength = St, this.detached = !1);
        })[ue], Te = (Le = function(ut, St, Ft) {
          N(this, Te), N(ut, _e);
          var Ht = ee(ut), zt = Ht.byteLength, ze = w(St);
          if (ze < 0 || ze > zt) throw Pe("Wrong offset");
          if (ze + (Ft = Ft === void 0 ? zt - ze : _(Ft)) > zt) throw Pe("Wrong length");
          he(this, { type: J, buffer: ut, byteLength: Ft, byteOffset: ze, bytes: Ht.bytes }), p || (this.buffer = ut, this.byteLength = Ft, this.byteOffset = ze);
        })[ue], p && (gt(Ce, "byteLength", ee), gt(Le, "buffer", de), gt(Le, "byteLength", de), gt(Le, "byteOffset", de)), C(Te, { getInt8: function(ut) {
          return it(this, 1, ut)[0] << 24 >> 24;
        }, getUint8: function(ut) {
          return it(this, 1, ut)[0];
        }, getInt16: function(ut) {
          var St = it(this, 2, ut, arguments.length > 1 ? arguments[1] : void 0);
          return (St[1] << 8 | St[0]) << 16 >> 16;
        }, getUint16: function(ut) {
          var St = it(this, 2, ut, arguments.length > 1 ? arguments[1] : void 0);
          return St[1] << 8 | St[0];
        }, getInt32: function(ut) {
          return pt(it(this, 4, ut, arguments.length > 1 ? arguments[1] : void 0));
        }, getUint32: function(ut) {
          return pt(it(this, 4, ut, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
        }, getFloat32: function(ut) {
          return Be(it(this, 4, ut, arguments.length > 1 ? arguments[1] : void 0), 23);
        }, getFloat64: function(ut) {
          return Be(it(this, 8, ut, arguments.length > 1 ? arguments[1] : void 0), 52);
        }, setInt8: function(ut, St) {
          Tt(this, 1, ut, Ke, St);
        }, setUint8: function(ut, St) {
          Tt(this, 1, ut, Ke, St);
        }, setInt16: function(ut, St) {
          Tt(this, 2, ut, Ze, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setUint16: function(ut, St) {
          Tt(this, 2, ut, Ze, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setInt32: function(ut, St) {
          Tt(this, 4, ut, at, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setUint32: function(ut, St) {
          Tt(this, 4, ut, at, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setFloat32: function(ut, St) {
          Tt(this, 4, ut, It, St, arguments.length > 2 ? arguments[2] : void 0);
        }, setFloat64: function(ut, St) {
          Tt(this, 8, ut, Rt, St, arguments.length > 2 ? arguments[2] : void 0);
        } });
        j(Ce, V), j(Le, J), l.exports = { ArrayBuffer: Ce, DataView: Le };
      }, 1048: function(l, v, s) {
        var c = s(7908), d = s(1400), p = s(6244), m = s(5117), E = Math.min;
        l.exports = [].copyWithin || function(y, g) {
          var C = c(this), O = p(C), N = d(y, O), w = d(g, O), _ = arguments.length > 2 ? arguments[2] : void 0, I = E((_ === void 0 ? O : d(_, O)) - w, O - N), k = 1;
          for (w < N && N < w + I && (k = -1, w += I - 1, N += I - 1); I-- > 0; ) w in C ? C[N] = C[w] : m(C, N), N += k, w += k;
          return C;
        };
      }, 1285: function(l, v, s) {
        var c = s(7908), d = s(1400), p = s(6244);
        l.exports = function(m) {
          for (var E = c(this), y = p(E), g = arguments.length, C = d(g > 1 ? arguments[1] : void 0, y), O = g > 2 ? arguments[2] : void 0, N = O === void 0 ? y : d(O, y); N > C; ) E[C++] = m;
          return E;
        };
      }, 8533: function(l, v, s) {
        var c = s(2092).forEach, d = s(9341)("forEach");
        l.exports = d ? [].forEach : function(p) {
          return c(this, p, arguments.length > 1 ? arguments[1] : void 0);
        };
      }, 7745: function(l, v, s) {
        var c = s(6244);
        l.exports = function(d, p) {
          for (var m = 0, E = c(p), y = new d(E); E > m; ) y[m] = p[m++];
          return y;
        };
      }, 8457: function(l, v, s) {
        var c = s(9974), d = s(6916), p = s(7908), m = s(3411), E = s(7659), y = s(4411), g = s(6244), C = s(6135), O = s(4121), N = s(1246), w = Array;
        l.exports = function(_) {
          var I = p(_), k = y(this), H = arguments.length, S = H > 1 ? arguments[1] : void 0, B = S !== void 0;
          B && (S = c(S, H > 2 ? arguments[2] : void 0));
          var D, F, j, G, U, M, V = N(I), J = 0;
          if (!V || this === w && E(V)) for (D = g(I), F = k ? new this(D) : w(D); D > J; J++) M = B ? S(I[J], J) : I[J], C(F, J, M);
          else for (U = (G = O(I, V)).next, F = k ? new this() : []; !(j = d(U, G)).done; J++) M = B ? m(G, S, [j.value, J], !0) : j.value, C(F, J, M);
          return F.length = J, F;
        };
      }, 1318: function(l, v, s) {
        var c = s(5656), d = s(1400), p = s(6244), m = function(E) {
          return function(y, g, C) {
            var O, N = c(y), w = p(N), _ = d(C, w);
            if (E && g != g) {
              for (; w > _; ) if ((O = N[_++]) != O) return !0;
            } else for (; w > _; _++) if ((E || _ in N) && N[_] === g) return E || _ || 0;
            return !E && -1;
          };
        };
        l.exports = { includes: m(!0), indexOf: m(!1) };
      }, 2092: function(l, v, s) {
        var c = s(9974), d = s(1702), p = s(8361), m = s(7908), E = s(6244), y = s(5417), g = d([].push), C = function(O) {
          var N = O == 1, w = O == 2, _ = O == 3, I = O == 4, k = O == 6, H = O == 7, S = O == 5 || k;
          return function(B, D, F, j) {
            for (var G, U, M = m(B), V = p(M), J = c(D, F), ue = E(V), se = 0, ee = j || y, de = N ? ee(B, ue) : w || H ? ee(B, 0) : void 0; ue > se; se++) if ((S || se in V) && (U = J(G = V[se], se, M), O)) if (N) de[se] = U;
            else if (U) switch (O) {
              case 3:
                return !0;
              case 5:
                return G;
              case 6:
                return se;
              case 2:
                g(de, G);
            }
            else switch (O) {
              case 4:
                return !1;
              case 7:
                g(de, G);
            }
            return k ? -1 : _ || I ? I : de;
          };
        };
        l.exports = { forEach: C(0), map: C(1), filter: C(2), some: C(3), every: C(4), find: C(5), findIndex: C(6), filterReject: C(7) };
      }, 6583: function(l, v, s) {
        var c = s(2104), d = s(5656), p = s(9303), m = s(6244), E = s(9341), y = Math.min, g = [].lastIndexOf, C = !!g && 1 / [1].lastIndexOf(1, -0) < 0, O = E("lastIndexOf"), N = C || !O;
        l.exports = N ? function(w) {
          if (C) return c(g, this, arguments) || 0;
          var _ = d(this), I = m(_), k = I - 1;
          for (arguments.length > 1 && (k = y(k, p(arguments[1]))), k < 0 && (k = I + k); k >= 0; k--) if (k in _ && _[k] === w) return k || 0;
          return -1;
        } : g;
      }, 1194: function(l, v, s) {
        var c = s(7293), d = s(5112), p = s(7392), m = d("species");
        l.exports = function(E) {
          return p >= 51 || !c(function() {
            var y = [];
            return (y.constructor = {})[m] = function() {
              return { foo: 1 };
            }, y[E](Boolean).foo !== 1;
          });
        };
      }, 9341: function(l, v, s) {
        var c = s(7293);
        l.exports = function(d, p) {
          var m = [][d];
          return !!m && c(function() {
            m.call(null, p || function() {
              return 1;
            }, 1);
          });
        };
      }, 3671: function(l, v, s) {
        var c = s(9662), d = s(7908), p = s(8361), m = s(6244), E = TypeError, y = function(g) {
          return function(C, O, N, w) {
            c(O);
            var _ = d(C), I = p(_), k = m(_), H = g ? k - 1 : 0, S = g ? -1 : 1;
            if (N < 2) for (; ; ) {
              if (H in I) {
                w = I[H], H += S;
                break;
              }
              if (H += S, g ? H < 0 : k <= H) throw E("Reduce of empty array with no initial value");
            }
            for (; g ? H >= 0 : k > H; H += S) H in I && (w = O(w, I[H], H, _));
            return w;
          };
        };
        l.exports = { left: y(!1), right: y(!0) };
      }, 3658: function(l, v, s) {
        var c = s(9781), d = s(3157), p = TypeError, m = Object.getOwnPropertyDescriptor, E = c && !function() {
          if (this !== void 0) return !0;
          try {
            Object.defineProperty([], "length", { writable: !1 }).length = 1;
          } catch (y) {
            return y instanceof TypeError;
          }
        }();
        l.exports = E ? function(y, g) {
          if (d(y) && !m(y, "length").writable) throw p("Cannot set read only .length");
          return y.length = g;
        } : function(y, g) {
          return y.length = g;
        };
      }, 1589: function(l, v, s) {
        var c = s(1400), d = s(6244), p = s(6135), m = Array, E = Math.max;
        l.exports = function(y, g, C) {
          for (var O = d(y), N = c(g, O), w = c(C === void 0 ? O : C, O), _ = m(E(w - N, 0)), I = 0; N < w; N++, I++) p(_, I, y[N]);
          return _.length = I, _;
        };
      }, 206: function(l, v, s) {
        var c = s(1702);
        l.exports = c([].slice);
      }, 4362: function(l, v, s) {
        var c = s(1589), d = Math.floor, p = function(y, g) {
          var C = y.length, O = d(C / 2);
          return C < 8 ? m(y, g) : E(y, p(c(y, 0, O), g), p(c(y, O), g), g);
        }, m = function(y, g) {
          for (var C, O, N = y.length, w = 1; w < N; ) {
            for (O = w, C = y[w]; O && g(y[O - 1], C) > 0; ) y[O] = y[--O];
            O !== w++ && (y[O] = C);
          }
          return y;
        }, E = function(y, g, C, O) {
          for (var N = g.length, w = C.length, _ = 0, I = 0; _ < N || I < w; ) y[_ + I] = _ < N && I < w ? O(g[_], C[I]) <= 0 ? g[_++] : C[I++] : _ < N ? g[_++] : C[I++];
          return y;
        };
        l.exports = p;
      }, 7475: function(l, v, s) {
        var c = s(3157), d = s(4411), p = s(111), m = s(5112)("species"), E = Array;
        l.exports = function(y) {
          var g;
          return c(y) && (g = y.constructor, (d(g) && (g === E || c(g.prototype)) || p(g) && (g = g[m]) === null) && (g = void 0)), g === void 0 ? E : g;
        };
      }, 5417: function(l, v, s) {
        var c = s(7475);
        l.exports = function(d, p) {
          return new (c(d))(p === 0 ? 0 : p);
        };
      }, 3411: function(l, v, s) {
        var c = s(9670), d = s(9212);
        l.exports = function(p, m, E, y) {
          try {
            return y ? m(c(E)[0], E[1]) : m(E);
          } catch (g) {
            d(p, "throw", g);
          }
        };
      }, 7072: function(l, v, s) {
        var c = s(5112)("iterator"), d = !1;
        try {
          var p = 0, m = { next: function() {
            return { done: !!p++ };
          }, return: function() {
            d = !0;
          } };
          m[c] = function() {
            return this;
          }, Array.from(m, function() {
            throw 2;
          });
        } catch {
        }
        l.exports = function(E, y) {
          if (!y && !d) return !1;
          var g = !1;
          try {
            var C = {};
            C[c] = function() {
              return { next: function() {
                return { done: g = !0 };
              } };
            }, E(C);
          } catch {
          }
          return g;
        };
      }, 4326: function(l, v, s) {
        var c = s(1702), d = c({}.toString), p = c("".slice);
        l.exports = function(m) {
          return p(d(m), 8, -1);
        };
      }, 648: function(l, v, s) {
        var c = s(1694), d = s(614), p = s(4326), m = s(5112)("toStringTag"), E = Object, y = p(/* @__PURE__ */ function() {
          return arguments;
        }()) == "Arguments";
        l.exports = c ? p : function(g) {
          var C, O, N;
          return g === void 0 ? "Undefined" : g === null ? "Null" : typeof (O = function(w, _) {
            try {
              return w[_];
            } catch {
            }
          }(C = E(g), m)) == "string" ? O : y ? p(C) : (N = p(C)) == "Object" && d(C.callee) ? "Arguments" : N;
        };
      }, 5631: function(l, v, s) {
        var c = s(30), d = s(7045), p = s(9190), m = s(9974), E = s(5787), y = s(8554), g = s(408), C = s(1656), O = s(6178), N = s(6340), w = s(9781), _ = s(2423).fastKey, I = s(9909), k = I.set, H = I.getterFor;
        l.exports = { getConstructor: function(S, B, D, F) {
          var j = S(function(J, ue) {
            E(J, G), k(J, { type: B, index: c(null), first: void 0, last: void 0, size: 0 }), w || (J.size = 0), y(ue) || g(ue, J[F], { that: J, AS_ENTRIES: D });
          }), G = j.prototype, U = H(B), M = function(J, ue, se) {
            var ee, de, he = U(J), pe = V(J, ue);
            return pe ? pe.value = se : (he.last = pe = { index: de = _(ue, !0), key: ue, value: se, previous: ee = he.last, next: void 0, removed: !1 }, he.first || (he.first = pe), ee && (ee.next = pe), w ? he.size++ : J.size++, de !== "F" && (he.index[de] = pe)), J;
          }, V = function(J, ue) {
            var se, ee = U(J), de = _(ue);
            if (de !== "F") return ee.index[de];
            for (se = ee.first; se; se = se.next) if (se.key == ue) return se;
          };
          return p(G, { clear: function() {
            for (var J = U(this), ue = J.index, se = J.first; se; ) se.removed = !0, se.previous && (se.previous = se.previous.next = void 0), delete ue[se.index], se = se.next;
            J.first = J.last = void 0, w ? J.size = 0 : this.size = 0;
          }, delete: function(J) {
            var ue = this, se = U(ue), ee = V(ue, J);
            if (ee) {
              var de = ee.next, he = ee.previous;
              delete se.index[ee.index], ee.removed = !0, he && (he.next = de), de && (de.previous = he), se.first == ee && (se.first = de), se.last == ee && (se.last = he), w ? se.size-- : ue.size--;
            }
            return !!ee;
          }, forEach: function(J) {
            for (var ue, se = U(this), ee = m(J, arguments.length > 1 ? arguments[1] : void 0); ue = ue ? ue.next : se.first; ) for (ee(ue.value, ue.key, this); ue && ue.removed; ) ue = ue.previous;
          }, has: function(J) {
            return !!V(this, J);
          } }), p(G, D ? { get: function(J) {
            var ue = V(this, J);
            return ue && ue.value;
          }, set: function(J, ue) {
            return M(this, J === 0 ? 0 : J, ue);
          } } : { add: function(J) {
            return M(this, J = J === 0 ? 0 : J, J);
          } }), w && d(G, "size", { configurable: !0, get: function() {
            return U(this).size;
          } }), j;
        }, setStrong: function(S, B, D) {
          var F = B + " Iterator", j = H(B), G = H(F);
          C(S, B, function(U, M) {
            k(this, { type: F, target: U, state: j(U), kind: M, last: void 0 });
          }, function() {
            for (var U = G(this), M = U.kind, V = U.last; V && V.removed; ) V = V.previous;
            return U.target && (U.last = V = V ? V.next : U.state.first) ? O(M == "keys" ? V.key : M == "values" ? V.value : [V.key, V.value], !1) : (U.target = void 0, O(void 0, !0));
          }, D ? "entries" : "values", !D, !0), N(B);
        } };
      }, 7710: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(1702), m = s(4705), E = s(8052), y = s(2423), g = s(408), C = s(5787), O = s(614), N = s(8554), w = s(111), _ = s(7293), I = s(7072), k = s(8003), H = s(9587);
        l.exports = function(S, B, D) {
          var F = S.indexOf("Map") !== -1, j = S.indexOf("Weak") !== -1, G = F ? "set" : "add", U = d[S], M = U && U.prototype, V = U, J = {}, ue = function(Ce) {
            var _e = p(M[Ce]);
            E(M, Ce, Ce == "add" ? function(Le) {
              return _e(this, Le === 0 ? 0 : Le), this;
            } : Ce == "delete" ? function(Le) {
              return !(j && !w(Le)) && _e(this, Le === 0 ? 0 : Le);
            } : Ce == "get" ? function(Le) {
              return j && !w(Le) ? void 0 : _e(this, Le === 0 ? 0 : Le);
            } : Ce == "has" ? function(Le) {
              return !(j && !w(Le)) && _e(this, Le === 0 ? 0 : Le);
            } : function(Le, Te) {
              return _e(this, Le === 0 ? 0 : Le, Te), this;
            });
          };
          if (m(S, !O(U) || !(j || M.forEach && !_(function() {
            new U().entries().next();
          })))) V = D.getConstructor(B, S, F, G), y.enable();
          else if (m(S, !0)) {
            var se = new V(), ee = se[G](j ? {} : -0, 1) != se, de = _(function() {
              se.has(1);
            }), he = I(function(Ce) {
              new U(Ce);
            }), pe = !j && _(function() {
              for (var Ce = new U(), _e = 5; _e--; ) Ce[G](_e, _e);
              return !Ce.has(-0);
            });
            he || ((V = B(function(Ce, _e) {
              C(Ce, M);
              var Le = H(new U(), Ce, V);
              return N(_e) || g(_e, Le[G], { that: Le, AS_ENTRIES: F }), Le;
            })).prototype = M, M.constructor = V), (de || pe) && (ue("delete"), ue("has"), F && ue("get")), (pe || ee) && ue(G), j && M.clear && delete M.clear;
          }
          return J[S] = V, c({ global: !0, constructor: !0, forced: V != U }, J), k(V, S), j || D.setStrong(V, S, F), V;
        };
      }, 9920: function(l, v, s) {
        var c = s(2597), d = s(3887), p = s(1236), m = s(3070);
        l.exports = function(E, y, g) {
          for (var C = d(y), O = m.f, N = p.f, w = 0; w < C.length; w++) {
            var _ = C[w];
            c(E, _) || g && c(g, _) || O(E, _, N(y, _));
          }
        };
      }, 4964: function(l, v, s) {
        var c = s(5112)("match");
        l.exports = function(d) {
          var p = /./;
          try {
            "/./"[d](p);
          } catch {
            try {
              return p[c] = !1, "/./"[d](p);
            } catch {
            }
          }
          return !1;
        };
      }, 8544: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          function d() {
          }
          return d.prototype.constructor = null, Object.getPrototypeOf(new d()) !== d.prototype;
        });
      }, 6178: function(l) {
        l.exports = function(v, s) {
          return { value: v, done: s };
        };
      }, 8880: function(l, v, s) {
        var c = s(9781), d = s(3070), p = s(9114);
        l.exports = c ? function(m, E, y) {
          return d.f(m, E, p(1, y));
        } : function(m, E, y) {
          return m[E] = y, m;
        };
      }, 9114: function(l) {
        l.exports = function(v, s) {
          return { enumerable: !(1 & v), configurable: !(2 & v), writable: !(4 & v), value: s };
        };
      }, 6135: function(l, v, s) {
        var c = s(4948), d = s(3070), p = s(9114);
        l.exports = function(m, E, y) {
          var g = c(E);
          g in m ? d.f(m, g, p(0, y)) : m[g] = y;
        };
      }, 7045: function(l, v, s) {
        var c = s(6339), d = s(3070);
        l.exports = function(p, m, E) {
          return E.get && c(E.get, m, { getter: !0 }), E.set && c(E.set, m, { setter: !0 }), d.f(p, m, E);
        };
      }, 8052: function(l, v, s) {
        var c = s(614), d = s(3070), p = s(6339), m = s(3072);
        l.exports = function(E, y, g, C) {
          C || (C = {});
          var O = C.enumerable, N = C.name !== void 0 ? C.name : y;
          if (c(g) && p(g, N, C), C.global) O ? E[y] = g : m(y, g);
          else {
            try {
              C.unsafe ? E[y] && (O = !0) : delete E[y];
            } catch {
            }
            O ? E[y] = g : d.f(E, y, { value: g, enumerable: !1, configurable: !C.nonConfigurable, writable: !C.nonWritable });
          }
          return E;
        };
      }, 9190: function(l, v, s) {
        var c = s(8052);
        l.exports = function(d, p, m) {
          for (var E in p) c(d, E, p[E], m);
          return d;
        };
      }, 3072: function(l, v, s) {
        var c = s(7854), d = Object.defineProperty;
        l.exports = function(p, m) {
          try {
            d(c, p, { value: m, configurable: !0, writable: !0 });
          } catch {
            c[p] = m;
          }
          return m;
        };
      }, 5117: function(l, v, s) {
        var c = s(6330), d = TypeError;
        l.exports = function(p, m) {
          if (!delete p[m]) throw d("Cannot delete property " + c(m) + " of " + c(p));
        };
      }, 9781: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          return Object.defineProperty({}, 1, { get: function() {
            return 7;
          } })[1] != 7;
        });
      }, 4154: function(l) {
        var v = typeof document == "object" && document.all, s = v === void 0 && v !== void 0;
        l.exports = { all: v, IS_HTMLDDA: s };
      }, 317: function(l, v, s) {
        var c = s(7854), d = s(111), p = c.document, m = d(p) && d(p.createElement);
        l.exports = function(E) {
          return m ? p.createElement(E) : {};
        };
      }, 7207: function(l) {
        var v = TypeError;
        l.exports = function(s) {
          if (s > 9007199254740991) throw v("Maximum allowed index exceeded");
          return s;
        };
      }, 8324: function(l) {
        l.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 };
      }, 8509: function(l, v, s) {
        var c = s(317)("span").classList, d = c && c.constructor && c.constructor.prototype;
        l.exports = d === Object.prototype ? void 0 : d;
      }, 8886: function(l, v, s) {
        var c = s(8113).match(/firefox\/(\d+)/i);
        l.exports = !!c && +c[1];
      }, 7871: function(l, v, s) {
        var c = s(3823), d = s(5268);
        l.exports = !c && !d && typeof window == "object" && typeof document == "object";
      }, 9363: function(l) {
        l.exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";
      }, 3823: function(l) {
        l.exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";
      }, 256: function(l, v, s) {
        var c = s(8113);
        l.exports = /MSIE|Trident/.test(c);
      }, 1528: function(l, v, s) {
        var c = s(8113);
        l.exports = /ipad|iphone|ipod/i.test(c) && typeof Pebble < "u";
      }, 6833: function(l, v, s) {
        var c = s(8113);
        l.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(c);
      }, 5268: function(l, v, s) {
        var c = s(4326);
        l.exports = typeof process < "u" && c(process) == "process";
      }, 1036: function(l, v, s) {
        var c = s(8113);
        l.exports = /web0s(?!.*chrome)/i.test(c);
      }, 8113: function(l) {
        l.exports = typeof navigator < "u" && String(navigator.userAgent) || "";
      }, 7392: function(l, v, s) {
        var c, d, p = s(7854), m = s(8113), E = p.process, y = p.Deno, g = E && E.versions || y && y.version, C = g && g.v8;
        C && (d = (c = C.split("."))[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !d && m && (!(c = m.match(/Edge\/(\d+)/)) || c[1] >= 74) && (c = m.match(/Chrome\/(\d+)/)) && (d = +c[1]), l.exports = d;
      }, 8008: function(l, v, s) {
        var c = s(8113).match(/AppleWebKit\/(\d+)\./);
        l.exports = !!c && +c[1];
      }, 748: function(l) {
        l.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
      }, 2109: function(l, v, s) {
        var c = s(7854), d = s(1236).f, p = s(8880), m = s(8052), E = s(3072), y = s(9920), g = s(4705);
        l.exports = function(C, O) {
          var N, w, _, I, k, H = C.target, S = C.global, B = C.stat;
          if (N = S ? c : B ? c[H] || E(H, {}) : (c[H] || {}).prototype) for (w in O) {
            if (I = O[w], _ = C.dontCallGetSet ? (k = d(N, w)) && k.value : N[w], !g(S ? w : H + (B ? "." : "#") + w, C.forced) && _ !== void 0) {
              if (typeof I == typeof _) continue;
              y(I, _);
            }
            (C.sham || _ && _.sham) && p(I, "sham", !0), m(N, w, I, C);
          }
        };
      }, 7293: function(l) {
        l.exports = function(v) {
          try {
            return !!v();
          } catch {
            return !0;
          }
        };
      }, 7007: function(l, v, s) {
        s(4916);
        var c = s(1470), d = s(8052), p = s(2261), m = s(7293), E = s(5112), y = s(8880), g = E("species"), C = RegExp.prototype;
        l.exports = function(O, N, w, _) {
          var I = E(O), k = !m(function() {
            var D = {};
            return D[I] = function() {
              return 7;
            }, ""[O](D) != 7;
          }), H = k && !m(function() {
            var D = !1, F = /a/;
            return O === "split" && ((F = {}).constructor = {}, F.constructor[g] = function() {
              return F;
            }, F.flags = "", F[I] = /./[I]), F.exec = function() {
              return D = !0, null;
            }, F[I](""), !D;
          });
          if (!k || !H || w) {
            var S = c(/./[I]), B = N(I, ""[O], function(D, F, j, G, U) {
              var M = c(D), V = F.exec;
              return V === p || V === C.exec ? k && !U ? { done: !0, value: S(F, j, G) } : { done: !0, value: M(j, F, G) } : { done: !1 };
            });
            d(String.prototype, O, B[0]), d(C, I, B[1]);
          }
          _ && y(C[I], "sham", !0);
        };
      }, 6677: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          return Object.isExtensible(Object.preventExtensions({}));
        });
      }, 2104: function(l, v, s) {
        var c = s(4374), d = Function.prototype, p = d.apply, m = d.call;
        l.exports = typeof Reflect == "object" && Reflect.apply || (c ? m.bind(p) : function() {
          return m.apply(p, arguments);
        });
      }, 9974: function(l, v, s) {
        var c = s(1470), d = s(9662), p = s(4374), m = c(c.bind);
        l.exports = function(E, y) {
          return d(E), y === void 0 ? E : p ? m(E, y) : function() {
            return E.apply(y, arguments);
          };
        };
      }, 4374: function(l, v, s) {
        var c = s(7293);
        l.exports = !c(function() {
          var d = (function() {
          }).bind();
          return typeof d != "function" || d.hasOwnProperty("prototype");
        });
      }, 7065: function(l, v, s) {
        var c = s(1702), d = s(9662), p = s(111), m = s(2597), E = s(206), y = s(4374), g = Function, C = c([].concat), O = c([].join), N = {};
        l.exports = y ? g.bind : function(w) {
          var _ = d(this), I = _.prototype, k = E(arguments, 1), H = function() {
            var S = C(k, E(arguments));
            return this instanceof H ? function(B, D, F) {
              if (!m(N, D)) {
                for (var j = [], G = 0; G < D; G++) j[G] = "a[" + G + "]";
                N[D] = g("C,a", "return new C(" + O(j, ",") + ")");
              }
              return N[D](B, F);
            }(_, S.length, S) : _.apply(w, S);
          };
          return p(I) && (H.prototype = I), H;
        };
      }, 6916: function(l, v, s) {
        var c = s(4374), d = Function.prototype.call;
        l.exports = c ? d.bind(d) : function() {
          return d.apply(d, arguments);
        };
      }, 6530: function(l, v, s) {
        var c = s(9781), d = s(2597), p = Function.prototype, m = c && Object.getOwnPropertyDescriptor, E = d(p, "name"), y = E && (function() {
        }).name === "something", g = E && (!c || c && m(p, "name").configurable);
        l.exports = { EXISTS: E, PROPER: y, CONFIGURABLE: g };
      }, 5668: function(l, v, s) {
        var c = s(1702), d = s(9662);
        l.exports = function(p, m, E) {
          try {
            return c(d(Object.getOwnPropertyDescriptor(p, m)[E]));
          } catch {
          }
        };
      }, 1470: function(l, v, s) {
        var c = s(4326), d = s(1702);
        l.exports = function(p) {
          if (c(p) === "Function") return d(p);
        };
      }, 1702: function(l, v, s) {
        var c = s(4374), d = Function.prototype, p = d.call, m = c && d.bind.bind(p, p);
        l.exports = c ? m : function(E) {
          return function() {
            return p.apply(E, arguments);
          };
        };
      }, 5005: function(l, v, s) {
        var c = s(7854), d = s(614);
        l.exports = function(p, m) {
          return arguments.length < 2 ? (E = c[p], d(E) ? E : void 0) : c[p] && c[p][m];
          var E;
        };
      }, 1246: function(l, v, s) {
        var c = s(648), d = s(8173), p = s(8554), m = s(7497), E = s(5112)("iterator");
        l.exports = function(y) {
          if (!p(y)) return d(y, E) || d(y, "@@iterator") || m[c(y)];
        };
      }, 4121: function(l, v, s) {
        var c = s(6916), d = s(9662), p = s(9670), m = s(6330), E = s(1246), y = TypeError;
        l.exports = function(g, C) {
          var O = arguments.length < 2 ? E(g) : C;
          if (d(O)) return p(c(O, g));
          throw y(m(g) + " is not iterable");
        };
      }, 8044: function(l, v, s) {
        var c = s(1702), d = s(3157), p = s(614), m = s(4326), E = s(1340), y = c([].push);
        l.exports = function(g) {
          if (p(g)) return g;
          if (d(g)) {
            for (var C = g.length, O = [], N = 0; N < C; N++) {
              var w = g[N];
              typeof w == "string" ? y(O, w) : typeof w != "number" && m(w) != "Number" && m(w) != "String" || y(O, E(w));
            }
            var _ = O.length, I = !0;
            return function(k, H) {
              if (I) return I = !1, H;
              if (d(this)) return H;
              for (var S = 0; S < _; S++) if (O[S] === k) return H;
            };
          }
        };
      }, 8173: function(l, v, s) {
        var c = s(9662), d = s(8554);
        l.exports = function(p, m) {
          var E = p[m];
          return d(E) ? void 0 : c(E);
        };
      }, 7854: function(l, v, s) {
        var c = function(d) {
          return d && d.Math == Math && d;
        };
        l.exports = c(typeof globalThis == "object" && globalThis) || c(typeof window == "object" && window) || c(typeof self == "object" && self) || c(typeof s.g == "object" && s.g) || /* @__PURE__ */ function() {
          return this;
        }() || this || Function("return this")();
      }, 2597: function(l, v, s) {
        var c = s(1702), d = s(7908), p = c({}.hasOwnProperty);
        l.exports = Object.hasOwn || function(m, E) {
          return p(d(m), E);
        };
      }, 3501: function(l) {
        l.exports = {};
      }, 842: function(l) {
        l.exports = function(v, s) {
          try {
            arguments.length == 1 ? console.error(v) : console.error(v, s);
          } catch {
          }
        };
      }, 490: function(l, v, s) {
        var c = s(5005);
        l.exports = c("document", "documentElement");
      }, 4664: function(l, v, s) {
        var c = s(9781), d = s(7293), p = s(317);
        l.exports = !c && !d(function() {
          return Object.defineProperty(p("div"), "a", { get: function() {
            return 7;
          } }).a != 7;
        });
      }, 1179: function(l) {
        var v = Array, s = Math.abs, c = Math.pow, d = Math.floor, p = Math.log, m = Math.LN2;
        l.exports = { pack: function(E, y, g) {
          var C, O, N, w = v(g), _ = 8 * g - y - 1, I = (1 << _) - 1, k = I >> 1, H = y === 23 ? c(2, -24) - c(2, -77) : 0, S = E < 0 || E === 0 && 1 / E < 0 ? 1 : 0, B = 0;
          for ((E = s(E)) != E || E === 1 / 0 ? (O = E != E ? 1 : 0, C = I) : (C = d(p(E) / m), E * (N = c(2, -C)) < 1 && (C--, N *= 2), (E += C + k >= 1 ? H / N : H * c(2, 1 - k)) * N >= 2 && (C++, N /= 2), C + k >= I ? (O = 0, C = I) : C + k >= 1 ? (O = (E * N - 1) * c(2, y), C += k) : (O = E * c(2, k - 1) * c(2, y), C = 0)); y >= 8; ) w[B++] = 255 & O, O /= 256, y -= 8;
          for (C = C << y | O, _ += y; _ > 0; ) w[B++] = 255 & C, C /= 256, _ -= 8;
          return w[--B] |= 128 * S, w;
        }, unpack: function(E, y) {
          var g, C = E.length, O = 8 * C - y - 1, N = (1 << O) - 1, w = N >> 1, _ = O - 7, I = C - 1, k = E[I--], H = 127 & k;
          for (k >>= 7; _ > 0; ) H = 256 * H + E[I--], _ -= 8;
          for (g = H & (1 << -_) - 1, H >>= -_, _ += y; _ > 0; ) g = 256 * g + E[I--], _ -= 8;
          if (H === 0) H = 1 - w;
          else {
            if (H === N) return g ? NaN : k ? -1 / 0 : 1 / 0;
            g += c(2, y), H -= w;
          }
          return (k ? -1 : 1) * g * c(2, H - y);
        } };
      }, 8361: function(l, v, s) {
        var c = s(1702), d = s(7293), p = s(4326), m = Object, E = c("".split);
        l.exports = d(function() {
          return !m("z").propertyIsEnumerable(0);
        }) ? function(y) {
          return p(y) == "String" ? E(y, "") : m(y);
        } : m;
      }, 9587: function(l, v, s) {
        var c = s(614), d = s(111), p = s(7674);
        l.exports = function(m, E, y) {
          var g, C;
          return p && c(g = E.constructor) && g !== y && d(C = g.prototype) && C !== y.prototype && p(m, C), m;
        };
      }, 2788: function(l, v, s) {
        var c = s(1702), d = s(614), p = s(5465), m = c(Function.toString);
        d(p.inspectSource) || (p.inspectSource = function(E) {
          return m(E);
        }), l.exports = p.inspectSource;
      }, 2423: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(3501), m = s(111), E = s(2597), y = s(3070).f, g = s(8006), C = s(1156), O = s(2050), N = s(9711), w = s(6677), _ = !1, I = N("meta"), k = 0, H = function(B) {
          y(B, I, { value: { objectID: "O" + k++, weakData: {} } });
        }, S = l.exports = { enable: function() {
          S.enable = function() {
          }, _ = !0;
          var B = g.f, D = d([].splice), F = {};
          F[I] = 1, B(F).length && (g.f = function(j) {
            for (var G = B(j), U = 0, M = G.length; U < M; U++) if (G[U] === I) {
              D(G, U, 1);
              break;
            }
            return G;
          }, c({ target: "Object", stat: !0, forced: !0 }, { getOwnPropertyNames: C.f }));
        }, fastKey: function(B, D) {
          if (!m(B)) return typeof B == "symbol" ? B : (typeof B == "string" ? "S" : "P") + B;
          if (!E(B, I)) {
            if (!O(B)) return "F";
            if (!D) return "E";
            H(B);
          }
          return B[I].objectID;
        }, getWeakData: function(B, D) {
          if (!E(B, I)) {
            if (!O(B)) return !0;
            if (!D) return !1;
            H(B);
          }
          return B[I].weakData;
        }, onFreeze: function(B) {
          return w && _ && O(B) && !E(B, I) && H(B), B;
        } };
        p[I] = !0;
      }, 9909: function(l, v, s) {
        var c, d, p, m = s(4811), E = s(7854), y = s(111), g = s(8880), C = s(2597), O = s(5465), N = s(6200), w = s(3501), _ = "Object already initialized", I = E.TypeError, k = E.WeakMap;
        if (m || O.state) {
          var H = O.state || (O.state = new k());
          H.get = H.get, H.has = H.has, H.set = H.set, c = function(B, D) {
            if (H.has(B)) throw I(_);
            return D.facade = B, H.set(B, D), D;
          }, d = function(B) {
            return H.get(B) || {};
          }, p = function(B) {
            return H.has(B);
          };
        } else {
          var S = N("state");
          w[S] = !0, c = function(B, D) {
            if (C(B, S)) throw I(_);
            return D.facade = B, g(B, S, D), D;
          }, d = function(B) {
            return C(B, S) ? B[S] : {};
          }, p = function(B) {
            return C(B, S);
          };
        }
        l.exports = { set: c, get: d, has: p, enforce: function(B) {
          return p(B) ? d(B) : c(B, {});
        }, getterFor: function(B) {
          return function(D) {
            var F;
            if (!y(D) || (F = d(D)).type !== B) throw I("Incompatible receiver, " + B + " required");
            return F;
          };
        } };
      }, 7659: function(l, v, s) {
        var c = s(5112), d = s(7497), p = c("iterator"), m = Array.prototype;
        l.exports = function(E) {
          return E !== void 0 && (d.Array === E || m[p] === E);
        };
      }, 3157: function(l, v, s) {
        var c = s(4326);
        l.exports = Array.isArray || function(d) {
          return c(d) == "Array";
        };
      }, 4067: function(l, v, s) {
        var c = s(648);
        l.exports = function(d) {
          var p = c(d);
          return p == "BigInt64Array" || p == "BigUint64Array";
        };
      }, 614: function(l, v, s) {
        var c = s(4154), d = c.all;
        l.exports = c.IS_HTMLDDA ? function(p) {
          return typeof p == "function" || p === d;
        } : function(p) {
          return typeof p == "function";
        };
      }, 4411: function(l, v, s) {
        var c = s(1702), d = s(7293), p = s(614), m = s(648), E = s(5005), y = s(2788), g = function() {
        }, C = [], O = E("Reflect", "construct"), N = /^\s*(?:class|function)\b/, w = c(N.exec), _ = !N.exec(g), I = function(H) {
          if (!p(H)) return !1;
          try {
            return O(g, C, H), !0;
          } catch {
            return !1;
          }
        }, k = function(H) {
          if (!p(H)) return !1;
          switch (m(H)) {
            case "AsyncFunction":
            case "GeneratorFunction":
            case "AsyncGeneratorFunction":
              return !1;
          }
          try {
            return _ || !!w(N, y(H));
          } catch {
            return !0;
          }
        };
        k.sham = !0, l.exports = !O || d(function() {
          var H;
          return I(I.call) || !I(Object) || !I(function() {
            H = !0;
          }) || H;
        }) ? k : I;
      }, 4705: function(l, v, s) {
        var c = s(7293), d = s(614), p = /#|\.prototype\./, m = function(O, N) {
          var w = y[E(O)];
          return w == C || w != g && (d(N) ? c(N) : !!N);
        }, E = m.normalize = function(O) {
          return String(O).replace(p, ".").toLowerCase();
        }, y = m.data = {}, g = m.NATIVE = "N", C = m.POLYFILL = "P";
        l.exports = m;
      }, 5988: function(l, v, s) {
        var c = s(111), d = Math.floor;
        l.exports = Number.isInteger || function(p) {
          return !c(p) && isFinite(p) && d(p) === p;
        };
      }, 8554: function(l) {
        l.exports = function(v) {
          return v == null;
        };
      }, 111: function(l, v, s) {
        var c = s(614), d = s(4154), p = d.all;
        l.exports = d.IS_HTMLDDA ? function(m) {
          return typeof m == "object" ? m !== null : c(m) || m === p;
        } : function(m) {
          return typeof m == "object" ? m !== null : c(m);
        };
      }, 1913: function(l) {
        l.exports = !1;
      }, 7850: function(l, v, s) {
        var c = s(111), d = s(4326), p = s(5112)("match");
        l.exports = function(m) {
          var E;
          return c(m) && ((E = m[p]) !== void 0 ? !!E : d(m) == "RegExp");
        };
      }, 2190: function(l, v, s) {
        var c = s(5005), d = s(614), p = s(7976), m = s(3307), E = Object;
        l.exports = m ? function(y) {
          return typeof y == "symbol";
        } : function(y) {
          var g = c("Symbol");
          return d(g) && p(g.prototype, E(y));
        };
      }, 408: function(l, v, s) {
        var c = s(9974), d = s(6916), p = s(9670), m = s(6330), E = s(7659), y = s(6244), g = s(7976), C = s(4121), O = s(1246), N = s(9212), w = TypeError, _ = function(k, H) {
          this.stopped = k, this.result = H;
        }, I = _.prototype;
        l.exports = function(k, H, S) {
          var B, D, F, j, G, U, M, V = S && S.that, J = !(!S || !S.AS_ENTRIES), ue = !(!S || !S.IS_RECORD), se = !(!S || !S.IS_ITERATOR), ee = !(!S || !S.INTERRUPTED), de = c(H, V), he = function(Ce) {
            return B && N(B, "normal", Ce), new _(!0, Ce);
          }, pe = function(Ce) {
            return J ? (p(Ce), ee ? de(Ce[0], Ce[1], he) : de(Ce[0], Ce[1])) : ee ? de(Ce, he) : de(Ce);
          };
          if (ue) B = k.iterator;
          else if (se) B = k;
          else {
            if (!(D = O(k))) throw w(m(k) + " is not iterable");
            if (E(D)) {
              for (F = 0, j = y(k); j > F; F++) if ((G = pe(k[F])) && g(I, G)) return G;
              return new _(!1);
            }
            B = C(k, D);
          }
          for (U = ue ? k.next : B.next; !(M = d(U, B)).done; ) {
            try {
              G = pe(M.value);
            } catch (Ce) {
              N(B, "throw", Ce);
            }
            if (typeof G == "object" && G && g(I, G)) return G;
          }
          return new _(!1);
        };
      }, 9212: function(l, v, s) {
        var c = s(6916), d = s(9670), p = s(8173);
        l.exports = function(m, E, y) {
          var g, C;
          d(m);
          try {
            if (!(g = p(m, "return"))) {
              if (E === "throw") throw y;
              return y;
            }
            g = c(g, m);
          } catch (O) {
            C = !0, g = O;
          }
          if (E === "throw") throw y;
          if (C) throw g;
          return d(g), y;
        };
      }, 3061: function(l, v, s) {
        var c = s(3383).IteratorPrototype, d = s(30), p = s(9114), m = s(8003), E = s(7497), y = function() {
          return this;
        };
        l.exports = function(g, C, O, N) {
          var w = C + " Iterator";
          return g.prototype = d(c, { next: p(+!N, O) }), m(g, w, !1, !0), E[w] = y, g;
        };
      }, 1656: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(1913), m = s(6530), E = s(614), y = s(3061), g = s(9518), C = s(7674), O = s(8003), N = s(8880), w = s(8052), _ = s(5112), I = s(7497), k = s(3383), H = m.PROPER, S = m.CONFIGURABLE, B = k.IteratorPrototype, D = k.BUGGY_SAFARI_ITERATORS, F = _("iterator"), j = "keys", G = "values", U = "entries", M = function() {
          return this;
        };
        l.exports = function(V, J, ue, se, ee, de, he) {
          y(ue, J, se);
          var pe, Ce, _e, Le = function($e) {
            if ($e === ee && xe) return xe;
            if (!D && $e in Oe) return Oe[$e];
            switch ($e) {
              case j:
              case G:
              case U:
                return function() {
                  return new ue(this, $e);
                };
            }
            return function() {
              return new ue(this);
            };
          }, Te = J + " Iterator", K = !1, Oe = V.prototype, Pe = Oe[F] || Oe["@@iterator"] || ee && Oe[ee], xe = !D && Pe || Le(ee), be = J == "Array" && Oe.entries || Pe;
          if (be && (pe = g(be.call(new V()))) !== Object.prototype && pe.next && (p || g(pe) === B || (C ? C(pe, B) : E(pe[F]) || w(pe, F, M)), O(pe, Te, !0, !0), p && (I[Te] = M)), H && ee == G && Pe && Pe.name !== G && (!p && S ? N(Oe, "name", G) : (K = !0, xe = function() {
            return d(Pe, this);
          })), ee) if (Ce = { values: Le(G), keys: de ? xe : Le(j), entries: Le(U) }, he) for (_e in Ce) (D || K || !(_e in Oe)) && w(Oe, _e, Ce[_e]);
          else c({ target: J, proto: !0, forced: D || K }, Ce);
          return p && !he || Oe[F] === xe || w(Oe, F, xe, { name: ee }), I[J] = xe, Ce;
        };
      }, 3383: function(l, v, s) {
        var c, d, p, m = s(7293), E = s(614), y = s(111), g = s(30), C = s(9518), O = s(8052), N = s(5112), w = s(1913), _ = N("iterator"), I = !1;
        [].keys && ("next" in (p = [].keys()) ? (d = C(C(p))) !== Object.prototype && (c = d) : I = !0), !y(c) || m(function() {
          var k = {};
          return c[_].call(k) !== k;
        }) ? c = {} : w && (c = g(c)), E(c[_]) || O(c, _, function() {
          return this;
        }), l.exports = { IteratorPrototype: c, BUGGY_SAFARI_ITERATORS: I };
      }, 7497: function(l) {
        l.exports = {};
      }, 6244: function(l, v, s) {
        var c = s(7466);
        l.exports = function(d) {
          return c(d.length);
        };
      }, 6339: function(l, v, s) {
        var c = s(1702), d = s(7293), p = s(614), m = s(2597), E = s(9781), y = s(6530).CONFIGURABLE, g = s(2788), C = s(9909), O = C.enforce, N = C.get, w = String, _ = Object.defineProperty, I = c("".slice), k = c("".replace), H = c([].join), S = E && !d(function() {
          return _(function() {
          }, "length", { value: 8 }).length !== 8;
        }), B = String(String).split("String"), D = l.exports = function(F, j, G) {
          I(w(j), 0, 7) === "Symbol(" && (j = "[" + k(w(j), /^Symbol\(([^)]*)\)/, "$1") + "]"), G && G.getter && (j = "get " + j), G && G.setter && (j = "set " + j), (!m(F, "name") || y && F.name !== j) && (E ? _(F, "name", { value: j, configurable: !0 }) : F.name = j), S && G && m(G, "arity") && F.length !== G.arity && _(F, "length", { value: G.arity });
          try {
            G && m(G, "constructor") && G.constructor ? E && _(F, "prototype", { writable: !1 }) : F.prototype && (F.prototype = void 0);
          } catch {
          }
          var U = O(F);
          return m(U, "source") || (U.source = H(B, typeof j == "string" ? j : "")), F;
        };
        Function.prototype.toString = D(function() {
          return p(this) && N(this).source || g(this);
        }, "toString");
      }, 4758: function(l) {
        var v = Math.ceil, s = Math.floor;
        l.exports = Math.trunc || function(c) {
          var d = +c;
          return (d > 0 ? s : v)(d);
        };
      }, 5948: function(l, v, s) {
        var c, d, p, m, E, y = s(7854), g = s(9974), C = s(1236).f, O = s(261).set, N = s(8572), w = s(6833), _ = s(1528), I = s(1036), k = s(5268), H = y.MutationObserver || y.WebKitMutationObserver, S = y.document, B = y.process, D = y.Promise, F = C(y, "queueMicrotask"), j = F && F.value;
        if (!j) {
          var G = new N(), U = function() {
            var M, V;
            for (k && (M = B.domain) && M.exit(); V = G.get(); ) try {
              V();
            } catch (J) {
              throw G.head && c(), J;
            }
            M && M.enter();
          };
          w || k || I || !H || !S ? !_ && D && D.resolve ? ((m = D.resolve(void 0)).constructor = D, E = g(m.then, m), c = function() {
            E(U);
          }) : k ? c = function() {
            B.nextTick(U);
          } : (O = g(O, y), c = function() {
            O(U);
          }) : (d = !0, p = S.createTextNode(""), new H(U).observe(p, { characterData: !0 }), c = function() {
            p.data = d = !d;
          }), j = function(M) {
            G.head || c(), G.add(M);
          };
        }
        l.exports = j;
      }, 8523: function(l, v, s) {
        var c = s(9662), d = TypeError, p = function(m) {
          var E, y;
          this.promise = new m(function(g, C) {
            if (E !== void 0 || y !== void 0) throw d("Bad Promise constructor");
            E = g, y = C;
          }), this.resolve = c(E), this.reject = c(y);
        };
        l.exports.f = function(m) {
          return new p(m);
        };
      }, 3929: function(l, v, s) {
        var c = s(7850), d = TypeError;
        l.exports = function(p) {
          if (c(p)) throw d("The method doesn't accept regular expressions");
          return p;
        };
      }, 1574: function(l, v, s) {
        var c = s(9781), d = s(1702), p = s(6916), m = s(7293), E = s(1956), y = s(5181), g = s(5296), C = s(7908), O = s(8361), N = Object.assign, w = Object.defineProperty, _ = d([].concat);
        l.exports = !N || m(function() {
          if (c && N({ b: 1 }, N(w({}, "a", { enumerable: !0, get: function() {
            w(this, "b", { value: 3, enumerable: !1 });
          } }), { b: 2 })).b !== 1) return !0;
          var I = {}, k = {}, H = Symbol(), S = "abcdefghijklmnopqrst";
          return I[H] = 7, S.split("").forEach(function(B) {
            k[B] = B;
          }), N({}, I)[H] != 7 || E(N({}, k)).join("") != S;
        }) ? function(I, k) {
          for (var H = C(I), S = arguments.length, B = 1, D = y.f, F = g.f; S > B; ) for (var j, G = O(arguments[B++]), U = D ? _(E(G), D(G)) : E(G), M = U.length, V = 0; M > V; ) j = U[V++], c && !p(F, G, j) || (H[j] = G[j]);
          return H;
        } : N;
      }, 30: function(l, v, s) {
        var c, d = s(9670), p = s(6048), m = s(748), E = s(3501), y = s(490), g = s(317), C = s(6200), O = "prototype", N = "script", w = C("IE_PROTO"), _ = function() {
        }, I = function(S) {
          return "<" + N + ">" + S + "</" + N + ">";
        }, k = function(S) {
          S.write(I("")), S.close();
          var B = S.parentWindow.Object;
          return S = null, B;
        }, H = function() {
          try {
            c = new ActiveXObject("htmlfile");
          } catch {
          }
          var S, B, D;
          H = typeof document < "u" ? document.domain && c ? k(c) : (B = g("iframe"), D = "java" + N + ":", B.style.display = "none", y.appendChild(B), B.src = String(D), (S = B.contentWindow.document).open(), S.write(I("document.F=Object")), S.close(), S.F) : k(c);
          for (var F = m.length; F--; ) delete H[O][m[F]];
          return H();
        };
        E[w] = !0, l.exports = Object.create || function(S, B) {
          var D;
          return S !== null ? (_[O] = d(S), D = new _(), _[O] = null, D[w] = S) : D = H(), B === void 0 ? D : p.f(D, B);
        };
      }, 6048: function(l, v, s) {
        var c = s(9781), d = s(3353), p = s(3070), m = s(9670), E = s(5656), y = s(1956);
        v.f = c && !d ? Object.defineProperties : function(g, C) {
          m(g);
          for (var O, N = E(C), w = y(C), _ = w.length, I = 0; _ > I; ) p.f(g, O = w[I++], N[O]);
          return g;
        };
      }, 3070: function(l, v, s) {
        var c = s(9781), d = s(4664), p = s(3353), m = s(9670), E = s(4948), y = TypeError, g = Object.defineProperty, C = Object.getOwnPropertyDescriptor, O = "enumerable", N = "configurable", w = "writable";
        v.f = c ? p ? function(_, I, k) {
          if (m(_), I = E(I), m(k), typeof _ == "function" && I === "prototype" && "value" in k && w in k && !k[w]) {
            var H = C(_, I);
            H && H[w] && (_[I] = k.value, k = { configurable: N in k ? k[N] : H[N], enumerable: O in k ? k[O] : H[O], writable: !1 });
          }
          return g(_, I, k);
        } : g : function(_, I, k) {
          if (m(_), I = E(I), m(k), d) try {
            return g(_, I, k);
          } catch {
          }
          if ("get" in k || "set" in k) throw y("Accessors not supported");
          return "value" in k && (_[I] = k.value), _;
        };
      }, 1236: function(l, v, s) {
        var c = s(9781), d = s(6916), p = s(5296), m = s(9114), E = s(5656), y = s(4948), g = s(2597), C = s(4664), O = Object.getOwnPropertyDescriptor;
        v.f = c ? O : function(N, w) {
          if (N = E(N), w = y(w), C) try {
            return O(N, w);
          } catch {
          }
          if (g(N, w)) return m(!d(p.f, N, w), N[w]);
        };
      }, 1156: function(l, v, s) {
        var c = s(4326), d = s(5656), p = s(8006).f, m = s(1589), E = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        l.exports.f = function(y) {
          return E && c(y) == "Window" ? function(g) {
            try {
              return p(g);
            } catch {
              return m(E);
            }
          }(y) : p(d(y));
        };
      }, 8006: function(l, v, s) {
        var c = s(6324), d = s(748).concat("length", "prototype");
        v.f = Object.getOwnPropertyNames || function(p) {
          return c(p, d);
        };
      }, 5181: function(l, v) {
        v.f = Object.getOwnPropertySymbols;
      }, 9518: function(l, v, s) {
        var c = s(2597), d = s(614), p = s(7908), m = s(6200), E = s(8544), y = m("IE_PROTO"), g = Object, C = g.prototype;
        l.exports = E ? g.getPrototypeOf : function(O) {
          var N = p(O);
          if (c(N, y)) return N[y];
          var w = N.constructor;
          return d(w) && N instanceof w ? w.prototype : N instanceof g ? C : null;
        };
      }, 2050: function(l, v, s) {
        var c = s(7293), d = s(111), p = s(4326), m = s(7556), E = Object.isExtensible, y = c(function() {
        });
        l.exports = y || m ? function(g) {
          return !!d(g) && (!m || p(g) != "ArrayBuffer") && (!E || E(g));
        } : E;
      }, 7976: function(l, v, s) {
        var c = s(1702);
        l.exports = c({}.isPrototypeOf);
      }, 6324: function(l, v, s) {
        var c = s(1702), d = s(2597), p = s(5656), m = s(1318).indexOf, E = s(3501), y = c([].push);
        l.exports = function(g, C) {
          var O, N = p(g), w = 0, _ = [];
          for (O in N) !d(E, O) && d(N, O) && y(_, O);
          for (; C.length > w; ) d(N, O = C[w++]) && (~m(_, O) || y(_, O));
          return _;
        };
      }, 1956: function(l, v, s) {
        var c = s(6324), d = s(748);
        l.exports = Object.keys || function(p) {
          return c(p, d);
        };
      }, 5296: function(l, v) {
        var s = {}.propertyIsEnumerable, c = Object.getOwnPropertyDescriptor, d = c && !s.call({ 1: 2 }, 1);
        v.f = d ? function(p) {
          var m = c(this, p);
          return !!m && m.enumerable;
        } : s;
      }, 7674: function(l, v, s) {
        var c = s(5668), d = s(9670), p = s(6077);
        l.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
          var m, E = !1, y = {};
          try {
            (m = c(Object.prototype, "__proto__", "set"))(y, []), E = y instanceof Array;
          } catch {
          }
          return function(g, C) {
            return d(g), p(C), E ? m(g, C) : g.__proto__ = C, g;
          };
        }() : void 0);
      }, 4699: function(l, v, s) {
        var c = s(9781), d = s(1702), p = s(1956), m = s(5656), E = d(s(5296).f), y = d([].push), g = function(C) {
          return function(O) {
            for (var N, w = m(O), _ = p(w), I = _.length, k = 0, H = []; I > k; ) N = _[k++], c && !E(w, N) || y(H, C ? [N, w[N]] : w[N]);
            return H;
          };
        };
        l.exports = { entries: g(!0), values: g(!1) };
      }, 288: function(l, v, s) {
        var c = s(1694), d = s(648);
        l.exports = c ? {}.toString : function() {
          return "[object " + d(this) + "]";
        };
      }, 2140: function(l, v, s) {
        var c = s(6916), d = s(614), p = s(111), m = TypeError;
        l.exports = function(E, y) {
          var g, C;
          if (y === "string" && d(g = E.toString) && !p(C = c(g, E)) || d(g = E.valueOf) && !p(C = c(g, E)) || y !== "string" && d(g = E.toString) && !p(C = c(g, E))) return C;
          throw m("Can't convert object to primitive value");
        };
      }, 3887: function(l, v, s) {
        var c = s(5005), d = s(1702), p = s(8006), m = s(5181), E = s(9670), y = d([].concat);
        l.exports = c("Reflect", "ownKeys") || function(g) {
          var C = p.f(E(g)), O = m.f;
          return O ? y(C, O(g)) : C;
        };
      }, 857: function(l, v, s) {
        var c = s(7854);
        l.exports = c;
      }, 2534: function(l) {
        l.exports = function(v) {
          try {
            return { error: !1, value: v() };
          } catch (s) {
            return { error: !0, value: s };
          }
        };
      }, 3702: function(l, v, s) {
        var c = s(7854), d = s(2492), p = s(614), m = s(4705), E = s(2788), y = s(5112), g = s(7871), C = s(3823), O = s(1913), N = s(7392), w = d && d.prototype, _ = y("species"), I = !1, k = p(c.PromiseRejectionEvent), H = m("Promise", function() {
          var S = E(d), B = S !== String(d);
          if (!B && N === 66 || O && (!w.catch || !w.finally)) return !0;
          if (!N || N < 51 || !/native code/.test(S)) {
            var D = new d(function(j) {
              j(1);
            }), F = function(j) {
              j(function() {
              }, function() {
              });
            };
            if ((D.constructor = {})[_] = F, !(I = D.then(function() {
            }) instanceof F)) return !0;
          }
          return !B && (g || C) && !k;
        });
        l.exports = { CONSTRUCTOR: H, REJECTION_EVENT: k, SUBCLASSING: I };
      }, 2492: function(l, v, s) {
        var c = s(7854);
        l.exports = c.Promise;
      }, 9478: function(l, v, s) {
        var c = s(9670), d = s(111), p = s(8523);
        l.exports = function(m, E) {
          if (c(m), d(E) && E.constructor === m) return E;
          var y = p.f(m);
          return (0, y.resolve)(E), y.promise;
        };
      }, 612: function(l, v, s) {
        var c = s(2492), d = s(7072), p = s(3702).CONSTRUCTOR;
        l.exports = p || !d(function(m) {
          c.all(m).then(void 0, function() {
          });
        });
      }, 8572: function(l) {
        var v = function() {
          this.head = null, this.tail = null;
        };
        v.prototype = { add: function(s) {
          var c = { item: s, next: null }, d = this.tail;
          d ? d.next = c : this.head = c, this.tail = c;
        }, get: function() {
          var s = this.head;
          if (s) return (this.head = s.next) === null && (this.tail = null), s.item;
        } }, l.exports = v;
      }, 7651: function(l, v, s) {
        var c = s(6916), d = s(9670), p = s(614), m = s(4326), E = s(2261), y = TypeError;
        l.exports = function(g, C) {
          var O = g.exec;
          if (p(O)) {
            var N = c(O, g, C);
            return N !== null && d(N), N;
          }
          if (m(g) === "RegExp") return c(E, g, C);
          throw y("RegExp#exec called on incompatible receiver");
        };
      }, 2261: function(l, v, s) {
        var c, d, p = s(6916), m = s(1702), E = s(1340), y = s(7066), g = s(2999), C = s(2309), O = s(30), N = s(9909).get, w = s(9441), _ = s(7168), I = C("native-string-replace", String.prototype.replace), k = RegExp.prototype.exec, H = k, S = m("".charAt), B = m("".indexOf), D = m("".replace), F = m("".slice), j = (d = /b*/g, p(k, c = /a/, "a"), p(k, d, "a"), c.lastIndex !== 0 || d.lastIndex !== 0), G = g.BROKEN_CARET, U = /()??/.exec("")[1] !== void 0;
        (j || U || G || w || _) && (H = function(M) {
          var V, J, ue, se, ee, de, he, pe = this, Ce = N(pe), _e = E(M), Le = Ce.raw;
          if (Le) return Le.lastIndex = pe.lastIndex, V = p(H, Le, _e), pe.lastIndex = Le.lastIndex, V;
          var Te = Ce.groups, K = G && pe.sticky, Oe = p(y, pe), Pe = pe.source, xe = 0, be = _e;
          if (K && (Oe = D(Oe, "y", ""), B(Oe, "g") === -1 && (Oe += "g"), be = F(_e, pe.lastIndex), pe.lastIndex > 0 && (!pe.multiline || pe.multiline && S(_e, pe.lastIndex - 1) !== `
`) && (Pe = "(?: " + Pe + ")", be = " " + be, xe++), J = new RegExp("^(?:" + Pe + ")", Oe)), U && (J = new RegExp("^" + Pe + "$(?!\\s)", Oe)), j && (ue = pe.lastIndex), se = p(k, K ? J : pe, be), K ? se ? (se.input = F(se.input, xe), se[0] = F(se[0], xe), se.index = pe.lastIndex, pe.lastIndex += se[0].length) : pe.lastIndex = 0 : j && se && (pe.lastIndex = pe.global ? se.index + se[0].length : ue), U && se && se.length > 1 && p(I, se[0], J, function() {
            for (ee = 1; ee < arguments.length - 2; ee++) arguments[ee] === void 0 && (se[ee] = void 0);
          }), se && Te) for (se.groups = de = O(null), ee = 0; ee < Te.length; ee++) de[(he = Te[ee])[0]] = se[he[1]];
          return se;
        }), l.exports = H;
      }, 7066: function(l, v, s) {
        var c = s(9670);
        l.exports = function() {
          var d = c(this), p = "";
          return d.hasIndices && (p += "d"), d.global && (p += "g"), d.ignoreCase && (p += "i"), d.multiline && (p += "m"), d.dotAll && (p += "s"), d.unicode && (p += "u"), d.unicodeSets && (p += "v"), d.sticky && (p += "y"), p;
        };
      }, 4706: function(l, v, s) {
        var c = s(6916), d = s(2597), p = s(7976), m = s(7066), E = RegExp.prototype;
        l.exports = function(y) {
          var g = y.flags;
          return g !== void 0 || "flags" in E || d(y, "flags") || !p(E, y) ? g : c(m, y);
        };
      }, 2999: function(l, v, s) {
        var c = s(7293), d = s(7854).RegExp, p = c(function() {
          var y = d("a", "y");
          return y.lastIndex = 2, y.exec("abcd") != null;
        }), m = p || c(function() {
          return !d("a", "y").sticky;
        }), E = p || c(function() {
          var y = d("^r", "gy");
          return y.lastIndex = 2, y.exec("str") != null;
        });
        l.exports = { BROKEN_CARET: E, MISSED_STICKY: m, UNSUPPORTED_Y: p };
      }, 9441: function(l, v, s) {
        var c = s(7293), d = s(7854).RegExp;
        l.exports = c(function() {
          var p = d(".", "s");
          return !(p.dotAll && p.exec(`
`) && p.flags === "s");
        });
      }, 7168: function(l, v, s) {
        var c = s(7293), d = s(7854).RegExp;
        l.exports = c(function() {
          var p = d("(?<a>b)", "g");
          return p.exec("b").groups.a !== "b" || "b".replace(p, "$<a>c") !== "bc";
        });
      }, 4488: function(l, v, s) {
        var c = s(8554), d = TypeError;
        l.exports = function(p) {
          if (c(p)) throw d("Can't call method on " + p);
          return p;
        };
      }, 7152: function(l, v, s) {
        var c, d = s(7854), p = s(2104), m = s(614), E = s(9363), y = s(8113), g = s(206), C = s(8053), O = d.Function, N = /MSIE .\./.test(y) || E && ((c = d.Bun.version.split(".")).length < 3 || c[0] == 0 && (c[1] < 3 || c[1] == 3 && c[2] == 0));
        l.exports = function(w, _) {
          var I = _ ? 2 : 1;
          return N ? function(k, H) {
            var S = C(arguments.length, 1) > I, B = m(k) ? k : O(k), D = S ? g(arguments, I) : [], F = S ? function() {
              p(B, this, D);
            } : B;
            return _ ? w(F, H) : w(F);
          } : w;
        };
      }, 6340: function(l, v, s) {
        var c = s(5005), d = s(7045), p = s(5112), m = s(9781), E = p("species");
        l.exports = function(y) {
          var g = c(y);
          m && g && !g[E] && d(g, E, { configurable: !0, get: function() {
            return this;
          } });
        };
      }, 8003: function(l, v, s) {
        var c = s(3070).f, d = s(2597), p = s(5112)("toStringTag");
        l.exports = function(m, E, y) {
          m && !y && (m = m.prototype), m && !d(m, p) && c(m, p, { configurable: !0, value: E });
        };
      }, 6200: function(l, v, s) {
        var c = s(2309), d = s(9711), p = c("keys");
        l.exports = function(m) {
          return p[m] || (p[m] = d(m));
        };
      }, 5465: function(l, v, s) {
        var c = s(7854), d = s(3072), p = "__core-js_shared__", m = c[p] || d(p, {});
        l.exports = m;
      }, 2309: function(l, v, s) {
        var c = s(1913), d = s(5465);
        (l.exports = function(p, m) {
          return d[p] || (d[p] = m !== void 0 ? m : {});
        })("versions", []).push({ version: "3.30.2", mode: c ? "pure" : "global", copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE", source: "https://github.com/zloirock/core-js" });
      }, 6707: function(l, v, s) {
        var c = s(9670), d = s(9483), p = s(8554), m = s(5112)("species");
        l.exports = function(E, y) {
          var g, C = c(E).constructor;
          return C === void 0 || p(g = c(C)[m]) ? y : d(g);
        };
      }, 8710: function(l, v, s) {
        var c = s(1702), d = s(9303), p = s(1340), m = s(4488), E = c("".charAt), y = c("".charCodeAt), g = c("".slice), C = function(O) {
          return function(N, w) {
            var _, I, k = p(m(N)), H = d(w), S = k.length;
            return H < 0 || H >= S ? O ? "" : void 0 : (_ = y(k, H)) < 55296 || _ > 56319 || H + 1 === S || (I = y(k, H + 1)) < 56320 || I > 57343 ? O ? E(k, H) : _ : O ? g(k, H, H + 2) : I - 56320 + (_ - 55296 << 10) + 65536;
          };
        };
        l.exports = { codeAt: C(!1), charAt: C(!0) };
      }, 3197: function(l, v, s) {
        var c = s(1702), d = 2147483647, p = /[^\0-\u007E]/, m = /[.\u3002\uFF0E\uFF61]/g, E = "Overflow: input needs wider integers to process", y = RangeError, g = c(m.exec), C = Math.floor, O = String.fromCharCode, N = c("".charCodeAt), w = c([].join), _ = c([].push), I = c("".replace), k = c("".split), H = c("".toLowerCase), S = function(F) {
          return F + 22 + 75 * (F < 26);
        }, B = function(F, j, G) {
          var U = 0;
          for (F = G ? C(F / 700) : F >> 1, F += C(F / j); F > 455; ) F = C(F / 35), U += 36;
          return C(U + 36 * F / (F + 38));
        }, D = function(F) {
          var j = [];
          F = function(K) {
            for (var Oe = [], Pe = 0, xe = K.length; Pe < xe; ) {
              var be = N(K, Pe++);
              if (be >= 55296 && be <= 56319 && Pe < xe) {
                var $e = N(K, Pe++);
                (64512 & $e) == 56320 ? _(Oe, ((1023 & be) << 10) + (1023 & $e) + 65536) : (_(Oe, be), Pe--);
              } else _(Oe, be);
            }
            return Oe;
          }(F);
          var G, U, M = F.length, V = 128, J = 0, ue = 72;
          for (G = 0; G < F.length; G++) (U = F[G]) < 128 && _(j, O(U));
          var se = j.length, ee = se;
          for (se && _(j, "-"); ee < M; ) {
            var de = d;
            for (G = 0; G < F.length; G++) (U = F[G]) >= V && U < de && (de = U);
            var he = ee + 1;
            if (de - V > C((d - J) / he)) throw y(E);
            for (J += (de - V) * he, V = de, G = 0; G < F.length; G++) {
              if ((U = F[G]) < V && ++J > d) throw y(E);
              if (U == V) {
                for (var pe = J, Ce = 36; ; ) {
                  var _e = Ce <= ue ? 1 : Ce >= ue + 26 ? 26 : Ce - ue;
                  if (pe < _e) break;
                  var Le = pe - _e, Te = 36 - _e;
                  _(j, O(S(_e + Le % Te))), pe = C(Le / Te), Ce += 36;
                }
                _(j, O(S(pe))), ue = B(J, he, ee == se), J = 0, ee++;
              }
            }
            J++, V++;
          }
          return w(j, "");
        };
        l.exports = function(F) {
          var j, G, U = [], M = k(I(H(F), m, "."), ".");
          for (j = 0; j < M.length; j++) G = M[j], _(U, g(p, G) ? "xn--" + D(G) : G);
          return w(U, ".");
        };
      }, 3111: function(l, v, s) {
        var c = s(1702), d = s(4488), p = s(1340), m = s(1361), E = c("".replace), y = RegExp("^[" + m + "]+"), g = RegExp("(^|[^" + m + "])[" + m + "]+$"), C = function(O) {
          return function(N) {
            var w = p(d(N));
            return 1 & O && (w = E(w, y, "")), 2 & O && (w = E(w, g, "$1")), w;
          };
        };
        l.exports = { start: C(1), end: C(2), trim: C(3) };
      }, 6293: function(l, v, s) {
        var c = s(7392), d = s(7293), p = s(7854).String;
        l.exports = !!Object.getOwnPropertySymbols && !d(function() {
          var m = Symbol();
          return !p(m) || !(Object(m) instanceof Symbol) || !Symbol.sham && c && c < 41;
        });
      }, 6532: function(l, v, s) {
        var c = s(6916), d = s(5005), p = s(5112), m = s(8052);
        l.exports = function() {
          var E = d("Symbol"), y = E && E.prototype, g = y && y.valueOf, C = p("toPrimitive");
          y && !y[C] && m(y, C, function(O) {
            return c(g, this);
          }, { arity: 1 });
        };
      }, 2015: function(l, v, s) {
        var c = s(6293);
        l.exports = c && !!Symbol.for && !!Symbol.keyFor;
      }, 261: function(l, v, s) {
        var c, d, p, m, E = s(7854), y = s(2104), g = s(9974), C = s(614), O = s(2597), N = s(7293), w = s(490), _ = s(206), I = s(317), k = s(8053), H = s(6833), S = s(5268), B = E.setImmediate, D = E.clearImmediate, F = E.process, j = E.Dispatch, G = E.Function, U = E.MessageChannel, M = E.String, V = 0, J = {}, ue = "onreadystatechange";
        N(function() {
          c = E.location;
        });
        var se = function(pe) {
          if (O(J, pe)) {
            var Ce = J[pe];
            delete J[pe], Ce();
          }
        }, ee = function(pe) {
          return function() {
            se(pe);
          };
        }, de = function(pe) {
          se(pe.data);
        }, he = function(pe) {
          E.postMessage(M(pe), c.protocol + "//" + c.host);
        };
        B && D || (B = function(pe) {
          k(arguments.length, 1);
          var Ce = C(pe) ? pe : G(pe), _e = _(arguments, 1);
          return J[++V] = function() {
            y(Ce, void 0, _e);
          }, d(V), V;
        }, D = function(pe) {
          delete J[pe];
        }, S ? d = function(pe) {
          F.nextTick(ee(pe));
        } : j && j.now ? d = function(pe) {
          j.now(ee(pe));
        } : U && !H ? (m = (p = new U()).port2, p.port1.onmessage = de, d = g(m.postMessage, m)) : E.addEventListener && C(E.postMessage) && !E.importScripts && c && c.protocol !== "file:" && !N(he) ? (d = he, E.addEventListener("message", de, !1)) : d = ue in I("script") ? function(pe) {
          w.appendChild(I("script"))[ue] = function() {
            w.removeChild(this), se(pe);
          };
        } : function(pe) {
          setTimeout(ee(pe), 0);
        }), l.exports = { set: B, clear: D };
      }, 863: function(l, v, s) {
        var c = s(1702);
        l.exports = c(1 .valueOf);
      }, 1400: function(l, v, s) {
        var c = s(9303), d = Math.max, p = Math.min;
        l.exports = function(m, E) {
          var y = c(m);
          return y < 0 ? d(y + E, 0) : p(y, E);
        };
      }, 4599: function(l, v, s) {
        var c = s(7593), d = TypeError;
        l.exports = function(p) {
          var m = c(p, "number");
          if (typeof m == "number") throw d("Can't convert number to bigint");
          return BigInt(m);
        };
      }, 7067: function(l, v, s) {
        var c = s(9303), d = s(7466), p = RangeError;
        l.exports = function(m) {
          if (m === void 0) return 0;
          var E = c(m), y = d(E);
          if (E !== y) throw p("Wrong length or index");
          return y;
        };
      }, 5656: function(l, v, s) {
        var c = s(8361), d = s(4488);
        l.exports = function(p) {
          return c(d(p));
        };
      }, 9303: function(l, v, s) {
        var c = s(4758);
        l.exports = function(d) {
          var p = +d;
          return p != p || p === 0 ? 0 : c(p);
        };
      }, 7466: function(l, v, s) {
        var c = s(9303), d = Math.min;
        l.exports = function(p) {
          return p > 0 ? d(c(p), 9007199254740991) : 0;
        };
      }, 7908: function(l, v, s) {
        var c = s(4488), d = Object;
        l.exports = function(p) {
          return d(c(p));
        };
      }, 4590: function(l, v, s) {
        var c = s(3002), d = RangeError;
        l.exports = function(p, m) {
          var E = c(p);
          if (E % m) throw d("Wrong offset");
          return E;
        };
      }, 3002: function(l, v, s) {
        var c = s(9303), d = RangeError;
        l.exports = function(p) {
          var m = c(p);
          if (m < 0) throw d("The argument can't be less than 0");
          return m;
        };
      }, 7593: function(l, v, s) {
        var c = s(6916), d = s(111), p = s(2190), m = s(8173), E = s(2140), y = s(5112), g = TypeError, C = y("toPrimitive");
        l.exports = function(O, N) {
          if (!d(O) || p(O)) return O;
          var w, _ = m(O, C);
          if (_) {
            if (N === void 0 && (N = "default"), w = c(_, O, N), !d(w) || p(w)) return w;
            throw g("Can't convert object to primitive value");
          }
          return N === void 0 && (N = "number"), E(O, N);
        };
      }, 4948: function(l, v, s) {
        var c = s(7593), d = s(2190);
        l.exports = function(p) {
          var m = c(p, "string");
          return d(m) ? m : m + "";
        };
      }, 1694: function(l, v, s) {
        var c = {};
        c[s(5112)("toStringTag")] = "z", l.exports = String(c) === "[object z]";
      }, 1340: function(l, v, s) {
        var c = s(648), d = String;
        l.exports = function(p) {
          if (c(p) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
          return d(p);
        };
      }, 6330: function(l) {
        var v = String;
        l.exports = function(s) {
          try {
            return v(s);
          } catch {
            return "Object";
          }
        };
      }, 9843: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(6916), m = s(9781), E = s(3832), y = s(260), g = s(3331), C = s(5787), O = s(9114), N = s(8880), w = s(5988), _ = s(7466), I = s(7067), k = s(4590), H = s(4948), S = s(2597), B = s(648), D = s(111), F = s(2190), j = s(30), G = s(7976), U = s(7674), M = s(8006).f, V = s(7321), J = s(2092).forEach, ue = s(6340), se = s(7045), ee = s(3070), de = s(1236), he = s(9909), pe = s(9587), Ce = he.get, _e = he.set, Le = he.enforce, Te = ee.f, K = de.f, Oe = Math.round, Pe = d.RangeError, xe = g.ArrayBuffer, be = xe.prototype, $e = g.DataView, Be = y.NATIVE_ARRAY_BUFFER_VIEWS, Ke = y.TYPED_ARRAY_TAG, Ze = y.TypedArray, at = y.TypedArrayPrototype, pt = y.aTypedArrayConstructor, It = y.isTypedArray, Rt = "BYTES_PER_ELEMENT", gt = "Wrong length", it = function(wt, Et) {
          pt(wt);
          for (var ut = 0, St = Et.length, Ft = new wt(St); St > ut; ) Ft[ut] = Et[ut++];
          return Ft;
        }, Tt = function(wt, Et) {
          se(wt, Et, { configurable: !0, get: function() {
            return Ce(this)[Et];
          } });
        }, Ut = function(wt) {
          var Et;
          return G(be, wt) || (Et = B(wt)) == "ArrayBuffer" || Et == "SharedArrayBuffer";
        }, st = function(wt, Et) {
          return It(wt) && !F(Et) && Et in wt && w(+Et) && Et >= 0;
        }, Ot = function(wt, Et) {
          return Et = H(Et), st(wt, Et) ? O(2, wt[Et]) : K(wt, Et);
        }, kt = function(wt, Et, ut) {
          return Et = H(Et), !(st(wt, Et) && D(ut) && S(ut, "value")) || S(ut, "get") || S(ut, "set") || ut.configurable || S(ut, "writable") && !ut.writable || S(ut, "enumerable") && !ut.enumerable ? Te(wt, Et, ut) : (wt[Et] = ut.value, wt);
        };
        m ? (Be || (de.f = Ot, ee.f = kt, Tt(at, "buffer"), Tt(at, "byteOffset"), Tt(at, "byteLength"), Tt(at, "length")), c({ target: "Object", stat: !0, forced: !Be }, { getOwnPropertyDescriptor: Ot, defineProperty: kt }), l.exports = function(wt, Et, ut) {
          var St = wt.match(/\d+/)[0] / 8, Ft = wt + (ut ? "Clamped" : "") + "Array", Ht = "get" + wt, zt = "set" + wt, ze = d[Ft], Ne = ze, le = Ne && Ne.prototype, X = {}, re = function(Se, ke) {
            Te(Se, ke, { get: function() {
              return function(Ge, nt) {
                var rt = Ce(Ge);
                return rt.view[Ht](nt * St + rt.byteOffset, !0);
              }(this, ke);
            }, set: function(Ge) {
              return function(nt, rt, dt) {
                var lt = Ce(nt);
                ut && (dt = (dt = Oe(dt)) < 0 ? 0 : dt > 255 ? 255 : 255 & dt), lt.view[zt](rt * St + lt.byteOffset, dt, !0);
              }(this, ke, Ge);
            }, enumerable: !0 });
          };
          Be ? E && (Ne = Et(function(Se, ke, Ge, nt) {
            return C(Se, le), pe(D(ke) ? Ut(ke) ? nt !== void 0 ? new ze(ke, k(Ge, St), nt) : Ge !== void 0 ? new ze(ke, k(Ge, St)) : new ze(ke) : It(ke) ? it(Ne, ke) : p(V, Ne, ke) : new ze(I(ke)), Se, Ne);
          }), U && U(Ne, Ze), J(M(ze), function(Se) {
            Se in Ne || N(Ne, Se, ze[Se]);
          }), Ne.prototype = le) : (Ne = Et(function(Se, ke, Ge, nt) {
            C(Se, le);
            var rt, dt, lt, Ct = 0, Ie = 0;
            if (D(ke)) {
              if (!Ut(ke)) return It(ke) ? it(Ne, ke) : p(V, Ne, ke);
              rt = ke, Ie = k(Ge, St);
              var x = ke.byteLength;
              if (nt === void 0) {
                if (x % St || (dt = x - Ie) < 0) throw Pe(gt);
              } else if ((dt = _(nt) * St) + Ie > x) throw Pe(gt);
              lt = dt / St;
            } else lt = I(ke), rt = new xe(dt = lt * St);
            for (_e(Se, { buffer: rt, byteOffset: Ie, byteLength: dt, length: lt, view: new $e(rt) }); Ct < lt; ) re(Se, Ct++);
          }), U && U(Ne, Ze), le = Ne.prototype = j(at)), le.constructor !== Ne && N(le, "constructor", Ne), Le(le).TypedArrayConstructor = Ne, Ke && N(le, Ke, Ft);
          var Me = Ne != ze;
          X[Ft] = Ne, c({ global: !0, constructor: !0, forced: Me, sham: !Be }, X), Rt in Ne || N(Ne, Rt, St), Rt in le || N(le, Rt, St), ue(Ft);
        }) : l.exports = function() {
        };
      }, 3832: function(l, v, s) {
        var c = s(7854), d = s(7293), p = s(7072), m = s(260).NATIVE_ARRAY_BUFFER_VIEWS, E = c.ArrayBuffer, y = c.Int8Array;
        l.exports = !m || !d(function() {
          y(1);
        }) || !d(function() {
          new y(-1);
        }) || !p(function(g) {
          new y(), new y(null), new y(1.5), new y(g);
        }, !0) || d(function() {
          return new y(new E(2), 1, void 0).length !== 1;
        });
      }, 3074: function(l, v, s) {
        var c = s(7745), d = s(6304);
        l.exports = function(p, m) {
          return c(d(p), m);
        };
      }, 7321: function(l, v, s) {
        var c = s(9974), d = s(6916), p = s(9483), m = s(7908), E = s(6244), y = s(4121), g = s(1246), C = s(7659), O = s(4067), N = s(260).aTypedArrayConstructor, w = s(4599);
        l.exports = function(_) {
          var I, k, H, S, B, D, F, j, G = p(this), U = m(_), M = arguments.length, V = M > 1 ? arguments[1] : void 0, J = V !== void 0, ue = g(U);
          if (ue && !C(ue)) for (j = (F = y(U, ue)).next, U = []; !(D = d(j, F)).done; ) U.push(D.value);
          for (J && M > 2 && (V = c(V, arguments[2])), k = E(U), H = new (N(G))(k), S = O(H), I = 0; k > I; I++) B = J ? V(U[I], I) : U[I], H[I] = S ? w(B) : +B;
          return H;
        };
      }, 6304: function(l, v, s) {
        var c = s(260), d = s(6707), p = c.aTypedArrayConstructor, m = c.getTypedArrayConstructor;
        l.exports = function(E) {
          return p(d(E, m(E)));
        };
      }, 9711: function(l, v, s) {
        var c = s(1702), d = 0, p = Math.random(), m = c(1 .toString);
        l.exports = function(E) {
          return "Symbol(" + (E === void 0 ? "" : E) + ")_" + m(++d + p, 36);
        };
      }, 5143: function(l, v, s) {
        var c = s(7293), d = s(5112), p = s(9781), m = s(1913), E = d("iterator");
        l.exports = !c(function() {
          var y = new URL("b?a=1&b=2&c=3", "http://a"), g = y.searchParams, C = "";
          return y.pathname = "c%20d", g.forEach(function(O, N) {
            g.delete("b"), C += N + O;
          }), m && !y.toJSON || !g.size && (m || !p) || !g.sort || y.href !== "http://a/c%20d?a=1&c=3" || g.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !g[E] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || C !== "a1c3" || new URL("http://x", void 0).host !== "x";
        });
      }, 3307: function(l, v, s) {
        var c = s(6293);
        l.exports = c && !Symbol.sham && typeof Symbol.iterator == "symbol";
      }, 3353: function(l, v, s) {
        var c = s(9781), d = s(7293);
        l.exports = c && d(function() {
          return Object.defineProperty(function() {
          }, "prototype", { value: 42, writable: !1 }).prototype != 42;
        });
      }, 8053: function(l) {
        var v = TypeError;
        l.exports = function(s, c) {
          if (s < c) throw v("Not enough arguments");
          return s;
        };
      }, 4811: function(l, v, s) {
        var c = s(7854), d = s(614), p = c.WeakMap;
        l.exports = d(p) && /native code/.test(String(p));
      }, 6800: function(l, v, s) {
        var c = s(857), d = s(2597), p = s(6061), m = s(3070).f;
        l.exports = function(E) {
          var y = c.Symbol || (c.Symbol = {});
          d(y, E) || m(y, E, { value: p.f(E) });
        };
      }, 6061: function(l, v, s) {
        var c = s(5112);
        v.f = c;
      }, 5112: function(l, v, s) {
        var c = s(7854), d = s(2309), p = s(2597), m = s(9711), E = s(6293), y = s(3307), g = c.Symbol, C = d("wks"), O = y ? g.for || g : g && g.withoutSetter || m;
        l.exports = function(N) {
          return p(C, N) || (C[N] = E && p(g, N) ? g[N] : O("Symbol." + N)), C[N];
        };
      }, 1361: function(l) {
        l.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
      }, 9575: function(l, v, s) {
        var c = s(2109), d = s(1470), p = s(7293), m = s(3331), E = s(9670), y = s(1400), g = s(7466), C = s(6707), O = m.ArrayBuffer, N = m.DataView, w = N.prototype, _ = d(O.prototype.slice), I = d(w.getUint8), k = d(w.setUint8);
        c({ target: "ArrayBuffer", proto: !0, unsafe: !0, forced: p(function() {
          return !new O(2).slice(1, void 0).byteLength;
        }) }, { slice: function(H, S) {
          if (_ && S === void 0) return _(E(this), H);
          for (var B = E(this).byteLength, D = y(H, B), F = y(S === void 0 ? B : S, B), j = new (C(this, O))(g(F - D)), G = new N(this), U = new N(j), M = 0; D < F; ) k(U, M++, I(G, D++));
          return j;
        } });
      }, 2222: function(l, v, s) {
        var c = s(2109), d = s(7293), p = s(3157), m = s(111), E = s(7908), y = s(6244), g = s(7207), C = s(6135), O = s(5417), N = s(1194), w = s(5112), _ = s(7392), I = w("isConcatSpreadable"), k = _ >= 51 || !d(function() {
          var S = [];
          return S[I] = !1, S.concat()[0] !== S;
        }), H = function(S) {
          if (!m(S)) return !1;
          var B = S[I];
          return B !== void 0 ? !!B : p(S);
        };
        c({ target: "Array", proto: !0, arity: 1, forced: !k || !N("concat") }, { concat: function(S) {
          var B, D, F, j, G, U = E(this), M = O(U, 0), V = 0;
          for (B = -1, F = arguments.length; B < F; B++) if (H(G = B === -1 ? U : arguments[B])) for (j = y(G), g(V + j), D = 0; D < j; D++, V++) D in G && C(M, V, G[D]);
          else g(V + 1), C(M, V++, G);
          return M.length = V, M;
        } });
      }, 7327: function(l, v, s) {
        var c = s(2109), d = s(2092).filter;
        c({ target: "Array", proto: !0, forced: !s(1194)("filter") }, { filter: function(p) {
          return d(this, p, arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 4553: function(l, v, s) {
        var c = s(2109), d = s(2092).findIndex, p = s(1223), m = "findIndex", E = !0;
        m in [] && Array(1)[m](function() {
          E = !1;
        }), c({ target: "Array", proto: !0, forced: E }, { findIndex: function(y) {
          return d(this, y, arguments.length > 1 ? arguments[1] : void 0);
        } }), p(m);
      }, 9826: function(l, v, s) {
        var c = s(2109), d = s(2092).find, p = s(1223), m = "find", E = !0;
        m in [] && Array(1)[m](function() {
          E = !1;
        }), c({ target: "Array", proto: !0, forced: E }, { find: function(y) {
          return d(this, y, arguments.length > 1 ? arguments[1] : void 0);
        } }), p(m);
      }, 9554: function(l, v, s) {
        var c = s(2109), d = s(8533);
        c({ target: "Array", proto: !0, forced: [].forEach != d }, { forEach: d });
      }, 1038: function(l, v, s) {
        var c = s(2109), d = s(8457);
        c({ target: "Array", stat: !0, forced: !s(7072)(function(p) {
          Array.from(p);
        }) }, { from: d });
      }, 6699: function(l, v, s) {
        var c = s(2109), d = s(1318).includes, p = s(7293), m = s(1223);
        c({ target: "Array", proto: !0, forced: p(function() {
          return !Array(1).includes();
        }) }, { includes: function(E) {
          return d(this, E, arguments.length > 1 ? arguments[1] : void 0);
        } }), m("includes");
      }, 2772: function(l, v, s) {
        var c = s(2109), d = s(1470), p = s(1318).indexOf, m = s(9341), E = d([].indexOf), y = !!E && 1 / E([1], 1, -0) < 0;
        c({ target: "Array", proto: !0, forced: y || !m("indexOf") }, { indexOf: function(g) {
          var C = arguments.length > 1 ? arguments[1] : void 0;
          return y ? E(this, g, C) || 0 : p(this, g, C);
        } });
      }, 9753: function(l, v, s) {
        s(2109)({ target: "Array", stat: !0 }, { isArray: s(3157) });
      }, 6992: function(l, v, s) {
        var c = s(5656), d = s(1223), p = s(7497), m = s(9909), E = s(3070).f, y = s(1656), g = s(6178), C = s(1913), O = s(9781), N = "Array Iterator", w = m.set, _ = m.getterFor(N);
        l.exports = y(Array, "Array", function(k, H) {
          w(this, { type: N, target: c(k), index: 0, kind: H });
        }, function() {
          var k = _(this), H = k.target, S = k.kind, B = k.index++;
          return !H || B >= H.length ? (k.target = void 0, g(void 0, !0)) : g(S == "keys" ? B : S == "values" ? H[B] : [B, H[B]], !1);
        }, "values");
        var I = p.Arguments = p.Array;
        if (d("keys"), d("values"), d("entries"), !C && O && I.name !== "values") try {
          E(I, "name", { value: "values" });
        } catch {
        }
      }, 9600: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(8361), m = s(5656), E = s(9341), y = d([].join);
        c({ target: "Array", proto: !0, forced: p != Object || !E("join", ",") }, { join: function(g) {
          return y(m(this), g === void 0 ? "," : g);
        } });
      }, 4986: function(l, v, s) {
        var c = s(2109), d = s(6583);
        c({ target: "Array", proto: !0, forced: d !== [].lastIndexOf }, { lastIndexOf: d });
      }, 1249: function(l, v, s) {
        var c = s(2109), d = s(2092).map;
        c({ target: "Array", proto: !0, forced: !s(1194)("map") }, { map: function(p) {
          return d(this, p, arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 5827: function(l, v, s) {
        var c = s(2109), d = s(3671).left, p = s(9341), m = s(7392);
        c({ target: "Array", proto: !0, forced: !s(5268) && m > 79 && m < 83 || !p("reduce") }, { reduce: function(E) {
          var y = arguments.length;
          return d(this, E, y, y > 1 ? arguments[1] : void 0);
        } });
      }, 5069: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(3157), m = d([].reverse), E = [1, 2];
        c({ target: "Array", proto: !0, forced: String(E) === String(E.reverse()) }, { reverse: function() {
          return p(this) && (this.length = this.length), m(this);
        } });
      }, 7042: function(l, v, s) {
        var c = s(2109), d = s(3157), p = s(4411), m = s(111), E = s(1400), y = s(6244), g = s(5656), C = s(6135), O = s(5112), N = s(1194), w = s(206), _ = N("slice"), I = O("species"), k = Array, H = Math.max;
        c({ target: "Array", proto: !0, forced: !_ }, { slice: function(S, B) {
          var D, F, j, G = g(this), U = y(G), M = E(S, U), V = E(B === void 0 ? U : B, U);
          if (d(G) && (D = G.constructor, (p(D) && (D === k || d(D.prototype)) || m(D) && (D = D[I]) === null) && (D = void 0), D === k || D === void 0)) return w(G, M, V);
          for (F = new (D === void 0 ? k : D)(H(V - M, 0)), j = 0; M < V; M++, j++) M in G && C(F, j, G[M]);
          return F.length = j, F;
        } });
      }, 5212: function(l, v, s) {
        var c = s(2109), d = s(2092).some;
        c({ target: "Array", proto: !0, forced: !s(9341)("some") }, { some: function(p) {
          return d(this, p, arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 561: function(l, v, s) {
        var c = s(2109), d = s(7908), p = s(1400), m = s(9303), E = s(6244), y = s(3658), g = s(7207), C = s(5417), O = s(6135), N = s(5117), w = s(1194)("splice"), _ = Math.max, I = Math.min;
        c({ target: "Array", proto: !0, forced: !w }, { splice: function(k, H) {
          var S, B, D, F, j, G, U = d(this), M = E(U), V = p(k, M), J = arguments.length;
          for (J === 0 ? S = B = 0 : J === 1 ? (S = 0, B = M - V) : (S = J - 2, B = I(_(m(H), 0), M - V)), g(M + S - B), D = C(U, B), F = 0; F < B; F++) (j = V + F) in U && O(D, F, U[j]);
          if (D.length = B, S < B) {
            for (F = V; F < M - B; F++) G = F + S, (j = F + B) in U ? U[G] = U[j] : N(U, G);
            for (F = M; F > M - B + S; F--) N(U, F - 1);
          } else if (S > B) for (F = M - B; F > V; F--) G = F + S - 1, (j = F + B - 1) in U ? U[G] = U[j] : N(U, G);
          for (F = 0; F < S; F++) U[F + V] = arguments[F + 2];
          return y(U, M - B + S), D;
        } });
      }, 3843: function(l, v, s) {
        var c = s(2109), d = s(1702), p = Date, m = d(p.prototype.getTime);
        c({ target: "Date", stat: !0 }, { now: function() {
          return m(new p());
        } });
      }, 3710: function(l, v, s) {
        var c = s(1702), d = s(8052), p = Date.prototype, m = "Invalid Date", E = "toString", y = c(p[E]), g = c(p.getTime);
        String(/* @__PURE__ */ new Date(NaN)) != m && d(p, E, function() {
          var C = g(this);
          return C == C ? y(this) : m;
        });
      }, 4812: function(l, v, s) {
        var c = s(2109), d = s(7065);
        c({ target: "Function", proto: !0, forced: Function.bind !== d }, { bind: d });
      }, 8309: function(l, v, s) {
        var c = s(9781), d = s(6530).EXISTS, p = s(1702), m = s(7045), E = Function.prototype, y = p(E.toString), g = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, C = p(g.exec);
        c && !d && m(E, "name", { configurable: !0, get: function() {
          try {
            return C(g, y(this))[1];
          } catch {
            return "";
          }
        } });
      }, 8862: function(l, v, s) {
        var c = s(2109), d = s(5005), p = s(2104), m = s(6916), E = s(1702), y = s(7293), g = s(614), C = s(2190), O = s(206), N = s(8044), w = s(6293), _ = String, I = d("JSON", "stringify"), k = E(/./.exec), H = E("".charAt), S = E("".charCodeAt), B = E("".replace), D = E(1 .toString), F = /[\uD800-\uDFFF]/g, j = /^[\uD800-\uDBFF]$/, G = /^[\uDC00-\uDFFF]$/, U = !w || y(function() {
          var ue = d("Symbol")();
          return I([ue]) != "[null]" || I({ a: ue }) != "{}" || I(Object(ue)) != "{}";
        }), M = y(function() {
          return I("\uDF06\uD834") !== '"\\udf06\\ud834"' || I("\uDEAD") !== '"\\udead"';
        }), V = function(ue, se) {
          var ee = O(arguments), de = N(se);
          if (g(de) || ue !== void 0 && !C(ue)) return ee[1] = function(he, pe) {
            if (g(de) && (pe = m(de, this, _(he), pe)), !C(pe)) return pe;
          }, p(I, null, ee);
        }, J = function(ue, se, ee) {
          var de = H(ee, se - 1), he = H(ee, se + 1);
          return k(j, ue) && !k(G, he) || k(G, ue) && !k(j, de) ? "\\u" + D(S(ue, 0), 16) : ue;
        };
        I && c({ target: "JSON", stat: !0, arity: 3, forced: U || M }, { stringify: function(ue, se, ee) {
          var de = O(arguments), he = p(U ? V : I, null, de);
          return M && typeof he == "string" ? B(he, F, J) : he;
        } });
      }, 9098: function(l, v, s) {
        s(7710)("Map", function(c) {
          return function() {
            return c(this, arguments.length ? arguments[0] : void 0);
          };
        }, s(5631));
      }, 1532: function(l, v, s) {
        s(9098);
      }, 9653: function(l, v, s) {
        var c = s(2109), d = s(1913), p = s(9781), m = s(7854), E = s(857), y = s(1702), g = s(4705), C = s(2597), O = s(9587), N = s(7976), w = s(2190), _ = s(7593), I = s(7293), k = s(8006).f, H = s(1236).f, S = s(3070).f, B = s(863), D = s(3111).trim, F = "Number", j = m[F], G = E[F], U = j.prototype, M = m.TypeError, V = y("".slice), J = y("".charCodeAt), ue = g(F, !j(" 0o1") || !j("0b1") || j("+0x1")), se = function(de) {
          var he, pe = arguments.length < 1 ? 0 : j(function(Ce) {
            var _e = _(Ce, "number");
            return typeof _e == "bigint" ? _e : function(Le) {
              var Te, K, Oe, Pe, xe, be, $e, Be, Ke = _(Le, "number");
              if (w(Ke)) throw M("Cannot convert a Symbol value to a number");
              if (typeof Ke == "string" && Ke.length > 2) {
                if (Ke = D(Ke), (Te = J(Ke, 0)) === 43 || Te === 45) {
                  if ((K = J(Ke, 2)) === 88 || K === 120) return NaN;
                } else if (Te === 48) {
                  switch (J(Ke, 1)) {
                    case 66:
                    case 98:
                      Oe = 2, Pe = 49;
                      break;
                    case 79:
                    case 111:
                      Oe = 8, Pe = 55;
                      break;
                    default:
                      return +Ke;
                  }
                  for (be = (xe = V(Ke, 2)).length, $e = 0; $e < be; $e++) if ((Be = J(xe, $e)) < 48 || Be > Pe) return NaN;
                  return parseInt(xe, Oe);
                }
              }
              return +Ke;
            }(_e);
          }(de));
          return N(U, he = this) && I(function() {
            B(he);
          }) ? O(Object(pe), this, se) : pe;
        };
        se.prototype = U, ue && !d && (U.constructor = se), c({ global: !0, constructor: !0, wrap: !0, forced: ue }, { Number: se });
        var ee = function(de, he) {
          for (var pe, Ce = p ? k(he) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), _e = 0; Ce.length > _e; _e++) C(he, pe = Ce[_e]) && !C(de, pe) && S(de, pe, H(he, pe));
        };
        d && G && ee(E[F], G), (ue || d) && ee(E[F], j);
      }, 3161: function(l, v, s) {
        s(2109)({ target: "Number", stat: !0 }, { isInteger: s(5988) });
      }, 4048: function(l, v, s) {
        s(2109)({ target: "Number", stat: !0 }, { isNaN: function(c) {
          return c != c;
        } });
      }, 9601: function(l, v, s) {
        var c = s(2109), d = s(1574);
        c({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== d }, { assign: d });
      }, 9070: function(l, v, s) {
        var c = s(2109), d = s(9781), p = s(3070).f;
        c({ target: "Object", stat: !0, forced: Object.defineProperty !== p, sham: !d }, { defineProperty: p });
      }, 9720: function(l, v, s) {
        var c = s(2109), d = s(4699).entries;
        c({ target: "Object", stat: !0 }, { entries: function(p) {
          return d(p);
        } });
      }, 9660: function(l, v, s) {
        var c = s(2109), d = s(6293), p = s(7293), m = s(5181), E = s(7908);
        c({ target: "Object", stat: !0, forced: !d || p(function() {
          m.f(1);
        }) }, { getOwnPropertySymbols: function(y) {
          var g = m.f;
          return g ? g(E(y)) : [];
        } });
      }, 7941: function(l, v, s) {
        var c = s(2109), d = s(7908), p = s(1956);
        c({ target: "Object", stat: !0, forced: s(7293)(function() {
          p(1);
        }) }, { keys: function(m) {
          return p(d(m));
        } });
      }, 1539: function(l, v, s) {
        var c = s(1694), d = s(8052), p = s(288);
        c || d(Object.prototype, "toString", p, { unsafe: !0 });
      }, 821: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(9662), m = s(8523), E = s(2534), y = s(408);
        c({ target: "Promise", stat: !0, forced: s(612) }, { all: function(g) {
          var C = this, O = m.f(C), N = O.resolve, w = O.reject, _ = E(function() {
            var I = p(C.resolve), k = [], H = 0, S = 1;
            y(g, function(B) {
              var D = H++, F = !1;
              S++, d(I, C, B).then(function(j) {
                F || (F = !0, k[D] = j, --S || N(k));
              }, w);
            }), --S || N(k);
          });
          return _.error && w(_.value), O.promise;
        } });
      }, 4164: function(l, v, s) {
        var c = s(2109), d = s(1913), p = s(3702).CONSTRUCTOR, m = s(2492), E = s(5005), y = s(614), g = s(8052), C = m && m.prototype;
        if (c({ target: "Promise", proto: !0, forced: p, real: !0 }, { catch: function(N) {
          return this.then(void 0, N);
        } }), !d && y(m)) {
          var O = E("Promise").prototype.catch;
          C.catch !== O && g(C, "catch", O, { unsafe: !0 });
        }
      }, 3401: function(l, v, s) {
        var c, d, p, m = s(2109), E = s(1913), y = s(5268), g = s(7854), C = s(6916), O = s(8052), N = s(7674), w = s(8003), _ = s(6340), I = s(9662), k = s(614), H = s(111), S = s(5787), B = s(6707), D = s(261).set, F = s(5948), j = s(842), G = s(2534), U = s(8572), M = s(9909), V = s(2492), J = s(3702), ue = s(8523), se = "Promise", ee = J.CONSTRUCTOR, de = J.REJECTION_EVENT, he = J.SUBCLASSING, pe = M.getterFor(se), Ce = M.set, _e = V && V.prototype, Le = V, Te = _e, K = g.TypeError, Oe = g.document, Pe = g.process, xe = ue.f, be = xe, $e = !!(Oe && Oe.createEvent && g.dispatchEvent), Be = "unhandledrejection", Ke = function(st) {
          var Ot;
          return !(!H(st) || !k(Ot = st.then)) && Ot;
        }, Ze = function(st, Ot) {
          var kt, wt, Et, ut = Ot.value, St = Ot.state == 1, Ft = St ? st.ok : st.fail, Ht = st.resolve, zt = st.reject, ze = st.domain;
          try {
            Ft ? (St || (Ot.rejection === 2 && gt(Ot), Ot.rejection = 1), Ft === !0 ? kt = ut : (ze && ze.enter(), kt = Ft(ut), ze && (ze.exit(), Et = !0)), kt === st.promise ? zt(K("Promise-chain cycle")) : (wt = Ke(kt)) ? C(wt, kt, Ht, zt) : Ht(kt)) : zt(ut);
          } catch (Ne) {
            ze && !Et && ze.exit(), zt(Ne);
          }
        }, at = function(st, Ot) {
          st.notified || (st.notified = !0, F(function() {
            for (var kt, wt = st.reactions; kt = wt.get(); ) Ze(kt, st);
            st.notified = !1, Ot && !st.rejection && It(st);
          }));
        }, pt = function(st, Ot, kt) {
          var wt, Et;
          $e ? ((wt = Oe.createEvent("Event")).promise = Ot, wt.reason = kt, wt.initEvent(st, !1, !0), g.dispatchEvent(wt)) : wt = { promise: Ot, reason: kt }, !de && (Et = g["on" + st]) ? Et(wt) : st === Be && j("Unhandled promise rejection", kt);
        }, It = function(st) {
          C(D, g, function() {
            var Ot, kt = st.facade, wt = st.value;
            if (Rt(st) && (Ot = G(function() {
              y ? Pe.emit("unhandledRejection", wt, kt) : pt(Be, kt, wt);
            }), st.rejection = y || Rt(st) ? 2 : 1, Ot.error)) throw Ot.value;
          });
        }, Rt = function(st) {
          return st.rejection !== 1 && !st.parent;
        }, gt = function(st) {
          C(D, g, function() {
            var Ot = st.facade;
            y ? Pe.emit("rejectionHandled", Ot) : pt("rejectionhandled", Ot, st.value);
          });
        }, it = function(st, Ot, kt) {
          return function(wt) {
            st(Ot, wt, kt);
          };
        }, Tt = function(st, Ot, kt) {
          st.done || (st.done = !0, kt && (st = kt), st.value = Ot, st.state = 2, at(st, !0));
        }, Ut = function(st, Ot, kt) {
          if (!st.done) {
            st.done = !0, kt && (st = kt);
            try {
              if (st.facade === Ot) throw K("Promise can't be resolved itself");
              var wt = Ke(Ot);
              wt ? F(function() {
                var Et = { done: !1 };
                try {
                  C(wt, Ot, it(Ut, Et, st), it(Tt, Et, st));
                } catch (ut) {
                  Tt(Et, ut, st);
                }
              }) : (st.value = Ot, st.state = 1, at(st, !1));
            } catch (Et) {
              Tt({ done: !1 }, Et, st);
            }
          }
        };
        if (ee && (Te = (Le = function(st) {
          S(this, Te), I(st), C(c, this);
          var Ot = pe(this);
          try {
            st(it(Ut, Ot), it(Tt, Ot));
          } catch (kt) {
            Tt(Ot, kt);
          }
        }).prototype, (c = function(st) {
          Ce(this, { type: se, done: !1, notified: !1, parent: !1, reactions: new U(), rejection: !1, state: 0, value: void 0 });
        }).prototype = O(Te, "then", function(st, Ot) {
          var kt = pe(this), wt = xe(B(this, Le));
          return kt.parent = !0, wt.ok = !k(st) || st, wt.fail = k(Ot) && Ot, wt.domain = y ? Pe.domain : void 0, kt.state == 0 ? kt.reactions.add(wt) : F(function() {
            Ze(wt, kt);
          }), wt.promise;
        }), d = function() {
          var st = new c(), Ot = pe(st);
          this.promise = st, this.resolve = it(Ut, Ot), this.reject = it(Tt, Ot);
        }, ue.f = xe = function(st) {
          return st === Le || st === void 0 ? new d(st) : be(st);
        }, !E && k(V) && _e !== Object.prototype)) {
          p = _e.then, he || O(_e, "then", function(st, Ot) {
            var kt = this;
            return new Le(function(wt, Et) {
              C(p, kt, wt, Et);
            }).then(st, Ot);
          }, { unsafe: !0 });
          try {
            delete _e.constructor;
          } catch {
          }
          N && N(_e, Te);
        }
        m({ global: !0, constructor: !0, wrap: !0, forced: ee }, { Promise: Le }), w(Le, se, !1, !0), _(se);
      }, 8674: function(l, v, s) {
        s(3401), s(821), s(4164), s(6027), s(683), s(6294);
      }, 6027: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(9662), m = s(8523), E = s(2534), y = s(408);
        c({ target: "Promise", stat: !0, forced: s(612) }, { race: function(g) {
          var C = this, O = m.f(C), N = O.reject, w = E(function() {
            var _ = p(C.resolve);
            y(g, function(I) {
              d(_, C, I).then(O.resolve, N);
            });
          });
          return w.error && N(w.value), O.promise;
        } });
      }, 683: function(l, v, s) {
        var c = s(2109), d = s(6916), p = s(8523);
        c({ target: "Promise", stat: !0, forced: s(3702).CONSTRUCTOR }, { reject: function(m) {
          var E = p.f(this);
          return d(E.reject, void 0, m), E.promise;
        } });
      }, 6294: function(l, v, s) {
        var c = s(2109), d = s(5005), p = s(1913), m = s(2492), E = s(3702).CONSTRUCTOR, y = s(9478), g = d("Promise"), C = p && !E;
        c({ target: "Promise", stat: !0, forced: p || E }, { resolve: function(O) {
          return y(C && this === g ? m : this, O);
        } });
      }, 4916: function(l, v, s) {
        var c = s(2109), d = s(2261);
        c({ target: "RegExp", proto: !0, forced: /./.exec !== d }, { exec: d });
      }, 9714: function(l, v, s) {
        var c = s(6530).PROPER, d = s(8052), p = s(9670), m = s(1340), E = s(7293), y = s(4706), g = "toString", C = RegExp.prototype[g], O = E(function() {
          return C.call({ source: "a", flags: "b" }) != "/a/b";
        }), N = c && C.name != g;
        (O || N) && d(RegExp.prototype, g, function() {
          var w = p(this);
          return "/" + m(w.source) + "/" + m(y(w));
        }, { unsafe: !0 });
      }, 2023: function(l, v, s) {
        var c = s(2109), d = s(1702), p = s(3929), m = s(4488), E = s(1340), y = s(4964), g = d("".indexOf);
        c({ target: "String", proto: !0, forced: !y("includes") }, { includes: function(C) {
          return !!~g(E(m(this)), E(p(C)), arguments.length > 1 ? arguments[1] : void 0);
        } });
      }, 8783: function(l, v, s) {
        var c = s(8710).charAt, d = s(1340), p = s(9909), m = s(1656), E = s(6178), y = "String Iterator", g = p.set, C = p.getterFor(y);
        m(String, "String", function(O) {
          g(this, { type: y, string: d(O), index: 0 });
        }, function() {
          var O, N = C(this), w = N.string, _ = N.index;
          return _ >= w.length ? E(void 0, !0) : (O = c(w, _), N.index += O.length, E(O, !1));
        });
      }, 3123: function(l, v, s) {
        var c = s(2104), d = s(6916), p = s(1702), m = s(7007), E = s(9670), y = s(8554), g = s(7850), C = s(4488), O = s(6707), N = s(1530), w = s(7466), _ = s(1340), I = s(8173), k = s(1589), H = s(7651), S = s(2261), B = s(2999), D = s(7293), F = B.UNSUPPORTED_Y, j = 4294967295, G = Math.min, U = [].push, M = p(/./.exec), V = p(U), J = p("".slice), ue = !D(function() {
          var se = /(?:)/, ee = se.exec;
          se.exec = function() {
            return ee.apply(this, arguments);
          };
          var de = "ab".split(se);
          return de.length !== 2 || de[0] !== "a" || de[1] !== "b";
        });
        m("split", function(se, ee, de) {
          var he;
          return he = "abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(pe, Ce) {
            var _e = _(C(this)), Le = Ce === void 0 ? j : Ce >>> 0;
            if (Le === 0) return [];
            if (pe === void 0) return [_e];
            if (!g(pe)) return d(ee, _e, pe, Le);
            for (var Te, K, Oe, Pe = [], xe = (pe.ignoreCase ? "i" : "") + (pe.multiline ? "m" : "") + (pe.unicode ? "u" : "") + (pe.sticky ? "y" : ""), be = 0, $e = new RegExp(pe.source, xe + "g"); (Te = d(S, $e, _e)) && !((K = $e.lastIndex) > be && (V(Pe, J(_e, be, Te.index)), Te.length > 1 && Te.index < _e.length && c(U, Pe, k(Te, 1)), Oe = Te[0].length, be = K, Pe.length >= Le)); ) $e.lastIndex === Te.index && $e.lastIndex++;
            return be === _e.length ? !Oe && M($e, "") || V(Pe, "") : V(Pe, J(_e, be)), Pe.length > Le ? k(Pe, 0, Le) : Pe;
          } : "0".split(void 0, 0).length ? function(pe, Ce) {
            return pe === void 0 && Ce === 0 ? [] : d(ee, this, pe, Ce);
          } : ee, [function(pe, Ce) {
            var _e = C(this), Le = y(pe) ? void 0 : I(pe, se);
            return Le ? d(Le, pe, _e, Ce) : d(he, _(_e), pe, Ce);
          }, function(pe, Ce) {
            var _e = E(this), Le = _(pe), Te = de(he, _e, Le, Ce, he !== ee);
            if (Te.done) return Te.value;
            var K = O(_e, RegExp), Oe = _e.unicode, Pe = (_e.ignoreCase ? "i" : "") + (_e.multiline ? "m" : "") + (_e.unicode ? "u" : "") + (F ? "g" : "y"), xe = new K(F ? "^(?:" + _e.source + ")" : _e, Pe), be = Ce === void 0 ? j : Ce >>> 0;
            if (be === 0) return [];
            if (Le.length === 0) return H(xe, Le) === null ? [Le] : [];
            for (var $e = 0, Be = 0, Ke = []; Be < Le.length; ) {
              xe.lastIndex = F ? 0 : Be;
              var Ze, at = H(xe, F ? J(Le, Be) : Le);
              if (at === null || (Ze = G(w(xe.lastIndex + (F ? Be : 0)), Le.length)) === $e) Be = N(Le, Be, Oe);
              else {
                if (V(Ke, J(Le, $e, Be)), Ke.length === be) return Ke;
                for (var pt = 1; pt <= at.length - 1; pt++) if (V(Ke, at[pt]), Ke.length === be) return Ke;
                Be = $e = Ze;
              }
            }
            return V(Ke, J(Le, $e)), Ke;
          }];
        }, !ue, F);
      }, 4032: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(6916), m = s(1702), E = s(1913), y = s(9781), g = s(6293), C = s(7293), O = s(2597), N = s(7976), w = s(9670), _ = s(5656), I = s(4948), k = s(1340), H = s(9114), S = s(30), B = s(1956), D = s(8006), F = s(1156), j = s(5181), G = s(1236), U = s(3070), M = s(6048), V = s(5296), J = s(8052), ue = s(7045), se = s(2309), ee = s(6200), de = s(3501), he = s(9711), pe = s(5112), Ce = s(6061), _e = s(6800), Le = s(6532), Te = s(8003), K = s(9909), Oe = s(2092).forEach, Pe = ee("hidden"), xe = "Symbol", be = "prototype", $e = K.set, Be = K.getterFor(xe), Ke = Object[be], Ze = d.Symbol, at = Ze && Ze[be], pt = d.TypeError, It = d.QObject, Rt = G.f, gt = U.f, it = F.f, Tt = V.f, Ut = m([].push), st = se("symbols"), Ot = se("op-symbols"), kt = se("wks"), wt = !It || !It[be] || !It[be].findChild, Et = y && C(function() {
          return S(gt({}, "a", { get: function() {
            return gt(this, "a", { value: 7 }).a;
          } })).a != 7;
        }) ? function(le, X, re) {
          var Me = Rt(Ke, X);
          Me && delete Ke[X], gt(le, X, re), Me && le !== Ke && gt(Ke, X, Me);
        } : gt, ut = function(le, X) {
          var re = st[le] = S(at);
          return $e(re, { type: xe, tag: le, description: X }), y || (re.description = X), re;
        }, St = function(le, X, re) {
          le === Ke && St(Ot, X, re), w(le);
          var Me = I(X);
          return w(re), O(st, Me) ? (re.enumerable ? (O(le, Pe) && le[Pe][Me] && (le[Pe][Me] = !1), re = S(re, { enumerable: H(0, !1) })) : (O(le, Pe) || gt(le, Pe, H(1, {})), le[Pe][Me] = !0), Et(le, Me, re)) : gt(le, Me, re);
        }, Ft = function(le, X) {
          w(le);
          var re = _(X), Me = B(re).concat(Ne(re));
          return Oe(Me, function(Se) {
            y && !p(Ht, re, Se) || St(le, Se, re[Se]);
          }), le;
        }, Ht = function(le) {
          var X = I(le), re = p(Tt, this, X);
          return !(this === Ke && O(st, X) && !O(Ot, X)) && (!(re || !O(this, X) || !O(st, X) || O(this, Pe) && this[Pe][X]) || re);
        }, zt = function(le, X) {
          var re = _(le), Me = I(X);
          if (re !== Ke || !O(st, Me) || O(Ot, Me)) {
            var Se = Rt(re, Me);
            return !Se || !O(st, Me) || O(re, Pe) && re[Pe][Me] || (Se.enumerable = !0), Se;
          }
        }, ze = function(le) {
          var X = it(_(le)), re = [];
          return Oe(X, function(Me) {
            O(st, Me) || O(de, Me) || Ut(re, Me);
          }), re;
        }, Ne = function(le) {
          var X = le === Ke, re = it(X ? Ot : _(le)), Me = [];
          return Oe(re, function(Se) {
            !O(st, Se) || X && !O(Ke, Se) || Ut(Me, st[Se]);
          }), Me;
        };
        g || (Ze = function() {
          if (N(at, this)) throw pt("Symbol is not a constructor");
          var le = arguments.length && arguments[0] !== void 0 ? k(arguments[0]) : void 0, X = he(le), re = function(Me) {
            this === Ke && p(re, Ot, Me), O(this, Pe) && O(this[Pe], X) && (this[Pe][X] = !1), Et(this, X, H(1, Me));
          };
          return y && wt && Et(Ke, X, { configurable: !0, set: re }), ut(X, le);
        }, J(at = Ze[be], "toString", function() {
          return Be(this).tag;
        }), J(Ze, "withoutSetter", function(le) {
          return ut(he(le), le);
        }), V.f = Ht, U.f = St, M.f = Ft, G.f = zt, D.f = F.f = ze, j.f = Ne, Ce.f = function(le) {
          return ut(pe(le), le);
        }, y && (ue(at, "description", { configurable: !0, get: function() {
          return Be(this).description;
        } }), E || J(Ke, "propertyIsEnumerable", Ht, { unsafe: !0 }))), c({ global: !0, constructor: !0, wrap: !0, forced: !g, sham: !g }, { Symbol: Ze }), Oe(B(kt), function(le) {
          _e(le);
        }), c({ target: xe, stat: !0, forced: !g }, { useSetter: function() {
          wt = !0;
        }, useSimple: function() {
          wt = !1;
        } }), c({ target: "Object", stat: !0, forced: !g, sham: !y }, { create: function(le, X) {
          return X === void 0 ? S(le) : Ft(S(le), X);
        }, defineProperty: St, defineProperties: Ft, getOwnPropertyDescriptor: zt }), c({ target: "Object", stat: !0, forced: !g }, { getOwnPropertyNames: ze }), Le(), Te(Ze, xe), de[Pe] = !0;
      }, 1817: function(l, v, s) {
        var c = s(2109), d = s(9781), p = s(7854), m = s(1702), E = s(2597), y = s(614), g = s(7976), C = s(1340), O = s(7045), N = s(9920), w = p.Symbol, _ = w && w.prototype;
        if (d && y(w) && (!("description" in _) || w().description !== void 0)) {
          var I = {}, k = function() {
            var G = arguments.length < 1 || arguments[0] === void 0 ? void 0 : C(arguments[0]), U = g(_, this) ? new w(G) : G === void 0 ? w() : w(G);
            return G === "" && (I[U] = !0), U;
          };
          N(k, w), k.prototype = _, _.constructor = k;
          var H = String(w("test")) == "Symbol(test)", S = m(_.valueOf), B = m(_.toString), D = /^Symbol\((.*)\)[^)]+$/, F = m("".replace), j = m("".slice);
          O(_, "description", { configurable: !0, get: function() {
            var G = S(this);
            if (E(I, G)) return "";
            var U = B(G), M = H ? j(U, 7, -1) : F(U, D, "$1");
            return M === "" ? void 0 : M;
          } }), c({ global: !0, constructor: !0, forced: !0 }, { Symbol: k });
        }
      }, 763: function(l, v, s) {
        var c = s(2109), d = s(5005), p = s(2597), m = s(1340), E = s(2309), y = s(2015), g = E("string-to-symbol-registry"), C = E("symbol-to-string-registry");
        c({ target: "Symbol", stat: !0, forced: !y }, { for: function(O) {
          var N = m(O);
          if (p(g, N)) return g[N];
          var w = d("Symbol")(N);
          return g[N] = w, C[w] = N, w;
        } });
      }, 2165: function(l, v, s) {
        s(6800)("iterator");
      }, 2526: function(l, v, s) {
        s(4032), s(763), s(6620), s(8862), s(9660);
      }, 6620: function(l, v, s) {
        var c = s(2109), d = s(2597), p = s(2190), m = s(6330), E = s(2309), y = s(2015), g = E("symbol-to-string-registry");
        c({ target: "Symbol", stat: !0, forced: !y }, { keyFor: function(C) {
          if (!p(C)) throw TypeError(m(C) + " is not a symbol");
          if (d(g, C)) return g[C];
        } });
      }, 2990: function(l, v, s) {
        var c = s(1702), d = s(260), p = c(s(1048)), m = d.aTypedArray;
        (0, d.exportTypedArrayMethod)("copyWithin", function(E, y) {
          return p(m(this), E, y, arguments.length > 2 ? arguments[2] : void 0);
        });
      }, 8927: function(l, v, s) {
        var c = s(260), d = s(2092).every, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("every", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 3105: function(l, v, s) {
        var c = s(260), d = s(1285), p = s(4599), m = s(648), E = s(6916), y = s(1702), g = s(7293), C = c.aTypedArray, O = c.exportTypedArrayMethod, N = y("".slice);
        O("fill", function(w) {
          var _ = arguments.length;
          C(this);
          var I = N(m(this), 0, 3) === "Big" ? p(w) : +w;
          return E(d, this, I, _ > 1 ? arguments[1] : void 0, _ > 2 ? arguments[2] : void 0);
        }, g(function() {
          var w = 0;
          return new Int8Array(2).fill({ valueOf: function() {
            return w++;
          } }), w !== 1;
        }));
      }, 5035: function(l, v, s) {
        var c = s(260), d = s(2092).filter, p = s(3074), m = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("filter", function(E) {
          var y = d(m(this), E, arguments.length > 1 ? arguments[1] : void 0);
          return p(this, y);
        });
      }, 7174: function(l, v, s) {
        var c = s(260), d = s(2092).findIndex, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("findIndex", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 4345: function(l, v, s) {
        var c = s(260), d = s(2092).find, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("find", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 2846: function(l, v, s) {
        var c = s(260), d = s(2092).forEach, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("forEach", function(m) {
          d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 8145: function(l, v, s) {
        var c = s(3832);
        (0, s(260).exportTypedArrayStaticMethod)("from", s(7321), c);
      }, 4731: function(l, v, s) {
        var c = s(260), d = s(1318).includes, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("includes", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 7209: function(l, v, s) {
        var c = s(260), d = s(1318).indexOf, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("indexOf", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 6319: function(l, v, s) {
        var c = s(7854), d = s(7293), p = s(1702), m = s(260), E = s(6992), y = s(5112)("iterator"), g = c.Uint8Array, C = p(E.values), O = p(E.keys), N = p(E.entries), w = m.aTypedArray, _ = m.exportTypedArrayMethod, I = g && g.prototype, k = !d(function() {
          I[y].call([1]);
        }), H = !!I && I.values && I[y] === I.values && I.values.name === "values", S = function() {
          return C(w(this));
        };
        _("entries", function() {
          return N(w(this));
        }, k), _("keys", function() {
          return O(w(this));
        }, k), _("values", S, k || !H, { name: "values" }), _(y, S, k || !H, { name: "values" });
      }, 8867: function(l, v, s) {
        var c = s(260), d = s(1702), p = c.aTypedArray, m = c.exportTypedArrayMethod, E = d([].join);
        m("join", function(y) {
          return E(p(this), y);
        });
      }, 7789: function(l, v, s) {
        var c = s(260), d = s(2104), p = s(6583), m = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("lastIndexOf", function(E) {
          var y = arguments.length;
          return d(p, m(this), y > 1 ? [E, arguments[1]] : [E]);
        });
      }, 3739: function(l, v, s) {
        var c = s(260), d = s(2092).map, p = s(6304), m = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("map", function(E) {
          return d(m(this), E, arguments.length > 1 ? arguments[1] : void 0, function(y, g) {
            return new (p(y))(g);
          });
        });
      }, 4483: function(l, v, s) {
        var c = s(260), d = s(3671).right, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("reduceRight", function(m) {
          var E = arguments.length;
          return d(p(this), m, E, E > 1 ? arguments[1] : void 0);
        });
      }, 9368: function(l, v, s) {
        var c = s(260), d = s(3671).left, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("reduce", function(m) {
          var E = arguments.length;
          return d(p(this), m, E, E > 1 ? arguments[1] : void 0);
        });
      }, 2056: function(l, v, s) {
        var c = s(260), d = c.aTypedArray, p = c.exportTypedArrayMethod, m = Math.floor;
        p("reverse", function() {
          for (var E, y = this, g = d(y).length, C = m(g / 2), O = 0; O < C; ) E = y[O], y[O++] = y[--g], y[g] = E;
          return y;
        });
      }, 3462: function(l, v, s) {
        var c = s(7854), d = s(6916), p = s(260), m = s(6244), E = s(4590), y = s(7908), g = s(7293), C = c.RangeError, O = c.Int8Array, N = O && O.prototype, w = N && N.set, _ = p.aTypedArray, I = p.exportTypedArrayMethod, k = !g(function() {
          var S = new Uint8ClampedArray(2);
          return d(w, S, { length: 1, 0: 3 }, 1), S[1] !== 3;
        }), H = k && p.NATIVE_ARRAY_BUFFER_VIEWS && g(function() {
          var S = new O(2);
          return S.set(1), S.set("2", 1), S[0] !== 0 || S[1] !== 2;
        });
        I("set", function(S) {
          _(this);
          var B = E(arguments.length > 1 ? arguments[1] : void 0, 1), D = y(S);
          if (k) return d(w, this, D, B);
          var F = this.length, j = m(D), G = 0;
          if (j + B > F) throw C("Wrong length");
          for (; G < j; ) this[B + G] = D[G++];
        }, !k || H);
      }, 678: function(l, v, s) {
        var c = s(260), d = s(6304), p = s(7293), m = s(206), E = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("slice", function(y, g) {
          for (var C = m(E(this), y, g), O = d(this), N = 0, w = C.length, _ = new O(w); w > N; ) _[N] = C[N++];
          return _;
        }, p(function() {
          new Int8Array(1).slice();
        }));
      }, 7462: function(l, v, s) {
        var c = s(260), d = s(2092).some, p = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("some", function(m) {
          return d(p(this), m, arguments.length > 1 ? arguments[1] : void 0);
        });
      }, 3824: function(l, v, s) {
        var c = s(7854), d = s(1470), p = s(7293), m = s(9662), E = s(4362), y = s(260), g = s(8886), C = s(256), O = s(7392), N = s(8008), w = y.aTypedArray, _ = y.exportTypedArrayMethod, I = c.Uint16Array, k = I && d(I.prototype.sort), H = !(!k || p(function() {
          k(new I(2), null);
        }) && p(function() {
          k(new I(2), {});
        })), S = !!k && !p(function() {
          if (O) return O < 74;
          if (g) return g < 67;
          if (C) return !0;
          if (N) return N < 602;
          var B, D, F = new I(516), j = Array(516);
          for (B = 0; B < 516; B++) D = B % 4, F[B] = 515 - B, j[B] = B - 2 * D + 3;
          for (k(F, function(G, U) {
            return (G / 4 | 0) - (U / 4 | 0);
          }), B = 0; B < 516; B++) if (F[B] !== j[B]) return !0;
        });
        _("sort", function(B) {
          return B !== void 0 && m(B), S ? k(this, B) : E(w(this), /* @__PURE__ */ function(D) {
            return function(F, j) {
              return D !== void 0 ? +D(F, j) || 0 : j != j ? -1 : F != F ? 1 : F === 0 && j === 0 ? 1 / F > 0 && 1 / j < 0 ? 1 : -1 : F > j;
            };
          }(B));
        }, !S || H);
      }, 5021: function(l, v, s) {
        var c = s(260), d = s(7466), p = s(1400), m = s(6304), E = c.aTypedArray;
        (0, c.exportTypedArrayMethod)("subarray", function(y, g) {
          var C = E(this), O = C.length, N = p(y, O);
          return new (m(C))(C.buffer, C.byteOffset + N * C.BYTES_PER_ELEMENT, d((g === void 0 ? O : p(g, O)) - N));
        });
      }, 2974: function(l, v, s) {
        var c = s(7854), d = s(2104), p = s(260), m = s(7293), E = s(206), y = c.Int8Array, g = p.aTypedArray, C = p.exportTypedArrayMethod, O = [].toLocaleString, N = !!y && m(function() {
          O.call(new y(1));
        });
        C("toLocaleString", function() {
          return d(O, N ? E(g(this)) : g(this), E(arguments));
        }, m(function() {
          return [1, 2].toLocaleString() != new y([1, 2]).toLocaleString();
        }) || !m(function() {
          y.prototype.toLocaleString.call([1, 2]);
        }));
      }, 5016: function(l, v, s) {
        var c = s(260).exportTypedArrayMethod, d = s(7293), p = s(7854), m = s(1702), E = p.Uint8Array, y = E && E.prototype || {}, g = [].toString, C = m([].join);
        d(function() {
          g.call({});
        }) && (g = function() {
          return C(this);
        });
        var O = y.toString != g;
        c("toString", g, O);
      }, 2472: function(l, v, s) {
        s(9843)("Uint8", function(c) {
          return function(d, p, m) {
            return c(this, d, p, m);
          };
        });
      }, 4747: function(l, v, s) {
        var c = s(7854), d = s(8324), p = s(8509), m = s(8533), E = s(8880), y = function(C) {
          if (C && C.forEach !== m) try {
            E(C, "forEach", m);
          } catch {
            C.forEach = m;
          }
        };
        for (var g in d) d[g] && y(c[g] && c[g].prototype);
        y(p);
      }, 3948: function(l, v, s) {
        var c = s(7854), d = s(8324), p = s(8509), m = s(6992), E = s(8880), y = s(5112), g = y("iterator"), C = y("toStringTag"), O = m.values, N = function(_, I) {
          if (_) {
            if (_[g] !== O) try {
              E(_, g, O);
            } catch {
              _[g] = O;
            }
            if (_[C] || E(_, C, I), d[I]) {
              for (var k in m) if (_[k] !== m[k]) try {
                E(_, k, m[k]);
              } catch {
                _[k] = m[k];
              }
            }
          }
        };
        for (var w in d) N(c[w] && c[w].prototype, w);
        N(p, "DOMTokenList");
      }, 6815: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(7152)(d.setInterval, !0);
        c({ global: !0, bind: !0, forced: d.setInterval !== p }, { setInterval: p });
      }, 8417: function(l, v, s) {
        var c = s(2109), d = s(7854), p = s(7152)(d.setTimeout, !0);
        c({ global: !0, bind: !0, forced: d.setTimeout !== p }, { setTimeout: p });
      }, 2564: function(l, v, s) {
        s(6815), s(8417);
      }, 5556: function(l, v, s) {
        s(6992);
        var c = s(2109), d = s(7854), p = s(6916), m = s(1702), E = s(9781), y = s(5143), g = s(8052), C = s(7045), O = s(9190), N = s(8003), w = s(3061), _ = s(9909), I = s(5787), k = s(614), H = s(2597), S = s(9974), B = s(648), D = s(9670), F = s(111), j = s(1340), G = s(30), U = s(9114), M = s(4121), V = s(1246), J = s(8053), ue = s(5112), se = s(4362), ee = ue("iterator"), de = "URLSearchParams", he = de + "Iterator", pe = _.set, Ce = _.getterFor(de), _e = _.getterFor(he), Le = Object.getOwnPropertyDescriptor, Te = function(ke) {
          if (!E) return d[ke];
          var Ge = Le(d, ke);
          return Ge && Ge.value;
        }, K = Te("fetch"), Oe = Te("Request"), Pe = Te("Headers"), xe = Oe && Oe.prototype, be = Pe && Pe.prototype, $e = d.RegExp, Be = d.TypeError, Ke = d.decodeURIComponent, Ze = d.encodeURIComponent, at = m("".charAt), pt = m([].join), It = m([].push), Rt = m("".replace), gt = m([].shift), it = m([].splice), Tt = m("".split), Ut = m("".slice), st = /\+/g, Ot = Array(4), kt = function(ke) {
          return Ot[ke - 1] || (Ot[ke - 1] = $e("((?:%[\\da-f]{2}){" + ke + "})", "gi"));
        }, wt = function(ke) {
          try {
            return Ke(ke);
          } catch {
            return ke;
          }
        }, Et = function(ke) {
          var Ge = Rt(ke, st, " "), nt = 4;
          try {
            return Ke(Ge);
          } catch {
            for (; nt; ) Ge = Rt(Ge, kt(nt--), wt);
            return Ge;
          }
        }, ut = /[!'()~]|%20/g, St = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+" }, Ft = function(ke) {
          return St[ke];
        }, Ht = function(ke) {
          return Rt(Ze(ke), ut, Ft);
        }, zt = w(function(ke, Ge) {
          pe(this, { type: he, iterator: M(Ce(ke).entries), kind: Ge });
        }, "Iterator", function() {
          var ke = _e(this), Ge = ke.kind, nt = ke.iterator.next(), rt = nt.value;
          return nt.done || (nt.value = Ge === "keys" ? rt.key : Ge === "values" ? rt.value : [rt.key, rt.value]), nt;
        }, !0), ze = function(ke) {
          this.entries = [], this.url = null, ke !== void 0 && (F(ke) ? this.parseObject(ke) : this.parseQuery(typeof ke == "string" ? at(ke, 0) === "?" ? Ut(ke, 1) : ke : j(ke)));
        };
        ze.prototype = { type: de, bindURL: function(ke) {
          this.url = ke, this.update();
        }, parseObject: function(ke) {
          var Ge, nt, rt, dt, lt, Ct, Ie, x = V(ke);
          if (x) for (nt = (Ge = M(ke, x)).next; !(rt = p(nt, Ge)).done; ) {
            if (lt = (dt = M(D(rt.value))).next, (Ct = p(lt, dt)).done || (Ie = p(lt, dt)).done || !p(lt, dt).done) throw Be("Expected sequence with length 2");
            It(this.entries, { key: j(Ct.value), value: j(Ie.value) });
          }
          else for (var ae in ke) H(ke, ae) && It(this.entries, { key: ae, value: j(ke[ae]) });
        }, parseQuery: function(ke) {
          if (ke) for (var Ge, nt, rt = Tt(ke, "&"), dt = 0; dt < rt.length; ) (Ge = rt[dt++]).length && (nt = Tt(Ge, "="), It(this.entries, { key: Et(gt(nt)), value: Et(pt(nt, "=")) }));
        }, serialize: function() {
          for (var ke, Ge = this.entries, nt = [], rt = 0; rt < Ge.length; ) ke = Ge[rt++], It(nt, Ht(ke.key) + "=" + Ht(ke.value));
          return pt(nt, "&");
        }, update: function() {
          this.entries.length = 0, this.parseQuery(this.url.query);
        }, updateURL: function() {
          this.url && this.url.update();
        } };
        var Ne = function() {
          I(this, le);
          var ke = pe(this, new ze(arguments.length > 0 ? arguments[0] : void 0));
          E || (this.length = ke.entries.length);
        }, le = Ne.prototype;
        if (O(le, { append: function(ke, Ge) {
          J(arguments.length, 2);
          var nt = Ce(this);
          It(nt.entries, { key: j(ke), value: j(Ge) }), E || this.length++, nt.updateURL();
        }, delete: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this), nt = Ge.entries, rt = j(ke), dt = 0; dt < nt.length; ) nt[dt].key === rt ? it(nt, dt, 1) : dt++;
          E || (this.length = nt.length), Ge.updateURL();
        }, get: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this).entries, nt = j(ke), rt = 0; rt < Ge.length; rt++) if (Ge[rt].key === nt) return Ge[rt].value;
          return null;
        }, getAll: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this).entries, nt = j(ke), rt = [], dt = 0; dt < Ge.length; dt++) Ge[dt].key === nt && It(rt, Ge[dt].value);
          return rt;
        }, has: function(ke) {
          J(arguments.length, 1);
          for (var Ge = Ce(this).entries, nt = j(ke), rt = 0; rt < Ge.length; ) if (Ge[rt++].key === nt) return !0;
          return !1;
        }, set: function(ke, Ge) {
          J(arguments.length, 1);
          for (var nt, rt = Ce(this), dt = rt.entries, lt = !1, Ct = j(ke), Ie = j(Ge), x = 0; x < dt.length; x++) (nt = dt[x]).key === Ct && (lt ? it(dt, x--, 1) : (lt = !0, nt.value = Ie));
          lt || It(dt, { key: Ct, value: Ie }), E || (this.length = dt.length), rt.updateURL();
        }, sort: function() {
          var ke = Ce(this);
          se(ke.entries, function(Ge, nt) {
            return Ge.key > nt.key ? 1 : -1;
          }), ke.updateURL();
        }, forEach: function(ke) {
          for (var Ge, nt = Ce(this).entries, rt = S(ke, arguments.length > 1 ? arguments[1] : void 0), dt = 0; dt < nt.length; ) rt((Ge = nt[dt++]).value, Ge.key, this);
        }, keys: function() {
          return new zt(this, "keys");
        }, values: function() {
          return new zt(this, "values");
        }, entries: function() {
          return new zt(this, "entries");
        } }, { enumerable: !0 }), g(le, ee, le.entries, { name: "entries" }), g(le, "toString", function() {
          return Ce(this).serialize();
        }, { enumerable: !0 }), E && C(le, "size", { get: function() {
          return Ce(this).entries.length;
        }, configurable: !0, enumerable: !0 }), N(Ne, de), c({ global: !0, constructor: !0, forced: !y }, { URLSearchParams: Ne }), !y && k(Pe)) {
          var X = m(be.has), re = m(be.set), Me = function(ke) {
            if (F(ke)) {
              var Ge, nt = ke.body;
              if (B(nt) === de) return Ge = ke.headers ? new Pe(ke.headers) : new Pe(), X(Ge, "content-type") || re(Ge, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), G(ke, { body: U(0, j(nt)), headers: U(0, Ge) });
            }
            return ke;
          };
          if (k(K) && c({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, { fetch: function(ke) {
            return K(ke, arguments.length > 1 ? Me(arguments[1]) : {});
          } }), k(Oe)) {
            var Se = function(ke) {
              return I(this, xe), new Oe(ke, arguments.length > 1 ? Me(arguments[1]) : {});
            };
            xe.constructor = Se, Se.prototype = xe, c({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, { Request: Se });
          }
        }
        l.exports = { URLSearchParams: Ne, getState: Ce };
      }, 1637: function(l, v, s) {
        s(5556);
      }, 8789: function(l, v, s) {
        s(8783);
        var c, d = s(2109), p = s(9781), m = s(5143), E = s(7854), y = s(9974), g = s(1702), C = s(8052), O = s(7045), N = s(5787), w = s(2597), _ = s(1574), I = s(8457), k = s(1589), H = s(8710).codeAt, S = s(3197), B = s(1340), D = s(8003), F = s(8053), j = s(5556), G = s(9909), U = G.set, M = G.getterFor("URL"), V = j.URLSearchParams, J = j.getState, ue = E.URL, se = E.TypeError, ee = E.parseInt, de = Math.floor, he = Math.pow, pe = g("".charAt), Ce = g(/./.exec), _e = g([].join), Le = g(1 .toString), Te = g([].pop), K = g([].push), Oe = g("".replace), Pe = g([].shift), xe = g("".split), be = g("".slice), $e = g("".toLowerCase), Be = g([].unshift), Ke = "Invalid scheme", Ze = "Invalid host", at = "Invalid port", pt = /[a-z]/i, It = /[\d+-.a-z]/i, Rt = /\d/, gt = /^0x/i, it = /^[0-7]+$/, Tt = /^\d+$/, Ut = /^[\da-f]+$/i, st = /[\0\t\n\r #%/:<>?@[\\\]^|]/, Ot = /[\0\t\n\r #/:<>?@[\\\]^|]/, kt = /^[\u0000-\u0020]+/, wt = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, Et = /[\t\n\r]/g, ut = function(je) {
          var qe, et, bt, ot;
          if (typeof je == "number") {
            for (qe = [], et = 0; et < 4; et++) Be(qe, je % 256), je = de(je / 256);
            return _e(qe, ".");
          }
          if (typeof je == "object") {
            for (qe = "", bt = function(Lt) {
              for (var Kt = null, $t = 1, yt = null, Wt = 0, In = 0; In < 8; In++) Lt[In] !== 0 ? (Wt > $t && (Kt = yt, $t = Wt), yt = null, Wt = 0) : (yt === null && (yt = In), ++Wt);
              return Wt > $t && (Kt = yt, $t = Wt), Kt;
            }(je), et = 0; et < 8; et++) ot && je[et] === 0 || (ot && (ot = !1), bt === et ? (qe += et ? ":" : "::", ot = !0) : (qe += Le(je[et], 16), et < 7 && (qe += ":")));
            return "[" + qe + "]";
          }
          return je;
        }, St = {}, Ft = _({}, St, { " ": 1, '"': 1, "<": 1, ">": 1, "`": 1 }), Ht = _({}, Ft, { "#": 1, "?": 1, "{": 1, "}": 1 }), zt = _({}, Ht, { "/": 1, ":": 1, ";": 1, "=": 1, "@": 1, "[": 1, "\\": 1, "]": 1, "^": 1, "|": 1 }), ze = function(je, qe) {
          var et = H(je, 0);
          return et > 32 && et < 127 && !w(qe, je) ? je : encodeURIComponent(je);
        }, Ne = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 }, le = function(je, qe) {
          var et;
          return je.length == 2 && Ce(pt, pe(je, 0)) && ((et = pe(je, 1)) == ":" || !qe && et == "|");
        }, X = function(je) {
          var qe;
          return je.length > 1 && le(be(je, 0, 2)) && (je.length == 2 || (qe = pe(je, 2)) === "/" || qe === "\\" || qe === "?" || qe === "#");
        }, re = function(je) {
          return je === "." || $e(je) === "%2e";
        }, Me = {}, Se = {}, ke = {}, Ge = {}, nt = {}, rt = {}, dt = {}, lt = {}, Ct = {}, Ie = {}, x = {}, ae = {}, Q = {}, Z = {}, ge = {}, me = {}, ve = {}, ie = {}, ye = {}, Ye = {}, ne = {}, Qe = function(je, qe, et) {
          var bt, ot, Lt, Kt = B(je);
          if (qe) {
            if (ot = this.parse(Kt)) throw se(ot);
            this.searchParams = null;
          } else {
            if (et !== void 0 && (bt = new Qe(et, !0)), ot = this.parse(Kt, null, bt)) throw se(ot);
            (Lt = J(new V())).bindURL(this), this.searchParams = Lt;
          }
        };
        Qe.prototype = { type: "URL", parse: function(je, qe, et) {
          var bt, ot, Lt, Kt, $t, yt = this, Wt = qe || Me, In = 0, gn = "", zn = !1, Xn = !1, yr = !1;
          for (je = B(je), qe || (yt.scheme = "", yt.username = "", yt.password = "", yt.host = null, yt.port = null, yt.path = [], yt.query = null, yt.fragment = null, yt.cannotBeABaseURL = !1, je = Oe(je, kt, ""), je = Oe(je, wt, "$1")), je = Oe(je, Et, ""), bt = I(je); In <= bt.length; ) {
            switch (ot = bt[In], Wt) {
              case Me:
                if (!ot || !Ce(pt, ot)) {
                  if (qe) return Ke;
                  Wt = ke;
                  continue;
                }
                gn += $e(ot), Wt = Se;
                break;
              case Se:
                if (ot && (Ce(It, ot) || ot == "+" || ot == "-" || ot == ".")) gn += $e(ot);
                else {
                  if (ot != ":") {
                    if (qe) return Ke;
                    gn = "", Wt = ke, In = 0;
                    continue;
                  }
                  if (qe && (yt.isSpecial() != w(Ne, gn) || gn == "file" && (yt.includesCredentials() || yt.port !== null) || yt.scheme == "file" && !yt.host)) return;
                  if (yt.scheme = gn, qe) return void (yt.isSpecial() && Ne[yt.scheme] == yt.port && (yt.port = null));
                  gn = "", yt.scheme == "file" ? Wt = Z : yt.isSpecial() && et && et.scheme == yt.scheme ? Wt = Ge : yt.isSpecial() ? Wt = lt : bt[In + 1] == "/" ? (Wt = nt, In++) : (yt.cannotBeABaseURL = !0, K(yt.path, ""), Wt = ye);
                }
                break;
              case ke:
                if (!et || et.cannotBeABaseURL && ot != "#") return Ke;
                if (et.cannotBeABaseURL && ot == "#") {
                  yt.scheme = et.scheme, yt.path = k(et.path), yt.query = et.query, yt.fragment = "", yt.cannotBeABaseURL = !0, Wt = ne;
                  break;
                }
                Wt = et.scheme == "file" ? Z : rt;
                continue;
              case Ge:
                if (ot != "/" || bt[In + 1] != "/") {
                  Wt = rt;
                  continue;
                }
                Wt = Ct, In++;
                break;
              case nt:
                if (ot == "/") {
                  Wt = Ie;
                  break;
                }
                Wt = ie;
                continue;
              case rt:
                if (yt.scheme = et.scheme, ot == c) yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.query = et.query;
                else if (ot == "/" || ot == "\\" && yt.isSpecial()) Wt = dt;
                else if (ot == "?") yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.query = "", Wt = Ye;
                else {
                  if (ot != "#") {
                    yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.path.length--, Wt = ie;
                    continue;
                  }
                  yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, yt.path = k(et.path), yt.query = et.query, yt.fragment = "", Wt = ne;
                }
                break;
              case dt:
                if (!yt.isSpecial() || ot != "/" && ot != "\\") {
                  if (ot != "/") {
                    yt.username = et.username, yt.password = et.password, yt.host = et.host, yt.port = et.port, Wt = ie;
                    continue;
                  }
                  Wt = Ie;
                } else Wt = Ct;
                break;
              case lt:
                if (Wt = Ct, ot != "/" || pe(gn, In + 1) != "/") continue;
                In++;
                break;
              case Ct:
                if (ot != "/" && ot != "\\") {
                  Wt = Ie;
                  continue;
                }
                break;
              case Ie:
                if (ot == "@") {
                  zn && (gn = "%40" + gn), zn = !0, Lt = I(gn);
                  for (var ur = 0; ur < Lt.length; ur++) {
                    var Yn = Lt[ur];
                    if (Yn != ":" || yr) {
                      var xi = ze(Yn, zt);
                      yr ? yt.password += xi : yt.username += xi;
                    } else yr = !0;
                  }
                  gn = "";
                } else if (ot == c || ot == "/" || ot == "?" || ot == "#" || ot == "\\" && yt.isSpecial()) {
                  if (zn && gn == "") return "Invalid authority";
                  In -= I(gn).length + 1, gn = "", Wt = x;
                } else gn += ot;
                break;
              case x:
              case ae:
                if (qe && yt.scheme == "file") {
                  Wt = me;
                  continue;
                }
                if (ot != ":" || Xn) {
                  if (ot == c || ot == "/" || ot == "?" || ot == "#" || ot == "\\" && yt.isSpecial()) {
                    if (yt.isSpecial() && gn == "") return Ze;
                    if (qe && gn == "" && (yt.includesCredentials() || yt.port !== null)) return;
                    if (Kt = yt.parseHost(gn)) return Kt;
                    if (gn = "", Wt = ve, qe) return;
                    continue;
                  }
                  ot == "[" ? Xn = !0 : ot == "]" && (Xn = !1), gn += ot;
                } else {
                  if (gn == "") return Ze;
                  if (Kt = yt.parseHost(gn)) return Kt;
                  if (gn = "", Wt = Q, qe == ae) return;
                }
                break;
              case Q:
                if (!Ce(Rt, ot)) {
                  if (ot == c || ot == "/" || ot == "?" || ot == "#" || ot == "\\" && yt.isSpecial() || qe) {
                    if (gn != "") {
                      var gs = ee(gn, 10);
                      if (gs > 65535) return at;
                      yt.port = yt.isSpecial() && gs === Ne[yt.scheme] ? null : gs, gn = "";
                    }
                    if (qe) return;
                    Wt = ve;
                    continue;
                  }
                  return at;
                }
                gn += ot;
                break;
              case Z:
                if (yt.scheme = "file", ot == "/" || ot == "\\") Wt = ge;
                else {
                  if (!et || et.scheme != "file") {
                    Wt = ie;
                    continue;
                  }
                  if (ot == c) yt.host = et.host, yt.path = k(et.path), yt.query = et.query;
                  else if (ot == "?") yt.host = et.host, yt.path = k(et.path), yt.query = "", Wt = Ye;
                  else {
                    if (ot != "#") {
                      X(_e(k(bt, In), "")) || (yt.host = et.host, yt.path = k(et.path), yt.shortenPath()), Wt = ie;
                      continue;
                    }
                    yt.host = et.host, yt.path = k(et.path), yt.query = et.query, yt.fragment = "", Wt = ne;
                  }
                }
                break;
              case ge:
                if (ot == "/" || ot == "\\") {
                  Wt = me;
                  break;
                }
                et && et.scheme == "file" && !X(_e(k(bt, In), "")) && (le(et.path[0], !0) ? K(yt.path, et.path[0]) : yt.host = et.host), Wt = ie;
                continue;
              case me:
                if (ot == c || ot == "/" || ot == "\\" || ot == "?" || ot == "#") {
                  if (!qe && le(gn)) Wt = ie;
                  else if (gn == "") {
                    if (yt.host = "", qe) return;
                    Wt = ve;
                  } else {
                    if (Kt = yt.parseHost(gn)) return Kt;
                    if (yt.host == "localhost" && (yt.host = ""), qe) return;
                    gn = "", Wt = ve;
                  }
                  continue;
                }
                gn += ot;
                break;
              case ve:
                if (yt.isSpecial()) {
                  if (Wt = ie, ot != "/" && ot != "\\") continue;
                } else if (qe || ot != "?") if (qe || ot != "#") {
                  if (ot != c && (Wt = ie, ot != "/")) continue;
                } else yt.fragment = "", Wt = ne;
                else yt.query = "", Wt = Ye;
                break;
              case ie:
                if (ot == c || ot == "/" || ot == "\\" && yt.isSpecial() || !qe && (ot == "?" || ot == "#")) {
                  if (($t = $e($t = gn)) === ".." || $t === "%2e." || $t === ".%2e" || $t === "%2e%2e" ? (yt.shortenPath(), ot == "/" || ot == "\\" && yt.isSpecial() || K(yt.path, "")) : re(gn) ? ot == "/" || ot == "\\" && yt.isSpecial() || K(yt.path, "") : (yt.scheme == "file" && !yt.path.length && le(gn) && (yt.host && (yt.host = ""), gn = pe(gn, 0) + ":"), K(yt.path, gn)), gn = "", yt.scheme == "file" && (ot == c || ot == "?" || ot == "#")) for (; yt.path.length > 1 && yt.path[0] === ""; ) Pe(yt.path);
                  ot == "?" ? (yt.query = "", Wt = Ye) : ot == "#" && (yt.fragment = "", Wt = ne);
                } else gn += ze(ot, Ht);
                break;
              case ye:
                ot == "?" ? (yt.query = "", Wt = Ye) : ot == "#" ? (yt.fragment = "", Wt = ne) : ot != c && (yt.path[0] += ze(ot, St));
                break;
              case Ye:
                qe || ot != "#" ? ot != c && (ot == "'" && yt.isSpecial() ? yt.query += "%27" : yt.query += ot == "#" ? "%23" : ze(ot, St)) : (yt.fragment = "", Wt = ne);
                break;
              case ne:
                ot != c && (yt.fragment += ze(ot, Ft));
            }
            In++;
          }
        }, parseHost: function(je) {
          var qe, et, bt;
          if (pe(je, 0) == "[") {
            if (pe(je, je.length - 1) != "]" || (qe = function(ot) {
              var Lt, Kt, $t, yt, Wt, In, gn, zn = [0, 0, 0, 0, 0, 0, 0, 0], Xn = 0, yr = null, ur = 0, Yn = function() {
                return pe(ot, ur);
              };
              if (Yn() == ":") {
                if (pe(ot, 1) != ":") return;
                ur += 2, yr = ++Xn;
              }
              for (; Yn(); ) {
                if (Xn == 8) return;
                if (Yn() != ":") {
                  for (Lt = Kt = 0; Kt < 4 && Ce(Ut, Yn()); ) Lt = 16 * Lt + ee(Yn(), 16), ur++, Kt++;
                  if (Yn() == ".") {
                    if (Kt == 0 || (ur -= Kt, Xn > 6)) return;
                    for ($t = 0; Yn(); ) {
                      if (yt = null, $t > 0) {
                        if (!(Yn() == "." && $t < 4)) return;
                        ur++;
                      }
                      if (!Ce(Rt, Yn())) return;
                      for (; Ce(Rt, Yn()); ) {
                        if (Wt = ee(Yn(), 10), yt === null) yt = Wt;
                        else {
                          if (yt == 0) return;
                          yt = 10 * yt + Wt;
                        }
                        if (yt > 255) return;
                        ur++;
                      }
                      zn[Xn] = 256 * zn[Xn] + yt, ++$t != 2 && $t != 4 || Xn++;
                    }
                    if ($t != 4) return;
                    break;
                  }
                  if (Yn() == ":") {
                    if (ur++, !Yn()) return;
                  } else if (Yn()) return;
                  zn[Xn++] = Lt;
                } else {
                  if (yr !== null) return;
                  ur++, yr = ++Xn;
                }
              }
              if (yr !== null) for (In = Xn - yr, Xn = 7; Xn != 0 && In > 0; ) gn = zn[Xn], zn[Xn--] = zn[yr + In - 1], zn[yr + --In] = gn;
              else if (Xn != 8) return;
              return zn;
            }(be(je, 1, -1)), !qe)) return Ze;
            this.host = qe;
          } else if (this.isSpecial()) {
            if (je = S(je), Ce(st, je) || (qe = function(ot) {
              var Lt, Kt, $t, yt, Wt, In, gn, zn = xe(ot, ".");
              if (zn.length && zn[zn.length - 1] == "" && zn.length--, (Lt = zn.length) > 4) return ot;
              for (Kt = [], $t = 0; $t < Lt; $t++) {
                if ((yt = zn[$t]) == "") return ot;
                if (Wt = 10, yt.length > 1 && pe(yt, 0) == "0" && (Wt = Ce(gt, yt) ? 16 : 8, yt = be(yt, Wt == 8 ? 1 : 2)), yt === "") In = 0;
                else {
                  if (!Ce(Wt == 10 ? Tt : Wt == 8 ? it : Ut, yt)) return ot;
                  In = ee(yt, Wt);
                }
                K(Kt, In);
              }
              for ($t = 0; $t < Lt; $t++) if (In = Kt[$t], $t == Lt - 1) {
                if (In >= he(256, 5 - Lt)) return null;
              } else if (In > 255) return null;
              for (gn = Te(Kt), $t = 0; $t < Kt.length; $t++) gn += Kt[$t] * he(256, 3 - $t);
              return gn;
            }(je), qe === null)) return Ze;
            this.host = qe;
          } else {
            if (Ce(Ot, je)) return Ze;
            for (qe = "", et = I(je), bt = 0; bt < et.length; bt++) qe += ze(et[bt], St);
            this.host = qe;
          }
        }, cannotHaveUsernamePasswordPort: function() {
          return !this.host || this.cannotBeABaseURL || this.scheme == "file";
        }, includesCredentials: function() {
          return this.username != "" || this.password != "";
        }, isSpecial: function() {
          return w(Ne, this.scheme);
        }, shortenPath: function() {
          var je = this.path, qe = je.length;
          !qe || this.scheme == "file" && qe == 1 && le(je[0], !0) || je.length--;
        }, serialize: function() {
          var je = this, qe = je.scheme, et = je.username, bt = je.password, ot = je.host, Lt = je.port, Kt = je.path, $t = je.query, yt = je.fragment, Wt = qe + ":";
          return ot !== null ? (Wt += "//", je.includesCredentials() && (Wt += et + (bt ? ":" + bt : "") + "@"), Wt += ut(ot), Lt !== null && (Wt += ":" + Lt)) : qe == "file" && (Wt += "//"), Wt += je.cannotBeABaseURL ? Kt[0] : Kt.length ? "/" + _e(Kt, "/") : "", $t !== null && (Wt += "?" + $t), yt !== null && (Wt += "#" + yt), Wt;
        }, setHref: function(je) {
          var qe = this.parse(je);
          if (qe) throw se(qe);
          this.searchParams.update();
        }, getOrigin: function() {
          var je = this.scheme, qe = this.port;
          if (je == "blob") try {
            return new W(je.path[0]).origin;
          } catch {
            return "null";
          }
          return je != "file" && this.isSpecial() ? je + "://" + ut(this.host) + (qe !== null ? ":" + qe : "") : "null";
        }, getProtocol: function() {
          return this.scheme + ":";
        }, setProtocol: function(je) {
          this.parse(B(je) + ":", Me);
        }, getUsername: function() {
          return this.username;
        }, setUsername: function(je) {
          var qe = I(B(je));
          if (!this.cannotHaveUsernamePasswordPort()) {
            this.username = "";
            for (var et = 0; et < qe.length; et++) this.username += ze(qe[et], zt);
          }
        }, getPassword: function() {
          return this.password;
        }, setPassword: function(je) {
          var qe = I(B(je));
          if (!this.cannotHaveUsernamePasswordPort()) {
            this.password = "";
            for (var et = 0; et < qe.length; et++) this.password += ze(qe[et], zt);
          }
        }, getHost: function() {
          var je = this.host, qe = this.port;
          return je === null ? "" : qe === null ? ut(je) : ut(je) + ":" + qe;
        }, setHost: function(je) {
          this.cannotBeABaseURL || this.parse(je, x);
        }, getHostname: function() {
          var je = this.host;
          return je === null ? "" : ut(je);
        }, setHostname: function(je) {
          this.cannotBeABaseURL || this.parse(je, ae);
        }, getPort: function() {
          var je = this.port;
          return je === null ? "" : B(je);
        }, setPort: function(je) {
          this.cannotHaveUsernamePasswordPort() || ((je = B(je)) == "" ? this.port = null : this.parse(je, Q));
        }, getPathname: function() {
          var je = this.path;
          return this.cannotBeABaseURL ? je[0] : je.length ? "/" + _e(je, "/") : "";
        }, setPathname: function(je) {
          this.cannotBeABaseURL || (this.path = [], this.parse(je, ve));
        }, getSearch: function() {
          var je = this.query;
          return je ? "?" + je : "";
        }, setSearch: function(je) {
          (je = B(je)) == "" ? this.query = null : (pe(je, 0) == "?" && (je = be(je, 1)), this.query = "", this.parse(je, Ye)), this.searchParams.update();
        }, getSearchParams: function() {
          return this.searchParams.facade;
        }, getHash: function() {
          var je = this.fragment;
          return je ? "#" + je : "";
        }, setHash: function(je) {
          (je = B(je)) != "" ? (pe(je, 0) == "#" && (je = be(je, 1)), this.fragment = "", this.parse(je, ne)) : this.fragment = null;
        }, update: function() {
          this.query = this.searchParams.serialize() || null;
        } };
        var W = function(je) {
          var qe = N(this, ce), et = F(arguments.length, 1) > 1 ? arguments[1] : void 0, bt = U(qe, new Qe(je, !1, et));
          p || (qe.href = bt.serialize(), qe.origin = bt.getOrigin(), qe.protocol = bt.getProtocol(), qe.username = bt.getUsername(), qe.password = bt.getPassword(), qe.host = bt.getHost(), qe.hostname = bt.getHostname(), qe.port = bt.getPort(), qe.pathname = bt.getPathname(), qe.search = bt.getSearch(), qe.searchParams = bt.getSearchParams(), qe.hash = bt.getHash());
        }, ce = W.prototype, fe = function(je, qe) {
          return { get: function() {
            return M(this)[je]();
          }, set: qe && function(et) {
            return M(this)[qe](et);
          }, configurable: !0, enumerable: !0 };
        };
        if (p && (O(ce, "href", fe("serialize", "setHref")), O(ce, "origin", fe("getOrigin")), O(ce, "protocol", fe("getProtocol", "setProtocol")), O(ce, "username", fe("getUsername", "setUsername")), O(ce, "password", fe("getPassword", "setPassword")), O(ce, "host", fe("getHost", "setHost")), O(ce, "hostname", fe("getHostname", "setHostname")), O(ce, "port", fe("getPort", "setPort")), O(ce, "pathname", fe("getPathname", "setPathname")), O(ce, "search", fe("getSearch", "setSearch")), O(ce, "searchParams", fe("getSearchParams")), O(ce, "hash", fe("getHash", "setHash"))), C(ce, "toJSON", function() {
          return M(this).serialize();
        }, { enumerable: !0 }), C(ce, "toString", function() {
          return M(this).serialize();
        }, { enumerable: !0 }), ue) {
          var we = ue.createObjectURL, Fe = ue.revokeObjectURL;
          we && C(W, "createObjectURL", y(we, ue)), Fe && C(W, "revokeObjectURL", y(Fe, ue));
        }
        D(W, "URL"), d({ global: !0, constructor: !0, forced: !m, sham: !p }, { URL: W });
      }, 285: function(l, v, s) {
        s(8789);
      }, 5717: function(l) {
        typeof Object.create == "function" ? l.exports = function(v, s) {
          s && (v.super_ = s, v.prototype = Object.create(s.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }));
        } : l.exports = function(v, s) {
          if (s) {
            v.super_ = s;
            var c = function() {
            };
            c.prototype = s.prototype, v.prototype = new c(), v.prototype.constructor = v;
          }
        };
      }, 3720: function(l) {
        l.exports = s;
        var v = null;
        try {
          v = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
        } catch {
        }
        function s(M, V, J) {
          this.low = 0 | M, this.high = 0 | V, this.unsigned = !!J;
        }
        function c(M) {
          return (M && M.__isLong__) === !0;
        }
        s.prototype.__isLong__, Object.defineProperty(s.prototype, "__isLong__", { value: !0 }), s.isLong = c;
        var d = {}, p = {};
        function m(M, V) {
          var J, ue, se;
          return V ? (se = 0 <= (M >>>= 0) && M < 256) && (ue = p[M]) ? ue : (J = y(M, (0 | M) < 0 ? -1 : 0, !0), se && (p[M] = J), J) : (se = -128 <= (M |= 0) && M < 128) && (ue = d[M]) ? ue : (J = y(M, M < 0 ? -1 : 0, !1), se && (d[M] = J), J);
        }
        function E(M, V) {
          if (isNaN(M)) return V ? H : k;
          if (V) {
            if (M < 0) return H;
            if (M >= w) return j;
          } else {
            if (M <= -9223372036854776e3) return G;
            if (M + 1 >= _) return F;
          }
          return M < 0 ? E(-M, V).neg() : y(M % N | 0, M / N | 0, V);
        }
        function y(M, V, J) {
          return new s(M, V, J);
        }
        s.fromInt = m, s.fromNumber = E, s.fromBits = y;
        var g = Math.pow;
        function C(M, V, J) {
          if (M.length === 0) throw Error("empty string");
          if (M === "NaN" || M === "Infinity" || M === "+Infinity" || M === "-Infinity") return k;
          if (typeof V == "number" ? (J = V, V = !1) : V = !!V, (J = J || 10) < 2 || 36 < J) throw RangeError("radix");
          var ue;
          if ((ue = M.indexOf("-")) > 0) throw Error("interior hyphen");
          if (ue === 0) return C(M.substring(1), V, J).neg();
          for (var se = E(g(J, 8)), ee = k, de = 0; de < M.length; de += 8) {
            var he = Math.min(8, M.length - de), pe = parseInt(M.substring(de, de + he), J);
            if (he < 8) {
              var Ce = E(g(J, he));
              ee = ee.mul(Ce).add(E(pe));
            } else ee = (ee = ee.mul(se)).add(E(pe));
          }
          return ee.unsigned = V, ee;
        }
        function O(M, V) {
          return typeof M == "number" ? E(M, V) : typeof M == "string" ? C(M, V) : y(M.low, M.high, typeof V == "boolean" ? V : M.unsigned);
        }
        s.fromString = C, s.fromValue = O;
        var N = 4294967296, w = N * N, _ = w / 2, I = m(1 << 24), k = m(0);
        s.ZERO = k;
        var H = m(0, !0);
        s.UZERO = H;
        var S = m(1);
        s.ONE = S;
        var B = m(1, !0);
        s.UONE = B;
        var D = m(-1);
        s.NEG_ONE = D;
        var F = y(-1, 2147483647, !1);
        s.MAX_VALUE = F;
        var j = y(-1, -1, !0);
        s.MAX_UNSIGNED_VALUE = j;
        var G = y(0, -2147483648, !1);
        s.MIN_VALUE = G;
        var U = s.prototype;
        U.toInt = function() {
          return this.unsigned ? this.low >>> 0 : this.low;
        }, U.toNumber = function() {
          return this.unsigned ? (this.high >>> 0) * N + (this.low >>> 0) : this.high * N + (this.low >>> 0);
        }, U.toString = function(M) {
          if ((M = M || 10) < 2 || 36 < M) throw RangeError("radix");
          if (this.isZero()) return "0";
          if (this.isNegative()) {
            if (this.eq(G)) {
              var V = E(M), J = this.div(V), ue = J.mul(V).sub(this);
              return J.toString(M) + ue.toInt().toString(M);
            }
            return "-" + this.neg().toString(M);
          }
          for (var se = E(g(M, 6), this.unsigned), ee = this, de = ""; ; ) {
            var he = ee.div(se), pe = (ee.sub(he.mul(se)).toInt() >>> 0).toString(M);
            if ((ee = he).isZero()) return pe + de;
            for (; pe.length < 6; ) pe = "0" + pe;
            de = "" + pe + de;
          }
        }, U.getHighBits = function() {
          return this.high;
        }, U.getHighBitsUnsigned = function() {
          return this.high >>> 0;
        }, U.getLowBits = function() {
          return this.low;
        }, U.getLowBitsUnsigned = function() {
          return this.low >>> 0;
        }, U.getNumBitsAbs = function() {
          if (this.isNegative()) return this.eq(G) ? 64 : this.neg().getNumBitsAbs();
          for (var M = this.high != 0 ? this.high : this.low, V = 31; V > 0 && !(M & 1 << V); V--) ;
          return this.high != 0 ? V + 33 : V + 1;
        }, U.isZero = function() {
          return this.high === 0 && this.low === 0;
        }, U.eqz = U.isZero, U.isNegative = function() {
          return !this.unsigned && this.high < 0;
        }, U.isPositive = function() {
          return this.unsigned || this.high >= 0;
        }, U.isOdd = function() {
          return (1 & this.low) == 1;
        }, U.isEven = function() {
          return (1 & this.low) == 0;
        }, U.equals = function(M) {
          return c(M) || (M = O(M)), (this.unsigned === M.unsigned || this.high >>> 31 != 1 || M.high >>> 31 != 1) && this.high === M.high && this.low === M.low;
        }, U.eq = U.equals, U.notEquals = function(M) {
          return !this.eq(M);
        }, U.neq = U.notEquals, U.ne = U.notEquals, U.lessThan = function(M) {
          return this.comp(M) < 0;
        }, U.lt = U.lessThan, U.lessThanOrEqual = function(M) {
          return this.comp(M) <= 0;
        }, U.lte = U.lessThanOrEqual, U.le = U.lessThanOrEqual, U.greaterThan = function(M) {
          return this.comp(M) > 0;
        }, U.gt = U.greaterThan, U.greaterThanOrEqual = function(M) {
          return this.comp(M) >= 0;
        }, U.gte = U.greaterThanOrEqual, U.ge = U.greaterThanOrEqual, U.compare = function(M) {
          if (c(M) || (M = O(M)), this.eq(M)) return 0;
          var V = this.isNegative(), J = M.isNegative();
          return V && !J ? -1 : !V && J ? 1 : this.unsigned ? M.high >>> 0 > this.high >>> 0 || M.high === this.high && M.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(M).isNegative() ? -1 : 1;
        }, U.comp = U.compare, U.negate = function() {
          return !this.unsigned && this.eq(G) ? G : this.not().add(S);
        }, U.neg = U.negate, U.add = function(M) {
          c(M) || (M = O(M));
          var V = this.high >>> 16, J = 65535 & this.high, ue = this.low >>> 16, se = 65535 & this.low, ee = M.high >>> 16, de = 65535 & M.high, he = M.low >>> 16, pe = 0, Ce = 0, _e = 0, Le = 0;
          return _e += (Le += se + (65535 & M.low)) >>> 16, Ce += (_e += ue + he) >>> 16, pe += (Ce += J + de) >>> 16, pe += V + ee, y((_e &= 65535) << 16 | (Le &= 65535), (pe &= 65535) << 16 | (Ce &= 65535), this.unsigned);
        }, U.subtract = function(M) {
          return c(M) || (M = O(M)), this.add(M.neg());
        }, U.sub = U.subtract, U.multiply = function(M) {
          if (this.isZero()) return k;
          if (c(M) || (M = O(M)), v) return y(v.mul(this.low, this.high, M.low, M.high), v.get_high(), this.unsigned);
          if (M.isZero()) return k;
          if (this.eq(G)) return M.isOdd() ? G : k;
          if (M.eq(G)) return this.isOdd() ? G : k;
          if (this.isNegative()) return M.isNegative() ? this.neg().mul(M.neg()) : this.neg().mul(M).neg();
          if (M.isNegative()) return this.mul(M.neg()).neg();
          if (this.lt(I) && M.lt(I)) return E(this.toNumber() * M.toNumber(), this.unsigned);
          var V = this.high >>> 16, J = 65535 & this.high, ue = this.low >>> 16, se = 65535 & this.low, ee = M.high >>> 16, de = 65535 & M.high, he = M.low >>> 16, pe = 65535 & M.low, Ce = 0, _e = 0, Le = 0, Te = 0;
          return Le += (Te += se * pe) >>> 16, _e += (Le += ue * pe) >>> 16, Le &= 65535, _e += (Le += se * he) >>> 16, Ce += (_e += J * pe) >>> 16, _e &= 65535, Ce += (_e += ue * he) >>> 16, _e &= 65535, Ce += (_e += se * de) >>> 16, Ce += V * pe + J * he + ue * de + se * ee, y((Le &= 65535) << 16 | (Te &= 65535), (Ce &= 65535) << 16 | (_e &= 65535), this.unsigned);
        }, U.mul = U.multiply, U.divide = function(M) {
          if (c(M) || (M = O(M)), M.isZero()) throw Error("division by zero");
          var V, J, ue;
          if (v) return this.unsigned || this.high !== -2147483648 || M.low !== -1 || M.high !== -1 ? y((this.unsigned ? v.div_u : v.div_s)(this.low, this.high, M.low, M.high), v.get_high(), this.unsigned) : this;
          if (this.isZero()) return this.unsigned ? H : k;
          if (this.unsigned) {
            if (M.unsigned || (M = M.toUnsigned()), M.gt(this)) return H;
            if (M.gt(this.shru(1))) return B;
            ue = H;
          } else {
            if (this.eq(G)) return M.eq(S) || M.eq(D) ? G : M.eq(G) ? S : (V = this.shr(1).div(M).shl(1)).eq(k) ? M.isNegative() ? S : D : (J = this.sub(M.mul(V)), ue = V.add(J.div(M)));
            if (M.eq(G)) return this.unsigned ? H : k;
            if (this.isNegative()) return M.isNegative() ? this.neg().div(M.neg()) : this.neg().div(M).neg();
            if (M.isNegative()) return this.div(M.neg()).neg();
            ue = k;
          }
          for (J = this; J.gte(M); ) {
            V = Math.max(1, Math.floor(J.toNumber() / M.toNumber()));
            for (var se = Math.ceil(Math.log(V) / Math.LN2), ee = se <= 48 ? 1 : g(2, se - 48), de = E(V), he = de.mul(M); he.isNegative() || he.gt(J); ) he = (de = E(V -= ee, this.unsigned)).mul(M);
            de.isZero() && (de = S), ue = ue.add(de), J = J.sub(he);
          }
          return ue;
        }, U.div = U.divide, U.modulo = function(M) {
          return c(M) || (M = O(M)), v ? y((this.unsigned ? v.rem_u : v.rem_s)(this.low, this.high, M.low, M.high), v.get_high(), this.unsigned) : this.sub(this.div(M).mul(M));
        }, U.mod = U.modulo, U.rem = U.modulo, U.not = function() {
          return y(~this.low, ~this.high, this.unsigned);
        }, U.and = function(M) {
          return c(M) || (M = O(M)), y(this.low & M.low, this.high & M.high, this.unsigned);
        }, U.or = function(M) {
          return c(M) || (M = O(M)), y(this.low | M.low, this.high | M.high, this.unsigned);
        }, U.xor = function(M) {
          return c(M) || (M = O(M)), y(this.low ^ M.low, this.high ^ M.high, this.unsigned);
        }, U.shiftLeft = function(M) {
          return c(M) && (M = M.toInt()), (M &= 63) == 0 ? this : M < 32 ? y(this.low << M, this.high << M | this.low >>> 32 - M, this.unsigned) : y(0, this.low << M - 32, this.unsigned);
        }, U.shl = U.shiftLeft, U.shiftRight = function(M) {
          return c(M) && (M = M.toInt()), (M &= 63) == 0 ? this : M < 32 ? y(this.low >>> M | this.high << 32 - M, this.high >> M, this.unsigned) : y(this.high >> M - 32, this.high >= 0 ? 0 : -1, this.unsigned);
        }, U.shr = U.shiftRight, U.shiftRightUnsigned = function(M) {
          if (c(M) && (M = M.toInt()), (M &= 63) == 0) return this;
          var V = this.high;
          return M < 32 ? y(this.low >>> M | V << 32 - M, V >>> M, this.unsigned) : y(M === 32 ? V : V >>> M - 32, 0, this.unsigned);
        }, U.shru = U.shiftRightUnsigned, U.shr_u = U.shiftRightUnsigned, U.toSigned = function() {
          return this.unsigned ? y(this.low, this.high, !1) : this;
        }, U.toUnsigned = function() {
          return this.unsigned ? this : y(this.low, this.high, !0);
        }, U.toBytes = function(M) {
          return M ? this.toBytesLE() : this.toBytesBE();
        }, U.toBytesLE = function() {
          var M = this.high, V = this.low;
          return [255 & V, V >>> 8 & 255, V >>> 16 & 255, V >>> 24, 255 & M, M >>> 8 & 255, M >>> 16 & 255, M >>> 24];
        }, U.toBytesBE = function() {
          var M = this.high, V = this.low;
          return [M >>> 24, M >>> 16 & 255, M >>> 8 & 255, 255 & M, V >>> 24, V >>> 16 & 255, V >>> 8 & 255, 255 & V];
        }, s.fromBytes = function(M, V, J) {
          return J ? s.fromBytesLE(M, V) : s.fromBytesBE(M, V);
        }, s.fromBytesLE = function(M, V) {
          return new s(M[0] | M[1] << 8 | M[2] << 16 | M[3] << 24, M[4] | M[5] << 8 | M[6] << 16 | M[7] << 24, V);
        }, s.fromBytesBE = function(M, V) {
          return new s(M[4] << 24 | M[5] << 16 | M[6] << 8 | M[7], M[0] << 24 | M[1] << 16 | M[2] << 8 | M[3], V);
        };
      }, 3281: function(l, v, s) {
        l.exports = s(9050);
      }, 2967: function(l) {
        l.exports = c;
        var v, s = /\/|\./;
        function c(d, p) {
          s.test(d) || (d = "google/protobuf/" + d + ".proto", p = { nested: { google: { nested: { protobuf: { nested: p } } } } }), c[d] = p;
        }
        c("any", { Any: { fields: { type_url: { type: "string", id: 1 }, value: { type: "bytes", id: 2 } } } }), c("duration", { Duration: v = { fields: { seconds: { type: "int64", id: 1 }, nanos: { type: "int32", id: 2 } } } }), c("timestamp", { Timestamp: v }), c("empty", { Empty: { fields: {} } }), c("struct", { Struct: { fields: { fields: { keyType: "string", type: "Value", id: 1 } } }, Value: { oneofs: { kind: { oneof: ["nullValue", "numberValue", "stringValue", "boolValue", "structValue", "listValue"] } }, fields: { nullValue: { type: "NullValue", id: 1 }, numberValue: { type: "double", id: 2 }, stringValue: { type: "string", id: 3 }, boolValue: { type: "bool", id: 4 }, structValue: { type: "Struct", id: 5 }, listValue: { type: "ListValue", id: 6 } } }, NullValue: { values: { NULL_VALUE: 0 } }, ListValue: { fields: { values: { rule: "repeated", type: "Value", id: 1 } } } }), c("wrappers", { DoubleValue: { fields: { value: { type: "double", id: 1 } } }, FloatValue: { fields: { value: { type: "float", id: 1 } } }, Int64Value: { fields: { value: { type: "int64", id: 1 } } }, UInt64Value: { fields: { value: { type: "uint64", id: 1 } } }, Int32Value: { fields: { value: { type: "int32", id: 1 } } }, UInt32Value: { fields: { value: { type: "uint32", id: 1 } } }, BoolValue: { fields: { value: { type: "bool", id: 1 } } }, StringValue: { fields: { value: { type: "string", id: 1 } } }, BytesValue: { fields: { value: { type: "bytes", id: 1 } } } }), c("field_mask", { FieldMask: { fields: { paths: { rule: "repeated", type: "string", id: 1 } } } }), c.get = function(d) {
          return c[d] || null;
        };
      }, 3996: function(l, v, s) {
        var c = v, d = s(7025), p = s(9935);
        function m(y, g, C, O) {
          if (g.resolvedType) if (g.resolvedType instanceof d) {
            y("switch(d%s){", O);
            for (var N = g.resolvedType.values, w = Object.keys(N), _ = 0; _ < w.length; ++_) g.repeated && N[w[_]] === g.typeDefault && y("default:"), y("case%j:", w[_])("case %i:", N[w[_]])("m%s=%j", O, N[w[_]])("break");
            y("}");
          } else y('if(typeof d%s!=="object")', O)("throw TypeError(%j)", g.fullName + ": object expected")("m%s=types[%i].fromObject(d%s)", O, C, O);
          else {
            var I = !1;
            switch (g.type) {
              case "double":
              case "float":
                y("m%s=Number(d%s)", O, O);
                break;
              case "uint32":
              case "fixed32":
                y("m%s=d%s>>>0", O, O);
                break;
              case "int32":
              case "sint32":
              case "sfixed32":
                y("m%s=d%s|0", O, O);
                break;
              case "uint64":
                I = !0;
              case "int64":
              case "sint64":
              case "fixed64":
              case "sfixed64":
                y("if(util.Long)")("(m%s=util.Long.fromValue(d%s)).unsigned=%j", O, O, I)('else if(typeof d%s==="string")', O)("m%s=parseInt(d%s,10)", O, O)('else if(typeof d%s==="number")', O)("m%s=d%s", O, O)('else if(typeof d%s==="object")', O)("m%s=new util.LongBits(d%s.low>>>0,d%s.high>>>0).toNumber(%s)", O, O, O, I ? "true" : "");
                break;
              case "bytes":
                y('if(typeof d%s==="string")', O)("util.base64.decode(d%s,m%s=util.newBuffer(util.base64.length(d%s)),0)", O, O, O)("else if(d%s.length)", O)("m%s=d%s", O, O);
                break;
              case "string":
                y("m%s=String(d%s)", O, O);
                break;
              case "bool":
                y("m%s=Boolean(d%s)", O, O);
            }
          }
          return y;
        }
        function E(y, g, C, O) {
          if (g.resolvedType) g.resolvedType instanceof d ? y("d%s=o.enums===String?types[%i].values[m%s]:m%s", O, C, O, O) : y("d%s=types[%i].toObject(m%s,o)", O, C, O);
          else {
            var N = !1;
            switch (g.type) {
              case "double":
              case "float":
                y("d%s=o.json&&!isFinite(m%s)?String(m%s):m%s", O, O, O, O);
                break;
              case "uint64":
                N = !0;
              case "int64":
              case "sint64":
              case "fixed64":
              case "sfixed64":
                y('if(typeof m%s==="number")', O)("d%s=o.longs===String?String(m%s):m%s", O, O, O)("else")("d%s=o.longs===String?util.Long.prototype.toString.call(m%s):o.longs===Number?new util.LongBits(m%s.low>>>0,m%s.high>>>0).toNumber(%s):m%s", O, O, O, O, N ? "true" : "", O);
                break;
              case "bytes":
                y("d%s=o.bytes===String?util.base64.encode(m%s,0,m%s.length):o.bytes===Array?Array.prototype.slice.call(m%s):m%s", O, O, O, O, O);
                break;
              default:
                y("d%s=m%s", O, O);
            }
          }
          return y;
        }
        c.fromObject = function(y) {
          var g = y.fieldsArray, C = p.codegen(["d"], y.name + "$fromObject")("if(d instanceof this.ctor)")("return d");
          if (!g.length) return C("return new this.ctor");
          C("var m=new this.ctor");
          for (var O = 0; O < g.length; ++O) {
            var N = g[O].resolve(), w = p.safeProp(N.name);
            N.map ? (C("if(d%s){", w)('if(typeof d%s!=="object")', w)("throw TypeError(%j)", N.fullName + ": object expected")("m%s={}", w)("for(var ks=Object.keys(d%s),i=0;i<ks.length;++i){", w), m(C, N, O, w + "[ks[i]]")("}")("}")) : N.repeated ? (C("if(d%s){", w)("if(!Array.isArray(d%s))", w)("throw TypeError(%j)", N.fullName + ": array expected")("m%s=[]", w)("for(var i=0;i<d%s.length;++i){", w), m(C, N, O, w + "[i]")("}")("}")) : (N.resolvedType instanceof d || C("if(d%s!=null){", w), m(C, N, O, w), N.resolvedType instanceof d || C("}"));
          }
          return C("return m");
        }, c.toObject = function(y) {
          var g = y.fieldsArray.slice().sort(p.compareFieldsById);
          if (!g.length) return p.codegen()("return {}");
          for (var C = p.codegen(["m", "o"], y.name + "$toObject")("if(!o)")("o={}")("var d={}"), O = [], N = [], w = [], _ = 0; _ < g.length; ++_) g[_].partOf || (g[_].resolve().repeated ? O : g[_].map ? N : w).push(g[_]);
          if (O.length) {
            for (C("if(o.arrays||o.defaults){"), _ = 0; _ < O.length; ++_) C("d%s=[]", p.safeProp(O[_].name));
            C("}");
          }
          if (N.length) {
            for (C("if(o.objects||o.defaults){"), _ = 0; _ < N.length; ++_) C("d%s={}", p.safeProp(N[_].name));
            C("}");
          }
          if (w.length) {
            for (C("if(o.defaults){"), _ = 0; _ < w.length; ++_) {
              var I = w[_], k = p.safeProp(I.name);
              if (I.resolvedType instanceof d) C("d%s=o.enums===String?%j:%j", k, I.resolvedType.valuesById[I.typeDefault], I.typeDefault);
              else if (I.long) C("if(util.Long){")("var n=new util.Long(%i,%i,%j)", I.typeDefault.low, I.typeDefault.high, I.typeDefault.unsigned)("d%s=o.longs===String?n.toString():o.longs===Number?n.toNumber():n", k)("}else")("d%s=o.longs===String?%j:%i", k, I.typeDefault.toString(), I.typeDefault.toNumber());
              else if (I.bytes) {
                var H = "[" + Array.prototype.slice.call(I.typeDefault).join(",") + "]";
                C("if(o.bytes===String)d%s=%j", k, String.fromCharCode.apply(String, I.typeDefault))("else{")("d%s=%s", k, H)("if(o.bytes!==Array)d%s=util.newBuffer(d%s)", k, k)("}");
              } else C("d%s=%j", k, I.typeDefault);
            }
            C("}");
          }
          var S = !1;
          for (_ = 0; _ < g.length; ++_) {
            I = g[_];
            var B = y._fieldsArray.indexOf(I);
            k = p.safeProp(I.name), I.map ? (S || (S = !0, C("var ks2")), C("if(m%s&&(ks2=Object.keys(m%s)).length){", k, k)("d%s={}", k)("for(var j=0;j<ks2.length;++j){"), E(C, I, B, k + "[ks2[j]]")("}")) : I.repeated ? (C("if(m%s&&m%s.length){", k, k)("d%s=[]", k)("for(var j=0;j<m%s.length;++j){", k), E(C, I, B, k + "[j]")("}")) : (C("if(m%s!=null&&m.hasOwnProperty(%j)){", k, I.name), E(C, I, B, k), I.partOf && C("if(o.oneofs)")("d%s=%j", p.safeProp(I.partOf.name), I.name)), C("}");
          }
          return C("return d");
        };
      }, 5305: function(l, v, s) {
        l.exports = function(E) {
          var y = p.codegen(["r", "l"], E.name + "$decode")("if(!(r instanceof Reader))")("r=Reader.create(r)")("var c=l===undefined?r.len:r.pos+l,m=new this.ctor" + (E.fieldsArray.filter(function(_) {
            return _.map;
          }).length ? ",k,value" : ""))("while(r.pos<c){")("var t=r.uint32()");
          E.group && y("if((t&7)===4)")("break"), y("switch(t>>>3){");
          for (var g = 0; g < E.fieldsArray.length; ++g) {
            var C = E._fieldsArray[g].resolve(), O = C.resolvedType instanceof c ? "int32" : C.type, N = "m" + p.safeProp(C.name);
            y("case %i:", C.id), C.map ? (y("if(%s===util.emptyObject)", N)("%s={}", N)("var c2 = r.uint32()+r.pos"), d.defaults[C.keyType] !== void 0 ? y("k=%j", d.defaults[C.keyType]) : y("k=null"), d.defaults[O] !== void 0 ? y("value=%j", d.defaults[O]) : y("value=null"), y("while(r.pos<c2){")("var tag2=r.uint32()")("switch(tag2>>>3){")("case 1: k=r.%s(); break", C.keyType)("case 2:"), d.basic[O] === void 0 ? y("value=types[%i].decode(r,r.uint32())", g) : y("value=r.%s()", O), y("break")("default:")("r.skipType(tag2&7)")("break")("}")("}"), d.long[C.keyType] !== void 0 ? y('%s[typeof k==="object"?util.longToHash(k):k]=value', N) : y("%s[k]=value", N)) : C.repeated ? (y("if(!(%s&&%s.length))", N, N)("%s=[]", N), d.packed[O] !== void 0 && y("if((t&7)===2){")("var c2=r.uint32()+r.pos")("while(r.pos<c2)")("%s.push(r.%s())", N, O)("}else"), d.basic[O] === void 0 ? y(C.resolvedType.group ? "%s.push(types[%i].decode(r))" : "%s.push(types[%i].decode(r,r.uint32()))", N, g) : y("%s.push(r.%s())", N, O)) : d.basic[O] === void 0 ? y(C.resolvedType.group ? "%s=types[%i].decode(r)" : "%s=types[%i].decode(r,r.uint32())", N, g) : y("%s=r.%s()", N, O), y("break");
          }
          for (y("default:")("r.skipType(t&7)")("break")("}")("}"), g = 0; g < E._fieldsArray.length; ++g) {
            var w = E._fieldsArray[g];
            w.required && y("if(!m.hasOwnProperty(%j))", w.name)("throw util.ProtocolError(%j,{instance:m})", m(w));
          }
          return y("return m");
        };
        var c = s(7025), d = s(7063), p = s(9935);
        function m(E) {
          return "missing required '" + E.name + "'";
        }
      }, 4928: function(l, v, s) {
        l.exports = function(E) {
          for (var y, g = p.codegen(["m", "w"], E.name + "$encode")("if(!w)")("w=Writer.create()"), C = E.fieldsArray.slice().sort(p.compareFieldsById), O = 0; O < C.length; ++O) {
            var N = C[O].resolve(), w = E._fieldsArray.indexOf(N), _ = N.resolvedType instanceof c ? "int32" : N.type, I = d.basic[_];
            y = "m" + p.safeProp(N.name), N.map ? (g("if(%s!=null&&Object.hasOwnProperty.call(m,%j)){", y, N.name)("for(var ks=Object.keys(%s),i=0;i<ks.length;++i){", y)("w.uint32(%i).fork().uint32(%i).%s(ks[i])", (N.id << 3 | 2) >>> 0, 8 | d.mapKey[N.keyType], N.keyType), I === void 0 ? g("types[%i].encode(%s[ks[i]],w.uint32(18).fork()).ldelim().ldelim()", w, y) : g(".uint32(%i).%s(%s[ks[i]]).ldelim()", 16 | I, _, y), g("}")("}")) : N.repeated ? (g("if(%s!=null&&%s.length){", y, y), N.packed && d.packed[_] !== void 0 ? g("w.uint32(%i).fork()", (N.id << 3 | 2) >>> 0)("for(var i=0;i<%s.length;++i)", y)("w.%s(%s[i])", _, y)("w.ldelim()") : (g("for(var i=0;i<%s.length;++i)", y), I === void 0 ? m(g, N, w, y + "[i]") : g("w.uint32(%i).%s(%s[i])", (N.id << 3 | I) >>> 0, _, y)), g("}")) : (N.optional && g("if(%s!=null&&Object.hasOwnProperty.call(m,%j))", y, N.name), I === void 0 ? m(g, N, w, y) : g("w.uint32(%i).%s(%s)", (N.id << 3 | I) >>> 0, _, y));
          }
          return g("return w");
        };
        var c = s(7025), d = s(7063), p = s(9935);
        function m(E, y, g, C) {
          return y.resolvedType.group ? E("types[%i].encode(%s,w.uint32(%i)).uint32(%i)", g, C, (y.id << 3 | 3) >>> 0, (y.id << 3 | 4) >>> 0) : E("types[%i].encode(%s,w.uint32(%i).fork()).ldelim()", g, C, (y.id << 3 | 2) >>> 0);
        }
      }, 7025: function(l, v, s) {
        l.exports = m;
        var c = s(3243);
        ((m.prototype = Object.create(c.prototype)).constructor = m).className = "Enum";
        var d = s(9313), p = s(9935);
        function m(E, y, g, C, O) {
          if (c.call(this, E, g), y && typeof y != "object") throw TypeError("values must be an object");
          if (this.valuesById = {}, this.values = Object.create(this.valuesById), this.comment = C, this.comments = O || {}, this.reserved = void 0, y) for (var N = Object.keys(y), w = 0; w < N.length; ++w) typeof y[N[w]] == "number" && (this.valuesById[this.values[N[w]] = y[N[w]]] = N[w]);
        }
        m.fromJSON = function(E, y) {
          var g = new m(E, y.values, y.options, y.comment, y.comments);
          return g.reserved = y.reserved, g;
        }, m.prototype.toJSON = function(E) {
          var y = !!E && !!E.keepComments;
          return p.toObject(["options", this.options, "values", this.values, "reserved", this.reserved && this.reserved.length ? this.reserved : void 0, "comment", y ? this.comment : void 0, "comments", y ? this.comments : void 0]);
        }, m.prototype.add = function(E, y, g) {
          if (!p.isString(E)) throw TypeError("name must be a string");
          if (!p.isInteger(y)) throw TypeError("id must be an integer");
          if (this.values[E] !== void 0) throw Error("duplicate name '" + E + "' in " + this);
          if (this.isReservedId(y)) throw Error("id " + y + " is reserved in " + this);
          if (this.isReservedName(E)) throw Error("name '" + E + "' is reserved in " + this);
          if (this.valuesById[y] !== void 0) {
            if (!this.options || !this.options.allow_alias) throw Error("duplicate id " + y + " in " + this);
            this.values[E] = y;
          } else this.valuesById[this.values[E] = y] = E;
          return this.comments[E] = g || null, this;
        }, m.prototype.remove = function(E) {
          if (!p.isString(E)) throw TypeError("name must be a string");
          var y = this.values[E];
          if (y == null) throw Error("name '" + E + "' does not exist in " + this);
          return delete this.valuesById[y], delete this.values[E], delete this.comments[E], this;
        }, m.prototype.isReservedId = function(E) {
          return d.isReservedId(this.reserved, E);
        }, m.prototype.isReservedName = function(E) {
          return d.isReservedName(this.reserved, E);
        };
      }, 3548: function(l, v, s) {
        l.exports = g;
        var c = s(3243);
        ((g.prototype = Object.create(c.prototype)).constructor = g).className = "Field";
        var d, p = s(7025), m = s(7063), E = s(9935), y = /^required|optional|repeated$/;
        function g(C, O, N, w, _, I, k) {
          if (E.isObject(w) ? (k = _, I = w, w = _ = void 0) : E.isObject(_) && (k = I, I = _, _ = void 0), c.call(this, C, I), !E.isInteger(O) || O < 0) throw TypeError("id must be a non-negative integer");
          if (!E.isString(N)) throw TypeError("type must be a string");
          if (w !== void 0 && !y.test(w = w.toString().toLowerCase())) throw TypeError("rule must be a string rule");
          if (_ !== void 0 && !E.isString(_)) throw TypeError("extend must be a string");
          w === "proto3_optional" && (w = "optional"), this.rule = w && w !== "optional" ? w : void 0, this.type = N, this.id = O, this.extend = _ || void 0, this.required = w === "required", this.optional = !this.required, this.repeated = w === "repeated", this.map = !1, this.message = null, this.partOf = null, this.typeDefault = null, this.defaultValue = null, this.long = !!E.Long && m.long[N] !== void 0, this.bytes = N === "bytes", this.resolvedType = null, this.extensionField = null, this.declaringField = null, this._packed = null, this.comment = k;
        }
        g.fromJSON = function(C, O) {
          return new g(C, O.id, O.type, O.rule, O.extend, O.options, O.comment);
        }, Object.defineProperty(g.prototype, "packed", { get: function() {
          return this._packed === null && (this._packed = this.getOption("packed") !== !1), this._packed;
        } }), g.prototype.setOption = function(C, O, N) {
          return C === "packed" && (this._packed = null), c.prototype.setOption.call(this, C, O, N);
        }, g.prototype.toJSON = function(C) {
          var O = !!C && !!C.keepComments;
          return E.toObject(["rule", this.rule !== "optional" && this.rule || void 0, "type", this.type, "id", this.id, "extend", this.extend, "options", this.options, "comment", O ? this.comment : void 0]);
        }, g.prototype.resolve = function() {
          if (this.resolved) return this;
          if ((this.typeDefault = m.defaults[this.type]) === void 0 && (this.resolvedType = (this.declaringField ? this.declaringField.parent : this.parent).lookupTypeOrEnum(this.type), this.resolvedType instanceof d ? this.typeDefault = null : this.typeDefault = this.resolvedType.values[Object.keys(this.resolvedType.values)[0]]), this.options && this.options.default != null && (this.typeDefault = this.options.default, this.resolvedType instanceof p && typeof this.typeDefault == "string" && (this.typeDefault = this.resolvedType.values[this.typeDefault])), this.options && (this.options.packed !== !0 && (this.options.packed === void 0 || !this.resolvedType || this.resolvedType instanceof p) || delete this.options.packed, Object.keys(this.options).length || (this.options = void 0)), this.long) this.typeDefault = E.Long.fromNumber(this.typeDefault, this.type.charAt(0) === "u"), Object.freeze && Object.freeze(this.typeDefault);
          else if (this.bytes && typeof this.typeDefault == "string") {
            var C;
            E.base64.test(this.typeDefault) ? E.base64.decode(this.typeDefault, C = E.newBuffer(E.base64.length(this.typeDefault)), 0) : E.utf8.write(this.typeDefault, C = E.newBuffer(E.utf8.length(this.typeDefault)), 0), this.typeDefault = C;
          }
          return this.map ? this.defaultValue = E.emptyObject : this.repeated ? this.defaultValue = E.emptyArray : this.defaultValue = this.typeDefault, this.parent instanceof d && (this.parent.ctor.prototype[this.name] = this.defaultValue), c.prototype.resolve.call(this);
        }, g.d = function(C, O, N, w) {
          return typeof O == "function" ? O = E.decorateType(O).name : O && typeof O == "object" && (O = E.decorateEnum(O).name), function(_, I) {
            E.decorateType(_.constructor).add(new g(I, C, O, N, { default: w }));
          };
        }, g._configure = function(C) {
          d = C;
        };
      }, 8836: function(l, v, s) {
        var c = l.exports = s(9482);
        c.build = "light", c.load = function(d, p, m) {
          return typeof p == "function" ? (m = p, p = new c.Root()) : p || (p = new c.Root()), p.load(d, m);
        }, c.loadSync = function(d, p) {
          return p || (p = new c.Root()), p.loadSync(d);
        }, c.encoder = s(4928), c.decoder = s(5305), c.verifier = s(4497), c.converter = s(3996), c.ReflectionObject = s(3243), c.Namespace = s(9313), c.Root = s(9424), c.Enum = s(7025), c.Type = s(7645), c.Field = s(3548), c.OneOf = s(7598), c.MapField = s(6039), c.Service = s(7513), c.Method = s(4429), c.Message = s(8368), c.wrappers = s(1667), c.types = s(7063), c.util = s(9935), c.ReflectionObject._configure(c.Root), c.Namespace._configure(c.Type, c.Service, c.Enum), c.Root._configure(c.Type), c.Field._configure(c.Type);
      }, 9482: function(l, v, s) {
        var c = v;
        function d() {
          c.util._configure(), c.Writer._configure(c.BufferWriter), c.Reader._configure(c.BufferReader);
        }
        c.build = "minimal", c.Writer = s(1173), c.BufferWriter = s(3155), c.Reader = s(1408), c.BufferReader = s(593), c.util = s(9693), c.rpc = s(5994), c.roots = s(5054), c.configure = d, d();
      }, 9050: function(l, v, s) {
        var c = l.exports = s(8836);
        c.build = "full", c.tokenize = s(626), c.parse = s(2228), c.common = s(2967), c.Root._configure(c.Type, c.parse, c.common);
      }, 6039: function(l, v, s) {
        l.exports = m;
        var c = s(3548);
        ((m.prototype = Object.create(c.prototype)).constructor = m).className = "MapField";
        var d = s(7063), p = s(9935);
        function m(E, y, g, C, O, N) {
          if (c.call(this, E, y, C, void 0, void 0, O, N), !p.isString(g)) throw TypeError("keyType must be a string");
          this.keyType = g, this.resolvedKeyType = null, this.map = !0;
        }
        m.fromJSON = function(E, y) {
          return new m(E, y.id, y.keyType, y.type, y.options, y.comment);
        }, m.prototype.toJSON = function(E) {
          var y = !!E && !!E.keepComments;
          return p.toObject(["keyType", this.keyType, "type", this.type, "id", this.id, "extend", this.extend, "options", this.options, "comment", y ? this.comment : void 0]);
        }, m.prototype.resolve = function() {
          if (this.resolved) return this;
          if (d.mapKey[this.keyType] === void 0) throw Error("invalid key type: " + this.keyType);
          return c.prototype.resolve.call(this);
        }, m.d = function(E, y, g) {
          return typeof g == "function" ? g = p.decorateType(g).name : g && typeof g == "object" && (g = p.decorateEnum(g).name), function(C, O) {
            p.decorateType(C.constructor).add(new m(O, E, y, g));
          };
        };
      }, 8368: function(l, v, s) {
        l.exports = d;
        var c = s(9693);
        function d(p) {
          if (p) for (var m = Object.keys(p), E = 0; E < m.length; ++E) this[m[E]] = p[m[E]];
        }
        d.create = function(p) {
          return this.$type.create(p);
        }, d.encode = function(p, m) {
          return this.$type.encode(p, m);
        }, d.encodeDelimited = function(p, m) {
          return this.$type.encodeDelimited(p, m);
        }, d.decode = function(p) {
          return this.$type.decode(p);
        }, d.decodeDelimited = function(p) {
          return this.$type.decodeDelimited(p);
        }, d.verify = function(p) {
          return this.$type.verify(p);
        }, d.fromObject = function(p) {
          return this.$type.fromObject(p);
        }, d.toObject = function(p, m) {
          return this.$type.toObject(p, m);
        }, d.prototype.toJSON = function() {
          return this.$type.toObject(this, c.toJSONOptions);
        };
      }, 4429: function(l, v, s) {
        l.exports = p;
        var c = s(3243);
        ((p.prototype = Object.create(c.prototype)).constructor = p).className = "Method";
        var d = s(9935);
        function p(m, E, y, g, C, O, N, w, _) {
          if (d.isObject(C) ? (N = C, C = O = void 0) : d.isObject(O) && (N = O, O = void 0), E !== void 0 && !d.isString(E)) throw TypeError("type must be a string");
          if (!d.isString(y)) throw TypeError("requestType must be a string");
          if (!d.isString(g)) throw TypeError("responseType must be a string");
          c.call(this, m, N), this.type = E || "rpc", this.requestType = y, this.requestStream = !!C || void 0, this.responseType = g, this.responseStream = !!O || void 0, this.resolvedRequestType = null, this.resolvedResponseType = null, this.comment = w, this.parsedOptions = _;
        }
        p.fromJSON = function(m, E) {
          return new p(m, E.type, E.requestType, E.responseType, E.requestStream, E.responseStream, E.options, E.comment, E.parsedOptions);
        }, p.prototype.toJSON = function(m) {
          var E = !!m && !!m.keepComments;
          return d.toObject(["type", this.type !== "rpc" && this.type || void 0, "requestType", this.requestType, "requestStream", this.requestStream, "responseType", this.responseType, "responseStream", this.responseStream, "options", this.options, "comment", E ? this.comment : void 0, "parsedOptions", this.parsedOptions]);
        }, p.prototype.resolve = function() {
          return this.resolved ? this : (this.resolvedRequestType = this.parent.lookupType(this.requestType), this.resolvedResponseType = this.parent.lookupType(this.responseType), c.prototype.resolve.call(this));
        };
      }, 9313: function(l, v, s) {
        l.exports = O;
        var c = s(3243);
        ((O.prototype = Object.create(c.prototype)).constructor = O).className = "Namespace";
        var d, p, m, E = s(3548), y = s(7598), g = s(9935);
        function C(w, _) {
          if (w && w.length) {
            for (var I = {}, k = 0; k < w.length; ++k) I[w[k].name] = w[k].toJSON(_);
            return I;
          }
        }
        function O(w, _) {
          c.call(this, w, _), this.nested = void 0, this._nestedArray = null;
        }
        function N(w) {
          return w._nestedArray = null, w;
        }
        O.fromJSON = function(w, _) {
          return new O(w, _.options).addJSON(_.nested);
        }, O.arrayToJSON = C, O.isReservedId = function(w, _) {
          if (w) {
            for (var I = 0; I < w.length; ++I) if (typeof w[I] != "string" && w[I][0] <= _ && w[I][1] > _) return !0;
          }
          return !1;
        }, O.isReservedName = function(w, _) {
          if (w) {
            for (var I = 0; I < w.length; ++I) if (w[I] === _) return !0;
          }
          return !1;
        }, Object.defineProperty(O.prototype, "nestedArray", { get: function() {
          return this._nestedArray || (this._nestedArray = g.toArray(this.nested));
        } }), O.prototype.toJSON = function(w) {
          return g.toObject(["options", this.options, "nested", C(this.nestedArray, w)]);
        }, O.prototype.addJSON = function(w) {
          if (w) for (var _, I = Object.keys(w), k = 0; k < I.length; ++k) _ = w[I[k]], this.add((_.fields !== void 0 ? d.fromJSON : _.values !== void 0 ? m.fromJSON : _.methods !== void 0 ? p.fromJSON : _.id !== void 0 ? E.fromJSON : O.fromJSON)(I[k], _));
          return this;
        }, O.prototype.get = function(w) {
          return this.nested && this.nested[w] || null;
        }, O.prototype.getEnum = function(w) {
          if (this.nested && this.nested[w] instanceof m) return this.nested[w].values;
          throw Error("no such enum: " + w);
        }, O.prototype.add = function(w) {
          if (!(w instanceof E && w.extend !== void 0 || w instanceof d || w instanceof m || w instanceof p || w instanceof O || w instanceof y)) throw TypeError("object must be a valid nested object");
          if (this.nested) {
            var _ = this.get(w.name);
            if (_) {
              if (!(_ instanceof O && w instanceof O) || _ instanceof d || _ instanceof p) throw Error("duplicate name '" + w.name + "' in " + this);
              for (var I = _.nestedArray, k = 0; k < I.length; ++k) w.add(I[k]);
              this.remove(_), this.nested || (this.nested = {}), w.setOptions(_.options, !0);
            }
          } else this.nested = {};
          return this.nested[w.name] = w, w.onAdd(this), N(this);
        }, O.prototype.remove = function(w) {
          if (!(w instanceof c)) throw TypeError("object must be a ReflectionObject");
          if (w.parent !== this) throw Error(w + " is not a member of " + this);
          return delete this.nested[w.name], Object.keys(this.nested).length || (this.nested = void 0), w.onRemove(this), N(this);
        }, O.prototype.define = function(w, _) {
          if (g.isString(w)) w = w.split(".");
          else if (!Array.isArray(w)) throw TypeError("illegal path");
          if (w && w.length && w[0] === "") throw Error("path must be relative");
          for (var I = this; w.length > 0; ) {
            var k = w.shift();
            if (I.nested && I.nested[k]) {
              if (!((I = I.nested[k]) instanceof O)) throw Error("path conflicts with non-namespace objects");
            } else I.add(I = new O(k));
          }
          return _ && I.addJSON(_), I;
        }, O.prototype.resolveAll = function() {
          for (var w = this.nestedArray, _ = 0; _ < w.length; ) w[_] instanceof O ? w[_++].resolveAll() : w[_++].resolve();
          return this.resolve();
        }, O.prototype.lookup = function(w, _, I) {
          if (typeof _ == "boolean" ? (I = _, _ = void 0) : _ && !Array.isArray(_) && (_ = [_]), g.isString(w) && w.length) {
            if (w === ".") return this.root;
            w = w.split(".");
          } else if (!w.length) return this;
          if (w[0] === "") return this.root.lookup(w.slice(1), _);
          var k = this.get(w[0]);
          if (k) {
            if (w.length === 1) {
              if (!_ || _.indexOf(k.constructor) > -1) return k;
            } else if (k instanceof O && (k = k.lookup(w.slice(1), _, !0))) return k;
          } else for (var H = 0; H < this.nestedArray.length; ++H) if (this._nestedArray[H] instanceof O && (k = this._nestedArray[H].lookup(w, _, !0))) return k;
          return this.parent === null || I ? null : this.parent.lookup(w, _);
        }, O.prototype.lookupType = function(w) {
          var _ = this.lookup(w, [d]);
          if (!_) throw Error("no such type: " + w);
          return _;
        }, O.prototype.lookupEnum = function(w) {
          var _ = this.lookup(w, [m]);
          if (!_) throw Error("no such Enum '" + w + "' in " + this);
          return _;
        }, O.prototype.lookupTypeOrEnum = function(w) {
          var _ = this.lookup(w, [d, m]);
          if (!_) throw Error("no such Type or Enum '" + w + "' in " + this);
          return _;
        }, O.prototype.lookupService = function(w) {
          var _ = this.lookup(w, [p]);
          if (!_) throw Error("no such Service '" + w + "' in " + this);
          return _;
        }, O._configure = function(w, _, I) {
          d = w, p = _, m = I;
        };
      }, 3243: function(l, v, s) {
        l.exports = p, p.className = "ReflectionObject";
        var c, d = s(9935);
        function p(m, E) {
          if (!d.isString(m)) throw TypeError("name must be a string");
          if (E && !d.isObject(E)) throw TypeError("options must be an object");
          this.options = E, this.parsedOptions = null, this.name = m, this.parent = null, this.resolved = !1, this.comment = null, this.filename = null;
        }
        Object.defineProperties(p.prototype, { root: { get: function() {
          for (var m = this; m.parent !== null; ) m = m.parent;
          return m;
        } }, fullName: { get: function() {
          for (var m = [this.name], E = this.parent; E; ) m.unshift(E.name), E = E.parent;
          return m.join(".");
        } } }), p.prototype.toJSON = function() {
          throw Error();
        }, p.prototype.onAdd = function(m) {
          this.parent && this.parent !== m && this.parent.remove(this), this.parent = m, this.resolved = !1;
          var E = m.root;
          E instanceof c && E._handleAdd(this);
        }, p.prototype.onRemove = function(m) {
          var E = m.root;
          E instanceof c && E._handleRemove(this), this.parent = null, this.resolved = !1;
        }, p.prototype.resolve = function() {
          return this.resolved || this.root instanceof c && (this.resolved = !0), this;
        }, p.prototype.getOption = function(m) {
          if (this.options) return this.options[m];
        }, p.prototype.setOption = function(m, E, y) {
          return y && this.options && this.options[m] !== void 0 || ((this.options || (this.options = {}))[m] = E), this;
        }, p.prototype.setParsedOption = function(m, E, y) {
          this.parsedOptions || (this.parsedOptions = []);
          var g = this.parsedOptions;
          if (y) {
            var C = g.find(function(w) {
              return Object.prototype.hasOwnProperty.call(w, m);
            });
            if (C) {
              var O = C[m];
              d.setProperty(O, y, E);
            } else (C = {})[m] = d.setProperty({}, y, E), g.push(C);
          } else {
            var N = {};
            N[m] = E, g.push(N);
          }
          return this;
        }, p.prototype.setOptions = function(m, E) {
          if (m) for (var y = Object.keys(m), g = 0; g < y.length; ++g) this.setOption(y[g], m[y[g]], E);
          return this;
        }, p.prototype.toString = function() {
          var m = this.constructor.className, E = this.fullName;
          return E.length ? m + " " + E : m;
        }, p._configure = function(m) {
          c = m;
        };
      }, 7598: function(l, v, s) {
        l.exports = m;
        var c = s(3243);
        ((m.prototype = Object.create(c.prototype)).constructor = m).className = "OneOf";
        var d = s(3548), p = s(9935);
        function m(y, g, C, O) {
          if (Array.isArray(g) || (C = g, g = void 0), c.call(this, y, C), g !== void 0 && !Array.isArray(g)) throw TypeError("fieldNames must be an Array");
          this.oneof = g || [], this.fieldsArray = [], this.comment = O;
        }
        function E(y) {
          if (y.parent) for (var g = 0; g < y.fieldsArray.length; ++g) y.fieldsArray[g].parent || y.parent.add(y.fieldsArray[g]);
        }
        m.fromJSON = function(y, g) {
          return new m(y, g.oneof, g.options, g.comment);
        }, m.prototype.toJSON = function(y) {
          var g = !!y && !!y.keepComments;
          return p.toObject(["options", this.options, "oneof", this.oneof, "comment", g ? this.comment : void 0]);
        }, m.prototype.add = function(y) {
          if (!(y instanceof d)) throw TypeError("field must be a Field");
          return y.parent && y.parent !== this.parent && y.parent.remove(y), this.oneof.push(y.name), this.fieldsArray.push(y), y.partOf = this, E(this), this;
        }, m.prototype.remove = function(y) {
          if (!(y instanceof d)) throw TypeError("field must be a Field");
          var g = this.fieldsArray.indexOf(y);
          if (g < 0) throw Error(y + " is not a member of " + this);
          return this.fieldsArray.splice(g, 1), (g = this.oneof.indexOf(y.name)) > -1 && this.oneof.splice(g, 1), y.partOf = null, this;
        }, m.prototype.onAdd = function(y) {
          c.prototype.onAdd.call(this, y);
          for (var g = 0; g < this.oneof.length; ++g) {
            var C = y.get(this.oneof[g]);
            C && !C.partOf && (C.partOf = this, this.fieldsArray.push(C));
          }
          E(this);
        }, m.prototype.onRemove = function(y) {
          for (var g, C = 0; C < this.fieldsArray.length; ++C) (g = this.fieldsArray[C]).parent && g.parent.remove(g);
          c.prototype.onRemove.call(this, y);
        }, m.d = function() {
          for (var y = new Array(arguments.length), g = 0; g < arguments.length; ) y[g] = arguments[g++];
          return function(C, O) {
            p.decorateType(C.constructor).add(new m(O, y)), Object.defineProperty(C, O, { get: p.oneOfGetter(y), set: p.oneOfSetter(y) });
          };
        };
      }, 2228: function(l, v, s) {
        l.exports = U, U.filename = null, U.defaults = { keepCase: !1 };
        var c = s(626), d = s(9424), p = s(7645), m = s(3548), E = s(6039), y = s(7598), g = s(7025), C = s(7513), O = s(4429), N = s(7063), w = s(9935), _ = /^[1-9][0-9]*$/, I = /^-?[1-9][0-9]*$/, k = /^0[x][0-9a-fA-F]+$/, H = /^-?0[x][0-9a-fA-F]+$/, S = /^0[0-7]+$/, B = /^-?0[0-7]+$/, D = /^(?![eE])[0-9]*(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?$/, F = /^[a-zA-Z_][a-zA-Z_0-9]*$/, j = /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)(?:\.[a-zA-Z_][a-zA-Z_0-9]*)*$/, G = /^(?:\.[a-zA-Z_][a-zA-Z_0-9]*)+$/;
        function U(M, V, J) {
          V instanceof d || (J = V, V = new d()), J || (J = U.defaults);
          var ue, se, ee, de, he, pe = J.preferTrailingComment || !1, Ce = c(M, J.alternateCommentMode || !1), _e = Ce.next, Le = Ce.push, Te = Ce.peek, K = Ce.skip, Oe = Ce.cmnt, Pe = !0, xe = !1, be = V, $e = J.keepCase ? function(Et) {
            return Et;
          } : w.camelCase;
          function Be(Et, ut, St) {
            var Ft = U.filename;
            return St || (U.filename = null), Error("illegal " + (ut || "token") + " '" + Et + "' (" + (Ft ? Ft + ", " : "") + "line " + Ce.line + ")");
          }
          function Ke() {
            var Et, ut = [];
            do {
              if ((Et = _e()) !== '"' && Et !== "'") throw Be(Et);
              ut.push(_e()), K(Et), Et = Te();
            } while (Et === '"' || Et === "'");
            return ut.join("");
          }
          function Ze(Et) {
            var ut = _e();
            switch (ut) {
              case "'":
              case '"':
                return Le(ut), Ke();
              case "true":
              case "TRUE":
                return !0;
              case "false":
              case "FALSE":
                return !1;
            }
            try {
              return function(St, Ft) {
                var Ht = 1;
                switch (St.charAt(0) === "-" && (Ht = -1, St = St.substring(1)), St) {
                  case "inf":
                  case "INF":
                  case "Inf":
                    return Ht * (1 / 0);
                  case "nan":
                  case "NAN":
                  case "Nan":
                  case "NaN":
                    return NaN;
                  case "0":
                    return 0;
                }
                if (_.test(St)) return Ht * parseInt(St, 10);
                if (k.test(St)) return Ht * parseInt(St, 16);
                if (S.test(St)) return Ht * parseInt(St, 8);
                if (D.test(St)) return Ht * parseFloat(St);
                throw Be(St, "number", !0);
              }(ut);
            } catch {
              if (j.test(ut)) return ut;
              throw Be(ut, "value");
            }
          }
          function at(Et, ut) {
            var St, Ft;
            do
              !ut || (St = Te()) !== '"' && St !== "'" ? Et.push([Ft = pt(_e()), K("to", !0) ? pt(_e()) : Ft]) : Et.push(Ke());
            while (K(",", !0));
            K(";");
          }
          function pt(Et, ut) {
            switch (Et) {
              case "max":
              case "MAX":
              case "Max":
                return 536870911;
              case "0":
                return 0;
            }
            if (!ut && Et.charAt(0) === "-") throw Be(Et, "id");
            if (I.test(Et)) return parseInt(Et, 10);
            if (H.test(Et)) return parseInt(Et, 16);
            if (B.test(Et)) return parseInt(Et, 8);
            throw Be(Et, "id");
          }
          function It() {
            if (ue !== void 0) throw Be("package");
            if (ue = _e(), !j.test(ue)) throw Be(ue, "name");
            be = be.define(ue), K(";");
          }
          function Rt() {
            var Et, ut = Te();
            switch (ut) {
              case "weak":
                Et = ee || (ee = []), _e();
                break;
              case "public":
                _e();
              default:
                Et = se || (se = []);
            }
            ut = Ke(), K(";"), Et.push(ut);
          }
          function gt() {
            if (K("="), de = Ke(), !(xe = de === "proto3") && de !== "proto2") throw Be(de, "syntax");
            K(";");
          }
          function it(Et, ut) {
            switch (ut) {
              case "option":
                return st(Et, ut), K(";"), !0;
              case "message":
                return function(St, Ft) {
                  if (!F.test(Ft = _e())) throw Be(Ft, "type name");
                  var Ht = new p(Ft);
                  Tt(Ht, function(zt) {
                    if (!it(Ht, zt)) switch (zt) {
                      case "map":
                        (function(ze) {
                          K("<");
                          var Ne = _e();
                          if (N.mapKey[Ne] === void 0) throw Be(Ne, "type");
                          K(",");
                          var le = _e();
                          if (!j.test(le)) throw Be(le, "type");
                          K(">");
                          var X = _e();
                          if (!F.test(X)) throw Be(X, "name");
                          K("=");
                          var re = new E($e(X), pt(_e()), Ne, le);
                          Tt(re, function(Me) {
                            if (Me !== "option") throw Be(Me);
                            st(re, Me), K(";");
                          }, function() {
                            wt(re);
                          }), ze.add(re);
                        })(Ht);
                        break;
                      case "required":
                      case "repeated":
                        Ut(Ht, zt);
                        break;
                      case "optional":
                        Ut(Ht, xe ? "proto3_optional" : "optional");
                        break;
                      case "oneof":
                        (function(ze, Ne) {
                          if (!F.test(Ne = _e())) throw Be(Ne, "name");
                          var le = new y($e(Ne));
                          Tt(le, function(X) {
                            X === "option" ? (st(le, X), K(";")) : (Le(X), Ut(le, "optional"));
                          }), ze.add(le);
                        })(Ht, zt);
                        break;
                      case "extensions":
                        at(Ht.extensions || (Ht.extensions = []));
                        break;
                      case "reserved":
                        at(Ht.reserved || (Ht.reserved = []), !0);
                        break;
                      default:
                        if (!xe || !j.test(zt)) throw Be(zt);
                        Le(zt), Ut(Ht, "optional");
                    }
                  }), St.add(Ht);
                }(Et, ut), !0;
              case "enum":
                return function(St, Ft) {
                  if (!F.test(Ft = _e())) throw Be(Ft, "name");
                  var Ht = new g(Ft);
                  Tt(Ht, function(zt) {
                    switch (zt) {
                      case "option":
                        st(Ht, zt), K(";");
                        break;
                      case "reserved":
                        at(Ht.reserved || (Ht.reserved = []), !0);
                        break;
                      default:
                        (function(ze, Ne) {
                          if (!F.test(Ne)) throw Be(Ne, "name");
                          K("=");
                          var le = pt(_e(), !0), X = {};
                          Tt(X, function(re) {
                            if (re !== "option") throw Be(re);
                            st(X, re), K(";");
                          }, function() {
                            wt(X);
                          }), ze.add(Ne, le, X.comment);
                        })(Ht, zt);
                    }
                  }), St.add(Ht);
                }(Et, ut), !0;
              case "service":
                return function(St, Ft) {
                  if (!F.test(Ft = _e())) throw Be(Ft, "service name");
                  var Ht = new C(Ft);
                  Tt(Ht, function(zt) {
                    if (!it(Ht, zt)) {
                      if (zt !== "rpc") throw Be(zt);
                      (function(ze, Ne) {
                        var le = Oe(), X = Ne;
                        if (!F.test(Ne = _e())) throw Be(Ne, "name");
                        var re, Me, Se, ke, Ge = Ne;
                        if (K("("), K("stream", !0) && (Me = !0), !j.test(Ne = _e()) || (re = Ne, K(")"), K("returns"), K("("), K("stream", !0) && (ke = !0), !j.test(Ne = _e()))) throw Be(Ne);
                        Se = Ne, K(")");
                        var nt = new O(Ge, X, re, Se, Me, ke);
                        nt.comment = le, Tt(nt, function(rt) {
                          if (rt !== "option") throw Be(rt);
                          st(nt, rt), K(";");
                        }), ze.add(nt);
                      })(Ht, zt);
                    }
                  }), St.add(Ht);
                }(Et, ut), !0;
              case "extend":
                return function(St, Ft) {
                  if (!j.test(Ft = _e())) throw Be(Ft, "reference");
                  var Ht = Ft;
                  Tt(null, function(zt) {
                    switch (zt) {
                      case "required":
                      case "repeated":
                        Ut(St, zt, Ht);
                        break;
                      case "optional":
                        Ut(St, xe ? "proto3_optional" : "optional", Ht);
                        break;
                      default:
                        if (!xe || !j.test(zt)) throw Be(zt);
                        Le(zt), Ut(St, "optional", Ht);
                    }
                  });
                }(Et, ut), !0;
            }
            return !1;
          }
          function Tt(Et, ut, St) {
            var Ft = Ce.line;
            if (Et && (typeof Et.comment != "string" && (Et.comment = Oe()), Et.filename = U.filename), K("{", !0)) {
              for (var Ht; (Ht = _e()) !== "}"; ) ut(Ht);
              K(";", !0);
            } else St && St(), K(";"), Et && (typeof Et.comment != "string" || pe) && (Et.comment = Oe(Ft) || Et.comment);
          }
          function Ut(Et, ut, St) {
            var Ft = _e();
            if (Ft !== "group") {
              if (!j.test(Ft)) throw Be(Ft, "type");
              var Ht = _e();
              if (!F.test(Ht)) throw Be(Ht, "name");
              Ht = $e(Ht), K("=");
              var zt = new m(Ht, pt(_e()), Ft, ut, St);
              if (Tt(zt, function(Ne) {
                if (Ne !== "option") throw Be(Ne);
                st(zt, Ne), K(";");
              }, function() {
                wt(zt);
              }), ut === "proto3_optional") {
                var ze = new y("_" + Ht);
                zt.setOption("proto3_optional", !0), ze.add(zt), Et.add(ze);
              } else Et.add(zt);
              xe || !zt.repeated || N.packed[Ft] === void 0 && N.basic[Ft] !== void 0 || zt.setOption("packed", !1, !0);
            } else (function(Ne, le) {
              var X = _e();
              if (!F.test(X)) throw Be(X, "name");
              var re = w.lcFirst(X);
              X === re && (X = w.ucFirst(X)), K("=");
              var Me = pt(_e()), Se = new p(X);
              Se.group = !0;
              var ke = new m(re, Me, X, le);
              ke.filename = U.filename, Tt(Se, function(Ge) {
                switch (Ge) {
                  case "option":
                    st(Se, Ge), K(";");
                    break;
                  case "required":
                  case "repeated":
                    Ut(Se, Ge);
                    break;
                  case "optional":
                    Ut(Se, xe ? "proto3_optional" : "optional");
                    break;
                  default:
                    throw Be(Ge);
                }
              }), Ne.add(Se).add(ke);
            })(Et, ut);
          }
          function st(Et, ut) {
            var St = K("(", !0);
            if (!j.test(ut = _e())) throw Be(ut, "name");
            var Ft, Ht = ut, zt = Ht;
            St && (K(")"), zt = Ht = "(" + Ht + ")", ut = Te(), G.test(ut) && (Ft = ut.substr(1), Ht += ut, _e())), K("="), function(ze, Ne, le, X) {
              ze.setParsedOption && ze.setParsedOption(Ne, le, X);
            }(Et, zt, Ot(Et, Ht), Ft);
          }
          function Ot(Et, ut) {
            if (K("{", !0)) {
              for (var St = {}; !K("}", !0); ) {
                if (!F.test(he = _e())) throw Be(he, "name");
                var Ft, Ht = he;
                Te() === "{" ? Ft = Ot(Et, ut + "." + he) : (K(":"), Te() === "{" ? Ft = Ot(Et, ut + "." + he) : (Ft = Ze(), kt(Et, ut + "." + he, Ft)));
                var zt = St[Ht];
                zt && (Ft = [].concat(zt).concat(Ft)), St[Ht] = Ft, K(",", !0);
              }
              return St;
            }
            var ze = Ze();
            return kt(Et, ut, ze), ze;
          }
          function kt(Et, ut, St) {
            Et.setOption && Et.setOption(ut, St);
          }
          function wt(Et) {
            if (K("[", !0)) {
              do
                st(Et, "option");
              while (K(",", !0));
              K("]");
            }
            return Et;
          }
          for (; (he = _e()) !== null; ) switch (he) {
            case "package":
              if (!Pe) throw Be(he);
              It();
              break;
            case "import":
              if (!Pe) throw Be(he);
              Rt();
              break;
            case "syntax":
              if (!Pe) throw Be(he);
              gt();
              break;
            case "option":
              st(be, he), K(";");
              break;
            default:
              if (it(be, he)) {
                Pe = !1;
                continue;
              }
              throw Be(he);
          }
          return U.filename = null, { package: ue, imports: se, weakImports: ee, syntax: de, root: V };
        }
      }, 1408: function(l, v, s) {
        l.exports = y;
        var c, d = s(9693), p = d.LongBits, m = d.utf8;
        function E(I, k) {
          return RangeError("index out of range: " + I.pos + " + " + (k || 1) + " > " + I.len);
        }
        function y(I) {
          this.buf = I, this.pos = 0, this.len = I.length;
        }
        var g, C = typeof Uint8Array < "u" ? function(I) {
          if (I instanceof Uint8Array || Array.isArray(I)) return new y(I);
          throw Error("illegal buffer");
        } : function(I) {
          if (Array.isArray(I)) return new y(I);
          throw Error("illegal buffer");
        }, O = function() {
          return d.Buffer ? function(I) {
            return (y.create = function(k) {
              return d.Buffer.isBuffer(k) ? new c(k) : C(k);
            })(I);
          } : C;
        };
        function N() {
          var I = new p(0, 0), k = 0;
          if (!(this.len - this.pos > 4)) {
            for (; k < 3; ++k) {
              if (this.pos >= this.len) throw E(this);
              if (I.lo = (I.lo | (127 & this.buf[this.pos]) << 7 * k) >>> 0, this.buf[this.pos++] < 128) return I;
            }
            return I.lo = (I.lo | (127 & this.buf[this.pos++]) << 7 * k) >>> 0, I;
          }
          for (; k < 4; ++k) if (I.lo = (I.lo | (127 & this.buf[this.pos]) << 7 * k) >>> 0, this.buf[this.pos++] < 128) return I;
          if (I.lo = (I.lo | (127 & this.buf[this.pos]) << 28) >>> 0, I.hi = (I.hi | (127 & this.buf[this.pos]) >> 4) >>> 0, this.buf[this.pos++] < 128) return I;
          if (k = 0, this.len - this.pos > 4) {
            for (; k < 5; ++k) if (I.hi = (I.hi | (127 & this.buf[this.pos]) << 7 * k + 3) >>> 0, this.buf[this.pos++] < 128) return I;
          } else for (; k < 5; ++k) {
            if (this.pos >= this.len) throw E(this);
            if (I.hi = (I.hi | (127 & this.buf[this.pos]) << 7 * k + 3) >>> 0, this.buf[this.pos++] < 128) return I;
          }
          throw Error("invalid varint encoding");
        }
        function w(I, k) {
          return (I[k - 4] | I[k - 3] << 8 | I[k - 2] << 16 | I[k - 1] << 24) >>> 0;
        }
        function _() {
          if (this.pos + 8 > this.len) throw E(this, 8);
          return new p(w(this.buf, this.pos += 4), w(this.buf, this.pos += 4));
        }
        y.create = O(), y.prototype._slice = d.Array.prototype.subarray || d.Array.prototype.slice, y.prototype.uint32 = (g = 4294967295, function() {
          if (g = (127 & this.buf[this.pos]) >>> 0, this.buf[this.pos++] < 128 || (g = (g | (127 & this.buf[this.pos]) << 7) >>> 0, this.buf[this.pos++] < 128) || (g = (g | (127 & this.buf[this.pos]) << 14) >>> 0, this.buf[this.pos++] < 128) || (g = (g | (127 & this.buf[this.pos]) << 21) >>> 0, this.buf[this.pos++] < 128) || (g = (g | (15 & this.buf[this.pos]) << 28) >>> 0, this.buf[this.pos++] < 128)) return g;
          if ((this.pos += 5) > this.len) throw this.pos = this.len, E(this, 10);
          return g;
        }), y.prototype.int32 = function() {
          return 0 | this.uint32();
        }, y.prototype.sint32 = function() {
          var I = this.uint32();
          return I >>> 1 ^ -(1 & I) | 0;
        }, y.prototype.bool = function() {
          return this.uint32() !== 0;
        }, y.prototype.fixed32 = function() {
          if (this.pos + 4 > this.len) throw E(this, 4);
          return w(this.buf, this.pos += 4);
        }, y.prototype.sfixed32 = function() {
          if (this.pos + 4 > this.len) throw E(this, 4);
          return 0 | w(this.buf, this.pos += 4);
        }, y.prototype.float = function() {
          if (this.pos + 4 > this.len) throw E(this, 4);
          var I = d.float.readFloatLE(this.buf, this.pos);
          return this.pos += 4, I;
        }, y.prototype.double = function() {
          if (this.pos + 8 > this.len) throw E(this, 4);
          var I = d.float.readDoubleLE(this.buf, this.pos);
          return this.pos += 8, I;
        }, y.prototype.bytes = function() {
          var I = this.uint32(), k = this.pos, H = this.pos + I;
          if (H > this.len) throw E(this, I);
          return this.pos += I, Array.isArray(this.buf) ? this.buf.slice(k, H) : k === H ? new this.buf.constructor(0) : this._slice.call(this.buf, k, H);
        }, y.prototype.string = function() {
          var I = this.bytes();
          return m.read(I, 0, I.length);
        }, y.prototype.skip = function(I) {
          if (typeof I == "number") {
            if (this.pos + I > this.len) throw E(this, I);
            this.pos += I;
          } else do
            if (this.pos >= this.len) throw E(this);
          while (128 & this.buf[this.pos++]);
          return this;
        }, y.prototype.skipType = function(I) {
          switch (I) {
            case 0:
              this.skip();
              break;
            case 1:
              this.skip(8);
              break;
            case 2:
              this.skip(this.uint32());
              break;
            case 3:
              for (; (I = 7 & this.uint32()) != 4; ) this.skipType(I);
              break;
            case 5:
              this.skip(4);
              break;
            default:
              throw Error("invalid wire type " + I + " at offset " + this.pos);
          }
          return this;
        }, y._configure = function(I) {
          c = I, y.create = O(), c._configure();
          var k = d.Long ? "toLong" : "toNumber";
          d.merge(y.prototype, { int64: function() {
            return N.call(this)[k](!1);
          }, uint64: function() {
            return N.call(this)[k](!0);
          }, sint64: function() {
            return N.call(this).zzDecode()[k](!1);
          }, fixed64: function() {
            return _.call(this)[k](!0);
          }, sfixed64: function() {
            return _.call(this)[k](!1);
          } });
        };
      }, 593: function(l, v, s) {
        l.exports = p;
        var c = s(1408);
        (p.prototype = Object.create(c.prototype)).constructor = p;
        var d = s(9693);
        function p(m) {
          c.call(this, m);
        }
        p._configure = function() {
          d.Buffer && (p.prototype._slice = d.Buffer.prototype.slice);
        }, p.prototype.string = function() {
          var m = this.uint32();
          return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + m, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + m, this.len));
        }, p._configure();
      }, 9424: function(l, v, s) {
        l.exports = O;
        var c = s(9313);
        ((O.prototype = Object.create(c.prototype)).constructor = O).className = "Root";
        var d, p, m, E = s(3548), y = s(7025), g = s(7598), C = s(9935);
        function O(I) {
          c.call(this, "", I), this.deferred = [], this.files = [];
        }
        function N() {
        }
        O.fromJSON = function(I, k) {
          return k || (k = new O()), I.options && k.setOptions(I.options), k.addJSON(I.nested);
        }, O.prototype.resolvePath = C.path.resolve, O.prototype.fetch = C.fetch, O.prototype.load = function I(k, H, S) {
          typeof H == "function" && (S = H, H = void 0);
          var B = this;
          if (!S) return C.asPromise(I, B, k, H);
          var D = S === N;
          function F(ue, se) {
            if (S) {
              var ee = S;
              if (S = null, D) throw ue;
              ee(ue, se);
            }
          }
          function j(ue) {
            var se = ue.lastIndexOf("google/protobuf/");
            if (se > -1) {
              var ee = ue.substring(se);
              if (ee in m) return ee;
            }
            return null;
          }
          function G(ue, se) {
            try {
              if (C.isString(se) && se.charAt(0) === "{" && (se = JSON.parse(se)), C.isString(se)) {
                p.filename = ue;
                var ee, de = p(se, B, H), he = 0;
                if (de.imports) for (; he < de.imports.length; ++he) (ee = j(de.imports[he]) || B.resolvePath(ue, de.imports[he])) && U(ee);
                if (de.weakImports) for (he = 0; he < de.weakImports.length; ++he) (ee = j(de.weakImports[he]) || B.resolvePath(ue, de.weakImports[he])) && U(ee, !0);
              } else B.setOptions(se.options).addJSON(se.nested);
            } catch (pe) {
              F(pe);
            }
            D || M || F(null, B);
          }
          function U(ue, se) {
            if (!(B.files.indexOf(ue) > -1)) if (B.files.push(ue), ue in m) D ? G(ue, m[ue]) : (++M, setTimeout(function() {
              --M, G(ue, m[ue]);
            }));
            else if (D) {
              var ee;
              try {
                ee = C.fs.readFileSync(ue).toString("utf8");
              } catch (de) {
                return void (se || F(de));
              }
              G(ue, ee);
            } else ++M, B.fetch(ue, function(de, he) {
              --M, S && (de ? se ? M || F(null, B) : F(de) : G(ue, he));
            });
          }
          var M = 0;
          C.isString(k) && (k = [k]);
          for (var V, J = 0; J < k.length; ++J) (V = B.resolvePath("", k[J])) && U(V);
          if (D) return B;
          M || F(null, B);
        }, O.prototype.loadSync = function(I, k) {
          if (!C.isNode) throw Error("not supported");
          return this.load(I, k, N);
        }, O.prototype.resolveAll = function() {
          if (this.deferred.length) throw Error("unresolvable extensions: " + this.deferred.map(function(I) {
            return "'extend " + I.extend + "' in " + I.parent.fullName;
          }).join(", "));
          return c.prototype.resolveAll.call(this);
        };
        var w = /^[A-Z]/;
        function _(I, k) {
          var H = k.parent.lookup(k.extend);
          if (H) {
            var S = new E(k.fullName, k.id, k.type, k.rule, void 0, k.options);
            return S.declaringField = k, k.extensionField = S, H.add(S), !0;
          }
          return !1;
        }
        O.prototype._handleAdd = function(I) {
          if (I instanceof E) I.extend === void 0 || I.extensionField || _(0, I) || this.deferred.push(I);
          else if (I instanceof y) w.test(I.name) && (I.parent[I.name] = I.values);
          else if (!(I instanceof g)) {
            if (I instanceof d) for (var k = 0; k < this.deferred.length; ) _(0, this.deferred[k]) ? this.deferred.splice(k, 1) : ++k;
            for (var H = 0; H < I.nestedArray.length; ++H) this._handleAdd(I._nestedArray[H]);
            w.test(I.name) && (I.parent[I.name] = I);
          }
        }, O.prototype._handleRemove = function(I) {
          if (I instanceof E) {
            if (I.extend !== void 0) if (I.extensionField) I.extensionField.parent.remove(I.extensionField), I.extensionField = null;
            else {
              var k = this.deferred.indexOf(I);
              k > -1 && this.deferred.splice(k, 1);
            }
          } else if (I instanceof y) w.test(I.name) && delete I.parent[I.name];
          else if (I instanceof c) {
            for (var H = 0; H < I.nestedArray.length; ++H) this._handleRemove(I._nestedArray[H]);
            w.test(I.name) && delete I.parent[I.name];
          }
        }, O._configure = function(I, k, H) {
          d = I, p = k, m = H;
        };
      }, 5054: function(l) {
        l.exports = {};
      }, 5994: function(l, v, s) {
        v.Service = s(7948);
      }, 7948: function(l, v, s) {
        l.exports = d;
        var c = s(9693);
        function d(p, m, E) {
          if (typeof p != "function") throw TypeError("rpcImpl must be a function");
          c.EventEmitter.call(this), this.rpcImpl = p, this.requestDelimited = !!m, this.responseDelimited = !!E;
        }
        (d.prototype = Object.create(c.EventEmitter.prototype)).constructor = d, d.prototype.rpcCall = function p(m, E, y, g, C) {
          if (!g) throw TypeError("request must be specified");
          var O = this;
          if (!C) return c.asPromise(p, O, m, E, y, g);
          if (O.rpcImpl) try {
            return O.rpcImpl(m, E[O.requestDelimited ? "encodeDelimited" : "encode"](g).finish(), function(N, w) {
              if (N) return O.emit("error", N, m), C(N);
              if (w !== null) {
                if (!(w instanceof y)) try {
                  w = y[O.responseDelimited ? "decodeDelimited" : "decode"](w);
                } catch (_) {
                  return O.emit("error", _, m), C(_);
                }
                return O.emit("data", w, m), C(null, w);
              }
              O.end(!0);
            });
          } catch (N) {
            return O.emit("error", N, m), void setTimeout(function() {
              C(N);
            }, 0);
          }
          else setTimeout(function() {
            C(Error("already ended"));
          }, 0);
        }, d.prototype.end = function(p) {
          return this.rpcImpl && (p || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
        };
      }, 7513: function(l, v, s) {
        l.exports = E;
        var c = s(9313);
        ((E.prototype = Object.create(c.prototype)).constructor = E).className = "Service";
        var d = s(4429), p = s(9935), m = s(5994);
        function E(g, C) {
          c.call(this, g, C), this.methods = {}, this._methodsArray = null;
        }
        function y(g) {
          return g._methodsArray = null, g;
        }
        E.fromJSON = function(g, C) {
          var O = new E(g, C.options);
          if (C.methods) for (var N = Object.keys(C.methods), w = 0; w < N.length; ++w) O.add(d.fromJSON(N[w], C.methods[N[w]]));
          return C.nested && O.addJSON(C.nested), O.comment = C.comment, O;
        }, E.prototype.toJSON = function(g) {
          var C = c.prototype.toJSON.call(this, g), O = !!g && !!g.keepComments;
          return p.toObject(["options", C && C.options || void 0, "methods", c.arrayToJSON(this.methodsArray, g) || {}, "nested", C && C.nested || void 0, "comment", O ? this.comment : void 0]);
        }, Object.defineProperty(E.prototype, "methodsArray", { get: function() {
          return this._methodsArray || (this._methodsArray = p.toArray(this.methods));
        } }), E.prototype.get = function(g) {
          return this.methods[g] || c.prototype.get.call(this, g);
        }, E.prototype.resolveAll = function() {
          for (var g = this.methodsArray, C = 0; C < g.length; ++C) g[C].resolve();
          return c.prototype.resolve.call(this);
        }, E.prototype.add = function(g) {
          if (this.get(g.name)) throw Error("duplicate name '" + g.name + "' in " + this);
          return g instanceof d ? (this.methods[g.name] = g, g.parent = this, y(this)) : c.prototype.add.call(this, g);
        }, E.prototype.remove = function(g) {
          if (g instanceof d) {
            if (this.methods[g.name] !== g) throw Error(g + " is not a member of " + this);
            return delete this.methods[g.name], g.parent = null, y(this);
          }
          return c.prototype.remove.call(this, g);
        }, E.prototype.create = function(g, C, O) {
          for (var N, w = new m.Service(g, C, O), _ = 0; _ < this.methodsArray.length; ++_) {
            var I = p.lcFirst((N = this._methodsArray[_]).resolve().name).replace(/[^$\w_]/g, "");
            w[I] = p.codegen(["r", "c"], p.isReserved(I) ? I + "_" : I)("return this.rpcCall(m,q,s,r,c)")({ m: N, q: N.resolvedRequestType.ctor, s: N.resolvedResponseType.ctor });
          }
          return w;
        };
      }, 626: function(l) {
        l.exports = O;
        var v = /[\s{}=;:[\],'"()<>]/g, s = /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g, c = /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g, d = /^ *[*/]+ */, p = /^\s*\*?\/*/, m = /\n/g, E = /\s/, y = /\\(.?)/g, g = { 0: "\0", r: "\r", n: `
`, t: "	" };
        function C(N) {
          return N.replace(y, function(w, _) {
            switch (_) {
              case "\\":
              case "":
                return _;
              default:
                return g[_] || "";
            }
          });
        }
        function O(N, w) {
          N = N.toString();
          var _ = 0, I = N.length, k = 1, H = null, S = null, B = 0, D = !1, F = !1, j = [], G = null;
          function U(he) {
            return Error("illegal " + he + " (line " + k + ")");
          }
          function M(he) {
            return N.charAt(he);
          }
          function V(he, pe, Ce) {
            H = N.charAt(he++), B = k, D = !1, F = Ce;
            var _e, Le = he - (w ? 2 : 3);
            do
              if (--Le < 0 || (_e = N.charAt(Le)) === `
`) {
                D = !0;
                break;
              }
            while (_e === " " || _e === "	");
            for (var Te = N.substring(he, pe).split(m), K = 0; K < Te.length; ++K) Te[K] = Te[K].replace(w ? p : d, "").trim();
            S = Te.join(`
`).trim();
          }
          function J(he) {
            var pe = ue(he), Ce = N.substring(he, pe);
            return /^\s*\/{1,2}/.test(Ce);
          }
          function ue(he) {
            for (var pe = he; pe < I && M(pe) !== `
`; ) pe++;
            return pe;
          }
          function se() {
            if (j.length > 0) return j.shift();
            if (G) return function() {
              var Pe = G === "'" ? c : s;
              Pe.lastIndex = _ - 1;
              var xe = Pe.exec(N);
              if (!xe) throw U("string");
              return _ = Pe.lastIndex, ee(G), G = null, C(xe[1]);
            }();
            var he, pe, Ce, _e, Le, Te = _ === 0;
            do {
              if (_ === I) return null;
              for (he = !1; E.test(Ce = M(_)); ) if (Ce === `
` && (Te = !0, ++k), ++_ === I) return null;
              if (M(_) === "/") {
                if (++_ === I) throw U("comment");
                if (M(_) === "/") if (w) {
                  if (_e = _, Le = !1, J(_)) {
                    Le = !0;
                    do {
                      if ((_ = ue(_)) === I) break;
                      _++;
                    } while (J(_));
                  } else _ = Math.min(I, ue(_) + 1);
                  Le && V(_e, _, Te), k++, he = !0;
                } else {
                  for (Le = M(_e = _ + 1) === "/"; M(++_) !== `
`; ) if (_ === I) return null;
                  ++_, Le && V(_e, _ - 1, Te), ++k, he = !0;
                }
                else {
                  if ((Ce = M(_)) !== "*") return "/";
                  _e = _ + 1, Le = w || M(_e) === "*";
                  do {
                    if (Ce === `
` && ++k, ++_ === I) throw U("comment");
                    pe = Ce, Ce = M(_);
                  } while (pe !== "*" || Ce !== "/");
                  ++_, Le && V(_e, _ - 2, Te), he = !0;
                }
              }
            } while (he);
            var K = _;
            if (v.lastIndex = 0, !v.test(M(K++))) for (; K < I && !v.test(M(K)); ) ++K;
            var Oe = N.substring(_, _ = K);
            return Oe !== '"' && Oe !== "'" || (G = Oe), Oe;
          }
          function ee(he) {
            j.push(he);
          }
          function de() {
            if (!j.length) {
              var he = se();
              if (he === null) return null;
              ee(he);
            }
            return j[0];
          }
          return Object.defineProperty({ next: se, peek: de, push: ee, skip: function(he, pe) {
            var Ce = de();
            if (Ce === he) return se(), !0;
            if (!pe) throw U("token '" + Ce + "', '" + he + "' expected");
            return !1;
          }, cmnt: function(he) {
            var pe = null;
            return he === void 0 ? B === k - 1 && (w || H === "*" || D) && (pe = F ? S : null) : (B < he && de(), B !== he || D || !w && H !== "/" || (pe = F ? null : S)), pe;
          } }, "line", { get: function() {
            return k;
          } });
        }
        O.unescape = C;
      }, 7645: function(l, v, s) {
        l.exports = S;
        var c = s(9313);
        ((S.prototype = Object.create(c.prototype)).constructor = S).className = "Type";
        var d = s(7025), p = s(7598), m = s(3548), E = s(6039), y = s(7513), g = s(8368), C = s(1408), O = s(1173), N = s(9935), w = s(4928), _ = s(5305), I = s(4497), k = s(3996), H = s(1667);
        function S(D, F) {
          c.call(this, D, F), this.fields = {}, this.oneofs = void 0, this.extensions = void 0, this.reserved = void 0, this.group = void 0, this._fieldsById = null, this._fieldsArray = null, this._oneofsArray = null, this._ctor = null;
        }
        function B(D) {
          return D._fieldsById = D._fieldsArray = D._oneofsArray = null, delete D.encode, delete D.decode, delete D.verify, D;
        }
        Object.defineProperties(S.prototype, { fieldsById: { get: function() {
          if (this._fieldsById) return this._fieldsById;
          this._fieldsById = {};
          for (var D = Object.keys(this.fields), F = 0; F < D.length; ++F) {
            var j = this.fields[D[F]], G = j.id;
            if (this._fieldsById[G]) throw Error("duplicate id " + G + " in " + this);
            this._fieldsById[G] = j;
          }
          return this._fieldsById;
        } }, fieldsArray: { get: function() {
          return this._fieldsArray || (this._fieldsArray = N.toArray(this.fields));
        } }, oneofsArray: { get: function() {
          return this._oneofsArray || (this._oneofsArray = N.toArray(this.oneofs));
        } }, ctor: { get: function() {
          return this._ctor || (this.ctor = S.generateConstructor(this)());
        }, set: function(D) {
          var F = D.prototype;
          F instanceof g || ((D.prototype = new g()).constructor = D, N.merge(D.prototype, F)), D.$type = D.prototype.$type = this, N.merge(D, g, !0), this._ctor = D;
          for (var j = 0; j < this.fieldsArray.length; ++j) this._fieldsArray[j].resolve();
          var G = {};
          for (j = 0; j < this.oneofsArray.length; ++j) G[this._oneofsArray[j].resolve().name] = { get: N.oneOfGetter(this._oneofsArray[j].oneof), set: N.oneOfSetter(this._oneofsArray[j].oneof) };
          j && Object.defineProperties(D.prototype, G);
        } } }), S.generateConstructor = function(D) {
          for (var F, j = N.codegen(["p"], D.name), G = 0; G < D.fieldsArray.length; ++G) (F = D._fieldsArray[G]).map ? j("this%s={}", N.safeProp(F.name)) : F.repeated && j("this%s=[]", N.safeProp(F.name));
          return j("if(p)for(var ks=Object.keys(p),i=0;i<ks.length;++i)if(p[ks[i]]!=null)")("this[ks[i]]=p[ks[i]]");
        }, S.fromJSON = function(D, F) {
          var j = new S(D, F.options);
          j.extensions = F.extensions, j.reserved = F.reserved;
          for (var G = Object.keys(F.fields), U = 0; U < G.length; ++U) j.add((F.fields[G[U]].keyType !== void 0 ? E.fromJSON : m.fromJSON)(G[U], F.fields[G[U]]));
          if (F.oneofs) for (G = Object.keys(F.oneofs), U = 0; U < G.length; ++U) j.add(p.fromJSON(G[U], F.oneofs[G[U]]));
          if (F.nested) for (G = Object.keys(F.nested), U = 0; U < G.length; ++U) {
            var M = F.nested[G[U]];
            j.add((M.id !== void 0 ? m.fromJSON : M.fields !== void 0 ? S.fromJSON : M.values !== void 0 ? d.fromJSON : M.methods !== void 0 ? y.fromJSON : c.fromJSON)(G[U], M));
          }
          return F.extensions && F.extensions.length && (j.extensions = F.extensions), F.reserved && F.reserved.length && (j.reserved = F.reserved), F.group && (j.group = !0), F.comment && (j.comment = F.comment), j;
        }, S.prototype.toJSON = function(D) {
          var F = c.prototype.toJSON.call(this, D), j = !!D && !!D.keepComments;
          return N.toObject(["options", F && F.options || void 0, "oneofs", c.arrayToJSON(this.oneofsArray, D), "fields", c.arrayToJSON(this.fieldsArray.filter(function(G) {
            return !G.declaringField;
          }), D) || {}, "extensions", this.extensions && this.extensions.length ? this.extensions : void 0, "reserved", this.reserved && this.reserved.length ? this.reserved : void 0, "group", this.group || void 0, "nested", F && F.nested || void 0, "comment", j ? this.comment : void 0]);
        }, S.prototype.resolveAll = function() {
          for (var D = this.fieldsArray, F = 0; F < D.length; ) D[F++].resolve();
          var j = this.oneofsArray;
          for (F = 0; F < j.length; ) j[F++].resolve();
          return c.prototype.resolveAll.call(this);
        }, S.prototype.get = function(D) {
          return this.fields[D] || this.oneofs && this.oneofs[D] || this.nested && this.nested[D] || null;
        }, S.prototype.add = function(D) {
          if (this.get(D.name)) throw Error("duplicate name '" + D.name + "' in " + this);
          if (D instanceof m && D.extend === void 0) {
            if (this._fieldsById ? this._fieldsById[D.id] : this.fieldsById[D.id]) throw Error("duplicate id " + D.id + " in " + this);
            if (this.isReservedId(D.id)) throw Error("id " + D.id + " is reserved in " + this);
            if (this.isReservedName(D.name)) throw Error("name '" + D.name + "' is reserved in " + this);
            return D.parent && D.parent.remove(D), this.fields[D.name] = D, D.message = this, D.onAdd(this), B(this);
          }
          return D instanceof p ? (this.oneofs || (this.oneofs = {}), this.oneofs[D.name] = D, D.onAdd(this), B(this)) : c.prototype.add.call(this, D);
        }, S.prototype.remove = function(D) {
          if (D instanceof m && D.extend === void 0) {
            if (!this.fields || this.fields[D.name] !== D) throw Error(D + " is not a member of " + this);
            return delete this.fields[D.name], D.parent = null, D.onRemove(this), B(this);
          }
          if (D instanceof p) {
            if (!this.oneofs || this.oneofs[D.name] !== D) throw Error(D + " is not a member of " + this);
            return delete this.oneofs[D.name], D.parent = null, D.onRemove(this), B(this);
          }
          return c.prototype.remove.call(this, D);
        }, S.prototype.isReservedId = function(D) {
          return c.isReservedId(this.reserved, D);
        }, S.prototype.isReservedName = function(D) {
          return c.isReservedName(this.reserved, D);
        }, S.prototype.create = function(D) {
          return new this.ctor(D);
        }, S.prototype.setup = function() {
          for (var D = this.fullName, F = [], j = 0; j < this.fieldsArray.length; ++j) F.push(this._fieldsArray[j].resolve().resolvedType);
          this.encode = w(this)({ Writer: O, types: F, util: N }), this.decode = _(this)({ Reader: C, types: F, util: N }), this.verify = I(this)({ types: F, util: N }), this.fromObject = k.fromObject(this)({ types: F, util: N }), this.toObject = k.toObject(this)({ types: F, util: N });
          var G = H[D];
          if (G) {
            var U = Object.create(this);
            U.fromObject = this.fromObject, this.fromObject = G.fromObject.bind(U), U.toObject = this.toObject, this.toObject = G.toObject.bind(U);
          }
          return this;
        }, S.prototype.encode = function(D, F) {
          return this.setup().encode(D, F);
        }, S.prototype.encodeDelimited = function(D, F) {
          return this.encode(D, F && F.len ? F.fork() : F).ldelim();
        }, S.prototype.decode = function(D, F) {
          return this.setup().decode(D, F);
        }, S.prototype.decodeDelimited = function(D) {
          return D instanceof C || (D = C.create(D)), this.decode(D, D.uint32());
        }, S.prototype.verify = function(D) {
          return this.setup().verify(D);
        }, S.prototype.fromObject = function(D) {
          return this.setup().fromObject(D);
        }, S.prototype.toObject = function(D, F) {
          return this.setup().toObject(D, F);
        }, S.d = function(D) {
          return function(F) {
            N.decorateType(F, D);
          };
        };
      }, 7063: function(l, v, s) {
        var c = v, d = s(9935), p = ["double", "float", "int32", "uint32", "sint32", "fixed32", "sfixed32", "int64", "uint64", "sint64", "fixed64", "sfixed64", "bool", "string", "bytes"];
        function m(E, y) {
          var g = 0, C = {};
          for (y |= 0; g < E.length; ) C[p[g + y]] = E[g++];
          return C;
        }
        c.basic = m([1, 5, 0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0, 2, 2]), c.defaults = m([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, !1, "", d.emptyArray, null]), c.long = m([0, 0, 0, 1, 1], 7), c.mapKey = m([0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0, 2], 2), c.packed = m([1, 5, 0, 0, 0, 5, 5, 0, 0, 0, 1, 1, 0]);
      }, 9935: function(l, v, s) {
        var c, d, p = l.exports = s(9693), m = s(5054);
        p.codegen = s(5124), p.fetch = s(9054), p.path = s(8626), p.fs = p.inquire("fs"), p.toArray = function(O) {
          if (O) {
            for (var N = Object.keys(O), w = new Array(N.length), _ = 0; _ < N.length; ) w[_] = O[N[_++]];
            return w;
          }
          return [];
        }, p.toObject = function(O) {
          for (var N = {}, w = 0; w < O.length; ) {
            var _ = O[w++], I = O[w++];
            I !== void 0 && (N[_] = I);
          }
          return N;
        };
        var E = /\\/g, y = /"/g;
        p.isReserved = function(O) {
          return /^(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$/.test(O);
        }, p.safeProp = function(O) {
          return !/^[$\w_]+$/.test(O) || p.isReserved(O) ? '["' + O.replace(E, "\\\\").replace(y, '\\"') + '"]' : "." + O;
        }, p.ucFirst = function(O) {
          return O.charAt(0).toUpperCase() + O.substring(1);
        };
        var g = /_([a-z])/g;
        p.camelCase = function(O) {
          return O.substring(0, 1) + O.substring(1).replace(g, function(N, w) {
            return w.toUpperCase();
          });
        }, p.compareFieldsById = function(O, N) {
          return O.id - N.id;
        }, p.decorateType = function(O, N) {
          if (O.$type) return N && O.$type.name !== N && (p.decorateRoot.remove(O.$type), O.$type.name = N, p.decorateRoot.add(O.$type)), O.$type;
          c || (c = s(7645));
          var w = new c(N || O.name);
          return p.decorateRoot.add(w), w.ctor = O, Object.defineProperty(O, "$type", { value: w, enumerable: !1 }), Object.defineProperty(O.prototype, "$type", { value: w, enumerable: !1 }), w;
        };
        var C = 0;
        p.decorateEnum = function(O) {
          if (O.$type) return O.$type;
          d || (d = s(7025));
          var N = new d("Enum" + C++, O);
          return p.decorateRoot.add(N), Object.defineProperty(O, "$type", { value: N, enumerable: !1 }), N;
        }, p.setProperty = function(O, N, w) {
          if (typeof O != "object") throw TypeError("dst must be an object");
          if (!N) throw TypeError("path must be specified");
          return function _(I, k, H) {
            var S = k.shift();
            if (S === "__proto__") return I;
            if (k.length > 0) I[S] = _(I[S] || {}, k, H);
            else {
              var B = I[S];
              B && (H = [].concat(B).concat(H)), I[S] = H;
            }
            return I;
          }(O, N = N.split("."), w);
        }, Object.defineProperty(p, "decorateRoot", { get: function() {
          return m.decorated || (m.decorated = new (s(9424))());
        } });
      }, 1945: function(l, v, s) {
        l.exports = d;
        var c = s(9693);
        function d(y, g) {
          this.lo = y >>> 0, this.hi = g >>> 0;
        }
        var p = d.zero = new d(0, 0);
        p.toNumber = function() {
          return 0;
        }, p.zzEncode = p.zzDecode = function() {
          return this;
        }, p.length = function() {
          return 1;
        };
        var m = d.zeroHash = "\0\0\0\0\0\0\0\0";
        d.fromNumber = function(y) {
          if (y === 0) return p;
          var g = y < 0;
          g && (y = -y);
          var C = y >>> 0, O = (y - C) / 4294967296 >>> 0;
          return g && (O = ~O >>> 0, C = ~C >>> 0, ++C > 4294967295 && (C = 0, ++O > 4294967295 && (O = 0))), new d(C, O);
        }, d.from = function(y) {
          if (typeof y == "number") return d.fromNumber(y);
          if (c.isString(y)) {
            if (!c.Long) return d.fromNumber(parseInt(y, 10));
            y = c.Long.fromString(y);
          }
          return y.low || y.high ? new d(y.low >>> 0, y.high >>> 0) : p;
        }, d.prototype.toNumber = function(y) {
          if (!y && this.hi >>> 31) {
            var g = 1 + ~this.lo >>> 0, C = ~this.hi >>> 0;
            return g || (C = C + 1 >>> 0), -(g + 4294967296 * C);
          }
          return this.lo + 4294967296 * this.hi;
        }, d.prototype.toLong = function(y) {
          return c.Long ? new c.Long(0 | this.lo, 0 | this.hi, !!y) : { low: 0 | this.lo, high: 0 | this.hi, unsigned: !!y };
        };
        var E = String.prototype.charCodeAt;
        d.fromHash = function(y) {
          return y === m ? p : new d((E.call(y, 0) | E.call(y, 1) << 8 | E.call(y, 2) << 16 | E.call(y, 3) << 24) >>> 0, (E.call(y, 4) | E.call(y, 5) << 8 | E.call(y, 6) << 16 | E.call(y, 7) << 24) >>> 0);
        }, d.prototype.toHash = function() {
          return String.fromCharCode(255 & this.lo, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, 255 & this.hi, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
        }, d.prototype.zzEncode = function() {
          var y = this.hi >> 31;
          return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ y) >>> 0, this.lo = (this.lo << 1 ^ y) >>> 0, this;
        }, d.prototype.zzDecode = function() {
          var y = -(1 & this.lo);
          return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ y) >>> 0, this.hi = (this.hi >>> 1 ^ y) >>> 0, this;
        }, d.prototype.length = function() {
          var y = this.lo, g = (this.lo >>> 28 | this.hi << 4) >>> 0, C = this.hi >>> 24;
          return C === 0 ? g === 0 ? y < 16384 ? y < 128 ? 1 : 2 : y < 2097152 ? 3 : 4 : g < 16384 ? g < 128 ? 5 : 6 : g < 2097152 ? 7 : 8 : C < 128 ? 9 : 10;
        };
      }, 9693: function(l, v, s) {
        var c = v;
        function d(m, E, y) {
          for (var g = Object.keys(E), C = 0; C < g.length; ++C) m[g[C]] !== void 0 && y || (m[g[C]] = E[g[C]]);
          return m;
        }
        function p(m) {
          function E(y, g) {
            if (!(this instanceof E)) return new E(y, g);
            Object.defineProperty(this, "message", { get: function() {
              return y;
            } }), Error.captureStackTrace ? Error.captureStackTrace(this, E) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), g && d(this, g);
          }
          return (E.prototype = Object.create(Error.prototype)).constructor = E, Object.defineProperty(E.prototype, "name", { get: function() {
            return m;
          } }), E.prototype.toString = function() {
            return this.name + ": " + this.message;
          }, E;
        }
        c.asPromise = s(4537), c.base64 = s(7419), c.EventEmitter = s(9211), c.float = s(945), c.inquire = s(7199), c.utf8 = s(4997), c.pool = s(6662), c.LongBits = s(1945), c.isNode = !!(s.g !== void 0 && s.g && s.g.process && s.g.process.versions && s.g.process.versions.node), c.global = c.isNode && s.g || typeof window < "u" && window || typeof self < "u" && self || this, c.emptyArray = Object.freeze ? Object.freeze([]) : [], c.emptyObject = Object.freeze ? Object.freeze({}) : {}, c.isInteger = Number.isInteger || function(m) {
          return typeof m == "number" && isFinite(m) && Math.floor(m) === m;
        }, c.isString = function(m) {
          return typeof m == "string" || m instanceof String;
        }, c.isObject = function(m) {
          return m && typeof m == "object";
        }, c.isset = c.isSet = function(m, E) {
          var y = m[E];
          return !(y == null || !m.hasOwnProperty(E)) && (typeof y != "object" || (Array.isArray(y) ? y.length : Object.keys(y).length) > 0);
        }, c.Buffer = function() {
          try {
            var m = c.inquire("buffer").Buffer;
            return m.prototype.utf8Write ? m : null;
          } catch {
            return null;
          }
        }(), c._Buffer_from = null, c._Buffer_allocUnsafe = null, c.newBuffer = function(m) {
          return typeof m == "number" ? c.Buffer ? c._Buffer_allocUnsafe(m) : new c.Array(m) : c.Buffer ? c._Buffer_from(m) : typeof Uint8Array > "u" ? m : new Uint8Array(m);
        }, c.Array = typeof Uint8Array < "u" ? Uint8Array : Array, c.Long = c.global.dcodeIO && c.global.dcodeIO.Long || c.global.Long || c.inquire("long"), c.key2Re = /^true|false|0|1$/, c.key32Re = /^-?(?:0|[1-9][0-9]*)$/, c.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, c.longToHash = function(m) {
          return m ? c.LongBits.from(m).toHash() : c.LongBits.zeroHash;
        }, c.longFromHash = function(m, E) {
          var y = c.LongBits.fromHash(m);
          return c.Long ? c.Long.fromBits(y.lo, y.hi, E) : y.toNumber(!!E);
        }, c.merge = d, c.lcFirst = function(m) {
          return m.charAt(0).toLowerCase() + m.substring(1);
        }, c.newError = p, c.ProtocolError = p("ProtocolError"), c.oneOfGetter = function(m) {
          for (var E = {}, y = 0; y < m.length; ++y) E[m[y]] = 1;
          return function() {
            for (var g = Object.keys(this), C = g.length - 1; C > -1; --C) if (E[g[C]] === 1 && this[g[C]] !== void 0 && this[g[C]] !== null) return g[C];
          };
        }, c.oneOfSetter = function(m) {
          return function(E) {
            for (var y = 0; y < m.length; ++y) m[y] !== E && delete this[m[y]];
          };
        }, c.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }, c._configure = function() {
          var m = c.Buffer;
          m ? (c._Buffer_from = m.from !== Uint8Array.from && m.from || function(E, y) {
            return new m(E, y);
          }, c._Buffer_allocUnsafe = m.allocUnsafe || function(E) {
            return new m(E);
          }) : c._Buffer_from = c._Buffer_allocUnsafe = null;
        };
      }, 4497: function(l, v, s) {
        l.exports = function(y) {
          var g = d.codegen(["m"], y.name + "$verify")('if(typeof m!=="object"||m===null)')("return%j", "object expected"), C = {};
          y.oneofsArray.length && g("var p={}");
          for (var O = 0; O < y.fieldsArray.length; ++O) {
            var N = y._fieldsArray[O].resolve(), w = "m" + d.safeProp(N.name);
            if (N.optional && g("if(%s!=null&&m.hasOwnProperty(%j)){", w, N.name), N.map) g("if(!util.isObject(%s))", w)("return%j", p(N, "object"))("var k=Object.keys(%s)", w)("for(var i=0;i<k.length;++i){"), E(g, N, "k[i]"), m(g, N, O, w + "[k[i]]")("}");
            else if (N.repeated) g("if(!Array.isArray(%s))", w)("return%j", p(N, "array"))("for(var i=0;i<%s.length;++i){", w), m(g, N, O, w + "[i]")("}");
            else {
              if (N.partOf) {
                var _ = d.safeProp(N.partOf.name);
                C[N.partOf.name] === 1 && g("if(p%s===1)", _)("return%j", N.partOf.name + ": multiple values"), C[N.partOf.name] = 1, g("p%s=1", _);
              }
              m(g, N, O, w);
            }
            N.optional && g("}");
          }
          return g("return null");
        };
        var c = s(7025), d = s(9935);
        function p(y, g) {
          return y.name + ": " + g + (y.repeated && g !== "array" ? "[]" : y.map && g !== "object" ? "{k:" + y.keyType + "}" : "") + " expected";
        }
        function m(y, g, C, O) {
          if (g.resolvedType) if (g.resolvedType instanceof c) {
            y("switch(%s){", O)("default:")("return%j", p(g, "enum value"));
            for (var N = Object.keys(g.resolvedType.values), w = 0; w < N.length; ++w) y("case %i:", g.resolvedType.values[N[w]]);
            y("break")("}");
          } else y("{")("var e=types[%i].verify(%s);", C, O)("if(e)")("return%j+e", g.name + ".")("}");
          else switch (g.type) {
            case "int32":
            case "uint32":
            case "sint32":
            case "fixed32":
            case "sfixed32":
              y("if(!util.isInteger(%s))", O)("return%j", p(g, "integer"));
              break;
            case "int64":
            case "uint64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
              y("if(!util.isInteger(%s)&&!(%s&&util.isInteger(%s.low)&&util.isInteger(%s.high)))", O, O, O, O)("return%j", p(g, "integer|Long"));
              break;
            case "float":
            case "double":
              y('if(typeof %s!=="number")', O)("return%j", p(g, "number"));
              break;
            case "bool":
              y('if(typeof %s!=="boolean")', O)("return%j", p(g, "boolean"));
              break;
            case "string":
              y("if(!util.isString(%s))", O)("return%j", p(g, "string"));
              break;
            case "bytes":
              y('if(!(%s&&typeof %s.length==="number"||util.isString(%s)))', O, O, O)("return%j", p(g, "buffer"));
          }
          return y;
        }
        function E(y, g, C) {
          switch (g.keyType) {
            case "int32":
            case "uint32":
            case "sint32":
            case "fixed32":
            case "sfixed32":
              y("if(!util.key32Re.test(%s))", C)("return%j", p(g, "integer key"));
              break;
            case "int64":
            case "uint64":
            case "sint64":
            case "fixed64":
            case "sfixed64":
              y("if(!util.key64Re.test(%s))", C)("return%j", p(g, "integer|Long key"));
              break;
            case "bool":
              y("if(!util.key2Re.test(%s))", C)("return%j", p(g, "boolean key"));
          }
          return y;
        }
      }, 1667: function(l, v, s) {
        var c = v, d = s(8368);
        c[".google.protobuf.Any"] = { fromObject: function(p) {
          if (p && p["@type"]) {
            var m = p["@type"].substring(p["@type"].lastIndexOf("/") + 1), E = this.lookup(m);
            if (E) {
              var y = p["@type"].charAt(0) === "." ? p["@type"].substr(1) : p["@type"];
              return y.indexOf("/") === -1 && (y = "/" + y), this.create({ type_url: y, value: E.encode(E.fromObject(p)).finish() });
            }
          }
          return this.fromObject(p);
        }, toObject: function(p, m) {
          var E = "", y = "";
          if (m && m.json && p.type_url && p.value) {
            y = p.type_url.substring(p.type_url.lastIndexOf("/") + 1), E = p.type_url.substring(0, p.type_url.lastIndexOf("/") + 1);
            var g = this.lookup(y);
            g && (p = g.decode(p.value));
          }
          if (!(p instanceof this.ctor) && p instanceof d) {
            var C = p.$type.toObject(p, m);
            return E === "" && (E = "type.googleapis.com/"), y = E + (p.$type.fullName[0] === "." ? p.$type.fullName.substr(1) : p.$type.fullName), C["@type"] = y, C;
          }
          return this.toObject(p, m);
        } };
      }, 1173: function(l, v, s) {
        l.exports = O;
        var c, d = s(9693), p = d.LongBits, m = d.base64, E = d.utf8;
        function y(S, B, D) {
          this.fn = S, this.len = B, this.next = void 0, this.val = D;
        }
        function g() {
        }
        function C(S) {
          this.head = S.head, this.tail = S.tail, this.len = S.len, this.next = S.states;
        }
        function O() {
          this.len = 0, this.head = new y(g, 0, 0), this.tail = this.head, this.states = null;
        }
        var N = function() {
          return d.Buffer ? function() {
            return (O.create = function() {
              return new c();
            })();
          } : function() {
            return new O();
          };
        };
        function w(S, B, D) {
          B[D] = 255 & S;
        }
        function _(S, B) {
          this.len = S, this.next = void 0, this.val = B;
        }
        function I(S, B, D) {
          for (; S.hi; ) B[D++] = 127 & S.lo | 128, S.lo = (S.lo >>> 7 | S.hi << 25) >>> 0, S.hi >>>= 7;
          for (; S.lo > 127; ) B[D++] = 127 & S.lo | 128, S.lo = S.lo >>> 7;
          B[D++] = S.lo;
        }
        function k(S, B, D) {
          B[D] = 255 & S, B[D + 1] = S >>> 8 & 255, B[D + 2] = S >>> 16 & 255, B[D + 3] = S >>> 24;
        }
        O.create = N(), O.alloc = function(S) {
          return new d.Array(S);
        }, d.Array !== Array && (O.alloc = d.pool(O.alloc, d.Array.prototype.subarray)), O.prototype._push = function(S, B, D) {
          return this.tail = this.tail.next = new y(S, B, D), this.len += B, this;
        }, _.prototype = Object.create(y.prototype), _.prototype.fn = function(S, B, D) {
          for (; S > 127; ) B[D++] = 127 & S | 128, S >>>= 7;
          B[D] = S;
        }, O.prototype.uint32 = function(S) {
          return this.len += (this.tail = this.tail.next = new _((S >>>= 0) < 128 ? 1 : S < 16384 ? 2 : S < 2097152 ? 3 : S < 268435456 ? 4 : 5, S)).len, this;
        }, O.prototype.int32 = function(S) {
          return S < 0 ? this._push(I, 10, p.fromNumber(S)) : this.uint32(S);
        }, O.prototype.sint32 = function(S) {
          return this.uint32((S << 1 ^ S >> 31) >>> 0);
        }, O.prototype.uint64 = function(S) {
          var B = p.from(S);
          return this._push(I, B.length(), B);
        }, O.prototype.int64 = O.prototype.uint64, O.prototype.sint64 = function(S) {
          var B = p.from(S).zzEncode();
          return this._push(I, B.length(), B);
        }, O.prototype.bool = function(S) {
          return this._push(w, 1, S ? 1 : 0);
        }, O.prototype.fixed32 = function(S) {
          return this._push(k, 4, S >>> 0);
        }, O.prototype.sfixed32 = O.prototype.fixed32, O.prototype.fixed64 = function(S) {
          var B = p.from(S);
          return this._push(k, 4, B.lo)._push(k, 4, B.hi);
        }, O.prototype.sfixed64 = O.prototype.fixed64, O.prototype.float = function(S) {
          return this._push(d.float.writeFloatLE, 4, S);
        }, O.prototype.double = function(S) {
          return this._push(d.float.writeDoubleLE, 8, S);
        };
        var H = d.Array.prototype.set ? function(S, B, D) {
          B.set(S, D);
        } : function(S, B, D) {
          for (var F = 0; F < S.length; ++F) B[D + F] = S[F];
        };
        O.prototype.bytes = function(S) {
          var B = S.length >>> 0;
          if (!B) return this._push(w, 1, 0);
          if (d.isString(S)) {
            var D = O.alloc(B = m.length(S));
            m.decode(S, D, 0), S = D;
          }
          return this.uint32(B)._push(H, B, S);
        }, O.prototype.string = function(S) {
          var B = E.length(S);
          return B ? this.uint32(B)._push(E.write, B, S) : this._push(w, 1, 0);
        }, O.prototype.fork = function() {
          return this.states = new C(this), this.head = this.tail = new y(g, 0, 0), this.len = 0, this;
        }, O.prototype.reset = function() {
          return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new y(g, 0, 0), this.len = 0), this;
        }, O.prototype.ldelim = function() {
          var S = this.head, B = this.tail, D = this.len;
          return this.reset().uint32(D), D && (this.tail.next = S.next, this.tail = B, this.len += D), this;
        }, O.prototype.finish = function() {
          for (var S = this.head.next, B = this.constructor.alloc(this.len), D = 0; S; ) S.fn(S.val, B, D), D += S.len, S = S.next;
          return B;
        }, O._configure = function(S) {
          c = S, O.create = N(), c._configure();
        };
      }, 3155: function(l, v, s) {
        l.exports = p;
        var c = s(1173);
        (p.prototype = Object.create(c.prototype)).constructor = p;
        var d = s(9693);
        function p() {
          c.call(this);
        }
        function m(E, y, g) {
          E.length < 40 ? d.utf8.write(E, y, g) : y.utf8Write ? y.utf8Write(E, g) : y.write(E, g);
        }
        p._configure = function() {
          p.alloc = d._Buffer_allocUnsafe, p.writeBytesBuffer = d.Buffer && d.Buffer.prototype instanceof Uint8Array && d.Buffer.prototype.set.name === "set" ? function(E, y, g) {
            y.set(E, g);
          } : function(E, y, g) {
            if (E.copy) E.copy(y, g, 0, E.length);
            else for (var C = 0; C < E.length; ) y[g++] = E[C++];
          };
        }, p.prototype.bytes = function(E) {
          d.isString(E) && (E = d._Buffer_from(E, "base64"));
          var y = E.length >>> 0;
          return this.uint32(y), y && this._push(p.writeBytesBuffer, y, E), this;
        }, p.prototype.string = function(E) {
          var y = d.Buffer.byteLength(E);
          return this.uint32(y), y && this._push(m, y, E), this;
        }, p._configure();
      }, 8e3: function(l, v, s) {
        var c = s(7581);
        l.exports = s(3626)(c), "_sockjs_onload" in s.g && setTimeout(s.g._sockjs_onload, 1);
      }, 2530: function(l, v, s) {
        var c = s(5717), d = s(685);
        function p() {
          d.call(this), this.initEvent("close", !1, !1), this.wasClean = !1, this.code = 0, this.reason = "";
        }
        c(p, d), l.exports = p;
      }, 3212: function(l, v, s) {
        var c = s(5717), d = s(3184);
        function p() {
          d.call(this);
        }
        c(p, d), p.prototype.removeAllListeners = function(m) {
          m ? delete this._listeners[m] : this._listeners = {};
        }, p.prototype.once = function(m, E) {
          var y = this, g = !1;
          this.on(m, function C() {
            y.removeListener(m, C), g || (g = !0, E.apply(this, arguments));
          });
        }, p.prototype.emit = function() {
          var m = arguments[0], E = this._listeners[m];
          if (E) {
            for (var y = arguments.length, g = new Array(y - 1), C = 1; C < y; C++) g[C - 1] = arguments[C];
            for (var O = 0; O < E.length; O++) E[O].apply(this, g);
          }
        }, p.prototype.on = p.prototype.addListener = d.prototype.addEventListener, p.prototype.removeListener = d.prototype.removeEventListener, l.exports.v = p;
      }, 685: function(l) {
        function v(s) {
          this.type = s;
        }
        v.prototype.initEvent = function(s, c, d) {
          return this.type = s, this.bubbles = c, this.cancelable = d, this.timeStamp = +/* @__PURE__ */ new Date(), this;
        }, v.prototype.stopPropagation = function() {
        }, v.prototype.preventDefault = function() {
        }, v.CAPTURING_PHASE = 1, v.AT_TARGET = 2, v.BUBBLING_PHASE = 3, l.exports = v;
      }, 3184: function(l) {
        function v() {
          this._listeners = {};
        }
        v.prototype.addEventListener = function(s, c) {
          s in this._listeners || (this._listeners[s] = []);
          var d = this._listeners[s];
          d.indexOf(c) === -1 && (d = d.concat([c])), this._listeners[s] = d;
        }, v.prototype.removeEventListener = function(s, c) {
          var d = this._listeners[s];
          if (d) {
            var p = d.indexOf(c);
            p === -1 || (d.length > 1 ? this._listeners[s] = d.slice(0, p).concat(d.slice(p + 1)) : delete this._listeners[s]);
          }
        }, v.prototype.dispatchEvent = function() {
          var s = arguments[0], c = s.type, d = arguments.length === 1 ? [s] : Array.apply(null, arguments);
          if (this["on" + c] && this["on" + c].apply(this, d), c in this._listeners) for (var p = this._listeners[c], m = 0; m < p.length; m++) p[m].apply(this, d);
        }, l.exports = v;
      }, 3326: function(l, v, s) {
        var c = s(5717), d = s(685);
        function p(m) {
          d.call(this), this.initEvent("message", !1, !1), this.data = m;
        }
        c(p, d), l.exports = p;
      }, 691: function(l, v, s) {
        var c = s(3683);
        function d(p) {
          this._transport = p, p.on("message", this._transportMessage.bind(this)), p.on("close", this._transportClose.bind(this));
        }
        d.prototype._transportClose = function(p, m) {
          c.postMessage("c", JSON.stringify([p, m]));
        }, d.prototype._transportMessage = function(p) {
          c.postMessage("t", p);
        }, d.prototype._send = function(p) {
          this._transport.send(p);
        }, d.prototype._close = function() {
          this._transport.close(), this._transport.removeAllListeners();
        }, l.exports = d;
      }, 551: function(l, v, s) {
        var c = s(273), d = s(7705), p = s(691), m = s(6311), E = s(3683), y = s(7486);
        l.exports = function(g, C) {
          var O, N = {};
          C.forEach(function(w) {
            w.facadeTransport && (N[w.facadeTransport.transportName] = w.facadeTransport);
          }), N[m.transportName] = m, g.bootstrap_iframe = function() {
            var w;
            E.currentWindowId = y.hash.slice(1), d.attachEvent("message", function(_) {
              if (_.source === parent && (O === void 0 && (O = _.origin), _.origin === O)) {
                var I;
                try {
                  I = JSON.parse(_.data);
                } catch {
                  return void _.data;
                }
                if (I.windowId === E.currentWindowId) switch (I.type) {
                  case "s":
                    var k;
                    try {
                      k = JSON.parse(I.data);
                    } catch {
                      I.data;
                      break;
                    }
                    var H = k[0], S = k[1], B = k[2], D = k[3];
                    if (H !== g.version) throw new Error('Incompatible SockJS! Main site uses: "' + H + '", the iframe: "' + g.version + '".');
                    if (!c.isOriginEqual(B, y.href) || !c.isOriginEqual(D, y.href)) throw new Error("Can't connect to different domain from within an iframe. (" + y.href + ", " + B + ", " + D + ")");
                    w = new p(new N[S](B, D));
                    break;
                  case "m":
                    w._send(I.data);
                    break;
                  case "c":
                    w && w._close(), w = null;
                }
              }
            }), E.postMessage("s");
          };
        };
      }, 2550: function(l, v, s) {
        var c = s(3212).v, d = s(5717), p = s(2217);
        function m(E, y) {
          c.call(this);
          var g = this, C = +/* @__PURE__ */ new Date();
          this.xo = new y("GET", E), this.xo.once("finish", function(O, N) {
            var w, _;
            if (O === 200) {
              if (_ = +/* @__PURE__ */ new Date() - C, N) try {
                w = JSON.parse(N);
              } catch {
              }
              p.isObject(w) || (w = {});
            }
            g.emit("finish", w, _), g.removeAllListeners();
          });
        }
        d(m, c), m.prototype.close = function() {
          this.removeAllListeners(), this.xo.close();
        }, l.exports = m;
      }, 6311: function(l, v, s) {
        var c = s(5717), d = s(3212).v, p = s(3515), m = s(2550);
        function E(y) {
          var g = this;
          d.call(this), this.ir = new m(y, p), this.ir.once("finish", function(C, O) {
            g.ir = null, g.emit("message", JSON.stringify([C, O]));
          });
        }
        c(E, d), E.transportName = "iframe-info-receiver", E.prototype.close = function() {
          this.ir && (this.ir.close(), this.ir = null), this.removeAllListeners();
        }, l.exports = E;
      }, 3616: function(l, v, s) {
        var c = s(3212).v, d = s(5717), p = s(7705), m = s(5088), E = s(6311);
        function y(g, C) {
          var O = this;
          c.call(this);
          var N = function() {
            var w = O.ifr = new m(E.transportName, C, g);
            w.once("message", function(_) {
              if (_) {
                var I;
                try {
                  I = JSON.parse(_);
                } catch {
                  return O.emit("finish"), void O.close();
                }
                var k = I[0], H = I[1];
                O.emit("finish", k, H);
              }
              O.close();
            }), w.once("close", function() {
              O.emit("finish"), O.close();
            });
          };
          s.g.document.body ? N() : p.attachEvent("load", N);
        }
        d(y, c), y.enabled = function() {
          return m.enabled();
        }, y.prototype.close = function() {
          this.ifr && this.ifr.close(), this.removeAllListeners(), this.ifr = null;
        }, l.exports = y;
      }, 5172: function(l, v, s) {
        var c = s(3212).v, d = s(5717), p = s(273), m = s(6073), E = s(9033), y = s(3515), g = s(7103), C = s(3616), O = s(2550);
        function N(w, _) {
          var I = this;
          c.call(this), setTimeout(function() {
            I.doXhr(w, _);
          }, 0);
        }
        d(N, c), N._getReceiver = function(w, _, I) {
          return I.sameOrigin ? new O(_, y) : E.enabled ? new O(_, E) : m.enabled && I.sameScheme ? new O(_, m) : C.enabled() ? new C(w, _) : new O(_, g);
        }, N.prototype.doXhr = function(w, _) {
          var I = this, k = p.addPath(w, "/info");
          this.xo = N._getReceiver(w, k, _), this.timeoutRef = setTimeout(function() {
            I._cleanup(!1), I.emit("finish");
          }, N.timeout), this.xo.once("finish", function(H, S) {
            I._cleanup(!0), I.emit("finish", H, S);
          });
        }, N.prototype._cleanup = function(w) {
          clearTimeout(this.timeoutRef), this.timeoutRef = null, !w && this.xo && this.xo.close(), this.xo = null;
        }, N.prototype.close = function() {
          this.removeAllListeners(), this._cleanup(!1);
        }, N.timeout = 8e3, l.exports = N;
      }, 7486: function(l, v, s) {
        l.exports = s.g.location || { origin: "http://localhost:80", protocol: "http:", host: "localhost", port: 80, href: "http://localhost/", hash: "" };
      }, 3626: function(l, v, s) {
        s(1247);
        var c, d = s(4564), p = s(5717), m = s(8915), E = s(8028), y = s(273), g = s(7705), C = s(5581), O = s(2217), N = s(8510), w = s(4886), _ = s(685), I = s(3184), k = s(7486), H = s(2530), S = s(3326), B = s(5172);
        function D(j, G, U) {
          if (!(this instanceof D)) return new D(j, G, U);
          if (arguments.length < 1) throw new TypeError("Failed to construct 'SockJS: 1 argument required, but only 0 present");
          I.call(this), this.readyState = D.CONNECTING, this.extensions = "", this.protocol = "", (U = U || {}).protocols_whitelist && w.warn("'protocols_whitelist' is DEPRECATED. Use 'transports' instead."), this._transportsWhitelist = U.transports, this._transportOptions = U.transportOptions || {}, this._timeout = U.timeout || 0;
          var M = U.sessionId || 8;
          if (typeof M == "function") this._generateSessionId = M;
          else {
            if (typeof M != "number") throw new TypeError("If sessionId is used in the options, it needs to be a number or a function.");
            this._generateSessionId = function() {
              return m.string(M);
            };
          }
          this._server = U.server || m.numberString(1e3);
          var V = new d(j);
          if (!V.host || !V.protocol) throw new SyntaxError("The URL '" + j + "' is invalid");
          if (V.hash) throw new SyntaxError("The URL must not contain a fragment");
          if (V.protocol !== "http:" && V.protocol !== "https:") throw new SyntaxError("The URL's scheme must be either 'http:' or 'https:'. '" + V.protocol + "' is not allowed.");
          var J = V.protocol === "https:";
          if (k.protocol === "https:" && !J && !y.isLoopbackAddr(V.hostname)) throw new Error("SecurityError: An insecure SockJS connection may not be initiated from a page loaded over HTTPS");
          G ? Array.isArray(G) || (G = [G]) : G = [];
          var ue = G.sort();
          ue.forEach(function(ee, de) {
            if (!ee) throw new SyntaxError("The protocols entry '" + ee + "' is invalid.");
            if (de < ue.length - 1 && ee === ue[de + 1]) throw new SyntaxError("The protocols entry '" + ee + "' is duplicated.");
          });
          var se = y.getOrigin(k.href);
          this._origin = se ? se.toLowerCase() : null, V.set("pathname", V.pathname.replace(/\/+$/, "")), this.url = V.href, this.url, this._urlInfo = { nullOrigin: !N.hasDomain(), sameOrigin: y.isOriginEqual(this.url, k.href), sameScheme: y.isSchemeEqual(this.url, k.href) }, this._ir = new B(this.url, this._urlInfo), this._ir.once("finish", this._receiveInfo.bind(this));
        }
        function F(j) {
          return j === 1e3 || j >= 3e3 && j <= 4999;
        }
        p(D, I), D.prototype.close = function(j, G) {
          if (j && !F(j)) throw new Error("InvalidAccessError: Invalid code");
          if (G && G.length > 123) throw new SyntaxError("reason argument has an invalid length");
          this.readyState !== D.CLOSING && this.readyState !== D.CLOSED && this._close(j || 1e3, G || "Normal closure", !0);
        }, D.prototype.send = function(j) {
          if (typeof j != "string" && (j = "" + j), this.readyState === D.CONNECTING) throw new Error("InvalidStateError: The connection has not been established yet");
          this.readyState === D.OPEN && this._transport.send(E.quote(j));
        }, D.version = s(2828), D.CONNECTING = 0, D.OPEN = 1, D.CLOSING = 2, D.CLOSED = 3, D.prototype._receiveInfo = function(j, G) {
          if (this._ir = null, j) {
            this._rto = this.countRTO(G), this._transUrl = j.base_url ? j.base_url : this.url, j = O.extend(j, this._urlInfo);
            var U = c.filterToEnabled(this._transportsWhitelist, j);
            this._transports = U.main, this._transports.length, this._connect();
          } else this._close(1002, "Cannot connect to server");
        }, D.prototype._connect = function() {
          for (var j = this._transports.shift(); j; j = this._transports.shift()) {
            if (j.transportName, j.needBody && (!s.g.document.body || s.g.document.readyState !== void 0 && s.g.document.readyState !== "complete" && s.g.document.readyState !== "interactive")) return this._transports.unshift(j), void g.attachEvent("load", this._connect.bind(this));
            var G = Math.max(this._timeout, this._rto * j.roundTrips || 5e3);
            this._transportTimeoutId = setTimeout(this._transportTimeout.bind(this), G);
            var U = y.addPath(this._transUrl, "/" + this._server + "/" + this._generateSessionId()), M = this._transportOptions[j.transportName], V = new j(U, this._transUrl, M);
            return V.on("message", this._transportMessage.bind(this)), V.once("close", this._transportClose.bind(this)), V.transportName = j.transportName, void (this._transport = V);
          }
          this._close(2e3, "All transports failed", !1);
        }, D.prototype._transportTimeout = function() {
          this.readyState === D.CONNECTING && (this._transport && this._transport.close(), this._transportClose(2007, "Transport timed out"));
        }, D.prototype._transportMessage = function(j) {
          var G, U = this, M = j.slice(0, 1), V = j.slice(1);
          switch (M) {
            case "o":
              return void this._open();
            case "h":
              return this.dispatchEvent(new _("heartbeat")), void this.transport;
          }
          if (V) try {
            G = JSON.parse(V);
          } catch {
          }
          if (G !== void 0) switch (M) {
            case "a":
              Array.isArray(G) && G.forEach(function(J) {
                U.transport, U.dispatchEvent(new S(J));
              });
              break;
            case "m":
              this.transport, this.dispatchEvent(new S(G));
              break;
            case "c":
              Array.isArray(G) && G.length === 2 && this._close(G[0], G[1], !0);
          }
        }, D.prototype._transportClose = function(j, G) {
          this.transport, this._transport && (this._transport.removeAllListeners(), this._transport = null, this.transport = null), F(j) || j === 2e3 || this.readyState !== D.CONNECTING ? this._close(j, G) : this._connect();
        }, D.prototype._open = function() {
          this._transport && this._transport.transportName, this.readyState, this.readyState === D.CONNECTING ? (this._transportTimeoutId && (clearTimeout(this._transportTimeoutId), this._transportTimeoutId = null), this.readyState = D.OPEN, this.transport = this._transport.transportName, this.dispatchEvent(new _("open")), this.transport) : this._close(1006, "Server lost session");
        }, D.prototype._close = function(j, G, U) {
          this.transport, this.readyState;
          var M = !1;
          if (this._ir && (M = !0, this._ir.close(), this._ir = null), this._transport && (this._transport.close(), this._transport = null, this.transport = null), this.readyState === D.CLOSED) throw new Error("InvalidStateError: SockJS has already been closed");
          this.readyState = D.CLOSING, setTimeout((function() {
            this.readyState = D.CLOSED, M && this.dispatchEvent(new _("error"));
            var V = new H("close");
            V.wasClean = U || !1, V.code = j || 1e3, V.reason = G, this.dispatchEvent(V), this.onmessage = this.onclose = this.onerror = null;
          }).bind(this), 0);
        }, D.prototype.countRTO = function(j) {
          return j > 100 ? 4 * j : 300 + j;
        }, l.exports = function(j) {
          return c = C(j), s(551)(D, j), D;
        };
      }, 1247: function() {
        var l, v = Array.prototype, s = Object.prototype, c = Function.prototype, d = String.prototype, p = v.slice, m = s.toString, E = function(j) {
          return s.toString.call(j) === "[object Function]";
        }, y = function(j) {
          return m.call(j) === "[object String]";
        }, g = Object.defineProperty && function() {
          try {
            return Object.defineProperty({}, "x", {}), !0;
          } catch {
            return !1;
          }
        }();
        l = g ? function(j, G, U, M) {
          !M && G in j || Object.defineProperty(j, G, { configurable: !0, enumerable: !1, writable: !0, value: U });
        } : function(j, G, U, M) {
          !M && G in j || (j[G] = U);
        };
        var C = function(j, G, U) {
          for (var M in G) s.hasOwnProperty.call(G, M) && l(j, M, G[M], U);
        }, O = function(j) {
          if (j == null) throw new TypeError("can't convert " + j + " to object");
          return Object(j);
        };
        function N() {
        }
        C(c, { bind: function(j) {
          var G = this;
          if (!E(G)) throw new TypeError("Function.prototype.bind called on incompatible " + G);
          for (var U = p.call(arguments, 1), M = Math.max(0, G.length - U.length), V = [], J = 0; J < M; J++) V.push("$" + J);
          var ue = Function("binder", "return function (" + V.join(",") + "){ return binder.apply(this, arguments); }")(function() {
            if (this instanceof ue) {
              var se = G.apply(this, U.concat(p.call(arguments)));
              return Object(se) === se ? se : this;
            }
            return G.apply(j, U.concat(p.call(arguments)));
          });
          return G.prototype && (N.prototype = G.prototype, ue.prototype = new N(), N.prototype = null), ue;
        } }), C(Array, { isArray: function(j) {
          return m.call(j) === "[object Array]";
        } });
        var w, _, I, k = Object("a"), H = k[0] !== "a" || !(0 in k);
        C(v, { forEach: function(j) {
          var G = O(this), U = H && y(this) ? this.split("") : G, M = arguments[1], V = -1, J = U.length >>> 0;
          if (!E(j)) throw new TypeError();
          for (; ++V < J; ) V in U && j.call(M, U[V], V, G);
        } }, (w = v.forEach, _ = !0, I = !0, w && (w.call("foo", function(j, G, U) {
          typeof U != "object" && (_ = !1);
        }), w.call([1], function() {
          I = typeof this == "string";
        }, "x")), !(w && _ && I)));
        var S = Array.prototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
        C(v, { indexOf: function(j) {
          var G = H && y(this) ? this.split("") : O(this), U = G.length >>> 0;
          if (!U) return -1;
          var M, V = 0;
          for (arguments.length > 1 && ((M = +arguments[1]) != M ? M = 0 : M !== 0 && M !== 1 / 0 && M !== -1 / 0 && (M = (M > 0 || -1) * Math.floor(Math.abs(M))), V = M), V = V >= 0 ? V : Math.max(0, U + V); V < U; V++) if (V in G && G[V] === j) return V;
          return -1;
        } }, S);
        var B, D = d.split;
        "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || "tesst".split(/(s)*/)[1] === "t" || "test".split(/(?:)/, -1).length !== 4 || "".split(/.?/).length || ".".split(/()()/).length > 1 ? (B = /()??/.exec("")[1] === void 0, d.split = function(j, G) {
          var U = this;
          if (j === void 0 && G === 0) return [];
          if (m.call(j) !== "[object RegExp]") return D.call(this, j, G);
          var M, V, J, ue, se = [], ee = (j.ignoreCase ? "i" : "") + (j.multiline ? "m" : "") + (j.extended ? "x" : "") + (j.sticky ? "y" : ""), de = 0;
          for (j = new RegExp(j.source, ee + "g"), U += "", B || (M = new RegExp("^" + j.source + "$(?!\\s)", ee)), G = G === void 0 ? 4294967295 : G >>> 0; (V = j.exec(U)) && !((J = V.index + V[0].length) > de && (se.push(U.slice(de, V.index)), !B && V.length > 1 && V[0].replace(M, function() {
            for (var he = 1; he < arguments.length - 2; he++) arguments[he] === void 0 && (V[he] = void 0);
          }), V.length > 1 && V.index < U.length && v.push.apply(se, V.slice(1)), ue = V[0].length, de = J, se.length >= G)); ) j.lastIndex === V.index && j.lastIndex++;
          return de === U.length ? !ue && j.test("") || se.push("") : se.push(U.slice(de)), se.length > G ? se.slice(0, G) : se;
        }) : "0".split(void 0, 0).length && (d.split = function(j, G) {
          return j === void 0 && G === 0 ? [] : D.call(this, j, G);
        });
        var F = d.substr;
        C(d, { substr: function(j, G) {
          return F.call(this, j < 0 && (j = this.length + j) < 0 ? 0 : j, G);
        } }, "".substr && "0b".substr(-1) !== "b");
      }, 7581: function(l, v, s) {
        l.exports = [s(2412), s(9842), s(4620), s(3004), s(882)(s(3004)), s(5616), s(882)(s(5616)), s(2387), s(9998), s(882)(s(2387)), s(5375)];
      }, 2940: function(l, v, s) {
        var c = s(3212).v, d = s(5717), p = s(7705), m = s(273), E = s.g.XMLHttpRequest;
        function y(O, N, w, _) {
          var I = this;
          c.call(this), setTimeout(function() {
            I._start(O, N, w, _);
          }, 0);
        }
        d(y, c), y.prototype._start = function(O, N, w, _) {
          var I = this;
          try {
            this.xhr = new E();
          } catch {
          }
          if (!this.xhr) return this.emit("finish", 0, "no xhr support"), void this._cleanup();
          N = m.addQuery(N, "t=" + +/* @__PURE__ */ new Date()), this.unloadRef = p.unloadAdd(function() {
            I._cleanup(!0);
          });
          try {
            this.xhr.open(O, N, !0), this.timeout && "timeout" in this.xhr && (this.xhr.timeout = this.timeout, this.xhr.ontimeout = function() {
              I.emit("finish", 0, ""), I._cleanup(!1);
            });
          } catch {
            return this.emit("finish", 0, ""), void this._cleanup(!1);
          }
          if (_ && _.noCredentials || !y.supportsCORS || (this.xhr.withCredentials = !0), _ && _.headers) for (var k in _.headers) this.xhr.setRequestHeader(k, _.headers[k]);
          this.xhr.onreadystatechange = function() {
            if (I.xhr) {
              var H, S, B = I.xhr;
              switch (B.readyState, B.readyState) {
                case 3:
                  try {
                    S = B.status, H = B.responseText;
                  } catch {
                  }
                  S === 1223 && (S = 204), S === 200 && H && H.length > 0 && I.emit("chunk", S, H);
                  break;
                case 4:
                  (S = B.status) === 1223 && (S = 204), S !== 12005 && S !== 12029 || (S = 0), B.responseText, I.emit("finish", S, B.responseText), I._cleanup(!1);
              }
            }
          };
          try {
            I.xhr.send(w);
          } catch {
            I.emit("finish", 0, ""), I._cleanup(!1);
          }
        }, y.prototype._cleanup = function(O) {
          if (this.xhr) {
            if (this.removeAllListeners(), p.unloadDel(this.unloadRef), this.xhr.onreadystatechange = function() {
            }, this.xhr.ontimeout && (this.xhr.ontimeout = null), O) try {
              this.xhr.abort();
            } catch {
            }
            this.unloadRef = this.xhr = null;
          }
        }, y.prototype.close = function() {
          this._cleanup(!0);
        }, y.enabled = !!E;
        var g = ["Active"].concat("Object").join("X");
        !y.enabled && g in s.g && (E = function() {
          try {
            return new s.g[g]("Microsoft.XMLHTTP");
          } catch {
            return null;
          }
        }, y.enabled = !!new E());
        var C = !1;
        try {
          C = "withCredentials" in new E();
        } catch {
        }
        y.supportsCORS = C, l.exports = y;
      }, 3759: function(l, v, s) {
        l.exports = s.g.EventSource;
      }, 9334: function(l, v, s) {
        var c = s.g.WebSocket || s.g.MozWebSocket;
        l.exports = c ? function(d) {
          return new c(d);
        } : void 0;
      }, 3004: function(l, v, s) {
        var c = s(5717), d = s(9395), p = s(6709), m = s(9033), E = s(3759);
        function y(g) {
          if (!y.enabled()) throw new Error("Transport created when disabled");
          d.call(this, g, "/eventsource", p, m);
        }
        c(y, d), y.enabled = function() {
          return !!E;
        }, y.transportName = "eventsource", y.roundTrips = 2, l.exports = y;
      }, 5616: function(l, v, s) {
        var c = s(5717), d = s(3608), p = s(3515), m = s(9395);
        function E(y) {
          if (!d.enabled) throw new Error("Transport created when disabled");
          m.call(this, y, "/htmlfile", d, p);
        }
        c(E, m), E.enabled = function(y) {
          return d.enabled && y.sameOrigin;
        }, E.transportName = "htmlfile", E.roundTrips = 2, l.exports = E;
      }, 5088: function(l, v, s) {
        var c = s(5717), d = s(3212).v, p = s(2828), m = s(273), E = s(3683), y = s(7705), g = s(8915);
        function C(O, N, w) {
          if (!C.enabled()) throw new Error("Transport created when disabled");
          d.call(this);
          var _ = this;
          this.origin = m.getOrigin(w), this.baseUrl = w, this.transUrl = N, this.transport = O, this.windowId = g.string(8);
          var I = m.addPath(w, "/iframe.html") + "#" + this.windowId;
          this.iframeObj = E.createIframe(I, function(k) {
            _.emit("close", 1006, "Unable to load an iframe (" + k + ")"), _.close();
          }), this.onmessageCallback = this._message.bind(this), y.attachEvent("message", this.onmessageCallback);
        }
        c(C, d), C.prototype.close = function() {
          if (this.removeAllListeners(), this.iframeObj) {
            y.detachEvent("message", this.onmessageCallback);
            try {
              this.postMessage("c");
            } catch {
            }
            this.iframeObj.cleanup(), this.iframeObj = null, this.onmessageCallback = this.iframeObj = null;
          }
        }, C.prototype._message = function(O) {
          if (O.data, !m.isOriginEqual(O.origin, this.origin)) return O.origin, void this.origin;
          var N;
          try {
            N = JSON.parse(O.data);
          } catch {
            return void O.data;
          }
          if (N.windowId !== this.windowId) return N.windowId, void this.windowId;
          switch (N.type) {
            case "s":
              this.iframeObj.loaded(), this.postMessage("s", JSON.stringify([p, this.transport, this.transUrl, this.baseUrl]));
              break;
            case "t":
              this.emit("message", N.data);
              break;
            case "c":
              var w;
              try {
                w = JSON.parse(N.data);
              } catch {
                return void N.data;
              }
              this.emit("close", w[0], w[1]), this.close();
          }
        }, C.prototype.postMessage = function(O, N) {
          this.iframeObj.post(JSON.stringify({ windowId: this.windowId, type: O, data: N || "" }), this.origin);
        }, C.prototype.send = function(O) {
          this.postMessage("m", O);
        }, C.enabled = function() {
          return E.iframeEnabled;
        }, C.transportName = "iframe", C.roundTrips = 2, l.exports = C;
      }, 5375: function(l, v, s) {
        var c = s(5717), d = s(8347), p = s(514), m = s(771);
        function E(y) {
          if (!E.enabled()) throw new Error("Transport created when disabled");
          d.call(this, y, "/jsonp", m, p);
        }
        c(E, d), E.enabled = function() {
          return !!s.g.document;
        }, E.transportName = "jsonp-polling", E.roundTrips = 1, E.needBody = !0, l.exports = E;
      }, 9395: function(l, v, s) {
        var c = s(5717), d = s(273), p = s(8347);
        function m(E, y, g, C) {
          p.call(this, E, y, /* @__PURE__ */ function(O) {
            return function(N, w, _) {
              var I = {};
              typeof w == "string" && (I.headers = { "Content-type": "text/plain" });
              var k = d.addPath(N, "/xhr_send"), H = new O("POST", k, w, I);
              return H.once("finish", function(S) {
                if (H = null, S !== 200 && S !== 204) return _(new Error("http status " + S));
                _();
              }), function() {
                H.close(), H = null;
                var S = new Error("Aborted");
                S.code = 1e3, _(S);
              };
            };
          }(C), g, C);
        }
        c(m, p), l.exports = m;
      }, 1851: function(l, v, s) {
        var c = s(5717), d = s(3212).v;
        function p(m, E) {
          d.call(this), this.sendBuffer = [], this.sender = E, this.url = m;
        }
        c(p, d), p.prototype.send = function(m) {
          this.sendBuffer.push(m), this.sendStop || this.sendSchedule();
        }, p.prototype.sendScheduleWait = function() {
          var m, E = this;
          this.sendStop = function() {
            E.sendStop = null, clearTimeout(m);
          }, m = setTimeout(function() {
            E.sendStop = null, E.sendSchedule();
          }, 25);
        }, p.prototype.sendSchedule = function() {
          this.sendBuffer.length;
          var m = this;
          if (this.sendBuffer.length > 0) {
            var E = "[" + this.sendBuffer.join(",") + "]";
            this.sendStop = this.sender(this.url, E, function(y) {
              m.sendStop = null, y ? (m.emit("close", y.code || 1006, "Sending error: " + y), m.close()) : m.sendScheduleWait();
            }), this.sendBuffer = [];
          }
        }, p.prototype._cleanup = function() {
          this.removeAllListeners();
        }, p.prototype.close = function() {
          this._cleanup(), this.sendStop && (this.sendStop(), this.sendStop = null);
        }, l.exports = p;
      }, 882: function(l, v, s) {
        var c = s(5717), d = s(5088), p = s(2217);
        l.exports = function(m) {
          function E(y, g) {
            d.call(this, m.transportName, y, g);
          }
          return c(E, d), E.enabled = function(y, g) {
            if (!s.g.document) return !1;
            var C = p.extend({}, g);
            return C.sameOrigin = !0, m.enabled(C) && d.enabled();
          }, E.transportName = "iframe-" + m.transportName, E.needBody = !0, E.roundTrips = d.roundTrips + m.roundTrips - 1, E.facadeTransport = m, E;
        };
      }, 1265: function(l, v, s) {
        var c = s(5717), d = s(3212).v;
        function p(m, E, y) {
          d.call(this), this.Receiver = m, this.receiveUrl = E, this.AjaxObject = y, this._scheduleReceiver();
        }
        c(p, d), p.prototype._scheduleReceiver = function() {
          var m = this, E = this.poll = new this.Receiver(this.receiveUrl, this.AjaxObject);
          E.on("message", function(y) {
            m.emit("message", y);
          }), E.once("close", function(y, g) {
            m.pollIsClosing, m.poll = E = null, m.pollIsClosing || (g === "network" ? m._scheduleReceiver() : (m.emit("close", y || 1006, g), m.removeAllListeners()));
          });
        }, p.prototype.abort = function() {
          this.removeAllListeners(), this.pollIsClosing = !0, this.poll && this.poll.abort();
        }, l.exports = p;
      }, 8347: function(l, v, s) {
        var c = s(5717), d = s(273), p = s(1851), m = s(1265);
        function E(y, g, C, O, N) {
          var w = d.addPath(y, g), _ = this;
          p.call(this, y, C), this.poll = new m(O, w, N), this.poll.on("message", function(I) {
            _.emit("message", I);
          }), this.poll.once("close", function(I, k) {
            _.poll = null, _.emit("close", I, k), _.close();
          });
        }
        c(E, p), E.prototype.close = function() {
          p.prototype.close.call(this), this.removeAllListeners(), this.poll && (this.poll.abort(), this.poll = null);
        }, l.exports = E;
      }, 6709: function(l, v, s) {
        var c = s(5717), d = s(3212).v, p = s(3759);
        function m(E) {
          d.call(this);
          var y = this, g = this.es = new p(E);
          g.onmessage = function(C) {
            C.data, y.emit("message", decodeURI(C.data));
          }, g.onerror = function(C) {
            g.readyState;
            var O = g.readyState !== 2 ? "network" : "permanent";
            y._cleanup(), y._close(O);
          };
        }
        c(m, d), m.prototype.abort = function() {
          this._cleanup(), this._close("user");
        }, m.prototype._cleanup = function() {
          var E = this.es;
          E && (E.onmessage = E.onerror = null, E.close(), this.es = null);
        }, m.prototype._close = function(E) {
          var y = this;
          setTimeout(function() {
            y.emit("close", null, E), y.removeAllListeners();
          }, 200);
        }, l.exports = m;
      }, 3608: function(l, v, s) {
        var c = s(5717), d = s(3683), p = s(273), m = s(3212).v, E = s(8915);
        function y(C) {
          m.call(this);
          var O = this;
          d.polluteGlobalNamespace(), this.id = "a" + E.string(6), C = p.addQuery(C, "c=" + decodeURIComponent(d.WPrefix + "." + this.id)), y.htmlfileEnabled;
          var N = y.htmlfileEnabled ? d.createHtmlfile : d.createIframe;
          s.g[d.WPrefix][this.id] = { start: function() {
            O.iframeObj.loaded();
          }, message: function(w) {
            O.emit("message", w);
          }, stop: function() {
            O._cleanup(), O._close("network");
          } }, this.iframeObj = N(C, function() {
            O._cleanup(), O._close("permanent");
          });
        }
        c(y, m), y.prototype.abort = function() {
          this._cleanup(), this._close("user");
        }, y.prototype._cleanup = function() {
          this.iframeObj && (this.iframeObj.cleanup(), this.iframeObj = null), delete s.g[d.WPrefix][this.id];
        }, y.prototype._close = function(C) {
          this.emit("close", null, C), this.removeAllListeners();
        }, y.htmlfileEnabled = !1;
        var g = ["Active"].concat("Object").join("X");
        if (g in s.g) try {
          y.htmlfileEnabled = !!new s.g[g]("htmlfile");
        } catch {
        }
        y.enabled = y.htmlfileEnabled || d.iframeEnabled, l.exports = y;
      }, 514: function(l, v, s) {
        var c = s(3683), d = s(8915), p = s(8510), m = s(273), E = s(5717), y = s(3212).v;
        function g(C) {
          var O = this;
          y.call(this), c.polluteGlobalNamespace(), this.id = "a" + d.string(6);
          var N = m.addQuery(C, "c=" + encodeURIComponent(c.WPrefix + "." + this.id));
          s.g[c.WPrefix][this.id] = this._callback.bind(this), this._createScript(N), this.timeoutId = setTimeout(function() {
            O._abort(new Error("JSONP script loaded abnormally (timeout)"));
          }, g.timeout);
        }
        E(g, y), g.prototype.abort = function() {
          if (s.g[c.WPrefix][this.id]) {
            var C = new Error("JSONP user aborted read");
            C.code = 1e3, this._abort(C);
          }
        }, g.timeout = 35e3, g.scriptErrorTimeout = 1e3, g.prototype._callback = function(C) {
          this._cleanup(), this.aborting || (C && this.emit("message", C), this.emit("close", null, "network"), this.removeAllListeners());
        }, g.prototype._abort = function(C) {
          this._cleanup(), this.aborting = !0, this.emit("close", C.code, C.message), this.removeAllListeners();
        }, g.prototype._cleanup = function() {
          if (clearTimeout(this.timeoutId), this.script2 && (this.script2.parentNode.removeChild(this.script2), this.script2 = null), this.script) {
            var C = this.script;
            C.parentNode.removeChild(C), C.onreadystatechange = C.onerror = C.onload = C.onclick = null, this.script = null;
          }
          delete s.g[c.WPrefix][this.id];
        }, g.prototype._scriptError = function() {
          var C = this;
          this.errorTimer || (this.errorTimer = setTimeout(function() {
            C.loadedOkay || C._abort(new Error("JSONP script loaded abnormally (onerror)"));
          }, g.scriptErrorTimeout));
        }, g.prototype._createScript = function(C) {
          var O, N = this, w = this.script = s.g.document.createElement("script");
          if (w.id = "a" + d.string(8), w.src = C, w.type = "text/javascript", w.charset = "UTF-8", w.onerror = this._scriptError.bind(this), w.onload = function() {
            N._abort(new Error("JSONP script loaded abnormally (onload)"));
          }, w.onreadystatechange = function() {
            if (w.readyState, /loaded|closed/.test(w.readyState)) {
              if (w && w.htmlFor && w.onclick) {
                N.loadedOkay = !0;
                try {
                  w.onclick();
                } catch {
                }
              }
              w && N._abort(new Error("JSONP script loaded abnormally (onreadystatechange)"));
            }
          }, w.async === void 0 && s.g.document.attachEvent) if (p.isOpera()) (O = this.script2 = s.g.document.createElement("script")).text = "try{var a = document.getElementById('" + w.id + "'); if(a)a.onerror();}catch(x){};", w.async = O.async = !1;
          else {
            try {
              w.htmlFor = w.id, w.event = "onclick";
            } catch {
            }
            w.async = !0;
          }
          w.async !== void 0 && (w.async = !0);
          var _ = s.g.document.getElementsByTagName("head")[0];
          _.insertBefore(w, _.firstChild), O && _.insertBefore(O, _.firstChild);
        }, l.exports = g;
      }, 1044: function(l, v, s) {
        var c = s(5717), d = s(3212).v;
        function p(m, E) {
          d.call(this);
          var y = this;
          this.bufferPosition = 0, this.xo = new E("POST", m, null), this.xo.on("chunk", this._chunkHandler.bind(this)), this.xo.once("finish", function(g, C) {
            y._chunkHandler(g, C), y.xo = null;
            var O = g === 200 ? "network" : "permanent";
            y.emit("close", null, O), y._cleanup();
          });
        }
        c(p, d), p.prototype._chunkHandler = function(m, E) {
          if (m === 200 && E) for (var y = -1; ; this.bufferPosition += y + 1) {
            var g = E.slice(this.bufferPosition);
            if ((y = g.indexOf(`
`)) === -1) break;
            var C = g.slice(0, y);
            C && this.emit("message", C);
          }
        }, p.prototype._cleanup = function() {
          this.removeAllListeners();
        }, p.prototype.abort = function() {
          this.xo && (this.xo.close(), this.emit("close", null, "user"), this.xo = null), this._cleanup();
        }, l.exports = p;
      }, 771: function(l, v, s) {
        var c, d, p = s(8915), m = s(273);
        l.exports = function(E, y, g) {
          c || ((c = s.g.document.createElement("form")).style.display = "none", c.style.position = "absolute", c.method = "POST", c.enctype = "application/x-www-form-urlencoded", c.acceptCharset = "UTF-8", (d = s.g.document.createElement("textarea")).name = "d", c.appendChild(d), s.g.document.body.appendChild(c));
          var C = "a" + p.string(8);
          c.target = C, c.action = m.addQuery(m.addPath(E, "/jsonp_send"), "i=" + C);
          var O = function(w) {
            try {
              return s.g.document.createElement('<iframe name="' + w + '">');
            } catch {
              var _ = s.g.document.createElement("iframe");
              return _.name = w, _;
            }
          }(C);
          O.id = C, O.style.display = "none", c.appendChild(O);
          try {
            d.value = y;
          } catch {
          }
          c.submit();
          var N = function(w) {
            O.onerror && (O.onreadystatechange = O.onerror = O.onload = null, setTimeout(function() {
              O.parentNode.removeChild(O), O = null;
            }, 500), d.value = "", g(w));
          };
          return O.onerror = function() {
            N();
          }, O.onload = function() {
            N();
          }, O.onreadystatechange = function(w) {
            O.readyState, O.readyState === "complete" && N();
          }, function() {
            N(new Error("Aborted"));
          };
        };
      }, 6073: function(l, v, s) {
        var c = s(3212).v, d = s(5717), p = s(7705), m = s(8510), E = s(273);
        function y(g, C, O) {
          var N = this;
          c.call(this), setTimeout(function() {
            N._start(g, C, O);
          }, 0);
        }
        d(y, c), y.prototype._start = function(g, C, O) {
          var N = this, w = new s.g.XDomainRequest();
          C = E.addQuery(C, "t=" + +/* @__PURE__ */ new Date()), w.onerror = function() {
            N._error();
          }, w.ontimeout = function() {
            N._error();
          }, w.onprogress = function() {
            w.responseText, N.emit("chunk", 200, w.responseText);
          }, w.onload = function() {
            N.emit("finish", 200, w.responseText), N._cleanup(!1);
          }, this.xdr = w, this.unloadRef = p.unloadAdd(function() {
            N._cleanup(!0);
          });
          try {
            this.xdr.open(g, C), this.timeout && (this.xdr.timeout = this.timeout), this.xdr.send(O);
          } catch {
            this._error();
          }
        }, y.prototype._error = function() {
          this.emit("finish", 0, ""), this._cleanup(!1);
        }, y.prototype._cleanup = function(g) {
          if (this.xdr) {
            if (this.removeAllListeners(), p.unloadDel(this.unloadRef), this.xdr.ontimeout = this.xdr.onerror = this.xdr.onprogress = this.xdr.onload = null, g) try {
              this.xdr.abort();
            } catch {
            }
            this.unloadRef = this.xdr = null;
          }
        }, y.prototype.close = function() {
          this._cleanup(!0);
        }, y.enabled = !(!s.g.XDomainRequest || !m.hasDomain()), l.exports = y;
      }, 9033: function(l, v, s) {
        var c = s(5717), d = s(2940);
        function p(m, E, y, g) {
          d.call(this, m, E, y, g);
        }
        c(p, d), p.enabled = d.enabled && d.supportsCORS, l.exports = p;
      }, 7103: function(l, v, s) {
        var c = s(3212).v;
        function d() {
          var p = this;
          c.call(this), this.to = setTimeout(function() {
            p.emit("finish", 200, "{}");
          }, d.timeout);
        }
        s(5717)(d, c), d.prototype.close = function() {
          clearTimeout(this.to);
        }, d.timeout = 2e3, l.exports = d;
      }, 3515: function(l, v, s) {
        var c = s(5717), d = s(2940);
        function p(m, E, y) {
          d.call(this, m, E, y, { noCredentials: !0 });
        }
        c(p, d), p.enabled = d.enabled, l.exports = p;
      }, 2412: function(l, v, s) {
        var c = s(7705), d = s(273), p = s(5717), m = s(3212).v, E = s(9334);
        function y(g, C, O) {
          if (!y.enabled()) throw new Error("Transport created when disabled");
          m.call(this);
          var N = this, w = d.addPath(g, "/websocket");
          w = w.slice(0, 5) === "https" ? "wss" + w.slice(5) : "ws" + w.slice(4), this.url = w, this.ws = new E(this.url, [], O), this.ws.onmessage = function(_) {
            _.data, N.emit("message", _.data);
          }, this.unloadRef = c.unloadAdd(function() {
            N.ws.close();
          }), this.ws.onclose = function(_) {
            _.code, _.reason, N.emit("close", _.code, _.reason), N._cleanup();
          }, this.ws.onerror = function(_) {
            N.emit("close", 1006, "WebSocket connection broken"), N._cleanup();
          };
        }
        p(y, m), y.prototype.send = function(g) {
          var C = "[" + g + "]";
          this.ws.send(C);
        }, y.prototype.close = function() {
          var g = this.ws;
          this._cleanup(), g && g.close();
        }, y.prototype._cleanup = function() {
          var g = this.ws;
          g && (g.onmessage = g.onclose = g.onerror = null), c.unloadDel(this.unloadRef), this.unloadRef = this.ws = null, this.removeAllListeners();
        }, y.enabled = function() {
          return !!E;
        }, y.transportName = "websocket", y.roundTrips = 2, l.exports = y;
      }, 9998: function(l, v, s) {
        var c = s(5717), d = s(9395), p = s(4620), m = s(1044), E = s(6073);
        function y(g) {
          if (!E.enabled) throw new Error("Transport created when disabled");
          d.call(this, g, "/xhr", m, E);
        }
        c(y, d), y.enabled = p.enabled, y.transportName = "xdr-polling", y.roundTrips = 2, l.exports = y;
      }, 4620: function(l, v, s) {
        var c = s(5717), d = s(9395), p = s(1044), m = s(6073);
        function E(y) {
          if (!m.enabled) throw new Error("Transport created when disabled");
          d.call(this, y, "/xhr_streaming", p, m);
        }
        c(E, d), E.enabled = function(y) {
          return !y.cookie_needed && !y.nullOrigin && m.enabled && y.sameScheme;
        }, E.transportName = "xdr-streaming", E.roundTrips = 2, l.exports = E;
      }, 2387: function(l, v, s) {
        var c = s(5717), d = s(9395), p = s(1044), m = s(9033), E = s(3515);
        function y(g) {
          if (!E.enabled && !m.enabled) throw new Error("Transport created when disabled");
          d.call(this, g, "/xhr", p, m);
        }
        c(y, d), y.enabled = function(g) {
          return !g.nullOrigin && (!(!E.enabled || !g.sameOrigin) || m.enabled);
        }, y.transportName = "xhr-polling", y.roundTrips = 2, l.exports = y;
      }, 9842: function(l, v, s) {
        var c = s(5717), d = s(9395), p = s(1044), m = s(9033), E = s(3515), y = s(8510);
        function g(C) {
          if (!E.enabled && !m.enabled) throw new Error("Transport created when disabled");
          d.call(this, C, "/xhr_streaming", p, m);
        }
        c(g, d), g.enabled = function(C) {
          return !C.nullOrigin && !y.isOpera() && m.enabled;
        }, g.transportName = "xhr-streaming", g.roundTrips = 2, g.needBody = !!s.g.document, l.exports = g;
      }, 2017: function(l, v, s) {
        s.g.crypto && s.g.crypto.getRandomValues ? l.exports.randomBytes = function(c) {
          var d = new Uint8Array(c);
          return s.g.crypto.getRandomValues(d), d;
        } : l.exports.randomBytes = function(c) {
          for (var d = new Array(c), p = 0; p < c; p++) d[p] = Math.floor(256 * Math.random());
          return d;
        };
      }, 8510: function(l, v, s) {
        l.exports = { isOpera: function() {
          return s.g.navigator && /opera/i.test(s.g.navigator.userAgent);
        }, isKonqueror: function() {
          return s.g.navigator && /konqueror/i.test(s.g.navigator.userAgent);
        }, hasDomain: function() {
          if (!s.g.document) return !0;
          try {
            return !!s.g.document.domain;
          } catch {
            return !1;
          }
        } };
      }, 8028: function(l) {
        var v, s = /[\x00-\x1f\ud800-\udfff\ufffe\uffff\u0300-\u0333\u033d-\u0346\u034a-\u034c\u0350-\u0352\u0357-\u0358\u035c-\u0362\u0374\u037e\u0387\u0591-\u05af\u05c4\u0610-\u0617\u0653-\u0654\u0657-\u065b\u065d-\u065e\u06df-\u06e2\u06eb-\u06ec\u0730\u0732-\u0733\u0735-\u0736\u073a\u073d\u073f-\u0741\u0743\u0745\u0747\u07eb-\u07f1\u0951\u0958-\u095f\u09dc-\u09dd\u09df\u0a33\u0a36\u0a59-\u0a5b\u0a5e\u0b5c-\u0b5d\u0e38-\u0e39\u0f43\u0f4d\u0f52\u0f57\u0f5c\u0f69\u0f72-\u0f76\u0f78\u0f80-\u0f83\u0f93\u0f9d\u0fa2\u0fa7\u0fac\u0fb9\u1939-\u193a\u1a17\u1b6b\u1cda-\u1cdb\u1dc0-\u1dcf\u1dfc\u1dfe\u1f71\u1f73\u1f75\u1f77\u1f79\u1f7b\u1f7d\u1fbb\u1fbe\u1fc9\u1fcb\u1fd3\u1fdb\u1fe3\u1feb\u1fee-\u1fef\u1ff9\u1ffb\u1ffd\u2000-\u2001\u20d0-\u20d1\u20d4-\u20d7\u20e7-\u20e9\u2126\u212a-\u212b\u2329-\u232a\u2adc\u302b-\u302c\uaab2-\uaab3\uf900-\ufa0d\ufa10\ufa12\ufa15-\ufa1e\ufa20\ufa22\ufa25-\ufa26\ufa2a-\ufa2d\ufa30-\ufa6d\ufa70-\ufad9\ufb1d\ufb1f\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufb4e\ufff0-\uffff]/g;
        l.exports = { quote: function(c) {
          var d = JSON.stringify(c);
          return s.lastIndex = 0, s.test(d) ? (v || (v = function(p) {
            var m, E = {}, y = [];
            for (m = 0; m < 65536; m++) y.push(String.fromCharCode(m));
            return p.lastIndex = 0, y.join("").replace(p, function(g) {
              return E[g] = "\\u" + ("0000" + g.charCodeAt(0).toString(16)).slice(-4), "";
            }), p.lastIndex = 0, E;
          }(s)), d.replace(s, function(p) {
            return v[p];
          })) : d;
        } };
      }, 7705: function(l, v, s) {
        var c = s(8915), d = {}, p = !1, m = s.g.chrome && s.g.chrome.app && s.g.chrome.app.runtime;
        l.exports = { attachEvent: function(E, y) {
          s.g.addEventListener !== void 0 ? s.g.addEventListener(E, y, !1) : s.g.document && s.g.attachEvent && (s.g.document.attachEvent("on" + E, y), s.g.attachEvent("on" + E, y));
        }, detachEvent: function(E, y) {
          s.g.addEventListener !== void 0 ? s.g.removeEventListener(E, y, !1) : s.g.document && s.g.detachEvent && (s.g.document.detachEvent("on" + E, y), s.g.detachEvent("on" + E, y));
        }, unloadAdd: function(E) {
          if (m) return null;
          var y = c.string(8);
          return d[y] = E, p && setTimeout(this.triggerUnloadCallbacks, 0), y;
        }, unloadDel: function(E) {
          E in d && delete d[E];
        }, triggerUnloadCallbacks: function() {
          for (var E in d) d[E](), delete d[E];
        } }, m || l.exports.attachEvent("unload", function() {
          p || (p = !0, l.exports.triggerUnloadCallbacks());
        });
      }, 3683: function(l, v, s) {
        var c = s(7705), d = s(8510);
        l.exports = { WPrefix: "_jp", currentWindowId: null, polluteGlobalNamespace: function() {
          l.exports.WPrefix in s.g || (s.g[l.exports.WPrefix] = {});
        }, postMessage: function(p, m) {
          s.g.parent !== s.g && s.g.parent.postMessage(JSON.stringify({ windowId: l.exports.currentWindowId, type: p, data: m || "" }), "*");
        }, createIframe: function(p, m) {
          var E, y, g = s.g.document.createElement("iframe"), C = function() {
            clearTimeout(E);
            try {
              g.onload = null;
            } catch {
            }
            g.onerror = null;
          }, O = function() {
            g && (C(), setTimeout(function() {
              g && g.parentNode.removeChild(g), g = null;
            }, 0), c.unloadDel(y));
          }, N = function(w) {
            g && (O(), m(w));
          };
          return g.src = p, g.style.display = "none", g.style.position = "absolute", g.onerror = function() {
            N("onerror");
          }, g.onload = function() {
            clearTimeout(E), E = setTimeout(function() {
              N("onload timeout");
            }, 2e3);
          }, s.g.document.body.appendChild(g), E = setTimeout(function() {
            N("timeout");
          }, 15e3), y = c.unloadAdd(O), { post: function(w, _) {
            setTimeout(function() {
              try {
                g && g.contentWindow && g.contentWindow.postMessage(w, _);
              } catch {
              }
            }, 0);
          }, cleanup: O, loaded: C };
        }, createHtmlfile: function(p, m) {
          var E, y, g, C = ["Active"].concat("Object").join("X"), O = new s.g[C]("htmlfile"), N = function() {
            clearTimeout(E), g.onerror = null;
          }, w = function() {
            O && (N(), c.unloadDel(y), g.parentNode.removeChild(g), g = O = null, CollectGarbage());
          }, _ = function(k) {
            O && (w(), m(k));
          };
          O.open(), O.write('<html><script>document.domain="' + s.g.document.domain + '";<\/script></html>'), O.close(), O.parentWindow[l.exports.WPrefix] = s.g[l.exports.WPrefix];
          var I = O.createElement("div");
          return O.body.appendChild(I), g = O.createElement("iframe"), I.appendChild(g), g.src = p, g.onerror = function() {
            _("onerror");
          }, E = setTimeout(function() {
            _("timeout");
          }, 15e3), y = c.unloadAdd(w), { post: function(k, H) {
            try {
              setTimeout(function() {
                g && g.contentWindow && g.contentWindow.postMessage(k, H);
              }, 0);
            } catch {
            }
          }, cleanup: w, loaded: N };
        } }, l.exports.iframeEnabled = !1, s.g.document && (l.exports.iframeEnabled = (typeof s.g.postMessage == "function" || typeof s.g.postMessage == "object") && !d.isKonqueror());
      }, 4886: function(l, v, s) {
        var c = {};
        ["log", "debug", "warn"].forEach(function(d) {
          var p;
          try {
            p = s.g.console && s.g.console[d] && s.g.console[d].apply;
          } catch {
          }
          c[d] = p ? function() {
            return s.g.console[d].apply(s.g.console, arguments);
          } : d === "log" ? function() {
          } : c.log;
        }), l.exports = c;
      }, 2217: function(l) {
        l.exports = { isObject: function(v) {
          var s = typeof v;
          return s === "function" || s === "object" && !!v;
        }, extend: function(v) {
          if (!this.isObject(v)) return v;
          for (var s, c, d = 1, p = arguments.length; d < p; d++) for (c in s = arguments[d]) Object.prototype.hasOwnProperty.call(s, c) && (v[c] = s[c]);
          return v;
        } };
      }, 8915: function(l, v, s) {
        var c = s(2017);
        l.exports = { string: function(d) {
          for (var p = c.randomBytes(d), m = [], E = 0; E < d; E++) m.push("abcdefghijklmnopqrstuvwxyz012345".substr(p[E] % 32, 1));
          return m.join("");
        }, number: function(d) {
          return Math.floor(Math.random() * d);
        }, numberString: function(d) {
          var p = ("" + (d - 1)).length;
          return (new Array(p + 1).join("0") + this.number(d)).slice(-p);
        } };
      }, 5581: function(l) {
        l.exports = function(v) {
          return { filterToEnabled: function(s, c) {
            var d = { main: [], facade: [] };
            return s ? typeof s == "string" && (s = [s]) : s = [], v.forEach(function(p) {
              p && (p.transportName === "websocket" && c.websocket === !1 || (s.length && s.indexOf(p.transportName) === -1 ? p.transportName : p.enabled(c) ? (p.transportName, d.main.push(p), p.facadeTransport && d.facade.push(p.facadeTransport)) : p.transportName));
            }), d;
          } };
        };
      }, 273: function(l, v, s) {
        var c = s(4564);
        l.exports = { getOrigin: function(d) {
          if (!d) return null;
          var p = new c(d);
          if (p.protocol === "file:") return null;
          var m = p.port;
          return m || (m = p.protocol === "https:" ? "443" : "80"), p.protocol + "//" + p.hostname + ":" + m;
        }, isOriginEqual: function(d, p) {
          return this.getOrigin(d) === this.getOrigin(p);
        }, isSchemeEqual: function(d, p) {
          return d.split(":")[0] === p.split(":")[0];
        }, addPath: function(d, p) {
          var m = d.split("?");
          return m[0] + p + (m[1] ? "?" + m[1] : "");
        }, addQuery: function(d, p) {
          return d + (d.indexOf("?") === -1 ? "?" + p : "&" + p);
        }, isLoopbackAddr: function(d) {
          return /^127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(d) || /^\[::1\]$/.test(d);
        } };
      }, 2828: function(l) {
        l.exports = "1.6.1";
      }, 4564: function(l, v, s) {
        var c = s(4058), d = s(8188), p = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, m = /[\n\r\t]/g, E = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, y = /:\d+$/, g = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, C = /^[a-zA-Z]:/;
        function O(S) {
          return (S || "").toString().replace(p, "");
        }
        var N = [["#", "hash"], ["?", "query"], function(S, B) {
          return I(B.protocol) ? S.replace(/\\/g, "/") : S;
        }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d*)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]], w = { hash: 1, query: 1 };
        function _(S) {
          var B, D = (typeof window < "u" ? window : s.g !== void 0 ? s.g : typeof self < "u" ? self : {}).location || {}, F = {}, j = typeof (S = S || D);
          if (S.protocol === "blob:") F = new H(unescape(S.pathname), {});
          else if (j === "string") for (B in F = new H(S, {}), w) delete F[B];
          else if (j === "object") {
            for (B in S) B in w || (F[B] = S[B]);
            F.slashes === void 0 && (F.slashes = E.test(S.href));
          }
          return F;
        }
        function I(S) {
          return S === "file:" || S === "ftp:" || S === "http:" || S === "https:" || S === "ws:" || S === "wss:";
        }
        function k(S, B) {
          S = (S = O(S)).replace(m, ""), B = B || {};
          var D, F = g.exec(S), j = F[1] ? F[1].toLowerCase() : "", G = !!F[2], U = !!F[3], M = 0;
          return G ? U ? (D = F[2] + F[3] + F[4], M = F[2].length + F[3].length) : (D = F[2] + F[4], M = F[2].length) : U ? (D = F[3] + F[4], M = F[3].length) : D = F[4], j === "file:" ? M >= 2 && (D = D.slice(2)) : I(j) ? D = F[4] : j ? G && (D = D.slice(2)) : M >= 2 && I(B.protocol) && (D = F[4]), { protocol: j, slashes: G || I(j), slashesCount: M, rest: D };
        }
        function H(S, B, D) {
          if (S = (S = O(S)).replace(m, ""), !(this instanceof H)) return new H(S, B, D);
          var F, j, G, U, M, V, J = N.slice(), ue = typeof B, se = this, ee = 0;
          for (ue !== "object" && ue !== "string" && (D = B, B = null), D && typeof D != "function" && (D = d.parse), F = !(j = k(S || "", B = _(B))).protocol && !j.slashes, se.slashes = j.slashes || F && B.slashes, se.protocol = j.protocol || B.protocol || "", S = j.rest, (j.protocol === "file:" && (j.slashesCount !== 2 || C.test(S)) || !j.slashes && (j.protocol || j.slashesCount < 2 || !I(se.protocol))) && (J[3] = [/(.*)/, "pathname"]); ee < J.length; ee++) typeof (U = J[ee]) != "function" ? (G = U[0], V = U[1], G != G ? se[V] = S : typeof G == "string" ? ~(M = G === "@" ? S.lastIndexOf(G) : S.indexOf(G)) && (typeof U[2] == "number" ? (se[V] = S.slice(0, M), S = S.slice(M + U[2])) : (se[V] = S.slice(M), S = S.slice(0, M))) : (M = G.exec(S)) && (se[V] = M[1], S = S.slice(0, M.index)), se[V] = se[V] || F && U[3] && B[V] || "", U[4] && (se[V] = se[V].toLowerCase())) : S = U(S, se);
          D && (se.query = D(se.query)), F && B.slashes && se.pathname.charAt(0) !== "/" && (se.pathname !== "" || B.pathname !== "") && (se.pathname = function(de, he) {
            if (de === "") return he;
            for (var pe = (he || "/").split("/").slice(0, -1).concat(de.split("/")), Ce = pe.length, _e = pe[Ce - 1], Le = !1, Te = 0; Ce--; ) pe[Ce] === "." ? pe.splice(Ce, 1) : pe[Ce] === ".." ? (pe.splice(Ce, 1), Te++) : Te && (Ce === 0 && (Le = !0), pe.splice(Ce, 1), Te--);
            return Le && pe.unshift(""), _e !== "." && _e !== ".." || pe.push(""), pe.join("/");
          }(se.pathname, B.pathname)), se.pathname.charAt(0) !== "/" && I(se.protocol) && (se.pathname = "/" + se.pathname), c(se.port, se.protocol) || (se.host = se.hostname, se.port = ""), se.username = se.password = "", se.auth && (~(M = se.auth.indexOf(":")) ? (se.username = se.auth.slice(0, M), se.username = encodeURIComponent(decodeURIComponent(se.username)), se.password = se.auth.slice(M + 1), se.password = encodeURIComponent(decodeURIComponent(se.password))) : se.username = encodeURIComponent(decodeURIComponent(se.auth)), se.auth = se.password ? se.username + ":" + se.password : se.username), se.origin = se.protocol !== "file:" && I(se.protocol) && se.host ? se.protocol + "//" + se.host : "null", se.href = se.toString();
        }
        H.prototype = { set: function(S, B, D) {
          var F = this;
          switch (S) {
            case "query":
              typeof B == "string" && B.length && (B = (D || d.parse)(B)), F[S] = B;
              break;
            case "port":
              F[S] = B, c(B, F.protocol) ? B && (F.host = F.hostname + ":" + B) : (F.host = F.hostname, F[S] = "");
              break;
            case "hostname":
              F[S] = B, F.port && (B += ":" + F.port), F.host = B;
              break;
            case "host":
              F[S] = B, y.test(B) ? (B = B.split(":"), F.port = B.pop(), F.hostname = B.join(":")) : (F.hostname = B, F.port = "");
              break;
            case "protocol":
              F.protocol = B.toLowerCase(), F.slashes = !D;
              break;
            case "pathname":
            case "hash":
              if (B) {
                var j = S === "pathname" ? "/" : "#";
                F[S] = B.charAt(0) !== j ? j + B : B;
              } else F[S] = B;
              break;
            case "username":
            case "password":
              F[S] = encodeURIComponent(B);
              break;
            case "auth":
              var G = B.indexOf(":");
              ~G ? (F.username = B.slice(0, G), F.username = encodeURIComponent(decodeURIComponent(F.username)), F.password = B.slice(G + 1), F.password = encodeURIComponent(decodeURIComponent(F.password))) : F.username = encodeURIComponent(decodeURIComponent(B));
          }
          for (var U = 0; U < N.length; U++) {
            var M = N[U];
            M[4] && (F[M[1]] = F[M[1]].toLowerCase());
          }
          return F.auth = F.password ? F.username + ":" + F.password : F.username, F.origin = F.protocol !== "file:" && I(F.protocol) && F.host ? F.protocol + "//" + F.host : "null", F.href = F.toString(), F;
        }, toString: function(S) {
          S && typeof S == "function" || (S = d.stringify);
          var B, D = this, F = D.host, j = D.protocol;
          j && j.charAt(j.length - 1) !== ":" && (j += ":");
          var G = j + (D.protocol && D.slashes || I(D.protocol) ? "//" : "");
          return D.username ? (G += D.username, D.password && (G += ":" + D.password), G += "@") : D.password ? (G += ":" + D.password, G += "@") : D.protocol !== "file:" && I(D.protocol) && !F && D.pathname !== "/" && (G += "@"), (F[F.length - 1] === ":" || y.test(D.hostname) && !D.port) && (F += ":"), G += F + D.pathname, (B = typeof D.query == "object" ? S(D.query) : D.query) && (G += B.charAt(0) !== "?" ? "?" + B : B), D.hash && (G += D.hash), G;
        } }, H.extractProtocol = k, H.location = _, H.trimLeft = O, H.qs = d, l.exports = H;
      }, 8188: function(l, v) {
        var s = Object.prototype.hasOwnProperty;
        function c(p) {
          try {
            return decodeURIComponent(p.replace(/\+/g, " "));
          } catch {
            return null;
          }
        }
        function d(p) {
          try {
            return encodeURIComponent(p);
          } catch {
            return null;
          }
        }
        v.stringify = function(p, m) {
          m = m || "";
          var E, y, g = [];
          for (y in typeof m != "string" && (m = "?"), p) if (s.call(p, y)) {
            if ((E = p[y]) || E != null && !isNaN(E) || (E = ""), y = d(y), E = d(E), y === null || E === null) continue;
            g.push(y + "=" + E);
          }
          return g.length ? m + g.join("&") : "";
        }, v.parse = function(p) {
          for (var m, E = /([^=?#&]+)=?([^&]*)/g, y = {}; m = E.exec(p); ) {
            var g = c(m[1]), C = c(m[2]);
            g === null || C === null || g in y || (y[g] = C);
          }
          return y;
        };
      }, 4058: function(l) {
        l.exports = function(v, s) {
          if (s = s.split(":")[0], !(v = +v)) return !1;
          switch (s) {
            case "http":
            case "ws":
              return v !== 80;
            case "https":
            case "wss":
              return v !== 443;
            case "ftp":
              return v !== 21;
            case "gopher":
              return v !== 70;
            case "file":
              return !1;
          }
          return v !== 0;
        };
      } }, u = {};
      function h(l) {
        var v = u[l];
        if (v !== void 0) return v.exports;
        var s = u[l] = { exports: {} };
        return a[l].call(s.exports, s, s.exports, h), s.exports;
      }
      h.amdO = {}, h.n = function(l) {
        var v = l && l.__esModule ? function() {
          return l.default;
        } : function() {
          return l;
        };
        return h.d(v, { a: v }), v;
      }, h.d = function(l, v) {
        for (var s in v) h.o(v, s) && !h.o(l, s) && Object.defineProperty(l, s, { enumerable: !0, get: v[s] });
      }, h.g = function() {
        if (typeof globalThis == "object") return globalThis;
        try {
          return this || new Function("return this")();
        } catch {
          if (typeof window == "object") return window;
        }
      }(), h.o = function(l, v) {
        return Object.prototype.hasOwnProperty.call(l, v);
      }, h.r = function(l) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(l, "__esModule", { value: !0 });
      };
      var b = {};
      return function() {
        h.r(b), h.d(b, { default: function() {
          return zt;
        } });
        var l = h(8e3), v = h.n(l), s = h(3281), c = h.n(s), d = h(3720), p = h.n(d), m = (h(9601), h(1539), h(8674), h(2526), h(1817), h(2165), h(6992), h(8783), h(3948), h(8309), h(3843), h(3710), h(1532), h(4812), h(9070), h(7941), h(2222), h(9653), h(9575), h(2472), h(2990), h(8927), h(3105), h(5035), h(4345), h(7174), h(2846), h(4731), h(7209), h(6319), h(8867), h(7789), h(3739), h(9368), h(4483), h(2056), h(3462), h(678), h(7462), h(3824), h(5021), h(2974), h(5016), h(5827), h(2564), h(9554), h(4747), h(7327), h(561), h(7252)), E = h(4024), y = h(4998), g = h(5531), C = h(6424), O = (h(6699), h(7360)), N = ["onTextMessage", "onFileMessage", "onAudioMessage", "onVideoMessage", "onImageMessage", "onLocationMessage", "onCustomMessage", "onCMDMessage"], w = function() {
          function ze(Ne, le, X) {
            this.handlerData = {}, this.handlerData = {}, Ne.addEventHandler = this.addEventHandler.bind(this), Ne.removeEventHandler = this.removeEventHandler.bind(this);
          }
          return ze.prototype.addEventHandler = function(Ne, le) {
            this.handlerData[Ne] = le;
          }, ze.prototype.removeEventHandler = function(Ne) {
            delete this.handlerData[Ne];
          }, ze.prototype.dispatch = function(Ne, le) {
            for (var X in N.includes(Ne) && le ? O.kg.debug("dispatch event: " + Ne, { id: le.id, type: le.type, time: le.time, from: le.from, to: le.to, chatType: le.chatType }) : Ne === "onMessage" ? O.kg.debug("dispatch event: " + Ne, le == null ? void 0 : le.length) : O.kg.debug("dispatch event: " + Ne, le || ""), this.handlerData) {
              var re = this.handlerData[X][Ne];
              re && re(le);
            }
          }, ze;
        }(), _ = function() {
        };
        function I(ze) {
          this.onOpened = ze.onOpened || _, this.onPresence = ze.onPresence || _, this.onTextMessage = ze.onTextMessage || _, this.onPictureMessage = ze.onPictureMessage || _, this.onAudioMessage = ze.onAudioMessage || _, this.onVideoMessage = ze.onVideoMessage || _, this.onFileMessage = ze.onFileMessage || _, this.onLocationMessage = ze.onLocationMessage || _, this.onCmdMessage = ze.onCmdMessage || _, this.onCustomMessage = ze.onCustomMessage || _, this.onReceivedMessage = ze.onReceivedMessage || _, this.onDeliveredMessage = ze.onDeliveredMessage || _, this.onReadMessage = ze.onReadMessage || _, this.onRecallMessage = ze.onRecallMessage || _, this.onChannelMessage = ze.onChannelMessage || _, this.onError = ze.onError || _, this.onOffline = ze.onOffline || _, this.onOnline = ze.onOnline || _, this.onStatisticMessage = ze.onStatisticMessage || _, this.onContactInvited = ze.onContactInvited || _, this.onContactAgreed = ze.onContactAgreed || _, this.onContactRefuse = ze.onContactRefuse || _, this.onContactDeleted = ze.onContactDeleted || _, this.onContactAdded = ze.onContactAdded || _, this.onTokenWillExpire = ze.onTokenWillExpire || _, this.onTokenExpired = ze.onTokenExpired || _, this.onClosed = ze.onClosed || _, this.onPresenceStatusChange = ze.onPresenceStatusChange || _;
        }
        h(2772);
        var k = { biz: "", debug: !1, token: "" }, H = "https://data-reporting.agora.io/report", S = "https://data-reporting.sh.agoralab.co/report", B = (h(2023), h(2071)), D = h(1595), F = function(ze) {
          var Ne = Number(D.C8[ze]);
          return Ne === D.C8.USER_LOGIN ? "MANUALLOGIN" : Ne === D.C8.MSYNC_SENDMESSAGE ? "SENDMESSAGE" : Ne > D.C8.UNKNOWOPERATION && Ne < D.C8.REST_OPERATE ? "REST" : Ne > D.C8.REST_OPERATE && Ne < D.C8.MSYNC_OPERATE ? "MESSAGE" : Ne > D.C8.MSYNC_OPERATE && Ne < D.C8.ROSTER_OPERATE ? "ROSTER" : Ne > D.C8.ROSTER_OPERATE && Ne < D.C8.USER_OPERATE ? "USER" : Ne > D.C8.USER_OPERATE && Ne < D.C8.GROUP_OPERATE ? "GROUP" : Ne > D.C8.GROUP_OPERATE && Ne < D.C8.CHATROOM_OPERATE ? "CHATROOM" : "OPERATION";
        }, j = function() {
          return (/* @__PURE__ */ new Date()).getTime();
        }, G = function(ze) {
          return [E.iw.BAIDU, E.iw.WX, E.iw.DD, E.iw.ZFB, E.iw.TT, E.iw.QUICK_APP, E.iw.UNI].includes(ze.platform);
        }, U = function() {
          return ze = 1, Ne = 99999, ze = Math.ceil(ze), Ne = Math.floor(Ne), Math.floor(Math.random() * (Ne - ze)) + ze;
          var ze, Ne;
        }, M = {}, V = (h(1249), function(ze, Ne) {
          var le = {};
          for (var X in ze) Object.prototype.hasOwnProperty.call(ze, X) && Ne.indexOf(X) < 0 && (le[X] = ze[X]);
          if (ze != null && typeof Object.getOwnPropertySymbols == "function") {
            var re = 0;
            for (X = Object.getOwnPropertySymbols(ze); re < X.length; re++) Ne.indexOf(X[re]) < 0 && Object.prototype.propertyIsEnumerable.call(ze, X[re]) && (le[X[re]] = ze[X[re]]);
          }
          return le;
        }), J = 1e3, ue = function() {
          function ze(Ne) {
            this.eventQueue = [], this.stock = J, this.config = Ne, this.governor();
          }
          return ze.prototype.add = function(Ne) {
            this.stock <= 0 ? console.warn("Event Report limit ".concat(J, " per minute")) : (this.eventQueue.push(Ne), this.consume(), this.stock -= 1);
          }, ze.prototype.consume = function() {
            var Ne = this;
            this.eventQueue.length !== 0 && (this.timer && this.eventQueue.length <= 10 && clearTimeout(this.timer), this.timer = setTimeout(function() {
              var le, X = Ne.eventQueue.splice(0, 10), re = X.filter(function(Se) {
                return Se.appId === X[0].appId;
              }), Me = X.filter(function(Se) {
                return Se.appId !== X[0].appId;
              });
              (le = Ne.eventQueue).unshift.apply(le, Me), Ne.batchSend(re);
            }, 1e3));
          }, ze.prototype.governor = function() {
            var Ne = this, le = setInterval(function() {
              Ne.stock = J;
            }, 6e4);
            typeof addEventListener < "u" && addEventListener("beforeunload", function() {
              clearInterval(le);
            });
          }, ze.prototype.batchSend = function(Ne) {
            var le, X;
            if (Ne === void 0 && (Ne = []), Ne.length !== 0) try {
              var re = Ne.map(function(Me) {
                Me.biz, Me.appId;
                var Se = Me.eventId, ke = V(Me, ["biz", "appId", "eventId"]);
                return { eventId: Number(Se), body: ke };
              });
              (function(Me, Se) {
                try {
                  var ke = Se.biz, Ge = Se.appId, nt = Se.data, rt = Se.debug, dt = Se.onSuccess;
                  if (!ke) throw new Error("biz is not defined");
                  M.global || (M = E.P6.getEnvInfo());
                  var lt = M;
                  if (G(lt)) {
                    var Ct = { url: rt ? S : H, data: nt, method: "POST", success: function() {
                      dt == null || dt();
                    }, fail: function() {
                    }, complete: function() {
                    } }, Ie = { token: Me, appid: Ge ?? "", sendts: "".concat(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3)), biz: ke, debug: "".concat(rt) };
                    if (lt.platform === "zfb" || lt.platform === "dd" ? Ct.headers = Ie : Ct.header = Ie, lt.platform === "dd") return lt.global.httpRequest(Ct);
                    lt.global.request(Ct);
                  } else {
                    var x = new XMLHttpRequest();
                    x.onreadystatechange = function() {
                      x.readyState === 2 && (dt == null || dt());
                    }, x.open("POST", rt ? S : H), x.setRequestHeader("Content-Type", "application/json"), x.setRequestHeader("token", Me), x.setRequestHeader("appid", Ge ?? ""), x.setRequestHeader("sendts", "".concat(Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3))), x.setRequestHeader("biz", ke), x.setRequestHeader("debug", "".concat(rt)), x.send(JSON.stringify(nt));
                  }
                } catch (ae) {
                  console.error(ae);
                }
              })(this.config.token, { biz: (le = Ne[0]) === null || le === void 0 ? void 0 : le.biz, appId: (X = Ne[0]) === null || X === void 0 ? void 0 : X.appId, data: re, debug: this.config.debug, onSuccess: this.consume.bind(this) });
            } catch (Me) {
              console.error(Me);
            }
          }, ze;
        }(), se = function() {
          return se = Object.assign || function(ze) {
            for (var Ne, le = 1, X = arguments.length; le < X; le++) for (var re in Ne = arguments[le]) Object.prototype.hasOwnProperty.call(Ne, re) && (ze[re] = Ne[re]);
            return ze;
          }, se.apply(this, arguments);
        }, ee = new (function() {
          function ze(Ne) {
            this.inited = !1, this.appId = "", this.biz = "", this.eventQueue = {}, this.config = k, Ne && this.init(Ne);
          }
          return ze.prototype.init = function(Ne) {
            var le;
            if (Ne === void 0 && (Ne = {}), !Ne.biz || !Ne.token) throw new Error("Event Report: biz or token is not defined");
            try {
              this.appId = (le = Ne.appId) !== null && le !== void 0 ? le : "", this.biz = Ne.biz, this.config = se(se({}, k), Ne), this.eventQueue = new ue(this.config), this.log(Ne), this.inited = !0;
            } catch (X) {
              console.error(X);
            }
          }, ze.prototype.send = function(Ne, le, X) {
            var re;
            if (le === void 0 && (le = {}), this.inited) {
              var Me = se(se({}, le), { eventId: Number(Ne), biz: this.biz, appId: (re = X == null ? void 0 : X.appId) !== null && re !== void 0 ? re : this.appId });
              this.eventQueue.add(Me), this.log(Me);
            } else console.error("Event Report: init is not called");
          }, ze.prototype.log = function(Ne) {
            try {
              if (this.config.debug) {
                var le = Ne.payload, X = function(re, Me) {
                  var Se = {};
                  for (var ke in re) Object.prototype.hasOwnProperty.call(re, ke) && Me.indexOf(ke) < 0 && (Se[ke] = re[ke]);
                  if (re != null && typeof Object.getOwnPropertySymbols == "function") {
                    var Ge = 0;
                    for (ke = Object.getOwnPropertySymbols(re); Ge < ke.length; Ge++) Me.indexOf(ke[Ge]) < 0 && Object.prototype.propertyIsEnumerable.call(re, ke[Ge]) && (Se[ke[Ge]] = re[ke[Ge]]);
                  }
                  return Se;
                }(Ne, ["payload"]);
                console.log("%c Event Report: ".concat(this.config.biz, " "), "background: #8A97FC; color: #fff"), console.table(X), le && (console.info("payload:"), console.table(le));
              }
            } catch (re) {
              console.error(re);
            }
          }, ze;
        }())(), de = function() {
          return de = Object.assign || function(ze) {
            for (var Ne, le = 1, X = arguments.length; le < X; le++) for (var re in Ne = arguments[le]) Object.prototype.hasOwnProperty.call(Ne, re) && (ze[re] = Ne[re]);
            return ze;
          }, de.apply(this, arguments);
        }, he = { requestName: "", subrequestid: "1", requestMethod: "GET", requestUrl: "", requestElapse: 0, code: 0, codeDesc: "", isLastApi: 0, isSuccess: 1 }, pe = function() {
          function ze(Ne) {
            this.platform = E.P6.getEnvInfo(), this.isReportDt = Ne.isReport || !1, this.isCollectDt = !0, G(this.platform) && !this.isReportDt && (this.isCollectDt = !1), this.eventQueue = [], this.accessChannel = B.yK, this.options = function(le, X) {
              X.platform || (X = E.P6.getEnvInfo());
              var re = le.org, Me = le.appkey, Se = le.deviceId, ke = le.sdkVersion, Ge = (navigator == null ? void 0 : navigator.userAgent) || "".concat(X.platform, "_mini_program");
              return { org: re, appkey: Me, deviceId: Se, sdkServiceId: "sid_".concat(E.P6.getUniqueId(), "_").concat(U()), did: Ge, sdkVersion: ke, os: B.Wc, sdkProduct: D.aC.web };
            }(Ne, this.platform), this.sid = this.options.sdkServiceId, this.init(Ne);
          }
          return ze.getInstance = function() {
            return ze.instance;
          }, ze.prototype.getServiceId = function() {
            return this.sid || "sid_0";
          }, ze.prototype.setIsReportDt = function(Ne) {
            this.isReportDt = Ne, Ne && this.rptEventQueue();
          }, ze.prototype.setIsCollectDt = function(Ne) {
            this.isCollectDt = Ne, Ne || (this.eventQueue = []);
          }, ze.prototype.rptEventQueue = function() {
            var Ne = this;
            this.eventQueue.length && this.eventQueue.forEach(function(le, X) {
              ee.send(le.eventId, le.dt), X >= Ne.eventQueue.length - 1 && (Ne.eventQueue = []);
            });
          }, ze.prototype.init = function(Ne) {
            ze.instance || (ze.instance = this, ee.init({ biz: B.el, token: B.$x, appId: Ne.appkey, debug: !1 }), this.reportInit());
          }, ze.prototype.reportInit = function() {
            if (this.isCollectDt) {
              var Ne = this.options, le = Ne.did, X = Ne.os, re = Ne.sdkVersion, Me = Ne.deviceId;
              this.reportData(B.iB.INIT, { did: le, os: X, sdkVersion: re, deviceId: Me });
            }
          }, ze.prototype.geOperateFun = function(Ne) {
            var le = this;
            if (!this.isCollectDt) return function() {
            };
            var X = 1, re = 0, Me = "", Se = j(), ke = Ne.uid, Ge = Ne.operationName;
            ke && (this.uid = ke);
            var nt = { uid: this.uid, operationId: "opr_".concat(E.P6.getUniqueId(), "_").concat(U()), requestid: "req_".concat(E.P6.getUniqueId(), "_").concat(U()), operationName: Ge };
            return function(rt) {
              var dt, lt, Ct, Ie;
              if (rt.data.isSuccess ? (re = 0, Me = "") : (rt.data.code === 0 && (rt.data.code = B.Tp), re = (dt = rt.data.code) !== null && dt !== void 0 ? dt : re, Me = (lt = rt.data.codeDesc) !== null && lt !== void 0 ? lt : Me), !((Ct = rt.data) === null || Ct === void 0) && Ct.accessChannel && (le.accessChannel = (Ie = rt.data) === null || Ie === void 0 ? void 0 : Ie.accessChannel), rt.isRetry ? (X++, rt.data.subrequestid = "".concat(X)) : (nt.requestid = "req_".concat(E.P6.getUniqueId(), "_").concat(U()), X = 1), rt.data.isLastApi) {
                var x = j();
                rt.data.requestElapse = x - Se, rt.data.requestMethod = "", rt.data.subrequestid = "0", rt.data.code = re === 200 ? 0 : re, rt.data.codeDesc = Me;
              } else rt.data.requestName || (rt.data.requestName = Ge);
              rt.data.requestElapse || (rt.data.requestElapse = j() - Se), le.reportData.call(le, B.iB.API, de(de(de(de({}, he), nt), rt.data), { accessChannel: le.accessChannel, operationType: F(Ge) })), rt.isEndApi && le.reportData.call(le, B.iB.API, de(de(de({}, nt), he), { isSuccess: rt.data.isSuccess, isLastApi: 1, subrequestid: "0", requestMethod: "", code: re === 200 ? 0 : re, codeDesc: Me, requestElapse: rt.data.requestElapse, accessChannel: le.accessChannel, operationType: F(Ge) }));
            };
          }, ze.prototype.reportData = function(Ne, le) {
            return X = this, re = void 0, Se = function() {
              var ke, Ge, nt, rt, dt, lt, Ct, Ie;
              return function(x, ae) {
                var Q, Z, ge, me, ve = { label: 0, sent: function() {
                  if (1 & ge[0]) throw ge[1];
                  return ge[1];
                }, trys: [], ops: [] };
                return me = { next: ie(0), throw: ie(1), return: ie(2) }, typeof Symbol == "function" && (me[Symbol.iterator] = function() {
                  return this;
                }), me;
                function ie(ye) {
                  return function(Ye) {
                    return function(ne) {
                      if (Q) throw new TypeError("Generator is already executing.");
                      for (; ve; ) try {
                        if (Q = 1, Z && (ge = 2 & ne[0] ? Z.return : ne[0] ? Z.throw || ((ge = Z.return) && ge.call(Z), 0) : Z.next) && !(ge = ge.call(Z, ne[1])).done) return ge;
                        switch (Z = 0, ge && (ne = [2 & ne[0], ge.value]), ne[0]) {
                          case 0:
                          case 1:
                            ge = ne;
                            break;
                          case 4:
                            return ve.label++, { value: ne[1], done: !1 };
                          case 5:
                            ve.label++, Z = ne[1], ne = [0];
                            continue;
                          case 7:
                            ne = ve.ops.pop(), ve.trys.pop();
                            continue;
                          default:
                            if (!((ge = (ge = ve.trys).length > 0 && ge[ge.length - 1]) || ne[0] !== 6 && ne[0] !== 2)) {
                              ve = 0;
                              continue;
                            }
                            if (ne[0] === 3 && (!ge || ne[1] > ge[0] && ne[1] < ge[3])) {
                              ve.label = ne[1];
                              break;
                            }
                            if (ne[0] === 6 && ve.label < ge[1]) {
                              ve.label = ge[1], ge = ne;
                              break;
                            }
                            if (ge && ve.label < ge[2]) {
                              ve.label = ge[2], ve.ops.push(ne);
                              break;
                            }
                            ge[2] && ve.ops.pop(), ve.trys.pop();
                            continue;
                        }
                        ne = ae.call(x, ve);
                      } catch (Qe) {
                        ne = [6, Qe], Z = 0;
                      } finally {
                        Q = ge = 0;
                      }
                      if (5 & ne[0]) throw ne[1];
                      return { value: ne[0] ? ne[1] : void 0, done: !0 };
                    }([ye, Ye]);
                  };
                }
              }(this, function(x) {
                switch (x.label) {
                  case 0:
                    return x.trys.push([0, 3, , 4]), ke = j(), Ge = 0, Ne !== B.iB.API ? [3, 2] : [4, (ae = this.platform, new Promise(function(Q) {
                      var Z;
                      ae.platform || (ae = E.P6.getEnvInfo());
                      var ge = "";
                      if (ae.platform === E.iw.WEB) {
                        var me = navigator.connection;
                        me != null && me.type ? (me == null || me.type, ge = D.td.WIFI) : me != null && me.effectiveType && (ge = D.td[me.effectiveType.toLocaleUpperCase()]), Q(ge);
                      } else ae.platform === E.iw.NODE ? (ge = D.td.UNKNOWN, Q(ge)) : (Z = ae.global) === null || Z === void 0 || Z.getNetworkType({ success: function(ve) {
                        ge = D.td[ve.networkType.toLocaleUpperCase()], Q(ge);
                      } });
                    }))];
                  case 1:
                    Ge = x.sent(), x.label = 2;
                  case 2:
                    return nt = this.options, rt = nt.appkey, dt = nt.sdkServiceId, lt = nt.sdkProduct, Ct = de({ lts: ke, net: Ge, appkey: rt, sdkServiceId: dt, sdkProduct: lt }, le), this.isReportDt ? ee.send(Ne, Ct) : this.isCollectDt && this.eventQueue.push({ eventId: Ne, dt: Ct }), [3, 4];
                  case 3:
                    return Ie = x.sent(), console.warn(Ie), [3, 4];
                  case 4:
                    return [2];
                }
                var ae;
              });
            }, new ((Me = void 0) || (Me = Promise))(function(ke, Ge) {
              function nt(lt) {
                try {
                  dt(Se.next(lt));
                } catch (Ct) {
                  Ge(Ct);
                }
              }
              function rt(lt) {
                try {
                  dt(Se.throw(lt));
                } catch (Ct) {
                  Ge(Ct);
                }
              }
              function dt(lt) {
                var Ct;
                lt.done ? ke(lt.value) : (Ct = lt.value, Ct instanceof Me ? Ct : new Me(function(Ie) {
                  Ie(Ct);
                })).then(nt, rt);
              }
              dt((Se = Se.apply(X, re || [])).next());
            });
            var X, re, Me, Se;
          }, ze;
        }(), Ce = h(7288), _e = h(7479), Le = h(2856), Te = h(9667), K = h(3770), Oe = h(1735), Pe = h(7384), xe = h(70), be = h(8161);
        function $e(ze) {
          return $e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ne) {
            return typeof Ne;
          } : function(Ne) {
            return Ne && typeof Symbol == "function" && Ne.constructor === Symbol && Ne !== Symbol.prototype ? "symbol" : typeof Ne;
          }, $e(ze);
        }
        var Be = function() {
          return Be = Object.assign || function(ze) {
            for (var Ne, le = 1, X = arguments.length; le < X; le++) for (var re in Ne = arguments[le]) Object.prototype.hasOwnProperty.call(Ne, re) && (ze[re] = Ne[re]);
            return ze;
          }, Be.apply(this, arguments);
        }, Ke = function(ze, Ne) {
          var le, X, re, Me, Se = { label: 0, sent: function() {
            if (1 & re[0]) throw re[1];
            return re[1];
          }, trys: [], ops: [] };
          return Me = { next: ke(0), throw: ke(1), return: ke(2) }, typeof Symbol == "function" && (Me[Symbol.iterator] = function() {
            return this;
          }), Me;
          function ke(Ge) {
            return function(nt) {
              return function(rt) {
                if (le) throw new TypeError("Generator is already executing.");
                for (; Se; ) try {
                  if (le = 1, X && (re = 2 & rt[0] ? X.return : rt[0] ? X.throw || ((re = X.return) && re.call(X), 0) : X.next) && !(re = re.call(X, rt[1])).done) return re;
                  switch (X = 0, re && (rt = [2 & rt[0], re.value]), rt[0]) {
                    case 0:
                    case 1:
                      re = rt;
                      break;
                    case 4:
                      return Se.label++, { value: rt[1], done: !1 };
                    case 5:
                      Se.label++, X = rt[1], rt = [0];
                      continue;
                    case 7:
                      rt = Se.ops.pop(), Se.trys.pop();
                      continue;
                    default:
                      if (!((re = (re = Se.trys).length > 0 && re[re.length - 1]) || rt[0] !== 6 && rt[0] !== 2)) {
                        Se = 0;
                        continue;
                      }
                      if (rt[0] === 3 && (!re || rt[1] > re[0] && rt[1] < re[3])) {
                        Se.label = rt[1];
                        break;
                      }
                      if (rt[0] === 6 && Se.label < re[1]) {
                        Se.label = re[1], re = rt;
                        break;
                      }
                      if (re && Se.label < re[2]) {
                        Se.label = re[2], Se.ops.push(rt);
                        break;
                      }
                      re[2] && Se.ops.pop(), Se.trys.pop();
                      continue;
                  }
                  rt = Ne.call(ze, Se);
                } catch (dt) {
                  rt = [6, dt], X = 0;
                } finally {
                  le = re = 0;
                }
                if (5 & rt[0]) throw rt[1];
                return { value: rt[0] ? rt[1] : void 0, done: !0 };
              }([Ge, nt]);
            };
          }
        }, Ze = E.P6.getEnvInfo(), at = Ze.platform === "web", pt = function() {
        }, It = { CLOSED: 3, CLOSING: 2, CONNECTING: 0, OPEN: 1 }, Rt = function() {
          function ze(Ne) {
            var le, X;
            if (this.name = "connection", this.max_cache_length = 100, this.enableReportLogs = !1, this._reportLogs = !1, this._reportInterval = 3e5, this.unSyncQueue = [], this.lastHeartbeat = Date.now(), this.isDebug = Ne.isDebug || !1, this.isReport = !1, this.enableReportLogs = Ne.enableReportLogs || !1, this.uploadPartEnable = !0, this.isHttpDNS = Ne.isHttpDNS === void 0 ? at : Ne.isHttpDNS, this.heartBeatWait = Ne.heartBeatWait || 3e4, this.autoReconnectNumMax = Ne.autoReconnectNumMax || 5, this.refreshDNSIntervals = this.autoReconnectNumMax < 5 ? this.autoReconnectNumMax : 5, this.delivery = Ne.delivery || !1, this.disconnectedReason = void 0, this.loginInfoCustomExt = void 0, this.dnsArr = ["https://rs.easemob.com", "https://rs.chat.agora.io", "http://59.110.89.59", "http://39.97.193.190", "http://39.97.193.187"], this.dnsIndex = 0, this.dnsTotal = this.dnsArr.length, this.restHosts = [], this.restTotal = 0, this.restIndex = 0, this.hostIndex = 0, this.socketHost = [], this.hostTotal = 0, this.times = 1, this.autoReconnectNumTotal = 0, this.domain = "easemob.com", this.appKey = Ne.appKey, this.appName = "", this.orgName = "", this.token = "", this.grantType = "", this.apiUrl = Ne.apiUrl || "", this.url = Ne.url || "", this.https = Ne.https || typeof window < "u" && ((le = window.location) === null || le === void 0 ? void 0 : le.protocol) === "https:", this.version = "1.3.1", this.deviceId = Ne.deviceId || "webim", this.isFixedDeviceId = (X = Ne.isFixedDeviceId) === null || X === void 0 || X, this.osType = 16, this.useOwnUploadFun = Ne.useOwnUploadFun || !1, this.compressType = [0], this.encryptType = [0], this.clientResource = "", this.expiresIn = 0, this.expirationTime = 0, this.useReplacedMessageContents = Ne.useReplacedMessageContents || !1, this.logOut = !0, this.context = { jid: { appKey: "", clientResource: "", domain: "easemob.com", name: "" }, userId: "", appKey: "", status: 0, restTokenData: "", appName: "", orgName: "", root: {}, accessToken: "" }, this._msgHash = {}, this._msgPromiseHash = {}, this._queues = [], this._load_msg_cache = [], this.unMSyncSendMsgMap = /* @__PURE__ */ new Map(), this.mr_cache = {}, this.reconnecting = !1, this._offlineMessagePullState = y.a.SYNC_INIT, this._offlineMessagePullQueue = [], this.uniPushConfig = {}, this.uniPush = null, this.isRegisterPush = !1, this.pushCertificateName = "", typeof this.appKey != "string" || this.appKey.split("#").length !== 2) throw Error("Illegal appKey: ".concat(this.appKey));
            this.devInfos = this.appKey.split("#"), this.orgName = this.devInfos[0], this.appName = this.devInfos[1], this.listen = I.bind(this), this.mSync = this.usePlugin(C.ZP), this.eventHandler = this.usePlugin(w), Object.assign(ze.prototype, _e), Object.assign(ze.prototype, Le), Object.assign(ze.prototype, Te), Object.assign(ze.prototype, K), Object.assign(ze.prototype, Oe), Object.assign(ze.prototype, Pe), Object.assign(ze.prototype, xe), this.dataReport = new pe({ appkey: this.appKey, org: this.orgName, sdkVersion: this.version, deviceId: this.deviceId, isReport: this.isReport });
            var re = 0, Me = this;
            if (Object.defineProperty(E.P6, "ajaxUnconventionalErrorTimes", { set: function(ke) {
              ke !== 0 && (O.kg.debug("rest api request fail times: ".concat(ke)), (re = ke) % 5 == 0 && Me.isHttpDNS && (O.kg.debug("refresh dns config when rest request fail."), wt.call(Me, "refresh", {}, {})));
            }, get: function() {
              return re;
            } }), this.isFixedDeviceId) {
              var Se = E.P6.getLocalDeviceInfo();
              Se && (this.clientResource = JSON.parse(Se).deviceId);
            }
            O.kg.debug("init SDK: Conn ".concat(this.version, " ").concat(Ze.platform));
          }
          return ze.prototype.usePlugin = function(Ne, le) {
            if (le !== "push") return le ? void (this[le] = new Ne(this)) : new Ne(this);
            Ne.config && Ne.emPush ? (this.uniPushConfig = Ne.config, this.uniPush = Ne.emPush) : O.kg.error("use push plugin failed", "emPush", this.uniPush, "config", this.uniPushConfig);
          }, ze.prototype.listen = function(Ne) {
          }, ze.prototype.addEventHandler = function(Ne, le) {
          }, ze.prototype.removeEventHandler = function(Ne) {
          }, ze.prototype.registerUser = function(Ne) {
            var le = this;
            return new Promise(function(X, re) {
              var Me = le.dataReport.geOperateFun({ uid: Ne.username, operationName: D.fI.REGISTER });
              if (le.isHttpDNS) {
                le.dnsIndex = 0;
                var Se = Be(Be({}, Ne), { user: Ne.username, pwd: Ne.password, promise: { resolve: X, reject: re } });
                wt.call(le, "signup", Se, { rpt: Me });
              } else Se = Be(Be({}, Ne), { promise: { resolve: X, reject: re } }), gt.call(le, Se, { rpt: Me });
            });
          }, ze.prototype.open = function(Ne) {
            var le = this;
            if (O.kg.debug("open", Ne.user), O.kg.debug("isLogout", this.logOut), Ze.platform === "web") {
              var X = E.P6.detectBrowser();
              O.kg.debug("browser", X);
            }
            return new Promise(function(re, Me) {
              var Se, ke = Ot.call(le, Ne);
              if (ke) return (Se = le.onError) === null || Se === void 0 || Se.call(le, ke), Me(ke);
              Ne.accessToken && (le.token = Ne.accessToken);
              var Ge = Be(Be({}, Ne), { promise: { resolve: re, reject: Me } }), nt = le.dataReport.geOperateFun({ uid: Ne.user, operationName: D.fI.LOGIN });
              if (le.isHttpDNS) le.dnsIndex = 0, wt.call(le, "login", Ge, { rpt: nt });
              else {
                if (Ze.platform !== "web" && le.enableReportLogs) return le.dnsIndex = 0, void le.getDNS().then(function() {
                  it.call(le, Ge, { rpt: nt });
                }).catch(function(rt) {
                  var dt;
                  Ge.promise.reject(rt), (dt = Ge.error) === null || dt === void 0 || dt.call(Ge, rt);
                });
                it.call(le, Ge, { rpt: nt });
              }
            });
          }, ze.prototype.getDNS = function() {
            var Ne = this, le = this.dnsIndex < this.dnsTotal ? this.dnsIndex : 0, X = this.dnsArr[le] + "/easemob/server.json";
            return new Promise(function(re, Me) {
              var Se = Ne;
              (function ke() {
                var Ge = { url: X, dataType: "json", type: "GET", data: { app_key: Se.appKey }, success: function(nt) {
                  var rt = nt.enableReportLogs, dt = nt.reportInterval;
                  Se._reportLogs = rt === "true", Se._reportInterval = Number(dt || 3e5), re(nt);
                }, error: function(nt) {
                  if (O.kg.debug("getHttpDNS fail: " + Se.dnsIndex), Se.dnsIndex++, Se.dnsIndex < Se.dnsTotal) ke();
                  else {
                    var rt = m.Z.create({ type: g.E.SERVER_GET_DNSLIST_FAILED, message: "get DNS failed", data: nt });
                    Me(rt);
                  }
                } };
                E.P6.ajax(Ge).catch(function(nt) {
                  console.warn(nt);
                });
              })();
            });
          }, ze.prototype.isOpened = function() {
            return this.sock && this.sock.readyState === It.OPEN || !1;
          }, ze.prototype.close = function() {
            var Ne, le, X;
            O.kg.debug("call close"), O.kg._stopReportLogs(), this.logOut = !0, this.disconnectedReason = void 0, this.reconnecting = !1, this.context.status = g.E.STATUS_CLOSING, this.sock && this.sock.close(), (Ne = this.unMSyncSendMsgMap) === null || Ne === void 0 || Ne.clear(), this.stopHeartBeat(), this.rejectMessage(), this.context.status = g.E.STATUS_CLOSED, this._load_msg_cache = [], this._queues = [], this.unSyncQueue = [], this._msgHash = {}, this.mr_cache = {}, this.token = "", this.context.accessToken = "", this.isRegisterPush = !1, this.clearTokenTimeout(), (X = (le = this == null ? void 0 : this._localCache) === null || le === void 0 ? void 0 : le.getInstance()) === null || X === void 0 || X.close();
          }, ze.prototype.downloadAndParseCombineMessage = function(Ne) {
            var le = this, X = Ne.url, re = Ne.secret;
            return new Promise(function(Me, Se) {
              var ke, Ge, nt = E.P6.getEnvInfo(), rt = nt.platform !== "web" && nt.platform !== "node" && nt.platform !== "quick_app" && ((Ge = (ke = nt.global) === null || ke === void 0 ? void 0 : ke.canIUse) === null || Ge === void 0 ? void 0 : Ge.call(ke, "getFileSystemManager")), dt = function(Ct) {
                var Ie = function(ge) {
                  Se({ type: g.E.PARSE_FILE_ERROR, message: "Read file failed", data: ge });
                }, x = function(ge) {
                  return me = le, ve = void 0, ye = function() {
                    var Ye, ne, Qe, W, ce, fe, we, Fe, je, qe, et, bt, ot;
                    return Ke(this, function(Lt) {
                      switch (Lt.label) {
                        case 0:
                          for (Ye = rt ? new Uint8Array(ge.data) : new Uint8Array(ge.target.result), ne = 0, Qe = 0, W = 2, ce = Ye.subarray(ne, ne + W), fe = E.P6.Uint8ArrayToString(ce), O.kg.debug("file header:", fe), Qe += W, we = 0, Fe = 2; Fe < Ye.length - 1; Fe++) Fe % 2 == 1 && (we ^= Ye[Fe]);
                          if (je = Ye.subarray(Ye.length - 1, Ye.length), O.kg.debug("checkResult:", we, je[0] === we), je[0] !== we) return [2, Se({ type: g.E.PARSE_FILE_ERROR, message: "File verification failed" })];
                          if (fe !== "cm") return [3, 7];
                          Lt.label = 1;
                        case 1:
                          Lt.trys.push([1, 5, , 6]), qe = [], et = function() {
                            var Kt, $t, yt, Wt;
                            return Ke(this, function(In) {
                              switch (In.label) {
                                case 0:
                                  return ne += W, Qe += W = 4, Kt = Ye.subarray(ne, ne + W), ne += W, W = Kt.reduce(function(gn, zn, Xn) {
                                    return gn + (zn << 8 * (Kt.length - Xn - 1));
                                  }, 0), Qe += W, $t = Ye.subarray(ne, ne + W), yt = (yt = bt.root.lookup("easemob.pb.Meta")).decode($t), [4, be.Z.call(bt, yt, 0, !0, !0)];
                                case 1:
                                  return Wt = In.sent(), qe.push(Wt), [2];
                              }
                            });
                          }, bt = this, Lt.label = 2;
                        case 2:
                          return Qe < Ye.length - 1 ? [5, et()] : [3, 4];
                        case 3:
                          return Lt.sent(), [3, 2];
                        case 4:
                          return [2, Me(qe)];
                        case 5:
                          return ot = Lt.sent(), Se({ type: g.E.PARSE_FILE_ERROR, message: "Parse file failed", data: ot }), [3, 6];
                        case 6:
                          return [3, 8];
                        case 7:
                          return [2, Se({ type: g.E.PARSE_FILE_ERROR, message: "File verification failed" })];
                        case 8:
                          return [2];
                      }
                    });
                  }, new ((ie = void 0) || (ie = Promise))(function(Ye, ne) {
                    function Qe(fe) {
                      try {
                        ce(ye.next(fe));
                      } catch (we) {
                        ne(we);
                      }
                    }
                    function W(fe) {
                      try {
                        ce(ye.throw(fe));
                      } catch (we) {
                        ne(we);
                      }
                    }
                    function ce(fe) {
                      var we;
                      fe.done ? Ye(fe.value) : (we = fe.value, we instanceof ie ? we : new ie(function(Fe) {
                        Fe(we);
                      })).then(Qe, W);
                    }
                    ce((ye = ye.apply(me, ve || [])).next());
                  });
                  var me, ve, ie, ye;
                };
                if (rt) {
                  var ae = nt.global.getFileSystemManager(), Q = Ct.tempFilePath;
                  ae.readFile({ filePath: Q, success: x, fail: Ie });
                } else if (Ct instanceof Blob) {
                  var Z = new FileReader();
                  Z.readAsArrayBuffer(Ct), Z.onerror = Ie, Z.onload = x;
                }
              }, lt = function(Ct) {
                Se({ type: g.E.WEBIM_DOWNLOADFILE_ERROR, message: "Download failed, please try again", data: Ct });
              };
              rt ? nt.global.downloadFile({ url: X, success: dt, fail: lt }) : E.P6.download.call(le, { url: X, headers: { Accept: "application/json" }, onFileDownloadComplete: dt, onFileDownloadError: lt, secret: re, accessToken: le.context.accessToken });
            });
          }, ze.prototype.stopHeartBeat = function() {
            clearInterval(this.heartBeatID);
          }, ze.prototype.clear = function() {
            this.restTotal = 0, this.restIndex = 0, this.hostIndex = 0, this.hostTotal = 0;
          }, ze.prototype.heartBeat = function() {
          }, ze.prototype.renewToken = function(Ne) {
            var le = this;
            return this.isOpened() ? this.getTokenExpireTimestamp(Ne).then(function(X) {
              var re = X.expire_timestamp, Me = Date.now();
              return le.expirationTime = re, le.expiresIn = re - Me, le.token = Ne, le.context.accessToken = Ne, le.clearTokenTimeout(), le.tokenExpireTimeCountDown(le.expiresIn), { status: !0, token: Ne, expire: re };
            }) : Promise.reject({ status: !1 });
          }, ze.prototype.clearTokenTimeout = function() {
            O.kg.info("clearTokenTimeout"), this.tokenWillExpireTimer && clearTimeout(this.tokenWillExpireTimer), this.tokenExpiredTimer && clearTimeout(this.tokenExpiredTimer), this.tokenWillExpireTimer = null, this.tokenExpiredTimer = null;
          }, ze.prototype.tokenExpireTimeCountDown = function(Ne) {
            var le = this;
            O.kg.info("tokenExpireTimeCountDown", Ne), Ne > Math.pow(2, 31) - 1 && (Ne = Math.pow(2, 31) - 1), this.tokenWillExpireTimer = setTimeout(function() {
              var X;
              le.onTokenWillExpire && le.onTokenWillExpire(), (X = le.eventHandler) === null || X === void 0 || X.dispatch("onTokenWillExpire"), O.kg.info("onTokenWillExpire", Math.floor(Ne / 2));
            }, Ne / 2), this.tokenExpiredTimer = setTimeout(function() {
              var X;
              O.kg.info("onTokenExpired", 0), le.onTokenExpired && le.onTokenExpired(), (X = le.eventHandler) === null || X === void 0 || X.dispatch("onTokenExpired"), le.close();
            }, Ne);
          }, ze.prototype.compareTokenExpireTime = function(Ne, le) {
            var X, re = Number(le) - Number(Ne);
            O.kg.debug("compareTokenExpireTime", re), re <= this.expiresIn / 2 && re > 0 ? (this.onTokenWillExpire && this.onTokenWillExpire(), (X = this.eventHandler) === null || X === void 0 || X.dispatch("onTokenWillExpire"), O.kg.info("onTokenWillExpire", re)) : re <= 0 && (this.closeByTokenExpired(), O.kg.info("closeByTokenExpired", re));
          }, ze.prototype.closeByTokenExpired = function() {
            var Ne;
            O.kg.info("closed By TokenExpired"), this.onTokenExpired && this.onTokenExpired(), (Ne = this.eventHandler) === null || Ne === void 0 || Ne.dispatch("onTokenExpired"), this.close();
          }, ze.prototype.rejectMessage = function() {
            var Ne = this, le = Object.keys(this._msgHash);
            if (le.length > 0) {
              var X = m.Z.create({ type: g.E.MESSAGE_WEBSOCKET_DISCONNECTED, message: "websocket disconnected" });
              le.forEach(function(re) {
                var Me, Se, ke;
                !((Me = Ne.unMSyncSendMsgMap) === null || Me === void 0) && Me.has(re) || (Ne._msgHash[re].reject instanceof Function && Ne._msgHash[re].reject(X), (ke = (Se = Ne._localCache) === null || Se === void 0 ? void 0 : Se.getInstance()) === null || ke === void 0 || ke.updateLocalMessage(re, { serverMsgId: re, status: Ce.r.FAIL }), Ne._msgHash[re].fail instanceof Function && Ne._msgHash[re].fail(X), delete Ne._msgHash[re]);
              });
            }
          }, ze.prototype.resetConnState = function() {
            this.mSync.stopHeartBeat(), this.times = 1, this.autoReconnectNumTotal = 0, this.hostIndex = 0;
          }, ze.prototype.reconnect = function() {
            var Ne, le = this;
            O.kg.debug("socket reconnect readyState", this.sock.readyState), this.sock.readyState !== It.CONNECTING && this.sock.readyState !== It.OPEN && (O.kg.info("reconnect: time", this.times), O.kg.info("reconnect sock.readyState: ", this.sock.readyState), this.reconnecting === !1 && (this.reconnecting = !0), (Ne = this.eventHandler) === null || Ne === void 0 || Ne.dispatch("onReconnecting"), this.rejectMessage(), this.isHttpDNS && (this.hostIndex < this.socketHost.length - 1 ? this.hostIndex++ : this.hostIndex = this.socketHost.length - 1), setTimeout(function() {
              le.sock.readyState !== It.OPEN && (O.kg.info("login sock.readyState: ", le.sock.readyState), le.sock.close(), st.call(le, { access_token: le.context.accessToken }), le.times++);
            }, 500 * this.times), this.autoReconnectNumTotal++);
          }, ze.prototype.send = function(Ne) {
            return Promise.resolve(null);
          }, ze.prototype.setLoginInfoCustomExt = function(Ne) {
            if (O.kg.debug("setLoginInfoCustomExt", "params:", Ne), Ne) {
              if (typeof Ne != "string") throw new Error("ext must be a string");
              if (Ne.length > 1024) throw new Error("ext length must be less than 1024");
            }
            this.loginInfoCustomExt = Ne;
          }, ze._getSock = function() {
          }, ze;
        }();
        function gt(ze, Ne) {
          var le = this, X = Ne.rpt, re = Ne.isRetry, Me = ze.promise, Se = this.apiUrl + "/" + this.orgName + "/" + this.appName + "/users", ke = { requestName: D.c.RESISTER, requestUrl: Se }, Ge = ze.error || pt;
          if (!this.orgName && !this.appName) {
            var nt = m.Z.create({ type: g.E.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR, message: "signup error" });
            Ge(nt);
          }
          var rt = { headers: { "Content-type": "application/json" }, url: Se, dataType: "json", data: JSON.stringify({ username: ze.username, password: ze.password, nickname: ze.nickname || "" }), success: function(dt) {
            ze.success && ze.success(dt);
            var lt = Be(Be({}, dt), { type: g.E.REQUEST_SUCCESS });
            Me.resolve && Me.resolve(lt);
            var Ct = dt.extraInfo, Ie = Ct.httpCode, x = Ct.elapse;
            X({ isEndApi: !0, isRetry: re, data: Be(Be({}, { requestElapse: x, isSuccess: 1, code: Ie }), ke) });
          }, error: function(dt) {
            var lt = dt.extraInfo, Ct = lt.elapse, Ie = lt.httpCode, x = lt.errDesc;
            return X({ isRetry: re, data: Be(Be({}, { requestElapse: Ct, isSuccess: 0, code: Ie, codeDesc: x }), ke) }), le.isHttpDNS && le.restIndex + 1 < le.restTotal ? (le.restIndex++, Et.call(le), gt.call(le, ze, { rpt: X, isRetry: re }), Promise.reject(dt)) : (X({ data: { isLastApi: 1, isSuccess: 0 } }), le.clear(), Me.reject && Me.reject(dt), Ge(dt));
          } };
          return E.P6.ajax(rt).catch(function(dt) {
            Me.reject && Me.reject(dt);
          });
        }
        function it(ze, Ne) {
          var le, X = this;
          if (!Ot.call(this, ze)) if (O.kg.debug("socket readyState", (le = this.sock) === null || le === void 0 ? void 0 : le.readyState), this.isOpened()) O.kg.debug("socket is already opened");
          else {
            var re = Ne.rpt, Me = Ne.isRetry;
            kt.call(this, ze), this.user = ze.user;
            var Se = ze.promise, ke = this.context.appName, Ge = this.context.orgName, nt = this.apiUrl + "/" + Ge + "/" + ke + "/token";
            if (ze.accessToken) O.kg.debug("login with accessToken"), this.grantType = "accessToken", this.token = ze.accessToken, this.context.accessToken = ze.accessToken, this.context.restTokenData = ze.accessToken, Se.resolve({ accessToken: ze.accessToken }), st.call(this, ze, re), O.kg.initReport({ report: this._reportLogs, reportInterval: this._reportInterval, connection: this });
            else if (ze.agoraToken) O.kg.debug("login with agoraToken"), this.grantType = "agoraToken", this.token = ze.agoraToken, this.context.accessToken = ze.agoraToken, this.context.restTokenData = ze.agoraToken, Se.resolve({ accessToken: ze.agoraToken }), st.call(this, ze, re), O.kg.initReport({ report: this._reportLogs, reportInterval: this._reportInterval, connection: this });
            else {
              O.kg.debug("login with password"), this.grantType = "password";
              var rt = { grant_type: "password", username: ze.user, password: ze.pwd, timestamp: +/* @__PURE__ */ new Date() }, dt = JSON.stringify(rt), lt = { headers: { "Content-type": "application/json" }, url: nt, dataType: "json", data: dt, success: function(Ct) {
                O.kg.debug("get token success"), typeof ze.success == "function" && ze.success(Ct), X.token = Ct.access_token, X.context.restTokenData = Ct.access_token, X.context.accessToken = Ct.access_token, X.expiresIn = Ct.expires_in, Se.resolve({ accessToken: Ct.access_token, duration: Ct.expires_in });
                var Ie = Ct.extraInfo, x = Ie.httpCode, ae = Ie.elapse, Q = { requestName: D.c.LOGIN_BY_PWD, requestElapse: ae, requestUrl: nt, isSuccess: 1, code: x };
                re({ isRetry: Me, data: Q }), st.call(X, Ct, re), O.kg.initReport({ report: X._reportLogs, reportInterval: X._reportInterval, connection: X });
              }, error: function(Ct) {
                var Ie, x = Ct.extraInfo, ae = x.elapse, Q = x.httpCode, Z = x.errDesc, ge = { requestName: D.c.LOGIN_BY_PWD, requestElapse: ae, requestUrl: nt, isSuccess: 0, code: Q, codeDesc: Z };
                if (re({ isRetry: Me, data: ge }), X.isHttpDNS && X.restIndex + 1 < X.restTotal) return X.restIndex++, Et.call(X), void it.call(X, ze, { rpt: re, isRetry: !0 });
                re({ data: { isLastApi: 1, isSuccess: 0 } }), X.clear(), Ct.error && Ct.error_description ? (Ie = m.Z.create({ type: g.E.WEBIM_CONNCTION_OPEN_USERGRID_ERROR, message: Ct.error_description, data: Ct }), X.onError && X.onError(Ie)) : (Ie = m.Z.create({ type: g.E.WEBIM_CONNCTION_OPEN_ERROR, message: Ct.error_description, data: Ct }), X.onError && X.onError(Ie)), typeof ze.error == "function" && ze.error(Ie), Se.reject(Ie);
              }, version: this.version };
              O.kg.debug("start get token"), E.P6.ajax(lt).catch(function(Ct) {
                console.warn(Ct);
              });
            }
            O.kg.debug("grantType", this.grantType), E.P6.listenNetwork(Tt.bind(this), Ut.bind(this)), E.P6.listenBrowserVisibility(function() {
              O.kg.debug("visibility true");
            }, function() {
              O.kg.debug("visibility false");
            });
          }
        }
        function Tt() {
          var ze;
          O.kg.debug("online"), this.onOnline && this.onOnline(), (ze = this.eventHandler) === null || ze === void 0 || ze.dispatch("onOnline"), this.sock && this.sock.readyState !== 1 && (O.kg.debug("sock.readyState:", this.sock.readyState), this.logOut || this.reconnecting || this.reconnect());
        }
        function Ut() {
          var ze, Ne;
          O.kg.debug("offline"), (ze = this.sock) === null || ze === void 0 || ze.close(), this.onOffline && this.onOffline(), (Ne = this.eventHandler) === null || Ne === void 0 || Ne.dispatch("onOffline");
        }
        function st(ze, Ne) {
          var le = this, X = this._getSock();
          this.sock = X, O.kg.debug("start connect ws");
          var re = function() {
            var ke;
            O.kg.debug("websocket onOpen"), Ne && Ne({ data: { isLastApi: 1, isSuccess: 1, accessChannel: (ke = le.socketHost[le.hostIndex]) === null || ke === void 0 ? void 0 : ke.channel } });
            var Ge = E.P6.flow([le.mSync.generateProvision, le.mSync.base64transform])();
            try {
              X.send(Ge);
            } catch (rt) {
              var nt = m.Z.create({ type: g.E.SDK_RUNTIME_ERROR, message: "send message error", data: rt });
              le.onError && le.onError(nt);
            }
          }, Me = function(ke) {
            setTimeout(function() {
              var Ge, nt, rt, dt, lt, Ct, Ie;
              if (O.kg.debug("websocket onClose", ke), Ze.platform !== "zfb" && Ze.platform !== "dd" || (le.sock.readyState = It.CLOSED), le.logOut) le.clear(), le.resetConnState(), (nt = (Ge = le == null ? void 0 : le._localCache) === null || Ge === void 0 ? void 0 : Ge.getInstance()) === null || nt === void 0 || nt.close(), le.onClosed && le.onClosed(), (rt = le.eventHandler) === null || rt === void 0 || rt.dispatch("onDisconnected", le.disconnectedReason);
              else if (le.autoReconnectNumTotal < le.autoReconnectNumMax) {
                le.reconnect();
                var x = { type: g.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" };
                le.onError && le.onError(x), le.autoReconnectNumTotal % le.refreshDNSIntervals == 0 && Ze.platform === "web" && le.isHttpDNS && (O.kg.debug("refresh dns config when websocket close"), wt.call(le, "refresh", {}, {}));
              } else (dt = le.unMSyncSendMsgMap) === null || dt === void 0 || dt.clear(), le.rejectMessage(), x = { type: g.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" }, le.disconnectedReason = m.Z.create({ type: g.E.WEBIM_CONNCTION_DISCONNECTED, message: "reconnection failed" }), le.onError && le.onError(x), (Ct = (lt = le == null ? void 0 : le._localCache) === null || lt === void 0 ? void 0 : lt.getInstance()) === null || Ct === void 0 || Ct.close(), le.onClosed && le.onClosed(), (Ie = le.eventHandler) === null || Ie === void 0 || Ie.dispatch("onDisconnected", le.disconnectedReason), le.resetConnState(), le.reconnecting = !1, O.kg.debug("reconnect fail");
            }, 0);
          }, Se = function(ke) {
            var Ge = le.mSync, nt = Ge.decodeMSync, rt = Ge.distributeMSync;
            E.P6.flow([nt, rt])(ke);
          };
          Ze.platform === "web" ? (X.onopen = re, X.onclose = Me, X.onmessage = Se) : (X.onOpen(re), X.onMessage(Se), X.onClose(Me), typeof window < "u" && window.WebSocket || X.onError(function(ke) {
            var Ge, nt, rt, dt, lt;
            if (O.kg.debug("mini program sock on error", ke), le.sock.readyState !== It.CLOSED && (le.sock = Be(Be({}, le.sock), { close: le.sock.close, send: le.sock.send, readyState: It.CLOSED })), le.onError && le.onError({ type: g.E.WEBIM_CONNECTION_ERROR, message: "on socket error", data: ke }), !le.logOut) if (le.autoReconnectNumTotal < le.autoReconnectNumMax) O.kg.debug("sock.onError reconnect", le.autoReconnectNumTotal, le.autoReconnectNumMax), le.reconnect(), le.autoReconnectNumTotal % le.refreshDNSIntervals == 0 && Ze.platform === "web" && le.isHttpDNS && (O.kg.debug("refresh dns config when websocket error"), wt.call(le, "refresh", {}, {}));
            else {
              var Ct = { type: g.E.WEBIM_CONNCTION_DISCONNECTED, message: "websocket has been disconnected" };
              le.disconnectedReason = m.Z.create({ type: g.E.WEBIM_CONNCTION_DISCONNECTED, message: "reconnection failed" }), (Ge = le.unMSyncSendMsgMap) === null || Ge === void 0 || Ge.clear(), le.rejectMessage(), le.onError && le.onError(Ct), (rt = (nt = le == null ? void 0 : le._localCache) === null || nt === void 0 ? void 0 : nt.getInstance()) === null || rt === void 0 || rt.close(), le.onClosed && le.onClosed(), (dt = le.eventHandler) === null || dt === void 0 || dt.dispatch("onDisconnected", le.disconnectedReason), le.resetConnState(), le.reconnecting = !1, O.kg.debug("reconnect fail");
            }
            Ne && Ne({ data: { isLastApi: 1, isSuccess: 0, accessChannel: (lt = le.socketHost[le.hostIndex]) === null || lt === void 0 ? void 0 : lt.channel } });
          }));
        }
        function Ot(ze) {
          if ($e(ze) !== "object" || ze === null) return m.Z.create({ type: g.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the param is illegal" });
          if (!ze.user || typeof ze.user != "string") {
            var Ne = m.Z.create({ type: g.E.WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR, message: "the user is empty or type is not string" });
            return O.kg.debug("open params error", Ne), Ne;
          }
          return !("agoraToken" in ze) || ze.agoraToken && typeof ze.agoraToken == "string" ? !("accessToken" in ze) || ze.accessToken && typeof ze.accessToken == "string" ? "accessToken" in ze || "agoraToken" in ze || ze.pwd ? void 0 : (Ne = m.Z.create({ type: g.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the accessToken or pwd is illegal" }), O.kg.debug("open params error", Ne), Ne) : (Ne = m.Z.create({ type: g.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the accessToken is illegal" }), O.kg.debug("open params error", Ne), Ne) : (Ne = m.Z.create({ type: g.E.WEBIM_CONNCTION_OPEN_ERROR, message: "the agoraToken is illegal" }), O.kg.debug("open params error", Ne), console.warn("agoraToken is deprecated, please use accessToken instead"), Ne);
        }
        function kt(ze) {
          this.context.jid = { appKey: this.appKey, name: ze.user, domain: this.domain, clientResource: this.clientResource }, this.context.root = this.root, this.context.userId = ze.user, this.context.appKey = this.appKey, this.context.appName = this.appName, this.context.orgName = this.orgName;
        }
        function wt(ze, Ne, le) {
          var X = this, re = le.rpt, Me = le.isRetry, Se = this.dnsIndex < this.dnsTotal ? this.dnsIndex : 0, ke = this.dnsArr[Se] + "/easemob/server.json";
          O.kg.debug("call getHttpDNS: " + this.dnsIndex);
          var Ge = { url: ke, dataType: "json", type: "GET", data: { app_key: encodeURIComponent(this.appKey) }, success: function(nt) {
            O.kg.debug("getHttpDNS success");
            var rt = nt.extraInfo, dt = rt.elapse, lt = rt.httpCode, Ct = { requestUrl: ke, requestName: D.c.GET_DNS, requestElapse: dt, isSuccess: 1, code: lt };
            X._reportLogs = nt.enableReportLogs === "true", X._reportInterval = Number(nt.reportInterval || 3e5), (nt == null ? void 0 : nt.enableDataReport) === "true" ? (X.dataReport.setIsCollectDt(!0), X.dataReport.setIsReportDt(!0)) : (X.dataReport.setIsReportDt(!1), X.dataReport.setIsCollectDt(!1)), (nt == null ? void 0 : nt.uploadinparts_enable) === "false" && (X.uploadPartEnable = !1), re && re({ isRetry: Me, data: Ct });
            var Ie = nt.rest.hosts, x = X.https ? "https" : "http";
            if (O.kg.info("httpType: " + x), !Ie) {
              var ae = m.Z.create({ type: g.E.SERVER_GET_DNSLIST_FAILED, message: "DNS hosts resolution failed", data: nt.rest });
              Ne.error && Ne.error(ae), Ne.promise.reject && Ne.promise.reject(ae);
            }
            for (var Q = Ie.filter(function(ye) {
              if (ye.protocol === x) return ye;
            }), Z = 0; Z < Q.length; Z++) if (Q[Z].protocol === x) {
              var ge = Q[Z];
              Q.splice(Z, 1), Q.unshift(ge);
            }
            X.restHosts = Q, X.restTotal = Q.length;
            var me = nt["msync-ws"].hosts;
            if (!me) {
              var ve = m.Z.create({ type: g.E.SERVER_GET_DNSLIST_FAILED, message: "DNS msync-ws resolution failed", data: nt["msync-ws"] });
              Ne.error && Ne.error(ve), Ne.promise.reject && Ne.promise.reject(ve);
            }
            var ie = me.filter(function(ye) {
              return ye.protocol === x && ye;
            });
            X.socketHost = ie, X.hostTotal = ie.length, Et.call(X), ze !== "refresh" && (ze === "login" ? it.call(X, Ne, { rpt: re }) : gt.call(X, Ne, { rpt: re }));
          }, error: function(nt) {
            var rt = nt.extraInfo, dt = rt.elapse, lt = rt.httpCode, Ct = rt.errDesc, Ie = { requestUrl: ke, requestName: D.c.GET_DNS, isSuccess: 0, code: lt, codeDesc: Ct, requestElapse: dt };
            if (re && re({ isRetry: Me, data: Ie }), O.kg.debug("getHttpDNS fail: " + X.dnsIndex), X.dnsIndex++, X.dnsIndex < X.dnsTotal) wt.call(X, ze, Ne, { rpt: re, isRetry: !0 });
            else if (ze === "login" || ze === "signup") {
              var x = m.Z.create({ type: g.E.SERVER_GET_DNSLIST_FAILED, message: "get DNS failed", data: nt });
              Ne.error && Ne.error(x), Ne.promise.reject && Ne.promise.reject(x);
            }
          } };
          return E.P6.ajax(Ge).catch(function(nt) {
            console.warn(nt);
          });
        }
        function Et() {
          var ze, Ne;
          if (this.restIndex > this.restTotal) return O.kg.debug("restIndex > restTotal"), "";
          var le = "", X = this.restHosts[this.restIndex], re = X.domain, Me = X.ip, Se = X.port, ke = this.https ? "https:" : "http:";
          return Me && typeof window < "u" && ((ze = window == null ? void 0 : window.location) === null || ze === void 0 ? void 0 : ze.protocol) === "http:" ? le = ke + "//" + Me + ":" + Se : (le = ke + "//" + re, Se && Se !== "80" && Se !== "443" && (le += ":".concat(Se)), typeof window > "u" || window.location || (le = "https://" + re), typeof window < "u" && window.location && ((Ne = window.location) === null || Ne === void 0 ? void 0 : Ne.protocol) === "file:" && (le = "https://" + re)), typeof window > "u" && (le = ke + "//" + re), this.apiUrl = le, le;
        }
        var ut = h(2449);
        c().util.Long = p(), c().configure();
        var St = c().Root.fromJSON({ nested: { easemob: { nested: { pb: { nested: { MessageBody: { fields: { type: { type: "Type", id: 1 }, from: { type: "JID", id: 2 }, to: { type: "JID", id: 3 }, contents: { rule: "repeated", type: "Content", id: 4 }, ext: { rule: "repeated", type: "KeyValue", id: 5 }, ackMessageId: { type: "uint64", id: 6 }, msgConfig: { type: "MessageConfig", id: 7 }, ackContent: { type: "string", id: 8 }, meta: { type: "string", id: 9 }, editMessageId: { type: "uint64", id: 11 } }, nested: { Content: { fields: { type: { type: "Type", id: 1 }, text: { type: "string", id: 2 }, latitude: { type: "double", id: 3 }, longitude: { type: "double", id: 4 }, address: { type: "string", id: 5 }, displayName: { type: "string", id: 6 }, remotePath: { type: "string", id: 7 }, secretKey: { type: "string", id: 8 }, fileLength: { type: "int32", id: 9 }, action: { type: "string", id: 10 }, params: { rule: "repeated", type: "KeyValue", id: 11 }, duration: { type: "int32", id: 12 }, size: { type: "Size", id: 13 }, thumbnailRemotePath: { type: "string", id: 14 }, thumbnailSecretKey: { type: "string", id: 15 }, thumbnailDisplayName: { type: "string", id: 16 }, thumbnailFileLength: { type: "int32", id: 17 }, thumbnailSize: { type: "Size", id: 18 }, customEvent: { type: "string", id: 19 }, customExts: { rule: "repeated", type: "KeyValue", id: 20 }, buildingName: { type: "string", id: 21 }, subType: { type: "SubType", id: 22 }, title: { type: "string", id: 23 }, summary: { type: "string", id: 24 }, combineLevel: { type: "int32", id: 25 } }, nested: { Type: { values: { TEXT: 0, IMAGE: 1, VIDEO: 2, LOCATION: 3, VOICE: 4, FILE: 5, COMMAND: 6, CUSTOM: 7, COMBINE: 8 } }, Size: { fields: { width: { type: "double", id: 1 }, height: { type: "double", id: 2 } } }, SubType: { values: { COMBINE: 0 } } } }, Type: { values: { NORMAL: 0, CHAT: 1, GROUPCHAT: 2, CHATROOM: 3, READ_ACK: 4, DELIVER_ACK: 5, RECALL: 6, CHANNEL_ACK: 7, EDIT: 8 } }, MessageConfig: { fields: { allowGroupAck: { type: "bool", id: 1 } } } } }, KeyValue: { oneofs: { value: { oneof: ["varintValue", "floatValue", "doubleValue", "stringValue"] } }, fields: { key: { type: "string", id: 1 }, type: { type: "ValueType", id: 2 }, varintValue: { type: "int64", id: 3 }, floatValue: { type: "float", id: 4 }, doubleValue: { type: "double", id: 5 }, stringValue: { type: "string", id: 6 } }, nested: { ValueType: { values: { BOOL: 1, INT: 2, UINT: 3, LLINT: 4, FLOAT: 5, DOUBLE: 6, STRING: 7, JSON_STRING: 8 } } } }, JID: { fields: { appKey: { type: "string", id: 1 }, name: { type: "string", id: 2 }, domain: { type: "string", id: 3 }, clientResource: { type: "string", id: 4 } } }, ConferenceBody: { fields: { sessionId: { type: "string", id: 1 }, operation: { type: "Operation", id: 2 }, conferenceId: { type: "string", id: 3 }, type: { type: "Type", id: 4 }, content: { type: "string", id: 5 }, network: { type: "string", id: 6 }, version: { type: "string", id: 7 }, identity: { type: "Identity", id: 8 }, duration: { type: "string", id: 9 }, peerName: { type: "string", id: 10 }, endReason: { type: "EndReason", id: 11 }, status: { type: "Status", id: 12 }, isDirect: { type: "bool", id: 13 }, controlType: { type: "StreamControlType", id: 14 }, routeFlag: { type: "int32", id: 15 }, routeKey: { type: "string", id: 16 } }, nested: { Status: { fields: { errorCode: { type: "int32", id: 1 } } }, Operation: { values: { JOIN: 0, INITIATE: 1, ACCEPT_INITIATE: 2, ANSWER: 3, TERMINATE: 4, REMOVE: 5, STREAM_CONTROL: 6, MEDIA_REQUEST: 7 } }, Type: { values: { VOICE: 0, VIDEO: 1 } }, Identity: { values: { CALLER: 0, CALLEE: 1 } }, EndReason: { values: { HANGUP: 0, NORESPONSE: 1, REJECT: 2, BUSY: 3, FAIL: 4, UNSUPPORTED: 5, OFFLINE: 6 } }, StreamControlType: { values: { PAUSE_VOICE: 0, RESUME_VOICE: 1, PAUSE_VIDEO: 2, RESUME_VIDEO: 3 } } } }, MSync: { fields: { version: { type: "Version", id: 1, options: { default: "MSYNC_V1" } }, guid: { type: "JID", id: 2 }, auth: { type: "string", id: 3 }, compressAlgorimth: { type: "uint32", id: 4 }, crypto: { type: "uint32", id: 5 }, userAgent: { type: "string", id: 6 }, pov: { type: "uint64", id: 7 }, command: { type: "Command", id: 8 }, deviceId: { type: "uint32", id: 10 }, encryptType: { rule: "repeated", type: "EncryptType", id: 11, options: { packed: !1 } }, encryptKey: { type: "string", id: 12 }, payload: { type: "bytes", id: 9 } }, nested: { Version: { values: { MSYNC_V1: 0, MSYNC_V2: 1 } }, Command: { values: { SYNC: 0, UNREAD: 1, NOTICE: 2, PROVISION: 3 } } } }, EncryptType: { values: { ENCRYPT_NONE: 0, ENCRYPT_AES_128_CBC: 1, ENCRYPT_AES_256_CBC: 2 } }, CommSyncUL: { fields: { meta: { type: "Meta", id: 1 }, key: { type: "uint64", id: 2 }, queue: { type: "JID", id: 3 }, isRoam: { type: "bool", id: 4 }, lastFullRoamKey: { type: "uint64", id: 5 } } }, CommSyncDL: { fields: { status: { type: "Status", id: 1 }, metaId: { type: "uint64", id: 2 }, serverId: { type: "uint64", id: 3 }, metas: { rule: "repeated", type: "Meta", id: 4 }, nextKey: { type: "uint64", id: 5 }, queue: { type: "JID", id: 6 }, isLast: { type: "bool", id: 7 }, timestamp: { type: "uint64", id: 8 }, isRoam: { type: "bool", id: 9 } } }, CommNotice: { fields: { queue: { type: "JID", id: 1 } } }, CommUnreadUL: { fields: {} }, CommUnreadDL: { fields: { status: { type: "Status", id: 1 }, unread: { rule: "repeated", type: "MetaQueue", id: 2 }, timestamp: { type: "uint64", id: 3 } } }, MetaQueue: { fields: { queue: { type: "JID", id: 1 }, n: { type: "uint32", id: 2 } } }, Meta: { fields: { id: { type: "uint64", id: 1 }, from: { type: "JID", id: 2 }, to: { type: "JID", id: 3 }, timestamp: { type: "uint64", id: 4 }, ns: { type: "NameSpace", id: 5 }, payload: { type: "bytes", id: 6 }, routetype: { type: "RouteType", id: 7 }, ext: { rule: "repeated", type: "KeyValue", id: 8 }, meta: { type: "bytes", id: 9 }, directedUsers: { rule: "repeated", type: "string", id: 10 } }, nested: { NameSpace: { values: { STATISTIC: 0, CHAT: 1, MUC: 2, ROSTER: 3, CONFERENCE: 4, NOTIFY: 5, QUERY: 6 } }, RouteType: { values: { ROUTE_ALL: 0, ROUTE_ONLINE: 1, ROUTE_DIRECT: 2 } } } }, Status: { fields: { errorCode: { type: "ErrorCode", id: 1 }, reason: { type: "string", id: 2 }, redirectInfo: { rule: "repeated", type: "RedirectInfo", id: 3 } }, nested: { ErrorCode: { values: { OK: 0, FAIL: 1, UNAUTHORIZED: 2, MISSING_PARAMETER: 3, WRONG_PARAMETER: 4, REDIRECT: 5, TOKEN_EXPIRED: 6, PERMISSION_DENIED: 7, NO_ROUTE: 8, UNKNOWN_COMMAND: 9, PB_PARSER_ERROR: 10, BIND_ANOTHER_DEVICE: 11, IM_FORBIDDEN: 12, TOO_MANY_DEVICES: 13, PLATFORM_LIMIT: 14, USER_MUTED: 15, ENCRYPT_DISABLE: 16, ENCRYPT_ENABLE: 17, DECRYPT_FAILURE: 18, PERMISSION_DENIED_EXTERNAL: 19 } } } }, RedirectInfo: { fields: { host: { type: "string", id: 1 }, port: { type: "uint32", id: 2 } } }, Provision: { fields: { osType: { type: "OsType", id: 1 }, version: { type: "string", id: 2 }, networkType: { type: "NetworkType", id: 3 }, appSign: { type: "string", id: 4 }, compressType: { rule: "repeated", type: "CompressType", id: 5, options: { packed: !1 } }, encryptType: { rule: "repeated", type: "EncryptType", id: 6, options: { packed: !1 } }, encryptKey: { type: "string", id: 7 }, status: { type: "Status", id: 8 }, deviceUuid: { type: "string", id: 9 }, isManualLogin: { type: "bool", id: 10 }, password: { type: "string", id: 11 }, deviceName: { type: "string", id: 12 }, resource: { type: "string", id: 13 }, auth: { type: "string", id: 14 }, serviceId: { type: "string", id: 16 }, actionVersion: { type: "string", id: 17 }, authToken: { type: "string", id: 18 }, sessionId: { type: "string", id: 20 }, reason: { type: "string", id: 21 } }, nested: { OsType: { values: { OS_IOS: 0, OS_ANDROID: 1, OS_LINUX: 2, OS_OSX: 3, OS_WIN: 4, OS_OTHER: 16 } }, NetworkType: { values: { NETWORK_NONE: 0, NETWORK_WIFI: 1, NETWORK_4G: 2, NETWORK_3G: 3, NETWORK_2G: 4, NETWORK_WIRE: 5 } }, CompressType: { values: { COMPRESS_NONE: 0, COMPRESS_ZLIB: 1 } } } }, MUCBody: { fields: { mucId: { type: "JID", id: 1 }, operation: { type: "Operation", id: 2 }, from: { type: "JID", id: 3 }, to: { rule: "repeated", type: "JID", id: 4 }, setting: { type: "Setting", id: 5 }, reason: { type: "string", id: 6 }, isChatroom: { type: "bool", id: 7 }, status: { type: "Status", id: 8 }, isThread: { type: "bool", id: 9 }, mucParentId: { type: "JID", id: 10 }, mucName: { type: "string", id: 11 }, eventInfo: { type: "EventInfo", id: 12 }, mucMemberCount: { type: "int32", id: 13 }, ext: { type: "string", id: 14 }, leaveOtherRooms: { type: "bool", id: 15 } }, nested: { Operation: { values: { CREATE: 0, DESTROY: 1, JOIN: 2, LEAVE: 3, APPLY: 4, APPLY_ACCEPT: 5, APPLY_DECLINE: 6, INVITE: 7, INVITE_ACCEPT: 8, INVITE_DECLINE: 9, KICK: 10, GET_BLACKLIST: 11, BAN: 12, ALLOW: 13, UPDATE: 14, BLOCK: 15, UNBLOCK: 16, PRESENCE: 17, ABSENCE: 18, DIRECT_JOINED: 19, ASSIGN_OWNER: 20, ADD_ADMIN: 21, REMOVE_ADMIN: 22, ADD_MUTE: 23, REMOVE_MUTE: 24, UPDATE_ANNOUNCEMENT: 25, DELETE_ANNOUNCEMENT: 26, UPLOAD_FILE: 27, DELETE_FILE: 28, ADD_USER_WHITE_LIST: 29, REMOVE_USER_WHITE_LIST: 30, BAN_GROUP: 31, REMOVE_BAN_GROUP: 32, THREAD_CREATE: 33, THREAD_DESTROY: 34, THREAD_JOIN: 35, THREAD_LEAVE: 36, THREAD_KICK: 37, THREAD_UPDATE: 38, THREAD_PRESENCE: 39, THREAD_ABSENCE: 40, DISABLE_GROUP: 41, ABLE_GROUP: 42, SET_METADATA: 43, DELETE_METADATA: 44, GROUP_MEMBER_METADATA_UPDATE: 45 } }, Setting: { fields: { name: { type: "string", id: 1 }, desc: { type: "string", id: 2 }, type: { type: "Type", id: 3 }, maxUsers: { type: "int32", id: 4 }, owner: { type: "string", id: 5 } }, nested: { Type: { values: { PRIVATE_OWNER_INVITE: 0, PRIVATE_MEMBER_INVITE: 1, PUBLIC_JOIN_APPROVAL: 2, PUBLIC_JOIN_OPEN: 3, PUBLIC_ANONYMOUS: 4 } } } }, Status: { fields: { errorCode: { type: "ErrorCode", id: 1 }, description: { type: "string", id: 2 } }, nested: { ErrorCode: { values: { OK: 0, PERMISSION_DENIED: 1, WRONG_PARAMETER: 2, MUC_NOT_EXIST: 3, USER_NOT_EXIST: 4, UNKNOWN: 5 } } } }, EventInfo: { fields: { eventType: { type: "EventType", id: 1, options: { default: "EVENT_NONE" } }, ext: { type: "string", id: 2 } }, nested: { EventType: { values: { EVENT_NONE: 0, CIRCLE_CHANNEL: 1 } } } } } }, RosterBody: { fields: { operation: { type: "Operation", id: 1 }, status: { type: "Status", id: 2 }, from: { type: "JID", id: 3 }, to: { rule: "repeated", type: "JID", id: 4 }, reason: { type: "string", id: 5 }, rosterVer: { type: "string", id: 6 }, biDirection: { type: "bool", id: 7 } }, nested: { Operation: { values: { GET_ROSTER: 0, GET_BLACKLIST: 1, ADD: 2, REMOVE: 3, ACCEPT: 4, DECLINE: 5, BAN: 6, ALLOW: 7, REMOTE_ACCEPT: 8, REMOTE_DECLINE: 9 } }, Status: { fields: { errorCode: { type: "ErrorCode", id: 1 }, description: { type: "string", id: 2 } }, nested: { ErrorCode: { values: { OK: 0, USER_NOT_EXIST: 1, USER_ALREADY_FRIEND: 2, USER_ALREADY_BLACKLIST: 3 } } } } } }, StatisticsBody: { fields: { operation: { type: "Operation", id: 1 }, os: { type: "OsType", id: 2 }, version: { type: "string", id: 3 }, network: { type: "NetworkType", id: 4 }, imTime: { type: "uint32", id: 5 }, chatTime: { type: "uint32", id: 6 }, location: { type: "string", id: 7 }, reason: { type: "string", id: 10 } }, nested: { Operation: { values: { INFORMATION: 0, USER_REMOVED: 1, USER_LOGIN_ANOTHER_DEVICE: 2, USER_KICKED_BY_CHANGE_PASSWORD: 3, USER_KICKED_BY_OTHER_DEVICE: 4 } }, OsType: { values: { OS_IOS: 0, OS_ANDROID: 1, OS_LINUX: 2, OS_OSX: 3, OS_WIN: 4, OS_OTHER: 16 } }, NetworkType: { values: { NETWORK_NONE: 0, NETWORK_WIFI: 1, NETWORK_4G: 2, NETWORK_3G: 3, NETWORK_2G: 4, NETWORK_WIRE: 5 } } } } } } } } } });
        Rt.prototype.root = St;
        var Ft = O.kg.getLogger("defaultLogger");
        Ft.setConfig({ useCache: !1, maxCache: 3145728, color: "", background: "" }), Ft.enableAll(), Rt.prototype._getSock = function() {
          if (this.isHttpDNS) {
            var ze = this.socketHost[this.hostIndex];
            if (!ze) throw this.times = 1, this.autoReconnectNumTotal = 0, this.hostIndex = 0, this.onClosed && this.onClosed(), new Error("No connected domain name when get websocket.");
            var Ne = ze.domain, le = ze.ip, X = "", re = ze.port;
            X = Ne || le, re && re !== "80" && re !== "443" && (X += ":" + re), X && (this.url = "//" + X + "/ws");
            var Me = this.https ? "https:" : "http:";
            this.url = Me + this.url;
          }
          return new (v())(this.url, null, { timeout: 3e4 });
        }, Rt.prototype.getUniqueId = E.P6.getUniqueId;
        var Ht = { connection: Rt, message: ut.Message, utils: E.P6, logger: Ft, statusCode: g.E };
        typeof window < "u" && (window.WebIM = Ht);
        var zt = Ht;
      }(), b;
    }();
  });
})(EX);
var KIe = EX.exports;
const _n = /* @__PURE__ */ Gl(KIe);
Math.uuid = function(t, r) {
  var a = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""), u = a, h = [], b;
  if (r = r || u.length, t)
    for (b = 0; b < t; b++)
      h[b] = u[0 | Math.random() * r];
  else {
    var l;
    for (h[8] = h[13] = h[18] = h[23] = "-", h[14] = "4", b = 0; b < 36; b++)
      h[b] || (l = 0 | Math.random() * 16, h[b] = u[b == 19 ? l & 3 | 8 : l]);
  }
  return h.join("");
};
function JIe(t, r, a) {
  var u = function(c) {
    var d = "";
    return c >= 0 && c < 10 ? d = "0" + c : d = c + "", d;
  }, h = "", b = u(t), l = u(r), v = u(a);
  return h = b == "00" ? l + ":" + v : b + ":" + l + ":" + v, h;
}
var yX = function(r, a, u, h) {
  var b = {
    chatType: r,
    type: "txt",
    to: a,
    msg: u,
    ext: h
  }, l = _n.message.create(b);
  if (_n.conn.send(l), h.type === 0 || h.type === 1) {
    var v = hi.dispatch;
    _n.rtc.timer && clearTimeout(_n.rtc.timer), _n.rtc.timer = setTimeout(function() {
      console.warn("caller timeout"), Ji.hangup("timeout", !0), v(Ki(Qn.idle));
    }, 3e4);
  }
}, ZIe = function(r, a, u) {
  hi.getState;
  var h = hi.dispatch, b = _n.conn.getUniqueId(), l = new _n.message("cmd", b);
  if (!r) {
    console.error("to is undefined when send alerting.");
    return;
  }
  l.set({
    to: r,
    action: "rtcCall",
    ext: {
      action: "alert",
      calleeDevId: _n.conn.context.jid.clientResource,
      callerDevId: a,
      callId: u,
      ts: Date.now(),
      msgType: "rtcCallWithAgora"
    },
    success: function(s, c) {
      h(Ki(Qn.alerting));
    },
    fail: function(s) {
      console.warn("callee send alert fail", l);
    }
  }), _n.conn.send(l.body), _n.rtc.timer && clearTimeout(_n.rtc.timer), _n.rtc.timer = setTimeout(function() {
    console.warn("callee timeout"), Ji.hangup("timeout"), h(Ki(Qn.idle));
  }, 3e4);
}, QIe = function(r, a, u, h) {
  var b = hi.getState, l = hi.dispatch, v = b().confr, s = v.callId, c = !0;
  if (h !== s && (console.warn("not current call", h, s), c = !1), b().callStatus > Qn.receivedConfirmRing && ![2, 3].includes(v.type) && (console.warn("caller is busy", v), c = !1), u !== _n.conn.context.jid.clientResource) {
    console.warn("caller device is different");
    return;
  }
  var d = _n.conn.getUniqueId(), p = new _n.message("cmd", d);
  p.set({
    to: r,
    action: "rtcCall",
    ext: {
      action: "confirmRing",
      status: c,
      callerDevId: _n.conn.context.jid.clientResource,
      calleeDevId: a,
      callId: h,
      ts: Date.now(),
      msgType: "rtcCallWithAgora"
    },
    success: function(E, y) {
      c && b().callStatus < Qn.confirmRing && l(Ki(Qn.confirmRing));
    },
    fail: function(E) {
      console.warn("caller send confirmRing fail", p);
    }
  }), _n.conn.send(p.body);
}, Mm = function(r, a) {
  var u = hi.getState;
  hi.dispatch, a = a || {};
  var h = _n.conn.getUniqueId(), b = new _n.message("cmd", h), l = a.currentCallId || u().confr.callId, v = a.callerDevId || u().confr.callerDevId, s = a.to || u().confr.callerIMName;
  b.set({
    to: s,
    action: "rtcCall",
    ext: {
      action: "answerCall",
      result: r,
      // busy/accept/refuse
      callerDevId: v,
      calleeDevId: _n.conn.context.jid.clientResource,
      callId: l,
      ts: Date.now(),
      msgType: "rtcCallWithAgora"
    },
    success: function(d, p) {
    },
    fail: function(d) {
      console.warn("callee send answerCall fail", b);
    }
  }), _n.conn.send(b.body);
}, T2 = function(r, a, u) {
  var h = hi.getState, b = hi.dispatch, l = _n.conn.getUniqueId(), v = new _n.message("cmd", l), s = h().confr, c = s.callId;
  !s.calleeDevId && ![2, 3].includes(s.type) ? b(fh({
    to: s.confrName,
    ext: {
      channelName: s.channel,
      token: s.token,
      type: s.type,
      callerDevId: s.callerDevId,
      calleeDevId: a,
      callId: s.callId,
      calleeIMName: s.calleeIMName,
      callerIMName: s.callerIMName
    }
  })) : s.calleeDevId != a && ![2, 3].includes(s.type) && (u = "refuse"), v.set({
    to: r,
    action: "rtcCall",
    ext: {
      action: "confirmCallee",
      result: u || "accept",
      // busy/accept/refuse
      callerDevId: _n.conn.context.jid.clientResource,
      calleeDevId: a,
      callId: c,
      ts: Date.now(),
      msgType: "rtcCallWithAgora"
    },
    success: function(p, m) {
      u == "accept" && b(Ki(Qn.confirmCallee));
    },
    fail: function(p) {
      console.warn("caller send confirmCallee fail", v);
    }
  }), _n.conn.send(v.body);
}, HB = function(r) {
  var a = hi.getState, u = _n.conn.getUniqueId(), h = new _n.message("cmd", u), b = a().confr.callerDevId, l = r || a().confr.calleeIMName, v = a().confr.callId;
  if (!l) {
    console.warn("send cancelCall fail, to is undefined");
    return;
  }
  h.set({
    to: l,
    action: "rtcCall",
    ext: {
      action: "cancelCall",
      callerDevId: b,
      callId: v,
      ts: Date.now(),
      msgType: "rtcCallWithAgora"
    },
    success: function(c, d) {
    },
    fail: function(c) {
      console.warn("caller send canlcel fail", h);
    }
  }), _n.conn.send(h.body);
}, $Ie = function() {
  var r = hi.getState, a = hi.dispatch;
  _n.conn.addEventHandler("message", {
    onTextMessage: function(h) {
      if (h.chatType === "singleChat") {
        var b = r(), l = b.conf, v = b.callStatus, s = h.from, c = h.to;
        if (h.ext && h.ext.action === "invite") {
          if (h.from == _n.conn.context.jid.name)
            return;
          if (h.chatType == "singleChat")
            v > Qn.idle ? Mm("busy", {
              currentCallId: h.ext.callId,
              callerDevId: h.ext.callerDevId,
              to: s
            }) : (h.ext.calleeIMName = h.to, h.ext.callerIMName = h.from, a(fh(h)), a(Ki(Qn.alerting)));
          else {
            var d = h.ext;
            v > Qn.idle && (d.callId == l.callId ? a(Ki(Qn.alerting)) : Mm("busy", {
              currentCallId: d.callId,
              callerDevId: d.callerDevId,
              to: s
            })), d.calleeIMName = _n.conn.context.jid.name, d.callerIMName = s, a(fh({
              from: s,
              to: c,
              ext: d
            })), a(Ki(Qn.alerting));
          }
        }
      }
    },
    onCmdMessage: function(h) {
      if (h.action === "rtcCall") {
        var b = h.ext, l = "", v = "", s = "", c = hi.getState();
        switch (b.action) {
          case "invite":
            return;
          case "alert":
            l = b.calleeDevId, v = b.callerDevId, s = b.callId, QIe(h.from, l, v, s);
            break;
          case "confirmRing":
            if (b.calleeDevId != _n.conn.context.jid.clientResource)
              return;
            if (!b.status && c.callStatus < Qn.receivedConfirmRing) {
              console.warn("The invitation has expired", b), a(Ki(Qn.idle)), Ji.hangup("invitation has expired"), _n.rtc.timer && clearTimeout(_n.rtc.timer);
              return;
            }
            l = b.calleeDevId, a(Ki(Qn.receivedConfirmRing));
            break;
          case "answerCall":
            if (_n.rtc.timer && clearTimeout(_n.rtc.timer), l = b.calleeDevId, b.callerDevId != _n.conn.context.jid.clientResource)
              return h.from == _n.conn.context.jid.name ? (b.result === "accept" ? Ji.hangup("accepted on other devices") : b.result === "refuse" && Ji.hangup("refused on other devices"), a(Ki(Qn.idle)), _n.rtc.timer && clearTimeout(_n.rtc.timer), console.warn("processed on other devices")) : void 0;
            if (b.result !== "accept")
              if (b.result === "busy" ? console.warn("target is busy") : b.result === "refuse" && console.error("the target has refused"), [2, 3].includes(c.confr.type))
                T2(h.from, l, "refuse");
              else {
                T2(h.from, l, b.result);
                var d = b.result == "busy" ? "busy" : "refused";
                Ji.hangup(d), a(Ki(Qn.idle));
              }
            else
              T2(h.from, l, b.result);
            break;
          case "confirmCallee":
            if (b.calleeDevId != _n.conn.context.jid.clientResource && c.callStatus !== 7) {
              Ji.hangup("processed on other devices"), a(Ki(Qn.idle)), _n.rtc.timer && clearTimeout(_n.rtc.timer);
              return;
            }
            if (h.ext.result != "accept" && c.callStatus !== 7) {
              c.callStatus !== 0 && (Ji.hangup(h.ext.result), a(Ki(Qn.idle))), _n.rtc.timer && clearTimeout(_n.rtc.timer);
              return;
            }
            a(Ki(Qn.confirmCallee));
            break;
          case "cancelCall":
            if (h.from == _n.conn.context.jid.name)
              return;
            h.from == c.confr.callerIMName && (Ji.hangup("cancel"), a(Ki(Qn.idle)));
            break;
          default:
            console.warn("unexpected action " + h.action);
            break;
        }
      }
    }
  });
};
function BB(t, r, a, u, h, b, l) {
  try {
    var v = t[b](l), s = v.value;
  } catch (c) {
    a(c);
    return;
  }
  v.done ? r(s) : Promise.resolve(s).then(u, h);
}
function zB(t) {
  return function() {
    var r = this, a = arguments;
    return new Promise(function(u, h) {
      var b = t.apply(r, a);
      function l(s) {
        BB(b, u, h, l, v, "next", s);
      }
      function v(s) {
        BB(b, u, h, l, v, "throw", s);
      }
      l(void 0);
    });
  };
}
function Bb() {
  return Bb = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a)
        Object.prototype.hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, Bb.apply(this, arguments);
}
var Yp = Hb.createClient({
  mode: "live",
  codec: "h264"
});
Yp.setClientRole("host");
var eRe = /* @__PURE__ */ function() {
  function t(a) {
    a && this.init(a), this.client = Yp, this.props = {}, this.callId = "", _n.rtc = this.rtc = {
      client: Yp,
      localAudioTrack: null,
      localVideoTrack: null,
      timer: null
    };
  }
  var r = t.prototype;
  return r.init = function(u, h, b) {
    this.appId = u, this.agoraUid = h, _n.conn = b, $Ie();
  }, r.setCallKitProps = function(u) {
    this.props = u;
  }, r.changeState = function(u) {
    this.props.onStateChange && this.props.onStateChange(u);
  }, r.setToken = function(u) {
    this.accessToken = u;
  }, r.setUserIdMap = function(u) {
    hi.getState;
    var h = hi.dispatch;
    h(VSe(u));
  }, r.setUserInfo = function(u) {
    var h = hi.getState, b = hi.dispatch, l = h();
    b(IB(Bb({}, l.userInfo, u)));
  }, r.answerCall = function(u, h) {
    var b = hi.getState;
    hi.dispatch;
    var l = b(), v = l.confr;
    if (u)
      this.accessToken = h, ZIe(v.callerIMName, v.callerDevId, v.callId);
    else {
      var s = hi.dispatch;
      s(Ki(Qn.idle));
    }
  }, r.startCall = function(u) {
    var h = hi.getState, b = hi.dispatch, l = h(), v = u.callId, s = u.channel, c = u.chatType, d = u.callType, p = u.to, m = u.message, E = u.groupId, y = u.groupName, g = u.accessToken;
    this.accessToken = g, l.confr.callId && l.callStatus > 0 && (s = l.confr.channel, v = l.confr.callId, d = l.confr.type);
    var C = {
      action: "invite",
      channelName: s,
      type: d,
      //0 1v1 audio，1 1v1 video，2 multi video 3 multi audio
      callerDevId: _n.conn.context.jid.clientResource,
      callId: v,
      ts: Date.now(),
      msgType: "rtcCallWithAgora",
      callerIMName: _n.conn.context.jid.name,
      // for ios push
      chatType: d,
      em_push_ext: {
        type: "call",
        custom: {
          callId: v
        }
      },
      em_apns_ext: {
        em_push_type: "voip"
      }
    }, O = {
      channelName: s,
      token: null,
      type: d,
      callerDevId: _n.conn.context.jid.clientResource,
      callId: v,
      calleeIMName: p,
      callerIMName: _n.conn.context.jid.name
    };
    if (this.callId = v, d === 2 || d === 3) {
      C.ext = {
        groupId: E,
        groupName: y
      }, O.ext = {
        groupId: E,
        groupName: y
      };
      var N = l.invitedMembers;
      N.includes(p) || b(RB([].concat(N, [p])));
    }
    c === "groupChat" || yX(c, p, m, C), b(fh({
      ext: O,
      to: p,
      from: _n.conn.context.jid.name
    })), l.callStatus < Qn.inviting && b(Ki(Qn.inviting));
  }, r.join = /* @__PURE__ */ function() {
    var a = zB(/* @__PURE__ */ vc.mark(function h() {
      var b, l, v, s, c, d, p, m, E, y, g;
      return vc.wrap(function(O) {
        for (; ; )
          switch (O.prev = O.next) {
            case 0:
              if (b = hi.getState, l = hi.dispatch, v = b(), v.callStatus !== Qn.confirmCallee) {
                O.next = 4;
                break;
              }
              return O.abrupt("return");
            case 4:
              return s = v.confr, c = _n.conn.context.userId, O.next = 8, Yp.join(this.appId, s.channel, this.accessToken, Number(this.agoraUid));
            case 8:
              return d = O.sent, O.next = 11, Hb.createMicrophoneAudioTrack();
            case 11:
              if (p = O.sent, this.rtc.localAudioTrack = p, m = [p], E = c, v.uid2userId[d] ? E = v.uid2userId[d] : v.uid2userId[c] && (E = v.uid2userId[c]), !(s.type === 0 || s.type === 3)) {
                O.next = 22;
                break;
              }
              return O.next = 19, Yp.publish(m);
            case 19:
              l(Kc({
                videoElm: null,
                name: E,
                type: "audio",
                value: d,
                action: "add",
                audio: !0,
                video: !1,
                isSelf: !0
              })), O.next = 32;
              break;
            case 22:
              return O.next = 24, Hb.createCameraVideoTrack();
            case 24:
              return y = O.sent, m.push(y), this.rtc.localVideoTrack = y, O.next = 29, Yp.publish(m);
            case 29:
              g = s.type === 2 ? "video" + d : "local-player", l(Kc({
                videoElm: g,
                name: E,
                type: "video",
                value: d,
                action: "add",
                audio: !0,
                video: !0,
                isSelf: !0
              })), setTimeout(function() {
                y.play(g);
              }, 500);
            case 32:
              this.startTime();
            case 33:
            case "end":
              return O.stop();
          }
      }, h, this);
    }));
    function u() {
      return a.apply(this, arguments);
    }
    return u;
  }(), r.startTime = function() {
    var u = hi.dispatch, h = 0, b = 0, l = 0;
    this.rtc.intervalTimer && clearInterval(_n.rtc.intervalTimer);
    var v = setInterval(function() {
      l += 1, l === 60 && (l = 0, b += 1, b === 60 && (b = 0, h += 1, h == 24 && (h = 0)));
      var s = JIe(h, b, l);
      u(SB(s));
    }, 1e3);
    this.rtc.intervalTimer = v;
  }, r.hangup = /* @__PURE__ */ function() {
    var a = zB(/* @__PURE__ */ vc.mark(function h(b, l) {
      var v, s, c, d;
      return vc.wrap(function(m) {
        for (; ; )
          switch (m.prev = m.next) {
            case 0:
              if (this.rtc.localAudioTrack && this.rtc.localAudioTrack.close(), this.rtc.localVideoTrack && this.rtc.localVideoTrack.close(), this.rtc.intervalTimer && clearInterval(this.rtc.intervalTimer), v = hi.getState, s = hi.dispatch, c = v(), d = c.confr, l && d.callerIMName == _n.conn.context.jid.name && (d.type == 2 || d.type == 3 ? c.invitedMembers.forEach(function(E) {
                HB(E);
              }) : HB()), this.props.onStateChange && this.props.onStateChange({
                type: "hangup",
                reason: b,
                callInfo: Bb({}, c.confr, {
                  duration: c.callDuration,
                  groupId: c.groupId,
                  groupName: c.groupName
                })
              }), this.callId = "", m.t0 = this.rtc.client, !m.t0) {
                m.next = 13;
                break;
              }
              return m.next = 13, this.rtc.client.leave();
            case 13:
              s(Ki(Qn.idle)), s(SB("00:00")), s(Ub("normal")), s(Kc([])), s(RB([])), s(fh({
                to: "",
                ext: {}
              })), s(IB({}));
            case 20:
            case "end":
              return m.stop();
          }
      }, h, this);
    }));
    function u(h, b) {
      return a.apply(this, arguments);
    }
    return u;
  }(), t;
}(), Ji = new eRe();
function FB(t, r, a, u, h, b, l) {
  try {
    var v = t[b](l), s = v.value;
  } catch (c) {
    a(c);
    return;
  }
  v.done ? r(s) : Promise.resolve(s).then(u, h);
}
function tRe(t) {
  return function() {
    var r = this, a = arguments;
    return new Promise(function(u, h) {
      var b = t.apply(r, a);
      function l(s) {
        FB(b, u, h, l, v, "next", s);
      }
      function v(s) {
        FB(b, u, h, l, v, "throw", s);
      }
      l(void 0);
    });
  };
}
function nRe(t) {
  var r = t.targetInfo, a = t.myInfo, u = Ja(function(s) {
    return s;
  }), h = tn(!0), b = h[0], l = h[1], v = function() {
    l(function() {
      return !b;
    });
  };
  return /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-single-videobox"
  }, /* @__PURE__ */ _t.createElement("div", {
    id: "local-player",
    className: b ? "callkit-single-video-self" : "callkit-single-video-target",
    onClick: v
  }, /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-single-video-info",
    style: {
      display: u.callStatus >= Qn.confirmCallee && a.isCloseCamera ? "flex" : "none"
    }
  }, a.avatar, /* @__PURE__ */ _t.createElement("div", null, a.userName))), /* @__PURE__ */ _t.createElement("div", {
    style: {
      visibility: u.callStatus >= Qn.confirmCallee ? "visible" : "hidden"
    },
    id: "remote-player",
    className: b ? "callkit-single-video-target" : "callkit-single-video-self",
    onClick: v
  }, /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-single-video-info",
    style: {
      display: u.callStatus >= Qn.confirmCallee && r.isCloseCamera ? "flex" : "none"
    }
  }, r.avatar, /* @__PURE__ */ _t.createElement("div", null, r.userName))));
}
function rRe(t) {
  var r, a, u = Zn(Sh), h = t.style, b = tn(!1), l = b[0], v = b[1], s = tn(!1), c = s[0], d = s[1], p = tn(!1), m = p[0], E = p[1], y = Ja(function(Ce) {
    return Ce;
  }), g = DA(), C = u.contactAvatar, O = Ja(function(Ce) {
    return Ce.uid2userId;
  }), N = Ja(function(Ce) {
    return Ce.userInfo;
  }), w = Ji.client;
  Ji.setCallKitProps(u);
  var _ = function() {
    w.on("user-published", /* @__PURE__ */ function() {
      var _e = tRe(/* @__PURE__ */ vc.mark(function Le(Te, K) {
        var Oe, Pe, xe;
        return vc.wrap(function($e) {
          for (; ; )
            switch ($e.prev = $e.next) {
              case 0:
                return u.onStateChange && u.onStateChange({
                  type: "user-published",
                  user: Te,
                  mediaType: K
                }), O[Te.uid] ? Te.uid2userid = O[Te.uid] : Te.uid2userid = Te.uid, $e.next = 4, w.subscribe(Te, K);
              case 4:
                Oe = {}, Oe = {
                  name: Te.uid2userid,
                  videoElm: "remote-player",
                  type: K,
                  value: Te.uid,
                  action: "add",
                  audio: !0,
                  video: !0
                }, K === "video" && (Pe = Te.videoTrack, Oe.video = !0, g(Kc(Oe)), Pe.play("remote-player"), _n.rtc.remoteVideoTrack = Pe), K === "audio" && (xe = Te.audioTrack, Oe.audio = !0, g(Kc(Oe)), _n.rtc.other = Te, xe.play()), E(!1);
              case 9:
              case "end":
                return $e.stop();
            }
        }, Le);
      }));
      return function(Le, Te) {
        return _e.apply(this, arguments);
      };
    }()), w.on("user-left", function(_e, Le) {
      u.onStateChange && u.onStateChange({
        type: "user-left",
        user: _e,
        mediaType: Le
      }), k("user-left");
    }), w.on("user-unpublished", function(_e, Le) {
      u.onStateChange && u.onStateChange({
        type: "user-unpublished",
        user: _e,
        mediaType: Le
      }), E(!0);
    });
  };
  Pn(function() {
    return _(), function() {
      _n.rtc.client.removeAllListeners(), g(fh({})), g(Ki(Qn.idle)), clearTimeout(_n.rtc.timer);
    };
  }, []), Pn(function() {
    (y.callStatus === Qn.inviting || y.callStatus === Qn.answerCall) && I();
  }, [y.callStatus]);
  var I = function() {
    Ji.join();
  }, k = function(_e) {
    var Le = typeof _e == "string" ? _e : "normal";
    Ji.hangup(Le, !0), g(Ki(Qn.idle));
  }, H = function() {
    Mm("accept"), g(Ki(Qn.answerCall)), u.onStateChange && u.onStateChange({
      type: "accept",
      callInfo: y.confr
    }), clearTimeout(_n.rtc.timer);
  }, S = function() {
    Mm("refuse"), y.callStatus < Qn.confirmCallee && (Ji.hangup("refuse"), g(Ki(Qn.idle))), clearTimeout(_n.rtc.timer);
  }, B = function() {
    if (y.callStatus < Qn.confirmRing || y.callStatus === Qn.receivedConfirmRing)
      return console.warn("not joined the call yet");
    v(function(_e) {
      return !_e;
    }), _n.rtc.localAudioTrack.setEnabled(l);
  }, D = function() {
    if (y.callStatus < Qn.confirmRing || y.callStatus === Qn.receivedConfirmRing)
      return console.warn("not joined the call yet");
    d(function(Le) {
      return !Le;
    });
    var _e = !!c;
    _n.rtc.localVideoTrack.setEnabled && _n.rtc.localVideoTrack.setEnabled(_e);
  };
  function F() {
    return y.confr.type === 0 ? y.callStatus === Qn.alerting || y.callStatus === Qn.receivedConfirmRing ? /* @__PURE__ */ _t.createElement(_t.Fragment, null, /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: S
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      right: !0,
      onClick: H
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone callkit-main-button"
    }))) : /* @__PURE__ */ _t.createElement(_t.Fragment, null, l ? /* @__PURE__ */ _t.createElement(Yi, {
      className: "callkit-singleCall-slash",
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: k
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    }))) : y.callStatus === Qn.alerting || y.callStatus === Qn.receivedConfirmRing ? /* @__PURE__ */ _t.createElement(_t.Fragment, null, c ? /* @__PURE__ */ _t.createElement(Yi, {
      className: "callkit-singleCall-slash",
      circle: !0,
      onClick: D
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: D
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: S
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      right: !0,
      onClick: H
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone callkit-main-button"
    }))) : /* @__PURE__ */ _t.createElement(_t.Fragment, null, c ? /* @__PURE__ */ _t.createElement(Yi, {
      className: "callkit-singleCall-slash",
      circle: !0,
      onClick: D
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: D
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video callkit-main-button"
    })), l ? /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: B,
      className: "callkit-singleCall-slash"
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: k
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    })));
  }
  var j = y.confr.type === 0 ? !0 : y.callStatus !== 7, G = y.confr.type === 0 ? "Audio Call" : "Video Call", U = y.confr, M = U.callerIMName, V = U.calleeIMName, J = _n.conn.context.jid.name, ue = M == J ? V : M, se = ue;
  O[ue] && (se = O[ue]), se = N[se] ? N[se].nickname : se;
  var ee = N[_n.conn.user] ? N[_n.conn.user].nickname : _n.conn.user;
  y.callStatus > Qn.answerCall && y.confr.type === 0 && (G = y.callDuration);
  var de;
  if (!((r = N[se]) === null || r === void 0) && r.avatarUrl) {
    var he;
    de = /* @__PURE__ */ _t.createElement(rh, {
      src: ((he = N[se]) === null || he === void 0 ? void 0 : he.avatarUrl) || _d,
      alt: "name",
      style: {
        zIndex: 9
      }
    });
  } else
    de = typeof C == "object" ? C : /* @__PURE__ */ _t.createElement(rh, {
      src: C || _d,
      alt: "name",
      style: {
        zIndex: 9
      }
    });
  var pe = /* @__PURE__ */ _t.createElement(rh, {
    src: ((a = N[_n.conn.user]) === null || a === void 0 ? void 0 : a.avatarUrl) || _d,
    alt: "name",
    style: {
      zIndex: 9
    }
  });
  return /* @__PURE__ */ _t.createElement("div", {
    style: h,
    className: "callkit-singleCall-container"
  }, j && /* @__PURE__ */ _t.createElement(_t.Fragment, null, de, /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-singleCall-username"
  }, se), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-singleCall-title"
  }, G)), G === "Video Call" && /* @__PURE__ */ _t.createElement(nRe, {
    targetInfo: {
      avatar: de,
      userName: se,
      isCloseCamera: m
    },
    myInfo: {
      isCloseCamera: c,
      avatar: pe,
      userName: ee
    }
  }), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-singleCall-control"
  }, F()));
}
function GB(t, r, a, u, h, b, l) {
  try {
    var v = t[b](l), s = v.value;
  } catch (c) {
    a(c);
    return;
  }
  v.done ? r(s) : Promise.resolve(s).then(u, h);
}
function b2(t) {
  return function() {
    var r = this, a = arguments;
    return new Promise(function(u, h) {
      var b = t.apply(r, a);
      function l(s) {
        GB(b, u, h, l, v, "next", s);
      }
      function v(s) {
        GB(b, u, h, l, v, "throw", s);
      }
      l(void 0);
    });
  };
}
var iRe = 16;
function sRe(t) {
  var r = t.text, a = t.className, u = t.id, h = t.avatarUrl, b = t.memberCount;
  Zn(Sh);
  var l = En(a, {
    "callkit-group-video-box-4": !0
  }), v = t.data, s = En({
    iconfont: !0,
    "icon-mic_slash": !0,
    "callkit-group-audio-icon2": !0,
    "display-none": v.audio
  }), c = En({
    iconfont: !0,
    "icon-video_slash": !0,
    "callkit-group-video-icon": !0,
    "display-none": v.video
  }), d = !v.video, p = En("callkit-group-video-name", {
    "callkit-group-video-name-left": !d && v.isSelf && b <= 2
  });
  return /* @__PURE__ */ _t.createElement("div", {
    className: l,
    id: u
  }, d && /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-group-video-avatar-box"
  }, /* @__PURE__ */ _t.createElement(rh, {
    src: h || _d,
    className: "callkit-group-audio-avatar"
  })), /* @__PURE__ */ _t.createElement("span", {
    className: p
  }, r), /* @__PURE__ */ _t.createElement(ei, {
    className: s
  }), /* @__PURE__ */ _t.createElement(ei, {
    className: c
  }));
}
function aRe(t) {
  var r = t.active, a = t.text, u = t.mute, h = t.avatarUrl;
  Zn(Sh);
  var b = En({
    "callkit-group-audio-avatar": !0,
    "callkit-group-audio-active": r
  }), l = En({
    iconfont: !0,
    "icon-mic_slash": !0,
    "callkit-group-audio-icon": !0,
    "display-none": !u
  });
  return /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-group-audio-container"
  }, /* @__PURE__ */ _t.createElement(rh, {
    src: h || _d,
    alt: "name",
    className: b
  }, a), /* @__PURE__ */ _t.createElement(ei, {
    className: l
  }), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-group-audio-username"
  }, a));
}
function oRe(t) {
  var r = Zn(Sh), a = tn(!1), u = a[0], h = a[1], b = tn(!1), l = b[0], v = b[1], s = tn([]), c = s[0], d = s[1], p = Ja(function(U) {
    return U;
  }), m = Ja(function(U) {
    return U.uid2userId;
  }), E = Ja(function(U) {
    return U.userInfo;
  }), y = DA(), g = _n.conn.context.userId, C = r.groupAvatar;
  function O() {
    return p.confr.type === 3 ? p.callStatus === 2 || p.callStatus === 4 ? /* @__PURE__ */ _t.createElement(_t.Fragment, null, /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: H
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      right: !0,
      onClick: k
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone callkit-main-button"
    }))) : /* @__PURE__ */ _t.createElement(_t.Fragment, null, u ? /* @__PURE__ */ _t.createElement(Yi, {
      className: "callkit-singleCall-slash",
      circle: !0,
      onClick: S
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: S
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: I
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    }))) : p.callStatus === 2 || p.callStatus === 4 ? /* @__PURE__ */ _t.createElement(_t.Fragment, null, l ? /* @__PURE__ */ _t.createElement(Yi, {
      className: "callkit-singleCall-slash",
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: H
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      right: !0,
      onClick: k
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone callkit-main-button"
    }))) : /* @__PURE__ */ _t.createElement(_t.Fragment, null, l ? /* @__PURE__ */ _t.createElement(Yi, {
      className: "callkit-singleCall-slash",
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: B
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-video callkit-main-button"
    })), u ? /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: S,
      className: "callkit-singleCall-slash"
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic_slash callkit-main-button"
    })) : /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      onClick: S
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-mic callkit-main-button"
    })), /* @__PURE__ */ _t.createElement(Yi, {
      circle: !0,
      danger: !0,
      onClick: I
    }, /* @__PURE__ */ _t.createElement(ei, {
      className: "iconfont icon-phone_down callkit-main-button"
    })));
  }
  Ji.setCallKitProps(r);
  function N() {
    return w.apply(this, arguments);
  }
  function w() {
    return w = b2(/* @__PURE__ */ vc.mark(function U() {
      return vc.wrap(function(V) {
        for (; ; )
          switch (V.prev = V.next) {
            case 0:
              _n.rtc.client.on("user-published", /* @__PURE__ */ function() {
                var J = b2(/* @__PURE__ */ vc.mark(function ue(se, ee) {
                  var de, he, pe, Ce, _e;
                  return vc.wrap(function(Te) {
                    for (; ; )
                      switch (Te.prev = Te.next) {
                        case 0:
                          if (de = hi.getState(), !(de.joinedMembers.length >= iRe)) {
                            Te.next = 3;
                            break;
                          }
                          return Te.abrupt("return");
                        case 3:
                          return r.onStateChange && r.onStateChange({
                            type: "user-published",
                            user: se,
                            mediaType: ee,
                            confr: de.confr
                          }), m[se.uid] ? se.uid2userid = m[se.uid] : se.uid2userid = se.uid, Te.next = 7, _n.rtc.client.subscribe(se, ee);
                        case 7:
                          he = "", pe = {}, pe = {
                            name: se.uid2userid,
                            videoElm: "video" + se.uid,
                            type: ee,
                            value: se.uid,
                            action: "add",
                            audio: !0,
                            video: !0
                          }, de.joinedMembers.forEach(function(K) {
                            K.value == se.uid && (pe = Object.assign({
                              action: "add"
                            }, K));
                          }), he = "video" + se.uid, ee === "video" && (Ce = se.videoTrack, pe.video = !0, y(Kc(pe)), setTimeout(function() {
                            Ce.play(he);
                          }, 500)), ee === "audio" && (pe.audio = !0, y(Kc(pe)), _e = se.audioTrack, _e && _e.play());
                        case 14:
                        case "end":
                          return Te.stop();
                      }
                  }, ue);
                }));
                return function(ue, se) {
                  return J.apply(this, arguments);
                };
              }()), _n.rtc.client.on("user-unpublished", function(J, ue) {
                var se = hi.getState();
                r.onStateChange && r.onStateChange({
                  type: "user-unpublished",
                  user: J,
                  mediaType: ue
                });
                var ee = [].concat(se.joinedMembers);
                ee.forEach(function(de, he) {
                  if (de.value == J.uid) {
                    var pe = Object.assign({}, de);
                    ue === "audio" ? pe.audio = !1 : pe.video = !1, ee[he] = pe;
                  }
                }), y(Kc(ee));
              }), _n.rtc.client.on("user-left", function(J, ue) {
                r.onStateChange && r.onStateChange({
                  type: "user-left",
                  user: J,
                  mediaType: ue
                });
                var se = hi.getState(), ee = se.joinedMembers.filter(function(de) {
                  return de.value !== J.uid;
                });
                y(Kc(ee));
              }), _n.rtc.client.enableAudioVolumeIndicator(), _n.rtc.client.on("volume-indicator", function(J) {
                var ue = [].concat(c);
                J.forEach(function(se, ee) {
                  var de = m[se.uid];
                  if (de) {
                    if (se.level > 1 && !ue.includes(de))
                      ue.push(de);
                    else if (se.level < 1 && ue.includes(de)) {
                      var he = ue.indexOf(de);
                      ue.splice(he, 1);
                    }
                  }
                }), d(ue);
              });
            case 5:
            case "end":
              return V.stop();
          }
      }, U);
    })), w.apply(this, arguments);
  }
  Pn(function() {
    return N(), function() {
      _n.rtc.client.removeAllListeners(), y(fh({})), y(Ki(Qn.idle)), clearTimeout(_n.rtc.timer);
    };
  }, []), Pn(function() {
    var U = [].concat(p.joinedMembers);
    U.forEach(function(M, V) {
      var J = {
        name: M.name,
        type: M.type,
        value: M.value,
        videoElm: M.videoElm,
        video: M.video,
        audio: M.audio,
        isSelf: M.isSelf
      };
      J.value in m && (J.name = m[J.value]), U[V] = J;
    }), y(Kc(U));
  }, [Object.keys(p.uid2userId).length, p.joinedMembers.length]);
  var _ = /* @__PURE__ */ function() {
    var U = b2(/* @__PURE__ */ vc.mark(function M() {
      return vc.wrap(function(J) {
        for (; ; )
          switch (J.prev = J.next) {
            case 0:
              return J.next = 2, Ji.join();
            case 2:
            case "end":
              return J.stop();
          }
      }, M);
    }));
    return function() {
      return U.apply(this, arguments);
    };
  }();
  Pn(function() {
    (p.callStatus === Qn.confirmRing || p.callStatus === Qn.answerCall) && _();
  }, [p.callStatus]);
  var I = function() {
    if (p.callStatus < Qn.confirmCallee)
      Ji.hangup("normal", !0);
    else {
      if (p.joinedMembers.length == 1 && p.confr.callerIMName == g) {
        Ji.hangup("normal", !0);
        return;
      }
      Ji.hangup("normal", !1);
    }
    y(Ki(Qn.idle));
  }, k = function() {
    Mm("accept"), y(Ki(Qn.answerCall)), r.onStateChange && r.onStateChange({
      type: "accept",
      callInfo: p.confr
    }), clearTimeout(_n.rtc.timer);
  }, H = function() {
    Mm("refuse"), p.callStatus < 7 && (Ji.hangup("refuse"), y(Ki(Qn.idle))), clearTimeout(_n.rtc.timer);
  }, S = function() {
    if (p.callStatus < Qn.confirmRing || p.callStatus === Qn.receivedConfirmRing)
      return console.warn("not joined the call yet");
    h(function(M) {
      return !M;
    }), _n.rtc.localAudioTrack.setEnabled(u);
  }, B = function() {
    if (p.callStatus < Qn.confirmRing || p.callStatus === Qn.receivedConfirmRing)
      return console.warn("not joined the call yet");
    v(function(J) {
      return !J;
    });
    var M = !!l;
    _n.rtc.localVideoTrack.setEnabled && _n.rtc.localVideoTrack.setEnabled(M);
    var V = [].concat(p.joinedMembers);
    V.forEach(function(J, ue) {
      if (J.value == Ji.agoraUid) {
        var se = Object.assign({}, J);
        se.video = M, V[ue] = se;
      }
    }), y(Kc(V));
  }, D = ![0, 3, 5, 6, 7].includes(p.callStatus), F = p.confr.type === 3 ? "Audio Call" : "Video Call", j = En({
    "callkit-groupCall-container": !0,
    "callkit-group-flex-start": p.joinedMembers.length > 6,
    "callkit-group-container-video": p.confr.type === 2
  }), G = typeof C == "object" ? C : /* @__PURE__ */ _t.createElement(rh, {
    src: C || _d,
    alt: "name",
    style: {
      zIndex: 9
    }
  });
  return /* @__PURE__ */ _t.createElement("div", {
    className: j
  }, D && /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-group-avatar"
  }, G, /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-singleCall-username"
  }, p.groupName), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-singleCall-title"
  }, F)), p.confr.type === 3 && p.joinedMembers.map(function(U) {
    var M, V, J = c.includes(U.name);
    return /* @__PURE__ */ _t.createElement(aRe, {
      key: U.name,
      active: J,
      text: ((M = E[U.name]) === null || M === void 0 ? void 0 : M.nickname) || U.name,
      mute: !U.audio,
      avatarUrl: (V = E[U.name]) === null || V === void 0 ? void 0 : V.avatarUrl
    });
  }), p.confr.type === 2 && p.joinedMembers.map(function(U) {
    var M, V, J = "";
    return p.joinedMembers.length <= 2 && (U.isSelf ? J = "callkit-group-video-2-self" : J = "callkit-group-video-2-target"), /* @__PURE__ */ _t.createElement(sRe, {
      key: U.value,
      text: ((M = E[U.name]) === null || M === void 0 ? void 0 : M.nickname) || U.name,
      id: "video" + U.value,
      className: J,
      data: U,
      avatarUrl: (V = E[U.name]) === null || V === void 0 ? void 0 : V.avatarUrl,
      memberCount: p.joinedMembers.length
    });
  }), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-group-control"
  }, O()));
}
const cRe = Pd(oRe);
function uRe() {
  var t = Ja(function(a) {
    return a;
  }), r = t.confr.type === 2 || t.confr.type === 3;
  return /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-main-cantainer"
  }, r ? /* @__PURE__ */ _t.createElement(cRe, null) : /* @__PURE__ */ _t.createElement(rRe, {
    style: {
      marginTop: "96px"
    }
  }));
}
function dRe(t) {
  var r = t.className, a = DA(), u = Ja(function(w) {
    return w;
  }), h = u.callDuration, b = u.callStatus, l = u.confr, v = l.type === 1, s = b < Qn.answerCall ? "Calling" : h, c = Zn(Sh), d = c.contactAvatar, p = c.groupAvatar, m = En(r, {
    "callkit-miniwin-container": !0,
    "callkit-miniwin-minivideo": v
  }), E, y = function() {
    E = Date.now();
  }, g = function() {
    var _ = Date.now();
    _ - E < 300 && a(Ub("normal"));
  };
  Pn(function() {
    if (l.type === 1)
      return u.windowSize === "mini" && _n.rtc.remoteVideoTrack && _n.rtc.remoteVideoTrack.play("mini-player"), function() {
        _n.rtc.remoteVideoTrack && _n.rtc.remoteVideoTrack.play("remote-player");
      };
  }, [u.windowSize]);
  var C;
  l.type > 1 ? C = p || _d : C = d || _d;
  var O = typeof C == "object" ? C : /* @__PURE__ */ _t.createElement(rh, {
    className: "callkit-miniwin-avatar",
    src: C || _d,
    alt: "name",
    style: {
      borderRadius: p ? "inherit" : "50%"
    }
  }), N = v ? /* @__PURE__ */ _t.createElement(_t.Fragment, null, /* @__PURE__ */ _t.createElement("div", {
    id: "mini-player",
    className: "callkit-miniwin-video"
  }), /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-miniwin-video-text"
  }, s)) : /* @__PURE__ */ _t.createElement(_t.Fragment, null, " ", typeof C == "object" ? /* @__PURE__ */ _t.createElement("div", {
    className: "callkit-miniwin-avatar"
  }, O) : O, /* @__PURE__ */ _t.createElement("span", {
    className: "callkit-miniwin-text"
  }, s));
  return /* @__PURE__ */ _t.createElement(fX, {
    onStart: y,
    onStop: g
  }, /* @__PURE__ */ _t.createElement("div", {
    className: m
  }, N));
}
function lRe(t) {
  var r = t.onAddPerson;
  t.onStateChange;
  var a = t.onInvite, u = Zn(Sh), h = Ja(function(m) {
    return m.confr;
  }), b = Ja(function(m) {
    return m.windowSize;
  }), l = Ja(function(m) {
    return m.callStatus;
  }), v = En("callkit-layout-cantainer", {
    "callkit-layout-large": b === "large",
    "callkit-layout-displaynone": b === "mini"
  }), s = En({
    "callkit-layout-displaynone": b !== "mini"
  }), c = b === "large" ? {
    x: 0,
    y: 0
  } : null, d = function(E) {
    r && r(E);
  }, p = er(null);
  return Pn(function() {
    if (l === Qn.alerting) {
      if (a && a(h), !u.ringingSource) {
        console.warn("no ringing source.");
        return;
      }
      p.current = new Audio(), p.current.muted = "muted", p.current.src = u.ringingSource, p.current.play(), p.current.muted = !1, p.current.onended = function() {
        p.current.load(), p.current.play();
      };
    } else if (l != Qn.receivedConfirmRing) {
      if (!p.current) return;
      p.current.pause(), p.current.src = null, p.current.load();
    }
  }, [l]), l > Qn.idle ? /* @__PURE__ */ _t.createElement(_t.Fragment, null, /* @__PURE__ */ _t.createElement(fX, {
    position: c
  }, /* @__PURE__ */ _t.createElement("div", {
    className: v
  }, /* @__PURE__ */ _t.createElement(zIe, {
    onAddPerson: d
  }), /* @__PURE__ */ _t.createElement(uRe, null))), /* @__PURE__ */ _t.createElement(dRe, {
    className: s
  })) : null;
}
function zb() {
  return zb = Object.assign || function(t) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];
      for (var u in a)
        Object.prototype.hasOwnProperty.call(a, u) && (t[u] = a[u]);
    }
    return t;
  }, zb.apply(this, arguments);
}
window.callkit_store = hi;
var Sh = _t.createContext();
function _s(t) {
  return /* @__PURE__ */ _t.createElement(FCe, {
    store: hi
  }, /* @__PURE__ */ _t.createElement("div", null, /* @__PURE__ */ _t.createElement(Sh.Provider, {
    value: t
  }, /* @__PURE__ */ _t.createElement(lRe, t))));
}
_s.init = function(t, r, a) {
  if (typeof t != "string")
    throw new Error("invalid parameter appId: " + t);
  if (typeof r != "string")
    throw new Error("invalid parameter uid: " + r);
  if (typeof a != "object")
    throw new Error("invalid parameter conn: " + a);
  Ji.init(t, r, a);
};
_s.startCall = function(t) {
  if (typeof t.to != "string" && !(t.to instanceof Array))
    throw new Error("invalid parameter options.to: " + t.to);
  if (typeof t.channel != "string")
    throw new Error("invalid parameter options.channel: " + t.channel);
  if (typeof t.accessToken != "string")
    throw new Error("invalid parameter options.accessToken: " + t.accessToken);
  if ([0, 1, 2, 3].includes(t.callType)) {
    if (t.chatType === "groupChat" && !t.groupId)
      throw new Error("The groupId is required");
  } else throw new Error("invalid parameter options.callType: " + t.callType);
  if (t.chatType === "groupChat" && Array.isArray(t.to)) {
    var r = _n.conn.getUniqueId().toString(), a = t.channel || Math.uuid(8), u = zb({}, t, {
      callId: r,
      channel: a
    });
    t.to.forEach(function(l) {
      u.to = l, u.chatType = "singleChat", Ji.startCall(u);
    }), yX(t.chatType, t.groupId, t.message, {
      action: "invite",
      type: t.callType,
      msgType: "rtcCallWithAgora",
      callId: r,
      channelName: a,
      callerDevId: _n.conn.context.jid.clientResource,
      ts: Date.now()
    });
    return;
  }
  var h = _n.conn.getUniqueId().toString(), b = zb({}, t, {
    callId: h
  });
  return Ji.startCall(b), {
    callId: h
  };
};
_s.answerCall = function(t, r) {
  if (typeof t != "boolean")
    throw new Error("invalid parameter result: " + t);
  if (typeof r != "string")
    throw new Error("invalid parameter token: " + r);
  Ji.answerCall(t, r);
};
_s.setUserIdMap = function(t) {
  if (typeof t != "object")
    throw new Error("invalid parameter idMap: " + t);
  Ji.setUserIdMap(t);
};
_s.setUserInfo = function(t) {
  if (typeof t != "object")
    throw new Error("invalid parameter userInfo: " + t);
  Ji.setUserInfo(t);
};
_s.getAgoraRTC = function() {
  return Hb;
};
const fRe = (t) => {
  var Le, Te, K, Oe, Pe;
  const { prefix: r, className: a, style: u, message: h, targetLanguage: b, onReport: l } = t, { getPrefixCls: v } = _t.useContext(Hn), s = v("message-chatroom", r), c = En(s, a), { t: d } = Yr(), [p, m] = tn(!1), [E, y] = tn(!1), g = Zn(Vn), { theme: C } = g, O = C == null ? void 0 : C.mode;
  let N, w = { visible: !1 };
  const { pinMessage: _, unpinMessage: I, clearPinnedMessages: k, getPinnedMessages: H, list: S } = Rc({
    conversation: {
      conversationType: "chatRoom",
      conversationId: h.to
    }
  }), [B, D] = tn(h.msg), F = Zt.addressStore.chatroom.filter((xe) => xe.id === h.to)[0] || {}, G = (F.muteList || []).includes(h.from), U = F.owner || "";
  w = {
    visible: !0,
    icon: null,
    actions: [
      {
        content: "TRANSLATE",
        onClick: () => {
        }
      },
      {
        content: "REPORT",
        onClick: () => {
        }
      }
    ]
  }, U === Zt.client.user && ((Le = w.actions) == null || Le.unshift({
    content: "PIN",
    onClick: () => {
    }
  }), h.from != Zt.client.user && ((Te = w.actions) == null || Te.unshift({
    content: "MUTE",
    onClick: () => {
    }
  }))), h.from == Zt.client.user && ((K = w.actions) == null || K.unshift({
    content: "RECALL",
    onClick: () => {
    }
  }));
  const M = () => {
    var be, $e, Be, Ke, Ze;
    const { msg: xe } = h;
    if (xe !== B)
      return D(xe);
    if (($e = (be = h == null ? void 0 : h.translations) == null ? void 0 : be[0]) != null && $e.text)
      return D((Ke = (Be = h == null ? void 0 : h.translations) == null ? void 0 : Be[0]) == null ? void 0 : Ke.text);
    (Ze = Zt.messageStore.translateMessage(
      {
        chatType: "chatRoom",
        conversationId: h.to
      },
      // @ts-ignore
      h.mid || h.id,
      b || navigator.language
    )) == null || Ze.then(() => {
      var pt, It;
      const at = (It = (pt = h == null ? void 0 : h.translations) == null ? void 0 : pt[0]) == null ? void 0 : It.text;
      D(at), mn.dispatchSuccess("translateMessage");
    }).catch((at) => {
      mn.dispatchError("translateMessage", at);
    }), y(!1);
  }, V = () => {
    Zt.messageStore.recallMessage(
      {
        chatType: "chatRoom",
        conversationId: h.to
      },
      // @ts-ignore
      h.mid || h.id,
      !1,
      !0
    ), y(!1);
  }, J = () => {
    if (G) {
      Zt.addressStore.unmuteChatRoomMember(h.to, h.from);
      return;
    }
    Zt.addressStore.muteChatRoomMember(h.to, h.from), y(!1);
  }, ue = () => {
    l == null || l(h), y(!1);
  }, se = () => {
    S.forEach((xe) => {
      I(xe.message.mid || xe.message.id);
    }), _(h.mid || h.id).then(() => {
      Zt.pinnedMessagesStore.pushPinnedMessage("chatRoom", h.to, {
        operatorId: Zt.client.user,
        pinTime: Date.now(),
        message: h
      });
    }), y(!1);
  }, ee = v("moreAction", r), de = En(ee, {
    [`${ee}-${O}`]: !!O
  });
  w != null && w.visible && (N = /* @__PURE__ */ q.jsx("ul", { className: de, children: (Oe = w == null ? void 0 : w.actions) == null ? void 0 : Oe.map((xe, be) => xe.content === "RECALL" ? /* @__PURE__ */ q.jsxs("li", { onClick: V, children: [
    /* @__PURE__ */ q.jsx(pn, { type: "ARROW_BACK", width: 16, height: 16 }),
    d("unsend")
  ] }, be) : xe.content === "TRANSLATE" ? (h == null ? void 0 : h.type) === "txt" && /* @__PURE__ */ q.jsxs("li", { onClick: M, children: [
    /* @__PURE__ */ q.jsx(pn, { type: "TRANSLATION", width: 16, height: 16 }),
    d("translate")
  ] }, be) : xe.content === "MUTE" ? /* @__PURE__ */ q.jsxs("li", { onClick: J, children: [
    /* @__PURE__ */ q.jsx(pn, { type: G ? "BELL" : "BELL_SLASH", width: 16, height: 16 }),
    d(G ? "unmute" : "mute")
  ] }, G ? be : -be) : xe.content === "REPORT" ? h.from == Zt.client.user ? null : /* @__PURE__ */ q.jsxs("li", { onClick: ue, children: [
    /* @__PURE__ */ q.jsx(pn, { type: "ENVELOPE", width: 16, height: 16 }),
    d("report")
  ] }, be) : xe.content === "PIN" ? /* @__PURE__ */ q.jsxs("li", { onClick: se, children: [
    /* @__PURE__ */ q.jsx(pn, { type: "PIN", width: 16, height: 16 }),
    d("Pin")
  ] }, be) : /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: () => {
        var $e;
        ($e = xe.onClick) == null || $e.call(xe, h);
      },
      children: [
        xe.icon && xe.icon,
        xe.content
      ]
    },
    be
  )) }));
  const he = (xe) => /* @__PURE__ */ q.jsx("div", { className: `${s}-text-box`, children: Nd(xe) }), pe = () => {
    var be;
    if (h.customEvent == "CHATROOMUIKITUSERJOIN")
      return /* @__PURE__ */ q.jsx("div", { className: `${s}-notice-box`, children: d("Joined") });
    if (h.customEvent != "CHATROOMUIKITGIFT")
      return;
    let xe = ((be = h == null ? void 0 : h.customExts) == null ? void 0 : be.chatroom_uikit_gift) || {};
    return typeof xe == "string" && (xe = JSON.parse(xe)), /* @__PURE__ */ q.jsxs("div", { className: `${s}-gift`, children: [
      d("sent"),
      /* @__PURE__ */ q.jsx("div", { children: d(xe.giftName) }),
      /* @__PURE__ */ q.jsx("img", { src: xe.giftIcon, alt: "", className: `${s}-gift-img` }),
      /* @__PURE__ */ q.jsxs("div", { className: `${s}-gift-number`, children: [
        "x",
        xe.giftCount || 1
      ] })
    ] });
  }, Ce = ((Pe = h == null ? void 0 : h.ext) == null ? void 0 : Pe.chatroom_uikit_userInfo) || {}, _e = (xe) => new Date(xe).getHours() + ":" + (new Date(xe).getMinutes() < 10 ? `0${new Date(xe).getMinutes()}` : new Date(xe).getMinutes());
  return /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: c,
      style: { ...u },
      onMouseOver: () => m(!0),
      onMouseLeave: () => {
        E || m(!1);
      },
      children: [
        /* @__PURE__ */ q.jsxs("div", { className: `${s}-container`, children: [
          /* @__PURE__ */ q.jsxs("div", { className: `${s}-header`, children: [
            /* @__PURE__ */ q.jsx("div", { className: `${s}-header-label`, children: _e(h.time) }),
            /* @__PURE__ */ q.jsx(zs, { size: 20, src: Ce.avatarURL, children: Ce.nickname || h.from }),
            /* @__PURE__ */ q.jsx("div", { className: `${s}-header-nick`, children: Ce.nickname || h.from })
          ] }),
          h.type == "custom" && pe(),
          h.type == "txt" && he(B)
        ] }),
        p && h.type == "txt" && /* @__PURE__ */ q.jsx(
          va,
          {
            title: N,
            trigger: "click",
            placement: "bottom",
            align: { offset: [5] },
            open: E,
            onOpenChange: (xe) => {
              y(xe), m(xe);
            },
            children: /* @__PURE__ */ q.jsx(
              pn,
              {
                type: "ELLIPSIS",
                color: "var(--cui-primary-color5)",
                className: `${s}-body-action`,
                height: 20
              }
            )
          }
        )
      ]
    }
  );
}, vX = mi(fRe);
vX.displayName = "ChatroomMessage";
var TX = {};
function hRe(t) {
  if (typeof window > "u")
    return;
  const r = document.createElement("style");
  return r.setAttribute("type", "text/css"), r.innerHTML = t, document.head.appendChild(r), t;
}
Object.defineProperty(TX, "__esModule", { value: !0 });
var ws = _t;
function pRe(t) {
  return t && typeof t == "object" && "default" in t ? t : { default: t };
}
var Ol = /* @__PURE__ */ pRe(ws);
hRe(`.rfm-marquee-container {
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  width: var(--width);
  transform: var(--transform);
}
.rfm-marquee-container:hover div {
  animation-play-state: var(--pause-on-hover);
}
.rfm-marquee-container:active div {
  animation-play-state: var(--pause-on-click);
}

.rfm-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}
.rfm-overlay::before, .rfm-overlay::after {
  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));
  content: "";
  height: 100%;
  position: absolute;
  width: var(--gradient-width);
  z-index: 2;
  pointer-events: none;
  touch-action: none;
}
.rfm-overlay::after {
  right: 0;
  top: 0;
  transform: rotateZ(180deg);
}
.rfm-overlay::before {
  left: 0;
  top: 0;
}

.rfm-marquee {
  flex: 0 0 auto;
  min-width: var(--min-width);
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);
  animation-play-state: var(--play);
  animation-delay: var(--delay);
  animation-direction: var(--direction);
}
@keyframes scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.rfm-initial-child-container {
  flex: 0 0 auto;
  display: flex;
  min-width: auto;
  flex-direction: row;
  align-items: center;
}

.rfm-child {
  transform: var(--transform);
}`);
const gRe = ws.forwardRef(function({ style: r = {}, className: a = "", autoFill: u = !1, play: h = !0, pauseOnHover: b = !1, pauseOnClick: l = !1, direction: v = "left", speed: s = 50, delay: c = 0, loop: d = 0, gradient: p = !1, gradientColor: m = "white", gradientWidth: E = 200, onFinish: y, onCycleComplete: g, onMount: C, children: O }, N) {
  const [w, _] = ws.useState(0), [I, k] = ws.useState(0), [H, S] = ws.useState(1), [B, D] = ws.useState(!1), F = ws.useRef(null), j = N || F, G = ws.useRef(null), U = ws.useCallback(() => {
    if (G.current && j.current) {
      const de = j.current.getBoundingClientRect(), he = G.current.getBoundingClientRect();
      let pe = de.width, Ce = he.width;
      (v === "up" || v === "down") && (pe = de.height, Ce = he.height), S(u && pe && Ce && Ce < pe ? Math.ceil(pe / Ce) : 1), _(pe), k(Ce);
    }
  }, [u, j, v]);
  ws.useEffect(() => {
    if (B && (U(), G.current && j.current)) {
      const de = new ResizeObserver(() => U());
      return de.observe(j.current), de.observe(G.current), () => {
        de && de.disconnect();
      };
    }
  }, [U, j, B]), ws.useEffect(() => {
    U();
  }, [U, O]), ws.useEffect(() => {
    D(!0);
  }, []), ws.useEffect(() => {
    typeof C == "function" && C();
  }, []);
  const M = ws.useMemo(() => u ? I * H / s : I < w ? w / s : I / s, [u, w, I, H, s]), V = ws.useMemo(() => Object.assign(Object.assign({}, r), { "--pause-on-hover": !h || b ? "paused" : "running", "--pause-on-click": !h || b && !l || l ? "paused" : "running", "--width": v === "up" || v === "down" ? "100vh" : "100%", "--transform": v === "up" ? "rotate(-90deg)" : v === "down" ? "rotate(90deg)" : "none" }), [r, h, b, l, v]), J = ws.useMemo(() => ({
    "--gradient-color": m,
    "--gradient-width": typeof E == "number" ? `${E}px` : E
  }), [m, E]), ue = ws.useMemo(() => ({
    "--play": h ? "running" : "paused",
    "--direction": v === "left" ? "normal" : "reverse",
    "--duration": `${M}s`,
    "--delay": `${c}s`,
    "--iteration-count": d ? `${d}` : "infinite",
    "--min-width": u ? "auto" : "100%"
  }), [h, v, M, c, d, u]), se = ws.useMemo(() => ({
    "--transform": v === "up" ? "rotate(90deg)" : v === "down" ? "rotate(-90deg)" : "none"
  }), [v]), ee = ws.useCallback((de) => [
    ...Array(Number.isFinite(de) && de >= 0 ? de : 0)
  ].map((he, pe) => Ol.default.createElement(ws.Fragment, { key: pe }, ws.Children.map(O, (Ce) => Ol.default.createElement("div", { style: se, className: "rfm-child" }, Ce)))), [se, O]);
  return B ? Ol.default.createElement(
    "div",
    { ref: j, style: V, className: "rfm-marquee-container " + a },
    p && Ol.default.createElement("div", { style: J, className: "rfm-overlay" }),
    Ol.default.createElement(
      "div",
      { className: "rfm-marquee", style: ue, onAnimationIteration: g, onAnimationEnd: y },
      Ol.default.createElement("div", { className: "rfm-initial-child-container", ref: G }, ws.Children.map(O, (de) => Ol.default.createElement("div", { style: se, className: "rfm-child" }, de))),
      ee(H - 1)
    ),
    Ol.default.createElement("div", { className: "rfm-marquee", style: ue }, ee(H))
  ) : null;
});
var mRe = TX.default = gRe;
const ERe = (t) => {
  const {
    prefix: r,
    className: a,
    style: u,
    loop: h = 0,
    delay: b = 0,
    speed: l = 50,
    direction: v = "left",
    play: s = !0,
    pauseOnHover: c = !0,
    onFinish: d,
    onCycleComplete: p,
    children: m,
    prefixIcon: E,
    suffixIcon: y
  } = t, { getPrefixCls: g } = Zn(Hn), C = g("broadcast", r), O = En(C, a), N = E || /* @__PURE__ */ q.jsx(pn, { type: "SPEAKER_N_VERTICAL_BAR", color: "#F9FAFA", width: 20, height: 20 });
  return /* @__PURE__ */ q.jsxs("div", { className: O, style: { ...u }, children: [
    N,
    /* @__PURE__ */ q.jsx(
      mRe,
      {
        loop: h,
        delay: b,
        speed: l,
        direction: v,
        play: s,
        pauseOnHover: c,
        onFinish: () => {
          d == null || d();
        },
        autoFill: !1,
        onCycleComplete: () => {
          p == null || p();
        },
        children: m
      }
    ),
    y
  ] });
}, yRe = (t) => {
  var G, U;
  const { children: r, className: a, style: u } = t, h = Zn(Vn), { theme: b, rootStore: l } = h, v = (b == null ? void 0 : b.mode) || "light", { getPrefixCls: s } = Zn(Hn), c = s("pinned-text-message"), [d, p] = tn(!1), [m, E] = tn(!1), [y, g] = tn(!1), C = er(null), { t: O } = Yr(), N = En(
    c,
    {
      [`${c}-${v}`]: !!v,
      [`${c}-expand`]: m
    },
    a
  ), w = () => {
    E((M) => !M), y ? g(!y) : setTimeout(() => {
      g(!y);
    }, 300);
  };
  Pn(() => {
    if (C.current) {
      const V = parseInt(window.getComputedStyle(C.current).lineHeight, 10) * 2, J = C.current.scrollHeight;
      console.log("actualHeight", J, "maxHeight", V), J > V ? (p(!0), g(!0)) : (g(!1), p(!1), E(!1));
    }
  }, [t.message]);
  const _ = En(`${c}-button`, {
    [`${c}-button-expand`]: m
  }), { pinMessage: I, unpinMessage: k, clearPinnedMessages: H, getPinnedMessages: S, list: B } = Rc({
    conversation: {
      conversationType: "chatRoom",
      conversationId: (G = t.message.message) == null ? void 0 : G.to
    }
  }), D = () => {
    console.log("unpin message", t.message), k(t.message.message.mid || t.message.message.id), H();
  }, F = t.message.message, j = ((U = F == null ? void 0 : F.ext) == null ? void 0 : U.chatroom_uikit_userInfo) || {};
  return console.log("----->", t.message, l.client.user), /* @__PURE__ */ q.jsxs("div", { className: N, style: u, children: [
    /* @__PURE__ */ q.jsxs("div", { className: `${c}-text`, ref: C, children: [
      /* @__PURE__ */ q.jsxs("div", { className: `${c}-text-header`, children: [
        /* @__PURE__ */ q.jsx(
          pn,
          {
            width: 20,
            height: 20,
            type: "PIN",
            color: v == "light" ? "#F9FAFA" : "#464E53"
          }
        ),
        /* @__PURE__ */ q.jsx(zs, { size: 20, src: j.avatarURL, children: j.nickname }),
        /* @__PURE__ */ q.jsx("div", { className: `${c}-text-name`, children: j.nickname })
      ] }),
      /* @__PURE__ */ q.jsx("div", { children: F.msg }),
      //超出后显示省略号
      y && /* @__PURE__ */ q.jsx("span", { className: `${c}-ellipsis`, children: "..." })
    ] }),
    /* @__PURE__ */ q.jsxs("div", { className: `${c}-buttons`, children: [
      /* @__PURE__ */ q.jsx(
        va,
        {
          title: /* @__PURE__ */ q.jsx("ul", { className: "cui-moreAction", children: /* @__PURE__ */ q.jsxs("li", { style: { display: "flex", alignItems: "center" }, onClick: D, children: [
            /* @__PURE__ */ q.jsx(pn, { type: "UNPIN", width: 16, height: 16 }),
            O("Remove pin message")
          ] }) }),
          trigger: "click",
          placement: "bottomRight",
          children: t.message.operatorId === l.client.user && /* @__PURE__ */ q.jsx(pn, { type: "ELLIPSIS", width: 16, height: 16, className: `${c}-button` })
        }
      ),
      d && /* @__PURE__ */ q.jsx(
        pn,
        {
          type: "ARROW_DOWN",
          className: _,
          width: 16,
          height: 16,
          onClick: w
        }
      )
    ] })
  ] });
};
let eh = {
  tag1: "Unwelcome commercial content",
  tag2: "Pornographic or explicit content",
  tag3: "Child abuse",
  tag4: "Hate speech or graphic violence",
  tag5: "Promote terrorism",
  tag6: "Harassment or bullying",
  tag7: "Suicide or self harm",
  tag8: "False information",
  tag9: "Others"
}, WN = (t) => {
  var Ke, Ze, at, pt, It;
  const { t: r } = Yr(), {
    renderEmpty: a,
    renderHeader: u,
    headerProps: h,
    renderMessageInput: b,
    messageInputProps: l,
    renderMessageList: v,
    messageListProps: s,
    renderBroadcast: c,
    broadcastProps: d,
    chatroomId: p,
    prefix: m,
    className: E,
    style: y,
    reportType: g
  } = t;
  g && (eh = g);
  const C = Zn(Vn), { rootStore: O, features: N, theme: w } = C, _ = N == null ? void 0 : N.chatroom, I = (w == null ? void 0 : w.mode) || "light", [k, H] = tn(!1), { getPrefixCls: S } = _t.useContext(Hn), B = S("chatroom", m), D = En(
    B,
    {
      [`${B}-${I}`]: !!I
    },
    E
  ), { pinMessage: F, unpinMessage: j, clearPinnedMessages: G, getPinnedMessages: U, list: M } = Rc({
    conversation: {
      conversationType: "chatRoom",
      conversationId: p
    }
  }), V = () => {
    var Ut;
    const Rt = O.addressStore.appUsersInfo[O.client.user] || {}, gt = {
      userId: Rt == null ? void 0 : Rt.userId,
      nickname: Rt == null ? void 0 : Rt.nickname,
      avatarURL: Rt == null ? void 0 : Rt.avatarurl,
      gender: Number(Rt == null ? void 0 : Rt.gender),
      identify: (Ut = Rt == null ? void 0 : Rt.ext) == null ? void 0 : Ut.identify
    }, it = {
      type: "custom",
      to: p,
      chatType: "chatRoom",
      customEvent: "CHATROOMUIKITUSERJOIN",
      customExts: {},
      ext: {
        chatroom_uikit_userInfo: gt
      }
    }, Tt = Zs.message.create(it);
    O.messageStore.sendMessage(Tt);
  };
  Pn(() => {
    if (O.loginState) {
      if (!p) {
        H(!0);
        return;
      }
      return H(!1), O.client.joinChatRoom({ roomId: p }).then(() => {
        var Rt;
        mn.dispatchSuccess("joinChatRoom"), (Rt = xd({
          userIdList: [O.client.user],
          withPresence: !1
        })) == null || Rt.then(() => {
          V(), mn.dispatchSuccess("fetchUserInfoById");
        }).catch((gt) => {
          mn.dispatchError("fetchUserInfoById", gt);
        }), O.client.getChatRoomDetails({ chatRoomId: p }).then((gt) => {
          var Tt, Ut;
          O.addressStore.setChatroom(gt.data), ((Ut = (Tt = gt.data) == null ? void 0 : Tt[0]) == null ? void 0 : Ut.owner) == O.client.user && O.addressStore.getChatroomMuteList(p), mn.dispatchSuccess("getChatRoomDetails");
        }).catch((gt) => {
          mn.dispatchError("getChatRoomDetails", gt);
        }), U();
      }).catch((Rt) => {
        mn.dispatchError("joinChatRoom", Rt);
      }), () => {
        O.client.leaveChatRoom({
          roomId: p
        }).then(() => {
          mn.dispatchSuccess("leaveChatRoom");
        }).catch((Rt) => {
          mn.dispatchError("leaveChatRoom", Rt);
        });
      };
    }
  }, [p, O.loginState]);
  const J = {
    actions: [
      {
        name: "TEXTAREA",
        visible: !0
      },
      {
        name: "EMOJI",
        visible: !0
      },
      {
        name: "GIFT",
        visible: !0,
        icon: /* @__PURE__ */ q.jsx(
          mY,
          {
            conversation: {
              chatType: "chatRoom",
              conversationId: p
            }
          }
        )
      },
      {
        name: "MORE",
        visible: !1
      }
    ]
  };
  _ != null && _.messageInput && (J.actions = (Ke = J.actions) == null ? void 0 : Ke.filter((Rt) => {
    var gt, it;
    return !(Rt.name == "EMOJI" && ((gt = _ == null ? void 0 : _.messageInput) == null ? void 0 : gt.emoji) == !1 || Rt.name == "GIFT" && ((it = _ == null ? void 0 : _.messageInput) == null ? void 0 : it.gift) == !1);
  }));
  const ue = O.addressStore.chatroom.filter((Rt) => Rt.id === p)[0] || {}, se = O.addressStore.appUsersInfo, ee = O.messageStore.message.broadcast, [de, he] = tn(""), pe = (Rt) => {
    Le(!0), he(Rt.mid || Rt.id);
  }, Ce = (Rt) => {
    if (Rt.type == "txt" || Rt.type == "custom")
      return /* @__PURE__ */ q.jsx(vX, { message: Rt, onReport: pe }, Rt.mid || Rt.id);
  }, [_e, Le] = tn(!1), [Te, K] = tn(""), Oe = (Rt) => {
    K(Rt);
  }, Pe = () => {
    O.client.reportMessage({
      reportType: Te,
      reportReason: eh[Te],
      messageId: de
    }).then(() => {
      mn.dispatchSuccess("reportMessage"), Le(!1), K("");
    }).catch((Rt) => {
      mn.dispatchError("reportMessage", Rt);
    });
  }, xe = () => {
    O.messageStore.shiftBroadcastMessage();
  }, be = ((Ze = O.pinnedMessagesStore.messages.chatRoom[p]) == null ? void 0 : Ze.list) || [], Be = ((Rt) => Rt == null ? "0" : Rt < 1e3 ? Rt.toString() : (Rt / 1e3).toFixed(1) + "k")(ue.affiliations_count);
  return /* @__PURE__ */ q.jsxs("div", { className: D, style: { ...y }, children: [
    k ? a ? a() : /* @__PURE__ */ q.jsx(Pm, { text: r("Enter chatroom to start chatting") }) : /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
      u ? u(ue) : /* @__PURE__ */ q.jsx(
        au,
        {
          avatarSrc: (at = se[ue.owner]) == null ? void 0 : at.avatarurl,
          content: ue.name || p,
          subtitle: ((pt = se[ue.owner]) == null ? void 0 : pt.nickname) || ue.owner,
          suffixIcon: /* @__PURE__ */ q.jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
            /* @__PURE__ */ q.jsx(
              pn,
              {
                type: "PERSON_DOUBLE_FILL",
                onClick: (h == null ? void 0 : h.onClickMember) || (() => {
                }),
                width: 24,
                height: 24,
                color: I == "dark" ? "#C8CDD0" : "#464E53"
              }
            ),
            Number(Be) > 0 && /* @__PURE__ */ q.jsx("span", { className: `${B}-header-count`, children: Be })
          ] }),
          ...h
        }
      ),
      /* @__PURE__ */ q.jsx("p", {}),
      /* @__PURE__ */ q.jsxs(
        "div",
        {
          style: {
            position: "relative",
            flex: "1",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
          },
          children: [
            /* @__PURE__ */ q.jsxs("div", { style: { position: "absolute", width: "100%" }, children: [
              be.length > 0 && /* @__PURE__ */ q.jsx(
                yRe,
                {
                  message: be[0],
                  style: {
                    margin: "12px",
                    position: "relative",
                    zIndex: 9,
                    width: "calc(100% - 24px)"
                  }
                }
              ),
              typeof c == "function" ? c() : ee.length > 0 && /* @__PURE__ */ q.jsx(
                ERe,
                {
                  loop: 0,
                  delay: 1,
                  play: !0,
                  onCycleComplete: xe,
                  style: {
                    position: "relative",
                    width: "calc(100% - 24px)",
                    zIndex: 9,
                    margin: "12px"
                  },
                  ...d,
                  children: /* @__PURE__ */ q.jsx("div", { children: ((It = ee[0]) == null ? void 0 : It.msg) || "" })
                }
              )
            ] }),
            v ? v() : /* @__PURE__ */ q.jsx(
              cv,
              {
                renderMessage: Ce,
                conversation: {
                  chatType: "chatRoom",
                  conversationId: p
                },
                ...s
              }
            )
          ]
        }
      ),
      b ? b() : /* @__PURE__ */ q.jsx(
        zv,
        {
          placeHolder: r("Let's Chat"),
          conversation: {
            chatType: "chatRoom",
            conversationId: p
          },
          ...J,
          ...l
        }
      )
    ] }),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: _e,
        title: r("report"),
        okText: r("report"),
        cancelText: r("cancel"),
        onOk: Pe,
        onCancel: () => {
          Le(!1);
        },
        children: /* @__PURE__ */ q.jsx("div", { children: Object.keys(eh).map((Rt, gt) => /* @__PURE__ */ q.jsxs(
          "div",
          {
            className: En("report-item", {
              "report-item-dark": I == "dark"
            }),
            onClick: () => {
              Oe(Rt);
            },
            children: [
              /* @__PURE__ */ q.jsx("div", { children: r(eh[Rt]) }),
              /* @__PURE__ */ q.jsx(
                Bv,
                {
                  checked: Te === Rt
                }
              )
            ]
          },
          gt
        )) })
      }
    )
  ] });
};
WN = mi(WN);
const vRe = (t) => {
  var r;
  if (t.chatType === "singleChat")
    return (r = gr().addressStore.appUsersInfo[t.conversationId]) == null ? void 0 : r.avatarurl;
  if (t.chatType === "groupChat") {
    const a = gr().addressStore.groups.find((u) => u.groupid === t.conversationId);
    return a == null ? void 0 : a.avatarUrl;
  }
};
let dv = Gu((t, r) => {
  var ut, St, Ft, Ht, zt, ze, Ne, le, X, re, Me, Se, ke, Ge, nt, rt, dt, lt, Ct, Ie, x, ae, Q, Z, ge, me, ve;
  const {
    prefix: a,
    className: u,
    renderHeader: h,
    renderMessageList: b,
    renderMessageInput: l,
    renderEmpty: v,
    headerProps: s,
    messageListProps: c,
    messageInputProps: d,
    rtcConfig: p,
    style: m = {},
    onOpenThread: E,
    onOpenThreadList: y,
    onAudioCall: g,
    onVideoCall: C,
    renderRepliedMessage: O
  } = t, { t: N } = Yr(), { getPrefixCls: w } = _t.useContext(Hn), _ = w("chat", a), { show: I } = Rc(), [k, H] = tn(!0), S = Zn(Vn), { rootStore: B, features: D, theme: F, presenceMap: j } = S, G = (F == null ? void 0 : F.mode) || "light", U = En(
    _,
    {
      [`${_}-${G}`]: !!G
    },
    u
  );
  B.addressStore;
  const M = D == null ? void 0 : D.chat, V = B.conversationStore.currentCvs, { suffixIcon: J, ...ue } = s || {};
  Zw();
  const se = p == null ? void 0 : p.getRTCToken;
  Pn(() => {
    B.conversationStore.currentCvs.conversationId ? H(!1) : H(!0), B.messageStore.setRepliedMessage(null), B.conversationStore.currentCvs.conversationId && (B.messageStore.setSelectedMessage(B.conversationStore.currentCvs, {
      selectable: !1,
      selectedMessage: []
    }), B.threadStore.setThreadVisible(!1));
  }, [B.conversationStore.currentCvs]);
  const ee = B.messageStore.repliedMessage, de = ar(ee || {}), he = ee && de === V.conversationId;
  let pe = !0, Ce = {
    visible: !0,
    actions: [
      {
        content: N("clearMsgs"),
        onClick: () => {
          B.messageStore.clearMessage(B.conversationStore.currentCvs), B.client.removeHistoryMessages({
            targetId: V.conversationId,
            chatType: V.chatType,
            beforeTimeStamp: Date.now()
          });
        }
      },
      {
        content: N("deleteCvs"),
        onClick: () => {
          B.conversationStore.deleteConversation(B.conversationStore.currentCvs), B.client.deleteConversation({
            channel: V.conversationId,
            chatType: V.chatType,
            deleteRoam: !0
          });
        }
      }
    ]
  };
  M != null && M.header && (((ut = M == null ? void 0 : M.header) == null ? void 0 : ut.threadList) == !1 && (pe = !1), ((St = M == null ? void 0 : M.header) == null ? void 0 : St.moreAction) == !1 && (Ce = {
    visible: !1,
    actions: []
  }), ((Ft = M == null ? void 0 : M.header) == null ? void 0 : Ft.clearMessage) == !1 && Ce.actions.shift(), ((Ht = M == null ? void 0 : M.header) == null ? void 0 : Ht.deleteConversation) == !1 && Ce.actions.pop());
  const _e = (ie) => {
    st(!0), Tt(ie.mid || ie.id);
  }, [Le, Te] = tn(!1), [K, Oe] = tn(null), xe = {
    customAction: {
      visible: !0,
      icon: null,
      actions: [
        {
          content: "FORWARD",
          onClick: () => {
          }
        },
        {
          content: "REPLY",
          onClick: () => {
          }
        },
        {
          content: "UNSEND",
          onClick: () => {
          }
        },
        {
          content: "Modify",
          onClick: () => {
          }
        },
        {
          content: "SELECT",
          onClick: () => {
          }
        },
        {
          content: "PIN",
          onClick: () => {
          }
        },
        {
          content: "TRANSLATE",
          onClick: () => {
          }
        },
        {
          content: "REPORT",
          onClick: () => {
          }
        },
        {
          content: "DELETE",
          onClick: () => {
          }
        }
      ]
    },
    onReportMessage: _e,
    onDeleteMessage: (ie) => {
      Oe(ie), Te(!0);
    }
  };
  M != null && M.message && (((zt = M == null ? void 0 : M.message) == null ? void 0 : zt.status) == !1 && (xe.messageStatus = !1), ((ze = M == null ? void 0 : M.message) == null ? void 0 : ze.thread) == !1 && (xe.thread = !1), ((Ne = M == null ? void 0 : M.message) == null ? void 0 : Ne.reaction) == !1 && (xe.reaction = !1), ((le = M == null ? void 0 : M.message) == null ? void 0 : le.moreAction) == !1 && (xe.customAction = {
    visible: !1
  }), xe.customAction.actions = (re = (X = xe.customAction.actions) == null ? void 0 : X.filter) == null ? void 0 : re.call(X, (ie) => {
    var ye, Ye, ne, Qe, W, ce, fe, we, Fe;
    return !(((ye = M == null ? void 0 : M.message) == null ? void 0 : ye.reply) == !1 && ie.content == "REPLY" || ((Ye = M == null ? void 0 : M.message) == null ? void 0 : Ye.delete) == !1 && ie.content == "DELETE" || ((ne = M == null ? void 0 : M.message) == null ? void 0 : ne.recall) == !1 && ie.content == "UNSEND" || ((Qe = M == null ? void 0 : M.message) == null ? void 0 : Qe.translate) == !1 && ie.content == "TRANSLATE" || ((W = M == null ? void 0 : M.message) == null ? void 0 : W.edit) == !1 && ie.content == "Modify" || ((ce = M == null ? void 0 : M.message) == null ? void 0 : ce.select) == !1 && ie.content == "SELECT" || ((fe = M == null ? void 0 : M.message) == null ? void 0 : fe.forward) == !1 && ie.content == "FORWARD" || ((we = M == null ? void 0 : M.message) == null ? void 0 : we.report) == !1 && ie.content == "REPORT" || ((Fe = M == null ? void 0 : M.message) == null ? void 0 : Fe.pin) == !1 && ie.content == "PIN");
  }));
  const be = {
    enabledTyping: !0,
    enabledMention: !0,
    actions: [
      {
        name: "RECORDER",
        visible: !0
      },
      {
        name: "TEXTAREA",
        visible: !0
      },
      {
        name: "EMOJI",
        visible: !0
      },
      {
        name: "MORE",
        visible: !0
      }
    ],
    customActions: [
      {
        content: "IMAGE"
      },
      {
        content: "VIDEO"
      },
      {
        content: "FILE"
      },
      {
        content: "CARD"
      }
    ]
  };
  M != null && M.messageInput && (((Me = M == null ? void 0 : M.messageInput) == null ? void 0 : Me.mention) == !1 && (be.enabledMention = !1), ((Se = M == null ? void 0 : M.messageInput) == null ? void 0 : Se.typing) == !1 && (be.enabledTyping = !1), be.actions = (ke = be.actions) == null ? void 0 : ke.filter((ie) => {
    var ye, Ye, ne;
    return !(ie.name == "EMOJI" && ((ye = M == null ? void 0 : M.messageInput) == null ? void 0 : ye.emoji) == !1 || ie.name == "MORE" && ((Ye = M == null ? void 0 : M.messageInput) == null ? void 0 : Ye.moreAction) == !1 || ie.name == "RECORDER" && ((ne = M == null ? void 0 : M.messageInput) == null ? void 0 : ne.record) == !1);
  }), be.customActions = (Ge = be.customActions) == null ? void 0 : Ge.filter((ie) => {
    var ye, Ye, ne, Qe;
    return !(ie.content == "IMAGE" && ((ye = M == null ? void 0 : M.messageInput) == null ? void 0 : ye.picture) == !1 || ie.content == "FILE" && ((Ye = M == null ? void 0 : M.messageInput) == null ? void 0 : Ye.file) == !1 || ie.content == "VIDEO" && ((ne = M == null ? void 0 : M.messageInput) == null ? void 0 : ne.video) == !1 || ie.content == "CARD" && ((Qe = M == null ? void 0 : M.messageInput) == null ? void 0 : Qe.contactCard) == !1);
  }));
  const [$e, Be] = tn({}), Ke = async (ie) => {
    var Qe;
    const ye = await ((Qe = p == null ? void 0 : p.onAddPerson) == null ? void 0 : Qe.call(p, ie)), Ye = ye == null ? void 0 : ye.map((W) => W.id), ne = {
      callType: $e.callType,
      chatType: "groupChat",
      to: Ye,
      // agoraUid: agoraUid,
      message: N(`Start a ${$e.callType == 2 ? "video" : "audio"} meeting`),
      groupId: ie.groupId,
      groupName: ie.groupName,
      accessToken: $e.accessToken,
      channel: $e.channel
    };
    _s.startCall(ne);
  }, Ze = async (ie) => {
    var ye, Ye;
    switch ((ye = p == null ? void 0 : p.onStateChange) == null || ye.call(p, ie), ie.type) {
      case "hangup":
      case "refuse":
        break;
      case "user-published":
        if (!ie.confr) return;
        try {
          const ne = await ((Ye = p == null ? void 0 : p.getIdMap) == null ? void 0 : Ye.call(p, {
            userId: B.client.user,
            channel: ie.confr.channel
          })) || {}, Qe = Object.values(ne), W = {};
          Qe.forEach((ce) => {
            var fe, we;
            W[ce] = {
              nickname: (fe = B.addressStore.appUsersInfo[ce]) == null ? void 0 : fe.nickname,
              avatarUrl: (we = B.addressStore.appUsersInfo[ce]) == null ? void 0 : we.avatarurl
            };
          }), ne && Object.keys(ne).length > 0 && (_s.setUserIdMap(ne), _s.setUserInfo(W));
        } catch (ne) {
          console.error(ne);
        }
        break;
    }
  }, at = async (ie) => {
    var ce, fe, we, Fe;
    if (!se) return console.error("need getRTCToken method to get token");
    (ce = p == null ? void 0 : p.onRing) == null || ce.call(p, ie);
    const { agoraUid: ye, accessToken: Ye } = await se({
      channel: ie.channel,
      chatUserId: B.client.user
    }), ne = await ((fe = p == null ? void 0 : p.getIdMap) == null ? void 0 : fe.call(p, {
      userId: B.client.user,
      channel: ie.channel
    })) || {}, Qe = Object.values(ne), W = {};
    Qe.forEach((je) => {
      var qe, et;
      W[je] = {
        nickname: (qe = B.addressStore.appUsersInfo[je]) == null ? void 0 : qe.nickname,
        avatarUrl: (et = B.addressStore.appUsersInfo[je]) == null ? void 0 : et.avatarurl
      };
    }), W[ie.callerIMName] = {
      nickname: (we = B.addressStore.appUsersInfo[ie.callerIMName]) == null ? void 0 : we.nickname,
      avatarUrl: (Fe = B.addressStore.appUsersInfo[ie.callerIMName]) == null ? void 0 : Fe.avatarurl
    }, Object.keys(ne).length > 0 && (_s.setUserIdMap(ne), _s.setUserInfo(W)), Be({
      ...ie,
      accessToken: Ye,
      callType: ie.type
    }), _s.answerCall(!0, Ye);
  }, pt = async (ie) => {
    var W, ce, fe, we, Fe, je, qe, et;
    if (!se) return console.error("need getRTCToken method to get token");
    const ye = String(Math.ceil(Math.random() * 1e8)), { agoraUid: Ye, accessToken: ne } = await se({
      channel: ye,
      chatUserId: B.client.user
    });
    if (ie == "video" ? C == null || C({
      channel: ye
    }) : g == null || g({
      channel: ye
    }), V.chatType === "groupChat") {
      const bt = await ((W = p == null ? void 0 : p.onInvite) == null ? void 0 : W.call(p, { channel: ye, conversation: V, type: ie })), ot = bt == null ? void 0 : bt.map(($t) => $t.id), Lt = {
        callType: ie == "video" ? 2 : 3,
        chatType: "groupChat",
        to: ot,
        agoraUid: Ye,
        message: N(`Start a ${ie} meeting`),
        groupId: V.conversationId,
        groupName: V.name || "",
        accessToken: ne,
        channel: ye
      };
      _s.startCall(Lt), Be({
        channel: ye,
        accessToken: ne,
        groupId: V.conversationId,
        groupName: V.name || "",
        chatType: "groupChat",
        callType: ie == "video" ? 2 : 3
      });
      const Kt = {};
      bt == null || bt.forEach(($t) => {
        Kt[$t.id] = {
          nickname: $t.name,
          avatarUrl: $t.avatarurl
        };
      }), Kt[B.client.user] = {
        nickname: (ce = B.addressStore.appUsersInfo[B.client.user]) == null ? void 0 : ce.nickname,
        avatarUrl: (fe = B.addressStore.appUsersInfo[B.client.user]) == null ? void 0 : fe.avatarurl
      }, _s.setUserInfo(Kt);
      return;
    }
    const Qe = {
      callType: ie == "video" ? 1 : 0,
      chatType: "singleChat",
      to: V.conversationId,
      agoraUid: Ye,
      message: N(`Start a ${ie} call`),
      accessToken: ne,
      channel: ye
    };
    Be({
      channel: ye,
      accessToken: ne,
      targetId: V.conversationId,
      targetName: V.name || "",
      chatType: "singleChat",
      callType: ie == "video" ? 1 : 0
    }), _s.startCall(Qe);
    try {
      const bt = await ((we = p == null ? void 0 : p.getIdMap) == null ? void 0 : we.call(p, { userId: B.client.user, channel: ye }));
      _s.setUserIdMap(bt);
    } catch (bt) {
      console.error(bt);
    }
    _s.setUserInfo({
      [V.conversationId]: {
        nickname: ((Fe = B.addressStore.appUsersInfo[V.conversationId]) == null ? void 0 : Fe.nickname) || V.conversationId,
        avatarUrl: (je = B.addressStore.appUsersInfo[V.conversationId]) == null ? void 0 : je.avatarurl
      },
      // @ts-ignore
      [B.client.user]: {
        nickname: (qe = B.addressStore.appUsersInfo[B.client.user]) == null ? void 0 : qe.nickname,
        avatarUrl: (et = B.addressStore.appUsersInfo[B.client.user]) == null ? void 0 : et.avatarurl
      }
    });
  };
  lv(r, () => ({
    startVideoCall: () => {
      pt("video");
    },
    startAudioCall: () => {
      pt("audio");
    }
  })), Pn(() => {
    !p || !p.appId || _s.init(p.appId, p == null ? void 0 : p.agoraUid, B.client);
  }, [p == null ? void 0 : p.appId, p == null ? void 0 : p.agoraUid]);
  let It = !0, Rt = !0, gt = !0;
  ((nt = M == null ? void 0 : M.header) == null ? void 0 : nt.audioCall) == !1 && (It = !1), ((rt = M == null ? void 0 : M.header) == null ? void 0 : rt.videoCall) == !1 && (Rt = !1), p || (Rt = !1, It = !1), ((dt = M == null ? void 0 : M.header) == null ? void 0 : dt.pinMessage) === !1 && (gt = !1), ((lt = V.conversationId) == null ? void 0 : lt.indexOf("chatbot_")) > -1 && (Rt = !1, It = !1);
  const [it, Tt] = tn(""), [Ut, st] = tn(!1), [Ot, kt] = tn(""), wt = () => {
    B.client.reportMessage({
      reportType: Ot,
      reportReason: eh[Ot],
      messageId: it
    }).then(() => {
      mn.dispatchSuccess("reportMessage"), st(!1), kt("");
    }).catch((ie) => {
      mn.dispatchError("reportMessage", ie);
    });
  }, Et = () => {
    let ie = s == null ? void 0 : s.suffixIcon;
    return ie || (ie = ["PIN", "THREAD", "AUDIO", "VIDEO"]), ie instanceof Array ? ie.map((Ye) => Ye === "PIN" ? gt && /* @__PURE__ */ q.jsx(gi, { onClick: I, type: "text", shape: "circle", children: /* @__PURE__ */ q.jsx(pn, { width: 24, height: 24, type: "PIN" }) }, "pin") : Ye === "THREAD" ? V.chatType == "groupChat" && pe && /* @__PURE__ */ q.jsx(
      ECe,
      {
        style: { width: "540px" }
      },
      "thread"
    ) : Ye === "AUDIO" ? It && /* @__PURE__ */ q.jsx(
      gi,
      {
        onClick: () => pt("audio"),
        type: "text",
        shape: "circle",
        children: /* @__PURE__ */ q.jsx(pn, { type: "PHONE_PICK", width: 24, height: 24 })
      },
      "audio"
    ) : Ye === "VIDEO" ? Rt && /* @__PURE__ */ q.jsx(
      gi,
      {
        onClick: () => pt("video"),
        type: "text",
        shape: "circle",
        children: /* @__PURE__ */ q.jsx(pn, { type: "VIDEO_CAMERA", width: 24, height: 24 })
      },
      "video"
    ) : Ye) : (console.warn("suffixIcon is not valid"), null);
  };
  return /* @__PURE__ */ q.jsxs("div", { className: U, style: { ...m }, children: [
    k ? v ? v() : /* @__PURE__ */ q.jsx(Pm, { text: N("noConversation") }) : /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
      h ? (
        // @ts-ignore
        h(B.conversationStore.currentCvs)
      ) : /* @__PURE__ */ q.jsx(
        au,
        {
          avatarSrc: vRe(V),
          presence: {
            visible: !!((Ie = (Ct = D == null ? void 0 : D.conversationList) == null ? void 0 : Ct.item) != null && Ie.presence) && V.chatType === "singleChat" && typeof j < "u" && !V.conversationId.includes("chatbot"),
            icon: (j == null ? void 0 : j[(x = B.addressStore.appUsersInfo[V.conversationId]) != null && x.isOnline ? ((ae = B.addressStore.appUsersInfo[V.conversationId]) == null ? void 0 : ae.presenceExt) ?? "Online" : "Offline"]) || (j == null ? void 0 : j.Custom)
          },
          subtitle: !!((Z = (Q = D == null ? void 0 : D.conversationList) == null ? void 0 : Q.item) != null && Z.presence) && V.chatType === "singleChat" && typeof j < "u" && !V.conversationId.includes("chatbot") && ((ge = B.addressStore.appUsersInfo[V.conversationId]) != null && ge.isOnline ? N(((me = B.addressStore.appUsersInfo[V.conversationId]) == null ? void 0 : me.presenceExt) ?? "") ?? N("Online") : N("Offline")),
          suffixIcon: Et(),
          content: B.conversationStore.currentCvs.name || B.conversationStore.currentCvs.conversationId,
          moreAction: Ce,
          ...ue
        }
      ),
      b ? b() : /* @__PURE__ */ q.jsx(
        cv,
        {
          ...c,
          onOpenThreadPanel: (ie) => {
            E == null || E({
              id: ie
            });
          },
          messageProps: { ...xe, ...c == null ? void 0 : c.messageProps }
        }
      ),
      (d == null ? void 0 : d.enabledTyping) && /* @__PURE__ */ q.jsx(
        MOe,
        {
          conversation: B.conversationStore.currentCvs,
          onHide: () => {
            B.messageStore.setTyping(B.conversationStore.currentCvs, !1);
          }
        }
      ),
      he && (O ? O(B.messageStore.repliedMessage) : /* @__PURE__ */ q.jsx(aY, { type: "summary" })),
      l ? l() : /* @__PURE__ */ q.jsx(zv, { ...be, ...d })
    ] }),
    /* @__PURE__ */ q.jsx(
      _s,
      {
        onAddPerson: Ke,
        onStateChange: Ze,
        onInvite: at,
        contactAvatar: (ve = B.addressStore.appUsersInfo[$e.targetId]) == null ? void 0 : ve.avatarurl,
        groupAvatar: /* @__PURE__ */ q.jsx(zs, { className: "cui-callkit-groupAvatar", src: p == null ? void 0 : p.groupAvatar, children: V.name })
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: Ut,
        title: N("report"),
        okText: N("report"),
        cancelText: N("cancel"),
        okButtonProps: {
          disabled: Ot == ""
        },
        onOk: wt,
        onCancel: () => {
          st(!1);
        },
        children: /* @__PURE__ */ q.jsxs("div", { children: [
          /* @__PURE__ */ q.jsx(
            "div",
            {
              className: En("report-title", {
                "report-title-dark": G == "dark"
              }),
              children: N("Violation")
            }
          ),
          Object.keys(eh).map((ie, ye) => /* @__PURE__ */ q.jsxs(
            "div",
            {
              className: En("report-item", {
                "report-item-dark": G == "dark"
              }),
              onClick: () => {
                kt(ie);
              },
              children: [
                /* @__PURE__ */ q.jsx("div", { children: N(eh[ie]) }),
                /* @__PURE__ */ q.jsx(
                  Bv,
                  {
                    checked: Ot === ie
                  }
                )
              ]
            },
            ye
          ))
        ] })
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: Le,
        title: N("deleteMessage"),
        onCancel: () => {
          Te(!1), Oe(null);
        },
        onOk: () => {
          if (!K) return;
          const ie = ar(K);
          B.messageStore.deleteMessage(
            {
              chatType: K.chatType,
              conversationId: ie
            },
            // @ts-ignore
            K.mid || K.id
          ), Te(!1), Oe(null);
        },
        children: /* @__PURE__ */ q.jsx("div", { children: `${N("Delete this message")}?` })
      }
    )
  ] });
});
dv = mi(dv);
dv.displayName = "Chat";
dv.displayName = "Chat";
const B3e = dv;
function VB({
  prefixCls: t,
  value: r,
  current: a,
  offset: u = 0
}) {
  let h;
  return u && (h = {
    position: "absolute",
    top: `${u}00%`,
    left: 0
  }), /* @__PURE__ */ q.jsx(
    "span",
    {
      style: h,
      className: En(`${t}-only-unit`, {
        current: a
      }),
      children: r
    }
  );
}
function TRe(t, r, a) {
  let u = t, h = 0;
  for (; (u + 10) % 10 !== r; )
    u += a, h += a;
  return h;
}
function bRe(t) {
  const { prefixCls: r, count: a, value: u } = t, h = Number(u), b = Math.abs(a), [l, v] = ht.useState(h), [s, c] = ht.useState(b), d = () => {
    v(h), c(b);
  };
  ht.useEffect(() => {
    const E = setTimeout(() => {
      d();
    }, 1e3);
    return () => {
      clearTimeout(E);
    };
  }, [h]);
  let p, m;
  if (l === h || Number.isNaN(h) || Number.isNaN(l))
    p = [/* @__PURE__ */ rg(VB, { ...t, key: h, current: !0 })], m = {
      transition: "none"
    };
  else {
    p = [];
    const E = h + 10, y = [];
    for (let O = h; O <= E; O += 1)
      y.push(O);
    const g = y.findIndex((O) => O % 10 === l);
    p = y.map((O, N) => {
      const w = O % 10;
      return /* @__PURE__ */ rg(
        VB,
        {
          ...t,
          key: O,
          value: w,
          offset: N - g,
          current: N === g
        }
      );
    });
    const C = s < b ? 1 : -1;
    m = {
      transform: `translateY(${-TRe(l, h, C)}00%)`
    };
  }
  return /* @__PURE__ */ q.jsx(
    "span",
    {
      className: `${r}-only`,
      style: m,
      onTransitionEnd: d,
      children: p
    }
  );
}
const ARe = ({
  prefixCls: t,
  count: r,
  className: a,
  motionClassName: u,
  style: h,
  title: b,
  show: l,
  component: v = "sup",
  children: s,
  ...c
}) => {
  const { getPrefixCls: d } = ht.useContext(Hn), p = d("scroll-number", t), m = {
    ...c,
    "data-show": l,
    style: h,
    className: En(p, a, u),
    title: b
  };
  let E = r;
  if (r && Number(r) % 1 === 0) {
    const y = String(r).split("");
    E = y.map((g, C) => /* @__PURE__ */ q.jsx(
      bRe,
      {
        prefixCls: p,
        count: Number(r),
        value: g
      },
      y.length - C
    ));
  }
  return h && h.borderColor && (m.style = {
    ...h,
    boxShadow: `0 0 0 1px ${h.borderColor} inset`
  }), s ? Vl(s, (y) => ({
    className: En(
      `${p}-custom-component`,
      y == null ? void 0 : y.className,
      u
    )
  })) : ht.createElement(v, m, E);
}, ORe = ({
  count: t,
  overflowCount: r = 99,
  dot: a = !1,
  showZero: u = !1,
  style: h,
  className: b,
  // text,
  size: l = "default",
  offset: v,
  title: s,
  children: c,
  color: d,
  scrollNumberPrefixCls: p,
  prefixCls: m,
  ...E
}) => {
  const { getPrefixCls: y } = Zn(Hn), g = y("badge", m), C = t > r ? `${r}+` : t, O = C === "0" || C === 0, N = a && !O, w = N ? "" : C, _ = Wy(() => (w == null || w === "" || O && !u) && !N, [w, O, u, N]), I = er(t);
  _ || (I.current = t);
  const k = I.current, H = er(w);
  _ || (H.current = w);
  const S = H.current, B = er(N);
  _ || (B.current = N);
  const D = Wy(() => v ? {
    ...{
      marginTop: v[1],
      marginLeft: v[0]
    },
    ...h
  } : { ...h }, [v, h]), F = En(
    g,
    {
      [`${g}-not-a-wrapper`]: !c
    },
    b
  ), j = s ?? (typeof k == "string" || typeof k == "number" ? k : void 0), G = !k || typeof k != "object" ? void 0 : Vl(k, (U) => ({
    style: {
      ...D,
      ...U.style
    }
  }));
  return /* @__PURE__ */ q.jsxs("span", { ...E, className: F, children: [
    c,
    /* @__PURE__ */ q.jsx(
      mh,
      {
        visible: !_,
        motionName: `${g}-zoom`,
        motionAppear: !1,
        motionDeadline: 1e3,
        children: ({ className: U }) => {
          const M = y(
            "scroll-number",
            p
          ), V = B.current, J = En({
            [`${g}-dot`]: V,
            [`${g}-count`]: !V,
            [`${g}-count-sm`]: l === "small",
            [`${g}-multiple-words`]: !V && S && S.toString().length > 1
            // [`${prefixCls}-status-${color}`]: isPresetColor(color),
          });
          let ue = {
            ...D
          };
          return d && (ue = ue || {}, ue.background = d), /* @__PURE__ */ q.jsx(
            ARe,
            {
              prefixCls: M,
              show: !_,
              motionClassName: U,
              className: J,
              count: S,
              title: j,
              style: ue,
              children: G
            },
            "scrollNumber"
          );
        }
      }
    )
  ] });
};
let qN = (t) => {
  var _e, Le, Te, K, Oe, Pe, xe, be, $e, Be;
  let {
    prefix: r,
    className: a,
    nickname: u,
    avatarShape: h = "circle",
    avatarSize: b = 50,
    avatar: l,
    onClick: v,
    isActive: s = !1,
    data: c,
    badgeColor: d,
    moreAction: p = {
      visible: !0,
      actions: [
        {
          content: "DELETE"
        },
        {
          content: "PIN"
        },
        {
          content: "SILENT"
        }
      ]
    },
    formatDateTime: m,
    renderMessageContent: E,
    ripple: y,
    ...g
  } = t;
  const { t: C } = Yr(), { getPrefixCls: O } = _t.useContext(Hn), N = O("conversationItem", r), [w, _] = tn(!1), [I, k] = tn(!1);
  tn(s);
  const H = Zn(Vn), { rootStore: S, theme: B } = H, D = (B == null ? void 0 : B.mode) || "light";
  B != null && B.avatarShape && (h = B == null ? void 0 : B.avatarShape);
  const F = B == null ? void 0 : B.ripple, j = S.conversationStore, G = En(
    N,
    {
      [`${N}-selected`]: !!s,
      [`${N}-${D}`]: !!D,
      [`${N}-sticky`]: c.isPinned
    },
    a
  ), U = (Ke) => {
    const { type: Ze = "NONE" } = Ke;
    return Ze === "NONE" ? /* @__PURE__ */ q.jsx(q.Fragment, {}) : /* @__PURE__ */ q.jsx("div", { className: `${N}-at-tag`, children: C(Ze === "ALL" ? "atAllTag" : "atTag") });
  }, M = (Ke) => {
    S == null || S.conversationStore.setAtType(c.chatType, c.conversationId, "NONE"), v && v(Ke);
  }, V = () => {
    p.visible && _(!0);
  }, J = () => {
    I || _(!1);
  }, ue = async (Ke) => {
    Ke.stopPropagation();
    const Ze = p.actions.find((at) => at.content === "DELETE");
    Ze && Ze.onClick && !await Ze.onClick(c) || (j.deleteConversation(c), S.client.deleteConversation({
      channel: c.conversationId,
      chatType: c.chatType,
      deleteRoam: !0
    }).then(() => {
      mn.dispatchSuccess("deleteConversation");
    }).catch((at) => {
      mn.dispatchError("deleteConversation", at);
    }), k(!1));
  }, se = () => {
    S == null || S.conversationStore.pinConversation(
      c.chatType,
      c.conversationId,
      !c.isPinned
    ), k(!1);
  }, ee = () => {
    c.silent ? S == null || S.conversationStore.clearRemindTypeForConversation({
      chatType: c.chatType,
      conversationId: c.conversationId
    }) : S == null || S.conversationStore.setSilentModeForConversation({
      chatType: c.chatType,
      conversationId: c.conversationId
    }), k(!1);
  }, de = O("moreAction", r);
  let he;
  p != null && p.visible && (he = /* @__PURE__ */ q.jsx("ul", { className: de, children: p.actions.map((Ke, Ze) => Ke.content === "DELETE" ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: ue,
      className: D == "dark" ? "cui-li-dark" : "",
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: "DELETE" }),
        C("deleteCvs")
      ]
    },
    Ze
  ) : Ke.content === "PIN" ? /* @__PURE__ */ q.jsxs("li", { onClick: se, className: D == "dark" ? "cui-li-dark" : "", children: [
    /* @__PURE__ */ q.jsx(pn, { type: c.isPinned ? "ARROW_LINE" : "LINE_ARROW" }),
    c.isPinned ? C("unSticky") : C("sticky")
  ] }, Ze) : Ke.content === "SILENT" ? /* @__PURE__ */ q.jsxs(
    "li",
    {
      onClick: ee,
      className: D == "dark" ? "cui-li-dark" : "",
      children: [
        /* @__PURE__ */ q.jsx(pn, { type: c.silent ? "BELL_SLASH" : "BELL" }),
        c.silent ? C("unmuteNotification") : C("muteNotification")
      ]
    },
    Ze
  ) : /* @__PURE__ */ q.jsx(
    "li",
    {
      className: D == "dark" ? "cui-li-dark" : "",
      onClick: () => {
        var at;
        (at = Ke.onClick) == null || at.call(Ke, c);
      },
      children: Ke.content
    },
    Ze
  )) }));
  let pe = "";
  switch ((_e = c.lastMessage) == null ? void 0 : _e.type) {
    case "txt":
      ((Le = c.lastMessage) == null ? void 0 : Le.msg) == "the combine message" ? pe = `/${C("chatHistory")}/` : pe = Nd((Te = c.lastMessage) == null ? void 0 : Te.msg, !1);
      break;
    case "img":
      pe = `[${C("image")}]`;
      break;
    case "audio":
      pe = `[${C("audio")}]`;
      break;
    case "file":
      pe = `[${C("file")}]`;
      break;
    case "video":
      pe = `[${C("video")}]`;
      break;
    case "custom":
      c.lastMessage.customEvent == "userCard" ? pe = `[${C("contact")}]` : pe = `[${C("custom")}]`;
      break;
    case "combine":
      pe = `[${C("chatHistory")}]`;
      break;
    case "recall":
      pe = C("unsentAMessage");
      break;
    default:
      console.warn("unexpected message type:", (K = c.lastMessage) == null ? void 0 : K.type);
      break;
  }
  if (pe = (E == null ? void 0 : E(c.lastMessage)) ?? pe, c.chatType == "groupChat") {
    const Ke = ((Oe = c.lastMessage) == null ? void 0 : Oe.from) || "";
    let Ze = Ke && Ke !== S.client.context.userId ? `${Ke}: ` : "";
    const at = jd(c.conversationId);
    if (at) {
      const pt = aA(at, Ke) ?? -1, It = (xe = (Pe = c.lastMessage) == null ? void 0 : Pe.ext) == null ? void 0 : xe.ease_chat_uikit_user_info;
      if (It && It.nickname)
        Ze = `${It.nickname}: `;
      else if (pt > -1) {
        const Rt = ((be = at == null ? void 0 : at.members) == null ? void 0 : be[pt]) || {};
        Ze = `${ah(Rt)}: `;
      }
    }
    Array.isArray(pe) ? pe = [Ze, ...Array.from(pe)] : pe = [Ze, pe];
  }
  const Ce = y === void 0 ? F : y;
  return /* @__PURE__ */ q.jsxs(
    "div",
    {
      className: G,
      onClick: M,
      style: g.style,
      onMouseOver: V,
      onMouseLeave: J,
      children: [
        l || // 在会话列表不显示在线状态 isOnline={data.isOnline}
        /* @__PURE__ */ q.jsx(zs, { src: c.avatarUrl, size: b, shape: h, children: c.name || c.conversationId }),
        /* @__PURE__ */ q.jsxs("div", { className: `${N}-content`, children: [
          /* @__PURE__ */ q.jsxs("span", { className: `${N}-nickname ${c.silent ? "has-silent" : ""}`, children: [
            c.name || c.conversationId,
            c.silent && /* @__PURE__ */ q.jsx(pn, { type: "BELL_SLASH", className: `${N}-nickname-silent` })
          ] }),
          /* @__PURE__ */ q.jsxs("span", { className: `${N}-message`, children: [
            /* @__PURE__ */ q.jsx(U, { type: c == null ? void 0 : c.atType }),
            pe
          ] })
        ] }),
        /* @__PURE__ */ q.jsxs("div", { className: `${N}-info`, children: [
          /* @__PURE__ */ q.jsx("span", { className: `${N}-time`, children: (m == null ? void 0 : m(($e = c.lastMessage) == null ? void 0 : $e.time)) || Tm((Be = c.lastMessage) == null ? void 0 : Be.time) }),
          w ? /* @__PURE__ */ q.jsx(
            va,
            {
              title: he,
              trigger: "click",
              placement: "bottomRight",
              open: I,
              onOpenChange: (Ke) => {
                k(Ke), _(Ke);
              },
              children: p.icon || /* @__PURE__ */ q.jsx(
                pn,
                {
                  type: "ELLIPSIS",
                  color: D === "dark" ? "var(--cui-primary-color6)" : "var(--cui-primary-color5)",
                  height: 20,
                  width: 20,
                  style: { cursor: "pointer", zIndex: 10 }
                }
              )
            }
          ) : /* @__PURE__ */ q.jsx(
            "div",
            {
              style: {
                height: "20px",
                position: "relative"
              },
              children: /* @__PURE__ */ q.jsx(
                ORe,
                {
                  dot: c.silent,
                  count: c.unreadCount || 0,
                  color: d || D === "dark" ? "var(--cui-primary-color6)" : "var(--cui-primary-color5)"
                }
              )
            }
          )
        ] }),
        Ce && /* @__PURE__ */ q.jsx(qw, {})
      ]
    }
  );
};
qN = mi(qN);
const CRe = Fv(), SRe = (t) => {
  var $e, Be, Ke, Ze, at, pt, It;
  const {
    prefix: r,
    className: a,
    onItemClick: u,
    onSearch: h,
    renderHeader: b,
    renderSearch: l,
    renderItem: v,
    headerProps: s = {},
    itemProps: c = {},
    style: d = {},
    presence: p,
    showSearchList: m
  } = t, { getPrefixCls: E } = _t.useContext(Hn), y = E("conversationList", r), [g, C] = tn(), { getJoinedGroupList: O } = hY(), [N, w] = tn(!1), [_, I] = tn([]), [k, H] = tn([]), S = Zn(Vn), { rootStore: B, features: D, theme: F, initConfig: j } = S, { useUserInfo: G } = j, U = (F == null ? void 0 : F.mode) || "light", M = En(
    y,
    {
      [`${y}-${U}`]: !!U
    },
    a
  ), V = B.conversationStore, { appUsersInfo: J, contacts: ue } = B.addressStore, { t: se } = Yr(), { getConversationList: ee, hasConversationNext: de } = Nme(), he = (D == null ? void 0 : D.conversationList) || {}, pe = p || (($e = he == null ? void 0 : he.item) == null ? void 0 : $e.presence) != !1;
  G && Qw("conversation", pe);
  const Ce = B.addressStore.groups, _e = (Rt, gt) => () => {
    C(Rt.conversationId), V.currentCvs.conversationId !== Rt.conversationId && V.setCurrentCvs({
      chatType: Rt.chatType,
      conversationId: Rt.conversationId,
      name: Rt.name,
      unreadCount: 0
    }), u == null || u(Rt);
  };
  Pn(() => {
    !V.currentCvs || V.currentCvs && Object.keys(V.currentCvs).length == 0 ? C("-1") : C(V.currentCvs.conversationId);
  }, [V.currentCvs]), Pn(() => {
    if (N || m)
      I(V.searchList);
    else {
      const Rt = V.conversationList.map((gt) => {
        var Tt, Ut;
        const it = { ...gt };
        if (gt.chatType == "groupChat")
          Ce.forEach((st) => {
            gt.conversationId == st.groupid && (it.name = it.name || st.groupname, it.avatarUrl = st.avatarUrl);
          });
        else if (gt.chatType == "singleChat") {
          it.name = it.name || ((Tt = J == null ? void 0 : J[gt.conversationId]) == null ? void 0 : Tt.nickname), it.avatarUrl = (Ut = J == null ? void 0 : J[gt.conversationId]) == null ? void 0 : Ut.avatarurl;
          const st = ue == null ? void 0 : ue.find((Ot) => Ot.userId == gt.conversationId);
          st != null && st.remark && (it.name = st.remark);
        }
        return it;
      });
      I(Rt), H(Rt);
    }
  }, [V.conversationList, V.searchList, Ce.length, J, ue]), Pn(() => {
    var Rt;
    (Rt = V.conversationList) == null || Rt.forEach((gt) => {
      !gt.name && gt.chatType == "groupChat" && B.addressStore.groups.length > 0 && (B.addressStore.groups.find((Tt) => Tt.groupid === gt.conversationId) || V.updateConversationName(gt.chatType, gt.conversationId));
    });
  }, [(Be = V.conversationList) == null ? void 0 : Be.length]);
  const Le = (Rt) => {
    const gt = Rt.target.value;
    if ((h == null ? void 0 : h(Rt)) === !1) {
      w(gt.length > 0);
      return;
    }
    const Tt = k.filter((Ut) => {
      var st;
      return !!(Ut.conversationId.includes(gt) || (st = Ut.name) != null && st.includes(gt));
    });
    w(gt.length > 0), V.setSearchList(Tt);
  }, [Te, K] = tn(!1), [Oe, Pe] = tn();
  Pn(() => {
    B.loginState && (ee().then(() => {
      var Rt;
      ((Rt = he == null ? void 0 : he.item) == null ? void 0 : Rt.pinConversation) != !1 && B.conversationStore.getServerPinnedConversations();
    }), O(), G && xd({
      userIdList: [B.client.user]
    }).catch((Rt) => {
      console.warn("getUsersInfo error", Rt);
    }));
  }, [B.loginState]);
  let xe;
  (Ke = he == null ? void 0 : he.item) != null && Ke.moreAction && (xe = {
    visible: !0,
    actions: []
  }, ((Ze = he == null ? void 0 : he.item) == null ? void 0 : Ze.deleteConversation) != !1 && xe.actions.push({
    content: "DELETE",
    onClick: (Rt) => (K(!0), new Promise((it, Tt) => {
      Pe({
        resolve: it,
        reject: Tt
      });
    }))
  }), ((at = he == null ? void 0 : he.item) == null ? void 0 : at.pinConversation) != !1 && xe.actions.push({
    content: "PIN"
  }), ((pt = he == null ? void 0 : he.item) == null ? void 0 : pt.muteConversation) != !1 && xe.actions.push({
    content: "SILENT"
  })), ((It = he == null ? void 0 : he.item) == null ? void 0 : It.moreAction) == !1 && (xe = {
    visible: !1,
    actions: []
  });
  let be = !0;
  return he.search == !1 && (be = !1), /* @__PURE__ */ q.jsxs("div", { className: M, style: d, children: [
    b ? b() : /* @__PURE__ */ q.jsx(
      au,
      {
        ...s,
        back: s.back || !1,
        content: s.content || se("conversationTitle"),
        icon: s.icon || /* @__PURE__ */ q.jsx(pn, { type: "PLUS_IN_CIRCLE", height: 24, width: 24 })
      }
    ),
    l ? l() : be && /* @__PURE__ */ q.jsx("div", { className: `${y}-search`, children: /* @__PURE__ */ q.jsx(_b, { onChange: Le }) }),
    /* @__PURE__ */ q.jsx(
      CRe,
      {
        hasMore: de,
        data: _,
        scrollDirection: "down",
        loading: !1,
        loadMoreItems: ee,
        renderItem: (Rt, gt) => v ? v(Rt, gt) : /* @__PURE__ */ rg(
          qN,
          {
            moreAction: xe,
            ...c,
            data: Rt,
            key: Rt.conversationId,
            isActive: Rt.conversationId === g,
            onClick: _e(Rt)
          }
        )
      }
    ),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        open: Te,
        title: se("deleteConversation"),
        onCancel: () => {
          var Rt;
          (Rt = Oe == null ? void 0 : Oe.resolve) == null || Rt.call(Oe, !1), K(!1);
        },
        onOk: () => {
          var Rt;
          (Rt = Oe == null ? void 0 : Oe.resolve) == null || Rt.call(Oe, !0), Pe(void 0), K(!1);
        },
        children: /* @__PURE__ */ q.jsx("div", { children: `${se("Delete this conversation")}?` })
      }
    )
  ] });
}, z3e = mi(SRe), IRe = ({
  checked: t,
  onChange: r,
  disabled: a,
  className: u = "",
  style: h = {}
}) => {
  const [b, l] = tn(t), { getPrefixCls: v } = _t.useContext(Hn), s = v("switch"), c = a ? En(s, u, `${s}-disabled`) : En(s, u);
  Pn(() => {
    l(t);
  }, [t]);
  function d(p) {
    if (a) return;
    const m = p.currentTarget.checked;
    t === void 0 && l(m), r && r(p);
  }
  return /* @__PURE__ */ q.jsxs("label", { className: c, style: { ...h }, children: [
    /* @__PURE__ */ q.jsx(
      "input",
      {
        type: "checkbox",
        checked: b,
        onChange: d,
        className: `${s}-checkbox`
      }
    ),
    /* @__PURE__ */ q.jsx(
      "div",
      {
        className: b ? `${s}-container ${s}-container-checked` : `${s}-container`
      }
    )
  ] });
}, RRe = (t) => {
  const {
    style: r,
    className: a,
    prefix: u,
    onItemClick: h,
    checkable: b,
    groupMembers: l = [],
    onPrivateChat: v,
    onAddContact: s,
    onClickBack: c,
    groupId: d,
    onUserSelect: p,
    enableMultipleSelection: m,
    isOwner: E = !0,
    headerProps: y,
    moreAction: g,
    checkedUsers: C
  } = t, { getPrefixCls: O } = _t.useContext(Hn), N = O("group-member", u), w = _t.useContext(Vn), { rootStore: _, theme: I, features: k } = w, { addressStore: H, conversationStore: S } = _, B = (I == null ? void 0 : I.mode) || "light", { t: D } = Yr();
  Zw();
  const F = En(
    N,
    {
      [`${N}-${B}`]: !!B
    },
    a
  );
  _.addressStore.groups.find((_e) => _e.groupid == d);
  const j = l.filter((_e) => {
    if (_e.userId.indexOf("chatbot_") > -1)
      return {
        userId: _e.userId
      };
  }), G = (_e) => {
    var K, Oe;
    if ((v == null ? void 0 : v(_e)) == !1) return;
    const Te = (Oe = (K = H.appUsersInfo) == null ? void 0 : K[_e]) == null ? void 0 : Oe.nickname;
    S.addConversation({
      chatType: "singleChat",
      conversationId: _e,
      name: Te,
      lastMessage: {
        time: Date.now(),
        type: "txt",
        msg: "",
        id: "",
        chatType: "singleChat",
        to: _e
      },
      unreadCount: 0
    }), S.setCurrentCvs({
      chatType: "singleChat",
      conversationId: _e,
      name: Te
    }), v == null || v(_e);
  }, U = (_e) => {
    (s == null ? void 0 : s(_e)) != !1 && _.addressStore.addContact(_e);
  }, M = () => {
    if (J.type == "add") {
      const _e = se.map((Le) => Le.userId);
      _.addressStore.inviteToGroup(d, _e);
    } else {
      const _e = se.map((Le) => Le.userId);
      _.addressStore.removeGroupMembers(d, _e);
    }
    ue({
      ...J,
      open: !1
    }), ee([]);
  }, V = () => {
    const _e = l.map((Le) => {
      var Te, K, Oe, Pe;
      return {
        userId: Le.userId,
        nickname: (K = (Te = H.appUsersInfo) == null ? void 0 : Te[Le.userId]) == null ? void 0 : K.nickname,
        avatarUrl: (Pe = (Oe = H.appUsersInfo) == null ? void 0 : Oe[Le.userId]) == null ? void 0 : Pe.avatarurl
      };
    });
    ue({
      title: D("removeGroupMembers"),
      users: _e,
      type: "delete",
      open: !0
    });
  }, [J, ue] = tn({
    title: D("addGroupMembers"),
    users: [],
    type: "add",
    open: !1
  }), [se, ee] = tn([]), [de, he] = tn([]), pe = (_e, Le) => {
    if (_e) {
      if (!m) {
        he((Te) => [Le]), p == null || p(
          {
            ...Le,
            type: "add"
          },
          [Le]
        );
        return;
      }
      he((Te) => (p == null || p(
        {
          ...Le,
          type: "add"
        },
        [...Te, Le]
      ), [...Te, Le]));
    } else {
      if (!m) {
        he([]), p == null || p(
          {
            ...Le,
            type: "delete"
          },
          []
        );
        return;
      }
      he((Te) => {
        const K = Te.filter((Oe) => Oe.userId !== Le.userId);
        return p == null || p(
          {
            ...Le,
            type: "delete"
          },
          K
        ), K;
      });
    }
  }, Ce = (l == null ? void 0 : l.map((_e) => {
    const Le = { ..._e };
    return Le.isInContact = H.contacts.some((Te) => Te.userId === _e.userId), Le;
  })) || [];
  return /* @__PURE__ */ q.jsxs("div", { className: F, style: { ...r }, children: [
    /* @__PURE__ */ q.jsx(
      au,
      {
        avatar: /* @__PURE__ */ q.jsx(q.Fragment, {}),
        back: !0,
        content: D("groupMembers"),
        onClickBack: c,
        suffixIcon: E ? /* @__PURE__ */ q.jsxs("div", { children: [
          /* @__PURE__ */ q.jsx(
            pn,
            {
              type: "PERSON_ADD",
              style: {
                padding: "6px",
                margin: "2px",
                width: "24px",
                height: "24px",
                cursor: "pointer"
              },
              onClick: () => {
                ue({
                  title: D("addGroupMembers"),
                  users: [],
                  type: "add",
                  open: !0
                });
              }
            }
          ),
          /* @__PURE__ */ q.jsx(
            pn,
            {
              type: "PERSON_MINUS",
              style: {
                padding: "6px",
                margin: "2px",
                width: "24px",
                height: "24px",
                cursor: "pointer"
              },
              onClick: V
            }
          )
        ] }) : null,
        ...y
      }
    ),
    /* @__PURE__ */ q.jsx("div", { className: `${N}-container`, children: Ce == null ? void 0 : Ce.map((_e) => {
      var Oe, Pe, xe, be, $e, Be;
      let Le = (Pe = (Oe = H.appUsersInfo) == null ? void 0 : Oe[_e.userId]) == null ? void 0 : Pe.nickname;
      const Te = (be = (xe = H.appUsersInfo) == null ? void 0 : xe[_e.userId]) == null ? void 0 : be.avatarurl;
      ($e = _e.attributes) != null && $e.nickName && (Le = (Be = _e.attributes) == null ? void 0 : Be.nickName);
      const K = H.contacts.find((Ke) => Ke.userId === _e.userId);
      return K && K.remark && (Le = K.remark), /* @__PURE__ */ q.jsx(
        Md,
        {
          avatarSize: 40,
          avatarShape: I == null ? void 0 : I.avatarShape,
          data: { userId: _e.userId, nickname: Le, avatarUrl: Te },
          checkable: b,
          disabled: C == null ? void 0 : C.some((Ke) => Ke.userId == _e.userId),
          checked: de && de.map((Ke) => Ke.userId).includes(_e.userId) || (C == null ? void 0 : C.some((Ke) => Ke.userId == _e.userId)),
          onCheckboxChange: pe,
          moreAction: g || (_e.userId == _.client.user ? void 0 : {
            visible: !0,
            icon: /* @__PURE__ */ q.jsx(
              pn,
              {
                type: "ELLIPSIS",
                height: 20,
                color: B === "dark" ? "var(--cui-primary-color6)" : "var(--cui-primary-color5)",
                style: { cursor: "pointer", zIndex: 10 }
              }
            ),
            actions: [
              {
                icon: /* @__PURE__ */ q.jsx(
                  pn,
                  {
                    type: _e.isInContact ? "BUBBLE_FILL" : "PERSON_ADD_FILL",
                    width: 18,
                    height: 18
                  }
                ),
                content: _e.isInContact ? D("privateChat") : D("addContact"),
                onClick: () => {
                  _e.isInContact ? G(_e.userId) : U(_e.userId);
                }
              }
            ]
          }),
          onClick: (Ke) => {
            C != null && C.some((Ze) => Ze.userId == _e.userId) || pe(!de.map((Ze) => Ze.userId).includes(_e.userId), {
              userId: _e.userId,
              nickname: Le,
              avatarUrl: Te
            });
          }
        },
        _e.userId
      );
    }) }),
    /* @__PURE__ */ q.jsx(
      gY,
      {
        title: J.title,
        selectedPanelHeader: /* @__PURE__ */ q.jsx(q.Fragment, {}),
        onCancel: () => {
          ue({
            ...J,
            open: !1
          }), ee([]);
        },
        selectedPanelFooter: /* @__PURE__ */ q.jsxs("div", { children: [
          /* @__PURE__ */ q.jsx(
            gi,
            {
              style: { marginRight: "24px", width: "68px" },
              type: "primary",
              onClick: () => {
                M();
              },
              disabled: se.length === 0,
              children: D("confirmBtn")
            }
          ),
          /* @__PURE__ */ q.jsx(
            gi,
            {
              style: { width: "68px" },
              type: "default",
              onClick: () => {
                ue({
                  ...J,
                  open: !1
                }), ee([]);
              },
              children: D("cancelBtn")
            }
          )
        ] }),
        closable: !0,
        enableMultipleSelection: !0,
        open: J.open,
        onUserSelect: (_e, Le) => {
          ee(Le);
        },
        users: J.users,
        checkedUsers: J.type == "add" ? l : [
          {
            userId: _.client.user
          },
          ...j
        ]
      }
    )
  ] });
}, NRe = mi(RRe), bX = (t) => {
  var Tt, Ut;
  const {
    conversation: r,
    style: a,
    className: u,
    prefix: h,
    onUserIdCopied: b,
    groupMemberProps: l,
    onLeaveGroup: v,
    onDestroyGroup: s,
    onGroupMemberVisibleChange: c
  } = t, { getPrefixCls: d } = _t.useContext(Hn), p = d("groupSetting", h), m = Zn(Vn), { rootStore: E, theme: y, features: g, initConfig: C } = m, { addressStore: O } = E, N = (y == null ? void 0 : y.mode) || "light", w = (y == null ? void 0 : y.componentsShape) || "round", { t: _ } = Yr(), I = En(
    p,
    {
      [`${p}-${N}`]: !!N
    },
    u
  ), k = En(`${p}-member-box`, {
    [`${p}-${N}`]: !!N
  }), { useUserInfo: H } = C, { getGroupMemberList: S } = $w(r.conversationId, H ?? !0);
  r.conversationId && (S == null || S());
  const B = E.addressStore.groups.find(
    (st) => st.groupid == r.conversationId
  );
  Pn(() => {
    r.conversationId && (r.chatType === "groupChat" && E.addressStore.getGroupInfo(r.conversationId), !((B == null ? void 0 : B.silent) !== void 0 || !r.conversationId) && O.getSilentModeForConversations([
      {
        conversationId: r.conversationId,
        chatType: r.chatType
      }
    ]));
  }, [r]);
  const D = B == null ? void 0 : B.info, j = (D == null ? void 0 : D.owner) == E.client.user, G = B == null ? void 0 : B.members, U = G == null ? void 0 : G.filter((st) => st.userId === E.client.user)[0], M = B == null ? void 0 : B.avatarUrl, V = () => {
    const st = document.createElement("textarea");
    st.value = r.conversationId, document.body.appendChild(st), st.select(), document.execCommand("copy"), document.body.removeChild(st), b == null || b(r.conversationId);
  }, [J, ue] = tn(!1), [se, ee] = tn(((Tt = U == null ? void 0 : U.attributes) == null ? void 0 : Tt.nickName) || "");
  Pn(() => {
    var st;
    ee(((st = U == null ? void 0 : U.attributes) == null ? void 0 : st.nickName) || "");
  }, [(Ut = U == null ? void 0 : U.attributes) == null ? void 0 : Ut.nickName]);
  const de = (st) => {
    st.target.value.length > 20 || ee(st.target.value);
  }, he = () => {
    E.addressStore.setGroupMemberAttributesAsync(
      r.conversationId,
      E.client.user,
      {
        nickName: se
      }
    ), ue(!1);
  }, pe = (st) => {
    const Ot = st.target.checked;
    E.addressStore.setSilentModeForConversation(
      {
        conversationId: r.conversationId,
        chatType: r.chatType
      },
      Ot
    );
  }, [Ce, _e] = tn(!1), Le = () => {
    E.messageStore.clearMessage(r), _e(!1);
  }, [Te, K] = tn(!1), [Oe, Pe] = tn({
    name: "",
    description: ""
  });
  Pn(() => {
    Pe({
      name: (D == null ? void 0 : D.name) || "",
      description: (D == null ? void 0 : D.description) || ""
    });
  }, [D == null ? void 0 : D.name]);
  const xe = (st, Ot) => {
    Pe({
      ...Oe,
      [Ot]: st.target.value
    });
  }, be = () => {
    E.addressStore.modifyGroup(
      r.conversationId,
      Oe.name,
      Oe.description
    ), K(!1);
  }, [$e, Be] = tn(!1), Ke = () => {
    j ? (E.addressStore.destroyGroup(r.conversationId), s == null || s()) : (E.addressStore.leaveGroup(r.conversationId), v == null || v()), Be(!1);
  }, [Ze, at] = tn({
    open: !1,
    type: "showMember"
  }), [pt, It] = tn(!1), [Rt, gt] = tn(null), it = () => {
    if (Rt)
      O.changeGroupOwner(r.conversationId, Rt.userId);
    else
      return It(!1), console.warn("no selected owner");
    It(!1), at({
      open: !1,
      type: "showMember"
    }), c == null || c(!1);
  };
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsxs(
      "div",
      {
        className: I,
        style: { ...a, display: Ze.open ? "none" : "flex" },
        children: [
          /* @__PURE__ */ q.jsxs("div", { className: `${p}-header`, children: [
            /* @__PURE__ */ q.jsx(
              zs,
              {
                src: M,
                size: 100,
                shape: w === "round" ? "circle" : "square",
                children: D == null ? void 0 : D.name
              }
            ),
            /* @__PURE__ */ q.jsxs("div", { children: [
              /* @__PURE__ */ q.jsx("div", { className: `${p}-header-name`, children: D == null ? void 0 : D.name }),
              /* @__PURE__ */ q.jsxs("div", { className: `${p}-header-id`, children: [
                /* @__PURE__ */ q.jsxs("div", { children: [
                  _("group"),
                  " ID:"
                ] }),
                D == null ? void 0 : D.id,
                /* @__PURE__ */ q.jsx(pn, { type: "DOC_ON_DOC", style: { cursor: "copy" }, onClick: V })
              ] }),
              /* @__PURE__ */ q.jsx("div", { className: `${p}-header-description`, children: D == null ? void 0 : D.description })
            ] })
          ] }),
          /* @__PURE__ */ q.jsxs("div", { className: `${p}-content`, children: [
            /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-item`, children: [
              /* @__PURE__ */ q.jsx(pn, { type: "PERSON_DOUBLE_FILL", width: 24, height: 24 }),
              /* @__PURE__ */ q.jsxs(
                "div",
                {
                  className: `${p}-content-item-box`,
                  onClick: () => {
                    at({
                      open: !0,
                      type: "showMember"
                    }), c == null || c(!0);
                  },
                  children: [
                    /* @__PURE__ */ q.jsx("span", { children: _("groupMembers") }),
                    /* @__PURE__ */ q.jsxs("div", { children: [
                      (G == null ? void 0 : G.length) ?? (D == null ? void 0 : D.affiliations_count),
                      /* @__PURE__ */ q.jsx(pn, { type: "ARROW_RIGHT", width: 24, height: 24 })
                    ] })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-item`, children: [
              /* @__PURE__ */ q.jsx(pn, { type: "BELL", width: 24, height: 24 }),
              /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-item-box`, children: [
                /* @__PURE__ */ q.jsx("span", { children: _("muteNotifications") }),
                /* @__PURE__ */ q.jsx("div", { children: /* @__PURE__ */ q.jsx(IRe, { checked: !!(B != null && B.silent), onChange: pe }) })
              ] })
            ] }),
            /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-item`, children: [
              /* @__PURE__ */ q.jsx(pn, { type: "ERASER", width: 24, height: 24 }),
              /* @__PURE__ */ q.jsx(
                "div",
                {
                  className: `${p}-content-item-box`,
                  onClick: () => {
                    _e(!0);
                  },
                  children: /* @__PURE__ */ q.jsx("span", { children: _("clearChatHistory") })
                }
              )
            ] }),
            j && /* @__PURE__ */ q.jsx("div", { className: `${p}-content-section`, children: /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-item`, children: [
              /* @__PURE__ */ q.jsx(pn, { type: "SLASH_IN_BOX", width: 24, height: 24 }),
              /* @__PURE__ */ q.jsxs(
                "div",
                {
                  className: `${p}-content-item-box`,
                  onClick: () => {
                    K(!0);
                  },
                  children: [
                    /* @__PURE__ */ q.jsx("span", { children: _("editGroupDetail") }),
                    /* @__PURE__ */ q.jsx("div", { children: /* @__PURE__ */ q.jsx(pn, { type: "ARROW_RIGHT", width: 24, height: 24 }) })
                  ]
                }
              )
            ] }) }),
            /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-section`, children: [
              j && /* @__PURE__ */ q.jsxs(
                "div",
                {
                  className: `${p}-content-item`,
                  onClick: () => {
                    at({
                      open: !0,
                      type: "transferOwner"
                    });
                  },
                  children: [
                    /* @__PURE__ */ q.jsx(pn, { type: "ARROWS_ROUND", width: 24, height: 24 }),
                    /* @__PURE__ */ q.jsx("div", { className: `${p}-content-item-box`, children: /* @__PURE__ */ q.jsx("span", { children: _("transferOwner") }) })
                  ]
                }
              ),
              /* @__PURE__ */ q.jsxs("div", { className: `${p}-content-item`, children: [
                /* @__PURE__ */ q.jsx(
                  pn,
                  {
                    type: j ? "DELETE" : "ARROW_RIGHT_SQUARE_FILL",
                    width: 24,
                    height: 24,
                    style: { fill: "#FF002B", width: "24px", height: "24px" }
                  }
                ),
                /* @__PURE__ */ q.jsx(
                  "div",
                  {
                    className: `${p}-content-item-box`,
                    onClick: () => {
                      Be(!0);
                    },
                    children: /* @__PURE__ */ q.jsx("span", { style: { color: "#FF002B" }, children: _(j ? "disbandGroup" : "leaveGroup") })
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ q.jsx(
            ca,
            {
              open: J,
              onCancel: () => {
                ue(!1);
              },
              onOk: he,
              title: _("myAliasInGroup"),
              wrapClassName: "modify-message-modal",
              children: /* @__PURE__ */ q.jsx(
                Ml,
                {
                  className: "cui-group-nickname-input",
                  maxLength: 20,
                  value: se,
                  onChange: de
                }
              )
            }
          ),
          /* @__PURE__ */ q.jsx(
            ca,
            {
              title: _("clearChatHistory"),
              open: Ce,
              onCancel: () => {
                _e(!1);
              },
              onOk: Le,
              children: /* @__PURE__ */ q.jsx("div", { children: `${_("Want to delete all chat history")}?` })
            }
          ),
          /* @__PURE__ */ q.jsxs(
            ca,
            {
              open: Te,
              onCancel: () => {
                K(!1);
              },
              onOk: be,
              title: _("editGroupDetail"),
              wrapClassName: "modify-message-modal",
              children: [
                /* @__PURE__ */ q.jsxs("div", { className: `${p}-infoModal`, children: [
                  /* @__PURE__ */ q.jsx("div", { children: `${_("group")} ${_("name")}` }),
                  /* @__PURE__ */ q.jsx(
                    Ml,
                    {
                      name: "name",
                      className: "cui-group-nickname-input",
                      maxLength: 20,
                      value: Oe.name,
                      onChange: (st) => {
                        xe(st, "name");
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ q.jsxs("div", { className: `${p}-infoModal`, children: [
                  /* @__PURE__ */ q.jsx("div", { children: `${_("group")} ${_("announcement")}` }),
                  /* @__PURE__ */ q.jsx(
                    Ml,
                    {
                      name: "description",
                      className: "cui-group-nickname-input",
                      maxLength: 20,
                      value: Oe.description,
                      onChange: (st) => {
                        xe(st, "description");
                      }
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ q.jsx(
            ca,
            {
              title: _(j ? "disbandGroup" : "leaveGroup"),
              open: $e,
              onCancel: () => {
                Be(!1);
              },
              onOk: Ke,
              children: /* @__PURE__ */ q.jsx("div", { children: `${_("want")} ${j ? _("disbandGroup").toLocaleLowerCase() : _("leaveGroup").toLocaleLowerCase()} “${D == null ? void 0 : D.name}” ${_("and delete all chat history")}?` })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ q.jsxs(
      "div",
      {
        className: k,
        style: { ...a, display: Ze.open ? "flex" : "none" },
        children: [
          /* @__PURE__ */ q.jsx(
            NRe,
            {
              headerProps: Ze.type === "transferOwner" && {
                content: _("transferOwner"),
                suffixIcon: /* @__PURE__ */ q.jsx(
                  "div",
                  {
                    className: `${p}-select`,
                    onClick: () => {
                      It(!0);
                    },
                    children: _("done")
                  }
                )
              } || {},
              onClickBack: () => {
                at({
                  open: !1,
                  type: "showMember"
                }), c == null || c(!1);
              },
              checkable: Ze.type == "transferOwner",
              groupMembers: B == null ? void 0 : B.members,
              groupId: (D == null ? void 0 : D.id) || "",
              onUserSelect: (st, Ot) => {
                st.type == "add" ? gt(st) : gt(null);
              },
              checkedUsers: Ze.type == "transferOwner" ? [
                {
                  userId: E.client.user
                }
              ] : [],
              isOwner: j,
              moreAction: Ze.type === "transferOwner" ? {
                visible: !1,
                actions: []
              } : void 0,
              ...l
            }
          ),
          /* @__PURE__ */ q.jsx(
            ca,
            {
              title: _("transferOwner"),
              open: pt,
              onCancel: () => {
                It(!1);
              },
              onOk: it,
              children: /* @__PURE__ */ q.jsx("div", { children: Rt ? `${_("Want to transfer group ownership to")} “${Rt.nickname || Rt.userId}”?` : _("Please select the person to be transferred") })
            }
          )
        ]
      }
    )
  ] });
};
bX.displayName = "GroupDetail";
const wRe = mi(bX);
wRe.displayName = "GroupDetail";
const _Re = (t) => {
  const { initConfig: r, features: a } = t, u = gr(), { messageStore: h, threadStore: b, conversationStore: l, addressStore: v } = u, s = u.client, { useUserInfo: c } = r;
  Pn(() => {
    var d;
    return (d = s == null ? void 0 : s.addEventHandler) == null || d.call(s, "UIKitMessage", {
      onTextMessage: (p) => {
        h.receiveMessage(p);
      },
      onImageMessage: (p) => {
        h.receiveMessage(p);
      },
      onFileMessage: (p) => {
        h.receiveMessage(p);
      },
      onAudioMessage: (p) => {
        h.receiveMessage(p);
      },
      onVideoMessage: (p) => {
        h.receiveMessage(p);
      },
      onLocationMessage: (p) => {
        h.receiveMessage(p);
      },
      onCmdMessage: (p) => {
        const m = ar(p), E = {
          chatType: p.chatType,
          conversationId: m
        }, { action: y } = p;
        switch (y) {
          case "TypingBegin":
            h.setTyping(E, !0);
            break;
          case "TypingEnd":
            h.setTyping(E, !1);
            break;
          default:
            h.receiveMessage(p);
            break;
        }
      },
      onCustomMessage: (p) => {
        h.receiveMessage(p);
      },
      onReceivedMessage: (p) => {
        h.updateMessageStatus(p.mid, "sent");
      },
      onDeliveredMessage: (p) => {
        h.updateMessageStatus(p.mid, "received");
      },
      onReadMessage: (p) => {
        h.updateMessageStatus(p.mid, "read");
      },
      onChannelMessage: (p) => {
        const { chatType: m, from: E = "" } = p;
        m === "singleChat" && setTimeout(() => {
          var y, g, C;
          (C = (g = (y = u.messageStore.message) == null ? void 0 : y[m]) == null ? void 0 : g[E]) == null || C.filter((O) => (
            //@ts-ignore
            O.status === "received" && O.type != "audio" && O.type != "video" && O.type != "file" && O.type != "combine"
          )).forEach((O) => {
            h.updateMessageStatus(O.mid || O.id, "read");
          });
        }, 10);
      },
      onRecallMessage: (p) => {
        let m = "singleChat", E = p.from == u.client.user ? p.to : p.from;
        p.to.length == 15 && Number(p.to) > 0 && (m = "groupChat", E = p.to), h.recallMessage(
          {
            chatType: m,
            // TODO: 'singleChat' | 'groupChat'
            conversationId: E
          },
          p.mid
        );
      },
      onConnected: () => {
        u.setLoginState(!0);
      },
      onDisconnected: () => {
        u.setLoginState(!1);
      },
      onReactionChange: (p) => {
        const m = ar(p), E = {
          chatType: p.chatType,
          conversationId: m
        };
        u.messageStore.updateReactions(E, p.messageId, p.reactions);
      },
      onModifiedMessage: (p) => {
        gr().messageStore.modifyLocalMessage(p.id, p, !0);
      },
      onMessagePinEvent: (p) => {
        const { messageId: m, conversationType: E, conversationId: y, operation: g, time: C, operatorId: O } = p;
        switch (g) {
          case "pin":
            if (gr().pinnedMessagesStore.updatePinnedMessage(
              E,
              y,
              m,
              C,
              O
            ), gr().pinnedMessagesStore.pushPinNoticeMessage({
              conversationId: y,
              conversationType: E,
              operatorId: O,
              noticeType: "pin",
              time: C
            }), E === "chatRoom") {
              const N = gr().messageStore.message[E][
                y
                //@ts-ignore
              ].find((w) => (w.mid === m || w.id === m) && w);
              N && (gr().pinnedMessagesStore.clearPinnedMessages(
                E,
                y
              ), gr().pinnedMessagesStore.pushPinnedMessage(E, y, {
                operatorId: O,
                pinTime: C,
                message: N
              }));
            }
            break;
          case "unpin":
            gr().pinnedMessagesStore.deletePinnedMessage(
              E,
              y,
              m
            ), gr().pinnedMessagesStore.pushPinNoticeMessage({
              conversationId: y,
              conversationType: E,
              operatorId: O,
              noticeType: "unpin",
              time: C
            });
            break;
        }
      },
      onGroupEvent: (p) => {
        const { operation: m, id: E } = p, { addressStore: y, client: g } = u, C = jd(E);
        switch (m) {
          case "memberAttributesUpdate":
            y.setGroupMemberAttributes(E, p.userId, p.attributes);
            break;
          case "setAdmin":
            C && y.setGroupAdmins(E, [...(C == null ? void 0 : C.admins) || [], g.user]);
            break;
          case "removeAdmin":
            if (C) {
              const O = [...(C == null ? void 0 : C.admins) || []];
              O.splice(O.indexOf(g.user), 1), y.setGroupAdmins(E, [...O]);
            }
            break;
          case "memberPresence":
            C && C.members && (y.setGroupMembers(E, [{ member: p.from }]), pY(E, [p.from]));
            break;
          case "memberAbsence":
            C && (C.members && y.removeGroupMember(E, p.from), C.admins && C.admins.includes(p.from) && y.setGroupAdmins(
              E,
              C.admins.filter((O) => O !== p.from)
            ));
            break;
          case "directJoined":
            y.setGroups([
              {
                groupid: E,
                groupname: p.name || ""
              }
            ]);
            break;
          case "destroy":
            y.removeGroupFromContactList(E);
            break;
        }
      },
      onGroupChange: (p) => {
        const { type: m, gid: E } = p, { addressStore: y } = u;
        switch (m) {
          case "changeOwner":
            y.setGroupOwner(E, p.to);
            break;
          case "removedFromGroup":
            p.kicked == u.client.user && y.removeGroupFromContactList(E);
            break;
        }
      },
      onPresenceStatusChange: (p) => {
        var y, g;
        if (((g = (y = a == null ? void 0 : a.conversationList) == null ? void 0 : y.item) == null ? void 0 : g.presence) == !1) return;
        const { addressStore: m } = u;
        p.length > 0 && p.forEach((C) => {
          const O = m.appUsersInfo;
          if (O[C.userId]) {
            const N = C.statusDetails;
            let w = !1;
            N.forEach((_) => {
              _.status === 1 && (w = !0);
            }), qi(() => {
              O[C.userId].isOnline = w, O[C.userId].presenceExt = C.ext, m.setAppUserInfo({ ...O });
            });
          }
        });
        const E = p.map((C) => {
          const O = {};
          return C.statusDetails.forEach((N) => {
            O[N.device] = String(N.status);
          }), {
            ...C,
            uid: C.userId,
            status: O,
            expiry: C.expire,
            last_time: C.lastTime,
            presenceExt: C.ext
          };
        });
        l.setOnlineStatus(E);
      },
      // @ts-ignore
      onCombineMessage: (p) => {
        h.receiveMessage(p);
      },
      onChatThreadChange: (p) => {
        var m, E;
        p.operation == "userRemove" ? p.userName == u.client.user && ((E = (m = b.currentThread) == null ? void 0 : m.info) == null ? void 0 : E.id) == p.id && b.setThreadVisible(!1) : b.updateThreadInfo(p);
      },
      onContactInvited: (p) => {
        v.addContactRequest({
          ...p,
          type: "subscribe",
          requestStatus: "pending"
        }), c && v.getUserInfo(p.from);
      },
      onContactDeleted: (p) => {
        console.log("onContactDeleted", p);
        const { addressStore: m } = u;
        m.deleteContactFromContactList(p.from);
      },
      onContactAdded: (p) => {
        var y, g;
        console.log("onContactAdded", p);
        const { addressStore: m } = u, E = ((g = (y = a == null ? void 0 : a.conversationList) == null ? void 0 : y.item) == null ? void 0 : g.presence) ?? !1;
        m.addContactToContactList(p.from, E);
      },
      onContactAgreed: (p) => {
        var y, g;
        const { addressStore: m } = u, E = ((g = (y = a == null ? void 0 : a.conversationList) == null ? void 0 : y.item) == null ? void 0 : g.presence) ?? !1;
        m.addContactToContactList(p.from, E);
      },
      onMultiDeviceEvent: (p) => {
        console.log("onMultiDeviceEvent", p), p.operation === "setSilentModeForConversation" ? (u.conversationStore.setSilentModeForConversationSync(
          {
            chatType: p.type,
            conversationId: p.conversationId
          },
          !0
        ), u.addressStore.setSilentModeForConversationSync(
          {
            chatType: p.type,
            conversationId: p.conversationId
          },
          !0
        )) : p.operation === "removeSilentModeForConversation" && (u.conversationStore.setSilentModeForConversationSync(
          {
            chatType: p.type,
            conversationId: p.conversationId
          },
          !1
        ), u.addressStore.setSilentModeForConversationSync(
          {
            chatType: p.type,
            conversationId: p.conversationId
          },
          !1
        ));
      },
      onChatroomEvent: (p) => {
        if (p.operation === "memberPresence") {
          const m = p.memberCount;
          typeof m == "number" && v.updateChatroomMemberCount(p.id, m);
        }
      }
    }), () => {
      var p;
      (p = s == null ? void 0 : s.removeEventHandler) == null || p.call(s, "UIKitMessage");
    };
  }, [s]);
}, PRe = "欢迎使用", xRe = "会话列表", DRe = "删除", MRe = "清空消息", LRe = "图片", kRe = "语音消息", jRe = "视频消息", URe = "文件", HRe = "名片", BRe = "视频", zRe = "自定义消息", FRe = "合并消息", GRe = "没有会话", VRe = "录音中", YRe = "你", XRe = "自己", WRe = "回复了", qRe = "原始内容不存在", KRe = "回复", JRe = "回复", ZRe = "撤回", QRe = "附件", $Re = "撤回了一条消息", e2e = "翻译", t2e = "已翻译", n2e = "翻译失败", r2e = "翻译中", i2e = "编辑", s2e = "消息编辑", a2e = "确认", o2e = "取消", c2e = "重试", u2e = "隐藏", d2e = "显示", l2e = "所有人", f2e = "[有人@你] ", h2e = "[@所有人] ", p2e = "多选", g2e = "聊天记录", m2e = "批量删除", E2e = "条消息？", y2e = "取消", v2e = "发起人", T2e = "创建子区", b2e = "子区名称（必填）", A2e = "请输入子区名称", O2e = "一个子区", C2e = "子区", S2e = "子区列表", I2e = "子区成员", R2e = "离开", N2e = "编辑子区名称", w2e = "保存", _2e = "成员", P2e = "解散", x2e = "解散", D2e = "列表", M2e = "编辑子区", L2e = "离开子区", k2e = "解散子区", j2e = "消息已编辑", U2e = "发送", H2e = "送了", B2e = "转发", z2e = "更多", F2e = "表情", G2e = "录音", V2e = "重发", Y2e = "不支持的消息类型", X2e = "禁言", W2e = "解除禁言", q2e = "新消息", K2e = "加入了", J2e = "房主", Z2e = "想要移除", Q2e = "移除", $2e = "所有人", eNe = "已禁言", tNe = "搜索", nNe = "举报", rNe = "其它", iNe = "置顶", sNe = "取消置顶", aNe = "免打扰", oNe = "取消免打扰", cNe = "爱心", uNe = "玫瑰", dNe = "超级A", lNe = "星星", fNe = "棒棒糖", hNe = "钻石", pNe = "皇冠", gNe = "麦克风", mNe = "气球", ENe = "火箭", yNe = "星球", vNe = "在线观众", TNe = "群成员", bNe = "我在本群的昵称", ANe = "消息免打扰", ONe = "清空聊天记录", CNe = "转移群主", SNe = "解散群组", INe = "离开群组", RNe = "用户", NNe = "发消息", wNe = "添加联系人", _Ne = "个人名片", PNe = "修改群组信息", xNe = "群组", DNe = "名称", MNe = "公告", LNe = "确定", kNe = "选择", jNe = "新请求", UNe = "联系人", HNe = "群组", BNe = "添加群成员", zNe = "移除群成员", FNe = "私聊", GNe = "分享", VNe = "礼物", YNe = "视频通话", XNe = "语音通话", WNe = "请求添加你为好友", qNe = "完成", KNe = "置顶", JNe = "置顶了", ZNe = "黑名单", QNe = "在线", $Ne = "离线", ewe = "忙碌", twe = "离开", nwe = "自定义状态", rwe = "举报原因", iwe = "删除消息", swe = "删除会话", awe = {
  hello: PRe,
  conversationTitle: xRe,
  deleteCvs: DRe,
  clearMsgs: MRe,
  image: LRe,
  audio: kRe,
  video: jRe,
  file: URe,
  userCard: HRe,
  videoBtn: BRe,
  custom: zRe,
  combine: FRe,
  noConversation: GRe,
  recording: VRe,
  you: YRe,
  yourself: XRe,
  repliedTo: WRe,
  messageNotFound: qRe,
  replyingTo: KRe,
  delete: "删除",
  reply: JRe,
  unsend: ZRe,
  attachment: QRe,
  unsentAMessage: $Re,
  translate: e2e,
  translated: t2e,
  translationFailed: n2e,
  translating: r2e,
  modify: i2e,
  modifyTitle: s2e,
  confirmBtn: a2e,
  cancelBtn: o2e,
  retry: c2e,
  hide: u2e,
  show: d2e,
  atAll: l2e,
  atTag: f2e,
  atAllTag: h2e,
  select: p2e,
  chatHistory: g2e,
  batchDeletion: m2e,
  messages: E2e,
  cancel: y2e,
  startedBy: v2e,
  createThread: T2e,
  threadNameRequired: b2e,
  enterThreadName: A2e,
  aThread: O2e,
  "are you sure you want to destroy this thread": "你想要解散这个子区吗？",
  "Are you sure you want to leave this thread": "你想要离开这个子区吗？",
  thread: C2e,
  threadList: S2e,
  threadMembers: I2e,
  leave: R2e,
  editThreadName: N2e,
  save: w2e,
  members: _2e,
  disband: P2e,
  destroy: x2e,
  list: D2e,
  modifyThread: M2e,
  leaveThread: L2e,
  destroyThread: k2e,
  edited: j2e,
  send: U2e,
  sent: H2e,
  forward: B2e,
  more: z2e,
  emoji: F2e,
  record: G2e,
  resend: V2e,
  unsupportedMessageType: Y2e,
  mute: X2e,
  unmute: W2e,
  newMessage: q2e,
  Joined: K2e,
  owner: J2e,
  wantToRemove: Z2e,
  remove: Q2e,
  all: $2e,
  muted: eNe,
  search: tNe,
  report: nNe,
  "Unwelcome commercial content": "不受欢迎的商业内容或垃圾邮件",
  "Pornographic or explicit content": "色情或露骨内容",
  "Child abuse": "虐待儿童",
  "Hate speech or graphic violence": "仇恨言论或暴力画面",
  "Promote terrorism": "宣扬恐怖主义",
  "Harassment or bullying": "骚扰或欺凌",
  "Suicide or self harm": "自杀或自残",
  "False information": "虚假信息",
  Others: rNe,
  "say something": "",
  sticky: iNe,
  unSticky: sNe,
  muteNotification: aNe,
  unmuteNotification: oNe,
  Heart: cNe,
  Rose: uNe,
  "Super Cube": "超级环",
  Alpha: dNe,
  Star: lNe,
  Lollipop: fNe,
  Diamond: hNe,
  Crown: pNe,
  Mic: gNe,
  Balloon: mNe,
  Rocket: ENe,
  Planet: yNe,
  "Enter chatroom to start chatting": "进入聊天室开始聊天",
  "Let's Chat": "发条弹幕吧~",
  Participants: vNe,
  groupMembers: TNe,
  myAliasInGroup: bNe,
  muteNotifications: ANe,
  clearChatHistory: ONe,
  transferOwner: CNe,
  disbandGroup: SNe,
  leaveGroup: INe,
  user: RNe,
  message: NNe,
  addContact: wNe,
  contact: _Ne,
  editGroupDetail: PNe,
  group: xNe,
  name: DNe,
  announcement: MNe,
  want: LNe,
  "and delete all chat history": "并删除全部聊天记录",
  "Want to delete all chat history": "确定删除全部聊天记录",
  choose: kNe,
  "Please select the person to be transferred": "请选择要转让的人",
  "Want to transfer group ownership to": "确认将群主身份转移给",
  newRequests: jNe,
  contacts: UNe,
  groups: HNe,
  "no contact": "没有联系人",
  addGroupMembers: BNe,
  removeGroupMembers: zNe,
  privateChat: FNe,
  "Selected group members": "已选群成员",
  share: GNe,
  gift: VNe,
  videoCall: YNe,
  audioCall: XNe,
  requestToAddContact: WNe,
  "Start a video call": "邀请你进入视频通话",
  "Start a audio call": "邀请你进入语音通话",
  "Start a video meeting": "邀请你进入多人视频通话",
  "Start a audio meeting": "邀请你进入多人语音通话",
  done: qNe,
  "Pinned Messages": "置顶消息",
  Pin: KNe,
  "Remove pin message": "移除置顶消息",
  "Confirm to remove pin message": "确定移除置顶消息吗?",
  "Jump to pinned message": "跳转到Pinned消息",
  "pinned a message": "置顶了一条消息",
  "removed a pin message": "取消了一条置顶消息",
  "'s message": "的消息",
  pinned: JNe,
  blocklist: ZNe,
  Online: QNe,
  Offline: $Ne,
  Busy: ewe,
  Away: twe,
  "Do Not Disturb": "请勿打扰",
  Custom: nwe,
  Violation: rwe,
  "Confirm to remove pin message ?": "确定移除置顶消息 ?",
  "Click to view the original message": "点击查看原消息",
  "Delete this message": "删除这条消息",
  deleteMessage: iwe,
  "Delete this conversation": "确认删除会话",
  deleteConversation: swe
}, owe = "hello word", cwe = "Conversation List", uwe = "Delete", dwe = "Clear Messages", lwe = "Image", fwe = "Audio message", hwe = "Video message", pwe = "File", gwe = "Contact Card", mwe = "Video", Ewe = "Custom message", ywe = "Combined message", vwe = "No Conversations", Twe = "Recording", bwe = "You", Awe = "Yourself", Owe = "replied to", Cwe = "Quoted content does not exist", Swe = "Replying to", Iwe = "Reply", Rwe = "Recall", Nwe = "Attachment", wwe = " recalled a message", _we = "Translate", Pwe = "Translated", xwe = "translation failed", Dwe = "Translating", Mwe = "Edit", Lwe = "Message Edit", kwe = "Confirm", jwe = "Cancel", Uwe = "Retry", Hwe = "Hide", Bwe = "Show", zwe = "All", Fwe = "[Someone@You] ", Gwe = "[@All] ", Vwe = "Select", Ywe = "Chat History", Xwe = "Batch Deletion", Wwe = "messages?", qwe = "Cancel", Kwe = "Started by", Jwe = "Create Thread", Zwe = "Thread name (required)", Qwe = "Enter a thread name", $we = "A Thread", e_e = "Thread", t_e = "Thread List", n_e = "Thread Members", r_e = "Leave", i_e = "Edit Thread Name", s_e = "Save", a_e = "Members", o_e = "Disband", c_e = "Destroy", u_e = "List", d_e = "Edit Thread", l_e = "Leave Thread", f_e = "Destroy Thread", h_e = "Message Edited", p_e = "Send", g_e = "sent", m_e = "Forward", E_e = "More", y_e = "Emoji", v_e = "Record", T_e = "Resend", b_e = "Unsupported message type", A_e = "Mute", O_e = "Unmute", C_e = "new message(s)", S_e = "Joined", I_e = "owner", R_e = "want to remove", N_e = "Remove", w_e = "ALL", __e = "Muted", P_e = "Search", x_e = "Report", D_e = "Others", M_e = "Pin", L_e = "Unpin", k_e = "Mute", j_e = "Unmute", U_e = "Heart", H_e = "Rose", B_e = "Alpha", z_e = "Star", F_e = "Lollipop", G_e = "Diamond", V_e = "Crown", Y_e = "Mic", X_e = "Balloon", W_e = "Rocket", q_e = "Planet", K_e = "Participants", J_e = "Group Members", Z_e = "My Alias in Group", Q_e = "Mute Notifications", $_e = "Clear Chat History", ePe = "Transfer Ownership", tPe = "Disband Group", nPe = "Leave Group", rPe = "User", iPe = "Send Messages", sPe = "Add Contact", aPe = "Contact Card", oPe = "Edit Group Details", cPe = "Group", uPe = "Name", dPe = "Announcement", lPe = "Want to", fPe = "Choose", hPe = "New Requests", pPe = "Contacts", gPe = "Groups", mPe = "Add Group Members", EPe = "Remove Group Members", yPe = "Private Chat", vPe = "Share", TPe = "Gift", bPe = "Video Call", APe = "Voice Call", OPe = "Request to add you as a contact", CPe = "Done", SPe = "Pin", IPe = "pinned", RPe = "Blocklist", NPe = "Online", wPe = "Offline", _Pe = "Busy", PPe = "Away", xPe = "Custom", DPe = "Violation", MPe = "Delete Message", LPe = "Delete Conversation", kPe = {
  hello: owe,
  conversationTitle: cwe,
  deleteCvs: uwe,
  clearMsgs: dwe,
  image: lwe,
  audio: fwe,
  video: hwe,
  file: pwe,
  userCard: gwe,
  videoBtn: mwe,
  custom: Ewe,
  combine: ywe,
  noConversation: vwe,
  recording: Twe,
  you: bwe,
  yourself: Awe,
  repliedTo: Owe,
  messageNotFound: Cwe,
  replyingTo: Swe,
  delete: "Delete",
  reply: Iwe,
  unsend: Rwe,
  attachment: Nwe,
  unsentAMessage: wwe,
  translate: _we,
  translated: Pwe,
  translationFailed: xwe,
  translating: Dwe,
  modify: Mwe,
  modifyTitle: Lwe,
  confirmBtn: kwe,
  cancelBtn: jwe,
  retry: Uwe,
  hide: Hwe,
  show: Bwe,
  atAll: zwe,
  atTag: Fwe,
  atAllTag: Gwe,
  select: Vwe,
  chatHistory: Ywe,
  batchDeletion: Xwe,
  messages: Wwe,
  cancel: qwe,
  startedBy: Kwe,
  createThread: Jwe,
  threadNameRequired: Zwe,
  enterThreadName: Qwe,
  aThread: $we,
  "are you sure you want to destroy this thread": "Are you sure you want to destroy this thread?",
  "Are you sure you want to leave this thread": "Are you sure you want to leave this thread?",
  thread: e_e,
  threadList: t_e,
  threadMembers: n_e,
  leave: r_e,
  editThreadName: i_e,
  save: s_e,
  members: a_e,
  disband: o_e,
  destroy: c_e,
  list: u_e,
  modifyThread: d_e,
  leaveThread: l_e,
  destroyThread: f_e,
  edited: h_e,
  send: p_e,
  sent: g_e,
  forward: m_e,
  more: E_e,
  emoji: y_e,
  record: v_e,
  resend: T_e,
  unsupportedMessageType: b_e,
  mute: A_e,
  unmute: O_e,
  newMessage: C_e,
  Joined: S_e,
  owner: I_e,
  wantToRemove: R_e,
  remove: N_e,
  all: w_e,
  muted: __e,
  search: P_e,
  report: x_e,
  "Unwelcome commercial content": "Unwelcome commercial content or spam",
  "Pornographic or explicit content": "Pornographic or explicit content",
  "Child abuse": "Child abuse",
  "Hate speech or graphic violence": "Hate speech or graphic violence",
  "Promote terrorism": "Promote terrorism",
  "Harassment or bullying": "Harassment or bullying",
  "Suicide or self harm": "Suicide or self harm",
  "False information": "False information",
  Others: D_e,
  "say something": "",
  sticky: M_e,
  unSticky: L_e,
  muteNotification: k_e,
  unmuteNotification: j_e,
  Heart: U_e,
  Rose: H_e,
  "Super Cube": "Super Cube",
  Alpha: B_e,
  Star: z_e,
  Lollipop: F_e,
  Diamond: G_e,
  Crown: V_e,
  Mic: Y_e,
  Balloon: X_e,
  Rocket: W_e,
  Planet: q_e,
  "Enter chatroom to start chatting": "Enter chatroom to start chatting",
  "Let's Chat": "Let's Chat!",
  Participants: K_e,
  groupMembers: J_e,
  myAliasInGroup: Z_e,
  muteNotifications: Q_e,
  clearChatHistory: $_e,
  transferOwner: ePe,
  disbandGroup: tPe,
  leaveGroup: nPe,
  user: rPe,
  message: iPe,
  addContact: sPe,
  contact: aPe,
  editGroupDetail: oPe,
  group: cPe,
  name: uPe,
  announcement: dPe,
  want: lPe,
  "and delete all chat history": "and delete all chat history",
  "Want to delete all chat history": "Want to delete all chat history",
  choose: fPe,
  "Please select the person to be transferred": "Please select the person to be transferred",
  "Want to transfer group ownership to": "Want to transfer group ownership to",
  newRequests: hPe,
  contacts: pPe,
  groups: gPe,
  "no contact": "No Contacts",
  addGroupMembers: mPe,
  removeGroupMembers: EPe,
  privateChat: yPe,
  "Selected group members": "Selected group members",
  share: vPe,
  gift: TPe,
  videoCall: bPe,
  audioCall: APe,
  requestToAddContact: OPe,
  "Start a video call": "You are invited to a video call",
  "Start a audio call": "You are invited to a voice call",
  "Start a video meeting": "You are invited to a multi-party video call",
  "Start a audio meeting": "You are invited to a multi-party voice call",
  done: CPe,
  "Pinned Messages": "Pinned Messages",
  Pin: SPe,
  "Remove pin message": "Remove pin message",
  "Confirm to remove pin message": "Confirm to remove pin message?",
  "Jump to pinned message": "Jump to pinned message",
  "pinned a message": "pinned a message",
  "removed a pin message": "removed a pin message",
  "'s message": "'s message",
  pinned: IPe,
  blocklist: RPe,
  Online: NPe,
  Offline: wPe,
  Busy: _Pe,
  Away: PPe,
  "Do Not Disturb": "Do Not Disturb",
  Custom: xPe,
  Violation: DPe,
  "Confirm to remove pin message ?": "Confirm to remove pin message ?",
  "Click to view the original message": "Click to view the original message",
  "Delete this message": "Delete this message",
  deleteMessage: MPe,
  "Delete this conversation": "Delete this conversation",
  deleteConversation: LPe
}, YB = {
  zh: {
    translation: awe
  },
  en: {
    translation: kPe
  }
};
function jPe(t) {
  var r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, a = r.exec(t);
  if (!a)
    return null;
  var u = parseInt(a[1], 16), h = parseInt(a[2], 16), b = parseInt(a[3], 16);
  return [u, h, b];
}
function UPe(t) {
  var r = t[0] / 255, a = t[1] / 255, u = t[2] / 255, h = Math.max(r, a, u), b = Math.min(r, a, u), c, v, l = (h + b) / 2, v = 0, s = 0;
  h !== b && (s = h - b, v = l > 0.5 ? s / (2 - h - b) : s / (h + b));
  var c = 0;
  if (h !== b) {
    switch (h) {
      case r:
        c = (a - u) / s + (a < u ? 6 : 0);
        break;
      case a:
        c = (u - r) / s + 2;
        break;
      case u:
        c = (r - a) / s + 4;
        break;
    }
    c /= 6;
  }
  return `hsla(${Math.round(c * 360)},${Math.round(v * 100)}%,${Math.round(l * 100)}%,1)`;
}
function HPe(t) {
  var r = jPe(t);
  return r === null ? null : UPe(r);
}
function A2(t, r = [-50, -40, -30, -20, -10, 0, 10, 20, 30, 35, 38, 40]) {
  for (var a = t.split(","), u = parseInt(a[2]), h = [], b = 0; b < r.length; b++) {
    var l = u + r[b];
    a[2] = l + "%";
    var v = a.join(",");
    h.push(v);
  }
  return BPe(h), h;
}
function BPe(t) {
  document.documentElement.style.setProperty("--cui-primary-color1", t[0]), document.documentElement.style.setProperty("--cui-primary-color2", t[1]), document.documentElement.style.setProperty("--cui-primary-color3", t[2]), document.documentElement.style.setProperty("--cui-primary-color4", t[3]), document.documentElement.style.setProperty("--cui-primary-color5", t[4]), document.documentElement.style.setProperty("--cui-primary-color", t[5]), document.documentElement.style.setProperty("--cui-primary-color7", t[6]), document.documentElement.style.setProperty("--cui-primary-color8", t[7]), document.documentElement.style.setProperty("--cui-primary-color9", t[8]), document.documentElement.style.setProperty("--cui-primary-color95", t[9]), document.documentElement.style.setProperty("--cui-primary-color98", t[10]), document.documentElement.style.setProperty("--cui-primary-color10", t[11]);
}
const zPe = (t) => typeof t == "number" && t >= 0 && t <= 360, FPe = (t) => typeof t == "string" && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(t), GPe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAIAAAADJ/2KAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAANqADAAQAAAABAAAANgAAAADzQy6kAAAAdklEQVRoBe3SwQ0AEBQFQfR/VS/Rwx4cRgEvP2PnOHv8/dbf573rnFj8EUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxoUWKhUCxocVC8QKljAIAkEfcfQAAAABJRU5ErkJggg==", VPe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAIAAAADJ/2KAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAANqADAAQAAAABAAAANgAAAADzQy6kAAAAeUlEQVRoBe3SMQ0AIRQFQcC/lCtpcEfOwxYUg4CXn2Hnt894+623z/uvc2LxRxQpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYpFgLFhhYLxQuDAgKFF/xbVQAAAABJRU5ErkJggg==", YPe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAANqADAAQAAAABAAAANgAAAADzQy6kAAAEcElEQVRoBe2aT2sTQRTA32wS0aolKF6q2BQpooINiAcvGg9aai0YYs/VT1D9BKbfIH4Ce/dPArWE6MHqSfBg9KDiH0xVVDwFpVja7Izv7bJxdrPZzCbbZBc6EPbNzJs377dvZnZ3JgDbafsOhOIOsKC9KBaLyc0du6/EhJgQDFIgIA3AkgACf81Uw7IaA1EFxl5pmr6SnZrCsuBSIGAEw3fsmRdCZBAAf/6TAKhqjN0OCrInMAnohiMi/smkFoyxRQRc6CWKXYPdX358CyMUKJDEZoiMafnc9IUFZ7lK3jdYsVxO6bpWRONplQ5IJ5GIw+ihEUP9x89fsPZ3XbUpoIM1LcbP+42eL7AH5coc11nBz7BLDu+Fs2dOQyIeN2A2Nxvw7PkLqP/+owyHinVchK5fnZksqTbSVBXvL1ducR0W/UCR7VMTJ5pQlKfonTx+lEQ/KYmhK9LwV22kBEZQQkBe1aislxwelrOGfGD/vpYylQIheF4VriPYvaXKlW6hVJz1q0NwNCU6tfMEo4UCH6B3Ohnpdz1OiYLhm0fHnmBc1574nVMefQVZlWyYK3Nbm23BjHkFkGrbcsAVuJyn7y5V8u3ccAWjMIdpXrVznjGYp7cft3pXMM5jysuqm9E+liUb8aEbbv21gJnREtfclMNY1i5qLWAYrUwYATx8co1aCxjOrXkPI6Gswq+Bc07HbGDms0GknUrhz4uMcxGxgUVwGDbvOcev9mYGBRuY4DyC0TJxnL7bwIBpEzJ1lGRjf0Vy2PxIahaIVFPcYiE3fbFjD5uNBtS+fofXb9511GXAbEGxRyxkr1D0cTo+dhiOjR/pCIYKSVnJCSbXhUYeHxtV8aW/YDScBpEcEWP1oJ14+/5jzyZXv333bcO5eBCYLaS+LToafPj8Bfc5EjB6cASGhnY5ar2ztPHzsbYKb95/8lY0a2uykg0MXyir+EqVkhWCkMkxRed66I7V5Ma2oSi4WJUrIyUL/kr21wbGNa0qV0ZJZhoecEjJBpbYSJSkukiJmgYrssM2sGz2fB2Pd2wKsnJ4ZVZ1boHbwMhxIfSn4QVw94wx/bazpgUs3thZwKhh5KKTnMOQPG8Bo+GIUWu5A2HFpLM05zB0BaPCKEWNDgjdbnpLxEgpKlHDl4m2p57MjdYqu/fw0UtcTtJWPkxXdLyWuzw51s4n14hZyrGYng3nQsLqdMpp+el29QSjSYlL6U23hgMtE43rbguG7JMnGCnmpqcW8UxqQW40SJnm1dWZS6VOPuBQVUt3l8p5PMUf6J4+Qc3OTOZVPFYGI2N0umkeBNr+ZaPST486rE5TgkaPqiFfYGSUdovpQFD0b+OnGovxbKc55QT2DWYZ2PqhyYw3oNmZqbzVp59r12DUCUUP/8ySR3GO8sEkEyjeWC9ks9mu31l7ArNAjOHJISNEDE9qun2gsxX6sugVyPIpEDDLGF2bkJylzS1zY3c59V+HvhwELgZaVXB9lb7aExtrpV6i89/2trR9B0J3B/4B+RCGJzafIP4AAAAASUVORK5CYII=", XPe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAANqADAAQAAAABAAAANgAAAADzQy6kAAADm0lEQVRoBe2aTVbbMBCAZ+yWtXuD9ASkCYvuak5QFlDYNZwAegLgBuEEhB0tLNITNN11ASHcwDeoy7Ikns4olnHixHachGf5Ve/lSZZG0nye0Y+lIKw40NaBCwHVAYNNbroOhA4g1Sa6IfQ4zwNAn8t/goUDvL3qTcgs+YBL1lfVFQyNPvPDDv+cgm36XK8LaF+uArIwGLk7DjxuHPGbP14CZt478IDgDPvXnXkCWfmFwKi5fwQQnHLjRa2TpZcuLwy4EBi9P6jB0+iCe3V1zy8Ue/Da3sZfV17e/qy8gspKT6N7lnfz1lmhnLzQe2rsi9vnCrksRo1PJzyWTnO1uG4hwlPsfzvL6iYTjBp7F4DQymrohcs7eHd9mNZnKlhJoTRPKtzcMTZ2v9JZSkNJ3FI6xnNi6ZkWC6fzdkyuvEmyvmD/a0LXBFg4pcvst+41alUvy+el4N30UpB0xafgh0FQ8nKccG2deFETYDxZtACmNqwT4qV9cKfXuAkwQDwprepZimFwQnXev4YhAjPYWprFgVcbx/ohAjPaWpqGiDfn46DA1PeUmWNLc+jYoa1dVx7GFht/JOpCs2NC+eANwcZfvmYDPWu/I0kMP+tl7apOQNpmV+SDl8oFu24B0YfKcVGwKRaLFrXKACKwxQBrlQHSIASOWKx6YAA1Bqtm+A9mml1l8vBMUzqHvp7Few8/h6BZIggMRvhgltY5tCX4wxbDQQ5Rs0TQ6vEYG1UPjJnU8Rs1936zSaqytfL5+PtNuI7hd7N8LVXbrpSOwTDopIqaVIh0KepGJ8EVcUeP3fCtgIWuKIh4LhlGB7631vo/gw3/tjnT1wUGxl78Mj4Cw0GX/3NBEbFxYDFrie7RGNMgPNbkYMfVz4bE0djS+kYW0xkwsg85bZJL+qzzdqR/mEiA4eDKM8olkc6UzlNkCTApx/5Nm3f95R9vAnXLus4IiTEWl6Hmbocx1ZFxPL8cabrEu5vWPF1SwaRSOeHSoUTvma4oBTqot1ImtxT3S7FUpLdOZMXU2D0O79CcLNk1lfsy7ueNqek+M10xXoHq/CcxWy7fX/gsEqEHQ/tw1uwX1y+eXghMV1TXuuq+eu2AC1lJ6ydxITDdwBoBBegchsO22urpDheIlwLT/ajrUZK/J+FHzis6Bn2eyrq8OeC/zt70dNtF45WAxTtXkIFdB0uup/gmh7CWHJPqz85sFRjAyHoAi88oVgAT1+Mf/Q4kOxoOgwMAAAAASUVORK5CYII=", WPe = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAANqADAAQAAAABAAAANgAAAADzQy6kAAAFOUlEQVRoBe1aXXLbNhDeFWM/ZVr1BGVOEMV2Z/pW6QS1p7Unb4lPEPcEkU7Q+ARR3zJxO1ZPYOetM40T5QRlb6B0+mRJRHdBMgJIAAR/xObBO6MhgF1g98MCiz8B3NFdD3wWPYBtWyGGh334Z+cQevgQBIT0GwCKPunhX0ICIyqjH84hFh9gN7jGP15FGbuNbyvAEjC7z8jYIRnFvzo0p044bwtkI2AKoDNCsvFIHVh6nSnsBJMmXqwNTOydPCcPtQ1IhydwjO9eT/RCv1xlYOLbxyGs1pdy7vjpaCoVkfdGVb3Xq6JV7J88geX6fYeg2LyQdYr9Hw6r2OoNTA49EFNqvM255Gsr6exdJjb4VfEaiul8Gvs1qUpxWAeKduJvCu0LyREU+hG/TrwuQlXaK+0570qBJUOgd+mllIUQriHu/Q67OCubF2JA87W3HhLQ5wBVQOJTvHn9i8smJzAZKHhO+Q0/8o44xbe/XrsU2nhi7/hpBYALCiiPXB3nnmPL+MoPVHyONxcP6oKSYL9YzqhjkuFqQ78p71NAcY4iK7A0WISbtoypBRkzwpvfzoxcz0K50P+7c1Ux2g7EwcnYpsI4FNMh+JetUlq+gDWMcH4xL5FzsmuCytokG5YPcD4reNrsseWaJnMZxaf/Myg2sA/3do2jpeAxL2+hmNB8GpdBd/Ebekpt2ui1osdu10O1liEddQqK10Gg9dBORq8VgfXgmb0N4giYOPklzEqeYlCr5QgwPnU2K8R3eb42FD2GYcRhPd+Ib74OqCwwiP3jK9IztOpaL7/KZFlG91jZMGzgrSagJBik3YyLdujUrpAODOkY76I4uHaxbbzGoLjhFc5s7cvyWLddBwbw0FE5wvmryME3sloBRS0nup1BJFQNyAFDjakKUvpDLl+abQuUoogipJU0p+SAOXfYkbVJA2MLoEgLHX/s1FdZOWAqK5fOzlO5YlN2O6BIk9uGmsBMCAxlWwNl0OUqyntsYRXmk28JbR2Uhw2ZiTlg6fE94+rfUM/qua2DkuroSsFOkcrKAeN9mZW0qKNKdQNKahyoerU0QqTmc8CcUSeUWy61NqW7ApXodkRtoS9HOjDh9Bit/uJQxdUVKKmzfLunjTYdWEz3Di4S8fcZu1NQrFTeZGXaDd/cdk/b3bN46S6a7jjg/moOvncU6dFD3XkbzHIWJTdY8NIqRDrw7cUjla97jDmIb1SBQlrgyy5BSf2l3qLnpxwVga1uX5DMIienZkOv26QWPMVKvW7LcsOQ6xWAySGDWOgBFvamtkDxQwSKcYneqenUUQAmGyn3ml1XW6C+OR5Qv9vnVWbBOphkSfVrBFbba22BOng8hBj4KqCvGltI822Z5YxYiIpqZYqQ7ylPPedBbYHaO/mZht+Zh0bn/cs9ZwPr4AgCz0cJQb3bk/cOU2ebFqZgL4mYhp5jd7GpS3eJwWiTLaacHmPx0jWk2GYkr+g8/uIgt0m3tJtBufAPi03ZSuIjei+Y2bhcXgqMhcTBj2MQ/IZVmSJSMSct9IWPae0vCXgolwz08k5aLf143kJ7AeMmG4DTDWuS8wTFKryBsXD6uskhuM/5DmlBK+5P+OfF1FdnJWDcqHxeDfhBsMYw8rVKlZPRNjiyhXVVVE1XBpZV7mBo8qPied0HkNrAGGDivdWYRvSTDHALXwkIVqsXTU4EjYBlID69/vNLDf/brQ7xvw1AvGkKKFPdCrCsMf5+AsnvAEhX5gLD3HxckIfJK3Ra5/9/8KmdDrhNvMN67+iuBz7THvgPF+qIkJ2Aic0AAAAASUVORK5CYII=", qPe = "data:image/png;base64,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", KPe = (t) => {
  const { initConfig: r, local: a, features: u, reactionConfig: h, theme: b, presenceMap: l } = t, {
    appKey: v,
    appId: s,
    msyncUrl: c,
    restUrl: d,
    isHttpDNS: p = !0,
    useReplacedMessageContents: m,
    deviceId: E,
    isFixedDeviceId: y = !0,
    useOwnUploadFun: g = !1
  } = r, C = {
    delivery: !0,
    url: c,
    apiUrl: d,
    isHttpDNS: p,
    deviceId: E,
    useReplacedMessageContents: m,
    isFixedDeviceId: y,
    useOwnUploadFun: g
  };
  v ? C.appKey = v : s && (C.appId = s);
  const O = Wy(() => new Zs.connection(C), [v, s]);
  Zt.setClient(O), Zt.setInitConfig(r), _Re(t);
  let N = {
    fallbackLng: "en",
    lng: "en",
    resources: YB
  };
  if (a && (N = {
    lng: a.lng,
    fallbackLng: a.fallbackLng || "en",
    resources: a.resources || YB
  }), ua.use(oge).init(N), Pn(() => {
    r.userId && r.token ? O.open({
      user: r.userId.toLowerCase(),
      agoraToken: r.token
    }).then(() => {
      mn.dispatchSuccess("open");
    }).catch((_) => {
      mn.dispatchError("open", _);
    }) : r.userId && r.password && O.open({
      user: r.userId,
      pwd: r.password
    }).then(() => {
      mn.dispatchSuccess("open");
    }).catch((_) => {
      mn.dispatchError("open", _);
    });
  }, [r.userId, r.token]), FPe(b == null ? void 0 : b.primaryColor)) {
    const _ = HPe(b == null ? void 0 : b.primaryColor);
    _ && A2(_);
  } else zPe(b == null ? void 0 : b.primaryColor) ? A2(`hsla(${b == null ? void 0 : b.primaryColor}, 100%, 60%, 1)`) : A2("hsla(203, 100%, 60%, 1)");
  const w = {
    Online: GPe,
    Offline: VPe,
    Away: YPe,
    Busy: XPe,
    "Do Not Disturb": WPe,
    Custom: qPe
  };
  return /* @__PURE__ */ q.jsx(
    Jce,
    {
      value: {
        rootStore: Zt,
        initConfig: r,
        features: u,
        client: O,
        reactionConfig: h,
        theme: b,
        presenceMap: l || w
      },
      children: t.children
    }
  );
}, AX = Pd(KPe);
AX.displayName = "Provider";
const F3e = () => {
  let [t, r] = tn(Zt.client);
  return Pn(() => {
    r(Zt.client);
  }, [Zt.client]), t;
}, G3e = () => {
  const t = Zn(Vn).rootStore, { conversationStore: r } = t, {
    currentCvs: a,
    conversationList: u,
    setCurrentCvs: h,
    deleteConversation: b,
    topConversation: l,
    addConversation: v,
    modifyConversation: s
  } = r, [c, d] = tn(a), [p, m] = tn(u);
  return Pn(() => {
    const E = Qc(
      () => r.currentCvs,
      (g, C) => {
        d(g);
      }
    ), y = Qc(
      () => r.conversationList,
      (g, C) => {
        m(g);
      }
    );
    return () => {
      E(), y();
    };
  }, []), {
    currentConversation: c,
    conversationList: p,
    setCurrentConversation: h.bind(r),
    deleteConversation: b.bind(r),
    topConversation: l.bind(r),
    addConversation: v.bind(r),
    modifyConversation: s.bind(r)
  };
}, V3e = () => {
  const t = Zn(Vn).rootStore, { addressStore: r } = t, { muteChatRoomMember: a, unmuteChatRoomMember: u, removerChatroomMember: h } = r, [b, l] = tn(r.chatroom);
  return Pn(() => {
    const v = Qc(
      () => r.chatroom,
      (s, c) => {
        l(s);
      }
    );
    return () => {
      v();
    };
  }, []), {
    chatroom: b,
    muteChatRoomMember: a.bind(r),
    unmuteChatRoomMember: u.bind(r),
    removerChatroomMember: h.bind(r)
  };
}, Y3e = () => {
  const t = Zn(Vn).rootStore, { messageStore: r } = t, {
    message: a,
    currentCvsMsgs: u,
    repliedMessage: h,
    typing: b,
    sendMessage: l,
    deleteMessage: v,
    recallMessage: s,
    addReaction: c,
    deleteReaction: d,
    translateMessage: p,
    modifyServerMessage: m,
    modifyMessage: E,
    updateMessageStatus: y,
    sendTypingCmd: g,
    setRepliedMessage: C,
    clearMessage: O
  } = r, [N, w] = tn(a), [_, I] = tn(h), [k, H] = tn(b);
  return Pn(() => {
    const S = Qc(
      () => r.message,
      (F, j) => {
        w(F);
      }
    ), B = Qc(
      () => r.repliedMessage,
      (F, j) => {
        I(F);
      }
    ), D = Qc(
      () => r.typing,
      (F, j) => {
        H(F);
      }
    );
    return () => {
      S(), B(), D();
    };
  }, []), {
    messages: N,
    repliedMessage: _,
    typing: k,
    sendMessage: l.bind(r),
    deleteMessage: v.bind(r),
    recallMessage: s.bind(r),
    addReaction: c.bind(r),
    deleteReaction: d.bind(r),
    translateMessage: p.bind(r),
    modifyMessage: m.bind(r),
    modifyLocalMessage: E.bind(r),
    updateMessageStatus: y.bind(r),
    sendTypingCommand: g.bind(r),
    setRepliedMessage: C.bind(r),
    clearMessages: O.bind(r)
  };
}, X3e = () => {
  const t = Zn(Vn).rootStore, { addressStore: r } = t, {
    appUsersInfo: a,
    setAppUserInfo: u,
    groups: h,
    setGroups: b,
    updateGroupName: l,
    setGroupMembers: v,
    removeGroupMember: s,
    setGroupMemberAttributes: c,
    setGroupAdmins: d
  } = r, [p, m] = tn(a), [E, y] = tn(h);
  Pn(() => {
    const C = Qc(
      () => r.appUsersInfo,
      (N, w) => {
        m(N);
      }
    ), O = Qc(
      () => r.groups,
      (N, w) => {
        y(N);
      }
    );
    return () => {
      C(), O();
    };
  }, []);
  const g = (C, O) => {
    const { getGroupMemberList: N } = $w(C, O);
    return N == null ? void 0 : N();
  };
  return {
    appUsersInfo: p,
    groups: E,
    setAppUserInfo: u.bind(r),
    setGroups: b.bind(r),
    updateGroupName: l.bind(r),
    setGroupMembers: v.bind(r),
    removeGroupMember: s.bind(r),
    setGroupMemberAttributes: c.bind(r),
    setGroupAdmins: d.bind(r),
    getGroupMembers: g
  };
}, W3e = () => {
  const t = Zn(Vn).rootStore, { threadStore: r } = t, {
    currentThread: a,
    threadList: u,
    showThreadPanel: h,
    setCurrentThread: b,
    setThreadVisible: l,
    getGroupChatThreads: v,
    getThreadMembers: s,
    removeChatThreadMember: c,
    getChatThreadDetail: d
  } = r, [p, m] = tn(a), [E, y] = tn(u), [g, C] = tn(h);
  return Pn(() => {
    const O = Qc(
      () => r.currentThread,
      (_, I) => {
        m(_);
      }
    ), N = Qc(
      () => r.threadList,
      (_, I) => {
        y(_);
      }
    ), w = Qc(
      () => r.showThreadPanel,
      (_, I) => {
        C(_);
      }
    );
    return () => {
      O(), N(), w();
    };
  }, []), {
    currentThread: p,
    threadList: E,
    threadVisible: g,
    setCurrentThread: b.bind(r),
    setThreadVisible: l.bind(r),
    getGroupChatThreads: v.bind(r),
    getThreadMembers: s.bind(r),
    removeChatThreadMember: c.bind(r),
    getCurrentChatThreadDetail: d.bind(r)
  };
};
var ez;
const JPe = (ez = _s.getAgoraRTC) == null ? void 0 : ez.call(_s), q3e = () => ({
  AgoraRTC: JPe,
  ChatSDK: Zs
}), ZPe = (t) => {
  const {
    prefix: r,
    className: a,
    style: u,
    onItemClick: h,
    renderHeader: b,
    renderItems: l,
    headerProps: v,
    renderEmpty: s
  } = t, c = Zn(Vn), { rootStore: d, features: p, theme: m } = c, E = (m == null ? void 0 : m.mode) || "light", { t: y } = Yr(), { getPrefixCls: g } = _t.useContext(Hn), C = g("blocklist", r), O = En(
    C,
    {
      [`${C}-${E}`]: !!E
    },
    a
  );
  Pn(() => {
    d.loginState && d.addressStore.getBlockList();
  }, [d.loginState]), Qw("blocklist");
  const N = d.addressStore.appUsersInfo;
  return /* @__PURE__ */ q.jsxs("div", { className: O, style: { ...u }, children: [
    b ? b() : /* @__PURE__ */ q.jsx(au, { content: y("blocklist"), avatar: /* @__PURE__ */ q.jsx(q.Fragment, {}), ...v }),
    /* @__PURE__ */ q.jsxs("div", { className: `${C}-main`, children: [
      d.addressStore.blockList.length === 0 ? s ? s() : /* @__PURE__ */ q.jsx(Pm, { text: ua.t("no contact") }) : null,
      l ? d.addressStore.blockList.map((w, _) => {
        var k, H;
        const I = {
          userId: w,
          nickname: ((k = N[w]) == null ? void 0 : k.nickname) || w,
          avatarUrl: (H = N[w]) == null ? void 0 : H.avatarurl
        };
        return l(I, _);
      }) : d.addressStore.blockList.map((w) => {
        var _, I;
        return /* @__PURE__ */ q.jsx(
          Md,
          {
            data: {
              userId: w,
              nickname: ((_ = N[w]) == null ? void 0 : _.nickname) || w,
              avatarUrl: (I = N[w]) == null ? void 0 : I.avatarurl
            },
            onClick: () => {
              var k, H;
              h == null || h({
                userId: w,
                nickname: ((k = N[w]) == null ? void 0 : k.nickname) || w,
                avatarUrl: (H = N[w]) == null ? void 0 : H.avatarurl
              });
            }
          },
          w
        );
      })
    ] })
  ] });
}, QPe = mi(ZPe);
QPe.displayName = "Blocklist";
const K3e = WN;
function $Pe(t) {
  var O;
  const { tabs: r, defaultActiveKey: a, prefix: u, onTabClick: h, onChange: b, style: l } = t;
  if (!r || r.length === 0)
    return null;
  const { theme: v } = _t.useContext(Vn), s = v == null ? void 0 : v.mode, { getPrefixCls: c } = _t.useContext(Hn), d = c("tabs", u), p = En(
    d,
    {
      [`${d}-centered`]: t.centered,
      [`${d}-${s}`]: !!s
    },
    t.className
  ), [m, E] = tn(a || ((O = r[0]) == null ? void 0 : O.key)), y = (N, w) => {
    E(N);
  };
  Pn(() => {
    b == null || b(m);
  }, [m]);
  const g = t.tabs.findIndex((N) => N.key === m), C = t.tabs[g];
  return /* @__PURE__ */ q.jsxs("div", { className: p, style: { ...l }, children: [
    /* @__PURE__ */ q.jsx("ul", { className: `${d}-header`, children: t.tabs.map((N, w) => /* @__PURE__ */ q.jsx(
      "li",
      {
        className: (N.key === m ? `${d}-header-li-active` : "") + (N.disabled ? `${d}-header-li-disabled` : ""),
        onClick: (_) => {
          h == null || h(N.key, _), !N.disabled && y(N.key);
        },
        children: N.label
      },
      w
    )) }),
    /* @__PURE__ */ q.jsx("div", { className: `${d}-content`, children: C.content })
  ] });
}
const e3e = Fv(), t3e = (t) => {
  var Oe, Pe;
  const {
    prefix: r,
    className: a,
    style: u,
    chatroomId: h,
    headerProps: b,
    renderHeader: l,
    memberListProps: v,
    muteListProps: s
  } = t, { t: c } = Yr(), d = Zn(Vn), { rootStore: p, features: m, theme: E } = d, y = m == null ? void 0 : m.chatroomMember, g = (E == null ? void 0 : E.mode) || "light", { addressStore: C } = p, { getChatroomMembers: O } = _me(h);
  Pn(() => {
    if (!p.loginState || !h) return;
    C.chatroom.filter((be) => be.id === h)[0] ? O() : p.client.getChatRoomDetails({ chatRoomId: h }).then((be) => {
      p.addressStore.setChatroom(be.data), O(), mn.dispatchSuccess("getChatRoomDetails");
    }).catch((be) => {
      mn.dispatchError("getChatRoomDetails", be);
    });
  }, [p.loginState, h]);
  const N = C.chatroom.filter((xe) => xe.id === h)[0] || {}, w = N.owner || "", _ = C.appUsersInfo, I = N.membersId || [], [k, H] = _t.useState(!1);
  Pn(() => {
    p.loginState && w == p.client.user && h && p.addressStore.getChatroomMuteList(h);
  }, [p.loginState, w, h]);
  const S = I.map((xe) => ({
    ..._[xe],
    userId: xe
  })), [B, D] = _t.useState(""), F = (xe) => {
    C.muteChatRoomMember(h, xe.userId);
  }, j = (xe) => {
    D(xe.userId), H(!0);
  }, G = () => {
    C.removerChatroomMember(h, B), H(!1);
  }, U = {
    visible: w == p.client.user,
    actions: [
      {
        content: "mute",
        onClick: F
      },
      {
        content: "remove",
        onClick: j
      }
    ]
  };
  y && (U.actions = U.actions.filter((xe) => !(xe.content == "mute" && (y == null ? void 0 : y.mute) == !1 || xe.content == "remove" && (y == null ? void 0 : y.mute) == !1)));
  const M = (xe) => {
    C.unmuteChatRoomMember(h, xe.userId);
  }, V = {
    visible: w == p.client.user,
    actions: [
      {
        content: c("unmute"),
        onClick: M
      }
    ]
  }, [J, ue] = _t.useState(S), [se, ee] = _t.useState(N == null ? void 0 : N.muteList);
  Pn(() => {
    ue(S);
  }, [S.length, Object.keys(_).length]), Pn(() => {
    ee(N == null ? void 0 : N.muteList);
  }, [(Oe = N == null ? void 0 : N.muteList) == null ? void 0 : Oe.length]);
  const de = (xe) => {
    const be = S.filter(($e) => {
      var Be, Ke;
      return ((Be = $e.nickname) == null ? void 0 : Be.includes(xe.target.value)) || ((Ke = $e.userId) == null ? void 0 : Ke.includes(xe.target.value));
    });
    ue(be), xe.target.value == "" && ue(S);
  }, he = () => {
    var xe;
    return S.length > 0 ? /* @__PURE__ */ q.jsxs("div", { className: "cui-member-list", style: { flex: "1", overflow: "hidden" }, children: [
      ((v == null ? void 0 : v.search) == !0 || typeof (v == null ? void 0 : v.search) > "u") && /* @__PURE__ */ q.jsx("div", { style: { margin: "6px 12px" }, children: /* @__PURE__ */ q.jsx(_b, { onChange: de, placeholder: v == null ? void 0 : v.placeholder }) }),
      /* @__PURE__ */ q.jsx(
        e3e,
        {
          loading: !0,
          hasMore: !0,
          data: J,
          scrollDirection: "down",
          loadMoreItems: () => {
            O();
          },
          renderItem: v != null && v.renderItem ? (be) => {
            var $e;
            return ($e = v == null ? void 0 : v.renderItem) == null ? void 0 : $e.call(v, be);
          } : (be) => {
            let $e = U;
            return se != null && se.includes(be.userId) && ($e = {
              visible: w == p.client.user,
              actions: [
                {
                  content: "remove",
                  onClick: j
                }
              ]
            }), /* @__PURE__ */ q.jsx(
              Md,
              {
                data: {
                  userId: be.userId,
                  nickname: be.nickname,
                  avatarUrl: be.avatarurl,
                  description: w == be.userId ? c("owner") : ""
                },
                moreAction: w == be.userId ? { visible: !1, actions: [] } : $e,
                ...v == null ? void 0 : v.UserItemProps
              },
              be.userId
            );
          }
        }
      )
    ] }) : v != null && v.renderEmpty ? (xe = v == null ? void 0 : v.renderEmpty) == null ? void 0 : xe.call(v) : /* @__PURE__ */ q.jsx(Pm, { text: "", icon: /* @__PURE__ */ q.jsx(pn, { type: "EMPTY", width: 120, height: 120 }) });
  }, pe = (xe) => {
    var $e;
    const be = ($e = N == null ? void 0 : N.muteList) == null ? void 0 : $e.filter((Be) => {
      var Ze, at;
      return (((Ze = _[Be]) == null ? void 0 : Ze.nickname) || ((at = _[Be]) == null ? void 0 : at.userId) || "").includes(xe.target.value);
    });
    ee(be || []), xe.target.value == "" && ee(N == null ? void 0 : N.muteList);
  }, Ce = () => {
    var xe, be;
    return (((xe = N == null ? void 0 : N.muteList) == null ? void 0 : xe.length) || 0) > 0 ? /* @__PURE__ */ q.jsxs("div", { className: "cui-member-list", style: { flex: "1", overflow: "hidden" }, children: [
      /* @__PURE__ */ q.jsx("div", { style: { margin: "6px 12px" }, children: /* @__PURE__ */ q.jsx(_b, { onChange: pe }) }),
      se == null ? void 0 : se.map(($e) => {
        var Be, Ke;
        return /* @__PURE__ */ q.jsx(
          Md,
          {
            moreAction: V,
            data: {
              userId: $e,
              nickname: (Be = _[$e]) == null ? void 0 : Be.nickname,
              avatarUrl: (Ke = _[$e]) == null ? void 0 : Ke.avatarurl
            }
          },
          $e
        );
      })
    ] }) : s != null && s.renderEmpty ? (be = s == null ? void 0 : s.renderEmpty) == null ? void 0 : be.call(s) : /* @__PURE__ */ q.jsx(Pm, { text: "", icon: /* @__PURE__ */ q.jsx(pn, { type: "EMPTY", width: 120, height: 120 }) });
  }, _e = () => {
    var xe;
    (xe = b == null ? void 0 : b.onCloseClick) == null || xe.call(b);
  }, { getPrefixCls: Le } = _t.useContext(Hn), Te = Le("chatroom-member", r), K = En(
    Te,
    {
      [`${Te}-${g}`]: !!g
    },
    a
  );
  return h ? /* @__PURE__ */ q.jsxs("div", { className: K, style: { ...u }, children: [
    l ? l({
      chatType: "chatRoom",
      conversationId: h
    }) : /* @__PURE__ */ q.jsx(
      au,
      {
        close: !0,
        content: c("Participants"),
        avatar: /* @__PURE__ */ q.jsx("div", {}),
        onClickClose: _e,
        ...b
      }
    ),
    /* @__PURE__ */ q.jsx("div", { className: "chatroom-member-line" }),
    w == p.client.user && (y == null ? void 0 : y.mute) != !1 ? /* @__PURE__ */ q.jsx(
      $Pe,
      {
        tabs: [
          {
            label: c("all"),
            key: "all",
            content: he()
          },
          {
            label: c("muted"),
            key: "muted",
            content: Ce()
          }
        ]
      }
    ) : he(),
    /* @__PURE__ */ q.jsx(
      ca,
      {
        title: c("remove"),
        okText: c("remove"),
        cancelText: c("cancel"),
        open: k,
        onCancel: () => {
          H(!1);
        },
        onOk: G,
        children: /* @__PURE__ */ q.jsxs("div", { children: [
          c("wantToRemove"),
          " ",
          ((Pe = _[B]) == null ? void 0 : Pe.nickname) || B
        ] })
      }
    )
  ] }) : (console.warn("chatroomId is required"), null);
}, n3e = mi(t3e);
n3e.displayName = "ChatroomMember";
const r3e = ({
  className: t,
  disabled: r,
  children: a = /* @__PURE__ */ q.jsx(q.Fragment, {}),
  onClick: u
}) => {
  const { getPrefixCls: h } = _t.useContext(Hn), b = h("menu-item"), l = En(b, t), v = !!r, s = (c) => {
    if (v) {
      c.stopPropagation(), c.preventDefault();
      return;
    }
    u(c);
  };
  return /* @__PURE__ */ q.jsx("li", { className: l, children: _t.cloneElement(a, {
    onClick: (c) => {
      s(c);
    }
  }) });
}, i3e = ({
  containerRef: t,
  menuRef: r
}) => {
  var c, d, p;
  const a = (d = (c = t == null ? void 0 : t.current) == null ? void 0 : c.getBoundingClientRect) == null ? void 0 : d.call(c), u = (a == null ? void 0 : a.x) || (a == null ? void 0 : a.left) || 0, h = (a == null ? void 0 : a.y) || (a == null ? void 0 : a.top) || 0, b = {
    top: h,
    left: u
  };
  if (!r.current) return b;
  const { innerWidth: l, innerHeight: v } = window, s = (p = r == null ? void 0 : r.current) == null ? void 0 : p.getBoundingClientRect();
  return h + s.height > v && (b.top -= s.height), u + s.width > l && (b.left -= s.width), b.top < 0 && (b.top = s.height < v ? (v - s.height) / 2 : 0), b.left < 0 && (b.left = s.width < l ? (l - s.width) / 2 : 0), b.top += 32, b;
}, s3e = ({
  className: t,
  children: r,
  containerRef: a,
  onClose: u = () => {
  }
}) => {
  const h = er(null), { getPrefixCls: b } = _t.useContext(Hn), l = b("menu-wrap"), v = En(l, t), [s, c] = tn({}), d = Uy((p) => {
    var m, E;
    h != null && h.current && !((E = (m = h == null ? void 0 : h.current) == null ? void 0 : m.contains) != null && E.call(m, p.target)) && (u == null || u());
  }, []);
  return Pn(() => (document.addEventListener("mousedown", d), () => {
    document.removeEventListener("mousedown", d);
  }), []), Pn(() => {
    let p = i3e({
      containerRef: a,
      menuRef: h
    });
    return c(p), document.body.style.overflow = "hidden", () => {
      document.body.style.overflow = "auto";
    };
  }, []), /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx("div", { className: `${l}-mask` }),
    /* @__PURE__ */ q.jsx("ul", { ref: h, className: v, style: s, children: r })
  ] });
}, J3e = ({ children: t, className: r, menu: a, isOpen: u, style: h = {} }) => {
  const { getPrefixCls: b } = _t.useContext(Hn), l = b("dropdown"), v = En(l, r), [s, c] = tn(!!u), d = er(null), p = () => {
    c(!s);
  };
  return /* @__PURE__ */ q.jsxs(q.Fragment, { children: [
    /* @__PURE__ */ q.jsx("div", { className: v, ref: d, style: { ...h }, children: _t.cloneElement(t, {
      onClick: p
    }) }),
    s ? /* @__PURE__ */ q.jsx(
      s3e,
      {
        onClose: () => {
          c(!1);
        },
        containerRef: d,
        children: /* @__PURE__ */ q.jsx(q.Fragment, { children: a == null ? void 0 : a.map((m, E) => /* @__PURE__ */ q.jsx(
          r3e,
          {
            onClick: (y) => {
              m.props.onClick(y), c(!1);
            },
            children: m
          },
          E
        )) })
      }
    ) : null
  ] });
};
function a3e(t, r) {
  t.prototype = Object.create(r.prototype), t.prototype.constructor = t, hb(t, r);
}
var XB = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function o3e(t, r) {
  return !!(t === r || XB(t) && XB(r));
}
function c3e(t, r) {
  if (t.length !== r.length)
    return !1;
  for (var a = 0; a < t.length; a++)
    if (!o3e(t[a], r[a]))
      return !1;
  return !0;
}
function O2(t, r) {
  r === void 0 && (r = c3e);
  var a, u = [], h, b = !1;
  function l() {
    for (var v = [], s = 0; s < arguments.length; s++)
      v[s] = arguments[s];
    return b && a === this && r(v, u) || (h = t.apply(this, v), b = !0, a = this, u = v), h;
  }
  return l;
}
var u3e = typeof performance == "object" && typeof performance.now == "function", WB = u3e ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function qB(t) {
  cancelAnimationFrame(t.id);
}
function d3e(t, r) {
  var a = WB();
  function u() {
    WB() - a >= r ? t.call(null) : h.id = requestAnimationFrame(u);
  }
  var h = {
    id: requestAnimationFrame(u)
  };
  return h;
}
var C2 = -1;
function KB(t) {
  if (t === void 0 && (t = !1), C2 === -1 || t) {
    var r = document.createElement("div"), a = r.style;
    a.width = "50px", a.height = "50px", a.overflow = "scroll", document.body.appendChild(r), C2 = r.offsetWidth - r.clientWidth, document.body.removeChild(r);
  }
  return C2;
}
var Gp = null;
function JB(t) {
  if (t === void 0 && (t = !1), Gp === null || t) {
    var r = document.createElement("div"), a = r.style;
    a.width = "50px", a.height = "50px", a.overflow = "scroll", a.direction = "rtl";
    var u = document.createElement("div"), h = u.style;
    return h.width = "100px", h.height = "100px", r.appendChild(u), document.body.appendChild(r), r.scrollLeft > 0 ? Gp = "positive-descending" : (r.scrollLeft = 1, r.scrollLeft === 0 ? Gp = "negative" : Gp = "positive-ascending"), document.body.removeChild(r), Gp;
  }
  return Gp;
}
process.env.NODE_ENV;
var l3e = 150, f3e = function(r, a) {
  return r;
}, eb = null, tb = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (eb = /* @__PURE__ */ new WeakSet(), tb = /* @__PURE__ */ new WeakSet());
function h3e(t) {
  var r, a = t.getItemOffset, u = t.getEstimatedTotalSize, h = t.getItemSize, b = t.getOffsetForIndexAndAlignment, l = t.getStartIndexForOffset, v = t.getStopIndexForStartIndex, s = t.initInstanceProps, c = t.shouldResetStyleCacheOnItemSizeChange, d = t.validateProps;
  return r = /* @__PURE__ */ function(p) {
    a3e(m, p);
    function m(y) {
      var g;
      return g = p.call(this, y) || this, g._instanceProps = s(g.props, Er(g)), g._outerRef = void 0, g._resetIsScrollingTimeoutId = null, g.state = {
        instance: Er(g),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof g.props.initialScrollOffset == "number" ? g.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, g._callOnItemsRendered = void 0, g._callOnItemsRendered = O2(function(C, O, N, w) {
        return g.props.onItemsRendered({
          overscanStartIndex: C,
          overscanStopIndex: O,
          visibleStartIndex: N,
          visibleStopIndex: w
        });
      }), g._callOnScroll = void 0, g._callOnScroll = O2(function(C, O, N) {
        return g.props.onScroll({
          scrollDirection: C,
          scrollOffset: O,
          scrollUpdateWasRequested: N
        });
      }), g._getItemStyle = void 0, g._getItemStyle = function(C) {
        var O = g.props, N = O.direction, w = O.itemSize, _ = O.layout, I = g._getItemStyleCache(c && w, c && _, c && N), k;
        if (I.hasOwnProperty(C))
          k = I[C];
        else {
          var H = a(g.props, C, g._instanceProps), S = h(g.props, C, g._instanceProps), B = N === "horizontal" || _ === "horizontal", D = N === "rtl", F = B ? H : 0;
          I[C] = k = {
            position: "absolute",
            left: D ? void 0 : F,
            right: D ? F : void 0,
            top: B ? 0 : H,
            height: B ? "100%" : S,
            width: B ? S : "100%"
          };
        }
        return k;
      }, g._getItemStyleCache = void 0, g._getItemStyleCache = O2(function(C, O, N) {
        return {};
      }), g._onScrollHorizontal = function(C) {
        var O = C.currentTarget, N = O.clientWidth, w = O.scrollLeft, _ = O.scrollWidth;
        g.setState(function(I) {
          if (I.scrollOffset === w)
            return null;
          var k = g.props.direction, H = w;
          if (k === "rtl")
            switch (JB()) {
              case "negative":
                H = -w;
                break;
              case "positive-descending":
                H = _ - N - w;
                break;
            }
          return H = Math.max(0, Math.min(H, _ - N)), {
            isScrolling: !0,
            scrollDirection: I.scrollOffset < H ? "forward" : "backward",
            scrollOffset: H,
            scrollUpdateWasRequested: !1
          };
        }, g._resetIsScrollingDebounced);
      }, g._onScrollVertical = function(C) {
        var O = C.currentTarget, N = O.clientHeight, w = O.scrollHeight, _ = O.scrollTop;
        g.setState(function(I) {
          if (I.scrollOffset === _)
            return null;
          var k = Math.max(0, Math.min(_, w - N));
          return {
            isScrolling: !0,
            scrollDirection: I.scrollOffset < k ? "forward" : "backward",
            scrollOffset: k,
            scrollUpdateWasRequested: !1
          };
        }, g._resetIsScrollingDebounced);
      }, g._outerRefSetter = function(C) {
        var O = g.props.outerRef;
        g._outerRef = C, typeof O == "function" ? O(C) : O != null && typeof O == "object" && O.hasOwnProperty("current") && (O.current = C);
      }, g._resetIsScrollingDebounced = function() {
        g._resetIsScrollingTimeoutId !== null && qB(g._resetIsScrollingTimeoutId), g._resetIsScrollingTimeoutId = d3e(g._resetIsScrolling, l3e);
      }, g._resetIsScrolling = function() {
        g._resetIsScrollingTimeoutId = null, g.setState({
          isScrolling: !1
        }, function() {
          g._getItemStyleCache(-1, null);
        });
      }, g;
    }
    m.getDerivedStateFromProps = function(g, C) {
      return p3e(g, C), d(g), null;
    };
    var E = m.prototype;
    return E.scrollTo = function(g) {
      g = Math.max(0, g), this.setState(function(C) {
        return C.scrollOffset === g ? null : {
          scrollDirection: C.scrollOffset < g ? "forward" : "backward",
          scrollOffset: g,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, E.scrollToItem = function(g, C) {
      C === void 0 && (C = "auto");
      var O = this.props, N = O.itemCount, w = O.layout, _ = this.state.scrollOffset;
      g = Math.max(0, Math.min(g, N - 1));
      var I = 0;
      if (this._outerRef) {
        var k = this._outerRef;
        w === "vertical" ? I = k.scrollWidth > k.clientWidth ? KB() : 0 : I = k.scrollHeight > k.clientHeight ? KB() : 0;
      }
      this.scrollTo(b(this.props, g, C, _, this._instanceProps, I));
    }, E.componentDidMount = function() {
      var g = this.props, C = g.direction, O = g.initialScrollOffset, N = g.layout;
      if (typeof O == "number" && this._outerRef != null) {
        var w = this._outerRef;
        C === "horizontal" || N === "horizontal" ? w.scrollLeft = O : w.scrollTop = O;
      }
      this._callPropsCallbacks();
    }, E.componentDidUpdate = function() {
      var g = this.props, C = g.direction, O = g.layout, N = this.state, w = N.scrollOffset, _ = N.scrollUpdateWasRequested;
      if (_ && this._outerRef != null) {
        var I = this._outerRef;
        if (C === "horizontal" || O === "horizontal")
          if (C === "rtl")
            switch (JB()) {
              case "negative":
                I.scrollLeft = -w;
                break;
              case "positive-ascending":
                I.scrollLeft = w;
                break;
              default:
                var k = I.clientWidth, H = I.scrollWidth;
                I.scrollLeft = H - k - w;
                break;
            }
          else
            I.scrollLeft = w;
        else
          I.scrollTop = w;
      }
      this._callPropsCallbacks();
    }, E.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && qB(this._resetIsScrollingTimeoutId);
    }, E.render = function() {
      var g = this.props, C = g.children, O = g.className, N = g.direction, w = g.height, _ = g.innerRef, I = g.innerElementType, k = g.innerTagName, H = g.itemCount, S = g.itemData, B = g.itemKey, D = B === void 0 ? f3e : B, F = g.layout, j = g.outerElementType, G = g.outerTagName, U = g.style, M = g.useIsScrolling, V = g.width, J = this.state.isScrolling, ue = N === "horizontal" || F === "horizontal", se = ue ? this._onScrollHorizontal : this._onScrollVertical, ee = this._getRangeToRender(), de = ee[0], he = ee[1], pe = [];
      if (H > 0)
        for (var Ce = de; Ce <= he; Ce++)
          pe.push(rg(C, {
            data: S,
            key: D(Ce, S),
            index: Ce,
            isScrolling: M ? J : void 0,
            style: this._getItemStyle(Ce)
          }));
      var _e = u(this.props, this._instanceProps);
      return rg(j || G || "div", {
        className: O,
        onScroll: se,
        ref: this._outerRefSetter,
        style: ru({
          position: "relative",
          height: w,
          width: V,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: N
        }, U)
      }, rg(I || k || "div", {
        children: pe,
        ref: _,
        style: {
          height: ue ? "100%" : _e,
          pointerEvents: J ? "none" : void 0,
          width: ue ? _e : "100%"
        }
      }));
    }, E._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var g = this.props.itemCount;
        if (g > 0) {
          var C = this._getRangeToRender(), O = C[0], N = C[1], w = C[2], _ = C[3];
          this._callOnItemsRendered(O, N, w, _);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var I = this.state, k = I.scrollDirection, H = I.scrollOffset, S = I.scrollUpdateWasRequested;
        this._callOnScroll(k, H, S);
      }
    }, E._getRangeToRender = function() {
      var g = this.props, C = g.itemCount, O = g.overscanCount, N = this.state, w = N.isScrolling, _ = N.scrollDirection, I = N.scrollOffset;
      if (C === 0)
        return [0, 0, 0, 0];
      var k = l(this.props, I, this._instanceProps), H = v(this.props, k, I, this._instanceProps), S = !w || _ === "backward" ? Math.max(1, O) : 1, B = !w || _ === "forward" ? Math.max(1, O) : 1;
      return [Math.max(0, k - S), Math.max(0, Math.min(C - 1, H + B)), k, H];
    }, m;
  }(tz), r.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, r;
}
var p3e = function(r, a) {
  var u = r.children, h = r.direction, b = r.height, l = r.layout, v = r.innerTagName, s = r.outerTagName, c = r.width, d = a.instance;
  if (process.env.NODE_ENV !== "production") {
    (v != null || s != null) && tb && !tb.has(d) && (tb.add(d), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var p = h === "horizontal" || l === "horizontal";
    switch (h) {
      case "horizontal":
      case "vertical":
        eb && !eb.has(d) && (eb.add(d), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + h + '" was specified.'));
    }
    switch (l) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + l + '" was specified.'));
    }
    if (u == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (u === null ? "null" : typeof u) + '" was specified.'));
    if (p && typeof c != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (c === null ? "null" : typeof c) + '" was specified.'));
    if (!p && typeof b != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (b === null ? "null" : typeof b) + '" was specified.'));
  }
}, g3e = 50, ng = function(r, a, u) {
  var h = r, b = h.itemSize, l = u.itemMetadataMap, v = u.lastMeasuredIndex;
  if (a > v) {
    var s = 0;
    if (v >= 0) {
      var c = l[v];
      s = c.offset + c.size;
    }
    for (var d = v + 1; d <= a; d++) {
      var p = b(d);
      l[d] = {
        offset: s,
        size: p
      }, s += p;
    }
    u.lastMeasuredIndex = a;
  }
  return l[a];
}, m3e = function(r, a, u) {
  var h = a.itemMetadataMap, b = a.lastMeasuredIndex, l = b > 0 ? h[b].offset : 0;
  return l >= u ? OX(r, a, b, 0, u) : E3e(r, a, Math.max(0, b), u);
}, OX = function(r, a, u, h, b) {
  for (; h <= u; ) {
    var l = h + Math.floor((u - h) / 2), v = ng(r, l, a).offset;
    if (v === b)
      return l;
    v < b ? h = l + 1 : v > b && (u = l - 1);
  }
  return h > 0 ? h - 1 : 0;
}, E3e = function(r, a, u, h) {
  for (var b = r.itemCount, l = 1; u < b && ng(r, u, a).offset < h; )
    u += l, l *= 2;
  return OX(r, a, Math.min(u, b - 1), Math.floor(u / 2), h);
}, ZB = function(r, a) {
  var u = r.itemCount, h = a.itemMetadataMap, b = a.estimatedItemSize, l = a.lastMeasuredIndex, v = 0;
  if (l >= u && (l = u - 1), l >= 0) {
    var s = h[l];
    v = s.offset + s.size;
  }
  var c = u - l - 1, d = c * b;
  return v + d;
}, y3e = /* @__PURE__ */ h3e({
  getItemOffset: function(r, a, u) {
    return ng(r, a, u).offset;
  },
  getItemSize: function(r, a, u) {
    return u.itemMetadataMap[a].size;
  },
  getEstimatedTotalSize: ZB,
  getOffsetForIndexAndAlignment: function(r, a, u, h, b, l) {
    var v = r.direction, s = r.height, c = r.layout, d = r.width, p = v === "horizontal" || c === "horizontal", m = p ? d : s, E = ng(r, a, b), y = ZB(r, b), g = Math.max(0, Math.min(y - m, E.offset)), C = Math.max(0, E.offset - m + E.size + l);
    switch (u === "smart" && (h >= C - m && h <= g + m ? u = "auto" : u = "center"), u) {
      case "start":
        return g;
      case "end":
        return C;
      case "center":
        return Math.round(C + (g - C) / 2);
      case "auto":
      default:
        return h >= C && h <= g ? h : h < C ? C : g;
    }
  },
  getStartIndexForOffset: function(r, a, u) {
    return m3e(r, u, a);
  },
  getStopIndexForStartIndex: function(r, a, u, h) {
    for (var b = r.direction, l = r.height, v = r.itemCount, s = r.layout, c = r.width, d = b === "horizontal" || s === "horizontal", p = d ? c : l, m = ng(r, a, h), E = u + p, y = m.offset + m.size, g = a; g < v - 1 && y < E; )
      g++, y += ng(r, g, h).size;
    return g;
  },
  initInstanceProps: function(r, a) {
    var u = r, h = u.estimatedItemSize, b = {
      itemMetadataMap: {},
      estimatedItemSize: h || g3e,
      lastMeasuredIndex: -1
    };
    return a.resetAfterIndex = function(l, v) {
      v === void 0 && (v = !0), b.lastMeasuredIndex = Math.min(b.lastMeasuredIndex, l - 1), a._getItemStyleCache(-1), v && a.forceUpdate();
    }, b;
  },
  shouldResetStyleCacheOnItemSizeChange: !1,
  validateProps: function(r) {
    var a = r.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof a != "function")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a function. ' + ('"' + (a === null ? "null" : typeof a) + '" was specified.'));
  }
});
function QB(t) {
  return typeof t == "number" && isFinite(t) && Math.floor(t) === t;
}
function v3e(t) {
  var r = t.lastRenderedStartIndex, a = t.lastRenderedStopIndex, u = t.startIndex, h = t.stopIndex;
  return !(u > a || h < r);
}
function T3e(t) {
  for (var r = t.isItemLoaded, a = t.itemCount, u = t.minimumBatchSize, h = t.startIndex, b = t.stopIndex, l = [], v = null, s = null, c = h; c <= b; c++) {
    var d = r(c);
    d ? s !== null && (l.push(v, s), v = s = null) : (s = c, v === null && (v = c));
  }
  if (s !== null) {
    for (var p = Math.min(Math.max(s, v + u - 1), a - 1), m = s + 1; m <= p && !r(m); m++)
      s = m;
    l.push(v, s);
  }
  if (l.length)
    for (; l[1] - l[0] + 1 < u && l[0] > 0; ) {
      var E = l[0] - 1;
      if (!r(E))
        l[0] = E;
      else
        break;
    }
  return l;
}
var b3e = function(t, r) {
  if (!(t instanceof r))
    throw new TypeError("Cannot call a class as a function");
}, A3e = /* @__PURE__ */ function() {
  function t(r, a) {
    for (var u = 0; u < a.length; u++) {
      var h = a[u];
      h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(r, h.key, h);
    }
  }
  return function(r, a, u) {
    return a && t(r.prototype, a), u && t(r, u), r;
  };
}(), O3e = function(t, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof r);
  t.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(t, r) : t.__proto__ = r);
}, $B = function(t, r) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r && (typeof r == "object" || typeof r == "function") ? r : t;
}, C3e = function(t) {
  O3e(r, t);
  function r() {
    var a, u, h, b;
    b3e(this, r);
    for (var l = arguments.length, v = Array(l), s = 0; s < l; s++)
      v[s] = arguments[s];
    return b = (u = (h = $B(this, (a = r.__proto__ || Object.getPrototypeOf(r)).call.apply(a, [this].concat(v))), h), h._lastRenderedStartIndex = -1, h._lastRenderedStopIndex = -1, h._memoizedUnloadedRanges = [], h._onItemsRendered = function(c) {
      var d = c.visibleStartIndex, p = c.visibleStopIndex;
      process.env.NODE_ENV !== "production" && ((!QB(d) || !QB(p)) && console.warn("Invalid onItemsRendered signature; please refer to InfiniteLoader documentation."), typeof h.props.loadMoreRows == "function" && console.warn('InfiniteLoader "loadMoreRows" prop has been renamed to "loadMoreItems".')), h._lastRenderedStartIndex = d, h._lastRenderedStopIndex = p, h._ensureRowsLoaded(d, p);
    }, h._setRef = function(c) {
      h._listRef = c;
    }, u), $B(h, b);
  }
  return A3e(r, [{
    key: "resetloadMoreItemsCache",
    value: function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      this._memoizedUnloadedRanges = [], u && this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      process.env.NODE_ENV !== "production" && this._listRef == null && console.warn("Invalid list ref; please refer to InfiniteLoader documentation.");
    }
  }, {
    key: "render",
    value: function() {
      var u = this.props.children;
      return u({
        onItemsRendered: this._onItemsRendered,
        ref: this._setRef
      });
    }
  }, {
    key: "_ensureRowsLoaded",
    value: function(u, h) {
      var b = this.props, l = b.isItemLoaded, v = b.itemCount, s = b.minimumBatchSize, c = s === void 0 ? 10 : s, d = b.threshold, p = d === void 0 ? 15 : d, m = T3e({
        isItemLoaded: l,
        itemCount: v,
        minimumBatchSize: c,
        startIndex: Math.max(0, u - p),
        stopIndex: Math.min(v - 1, h + p)
      });
      (this._memoizedUnloadedRanges.length !== m.length || this._memoizedUnloadedRanges.some(function(E, y) {
        return m[y] !== E;
      })) && (this._memoizedUnloadedRanges = m, this._loadUnloadedRanges(m));
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function(u) {
      for (var h = this, b = this.props.loadMoreItems || this.props.loadMoreRows, l = function(c) {
        var d = u[c], p = u[c + 1], m = b(d, p);
        m != null && m.then(function() {
          if (v3e({
            lastRenderedStartIndex: h._lastRenderedStartIndex,
            lastRenderedStopIndex: h._lastRenderedStopIndex,
            startIndex: d,
            stopIndex: p
          })) {
            if (h._listRef == null)
              return;
            typeof h._listRef.resetAfterIndex == "function" ? h._listRef.resetAfterIndex(d, !0) : (typeof h._listRef._getItemStyleCache == "function" && h._listRef._getItemStyleCache(-1), h._listRef.forceUpdate());
          }
        });
      }, v = 0; v < u.length; v += 2)
        l(v);
    }
  }]), r;
}(tz);
const S3e = ({
  index: t,
  style: r,
  content: a
}) => /* @__PURE__ */ q.jsx("div", { style: r, children: a }), I3e = _t.forwardRef((t, r) => {
  const {
    height: a,
    itemCount: u,
    itemSize: h,
    width: b = "100%",
    children: l,
    loadMoreItems: v,
    onItemRendered: s,
    isItemLoaded: c,
    itemData: d,
    ...p
  } = t;
  let m;
  typeof h == "number" ? m = () => h : m = h;
  const E = er(null);
  return /* @__PURE__ */ q.jsx(
    C3e,
    {
      isItemLoaded: c,
      itemCount: u,
      loadMoreItems: v,
      ref: E,
      threshold: 5,
      children: ({ onItemsRendered: y }) => /* @__PURE__ */ q.jsx(
        y3e,
        {
          onItemsRendered: y,
          ref: r,
          height: a,
          itemCount: u,
          itemSize: m,
          width: b,
          itemData: d,
          ...p,
          children: l
        }
      )
    }
  );
});
I3e.Row = S3e;
const Z3e = ({ className: t = "", children: r = "", style: a = {} }) => {
  const { getPrefixCls: u } = _t.useContext(Hn), h = u("popover"), b = En(h, t);
  return /* @__PURE__ */ q.jsx("div", { className: b, style: { ...a }, children: /* @__PURE__ */ q.jsx("span", { children: r }) });
}, Q3e = (t) => {
  const {
    prefix: r,
    className: a,
    direction: u = "right",
    style: h,
    expandIcon: b,
    expandIconPosition: l = u == "left" || u == "right" ? "start" : "end",
    bordered: v = !1,
    onChange: s,
    collapsible: c = "header"
  } = t, { theme: d } = Zn(Vn), p = d == null ? void 0 : d.mode, [m, E] = tn(!1), { title: y, content: g } = t, C = (_) => {
    c !== "disabled" && (_ === "header" && c === "icon" || (s == null || s(!m), E(!m)));
  }, { getPrefixCls: O } = _t.useContext(Hn), N = O("collapse", r), w = En(
    N,
    {
      [`${N}-${u}`]: !!u,
      [`${N}-bordered`]: v,
      [`${N}-expandIcon-${l}`]: !!l
    },
    a
  );
  return /* @__PURE__ */ q.jsxs("div", { className: w, style: { ...h }, children: [
    /* @__PURE__ */ q.jsxs(
      "div",
      {
        className: `${N}-header  ${m ? "open" : ""}`,
        onClick: () => {
          C("header");
        },
        children: [
          /* @__PURE__ */ q.jsx("div", { children: typeof y == "function" ? y() : y }),
          b || /* @__PURE__ */ q.jsx(
            pn,
            {
              onClick: () => {
                C("icon");
              },
              width: 24,
              height: 24,
              color: p == "dark" ? "#E3E6E8" : "#464E53",
              className: `${N}-icon ${m ? "open" : ""}`,
              type: "VERTICAL_ARROW"
            }
          )
        ]
      }
    ),
    m && /* @__PURE__ */ q.jsx("div", { className: `${N}-content`, children: typeof g == "function" ? g() : g })
  ] });
}, $3e = AX, e4e = zv;
export {
  Xm as AudioMessage,
  zs as Avatar,
  ORe as Badge,
  Oh as BaseMessage,
  QPe as Blocklist,
  gi as Button,
  B3e as Chat,
  K3e as Chatroom,
  n3e as ChatroomMember,
  vX as ChatroomMessage,
  Bv as Checkbox,
  Q3e as Collapse,
  Hv as CombinedMessage,
  U3e as ContactDetail,
  vAe as ContactItem,
  _N as ContactList,
  qN as ConversationItem,
  z3e as ConversationList,
  J3e as Dropdown,
  Pm as Empty,
  jv as FileMessage,
  wRe as GroupDetail,
  NRe as GroupMember,
  au as Header,
  pn as Icon,
  kv as ImageMessage,
  Ml as Input,
  I3e as List,
  e4e as MessageEditor,
  zv as MessageInput,
  cv as MessageList,
  Lde as MessageStatus,
  ca as Modal,
  Dge as NoticeMessage,
  EAe as PinnedMessage,
  Z3e as Popover,
  AX as Provider,
  RN as RecalledMessage,
  oAe as RepliedMsg,
  L3e as RootConsumer,
  Vn as RootContext,
  Jce as RootProvider,
  Fv as ScrollList,
  IRe as Switch,
  Dd as TextMessage,
  UOe as Thread,
  va as Tooltip,
  $3e as UIKitProvider,
  aY as UnsentRepliedMsg,
  PA as UserCardMessage,
  Md as UserItem,
  fY as UserProfile,
  gY as UserSelect,
  Uv as VideoMessage,
  mn as eventHandler,
  Zt as rootStore,
  X3e as useAddressContext,
  Y3e as useChatContext,
  V3e as useChatroomContext,
  F3e as useClient,
  G3e as useConversationContext,
  Nme as useConversations,
  Lge as useHistoryMessages,
  Rc as usePinnedMessage,
  q3e as useSDK,
  W3e as useThreadContext
};
